var HU = Object.defineProperty;
var zU = (i, e, t) => e in i ? HU(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t;
var $d = (i, e, t) => zU(i, typeof e != "symbol" ? e + "" : e, t);
function Ao(i, e = 0) {
  return i[i.length - (1 + e)];
}
function ri(i, e, t = (n, s) => n === s) {
  if (i === e) return !0;
  if (!i || !e || i.length !== e.length) return !1;
  for (let n = 0, s = i.length; n < s; n++) if (!t(i[n], e[n])) return !1;
  return !0;
}
function U0(i, e, t) {
  return function(n, s) {
    let o = 0, r = n - 1;
    for (; o <= r; ) {
      const a = (o + r) / 2 | 0, l = s(a);
      if (l < 0) o = a + 1;
      else {
        if (!(l > 0)) return a;
        r = a - 1;
      }
    }
    return -(o + 1);
  }(i.length, (n) => t(i[n], e));
}
function wN(i, e, t) {
  if ((i |= 0) >= e.length) throw new TypeError("invalid index");
  const n = e[Math.floor(e.length * Math.random())], s = [], o = [], r = [];
  for (const a of e) {
    const l = t(a, n);
    l < 0 ? s.push(a) : l > 0 ? o.push(a) : r.push(a);
  }
  return i < s.length ? wN(i, s, t) : i < s.length + r.length ? r[0] : wN(i - (s.length + r.length), o, t);
}
function GP(i, e) {
  const t = [];
  let n;
  for (const s of i.slice(0).sort(e)) n && e(n[0], s) === 0 ? n.push(s) : (n = [s], t.push(n));
  return t;
}
function* zT(i, e) {
  let t, n;
  for (const s of i) n !== void 0 && e(n, s) ? t.push(s) : (t && (yield t), t = [s]), n = s;
  t && (yield t);
}
function p7(i, e) {
  for (let t = 0; t <= i.length; t++) e(t === 0 ? void 0 : i[t - 1], t === i.length ? void 0 : i[t]);
}
function ca(i) {
  return i.filter((e) => !!e);
}
function ZP(i) {
  let e = 0;
  for (let t = 0; t < i.length; t++) i[t] && (i[e] = i[t], e += 1);
  i.length = e;
}
function m7(i) {
  return !Array.isArray(i) || i.length === 0;
}
function zn(i) {
  return Array.isArray(i) && i.length > 0;
}
function Ad(i, e = (t) => t) {
  const t = /* @__PURE__ */ new Set();
  return i.filter((n) => {
    const s = e(n);
    return !t.has(s) && (t.add(s), !0);
  });
}
function UT(i, e) {
  return i.length > 0 ? i[0] : e;
}
function Ds(i, e) {
  let t = typeof e == "number" ? i : 0;
  typeof e == "number" ? t = i : (t = 0, e = i);
  const n = [];
  if (t <= e) for (let s = t; s < e; s++) n.push(s);
  else for (let s = t; s > e; s--) n.push(s);
  return n;
}
function PS(i, e, t) {
  const n = i.slice(0, e), s = i.slice(e);
  return n.concat(t, s);
}
function Ek(i, e) {
  const t = i.indexOf(e);
  t > -1 && (i.splice(t, 1), i.unshift(e));
}
function $1(i, e) {
  const t = i.indexOf(e);
  t > -1 && (i.splice(t, 1), i.push(e));
}
function yN(i, e) {
  for (const t of e) i.push(t);
}
function KT(i) {
  return Array.isArray(i) ? i : [i];
}
function YP(i, e, t, n) {
  const s = XP(i, e);
  let o = i.splice(s, t);
  return o === void 0 && (o = []), function(r, a, l) {
    const d = XP(r, a), h = r.length, c = l.length;
    r.length = h + c;
    for (let u = h - 1; u >= d; u--) r[u + c] = r[u];
    for (let u = 0; u < c; u++) r[u + d] = l[u];
  }(i, s, n), o;
}
function XP(i, e) {
  return e < 0 ? Math.max(e + i.length, 0) : Math.min(e, i.length);
}
var K0;
function jo(i, e) {
  return (t, n) => e(i(t), i(n));
}
(function(i) {
  i.isLessThan = function(e) {
    return e < 0;
  }, i.isLessThanOrEqual = function(e) {
    return e <= 0;
  }, i.isGreaterThan = function(e) {
    return e > 0;
  }, i.isNeitherLessOrGreaterThan = function(e) {
    return e === 0;
  }, i.greaterThan = 1, i.lessThan = -1, i.neitherLessOrGreaterThan = 0;
})(K0 || (K0 = {}));
const od = (i, e) => i - e, UU = (i, e) => od(i ? 1 : 0, e ? 1 : 0);
function f7(i) {
  return (e, t) => -i(e, t);
}
class Pd {
  constructor(e) {
    this.items = e, this.firstIdx = 0, this.lastIdx = this.items.length - 1;
  }
  get length() {
    return this.lastIdx - this.firstIdx + 1;
  }
  takeWhile(e) {
    let t = this.firstIdx;
    for (; t < this.items.length && e(this.items[t]); ) t++;
    const n = t === this.firstIdx ? null : this.items.slice(this.firstIdx, t);
    return this.firstIdx = t, n;
  }
  takeFromEndWhile(e) {
    let t = this.lastIdx;
    for (; t >= 0 && e(this.items[t]); ) t--;
    const n = t === this.lastIdx ? null : this.items.slice(t + 1, this.lastIdx + 1);
    return this.lastIdx = t, n;
  }
  peek() {
    if (this.length !== 0) return this.items[this.firstIdx];
  }
  dequeue() {
    const e = this.items[this.firstIdx];
    return this.firstIdx++, e;
  }
  takeCount(e) {
    const t = this.items.slice(this.firstIdx, this.firstIdx + e);
    return this.firstIdx += e, t;
  }
}
class hl {
  constructor(e) {
    this.iterate = e;
  }
  toArray() {
    const e = [];
    return this.iterate((t) => (e.push(t), !0)), e;
  }
  filter(e) {
    return new hl((t) => this.iterate((n) => !e(n) || t(n)));
  }
  map(e) {
    return new hl((t) => this.iterate((n) => t(e(n))));
  }
  findLast(e) {
    let t;
    return this.iterate((n) => (e(n) && (t = n), !0)), t;
  }
  findLastMaxBy(e) {
    let t, n = !0;
    return this.iterate((s) => ((n || K0.isGreaterThan(e(s, t))) && (n = !1, t = s), !0)), t;
  }
}
hl.empty = new hl((i) => {
});
class Nw {
  constructor(e) {
    this._indexMap = e;
  }
  static createSortPermutation(e, t) {
    const n = Array.from(e.keys()).sort((s, o) => t(e[s], e[o]));
    return new Nw(n);
  }
  apply(e) {
    return e.map((t, n) => e[this._indexMap[n]]);
  }
  inverse() {
    const e = this._indexMap.slice();
    for (let t = 0; t < this._indexMap.length; t++) e[this._indexMap[t]] = t;
    return new Nw(e);
  }
}
function ps(i) {
  return typeof i == "string";
}
function ms(i) {
  return !(typeof i != "object" || i === null || Array.isArray(i) || i instanceof RegExp || i instanceof Date);
}
function KU(i) {
  const e = Object.getPrototypeOf(Uint8Array);
  return typeof i == "object" && i instanceof e;
}
function gc(i) {
  return typeof i == "number" && !isNaN(i);
}
function QP(i) {
  return !!i && typeof i[Symbol.iterator] == "function";
}
function _7(i) {
  return i === !0 || i === !1;
}
function $s(i) {
  return i === void 0;
}
function cl(i) {
  return !mo(i);
}
function mo(i) {
  return $s(i) || i === null;
}
function vt(i, e) {
  if (!i) throw new Error(e ? `Unexpected type, expected '${e}'` : "Unexpected type");
}
function xh(i) {
  if (mo(i)) throw new Error("Assertion Failed: argument is undefined or null");
  return i;
}
function j0(i) {
  return typeof i == "function";
}
function jU(i, e) {
  if (ps(e)) {
    if (typeof i !== e) throw new Error(`argument does not match constraint: typeof ${e}`);
  } else if (j0(e)) {
    try {
      if (i instanceof e) return;
    } catch {
    }
    if (!mo(i) && i.constructor === e || e.length === 1 && e.call(void 0, i) === !0) return;
    throw new Error("argument does not match one of these constraints: arg instanceof constraint, arg.constructor === constraint, nor constraint(arg) === true");
  }
}
function Ul(i) {
  if (!i || typeof i != "object" || i instanceof RegExp) return i;
  const e = Array.isArray(i) ? [] : {};
  return Object.entries(i).forEach(([t, n]) => {
    e[t] = n && typeof n == "object" ? Ul(n) : n;
  }), e;
}
const v7 = Object.prototype.hasOwnProperty;
function b7(i, e) {
  return SN(i, e, /* @__PURE__ */ new Set());
}
function SN(i, e, t) {
  if (mo(i)) return i;
  const n = e(i);
  if (n !== void 0) return n;
  if (Array.isArray(i)) {
    const s = [];
    for (const o of i) s.push(SN(o, e, t));
    return s;
  }
  if (ms(i)) {
    if (t.has(i)) throw new Error("Cannot clone recursive data-structure");
    t.add(i);
    const s = {};
    for (const o in i) v7.call(i, o) && (s[o] = SN(i[o], e, t));
    return t.delete(i), s;
  }
  return i;
}
function OS(i, e, t = !0) {
  return ms(i) ? (ms(e) && Object.keys(e).forEach((n) => {
    n in i ? t && (ms(i[n]) && ms(e[n]) ? OS(i[n], e[n], t) : i[n] = e[n]) : i[n] = e[n];
  }), i) : e;
}
function So(i, e) {
  if (i === e) return !0;
  if (i == null || e == null || typeof i != typeof e || typeof i != "object" || Array.isArray(i) !== Array.isArray(e)) return !1;
  let t, n;
  if (Array.isArray(i)) {
    if (i.length !== e.length) return !1;
    for (t = 0; t < i.length; t++) if (!So(i[t], e[t])) return !1;
  } else {
    const s = [];
    for (n in i) s.push(n);
    s.sort();
    const o = [];
    for (n in e) o.push(n);
    if (o.sort(), !So(s, o)) return !1;
    for (t = 0; t < s.length; t++) if (!So(i[s[t]], e[s[t]])) return !1;
  }
  return !0;
}
function jT(i) {
  const e = [];
  for (const t of function(n) {
    let s = [];
    for (; Object.prototype !== n; ) s = s.concat(Object.getOwnPropertyNames(n)), n = Object.getPrototypeOf(n);
    return s;
  }(i)) typeof i[t] == "function" && e.push(t);
  return e;
}
let qU = typeof document < "u" && document.location && document.location.hash.indexOf("pseudo=true") >= 0;
function C7(i, e) {
  let t;
  return t = e.length === 0 ? i : i.replace(/\{(\d+)\}/g, (n, s) => {
    const o = s[0], r = e[o];
    let a = n;
    return typeof r == "string" ? a = r : typeof r != "number" && typeof r != "boolean" && r != null || (a = String(r)), a;
  }), qU && (t = "［" + t.replace(/[aouei]/g, "$&$&") + "］"), t;
}
function m(i, e, ...t) {
  return C7(e, t);
}
function ct(i, e, ...t) {
  const n = C7(e, t);
  return { value: n, original: n };
}
var Ik, Mk;
const Sp = "en";
let G1, $U, Ia, Ew = !1, Iw = !1, DC = !1, w7 = !1, qT = !1, $T = !1, y7 = !1, xC = Sp, JP = Sp;
const Sd = globalThis;
let js;
Sd.vscode !== void 0 && Sd.vscode.process !== void 0 ? js = Sd.vscode.process : typeof process < "u" && typeof ((Ik = process == null ? void 0 : process.versions) === null || Ik === void 0 ? void 0 : Ik.node) == "string" && (js = process);
const GU = typeof ((Mk = js == null ? void 0 : js.versions) === null || Mk === void 0 ? void 0 : Mk.electron) == "string" && (js == null ? void 0 : js.type) === "renderer";
if (typeof js == "object") {
  Ew = js.platform === "win32", Iw = js.platform === "darwin", DC = js.platform === "linux", DC && js.env.SNAP && js.env.SNAP_REVISION, js.env.CI || js.env.BUILD_ARTIFACTSTAGINGDIRECTORY, G1 = Sp, xC = Sp;
  const i = js.env.VSCODE_NLS_CONFIG;
  if (i) try {
    const e = JSON.parse(i), t = e.availableLanguages["*"];
    G1 = e.locale, JP = e.osLocale, xC = t || Sp, $U = e._translationsConfigFile;
  } catch {
  }
  w7 = !0;
} else typeof navigator != "object" || GU ? console.error("Unable to resolve platform.") : (Ia = navigator.userAgent, Ew = Ia.indexOf("Windows") >= 0, Iw = Ia.indexOf("Macintosh") >= 0, $T = (Ia.indexOf("Macintosh") >= 0 || Ia.indexOf("iPad") >= 0 || Ia.indexOf("iPhone") >= 0) && !!navigator.maxTouchPoints && navigator.maxTouchPoints > 0, DC = Ia.indexOf("Linux") >= 0, y7 = (Ia == null ? void 0 : Ia.indexOf("Mobi")) >= 0, qT = !0, m(0, "_"), G1 = Sp, xC = G1, JP = navigator.language);
const Tn = Ew, Je = Iw, Cs = DC, sa = w7, pc = qT, ZU = qT && typeof Sd.importScripts == "function" ? Sd.origin : void 0, ua = $T, S7 = y7, fl = Ia, YU = xC, XU = typeof Sd.postMessage == "function" && !Sd.importScripts, L7 = (() => {
  if (XU) {
    const i = [];
    Sd.addEventListener("message", (t) => {
      if (t.data && t.data.vscodeScheduleAsyncWork) for (let n = 0, s = i.length; n < s; n++) {
        const o = i[n];
        if (o.id === t.data.vscodeScheduleAsyncWork) return i.splice(n, 1), void o.callback();
      }
    });
    let e = 0;
    return (t) => {
      const n = ++e;
      i.push({ id: n, callback: t }), Sd.postMessage({ vscodeScheduleAsyncWork: n }, "*");
    };
  }
  return (i) => setTimeout(i);
})(), Gs = Iw || $T ? 2 : Ew ? 1 : 3;
let eO = !0, tO = !1;
function k7() {
  if (!tO) {
    tO = !0;
    const i = new Uint8Array(2);
    i[0] = 1, i[1] = 2, eO = new Uint16Array(i.buffer)[0] === 513;
  }
  return eO;
}
const D7 = !!(fl && fl.indexOf("Chrome") >= 0), QU = !!(fl && fl.indexOf("Firefox") >= 0), JU = !!(!D7 && fl && fl.indexOf("Safari") >= 0), eK = !!(fl && fl.indexOf("Edg/") >= 0), tK = !!(fl && fl.indexOf("Android") >= 0), Wn = { tabSize: 4, indentSize: 4, insertSpaces: !0, detectIndentation: !0, trimAutoWhitespace: !0, largeFileOptimizations: !0, bracketPairColorizationOptions: { enabled: !0, independentColorPoolPerBracketType: !1 } };
var at;
(function(i) {
  function e(s) {
    return s && typeof s == "object" && typeof s[Symbol.iterator] == "function";
  }
  i.is = e;
  const t = Object.freeze([]);
  function* n(s) {
    yield s;
  }
  i.empty = function() {
    return t;
  }, i.single = n, i.wrap = function(s) {
    return e(s) ? s : n(s);
  }, i.from = function(s) {
    return s || t;
  }, i.reverse = function* (s) {
    for (let o = s.length - 1; o >= 0; o--) yield s[o];
  }, i.isEmpty = function(s) {
    return !s || s[Symbol.iterator]().next().done === !0;
  }, i.first = function(s) {
    return s[Symbol.iterator]().next().value;
  }, i.some = function(s, o) {
    for (const r of s) if (o(r)) return !0;
    return !1;
  }, i.find = function(s, o) {
    for (const r of s) if (o(r)) return r;
  }, i.filter = function* (s, o) {
    for (const r of s) o(r) && (yield r);
  }, i.map = function* (s, o) {
    let r = 0;
    for (const a of s) yield o(a, r++);
  }, i.concat = function* (...s) {
    for (const o of s) yield* o;
  }, i.reduce = function(s, o, r) {
    let a = r;
    for (const l of s) a = o(a, l);
    return a;
  }, i.slice = function* (s, o, r = s.length) {
    for (o < 0 && (o += s.length), r < 0 ? r += s.length : r > s.length && (r = s.length); o < r; o++) yield s[o];
  }, i.consume = function(s, o = Number.POSITIVE_INFINITY) {
    const r = [];
    if (o === 0) return [r, s];
    const a = s[Symbol.iterator]();
    for (let l = 0; l < o; l++) {
      const d = a.next();
      if (d.done) return [r, i.empty()];
      r.push(d.value);
    }
    return [r, { [Symbol.iterator]: () => a }];
  }, i.asyncToArray = async function(s) {
    const o = [];
    for await (const r of s) o.push(r);
    return Promise.resolve(o);
  };
})(at || (at = {}));
let Wi = class LN {
  constructor(e) {
    this.element = e, this.next = LN.Undefined, this.prev = LN.Undefined;
  }
};
Wi.Undefined = new Wi(void 0);
class fs {
  constructor() {
    this._first = Wi.Undefined, this._last = Wi.Undefined, this._size = 0;
  }
  get size() {
    return this._size;
  }
  isEmpty() {
    return this._first === Wi.Undefined;
  }
  clear() {
    let e = this._first;
    for (; e !== Wi.Undefined; ) {
      const t = e.next;
      e.prev = Wi.Undefined, e.next = Wi.Undefined, e = t;
    }
    this._first = Wi.Undefined, this._last = Wi.Undefined, this._size = 0;
  }
  unshift(e) {
    return this._insert(e, !1);
  }
  push(e) {
    return this._insert(e, !0);
  }
  _insert(e, t) {
    const n = new Wi(e);
    if (this._first === Wi.Undefined) this._first = n, this._last = n;
    else if (t) {
      const o = this._last;
      this._last = n, n.prev = o, o.next = n;
    } else {
      const o = this._first;
      this._first = n, n.next = o, o.prev = n;
    }
    this._size += 1;
    let s = !1;
    return () => {
      s || (s = !0, this._remove(n));
    };
  }
  shift() {
    if (this._first !== Wi.Undefined) {
      const e = this._first.element;
      return this._remove(this._first), e;
    }
  }
  pop() {
    if (this._last !== Wi.Undefined) {
      const e = this._last.element;
      return this._remove(this._last), e;
    }
  }
  _remove(e) {
    if (e.prev !== Wi.Undefined && e.next !== Wi.Undefined) {
      const t = e.prev;
      t.next = e.next, e.next.prev = t;
    } else e.prev === Wi.Undefined && e.next === Wi.Undefined ? (this._first = Wi.Undefined, this._last = Wi.Undefined) : e.next === Wi.Undefined ? (this._last = this._last.prev, this._last.next = Wi.Undefined) : e.prev === Wi.Undefined && (this._first = this._first.next, this._first.prev = Wi.Undefined);
    this._size -= 1;
  }
  *[Symbol.iterator]() {
    let e = this._first;
    for (; e !== Wi.Undefined; ) yield e.element, e = e.next;
  }
}
const x7 = "`~!@#$%^&*()-=+[{]}\\|;:'\",.<>/?", GT = function(i = "") {
  let e = "(-?\\d*\\.\\d\\w*)|([^";
  for (const t of x7) i.indexOf(t) >= 0 || (e += "\\" + t);
  return e += "\\s]+)", new RegExp(e, "g");
}();
function ZT(i) {
  let e = GT;
  if (i && i instanceof RegExp) if (i.global) e = i;
  else {
    let t = "g";
    i.ignoreCase && (t += "i"), i.multiline && (t += "m"), i.unicode && (t += "u"), e = new RegExp(i.source, t);
  }
  return e.lastIndex = 0, e;
}
const N7 = new fs();
function q0(i, e, t, n, s) {
  if (e = ZT(e), s || (s = at.first(N7)), t.length > s.maxLen) {
    let d = i - s.maxLen / 2;
    return d < 0 ? d = 0 : n += d, q0(i, e, t = t.substring(d, i + s.maxLen / 2), n, s);
  }
  const o = Date.now(), r = i - 1 - n;
  let a = -1, l = null;
  for (let d = 1; !(Date.now() - o >= s.timeBudget); d++) {
    const h = r - s.windowSize * d;
    e.lastIndex = Math.max(0, h);
    const c = iK(e, t, r, a);
    if (!c && l || (l = c, h <= 0)) break;
    a = h;
  }
  if (l) {
    const d = { word: l[0], startColumn: n + 1 + l.index, endColumn: n + 1 + l.index + l[0].length };
    return e.lastIndex = 0, d;
  }
  return null;
}
function iK(i, e, t, n) {
  let s;
  for (; s = i.exec(e); ) {
    const o = s.index || 0;
    if (o <= t && i.lastIndex >= t) return s;
    if (n > 0 && o > n) return null;
  }
  return null;
}
N7.unshift({ maxLen: 1e3, windowSize: 15, timeBudget: 150 });
class E7 {
  constructor(e) {
    this._values = e;
  }
  hasChanged(e) {
    return this._values[e];
  }
}
class I7 {
  constructor() {
    this.stableMinimapLayoutInput = null, this.stableFitMaxMinimapScale = 0, this.stableFitRemainingWidth = 0;
  }
}
class Qt {
  constructor(e, t, n, s) {
    this.id = e, this.name = t, this.defaultValue = n, this.schema = s;
  }
  applyUpdate(e, t) {
    return FS(e, t);
  }
  compute(e, t, n) {
    return n;
  }
}
class G_ {
  constructor(e, t) {
    this.newValue = e, this.didChange = t;
  }
}
function FS(i, e) {
  if (typeof i != "object" || typeof e != "object" || !i || !e) return new G_(e, i !== e);
  if (Array.isArray(i) || Array.isArray(e)) {
    const n = Array.isArray(i) && Array.isArray(e) && ri(i, e);
    return new G_(e, !n);
  }
  let t = !1;
  for (const n in e) if (e.hasOwnProperty(n)) {
    const s = FS(i[n], e[n]);
    s.didChange && (i[n] = s.newValue, t = !0);
  }
  return new G_(i, t);
}
class c_ {
  constructor(e) {
    this.schema = void 0, this.id = e, this.name = "_never_", this.defaultValue = void 0;
  }
  applyUpdate(e, t) {
    return FS(e, t);
  }
  validate(e) {
    return this.defaultValue;
  }
}
class cf {
  constructor(e, t, n, s) {
    this.id = e, this.name = t, this.defaultValue = n, this.schema = s;
  }
  applyUpdate(e, t) {
    return FS(e, t);
  }
  validate(e) {
    return e === void 0 ? this.defaultValue : e;
  }
  compute(e, t, n) {
    return n;
  }
}
function ve(i, e) {
  return i === void 0 ? e : i !== "false" && !!i;
}
class gt extends cf {
  constructor(e, t, n, s = void 0) {
    s !== void 0 && (s.type = "boolean", s.default = n), super(e, t, n, s);
  }
  validate(e) {
    return ve(e, this.defaultValue);
  }
}
function nu(i, e, t, n) {
  if (i === void 0) return e;
  let s = parseInt(i, 10);
  return isNaN(s) ? e : (s = Math.max(t, s), s = Math.min(n, s), 0 | s);
}
class Ot extends cf {
  static clampedInt(e, t, n, s) {
    return nu(e, t, n, s);
  }
  constructor(e, t, n, s, o, r = void 0) {
    r !== void 0 && (r.type = "integer", r.default = n, r.minimum = s, r.maximum = o), super(e, t, n, r), this.minimum = s, this.maximum = o;
  }
  validate(e) {
    return Ot.clampedInt(e, this.defaultValue, this.minimum, this.maximum);
  }
}
function nK(i, e, t, n) {
  if (i === void 0) return e;
  const s = Fo.float(i, e);
  return Fo.clamp(s, t, n);
}
class Fo extends cf {
  static clamp(e, t, n) {
    return e < t ? t : e > n ? n : e;
  }
  static float(e, t) {
    if (typeof e == "number") return e;
    if (e === void 0) return t;
    const n = parseFloat(e);
    return isNaN(n) ? t : n;
  }
  constructor(e, t, n, s, o) {
    o !== void 0 && (o.type = "number", o.default = n), super(e, t, n, o), this.validationFn = s;
  }
  validate(e) {
    return this.validationFn(Fo.float(e, this.defaultValue));
  }
}
class ss extends cf {
  static string(e, t) {
    return typeof e != "string" ? t : e;
  }
  constructor(e, t, n, s = void 0) {
    s !== void 0 && (s.type = "string", s.default = n), super(e, t, n, s);
  }
  validate(e) {
    return ss.string(e, this.defaultValue);
  }
}
function _i(i, e, t, n) {
  return typeof i != "string" ? e : n && i in n ? n[i] : t.indexOf(i) === -1 ? e : i;
}
class hi extends cf {
  constructor(e, t, n, s, o = void 0) {
    o !== void 0 && (o.type = "string", o.enum = s, o.default = n), super(e, t, n, o), this._allowedValues = s;
  }
  validate(e) {
    return _i(e, this.defaultValue, this._allowedValues);
  }
}
class Z1 extends Qt {
  constructor(e, t, n, s, o, r, a = void 0) {
    a !== void 0 && (a.type = "string", a.enum = o, a.default = s), super(e, t, n, a), this._allowedValues = o, this._convert = r;
  }
  validate(e) {
    return typeof e != "string" || this._allowedValues.indexOf(e) === -1 ? this.defaultValue : this._convert(e);
  }
}
var vn, mr;
(function(i) {
  i[i.Line = 1] = "Line", i[i.Block = 2] = "Block", i[i.Underline = 3] = "Underline", i[i.LineThin = 4] = "LineThin", i[i.BlockOutline = 5] = "BlockOutline", i[i.UnderlineThin = 6] = "UnderlineThin";
})(vn || (vn = {}));
class fo extends Qt {
  constructor() {
    super(51, "fontLigatures", fo.OFF, { anyOf: [{ type: "boolean", description: m(0, "Enables/Disables font ligatures ('calt' and 'liga' font features). Change this to a string for fine-grained control of the 'font-feature-settings' CSS property.") }, { type: "string", description: m(0, "Explicit 'font-feature-settings' CSS property. A boolean can be passed instead if one only needs to turn on/off ligatures.") }], description: m(0, "Configures font ligatures or font features. Can be either a boolean to enable/disable ligatures or a string for the value of the CSS 'font-feature-settings' property."), default: !1 });
  }
  validate(e) {
    return e === void 0 ? this.defaultValue : typeof e == "string" ? e === "false" || e.length === 0 ? fo.OFF : e === "true" ? fo.ON : e : e ? fo.ON : fo.OFF;
  }
}
fo.OFF = '"liga" off, "calt" off', fo.ON = '"liga" on, "calt" on';
class Xr extends Qt {
  constructor() {
    super(54, "fontVariations", Xr.OFF, { anyOf: [{ type: "boolean", description: m(0, "Enables/Disables the translation from font-weight to font-variation-settings. Change this to a string for fine-grained control of the 'font-variation-settings' CSS property.") }, { type: "string", description: m(0, "Explicit 'font-variation-settings' CSS property. A boolean can be passed instead if one only needs to translate font-weight to font-variation-settings.") }], description: m(0, "Configures font variations. Can be either a boolean to enable/disable the translation from font-weight to font-variation-settings or a string for the value of the CSS 'font-variation-settings' property."), default: !1 });
  }
  validate(e) {
    return e === void 0 ? this.defaultValue : typeof e == "string" ? e === "false" ? Xr.OFF : e === "true" ? Xr.TRANSLATE : e : e ? Xr.TRANSLATE : Xr.OFF;
  }
  compute(e, t, n) {
    return e.fontInfo.fontVariationSettings;
  }
}
Xr.OFF = "normal", Xr.TRANSLATE = "translate";
class ja extends Qt {
  constructor() {
    super(53, "fontWeight", Is.fontWeight, { anyOf: [{ type: "number", minimum: ja.MINIMUM_VALUE, maximum: ja.MAXIMUM_VALUE, errorMessage: m(0, 'Only "normal" and "bold" keywords or numbers between 1 and 1000 are allowed.') }, { type: "string", pattern: "^(normal|bold|1000|[1-9][0-9]{0,2})$" }, { enum: ja.SUGGESTION_VALUES }], default: Is.fontWeight, description: m(0, 'Controls the font weight. Accepts "normal" and "bold" keywords or numbers between 1 and 1000.') });
  }
  validate(e) {
    return e === "normal" || e === "bold" ? e : String(Ot.clampedInt(e, Is.fontWeight, ja.MINIMUM_VALUE, ja.MAXIMUM_VALUE));
  }
}
ja.SUGGESTION_VALUES = ["normal", "bold", "100", "200", "300", "400", "500", "600", "700", "800", "900"], ja.MINIMUM_VALUE = 1, ja.MAXIMUM_VALUE = 1e3;
class Xp extends c_ {
  constructor() {
    super(145);
  }
  compute(e, t, n) {
    return Xp.computeLayout(t, { memory: e.memory, outerWidth: e.outerWidth, outerHeight: e.outerHeight, isDominatedByLongLines: e.isDominatedByLongLines, lineHeight: e.fontInfo.lineHeight, viewLineCount: e.viewLineCount, lineNumbersDigitCount: e.lineNumbersDigitCount, typicalHalfwidthCharacterWidth: e.fontInfo.typicalHalfwidthCharacterWidth, maxDigitWidth: e.fontInfo.maxDigitWidth, pixelRatio: e.pixelRatio, glyphMarginDecorationLaneCount: e.glyphMarginDecorationLaneCount });
  }
  static computeContainedMinimapLineCount(e) {
    const t = e.height / e.lineHeight, n = Math.floor(e.paddingTop / e.lineHeight);
    let s = Math.floor(e.paddingBottom / e.lineHeight);
    e.scrollBeyondLastLine && (s = Math.max(s, t - 1));
    const o = (n + e.viewLineCount + s) / (e.pixelRatio * e.height);
    return { typicalViewportLineCount: t, extraLinesBeforeFirstLine: n, extraLinesBeyondLastLine: s, desiredRatio: o, minimapLineCount: Math.floor(e.viewLineCount / o) };
  }
  static _computeMinimapLayout(e, t) {
    const n = e.outerWidth, s = e.outerHeight, o = e.pixelRatio;
    if (!e.minimap.enabled) return { renderMinimap: 0, minimapLeft: 0, minimapWidth: 0, minimapHeightIsEditorHeight: !1, minimapIsSampling: !1, minimapScale: 1, minimapLineHeight: 1, minimapCanvasInnerWidth: 0, minimapCanvasInnerHeight: Math.floor(o * s), minimapCanvasOuterWidth: 0, minimapCanvasOuterHeight: s };
    const r = t.stableMinimapLayoutInput, a = r && e.outerHeight === r.outerHeight && e.lineHeight === r.lineHeight && e.typicalHalfwidthCharacterWidth === r.typicalHalfwidthCharacterWidth && e.pixelRatio === r.pixelRatio && e.scrollBeyondLastLine === r.scrollBeyondLastLine && e.paddingTop === r.paddingTop && e.paddingBottom === r.paddingBottom && e.minimap.enabled === r.minimap.enabled && e.minimap.side === r.minimap.side && e.minimap.size === r.minimap.size && e.minimap.showSlider === r.minimap.showSlider && e.minimap.renderCharacters === r.minimap.renderCharacters && e.minimap.maxColumn === r.minimap.maxColumn && e.minimap.scale === r.minimap.scale && e.verticalScrollbarWidth === r.verticalScrollbarWidth && e.isViewportWrapping === r.isViewportWrapping, l = e.lineHeight, d = e.typicalHalfwidthCharacterWidth, h = e.scrollBeyondLastLine, c = e.minimap.renderCharacters;
    let u = o >= 2 ? Math.round(2 * e.minimap.scale) : e.minimap.scale;
    const g = e.minimap.maxColumn, p = e.minimap.size, f = e.minimap.side, _ = e.verticalScrollbarWidth, v = e.viewLineCount, b = e.remainingWidth, C = e.isViewportWrapping, w = c ? 2 : 3;
    let y = Math.floor(o * s);
    const L = y / o;
    let k = !1, N = !1, A = w * u, B = u / o, T = 1;
    if (p === "fill" || p === "fit") {
      const { typicalViewportLineCount: me, extraLinesBeforeFirstLine: ue, extraLinesBeyondLastLine: ee, desiredRatio: te, minimapLineCount: be } = Xp.computeContainedMinimapLineCount({ viewLineCount: v, scrollBeyondLastLine: h, paddingTop: e.paddingTop, paddingBottom: e.paddingBottom, height: s, lineHeight: l, pixelRatio: o });
      if (v / be > 1) k = !0, N = !0, u = 1, A = 1, B = u / o;
      else {
        let we = !1, Re = u + 1;
        if (p === "fit") {
          const it = Math.ceil((ue + v + ee) * A);
          C && a && b <= t.stableFitRemainingWidth ? (we = !0, Re = t.stableFitMaxMinimapScale) : we = it > y;
        }
        if (p === "fill" || we) {
          k = !0;
          const it = u;
          A = Math.min(l * o, Math.max(1, Math.floor(1 / te))), C && a && b <= t.stableFitRemainingWidth && (Re = t.stableFitMaxMinimapScale), u = Math.min(Re, Math.max(1, Math.floor(A / w))), u > it && (T = Math.min(2, u / it)), B = u / o / T, y = Math.ceil(Math.max(me, ue + v + ee) * A), C ? (t.stableMinimapLayoutInput = e, t.stableFitRemainingWidth = b, t.stableFitMaxMinimapScale = u) : (t.stableMinimapLayoutInput = null, t.stableFitRemainingWidth = 0);
        }
      }
    }
    const O = Math.floor(g * B), H = Math.min(O, Math.max(0, Math.floor((b - _ - 2) * B / (d + B))) + 8);
    let $ = Math.floor(o * H);
    const pe = $ / o;
    return $ = Math.floor($ * T), { renderMinimap: c ? 1 : 2, minimapLeft: f === "left" ? 0 : n - H - _, minimapWidth: H, minimapHeightIsEditorHeight: k, minimapIsSampling: N, minimapScale: u, minimapLineHeight: A, minimapCanvasInnerWidth: $, minimapCanvasInnerHeight: y, minimapCanvasOuterWidth: pe, minimapCanvasOuterHeight: L };
  }
  static computeLayout(e, t) {
    const n = 0 | t.outerWidth, s = 0 | t.outerHeight, o = 0 | t.lineHeight, r = 0 | t.lineNumbersDigitCount, a = t.typicalHalfwidthCharacterWidth, l = t.maxDigitWidth, d = t.pixelRatio, h = t.viewLineCount, c = e.get(137), u = c === "inherit" ? e.get(136) : c, g = u === "inherit" ? e.get(132) : u, p = e.get(135), f = t.isDominatedByLongLines, _ = e.get(57), v = e.get(68).renderType !== 0, b = e.get(69), C = e.get(105), w = e.get(84), y = e.get(73), L = e.get(103), k = L.verticalScrollbarSize, N = L.verticalHasArrows, A = L.arrowSize, B = L.horizontalScrollbarSize, T = e.get(43), O = e.get(110) !== "never";
    let H = e.get(66);
    T && O && (H += 16);
    let $ = 0;
    if (v) {
      const an = Math.max(r, b);
      $ = Math.round(an * l);
    }
    let pe = 0;
    _ && (pe = o * t.glyphMarginDecorationLaneCount);
    let me = 0, ue = me + pe, ee = ue + $, te = ee + H;
    const be = n - pe - $ - H;
    let we = !1, Re = !1, it = -1;
    u === "inherit" && f ? (we = !0, Re = !0) : g === "on" || g === "bounded" ? Re = !0 : g === "wordWrapColumn" && (it = p);
    const ut = Xp._computeMinimapLayout({ outerWidth: n, outerHeight: s, lineHeight: o, typicalHalfwidthCharacterWidth: a, pixelRatio: d, scrollBeyondLastLine: C, paddingTop: w.top, paddingBottom: w.bottom, minimap: y, verticalScrollbarWidth: k, viewLineCount: h, remainingWidth: be, isViewportWrapping: Re }, t.memory || new I7());
    ut.renderMinimap !== 0 && ut.minimapLeft === 0 && (me += ut.minimapWidth, ue += ut.minimapWidth, ee += ut.minimapWidth, te += ut.minimapWidth);
    const Xi = be - ut.minimapWidth, nt = Math.max(1, Math.floor((Xi - k - 2) / a)), De = N ? A : 0;
    return Re && (it = Math.max(1, nt), g === "bounded" && (it = Math.min(it, p))), { width: n, height: s, glyphMarginLeft: me, glyphMarginWidth: pe, glyphMarginDecorationLaneCount: t.glyphMarginDecorationLaneCount, lineNumbersLeft: ue, lineNumbersWidth: $, decorationsLeft: ee, decorationsWidth: H, contentLeft: te, contentWidth: Xi, minimap: ut, viewportColumn: nt, isWordWrapMinified: we, isViewportWrapping: Re, wrappingColumn: it, verticalScrollbarWidth: k, horizontalScrollbarHeight: B, overviewRuler: { top: De, width: k, height: s - 2 * De, right: 0 } };
  }
}
(function(i) {
  i.Off = "off", i.OnCode = "onCode", i.On = "on";
})(mr || (mr = {}));
function Mw(i) {
  const e = i.get(98);
  return e === "editable" ? i.get(91) : e !== "on";
}
function iO(i, e) {
  if (typeof i != "string") return e;
  switch (i) {
    case "hidden":
      return 2;
    case "visible":
      return 3;
    default:
      return 1;
  }
}
const ro = "inUntrustedWorkspace", kN = "editor.unicodeHighlight.allowedCharacters", M7 = "editor.unicodeHighlight.invisibleCharacters", T7 = "editor.unicodeHighlight.nonBasicASCII", R7 = "editor.unicodeHighlight.ambiguousCharacters", A7 = "editor.unicodeHighlight.includeComments", P7 = "editor.unicodeHighlight.includeStrings", DN = "editor.unicodeHighlight.allowedLocales";
function Vg(i, e, t) {
  const n = t.indexOf(i);
  return n === -1 ? e : t[n];
}
const Is = { fontFamily: Je ? "Menlo, Monaco, 'Courier New', monospace" : Cs ? "'Droid Sans Mono', 'monospace', monospace" : "Consolas, 'Courier New', monospace", fontWeight: "normal", fontSize: Je ? 12 : 14, lineHeight: 0, letterSpacing: 0 }, Lp = [];
function J(i) {
  return Lp[i.id] = i, i;
}
const ta = { acceptSuggestionOnCommitCharacter: J(new gt(0, "acceptSuggestionOnCommitCharacter", !0, { markdownDescription: m(0, "Controls whether suggestions should be accepted on commit characters. For example, in JavaScript, the semi-colon (`;`) can be a commit character that accepts a suggestion and types that character.") })), acceptSuggestionOnEnter: J(new hi(1, "acceptSuggestionOnEnter", "on", ["on", "smart", "off"], { markdownEnumDescriptions: ["", m(0, "Only accept a suggestion with `Enter` when it makes a textual change."), ""], markdownDescription: m(0, "Controls whether suggestions should be accepted on `Enter`, in addition to `Tab`. Helps to avoid ambiguity between inserting new lines or accepting suggestions.") })), accessibilitySupport: J(new class extends Qt {
  constructor() {
    super(2, "accessibilitySupport", 0, { type: "string", enum: ["auto", "on", "off"], enumDescriptions: [m(0, "Use platform APIs to detect when a Screen Reader is attached."), m(0, "Optimize for usage with a Screen Reader."), m(0, "Assume a screen reader is not attached.")], default: "auto", tags: ["accessibility"], description: m(0, "Controls if the UI should run in a mode where it is optimized for screen readers.") });
  }
  validate(i) {
    switch (i) {
      case "auto":
        return 0;
      case "off":
        return 1;
      case "on":
        return 2;
    }
    return this.defaultValue;
  }
  compute(i, e, t) {
    return t === 0 ? i.accessibilitySupport : t;
  }
}()), accessibilityPageSize: J(new Ot(3, "accessibilityPageSize", 10, 1, 1073741824, { description: m(0, "Controls the number of lines in the editor that can be read out by a screen reader at once. When we detect a screen reader we automatically set the default to be 500. Warning: this has a performance implication for numbers larger than the default."), tags: ["accessibility"] })), ariaLabel: J(new ss(4, "ariaLabel", m(0, "Editor content"))), ariaRequired: J(new gt(5, "ariaRequired", !1, void 0)), screenReaderAnnounceInlineSuggestion: J(new gt(8, "screenReaderAnnounceInlineSuggestion", !0, { description: m(0, "Control whether inline suggestions are announced by a screen reader."), tags: ["accessibility"] })), autoClosingBrackets: J(new hi(6, "autoClosingBrackets", "languageDefined", ["always", "languageDefined", "beforeWhitespace", "never"], { enumDescriptions: ["", m(0, "Use language configurations to determine when to autoclose brackets."), m(0, "Autoclose brackets only when the cursor is to the left of whitespace."), ""], description: m(0, "Controls whether the editor should automatically close brackets after the user adds an opening bracket.") })), autoClosingComments: J(new hi(7, "autoClosingComments", "languageDefined", ["always", "languageDefined", "beforeWhitespace", "never"], { enumDescriptions: ["", m(0, "Use language configurations to determine when to autoclose comments."), m(0, "Autoclose comments only when the cursor is to the left of whitespace."), ""], description: m(0, "Controls whether the editor should automatically close comments after the user adds an opening comment.") })), autoClosingDelete: J(new hi(9, "autoClosingDelete", "auto", ["always", "auto", "never"], { enumDescriptions: ["", m(0, "Remove adjacent closing quotes or brackets only if they were automatically inserted."), ""], description: m(0, "Controls whether the editor should remove adjacent closing quotes or brackets when deleting.") })), autoClosingOvertype: J(new hi(10, "autoClosingOvertype", "auto", ["always", "auto", "never"], { enumDescriptions: ["", m(0, "Type over closing quotes or brackets only if they were automatically inserted."), ""], description: m(0, "Controls whether the editor should type over closing quotes or brackets.") })), autoClosingQuotes: J(new hi(11, "autoClosingQuotes", "languageDefined", ["always", "languageDefined", "beforeWhitespace", "never"], { enumDescriptions: ["", m(0, "Use language configurations to determine when to autoclose quotes."), m(0, "Autoclose quotes only when the cursor is to the left of whitespace."), ""], description: m(0, "Controls whether the editor should automatically close quotes after the user adds an opening quote.") })), autoIndent: J(new Z1(12, "autoIndent", 4, "full", ["none", "keep", "brackets", "advanced", "full"], function(i) {
  switch (i) {
    case "none":
      return 0;
    case "keep":
      return 1;
    case "brackets":
      return 2;
    case "advanced":
      return 3;
    case "full":
      return 4;
  }
}, { enumDescriptions: [m(0, "The editor will not insert indentation automatically."), m(0, "The editor will keep the current line's indentation."), m(0, "The editor will keep the current line's indentation and honor language defined brackets."), m(0, "The editor will keep the current line's indentation, honor language defined brackets and invoke special onEnterRules defined by languages."), m(0, "The editor will keep the current line's indentation, honor language defined brackets, invoke special onEnterRules defined by languages, and honor indentationRules defined by languages.")], description: m(0, "Controls whether the editor should automatically adjust the indentation when users type, paste, move or indent lines.") })), automaticLayout: J(new gt(13, "automaticLayout", !1)), autoSurround: J(new hi(14, "autoSurround", "languageDefined", ["languageDefined", "quotes", "brackets", "never"], { enumDescriptions: [m(0, "Use language configurations to determine when to automatically surround selections."), m(0, "Surround with quotes but not brackets."), m(0, "Surround with brackets but not quotes."), ""], description: m(0, "Controls whether the editor should automatically surround selections when typing quotes or brackets.") })), bracketPairColorization: J(new class extends Qt {
  constructor() {
    const i = { enabled: Wn.bracketPairColorizationOptions.enabled, independentColorPoolPerBracketType: Wn.bracketPairColorizationOptions.independentColorPoolPerBracketType };
    super(15, "bracketPairColorization", i, { "editor.bracketPairColorization.enabled": { type: "boolean", default: i.enabled, markdownDescription: m(0, "Controls whether bracket pair colorization is enabled or not. Use {0} to override the bracket highlight colors.", "`#workbench.colorCustomizations#`") }, "editor.bracketPairColorization.independentColorPoolPerBracketType": { type: "boolean", default: i.independentColorPoolPerBracketType, description: m(0, "Controls whether each bracket type has its own independent color pool.") } });
  }
  validate(i) {
    if (!i || typeof i != "object") return this.defaultValue;
    const e = i;
    return { enabled: ve(e.enabled, this.defaultValue.enabled), independentColorPoolPerBracketType: ve(e.independentColorPoolPerBracketType, this.defaultValue.independentColorPoolPerBracketType) };
  }
}()), bracketPairGuides: J(new class extends Qt {
  constructor() {
    const i = { bracketPairs: !1, bracketPairsHorizontal: "active", highlightActiveBracketPair: !0, indentation: !0, highlightActiveIndentation: !0 };
    super(16, "guides", i, { "editor.guides.bracketPairs": { type: ["boolean", "string"], enum: [!0, "active", !1], enumDescriptions: [m(0, "Enables bracket pair guides."), m(0, "Enables bracket pair guides only for the active bracket pair."), m(0, "Disables bracket pair guides.")], default: i.bracketPairs, description: m(0, "Controls whether bracket pair guides are enabled or not.") }, "editor.guides.bracketPairsHorizontal": { type: ["boolean", "string"], enum: [!0, "active", !1], enumDescriptions: [m(0, "Enables horizontal guides as addition to vertical bracket pair guides."), m(0, "Enables horizontal guides only for the active bracket pair."), m(0, "Disables horizontal bracket pair guides.")], default: i.bracketPairsHorizontal, description: m(0, "Controls whether horizontal bracket pair guides are enabled or not.") }, "editor.guides.highlightActiveBracketPair": { type: "boolean", default: i.highlightActiveBracketPair, description: m(0, "Controls whether the editor should highlight the active bracket pair.") }, "editor.guides.indentation": { type: "boolean", default: i.indentation, description: m(0, "Controls whether the editor should render indent guides.") }, "editor.guides.highlightActiveIndentation": { type: ["boolean", "string"], enum: [!0, "always", !1], enumDescriptions: [m(0, "Highlights the active indent guide."), m(0, "Highlights the active indent guide even if bracket guides are highlighted."), m(0, "Do not highlight the active indent guide.")], default: i.highlightActiveIndentation, description: m(0, "Controls whether the editor should highlight the active indent guide.") } });
  }
  validate(i) {
    if (!i || typeof i != "object") return this.defaultValue;
    const e = i;
    return { bracketPairs: Vg(e.bracketPairs, this.defaultValue.bracketPairs, [!0, !1, "active"]), bracketPairsHorizontal: Vg(e.bracketPairsHorizontal, this.defaultValue.bracketPairsHorizontal, [!0, !1, "active"]), highlightActiveBracketPair: ve(e.highlightActiveBracketPair, this.defaultValue.highlightActiveBracketPair), indentation: ve(e.indentation, this.defaultValue.indentation), highlightActiveIndentation: Vg(e.highlightActiveIndentation, this.defaultValue.highlightActiveIndentation, [!0, !1, "always"]) };
  }
}()), stickyTabStops: J(new gt(116, "stickyTabStops", !1, { description: m(0, "Emulate selection behavior of tab characters when using spaces for indentation. Selection will stick to tab stops.") })), codeLens: J(new gt(17, "codeLens", !0, { description: m(0, "Controls whether the editor shows CodeLens.") })), codeLensFontFamily: J(new ss(18, "codeLensFontFamily", "", { description: m(0, "Controls the font family for CodeLens.") })), codeLensFontSize: J(new Ot(19, "codeLensFontSize", 0, 0, 100, { type: "number", default: 0, minimum: 0, maximum: 100, markdownDescription: m(0, "Controls the font size in pixels for CodeLens. When set to 0, 90% of `#editor.fontSize#` is used.") })), colorDecorators: J(new gt(20, "colorDecorators", !0, { description: m(0, "Controls whether the editor should render the inline color decorators and color picker.") })), colorDecoratorActivatedOn: J(new hi(148, "colorDecoratorsActivatedOn", "clickAndHover", ["clickAndHover", "hover", "click"], { enumDescriptions: [m(0, "Make the color picker appear both on click and hover of the color decorator"), m(0, "Make the color picker appear on hover of the color decorator"), m(0, "Make the color picker appear on click of the color decorator")], description: m(0, "Controls the condition to make a color picker appear from a color decorator") })), colorDecoratorsLimit: J(new Ot(21, "colorDecoratorsLimit", 500, 1, 1e6, { markdownDescription: m(0, "Controls the max number of color decorators that can be rendered in an editor at once.") })), columnSelection: J(new gt(22, "columnSelection", !1, { description: m(0, "Enable that the selection with the mouse and keys is doing column selection.") })), comments: J(new class extends Qt {
  constructor() {
    const i = { insertSpace: !0, ignoreEmptyLines: !0 };
    super(23, "comments", i, { "editor.comments.insertSpace": { type: "boolean", default: i.insertSpace, description: m(0, "Controls whether a space character is inserted when commenting.") }, "editor.comments.ignoreEmptyLines": { type: "boolean", default: i.ignoreEmptyLines, description: m(0, "Controls if empty lines should be ignored with toggle, add or remove actions for line comments.") } });
  }
  validate(i) {
    if (!i || typeof i != "object") return this.defaultValue;
    const e = i;
    return { insertSpace: ve(e.insertSpace, this.defaultValue.insertSpace), ignoreEmptyLines: ve(e.ignoreEmptyLines, this.defaultValue.ignoreEmptyLines) };
  }
}()), contextmenu: J(new gt(24, "contextmenu", !0)), copyWithSyntaxHighlighting: J(new gt(25, "copyWithSyntaxHighlighting", !0, { description: m(0, "Controls whether syntax highlighting should be copied into the clipboard.") })), cursorBlinking: J(new Z1(26, "cursorBlinking", 1, "blink", ["blink", "smooth", "phase", "expand", "solid"], function(i) {
  switch (i) {
    case "blink":
      return 1;
    case "smooth":
      return 2;
    case "phase":
      return 3;
    case "expand":
      return 4;
    case "solid":
      return 5;
  }
}, { description: m(0, "Control the cursor animation style.") })), cursorSmoothCaretAnimation: J(new hi(27, "cursorSmoothCaretAnimation", "off", ["off", "explicit", "on"], { enumDescriptions: [m(0, "Smooth caret animation is disabled."), m(0, "Smooth caret animation is enabled only when the user moves the cursor with an explicit gesture."), m(0, "Smooth caret animation is always enabled.")], description: m(0, "Controls whether the smooth caret animation should be enabled.") })), cursorStyle: J(new Z1(28, "cursorStyle", vn.Line, "line", ["line", "block", "underline", "line-thin", "block-outline", "underline-thin"], function(i) {
  switch (i) {
    case "line":
      return vn.Line;
    case "block":
      return vn.Block;
    case "underline":
      return vn.Underline;
    case "line-thin":
      return vn.LineThin;
    case "block-outline":
      return vn.BlockOutline;
    case "underline-thin":
      return vn.UnderlineThin;
  }
}, { description: m(0, "Controls the cursor style.") })), cursorSurroundingLines: J(new Ot(29, "cursorSurroundingLines", 0, 0, 1073741824, { description: m(0, "Controls the minimal number of visible leading lines (minimum 0) and trailing lines (minimum 1) surrounding the cursor. Known as 'scrollOff' or 'scrollOffset' in some other editors.") })), cursorSurroundingLinesStyle: J(new hi(30, "cursorSurroundingLinesStyle", "default", ["default", "all"], { enumDescriptions: [m(0, "`cursorSurroundingLines` is enforced only when triggered via the keyboard or API."), m(0, "`cursorSurroundingLines` is enforced always.")], markdownDescription: m(0, "Controls when `#editor.cursorSurroundingLines#` should be enforced.") })), cursorWidth: J(new Ot(31, "cursorWidth", 0, 0, 1073741824, { markdownDescription: m(0, "Controls the width of the cursor when `#editor.cursorStyle#` is set to `line`.") })), disableLayerHinting: J(new gt(32, "disableLayerHinting", !1)), disableMonospaceOptimizations: J(new gt(33, "disableMonospaceOptimizations", !1)), domReadOnly: J(new gt(34, "domReadOnly", !1)), dragAndDrop: J(new gt(35, "dragAndDrop", !0, { description: m(0, "Controls whether the editor should allow moving selections via drag and drop.") })), emptySelectionClipboard: J(new class extends gt {
  constructor() {
    super(37, "emptySelectionClipboard", !0, { description: m(0, "Controls whether copying without a selection copies the current line.") });
  }
  compute(i, e, t) {
    return t && i.emptySelectionClipboard;
  }
}()), dropIntoEditor: J(new class extends Qt {
  constructor() {
    const i = { enabled: !0, showDropSelector: "afterDrop" };
    super(36, "dropIntoEditor", i, { "editor.dropIntoEditor.enabled": { type: "boolean", default: i.enabled, markdownDescription: m(0, "Controls whether you can drag and drop a file into a text editor by holding down the `Shift` key (instead of opening the file in an editor).") }, "editor.dropIntoEditor.showDropSelector": { type: "string", markdownDescription: m(0, "Controls if a widget is shown when dropping files into the editor. This widget lets you control how the file is dropped."), enum: ["afterDrop", "never"], enumDescriptions: [m(0, "Show the drop selector widget after a file is dropped into the editor."), m(0, "Never show the drop selector widget. Instead the default drop provider is always used.")], default: "afterDrop" } });
  }
  validate(i) {
    if (!i || typeof i != "object") return this.defaultValue;
    const e = i;
    return { enabled: ve(e.enabled, this.defaultValue.enabled), showDropSelector: _i(e.showDropSelector, this.defaultValue.showDropSelector, ["afterDrop", "never"]) };
  }
}()), stickyScroll: J(new class extends Qt {
  constructor() {
    const i = { enabled: !0, maxLineCount: 5, defaultModel: "outlineModel", scrollWithEditor: !0 };
    super(115, "stickyScroll", i, { "editor.stickyScroll.enabled": { type: "boolean", default: i.enabled, description: m(0, "Shows the nested current scopes during the scroll at the top of the editor."), tags: ["experimental"] }, "editor.stickyScroll.maxLineCount": { type: "number", default: i.maxLineCount, minimum: 1, maximum: 20, description: m(0, "Defines the maximum number of sticky lines to show.") }, "editor.stickyScroll.defaultModel": { type: "string", enum: ["outlineModel", "foldingProviderModel", "indentationModel"], default: i.defaultModel, description: m(0, "Defines the model to use for determining which lines to stick. If the outline model does not exist, it will fall back on the folding provider model which falls back on the indentation model. This order is respected in all three cases.") }, "editor.stickyScroll.scrollWithEditor": { type: "boolean", default: i.scrollWithEditor, description: m(0, "Enable scrolling of Sticky Scroll with the editor's horizontal scrollbar.") } });
  }
  validate(i) {
    if (!i || typeof i != "object") return this.defaultValue;
    const e = i;
    return { enabled: ve(e.enabled, this.defaultValue.enabled), maxLineCount: Ot.clampedInt(e.maxLineCount, this.defaultValue.maxLineCount, 1, 20), defaultModel: _i(e.defaultModel, this.defaultValue.defaultModel, ["outlineModel", "foldingProviderModel", "indentationModel"]), scrollWithEditor: ve(e.scrollWithEditor, this.defaultValue.scrollWithEditor) };
  }
}()), experimentalWhitespaceRendering: J(new hi(38, "experimentalWhitespaceRendering", "svg", ["svg", "font", "off"], { enumDescriptions: [m(0, "Use a new rendering method with svgs."), m(0, "Use a new rendering method with font characters."), m(0, "Use the stable rendering method.")], description: m(0, "Controls whether whitespace is rendered with a new, experimental method.") })), extraEditorClassName: J(new ss(39, "extraEditorClassName", "")), fastScrollSensitivity: J(new Fo(40, "fastScrollSensitivity", 5, (i) => i <= 0 ? 5 : i, { markdownDescription: m(0, "Scrolling speed multiplier when pressing `Alt`.") })), find: J(new class extends Qt {
  constructor() {
    const i = { cursorMoveOnType: !0, seedSearchStringFromSelection: "always", autoFindInSelection: "never", globalFindClipboard: !1, addExtraSpaceOnTop: !0, loop: !0 };
    super(41, "find", i, { "editor.find.cursorMoveOnType": { type: "boolean", default: i.cursorMoveOnType, description: m(0, "Controls whether the cursor should jump to find matches while typing.") }, "editor.find.seedSearchStringFromSelection": { type: "string", enum: ["never", "always", "selection"], default: i.seedSearchStringFromSelection, enumDescriptions: [m(0, "Never seed search string from the editor selection."), m(0, "Always seed search string from the editor selection, including word at cursor position."), m(0, "Only seed search string from the editor selection.")], description: m(0, "Controls whether the search string in the Find Widget is seeded from the editor selection.") }, "editor.find.autoFindInSelection": { type: "string", enum: ["never", "always", "multiline"], default: i.autoFindInSelection, enumDescriptions: [m(0, "Never turn on Find in Selection automatically (default)."), m(0, "Always turn on Find in Selection automatically."), m(0, "Turn on Find in Selection automatically when multiple lines of content are selected.")], description: m(0, "Controls the condition for turning on Find in Selection automatically.") }, "editor.find.globalFindClipboard": { type: "boolean", default: i.globalFindClipboard, description: m(0, "Controls whether the Find Widget should read or modify the shared find clipboard on macOS."), included: Je }, "editor.find.addExtraSpaceOnTop": { type: "boolean", default: i.addExtraSpaceOnTop, description: m(0, "Controls whether the Find Widget should add extra lines on top of the editor. When true, you can scroll beyond the first line when the Find Widget is visible.") }, "editor.find.loop": { type: "boolean", default: i.loop, description: m(0, "Controls whether the search automatically restarts from the beginning (or the end) when no further matches can be found.") } });
  }
  validate(i) {
    if (!i || typeof i != "object") return this.defaultValue;
    const e = i;
    return { cursorMoveOnType: ve(e.cursorMoveOnType, this.defaultValue.cursorMoveOnType), seedSearchStringFromSelection: typeof i.seedSearchStringFromSelection == "boolean" ? i.seedSearchStringFromSelection ? "always" : "never" : _i(e.seedSearchStringFromSelection, this.defaultValue.seedSearchStringFromSelection, ["never", "always", "selection"]), autoFindInSelection: typeof i.autoFindInSelection == "boolean" ? i.autoFindInSelection ? "always" : "never" : _i(e.autoFindInSelection, this.defaultValue.autoFindInSelection, ["never", "always", "multiline"]), globalFindClipboard: ve(e.globalFindClipboard, this.defaultValue.globalFindClipboard), addExtraSpaceOnTop: ve(e.addExtraSpaceOnTop, this.defaultValue.addExtraSpaceOnTop), loop: ve(e.loop, this.defaultValue.loop) };
  }
}()), fixedOverflowWidgets: J(new gt(42, "fixedOverflowWidgets", !1)), folding: J(new gt(43, "folding", !0, { description: m(0, "Controls whether the editor has code folding enabled.") })), foldingStrategy: J(new hi(44, "foldingStrategy", "auto", ["auto", "indentation"], { enumDescriptions: [m(0, "Use a language-specific folding strategy if available, else the indentation-based one."), m(0, "Use the indentation-based folding strategy.")], description: m(0, "Controls the strategy for computing folding ranges.") })), foldingHighlight: J(new gt(45, "foldingHighlight", !0, { description: m(0, "Controls whether the editor should highlight folded ranges.") })), foldingImportsByDefault: J(new gt(46, "foldingImportsByDefault", !1, { description: m(0, "Controls whether the editor automatically collapses import ranges.") })), foldingMaximumRegions: J(new Ot(47, "foldingMaximumRegions", 5e3, 10, 65e3, { description: m(0, "The maximum number of foldable regions. Increasing this value may result in the editor becoming less responsive when the current source has a large number of foldable regions.") })), unfoldOnClickAfterEndOfLine: J(new gt(48, "unfoldOnClickAfterEndOfLine", !1, { description: m(0, "Controls whether clicking on the empty content after a folded line will unfold the line.") })), fontFamily: J(new ss(49, "fontFamily", Is.fontFamily, { description: m(0, "Controls the font family.") })), fontInfo: J(new class extends c_ {
  constructor() {
    super(50);
  }
  compute(i, e, t) {
    return i.fontInfo;
  }
}()), fontLigatures2: J(new fo()), fontSize: J(new class extends cf {
  constructor() {
    super(52, "fontSize", Is.fontSize, { type: "number", minimum: 6, maximum: 100, default: Is.fontSize, description: m(0, "Controls the font size in pixels.") });
  }
  validate(i) {
    const e = Fo.float(i, this.defaultValue);
    return e === 0 ? Is.fontSize : Fo.clamp(e, 6, 100);
  }
  compute(i, e, t) {
    return i.fontInfo.fontSize;
  }
}()), fontWeight: J(new ja()), fontVariations: J(new Xr()), formatOnPaste: J(new gt(55, "formatOnPaste", !1, { description: m(0, "Controls whether the editor should automatically format the pasted content. A formatter must be available and the formatter should be able to format a range in a document.") })), formatOnType: J(new gt(56, "formatOnType", !1, { description: m(0, "Controls whether the editor should automatically format the line after typing.") })), glyphMargin: J(new gt(57, "glyphMargin", !0, { description: m(0, "Controls whether the editor should render the vertical glyph margin. Glyph margin is mostly used for debugging.") })), gotoLocation: J(new class extends Qt {
  constructor() {
    const i = { multiple: "peek", multipleDefinitions: "peek", multipleTypeDefinitions: "peek", multipleDeclarations: "peek", multipleImplementations: "peek", multipleReferences: "peek", alternativeDefinitionCommand: "editor.action.goToReferences", alternativeTypeDefinitionCommand: "editor.action.goToReferences", alternativeDeclarationCommand: "editor.action.goToReferences", alternativeImplementationCommand: "", alternativeReferenceCommand: "" }, e = { type: "string", enum: ["peek", "gotoAndPeek", "goto"], default: i.multiple, enumDescriptions: [m(0, "Show Peek view of the results (default)"), m(0, "Go to the primary result and show a Peek view"), m(0, "Go to the primary result and enable Peek-less navigation to others")] }, t = ["", "editor.action.referenceSearch.trigger", "editor.action.goToReferences", "editor.action.peekImplementation", "editor.action.goToImplementation", "editor.action.peekTypeDefinition", "editor.action.goToTypeDefinition", "editor.action.peekDeclaration", "editor.action.revealDeclaration", "editor.action.peekDefinition", "editor.action.revealDefinitionAside", "editor.action.revealDefinition"];
    super(58, "gotoLocation", i, { "editor.gotoLocation.multiple": { deprecationMessage: m(0, "This setting is deprecated, please use separate settings like 'editor.editor.gotoLocation.multipleDefinitions' or 'editor.editor.gotoLocation.multipleImplementations' instead.") }, "editor.gotoLocation.multipleDefinitions": { description: m(0, "Controls the behavior the 'Go to Definition'-command when multiple target locations exist."), ...e }, "editor.gotoLocation.multipleTypeDefinitions": { description: m(0, "Controls the behavior the 'Go to Type Definition'-command when multiple target locations exist."), ...e }, "editor.gotoLocation.multipleDeclarations": { description: m(0, "Controls the behavior the 'Go to Declaration'-command when multiple target locations exist."), ...e }, "editor.gotoLocation.multipleImplementations": { description: m(0, "Controls the behavior the 'Go to Implementations'-command when multiple target locations exist."), ...e }, "editor.gotoLocation.multipleReferences": { description: m(0, "Controls the behavior the 'Go to References'-command when multiple target locations exist."), ...e }, "editor.gotoLocation.alternativeDefinitionCommand": { type: "string", default: i.alternativeDefinitionCommand, enum: t, description: m(0, "Alternative command id that is being executed when the result of 'Go to Definition' is the current location.") }, "editor.gotoLocation.alternativeTypeDefinitionCommand": { type: "string", default: i.alternativeTypeDefinitionCommand, enum: t, description: m(0, "Alternative command id that is being executed when the result of 'Go to Type Definition' is the current location.") }, "editor.gotoLocation.alternativeDeclarationCommand": { type: "string", default: i.alternativeDeclarationCommand, enum: t, description: m(0, "Alternative command id that is being executed when the result of 'Go to Declaration' is the current location.") }, "editor.gotoLocation.alternativeImplementationCommand": { type: "string", default: i.alternativeImplementationCommand, enum: t, description: m(0, "Alternative command id that is being executed when the result of 'Go to Implementation' is the current location.") }, "editor.gotoLocation.alternativeReferenceCommand": { type: "string", default: i.alternativeReferenceCommand, enum: t, description: m(0, "Alternative command id that is being executed when the result of 'Go to Reference' is the current location.") } });
  }
  validate(i) {
    var e, t, n, s, o;
    if (!i || typeof i != "object") return this.defaultValue;
    const r = i;
    return { multiple: _i(r.multiple, this.defaultValue.multiple, ["peek", "gotoAndPeek", "goto"]), multipleDefinitions: (e = r.multipleDefinitions) !== null && e !== void 0 ? e : _i(r.multipleDefinitions, "peek", ["peek", "gotoAndPeek", "goto"]), multipleTypeDefinitions: (t = r.multipleTypeDefinitions) !== null && t !== void 0 ? t : _i(r.multipleTypeDefinitions, "peek", ["peek", "gotoAndPeek", "goto"]), multipleDeclarations: (n = r.multipleDeclarations) !== null && n !== void 0 ? n : _i(r.multipleDeclarations, "peek", ["peek", "gotoAndPeek", "goto"]), multipleImplementations: (s = r.multipleImplementations) !== null && s !== void 0 ? s : _i(r.multipleImplementations, "peek", ["peek", "gotoAndPeek", "goto"]), multipleReferences: (o = r.multipleReferences) !== null && o !== void 0 ? o : _i(r.multipleReferences, "peek", ["peek", "gotoAndPeek", "goto"]), alternativeDefinitionCommand: ss.string(r.alternativeDefinitionCommand, this.defaultValue.alternativeDefinitionCommand), alternativeTypeDefinitionCommand: ss.string(r.alternativeTypeDefinitionCommand, this.defaultValue.alternativeTypeDefinitionCommand), alternativeDeclarationCommand: ss.string(r.alternativeDeclarationCommand, this.defaultValue.alternativeDeclarationCommand), alternativeImplementationCommand: ss.string(r.alternativeImplementationCommand, this.defaultValue.alternativeImplementationCommand), alternativeReferenceCommand: ss.string(r.alternativeReferenceCommand, this.defaultValue.alternativeReferenceCommand) };
  }
}()), hideCursorInOverviewRuler: J(new gt(59, "hideCursorInOverviewRuler", !1, { description: m(0, "Controls whether the cursor should be hidden in the overview ruler.") })), hover: J(new class extends Qt {
  constructor() {
    const i = { enabled: !0, delay: 300, hidingDelay: 300, sticky: !0, above: !0 };
    super(60, "hover", i, { "editor.hover.enabled": { type: "boolean", default: i.enabled, description: m(0, "Controls whether the hover is shown.") }, "editor.hover.delay": { type: "number", default: i.delay, minimum: 0, maximum: 1e4, description: m(0, "Controls the delay in milliseconds after which the hover is shown.") }, "editor.hover.sticky": { type: "boolean", default: i.sticky, description: m(0, "Controls whether the hover should remain visible when mouse is moved over it.") }, "editor.hover.hidingDelay": { type: "integer", minimum: 0, default: i.hidingDelay, description: m(0, "Controls the delay in milliseconds after which the hover is hidden. Requires `editor.hover.sticky` to be enabled.") }, "editor.hover.above": { type: "boolean", default: i.above, description: m(0, "Prefer showing hovers above the line, if there's space.") } });
  }
  validate(i) {
    if (!i || typeof i != "object") return this.defaultValue;
    const e = i;
    return { enabled: ve(e.enabled, this.defaultValue.enabled), delay: Ot.clampedInt(e.delay, this.defaultValue.delay, 0, 1e4), sticky: ve(e.sticky, this.defaultValue.sticky), hidingDelay: Ot.clampedInt(e.hidingDelay, this.defaultValue.hidingDelay, 0, 6e5), above: ve(e.above, this.defaultValue.above) };
  }
}()), inDiffEditor: J(new gt(61, "inDiffEditor", !1)), letterSpacing: J(new Fo(64, "letterSpacing", Is.letterSpacing, (i) => Fo.clamp(i, -5, 20), { description: m(0, "Controls the letter spacing in pixels.") })), lightbulb: J(new class extends Qt {
  constructor() {
    const i = { enabled: mr.On };
    super(65, "lightbulb", i, { "editor.lightbulb.enabled": { type: "string", tags: ["experimental"], enum: [mr.Off, mr.OnCode, mr.On], default: i.enabled, enumDescriptions: [m(0, "Disable the code action menu."), m(0, "Show the code action menu when the cursor is on lines with code."), m(0, "Show the code action menu when the cursor is on lines with code or on empty lines.")], description: m(0, "Enables the Code Action lightbulb in the editor.") } });
  }
  validate(i) {
    return !i || typeof i != "object" ? this.defaultValue : { enabled: _i(i.enabled, this.defaultValue.enabled, [mr.Off, mr.OnCode, mr.On]) };
  }
}()), lineDecorationsWidth: J(new class extends Qt {
  constructor() {
    super(66, "lineDecorationsWidth", 10);
  }
  validate(i) {
    return typeof i == "string" && /^\d+(\.\d+)?ch$/.test(i) ? -parseFloat(i.substring(0, i.length - 2)) : Ot.clampedInt(i, this.defaultValue, 0, 1e3);
  }
  compute(i, e, t) {
    return t < 0 ? Ot.clampedInt(-t * i.fontInfo.typicalHalfwidthCharacterWidth, this.defaultValue, 0, 1e3) : t;
  }
}()), lineHeight: J(new class extends Fo {
  constructor() {
    super(67, "lineHeight", Is.lineHeight, (i) => Fo.clamp(i, 0, 150), { markdownDescription: m(0, `Controls the line height. 
 - Use 0 to automatically compute the line height from the font size.
 - Values between 0 and 8 will be used as a multiplier with the font size.
 - Values greater than or equal to 8 will be used as effective values.`) });
  }
  compute(i, e, t) {
    return i.fontInfo.lineHeight;
  }
}()), lineNumbers: J(new class extends Qt {
  constructor() {
    super(68, "lineNumbers", { renderType: 1, renderFn: null }, { type: "string", enum: ["off", "on", "relative", "interval"], enumDescriptions: [m(0, "Line numbers are not rendered."), m(0, "Line numbers are rendered as absolute number."), m(0, "Line numbers are rendered as distance in lines to cursor position."), m(0, "Line numbers are rendered every 10 lines.")], default: "on", description: m(0, "Controls the display of line numbers.") });
  }
  validate(i) {
    let e = this.defaultValue.renderType, t = this.defaultValue.renderFn;
    return i !== void 0 && (typeof i == "function" ? (e = 4, t = i) : e = i === "interval" ? 3 : i === "relative" ? 2 : i === "on" ? 1 : 0), { renderType: e, renderFn: t };
  }
}()), lineNumbersMinChars: J(new Ot(69, "lineNumbersMinChars", 5, 1, 300)), linkedEditing: J(new gt(70, "linkedEditing", !1, { description: m(0, "Controls whether the editor has linked editing enabled. Depending on the language, related symbols such as HTML tags, are updated while editing.") })), links: J(new gt(71, "links", !0, { description: m(0, "Controls whether the editor should detect links and make them clickable.") })), matchBrackets: J(new hi(72, "matchBrackets", "always", ["always", "near", "never"], { description: m(0, "Highlight matching brackets.") })), minimap: J(new class extends Qt {
  constructor() {
    const i = { enabled: !0, size: "proportional", side: "right", showSlider: "mouseover", autohide: !1, renderCharacters: !0, maxColumn: 120, scale: 1, showRegionSectionHeaders: !0, showMarkSectionHeaders: !0, sectionHeaderFontSize: 9 };
    super(73, "minimap", i, { "editor.minimap.enabled": { type: "boolean", default: i.enabled, description: m(0, "Controls whether the minimap is shown.") }, "editor.minimap.autohide": { type: "boolean", default: i.autohide, description: m(0, "Controls whether the minimap is hidden automatically.") }, "editor.minimap.size": { type: "string", enum: ["proportional", "fill", "fit"], enumDescriptions: [m(0, "The minimap has the same size as the editor contents (and might scroll)."), m(0, "The minimap will stretch or shrink as necessary to fill the height of the editor (no scrolling)."), m(0, "The minimap will shrink as necessary to never be larger than the editor (no scrolling).")], default: i.size, description: m(0, "Controls the size of the minimap.") }, "editor.minimap.side": { type: "string", enum: ["left", "right"], default: i.side, description: m(0, "Controls the side where to render the minimap.") }, "editor.minimap.showSlider": { type: "string", enum: ["always", "mouseover"], default: i.showSlider, description: m(0, "Controls when the minimap slider is shown.") }, "editor.minimap.scale": { type: "number", default: i.scale, minimum: 1, maximum: 3, enum: [1, 2, 3], description: m(0, "Scale of content drawn in the minimap: 1, 2 or 3.") }, "editor.minimap.renderCharacters": { type: "boolean", default: i.renderCharacters, description: m(0, "Render the actual characters on a line as opposed to color blocks.") }, "editor.minimap.maxColumn": { type: "number", default: i.maxColumn, description: m(0, "Limit the width of the minimap to render at most a certain number of columns.") }, "editor.minimap.showRegionSectionHeaders": { type: "boolean", default: i.showRegionSectionHeaders, description: m(0, "Controls whether named regions are shown as section headers in the minimap.") }, "editor.minimap.showMarkSectionHeaders": { type: "boolean", default: i.showMarkSectionHeaders, description: m(0, "Controls whether MARK: comments are shown as section headers in the minimap.") }, "editor.minimap.sectionHeaderFontSize": { type: "number", default: i.sectionHeaderFontSize, description: m(0, "Controls the font size of section headers in the minimap.") } });
  }
  validate(i) {
    var e;
    if (!i || typeof i != "object") return this.defaultValue;
    const t = i;
    return { enabled: ve(t.enabled, this.defaultValue.enabled), autohide: ve(t.autohide, this.defaultValue.autohide), size: _i(t.size, this.defaultValue.size, ["proportional", "fill", "fit"]), side: _i(t.side, this.defaultValue.side, ["right", "left"]), showSlider: _i(t.showSlider, this.defaultValue.showSlider, ["always", "mouseover"]), renderCharacters: ve(t.renderCharacters, this.defaultValue.renderCharacters), scale: Ot.clampedInt(t.scale, 1, 1, 3), maxColumn: Ot.clampedInt(t.maxColumn, this.defaultValue.maxColumn, 1, 1e4), showRegionSectionHeaders: ve(t.showRegionSectionHeaders, this.defaultValue.showRegionSectionHeaders), showMarkSectionHeaders: ve(t.showMarkSectionHeaders, this.defaultValue.showMarkSectionHeaders), sectionHeaderFontSize: Fo.clamp((e = t.sectionHeaderFontSize) !== null && e !== void 0 ? e : this.defaultValue.sectionHeaderFontSize, 4, 32) };
  }
}()), mouseStyle: J(new hi(74, "mouseStyle", "text", ["text", "default", "copy"])), mouseWheelScrollSensitivity: J(new Fo(75, "mouseWheelScrollSensitivity", 1, (i) => i === 0 ? 1 : i, { markdownDescription: m(0, "A multiplier to be used on the `deltaX` and `deltaY` of mouse wheel scroll events.") })), mouseWheelZoom: J(new gt(76, "mouseWheelZoom", !1, { markdownDescription: m(0, Je ? "Zoom the font of the editor when using mouse wheel and holding `Cmd`." : "Zoom the font of the editor when using mouse wheel and holding `Ctrl`.") })), multiCursorMergeOverlapping: J(new gt(77, "multiCursorMergeOverlapping", !0, { description: m(0, "Merge multiple cursors when they are overlapping.") })), multiCursorModifier: J(new Z1(78, "multiCursorModifier", "altKey", "alt", ["ctrlCmd", "alt"], function(i) {
  return i === "ctrlCmd" ? Je ? "metaKey" : "ctrlKey" : "altKey";
}, { markdownEnumDescriptions: [m(0, "Maps to `Control` on Windows and Linux and to `Command` on macOS."), m(0, "Maps to `Alt` on Windows and Linux and to `Option` on macOS.")], markdownDescription: m(0, "The modifier to be used to add multiple cursors with the mouse. The Go to Definition and Open Link mouse gestures will adapt such that they do not conflict with the [multicursor modifier](https://code.visualstudio.com/docs/editor/codebasics#_multicursor-modifier).") })), multiCursorPaste: J(new hi(79, "multiCursorPaste", "spread", ["spread", "full"], { markdownEnumDescriptions: [m(0, "Each cursor pastes a single line of the text."), m(0, "Each cursor pastes the full text.")], markdownDescription: m(0, "Controls pasting when the line count of the pasted text matches the cursor count.") })), multiCursorLimit: J(new Ot(80, "multiCursorLimit", 1e4, 1, 1e5, { markdownDescription: m(0, "Controls the max number of cursors that can be in an active editor at once.") })), occurrencesHighlight: J(new hi(81, "occurrencesHighlight", "singleFile", ["off", "singleFile", "multiFile"], { markdownEnumDescriptions: [m(0, "Does not highlight occurrences."), m(0, "Highlights occurrences only in the current file."), m(0, "Experimental: Highlights occurrences across all valid open files.")], markdownDescription: m(0, "Controls whether occurrences should be highlighted across open files.") })), overviewRulerBorder: J(new gt(82, "overviewRulerBorder", !0, { description: m(0, "Controls whether a border should be drawn around the overview ruler.") })), overviewRulerLanes: J(new Ot(83, "overviewRulerLanes", 3, 0, 3)), padding: J(new class extends Qt {
  constructor() {
    super(84, "padding", { top: 0, bottom: 0 }, { "editor.padding.top": { type: "number", default: 0, minimum: 0, maximum: 1e3, description: m(0, "Controls the amount of space between the top edge of the editor and the first line.") }, "editor.padding.bottom": { type: "number", default: 0, minimum: 0, maximum: 1e3, description: m(0, "Controls the amount of space between the bottom edge of the editor and the last line.") } });
  }
  validate(i) {
    if (!i || typeof i != "object") return this.defaultValue;
    const e = i;
    return { top: Ot.clampedInt(e.top, 0, 0, 1e3), bottom: Ot.clampedInt(e.bottom, 0, 0, 1e3) };
  }
}()), pasteAs: J(new class extends Qt {
  constructor() {
    const i = { enabled: !0, showPasteSelector: "afterPaste" };
    super(85, "pasteAs", i, { "editor.pasteAs.enabled": { type: "boolean", default: i.enabled, markdownDescription: m(0, "Controls whether you can paste content in different ways.") }, "editor.pasteAs.showPasteSelector": { type: "string", markdownDescription: m(0, "Controls if a widget is shown when pasting content in to the editor. This widget lets you control how the file is pasted."), enum: ["afterPaste", "never"], enumDescriptions: [m(0, "Show the paste selector widget after content is pasted into the editor."), m(0, "Never show the paste selector widget. Instead the default pasting behavior is always used.")], default: "afterPaste" } });
  }
  validate(i) {
    if (!i || typeof i != "object") return this.defaultValue;
    const e = i;
    return { enabled: ve(e.enabled, this.defaultValue.enabled), showPasteSelector: _i(e.showPasteSelector, this.defaultValue.showPasteSelector, ["afterPaste", "never"]) };
  }
}()), parameterHints: J(new class extends Qt {
  constructor() {
    const i = { enabled: !0, cycle: !0 };
    super(86, "parameterHints", i, { "editor.parameterHints.enabled": { type: "boolean", default: i.enabled, description: m(0, "Enables a pop-up that shows parameter documentation and type information as you type.") }, "editor.parameterHints.cycle": { type: "boolean", default: i.cycle, description: m(0, "Controls whether the parameter hints menu cycles or closes when reaching the end of the list.") } });
  }
  validate(i) {
    if (!i || typeof i != "object") return this.defaultValue;
    const e = i;
    return { enabled: ve(e.enabled, this.defaultValue.enabled), cycle: ve(e.cycle, this.defaultValue.cycle) };
  }
}()), peekWidgetDefaultFocus: J(new hi(87, "peekWidgetDefaultFocus", "tree", ["tree", "editor"], { enumDescriptions: [m(0, "Focus the tree when opening peek"), m(0, "Focus the editor when opening peek")], description: m(0, "Controls whether to focus the inline editor or the tree in the peek widget.") })), definitionLinkOpensInPeek: J(new gt(88, "definitionLinkOpensInPeek", !1, { description: m(0, "Controls whether the Go to Definition mouse gesture always opens the peek widget.") })), quickSuggestions: J(new class extends Qt {
  constructor() {
    const i = { other: "on", comments: "off", strings: "off" }, e = [{ type: "boolean" }, { type: "string", enum: ["on", "inline", "off"], enumDescriptions: [m(0, "Quick suggestions show inside the suggest widget"), m(0, "Quick suggestions show as ghost text"), m(0, "Quick suggestions are disabled")] }];
    super(89, "quickSuggestions", i, { type: "object", additionalProperties: !1, properties: { strings: { anyOf: e, default: i.strings, description: m(0, "Enable quick suggestions inside strings.") }, comments: { anyOf: e, default: i.comments, description: m(0, "Enable quick suggestions inside comments.") }, other: { anyOf: e, default: i.other, description: m(0, "Enable quick suggestions outside of strings and comments.") } }, default: i, markdownDescription: m(0, "Controls whether suggestions should automatically show up while typing. This can be controlled for typing in comments, strings, and other code. Quick suggestion can be configured to show as ghost text or with the suggest widget. Also be aware of the '{0}'-setting which controls if suggestions are triggered by special characters.", "#editor.suggestOnTriggerCharacters#") }), this.defaultValue = i;
  }
  validate(i) {
    if (typeof i == "boolean") {
      const l = i ? "on" : "off";
      return { comments: l, strings: l, other: l };
    }
    if (!i || typeof i != "object") return this.defaultValue;
    const { other: e, comments: t, strings: n } = i, s = ["on", "inline", "off"];
    let o, r, a;
    return o = typeof e == "boolean" ? e ? "on" : "off" : _i(e, this.defaultValue.other, s), r = typeof t == "boolean" ? t ? "on" : "off" : _i(t, this.defaultValue.comments, s), a = typeof n == "boolean" ? n ? "on" : "off" : _i(n, this.defaultValue.strings, s), { other: o, comments: r, strings: a };
  }
}()), quickSuggestionsDelay: J(new Ot(90, "quickSuggestionsDelay", 10, 0, 1073741824, { description: m(0, "Controls the delay in milliseconds after which quick suggestions will show up.") })), readOnly: J(new gt(91, "readOnly", !1)), readOnlyMessage: J(new class extends Qt {
  constructor() {
    super(92, "readOnlyMessage", void 0);
  }
  validate(i) {
    return i && typeof i == "object" ? i : this.defaultValue;
  }
}()), renameOnType: J(new gt(93, "renameOnType", !1, { description: m(0, "Controls whether the editor auto renames on type."), markdownDeprecationMessage: m(0, "Deprecated, use `editor.linkedEditing` instead.") })), renderControlCharacters: J(new gt(94, "renderControlCharacters", !0, { description: m(0, "Controls whether the editor should render control characters."), restricted: !0 })), renderFinalNewline: J(new hi(95, "renderFinalNewline", Cs ? "dimmed" : "on", ["off", "on", "dimmed"], { description: m(0, "Render last line number when the file ends with a newline.") })), renderLineHighlight: J(new hi(96, "renderLineHighlight", "line", ["none", "gutter", "line", "all"], { enumDescriptions: ["", "", "", m(0, "Highlights both the gutter and the current line.")], description: m(0, "Controls how the editor should render the current line highlight.") })), renderLineHighlightOnlyWhenFocus: J(new gt(97, "renderLineHighlightOnlyWhenFocus", !1, { description: m(0, "Controls if the editor should render the current line highlight only when the editor is focused.") })), renderValidationDecorations: J(new hi(98, "renderValidationDecorations", "editable", ["editable", "on", "off"])), renderWhitespace: J(new hi(99, "renderWhitespace", "selection", ["none", "boundary", "selection", "trailing", "all"], { enumDescriptions: ["", m(0, "Render whitespace characters except for single spaces between words."), m(0, "Render whitespace characters only on selected text."), m(0, "Render only trailing whitespace characters."), ""], description: m(0, "Controls how the editor should render whitespace characters.") })), revealHorizontalRightPadding: J(new Ot(100, "revealHorizontalRightPadding", 15, 0, 1e3)), roundedSelection: J(new gt(101, "roundedSelection", !0, { description: m(0, "Controls whether selections should have rounded corners.") })), rulers: J(new class extends Qt {
  constructor() {
    const i = [], e = { type: "number", description: m(0, "Number of monospace characters at which this editor ruler will render.") };
    super(102, "rulers", i, { type: "array", items: { anyOf: [e, { type: ["object"], properties: { column: e, color: { type: "string", description: m(0, "Color of this editor ruler."), format: "color-hex" } } }] }, default: i, description: m(0, "Render vertical rulers after a certain number of monospace characters. Use multiple values for multiple rulers. No rulers are drawn if array is empty.") });
  }
  validate(i) {
    if (Array.isArray(i)) {
      const e = [];
      for (const t of i) if (typeof t == "number") e.push({ column: Ot.clampedInt(t, 0, 0, 1e4), color: null });
      else if (t && typeof t == "object") {
        const n = t;
        e.push({ column: Ot.clampedInt(n.column, 0, 0, 1e4), color: n.color });
      }
      return e.sort((t, n) => t.column - n.column), e;
    }
    return this.defaultValue;
  }
}()), scrollbar: J(new class extends Qt {
  constructor() {
    const i = { vertical: 1, horizontal: 1, arrowSize: 11, useShadows: !0, verticalHasArrows: !1, horizontalHasArrows: !1, horizontalScrollbarSize: 12, horizontalSliderSize: 12, verticalScrollbarSize: 14, verticalSliderSize: 14, handleMouseWheel: !0, alwaysConsumeMouseWheel: !0, scrollByPage: !1, ignoreHorizontalScrollbarInContentHeight: !1 };
    super(103, "scrollbar", i, { "editor.scrollbar.vertical": { type: "string", enum: ["auto", "visible", "hidden"], enumDescriptions: [m(0, "The vertical scrollbar will be visible only when necessary."), m(0, "The vertical scrollbar will always be visible."), m(0, "The vertical scrollbar will always be hidden.")], default: "auto", description: m(0, "Controls the visibility of the vertical scrollbar.") }, "editor.scrollbar.horizontal": { type: "string", enum: ["auto", "visible", "hidden"], enumDescriptions: [m(0, "The horizontal scrollbar will be visible only when necessary."), m(0, "The horizontal scrollbar will always be visible."), m(0, "The horizontal scrollbar will always be hidden.")], default: "auto", description: m(0, "Controls the visibility of the horizontal scrollbar.") }, "editor.scrollbar.verticalScrollbarSize": { type: "number", default: i.verticalScrollbarSize, description: m(0, "The width of the vertical scrollbar.") }, "editor.scrollbar.horizontalScrollbarSize": { type: "number", default: i.horizontalScrollbarSize, description: m(0, "The height of the horizontal scrollbar.") }, "editor.scrollbar.scrollByPage": { type: "boolean", default: i.scrollByPage, description: m(0, "Controls whether clicks scroll by page or jump to click position.") }, "editor.scrollbar.ignoreHorizontalScrollbarInContentHeight": { type: "boolean", default: i.ignoreHorizontalScrollbarInContentHeight, description: m(0, "When set, the horizontal scrollbar will not increase the size of the editor's content.") } });
  }
  validate(i) {
    if (!i || typeof i != "object") return this.defaultValue;
    const e = i, t = Ot.clampedInt(e.horizontalScrollbarSize, this.defaultValue.horizontalScrollbarSize, 0, 1e3), n = Ot.clampedInt(e.verticalScrollbarSize, this.defaultValue.verticalScrollbarSize, 0, 1e3);
    return { arrowSize: Ot.clampedInt(e.arrowSize, this.defaultValue.arrowSize, 0, 1e3), vertical: iO(e.vertical, this.defaultValue.vertical), horizontal: iO(e.horizontal, this.defaultValue.horizontal), useShadows: ve(e.useShadows, this.defaultValue.useShadows), verticalHasArrows: ve(e.verticalHasArrows, this.defaultValue.verticalHasArrows), horizontalHasArrows: ve(e.horizontalHasArrows, this.defaultValue.horizontalHasArrows), handleMouseWheel: ve(e.handleMouseWheel, this.defaultValue.handleMouseWheel), alwaysConsumeMouseWheel: ve(e.alwaysConsumeMouseWheel, this.defaultValue.alwaysConsumeMouseWheel), horizontalScrollbarSize: t, horizontalSliderSize: Ot.clampedInt(e.horizontalSliderSize, t, 0, 1e3), verticalScrollbarSize: n, verticalSliderSize: Ot.clampedInt(e.verticalSliderSize, n, 0, 1e3), scrollByPage: ve(e.scrollByPage, this.defaultValue.scrollByPage), ignoreHorizontalScrollbarInContentHeight: ve(e.ignoreHorizontalScrollbarInContentHeight, this.defaultValue.ignoreHorizontalScrollbarInContentHeight) };
  }
}()), scrollBeyondLastColumn: J(new Ot(104, "scrollBeyondLastColumn", 4, 0, 1073741824, { description: m(0, "Controls the number of extra characters beyond which the editor will scroll horizontally.") })), scrollBeyondLastLine: J(new gt(105, "scrollBeyondLastLine", !0, { description: m(0, "Controls whether the editor will scroll beyond the last line.") })), scrollPredominantAxis: J(new gt(106, "scrollPredominantAxis", !0, { description: m(0, "Scroll only along the predominant axis when scrolling both vertically and horizontally at the same time. Prevents horizontal drift when scrolling vertically on a trackpad.") })), selectionClipboard: J(new gt(107, "selectionClipboard", !0, { description: m(0, "Controls whether the Linux primary clipboard should be supported."), included: Cs })), selectionHighlight: J(new gt(108, "selectionHighlight", !0, { description: m(0, "Controls whether the editor should highlight matches similar to the selection.") })), selectOnLineNumbers: J(new gt(109, "selectOnLineNumbers", !0)), showFoldingControls: J(new hi(110, "showFoldingControls", "mouseover", ["always", "never", "mouseover"], { enumDescriptions: [m(0, "Always show the folding controls."), m(0, "Never show the folding controls and reduce the gutter size."), m(0, "Only show the folding controls when the mouse is over the gutter.")], description: m(0, "Controls when the folding controls on the gutter are shown.") })), showUnused: J(new gt(111, "showUnused", !0, { description: m(0, "Controls fading out of unused code.") })), showDeprecated: J(new gt(140, "showDeprecated", !0, { description: m(0, "Controls strikethrough deprecated variables.") })), inlayHints: J(new class extends Qt {
  constructor() {
    const i = { enabled: "on", fontSize: 0, fontFamily: "", padding: !1 };
    super(141, "inlayHints", i, { "editor.inlayHints.enabled": { type: "string", default: i.enabled, description: m(0, "Enables the inlay hints in the editor."), enum: ["on", "onUnlessPressed", "offUnlessPressed", "off"], markdownEnumDescriptions: [m(0, "Inlay hints are enabled"), m(0, "Inlay hints are showing by default and hide when holding {0}", Je ? "Ctrl+Option" : "Ctrl+Alt"), m(0, "Inlay hints are hidden by default and show when holding {0}", Je ? "Ctrl+Option" : "Ctrl+Alt"), m(0, "Inlay hints are disabled")] }, "editor.inlayHints.fontSize": { type: "number", default: i.fontSize, markdownDescription: m(0, "Controls font size of inlay hints in the editor. As default the {0} is used when the configured value is less than {1} or greater than the editor font size.", "`#editor.fontSize#`", "`5`") }, "editor.inlayHints.fontFamily": { type: "string", default: i.fontFamily, markdownDescription: m(0, "Controls font family of inlay hints in the editor. When set to empty, the {0} is used.", "`#editor.fontFamily#`") }, "editor.inlayHints.padding": { type: "boolean", default: i.padding, description: m(0, "Enables the padding around the inlay hints in the editor.") } });
  }
  validate(i) {
    if (!i || typeof i != "object") return this.defaultValue;
    const e = i;
    return typeof e.enabled == "boolean" && (e.enabled = e.enabled ? "on" : "off"), { enabled: _i(e.enabled, this.defaultValue.enabled, ["on", "off", "offUnlessPressed", "onUnlessPressed"]), fontSize: Ot.clampedInt(e.fontSize, this.defaultValue.fontSize, 0, 100), fontFamily: ss.string(e.fontFamily, this.defaultValue.fontFamily), padding: ve(e.padding, this.defaultValue.padding) };
  }
}()), snippetSuggestions: J(new hi(112, "snippetSuggestions", "inline", ["top", "bottom", "inline", "none"], { enumDescriptions: [m(0, "Show snippet suggestions on top of other suggestions."), m(0, "Show snippet suggestions below other suggestions."), m(0, "Show snippets suggestions with other suggestions."), m(0, "Do not show snippet suggestions.")], description: m(0, "Controls whether snippets are shown with other suggestions and how they are sorted.") })), smartSelect: J(new class extends Qt {
  constructor() {
    super(113, "smartSelect", { selectLeadingAndTrailingWhitespace: !0, selectSubwords: !0 }, { "editor.smartSelect.selectLeadingAndTrailingWhitespace": { description: m(0, "Whether leading and trailing whitespace should always be selected."), default: !0, type: "boolean" }, "editor.smartSelect.selectSubwords": { description: m(0, "Whether subwords (like 'foo' in 'fooBar' or 'foo_bar') should be selected."), default: !0, type: "boolean" } });
  }
  validate(i) {
    return i && typeof i == "object" ? { selectLeadingAndTrailingWhitespace: ve(i.selectLeadingAndTrailingWhitespace, this.defaultValue.selectLeadingAndTrailingWhitespace), selectSubwords: ve(i.selectSubwords, this.defaultValue.selectSubwords) } : this.defaultValue;
  }
}()), smoothScrolling: J(new gt(114, "smoothScrolling", !1, { description: m(0, "Controls whether the editor will scroll using an animation.") })), stopRenderingLineAfter: J(new Ot(117, "stopRenderingLineAfter", 1e4, -1, 1073741824)), suggest: J(new class extends Qt {
  constructor() {
    const i = { insertMode: "insert", filterGraceful: !0, snippetsPreventQuickSuggestions: !1, localityBonus: !1, shareSuggestSelections: !1, selectionMode: "always", showIcons: !0, showStatusBar: !1, preview: !1, previewMode: "subwordSmart", showInlineDetails: !0, showMethods: !0, showFunctions: !0, showConstructors: !0, showDeprecated: !0, matchOnWordStartOnly: !0, showFields: !0, showVariables: !0, showClasses: !0, showStructs: !0, showInterfaces: !0, showModules: !0, showProperties: !0, showEvents: !0, showOperators: !0, showUnits: !0, showValues: !0, showConstants: !0, showEnums: !0, showEnumMembers: !0, showKeywords: !0, showWords: !0, showColors: !0, showFiles: !0, showReferences: !0, showFolders: !0, showTypeParameters: !0, showSnippets: !0, showUsers: !0, showIssues: !0 };
    super(118, "suggest", i, { "editor.suggest.insertMode": { type: "string", enum: ["insert", "replace"], enumDescriptions: [m(0, "Insert suggestion without overwriting text right of the cursor."), m(0, "Insert suggestion and overwrite text right of the cursor.")], default: i.insertMode, description: m(0, "Controls whether words are overwritten when accepting completions. Note that this depends on extensions opting into this feature.") }, "editor.suggest.filterGraceful": { type: "boolean", default: i.filterGraceful, description: m(0, "Controls whether filtering and sorting suggestions accounts for small typos.") }, "editor.suggest.localityBonus": { type: "boolean", default: i.localityBonus, description: m(0, "Controls whether sorting favors words that appear close to the cursor.") }, "editor.suggest.shareSuggestSelections": { type: "boolean", default: i.shareSuggestSelections, markdownDescription: m(0, "Controls whether remembered suggestion selections are shared between multiple workspaces and windows (needs `#editor.suggestSelection#`).") }, "editor.suggest.selectionMode": { type: "string", enum: ["always", "never", "whenTriggerCharacter", "whenQuickSuggestion"], enumDescriptions: [m(0, "Always select a suggestion when automatically triggering IntelliSense."), m(0, "Never select a suggestion when automatically triggering IntelliSense."), m(0, "Select a suggestion only when triggering IntelliSense from a trigger character."), m(0, "Select a suggestion only when triggering IntelliSense as you type.")], default: i.selectionMode, markdownDescription: m(0, "Controls whether a suggestion is selected when the widget shows. Note that this only applies to automatically triggered suggestions (`#editor.quickSuggestions#` and `#editor.suggestOnTriggerCharacters#`) and that a suggestion is always selected when explicitly invoked, e.g via `Ctrl+Space`.") }, "editor.suggest.snippetsPreventQuickSuggestions": { type: "boolean", default: i.snippetsPreventQuickSuggestions, description: m(0, "Controls whether an active snippet prevents quick suggestions.") }, "editor.suggest.showIcons": { type: "boolean", default: i.showIcons, description: m(0, "Controls whether to show or hide icons in suggestions.") }, "editor.suggest.showStatusBar": { type: "boolean", default: i.showStatusBar, description: m(0, "Controls the visibility of the status bar at the bottom of the suggest widget.") }, "editor.suggest.preview": { type: "boolean", default: i.preview, description: m(0, "Controls whether to preview the suggestion outcome in the editor.") }, "editor.suggest.showInlineDetails": { type: "boolean", default: i.showInlineDetails, description: m(0, "Controls whether suggest details show inline with the label or only in the details widget.") }, "editor.suggest.maxVisibleSuggestions": { type: "number", deprecationMessage: m(0, "This setting is deprecated. The suggest widget can now be resized.") }, "editor.suggest.filteredTypes": { type: "object", deprecationMessage: m(0, "This setting is deprecated, please use separate settings like 'editor.suggest.showKeywords' or 'editor.suggest.showSnippets' instead.") }, "editor.suggest.showMethods": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `method`-suggestions.") }, "editor.suggest.showFunctions": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `function`-suggestions.") }, "editor.suggest.showConstructors": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `constructor`-suggestions.") }, "editor.suggest.showDeprecated": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `deprecated`-suggestions.") }, "editor.suggest.matchOnWordStartOnly": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense filtering requires that the first character matches on a word start. For example, `c` on `Console` or `WebContext` but _not_ on `description`. When disabled IntelliSense will show more results but still sorts them by match quality.") }, "editor.suggest.showFields": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `field`-suggestions.") }, "editor.suggest.showVariables": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `variable`-suggestions.") }, "editor.suggest.showClasses": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `class`-suggestions.") }, "editor.suggest.showStructs": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `struct`-suggestions.") }, "editor.suggest.showInterfaces": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `interface`-suggestions.") }, "editor.suggest.showModules": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `module`-suggestions.") }, "editor.suggest.showProperties": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `property`-suggestions.") }, "editor.suggest.showEvents": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `event`-suggestions.") }, "editor.suggest.showOperators": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `operator`-suggestions.") }, "editor.suggest.showUnits": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `unit`-suggestions.") }, "editor.suggest.showValues": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `value`-suggestions.") }, "editor.suggest.showConstants": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `constant`-suggestions.") }, "editor.suggest.showEnums": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `enum`-suggestions.") }, "editor.suggest.showEnumMembers": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `enumMember`-suggestions.") }, "editor.suggest.showKeywords": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `keyword`-suggestions.") }, "editor.suggest.showWords": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `text`-suggestions.") }, "editor.suggest.showColors": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `color`-suggestions.") }, "editor.suggest.showFiles": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `file`-suggestions.") }, "editor.suggest.showReferences": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `reference`-suggestions.") }, "editor.suggest.showCustomcolors": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `customcolor`-suggestions.") }, "editor.suggest.showFolders": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `folder`-suggestions.") }, "editor.suggest.showTypeParameters": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `typeParameter`-suggestions.") }, "editor.suggest.showSnippets": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `snippet`-suggestions.") }, "editor.suggest.showUsers": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `user`-suggestions.") }, "editor.suggest.showIssues": { type: "boolean", default: !0, markdownDescription: m(0, "When enabled IntelliSense shows `issues`-suggestions.") } });
  }
  validate(i) {
    if (!i || typeof i != "object") return this.defaultValue;
    const e = i;
    return { insertMode: _i(e.insertMode, this.defaultValue.insertMode, ["insert", "replace"]), filterGraceful: ve(e.filterGraceful, this.defaultValue.filterGraceful), snippetsPreventQuickSuggestions: ve(e.snippetsPreventQuickSuggestions, this.defaultValue.filterGraceful), localityBonus: ve(e.localityBonus, this.defaultValue.localityBonus), shareSuggestSelections: ve(e.shareSuggestSelections, this.defaultValue.shareSuggestSelections), selectionMode: _i(e.selectionMode, this.defaultValue.selectionMode, ["always", "never", "whenQuickSuggestion", "whenTriggerCharacter"]), showIcons: ve(e.showIcons, this.defaultValue.showIcons), showStatusBar: ve(e.showStatusBar, this.defaultValue.showStatusBar), preview: ve(e.preview, this.defaultValue.preview), previewMode: _i(e.previewMode, this.defaultValue.previewMode, ["prefix", "subword", "subwordSmart"]), showInlineDetails: ve(e.showInlineDetails, this.defaultValue.showInlineDetails), showMethods: ve(e.showMethods, this.defaultValue.showMethods), showFunctions: ve(e.showFunctions, this.defaultValue.showFunctions), showConstructors: ve(e.showConstructors, this.defaultValue.showConstructors), showDeprecated: ve(e.showDeprecated, this.defaultValue.showDeprecated), matchOnWordStartOnly: ve(e.matchOnWordStartOnly, this.defaultValue.matchOnWordStartOnly), showFields: ve(e.showFields, this.defaultValue.showFields), showVariables: ve(e.showVariables, this.defaultValue.showVariables), showClasses: ve(e.showClasses, this.defaultValue.showClasses), showStructs: ve(e.showStructs, this.defaultValue.showStructs), showInterfaces: ve(e.showInterfaces, this.defaultValue.showInterfaces), showModules: ve(e.showModules, this.defaultValue.showModules), showProperties: ve(e.showProperties, this.defaultValue.showProperties), showEvents: ve(e.showEvents, this.defaultValue.showEvents), showOperators: ve(e.showOperators, this.defaultValue.showOperators), showUnits: ve(e.showUnits, this.defaultValue.showUnits), showValues: ve(e.showValues, this.defaultValue.showValues), showConstants: ve(e.showConstants, this.defaultValue.showConstants), showEnums: ve(e.showEnums, this.defaultValue.showEnums), showEnumMembers: ve(e.showEnumMembers, this.defaultValue.showEnumMembers), showKeywords: ve(e.showKeywords, this.defaultValue.showKeywords), showWords: ve(e.showWords, this.defaultValue.showWords), showColors: ve(e.showColors, this.defaultValue.showColors), showFiles: ve(e.showFiles, this.defaultValue.showFiles), showReferences: ve(e.showReferences, this.defaultValue.showReferences), showFolders: ve(e.showFolders, this.defaultValue.showFolders), showTypeParameters: ve(e.showTypeParameters, this.defaultValue.showTypeParameters), showSnippets: ve(e.showSnippets, this.defaultValue.showSnippets), showUsers: ve(e.showUsers, this.defaultValue.showUsers), showIssues: ve(e.showIssues, this.defaultValue.showIssues) };
  }
}()), inlineSuggest: J(new class extends Qt {
  constructor() {
    const i = { enabled: !0, mode: "subwordSmart", showToolbar: "onHover", suppressSuggestions: !1, keepOnBlur: !1, fontFamily: "default" };
    super(62, "inlineSuggest", i, { "editor.inlineSuggest.enabled": { type: "boolean", default: i.enabled, description: m(0, "Controls whether to automatically show inline suggestions in the editor.") }, "editor.inlineSuggest.showToolbar": { type: "string", default: i.showToolbar, enum: ["always", "onHover", "never"], enumDescriptions: [m(0, "Show the inline suggestion toolbar whenever an inline suggestion is shown."), m(0, "Show the inline suggestion toolbar when hovering over an inline suggestion."), m(0, "Never show the inline suggestion toolbar.")], description: m(0, "Controls when to show the inline suggestion toolbar.") }, "editor.inlineSuggest.suppressSuggestions": { type: "boolean", default: i.suppressSuggestions, description: m(0, "Controls how inline suggestions interact with the suggest widget. If enabled, the suggest widget is not shown automatically when inline suggestions are available.") }, "editor.inlineSuggest.fontFamily": { type: "string", default: i.fontFamily, description: m(0, "Controls the font family of the inline suggestions.") } });
  }
  validate(i) {
    if (!i || typeof i != "object") return this.defaultValue;
    const e = i;
    return { enabled: ve(e.enabled, this.defaultValue.enabled), mode: _i(e.mode, this.defaultValue.mode, ["prefix", "subword", "subwordSmart"]), showToolbar: _i(e.showToolbar, this.defaultValue.showToolbar, ["always", "onHover", "never"]), suppressSuggestions: ve(e.suppressSuggestions, this.defaultValue.suppressSuggestions), keepOnBlur: ve(e.keepOnBlur, this.defaultValue.keepOnBlur), fontFamily: ss.string(e.fontFamily, this.defaultValue.fontFamily) };
  }
}()), inlineEdit: J(new class extends Qt {
  constructor() {
    const i = { enabled: !1, showToolbar: "onHover", fontFamily: "default", keepOnBlur: !1, backgroundColoring: !1 };
    super(63, "experimentalInlineEdit", i, { "editor.experimentalInlineEdit.enabled": { type: "boolean", default: i.enabled, description: m(0, "Controls whether to show inline edits in the editor.") }, "editor.experimentalInlineEdit.showToolbar": { type: "string", default: i.showToolbar, enum: ["always", "onHover", "never"], enumDescriptions: [m(0, "Show the inline edit toolbar whenever an inline suggestion is shown."), m(0, "Show the inline edit toolbar when hovering over an inline suggestion."), m(0, "Never show the inline edit toolbar.")], description: m(0, "Controls when to show the inline edit toolbar.") }, "editor.experimentalInlineEdit.fontFamily": { type: "string", default: i.fontFamily, description: m(0, "Controls the font family of the inline edit.") }, "editor.experimentalInlineEdit.backgroundColoring": { type: "boolean", default: i.backgroundColoring, description: m(0, "Controls whether to color the background of inline edits.") } });
  }
  validate(i) {
    if (!i || typeof i != "object") return this.defaultValue;
    const e = i;
    return { enabled: ve(e.enabled, this.defaultValue.enabled), showToolbar: _i(e.showToolbar, this.defaultValue.showToolbar, ["always", "onHover", "never"]), fontFamily: ss.string(e.fontFamily, this.defaultValue.fontFamily), keepOnBlur: ve(e.keepOnBlur, this.defaultValue.keepOnBlur), backgroundColoring: ve(e.backgroundColoring, this.defaultValue.backgroundColoring) };
  }
}()), inlineCompletionsAccessibilityVerbose: J(new gt(149, "inlineCompletionsAccessibilityVerbose", !1, { description: m(0, "Controls whether the accessibility hint should be provided to screen reader users when an inline completion is shown.") })), suggestFontSize: J(new Ot(119, "suggestFontSize", 0, 0, 1e3, { markdownDescription: m(0, "Font size for the suggest widget. When set to {0}, the value of {1} is used.", "`0`", "`#editor.fontSize#`") })), suggestLineHeight: J(new Ot(120, "suggestLineHeight", 0, 0, 1e3, { markdownDescription: m(0, "Line height for the suggest widget. When set to {0}, the value of {1} is used. The minimum value is 8.", "`0`", "`#editor.lineHeight#`") })), suggestOnTriggerCharacters: J(new gt(121, "suggestOnTriggerCharacters", !0, { description: m(0, "Controls whether suggestions should automatically show up when typing trigger characters.") })), suggestSelection: J(new hi(122, "suggestSelection", "first", ["first", "recentlyUsed", "recentlyUsedByPrefix"], { markdownEnumDescriptions: [m(0, "Always select the first suggestion."), m(0, "Select recent suggestions unless further typing selects one, e.g. `console.| -> console.log` because `log` has been completed recently."), m(0, "Select suggestions based on previous prefixes that have completed those suggestions, e.g. `co -> console` and `con -> const`.")], description: m(0, "Controls how suggestions are pre-selected when showing the suggest list.") })), tabCompletion: J(new hi(123, "tabCompletion", "off", ["on", "off", "onlySnippets"], { enumDescriptions: [m(0, "Tab complete will insert the best matching suggestion when pressing tab."), m(0, "Disable tab completions."), m(0, "Tab complete snippets when their prefix match. Works best when 'quickSuggestions' aren't enabled.")], description: m(0, "Enables tab completions.") })), tabIndex: J(new Ot(124, "tabIndex", 0, -1, 1073741824)), unicodeHighlight: J(new class extends Qt {
  constructor() {
    const i = { nonBasicASCII: ro, invisibleCharacters: !0, ambiguousCharacters: !0, includeComments: ro, includeStrings: !0, allowedCharacters: {}, allowedLocales: { _os: !0, _vscode: !0 } };
    super(125, "unicodeHighlight", i, { [T7]: { restricted: !0, type: ["boolean", "string"], enum: [!0, !1, ro], default: i.nonBasicASCII, description: m(0, "Controls whether all non-basic ASCII characters are highlighted. Only characters between U+0020 and U+007E, tab, line-feed and carriage-return are considered basic ASCII.") }, [M7]: { restricted: !0, type: "boolean", default: i.invisibleCharacters, description: m(0, "Controls whether characters that just reserve space or have no width at all are highlighted.") }, [R7]: { restricted: !0, type: "boolean", default: i.ambiguousCharacters, description: m(0, "Controls whether characters are highlighted that can be confused with basic ASCII characters, except those that are common in the current user locale.") }, [A7]: { restricted: !0, type: ["boolean", "string"], enum: [!0, !1, ro], default: i.includeComments, description: m(0, "Controls whether characters in comments should also be subject to Unicode highlighting.") }, [P7]: { restricted: !0, type: ["boolean", "string"], enum: [!0, !1, ro], default: i.includeStrings, description: m(0, "Controls whether characters in strings should also be subject to Unicode highlighting.") }, [kN]: { restricted: !0, type: "object", default: i.allowedCharacters, description: m(0, "Defines allowed characters that are not being highlighted."), additionalProperties: { type: "boolean" } }, [DN]: { restricted: !0, type: "object", additionalProperties: { type: "boolean" }, default: i.allowedLocales, description: m(0, "Unicode characters that are common in allowed locales are not being highlighted.") } });
  }
  applyUpdate(i, e) {
    let t = !1;
    e.allowedCharacters && i && (So(i.allowedCharacters, e.allowedCharacters) || (i = { ...i, allowedCharacters: e.allowedCharacters }, t = !0)), e.allowedLocales && i && (So(i.allowedLocales, e.allowedLocales) || (i = { ...i, allowedLocales: e.allowedLocales }, t = !0));
    const n = super.applyUpdate(i, e);
    return t ? new G_(n.newValue, !0) : n;
  }
  validate(i) {
    if (!i || typeof i != "object") return this.defaultValue;
    const e = i;
    return { nonBasicASCII: Vg(e.nonBasicASCII, ro, [!0, !1, ro]), invisibleCharacters: ve(e.invisibleCharacters, this.defaultValue.invisibleCharacters), ambiguousCharacters: ve(e.ambiguousCharacters, this.defaultValue.ambiguousCharacters), includeComments: Vg(e.includeComments, ro, [!0, !1, ro]), includeStrings: Vg(e.includeStrings, ro, [!0, !1, ro]), allowedCharacters: this.validateBooleanMap(i.allowedCharacters, this.defaultValue.allowedCharacters), allowedLocales: this.validateBooleanMap(i.allowedLocales, this.defaultValue.allowedLocales) };
  }
  validateBooleanMap(i, e) {
    if (typeof i != "object" || !i) return e;
    const t = {};
    for (const [n, s] of Object.entries(i)) s === !0 && (t[n] = !0);
    return t;
  }
}()), unusualLineTerminators: J(new hi(126, "unusualLineTerminators", "prompt", ["auto", "off", "prompt"], { enumDescriptions: [m(0, "Unusual line terminators are automatically removed."), m(0, "Unusual line terminators are ignored."), m(0, "Unusual line terminators prompt to be removed.")], description: m(0, "Remove unusual line terminators that might cause problems.") })), useShadowDOM: J(new gt(127, "useShadowDOM", !0)), useTabStops: J(new gt(128, "useTabStops", !0, { description: m(0, "Spaces and tabs are inserted and deleted in alignment with tab stops.") })), wordBreak: J(new hi(129, "wordBreak", "normal", ["normal", "keepAll"], { markdownEnumDescriptions: [m(0, "Use the default line break rule."), m(0, "Word breaks should not be used for Chinese/Japanese/Korean (CJK) text. Non-CJK text behavior is the same as for normal.")], description: m(0, "Controls the word break rules used for Chinese/Japanese/Korean (CJK) text.") })), wordSegmenterLocales: J(new class extends Qt {
  constructor() {
    super(130, "wordSegmenterLocales", [], { anyOf: [{ description: m(0, "Locales to be used for word segmentation when doing word related navigations or operations. Specify the BCP 47 language tag of the word you wish to recognize (e.g., ja, zh-CN, zh-Hant-TW, etc.)."), type: "string" }, { description: m(0, "Locales to be used for word segmentation when doing word related navigations or operations. Specify the BCP 47 language tag of the word you wish to recognize (e.g., ja, zh-CN, zh-Hant-TW, etc.)."), type: "array", items: { type: "string" } }] });
  }
  validate(i) {
    if (typeof i == "string" && (i = [i]), Array.isArray(i)) {
      const e = [];
      for (const t of i) if (typeof t == "string") try {
        Intl.Segmenter.supportedLocalesOf(t).length > 0 && e.push(t);
      } catch {
      }
      return e;
    }
    return this.defaultValue;
  }
}()), wordSeparators: J(new ss(131, "wordSeparators", x7, { description: m(0, "Characters that will be used as word separators when doing word related navigations or operations.") })), wordWrap: J(new hi(132, "wordWrap", "off", ["off", "on", "wordWrapColumn", "bounded"], { markdownEnumDescriptions: [m(0, "Lines will never wrap."), m(0, "Lines will wrap at the viewport width."), m(0, "Lines will wrap at `#editor.wordWrapColumn#`."), m(0, "Lines will wrap at the minimum of viewport and `#editor.wordWrapColumn#`.")], description: m(0, "Controls how lines should wrap.") })), wordWrapBreakAfterCharacters: J(new ss(133, "wordWrapBreakAfterCharacters", " 	})]?|/&.,;¢°′″‰℃、。｡､￠，．：；？！％・･ゝゞヽヾーァィゥェォッャュョヮヵヶぁぃぅぇぉっゃゅょゎゕゖㇰㇱㇲㇳㇴㇵㇶㇷㇸㇹㇺㇻㇼㇽㇾㇿ々〻ｧｨｩｪｫｬｭｮｯｰ”〉》」』】〕）］｝｣")), wordWrapBreakBeforeCharacters: J(new ss(134, "wordWrapBreakBeforeCharacters", "([{‘“〈《「『【〔（［｛｢£¥＄￡￥+＋")), wordWrapColumn: J(new Ot(135, "wordWrapColumn", 80, 1, 1073741824, { markdownDescription: m(0, "Controls the wrapping column of the editor when `#editor.wordWrap#` is `wordWrapColumn` or `bounded`.") })), wordWrapOverride1: J(new hi(136, "wordWrapOverride1", "inherit", ["off", "on", "inherit"])), wordWrapOverride2: J(new hi(137, "wordWrapOverride2", "inherit", ["off", "on", "inherit"])), editorClassName: J(new class extends c_ {
  constructor() {
    super(142);
  }
  compute(i, e, t) {
    const n = ["monaco-editor"];
    return e.get(39) && n.push(e.get(39)), i.extraEditorClassName && n.push(i.extraEditorClassName), e.get(74) === "default" ? n.push("mouse-default") : e.get(74) === "copy" && n.push("mouse-copy"), e.get(111) && n.push("showUnused"), e.get(140) && n.push("showDeprecated"), n.join(" ");
  }
}()), defaultColorDecorators: J(new gt(147, "defaultColorDecorators", !1, { markdownDescription: m(0, "Controls whether inline color decorations should be shown using the default document color provider") })), pixelRatio: J(new class extends c_ {
  constructor() {
    super(143);
  }
  compute(i, e, t) {
    return i.pixelRatio;
  }
}()), tabFocusMode: J(new gt(144, "tabFocusMode", !1, { markdownDescription: m(0, "Controls whether the editor receives tabs or defers them to the workbench for navigation.") })), layoutInfo: J(new Xp()), wrappingInfo: J(new class extends c_ {
  constructor() {
    super(146);
  }
  compute(i, e, t) {
    const n = e.get(145);
    return { isDominatedByLongLines: i.isDominatedByLongLines, isWordWrapMinified: n.isWordWrapMinified, isViewportWrapping: n.isViewportWrapping, wrappingColumn: n.wrappingColumn };
  }
}()), wrappingIndent: J(new class extends Qt {
  constructor() {
    super(138, "wrappingIndent", 1, { "editor.wrappingIndent": { type: "string", enum: ["none", "same", "indent", "deepIndent"], enumDescriptions: [m(0, "No indentation. Wrapped lines begin at column 1."), m(0, "Wrapped lines get the same indentation as the parent."), m(0, "Wrapped lines get +1 indentation toward the parent."), m(0, "Wrapped lines get +2 indentation toward the parent.")], description: m(0, "Controls the indentation of wrapped lines."), default: "same" } });
  }
  validate(i) {
    switch (i) {
      case "none":
        return 0;
      case "same":
        return 1;
      case "indent":
        return 2;
      case "deepIndent":
        return 3;
    }
    return 1;
  }
  compute(i, e, t) {
    return e.get(2) === 2 ? 0 : t;
  }
}()), wrappingStrategy: J(new class extends Qt {
  constructor() {
    super(139, "wrappingStrategy", "simple", { "editor.wrappingStrategy": { enumDescriptions: [m(0, "Assumes that all characters are of the same width. This is a fast algorithm that works correctly for monospace fonts and certain scripts (like Latin characters) where glyphs are of equal width."), m(0, "Delegates wrapping points computation to the browser. This is a slow algorithm, that might cause freezes for large files, but it works correctly in all cases.")], type: "string", enum: ["simple", "advanced"], default: "simple", description: m(0, "Controls the algorithm that computes wrapping points. Note that when in accessibility mode, advanced will be used for the best experience.") } });
  }
  validate(i) {
    return _i(i, "simple", ["simple", "advanced"]);
  }
  compute(i, e, t) {
    return e.get(2) === 2 ? "advanced" : t;
  }
}()) }, O7 = new class {
  constructor() {
    this.listeners = [], this.unexpectedErrorHandler = function(i) {
      setTimeout(() => {
        throw i.stack ? Pm.isErrorNoTelemetry(i) ? new Pm(i.message + `

` + i.stack) : new Error(i.message + `

` + i.stack) : i;
      }, 0);
    };
  }
  emit(i) {
    this.listeners.forEach((e) => {
      e(i);
    });
  }
  onUnexpectedError(i) {
    this.unexpectedErrorHandler(i), this.emit(i);
  }
  onUnexpectedExternalError(i) {
    this.unexpectedErrorHandler(i);
  }
}();
function We(i) {
  Sa(i) || O7.onUnexpectedError(i);
}
function Ni(i) {
  Sa(i) || O7.onUnexpectedExternalError(i);
}
function nO(i) {
  if (i instanceof Error) {
    const { name: e, message: t } = i;
    return { $isError: !0, name: e, message: t, stack: i.stacktrace || i.stack, noTelemetry: Pm.isErrorNoTelemetry(i) };
  }
  return i;
}
const Tw = "Canceled";
function Sa(i) {
  return i instanceof Vd || i instanceof Error && i.name === Tw && i.message === Tw;
}
class Vd extends Error {
  constructor() {
    super(Tw), this.name = this.message;
  }
}
function Yo(i) {
  return i ? new Error(`Illegal argument: ${i}`) : new Error("Illegal argument");
}
function YT(i) {
  return i ? new Error(`Illegal state: ${i}`) : new Error("Illegal state");
}
class sK extends Error {
  constructor(e) {
    super("NotSupported"), e && (this.message = e);
  }
}
class Pm extends Error {
  constructor(e) {
    super(e), this.name = "CodeExpectedError";
  }
  static fromError(e) {
    if (e instanceof Pm) return e;
    const t = new Pm();
    return t.message = e.message, t.stack = e.stack, t;
  }
  static isErrorNoTelemetry(e) {
    return e.name === "CodeExpectedError";
  }
}
class Kt extends Error {
  constructor(e) {
    super(e || "An unexpected bug occurred."), Object.setPrototypeOf(this, Kt.prototype);
  }
}
function mc(i, e) {
  const t = this;
  let n, s = !1;
  return function() {
    return s || (s = !0, n = i.apply(t, arguments)), n;
  };
}
function XT(i) {
  return typeof i.dispose == "function" && i.dispose.length === 0;
}
function Ht(i) {
  if (at.is(i)) {
    const e = [];
    for (const t of i) if (t) try {
      t.dispose();
    } catch (n) {
      e.push(n);
    }
    if (e.length === 1) throw e[0];
    if (e.length > 1) throw new AggregateError(e, "Encountered errors while disposing of store");
    return Array.isArray(i) ? [] : i;
  }
  if (i) return i.dispose(), i;
}
function yr(...i) {
  return ye(() => Ht(i));
}
function ye(i) {
  return { dispose: mc(() => {
    i();
  }) };
}
class G {
  constructor() {
    this._toDispose = /* @__PURE__ */ new Set(), this._isDisposed = !1;
  }
  dispose() {
    this._isDisposed || (this._isDisposed = !0, this.clear());
  }
  get isDisposed() {
    return this._isDisposed;
  }
  clear() {
    if (this._toDispose.size !== 0) try {
      Ht(this._toDispose);
    } finally {
      this._toDispose.clear();
    }
  }
  add(e) {
    if (!e) return e;
    if (e === this) throw new Error("Cannot register a disposable on itself!");
    return this._isDisposed ? G.DISABLE_DISPOSED_WARNING || console.warn(new Error("Trying to add a disposable to a DisposableStore that has already been disposed of. The added object will be leaked!").stack) : this._toDispose.add(e), e;
  }
  deleteAndLeak(e) {
    e && this._toDispose.has(e) && this._toDispose.delete(e);
  }
}
G.DISABLE_DISPOSED_WARNING = !1;
class V {
  constructor() {
    this._store = new G(), this._store;
  }
  dispose() {
    this._store.dispose();
  }
  _register(e) {
    if (e === this) throw new Error("Cannot register a disposable on itself!");
    return this._store.add(e);
  }
}
V.None = Object.freeze({ dispose() {
} });
class rn {
  constructor() {
    this._isDisposed = !1;
  }
  get value() {
    return this._isDisposed ? void 0 : this._value;
  }
  set value(e) {
    var t;
    this._isDisposed || e === this._value || ((t = this._value) === null || t === void 0 || t.dispose(), this._value = e);
  }
  clear() {
    this.value = void 0;
  }
  dispose() {
    var e;
    this._isDisposed = !0, (e = this._value) === null || e === void 0 || e.dispose(), this._value = void 0;
  }
}
class oK {
  constructor(e) {
    this._disposable = e, this._counter = 1;
  }
  acquire() {
    return this._counter++, this;
  }
  release() {
    return --this._counter == 0 && this._disposable.dispose(), this;
  }
}
class rK {
  constructor(e) {
    this.object = e;
  }
  dispose() {
  }
}
class QT {
  constructor() {
    this._store = /* @__PURE__ */ new Map(), this._isDisposed = !1;
  }
  dispose() {
    this._isDisposed = !0, this.clearAndDisposeAll();
  }
  clearAndDisposeAll() {
    if (this._store.size) try {
      Ht(this._store.values());
    } finally {
      this._store.clear();
    }
  }
  get(e) {
    return this._store.get(e);
  }
  set(e, t, n = !1) {
    var s;
    this._isDisposed && console.warn(new Error("Trying to add a disposable to a DisposableMap that has already been disposed of. The added object will be leaked!").stack), n || (s = this._store.get(e)) === null || s === void 0 || s.dispose(), this._store.set(e, t);
  }
  deleteAndDispose(e) {
    var t;
    (t = this._store.get(e)) === null || t === void 0 || t.dispose(), this._store.delete(e);
  }
  [Symbol.iterator]() {
    return this._store[Symbol.iterator]();
  }
}
const aK = globalThis.performance && typeof globalThis.performance.now == "function";
class Rn {
  static create(e) {
    return new Rn(e);
  }
  constructor(e) {
    this._now = aK && e === !1 ? Date.now : globalThis.performance.now.bind(globalThis.performance), this._startTime = this._now(), this._stopTime = -1;
  }
  stop() {
    this._stopTime = this._now();
  }
  reset() {
    this._startTime = this._now(), this._stopTime = -1;
  }
  elapsed() {
    return this._stopTime !== -1 ? this._stopTime - this._startTime : this._now() - this._startTime;
  }
}
var se;
(function(i) {
  function e(d) {
    return (h, c = null, u) => {
      let g, p = !1;
      return g = d((f) => {
        if (!p) return g ? g.dispose() : p = !0, h.call(c, f);
      }, null, u), p && g.dispose(), g;
    };
  }
  function t(d, h, c) {
    return s((u, g = null, p) => d((f) => u.call(g, h(f)), null, p), c);
  }
  function n(d, h, c) {
    return s((u, g = null, p) => d((f) => h(f) && u.call(g, f), null, p), c);
  }
  function s(d, h) {
    let c;
    const u = new F({ onWillAddFirstListener() {
      c = d(u.fire, u);
    }, onDidRemoveLastListener() {
      c == null || c.dispose();
    } });
    return h == null || h.add(u), u.event;
  }
  function o(d, h, c = 100, u = !1, g = !1, p, f) {
    let _, v, b, C, w = 0;
    const y = new F({ leakWarningThreshold: p, onWillAddFirstListener() {
      _ = d((L) => {
        w++, v = h(v, L), u && !b && (y.fire(v), v = void 0), C = () => {
          const k = v;
          v = void 0, b = void 0, (!u || w > 1) && y.fire(k), w = 0;
        }, typeof c == "number" ? (clearTimeout(b), b = setTimeout(C, c)) : b === void 0 && (b = 0, queueMicrotask(C));
      });
    }, onWillRemoveListener() {
      g && w > 0 && (C == null || C());
    }, onDidRemoveLastListener() {
      C = void 0, _.dispose();
    } });
    return f == null || f.add(y), y.event;
  }
  i.None = () => V.None, i.defer = function(d, h) {
    return o(d, () => {
    }, 0, void 0, !0, void 0, h);
  }, i.once = e, i.map = t, i.forEach = function(d, h, c) {
    return s((u, g = null, p) => d((f) => {
      h(f), u.call(g, f);
    }, null, p), c);
  }, i.filter = n, i.signal = function(d) {
    return d;
  }, i.any = function(...d) {
    return (h, c = null, u) => function(g, p) {
      return p instanceof Array ? p.push(g) : p && p.add(g), g;
    }(yr(...d.map((g) => g((p) => h.call(c, p)))), u);
  }, i.reduce = function(d, h, c, u) {
    let g = c;
    return t(d, (p) => (g = h(g, p), g), u);
  }, i.debounce = o, i.accumulate = function(d, h = 0, c) {
    return i.debounce(d, (u, g) => u ? (u.push(g), u) : [g], h, void 0, !0, void 0, c);
  }, i.latch = function(d, h = (u, g) => u === g, c) {
    let u, g = !0;
    return n(d, (p) => {
      const f = g || !h(p, u);
      return g = !1, u = p, f;
    }, c);
  }, i.split = function(d, h, c) {
    return [i.filter(d, h, c), i.filter(d, (u) => !h(u), c)];
  }, i.buffer = function(d, h = !1, c = [], u) {
    let g = c.slice(), p = d((v) => {
      g ? g.push(v) : _.fire(v);
    });
    u && u.add(p);
    const f = () => {
      g == null || g.forEach((v) => _.fire(v)), g = null;
    }, _ = new F({ onWillAddFirstListener() {
      p || (p = d((v) => _.fire(v)), u && u.add(p));
    }, onDidAddFirstListener() {
      g && (h ? setTimeout(f) : f());
    }, onDidRemoveLastListener() {
      p && p.dispose(), p = null;
    } });
    return u && u.add(_), _.event;
  }, i.chain = function(d, h) {
    return (c, u, g) => {
      const p = h(new a());
      return d(function(f) {
        const _ = p.evaluate(f);
        _ !== r && c.call(u, _);
      }, void 0, g);
    };
  };
  const r = Symbol("HaltChainable");
  class a {
    constructor() {
      this.steps = [];
    }
    map(h) {
      return this.steps.push(h), this;
    }
    forEach(h) {
      return this.steps.push((c) => (h(c), c)), this;
    }
    filter(h) {
      return this.steps.push((c) => h(c) ? c : r), this;
    }
    reduce(h, c) {
      let u = c;
      return this.steps.push((g) => (u = h(u, g), u)), this;
    }
    latch(h = (c, u) => c === u) {
      let c, u = !0;
      return this.steps.push((g) => {
        const p = u || !h(g, c);
        return u = !1, c = g, p ? g : r;
      }), this;
    }
    evaluate(h) {
      for (const c of this.steps) if ((h = c(h)) === r) break;
      return h;
    }
  }
  i.fromNodeEventEmitter = function(d, h, c = (u) => u) {
    const u = (...p) => g.fire(c(...p)), g = new F({ onWillAddFirstListener: () => d.on(h, u), onDidRemoveLastListener: () => d.removeListener(h, u) });
    return g.event;
  }, i.fromDOMEventEmitter = function(d, h, c = (u) => u) {
    const u = (...p) => g.fire(c(...p)), g = new F({ onWillAddFirstListener: () => d.addEventListener(h, u), onDidRemoveLastListener: () => d.removeEventListener(h, u) });
    return g.event;
  }, i.toPromise = function(d) {
    return new Promise((h) => e(d)(h));
  }, i.fromPromise = function(d) {
    const h = new F();
    return d.then((c) => {
      h.fire(c);
    }, () => {
      h.fire(void 0);
    }).finally(() => {
      h.dispose();
    }), h.event;
  }, i.runAndSubscribe = function(d, h, c) {
    return h(c), d((u) => h(u));
  };
  class l {
    constructor(h, c) {
      this._observable = h, this._counter = 0, this._hasChanged = !1;
      const u = { onWillAddFirstListener: () => {
        h.addObserver(this);
      }, onDidRemoveLastListener: () => {
        h.removeObserver(this);
      } };
      this.emitter = new F(u), c && c.add(this.emitter);
    }
    beginUpdate(h) {
      this._counter++;
    }
    handlePossibleChange(h) {
    }
    handleChange(h, c) {
      this._hasChanged = !0;
    }
    endUpdate(h) {
      this._counter--, this._counter === 0 && (this._observable.reportChanges(), this._hasChanged && (this._hasChanged = !1, this.emitter.fire(this._observable.get())));
    }
  }
  i.fromObservable = function(d, h) {
    return new l(d, h).emitter.event;
  }, i.fromObservableLight = function(d) {
    return (h, c, u) => {
      let g = 0, p = !1;
      const f = { beginUpdate() {
        g++;
      }, endUpdate() {
        g--, g === 0 && (d.reportChanges(), p && (p = !1, h.call(c)));
      }, handlePossibleChange() {
      }, handleChange() {
        p = !0;
      } };
      d.addObserver(f), d.reportChanges();
      const _ = { dispose() {
        d.removeObserver(f);
      } };
      return u instanceof G ? u.add(_) : Array.isArray(u) && u.push(_), _;
    };
  };
})(se || (se = {}));
class Om {
  constructor(e) {
    this.listenerCount = 0, this.invocationCount = 0, this.elapsedOverall = 0, this.durations = [], this.name = `${e}_${Om._idPool++}`, Om.all.add(this);
  }
  start(e) {
    this._stopWatch = new Rn(), this.listenerCount = e;
  }
  stop() {
    if (this._stopWatch) {
      const e = this._stopWatch.elapsed();
      this.durations.push(e), this.elapsedOverall += e, this.invocationCount += 1, this._stopWatch = void 0;
    }
  }
}
Om.all = /* @__PURE__ */ new Set(), Om._idPool = 0;
class lK {
  constructor(e, t = Math.random().toString(18).slice(2, 5)) {
    this.threshold = e, this.name = t, this._warnCountdown = 0;
  }
  dispose() {
    var e;
    (e = this._stacks) === null || e === void 0 || e.clear();
  }
  check(e, t) {
    const n = this.threshold;
    if (n <= 0 || t < n) return;
    this._stacks || (this._stacks = /* @__PURE__ */ new Map());
    const s = this._stacks.get(e.value) || 0;
    if (this._stacks.set(e.value, s + 1), this._warnCountdown -= 1, this._warnCountdown <= 0) {
      let o;
      this._warnCountdown = 0.5 * n;
      let r = 0;
      for (const [a, l] of this._stacks) (!o || r < l) && (o = a, r = l);
      console.warn(`[${this.name}] potential listener LEAK detected, having ${t} listeners already. MOST frequent listener (${r}):`), console.warn(o);
    }
    return () => {
      const o = this._stacks.get(e.value) || 0;
      this._stacks.set(e.value, o - 1);
    };
  }
}
class JT {
  static create() {
    var e;
    return new JT((e = new Error().stack) !== null && e !== void 0 ? e : "");
  }
  constructor(e) {
    this.value = e;
  }
  print() {
    console.warn(this.value.split(`
`).slice(2).join(`
`));
  }
}
class Tk {
  constructor(e) {
    this.value = e;
  }
}
let F = class {
  constructor(i) {
    var e, t, n, s, o;
    this._size = 0, this._options = i, this._leakageMon = !((e = this._options) === null || e === void 0) && e.leakWarningThreshold ? new lK((n = (t = this._options) === null || t === void 0 ? void 0 : t.leakWarningThreshold) !== null && n !== void 0 ? n : -1) : void 0, this._perfMon = !((s = this._options) === null || s === void 0) && s._profName ? new Om(this._options._profName) : void 0, this._deliveryQueue = (o = this._options) === null || o === void 0 ? void 0 : o.deliveryQueue;
  }
  dispose() {
    var i, e, t, n;
    this._disposed || (this._disposed = !0, ((i = this._deliveryQueue) === null || i === void 0 ? void 0 : i.current) === this && this._deliveryQueue.reset(), this._listeners && (this._listeners = void 0, this._size = 0), (t = (e = this._options) === null || e === void 0 ? void 0 : e.onDidRemoveLastListener) === null || t === void 0 || t.call(e), (n = this._leakageMon) === null || n === void 0 || n.dispose());
  }
  get event() {
    var i;
    return (i = this._event) !== null && i !== void 0 || (this._event = (e, t, n) => {
      var s, o, r, a, l;
      if (this._leakageMon && this._size > 3 * this._leakageMon.threshold) return console.warn(`[${this._leakageMon.name}] REFUSES to accept new listeners because it exceeded its threshold by far`), V.None;
      if (this._disposed) return V.None;
      t && (e = e.bind(t));
      const d = new Tk(e);
      let h;
      this._leakageMon && this._size >= Math.ceil(0.2 * this._leakageMon.threshold) && (d.stack = JT.create(), h = this._leakageMon.check(d.stack, this._size + 1)), this._listeners ? this._listeners instanceof Tk ? ((l = this._deliveryQueue) !== null && l !== void 0 || (this._deliveryQueue = new F7()), this._listeners = [this._listeners, d]) : this._listeners.push(d) : ((o = (s = this._options) === null || s === void 0 ? void 0 : s.onWillAddFirstListener) === null || o === void 0 || o.call(s, this), this._listeners = d, (a = (r = this._options) === null || r === void 0 ? void 0 : r.onDidAddFirstListener) === null || a === void 0 || a.call(r, this)), this._size++;
      const c = ye(() => {
        h == null || h(), this._removeListener(d);
      });
      return n instanceof G ? n.add(c) : Array.isArray(n) && n.push(c), c;
    }), this._event;
  }
  _removeListener(i) {
    var e, t, n, s;
    if ((t = (e = this._options) === null || e === void 0 ? void 0 : e.onWillRemoveListener) === null || t === void 0 || t.call(e, this), !this._listeners) return;
    if (this._size === 1) return this._listeners = void 0, (s = (n = this._options) === null || n === void 0 ? void 0 : n.onDidRemoveLastListener) === null || s === void 0 || s.call(n, this), void (this._size = 0);
    const o = this._listeners, r = o.indexOf(i);
    if (r === -1) throw console.log("disposed?", this._disposed), console.log("size?", this._size), console.log("arr?", JSON.stringify(this._listeners)), new Error("Attempted to dispose unknown listener");
    this._size--, o[r] = void 0;
    const a = this._deliveryQueue.current === this;
    if (2 * this._size <= o.length) {
      let l = 0;
      for (let d = 0; d < o.length; d++) o[d] ? o[l++] = o[d] : a && (this._deliveryQueue.end--, l < this._deliveryQueue.i && this._deliveryQueue.i--);
      o.length = l;
    }
  }
  _deliver(i, e) {
    var t;
    if (!i) return;
    const n = ((t = this._options) === null || t === void 0 ? void 0 : t.onListenerError) || We;
    if (n) try {
      i.value(e);
    } catch (s) {
      n(s);
    }
    else i.value(e);
  }
  _deliverQueue(i) {
    const e = i.current._listeners;
    for (; i.i < i.end; ) this._deliver(e[i.i++], i.value);
    i.reset();
  }
  fire(i) {
    var e, t, n, s;
    if (!((e = this._deliveryQueue) === null || e === void 0) && e.current && (this._deliverQueue(this._deliveryQueue), (t = this._perfMon) === null || t === void 0 || t.stop()), (n = this._perfMon) === null || n === void 0 || n.start(this._size), this._listeners) if (this._listeners instanceof Tk) this._deliver(this._listeners, i);
    else {
      const o = this._deliveryQueue;
      o.enqueue(this, i, this._listeners.length), this._deliverQueue(o);
    }
    (s = this._perfMon) === null || s === void 0 || s.stop();
  }
  hasListeners() {
    return this._size > 0;
  }
};
class F7 {
  constructor() {
    this.i = -1, this.end = 0;
  }
  enqueue(e, t, n) {
    this.i = 0, this.end = n, this.current = e, this.value = t;
  }
  reset() {
    this.i = this.end, this.current = void 0, this.value = void 0;
  }
}
class og extends F {
  constructor(e) {
    super(e), this._isPaused = 0, this._eventQueue = new fs(), this._mergeFn = e == null ? void 0 : e.merge;
  }
  pause() {
    this._isPaused++;
  }
  resume() {
    if (this._isPaused !== 0 && --this._isPaused == 0) if (this._mergeFn) {
      if (this._eventQueue.size > 0) {
        const e = Array.from(this._eventQueue);
        this._eventQueue.clear(), super.fire(this._mergeFn(e));
      }
    } else for (; !this._isPaused && this._eventQueue.size !== 0; ) super.fire(this._eventQueue.shift());
  }
  fire(e) {
    this._size && (this._isPaused !== 0 ? this._eventQueue.push(e) : super.fire(e));
  }
}
class B7 extends og {
  constructor(e) {
    var t;
    super(e), this._delay = (t = e.delay) !== null && t !== void 0 ? t : 100;
  }
  fire(e) {
    this._handle || (this.pause(), this._handle = setTimeout(() => {
      this._handle = void 0, this.resume();
    }, this._delay)), super.fire(e);
  }
}
class dK extends F {
  constructor(e) {
    super(e), this._queuedEvents = [], this._mergeFn = e == null ? void 0 : e.merge;
  }
  fire(e) {
    this.hasListeners() && (this._queuedEvents.push(e), this._queuedEvents.length === 1 && queueMicrotask(() => {
      this._mergeFn ? super.fire(this._mergeFn(this._queuedEvents)) : this._queuedEvents.forEach((t) => super.fire(t)), this._queuedEvents = [];
    }));
  }
}
class hK {
  constructor() {
    this.hasListeners = !1, this.events = [], this.emitter = new F({ onWillAddFirstListener: () => this.onFirstListenerAdd(), onDidRemoveLastListener: () => this.onLastListenerRemove() });
  }
  get event() {
    return this.emitter.event;
  }
  add(e) {
    const t = { event: e, listener: null };
    return this.events.push(t), this.hasListeners && this.hook(t), ye(mc(() => {
      this.hasListeners && this.unhook(t);
      const n = this.events.indexOf(t);
      this.events.splice(n, 1);
    }));
  }
  onFirstListenerAdd() {
    this.hasListeners = !0, this.events.forEach((e) => this.hook(e));
  }
  onLastListenerRemove() {
    this.hasListeners = !1, this.events.forEach((e) => this.unhook(e));
  }
  hook(e) {
    e.listener = e.event((t) => this.emitter.fire(t));
  }
  unhook(e) {
    var t;
    (t = e.listener) === null || t === void 0 || t.dispose(), e.listener = null;
  }
  dispose() {
    var e;
    this.emitter.dispose();
    for (const t of this.events) (e = t.listener) === null || e === void 0 || e.dispose();
    this.events = [];
  }
}
class eR {
  constructor() {
    this.buffers = [];
  }
  wrapEvent(e) {
    return (t, n, s) => e((o) => {
      const r = this.buffers[this.buffers.length - 1];
      r ? r.push(() => t.call(n, o)) : t.call(n, o);
    }, void 0, s);
  }
  bufferEvents(e) {
    const t = [];
    this.buffers.push(t);
    const n = e();
    return this.buffers.pop(), t.forEach((s) => s()), n;
  }
}
class sO {
  constructor() {
    this.listening = !1, this.inputEvent = se.None, this.inputEventListener = V.None, this.emitter = new F({ onDidAddFirstListener: () => {
      this.listening = !0, this.inputEventListener = this.inputEvent(this.emitter.fire, this.emitter);
    }, onDidRemoveLastListener: () => {
      this.listening = !1, this.inputEventListener.dispose();
    } }), this.event = this.emitter.event;
  }
  set input(e) {
    this.inputEvent = e, this.listening && (this.inputEventListener.dispose(), this.inputEventListener = e(this.emitter.fire, this.emitter));
  }
  dispose() {
    this.inputEventListener.dispose(), this.emitter.dispose();
  }
}
const W7 = Object.freeze(function(i, e) {
  const t = setTimeout(i.bind(e), 0);
  return { dispose() {
    clearTimeout(t);
  } };
});
var et;
(function(i) {
  i.isCancellationToken = function(e) {
    return e === i.None || e === i.Cancelled || e instanceof NC || !(!e || typeof e != "object") && typeof e.isCancellationRequested == "boolean" && typeof e.onCancellationRequested == "function";
  }, i.None = Object.freeze({ isCancellationRequested: !1, onCancellationRequested: se.None }), i.Cancelled = Object.freeze({ isCancellationRequested: !0, onCancellationRequested: W7 });
})(et || (et = {}));
class NC {
  constructor() {
    this._isCancelled = !1, this._emitter = null;
  }
  cancel() {
    this._isCancelled || (this._isCancelled = !0, this._emitter && (this._emitter.fire(void 0), this.dispose()));
  }
  get isCancellationRequested() {
    return this._isCancelled;
  }
  get onCancellationRequested() {
    return this._isCancelled ? W7 : (this._emitter || (this._emitter = new F()), this._emitter.event);
  }
  dispose() {
    this._emitter && (this._emitter.dispose(), this._emitter = null);
  }
}
let Ci = class {
  constructor(i) {
    this._token = void 0, this._parentListener = void 0, this._parentListener = i && i.onCancellationRequested(this.cancel, this);
  }
  get token() {
    return this._token || (this._token = new NC()), this._token;
  }
  cancel() {
    this._token ? this._token instanceof NC && this._token.cancel() : this._token = et.Cancelled;
  }
  dispose(i = !1) {
    var e;
    i && this.cancel(), (e = this._parentListener) === null || e === void 0 || e.dispose(), this._token ? this._token instanceof NC && this._token.dispose() : this._token = et.None;
  }
};
class tR {
  constructor() {
    this._keyCodeToStr = [], this._strToKeyCode = /* @__PURE__ */ Object.create(null);
  }
  define(e, t) {
    this._keyCodeToStr[e] = t, this._strToKeyCode[t.toLowerCase()] = e;
  }
  keyCodeToStr(e) {
    return this._keyCodeToStr[e];
  }
  strToKeyCode(e) {
    return this._strToKeyCode[e.toLowerCase()] || 0;
  }
}
const Y1 = new tR(), Rk = new tR(), Ak = new tR(), V7 = new Array(230), cK = /* @__PURE__ */ Object.create(null), uK = /* @__PURE__ */ Object.create(null), iR = [];
for (let i = 0; i <= 193; i++) iR[i] = -1;
var Yl;
function Vi(i, e) {
  return (i | (65535 & e) << 16 >>> 0) >>> 0;
}
let $0;
(function() {
  const i = "", e = [[1, 0, "None", 0, "unknown", 0, "VK_UNKNOWN", i, i], [1, 1, "Hyper", 0, i, 0, i, i, i], [1, 2, "Super", 0, i, 0, i, i, i], [1, 3, "Fn", 0, i, 0, i, i, i], [1, 4, "FnLock", 0, i, 0, i, i, i], [1, 5, "Suspend", 0, i, 0, i, i, i], [1, 6, "Resume", 0, i, 0, i, i, i], [1, 7, "Turbo", 0, i, 0, i, i, i], [1, 8, "Sleep", 0, i, 0, "VK_SLEEP", i, i], [1, 9, "WakeUp", 0, i, 0, i, i, i], [0, 10, "KeyA", 31, "A", 65, "VK_A", i, i], [0, 11, "KeyB", 32, "B", 66, "VK_B", i, i], [0, 12, "KeyC", 33, "C", 67, "VK_C", i, i], [0, 13, "KeyD", 34, "D", 68, "VK_D", i, i], [0, 14, "KeyE", 35, "E", 69, "VK_E", i, i], [0, 15, "KeyF", 36, "F", 70, "VK_F", i, i], [0, 16, "KeyG", 37, "G", 71, "VK_G", i, i], [0, 17, "KeyH", 38, "H", 72, "VK_H", i, i], [0, 18, "KeyI", 39, "I", 73, "VK_I", i, i], [0, 19, "KeyJ", 40, "J", 74, "VK_J", i, i], [0, 20, "KeyK", 41, "K", 75, "VK_K", i, i], [0, 21, "KeyL", 42, "L", 76, "VK_L", i, i], [0, 22, "KeyM", 43, "M", 77, "VK_M", i, i], [0, 23, "KeyN", 44, "N", 78, "VK_N", i, i], [0, 24, "KeyO", 45, "O", 79, "VK_O", i, i], [0, 25, "KeyP", 46, "P", 80, "VK_P", i, i], [0, 26, "KeyQ", 47, "Q", 81, "VK_Q", i, i], [0, 27, "KeyR", 48, "R", 82, "VK_R", i, i], [0, 28, "KeyS", 49, "S", 83, "VK_S", i, i], [0, 29, "KeyT", 50, "T", 84, "VK_T", i, i], [0, 30, "KeyU", 51, "U", 85, "VK_U", i, i], [0, 31, "KeyV", 52, "V", 86, "VK_V", i, i], [0, 32, "KeyW", 53, "W", 87, "VK_W", i, i], [0, 33, "KeyX", 54, "X", 88, "VK_X", i, i], [0, 34, "KeyY", 55, "Y", 89, "VK_Y", i, i], [0, 35, "KeyZ", 56, "Z", 90, "VK_Z", i, i], [0, 36, "Digit1", 22, "1", 49, "VK_1", i, i], [0, 37, "Digit2", 23, "2", 50, "VK_2", i, i], [0, 38, "Digit3", 24, "3", 51, "VK_3", i, i], [0, 39, "Digit4", 25, "4", 52, "VK_4", i, i], [0, 40, "Digit5", 26, "5", 53, "VK_5", i, i], [0, 41, "Digit6", 27, "6", 54, "VK_6", i, i], [0, 42, "Digit7", 28, "7", 55, "VK_7", i, i], [0, 43, "Digit8", 29, "8", 56, "VK_8", i, i], [0, 44, "Digit9", 30, "9", 57, "VK_9", i, i], [0, 45, "Digit0", 21, "0", 48, "VK_0", i, i], [1, 46, "Enter", 3, "Enter", 13, "VK_RETURN", i, i], [1, 47, "Escape", 9, "Escape", 27, "VK_ESCAPE", i, i], [1, 48, "Backspace", 1, "Backspace", 8, "VK_BACK", i, i], [1, 49, "Tab", 2, "Tab", 9, "VK_TAB", i, i], [1, 50, "Space", 10, "Space", 32, "VK_SPACE", i, i], [0, 51, "Minus", 88, "-", 189, "VK_OEM_MINUS", "-", "OEM_MINUS"], [0, 52, "Equal", 86, "=", 187, "VK_OEM_PLUS", "=", "OEM_PLUS"], [0, 53, "BracketLeft", 92, "[", 219, "VK_OEM_4", "[", "OEM_4"], [0, 54, "BracketRight", 94, "]", 221, "VK_OEM_6", "]", "OEM_6"], [0, 55, "Backslash", 93, "\\", 220, "VK_OEM_5", "\\", "OEM_5"], [0, 56, "IntlHash", 0, i, 0, i, i, i], [0, 57, "Semicolon", 85, ";", 186, "VK_OEM_1", ";", "OEM_1"], [0, 58, "Quote", 95, "'", 222, "VK_OEM_7", "'", "OEM_7"], [0, 59, "Backquote", 91, "`", 192, "VK_OEM_3", "`", "OEM_3"], [0, 60, "Comma", 87, ",", 188, "VK_OEM_COMMA", ",", "OEM_COMMA"], [0, 61, "Period", 89, ".", 190, "VK_OEM_PERIOD", ".", "OEM_PERIOD"], [0, 62, "Slash", 90, "/", 191, "VK_OEM_2", "/", "OEM_2"], [1, 63, "CapsLock", 8, "CapsLock", 20, "VK_CAPITAL", i, i], [1, 64, "F1", 59, "F1", 112, "VK_F1", i, i], [1, 65, "F2", 60, "F2", 113, "VK_F2", i, i], [1, 66, "F3", 61, "F3", 114, "VK_F3", i, i], [1, 67, "F4", 62, "F4", 115, "VK_F4", i, i], [1, 68, "F5", 63, "F5", 116, "VK_F5", i, i], [1, 69, "F6", 64, "F6", 117, "VK_F6", i, i], [1, 70, "F7", 65, "F7", 118, "VK_F7", i, i], [1, 71, "F8", 66, "F8", 119, "VK_F8", i, i], [1, 72, "F9", 67, "F9", 120, "VK_F9", i, i], [1, 73, "F10", 68, "F10", 121, "VK_F10", i, i], [1, 74, "F11", 69, "F11", 122, "VK_F11", i, i], [1, 75, "F12", 70, "F12", 123, "VK_F12", i, i], [1, 76, "PrintScreen", 0, i, 0, i, i, i], [1, 77, "ScrollLock", 84, "ScrollLock", 145, "VK_SCROLL", i, i], [1, 78, "Pause", 7, "PauseBreak", 19, "VK_PAUSE", i, i], [1, 79, "Insert", 19, "Insert", 45, "VK_INSERT", i, i], [1, 80, "Home", 14, "Home", 36, "VK_HOME", i, i], [1, 81, "PageUp", 11, "PageUp", 33, "VK_PRIOR", i, i], [1, 82, "Delete", 20, "Delete", 46, "VK_DELETE", i, i], [1, 83, "End", 13, "End", 35, "VK_END", i, i], [1, 84, "PageDown", 12, "PageDown", 34, "VK_NEXT", i, i], [1, 85, "ArrowRight", 17, "RightArrow", 39, "VK_RIGHT", "Right", i], [1, 86, "ArrowLeft", 15, "LeftArrow", 37, "VK_LEFT", "Left", i], [1, 87, "ArrowDown", 18, "DownArrow", 40, "VK_DOWN", "Down", i], [1, 88, "ArrowUp", 16, "UpArrow", 38, "VK_UP", "Up", i], [1, 89, "NumLock", 83, "NumLock", 144, "VK_NUMLOCK", i, i], [1, 90, "NumpadDivide", 113, "NumPad_Divide", 111, "VK_DIVIDE", i, i], [1, 91, "NumpadMultiply", 108, "NumPad_Multiply", 106, "VK_MULTIPLY", i, i], [1, 92, "NumpadSubtract", 111, "NumPad_Subtract", 109, "VK_SUBTRACT", i, i], [1, 93, "NumpadAdd", 109, "NumPad_Add", 107, "VK_ADD", i, i], [1, 94, "NumpadEnter", 3, i, 0, i, i, i], [1, 95, "Numpad1", 99, "NumPad1", 97, "VK_NUMPAD1", i, i], [1, 96, "Numpad2", 100, "NumPad2", 98, "VK_NUMPAD2", i, i], [1, 97, "Numpad3", 101, "NumPad3", 99, "VK_NUMPAD3", i, i], [1, 98, "Numpad4", 102, "NumPad4", 100, "VK_NUMPAD4", i, i], [1, 99, "Numpad5", 103, "NumPad5", 101, "VK_NUMPAD5", i, i], [1, 100, "Numpad6", 104, "NumPad6", 102, "VK_NUMPAD6", i, i], [1, 101, "Numpad7", 105, "NumPad7", 103, "VK_NUMPAD7", i, i], [1, 102, "Numpad8", 106, "NumPad8", 104, "VK_NUMPAD8", i, i], [1, 103, "Numpad9", 107, "NumPad9", 105, "VK_NUMPAD9", i, i], [1, 104, "Numpad0", 98, "NumPad0", 96, "VK_NUMPAD0", i, i], [1, 105, "NumpadDecimal", 112, "NumPad_Decimal", 110, "VK_DECIMAL", i, i], [0, 106, "IntlBackslash", 97, "OEM_102", 226, "VK_OEM_102", i, i], [1, 107, "ContextMenu", 58, "ContextMenu", 93, i, i, i], [1, 108, "Power", 0, i, 0, i, i, i], [1, 109, "NumpadEqual", 0, i, 0, i, i, i], [1, 110, "F13", 71, "F13", 124, "VK_F13", i, i], [1, 111, "F14", 72, "F14", 125, "VK_F14", i, i], [1, 112, "F15", 73, "F15", 126, "VK_F15", i, i], [1, 113, "F16", 74, "F16", 127, "VK_F16", i, i], [1, 114, "F17", 75, "F17", 128, "VK_F17", i, i], [1, 115, "F18", 76, "F18", 129, "VK_F18", i, i], [1, 116, "F19", 77, "F19", 130, "VK_F19", i, i], [1, 117, "F20", 78, "F20", 131, "VK_F20", i, i], [1, 118, "F21", 79, "F21", 132, "VK_F21", i, i], [1, 119, "F22", 80, "F22", 133, "VK_F22", i, i], [1, 120, "F23", 81, "F23", 134, "VK_F23", i, i], [1, 121, "F24", 82, "F24", 135, "VK_F24", i, i], [1, 122, "Open", 0, i, 0, i, i, i], [1, 123, "Help", 0, i, 0, i, i, i], [1, 124, "Select", 0, i, 0, i, i, i], [1, 125, "Again", 0, i, 0, i, i, i], [1, 126, "Undo", 0, i, 0, i, i, i], [1, 127, "Cut", 0, i, 0, i, i, i], [1, 128, "Copy", 0, i, 0, i, i, i], [1, 129, "Paste", 0, i, 0, i, i, i], [1, 130, "Find", 0, i, 0, i, i, i], [1, 131, "AudioVolumeMute", 117, "AudioVolumeMute", 173, "VK_VOLUME_MUTE", i, i], [1, 132, "AudioVolumeUp", 118, "AudioVolumeUp", 175, "VK_VOLUME_UP", i, i], [1, 133, "AudioVolumeDown", 119, "AudioVolumeDown", 174, "VK_VOLUME_DOWN", i, i], [1, 134, "NumpadComma", 110, "NumPad_Separator", 108, "VK_SEPARATOR", i, i], [0, 135, "IntlRo", 115, "ABNT_C1", 193, "VK_ABNT_C1", i, i], [1, 136, "KanaMode", 0, i, 0, i, i, i], [0, 137, "IntlYen", 0, i, 0, i, i, i], [1, 138, "Convert", 0, i, 0, i, i, i], [1, 139, "NonConvert", 0, i, 0, i, i, i], [1, 140, "Lang1", 0, i, 0, i, i, i], [1, 141, "Lang2", 0, i, 0, i, i, i], [1, 142, "Lang3", 0, i, 0, i, i, i], [1, 143, "Lang4", 0, i, 0, i, i, i], [1, 144, "Lang5", 0, i, 0, i, i, i], [1, 145, "Abort", 0, i, 0, i, i, i], [1, 146, "Props", 0, i, 0, i, i, i], [1, 147, "NumpadParenLeft", 0, i, 0, i, i, i], [1, 148, "NumpadParenRight", 0, i, 0, i, i, i], [1, 149, "NumpadBackspace", 0, i, 0, i, i, i], [1, 150, "NumpadMemoryStore", 0, i, 0, i, i, i], [1, 151, "NumpadMemoryRecall", 0, i, 0, i, i, i], [1, 152, "NumpadMemoryClear", 0, i, 0, i, i, i], [1, 153, "NumpadMemoryAdd", 0, i, 0, i, i, i], [1, 154, "NumpadMemorySubtract", 0, i, 0, i, i, i], [1, 155, "NumpadClear", 131, "Clear", 12, "VK_CLEAR", i, i], [1, 156, "NumpadClearEntry", 0, i, 0, i, i, i], [1, 0, i, 5, "Ctrl", 17, "VK_CONTROL", i, i], [1, 0, i, 4, "Shift", 16, "VK_SHIFT", i, i], [1, 0, i, 6, "Alt", 18, "VK_MENU", i, i], [1, 0, i, 57, "Meta", 91, "VK_COMMAND", i, i], [1, 157, "ControlLeft", 5, i, 0, "VK_LCONTROL", i, i], [1, 158, "ShiftLeft", 4, i, 0, "VK_LSHIFT", i, i], [1, 159, "AltLeft", 6, i, 0, "VK_LMENU", i, i], [1, 160, "MetaLeft", 57, i, 0, "VK_LWIN", i, i], [1, 161, "ControlRight", 5, i, 0, "VK_RCONTROL", i, i], [1, 162, "ShiftRight", 4, i, 0, "VK_RSHIFT", i, i], [1, 163, "AltRight", 6, i, 0, "VK_RMENU", i, i], [1, 164, "MetaRight", 57, i, 0, "VK_RWIN", i, i], [1, 165, "BrightnessUp", 0, i, 0, i, i, i], [1, 166, "BrightnessDown", 0, i, 0, i, i, i], [1, 167, "MediaPlay", 0, i, 0, i, i, i], [1, 168, "MediaRecord", 0, i, 0, i, i, i], [1, 169, "MediaFastForward", 0, i, 0, i, i, i], [1, 170, "MediaRewind", 0, i, 0, i, i, i], [1, 171, "MediaTrackNext", 124, "MediaTrackNext", 176, "VK_MEDIA_NEXT_TRACK", i, i], [1, 172, "MediaTrackPrevious", 125, "MediaTrackPrevious", 177, "VK_MEDIA_PREV_TRACK", i, i], [1, 173, "MediaStop", 126, "MediaStop", 178, "VK_MEDIA_STOP", i, i], [1, 174, "Eject", 0, i, 0, i, i, i], [1, 175, "MediaPlayPause", 127, "MediaPlayPause", 179, "VK_MEDIA_PLAY_PAUSE", i, i], [1, 176, "MediaSelect", 128, "LaunchMediaPlayer", 181, "VK_MEDIA_LAUNCH_MEDIA_SELECT", i, i], [1, 177, "LaunchMail", 129, "LaunchMail", 180, "VK_MEDIA_LAUNCH_MAIL", i, i], [1, 178, "LaunchApp2", 130, "LaunchApp2", 183, "VK_MEDIA_LAUNCH_APP2", i, i], [1, 179, "LaunchApp1", 0, i, 0, "VK_MEDIA_LAUNCH_APP1", i, i], [1, 180, "SelectTask", 0, i, 0, i, i, i], [1, 181, "LaunchScreenSaver", 0, i, 0, i, i, i], [1, 182, "BrowserSearch", 120, "BrowserSearch", 170, "VK_BROWSER_SEARCH", i, i], [1, 183, "BrowserHome", 121, "BrowserHome", 172, "VK_BROWSER_HOME", i, i], [1, 184, "BrowserBack", 122, "BrowserBack", 166, "VK_BROWSER_BACK", i, i], [1, 185, "BrowserForward", 123, "BrowserForward", 167, "VK_BROWSER_FORWARD", i, i], [1, 186, "BrowserStop", 0, i, 0, "VK_BROWSER_STOP", i, i], [1, 187, "BrowserRefresh", 0, i, 0, "VK_BROWSER_REFRESH", i, i], [1, 188, "BrowserFavorites", 0, i, 0, "VK_BROWSER_FAVORITES", i, i], [1, 189, "ZoomToggle", 0, i, 0, i, i, i], [1, 190, "MailReply", 0, i, 0, i, i, i], [1, 191, "MailForward", 0, i, 0, i, i, i], [1, 192, "MailSend", 0, i, 0, i, i, i], [1, 0, i, 114, "KeyInComposition", 229, i, i, i], [1, 0, i, 116, "ABNT_C2", 194, "VK_ABNT_C2", i, i], [1, 0, i, 96, "OEM_8", 223, "VK_OEM_8", i, i], [1, 0, i, 0, i, 0, "VK_KANA", i, i], [1, 0, i, 0, i, 0, "VK_HANGUL", i, i], [1, 0, i, 0, i, 0, "VK_JUNJA", i, i], [1, 0, i, 0, i, 0, "VK_FINAL", i, i], [1, 0, i, 0, i, 0, "VK_HANJA", i, i], [1, 0, i, 0, i, 0, "VK_KANJI", i, i], [1, 0, i, 0, i, 0, "VK_CONVERT", i, i], [1, 0, i, 0, i, 0, "VK_NONCONVERT", i, i], [1, 0, i, 0, i, 0, "VK_ACCEPT", i, i], [1, 0, i, 0, i, 0, "VK_MODECHANGE", i, i], [1, 0, i, 0, i, 0, "VK_SELECT", i, i], [1, 0, i, 0, i, 0, "VK_PRINT", i, i], [1, 0, i, 0, i, 0, "VK_EXECUTE", i, i], [1, 0, i, 0, i, 0, "VK_SNAPSHOT", i, i], [1, 0, i, 0, i, 0, "VK_HELP", i, i], [1, 0, i, 0, i, 0, "VK_APPS", i, i], [1, 0, i, 0, i, 0, "VK_PROCESSKEY", i, i], [1, 0, i, 0, i, 0, "VK_PACKET", i, i], [1, 0, i, 0, i, 0, "VK_DBE_SBCSCHAR", i, i], [1, 0, i, 0, i, 0, "VK_DBE_DBCSCHAR", i, i], [1, 0, i, 0, i, 0, "VK_ATTN", i, i], [1, 0, i, 0, i, 0, "VK_CRSEL", i, i], [1, 0, i, 0, i, 0, "VK_EXSEL", i, i], [1, 0, i, 0, i, 0, "VK_EREOF", i, i], [1, 0, i, 0, i, 0, "VK_PLAY", i, i], [1, 0, i, 0, i, 0, "VK_ZOOM", i, i], [1, 0, i, 0, i, 0, "VK_NONAME", i, i], [1, 0, i, 0, i, 0, "VK_PA1", i, i], [1, 0, i, 0, i, 0, "VK_OEM_CLEAR", i, i]], t = [], n = [];
  for (const s of e) {
    const [o, r, a, l, d, h, c, u, g] = s;
    if (n[r] || (n[r] = !0, cK[a] = r, uK[a.toLowerCase()] = r, o && (iR[r] = l)), !t[l]) {
      if (t[l] = !0, !d) throw new Error(`String representation missing for key code ${l} around scan code ${a}`);
      Y1.define(l, d), Rk.define(l, u || d), Ak.define(l, g || u || d);
    }
    h && (V7[h] = l);
  }
})(), function(i) {
  i.toString = function(e) {
    return Y1.keyCodeToStr(e);
  }, i.fromString = function(e) {
    return Y1.strToKeyCode(e);
  }, i.toUserSettingsUS = function(e) {
    return Rk.keyCodeToStr(e);
  }, i.toUserSettingsGeneral = function(e) {
    return Ak.keyCodeToStr(e);
  }, i.fromUserSettings = function(e) {
    return Rk.strToKeyCode(e) || Ak.strToKeyCode(e);
  }, i.toElectronAccelerator = function(e) {
    if (e >= 98 && e <= 113) return null;
    switch (e) {
      case 16:
        return "Up";
      case 18:
        return "Down";
      case 15:
        return "Left";
      case 17:
        return "Right";
    }
    return Y1.keyCodeToStr(e);
  };
}(Yl || (Yl = {}));
const Pk = globalThis.vscode;
if (Pk !== void 0 && Pk.process !== void 0) {
  const i = Pk.process;
  $0 = { get platform() {
    return i.platform;
  }, get arch() {
    return i.arch;
  }, get env() {
    return i.env;
  }, cwd: () => i.cwd() };
} else $0 = typeof process < "u" ? { get platform() {
  return process.platform;
}, get arch() {
  return process.arch;
}, get env() {
  return process.env;
}, cwd: () => process.env.VSCODE_CWD || process.cwd() } : { get platform() {
  return Tn ? "win32" : Je ? "darwin" : "linux";
}, get arch() {
}, get env() {
  return {};
}, cwd: () => "/" };
const Rw = $0.cwd, xN = $0.env, gK = $0.platform, Qh = 46, $n = 47, oo = 92, Gd = 58;
class H7 extends Error {
  constructor(e, t, n) {
    let s;
    typeof t == "string" && t.indexOf("not ") === 0 ? (s = "must not be", t = t.replace(/^not /, "")) : s = "must be";
    const o = e.indexOf(".") !== -1 ? "property" : "argument";
    let r = `The "${e}" ${o} ${s} of type ${t}`;
    r += ". Received type " + typeof n, super(r), this.code = "ERR_INVALID_ARG_TYPE";
  }
}
function cn(i, e) {
  if (typeof i != "string") throw new H7(e, "string", i);
}
const Ac = gK === "win32";
function kt(i) {
  return i === $n || i === oo;
}
function NN(i) {
  return i === $n;
}
function Zd(i) {
  return i >= 65 && i <= 90 || i >= 97 && i <= 122;
}
function Aw(i, e, t, n) {
  let s = "", o = 0, r = -1, a = 0, l = 0;
  for (let d = 0; d <= i.length; ++d) {
    if (d < i.length) l = i.charCodeAt(d);
    else {
      if (n(l)) break;
      l = $n;
    }
    if (n(l)) {
      if (!(r === d - 1 || a === 1)) if (a === 2) {
        if (s.length < 2 || o !== 2 || s.charCodeAt(s.length - 1) !== Qh || s.charCodeAt(s.length - 2) !== Qh) {
          if (s.length > 2) {
            const h = s.lastIndexOf(t);
            h === -1 ? (s = "", o = 0) : (s = s.slice(0, h), o = s.length - 1 - s.lastIndexOf(t)), r = d, a = 0;
            continue;
          }
          if (s.length !== 0) {
            s = "", o = 0, r = d, a = 0;
            continue;
          }
        }
        e && (s += s.length > 0 ? `${t}..` : "..", o = 2);
      } else s.length > 0 ? s += `${t}${i.slice(r + 1, d)}` : s = i.slice(r + 1, d), o = d - r - 1;
      r = d, a = 0;
    } else l === Qh && a !== -1 ? ++a : a = -1;
  }
  return s;
}
function z7(i, e) {
  (function(s, o) {
    if (s === null || typeof s != "object") throw new H7(o, "Object", s);
  })(e, "pathObject");
  const t = e.dir || e.root, n = e.base || `${e.name || ""}${e.ext || ""}`;
  return t ? t === e.root ? `${t}${n}` : `${t}${i}${n}` : n;
}
const Zs = { resolve(...i) {
  let e = "", t = "", n = !1;
  for (let s = i.length - 1; s >= -1; s--) {
    let o;
    if (s >= 0) {
      if (o = i[s], cn(o, "path"), o.length === 0) continue;
    } else e.length === 0 ? o = Rw() : (o = xN[`=${e}`] || Rw(), (o === void 0 || o.slice(0, 2).toLowerCase() !== e.toLowerCase() && o.charCodeAt(2) === oo) && (o = `${e}\\`));
    const r = o.length;
    let a = 0, l = "", d = !1;
    const h = o.charCodeAt(0);
    if (r === 1) kt(h) && (a = 1, d = !0);
    else if (kt(h)) if (d = !0, kt(o.charCodeAt(1))) {
      let c = 2, u = c;
      for (; c < r && !kt(o.charCodeAt(c)); ) c++;
      if (c < r && c !== u) {
        const g = o.slice(u, c);
        for (u = c; c < r && kt(o.charCodeAt(c)); ) c++;
        if (c < r && c !== u) {
          for (u = c; c < r && !kt(o.charCodeAt(c)); ) c++;
          c !== r && c === u || (l = `\\\\${g}\\${o.slice(u, c)}`, a = c);
        }
      }
    } else a = 1;
    else Zd(h) && o.charCodeAt(1) === Gd && (l = o.slice(0, 2), a = 2, r > 2 && kt(o.charCodeAt(2)) && (d = !0, a = 3));
    if (l.length > 0) if (e.length > 0) {
      if (l.toLowerCase() !== e.toLowerCase()) continue;
    } else e = l;
    if (n) {
      if (e.length > 0) break;
    } else if (t = `${o.slice(a)}\\${t}`, n = d, d && e.length > 0) break;
  }
  return t = Aw(t, !n, "\\", kt), n ? `${e}\\${t}` : `${e}${t}` || ".";
}, normalize(i) {
  cn(i, "path");
  const e = i.length;
  if (e === 0) return ".";
  let t, n = 0, s = !1;
  const o = i.charCodeAt(0);
  if (e === 1) return NN(o) ? "\\" : i;
  if (kt(o)) if (s = !0, kt(i.charCodeAt(1))) {
    let a = 2, l = a;
    for (; a < e && !kt(i.charCodeAt(a)); ) a++;
    if (a < e && a !== l) {
      const d = i.slice(l, a);
      for (l = a; a < e && kt(i.charCodeAt(a)); ) a++;
      if (a < e && a !== l) {
        for (l = a; a < e && !kt(i.charCodeAt(a)); ) a++;
        if (a === e) return `\\\\${d}\\${i.slice(l)}\\`;
        a !== l && (t = `\\\\${d}\\${i.slice(l, a)}`, n = a);
      }
    }
  } else n = 1;
  else Zd(o) && i.charCodeAt(1) === Gd && (t = i.slice(0, 2), n = 2, e > 2 && kt(i.charCodeAt(2)) && (s = !0, n = 3));
  let r = n < e ? Aw(i.slice(n), !s, "\\", kt) : "";
  return r.length !== 0 || s || (r = "."), r.length > 0 && kt(i.charCodeAt(e - 1)) && (r += "\\"), t === void 0 ? s ? `\\${r}` : r : s ? `${t}\\${r}` : `${t}${r}`;
}, isAbsolute(i) {
  cn(i, "path");
  const e = i.length;
  if (e === 0) return !1;
  const t = i.charCodeAt(0);
  return kt(t) || e > 2 && Zd(t) && i.charCodeAt(1) === Gd && kt(i.charCodeAt(2));
}, join(...i) {
  if (i.length === 0) return ".";
  let e, t;
  for (let o = 0; o < i.length; ++o) {
    const r = i[o];
    cn(r, "path"), r.length > 0 && (e === void 0 ? e = t = r : e += `\\${r}`);
  }
  if (e === void 0) return ".";
  let n = !0, s = 0;
  if (typeof t == "string" && kt(t.charCodeAt(0))) {
    ++s;
    const o = t.length;
    o > 1 && kt(t.charCodeAt(1)) && (++s, o > 2 && (kt(t.charCodeAt(2)) ? ++s : n = !1));
  }
  if (n) {
    for (; s < e.length && kt(e.charCodeAt(s)); ) s++;
    s >= 2 && (e = `\\${e.slice(s)}`);
  }
  return Zs.normalize(e);
}, relative(i, e) {
  if (cn(i, "from"), cn(e, "to"), i === e) return "";
  const t = Zs.resolve(i), n = Zs.resolve(e);
  if (t === n || (i = t.toLowerCase()) === (e = n.toLowerCase())) return "";
  let s = 0;
  for (; s < i.length && i.charCodeAt(s) === oo; ) s++;
  let o = i.length;
  for (; o - 1 > s && i.charCodeAt(o - 1) === oo; ) o--;
  const r = o - s;
  let a = 0;
  for (; a < e.length && e.charCodeAt(a) === oo; ) a++;
  let l = e.length;
  for (; l - 1 > a && e.charCodeAt(l - 1) === oo; ) l--;
  const d = l - a, h = r < d ? r : d;
  let c = -1, u = 0;
  for (; u < h; u++) {
    const p = i.charCodeAt(s + u);
    if (p !== e.charCodeAt(a + u)) break;
    p === oo && (c = u);
  }
  if (u !== h) {
    if (c === -1) return n;
  } else {
    if (d > h) {
      if (e.charCodeAt(a + u) === oo) return n.slice(a + u + 1);
      if (u === 2) return n.slice(a + u);
    }
    r > h && (i.charCodeAt(s + u) === oo ? c = u : u === 2 && (c = 3)), c === -1 && (c = 0);
  }
  let g = "";
  for (u = s + c + 1; u <= o; ++u) u !== o && i.charCodeAt(u) !== oo || (g += g.length === 0 ? ".." : "\\..");
  return a += c, g.length > 0 ? `${g}${n.slice(a, l)}` : (n.charCodeAt(a) === oo && ++a, n.slice(a, l));
}, toNamespacedPath(i) {
  if (typeof i != "string" || i.length === 0) return i;
  const e = Zs.resolve(i);
  if (e.length <= 2) return i;
  if (e.charCodeAt(0) === oo) {
    if (e.charCodeAt(1) === oo) {
      const t = e.charCodeAt(2);
      if (t !== 63 && t !== Qh) return `\\\\?\\UNC\\${e.slice(2)}`;
    }
  } else if (Zd(e.charCodeAt(0)) && e.charCodeAt(1) === Gd && e.charCodeAt(2) === oo) return `\\\\?\\${e}`;
  return i;
}, dirname(i) {
  cn(i, "path");
  const e = i.length;
  if (e === 0) return ".";
  let t = -1, n = 0;
  const s = i.charCodeAt(0);
  if (e === 1) return kt(s) ? i : ".";
  if (kt(s)) {
    if (t = n = 1, kt(i.charCodeAt(1))) {
      let a = 2, l = a;
      for (; a < e && !kt(i.charCodeAt(a)); ) a++;
      if (a < e && a !== l) {
        for (l = a; a < e && kt(i.charCodeAt(a)); ) a++;
        if (a < e && a !== l) {
          for (l = a; a < e && !kt(i.charCodeAt(a)); ) a++;
          if (a === e) return i;
          a !== l && (t = n = a + 1);
        }
      }
    }
  } else Zd(s) && i.charCodeAt(1) === Gd && (t = e > 2 && kt(i.charCodeAt(2)) ? 3 : 2, n = t);
  let o = -1, r = !0;
  for (let a = e - 1; a >= n; --a) if (kt(i.charCodeAt(a))) {
    if (!r) {
      o = a;
      break;
    }
  } else r = !1;
  if (o === -1) {
    if (t === -1) return ".";
    o = t;
  }
  return i.slice(0, o);
}, basename(i, e) {
  e !== void 0 && cn(e, "ext"), cn(i, "path");
  let t, n = 0, s = -1, o = !0;
  if (i.length >= 2 && Zd(i.charCodeAt(0)) && i.charCodeAt(1) === Gd && (n = 2), e !== void 0 && e.length > 0 && e.length <= i.length) {
    if (e === i) return "";
    let r = e.length - 1, a = -1;
    for (t = i.length - 1; t >= n; --t) {
      const l = i.charCodeAt(t);
      if (kt(l)) {
        if (!o) {
          n = t + 1;
          break;
        }
      } else a === -1 && (o = !1, a = t + 1), r >= 0 && (l === e.charCodeAt(r) ? --r == -1 && (s = t) : (r = -1, s = a));
    }
    return n === s ? s = a : s === -1 && (s = i.length), i.slice(n, s);
  }
  for (t = i.length - 1; t >= n; --t) if (kt(i.charCodeAt(t))) {
    if (!o) {
      n = t + 1;
      break;
    }
  } else s === -1 && (o = !1, s = t + 1);
  return s === -1 ? "" : i.slice(n, s);
}, extname(i) {
  cn(i, "path");
  let e = 0, t = -1, n = 0, s = -1, o = !0, r = 0;
  i.length >= 2 && i.charCodeAt(1) === Gd && Zd(i.charCodeAt(0)) && (e = n = 2);
  for (let a = i.length - 1; a >= e; --a) {
    const l = i.charCodeAt(a);
    if (kt(l)) {
      if (!o) {
        n = a + 1;
        break;
      }
    } else s === -1 && (o = !1, s = a + 1), l === Qh ? t === -1 ? t = a : r !== 1 && (r = 1) : t !== -1 && (r = -1);
  }
  return t === -1 || s === -1 || r === 0 || r === 1 && t === s - 1 && t === n + 1 ? "" : i.slice(t, s);
}, format: z7.bind(null, "\\"), parse(i) {
  cn(i, "path");
  const e = { root: "", dir: "", base: "", ext: "", name: "" };
  if (i.length === 0) return e;
  const t = i.length;
  let n = 0, s = i.charCodeAt(0);
  if (t === 1) return kt(s) ? (e.root = e.dir = i, e) : (e.base = e.name = i, e);
  if (kt(s)) {
    if (n = 1, kt(i.charCodeAt(1))) {
      let c = 2, u = c;
      for (; c < t && !kt(i.charCodeAt(c)); ) c++;
      if (c < t && c !== u) {
        for (u = c; c < t && kt(i.charCodeAt(c)); ) c++;
        if (c < t && c !== u) {
          for (u = c; c < t && !kt(i.charCodeAt(c)); ) c++;
          c === t ? n = c : c !== u && (n = c + 1);
        }
      }
    }
  } else if (Zd(s) && i.charCodeAt(1) === Gd) {
    if (t <= 2) return e.root = e.dir = i, e;
    if (n = 2, kt(i.charCodeAt(2))) {
      if (t === 3) return e.root = e.dir = i, e;
      n = 3;
    }
  }
  n > 0 && (e.root = i.slice(0, n));
  let o = -1, r = n, a = -1, l = !0, d = i.length - 1, h = 0;
  for (; d >= n; --d) if (s = i.charCodeAt(d), kt(s)) {
    if (!l) {
      r = d + 1;
      break;
    }
  } else a === -1 && (l = !1, a = d + 1), s === Qh ? o === -1 ? o = d : h !== 1 && (h = 1) : o !== -1 && (h = -1);
  return a !== -1 && (o === -1 || h === 0 || h === 1 && o === a - 1 && o === r + 1 ? e.base = e.name = i.slice(r, a) : (e.name = i.slice(r, o), e.base = i.slice(r, a), e.ext = i.slice(o, a))), e.dir = r > 0 && r !== n ? i.slice(0, r - 1) : e.root, e;
}, sep: "\\", delimiter: ";", win32: null, posix: null }, pK = (() => {
  if (Ac) {
    const i = /\\/g;
    return () => {
      const e = Rw().replace(i, "/");
      return e.slice(e.indexOf("/"));
    };
  }
  return () => Rw();
})(), Fi = { resolve(...i) {
  let e = "", t = !1;
  for (let n = i.length - 1; n >= -1 && !t; n--) {
    const s = n >= 0 ? i[n] : pK();
    cn(s, "path"), s.length !== 0 && (e = `${s}/${e}`, t = s.charCodeAt(0) === $n);
  }
  return e = Aw(e, !t, "/", NN), t ? `/${e}` : e.length > 0 ? e : ".";
}, normalize(i) {
  if (cn(i, "path"), i.length === 0) return ".";
  const e = i.charCodeAt(0) === $n, t = i.charCodeAt(i.length - 1) === $n;
  return (i = Aw(i, !e, "/", NN)).length === 0 ? e ? "/" : t ? "./" : "." : (t && (i += "/"), e ? `/${i}` : i);
}, isAbsolute: (i) => (cn(i, "path"), i.length > 0 && i.charCodeAt(0) === $n), join(...i) {
  if (i.length === 0) return ".";
  let e;
  for (let t = 0; t < i.length; ++t) {
    const n = i[t];
    cn(n, "path"), n.length > 0 && (e === void 0 ? e = n : e += `/${n}`);
  }
  return e === void 0 ? "." : Fi.normalize(e);
}, relative(i, e) {
  if (cn(i, "from"), cn(e, "to"), i === e || (i = Fi.resolve(i)) === (e = Fi.resolve(e))) return "";
  const t = i.length, n = t - 1, s = e.length - 1, o = n < s ? n : s;
  let r = -1, a = 0;
  for (; a < o; a++) {
    const d = i.charCodeAt(1 + a);
    if (d !== e.charCodeAt(1 + a)) break;
    d === $n && (r = a);
  }
  if (a === o) if (s > o) {
    if (e.charCodeAt(1 + a) === $n) return e.slice(1 + a + 1);
    if (a === 0) return e.slice(1 + a);
  } else n > o && (i.charCodeAt(1 + a) === $n ? r = a : a === 0 && (r = 0));
  let l = "";
  for (a = 1 + r + 1; a <= t; ++a) a !== t && i.charCodeAt(a) !== $n || (l += l.length === 0 ? ".." : "/..");
  return `${l}${e.slice(1 + r)}`;
}, toNamespacedPath: (i) => i, dirname(i) {
  if (cn(i, "path"), i.length === 0) return ".";
  const e = i.charCodeAt(0) === $n;
  let t = -1, n = !0;
  for (let s = i.length - 1; s >= 1; --s) if (i.charCodeAt(s) === $n) {
    if (!n) {
      t = s;
      break;
    }
  } else n = !1;
  return t === -1 ? e ? "/" : "." : e && t === 1 ? "//" : i.slice(0, t);
}, basename(i, e) {
  e !== void 0 && cn(e, "ext"), cn(i, "path");
  let t, n = 0, s = -1, o = !0;
  if (e !== void 0 && e.length > 0 && e.length <= i.length) {
    if (e === i) return "";
    let r = e.length - 1, a = -1;
    for (t = i.length - 1; t >= 0; --t) {
      const l = i.charCodeAt(t);
      if (l === $n) {
        if (!o) {
          n = t + 1;
          break;
        }
      } else a === -1 && (o = !1, a = t + 1), r >= 0 && (l === e.charCodeAt(r) ? --r == -1 && (s = t) : (r = -1, s = a));
    }
    return n === s ? s = a : s === -1 && (s = i.length), i.slice(n, s);
  }
  for (t = i.length - 1; t >= 0; --t) if (i.charCodeAt(t) === $n) {
    if (!o) {
      n = t + 1;
      break;
    }
  } else s === -1 && (o = !1, s = t + 1);
  return s === -1 ? "" : i.slice(n, s);
}, extname(i) {
  cn(i, "path");
  let e = -1, t = 0, n = -1, s = !0, o = 0;
  for (let r = i.length - 1; r >= 0; --r) {
    const a = i.charCodeAt(r);
    if (a !== $n) n === -1 && (s = !1, n = r + 1), a === Qh ? e === -1 ? e = r : o !== 1 && (o = 1) : e !== -1 && (o = -1);
    else if (!s) {
      t = r + 1;
      break;
    }
  }
  return e === -1 || n === -1 || o === 0 || o === 1 && e === n - 1 && e === t + 1 ? "" : i.slice(e, n);
}, format: z7.bind(null, "/"), parse(i) {
  cn(i, "path");
  const e = { root: "", dir: "", base: "", ext: "", name: "" };
  if (i.length === 0) return e;
  const t = i.charCodeAt(0) === $n;
  let n;
  t ? (e.root = "/", n = 1) : n = 0;
  let s = -1, o = 0, r = -1, a = !0, l = i.length - 1, d = 0;
  for (; l >= n; --l) {
    const h = i.charCodeAt(l);
    if (h !== $n) r === -1 && (a = !1, r = l + 1), h === Qh ? s === -1 ? s = l : d !== 1 && (d = 1) : s !== -1 && (d = -1);
    else if (!a) {
      o = l + 1;
      break;
    }
  }
  if (r !== -1) {
    const h = o === 0 && t ? 1 : o;
    s === -1 || d === 0 || d === 1 && s === r - 1 && s === o + 1 ? e.base = e.name = i.slice(h, r) : (e.name = i.slice(h, s), e.base = i.slice(h, r), e.ext = i.slice(s, r));
  }
  return o > 0 ? e.dir = i.slice(0, o - 1) : t && (e.dir = "/"), e;
}, sep: "/", delimiter: ":", win32: null, posix: null };
Fi.win32 = Zs.win32 = Zs, Fi.posix = Zs.posix = Fi;
const U7 = Ac ? Zs.normalize : Fi.normalize, mK = Ac ? Zs.resolve : Fi.resolve, fK = Ac ? Zs.relative : Fi.relative, K7 = Ac ? Zs.dirname : Fi.dirname, Nh = Ac ? Zs.basename : Fi.basename, _K = Ac ? Zs.extname : Fi.extname, oa = Ac ? Zs.sep : Fi.sep, vK = /^\w[\w\d+.-]*$/, bK = /^\//, CK = /^\/\//, Ii = "", Br = "/", wK = /^(([^:/?#]+?):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/;
let Ie = class EC {
  static isUri(e) {
    return e instanceof EC || !!e && typeof e.authority == "string" && typeof e.fragment == "string" && typeof e.path == "string" && typeof e.query == "string" && typeof e.scheme == "string" && typeof e.fsPath == "string" && typeof e.with == "function" && typeof e.toString == "function";
  }
  constructor(e, t, n, s, o, r = !1) {
    typeof e == "object" ? (this.scheme = e.scheme || Ii, this.authority = e.authority || Ii, this.path = e.path || Ii, this.query = e.query || Ii, this.fragment = e.fragment || Ii) : (this.scheme = /* @__PURE__ */ function(a, l) {
      return a || l ? a : "file";
    }(e, r), this.authority = t || Ii, this.path = function(a, l) {
      switch (a) {
        case "https":
        case "http":
        case "file":
          l ? l[0] !== Br && (l = Br + l) : l = Br;
      }
      return l;
    }(this.scheme, n || Ii), this.query = s || Ii, this.fragment = o || Ii, function(a, l) {
      if (!a.scheme && l) throw new Error(`[UriError]: Scheme is missing: {scheme: "", authority: "${a.authority}", path: "${a.path}", query: "${a.query}", fragment: "${a.fragment}"}`);
      if (a.scheme && !vK.test(a.scheme)) throw new Error("[UriError]: Scheme contains illegal characters.");
      if (a.path) {
        if (a.authority) {
          if (!bK.test(a.path)) throw new Error('[UriError]: If a URI contains an authority component, then the path component must either be empty or begin with a slash ("/") character');
        } else if (CK.test(a.path)) throw new Error('[UriError]: If a URI does not contain an authority component, then the path cannot begin with two slash characters ("//")');
      }
    }(this, r));
  }
  get fsPath() {
    return Pw(this, !1);
  }
  with(e) {
    if (!e) return this;
    let { scheme: t, authority: n, path: s, query: o, fragment: r } = e;
    return t === void 0 ? t = this.scheme : t === null && (t = Ii), n === void 0 ? n = this.authority : n === null && (n = Ii), s === void 0 ? s = this.path : s === null && (s = Ii), o === void 0 ? o = this.query : o === null && (o = Ii), r === void 0 ? r = this.fragment : r === null && (r = Ii), t === this.scheme && n === this.authority && s === this.path && o === this.query && r === this.fragment ? this : new Hg(t, n, s, o, r);
  }
  static parse(e, t = !1) {
    const n = wK.exec(e);
    return n ? new Hg(n[2] || Ii, X1(n[4] || Ii), X1(n[5] || Ii), X1(n[7] || Ii), X1(n[9] || Ii), t) : new Hg(Ii, Ii, Ii, Ii, Ii);
  }
  static file(e) {
    let t = Ii;
    if (Tn && (e = e.replace(/\\/g, Br)), e[0] === Br && e[1] === Br) {
      const n = e.indexOf(Br, 2);
      n === -1 ? (t = e.substring(2), e = Br) : (t = e.substring(2, n), e = e.substring(n) || Br);
    }
    return new Hg("file", t, e, Ii, Ii);
  }
  static from(e, t) {
    return new Hg(e.scheme, e.authority, e.path, e.query, e.fragment, t);
  }
  static joinPath(e, ...t) {
    if (!e.path) throw new Error("[UriError]: cannot call joinPath on URI without path");
    let n;
    return n = Tn && e.scheme === "file" ? EC.file(Zs.join(Pw(e, !0), ...t)).path : Fi.join(e.path, ...t), e.with({ path: n });
  }
  toString(e = !1) {
    return EN(this, e);
  }
  toJSON() {
    return this;
  }
  static revive(e) {
    var t, n;
    if (e) {
      if (e instanceof EC) return e;
      {
        const s = new Hg(e);
        return s._formatted = (t = e.external) !== null && t !== void 0 ? t : null, s._fsPath = e._sep === j7 && (n = e.fsPath) !== null && n !== void 0 ? n : null, s;
      }
    }
    return e;
  }
};
const j7 = Tn ? 1 : void 0;
let Hg = class extends Ie {
  constructor() {
    super(...arguments), this._formatted = null, this._fsPath = null;
  }
  get fsPath() {
    return this._fsPath || (this._fsPath = Pw(this, !1)), this._fsPath;
  }
  toString(i = !1) {
    return i ? EN(this, !0) : (this._formatted || (this._formatted = EN(this, !1)), this._formatted);
  }
  toJSON() {
    const i = { $mid: 1 };
    return this._fsPath && (i.fsPath = this._fsPath, i._sep = j7), this._formatted && (i.external = this._formatted), this.path && (i.path = this.path), this.scheme && (i.scheme = this.scheme), this.authority && (i.authority = this.authority), this.query && (i.query = this.query), this.fragment && (i.fragment = this.fragment), i;
  }
};
const q7 = { 58: "%3A", 47: "%2F", 63: "%3F", 35: "%23", 91: "%5B", 93: "%5D", 64: "%40", 33: "%21", 36: "%24", 38: "%26", 39: "%27", 40: "%28", 41: "%29", 42: "%2A", 43: "%2B", 44: "%2C", 59: "%3B", 61: "%3D", 32: "%20" };
function oO(i, e, t) {
  let n, s = -1;
  for (let o = 0; o < i.length; o++) {
    const r = i.charCodeAt(o);
    if (r >= 97 && r <= 122 || r >= 65 && r <= 90 || r >= 48 && r <= 57 || r === 45 || r === 46 || r === 95 || r === 126 || e && r === 47 || t && r === 91 || t && r === 93 || t && r === 58) s !== -1 && (n += encodeURIComponent(i.substring(s, o)), s = -1), n !== void 0 && (n += i.charAt(o));
    else {
      n === void 0 && (n = i.substr(0, o));
      const a = q7[r];
      a !== void 0 ? (s !== -1 && (n += encodeURIComponent(i.substring(s, o)), s = -1), n += a) : s === -1 && (s = o);
    }
  }
  return s !== -1 && (n += encodeURIComponent(i.substring(s))), n !== void 0 ? n : i;
}
function yK(i) {
  let e;
  for (let t = 0; t < i.length; t++) {
    const n = i.charCodeAt(t);
    n === 35 || n === 63 ? (e === void 0 && (e = i.substr(0, t)), e += q7[n]) : e !== void 0 && (e += i[t]);
  }
  return e !== void 0 ? e : i;
}
function Pw(i, e) {
  let t;
  return t = i.authority && i.path.length > 1 && i.scheme === "file" ? `//${i.authority}${i.path}` : i.path.charCodeAt(0) === 47 && (i.path.charCodeAt(1) >= 65 && i.path.charCodeAt(1) <= 90 || i.path.charCodeAt(1) >= 97 && i.path.charCodeAt(1) <= 122) && i.path.charCodeAt(2) === 58 ? e ? i.path.substr(1) : i.path[1].toLowerCase() + i.path.substr(2) : i.path, Tn && (t = t.replace(/\//g, "\\")), t;
}
function EN(i, e) {
  const t = e ? yK : oO;
  let n = "", { scheme: s, authority: o, path: r, query: a, fragment: l } = i;
  if (s && (n += s, n += ":"), (o || s === "file") && (n += Br, n += Br), o) {
    let d = o.indexOf("@");
    if (d !== -1) {
      const h = o.substr(0, d);
      o = o.substr(d + 1), d = h.lastIndexOf(":"), d === -1 ? n += t(h, !1, !1) : (n += t(h.substr(0, d), !1, !1), n += ":", n += t(h.substr(d + 1), !1, !0)), n += "@";
    }
    o = o.toLowerCase(), d = o.lastIndexOf(":"), d === -1 ? n += t(o, !1, !0) : (n += t(o.substr(0, d), !1, !0), n += o.substr(d));
  }
  if (r) {
    if (r.length >= 3 && r.charCodeAt(0) === 47 && r.charCodeAt(2) === 58) {
      const d = r.charCodeAt(1);
      d >= 65 && d <= 90 && (r = `/${String.fromCharCode(d + 32)}:${r.substr(3)}`);
    } else if (r.length >= 2 && r.charCodeAt(1) === 58) {
      const d = r.charCodeAt(0);
      d >= 65 && d <= 90 && (r = `${String.fromCharCode(d + 32)}:${r.substr(2)}`);
    }
    n += t(r, !0, !1);
  }
  return a && (n += "?", n += t(a, !1, !1)), l && (n += "#", n += e ? l : oO(l, !1, !1)), n;
}
function $7(i) {
  try {
    return decodeURIComponent(i);
  } catch {
    return i.length > 3 ? i.substr(0, 3) + $7(i.substr(3)) : i;
  }
}
const rO = /(%[0-9A-Za-z][0-9A-Za-z])+/g;
function X1(i) {
  return i.match(rO) ? i.replace(rO, (e) => $7(e)) : i;
}
let W = class su {
  constructor(e, t) {
    this.lineNumber = e, this.column = t;
  }
  with(e = this.lineNumber, t = this.column) {
    return e === this.lineNumber && t === this.column ? this : new su(e, t);
  }
  delta(e = 0, t = 0) {
    return this.with(this.lineNumber + e, this.column + t);
  }
  equals(e) {
    return su.equals(this, e);
  }
  static equals(e, t) {
    return !e && !t || !!e && !!t && e.lineNumber === t.lineNumber && e.column === t.column;
  }
  isBefore(e) {
    return su.isBefore(this, e);
  }
  static isBefore(e, t) {
    return e.lineNumber < t.lineNumber || !(t.lineNumber < e.lineNumber) && e.column < t.column;
  }
  isBeforeOrEqual(e) {
    return su.isBeforeOrEqual(this, e);
  }
  static isBeforeOrEqual(e, t) {
    return e.lineNumber < t.lineNumber || !(t.lineNumber < e.lineNumber) && e.column <= t.column;
  }
  static compare(e, t) {
    const n = 0 | e.lineNumber, s = 0 | t.lineNumber;
    return n === s ? (0 | e.column) - (0 | t.column) : n - s;
  }
  clone() {
    return new su(this.lineNumber, this.column);
  }
  toString() {
    return "(" + this.lineNumber + "," + this.column + ")";
  }
  static lift(e) {
    return new su(e.lineNumber, e.column);
  }
  static isIPosition(e) {
    return e && typeof e.lineNumber == "number" && typeof e.column == "number";
  }
  toJSON() {
    return { lineNumber: this.lineNumber, column: this.column };
  }
}, D = class pn {
  constructor(e, t, n, s) {
    e > n || e === n && t > s ? (this.startLineNumber = n, this.startColumn = s, this.endLineNumber = e, this.endColumn = t) : (this.startLineNumber = e, this.startColumn = t, this.endLineNumber = n, this.endColumn = s);
  }
  isEmpty() {
    return pn.isEmpty(this);
  }
  static isEmpty(e) {
    return e.startLineNumber === e.endLineNumber && e.startColumn === e.endColumn;
  }
  containsPosition(e) {
    return pn.containsPosition(this, e);
  }
  static containsPosition(e, t) {
    return !(t.lineNumber < e.startLineNumber || t.lineNumber > e.endLineNumber) && !(t.lineNumber === e.startLineNumber && t.column < e.startColumn) && !(t.lineNumber === e.endLineNumber && t.column > e.endColumn);
  }
  static strictContainsPosition(e, t) {
    return !(t.lineNumber < e.startLineNumber || t.lineNumber > e.endLineNumber) && !(t.lineNumber === e.startLineNumber && t.column <= e.startColumn) && !(t.lineNumber === e.endLineNumber && t.column >= e.endColumn);
  }
  containsRange(e) {
    return pn.containsRange(this, e);
  }
  static containsRange(e, t) {
    return !(t.startLineNumber < e.startLineNumber || t.endLineNumber < e.startLineNumber) && !(t.startLineNumber > e.endLineNumber || t.endLineNumber > e.endLineNumber) && !(t.startLineNumber === e.startLineNumber && t.startColumn < e.startColumn) && !(t.endLineNumber === e.endLineNumber && t.endColumn > e.endColumn);
  }
  strictContainsRange(e) {
    return pn.strictContainsRange(this, e);
  }
  static strictContainsRange(e, t) {
    return !(t.startLineNumber < e.startLineNumber || t.endLineNumber < e.startLineNumber) && !(t.startLineNumber > e.endLineNumber || t.endLineNumber > e.endLineNumber) && !(t.startLineNumber === e.startLineNumber && t.startColumn <= e.startColumn) && !(t.endLineNumber === e.endLineNumber && t.endColumn >= e.endColumn);
  }
  plusRange(e) {
    return pn.plusRange(this, e);
  }
  static plusRange(e, t) {
    let n, s, o, r;
    return t.startLineNumber < e.startLineNumber ? (n = t.startLineNumber, s = t.startColumn) : t.startLineNumber === e.startLineNumber ? (n = t.startLineNumber, s = Math.min(t.startColumn, e.startColumn)) : (n = e.startLineNumber, s = e.startColumn), t.endLineNumber > e.endLineNumber ? (o = t.endLineNumber, r = t.endColumn) : t.endLineNumber === e.endLineNumber ? (o = t.endLineNumber, r = Math.max(t.endColumn, e.endColumn)) : (o = e.endLineNumber, r = e.endColumn), new pn(n, s, o, r);
  }
  intersectRanges(e) {
    return pn.intersectRanges(this, e);
  }
  static intersectRanges(e, t) {
    let n = e.startLineNumber, s = e.startColumn, o = e.endLineNumber, r = e.endColumn;
    const a = t.startLineNumber, l = t.startColumn, d = t.endLineNumber, h = t.endColumn;
    return n < a ? (n = a, s = l) : n === a && (s = Math.max(s, l)), o > d ? (o = d, r = h) : o === d && (r = Math.min(r, h)), n > o || n === o && s > r ? null : new pn(n, s, o, r);
  }
  equalsRange(e) {
    return pn.equalsRange(this, e);
  }
  static equalsRange(e, t) {
    return !e && !t || !!e && !!t && e.startLineNumber === t.startLineNumber && e.startColumn === t.startColumn && e.endLineNumber === t.endLineNumber && e.endColumn === t.endColumn;
  }
  getEndPosition() {
    return pn.getEndPosition(this);
  }
  static getEndPosition(e) {
    return new W(e.endLineNumber, e.endColumn);
  }
  getStartPosition() {
    return pn.getStartPosition(this);
  }
  static getStartPosition(e) {
    return new W(e.startLineNumber, e.startColumn);
  }
  toString() {
    return "[" + this.startLineNumber + "," + this.startColumn + " -> " + this.endLineNumber + "," + this.endColumn + "]";
  }
  setEndPosition(e, t) {
    return new pn(this.startLineNumber, this.startColumn, e, t);
  }
  setStartPosition(e, t) {
    return new pn(e, t, this.endLineNumber, this.endColumn);
  }
  collapseToStart() {
    return pn.collapseToStart(this);
  }
  static collapseToStart(e) {
    return new pn(e.startLineNumber, e.startColumn, e.startLineNumber, e.startColumn);
  }
  collapseToEnd() {
    return pn.collapseToEnd(this);
  }
  static collapseToEnd(e) {
    return new pn(e.endLineNumber, e.endColumn, e.endLineNumber, e.endColumn);
  }
  delta(e) {
    return new pn(this.startLineNumber + e, this.startColumn, this.endLineNumber + e, this.endColumn);
  }
  static fromPositions(e, t = e) {
    return new pn(e.lineNumber, e.column, t.lineNumber, t.column);
  }
  static lift(e) {
    return e ? new pn(e.startLineNumber, e.startColumn, e.endLineNumber, e.endColumn) : null;
  }
  static isIRange(e) {
    return e && typeof e.startLineNumber == "number" && typeof e.startColumn == "number" && typeof e.endLineNumber == "number" && typeof e.endColumn == "number";
  }
  static areIntersectingOrTouching(e, t) {
    return !(e.endLineNumber < t.startLineNumber || e.endLineNumber === t.startLineNumber && e.endColumn < t.startColumn) && !(t.endLineNumber < e.startLineNumber || t.endLineNumber === e.startLineNumber && t.endColumn < e.startColumn);
  }
  static areIntersecting(e, t) {
    return !(e.endLineNumber < t.startLineNumber || e.endLineNumber === t.startLineNumber && e.endColumn <= t.startColumn) && !(t.endLineNumber < e.startLineNumber || t.endLineNumber === e.startLineNumber && t.endColumn <= e.startColumn);
  }
  static compareRangesUsingStarts(e, t) {
    if (e && t) {
      const n = 0 | e.startLineNumber, s = 0 | t.startLineNumber;
      if (n === s) {
        const o = 0 | e.startColumn, r = 0 | t.startColumn;
        if (o === r) {
          const a = 0 | e.endLineNumber, l = 0 | t.endLineNumber;
          return a === l ? (0 | e.endColumn) - (0 | t.endColumn) : a - l;
        }
        return o - r;
      }
      return n - s;
    }
    return (e ? 1 : 0) - (t ? 1 : 0);
  }
  static compareRangesUsingEnds(e, t) {
    return e.endLineNumber === t.endLineNumber ? e.endColumn === t.endColumn ? e.startLineNumber === t.startLineNumber ? e.startColumn - t.startColumn : e.startLineNumber - t.startLineNumber : e.endColumn - t.endColumn : e.endLineNumber - t.endLineNumber;
  }
  static spansMultipleLines(e) {
    return e.endLineNumber > e.startLineNumber;
  }
  toJSON() {
    return this;
  }
}, _e = class dr extends D {
  constructor(e, t, n, s) {
    super(e, t, n, s), this.selectionStartLineNumber = e, this.selectionStartColumn = t, this.positionLineNumber = n, this.positionColumn = s;
  }
  toString() {
    return "[" + this.selectionStartLineNumber + "," + this.selectionStartColumn + " -> " + this.positionLineNumber + "," + this.positionColumn + "]";
  }
  equalsSelection(e) {
    return dr.selectionsEqual(this, e);
  }
  static selectionsEqual(e, t) {
    return e.selectionStartLineNumber === t.selectionStartLineNumber && e.selectionStartColumn === t.selectionStartColumn && e.positionLineNumber === t.positionLineNumber && e.positionColumn === t.positionColumn;
  }
  getDirection() {
    return this.selectionStartLineNumber === this.startLineNumber && this.selectionStartColumn === this.startColumn ? 0 : 1;
  }
  setEndPosition(e, t) {
    return this.getDirection() === 0 ? new dr(this.startLineNumber, this.startColumn, e, t) : new dr(e, t, this.startLineNumber, this.startColumn);
  }
  getPosition() {
    return new W(this.positionLineNumber, this.positionColumn);
  }
  getSelectionStart() {
    return new W(this.selectionStartLineNumber, this.selectionStartColumn);
  }
  setStartPosition(e, t) {
    return this.getDirection() === 0 ? new dr(e, t, this.endLineNumber, this.endColumn) : new dr(this.endLineNumber, this.endColumn, e, t);
  }
  static fromPositions(e, t = e) {
    return new dr(e.lineNumber, e.column, t.lineNumber, t.column);
  }
  static fromRange(e, t) {
    return t === 0 ? new dr(e.startLineNumber, e.startColumn, e.endLineNumber, e.endColumn) : new dr(e.endLineNumber, e.endColumn, e.startLineNumber, e.startColumn);
  }
  static liftSelection(e) {
    return new dr(e.selectionStartLineNumber, e.selectionStartColumn, e.positionLineNumber, e.positionColumn);
  }
  static selectionsArrEqual(e, t) {
    if (e && !t || !e && t) return !1;
    if (!e && !t) return !0;
    if (e.length !== t.length) return !1;
    for (let n = 0, s = e.length; n < s; n++) if (!this.selectionsEqual(e[n], t[n])) return !1;
    return !0;
  }
  static isISelection(e) {
    return e && typeof e.selectionStartLineNumber == "number" && typeof e.selectionStartColumn == "number" && typeof e.positionLineNumber == "number" && typeof e.positionColumn == "number";
  }
  static createWithDirection(e, t, n, s, o) {
    return o === 0 ? new dr(e, t, n, s) : new dr(n, s, e, t);
  }
};
const IN = /* @__PURE__ */ Object.create(null);
function S(i, e) {
  if (ps(e)) {
    const t = IN[e];
    if (t === void 0) throw new Error(`${i} references an unknown codicon: ${e}`);
    e = t;
  }
  return IN[i] = e, { id: i };
}
function G7() {
  return IN;
}
const ne = { add: S("add", 6e4), plus: S("plus", 6e4), gistNew: S("gist-new", 6e4), repoCreate: S("repo-create", 6e4), lightbulb: S("lightbulb", 60001), lightBulb: S("light-bulb", 60001), repo: S("repo", 60002), repoDelete: S("repo-delete", 60002), gistFork: S("gist-fork", 60003), repoForked: S("repo-forked", 60003), gitPullRequest: S("git-pull-request", 60004), gitPullRequestAbandoned: S("git-pull-request-abandoned", 60004), recordKeys: S("record-keys", 60005), keyboard: S("keyboard", 60005), tag: S("tag", 60006), gitPullRequestLabel: S("git-pull-request-label", 60006), tagAdd: S("tag-add", 60006), tagRemove: S("tag-remove", 60006), person: S("person", 60007), personFollow: S("person-follow", 60007), personOutline: S("person-outline", 60007), personFilled: S("person-filled", 60007), gitBranch: S("git-branch", 60008), gitBranchCreate: S("git-branch-create", 60008), gitBranchDelete: S("git-branch-delete", 60008), sourceControl: S("source-control", 60008), mirror: S("mirror", 60009), mirrorPublic: S("mirror-public", 60009), star: S("star", 60010), starAdd: S("star-add", 60010), starDelete: S("star-delete", 60010), starEmpty: S("star-empty", 60010), comment: S("comment", 60011), commentAdd: S("comment-add", 60011), alert: S("alert", 60012), warning: S("warning", 60012), search: S("search", 60013), searchSave: S("search-save", 60013), logOut: S("log-out", 60014), signOut: S("sign-out", 60014), logIn: S("log-in", 60015), signIn: S("sign-in", 60015), eye: S("eye", 60016), eyeUnwatch: S("eye-unwatch", 60016), eyeWatch: S("eye-watch", 60016), circleFilled: S("circle-filled", 60017), primitiveDot: S("primitive-dot", 60017), closeDirty: S("close-dirty", 60017), debugBreakpoint: S("debug-breakpoint", 60017), debugBreakpointDisabled: S("debug-breakpoint-disabled", 60017), debugHint: S("debug-hint", 60017), terminalDecorationSuccess: S("terminal-decoration-success", 60017), primitiveSquare: S("primitive-square", 60018), edit: S("edit", 60019), pencil: S("pencil", 60019), info: S("info", 60020), issueOpened: S("issue-opened", 60020), gistPrivate: S("gist-private", 60021), gitForkPrivate: S("git-fork-private", 60021), lock: S("lock", 60021), mirrorPrivate: S("mirror-private", 60021), close: S("close", 60022), removeClose: S("remove-close", 60022), x: S("x", 60022), repoSync: S("repo-sync", 60023), sync: S("sync", 60023), clone: S("clone", 60024), desktopDownload: S("desktop-download", 60024), beaker: S("beaker", 60025), microscope: S("microscope", 60025), vm: S("vm", 60026), deviceDesktop: S("device-desktop", 60026), file: S("file", 60027), fileText: S("file-text", 60027), more: S("more", 60028), ellipsis: S("ellipsis", 60028), kebabHorizontal: S("kebab-horizontal", 60028), mailReply: S("mail-reply", 60029), reply: S("reply", 60029), organization: S("organization", 60030), organizationFilled: S("organization-filled", 60030), organizationOutline: S("organization-outline", 60030), newFile: S("new-file", 60031), fileAdd: S("file-add", 60031), newFolder: S("new-folder", 60032), fileDirectoryCreate: S("file-directory-create", 60032), trash: S("trash", 60033), trashcan: S("trashcan", 60033), history: S("history", 60034), clock: S("clock", 60034), folder: S("folder", 60035), fileDirectory: S("file-directory", 60035), symbolFolder: S("symbol-folder", 60035), logoGithub: S("logo-github", 60036), markGithub: S("mark-github", 60036), github: S("github", 60036), terminal: S("terminal", 60037), console: S("console", 60037), repl: S("repl", 60037), zap: S("zap", 60038), symbolEvent: S("symbol-event", 60038), error: S("error", 60039), stop: S("stop", 60039), variable: S("variable", 60040), symbolVariable: S("symbol-variable", 60040), array: S("array", 60042), symbolArray: S("symbol-array", 60042), symbolModule: S("symbol-module", 60043), symbolPackage: S("symbol-package", 60043), symbolNamespace: S("symbol-namespace", 60043), symbolObject: S("symbol-object", 60043), symbolMethod: S("symbol-method", 60044), symbolFunction: S("symbol-function", 60044), symbolConstructor: S("symbol-constructor", 60044), symbolBoolean: S("symbol-boolean", 60047), symbolNull: S("symbol-null", 60047), symbolNumeric: S("symbol-numeric", 60048), symbolNumber: S("symbol-number", 60048), symbolStructure: S("symbol-structure", 60049), symbolStruct: S("symbol-struct", 60049), symbolParameter: S("symbol-parameter", 60050), symbolTypeParameter: S("symbol-type-parameter", 60050), symbolKey: S("symbol-key", 60051), symbolText: S("symbol-text", 60051), symbolReference: S("symbol-reference", 60052), goToFile: S("go-to-file", 60052), symbolEnum: S("symbol-enum", 60053), symbolValue: S("symbol-value", 60053), symbolRuler: S("symbol-ruler", 60054), symbolUnit: S("symbol-unit", 60054), activateBreakpoints: S("activate-breakpoints", 60055), archive: S("archive", 60056), arrowBoth: S("arrow-both", 60057), arrowDown: S("arrow-down", 60058), arrowLeft: S("arrow-left", 60059), arrowRight: S("arrow-right", 60060), arrowSmallDown: S("arrow-small-down", 60061), arrowSmallLeft: S("arrow-small-left", 60062), arrowSmallRight: S("arrow-small-right", 60063), arrowSmallUp: S("arrow-small-up", 60064), arrowUp: S("arrow-up", 60065), bell: S("bell", 60066), bold: S("bold", 60067), book: S("book", 60068), bookmark: S("bookmark", 60069), debugBreakpointConditionalUnverified: S("debug-breakpoint-conditional-unverified", 60070), debugBreakpointConditional: S("debug-breakpoint-conditional", 60071), debugBreakpointConditionalDisabled: S("debug-breakpoint-conditional-disabled", 60071), debugBreakpointDataUnverified: S("debug-breakpoint-data-unverified", 60072), debugBreakpointData: S("debug-breakpoint-data", 60073), debugBreakpointDataDisabled: S("debug-breakpoint-data-disabled", 60073), debugBreakpointLogUnverified: S("debug-breakpoint-log-unverified", 60074), debugBreakpointLog: S("debug-breakpoint-log", 60075), debugBreakpointLogDisabled: S("debug-breakpoint-log-disabled", 60075), briefcase: S("briefcase", 60076), broadcast: S("broadcast", 60077), browser: S("browser", 60078), bug: S("bug", 60079), calendar: S("calendar", 60080), caseSensitive: S("case-sensitive", 60081), check: S("check", 60082), checklist: S("checklist", 60083), chevronDown: S("chevron-down", 60084), chevronLeft: S("chevron-left", 60085), chevronRight: S("chevron-right", 60086), chevronUp: S("chevron-up", 60087), chromeClose: S("chrome-close", 60088), chromeMaximize: S("chrome-maximize", 60089), chromeMinimize: S("chrome-minimize", 60090), chromeRestore: S("chrome-restore", 60091), circleOutline: S("circle-outline", 60092), circle: S("circle", 60092), debugBreakpointUnverified: S("debug-breakpoint-unverified", 60092), terminalDecorationIncomplete: S("terminal-decoration-incomplete", 60092), circleSlash: S("circle-slash", 60093), circuitBoard: S("circuit-board", 60094), clearAll: S("clear-all", 60095), clippy: S("clippy", 60096), closeAll: S("close-all", 60097), cloudDownload: S("cloud-download", 60098), cloudUpload: S("cloud-upload", 60099), code: S("code", 60100), collapseAll: S("collapse-all", 60101), colorMode: S("color-mode", 60102), commentDiscussion: S("comment-discussion", 60103), creditCard: S("credit-card", 60105), dash: S("dash", 60108), dashboard: S("dashboard", 60109), database: S("database", 60110), debugContinue: S("debug-continue", 60111), debugDisconnect: S("debug-disconnect", 60112), debugPause: S("debug-pause", 60113), debugRestart: S("debug-restart", 60114), debugStart: S("debug-start", 60115), debugStepInto: S("debug-step-into", 60116), debugStepOut: S("debug-step-out", 60117), debugStepOver: S("debug-step-over", 60118), debugStop: S("debug-stop", 60119), debug: S("debug", 60120), deviceCameraVideo: S("device-camera-video", 60121), deviceCamera: S("device-camera", 60122), deviceMobile: S("device-mobile", 60123), diffAdded: S("diff-added", 60124), diffIgnored: S("diff-ignored", 60125), diffModified: S("diff-modified", 60126), diffRemoved: S("diff-removed", 60127), diffRenamed: S("diff-renamed", 60128), diff: S("diff", 60129), diffSidebyside: S("diff-sidebyside", 60129), discard: S("discard", 60130), editorLayout: S("editor-layout", 60131), emptyWindow: S("empty-window", 60132), exclude: S("exclude", 60133), extensions: S("extensions", 60134), eyeClosed: S("eye-closed", 60135), fileBinary: S("file-binary", 60136), fileCode: S("file-code", 60137), fileMedia: S("file-media", 60138), filePdf: S("file-pdf", 60139), fileSubmodule: S("file-submodule", 60140), fileSymlinkDirectory: S("file-symlink-directory", 60141), fileSymlinkFile: S("file-symlink-file", 60142), fileZip: S("file-zip", 60143), files: S("files", 60144), filter: S("filter", 60145), flame: S("flame", 60146), foldDown: S("fold-down", 60147), foldUp: S("fold-up", 60148), fold: S("fold", 60149), folderActive: S("folder-active", 60150), folderOpened: S("folder-opened", 60151), gear: S("gear", 60152), gift: S("gift", 60153), gistSecret: S("gist-secret", 60154), gist: S("gist", 60155), gitCommit: S("git-commit", 60156), gitCompare: S("git-compare", 60157), compareChanges: S("compare-changes", 60157), gitMerge: S("git-merge", 60158), githubAction: S("github-action", 60159), githubAlt: S("github-alt", 60160), globe: S("globe", 60161), grabber: S("grabber", 60162), graph: S("graph", 60163), gripper: S("gripper", 60164), heart: S("heart", 60165), home: S("home", 60166), horizontalRule: S("horizontal-rule", 60167), hubot: S("hubot", 60168), inbox: S("inbox", 60169), issueReopened: S("issue-reopened", 60171), issues: S("issues", 60172), italic: S("italic", 60173), jersey: S("jersey", 60174), json: S("json", 60175), kebabVertical: S("kebab-vertical", 60176), key: S("key", 60177), law: S("law", 60178), lightbulbAutofix: S("lightbulb-autofix", 60179), linkExternal: S("link-external", 60180), link: S("link", 60181), listOrdered: S("list-ordered", 60182), listUnordered: S("list-unordered", 60183), liveShare: S("live-share", 60184), loading: S("loading", 60185), location: S("location", 60186), mailRead: S("mail-read", 60187), mail: S("mail", 60188), markdown: S("markdown", 60189), megaphone: S("megaphone", 60190), mention: S("mention", 60191), milestone: S("milestone", 60192), gitPullRequestMilestone: S("git-pull-request-milestone", 60192), mortarBoard: S("mortar-board", 60193), move: S("move", 60194), multipleWindows: S("multiple-windows", 60195), mute: S("mute", 60196), noNewline: S("no-newline", 60197), note: S("note", 60198), octoface: S("octoface", 60199), openPreview: S("open-preview", 60200), package: S("package", 60201), paintcan: S("paintcan", 60202), pin: S("pin", 60203), play: S("play", 60204), run: S("run", 60204), plug: S("plug", 60205), preserveCase: S("preserve-case", 60206), preview: S("preview", 60207), project: S("project", 60208), pulse: S("pulse", 60209), question: S("question", 60210), quote: S("quote", 60211), radioTower: S("radio-tower", 60212), reactions: S("reactions", 60213), references: S("references", 60214), refresh: S("refresh", 60215), regex: S("regex", 60216), remoteExplorer: S("remote-explorer", 60217), remote: S("remote", 60218), remove: S("remove", 60219), replaceAll: S("replace-all", 60220), replace: S("replace", 60221), repoClone: S("repo-clone", 60222), repoForcePush: S("repo-force-push", 60223), repoPull: S("repo-pull", 60224), repoPush: S("repo-push", 60225), report: S("report", 60226), requestChanges: S("request-changes", 60227), rocket: S("rocket", 60228), rootFolderOpened: S("root-folder-opened", 60229), rootFolder: S("root-folder", 60230), rss: S("rss", 60231), ruby: S("ruby", 60232), saveAll: S("save-all", 60233), saveAs: S("save-as", 60234), save: S("save", 60235), screenFull: S("screen-full", 60236), screenNormal: S("screen-normal", 60237), searchStop: S("search-stop", 60238), server: S("server", 60240), settingsGear: S("settings-gear", 60241), settings: S("settings", 60242), shield: S("shield", 60243), smiley: S("smiley", 60244), sortPrecedence: S("sort-precedence", 60245), splitHorizontal: S("split-horizontal", 60246), splitVertical: S("split-vertical", 60247), squirrel: S("squirrel", 60248), starFull: S("star-full", 60249), starHalf: S("star-half", 60250), symbolClass: S("symbol-class", 60251), symbolColor: S("symbol-color", 60252), symbolConstant: S("symbol-constant", 60253), symbolEnumMember: S("symbol-enum-member", 60254), symbolField: S("symbol-field", 60255), symbolFile: S("symbol-file", 60256), symbolInterface: S("symbol-interface", 60257), symbolKeyword: S("symbol-keyword", 60258), symbolMisc: S("symbol-misc", 60259), symbolOperator: S("symbol-operator", 60260), symbolProperty: S("symbol-property", 60261), wrench: S("wrench", 60261), wrenchSubaction: S("wrench-subaction", 60261), symbolSnippet: S("symbol-snippet", 60262), tasklist: S("tasklist", 60263), telescope: S("telescope", 60264), textSize: S("text-size", 60265), threeBars: S("three-bars", 60266), thumbsdown: S("thumbsdown", 60267), thumbsup: S("thumbsup", 60268), tools: S("tools", 60269), triangleDown: S("triangle-down", 60270), triangleLeft: S("triangle-left", 60271), triangleRight: S("triangle-right", 60272), triangleUp: S("triangle-up", 60273), twitter: S("twitter", 60274), unfold: S("unfold", 60275), unlock: S("unlock", 60276), unmute: S("unmute", 60277), unverified: S("unverified", 60278), verified: S("verified", 60279), versions: S("versions", 60280), vmActive: S("vm-active", 60281), vmOutline: S("vm-outline", 60282), vmRunning: S("vm-running", 60283), watch: S("watch", 60284), whitespace: S("whitespace", 60285), wholeWord: S("whole-word", 60286), window: S("window", 60287), wordWrap: S("word-wrap", 60288), zoomIn: S("zoom-in", 60289), zoomOut: S("zoom-out", 60290), listFilter: S("list-filter", 60291), listFlat: S("list-flat", 60292), listSelection: S("list-selection", 60293), selection: S("selection", 60293), listTree: S("list-tree", 60294), debugBreakpointFunctionUnverified: S("debug-breakpoint-function-unverified", 60295), debugBreakpointFunction: S("debug-breakpoint-function", 60296), debugBreakpointFunctionDisabled: S("debug-breakpoint-function-disabled", 60296), debugStackframeActive: S("debug-stackframe-active", 60297), circleSmallFilled: S("circle-small-filled", 60298), debugStackframeDot: S("debug-stackframe-dot", 60298), terminalDecorationMark: S("terminal-decoration-mark", 60298), debugStackframe: S("debug-stackframe", 60299), debugStackframeFocused: S("debug-stackframe-focused", 60299), debugBreakpointUnsupported: S("debug-breakpoint-unsupported", 60300), symbolString: S("symbol-string", 60301), debugReverseContinue: S("debug-reverse-continue", 60302), debugStepBack: S("debug-step-back", 60303), debugRestartFrame: S("debug-restart-frame", 60304), debugAlt: S("debug-alt", 60305), callIncoming: S("call-incoming", 60306), callOutgoing: S("call-outgoing", 60307), menu: S("menu", 60308), expandAll: S("expand-all", 60309), feedback: S("feedback", 60310), gitPullRequestReviewer: S("git-pull-request-reviewer", 60310), groupByRefType: S("group-by-ref-type", 60311), ungroupByRefType: S("ungroup-by-ref-type", 60312), account: S("account", 60313), gitPullRequestAssignee: S("git-pull-request-assignee", 60313), bellDot: S("bell-dot", 60314), debugConsole: S("debug-console", 60315), library: S("library", 60316), output: S("output", 60317), runAll: S("run-all", 60318), syncIgnored: S("sync-ignored", 60319), pinned: S("pinned", 60320), githubInverted: S("github-inverted", 60321), serverProcess: S("server-process", 60322), serverEnvironment: S("server-environment", 60323), pass: S("pass", 60324), issueClosed: S("issue-closed", 60324), stopCircle: S("stop-circle", 60325), playCircle: S("play-circle", 60326), record: S("record", 60327), debugAltSmall: S("debug-alt-small", 60328), vmConnect: S("vm-connect", 60329), cloud: S("cloud", 60330), merge: S("merge", 60331), export: S("export", 60332), graphLeft: S("graph-left", 60333), magnet: S("magnet", 60334), notebook: S("notebook", 60335), redo: S("redo", 60336), checkAll: S("check-all", 60337), pinnedDirty: S("pinned-dirty", 60338), passFilled: S("pass-filled", 60339), circleLargeFilled: S("circle-large-filled", 60340), circleLarge: S("circle-large", 60341), circleLargeOutline: S("circle-large-outline", 60341), combine: S("combine", 60342), gather: S("gather", 60342), table: S("table", 60343), variableGroup: S("variable-group", 60344), typeHierarchy: S("type-hierarchy", 60345), typeHierarchySub: S("type-hierarchy-sub", 60346), typeHierarchySuper: S("type-hierarchy-super", 60347), gitPullRequestCreate: S("git-pull-request-create", 60348), runAbove: S("run-above", 60349), runBelow: S("run-below", 60350), notebookTemplate: S("notebook-template", 60351), debugRerun: S("debug-rerun", 60352), workspaceTrusted: S("workspace-trusted", 60353), workspaceUntrusted: S("workspace-untrusted", 60354), workspaceUnknown: S("workspace-unknown", 60355), terminalCmd: S("terminal-cmd", 60356), terminalDebian: S("terminal-debian", 60357), terminalLinux: S("terminal-linux", 60358), terminalPowershell: S("terminal-powershell", 60359), terminalTmux: S("terminal-tmux", 60360), terminalUbuntu: S("terminal-ubuntu", 60361), terminalBash: S("terminal-bash", 60362), arrowSwap: S("arrow-swap", 60363), copy: S("copy", 60364), personAdd: S("person-add", 60365), filterFilled: S("filter-filled", 60366), wand: S("wand", 60367), debugLineByLine: S("debug-line-by-line", 60368), inspect: S("inspect", 60369), layers: S("layers", 60370), layersDot: S("layers-dot", 60371), layersActive: S("layers-active", 60372), compass: S("compass", 60373), compassDot: S("compass-dot", 60374), compassActive: S("compass-active", 60375), azure: S("azure", 60376), issueDraft: S("issue-draft", 60377), gitPullRequestClosed: S("git-pull-request-closed", 60378), gitPullRequestDraft: S("git-pull-request-draft", 60379), debugAll: S("debug-all", 60380), debugCoverage: S("debug-coverage", 60381), runErrors: S("run-errors", 60382), folderLibrary: S("folder-library", 60383), debugContinueSmall: S("debug-continue-small", 60384), beakerStop: S("beaker-stop", 60385), graphLine: S("graph-line", 60386), graphScatter: S("graph-scatter", 60387), pieChart: S("pie-chart", 60388), bracket: S("bracket", 60175), bracketDot: S("bracket-dot", 60389), bracketError: S("bracket-error", 60390), lockSmall: S("lock-small", 60391), azureDevops: S("azure-devops", 60392), verifiedFilled: S("verified-filled", 60393), newline: S("newline", 60394), layout: S("layout", 60395), layoutActivitybarLeft: S("layout-activitybar-left", 60396), layoutActivitybarRight: S("layout-activitybar-right", 60397), layoutPanelLeft: S("layout-panel-left", 60398), layoutPanelCenter: S("layout-panel-center", 60399), layoutPanelJustify: S("layout-panel-justify", 60400), layoutPanelRight: S("layout-panel-right", 60401), layoutPanel: S("layout-panel", 60402), layoutSidebarLeft: S("layout-sidebar-left", 60403), layoutSidebarRight: S("layout-sidebar-right", 60404), layoutStatusbar: S("layout-statusbar", 60405), layoutMenubar: S("layout-menubar", 60406), layoutCentered: S("layout-centered", 60407), target: S("target", 60408), indent: S("indent", 60409), recordSmall: S("record-small", 60410), errorSmall: S("error-small", 60411), terminalDecorationError: S("terminal-decoration-error", 60411), arrowCircleDown: S("arrow-circle-down", 60412), arrowCircleLeft: S("arrow-circle-left", 60413), arrowCircleRight: S("arrow-circle-right", 60414), arrowCircleUp: S("arrow-circle-up", 60415), layoutSidebarRightOff: S("layout-sidebar-right-off", 60416), layoutPanelOff: S("layout-panel-off", 60417), layoutSidebarLeftOff: S("layout-sidebar-left-off", 60418), blank: S("blank", 60419), heartFilled: S("heart-filled", 60420), map: S("map", 60421), mapHorizontal: S("map-horizontal", 60421), foldHorizontal: S("fold-horizontal", 60421), mapFilled: S("map-filled", 60422), mapHorizontalFilled: S("map-horizontal-filled", 60422), foldHorizontalFilled: S("fold-horizontal-filled", 60422), circleSmall: S("circle-small", 60423), bellSlash: S("bell-slash", 60424), bellSlashDot: S("bell-slash-dot", 60425), commentUnresolved: S("comment-unresolved", 60426), gitPullRequestGoToChanges: S("git-pull-request-go-to-changes", 60427), gitPullRequestNewChanges: S("git-pull-request-new-changes", 60428), searchFuzzy: S("search-fuzzy", 60429), commentDraft: S("comment-draft", 60430), send: S("send", 60431), sparkle: S("sparkle", 60432), insert: S("insert", 60433), mic: S("mic", 60434), thumbsdownFilled: S("thumbsdown-filled", 60435), thumbsupFilled: S("thumbsup-filled", 60436), coffee: S("coffee", 60437), snake: S("snake", 60438), game: S("game", 60439), vr: S("vr", 60440), chip: S("chip", 60441), piano: S("piano", 60442), music: S("music", 60443), micFilled: S("mic-filled", 60444), repoFetch: S("repo-fetch", 60445), copilot: S("copilot", 60446), lightbulbSparkle: S("lightbulb-sparkle", 60447), robot: S("robot", 60448), sparkleFilled: S("sparkle-filled", 60449), diffSingle: S("diff-single", 60450), diffMultiple: S("diff-multiple", 60451), surroundWith: S("surround-with", 60452), share: S("share", 60453), gitStash: S("git-stash", 60454), gitStashApply: S("git-stash-apply", 60455), gitStashPop: S("git-stash-pop", 60456), vscode: S("vscode", 60457), vscodeInsiders: S("vscode-insiders", 60458), codeOss: S("code-oss", 60459), runCoverage: S("run-coverage", 60460), runAllCoverage: S("run-all-coverage", 60461), coverage: S("coverage", 60462), githubProject: S("github-project", 60463), mapVertical: S("map-vertical", 60464), foldVertical: S("fold-vertical", 60464), mapVerticalFilled: S("map-vertical-filled", 60465), foldVerticalFilled: S("fold-vertical-filled", 60465), dialogError: S("dialog-error", "error"), dialogWarning: S("dialog-warning", "warning"), dialogInfo: S("dialog-info", "info"), dialogClose: S("dialog-close", "close"), treeItemExpanded: S("tree-item-expanded", "chevron-down"), treeFilterOnTypeOn: S("tree-filter-on-type-on", "list-filter"), treeFilterOnTypeOff: S("tree-filter-on-type-off", "list-selection"), treeFilterClear: S("tree-filter-clear", "close"), treeItemLoading: S("tree-item-loading", "loading"), menuSelection: S("menu-selection", "check"), menuSubmenu: S("menu-submenu", "chevron-right"), menuBarMore: S("menubar-more", "more"), scrollbarButtonLeft: S("scrollbar-button-left", "triangle-left"), scrollbarButtonRight: S("scrollbar-button-right", "triangle-right"), scrollbarButtonUp: S("scrollbar-button-up", "triangle-up"), scrollbarButtonDown: S("scrollbar-button-down", "triangle-down"), toolBarMore: S("toolbar-more", "more"), quickInputBack: S("quick-input-back", "arrow-left"), dropDownButton: S("drop-down-button", 60084), symbolCustomColor: S("symbol-customcolor", 60252), exportIcon: S("export", 60332), workspaceUnspecified: S("workspace-unspecified", 60355), newLine: S("newline", 60394), thumbsDownFilled: S("thumbsdown-filled", 60435), thumbsUpFilled: S("thumbsup-filled", 60436), gitFetch: S("git-fetch", 60445), lightbulbSparkleAutofix: S("lightbulb-sparkle-autofix", 60447), debugBreakpointPending: S("debug-breakpoint-pending", 60377) };
class SK extends V {
  get isResolved() {
    return this._isResolved;
  }
  constructor(e, t, n) {
    super(), this._registry = e, this._languageId = t, this._factory = n, this._isDisposed = !1, this._resolvePromise = null, this._isResolved = !1;
  }
  dispose() {
    this._isDisposed = !0, super.dispose();
  }
  async resolve() {
    return this._resolvePromise || (this._resolvePromise = this._create()), this._resolvePromise;
  }
  async _create() {
    const e = await this._factory.tokenizationSupport;
    this._isResolved = !0, e && !this._isDisposed && this._register(this._registry.register(this._languageId, e));
  }
}
let G0 = class {
  constructor(i, e, t) {
    this.offset = i, this.type = e, this.language = t, this._tokenBrand = void 0;
  }
  toString() {
    return "(" + this.offset + ", " + this.type + ")";
  }
};
class nR {
  constructor(e, t) {
    this.tokens = e, this.endState = t, this._tokenizationResultBrand = void 0;
  }
}
class BS {
  constructor(e, t) {
    this.tokens = e, this.endState = t, this._encodedTokenizationResultBrand = void 0;
  }
}
var Z0, Ld, Y0, ul, X0;
(function(i) {
  const e = /* @__PURE__ */ new Map();
  e.set(0, ne.symbolMethod), e.set(1, ne.symbolFunction), e.set(2, ne.symbolConstructor), e.set(3, ne.symbolField), e.set(4, ne.symbolVariable), e.set(5, ne.symbolClass), e.set(6, ne.symbolStruct), e.set(7, ne.symbolInterface), e.set(8, ne.symbolModule), e.set(9, ne.symbolProperty), e.set(10, ne.symbolEvent), e.set(11, ne.symbolOperator), e.set(12, ne.symbolUnit), e.set(13, ne.symbolValue), e.set(15, ne.symbolEnum), e.set(14, ne.symbolConstant), e.set(15, ne.symbolEnum), e.set(16, ne.symbolEnumMember), e.set(17, ne.symbolKeyword), e.set(27, ne.symbolSnippet), e.set(18, ne.symbolText), e.set(19, ne.symbolColor), e.set(20, ne.symbolFile), e.set(21, ne.symbolReference), e.set(22, ne.symbolCustomColor), e.set(23, ne.symbolFolder), e.set(24, ne.symbolTypeParameter), e.set(25, ne.account), e.set(26, ne.issues), i.toIcon = function(n) {
    let s = e.get(n);
    return s || (console.info("No codicon found for CompletionItemKind " + n), s = ne.symbolProperty), s;
  };
  const t = /* @__PURE__ */ new Map();
  t.set("method", 0), t.set("function", 1), t.set("constructor", 2), t.set("field", 3), t.set("variable", 4), t.set("class", 5), t.set("struct", 6), t.set("interface", 7), t.set("module", 8), t.set("property", 9), t.set("event", 10), t.set("operator", 11), t.set("unit", 12), t.set("value", 13), t.set("constant", 14), t.set("enum", 15), t.set("enum-member", 16), t.set("enumMember", 16), t.set("keyword", 17), t.set("snippet", 27), t.set("text", 18), t.set("color", 19), t.set("file", 20), t.set("reference", 21), t.set("customcolor", 22), t.set("folder", 23), t.set("type-parameter", 24), t.set("typeParameter", 24), t.set("account", 25), t.set("issue", 26), i.fromString = function(n, s) {
    let o = t.get(n);
    return o !== void 0 || s || (o = 9), o;
  };
})(Z0 || (Z0 = {})), function(i) {
  i[i.Automatic = 0] = "Automatic", i[i.Explicit = 1] = "Explicit";
}(Ld || (Ld = {}));
class Z7 {
  constructor(e, t, n, s) {
    this.range = e, this.text = t, this.completionKind = n, this.isSnippetText = s;
  }
  equals(e) {
    return D.lift(this.range).equalsRange(e.range) && this.text === e.text && this.completionKind === e.completionKind && this.isSnippetText === e.isSnippetText;
  }
}
(function(i) {
  i[i.Automatic = 0] = "Automatic", i[i.PasteAs = 1] = "PasteAs";
})(Y0 || (Y0 = {})), function(i) {
  i[i.Invoke = 1] = "Invoke", i[i.TriggerCharacter = 2] = "TriggerCharacter", i[i.ContentChange = 3] = "ContentChange";
}(ul || (ul = {})), function(i) {
  i[i.Text = 0] = "Text", i[i.Read = 1] = "Read", i[i.Write = 2] = "Write";
}(X0 || (X0 = {}));
const LK = { 17: m(0, "array"), 16: m(0, "boolean"), 4: m(0, "class"), 13: m(0, "constant"), 8: m(0, "constructor"), 9: m(0, "enumeration"), 21: m(0, "enumeration member"), 23: m(0, "event"), 7: m(0, "field"), 0: m(0, "file"), 11: m(0, "function"), 10: m(0, "interface"), 19: m(0, "key"), 5: m(0, "method"), 1: m(0, "module"), 2: m(0, "namespace"), 20: m(0, "null"), 15: m(0, "number"), 18: m(0, "object"), 24: m(0, "operator"), 3: m(0, "package"), 6: m(0, "property"), 14: m(0, "string"), 22: m(0, "struct"), 25: m(0, "type parameter"), 12: m(0, "variable") };
var Ow, MN, TN, Fw;
(function(i) {
  const e = /* @__PURE__ */ new Map();
  e.set(0, ne.symbolFile), e.set(1, ne.symbolModule), e.set(2, ne.symbolNamespace), e.set(3, ne.symbolPackage), e.set(4, ne.symbolClass), e.set(5, ne.symbolMethod), e.set(6, ne.symbolProperty), e.set(7, ne.symbolField), e.set(8, ne.symbolConstructor), e.set(9, ne.symbolEnum), e.set(10, ne.symbolInterface), e.set(11, ne.symbolFunction), e.set(12, ne.symbolVariable), e.set(13, ne.symbolConstant), e.set(14, ne.symbolString), e.set(15, ne.symbolNumber), e.set(16, ne.symbolBoolean), e.set(17, ne.symbolArray), e.set(18, ne.symbolObject), e.set(19, ne.symbolKey), e.set(20, ne.symbolNull), e.set(21, ne.symbolEnumMember), e.set(22, ne.symbolStruct), e.set(23, ne.symbolEvent), e.set(24, ne.symbolOperator), e.set(25, ne.symbolTypeParameter), i.toIcon = function(t) {
    let n = e.get(t);
    return n || (console.info("No codicon found for SymbolKind " + t), n = ne.symbolProperty), n;
  };
})(Ow || (Ow = {}));
class ls {
  static fromValue(e) {
    switch (e) {
      case "comment":
        return ls.Comment;
      case "imports":
        return ls.Imports;
      case "region":
        return ls.Region;
    }
    return new ls(e);
  }
  constructor(e) {
    this.value = e;
  }
}
ls.Comment = new ls("comment"), ls.Imports = new ls("imports"), ls.Region = new ls("region"), function(i) {
  i[i.AIGenerated = 1] = "AIGenerated";
}(MN || (MN = {})), (TN || (TN = {})).is = function(i) {
  return !(!i || typeof i != "object") && typeof i.id == "string" && typeof i.title == "string";
}, function(i) {
  i[i.Type = 1] = "Type", i[i.Parameter = 2] = "Parameter";
}(Fw || (Fw = {}));
class kK {
  constructor(e) {
    this.createSupport = e, this._tokenizationSupport = null;
  }
  dispose() {
    this._tokenizationSupport && this._tokenizationSupport.then((e) => {
      e && e.dispose();
    });
  }
  get tokenizationSupport() {
    return this._tokenizationSupport || (this._tokenizationSupport = this.createSupport()), this._tokenizationSupport;
  }
}
const ci = new class {
  constructor() {
    this._tokenizationSupports = /* @__PURE__ */ new Map(), this._factories = /* @__PURE__ */ new Map(), this._onDidChange = new F(), this.onDidChange = this._onDidChange.event, this._colorMap = null;
  }
  handleChange(i) {
    this._onDidChange.fire({ changedLanguages: i, changedColorMap: !1 });
  }
  register(i, e) {
    return this._tokenizationSupports.set(i, e), this.handleChange([i]), ye(() => {
      this._tokenizationSupports.get(i) === e && (this._tokenizationSupports.delete(i), this.handleChange([i]));
    });
  }
  get(i) {
    return this._tokenizationSupports.get(i) || null;
  }
  registerFactory(i, e) {
    var t;
    (t = this._factories.get(i)) === null || t === void 0 || t.dispose();
    const n = new SK(this, i, e);
    return this._factories.set(i, n), ye(() => {
      const s = this._factories.get(i);
      s && s === n && (this._factories.delete(i), s.dispose());
    });
  }
  async getOrCreate(i) {
    const e = this.get(i);
    if (e) return e;
    const t = this._factories.get(i);
    return !t || t.isResolved ? null : (await t.resolve(), this.get(i));
  }
  isResolved(i) {
    if (this.get(i)) return !0;
    const e = this._factories.get(i);
    return !(e && !e.isResolved);
  }
  setColorMap(i) {
    this._colorMap = i, this._onDidChange.fire({ changedLanguages: Array.from(this._tokenizationSupports.keys()), changedColorMap: !0 });
  }
  getColorMap() {
    return this._colorMap;
  }
  getDefaultBackground() {
    return this._colorMap && this._colorMap.length > 2 ? this._colorMap[2] : null;
  }
}();
var Bw, RN, AN, PN, ON, FN, BN, WN, VN, HN, zN, UN, KN, jN, qN, $N, GN, ZN, YN, XN, QN, JN, eE, tE, iE, nE, sE, oE, rE, aE, lE, dE, hE, cE, uE, gE, pE, mE, fE, _E, vE, bE, CE, wE, yE;
(function(i) {
  i[i.Invoke = 0] = "Invoke", i[i.Automatic = 1] = "Automatic";
})(Bw || (Bw = {})), function(i) {
  i[i.Unknown = 0] = "Unknown", i[i.Disabled = 1] = "Disabled", i[i.Enabled = 2] = "Enabled";
}(RN || (RN = {})), function(i) {
  i[i.Invoke = 1] = "Invoke", i[i.Auto = 2] = "Auto";
}(AN || (AN = {})), function(i) {
  i[i.None = 0] = "None", i[i.KeepWhitespace = 1] = "KeepWhitespace", i[i.InsertAsSnippet = 4] = "InsertAsSnippet";
}(PN || (PN = {})), function(i) {
  i[i.Method = 0] = "Method", i[i.Function = 1] = "Function", i[i.Constructor = 2] = "Constructor", i[i.Field = 3] = "Field", i[i.Variable = 4] = "Variable", i[i.Class = 5] = "Class", i[i.Struct = 6] = "Struct", i[i.Interface = 7] = "Interface", i[i.Module = 8] = "Module", i[i.Property = 9] = "Property", i[i.Event = 10] = "Event", i[i.Operator = 11] = "Operator", i[i.Unit = 12] = "Unit", i[i.Value = 13] = "Value", i[i.Constant = 14] = "Constant", i[i.Enum = 15] = "Enum", i[i.EnumMember = 16] = "EnumMember", i[i.Keyword = 17] = "Keyword", i[i.Text = 18] = "Text", i[i.Color = 19] = "Color", i[i.File = 20] = "File", i[i.Reference = 21] = "Reference", i[i.Customcolor = 22] = "Customcolor", i[i.Folder = 23] = "Folder", i[i.TypeParameter = 24] = "TypeParameter", i[i.User = 25] = "User", i[i.Issue = 26] = "Issue", i[i.Snippet = 27] = "Snippet";
}(ON || (ON = {})), function(i) {
  i[i.Deprecated = 1] = "Deprecated";
}(FN || (FN = {})), function(i) {
  i[i.Invoke = 0] = "Invoke", i[i.TriggerCharacter = 1] = "TriggerCharacter", i[i.TriggerForIncompleteCompletions = 2] = "TriggerForIncompleteCompletions";
}(BN || (BN = {})), function(i) {
  i[i.EXACT = 0] = "EXACT", i[i.ABOVE = 1] = "ABOVE", i[i.BELOW = 2] = "BELOW";
}(WN || (WN = {})), function(i) {
  i[i.NotSet = 0] = "NotSet", i[i.ContentFlush = 1] = "ContentFlush", i[i.RecoverFromMarkers = 2] = "RecoverFromMarkers", i[i.Explicit = 3] = "Explicit", i[i.Paste = 4] = "Paste", i[i.Undo = 5] = "Undo", i[i.Redo = 6] = "Redo";
}(VN || (VN = {})), function(i) {
  i[i.LF = 1] = "LF", i[i.CRLF = 2] = "CRLF";
}(HN || (HN = {})), function(i) {
  i[i.Text = 0] = "Text", i[i.Read = 1] = "Read", i[i.Write = 2] = "Write";
}(zN || (zN = {})), function(i) {
  i[i.None = 0] = "None", i[i.Keep = 1] = "Keep", i[i.Brackets = 2] = "Brackets", i[i.Advanced = 3] = "Advanced", i[i.Full = 4] = "Full";
}(UN || (UN = {})), function(i) {
  i[i.acceptSuggestionOnCommitCharacter = 0] = "acceptSuggestionOnCommitCharacter", i[i.acceptSuggestionOnEnter = 1] = "acceptSuggestionOnEnter", i[i.accessibilitySupport = 2] = "accessibilitySupport", i[i.accessibilityPageSize = 3] = "accessibilityPageSize", i[i.ariaLabel = 4] = "ariaLabel", i[i.ariaRequired = 5] = "ariaRequired", i[i.autoClosingBrackets = 6] = "autoClosingBrackets", i[i.autoClosingComments = 7] = "autoClosingComments", i[i.screenReaderAnnounceInlineSuggestion = 8] = "screenReaderAnnounceInlineSuggestion", i[i.autoClosingDelete = 9] = "autoClosingDelete", i[i.autoClosingOvertype = 10] = "autoClosingOvertype", i[i.autoClosingQuotes = 11] = "autoClosingQuotes", i[i.autoIndent = 12] = "autoIndent", i[i.automaticLayout = 13] = "automaticLayout", i[i.autoSurround = 14] = "autoSurround", i[i.bracketPairColorization = 15] = "bracketPairColorization", i[i.guides = 16] = "guides", i[i.codeLens = 17] = "codeLens", i[i.codeLensFontFamily = 18] = "codeLensFontFamily", i[i.codeLensFontSize = 19] = "codeLensFontSize", i[i.colorDecorators = 20] = "colorDecorators", i[i.colorDecoratorsLimit = 21] = "colorDecoratorsLimit", i[i.columnSelection = 22] = "columnSelection", i[i.comments = 23] = "comments", i[i.contextmenu = 24] = "contextmenu", i[i.copyWithSyntaxHighlighting = 25] = "copyWithSyntaxHighlighting", i[i.cursorBlinking = 26] = "cursorBlinking", i[i.cursorSmoothCaretAnimation = 27] = "cursorSmoothCaretAnimation", i[i.cursorStyle = 28] = "cursorStyle", i[i.cursorSurroundingLines = 29] = "cursorSurroundingLines", i[i.cursorSurroundingLinesStyle = 30] = "cursorSurroundingLinesStyle", i[i.cursorWidth = 31] = "cursorWidth", i[i.disableLayerHinting = 32] = "disableLayerHinting", i[i.disableMonospaceOptimizations = 33] = "disableMonospaceOptimizations", i[i.domReadOnly = 34] = "domReadOnly", i[i.dragAndDrop = 35] = "dragAndDrop", i[i.dropIntoEditor = 36] = "dropIntoEditor", i[i.emptySelectionClipboard = 37] = "emptySelectionClipboard", i[i.experimentalWhitespaceRendering = 38] = "experimentalWhitespaceRendering", i[i.extraEditorClassName = 39] = "extraEditorClassName", i[i.fastScrollSensitivity = 40] = "fastScrollSensitivity", i[i.find = 41] = "find", i[i.fixedOverflowWidgets = 42] = "fixedOverflowWidgets", i[i.folding = 43] = "folding", i[i.foldingStrategy = 44] = "foldingStrategy", i[i.foldingHighlight = 45] = "foldingHighlight", i[i.foldingImportsByDefault = 46] = "foldingImportsByDefault", i[i.foldingMaximumRegions = 47] = "foldingMaximumRegions", i[i.unfoldOnClickAfterEndOfLine = 48] = "unfoldOnClickAfterEndOfLine", i[i.fontFamily = 49] = "fontFamily", i[i.fontInfo = 50] = "fontInfo", i[i.fontLigatures = 51] = "fontLigatures", i[i.fontSize = 52] = "fontSize", i[i.fontWeight = 53] = "fontWeight", i[i.fontVariations = 54] = "fontVariations", i[i.formatOnPaste = 55] = "formatOnPaste", i[i.formatOnType = 56] = "formatOnType", i[i.glyphMargin = 57] = "glyphMargin", i[i.gotoLocation = 58] = "gotoLocation", i[i.hideCursorInOverviewRuler = 59] = "hideCursorInOverviewRuler", i[i.hover = 60] = "hover", i[i.inDiffEditor = 61] = "inDiffEditor", i[i.inlineSuggest = 62] = "inlineSuggest", i[i.inlineEdit = 63] = "inlineEdit", i[i.letterSpacing = 64] = "letterSpacing", i[i.lightbulb = 65] = "lightbulb", i[i.lineDecorationsWidth = 66] = "lineDecorationsWidth", i[i.lineHeight = 67] = "lineHeight", i[i.lineNumbers = 68] = "lineNumbers", i[i.lineNumbersMinChars = 69] = "lineNumbersMinChars", i[i.linkedEditing = 70] = "linkedEditing", i[i.links = 71] = "links", i[i.matchBrackets = 72] = "matchBrackets", i[i.minimap = 73] = "minimap", i[i.mouseStyle = 74] = "mouseStyle", i[i.mouseWheelScrollSensitivity = 75] = "mouseWheelScrollSensitivity", i[i.mouseWheelZoom = 76] = "mouseWheelZoom", i[i.multiCursorMergeOverlapping = 77] = "multiCursorMergeOverlapping", i[i.multiCursorModifier = 78] = "multiCursorModifier", i[i.multiCursorPaste = 79] = "multiCursorPaste", i[i.multiCursorLimit = 80] = "multiCursorLimit", i[i.occurrencesHighlight = 81] = "occurrencesHighlight", i[i.overviewRulerBorder = 82] = "overviewRulerBorder", i[i.overviewRulerLanes = 83] = "overviewRulerLanes", i[i.padding = 84] = "padding", i[i.pasteAs = 85] = "pasteAs", i[i.parameterHints = 86] = "parameterHints", i[i.peekWidgetDefaultFocus = 87] = "peekWidgetDefaultFocus", i[i.definitionLinkOpensInPeek = 88] = "definitionLinkOpensInPeek", i[i.quickSuggestions = 89] = "quickSuggestions", i[i.quickSuggestionsDelay = 90] = "quickSuggestionsDelay", i[i.readOnly = 91] = "readOnly", i[i.readOnlyMessage = 92] = "readOnlyMessage", i[i.renameOnType = 93] = "renameOnType", i[i.renderControlCharacters = 94] = "renderControlCharacters", i[i.renderFinalNewline = 95] = "renderFinalNewline", i[i.renderLineHighlight = 96] = "renderLineHighlight", i[i.renderLineHighlightOnlyWhenFocus = 97] = "renderLineHighlightOnlyWhenFocus", i[i.renderValidationDecorations = 98] = "renderValidationDecorations", i[i.renderWhitespace = 99] = "renderWhitespace", i[i.revealHorizontalRightPadding = 100] = "revealHorizontalRightPadding", i[i.roundedSelection = 101] = "roundedSelection", i[i.rulers = 102] = "rulers", i[i.scrollbar = 103] = "scrollbar", i[i.scrollBeyondLastColumn = 104] = "scrollBeyondLastColumn", i[i.scrollBeyondLastLine = 105] = "scrollBeyondLastLine", i[i.scrollPredominantAxis = 106] = "scrollPredominantAxis", i[i.selectionClipboard = 107] = "selectionClipboard", i[i.selectionHighlight = 108] = "selectionHighlight", i[i.selectOnLineNumbers = 109] = "selectOnLineNumbers", i[i.showFoldingControls = 110] = "showFoldingControls", i[i.showUnused = 111] = "showUnused", i[i.snippetSuggestions = 112] = "snippetSuggestions", i[i.smartSelect = 113] = "smartSelect", i[i.smoothScrolling = 114] = "smoothScrolling", i[i.stickyScroll = 115] = "stickyScroll", i[i.stickyTabStops = 116] = "stickyTabStops", i[i.stopRenderingLineAfter = 117] = "stopRenderingLineAfter", i[i.suggest = 118] = "suggest", i[i.suggestFontSize = 119] = "suggestFontSize", i[i.suggestLineHeight = 120] = "suggestLineHeight", i[i.suggestOnTriggerCharacters = 121] = "suggestOnTriggerCharacters", i[i.suggestSelection = 122] = "suggestSelection", i[i.tabCompletion = 123] = "tabCompletion", i[i.tabIndex = 124] = "tabIndex", i[i.unicodeHighlighting = 125] = "unicodeHighlighting", i[i.unusualLineTerminators = 126] = "unusualLineTerminators", i[i.useShadowDOM = 127] = "useShadowDOM", i[i.useTabStops = 128] = "useTabStops", i[i.wordBreak = 129] = "wordBreak", i[i.wordSegmenterLocales = 130] = "wordSegmenterLocales", i[i.wordSeparators = 131] = "wordSeparators", i[i.wordWrap = 132] = "wordWrap", i[i.wordWrapBreakAfterCharacters = 133] = "wordWrapBreakAfterCharacters", i[i.wordWrapBreakBeforeCharacters = 134] = "wordWrapBreakBeforeCharacters", i[i.wordWrapColumn = 135] = "wordWrapColumn", i[i.wordWrapOverride1 = 136] = "wordWrapOverride1", i[i.wordWrapOverride2 = 137] = "wordWrapOverride2", i[i.wrappingIndent = 138] = "wrappingIndent", i[i.wrappingStrategy = 139] = "wrappingStrategy", i[i.showDeprecated = 140] = "showDeprecated", i[i.inlayHints = 141] = "inlayHints", i[i.editorClassName = 142] = "editorClassName", i[i.pixelRatio = 143] = "pixelRatio", i[i.tabFocusMode = 144] = "tabFocusMode", i[i.layoutInfo = 145] = "layoutInfo", i[i.wrappingInfo = 146] = "wrappingInfo", i[i.defaultColorDecorators = 147] = "defaultColorDecorators", i[i.colorDecoratorsActivatedOn = 148] = "colorDecoratorsActivatedOn", i[i.inlineCompletionsAccessibilityVerbose = 149] = "inlineCompletionsAccessibilityVerbose";
}(KN || (KN = {})), function(i) {
  i[i.TextDefined = 0] = "TextDefined", i[i.LF = 1] = "LF", i[i.CRLF = 2] = "CRLF";
}(jN || (jN = {})), function(i) {
  i[i.LF = 0] = "LF", i[i.CRLF = 1] = "CRLF";
}(qN || (qN = {})), function(i) {
  i[i.Left = 1] = "Left", i[i.Center = 2] = "Center", i[i.Right = 3] = "Right";
}($N || ($N = {})), function(i) {
  i[i.None = 0] = "None", i[i.Indent = 1] = "Indent", i[i.IndentOutdent = 2] = "IndentOutdent", i[i.Outdent = 3] = "Outdent";
}(GN || (GN = {})), function(i) {
  i[i.Both = 0] = "Both", i[i.Right = 1] = "Right", i[i.Left = 2] = "Left", i[i.None = 3] = "None";
}(ZN || (ZN = {})), function(i) {
  i[i.Type = 1] = "Type", i[i.Parameter = 2] = "Parameter";
}(YN || (YN = {})), function(i) {
  i[i.Automatic = 0] = "Automatic", i[i.Explicit = 1] = "Explicit";
}(XN || (XN = {})), function(i) {
  i[i.Invoke = 0] = "Invoke", i[i.Automatic = 1] = "Automatic";
}(QN || (QN = {})), function(i) {
  i[i.DependsOnKbLayout = -1] = "DependsOnKbLayout", i[i.Unknown = 0] = "Unknown", i[i.Backspace = 1] = "Backspace", i[i.Tab = 2] = "Tab", i[i.Enter = 3] = "Enter", i[i.Shift = 4] = "Shift", i[i.Ctrl = 5] = "Ctrl", i[i.Alt = 6] = "Alt", i[i.PauseBreak = 7] = "PauseBreak", i[i.CapsLock = 8] = "CapsLock", i[i.Escape = 9] = "Escape", i[i.Space = 10] = "Space", i[i.PageUp = 11] = "PageUp", i[i.PageDown = 12] = "PageDown", i[i.End = 13] = "End", i[i.Home = 14] = "Home", i[i.LeftArrow = 15] = "LeftArrow", i[i.UpArrow = 16] = "UpArrow", i[i.RightArrow = 17] = "RightArrow", i[i.DownArrow = 18] = "DownArrow", i[i.Insert = 19] = "Insert", i[i.Delete = 20] = "Delete", i[i.Digit0 = 21] = "Digit0", i[i.Digit1 = 22] = "Digit1", i[i.Digit2 = 23] = "Digit2", i[i.Digit3 = 24] = "Digit3", i[i.Digit4 = 25] = "Digit4", i[i.Digit5 = 26] = "Digit5", i[i.Digit6 = 27] = "Digit6", i[i.Digit7 = 28] = "Digit7", i[i.Digit8 = 29] = "Digit8", i[i.Digit9 = 30] = "Digit9", i[i.KeyA = 31] = "KeyA", i[i.KeyB = 32] = "KeyB", i[i.KeyC = 33] = "KeyC", i[i.KeyD = 34] = "KeyD", i[i.KeyE = 35] = "KeyE", i[i.KeyF = 36] = "KeyF", i[i.KeyG = 37] = "KeyG", i[i.KeyH = 38] = "KeyH", i[i.KeyI = 39] = "KeyI", i[i.KeyJ = 40] = "KeyJ", i[i.KeyK = 41] = "KeyK", i[i.KeyL = 42] = "KeyL", i[i.KeyM = 43] = "KeyM", i[i.KeyN = 44] = "KeyN", i[i.KeyO = 45] = "KeyO", i[i.KeyP = 46] = "KeyP", i[i.KeyQ = 47] = "KeyQ", i[i.KeyR = 48] = "KeyR", i[i.KeyS = 49] = "KeyS", i[i.KeyT = 50] = "KeyT", i[i.KeyU = 51] = "KeyU", i[i.KeyV = 52] = "KeyV", i[i.KeyW = 53] = "KeyW", i[i.KeyX = 54] = "KeyX", i[i.KeyY = 55] = "KeyY", i[i.KeyZ = 56] = "KeyZ", i[i.Meta = 57] = "Meta", i[i.ContextMenu = 58] = "ContextMenu", i[i.F1 = 59] = "F1", i[i.F2 = 60] = "F2", i[i.F3 = 61] = "F3", i[i.F4 = 62] = "F4", i[i.F5 = 63] = "F5", i[i.F6 = 64] = "F6", i[i.F7 = 65] = "F7", i[i.F8 = 66] = "F8", i[i.F9 = 67] = "F9", i[i.F10 = 68] = "F10", i[i.F11 = 69] = "F11", i[i.F12 = 70] = "F12", i[i.F13 = 71] = "F13", i[i.F14 = 72] = "F14", i[i.F15 = 73] = "F15", i[i.F16 = 74] = "F16", i[i.F17 = 75] = "F17", i[i.F18 = 76] = "F18", i[i.F19 = 77] = "F19", i[i.F20 = 78] = "F20", i[i.F21 = 79] = "F21", i[i.F22 = 80] = "F22", i[i.F23 = 81] = "F23", i[i.F24 = 82] = "F24", i[i.NumLock = 83] = "NumLock", i[i.ScrollLock = 84] = "ScrollLock", i[i.Semicolon = 85] = "Semicolon", i[i.Equal = 86] = "Equal", i[i.Comma = 87] = "Comma", i[i.Minus = 88] = "Minus", i[i.Period = 89] = "Period", i[i.Slash = 90] = "Slash", i[i.Backquote = 91] = "Backquote", i[i.BracketLeft = 92] = "BracketLeft", i[i.Backslash = 93] = "Backslash", i[i.BracketRight = 94] = "BracketRight", i[i.Quote = 95] = "Quote", i[i.OEM_8 = 96] = "OEM_8", i[i.IntlBackslash = 97] = "IntlBackslash", i[i.Numpad0 = 98] = "Numpad0", i[i.Numpad1 = 99] = "Numpad1", i[i.Numpad2 = 100] = "Numpad2", i[i.Numpad3 = 101] = "Numpad3", i[i.Numpad4 = 102] = "Numpad4", i[i.Numpad5 = 103] = "Numpad5", i[i.Numpad6 = 104] = "Numpad6", i[i.Numpad7 = 105] = "Numpad7", i[i.Numpad8 = 106] = "Numpad8", i[i.Numpad9 = 107] = "Numpad9", i[i.NumpadMultiply = 108] = "NumpadMultiply", i[i.NumpadAdd = 109] = "NumpadAdd", i[i.NUMPAD_SEPARATOR = 110] = "NUMPAD_SEPARATOR", i[i.NumpadSubtract = 111] = "NumpadSubtract", i[i.NumpadDecimal = 112] = "NumpadDecimal", i[i.NumpadDivide = 113] = "NumpadDivide", i[i.KEY_IN_COMPOSITION = 114] = "KEY_IN_COMPOSITION", i[i.ABNT_C1 = 115] = "ABNT_C1", i[i.ABNT_C2 = 116] = "ABNT_C2", i[i.AudioVolumeMute = 117] = "AudioVolumeMute", i[i.AudioVolumeUp = 118] = "AudioVolumeUp", i[i.AudioVolumeDown = 119] = "AudioVolumeDown", i[i.BrowserSearch = 120] = "BrowserSearch", i[i.BrowserHome = 121] = "BrowserHome", i[i.BrowserBack = 122] = "BrowserBack", i[i.BrowserForward = 123] = "BrowserForward", i[i.MediaTrackNext = 124] = "MediaTrackNext", i[i.MediaTrackPrevious = 125] = "MediaTrackPrevious", i[i.MediaStop = 126] = "MediaStop", i[i.MediaPlayPause = 127] = "MediaPlayPause", i[i.LaunchMediaPlayer = 128] = "LaunchMediaPlayer", i[i.LaunchMail = 129] = "LaunchMail", i[i.LaunchApp2 = 130] = "LaunchApp2", i[i.Clear = 131] = "Clear", i[i.MAX_VALUE = 132] = "MAX_VALUE";
}(JN || (JN = {})), function(i) {
  i[i.Hint = 1] = "Hint", i[i.Info = 2] = "Info", i[i.Warning = 4] = "Warning", i[i.Error = 8] = "Error";
}(eE || (eE = {})), function(i) {
  i[i.Unnecessary = 1] = "Unnecessary", i[i.Deprecated = 2] = "Deprecated";
}(tE || (tE = {})), function(i) {
  i[i.Inline = 1] = "Inline", i[i.Gutter = 2] = "Gutter";
}(iE || (iE = {})), function(i) {
  i[i.Normal = 1] = "Normal", i[i.Underlined = 2] = "Underlined";
}(nE || (nE = {})), function(i) {
  i[i.UNKNOWN = 0] = "UNKNOWN", i[i.TEXTAREA = 1] = "TEXTAREA", i[i.GUTTER_GLYPH_MARGIN = 2] = "GUTTER_GLYPH_MARGIN", i[i.GUTTER_LINE_NUMBERS = 3] = "GUTTER_LINE_NUMBERS", i[i.GUTTER_LINE_DECORATIONS = 4] = "GUTTER_LINE_DECORATIONS", i[i.GUTTER_VIEW_ZONE = 5] = "GUTTER_VIEW_ZONE", i[i.CONTENT_TEXT = 6] = "CONTENT_TEXT", i[i.CONTENT_EMPTY = 7] = "CONTENT_EMPTY", i[i.CONTENT_VIEW_ZONE = 8] = "CONTENT_VIEW_ZONE", i[i.CONTENT_WIDGET = 9] = "CONTENT_WIDGET", i[i.OVERVIEW_RULER = 10] = "OVERVIEW_RULER", i[i.SCROLLBAR = 11] = "SCROLLBAR", i[i.OVERLAY_WIDGET = 12] = "OVERLAY_WIDGET", i[i.OUTSIDE_EDITOR = 13] = "OUTSIDE_EDITOR";
}(sE || (sE = {})), function(i) {
  i[i.AIGenerated = 1] = "AIGenerated";
}(oE || (oE = {})), function(i) {
  i[i.TOP_RIGHT_CORNER = 0] = "TOP_RIGHT_CORNER", i[i.BOTTOM_RIGHT_CORNER = 1] = "BOTTOM_RIGHT_CORNER", i[i.TOP_CENTER = 2] = "TOP_CENTER";
}(rE || (rE = {})), function(i) {
  i[i.Left = 1] = "Left", i[i.Center = 2] = "Center", i[i.Right = 4] = "Right", i[i.Full = 7] = "Full";
}(aE || (aE = {})), function(i) {
  i[i.Word = 0] = "Word", i[i.Line = 1] = "Line", i[i.Suggest = 2] = "Suggest";
}(lE || (lE = {})), function(i) {
  i[i.Left = 0] = "Left", i[i.Right = 1] = "Right", i[i.None = 2] = "None", i[i.LeftOfInjectedText = 3] = "LeftOfInjectedText", i[i.RightOfInjectedText = 4] = "RightOfInjectedText";
}(dE || (dE = {})), function(i) {
  i[i.Off = 0] = "Off", i[i.On = 1] = "On", i[i.Relative = 2] = "Relative", i[i.Interval = 3] = "Interval", i[i.Custom = 4] = "Custom";
}(hE || (hE = {})), function(i) {
  i[i.None = 0] = "None", i[i.Text = 1] = "Text", i[i.Blocks = 2] = "Blocks";
}(cE || (cE = {})), function(i) {
  i[i.Smooth = 0] = "Smooth", i[i.Immediate = 1] = "Immediate";
}(uE || (uE = {})), function(i) {
  i[i.Auto = 1] = "Auto", i[i.Hidden = 2] = "Hidden", i[i.Visible = 3] = "Visible";
}(gE || (gE = {})), function(i) {
  i[i.LTR = 0] = "LTR", i[i.RTL = 1] = "RTL";
}(pE || (pE = {})), function(i) {
  i.Off = "off", i.OnCode = "onCode", i.On = "on";
}(mE || (mE = {})), function(i) {
  i[i.Invoke = 1] = "Invoke", i[i.TriggerCharacter = 2] = "TriggerCharacter", i[i.ContentChange = 3] = "ContentChange";
}(fE || (fE = {})), function(i) {
  i[i.File = 0] = "File", i[i.Module = 1] = "Module", i[i.Namespace = 2] = "Namespace", i[i.Package = 3] = "Package", i[i.Class = 4] = "Class", i[i.Method = 5] = "Method", i[i.Property = 6] = "Property", i[i.Field = 7] = "Field", i[i.Constructor = 8] = "Constructor", i[i.Enum = 9] = "Enum", i[i.Interface = 10] = "Interface", i[i.Function = 11] = "Function", i[i.Variable = 12] = "Variable", i[i.Constant = 13] = "Constant", i[i.String = 14] = "String", i[i.Number = 15] = "Number", i[i.Boolean = 16] = "Boolean", i[i.Array = 17] = "Array", i[i.Object = 18] = "Object", i[i.Key = 19] = "Key", i[i.Null = 20] = "Null", i[i.EnumMember = 21] = "EnumMember", i[i.Struct = 22] = "Struct", i[i.Event = 23] = "Event", i[i.Operator = 24] = "Operator", i[i.TypeParameter = 25] = "TypeParameter";
}(_E || (_E = {})), function(i) {
  i[i.Deprecated = 1] = "Deprecated";
}(vE || (vE = {})), function(i) {
  i[i.Hidden = 0] = "Hidden", i[i.Blink = 1] = "Blink", i[i.Smooth = 2] = "Smooth", i[i.Phase = 3] = "Phase", i[i.Expand = 4] = "Expand", i[i.Solid = 5] = "Solid";
}(bE || (bE = {})), function(i) {
  i[i.Line = 1] = "Line", i[i.Block = 2] = "Block", i[i.Underline = 3] = "Underline", i[i.LineThin = 4] = "LineThin", i[i.BlockOutline = 5] = "BlockOutline", i[i.UnderlineThin = 6] = "UnderlineThin";
}(CE || (CE = {})), function(i) {
  i[i.AlwaysGrowsWhenTypingAtEdges = 0] = "AlwaysGrowsWhenTypingAtEdges", i[i.NeverGrowsWhenTypingAtEdges = 1] = "NeverGrowsWhenTypingAtEdges", i[i.GrowsOnlyWhenTypingBefore = 2] = "GrowsOnlyWhenTypingBefore", i[i.GrowsOnlyWhenTypingAfter = 3] = "GrowsOnlyWhenTypingAfter";
}(wE || (wE = {})), function(i) {
  i[i.None = 0] = "None", i[i.Same = 1] = "Same", i[i.Indent = 2] = "Indent", i[i.DeepIndent = 3] = "DeepIndent";
}(yE || (yE = {}));
let u_ = class {
  static chord(i, e) {
    return Vi(i, e);
  }
};
function Y7() {
  return { editor: void 0, languages: void 0, CancellationTokenSource: Ci, Emitter: F, KeyCode: JN, KeyMod: u_, Position: W, Range: D, Selection: _e, SelectionDirection: pE, MarkerSeverity: eE, MarkerTag: tE, Uri: Ie, Token: G0 };
}
u_.CtrlCmd = 2048, u_.Shift = 1024, u_.Alt = 512, u_.WinCtrl = 256;
const Et = window;
class aO {
  get cachedValues() {
    return this._map;
  }
  constructor(e) {
    this.fn = e, this._map = /* @__PURE__ */ new Map();
  }
  get(e) {
    if (this._map.has(e)) return this._map.get(e);
    const t = this.fn(e);
    return this._map.set(e, t), t;
  }
}
class ga {
  constructor(e) {
    this.executor = e, this._didRun = !1;
  }
  get value() {
    if (!this._didRun) try {
      this._value = this.executor();
    } catch (e) {
      this._error = e;
    } finally {
      this._didRun = !0;
    }
    if (this._error) throw this._error;
    return this._value;
  }
  get rawValue() {
    return this._value;
  }
}
var kp;
function X7(i) {
  return !i || typeof i != "string" || i.trim().length === 0;
}
const DK = /{(\d+)}/g;
function rg(i, ...e) {
  return e.length === 0 ? i : i.replace(DK, function(t, n) {
    const s = parseInt(n, 10);
    return isNaN(s) || s < 0 || s >= e.length ? t : e[s];
  });
}
function Ww(i) {
  return i.replace(/[<>&]/g, function(e) {
    switch (e) {
      case "<":
        return "&lt;";
      case ">":
        return "&gt;";
      case "&":
        return "&amp;";
      default:
        return e;
    }
  });
}
function No(i) {
  return i.replace(/[\\\{\}\*\+\?\|\^\$\.\[\]\(\)]/g, "\\$&");
}
function xK(i, e = " ") {
  return Q7(p1(i, e), e);
}
function p1(i, e) {
  if (!i || !e) return i;
  const t = e.length;
  if (t === 0 || i.length === 0) return i;
  let n = 0;
  for (; i.indexOf(e, n) === n; ) n += t;
  return i.substring(n);
}
function Q7(i, e) {
  if (!i || !e) return i;
  const t = e.length, n = i.length;
  if (t === 0 || n === 0) return i;
  let s = n, o = -1;
  for (; o = i.lastIndexOf(e, s - 1), o !== -1 && o + t === s; ) {
    if (o === 0) return "";
    s = o;
  }
  return i.substring(0, s);
}
function J7(i, e, t = {}) {
  if (!i) throw new Error("Cannot create regex from empty string");
  e || (i = No(i)), t.wholeWord && (/\B/.test(i.charAt(0)) || (i = "\\b" + i), /\B/.test(i.charAt(i.length - 1)) || (i += "\\b"));
  let n = "";
  return t.global && (n += "g"), t.matchCase || (n += "i"), t.multiline && (n += "m"), t.unicode && (n += "u"), new RegExp(i, n);
}
function Sl(i) {
  return i.split(/\r\n|\r|\n/);
}
function Jn(i) {
  for (let e = 0, t = i.length; e < t; e++) {
    const n = i.charCodeAt(e);
    if (n !== 32 && n !== 9) return e;
  }
  return -1;
}
function Wt(i, e = 0, t = i.length) {
  for (let n = e; n < t; n++) {
    const s = i.charCodeAt(n);
    if (s !== 32 && s !== 9) return i.substring(e, n);
  }
  return i.substring(e, t);
}
function ra(i, e = i.length - 1) {
  for (let t = e; t >= 0; t--) {
    const n = i.charCodeAt(t);
    if (n !== 32 && n !== 9) return t;
  }
  return -1;
}
function Q0(i, e) {
  return i < e ? -1 : i > e ? 1 : 0;
}
function sR(i, e, t = 0, n = i.length, s = 0, o = e.length) {
  for (; t < n && s < o; t++, s++) {
    const l = i.charCodeAt(t), d = e.charCodeAt(s);
    if (l < d) return -1;
    if (l > d) return 1;
  }
  const r = n - t, a = o - s;
  return r < a ? -1 : r > a ? 1 : 0;
}
function SE(i, e) {
  return m1(i, e, 0, i.length, 0, e.length);
}
function m1(i, e, t = 0, n = i.length, s = 0, o = e.length) {
  for (; t < n && s < o; t++, s++) {
    let l = i.charCodeAt(t), d = e.charCodeAt(s);
    if (l === d) continue;
    if (l >= 128 || d >= 128) return sR(i.toLowerCase(), e.toLowerCase(), t, n, s, o);
    Eh(l) && (l -= 32), Eh(d) && (d -= 32);
    const h = l - d;
    if (h !== 0) return h;
  }
  const r = n - t, a = o - s;
  return r < a ? -1 : r > a ? 1 : 0;
}
function Q1(i) {
  return i >= 48 && i <= 57;
}
function Eh(i) {
  return i >= 97 && i <= 122;
}
function Wa(i) {
  return i >= 65 && i <= 90;
}
function Dp(i, e) {
  return i.length === e.length && m1(i, e) === 0;
}
function oR(i, e) {
  const t = e.length;
  return !(e.length > i.length) && m1(i, e, 0, t) === 0;
}
function fc(i, e) {
  const t = Math.min(i.length, e.length);
  let n;
  for (n = 0; n < t; n++) if (i.charCodeAt(n) !== e.charCodeAt(n)) return n;
  return t;
}
function Vw(i, e) {
  const t = Math.min(i.length, e.length);
  let n;
  const s = i.length - 1, o = e.length - 1;
  for (n = 0; n < t; n++) if (i.charCodeAt(s - n) !== e.charCodeAt(o - n)) return n;
  return t;
}
function en(i) {
  return 55296 <= i && i <= 56319;
}
function ag(i) {
  return 56320 <= i && i <= 57343;
}
function rR(i, e) {
  return e - 56320 + (i - 55296 << 10) + 65536;
}
function Hw(i, e, t) {
  const n = i.charCodeAt(t);
  if (en(n) && t + 1 < e) {
    const s = i.charCodeAt(t + 1);
    if (ag(s)) return rR(n, s);
  }
  return n;
}
class LE {
  get offset() {
    return this._offset;
  }
  constructor(e, t = 0) {
    this._str = e, this._len = e.length, this._offset = t;
  }
  setOffset(e) {
    this._offset = e;
  }
  prevCodePoint() {
    const e = function(t, n) {
      const s = t.charCodeAt(n - 1);
      if (ag(s) && n > 1) {
        const o = t.charCodeAt(n - 2);
        if (en(o)) return rR(o, s);
      }
      return s;
    }(this._str, this._offset);
    return this._offset -= e >= 65536 ? 2 : 1, e;
  }
  nextCodePoint() {
    const e = Hw(this._str, this._len, this._offset);
    return this._offset += e >= 65536 ? 2 : 1, e;
  }
  eol() {
    return this._offset >= this._len;
  }
}
class zw {
  get offset() {
    return this._iterator.offset;
  }
  constructor(e, t = 0) {
    this._iterator = new LE(e, t);
  }
  nextGraphemeLength() {
    const e = Ih.getInstance(), t = this._iterator, n = t.offset;
    let s = e.getGraphemeBreakType(t.nextCodePoint());
    for (; !t.eol(); ) {
      const o = t.offset, r = e.getGraphemeBreakType(t.nextCodePoint());
      if (lO(s, r)) {
        t.setOffset(o);
        break;
      }
      s = r;
    }
    return t.offset - n;
  }
  prevGraphemeLength() {
    const e = Ih.getInstance(), t = this._iterator, n = t.offset;
    let s = e.getGraphemeBreakType(t.prevCodePoint());
    for (; t.offset > 0; ) {
      const o = t.offset, r = e.getGraphemeBreakType(t.prevCodePoint());
      if (lO(r, s)) {
        t.setOffset(o);
        break;
      }
      s = r;
    }
    return n - t.offset;
  }
  eol() {
    return this._iterator.eol();
  }
}
function aR(i, e) {
  return new zw(i, e).nextGraphemeLength();
}
function e8(i, e) {
  return new zw(i, e).prevGraphemeLength();
}
let Ok;
function Fm(i) {
  return Ok || (Ok = /(?:[\u05BE\u05C0\u05C3\u05C6\u05D0-\u05F4\u0608\u060B\u060D\u061B-\u064A\u066D-\u066F\u0671-\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u0710\u0712-\u072F\u074D-\u07A5\u07B1-\u07EA\u07F4\u07F5\u07FA\u07FE-\u0815\u081A\u0824\u0828\u0830-\u0858\u085E-\u088E\u08A0-\u08C9\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFD3D\uFD50-\uFDC7\uFDF0-\uFDFC\uFE70-\uFEFC]|\uD802[\uDC00-\uDD1B\uDD20-\uDE00\uDE10-\uDE35\uDE40-\uDEE4\uDEEB-\uDF35\uDF40-\uDFFF]|\uD803[\uDC00-\uDD23\uDE80-\uDEA9\uDEAD-\uDF45\uDF51-\uDF81\uDF86-\uDFF6]|\uD83A[\uDC00-\uDCCF\uDD00-\uDD43\uDD4B-\uDFFF]|\uD83B[\uDC00-\uDEBB])/), Ok.test(i);
}
const NK = /^[\t\n\r\x20-\x7E]*$/;
function f1(i) {
  return NK.test(i);
}
const t8 = /[\u2028\u2029]/;
function i8(i) {
  return t8.test(i);
}
function _c(i) {
  return i >= 11904 && i <= 55215 || i >= 63744 && i <= 64255 || i >= 65281 && i <= 65374;
}
function lR(i) {
  return i >= 127462 && i <= 127487 || i === 8986 || i === 8987 || i === 9200 || i === 9203 || i >= 9728 && i <= 10175 || i === 11088 || i === 11093 || i >= 127744 && i <= 128591 || i >= 128640 && i <= 128764 || i >= 128992 && i <= 129008 || i >= 129280 && i <= 129535 || i >= 129648 && i <= 129782;
}
const EK = "\uFEFF";
function dR(i) {
  return !!(i && i.length > 0 && i.charCodeAt(0) === 65279);
}
function n8(i) {
  return (i %= 52) < 26 ? String.fromCharCode(97 + i) : String.fromCharCode(65 + i - 26);
}
function lO(i, e) {
  return i === 0 ? e !== 5 && e !== 7 : (i !== 2 || e !== 3) && (i === 4 || i === 2 || i === 3 || e === 4 || e === 2 || e === 3 || (i !== 8 || e !== 8 && e !== 9 && e !== 11 && e !== 12) && (i !== 11 && i !== 9 || e !== 9 && e !== 10) && (i !== 12 && i !== 10 || e !== 10) && e !== 5 && e !== 13 && e !== 7 && i !== 1 && (i !== 13 || e !== 14) && (i !== 6 || e !== 6));
}
class Ih {
  static getInstance() {
    return Ih._INSTANCE || (Ih._INSTANCE = new Ih()), Ih._INSTANCE;
  }
  constructor() {
    this._data = JSON.parse("[0,0,0,51229,51255,12,44061,44087,12,127462,127487,6,7083,7085,5,47645,47671,12,54813,54839,12,128678,128678,14,3270,3270,5,9919,9923,14,45853,45879,12,49437,49463,12,53021,53047,12,71216,71218,7,128398,128399,14,129360,129374,14,2519,2519,5,4448,4519,9,9742,9742,14,12336,12336,14,44957,44983,12,46749,46775,12,48541,48567,12,50333,50359,12,52125,52151,12,53917,53943,12,69888,69890,5,73018,73018,5,127990,127990,14,128558,128559,14,128759,128760,14,129653,129655,14,2027,2035,5,2891,2892,7,3761,3761,5,6683,6683,5,8293,8293,4,9825,9826,14,9999,9999,14,43452,43453,5,44509,44535,12,45405,45431,12,46301,46327,12,47197,47223,12,48093,48119,12,48989,49015,12,49885,49911,12,50781,50807,12,51677,51703,12,52573,52599,12,53469,53495,12,54365,54391,12,65279,65279,4,70471,70472,7,72145,72147,7,119173,119179,5,127799,127818,14,128240,128244,14,128512,128512,14,128652,128652,14,128721,128722,14,129292,129292,14,129445,129450,14,129734,129743,14,1476,1477,5,2366,2368,7,2750,2752,7,3076,3076,5,3415,3415,5,4141,4144,5,6109,6109,5,6964,6964,5,7394,7400,5,9197,9198,14,9770,9770,14,9877,9877,14,9968,9969,14,10084,10084,14,43052,43052,5,43713,43713,5,44285,44311,12,44733,44759,12,45181,45207,12,45629,45655,12,46077,46103,12,46525,46551,12,46973,46999,12,47421,47447,12,47869,47895,12,48317,48343,12,48765,48791,12,49213,49239,12,49661,49687,12,50109,50135,12,50557,50583,12,51005,51031,12,51453,51479,12,51901,51927,12,52349,52375,12,52797,52823,12,53245,53271,12,53693,53719,12,54141,54167,12,54589,54615,12,55037,55063,12,69506,69509,5,70191,70193,5,70841,70841,7,71463,71467,5,72330,72342,5,94031,94031,5,123628,123631,5,127763,127765,14,127941,127941,14,128043,128062,14,128302,128317,14,128465,128467,14,128539,128539,14,128640,128640,14,128662,128662,14,128703,128703,14,128745,128745,14,129004,129007,14,129329,129330,14,129402,129402,14,129483,129483,14,129686,129704,14,130048,131069,14,173,173,4,1757,1757,1,2200,2207,5,2434,2435,7,2631,2632,5,2817,2817,5,3008,3008,5,3201,3201,5,3387,3388,5,3542,3542,5,3902,3903,7,4190,4192,5,6002,6003,5,6439,6440,5,6765,6770,7,7019,7027,5,7154,7155,7,8205,8205,13,8505,8505,14,9654,9654,14,9757,9757,14,9792,9792,14,9852,9853,14,9890,9894,14,9937,9937,14,9981,9981,14,10035,10036,14,11035,11036,14,42654,42655,5,43346,43347,7,43587,43587,5,44006,44007,7,44173,44199,12,44397,44423,12,44621,44647,12,44845,44871,12,45069,45095,12,45293,45319,12,45517,45543,12,45741,45767,12,45965,45991,12,46189,46215,12,46413,46439,12,46637,46663,12,46861,46887,12,47085,47111,12,47309,47335,12,47533,47559,12,47757,47783,12,47981,48007,12,48205,48231,12,48429,48455,12,48653,48679,12,48877,48903,12,49101,49127,12,49325,49351,12,49549,49575,12,49773,49799,12,49997,50023,12,50221,50247,12,50445,50471,12,50669,50695,12,50893,50919,12,51117,51143,12,51341,51367,12,51565,51591,12,51789,51815,12,52013,52039,12,52237,52263,12,52461,52487,12,52685,52711,12,52909,52935,12,53133,53159,12,53357,53383,12,53581,53607,12,53805,53831,12,54029,54055,12,54253,54279,12,54477,54503,12,54701,54727,12,54925,54951,12,55149,55175,12,68101,68102,5,69762,69762,7,70067,70069,7,70371,70378,5,70720,70721,7,71087,71087,5,71341,71341,5,71995,71996,5,72249,72249,7,72850,72871,5,73109,73109,5,118576,118598,5,121505,121519,5,127245,127247,14,127568,127569,14,127777,127777,14,127872,127891,14,127956,127967,14,128015,128016,14,128110,128172,14,128259,128259,14,128367,128368,14,128424,128424,14,128488,128488,14,128530,128532,14,128550,128551,14,128566,128566,14,128647,128647,14,128656,128656,14,128667,128673,14,128691,128693,14,128715,128715,14,128728,128732,14,128752,128752,14,128765,128767,14,129096,129103,14,129311,129311,14,129344,129349,14,129394,129394,14,129413,129425,14,129466,129471,14,129511,129535,14,129664,129666,14,129719,129722,14,129760,129767,14,917536,917631,5,13,13,2,1160,1161,5,1564,1564,4,1807,1807,1,2085,2087,5,2307,2307,7,2382,2383,7,2497,2500,5,2563,2563,7,2677,2677,5,2763,2764,7,2879,2879,5,2914,2915,5,3021,3021,5,3142,3144,5,3263,3263,5,3285,3286,5,3398,3400,7,3530,3530,5,3633,3633,5,3864,3865,5,3974,3975,5,4155,4156,7,4229,4230,5,5909,5909,7,6078,6085,7,6277,6278,5,6451,6456,7,6744,6750,5,6846,6846,5,6972,6972,5,7074,7077,5,7146,7148,7,7222,7223,5,7416,7417,5,8234,8238,4,8417,8417,5,9000,9000,14,9203,9203,14,9730,9731,14,9748,9749,14,9762,9763,14,9776,9783,14,9800,9811,14,9831,9831,14,9872,9873,14,9882,9882,14,9900,9903,14,9929,9933,14,9941,9960,14,9974,9974,14,9989,9989,14,10006,10006,14,10062,10062,14,10160,10160,14,11647,11647,5,12953,12953,14,43019,43019,5,43232,43249,5,43443,43443,5,43567,43568,7,43696,43696,5,43765,43765,7,44013,44013,5,44117,44143,12,44229,44255,12,44341,44367,12,44453,44479,12,44565,44591,12,44677,44703,12,44789,44815,12,44901,44927,12,45013,45039,12,45125,45151,12,45237,45263,12,45349,45375,12,45461,45487,12,45573,45599,12,45685,45711,12,45797,45823,12,45909,45935,12,46021,46047,12,46133,46159,12,46245,46271,12,46357,46383,12,46469,46495,12,46581,46607,12,46693,46719,12,46805,46831,12,46917,46943,12,47029,47055,12,47141,47167,12,47253,47279,12,47365,47391,12,47477,47503,12,47589,47615,12,47701,47727,12,47813,47839,12,47925,47951,12,48037,48063,12,48149,48175,12,48261,48287,12,48373,48399,12,48485,48511,12,48597,48623,12,48709,48735,12,48821,48847,12,48933,48959,12,49045,49071,12,49157,49183,12,49269,49295,12,49381,49407,12,49493,49519,12,49605,49631,12,49717,49743,12,49829,49855,12,49941,49967,12,50053,50079,12,50165,50191,12,50277,50303,12,50389,50415,12,50501,50527,12,50613,50639,12,50725,50751,12,50837,50863,12,50949,50975,12,51061,51087,12,51173,51199,12,51285,51311,12,51397,51423,12,51509,51535,12,51621,51647,12,51733,51759,12,51845,51871,12,51957,51983,12,52069,52095,12,52181,52207,12,52293,52319,12,52405,52431,12,52517,52543,12,52629,52655,12,52741,52767,12,52853,52879,12,52965,52991,12,53077,53103,12,53189,53215,12,53301,53327,12,53413,53439,12,53525,53551,12,53637,53663,12,53749,53775,12,53861,53887,12,53973,53999,12,54085,54111,12,54197,54223,12,54309,54335,12,54421,54447,12,54533,54559,12,54645,54671,12,54757,54783,12,54869,54895,12,54981,55007,12,55093,55119,12,55243,55291,10,66045,66045,5,68325,68326,5,69688,69702,5,69817,69818,5,69957,69958,7,70089,70092,5,70198,70199,5,70462,70462,5,70502,70508,5,70750,70750,5,70846,70846,7,71100,71101,5,71230,71230,7,71351,71351,5,71737,71738,5,72000,72000,7,72160,72160,5,72273,72278,5,72752,72758,5,72882,72883,5,73031,73031,5,73461,73462,7,94192,94193,7,119149,119149,7,121403,121452,5,122915,122916,5,126980,126980,14,127358,127359,14,127535,127535,14,127759,127759,14,127771,127771,14,127792,127793,14,127825,127867,14,127897,127899,14,127945,127945,14,127985,127986,14,128000,128007,14,128021,128021,14,128066,128100,14,128184,128235,14,128249,128252,14,128266,128276,14,128335,128335,14,128379,128390,14,128407,128419,14,128444,128444,14,128481,128481,14,128499,128499,14,128526,128526,14,128536,128536,14,128543,128543,14,128556,128556,14,128564,128564,14,128577,128580,14,128643,128645,14,128649,128649,14,128654,128654,14,128660,128660,14,128664,128664,14,128675,128675,14,128686,128689,14,128695,128696,14,128705,128709,14,128717,128719,14,128725,128725,14,128736,128741,14,128747,128748,14,128755,128755,14,128762,128762,14,128981,128991,14,129009,129023,14,129160,129167,14,129296,129304,14,129320,129327,14,129340,129342,14,129356,129356,14,129388,129392,14,129399,129400,14,129404,129407,14,129432,129442,14,129454,129455,14,129473,129474,14,129485,129487,14,129648,129651,14,129659,129660,14,129671,129679,14,129709,129711,14,129728,129730,14,129751,129753,14,129776,129782,14,917505,917505,4,917760,917999,5,10,10,3,127,159,4,768,879,5,1471,1471,5,1536,1541,1,1648,1648,5,1767,1768,5,1840,1866,5,2070,2073,5,2137,2139,5,2274,2274,1,2363,2363,7,2377,2380,7,2402,2403,5,2494,2494,5,2507,2508,7,2558,2558,5,2622,2624,7,2641,2641,5,2691,2691,7,2759,2760,5,2786,2787,5,2876,2876,5,2881,2884,5,2901,2902,5,3006,3006,5,3014,3016,7,3072,3072,5,3134,3136,5,3157,3158,5,3260,3260,5,3266,3266,5,3274,3275,7,3328,3329,5,3391,3392,7,3405,3405,5,3457,3457,5,3536,3537,7,3551,3551,5,3636,3642,5,3764,3772,5,3895,3895,5,3967,3967,7,3993,4028,5,4146,4151,5,4182,4183,7,4226,4226,5,4253,4253,5,4957,4959,5,5940,5940,7,6070,6070,7,6087,6088,7,6158,6158,4,6432,6434,5,6448,6449,7,6679,6680,5,6742,6742,5,6754,6754,5,6783,6783,5,6912,6915,5,6966,6970,5,6978,6978,5,7042,7042,7,7080,7081,5,7143,7143,7,7150,7150,7,7212,7219,5,7380,7392,5,7412,7412,5,8203,8203,4,8232,8232,4,8265,8265,14,8400,8412,5,8421,8432,5,8617,8618,14,9167,9167,14,9200,9200,14,9410,9410,14,9723,9726,14,9733,9733,14,9745,9745,14,9752,9752,14,9760,9760,14,9766,9766,14,9774,9774,14,9786,9786,14,9794,9794,14,9823,9823,14,9828,9828,14,9833,9850,14,9855,9855,14,9875,9875,14,9880,9880,14,9885,9887,14,9896,9897,14,9906,9916,14,9926,9927,14,9935,9935,14,9939,9939,14,9962,9962,14,9972,9972,14,9978,9978,14,9986,9986,14,9997,9997,14,10002,10002,14,10017,10017,14,10055,10055,14,10071,10071,14,10133,10135,14,10548,10549,14,11093,11093,14,12330,12333,5,12441,12442,5,42608,42610,5,43010,43010,5,43045,43046,5,43188,43203,7,43302,43309,5,43392,43394,5,43446,43449,5,43493,43493,5,43571,43572,7,43597,43597,7,43703,43704,5,43756,43757,5,44003,44004,7,44009,44010,7,44033,44059,12,44089,44115,12,44145,44171,12,44201,44227,12,44257,44283,12,44313,44339,12,44369,44395,12,44425,44451,12,44481,44507,12,44537,44563,12,44593,44619,12,44649,44675,12,44705,44731,12,44761,44787,12,44817,44843,12,44873,44899,12,44929,44955,12,44985,45011,12,45041,45067,12,45097,45123,12,45153,45179,12,45209,45235,12,45265,45291,12,45321,45347,12,45377,45403,12,45433,45459,12,45489,45515,12,45545,45571,12,45601,45627,12,45657,45683,12,45713,45739,12,45769,45795,12,45825,45851,12,45881,45907,12,45937,45963,12,45993,46019,12,46049,46075,12,46105,46131,12,46161,46187,12,46217,46243,12,46273,46299,12,46329,46355,12,46385,46411,12,46441,46467,12,46497,46523,12,46553,46579,12,46609,46635,12,46665,46691,12,46721,46747,12,46777,46803,12,46833,46859,12,46889,46915,12,46945,46971,12,47001,47027,12,47057,47083,12,47113,47139,12,47169,47195,12,47225,47251,12,47281,47307,12,47337,47363,12,47393,47419,12,47449,47475,12,47505,47531,12,47561,47587,12,47617,47643,12,47673,47699,12,47729,47755,12,47785,47811,12,47841,47867,12,47897,47923,12,47953,47979,12,48009,48035,12,48065,48091,12,48121,48147,12,48177,48203,12,48233,48259,12,48289,48315,12,48345,48371,12,48401,48427,12,48457,48483,12,48513,48539,12,48569,48595,12,48625,48651,12,48681,48707,12,48737,48763,12,48793,48819,12,48849,48875,12,48905,48931,12,48961,48987,12,49017,49043,12,49073,49099,12,49129,49155,12,49185,49211,12,49241,49267,12,49297,49323,12,49353,49379,12,49409,49435,12,49465,49491,12,49521,49547,12,49577,49603,12,49633,49659,12,49689,49715,12,49745,49771,12,49801,49827,12,49857,49883,12,49913,49939,12,49969,49995,12,50025,50051,12,50081,50107,12,50137,50163,12,50193,50219,12,50249,50275,12,50305,50331,12,50361,50387,12,50417,50443,12,50473,50499,12,50529,50555,12,50585,50611,12,50641,50667,12,50697,50723,12,50753,50779,12,50809,50835,12,50865,50891,12,50921,50947,12,50977,51003,12,51033,51059,12,51089,51115,12,51145,51171,12,51201,51227,12,51257,51283,12,51313,51339,12,51369,51395,12,51425,51451,12,51481,51507,12,51537,51563,12,51593,51619,12,51649,51675,12,51705,51731,12,51761,51787,12,51817,51843,12,51873,51899,12,51929,51955,12,51985,52011,12,52041,52067,12,52097,52123,12,52153,52179,12,52209,52235,12,52265,52291,12,52321,52347,12,52377,52403,12,52433,52459,12,52489,52515,12,52545,52571,12,52601,52627,12,52657,52683,12,52713,52739,12,52769,52795,12,52825,52851,12,52881,52907,12,52937,52963,12,52993,53019,12,53049,53075,12,53105,53131,12,53161,53187,12,53217,53243,12,53273,53299,12,53329,53355,12,53385,53411,12,53441,53467,12,53497,53523,12,53553,53579,12,53609,53635,12,53665,53691,12,53721,53747,12,53777,53803,12,53833,53859,12,53889,53915,12,53945,53971,12,54001,54027,12,54057,54083,12,54113,54139,12,54169,54195,12,54225,54251,12,54281,54307,12,54337,54363,12,54393,54419,12,54449,54475,12,54505,54531,12,54561,54587,12,54617,54643,12,54673,54699,12,54729,54755,12,54785,54811,12,54841,54867,12,54897,54923,12,54953,54979,12,55009,55035,12,55065,55091,12,55121,55147,12,55177,55203,12,65024,65039,5,65520,65528,4,66422,66426,5,68152,68154,5,69291,69292,5,69633,69633,5,69747,69748,5,69811,69814,5,69826,69826,5,69932,69932,7,70016,70017,5,70079,70080,7,70095,70095,5,70196,70196,5,70367,70367,5,70402,70403,7,70464,70464,5,70487,70487,5,70709,70711,7,70725,70725,7,70833,70834,7,70843,70844,7,70849,70849,7,71090,71093,5,71103,71104,5,71227,71228,7,71339,71339,5,71344,71349,5,71458,71461,5,71727,71735,5,71985,71989,7,71998,71998,5,72002,72002,7,72154,72155,5,72193,72202,5,72251,72254,5,72281,72283,5,72344,72345,5,72766,72766,7,72874,72880,5,72885,72886,5,73023,73029,5,73104,73105,5,73111,73111,5,92912,92916,5,94095,94098,5,113824,113827,4,119142,119142,7,119155,119162,4,119362,119364,5,121476,121476,5,122888,122904,5,123184,123190,5,125252,125258,5,127183,127183,14,127340,127343,14,127377,127386,14,127491,127503,14,127548,127551,14,127744,127756,14,127761,127761,14,127769,127769,14,127773,127774,14,127780,127788,14,127796,127797,14,127820,127823,14,127869,127869,14,127894,127895,14,127902,127903,14,127943,127943,14,127947,127950,14,127972,127972,14,127988,127988,14,127992,127994,14,128009,128011,14,128019,128019,14,128023,128041,14,128064,128064,14,128102,128107,14,128174,128181,14,128238,128238,14,128246,128247,14,128254,128254,14,128264,128264,14,128278,128299,14,128329,128330,14,128348,128359,14,128371,128377,14,128392,128393,14,128401,128404,14,128421,128421,14,128433,128434,14,128450,128452,14,128476,128478,14,128483,128483,14,128495,128495,14,128506,128506,14,128519,128520,14,128528,128528,14,128534,128534,14,128538,128538,14,128540,128542,14,128544,128549,14,128552,128555,14,128557,128557,14,128560,128563,14,128565,128565,14,128567,128576,14,128581,128591,14,128641,128642,14,128646,128646,14,128648,128648,14,128650,128651,14,128653,128653,14,128655,128655,14,128657,128659,14,128661,128661,14,128663,128663,14,128665,128666,14,128674,128674,14,128676,128677,14,128679,128685,14,128690,128690,14,128694,128694,14,128697,128702,14,128704,128704,14,128710,128714,14,128716,128716,14,128720,128720,14,128723,128724,14,128726,128727,14,128733,128735,14,128742,128744,14,128746,128746,14,128749,128751,14,128753,128754,14,128756,128758,14,128761,128761,14,128763,128764,14,128884,128895,14,128992,129003,14,129008,129008,14,129036,129039,14,129114,129119,14,129198,129279,14,129293,129295,14,129305,129310,14,129312,129319,14,129328,129328,14,129331,129338,14,129343,129343,14,129351,129355,14,129357,129359,14,129375,129387,14,129393,129393,14,129395,129398,14,129401,129401,14,129403,129403,14,129408,129412,14,129426,129431,14,129443,129444,14,129451,129453,14,129456,129465,14,129472,129472,14,129475,129482,14,129484,129484,14,129488,129510,14,129536,129647,14,129652,129652,14,129656,129658,14,129661,129663,14,129667,129670,14,129680,129685,14,129705,129708,14,129712,129718,14,129723,129727,14,129731,129733,14,129744,129750,14,129754,129759,14,129768,129775,14,129783,129791,14,917504,917504,4,917506,917535,4,917632,917759,4,918000,921599,4,0,9,4,11,12,4,14,31,4,169,169,14,174,174,14,1155,1159,5,1425,1469,5,1473,1474,5,1479,1479,5,1552,1562,5,1611,1631,5,1750,1756,5,1759,1764,5,1770,1773,5,1809,1809,5,1958,1968,5,2045,2045,5,2075,2083,5,2089,2093,5,2192,2193,1,2250,2273,5,2275,2306,5,2362,2362,5,2364,2364,5,2369,2376,5,2381,2381,5,2385,2391,5,2433,2433,5,2492,2492,5,2495,2496,7,2503,2504,7,2509,2509,5,2530,2531,5,2561,2562,5,2620,2620,5,2625,2626,5,2635,2637,5,2672,2673,5,2689,2690,5,2748,2748,5,2753,2757,5,2761,2761,7,2765,2765,5,2810,2815,5,2818,2819,7,2878,2878,5,2880,2880,7,2887,2888,7,2893,2893,5,2903,2903,5,2946,2946,5,3007,3007,7,3009,3010,7,3018,3020,7,3031,3031,5,3073,3075,7,3132,3132,5,3137,3140,7,3146,3149,5,3170,3171,5,3202,3203,7,3262,3262,7,3264,3265,7,3267,3268,7,3271,3272,7,3276,3277,5,3298,3299,5,3330,3331,7,3390,3390,5,3393,3396,5,3402,3404,7,3406,3406,1,3426,3427,5,3458,3459,7,3535,3535,5,3538,3540,5,3544,3550,7,3570,3571,7,3635,3635,7,3655,3662,5,3763,3763,7,3784,3789,5,3893,3893,5,3897,3897,5,3953,3966,5,3968,3972,5,3981,3991,5,4038,4038,5,4145,4145,7,4153,4154,5,4157,4158,5,4184,4185,5,4209,4212,5,4228,4228,7,4237,4237,5,4352,4447,8,4520,4607,10,5906,5908,5,5938,5939,5,5970,5971,5,6068,6069,5,6071,6077,5,6086,6086,5,6089,6099,5,6155,6157,5,6159,6159,5,6313,6313,5,6435,6438,7,6441,6443,7,6450,6450,5,6457,6459,5,6681,6682,7,6741,6741,7,6743,6743,7,6752,6752,5,6757,6764,5,6771,6780,5,6832,6845,5,6847,6862,5,6916,6916,7,6965,6965,5,6971,6971,7,6973,6977,7,6979,6980,7,7040,7041,5,7073,7073,7,7078,7079,7,7082,7082,7,7142,7142,5,7144,7145,5,7149,7149,5,7151,7153,5,7204,7211,7,7220,7221,7,7376,7378,5,7393,7393,7,7405,7405,5,7415,7415,7,7616,7679,5,8204,8204,5,8206,8207,4,8233,8233,4,8252,8252,14,8288,8292,4,8294,8303,4,8413,8416,5,8418,8420,5,8482,8482,14,8596,8601,14,8986,8987,14,9096,9096,14,9193,9196,14,9199,9199,14,9201,9202,14,9208,9210,14,9642,9643,14,9664,9664,14,9728,9729,14,9732,9732,14,9735,9741,14,9743,9744,14,9746,9746,14,9750,9751,14,9753,9756,14,9758,9759,14,9761,9761,14,9764,9765,14,9767,9769,14,9771,9773,14,9775,9775,14,9784,9785,14,9787,9791,14,9793,9793,14,9795,9799,14,9812,9822,14,9824,9824,14,9827,9827,14,9829,9830,14,9832,9832,14,9851,9851,14,9854,9854,14,9856,9861,14,9874,9874,14,9876,9876,14,9878,9879,14,9881,9881,14,9883,9884,14,9888,9889,14,9895,9895,14,9898,9899,14,9904,9905,14,9917,9918,14,9924,9925,14,9928,9928,14,9934,9934,14,9936,9936,14,9938,9938,14,9940,9940,14,9961,9961,14,9963,9967,14,9970,9971,14,9973,9973,14,9975,9977,14,9979,9980,14,9982,9985,14,9987,9988,14,9992,9996,14,9998,9998,14,10000,10001,14,10004,10004,14,10013,10013,14,10024,10024,14,10052,10052,14,10060,10060,14,10067,10069,14,10083,10083,14,10085,10087,14,10145,10145,14,10175,10175,14,11013,11015,14,11088,11088,14,11503,11505,5,11744,11775,5,12334,12335,5,12349,12349,14,12951,12951,14,42607,42607,5,42612,42621,5,42736,42737,5,43014,43014,5,43043,43044,7,43047,43047,7,43136,43137,7,43204,43205,5,43263,43263,5,43335,43345,5,43360,43388,8,43395,43395,7,43444,43445,7,43450,43451,7,43454,43456,7,43561,43566,5,43569,43570,5,43573,43574,5,43596,43596,5,43644,43644,5,43698,43700,5,43710,43711,5,43755,43755,7,43758,43759,7,43766,43766,5,44005,44005,5,44008,44008,5,44012,44012,7,44032,44032,11,44060,44060,11,44088,44088,11,44116,44116,11,44144,44144,11,44172,44172,11,44200,44200,11,44228,44228,11,44256,44256,11,44284,44284,11,44312,44312,11,44340,44340,11,44368,44368,11,44396,44396,11,44424,44424,11,44452,44452,11,44480,44480,11,44508,44508,11,44536,44536,11,44564,44564,11,44592,44592,11,44620,44620,11,44648,44648,11,44676,44676,11,44704,44704,11,44732,44732,11,44760,44760,11,44788,44788,11,44816,44816,11,44844,44844,11,44872,44872,11,44900,44900,11,44928,44928,11,44956,44956,11,44984,44984,11,45012,45012,11,45040,45040,11,45068,45068,11,45096,45096,11,45124,45124,11,45152,45152,11,45180,45180,11,45208,45208,11,45236,45236,11,45264,45264,11,45292,45292,11,45320,45320,11,45348,45348,11,45376,45376,11,45404,45404,11,45432,45432,11,45460,45460,11,45488,45488,11,45516,45516,11,45544,45544,11,45572,45572,11,45600,45600,11,45628,45628,11,45656,45656,11,45684,45684,11,45712,45712,11,45740,45740,11,45768,45768,11,45796,45796,11,45824,45824,11,45852,45852,11,45880,45880,11,45908,45908,11,45936,45936,11,45964,45964,11,45992,45992,11,46020,46020,11,46048,46048,11,46076,46076,11,46104,46104,11,46132,46132,11,46160,46160,11,46188,46188,11,46216,46216,11,46244,46244,11,46272,46272,11,46300,46300,11,46328,46328,11,46356,46356,11,46384,46384,11,46412,46412,11,46440,46440,11,46468,46468,11,46496,46496,11,46524,46524,11,46552,46552,11,46580,46580,11,46608,46608,11,46636,46636,11,46664,46664,11,46692,46692,11,46720,46720,11,46748,46748,11,46776,46776,11,46804,46804,11,46832,46832,11,46860,46860,11,46888,46888,11,46916,46916,11,46944,46944,11,46972,46972,11,47000,47000,11,47028,47028,11,47056,47056,11,47084,47084,11,47112,47112,11,47140,47140,11,47168,47168,11,47196,47196,11,47224,47224,11,47252,47252,11,47280,47280,11,47308,47308,11,47336,47336,11,47364,47364,11,47392,47392,11,47420,47420,11,47448,47448,11,47476,47476,11,47504,47504,11,47532,47532,11,47560,47560,11,47588,47588,11,47616,47616,11,47644,47644,11,47672,47672,11,47700,47700,11,47728,47728,11,47756,47756,11,47784,47784,11,47812,47812,11,47840,47840,11,47868,47868,11,47896,47896,11,47924,47924,11,47952,47952,11,47980,47980,11,48008,48008,11,48036,48036,11,48064,48064,11,48092,48092,11,48120,48120,11,48148,48148,11,48176,48176,11,48204,48204,11,48232,48232,11,48260,48260,11,48288,48288,11,48316,48316,11,48344,48344,11,48372,48372,11,48400,48400,11,48428,48428,11,48456,48456,11,48484,48484,11,48512,48512,11,48540,48540,11,48568,48568,11,48596,48596,11,48624,48624,11,48652,48652,11,48680,48680,11,48708,48708,11,48736,48736,11,48764,48764,11,48792,48792,11,48820,48820,11,48848,48848,11,48876,48876,11,48904,48904,11,48932,48932,11,48960,48960,11,48988,48988,11,49016,49016,11,49044,49044,11,49072,49072,11,49100,49100,11,49128,49128,11,49156,49156,11,49184,49184,11,49212,49212,11,49240,49240,11,49268,49268,11,49296,49296,11,49324,49324,11,49352,49352,11,49380,49380,11,49408,49408,11,49436,49436,11,49464,49464,11,49492,49492,11,49520,49520,11,49548,49548,11,49576,49576,11,49604,49604,11,49632,49632,11,49660,49660,11,49688,49688,11,49716,49716,11,49744,49744,11,49772,49772,11,49800,49800,11,49828,49828,11,49856,49856,11,49884,49884,11,49912,49912,11,49940,49940,11,49968,49968,11,49996,49996,11,50024,50024,11,50052,50052,11,50080,50080,11,50108,50108,11,50136,50136,11,50164,50164,11,50192,50192,11,50220,50220,11,50248,50248,11,50276,50276,11,50304,50304,11,50332,50332,11,50360,50360,11,50388,50388,11,50416,50416,11,50444,50444,11,50472,50472,11,50500,50500,11,50528,50528,11,50556,50556,11,50584,50584,11,50612,50612,11,50640,50640,11,50668,50668,11,50696,50696,11,50724,50724,11,50752,50752,11,50780,50780,11,50808,50808,11,50836,50836,11,50864,50864,11,50892,50892,11,50920,50920,11,50948,50948,11,50976,50976,11,51004,51004,11,51032,51032,11,51060,51060,11,51088,51088,11,51116,51116,11,51144,51144,11,51172,51172,11,51200,51200,11,51228,51228,11,51256,51256,11,51284,51284,11,51312,51312,11,51340,51340,11,51368,51368,11,51396,51396,11,51424,51424,11,51452,51452,11,51480,51480,11,51508,51508,11,51536,51536,11,51564,51564,11,51592,51592,11,51620,51620,11,51648,51648,11,51676,51676,11,51704,51704,11,51732,51732,11,51760,51760,11,51788,51788,11,51816,51816,11,51844,51844,11,51872,51872,11,51900,51900,11,51928,51928,11,51956,51956,11,51984,51984,11,52012,52012,11,52040,52040,11,52068,52068,11,52096,52096,11,52124,52124,11,52152,52152,11,52180,52180,11,52208,52208,11,52236,52236,11,52264,52264,11,52292,52292,11,52320,52320,11,52348,52348,11,52376,52376,11,52404,52404,11,52432,52432,11,52460,52460,11,52488,52488,11,52516,52516,11,52544,52544,11,52572,52572,11,52600,52600,11,52628,52628,11,52656,52656,11,52684,52684,11,52712,52712,11,52740,52740,11,52768,52768,11,52796,52796,11,52824,52824,11,52852,52852,11,52880,52880,11,52908,52908,11,52936,52936,11,52964,52964,11,52992,52992,11,53020,53020,11,53048,53048,11,53076,53076,11,53104,53104,11,53132,53132,11,53160,53160,11,53188,53188,11,53216,53216,11,53244,53244,11,53272,53272,11,53300,53300,11,53328,53328,11,53356,53356,11,53384,53384,11,53412,53412,11,53440,53440,11,53468,53468,11,53496,53496,11,53524,53524,11,53552,53552,11,53580,53580,11,53608,53608,11,53636,53636,11,53664,53664,11,53692,53692,11,53720,53720,11,53748,53748,11,53776,53776,11,53804,53804,11,53832,53832,11,53860,53860,11,53888,53888,11,53916,53916,11,53944,53944,11,53972,53972,11,54000,54000,11,54028,54028,11,54056,54056,11,54084,54084,11,54112,54112,11,54140,54140,11,54168,54168,11,54196,54196,11,54224,54224,11,54252,54252,11,54280,54280,11,54308,54308,11,54336,54336,11,54364,54364,11,54392,54392,11,54420,54420,11,54448,54448,11,54476,54476,11,54504,54504,11,54532,54532,11,54560,54560,11,54588,54588,11,54616,54616,11,54644,54644,11,54672,54672,11,54700,54700,11,54728,54728,11,54756,54756,11,54784,54784,11,54812,54812,11,54840,54840,11,54868,54868,11,54896,54896,11,54924,54924,11,54952,54952,11,54980,54980,11,55008,55008,11,55036,55036,11,55064,55064,11,55092,55092,11,55120,55120,11,55148,55148,11,55176,55176,11,55216,55238,9,64286,64286,5,65056,65071,5,65438,65439,5,65529,65531,4,66272,66272,5,68097,68099,5,68108,68111,5,68159,68159,5,68900,68903,5,69446,69456,5,69632,69632,7,69634,69634,7,69744,69744,5,69759,69761,5,69808,69810,7,69815,69816,7,69821,69821,1,69837,69837,1,69927,69931,5,69933,69940,5,70003,70003,5,70018,70018,7,70070,70078,5,70082,70083,1,70094,70094,7,70188,70190,7,70194,70195,7,70197,70197,7,70206,70206,5,70368,70370,7,70400,70401,5,70459,70460,5,70463,70463,7,70465,70468,7,70475,70477,7,70498,70499,7,70512,70516,5,70712,70719,5,70722,70724,5,70726,70726,5,70832,70832,5,70835,70840,5,70842,70842,5,70845,70845,5,70847,70848,5,70850,70851,5,71088,71089,7,71096,71099,7,71102,71102,7,71132,71133,5,71219,71226,5,71229,71229,5,71231,71232,5,71340,71340,7,71342,71343,7,71350,71350,7,71453,71455,5,71462,71462,7,71724,71726,7,71736,71736,7,71984,71984,5,71991,71992,7,71997,71997,7,71999,71999,1,72001,72001,1,72003,72003,5,72148,72151,5,72156,72159,7,72164,72164,7,72243,72248,5,72250,72250,1,72263,72263,5,72279,72280,7,72324,72329,1,72343,72343,7,72751,72751,7,72760,72765,5,72767,72767,5,72873,72873,7,72881,72881,7,72884,72884,7,73009,73014,5,73020,73021,5,73030,73030,1,73098,73102,7,73107,73108,7,73110,73110,7,73459,73460,5,78896,78904,4,92976,92982,5,94033,94087,7,94180,94180,5,113821,113822,5,118528,118573,5,119141,119141,5,119143,119145,5,119150,119154,5,119163,119170,5,119210,119213,5,121344,121398,5,121461,121461,5,121499,121503,5,122880,122886,5,122907,122913,5,122918,122922,5,123566,123566,5,125136,125142,5,126976,126979,14,126981,127182,14,127184,127231,14,127279,127279,14,127344,127345,14,127374,127374,14,127405,127461,14,127489,127490,14,127514,127514,14,127538,127546,14,127561,127567,14,127570,127743,14,127757,127758,14,127760,127760,14,127762,127762,14,127766,127768,14,127770,127770,14,127772,127772,14,127775,127776,14,127778,127779,14,127789,127791,14,127794,127795,14,127798,127798,14,127819,127819,14,127824,127824,14,127868,127868,14,127870,127871,14,127892,127893,14,127896,127896,14,127900,127901,14,127904,127940,14,127942,127942,14,127944,127944,14,127946,127946,14,127951,127955,14,127968,127971,14,127973,127984,14,127987,127987,14,127989,127989,14,127991,127991,14,127995,127999,5,128008,128008,14,128012,128014,14,128017,128018,14,128020,128020,14,128022,128022,14,128042,128042,14,128063,128063,14,128065,128065,14,128101,128101,14,128108,128109,14,128173,128173,14,128182,128183,14,128236,128237,14,128239,128239,14,128245,128245,14,128248,128248,14,128253,128253,14,128255,128258,14,128260,128263,14,128265,128265,14,128277,128277,14,128300,128301,14,128326,128328,14,128331,128334,14,128336,128347,14,128360,128366,14,128369,128370,14,128378,128378,14,128391,128391,14,128394,128397,14,128400,128400,14,128405,128406,14,128420,128420,14,128422,128423,14,128425,128432,14,128435,128443,14,128445,128449,14,128453,128464,14,128468,128475,14,128479,128480,14,128482,128482,14,128484,128487,14,128489,128494,14,128496,128498,14,128500,128505,14,128507,128511,14,128513,128518,14,128521,128525,14,128527,128527,14,128529,128529,14,128533,128533,14,128535,128535,14,128537,128537,14]");
  }
  getGraphemeBreakType(e) {
    if (e < 32) return e === 10 ? 3 : e === 13 ? 2 : 4;
    if (e < 127) return 0;
    const t = this._data, n = t.length / 3;
    let s = 1;
    for (; s <= n; ) if (e < t[3 * s]) s *= 2;
    else {
      if (!(e > t[3 * s + 1])) return t[3 * s + 2];
      s = 2 * s + 1;
    }
    return 0;
  }
}
function IK(i, e) {
  if (i === 0) return 0;
  const t = function(s, o) {
    const r = new LE(o, s);
    let a = r.prevCodePoint();
    for (; MK(a) || a === 65039 || a === 8419; ) {
      if (r.offset === 0) return;
      a = r.prevCodePoint();
    }
    if (!lR(a)) return;
    let l = r.offset;
    return l > 0 && r.prevCodePoint() === 8205 && (l = r.offset), l;
  }(i, e);
  if (t !== void 0) return t;
  const n = new LE(e, i);
  return n.prevCodePoint(), n.offset;
}
function MK(i) {
  return 127995 <= i && i <= 127999;
}
Ih._INSTANCE = null;
class Nu {
  static getInstance(e) {
    return kp.cache.get(Array.from(e));
  }
  static getLocales() {
    return kp._locales.value;
  }
  constructor(e) {
    this.confusableDictionary = e;
  }
  isAmbiguous(e) {
    return this.confusableDictionary.has(e);
  }
  getPrimaryConfusable(e) {
    return this.confusableDictionary.get(e);
  }
  getConfusableCodePoints() {
    return new Set(this.confusableDictionary.keys());
  }
}
kp = Nu, Nu.ambiguousCharacterData = new ga(() => JSON.parse('{"_common":[8232,32,8233,32,5760,32,8192,32,8193,32,8194,32,8195,32,8196,32,8197,32,8198,32,8200,32,8201,32,8202,32,8287,32,8199,32,8239,32,2042,95,65101,95,65102,95,65103,95,8208,45,8209,45,8210,45,65112,45,1748,45,8259,45,727,45,8722,45,10134,45,11450,45,1549,44,1643,44,8218,44,184,44,42233,44,894,59,2307,58,2691,58,1417,58,1795,58,1796,58,5868,58,65072,58,6147,58,6153,58,8282,58,1475,58,760,58,42889,58,8758,58,720,58,42237,58,451,33,11601,33,660,63,577,63,2429,63,5038,63,42731,63,119149,46,8228,46,1793,46,1794,46,42510,46,68176,46,1632,46,1776,46,42232,46,1373,96,65287,96,8219,96,8242,96,1370,96,1523,96,8175,96,65344,96,900,96,8189,96,8125,96,8127,96,8190,96,697,96,884,96,712,96,714,96,715,96,756,96,699,96,701,96,700,96,702,96,42892,96,1497,96,2036,96,2037,96,5194,96,5836,96,94033,96,94034,96,65339,91,10088,40,10098,40,12308,40,64830,40,65341,93,10089,41,10099,41,12309,41,64831,41,10100,123,119060,123,10101,125,65342,94,8270,42,1645,42,8727,42,66335,42,5941,47,8257,47,8725,47,8260,47,9585,47,10187,47,10744,47,119354,47,12755,47,12339,47,11462,47,20031,47,12035,47,65340,92,65128,92,8726,92,10189,92,10741,92,10745,92,119311,92,119355,92,12756,92,20022,92,12034,92,42872,38,708,94,710,94,5869,43,10133,43,66203,43,8249,60,10094,60,706,60,119350,60,5176,60,5810,60,5120,61,11840,61,12448,61,42239,61,8250,62,10095,62,707,62,119351,62,5171,62,94015,62,8275,126,732,126,8128,126,8764,126,65372,124,65293,45,120784,50,120794,50,120804,50,120814,50,120824,50,130034,50,42842,50,423,50,1000,50,42564,50,5311,50,42735,50,119302,51,120785,51,120795,51,120805,51,120815,51,120825,51,130035,51,42923,51,540,51,439,51,42858,51,11468,51,1248,51,94011,51,71882,51,120786,52,120796,52,120806,52,120816,52,120826,52,130036,52,5070,52,71855,52,120787,53,120797,53,120807,53,120817,53,120827,53,130037,53,444,53,71867,53,120788,54,120798,54,120808,54,120818,54,120828,54,130038,54,11474,54,5102,54,71893,54,119314,55,120789,55,120799,55,120809,55,120819,55,120829,55,130039,55,66770,55,71878,55,2819,56,2538,56,2666,56,125131,56,120790,56,120800,56,120810,56,120820,56,120830,56,130040,56,547,56,546,56,66330,56,2663,57,2920,57,2541,57,3437,57,120791,57,120801,57,120811,57,120821,57,120831,57,130041,57,42862,57,11466,57,71884,57,71852,57,71894,57,9082,97,65345,97,119834,97,119886,97,119938,97,119990,97,120042,97,120094,97,120146,97,120198,97,120250,97,120302,97,120354,97,120406,97,120458,97,593,97,945,97,120514,97,120572,97,120630,97,120688,97,120746,97,65313,65,119808,65,119860,65,119912,65,119964,65,120016,65,120068,65,120120,65,120172,65,120224,65,120276,65,120328,65,120380,65,120432,65,913,65,120488,65,120546,65,120604,65,120662,65,120720,65,5034,65,5573,65,42222,65,94016,65,66208,65,119835,98,119887,98,119939,98,119991,98,120043,98,120095,98,120147,98,120199,98,120251,98,120303,98,120355,98,120407,98,120459,98,388,98,5071,98,5234,98,5551,98,65314,66,8492,66,119809,66,119861,66,119913,66,120017,66,120069,66,120121,66,120173,66,120225,66,120277,66,120329,66,120381,66,120433,66,42932,66,914,66,120489,66,120547,66,120605,66,120663,66,120721,66,5108,66,5623,66,42192,66,66178,66,66209,66,66305,66,65347,99,8573,99,119836,99,119888,99,119940,99,119992,99,120044,99,120096,99,120148,99,120200,99,120252,99,120304,99,120356,99,120408,99,120460,99,7428,99,1010,99,11429,99,43951,99,66621,99,128844,67,71922,67,71913,67,65315,67,8557,67,8450,67,8493,67,119810,67,119862,67,119914,67,119966,67,120018,67,120174,67,120226,67,120278,67,120330,67,120382,67,120434,67,1017,67,11428,67,5087,67,42202,67,66210,67,66306,67,66581,67,66844,67,8574,100,8518,100,119837,100,119889,100,119941,100,119993,100,120045,100,120097,100,120149,100,120201,100,120253,100,120305,100,120357,100,120409,100,120461,100,1281,100,5095,100,5231,100,42194,100,8558,68,8517,68,119811,68,119863,68,119915,68,119967,68,120019,68,120071,68,120123,68,120175,68,120227,68,120279,68,120331,68,120383,68,120435,68,5024,68,5598,68,5610,68,42195,68,8494,101,65349,101,8495,101,8519,101,119838,101,119890,101,119942,101,120046,101,120098,101,120150,101,120202,101,120254,101,120306,101,120358,101,120410,101,120462,101,43826,101,1213,101,8959,69,65317,69,8496,69,119812,69,119864,69,119916,69,120020,69,120072,69,120124,69,120176,69,120228,69,120280,69,120332,69,120384,69,120436,69,917,69,120492,69,120550,69,120608,69,120666,69,120724,69,11577,69,5036,69,42224,69,71846,69,71854,69,66182,69,119839,102,119891,102,119943,102,119995,102,120047,102,120099,102,120151,102,120203,102,120255,102,120307,102,120359,102,120411,102,120463,102,43829,102,42905,102,383,102,7837,102,1412,102,119315,70,8497,70,119813,70,119865,70,119917,70,120021,70,120073,70,120125,70,120177,70,120229,70,120281,70,120333,70,120385,70,120437,70,42904,70,988,70,120778,70,5556,70,42205,70,71874,70,71842,70,66183,70,66213,70,66853,70,65351,103,8458,103,119840,103,119892,103,119944,103,120048,103,120100,103,120152,103,120204,103,120256,103,120308,103,120360,103,120412,103,120464,103,609,103,7555,103,397,103,1409,103,119814,71,119866,71,119918,71,119970,71,120022,71,120074,71,120126,71,120178,71,120230,71,120282,71,120334,71,120386,71,120438,71,1292,71,5056,71,5107,71,42198,71,65352,104,8462,104,119841,104,119945,104,119997,104,120049,104,120101,104,120153,104,120205,104,120257,104,120309,104,120361,104,120413,104,120465,104,1211,104,1392,104,5058,104,65320,72,8459,72,8460,72,8461,72,119815,72,119867,72,119919,72,120023,72,120179,72,120231,72,120283,72,120335,72,120387,72,120439,72,919,72,120494,72,120552,72,120610,72,120668,72,120726,72,11406,72,5051,72,5500,72,42215,72,66255,72,731,105,9075,105,65353,105,8560,105,8505,105,8520,105,119842,105,119894,105,119946,105,119998,105,120050,105,120102,105,120154,105,120206,105,120258,105,120310,105,120362,105,120414,105,120466,105,120484,105,618,105,617,105,953,105,8126,105,890,105,120522,105,120580,105,120638,105,120696,105,120754,105,1110,105,42567,105,1231,105,43893,105,5029,105,71875,105,65354,106,8521,106,119843,106,119895,106,119947,106,119999,106,120051,106,120103,106,120155,106,120207,106,120259,106,120311,106,120363,106,120415,106,120467,106,1011,106,1112,106,65322,74,119817,74,119869,74,119921,74,119973,74,120025,74,120077,74,120129,74,120181,74,120233,74,120285,74,120337,74,120389,74,120441,74,42930,74,895,74,1032,74,5035,74,5261,74,42201,74,119844,107,119896,107,119948,107,120000,107,120052,107,120104,107,120156,107,120208,107,120260,107,120312,107,120364,107,120416,107,120468,107,8490,75,65323,75,119818,75,119870,75,119922,75,119974,75,120026,75,120078,75,120130,75,120182,75,120234,75,120286,75,120338,75,120390,75,120442,75,922,75,120497,75,120555,75,120613,75,120671,75,120729,75,11412,75,5094,75,5845,75,42199,75,66840,75,1472,108,8739,73,9213,73,65512,73,1633,108,1777,73,66336,108,125127,108,120783,73,120793,73,120803,73,120813,73,120823,73,130033,73,65321,73,8544,73,8464,73,8465,73,119816,73,119868,73,119920,73,120024,73,120128,73,120180,73,120232,73,120284,73,120336,73,120388,73,120440,73,65356,108,8572,73,8467,108,119845,108,119897,108,119949,108,120001,108,120053,108,120105,73,120157,73,120209,73,120261,73,120313,73,120365,73,120417,73,120469,73,448,73,120496,73,120554,73,120612,73,120670,73,120728,73,11410,73,1030,73,1216,73,1493,108,1503,108,1575,108,126464,108,126592,108,65166,108,65165,108,1994,108,11599,73,5825,73,42226,73,93992,73,66186,124,66313,124,119338,76,8556,76,8466,76,119819,76,119871,76,119923,76,120027,76,120079,76,120131,76,120183,76,120235,76,120287,76,120339,76,120391,76,120443,76,11472,76,5086,76,5290,76,42209,76,93974,76,71843,76,71858,76,66587,76,66854,76,65325,77,8559,77,8499,77,119820,77,119872,77,119924,77,120028,77,120080,77,120132,77,120184,77,120236,77,120288,77,120340,77,120392,77,120444,77,924,77,120499,77,120557,77,120615,77,120673,77,120731,77,1018,77,11416,77,5047,77,5616,77,5846,77,42207,77,66224,77,66321,77,119847,110,119899,110,119951,110,120003,110,120055,110,120107,110,120159,110,120211,110,120263,110,120315,110,120367,110,120419,110,120471,110,1400,110,1404,110,65326,78,8469,78,119821,78,119873,78,119925,78,119977,78,120029,78,120081,78,120185,78,120237,78,120289,78,120341,78,120393,78,120445,78,925,78,120500,78,120558,78,120616,78,120674,78,120732,78,11418,78,42208,78,66835,78,3074,111,3202,111,3330,111,3458,111,2406,111,2662,111,2790,111,3046,111,3174,111,3302,111,3430,111,3664,111,3792,111,4160,111,1637,111,1781,111,65359,111,8500,111,119848,111,119900,111,119952,111,120056,111,120108,111,120160,111,120212,111,120264,111,120316,111,120368,111,120420,111,120472,111,7439,111,7441,111,43837,111,959,111,120528,111,120586,111,120644,111,120702,111,120760,111,963,111,120532,111,120590,111,120648,111,120706,111,120764,111,11423,111,4351,111,1413,111,1505,111,1607,111,126500,111,126564,111,126596,111,65259,111,65260,111,65258,111,65257,111,1726,111,64428,111,64429,111,64427,111,64426,111,1729,111,64424,111,64425,111,64423,111,64422,111,1749,111,3360,111,4125,111,66794,111,71880,111,71895,111,66604,111,1984,79,2534,79,2918,79,12295,79,70864,79,71904,79,120782,79,120792,79,120802,79,120812,79,120822,79,130032,79,65327,79,119822,79,119874,79,119926,79,119978,79,120030,79,120082,79,120134,79,120186,79,120238,79,120290,79,120342,79,120394,79,120446,79,927,79,120502,79,120560,79,120618,79,120676,79,120734,79,11422,79,1365,79,11604,79,4816,79,2848,79,66754,79,42227,79,71861,79,66194,79,66219,79,66564,79,66838,79,9076,112,65360,112,119849,112,119901,112,119953,112,120005,112,120057,112,120109,112,120161,112,120213,112,120265,112,120317,112,120369,112,120421,112,120473,112,961,112,120530,112,120544,112,120588,112,120602,112,120646,112,120660,112,120704,112,120718,112,120762,112,120776,112,11427,112,65328,80,8473,80,119823,80,119875,80,119927,80,119979,80,120031,80,120083,80,120187,80,120239,80,120291,80,120343,80,120395,80,120447,80,929,80,120504,80,120562,80,120620,80,120678,80,120736,80,11426,80,5090,80,5229,80,42193,80,66197,80,119850,113,119902,113,119954,113,120006,113,120058,113,120110,113,120162,113,120214,113,120266,113,120318,113,120370,113,120422,113,120474,113,1307,113,1379,113,1382,113,8474,81,119824,81,119876,81,119928,81,119980,81,120032,81,120084,81,120188,81,120240,81,120292,81,120344,81,120396,81,120448,81,11605,81,119851,114,119903,114,119955,114,120007,114,120059,114,120111,114,120163,114,120215,114,120267,114,120319,114,120371,114,120423,114,120475,114,43847,114,43848,114,7462,114,11397,114,43905,114,119318,82,8475,82,8476,82,8477,82,119825,82,119877,82,119929,82,120033,82,120189,82,120241,82,120293,82,120345,82,120397,82,120449,82,422,82,5025,82,5074,82,66740,82,5511,82,42211,82,94005,82,65363,115,119852,115,119904,115,119956,115,120008,115,120060,115,120112,115,120164,115,120216,115,120268,115,120320,115,120372,115,120424,115,120476,115,42801,115,445,115,1109,115,43946,115,71873,115,66632,115,65331,83,119826,83,119878,83,119930,83,119982,83,120034,83,120086,83,120138,83,120190,83,120242,83,120294,83,120346,83,120398,83,120450,83,1029,83,1359,83,5077,83,5082,83,42210,83,94010,83,66198,83,66592,83,119853,116,119905,116,119957,116,120009,116,120061,116,120113,116,120165,116,120217,116,120269,116,120321,116,120373,116,120425,116,120477,116,8868,84,10201,84,128872,84,65332,84,119827,84,119879,84,119931,84,119983,84,120035,84,120087,84,120139,84,120191,84,120243,84,120295,84,120347,84,120399,84,120451,84,932,84,120507,84,120565,84,120623,84,120681,84,120739,84,11430,84,5026,84,42196,84,93962,84,71868,84,66199,84,66225,84,66325,84,119854,117,119906,117,119958,117,120010,117,120062,117,120114,117,120166,117,120218,117,120270,117,120322,117,120374,117,120426,117,120478,117,42911,117,7452,117,43854,117,43858,117,651,117,965,117,120534,117,120592,117,120650,117,120708,117,120766,117,1405,117,66806,117,71896,117,8746,85,8899,85,119828,85,119880,85,119932,85,119984,85,120036,85,120088,85,120140,85,120192,85,120244,85,120296,85,120348,85,120400,85,120452,85,1357,85,4608,85,66766,85,5196,85,42228,85,94018,85,71864,85,8744,118,8897,118,65366,118,8564,118,119855,118,119907,118,119959,118,120011,118,120063,118,120115,118,120167,118,120219,118,120271,118,120323,118,120375,118,120427,118,120479,118,7456,118,957,118,120526,118,120584,118,120642,118,120700,118,120758,118,1141,118,1496,118,71430,118,43945,118,71872,118,119309,86,1639,86,1783,86,8548,86,119829,86,119881,86,119933,86,119985,86,120037,86,120089,86,120141,86,120193,86,120245,86,120297,86,120349,86,120401,86,120453,86,1140,86,11576,86,5081,86,5167,86,42719,86,42214,86,93960,86,71840,86,66845,86,623,119,119856,119,119908,119,119960,119,120012,119,120064,119,120116,119,120168,119,120220,119,120272,119,120324,119,120376,119,120428,119,120480,119,7457,119,1121,119,1309,119,1377,119,71434,119,71438,119,71439,119,43907,119,71919,87,71910,87,119830,87,119882,87,119934,87,119986,87,120038,87,120090,87,120142,87,120194,87,120246,87,120298,87,120350,87,120402,87,120454,87,1308,87,5043,87,5076,87,42218,87,5742,120,10539,120,10540,120,10799,120,65368,120,8569,120,119857,120,119909,120,119961,120,120013,120,120065,120,120117,120,120169,120,120221,120,120273,120,120325,120,120377,120,120429,120,120481,120,5441,120,5501,120,5741,88,9587,88,66338,88,71916,88,65336,88,8553,88,119831,88,119883,88,119935,88,119987,88,120039,88,120091,88,120143,88,120195,88,120247,88,120299,88,120351,88,120403,88,120455,88,42931,88,935,88,120510,88,120568,88,120626,88,120684,88,120742,88,11436,88,11613,88,5815,88,42219,88,66192,88,66228,88,66327,88,66855,88,611,121,7564,121,65369,121,119858,121,119910,121,119962,121,120014,121,120066,121,120118,121,120170,121,120222,121,120274,121,120326,121,120378,121,120430,121,120482,121,655,121,7935,121,43866,121,947,121,8509,121,120516,121,120574,121,120632,121,120690,121,120748,121,1199,121,4327,121,71900,121,65337,89,119832,89,119884,89,119936,89,119988,89,120040,89,120092,89,120144,89,120196,89,120248,89,120300,89,120352,89,120404,89,120456,89,933,89,978,89,120508,89,120566,89,120624,89,120682,89,120740,89,11432,89,1198,89,5033,89,5053,89,42220,89,94019,89,71844,89,66226,89,119859,122,119911,122,119963,122,120015,122,120067,122,120119,122,120171,122,120223,122,120275,122,120327,122,120379,122,120431,122,120483,122,7458,122,43923,122,71876,122,66293,90,71909,90,65338,90,8484,90,8488,90,119833,90,119885,90,119937,90,119989,90,120041,90,120197,90,120249,90,120301,90,120353,90,120405,90,120457,90,918,90,120493,90,120551,90,120609,90,120667,90,120725,90,5059,90,42204,90,71849,90,65282,34,65284,36,65285,37,65286,38,65290,42,65291,43,65294,46,65295,47,65296,48,65297,49,65298,50,65299,51,65300,52,65301,53,65302,54,65303,55,65304,56,65305,57,65308,60,65309,61,65310,62,65312,64,65316,68,65318,70,65319,71,65324,76,65329,81,65330,82,65333,85,65334,86,65335,87,65343,95,65346,98,65348,100,65350,102,65355,107,65357,109,65358,110,65361,113,65362,114,65364,116,65365,117,65367,119,65370,122,65371,123,65373,125,119846,109],"_default":[160,32,8211,45,65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"cs":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"de":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"es":[8211,45,65374,126,65306,58,65281,33,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"fr":[65374,126,65306,58,65281,33,8216,96,8245,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"it":[160,32,8211,45,65374,126,65306,58,65281,33,8216,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"ja":[8211,45,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65292,44,65307,59],"ko":[8211,45,65374,126,65306,58,65281,33,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"pl":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"pt-BR":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"qps-ploc":[160,32,8211,45,65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"ru":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,305,105,921,73,1009,112,215,120,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"tr":[160,32,8211,45,65374,126,65306,58,65281,33,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"zh-hans":[65374,126,65306,58,65281,33,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65288,40,65289,41],"zh-hant":[8211,45,65374,126,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65307,59]}')), Nu.cache = new class {
  constructor(i, e = JSON.stringify) {
    this.fn = i, this._computeKey = e, this.lastCache = void 0, this.lastArgKey = void 0;
  }
  get(i) {
    const e = this._computeKey(i);
    return this.lastArgKey !== e && (this.lastArgKey = e, this.lastCache = this.fn(i)), this.lastCache;
  }
}((i) => {
  function e(a) {
    const l = /* @__PURE__ */ new Map();
    for (let d = 0; d < a.length; d += 2) l.set(a[d], a[d + 1]);
    return l;
  }
  function t(a, l) {
    if (!a) return l;
    const d = /* @__PURE__ */ new Map();
    for (const [h, c] of a) l.has(h) && d.set(h, c);
    return d;
  }
  const n = kp.ambiguousCharacterData.value;
  let s, o = i.filter((a) => !a.startsWith("_") && a in n);
  o.length === 0 && (o = ["_default"]);
  for (const a of o)
    s = t(s, e(n[a]));
  const r = function(a, l) {
    const d = new Map(a);
    for (const [h, c] of l) d.set(h, c);
    return d;
  }(e(n._common), s);
  return new kp(r);
}), Nu._locales = new ga(() => Object.keys(kp.ambiguousCharacterData.value).filter((i) => !i.startsWith("_")));
class gl {
  static getRawData() {
    return JSON.parse("[9,10,11,12,13,32,127,160,173,847,1564,4447,4448,6068,6069,6155,6156,6157,6158,7355,7356,8192,8193,8194,8195,8196,8197,8198,8199,8200,8201,8202,8203,8204,8205,8206,8207,8234,8235,8236,8237,8238,8239,8287,8288,8289,8290,8291,8292,8293,8294,8295,8296,8297,8298,8299,8300,8301,8302,8303,10240,12288,12644,65024,65025,65026,65027,65028,65029,65030,65031,65032,65033,65034,65035,65036,65037,65038,65039,65279,65440,65520,65521,65522,65523,65524,65525,65526,65527,65528,65532,78844,119155,119156,119157,119158,119159,119160,119161,119162,917504,917505,917506,917507,917508,917509,917510,917511,917512,917513,917514,917515,917516,917517,917518,917519,917520,917521,917522,917523,917524,917525,917526,917527,917528,917529,917530,917531,917532,917533,917534,917535,917536,917537,917538,917539,917540,917541,917542,917543,917544,917545,917546,917547,917548,917549,917550,917551,917552,917553,917554,917555,917556,917557,917558,917559,917560,917561,917562,917563,917564,917565,917566,917567,917568,917569,917570,917571,917572,917573,917574,917575,917576,917577,917578,917579,917580,917581,917582,917583,917584,917585,917586,917587,917588,917589,917590,917591,917592,917593,917594,917595,917596,917597,917598,917599,917600,917601,917602,917603,917604,917605,917606,917607,917608,917609,917610,917611,917612,917613,917614,917615,917616,917617,917618,917619,917620,917621,917622,917623,917624,917625,917626,917627,917628,917629,917630,917631,917760,917761,917762,917763,917764,917765,917766,917767,917768,917769,917770,917771,917772,917773,917774,917775,917776,917777,917778,917779,917780,917781,917782,917783,917784,917785,917786,917787,917788,917789,917790,917791,917792,917793,917794,917795,917796,917797,917798,917799,917800,917801,917802,917803,917804,917805,917806,917807,917808,917809,917810,917811,917812,917813,917814,917815,917816,917817,917818,917819,917820,917821,917822,917823,917824,917825,917826,917827,917828,917829,917830,917831,917832,917833,917834,917835,917836,917837,917838,917839,917840,917841,917842,917843,917844,917845,917846,917847,917848,917849,917850,917851,917852,917853,917854,917855,917856,917857,917858,917859,917860,917861,917862,917863,917864,917865,917866,917867,917868,917869,917870,917871,917872,917873,917874,917875,917876,917877,917878,917879,917880,917881,917882,917883,917884,917885,917886,917887,917888,917889,917890,917891,917892,917893,917894,917895,917896,917897,917898,917899,917900,917901,917902,917903,917904,917905,917906,917907,917908,917909,917910,917911,917912,917913,917914,917915,917916,917917,917918,917919,917920,917921,917922,917923,917924,917925,917926,917927,917928,917929,917930,917931,917932,917933,917934,917935,917936,917937,917938,917939,917940,917941,917942,917943,917944,917945,917946,917947,917948,917949,917950,917951,917952,917953,917954,917955,917956,917957,917958,917959,917960,917961,917962,917963,917964,917965,917966,917967,917968,917969,917970,917971,917972,917973,917974,917975,917976,917977,917978,917979,917980,917981,917982,917983,917984,917985,917986,917987,917988,917989,917990,917991,917992,917993,917994,917995,917996,917997,917998,917999]");
  }
  static getData() {
    return this._data || (this._data = new Set(gl.getRawData())), this._data;
  }
  static isInvisibleCharacter(e) {
    return gl.getData().has(e);
  }
  static get codePoints() {
    return gl.getData();
  }
}
gl._data = void 0;
class kE {
  constructor() {
    this.mapWindowIdToZoomFactor = /* @__PURE__ */ new Map();
  }
  getZoomFactor(e) {
    var t;
    return (t = this.mapWindowIdToZoomFactor.get(this.getWindowId(e))) !== null && t !== void 0 ? t : 1;
  }
  getWindowId(e) {
    return e.vscodeWindowId;
  }
}
function s8(i, e, t) {
  typeof e == "string" && (e = i.matchMedia(e)), e.addEventListener("change", t);
}
kE.INSTANCE = new kE();
const uf = navigator.userAgent, tr = uf.indexOf("Firefox") >= 0, Uu = uf.indexOf("AppleWebKit") >= 0, _1 = uf.indexOf("Chrome") >= 0, vc = !_1 && uf.indexOf("Safari") >= 0, o8 = !_1 && !vc && Uu;
uf.indexOf("Electron/");
const dO = uf.indexOf("Android") >= 0;
let IC = !1;
if (typeof Et.matchMedia == "function") {
  const i = Et.matchMedia("(display-mode: standalone) or (display-mode: window-controls-overlay)"), e = Et.matchMedia("(display-mode: fullscreen)");
  IC = i.matches, s8(Et, i, ({ matches: t }) => {
    IC && e.matches || (IC = t);
  });
}
sa || document.queryCommandSupported && document.queryCommandSupported("copy") || navigator && navigator.clipboard && navigator.clipboard.writeText, sa || navigator && navigator.clipboard && navigator.clipboard.readText, sa || IC || navigator.keyboard, "ontouchstart" in Et || navigator.maxTouchPoints;
const hR = Et.PointerEvent && ("ontouchstart" in Et || navigator.maxTouchPoints > 0);
function DE(i, e) {
  if (typeof i == "number") {
    if (i === 0) return null;
    const t = (65535 & i) >>> 0, n = (4294901760 & i) >>> 16;
    return new hO(n !== 0 ? [J1(t, e), J1(n, e)] : [J1(t, e)]);
  }
  {
    const t = [];
    for (let n = 0; n < i.length; n++) t.push(J1(i[n], e));
    return new hO(t);
  }
}
function J1(i, e) {
  const t = !!(2048 & i), n = !!(256 & i);
  return new Od(e === 2 ? n : t, !!(1024 & i), !!(512 & i), e === 2 ? t : n, 255 & i);
}
class Od {
  constructor(e, t, n, s, o) {
    this.ctrlKey = e, this.shiftKey = t, this.altKey = n, this.metaKey = s, this.keyCode = o;
  }
  equals(e) {
    return e instanceof Od && this.ctrlKey === e.ctrlKey && this.shiftKey === e.shiftKey && this.altKey === e.altKey && this.metaKey === e.metaKey && this.keyCode === e.keyCode;
  }
  isModifierKey() {
    return this.keyCode === 0 || this.keyCode === 5 || this.keyCode === 57 || this.keyCode === 6 || this.keyCode === 4;
  }
  isDuplicateModifierCase() {
    return this.ctrlKey && this.keyCode === 5 || this.shiftKey && this.keyCode === 4 || this.altKey && this.keyCode === 6 || this.metaKey && this.keyCode === 57;
  }
}
class hO {
  constructor(e) {
    if (e.length === 0) throw Yo("chords");
    this.chords = e;
  }
}
class TK {
  constructor(e, t, n, s, o, r) {
    this.ctrlKey = e, this.shiftKey = t, this.altKey = n, this.metaKey = s, this.keyLabel = o, this.keyAriaLabel = r;
  }
}
class RK {
}
const AK = Je ? 256 : 2048, PK = Je ? 2048 : 256;
class jt {
  constructor(e) {
    var t;
    this._standardKeyboardEventBrand = !0;
    const n = e;
    this.browserEvent = n, this.target = n.target, this.ctrlKey = n.ctrlKey, this.shiftKey = n.shiftKey, this.altKey = n.altKey, this.metaKey = n.metaKey, this.altGraphKey = (t = n.getModifierState) === null || t === void 0 ? void 0 : t.call(n, "AltGraph"), this.keyCode = function(s) {
      if (s.charCode) {
        const r = String.fromCharCode(s.charCode).toUpperCase();
        return Yl.fromString(r);
      }
      const o = s.keyCode;
      if (o === 3) return 7;
      if (tr) switch (o) {
        case 59:
          return 85;
        case 60:
          if (Cs) return 97;
          break;
        case 61:
          return 86;
        case 107:
          return 109;
        case 109:
          return 111;
        case 173:
          return 88;
        case 224:
          if (Je) return 57;
      }
      else if (Uu && (Je && o === 93 || !Je && o === 92))
        return 57;
      return V7[o] || 0;
    }(n), this.code = n.code, this.ctrlKey = this.ctrlKey || this.keyCode === 5, this.altKey = this.altKey || this.keyCode === 6, this.shiftKey = this.shiftKey || this.keyCode === 4, this.metaKey = this.metaKey || this.keyCode === 57, this._asKeybinding = this._computeKeybinding(), this._asKeyCodeChord = this._computeKeyCodeChord();
  }
  preventDefault() {
    this.browserEvent && this.browserEvent.preventDefault && this.browserEvent.preventDefault();
  }
  stopPropagation() {
    this.browserEvent && this.browserEvent.stopPropagation && this.browserEvent.stopPropagation();
  }
  toKeyCodeChord() {
    return this._asKeyCodeChord;
  }
  equals(e) {
    return this._asKeybinding === e;
  }
  _computeKeybinding() {
    let e = 0;
    this.keyCode !== 5 && this.keyCode !== 4 && this.keyCode !== 6 && this.keyCode !== 57 && (e = this.keyCode);
    let t = 0;
    return this.ctrlKey && (t |= AK), this.altKey && (t |= 512), this.shiftKey && (t |= 1024), this.metaKey && (t |= PK), t |= e, t;
  }
  _computeKeyCodeChord() {
    let e = 0;
    return this.keyCode !== 5 && this.keyCode !== 4 && this.keyCode !== 6 && this.keyCode !== 57 && (e = this.keyCode), new Od(this.ctrlKey, this.shiftKey, this.altKey, this.metaKey, e);
  }
}
const cO = /* @__PURE__ */ new WeakMap();
function OK(i) {
  if (!i.parent || i.parent === i) return null;
  try {
    const e = i.location, t = i.parent.location;
    if (e.origin !== "null" && t.origin !== "null" && e.origin !== t.origin) return null;
  } catch {
    return null;
  }
  return i.parent;
}
class FK {
  static getSameOriginWindowChain(e) {
    let t = cO.get(e);
    if (!t) {
      t = [], cO.set(e, t);
      let n, s = e;
      do
        n = OK(s), n ? t.push({ window: new WeakRef(s), iframeElement: s.frameElement || null }) : t.push({ window: new WeakRef(s), iframeElement: null }), s = n;
      while (s);
    }
    return t.slice(0);
  }
  static getPositionOfChildWindowRelativeToAncestorWindow(e, t) {
    var n, s;
    if (!t || e === t) return { top: 0, left: 0 };
    let o = 0, r = 0;
    const a = this.getSameOriginWindowChain(e);
    for (const l of a) {
      const d = l.window.deref();
      if (o += (n = d == null ? void 0 : d.scrollY) !== null && n !== void 0 ? n : 0, r += (s = d == null ? void 0 : d.scrollX) !== null && s !== void 0 ? s : 0, d === t || !l.iframeElement) break;
      const h = l.iframeElement.getBoundingClientRect();
      o += h.top, r += h.left;
    }
    return { top: o, left: r };
  }
}
class _r {
  constructor(e, t) {
    this.timestamp = Date.now(), this.browserEvent = t, this.leftButton = t.button === 0, this.middleButton = t.button === 1, this.rightButton = t.button === 2, this.buttons = t.buttons, this.target = t.target, this.detail = t.detail || 1, t.type === "dblclick" && (this.detail = 2), this.ctrlKey = t.ctrlKey, this.shiftKey = t.shiftKey, this.altKey = t.altKey, this.metaKey = t.metaKey, typeof t.pageX == "number" ? (this.posx = t.pageX, this.posy = t.pageY) : (this.posx = t.clientX + this.target.ownerDocument.body.scrollLeft + this.target.ownerDocument.documentElement.scrollLeft, this.posy = t.clientY + this.target.ownerDocument.body.scrollTop + this.target.ownerDocument.documentElement.scrollTop);
    const n = FK.getPositionOfChildWindowRelativeToAncestorWindow(e, t.view);
    this.posx -= n.left, this.posy -= n.top;
  }
  preventDefault() {
    this.browserEvent.preventDefault();
  }
  stopPropagation() {
    this.browserEvent.stopPropagation();
  }
}
class lg {
  constructor(e, t = 0, n = 0) {
    var s;
    this.browserEvent = e || null, this.target = e ? e.target || e.targetNode || e.srcElement : null, this.deltaY = n, this.deltaX = t;
    let o = !1;
    if (_1) {
      const r = navigator.userAgent.match(/Chrome\/(\d+)/);
      o = (r ? parseInt(r[1]) : 123) <= 122;
    }
    if (e) {
      const r = e, a = e, l = ((s = e.view) === null || s === void 0 ? void 0 : s.devicePixelRatio) || 1;
      if (r.wheelDeltaY !== void 0) this.deltaY = o ? r.wheelDeltaY / (120 * l) : r.wheelDeltaY / 120;
      else if (a.VERTICAL_AXIS !== void 0 && a.axis === a.VERTICAL_AXIS) this.deltaY = -a.detail / 3;
      else if (e.type === "wheel") {
        const d = e;
        d.deltaMode === d.DOM_DELTA_LINE ? this.deltaY = tr && !Je ? -e.deltaY / 3 : -e.deltaY : this.deltaY = -e.deltaY / 40;
      }
      if (r.wheelDeltaX !== void 0) this.deltaX = vc && Tn ? -r.wheelDeltaX / 120 : o ? r.wheelDeltaX / (120 * l) : r.wheelDeltaX / 120;
      else if (a.HORIZONTAL_AXIS !== void 0 && a.axis === a.HORIZONTAL_AXIS) this.deltaX = -e.detail / 3;
      else if (e.type === "wheel") {
        const d = e;
        d.deltaMode === d.DOM_DELTA_LINE ? this.deltaX = tr && !Je ? -e.deltaX / 3 : -e.deltaX : this.deltaX = -e.deltaX / 40;
      }
      this.deltaY === 0 && this.deltaX === 0 && e.wheelDelta && (this.deltaY = o ? e.wheelDelta / (120 * l) : e.wheelDelta / 120);
    }
  }
  preventDefault() {
    var e;
    (e = this.browserEvent) === null || e === void 0 || e.preventDefault();
  }
  stopPropagation() {
    var e;
    (e = this.browserEvent) === null || e === void 0 || e.stopPropagation();
  }
}
const r8 = Symbol("MicrotaskDelay");
function Fk(i) {
  return !!i && typeof i.then == "function";
}
function on(i) {
  const e = new Ci(), t = i(e.token), n = new Promise((s, o) => {
    const r = e.token.onCancellationRequested(() => {
      r.dispose(), o(new Vd());
    });
    Promise.resolve(t).then((a) => {
      r.dispose(), e.dispose(), s(a);
    }, (a) => {
      r.dispose(), e.dispose(), o(a);
    });
  });
  return new class {
    cancel() {
      e.cancel(), e.dispose();
    }
    then(s, o) {
      return n.then(s, o);
    }
    catch(s) {
      return this.then(void 0, s);
    }
    finally(s) {
      return n.finally(s);
    }
  }();
}
function v1(i, e, t) {
  return new Promise((n, s) => {
    const o = e.onCancellationRequested(() => {
      o.dispose(), n(t);
    });
    i.then(n, s).finally(() => o.dispose());
  });
}
class BK {
  constructor() {
    this.isDisposed = !1, this.activePromise = null, this.queuedPromise = null, this.queuedPromiseFactory = null;
  }
  queue(e) {
    if (this.isDisposed) return Promise.reject(new Error("Throttler is disposed"));
    if (this.activePromise) {
      if (this.queuedPromiseFactory = e, !this.queuedPromise) {
        const t = () => {
          if (this.queuedPromise = null, this.isDisposed) return;
          const n = this.queue(this.queuedPromiseFactory);
          return this.queuedPromiseFactory = null, n;
        };
        this.queuedPromise = new Promise((n) => {
          this.activePromise.then(t, t).then(n);
        });
      }
      return new Promise((t, n) => {
        this.queuedPromise.then(t, n);
      });
    }
    return this.activePromise = e(), new Promise((t, n) => {
      this.activePromise.then((s) => {
        this.activePromise = null, t(s);
      }, (s) => {
        this.activePromise = null, n(s);
      });
    });
  }
  dispose() {
    this.isDisposed = !0;
  }
}
class Sr {
  constructor(e) {
    this.defaultDelay = e, this.deferred = null, this.completionPromise = null, this.doResolve = null, this.doReject = null, this.task = null;
  }
  trigger(e, t = this.defaultDelay) {
    this.task = e, this.cancelTimeout(), this.completionPromise || (this.completionPromise = new Promise((s, o) => {
      this.doResolve = s, this.doReject = o;
    }).then(() => {
      if (this.completionPromise = null, this.doResolve = null, this.task) {
        const s = this.task;
        return this.task = null, s();
      }
    }));
    const n = () => {
      var s;
      this.deferred = null, (s = this.doResolve) === null || s === void 0 || s.call(this, null);
    };
    return this.deferred = t === r8 ? ((s) => {
      let o = !0;
      return queueMicrotask(() => {
        o && (o = !1, s());
      }), { isTriggered: () => o, dispose: () => {
        o = !1;
      } };
    })(n) : ((s, o) => {
      let r = !0;
      const a = setTimeout(() => {
        r = !1, o();
      }, s);
      return { isTriggered: () => r, dispose: () => {
        clearTimeout(a), r = !1;
      } };
    })(t, n), this.completionPromise;
  }
  isTriggered() {
    var e;
    return !!(!((e = this.deferred) === null || e === void 0) && e.isTriggered());
  }
  cancel() {
    var e;
    this.cancelTimeout(), this.completionPromise && ((e = this.doReject) === null || e === void 0 || e.call(this, new Vd()), this.completionPromise = null);
  }
  cancelTimeout() {
    var e;
    (e = this.deferred) === null || e === void 0 || e.dispose(), this.deferred = null;
  }
  dispose() {
    this.cancel();
  }
}
class a8 {
  constructor(e) {
    this.delayer = new Sr(e), this.throttler = new BK();
  }
  trigger(e, t) {
    return this.delayer.trigger(() => this.throttler.queue(e), t);
  }
  cancel() {
    this.delayer.cancel();
  }
  dispose() {
    this.delayer.dispose(), this.throttler.dispose();
  }
}
function bc(i, e) {
  return e ? new Promise((t, n) => {
    const s = setTimeout(() => {
      o.dispose(), t();
    }, i), o = e.onCancellationRequested(() => {
      clearTimeout(s), o.dispose(), n(new Vd());
    });
  }) : on((t) => bc(i, t));
}
function Cc(i, e = 0, t) {
  const n = setTimeout(() => {
    i(), t && s.dispose();
  }, e), s = ye(() => {
    clearTimeout(n), t == null || t.deleteAndLeak(s);
  });
  return t == null || t.add(s), s;
}
function cR(i, e = (n) => !!n, t = null) {
  let n = 0;
  const s = i.length, o = () => {
    if (n >= s) return Promise.resolve(t);
    const r = i[n++];
    return Promise.resolve(r()).then((a) => e(a) ? Promise.resolve(a) : o());
  };
  return o();
}
class Dr {
  constructor(e, t) {
    this._token = -1, typeof e == "function" && typeof t == "number" && this.setIfNotSet(e, t);
  }
  dispose() {
    this.cancel();
  }
  cancel() {
    this._token !== -1 && (clearTimeout(this._token), this._token = -1);
  }
  cancelAndSet(e, t) {
    this.cancel(), this._token = setTimeout(() => {
      this._token = -1, e();
    }, t);
  }
  setIfNotSet(e, t) {
    this._token === -1 && (this._token = setTimeout(() => {
      this._token = -1, e();
    }, t));
  }
}
class uR {
  constructor() {
    this.disposable = void 0;
  }
  cancel() {
    var e;
    (e = this.disposable) === null || e === void 0 || e.dispose(), this.disposable = void 0;
  }
  cancelAndSet(e, t, n = globalThis) {
    this.cancel();
    const s = n.setInterval(() => {
      e();
    }, t);
    this.disposable = ye(() => {
      n.clearInterval(s), this.disposable = void 0;
    });
  }
  dispose() {
    this.cancel();
  }
}
class It {
  constructor(e, t) {
    this.timeoutToken = -1, this.runner = e, this.timeout = t, this.timeoutHandler = this.onTimeout.bind(this);
  }
  dispose() {
    this.cancel(), this.runner = null;
  }
  cancel() {
    this.isScheduled() && (clearTimeout(this.timeoutToken), this.timeoutToken = -1);
  }
  schedule(e = this.timeout) {
    this.cancel(), this.timeoutToken = setTimeout(this.timeoutHandler, e);
  }
  get delay() {
    return this.timeout;
  }
  set delay(e) {
    this.timeout = e;
  }
  isScheduled() {
    return this.timeoutToken !== -1;
  }
  onTimeout() {
    this.timeoutToken = -1, this.runner && this.doRun();
  }
  doRun() {
    var e;
    (e = this.runner) === null || e === void 0 || e.call(this);
  }
}
let l8, Uw;
Uw = typeof globalThis.requestIdleCallback != "function" || typeof globalThis.cancelIdleCallback != "function" ? (i, e) => {
  L7(() => {
    if (t) return;
    const n = Date.now() + 15;
    e(Object.freeze({ didTimeout: !0, timeRemaining: () => Math.max(0, n - Date.now()) }));
  });
  let t = !1;
  return { dispose() {
    t || (t = !0);
  } };
} : (i, e, t) => {
  const n = i.requestIdleCallback(e, typeof t == "number" ? { timeout: t } : void 0);
  let s = !1;
  return { dispose() {
    s || (s = !0, i.cancelIdleCallback(n));
  } };
}, l8 = (i) => Uw(globalThis, i);
class d8 {
  constructor(e, t) {
    this._didRun = !1, this._executor = () => {
      try {
        this._value = t();
      } catch (n) {
        this._error = n;
      } finally {
        this._didRun = !0;
      }
    }, this._handle = Uw(e, () => this._executor());
  }
  dispose() {
    this._handle.dispose();
  }
  get value() {
    if (this._didRun || (this._handle.dispose(), this._executor()), this._error) throw this._error;
    return this._value;
  }
  get isInitialized() {
    return this._didRun;
  }
}
class WK extends d8 {
  constructor(e) {
    super(globalThis, e);
  }
}
class b1 {
  get isRejected() {
    var e;
    return ((e = this.outcome) === null || e === void 0 ? void 0 : e.outcome) === 1;
  }
  get isSettled() {
    return !!this.outcome;
  }
  constructor() {
    this.p = new Promise((e, t) => {
      this.completeCallback = e, this.errorCallback = t;
    });
  }
  complete(e) {
    return new Promise((t) => {
      this.completeCallback(e), this.outcome = { outcome: 0, value: e }, t();
    });
  }
  error(e) {
    return new Promise((t) => {
      this.errorCallback(e), this.outcome = { outcome: 1, value: e }, t();
    });
  }
  cancel() {
    return this.error(new Vd());
  }
}
var xE;
(function(i) {
  i.settled = async function(e) {
    let t;
    const n = await Promise.all(e.map((s) => s.then((o) => o, (o) => {
      t || (t = o);
    })));
    if (t !== void 0) throw t;
    return n;
  }, i.withAsyncBody = function(e) {
    return new Promise(async (t, n) => {
      try {
        await e(t, n);
      } catch (s) {
        n(s);
      }
    });
  };
})(xE || (xE = {}));
class Pi {
  static fromArray(e) {
    return new Pi((t) => {
      t.emitMany(e);
    });
  }
  static fromPromise(e) {
    return new Pi(async (t) => {
      t.emitMany(await e);
    });
  }
  static fromPromises(e) {
    return new Pi(async (t) => {
      await Promise.all(e.map(async (n) => t.emitOne(await n)));
    });
  }
  static merge(e) {
    return new Pi(async (t) => {
      await Promise.all(e.map(async (n) => {
        for await (const s of n) t.emitOne(s);
      }));
    });
  }
  constructor(e) {
    this._state = 0, this._results = [], this._error = null, this._onStateChanged = new F(), queueMicrotask(async () => {
      const t = { emitOne: (n) => this.emitOne(n), emitMany: (n) => this.emitMany(n), reject: (n) => this.reject(n) };
      try {
        await Promise.resolve(e(t)), this.resolve();
      } catch (n) {
        this.reject(n);
      } finally {
        t.emitOne = void 0, t.emitMany = void 0, t.reject = void 0;
      }
    });
  }
  [Symbol.asyncIterator]() {
    let e = 0;
    return { next: async () => {
      for (; ; ) {
        if (this._state === 2) throw this._error;
        if (e < this._results.length) return { done: !1, value: this._results[e++] };
        if (this._state === 1) return { done: !0, value: void 0 };
        await se.toPromise(this._onStateChanged.event);
      }
    } };
  }
  static map(e, t) {
    return new Pi(async (n) => {
      for await (const s of e) n.emitOne(t(s));
    });
  }
  map(e) {
    return Pi.map(this, e);
  }
  static filter(e, t) {
    return new Pi(async (n) => {
      for await (const s of e) t(s) && n.emitOne(s);
    });
  }
  filter(e) {
    return Pi.filter(this, e);
  }
  static coalesce(e) {
    return Pi.filter(e, (t) => !!t);
  }
  coalesce() {
    return Pi.coalesce(this);
  }
  static async toPromise(e) {
    const t = [];
    for await (const n of e) t.push(n);
    return t;
  }
  toPromise() {
    return Pi.toPromise(this);
  }
  emitOne(e) {
    this._state === 0 && (this._results.push(e), this._onStateChanged.fire());
  }
  emitMany(e) {
    this._state === 0 && (this._results = this._results.concat(e), this._onStateChanged.fire());
  }
  resolve() {
    this._state === 0 && (this._state = 1, this._onStateChanged.fire());
  }
  reject(e) {
    this._state === 0 && (this._state = 2, this._error = e, this._onStateChanged.fire());
  }
}
Pi.EMPTY = Pi.fromArray([]);
class VK extends Pi {
  constructor(e, t) {
    super(t), this._source = e;
  }
  cancel() {
    this._source.cancel();
  }
}
const { entries: h8, setPrototypeOf: uO, isFrozen: HK, getPrototypeOf: zK, getOwnPropertyDescriptor: UK } = Object;
let { freeze: eo, seal: pa, create: KK } = Object, { apply: NE, construct: EE } = typeof Reflect < "u" && Reflect;
NE || (NE = function(i, e, t) {
  return i.apply(e, t);
}), eo || (eo = function(i) {
  return i;
}), pa || (pa = function(i) {
  return i;
}), EE || (EE = function(i, e) {
  return new i(...e);
});
const jK = Lr(Array.prototype.forEach), gO = Lr(Array.prototype.pop), Ef = Lr(Array.prototype.push), MC = Lr(String.prototype.toLowerCase), Bk = Lr(String.prototype.toString), qK = Lr(String.prototype.match), Tr = Lr(String.prototype.replace), $K = Lr(String.prototype.indexOf), GK = Lr(String.prototype.trim), Po = Lr(RegExp.prototype.test), If = (pO = TypeError, function() {
  for (var i = arguments.length, e = new Array(i), t = 0; t < i; t++) e[t] = arguments[t];
  return EE(pO, e);
});
var pO;
function Lr(i) {
  return function(e) {
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++) n[s - 1] = arguments[s];
    return NE(i, e, n);
  };
}
function xt(i, e, t) {
  var n;
  t = (n = t) !== null && n !== void 0 ? n : MC, uO && uO(i, null);
  let s = e.length;
  for (; s--; ) {
    let o = e[s];
    if (typeof o == "string") {
      const r = t(o);
      r !== o && (HK(e) || (e[s] = r), o = r);
    }
    i[o] = !0;
  }
  return i;
}
function zg(i) {
  const e = KK(null);
  for (const [t, n] of h8(i)) e[t] = n;
  return e;
}
function eb(i, e) {
  for (; i !== null; ) {
    const t = UK(i, e);
    if (t) {
      if (t.get) return Lr(t.get);
      if (typeof t.value == "function") return Lr(t.value);
    }
    i = zK(i);
  }
  return function(t) {
    return console.warn("fallback value for", t), null;
  };
}
const mO = eo(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Wk = eo(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Vk = eo(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), ZK = eo(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Hk = eo(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), YK = eo(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), fO = eo(["#text"]), _O = eo(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "xmlns", "slot"]), zk = eo(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), vO = eo(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), tb = eo(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), XK = pa(/\{\{[\w\W]*|[\w\W]*\}\}/gm), QK = pa(/<%[\w\W]*|[\w\W]*%>/gm), JK = pa(/\${[\w\W]*}/gm), ej = pa(/^data-[\-\w.\u00B7-\uFFFF]/), tj = pa(/^aria-[\-\w]+$/), c8 = pa(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i), ij = pa(/^(?:\w+script|data):/i), nj = pa(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g), u8 = pa(/^html$/i);
var bO = Object.freeze({ __proto__: null, MUSTACHE_EXPR: XK, ERB_EXPR: QK, TMPLIT_EXPR: JK, DATA_ATTR: ej, ARIA_ATTR: tj, IS_ALLOWED_URI: c8, IS_SCRIPT_OR_DATA: ij, ATTR_WHITESPACE: nj, DOCTYPE_NAME: u8 });
const sj = () => typeof window > "u" ? null : window;
var pl = function i() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : sj();
  const t = (j) => i(j);
  if (t.version = "3.0.5", t.removed = [], !e || !e.document || e.document.nodeType !== 9) return t.isSupported = !1, t;
  const n = e.document, s = n.currentScript;
  let { document: o } = e;
  const { DocumentFragment: r, HTMLTemplateElement: a, Node: l, Element: d, NodeFilter: h, NamedNodeMap: c = e.NamedNodeMap || e.MozNamedAttrMap, HTMLFormElement: u, DOMParser: g, trustedTypes: p } = e, f = d.prototype, _ = eb(f, "cloneNode"), v = eb(f, "nextSibling"), b = eb(f, "childNodes"), C = eb(f, "parentNode");
  if (typeof a == "function") {
    const j = o.createElement("template");
    j.content && j.content.ownerDocument && (o = j.content.ownerDocument);
  }
  let w, y = "";
  const { implementation: L, createNodeIterator: k, createDocumentFragment: N, getElementsByTagName: A } = o, { importNode: B } = n;
  let T = {};
  t.isSupported = typeof h8 == "function" && typeof C == "function" && L && L.createHTMLDocument !== void 0;
  const { MUSTACHE_EXPR: O, ERB_EXPR: H, TMPLIT_EXPR: $, DATA_ATTR: pe, ARIA_ATTR: me, IS_SCRIPT_OR_DATA: ue, ATTR_WHITESPACE: ee } = bO;
  let { IS_ALLOWED_URI: te } = bO, be = null;
  const we = xt({}, [...mO, ...Wk, ...Vk, ...Hk, ...fO]);
  let Re = null;
  const it = xt({}, [..._O, ...zk, ...vO, ...tb]);
  let ut = Object.seal(Object.create(null, { tagNameCheck: { writable: !0, configurable: !1, enumerable: !0, value: null }, attributeNameCheck: { writable: !0, configurable: !1, enumerable: !0, value: null }, allowCustomizedBuiltInElements: { writable: !0, configurable: !1, enumerable: !0, value: !1 } })), Xi = null, nt = null, De = !0, an = !0, ka = !1, Er = !0, Ws = !1, Ss = !1, Ir = !1, jd = !1, Ki = !1, le = !1, Y = !1, M = !0, R = !1, P = !0, U = !1, ce = {}, Ae = null;
  const ge = xt({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Ne = null;
  const Xe = xt({}, ["audio", "video", "img", "source", "image", "track"]);
  let Oe = null;
  const _t = xt({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Ke = "http://www.w3.org/1998/Math/MathML", Lt = "http://www.w3.org/2000/svg", Mt = "http://www.w3.org/1999/xhtml";
  let si = Mt, Vs = !1, At = null;
  const Vc = xt({}, [Ke, Lt, Mt], Bk);
  let Mr;
  const Dl = ["application/xhtml+xml", "text/html"];
  let Qi, Sn = null;
  const Og = o.createElement("form"), qd = function(j) {
    return j instanceof RegExp || j instanceof Function;
  }, xf = function(j) {
    if (!Sn || Sn !== j) {
      if (j && typeof j == "object" || (j = {}), j = zg(j), Mr = Mr = Dl.indexOf(j.PARSER_MEDIA_TYPE) === -1 ? "text/html" : j.PARSER_MEDIA_TYPE, Qi = Mr === "application/xhtml+xml" ? Bk : MC, be = "ALLOWED_TAGS" in j ? xt({}, j.ALLOWED_TAGS, Qi) : we, Re = "ALLOWED_ATTR" in j ? xt({}, j.ALLOWED_ATTR, Qi) : it, At = "ALLOWED_NAMESPACES" in j ? xt({}, j.ALLOWED_NAMESPACES, Bk) : Vc, Oe = "ADD_URI_SAFE_ATTR" in j ? xt(zg(_t), j.ADD_URI_SAFE_ATTR, Qi) : _t, Ne = "ADD_DATA_URI_TAGS" in j ? xt(zg(Xe), j.ADD_DATA_URI_TAGS, Qi) : Xe, Ae = "FORBID_CONTENTS" in j ? xt({}, j.FORBID_CONTENTS, Qi) : ge, Xi = "FORBID_TAGS" in j ? xt({}, j.FORBID_TAGS, Qi) : {}, nt = "FORBID_ATTR" in j ? xt({}, j.FORBID_ATTR, Qi) : {}, ce = "USE_PROFILES" in j && j.USE_PROFILES, De = j.ALLOW_ARIA_ATTR !== !1, an = j.ALLOW_DATA_ATTR !== !1, ka = j.ALLOW_UNKNOWN_PROTOCOLS || !1, Er = j.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Ws = j.SAFE_FOR_TEMPLATES || !1, Ss = j.WHOLE_DOCUMENT || !1, Ki = j.RETURN_DOM || !1, le = j.RETURN_DOM_FRAGMENT || !1, Y = j.RETURN_TRUSTED_TYPE || !1, jd = j.FORCE_BODY || !1, M = j.SANITIZE_DOM !== !1, R = j.SANITIZE_NAMED_PROPS || !1, P = j.KEEP_CONTENT !== !1, U = j.IN_PLACE || !1, te = j.ALLOWED_URI_REGEXP || c8, si = j.NAMESPACE || Mt, ut = j.CUSTOM_ELEMENT_HANDLING || {}, j.CUSTOM_ELEMENT_HANDLING && qd(j.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (ut.tagNameCheck = j.CUSTOM_ELEMENT_HANDLING.tagNameCheck), j.CUSTOM_ELEMENT_HANDLING && qd(j.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (ut.attributeNameCheck = j.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), j.CUSTOM_ELEMENT_HANDLING && typeof j.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (ut.allowCustomizedBuiltInElements = j.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Ws && (an = !1), le && (Ki = !0), ce && (be = xt({}, [...fO]), Re = [], ce.html === !0 && (xt(be, mO), xt(Re, _O)), ce.svg === !0 && (xt(be, Wk), xt(Re, zk), xt(Re, tb)), ce.svgFilters === !0 && (xt(be, Vk), xt(Re, zk), xt(Re, tb)), ce.mathMl === !0 && (xt(be, Hk), xt(Re, vO), xt(Re, tb))), j.ADD_TAGS && (be === we && (be = zg(be)), xt(be, j.ADD_TAGS, Qi)), j.ADD_ATTR && (Re === it && (Re = zg(Re)), xt(Re, j.ADD_ATTR, Qi)), j.ADD_URI_SAFE_ATTR && xt(Oe, j.ADD_URI_SAFE_ATTR, Qi), j.FORBID_CONTENTS && (Ae === ge && (Ae = zg(Ae)), xt(Ae, j.FORBID_CONTENTS, Qi)), P && (be["#text"] = !0), Ss && xt(be, ["html", "head", "body"]), be.table && (xt(be, ["tbody"]), delete Xi.tbody), j.TRUSTED_TYPES_POLICY) {
        if (typeof j.TRUSTED_TYPES_POLICY.createHTML != "function") throw If('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof j.TRUSTED_TYPES_POLICY.createScriptURL != "function") throw If('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        w = j.TRUSTED_TYPES_POLICY, y = w.createHTML("");
      } else w === void 0 && (w = function(xe, Be) {
        if (typeof xe != "object" || typeof xe.createPolicy != "function") return null;
        let Pt = null;
        const di = "data-tt-policy-suffix";
        Be && Be.hasAttribute(di) && (Pt = Be.getAttribute(di));
        const wi = "dompurify" + (Pt ? "#" + Pt : "");
        try {
          return xe.createPolicy(wi, { createHTML: (mi) => mi, createScriptURL: (mi) => mi });
        } catch {
          return console.warn("TrustedTypes policy " + wi + " could not be created."), null;
        }
      }(p, s)), w !== null && typeof y == "string" && (y = w.createHTML(""));
      eo && eo(j), Sn = j;
    }
  }, Fg = xt({}, ["mi", "mo", "mn", "ms", "mtext"]), Nf = xt({}, ["foreignobject", "desc", "title", "annotation-xml"]), j1 = xt({}, ["title", "style", "font", "a", "script"]), Bg = xt({}, Wk);
  xt(Bg, Vk), xt(Bg, ZK);
  const xk = xt({}, Hk);
  xt(xk, YK);
  const Hc = function(j) {
    Ef(t.removed, { element: j });
    try {
      j.parentNode.removeChild(j);
    } catch {
      j.remove();
    }
  }, Nk = function(j, xe) {
    try {
      Ef(t.removed, { attribute: xe.getAttributeNode(j), from: xe });
    } catch {
      Ef(t.removed, { attribute: null, from: xe });
    }
    if (xe.removeAttribute(j), j === "is" && !Re[j]) if (Ki || le) try {
      Hc(xe);
    } catch {
    }
    else try {
      xe.setAttribute(j, "");
    } catch {
    }
  }, HP = function(j) {
    let xe, Be;
    if (jd) j = "<remove></remove>" + j;
    else {
      const wi = qK(j, /^[\r\n\t ]+/);
      Be = wi && wi[0];
    }
    Mr === "application/xhtml+xml" && si === Mt && (j = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + j + "</body></html>");
    const Pt = w ? w.createHTML(j) : j;
    if (si === Mt) try {
      xe = new g().parseFromString(Pt, Mr);
    } catch {
    }
    if (!xe || !xe.documentElement) {
      xe = L.createDocument(si, "template", null);
      try {
        xe.documentElement.innerHTML = Vs ? y : Pt;
      } catch {
      }
    }
    const di = xe.body || xe.documentElement;
    return j && Be && di.insertBefore(o.createTextNode(Be), di.childNodes[0] || null), si === Mt ? A.call(xe, Ss ? "html" : "body")[0] : Ss ? xe.documentElement : di;
  }, zP = function(j) {
    return k.call(j.ownerDocument || j, j, h.SHOW_ELEMENT | h.SHOW_COMMENT | h.SHOW_TEXT, null, !1);
  }, q1 = function(j) {
    return typeof l == "object" ? j instanceof l : j && typeof j == "object" && typeof j.nodeType == "number" && typeof j.nodeName == "string";
  }, xl = function(j, xe, Be) {
    T[j] && jK(T[j], (Pt) => {
      Pt.call(t, xe, Be, Sn);
    });
  }, UP = function(j) {
    let xe;
    if (xl("beforeSanitizeElements", j, null), (Be = j) instanceof u && (typeof Be.nodeName != "string" || typeof Be.textContent != "string" || typeof Be.removeChild != "function" || !(Be.attributes instanceof c) || typeof Be.removeAttribute != "function" || typeof Be.setAttribute != "function" || typeof Be.namespaceURI != "string" || typeof Be.insertBefore != "function" || typeof Be.hasChildNodes != "function")) return Hc(j), !0;
    var Be;
    const Pt = Qi(j.nodeName);
    if (xl("uponSanitizeElement", j, { tagName: Pt, allowedTags: be }), j.hasChildNodes() && !q1(j.firstElementChild) && (!q1(j.content) || !q1(j.content.firstElementChild)) && Po(/<[/\w]/g, j.innerHTML) && Po(/<[/\w]/g, j.textContent)) return Hc(j), !0;
    if (!be[Pt] || Xi[Pt]) {
      if (!Xi[Pt] && jP(Pt) && (ut.tagNameCheck instanceof RegExp && Po(ut.tagNameCheck, Pt) || ut.tagNameCheck instanceof Function && ut.tagNameCheck(Pt)))
        return !1;
      if (P && !Ae[Pt]) {
        const di = C(j) || j.parentNode, wi = b(j) || j.childNodes;
        if (wi && di)
          for (let mi = wi.length - 1; mi >= 0; --mi) di.insertBefore(_(wi[mi], !0), v(j));
      }
      return Hc(j), !0;
    }
    return j instanceof d && !function(di) {
      let wi = C(di);
      wi && wi.tagName || (wi = { namespaceURI: si, tagName: "template" });
      const mi = MC(di.tagName), ji = MC(wi.tagName);
      return !!At[di.namespaceURI] && (di.namespaceURI === Lt ? wi.namespaceURI === Mt ? mi === "svg" : wi.namespaceURI === Ke ? mi === "svg" && (ji === "annotation-xml" || Fg[ji]) : !!Bg[mi] : di.namespaceURI === Ke ? wi.namespaceURI === Mt ? mi === "math" : wi.namespaceURI === Lt ? mi === "math" && Nf[ji] : !!xk[mi] : di.namespaceURI === Mt ? !(wi.namespaceURI === Lt && !Nf[ji]) && !(wi.namespaceURI === Ke && !Fg[ji]) && !xk[mi] && (j1[mi] || !Bg[mi]) : !(Mr !== "application/xhtml+xml" || !At[di.namespaceURI]));
    }(j) ? (Hc(j), !0) : Pt !== "noscript" && Pt !== "noembed" && Pt !== "noframes" || !Po(/<\/no(script|embed|frames)/i, j.innerHTML) ? (Ws && j.nodeType === 3 && (xe = j.textContent, xe = Tr(xe, O, " "), xe = Tr(xe, H, " "), xe = Tr(xe, $, " "), j.textContent !== xe && (Ef(t.removed, { element: j.cloneNode() }), j.textContent = xe)), xl("afterSanitizeElements", j, null), !1) : (Hc(j), !0);
  }, KP = function(j, xe, Be) {
    if (M && (xe === "id" || xe === "name") && (Be in o || Be in Og)) return !1;
    if (!(an && !nt[xe] && Po(pe, xe))) {
      if (!(De && Po(me, xe))) {
        if (!Re[xe] || nt[xe]) {
          if (!(jP(j) && (ut.tagNameCheck instanceof RegExp && Po(ut.tagNameCheck, j) || ut.tagNameCheck instanceof Function && ut.tagNameCheck(j)) && (ut.attributeNameCheck instanceof RegExp && Po(ut.attributeNameCheck, xe) || ut.attributeNameCheck instanceof Function && ut.attributeNameCheck(xe)) || xe === "is" && ut.allowCustomizedBuiltInElements && (ut.tagNameCheck instanceof RegExp && Po(ut.tagNameCheck, Be) || ut.tagNameCheck instanceof Function && ut.tagNameCheck(Be)))) return !1;
        } else if (!Oe[xe]) {
          if (!Po(te, Tr(Be, ee, ""))) {
            if ((xe !== "src" && xe !== "xlink:href" && xe !== "href" || j === "script" || $K(Be, "data:") !== 0 || !Ne[j]) && !(ka && !Po(ue, Tr(Be, ee, "")))) {
              if (Be) return !1;
            }
          }
        }
      }
    }
    return !0;
  }, jP = function(j) {
    return j.indexOf("-") > 0;
  }, qP = function(j) {
    let xe, Be, Pt, di;
    xl("beforeSanitizeAttributes", j, null);
    const { attributes: wi } = j;
    if (!wi) return;
    const mi = { attrName: "", attrValue: "", keepAttr: !0, allowedAttributes: Re };
    for (di = wi.length; di--; ) {
      xe = wi[di];
      const { name: ji, namespaceURI: Wg } = xe;
      if (Be = ji === "value" ? xe.value : GK(xe.value), Pt = Qi(ji), mi.attrName = Pt, mi.attrValue = Be, mi.keepAttr = !0, mi.forceKeepAttr = void 0, xl("uponSanitizeAttribute", j, mi), Be = mi.attrValue, mi.forceKeepAttr || (Nk(ji, j), !mi.keepAttr)) continue;
      if (!Er && Po(/\/>/i, Be)) {
        Nk(ji, j);
        continue;
      }
      Ws && (Be = Tr(Be, O, " "), Be = Tr(Be, H, " "), Be = Tr(Be, $, " "));
      const $P = Qi(j.nodeName);
      if (KP($P, Pt, Be)) {
        if (!R || Pt !== "id" && Pt !== "name" || (Nk(ji, j), Be = "user-content-" + Be), w && typeof p == "object" && typeof p.getAttributeType == "function" && !Wg) switch (p.getAttributeType($P, Pt)) {
          case "TrustedHTML":
            Be = w.createHTML(Be);
            break;
          case "TrustedScriptURL":
            Be = w.createScriptURL(Be);
        }
        try {
          Wg ? j.setAttributeNS(Wg, ji, Be) : j.setAttribute(ji, Be), gO(t.removed);
        } catch {
        }
      }
    }
    xl("afterSanitizeAttributes", j, null);
  }, VU = function j(xe) {
    let Be;
    const Pt = zP(xe);
    for (xl("beforeSanitizeShadowDOM", xe, null); Be = Pt.nextNode(); ) xl("uponSanitizeShadowNode", Be, null), UP(Be) || (Be.content instanceof r && j(Be.content), qP(Be));
    xl("afterSanitizeShadowDOM", xe, null);
  };
  return t.sanitize = function(j) {
    let xe, Be, Pt, di, wi = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (Vs = !j, Vs && (j = "<!-->"), typeof j != "string" && !q1(j)) {
      if (typeof j.toString != "function") throw If("toString is not a function");
      if (typeof (j = j.toString()) != "string") throw If("dirty is not a string, aborting");
    }
    if (!t.isSupported) return j;
    if (Ir || xf(wi), t.removed = [], typeof j == "string" && (U = !1), U) {
      if (j.nodeName) {
        const Wg = Qi(j.nodeName);
        if (!be[Wg] || Xi[Wg]) throw If("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (j instanceof l) xe = HP("<!---->"), Be = xe.ownerDocument.importNode(j, !0), Be.nodeType === 1 && Be.nodeName === "BODY" || Be.nodeName === "HTML" ? xe = Be : xe.appendChild(Be);
    else {
      if (!Ki && !Ws && !Ss && j.indexOf("<") === -1) return w && Y ? w.createHTML(j) : j;
      if (xe = HP(j), !xe) return Ki ? null : Y ? y : "";
    }
    xe && jd && Hc(xe.firstChild);
    const mi = zP(U ? j : xe);
    for (; Pt = mi.nextNode(); ) UP(Pt) || (Pt.content instanceof r && VU(Pt.content), qP(Pt));
    if (U) return j;
    if (Ki) {
      if (le) for (di = N.call(xe.ownerDocument); xe.firstChild; ) di.appendChild(xe.firstChild);
      else di = xe;
      return (Re.shadowroot || Re.shadowrootmode) && (di = B.call(n, di, !0)), di;
    }
    let ji = Ss ? xe.outerHTML : xe.innerHTML;
    return Ss && be["!doctype"] && xe.ownerDocument && xe.ownerDocument.doctype && xe.ownerDocument.doctype.name && Po(u8, xe.ownerDocument.doctype.name) && (ji = "<!DOCTYPE " + xe.ownerDocument.doctype.name + `>
` + ji), Ws && (ji = Tr(ji, O, " "), ji = Tr(ji, H, " "), ji = Tr(ji, $, " ")), w && Y ? w.createHTML(ji) : ji;
  }, t.setConfig = function(j) {
    xf(j), Ir = !0;
  }, t.clearConfig = function() {
    Sn = null, Ir = !1;
  }, t.isValidAttribute = function(j, xe, Be) {
    Sn || xf({});
    const Pt = Qi(j), di = Qi(xe);
    return KP(Pt, di, Be);
  }, t.addHook = function(j, xe) {
    typeof xe == "function" && (T[j] = T[j] || [], Ef(T[j], xe));
  }, t.removeHook = function(j) {
    if (T[j]) return gO(T[j]);
  }, t.removeHooks = function(j) {
    T[j] && (T[j] = []);
  }, t.removeAllHooks = function() {
    T = {};
  }, t;
}();
pl.version, pl.isSupported;
const g8 = pl.sanitize;
pl.setConfig, pl.clearConfig, pl.isValidAttribute;
const Uk = pl.addHook, CO = pl.removeHook;
var Ue;
function gR(i, e) {
  return Ie.isUri(i) ? Dp(i.scheme, e) : oR(i, e + ":");
}
function wO(i, ...e) {
  return e.some((t) => gR(i, t));
}
pl.removeHooks, pl.removeAllHooks, function(i) {
  i.inMemory = "inmemory", i.vscode = "vscode", i.internal = "private", i.walkThrough = "walkThrough", i.walkThroughSnippet = "walkThroughSnippet", i.http = "http", i.https = "https", i.file = "file", i.mailto = "mailto", i.untitled = "untitled", i.data = "data", i.command = "command", i.vscodeRemote = "vscode-remote", i.vscodeRemoteResource = "vscode-remote-resource", i.vscodeManagedRemoteResource = "vscode-managed-remote-resource", i.vscodeUserData = "vscode-userdata", i.vscodeCustomEditor = "vscode-custom-editor", i.vscodeNotebookCell = "vscode-notebook-cell", i.vscodeNotebookCellMetadata = "vscode-notebook-cell-metadata", i.vscodeNotebookCellOutput = "vscode-notebook-cell-output", i.vscodeInteractiveInput = "vscode-interactive-input", i.vscodeSettings = "vscode-settings", i.vscodeWorkspaceTrust = "vscode-workspace-trust", i.vscodeTerminal = "vscode-terminal", i.vscodeChatCodeBlock = "vscode-chat-code-block", i.vscodeChatSesssion = "vscode-chat-editor", i.webviewPanel = "webview-panel", i.vscodeWebview = "vscode-webview", i.extension = "extension", i.vscodeFileResource = "vscode-file", i.tmp = "tmp", i.vsls = "vsls", i.vscodeSourceControl = "vscode-scm", i.codeSetting = "code-setting";
}(Ue || (Ue = {}));
const p8 = new class {
  constructor() {
    this._hosts = /* @__PURE__ */ Object.create(null), this._ports = /* @__PURE__ */ Object.create(null), this._connectionTokens = /* @__PURE__ */ Object.create(null), this._preferredWebSchema = "http", this._delegate = null, this._serverRootPath = "/";
  }
  setPreferredWebSchema(i) {
    this._preferredWebSchema = i;
  }
  get _remoteResourcesPath() {
    return Fi.join(this._serverRootPath, Ue.vscodeRemoteResource);
  }
  rewrite(i) {
    if (this._delegate) try {
      return this._delegate(i);
    } catch (r) {
      return We(r), i;
    }
    const e = i.authority;
    let t = this._hosts[e];
    t && t.indexOf(":") !== -1 && t.indexOf("[") === -1 && (t = `[${t}]`);
    const n = this._ports[e], s = this._connectionTokens[e];
    let o = `path=${encodeURIComponent(i.path)}`;
    return typeof s == "string" && (o += `&tkn=${encodeURIComponent(s)}`), Ie.from({ scheme: pc ? this._preferredWebSchema : Ue.vscodeRemoteResource, authority: `${t}:${n}`, path: this._remoteResourcesPath, query: o });
  }
}();
class J0 {
  uriToBrowserUri(e) {
    return e.scheme === Ue.vscodeRemote ? p8.rewrite(e) : e.scheme !== Ue.file || !sa && ZU !== `${Ue.vscodeFileResource}://${J0.FALLBACK_AUTHORITY}` ? e : e.with({ scheme: Ue.vscodeFileResource, authority: e.authority || J0.FALLBACK_AUTHORITY, query: null, fragment: null });
  }
}
J0.FALLBACK_AUTHORITY = "vscode-app";
const m8 = new J0();
var yO;
function WS(i) {
  return Kw(i, 0);
}
function Kw(i, e) {
  switch (typeof i) {
    case "object":
      return i === null ? Bl(349, e) : Array.isArray(i) ? (t = i, n = Bl(104579, n = e), t.reduce((s, o) => Kw(o, s), n)) : function(s, o) {
        return o = Bl(181387, o), Object.keys(s).sort().reduce((r, a) => (r = IE(a, r), Kw(s[a], r)), o);
      }(i, e);
    case "string":
      return IE(i, e);
    case "boolean":
      return function(s, o) {
        return Bl(s ? 433 : 863, o);
      }(i, e);
    case "number":
      return Bl(i, e);
    case "undefined":
      return Bl(937, e);
    default:
      return Bl(617, e);
  }
  var t, n;
}
function Bl(i, e) {
  return (e << 5) - e + i | 0;
}
function IE(i, e) {
  e = Bl(149417, e);
  for (let t = 0, n = i.length; t < n; t++) e = Bl(i.charCodeAt(t), e);
  return e;
}
function Kk(i, e, t = 32) {
  const n = t - e;
  return (i << e | (~((1 << n) - 1) & i) >>> n) >>> 0;
}
function SO(i, e = 0, t = i.byteLength, n = 0) {
  for (let s = 0; s < t; s++) i[e + s] = n;
}
function Mf(i, e = 32) {
  return i instanceof ArrayBuffer ? Array.from(new Uint8Array(i)).map((t) => t.toString(16).padStart(2, "0")).join("") : function(t, n, s = "0") {
    for (; t.length < n; ) t = s + t;
    return t;
  }((i >>> 0).toString(16), e / 4);
}
(function(i) {
  const e = /* @__PURE__ */ new Map([["1", { "Cross-Origin-Opener-Policy": "same-origin" }], ["2", { "Cross-Origin-Embedder-Policy": "require-corp" }], ["3", { "Cross-Origin-Opener-Policy": "same-origin", "Cross-Origin-Embedder-Policy": "require-corp" }]]);
  i.CoopAndCoep = Object.freeze(e.get("3"));
  const t = "vscode-coi";
  i.getHeadersFromQuery = function(n) {
    let s;
    typeof n == "string" ? s = new URL(n).searchParams : n instanceof URL ? s = n.searchParams : Ie.isUri(n) && (s = new URL(n.toString(!0)).searchParams);
    const o = s == null ? void 0 : s.get(t);
    if (o) return e.get(o);
  }, i.addSearchParam = function(n, s, o) {
    if (!globalThis.crossOriginIsolated) return;
    const r = s && o ? "3" : o ? "2" : "1";
    n instanceof URLSearchParams ? n.set(t, r) : n[t] = r;
  };
})(yO || (yO = {}));
class VS {
  constructor() {
    this._h0 = 1732584193, this._h1 = 4023233417, this._h2 = 2562383102, this._h3 = 271733878, this._h4 = 3285377520, this._buff = new Uint8Array(67), this._buffDV = new DataView(this._buff.buffer), this._buffLen = 0, this._totalLen = 0, this._leftoverHighSurrogate = 0, this._finished = !1;
  }
  update(e) {
    const t = e.length;
    if (t === 0) return;
    const n = this._buff;
    let s, o, r = this._buffLen, a = this._leftoverHighSurrogate;
    for (a !== 0 ? (s = a, o = -1, a = 0) : (s = e.charCodeAt(0), o = 0); ; ) {
      let l = s;
      if (en(s)) {
        if (!(o + 1 < t)) {
          a = s;
          break;
        }
        {
          const d = e.charCodeAt(o + 1);
          ag(d) ? (o++, l = rR(s, d)) : l = 65533;
        }
      } else ag(s) && (l = 65533);
      if (r = this._push(n, r, l), o++, !(o < t)) break;
      s = e.charCodeAt(o);
    }
    this._buffLen = r, this._leftoverHighSurrogate = a;
  }
  _push(e, t, n) {
    return n < 128 ? e[t++] = n : n < 2048 ? (e[t++] = 192 | (1984 & n) >>> 6, e[t++] = 128 | (63 & n) >>> 0) : n < 65536 ? (e[t++] = 224 | (61440 & n) >>> 12, e[t++] = 128 | (4032 & n) >>> 6, e[t++] = 128 | (63 & n) >>> 0) : (e[t++] = 240 | (1835008 & n) >>> 18, e[t++] = 128 | (258048 & n) >>> 12, e[t++] = 128 | (4032 & n) >>> 6, e[t++] = 128 | (63 & n) >>> 0), t >= 64 && (this._step(), t -= 64, this._totalLen += 64, e[0] = e[64], e[1] = e[65], e[2] = e[66]), t;
  }
  digest() {
    return this._finished || (this._finished = !0, this._leftoverHighSurrogate && (this._leftoverHighSurrogate = 0, this._buffLen = this._push(this._buff, this._buffLen, 65533)), this._totalLen += this._buffLen, this._wrapUp()), Mf(this._h0) + Mf(this._h1) + Mf(this._h2) + Mf(this._h3) + Mf(this._h4);
  }
  _wrapUp() {
    this._buff[this._buffLen++] = 128, SO(this._buff, this._buffLen), this._buffLen > 56 && (this._step(), SO(this._buff));
    const e = 8 * this._totalLen;
    this._buffDV.setUint32(56, Math.floor(e / 4294967296), !1), this._buffDV.setUint32(60, e % 4294967296, !1), this._step();
  }
  _step() {
    const e = VS._bigBlock32, t = this._buffDV;
    for (let c = 0; c < 64; c += 4) e.setUint32(c, t.getUint32(c, !1), !1);
    for (let c = 64; c < 320; c += 4) e.setUint32(c, Kk(e.getUint32(c - 12, !1) ^ e.getUint32(c - 32, !1) ^ e.getUint32(c - 56, !1) ^ e.getUint32(c - 64, !1), 1), !1);
    let n, s, o, r = this._h0, a = this._h1, l = this._h2, d = this._h3, h = this._h4;
    for (let c = 0; c < 80; c++) c < 20 ? (n = a & l | ~a & d, s = 1518500249) : c < 40 ? (n = a ^ l ^ d, s = 1859775393) : c < 60 ? (n = a & l | a & d | l & d, s = 2400959708) : (n = a ^ l ^ d, s = 3395469782), o = Kk(r, 5) + n + h + s + e.getUint32(4 * c, !1) & 4294967295, h = d, d = l, l = Kk(a, 30), a = r, r = o;
    this._h0 = this._h0 + r & 4294967295, this._h1 = this._h1 + a & 4294967295, this._h2 = this._h2 + l & 4294967295, this._h3 = this._h3 + d & 4294967295, this._h4 = this._h4 + h & 4294967295;
  }
}
VS._bigBlock32 = new DataView(new ArrayBuffer(320));
const { registerWindow: Ice, getWindow: ke, getDocument: Mce, getWindows: f8, getWindowsCount: oj, getWindowId: jw, getWindowById: LO, hasWindow: Tce, onDidRegisterWindow: HS, onWillUnregisterWindow: rj, onDidUnregisterWindow: aj } = function() {
  const i = /* @__PURE__ */ new Map();
  (function(o, r) {
    const a = o;
    typeof a.vscodeWindowId != "number" && Object.defineProperty(a, "vscodeWindowId", { get: () => r });
  })(Et, 1);
  const e = { window: Et, disposables: new G() };
  i.set(Et.vscodeWindowId, e);
  const t = new F(), n = new F(), s = new F();
  return { onDidRegisterWindow: t.event, onWillUnregisterWindow: s.event, onDidUnregisterWindow: n.event, registerWindow(o) {
    if (i.has(o.vscodeWindowId)) return V.None;
    const r = new G(), a = { window: o, disposables: r.add(new G()) };
    return i.set(o.vscodeWindowId, a), r.add(ye(() => {
      i.delete(o.vscodeWindowId), n.fire(o);
    })), r.add(K(o, ie.BEFORE_UNLOAD, () => {
      s.fire(o);
    })), t.fire(a), r;
  }, getWindows: () => i.values(), getWindowsCount: () => i.size, getWindowId: (o) => o.vscodeWindowId, hasWindow: (o) => i.has(o), getWindowById: function(o, r) {
    const a = typeof o == "number" ? i.get(o) : void 0;
    return a ?? (r ? e : void 0);
  }, getWindow(o) {
    var r;
    const a = o;
    if (!((r = a == null ? void 0 : a.ownerDocument) === null || r === void 0) && r.defaultView) return a.ownerDocument.defaultView.window;
    const l = o;
    return l != null && l.view ? l.view.window : Et;
  }, getDocument: (o) => ke(o).document };
}();
function Un(i) {
  for (; i.firstChild; ) i.firstChild.remove();
}
class lj {
  constructor(e, t, n, s) {
    this._node = e, this._type = t, this._handler = n, this._options = s || !1, this._node.addEventListener(this._type, this._handler, this._options);
  }
  dispose() {
    this._handler && (this._node.removeEventListener(this._type, this._handler, this._options), this._node = null, this._handler = null);
  }
}
function K(i, e, t, n) {
  return new lj(i, e, t, n);
}
function _8(i, e) {
  return function(t) {
    return e(new _r(i, t));
  };
}
const bi = function(i, e, t, n) {
  let s = t;
  return e === "click" || e === "mousedown" ? s = _8(ke(i), t) : e !== "keydown" && e !== "keypress" && e !== "keyup" || (s = /* @__PURE__ */ function(o) {
    return function(r) {
      return o(new jt(r));
    };
  }(t)), K(i, e, s, n);
}, dj = function(i, e, t) {
  return function(n, s, o) {
    return K(n, ua && hR ? ie.POINTER_DOWN : ie.MOUSE_DOWN, s, o);
  }(i, _8(ke(i), e), t);
};
function g_(i, e, t) {
  return Uw(i, e, t);
}
class jk extends d8 {
  constructor(e, t) {
    super(e, t);
  }
}
let qw, Ys;
class pR extends uR {
  constructor(e) {
    super(), this.defaultTarget = e && ke(e);
  }
  cancelAndSet(e, t, n) {
    return super.cancelAndSet(e, t, n ?? this.defaultTarget);
  }
}
class qk {
  constructor(e, t = 0) {
    this._runner = e, this.priority = t, this._canceled = !1;
  }
  dispose() {
    this._canceled = !0;
  }
  execute() {
    if (!this._canceled) try {
      this._runner();
    } catch (e) {
      We(e);
    }
  }
  static sort(e, t) {
    return t.priority - e.priority;
  }
}
function zS(i) {
  return ke(i).getComputedStyle(i, null);
}
function wc(i, e) {
  const t = ke(i), n = t.document;
  if (i !== n.body) return new bt(i.clientWidth, i.clientHeight);
  if (ua && (t != null && t.visualViewport)) return new bt(t.visualViewport.width, t.visualViewport.height);
  if (t != null && t.innerWidth && t.innerHeight) return new bt(t.innerWidth, t.innerHeight);
  if (n.body && n.body.clientWidth && n.body.clientHeight) return new bt(n.body.clientWidth, n.body.clientHeight);
  if (n.documentElement && n.documentElement.clientWidth && n.documentElement.clientHeight) return new bt(n.documentElement.clientWidth, n.documentElement.clientHeight);
  throw new Error("Unable to figure out browser width and height");
}
(function() {
  const i = /* @__PURE__ */ new Map(), e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  Ys = (s, o, r = 0) => {
    const a = jw(s), l = new qk(o, r);
    let d = i.get(a);
    return d || (d = [], i.set(a, d)), d.push(l), t.get(a) || (t.set(a, !0), s.requestAnimationFrame(() => ((h) => {
      var c;
      t.set(h, !1);
      const u = (c = i.get(h)) !== null && c !== void 0 ? c : [];
      for (e.set(h, u), i.set(h, []), n.set(h, !0); u.length > 0; ) u.sort(qk.sort), u.shift().execute();
      n.set(h, !1);
    })(a))), l;
  }, qw = (s, o, r) => {
    const a = jw(s);
    if (n.get(a)) {
      const l = new qk(o, r);
      let d = e.get(a);
      return d || (d = [], e.set(a, d)), d.push(l), l;
    }
    return Ys(s, o, r);
  };
})();
class Si {
  static convertToPixels(e, t) {
    return parseFloat(t) || 0;
  }
  static getDimension(e, t, n) {
    const s = zS(e), o = s ? s.getPropertyValue(t) : "0";
    return Si.convertToPixels(e, o);
  }
  static getBorderLeftWidth(e) {
    return Si.getDimension(e, "border-left-width", "borderLeftWidth");
  }
  static getBorderRightWidth(e) {
    return Si.getDimension(e, "border-right-width", "borderRightWidth");
  }
  static getBorderTopWidth(e) {
    return Si.getDimension(e, "border-top-width", "borderTopWidth");
  }
  static getBorderBottomWidth(e) {
    return Si.getDimension(e, "border-bottom-width", "borderBottomWidth");
  }
  static getPaddingLeft(e) {
    return Si.getDimension(e, "padding-left", "paddingLeft");
  }
  static getPaddingRight(e) {
    return Si.getDimension(e, "padding-right", "paddingRight");
  }
  static getPaddingTop(e) {
    return Si.getDimension(e, "padding-top", "paddingTop");
  }
  static getPaddingBottom(e) {
    return Si.getDimension(e, "padding-bottom", "paddingBottom");
  }
  static getMarginLeft(e) {
    return Si.getDimension(e, "margin-left", "marginLeft");
  }
  static getMarginTop(e) {
    return Si.getDimension(e, "margin-top", "marginTop");
  }
  static getMarginRight(e) {
    return Si.getDimension(e, "margin-right", "marginRight");
  }
  static getMarginBottom(e) {
    return Si.getDimension(e, "margin-bottom", "marginBottom");
  }
}
class bt {
  constructor(e, t) {
    this.width = e, this.height = t;
  }
  with(e = this.width, t = this.height) {
    return e !== this.width || t !== this.height ? new bt(e, t) : this;
  }
  static is(e) {
    return typeof e == "object" && typeof e.height == "number" && typeof e.width == "number";
  }
  static lift(e) {
    return e instanceof bt ? e : new bt(e.width, e.height);
  }
  static equals(e, t) {
    return e === t || !(!e || !t) && e.width === t.width && e.height === t.height;
  }
}
function v8(i) {
  let e = i.offsetParent, t = i.offsetTop, n = i.offsetLeft;
  for (; (i = i.parentNode) !== null && i !== i.ownerDocument.body && i !== i.ownerDocument.documentElement; ) {
    t -= i.scrollTop;
    const s = C8(i) ? null : zS(i);
    s && (n -= s.direction !== "rtl" ? i.scrollLeft : -i.scrollLeft), i === e && (n += Si.getBorderLeftWidth(i), t += Si.getBorderTopWidth(i), t += i.offsetTop, n += i.offsetLeft, e = i.offsetParent);
  }
  return { left: n, top: t };
}
function Ti(i) {
  const e = i.getBoundingClientRect(), t = ke(i);
  return { left: e.left + t.scrollX, top: e.top + t.scrollY, width: e.width, height: e.height };
}
function b8(i) {
  let e = i, t = 1;
  do {
    const n = zS(e).zoom;
    n != null && n !== "1" && (t *= n), e = e.parentElement;
  } while (e !== null && e !== e.ownerDocument.documentElement);
  return t;
}
function os(i) {
  const e = Si.getMarginLeft(i) + Si.getMarginRight(i);
  return i.offsetWidth + e;
}
function $k(i) {
  const e = Si.getBorderLeftWidth(i) + Si.getBorderRightWidth(i), t = Si.getPaddingLeft(i) + Si.getPaddingRight(i);
  return i.offsetWidth - e - t;
}
function hj(i) {
  const e = Si.getBorderTopWidth(i) + Si.getBorderBottomWidth(i), t = Si.getPaddingTop(i) + Si.getPaddingBottom(i);
  return i.offsetHeight - e - t;
}
function rd(i) {
  const e = Si.getMarginTop(i) + Si.getMarginBottom(i);
  return i.offsetHeight + e;
}
function gn(i, e) {
  return !!(e != null && e.contains(i));
}
function Gk(i, e, t) {
  return !!function(n, s, o) {
    for (; n && n.nodeType === n.ELEMENT_NODE; ) {
      if (n.classList.contains(s)) return n;
      if (o) {
        if (typeof o == "string") {
          if (n.classList.contains(o)) return null;
        } else if (n === o) return null;
      }
      n = n.parentNode;
    }
    return null;
  }(i, e, t);
}
function C8(i) {
  return i && !!i.host && !!i.mode;
}
function $w(i) {
  return !!dg(i);
}
function dg(i) {
  for (var e; i.parentNode; ) {
    if (i === ((e = i.ownerDocument) === null || e === void 0 ? void 0 : e.body)) return null;
    i = i.parentNode;
  }
  return C8(i) ? i : null;
}
function Mn() {
  let i = gf().activeElement;
  for (; i != null && i.shadowRoot; ) i = i.shadowRoot.activeElement;
  return i;
}
function US(i) {
  return Mn() === i;
}
function w8(i) {
  return gn(Mn(), i);
}
function gf() {
  var i;
  return oj() <= 1 ? Et.document : (i = Array.from(f8()).map(({ window: e }) => e.document).find((e) => e.hasFocus())) !== null && i !== void 0 ? i : Et.document;
}
bt.None = new bt(0, 0);
const mR = /* @__PURE__ */ new Map();
function y8() {
  return new cj();
}
class cj {
  constructor() {
    this._currentCssStyle = "", this._styleSheet = void 0;
  }
  setStyle(e) {
    e !== this._currentCssStyle && (this._currentCssStyle = e, this._styleSheet ? this._styleSheet.innerText = e : this._styleSheet = Lo(Et.document.head, (t) => t.innerText = e));
  }
  dispose() {
    this._styleSheet && (this._styleSheet.remove(), this._styleSheet = void 0);
  }
}
function Lo(i = Et.document.head, e, t) {
  const n = document.createElement("style");
  if (n.type = "text/css", n.media = "screen", e == null || e(n), i.appendChild(n), t && t.add(ye(() => i.removeChild(n))), i === Et.document.head) {
    const s = /* @__PURE__ */ new Set();
    mR.set(n, s);
    for (const { window: o, disposables: r } of f8()) {
      if (o === Et) continue;
      const a = r.add(uj(n, s, o));
      t == null || t.add(a);
    }
  }
  return n;
}
function uj(i, e, t) {
  var n, s;
  const o = new G(), r = i.cloneNode(!0);
  t.document.head.appendChild(r), o.add(ye(() => t.document.head.removeChild(r)));
  for (const a of L8(i)) (n = r.sheet) === null || n === void 0 || n.insertRule(a.cssText, (s = r.sheet) === null || s === void 0 ? void 0 : s.cssRules.length);
  return o.add(gj.observe(i, o, { childList: !0 })(() => {
    r.textContent = i.textContent;
  })), e.add(r), o.add(ye(() => e.delete(r))), o;
}
const gj = new class {
  constructor() {
    this.mutationObservers = /* @__PURE__ */ new Map();
  }
  observe(i, e, t) {
    let n = this.mutationObservers.get(i);
    n || (n = /* @__PURE__ */ new Map(), this.mutationObservers.set(i, n));
    const s = WS(t);
    let o = n.get(s);
    if (o) o.users += 1;
    else {
      const r = new F(), a = new MutationObserver((d) => r.fire(d));
      a.observe(i, t);
      const l = o = { users: 1, observer: a, onDidMutate: r.event };
      e.add(ye(() => {
        l.users -= 1, l.users === 0 && (r.dispose(), a.disconnect(), n == null || n.delete(s), (n == null ? void 0 : n.size) === 0 && this.mutationObservers.delete(i));
      })), n.set(s, o);
    }
    return o.onDidMutate;
  }
}();
let Zk = null;
function S8() {
  return Zk || (Zk = Lo()), Zk;
}
function L8(i) {
  var e, t;
  return !((e = i == null ? void 0 : i.sheet) === null || e === void 0) && e.rules ? i.sheet.rules : !((t = i == null ? void 0 : i.sheet) === null || t === void 0) && t.cssRules ? i.sheet.cssRules : [];
}
function Gw(i, e, t = S8()) {
  var n, s;
  if (t && e) {
    (n = t.sheet) === null || n === void 0 || n.insertRule(`${i} {${e}}`, 0);
    for (const o of (s = mR.get(t)) !== null && s !== void 0 ? s : []) Gw(i, e, o);
  }
}
function ME(i, e = S8()) {
  var t, n;
  if (!e) return;
  const s = L8(e), o = [];
  for (let r = 0; r < s.length; r++) {
    const a = s[r];
    pj(a) && a.selectorText.indexOf(i) !== -1 && o.push(r);
  }
  for (let r = o.length - 1; r >= 0; r--) (t = e.sheet) === null || t === void 0 || t.deleteRule(o[r]);
  for (const r of (n = mR.get(e)) !== null && n !== void 0 ? n : []) ME(i, r);
}
function pj(i) {
  return typeof i.selectorText == "string";
}
function fR(i) {
  return i instanceof MouseEvent || i instanceof ke(i).MouseEvent;
}
function _h(i) {
  return i instanceof KeyboardEvent || i instanceof ke(i).KeyboardEvent;
}
const ie = { CLICK: "click", AUXCLICK: "auxclick", DBLCLICK: "dblclick", MOUSE_UP: "mouseup", MOUSE_DOWN: "mousedown", MOUSE_OVER: "mouseover", MOUSE_MOVE: "mousemove", MOUSE_OUT: "mouseout", MOUSE_ENTER: "mouseenter", MOUSE_LEAVE: "mouseleave", MOUSE_WHEEL: "wheel", POINTER_UP: "pointerup", POINTER_DOWN: "pointerdown", POINTER_MOVE: "pointermove", POINTER_LEAVE: "pointerleave", CONTEXT_MENU: "contextmenu", WHEEL: "wheel", KEY_DOWN: "keydown", KEY_PRESS: "keypress", KEY_UP: "keyup", LOAD: "load", BEFORE_UNLOAD: "beforeunload", UNLOAD: "unload", PAGE_SHOW: "pageshow", PAGE_HIDE: "pagehide", PASTE: "paste", ABORT: "abort", ERROR: "error", RESIZE: "resize", SCROLL: "scroll", FULLSCREEN_CHANGE: "fullscreenchange", WK_FULLSCREEN_CHANGE: "webkitfullscreenchange", SELECT: "select", CHANGE: "change", SUBMIT: "submit", RESET: "reset", FOCUS: "focus", FOCUS_IN: "focusin", FOCUS_OUT: "focusout", BLUR: "blur", INPUT: "input", STORAGE: "storage", DRAG_START: "dragstart", DRAG: "drag", DRAG_ENTER: "dragenter", DRAG_LEAVE: "dragleave", DRAG_OVER: "dragover", DROP: "drop", DRAG_END: "dragend", ANIMATION_START: Uu ? "webkitAnimationStart" : "animationstart", ANIMATION_END: Uu ? "webkitAnimationEnd" : "animationend", ANIMATION_ITERATION: Uu ? "webkitAnimationIteration" : "animationiteration" };
function mj(i) {
  const e = i;
  return !(!e || typeof e.preventDefault != "function" || typeof e.stopPropagation != "function");
}
const Ze = (i, e) => (i.preventDefault(), e && i.stopPropagation(), i);
class Zw extends V {
  static hasFocusWithin(e) {
    if (e instanceof HTMLElement) {
      const t = dg(e);
      return gn(t ? t.activeElement : e.ownerDocument.activeElement, e);
    }
    {
      const t = e;
      return gn(t.document.activeElement, t.document);
    }
  }
  constructor(e) {
    super(), this._onDidFocus = this._register(new F()), this.onDidFocus = this._onDidFocus.event, this._onDidBlur = this._register(new F()), this.onDidBlur = this._onDidBlur.event;
    let t = Zw.hasFocusWithin(e), n = !1;
    const s = () => {
      n = !1, t || (t = !0, this._onDidFocus.fire());
    }, o = () => {
      t && (n = !0, (e instanceof HTMLElement ? ke(e) : e).setTimeout(() => {
        n && (n = !1, t = !1, this._onDidBlur.fire());
      }, 0));
    };
    this._refreshStateHandler = () => {
      Zw.hasFocusWithin(e) !== t && (t ? o() : s());
    }, this._register(K(e, ie.FOCUS, s, !0)), this._register(K(e, ie.BLUR, o, !0)), e instanceof HTMLElement && (this._register(K(e, ie.FOCUS_IN, () => this._refreshStateHandler())), this._register(K(e, ie.FOCUS_OUT, () => this._refreshStateHandler())));
  }
}
function ma(i) {
  return new Zw(i);
}
function Z(i, ...e) {
  if (i.append(...e), e.length === 1 && typeof e[0] != "string") return e[0];
}
function _R(i, e) {
  return i.insertBefore(e, i.firstChild), e;
}
function wn(i, ...e) {
  i.innerText = "", Z(i, ...e);
}
const fj = /([\w\-]+)?(#([\w\-]+))?((\.([\w\-]+))*)/;
var Z_;
function k8(i, e, t, ...n) {
  const s = fj.exec(e);
  if (!s) throw new Error("Bad use of emmet");
  const o = s[1] || "div";
  let r;
  return r = i !== Z_.HTML ? document.createElementNS(i, o) : document.createElement(o), s[3] && (r.id = s[3]), s[4] && (r.className = s[4].replace(/\./g, " ").trim()), t && Object.entries(t).forEach(([a, l]) => {
    l !== void 0 && (/^on\w+$/.test(a) ? r[a] = l : a === "selected" ? l && r.setAttribute(a, "true") : r.setAttribute(a, l));
  }), r.append(...n), r;
}
function Q(i, e, ...t) {
  return k8(Z_.HTML, i, e, ...t);
}
function bo(...i) {
  for (const e of i) e.style.display = "", e.removeAttribute("aria-hidden");
}
function Ts(...i) {
  for (const e of i) e.style.display = "none", e.setAttribute("aria-hidden", "true");
}
function kO(i, e) {
  const t = i.devicePixelRatio * e;
  return Math.max(1, Math.floor(t)) / i.devicePixelRatio;
}
function D8(i) {
  Et.open(i, "_blank", "noopener");
}
function yc(i) {
  return i ? `url('${m8.uriToBrowserUri(i).toString(!0).replace(/'/g, "%27")}')` : "url('')";
}
function DO(i) {
  return `'${i.replace(/'/g, "%27")}'`;
}
function kd(i, e) {
  if (i !== void 0) {
    const t = i.match(/^\s*var\((.+)\)$/);
    if (t) {
      const n = t[1].split(",", 2);
      return n.length === 2 && (e = kd(n[1].trim(), e)), `var(${n[0]}, ${e})`;
    }
    return i;
  }
  return e;
}
(function(i) {
  i.HTML = "http://www.w3.org/1999/xhtml", i.SVG = "http://www.w3.org/2000/svg";
})(Z_ || (Z_ = {})), Q.SVG = function(i, e, ...t) {
  return k8(Z_.SVG, i, e, ...t);
}, p8.setPreferredWebSchema(/^https:/.test(Et.location.href) ? "https" : "http");
const _j = Object.freeze(["a", "abbr", "b", "bdo", "blockquote", "br", "caption", "cite", "code", "col", "colgroup", "dd", "del", "details", "dfn", "div", "dl", "dt", "em", "figcaption", "figure", "h1", "h2", "h3", "h4", "h5", "h6", "hr", "i", "img", "input", "ins", "kbd", "label", "li", "mark", "ol", "p", "pre", "q", "rp", "rt", "ruby", "samp", "small", "small", "source", "span", "strike", "strong", "sub", "summary", "sup", "table", "tbody", "td", "tfoot", "th", "thead", "time", "tr", "tt", "u", "ul", "var", "video", "wbr"]);
class ad extends F {
  constructor() {
    super(), this._subscriptions = new G(), this._keyStatus = { altKey: !1, shiftKey: !1, ctrlKey: !1, metaKey: !1 }, this._subscriptions.add(se.runAndSubscribe(HS, ({ window: e, disposables: t }) => this.registerListeners(e, t), { window: Et, disposables: this._subscriptions }));
  }
  registerListeners(e, t) {
    t.add(K(e, "keydown", (n) => {
      if (n.defaultPrevented) return;
      const s = new jt(n);
      if (s.keyCode !== 6 || !n.repeat) {
        if (n.altKey && !this._keyStatus.altKey) this._keyStatus.lastKeyPressed = "alt";
        else if (n.ctrlKey && !this._keyStatus.ctrlKey) this._keyStatus.lastKeyPressed = "ctrl";
        else if (n.metaKey && !this._keyStatus.metaKey) this._keyStatus.lastKeyPressed = "meta";
        else if (n.shiftKey && !this._keyStatus.shiftKey) this._keyStatus.lastKeyPressed = "shift";
        else {
          if (s.keyCode === 6) return;
          this._keyStatus.lastKeyPressed = void 0;
        }
        this._keyStatus.altKey = n.altKey, this._keyStatus.ctrlKey = n.ctrlKey, this._keyStatus.metaKey = n.metaKey, this._keyStatus.shiftKey = n.shiftKey, this._keyStatus.lastKeyPressed && (this._keyStatus.event = n, this.fire(this._keyStatus));
      }
    }, !0)), t.add(K(e, "keyup", (n) => {
      n.defaultPrevented || (!n.altKey && this._keyStatus.altKey ? this._keyStatus.lastKeyReleased = "alt" : !n.ctrlKey && this._keyStatus.ctrlKey ? this._keyStatus.lastKeyReleased = "ctrl" : !n.metaKey && this._keyStatus.metaKey ? this._keyStatus.lastKeyReleased = "meta" : !n.shiftKey && this._keyStatus.shiftKey ? this._keyStatus.lastKeyReleased = "shift" : this._keyStatus.lastKeyReleased = void 0, this._keyStatus.lastKeyPressed !== this._keyStatus.lastKeyReleased && (this._keyStatus.lastKeyPressed = void 0), this._keyStatus.altKey = n.altKey, this._keyStatus.ctrlKey = n.ctrlKey, this._keyStatus.metaKey = n.metaKey, this._keyStatus.shiftKey = n.shiftKey, this._keyStatus.lastKeyReleased && (this._keyStatus.event = n, this.fire(this._keyStatus)));
    }, !0)), t.add(K(e.document.body, "mousedown", () => {
      this._keyStatus.lastKeyPressed = void 0;
    }, !0)), t.add(K(e.document.body, "mouseup", () => {
      this._keyStatus.lastKeyPressed = void 0;
    }, !0)), t.add(K(e.document.body, "mousemove", (n) => {
      n.buttons && (this._keyStatus.lastKeyPressed = void 0);
    }, !0)), t.add(K(e, "blur", () => {
      this.resetKeyStatus();
    }));
  }
  get keyStatus() {
    return this._keyStatus;
  }
  resetKeyStatus() {
    this.doResetKeyStatus(), this.fire(this._keyStatus);
  }
  doResetKeyStatus() {
    this._keyStatus = { altKey: !1, shiftKey: !1, ctrlKey: !1, metaKey: !1 };
  }
  static getInstance() {
    return ad.instance || (ad.instance = new ad()), ad.instance;
  }
  dispose() {
    super.dispose(), this._subscriptions.dispose();
  }
}
class vj extends V {
  constructor(e, t) {
    super(), this.element = e, this.callbacks = t, this.counter = 0, this.dragStartTime = 0, this.registerListeners();
  }
  registerListeners() {
    this.callbacks.onDragStart && this._register(K(this.element, ie.DRAG_START, (e) => {
      var t, n;
      (n = (t = this.callbacks).onDragStart) === null || n === void 0 || n.call(t, e);
    })), this.callbacks.onDrag && this._register(K(this.element, ie.DRAG, (e) => {
      var t, n;
      (n = (t = this.callbacks).onDrag) === null || n === void 0 || n.call(t, e);
    })), this._register(K(this.element, ie.DRAG_ENTER, (e) => {
      var t, n;
      this.counter++, this.dragStartTime = e.timeStamp, (n = (t = this.callbacks).onDragEnter) === null || n === void 0 || n.call(t, e);
    })), this._register(K(this.element, ie.DRAG_OVER, (e) => {
      var t, n;
      e.preventDefault(), (n = (t = this.callbacks).onDragOver) === null || n === void 0 || n.call(t, e, e.timeStamp - this.dragStartTime);
    })), this._register(K(this.element, ie.DRAG_LEAVE, (e) => {
      var t, n;
      this.counter--, this.counter === 0 && (this.dragStartTime = 0, (n = (t = this.callbacks).onDragLeave) === null || n === void 0 || n.call(t, e));
    })), this._register(K(this.element, ie.DRAG_END, (e) => {
      var t, n;
      this.counter = 0, this.dragStartTime = 0, (n = (t = this.callbacks).onDragEnd) === null || n === void 0 || n.call(t, e);
    })), this._register(K(this.element, ie.DROP, (e) => {
      var t, n;
      this.counter = 0, this.dragStartTime = 0, (n = (t = this.callbacks).onDrop) === null || n === void 0 || n.call(t, e);
    }));
  }
}
const bj = /(?<tag>[\w\-]+)?(?:#(?<id>[\w\-]+))?(?<class>(?:\.(?:[\w\-]+))*)(?:@(?<name>(?:[\w\_])+))?/;
function yt(i, ...e) {
  let t, n;
  Array.isArray(e[0]) ? (t = {}, n = e[0]) : (t = e[0] || {}, n = e[1]);
  const s = bj.exec(i);
  if (!s || !s.groups) throw new Error("Bad use of h");
  const o = s.groups.tag || "div", r = document.createElement(o);
  s.groups.id && (r.id = s.groups.id);
  const a = [];
  if (s.groups.class) for (const d of s.groups.class.split(".")) d !== "" && a.push(d);
  if (t.className !== void 0) for (const d of t.className.split(".")) d !== "" && a.push(d);
  a.length > 0 && (r.className = a.join(" "));
  const l = {};
  if (s.groups.name && (l[s.groups.name] = r), n) for (const d of n) d instanceof HTMLElement ? r.appendChild(d) : typeof d == "string" ? r.append(d) : "root" in d && (Object.assign(l, d), r.appendChild(d.root));
  for (const [d, h] of Object.entries(t)) if (d !== "className") if (d === "style") for (const [c, u] of Object.entries(h)) r.style.setProperty(xO(c), typeof u == "number" ? u + "px" : "" + u);
  else d === "tabIndex" ? r.tabIndex = h : r.setAttribute(xO(d), h.toString());
  return l.root = r, l;
}
function xO(i) {
  return i.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
class Cj extends V {
  constructor(e) {
    super(), this._onDidChange = this._register(new F()), this.onDidChange = this._onDidChange.event, this._listener = () => this._handleChange(e, !0), this._mediaQueryList = null, this._handleChange(e, !1);
  }
  _handleChange(e, t) {
    var n;
    (n = this._mediaQueryList) === null || n === void 0 || n.removeEventListener("change", this._listener), this._mediaQueryList = e.matchMedia(`(resolution: ${e.devicePixelRatio}dppx)`), this._mediaQueryList.addEventListener("change", this._listener), t && this._onDidChange.fire();
  }
}
class wj extends V {
  get value() {
    return this._value;
  }
  constructor(e) {
    super(), this._onDidChange = this._register(new F()), this.onDidChange = this._onDidChange.event, this._value = this._getPixelRatio(e);
    const t = this._register(new Cj(e));
    this._register(t.onDidChange(() => {
      this._value = this._getPixelRatio(e), this._onDidChange.fire(this._value);
    }));
  }
  _getPixelRatio(e) {
    const t = document.createElement("canvas").getContext("2d");
    return (e.devicePixelRatio || 1) / (t.webkitBackingStorePixelRatio || t.mozBackingStorePixelRatio || t.msBackingStorePixelRatio || t.oBackingStorePixelRatio || t.backingStorePixelRatio || 1);
  }
}
const ev = new class {
  constructor() {
    this.mapWindowIdToPixelRatioMonitor = /* @__PURE__ */ new Map();
  }
  _getOrCreatePixelRatioMonitor(i) {
    const e = jw(i);
    let t = this.mapWindowIdToPixelRatioMonitor.get(e);
    return t || (t = new wj(i), this.mapWindowIdToPixelRatioMonitor.set(e, t), se.once(aj)(({ vscodeWindowId: n }) => {
      n === e && (t == null || t.dispose(), this.mapWindowIdToPixelRatioMonitor.delete(e));
    })), t;
  }
  getInstance(i) {
    return this._getOrCreatePixelRatioMonitor(i);
  }
}();
class x8 {
  constructor(e) {
    this.domNode = e, this._maxWidth = "", this._width = "", this._height = "", this._top = "", this._left = "", this._bottom = "", this._right = "", this._paddingLeft = "", this._fontFamily = "", this._fontWeight = "", this._fontSize = "", this._fontStyle = "", this._fontFeatureSettings = "", this._fontVariationSettings = "", this._textDecoration = "", this._lineHeight = "", this._letterSpacing = "", this._className = "", this._display = "", this._position = "", this._visibility = "", this._color = "", this._backgroundColor = "", this._layerHint = !1, this._contain = "none", this._boxShadow = "";
  }
  setMaxWidth(e) {
    const t = Rr(e);
    this._maxWidth !== t && (this._maxWidth = t, this.domNode.style.maxWidth = this._maxWidth);
  }
  setWidth(e) {
    const t = Rr(e);
    this._width !== t && (this._width = t, this.domNode.style.width = this._width);
  }
  setHeight(e) {
    const t = Rr(e);
    this._height !== t && (this._height = t, this.domNode.style.height = this._height);
  }
  setTop(e) {
    const t = Rr(e);
    this._top !== t && (this._top = t, this.domNode.style.top = this._top);
  }
  setLeft(e) {
    const t = Rr(e);
    this._left !== t && (this._left = t, this.domNode.style.left = this._left);
  }
  setBottom(e) {
    const t = Rr(e);
    this._bottom !== t && (this._bottom = t, this.domNode.style.bottom = this._bottom);
  }
  setRight(e) {
    const t = Rr(e);
    this._right !== t && (this._right = t, this.domNode.style.right = this._right);
  }
  setPaddingLeft(e) {
    const t = Rr(e);
    this._paddingLeft !== t && (this._paddingLeft = t, this.domNode.style.paddingLeft = this._paddingLeft);
  }
  setFontFamily(e) {
    this._fontFamily !== e && (this._fontFamily = e, this.domNode.style.fontFamily = this._fontFamily);
  }
  setFontWeight(e) {
    this._fontWeight !== e && (this._fontWeight = e, this.domNode.style.fontWeight = this._fontWeight);
  }
  setFontSize(e) {
    const t = Rr(e);
    this._fontSize !== t && (this._fontSize = t, this.domNode.style.fontSize = this._fontSize);
  }
  setFontStyle(e) {
    this._fontStyle !== e && (this._fontStyle = e, this.domNode.style.fontStyle = this._fontStyle);
  }
  setFontFeatureSettings(e) {
    this._fontFeatureSettings !== e && (this._fontFeatureSettings = e, this.domNode.style.fontFeatureSettings = this._fontFeatureSettings);
  }
  setFontVariationSettings(e) {
    this._fontVariationSettings !== e && (this._fontVariationSettings = e, this.domNode.style.fontVariationSettings = this._fontVariationSettings);
  }
  setTextDecoration(e) {
    this._textDecoration !== e && (this._textDecoration = e, this.domNode.style.textDecoration = this._textDecoration);
  }
  setLineHeight(e) {
    const t = Rr(e);
    this._lineHeight !== t && (this._lineHeight = t, this.domNode.style.lineHeight = this._lineHeight);
  }
  setLetterSpacing(e) {
    const t = Rr(e);
    this._letterSpacing !== t && (this._letterSpacing = t, this.domNode.style.letterSpacing = this._letterSpacing);
  }
  setClassName(e) {
    this._className !== e && (this._className = e, this.domNode.className = this._className);
  }
  toggleClassName(e, t) {
    this.domNode.classList.toggle(e, t), this._className = this.domNode.className;
  }
  setDisplay(e) {
    this._display !== e && (this._display = e, this.domNode.style.display = this._display);
  }
  setPosition(e) {
    this._position !== e && (this._position = e, this.domNode.style.position = this._position);
  }
  setVisibility(e) {
    this._visibility !== e && (this._visibility = e, this.domNode.style.visibility = this._visibility);
  }
  setColor(e) {
    this._color !== e && (this._color = e, this.domNode.style.color = this._color);
  }
  setBackgroundColor(e) {
    this._backgroundColor !== e && (this._backgroundColor = e, this.domNode.style.backgroundColor = this._backgroundColor);
  }
  setLayerHinting(e) {
    this._layerHint !== e && (this._layerHint = e, this.domNode.style.transform = this._layerHint ? "translate3d(0px, 0px, 0px)" : "");
  }
  setBoxShadow(e) {
    this._boxShadow !== e && (this._boxShadow = e, this.domNode.style.boxShadow = e);
  }
  setContain(e) {
    this._contain !== e && (this._contain = e, this.domNode.style.contain = this._contain);
  }
  setAttribute(e, t) {
    this.domNode.setAttribute(e, t);
  }
  removeAttribute(e) {
    this.domNode.removeAttribute(e);
  }
  appendChild(e) {
    this.domNode.appendChild(e.domNode);
  }
  removeChild(e) {
    this.domNode.removeChild(e.domNode);
  }
}
function Rr(i) {
  return typeof i == "number" ? `${i}px` : i;
}
function wt(i) {
  return new x8(i);
}
function yn(i, e) {
  i instanceof x8 ? (i.setFontFamily(e.getMassagedFontFamily()), i.setFontWeight(e.fontWeight), i.setFontSize(e.fontSize), i.setFontFeatureSettings(e.fontFeatureSettings), i.setFontVariationSettings(e.fontVariationSettings), i.setLineHeight(e.lineHeight), i.setLetterSpacing(e.letterSpacing)) : (i.style.fontFamily = e.getMassagedFontFamily(), i.style.fontWeight = e.fontWeight, i.style.fontSize = e.fontSize + "px", i.style.fontFeatureSettings = e.fontFeatureSettings, i.style.fontVariationSettings = e.fontVariationSettings, i.style.lineHeight = e.lineHeight + "px", i.style.letterSpacing = e.letterSpacing + "px");
}
class yj {
  constructor(e, t) {
    this.chr = e, this.type = t, this.width = 0;
  }
  fulfill(e) {
    this.width = e;
  }
}
class vR {
  constructor(e, t) {
    this._bareFontInfo = e, this._requests = t, this._container = null, this._testElements = null;
  }
  read(e) {
    this._createDomElements(), e.document.body.appendChild(this._container), this._readFromDomElements(), e.document.body.removeChild(this._container), this._container = null, this._testElements = null;
  }
  _createDomElements() {
    const e = document.createElement("div");
    e.style.position = "absolute", e.style.top = "-50000px", e.style.width = "50000px";
    const t = document.createElement("div");
    yn(t, this._bareFontInfo), e.appendChild(t);
    const n = document.createElement("div");
    yn(n, this._bareFontInfo), n.style.fontWeight = "bold", e.appendChild(n);
    const s = document.createElement("div");
    yn(s, this._bareFontInfo), s.style.fontStyle = "italic", e.appendChild(s);
    const o = [];
    for (const r of this._requests) {
      let a;
      r.type === 0 && (a = t), r.type === 2 && (a = n), r.type === 1 && (a = s), a.appendChild(document.createElement("br"));
      const l = document.createElement("span");
      vR._render(l, r), a.appendChild(l), o.push(l);
    }
    this._container = e, this._testElements = o;
  }
  static _render(e, t) {
    if (t.chr === " ") {
      let n = " ";
      for (let s = 0; s < 8; s++) n += n;
      e.innerText = n;
    } else {
      let n = t.chr;
      for (let s = 0; s < 8; s++) n += n;
      e.textContent = n;
    }
  }
  _readFromDomElements() {
    for (let e = 0, t = this._requests.length; e < t; e++) {
      const n = this._requests[e], s = this._testElements[e];
      n.fulfill(s.offsetWidth / 256);
    }
  }
}
const Vo = new class {
  constructor() {
    this._zoomLevel = 0, this._onDidChangeZoomLevel = new F(), this.onDidChangeZoomLevel = this._onDidChangeZoomLevel.event;
  }
  getZoomLevel() {
    return this._zoomLevel;
  }
  setZoomLevel(i) {
    i = Math.min(Math.max(-5, i), 20), this._zoomLevel !== i && (this._zoomLevel = i, this._onDidChangeZoomLevel.fire(this._zoomLevel));
  }
}(), Sj = Je ? 1.5 : 1.35;
class Ku {
  static createFromValidatedSettings(e, t, n) {
    const s = e.get(49), o = e.get(53), r = e.get(52), a = e.get(51), l = e.get(54), d = e.get(67), h = e.get(64);
    return Ku._create(s, o, r, a, l, d, h, t, n);
  }
  static _create(e, t, n, s, o, r, a, l, d) {
    r === 0 ? r = Sj * n : r < 8 && (r *= n), (r = Math.round(r)) < 8 && (r = 8);
    const h = 1 + (d ? 0 : 0.1 * Vo.getZoomLevel());
    return n *= h, r *= h, o === Xr.TRANSLATE && (t === "normal" || t === "bold" ? o = Xr.OFF : (o = `'wght' ${parseInt(t, 10)}`, t = "normal")), new Ku({ pixelRatio: l, fontFamily: e, fontWeight: t, fontSize: n, fontFeatureSettings: s, fontVariationSettings: o, lineHeight: r, letterSpacing: a });
  }
  constructor(e) {
    this._bareFontInfoBrand = void 0, this.pixelRatio = e.pixelRatio, this.fontFamily = String(e.fontFamily), this.fontWeight = String(e.fontWeight), this.fontSize = e.fontSize, this.fontFeatureSettings = e.fontFeatureSettings, this.fontVariationSettings = e.fontVariationSettings, this.lineHeight = 0 | e.lineHeight, this.letterSpacing = e.letterSpacing;
  }
  getId() {
    return `${this.pixelRatio}-${this.fontFamily}-${this.fontWeight}-${this.fontSize}-${this.fontFeatureSettings}-${this.fontVariationSettings}-${this.lineHeight}-${this.letterSpacing}`;
  }
  getMassagedFontFamily() {
    const e = Is.fontFamily, t = Ku._wrapInQuotes(this.fontFamily);
    return e && this.fontFamily !== e ? `${t}, ${e}` : t;
  }
  static _wrapInQuotes(e) {
    return /[,"']/.test(e) ? e : /[+ ]/.test(e) ? `"${e}"` : e;
  }
}
class TE extends Ku {
  constructor(e, t) {
    super(e), this._editorStylingBrand = void 0, this.version = 2, this.isTrusted = t, this.isMonospace = e.isMonospace, this.typicalHalfwidthCharacterWidth = e.typicalHalfwidthCharacterWidth, this.typicalFullwidthCharacterWidth = e.typicalFullwidthCharacterWidth, this.canUseHalfwidthRightwardsArrow = e.canUseHalfwidthRightwardsArrow, this.spaceWidth = e.spaceWidth, this.middotWidth = e.middotWidth, this.wsmiddotWidth = e.wsmiddotWidth, this.maxDigitWidth = e.maxDigitWidth;
  }
  equals(e) {
    return this.fontFamily === e.fontFamily && this.fontWeight === e.fontWeight && this.fontSize === e.fontSize && this.fontFeatureSettings === e.fontFeatureSettings && this.fontVariationSettings === e.fontVariationSettings && this.lineHeight === e.lineHeight && this.letterSpacing === e.letterSpacing && this.typicalHalfwidthCharacterWidth === e.typicalHalfwidthCharacterWidth && this.typicalFullwidthCharacterWidth === e.typicalFullwidthCharacterWidth && this.canUseHalfwidthRightwardsArrow === e.canUseHalfwidthRightwardsArrow && this.spaceWidth === e.spaceWidth && this.middotWidth === e.middotWidth && this.wsmiddotWidth === e.wsmiddotWidth && this.maxDigitWidth === e.maxDigitWidth;
  }
}
class Lj {
  constructor() {
    this._keys = /* @__PURE__ */ Object.create(null), this._values = /* @__PURE__ */ Object.create(null);
  }
  has(e) {
    const t = e.getId();
    return !!this._values[t];
  }
  get(e) {
    const t = e.getId();
    return this._values[t];
  }
  put(e, t) {
    const n = e.getId();
    this._keys[n] = e, this._values[n] = t;
  }
  remove(e) {
    const t = e.getId();
    delete this._keys[t], delete this._values[t];
  }
  getValues() {
    return Object.keys(this._keys).map((e) => this._values[e]);
  }
}
const RE = new class extends V {
  constructor() {
    super(...arguments), this._cache = /* @__PURE__ */ new Map(), this._evictUntrustedReadingsTimeout = -1, this._onDidChange = this._register(new F()), this.onDidChange = this._onDidChange.event;
  }
  dispose() {
    this._evictUntrustedReadingsTimeout !== -1 && (clearTimeout(this._evictUntrustedReadingsTimeout), this._evictUntrustedReadingsTimeout = -1), super.dispose();
  }
  clearAllFontInfos() {
    this._cache.clear(), this._onDidChange.fire();
  }
  _ensureCache(i) {
    const e = jw(i);
    let t = this._cache.get(e);
    return t || (t = new Lj(), this._cache.set(e, t)), t;
  }
  _writeToCache(i, e, t) {
    this._ensureCache(i).put(e, t), t.isTrusted || this._evictUntrustedReadingsTimeout !== -1 || (this._evictUntrustedReadingsTimeout = i.setTimeout(() => {
      this._evictUntrustedReadingsTimeout = -1, this._evictUntrustedReadings(i);
    }, 5e3));
  }
  _evictUntrustedReadings(i) {
    const e = this._ensureCache(i), t = e.getValues();
    let n = !1;
    for (const s of t) s.isTrusted || (n = !0, e.remove(s));
    n && this._onDidChange.fire();
  }
  readFontInfo(i, e) {
    const t = this._ensureCache(i);
    if (!t.has(e)) {
      let n = this._actualReadFontInfo(i, e);
      (n.typicalHalfwidthCharacterWidth <= 2 || n.typicalFullwidthCharacterWidth <= 2 || n.spaceWidth <= 2 || n.maxDigitWidth <= 2) && (n = new TE({ pixelRatio: ev.getInstance(i).value, fontFamily: n.fontFamily, fontWeight: n.fontWeight, fontSize: n.fontSize, fontFeatureSettings: n.fontFeatureSettings, fontVariationSettings: n.fontVariationSettings, lineHeight: n.lineHeight, letterSpacing: n.letterSpacing, isMonospace: n.isMonospace, typicalHalfwidthCharacterWidth: Math.max(n.typicalHalfwidthCharacterWidth, 5), typicalFullwidthCharacterWidth: Math.max(n.typicalFullwidthCharacterWidth, 5), canUseHalfwidthRightwardsArrow: n.canUseHalfwidthRightwardsArrow, spaceWidth: Math.max(n.spaceWidth, 5), middotWidth: Math.max(n.middotWidth, 5), wsmiddotWidth: Math.max(n.wsmiddotWidth, 5), maxDigitWidth: Math.max(n.maxDigitWidth, 5) }, !1)), this._writeToCache(i, e, n);
    }
    return t.get(e);
  }
  _createRequest(i, e, t, n) {
    const s = new yj(i, e);
    return t.push(s), n == null || n.push(s), s;
  }
  _actualReadFontInfo(i, e) {
    const t = [], n = [], s = this._createRequest("n", 0, t, n), o = this._createRequest("ｍ", 0, t, null), r = this._createRequest(" ", 0, t, n), a = this._createRequest("0", 0, t, n), l = this._createRequest("1", 0, t, n), d = this._createRequest("2", 0, t, n), h = this._createRequest("3", 0, t, n), c = this._createRequest("4", 0, t, n), u = this._createRequest("5", 0, t, n), g = this._createRequest("6", 0, t, n), p = this._createRequest("7", 0, t, n), f = this._createRequest("8", 0, t, n), _ = this._createRequest("9", 0, t, n), v = this._createRequest("→", 0, t, n), b = this._createRequest("￫", 0, t, null), C = this._createRequest("·", 0, t, n), w = this._createRequest("⸱", 0, t, null), y = "|/-_ilm%";
    for (let B = 0, T = 8; B < T; B++) this._createRequest(y.charAt(B), 0, t, n), this._createRequest(y.charAt(B), 1, t, n), this._createRequest(y.charAt(B), 2, t, n);
    (function(B, T, O) {
      new vR(T, O).read(B);
    })(i, e, t);
    const L = Math.max(a.width, l.width, d.width, h.width, c.width, u.width, g.width, p.width, f.width, _.width);
    let k = e.fontFeatureSettings === fo.OFF;
    const N = n[0].width;
    for (let B = 1, T = n.length; k && B < T; B++) {
      const O = N - n[B].width;
      if (O < -1e-3 || O > 1e-3) {
        k = !1;
        break;
      }
    }
    let A = !0;
    return k && b.width !== N && (A = !1), b.width > v.width && (A = !1), new TE({ pixelRatio: ev.getInstance(i).value, fontFamily: e.fontFamily, fontWeight: e.fontWeight, fontSize: e.fontSize, fontFeatureSettings: e.fontFeatureSettings, fontVariationSettings: e.fontVariationSettings, lineHeight: e.lineHeight, letterSpacing: e.letterSpacing, isMonospace: k, typicalHalfwidthCharacterWidth: s.width, typicalFullwidthCharacterWidth: o.width, canUseHalfwidthRightwardsArrow: A, spaceWidth: r.width, middotWidth: C.width, wsmiddotWidth: w.width, maxDigitWidth: L }, !0);
  }
}();
var zr;
(function(i) {
  i.serviceIds = /* @__PURE__ */ new Map(), i.DI_TARGET = "$di$target", i.DI_DEPENDENCIES = "$di$dependencies", i.getServiceDependencies = function(e) {
    return e[i.DI_DEPENDENCIES] || [];
  };
})(zr || (zr = {}));
const Se = tt("instantiationService");
function tt(i) {
  if (zr.serviceIds.has(i)) return zr.serviceIds.get(i);
  const e = function(t, n, s) {
    if (arguments.length !== 3) throw new Error("@IServiceName-decorator can only be used to decorate a parameter");
    (function(o, r, a) {
      r[zr.DI_TARGET] === r ? r[zr.DI_DEPENDENCIES].push({ id: o, index: a }) : (r[zr.DI_DEPENDENCIES] = [{ id: o, index: a }], r[zr.DI_TARGET] = r);
    })(e, t, s);
  };
  return e.toString = () => i, zr.serviceIds.set(i, e), e;
}
const mt = tt("codeEditorService"), ni = tt("modelService"), Ps = tt("textModelService");
class Qs extends V {
  constructor(e, t = "", n = "", s = !0, o) {
    super(), this._onDidChange = this._register(new F()), this.onDidChange = this._onDidChange.event, this._enabled = !0, this._id = e, this._label = t, this._cssClass = n, this._enabled = s, this._actionCallback = o;
  }
  get id() {
    return this._id;
  }
  get label() {
    return this._label;
  }
  set label(e) {
    this._setLabel(e);
  }
  _setLabel(e) {
    this._label !== e && (this._label = e, this._onDidChange.fire({ label: e }));
  }
  get tooltip() {
    return this._tooltip || "";
  }
  set tooltip(e) {
    this._setTooltip(e);
  }
  _setTooltip(e) {
    this._tooltip !== e && (this._tooltip = e, this._onDidChange.fire({ tooltip: e }));
  }
  get class() {
    return this._cssClass;
  }
  set class(e) {
    this._setClass(e);
  }
  _setClass(e) {
    this._cssClass !== e && (this._cssClass = e, this._onDidChange.fire({ class: e }));
  }
  get enabled() {
    return this._enabled;
  }
  set enabled(e) {
    this._setEnabled(e);
  }
  _setEnabled(e) {
    this._enabled !== e && (this._enabled = e, this._onDidChange.fire({ enabled: e }));
  }
  get checked() {
    return this._checked;
  }
  set checked(e) {
    this._setChecked(e);
  }
  _setChecked(e) {
    this._checked !== e && (this._checked = e, this._onDidChange.fire({ checked: e }));
  }
  async run(e, t) {
    this._actionCallback && await this._actionCallback(e);
  }
}
class hg extends V {
  constructor() {
    super(...arguments), this._onWillRun = this._register(new F()), this.onWillRun = this._onWillRun.event, this._onDidRun = this._register(new F()), this.onDidRun = this._onDidRun.event;
  }
  async run(e, t) {
    if (!e.enabled) return;
    let n;
    this._onWillRun.fire({ action: e });
    try {
      await this.runAction(e, t);
    } catch (s) {
      n = s;
    }
    this._onDidRun.fire({ action: e, error: n });
  }
  async runAction(e, t) {
    await e.run(t);
  }
}
class Ui {
  constructor() {
    this.id = Ui.ID, this.label = "", this.tooltip = "", this.class = "separator", this.enabled = !1, this.checked = !1;
  }
  static join(...e) {
    let t = [];
    for (const n of e) n.length && (t = t.length ? [...t, new Ui(), ...n] : n);
    return t;
  }
  async run() {
  }
}
Ui.ID = "vs.actions.separator";
class Bm {
  get actions() {
    return this._actions;
  }
  constructor(e, t, n, s) {
    this.tooltip = "", this.enabled = !0, this.checked = void 0, this.id = e, this.label = t, this.class = s, this._actions = n;
  }
  async run() {
  }
}
class KS extends Qs {
  constructor() {
    super(KS.ID, m(0, "(empty)"), void 0, !1);
  }
}
function Qp(i) {
  var e;
  return { id: i.id, label: i.label, class: i.class, enabled: (e = i.enabled) === null || e === void 0 || e, checked: i.checked, run: async (...t) => i.run(...t), tooltip: i.label };
}
var Yk, Ee;
KS.ID = "vs.actions.empty", function(i) {
  i.isThemeColor = function(e) {
    return e && typeof e == "object" && typeof e.id == "string";
  };
}(Yk || (Yk = {})), function(i) {
  i.iconNameSegment = "[A-Za-z0-9]+", i.iconNameExpression = "[A-Za-z0-9-]+", i.iconModifierExpression = "~[A-Za-z]+", i.iconNameCharacter = "[A-Za-z0-9~-]";
  const e = new RegExp(`^(${i.iconNameExpression})(${i.iconModifierExpression})?$`);
  function t(s) {
    const o = e.exec(s.id);
    if (!o) return t(ne.error);
    const [, r, a] = o, l = ["codicon", "codicon-" + r];
    return a && l.push("codicon-modifier-" + a.substring(1)), l;
  }
  i.asClassNameArray = t, i.asClassName = function(s) {
    return t(s).join(" ");
  }, i.asCSSSelector = function(s) {
    return "." + t(s).join(".");
  }, i.isThemeIcon = function(s) {
    return s && typeof s == "object" && typeof s.id == "string" && (s.color === void 0 || Yk.isThemeColor(s.color));
  };
  const n = new RegExp(`^\\$\\((${i.iconNameExpression}(?:${i.iconModifierExpression})?)\\)$`);
  i.fromString = function(s) {
    const o = n.exec(s);
    if (!o) return;
    const [, r] = o;
    return { id: r };
  }, i.fromId = function(s) {
    return { id: s };
  }, i.modify = function(s, o) {
    let r = s.id;
    const a = r.lastIndexOf("~");
    return a !== -1 && (r = r.substring(0, a)), o && (r = `${r}~${o}`), { id: r };
  }, i.getModifier = function(s) {
    const o = s.id.lastIndexOf("~");
    if (o !== -1) return s.id.substring(o + 1);
  }, i.isEqual = function(s, o) {
    var r, a;
    return s.id === o.id && ((r = s.color) === null || r === void 0 ? void 0 : r.id) === ((a = o.color) === null || a === void 0 ? void 0 : a.id);
  };
}(Ee || (Ee = {}));
const ai = tt("commandService"), dt = new class {
  constructor() {
    this._commands = /* @__PURE__ */ new Map(), this._onDidRegisterCommand = new F(), this.onDidRegisterCommand = this._onDidRegisterCommand.event;
  }
  registerCommand(i, e) {
    if (!i) throw new Error("invalid command");
    if (typeof i == "string") {
      if (!e) throw new Error("invalid command");
      return this.registerCommand({ id: i, handler: e });
    }
    if (i.metadata && Array.isArray(i.metadata.args)) {
      const r = [];
      for (const l of i.metadata.args) r.push(l.constraint);
      const a = i.handler;
      i.handler = function(l, ...d) {
        return function(h, c) {
          const u = Math.min(h.length, c.length);
          for (let g = 0; g < u; g++) jU(h[g], c[g]);
        }(d, r), a(l, ...d);
      };
    }
    const { id: t } = i;
    let n = this._commands.get(t);
    n || (n = new fs(), this._commands.set(t, n));
    const s = n.unshift(i), o = ye(() => {
      s();
      const r = this._commands.get(t);
      r != null && r.isEmpty() && this._commands.delete(t);
    });
    return this._onDidRegisterCommand.fire(t), o;
  }
  registerCommandAlias(i, e) {
    return dt.registerCommand(i, (t, ...n) => t.get(ai).executeCommand(e, ...n));
  }
  getCommand(i) {
    const e = this._commands.get(i);
    if (e && !e.isEmpty()) return at.first(e);
  }
  getCommands() {
    const i = /* @__PURE__ */ new Map();
    for (const e of this._commands.keys()) {
      const t = this.getCommand(e);
      t && i.set(e, t);
    }
    return i;
  }
}();
function Xk(...i) {
  switch (i.length) {
    case 1:
      return m(0, "Did you mean {0}?", i[0]);
    case 2:
      return m(0, "Did you mean {0} or {1}?", i[0], i[1]);
    case 3:
      return m(0, "Did you mean {0}, {1} or {2}?", i[0], i[1], i[2]);
    default:
      return;
  }
}
dt.registerCommand("noop", () => {
});
const kj = m(0, "Did you forget to open or close the quote?"), Dj = m(0, "Did you forget to escape the '/' (slash) character? Put two backslashes before it to escape, e.g., '\\\\/'.");
let pu = class AE {
  constructor() {
    this._input = "", this._start = 0, this._current = 0, this._tokens = [], this._errors = [], this.stringRe = /[a-zA-Z0-9_<>\-\./\\:\*\?\+\[\]\^,#@;"%\$\p{L}-]+/uy;
  }
  static getLexeme(e) {
    switch (e.type) {
      case 0:
        return "(";
      case 1:
        return ")";
      case 2:
        return "!";
      case 3:
        return e.isTripleEq ? "===" : "==";
      case 4:
        return e.isTripleEq ? "!==" : "!=";
      case 5:
        return "<";
      case 6:
        return "<=";
      case 7:
      case 8:
        return ">=";
      case 9:
        return "=~";
      case 10:
      case 17:
      case 18:
      case 19:
        return e.lexeme;
      case 11:
        return "true";
      case 12:
        return "false";
      case 13:
        return "in";
      case 14:
        return "not";
      case 15:
        return "&&";
      case 16:
        return "||";
      case 20:
        return "EOF";
      default:
        throw YT(`unhandled token type: ${JSON.stringify(e)}; have you forgotten to add a case?`);
    }
  }
  reset(e) {
    return this._input = e, this._start = 0, this._current = 0, this._tokens = [], this._errors = [], this;
  }
  scan() {
    for (; !this._isAtEnd(); )
      switch (this._start = this._current, this._advance()) {
        case 40:
          this._addToken(0);
          break;
        case 41:
          this._addToken(1);
          break;
        case 33:
          if (this._match(61)) {
            const e = this._match(61);
            this._tokens.push({ type: 4, offset: this._start, isTripleEq: e });
          } else this._addToken(2);
          break;
        case 39:
          this._quotedString();
          break;
        case 47:
          this._regex();
          break;
        case 61:
          if (this._match(61)) {
            const e = this._match(61);
            this._tokens.push({ type: 3, offset: this._start, isTripleEq: e });
          } else this._match(126) ? this._addToken(9) : this._error(Xk("==", "=~"));
          break;
        case 60:
          this._addToken(this._match(61) ? 6 : 5);
          break;
        case 62:
          this._addToken(this._match(61) ? 8 : 7);
          break;
        case 38:
          this._match(38) ? this._addToken(15) : this._error(Xk("&&"));
          break;
        case 124:
          this._match(124) ? this._addToken(16) : this._error(Xk("||"));
          break;
        case 32:
        case 13:
        case 9:
        case 10:
        case 160:
          break;
        default:
          this._string();
      }
    return this._start = this._current, this._addToken(20), Array.from(this._tokens);
  }
  _match(e) {
    return !this._isAtEnd() && this._input.charCodeAt(this._current) === e && (this._current++, !0);
  }
  _advance() {
    return this._input.charCodeAt(this._current++);
  }
  _peek() {
    return this._isAtEnd() ? 0 : this._input.charCodeAt(this._current);
  }
  _addToken(e) {
    this._tokens.push({ type: e, offset: this._start });
  }
  _error(e) {
    const t = this._start, n = this._input.substring(this._start, this._current), s = { type: 19, offset: this._start, lexeme: n };
    this._errors.push({ offset: t, lexeme: n, additionalInfo: e }), this._tokens.push(s);
  }
  _string() {
    this.stringRe.lastIndex = this._start;
    const e = this.stringRe.exec(this._input);
    if (e) {
      this._current = this._start + e[0].length;
      const t = this._input.substring(this._start, this._current), n = AE._keywords.get(t);
      n ? this._addToken(n) : this._tokens.push({ type: 17, lexeme: t, offset: this._start });
    }
  }
  _quotedString() {
    for (; this._peek() !== 39 && !this._isAtEnd(); ) this._advance();
    this._isAtEnd() ? this._error(kj) : (this._advance(), this._tokens.push({ type: 18, lexeme: this._input.substring(this._start + 1, this._current - 1), offset: this._start + 1 }));
  }
  _regex() {
    let e = this._current, t = !1, n = !1;
    for (; ; ) {
      if (e >= this._input.length) return this._current = e, void this._error(Dj);
      const o = this._input.charCodeAt(e);
      if (t) t = !1;
      else {
        if (o === 47 && !n) {
          e++;
          break;
        }
        o === 91 ? n = !0 : o === 92 ? t = !0 : o === 93 && (n = !1);
      }
      e++;
    }
    for (; e < this._input.length && AE._regexFlags.has(this._input.charCodeAt(e)); ) e++;
    this._current = e;
    const s = this._input.substring(this._start, this._current);
    this._tokens.push({ type: 10, lexeme: s, offset: this._start });
  }
  _isAtEnd() {
    return this._current >= this._input.length;
  }
};
pu._regexFlags = new Set(["i", "g", "s", "m", "y", "u"].map((i) => i.charCodeAt(0))), pu._keywords = /* @__PURE__ */ new Map([["not", 14], ["in", 13], ["false", 12], ["true", 11]]);
const On = /* @__PURE__ */ new Map();
On.set("false", !1), On.set("true", !0), On.set("isMac", Je), On.set("isLinux", Cs), On.set("isWindows", Tn), On.set("isWeb", pc), On.set("isMacNative", Je && !pc), On.set("isEdge", eK), On.set("isFirefox", QU), On.set("isChrome", D7), On.set("isSafari", JU);
const xj = Object.prototype.hasOwnProperty, Nj = { regexParsingWithErrorRecovery: !0 }, Ej = m(0, "Empty context key expression"), Ij = m(0, "Did you forget to write an expression? You can also put 'false' or 'true' to always evaluate to false or true, respectively."), Mj = m(0, "'in' after 'not'."), NO = m(0, "closing parenthesis ')'"), Tj = m(0, "Unexpected token"), Rj = m(0, "Did you forget to put && or || before the token?"), Aj = m(0, "Unexpected end of expression"), Pj = m(0, "Did you forget to put a context key?");
let N8 = class p_ {
  constructor(e = Nj) {
    this._config = e, this._scanner = new pu(), this._tokens = [], this._current = 0, this._parsingErrors = [], this._flagsGYRe = /g|y/g;
  }
  parse(e) {
    if (e !== "") {
      this._tokens = this._scanner.reset(e).scan(), this._current = 0, this._parsingErrors = [];
      try {
        const t = this._expr();
        if (!this._isAtEnd()) {
          const n = this._peek(), s = n.type === 17 ? Rj : void 0;
          throw this._parsingErrors.push({ message: Tj, offset: n.offset, lexeme: pu.getLexeme(n), additionalInfo: s }), p_._parseError;
        }
        return t;
      } catch (t) {
        if (t !== p_._parseError) throw t;
        return;
      }
    } else this._parsingErrors.push({ message: Ej, offset: 0, lexeme: "", additionalInfo: Ij });
  }
  _expr() {
    return this._or();
  }
  _or() {
    const e = [this._and()];
    for (; this._matchOne(16); ) {
      const t = this._and();
      e.push(t);
    }
    return e.length === 1 ? e[0] : q.or(...e);
  }
  _and() {
    const e = [this._term()];
    for (; this._matchOne(15); ) {
      const t = this._term();
      e.push(t);
    }
    return e.length === 1 ? e[0] : q.and(...e);
  }
  _term() {
    if (this._matchOne(2)) {
      const e = this._peek();
      switch (e.type) {
        case 11:
          return this._advance(), ws.INSTANCE;
        case 12:
          return this._advance(), Os.INSTANCE;
        case 0: {
          this._advance();
          const t = this._expr();
          return this._consume(1, NO), t == null ? void 0 : t.negate();
        }
        case 17:
          return this._advance(), Ng.create(e.lexeme);
        default:
          throw this._errExpectedButGot("KEY | true | false | '(' expression ')'", e);
      }
    }
    return this._primary();
  }
  _primary() {
    const e = this._peek();
    switch (e.type) {
      case 11:
        return this._advance(), q.true();
      case 12:
        return this._advance(), q.false();
      case 0: {
        this._advance();
        const t = this._expr();
        return this._consume(1, NO), t;
      }
      case 17: {
        const t = e.lexeme;
        if (this._advance(), this._matchOne(9)) {
          const n = this._peek();
          if (!this._config.regexParsingWithErrorRecovery) {
            if (this._advance(), n.type !== 10) throw this._errExpectedButGot("REGEX", n);
            const s = n.lexeme, o = s.lastIndexOf("/"), r = o === s.length - 1 ? void 0 : this._removeFlagsGY(s.substring(o + 1));
            let a;
            try {
              a = new RegExp(s.substring(1, o), r);
            } catch {
              throw this._errExpectedButGot("REGEX", n);
            }
            return tv.create(t, a);
          }
          switch (n.type) {
            case 10:
            case 19: {
              const s = [n.lexeme];
              this._advance();
              let o = this._peek(), r = 0;
              for (let c = 0; c < n.lexeme.length; c++) n.lexeme.charCodeAt(c) === 40 ? r++ : n.lexeme.charCodeAt(c) === 41 && r--;
              for (; !this._isAtEnd() && o.type !== 15 && o.type !== 16; ) {
                switch (o.type) {
                  case 0:
                    r++;
                    break;
                  case 1:
                    r--;
                    break;
                  case 10:
                  case 18:
                    for (let c = 0; c < o.lexeme.length; c++) o.lexeme.charCodeAt(c) === 40 ? r++ : n.lexeme.charCodeAt(c) === 41 && r--;
                }
                if (r < 0) break;
                s.push(pu.getLexeme(o)), this._advance(), o = this._peek();
              }
              const a = s.join(""), l = a.lastIndexOf("/"), d = l === a.length - 1 ? void 0 : this._removeFlagsGY(a.substring(l + 1));
              let h;
              try {
                h = new RegExp(a.substring(1, l), d);
              } catch {
                throw this._errExpectedButGot("REGEX", n);
              }
              return q.regex(t, h);
            }
            case 18: {
              const s = n.lexeme;
              this._advance();
              let o = null;
              if (!X7(s)) {
                const r = s.indexOf("/"), a = s.lastIndexOf("/");
                if (r !== a && r >= 0) {
                  const l = s.slice(r + 1, a), d = s[a + 1] === "i" ? "i" : "";
                  try {
                    o = new RegExp(l, d);
                  } catch {
                    throw this._errExpectedButGot("REGEX", n);
                  }
                }
              }
              if (o === null) throw this._errExpectedButGot("REGEX", n);
              return tv.create(t, o);
            }
            default:
              throw this._errExpectedButGot("REGEX", this._peek());
          }
        }
        if (this._matchOne(14)) {
          this._consume(13, Mj);
          const n = this._value();
          return q.notIn(t, n);
        }
        switch (this._peek().type) {
          case 3: {
            this._advance();
            const n = this._value();
            if (this._previous().type === 18) return q.equals(t, n);
            switch (n) {
              case "true":
                return q.has(t);
              case "false":
                return q.not(t);
              default:
                return q.equals(t, n);
            }
          }
          case 4: {
            this._advance();
            const n = this._value();
            if (this._previous().type === 18) return q.notEquals(t, n);
            switch (n) {
              case "true":
                return q.not(t);
              case "false":
                return q.has(t);
              default:
                return q.notEquals(t, n);
            }
          }
          case 5:
            return this._advance(), XS.create(t, this._value());
          case 6:
            return this._advance(), QS.create(t, this._value());
          case 7:
            return this._advance(), ZS.create(t, this._value());
          case 8:
            return this._advance(), YS.create(t, this._value());
          case 13:
            return this._advance(), q.in(t, this._value());
          default:
            return q.has(t);
        }
      }
      case 20:
        throw this._parsingErrors.push({ message: Aj, offset: e.offset, lexeme: "", additionalInfo: Pj }), p_._parseError;
      default:
        throw this._errExpectedButGot(`true | false | KEY 
	| KEY '=~' REGEX 
	| KEY ('==' | '!=' | '<' | '<=' | '>' | '>=' | 'in' | 'not' 'in') value`, this._peek());
    }
  }
  _value() {
    const e = this._peek();
    switch (e.type) {
      case 17:
      case 18:
        return this._advance(), e.lexeme;
      case 11:
        return this._advance(), "true";
      case 12:
        return this._advance(), "false";
      case 13:
        return this._advance(), "in";
      default:
        return "";
    }
  }
  _removeFlagsGY(e) {
    return e.replaceAll(this._flagsGYRe, "");
  }
  _previous() {
    return this._tokens[this._current - 1];
  }
  _matchOne(e) {
    return !!this._check(e) && (this._advance(), !0);
  }
  _advance() {
    return this._isAtEnd() || this._current++, this._previous();
  }
  _consume(e, t) {
    if (this._check(e)) return this._advance();
    throw this._errExpectedButGot(t, this._peek());
  }
  _errExpectedButGot(e, t, n) {
    const s = m(0, `Expected: {0}
Received: '{1}'.`, e, pu.getLexeme(t)), o = t.offset, r = pu.getLexeme(t);
    return this._parsingErrors.push({ message: s, offset: o, lexeme: r, additionalInfo: n }), p_._parseError;
  }
  _check(e) {
    return this._peek().type === e;
  }
  _peek() {
    return this._tokens[this._current];
  }
  _isAtEnd() {
    return this._peek().type === 20;
  }
};
N8._parseError = new Error();
class q {
  static false() {
    return ws.INSTANCE;
  }
  static true() {
    return Os.INSTANCE;
  }
  static has(e) {
    return xg.create(e);
  }
  static equals(e, t) {
    return pf.create(e, t);
  }
  static notEquals(e, t) {
    return $S.create(e, t);
  }
  static regex(e, t) {
    return tv.create(e, t);
  }
  static in(e, t) {
    return jS.create(e, t);
  }
  static notIn(e, t) {
    return qS.create(e, t);
  }
  static not(e) {
    return Ng.create(e);
  }
  static and(...e) {
    return Eu.create(e, null, !0);
  }
  static or(...e) {
    return Xl.create(e, null, !0);
  }
  static deserialize(e) {
    if (e != null)
      return this._parser.parse(e);
  }
}
function Y_(i, e) {
  return i.cmp(e);
}
q._parser = new N8({ regexParsingWithErrorRecovery: !1 });
class ws {
  constructor() {
    this.type = 0;
  }
  cmp(e) {
    return this.type - e.type;
  }
  equals(e) {
    return e.type === this.type;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return !1;
  }
  serialize() {
    return "false";
  }
  keys() {
    return [];
  }
  negate() {
    return Os.INSTANCE;
  }
}
ws.INSTANCE = new ws();
class Os {
  constructor() {
    this.type = 1;
  }
  cmp(e) {
    return this.type - e.type;
  }
  equals(e) {
    return e.type === this.type;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return !0;
  }
  serialize() {
    return "true";
  }
  keys() {
    return [];
  }
  negate() {
    return ws.INSTANCE;
  }
}
Os.INSTANCE = new Os();
class xg {
  static create(e, t = null) {
    const n = On.get(e);
    return typeof n == "boolean" ? n ? Os.INSTANCE : ws.INSTANCE : new xg(e, t);
  }
  constructor(e, t) {
    this.key = e, this.negated = t, this.type = 2;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : I8(this.key, e.key);
  }
  equals(e) {
    return e.type === this.type && this.key === e.key;
  }
  substituteConstants() {
    const e = On.get(this.key);
    return typeof e == "boolean" ? e ? Os.INSTANCE : ws.INSTANCE : this;
  }
  evaluate(e) {
    return !!e.getValue(this.key);
  }
  serialize() {
    return this.key;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = Ng.create(this.key, this)), this.negated;
  }
}
class pf {
  static create(e, t, n = null) {
    if (typeof t == "boolean") return t ? xg.create(e, n) : Ng.create(e, n);
    const s = On.get(e);
    return typeof s == "boolean" ? t === (s ? "true" : "false") ? Os.INSTANCE : ws.INSTANCE : new pf(e, t, n);
  }
  constructor(e, t, n) {
    this.key = e, this.value = t, this.negated = n, this.type = 4;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : Eg(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type && this.key === e.key && this.value === e.value;
  }
  substituteConstants() {
    const e = On.get(this.key);
    if (typeof e == "boolean") {
      const t = e ? "true" : "false";
      return this.value === t ? Os.INSTANCE : ws.INSTANCE;
    }
    return this;
  }
  evaluate(e) {
    return e.getValue(this.key) == this.value;
  }
  serialize() {
    return `${this.key} == '${this.value}'`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = $S.create(this.key, this.value, this)), this.negated;
  }
}
class jS {
  static create(e, t) {
    return new jS(e, t);
  }
  constructor(e, t) {
    this.key = e, this.valueKey = t, this.type = 10, this.negated = null;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : Eg(this.key, this.valueKey, e.key, e.valueKey);
  }
  equals(e) {
    return e.type === this.type && this.key === e.key && this.valueKey === e.valueKey;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    const t = e.getValue(this.valueKey), n = e.getValue(this.key);
    return Array.isArray(t) ? t.includes(n) : typeof n == "string" && typeof t == "object" && t !== null && xj.call(t, n);
  }
  serialize() {
    return `${this.key} in '${this.valueKey}'`;
  }
  keys() {
    return [this.key, this.valueKey];
  }
  negate() {
    return this.negated || (this.negated = qS.create(this.key, this.valueKey)), this.negated;
  }
}
class qS {
  static create(e, t) {
    return new qS(e, t);
  }
  constructor(e, t) {
    this.key = e, this.valueKey = t, this.type = 11, this._negated = jS.create(e, t);
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : this._negated.cmp(e._negated);
  }
  equals(e) {
    return e.type === this.type && this._negated.equals(e._negated);
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return !this._negated.evaluate(e);
  }
  serialize() {
    return `${this.key} not in '${this.valueKey}'`;
  }
  keys() {
    return this._negated.keys();
  }
  negate() {
    return this._negated;
  }
}
class $S {
  static create(e, t, n = null) {
    if (typeof t == "boolean") return t ? Ng.create(e, n) : xg.create(e, n);
    const s = On.get(e);
    return typeof s == "boolean" ? t === (s ? "true" : "false") ? ws.INSTANCE : Os.INSTANCE : new $S(e, t, n);
  }
  constructor(e, t, n) {
    this.key = e, this.value = t, this.negated = n, this.type = 5;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : Eg(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type && this.key === e.key && this.value === e.value;
  }
  substituteConstants() {
    const e = On.get(this.key);
    if (typeof e == "boolean") {
      const t = e ? "true" : "false";
      return this.value === t ? ws.INSTANCE : Os.INSTANCE;
    }
    return this;
  }
  evaluate(e) {
    return e.getValue(this.key) != this.value;
  }
  serialize() {
    return `${this.key} != '${this.value}'`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = pf.create(this.key, this.value, this)), this.negated;
  }
}
class Ng {
  static create(e, t = null) {
    const n = On.get(e);
    return typeof n == "boolean" ? n ? ws.INSTANCE : Os.INSTANCE : new Ng(e, t);
  }
  constructor(e, t) {
    this.key = e, this.negated = t, this.type = 3;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : I8(this.key, e.key);
  }
  equals(e) {
    return e.type === this.type && this.key === e.key;
  }
  substituteConstants() {
    const e = On.get(this.key);
    return typeof e == "boolean" ? e ? ws.INSTANCE : Os.INSTANCE : this;
  }
  evaluate(e) {
    return !e.getValue(this.key);
  }
  serialize() {
    return `!${this.key}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = xg.create(this.key, this)), this.negated;
  }
}
function GS(i, e) {
  if (typeof i == "string") {
    const t = parseFloat(i);
    isNaN(t) || (i = t);
  }
  return typeof i == "string" || typeof i == "number" ? e(i) : ws.INSTANCE;
}
class ZS {
  static create(e, t, n = null) {
    return GS(t, (s) => new ZS(e, s, n));
  }
  constructor(e, t, n) {
    this.key = e, this.value = t, this.negated = n, this.type = 12;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : Eg(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type && this.key === e.key && this.value === e.value;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return typeof this.value != "string" && parseFloat(e.getValue(this.key)) > this.value;
  }
  serialize() {
    return `${this.key} > ${this.value}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = QS.create(this.key, this.value, this)), this.negated;
  }
}
class YS {
  static create(e, t, n = null) {
    return GS(t, (s) => new YS(e, s, n));
  }
  constructor(e, t, n) {
    this.key = e, this.value = t, this.negated = n, this.type = 13;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : Eg(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type && this.key === e.key && this.value === e.value;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return typeof this.value != "string" && parseFloat(e.getValue(this.key)) >= this.value;
  }
  serialize() {
    return `${this.key} >= ${this.value}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = XS.create(this.key, this.value, this)), this.negated;
  }
}
class XS {
  static create(e, t, n = null) {
    return GS(t, (s) => new XS(e, s, n));
  }
  constructor(e, t, n) {
    this.key = e, this.value = t, this.negated = n, this.type = 14;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : Eg(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type && this.key === e.key && this.value === e.value;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return typeof this.value != "string" && parseFloat(e.getValue(this.key)) < this.value;
  }
  serialize() {
    return `${this.key} < ${this.value}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = YS.create(this.key, this.value, this)), this.negated;
  }
}
class QS {
  static create(e, t, n = null) {
    return GS(t, (s) => new QS(e, s, n));
  }
  constructor(e, t, n) {
    this.key = e, this.value = t, this.negated = n, this.type = 15;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : Eg(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type && this.key === e.key && this.value === e.value;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return typeof this.value != "string" && parseFloat(e.getValue(this.key)) <= this.value;
  }
  serialize() {
    return `${this.key} <= ${this.value}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = ZS.create(this.key, this.value, this)), this.negated;
  }
}
class tv {
  static create(e, t) {
    return new tv(e, t);
  }
  constructor(e, t) {
    this.key = e, this.regexp = t, this.type = 7, this.negated = null;
  }
  cmp(e) {
    if (e.type !== this.type) return this.type - e.type;
    if (this.key < e.key) return -1;
    if (this.key > e.key) return 1;
    const t = this.regexp ? this.regexp.source : "", n = e.regexp ? e.regexp.source : "";
    return t < n ? -1 : t > n ? 1 : 0;
  }
  equals(e) {
    if (e.type === this.type) {
      const t = this.regexp ? this.regexp.source : "", n = e.regexp ? e.regexp.source : "";
      return this.key === e.key && t === n;
    }
    return !1;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    const t = e.getValue(this.key);
    return !!this.regexp && this.regexp.test(t);
  }
  serialize() {
    const e = this.regexp ? `/${this.regexp.source}/${this.regexp.flags}` : "/invalid/";
    return `${this.key} =~ ${e}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = bR.create(this)), this.negated;
  }
}
class bR {
  static create(e) {
    return new bR(e);
  }
  constructor(e) {
    this._actual = e, this.type = 8;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : this._actual.cmp(e._actual);
  }
  equals(e) {
    return e.type === this.type && this._actual.equals(e._actual);
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return !this._actual.evaluate(e);
  }
  serialize() {
    return `!(${this._actual.serialize()})`;
  }
  keys() {
    return this._actual.keys();
  }
  negate() {
    return this._actual;
  }
}
function E8(i) {
  let e = null;
  for (let t = 0, n = i.length; t < n; t++) {
    const s = i[t].substituteConstants();
    if (i[t] !== s && e === null) {
      e = [];
      for (let o = 0; o < t; o++) e[o] = i[o];
    }
    e !== null && (e[t] = s);
  }
  return e === null ? i : e;
}
class Eu {
  static create(e, t, n) {
    return Eu._normalizeArr(e, t, n);
  }
  constructor(e, t) {
    this.expr = e, this.negated = t, this.type = 6;
  }
  cmp(e) {
    if (e.type !== this.type) return this.type - e.type;
    if (this.expr.length < e.expr.length) return -1;
    if (this.expr.length > e.expr.length) return 1;
    for (let t = 0, n = this.expr.length; t < n; t++) {
      const s = Y_(this.expr[t], e.expr[t]);
      if (s !== 0) return s;
    }
    return 0;
  }
  equals(e) {
    if (e.type === this.type) {
      if (this.expr.length !== e.expr.length) return !1;
      for (let t = 0, n = this.expr.length; t < n; t++) if (!this.expr[t].equals(e.expr[t])) return !1;
      return !0;
    }
    return !1;
  }
  substituteConstants() {
    const e = E8(this.expr);
    return e === this.expr ? this : Eu.create(e, this.negated, !1);
  }
  evaluate(e) {
    for (let t = 0, n = this.expr.length; t < n; t++) if (!this.expr[t].evaluate(e)) return !1;
    return !0;
  }
  static _normalizeArr(e, t, n) {
    const s = [];
    let o = !1;
    for (const r of e) if (r) if (r.type !== 1) {
      if (r.type === 0) return ws.INSTANCE;
      r.type !== 6 ? s.push(r) : s.push(...r.expr);
    } else o = !0;
    if (s.length === 0 && o) return Os.INSTANCE;
    if (s.length !== 0) {
      if (s.length === 1) return s[0];
      s.sort(Y_);
      for (let r = 1; r < s.length; r++) s[r - 1].equals(s[r]) && (s.splice(r, 1), r--);
      if (s.length === 1) return s[0];
      for (; s.length > 1; ) {
        const r = s[s.length - 1];
        if (r.type !== 9) break;
        s.pop();
        const a = s.pop(), l = s.length === 0, d = Xl.create(r.expr.map((h) => Eu.create([h, a], null, n)), null, l);
        d && (s.push(d), s.sort(Y_));
      }
      if (s.length === 1) return s[0];
      if (n) {
        for (let r = 0; r < s.length; r++) for (let a = r + 1; a < s.length; a++) if (s[r].negate().equals(s[a])) return ws.INSTANCE;
        if (s.length === 1) return s[0];
      }
      return new Eu(s, t);
    }
  }
  serialize() {
    return this.expr.map((e) => e.serialize()).join(" && ");
  }
  keys() {
    const e = [];
    for (const t of this.expr) e.push(...t.keys());
    return e;
  }
  negate() {
    if (!this.negated) {
      const e = [];
      for (const t of this.expr) e.push(t.negate());
      this.negated = Xl.create(e, this, !0);
    }
    return this.negated;
  }
}
class Xl {
  static create(e, t, n) {
    return Xl._normalizeArr(e, t, n);
  }
  constructor(e, t) {
    this.expr = e, this.negated = t, this.type = 9;
  }
  cmp(e) {
    if (e.type !== this.type) return this.type - e.type;
    if (this.expr.length < e.expr.length) return -1;
    if (this.expr.length > e.expr.length) return 1;
    for (let t = 0, n = this.expr.length; t < n; t++) {
      const s = Y_(this.expr[t], e.expr[t]);
      if (s !== 0) return s;
    }
    return 0;
  }
  equals(e) {
    if (e.type === this.type) {
      if (this.expr.length !== e.expr.length) return !1;
      for (let t = 0, n = this.expr.length; t < n; t++) if (!this.expr[t].equals(e.expr[t])) return !1;
      return !0;
    }
    return !1;
  }
  substituteConstants() {
    const e = E8(this.expr);
    return e === this.expr ? this : Xl.create(e, this.negated, !1);
  }
  evaluate(e) {
    for (let t = 0, n = this.expr.length; t < n; t++) if (this.expr[t].evaluate(e)) return !0;
    return !1;
  }
  static _normalizeArr(e, t, n) {
    let s = [], o = !1;
    if (e) {
      for (let r = 0, a = e.length; r < a; r++) {
        const l = e[r];
        if (l) if (l.type !== 0) {
          if (l.type === 1) return Os.INSTANCE;
          l.type !== 9 ? s.push(l) : s = s.concat(l.expr);
        } else o = !0;
      }
      if (s.length === 0 && o) return ws.INSTANCE;
      s.sort(Y_);
    }
    if (s.length !== 0) {
      if (s.length === 1) return s[0];
      for (let r = 1; r < s.length; r++) s[r - 1].equals(s[r]) && (s.splice(r, 1), r--);
      if (s.length === 1) return s[0];
      if (n) {
        for (let r = 0; r < s.length; r++) for (let a = r + 1; a < s.length; a++) if (s[r].negate().equals(s[a])) return Os.INSTANCE;
        if (s.length === 1) return s[0];
      }
      return new Xl(s, t);
    }
  }
  serialize() {
    return this.expr.map((e) => e.serialize()).join(" || ");
  }
  keys() {
    const e = [];
    for (const t of this.expr) e.push(...t.keys());
    return e;
  }
  negate() {
    if (!this.negated) {
      const e = [];
      for (const t of this.expr) e.push(t.negate());
      for (; e.length > 1; ) {
        const t = e.shift(), n = e.shift(), s = [];
        for (const o of IO(t)) for (const r of IO(n)) s.push(Eu.create([o, r], null, !1));
        e.unshift(Xl.create(s, null, !1));
      }
      this.negated = Xl.create(e, this, !0);
    }
    return this.negated;
  }
}
class ae extends xg {
  static all() {
    return ae._info.values();
  }
  constructor(e, t, n) {
    super(e, null), this._defaultValue = t, typeof n == "object" ? ae._info.push({ ...n, key: e }) : n !== !0 && ae._info.push({ key: e, description: n, type: t != null ? typeof t : void 0 });
  }
  bindTo(e) {
    return e.createKey(this.key, this._defaultValue);
  }
  getValue(e) {
    return e.getContextKeyValue(this.key);
  }
  toNegated() {
    return this.negate();
  }
  isEqualTo(e) {
    return pf.create(this.key, e);
  }
}
ae._info = [];
const Te = tt("contextKeyService");
function I8(i, e) {
  return i < e ? -1 : i > e ? 1 : 0;
}
function Eg(i, e, t, n) {
  return i < t ? -1 : i > t ? 1 : e < n ? -1 : e > n ? 1 : 0;
}
function PE(i, e) {
  if (i.type === 0 || e.type === 1) return !0;
  if (i.type === 9) return e.type === 9 && EO(i.expr, e.expr);
  if (e.type === 9) {
    for (const t of e.expr) if (PE(i, t)) return !0;
    return !1;
  }
  if (i.type === 6) {
    if (e.type === 6) return EO(e.expr, i.expr);
    for (const t of i.expr) if (PE(t, e)) return !0;
    return !1;
  }
  return i.equals(e);
}
function EO(i, e) {
  let t = 0, n = 0;
  for (; t < i.length && n < e.length; ) {
    const s = i[t].cmp(e[n]);
    if (s < 0) return !1;
    s === 0 && t++, n++;
  }
  return t === i.length;
}
function IO(i) {
  return i.type === 9 ? i.expr : [i];
}
function Qk(i, e) {
  if (!i) throw new Error(e ? `Assertion failed (${e})` : "Assertion Failed");
}
function JS(i, e = "Unreachable") {
  throw new Error(e);
}
function MO(i) {
  i || We(new Kt("Soft Assertion Failed"));
}
function cg(i) {
  i() || (i(), We(new Kt("Assertion Failed")));
}
function CR(i, e) {
  let t = 0;
  for (; t < i.length - 1; ) {
    if (!e(i[t], i[t + 1])) return !1;
    t++;
  }
  return !0;
}
const li = new class {
  constructor() {
    this.data = /* @__PURE__ */ new Map();
  }
  add(i, e) {
    Qk(ps(i)), Qk(ms(e)), Qk(!this.data.has(i), "There is already an extension with this id"), this.data.set(i, e);
  }
  as(i) {
    return this.data.get(i) || null;
  }
}();
class wR {
  constructor() {
    this._coreKeybindings = new fs(), this._extensionKeybindings = [], this._cachedMergedKeybindings = null;
  }
  static bindToCurrentPlatform(e) {
    if (Gs === 1) {
      if (e && e.win) return e.win;
    } else if (Gs === 2) {
      if (e && e.mac) return e.mac;
    } else if (e && e.linux) return e.linux;
    return e;
  }
  registerKeybindingRule(e) {
    const t = wR.bindToCurrentPlatform(e), n = new G();
    if (t && t.primary) {
      const s = DE(t.primary, Gs);
      s && n.add(this._registerDefaultKeybinding(s, e.id, e.args, e.weight, 0, e.when));
    }
    if (t && Array.isArray(t.secondary)) for (let s = 0, o = t.secondary.length; s < o; s++) {
      const r = DE(t.secondary[s], Gs);
      r && n.add(this._registerDefaultKeybinding(r, e.id, e.args, e.weight, -s - 1, e.when));
    }
    return n;
  }
  registerCommandAndKeybindingRule(e) {
    return yr(this.registerKeybindingRule(e), dt.registerCommand(e));
  }
  _registerDefaultKeybinding(e, t, n, s, o, r) {
    const a = this._coreKeybindings.push({ keybinding: e, command: t, commandArgs: n, when: r, weight1: s, weight2: o, extensionId: null, isBuiltinExtension: !1 });
    return this._cachedMergedKeybindings = null, ye(() => {
      a(), this._cachedMergedKeybindings = null;
    });
  }
  getDefaultKeybindings() {
    return this._cachedMergedKeybindings || (this._cachedMergedKeybindings = Array.from(this._coreKeybindings).concat(this._extensionKeybindings), this._cachedMergedKeybindings.sort(Oj)), this._cachedMergedKeybindings.slice(0);
  }
}
const Es = new wR();
function Oj(i, e) {
  if (i.weight1 !== e.weight1) return i.weight1 - e.weight1;
  if (i.command && e.command) {
    if (i.command < e.command) return -1;
    if (i.command > e.command) return 1;
  }
  return i.weight2 - e.weight2;
}
li.add("platform.keybindingsRegistry", Es);
var TC, Fj = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, TO = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
function xp(i) {
  return i.command !== void 0;
}
class x {
  constructor(e) {
    if (x._instances.has(e)) throw new TypeError(`MenuId with identifier '${e}' already exists. Use MenuId.for(ident) or a unique identifier`);
    x._instances.set(e, this), this.id = e;
  }
}
x._instances = /* @__PURE__ */ new Map(), x.CommandPalette = new x("CommandPalette"), x.DebugBreakpointsContext = new x("DebugBreakpointsContext"), x.DebugCallStackContext = new x("DebugCallStackContext"), x.DebugConsoleContext = new x("DebugConsoleContext"), x.DebugVariablesContext = new x("DebugVariablesContext"), x.NotebookVariablesContext = new x("NotebookVariablesContext"), x.DebugHoverContext = new x("DebugHoverContext"), x.DebugWatchContext = new x("DebugWatchContext"), x.DebugToolBar = new x("DebugToolBar"), x.DebugToolBarStop = new x("DebugToolBarStop"), x.EditorContext = new x("EditorContext"), x.SimpleEditorContext = new x("SimpleEditorContext"), x.EditorContent = new x("EditorContent"), x.EditorLineNumberContext = new x("EditorLineNumberContext"), x.EditorContextCopy = new x("EditorContextCopy"), x.EditorContextPeek = new x("EditorContextPeek"), x.EditorContextShare = new x("EditorContextShare"), x.EditorTitle = new x("EditorTitle"), x.EditorTitleRun = new x("EditorTitleRun"), x.EditorTitleContext = new x("EditorTitleContext"), x.EditorTitleContextShare = new x("EditorTitleContextShare"), x.EmptyEditorGroup = new x("EmptyEditorGroup"), x.EmptyEditorGroupContext = new x("EmptyEditorGroupContext"), x.EditorTabsBarContext = new x("EditorTabsBarContext"), x.EditorTabsBarShowTabsSubmenu = new x("EditorTabsBarShowTabsSubmenu"), x.EditorTabsBarShowTabsZenModeSubmenu = new x("EditorTabsBarShowTabsZenModeSubmenu"), x.EditorActionsPositionSubmenu = new x("EditorActionsPositionSubmenu"), x.ExplorerContext = new x("ExplorerContext"), x.ExplorerContextShare = new x("ExplorerContextShare"), x.ExtensionContext = new x("ExtensionContext"), x.GlobalActivity = new x("GlobalActivity"), x.CommandCenter = new x("CommandCenter"), x.CommandCenterCenter = new x("CommandCenterCenter"), x.LayoutControlMenuSubmenu = new x("LayoutControlMenuSubmenu"), x.LayoutControlMenu = new x("LayoutControlMenu"), x.MenubarMainMenu = new x("MenubarMainMenu"), x.MenubarAppearanceMenu = new x("MenubarAppearanceMenu"), x.MenubarDebugMenu = new x("MenubarDebugMenu"), x.MenubarEditMenu = new x("MenubarEditMenu"), x.MenubarCopy = new x("MenubarCopy"), x.MenubarFileMenu = new x("MenubarFileMenu"), x.MenubarGoMenu = new x("MenubarGoMenu"), x.MenubarHelpMenu = new x("MenubarHelpMenu"), x.MenubarLayoutMenu = new x("MenubarLayoutMenu"), x.MenubarNewBreakpointMenu = new x("MenubarNewBreakpointMenu"), x.PanelAlignmentMenu = new x("PanelAlignmentMenu"), x.PanelPositionMenu = new x("PanelPositionMenu"), x.ActivityBarPositionMenu = new x("ActivityBarPositionMenu"), x.MenubarPreferencesMenu = new x("MenubarPreferencesMenu"), x.MenubarRecentMenu = new x("MenubarRecentMenu"), x.MenubarSelectionMenu = new x("MenubarSelectionMenu"), x.MenubarShare = new x("MenubarShare"), x.MenubarSwitchEditorMenu = new x("MenubarSwitchEditorMenu"), x.MenubarSwitchGroupMenu = new x("MenubarSwitchGroupMenu"), x.MenubarTerminalMenu = new x("MenubarTerminalMenu"), x.MenubarViewMenu = new x("MenubarViewMenu"), x.MenubarHomeMenu = new x("MenubarHomeMenu"), x.OpenEditorsContext = new x("OpenEditorsContext"), x.OpenEditorsContextShare = new x("OpenEditorsContextShare"), x.ProblemsPanelContext = new x("ProblemsPanelContext"), x.SCMInputBox = new x("SCMInputBox"), x.SCMChangesSeparator = new x("SCMChangesSeparator"), x.SCMIncomingChanges = new x("SCMIncomingChanges"), x.SCMIncomingChangesContext = new x("SCMIncomingChangesContext"), x.SCMIncomingChangesSetting = new x("SCMIncomingChangesSetting"), x.SCMOutgoingChanges = new x("SCMOutgoingChanges"), x.SCMOutgoingChangesContext = new x("SCMOutgoingChangesContext"), x.SCMOutgoingChangesSetting = new x("SCMOutgoingChangesSetting"), x.SCMIncomingChangesAllChangesContext = new x("SCMIncomingChangesAllChangesContext"), x.SCMIncomingChangesHistoryItemContext = new x("SCMIncomingChangesHistoryItemContext"), x.SCMOutgoingChangesAllChangesContext = new x("SCMOutgoingChangesAllChangesContext"), x.SCMOutgoingChangesHistoryItemContext = new x("SCMOutgoingChangesHistoryItemContext"), x.SCMChangeContext = new x("SCMChangeContext"), x.SCMResourceContext = new x("SCMResourceContext"), x.SCMResourceContextShare = new x("SCMResourceContextShare"), x.SCMResourceFolderContext = new x("SCMResourceFolderContext"), x.SCMResourceGroupContext = new x("SCMResourceGroupContext"), x.SCMSourceControl = new x("SCMSourceControl"), x.SCMSourceControlInline = new x("SCMSourceControlInline"), x.SCMSourceControlTitle = new x("SCMSourceControlTitle"), x.SCMTitle = new x("SCMTitle"), x.SearchContext = new x("SearchContext"), x.SearchActionMenu = new x("SearchActionContext"), x.StatusBarWindowIndicatorMenu = new x("StatusBarWindowIndicatorMenu"), x.StatusBarRemoteIndicatorMenu = new x("StatusBarRemoteIndicatorMenu"), x.StickyScrollContext = new x("StickyScrollContext"), x.TestItem = new x("TestItem"), x.TestItemGutter = new x("TestItemGutter"), x.TestMessageContext = new x("TestMessageContext"), x.TestMessageContent = new x("TestMessageContent"), x.TestPeekElement = new x("TestPeekElement"), x.TestPeekTitle = new x("TestPeekTitle"), x.TouchBarContext = new x("TouchBarContext"), x.TitleBarContext = new x("TitleBarContext"), x.TitleBarTitleContext = new x("TitleBarTitleContext"), x.TunnelContext = new x("TunnelContext"), x.TunnelPrivacy = new x("TunnelPrivacy"), x.TunnelProtocol = new x("TunnelProtocol"), x.TunnelPortInline = new x("TunnelInline"), x.TunnelTitle = new x("TunnelTitle"), x.TunnelLocalAddressInline = new x("TunnelLocalAddressInline"), x.TunnelOriginInline = new x("TunnelOriginInline"), x.ViewItemContext = new x("ViewItemContext"), x.ViewContainerTitle = new x("ViewContainerTitle"), x.ViewContainerTitleContext = new x("ViewContainerTitleContext"), x.ViewTitle = new x("ViewTitle"), x.ViewTitleContext = new x("ViewTitleContext"), x.CommentEditorActions = new x("CommentEditorActions"), x.CommentThreadTitle = new x("CommentThreadTitle"), x.CommentThreadActions = new x("CommentThreadActions"), x.CommentThreadAdditionalActions = new x("CommentThreadAdditionalActions"), x.CommentThreadTitleContext = new x("CommentThreadTitleContext"), x.CommentThreadCommentContext = new x("CommentThreadCommentContext"), x.CommentTitle = new x("CommentTitle"), x.CommentActions = new x("CommentActions"), x.CommentsViewThreadActions = new x("CommentsViewThreadActions"), x.InteractiveToolbar = new x("InteractiveToolbar"), x.InteractiveCellTitle = new x("InteractiveCellTitle"), x.InteractiveCellDelete = new x("InteractiveCellDelete"), x.InteractiveCellExecute = new x("InteractiveCellExecute"), x.InteractiveInputExecute = new x("InteractiveInputExecute"), x.IssueReporter = new x("IssueReporter"), x.NotebookToolbar = new x("NotebookToolbar"), x.NotebookStickyScrollContext = new x("NotebookStickyScrollContext"), x.NotebookCellTitle = new x("NotebookCellTitle"), x.NotebookCellDelete = new x("NotebookCellDelete"), x.NotebookCellInsert = new x("NotebookCellInsert"), x.NotebookCellBetween = new x("NotebookCellBetween"), x.NotebookCellListTop = new x("NotebookCellTop"), x.NotebookCellExecute = new x("NotebookCellExecute"), x.NotebookCellExecuteGoTo = new x("NotebookCellExecuteGoTo"), x.NotebookCellExecutePrimary = new x("NotebookCellExecutePrimary"), x.NotebookDiffCellInputTitle = new x("NotebookDiffCellInputTitle"), x.NotebookDiffCellMetadataTitle = new x("NotebookDiffCellMetadataTitle"), x.NotebookDiffCellOutputsTitle = new x("NotebookDiffCellOutputsTitle"), x.NotebookOutputToolbar = new x("NotebookOutputToolbar"), x.NotebookOutlineFilter = new x("NotebookOutlineFilter"), x.NotebookOutlineActionMenu = new x("NotebookOutlineActionMenu"), x.NotebookEditorLayoutConfigure = new x("NotebookEditorLayoutConfigure"), x.NotebookKernelSource = new x("NotebookKernelSource"), x.BulkEditTitle = new x("BulkEditTitle"), x.BulkEditContext = new x("BulkEditContext"), x.TimelineItemContext = new x("TimelineItemContext"), x.TimelineTitle = new x("TimelineTitle"), x.TimelineTitleContext = new x("TimelineTitleContext"), x.TimelineFilterSubMenu = new x("TimelineFilterSubMenu"), x.AccountsContext = new x("AccountsContext"), x.SidebarTitle = new x("SidebarTitle"), x.PanelTitle = new x("PanelTitle"), x.AuxiliaryBarTitle = new x("AuxiliaryBarTitle"), x.AuxiliaryBarHeader = new x("AuxiliaryBarHeader"), x.TerminalInstanceContext = new x("TerminalInstanceContext"), x.TerminalEditorInstanceContext = new x("TerminalEditorInstanceContext"), x.TerminalNewDropdownContext = new x("TerminalNewDropdownContext"), x.TerminalTabContext = new x("TerminalTabContext"), x.TerminalTabEmptyAreaContext = new x("TerminalTabEmptyAreaContext"), x.TerminalStickyScrollContext = new x("TerminalStickyScrollContext"), x.WebviewContext = new x("WebviewContext"), x.InlineCompletionsActions = new x("InlineCompletionsActions"), x.InlineEditActions = new x("InlineEditActions"), x.NewFile = new x("NewFile"), x.MergeInput1Toolbar = new x("MergeToolbar1Toolbar"), x.MergeInput2Toolbar = new x("MergeToolbar2Toolbar"), x.MergeBaseToolbar = new x("MergeBaseToolbar"), x.MergeInputResultToolbar = new x("MergeToolbarResultToolbar"), x.InlineSuggestionToolbar = new x("InlineSuggestionToolbar"), x.InlineEditToolbar = new x("InlineEditToolbar"), x.ChatContext = new x("ChatContext"), x.ChatCodeBlock = new x("ChatCodeblock"), x.ChatMessageTitle = new x("ChatMessageTitle"), x.ChatExecute = new x("ChatExecute"), x.ChatExecuteSecondary = new x("ChatExecuteSecondary"), x.ChatInputSide = new x("ChatInputSide"), x.AccessibleView = new x("AccessibleView"), x.MultiDiffEditorFileToolbar = new x("MultiDiffEditorFileToolbar"), x.DiffEditorHunkToolbar = new x("DiffEditorHunkToolbar"), x.DiffEditorSelectionToolbar = new x("DiffEditorSelectionToolbar");
const Mo = tt("menuService");
class Ql {
  static for(e) {
    let t = this._all.get(e);
    return t || (t = new Ql(e), this._all.set(e, t)), t;
  }
  static merge(e) {
    const t = /* @__PURE__ */ new Set();
    for (const n of e) n instanceof Ql && t.add(n.id);
    return t;
  }
  constructor(e) {
    this.id = e, this.has = (t) => t === e;
  }
}
Ql._all = /* @__PURE__ */ new Map();
const tn = new class {
  constructor() {
    this._commands = /* @__PURE__ */ new Map(), this._menuItems = /* @__PURE__ */ new Map(), this._onDidChangeMenu = new dK({ merge: Ql.merge }), this.onDidChangeMenu = this._onDidChangeMenu.event;
  }
  addCommand(i) {
    return this._commands.set(i.id, i), this._onDidChangeMenu.fire(Ql.for(x.CommandPalette)), ye(() => {
      this._commands.delete(i.id) && this._onDidChangeMenu.fire(Ql.for(x.CommandPalette));
    });
  }
  getCommand(i) {
    return this._commands.get(i);
  }
  getCommands() {
    const i = /* @__PURE__ */ new Map();
    return this._commands.forEach((e, t) => i.set(t, e)), i;
  }
  appendMenuItem(i, e) {
    let t = this._menuItems.get(i);
    t || (t = new fs(), this._menuItems.set(i, t));
    const n = t.push(e);
    return this._onDidChangeMenu.fire(Ql.for(i)), ye(() => {
      n(), this._onDidChangeMenu.fire(Ql.for(i));
    });
  }
  appendMenuItems(i) {
    const e = new G();
    for (const { id: t, item: n } of i) e.add(this.appendMenuItem(t, n));
    return e;
  }
  getMenuItems(i) {
    let e;
    return e = this._menuItems.has(i) ? [...this._menuItems.get(i)] : [], i === x.CommandPalette && this._appendImplicitItems(e), e;
  }
  _appendImplicitItems(i) {
    const e = /* @__PURE__ */ new Set();
    for (const t of i) xp(t) && (e.add(t.command.id), t.alt && e.add(t.alt.id));
    this._commands.forEach((t, n) => {
      e.has(n) || i.push({ command: t });
    });
  }
}();
class iv extends Bm {
  constructor(e, t, n) {
    super(`submenuitem.${e.submenu.id}`, typeof e.title == "string" ? e.title : e.title.value, n, "submenu"), this.item = e, this.hideActions = t;
  }
}
let Eo = TC = class {
  static label(i, e) {
    return e != null && e.renderShortTitle && i.shortTitle ? typeof i.shortTitle == "string" ? i.shortTitle : i.shortTitle.value : typeof i.title == "string" ? i.title : i.title.value;
  }
  constructor(i, e, t, n, s, o) {
    var r, a;
    let l;
    if (this.hideActions = n, this._commandService = o, this.id = i.id, this.label = TC.label(i, t), this.tooltip = (a = typeof i.tooltip == "string" ? i.tooltip : (r = i.tooltip) === null || r === void 0 ? void 0 : r.value) !== null && a !== void 0 ? a : "", this.enabled = !i.precondition || s.contextMatchesRules(i.precondition), this.checked = void 0, i.toggled) {
      const d = i.toggled.condition ? i.toggled : { condition: i.toggled };
      this.checked = s.contextMatchesRules(d.condition), this.checked && d.tooltip && (this.tooltip = typeof d.tooltip == "string" ? d.tooltip : d.tooltip.value), this.checked && Ee.isThemeIcon(d.icon) && (l = d.icon), this.checked && d.title && (this.label = typeof d.title == "string" ? d.title : d.title.value);
    }
    l || (l = Ee.isThemeIcon(i.icon) ? i.icon : void 0), this.item = i, this.alt = e ? new TC(e, void 0, t, n, s, o) : void 0, this._options = t, this.class = l && Ee.asClassName(l);
  }
  run(...i) {
    var e, t;
    let n = [];
    return !((e = this._options) === null || e === void 0) && e.arg && (n = [...n, this._options.arg]), !((t = this._options) === null || t === void 0) && t.shouldForwardArgs && (n = [...n, ...i]), this._commandService.executeCommand(this.id, ...n);
  }
};
Eo = TC = Fj([TO(4, Te), TO(5, ai)], Eo);
class cs {
  constructor(e) {
    this.desc = e;
  }
}
function Ft(i) {
  const e = new G(), t = new i(), { f1: n, menu: s, keybinding: o, ...r } = t.desc;
  if (dt.getCommand(r.id)) throw new Error(`Cannot register two commands with the same id: ${r.id}`);
  if (e.add(dt.registerCommand({ id: r.id, handler: (a, ...l) => t.run(a, ...l), metadata: r.metadata })), Array.isArray(s)) for (const a of s) e.add(tn.appendMenuItem(a.id, { command: { ...r, precondition: a.precondition === null ? void 0 : r.precondition }, ...a }));
  else s && e.add(tn.appendMenuItem(s.id, { command: { ...r, precondition: s.precondition === null ? void 0 : r.precondition }, ...s }));
  if (n && (e.add(tn.appendMenuItem(x.CommandPalette, { command: r, when: r.precondition })), e.add(tn.addCommand(r))), Array.isArray(o)) for (const a of o) e.add(Es.registerKeybindingRule({ ...a, id: r.id, when: r.precondition ? q.and(r.precondition, a.when) : a.when }));
  else o && e.add(Es.registerKeybindingRule({ ...o, id: r.id, when: r.precondition ? q.and(r.precondition, o.when) : o.when }));
  return e;
}
const es = tt("telemetryService"), ts = tt("logService");
var Nn;
(function(i) {
  i[i.Off = 0] = "Off", i[i.Trace = 1] = "Trace", i[i.Debug = 2] = "Debug", i[i.Info = 3] = "Info", i[i.Warning = 4] = "Warning", i[i.Error = 5] = "Error";
})(Nn || (Nn = {}));
const M8 = Nn.Info;
class T8 extends V {
  constructor() {
    super(...arguments), this.level = M8, this._onDidChangeLogLevel = this._register(new F()), this.onDidChangeLogLevel = this._onDidChangeLogLevel.event;
  }
  setLevel(e) {
    this.level !== e && (this.level = e, this._onDidChangeLogLevel.fire(this.level));
  }
  getLevel() {
    return this.level;
  }
  checkLogLevel(e) {
    return this.level !== Nn.Off && this.level <= e;
  }
}
class Bj extends T8 {
  constructor(e = M8, t = !0) {
    super(), this.useColors = t, this.setLevel(e);
  }
  trace(e, ...t) {
    this.checkLogLevel(Nn.Trace) && (this.useColors ? console.log("%cTRACE", "color: #888", e, ...t) : console.log(e, ...t));
  }
  debug(e, ...t) {
    this.checkLogLevel(Nn.Debug) && (this.useColors ? console.log("%cDEBUG", "background: #eee; color: #888", e, ...t) : console.log(e, ...t));
  }
  info(e, ...t) {
    this.checkLogLevel(Nn.Info) && (this.useColors ? console.log("%c INFO", "color: #33f", e, ...t) : console.log(e, ...t));
  }
  warn(e, ...t) {
    this.checkLogLevel(Nn.Warning) && (this.useColors ? console.log("%c WARN", "color: #993", e, ...t) : console.log(e, ...t));
  }
  error(e, ...t) {
    this.checkLogLevel(Nn.Error) && (this.useColors ? console.log("%c  ERR", "color: #f33", e, ...t) : console.error(e, ...t));
  }
}
class Wj extends T8 {
  constructor(e) {
    super(), this.loggers = e, e.length && this.setLevel(e[0].getLevel());
  }
  setLevel(e) {
    for (const t of this.loggers) t.setLevel(e);
    super.setLevel(e);
  }
  trace(e, ...t) {
    for (const n of this.loggers) n.trace(e, ...t);
  }
  debug(e, ...t) {
    for (const n of this.loggers) n.debug(e, ...t);
  }
  info(e, ...t) {
    for (const n of this.loggers) n.info(e, ...t);
  }
  warn(e, ...t) {
    for (const n of this.loggers) n.warn(e, ...t);
  }
  error(e, ...t) {
    for (const n of this.loggers) n.error(e, ...t);
  }
  dispose() {
    for (const e of this.loggers) e.dispose();
    super.dispose();
  }
}
new ae("logLevel", function(i) {
  switch (i) {
    case Nn.Trace:
      return "trace";
    case Nn.Debug:
      return "debug";
    case Nn.Info:
      return "info";
    case Nn.Warning:
      return "warn";
    case Nn.Error:
      return "error";
    case Nn.Off:
      return "off";
  }
}(Nn.Info));
class eL {
  constructor(e) {
    this.id = e.id, this.precondition = e.precondition, this._kbOpts = e.kbOpts, this._menuOpts = e.menuOpts, this.metadata = e.metadata;
  }
  register() {
    if (Array.isArray(this._menuOpts) ? this._menuOpts.forEach(this._registerMenuItem, this) : this._menuOpts && this._registerMenuItem(this._menuOpts), this._kbOpts) {
      const e = Array.isArray(this._kbOpts) ? this._kbOpts : [this._kbOpts];
      for (const t of e) {
        let n = t.kbExpr;
        this.precondition && (n = n ? q.and(n, this.precondition) : this.precondition);
        const s = { id: this.id, weight: t.weight, args: t.args, when: n, primary: t.primary, secondary: t.secondary, win: t.win, linux: t.linux, mac: t.mac };
        Es.registerKeybindingRule(s);
      }
    }
    dt.registerCommand({ id: this.id, handler: (e, t) => this.runCommand(e, t), metadata: this.metadata });
  }
  _registerMenuItem(e) {
    tn.appendMenuItem(e.menuId, { group: e.group, command: { id: this.id, title: e.title, icon: e.icon, precondition: this.precondition }, when: e.when, order: e.order });
  }
}
class mf extends eL {
  constructor() {
    super(...arguments), this._implementations = [];
  }
  addImplementation(e, t, n, s) {
    return this._implementations.push({ priority: e, name: t, implementation: n, when: s }), this._implementations.sort((o, r) => r.priority - o.priority), { dispose: () => {
      for (let o = 0; o < this._implementations.length; o++) if (this._implementations[o].implementation === n) return void this._implementations.splice(o, 1);
    } };
  }
  runCommand(e, t) {
    const n = e.get(ts), s = e.get(Te);
    n.trace(`Executing Command '${this.id}' which has ${this._implementations.length} bound.`);
    for (const o of this._implementations) {
      if (o.when) {
        const a = s.getContext(Mn());
        if (!o.when.evaluate(a)) continue;
      }
      const r = o.implementation(e, t);
      if (r)
        return n.trace(`Command '${this.id}' was handled by '${o.name}'.`), typeof r == "boolean" ? void 0 : r;
    }
    n.trace(`The Command '${this.id}' was not handled by any implementation.`);
  }
}
class R8 extends eL {
  constructor(e, t) {
    super(t), this.command = e;
  }
  runCommand(e, t) {
    return this.command.runCommand(e, t);
  }
}
class Zi extends eL {
  static bindToContribution(e) {
    return class extends Zi {
      constructor(t) {
        super(t), this._callback = t.handler;
      }
      runEditorCommand(t, n, s) {
        const o = e(n);
        o && this._callback(o, s);
      }
    };
  }
  static runEditorCommand(e, t, n, s) {
    const o = e.get(mt), r = o.getFocusedCodeEditor() || o.getActiveCodeEditor();
    if (r) return r.invokeWithinContext((a) => {
      if (a.get(Te).contextMatchesRules(n ?? void 0)) return s(a, r, t);
    });
  }
  runCommand(e, t) {
    return Zi.runEditorCommand(e, t, this.precondition, (n, s, o) => this.runEditorCommand(n, s, o));
  }
}
class he extends Zi {
  static convertOptions(e) {
    let t;
    function n(s) {
      return s.menuId || (s.menuId = x.EditorContext), s.title || (s.title = e.label), s.when = q.and(e.precondition, s.when), s;
    }
    return t = Array.isArray(e.menuOpts) ? e.menuOpts : e.menuOpts ? [e.menuOpts] : [], Array.isArray(e.contextMenuOpts) ? t.push(...e.contextMenuOpts.map(n)) : e.contextMenuOpts && t.push(n(e.contextMenuOpts)), e.menuOpts = t, e;
  }
  constructor(e) {
    super(he.convertOptions(e)), this.label = e.label, this.alias = e.alias;
  }
  runEditorCommand(e, t, n) {
    return this.reportTelemetry(e, t), this.run(e, t, n || {});
  }
  reportTelemetry(e, t) {
    e.get(es).publicLog2("editorActionInvoked", { name: this.label, id: this.id });
  }
}
class A8 extends he {
  constructor() {
    super(...arguments), this._implementations = [];
  }
  addImplementation(e, t) {
    return this._implementations.push([e, t]), this._implementations.sort((n, s) => s[0] - n[0]), { dispose: () => {
      for (let n = 0; n < this._implementations.length; n++) if (this._implementations[n][1] === t) return void this._implementations.splice(n, 1);
    } };
  }
  run(e, t, n) {
    for (const s of this._implementations) {
      const o = s[1](e, t, n);
      if (o)
        return typeof o == "boolean" ? void 0 : o;
    }
  }
}
class Qr extends cs {
  run(e, ...t) {
    const n = e.get(mt), s = n.getFocusedCodeEditor() || n.getActiveCodeEditor();
    if (s) return s.invokeWithinContext((o) => {
      var r, a;
      const l = o.get(Te), d = o.get(ts);
      if (l.contextMatchesRules((r = this.desc.precondition) !== null && r !== void 0 ? r : void 0)) return this.runEditorCommand(o, s, ...t);
      d.debug("[EditorAction2] NOT running command because its precondition is FALSE", this.desc.id, (a = this.desc.precondition) === null || a === void 0 ? void 0 : a.serialize());
    });
  }
}
function qa(i, e) {
  dt.registerCommand(i, function(t, ...n) {
    const s = t.get(Se), [o, r] = n;
    vt(Ie.isUri(o)), vt(W.isIPosition(r));
    const a = t.get(ni).getModel(o);
    if (a) {
      const l = W.lift(r);
      return s.invokeFunction(e, a, l, ...n.slice(2));
    }
    return t.get(Ps).createModelReference(o).then((l) => new Promise((d, h) => {
      try {
        d(s.invokeFunction(e, l.object.textEditorModel, W.lift(r), n.slice(2)));
      } catch (c) {
        h(c);
      }
    }).finally(() => {
      l.dispose();
    }));
  });
}
function re(i) {
  return Ho.INSTANCE.registerEditorCommand(i), i;
}
function X(i) {
  const e = new i();
  return Ho.INSTANCE.registerEditorAction(e), e;
}
function P8(i) {
  return Ho.INSTANCE.registerEditorAction(i), i;
}
function ft(i, e, t) {
  Ho.INSTANCE.registerEditorContribution(i, e, t);
}
var Jp;
(function(i) {
  i.getEditorCommand = function(e) {
    return Ho.INSTANCE.getEditorCommand(e);
  }, i.getEditorActions = function() {
    return Ho.INSTANCE.getEditorActions();
  }, i.getEditorContributions = function() {
    return Ho.INSTANCE.getEditorContributions();
  }, i.getSomeEditorContributions = function(e) {
    return Ho.INSTANCE.getEditorContributions().filter((t) => e.indexOf(t.id) >= 0);
  }, i.getDiffEditorContributions = function() {
    return Ho.INSTANCE.getDiffEditorContributions();
  };
})(Jp || (Jp = {}));
class Ho {
  constructor() {
    this.editorContributions = [], this.diffEditorContributions = [], this.editorActions = [], this.editorCommands = /* @__PURE__ */ Object.create(null);
  }
  registerEditorContribution(e, t, n) {
    this.editorContributions.push({ id: e, ctor: t, instantiation: n });
  }
  getEditorContributions() {
    return this.editorContributions.slice(0);
  }
  getDiffEditorContributions() {
    return this.diffEditorContributions.slice(0);
  }
  registerEditorAction(e) {
    e.register(), this.editorActions.push(e);
  }
  getEditorActions() {
    return this.editorActions;
  }
  registerEditorCommand(e) {
    e.register(), this.editorCommands[e.id] = e;
  }
  getEditorCommand(e) {
    return this.editorCommands[e] || null;
  }
}
function C1(i) {
  return i.register(), i;
}
Ho.INSTANCE = new Ho(), li.add("editor.contributions", Ho.INSTANCE);
const O8 = C1(new mf({ id: "undo", precondition: void 0, kbOpts: { weight: 0, primary: 2104 }, menuOpts: [{ menuId: x.MenubarEditMenu, group: "1_do", title: m(0, "&&Undo"), order: 1 }, { menuId: x.CommandPalette, group: "", title: m(0, "Undo"), order: 1 }] }));
C1(new R8(O8, { id: "default:undo", precondition: void 0 }));
const F8 = C1(new mf({ id: "redo", precondition: void 0, kbOpts: { weight: 0, primary: 2103, secondary: [3128], mac: { primary: 3128 } }, menuOpts: [{ menuId: x.MenubarEditMenu, group: "1_do", title: m(0, "&&Redo"), order: 2 }, { menuId: x.CommandPalette, group: "", title: m(0, "Redo"), order: 1 }] }));
C1(new R8(F8, { id: "default:redo", precondition: void 0 }));
const Vj = C1(new mf({ id: "editor.action.selectAll", precondition: void 0, kbOpts: { weight: 0, kbExpr: null, primary: 2079 }, menuOpts: [{ menuId: x.MenubarSelectionMenu, group: "1_basic", title: m(0, "&&Select All"), order: 1 }, { menuId: x.CommandPalette, group: "", title: m(0, "Select All"), order: 1 }] }));
let RO = !1;
function OE(i) {
  pc && (RO || (RO = !0, console.warn("Could not create web worker(s). Falling back to loading web worker code in main thread, which might cause UI freezes. Please see https://github.com/microsoft/monaco-editor#faq")), console.warn(i.message));
}
class Hj {
  constructor(e, t, n, s) {
    this.vsWorker = e, this.req = t, this.method = n, this.args = s, this.type = 0;
  }
}
class AO {
  constructor(e, t, n, s) {
    this.vsWorker = e, this.seq = t, this.res = n, this.err = s, this.type = 1;
  }
}
class zj {
  constructor(e, t, n, s) {
    this.vsWorker = e, this.req = t, this.eventName = n, this.arg = s, this.type = 2;
  }
}
class Uj {
  constructor(e, t, n) {
    this.vsWorker = e, this.req = t, this.event = n, this.type = 3;
  }
}
class Kj {
  constructor(e, t) {
    this.vsWorker = e, this.req = t, this.type = 4;
  }
}
class jj {
  constructor(e) {
    this._workerId = -1, this._handler = e, this._lastSentReq = 0, this._pendingReplies = /* @__PURE__ */ Object.create(null), this._pendingEmitters = /* @__PURE__ */ new Map(), this._pendingEvents = /* @__PURE__ */ new Map();
  }
  setWorkerId(e) {
    this._workerId = e;
  }
  sendMessage(e, t) {
    const n = String(++this._lastSentReq);
    return new Promise((s, o) => {
      this._pendingReplies[n] = { resolve: s, reject: o }, this._send(new Hj(this._workerId, n, e, t));
    });
  }
  listen(e, t) {
    let n = null;
    const s = new F({ onWillAddFirstListener: () => {
      n = String(++this._lastSentReq), this._pendingEmitters.set(n, s), this._send(new zj(this._workerId, n, e, t));
    }, onDidRemoveLastListener: () => {
      this._pendingEmitters.delete(n), this._send(new Kj(this._workerId, n)), n = null;
    } });
    return s.event;
  }
  handleMessage(e) {
    e && e.vsWorker && (this._workerId !== -1 && e.vsWorker !== this._workerId || this._handleMessage(e));
  }
  _handleMessage(e) {
    switch (e.type) {
      case 1:
        return this._handleReplyMessage(e);
      case 0:
        return this._handleRequestMessage(e);
      case 2:
        return this._handleSubscribeEventMessage(e);
      case 3:
        return this._handleEventMessage(e);
      case 4:
        return this._handleUnsubscribeEventMessage(e);
    }
  }
  _handleReplyMessage(e) {
    if (!this._pendingReplies[e.seq]) return void console.warn("Got reply to unknown seq");
    const t = this._pendingReplies[e.seq];
    if (delete this._pendingReplies[e.seq], e.err) {
      let n = e.err;
      return e.err.$isError && (n = new Error(), n.name = e.err.name, n.message = e.err.message, n.stack = e.err.stack), void t.reject(n);
    }
    t.resolve(e.res);
  }
  _handleRequestMessage(e) {
    const t = e.req;
    this._handler.handleMessage(e.method, e.args).then((n) => {
      this._send(new AO(this._workerId, t, n, void 0));
    }, (n) => {
      n.detail instanceof Error && (n.detail = nO(n.detail)), this._send(new AO(this._workerId, t, void 0, nO(n)));
    });
  }
  _handleSubscribeEventMessage(e) {
    const t = e.req, n = this._handler.handleEvent(e.eventName, e.arg)((s) => {
      this._send(new Uj(this._workerId, t, s));
    });
    this._pendingEvents.set(t, n);
  }
  _handleEventMessage(e) {
    this._pendingEmitters.has(e.req) ? this._pendingEmitters.get(e.req).fire(e.event) : console.warn("Got event for unknown req");
  }
  _handleUnsubscribeEventMessage(e) {
    this._pendingEvents.has(e.req) ? (this._pendingEvents.get(e.req).dispose(), this._pendingEvents.delete(e.req)) : console.warn("Got unsubscribe for unknown req");
  }
  _send(e) {
    const t = [];
    if (e.type === 0) for (let n = 0; n < e.args.length; n++) e.args[n] instanceof ArrayBuffer && t.push(e.args[n]);
    else e.type === 1 && e.res instanceof ArrayBuffer && t.push(e.res);
    this._handler.sendMessage(e, t);
  }
}
class qj extends V {
  constructor(e, t, n) {
    super();
    let s = null;
    this._worker = this._register(e.create("vs/base/common/worker/simpleWorker", (h) => {
      this._protocol.handleMessage(h);
    }, (h) => {
      s == null || s(h);
    })), this._protocol = new jj({ sendMessage: (h, c) => {
      this._worker.postMessage(h, c);
    }, handleMessage: (h, c) => {
      if (typeof n[h] != "function") return Promise.reject(new Error("Missing method " + h + " on main thread host."));
      try {
        return Promise.resolve(n[h].apply(n, c));
      } catch (u) {
        return Promise.reject(u);
      }
    }, handleEvent: (h, c) => {
      if (OO(h)) {
        const u = n[h].call(n, c);
        if (typeof u != "function") throw new Error(`Missing dynamic event ${h} on main thread host.`);
        return u;
      }
      if (PO(h)) {
        const u = n[h];
        if (typeof u != "function") throw new Error(`Missing event ${h} on main thread host.`);
        return u;
      }
      throw new Error(`Malformed event name ${h}`);
    } }), this._protocol.setWorkerId(this._worker.getId());
    let o = null;
    const r = globalThis.require;
    r !== void 0 && typeof r.getConfig == "function" ? o = r.getConfig() : globalThis.requirejs !== void 0 && (o = globalThis.requirejs.s.contexts._.config);
    const a = jT(n);
    this._onModuleLoaded = this._protocol.sendMessage("$initialize", [this._worker.getId(), JSON.parse(JSON.stringify(o)), t, a]);
    const l = (h, c) => this._request(h, c), d = (h, c) => this._protocol.listen(h, c);
    this._lazyProxy = new Promise((h, c) => {
      s = c, this._onModuleLoaded.then((u) => {
        h(function(g, p, f) {
          const _ = (C) => function() {
            const w = Array.prototype.slice.call(arguments, 0);
            return p(C, w);
          }, v = (C) => function(w) {
            return f(C, w);
          }, b = {};
          for (const C of g) OO(C) ? b[C] = v(C) : PO(C) ? b[C] = f(C, void 0) : b[C] = _(C);
          return b;
        }(u, l, d));
      }, (u) => {
        c(u), this._onError("Worker failed to load " + t, u);
      });
    });
  }
  getProxyObject() {
    return this._lazyProxy;
  }
  _request(e, t) {
    return new Promise((n, s) => {
      this._onModuleLoaded.then(() => {
        this._protocol.sendMessage(e, t).then(n, s);
      }, s);
    });
  }
  _onError(e, t) {
    console.error(e), console.info(t);
  }
}
function PO(i) {
  return i[0] === "o" && i[1] === "n" && Wa(i.charCodeAt(2));
}
function OO(i) {
  return /^onDynamic/.test(i) && Wa(i.charCodeAt(9));
}
function Hd(i, e) {
  var t;
  const n = globalThis.MonacoEnvironment;
  if (n != null && n.createTrustedTypesPolicy) try {
    return n.createTrustedTypesPolicy(i, e);
  } catch (s) {
    return void We(s);
  }
  try {
    return (t = Et.trustedTypes) === null || t === void 0 ? void 0 : t.createPolicy(i, e);
  } catch (s) {
    return void We(s);
  }
}
const FO = Hd("defaultWorkerFactory", { createScriptURL: (i) => i });
class $j extends V {
  constructor(e, t, n, s, o) {
    super(), this.id = t, this.label = n;
    const r = function(a) {
      const l = globalThis.MonacoEnvironment;
      if (l) {
        if (typeof l.getWorker == "function") return l.getWorker("workerMain.js", a);
        if (typeof l.getWorkerUrl == "function") {
          const d = l.getWorkerUrl("workerMain.js", a);
          return new Worker(FO ? FO.createScriptURL(d) : d, { name: a });
        }
      }
      throw new Error("You must define a function MonacoEnvironment.getWorkerUrl or MonacoEnvironment.getWorker");
    }(n);
    typeof r.then == "function" ? this.worker = r : this.worker = Promise.resolve(r), this.postMessage(e, []), this.worker.then((a) => {
      a.onmessage = function(l) {
        s(l.data);
      }, a.onmessageerror = o, typeof a.addEventListener == "function" && a.addEventListener("error", o);
    }), this._register(ye(() => {
      var a;
      (a = this.worker) === null || a === void 0 || a.then((l) => {
        l.onmessage = null, l.onmessageerror = null, l.removeEventListener("error", o), l.terminate();
      }), this.worker = null;
    }));
  }
  getId() {
    return this.id;
  }
  postMessage(e, t) {
    var n;
    (n = this.worker) === null || n === void 0 || n.then((s) => {
      try {
        s.postMessage(e, t);
      } catch (o) {
        We(o), We(new Error(`FAILED to post message to '${this.label}'-worker`, { cause: o }));
      }
    });
  }
}
class tL {
  constructor(e) {
    this._label = e, this._webWorkerFailedBeforeError = !1;
  }
  create(e, t, n) {
    const s = ++tL.LAST_WORKER_ID;
    if (this._webWorkerFailedBeforeError) throw this._webWorkerFailedBeforeError;
    return new $j(e, s, this._label || "anonymous" + s, t, (o) => {
      OE(o), this._webWorkerFailedBeforeError = o, n(o);
    });
  }
}
var Oi;
tL.LAST_WORKER_ID = 0, function(i) {
  i[i.None = 0] = "None", i[i.Indent = 1] = "Indent", i[i.IndentOutdent = 2] = "IndentOutdent", i[i.Outdent = 3] = "Outdent";
}(Oi || (Oi = {}));
class Jk {
  constructor(e) {
    if (this._neutralCharacter = null, this._neutralCharacterSearched = !1, this.open = e.open, this.close = e.close, this._inString = !0, this._inComment = !0, this._inRegEx = !0, Array.isArray(e.notIn)) for (let t = 0, n = e.notIn.length; t < n; t++)
      switch (e.notIn[t]) {
        case "string":
          this._inString = !1;
          break;
        case "comment":
          this._inComment = !1;
          break;
        case "regex":
          this._inRegEx = !1;
      }
  }
  isOK(e) {
    switch (e) {
      case 0:
        return !0;
      case 1:
        return this._inComment;
      case 2:
        return this._inString;
      case 3:
        return this._inRegEx;
    }
  }
  shouldAutoClose(e, t) {
    if (e.getTokenCount() === 0) return !0;
    const n = e.findTokenIndexAtOffset(t - 2), s = e.getStandardTokenType(n);
    return this.isOK(s);
  }
  _findNeutralCharacterInRange(e, t) {
    for (let n = e; n <= t; n++) {
      const s = String.fromCharCode(n);
      if (!this.open.includes(s) && !this.close.includes(s)) return s;
    }
    return null;
  }
  findNeutralCharacter() {
    return this._neutralCharacterSearched || (this._neutralCharacterSearched = !0, this._neutralCharacter || (this._neutralCharacter = this._findNeutralCharacterInRange(48, 57)), this._neutralCharacter || (this._neutralCharacter = this._findNeutralCharacterInRange(97, 122)), this._neutralCharacter || (this._neutralCharacter = this._findNeutralCharacterInRange(65, 90))), this._neutralCharacter;
  }
}
class Gj {
  constructor(e) {
    this.autoClosingPairsOpenByStart = /* @__PURE__ */ new Map(), this.autoClosingPairsOpenByEnd = /* @__PURE__ */ new Map(), this.autoClosingPairsCloseByStart = /* @__PURE__ */ new Map(), this.autoClosingPairsCloseByEnd = /* @__PURE__ */ new Map(), this.autoClosingPairsCloseSingleChar = /* @__PURE__ */ new Map();
    for (const t of e) Tf(this.autoClosingPairsOpenByStart, t.open.charAt(0), t), Tf(this.autoClosingPairsOpenByEnd, t.open.charAt(t.open.length - 1), t), Tf(this.autoClosingPairsCloseByStart, t.close.charAt(0), t), Tf(this.autoClosingPairsCloseByEnd, t.close.charAt(t.close.length - 1), t), t.close.length === 1 && t.open.length === 1 && Tf(this.autoClosingPairsCloseSingleChar, t.close, t);
  }
}
function Tf(i, e, t) {
  i.has(e) ? i.get(e).push(t) : i.set(e, [t]);
}
function Yw(i, e) {
  const t = i.getCount(), n = i.findTokenIndexAtOffset(e), s = i.getLanguageId(n);
  let o = n;
  for (; o + 1 < t && i.getLanguageId(o + 1) === s; ) o++;
  let r = n;
  for (; r > 0 && i.getLanguageId(r - 1) === s; ) r--;
  return new Zj(i, s, r, o + 1, i.getStartOffset(r), i.getEndOffset(o));
}
class Zj {
  constructor(e, t, n, s, o, r) {
    this._scopedLineTokensBrand = void 0, this._actual = e, this.languageId = t, this._firstTokenIndex = n, this._lastTokenIndex = s, this.firstCharOffset = o, this._lastCharOffset = r;
  }
  getLineContent() {
    return this._actual.getLineContent().substring(this.firstCharOffset, this._lastCharOffset);
  }
  getActualLineContentBefore(e) {
    return this._actual.getLineContent().substring(0, this.firstCharOffset + e);
  }
  getTokenCount() {
    return this._lastTokenIndex - this._firstTokenIndex;
  }
  findTokenIndexAtOffset(e) {
    return this._actual.findTokenIndexAtOffset(e + this.firstCharOffset) - this._firstTokenIndex;
  }
  getStandardTokenType(e) {
    return this._actual.getStandardTokenType(e + this._firstTokenIndex);
  }
}
function Ma(i) {
  return !!(3 & i);
}
class Wm {
  constructor(e) {
    if (e.autoClosingPairs ? this._autoClosingPairs = e.autoClosingPairs.map((t) => new Jk(t)) : e.brackets ? this._autoClosingPairs = e.brackets.map((t) => new Jk({ open: t[0], close: t[1] })) : this._autoClosingPairs = [], e.__electricCharacterSupport && e.__electricCharacterSupport.docComment) {
      const t = e.__electricCharacterSupport.docComment;
      this._autoClosingPairs.push(new Jk({ open: t.open, close: t.close || "" }));
    }
    this._autoCloseBeforeForQuotes = typeof e.autoCloseBefore == "string" ? e.autoCloseBefore : Wm.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_QUOTES, this._autoCloseBeforeForBrackets = typeof e.autoCloseBefore == "string" ? e.autoCloseBefore : Wm.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_BRACKETS, this._surroundingPairs = e.surroundingPairs || this._autoClosingPairs;
  }
  getAutoClosingPairs() {
    return this._autoClosingPairs;
  }
  getAutoCloseBeforeSet(e) {
    return e ? this._autoCloseBeforeForQuotes : this._autoCloseBeforeForBrackets;
  }
  getSurroundingPairs() {
    return this._surroundingPairs;
  }
}
Wm.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_QUOTES = `;:.,=}])> 
	`, Wm.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_BRACKETS = `'"\`;:.,=}])> 
	`;
const BO = typeof Buffer < "u";
let eD, tD, iD, nD;
class iL {
  static wrap(e) {
    return BO && !Buffer.isBuffer(e) && (e = Buffer.from(e.buffer, e.byteOffset, e.byteLength)), new iL(e);
  }
  constructor(e) {
    this.buffer = e, this.byteLength = this.buffer.byteLength;
  }
  toString() {
    return BO ? this.buffer.toString() : (eD || (eD = new TextDecoder()), eD.decode(this.buffer));
  }
}
function Yj(i, e) {
  return (i[e + 0] | 0) >>> 0 | i[e + 1] << 8 >>> 0;
}
function Xj(i, e, t) {
  i[t + 0] = 255 & e, e >>>= 8, i[t + 1] = 255 & e;
}
function Vr(i, e) {
  return i[e] * 2 ** 24 + 65536 * i[e + 1] + 256 * i[e + 2] + i[e + 3];
}
function Hr(i, e, t) {
  i[t + 3] = e, e >>>= 8, i[t + 2] = e, e >>>= 8, i[t + 1] = e, e >>>= 8, i[t] = e;
}
function WO(i, e) {
  return i[e];
}
function VO(i, e, t) {
  i[t] = e;
}
function B8() {
  return tD || (tD = new TextDecoder("UTF-16LE")), tD;
}
function W8() {
  return nD || (nD = k7() ? B8() : (iD || (iD = new TextDecoder("UTF-16BE")), iD)), nD;
}
function Qj(i, e, t) {
  const n = new Uint16Array(i.buffer, e, t);
  return t > 0 && (n[0] === 65279 || n[0] === 65534) ? function(s, o, r) {
    const a = [];
    let l = 0;
    for (let d = 0; d < r; d++) {
      const h = Yj(s, o);
      o += 2, a[l++] = String.fromCharCode(h);
    }
    return a.join("");
  }(i, e, t) : B8().decode(n);
}
class ff {
  constructor(e) {
    this._capacity = 0 | e, this._buffer = new Uint16Array(this._capacity), this._completedStrings = null, this._bufferLength = 0;
  }
  reset() {
    this._completedStrings = null, this._bufferLength = 0;
  }
  build() {
    return this._completedStrings !== null ? (this._flushBuffer(), this._completedStrings.join("")) : this._buildBuffer();
  }
  _buildBuffer() {
    if (this._bufferLength === 0) return "";
    const e = new Uint16Array(this._buffer.buffer, 0, this._bufferLength);
    return W8().decode(e);
  }
  _flushBuffer() {
    const e = this._buildBuffer();
    this._bufferLength = 0, this._completedStrings === null ? this._completedStrings = [e] : this._completedStrings[this._completedStrings.length] = e;
  }
  appendCharCode(e) {
    const t = this._capacity - this._bufferLength;
    t <= 1 && (t === 0 || en(e)) && this._flushBuffer(), this._buffer[this._bufferLength++] = e;
  }
  appendASCIICharCode(e) {
    this._bufferLength === this._capacity && this._flushBuffer(), this._buffer[this._bufferLength++] = e;
  }
  appendString(e) {
    const t = e.length;
    if (this._bufferLength + t >= this._capacity) return this._flushBuffer(), void (this._completedStrings[this._completedStrings.length] = e);
    for (let n = 0; n < t; n++) this._buffer[this._bufferLength++] = e.charCodeAt(n);
  }
}
class Xw {
  constructor(e, t, n, s, o, r) {
    this._richEditBracketBrand = void 0, this.languageId = e, this.index = t, this.open = n, this.close = s, this.forwardRegex = o, this.reversedRegex = r, this._openSet = Xw._toSet(this.open), this._closeSet = Xw._toSet(this.close);
  }
  isOpen(e) {
    return this._openSet.has(e);
  }
  isClose(e) {
    return this._closeSet.has(e);
  }
  static _toSet(e) {
    const t = /* @__PURE__ */ new Set();
    for (const n of e) t.add(n);
    return t;
  }
}
class Jj {
  constructor(e, t) {
    this._richEditBracketsBrand = void 0;
    const n = function(s) {
      const o = s.length;
      s = s.map((h) => [h[0].toLowerCase(), h[1].toLowerCase()]);
      const r = [];
      for (let h = 0; h < o; h++) r[h] = h;
      const a = (h, c) => {
        const [u, g] = h, [p, f] = c;
        return u === p || u === f || g === p || g === f;
      }, l = (h, c) => {
        const u = Math.min(h, c), g = Math.max(h, c);
        for (let p = 0; p < o; p++) r[p] === g && (r[p] = u);
      };
      for (let h = 0; h < o; h++) {
        const c = s[h];
        for (let u = h + 1; u < o; u++) a(c, s[u]) && l(r[h], r[u]);
      }
      const d = [];
      for (let h = 0; h < o; h++) {
        const c = [], u = [];
        for (let g = 0; g < o; g++) if (r[g] === h) {
          const [p, f] = s[g];
          c.push(p), u.push(f);
        }
        c.length > 0 && d.push({ open: c, close: u });
      }
      return d;
    }(t);
    this.brackets = n.map((s, o) => new Xw(e, o, s.open, s.close, function(r, a, l, d) {
      let h = [];
      h = h.concat(r), h = h.concat(a);
      for (let c = 0, u = h.length; c < u; c++) HO(h[c], l, d, h);
      return h = ib(h), h.sort(zO), h.reverse(), nb(h);
    }(s.open, s.close, n, o), function(r, a, l, d) {
      let h = [];
      h = h.concat(r), h = h.concat(a);
      for (let c = 0, u = h.length; c < u; c++) HO(h[c], l, d, h);
      return h = ib(h), h.sort(zO), h.reverse(), nb(h.map(FE));
    }(s.open, s.close, n, o))), this.forwardRegex = function(s) {
      let o = [];
      for (const r of s) {
        for (const a of r.open) o.push(a);
        for (const a of r.close) o.push(a);
      }
      return o = ib(o), nb(o);
    }(this.brackets), this.reversedRegex = function(s) {
      let o = [];
      for (const r of s) {
        for (const a of r.open) o.push(a);
        for (const a of r.close) o.push(a);
      }
      return o = ib(o), nb(o.map(FE));
    }(this.brackets), this.textIsBracket = {}, this.textIsOpenBracket = {}, this.maxBracketLength = 0;
    for (const s of this.brackets) {
      for (const o of s.open) this.textIsBracket[o] = s, this.textIsOpenBracket[o] = !0, this.maxBracketLength = Math.max(this.maxBracketLength, o.length);
      for (const o of s.close) this.textIsBracket[o] = s, this.textIsOpenBracket[o] = !1, this.maxBracketLength = Math.max(this.maxBracketLength, o.length);
    }
  }
}
function HO(i, e, t, n) {
  for (let s = 0, o = e.length; s < o; s++) {
    if (s === t) continue;
    const r = e[s];
    for (const a of r.open) a.indexOf(i) >= 0 && n.push(a);
    for (const a of r.close) a.indexOf(i) >= 0 && n.push(a);
  }
}
function zO(i, e) {
  return i.length - e.length;
}
function ib(i) {
  if (i.length <= 1) return i;
  const e = [], t = /* @__PURE__ */ new Set();
  for (const n of i) t.has(n) || (e.push(n), t.add(n));
  return e;
}
function eq(i) {
  const e = /^[\w ]+$/.test(i);
  return i = No(i), e ? `\\b${i}\\b` : i;
}
function nb(i) {
  return J7(`(${i.map(eq).join(")|(")})`, !0);
}
const FE = /* @__PURE__ */ function() {
  let i = null, e = null;
  return function(t) {
    return i !== t && (i = t, e = function(n) {
      const s = new Uint16Array(n.length);
      let o = 0;
      for (let r = n.length - 1; r >= 0; r--) s[o++] = n.charCodeAt(r);
      return W8().decode(s);
    }(i)), e;
  };
}();
class hr {
  static _findPrevBracketInText(e, t, n, s) {
    const o = n.match(e);
    if (!o) return null;
    const r = n.length - (o.index || 0), a = o[0].length, l = s + r;
    return new D(t, l - a + 1, t, l + 1);
  }
  static findPrevBracketInRange(e, t, n, s, o) {
    const r = FE(n).substring(n.length - o, n.length - s);
    return this._findPrevBracketInText(e, t, r, s);
  }
  static findNextBracketInText(e, t, n, s) {
    const o = n.match(e);
    if (!o) return null;
    const r = o.index || 0, a = o[0].length;
    if (a === 0) return null;
    const l = s + r;
    return new D(t, l + 1, t, l + 1 + a);
  }
  static findNextBracketInRange(e, t, n, s, o) {
    const r = n.substring(s, o);
    return this.findNextBracketInText(e, t, r, s);
  }
}
class tq {
  constructor(e) {
    this._richEditBrackets = e;
  }
  getElectricCharacters() {
    const e = [];
    if (this._richEditBrackets) for (const t of this._richEditBrackets.brackets) for (const n of t.close) {
      const s = n.charAt(n.length - 1);
      e.push(s);
    }
    return Ad(e);
  }
  onElectricCharacter(e, t, n) {
    if (!this._richEditBrackets || this._richEditBrackets.brackets.length === 0) return null;
    const s = t.findTokenIndexAtOffset(n - 1);
    if (Ma(t.getStandardTokenType(s))) return null;
    const o = this._richEditBrackets.reversedRegex, r = t.getLineContent().substring(0, n - 1) + e, a = hr.findPrevBracketInRange(o, 1, r, 0, r.length);
    if (!a) return null;
    const l = r.substring(a.startColumn - 1, a.endColumn - 1).toLowerCase();
    if (this._richEditBrackets.textIsOpenBracket[l]) return null;
    const d = t.getActualLineContentBefore(a.startColumn - 1);
    return /^\s*$/.test(d) ? { matchOpenBracket: l } : null;
  }
}
function sb(i) {
  return i.global && (i.lastIndex = 0), !0;
}
class iq {
  constructor(e) {
    this._indentationRules = e;
  }
  shouldIncrease(e) {
    return !!(this._indentationRules && this._indentationRules.increaseIndentPattern && sb(this._indentationRules.increaseIndentPattern) && this._indentationRules.increaseIndentPattern.test(e));
  }
  shouldDecrease(e) {
    return !!(this._indentationRules && this._indentationRules.decreaseIndentPattern && sb(this._indentationRules.decreaseIndentPattern) && this._indentationRules.decreaseIndentPattern.test(e));
  }
  shouldIndentNextLine(e) {
    return !!(this._indentationRules && this._indentationRules.indentNextLinePattern && sb(this._indentationRules.indentNextLinePattern) && this._indentationRules.indentNextLinePattern.test(e));
  }
  shouldIgnore(e) {
    return !!(this._indentationRules && this._indentationRules.unIndentedLinePattern && sb(this._indentationRules.unIndentedLinePattern) && this._indentationRules.unIndentedLinePattern.test(e));
  }
  getIndentMetadata(e) {
    let t = 0;
    return this.shouldIncrease(e) && (t += 1), this.shouldDecrease(e) && (t += 2), this.shouldIndentNextLine(e) && (t += 4), this.shouldIgnore(e) && (t += 8), t;
  }
}
class Np {
  constructor(e) {
    (e = e || {}).brackets = e.brackets || [["(", ")"], ["{", "}"], ["[", "]"]], this._brackets = [], e.brackets.forEach((t) => {
      const n = Np._createOpenBracketRegExp(t[0]), s = Np._createCloseBracketRegExp(t[1]);
      n && s && this._brackets.push({ open: t[0], openRegExp: n, close: t[1], closeRegExp: s });
    }), this._regExpRules = e.onEnterRules || [];
  }
  onEnter(e, t, n, s) {
    if (e >= 3) for (let o = 0, r = this._regExpRules.length; o < r; o++) {
      const a = this._regExpRules[o];
      if ([{ reg: a.beforeText, text: n }, { reg: a.afterText, text: s }, { reg: a.previousLineText, text: t }].every((l) => !l.reg || (l.reg.lastIndex = 0, l.reg.test(l.text)))) return a.action;
    }
    if (e >= 2 && n.length > 0 && s.length > 0) for (let o = 0, r = this._brackets.length; o < r; o++) {
      const a = this._brackets[o];
      if (a.openRegExp.test(n) && a.closeRegExp.test(s)) return { indentAction: Oi.IndentOutdent };
    }
    if (e >= 2 && n.length > 0) {
      for (let o = 0, r = this._brackets.length; o < r; o++)
        if (this._brackets[o].openRegExp.test(n)) return { indentAction: Oi.Indent };
    }
    return null;
  }
  static _createOpenBracketRegExp(e) {
    let t = No(e);
    return /\B/.test(t.charAt(0)) || (t = "\\b" + t), t += "\\s*$", Np._safeRegExp(t);
  }
  static _createCloseBracketRegExp(e) {
    let t = No(e);
    return /\B/.test(t.charAt(t.length - 1)) || (t += "\\b"), t = "^\\s*" + t, Np._safeRegExp(t);
  }
  static _safeRegExp(e) {
    try {
      return new RegExp(e);
    } catch (t) {
      return We(t), null;
    }
  }
}
const Ye = tt("configurationService");
function BE(i, e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const n in i) V8(t, n, i[n], e);
  return t;
}
function V8(i, e, t, n) {
  const s = e.split("."), o = s.pop();
  let r = i;
  for (let a = 0; a < s.length; a++) {
    const l = s[a];
    let d = r[l];
    switch (typeof d) {
      case "undefined":
        d = r[l] = /* @__PURE__ */ Object.create(null);
        break;
      case "object":
        break;
      default:
        return void n(`Ignoring ${e} as ${s.slice(0, a + 1).join(".")} is ${JSON.stringify(d)}`);
    }
    r = d;
  }
  if (typeof r == "object" && r !== null) try {
    r[o] = t;
  } catch {
    n(`Ignoring ${e} as ${s.join(".")} is ${JSON.stringify(r)}`);
  }
  else n(`Ignoring ${e} as ${s.join(".")} is ${JSON.stringify(r)}`);
}
function nq(i, e) {
  H8(i, e.split("."));
}
function H8(i, e) {
  const t = e.shift();
  if (e.length !== 0) {
    if (Object.keys(i).indexOf(t) !== -1) {
      const n = i[t];
      typeof n != "object" || Array.isArray(n) || (H8(n, e), Object.keys(n).length === 0 && delete i[t]);
    }
  } else delete i[t];
}
function UO(i, e, t) {
  const n = function(s, o) {
    let r = s;
    for (const a of o) {
      if (typeof r != "object" || r === null) return;
      r = r[a];
    }
    return r;
  }(i, e.split("."));
  return n === void 0 ? t : n;
}
const Xt = tt("languageService");
class Va {
  constructor(e, t = [], n = !1) {
    this.ctor = e, this.staticArguments = t, this.supportsDelayedInstantiation = n;
  }
}
const z8 = [];
function rt(i, e, t) {
  e instanceof Va || (e = new Va(e, [], !!t)), z8.push([i, e]);
}
function KO() {
  return z8;
}
const vi = Object.freeze({ text: "text/plain", binary: "application/octet-stream", unknown: "application/unknown", markdown: "text/markdown", latex: "text/latex", uriList: "text/uri-list" }), nL = "base.contributions.json", sq = new class {
  constructor() {
    this._onDidChangeSchema = new F(), this.schemasById = {};
  }
  registerSchema(i, e) {
    var t;
    this.schemasById[t = i, t.length > 0 && t.charAt(t.length - 1) === "#" ? t.substring(0, t.length - 1) : t] = e, this._onDidChangeSchema.fire(i);
  }
  notifySchemaChanged(i) {
    this._onDidChangeSchema.fire(i);
  }
}();
li.add(nL, sq);
const fa = "base.contributions.configuration", ob = "vscode://schemas/settings/resourceLanguage", jO = li.as(nL), U8 = "\\[([^\\]]+)\\]", qO = new RegExp(U8, "g"), Sc = new RegExp(`^(${U8})+$`);
function Qw(i) {
  const e = [];
  if (Sc.test(i)) {
    let t = qO.exec(i);
    for (; t != null && t.length; ) {
      const n = t[1].trim();
      n && e.push(n), t = qO.exec(i);
    }
  }
  return Ad(e);
}
const RC = new class {
  constructor() {
    this.overrideIdentifiers = /* @__PURE__ */ new Set(), this._onDidSchemaChange = new F(), this._onDidUpdateConfiguration = new F(), this.configurationDefaultsOverrides = /* @__PURE__ */ new Map(), this.defaultLanguageConfigurationOverridesNode = { id: "defaultOverrides", title: m(0, "Default Language Configuration Overrides"), properties: {} }, this.configurationContributors = [this.defaultLanguageConfigurationOverridesNode], this.resourceLanguageSettingsSchema = { properties: {}, patternProperties: {}, additionalProperties: !0, allowTrailingCommas: !0, allowComments: !0 }, this.configurationProperties = {}, this.policyConfigurations = /* @__PURE__ */ new Map(), this.excludedConfigurationProperties = {}, jO.registerSchema(ob, this.resourceLanguageSettingsSchema), this.registerOverridePropertyPatternKey();
  }
  registerConfiguration(i, e = !0) {
    this.registerConfigurations([i], e);
  }
  registerConfigurations(i, e = !0) {
    const t = /* @__PURE__ */ new Set();
    this.doRegisterConfigurations(i, e, t), jO.registerSchema(ob, this.resourceLanguageSettingsSchema), this._onDidSchemaChange.fire(), this._onDidUpdateConfiguration.fire({ properties: t });
  }
  registerDefaultConfigurations(i) {
    const e = /* @__PURE__ */ new Set();
    this.doRegisterDefaultConfigurations(i, e), this._onDidSchemaChange.fire(), this._onDidUpdateConfiguration.fire({ properties: e, defaultsOverrides: !0 });
  }
  doRegisterDefaultConfigurations(i, e) {
    var t;
    const n = [];
    for (const { overrides: s, source: o } of i) for (const r in s) if (e.add(r), Sc.test(r)) {
      const a = this.configurationDefaultsOverrides.get(r), l = (t = a == null ? void 0 : a.valuesSources) !== null && t !== void 0 ? t : /* @__PURE__ */ new Map();
      if (o) for (const c of Object.keys(s[r])) l.set(c, o);
      const d = { ...(a == null ? void 0 : a.value) || {}, ...s[r] };
      this.configurationDefaultsOverrides.set(r, { source: o, value: d, valuesSources: l });
      const h = { type: "object", default: d, description: m(0, "Configure settings to be overridden for the {0} language.", r.replace(/[\[\]]/g, "")), $ref: ob, defaultDefaultValue: d, source: ps(o) ? void 0 : o, defaultValueSource: o };
      n.push(...Qw(r)), this.configurationProperties[r] = h, this.defaultLanguageConfigurationOverridesNode.properties[r] = h;
    } else {
      this.configurationDefaultsOverrides.set(r, { value: s[r], source: o });
      const a = this.configurationProperties[r];
      a && (this.updatePropertyDefaultValue(r, a), this.updateSchema(r, a));
    }
    this.doRegisterOverrideIdentifiers(n);
  }
  registerOverrideIdentifiers(i) {
    this.doRegisterOverrideIdentifiers(i), this._onDidSchemaChange.fire();
  }
  doRegisterOverrideIdentifiers(i) {
    for (const e of i) this.overrideIdentifiers.add(e);
    this.updateOverridePropertyPatternKey();
  }
  doRegisterConfigurations(i, e, t) {
    i.forEach((n) => {
      this.validateAndRegisterProperties(n, e, n.extensionInfo, n.restrictedProperties, void 0, t), this.configurationContributors.push(n), this.registerJSONConfiguration(n);
    });
  }
  validateAndRegisterProperties(i, e = !0, t, n, s = 3, o) {
    var r;
    s = mo(i.scope) ? s : i.scope;
    const a = i.properties;
    if (a) for (const d in a) {
      const h = a[d];
      e && oq(d, h) ? delete a[d] : (h.source = t, h.defaultDefaultValue = a[d].default, this.updatePropertyDefaultValue(d, h), Sc.test(d) ? h.scope = void 0 : (h.scope = mo(h.scope) ? s : h.scope, h.restricted = mo(h.restricted) ? !!(n != null && n.includes(d)) : h.restricted), !a[d].hasOwnProperty("included") || a[d].included ? (this.configurationProperties[d] = a[d], !((r = a[d].policy) === null || r === void 0) && r.name && this.policyConfigurations.set(a[d].policy.name, d), !a[d].deprecationMessage && a[d].markdownDeprecationMessage && (a[d].deprecationMessage = a[d].markdownDeprecationMessage), o.add(d)) : (this.excludedConfigurationProperties[d] = a[d], delete a[d]));
    }
    const l = i.allOf;
    if (l) for (const d of l) this.validateAndRegisterProperties(d, e, t, n, s, o);
  }
  getConfigurationProperties() {
    return this.configurationProperties;
  }
  getPolicyConfigurations() {
    return this.policyConfigurations;
  }
  registerJSONConfiguration(i) {
    const e = (t) => {
      const n = t.properties;
      if (n) for (const o in n) this.updateSchema(o, n[o]);
      const s = t.allOf;
      s == null || s.forEach(e);
    };
    e(i);
  }
  updateSchema(i, e) {
    switch (e.scope) {
      case 1:
      case 2:
      case 6:
      case 3:
      case 4:
        break;
      case 5:
        this.resourceLanguageSettingsSchema.properties[i] = e;
    }
  }
  updateOverridePropertyPatternKey() {
    for (const i of this.overrideIdentifiers.values()) {
      const e = `[${i}]`, t = { type: "object", description: m(0, "Configure editor settings to be overridden for a language."), errorMessage: m(0, "This setting does not support per-language configuration."), $ref: ob };
      this.updatePropertyDefaultValue(e, t);
    }
  }
  registerOverridePropertyPatternKey() {
    m(0, "Configure editor settings to be overridden for a language."), m(0, "This setting does not support per-language configuration."), this._onDidSchemaChange.fire();
  }
  updatePropertyDefaultValue(i, e) {
    const t = this.configurationDefaultsOverrides.get(i);
    let n = t == null ? void 0 : t.value, s = t == null ? void 0 : t.source;
    $s(n) && (n = e.defaultDefaultValue, s = void 0), $s(n) && (n = function(o) {
      switch (Array.isArray(o) ? o[0] : o) {
        case "boolean":
          return !1;
        case "integer":
        case "number":
          return 0;
        case "string":
          return "";
        case "array":
          return [];
        case "object":
          return {};
        default:
          return null;
      }
    }(e.type)), e.default = n, e.defaultValueSource = s;
  }
}();
function oq(i, e) {
  var t, n, s, o;
  return i.trim() ? Sc.test(i) ? m(0, "Cannot register '{0}'. This matches property pattern '\\\\[.*\\\\]$' for describing language specific editor settings. Use 'configurationDefaults' contribution.", i) : RC.getConfigurationProperties()[i] !== void 0 ? m(0, "Cannot register '{0}'. This property is already registered.", i) : !((t = e.policy) === null || t === void 0) && t.name && RC.getPolicyConfigurations().get((n = e.policy) === null || n === void 0 ? void 0 : n.name) !== void 0 ? m(0, "Cannot register '{0}'. The associated policy {1} is already registered with {2}.", i, (s = e.policy) === null || s === void 0 ? void 0 : s.name, RC.getPolicyConfigurations().get((o = e.policy) === null || o === void 0 ? void 0 : o.name)) : null : m(0, "Cannot register an empty property");
}
li.add(fa, RC);
const Vm = new class {
  constructor() {
    this._onDidChangeLanguages = new F(), this.onDidChangeLanguages = this._onDidChangeLanguages.event, this._languages = [];
  }
  registerLanguage(i) {
    return this._languages.push(i), this._onDidChangeLanguages.fire(void 0), { dispose: () => {
      for (let e = 0, t = this._languages.length; e < t; e++) if (this._languages[e] === i) return void this._languages.splice(e, 1);
    } };
  }
  getLanguages() {
    return this._languages;
  }
}();
li.add("editor.modesRegistry", Vm);
const ko = "plaintext";
Vm.registerLanguage({ id: ko, extensions: [".txt"], aliases: [m(0, "Plain Text"), "text"], mimetypes: [vi.text] }), li.as(fa).registerDefaultConfigurations([{ overrides: { "[plaintext]": { "editor.unicodeHighlight.ambiguousCharacters": !1, "editor.unicodeHighlight.invisibleCharacters": !1 } } }]);
class rq {
  constructor(e, t) {
    this.languageId = e;
    const n = t.brackets ? $O(t.brackets) : [], s = new aO((a) => {
      const l = /* @__PURE__ */ new Set();
      return { info: new aq(this, a, l), closing: l };
    }), o = new aO((a) => {
      const l = /* @__PURE__ */ new Set(), d = /* @__PURE__ */ new Set();
      return { info: new lq(this, a, l, d), opening: l, openingColorized: d };
    });
    for (const [a, l] of n) {
      const d = s.get(a), h = o.get(l);
      d.closing.add(h.info), h.opening.add(d.info);
    }
    const r = t.colorizedBracketPairs ? $O(t.colorizedBracketPairs) : n.filter((a) => !(a[0] === "<" && a[1] === ">"));
    for (const [a, l] of r) {
      const d = s.get(a), h = o.get(l);
      d.closing.add(h.info), h.openingColorized.add(d.info), h.opening.add(d.info);
    }
    this._openingBrackets = new Map([...s.cachedValues].map(([a, l]) => [a, l.info])), this._closingBrackets = new Map([...o.cachedValues].map(([a, l]) => [a, l.info]));
  }
  get openingBrackets() {
    return [...this._openingBrackets.values()];
  }
  get closingBrackets() {
    return [...this._closingBrackets.values()];
  }
  getOpeningBracketInfo(e) {
    return this._openingBrackets.get(e);
  }
  getClosingBracketInfo(e) {
    return this._closingBrackets.get(e);
  }
  getBracketInfo(e) {
    return this.getOpeningBracketInfo(e) || this.getClosingBracketInfo(e);
  }
}
function $O(i) {
  return i.filter(([e, t]) => e !== "" && t !== "");
}
class K8 {
  constructor(e, t) {
    this.config = e, this.bracketText = t;
  }
  get languageId() {
    return this.config.languageId;
  }
}
class aq extends K8 {
  constructor(e, t, n) {
    super(e, t), this.openedBrackets = n, this.isOpeningBracket = !0;
  }
}
class lq extends K8 {
  constructor(e, t, n, s) {
    super(e, t), this.openingBrackets = n, this.openingColorizedBrackets = s, this.isOpeningBracket = !1;
  }
  closes(e) {
    return e.config === this.config && this.openingBrackets.has(e);
  }
  closesColorized(e) {
    return e.config === this.config && this.openingColorizedBrackets.has(e);
  }
  getOpeningBrackets() {
    return [...this.openingBrackets];
  }
}
var dq = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, GO = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class sD {
  constructor(e) {
    this.languageId = e;
  }
  affects(e) {
    return !this.languageId || this.languageId === e;
  }
}
const zt = tt("languageConfigurationService");
let WE = class extends V {
  constructor(i, e) {
    super(), this.configurationService = i, this.languageService = e, this._registry = this._register(new cq()), this.onDidChangeEmitter = this._register(new F()), this.onDidChange = this.onDidChangeEmitter.event, this.configurations = /* @__PURE__ */ new Map();
    const t = new Set(Object.values(oD));
    this._register(this.configurationService.onDidChangeConfiguration((n) => {
      const s = n.change.keys.some((r) => t.has(r)), o = n.change.overrides.filter(([r, a]) => a.some((l) => t.has(l))).map(([r]) => r);
      if (s) this.configurations.clear(), this.onDidChangeEmitter.fire(new sD(void 0));
      else for (const r of o) this.languageService.isRegisteredLanguageId(r) && (this.configurations.delete(r), this.onDidChangeEmitter.fire(new sD(r)));
    })), this._register(this._registry.onDidChange((n) => {
      this.configurations.delete(n.languageId), this.onDidChangeEmitter.fire(new sD(n.languageId));
    }));
  }
  register(i, e, t) {
    return this._registry.register(i, e, t);
  }
  getLanguageConfiguration(i) {
    let e = this.configurations.get(i);
    return e || (e = function(t, n, s, o) {
      let r = n.getLanguageConfiguration(t);
      if (!r) {
        if (!o.isRegisteredLanguageId(t)) return new tm(t, {});
        r = new tm(t, {});
      }
      const a = function(d, h) {
        const c = h.getValue(oD.brackets, { overrideIdentifier: d }), u = h.getValue(oD.colorizedBracketPairs, { overrideIdentifier: d });
        return { brackets: ZO(c), colorizedBracketPairs: ZO(u) };
      }(r.languageId, s), l = q8([r.underlyingConfig, a]);
      return new tm(r.languageId, l);
    }(i, this._registry, this.configurationService, this.languageService), this.configurations.set(i, e)), e;
  }
};
WE = dq([GO(0, Ye), GO(1, Xt)], WE);
const oD = { brackets: "editor.language.brackets", colorizedBracketPairs: "editor.language.colorizedBracketPairs" };
function ZO(i) {
  if (Array.isArray(i)) return i.map((e) => {
    if (Array.isArray(e) && e.length === 2) return [e[0], e[1]];
  }).filter((e) => !!e);
}
function j8(i, e, t) {
  let n = Wt(i.getLineContent(e));
  return n.length > t - 1 && (n = n.substring(0, t - 1)), n;
}
function em(i, e, t) {
  return i.tokenization.forceTokenization(e), Yw(i.tokenization.getLineTokens(e), t === void 0 ? i.getLineMaxColumn(e) - 1 : t - 1);
}
class hq {
  constructor(e) {
    this.languageId = e, this._resolved = null, this._entries = [], this._order = 0, this._resolved = null;
  }
  register(e, t) {
    const n = new YO(e, t, ++this._order);
    return this._entries.push(n), this._resolved = null, ye(() => {
      for (let s = 0; s < this._entries.length; s++) if (this._entries[s] === n) {
        this._entries.splice(s, 1), this._resolved = null;
        break;
      }
    });
  }
  getResolvedConfiguration() {
    if (!this._resolved) {
      const e = this._resolve();
      e && (this._resolved = new tm(this.languageId, e));
    }
    return this._resolved;
  }
  _resolve() {
    return this._entries.length === 0 ? null : (this._entries.sort(YO.cmp), q8(this._entries.map((e) => e.configuration)));
  }
}
function q8(i) {
  let e = { comments: void 0, brackets: void 0, wordPattern: void 0, indentationRules: void 0, onEnterRules: void 0, autoClosingPairs: void 0, surroundingPairs: void 0, autoCloseBefore: void 0, folding: void 0, colorizedBracketPairs: void 0, __electricCharacterSupport: void 0 };
  for (const t of i) e = { comments: t.comments || e.comments, brackets: t.brackets || e.brackets, wordPattern: t.wordPattern || e.wordPattern, indentationRules: t.indentationRules || e.indentationRules, onEnterRules: t.onEnterRules || e.onEnterRules, autoClosingPairs: t.autoClosingPairs || e.autoClosingPairs, surroundingPairs: t.surroundingPairs || e.surroundingPairs, autoCloseBefore: t.autoCloseBefore || e.autoCloseBefore, folding: t.folding || e.folding, colorizedBracketPairs: t.colorizedBracketPairs || e.colorizedBracketPairs, __electricCharacterSupport: t.__electricCharacterSupport || e.__electricCharacterSupport };
  return e;
}
class YO {
  constructor(e, t, n) {
    this.configuration = e, this.priority = t, this.order = n;
  }
  static cmp(e, t) {
    return e.priority === t.priority ? e.order - t.order : e.priority - t.priority;
  }
}
class XO {
  constructor(e) {
    this.languageId = e;
  }
}
class cq extends V {
  constructor() {
    super(), this._entries = /* @__PURE__ */ new Map(), this._onDidChange = this._register(new F()), this.onDidChange = this._onDidChange.event, this._register(this.register(ko, { brackets: [["(", ")"], ["[", "]"], ["{", "}"]], surroundingPairs: [{ open: "{", close: "}" }, { open: "[", close: "]" }, { open: "(", close: ")" }, { open: "<", close: ">" }, { open: '"', close: '"' }, { open: "'", close: "'" }, { open: "`", close: "`" }], colorizedBracketPairs: [], folding: { offSide: !0 } }, 0));
  }
  register(e, t, n = 0) {
    let s = this._entries.get(e);
    s || (s = new hq(e), this._entries.set(e, s));
    const o = s.register(t, n);
    return this._onDidChange.fire(new XO(e)), ye(() => {
      o.dispose(), this._onDidChange.fire(new XO(e));
    });
  }
  getLanguageConfiguration(e) {
    const t = this._entries.get(e);
    return (t == null ? void 0 : t.getResolvedConfiguration()) || null;
  }
}
class tm {
  constructor(e, t) {
    this.languageId = e, this.underlyingConfig = t, this._brackets = null, this._electricCharacter = null, this._onEnterSupport = this.underlyingConfig.brackets || this.underlyingConfig.indentationRules || this.underlyingConfig.onEnterRules ? new Np(this.underlyingConfig) : null, this.comments = tm._handleComments(this.underlyingConfig), this.characterPair = new Wm(this.underlyingConfig), this.wordDefinition = this.underlyingConfig.wordPattern || GT, this.indentationRules = this.underlyingConfig.indentationRules, this.underlyingConfig.indentationRules ? this.indentRulesSupport = new iq(this.underlyingConfig.indentationRules) : this.indentRulesSupport = null, this.foldingRules = this.underlyingConfig.folding || {}, this.bracketsNew = new rq(e, this.underlyingConfig);
  }
  getWordDefinition() {
    return ZT(this.wordDefinition);
  }
  get brackets() {
    return !this._brackets && this.underlyingConfig.brackets && (this._brackets = new Jj(this.languageId, this.underlyingConfig.brackets)), this._brackets;
  }
  get electricCharacter() {
    return this._electricCharacter || (this._electricCharacter = new tq(this.brackets)), this._electricCharacter;
  }
  onEnter(e, t, n, s) {
    return this._onEnterSupport ? this._onEnterSupport.onEnter(e, t, n, s) : null;
  }
  getAutoClosingPairs() {
    return new Gj(this.characterPair.getAutoClosingPairs());
  }
  getAutoCloseBeforeSet(e) {
    return this.characterPair.getAutoCloseBeforeSet(e);
  }
  getSurroundingPairs() {
    return this.characterPair.getSurroundingPairs();
  }
  static _handleComments(e) {
    const t = e.comments;
    if (!t) return null;
    const n = {};
    if (t.lineComment && (n.lineCommentToken = t.lineComment), t.blockComment) {
      const [s, o] = t.blockComment;
      n.blockCommentStartToken = s, n.blockCommentEndToken = o;
    }
    return n;
  }
}
rt(zt, WE, 1);
class sh {
  constructor(e, t, n, s) {
    this.originalStart = e, this.originalLength = t, this.modifiedStart = n, this.modifiedLength = s;
  }
  getOriginalEnd() {
    return this.originalStart + this.originalLength;
  }
  getModifiedEnd() {
    return this.modifiedStart + this.modifiedLength;
  }
}
class QO {
  constructor(e) {
    this.source = e;
  }
  getElements() {
    const e = this.source, t = new Int32Array(e.length);
    for (let n = 0, s = e.length; n < s; n++) t[n] = e.charCodeAt(n);
    return t;
  }
}
function uq(i, e, t) {
  return new $a(new QO(i), new QO(e)).ComputeDiff(t).changes;
}
class Ug {
  static Assert(e, t) {
    if (!e) throw new Error(t);
  }
}
class Kg {
  static Copy(e, t, n, s, o) {
    for (let r = 0; r < o; r++) n[s + r] = e[t + r];
  }
  static Copy2(e, t, n, s, o) {
    for (let r = 0; r < o; r++) n[s + r] = e[t + r];
  }
}
class JO {
  constructor() {
    this.m_changes = [], this.m_originalStart = 1073741824, this.m_modifiedStart = 1073741824, this.m_originalCount = 0, this.m_modifiedCount = 0;
  }
  MarkNextChange() {
    (this.m_originalCount > 0 || this.m_modifiedCount > 0) && this.m_changes.push(new sh(this.m_originalStart, this.m_originalCount, this.m_modifiedStart, this.m_modifiedCount)), this.m_originalCount = 0, this.m_modifiedCount = 0, this.m_originalStart = 1073741824, this.m_modifiedStart = 1073741824;
  }
  AddOriginalElement(e, t) {
    this.m_originalStart = Math.min(this.m_originalStart, e), this.m_modifiedStart = Math.min(this.m_modifiedStart, t), this.m_originalCount++;
  }
  AddModifiedElement(e, t) {
    this.m_originalStart = Math.min(this.m_originalStart, e), this.m_modifiedStart = Math.min(this.m_modifiedStart, t), this.m_modifiedCount++;
  }
  getChanges() {
    return (this.m_originalCount > 0 || this.m_modifiedCount > 0) && this.MarkNextChange(), this.m_changes;
  }
  getReverseChanges() {
    return (this.m_originalCount > 0 || this.m_modifiedCount > 0) && this.MarkNextChange(), this.m_changes.reverse(), this.m_changes;
  }
}
class $a {
  constructor(e, t, n = null) {
    this.ContinueProcessingPredicate = n, this._originalSequence = e, this._modifiedSequence = t;
    const [s, o, r] = $a._getElements(e), [a, l, d] = $a._getElements(t);
    this._hasStrings = r && d, this._originalStringElements = s, this._originalElementsOrHash = o, this._modifiedStringElements = a, this._modifiedElementsOrHash = l, this.m_forwardHistory = [], this.m_reverseHistory = [];
  }
  static _isStringArray(e) {
    return e.length > 0 && typeof e[0] == "string";
  }
  static _getElements(e) {
    const t = e.getElements();
    if ($a._isStringArray(t)) {
      const n = new Int32Array(t.length);
      for (let s = 0, o = t.length; s < o; s++) n[s] = IE(t[s], 0);
      return [t, n, !0];
    }
    return t instanceof Int32Array ? [[], t, !1] : [[], new Int32Array(t), !1];
  }
  ElementsAreEqual(e, t) {
    return this._originalElementsOrHash[e] === this._modifiedElementsOrHash[t] && (!this._hasStrings || this._originalStringElements[e] === this._modifiedStringElements[t]);
  }
  ElementsAreStrictEqual(e, t) {
    return this.ElementsAreEqual(e, t) ? $a._getStrictElement(this._originalSequence, e) === $a._getStrictElement(this._modifiedSequence, t) : !1;
  }
  static _getStrictElement(e, t) {
    return typeof e.getStrictElement == "function" ? e.getStrictElement(t) : null;
  }
  OriginalElementsAreEqual(e, t) {
    return this._originalElementsOrHash[e] === this._originalElementsOrHash[t] && (!this._hasStrings || this._originalStringElements[e] === this._originalStringElements[t]);
  }
  ModifiedElementsAreEqual(e, t) {
    return this._modifiedElementsOrHash[e] === this._modifiedElementsOrHash[t] && (!this._hasStrings || this._modifiedStringElements[e] === this._modifiedStringElements[t]);
  }
  ComputeDiff(e) {
    return this._ComputeDiff(0, this._originalElementsOrHash.length - 1, 0, this._modifiedElementsOrHash.length - 1, e);
  }
  _ComputeDiff(e, t, n, s, o) {
    const r = [!1];
    let a = this.ComputeDiffRecursive(e, t, n, s, r);
    return o && (a = this.PrettifyChanges(a)), { quitEarly: r[0], changes: a };
  }
  ComputeDiffRecursive(e, t, n, s, o) {
    for (o[0] = !1; e <= t && n <= s && this.ElementsAreEqual(e, n); ) e++, n++;
    for (; t >= e && s >= n && this.ElementsAreEqual(t, s); ) t--, s--;
    if (e > t || n > s) {
      let c;
      return n <= s ? (Ug.Assert(e === t + 1, "originalStart should only be one more than originalEnd"), c = [new sh(e, 0, n, s - n + 1)]) : e <= t ? (Ug.Assert(n === s + 1, "modifiedStart should only be one more than modifiedEnd"), c = [new sh(e, t - e + 1, n, 0)]) : (Ug.Assert(e === t + 1, "originalStart should only be one more than originalEnd"), Ug.Assert(n === s + 1, "modifiedStart should only be one more than modifiedEnd"), c = []), c;
    }
    const r = [0], a = [0], l = this.ComputeRecursionPoint(e, t, n, s, r, a, o), d = r[0], h = a[0];
    if (l !== null) return l;
    if (!o[0]) {
      const c = this.ComputeDiffRecursive(e, d, n, h, o);
      let u = [];
      return u = o[0] ? [new sh(d + 1, t - (d + 1) + 1, h + 1, s - (h + 1) + 1)] : this.ComputeDiffRecursive(d + 1, t, h + 1, s, o), this.ConcatenateChanges(c, u);
    }
    return [new sh(e, t - e + 1, n, s - n + 1)];
  }
  WALKTRACE(e, t, n, s, o, r, a, l, d, h, c, u, g, p, f, _, v, b) {
    let C = null, w = null, y = new JO(), L = t, k = n, N = g[0] - _[0] - s, A = -1073741824, B = this.m_forwardHistory.length - 1;
    do {
      const T = N + e;
      T === L || T < k && d[T - 1] < d[T + 1] ? (p = (c = d[T + 1]) - N - s, c < A && y.MarkNextChange(), A = c, y.AddModifiedElement(c + 1, p), N = T + 1 - e) : (p = (c = d[T - 1] + 1) - N - s, c < A && y.MarkNextChange(), A = c - 1, y.AddOriginalElement(c, p + 1), N = T - 1 - e), B >= 0 && (e = (d = this.m_forwardHistory[B])[0], L = 1, k = d.length - 1);
    } while (--B >= -1);
    if (C = y.getReverseChanges(), b[0]) {
      let T = g[0] + 1, O = _[0] + 1;
      if (C !== null && C.length > 0) {
        const H = C[C.length - 1];
        T = Math.max(T, H.getOriginalEnd()), O = Math.max(O, H.getModifiedEnd());
      }
      w = [new sh(T, u - T + 1, O, f - O + 1)];
    } else {
      y = new JO(), L = r, k = a, N = g[0] - _[0] - l, A = 1073741824, B = v ? this.m_reverseHistory.length - 1 : this.m_reverseHistory.length - 2;
      do {
        const T = N + o;
        T === L || T < k && h[T - 1] >= h[T + 1] ? (p = (c = h[T + 1] - 1) - N - l, c > A && y.MarkNextChange(), A = c + 1, y.AddOriginalElement(c + 1, p + 1), N = T + 1 - o) : (p = (c = h[T - 1]) - N - l, c > A && y.MarkNextChange(), A = c, y.AddModifiedElement(c + 1, p + 1), N = T - 1 - o), B >= 0 && (o = (h = this.m_reverseHistory[B])[0], L = 1, k = h.length - 1);
      } while (--B >= -1);
      w = y.getChanges();
    }
    return this.ConcatenateChanges(C, w);
  }
  ComputeRecursionPoint(e, t, n, s, o, r, a) {
    let l = 0, d = 0, h = 0, c = 0, u = 0, g = 0;
    e--, n--, o[0] = 0, r[0] = 0, this.m_forwardHistory = [], this.m_reverseHistory = [];
    const p = t - e + (s - n), f = p + 1, _ = new Int32Array(f), v = new Int32Array(f), b = s - n, C = t - e, w = e - n, y = t - s, L = (C - b) % 2 == 0;
    _[b] = e, v[C] = t, a[0] = !1;
    for (let k = 1; k <= p / 2 + 1; k++) {
      let N = 0, A = 0;
      h = this.ClipDiagonalBound(b - k, k, b, f), c = this.ClipDiagonalBound(b + k, k, b, f);
      for (let T = h; T <= c; T += 2) {
        l = T === h || T < c && _[T - 1] < _[T + 1] ? _[T + 1] : _[T - 1] + 1, d = l - (T - b) - w;
        const O = l;
        for (; l < t && d < s && this.ElementsAreEqual(l + 1, d + 1); ) l++, d++;
        if (_[T] = l, l + d > N + A && (N = l, A = d), !L && Math.abs(T - C) <= k - 1 && l >= v[T]) return o[0] = l, r[0] = d, O <= v[T] && k <= 1448 ? this.WALKTRACE(b, h, c, w, C, u, g, y, _, v, l, t, o, d, s, r, L, a) : null;
      }
      const B = (N - e + (A - n) - k) / 2;
      if (this.ContinueProcessingPredicate !== null && !this.ContinueProcessingPredicate(N, B)) return a[0] = !0, o[0] = N, r[0] = A, B > 0 && k <= 1448 ? this.WALKTRACE(b, h, c, w, C, u, g, y, _, v, l, t, o, d, s, r, L, a) : (e++, n++, [new sh(e, t - e + 1, n, s - n + 1)]);
      u = this.ClipDiagonalBound(C - k, k, C, f), g = this.ClipDiagonalBound(C + k, k, C, f);
      for (let T = u; T <= g; T += 2) {
        l = T === u || T < g && v[T - 1] >= v[T + 1] ? v[T + 1] - 1 : v[T - 1], d = l - (T - C) - y;
        const O = l;
        for (; l > e && d > n && this.ElementsAreEqual(l, d); ) l--, d--;
        if (v[T] = l, L && Math.abs(T - b) <= k && l <= _[T]) return o[0] = l, r[0] = d, O >= _[T] && k <= 1448 ? this.WALKTRACE(b, h, c, w, C, u, g, y, _, v, l, t, o, d, s, r, L, a) : null;
      }
      if (k <= 1447) {
        let T = new Int32Array(c - h + 2);
        T[0] = b - h + 1, Kg.Copy2(_, h, T, 1, c - h + 1), this.m_forwardHistory.push(T), T = new Int32Array(g - u + 2), T[0] = C - u + 1, Kg.Copy2(v, u, T, 1, g - u + 1), this.m_reverseHistory.push(T);
      }
    }
    return this.WALKTRACE(b, h, c, w, C, u, g, y, _, v, l, t, o, d, s, r, L, a);
  }
  PrettifyChanges(e) {
    for (let t = 0; t < e.length; t++) {
      const n = e[t], s = t < e.length - 1 ? e[t + 1].originalStart : this._originalElementsOrHash.length, o = t < e.length - 1 ? e[t + 1].modifiedStart : this._modifiedElementsOrHash.length, r = n.originalLength > 0, a = n.modifiedLength > 0;
      for (; n.originalStart + n.originalLength < s && n.modifiedStart + n.modifiedLength < o && (!r || this.OriginalElementsAreEqual(n.originalStart, n.originalStart + n.originalLength)) && (!a || this.ModifiedElementsAreEqual(n.modifiedStart, n.modifiedStart + n.modifiedLength)); ) {
        const d = this.ElementsAreStrictEqual(n.originalStart, n.modifiedStart);
        if (this.ElementsAreStrictEqual(n.originalStart + n.originalLength, n.modifiedStart + n.modifiedLength) && !d) break;
        n.originalStart++, n.modifiedStart++;
      }
      const l = [null];
      t < e.length - 1 && this.ChangesOverlap(e[t], e[t + 1], l) && (e[t] = l[0], e.splice(t + 1, 1), t--);
    }
    for (let t = e.length - 1; t >= 0; t--) {
      const n = e[t];
      let s = 0, o = 0;
      if (t > 0) {
        const c = e[t - 1];
        s = c.originalStart + c.originalLength, o = c.modifiedStart + c.modifiedLength;
      }
      const r = n.originalLength > 0, a = n.modifiedLength > 0;
      let l = 0, d = this._boundaryScore(n.originalStart, n.originalLength, n.modifiedStart, n.modifiedLength);
      for (let c = 1; ; c++) {
        const u = n.originalStart - c, g = n.modifiedStart - c;
        if (u < s || g < o || r && !this.OriginalElementsAreEqual(u, u + n.originalLength) || a && !this.ModifiedElementsAreEqual(g, g + n.modifiedLength)) break;
        const p = (u === s && g === o ? 5 : 0) + this._boundaryScore(u, n.originalLength, g, n.modifiedLength);
        p > d && (d = p, l = c);
      }
      n.originalStart -= l, n.modifiedStart -= l;
      const h = [null];
      t > 0 && this.ChangesOverlap(e[t - 1], e[t], h) && (e[t - 1] = h[0], e.splice(t, 1), t++);
    }
    if (this._hasStrings) for (let t = 1, n = e.length; t < n; t++) {
      const s = e[t - 1], o = e[t], r = o.originalStart - s.originalStart - s.originalLength, a = s.originalStart, l = o.originalStart + o.originalLength, d = l - a, h = s.modifiedStart, c = o.modifiedStart + o.modifiedLength, u = c - h;
      if (r < 5 && d < 20 && u < 20) {
        const g = this._findBetterContiguousSequence(a, d, h, u, r);
        if (g) {
          const [p, f] = g;
          p === s.originalStart + s.originalLength && f === s.modifiedStart + s.modifiedLength || (s.originalLength = p - s.originalStart, s.modifiedLength = f - s.modifiedStart, o.originalStart = p + r, o.modifiedStart = f + r, o.originalLength = l - o.originalStart, o.modifiedLength = c - o.modifiedStart);
        }
      }
    }
    return e;
  }
  _findBetterContiguousSequence(e, t, n, s, o) {
    if (t < o || s < o) return null;
    const r = e + t - o + 1, a = n + s - o + 1;
    let l = 0, d = 0, h = 0;
    for (let c = e; c < r; c++) for (let u = n; u < a; u++) {
      const g = this._contiguousSequenceScore(c, u, o);
      g > 0 && g > l && (l = g, d = c, h = u);
    }
    return l > 0 ? [d, h] : null;
  }
  _contiguousSequenceScore(e, t, n) {
    let s = 0;
    for (let o = 0; o < n; o++) {
      if (!this.ElementsAreEqual(e + o, t + o)) return 0;
      s += this._originalStringElements[e + o].length;
    }
    return s;
  }
  _OriginalIsBoundary(e) {
    return e <= 0 || e >= this._originalElementsOrHash.length - 1 || this._hasStrings && /^\s*$/.test(this._originalStringElements[e]);
  }
  _OriginalRegionIsBoundary(e, t) {
    if (this._OriginalIsBoundary(e) || this._OriginalIsBoundary(e - 1)) return !0;
    if (t > 0) {
      const n = e + t;
      if (this._OriginalIsBoundary(n - 1) || this._OriginalIsBoundary(n)) return !0;
    }
    return !1;
  }
  _ModifiedIsBoundary(e) {
    return e <= 0 || e >= this._modifiedElementsOrHash.length - 1 || this._hasStrings && /^\s*$/.test(this._modifiedStringElements[e]);
  }
  _ModifiedRegionIsBoundary(e, t) {
    if (this._ModifiedIsBoundary(e) || this._ModifiedIsBoundary(e - 1)) return !0;
    if (t > 0) {
      const n = e + t;
      if (this._ModifiedIsBoundary(n - 1) || this._ModifiedIsBoundary(n)) return !0;
    }
    return !1;
  }
  _boundaryScore(e, t, n, s) {
    return (this._OriginalRegionIsBoundary(e, t) ? 1 : 0) + (this._ModifiedRegionIsBoundary(n, s) ? 1 : 0);
  }
  ConcatenateChanges(e, t) {
    const n = [];
    if (e.length === 0 || t.length === 0) return t.length > 0 ? t : e;
    if (this.ChangesOverlap(e[e.length - 1], t[0], n)) {
      const s = new Array(e.length + t.length - 1);
      return Kg.Copy(e, 0, s, 0, e.length - 1), s[e.length - 1] = n[0], Kg.Copy(t, 1, s, e.length, t.length - 1), s;
    }
    {
      const s = new Array(e.length + t.length);
      return Kg.Copy(e, 0, s, 0, e.length), Kg.Copy(t, 0, s, e.length, t.length), s;
    }
  }
  ChangesOverlap(e, t, n) {
    if (Ug.Assert(e.originalStart <= t.originalStart, "Left change is not less than or equal to right change"), Ug.Assert(e.modifiedStart <= t.modifiedStart, "Left change is not less than or equal to right change"), e.originalStart + e.originalLength >= t.originalStart || e.modifiedStart + e.modifiedLength >= t.modifiedStart) {
      const s = e.originalStart;
      let o = e.originalLength;
      const r = e.modifiedStart;
      let a = e.modifiedLength;
      return e.originalStart + e.originalLength >= t.originalStart && (o = t.originalStart + t.originalLength - e.originalStart), e.modifiedStart + e.modifiedLength >= t.modifiedStart && (a = t.modifiedStart + t.modifiedLength - e.modifiedStart), n[0] = new sh(s, o, r, a), !0;
    }
    return n[0] = null, !1;
  }
  ClipDiagonalBound(e, t, n, s) {
    if (e >= 0 && e < s) return e;
    const o = t % 2 == 0;
    return e < 0 ? o === (n % 2 == 0) ? 0 : 1 : o === ((s - n - 1) % 2 == 0) ? s - 1 : s - 2;
  }
}
function Jw(i) {
  return i < 0 ? 0 : i > 255 ? 255 : 0 | i;
}
function jg(i) {
  return i < 0 ? 0 : i > 4294967295 ? 4294967295 : 0 | i;
}
class gq {
  constructor(e) {
    this.values = e, this.prefixSum = new Uint32Array(e.length), this.prefixSumValidIndex = new Int32Array(1), this.prefixSumValidIndex[0] = -1;
  }
  insertValues(e, t) {
    e = jg(e);
    const n = this.values, s = this.prefixSum, o = t.length;
    return o !== 0 && (this.values = new Uint32Array(n.length + o), this.values.set(n.subarray(0, e), 0), this.values.set(n.subarray(e), e + o), this.values.set(t, e), e - 1 < this.prefixSumValidIndex[0] && (this.prefixSumValidIndex[0] = e - 1), this.prefixSum = new Uint32Array(this.values.length), this.prefixSumValidIndex[0] >= 0 && this.prefixSum.set(s.subarray(0, this.prefixSumValidIndex[0] + 1)), !0);
  }
  setValue(e, t) {
    return e = jg(e), t = jg(t), this.values[e] !== t && (this.values[e] = t, e - 1 < this.prefixSumValidIndex[0] && (this.prefixSumValidIndex[0] = e - 1), !0);
  }
  removeValues(e, t) {
    e = jg(e), t = jg(t);
    const n = this.values, s = this.prefixSum;
    if (e >= n.length) return !1;
    const o = n.length - e;
    return t >= o && (t = o), t !== 0 && (this.values = new Uint32Array(n.length - t), this.values.set(n.subarray(0, e), 0), this.values.set(n.subarray(e + t), e), this.prefixSum = new Uint32Array(this.values.length), e - 1 < this.prefixSumValidIndex[0] && (this.prefixSumValidIndex[0] = e - 1), this.prefixSumValidIndex[0] >= 0 && this.prefixSum.set(s.subarray(0, this.prefixSumValidIndex[0] + 1)), !0);
  }
  getTotalSum() {
    return this.values.length === 0 ? 0 : this._getPrefixSum(this.values.length - 1);
  }
  getPrefixSum(e) {
    return e < 0 ? 0 : (e = jg(e), this._getPrefixSum(e));
  }
  _getPrefixSum(e) {
    if (e <= this.prefixSumValidIndex[0]) return this.prefixSum[e];
    let t = this.prefixSumValidIndex[0] + 1;
    t === 0 && (this.prefixSum[0] = this.values[0], t++), e >= this.values.length && (e = this.values.length - 1);
    for (let n = t; n <= e; n++) this.prefixSum[n] = this.prefixSum[n - 1] + this.values[n];
    return this.prefixSumValidIndex[0] = Math.max(this.prefixSumValidIndex[0], e), this.prefixSum[e];
  }
  getIndexOf(e) {
    e = Math.floor(e), this.getTotalSum();
    let t = 0, n = this.values.length - 1, s = 0, o = 0, r = 0;
    for (; t <= n; ) if (s = t + (n - t) / 2 | 0, o = this.prefixSum[s], r = o - this.values[s], e < r) n = s - 1;
    else {
      if (!(e >= o)) break;
      t = s + 1;
    }
    return new $8(s, e - r);
  }
}
class pq {
  constructor(e) {
    this._values = e, this._isValid = !1, this._validEndIndex = -1, this._prefixSum = [], this._indexBySum = [];
  }
  getTotalSum() {
    return this._ensureValid(), this._indexBySum.length;
  }
  getPrefixSum(e) {
    return this._ensureValid(), e === 0 ? 0 : this._prefixSum[e - 1];
  }
  getIndexOf(e) {
    this._ensureValid();
    const t = this._indexBySum[e], n = t > 0 ? this._prefixSum[t - 1] : 0;
    return new $8(t, e - n);
  }
  removeValues(e, t) {
    this._values.splice(e, t), this._invalidate(e);
  }
  insertValues(e, t) {
    this._values = PS(this._values, e, t), this._invalidate(e);
  }
  _invalidate(e) {
    this._isValid = !1, this._validEndIndex = Math.min(this._validEndIndex, e - 1);
  }
  _ensureValid() {
    if (!this._isValid) {
      for (let e = this._validEndIndex + 1, t = this._values.length; e < t; e++) {
        const n = this._values[e], s = e > 0 ? this._prefixSum[e - 1] : 0;
        this._prefixSum[e] = s + n;
        for (let o = 0; o < n; o++) this._indexBySum[s + o] = e;
      }
      this._prefixSum.length = this._values.length, this._indexBySum.length = this._prefixSum[this._prefixSum.length - 1], this._isValid = !0, this._validEndIndex = this._values.length - 1;
    }
  }
  setValue(e, t) {
    this._values[e] !== t && (this._values[e] = t, this._invalidate(e));
  }
}
class $8 {
  constructor(e, t) {
    this.index = e, this.remainder = t, this._prefixSumIndexOfResultBrand = void 0, this.index = e, this.remainder = t;
  }
}
class mq {
  constructor(e, t, n, s) {
    this._uri = e, this._lines = t, this._eol = n, this._versionId = s, this._lineStarts = null, this._cachedTextValue = null;
  }
  dispose() {
    this._lines.length = 0;
  }
  get version() {
    return this._versionId;
  }
  getText() {
    return this._cachedTextValue === null && (this._cachedTextValue = this._lines.join(this._eol)), this._cachedTextValue;
  }
  onEvents(e) {
    e.eol && e.eol !== this._eol && (this._eol = e.eol, this._lineStarts = null);
    const t = e.changes;
    for (const n of t) this._acceptDeleteRange(n.range), this._acceptInsertText(new W(n.range.startLineNumber, n.range.startColumn), n.text);
    this._versionId = e.versionId, this._cachedTextValue = null;
  }
  _ensureLineStarts() {
    if (!this._lineStarts) {
      const e = this._eol.length, t = this._lines.length, n = new Uint32Array(t);
      for (let s = 0; s < t; s++) n[s] = this._lines[s].length + e;
      this._lineStarts = new gq(n);
    }
  }
  _setLineText(e, t) {
    this._lines[e] = t, this._lineStarts && this._lineStarts.setValue(e, this._lines[e].length + this._eol.length);
  }
  _acceptDeleteRange(e) {
    if (e.startLineNumber !== e.endLineNumber) this._setLineText(e.startLineNumber - 1, this._lines[e.startLineNumber - 1].substring(0, e.startColumn - 1) + this._lines[e.endLineNumber - 1].substring(e.endColumn - 1)), this._lines.splice(e.startLineNumber, e.endLineNumber - e.startLineNumber), this._lineStarts && this._lineStarts.removeValues(e.startLineNumber, e.endLineNumber - e.startLineNumber);
    else {
      if (e.startColumn === e.endColumn) return;
      this._setLineText(e.startLineNumber - 1, this._lines[e.startLineNumber - 1].substring(0, e.startColumn - 1) + this._lines[e.startLineNumber - 1].substring(e.endColumn - 1));
    }
  }
  _acceptInsertText(e, t) {
    if (t.length === 0) return;
    const n = Sl(t);
    if (n.length === 1) return void this._setLineText(e.lineNumber - 1, this._lines[e.lineNumber - 1].substring(0, e.column - 1) + n[0] + this._lines[e.lineNumber - 1].substring(e.column - 1));
    n[n.length - 1] += this._lines[e.lineNumber - 1].substring(e.column - 1), this._setLineText(e.lineNumber - 1, this._lines[e.lineNumber - 1].substring(0, e.column - 1) + n[0]);
    const s = new Uint32Array(n.length - 1);
    for (let o = 1; o < n.length; o++) this._lines.splice(e.lineNumber + o - 1, 0, n[o]), s[o - 1] = n[o].length + this._eol.length;
    this._lineStarts && this._lineStarts.insertValues(e.lineNumber, s);
  }
}
class _f {
  constructor(e) {
    const t = Jw(e);
    this._defaultValue = t, this._asciiMap = _f._createAsciiMap(t), this._map = /* @__PURE__ */ new Map();
  }
  static _createAsciiMap(e) {
    const t = new Uint8Array(256);
    return t.fill(e), t;
  }
  set(e, t) {
    const n = Jw(t);
    e >= 0 && e < 256 ? this._asciiMap[e] = n : this._map.set(e, n);
  }
  get(e) {
    return e >= 0 && e < 256 ? this._asciiMap[e] : this._map.get(e) || this._defaultValue;
  }
  clear() {
    this._asciiMap.fill(this._defaultValue), this._map.clear();
  }
}
class ey {
  constructor() {
    this._actual = new _f(0);
  }
  add(e) {
    this._actual.set(e, 1);
  }
  has(e) {
    return this._actual.get(e) === 1;
  }
  clear() {
    return this._actual.clear();
  }
}
class fq {
  constructor(e, t, n) {
    const s = new Uint8Array(e * t);
    for (let o = 0, r = e * t; o < r; o++) s[o] = n;
    this._data = s, this.rows = e, this.cols = t;
  }
  get(e, t) {
    return this._data[e * this.cols + t];
  }
  set(e, t, n) {
    this._data[e * this.cols + t] = n;
  }
}
class _q {
  constructor(e) {
    let t = 0, n = 0;
    for (let o = 0, r = e.length; o < r; o++) {
      const [a, l, d] = e[o];
      l > t && (t = l), a > n && (n = a), d > n && (n = d);
    }
    t++, n++;
    const s = new fq(n, t, 0);
    for (let o = 0, r = e.length; o < r; o++) {
      const [a, l, d] = e[o];
      s.set(a, l, d);
    }
    this._states = s, this._maxCharCode = t;
  }
  nextState(e, t) {
    return t < 0 || t >= this._maxCharCode ? 0 : this._states.get(e, t);
  }
}
let rD = null, Rf = null;
class ty {
  static _createLink(e, t, n, s, o) {
    let r = o - 1;
    do {
      const a = t.charCodeAt(r);
      if (e.get(a) !== 2) break;
      r--;
    } while (r > s);
    if (s > 0) {
      const a = t.charCodeAt(s - 1), l = t.charCodeAt(r);
      (a === 40 && l === 41 || a === 91 && l === 93 || a === 123 && l === 125) && r--;
    }
    return { range: { startLineNumber: n, startColumn: s + 1, endLineNumber: n, endColumn: r + 2 }, url: t.substring(s, r + 1) };
  }
  static computeLinks(e, t = function() {
    return rD === null && (rD = new _q([[1, 104, 2], [1, 72, 2], [1, 102, 6], [1, 70, 6], [2, 116, 3], [2, 84, 3], [3, 116, 4], [3, 84, 4], [4, 112, 5], [4, 80, 5], [5, 115, 9], [5, 83, 9], [5, 58, 10], [6, 105, 7], [6, 73, 7], [7, 108, 8], [7, 76, 8], [8, 101, 9], [8, 69, 9], [9, 58, 10], [10, 47, 11], [11, 47, 12]])), rD;
  }()) {
    const n = function() {
      if (Rf === null) {
        Rf = new _f(0);
        const o = ` 	<>'"、。｡､，．：；‘〈「『〔（［｛｢｣｝］）〕』」〉’｀～…`;
        for (let a = 0; a < o.length; a++) Rf.set(o.charCodeAt(a), 1);
        const r = ".,;:";
        for (let a = 0; a < r.length; a++) Rf.set(r.charCodeAt(a), 2);
      }
      return Rf;
    }(), s = [];
    for (let o = 1, r = e.getLineCount(); o <= r; o++) {
      const a = e.getLineContent(o), l = a.length;
      let d = 0, h = 0, c = 0, u = 1, g = !1, p = !1, f = !1, _ = !1;
      for (; d < l; ) {
        let v = !1;
        const b = a.charCodeAt(d);
        if (u === 13) {
          let C;
          switch (b) {
            case 40:
              g = !0, C = 0;
              break;
            case 41:
              C = g ? 0 : 1;
              break;
            case 91:
              f = !0, p = !0, C = 0;
              break;
            case 93:
              f = !1, C = p ? 0 : 1;
              break;
            case 123:
              _ = !0, C = 0;
              break;
            case 125:
              C = _ ? 0 : 1;
              break;
            case 39:
            case 34:
            case 96:
              C = c === b ? 1 : c === 39 || c === 34 || c === 96 ? 0 : 1;
              break;
            case 42:
              C = c === 42 ? 1 : 0;
              break;
            case 124:
              C = c === 124 ? 1 : 0;
              break;
            case 32:
              C = f ? 0 : 1;
              break;
            default:
              C = n.get(b);
          }
          C === 1 && (s.push(ty._createLink(n, a, o, h, d)), v = !0);
        } else if (u === 12) {
          let C;
          b === 91 ? (p = !0, C = 0) : C = n.get(b), C === 1 ? v = !0 : u = 13;
        } else u = t.nextState(u, b), u === 0 && (v = !0);
        v && (u = 1, g = !1, p = !1, _ = !1, h = d + 1, c = b), d++;
      }
      u === 13 && s.push(ty._createLink(n, a, o, h, l));
    }
    return s;
  }
}
class VE {
  constructor() {
    this._defaultValueSet = [["true", "false"], ["True", "False"], ["Private", "Public", "Friend", "ReadOnly", "Partial", "Protected", "WriteOnly"], ["public", "protected", "private"]];
  }
  navigateValueSet(e, t, n, s, o) {
    if (e && t) {
      const r = this.doNavigateValueSet(t, o);
      if (r) return { range: e, value: r };
    }
    if (n && s) {
      const r = this.doNavigateValueSet(s, o);
      if (r) return { range: n, value: r };
    }
    return null;
  }
  doNavigateValueSet(e, t) {
    const n = this.numberReplace(e, t);
    return n !== null ? n : this.textReplace(e, t);
  }
  numberReplace(e, t) {
    const n = Math.pow(10, e.length - (e.lastIndexOf(".") + 1));
    let s = Number(e);
    const o = parseFloat(e);
    return isNaN(s) || isNaN(o) || s !== o ? null : s !== 0 || t ? (s = Math.floor(s * n), s += t ? n : -n, String(s / n)) : null;
  }
  textReplace(e, t) {
    return this.valueSetsReplace(this._defaultValueSet, e, t);
  }
  valueSetsReplace(e, t, n) {
    let s = null;
    for (let o = 0, r = e.length; s === null && o < r; o++) s = this.valueSetReplace(e[o], t, n);
    return s;
  }
  valueSetReplace(e, t, n) {
    let s = e.indexOf(t);
    return s >= 0 ? (s += n ? 1 : -1, s < 0 ? s = e.length - 1 : s %= e.length, e[s]) : null;
  }
}
var e4, t4;
VE.INSTANCE = new VE();
class vq {
  constructor(e, t) {
    this.uri = e, this.value = t;
  }
}
class Di {
  constructor(e, t) {
    if (this[e4] = "ResourceMap", e instanceof Di) this.map = new Map(e.map), this.toKey = t ?? Di.defaultToKey;
    else if (function(n) {
      return Array.isArray(n);
    }(e)) {
      this.map = /* @__PURE__ */ new Map(), this.toKey = t ?? Di.defaultToKey;
      for (const [n, s] of e) this.set(n, s);
    } else this.map = /* @__PURE__ */ new Map(), this.toKey = e ?? Di.defaultToKey;
  }
  set(e, t) {
    return this.map.set(this.toKey(e), new vq(e, t)), this;
  }
  get(e) {
    var t;
    return (t = this.map.get(this.toKey(e))) === null || t === void 0 ? void 0 : t.value;
  }
  has(e) {
    return this.map.has(this.toKey(e));
  }
  get size() {
    return this.map.size;
  }
  clear() {
    this.map.clear();
  }
  delete(e) {
    return this.map.delete(this.toKey(e));
  }
  forEach(e, t) {
    t !== void 0 && (e = e.bind(t));
    for (const [n, s] of this.map) e(s.value, s.uri, this);
  }
  *values() {
    for (const e of this.map.values()) yield e.value;
  }
  *keys() {
    for (const e of this.map.values()) yield e.uri;
  }
  *entries() {
    for (const e of this.map.values()) yield [e.uri, e.value];
  }
  *[(e4 = Symbol.toStringTag, Symbol.iterator)]() {
    for (const [, e] of this.map) yield [e.uri, e.value];
  }
}
Di.defaultToKey = (i) => i.toString();
class bq {
  constructor() {
    this[t4] = "LinkedMap", this._map = /* @__PURE__ */ new Map(), this._head = void 0, this._tail = void 0, this._size = 0, this._state = 0;
  }
  clear() {
    this._map.clear(), this._head = void 0, this._tail = void 0, this._size = 0, this._state++;
  }
  isEmpty() {
    return !this._head && !this._tail;
  }
  get size() {
    return this._size;
  }
  get first() {
    var e;
    return (e = this._head) === null || e === void 0 ? void 0 : e.value;
  }
  get last() {
    var e;
    return (e = this._tail) === null || e === void 0 ? void 0 : e.value;
  }
  has(e) {
    return this._map.has(e);
  }
  get(e, t = 0) {
    const n = this._map.get(e);
    if (n) return t !== 0 && this.touch(n, t), n.value;
  }
  set(e, t, n = 0) {
    let s = this._map.get(e);
    if (s) s.value = t, n !== 0 && this.touch(s, n);
    else {
      switch (s = { key: e, value: t, next: void 0, previous: void 0 }, n) {
        case 0:
        case 2:
        default:
          this.addItemLast(s);
          break;
        case 1:
          this.addItemFirst(s);
      }
      this._map.set(e, s), this._size++;
    }
    return this;
  }
  delete(e) {
    return !!this.remove(e);
  }
  remove(e) {
    const t = this._map.get(e);
    if (t) return this._map.delete(e), this.removeItem(t), this._size--, t.value;
  }
  shift() {
    if (!this._head && !this._tail) return;
    if (!this._head || !this._tail) throw new Error("Invalid list");
    const e = this._head;
    return this._map.delete(e.key), this.removeItem(e), this._size--, e.value;
  }
  forEach(e, t) {
    const n = this._state;
    let s = this._head;
    for (; s; ) {
      if (t ? e.bind(t)(s.value, s.key, this) : e(s.value, s.key, this), this._state !== n) throw new Error("LinkedMap got modified during iteration.");
      s = s.next;
    }
  }
  keys() {
    const e = this, t = this._state;
    let n = this._head;
    const s = { [Symbol.iterator]: () => s, next() {
      if (e._state !== t) throw new Error("LinkedMap got modified during iteration.");
      if (n) {
        const o = { value: n.key, done: !1 };
        return n = n.next, o;
      }
      return { value: void 0, done: !0 };
    } };
    return s;
  }
  values() {
    const e = this, t = this._state;
    let n = this._head;
    const s = { [Symbol.iterator]: () => s, next() {
      if (e._state !== t) throw new Error("LinkedMap got modified during iteration.");
      if (n) {
        const o = { value: n.value, done: !1 };
        return n = n.next, o;
      }
      return { value: void 0, done: !0 };
    } };
    return s;
  }
  entries() {
    const e = this, t = this._state;
    let n = this._head;
    const s = { [Symbol.iterator]: () => s, next() {
      if (e._state !== t) throw new Error("LinkedMap got modified during iteration.");
      if (n) {
        const o = { value: [n.key, n.value], done: !1 };
        return n = n.next, o;
      }
      return { value: void 0, done: !0 };
    } };
    return s;
  }
  [(t4 = Symbol.toStringTag, Symbol.iterator)]() {
    return this.entries();
  }
  trimOld(e) {
    if (e >= this.size) return;
    if (e === 0) return void this.clear();
    let t = this._head, n = this.size;
    for (; t && n > e; ) this._map.delete(t.key), t = t.next, n--;
    this._head = t, this._size = n, t && (t.previous = void 0), this._state++;
  }
  addItemFirst(e) {
    if (this._head || this._tail) {
      if (!this._head) throw new Error("Invalid list");
      e.next = this._head, this._head.previous = e;
    } else this._tail = e;
    this._head = e, this._state++;
  }
  addItemLast(e) {
    if (this._head || this._tail) {
      if (!this._tail) throw new Error("Invalid list");
      e.previous = this._tail, this._tail.next = e;
    } else this._head = e;
    this._tail = e, this._state++;
  }
  removeItem(e) {
    if (e === this._head && e === this._tail) this._head = void 0, this._tail = void 0;
    else if (e === this._head) {
      if (!e.next) throw new Error("Invalid list");
      e.next.previous = void 0, this._head = e.next;
    } else if (e === this._tail) {
      if (!e.previous) throw new Error("Invalid list");
      e.previous.next = void 0, this._tail = e.previous;
    } else {
      const t = e.next, n = e.previous;
      if (!t || !n) throw new Error("Invalid list");
      t.previous = n, n.next = t;
    }
    e.next = void 0, e.previous = void 0, this._state++;
  }
  touch(e, t) {
    if (!this._head || !this._tail) throw new Error("Invalid list");
    if (t === 1 || t === 2) {
      if (t === 1) {
        if (e === this._head) return;
        const n = e.next, s = e.previous;
        e === this._tail ? (s.next = void 0, this._tail = s) : (n.previous = s, s.next = n), e.previous = void 0, e.next = this._head, this._head.previous = e, this._head = e, this._state++;
      } else if (t === 2) {
        if (e === this._tail) return;
        const n = e.next, s = e.previous;
        e === this._head ? (n.previous = void 0, this._head = n) : (n.previous = s, s.next = n), e.next = void 0, e.previous = this._tail, this._tail.next = e, this._tail = e, this._state++;
      }
    }
  }
  toJSON() {
    const e = [];
    return this.forEach((t, n) => {
      e.push([n, t]);
    }), e;
  }
  fromJSON(e) {
    this.clear();
    for (const [t, n] of e) this.set(t, n);
  }
}
class Ll extends bq {
  constructor(e, t = 1) {
    super(), this._limit = e, this._ratio = Math.min(Math.max(0, t), 1);
  }
  get limit() {
    return this._limit;
  }
  set limit(e) {
    this._limit = e, this.checkTrim();
  }
  get(e, t = 2) {
    return super.get(e, t);
  }
  peek(e) {
    return super.get(e, 0);
  }
  set(e, t) {
    return super.set(e, t, 2), this.checkTrim(), this;
  }
  checkTrim() {
    this.size > this._limit && this.trimOld(Math.round(this._limit * this._ratio));
  }
}
class Cq {
  constructor(e) {
    if (this._m1 = /* @__PURE__ */ new Map(), this._m2 = /* @__PURE__ */ new Map(), e) for (const [t, n] of e) this.set(t, n);
  }
  clear() {
    this._m1.clear(), this._m2.clear();
  }
  set(e, t) {
    this._m1.set(e, t), this._m2.set(t, e);
  }
  get(e) {
    return this._m1.get(e);
  }
  getKey(e) {
    return this._m2.get(e);
  }
  delete(e) {
    const t = this._m1.get(e);
    return t !== void 0 && (this._m1.delete(e), this._m2.delete(t), !0);
  }
  keys() {
    return this._m1.keys();
  }
  values() {
    return this._m1.values();
  }
}
class yR {
  constructor() {
    this.map = /* @__PURE__ */ new Map();
  }
  add(e, t) {
    let n = this.map.get(e);
    n || (n = /* @__PURE__ */ new Set(), this.map.set(e, n)), n.add(t);
  }
  delete(e, t) {
    const n = this.map.get(e);
    n && (n.delete(t), n.size === 0 && this.map.delete(e));
  }
  forEach(e, t) {
    const n = this.map.get(e);
    n && n.forEach(t);
  }
  get(e) {
    return this.map.get(e) || /* @__PURE__ */ new Set();
  }
}
class wq extends _f {
  constructor(e, t) {
    super(0), this._segmenter = null, this._cachedLine = null, this._cachedSegments = [], this.intlSegmenterLocales = t, this.intlSegmenterLocales.length > 0 ? this._segmenter = new Intl.Segmenter(this.intlSegmenterLocales, { granularity: "word" }) : this._segmenter = null;
    for (let n = 0, s = e.length; n < s; n++) this.set(e.charCodeAt(n), 2);
    this.set(32, 1), this.set(9, 1);
  }
  findPrevIntlWordBeforeOrAtOffset(e, t) {
    let n = null;
    for (const s of this._getIntlSegmenterWordsOnLine(e)) {
      if (s.index > t) break;
      n = s;
    }
    return n;
  }
  findNextIntlWordAtOrAfterOffset(e, t) {
    for (const n of this._getIntlSegmenterWordsOnLine(e)) if (!(n.index < t)) return n;
    return null;
  }
  _getIntlSegmenterWordsOnLine(e) {
    return this._segmenter ? (this._cachedLine === e || (this._cachedLine = e, this._cachedSegments = this._filterWordSegments(this._segmenter.segment(e))), this._cachedSegments) : [];
  }
  _filterWordSegments(e) {
    const t = [];
    for (const n of e) this._isWordLike(n) && t.push(n);
    return t;
  }
  _isWordLike(e) {
    return !!e.isWordLike;
  }
}
const i4 = new Ll(10);
function zo(i, e) {
  const t = `${i}/${e.join(",")}`;
  let n = i4.get(t);
  return n || (n = new wq(i, e), i4.set(t, n)), n;
}
var Do, _l, vr;
(function(i) {
  i[i.Left = 1] = "Left", i[i.Center = 2] = "Center", i[i.Right = 4] = "Right", i[i.Full = 7] = "Full";
})(Do || (Do = {})), function(i) {
  i[i.Left = 1] = "Left", i[i.Center = 2] = "Center", i[i.Right = 3] = "Right";
}(_l || (_l = {})), function(i) {
  i[i.Both = 0] = "Both", i[i.Right = 1] = "Right", i[i.Left = 2] = "Left", i[i.None = 3] = "None";
}(vr || (vr = {}));
class AC {
  get originalIndentSize() {
    return this._indentSizeIsTabSize ? "tabSize" : this.indentSize;
  }
  constructor(e) {
    this._textModelResolvedOptionsBrand = void 0, this.tabSize = Math.max(1, 0 | e.tabSize), e.indentSize === "tabSize" ? (this.indentSize = this.tabSize, this._indentSizeIsTabSize = !0) : (this.indentSize = Math.max(1, 0 | e.indentSize), this._indentSizeIsTabSize = !1), this.insertSpaces = !!e.insertSpaces, this.defaultEOL = 0 | e.defaultEOL, this.trimAutoWhitespace = !!e.trimAutoWhitespace, this.bracketPairColorizationOptions = e.bracketPairColorizationOptions;
  }
  equals(e) {
    return this.tabSize === e.tabSize && this._indentSizeIsTabSize === e._indentSizeIsTabSize && this.indentSize === e.indentSize && this.insertSpaces === e.insertSpaces && this.defaultEOL === e.defaultEOL && this.trimAutoWhitespace === e.trimAutoWhitespace && So(this.bracketPairColorizationOptions, e.bracketPairColorizationOptions);
  }
  createChangeEvent(e) {
    return { tabSize: this.tabSize !== e.tabSize, indentSize: this.indentSize !== e.indentSize, insertSpaces: this.insertSpaces !== e.insertSpaces, trimAutoWhitespace: this.trimAutoWhitespace !== e.trimAutoWhitespace };
  }
}
class nv {
  constructor(e, t) {
    this._findMatchBrand = void 0, this.range = e, this.matches = t;
  }
}
class aD {
  constructor(e, t, n, s, o, r) {
    this.identifier = e, this.range = t, this.text = n, this.forceMoveMarkers = s, this.isAutoWhitespaceEdit = o, this._isTracked = r;
  }
}
class yq {
  constructor(e, t, n) {
    this.regex = e, this.wordSeparators = t, this.simpleSearch = n;
  }
}
class Sq {
  constructor(e, t, n) {
    this.reverseEdits = e, this.changes = t, this.trimAutoWhitespaceLineNumbers = n;
  }
}
function G8(i) {
  return !i.isTooLargeForSyncing() && !i.isForSimpleWidget;
}
class ou {
  constructor(e, t, n, s) {
    this.searchString = e, this.isRegex = t, this.matchCase = n, this.wordSeparators = s;
  }
  parseSearchRequest() {
    if (this.searchString === "") return null;
    let e;
    e = this.isRegex ? function(s) {
      if (!s || s.length === 0) return !1;
      for (let o = 0, r = s.length; o < r; o++) {
        const a = s.charCodeAt(o);
        if (a === 10) return !0;
        if (a === 92) {
          if (o++, o >= r) break;
          const l = s.charCodeAt(o);
          if (l === 110 || l === 114 || l === 87) return !0;
        }
      }
      return !1;
    }(this.searchString) : this.searchString.indexOf(`
`) >= 0;
    let t = null;
    try {
      t = J7(this.searchString, this.isRegex, { matchCase: this.matchCase, wholeWord: !1, multiline: e, global: !0, unicode: !0 });
    } catch {
      return null;
    }
    if (!t) return null;
    let n = !this.isRegex && !e;
    return n && this.searchString.toLowerCase() !== this.searchString.toUpperCase() && (n = this.matchCase), new yq(t, this.wordSeparators ? zo(this.wordSeparators, []) : null, n ? this.searchString : null);
  }
}
function mu(i, e, t) {
  if (!t) return new nv(i, null);
  const n = [];
  for (let s = 0, o = e.length; s < o; s++) n[s] = e[s];
  return new nv(i, n);
}
class n4 {
  constructor(e) {
    const t = [];
    let n = 0;
    for (let s = 0, o = e.length; s < o; s++) e.charCodeAt(s) === 10 && (t[n++] = s);
    this._lineFeedsOffsets = t;
  }
  findLineFeedCountBeforeOffset(e) {
    const t = this._lineFeedsOffsets;
    let n = 0, s = t.length - 1;
    if (s === -1 || e <= t[0]) return 0;
    for (; n < s; ) {
      const o = n + ((s - n) / 2 | 0);
      t[o] >= e ? s = o - 1 : t[o + 1] >= e ? (n = o, s = o) : n = o + 1;
    }
    return n + 1;
  }
}
class rb {
  static findMatches(e, t, n, s, o) {
    const r = t.parseSearchRequest();
    return r ? r.regex.multiline ? this._doFindMatchesMultiline(e, n, new Ep(r.wordSeparators, r.regex), s, o) : this._doFindMatchesLineByLine(e, n, r, s, o) : [];
  }
  static _getMultilineMatchRange(e, t, n, s, o, r) {
    let a, l, d = 0;
    if (s ? (d = s.findLineFeedCountBeforeOffset(o), a = t + o + d) : a = t + o, s) {
      const u = s.findLineFeedCountBeforeOffset(o + r.length) - d;
      l = a + r.length + u;
    } else l = a + r.length;
    const h = e.getPositionAt(a), c = e.getPositionAt(l);
    return new D(h.lineNumber, h.column, c.lineNumber, c.column);
  }
  static _doFindMatchesMultiline(e, t, n, s, o) {
    const r = e.getOffsetAt(t.getStartPosition()), a = e.getValueInRange(t, 1), l = e.getEOL() === `\r
` ? new n4(a) : null, d = [];
    let h, c = 0;
    for (n.reset(0); h = n.next(a); ) if (d[c++] = mu(this._getMultilineMatchRange(e, r, a, l, h.index, h[0]), h, s), c >= o) return d;
    return d;
  }
  static _doFindMatchesLineByLine(e, t, n, s, o) {
    const r = [];
    let a = 0;
    if (t.startLineNumber === t.endLineNumber) {
      const d = e.getLineContent(t.startLineNumber).substring(t.startColumn - 1, t.endColumn - 1);
      return a = this._findMatchesInLine(n, d, t.startLineNumber, t.startColumn - 1, a, r, s, o), r;
    }
    const l = e.getLineContent(t.startLineNumber).substring(t.startColumn - 1);
    a = this._findMatchesInLine(n, l, t.startLineNumber, t.startColumn - 1, a, r, s, o);
    for (let d = t.startLineNumber + 1; d < t.endLineNumber && a < o; d++) a = this._findMatchesInLine(n, e.getLineContent(d), d, 0, a, r, s, o);
    if (a < o) {
      const d = e.getLineContent(t.endLineNumber).substring(0, t.endColumn - 1);
      a = this._findMatchesInLine(n, d, t.endLineNumber, 0, a, r, s, o);
    }
    return r;
  }
  static _findMatchesInLine(e, t, n, s, o, r, a, l) {
    const d = e.wordSeparators;
    if (!a && e.simpleSearch) {
      const u = e.simpleSearch, g = u.length, p = t.length;
      let f = -g;
      for (; (f = t.indexOf(u, f + g)) !== -1; ) if ((!d || SR(d, t, p, f, g)) && (r[o++] = new nv(new D(n, f + 1 + s, n, f + 1 + g + s), null), o >= l)) return o;
      return o;
    }
    const h = new Ep(e.wordSeparators, e.regex);
    let c;
    h.reset(0);
    do
      if (c = h.next(t), c && (r[o++] = mu(new D(n, c.index + 1 + s, n, c.index + 1 + c[0].length + s), c, a), o >= l)) return o;
    while (c);
    return o;
  }
  static findNextMatch(e, t, n, s) {
    const o = t.parseSearchRequest();
    if (!o) return null;
    const r = new Ep(o.wordSeparators, o.regex);
    return o.regex.multiline ? this._doFindNextMatchMultiline(e, n, r, s) : this._doFindNextMatchLineByLine(e, n, r, s);
  }
  static _doFindNextMatchMultiline(e, t, n, s) {
    const o = new W(t.lineNumber, 1), r = e.getOffsetAt(o), a = e.getLineCount(), l = e.getValueInRange(new D(o.lineNumber, o.column, a, e.getLineMaxColumn(a)), 1), d = e.getEOL() === `\r
` ? new n4(l) : null;
    n.reset(t.column - 1);
    const h = n.next(l);
    return h ? mu(this._getMultilineMatchRange(e, r, l, d, h.index, h[0]), h, s) : t.lineNumber !== 1 || t.column !== 1 ? this._doFindNextMatchMultiline(e, new W(1, 1), n, s) : null;
  }
  static _doFindNextMatchLineByLine(e, t, n, s) {
    const o = e.getLineCount(), r = t.lineNumber, a = e.getLineContent(r), l = this._findFirstMatchInLine(n, a, r, t.column, s);
    if (l) return l;
    for (let d = 1; d <= o; d++) {
      const h = (r + d - 1) % o, c = e.getLineContent(h + 1), u = this._findFirstMatchInLine(n, c, h + 1, 1, s);
      if (u) return u;
    }
    return null;
  }
  static _findFirstMatchInLine(e, t, n, s, o) {
    e.reset(s - 1);
    const r = e.next(t);
    return r ? mu(new D(n, r.index + 1, n, r.index + 1 + r[0].length), r, o) : null;
  }
  static findPreviousMatch(e, t, n, s) {
    const o = t.parseSearchRequest();
    if (!o) return null;
    const r = new Ep(o.wordSeparators, o.regex);
    return o.regex.multiline ? this._doFindPreviousMatchMultiline(e, n, r, s) : this._doFindPreviousMatchLineByLine(e, n, r, s);
  }
  static _doFindPreviousMatchMultiline(e, t, n, s) {
    const o = this._doFindMatchesMultiline(e, new D(1, 1, t.lineNumber, t.column), n, s, 9990);
    if (o.length > 0) return o[o.length - 1];
    const r = e.getLineCount();
    return t.lineNumber !== r || t.column !== e.getLineMaxColumn(r) ? this._doFindPreviousMatchMultiline(e, new W(r, e.getLineMaxColumn(r)), n, s) : null;
  }
  static _doFindPreviousMatchLineByLine(e, t, n, s) {
    const o = e.getLineCount(), r = t.lineNumber, a = e.getLineContent(r).substring(0, t.column - 1), l = this._findLastMatchInLine(n, a, r, s);
    if (l) return l;
    for (let d = 1; d <= o; d++) {
      const h = (o + r - d - 1) % o, c = e.getLineContent(h + 1), u = this._findLastMatchInLine(n, c, h + 1, s);
      if (u) return u;
    }
    return null;
  }
  static _findLastMatchInLine(e, t, n, s) {
    let o, r = null;
    for (e.reset(0); o = e.next(t); ) r = mu(new D(n, o.index + 1, n, o.index + 1 + o[0].length), o, s);
    return r;
  }
}
function SR(i, e, t, n, s) {
  return function(o, r, a, l, d) {
    if (l === 0) return !0;
    const h = r.charCodeAt(l - 1);
    if (o.get(h) !== 0 || h === 13 || h === 10) return !0;
    if (d > 0) {
      const c = r.charCodeAt(l);
      if (o.get(c) !== 0) return !0;
    }
    return !1;
  }(i, e, 0, n, s) && function(o, r, a, l, d) {
    if (l + d === a) return !0;
    const h = r.charCodeAt(l + d);
    if (o.get(h) !== 0 || h === 13 || h === 10) return !0;
    if (d > 0) {
      const c = r.charCodeAt(l + d - 1);
      if (o.get(c) !== 0) return !0;
    }
    return !1;
  }(i, e, t, n, s);
}
class Ep {
  constructor(e, t) {
    this._wordSeparators = e, this._searchRegex = t, this._prevMatchStartIndex = -1, this._prevMatchLength = 0;
  }
  reset(e) {
    this._searchRegex.lastIndex = e, this._prevMatchStartIndex = -1, this._prevMatchLength = 0;
  }
  next(e) {
    const t = e.length;
    let n;
    do {
      if (this._prevMatchStartIndex + this._prevMatchLength === t || (n = this._searchRegex.exec(e), !n)) return null;
      const s = n.index, o = n[0].length;
      if (s === this._prevMatchStartIndex && o === this._prevMatchLength) {
        if (o === 0) {
          Hw(e, t, this._searchRegex.lastIndex) > 65535 ? this._searchRegex.lastIndex += 2 : this._searchRegex.lastIndex += 1;
          continue;
        }
        return null;
      }
      if (this._prevMatchStartIndex = s, this._prevMatchLength = o, !this._wordSeparators || SR(this._wordSeparators, e, t, s, o)) return n;
    } while (n);
    return null;
  }
}
class LR {
  static computeUnicodeHighlights(e, t, n) {
    const s = n ? n.startLineNumber : 1, o = n ? n.endLineNumber : e.getLineCount(), r = new s4(t), a = r.getCandidateCodePoints();
    let l;
    l = a === "allNonBasicAscii" ? new RegExp("[^\\t\\n\\r\\x20-\\x7E]", "g") : new RegExp(`[${No(Array.from(a).map((_) => String.fromCodePoint(_)).join(""))}]`, "g");
    const d = new Ep(null, l), h = [];
    let c, u = !1, g = 0, p = 0, f = 0;
    e: for (let _ = s, v = o; _ <= v; _++) {
      const b = e.getLineContent(_), C = b.length;
      d.reset(0);
      do
        if (c = d.next(b), c) {
          let w = c.index, y = c.index + c[0].length;
          w > 0 && en(b.charCodeAt(w - 1)) && w--, y + 1 < C && en(b.charCodeAt(y - 1)) && y++;
          const L = b.substring(w, y);
          let k = q0(w + 1, GT, b, 0);
          k && k.endColumn <= w + 1 && (k = null);
          const N = r.shouldHighlightNonBasicASCII(L, k ? k.word : null);
          if (N !== 0) {
            if (N === 3 ? g++ : N === 2 ? p++ : N === 1 ? f++ : JS(), h.length >= 1e3) {
              u = !0;
              break e;
            }
            h.push(new D(_, w + 1, _, y + 1));
          }
        }
      while (c);
    }
    return { ranges: h, hasMore: u, ambiguousCharacterCount: g, invisibleCharacterCount: p, nonBasicAsciiCharacterCount: f };
  }
  static computeUnicodeHighlightReason(e, t) {
    const n = new s4(t);
    switch (n.shouldHighlightNonBasicASCII(e, null)) {
      case 0:
        return null;
      case 2:
        return { kind: 1 };
      case 3: {
        const s = e.codePointAt(0), o = n.ambiguousCharacters.getPrimaryConfusable(s), r = Nu.getLocales().filter((a) => !Nu.getInstance(/* @__PURE__ */ new Set([...t.allowedLocales, a])).isAmbiguous(s));
        return { kind: 0, confusableWith: String.fromCodePoint(o), notAmbiguousInLocales: r };
      }
      case 1:
        return { kind: 2 };
    }
  }
}
class s4 {
  constructor(e) {
    this.options = e, this.allowedCodePoints = new Set(e.allowedCodePoints), this.ambiguousCharacters = Nu.getInstance(new Set(e.allowedLocales));
  }
  getCandidateCodePoints() {
    if (this.options.nonBasicASCII) return "allNonBasicAscii";
    const e = /* @__PURE__ */ new Set();
    if (this.options.invisibleCharacters) for (const t of gl.codePoints) o4(String.fromCodePoint(t)) || e.add(t);
    if (this.options.ambiguousCharacters) for (const t of this.ambiguousCharacters.getConfusableCodePoints()) e.add(t);
    for (const t of this.allowedCodePoints) e.delete(t);
    return e;
  }
  shouldHighlightNonBasicASCII(e, t) {
    const n = e.codePointAt(0);
    if (this.allowedCodePoints.has(n)) return 0;
    if (this.options.nonBasicASCII) return 1;
    let s = !1, o = !1;
    if (t) for (const r of t) {
      const a = r.codePointAt(0), l = f1(r);
      s = s || l, l || this.ambiguousCharacters.isAmbiguous(a) || gl.isInvisibleCharacter(a) || (o = !0);
    }
    return !s && o ? 0 : this.options.invisibleCharacters && !o4(e) && gl.isInvisibleCharacter(n) ? 2 : this.options.ambiguousCharacters && this.ambiguousCharacters.isAmbiguous(n) ? 3 : 0;
  }
}
function o4(i) {
  return i === " " || i === `
` || i === "	";
}
class PC {
  constructor(e, t, n) {
    this.changes = e, this.moves = t, this.hitTimeout = n;
  }
}
class Z8 {
  constructor(e, t) {
    this.lineRangeMapping = e, this.changes = t;
  }
}
class qe {
  static addRange(e, t) {
    let n = 0;
    for (; n < t.length && t[n].endExclusive < e.start; ) n++;
    let s = n;
    for (; s < t.length && t[s].start <= e.endExclusive; ) s++;
    if (n === s) t.splice(n, 0, e);
    else {
      const o = Math.min(e.start, t[n].start), r = Math.max(e.endExclusive, t[s - 1].endExclusive);
      t.splice(n, s - n, new qe(o, r));
    }
  }
  static tryCreate(e, t) {
    if (!(e > t)) return new qe(e, t);
  }
  static ofLength(e) {
    return new qe(0, e);
  }
  static ofStartAndLength(e, t) {
    return new qe(e, e + t);
  }
  constructor(e, t) {
    if (this.start = e, this.endExclusive = t, e > t) throw new Kt(`Invalid range: ${this.toString()}`);
  }
  get isEmpty() {
    return this.start === this.endExclusive;
  }
  delta(e) {
    return new qe(this.start + e, this.endExclusive + e);
  }
  deltaStart(e) {
    return new qe(this.start + e, this.endExclusive);
  }
  deltaEnd(e) {
    return new qe(this.start, this.endExclusive + e);
  }
  get length() {
    return this.endExclusive - this.start;
  }
  toString() {
    return `[${this.start}, ${this.endExclusive})`;
  }
  contains(e) {
    return this.start <= e && e < this.endExclusive;
  }
  join(e) {
    return new qe(Math.min(this.start, e.start), Math.max(this.endExclusive, e.endExclusive));
  }
  intersect(e) {
    const t = Math.max(this.start, e.start), n = Math.min(this.endExclusive, e.endExclusive);
    if (t <= n) return new qe(t, n);
  }
  intersects(e) {
    return Math.max(this.start, e.start) < Math.min(this.endExclusive, e.endExclusive);
  }
  isBefore(e) {
    return this.endExclusive <= e.start;
  }
  isAfter(e) {
    return this.start >= e.endExclusive;
  }
  slice(e) {
    return e.slice(this.start, this.endExclusive);
  }
  substring(e) {
    return e.substring(this.start, this.endExclusive);
  }
  clip(e) {
    if (this.isEmpty) throw new Kt(`Invalid clipping range: ${this.toString()}`);
    return Math.max(this.start, Math.min(this.endExclusive - 1, e));
  }
  clipCyclic(e) {
    if (this.isEmpty) throw new Kt(`Invalid clipping range: ${this.toString()}`);
    return e < this.start ? this.endExclusive - (this.start - e) % this.length : e >= this.endExclusive ? this.start + (e - this.start) % this.length : e;
  }
  forEach(e) {
    for (let t = this.start; t < this.endExclusive; t++) e(t);
  }
}
class kR {
  constructor() {
    this._sortedRanges = [];
  }
  addRange(e) {
    let t = 0;
    for (; t < this._sortedRanges.length && this._sortedRanges[t].endExclusive < e.start; ) t++;
    let n = t;
    for (; n < this._sortedRanges.length && this._sortedRanges[n].start <= e.endExclusive; ) n++;
    if (t === n) this._sortedRanges.splice(t, 0, e);
    else {
      const s = Math.min(e.start, this._sortedRanges[t].start), o = Math.max(e.endExclusive, this._sortedRanges[n - 1].endExclusive);
      this._sortedRanges.splice(t, n - t, new qe(s, o));
    }
  }
  toString() {
    return this._sortedRanges.map((e) => e.toString()).join(", ");
  }
  intersectsStrict(e) {
    let t = 0;
    for (; t < this._sortedRanges.length && this._sortedRanges[t].endExclusive <= e.start; ) t++;
    return t < this._sortedRanges.length && this._sortedRanges[t].start < e.endExclusive;
  }
  intersectWithRange(e) {
    const t = new kR();
    for (const n of this._sortedRanges) {
      const s = n.intersect(e);
      s && t.addRange(s);
    }
    return t;
  }
  intersectWithRangeLength(e) {
    return this.intersectWithRange(e).length;
  }
  get length() {
    return this._sortedRanges.reduce((e, t) => e + t.length, 0);
  }
}
function sv(i, e, t) {
  const n = function(s, o, r = s.length - 1) {
    for (let a = r; a >= 0; a--)
      if (o(s[a])) return a;
    return -1;
  }(i, e);
  if (n !== -1) return i[n];
}
function im(i, e) {
  const t = ov(i, e);
  return t === -1 ? void 0 : i[t];
}
function ov(i, e, t = 0, n = i.length) {
  let s = t, o = n;
  for (; s < o; ) {
    const r = Math.floor((s + o) / 2);
    e(i[r]) ? s = r + 1 : o = r;
  }
  return s - 1;
}
function rv(i, e, t = 0, n = i.length) {
  let s = t, o = n;
  for (; s < o; ) {
    const r = Math.floor((s + o) / 2);
    e(i[r]) ? o = r : s = r + 1;
  }
  return s;
}
class av {
  constructor(e) {
    this._array = e, this._findLastMonotonousLastIdx = 0;
  }
  findLastMonotonous(e) {
    if (av.assertInvariants) {
      if (this._prevFindLastPredicate) {
        for (const n of this._array) if (this._prevFindLastPredicate(n) && !e(n)) throw new Error("MonotonousArray: current predicate must be weaker than (or equal to) the previous predicate.");
      }
      this._prevFindLastPredicate = e;
    }
    const t = ov(this._array, e, this._findLastMonotonousLastIdx);
    return this._findLastMonotonousLastIdx = t + 1, t === -1 ? void 0 : this._array[t];
  }
}
function DR(i, e) {
  if (i.length === 0) return;
  let t = i[0];
  for (let n = 1; n < i.length; n++) {
    const s = i[n];
    e(s, t) > 0 && (t = s);
  }
  return t;
}
function Lq(i, e) {
  if (i.length === 0) return -1;
  let t = 0;
  for (let n = 1; n < i.length; n++)
    e(i[n], i[t]) > 0 && (t = n);
  return t;
}
av.assertInvariants = !1;
let je = class Pl {
  static fromRangeInclusive(e) {
    return new Pl(e.startLineNumber, e.endLineNumber + 1);
  }
  static joinMany(e) {
    if (e.length === 0) return [];
    let t = new Uo(e[0].slice());
    for (let n = 1; n < e.length; n++) t = t.getUnion(new Uo(e[n].slice()));
    return t.ranges;
  }
  static join(e) {
    if (e.length === 0) throw new Kt("lineRanges cannot be empty");
    let t = e[0].startLineNumber, n = e[0].endLineNumberExclusive;
    for (let s = 1; s < e.length; s++) t = Math.min(t, e[s].startLineNumber), n = Math.max(n, e[s].endLineNumberExclusive);
    return new Pl(t, n);
  }
  static ofLength(e, t) {
    return new Pl(e, e + t);
  }
  static deserialize(e) {
    return new Pl(e[0], e[1]);
  }
  constructor(e, t) {
    if (e > t) throw new Kt(`startLineNumber ${e} cannot be after endLineNumberExclusive ${t}`);
    this.startLineNumber = e, this.endLineNumberExclusive = t;
  }
  contains(e) {
    return this.startLineNumber <= e && e < this.endLineNumberExclusive;
  }
  get isEmpty() {
    return this.startLineNumber === this.endLineNumberExclusive;
  }
  delta(e) {
    return new Pl(this.startLineNumber + e, this.endLineNumberExclusive + e);
  }
  deltaLength(e) {
    return new Pl(this.startLineNumber, this.endLineNumberExclusive + e);
  }
  get length() {
    return this.endLineNumberExclusive - this.startLineNumber;
  }
  join(e) {
    return new Pl(Math.min(this.startLineNumber, e.startLineNumber), Math.max(this.endLineNumberExclusive, e.endLineNumberExclusive));
  }
  toString() {
    return `[${this.startLineNumber},${this.endLineNumberExclusive})`;
  }
  intersect(e) {
    const t = Math.max(this.startLineNumber, e.startLineNumber), n = Math.min(this.endLineNumberExclusive, e.endLineNumberExclusive);
    if (t <= n) return new Pl(t, n);
  }
  intersectsStrict(e) {
    return this.startLineNumber < e.endLineNumberExclusive && e.startLineNumber < this.endLineNumberExclusive;
  }
  overlapOrTouch(e) {
    return this.startLineNumber <= e.endLineNumberExclusive && e.startLineNumber <= this.endLineNumberExclusive;
  }
  equals(e) {
    return this.startLineNumber === e.startLineNumber && this.endLineNumberExclusive === e.endLineNumberExclusive;
  }
  toInclusiveRange() {
    return this.isEmpty ? null : new D(this.startLineNumber, 1, this.endLineNumberExclusive - 1, Number.MAX_SAFE_INTEGER);
  }
  toExclusiveRange() {
    return new D(this.startLineNumber, 1, this.endLineNumberExclusive, 1);
  }
  mapToLineArray(e) {
    const t = [];
    for (let n = this.startLineNumber; n < this.endLineNumberExclusive; n++) t.push(e(n));
    return t;
  }
  forEach(e) {
    for (let t = this.startLineNumber; t < this.endLineNumberExclusive; t++) e(t);
  }
  serialize() {
    return [this.startLineNumber, this.endLineNumberExclusive];
  }
  includes(e) {
    return this.startLineNumber <= e && e < this.endLineNumberExclusive;
  }
  toOffsetRange() {
    return new qe(this.startLineNumber - 1, this.endLineNumberExclusive - 1);
  }
};
class Uo {
  constructor(e = []) {
    this._normalizedRanges = e;
  }
  get ranges() {
    return this._normalizedRanges;
  }
  addRange(e) {
    if (e.length === 0) return;
    const t = rv(this._normalizedRanges, (s) => s.endLineNumberExclusive >= e.startLineNumber), n = ov(this._normalizedRanges, (s) => s.startLineNumber <= e.endLineNumberExclusive) + 1;
    if (t === n) this._normalizedRanges.splice(t, 0, e);
    else if (t === n - 1) {
      const s = this._normalizedRanges[t];
      this._normalizedRanges[t] = s.join(e);
    } else {
      const s = this._normalizedRanges[t].join(this._normalizedRanges[n - 1]).join(e);
      this._normalizedRanges.splice(t, n - t, s);
    }
  }
  contains(e) {
    const t = im(this._normalizedRanges, (n) => n.startLineNumber <= e);
    return !!t && t.endLineNumberExclusive > e;
  }
  intersects(e) {
    const t = im(this._normalizedRanges, (n) => n.startLineNumber < e.endLineNumberExclusive);
    return !!t && t.endLineNumberExclusive > e.startLineNumber;
  }
  getUnion(e) {
    if (this._normalizedRanges.length === 0) return e;
    if (e._normalizedRanges.length === 0) return this;
    const t = [];
    let n = 0, s = 0, o = null;
    for (; n < this._normalizedRanges.length || s < e._normalizedRanges.length; ) {
      let r = null;
      if (n < this._normalizedRanges.length && s < e._normalizedRanges.length) {
        const a = this._normalizedRanges[n], l = e._normalizedRanges[s];
        a.startLineNumber < l.startLineNumber ? (r = a, n++) : (r = l, s++);
      } else n < this._normalizedRanges.length ? (r = this._normalizedRanges[n], n++) : (r = e._normalizedRanges[s], s++);
      o === null ? o = r : o.endLineNumberExclusive >= r.startLineNumber ? o = new je(o.startLineNumber, Math.max(o.endLineNumberExclusive, r.endLineNumberExclusive)) : (t.push(o), o = r);
    }
    return o !== null && t.push(o), new Uo(t);
  }
  subtractFrom(e) {
    const t = rv(this._normalizedRanges, (r) => r.endLineNumberExclusive >= e.startLineNumber), n = ov(this._normalizedRanges, (r) => r.startLineNumber <= e.endLineNumberExclusive) + 1;
    if (t === n) return new Uo([e]);
    const s = [];
    let o = e.startLineNumber;
    for (let r = t; r < n; r++) {
      const a = this._normalizedRanges[r];
      a.startLineNumber > o && s.push(new je(o, a.startLineNumber)), o = a.endLineNumberExclusive;
    }
    return o < e.endLineNumberExclusive && s.push(new je(o, e.endLineNumberExclusive)), new Uo(s);
  }
  toString() {
    return this._normalizedRanges.map((e) => e.toString()).join(", ");
  }
  getIntersection(e) {
    const t = [];
    let n = 0, s = 0;
    for (; n < this._normalizedRanges.length && s < e._normalizedRanges.length; ) {
      const o = this._normalizedRanges[n], r = e._normalizedRanges[s], a = o.intersect(r);
      a && !a.isEmpty && t.push(a), o.endLineNumberExclusive < r.endLineNumberExclusive ? n++ : s++;
    }
    return new Uo(t);
  }
  getWithDelta(e) {
    return new Uo(this._normalizedRanges.map((t) => t.delta(e)));
  }
}
class us {
  static inverse(e, t, n) {
    const s = [];
    let o = 1, r = 1;
    for (const l of e) {
      const d = new us(new je(o, l.original.startLineNumber), new je(r, l.modified.startLineNumber));
      d.modified.isEmpty || s.push(d), o = l.original.endLineNumberExclusive, r = l.modified.endLineNumberExclusive;
    }
    const a = new us(new je(o, t + 1), new je(r, n + 1));
    return a.modified.isEmpty || s.push(a), s;
  }
  static clip(e, t, n) {
    const s = [];
    for (const o of e) {
      const r = o.original.intersect(t), a = o.modified.intersect(n);
      r && !r.isEmpty && a && !a.isEmpty && s.push(new us(r, a));
    }
    return s;
  }
  constructor(e, t) {
    this.original = e, this.modified = t;
  }
  toString() {
    return `{${this.original.toString()}->${this.modified.toString()}}`;
  }
  flip() {
    return new us(this.modified, this.original);
  }
  join(e) {
    return new us(this.original.join(e.original), this.modified.join(e.modified));
  }
}
class xo extends us {
  static fromRangeMappings(e) {
    const t = je.join(e.map((s) => je.fromRangeInclusive(s.originalRange))), n = je.join(e.map((s) => je.fromRangeInclusive(s.modifiedRange)));
    return new xo(t, n, e);
  }
  constructor(e, t, n) {
    super(e, t), this.innerChanges = n;
  }
  flip() {
    var e;
    return new xo(this.modified, this.original, (e = this.innerChanges) === null || e === void 0 ? void 0 : e.map((t) => t.flip()));
  }
  withInnerChangesFromLineRanges() {
    return new xo(this.original, this.modified, [new Fd(this.original.toExclusiveRange(), this.modified.toExclusiveRange())]);
  }
}
class Fd {
  constructor(e, t) {
    this.originalRange = e, this.modifiedRange = t;
  }
  toString() {
    return `{${this.originalRange.toString()}->${this.modifiedRange.toString()}}`;
  }
  flip() {
    return new Fd(this.modifiedRange, this.originalRange);
  }
}
class kq {
  computeDiff(e, t, n) {
    var s;
    const o = new xq(e, t, { maxComputationTime: n.maxComputationTimeMs, shouldIgnoreTrimWhitespace: n.ignoreTrimWhitespace, shouldComputeCharChanges: !0, shouldMakePrettyDiff: !0, shouldPostProcessCharChanges: !0 }).computeDiff(), r = [];
    let a = null;
    for (const l of o.changes) {
      let d, h;
      d = l.originalEndLineNumber === 0 ? new je(l.originalStartLineNumber + 1, l.originalStartLineNumber + 1) : new je(l.originalStartLineNumber, l.originalEndLineNumber + 1), h = l.modifiedEndLineNumber === 0 ? new je(l.modifiedStartLineNumber + 1, l.modifiedStartLineNumber + 1) : new je(l.modifiedStartLineNumber, l.modifiedEndLineNumber + 1);
      let c = new xo(d, h, (s = l.charChanges) === null || s === void 0 ? void 0 : s.map((u) => new Fd(new D(u.originalStartLineNumber, u.originalStartColumn, u.originalEndLineNumber, u.originalEndColumn), new D(u.modifiedStartLineNumber, u.modifiedStartColumn, u.modifiedEndLineNumber, u.modifiedEndColumn))));
      a && (a.modified.endLineNumberExclusive !== c.modified.startLineNumber && a.original.endLineNumberExclusive !== c.original.startLineNumber || (c = new xo(a.original.join(c.original), a.modified.join(c.modified), a.innerChanges && c.innerChanges ? a.innerChanges.concat(c.innerChanges) : void 0), r.pop())), r.push(c), a = c;
    }
    return cg(() => CR(r, (l, d) => d.original.startLineNumber - l.original.endLineNumberExclusive == d.modified.startLineNumber - l.modified.endLineNumberExclusive && l.original.endLineNumberExclusive < d.original.startLineNumber && l.modified.endLineNumberExclusive < d.modified.startLineNumber)), new PC(r, [], o.quitEarly);
  }
}
function Y8(i, e, t, n) {
  return new $a(i, e, t).ComputeDiff(n);
}
let r4 = class {
  constructor(i) {
    const e = [], t = [];
    for (let n = 0, s = i.length; n < s; n++) e[n] = HE(i[n], 1), t[n] = zE(i[n], 1);
    this.lines = i, this._startColumns = e, this._endColumns = t;
  }
  getElements() {
    const i = [];
    for (let e = 0, t = this.lines.length; e < t; e++) i[e] = this.lines[e].substring(this._startColumns[e] - 1, this._endColumns[e] - 1);
    return i;
  }
  getStrictElement(i) {
    return this.lines[i];
  }
  getStartLineNumber(i) {
    return i + 1;
  }
  getEndLineNumber(i) {
    return i + 1;
  }
  createCharSequence(i, e, t) {
    const n = [], s = [], o = [];
    let r = 0;
    for (let a = e; a <= t; a++) {
      const l = this.lines[a], d = i ? this._startColumns[a] : 1, h = i ? this._endColumns[a] : l.length + 1;
      for (let c = d; c < h; c++) n[r] = l.charCodeAt(c - 1), s[r] = a + 1, o[r] = c, r++;
      !i && a < t && (n[r] = 10, s[r] = a + 1, o[r] = l.length + 1, r++);
    }
    return new Dq(n, s, o);
  }
};
class Dq {
  constructor(e, t, n) {
    this._charCodes = e, this._lineNumbers = t, this._columns = n;
  }
  toString() {
    return "[" + this._charCodes.map((e, t) => (e === 10 ? "\\n" : String.fromCharCode(e)) + `-(${this._lineNumbers[t]},${this._columns[t]})`).join(", ") + "]";
  }
  _assertIndex(e, t) {
    if (e < 0 || e >= t.length) throw new Error("Illegal index");
  }
  getElements() {
    return this._charCodes;
  }
  getStartLineNumber(e) {
    return e > 0 && e === this._lineNumbers.length ? this.getEndLineNumber(e - 1) : (this._assertIndex(e, this._lineNumbers), this._lineNumbers[e]);
  }
  getEndLineNumber(e) {
    return e === -1 ? this.getStartLineNumber(e + 1) : (this._assertIndex(e, this._lineNumbers), this._charCodes[e] === 10 ? this._lineNumbers[e] + 1 : this._lineNumbers[e]);
  }
  getStartColumn(e) {
    return e > 0 && e === this._columns.length ? this.getEndColumn(e - 1) : (this._assertIndex(e, this._columns), this._columns[e]);
  }
  getEndColumn(e) {
    return e === -1 ? this.getStartColumn(e + 1) : (this._assertIndex(e, this._columns), this._charCodes[e] === 10 ? 1 : this._columns[e] + 1);
  }
}
class nm {
  constructor(e, t, n, s, o, r, a, l) {
    this.originalStartLineNumber = e, this.originalStartColumn = t, this.originalEndLineNumber = n, this.originalEndColumn = s, this.modifiedStartLineNumber = o, this.modifiedStartColumn = r, this.modifiedEndLineNumber = a, this.modifiedEndColumn = l;
  }
  static createFromDiffChange(e, t, n) {
    const s = t.getStartLineNumber(e.originalStart), o = t.getStartColumn(e.originalStart), r = t.getEndLineNumber(e.originalStart + e.originalLength - 1), a = t.getEndColumn(e.originalStart + e.originalLength - 1), l = n.getStartLineNumber(e.modifiedStart), d = n.getStartColumn(e.modifiedStart), h = n.getEndLineNumber(e.modifiedStart + e.modifiedLength - 1), c = n.getEndColumn(e.modifiedStart + e.modifiedLength - 1);
    return new nm(s, o, r, a, l, d, h, c);
  }
}
class X_ {
  constructor(e, t, n, s, o) {
    this.originalStartLineNumber = e, this.originalEndLineNumber = t, this.modifiedStartLineNumber = n, this.modifiedEndLineNumber = s, this.charChanges = o;
  }
  static createFromDiffResult(e, t, n, s, o, r, a) {
    let l, d, h, c, u;
    if (t.originalLength === 0 ? (l = n.getStartLineNumber(t.originalStart) - 1, d = 0) : (l = n.getStartLineNumber(t.originalStart), d = n.getEndLineNumber(t.originalStart + t.originalLength - 1)), t.modifiedLength === 0 ? (h = s.getStartLineNumber(t.modifiedStart) - 1, c = 0) : (h = s.getStartLineNumber(t.modifiedStart), c = s.getEndLineNumber(t.modifiedStart + t.modifiedLength - 1)), r && t.originalLength > 0 && t.originalLength < 20 && t.modifiedLength > 0 && t.modifiedLength < 20 && o()) {
      const g = n.createCharSequence(e, t.originalStart, t.originalStart + t.originalLength - 1), p = s.createCharSequence(e, t.modifiedStart, t.modifiedStart + t.modifiedLength - 1);
      if (g.getElements().length > 0 && p.getElements().length > 0) {
        let f = Y8(g, p, o, !0).changes;
        a && (f = function(_) {
          if (_.length <= 1) return _;
          const v = [_[0]];
          let b = v[0];
          for (let C = 1, w = _.length; C < w; C++) {
            const y = _[C], L = y.originalStart - (b.originalStart + b.originalLength), k = y.modifiedStart - (b.modifiedStart + b.modifiedLength);
            Math.min(L, k) < 3 ? (b.originalLength = y.originalStart + y.originalLength - b.originalStart, b.modifiedLength = y.modifiedStart + y.modifiedLength - b.modifiedStart) : (v.push(y), b = y);
          }
          return v;
        }(f)), u = [];
        for (let _ = 0, v = f.length; _ < v; _++) u.push(nm.createFromDiffChange(f[_], g, p));
      }
    }
    return new X_(l, d, h, c, u);
  }
}
class xq {
  constructor(e, t, n) {
    this.shouldComputeCharChanges = n.shouldComputeCharChanges, this.shouldPostProcessCharChanges = n.shouldPostProcessCharChanges, this.shouldIgnoreTrimWhitespace = n.shouldIgnoreTrimWhitespace, this.shouldMakePrettyDiff = n.shouldMakePrettyDiff, this.originalLines = e, this.modifiedLines = t, this.original = new r4(e), this.modified = new r4(t), this.continueLineDiff = a4(n.maxComputationTime), this.continueCharDiff = a4(n.maxComputationTime === 0 ? 0 : Math.min(n.maxComputationTime, 5e3));
  }
  computeDiff() {
    if (this.original.lines.length === 1 && this.original.lines[0].length === 0) return this.modified.lines.length === 1 && this.modified.lines[0].length === 0 ? { quitEarly: !1, changes: [] } : { quitEarly: !1, changes: [{ originalStartLineNumber: 1, originalEndLineNumber: 1, modifiedStartLineNumber: 1, modifiedEndLineNumber: this.modified.lines.length, charChanges: void 0 }] };
    if (this.modified.lines.length === 1 && this.modified.lines[0].length === 0) return { quitEarly: !1, changes: [{ originalStartLineNumber: 1, originalEndLineNumber: this.original.lines.length, modifiedStartLineNumber: 1, modifiedEndLineNumber: 1, charChanges: void 0 }] };
    const e = Y8(this.original, this.modified, this.continueLineDiff, this.shouldMakePrettyDiff), t = e.changes, n = e.quitEarly;
    if (this.shouldIgnoreTrimWhitespace) {
      const a = [];
      for (let l = 0, d = t.length; l < d; l++) a.push(X_.createFromDiffResult(this.shouldIgnoreTrimWhitespace, t[l], this.original, this.modified, this.continueCharDiff, this.shouldComputeCharChanges, this.shouldPostProcessCharChanges));
      return { quitEarly: n, changes: a };
    }
    const s = [];
    let o = 0, r = 0;
    for (let a = -1, l = t.length; a < l; a++) {
      const d = a + 1 < l ? t[a + 1] : null, h = d ? d.originalStart : this.originalLines.length, c = d ? d.modifiedStart : this.modifiedLines.length;
      for (; o < h && r < c; ) {
        const u = this.originalLines[o], g = this.modifiedLines[r];
        if (u !== g) {
          {
            let p = HE(u, 1), f = HE(g, 1);
            for (; p > 1 && f > 1 && u.charCodeAt(p - 2) === g.charCodeAt(f - 2); )
              p--, f--;
            (p > 1 || f > 1) && this._pushTrimWhitespaceCharChange(s, o + 1, 1, p, r + 1, 1, f);
          }
          {
            let p = zE(u, 1), f = zE(g, 1);
            const _ = u.length + 1, v = g.length + 1;
            for (; p < _ && f < v && u.charCodeAt(p - 1) === u.charCodeAt(f - 1); )
              p++, f++;
            (p < _ || f < v) && this._pushTrimWhitespaceCharChange(s, o + 1, p, _, r + 1, f, v);
          }
        }
        o++, r++;
      }
      d && (s.push(X_.createFromDiffResult(this.shouldIgnoreTrimWhitespace, d, this.original, this.modified, this.continueCharDiff, this.shouldComputeCharChanges, this.shouldPostProcessCharChanges)), o += d.originalLength, r += d.modifiedLength);
    }
    return { quitEarly: n, changes: s };
  }
  _pushTrimWhitespaceCharChange(e, t, n, s, o, r, a) {
    if (this._mergeTrimWhitespaceCharChange(e, t, n, s, o, r, a)) return;
    let l;
    this.shouldComputeCharChanges && (l = [new nm(t, n, t, s, o, r, o, a)]), e.push(new X_(t, t, o, o, l));
  }
  _mergeTrimWhitespaceCharChange(e, t, n, s, o, r, a) {
    const l = e.length;
    if (l === 0) return !1;
    const d = e[l - 1];
    return d.originalEndLineNumber !== 0 && d.modifiedEndLineNumber !== 0 && (d.originalEndLineNumber === t && d.modifiedEndLineNumber === o ? (this.shouldComputeCharChanges && d.charChanges && d.charChanges.push(new nm(t, n, t, s, o, r, o, a)), !0) : d.originalEndLineNumber + 1 === t && d.modifiedEndLineNumber + 1 === o && (d.originalEndLineNumber = t, d.modifiedEndLineNumber = o, this.shouldComputeCharChanges && d.charChanges && d.charChanges.push(new nm(t, n, t, s, o, r, o, a)), !0));
  }
}
function HE(i, e) {
  const t = Jn(i);
  return t === -1 ? e : t + 1;
}
function zE(i, e) {
  const t = ra(i);
  return t === -1 ? e : t + 2;
}
function a4(i) {
  if (i === 0) return () => !0;
  const e = Date.now();
  return () => Date.now() - e < i;
}
class Dd {
  static trivial(e, t) {
    return new Dd([new Ji(qe.ofLength(e.length), qe.ofLength(t.length))], !1);
  }
  static trivialTimedOut(e, t) {
    return new Dd([new Ji(qe.ofLength(e.length), qe.ofLength(t.length))], !0);
  }
  constructor(e, t) {
    this.diffs = e, this.hitTimeout = t;
  }
}
class Ji {
  static invert(e, t) {
    const n = [];
    return p7(e, (s, o) => {
      n.push(Ji.fromOffsetPairs(s ? s.getEndExclusives() : qo.zero, o ? o.getStarts() : new qo(t, (s ? s.seq2Range.endExclusive - s.seq1Range.endExclusive : 0) + t)));
    }), n;
  }
  static fromOffsetPairs(e, t) {
    return new Ji(new qe(e.offset1, t.offset1), new qe(e.offset2, t.offset2));
  }
  constructor(e, t) {
    this.seq1Range = e, this.seq2Range = t;
  }
  swap() {
    return new Ji(this.seq2Range, this.seq1Range);
  }
  toString() {
    return `${this.seq1Range} <-> ${this.seq2Range}`;
  }
  join(e) {
    return new Ji(this.seq1Range.join(e.seq1Range), this.seq2Range.join(e.seq2Range));
  }
  delta(e) {
    return e === 0 ? this : new Ji(this.seq1Range.delta(e), this.seq2Range.delta(e));
  }
  deltaStart(e) {
    return e === 0 ? this : new Ji(this.seq1Range.deltaStart(e), this.seq2Range.deltaStart(e));
  }
  deltaEnd(e) {
    return e === 0 ? this : new Ji(this.seq1Range.deltaEnd(e), this.seq2Range.deltaEnd(e));
  }
  intersect(e) {
    const t = this.seq1Range.intersect(e.seq1Range), n = this.seq2Range.intersect(e.seq2Range);
    if (t && n) return new Ji(t, n);
  }
  getStarts() {
    return new qo(this.seq1Range.start, this.seq2Range.start);
  }
  getEndExclusives() {
    return new qo(this.seq1Range.endExclusive, this.seq2Range.endExclusive);
  }
}
class qo {
  constructor(e, t) {
    this.offset1 = e, this.offset2 = t;
  }
  toString() {
    return `${this.offset1} <-> ${this.offset2}`;
  }
  delta(e) {
    return e === 0 ? this : new qo(this.offset1 + e, this.offset2 + e);
  }
  equals(e) {
    return this.offset1 === e.offset1 && this.offset2 === e.offset2;
  }
}
qo.zero = new qo(0, 0), qo.max = new qo(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER);
class lv {
  isValid() {
    return !0;
  }
}
lv.instance = new lv();
class Nq {
  constructor(e) {
    if (this.timeout = e, this.startTime = Date.now(), this.valid = !0, e <= 0) throw new Kt("timeout must be positive");
  }
  isValid() {
    return !(Date.now() - this.startTime < this.timeout) && this.valid && (this.valid = !1), this.valid;
  }
}
class lD {
  constructor(e, t) {
    this.width = e, this.height = t, this.array = [], this.array = new Array(e * t);
  }
  get(e, t) {
    return this.array[e + t * this.width];
  }
  set(e, t, n) {
    this.array[e + t * this.width] = n;
  }
}
function UE(i) {
  return i === 32 || i === 9;
}
class Hm {
  static getKey(e) {
    let t = this.chrKeys.get(e);
    return t === void 0 && (t = this.chrKeys.size, this.chrKeys.set(e, t)), t;
  }
  constructor(e, t, n) {
    this.range = e, this.lines = t, this.source = n, this.histogram = [];
    let s = 0;
    for (let o = e.startLineNumber - 1; o < e.endLineNumberExclusive - 1; o++) {
      const r = t[o];
      for (let l = 0; l < r.length; l++) {
        s++;
        const d = r[l], h = Hm.getKey(d);
        this.histogram[h] = (this.histogram[h] || 0) + 1;
      }
      s++;
      const a = Hm.getKey(`
`);
      this.histogram[a] = (this.histogram[a] || 0) + 1;
    }
    this.totalCount = s;
  }
  computeSimilarity(e) {
    var t, n;
    let s = 0;
    const o = Math.max(this.histogram.length, e.histogram.length);
    for (let r = 0; r < o; r++) s += Math.abs(((t = this.histogram[r]) !== null && t !== void 0 ? t : 0) - ((n = e.histogram[r]) !== null && n !== void 0 ? n : 0));
    return 1 - s / (this.totalCount + e.totalCount);
  }
}
Hm.chrKeys = /* @__PURE__ */ new Map();
class Eq {
  compute(e, t, n = lv.instance, s) {
    if (e.length === 0 || t.length === 0) return Dd.trivial(e, t);
    const o = new lD(e.length, t.length), r = new lD(e.length, t.length), a = new lD(e.length, t.length);
    for (let p = 0; p < e.length; p++) for (let f = 0; f < t.length; f++) {
      if (!n.isValid()) return Dd.trivialTimedOut(e, t);
      const _ = p === 0 ? 0 : o.get(p - 1, f), v = f === 0 ? 0 : o.get(p, f - 1);
      let b;
      e.getElement(p) === t.getElement(f) ? (b = p === 0 || f === 0 ? 0 : o.get(p - 1, f - 1), p > 0 && f > 0 && r.get(p - 1, f - 1) === 3 && (b += a.get(p - 1, f - 1)), b += s ? s(p, f) : 1) : b = -1;
      const C = Math.max(_, v, b);
      if (C === b) {
        const w = p > 0 && f > 0 ? a.get(p - 1, f - 1) : 0;
        a.set(p, f, w + 1), r.set(p, f, 3);
      } else C === _ ? (a.set(p, f, 0), r.set(p, f, 1)) : C === v && (a.set(p, f, 0), r.set(p, f, 2));
      o.set(p, f, C);
    }
    const l = [];
    let d = e.length, h = t.length;
    function c(p, f) {
      p + 1 === d && f + 1 === h || l.push(new Ji(new qe(p + 1, d), new qe(f + 1, h))), d = p, h = f;
    }
    let u = e.length - 1, g = t.length - 1;
    for (; u >= 0 && g >= 0; ) r.get(u, g) === 3 ? (c(u, g), u--, g--) : r.get(u, g) === 1 ? u-- : g--;
    return c(-1, -1), l.reverse(), new Dd(l, !1);
  }
}
class X8 {
  compute(e, t, n = lv.instance) {
    if (e.length === 0 || t.length === 0) return Dd.trivial(e, t);
    const s = e, o = t;
    function r(f, _) {
      for (; f < s.length && _ < o.length && s.getElement(f) === o.getElement(_); ) f++, _++;
      return f;
    }
    let a = 0;
    const l = new Iq();
    l.set(0, r(0, 0));
    const d = new Mq();
    d.set(0, l.get(0) === 0 ? null : new l4(null, 0, 0, l.get(0)));
    let h = 0;
    e: for (; ; ) {
      if (a++, !n.isValid()) return Dd.trivialTimedOut(s, o);
      const f = -Math.min(a, o.length + a % 2), _ = Math.min(a, s.length + a % 2);
      for (h = f; h <= _; h += 2) {
        const v = h === _ ? -1 : l.get(h + 1), b = h === f ? -1 : l.get(h - 1) + 1, C = Math.min(Math.max(v, b), s.length), w = C - h;
        if (C > s.length || w > o.length) continue;
        const y = r(C, w);
        l.set(h, y);
        const L = C === v ? d.get(h + 1) : d.get(h - 1);
        if (d.set(h, y !== C ? new l4(L, C, w, y - C) : L), l.get(h) === s.length && l.get(h) - h === o.length) break e;
      }
    }
    let c = d.get(h);
    const u = [];
    let g = s.length, p = o.length;
    for (; ; ) {
      const f = c ? c.x + c.length : 0, _ = c ? c.y + c.length : 0;
      if (f === g && _ === p || u.push(new Ji(new qe(f, g), new qe(_, p))), !c) break;
      g = c.x, p = c.y, c = c.prev;
    }
    return u.reverse(), new Dd(u, !1);
  }
}
class l4 {
  constructor(e, t, n, s) {
    this.prev = e, this.x = t, this.y = n, this.length = s;
  }
}
class Iq {
  constructor() {
    this.positiveArr = new Int32Array(10), this.negativeArr = new Int32Array(10);
  }
  get(e) {
    return e < 0 ? (e = -e - 1, this.negativeArr[e]) : this.positiveArr[e];
  }
  set(e, t) {
    if (e < 0) {
      if ((e = -e - 1) >= this.negativeArr.length) {
        const n = this.negativeArr;
        this.negativeArr = new Int32Array(2 * n.length), this.negativeArr.set(n);
      }
      this.negativeArr[e] = t;
    } else {
      if (e >= this.positiveArr.length) {
        const n = this.positiveArr;
        this.positiveArr = new Int32Array(2 * n.length), this.positiveArr.set(n);
      }
      this.positiveArr[e] = t;
    }
  }
}
class Mq {
  constructor() {
    this.positiveArr = [], this.negativeArr = [];
  }
  get(e) {
    return e < 0 ? (e = -e - 1, this.negativeArr[e]) : this.positiveArr[e];
  }
  set(e, t) {
    e < 0 ? (e = -e - 1, this.negativeArr[e] = t) : this.positiveArr[e] = t;
  }
}
class iy {
  constructor(e, t, n) {
    this.lines = e, this.considerWhitespaceChanges = n, this.elements = [], this.firstCharOffsetByLine = [], this.additionalOffsetByLine = [];
    let s = !1;
    t.start > 0 && t.endExclusive >= e.length && (t = new qe(t.start - 1, t.endExclusive), s = !0), this.lineRange = t, this.firstCharOffsetByLine[0] = 0;
    for (let o = this.lineRange.start; o < this.lineRange.endExclusive; o++) {
      let r = e[o], a = 0;
      if (s) a = r.length, r = "", s = !1;
      else if (!n) {
        const l = r.trimStart();
        a = r.length - l.length, r = l.trimEnd();
      }
      this.additionalOffsetByLine.push(a);
      for (let l = 0; l < r.length; l++) this.elements.push(r.charCodeAt(l));
      o < e.length - 1 && (this.elements.push(10), this.firstCharOffsetByLine[o - this.lineRange.start + 1] = this.elements.length);
    }
    this.additionalOffsetByLine.push(0);
  }
  toString() {
    return `Slice: "${this.text}"`;
  }
  get text() {
    return this.getText(new qe(0, this.length));
  }
  getText(e) {
    return this.elements.slice(e.start, e.endExclusive).map((t) => String.fromCharCode(t)).join("");
  }
  getElement(e) {
    return this.elements[e];
  }
  get length() {
    return this.elements.length;
  }
  getBoundaryScore(e) {
    const t = h4(e > 0 ? this.elements[e - 1] : -1), n = h4(e < this.elements.length ? this.elements[e] : -1);
    if (t === 7 && n === 8) return 0;
    if (t === 8) return 150;
    let s = 0;
    return t !== n && (s += 10, t === 0 && n === 1 && (s += 1)), s += d4(t), s += d4(n), s;
  }
  translateOffset(e) {
    if (this.lineRange.isEmpty) return new W(this.lineRange.start + 1, 1);
    const t = ov(this.firstCharOffsetByLine, (n) => n <= e);
    return new W(this.lineRange.start + t + 1, e - this.firstCharOffsetByLine[t] + this.additionalOffsetByLine[t] + 1);
  }
  translateRange(e) {
    return D.fromPositions(this.translateOffset(e.start), this.translateOffset(e.endExclusive));
  }
  findWordContaining(e) {
    if (e < 0 || e >= this.elements.length || !dD(this.elements[e])) return;
    let t = e;
    for (; t > 0 && dD(this.elements[t - 1]); ) t--;
    let n = e;
    for (; n < this.elements.length && dD(this.elements[n]); ) n++;
    return new qe(t, n);
  }
  countLinesIn(e) {
    return this.translateOffset(e.endExclusive).lineNumber - this.translateOffset(e.start).lineNumber;
  }
  isStronglyEqual(e, t) {
    return this.elements[e] === this.elements[t];
  }
  extendToFullLines(e) {
    var t, n;
    const s = (t = im(this.firstCharOffsetByLine, (r) => r <= e.start)) !== null && t !== void 0 ? t : 0, o = (n = function(r, a) {
      const l = rv(r, a);
      return l === r.length ? void 0 : r[l];
    }(this.firstCharOffsetByLine, (r) => e.endExclusive <= r)) !== null && n !== void 0 ? n : this.elements.length;
    return new qe(s, o);
  }
}
function dD(i) {
  return i >= 97 && i <= 122 || i >= 65 && i <= 90 || i >= 48 && i <= 57;
}
const Tq = { 0: 0, 1: 0, 2: 0, 3: 10, 4: 2, 5: 30, 6: 3, 7: 10, 8: 10 };
function d4(i) {
  return Tq[i];
}
function h4(i) {
  return i === 10 ? 8 : i === 13 ? 7 : UE(i) ? 6 : i >= 97 && i <= 122 ? 0 : i >= 65 && i <= 90 ? 1 : i >= 48 && i <= 57 ? 2 : i === -1 ? 3 : i === 44 || i === 59 ? 5 : 4;
}
function Rq(i, e, t, n, s, o) {
  let { moves: r, excludedChanges: a } = function(d, h, c, u) {
    const g = [], p = d.filter((v) => v.modified.isEmpty && v.original.length >= 3).map((v) => new Hm(v.original, h, v)), f = new Set(d.filter((v) => v.original.isEmpty && v.modified.length >= 3).map((v) => new Hm(v.modified, c, v))), _ = /* @__PURE__ */ new Set();
    for (const v of p) {
      let b, C = -1;
      for (const w of f) {
        const y = v.computeSimilarity(w);
        y > C && (C = y, b = w);
      }
      if (C > 0.9 && b && (f.delete(b), g.push(new us(v.range, b.range)), _.add(v.source), _.add(b.source)), !u.isValid()) return { moves: g, excludedChanges: _ };
    }
    return { moves: g, excludedChanges: _ };
  }(i, e, t, o);
  if (!o.isValid()) return [];
  const l = function(d, h, c, u, g, p) {
    const f = [], _ = new yR();
    for (const y of d) for (let L = y.original.startLineNumber; L < y.original.endLineNumberExclusive - 2; L++) {
      const k = `${h[L - 1]}:${h[L + 1 - 1]}:${h[L + 2 - 1]}`;
      _.add(k, { range: new je(L, L + 3) });
    }
    const v = [];
    d.sort(jo((y) => y.modified.startLineNumber, od));
    for (const y of d) {
      let L = [];
      for (let k = y.modified.startLineNumber; k < y.modified.endLineNumberExclusive - 2; k++) {
        const N = `${c[k - 1]}:${c[k + 1 - 1]}:${c[k + 2 - 1]}`, A = new je(k, k + 3), B = [];
        _.forEach(N, ({ range: T }) => {
          for (const H of L) if (H.originalLineRange.endLineNumberExclusive + 1 === T.endLineNumberExclusive && H.modifiedLineRange.endLineNumberExclusive + 1 === A.endLineNumberExclusive) return H.originalLineRange = new je(H.originalLineRange.startLineNumber, T.endLineNumberExclusive), H.modifiedLineRange = new je(H.modifiedLineRange.startLineNumber, A.endLineNumberExclusive), void B.push(H);
          const O = { modifiedLineRange: A, originalLineRange: T };
          v.push(O), B.push(O);
        }), L = B;
      }
      if (!p.isValid()) return [];
    }
    v.sort(f7(jo((y) => y.modifiedLineRange.length, od)));
    const b = new Uo(), C = new Uo();
    for (const y of v) {
      const L = y.modifiedLineRange.startLineNumber - y.originalLineRange.startLineNumber, k = b.subtractFrom(y.modifiedLineRange), N = C.subtractFrom(y.originalLineRange).getWithDelta(L), A = k.getIntersection(N);
      for (const B of A.ranges) {
        if (B.length < 3) continue;
        const T = B, O = B.delta(-L);
        f.push(new us(O, T)), b.addRange(T), C.addRange(O);
      }
    }
    f.sort(jo((y) => y.original.startLineNumber, od));
    const w = new av(d);
    for (let y = 0; y < f.length; y++) {
      const L = f[y], k = w.findLastMonotonous((pe) => pe.original.startLineNumber <= L.original.startLineNumber), N = im(d, (pe) => pe.modified.startLineNumber <= L.modified.startLineNumber), A = Math.max(L.original.startLineNumber - k.original.startLineNumber, L.modified.startLineNumber - N.modified.startLineNumber), B = w.findLastMonotonous((pe) => pe.original.startLineNumber < L.original.endLineNumberExclusive), T = im(d, (pe) => pe.modified.startLineNumber < L.modified.endLineNumberExclusive), O = Math.max(B.original.endLineNumberExclusive - L.original.endLineNumberExclusive, T.modified.endLineNumberExclusive - L.modified.endLineNumberExclusive);
      let H, $;
      for (H = 0; H < A; H++) {
        const pe = L.original.startLineNumber - H - 1, me = L.modified.startLineNumber - H - 1;
        if (pe > u.length || me > g.length || b.contains(me) || C.contains(pe) || !c4(u[pe - 1], g[me - 1], p)) break;
      }
      for (H > 0 && (C.addRange(new je(L.original.startLineNumber - H, L.original.startLineNumber)), b.addRange(new je(L.modified.startLineNumber - H, L.modified.startLineNumber))), $ = 0; $ < O; $++) {
        const pe = L.original.endLineNumberExclusive + $, me = L.modified.endLineNumberExclusive + $;
        if (pe > u.length || me > g.length || b.contains(me) || C.contains(pe) || !c4(u[pe - 1], g[me - 1], p)) break;
      }
      $ > 0 && (C.addRange(new je(L.original.endLineNumberExclusive, L.original.endLineNumberExclusive + $)), b.addRange(new je(L.modified.endLineNumberExclusive, L.modified.endLineNumberExclusive + $))), (H > 0 || $ > 0) && (f[y] = new us(new je(L.original.startLineNumber - H, L.original.endLineNumberExclusive + $), new je(L.modified.startLineNumber - H, L.modified.endLineNumberExclusive + $)));
    }
    return f;
  }(i.filter((d) => !a.has(d)), n, s, e, t, o);
  return yN(r, l), r = function(d) {
    if (d.length === 0) return d;
    d.sort(jo((c) => c.original.startLineNumber, od));
    const h = [d[0]];
    for (let c = 1; c < d.length; c++) {
      const u = h[h.length - 1], g = d[c], p = g.original.startLineNumber - u.original.endLineNumberExclusive, f = g.modified.startLineNumber - u.modified.endLineNumberExclusive;
      p >= 0 && f >= 0 && p + f <= 2 ? h[h.length - 1] = u.join(g) : h.push(g);
    }
    return h;
  }(r), r = r.filter((d) => {
    const h = d.original.toOffsetRange().slice(e).map((c) => c.trim());
    return h.join(`
`).length >= 15 && function(c, u) {
      let g = 0;
      for (const p of c) u(p) && g++;
      return g;
    }(h, (c) => c.length >= 2) >= 2;
  }), r = function(d, h) {
    const c = new av(d);
    return h = h.filter((u) => (c.findLastMonotonous((g) => g.original.startLineNumber < u.original.endLineNumberExclusive) || new us(new je(1, 1), new je(1, 1))) !== im(d, (g) => g.modified.startLineNumber < u.modified.endLineNumberExclusive)), h;
  }(i, r), r;
}
function c4(i, e, t) {
  if (i.trim() === e.trim()) return !0;
  if (i.length > 300 && e.length > 300) return !1;
  const n = new X8().compute(new iy([i], new qe(0, 1), !1), new iy([e], new qe(0, 1), !1), t);
  let s = 0;
  const o = Ji.invert(n.diffs, i.length);
  for (const a of o) a.seq1Range.forEach((l) => {
    UE(i.charCodeAt(l)) || s++;
  });
  const r = function(a) {
    let l = 0;
    for (let d = 0; d < i.length; d++) UE(a.charCodeAt(d)) || l++;
    return l;
  }(i.length > e.length ? i : e);
  return s / r > 0.6 && r > 10;
}
function KE(i, e, t) {
  let n = t;
  return n = u4(i, e, n), n = u4(i, e, n), n = function(s, o, r) {
    if (!s.getBoundaryScore || !o.getBoundaryScore) return r;
    for (let a = 0; a < r.length; a++) {
      const l = a > 0 ? r[a - 1] : void 0, d = r[a], h = a + 1 < r.length ? r[a + 1] : void 0, c = new qe(l ? l.seq1Range.endExclusive + 1 : 0, h ? h.seq1Range.start - 1 : s.length), u = new qe(l ? l.seq2Range.endExclusive + 1 : 0, h ? h.seq2Range.start - 1 : o.length);
      d.seq1Range.isEmpty ? r[a] = g4(d, s, o, c, u) : d.seq2Range.isEmpty && (r[a] = g4(d.swap(), o, s, u, c).swap());
    }
    return r;
  }(i, e, n), n;
}
function u4(i, e, t) {
  if (t.length === 0) return t;
  const n = [];
  n.push(t[0]);
  for (let o = 1; o < t.length; o++) {
    const r = n[n.length - 1];
    let a = t[o];
    if (a.seq1Range.isEmpty || a.seq2Range.isEmpty) {
      const l = a.seq1Range.start - r.seq1Range.endExclusive;
      let d;
      for (d = 1; d <= l && i.getElement(a.seq1Range.start - d) === i.getElement(a.seq1Range.endExclusive - d) && e.getElement(a.seq2Range.start - d) === e.getElement(a.seq2Range.endExclusive - d); d++) ;
      if (d--, d === l) {
        n[n.length - 1] = new Ji(new qe(r.seq1Range.start, a.seq1Range.endExclusive - l), new qe(r.seq2Range.start, a.seq2Range.endExclusive - l));
        continue;
      }
      a = a.delta(-d);
    }
    n.push(a);
  }
  const s = [];
  for (let o = 0; o < n.length - 1; o++) {
    const r = n[o + 1];
    let a = n[o];
    if (a.seq1Range.isEmpty || a.seq2Range.isEmpty) {
      const l = r.seq1Range.start - a.seq1Range.endExclusive;
      let d;
      for (d = 0; d < l && i.isStronglyEqual(a.seq1Range.start + d, a.seq1Range.endExclusive + d) && e.isStronglyEqual(a.seq2Range.start + d, a.seq2Range.endExclusive + d); d++) ;
      if (d === l) {
        n[o + 1] = new Ji(new qe(a.seq1Range.start + l, r.seq1Range.endExclusive), new qe(a.seq2Range.start + l, r.seq2Range.endExclusive));
        continue;
      }
      d > 0 && (a = a.delta(d));
    }
    s.push(a);
  }
  return n.length > 0 && s.push(n[n.length - 1]), s;
}
function g4(i, e, t, n, s) {
  let o = 1;
  for (; i.seq1Range.start - o >= n.start && i.seq2Range.start - o >= s.start && t.isStronglyEqual(i.seq2Range.start - o, i.seq2Range.endExclusive - o) && o < 100; ) o++;
  o--;
  let r = 0;
  for (; i.seq1Range.start + r < n.endExclusive && i.seq2Range.endExclusive + r < s.endExclusive && t.isStronglyEqual(i.seq2Range.start + r, i.seq2Range.endExclusive + r) && r < 100; ) r++;
  if (o === 0 && r === 0) return i;
  let a = 0, l = -1;
  for (let d = -o; d <= r; d++) {
    const h = i.seq2Range.start + d, c = i.seq2Range.endExclusive + d, u = i.seq1Range.start + d, g = e.getBoundaryScore(u) + t.getBoundaryScore(h) + t.getBoundaryScore(c);
    g > l && (l = g, a = d);
  }
  return i.delta(a);
}
class p4 {
  constructor(e, t) {
    this.trimmedHash = e, this.lines = t;
  }
  getElement(e) {
    return this.trimmedHash[e];
  }
  get length() {
    return this.trimmedHash.length;
  }
  getBoundaryScore(e) {
    return 1e3 - ((e === 0 ? 0 : m4(this.lines[e - 1])) + (e === this.lines.length ? 0 : m4(this.lines[e])));
  }
  getText(e) {
    return this.lines.slice(e.start, e.endExclusive).join(`
`);
  }
  isStronglyEqual(e, t) {
    return this.lines[e] === this.lines[t];
  }
}
function m4(i) {
  let e = 0;
  for (; e < i.length && (i.charCodeAt(e) === 32 || i.charCodeAt(e) === 9); ) e++;
  return e;
}
class Q8 {
  constructor() {
    this.dynamicProgrammingDiffing = new Eq(), this.myersDiffingAlgorithm = new X8();
  }
  computeDiff(e, t, n) {
    if (e.length <= 1 && ri(e, t, (y, L) => y === L)) return new PC([], [], !1);
    if (e.length === 1 && e[0].length === 0 || t.length === 1 && t[0].length === 0) return new PC([new xo(new je(1, e.length + 1), new je(1, t.length + 1), [new Fd(new D(1, 1, e.length, e[0].length + 1), new D(1, 1, t.length, t[0].length + 1))])], [], !1);
    const s = n.maxComputationTimeMs === 0 ? lv.instance : new Nq(n.maxComputationTimeMs), o = !n.ignoreTrimWhitespace, r = /* @__PURE__ */ new Map();
    function a(y) {
      let L = r.get(y);
      return L === void 0 && (L = r.size, r.set(y, L)), L;
    }
    const l = e.map((y) => a(y.trim())), d = t.map((y) => a(y.trim())), h = new p4(l, e), c = new p4(d, t), u = h.length + c.length < 1700 ? this.dynamicProgrammingDiffing.compute(h, c, s, (y, L) => e[y] === t[L] ? t[L].length === 0 ? 0.1 : 1 + Math.log(1 + t[L].length) : 0.99) : this.myersDiffingAlgorithm.compute(h, c);
    let g = u.diffs, p = u.hitTimeout;
    g = KE(h, c, g), g = function(y, L, k) {
      let N = k;
      if (N.length === 0) return N;
      let A, B = 0;
      do {
        A = !1;
        const T = [N[0]];
        for (let O = 1; O < N.length; O++) {
          let pe = function(me, ue) {
            const ee = new qe($.seq1Range.endExclusive, H.seq1Range.start);
            return y.getText(ee).replace(/\s/g, "").length <= 4 && (me.seq1Range.length + me.seq2Range.length > 5 || ue.seq1Range.length + ue.seq2Range.length > 5);
          };
          const H = N[O], $ = T[T.length - 1];
          pe($, H) ? (A = !0, T[T.length - 1] = T[T.length - 1].join(H)) : T.push(H);
        }
        N = T;
      } while (B++ < 10 && A);
      return N;
    }(h, 0, g);
    const f = [], _ = (y) => {
      if (o) for (let L = 0; L < y; L++) {
        const k = v + L, N = b + L;
        if (e[k] !== t[N]) {
          const A = this.refineDiff(e, t, new Ji(new qe(k, k + 1), new qe(N, N + 1)), s, o);
          for (const B of A.mappings) f.push(B);
          A.hitTimeout && (p = !0);
        }
      }
    };
    let v = 0, b = 0;
    for (const y of g) {
      cg(() => y.seq1Range.start - v == y.seq2Range.start - b), _(y.seq1Range.start - v), v = y.seq1Range.endExclusive, b = y.seq2Range.endExclusive;
      const L = this.refineDiff(e, t, y, s, o);
      L.hitTimeout && (p = !0);
      for (const k of L.mappings) f.push(k);
    }
    _(e.length - v);
    const C = f4(f, e, t);
    let w = [];
    return n.computeMoves && (w = this.computeMoves(C, e, t, l, d, s, o)), cg(() => {
      function y(k, N) {
        if (k.lineNumber < 1 || k.lineNumber > N.length) return !1;
        const A = N[k.lineNumber - 1];
        return !(k.column < 1 || k.column > A.length + 1);
      }
      function L(k, N) {
        return !(k.startLineNumber < 1 || k.startLineNumber > N.length + 1) && !(k.endLineNumberExclusive < 1 || k.endLineNumberExclusive > N.length + 1);
      }
      for (const k of C) {
        if (!k.innerChanges) return !1;
        for (const N of k.innerChanges)
          if (!(y(N.modifiedRange.getStartPosition(), t) && y(N.modifiedRange.getEndPosition(), t) && y(N.originalRange.getStartPosition(), e) && y(N.originalRange.getEndPosition(), e))) return !1;
        if (!L(k.modified, t) || !L(k.original, e)) return !1;
      }
      return !0;
    }), new PC(C, w, p);
  }
  computeMoves(e, t, n, s, o, r, a) {
    return Rq(e, t, n, s, o, r).map((l) => {
      const d = f4(this.refineDiff(t, n, new Ji(l.original.toOffsetRange(), l.modified.toOffsetRange()), r, a).mappings, t, n, !0);
      return new Z8(l, d);
    });
  }
  refineDiff(e, t, n, s, o) {
    const r = new iy(e, n.seq1Range, o), a = new iy(t, n.seq2Range, o), l = r.length + a.length < 500 ? this.dynamicProgrammingDiffing.compute(r, a, s) : this.myersDiffingAlgorithm.compute(r, a, s);
    let d = l.diffs;
    return d = KE(r, a, d), d = function(h, c, u) {
      const g = Ji.invert(u, h.length), p = [];
      let f = new qo(0, 0);
      function _(v, b) {
        if (v.offset1 < f.offset1 || v.offset2 < f.offset2) return;
        const C = h.findWordContaining(v.offset1), w = c.findWordContaining(v.offset2);
        if (!C || !w) return;
        let y = new Ji(C, w);
        const L = y.intersect(b);
        let k = L.seq1Range.length, N = L.seq2Range.length;
        for (; g.length > 0; ) {
          const A = g[0];
          if (!A.seq1Range.intersects(y.seq1Range) && !A.seq2Range.intersects(y.seq2Range)) break;
          const B = h.findWordContaining(A.seq1Range.start), T = c.findWordContaining(A.seq2Range.start), O = new Ji(B, T), H = O.intersect(A);
          if (k += H.seq1Range.length, N += H.seq2Range.length, y = y.join(O), !(y.seq1Range.endExclusive >= A.seq1Range.endExclusive)) break;
          g.shift();
        }
        k + N < 2 * (y.seq1Range.length + y.seq2Range.length) / 3 && p.push(y), f = y.getEndExclusives();
      }
      for (; g.length > 0; ) {
        const v = g.shift();
        v.seq1Range.isEmpty || (_(v.getStarts(), v), _(v.getEndExclusives().delta(-1), v));
      }
      return function(v, b) {
        const C = [];
        for (; v.length > 0 || b.length > 0; ) {
          const w = v[0], y = b[0];
          let L;
          L = w && (!y || w.seq1Range.start < y.seq1Range.start) ? v.shift() : b.shift(), C.length > 0 && C[C.length - 1].seq1Range.endExclusive >= L.seq1Range.start ? C[C.length - 1] = C[C.length - 1].join(L) : C.push(L);
        }
        return C;
      }(u, p);
    }(r, a, d), d = function(h, c, u) {
      const g = [];
      for (const p of u) {
        const f = g[g.length - 1];
        f && (p.seq1Range.start - f.seq1Range.endExclusive <= 2 || p.seq2Range.start - f.seq2Range.endExclusive <= 2) ? g[g.length - 1] = new Ji(f.seq1Range.join(p.seq1Range), f.seq2Range.join(p.seq2Range)) : g.push(p);
      }
      return g;
    }(0, 0, d), d = function(h, c, u) {
      let g = u;
      if (g.length === 0) return g;
      let p, f = 0;
      do {
        p = !1;
        const v = [g[0]];
        for (let b = 1; b < g.length; b++) {
          let y = function(L, k) {
            const N = new qe(w.seq1Range.endExclusive, C.seq1Range.start);
            if (h.countLinesIn(N) > 5 || N.length > 500) return !1;
            const A = h.getText(N).trim();
            if (A.length > 20 || A.split(/\r\n|\r|\n/).length > 1) return !1;
            const B = h.countLinesIn(L.seq1Range), T = L.seq1Range.length, O = c.countLinesIn(L.seq2Range), H = L.seq2Range.length, $ = h.countLinesIn(k.seq1Range), pe = k.seq1Range.length, me = c.countLinesIn(k.seq2Range), ue = k.seq2Range.length;
            function ee(te) {
              return Math.min(te, 130);
            }
            return Math.pow(Math.pow(ee(40 * B + T), 1.5) + Math.pow(ee(40 * O + H), 1.5), 1.5) + Math.pow(Math.pow(ee(40 * $ + pe), 1.5) + Math.pow(ee(40 * me + ue), 1.5), 1.5) > 74184.96480721243;
          };
          const C = g[b], w = v[v.length - 1];
          y(w, C) ? (p = !0, v[v.length - 1] = v[v.length - 1].join(C)) : v.push(C);
        }
        g = v;
      } while (f++ < 10 && p);
      const _ = [];
      return function(v, b) {
        for (let C = 0; C < v.length; C++) b(C === 0 ? void 0 : v[C - 1], v[C], C + 1 === v.length ? void 0 : v[C + 1]);
      }(g, (v, b, C) => {
        let w = b;
        function y(T) {
          return T.length > 0 && T.trim().length <= 3 && b.seq1Range.length + b.seq2Range.length > 100;
        }
        const L = h.extendToFullLines(b.seq1Range), k = h.getText(new qe(L.start, b.seq1Range.start));
        y(k) && (w = w.deltaStart(-k.length));
        const N = h.getText(new qe(b.seq1Range.endExclusive, L.endExclusive));
        y(N) && (w = w.deltaEnd(N.length));
        const A = Ji.fromOffsetPairs(v ? v.getEndExclusives() : qo.zero, C ? C.getStarts() : qo.max), B = w.intersect(A);
        _.length > 0 && B.getStarts().equals(_[_.length - 1].getEndExclusives()) ? _[_.length - 1] = _[_.length - 1].join(B) : _.push(B);
      }), _;
    }(r, a, d), { mappings: d.map((h) => new Fd(r.translateRange(h.seq1Range), a.translateRange(h.seq2Range))), hitTimeout: l.hitTimeout };
  }
}
function f4(i, e, t, n = !1) {
  const s = [];
  for (const o of zT(i.map((r) => function(a, l, d) {
    let h = 0, c = 0;
    a.modifiedRange.endColumn === 1 && a.originalRange.endColumn === 1 && a.originalRange.startLineNumber + h <= a.originalRange.endLineNumber && a.modifiedRange.startLineNumber + h <= a.modifiedRange.endLineNumber && (c = -1), a.modifiedRange.startColumn - 1 >= d[a.modifiedRange.startLineNumber - 1].length && a.originalRange.startColumn - 1 >= l[a.originalRange.startLineNumber - 1].length && a.originalRange.startLineNumber <= a.originalRange.endLineNumber + c && a.modifiedRange.startLineNumber <= a.modifiedRange.endLineNumber + c && (h = 1);
    const u = new je(a.originalRange.startLineNumber + h, a.originalRange.endLineNumber + 1 + c), g = new je(a.modifiedRange.startLineNumber + h, a.modifiedRange.endLineNumber + 1 + c);
    return new xo(u, g, [a]);
  }(r, e, t)), (r, a) => r.original.overlapOrTouch(a.original) || r.modified.overlapOrTouch(a.modified))) {
    const r = o[0], a = o[o.length - 1];
    s.push(new xo(r.original.join(a.original), r.modified.join(a.modified), o.map((l) => l.innerChanges[0])));
  }
  return cg(() => !n && s.length > 0 && (s[0].modified.startLineNumber !== s[0].original.startLineNumber || t.length - s[s.length - 1].modified.endLineNumberExclusive != e.length - s[s.length - 1].original.endLineNumberExclusive) ? !1 : CR(s, (o, r) => r.original.startLineNumber - o.original.endLineNumberExclusive == r.modified.startLineNumber - o.modified.endLineNumberExclusive && o.original.endLineNumberExclusive < r.original.startLineNumber && o.modified.endLineNumberExclusive < r.modified.startLineNumber)), s;
}
const Aq = () => new kq(), Pq = () => new Q8();
function Jh(i, e) {
  const t = Math.pow(10, e);
  return Math.round(i * t) / t;
}
class ht {
  constructor(e, t, n, s = 1) {
    this._rgbaBrand = void 0, this.r = 0 | Math.min(255, Math.max(0, e)), this.g = 0 | Math.min(255, Math.max(0, t)), this.b = 0 | Math.min(255, Math.max(0, n)), this.a = Jh(Math.max(Math.min(1, s), 0), 3);
  }
  static equals(e, t) {
    return e.r === t.r && e.g === t.g && e.b === t.b && e.a === t.a;
  }
}
class fr {
  constructor(e, t, n, s) {
    this._hslaBrand = void 0, this.h = 0 | Math.max(Math.min(360, e), 0), this.s = Jh(Math.max(Math.min(1, t), 0), 3), this.l = Jh(Math.max(Math.min(1, n), 0), 3), this.a = Jh(Math.max(Math.min(1, s), 0), 3);
  }
  static equals(e, t) {
    return e.h === t.h && e.s === t.s && e.l === t.l && e.a === t.a;
  }
  static fromRGBA(e) {
    const t = e.r / 255, n = e.g / 255, s = e.b / 255, o = e.a, r = Math.max(t, n, s), a = Math.min(t, n, s);
    let l = 0, d = 0;
    const h = (a + r) / 2, c = r - a;
    if (c > 0) {
      switch (d = Math.min(h <= 0.5 ? c / (2 * h) : c / (2 - 2 * h), 1), r) {
        case t:
          l = (n - s) / c + (n < s ? 6 : 0);
          break;
        case n:
          l = (s - t) / c + 2;
          break;
        case s:
          l = (t - n) / c + 4;
      }
      l *= 60, l = Math.round(l);
    }
    return new fr(l, d, h, o);
  }
  static _hue2rgb(e, t, n) {
    return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + 6 * (t - e) * n : n < 0.5 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
  }
  static toRGBA(e) {
    const t = e.h / 360, { s: n, l: s, a: o } = e;
    let r, a, l;
    if (n === 0) r = a = l = s;
    else {
      const d = s < 0.5 ? s * (1 + n) : s + n - s * n, h = 2 * s - d;
      r = fr._hue2rgb(h, d, t + 1 / 3), a = fr._hue2rgb(h, d, t), l = fr._hue2rgb(h, d, t - 1 / 3);
    }
    return new ht(Math.round(255 * r), Math.round(255 * a), Math.round(255 * l), o);
  }
}
class nl {
  constructor(e, t, n, s) {
    this._hsvaBrand = void 0, this.h = 0 | Math.max(Math.min(360, e), 0), this.s = Jh(Math.max(Math.min(1, t), 0), 3), this.v = Jh(Math.max(Math.min(1, n), 0), 3), this.a = Jh(Math.max(Math.min(1, s), 0), 3);
  }
  static equals(e, t) {
    return e.h === t.h && e.s === t.s && e.v === t.v && e.a === t.a;
  }
  static fromRGBA(e) {
    const t = e.r / 255, n = e.g / 255, s = e.b / 255, o = Math.max(t, n, s), r = o - Math.min(t, n, s), a = o === 0 ? 0 : r / o;
    let l;
    return l = r === 0 ? 0 : o === t ? ((n - s) / r % 6 + 6) % 6 : o === n ? (s - t) / r + 2 : (t - n) / r + 4, new nl(Math.round(60 * l), a, o, e.a);
  }
  static toRGBA(e) {
    const { h: t, s: n, v: s, a: o } = e, r = s * n, a = r * (1 - Math.abs(t / 60 % 2 - 1)), l = s - r;
    let [d, h, c] = [0, 0, 0];
    return t < 60 ? (d = r, h = a) : t < 120 ? (d = a, h = r) : t < 180 ? (h = r, c = a) : t < 240 ? (h = a, c = r) : t < 300 ? (d = a, c = r) : t <= 360 && (d = r, c = a), d = Math.round(255 * (d + l)), h = Math.round(255 * (h + l)), c = Math.round(255 * (c + l)), new ht(d, h, c, o);
  }
}
class z {
  static fromHex(e) {
    return z.Format.CSS.parseHex(e) || z.red;
  }
  static equals(e, t) {
    return !e && !t || !(!e || !t) && e.equals(t);
  }
  get hsla() {
    return this._hsla ? this._hsla : fr.fromRGBA(this.rgba);
  }
  get hsva() {
    return this._hsva ? this._hsva : nl.fromRGBA(this.rgba);
  }
  constructor(e) {
    if (!e) throw new Error("Color needs a value");
    if (e instanceof ht) this.rgba = e;
    else if (e instanceof fr) this._hsla = e, this.rgba = fr.toRGBA(e);
    else {
      if (!(e instanceof nl)) throw new Error("Invalid color ctor argument");
      this._hsva = e, this.rgba = nl.toRGBA(e);
    }
  }
  equals(e) {
    return !!e && ht.equals(this.rgba, e.rgba) && fr.equals(this.hsla, e.hsla) && nl.equals(this.hsva, e.hsva);
  }
  getRelativeLuminance() {
    return Jh(0.2126 * z._relativeLuminanceForComponent(this.rgba.r) + 0.7152 * z._relativeLuminanceForComponent(this.rgba.g) + 0.0722 * z._relativeLuminanceForComponent(this.rgba.b), 4);
  }
  static _relativeLuminanceForComponent(e) {
    const t = e / 255;
    return t <= 0.03928 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
  }
  isLighter() {
    return (299 * this.rgba.r + 587 * this.rgba.g + 114 * this.rgba.b) / 1e3 >= 128;
  }
  isLighterThan(e) {
    return this.getRelativeLuminance() > e.getRelativeLuminance();
  }
  isDarkerThan(e) {
    return this.getRelativeLuminance() < e.getRelativeLuminance();
  }
  lighten(e) {
    return new z(new fr(this.hsla.h, this.hsla.s, this.hsla.l + this.hsla.l * e, this.hsla.a));
  }
  darken(e) {
    return new z(new fr(this.hsla.h, this.hsla.s, this.hsla.l - this.hsla.l * e, this.hsla.a));
  }
  transparent(e) {
    const { r: t, g: n, b: s, a: o } = this.rgba;
    return new z(new ht(t, n, s, o * e));
  }
  isTransparent() {
    return this.rgba.a === 0;
  }
  isOpaque() {
    return this.rgba.a === 1;
  }
  opposite() {
    return new z(new ht(255 - this.rgba.r, 255 - this.rgba.g, 255 - this.rgba.b, this.rgba.a));
  }
  makeOpaque(e) {
    if (this.isOpaque() || e.rgba.a !== 1) return this;
    const { r: t, g: n, b: s, a: o } = this.rgba;
    return new z(new ht(e.rgba.r - o * (e.rgba.r - t), e.rgba.g - o * (e.rgba.g - n), e.rgba.b - o * (e.rgba.b - s), 1));
  }
  toString() {
    return this._toString || (this._toString = z.Format.CSS.format(this)), this._toString;
  }
  static getLighterColor(e, t, n) {
    if (e.isLighterThan(t)) return e;
    n = n || 0.5;
    const s = e.getRelativeLuminance(), o = t.getRelativeLuminance();
    return n = n * (o - s) / o, e.lighten(n);
  }
  static getDarkerColor(e, t, n) {
    if (e.isDarkerThan(t)) return e;
    n = n || 0.5;
    const s = e.getRelativeLuminance();
    return n = n * (s - t.getRelativeLuminance()) / s, e.darken(n);
  }
}
function J8(i) {
  const e = [];
  for (const t of i) {
    const n = Number(t);
    (n || n === 0 && t.replace(/\s/g, "") !== "") && e.push(n);
  }
  return e;
}
function xR(i, e, t, n) {
  return { red: i / 255, blue: t / 255, green: e / 255, alpha: n };
}
function Af(i, e) {
  const t = e.index, n = e[0].length;
  if (!t) return;
  const s = i.positionAt(t);
  return { startLineNumber: s.lineNumber, startColumn: s.column, endLineNumber: s.lineNumber, endColumn: s.column + n };
}
function Oq(i, e) {
  if (!i) return;
  const t = z.Format.CSS.parseHex(e);
  return t ? { range: i, color: xR(t.rgba.r, t.rgba.g, t.rgba.b, t.rgba.a) } : void 0;
}
function _4(i, e, t) {
  if (!i || e.length !== 1) return;
  const n = J8(e[0].values());
  return { range: i, color: xR(n[0], n[1], n[2], t ? n[3] : 1) };
}
function v4(i, e, t) {
  if (!i || e.length !== 1) return;
  const n = J8(e[0].values()), s = new z(new fr(n[0], n[1] / 100, n[2] / 100, t ? n[3] : 1));
  return { range: i, color: xR(s.rgba.r, s.rgba.g, s.rgba.b, s.rgba.a) };
}
function Pf(i, e) {
  return typeof i == "string" ? [...i.matchAll(e)] : i.findMatches(e);
}
function Fq(i) {
  return i && typeof i.getValue == "function" && typeof i.positionAt == "function" ? function(e) {
    const t = [], n = Pf(e, /\b(rgb|rgba|hsl|hsla)(\([0-9\s,.\%]*\))|(#)([A-Fa-f0-9]{3})\b|(#)([A-Fa-f0-9]{4})\b|(#)([A-Fa-f0-9]{6})\b|(#)([A-Fa-f0-9]{8})\b/gm);
    if (n.length > 0) for (const s of n) {
      const o = s.filter((d) => d !== void 0), r = o[1], a = o[2];
      if (!a) continue;
      let l;
      if (r === "rgb") {
        const d = /^\(\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*\)$/gm;
        l = _4(Af(e, s), Pf(a, d), !1);
      } else if (r === "rgba") {
        const d = /^\(\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(0[.][0-9]+|[.][0-9]+|[01][.]|[01])\s*\)$/gm;
        l = _4(Af(e, s), Pf(a, d), !0);
      } else if (r === "hsl") {
        const d = /^\(\s*(36[0]|3[0-5][0-9]|[12][0-9][0-9]|[1-9]?[0-9])\s*,\s*(100|\d{1,2}[.]\d*|\d{1,2})%\s*,\s*(100|\d{1,2}[.]\d*|\d{1,2})%\s*\)$/gm;
        l = v4(Af(e, s), Pf(a, d), !1);
      } else if (r === "hsla") {
        const d = /^\(\s*(36[0]|3[0-5][0-9]|[12][0-9][0-9]|[1-9]?[0-9])\s*,\s*(100|\d{1,2}[.]\d*|\d{1,2})%\s*,\s*(100|\d{1,2}[.]\d*|\d{1,2})%\s*,\s*(0[.][0-9]+|[.][0-9]+|[01][.]|[01])\s*\)$/gm;
        l = v4(Af(e, s), Pf(a, d), !0);
      } else r === "#" && (l = Oq(Af(e, s), r + a));
      l && t.push(l);
    }
    return t;
  }(i) : [];
}
z.white = new z(new ht(255, 255, 255, 1)), z.black = new z(new ht(0, 0, 0, 1)), z.red = new z(new ht(255, 0, 0, 1)), z.blue = new z(new ht(0, 0, 255, 1)), z.green = new z(new ht(0, 255, 0, 1)), z.cyan = new z(new ht(0, 255, 255, 1)), z.lightgrey = new z(new ht(211, 211, 211, 1)), z.transparent = new z(new ht(0, 0, 0, 0)), function(i) {
  var e;
  (function(t) {
    function n(o) {
      const r = o.toString(16);
      return r.length !== 2 ? "0" + r : r;
    }
    function s(o) {
      switch (o) {
        case 48:
          return 0;
        case 49:
          return 1;
        case 50:
          return 2;
        case 51:
          return 3;
        case 52:
          return 4;
        case 53:
          return 5;
        case 54:
          return 6;
        case 55:
          return 7;
        case 56:
          return 8;
        case 57:
          return 9;
        case 97:
        case 65:
          return 10;
        case 98:
        case 66:
          return 11;
        case 99:
        case 67:
          return 12;
        case 100:
        case 68:
          return 13;
        case 101:
        case 69:
          return 14;
        case 102:
        case 70:
          return 15;
      }
      return 0;
    }
    t.formatRGB = function(o) {
      return o.rgba.a === 1 ? `rgb(${o.rgba.r}, ${o.rgba.g}, ${o.rgba.b})` : i.Format.CSS.formatRGBA(o);
    }, t.formatRGBA = function(o) {
      return `rgba(${o.rgba.r}, ${o.rgba.g}, ${o.rgba.b}, ${+o.rgba.a.toFixed(2)})`;
    }, t.formatHSL = function(o) {
      return o.hsla.a === 1 ? `hsl(${o.hsla.h}, ${(100 * o.hsla.s).toFixed(2)}%, ${(100 * o.hsla.l).toFixed(2)}%)` : i.Format.CSS.formatHSLA(o);
    }, t.formatHSLA = function(o) {
      return `hsla(${o.hsla.h}, ${(100 * o.hsla.s).toFixed(2)}%, ${(100 * o.hsla.l).toFixed(2)}%, ${o.hsla.a.toFixed(2)})`;
    }, t.formatHex = function(o) {
      return `#${n(o.rgba.r)}${n(o.rgba.g)}${n(o.rgba.b)}`;
    }, t.formatHexA = function(o, r = !1) {
      return r && o.rgba.a === 1 ? i.Format.CSS.formatHex(o) : `#${n(o.rgba.r)}${n(o.rgba.g)}${n(o.rgba.b)}${n(Math.round(255 * o.rgba.a))}`;
    }, t.format = function(o) {
      return o.isOpaque() ? i.Format.CSS.formatHex(o) : i.Format.CSS.formatRGBA(o);
    }, t.parseHex = function(o) {
      const r = o.length;
      if (r === 0 || o.charCodeAt(0) !== 35) return null;
      if (r === 7) {
        const a = 16 * s(o.charCodeAt(1)) + s(o.charCodeAt(2)), l = 16 * s(o.charCodeAt(3)) + s(o.charCodeAt(4)), d = 16 * s(o.charCodeAt(5)) + s(o.charCodeAt(6));
        return new i(new ht(a, l, d, 1));
      }
      if (r === 9) {
        const a = 16 * s(o.charCodeAt(1)) + s(o.charCodeAt(2)), l = 16 * s(o.charCodeAt(3)) + s(o.charCodeAt(4)), d = 16 * s(o.charCodeAt(5)) + s(o.charCodeAt(6)), h = 16 * s(o.charCodeAt(7)) + s(o.charCodeAt(8));
        return new i(new ht(a, l, d, h / 255));
      }
      if (r === 4) {
        const a = s(o.charCodeAt(1)), l = s(o.charCodeAt(2)), d = s(o.charCodeAt(3));
        return new i(new ht(16 * a + a, 16 * l + l, 16 * d + d));
      }
      if (r === 5) {
        const a = s(o.charCodeAt(1)), l = s(o.charCodeAt(2)), d = s(o.charCodeAt(3)), h = s(o.charCodeAt(4));
        return new i(new ht(16 * a + a, 16 * l + l, 16 * d + d, (16 * h + h) / 255));
      }
      return null;
    };
  })((e = i.Format || (i.Format = {})).CSS || (e.CSS = {}));
}(z || (z = {}));
const b4 = new RegExp("\\bMARK:\\s*(.*)$", "d"), Bq = /^-+|-+$/g;
function Wq(i, e) {
  var t;
  let n = [];
  if (e.findRegionSectionHeaders && (!((t = e.foldingRules) === null || t === void 0) && t.markers)) {
    const s = function(o, r) {
      const a = [], l = o.getLineCount();
      for (let d = 1; d <= l; d++) {
        const h = o.getLineContent(d), c = h.match(r.foldingRules.markers.start);
        if (c) {
          const u = { startLineNumber: d, startColumn: c[0].length + 1, endLineNumber: d, endColumn: h.length + 1 };
          if (u.endColumn > u.startColumn) {
            const g = { range: u, ...eB(h.substring(c[0].length)), shouldBeInComments: !1 };
            (g.text || g.hasSeparatorLine) && a.push(g);
          }
        }
      }
      return a;
    }(i, e);
    n = n.concat(s);
  }
  if (e.findMarkSectionHeaders) {
    const s = function(o) {
      const r = [], a = o.getLineCount();
      for (let l = 1; l <= a; l++)
        Vq(o.getLineContent(l), l, r);
      return r;
    }(i);
    n = n.concat(s);
  }
  return n;
}
function Vq(i, e, t) {
  b4.lastIndex = 0;
  const n = b4.exec(i);
  if (n) {
    const s = { startLineNumber: e, startColumn: n.indices[1][0] + 1, endLineNumber: e, endColumn: n.indices[1][1] + 1 };
    if (s.endColumn > s.startColumn) {
      const o = { range: s, ...eB(n[1]), shouldBeInComments: !0 };
      (o.text || o.hasSeparatorLine) && t.push(o);
    }
  }
}
function eB(i) {
  const e = (i = i.trim()).startsWith("-");
  return { text: i = i.replace(Bq, ""), hasSeparatorLine: e };
}
class Hq extends mq {
  get uri() {
    return this._uri;
  }
  get eol() {
    return this._eol;
  }
  getValue() {
    return this.getText();
  }
  findMatches(e) {
    const t = [];
    for (let n = 0; n < this._lines.length; n++) {
      const s = this._lines[n], o = this.offsetAt(new W(n + 1, 1)), r = s.matchAll(e);
      for (const a of r) (a.index || a.index === 0) && (a.index = a.index + o), t.push(a);
    }
    return t;
  }
  getLinesContent() {
    return this._lines.slice(0);
  }
  getLineCount() {
    return this._lines.length;
  }
  getLineContent(e) {
    return this._lines[e - 1];
  }
  getWordAtPosition(e, t) {
    const n = q0(e.column, ZT(t), this._lines[e.lineNumber - 1], 0);
    return n ? new D(e.lineNumber, n.startColumn, e.lineNumber, n.endColumn) : null;
  }
  words(e) {
    const t = this._lines, n = this._wordenize.bind(this);
    let s = 0, o = "", r = 0, a = [];
    return { *[Symbol.iterator]() {
      for (; ; ) if (r < a.length) {
        const l = o.substring(a[r].start, a[r].end);
        r += 1, yield l;
      } else {
        if (!(s < t.length)) break;
        o = t[s], a = n(o, e), r = 0, s += 1;
      }
    } };
  }
  getLineWords(e, t) {
    const n = this._lines[e - 1], s = this._wordenize(n, t), o = [];
    for (const r of s) o.push({ word: n.substring(r.start, r.end), startColumn: r.start + 1, endColumn: r.end + 1 });
    return o;
  }
  _wordenize(e, t) {
    const n = [];
    let s;
    for (t.lastIndex = 0; (s = t.exec(e)) && s[0].length !== 0; ) n.push({ start: s.index, end: s.index + s[0].length });
    return n;
  }
  getValueInRange(e) {
    if ((e = this._validateRange(e)).startLineNumber === e.endLineNumber) return this._lines[e.startLineNumber - 1].substring(e.startColumn - 1, e.endColumn - 1);
    const t = this._eol, n = e.startLineNumber - 1, s = e.endLineNumber - 1, o = [];
    o.push(this._lines[n].substring(e.startColumn - 1));
    for (let r = n + 1; r < s; r++) o.push(this._lines[r]);
    return o.push(this._lines[s].substring(0, e.endColumn - 1)), o.join(t);
  }
  offsetAt(e) {
    return e = this._validatePosition(e), this._ensureLineStarts(), this._lineStarts.getPrefixSum(e.lineNumber - 2) + (e.column - 1);
  }
  positionAt(e) {
    e = Math.floor(e), e = Math.max(0, e), this._ensureLineStarts();
    const t = this._lineStarts.getIndexOf(e), n = this._lines[t.index].length;
    return { lineNumber: 1 + t.index, column: 1 + Math.min(t.remainder, n) };
  }
  _validateRange(e) {
    const t = this._validatePosition({ lineNumber: e.startLineNumber, column: e.startColumn }), n = this._validatePosition({ lineNumber: e.endLineNumber, column: e.endColumn });
    return t.lineNumber !== e.startLineNumber || t.column !== e.startColumn || n.lineNumber !== e.endLineNumber || n.column !== e.endColumn ? { startLineNumber: t.lineNumber, startColumn: t.column, endLineNumber: n.lineNumber, endColumn: n.column } : e;
  }
  _validatePosition(e) {
    if (!W.isIPosition(e)) throw new Error("bad position");
    let { lineNumber: t, column: n } = e, s = !1;
    if (t < 1) t = 1, n = 1, s = !0;
    else if (t > this._lines.length) t = this._lines.length, n = this._lines[t - 1].length + 1, s = !0;
    else {
      const o = this._lines[t - 1].length + 1;
      n < 1 ? (n = 1, s = !0) : n > o && (n = o, s = !0);
    }
    return s ? { lineNumber: t, column: n } : e;
  }
}
class ec {
  constructor(e, t) {
    this._host = e, this._models = /* @__PURE__ */ Object.create(null), this._foreignModuleFactory = t, this._foreignModule = null;
  }
  dispose() {
    this._models = /* @__PURE__ */ Object.create(null);
  }
  _getModel(e) {
    return this._models[e];
  }
  _getModels() {
    const e = [];
    return Object.keys(this._models).forEach((t) => e.push(this._models[t])), e;
  }
  acceptNewModel(e) {
    this._models[e.url] = new Hq(Ie.parse(e.url), e.lines, e.EOL, e.versionId);
  }
  acceptModelChanged(e, t) {
    this._models[e] && this._models[e].onEvents(t);
  }
  acceptRemovedModel(e) {
    this._models[e] && delete this._models[e];
  }
  async computeUnicodeHighlights(e, t, n) {
    const s = this._getModel(e);
    return s ? LR.computeUnicodeHighlights(s, t, n) : { ranges: [], hasMore: !1, ambiguousCharacterCount: 0, invisibleCharacterCount: 0, nonBasicAsciiCharacterCount: 0 };
  }
  async findSectionHeaders(e, t) {
    const n = this._getModel(e);
    return n ? Wq(n, t) : [];
  }
  async computeDiff(e, t, n, s) {
    const o = this._getModel(e), r = this._getModel(t);
    return !o || !r ? null : ec.computeDiff(o, r, n, s);
  }
  static computeDiff(e, t, n, s) {
    const o = s === "advanced" ? Pq() : Aq(), r = e.getLinesContent(), a = t.getLinesContent(), l = o.computeDiff(r, a, n);
    function d(h) {
      return h.map((c) => {
        var u;
        return [c.original.startLineNumber, c.original.endLineNumberExclusive, c.modified.startLineNumber, c.modified.endLineNumberExclusive, (u = c.innerChanges) === null || u === void 0 ? void 0 : u.map((g) => [g.originalRange.startLineNumber, g.originalRange.startColumn, g.originalRange.endLineNumber, g.originalRange.endColumn, g.modifiedRange.startLineNumber, g.modifiedRange.startColumn, g.modifiedRange.endLineNumber, g.modifiedRange.endColumn])];
      });
    }
    return { identical: !(l.changes.length > 0) && this._modelsAreIdentical(e, t), quitEarly: l.hitTimeout, changes: d(l.changes), moves: l.moves.map((h) => [h.lineRangeMapping.original.startLineNumber, h.lineRangeMapping.original.endLineNumberExclusive, h.lineRangeMapping.modified.startLineNumber, h.lineRangeMapping.modified.endLineNumberExclusive, d(h.changes)]) };
  }
  static _modelsAreIdentical(e, t) {
    const n = e.getLineCount();
    if (n !== t.getLineCount()) return !1;
    for (let s = 1; s <= n; s++)
      if (e.getLineContent(s) !== t.getLineContent(s)) return !1;
    return !0;
  }
  async computeMoreMinimalEdits(e, t, n) {
    const s = this._getModel(e);
    if (!s) return t;
    const o = [];
    let r;
    t = t.slice(0).sort((l, d) => l.range && d.range ? D.compareRangesUsingStarts(l.range, d.range) : (l.range ? 0 : 1) - (d.range ? 0 : 1));
    let a = 0;
    for (let l = 1; l < t.length; l++) D.getEndPosition(t[a].range).equals(D.getStartPosition(t[l].range)) ? (t[a].range = D.fromPositions(D.getStartPosition(t[a].range), D.getEndPosition(t[l].range)), t[a].text += t[l].text) : (a++, t[a] = t[l]);
    t.length = a + 1;
    for (let { range: l, text: d, eol: h } of t) {
      if (typeof h == "number" && (r = h), D.isEmpty(l) && !d) continue;
      const c = s.getValueInRange(l);
      if (d = d.replace(/\r\n|\n|\r/g, s.eol), c === d) continue;
      if (Math.max(d.length, c.length) > ec._diffLimit) {
        o.push({ range: l, text: d });
        continue;
      }
      const u = uq(c, d, n), g = s.offsetAt(D.lift(l).getStartPosition());
      for (const p of u) {
        const f = s.positionAt(g + p.originalStart), _ = s.positionAt(g + p.originalStart + p.originalLength), v = { text: d.substr(p.modifiedStart, p.modifiedLength), range: { startLineNumber: f.lineNumber, startColumn: f.column, endLineNumber: _.lineNumber, endColumn: _.column } };
        s.getValueInRange(v.range) !== v.text && o.push(v);
      }
    }
    return typeof r == "number" && o.push({ eol: r, text: "", range: { startLineNumber: 0, startColumn: 0, endLineNumber: 0, endColumn: 0 } }), o;
  }
  async computeLinks(e) {
    const t = this._getModel(e);
    return t ? function(n) {
      return n && typeof n.getLineCount == "function" && typeof n.getLineContent == "function" ? ty.computeLinks(n) : [];
    }(t) : null;
  }
  async computeDefaultDocumentColors(e) {
    const t = this._getModel(e);
    return t ? Fq(t) : null;
  }
  async textualSuggest(e, t, n, s) {
    const o = new Rn(), r = new RegExp(n, s), a = /* @__PURE__ */ new Set();
    e: for (const l of e) {
      const d = this._getModel(l);
      if (d) {
        for (const h of d.words(r)) if (h !== t && isNaN(Number(h)) && (a.add(h), a.size > ec._suggestionsLimit)) break e;
      }
    }
    return { words: Array.from(a), duration: o.elapsed() };
  }
  async computeWordRanges(e, t, n, s) {
    const o = this._getModel(e);
    if (!o) return /* @__PURE__ */ Object.create(null);
    const r = new RegExp(n, s), a = /* @__PURE__ */ Object.create(null);
    for (let l = t.startLineNumber; l < t.endLineNumber; l++) {
      const d = o.getLineWords(l, r);
      for (const h of d) {
        if (!isNaN(Number(h.word))) continue;
        let c = a[h.word];
        c || (c = [], a[h.word] = c), c.push({ startLineNumber: l, startColumn: h.startColumn, endLineNumber: l, endColumn: h.endColumn });
      }
    }
    return a;
  }
  async navigateValueSet(e, t, n, s, o) {
    const r = this._getModel(e);
    if (!r) return null;
    const a = new RegExp(s, o);
    t.startColumn === t.endColumn && (t = { startLineNumber: t.startLineNumber, startColumn: t.startColumn, endLineNumber: t.endLineNumber, endColumn: t.endColumn + 1 });
    const l = r.getValueInRange(t), d = r.getWordAtPosition({ lineNumber: t.startLineNumber, column: t.startColumn }, a);
    if (!d) return null;
    const h = r.getValueInRange(d);
    return VE.INSTANCE.navigateValueSet(t, l, d, h, n);
  }
  loadForeignModule(e, t, n) {
    const s = function(r, a) {
      const l = (h) => function() {
        const c = Array.prototype.slice.call(arguments, 0);
        return a(h, c);
      }, d = {};
      for (const h of r) d[h] = l(h);
      return d;
    }(n, (r, a) => this._host.fhr(r, a)), o = { host: s, getMirrorModels: () => this._getModels() };
    return this._foreignModuleFactory ? (this._foreignModule = this._foreignModuleFactory(o, t), Promise.resolve(jT(this._foreignModule))) : Promise.reject(new Error("Unexpected usage"));
  }
  fmr(e, t) {
    if (!this._foreignModule || typeof this._foreignModule[e] != "function") return Promise.reject(new Error("Missing requestHandler or method: " + e));
    try {
      return Promise.resolve(this._foreignModule[e].apply(this._foreignModule, t));
    } catch (n) {
      return Promise.reject(n);
    }
  }
}
ec._diffLimit = 1e5, ec._suggestionsLimit = 1e4, typeof importScripts == "function" && (globalThis.monaco = Y7());
const NR = tt("textResourceConfigurationService"), tB = tt("textResourcePropertiesService"), fe = tt("ILanguageFeaturesService");
var zq = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Of = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const Uq = 3e5;
function fu(i, e) {
  const t = i.getModel(e);
  return !!t && !t.isTooLargeForSyncing();
}
let jE = class extends V {
  constructor(i, e, t, n, s) {
    super(), this._modelService = i, this._workerManager = this._register(new jq(this._modelService, n)), this._logService = t, this._register(s.linkProvider.register({ language: "*", hasAccessToAllModels: !0 }, { provideLinks: (o, r) => fu(this._modelService, o.uri) ? this._workerManager.withWorker().then((a) => a.computeLinks(o.uri)).then((a) => a && { links: a }) : Promise.resolve({ links: [] }) })), this._register(s.completionProvider.register("*", new Kq(this._workerManager, e, this._modelService, n)));
  }
  dispose() {
    super.dispose();
  }
  canComputeUnicodeHighlights(i) {
    return fu(this._modelService, i);
  }
  computedUnicodeHighlights(i, e, t) {
    return this._workerManager.withWorker().then((n) => n.computedUnicodeHighlights(i, e, t));
  }
  async computeDiff(i, e, t, n) {
    const s = await this._workerManager.withWorker().then((r) => r.computeDiff(i, e, t, n));
    if (!s) return null;
    return { identical: s.identical, quitEarly: s.quitEarly, changes: o(s.changes), moves: s.moves.map((r) => new Z8(new us(new je(r[0], r[1]), new je(r[2], r[3])), o(r[4]))) };
    function o(r) {
      return r.map((a) => {
        var l;
        return new xo(new je(a[0], a[1]), new je(a[2], a[3]), (l = a[4]) === null || l === void 0 ? void 0 : l.map((d) => new Fd(new D(d[0], d[1], d[2], d[3]), new D(d[4], d[5], d[6], d[7]))));
      });
    }
  }
  computeMoreMinimalEdits(i, e, t = !1) {
    if (zn(e)) {
      if (!fu(this._modelService, i)) return Promise.resolve(e);
      const n = Rn.create(), s = this._workerManager.withWorker().then((o) => o.computeMoreMinimalEdits(i, e, t));
      return s.finally(() => this._logService.trace("FORMAT#computeMoreMinimalEdits", i.toString(!0), n.elapsed())), Promise.race([s, bc(1e3).then(() => e)]);
    }
    return Promise.resolve(void 0);
  }
  canNavigateValueSet(i) {
    return fu(this._modelService, i);
  }
  navigateValueSet(i, e, t) {
    return this._workerManager.withWorker().then((n) => n.navigateValueSet(i, e, t));
  }
  canComputeWordRanges(i) {
    return fu(this._modelService, i);
  }
  computeWordRanges(i, e) {
    return this._workerManager.withWorker().then((t) => t.computeWordRanges(i, e));
  }
  findSectionHeaders(i, e) {
    return this._workerManager.withWorker().then((t) => t.findSectionHeaders(i, e));
  }
};
jE = zq([Of(0, ni), Of(1, NR), Of(2, ts), Of(3, zt), Of(4, fe)], jE);
class Kq {
  constructor(e, t, n, s) {
    this.languageConfigurationService = s, this._debugDisplayName = "wordbasedCompletions", this._workerManager = e, this._configurationService = t, this._modelService = n;
  }
  async provideCompletionItems(e, t) {
    const n = this._configurationService.getValue(e.uri, t, "editor");
    if (n.wordBasedSuggestions === "off") return;
    const s = [];
    if (n.wordBasedSuggestions === "currentDocument") fu(this._modelService, e.uri) && s.push(e.uri);
    else for (const c of this._modelService.getModels()) fu(this._modelService, c.uri) && (c === e ? s.unshift(c.uri) : n.wordBasedSuggestions !== "allDocuments" && c.getLanguageId() !== e.getLanguageId() || s.push(c.uri));
    if (s.length === 0) return;
    const o = this.languageConfigurationService.getLanguageConfiguration(e.getLanguageId()).getWordDefinition(), r = e.getWordAtPosition(t), a = r ? new D(t.lineNumber, r.startColumn, t.lineNumber, r.endColumn) : D.fromPositions(t), l = a.setEndPosition(t.lineNumber, t.column), d = await this._workerManager.withWorker(), h = await d.textualSuggest(s, r == null ? void 0 : r.word, o);
    return h ? { duration: h.duration, suggestions: h.words.map((c) => ({ kind: 18, label: c, insertText: c, range: { insert: l, replace: a } })) } : void 0;
  }
}
class jq extends V {
  constructor(e, t) {
    super(), this.languageConfigurationService = t, this._modelService = e, this._editorWorkerClient = null, this._lastWorkerUsedTime = (/* @__PURE__ */ new Date()).getTime(), this._register(new pR()).cancelAndSet(() => this._checkStopIdleWorker(), Math.round(15e4), Et), this._register(this._modelService.onModelRemoved((n) => this._checkStopEmptyWorker()));
  }
  dispose() {
    this._editorWorkerClient && (this._editorWorkerClient.dispose(), this._editorWorkerClient = null), super.dispose();
  }
  _checkStopEmptyWorker() {
    this._editorWorkerClient && this._modelService.getModels().length === 0 && (this._editorWorkerClient.dispose(), this._editorWorkerClient = null);
  }
  _checkStopIdleWorker() {
    this._editorWorkerClient && (/* @__PURE__ */ new Date()).getTime() - this._lastWorkerUsedTime > Uq && (this._editorWorkerClient.dispose(), this._editorWorkerClient = null);
  }
  withWorker() {
    return this._lastWorkerUsedTime = (/* @__PURE__ */ new Date()).getTime(), this._editorWorkerClient || (this._editorWorkerClient = new ER(this._modelService, !1, "editorWorkerService", this.languageConfigurationService)), Promise.resolve(this._editorWorkerClient);
  }
}
class qq extends V {
  constructor(e, t, n) {
    if (super(), this._syncedModels = /* @__PURE__ */ Object.create(null), this._syncedModelsLastUsedTime = /* @__PURE__ */ Object.create(null), this._proxy = e, this._modelService = t, !n) {
      const s = new uR();
      s.cancelAndSet(() => this._checkStopModelSync(), Math.round(3e4)), this._register(s);
    }
  }
  dispose() {
    for (const e in this._syncedModels) Ht(this._syncedModels[e]);
    this._syncedModels = /* @__PURE__ */ Object.create(null), this._syncedModelsLastUsedTime = /* @__PURE__ */ Object.create(null), super.dispose();
  }
  ensureSyncedResources(e, t) {
    for (const n of e) {
      const s = n.toString();
      this._syncedModels[s] || this._beginModelSync(n, t), this._syncedModels[s] && (this._syncedModelsLastUsedTime[s] = (/* @__PURE__ */ new Date()).getTime());
    }
  }
  _checkStopModelSync() {
    const e = (/* @__PURE__ */ new Date()).getTime(), t = [];
    for (const n in this._syncedModelsLastUsedTime)
      e - this._syncedModelsLastUsedTime[n] > 6e4 && t.push(n);
    for (const n of t) this._stopModelSync(n);
  }
  _beginModelSync(e, t) {
    const n = this._modelService.getModel(e);
    if (!n || !t && n.isTooLargeForSyncing()) return;
    const s = e.toString();
    this._proxy.acceptNewModel({ url: n.uri.toString(), lines: n.getLinesContent(), EOL: n.getEOL(), versionId: n.getVersionId() });
    const o = new G();
    o.add(n.onDidChangeContent((r) => {
      this._proxy.acceptModelChanged(s.toString(), r);
    })), o.add(n.onWillDispose(() => {
      this._stopModelSync(s);
    })), o.add(ye(() => {
      this._proxy.acceptRemovedModel(s);
    })), this._syncedModels[s] = o;
  }
  _stopModelSync(e) {
    const t = this._syncedModels[e];
    delete this._syncedModels[e], delete this._syncedModelsLastUsedTime[e], Ht(t);
  }
}
class C4 {
  constructor(e) {
    this._instance = e, this._proxyObj = Promise.resolve(this._instance);
  }
  dispose() {
    this._instance.dispose();
  }
  getProxyObject() {
    return this._proxyObj;
  }
}
class hD {
  constructor(e) {
    this._workerClient = e;
  }
  fhr(e, t) {
    return this._workerClient.fhr(e, t);
  }
}
class ER extends V {
  constructor(e, t, n, s) {
    super(), this.languageConfigurationService = s, this._disposed = !1, this._modelService = e, this._keepIdleModels = t, this._workerFactory = new tL(n), this._worker = null, this._modelManager = null;
  }
  fhr(e, t) {
    throw new Error("Not implemented!");
  }
  _getOrCreateWorker() {
    if (!this._worker) try {
      this._worker = this._register(new qj(this._workerFactory, "vs/editor/common/services/editorSimpleWorker", new hD(this)));
    } catch (e) {
      OE(e), this._worker = new C4(new ec(new hD(this), null));
    }
    return this._worker;
  }
  _getProxy() {
    return this._getOrCreateWorker().getProxyObject().then(void 0, (e) => (OE(e), this._worker = new C4(new ec(new hD(this), null)), this._getOrCreateWorker().getProxyObject()));
  }
  _getOrCreateModelManager(e) {
    return this._modelManager || (this._modelManager = this._register(new qq(e, this._modelService, this._keepIdleModels))), this._modelManager;
  }
  async _withSyncedResources(e, t = !1) {
    return this._disposed ? Promise.reject(function() {
      const n = new Error(Tw);
      return n.name = n.message, n;
    }()) : this._getProxy().then((n) => (this._getOrCreateModelManager(n).ensureSyncedResources(e, t), n));
  }
  computedUnicodeHighlights(e, t, n) {
    return this._withSyncedResources([e]).then((s) => s.computeUnicodeHighlights(e.toString(), t, n));
  }
  computeDiff(e, t, n, s) {
    return this._withSyncedResources([e, t], !0).then((o) => o.computeDiff(e.toString(), t.toString(), n, s));
  }
  computeMoreMinimalEdits(e, t, n) {
    return this._withSyncedResources([e]).then((s) => s.computeMoreMinimalEdits(e.toString(), t, n));
  }
  computeLinks(e) {
    return this._withSyncedResources([e]).then((t) => t.computeLinks(e.toString()));
  }
  computeDefaultDocumentColors(e) {
    return this._withSyncedResources([e]).then((t) => t.computeDefaultDocumentColors(e.toString()));
  }
  async textualSuggest(e, t, n) {
    const s = await this._withSyncedResources(e), o = n.source, r = n.flags;
    return s.textualSuggest(e.map((a) => a.toString()), t, o, r);
  }
  computeWordRanges(e, t) {
    return this._withSyncedResources([e]).then((n) => {
      const s = this._modelService.getModel(e);
      if (!s) return Promise.resolve(null);
      const o = this.languageConfigurationService.getLanguageConfiguration(s.getLanguageId()).getWordDefinition(), r = o.source, a = o.flags;
      return n.computeWordRanges(e.toString(), t, r, a);
    });
  }
  navigateValueSet(e, t, n) {
    return this._withSyncedResources([e]).then((s) => {
      const o = this._modelService.getModel(e);
      if (!o) return null;
      const r = this.languageConfigurationService.getLanguageConfiguration(o.getLanguageId()).getWordDefinition(), a = r.source, l = r.flags;
      return s.navigateValueSet(e.toString(), t, n, a, l);
    });
  }
  findSectionHeaders(e, t) {
    return this._withSyncedResources([e]).then((n) => n.findSectionHeaders(e.toString(), t));
  }
  dispose() {
    super.dispose(), this._disposed = !0;
  }
}
class $q extends ER {
  constructor(e, t, n) {
    super(e, n.keepIdleModels || !1, n.label, t), this._foreignModuleId = n.moduleId, this._foreignModuleCreateData = n.createData || null, this._foreignModuleHost = n.host || null, this._foreignProxy = null;
  }
  fhr(e, t) {
    if (!this._foreignModuleHost || typeof this._foreignModuleHost[e] != "function") return Promise.reject(new Error("Missing method " + e + " or missing main thread foreign host."));
    try {
      return Promise.resolve(this._foreignModuleHost[e].apply(this._foreignModuleHost, t));
    } catch (n) {
      return Promise.reject(n);
    }
  }
  _getForeignProxy() {
    return this._foreignProxy || (this._foreignProxy = this._getProxy().then((e) => {
      const t = this._foreignModuleHost ? jT(this._foreignModuleHost) : [];
      return e.loadForeignModule(this._foreignModuleId, this._foreignModuleCreateData, t).then((n) => {
        this._foreignModuleCreateData = null;
        const s = (a, l) => e.fmr(a, l), o = (a, l) => function() {
          const d = Array.prototype.slice.call(arguments, 0);
          return l(a, d);
        }, r = {};
        for (const a of n) r[a] = o(a, s);
        return r;
      });
    })), this._foreignProxy;
  }
  getProxy() {
    return this._getForeignProxy();
  }
  withSyncedResources(e) {
    return this._withSyncedResources(e).then((t) => this.getProxy());
  }
}
const w1 = { ICodeEditor: "vs.editor.ICodeEditor", IDiffEditor: "vs.editor.IDiffEditor" }, zm = new class {
  clone() {
    return this;
  }
  equals(i) {
    return this === i;
  }
}();
function IR(i, e) {
  return new nR([new G0(0, "", i)], e);
}
function sL(i, e) {
  const t = new Uint32Array(2);
  return t[0] = 0, t[1] = (32768 | i | 2 << 24) >>> 0, new BS(t, e === null ? zm : e);
}
class In {
  static getLanguageId(e) {
    return (255 & e) >>> 0;
  }
  static getTokenType(e) {
    return (768 & e) >>> 8;
  }
  static containsBalancedBrackets(e) {
    return !!(1024 & e);
  }
  static getFontStyle(e) {
    return (30720 & e) >>> 11;
  }
  static getForeground(e) {
    return (16744448 & e) >>> 15;
  }
  static getBackground(e) {
    return (4278190080 & e) >>> 24;
  }
  static getClassNameFromMetadata(e) {
    let t = "mtk" + this.getForeground(e);
    const n = this.getFontStyle(e);
    return 1 & n && (t += " mtki"), 2 & n && (t += " mtkb"), 4 & n && (t += " mtku"), 8 & n && (t += " mtks"), t;
  }
  static getInlineStyleFromMetadata(e, t) {
    const n = this.getForeground(e), s = this.getFontStyle(e);
    let o = `color: ${t[n]};`;
    1 & s && (o += "font-style: italic;"), 2 & s && (o += "font-weight: bold;");
    let r = "";
    return 4 & s && (r += " underline"), 8 & s && (r += " line-through"), r && (o += `text-decoration:${r};`), o;
  }
  static getPresentationFromMetadata(e) {
    const t = this.getForeground(e), n = this.getFontStyle(e);
    return { foreground: t, italic: !!(1 & n), bold: !!(2 & n), underline: !!(4 & n), strikethrough: !!(8 & n) };
  }
}
class nn {
  static createEmpty(e, t) {
    const n = nn.defaultTokenMetadata, s = new Uint32Array(2);
    return s[0] = e.length, s[1] = n, new nn(s, e, t);
  }
  constructor(e, t, n) {
    this._lineTokensBrand = void 0, this._tokens = e, this._tokensCount = this._tokens.length >>> 1, this._text = t, this._languageIdCodec = n;
  }
  equals(e) {
    return e instanceof nn && this.slicedEquals(e, 0, this._tokensCount);
  }
  slicedEquals(e, t, n) {
    if (this._text !== e._text || this._tokensCount !== e._tokensCount) return !1;
    const s = t << 1, o = s + (n << 1);
    for (let r = s; r < o; r++) if (this._tokens[r] !== e._tokens[r]) return !1;
    return !0;
  }
  getLineContent() {
    return this._text;
  }
  getCount() {
    return this._tokensCount;
  }
  getStartOffset(e) {
    return e > 0 ? this._tokens[e - 1 << 1] : 0;
  }
  getMetadata(e) {
    return this._tokens[1 + (e << 1)];
  }
  getLanguageId(e) {
    const t = this._tokens[1 + (e << 1)], n = In.getLanguageId(t);
    return this._languageIdCodec.decodeLanguageId(n);
  }
  getStandardTokenType(e) {
    const t = this._tokens[1 + (e << 1)];
    return In.getTokenType(t);
  }
  getForeground(e) {
    const t = this._tokens[1 + (e << 1)];
    return In.getForeground(t);
  }
  getClassName(e) {
    const t = this._tokens[1 + (e << 1)];
    return In.getClassNameFromMetadata(t);
  }
  getInlineStyle(e, t) {
    const n = this._tokens[1 + (e << 1)];
    return In.getInlineStyleFromMetadata(n, t);
  }
  getPresentation(e) {
    const t = this._tokens[1 + (e << 1)];
    return In.getPresentationFromMetadata(t);
  }
  getEndOffset(e) {
    return this._tokens[e << 1];
  }
  findTokenIndexAtOffset(e) {
    return nn.findIndexInTokensArray(this._tokens, e);
  }
  inflate() {
    return this;
  }
  sliceAndInflate(e, t, n) {
    return new MR(this, e, t, n);
  }
  static convertToEndOffset(e, t) {
    const n = (e.length >>> 1) - 1;
    for (let s = 0; s < n; s++) e[s << 1] = e[s + 1 << 1];
    e[n << 1] = t;
  }
  static findIndexInTokensArray(e, t) {
    if (e.length <= 2) return 0;
    let n = 0, s = (e.length >>> 1) - 1;
    for (; n < s; ) {
      const o = n + Math.floor((s - n) / 2), r = e[o << 1];
      if (r === t) return o + 1;
      r < t ? n = o + 1 : r > t && (s = o);
    }
    return n;
  }
  withInserted(e) {
    if (e.length === 0) return this;
    let t = 0, n = 0, s = "";
    const o = new Array();
    let r = 0;
    for (; ; ) {
      const a = t < this._tokensCount ? this._tokens[t << 1] : -1, l = n < e.length ? e[n] : null;
      if (a !== -1 && (l === null || a <= l.offset)) {
        s += this._text.substring(r, a);
        const d = this._tokens[1 + (t << 1)];
        o.push(s.length, d), t++, r = a;
      } else {
        if (!l) break;
        if (l.offset > r) {
          s += this._text.substring(r, l.offset);
          const d = this._tokens[1 + (t << 1)];
          o.push(s.length, d), r = l.offset;
        }
        s += l.text, o.push(s.length, l.tokenMetadata), n++;
      }
    }
    return new nn(new Uint32Array(o), s, this._languageIdCodec);
  }
}
nn.defaultTokenMetadata = 33587200;
class MR {
  constructor(e, t, n, s) {
    this._source = e, this._startOffset = t, this._endOffset = n, this._deltaOffset = s, this._firstTokenIndex = e.findTokenIndexAtOffset(t), this._tokensCount = 0;
    for (let o = this._firstTokenIndex, r = e.getCount(); o < r && !(e.getStartOffset(o) >= n); o++)
      this._tokensCount++;
  }
  getMetadata(e) {
    return this._source.getMetadata(this._firstTokenIndex + e);
  }
  getLanguageId(e) {
    return this._source.getLanguageId(this._firstTokenIndex + e);
  }
  getLineContent() {
    return this._source.getLineContent().substring(this._startOffset, this._endOffset);
  }
  equals(e) {
    return e instanceof MR && this._startOffset === e._startOffset && this._endOffset === e._endOffset && this._deltaOffset === e._deltaOffset && this._source.slicedEquals(e._source, this._firstTokenIndex, this._tokensCount);
  }
  getCount() {
    return this._tokensCount;
  }
  getForeground(e) {
    return this._source.getForeground(this._firstTokenIndex + e);
  }
  getEndOffset(e) {
    const t = this._source.getEndOffset(this._firstTokenIndex + e);
    return Math.min(this._endOffset, t) - this._startOffset + this._deltaOffset;
  }
  getClassName(e) {
    return this._source.getClassName(this._firstTokenIndex + e);
  }
  getInlineStyle(e, t) {
    return this._source.getInlineStyle(this._firstTokenIndex + e, t);
  }
  getPresentation(e) {
    return this._source.getPresentation(this._firstTokenIndex + e);
  }
  findTokenIndexAtOffset(e) {
    return this._source.findTokenIndexAtOffset(e + this._startOffset - this._deltaOffset) - this._firstTokenIndex;
  }
}
class _s {
  constructor(e, t, n, s) {
    this.startColumn = e, this.endColumn = t, this.className = n, this.type = s, this._lineDecorationBrand = void 0;
  }
  static _equals(e, t) {
    return e.startColumn === t.startColumn && e.endColumn === t.endColumn && e.className === t.className && e.type === t.type;
  }
  static equalsArr(e, t) {
    const n = e.length;
    if (n !== t.length) return !1;
    for (let s = 0; s < n; s++) if (!_s._equals(e[s], t[s])) return !1;
    return !0;
  }
  static extractWrapped(e, t, n) {
    if (e.length === 0) return e;
    const s = t + 1, o = n + 1, r = n - t, a = [];
    let l = 0;
    for (const d of e) d.endColumn <= s || d.startColumn >= o || (a[l++] = new _s(Math.max(1, d.startColumn - s + 1), Math.min(r + 1, d.endColumn - s + 1), d.className, d.type));
    return a;
  }
  static filter(e, t, n, s) {
    if (e.length === 0) return [];
    const o = [];
    let r = 0;
    for (let a = 0, l = e.length; a < l; a++) {
      const d = e[a], h = d.range;
      if (h.endLineNumber < t || h.startLineNumber > t || h.isEmpty() && (d.type === 0 || d.type === 3)) continue;
      const c = h.startLineNumber === t ? h.startColumn : n, u = h.endLineNumber === t ? h.endColumn : s;
      o[r++] = new _s(c, u, d.inlineClassName, d.type);
    }
    return o;
  }
  static _typeCompare(e, t) {
    const n = [2, 0, 1, 3];
    return n[e] - n[t];
  }
  static compare(e, t) {
    if (e.startColumn !== t.startColumn) return e.startColumn - t.startColumn;
    if (e.endColumn !== t.endColumn) return e.endColumn - t.endColumn;
    const n = _s._typeCompare(e.type, t.type);
    return n !== 0 ? n : e.className !== t.className ? e.className < t.className ? -1 : 1 : 0;
  }
}
class w4 {
  constructor(e, t, n, s) {
    this.startOffset = e, this.endOffset = t, this.className = n, this.metadata = s;
  }
}
class ny {
  constructor() {
    this.stopOffsets = [], this.classNames = [], this.metadata = [], this.count = 0;
  }
  static _metadata(e) {
    let t = 0;
    for (let n = 0, s = e.length; n < s; n++) t |= e[n];
    return t;
  }
  consumeLowerThan(e, t, n) {
    for (; this.count > 0 && this.stopOffsets[0] < e; ) {
      let s = 0;
      for (; s + 1 < this.count && this.stopOffsets[s] === this.stopOffsets[s + 1]; ) s++;
      n.push(new w4(t, this.stopOffsets[s], this.classNames.join(" "), ny._metadata(this.metadata))), t = this.stopOffsets[s] + 1, this.stopOffsets.splice(0, s + 1), this.classNames.splice(0, s + 1), this.metadata.splice(0, s + 1), this.count -= s + 1;
    }
    return this.count > 0 && t < e && (n.push(new w4(t, e - 1, this.classNames.join(" "), ny._metadata(this.metadata))), t = e), t;
  }
  insert(e, t, n) {
    if (this.count === 0 || this.stopOffsets[this.count - 1] <= e) this.stopOffsets.push(e), this.classNames.push(t), this.metadata.push(n);
    else for (let s = 0; s < this.count; s++) if (this.stopOffsets[s] >= e) {
      this.stopOffsets.splice(s, 0, e), this.classNames.splice(s, 0, t), this.metadata.splice(s, 0, n);
      break;
    }
    this.count++;
  }
}
class Gq {
  static normalize(e, t) {
    if (t.length === 0) return [];
    const n = [], s = new ny();
    let o = 0;
    for (let r = 0, a = t.length; r < a; r++) {
      const l = t[r];
      let d = l.startColumn, h = l.endColumn;
      const c = l.className, u = l.type === 1 ? 2 : l.type === 2 ? 4 : 0;
      d > 1 && en(e.charCodeAt(d - 2)) && d--, h > 1 && en(e.charCodeAt(h - 2)) && h--;
      const g = d - 1, p = h - 2;
      o = s.consumeLowerThan(g, o, n), s.count === 0 && (o = g), s.insert(p, c, u);
    }
    return s.consumeLowerThan(1073741824, o, n), n;
  }
}
class ln {
  constructor(e, t, n, s) {
    this.endIndex = e, this.type = t, this.metadata = n, this.containsRTL = s, this._linePartBrand = void 0;
  }
  isWhitespace() {
    return !!(1 & this.metadata);
  }
  isPseudoAfter() {
    return !!(4 & this.metadata);
  }
}
class iB {
  constructor(e, t) {
    this.startOffset = e, this.endOffset = t;
  }
  equals(e) {
    return this.startOffset === e.startOffset && this.endOffset === e.endOffset;
  }
}
class Lc {
  constructor(e, t, n, s, o, r, a, l, d, h, c, u, g, p, f, _, v, b, C) {
    this.useMonospaceOptimizations = e, this.canUseHalfwidthRightwardsArrow = t, this.lineContent = n, this.continuesWithWrappedLine = s, this.isBasicASCII = o, this.containsRTL = r, this.fauxIndentLength = a, this.lineTokens = l, this.lineDecorations = d.sort(_s.compare), this.tabSize = h, this.startVisibleColumn = c, this.spaceWidth = u, this.stopRenderingLineAfter = f, this.renderWhitespace = _ === "all" ? 4 : _ === "boundary" ? 1 : _ === "selection" ? 2 : _ === "trailing" ? 3 : 0, this.renderControlCharacters = v, this.fontLigatures = b, this.selectionsOnLine = C && C.sort((w, y) => w.startOffset < y.startOffset ? -1 : 1), Math.abs(p - u) < Math.abs(g - u) ? (this.renderSpaceWidth = p, this.renderSpaceCharCode = 11825) : (this.renderSpaceWidth = g, this.renderSpaceCharCode = 183);
  }
  sameSelection(e) {
    if (this.selectionsOnLine === null) return e === null;
    if (e === null || e.length !== this.selectionsOnLine.length) return !1;
    for (let t = 0; t < this.selectionsOnLine.length; t++) if (!this.selectionsOnLine[t].equals(e[t])) return !1;
    return !0;
  }
  equals(e) {
    return this.useMonospaceOptimizations === e.useMonospaceOptimizations && this.canUseHalfwidthRightwardsArrow === e.canUseHalfwidthRightwardsArrow && this.lineContent === e.lineContent && this.continuesWithWrappedLine === e.continuesWithWrappedLine && this.isBasicASCII === e.isBasicASCII && this.containsRTL === e.containsRTL && this.fauxIndentLength === e.fauxIndentLength && this.tabSize === e.tabSize && this.startVisibleColumn === e.startVisibleColumn && this.spaceWidth === e.spaceWidth && this.renderSpaceWidth === e.renderSpaceWidth && this.renderSpaceCharCode === e.renderSpaceCharCode && this.stopRenderingLineAfter === e.stopRenderingLineAfter && this.renderWhitespace === e.renderWhitespace && this.renderControlCharacters === e.renderControlCharacters && this.fontLigatures === e.fontLigatures && _s.equalsArr(this.lineDecorations, e.lineDecorations) && this.lineTokens.equals(e.lineTokens) && this.sameSelection(e.selectionsOnLine);
  }
}
class nB {
  constructor(e, t) {
    this.partIndex = e, this.charIndex = t;
  }
}
class Ha {
  static getPartIndex(e) {
    return (4294901760 & e) >>> 16;
  }
  static getCharIndex(e) {
    return (65535 & e) >>> 0;
  }
  constructor(e, t) {
    this.length = e, this._data = new Uint32Array(this.length), this._horizontalOffset = new Uint32Array(this.length);
  }
  setColumnInfo(e, t, n, s) {
    const o = (t << 16 | n) >>> 0;
    this._data[e - 1] = o, this._horizontalOffset[e - 1] = s;
  }
  getHorizontalOffset(e) {
    return this._horizontalOffset.length === 0 ? 0 : this._horizontalOffset[e - 1];
  }
  charOffsetToPartData(e) {
    return this.length === 0 ? 0 : e < 0 ? this._data[0] : e >= this.length ? this._data[this.length - 1] : this._data[e];
  }
  getDomPosition(e) {
    const t = this.charOffsetToPartData(e - 1), n = Ha.getPartIndex(t), s = Ha.getCharIndex(t);
    return new nB(n, s);
  }
  getColumn(e, t) {
    return this.partDataToCharOffset(e.partIndex, t, e.charIndex) + 1;
  }
  partDataToCharOffset(e, t, n) {
    if (this.length === 0) return 0;
    const s = (e << 16 | n) >>> 0;
    let o = 0, r = this.length - 1;
    for (; o + 1 < r; ) {
      const u = o + r >>> 1, g = this._data[u];
      if (g === s) return u;
      g > s ? r = u : o = u;
    }
    if (o === r) return o;
    const a = this._data[o], l = this._data[r];
    if (a === s) return o;
    if (l === s) return r;
    const d = Ha.getPartIndex(a), h = Ha.getCharIndex(a);
    let c;
    return c = d !== Ha.getPartIndex(l) ? t : Ha.getCharIndex(l), n - h <= c - n ? o : r;
  }
}
class cD {
  constructor(e, t, n) {
    this._renderLineOutputBrand = void 0, this.characterMapping = e, this.containsRTL = t, this.containsForeignElements = n;
  }
}
function y1(i, e) {
  if (i.lineContent.length === 0) {
    if (i.lineDecorations.length > 0) {
      e.appendString("<span>");
      let t = 0, n = 0, s = 0;
      for (const r of i.lineDecorations) r.type !== 1 && r.type !== 2 || (e.appendString('<span class="'), e.appendString(r.className), e.appendString('"></span>'), r.type === 1 && (s |= 1, t++), r.type === 2 && (s |= 2, n++));
      e.appendString("</span>");
      const o = new Ha(1, t + n);
      return o.setColumnInfo(1, t, 0, 0), new cD(o, !1, s);
    }
    return e.appendString("<span><span></span></span>"), new cD(new Ha(0, 0), !1, 0);
  }
  return function(t, n) {
    const s = t.fontIsMonospace, o = t.canUseHalfwidthRightwardsArrow, r = t.containsForeignElements, a = t.lineContent, l = t.len, d = t.isOverflowing, h = t.overflowingCharCount, c = t.parts, u = t.fauxIndentLength, g = t.tabSize, p = t.startVisibleColumn, f = t.containsRTL, _ = t.spaceWidth, v = t.renderSpaceCharCode, b = t.renderWhitespace, C = t.renderControlCharacters, w = new Ha(l + 1, c.length);
    let y = !1, L = 0, k = p, N = 0, A = 0, B = 0;
    f ? n.appendString('<span dir="ltr">') : n.appendString("<span>");
    for (let T = 0, O = c.length; T < O; T++) {
      const H = c[T], $ = H.endIndex, pe = H.type, me = H.containsRTL, ue = b !== 0 && H.isWhitespace(), ee = ue && !s && (pe === "mtkw" || !r), te = L === $ && H.isPseudoAfter();
      if (N = 0, n.appendString("<span "), me && n.appendString('style="unicode-bidi:isolate" '), n.appendString('class="'), n.appendString(ee ? "mtkz" : pe), n.appendASCIICharCode(34), ue) {
        let be = 0;
        {
          let we = L, Re = k;
          for (; we < $; we++) {
            const it = 0 | (a.charCodeAt(we) === 9 ? g - Re % g : 1);
            be += it, we >= u && (Re += it);
          }
        }
        for (ee && (n.appendString(' style="width:'), n.appendString(String(_ * be)), n.appendString('px"')), n.appendASCIICharCode(62); L < $; L++) {
          w.setColumnInfo(L + 1, T - B, N, A), B = 0;
          let we, Re;
          if (a.charCodeAt(L) === 9) {
            we = g - k % g | 0, Re = we, !o || Re > 1 ? n.appendCharCode(8594) : n.appendCharCode(65515);
            for (let it = 2; it <= Re; it++) n.appendCharCode(160);
          } else we = 2, Re = 1, n.appendCharCode(v), n.appendCharCode(8204);
          N += we, A += Re, L >= u && (k += Re);
        }
      } else for (n.appendASCIICharCode(62); L < $; L++) {
        w.setColumnInfo(L + 1, T - B, N, A), B = 0;
        const be = a.charCodeAt(L);
        let we = 1, Re = 1;
        switch (be) {
          case 9:
            we = g - k % g, Re = we;
            for (let it = 1; it <= we; it++) n.appendCharCode(160);
            break;
          case 32:
            n.appendCharCode(160);
            break;
          case 60:
            n.appendString("&lt;");
            break;
          case 62:
            n.appendString("&gt;");
            break;
          case 38:
            n.appendString("&amp;");
            break;
          case 0:
            C ? n.appendCharCode(9216) : n.appendString("&#00;");
            break;
          case 65279:
          case 8232:
          case 8233:
          case 133:
            n.appendCharCode(65533);
            break;
          default:
            _c(be) && Re++, C && be < 32 ? n.appendCharCode(9216 + be) : C && be === 127 ? n.appendCharCode(9249) : C && y4(be) ? (n.appendString("[U+"), n.appendString(Xq(be)), n.appendString("]"), we = 8, Re = we) : n.appendCharCode(be);
        }
        N += we, A += Re, L >= u && (k += Re);
      }
      te ? B++ : B = 0, L >= l && !y && H.isPseudoAfter() && (y = !0, w.setColumnInfo(L + 1, T, N, A)), n.appendString("</span>");
    }
    return y || w.setColumnInfo(l + 1, c.length - 1, N, A), d && (n.appendString('<span class="mtkoverflow">'), n.appendString(m(0, "Show more ({0})", function(T) {
      return T < 1024 ? m(0, "{0} chars", T) : T < 1048576 ? `${(T / 1024).toFixed(1)} KB` : `${(T / 1024 / 1024).toFixed(1)} MB`;
    }(h))), n.appendString("</span>")), n.appendString("</span>"), new cD(w, f, r);
  }(function(t) {
    const n = t.lineContent;
    let s, o, r;
    t.stopRenderingLineAfter !== -1 && t.stopRenderingLineAfter < n.length ? (s = !0, o = n.length - t.stopRenderingLineAfter, r = t.stopRenderingLineAfter) : (s = !1, o = 0, r = n.length);
    let a = function(d, h, c, u, g) {
      const p = [];
      let f = 0;
      u > 0 && (p[f++] = new ln(u, "", 0, !1));
      let _ = u;
      for (let v = 0, b = c.getCount(); v < b; v++) {
        const C = c.getEndOffset(v);
        if (C <= u) continue;
        const w = c.getClassName(v);
        if (C >= g) {
          const L = !!h && Fm(d.substring(_, g));
          p[f++] = new ln(g, w, 0, L);
          break;
        }
        const y = !!h && Fm(d.substring(_, C));
        p[f++] = new ln(C, w, 0, y), _ = C;
      }
      return p;
    }(n, t.containsRTL, t.lineTokens, t.fauxIndentLength, r);
    t.renderControlCharacters && !t.isBasicASCII && (a = function(d, h) {
      const c = [];
      let u = new ln(0, "", 0, !1), g = 0;
      for (const p of h) {
        const f = p.endIndex;
        for (; g < f; g++)
          y4(d.charCodeAt(g)) && (g > u.endIndex && (u = new ln(g, p.type, p.metadata, p.containsRTL), c.push(u)), u = new ln(g + 1, "mtkcontrol", p.metadata, !1), c.push(u));
        g > u.endIndex && (u = new ln(f, p.type, p.metadata, p.containsRTL), c.push(u));
      }
      return c;
    }(n, a)), (t.renderWhitespace === 4 || t.renderWhitespace === 1 || t.renderWhitespace === 2 && t.selectionsOnLine || t.renderWhitespace === 3 && !t.continuesWithWrappedLine) && (a = function(d, h, c, u) {
      const g = d.continuesWithWrappedLine, p = d.fauxIndentLength, f = d.tabSize, _ = d.startVisibleColumn, v = d.useMonospaceOptimizations, b = d.selectionsOnLine, C = d.renderWhitespace === 1, w = d.renderWhitespace === 3, y = d.renderSpaceWidth !== d.spaceWidth, L = [];
      let k = 0, N = 0, A = u[N].type, B = u[N].containsRTL, T = u[N].endIndex;
      const O = u.length;
      let H, $ = !1, pe = Jn(h);
      pe === -1 ? ($ = !0, pe = c, H = c) : H = ra(h);
      let me = !1, ue = 0, ee = b && b[ue], te = _ % f;
      for (let we = p; we < c; we++) {
        const Re = h.charCodeAt(we);
        let it;
        if (ee && we >= ee.endOffset && (ue++, ee = b && b[ue]), we < pe || we > H) it = !0;
        else if (Re === 9) it = !0;
        else if (Re === 32) if (C) if (me) it = !0;
        else {
          const ut = we + 1 < c ? h.charCodeAt(we + 1) : 0;
          it = ut === 32 || ut === 9;
        }
        else it = !0;
        else it = !1;
        if (it && b && (it = !!ee && ee.startOffset <= we && ee.endOffset > we), it && w && (it = $ || we > H), it && B && we >= pe && we <= H && (it = !1), me) {
          if (!it || !v && te >= f) {
            if (y)
              for (let ut = (k > 0 ? L[k - 1].endIndex : p) + 1; ut <= we; ut++) L[k++] = new ln(ut, "mtkw", 1, !1);
            else L[k++] = new ln(we, "mtkw", 1, !1);
            te %= f;
          }
        } else (we === T || it && we > p) && (L[k++] = new ln(we, A, 0, B), te %= f);
        for (Re === 9 ? te = f : _c(Re) ? te += 2 : te++, me = it; we === T && (N++, N < O); ) A = u[N].type, B = u[N].containsRTL, T = u[N].endIndex;
      }
      let be = !1;
      if (me) if (g && C) {
        const we = c > 0 ? h.charCodeAt(c - 1) : 0, Re = c > 1 ? h.charCodeAt(c - 2) : 0;
        we === 32 && Re !== 32 && Re !== 9 || (be = !0);
      } else be = !0;
      if (be) if (y)
        for (let we = (k > 0 ? L[k - 1].endIndex : p) + 1; we <= c; we++) L[k++] = new ln(we, "mtkw", 1, !1);
      else L[k++] = new ln(c, "mtkw", 1, !1);
      else L[k++] = new ln(c, A, 0, B);
      return L;
    }(t, n, r, a));
    let l = 0;
    if (t.lineDecorations.length > 0) {
      for (let d = 0, h = t.lineDecorations.length; d < h; d++) {
        const c = t.lineDecorations[d];
        c.type === 3 || c.type === 1 ? l |= 1 : c.type === 2 && (l |= 2);
      }
      a = function(d, h, c, u) {
        u.sort(_s.compare);
        const g = Gq.normalize(d, u), p = g.length;
        let f = 0;
        const _ = [];
        let v = 0, b = 0;
        for (let w = 0, y = c.length; w < y; w++) {
          const L = c[w], k = L.endIndex, N = L.type, A = L.metadata, B = L.containsRTL;
          for (; f < p && g[f].startOffset < k; ) {
            const T = g[f];
            if (T.startOffset > b && (b = T.startOffset, _[v++] = new ln(b, N, A, B)), !(T.endOffset + 1 <= k)) {
              b = k, _[v++] = new ln(b, N + " " + T.className, A | T.metadata, B);
              break;
            }
            b = T.endOffset + 1, _[v++] = new ln(b, N + " " + T.className, A | T.metadata, B), f++;
          }
          k > b && (b = k, _[v++] = new ln(b, N, A, B));
        }
        const C = c[c.length - 1].endIndex;
        if (f < p && g[f].startOffset === C) for (; f < p && g[f].startOffset === C; ) {
          const w = g[f];
          _[v++] = new ln(b, w.className, w.metadata, !1), f++;
        }
        return _;
      }(n, 0, a, t.lineDecorations);
    }
    return t.containsRTL || (a = function(d, h, c) {
      let u = 0;
      const g = [];
      let p = 0;
      if (c) for (let f = 0, _ = h.length; f < _; f++) {
        const v = h[f], b = v.endIndex;
        if (u + 50 < b) {
          const C = v.type, w = v.metadata, y = v.containsRTL;
          let L = -1, k = u;
          for (let N = u; N < b; N++) d.charCodeAt(N) === 32 && (L = N), L !== -1 && N - k >= 50 && (g[p++] = new ln(L + 1, C, w, y), k = L + 1, L = -1);
          k !== b && (g[p++] = new ln(b, C, w, y));
        } else g[p++] = v;
        u = b;
      }
      else for (let f = 0, _ = h.length; f < _; f++) {
        const v = h[f], b = v.endIndex, C = b - u;
        if (C > 50) {
          const w = v.type, y = v.metadata, L = v.containsRTL, k = Math.ceil(C / 50);
          for (let N = 1; N < k; N++) {
            const A = u + 50 * N;
            g[p++] = new ln(A, w, y, L);
          }
          g[p++] = new ln(b, w, y, L);
        } else g[p++] = v;
        u = b;
      }
      return g;
    }(n, a, !t.isBasicASCII || t.fontLigatures)), new Yq(t.useMonospaceOptimizations, t.canUseHalfwidthRightwardsArrow, n, r, s, o, a, l, t.fauxIndentLength, t.tabSize, t.startVisibleColumn, t.containsRTL, t.spaceWidth, t.renderSpaceCharCode, t.renderWhitespace, t.renderControlCharacters);
  }(i), e);
}
class Zq {
  constructor(e, t, n, s) {
    this.characterMapping = e, this.html = t, this.containsRTL = n, this.containsForeignElements = s;
  }
}
function sy(i) {
  const e = new ff(1e4), t = y1(i, e);
  return new Zq(t.characterMapping, e.build(), t.containsRTL, t.containsForeignElements);
}
class Yq {
  constructor(e, t, n, s, o, r, a, l, d, h, c, u, g, p, f, _) {
    this.fontIsMonospace = e, this.canUseHalfwidthRightwardsArrow = t, this.lineContent = n, this.len = s, this.isOverflowing = o, this.overflowingCharCount = r, this.parts = a, this.containsForeignElements = l, this.fauxIndentLength = d, this.tabSize = h, this.startVisibleColumn = c, this.containsRTL = u, this.spaceWidth = g, this.renderSpaceCharCode = p, this.renderWhitespace = f, this.renderControlCharacters = _;
  }
}
function y4(i) {
  return i < 32 ? i !== 9 : i === 127 || i >= 8234 && i <= 8238 || i >= 8294 && i <= 8297 || i >= 8206 && i <= 8207 || i === 1564;
}
function Xq(i) {
  return i.toString(16).toUpperCase().padStart(4, "0");
}
class S4 {
  constructor(e, t, n, s) {
    this._viewportBrand = void 0, this.top = 0 | e, this.left = 0 | t, this.width = 0 | n, this.height = 0 | s;
  }
}
class Qq {
  constructor(e, t) {
    this.tabSize = e, this.data = t;
  }
}
class TR {
  constructor(e, t, n, s, o, r, a) {
    this._viewLineDataBrand = void 0, this.content = e, this.continuesWithWrappedLine = t, this.minColumn = n, this.maxColumn = s, this.startVisibleColumn = o, this.tokens = r, this.inlineDecorations = a;
  }
}
class Co {
  constructor(e, t, n, s, o, r, a, l, d, h) {
    this.minColumn = e, this.maxColumn = t, this.content = n, this.continuesWithWrappedLine = s, this.isBasicASCII = Co.isBasicASCII(n, r), this.containsRTL = Co.containsRTL(n, this.isBasicASCII, o), this.tokens = a, this.inlineDecorations = l, this.tabSize = d, this.startVisibleColumn = h;
  }
  static isBasicASCII(e, t) {
    return !t || f1(e);
  }
  static containsRTL(e, t, n) {
    return !(t || !n) && Fm(e);
  }
}
class Q_ {
  constructor(e, t, n) {
    this.range = e, this.inlineClassName = t, this.type = n;
  }
}
class Jq {
  constructor(e, t, n, s) {
    this.startOffset = e, this.endOffset = t, this.inlineClassName = n, this.inlineClassNameAffectsLetterSpacing = s;
  }
  toInlineDecoration(e) {
    return new Q_(new D(e, this.startOffset + 1, e, this.endOffset + 1), this.inlineClassName, this.inlineClassNameAffectsLetterSpacing ? 3 : 0);
  }
}
class sB {
  constructor(e, t) {
    this._viewModelDecorationBrand = void 0, this.range = e, this.options = t;
  }
}
class dv {
  constructor(e, t, n) {
    this.color = e, this.zIndex = t, this.data = n;
  }
  static compareByRenderingProps(e, t) {
    return e.zIndex === t.zIndex ? e.color < t.color ? -1 : e.color > t.color ? 1 : 0 : e.zIndex - t.zIndex;
  }
  static equals(e, t) {
    return e.color === t.color && e.zIndex === t.zIndex && ri(e.data, t.data);
  }
  static equalsArr(e, t) {
    return ri(e, t, dv.equals);
  }
}
function e$(i) {
  return !function(e) {
    return Array.isArray(e);
  }(i);
}
function oB(i) {
  return typeof i == "string";
}
function L4(i) {
  return !oB(i);
}
function _u(i) {
  return !i;
}
function xd(i, e) {
  return i.ignoreCase && e ? e.toLowerCase() : e;
}
function k4(i) {
  return i.replace(/[&<>'"_]/g, "-");
}
function Gt(i, e) {
  return new Error(`${i.languageId}: ${e}`);
}
function vh(i, e, t, n, s) {
  let o = null;
  return e.replace(/\$((\$)|(#)|(\d\d?)|[sS](\d\d?)|@(\w+))/g, function(r, a, l, d, h, c, u, g, p) {
    return _u(l) ? _u(d) ? !_u(h) && h < n.length ? xd(i, n[h]) : !_u(u) && i && typeof i[u] == "string" ? i[u] : (o === null && (o = s.split("."), o.unshift(s)), !_u(c) && c < o.length ? xd(i, o[c]) : "") : xd(i, t) : "$";
  });
}
function ab(i, e) {
  let t = e;
  for (; t && t.length > 0; ) {
    const n = i.tokenizer[t];
    if (n) return n;
    const s = t.lastIndexOf(".");
    t = s < 0 ? null : t.substr(0, s);
  }
  return null;
}
var qE, t$ = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, i$ = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class hv {
  static create(e, t) {
    return this._INSTANCE.create(e, t);
  }
  constructor(e) {
    this._maxCacheDepth = e, this._entries = /* @__PURE__ */ Object.create(null);
  }
  create(e, t) {
    if (e !== null && e.depth >= this._maxCacheDepth) return new sm(e, t);
    let n = sm.getStackElementId(e);
    n.length > 0 && (n += "|"), n += t;
    let s = this._entries[n];
    return s || (s = new sm(e, t), this._entries[n] = s, s);
  }
}
hv._INSTANCE = new hv(5);
class sm {
  constructor(e, t) {
    this.parent = e, this.state = t, this.depth = (this.parent ? this.parent.depth : 0) + 1;
  }
  static getStackElementId(e) {
    let t = "";
    for (; e !== null; ) t.length > 0 && (t += "|"), t += e.state, e = e.parent;
    return t;
  }
  static _equals(e, t) {
    for (; e !== null && t !== null; ) {
      if (e === t) return !0;
      if (e.state !== t.state) return !1;
      e = e.parent, t = t.parent;
    }
    return e === null && t === null;
  }
  equals(e) {
    return sm._equals(this, e);
  }
  push(e) {
    return hv.create(this, e);
  }
  pop() {
    return this.parent;
  }
  popall() {
    let e = this;
    for (; e.parent; ) e = e.parent;
    return e;
  }
  switchTo(e) {
    return hv.create(this.parent, e);
  }
}
class J_ {
  constructor(e, t) {
    this.languageId = e, this.state = t;
  }
  equals(e) {
    return this.languageId === e.languageId && this.state.equals(e.state);
  }
  clone() {
    return this.state.clone() === this.state ? this : new J_(this.languageId, this.state);
  }
}
class bh {
  static create(e, t) {
    return this._INSTANCE.create(e, t);
  }
  constructor(e) {
    this._maxCacheDepth = e, this._entries = /* @__PURE__ */ Object.create(null);
  }
  create(e, t) {
    if (t !== null) return new e0(e, t);
    if (e !== null && e.depth >= this._maxCacheDepth) return new e0(e, t);
    const n = sm.getStackElementId(e);
    let s = this._entries[n];
    return s || (s = new e0(e, null), this._entries[n] = s, s);
  }
}
bh._INSTANCE = new bh(5);
class e0 {
  constructor(e, t) {
    this.stack = e, this.embeddedLanguageData = t;
  }
  clone() {
    return (this.embeddedLanguageData ? this.embeddedLanguageData.clone() : null) === this.embeddedLanguageData ? this : bh.create(this.stack, this.embeddedLanguageData);
  }
  equals(e) {
    return e instanceof e0 && !!this.stack.equals(e.stack) && (this.embeddedLanguageData === null && e.embeddedLanguageData === null || this.embeddedLanguageData !== null && e.embeddedLanguageData !== null && this.embeddedLanguageData.equals(e.embeddedLanguageData));
  }
}
class n$ {
  constructor() {
    this._tokens = [], this._languageId = null, this._lastTokenType = null, this._lastTokenLanguage = null;
  }
  enterLanguage(e) {
    this._languageId = e;
  }
  emit(e, t) {
    this._lastTokenType === t && this._lastTokenLanguage === this._languageId || (this._lastTokenType = t, this._lastTokenLanguage = this._languageId, this._tokens.push(new G0(e, t, this._languageId)));
  }
  nestedLanguageTokenize(e, t, n, s) {
    const o = n.languageId, r = n.state, a = ci.get(o);
    if (!a) return this.enterLanguage(o), this.emit(s, ""), r;
    const l = a.tokenize(e, t, r);
    if (s !== 0) for (const d of l.tokens) this._tokens.push(new G0(d.offset + s, d.type, d.language));
    else this._tokens = this._tokens.concat(l.tokens);
    return this._lastTokenType = null, this._lastTokenLanguage = null, this._languageId = null, l.endState;
  }
  finalize(e) {
    return new nR(this._tokens, e);
  }
}
class oy {
  constructor(e, t) {
    this._languageService = e, this._theme = t, this._prependTokens = null, this._tokens = [], this._currentLanguageId = 0, this._lastTokenMetadata = 0;
  }
  enterLanguage(e) {
    this._currentLanguageId = this._languageService.languageIdCodec.encodeLanguageId(e);
  }
  emit(e, t) {
    const n = 1024 | this._theme.match(this._currentLanguageId, t);
    this._lastTokenMetadata !== n && (this._lastTokenMetadata = n, this._tokens.push(e), this._tokens.push(n));
  }
  static _merge(e, t, n) {
    const s = e !== null ? e.length : 0, o = t.length, r = n !== null ? n.length : 0;
    if (s === 0 && o === 0 && r === 0) return new Uint32Array(0);
    if (s === 0 && o === 0) return n;
    if (o === 0 && r === 0) return e;
    const a = new Uint32Array(s + o + r);
    e !== null && a.set(e);
    for (let l = 0; l < o; l++) a[s + l] = t[l];
    return n !== null && a.set(n, s + o), a;
  }
  nestedLanguageTokenize(e, t, n, s) {
    const o = n.languageId, r = n.state, a = ci.get(o);
    if (!a) return this.enterLanguage(o), this.emit(s, ""), r;
    const l = a.tokenizeEncoded(e, t, r);
    if (s !== 0) for (let d = 0, h = l.tokens.length; d < h; d += 2) l.tokens[d] += s;
    return this._prependTokens = oy._merge(this._prependTokens, this._tokens, l.tokens), this._tokens = [], this._currentLanguageId = 0, this._lastTokenMetadata = 0, l.endState;
  }
  finalize(e) {
    return new BS(oy._merge(this._prependTokens, this._tokens, null), e);
  }
}
let cv = qE = class extends V {
  constructor(i, e, t, n, s) {
    super(), this._configurationService = s, this._languageService = i, this._standaloneThemeService = e, this._languageId = t, this._lexer = n, this._embeddedLanguages = /* @__PURE__ */ Object.create(null), this.embeddedLoaded = Promise.resolve(void 0);
    let o = !1;
    this._register(ci.onDidChange((r) => {
      if (o) return;
      let a = !1;
      for (let l = 0, d = r.changedLanguages.length; l < d; l++) {
        const h = r.changedLanguages[l];
        if (this._embeddedLanguages[h]) {
          a = !0;
          break;
        }
      }
      a && (o = !0, ci.handleChange([this._languageId]), o = !1);
    })), this._maxTokenizationLineLength = this._configurationService.getValue("editor.maxTokenizationLineLength", { overrideIdentifier: this._languageId }), this._register(this._configurationService.onDidChangeConfiguration((r) => {
      r.affectsConfiguration("editor.maxTokenizationLineLength") && (this._maxTokenizationLineLength = this._configurationService.getValue("editor.maxTokenizationLineLength", { overrideIdentifier: this._languageId }));
    }));
  }
  getLoadStatus() {
    const i = [];
    for (const e in this._embeddedLanguages) {
      const t = ci.get(e);
      if (t) {
        if (t instanceof qE) {
          const n = t.getLoadStatus();
          n.loaded === !1 && i.push(n.promise);
        }
      } else ci.isResolved(e) || i.push(ci.getOrCreate(e));
    }
    return i.length === 0 ? { loaded: !0 } : { loaded: !1, promise: Promise.all(i).then((e) => {
    }) };
  }
  getInitialState() {
    const i = hv.create(null, this._lexer.start);
    return bh.create(i, null);
  }
  tokenize(i, e, t) {
    if (i.length >= this._maxTokenizationLineLength) return IR(this._languageId, t);
    const n = new n$(), s = this._tokenize(i, e, t, n);
    return n.finalize(s);
  }
  tokenizeEncoded(i, e, t) {
    if (i.length >= this._maxTokenizationLineLength) return sL(this._languageService.languageIdCodec.encodeLanguageId(this._languageId), t);
    const n = new oy(this._languageService, this._standaloneThemeService.getColorTheme().tokenTheme), s = this._tokenize(i, e, t, n);
    return n.finalize(s);
  }
  _tokenize(i, e, t, n) {
    return t.embeddedLanguageData ? this._nestedTokenize(i, e, t, 0, n) : this._myTokenize(i, e, t, 0, n);
  }
  _findLeavingNestedLanguageOffset(i, e) {
    let t = this._lexer.tokenizer[e.stack.state];
    if (!t && (t = ab(this._lexer, e.stack.state), !t)) throw Gt(this._lexer, "tokenizer state is not defined: " + e.stack.state);
    let n = -1, s = !1;
    for (const o of t) {
      if (!L4(o.action) || o.action.nextEmbedded !== "@pop") continue;
      s = !0;
      let r = o.resolveRegex(e.stack.state);
      const a = r.source;
      if (a.substr(0, 4) === "^(?:" && a.substr(a.length - 1, 1) === ")") {
        const d = (r.ignoreCase ? "i" : "") + (r.unicode ? "u" : "");
        r = new RegExp(a.substr(4, a.length - 5), d);
      }
      const l = i.search(r);
      l === -1 || l !== 0 && o.matchOnlyAtLineStart || (n === -1 || l < n) && (n = l);
    }
    if (!s) throw Gt(this._lexer, 'no rule containing nextEmbedded: "@pop" in tokenizer embedded state: ' + e.stack.state);
    return n;
  }
  _nestedTokenize(i, e, t, n, s) {
    const o = this._findLeavingNestedLanguageOffset(i, t);
    if (o === -1) {
      const l = s.nestedLanguageTokenize(i, e, t.embeddedLanguageData, n);
      return bh.create(t.stack, new J_(t.embeddedLanguageData.languageId, l));
    }
    const r = i.substring(0, o);
    r.length > 0 && s.nestedLanguageTokenize(r, !1, t.embeddedLanguageData, n);
    const a = i.substring(o);
    return this._myTokenize(a, e, t, n + o, s);
  }
  _safeRuleName(i) {
    return i ? i.name : "(unknown)";
  }
  _myTokenize(i, e, t, n, s) {
    s.enterLanguage(this._languageId);
    const o = i.length, r = e && this._lexer.includeLF ? i + `
` : i, a = r.length;
    let l = t.embeddedLanguageData, d = t.stack, h = 0, c = null, u = !0;
    for (; u || h < a; ) {
      const f = h, _ = d.depth, v = c ? c.groups.length : 0, b = d.state;
      let C = null, w = null, y = null, L = null, k = null;
      if (c) {
        C = c.matches;
        const B = c.groups.shift();
        w = B.matched, y = B.action, L = c.rule, c.groups.length === 0 && (c = null);
      } else {
        if (!u && h >= a) break;
        u = !1;
        let B = this._lexer.tokenizer[b];
        if (!B && (B = ab(this._lexer, b), !B)) throw Gt(this._lexer, "tokenizer state is not defined: " + b);
        const T = r.substr(h);
        for (const O of B) if ((h === 0 || !O.matchOnlyAtLineStart) && (C = T.match(O.resolveRegex(b)), C)) {
          w = C[0], y = O.action;
          break;
        }
      }
      if (C || (C = [""], w = ""), y || (h < a && (C = [r.charAt(h)], w = C[0]), y = this._lexer.defaultToken), w === null) break;
      for (h += w.length; e$(y) && L4(y) && y.test; ) y = y.test(w, C, b, h === a);
      let N = null;
      if (typeof y == "string" || Array.isArray(y)) N = y;
      else if (y.group) N = y.group;
      else if (y.token !== null && y.token !== void 0) {
        if (N = y.tokenSubst ? vh(this._lexer, y.token, w, C, b) : y.token, y.nextEmbedded) if (y.nextEmbedded === "@pop") {
          if (!l) throw Gt(this._lexer, "cannot pop embedded language if not inside one");
          l = null;
        } else {
          if (l) throw Gt(this._lexer, "cannot enter embedded language from within an embedded language");
          k = vh(this._lexer, y.nextEmbedded, w, C, b);
        }
        if (y.goBack && (h = Math.max(0, h - y.goBack)), y.switchTo && typeof y.switchTo == "string") {
          let B = vh(this._lexer, y.switchTo, w, C, b);
          if (B[0] === "@" && (B = B.substr(1)), !ab(this._lexer, B)) throw Gt(this._lexer, "trying to switch to a state '" + B + "' that is undefined in rule: " + this._safeRuleName(L));
          d = d.switchTo(B);
        } else {
          if (y.transform && typeof y.transform == "function") throw Gt(this._lexer, "action.transform not supported");
          if (y.next) if (y.next === "@push") {
            if (d.depth >= this._lexer.maxStack) throw Gt(this._lexer, "maximum tokenizer stack size reached: [" + d.state + "," + d.parent.state + ",...]");
            d = d.push(b);
          } else if (y.next === "@pop") {
            if (d.depth <= 1) throw Gt(this._lexer, "trying to pop an empty stack in rule: " + this._safeRuleName(L));
            d = d.pop();
          } else if (y.next === "@popall") d = d.popall();
          else {
            let B = vh(this._lexer, y.next, w, C, b);
            if (B[0] === "@" && (B = B.substr(1)), !ab(this._lexer, B)) throw Gt(this._lexer, "trying to set a next state '" + B + "' that is undefined in rule: " + this._safeRuleName(L));
            d = d.push(B);
          }
        }
        y.log && typeof y.log == "string" && (g = this._lexer, p = this._lexer.languageId + ": " + vh(this._lexer, y.log, w, C, b), console.log(`${g.languageId}: ${p}`));
      }
      if (N === null) throw Gt(this._lexer, "lexer rule has no well-defined action in rule: " + this._safeRuleName(L));
      const A = (B) => {
        const T = this._languageService.getLanguageIdByLanguageName(B) || this._languageService.getLanguageIdByMimeType(B) || B, O = this._getNestedEmbeddedLanguageData(T);
        if (h < a) {
          const H = i.substr(h);
          return this._nestedTokenize(H, e, bh.create(d, O), n + h, s);
        }
        return bh.create(d, O);
      };
      if (Array.isArray(N)) {
        if (c && c.groups.length > 0) throw Gt(this._lexer, "groups cannot be nested: " + this._safeRuleName(L));
        if (C.length !== N.length + 1) throw Gt(this._lexer, "matched number of groups does not match the number of actions in rule: " + this._safeRuleName(L));
        let B = 0;
        for (let T = 1; T < C.length; T++) B += C[T].length;
        if (B !== w.length) throw Gt(this._lexer, "with groups, all characters should be matched in consecutive groups in rule: " + this._safeRuleName(L));
        c = { rule: L, matches: C, groups: [] };
        for (let T = 0; T < N.length; T++) c.groups[T] = { action: N[T], matched: C[T + 1] };
        h -= w.length;
      } else {
        {
          if (N === "@rematch" && (h -= w.length, w = "", C = null, N = "", k !== null)) return A(k);
          if (w.length === 0) {
            if (a === 0 || _ !== d.depth || b !== d.state || (c ? c.groups.length : 0) !== v) continue;
            throw Gt(this._lexer, "no progress in tokenizer in rule: " + this._safeRuleName(L));
          }
          let B = null;
          if (oB(N) && N.indexOf("@brackets") === 0) {
            const T = N.substr(9), O = s$(this._lexer, w);
            if (!O) throw Gt(this._lexer, "@brackets token returned but no bracket defined as: " + w);
            B = k4(O.token + T);
          } else
            B = k4(N === "" ? "" : N + this._lexer.tokenPostfix);
          f < o && s.emit(f + n, B);
        }
        if (k !== null) return A(k);
      }
    }
    var g, p;
    return bh.create(d, l);
  }
  _getNestedEmbeddedLanguageData(i) {
    if (!this._languageService.isRegisteredLanguageId(i)) return new J_(i, zm);
    i !== this._languageId && (this._languageService.requestBasicLanguageFeatures(i), ci.getOrCreate(i), this._embeddedLanguages[i] = !0);
    const e = ci.get(i);
    return new J_(i, e ? e.getInitialState() : zm);
  }
};
function s$(i, e) {
  if (!e) return null;
  e = xd(i, e);
  const t = i.brackets;
  for (const n of t) {
    if (n.open === e) return { token: n.token, bracketType: 1 };
    if (n.close === e) return { token: n.token, bracketType: -1 };
  }
  return null;
}
cv = qE = t$([i$(4, Ye)], cv);
const D4 = Hd("standaloneColorizer", { createHTML: (i) => i });
class RR {
  static colorizeElement(e, t, n, s) {
    const o = (s = s || {}).theme || "vs", r = s.mimeType || n.getAttribute("lang") || n.getAttribute("data-lang");
    if (!r) return console.error("Mode not detected"), Promise.resolve();
    const a = t.getLanguageIdByMimeType(r) || r;
    e.setTheme(o);
    const l = n.firstChild ? n.firstChild.nodeValue : "";
    return n.className += " " + o, this.colorize(t, l || "", a, s).then((d) => {
      var h;
      const c = (h = D4 == null ? void 0 : D4.createHTML(d)) !== null && h !== void 0 ? h : d;
      n.innerHTML = c;
    }, (d) => console.error(d));
  }
  static async colorize(e, t, n, s) {
    const o = e.languageIdCodec;
    let r = 4;
    s && typeof s.tabSize == "number" && (r = s.tabSize), dR(t) && (t = t.substr(1));
    const a = Sl(t);
    if (!e.isRegisteredLanguageId(n)) return x4(a, r, o);
    const l = await ci.getOrCreate(n);
    return l ? function(d, h, c, u) {
      return new Promise((g, p) => {
        const f = () => {
          const _ = function(v, b, C, w) {
            let y = [], L = C.getInitialState();
            for (let k = 0, N = v.length; k < N; k++) {
              const A = v[k], B = C.tokenizeEncoded(A, !0, L);
              nn.convertToEndOffset(B.tokens, A.length);
              const T = new nn(B.tokens, A, w), O = Co.isBasicASCII(A, !0), H = Co.containsRTL(A, O, !0), $ = sy(new Lc(!1, !0, A, !1, O, H, 0, T.inflate(), [], b, 0, 0, 0, 0, -1, "none", !1, !1, null));
              y = y.concat($.html), y.push("<br/>"), L = B.endState;
            }
            return y.join("");
          }(d, h, c, u);
          if (c instanceof cv) {
            const v = c.getLoadStatus();
            if (v.loaded === !1) return void v.promise.then(f, p);
          }
          g(_);
        };
        f();
      });
    }(a, r, l, o) : x4(a, r, o);
  }
  static colorizeLine(e, t, n, s, o = 4) {
    const r = Co.isBasicASCII(e, t), a = Co.containsRTL(e, r, n);
    return sy(new Lc(!1, !0, e, !1, r, a, 0, s, [], o, 0, 0, 0, 0, -1, "none", !1, !1, null)).html;
  }
  static colorizeModelLine(e, t, n = 4) {
    const s = e.getLineContent(t);
    e.tokenization.forceTokenization(t);
    const o = e.tokenization.getLineTokens(t).inflate();
    return this.colorizeLine(s, e.mightContainNonBasicASCII(), e.mightContainRTL(), o, n);
  }
}
function x4(i, e, t) {
  let n = [];
  const s = new Uint32Array(2);
  s[0] = 0, s[1] = 33587200;
  for (let o = 0, r = i.length; o < r; o++) {
    const a = i[o];
    s[0] = a.length;
    const l = new nn(s, a, t), d = Co.isBasicASCII(a, !0), h = Co.containsRTL(a, d, !0), c = sy(new Lc(!1, !0, a, !1, d, h, 0, l, [], e, 0, 0, 0, 0, -1, "none", !1, !1, null));
    n = n.concat(c.html), n.push("<br/>");
  }
  return n.join("");
}
const N4 = 2e4;
let vu, OC, $E, FC, GE;
function Io(i) {
  vu && (OC.textContent !== i ? (Un($E), ry(OC, i)) : (Un(OC), ry($E, i)));
}
function vl(i) {
  vu && (FC.textContent !== i ? (Un(GE), ry(FC, i)) : (Un(FC), ry(GE, i)));
}
function ry(i, e) {
  Un(i), e.length > N4 && (e = e.substr(0, N4)), i.textContent = e, i.style.visibility = "hidden", i.style.visibility = "visible";
}
const AR = tt("markerDecorationsService");
var o$ = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, r$ = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let Ff = class {
  constructor(i, e) {
  }
  dispose() {
  }
};
Ff.ID = "editor.contrib.markerDecorations", Ff = o$([r$(1, AR)], Ff), ft(Ff.ID, Ff, 0);
class rB extends V {
  constructor(e, t) {
    super(), this._onDidChange = this._register(new F()), this.onDidChange = this._onDidChange.event, this._referenceDomElement = e, this._width = -1, this._height = -1, this._resizeObserver = null, this.measureReferenceDomElement(!1, t);
  }
  dispose() {
    this.stopObserving(), super.dispose();
  }
  getWidth() {
    return this._width;
  }
  getHeight() {
    return this._height;
  }
  startObserving() {
    if (!this._resizeObserver && this._referenceDomElement) {
      let e = null;
      const t = () => {
        e ? this.observe({ width: e.width, height: e.height }) : this.observe();
      };
      let n = !1, s = !1;
      const o = () => {
        if (n && !s) try {
          n = !1, s = !0, t();
        } finally {
          Ys(ke(this._referenceDomElement), () => {
            s = !1, o();
          });
        }
      };
      this._resizeObserver = new ResizeObserver((r) => {
        e = r && r[0] && r[0].contentRect ? { width: r[0].contentRect.width, height: r[0].contentRect.height } : null, n = !0, o();
      }), this._resizeObserver.observe(this._referenceDomElement);
    }
  }
  stopObserving() {
    this._resizeObserver && (this._resizeObserver.disconnect(), this._resizeObserver = null);
  }
  observe(e) {
    this.measureReferenceDomElement(!0, e);
  }
  measureReferenceDomElement(e, t) {
    let n = 0, s = 0;
    t ? (n = t.width, s = t.height) : this._referenceDomElement && (n = this._referenceDomElement.clientWidth, s = this._referenceDomElement.clientHeight), n = Math.max(5, n), s = Math.max(5, s), this._width === n && this._height === s || (this._width = n, this._height = s, e && this._onDidChange.fire());
  }
}
class tc {
  constructor(e, t) {
    this.key = e, this.migrate = t;
  }
  apply(e) {
    const t = tc._read(e, this.key);
    this.migrate(t, (n) => tc._read(e, n), (n, s) => tc._write(e, n, s));
  }
  static _read(e, t) {
    if (e === void 0) return;
    const n = t.indexOf(".");
    if (n >= 0) {
      const s = t.substring(0, n);
      return this._read(e[s], t.substring(n + 1));
    }
    return e[t];
  }
  static _write(e, t, n) {
    const s = t.indexOf(".");
    if (s >= 0) {
      const o = t.substring(0, s);
      return e[o] = e[o] || {}, void this._write(e[o], t.substring(s + 1), n);
    }
    e[t] = n;
  }
}
function Ur(i, e) {
  tc.items.push(new tc(i, e));
}
function Hs(i, e) {
  Ur(i, (t, n, s) => {
    if (t !== void 0) {
      for (const [o, r] of e) if (t === o) return void s(i, r);
    }
  });
}
tc.items = [], Hs("wordWrap", [[!0, "on"], [!1, "off"]]), Hs("lineNumbers", [[!0, "on"], [!1, "off"]]), Hs("cursorBlinking", [["visible", "solid"]]), Hs("renderWhitespace", [[!0, "boundary"], [!1, "none"]]), Hs("renderLineHighlight", [[!0, "line"], [!1, "none"]]), Hs("acceptSuggestionOnEnter", [[!0, "on"], [!1, "off"]]), Hs("tabCompletion", [[!1, "off"], [!0, "onlySnippets"]]), Hs("hover", [[!0, { enabled: !0 }], [!1, { enabled: !1 }]]), Hs("parameterHints", [[!0, { enabled: !0 }], [!1, { enabled: !1 }]]), Hs("autoIndent", [[!1, "advanced"], [!0, "full"]]), Hs("matchBrackets", [[!0, "always"], [!1, "never"]]), Hs("renderFinalNewline", [[!0, "on"], [!1, "off"]]), Hs("cursorSmoothCaretAnimation", [[!0, "on"], [!1, "off"]]), Hs("occurrencesHighlight", [[!0, "singleFile"], [!1, "off"]]), Hs("wordBasedSuggestions", [[!0, "matchingDocuments"], [!1, "off"]]), Ur("autoClosingBrackets", (i, e, t) => {
  i === !1 && (t("autoClosingBrackets", "never"), e("autoClosingQuotes") === void 0 && t("autoClosingQuotes", "never"), e("autoSurround") === void 0 && t("autoSurround", "never"));
}), Ur("renderIndentGuides", (i, e, t) => {
  i !== void 0 && (t("renderIndentGuides", void 0), e("guides.indentation") === void 0 && t("guides.indentation", !!i));
}), Ur("highlightActiveIndentGuide", (i, e, t) => {
  i !== void 0 && (t("highlightActiveIndentGuide", void 0), e("guides.highlightActiveIndentation") === void 0 && t("guides.highlightActiveIndentation", !!i));
});
const a$ = { method: "showMethods", function: "showFunctions", constructor: "showConstructors", deprecated: "showDeprecated", field: "showFields", variable: "showVariables", class: "showClasses", struct: "showStructs", interface: "showInterfaces", module: "showModules", property: "showProperties", event: "showEvents", operator: "showOperators", unit: "showUnits", value: "showValues", constant: "showConstants", enum: "showEnums", enumMember: "showEnumMembers", keyword: "showKeywords", text: "showWords", color: "showColors", file: "showFiles", reference: "showReferences", folder: "showFolders", typeParameter: "showTypeParameters", snippet: "showSnippets" };
Ur("suggest.filteredTypes", (i, e, t) => {
  if (i && typeof i == "object") {
    for (const n of Object.entries(a$))
      i[n[0]] === !1 && e(`suggest.${n[1]}`) === void 0 && t(`suggest.${n[1]}`, !1);
    t("suggest.filteredTypes", void 0);
  }
}), Ur("quickSuggestions", (i, e, t) => {
  if (typeof i == "boolean") {
    const n = i ? "on" : "off";
    t("quickSuggestions", { comments: n, strings: n, other: n });
  }
}), Ur("experimental.stickyScroll.enabled", (i, e, t) => {
  typeof i == "boolean" && (t("experimental.stickyScroll.enabled", void 0), e("stickyScroll.enabled") === void 0 && t("stickyScroll.enabled", i));
}), Ur("experimental.stickyScroll.maxLineCount", (i, e, t) => {
  typeof i == "number" && (t("experimental.stickyScroll.maxLineCount", void 0), e("stickyScroll.maxLineCount") === void 0 && t("stickyScroll.maxLineCount", i));
}), Ur("codeActionsOnSave", (i, e, t) => {
  if (i && typeof i == "object") {
    let n = !1;
    const s = {};
    for (const o of Object.entries(i)) typeof o[1] == "boolean" ? (n = !0, s[o[0]] = o[1] ? "explicit" : "never") : s[o[0]] = o[1];
    n && t("codeActionsOnSave", s);
  }
}), Ur("codeActionWidget.includeNearbyQuickfixes", (i, e, t) => {
  typeof i == "boolean" && (t("codeActionWidget.includeNearbyQuickfixes", void 0), e("codeActionWidget.includeNearbyQuickFixes") === void 0 && t("codeActionWidget.includeNearbyQuickFixes", i));
}), Ur("lightbulb.enabled", (i, e, t) => {
  typeof i == "boolean" && t("lightbulb.enabled", i ? void 0 : "off");
});
const Um = new class {
  constructor() {
    this._tabFocus = !1, this._onDidChangeTabFocus = new F(), this.onDidChangeTabFocus = this._onDidChangeTabFocus.event;
  }
  getTabFocusMode() {
    return this._tabFocus;
  }
  setTabFocusMode(i) {
    this._tabFocus = i, this._onDidChangeTabFocus.fire(this._tabFocus);
  }
}(), or = tt("accessibilityService"), m_ = new ae("accessibilityModeEnabled", !1);
var l$ = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, d$ = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let ZE = class extends V {
  constructor(i, e, t, n) {
    super(), this._accessibilityService = n, this._onDidChange = this._register(new F()), this.onDidChange = this._onDidChange.event, this._onDidChangeFast = this._register(new F()), this.onDidChangeFast = this._onDidChangeFast.event, this._isDominatedByLongLines = !1, this._viewLineCount = 1, this._lineNumbersDigitCount = 1, this._reservedHeight = 0, this._glyphMarginDecorationLaneCount = 1, this._computeOptionsMemory = new I7(), this.isSimpleWidget = i, this._containerObserver = this._register(new rB(t, e.dimension)), this._targetWindowId = ke(t).vscodeWindowId, this._rawOptions = E4(e), this._validatedOptions = Ch.validateOptions(this._rawOptions), this.options = this._computeOptions(), this.options.get(13) && this._containerObserver.startObserving(), this._register(Vo.onDidChangeZoomLevel(() => this._recomputeOptions())), this._register(Um.onDidChangeTabFocus(() => this._recomputeOptions())), this._register(this._containerObserver.onDidChange(() => this._recomputeOptions())), this._register(RE.onDidChange(() => this._recomputeOptions())), this._register(ev.getInstance(ke(t)).onDidChange(() => this._recomputeOptions())), this._register(this._accessibilityService.onDidChangeScreenReaderOptimized(() => this._recomputeOptions()));
  }
  _recomputeOptions() {
    const i = this._computeOptions(), e = Ch.checkEquals(this.options, i);
    e !== null && (this.options = i, this._onDidChangeFast.fire(e), this._onDidChange.fire(e));
  }
  _computeOptions() {
    const i = this._readEnvConfiguration(), e = Ku.createFromValidatedSettings(this._validatedOptions, i.pixelRatio, this.isSimpleWidget), t = this._readFontInfo(e), n = { memory: this._computeOptionsMemory, outerWidth: i.outerWidth, outerHeight: i.outerHeight - this._reservedHeight, fontInfo: t, extraEditorClassName: i.extraEditorClassName, isDominatedByLongLines: this._isDominatedByLongLines, viewLineCount: this._viewLineCount, lineNumbersDigitCount: this._lineNumbersDigitCount, emptySelectionClipboard: i.emptySelectionClipboard, pixelRatio: i.pixelRatio, tabFocusMode: Um.getTabFocusMode(), accessibilitySupport: i.accessibilitySupport, glyphMarginDecorationLaneCount: this._glyphMarginDecorationLaneCount };
    return Ch.computeOptions(this._validatedOptions, n);
  }
  _readEnvConfiguration() {
    return { extraEditorClassName: h$(), outerWidth: this._containerObserver.getWidth(), outerHeight: this._containerObserver.getHeight(), emptySelectionClipboard: Uu || tr, pixelRatio: ev.getInstance(LO(this._targetWindowId, !0).window).value, accessibilitySupport: this._accessibilityService.isScreenReaderOptimized() ? 2 : this._accessibilityService.getAccessibilitySupport() };
  }
  _readFontInfo(i) {
    return RE.readFontInfo(LO(this._targetWindowId, !0).window, i);
  }
  getRawOptions() {
    return this._rawOptions;
  }
  updateOptions(i) {
    const e = E4(i);
    Ch.applyUpdate(this._rawOptions, e) && (this._validatedOptions = Ch.validateOptions(this._rawOptions), this._recomputeOptions());
  }
  observeContainer(i) {
    this._containerObserver.observe(i);
  }
  setIsDominatedByLongLines(i) {
    this._isDominatedByLongLines !== i && (this._isDominatedByLongLines = i, this._recomputeOptions());
  }
  setModelLineCount(i) {
    const e = function(t) {
      let n = 0;
      for (; t; ) t = Math.floor(t / 10), n++;
      return n || 1;
    }(i);
    this._lineNumbersDigitCount !== e && (this._lineNumbersDigitCount = e, this._recomputeOptions());
  }
  setViewLineCount(i) {
    this._viewLineCount !== i && (this._viewLineCount = i, this._recomputeOptions());
  }
  setReservedHeight(i) {
    this._reservedHeight !== i && (this._reservedHeight = i, this._recomputeOptions());
  }
  setGlyphMarginDecorationLaneCount(i) {
    this._glyphMarginDecorationLaneCount !== i && (this._glyphMarginDecorationLaneCount = i, this._recomputeOptions());
  }
};
function h$() {
  let i = "";
  return vc || o8 || (i += "no-user-select "), vc && (i += "no-minimap-shadow ", i += "enable-user-select "), Je && (i += "mac "), i;
}
ZE = l$([d$(3, or)], ZE);
class c$ {
  constructor() {
    this._values = [];
  }
  _read(e) {
    return this._values[e];
  }
  get(e) {
    return this._values[e];
  }
  _write(e, t) {
    this._values[e] = t;
  }
}
class u$ {
  constructor() {
    this._values = [];
  }
  _read(e) {
    if (e >= this._values.length) throw new Error("Cannot read uninitialized value");
    return this._values[e];
  }
  get(e) {
    return this._read(e);
  }
  _write(e, t) {
    this._values[e] = t;
  }
}
class Ch {
  static validateOptions(e) {
    const t = new c$();
    for (const n of Lp) {
      const s = n.name === "_never_" ? void 0 : e[n.name];
      t._write(n.id, n.validate(s));
    }
    return t;
  }
  static computeOptions(e, t) {
    const n = new u$();
    for (const s of Lp) n._write(s.id, s.compute(t, n, e._read(s.id)));
    return n;
  }
  static _deepEquals(e, t) {
    if (typeof e != "object" || typeof t != "object" || !e || !t) return e === t;
    if (Array.isArray(e) || Array.isArray(t)) return !(!Array.isArray(e) || !Array.isArray(t)) && ri(e, t);
    if (Object.keys(e).length !== Object.keys(t).length) return !1;
    for (const n in e) if (!Ch._deepEquals(e[n], t[n])) return !1;
    return !0;
  }
  static checkEquals(e, t) {
    const n = [];
    let s = !1;
    for (const o of Lp) {
      const r = !Ch._deepEquals(e._read(o.id), t._read(o.id));
      n[o.id] = r, r && (s = !0);
    }
    return s ? new E7(n) : null;
  }
  static applyUpdate(e, t) {
    let n = !1;
    for (const s of Lp) if (t.hasOwnProperty(s.name)) {
      const o = s.applyUpdate(e[s.name], t[s.name]);
      e[s.name] = o.newValue, n = n || o.didChange;
    }
    return n;
  }
}
function E4(i) {
  const e = Ul(i);
  return function(t) {
    tc.items.forEach((n) => n.apply(t));
  }(e), e;
}
var Mh;
(function(i) {
  const e = { total: 0, min: Number.MAX_VALUE, max: 0 }, t = { ...e }, n = { ...e }, s = { ...e };
  let o = 0;
  const r = { keydown: 0, input: 0, render: 0 };
  function a() {
    r.keydown === 1 && (performance.mark("keydown/end"), r.keydown = 2);
  }
  function l() {
    performance.mark("input/start"), r.input = 1, c();
  }
  function d() {
    r.input === 1 && (performance.mark("input/end"), r.input = 2);
  }
  function h() {
    r.render === 1 && (performance.mark("render/end"), r.render = 2);
  }
  function c() {
    setTimeout(u);
  }
  function u() {
    r.keydown === 2 && r.input === 2 && r.render === 2 && (performance.mark("inputlatency/end"), performance.measure("keydown", "keydown/start", "keydown/end"), performance.measure("input", "input/start", "input/end"), performance.measure("render", "render/start", "render/end"), performance.measure("inputlatency", "inputlatency/start", "inputlatency/end"), g("keydown", e), g("input", t), g("render", n), g("inputlatency", s), o++, performance.clearMarks("keydown/start"), performance.clearMarks("keydown/end"), performance.clearMarks("input/start"), performance.clearMarks("input/end"), performance.clearMarks("render/start"), performance.clearMarks("render/end"), performance.clearMarks("inputlatency/start"), performance.clearMarks("inputlatency/end"), performance.clearMeasures("keydown"), performance.clearMeasures("input"), performance.clearMeasures("render"), performance.clearMeasures("inputlatency"), r.keydown = 0, r.input = 0, r.render = 0);
  }
  function g(_, v) {
    const b = performance.getEntriesByName(_)[0].duration;
    v.total += b, v.min = Math.min(v.min, b), v.max = Math.max(v.max, b);
  }
  function p(_) {
    return { average: _.total / o, max: _.max, min: _.min };
  }
  function f(_) {
    _.total = 0, _.min = Number.MAX_VALUE, _.max = 0;
  }
  i.onKeyDown = function() {
    u(), performance.mark("inputlatency/start"), performance.mark("keydown/start"), r.keydown = 1, queueMicrotask(a);
  }, i.onBeforeInput = l, i.onInput = function() {
    r.input === 0 && l(), queueMicrotask(d);
  }, i.onKeyUp = function() {
    u();
  }, i.onSelectionChange = function() {
    u();
  }, i.onRenderStart = function() {
    r.keydown === 2 && r.input === 2 && r.render === 0 && (performance.mark("render/start"), r.render = 1, queueMicrotask(h), c());
  }, i.getAndClearMeasurements = function() {
    if (o === 0) return;
    const _ = { keydown: p(e), input: p(t), render: p(n), total: p(s), sampleCount: o };
    return f(e), f(t), f(n), f(s), o = 0, _;
  };
})(Mh || (Mh = {}));
class vf {
  constructor() {
    this._hooks = new G(), this._pointerMoveCallback = null, this._onStopCallback = null;
  }
  dispose() {
    this.stopMonitoring(!1), this._hooks.dispose();
  }
  stopMonitoring(e, t) {
    if (!this.isMonitoring()) return;
    this._hooks.clear(), this._pointerMoveCallback = null;
    const n = this._onStopCallback;
    this._onStopCallback = null, e && n && n(t);
  }
  isMonitoring() {
    return !!this._pointerMoveCallback;
  }
  startMonitoring(e, t, n, s, o) {
    this.isMonitoring() && this.stopMonitoring(!1), this._pointerMoveCallback = s, this._onStopCallback = o;
    let r = e;
    try {
      e.setPointerCapture(t), this._hooks.add(ye(() => {
        try {
          e.releasePointerCapture(t);
        } catch {
        }
      }));
    } catch {
      r = ke(e);
    }
    this._hooks.add(K(r, ie.POINTER_MOVE, (a) => {
      a.buttons === n ? (a.preventDefault(), this._pointerMoveCallback(a)) : this.stopMonitoring(!0);
    })), this._hooks.add(K(r, ie.POINTER_UP, (a) => this.stopMonitoring(!0)));
  }
}
function PR(i) {
  return `--vscode-${i.replace(/\./g, "-")}`;
}
function de(i) {
  return `var(${PR(i)})`;
}
const aB = "base.contributions.colors", oL = new class {
  constructor() {
    this._onDidChangeSchema = new F(), this.onDidChangeSchema = this._onDidChangeSchema.event, this.colorSchema = { type: "object", properties: {} }, this.colorReferenceSchema = { type: "string", enum: [], enumDescriptions: [] }, this.colorsById = {};
  }
  registerColor(i, e, t, n = !1, s) {
    const o = { id: i, description: t, defaults: e, needsTransparency: n, deprecationMessage: s };
    this.colorsById[i] = o;
    const r = { type: "string", description: t, format: "color-hex", defaultSnippets: [{ body: "${1:#ff0000}" }] };
    return s && (r.deprecationMessage = s), n && (r.pattern = "^#(?:(?<rgba>[0-9a-fA-f]{3}[0-9a-eA-E])|(?:[0-9a-fA-F]{6}(?:(?![fF]{2})(?:[0-9a-fA-F]{2}))))?$", r.patternErrorMessage = "This color must be transparent or it will obscure content"), this.colorSchema.properties[i] = r, this.colorReferenceSchema.enum.push(i), this.colorReferenceSchema.enumDescriptions.push(t), this._onDidChangeSchema.fire(), i;
  }
  getColors() {
    return Object.keys(this.colorsById).map((i) => this.colorsById[i]);
  }
  resolveDefaultColor(i, e) {
    const t = this.colorsById[i];
    if (t && t.defaults)
      return Pr(t.defaults[e.type], e);
  }
  getColorSchema() {
    return this.colorSchema;
  }
  toString() {
    return Object.keys(this.colorsById).sort((i, e) => {
      const t = i.indexOf(".") === -1 ? 0 : 1, n = e.indexOf(".") === -1 ? 0 : 1;
      return t !== n ? t - n : i.localeCompare(e);
    }).map((i) => `- \`${i}\`: ${this.colorsById[i].description}`).join(`
`);
  }
}();
function I(i, e, t, n, s) {
  return oL.registerColor(i, e, t, n, s);
}
function Ig(i, e) {
  return { op: 0, value: i, factor: e };
}
function aa(i, e) {
  return { op: 1, value: i, factor: e };
}
function Ce(i, e) {
  return { op: 2, value: i, factor: e };
}
function uv(...i) {
  return { op: 4, values: i };
}
function I4(i, e, t, n) {
  return { op: 5, value: i, background: e, factor: t, transparency: n };
}
function Pr(i, e) {
  if (i !== null) return typeof i == "string" ? i[0] === "#" ? z.fromHex(i) : e.getColor(i) : i instanceof z ? i : typeof i == "object" ? function(t, n) {
    var s, o, r, a;
    switch (t.op) {
      case 0:
        return (s = Pr(t.value, n)) === null || s === void 0 ? void 0 : s.darken(t.factor);
      case 1:
        return (o = Pr(t.value, n)) === null || o === void 0 ? void 0 : o.lighten(t.factor);
      case 2:
        return (r = Pr(t.value, n)) === null || r === void 0 ? void 0 : r.transparent(t.factor);
      case 3: {
        const l = Pr(t.background, n);
        return l ? (a = Pr(t.value, n)) === null || a === void 0 ? void 0 : a.makeOpaque(l) : Pr(t.value, n);
      }
      case 4:
        for (const l of t.values) {
          const d = Pr(l, n);
          if (d) return d;
        }
        return;
      case 6:
        return Pr(n.defines(t.if) ? t.then : t.else, n);
      case 5: {
        const l = Pr(t.value, n);
        if (!l) return;
        const d = Pr(t.background, n);
        return d ? l.isDarkerThan(d) ? z.getLighterColor(l, d, t.factor).transparent(t.transparency) : z.getDarkerColor(l, d, t.factor).transparent(t.transparency) : l.transparent(t.factor * t.transparency);
      }
      default:
        throw JS();
    }
  }(i, e) : void 0;
}
li.add(aB, oL);
const lB = "vscode://schemas/workbench-colors", dB = li.as(nL);
dB.registerSchema(lB, oL.getColorSchema());
const M4 = new It(() => dB.notifySchemaChanged(lB), 200);
oL.onDidChangeSchema(() => {
  M4.isScheduled() || M4.schedule();
});
const oe = I("foreground", { dark: "#CCCCCC", light: "#616161", hcDark: "#FFFFFF", hcLight: "#292929" }, m(0, "Overall foreground color. This color is only used if not overridden by a component."));
I("disabledForeground", { dark: "#CCCCCC80", light: "#61616180", hcDark: "#A5A5A5", hcLight: "#7F7F7F" }, m(0, "Overall foreground for disabled elements. This color is only used if not overridden by a component.")), I("errorForeground", { dark: "#F48771", light: "#A1260D", hcDark: "#F48771", hcLight: "#B5200D" }, m(0, "Overall foreground color for error messages. This color is only used if not overridden by a component.")), I("descriptionForeground", { light: "#717171", dark: Ce(oe, 0.7), hcDark: Ce(oe, 0.7), hcLight: Ce(oe, 0.7) }, m(0, "Foreground color for description text providing additional information, for example for a label."));
const sl = I("icon.foreground", { dark: "#C5C5C5", light: "#424242", hcDark: "#FFFFFF", hcLight: "#292929" }, m(0, "The default color for icons in the workbench.")), $o = I("focusBorder", { dark: "#007FD4", light: "#0090F1", hcDark: "#F38518", hcLight: "#006BBD" }, m(0, "Overall border color for focused elements. This color is only used if not overridden by a component.")), ot = I("contrastBorder", { light: null, dark: null, hcDark: "#6FC3DF", hcLight: "#0F4A85" }, m(0, "An extra border around elements to separate them from others for greater contrast.")), Zt = I("contrastActiveBorder", { light: null, dark: null, hcDark: $o, hcLight: $o }, m(0, "An extra border around active elements to separate them from others for greater contrast."));
I("selection.background", { light: null, dark: null, hcDark: null, hcLight: null }, m(0, "The background color of text selections in the workbench (e.g. for input fields or text areas). Note that this does not apply to selections within the editor."));
const g$ = I("textLink.foreground", { light: "#006AB1", dark: "#3794FF", hcDark: "#21A6FF", hcLight: "#0F4A85" }, m(0, "Foreground color for links in text."));
I("textLink.activeForeground", { light: "#006AB1", dark: "#3794FF", hcDark: "#21A6FF", hcLight: "#0F4A85" }, m(0, "Foreground color for links in text when clicked on and on mouse hover.")), I("textSeparator.foreground", { light: "#0000002e", dark: "#ffffff2e", hcDark: z.black, hcLight: "#292929" }, m(0, "Color for text separators.")), I("textPreformat.foreground", { light: "#A31515", dark: "#D7BA7D", hcDark: "#000000", hcLight: "#FFFFFF" }, m(0, "Foreground color for preformatted text segments.")), I("textPreformat.background", { light: "#0000001A", dark: "#FFFFFF1A", hcDark: "#FFFFFF", hcLight: "#09345f" }, m(0, "Background color for preformatted text segments.")), I("textBlockQuote.background", { light: "#f2f2f2", dark: "#222222", hcDark: null, hcLight: "#F2F2F2" }, m(0, "Background color for block quotes in text.")), I("textBlockQuote.border", { light: "#007acc80", dark: "#007acc80", hcDark: z.white, hcLight: "#292929" }, m(0, "Border color for block quotes in text.")), I("textCodeBlock.background", { light: "#dcdcdc66", dark: "#0a0a0a66", hcDark: z.black, hcLight: "#F2F2F2" }, m(0, "Background color for code blocks in text.")), I("sash.hoverBorder", { dark: $o, light: $o, hcDark: $o, hcLight: $o }, m(0, "Border color of active sashes."));
const BC = I("badge.background", { dark: "#4D4D4D", light: "#C4C4C4", hcDark: z.black, hcLight: "#0F4A85" }, m(0, "Badge background color. Badges are small information labels, e.g. for search results count.")), p$ = I("badge.foreground", { dark: z.white, light: "#333", hcDark: z.white, hcLight: z.white }, m(0, "Badge foreground color. Badges are small information labels, e.g. for search results count.")), f_ = I("scrollbar.shadow", { dark: "#000000", light: "#DDDDDD", hcDark: null, hcLight: null }, m(0, "Scrollbar shadow to indicate that the view is scrolled.")), __ = I("scrollbarSlider.background", { dark: z.fromHex("#797979").transparent(0.4), light: z.fromHex("#646464").transparent(0.4), hcDark: Ce(ot, 0.6), hcLight: Ce(ot, 0.4) }, m(0, "Scrollbar slider background color.")), v_ = I("scrollbarSlider.hoverBackground", { dark: z.fromHex("#646464").transparent(0.7), light: z.fromHex("#646464").transparent(0.7), hcDark: Ce(ot, 0.8), hcLight: Ce(ot, 0.8) }, m(0, "Scrollbar slider background color when hovering.")), b_ = I("scrollbarSlider.activeBackground", { dark: z.fromHex("#BFBFBF").transparent(0.4), light: z.fromHex("#000000").transparent(0.6), hcDark: ot, hcLight: ot }, m(0, "Scrollbar slider background color when clicked on.")), m$ = I("progressBar.background", { dark: z.fromHex("#0E70C0"), light: z.fromHex("#0E70C0"), hcDark: ot, hcLight: ot }, m(0, "Background color of the progress bar that can show for long running operations.")), sn = I("editor.background", { light: "#ffffff", dark: "#1E1E1E", hcDark: z.black, hcLight: z.white }, m(0, "Editor background color.")), Go = I("editor.foreground", { light: "#333333", dark: "#BBBBBB", hcDark: z.white, hcLight: oe }, m(0, "Editor default foreground color."));
I("editorStickyScroll.background", { light: sn, dark: sn, hcDark: sn, hcLight: sn }, m(0, "Background color of sticky scroll in the editor")), I("editorStickyScrollHover.background", { dark: "#2A2D2E", light: "#F0F0F0", hcDark: null, hcLight: z.fromHex("#0F4A85").transparent(0.1) }, m(0, "Background color of sticky scroll on hover in the editor")), I("editorStickyScroll.border", { dark: null, light: null, hcDark: ot, hcLight: ot }, m(0, "Border color of sticky scroll in the editor")), I("editorStickyScroll.shadow", { dark: f_, light: f_, hcDark: f_, hcLight: f_ }, m(0, " Shadow color of sticky scroll in the editor"));
const xi = I("editorWidget.background", { dark: "#252526", light: "#F3F3F3", hcDark: "#0C141F", hcLight: z.white }, m(0, "Background color of editor widgets, such as find/replace.")), ld = I("editorWidget.foreground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "Foreground color of editor widgets, such as find/replace.")), dd = I("editorWidget.border", { dark: "#454545", light: "#C8C8C8", hcDark: ot, hcLight: ot }, m(0, "Border color of editor widgets. The color is only used if the widget chooses to have a border and if the color is not overridden by a widget."));
I("editorWidget.resizeBorder", { light: null, dark: null, hcDark: null, hcLight: null }, m(0, "Border color of the resize bar of editor widgets. The color is only used if the widget chooses to have a resize border and if the color is not overridden by a widget.")), I("editorError.background", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Background color of error text in the editor. The color must not be opaque so as not to hide underlying decorations."), !0);
const ol = I("editorError.foreground", { dark: "#F14C4C", light: "#E51400", hcDark: "#F48771", hcLight: "#B5200D" }, m(0, "Foreground color of error squigglies in the editor.")), f$ = I("editorError.border", { dark: null, light: null, hcDark: z.fromHex("#E47777").transparent(0.8), hcLight: "#B5200D" }, m(0, "If set, color of double underlines for errors in the editor.")), lb = I("editorWarning.background", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Background color of warning text in the editor. The color must not be opaque so as not to hide underlying decorations."), !0), Qn = I("editorWarning.foreground", { dark: "#CCA700", light: "#BF8803", hcDark: "#FFD370", hcLight: "#895503" }, m(0, "Foreground color of warning squigglies in the editor.")), gv = I("editorWarning.border", { dark: null, light: null, hcDark: z.fromHex("#FFCC00").transparent(0.8), hcLight: z.fromHex("#FFCC00").transparent(0.8) }, m(0, "If set, color of double underlines for warnings in the editor."));
I("editorInfo.background", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Background color of info text in the editor. The color must not be opaque so as not to hide underlying decorations."), !0);
const Rs = I("editorInfo.foreground", { dark: "#3794FF", light: "#1a85ff", hcDark: "#3794FF", hcLight: "#1a85ff" }, m(0, "Foreground color of info squigglies in the editor.")), pv = I("editorInfo.border", { dark: null, light: null, hcDark: z.fromHex("#3794FF").transparent(0.8), hcLight: "#292929" }, m(0, "If set, color of double underlines for infos in the editor.")), _$ = I("editorHint.foreground", { dark: z.fromHex("#eeeeee").transparent(0.7), light: "#6c6c6c", hcDark: null, hcLight: null }, m(0, "Foreground color of hint squigglies in the editor."));
I("editorHint.border", { dark: null, light: null, hcDark: z.fromHex("#eeeeee").transparent(0.8), hcLight: "#292929" }, m(0, "If set, color of double underlines for hints in the editor."));
const v$ = I("editorLink.activeForeground", { dark: "#4E94CE", light: z.blue, hcDark: z.cyan, hcLight: "#292929" }, m(0, "Color of active links.")), Th = I("editor.selectionBackground", { light: "#ADD6FF", dark: "#264F78", hcDark: "#f3f518", hcLight: "#0F4A85" }, m(0, "Color of the editor selection.")), b$ = I("editor.selectionForeground", { light: null, dark: null, hcDark: "#000000", hcLight: z.white }, m(0, "Color of the selected text for high contrast.")), hB = I("editor.inactiveSelectionBackground", { light: Ce(Th, 0.5), dark: Ce(Th, 0.5), hcDark: Ce(Th, 0.7), hcLight: Ce(Th, 0.5) }, m(0, "Color of the selection in an inactive editor. The color must not be opaque so as not to hide underlying decorations."), !0), OR = I("editor.selectionHighlightBackground", { light: I4(Th, sn, 0.3, 0.6), dark: I4(Th, sn, 0.3, 0.6), hcDark: null, hcLight: null }, m(0, "Color for regions with the same content as the selection. The color must not be opaque so as not to hide underlying decorations."), !0);
I("editor.selectionHighlightBorder", { light: null, dark: null, hcDark: Zt, hcLight: Zt }, m(0, "Border color for regions with the same content as the selection.")), I("editor.findMatchBackground", { light: "#A8AC94", dark: "#515C6A", hcDark: null, hcLight: null }, m(0, "Color of the current search match."));
const hd = I("editor.findMatchHighlightBackground", { light: "#EA5C0055", dark: "#EA5C0055", hcDark: null, hcLight: null }, m(0, "Color of the other search matches. The color must not be opaque so as not to hide underlying decorations."), !0);
I("editor.findRangeHighlightBackground", { dark: "#3a3d4166", light: "#b4b4b44d", hcDark: null, hcLight: null }, m(0, "Color of the range limiting the search. The color must not be opaque so as not to hide underlying decorations."), !0), I("editor.findMatchBorder", { light: null, dark: null, hcDark: Zt, hcLight: Zt }, m(0, "Border color of the current search match."));
const Rh = I("editor.findMatchHighlightBorder", { light: null, dark: null, hcDark: Zt, hcLight: Zt }, m(0, "Border color of the other search matches.")), C$ = I("editor.findRangeHighlightBorder", { dark: null, light: null, hcDark: Ce(Zt, 0.4), hcLight: Ce(Zt, 0.4) }, m(0, "Border color of the range limiting the search. The color must not be opaque so as not to hide underlying decorations."), !0);
I("editor.hoverHighlightBackground", { light: "#ADD6FF26", dark: "#264f7840", hcDark: "#ADD6FF26", hcLight: null }, m(0, "Highlight below the word for which a hover is shown. The color must not be opaque so as not to hide underlying decorations."), !0);
const ay = I("editorHoverWidget.background", { light: xi, dark: xi, hcDark: xi, hcLight: xi }, m(0, "Background color of the editor hover."));
I("editorHoverWidget.foreground", { light: ld, dark: ld, hcDark: ld, hcLight: ld }, m(0, "Foreground color of the editor hover."));
const cB = I("editorHoverWidget.border", { light: dd, dark: dd, hcDark: dd, hcLight: dd }, m(0, "Border color of the editor hover."));
I("editorHoverWidget.statusBarBackground", { dark: aa(ay, 0.2), light: Ig(ay, 0.05), hcDark: xi, hcLight: xi }, m(0, "Background color of the editor hover status bar."));
const cd = I("editorInlayHint.foreground", { dark: "#969696", light: "#969696", hcDark: z.white, hcLight: z.black }, m(0, "Foreground color of inline hints")), ud = I("editorInlayHint.background", { dark: Ce(BC, 0.1), light: Ce(BC, 0.1), hcDark: Ce(z.white, 0.1), hcLight: Ce(BC, 0.1) }, m(0, "Background color of inline hints")), w$ = I("editorInlayHint.typeForeground", { dark: cd, light: cd, hcDark: cd, hcLight: cd }, m(0, "Foreground color of inline hints for types")), y$ = I("editorInlayHint.typeBackground", { dark: ud, light: ud, hcDark: ud, hcLight: ud }, m(0, "Background color of inline hints for types")), S$ = I("editorInlayHint.parameterForeground", { dark: cd, light: cd, hcDark: cd, hcLight: cd }, m(0, "Foreground color of inline hints for parameters")), L$ = I("editorInlayHint.parameterBackground", { dark: ud, light: ud, hcDark: ud, hcLight: ud }, m(0, "Background color of inline hints for parameters")), db = I("editorLightBulb.foreground", { dark: "#FFCC00", light: "#DDB100", hcDark: "#FFCC00", hcLight: "#007ACC" }, m(0, "The color used for the lightbulb actions icon."));
I("editorLightBulbAutoFix.foreground", { dark: "#75BEFF", light: "#007ACC", hcDark: "#75BEFF", hcLight: "#007ACC" }, m(0, "The color used for the lightbulb auto fix actions icon.")), I("editorLightBulbAi.foreground", { dark: db, light: db, hcDark: db, hcLight: db }, m(0, "The color used for the lightbulb AI icon.")), I("editor.snippetTabstopHighlightBackground", { dark: new z(new ht(124, 124, 124, 0.3)), light: new z(new ht(10, 50, 100, 0.2)), hcDark: new z(new ht(124, 124, 124, 0.3)), hcLight: new z(new ht(10, 50, 100, 0.2)) }, m(0, "Highlight background color of a snippet tabstop.")), I("editor.snippetTabstopHighlightBorder", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Highlight border color of a snippet tabstop.")), I("editor.snippetFinalTabstopHighlightBackground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Highlight background color of the final tabstop of a snippet.")), I("editor.snippetFinalTabstopHighlightBorder", { dark: "#525252", light: new z(new ht(10, 50, 100, 0.5)), hcDark: "#525252", hcLight: "#292929" }, m(0, "Highlight border color of the final tabstop of a snippet."));
const YE = new z(new ht(155, 185, 85, 0.2)), XE = new z(new ht(255, 0, 0, 0.2)), k$ = I("diffEditor.insertedTextBackground", { dark: "#9ccc2c33", light: "#9ccc2c40", hcDark: null, hcLight: null }, m(0, "Background color for text that got inserted. The color must not be opaque so as not to hide underlying decorations."), !0), D$ = I("diffEditor.removedTextBackground", { dark: "#ff000033", light: "#ff000033", hcDark: null, hcLight: null }, m(0, "Background color for text that got removed. The color must not be opaque so as not to hide underlying decorations."), !0);
I("diffEditor.insertedLineBackground", { dark: YE, light: YE, hcDark: null, hcLight: null }, m(0, "Background color for lines that got inserted. The color must not be opaque so as not to hide underlying decorations."), !0), I("diffEditor.removedLineBackground", { dark: XE, light: XE, hcDark: null, hcLight: null }, m(0, "Background color for lines that got removed. The color must not be opaque so as not to hide underlying decorations."), !0), I("diffEditorGutter.insertedLineBackground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Background color for the margin where lines got inserted.")), I("diffEditorGutter.removedLineBackground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Background color for the margin where lines got removed."));
const x$ = I("diffEditorOverview.insertedForeground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Diff overview ruler foreground for inserted content.")), N$ = I("diffEditorOverview.removedForeground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Diff overview ruler foreground for removed content."));
I("diffEditor.insertedTextBorder", { dark: null, light: null, hcDark: "#33ff2eff", hcLight: "#374E06" }, m(0, "Outline color for the text that got inserted.")), I("diffEditor.removedTextBorder", { dark: null, light: null, hcDark: "#FF008F", hcLight: "#AD0707" }, m(0, "Outline color for text that got removed.")), I("diffEditor.border", { dark: null, light: null, hcDark: ot, hcLight: ot }, m(0, "Border color between the two text editors.")), I("diffEditor.diagonalFill", { dark: "#cccccc33", light: "#22222233", hcDark: null, hcLight: null }, m(0, "Color of the diff editor's diagonal fill. The diagonal fill is used in side-by-side diff views.")), I("diffEditor.unchangedRegionBackground", { dark: "sideBar.background", light: "sideBar.background", hcDark: "sideBar.background", hcLight: "sideBar.background" }, m(0, "The background color of unchanged blocks in the diff editor.")), I("diffEditor.unchangedRegionForeground", { dark: "foreground", light: "foreground", hcDark: "foreground", hcLight: "foreground" }, m(0, "The foreground color of unchanged blocks in the diff editor.")), I("diffEditor.unchangedCodeBackground", { dark: "#74747429", light: "#b8b8b829", hcDark: null, hcLight: null }, m(0, "The background color of unchanged code in the diff editor."));
const gd = I("widget.shadow", { dark: Ce(z.black, 0.36), light: Ce(z.black, 0.16), hcDark: null, hcLight: null }, m(0, "Shadow color of widgets such as find/replace inside the editor.")), uB = I("widget.border", { dark: null, light: null, hcDark: ot, hcLight: ot }, m(0, "Border color of widgets such as find/replace inside the editor.")), T4 = I("toolbar.hoverBackground", { dark: "#5a5d5e50", light: "#b8b8b850", hcDark: null, hcLight: null }, m(0, "Toolbar background when hovering over actions using the mouse"));
I("toolbar.hoverOutline", { dark: null, light: null, hcDark: Zt, hcLight: Zt }, m(0, "Toolbar outline when hovering over actions using the mouse")), I("toolbar.activeBackground", { dark: aa(T4, 0.1), light: Ig(T4, 0.1), hcDark: null, hcLight: null }, m(0, "Toolbar background when holding the mouse over actions"));
const E$ = I("breadcrumb.foreground", { light: Ce(oe, 0.8), dark: Ce(oe, 0.8), hcDark: Ce(oe, 0.8), hcLight: Ce(oe, 0.8) }, m(0, "Color of focused breadcrumb items.")), I$ = I("breadcrumb.background", { light: sn, dark: sn, hcDark: sn, hcLight: sn }, m(0, "Background color of breadcrumb items.")), R4 = I("breadcrumb.focusForeground", { light: Ig(oe, 0.2), dark: aa(oe, 0.1), hcDark: aa(oe, 0.1), hcLight: aa(oe, 0.1) }, m(0, "Color of focused breadcrumb items.")), M$ = I("breadcrumb.activeSelectionForeground", { light: Ig(oe, 0.2), dark: aa(oe, 0.1), hcDark: aa(oe, 0.1), hcLight: aa(oe, 0.1) }, m(0, "Color of selected breadcrumb items."));
I("breadcrumbPicker.background", { light: xi, dark: xi, hcDark: xi, hcLight: xi }, m(0, "Background color of breadcrumb item picker."));
const A4 = z.fromHex("#40C8AE").transparent(0.5), P4 = z.fromHex("#40A6FF").transparent(0.5), O4 = z.fromHex("#606060").transparent(0.4), br = 0.4, Ip = I("merge.currentHeaderBackground", { dark: A4, light: A4, hcDark: null, hcLight: null }, m(0, "Current header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
I("merge.currentContentBackground", { dark: Ce(Ip, br), light: Ce(Ip, br), hcDark: Ce(Ip, br), hcLight: Ce(Ip, br) }, m(0, "Current content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
const Mp = I("merge.incomingHeaderBackground", { dark: P4, light: P4, hcDark: null, hcLight: null }, m(0, "Incoming header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
I("merge.incomingContentBackground", { dark: Ce(Mp, br), light: Ce(Mp, br), hcDark: Ce(Mp, br), hcLight: Ce(Mp, br) }, m(0, "Incoming content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
const Tp = I("merge.commonHeaderBackground", { dark: O4, light: O4, hcDark: null, hcLight: null }, m(0, "Common ancestor header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
I("merge.commonContentBackground", { dark: Ce(Tp, br), light: Ce(Tp, br), hcDark: Ce(Tp, br), hcLight: Ce(Tp, br) }, m(0, "Common ancestor content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
const qg = I("merge.border", { dark: null, light: null, hcDark: "#C3DF6F", hcLight: "#007ACC" }, m(0, "Border color on headers and the splitter in inline merge-conflicts."));
I("editorOverviewRuler.currentContentForeground", { dark: Ce(Ip, 1), light: Ce(Ip, 1), hcDark: qg, hcLight: qg }, m(0, "Current overview ruler foreground for inline merge-conflicts.")), I("editorOverviewRuler.incomingContentForeground", { dark: Ce(Mp, 1), light: Ce(Mp, 1), hcDark: qg, hcLight: qg }, m(0, "Incoming overview ruler foreground for inline merge-conflicts.")), I("editorOverviewRuler.commonContentForeground", { dark: Ce(Tp, 1), light: Ce(Tp, 1), hcDark: qg, hcLight: qg }, m(0, "Common ancestor overview ruler foreground for inline merge-conflicts."));
const uD = I("editorOverviewRuler.findMatchForeground", { dark: "#d186167e", light: "#d186167e", hcDark: "#AB5A00", hcLight: "" }, m(0, "Overview ruler marker color for find matches. The color must not be opaque so as not to hide underlying decorations."), !0), C_ = I("editorOverviewRuler.selectionHighlightForeground", { dark: "#A0A0A0CC", light: "#A0A0A0CC", hcDark: "#A0A0A0CC", hcLight: "#A0A0A0CC" }, m(0, "Overview ruler marker color for selection highlights. The color must not be opaque so as not to hide underlying decorations."), !0), T$ = I("problemsErrorIcon.foreground", { dark: ol, light: ol, hcDark: ol, hcLight: ol }, m(0, "The color used for the problems error icon.")), R$ = I("problemsWarningIcon.foreground", { dark: Qn, light: Qn, hcDark: Qn, hcLight: Qn }, m(0, "The color used for the problems warning icon.")), A$ = I("problemsInfoIcon.foreground", { dark: Rs, light: Rs, hcDark: Rs, hcLight: Rs }, m(0, "The color used for the problems info icon.")), Rp = I("minimap.findMatchHighlight", { light: "#d18616", dark: "#d18616", hcDark: "#AB5A00", hcLight: "#0F4A85" }, m(0, "Minimap marker color for find matches."), !0), rL = I("minimap.selectionOccurrenceHighlight", { light: "#c9c9c9", dark: "#676767", hcDark: "#ffffff", hcLight: "#0F4A85" }, m(0, "Minimap marker color for repeating editor selections."), !0), F4 = I("minimap.selectionHighlight", { light: "#ADD6FF", dark: "#264F78", hcDark: "#ffffff", hcLight: "#0F4A85" }, m(0, "Minimap marker color for the editor selection."), !0), P$ = I("minimap.infoHighlight", { dark: Rs, light: Rs, hcDark: pv, hcLight: pv }, m(0, "Minimap marker color for infos.")), O$ = I("minimap.warningHighlight", { dark: Qn, light: Qn, hcDark: gv, hcLight: gv }, m(0, "Minimap marker color for warnings.")), F$ = I("minimap.errorHighlight", { dark: new z(new ht(255, 18, 18, 0.7)), light: new z(new ht(255, 18, 18, 0.7)), hcDark: new z(new ht(255, 50, 50, 1)), hcLight: "#B5200D" }, m(0, "Minimap marker color for errors.")), B$ = I("minimap.background", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Minimap background color.")), W$ = I("minimap.foregroundOpacity", { dark: z.fromHex("#000f"), light: z.fromHex("#000f"), hcDark: z.fromHex("#000f"), hcLight: z.fromHex("#000f") }, m(0, 'Opacity of foreground elements rendered in the minimap. For example, "#000000c0" will render the elements with 75% opacity.'));
I("minimapSlider.background", { light: Ce(__, 0.5), dark: Ce(__, 0.5), hcDark: Ce(__, 0.5), hcLight: Ce(__, 0.5) }, m(0, "Minimap slider background color.")), I("minimapSlider.hoverBackground", { light: Ce(v_, 0.5), dark: Ce(v_, 0.5), hcDark: Ce(v_, 0.5), hcLight: Ce(v_, 0.5) }, m(0, "Minimap slider background color when hovering.")), I("minimapSlider.activeBackground", { light: Ce(b_, 0.5), dark: Ce(b_, 0.5), hcDark: Ce(b_, 0.5), hcLight: Ce(b_, 0.5) }, m(0, "Minimap slider background color when clicked on.")), I("charts.foreground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color used in charts.")), I("charts.lines", { dark: Ce(oe, 0.5), light: Ce(oe, 0.5), hcDark: Ce(oe, 0.5), hcLight: Ce(oe, 0.5) }, m(0, "The color used for horizontal lines in charts.")), I("charts.red", { dark: ol, light: ol, hcDark: ol, hcLight: ol }, m(0, "The red color used in chart visualizations.")), I("charts.blue", { dark: Rs, light: Rs, hcDark: Rs, hcLight: Rs }, m(0, "The blue color used in chart visualizations.")), I("charts.yellow", { dark: Qn, light: Qn, hcDark: Qn, hcLight: Qn }, m(0, "The yellow color used in chart visualizations.")), I("charts.orange", { dark: Rp, light: Rp, hcDark: Rp, hcLight: Rp }, m(0, "The orange color used in chart visualizations.")), I("charts.green", { dark: "#89D185", light: "#388A34", hcDark: "#89D185", hcLight: "#374e06" }, m(0, "The green color used in chart visualizations.")), I("charts.purple", { dark: "#B180D7", light: "#652D90", hcDark: "#B180D7", hcLight: "#652D90" }, m(0, "The purple color used in chart visualizations."));
const gB = I("input.background", { dark: "#3C3C3C", light: z.white, hcDark: z.black, hcLight: z.white }, m(0, "Input box background.")), pB = I("input.foreground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "Input box foreground.")), mB = I("input.border", { dark: null, light: null, hcDark: ot, hcLight: ot }, m(0, "Input box border.")), FR = I("inputOption.activeBorder", { dark: "#007ACC", light: "#007ACC", hcDark: ot, hcLight: ot }, m(0, "Border color of activated options in input fields."));
I("inputOption.hoverBackground", { dark: "#5a5d5e80", light: "#b8b8b850", hcDark: null, hcLight: null }, m(0, "Background color of activated options in input fields."));
const Iu = I("inputOption.activeBackground", { dark: Ce($o, 0.4), light: Ce($o, 0.2), hcDark: z.transparent, hcLight: z.transparent }, m(0, "Background hover color of options in input fields.")), BR = I("inputOption.activeForeground", { dark: z.white, light: z.black, hcDark: oe, hcLight: oe }, m(0, "Foreground color of activated options in input fields."));
I("input.placeholderForeground", { light: Ce(oe, 0.5), dark: Ce(oe, 0.5), hcDark: Ce(oe, 0.7), hcLight: Ce(oe, 0.7) }, m(0, "Input box foreground color for placeholder text."));
const V$ = I("inputValidation.infoBackground", { dark: "#063B49", light: "#D6ECF2", hcDark: z.black, hcLight: z.white }, m(0, "Input validation background color for information severity.")), H$ = I("inputValidation.infoForeground", { dark: null, light: null, hcDark: null, hcLight: oe }, m(0, "Input validation foreground color for information severity.")), z$ = I("inputValidation.infoBorder", { dark: "#007acc", light: "#007acc", hcDark: ot, hcLight: ot }, m(0, "Input validation border color for information severity.")), U$ = I("inputValidation.warningBackground", { dark: "#352A05", light: "#F6F5D2", hcDark: z.black, hcLight: z.white }, m(0, "Input validation background color for warning severity.")), K$ = I("inputValidation.warningForeground", { dark: null, light: null, hcDark: null, hcLight: oe }, m(0, "Input validation foreground color for warning severity.")), j$ = I("inputValidation.warningBorder", { dark: "#B89500", light: "#B89500", hcDark: ot, hcLight: ot }, m(0, "Input validation border color for warning severity.")), q$ = I("inputValidation.errorBackground", { dark: "#5A1D1D", light: "#F2DEDE", hcDark: z.black, hcLight: z.white }, m(0, "Input validation background color for error severity.")), $$ = I("inputValidation.errorForeground", { dark: null, light: null, hcDark: null, hcLight: oe }, m(0, "Input validation foreground color for error severity.")), G$ = I("inputValidation.errorBorder", { dark: "#BE1100", light: "#BE1100", hcDark: ot, hcLight: ot }, m(0, "Input validation border color for error severity.")), rl = I("dropdown.background", { dark: "#3C3C3C", light: z.white, hcDark: z.black, hcLight: z.white }, m(0, "Dropdown background.")), Z$ = I("dropdown.listBackground", { dark: null, light: null, hcDark: z.black, hcLight: z.white }, m(0, "Dropdown list background.")), pd = I("dropdown.foreground", { dark: "#F0F0F0", light: oe, hcDark: z.white, hcLight: oe }, m(0, "Dropdown foreground.")), Ap = I("dropdown.border", { dark: rl, light: "#CECECE", hcDark: ot, hcLight: ot }, m(0, "Dropdown border.")), w_ = I("button.foreground", { dark: z.white, light: z.white, hcDark: z.white, hcLight: z.white }, m(0, "Button foreground color.")), Y$ = I("button.separator", { dark: Ce(w_, 0.4), light: Ce(w_, 0.4), hcDark: Ce(w_, 0.4), hcLight: Ce(w_, 0.4) }, m(0, "Button separator color.")), y_ = I("button.background", { dark: "#0E639C", light: "#007ACC", hcDark: null, hcLight: "#0F4A85" }, m(0, "Button background color.")), X$ = I("button.hoverBackground", { dark: aa(y_, 0.2), light: Ig(y_, 0.2), hcDark: y_, hcLight: y_ }, m(0, "Button background color when hovering.")), Q$ = I("button.border", { dark: ot, light: ot, hcDark: ot, hcLight: ot }, m(0, "Button border color.")), J$ = I("button.secondaryForeground", { dark: z.white, light: z.white, hcDark: z.white, hcLight: oe }, m(0, "Secondary button foreground color.")), QE = I("button.secondaryBackground", { dark: "#3A3D41", light: "#5F6A79", hcDark: null, hcLight: z.white }, m(0, "Secondary button background color.")), eG = I("button.secondaryHoverBackground", { dark: aa(QE, 0.2), light: Ig(QE, 0.2), hcDark: null, hcLight: null }, m(0, "Secondary button background color when hovering.")), tG = I("checkbox.background", { dark: rl, light: rl, hcDark: rl, hcLight: rl }, m(0, "Background color of checkbox widget."));
I("checkbox.selectBackground", { dark: xi, light: xi, hcDark: xi, hcLight: xi }, m(0, "Background color of checkbox widget when the element it's in is selected."));
const iG = I("checkbox.foreground", { dark: pd, light: pd, hcDark: pd, hcLight: pd }, m(0, "Foreground color of checkbox widget.")), nG = I("checkbox.border", { dark: Ap, light: Ap, hcDark: Ap, hcLight: Ap }, m(0, "Border color of checkbox widget."));
I("checkbox.selectBorder", { dark: sl, light: sl, hcDark: sl, hcLight: sl }, m(0, "Border color of checkbox widget when the element it's in is selected."));
const sG = I("keybindingLabel.background", { dark: new z(new ht(128, 128, 128, 0.17)), light: new z(new ht(221, 221, 221, 0.4)), hcDark: z.transparent, hcLight: z.transparent }, m(0, "Keybinding label background color. The keybinding label is used to represent a keyboard shortcut.")), oG = I("keybindingLabel.foreground", { dark: z.fromHex("#CCCCCC"), light: z.fromHex("#555555"), hcDark: z.white, hcLight: oe }, m(0, "Keybinding label foreground color. The keybinding label is used to represent a keyboard shortcut.")), rG = I("keybindingLabel.border", { dark: new z(new ht(51, 51, 51, 0.6)), light: new z(new ht(204, 204, 204, 0.4)), hcDark: new z(new ht(111, 195, 223)), hcLight: ot }, m(0, "Keybinding label border color. The keybinding label is used to represent a keyboard shortcut.")), aG = I("keybindingLabel.bottomBorder", { dark: new z(new ht(68, 68, 68, 0.6)), light: new z(new ht(187, 187, 187, 0.4)), hcDark: new z(new ht(111, 195, 223)), hcLight: oe }, m(0, "Keybinding label border bottom color. The keybinding label is used to represent a keyboard shortcut.")), lG = I("list.focusBackground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "List/Tree background color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), dG = I("list.focusForeground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "List/Tree foreground color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), hG = I("list.focusOutline", { dark: $o, light: $o, hcDark: Zt, hcLight: Zt }, m(0, "List/Tree outline color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), cG = I("list.focusAndSelectionOutline", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "List/Tree outline color for the focused item when the list/tree is active and selected. An active list/tree has keyboard focus, an inactive does not.")), md = I("list.activeSelectionBackground", { dark: "#04395E", light: "#0060C0", hcDark: null, hcLight: z.fromHex("#0F4A85").transparent(0.1) }, m(0, "List/Tree background color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), al = I("list.activeSelectionForeground", { dark: z.white, light: z.white, hcDark: null, hcLight: null }, m(0, "List/Tree foreground color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), S_ = I("list.activeSelectionIconForeground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "List/Tree icon foreground color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), uG = I("list.inactiveSelectionBackground", { dark: "#37373D", light: "#E4E6F1", hcDark: null, hcLight: z.fromHex("#0F4A85").transparent(0.1) }, m(0, "List/Tree background color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.")), gG = I("list.inactiveSelectionForeground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "List/Tree foreground color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.")), pG = I("list.inactiveSelectionIconForeground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "List/Tree icon foreground color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.")), mG = I("list.inactiveFocusBackground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "List/Tree background color for the focused item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.")), fG = I("list.inactiveFocusOutline", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "List/Tree outline color for the focused item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.")), fB = I("list.hoverBackground", { dark: "#2A2D2E", light: "#F0F0F0", hcDark: z.white.transparent(0.1), hcLight: z.fromHex("#0F4A85").transparent(0.1) }, m(0, "List/Tree background when hovering over items using the mouse.")), _B = I("list.hoverForeground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "List/Tree foreground when hovering over items using the mouse.")), _G = I("list.dropBackground", { dark: "#062F4A", light: "#D6EBFF", hcDark: null, hcLight: null }, m(0, "List/Tree drag and drop background when moving items over other items when using the mouse.")), vG = I("list.dropBetweenBackground", { dark: sl, light: sl, hcDark: null, hcLight: null }, m(0, "List/Tree drag and drop border color when moving items between items when using the mouse.")), Cr = I("list.highlightForeground", { dark: "#2AAAFF", light: "#0066BF", hcDark: $o, hcLight: $o }, m(0, "List/Tree foreground color of the match highlights when searching inside the list/tree.")), hb = I("list.focusHighlightForeground", { dark: Cr, light: (B4 = md, W4 = Cr, V4 = "#BBE7FF", { op: 6, if: B4, then: W4, else: V4 }), hcDark: Cr, hcLight: Cr }, m(0, "List/Tree foreground color of the match highlights on actively focused items when searching inside the list/tree."));
var B4, W4, V4;
I("list.invalidItemForeground", { dark: "#B89500", light: "#B89500", hcDark: "#B89500", hcLight: "#B5200D" }, m(0, "List/Tree foreground color for invalid items, for example an unresolved root in explorer.")), I("list.errorForeground", { dark: "#F88070", light: "#B01011", hcDark: null, hcLight: null }, m(0, "Foreground color of list items containing errors.")), I("list.warningForeground", { dark: "#CCA700", light: "#855F00", hcDark: null, hcLight: null }, m(0, "Foreground color of list items containing warnings."));
const bG = I("listFilterWidget.background", { light: Ig(xi, 0), dark: aa(xi, 0), hcDark: xi, hcLight: xi }, m(0, "Background color of the type filter widget in lists and trees.")), CG = I("listFilterWidget.outline", { dark: z.transparent, light: z.transparent, hcDark: "#f38518", hcLight: "#007ACC" }, m(0, "Outline color of the type filter widget in lists and trees.")), wG = I("listFilterWidget.noMatchesOutline", { dark: "#BE1100", light: "#BE1100", hcDark: ot, hcLight: ot }, m(0, "Outline color of the type filter widget in lists and trees, when there are no matches.")), yG = I("listFilterWidget.shadow", { dark: gd, light: gd, hcDark: gd, hcLight: gd }, m(0, "Shadow color of the type filter widget in lists and trees."));
I("list.filterMatchBackground", { dark: hd, light: hd, hcDark: null, hcLight: null }, m(0, "Background color of the filtered match.")), I("list.filterMatchBorder", { dark: Rh, light: Rh, hcDark: ot, hcLight: Zt }, m(0, "Border color of the filtered match.")), I("list.deemphasizedForeground", { dark: "#8C8C8C", light: "#8E8E90", hcDark: "#A7A8A9", hcLight: "#666666" }, m(0, "List/Tree foreground color for items that are deemphasized."));
const L_ = I("tree.indentGuidesStroke", { dark: "#585858", light: "#a9a9a9", hcDark: "#a9a9a9", hcLight: "#a5a5a5" }, m(0, "Tree stroke color for the indentation guides.")), SG = I("tree.inactiveIndentGuidesStroke", { dark: Ce(L_, 0.4), light: Ce(L_, 0.4), hcDark: Ce(L_, 0.4), hcLight: Ce(L_, 0.4) }, m(0, "Tree stroke color for the indentation guides that are not active.")), LG = I("tree.tableColumnsBorder", { dark: "#CCCCCC20", light: "#61616120", hcDark: null, hcLight: null }, m(0, "Table border color between columns.")), kG = I("tree.tableOddRowsBackground", { dark: Ce(oe, 0.04), light: Ce(oe, 0.04), hcDark: null, hcLight: null }, m(0, "Background color for odd table rows.")), DG = I("menu.border", { dark: null, light: null, hcDark: ot, hcLight: ot }, m(0, "Border color of menus.")), xG = I("menu.foreground", { dark: pd, light: pd, hcDark: pd, hcLight: pd }, m(0, "Foreground color of menu items.")), NG = I("menu.background", { dark: rl, light: rl, hcDark: rl, hcLight: rl }, m(0, "Background color of menu items.")), EG = I("menu.selectionForeground", { dark: al, light: al, hcDark: al, hcLight: al }, m(0, "Foreground color of the selected menu item in menus.")), IG = I("menu.selectionBackground", { dark: md, light: md, hcDark: md, hcLight: md }, m(0, "Background color of the selected menu item in menus.")), MG = I("menu.selectionBorder", { dark: null, light: null, hcDark: Zt, hcLight: Zt }, m(0, "Border color of the selected menu item in menus.")), TG = I("menu.separatorBackground", { dark: "#606060", light: "#D4D4D4", hcDark: ot, hcLight: ot }, m(0, "Color of a separator menu item in menus.")), H4 = I("quickInput.background", { dark: xi, light: xi, hcDark: xi, hcLight: xi }, m(0, "Quick picker background color. The quick picker widget is the container for pickers like the command palette.")), RG = I("quickInput.foreground", { dark: ld, light: ld, hcDark: ld, hcLight: ld }, m(0, "Quick picker foreground color. The quick picker widget is the container for pickers like the command palette.")), AG = I("quickInputTitle.background", { dark: new z(new ht(255, 255, 255, 0.105)), light: new z(new ht(0, 0, 0, 0.06)), hcDark: "#000000", hcLight: z.white }, m(0, "Quick picker title background color. The quick picker widget is the container for pickers like the command palette.")), vB = I("pickerGroup.foreground", { dark: "#3794FF", light: "#0066BF", hcDark: z.white, hcLight: "#0F4A85" }, m(0, "Quick picker color for grouping labels.")), PG = I("pickerGroup.border", { dark: "#3F3F46", light: "#CCCEDB", hcDark: z.white, hcLight: "#0F4A85" }, m(0, "Quick picker color for grouping borders.")), z4 = I("quickInput.list.focusBackground", { dark: null, light: null, hcDark: null, hcLight: null }, "", void 0, m(0, "Please use quickInputList.focusBackground instead")), Ah = I("quickInputList.focusForeground", { dark: al, light: al, hcDark: al, hcLight: al }, m(0, "Quick picker foreground color for the focused item.")), Pp = I("quickInputList.focusIconForeground", { dark: S_, light: S_, hcDark: S_, hcLight: S_ }, m(0, "Quick picker icon foreground color for the focused item.")), Ph = I("quickInputList.focusBackground", { dark: uv(z4, md), light: uv(z4, md), hcDark: null, hcLight: null }, m(0, "Quick picker background color for the focused item."));
I("search.resultsInfoForeground", { light: oe, dark: Ce(oe, 0.65), hcDark: oe, hcLight: oe }, m(0, "Color of the text in the search viewlet's completion message.")), I("searchEditor.findMatchBackground", { light: Ce(hd, 0.66), dark: Ce(hd, 0.66), hcDark: hd, hcLight: hd }, m(0, "Color of the Search Editor query matches.")), I("searchEditor.findMatchBorder", { light: Ce(Rh, 0.66), dark: Ce(Rh, 0.66), hcDark: Rh, hcLight: Rh }, m(0, "Border color of the Search Editor query matches."));
class aL {
  constructor(e, t) {
    this.x = e, this.y = t, this._pageCoordinatesBrand = void 0;
  }
  toClientCoordinates(e) {
    return new bB(this.x - e.scrollX, this.y - e.scrollY);
  }
}
class bB {
  constructor(e, t) {
    this.clientX = e, this.clientY = t, this._clientCoordinatesBrand = void 0;
  }
  toPageCoordinates(e) {
    return new aL(this.clientX + e.scrollX, this.clientY + e.scrollY);
  }
}
class OG {
  constructor(e, t, n, s) {
    this.x = e, this.y = t, this.width = n, this.height = s, this._editorPagePositionBrand = void 0;
  }
}
class FG {
  constructor(e, t) {
    this.x = e, this.y = t, this._positionRelativeToEditorBrand = void 0;
  }
}
function WR(i) {
  const e = Ti(i);
  return new OG(e.left, e.top, e.width, e.height);
}
function VR(i, e, t) {
  const n = e.width / i.offsetWidth, s = e.height / i.offsetHeight, o = (t.x - e.x) / n, r = (t.y - e.y) / s;
  return new FG(o, r);
}
class kc extends _r {
  constructor(e, t, n) {
    super(ke(n), e), this._editorMouseEventBrand = void 0, this.isFromPointerCapture = t, this.pos = new aL(this.posx, this.posy), this.editorPos = WR(n), this.relativePos = VR(n, this.editorPos, this.pos);
  }
}
class BG {
  constructor(e) {
    this._editorViewDomNode = e;
  }
  _create(e) {
    return new kc(e, !1, this._editorViewDomNode);
  }
  onContextMenu(e, t) {
    return K(e, "contextmenu", (n) => {
      t(this._create(n));
    });
  }
  onMouseUp(e, t) {
    return K(e, "mouseup", (n) => {
      t(this._create(n));
    });
  }
  onMouseDown(e, t) {
    return K(e, ie.MOUSE_DOWN, (n) => {
      t(this._create(n));
    });
  }
  onPointerDown(e, t) {
    return K(e, ie.POINTER_DOWN, (n) => {
      t(this._create(n), n.pointerId);
    });
  }
  onMouseLeave(e, t) {
    return K(e, ie.MOUSE_LEAVE, (n) => {
      t(this._create(n));
    });
  }
  onMouseMove(e, t) {
    return K(e, "mousemove", (n) => t(this._create(n)));
  }
}
class WG {
  constructor(e) {
    this._editorViewDomNode = e;
  }
  _create(e) {
    return new kc(e, !1, this._editorViewDomNode);
  }
  onPointerUp(e, t) {
    return K(e, "pointerup", (n) => {
      t(this._create(n));
    });
  }
  onPointerDown(e, t) {
    return K(e, ie.POINTER_DOWN, (n) => {
      t(this._create(n), n.pointerId);
    });
  }
  onPointerLeave(e, t) {
    return K(e, ie.POINTER_LEAVE, (n) => {
      t(this._create(n));
    });
  }
  onPointerMove(e, t) {
    return K(e, "pointermove", (n) => t(this._create(n)));
  }
}
class VG extends V {
  constructor(e) {
    super(), this._editorViewDomNode = e, this._globalPointerMoveMonitor = this._register(new vf()), this._keydownListener = null;
  }
  startMonitoring(e, t, n, s, o) {
    this._keydownListener = bi(e.ownerDocument, "keydown", (r) => {
      r.toKeyCodeChord().isModifierKey() || this._globalPointerMoveMonitor.stopMonitoring(!0, r.browserEvent);
    }, !0), this._globalPointerMoveMonitor.startMonitoring(e, t, n, (r) => {
      s(new kc(r, !0, this._editorViewDomNode));
    }, (r) => {
      this._keydownListener.dispose(), o(r);
    });
  }
  stopMonitoring() {
    this._globalPointerMoveMonitor.stopMonitoring(!0);
  }
}
class S1 {
  constructor(e) {
    this._editor = e, this._instanceId = ++S1._idPool, this._counter = 0, this._rules = /* @__PURE__ */ new Map(), this._garbageCollectionScheduler = new It(() => this.garbageCollect(), 1e3);
  }
  createClassNameRef(e) {
    const t = this.getOrCreateRule(e);
    return t.increaseRefCount(), { className: t.className, dispose: () => {
      t.decreaseRefCount(), this._garbageCollectionScheduler.schedule();
    } };
  }
  getOrCreateRule(e) {
    const t = this.computeUniqueKey(e);
    let n = this._rules.get(t);
    if (!n) {
      const s = this._counter++;
      n = new HG(t, `dyn-rule-${this._instanceId}-${s}`, $w(this._editor.getContainerDomNode()) ? this._editor.getContainerDomNode() : void 0, e), this._rules.set(t, n);
    }
    return n;
  }
  computeUniqueKey(e) {
    return JSON.stringify(e);
  }
  garbageCollect() {
    for (const e of this._rules.values()) e.hasReferences() || (this._rules.delete(e.key), e.dispose());
  }
}
S1._idPool = 0;
class HG {
  constructor(e, t, n, s) {
    this.key = e, this.className = t, this.properties = s, this._referenceCount = 0, this._styleElementDisposables = new G(), this._styleElement = Lo(n, void 0, this._styleElementDisposables), this._styleElement.textContent = this.getCssText(this.className, this.properties);
  }
  getCssText(e, t) {
    let n = `.${e} {`;
    for (const s in t) {
      const o = t[s];
      let r;
      r = typeof o == "object" ? de(o.id) : o, n += `
	${zG(s)}: ${r};`;
    }
    return n += `
}`, n;
  }
  dispose() {
    this._styleElementDisposables.dispose(), this._styleElement = void 0;
  }
  increaseRefCount() {
    this._referenceCount++;
  }
  decreaseRefCount() {
    this._referenceCount--;
  }
  hasReferences() {
    return this._referenceCount > 0;
  }
}
function zG(i) {
  return i.replace(/(^[A-Z])/, ([e]) => e.toLowerCase()).replace(/([A-Z])/g, ([e]) => `-${e.toLowerCase()}`);
}
class L1 extends V {
  constructor() {
    super(), this._shouldRender = !0;
  }
  shouldRender() {
    return this._shouldRender;
  }
  forceShouldRender() {
    this._shouldRender = !0;
  }
  setShouldRender() {
    this._shouldRender = !0;
  }
  onDidRender() {
    this._shouldRender = !1;
  }
  onCompositionStart(e) {
    return !1;
  }
  onCompositionEnd(e) {
    return !1;
  }
  onConfigurationChanged(e) {
    return !1;
  }
  onCursorStateChanged(e) {
    return !1;
  }
  onDecorationsChanged(e) {
    return !1;
  }
  onFlushed(e) {
    return !1;
  }
  onFocusChanged(e) {
    return !1;
  }
  onLanguageConfigurationChanged(e) {
    return !1;
  }
  onLineMappingChanged(e) {
    return !1;
  }
  onLinesChanged(e) {
    return !1;
  }
  onLinesDeleted(e) {
    return !1;
  }
  onLinesInserted(e) {
    return !1;
  }
  onRevealRangeRequest(e) {
    return !1;
  }
  onScrollChanged(e) {
    return !1;
  }
  onThemeChanged(e) {
    return !1;
  }
  onTokensChanged(e) {
    return !1;
  }
  onTokensColorsChanged(e) {
    return !1;
  }
  onZonesChanged(e) {
    return !1;
  }
  handleEvents(e) {
    let t = !1;
    for (let n = 0, s = e.length; n < s; n++) {
      const o = e[n];
      switch (o.type) {
        case 0:
          this.onCompositionStart(o) && (t = !0);
          break;
        case 1:
          this.onCompositionEnd(o) && (t = !0);
          break;
        case 2:
          this.onConfigurationChanged(o) && (t = !0);
          break;
        case 3:
          this.onCursorStateChanged(o) && (t = !0);
          break;
        case 4:
          this.onDecorationsChanged(o) && (t = !0);
          break;
        case 5:
          this.onFlushed(o) && (t = !0);
          break;
        case 6:
          this.onFocusChanged(o) && (t = !0);
          break;
        case 7:
          this.onLanguageConfigurationChanged(o) && (t = !0);
          break;
        case 8:
          this.onLineMappingChanged(o) && (t = !0);
          break;
        case 9:
          this.onLinesChanged(o) && (t = !0);
          break;
        case 10:
          this.onLinesDeleted(o) && (t = !0);
          break;
        case 11:
          this.onLinesInserted(o) && (t = !0);
          break;
        case 12:
          this.onRevealRangeRequest(o) && (t = !0);
          break;
        case 13:
          this.onScrollChanged(o) && (t = !0);
          break;
        case 15:
          this.onTokensChanged(o) && (t = !0);
          break;
        case 14:
          this.onThemeChanged(o) && (t = !0);
          break;
        case 16:
          this.onTokensColorsChanged(o) && (t = !0);
          break;
        case 17:
          this.onZonesChanged(o) && (t = !0);
          break;
        default:
          console.info("View received unknown event: "), console.info(o);
      }
    }
    t && (this._shouldRender = !0);
  }
}
class to extends L1 {
  constructor(e) {
    super(), this._context = e, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), super.dispose();
  }
}
class _a {
  static write(e, t) {
    e.setAttribute("data-mprt", String(t));
  }
  static read(e) {
    const t = e.getAttribute("data-mprt");
    return t === null ? 0 : parseInt(t, 10);
  }
  static collect(e, t) {
    const n = [];
    let s = 0;
    for (; e && e !== e.ownerDocument.body && e !== t; ) e.nodeType === e.ELEMENT_NODE && (n[s++] = this.read(e)), e = e.parentElement;
    const o = new Uint8Array(s);
    for (let r = 0; r < s; r++) o[r] = n[s - r - 1];
    return o;
  }
}
class UG {
  constructor(e, t) {
    this._restrictedRenderingContextBrand = void 0, this._viewLayout = e, this.viewportData = t, this.scrollWidth = this._viewLayout.getScrollWidth(), this.scrollHeight = this._viewLayout.getScrollHeight(), this.visibleRange = this.viewportData.visibleRange, this.bigNumbersDelta = this.viewportData.bigNumbersDelta;
    const n = this._viewLayout.getCurrentViewport();
    this.scrollTop = n.top, this.scrollLeft = n.left, this.viewportWidth = n.width, this.viewportHeight = n.height;
  }
  getScrolledTopFromAbsoluteTop(e) {
    return e - this.scrollTop;
  }
  getVerticalOffsetForLineNumber(e, t) {
    return this._viewLayout.getVerticalOffsetForLineNumber(e, t);
  }
  getVerticalOffsetAfterLineNumber(e, t) {
    return this._viewLayout.getVerticalOffsetAfterLineNumber(e, t);
  }
  getDecorationsInViewport() {
    return this.viewportData.getDecorationsInViewport();
  }
}
class KG extends UG {
  constructor(e, t, n) {
    super(e, t), this._renderingContextBrand = void 0, this._viewLines = n;
  }
  linesVisibleRangesForRange(e, t) {
    return this._viewLines.linesVisibleRangesForRange(e, t);
  }
  visibleRangeForPosition(e) {
    return this._viewLines.visibleRangeForPosition(e);
  }
}
class jG {
  constructor(e, t, n, s) {
    this.outsideRenderedLine = e, this.lineNumber = t, this.ranges = n, this.continuesOnNextLine = s;
  }
}
class lL {
  static from(e) {
    const t = new Array(e.length);
    for (let n = 0, s = e.length; n < s; n++) {
      const o = e[n];
      t[n] = new lL(o.left, o.width);
    }
    return t;
  }
  constructor(e, t) {
    this._horizontalRangeBrand = void 0, this.left = Math.round(e), this.width = Math.round(t);
  }
  toString() {
    return `[${this.left},${this.width}]`;
  }
}
class ju {
  constructor(e, t) {
    this._floatHorizontalRangeBrand = void 0, this.left = e, this.width = t;
  }
  toString() {
    return `[${this.left},${this.width}]`;
  }
  static compare(e, t) {
    return e.left - t.left;
  }
}
class qG {
  constructor(e, t) {
    this.outsideRenderedLine = e, this.originalLeft = t, this.left = Math.round(this.originalLeft);
  }
}
class U4 {
  constructor(e, t) {
    this.outsideRenderedLine = e, this.ranges = t;
  }
}
class WC {
  static _createRange() {
    return this._handyReadyRange || (this._handyReadyRange = document.createRange()), this._handyReadyRange;
  }
  static _detachRange(e, t) {
    e.selectNodeContents(t);
  }
  static _readClientRects(e, t, n, s, o) {
    const r = this._createRange();
    try {
      return r.setStart(e, t), r.setEnd(n, s), r.getClientRects();
    } catch {
      return null;
    } finally {
      this._detachRange(r, o);
    }
  }
  static _mergeAdjacentRanges(e) {
    if (e.length === 1) return e;
    e.sort(ju.compare);
    const t = [];
    let n = 0, s = e[0];
    for (let o = 1, r = e.length; o < r; o++) {
      const a = e[o];
      s.left + s.width + 0.9 >= a.left ? s.width = Math.max(s.width, a.left + a.width - s.left) : (t[n++] = s, s = a);
    }
    return t[n++] = s, t;
  }
  static _createHorizontalRangesFromClientRects(e, t, n) {
    if (!e || e.length === 0) return null;
    const s = [];
    for (let o = 0, r = e.length; o < r; o++) {
      const a = e[o];
      s[o] = new ju(Math.max(0, (a.left - t) / n), a.width / n);
    }
    return this._mergeAdjacentRanges(s);
  }
  static readHorizontalRanges(e, t, n, s, o, r) {
    const a = e.children.length - 1;
    if (0 > a) return null;
    if ((t = Math.min(a, Math.max(0, t))) === (s = Math.min(a, Math.max(0, s))) && n === o && n === 0 && !e.children[t].firstChild) {
      const c = e.children[t].getClientRects();
      return r.markDidDomLayout(), this._createHorizontalRangesFromClientRects(c, r.clientRectDeltaLeft, r.clientRectScale);
    }
    t !== s && s > 0 && o === 0 && (s--, o = 1073741824);
    let l = e.children[t].firstChild, d = e.children[s].firstChild;
    if (l && d || (!l && n === 0 && t > 0 && (l = e.children[t - 1].firstChild, n = 1073741824), !d && o === 0 && s > 0 && (d = e.children[s - 1].firstChild, o = 1073741824)), !l || !d) return null;
    n = Math.min(l.textContent.length, Math.max(0, n)), o = Math.min(d.textContent.length, Math.max(0, o));
    const h = this._readClientRects(l, n, d, o, r.endNode);
    return r.markDidDomLayout(), this._createHorizontalRangesFromClientRects(h, r.clientRectDeltaLeft, r.clientRectScale);
  }
}
var Zo;
function la(i) {
  return i === Zo.HIGH_CONTRAST_DARK || i === Zo.HIGH_CONTRAST_LIGHT;
}
function Km(i) {
  return i === Zo.DARK || i === Zo.HIGH_CONTRAST_DARK;
}
(function(i) {
  i.DARK = "dark", i.LIGHT = "light", i.HIGH_CONTRAST_DARK = "hcDark", i.HIGH_CONTRAST_LIGHT = "hcLight";
})(Zo || (Zo = {}));
const $G = !!sa || !(Cs || tr || vc);
let t0 = !0;
class K4 {
  constructor(e, t) {
    this.themeType = t;
    const n = e.options, s = n.get(50), o = n.get(38);
    this.renderWhitespace = o === "off" ? n.get(99) : "none", this.renderControlCharacters = n.get(94), this.spaceWidth = s.spaceWidth, this.middotWidth = s.middotWidth, this.wsmiddotWidth = s.wsmiddotWidth, this.useMonospaceOptimizations = s.isMonospace && !n.get(33), this.canUseHalfwidthRightwardsArrow = s.canUseHalfwidthRightwardsArrow, this.lineHeight = n.get(67), this.stopRenderingLineAfter = n.get(117), this.fontLigatures = n.get(51);
  }
  equals(e) {
    return this.themeType === e.themeType && this.renderWhitespace === e.renderWhitespace && this.renderControlCharacters === e.renderControlCharacters && this.spaceWidth === e.spaceWidth && this.middotWidth === e.middotWidth && this.wsmiddotWidth === e.wsmiddotWidth && this.useMonospaceOptimizations === e.useMonospaceOptimizations && this.canUseHalfwidthRightwardsArrow === e.canUseHalfwidthRightwardsArrow && this.lineHeight === e.lineHeight && this.stopRenderingLineAfter === e.stopRenderingLineAfter && this.fontLigatures === e.fontLigatures;
  }
}
class Ga {
  constructor(e) {
    this._options = e, this._isMaybeInvalid = !0, this._renderedViewLine = null;
  }
  getDomNode() {
    return this._renderedViewLine && this._renderedViewLine.domNode ? this._renderedViewLine.domNode.domNode : null;
  }
  setDomNode(e) {
    if (!this._renderedViewLine) throw new Error("I have no rendered view line to set the dom node to...");
    this._renderedViewLine.domNode = wt(e);
  }
  onContentChanged() {
    this._isMaybeInvalid = !0;
  }
  onTokensChanged() {
    this._isMaybeInvalid = !0;
  }
  onDecorationsChanged() {
    this._isMaybeInvalid = !0;
  }
  onOptionsChanged(e) {
    this._isMaybeInvalid = !0, this._options = e;
  }
  onSelectionChanged() {
    return !(!la(this._options.themeType) && this._options.renderWhitespace !== "selection") && (this._isMaybeInvalid = !0, !0);
  }
  renderLine(e, t, n, s, o) {
    if (this._isMaybeInvalid === !1) return !1;
    this._isMaybeInvalid = !1;
    const r = s.getViewLineRenderingData(e), a = this._options, l = _s.filter(r.inlineDecorations, e, r.minColumn, r.maxColumn);
    let d = null;
    if (la(a.themeType) || this._options.renderWhitespace === "selection") {
      const g = s.selections;
      for (const p of g) {
        if (p.endLineNumber < e || p.startLineNumber > e) continue;
        const f = p.startLineNumber === e ? p.startColumn : r.minColumn, _ = p.endLineNumber === e ? p.endColumn : r.maxColumn;
        f < _ && (la(a.themeType) && l.push(new _s(f, _, "inline-selected-text", 0)), this._options.renderWhitespace === "selection" && (d || (d = []), d.push(new iB(f - 1, _ - 1))));
      }
    }
    const h = new Lc(a.useMonospaceOptimizations, a.canUseHalfwidthRightwardsArrow, r.content, r.continuesWithWrappedLine, r.isBasicASCII, r.containsRTL, r.minColumn - 1, r.tokens, l, r.tabSize, r.startVisibleColumn, a.spaceWidth, a.middotWidth, a.wsmiddotWidth, a.stopRenderingLineAfter, a.renderWhitespace, a.renderControlCharacters, a.fontLigatures !== fo.OFF, d);
    if (this._renderedViewLine && this._renderedViewLine.input.equals(h)) return !1;
    o.appendString('<div style="top:'), o.appendString(String(t)), o.appendString("px;height:"), o.appendString(String(n)), o.appendString('px;" class="'), o.appendString(Ga.CLASS_NAME), o.appendString('">');
    const c = y1(h, o);
    o.appendString("</div>");
    let u = null;
    return t0 && $G && r.isBasicASCII && a.useMonospaceOptimizations && c.containsForeignElements === 0 && (u = new cb(this._renderedViewLine ? this._renderedViewLine.domNode : null, h, c.characterMapping)), u || (u = wB(this._renderedViewLine ? this._renderedViewLine.domNode : null, h, c.characterMapping, c.containsRTL, c.containsForeignElements)), this._renderedViewLine = u, !0;
  }
  layoutLine(e, t, n) {
    this._renderedViewLine && this._renderedViewLine.domNode && (this._renderedViewLine.domNode.setTop(t), this._renderedViewLine.domNode.setHeight(n));
  }
  getWidth(e) {
    return this._renderedViewLine ? this._renderedViewLine.getWidth(e) : 0;
  }
  getWidthIsFast() {
    return !this._renderedViewLine || this._renderedViewLine.getWidthIsFast();
  }
  needsMonospaceFontCheck() {
    return !!this._renderedViewLine && this._renderedViewLine instanceof cb;
  }
  monospaceAssumptionsAreValid() {
    return this._renderedViewLine && this._renderedViewLine instanceof cb ? this._renderedViewLine.monospaceAssumptionsAreValid() : t0;
  }
  onMonospaceAssumptionsInvalidated() {
    this._renderedViewLine && this._renderedViewLine instanceof cb && (this._renderedViewLine = this._renderedViewLine.toSlowRenderedLine());
  }
  getVisibleRangesForRange(e, t, n, s) {
    if (!this._renderedViewLine) return null;
    t = Math.min(this._renderedViewLine.input.lineContent.length + 1, Math.max(1, t)), n = Math.min(this._renderedViewLine.input.lineContent.length + 1, Math.max(1, n));
    const o = this._renderedViewLine.input.stopRenderingLineAfter;
    if (o !== -1 && t > o + 1 && n > o + 1) return new U4(!0, [new ju(this.getWidth(s), 0)]);
    o !== -1 && t > o + 1 && (t = o + 1), o !== -1 && n > o + 1 && (n = o + 1);
    const r = this._renderedViewLine.getVisibleRangesForRange(e, t, n, s);
    return r && r.length > 0 ? new U4(!1, r) : null;
  }
  getColumnOfNodeOffset(e, t) {
    return this._renderedViewLine ? this._renderedViewLine.getColumnOfNodeOffset(e, t) : 1;
  }
}
Ga.CLASS_NAME = "view-line";
class cb {
  constructor(e, t, n) {
    this._cachedWidth = -1, this.domNode = e, this.input = t;
    const s = Math.floor(t.lineContent.length / 300);
    if (s > 0) {
      this._keyColumnPixelOffsetCache = new Float32Array(s);
      for (let o = 0; o < s; o++) this._keyColumnPixelOffsetCache[o] = -1;
    } else this._keyColumnPixelOffsetCache = null;
    this._characterMapping = n, this._charWidth = t.spaceWidth;
  }
  getWidth(e) {
    if (!this.domNode || this.input.lineContent.length < 300) {
      const t = this._characterMapping.getHorizontalOffset(this._characterMapping.length);
      return Math.round(this._charWidth * t);
    }
    return this._cachedWidth === -1 && (this._cachedWidth = this._getReadingTarget(this.domNode).offsetWidth, e == null || e.markDidDomLayout()), this._cachedWidth;
  }
  getWidthIsFast() {
    return this.input.lineContent.length < 300 || this._cachedWidth !== -1;
  }
  monospaceAssumptionsAreValid() {
    if (!this.domNode) return t0;
    if (this.input.lineContent.length < 300) {
      const e = this.getWidth(null), t = this.domNode.domNode.firstChild.offsetWidth;
      Math.abs(e - t) >= 2 && (console.warn("monospace assumptions have been violated, therefore disabling monospace optimizations!"), t0 = !1);
    }
    return t0;
  }
  toSlowRenderedLine() {
    return wB(this.domNode, this.input, this._characterMapping, !1, 0);
  }
  getVisibleRangesForRange(e, t, n, s) {
    const o = this._getColumnPixelOffset(e, t, s), r = this._getColumnPixelOffset(e, n, s);
    return [new ju(o, r - o)];
  }
  _getColumnPixelOffset(e, t, n) {
    if (t <= 300) {
      const d = this._characterMapping.getHorizontalOffset(t);
      return this._charWidth * d;
    }
    const s = Math.floor((t - 1) / 300) - 1, o = 300 * (s + 1) + 1;
    let r = -1;
    if (this._keyColumnPixelOffsetCache && (r = this._keyColumnPixelOffsetCache[s], r === -1 && (r = this._actualReadPixelOffset(e, o, n), this._keyColumnPixelOffsetCache[s] = r)), r === -1) {
      const d = this._characterMapping.getHorizontalOffset(t);
      return this._charWidth * d;
    }
    const a = this._characterMapping.getHorizontalOffset(o), l = this._characterMapping.getHorizontalOffset(t);
    return r + this._charWidth * (l - a);
  }
  _getReadingTarget(e) {
    return e.domNode.firstChild;
  }
  _actualReadPixelOffset(e, t, n) {
    if (!this.domNode) return -1;
    const s = this._characterMapping.getDomPosition(t), o = WC.readHorizontalRanges(this._getReadingTarget(this.domNode), s.partIndex, s.charIndex, s.partIndex, s.charIndex, n);
    return o && o.length !== 0 ? o[0].left : -1;
  }
  getColumnOfNodeOffset(e, t) {
    return HR(this._characterMapping, e, t);
  }
}
class CB {
  constructor(e, t, n, s, o) {
    if (this.domNode = e, this.input = t, this._characterMapping = n, this._isWhitespaceOnly = /^\s*$/.test(t.lineContent), this._containsForeignElements = o, this._cachedWidth = -1, this._pixelOffsetCache = null, !s || this._characterMapping.length === 0) {
      this._pixelOffsetCache = new Float32Array(Math.max(2, this._characterMapping.length + 1));
      for (let r = 0, a = this._characterMapping.length; r <= a; r++) this._pixelOffsetCache[r] = -1;
    }
  }
  _getReadingTarget(e) {
    return e.domNode.firstChild;
  }
  getWidth(e) {
    return this.domNode ? (this._cachedWidth === -1 && (this._cachedWidth = this._getReadingTarget(this.domNode).offsetWidth, e == null || e.markDidDomLayout()), this._cachedWidth) : 0;
  }
  getWidthIsFast() {
    return this._cachedWidth !== -1;
  }
  getVisibleRangesForRange(e, t, n, s) {
    if (!this.domNode) return null;
    if (this._pixelOffsetCache !== null) {
      const o = this._readPixelOffset(this.domNode, e, t, s);
      if (o === -1) return null;
      const r = this._readPixelOffset(this.domNode, e, n, s);
      return r === -1 ? null : [new ju(o, r - o)];
    }
    return this._readVisibleRangesForRange(this.domNode, e, t, n, s);
  }
  _readVisibleRangesForRange(e, t, n, s, o) {
    if (n === s) {
      const r = this._readPixelOffset(e, t, n, o);
      return r === -1 ? null : [new ju(r, 0)];
    }
    return this._readRawVisibleRangesForRange(e, n, s, o);
  }
  _readPixelOffset(e, t, n, s) {
    if (this._characterMapping.length === 0) {
      if (this._containsForeignElements === 0 || this._containsForeignElements === 2) return 0;
      if (this._containsForeignElements === 1) return this.getWidth(s);
      const o = this._getReadingTarget(e);
      return o.firstChild ? (s.markDidDomLayout(), o.firstChild.offsetWidth) : 0;
    }
    if (this._pixelOffsetCache !== null) {
      const o = this._pixelOffsetCache[n];
      if (o !== -1) return o;
      const r = this._actualReadPixelOffset(e, t, n, s);
      return this._pixelOffsetCache[n] = r, r;
    }
    return this._actualReadPixelOffset(e, t, n, s);
  }
  _actualReadPixelOffset(e, t, n, s) {
    if (this._characterMapping.length === 0) {
      const l = WC.readHorizontalRanges(this._getReadingTarget(e), 0, 0, 0, 0, s);
      return l && l.length !== 0 ? l[0].left : -1;
    }
    if (n === this._characterMapping.length && this._isWhitespaceOnly && this._containsForeignElements === 0) return this.getWidth(s);
    const o = this._characterMapping.getDomPosition(n), r = WC.readHorizontalRanges(this._getReadingTarget(e), o.partIndex, o.charIndex, o.partIndex, o.charIndex, s);
    if (!r || r.length === 0) return -1;
    const a = r[0].left;
    if (this.input.isBasicASCII) {
      const l = this._characterMapping.getHorizontalOffset(n), d = Math.round(this.input.spaceWidth * l);
      if (Math.abs(d - a) <= 1) return d;
    }
    return a;
  }
  _readRawVisibleRangesForRange(e, t, n, s) {
    if (t === 1 && n === this._characterMapping.length) return [new ju(0, this.getWidth(s))];
    const o = this._characterMapping.getDomPosition(t), r = this._characterMapping.getDomPosition(n);
    return WC.readHorizontalRanges(this._getReadingTarget(e), o.partIndex, o.charIndex, r.partIndex, r.charIndex, s);
  }
  getColumnOfNodeOffset(e, t) {
    return HR(this._characterMapping, e, t);
  }
}
class GG extends CB {
  _readVisibleRangesForRange(e, t, n, s, o) {
    const r = super._readVisibleRangesForRange(e, t, n, s, o);
    if (!r || r.length === 0 || n === s || n === 1 && s === this._characterMapping.length) return r;
    if (!this.input.containsRTL) {
      const a = this._readPixelOffset(e, t, s, o);
      if (a !== -1) {
        const l = r[r.length - 1];
        l.left < a && (l.width = a - l.left);
      }
    }
    return r;
  }
}
const wB = Uu ? ZG : YG;
function ZG(i, e, t, n, s) {
  return new GG(i, e, t, n, s);
}
function YG(i, e, t, n, s) {
  return new CB(i, e, t, n, s);
}
function HR(i, e, t) {
  const n = e.textContent.length;
  let s = -1;
  for (; e; ) e = e.previousSibling, s++;
  return i.getColumn(new nB(s, t), n);
}
class Gi {
  static _nextVisibleColumn(e, t, n) {
    return e === 9 ? Gi.nextRenderTabStop(t, n) : _c(e) || lR(e) ? t + 2 : t + 1;
  }
  static visibleColumnFromColumn(e, t, n) {
    const s = Math.min(t - 1, e.length), o = e.substring(0, s), r = new zw(o);
    let a = 0;
    for (; !r.eol(); ) {
      const l = Hw(o, s, r.offset);
      r.nextGraphemeLength(), a = this._nextVisibleColumn(l, a, n);
    }
    return a;
  }
  static columnFromVisibleColumn(e, t, n) {
    if (t <= 0) return 1;
    const s = e.length, o = new zw(e);
    let r = 0, a = 1;
    for (; !o.eol(); ) {
      const l = Hw(e, s, o.offset);
      o.nextGraphemeLength();
      const d = this._nextVisibleColumn(l, r, n), h = o.offset + 1;
      if (d >= t)
        return d - t < t - r ? h : a;
      r = d, a = h;
    }
    return s + 1;
  }
  static nextRenderTabStop(e, t) {
    return e + t - e % t;
  }
  static nextIndentTabStop(e, t) {
    return e + t - e % t;
  }
  static prevRenderTabStop(e, t) {
    return Math.max(0, e - 1 - (e - 1) % t);
  }
  static prevIndentTabStop(e, t) {
    return Math.max(0, e - 1 - (e - 1) % t);
  }
}
class mv {
  static whitespaceVisibleColumn(e, t, n) {
    const s = e.length;
    let o = 0, r = -1, a = -1;
    for (let l = 0; l < s; l++) {
      if (l === t) return [r, a, o];
      switch (o % n == 0 && (r = l, a = o), e.charCodeAt(l)) {
        case 32:
          o += 1;
          break;
        case 9:
          o = Gi.nextRenderTabStop(o, n);
          break;
        default:
          return [-1, -1, -1];
      }
    }
    return t === s ? [r, a, o] : [-1, -1, -1];
  }
  static atomicPosition(e, t, n, s) {
    const o = e.length, [r, a, l] = mv.whitespaceVisibleColumn(e, t, n);
    if (l === -1) return -1;
    let d;
    switch (s) {
      case 0:
        d = !0;
        break;
      case 1:
        d = !1;
        break;
      case 2:
        if (l % n == 0) return t;
        d = l % n <= n / 2;
    }
    if (d) {
      if (r === -1) return -1;
      let u = a;
      for (let g = r; g < o; ++g) {
        if (u === a + n) return r;
        switch (e.charCodeAt(g)) {
          case 32:
            u += 1;
            break;
          case 9:
            u = Gi.nextRenderTabStop(u, n);
            break;
          default:
            return -1;
        }
      }
      return u === a + n ? r : -1;
    }
    const h = Gi.nextRenderTabStop(l, n);
    let c = l;
    for (let u = t; u < o; u++) {
      if (c === h) return u;
      switch (e.charCodeAt(u)) {
        case 32:
          c += 1;
          break;
        case 9:
          c = Gi.nextRenderTabStop(c, n);
          break;
        default:
          return -1;
      }
    }
    return c === h ? o : -1;
  }
}
class oh {
  constructor(e = null) {
    this.hitTarget = e, this.type = 0;
  }
}
class yB {
  get hitTarget() {
    return this.spanNode;
  }
  constructor(e, t, n) {
    this.position = e, this.spanNode = t, this.injectedText = n, this.type = 1;
  }
}
var bu;
(function(i) {
  i.createFromDOMInfo = function(e, t, n) {
    const s = e.getPositionFromDOMInfo(t, n);
    return s ? new yB(s, t, null) : new oh(t);
  };
})(bu || (bu = {}));
class XG {
  constructor(e, t) {
    this.lastViewCursorsRenderData = e, this.lastTextareaPosition = t;
  }
}
class Yn {
  static _deduceRage(e, t = null) {
    return !t && e ? new D(e.lineNumber, e.column, e.lineNumber, e.column) : t ?? null;
  }
  static createUnknown(e, t, n) {
    return { type: 0, element: e, mouseColumn: t, position: n, range: this._deduceRage(n) };
  }
  static createTextarea(e, t) {
    return { type: 1, element: e, mouseColumn: t, position: null, range: null };
  }
  static createMargin(e, t, n, s, o, r) {
    return { type: e, element: t, mouseColumn: n, position: s, range: o, detail: r };
  }
  static createViewZone(e, t, n, s, o) {
    return { type: e, element: t, mouseColumn: n, position: s, range: this._deduceRage(s), detail: o };
  }
  static createContentText(e, t, n, s, o) {
    return { type: 6, element: e, mouseColumn: t, position: n, range: this._deduceRage(n, s), detail: o };
  }
  static createContentEmpty(e, t, n, s) {
    return { type: 7, element: e, mouseColumn: t, position: n, range: this._deduceRage(n), detail: s };
  }
  static createContentWidget(e, t, n) {
    return { type: 9, element: e, mouseColumn: t, position: null, range: null, detail: n };
  }
  static createScrollbar(e, t, n) {
    return { type: 11, element: e, mouseColumn: t, position: n, range: this._deduceRage(n) };
  }
  static createOverlayWidget(e, t, n) {
    return { type: 12, element: e, mouseColumn: t, position: null, range: null, detail: n };
  }
  static createOutsideEditor(e, t, n, s) {
    return { type: 13, element: null, mouseColumn: e, position: t, range: this._deduceRage(t), outsidePosition: n, outsideDistance: s };
  }
  static _typeToString(e) {
    return e === 1 ? "TEXTAREA" : e === 2 ? "GUTTER_GLYPH_MARGIN" : e === 3 ? "GUTTER_LINE_NUMBERS" : e === 4 ? "GUTTER_LINE_DECORATIONS" : e === 5 ? "GUTTER_VIEW_ZONE" : e === 6 ? "CONTENT_TEXT" : e === 7 ? "CONTENT_EMPTY" : e === 8 ? "CONTENT_VIEW_ZONE" : e === 9 ? "CONTENT_WIDGET" : e === 10 ? "OVERVIEW_RULER" : e === 11 ? "SCROLLBAR" : e === 12 ? "OVERLAY_WIDGET" : "UNKNOWN";
  }
  static toString(e) {
    return this._typeToString(e.type) + ": " + e.position + " - " + e.range + " - " + JSON.stringify(e.detail);
  }
}
class is {
  static isTextArea(e) {
    return e.length === 2 && e[0] === 3 && e[1] === 7;
  }
  static isChildOfViewLines(e) {
    return e.length >= 4 && e[0] === 3 && e[3] === 8;
  }
  static isStrictChildOfViewLines(e) {
    return e.length > 4 && e[0] === 3 && e[3] === 8;
  }
  static isChildOfScrollableElement(e) {
    return e.length >= 2 && e[0] === 3 && e[1] === 6;
  }
  static isChildOfMinimap(e) {
    return e.length >= 2 && e[0] === 3 && e[1] === 9;
  }
  static isChildOfContentWidgets(e) {
    return e.length >= 4 && e[0] === 3 && e[3] === 1;
  }
  static isChildOfOverflowGuard(e) {
    return e.length >= 1 && e[0] === 3;
  }
  static isChildOfOverflowingContentWidgets(e) {
    return e.length >= 1 && e[0] === 2;
  }
  static isChildOfOverlayWidgets(e) {
    return e.length >= 2 && e[0] === 3 && e[1] === 4;
  }
  static isChildOfOverflowingOverlayWidgets(e) {
    return e.length >= 1 && e[0] === 5;
  }
}
class jm {
  constructor(e, t, n) {
    this.viewModel = e.viewModel;
    const s = e.configuration.options;
    this.layoutInfo = s.get(145), this.viewDomNode = t.viewDomNode, this.lineHeight = s.get(67), this.stickyTabStops = s.get(116), this.typicalHalfwidthCharacterWidth = s.get(50).typicalHalfwidthCharacterWidth, this.lastRenderData = n, this._context = e, this._viewHelper = t;
  }
  getZoneAtCoord(e) {
    return jm.getZoneAtCoord(this._context, e);
  }
  static getZoneAtCoord(e, t) {
    const n = e.viewLayout.getWhitespaceAtVerticalOffset(t);
    if (n) {
      const s = n.verticalOffset + n.height / 2, o = e.viewModel.getLineCount();
      let r, a = null, l = null;
      return n.afterLineNumber !== o && (l = new W(n.afterLineNumber + 1, 1)), n.afterLineNumber > 0 && (a = new W(n.afterLineNumber, e.viewModel.getLineMaxColumn(n.afterLineNumber))), r = l === null ? a : a === null ? l : t < s ? a : l, { viewZoneId: n.id, afterLineNumber: n.afterLineNumber, positionBefore: a, positionAfter: l, position: r };
    }
    return null;
  }
  getFullLineRangeAtCoord(e) {
    if (this._context.viewLayout.isAfterLines(e)) {
      const s = this._context.viewModel.getLineCount(), o = this._context.viewModel.getLineMaxColumn(s);
      return { range: new D(s, o, s, o), isAfterLines: !0 };
    }
    const t = this._context.viewLayout.getLineNumberAtVerticalOffset(e), n = this._context.viewModel.getLineMaxColumn(t);
    return { range: new D(t, 1, t, n), isAfterLines: !1 };
  }
  getLineNumberAtVerticalOffset(e) {
    return this._context.viewLayout.getLineNumberAtVerticalOffset(e);
  }
  isAfterLines(e) {
    return this._context.viewLayout.isAfterLines(e);
  }
  isInTopPadding(e) {
    return this._context.viewLayout.isInTopPadding(e);
  }
  isInBottomPadding(e) {
    return this._context.viewLayout.isInBottomPadding(e);
  }
  getVerticalOffsetForLineNumber(e) {
    return this._context.viewLayout.getVerticalOffsetForLineNumber(e);
  }
  findAttribute(e, t) {
    return jm._findAttribute(e, t, this._viewHelper.viewDomNode);
  }
  static _findAttribute(e, t, n) {
    for (; e && e !== e.ownerDocument.body; ) {
      if (e.hasAttribute && e.hasAttribute(t)) return e.getAttribute(t);
      if (e === n) return null;
      e = e.parentNode;
    }
    return null;
  }
  getLineWidth(e) {
    return this._viewHelper.getLineWidth(e);
  }
  visibleRangeForPosition(e, t) {
    return this._viewHelper.visibleRangeForPosition(e, t);
  }
  getPositionFromDOMInfo(e, t) {
    return this._viewHelper.getPositionFromDOMInfo(e, t);
  }
  getCurrentScrollTop() {
    return this._context.viewLayout.getCurrentScrollTop();
  }
  getCurrentScrollLeft() {
    return this._context.viewLayout.getCurrentScrollLeft();
  }
}
class QG {
  constructor(e, t, n, s) {
    this.editorPos = t, this.pos = n, this.relativePos = s, this.mouseVerticalOffset = Math.max(0, e.getCurrentScrollTop() + this.relativePos.y), this.mouseContentHorizontalOffset = e.getCurrentScrollLeft() + this.relativePos.x - e.layoutInfo.contentLeft, this.isInMarginArea = this.relativePos.x < e.layoutInfo.contentLeft && this.relativePos.x >= e.layoutInfo.glyphMarginLeft, this.isInContentArea = !this.isInMarginArea, this.mouseColumn = Math.max(0, Gn._getMouseColumn(this.mouseContentHorizontalOffset, e.typicalHalfwidthCharacterWidth));
  }
}
class JG extends QG {
  get target() {
    return this._useHitTestTarget ? this.hitTestResult.value.hitTarget : this._eventTarget;
  }
  get targetPath() {
    return this._targetPathCacheElement !== this.target && (this._targetPathCacheElement = this.target, this._targetPathCacheValue = _a.collect(this.target, this._ctx.viewDomNode)), this._targetPathCacheValue;
  }
  constructor(e, t, n, s, o) {
    super(e, t, n, s), this.hitTestResult = new ga(() => Gn.doHitTest(this._ctx, this)), this._targetPathCacheElement = null, this._targetPathCacheValue = new Uint8Array(0), this._ctx = e, this._eventTarget = o;
    const r = !!this._eventTarget;
    this._useHitTestTarget = !r;
  }
  toString() {
    return `pos(${this.pos.x},${this.pos.y}), editorPos(${this.editorPos.x},${this.editorPos.y}), relativePos(${this.relativePos.x},${this.relativePos.y}), mouseVerticalOffset: ${this.mouseVerticalOffset}, mouseContentHorizontalOffset: ${this.mouseContentHorizontalOffset}
	target: ${this.target ? this.target.outerHTML : null}`;
  }
  get wouldBenefitFromHitTestTargetSwitch() {
    return !this._useHitTestTarget && this.hitTestResult.value.hitTarget !== null && this.target !== this.hitTestResult.value.hitTarget;
  }
  switchToHitTestTarget() {
    this._useHitTestTarget = !0;
  }
  _getMouseColumn(e = null) {
    return e && e.column < this._ctx.viewModel.getLineMaxColumn(e.lineNumber) ? Gi.visibleColumnFromColumn(this._ctx.viewModel.getLineContent(e.lineNumber), e.column, this._ctx.viewModel.model.getOptions().tabSize) + 1 : this.mouseColumn;
  }
  fulfillUnknown(e = null) {
    return Yn.createUnknown(this.target, this._getMouseColumn(e), e);
  }
  fulfillTextarea() {
    return Yn.createTextarea(this.target, this._getMouseColumn());
  }
  fulfillMargin(e, t, n, s) {
    return Yn.createMargin(e, this.target, this._getMouseColumn(t), t, n, s);
  }
  fulfillViewZone(e, t, n) {
    return Yn.createViewZone(e, this.target, this._getMouseColumn(t), t, n);
  }
  fulfillContentText(e, t, n) {
    return Yn.createContentText(this.target, this._getMouseColumn(e), e, t, n);
  }
  fulfillContentEmpty(e, t) {
    return Yn.createContentEmpty(this.target, this._getMouseColumn(e), e, t);
  }
  fulfillContentWidget(e) {
    return Yn.createContentWidget(this.target, this._getMouseColumn(), e);
  }
  fulfillScrollbar(e) {
    return Yn.createScrollbar(this.target, this._getMouseColumn(e), e);
  }
  fulfillOverlayWidget(e) {
    return Yn.createOverlayWidget(this.target, this._getMouseColumn(), e);
  }
}
const j4 = { isAfterLines: !0 };
function gD(i) {
  return { isAfterLines: !1, horizontalDistanceToText: i };
}
class Gn {
  constructor(e, t) {
    this._context = e, this._viewHelper = t;
  }
  mouseTargetIsWidget(e) {
    const t = e.target, n = _a.collect(t, this._viewHelper.viewDomNode);
    return !(!is.isChildOfContentWidgets(n) && !is.isChildOfOverflowingContentWidgets(n)) || !(!is.isChildOfOverlayWidgets(n) && !is.isChildOfOverflowingOverlayWidgets(n));
  }
  createMouseTarget(e, t, n, s, o) {
    const r = new jm(this._context, this._viewHelper, e), a = new JG(r, t, n, s, o);
    try {
      const l = Gn._createMouseTarget(r, a);
      if (l.type === 6 && r.stickyTabStops && l.position !== null) {
        const d = Gn._snapToSoftTabBoundary(l.position, r.viewModel), h = D.fromPositions(d, d).plusRange(l.range);
        return a.fulfillContentText(d, h, l.detail);
      }
      return l;
    } catch {
      return a.fulfillUnknown();
    }
  }
  static _createMouseTarget(e, t) {
    if (t.target === null) return t.fulfillUnknown();
    const n = t;
    let s = null;
    return is.isChildOfOverflowGuard(t.targetPath) || is.isChildOfOverflowingContentWidgets(t.targetPath) || is.isChildOfOverflowingOverlayWidgets(t.targetPath) || (s = s || t.fulfillUnknown()), s = s || Gn._hitTestContentWidget(e, n), s = s || Gn._hitTestOverlayWidget(e, n), s = s || Gn._hitTestMinimap(e, n), s = s || Gn._hitTestScrollbarSlider(e, n), s = s || Gn._hitTestViewZone(e, n), s = s || Gn._hitTestMargin(e, n), s = s || Gn._hitTestViewCursor(e, n), s = s || Gn._hitTestTextArea(e, n), s = s || Gn._hitTestViewLines(e, n), s = s || Gn._hitTestScrollbar(e, n), s || t.fulfillUnknown();
  }
  static _hitTestContentWidget(e, t) {
    if (is.isChildOfContentWidgets(t.targetPath) || is.isChildOfOverflowingContentWidgets(t.targetPath)) {
      const n = e.findAttribute(t.target, "widgetId");
      return n ? t.fulfillContentWidget(n) : t.fulfillUnknown();
    }
    return null;
  }
  static _hitTestOverlayWidget(e, t) {
    if (is.isChildOfOverlayWidgets(t.targetPath) || is.isChildOfOverflowingOverlayWidgets(t.targetPath)) {
      const n = e.findAttribute(t.target, "widgetId");
      return n ? t.fulfillOverlayWidget(n) : t.fulfillUnknown();
    }
    return null;
  }
  static _hitTestViewCursor(e, t) {
    if (t.target) {
      const n = e.lastRenderData.lastViewCursorsRenderData;
      for (const s of n) if (t.target === s.domNode) return t.fulfillContentText(s.position, null, { mightBeForeignElement: !1, injectedText: null });
    }
    if (t.isInContentArea) {
      const n = e.lastRenderData.lastViewCursorsRenderData, s = t.mouseContentHorizontalOffset, o = t.mouseVerticalOffset;
      for (const r of n) {
        if (s < r.contentLeft || s > r.contentLeft + r.width) continue;
        const a = e.getVerticalOffsetForLineNumber(r.position.lineNumber);
        if (a <= o && o <= a + r.height) return t.fulfillContentText(r.position, null, { mightBeForeignElement: !1, injectedText: null });
      }
    }
    return null;
  }
  static _hitTestViewZone(e, t) {
    const n = e.getZoneAtCoord(t.mouseVerticalOffset);
    if (n) {
      const s = t.isInContentArea ? 8 : 5;
      return t.fulfillViewZone(s, n.position, n);
    }
    return null;
  }
  static _hitTestTextArea(e, t) {
    return is.isTextArea(t.targetPath) ? e.lastRenderData.lastTextareaPosition ? t.fulfillContentText(e.lastRenderData.lastTextareaPosition, null, { mightBeForeignElement: !1, injectedText: null }) : t.fulfillTextarea() : null;
  }
  static _hitTestMargin(e, t) {
    if (t.isInMarginArea) {
      const n = e.getFullLineRangeAtCoord(t.mouseVerticalOffset), s = n.range.getStartPosition();
      let o = Math.abs(t.relativePos.x);
      const r = { isAfterLines: n.isAfterLines, glyphMarginLeft: e.layoutInfo.glyphMarginLeft, glyphMarginWidth: e.layoutInfo.glyphMarginWidth, lineNumbersWidth: e.layoutInfo.lineNumbersWidth, offsetX: o };
      if (o -= e.layoutInfo.glyphMarginLeft, o <= e.layoutInfo.glyphMarginWidth) {
        const a = e.viewModel.coordinatesConverter.convertViewPositionToModelPosition(n.range.getStartPosition()), l = e.viewModel.glyphLanes.getLanesAtLine(a.lineNumber);
        return r.glyphMarginLane = l[Math.floor(o / e.lineHeight)], t.fulfillMargin(2, s, n.range, r);
      }
      return o -= e.layoutInfo.glyphMarginWidth, o <= e.layoutInfo.lineNumbersWidth ? t.fulfillMargin(3, s, n.range, r) : (o -= e.layoutInfo.lineNumbersWidth, t.fulfillMargin(4, s, n.range, r));
    }
    return null;
  }
  static _hitTestViewLines(e, t) {
    if (!is.isChildOfViewLines(t.targetPath)) return null;
    if (e.isInTopPadding(t.mouseVerticalOffset)) return t.fulfillContentEmpty(new W(1, 1), j4);
    if (e.isAfterLines(t.mouseVerticalOffset) || e.isInBottomPadding(t.mouseVerticalOffset)) {
      const s = e.viewModel.getLineCount(), o = e.viewModel.getLineMaxColumn(s);
      return t.fulfillContentEmpty(new W(s, o), j4);
    }
    if (is.isStrictChildOfViewLines(t.targetPath)) {
      const s = e.getLineNumberAtVerticalOffset(t.mouseVerticalOffset);
      if (e.viewModel.getLineLength(s) === 0) {
        const r = e.getLineWidth(s), a = gD(t.mouseContentHorizontalOffset - r);
        return t.fulfillContentEmpty(new W(s, 1), a);
      }
      const o = e.getLineWidth(s);
      if (t.mouseContentHorizontalOffset >= o) {
        const r = gD(t.mouseContentHorizontalOffset - o), a = new W(s, e.viewModel.getLineMaxColumn(s));
        return t.fulfillContentEmpty(a, r);
      }
    }
    const n = t.hitTestResult.value;
    return n.type === 1 ? Gn.createMouseTargetFromHitTestPosition(e, t, n.spanNode, n.position, n.injectedText) : t.wouldBenefitFromHitTestTargetSwitch ? (t.switchToHitTestTarget(), this._createMouseTarget(e, t)) : t.fulfillUnknown();
  }
  static _hitTestMinimap(e, t) {
    if (is.isChildOfMinimap(t.targetPath)) {
      const n = e.getLineNumberAtVerticalOffset(t.mouseVerticalOffset), s = e.viewModel.getLineMaxColumn(n);
      return t.fulfillScrollbar(new W(n, s));
    }
    return null;
  }
  static _hitTestScrollbarSlider(e, t) {
    if (is.isChildOfScrollableElement(t.targetPath) && t.target && t.target.nodeType === 1) {
      const n = t.target.className;
      if (n && /\b(slider|scrollbar)\b/.test(n)) {
        const s = e.getLineNumberAtVerticalOffset(t.mouseVerticalOffset), o = e.viewModel.getLineMaxColumn(s);
        return t.fulfillScrollbar(new W(s, o));
      }
    }
    return null;
  }
  static _hitTestScrollbar(e, t) {
    if (is.isChildOfScrollableElement(t.targetPath)) {
      const n = e.getLineNumberAtVerticalOffset(t.mouseVerticalOffset), s = e.viewModel.getLineMaxColumn(n);
      return t.fulfillScrollbar(new W(n, s));
    }
    return null;
  }
  getMouseColumn(e) {
    const t = this._context.configuration.options, n = t.get(145), s = this._context.viewLayout.getCurrentScrollLeft() + e.x - n.contentLeft;
    return Gn._getMouseColumn(s, t.get(50).typicalHalfwidthCharacterWidth);
  }
  static _getMouseColumn(e, t) {
    return e < 0 ? 1 : Math.round(e / t) + 1;
  }
  static createMouseTargetFromHitTestPosition(e, t, n, s, o) {
    const r = s.lineNumber, a = s.column, l = e.getLineWidth(r);
    if (t.mouseContentHorizontalOffset > l) {
      const _ = gD(t.mouseContentHorizontalOffset - l);
      return t.fulfillContentEmpty(s, _);
    }
    const d = e.visibleRangeForPosition(r, a);
    if (!d) return t.fulfillUnknown(s);
    const h = d.left;
    if (Math.abs(t.mouseContentHorizontalOffset - h) < 1) return t.fulfillContentText(s, null, { mightBeForeignElement: !!o, injectedText: o });
    const c = [];
    if (c.push({ offset: d.left, column: a }), a > 1) {
      const _ = e.visibleRangeForPosition(r, a - 1);
      _ && c.push({ offset: _.left, column: a - 1 });
    }
    if (a < e.viewModel.getLineMaxColumn(r)) {
      const _ = e.visibleRangeForPosition(r, a + 1);
      _ && c.push({ offset: _.left, column: a + 1 });
    }
    c.sort((_, v) => _.offset - v.offset);
    const u = t.pos.toClientCoordinates(ke(e.viewDomNode)), g = n.getBoundingClientRect(), p = g.left <= u.clientX && u.clientX <= g.right;
    let f = null;
    for (let _ = 1; _ < c.length; _++) {
      const v = c[_ - 1], b = c[_];
      if (v.offset <= t.mouseContentHorizontalOffset && t.mouseContentHorizontalOffset <= b.offset) {
        f = new D(r, v.column, r, b.column);
        const C = Math.abs(v.offset - t.mouseContentHorizontalOffset), w = Math.abs(b.offset - t.mouseContentHorizontalOffset);
        s = new W(r, C < w ? v.column : b.column);
        break;
      }
    }
    return t.fulfillContentText(s, f, { mightBeForeignElement: !p || !!o, injectedText: o });
  }
  static _doHitTestWithCaretRangeFromPoint(e, t) {
    const n = e.getLineNumberAtVerticalOffset(t.mouseVerticalOffset), s = e.getVerticalOffsetForLineNumber(n), o = s + e.lineHeight;
    if (!(n === e.viewModel.getLineCount() && t.mouseVerticalOffset > o)) {
      const r = Math.floor((s + o) / 2);
      let a = t.pos.y + (r - t.mouseVerticalOffset);
      a <= t.editorPos.y && (a = t.editorPos.y + 1), a >= t.editorPos.y + t.editorPos.height && (a = t.editorPos.y + t.editorPos.height - 1);
      const l = new aL(t.pos.x, a), d = this._actualDoHitTestWithCaretRangeFromPoint(e, l.toClientCoordinates(ke(e.viewDomNode)));
      if (d.type === 1) return d;
    }
    return this._actualDoHitTestWithCaretRangeFromPoint(e, t.pos.toClientCoordinates(ke(e.viewDomNode)));
  }
  static _actualDoHitTestWithCaretRangeFromPoint(e, t) {
    const n = dg(e.viewDomNode);
    let s;
    if (s = n ? n.caretRangeFromPoint === void 0 ? function(r, a, l) {
      const d = document.createRange();
      let h = r.elementFromPoint(a, l);
      if (h !== null) {
        for (; h && h.firstChild && h.firstChild.nodeType !== h.firstChild.TEXT_NODE && h.lastChild && h.lastChild.firstChild; ) h = h.lastChild;
        const c = h.getBoundingClientRect(), u = ke(h), g = `${u.getComputedStyle(h, null).getPropertyValue("font-style")} ${u.getComputedStyle(h, null).getPropertyValue("font-variant")} ${u.getComputedStyle(h, null).getPropertyValue("font-weight")} ${u.getComputedStyle(h, null).getPropertyValue("font-size")}/${u.getComputedStyle(h, null).getPropertyValue("line-height")} ${u.getComputedStyle(h, null).getPropertyValue("font-family")}`, p = h.innerText;
        let f, _ = c.left, v = 0;
        if (a > c.left + c.width) v = p.length;
        else {
          const b = Mu.getInstance();
          for (let C = 0; C < p.length + 1; C++) {
            if (f = b.getCharWidth(p.charAt(C), g) / 2, _ += f, a < _) {
              v = C;
              break;
            }
            _ += f;
          }
        }
        d.setStart(h.firstChild, v), d.setEnd(h.firstChild, v);
      }
      return d;
    }(n, t.clientX, t.clientY) : n.caretRangeFromPoint(t.clientX, t.clientY) : e.viewDomNode.ownerDocument.caretRangeFromPoint(t.clientX, t.clientY), !s || !s.startContainer) return new oh();
    const o = s.startContainer;
    if (o.nodeType === o.TEXT_NODE) {
      const r = o.parentNode, a = r ? r.parentNode : null, l = a ? a.parentNode : null;
      return (l && l.nodeType === l.ELEMENT_NODE ? l.className : null) === Ga.CLASS_NAME ? bu.createFromDOMInfo(e, r, s.startOffset) : new oh(o.parentNode);
    }
    if (o.nodeType === o.ELEMENT_NODE) {
      const r = o.parentNode, a = r ? r.parentNode : null;
      return (a && a.nodeType === a.ELEMENT_NODE ? a.className : null) === Ga.CLASS_NAME ? bu.createFromDOMInfo(e, o, o.textContent.length) : new oh(o);
    }
    return new oh();
  }
  static _doHitTestWithCaretPositionFromPoint(e, t) {
    const n = e.viewDomNode.ownerDocument.caretPositionFromPoint(t.clientX, t.clientY);
    if (n.offsetNode.nodeType === n.offsetNode.TEXT_NODE) {
      const s = n.offsetNode.parentNode, o = s ? s.parentNode : null, r = o ? o.parentNode : null;
      return (r && r.nodeType === r.ELEMENT_NODE ? r.className : null) === Ga.CLASS_NAME ? bu.createFromDOMInfo(e, n.offsetNode.parentNode, n.offset) : new oh(n.offsetNode.parentNode);
    }
    if (n.offsetNode.nodeType === n.offsetNode.ELEMENT_NODE) {
      const s = n.offsetNode.parentNode, o = s && s.nodeType === s.ELEMENT_NODE ? s.className : null, r = s ? s.parentNode : null, a = r && r.nodeType === r.ELEMENT_NODE ? r.className : null;
      if (o === Ga.CLASS_NAME) {
        const l = n.offsetNode.childNodes[Math.min(n.offset, n.offsetNode.childNodes.length - 1)];
        if (l) return bu.createFromDOMInfo(e, l, 0);
      } else if (a === Ga.CLASS_NAME) return bu.createFromDOMInfo(e, n.offsetNode, 0);
    }
    return new oh(n.offsetNode);
  }
  static _snapToSoftTabBoundary(e, t) {
    const n = t.getLineContent(e.lineNumber), { tabSize: s } = t.model.getOptions(), o = mv.atomicPosition(n, e.column - 1, s, 2);
    return o !== -1 ? new W(e.lineNumber, o + 1) : e;
  }
  static doHitTest(e, t) {
    let n = new oh();
    if (typeof e.viewDomNode.ownerDocument.caretRangeFromPoint == "function" ? n = this._doHitTestWithCaretRangeFromPoint(e, t) : e.viewDomNode.ownerDocument.caretPositionFromPoint && (n = this._doHitTestWithCaretPositionFromPoint(e, t.pos.toClientCoordinates(ke(e.viewDomNode)))), n.type === 1) {
      const s = e.viewModel.getInjectedTextAt(n.position), o = e.viewModel.normalizePosition(n.position, 2);
      !s && o.equals(n.position) || (n = new yB(o, n.spanNode, s));
    }
    return n;
  }
}
class Mu {
  static getInstance() {
    return Mu._INSTANCE || (Mu._INSTANCE = new Mu()), Mu._INSTANCE;
  }
  constructor() {
    this._cache = {}, this._canvas = document.createElement("canvas");
  }
  getCharWidth(e, t) {
    const n = e + t;
    if (this._cache[n]) return this._cache[n];
    const s = this._canvas.getContext("2d");
    s.font = t;
    const o = s.measureText(e).width;
    return this._cache[n] = o, o;
  }
}
function Li(i, e, t) {
  let n = null, s = null;
  if (typeof t.value == "function" ? (n = "value", s = t.value, s.length !== 0 && console.warn("Memoize should only be used in functions with zero parameters")) : typeof t.get == "function" && (n = "get", s = t.get), !s) throw new Error("not supported");
  const o = `$memoize$${e}`;
  t[n] = function(...r) {
    return this.hasOwnProperty(o) || Object.defineProperty(this, o, { configurable: !1, enumerable: !1, writable: !1, value: s.apply(this, r) }), this[o];
  };
}
Mu._INSTANCE = null;
var Vt, eZ = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
};
(function(i) {
  i.Tap = "-monaco-gesturetap", i.Change = "-monaco-gesturechange", i.Start = "-monaco-gesturestart", i.End = "-monaco-gesturesend", i.Contextmenu = "-monaco-gesturecontextmenu";
})(Vt || (Vt = {}));
class Bt extends V {
  constructor() {
    super(), this.dispatched = !1, this.targets = new fs(), this.ignoreTargets = new fs(), this.activeTouches = {}, this.handle = null, this._lastSetTapCountTime = 0, this._register(se.runAndSubscribe(HS, ({ window: e, disposables: t }) => {
      t.add(K(e.document, "touchstart", (n) => this.onTouchStart(n), { passive: !1 })), t.add(K(e.document, "touchend", (n) => this.onTouchEnd(e, n))), t.add(K(e.document, "touchmove", (n) => this.onTouchMove(n), { passive: !1 }));
    }, { window: Et, disposables: this._store }));
  }
  static addTarget(e) {
    return Bt.isTouchDevice() ? (Bt.INSTANCE || (Bt.INSTANCE = new Bt()), ye(Bt.INSTANCE.targets.push(e))) : V.None;
  }
  static ignoreTarget(e) {
    return Bt.isTouchDevice() ? (Bt.INSTANCE || (Bt.INSTANCE = new Bt()), ye(Bt.INSTANCE.ignoreTargets.push(e))) : V.None;
  }
  static isTouchDevice() {
    return "ontouchstart" in Et || navigator.maxTouchPoints > 0;
  }
  dispose() {
    this.handle && (this.handle.dispose(), this.handle = null), super.dispose();
  }
  onTouchStart(e) {
    const t = Date.now();
    this.handle && (this.handle.dispose(), this.handle = null);
    for (let n = 0, s = e.targetTouches.length; n < s; n++) {
      const o = e.targetTouches.item(n);
      this.activeTouches[o.identifier] = { id: o.identifier, initialTarget: o.target, initialTimeStamp: t, initialPageX: o.pageX, initialPageY: o.pageY, rollingTimestamps: [t], rollingPageX: [o.pageX], rollingPageY: [o.pageY] };
      const r = this.newGestureEvent(Vt.Start, o.target);
      r.pageX = o.pageX, r.pageY = o.pageY, this.dispatchEvent(r);
    }
    this.dispatched && (e.preventDefault(), e.stopPropagation(), this.dispatched = !1);
  }
  onTouchEnd(e, t) {
    const n = Date.now(), s = Object.keys(this.activeTouches).length;
    for (let o = 0, r = t.changedTouches.length; o < r; o++) {
      const a = t.changedTouches.item(o);
      if (!this.activeTouches.hasOwnProperty(String(a.identifier))) {
        console.warn("move of an UNKNOWN touch", a);
        continue;
      }
      const l = this.activeTouches[a.identifier], d = Date.now() - l.initialTimeStamp;
      if (d < Bt.HOLD_DELAY && Math.abs(l.initialPageX - Ao(l.rollingPageX)) < 30 && Math.abs(l.initialPageY - Ao(l.rollingPageY)) < 30) {
        const h = this.newGestureEvent(Vt.Tap, l.initialTarget);
        h.pageX = Ao(l.rollingPageX), h.pageY = Ao(l.rollingPageY), this.dispatchEvent(h);
      } else if (d >= Bt.HOLD_DELAY && Math.abs(l.initialPageX - Ao(l.rollingPageX)) < 30 && Math.abs(l.initialPageY - Ao(l.rollingPageY)) < 30) {
        const h = this.newGestureEvent(Vt.Contextmenu, l.initialTarget);
        h.pageX = Ao(l.rollingPageX), h.pageY = Ao(l.rollingPageY), this.dispatchEvent(h);
      } else if (s === 1) {
        const h = Ao(l.rollingPageX), c = Ao(l.rollingPageY), u = Ao(l.rollingTimestamps) - l.rollingTimestamps[0], g = h - l.rollingPageX[0], p = c - l.rollingPageY[0], f = [...this.targets].filter((_) => l.initialTarget instanceof Node && _.contains(l.initialTarget));
        this.inertia(e, f, n, Math.abs(g) / u, g > 0 ? 1 : -1, h, Math.abs(p) / u, p > 0 ? 1 : -1, c);
      }
      this.dispatchEvent(this.newGestureEvent(Vt.End, l.initialTarget)), delete this.activeTouches[a.identifier];
    }
    this.dispatched && (t.preventDefault(), t.stopPropagation(), this.dispatched = !1);
  }
  newGestureEvent(e, t) {
    const n = document.createEvent("CustomEvent");
    return n.initEvent(e, !1, !0), n.initialTarget = t, n.tapCount = 0, n;
  }
  dispatchEvent(e) {
    if (e.type === Vt.Tap) {
      const t = (/* @__PURE__ */ new Date()).getTime();
      let n = 0;
      n = t - this._lastSetTapCountTime > Bt.CLEAR_TAP_COUNT_TIME ? 1 : 2, this._lastSetTapCountTime = t, e.tapCount = n;
    } else e.type !== Vt.Change && e.type !== Vt.Contextmenu || (this._lastSetTapCountTime = 0);
    if (e.initialTarget instanceof Node) {
      for (const n of this.ignoreTargets) if (n.contains(e.initialTarget)) return;
      const t = [];
      for (const n of this.targets) if (n.contains(e.initialTarget)) {
        let s = 0, o = e.initialTarget;
        for (; o && o !== n; ) s++, o = o.parentElement;
        t.push([s, n]);
      }
      t.sort((n, s) => n[0] - s[0]);
      for (const [n, s] of t) s.dispatchEvent(e), this.dispatched = !0;
    }
  }
  inertia(e, t, n, s, o, r, a, l, d) {
    this.handle = Ys(e, () => {
      const h = Date.now(), c = h - n;
      let u = 0, g = 0, p = !0;
      s += Bt.SCROLL_FRICTION * c, a += Bt.SCROLL_FRICTION * c, s > 0 && (p = !1, u = o * s * c), a > 0 && (p = !1, g = l * a * c);
      const f = this.newGestureEvent(Vt.Change);
      f.translationX = u, f.translationY = g, t.forEach((_) => _.dispatchEvent(f)), p || this.inertia(e, t, h, s, o, r + u, a, l, d + g);
    });
  }
  onTouchMove(e) {
    const t = Date.now();
    for (let n = 0, s = e.changedTouches.length; n < s; n++) {
      const o = e.changedTouches.item(n);
      if (!this.activeTouches.hasOwnProperty(String(o.identifier))) {
        console.warn("end of an UNKNOWN touch", o);
        continue;
      }
      const r = this.activeTouches[o.identifier], a = this.newGestureEvent(Vt.Change, r.initialTarget);
      a.translationX = o.pageX - Ao(r.rollingPageX), a.translationY = o.pageY - Ao(r.rollingPageY), a.pageX = o.pageX, a.pageY = o.pageY, this.dispatchEvent(a), r.rollingPageX.length > 3 && (r.rollingPageX.shift(), r.rollingPageY.shift(), r.rollingTimestamps.shift()), r.rollingPageX.push(o.pageX), r.rollingPageY.push(o.pageY), r.rollingTimestamps.push(t);
    }
    this.dispatched && (e.preventDefault(), e.stopPropagation(), this.dispatched = !1);
  }
}
Bt.SCROLL_FRICTION = -5e-3, Bt.HOLD_DELAY = 700, Bt.CLEAR_TAP_COUNT_TIME = 400, eZ([Li], Bt, "isTouchDevice", null);
let To = class extends V {
  onclick(i, e) {
    this._register(K(i, ie.CLICK, (t) => e(new _r(ke(i), t))));
  }
  onmousedown(i, e) {
    this._register(K(i, ie.MOUSE_DOWN, (t) => e(new _r(ke(i), t))));
  }
  onmouseover(i, e) {
    this._register(K(i, ie.MOUSE_OVER, (t) => e(new _r(ke(i), t))));
  }
  onmouseleave(i, e) {
    this._register(K(i, ie.MOUSE_LEAVE, (t) => e(new _r(ke(i), t))));
  }
  onkeydown(i, e) {
    this._register(K(i, ie.KEY_DOWN, (t) => e(new jt(t))));
  }
  onkeyup(i, e) {
    this._register(K(i, ie.KEY_UP, (t) => e(new jt(t))));
  }
  oninput(i, e) {
    this._register(K(i, ie.INPUT, e));
  }
  onblur(i, e) {
    this._register(K(i, ie.BLUR, e));
  }
  onfocus(i, e) {
    this._register(K(i, ie.FOCUS, e));
  }
  ignoreGesture(i) {
    return Bt.ignoreTarget(i);
  }
};
const ly = 11;
class tZ extends To {
  constructor(e) {
    super(), this._onActivate = e.onActivate, this.bgDomNode = document.createElement("div"), this.bgDomNode.className = "arrow-background", this.bgDomNode.style.position = "absolute", this.bgDomNode.style.width = e.bgWidth + "px", this.bgDomNode.style.height = e.bgHeight + "px", e.top !== void 0 && (this.bgDomNode.style.top = "0px"), e.left !== void 0 && (this.bgDomNode.style.left = "0px"), e.bottom !== void 0 && (this.bgDomNode.style.bottom = "0px"), e.right !== void 0 && (this.bgDomNode.style.right = "0px"), this.domNode = document.createElement("div"), this.domNode.className = e.className, this.domNode.classList.add(...Ee.asClassNameArray(e.icon)), this.domNode.style.position = "absolute", this.domNode.style.width = "11px", this.domNode.style.height = "11px", e.top !== void 0 && (this.domNode.style.top = e.top + "px"), e.left !== void 0 && (this.domNode.style.left = e.left + "px"), e.bottom !== void 0 && (this.domNode.style.bottom = e.bottom + "px"), e.right !== void 0 && (this.domNode.style.right = e.right + "px"), this._pointerMoveMonitor = this._register(new vf()), this._register(bi(this.bgDomNode, ie.POINTER_DOWN, (t) => this._arrowPointerDown(t))), this._register(bi(this.domNode, ie.POINTER_DOWN, (t) => this._arrowPointerDown(t))), this._pointerdownRepeatTimer = this._register(new pR()), this._pointerdownScheduleRepeatTimer = this._register(new Dr());
  }
  _arrowPointerDown(e) {
    e.target && e.target instanceof Element && (this._onActivate(), this._pointerdownRepeatTimer.cancel(), this._pointerdownScheduleRepeatTimer.cancelAndSet(() => {
      this._pointerdownRepeatTimer.cancelAndSet(() => this._onActivate(), 1e3 / 24, ke(e));
    }, 200), this._pointerMoveMonitor.startMonitoring(e.target, e.pointerId, e.buttons, (t) => {
    }, () => {
      this._pointerdownRepeatTimer.cancel(), this._pointerdownScheduleRepeatTimer.cancel();
    }), e.preventDefault());
  }
}
class iZ extends V {
  constructor(e, t, n) {
    super(), this._visibility = e, this._visibleClassName = t, this._invisibleClassName = n, this._domNode = null, this._isVisible = !1, this._isNeeded = !1, this._rawShouldBeVisible = !1, this._shouldBeVisible = !1, this._revealTimer = this._register(new Dr());
  }
  setVisibility(e) {
    this._visibility !== e && (this._visibility = e, this._updateShouldBeVisible());
  }
  setShouldBeVisible(e) {
    this._rawShouldBeVisible = e, this._updateShouldBeVisible();
  }
  _applyVisibilitySetting() {
    return this._visibility !== 2 && (this._visibility === 3 || this._rawShouldBeVisible);
  }
  _updateShouldBeVisible() {
    const e = this._applyVisibilitySetting();
    this._shouldBeVisible !== e && (this._shouldBeVisible = e, this.ensureVisibility());
  }
  setIsNeeded(e) {
    this._isNeeded !== e && (this._isNeeded = e, this.ensureVisibility());
  }
  setDomNode(e) {
    this._domNode = e, this._domNode.setClassName(this._invisibleClassName), this.setShouldBeVisible(!1);
  }
  ensureVisibility() {
    this._isNeeded ? this._shouldBeVisible ? this._reveal() : this._hide(!0) : this._hide(!1);
  }
  _reveal() {
    this._isVisible || (this._isVisible = !0, this._revealTimer.setIfNotSet(() => {
      var e;
      (e = this._domNode) === null || e === void 0 || e.setClassName(this._visibleClassName);
    }, 0));
  }
  _hide(e) {
    var t;
    this._revealTimer.cancel(), this._isVisible && (this._isVisible = !1, (t = this._domNode) === null || t === void 0 || t.setClassName(this._invisibleClassName + (e ? " fade" : "")));
  }
}
class SB extends To {
  constructor(e) {
    super(), this._lazyRender = e.lazyRender, this._host = e.host, this._scrollable = e.scrollable, this._scrollByPage = e.scrollByPage, this._scrollbarState = e.scrollbarState, this._visibilityController = this._register(new iZ(e.visibility, "visible scrollbar " + e.extraScrollbarClassName, "invisible scrollbar " + e.extraScrollbarClassName)), this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded()), this._pointerMoveMonitor = this._register(new vf()), this._shouldRender = !0, this.domNode = wt(document.createElement("div")), this.domNode.setAttribute("role", "presentation"), this.domNode.setAttribute("aria-hidden", "true"), this._visibilityController.setDomNode(this.domNode), this.domNode.setPosition("absolute"), this._register(K(this.domNode.domNode, ie.POINTER_DOWN, (t) => this._domNodePointerDown(t)));
  }
  _createArrow(e) {
    const t = this._register(new tZ(e));
    this.domNode.domNode.appendChild(t.bgDomNode), this.domNode.domNode.appendChild(t.domNode);
  }
  _createSlider(e, t, n, s) {
    this.slider = wt(document.createElement("div")), this.slider.setClassName("slider"), this.slider.setPosition("absolute"), this.slider.setTop(e), this.slider.setLeft(t), typeof n == "number" && this.slider.setWidth(n), typeof s == "number" && this.slider.setHeight(s), this.slider.setLayerHinting(!0), this.slider.setContain("strict"), this.domNode.domNode.appendChild(this.slider.domNode), this._register(K(this.slider.domNode, ie.POINTER_DOWN, (o) => {
      o.button === 0 && (o.preventDefault(), this._sliderPointerDown(o));
    })), this.onclick(this.slider.domNode, (o) => {
      o.leftButton && o.stopPropagation();
    });
  }
  _onElementSize(e) {
    return this._scrollbarState.setVisibleSize(e) && (this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded()), this._shouldRender = !0, this._lazyRender || this.render()), this._shouldRender;
  }
  _onElementScrollSize(e) {
    return this._scrollbarState.setScrollSize(e) && (this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded()), this._shouldRender = !0, this._lazyRender || this.render()), this._shouldRender;
  }
  _onElementScrollPosition(e) {
    return this._scrollbarState.setScrollPosition(e) && (this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded()), this._shouldRender = !0, this._lazyRender || this.render()), this._shouldRender;
  }
  beginReveal() {
    this._visibilityController.setShouldBeVisible(!0);
  }
  beginHide() {
    this._visibilityController.setShouldBeVisible(!1);
  }
  render() {
    this._shouldRender && (this._shouldRender = !1, this._renderDomNode(this._scrollbarState.getRectangleLargeSize(), this._scrollbarState.getRectangleSmallSize()), this._updateSlider(this._scrollbarState.getSliderSize(), this._scrollbarState.getArrowSize() + this._scrollbarState.getSliderPosition()));
  }
  _domNodePointerDown(e) {
    e.target === this.domNode.domNode && this._onPointerDown(e);
  }
  delegatePointerDown(e) {
    const t = this.domNode.domNode.getClientRects()[0].top, n = t + this._scrollbarState.getSliderPosition(), s = t + this._scrollbarState.getSliderPosition() + this._scrollbarState.getSliderSize(), o = this._sliderPointerPosition(e);
    n <= o && o <= s ? e.button === 0 && (e.preventDefault(), this._sliderPointerDown(e)) : this._onPointerDown(e);
  }
  _onPointerDown(e) {
    let t, n;
    if (e.target === this.domNode.domNode && typeof e.offsetX == "number" && typeof e.offsetY == "number") t = e.offsetX, n = e.offsetY;
    else {
      const o = Ti(this.domNode.domNode);
      t = e.pageX - o.left, n = e.pageY - o.top;
    }
    const s = this._pointerDownRelativePosition(t, n);
    this._setDesiredScrollPositionNow(this._scrollByPage ? this._scrollbarState.getDesiredScrollPositionFromOffsetPaged(s) : this._scrollbarState.getDesiredScrollPositionFromOffset(s)), e.button === 0 && (e.preventDefault(), this._sliderPointerDown(e));
  }
  _sliderPointerDown(e) {
    if (!(e.target && e.target instanceof Element)) return;
    const t = this._sliderPointerPosition(e), n = this._sliderOrthogonalPointerPosition(e), s = this._scrollbarState.clone();
    this.slider.toggleClassName("active", !0), this._pointerMoveMonitor.startMonitoring(e.target, e.pointerId, e.buttons, (o) => {
      const r = this._sliderOrthogonalPointerPosition(o), a = Math.abs(r - n);
      if (Tn && a > 140) return void this._setDesiredScrollPositionNow(s.getScrollPosition());
      const l = this._sliderPointerPosition(o) - t;
      this._setDesiredScrollPositionNow(s.getDesiredScrollPositionFromDelta(l));
    }, () => {
      this.slider.toggleClassName("active", !1), this._host.onDragEnd();
    }), this._host.onDragStart();
  }
  _setDesiredScrollPositionNow(e) {
    const t = {};
    this.writeScrollPosition(t, e), this._scrollable.setScrollPositionNow(t);
  }
  updateScrollbarSize(e) {
    this._updateScrollbarSize(e), this._scrollbarState.setScrollbarSize(e), this._shouldRender = !0, this._lazyRender || this.render();
  }
  isNeeded() {
    return this._scrollbarState.isNeeded();
  }
}
class qm {
  constructor(e, t, n, s, o, r) {
    this._scrollbarSize = Math.round(t), this._oppositeScrollbarSize = Math.round(n), this._arrowSize = Math.round(e), this._visibleSize = s, this._scrollSize = o, this._scrollPosition = r, this._computedAvailableSize = 0, this._computedIsNeeded = !1, this._computedSliderSize = 0, this._computedSliderRatio = 0, this._computedSliderPosition = 0, this._refreshComputedValues();
  }
  clone() {
    return new qm(this._arrowSize, this._scrollbarSize, this._oppositeScrollbarSize, this._visibleSize, this._scrollSize, this._scrollPosition);
  }
  setVisibleSize(e) {
    const t = Math.round(e);
    return this._visibleSize !== t && (this._visibleSize = t, this._refreshComputedValues(), !0);
  }
  setScrollSize(e) {
    const t = Math.round(e);
    return this._scrollSize !== t && (this._scrollSize = t, this._refreshComputedValues(), !0);
  }
  setScrollPosition(e) {
    const t = Math.round(e);
    return this._scrollPosition !== t && (this._scrollPosition = t, this._refreshComputedValues(), !0);
  }
  setScrollbarSize(e) {
    this._scrollbarSize = Math.round(e);
  }
  setOppositeScrollbarSize(e) {
    this._oppositeScrollbarSize = Math.round(e);
  }
  static _computeValues(e, t, n, s, o) {
    const r = Math.max(0, n - e), a = Math.max(0, r - 2 * t), l = s > 0 && s > n;
    if (!l) return { computedAvailableSize: Math.round(r), computedIsNeeded: l, computedSliderSize: Math.round(a), computedSliderRatio: 0, computedSliderPosition: 0 };
    const d = Math.round(Math.max(20, Math.floor(n * a / s))), h = (a - d) / (s - n), c = o * h;
    return { computedAvailableSize: Math.round(r), computedIsNeeded: l, computedSliderSize: Math.round(d), computedSliderRatio: h, computedSliderPosition: Math.round(c) };
  }
  _refreshComputedValues() {
    const e = qm._computeValues(this._oppositeScrollbarSize, this._arrowSize, this._visibleSize, this._scrollSize, this._scrollPosition);
    this._computedAvailableSize = e.computedAvailableSize, this._computedIsNeeded = e.computedIsNeeded, this._computedSliderSize = e.computedSliderSize, this._computedSliderRatio = e.computedSliderRatio, this._computedSliderPosition = e.computedSliderPosition;
  }
  getArrowSize() {
    return this._arrowSize;
  }
  getScrollPosition() {
    return this._scrollPosition;
  }
  getRectangleLargeSize() {
    return this._computedAvailableSize;
  }
  getRectangleSmallSize() {
    return this._scrollbarSize;
  }
  isNeeded() {
    return this._computedIsNeeded;
  }
  getSliderSize() {
    return this._computedSliderSize;
  }
  getSliderPosition() {
    return this._computedSliderPosition;
  }
  getDesiredScrollPositionFromOffset(e) {
    if (!this._computedIsNeeded) return 0;
    const t = e - this._arrowSize - this._computedSliderSize / 2;
    return Math.round(t / this._computedSliderRatio);
  }
  getDesiredScrollPositionFromOffsetPaged(e) {
    if (!this._computedIsNeeded) return 0;
    const t = e - this._arrowSize;
    let n = this._scrollPosition;
    return t < this._computedSliderPosition ? n -= this._visibleSize : n += this._visibleSize, n;
  }
  getDesiredScrollPositionFromDelta(e) {
    if (!this._computedIsNeeded) return 0;
    const t = this._computedSliderPosition + e;
    return Math.round(t / this._computedSliderRatio);
  }
}
class nZ extends SB {
  constructor(e, t, n) {
    const s = e.getScrollDimensions(), o = e.getCurrentScrollPosition();
    if (super({ lazyRender: t.lazyRender, host: n, scrollbarState: new qm(t.horizontalHasArrows ? t.arrowSize : 0, t.horizontal === 2 ? 0 : t.horizontalScrollbarSize, t.vertical === 2 ? 0 : t.verticalScrollbarSize, s.width, s.scrollWidth, o.scrollLeft), visibility: t.horizontal, extraScrollbarClassName: "horizontal", scrollable: e, scrollByPage: t.scrollByPage }), t.horizontalHasArrows) {
      const r = (t.arrowSize - ly) / 2, a = (t.horizontalScrollbarSize - ly) / 2;
      this._createArrow({ className: "scra", icon: ne.scrollbarButtonLeft, top: a, left: r, bottom: void 0, right: void 0, bgWidth: t.arrowSize, bgHeight: t.horizontalScrollbarSize, onActivate: () => this._host.onMouseWheel(new lg(null, 1, 0)) }), this._createArrow({ className: "scra", icon: ne.scrollbarButtonRight, top: a, left: void 0, bottom: void 0, right: r, bgWidth: t.arrowSize, bgHeight: t.horizontalScrollbarSize, onActivate: () => this._host.onMouseWheel(new lg(null, -1, 0)) });
    }
    this._createSlider(Math.floor((t.horizontalScrollbarSize - t.horizontalSliderSize) / 2), 0, void 0, t.horizontalSliderSize);
  }
  _updateSlider(e, t) {
    this.slider.setWidth(e), this.slider.setLeft(t);
  }
  _renderDomNode(e, t) {
    this.domNode.setWidth(e), this.domNode.setHeight(t), this.domNode.setLeft(0), this.domNode.setBottom(0);
  }
  onDidScroll(e) {
    return this._shouldRender = this._onElementScrollSize(e.scrollWidth) || this._shouldRender, this._shouldRender = this._onElementScrollPosition(e.scrollLeft) || this._shouldRender, this._shouldRender = this._onElementSize(e.width) || this._shouldRender, this._shouldRender;
  }
  _pointerDownRelativePosition(e, t) {
    return e;
  }
  _sliderPointerPosition(e) {
    return e.pageX;
  }
  _sliderOrthogonalPointerPosition(e) {
    return e.pageY;
  }
  _updateScrollbarSize(e) {
    this.slider.setHeight(e);
  }
  writeScrollPosition(e, t) {
    e.scrollLeft = t;
  }
  updateOptions(e) {
    this.updateScrollbarSize(e.horizontal === 2 ? 0 : e.horizontalScrollbarSize), this._scrollbarState.setOppositeScrollbarSize(e.vertical === 2 ? 0 : e.verticalScrollbarSize), this._visibilityController.setVisibility(e.horizontal), this._scrollByPage = e.scrollByPage;
  }
}
class sZ extends SB {
  constructor(e, t, n) {
    const s = e.getScrollDimensions(), o = e.getCurrentScrollPosition();
    if (super({ lazyRender: t.lazyRender, host: n, scrollbarState: new qm(t.verticalHasArrows ? t.arrowSize : 0, t.vertical === 2 ? 0 : t.verticalScrollbarSize, 0, s.height, s.scrollHeight, o.scrollTop), visibility: t.vertical, extraScrollbarClassName: "vertical", scrollable: e, scrollByPage: t.scrollByPage }), t.verticalHasArrows) {
      const r = (t.arrowSize - ly) / 2, a = (t.verticalScrollbarSize - ly) / 2;
      this._createArrow({ className: "scra", icon: ne.scrollbarButtonUp, top: r, left: a, bottom: void 0, right: void 0, bgWidth: t.verticalScrollbarSize, bgHeight: t.arrowSize, onActivate: () => this._host.onMouseWheel(new lg(null, 0, 1)) }), this._createArrow({ className: "scra", icon: ne.scrollbarButtonDown, top: void 0, left: a, bottom: r, right: void 0, bgWidth: t.verticalScrollbarSize, bgHeight: t.arrowSize, onActivate: () => this._host.onMouseWheel(new lg(null, 0, -1)) });
    }
    this._createSlider(0, Math.floor((t.verticalScrollbarSize - t.verticalSliderSize) / 2), t.verticalSliderSize, void 0);
  }
  _updateSlider(e, t) {
    this.slider.setHeight(e), this.slider.setTop(t);
  }
  _renderDomNode(e, t) {
    this.domNode.setWidth(t), this.domNode.setHeight(e), this.domNode.setRight(0), this.domNode.setTop(0);
  }
  onDidScroll(e) {
    return this._shouldRender = this._onElementScrollSize(e.scrollHeight) || this._shouldRender, this._shouldRender = this._onElementScrollPosition(e.scrollTop) || this._shouldRender, this._shouldRender = this._onElementSize(e.height) || this._shouldRender, this._shouldRender;
  }
  _pointerDownRelativePosition(e, t) {
    return t;
  }
  _sliderPointerPosition(e) {
    return e.pageY;
  }
  _sliderOrthogonalPointerPosition(e) {
    return e.pageX;
  }
  _updateScrollbarSize(e) {
    this.slider.setWidth(e);
  }
  writeScrollPosition(e, t) {
    e.scrollTop = t;
  }
  updateOptions(e) {
    this.updateScrollbarSize(e.vertical === 2 ? 0 : e.verticalScrollbarSize), this._scrollbarState.setOppositeScrollbarSize(0), this._visibilityController.setVisibility(e.vertical), this._scrollByPage = e.scrollByPage;
  }
}
class dy {
  constructor(e, t, n, s, o, r, a) {
    this._forceIntegerValues = e, this._scrollStateBrand = void 0, this._forceIntegerValues && (t |= 0, n |= 0, s |= 0, o |= 0, r |= 0, a |= 0), this.rawScrollLeft = s, this.rawScrollTop = a, t < 0 && (t = 0), s + t > n && (s = n - t), s < 0 && (s = 0), o < 0 && (o = 0), a + o > r && (a = r - o), a < 0 && (a = 0), this.width = t, this.scrollWidth = n, this.scrollLeft = s, this.height = o, this.scrollHeight = r, this.scrollTop = a;
  }
  equals(e) {
    return this.rawScrollLeft === e.rawScrollLeft && this.rawScrollTop === e.rawScrollTop && this.width === e.width && this.scrollWidth === e.scrollWidth && this.scrollLeft === e.scrollLeft && this.height === e.height && this.scrollHeight === e.scrollHeight && this.scrollTop === e.scrollTop;
  }
  withScrollDimensions(e, t) {
    return new dy(this._forceIntegerValues, e.width !== void 0 ? e.width : this.width, e.scrollWidth !== void 0 ? e.scrollWidth : this.scrollWidth, t ? this.rawScrollLeft : this.scrollLeft, e.height !== void 0 ? e.height : this.height, e.scrollHeight !== void 0 ? e.scrollHeight : this.scrollHeight, t ? this.rawScrollTop : this.scrollTop);
  }
  withScrollPosition(e) {
    return new dy(this._forceIntegerValues, this.width, this.scrollWidth, e.scrollLeft !== void 0 ? e.scrollLeft : this.rawScrollLeft, this.height, this.scrollHeight, e.scrollTop !== void 0 ? e.scrollTop : this.rawScrollTop);
  }
  createScrollEvent(e, t) {
    const n = this.width !== e.width, s = this.scrollWidth !== e.scrollWidth, o = this.scrollLeft !== e.scrollLeft, r = this.height !== e.height, a = this.scrollHeight !== e.scrollHeight, l = this.scrollTop !== e.scrollTop;
    return { inSmoothScrolling: t, oldWidth: e.width, oldScrollWidth: e.scrollWidth, oldScrollLeft: e.scrollLeft, width: this.width, scrollWidth: this.scrollWidth, scrollLeft: this.scrollLeft, oldHeight: e.height, oldScrollHeight: e.scrollHeight, oldScrollTop: e.scrollTop, height: this.height, scrollHeight: this.scrollHeight, scrollTop: this.scrollTop, widthChanged: n, scrollWidthChanged: s, scrollLeftChanged: o, heightChanged: r, scrollHeightChanged: a, scrollTopChanged: l };
  }
}
class bf extends V {
  constructor(e) {
    super(), this._scrollableBrand = void 0, this._onScroll = this._register(new F()), this.onScroll = this._onScroll.event, this._smoothScrollDuration = e.smoothScrollDuration, this._scheduleAtNextAnimationFrame = e.scheduleAtNextAnimationFrame, this._state = new dy(e.forceIntegerValues, 0, 0, 0, 0, 0, 0), this._smoothScrolling = null;
  }
  dispose() {
    this._smoothScrolling && (this._smoothScrolling.dispose(), this._smoothScrolling = null), super.dispose();
  }
  setSmoothScrollDuration(e) {
    this._smoothScrollDuration = e;
  }
  validateScrollPosition(e) {
    return this._state.withScrollPosition(e);
  }
  getScrollDimensions() {
    return this._state;
  }
  setScrollDimensions(e, t) {
    var n;
    const s = this._state.withScrollDimensions(e, t);
    this._setState(s, !!this._smoothScrolling), (n = this._smoothScrolling) === null || n === void 0 || n.acceptScrollDimensions(this._state);
  }
  getFutureScrollPosition() {
    return this._smoothScrolling ? this._smoothScrolling.to : this._state;
  }
  getCurrentScrollPosition() {
    return this._state;
  }
  setScrollPositionNow(e) {
    const t = this._state.withScrollPosition(e);
    this._smoothScrolling && (this._smoothScrolling.dispose(), this._smoothScrolling = null), this._setState(t, !1);
  }
  setScrollPositionSmooth(e, t) {
    if (this._smoothScrollDuration === 0) return this.setScrollPositionNow(e);
    if (this._smoothScrolling) {
      e = { scrollLeft: e.scrollLeft === void 0 ? this._smoothScrolling.to.scrollLeft : e.scrollLeft, scrollTop: e.scrollTop === void 0 ? this._smoothScrolling.to.scrollTop : e.scrollTop };
      const n = this._state.withScrollPosition(e);
      if (this._smoothScrolling.to.scrollLeft === n.scrollLeft && this._smoothScrolling.to.scrollTop === n.scrollTop) return;
      let s;
      s = t ? new fv(this._smoothScrolling.from, n, this._smoothScrolling.startTime, this._smoothScrolling.duration) : this._smoothScrolling.combine(this._state, n, this._smoothScrollDuration), this._smoothScrolling.dispose(), this._smoothScrolling = s;
    } else {
      const n = this._state.withScrollPosition(e);
      this._smoothScrolling = fv.start(this._state, n, this._smoothScrollDuration);
    }
    this._smoothScrolling.animationFrameDisposable = this._scheduleAtNextAnimationFrame(() => {
      this._smoothScrolling && (this._smoothScrolling.animationFrameDisposable = null, this._performSmoothScrolling());
    });
  }
  hasPendingScrollAnimation() {
    return !!this._smoothScrolling;
  }
  _performSmoothScrolling() {
    if (!this._smoothScrolling) return;
    const e = this._smoothScrolling.tick(), t = this._state.withScrollPosition(e);
    return this._setState(t, !0), this._smoothScrolling ? e.isDone ? (this._smoothScrolling.dispose(), void (this._smoothScrolling = null)) : void (this._smoothScrolling.animationFrameDisposable = this._scheduleAtNextAnimationFrame(() => {
      this._smoothScrolling && (this._smoothScrolling.animationFrameDisposable = null, this._performSmoothScrolling());
    })) : void 0;
  }
  _setState(e, t) {
    const n = this._state;
    n.equals(e) || (this._state = e, this._onScroll.fire(this._state.createScrollEvent(n, t)));
  }
}
class q4 {
  constructor(e, t, n) {
    this.scrollLeft = e, this.scrollTop = t, this.isDone = n;
  }
}
function pD(i, e) {
  const t = e - i;
  return function(n) {
    return i + t * (1 - function(s) {
      return Math.pow(s, 3);
    }(1 - n));
  };
}
class fv {
  constructor(e, t, n, s) {
    this.from = e, this.to = t, this.duration = s, this.startTime = n, this.animationFrameDisposable = null, this._initAnimations();
  }
  _initAnimations() {
    this.scrollLeft = this._initAnimation(this.from.scrollLeft, this.to.scrollLeft, this.to.width), this.scrollTop = this._initAnimation(this.from.scrollTop, this.to.scrollTop, this.to.height);
  }
  _initAnimation(e, t, n) {
    if (Math.abs(e - t) > 2.5 * n) {
      let a, l;
      return e < t ? (a = e + 0.75 * n, l = t - 0.75 * n) : (a = e - 0.75 * n, l = t + 0.75 * n), s = pD(e, a), o = pD(l, t), r = 0.33, function(d) {
        return d < r ? s(d / r) : o((d - r) / (1 - r));
      };
    }
    var s, o, r;
    return pD(e, t);
  }
  dispose() {
    this.animationFrameDisposable !== null && (this.animationFrameDisposable.dispose(), this.animationFrameDisposable = null);
  }
  acceptScrollDimensions(e) {
    this.to = e.withScrollPosition(this.to), this._initAnimations();
  }
  tick() {
    return this._tick(Date.now());
  }
  _tick(e) {
    const t = (e - this.startTime) / this.duration;
    if (t < 1) {
      const n = this.scrollLeft(t), s = this.scrollTop(t);
      return new q4(n, s, !1);
    }
    return new q4(this.to.scrollLeft, this.to.scrollTop, !0);
  }
  combine(e, t, n) {
    return fv.start(e, t, n);
  }
  static start(e, t, n) {
    n += 10;
    const s = Date.now() - 10;
    return new fv(e, t, s, n);
  }
}
class oZ {
  constructor(e, t, n) {
    this.timestamp = e, this.deltaX = t, this.deltaY = n, this.score = 0;
  }
}
class hy {
  constructor() {
    this._capacity = 5, this._memory = [], this._front = -1, this._rear = -1;
  }
  isPhysicalMouseWheel() {
    if (this._front === -1 && this._rear === -1) return !1;
    let e = 1, t = 0, n = 1, s = this._rear;
    for (; ; ) {
      const o = s === this._front ? e : Math.pow(2, -n);
      if (e -= o, t += this._memory[s].score * o, s === this._front) break;
      s = (this._capacity + s - 1) % this._capacity, n++;
    }
    return t <= 0.5;
  }
  acceptStandardWheelEvent(e) {
    if (_1) {
      const t = function(n) {
        return kE.INSTANCE.getZoomFactor(n);
      }(ke(e.browserEvent));
      this.accept(Date.now(), e.deltaX * t, e.deltaY * t);
    } else this.accept(Date.now(), e.deltaX, e.deltaY);
  }
  accept(e, t, n) {
    let s = null;
    const o = new oZ(e, t, n);
    this._front === -1 && this._rear === -1 ? (this._memory[0] = o, this._front = 0, this._rear = 0) : (s = this._memory[this._rear], this._rear = (this._rear + 1) % this._capacity, this._rear === this._front && (this._front = (this._front + 1) % this._capacity), this._memory[this._rear] = o), o.score = this._computeScore(o, s);
  }
  _computeScore(e, t) {
    if (Math.abs(e.deltaX) > 0 && Math.abs(e.deltaY) > 0) return 1;
    let n = 0.5;
    if (this._isAlmostInt(e.deltaX) && this._isAlmostInt(e.deltaY) || (n += 0.25), t) {
      const s = Math.abs(e.deltaX), o = Math.abs(e.deltaY), r = Math.abs(t.deltaX), a = Math.abs(t.deltaY), l = Math.max(Math.min(s, r), 1), d = Math.max(Math.min(o, a), 1), h = Math.max(s, r), c = Math.max(o, a);
      h % l == 0 && c % d == 0 && (n -= 0.5);
    }
    return Math.min(Math.max(n, 0), 1);
  }
  _isAlmostInt(e) {
    return Math.abs(Math.round(e) - e) < 0.01;
  }
}
hy.INSTANCE = new hy();
class zR extends To {
  get options() {
    return this._options;
  }
  constructor(e, t, n) {
    super(), this._onScroll = this._register(new F()), this.onScroll = this._onScroll.event, this._onWillScroll = this._register(new F()), e.style.overflow = "hidden", this._options = function(o) {
      const r = { lazyRender: o.lazyRender !== void 0 && o.lazyRender, className: o.className !== void 0 ? o.className : "", useShadows: o.useShadows === void 0 || o.useShadows, handleMouseWheel: o.handleMouseWheel === void 0 || o.handleMouseWheel, flipAxes: o.flipAxes !== void 0 && o.flipAxes, consumeMouseWheelIfScrollbarIsNeeded: o.consumeMouseWheelIfScrollbarIsNeeded !== void 0 && o.consumeMouseWheelIfScrollbarIsNeeded, alwaysConsumeMouseWheel: o.alwaysConsumeMouseWheel !== void 0 && o.alwaysConsumeMouseWheel, scrollYToX: o.scrollYToX !== void 0 && o.scrollYToX, mouseWheelScrollSensitivity: o.mouseWheelScrollSensitivity !== void 0 ? o.mouseWheelScrollSensitivity : 1, fastScrollSensitivity: o.fastScrollSensitivity !== void 0 ? o.fastScrollSensitivity : 5, scrollPredominantAxis: o.scrollPredominantAxis === void 0 || o.scrollPredominantAxis, mouseWheelSmoothScroll: o.mouseWheelSmoothScroll === void 0 || o.mouseWheelSmoothScroll, arrowSize: o.arrowSize !== void 0 ? o.arrowSize : 11, listenOnDomNode: o.listenOnDomNode !== void 0 ? o.listenOnDomNode : null, horizontal: o.horizontal !== void 0 ? o.horizontal : 1, horizontalScrollbarSize: o.horizontalScrollbarSize !== void 0 ? o.horizontalScrollbarSize : 10, horizontalSliderSize: o.horizontalSliderSize !== void 0 ? o.horizontalSliderSize : 0, horizontalHasArrows: o.horizontalHasArrows !== void 0 && o.horizontalHasArrows, vertical: o.vertical !== void 0 ? o.vertical : 1, verticalScrollbarSize: o.verticalScrollbarSize !== void 0 ? o.verticalScrollbarSize : 10, verticalHasArrows: o.verticalHasArrows !== void 0 && o.verticalHasArrows, verticalSliderSize: o.verticalSliderSize !== void 0 ? o.verticalSliderSize : 0, scrollByPage: o.scrollByPage !== void 0 && o.scrollByPage };
      return r.horizontalSliderSize = o.horizontalSliderSize !== void 0 ? o.horizontalSliderSize : r.horizontalScrollbarSize, r.verticalSliderSize = o.verticalSliderSize !== void 0 ? o.verticalSliderSize : r.verticalScrollbarSize, Je && (r.className += " mac"), r;
    }(t), this._scrollable = n, this._register(this._scrollable.onScroll((o) => {
      this._onWillScroll.fire(o), this._onDidScroll(o), this._onScroll.fire(o);
    }));
    const s = { onMouseWheel: (o) => this._onMouseWheel(o), onDragStart: () => this._onDragStart(), onDragEnd: () => this._onDragEnd() };
    this._verticalScrollbar = this._register(new sZ(this._scrollable, this._options, s)), this._horizontalScrollbar = this._register(new nZ(this._scrollable, this._options, s)), this._domNode = document.createElement("div"), this._domNode.className = "monaco-scrollable-element " + this._options.className, this._domNode.setAttribute("role", "presentation"), this._domNode.style.position = "relative", this._domNode.style.overflow = "hidden", this._domNode.appendChild(e), this._domNode.appendChild(this._horizontalScrollbar.domNode.domNode), this._domNode.appendChild(this._verticalScrollbar.domNode.domNode), this._options.useShadows ? (this._leftShadowDomNode = wt(document.createElement("div")), this._leftShadowDomNode.setClassName("shadow"), this._domNode.appendChild(this._leftShadowDomNode.domNode), this._topShadowDomNode = wt(document.createElement("div")), this._topShadowDomNode.setClassName("shadow"), this._domNode.appendChild(this._topShadowDomNode.domNode), this._topLeftShadowDomNode = wt(document.createElement("div")), this._topLeftShadowDomNode.setClassName("shadow"), this._domNode.appendChild(this._topLeftShadowDomNode.domNode)) : (this._leftShadowDomNode = null, this._topShadowDomNode = null, this._topLeftShadowDomNode = null), this._listenOnDomNode = this._options.listenOnDomNode || this._domNode, this._mouseWheelToDispose = [], this._setListeningToMouseWheel(this._options.handleMouseWheel), this.onmouseover(this._listenOnDomNode, (o) => this._onMouseOver(o)), this.onmouseleave(this._listenOnDomNode, (o) => this._onMouseLeave(o)), this._hideTimeout = this._register(new Dr()), this._isDragging = !1, this._mouseIsOver = !1, this._shouldRender = !0, this._revealOnScroll = !0;
  }
  dispose() {
    this._mouseWheelToDispose = Ht(this._mouseWheelToDispose), super.dispose();
  }
  getDomNode() {
    return this._domNode;
  }
  getOverviewRulerLayoutInfo() {
    return { parent: this._domNode, insertBefore: this._verticalScrollbar.domNode.domNode };
  }
  delegateVerticalScrollbarPointerDown(e) {
    this._verticalScrollbar.delegatePointerDown(e);
  }
  getScrollDimensions() {
    return this._scrollable.getScrollDimensions();
  }
  setScrollDimensions(e) {
    this._scrollable.setScrollDimensions(e, !1);
  }
  updateClassName(e) {
    this._options.className = e, Je && (this._options.className += " mac"), this._domNode.className = "monaco-scrollable-element " + this._options.className;
  }
  updateOptions(e) {
    e.handleMouseWheel !== void 0 && (this._options.handleMouseWheel = e.handleMouseWheel, this._setListeningToMouseWheel(this._options.handleMouseWheel)), e.mouseWheelScrollSensitivity !== void 0 && (this._options.mouseWheelScrollSensitivity = e.mouseWheelScrollSensitivity), e.fastScrollSensitivity !== void 0 && (this._options.fastScrollSensitivity = e.fastScrollSensitivity), e.scrollPredominantAxis !== void 0 && (this._options.scrollPredominantAxis = e.scrollPredominantAxis), e.horizontal !== void 0 && (this._options.horizontal = e.horizontal), e.vertical !== void 0 && (this._options.vertical = e.vertical), e.horizontalScrollbarSize !== void 0 && (this._options.horizontalScrollbarSize = e.horizontalScrollbarSize), e.verticalScrollbarSize !== void 0 && (this._options.verticalScrollbarSize = e.verticalScrollbarSize), e.scrollByPage !== void 0 && (this._options.scrollByPage = e.scrollByPage), this._horizontalScrollbar.updateOptions(this._options), this._verticalScrollbar.updateOptions(this._options), this._options.lazyRender || this._render();
  }
  delegateScrollFromMouseWheelEvent(e) {
    this._onMouseWheel(new lg(e));
  }
  _setListeningToMouseWheel(e) {
    if (this._mouseWheelToDispose.length > 0 !== e && (this._mouseWheelToDispose = Ht(this._mouseWheelToDispose), e)) {
      const t = (n) => {
        this._onMouseWheel(new lg(n));
      };
      this._mouseWheelToDispose.push(K(this._listenOnDomNode, ie.MOUSE_WHEEL, t, { passive: !1 }));
    }
  }
  _onMouseWheel(e) {
    var t;
    if (!((t = e.browserEvent) === null || t === void 0) && t.defaultPrevented) return;
    const n = hy.INSTANCE;
    n.acceptStandardWheelEvent(e);
    let s = !1;
    if (e.deltaY || e.deltaX) {
      let r = e.deltaY * this._options.mouseWheelScrollSensitivity, a = e.deltaX * this._options.mouseWheelScrollSensitivity;
      this._options.scrollPredominantAxis && (this._options.scrollYToX && a + r === 0 ? a = r = 0 : Math.abs(r) >= Math.abs(a) ? a = 0 : r = 0), this._options.flipAxes && ([r, a] = [a, r]);
      const l = !Je && e.browserEvent && e.browserEvent.shiftKey;
      !this._options.scrollYToX && !l || a || (a = r, r = 0), e.browserEvent && e.browserEvent.altKey && (a *= this._options.fastScrollSensitivity, r *= this._options.fastScrollSensitivity);
      const d = this._scrollable.getFutureScrollPosition();
      let h = {};
      if (r) {
        const c = 50 * r, u = d.scrollTop - (c < 0 ? Math.floor(c) : Math.ceil(c));
        this._verticalScrollbar.writeScrollPosition(h, u);
      }
      if (a) {
        const c = 50 * a, u = d.scrollLeft - (c < 0 ? Math.floor(c) : Math.ceil(c));
        this._horizontalScrollbar.writeScrollPosition(h, u);
      }
      h = this._scrollable.validateScrollPosition(h), (d.scrollLeft !== h.scrollLeft || d.scrollTop !== h.scrollTop) && (this._options.mouseWheelSmoothScroll && n.isPhysicalMouseWheel() ? this._scrollable.setScrollPositionSmooth(h) : this._scrollable.setScrollPositionNow(h), s = !0);
    }
    let o = s;
    !o && this._options.alwaysConsumeMouseWheel && (o = !0), !o && this._options.consumeMouseWheelIfScrollbarIsNeeded && (this._verticalScrollbar.isNeeded() || this._horizontalScrollbar.isNeeded()) && (o = !0), o && (e.preventDefault(), e.stopPropagation());
  }
  _onDidScroll(e) {
    this._shouldRender = this._horizontalScrollbar.onDidScroll(e) || this._shouldRender, this._shouldRender = this._verticalScrollbar.onDidScroll(e) || this._shouldRender, this._options.useShadows && (this._shouldRender = !0), this._revealOnScroll && this._reveal(), this._options.lazyRender || this._render();
  }
  renderNow() {
    if (!this._options.lazyRender) throw new Error("Please use `lazyRender` together with `renderNow`!");
    this._render();
  }
  _render() {
    if (this._shouldRender && (this._shouldRender = !1, this._horizontalScrollbar.render(), this._verticalScrollbar.render(), this._options.useShadows)) {
      const e = this._scrollable.getCurrentScrollPosition(), t = e.scrollTop > 0, n = e.scrollLeft > 0, s = n ? " left" : "", o = t ? " top" : "", r = n || t ? " top-left-corner" : "";
      this._leftShadowDomNode.setClassName(`shadow${s}`), this._topShadowDomNode.setClassName(`shadow${o}`), this._topLeftShadowDomNode.setClassName(`shadow${r}${o}${s}`);
    }
  }
  _onDragStart() {
    this._isDragging = !0, this._reveal();
  }
  _onDragEnd() {
    this._isDragging = !1, this._hide();
  }
  _onMouseLeave(e) {
    this._mouseIsOver = !1, this._hide();
  }
  _onMouseOver(e) {
    this._mouseIsOver = !0, this._reveal();
  }
  _reveal() {
    this._verticalScrollbar.beginReveal(), this._horizontalScrollbar.beginReveal(), this._scheduleHide();
  }
  _hide() {
    this._mouseIsOver || this._isDragging || (this._verticalScrollbar.beginHide(), this._horizontalScrollbar.beginHide());
  }
  _scheduleHide() {
    this._mouseIsOver || this._isDragging || this._hideTimeout.cancelAndSet(() => this._hide(), 500);
  }
}
class LB extends zR {
  constructor(e, t) {
    (t = t || {}).mouseWheelSmoothScroll = !1;
    const n = new bf({ forceIntegerValues: !0, smoothScrollDuration: 0, scheduleAtNextAnimationFrame: (s) => Ys(ke(e), s) });
    super(e, t, n), this._register(n);
  }
  setScrollPosition(e) {
    this._scrollable.setScrollPositionNow(e);
  }
}
class dL extends zR {
  constructor(e, t, n) {
    super(e, t, n);
  }
  setScrollPosition(e) {
    e.reuseAnimation ? this._scrollable.setScrollPositionSmooth(e, e.reuseAnimation) : this._scrollable.setScrollPositionNow(e);
  }
  getScrollPosition() {
    return this._scrollable.getCurrentScrollPosition();
  }
}
class k1 extends zR {
  constructor(e, t) {
    (t = t || {}).mouseWheelSmoothScroll = !1;
    const n = new bf({ forceIntegerValues: !1, smoothScrollDuration: 0, scheduleAtNextAnimationFrame: (s) => Ys(ke(e), s) });
    super(e, t, n), this._register(n), this._element = e, this._register(this.onScroll((s) => {
      s.scrollTopChanged && (this._element.scrollTop = s.scrollTop), s.scrollLeftChanged && (this._element.scrollLeft = s.scrollLeft);
    })), this.scanDomNode();
  }
  setScrollPosition(e) {
    this._scrollable.setScrollPositionNow(e);
  }
  getScrollPosition() {
    return this._scrollable.getCurrentScrollPosition();
  }
  scanDomNode() {
    this.setScrollDimensions({ width: this._element.clientWidth, scrollWidth: this._element.scrollWidth, height: this._element.clientHeight, scrollHeight: this._element.scrollHeight }), this.setScrollPosition({ scrollLeft: this._element.scrollLeft, scrollTop: this._element.scrollTop });
  }
}
class UR extends L1 {
  constructor(e, t, n) {
    super(), this._mouseLeaveMonitor = null, this._context = e, this.viewController = t, this.viewHelper = n, this.mouseTargetFactory = new Gn(this._context, n), this._mouseDownOperation = this._register(new rZ(this._context, this.viewController, this.viewHelper, this.mouseTargetFactory, (r, a) => this._createMouseTarget(r, a), (r) => this._getMouseColumn(r))), this.lastMouseLeaveTime = -1, this._height = this._context.configuration.options.get(145).height;
    const s = new BG(this.viewHelper.viewDomNode);
    this._register(s.onContextMenu(this.viewHelper.viewDomNode, (r) => this._onContextMenu(r, !0))), this._register(s.onMouseMove(this.viewHelper.viewDomNode, (r) => {
      this._onMouseMove(r), this._mouseLeaveMonitor || (this._mouseLeaveMonitor = K(this.viewHelper.viewDomNode.ownerDocument, "mousemove", (a) => {
        this.viewHelper.viewDomNode.contains(a.target) || this._onMouseLeave(new kc(a, !1, this.viewHelper.viewDomNode));
      }));
    })), this._register(s.onMouseUp(this.viewHelper.viewDomNode, (r) => this._onMouseUp(r))), this._register(s.onMouseLeave(this.viewHelper.viewDomNode, (r) => this._onMouseLeave(r)));
    let o = 0;
    this._register(s.onPointerDown(this.viewHelper.viewDomNode, (r, a) => {
      o = a;
    })), this._register(K(this.viewHelper.viewDomNode, ie.POINTER_UP, (r) => {
      this._mouseDownOperation.onPointerUp();
    })), this._register(s.onMouseDown(this.viewHelper.viewDomNode, (r) => this._onMouseDown(r, o))), this._setupMouseWheelZoomListener(), this._context.addEventHandler(this);
  }
  _setupMouseWheelZoomListener() {
    const e = hy.INSTANCE;
    let t = 0, n = Vo.getZoomLevel(), s = !1, o = 0;
    function r(a) {
      return Je ? (a.metaKey || a.ctrlKey) && !a.shiftKey && !a.altKey : a.ctrlKey && !a.metaKey && !a.shiftKey && !a.altKey;
    }
    this._register(K(this.viewHelper.viewDomNode, ie.MOUSE_WHEEL, (a) => {
      if (this.viewController.emitMouseWheel(a), !this._context.configuration.options.get(76)) return;
      const l = new lg(a);
      if (e.acceptStandardWheelEvent(l), e.isPhysicalMouseWheel()) {
        if (r(a)) {
          const d = Vo.getZoomLevel(), h = l.deltaY > 0 ? 1 : -1;
          Vo.setZoomLevel(d + h), l.preventDefault(), l.stopPropagation();
        }
      } else Date.now() - t > 50 && (n = Vo.getZoomLevel(), s = r(a), o = 0), t = Date.now(), o += l.deltaY, s && (Vo.setZoomLevel(n + o / 5), l.preventDefault(), l.stopPropagation());
    }, { capture: !0, passive: !1 }));
  }
  dispose() {
    this._context.removeEventHandler(this), this._mouseLeaveMonitor && (this._mouseLeaveMonitor.dispose(), this._mouseLeaveMonitor = null), super.dispose();
  }
  onConfigurationChanged(e) {
    if (e.hasChanged(145)) {
      const t = this._context.configuration.options.get(145).height;
      this._height !== t && (this._height = t, this._mouseDownOperation.onHeightChanged());
    }
    return !1;
  }
  onCursorStateChanged(e) {
    return this._mouseDownOperation.onCursorStateChanged(e), !1;
  }
  onFocusChanged(e) {
    return !1;
  }
  getTargetAtClientPoint(e, t) {
    const n = new bB(e, t).toPageCoordinates(ke(this.viewHelper.viewDomNode)), s = WR(this.viewHelper.viewDomNode);
    if (n.y < s.y || n.y > s.y + s.height || n.x < s.x || n.x > s.x + s.width) return null;
    const o = VR(this.viewHelper.viewDomNode, s, n);
    return this.mouseTargetFactory.createMouseTarget(this.viewHelper.getLastRenderData(), s, n, o, null);
  }
  _createMouseTarget(e, t) {
    let n = e.target;
    if (!this.viewHelper.viewDomNode.contains(n)) {
      const s = dg(this.viewHelper.viewDomNode);
      s && (n = s.elementsFromPoint(e.posx, e.posy).find((o) => this.viewHelper.viewDomNode.contains(o)));
    }
    return this.mouseTargetFactory.createMouseTarget(this.viewHelper.getLastRenderData(), e.editorPos, e.pos, e.relativePos, t ? n : null);
  }
  _getMouseColumn(e) {
    return this.mouseTargetFactory.getMouseColumn(e.relativePos);
  }
  _onContextMenu(e, t) {
    this.viewController.emitContextMenu({ event: e, target: this._createMouseTarget(e, t) });
  }
  _onMouseMove(e) {
    this.mouseTargetFactory.mouseTargetIsWidget(e) || e.preventDefault(), !this._mouseDownOperation.isActive() && (e.timestamp < this.lastMouseLeaveTime || this.viewController.emitMouseMove({ event: e, target: this._createMouseTarget(e, !0) }));
  }
  _onMouseLeave(e) {
    this._mouseLeaveMonitor && (this._mouseLeaveMonitor.dispose(), this._mouseLeaveMonitor = null), this.lastMouseLeaveTime = (/* @__PURE__ */ new Date()).getTime(), this.viewController.emitMouseLeave({ event: e, target: null });
  }
  _onMouseUp(e) {
    this.viewController.emitMouseUp({ event: e, target: this._createMouseTarget(e, !0) });
  }
  _onMouseDown(e, t) {
    const n = this._createMouseTarget(e, !0), s = n.type === 6 || n.type === 7, o = n.type === 2 || n.type === 3 || n.type === 4, r = n.type === 3, a = this._context.configuration.options.get(109), l = n.type === 8 || n.type === 5, d = n.type === 9;
    let h = e.leftButton || e.middleButton;
    Je && e.leftButton && e.ctrlKey && (h = !1);
    const c = () => {
      e.preventDefault(), this.viewHelper.focusTextArea();
    };
    if (h && (s || r && a)) c(), this._mouseDownOperation.start(n.type, e, t);
    else if (o) e.preventDefault();
    else if (l) {
      const u = n.detail;
      h && this.viewHelper.shouldSuppressMouseDownOnViewZone(u.viewZoneId) && (c(), this._mouseDownOperation.start(n.type, e, t), e.preventDefault());
    } else d && this.viewHelper.shouldSuppressMouseDownOnWidget(n.detail) && (c(), e.preventDefault());
    this.viewController.emitMouseDown({ event: e, target: n });
  }
}
class rZ extends V {
  constructor(e, t, n, s, o, r) {
    super(), this._context = e, this._viewController = t, this._viewHelper = n, this._mouseTargetFactory = s, this._createMouseTarget = o, this._getMouseColumn = r, this._mouseMoveMonitor = this._register(new VG(this._viewHelper.viewDomNode)), this._topBottomDragScrolling = this._register(new aZ(this._context, this._viewHelper, this._mouseTargetFactory, (a, l, d) => this._dispatchMouse(a, l, d))), this._mouseState = new hL(), this._currentSelection = new _e(1, 1, 1, 1), this._isActive = !1, this._lastMouseEvent = null;
  }
  dispose() {
    super.dispose();
  }
  isActive() {
    return this._isActive;
  }
  _onMouseDownThenMove(e) {
    this._lastMouseEvent = e, this._mouseState.setModifiers(e);
    const t = this._findMousePosition(e, !1);
    t && (this._mouseState.isDragAndDrop ? this._viewController.emitMouseDrag({ event: e, target: t }) : t.type !== 13 || t.outsidePosition !== "above" && t.outsidePosition !== "below" ? (this._topBottomDragScrolling.stop(), this._dispatchMouse(t, !0, 1)) : this._topBottomDragScrolling.start(t, e));
  }
  start(e, t, n) {
    this._lastMouseEvent = t, this._mouseState.setStartedOnLineNumbers(e === 3), this._mouseState.setStartButtons(t), this._mouseState.setModifiers(t);
    const s = this._findMousePosition(t, !0);
    if (!s || !s.position) return;
    this._mouseState.trySetCount(t.detail, s.position), t.detail = this._mouseState.count;
    const o = this._context.configuration.options;
    if (!o.get(91) && o.get(35) && !o.get(22) && !this._mouseState.altKey && t.detail < 2 && !this._isActive && !this._currentSelection.isEmpty() && s.type === 6 && s.position && this._currentSelection.containsPosition(s.position)) return this._mouseState.isDragAndDrop = !0, this._isActive = !0, void this._mouseMoveMonitor.startMonitoring(this._viewHelper.viewLinesDomNode, n, t.buttons, (r) => this._onMouseDownThenMove(r), (r) => {
      const a = this._findMousePosition(this._lastMouseEvent, !1);
      _h(r) ? this._viewController.emitMouseDropCanceled() : this._viewController.emitMouseDrop({ event: this._lastMouseEvent, target: a ? this._createMouseTarget(this._lastMouseEvent, !0) : null }), this._stop();
    });
    this._mouseState.isDragAndDrop = !1, this._dispatchMouse(s, t.shiftKey, 1), this._isActive || (this._isActive = !0, this._mouseMoveMonitor.startMonitoring(this._viewHelper.viewLinesDomNode, n, t.buttons, (r) => this._onMouseDownThenMove(r), () => this._stop()));
  }
  _stop() {
    this._isActive = !1, this._topBottomDragScrolling.stop();
  }
  onHeightChanged() {
    this._mouseMoveMonitor.stopMonitoring();
  }
  onPointerUp() {
    this._mouseMoveMonitor.stopMonitoring();
  }
  onCursorStateChanged(e) {
    this._currentSelection = e.selections[0];
  }
  _getPositionOutsideEditor(e) {
    const t = e.editorPos, n = this._context.viewModel, s = this._context.viewLayout, o = this._getMouseColumn(e);
    if (e.posy < t.y) {
      const a = t.y - e.posy, l = Math.max(s.getCurrentScrollTop() - a, 0), d = jm.getZoneAtCoord(this._context, l);
      if (d) {
        const c = this._helpPositionJumpOverViewZone(d);
        if (c) return Yn.createOutsideEditor(o, c, "above", a);
      }
      const h = s.getLineNumberAtVerticalOffset(l);
      return Yn.createOutsideEditor(o, new W(h, 1), "above", a);
    }
    if (e.posy > t.y + t.height) {
      const a = e.posy - t.y - t.height, l = s.getCurrentScrollTop() + e.relativePos.y, d = jm.getZoneAtCoord(this._context, l);
      if (d) {
        const c = this._helpPositionJumpOverViewZone(d);
        if (c) return Yn.createOutsideEditor(o, c, "below", a);
      }
      const h = s.getLineNumberAtVerticalOffset(l);
      return Yn.createOutsideEditor(o, new W(h, n.getLineMaxColumn(h)), "below", a);
    }
    const r = s.getLineNumberAtVerticalOffset(s.getCurrentScrollTop() + e.relativePos.y);
    if (e.posx < t.x) {
      const a = t.x - e.posx;
      return Yn.createOutsideEditor(o, new W(r, 1), "left", a);
    }
    if (e.posx > t.x + t.width) {
      const a = e.posx - t.x - t.width;
      return Yn.createOutsideEditor(o, new W(r, n.getLineMaxColumn(r)), "right", a);
    }
    return null;
  }
  _findMousePosition(e, t) {
    const n = this._getPositionOutsideEditor(e);
    if (n) return n;
    const s = this._createMouseTarget(e, t);
    if (!s.position) return null;
    if (s.type === 8 || s.type === 5) {
      const o = this._helpPositionJumpOverViewZone(s.detail);
      if (o) return Yn.createViewZone(s.type, s.element, s.mouseColumn, o, s.detail);
    }
    return s;
  }
  _helpPositionJumpOverViewZone(e) {
    const t = new W(this._currentSelection.selectionStartLineNumber, this._currentSelection.selectionStartColumn), n = e.positionBefore, s = e.positionAfter;
    return n && s ? n.isBefore(t) ? n : s : null;
  }
  _dispatchMouse(e, t, n) {
    e.position && this._viewController.dispatchMouse({ position: e.position, mouseColumn: e.mouseColumn, startedOnLineNumbers: this._mouseState.startedOnLineNumbers, revealType: n, inSelectionMode: t, mouseDownCount: this._mouseState.count, altKey: this._mouseState.altKey, ctrlKey: this._mouseState.ctrlKey, metaKey: this._mouseState.metaKey, shiftKey: this._mouseState.shiftKey, leftButton: this._mouseState.leftButton, middleButton: this._mouseState.middleButton, onInjectedText: e.type === 6 && e.detail.injectedText !== null });
  }
}
class aZ extends V {
  constructor(e, t, n, s) {
    super(), this._context = e, this._viewHelper = t, this._mouseTargetFactory = n, this._dispatchMouse = s, this._operation = null;
  }
  dispose() {
    super.dispose(), this.stop();
  }
  start(e, t) {
    this._operation ? this._operation.setPosition(e, t) : this._operation = new lZ(this._context, this._viewHelper, this._mouseTargetFactory, this._dispatchMouse, e, t);
  }
  stop() {
    this._operation && (this._operation.dispose(), this._operation = null);
  }
}
class lZ extends V {
  constructor(e, t, n, s, o, r) {
    super(), this._context = e, this._viewHelper = t, this._mouseTargetFactory = n, this._dispatchMouse = s, this._position = o, this._mouseEvent = r, this._lastTime = Date.now(), this._animationFrameDisposable = Ys(ke(r.browserEvent), () => this._execute());
  }
  dispose() {
    this._animationFrameDisposable.dispose(), super.dispose();
  }
  setPosition(e, t) {
    this._position = e, this._mouseEvent = t;
  }
  _tick() {
    const e = Date.now(), t = e - this._lastTime;
    return this._lastTime = e, t;
  }
  _getScrollSpeed() {
    const e = this._context.configuration.options.get(67), t = this._context.configuration.options.get(145).height / e, n = this._position.outsideDistance / e;
    return n <= 1.5 ? Math.max(30, t * (1 + n)) : n <= 3 ? Math.max(60, t * (2 + n)) : Math.max(200, t * (7 + n));
  }
  _execute() {
    const e = this._context.configuration.options.get(67), t = this._getScrollSpeed() * (this._tick() / 1e3) * e, n = this._position.outsidePosition === "above" ? -t : t;
    this._context.viewModel.viewLayout.deltaScrollNow(0, n), this._viewHelper.renderNow();
    const s = this._context.viewLayout.getLinesViewportData(), o = this._position.outsidePosition === "above" ? s.startLineNumber : s.endLineNumber;
    let r;
    {
      const a = WR(this._viewHelper.viewDomNode), l = this._context.configuration.options.get(145).horizontalScrollbarHeight, d = new aL(this._mouseEvent.pos.x, a.y + a.height - l - 0.1), h = VR(this._viewHelper.viewDomNode, a, d);
      r = this._mouseTargetFactory.createMouseTarget(this._viewHelper.getLastRenderData(), a, d, h, null);
    }
    r.position && r.position.lineNumber === o || (r = this._position.outsidePosition === "above" ? Yn.createOutsideEditor(this._position.mouseColumn, new W(o, 1), "above", this._position.outsideDistance) : Yn.createOutsideEditor(this._position.mouseColumn, new W(o, this._context.viewModel.getLineMaxColumn(o)), "below", this._position.outsideDistance)), this._dispatchMouse(r, !0, 2), this._animationFrameDisposable = Ys(ke(r.element), () => this._execute());
  }
}
class hL {
  get altKey() {
    return this._altKey;
  }
  get ctrlKey() {
    return this._ctrlKey;
  }
  get metaKey() {
    return this._metaKey;
  }
  get shiftKey() {
    return this._shiftKey;
  }
  get leftButton() {
    return this._leftButton;
  }
  get middleButton() {
    return this._middleButton;
  }
  get startedOnLineNumbers() {
    return this._startedOnLineNumbers;
  }
  constructor() {
    this._altKey = !1, this._ctrlKey = !1, this._metaKey = !1, this._shiftKey = !1, this._leftButton = !1, this._middleButton = !1, this._startedOnLineNumbers = !1, this._lastMouseDownPosition = null, this._lastMouseDownPositionEqualCount = 0, this._lastMouseDownCount = 0, this._lastSetMouseDownCountTime = 0, this.isDragAndDrop = !1;
  }
  get count() {
    return this._lastMouseDownCount;
  }
  setModifiers(e) {
    this._altKey = e.altKey, this._ctrlKey = e.ctrlKey, this._metaKey = e.metaKey, this._shiftKey = e.shiftKey;
  }
  setStartButtons(e) {
    this._leftButton = e.leftButton, this._middleButton = e.middleButton;
  }
  setStartedOnLineNumbers(e) {
    this._startedOnLineNumbers = e;
  }
  trySetCount(e, t) {
    const n = (/* @__PURE__ */ new Date()).getTime();
    n - this._lastSetMouseDownCountTime > hL.CLEAR_MOUSE_DOWN_COUNT_TIME && (e = 1), this._lastSetMouseDownCountTime = n, e > this._lastMouseDownCount + 1 && (e = this._lastMouseDownCount + 1), this._lastMouseDownPosition && this._lastMouseDownPosition.equals(t) ? this._lastMouseDownPositionEqualCount++ : this._lastMouseDownPositionEqualCount = 1, this._lastMouseDownPosition = t, this._lastMouseDownCount = Math.min(e, this._lastMouseDownPositionEqualCount);
  }
}
hL.CLEAR_MOUSE_DOWN_COUNT_TIME = 400;
class st {
  get event() {
    return this.emitter.event;
  }
  constructor(e, t, n) {
    const s = (o) => this.emitter.fire(o);
    this.emitter = new F({ onWillAddFirstListener: () => e.addEventListener(t, s, n), onDidRemoveLastListener: () => e.removeEventListener(t, s, n) });
  }
  dispose() {
    this.emitter.dispose();
  }
}
class fn {
  constructor(e, t, n, s, o) {
    this.value = e, this.selectionStart = t, this.selectionEnd = n, this.selection = s, this.newlineCountBeforeSelection = o;
  }
  toString() {
    return `[ <${this.value}>, selectionStart: ${this.selectionStart}, selectionEnd: ${this.selectionEnd}]`;
  }
  static readFromTextArea(e, t) {
    const n = e.getValue(), s = e.getSelectionStart(), o = e.getSelectionEnd();
    let r;
    return t && n.substring(0, s) === t.value.substring(0, t.selectionStart) && (r = t.newlineCountBeforeSelection), new fn(n, s, o, null, r);
  }
  collapseSelection() {
    return this.selectionStart === this.value.length ? this : new fn(this.value, this.value.length, this.value.length, null, void 0);
  }
  writeToTextArea(e, t, n) {
    t.setValue(e, this.value), n && t.setSelectionRange(e, this.selectionStart, this.selectionEnd);
  }
  deduceEditorPosition(e) {
    var t, n, s, o, r, a, l, d;
    if (e <= this.selectionStart) {
      const u = this.value.substring(e, this.selectionStart);
      return this._finishDeduceEditorPosition((n = (t = this.selection) === null || t === void 0 ? void 0 : t.getStartPosition()) !== null && n !== void 0 ? n : null, u, -1);
    }
    if (e >= this.selectionEnd) {
      const u = this.value.substring(this.selectionEnd, e);
      return this._finishDeduceEditorPosition((o = (s = this.selection) === null || s === void 0 ? void 0 : s.getEndPosition()) !== null && o !== void 0 ? o : null, u, 1);
    }
    const h = this.value.substring(this.selectionStart, e);
    if (h.indexOf("…") === -1) return this._finishDeduceEditorPosition((a = (r = this.selection) === null || r === void 0 ? void 0 : r.getStartPosition()) !== null && a !== void 0 ? a : null, h, 1);
    const c = this.value.substring(e, this.selectionEnd);
    return this._finishDeduceEditorPosition((d = (l = this.selection) === null || l === void 0 ? void 0 : l.getEndPosition()) !== null && d !== void 0 ? d : null, c, -1);
  }
  _finishDeduceEditorPosition(e, t, n) {
    let s = 0, o = -1;
    for (; (o = t.indexOf(`
`, o + 1)) !== -1; ) s++;
    return [e, n * t.length, s];
  }
  static deduceInput(e, t, n) {
    if (!e) return { text: "", replacePrevCharCnt: 0, replaceNextCharCnt: 0, positionDelta: 0 };
    const s = Math.min(fc(e.value, t.value), e.selectionStart, t.selectionStart), o = Math.min(Vw(e.value, t.value), e.value.length - e.selectionEnd, t.value.length - t.selectionEnd);
    e.value.substring(s, e.value.length - o);
    const r = t.value.substring(s, t.value.length - o), a = e.selectionStart - s, l = e.selectionEnd - s;
    return t.selectionStart - s === t.selectionEnd - s ? { text: r, replacePrevCharCnt: e.selectionStart - s, replaceNextCharCnt: 0, positionDelta: 0 } : { text: r, replacePrevCharCnt: l - a, replaceNextCharCnt: 0, positionDelta: 0 };
  }
  static deduceAndroidCompositionInput(e, t) {
    if (!e) return { text: "", replacePrevCharCnt: 0, replaceNextCharCnt: 0, positionDelta: 0 };
    if (e.value === t.value) return { text: "", replacePrevCharCnt: 0, replaceNextCharCnt: 0, positionDelta: t.selectionEnd - e.selectionEnd };
    const n = Math.min(fc(e.value, t.value), e.selectionEnd), s = Math.min(Vw(e.value, t.value), e.value.length - e.selectionEnd), o = e.value.substring(n, e.value.length - s), r = t.value.substring(n, t.value.length - s);
    e.selectionStart;
    const a = e.selectionEnd - n;
    t.selectionStart;
    const l = t.selectionEnd - n;
    return { text: r, replacePrevCharCnt: a, replaceNextCharCnt: o.length - a, positionDelta: l - r.length };
  }
}
fn.EMPTY = new fn("", 0, 0, null, void 0);
class Op {
  static _getPageOfLine(e, t) {
    return Math.floor((e - 1) / t);
  }
  static _getRangeForPage(e, t) {
    const n = e * t;
    return new D(n + 1, 1, n + t + 1, 1);
  }
  static fromEditorSelection(e, t, n, s) {
    const r = Op._getPageOfLine(t.startLineNumber, n), a = Op._getRangeForPage(r, n), l = Op._getPageOfLine(t.endLineNumber, n), d = Op._getRangeForPage(l, n);
    let h = a.intersectRanges(new D(1, 1, t.startLineNumber, t.startColumn));
    if (s && e.getValueLengthInRange(h, 1) > 500) {
      const v = e.modifyPosition(h.getEndPosition(), -500);
      h = D.fromPositions(v, h.getEndPosition());
    }
    const c = e.getValueInRange(h, 1), u = e.getLineCount(), g = e.getLineMaxColumn(u);
    let p = d.intersectRanges(new D(t.endLineNumber, t.endColumn, u, g));
    if (s && e.getValueLengthInRange(p, 1) > 500) {
      const v = e.modifyPosition(p.getStartPosition(), 500);
      p = D.fromPositions(p.getStartPosition(), v);
    }
    const f = e.getValueInRange(p, 1);
    let _;
    if (r === l || r + 1 === l) _ = e.getValueInRange(t, 1);
    else {
      const v = a.intersectRanges(t), b = d.intersectRanges(t);
      _ = e.getValueInRange(v, 1) + "…" + e.getValueInRange(b, 1);
    }
    return s && _.length > 1e3 && (_ = _.substring(0, 500) + "…" + _.substring(_.length - 500, _.length)), new fn(c + _ + f, c.length, c.length + _.length, t, h.endLineNumber - h.startLineNumber);
  }
}
var cy, dZ = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, $4 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
(function(i) {
  i.Tap = "-monaco-textarea-synthetic-tap";
})(cy || (cy = {}));
const JE = { forceCopyWithSyntaxHighlighting: !1 };
class _v {
  constructor() {
    this._lastState = null;
  }
  set(e, t) {
    this._lastState = { lastCopiedValue: e, data: t };
  }
  get(e) {
    return this._lastState && this._lastState.lastCopiedValue === e ? this._lastState.data : (this._lastState = null, null);
  }
}
_v.INSTANCE = new _v();
class hZ {
  constructor() {
    this._lastTypeTextLength = 0;
  }
  handleCompositionUpdate(e) {
    const t = { text: e = e || "", replacePrevCharCnt: this._lastTypeTextLength, replaceNextCharCnt: 0, positionDelta: 0 };
    return this._lastTypeTextLength = e.length, t;
  }
}
let eI = class extends V {
  get textAreaState() {
    return this._textAreaState;
  }
  constructor(i, e, t, n, s, o) {
    super(), this._host = i, this._textArea = e, this._OS = t, this._browser = n, this._accessibilityService = s, this._logService = o, this._onFocus = this._register(new F()), this.onFocus = this._onFocus.event, this._onBlur = this._register(new F()), this.onBlur = this._onBlur.event, this._onKeyDown = this._register(new F()), this.onKeyDown = this._onKeyDown.event, this._onKeyUp = this._register(new F()), this.onKeyUp = this._onKeyUp.event, this._onCut = this._register(new F()), this.onCut = this._onCut.event, this._onPaste = this._register(new F()), this.onPaste = this._onPaste.event, this._onType = this._register(new F()), this.onType = this._onType.event, this._onCompositionStart = this._register(new F()), this.onCompositionStart = this._onCompositionStart.event, this._onCompositionUpdate = this._register(new F()), this.onCompositionUpdate = this._onCompositionUpdate.event, this._onCompositionEnd = this._register(new F()), this.onCompositionEnd = this._onCompositionEnd.event, this._onSelectionChangeRequest = this._register(new F()), this.onSelectionChangeRequest = this._onSelectionChangeRequest.event, this._asyncFocusGainWriteScreenReaderContent = this._register(new rn()), this._asyncTriggerCut = this._register(new It(() => this._onCut.fire(), 0)), this._textAreaState = fn.EMPTY, this._selectionChangeListener = null, this._accessibilityService.isScreenReaderOptimized() && this.writeNativeTextAreaContent("ctor"), this._register(se.runAndSubscribe(this._accessibilityService.onDidChangeScreenReaderOptimized, () => {
      this._accessibilityService.isScreenReaderOptimized() && !this._asyncFocusGainWriteScreenReaderContent.value ? this._asyncFocusGainWriteScreenReaderContent.value = this._register(new It(() => this.writeNativeTextAreaContent("asyncFocusGain"), 0)) : this._asyncFocusGainWriteScreenReaderContent.clear();
    })), this._hasFocus = !1, this._currentComposition = null;
    let r = null;
    this._register(this._textArea.onKeyDown((a) => {
      const l = new jt(a);
      (l.keyCode === 114 || this._currentComposition && l.keyCode === 1) && l.stopPropagation(), l.equals(9) && l.preventDefault(), r = l, this._onKeyDown.fire(l);
    })), this._register(this._textArea.onKeyUp((a) => {
      const l = new jt(a);
      this._onKeyUp.fire(l);
    })), this._register(this._textArea.onCompositionStart((a) => {
      const l = new hZ();
      if (this._currentComposition) this._currentComposition = l;
      else {
        if (this._currentComposition = l, this._OS === 2 && r && r.equals(114) && this._textAreaState.selectionStart === this._textAreaState.selectionEnd && this._textAreaState.selectionStart > 0 && this._textAreaState.value.substr(this._textAreaState.selectionStart - 1, 1) === a.data && (r.code === "ArrowRight" || r.code === "ArrowLeft")) return l.handleCompositionUpdate("x"), void this._onCompositionStart.fire({ data: a.data });
        this._browser.isAndroid, this._onCompositionStart.fire({ data: a.data });
      }
    })), this._register(this._textArea.onCompositionUpdate((a) => {
      const l = this._currentComposition;
      if (!l) return;
      if (this._browser.isAndroid) {
        const h = fn.readFromTextArea(this._textArea, this._textAreaState), c = fn.deduceAndroidCompositionInput(this._textAreaState, h);
        return this._textAreaState = h, this._onType.fire(c), void this._onCompositionUpdate.fire(a);
      }
      const d = l.handleCompositionUpdate(a.data);
      this._textAreaState = fn.readFromTextArea(this._textArea, this._textAreaState), this._onType.fire(d), this._onCompositionUpdate.fire(a);
    })), this._register(this._textArea.onCompositionEnd((a) => {
      const l = this._currentComposition;
      if (!l) return;
      if (this._currentComposition = null, this._browser.isAndroid) {
        const h = fn.readFromTextArea(this._textArea, this._textAreaState), c = fn.deduceAndroidCompositionInput(this._textAreaState, h);
        return this._textAreaState = h, this._onType.fire(c), void this._onCompositionEnd.fire();
      }
      const d = l.handleCompositionUpdate(a.data);
      this._textAreaState = fn.readFromTextArea(this._textArea, this._textAreaState), this._onType.fire(d), this._onCompositionEnd.fire();
    })), this._register(this._textArea.onInput((a) => {
      if (this._textArea.setIgnoreSelectionChangeTime("received input event"), this._currentComposition) return;
      const l = fn.readFromTextArea(this._textArea, this._textAreaState), d = fn.deduceInput(this._textAreaState, l, this._OS === 2);
      (d.replacePrevCharCnt !== 0 || d.text.length !== 1 || !en(d.text.charCodeAt(0)) && d.text.charCodeAt(0) !== 127) && (this._textAreaState = l, d.text === "" && d.replacePrevCharCnt === 0 && d.replaceNextCharCnt === 0 && d.positionDelta === 0 || this._onType.fire(d));
    })), this._register(this._textArea.onCut((a) => {
      this._textArea.setIgnoreSelectionChangeTime("received cut event"), this._ensureClipboardGetsEditorSelection(a), this._asyncTriggerCut.schedule();
    })), this._register(this._textArea.onCopy((a) => {
      this._ensureClipboardGetsEditorSelection(a);
    })), this._register(this._textArea.onPaste((a) => {
      if (this._textArea.setIgnoreSelectionChangeTime("received paste event"), a.preventDefault(), !a.clipboardData) return;
      let [l, d] = tI.getTextData(a.clipboardData);
      l && (d = d || _v.INSTANCE.get(l), this._onPaste.fire({ text: l, metadata: d }));
    })), this._register(this._textArea.onFocus(() => {
      const a = this._hasFocus;
      this._setHasFocus(!0), this._accessibilityService.isScreenReaderOptimized() && this._browser.isSafari && !a && this._hasFocus && (this._asyncFocusGainWriteScreenReaderContent.value || (this._asyncFocusGainWriteScreenReaderContent.value = new It(() => this.writeNativeTextAreaContent("asyncFocusGain"), 0)), this._asyncFocusGainWriteScreenReaderContent.value.schedule());
    })), this._register(this._textArea.onBlur(() => {
      this._currentComposition && (this._currentComposition = null, this.writeNativeTextAreaContent("blurWithoutCompositionEnd"), this._onCompositionEnd.fire()), this._setHasFocus(!1);
    })), this._register(this._textArea.onSyntheticTap(() => {
      this._browser.isAndroid && this._currentComposition && (this._currentComposition = null, this.writeNativeTextAreaContent("tapWithoutCompositionEnd"), this._onCompositionEnd.fire());
    }));
  }
  _installSelectionChangeListener() {
    let i = 0;
    return K(this._textArea.ownerDocument, "selectionchange", (e) => {
      if (Mh.onSelectionChange(), !this._hasFocus || this._currentComposition || !this._browser.isChrome) return;
      const t = Date.now(), n = t - i;
      if (i = t, n < 5) return;
      const s = t - this._textArea.getIgnoreSelectionChangeTime();
      if (this._textArea.resetSelectionChangeTime(), s < 100 || !this._textAreaState.selection) return;
      const o = this._textArea.getValue();
      if (this._textAreaState.value !== o) return;
      const r = this._textArea.getSelectionStart(), a = this._textArea.getSelectionEnd();
      if (this._textAreaState.selectionStart === r && this._textAreaState.selectionEnd === a) return;
      const l = this._textAreaState.deduceEditorPosition(r), d = this._host.deduceModelPosition(l[0], l[1], l[2]), h = this._textAreaState.deduceEditorPosition(a), c = this._host.deduceModelPosition(h[0], h[1], h[2]), u = new _e(d.lineNumber, d.column, c.lineNumber, c.column);
      this._onSelectionChangeRequest.fire(u);
    });
  }
  dispose() {
    super.dispose(), this._selectionChangeListener && (this._selectionChangeListener.dispose(), this._selectionChangeListener = null);
  }
  focusTextArea() {
    this._setHasFocus(!0), this.refreshFocusState();
  }
  isFocused() {
    return this._hasFocus;
  }
  refreshFocusState() {
    this._setHasFocus(this._textArea.hasFocus());
  }
  _setHasFocus(i) {
    this._hasFocus !== i && (this._hasFocus = i, this._selectionChangeListener && (this._selectionChangeListener.dispose(), this._selectionChangeListener = null), this._hasFocus && (this._selectionChangeListener = this._installSelectionChangeListener()), this._hasFocus && this.writeNativeTextAreaContent("focusgain"), this._hasFocus ? this._onFocus.fire() : this._onBlur.fire());
  }
  _setAndWriteTextAreaState(i, e) {
    this._hasFocus || (e = e.collapseSelection()), e.writeToTextArea(i, this._textArea, this._hasFocus), this._textAreaState = e;
  }
  writeNativeTextAreaContent(i) {
    !this._accessibilityService.isScreenReaderOptimized() && i === "render" || this._currentComposition || (this._logService.trace(`writeTextAreaState(reason: ${i})`), this._setAndWriteTextAreaState(i, this._host.getScreenReaderContent()));
  }
  _ensureClipboardGetsEditorSelection(i) {
    const e = this._host.getDataToCopy(), t = { version: 1, isFromEmptySelection: e.isFromEmptySelection, multicursorText: e.multicursorText, mode: e.mode };
    _v.INSTANCE.set(this._browser.isFirefox ? e.text.replace(/\r\n/g, `
`) : e.text, t), i.preventDefault(), i.clipboardData && tI.setTextData(i.clipboardData, e.text, e.html, t);
  }
};
eI = dZ([$4(4, or), $4(5, ts)], eI);
const tI = { getTextData(i) {
  const e = i.getData(vi.text);
  let t = null;
  const n = i.getData("vscode-editor-data");
  if (typeof n == "string") try {
    t = JSON.parse(n), t.version !== 1 && (t = null);
  } catch {
  }
  return e.length === 0 && t === null && i.files.length > 0 ? [Array.prototype.slice.call(i.files, 0).map((s) => s.name).join(`
`), null] : [e, t];
}, setTextData(i, e, t, n) {
  i.setData(vi.text, e), typeof t == "string" && i.setData("text/html", t), i.setData("vscode-editor-data", JSON.stringify(n));
} };
class cZ extends V {
  get ownerDocument() {
    return this._actual.ownerDocument;
  }
  constructor(e) {
    super(), this._actual = e, this.onKeyDown = this._register(new st(this._actual, "keydown")).event, this.onKeyUp = this._register(new st(this._actual, "keyup")).event, this.onCompositionStart = this._register(new st(this._actual, "compositionstart")).event, this.onCompositionUpdate = this._register(new st(this._actual, "compositionupdate")).event, this.onCompositionEnd = this._register(new st(this._actual, "compositionend")).event, this.onBeforeInput = this._register(new st(this._actual, "beforeinput")).event, this.onInput = this._register(new st(this._actual, "input")).event, this.onCut = this._register(new st(this._actual, "cut")).event, this.onCopy = this._register(new st(this._actual, "copy")).event, this.onPaste = this._register(new st(this._actual, "paste")).event, this.onFocus = this._register(new st(this._actual, "focus")).event, this.onBlur = this._register(new st(this._actual, "blur")).event, this._onSyntheticTap = this._register(new F()), this.onSyntheticTap = this._onSyntheticTap.event, this._ignoreSelectionChangeTime = 0, this._register(this.onKeyDown(() => Mh.onKeyDown())), this._register(this.onBeforeInput(() => Mh.onBeforeInput())), this._register(this.onInput(() => Mh.onInput())), this._register(this.onKeyUp(() => Mh.onKeyUp())), this._register(K(this._actual, cy.Tap, () => this._onSyntheticTap.fire()));
  }
  hasFocus() {
    const e = dg(this._actual);
    return e ? e.activeElement === this._actual : !!this._actual.isConnected && Mn() === this._actual;
  }
  setIgnoreSelectionChangeTime(e) {
    this._ignoreSelectionChangeTime = Date.now();
  }
  getIgnoreSelectionChangeTime() {
    return this._ignoreSelectionChangeTime;
  }
  resetSelectionChangeTime() {
    this._ignoreSelectionChangeTime = 0;
  }
  getValue() {
    return this._actual.value;
  }
  setValue(e, t) {
    const n = this._actual;
    n.value !== t && (this.setIgnoreSelectionChangeTime("setValue"), n.value = t);
  }
  getSelectionStart() {
    return this._actual.selectionDirection === "backward" ? this._actual.selectionEnd : this._actual.selectionStart;
  }
  getSelectionEnd() {
    return this._actual.selectionDirection === "backward" ? this._actual.selectionStart : this._actual.selectionEnd;
  }
  setSelectionRange(e, t, n) {
    const s = this._actual;
    let o = null;
    const r = dg(s);
    o = r ? r.activeElement : Mn();
    const a = ke(o), l = o === s, d = s.selectionStart, h = s.selectionEnd;
    if (l && d === t && h === n) tr && a.parent !== a && s.focus();
    else {
      if (l) return this.setIgnoreSelectionChangeTime("setSelectionRange"), s.setSelectionRange(t, n), void (tr && a.parent !== a && s.focus());
      try {
        const c = function(u) {
          const g = [];
          for (let p = 0; u && u.nodeType === u.ELEMENT_NODE; p++) g[p] = u.scrollTop, u = u.parentNode;
          return g;
        }(s);
        this.setIgnoreSelectionChangeTime("setSelectionRange"), s.focus(), s.setSelectionRange(t, n), function(u, g) {
          for (let p = 0; u && u.nodeType === u.ELEMENT_NODE; p++) u.scrollTop !== g[p] && (u.scrollTop = g[p]), u = u.parentNode;
        }(s, c);
      } catch {
      }
    }
  }
}
class uZ extends UR {
  constructor(e, t, n) {
    super(e, t, n), this._register(Bt.addTarget(this.viewHelper.linesContentDomNode)), this._register(K(this.viewHelper.linesContentDomNode, Vt.Tap, (o) => this.onTap(o))), this._register(K(this.viewHelper.linesContentDomNode, Vt.Change, (o) => this.onChange(o))), this._register(K(this.viewHelper.linesContentDomNode, Vt.Contextmenu, (o) => this._onContextMenu(new kc(o, !1, this.viewHelper.viewDomNode), !1))), this._lastPointerType = "mouse", this._register(K(this.viewHelper.linesContentDomNode, "pointerdown", (o) => {
      const r = o.pointerType;
      this._lastPointerType = r !== "mouse" ? r === "touch" ? "touch" : "pen" : "mouse";
    }));
    const s = new WG(this.viewHelper.viewDomNode);
    this._register(s.onPointerMove(this.viewHelper.viewDomNode, (o) => this._onMouseMove(o))), this._register(s.onPointerUp(this.viewHelper.viewDomNode, (o) => this._onMouseUp(o))), this._register(s.onPointerLeave(this.viewHelper.viewDomNode, (o) => this._onMouseLeave(o))), this._register(s.onPointerDown(this.viewHelper.viewDomNode, (o, r) => this._onMouseDown(o, r)));
  }
  onTap(e) {
    e.initialTarget && this.viewHelper.linesContentDomNode.contains(e.initialTarget) && (e.preventDefault(), this.viewHelper.focusTextArea(), this._dispatchGesture(e, !1));
  }
  onChange(e) {
    this._lastPointerType === "touch" && this._context.viewModel.viewLayout.deltaScrollNow(-e.translationX, -e.translationY), this._lastPointerType === "pen" && this._dispatchGesture(e, !0);
  }
  _dispatchGesture(e, t) {
    const n = this._createMouseTarget(new kc(e, !1, this.viewHelper.viewDomNode), !1);
    n.position && this.viewController.dispatchMouse({ position: n.position, mouseColumn: n.position.column, startedOnLineNumbers: !1, revealType: 1, mouseDownCount: e.tapCount, inSelectionMode: t, altKey: !1, ctrlKey: !1, metaKey: !1, shiftKey: !1, leftButton: !1, middleButton: !1, onInjectedText: n.type === 6 && n.detail.injectedText !== null });
  }
  _onMouseDown(e, t) {
    e.browserEvent.pointerType !== "touch" && super._onMouseDown(e, t);
  }
}
class gZ extends UR {
  constructor(e, t, n) {
    super(e, t, n), this._register(Bt.addTarget(this.viewHelper.linesContentDomNode)), this._register(K(this.viewHelper.linesContentDomNode, Vt.Tap, (s) => this.onTap(s))), this._register(K(this.viewHelper.linesContentDomNode, Vt.Change, (s) => this.onChange(s))), this._register(K(this.viewHelper.linesContentDomNode, Vt.Contextmenu, (s) => this._onContextMenu(new kc(s, !1, this.viewHelper.viewDomNode), !1)));
  }
  onTap(e) {
    e.preventDefault(), this.viewHelper.focusTextArea();
    const t = this._createMouseTarget(new kc(e, !1, this.viewHelper.viewDomNode), !1);
    if (t.position) {
      const n = document.createEvent("CustomEvent");
      n.initEvent(cy.Tap, !1, !0), this.viewHelper.dispatchTextAreaEvent(n), this.viewController.moveTo(t.position, 1);
    }
  }
  onChange(e) {
    this._context.viewModel.viewLayout.deltaScrollNow(-e.translationX, -e.translationY);
  }
}
class pZ extends V {
  constructor(e, t, n) {
    super(), (ua || tK && S7) && hR ? this.handler = this._register(new uZ(e, t, n)) : Et.TouchEvent ? this.handler = this._register(new gZ(e, t, n)) : this.handler = this._register(new UR(e, t, n));
  }
  getTargetAtClientPoint(e, t) {
    return this.handler.getTargetAtClientPoint(e, t);
  }
}
class Mg extends L1 {
}
const Yi = tt("themeService");
function ui(i) {
  return { id: i };
}
function iI(i) {
  switch (i) {
    case Zo.DARK:
      return "vs-dark";
    case Zo.HIGH_CONTRAST_DARK:
      return "hc-black";
    case Zo.HIGH_CONTRAST_LIGHT:
      return "hc-light";
    default:
      return "vs";
  }
}
const kB = "base.contributions.theming", DB = new class {
  constructor() {
    this.themingParticipants = [], this.themingParticipants = [], this.onThemingParticipantAddedEmitter = new F();
  }
  onColorThemeChange(i) {
    return this.themingParticipants.push(i), this.onThemingParticipantAddedEmitter.fire(i), ye(() => {
      const e = this.themingParticipants.indexOf(i);
      this.themingParticipants.splice(e, 1);
    });
  }
  getThemingParticipants() {
    return this.themingParticipants;
  }
}();
function rr(i) {
  return DB.onColorThemeChange(i);
}
li.add(kB, DB);
class mZ extends V {
  constructor(e) {
    super(), this.themeService = e, this.theme = e.getColorTheme(), this._register(this.themeService.onDidColorThemeChange((t) => this.onThemeChange(t)));
  }
  onThemeChange(e) {
    this.theme = e, this.updateStyles();
  }
  updateStyles() {
  }
}
const xB = I("editor.lineHighlightBackground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Background color for the highlight of line at the cursor position.")), G4 = I("editor.lineHighlightBorder", { dark: "#282828", light: "#eeeeee", hcDark: "#f38518", hcLight: ot }, m(0, "Background color for the border around the line at the cursor position."));
I("editor.rangeHighlightBackground", { dark: "#ffffff0b", light: "#fdff0033", hcDark: null, hcLight: null }, m(0, "Background color of highlighted ranges, like by quick open and find features. The color must not be opaque so as not to hide underlying decorations."), !0), I("editor.rangeHighlightBorder", { dark: null, light: null, hcDark: Zt, hcLight: Zt }, m(0, "Background color of the border around highlighted ranges."), !0), I("editor.symbolHighlightBackground", { dark: hd, light: hd, hcDark: null, hcLight: null }, m(0, "Background color of highlighted symbol, like for go to definition or go next/previous symbol. The color must not be opaque so as not to hide underlying decorations."), !0), I("editor.symbolHighlightBorder", { dark: null, light: null, hcDark: Zt, hcLight: Zt }, m(0, "Background color of the border around highlighted symbols."), !0);
const ll = I("editorCursor.foreground", { dark: "#AEAFAD", light: z.black, hcDark: z.white, hcLight: "#0F4A85" }, m(0, "Color of the editor cursor.")), fd = I("editorCursor.background", null, m(0, "The background color of the editor cursor. Allows customizing the color of a character overlapped by a block cursor.")), NB = I("editorMultiCursor.primary.foreground", { dark: ll, light: ll, hcDark: ll, hcLight: ll }, m(0, "Color of the primary editor cursor when multiple cursors are present.")), fZ = I("editorMultiCursor.primary.background", { dark: fd, light: fd, hcDark: fd, hcLight: fd }, m(0, "The background color of the primary editor cursor when multiple cursors are present. Allows customizing the color of a character overlapped by a block cursor.")), EB = I("editorMultiCursor.secondary.foreground", { dark: ll, light: ll, hcDark: ll, hcLight: ll }, m(0, "Color of secondary editor cursors when multiple cursors are present.")), _Z = I("editorMultiCursor.secondary.background", { dark: fd, light: fd, hcDark: fd, hcLight: fd }, m(0, "The background color of secondary editor cursors when multiple cursors are present. Allows customizing the color of a character overlapped by a block cursor.")), _d = I("editorWhitespace.foreground", { dark: "#e3e4e229", light: "#33333333", hcDark: "#e3e4e229", hcLight: "#CCCCCC" }, m(0, "Color of whitespace characters in the editor.")), vZ = I("editorLineNumber.foreground", { dark: "#858585", light: "#237893", hcDark: z.white, hcLight: "#292929" }, m(0, "Color of editor line numbers.")), ub = I("editorIndentGuide.background", { dark: _d, light: _d, hcDark: _d, hcLight: _d }, m(0, "Color of the editor indentation guides."), !1, m(0, "'editorIndentGuide.background' is deprecated. Use 'editorIndentGuide.background1' instead.")), gb = I("editorIndentGuide.activeBackground", { dark: _d, light: _d, hcDark: _d, hcLight: _d }, m(0, "Color of the active editor indentation guides."), !1, m(0, "'editorIndentGuide.activeBackground' is deprecated. Use 'editorIndentGuide.activeBackground1' instead.")), D1 = I("editorIndentGuide.background1", { dark: ub, light: ub, hcDark: ub, hcLight: ub }, m(0, "Color of the editor indentation guides (1).")), bZ = I("editorIndentGuide.background2", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Color of the editor indentation guides (2).")), CZ = I("editorIndentGuide.background3", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Color of the editor indentation guides (3).")), wZ = I("editorIndentGuide.background4", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Color of the editor indentation guides (4).")), yZ = I("editorIndentGuide.background5", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Color of the editor indentation guides (5).")), SZ = I("editorIndentGuide.background6", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Color of the editor indentation guides (6).")), x1 = I("editorIndentGuide.activeBackground1", { dark: gb, light: gb, hcDark: gb, hcLight: gb }, m(0, "Color of the active editor indentation guides (1).")), LZ = I("editorIndentGuide.activeBackground2", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Color of the active editor indentation guides (2).")), kZ = I("editorIndentGuide.activeBackground3", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Color of the active editor indentation guides (3).")), DZ = I("editorIndentGuide.activeBackground4", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Color of the active editor indentation guides (4).")), xZ = I("editorIndentGuide.activeBackground5", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Color of the active editor indentation guides (5).")), NZ = I("editorIndentGuide.activeBackground6", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Color of the active editor indentation guides (6).")), pb = I("editorActiveLineNumber.foreground", { dark: "#c6c6c6", light: "#0B216F", hcDark: Zt, hcLight: Zt }, m(0, "Color of editor active line number"), !1, m(0, "Id is deprecated. Use 'editorLineNumber.activeForeground' instead."));
I("editorLineNumber.activeForeground", { dark: pb, light: pb, hcDark: pb, hcLight: pb }, m(0, "Color of editor active line number"));
const EZ = I("editorLineNumber.dimmedForeground", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Color of the final editor line when editor.renderFinalNewline is set to dimmed."));
I("editorRuler.foreground", { dark: "#5A5A5A", light: z.lightgrey, hcDark: z.white, hcLight: "#292929" }, m(0, "Color of the editor rulers.")), I("editorCodeLens.foreground", { dark: "#999999", light: "#919191", hcDark: "#999999", hcLight: "#292929" }, m(0, "Foreground color of editor CodeLens")), I("editorBracketMatch.background", { dark: "#0064001a", light: "#0064001a", hcDark: "#0064001a", hcLight: "#0000" }, m(0, "Background color behind matching brackets")), I("editorBracketMatch.border", { dark: "#888", light: "#B9B9B9", hcDark: ot, hcLight: ot }, m(0, "Color for matching brackets boxes"));
const IZ = I("editorOverviewRuler.border", { dark: "#7f7f7f4d", light: "#7f7f7f4d", hcDark: "#7f7f7f4d", hcLight: "#666666" }, m(0, "Color of the overview ruler border.")), MZ = I("editorOverviewRuler.background", null, m(0, "Background color of the editor overview ruler."));
I("editorGutter.background", { dark: sn, light: sn, hcDark: sn, hcLight: sn }, m(0, "Background color of the editor gutter. The gutter contains the glyph margins and the line numbers.")), I("editorUnnecessaryCode.border", { dark: null, light: null, hcDark: z.fromHex("#fff").transparent(0.8), hcLight: ot }, m(0, "Border color of unnecessary (unused) source code in the editor."));
const TZ = I("editorUnnecessaryCode.opacity", { dark: z.fromHex("#000a"), light: z.fromHex("#0007"), hcDark: null, hcLight: null }, m(0, `Opacity of unnecessary (unused) source code in the editor. For example, "#000000c0" will render the code with 75% opacity. For high contrast themes, use the  'editorUnnecessaryCode.border' theme color to underline unnecessary code instead of fading it out.`));
I("editorGhostText.border", { dark: null, light: null, hcDark: z.fromHex("#fff").transparent(0.8), hcLight: z.fromHex("#292929").transparent(0.8) }, m(0, "Border color of ghost text in the editor.")), I("editorGhostText.foreground", { dark: z.fromHex("#ffffff56"), light: z.fromHex("#0007"), hcDark: null, hcLight: null }, m(0, "Foreground color of the ghost text in the editor.")), I("editorGhostText.background", { dark: null, light: null, hcDark: null, hcLight: null }, m(0, "Background color of the ghost text in the editor."));
const mb = new z(new ht(0, 122, 204, 0.6)), IB = I("editorOverviewRuler.rangeHighlightForeground", { dark: mb, light: mb, hcDark: mb, hcLight: mb }, m(0, "Overview ruler marker color for range highlights. The color must not be opaque so as not to hide underlying decorations."), !0), RZ = I("editorOverviewRuler.errorForeground", { dark: new z(new ht(255, 18, 18, 0.7)), light: new z(new ht(255, 18, 18, 0.7)), hcDark: new z(new ht(255, 50, 50, 1)), hcLight: "#B5200D" }, m(0, "Overview ruler marker color for errors.")), AZ = I("editorOverviewRuler.warningForeground", { dark: Qn, light: Qn, hcDark: gv, hcLight: gv }, m(0, "Overview ruler marker color for warnings.")), PZ = I("editorOverviewRuler.infoForeground", { dark: Rs, light: Rs, hcDark: pv, hcLight: pv }, m(0, "Overview ruler marker color for infos.")), MB = I("editorBracketHighlight.foreground1", { dark: "#FFD700", light: "#0431FAFF", hcDark: "#FFD700", hcLight: "#0431FAFF" }, m(0, "Foreground color of brackets (1). Requires enabling bracket pair colorization.")), TB = I("editorBracketHighlight.foreground2", { dark: "#DA70D6", light: "#319331FF", hcDark: "#DA70D6", hcLight: "#319331FF" }, m(0, "Foreground color of brackets (2). Requires enabling bracket pair colorization.")), RB = I("editorBracketHighlight.foreground3", { dark: "#179FFF", light: "#7B3814FF", hcDark: "#87CEFA", hcLight: "#7B3814FF" }, m(0, "Foreground color of brackets (3). Requires enabling bracket pair colorization.")), AB = I("editorBracketHighlight.foreground4", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Foreground color of brackets (4). Requires enabling bracket pair colorization.")), PB = I("editorBracketHighlight.foreground5", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Foreground color of brackets (5). Requires enabling bracket pair colorization.")), OB = I("editorBracketHighlight.foreground6", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Foreground color of brackets (6). Requires enabling bracket pair colorization.")), OZ = I("editorBracketHighlight.unexpectedBracket.foreground", { dark: new z(new ht(255, 18, 18, 0.8)), light: new z(new ht(255, 18, 18, 0.8)), hcDark: new z(new ht(255, 50, 50, 1)), hcLight: "" }, m(0, "Foreground color of unexpected brackets.")), FZ = I("editorBracketPairGuide.background1", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of inactive bracket pair guides (1). Requires enabling bracket pair guides.")), BZ = I("editorBracketPairGuide.background2", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of inactive bracket pair guides (2). Requires enabling bracket pair guides.")), WZ = I("editorBracketPairGuide.background3", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of inactive bracket pair guides (3). Requires enabling bracket pair guides.")), VZ = I("editorBracketPairGuide.background4", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of inactive bracket pair guides (4). Requires enabling bracket pair guides.")), HZ = I("editorBracketPairGuide.background5", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of inactive bracket pair guides (5). Requires enabling bracket pair guides.")), zZ = I("editorBracketPairGuide.background6", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of inactive bracket pair guides (6). Requires enabling bracket pair guides.")), UZ = I("editorBracketPairGuide.activeBackground1", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of active bracket pair guides (1). Requires enabling bracket pair guides.")), KZ = I("editorBracketPairGuide.activeBackground2", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of active bracket pair guides (2). Requires enabling bracket pair guides.")), jZ = I("editorBracketPairGuide.activeBackground3", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of active bracket pair guides (3). Requires enabling bracket pair guides.")), qZ = I("editorBracketPairGuide.activeBackground4", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of active bracket pair guides (4). Requires enabling bracket pair guides.")), $Z = I("editorBracketPairGuide.activeBackground5", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of active bracket pair guides (5). Requires enabling bracket pair guides.")), GZ = I("editorBracketPairGuide.activeBackground6", { dark: "#00000000", light: "#00000000", hcDark: "#00000000", hcLight: "#00000000" }, m(0, "Background color of active bracket pair guides (6). Requires enabling bracket pair guides."));
I("editorUnicodeHighlight.border", { dark: Qn, light: Qn, hcDark: Qn, hcLight: Qn }, m(0, "Border color used to highlight unicode characters.")), I("editorUnicodeHighlight.background", { dark: lb, light: lb, hcDark: lb, hcLight: lb }, m(0, "Background color used to highlight unicode characters.")), rr((i, e) => {
  const t = i.getColor(sn), n = i.getColor(xB), s = n && !n.isTransparent() ? n : t;
  s && e.addRule(`.monaco-editor .inputarea.ime-input { background-color: ${s}; }`);
});
class N1 extends Mg {
  constructor(e) {
    super(), this._context = e, this._readConfig(), this._lastCursorModelPosition = new W(1, 1), this._renderResult = null, this._activeLineNumber = 1, this._context.addEventHandler(this);
  }
  _readConfig() {
    const e = this._context.configuration.options;
    this._lineHeight = e.get(67);
    const t = e.get(68);
    this._renderLineNumbers = t.renderType, this._renderCustomLineNumbers = t.renderFn, this._renderFinalNewline = e.get(95);
    const n = e.get(145);
    this._lineNumbersLeft = n.lineNumbersLeft, this._lineNumbersWidth = n.lineNumbersWidth;
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  onConfigurationChanged(e) {
    return this._readConfig(), !0;
  }
  onCursorStateChanged(e) {
    const t = e.selections[0].getPosition();
    this._lastCursorModelPosition = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(t);
    let n = !1;
    return this._activeLineNumber !== t.lineNumber && (this._activeLineNumber = t.lineNumber, n = !0), this._renderLineNumbers !== 2 && this._renderLineNumbers !== 3 || (n = !0), n;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  onDecorationsChanged(e) {
    return e.affectsLineNumber;
  }
  _getLineRenderLineNumber(e) {
    const t = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new W(e, 1));
    if (t.column !== 1) return "";
    const n = t.lineNumber;
    if (this._renderCustomLineNumbers) return this._renderCustomLineNumbers(n);
    if (this._renderLineNumbers === 2) {
      const s = Math.abs(this._lastCursorModelPosition.lineNumber - n);
      return s === 0 ? '<span class="relative-current-line-number">' + n + "</span>" : String(s);
    }
    return this._renderLineNumbers === 3 ? this._lastCursorModelPosition.lineNumber === n || n % 10 == 0 || n === this._context.viewModel.getLineCount() ? String(n) : "" : String(n);
  }
  prepareRender(e) {
    if (this._renderLineNumbers === 0) return void (this._renderResult = null);
    const t = Cs ? this._lineHeight % 2 == 0 ? " lh-even" : " lh-odd" : "", n = e.visibleRange.startLineNumber, s = e.visibleRange.endLineNumber, o = this._context.viewModel.getDecorationsInViewport(e.visibleRange).filter((d) => !!d.options.lineNumberClassName);
    o.sort((d, h) => D.compareRangesUsingEnds(d.range, h.range));
    let r = 0;
    const a = this._context.viewModel.getLineCount(), l = [];
    for (let d = n; d <= s; d++) {
      const h = d - n;
      let c = this._getLineRenderLineNumber(d), u = "";
      for (; r < o.length && o[r].range.endLineNumber < d; ) r++;
      for (let g = r; g < o.length; g++) {
        const { range: p, options: f } = o[g];
        p.startLineNumber <= d && (u += " " + f.lineNumberClassName);
      }
      c || u ? (d === a && this._context.viewModel.getLineLength(d) === 0 && (this._renderFinalNewline === "off" && (c = ""), this._renderFinalNewline === "dimmed" && (u += " dimmed-line-number")), d === this._activeLineNumber && (u += " active-line-number"), l[h] = `<div class="${N1.CLASS_NAME}${t}${u}" style="left:${this._lineNumbersLeft}px;width:${this._lineNumbersWidth}px;">${c}</div>`) : l[h] = "";
    }
    this._renderResult = l;
  }
  render(e, t) {
    if (!this._renderResult) return "";
    const n = t - e;
    return n < 0 || n >= this._renderResult.length ? "" : this._renderResult[n];
  }
}
N1.CLASS_NAME = "line-numbers", rr((i, e) => {
  const t = i.getColor(vZ), n = i.getColor(EZ);
  n ? e.addRule(`.monaco-editor .line-numbers.dimmed-line-number { color: ${n}; }`) : t && e.addRule(`.monaco-editor .line-numbers.dimmed-line-number { color: ${t.transparent(0.4)}; }`);
});
class ug extends to {
  constructor(e) {
    super(e);
    const t = this._context.configuration.options, n = t.get(145);
    this._canUseLayerHinting = !t.get(32), this._contentLeft = n.contentLeft, this._glyphMarginLeft = n.glyphMarginLeft, this._glyphMarginWidth = n.glyphMarginWidth, this._domNode = wt(document.createElement("div")), this._domNode.setClassName(ug.OUTER_CLASS_NAME), this._domNode.setPosition("absolute"), this._domNode.setAttribute("role", "presentation"), this._domNode.setAttribute("aria-hidden", "true"), this._glyphMarginBackgroundDomNode = wt(document.createElement("div")), this._glyphMarginBackgroundDomNode.setClassName(ug.CLASS_NAME), this._domNode.appendChild(this._glyphMarginBackgroundDomNode);
  }
  dispose() {
    super.dispose();
  }
  getDomNode() {
    return this._domNode;
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, n = t.get(145);
    return this._canUseLayerHinting = !t.get(32), this._contentLeft = n.contentLeft, this._glyphMarginLeft = n.glyphMarginLeft, this._glyphMarginWidth = n.glyphMarginWidth, !0;
  }
  onScrollChanged(e) {
    return super.onScrollChanged(e) || e.scrollTopChanged;
  }
  prepareRender(e) {
  }
  render(e) {
    this._domNode.setLayerHinting(this._canUseLayerHinting), this._domNode.setContain("strict");
    const t = e.scrollTop - e.bigNumbersDelta;
    this._domNode.setTop(-t);
    const n = Math.min(e.scrollHeight, 1e6);
    this._domNode.setHeight(n), this._domNode.setWidth(this._contentLeft), this._glyphMarginBackgroundDomNode.setLeft(this._glyphMarginLeft), this._glyphMarginBackgroundDomNode.setWidth(this._glyphMarginWidth), this._glyphMarginBackgroundDomNode.setHeight(n);
  }
}
ug.CLASS_NAME = "glyph-margin", ug.OUTER_CLASS_NAME = "margin";
const om = "monaco-mouse-cursor-text", i0 = new class {
  constructor() {
    this._onDidChange = new F(), this.onDidChange = this._onDidChange.event, this._enabled = !0;
  }
  get enabled() {
    return this._enabled;
  }
  enable() {
    this._enabled = !0, this._onDidChange.fire();
  }
  disable() {
    this._enabled = !1, this._onDidChange.fire();
  }
}(), Dt = tt("keybindingService");
var ZZ = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Z4 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class YZ {
  constructor(e, t, n, s, o) {
    this._context = e, this.modelLineNumber = t, this.distanceToModelLineStart = n, this.widthOfHiddenLineTextBefore = s, this.distanceToModelLineEnd = o, this._visibleTextAreaBrand = void 0, this.startPosition = null, this.endPosition = null, this.visibleTextareaStart = null, this.visibleTextareaEnd = null, this._previousPresentation = null;
  }
  prepareRender(e) {
    const t = new W(this.modelLineNumber, this.distanceToModelLineStart + 1), n = new W(this.modelLineNumber, this._context.viewModel.model.getLineMaxColumn(this.modelLineNumber) - this.distanceToModelLineEnd);
    this.startPosition = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(t), this.endPosition = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(n), this.startPosition.lineNumber === this.endPosition.lineNumber ? (this.visibleTextareaStart = e.visibleRangeForPosition(this.startPosition), this.visibleTextareaEnd = e.visibleRangeForPosition(this.endPosition)) : (this.visibleTextareaStart = null, this.visibleTextareaEnd = null);
  }
  definePresentation(e) {
    return this._previousPresentation || (this._previousPresentation = e || { foreground: 1, italic: !1, bold: !1, underline: !1, strikethrough: !1 }), this._previousPresentation;
  }
}
const mD = tr;
let nI = class extends to {
  constructor(i, e, t, n, s) {
    super(i), this._keybindingService = n, this._instantiationService = s, this._primaryCursorPosition = new W(1, 1), this._primaryCursorVisibleRange = null, this._viewController = e, this._visibleRangeProvider = t, this._scrollLeft = 0, this._scrollTop = 0;
    const o = this._context.configuration.options, r = o.get(145);
    this._setAccessibilityOptions(o), this._contentLeft = r.contentLeft, this._contentWidth = r.contentWidth, this._contentHeight = r.height, this._fontInfo = o.get(50), this._lineHeight = o.get(67), this._emptySelectionClipboard = o.get(37), this._copyWithSyntaxHighlighting = o.get(25), this._visibleTextArea = null, this._selections = [new _e(1, 1, 1, 1)], this._modelSelections = [new _e(1, 1, 1, 1)], this._lastRenderPosition = null, this.textArea = wt(document.createElement("textarea")), _a.write(this.textArea, 7), this.textArea.setClassName(`inputarea ${om}`), this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off");
    const { tabSize: a } = this._context.viewModel.model.getOptions();
    this.textArea.domNode.style.tabSize = a * this._fontInfo.spaceWidth + "px", this.textArea.setAttribute("autocorrect", "off"), this.textArea.setAttribute("autocapitalize", "off"), this.textArea.setAttribute("autocomplete", "off"), this.textArea.setAttribute("spellcheck", "false"), this.textArea.setAttribute("aria-label", this._getAriaLabel(o)), this.textArea.setAttribute("aria-required", o.get(5) ? "true" : "false"), this.textArea.setAttribute("tabindex", String(o.get(124))), this.textArea.setAttribute("role", "textbox"), this.textArea.setAttribute("aria-roledescription", m(0, "editor")), this.textArea.setAttribute("aria-multiline", "true"), this.textArea.setAttribute("aria-autocomplete", o.get(91) ? "none" : "both"), this._ensureReadOnlyAttribute(), this.textAreaCover = wt(document.createElement("div")), this.textAreaCover.setPosition("absolute");
    const l = { getLineCount: () => this._context.viewModel.getLineCount(), getLineMaxColumn: (c) => this._context.viewModel.getLineMaxColumn(c), getValueInRange: (c, u) => this._context.viewModel.getValueInRange(c, u), getValueLengthInRange: (c, u) => this._context.viewModel.getValueLengthInRange(c, u), modifyPosition: (c, u) => this._context.viewModel.modifyPosition(c, u) }, d = { getDataToCopy: () => {
      const c = this._context.viewModel.getPlainTextToCopy(this._modelSelections, this._emptySelectionClipboard, Tn), u = this._context.viewModel.model.getEOL(), g = this._emptySelectionClipboard && this._modelSelections.length === 1 && this._modelSelections[0].isEmpty(), p = Array.isArray(c) ? c : null, f = Array.isArray(c) ? c.join(u) : c;
      let _, v = null;
      if (JE.forceCopyWithSyntaxHighlighting || this._copyWithSyntaxHighlighting && f.length < 65536) {
        const b = this._context.viewModel.getRichTextToCopy(this._modelSelections, this._emptySelectionClipboard);
        b && (_ = b.html, v = b.mode);
      }
      return { isFromEmptySelection: g, multicursorText: p, text: f, html: _, mode: v };
    }, getScreenReaderContent: () => {
      if (this._accessibilitySupport === 1) {
        const c = this._selections[0];
        if (Je && c.isEmpty()) {
          const g = c.getStartPosition();
          let p = this._getWordBeforePosition(g);
          if (p.length === 0 && (p = this._getCharacterBeforePosition(g)), p.length > 0) return new fn(p, p.length, p.length, D.fromPositions(g), 0);
        }
        if (Je && !c.isEmpty() && l.getValueLengthInRange(c, 0) < 500) {
          const g = l.getValueInRange(c, 0);
          return new fn(g, 0, g.length, c, 0);
        }
        if (vc && !c.isEmpty()) {
          const g = "vscode-placeholder";
          return new fn(g, 0, g.length, null, void 0);
        }
        return fn.EMPTY;
      }
      if (dO) {
        const c = this._selections[0];
        if (c.isEmpty()) {
          const u = c.getStartPosition(), [g, p] = this._getAndroidWordAtPosition(u);
          if (g.length > 0) return new fn(g, p, p, D.fromPositions(u), 0);
        }
        return fn.EMPTY;
      }
      return Op.fromEditorSelection(l, this._selections[0], this._accessibilityPageSize, this._accessibilitySupport === 0);
    }, deduceModelPosition: (c, u, g) => this._context.viewModel.deduceModelPositionRelativeToViewPosition(c, u, g) }, h = this._register(new cZ(this.textArea.domNode));
    this._textAreaInput = this._register(this._instantiationService.createInstance(eI, d, h, Gs, { isAndroid: dO, isChrome: _1, isFirefox: tr, isSafari: vc })), this._register(this._textAreaInput.onKeyDown((c) => {
      this._viewController.emitKeyDown(c);
    })), this._register(this._textAreaInput.onKeyUp((c) => {
      this._viewController.emitKeyUp(c);
    })), this._register(this._textAreaInput.onPaste((c) => {
      let u = !1, g = null, p = null;
      c.metadata && (u = this._emptySelectionClipboard && !!c.metadata.isFromEmptySelection, g = c.metadata.multicursorText !== void 0 ? c.metadata.multicursorText : null, p = c.metadata.mode), this._viewController.paste(c.text, u, g, p);
    })), this._register(this._textAreaInput.onCut(() => {
      this._viewController.cut();
    })), this._register(this._textAreaInput.onType((c) => {
      c.replacePrevCharCnt || c.replaceNextCharCnt || c.positionDelta ? this._viewController.compositionType(c.text, c.replacePrevCharCnt, c.replaceNextCharCnt, c.positionDelta) : this._viewController.type(c.text);
    })), this._register(this._textAreaInput.onSelectionChangeRequest((c) => {
      this._viewController.setSelection(c);
    })), this._register(this._textAreaInput.onCompositionStart((c) => {
      const u = this.textArea.domNode, g = this._modelSelections[0], { distanceToModelLineStart: p, widthOfHiddenTextBefore: f } = (() => {
        const v = u.value.substring(0, Math.min(u.selectionStart, u.selectionEnd)), b = v.lastIndexOf(`
`), C = v.substring(b + 1), w = C.lastIndexOf("	"), y = C.length - w - 1, L = g.getStartPosition(), k = Math.min(L.column - 1, y), N = L.column - 1 - k, A = C.substring(0, C.length - k), { tabSize: B } = this._context.viewModel.model.getOptions(), T = function(O, H, $, pe) {
          if (H.length === 0) return 0;
          const me = O.createElement("div");
          me.style.position = "absolute", me.style.top = "-50000px", me.style.width = "50000px";
          const ue = O.createElement("span");
          yn(ue, $), ue.style.whiteSpace = "pre", ue.style.tabSize = pe * $.spaceWidth + "px", ue.append(H), me.appendChild(ue), O.body.appendChild(me);
          const ee = ue.offsetWidth;
          return O.body.removeChild(me), ee;
        }(this.textArea.domNode.ownerDocument, A, this._fontInfo, B);
        return { distanceToModelLineStart: N, widthOfHiddenTextBefore: T };
      })(), { distanceToModelLineEnd: _ } = (() => {
        const v = u.value.substring(Math.max(u.selectionStart, u.selectionEnd)), b = v.indexOf(`
`), C = b === -1 ? v : v.substring(0, b), w = C.indexOf("	"), y = w === -1 ? C.length : C.length - w - 1, L = g.getEndPosition(), k = Math.min(this._context.viewModel.model.getLineMaxColumn(L.lineNumber) - L.column, y);
        return { distanceToModelLineEnd: this._context.viewModel.model.getLineMaxColumn(L.lineNumber) - L.column - k };
      })();
      this._context.viewModel.revealRange("keyboard", !0, D.fromPositions(this._selections[0].getStartPosition()), 0, 1), this._visibleTextArea = new YZ(this._context, g.startLineNumber, p, f, _), this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off"), this._visibleTextArea.prepareRender(this._visibleRangeProvider), this._render(), this.textArea.setClassName(`inputarea ${om} ime-input`), this._viewController.compositionStart(), this._context.viewModel.onCompositionStart();
    })), this._register(this._textAreaInput.onCompositionUpdate((c) => {
      this._visibleTextArea && (this._visibleTextArea.prepareRender(this._visibleRangeProvider), this._render());
    })), this._register(this._textAreaInput.onCompositionEnd(() => {
      this._visibleTextArea = null, this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off"), this._render(), this.textArea.setClassName(`inputarea ${om}`), this._viewController.compositionEnd(), this._context.viewModel.onCompositionEnd();
    })), this._register(this._textAreaInput.onFocus(() => {
      this._context.viewModel.setHasFocus(!0);
    })), this._register(this._textAreaInput.onBlur(() => {
      this._context.viewModel.setHasFocus(!1);
    })), this._register(i0.onDidChange(() => {
      this._ensureReadOnlyAttribute();
    }));
  }
  writeScreenReaderContent(i) {
    this._textAreaInput.writeNativeTextAreaContent(i);
  }
  dispose() {
    super.dispose();
  }
  _getAndroidWordAtPosition(i) {
    const e = this._context.viewModel.getLineContent(i.lineNumber), t = zo('`~!@#$%^&*()-=+[{]}\\|;:",.<>/?', []);
    let n = !0, s = i.column, o = !0, r = i.column, a = 0;
    for (; a < 50 && (n || o); ) {
      if (n && s <= 1 && (n = !1), n) {
        const l = e.charCodeAt(s - 2);
        t.get(l) !== 0 ? n = !1 : s--;
      }
      if (o && r > e.length && (o = !1), o) {
        const l = e.charCodeAt(r - 1);
        t.get(l) !== 0 ? o = !1 : r++;
      }
      a++;
    }
    return [e.substring(s - 1, r - 1), i.column - s];
  }
  _getWordBeforePosition(i) {
    const e = this._context.viewModel.getLineContent(i.lineNumber), t = zo(this._context.configuration.options.get(131), []);
    let n = i.column, s = 0;
    for (; n > 1; ) {
      const o = e.charCodeAt(n - 2);
      if (t.get(o) !== 0 || s > 50) return e.substring(n - 1, i.column - 1);
      s++, n--;
    }
    return e.substring(0, i.column - 1);
  }
  _getCharacterBeforePosition(i) {
    if (i.column > 1) {
      const e = this._context.viewModel.getLineContent(i.lineNumber).charAt(i.column - 2);
      if (!en(e.charCodeAt(0))) return e;
    }
    return "";
  }
  _getAriaLabel(i) {
    var e, t, n;
    if (i.get(2) === 1) {
      const s = (e = this._keybindingService.lookupKeybinding("editor.action.toggleScreenReaderAccessibilityMode")) === null || e === void 0 ? void 0 : e.getAriaLabel(), o = (t = this._keybindingService.lookupKeybinding("workbench.action.showCommands")) === null || t === void 0 ? void 0 : t.getAriaLabel(), r = (n = this._keybindingService.lookupKeybinding("workbench.action.openGlobalKeybindings")) === null || n === void 0 ? void 0 : n.getAriaLabel(), a = m(0, "The editor is not accessible at this time.");
      return s ? m(0, "{0} To enable screen reader optimized mode, use {1}", a, s) : o ? m(0, "{0} To enable screen reader optimized mode, open the quick pick with {1} and run the command Toggle Screen Reader Accessibility Mode, which is currently not triggerable via keyboard.", a, o) : r ? m(0, "{0} Please assign a keybinding for the command Toggle Screen Reader Accessibility Mode by accessing the keybindings editor with {1} and run it.", a, r) : a;
    }
    return i.get(4);
  }
  _setAccessibilityOptions(i) {
    this._accessibilitySupport = i.get(2);
    const e = i.get(3);
    this._accessibilitySupport === 2 && e === ta.accessibilityPageSize.defaultValue ? this._accessibilityPageSize = 500 : this._accessibilityPageSize = e;
    const t = i.get(145).wrappingColumn;
    if (t !== -1 && this._accessibilitySupport !== 1) {
      const n = i.get(50);
      this._textAreaWrapping = !0, this._textAreaWidth = Math.round(t * n.typicalHalfwidthCharacterWidth);
    } else this._textAreaWrapping = !1, this._textAreaWidth = mD ? 0 : 1;
  }
  onConfigurationChanged(i) {
    const e = this._context.configuration.options, t = e.get(145);
    this._setAccessibilityOptions(e), this._contentLeft = t.contentLeft, this._contentWidth = t.contentWidth, this._contentHeight = t.height, this._fontInfo = e.get(50), this._lineHeight = e.get(67), this._emptySelectionClipboard = e.get(37), this._copyWithSyntaxHighlighting = e.get(25), this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off");
    const { tabSize: n } = this._context.viewModel.model.getOptions();
    return this.textArea.domNode.style.tabSize = n * this._fontInfo.spaceWidth + "px", this.textArea.setAttribute("aria-label", this._getAriaLabel(e)), this.textArea.setAttribute("aria-required", e.get(5) ? "true" : "false"), this.textArea.setAttribute("tabindex", String(e.get(124))), (i.hasChanged(34) || i.hasChanged(91)) && this._ensureReadOnlyAttribute(), i.hasChanged(2) && this._textAreaInput.writeNativeTextAreaContent("strategy changed"), !0;
  }
  onCursorStateChanged(i) {
    return this._selections = i.selections.slice(0), this._modelSelections = i.modelSelections.slice(0), this._textAreaInput.writeNativeTextAreaContent("selection changed"), !0;
  }
  onDecorationsChanged(i) {
    return !0;
  }
  onFlushed(i) {
    return !0;
  }
  onLinesChanged(i) {
    return !0;
  }
  onLinesDeleted(i) {
    return !0;
  }
  onLinesInserted(i) {
    return !0;
  }
  onScrollChanged(i) {
    return this._scrollLeft = i.scrollLeft, this._scrollTop = i.scrollTop, !0;
  }
  onZonesChanged(i) {
    return !0;
  }
  isFocused() {
    return this._textAreaInput.isFocused();
  }
  focusTextArea() {
    this._textAreaInput.focusTextArea();
  }
  getLastRenderData() {
    return this._lastRenderPosition;
  }
  setAriaOptions(i) {
    i.activeDescendant ? (this.textArea.setAttribute("aria-haspopup", "true"), this.textArea.setAttribute("aria-autocomplete", "list"), this.textArea.setAttribute("aria-activedescendant", i.activeDescendant)) : (this.textArea.setAttribute("aria-haspopup", "false"), this.textArea.setAttribute("aria-autocomplete", "both"), this.textArea.removeAttribute("aria-activedescendant")), i.role && this.textArea.setAttribute("role", i.role);
  }
  _ensureReadOnlyAttribute() {
    const i = this._context.configuration.options;
    !i0.enabled || i.get(34) && i.get(91) ? this.textArea.setAttribute("readonly", "true") : this.textArea.removeAttribute("readonly");
  }
  prepareRender(i) {
    var e;
    this._primaryCursorPosition = new W(this._selections[0].positionLineNumber, this._selections[0].positionColumn), this._primaryCursorVisibleRange = i.visibleRangeForPosition(this._primaryCursorPosition), (e = this._visibleTextArea) === null || e === void 0 || e.prepareRender(i);
  }
  render(i) {
    this._textAreaInput.writeNativeTextAreaContent("render"), this._render();
  }
  _render() {
    var i;
    if (this._visibleTextArea) {
      const n = this._visibleTextArea.visibleTextareaStart, s = this._visibleTextArea.visibleTextareaEnd, o = this._visibleTextArea.startPosition, r = this._visibleTextArea.endPosition;
      if (o && r && n && s && s.left >= this._scrollLeft && n.left <= this._scrollLeft + this._contentWidth) {
        const a = this._context.viewLayout.getVerticalOffsetForLineNumber(this._primaryCursorPosition.lineNumber) - this._scrollTop, l = this._newlinecount(this.textArea.domNode.value.substr(0, this.textArea.domNode.selectionStart));
        let d = this._visibleTextArea.widthOfHiddenLineTextBefore, h = this._contentLeft + n.left - this._scrollLeft, c = s.left - n.left + 1;
        if (h < this._contentLeft) {
          const _ = this._contentLeft - h;
          h += _, d += _, c -= _;
        }
        c > this._contentWidth && (c = this._contentWidth);
        const u = this._context.viewModel.getViewLineData(o.lineNumber), g = u.tokens.findTokenIndexAtOffset(o.column - 1), p = g === u.tokens.findTokenIndexAtOffset(r.column - 1), f = this._visibleTextArea.definePresentation(p ? u.tokens.getPresentation(g) : null);
        this.textArea.domNode.scrollTop = l * this._lineHeight, this.textArea.domNode.scrollLeft = d, this._doRender({ lastRenderPosition: null, top: a, left: h, width: c, height: this._lineHeight, useCover: !1, color: (ci.getColorMap() || [])[f.foreground], italic: f.italic, bold: f.bold, underline: f.underline, strikethrough: f.strikethrough });
      }
      return;
    }
    if (!this._primaryCursorVisibleRange) return void this._renderAtTopLeft();
    const e = this._contentLeft + this._primaryCursorVisibleRange.left - this._scrollLeft;
    if (e < this._contentLeft || e > this._contentLeft + this._contentWidth) return void this._renderAtTopLeft();
    const t = this._context.viewLayout.getVerticalOffsetForLineNumber(this._selections[0].positionLineNumber) - this._scrollTop;
    if (t < 0 || t > this._contentHeight) this._renderAtTopLeft();
    else if (Je || this._accessibilitySupport === 2) {
      this._doRender({ lastRenderPosition: this._primaryCursorPosition, top: t, left: this._textAreaWrapping ? this._contentLeft : e, width: this._textAreaWidth, height: this._lineHeight, useCover: !1 }), this.textArea.domNode.scrollLeft = this._primaryCursorVisibleRange.left;
      const n = (i = this._textAreaInput.textAreaState.newlineCountBeforeSelection) !== null && i !== void 0 ? i : this._newlinecount(this.textArea.domNode.value.substr(0, this.textArea.domNode.selectionStart));
      this.textArea.domNode.scrollTop = n * this._lineHeight;
    } else this._doRender({ lastRenderPosition: this._primaryCursorPosition, top: t, left: this._textAreaWrapping ? this._contentLeft : e, width: this._textAreaWidth, height: mD ? 0 : 1, useCover: !1 });
  }
  _newlinecount(i) {
    let e = 0, t = -1;
    for (; t = i.indexOf(`
`, t + 1), t !== -1; )
      e++;
    return e;
  }
  _renderAtTopLeft() {
    this._doRender({ lastRenderPosition: null, top: 0, left: 0, width: this._textAreaWidth, height: mD ? 0 : 1, useCover: !0 });
  }
  _doRender(i) {
    this._lastRenderPosition = i.lastRenderPosition;
    const e = this.textArea, t = this.textAreaCover;
    yn(e, this._fontInfo), e.setTop(i.top), e.setLeft(i.left), e.setWidth(i.width), e.setHeight(i.height), e.setColor(i.color ? z.Format.CSS.formatHex(i.color) : ""), e.setFontStyle(i.italic ? "italic" : ""), i.bold && e.setFontWeight("bold"), e.setTextDecoration(`${i.underline ? " underline" : ""}${i.strikethrough ? " line-through" : ""}`), t.setTop(i.useCover ? i.top : 0), t.setLeft(i.useCover ? i.left : 0), t.setWidth(i.useCover ? i.width : 0), t.setHeight(i.useCover ? i.height : 0);
    const n = this._context.configuration.options;
    n.get(57) ? t.setClassName("monaco-editor-background textAreaCover " + ug.OUTER_CLASS_NAME) : n.get(68).renderType !== 0 ? t.setClassName("monaco-editor-background textAreaCover " + N1.CLASS_NAME) : t.setClassName("monaco-editor-background textAreaCover");
  }
};
function KR(i, e, t) {
  let n = Jn(i);
  return n === -1 && (n = i.length), function(s, o, r) {
    let a = 0;
    for (let d = 0; d < s.length; d++) s.charAt(d) === "	" ? a = Gi.nextIndentTabStop(a, o) : a++;
    let l = "";
    if (!r) {
      const d = Math.floor(a / o);
      a %= o;
      for (let h = 0; h < d; h++) l += "	";
    }
    for (let d = 0; d < a; d++) l += " ";
    return l;
  }(i.substring(0, n), e, t) + i.substring(n);
}
nI = ZZ([Z4(3, Dt), Z4(4, Se)], nI);
const XZ = () => !0, QZ = () => !1, JZ = (i) => i === " " || i === "	";
class $g {
  static shouldRecreate(e) {
    return e.hasChanged(145) || e.hasChanged(131) || e.hasChanged(37) || e.hasChanged(77) || e.hasChanged(79) || e.hasChanged(80) || e.hasChanged(6) || e.hasChanged(7) || e.hasChanged(11) || e.hasChanged(9) || e.hasChanged(10) || e.hasChanged(14) || e.hasChanged(128) || e.hasChanged(50) || e.hasChanged(91) || e.hasChanged(130);
  }
  constructor(e, t, n, s) {
    var o;
    this.languageConfigurationService = s, this._cursorMoveConfigurationBrand = void 0, this._languageId = e;
    const r = n.options, a = r.get(145), l = r.get(50);
    this.readOnly = r.get(91), this.tabSize = t.tabSize, this.indentSize = t.indentSize, this.insertSpaces = t.insertSpaces, this.stickyTabStops = r.get(116), this.lineHeight = l.lineHeight, this.typicalHalfwidthCharacterWidth = l.typicalHalfwidthCharacterWidth, this.pageSize = Math.max(1, Math.floor(a.height / this.lineHeight) - 2), this.useTabStops = r.get(128), this.wordSeparators = r.get(131), this.emptySelectionClipboard = r.get(37), this.copyWithSyntaxHighlighting = r.get(25), this.multiCursorMergeOverlapping = r.get(77), this.multiCursorPaste = r.get(79), this.multiCursorLimit = r.get(80), this.autoClosingBrackets = r.get(6), this.autoClosingComments = r.get(7), this.autoClosingQuotes = r.get(11), this.autoClosingDelete = r.get(9), this.autoClosingOvertype = r.get(10), this.autoSurround = r.get(14), this.autoIndent = r.get(12), this.wordSegmenterLocales = r.get(130), this.surroundingPairs = {}, this._electricChars = null, this.shouldAutoCloseBefore = { quote: this._getShouldAutoClose(e, this.autoClosingQuotes, !0), comment: this._getShouldAutoClose(e, this.autoClosingComments, !1), bracket: this._getShouldAutoClose(e, this.autoClosingBrackets, !1) }, this.autoClosingPairs = this.languageConfigurationService.getLanguageConfiguration(e).getAutoClosingPairs();
    const d = this.languageConfigurationService.getLanguageConfiguration(e).getSurroundingPairs();
    if (d) for (const c of d) this.surroundingPairs[c.open] = c.close;
    const h = this.languageConfigurationService.getLanguageConfiguration(e).comments;
    this.blockCommentStartToken = (o = h == null ? void 0 : h.blockCommentStartToken) !== null && o !== void 0 ? o : null;
  }
  get electricChars() {
    var e;
    if (!this._electricChars) {
      this._electricChars = {};
      const t = (e = this.languageConfigurationService.getLanguageConfiguration(this._languageId).electricCharacter) === null || e === void 0 ? void 0 : e.getElectricCharacters();
      if (t) for (const n of t) this._electricChars[n] = !0;
    }
    return this._electricChars;
  }
  onElectricCharacter(e, t, n) {
    const s = Yw(t, n - 1), o = this.languageConfigurationService.getLanguageConfiguration(s.languageId).electricCharacter;
    return o ? o.onElectricCharacter(e, s, n - s.firstCharOffset) : null;
  }
  normalizeIndentation(e) {
    return KR(e, this.indentSize, this.insertSpaces);
  }
  _getShouldAutoClose(e, t, n) {
    switch (t) {
      case "beforeWhitespace":
        return JZ;
      case "languageDefined":
        return this._getLanguageDefinedShouldAutoClose(e, n);
      case "always":
        return XZ;
      case "never":
        return QZ;
    }
  }
  _getLanguageDefinedShouldAutoClose(e, t) {
    const n = this.languageConfigurationService.getLanguageConfiguration(e).getAutoCloseBeforeSet(t);
    return (s) => n.indexOf(s) !== -1;
  }
  visibleColumnFromColumn(e, t) {
    return Gi.visibleColumnFromColumn(e.getLineContent(t.lineNumber), t.column, this.tabSize);
  }
  columnFromVisibleColumn(e, t, n) {
    const s = Gi.columnFromVisibleColumn(e.getLineContent(t), n, this.tabSize), o = e.getLineMinColumn(t);
    if (s < o) return o;
    const r = e.getLineMaxColumn(t);
    return s > r ? r : s;
  }
}
let pt = class FB {
  static fromModelState(e) {
    return new eY(e);
  }
  static fromViewState(e) {
    return new tY(e);
  }
  static fromModelSelection(e) {
    const t = _e.liftSelection(e), n = new bn(D.fromPositions(t.getSelectionStart()), 0, 0, t.getPosition(), 0);
    return FB.fromModelState(n);
  }
  static fromModelSelections(e) {
    const t = [];
    for (let n = 0, s = e.length; n < s; n++) t[n] = this.fromModelSelection(e[n]);
    return t;
  }
  constructor(e, t) {
    this._cursorStateBrand = void 0, this.modelState = e, this.viewState = t;
  }
  equals(e) {
    return this.viewState.equals(e.viewState) && this.modelState.equals(e.modelState);
  }
};
class eY {
  constructor(e) {
    this.modelState = e, this.viewState = null;
  }
}
class tY {
  constructor(e) {
    this.modelState = null, this.viewState = e;
  }
}
class bn {
  constructor(e, t, n, s, o) {
    this.selectionStart = e, this.selectionStartKind = t, this.selectionStartLeftoverVisibleColumns = n, this.position = s, this.leftoverVisibleColumns = o, this._singleCursorStateBrand = void 0, this.selection = bn._computeSelection(this.selectionStart, this.position);
  }
  equals(e) {
    return this.selectionStartLeftoverVisibleColumns === e.selectionStartLeftoverVisibleColumns && this.leftoverVisibleColumns === e.leftoverVisibleColumns && this.selectionStartKind === e.selectionStartKind && this.position.equals(e.position) && this.selectionStart.equalsRange(e.selectionStart);
  }
  hasSelection() {
    return !this.selection.isEmpty() || !this.selectionStart.isEmpty();
  }
  move(e, t, n, s) {
    return e ? new bn(this.selectionStart, this.selectionStartKind, this.selectionStartLeftoverVisibleColumns, new W(t, n), s) : new bn(new D(t, n, t, n), 0, s, new W(t, n), s);
  }
  static _computeSelection(e, t) {
    return e.isEmpty() || !t.isBeforeOrEqual(e.getStartPosition()) ? _e.fromPositions(e.getStartPosition(), t) : _e.fromPositions(e.getEndPosition(), t);
  }
}
class Ls {
  constructor(e, t, n) {
    this._editOperationResultBrand = void 0, this.type = e, this.commands = t, this.shouldPushStackElementBefore = n.shouldPushStackElementBefore, this.shouldPushStackElementAfter = n.shouldPushStackElementAfter;
  }
}
function rh(i) {
  return i === "'" || i === '"' || i === "`";
}
class Cu {
  static columnSelect(e, t, n, s, o, r) {
    const a = Math.abs(o - n) + 1, l = n > o, d = s > r, h = s < r, c = [];
    for (let u = 0; u < a; u++) {
      const g = n + (l ? -u : u), p = e.columnFromVisibleColumn(t, g, s), f = e.columnFromVisibleColumn(t, g, r), _ = e.visibleColumnFromColumn(t, new W(g, p)), v = e.visibleColumnFromColumn(t, new W(g, f));
      h && (_ > r || v < s) || d && (v > s || _ < r) || c.push(new bn(new D(g, p, g, p), 0, 0, new W(g, f), 0));
    }
    if (c.length === 0) for (let u = 0; u < a; u++) {
      const g = n + (l ? -u : u), p = t.getLineMaxColumn(g);
      c.push(new bn(new D(g, p, g, p), 0, 0, new W(g, p), 0));
    }
    return { viewStates: c, reversed: l, fromLineNumber: n, fromVisualColumn: s, toLineNumber: o, toVisualColumn: r };
  }
  static columnSelectLeft(e, t, n) {
    let s = n.toViewVisualColumn;
    return s > 0 && s--, Cu.columnSelect(e, t, n.fromViewLineNumber, n.fromViewVisualColumn, n.toViewLineNumber, s);
  }
  static columnSelectRight(e, t, n) {
    let s = 0;
    const o = Math.min(n.fromViewLineNumber, n.toViewLineNumber), r = Math.max(n.fromViewLineNumber, n.toViewLineNumber);
    for (let l = o; l <= r; l++) {
      const d = t.getLineMaxColumn(l), h = e.visibleColumnFromColumn(t, new W(l, d));
      s = Math.max(s, h);
    }
    let a = n.toViewVisualColumn;
    return a < s && a++, this.columnSelect(e, t, n.fromViewLineNumber, n.fromViewVisualColumn, n.toViewLineNumber, a);
  }
  static columnSelectUp(e, t, n, s) {
    const o = s ? e.pageSize : 1, r = Math.max(1, n.toViewLineNumber - o);
    return this.columnSelect(e, t, n.fromViewLineNumber, n.fromViewVisualColumn, r, n.toViewVisualColumn);
  }
  static columnSelectDown(e, t, n, s) {
    const o = s ? e.pageSize : 1, r = Math.min(t.getLineCount(), n.toViewLineNumber + o);
    return this.columnSelect(e, t, n.fromViewLineNumber, n.fromViewVisualColumn, r, n.toViewVisualColumn);
  }
}
class Dn {
  constructor(e, t, n = !1) {
    this._range = e, this._text = t, this.insertsAutoWhitespace = n;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(this._range, this._text);
  }
  computeCursorState(e, t) {
    const n = t.getInverseEditOperations()[0].range;
    return _e.fromPositions(n.getEndPosition());
  }
}
class iY {
  constructor(e, t) {
    this._range = e, this._text = t;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(this._range, this._text);
  }
  computeCursorState(e, t) {
    const n = t.getInverseEditOperations()[0].range;
    return _e.fromRange(n, 0);
  }
}
class fb {
  constructor(e, t, n = !1) {
    this._range = e, this._text = t, this.insertsAutoWhitespace = n;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(this._range, this._text);
  }
  computeCursorState(e, t) {
    const n = t.getInverseEditOperations()[0].range;
    return _e.fromPositions(n.getStartPosition());
  }
}
class VC {
  constructor(e, t, n, s, o = !1) {
    this._range = e, this._text = t, this._columnDeltaOffset = s, this._lineNumberDeltaOffset = n, this.insertsAutoWhitespace = o;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(this._range, this._text);
  }
  computeCursorState(e, t) {
    const n = t.getInverseEditOperations()[0].range;
    return _e.fromPositions(n.getEndPosition().delta(this._lineNumberDeltaOffset, this._columnDeltaOffset));
  }
}
class jR {
  constructor(e, t, n, s = !1) {
    this._range = e, this._text = t, this._initialSelection = n, this._forceMoveMarkers = s, this._selectionId = null;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(this._range, this._text, this._forceMoveMarkers), this._selectionId = t.trackSelection(this._initialSelection);
  }
  computeCursorState(e, t) {
    return t.getTrackedSelection(this._selectionId);
  }
}
class fD {
  constructor(e, t, n) {
    this._cursorPositionBrand = void 0, this.lineNumber = e, this.column = t, this.leftoverVisibleColumns = n;
  }
}
class St {
  static leftPosition(e, t) {
    if (t.column > e.getLineMinColumn(t.lineNumber)) return t.delta(void 0, -e8(e.getLineContent(t.lineNumber), t.column - 1));
    if (t.lineNumber > 1) {
      const n = t.lineNumber - 1;
      return new W(n, e.getLineMaxColumn(n));
    }
    return t;
  }
  static leftPositionAtomicSoftTabs(e, t, n) {
    if (t.column <= e.getLineIndentColumn(t.lineNumber)) {
      const s = e.getLineMinColumn(t.lineNumber), o = e.getLineContent(t.lineNumber), r = mv.atomicPosition(o, t.column - 1, n, 0);
      if (r !== -1 && r + 1 >= s) return new W(t.lineNumber, r + 1);
    }
    return this.leftPosition(e, t);
  }
  static left(e, t, n) {
    const s = e.stickyTabStops ? St.leftPositionAtomicSoftTabs(t, n, e.tabSize) : St.leftPosition(t, n);
    return new fD(s.lineNumber, s.column, 0);
  }
  static moveLeft(e, t, n, s, o) {
    let r, a;
    if (n.hasSelection() && !s) r = n.selection.startLineNumber, a = n.selection.startColumn;
    else {
      const l = n.position.delta(void 0, -(o - 1)), d = t.normalizePosition(St.clipPositionColumn(l, t), 0), h = St.left(e, t, d);
      r = h.lineNumber, a = h.column;
    }
    return n.move(s, r, a, 0);
  }
  static clipPositionColumn(e, t) {
    return new W(e.lineNumber, St.clipRange(e.column, t.getLineMinColumn(e.lineNumber), t.getLineMaxColumn(e.lineNumber)));
  }
  static clipRange(e, t, n) {
    return e < t ? t : e > n ? n : e;
  }
  static rightPosition(e, t, n) {
    return n < e.getLineMaxColumn(t) ? n += aR(e.getLineContent(t), n - 1) : t < e.getLineCount() && (t += 1, n = e.getLineMinColumn(t)), new W(t, n);
  }
  static rightPositionAtomicSoftTabs(e, t, n, s, o) {
    if (n < e.getLineIndentColumn(t)) {
      const r = e.getLineContent(t), a = mv.atomicPosition(r, n - 1, s, 1);
      if (a !== -1) return new W(t, a + 1);
    }
    return this.rightPosition(e, t, n);
  }
  static right(e, t, n) {
    const s = e.stickyTabStops ? St.rightPositionAtomicSoftTabs(t, n.lineNumber, n.column, e.tabSize, e.indentSize) : St.rightPosition(t, n.lineNumber, n.column);
    return new fD(s.lineNumber, s.column, 0);
  }
  static moveRight(e, t, n, s, o) {
    let r, a;
    if (n.hasSelection() && !s) r = n.selection.endLineNumber, a = n.selection.endColumn;
    else {
      const l = n.position.delta(void 0, o - 1), d = t.normalizePosition(St.clipPositionColumn(l, t), 1), h = St.right(e, t, d);
      r = h.lineNumber, a = h.column;
    }
    return n.move(s, r, a, 0);
  }
  static vertical(e, t, n, s, o, r, a, l) {
    const d = Gi.visibleColumnFromColumn(t.getLineContent(n), s, e.tabSize) + o, h = t.getLineCount(), c = n === 1 && s === 1, u = n === h && s === t.getLineMaxColumn(n), g = r < n ? c : u;
    if ((n = r) < 1 ? (n = 1, s = a ? t.getLineMinColumn(n) : Math.min(t.getLineMaxColumn(n), s)) : n > h ? (n = h, s = a ? t.getLineMaxColumn(n) : Math.min(t.getLineMaxColumn(n), s)) : s = e.columnFromVisibleColumn(t, n, d), o = g ? 0 : d - Gi.visibleColumnFromColumn(t.getLineContent(n), s, e.tabSize), l !== void 0) {
      const p = new W(n, s), f = t.normalizePosition(p, l);
      o += s - f.column, n = f.lineNumber, s = f.column;
    }
    return new fD(n, s, o);
  }
  static down(e, t, n, s, o, r, a) {
    return this.vertical(e, t, n, s, o, n + r, a, 4);
  }
  static moveDown(e, t, n, s, o) {
    let r, a;
    n.hasSelection() && !s ? (r = n.selection.endLineNumber, a = n.selection.endColumn) : (r = n.position.lineNumber, a = n.position.column);
    let l, d = 0;
    do
      if (l = St.down(e, t, r + d, a, n.leftoverVisibleColumns, o, !0), t.normalizePosition(new W(l.lineNumber, l.column), 2).lineNumber > r) break;
    while (d++ < 10 && r + d < t.getLineCount());
    return n.move(s, l.lineNumber, l.column, l.leftoverVisibleColumns);
  }
  static translateDown(e, t, n) {
    const s = n.selection, o = St.down(e, t, s.selectionStartLineNumber, s.selectionStartColumn, n.selectionStartLeftoverVisibleColumns, 1, !1), r = St.down(e, t, s.positionLineNumber, s.positionColumn, n.leftoverVisibleColumns, 1, !1);
    return new bn(new D(o.lineNumber, o.column, o.lineNumber, o.column), 0, o.leftoverVisibleColumns, new W(r.lineNumber, r.column), r.leftoverVisibleColumns);
  }
  static up(e, t, n, s, o, r, a) {
    return this.vertical(e, t, n, s, o, n - r, a, 3);
  }
  static moveUp(e, t, n, s, o) {
    let r, a;
    n.hasSelection() && !s ? (r = n.selection.startLineNumber, a = n.selection.startColumn) : (r = n.position.lineNumber, a = n.position.column);
    const l = St.up(e, t, r, a, n.leftoverVisibleColumns, o, !0);
    return n.move(s, l.lineNumber, l.column, l.leftoverVisibleColumns);
  }
  static translateUp(e, t, n) {
    const s = n.selection, o = St.up(e, t, s.selectionStartLineNumber, s.selectionStartColumn, n.selectionStartLeftoverVisibleColumns, 1, !1), r = St.up(e, t, s.positionLineNumber, s.positionColumn, n.leftoverVisibleColumns, 1, !1);
    return new bn(new D(o.lineNumber, o.column, o.lineNumber, o.column), 0, o.leftoverVisibleColumns, new W(r.lineNumber, r.column), r.leftoverVisibleColumns);
  }
  static _isBlankLine(e, t) {
    return e.getLineFirstNonWhitespaceColumn(t) === 0;
  }
  static moveToPrevBlankLine(e, t, n, s) {
    let o = n.position.lineNumber;
    for (; o > 1 && this._isBlankLine(t, o); ) o--;
    for (; o > 1 && !this._isBlankLine(t, o); ) o--;
    return n.move(s, o, t.getLineMinColumn(o), 0);
  }
  static moveToNextBlankLine(e, t, n, s) {
    const o = t.getLineCount();
    let r = n.position.lineNumber;
    for (; r < o && this._isBlankLine(t, r); ) r++;
    for (; r < o && !this._isBlankLine(t, r); ) r++;
    return n.move(s, r, t.getLineMinColumn(r), 0);
  }
  static moveToBeginningOfLine(e, t, n, s) {
    const o = n.position.lineNumber, r = t.getLineMinColumn(o), a = t.getLineFirstNonWhitespaceColumn(o) || r;
    let l;
    return l = n.position.column === a ? r : a, n.move(s, o, l, 0);
  }
  static moveToEndOfLine(e, t, n, s, o) {
    const r = n.position.lineNumber, a = t.getLineMaxColumn(r);
    return n.move(s, r, a, o ? 1073741824 - a : 0);
  }
  static moveToBeginningOfBuffer(e, t, n, s) {
    return n.move(s, 1, 1, 0);
  }
  static moveToEndOfBuffer(e, t, n, s) {
    const o = t.getLineCount(), r = t.getLineMaxColumn(o);
    return n.move(s, o, r, 0);
  }
}
class gg {
  static deleteRight(e, t, n, s) {
    const o = [];
    let r = e !== 3;
    for (let a = 0, l = s.length; a < l; a++) {
      const d = s[a];
      let h = d;
      if (h.isEmpty()) {
        const c = d.getPosition(), u = St.right(t, n, c);
        h = new D(u.lineNumber, u.column, c.lineNumber, c.column);
      }
      h.isEmpty() ? o[a] = null : (h.startLineNumber !== h.endLineNumber && (r = !0), o[a] = new Dn(h, ""));
    }
    return [r, o];
  }
  static isAutoClosingPairDelete(e, t, n, s, o, r, a) {
    if (t === "never" && n === "never" || e === "never") return !1;
    for (let l = 0, d = r.length; l < d; l++) {
      const h = r[l], c = h.getPosition();
      if (!h.isEmpty()) return !1;
      const u = o.getLineContent(c.lineNumber);
      if (c.column < 2 || c.column >= u.length + 1) return !1;
      const g = u.charAt(c.column - 2), p = s.get(g);
      if (!p) return !1;
      if (rh(g)) {
        if (n === "never") return !1;
      } else if (t === "never") return !1;
      const f = u.charAt(c.column - 1);
      let _ = !1;
      for (const v of p) v.open === g && v.close === f && (_ = !0);
      if (!_) return !1;
      if (e === "auto") {
        let v = !1;
        for (let b = 0, C = a.length; b < C; b++) {
          const w = a[b];
          if (c.lineNumber === w.startLineNumber && c.column === w.startColumn) {
            v = !0;
            break;
          }
        }
        if (!v) return !1;
      }
    }
    return !0;
  }
  static _runAutoClosingPairDelete(e, t, n) {
    const s = [];
    for (let o = 0, r = n.length; o < r; o++) {
      const a = n[o].getPosition(), l = new D(a.lineNumber, a.column - 1, a.lineNumber, a.column + 1);
      s[o] = new Dn(l, "");
    }
    return [!0, s];
  }
  static deleteLeft(e, t, n, s, o) {
    if (this.isAutoClosingPairDelete(t.autoClosingDelete, t.autoClosingBrackets, t.autoClosingQuotes, t.autoClosingPairs.autoClosingPairsOpenByEnd, n, s, o)) return this._runAutoClosingPairDelete(t, n, s);
    const r = [];
    let a = e !== 2;
    for (let l = 0, d = s.length; l < d; l++) {
      const h = gg.getDeleteRange(s[l], n, t);
      h.isEmpty() ? r[l] = null : (h.startLineNumber !== h.endLineNumber && (a = !0), r[l] = new Dn(h, ""));
    }
    return [a, r];
  }
  static getDeleteRange(e, t, n) {
    if (!e.isEmpty()) return e;
    const s = e.getPosition();
    if (n.useTabStops && s.column > 1) {
      const o = t.getLineContent(s.lineNumber), r = Jn(o), a = r === -1 ? o.length + 1 : r + 1;
      if (s.column <= a) {
        const l = n.visibleColumnFromColumn(t, s), d = Gi.prevIndentTabStop(l, n.indentSize), h = n.columnFromVisibleColumn(t, s.lineNumber, d);
        return new D(s.lineNumber, h, s.lineNumber, s.column);
      }
    }
    return D.fromPositions(gg.getPositionAfterDeleteLeft(s, t), s);
  }
  static getPositionAfterDeleteLeft(e, t) {
    if (e.column > 1) {
      const n = IK(e.column - 1, t.getLineContent(e.lineNumber));
      return e.with(void 0, n + 1);
    }
    if (e.lineNumber > 1) {
      const n = e.lineNumber - 1;
      return new W(n, t.getLineMaxColumn(n));
    }
    return e;
  }
  static cut(e, t, n) {
    const s = [];
    let o = null;
    n.sort((r, a) => W.compare(r.getStartPosition(), a.getEndPosition()));
    for (let r = 0, a = n.length; r < a; r++) {
      const l = n[r];
      if (l.isEmpty()) if (e.emptySelectionClipboard) {
        const d = l.getPosition();
        let h, c, u, g;
        d.lineNumber < t.getLineCount() ? (h = d.lineNumber, c = 1, u = d.lineNumber + 1, g = 1) : d.lineNumber > 1 && (o == null ? void 0 : o.endLineNumber) !== d.lineNumber ? (h = d.lineNumber - 1, c = t.getLineMaxColumn(d.lineNumber - 1), u = d.lineNumber, g = t.getLineMaxColumn(d.lineNumber)) : (h = d.lineNumber, c = 1, u = d.lineNumber, g = t.getLineMaxColumn(d.lineNumber));
        const p = new D(h, c, u, g);
        o = p, p.isEmpty() ? s[r] = null : s[r] = new Dn(p, "");
      } else s[r] = null;
      else s[r] = new Dn(l, "");
    }
    return new Ls(0, s, { shouldPushStackElementBefore: !0, shouldPushStackElementAfter: !0 });
  }
}
class Ct {
  static _createWord(e, t, n, s, o) {
    return { start: s, end: o, wordType: t, nextCharClass: n };
  }
  static _createIntlWord(e, t) {
    return { start: e.index, end: e.index + e.segment.length, wordType: 1, nextCharClass: t };
  }
  static _findPreviousWordOnLine(e, t, n) {
    const s = t.getLineContent(n.lineNumber);
    return this._doFindPreviousWordOnLine(s, e, n);
  }
  static _doFindPreviousWordOnLine(e, t, n) {
    let s = 0;
    const o = t.findPrevIntlWordBeforeOrAtOffset(e, n.column - 2);
    for (let r = n.column - 2; r >= 0; r--) {
      const a = e.charCodeAt(r), l = t.get(a);
      if (o && r === o.index) return this._createIntlWord(o, l);
      if (l === 0) {
        if (s === 2) return this._createWord(e, s, l, r + 1, this._findEndOfWord(e, t, s, r + 1));
        s = 1;
      } else if (l === 2) {
        if (s === 1) return this._createWord(e, s, l, r + 1, this._findEndOfWord(e, t, s, r + 1));
        s = 2;
      } else if (l === 1 && s !== 0) return this._createWord(e, s, l, r + 1, this._findEndOfWord(e, t, s, r + 1));
    }
    return s !== 0 ? this._createWord(e, s, 1, 0, this._findEndOfWord(e, t, s, 0)) : null;
  }
  static _findEndOfWord(e, t, n, s) {
    const o = t.findNextIntlWordAtOrAfterOffset(e, s), r = e.length;
    for (let a = s; a < r; a++) {
      const l = e.charCodeAt(a), d = t.get(l);
      if (o && a === o.index + o.segment.length || d === 1 || n === 1 && d === 2 || n === 2 && d === 0) return a;
    }
    return r;
  }
  static _findNextWordOnLine(e, t, n) {
    const s = t.getLineContent(n.lineNumber);
    return this._doFindNextWordOnLine(s, e, n);
  }
  static _doFindNextWordOnLine(e, t, n) {
    let s = 0;
    const o = e.length, r = t.findNextIntlWordAtOrAfterOffset(e, n.column - 1);
    for (let a = n.column - 1; a < o; a++) {
      const l = e.charCodeAt(a), d = t.get(l);
      if (r && a === r.index) return this._createIntlWord(r, d);
      if (d === 0) {
        if (s === 2) return this._createWord(e, s, d, this._findStartOfWord(e, t, s, a - 1), a);
        s = 1;
      } else if (d === 2) {
        if (s === 1) return this._createWord(e, s, d, this._findStartOfWord(e, t, s, a - 1), a);
        s = 2;
      } else if (d === 1 && s !== 0) return this._createWord(e, s, d, this._findStartOfWord(e, t, s, a - 1), a);
    }
    return s !== 0 ? this._createWord(e, s, 1, this._findStartOfWord(e, t, s, o - 1), o) : null;
  }
  static _findStartOfWord(e, t, n, s) {
    const o = t.findPrevIntlWordBeforeOrAtOffset(e, s);
    for (let r = s; r >= 0; r--) {
      const a = e.charCodeAt(r), l = t.get(a);
      if (o && r === o.index) return r;
      if (l === 1 || n === 1 && l === 2 || n === 2 && l === 0) return r + 1;
    }
    return 0;
  }
  static moveWordLeft(e, t, n, s) {
    let o = n.lineNumber, r = n.column;
    r === 1 && o > 1 && (o -= 1, r = t.getLineMaxColumn(o));
    let a = Ct._findPreviousWordOnLine(e, t, new W(o, r));
    if (s === 0) return new W(o, a ? a.start + 1 : 1);
    if (s === 1) return a && a.wordType === 2 && a.end - a.start == 1 && a.nextCharClass === 0 && (a = Ct._findPreviousWordOnLine(e, t, new W(o, a.start + 1))), new W(o, a ? a.start + 1 : 1);
    if (s === 3) {
      for (; a && a.wordType === 2; ) a = Ct._findPreviousWordOnLine(e, t, new W(o, a.start + 1));
      return new W(o, a ? a.start + 1 : 1);
    }
    return a && r <= a.end + 1 && (a = Ct._findPreviousWordOnLine(e, t, new W(o, a.start + 1))), new W(o, a ? a.end + 1 : 1);
  }
  static _moveWordPartLeft(e, t) {
    const n = t.lineNumber, s = e.getLineMaxColumn(n);
    if (t.column === 1) return n > 1 ? new W(n - 1, e.getLineMaxColumn(n - 1)) : t;
    const o = e.getLineContent(n);
    for (let r = t.column - 1; r > 1; r--) {
      const a = o.charCodeAt(r - 2), l = o.charCodeAt(r - 1);
      if (a === 95 && l !== 95) return new W(n, r);
      if (a === 45 && l !== 45) return new W(n, r);
      if ((Eh(a) || Q1(a)) && Wa(l)) return new W(n, r);
      if (Wa(a) && Wa(l) && r + 1 < s) {
        const d = o.charCodeAt(r);
        if (Eh(d) || Q1(d)) return new W(n, r);
      }
    }
    return new W(n, 1);
  }
  static moveWordRight(e, t, n, s) {
    let o = n.lineNumber, r = n.column, a = !1;
    r === t.getLineMaxColumn(o) && o < t.getLineCount() && (a = !0, o += 1, r = 1);
    let l = Ct._findNextWordOnLine(e, t, new W(o, r));
    if (s === 2) l && l.wordType === 2 && l.end - l.start == 1 && l.nextCharClass === 0 && (l = Ct._findNextWordOnLine(e, t, new W(o, l.end + 1))), r = l ? l.end + 1 : t.getLineMaxColumn(o);
    else if (s === 3) {
      for (a && (r = 0); l && (l.wordType === 2 || l.start + 1 <= r); ) l = Ct._findNextWordOnLine(e, t, new W(o, l.end + 1));
      r = l ? l.start + 1 : t.getLineMaxColumn(o);
    } else l && !a && r >= l.start + 1 && (l = Ct._findNextWordOnLine(e, t, new W(o, l.end + 1))), r = l ? l.start + 1 : t.getLineMaxColumn(o);
    return new W(o, r);
  }
  static _moveWordPartRight(e, t) {
    const n = t.lineNumber, s = e.getLineMaxColumn(n);
    if (t.column === s) return n < e.getLineCount() ? new W(n + 1, 1) : t;
    const o = e.getLineContent(n);
    for (let r = t.column + 1; r < s; r++) {
      const a = o.charCodeAt(r - 2), l = o.charCodeAt(r - 1);
      if (a !== 95 && l === 95) return new W(n, r);
      if (a !== 45 && l === 45) return new W(n, r);
      if ((Eh(a) || Q1(a)) && Wa(l)) return new W(n, r);
      if (Wa(a) && Wa(l) && r + 1 < s) {
        const d = o.charCodeAt(r);
        if (Eh(d) || Q1(d)) return new W(n, r);
      }
    }
    return new W(n, s);
  }
  static _deleteWordLeftWhitespace(e, t) {
    const n = e.getLineContent(t.lineNumber), s = t.column - 2, o = ra(n, s);
    return o + 1 < s ? new D(t.lineNumber, o + 2, t.lineNumber, t.column) : null;
  }
  static deleteWordLeft(e, t) {
    const n = e.wordSeparators, s = e.model, o = e.selection, r = e.whitespaceHeuristics;
    if (!o.isEmpty()) return o;
    if (gg.isAutoClosingPairDelete(e.autoClosingDelete, e.autoClosingBrackets, e.autoClosingQuotes, e.autoClosingPairs.autoClosingPairsOpenByEnd, e.model, [e.selection], e.autoClosedCharacters)) {
      const c = e.selection.getPosition();
      return new D(c.lineNumber, c.column - 1, c.lineNumber, c.column + 1);
    }
    const a = new W(o.positionLineNumber, o.positionColumn);
    let l = a.lineNumber, d = a.column;
    if (l === 1 && d === 1) return null;
    if (r) {
      const c = this._deleteWordLeftWhitespace(s, a);
      if (c) return c;
    }
    let h = Ct._findPreviousWordOnLine(n, s, a);
    return t === 0 ? h ? d = h.start + 1 : d > 1 ? d = 1 : (l--, d = s.getLineMaxColumn(l)) : (h && d <= h.end + 1 && (h = Ct._findPreviousWordOnLine(n, s, new W(l, h.start + 1))), h ? d = h.end + 1 : d > 1 ? d = 1 : (l--, d = s.getLineMaxColumn(l))), new D(l, d, a.lineNumber, a.column);
  }
  static deleteInsideWord(e, t, n) {
    if (!n.isEmpty()) return n;
    const s = new W(n.positionLineNumber, n.positionColumn);
    return this._deleteInsideWordWhitespace(t, s) || this._deleteInsideWordDetermineDeleteRange(e, t, s);
  }
  static _charAtIsWhitespace(e, t) {
    const n = e.charCodeAt(t);
    return n === 32 || n === 9;
  }
  static _deleteInsideWordWhitespace(e, t) {
    const n = e.getLineContent(t.lineNumber), s = n.length;
    if (s === 0) return null;
    let o = Math.max(t.column - 2, 0);
    if (!this._charAtIsWhitespace(n, o)) return null;
    let r = Math.min(t.column - 1, s - 1);
    if (!this._charAtIsWhitespace(n, r)) return null;
    for (; o > 0 && this._charAtIsWhitespace(n, o - 1); ) o--;
    for (; r + 1 < s && this._charAtIsWhitespace(n, r + 1); ) r++;
    return new D(t.lineNumber, o + 1, t.lineNumber, r + 2);
  }
  static _deleteInsideWordDetermineDeleteRange(e, t, n) {
    const s = t.getLineContent(n.lineNumber), o = s.length;
    if (o === 0) return n.lineNumber > 1 ? new D(n.lineNumber - 1, t.getLineMaxColumn(n.lineNumber - 1), n.lineNumber, 1) : n.lineNumber < t.getLineCount() ? new D(n.lineNumber, 1, n.lineNumber + 1, 1) : new D(n.lineNumber, 1, n.lineNumber, 1);
    const r = (c) => c.start + 1 <= n.column && n.column <= c.end + 1, a = (c, u) => (c = Math.min(c, n.column), u = Math.max(u, n.column), new D(n.lineNumber, c, n.lineNumber, u)), l = (c) => {
      let u = c.start + 1, g = c.end + 1, p = !1;
      for (; g - 1 < o && this._charAtIsWhitespace(s, g - 1); ) p = !0, g++;
      if (!p) for (; u > 1 && this._charAtIsWhitespace(s, u - 2); ) u--;
      return a(u, g);
    }, d = Ct._findPreviousWordOnLine(e, t, n);
    if (d && r(d)) return l(d);
    const h = Ct._findNextWordOnLine(e, t, n);
    return h && r(h) ? l(h) : d && h ? a(d.end + 1, h.start + 1) : d ? a(d.start + 1, d.end + 1) : h ? a(h.start + 1, h.end + 1) : a(1, o + 1);
  }
  static _deleteWordPartLeft(e, t) {
    if (!t.isEmpty()) return t;
    const n = t.getPosition(), s = Ct._moveWordPartLeft(e, n);
    return new D(n.lineNumber, n.column, s.lineNumber, s.column);
  }
  static _findFirstNonWhitespaceChar(e, t) {
    const n = e.length;
    for (let s = t; s < n; s++) {
      const o = e.charAt(s);
      if (o !== " " && o !== "	") return s;
    }
    return n;
  }
  static _deleteWordRightWhitespace(e, t) {
    const n = e.getLineContent(t.lineNumber), s = t.column - 1, o = this._findFirstNonWhitespaceChar(n, s);
    return s + 1 < o ? new D(t.lineNumber, t.column, t.lineNumber, o + 1) : null;
  }
  static deleteWordRight(e, t) {
    const n = e.wordSeparators, s = e.model, o = e.selection, r = e.whitespaceHeuristics;
    if (!o.isEmpty()) return o;
    const a = new W(o.positionLineNumber, o.positionColumn);
    let l = a.lineNumber, d = a.column;
    const h = s.getLineCount(), c = s.getLineMaxColumn(l);
    if (l === h && d === c) return null;
    if (r) {
      const g = this._deleteWordRightWhitespace(s, a);
      if (g) return g;
    }
    let u = Ct._findNextWordOnLine(n, s, a);
    return t === 2 ? u ? d = u.end + 1 : d < c || l === h ? d = c : (l++, u = Ct._findNextWordOnLine(n, s, new W(l, 1)), d = u ? u.start + 1 : s.getLineMaxColumn(l)) : (u && d >= u.start + 1 && (u = Ct._findNextWordOnLine(n, s, new W(l, u.end + 1))), u ? d = u.start + 1 : d < c || l === h ? d = c : (l++, u = Ct._findNextWordOnLine(n, s, new W(l, 1)), d = u ? u.start + 1 : s.getLineMaxColumn(l))), new D(l, d, a.lineNumber, a.column);
  }
  static _deleteWordPartRight(e, t) {
    if (!t.isEmpty()) return t;
    const n = t.getPosition(), s = Ct._moveWordPartRight(e, n);
    return new D(n.lineNumber, n.column, s.lineNumber, s.column);
  }
  static _createWordAtPosition(e, t, n) {
    const s = new D(t, n.start + 1, t, n.end + 1);
    return { word: e.getValueInRange(s), startColumn: s.startColumn, endColumn: s.endColumn };
  }
  static getWordAtPosition(e, t, n, s) {
    const o = zo(t, n), r = Ct._findPreviousWordOnLine(o, e, s);
    if (r && r.wordType === 1 && r.start <= s.column - 1 && s.column - 1 <= r.end) return Ct._createWordAtPosition(e, s.lineNumber, r);
    const a = Ct._findNextWordOnLine(o, e, s);
    return a && a.wordType === 1 && a.start <= s.column - 1 && s.column - 1 <= a.end ? Ct._createWordAtPosition(e, s.lineNumber, a) : null;
  }
  static word(e, t, n, s, o) {
    const r = zo(e.wordSeparators, e.wordSegmenterLocales), a = Ct._findPreviousWordOnLine(r, t, o), l = Ct._findNextWordOnLine(r, t, o);
    if (!s) {
      let g, p;
      return a && a.wordType === 1 && a.start <= o.column - 1 && o.column - 1 <= a.end ? (g = a.start + 1, p = a.end + 1) : l && l.wordType === 1 && l.start <= o.column - 1 && o.column - 1 <= l.end ? (g = l.start + 1, p = l.end + 1) : (g = a ? a.end + 1 : 1, p = l ? l.start + 1 : t.getLineMaxColumn(o.lineNumber)), new bn(new D(o.lineNumber, g, o.lineNumber, p), 1, 0, new W(o.lineNumber, p), 0);
    }
    let d, h;
    a && a.wordType === 1 && a.start < o.column - 1 && o.column - 1 < a.end ? (d = a.start + 1, h = a.end + 1) : l && l.wordType === 1 && l.start < o.column - 1 && o.column - 1 < l.end ? (d = l.start + 1, h = l.end + 1) : (d = o.column, h = o.column);
    const c = o.lineNumber;
    let u;
    if (n.selectionStart.containsPosition(o)) u = n.selectionStart.endColumn;
    else if (o.isBeforeOrEqual(n.selectionStart.getStartPosition())) {
      u = d;
      const g = new W(c, u);
      n.selectionStart.containsPosition(g) && (u = n.selectionStart.endColumn);
    } else {
      u = h;
      const g = new W(c, u);
      n.selectionStart.containsPosition(g) && (u = n.selectionStart.startColumn);
    }
    return n.move(!0, c, u, 0);
  }
}
class uy extends Ct {
  static deleteWordPartLeft(e) {
    const t = _b([Ct.deleteWordLeft(e, 0), Ct.deleteWordLeft(e, 2), Ct._deleteWordPartLeft(e.model, e.selection)]);
    return t.sort(D.compareRangesUsingEnds), t[2];
  }
  static deleteWordPartRight(e) {
    const t = _b([Ct.deleteWordRight(e, 0), Ct.deleteWordRight(e, 2), Ct._deleteWordPartRight(e.model, e.selection)]);
    return t.sort(D.compareRangesUsingStarts), t[0];
  }
  static moveWordPartLeft(e, t, n) {
    const s = _b([Ct.moveWordLeft(e, t, n, 0), Ct.moveWordLeft(e, t, n, 2), Ct._moveWordPartLeft(t, n)]);
    return s.sort(W.compare), s[2];
  }
  static moveWordPartRight(e, t, n) {
    const s = _b([Ct.moveWordRight(e, t, n, 0), Ct.moveWordRight(e, t, n, 2), Ct._moveWordPartRight(t, n)]);
    return s.sort(W.compare), s[0];
  }
}
function _b(i) {
  return i.filter((e) => !!e);
}
class mn {
  static addCursorDown(e, t, n) {
    const s = [];
    let o = 0;
    for (let r = 0, a = t.length; r < a; r++) {
      const l = t[r];
      s[o++] = new pt(l.modelState, l.viewState), s[o++] = n ? pt.fromModelState(St.translateDown(e.cursorConfig, e.model, l.modelState)) : pt.fromViewState(St.translateDown(e.cursorConfig, e, l.viewState));
    }
    return s;
  }
  static addCursorUp(e, t, n) {
    const s = [];
    let o = 0;
    for (let r = 0, a = t.length; r < a; r++) {
      const l = t[r];
      s[o++] = new pt(l.modelState, l.viewState), s[o++] = n ? pt.fromModelState(St.translateUp(e.cursorConfig, e.model, l.modelState)) : pt.fromViewState(St.translateUp(e.cursorConfig, e, l.viewState));
    }
    return s;
  }
  static moveToBeginningOfLine(e, t, n) {
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o];
      s[o] = this._moveToLineStart(e, a, n);
    }
    return s;
  }
  static _moveToLineStart(e, t, n) {
    const s = t.viewState.position.column, o = s === t.modelState.position.column, r = t.viewState.position.lineNumber, a = e.getLineFirstNonWhitespaceColumn(r);
    return o || s === a ? this._moveToLineStartByModel(e, t, n) : this._moveToLineStartByView(e, t, n);
  }
  static _moveToLineStartByView(e, t, n) {
    return pt.fromViewState(St.moveToBeginningOfLine(e.cursorConfig, e, t.viewState, n));
  }
  static _moveToLineStartByModel(e, t, n) {
    return pt.fromModelState(St.moveToBeginningOfLine(e.cursorConfig, e.model, t.modelState, n));
  }
  static moveToEndOfLine(e, t, n, s) {
    const o = [];
    for (let r = 0, a = t.length; r < a; r++) {
      const l = t[r];
      o[r] = this._moveToLineEnd(e, l, n, s);
    }
    return o;
  }
  static _moveToLineEnd(e, t, n, s) {
    const o = t.viewState.position, r = e.getLineMaxColumn(o.lineNumber), a = o.column === r, l = t.modelState.position, d = e.model.getLineMaxColumn(l.lineNumber), h = r - o.column == d - l.column;
    return a || h ? this._moveToLineEndByModel(e, t, n, s) : this._moveToLineEndByView(e, t, n, s);
  }
  static _moveToLineEndByView(e, t, n, s) {
    return pt.fromViewState(St.moveToEndOfLine(e.cursorConfig, e, t.viewState, n, s));
  }
  static _moveToLineEndByModel(e, t, n, s) {
    return pt.fromModelState(St.moveToEndOfLine(e.cursorConfig, e.model, t.modelState, n, s));
  }
  static expandLineSelection(e, t) {
    const n = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const r = t[s], a = r.modelState.selection.startLineNumber, l = e.model.getLineCount();
      let d, h = r.modelState.selection.endLineNumber;
      h === l ? d = e.model.getLineMaxColumn(l) : (h++, d = 1), n[s] = pt.fromModelState(new bn(new D(a, 1, a, 1), 0, 0, new W(h, d), 0));
    }
    return n;
  }
  static moveToBeginningOfBuffer(e, t, n) {
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o];
      s[o] = pt.fromModelState(St.moveToBeginningOfBuffer(e.cursorConfig, e.model, a.modelState, n));
    }
    return s;
  }
  static moveToEndOfBuffer(e, t, n) {
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o];
      s[o] = pt.fromModelState(St.moveToEndOfBuffer(e.cursorConfig, e.model, a.modelState, n));
    }
    return s;
  }
  static selectAll(e, t) {
    const n = e.model.getLineCount(), s = e.model.getLineMaxColumn(n);
    return pt.fromModelState(new bn(new D(1, 1, 1, 1), 0, 0, new W(n, s), 0));
  }
  static line(e, t, n, s, o) {
    const r = e.model.validatePosition(s), a = o ? e.coordinatesConverter.validateViewPosition(new W(o.lineNumber, o.column), r) : e.coordinatesConverter.convertModelPositionToViewPosition(r);
    if (!n) {
      const d = e.model.getLineCount();
      let h = r.lineNumber + 1, c = 1;
      return h > d && (h = d, c = e.model.getLineMaxColumn(h)), pt.fromModelState(new bn(new D(r.lineNumber, 1, h, c), 2, 0, new W(h, c), 0));
    }
    const l = t.modelState.selectionStart.getStartPosition().lineNumber;
    if (r.lineNumber < l) return pt.fromViewState(t.viewState.move(!0, a.lineNumber, 1, 0));
    if (r.lineNumber > l) {
      const d = e.getLineCount();
      let h = a.lineNumber + 1, c = 1;
      return h > d && (h = d, c = e.getLineMaxColumn(h)), pt.fromViewState(t.viewState.move(!0, h, c, 0));
    }
    {
      const d = t.modelState.selectionStart.getEndPosition();
      return pt.fromModelState(t.modelState.move(!0, d.lineNumber, d.column, 0));
    }
  }
  static word(e, t, n, s) {
    const o = e.model.validatePosition(s);
    return pt.fromModelState(Ct.word(e.cursorConfig, e.model, t.modelState, n, o));
  }
  static cancelSelection(e, t) {
    if (!t.modelState.hasSelection()) return new pt(t.modelState, t.viewState);
    const n = t.viewState.position.lineNumber, s = t.viewState.position.column;
    return pt.fromViewState(new bn(new D(n, s, n, s), 0, 0, new W(n, s), 0));
  }
  static moveTo(e, t, n, s, o) {
    if (n) {
      if (t.modelState.selectionStartKind === 1) return this.word(e, t, n, s);
      if (t.modelState.selectionStartKind === 2) return this.line(e, t, n, s, o);
    }
    const r = e.model.validatePosition(s), a = o ? e.coordinatesConverter.validateViewPosition(new W(o.lineNumber, o.column), r) : e.coordinatesConverter.convertModelPositionToViewPosition(r);
    return pt.fromViewState(t.viewState.move(n, a.lineNumber, a.column, 0));
  }
  static simpleMove(e, t, n, s, o, r) {
    switch (n) {
      case 0:
        return r === 4 ? this._moveHalfLineLeft(e, t, s) : this._moveLeft(e, t, s, o);
      case 1:
        return r === 4 ? this._moveHalfLineRight(e, t, s) : this._moveRight(e, t, s, o);
      case 2:
        return r === 2 ? this._moveUpByViewLines(e, t, s, o) : this._moveUpByModelLines(e, t, s, o);
      case 3:
        return r === 2 ? this._moveDownByViewLines(e, t, s, o) : this._moveDownByModelLines(e, t, s, o);
      case 4:
        return r === 2 ? t.map((a) => pt.fromViewState(St.moveToPrevBlankLine(e.cursorConfig, e, a.viewState, s))) : t.map((a) => pt.fromModelState(St.moveToPrevBlankLine(e.cursorConfig, e.model, a.modelState, s)));
      case 5:
        return r === 2 ? t.map((a) => pt.fromViewState(St.moveToNextBlankLine(e.cursorConfig, e, a.viewState, s))) : t.map((a) => pt.fromModelState(St.moveToNextBlankLine(e.cursorConfig, e.model, a.modelState, s)));
      case 6:
        return this._moveToViewMinColumn(e, t, s);
      case 7:
        return this._moveToViewFirstNonWhitespaceColumn(e, t, s);
      case 8:
        return this._moveToViewCenterColumn(e, t, s);
      case 9:
        return this._moveToViewMaxColumn(e, t, s);
      case 10:
        return this._moveToViewLastNonWhitespaceColumn(e, t, s);
      default:
        return null;
    }
  }
  static viewportMove(e, t, n, s, o) {
    const r = e.getCompletelyVisibleViewRange(), a = e.coordinatesConverter.convertViewRangeToModelRange(r);
    switch (n) {
      case 11: {
        const l = this._firstLineNumberInRange(e.model, a, o), d = e.model.getLineFirstNonWhitespaceColumn(l);
        return [this._moveToModelPosition(e, t[0], s, l, d)];
      }
      case 13: {
        const l = this._lastLineNumberInRange(e.model, a, o), d = e.model.getLineFirstNonWhitespaceColumn(l);
        return [this._moveToModelPosition(e, t[0], s, l, d)];
      }
      case 12: {
        const l = Math.round((a.startLineNumber + a.endLineNumber) / 2), d = e.model.getLineFirstNonWhitespaceColumn(l);
        return [this._moveToModelPosition(e, t[0], s, l, d)];
      }
      case 14: {
        const l = [];
        for (let d = 0, h = t.length; d < h; d++) {
          const c = t[d];
          l[d] = this.findPositionInViewportIfOutside(e, c, r, s);
        }
        return l;
      }
      default:
        return null;
    }
  }
  static findPositionInViewportIfOutside(e, t, n, s) {
    const o = t.viewState.position.lineNumber;
    if (n.startLineNumber <= o && o <= n.endLineNumber - 1) return new pt(t.modelState, t.viewState);
    {
      let r;
      r = o > n.endLineNumber - 1 ? n.endLineNumber - 1 : o < n.startLineNumber ? n.startLineNumber : o;
      const a = St.vertical(e.cursorConfig, e, o, t.viewState.position.column, t.viewState.leftoverVisibleColumns, r, !1);
      return pt.fromViewState(t.viewState.move(s, a.lineNumber, a.column, a.leftoverVisibleColumns));
    }
  }
  static _firstLineNumberInRange(e, t, n) {
    let s = t.startLineNumber;
    return t.startColumn !== e.getLineMinColumn(s) && s++, Math.min(t.endLineNumber, s + n - 1);
  }
  static _lastLineNumberInRange(e, t, n) {
    let s = t.startLineNumber;
    return t.startColumn !== e.getLineMinColumn(s) && s++, Math.max(s, t.endLineNumber - n + 1);
  }
  static _moveLeft(e, t, n, s) {
    return t.map((o) => pt.fromViewState(St.moveLeft(e.cursorConfig, e, o.viewState, n, s)));
  }
  static _moveHalfLineLeft(e, t, n) {
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o], l = a.viewState.position.lineNumber, d = Math.round(e.getLineLength(l) / 2);
      s[o] = pt.fromViewState(St.moveLeft(e.cursorConfig, e, a.viewState, n, d));
    }
    return s;
  }
  static _moveRight(e, t, n, s) {
    return t.map((o) => pt.fromViewState(St.moveRight(e.cursorConfig, e, o.viewState, n, s)));
  }
  static _moveHalfLineRight(e, t, n) {
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o], l = a.viewState.position.lineNumber, d = Math.round(e.getLineLength(l) / 2);
      s[o] = pt.fromViewState(St.moveRight(e.cursorConfig, e, a.viewState, n, d));
    }
    return s;
  }
  static _moveDownByViewLines(e, t, n, s) {
    const o = [];
    for (let r = 0, a = t.length; r < a; r++) {
      const l = t[r];
      o[r] = pt.fromViewState(St.moveDown(e.cursorConfig, e, l.viewState, n, s));
    }
    return o;
  }
  static _moveDownByModelLines(e, t, n, s) {
    const o = [];
    for (let r = 0, a = t.length; r < a; r++) {
      const l = t[r];
      o[r] = pt.fromModelState(St.moveDown(e.cursorConfig, e.model, l.modelState, n, s));
    }
    return o;
  }
  static _moveUpByViewLines(e, t, n, s) {
    const o = [];
    for (let r = 0, a = t.length; r < a; r++) {
      const l = t[r];
      o[r] = pt.fromViewState(St.moveUp(e.cursorConfig, e, l.viewState, n, s));
    }
    return o;
  }
  static _moveUpByModelLines(e, t, n, s) {
    const o = [];
    for (let r = 0, a = t.length; r < a; r++) {
      const l = t[r];
      o[r] = pt.fromModelState(St.moveUp(e.cursorConfig, e.model, l.modelState, n, s));
    }
    return o;
  }
  static _moveToViewPosition(e, t, n, s, o) {
    return pt.fromViewState(t.viewState.move(n, s, o, 0));
  }
  static _moveToModelPosition(e, t, n, s, o) {
    return pt.fromModelState(t.modelState.move(n, s, o, 0));
  }
  static _moveToViewMinColumn(e, t, n) {
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o], l = a.viewState.position.lineNumber, d = e.getLineMinColumn(l);
      s[o] = this._moveToViewPosition(e, a, n, l, d);
    }
    return s;
  }
  static _moveToViewFirstNonWhitespaceColumn(e, t, n) {
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o], l = a.viewState.position.lineNumber, d = e.getLineFirstNonWhitespaceColumn(l);
      s[o] = this._moveToViewPosition(e, a, n, l, d);
    }
    return s;
  }
  static _moveToViewCenterColumn(e, t, n) {
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o], l = a.viewState.position.lineNumber, d = Math.round((e.getLineMaxColumn(l) + e.getLineMinColumn(l)) / 2);
      s[o] = this._moveToViewPosition(e, a, n, l, d);
    }
    return s;
  }
  static _moveToViewMaxColumn(e, t, n) {
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o], l = a.viewState.position.lineNumber, d = e.getLineMaxColumn(l);
      s[o] = this._moveToViewPosition(e, a, n, l, d);
    }
    return s;
  }
  static _moveToViewLastNonWhitespaceColumn(e, t, n) {
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o], l = a.viewState.position.lineNumber, d = e.getLineLastNonWhitespaceColumn(l);
      s[o] = this._moveToViewPosition(e, a, n, l, d);
    }
    return s;
  }
}
var gy;
function rm(i, e, t, n) {
  const s = em(e, t.startLineNumber, t.startColumn), o = n.getLanguageConfiguration(s.languageId);
  if (!o) return null;
  const r = s.getLineContent(), a = r.substr(0, t.startColumn - 1 - s.firstCharOffset);
  let l;
  t.isEmpty() ? l = r.substr(t.startColumn - 1 - s.firstCharOffset) : l = em(e, t.endLineNumber, t.endColumn).getLineContent().substr(t.endColumn - 1 - s.firstCharOffset);
  let d = "";
  if (t.startLineNumber > 1 && s.firstCharOffset === 0) {
    const f = em(e, t.startLineNumber - 1);
    f.languageId === s.languageId && (d = f.getLineContent());
  }
  const h = o.onEnter(i, d, a, l);
  if (!h) return null;
  const c = h.indentAction;
  let u = h.appendText;
  const g = h.removeText || 0;
  u ? c === Oi.Indent && (u = "	" + u) : u = c === Oi.Indent || c === Oi.IndentOutdent ? "	" : "";
  let p = j8(e, t.startLineNumber, t.startColumn);
  return g && (p = p.substring(0, p.length - g)), { indentAction: c, appendText: u, removeText: g, indentation: p };
}
(function(i) {
  i.metadata = { description: "Move cursor to a logical position in the view", args: [{ name: "Cursor move argument object", description: `Property-value pairs that can be passed through this argument:
					* 'to': A mandatory logical position value providing where to move the cursor.
						\`\`\`
						'left', 'right', 'up', 'down', 'prevBlankLine', 'nextBlankLine',
						'wrappedLineStart', 'wrappedLineEnd', 'wrappedLineColumnCenter'
						'wrappedLineFirstNonWhitespaceCharacter', 'wrappedLineLastNonWhitespaceCharacter'
						'viewPortTop', 'viewPortCenter', 'viewPortBottom', 'viewPortIfOutside'
						\`\`\`
					* 'by': Unit to move. Default is computed based on 'to' value.
						\`\`\`
						'line', 'wrappedLine', 'character', 'halfLine'
						\`\`\`
					* 'value': Number of units to move. Default is '1'.
					* 'select': If 'true' makes the selection. Default is 'false'.
				`, constraint: function(e) {
    if (!ms(e)) return !1;
    const t = e;
    return !!ps(t.to) && !(!$s(t.select) && !_7(t.select)) && !(!$s(t.by) && !ps(t.by)) && !(!$s(t.value) && !gc(t.value));
  }, schema: { type: "object", required: ["to"], properties: { to: { type: "string", enum: ["left", "right", "up", "down", "prevBlankLine", "nextBlankLine", "wrappedLineStart", "wrappedLineEnd", "wrappedLineColumnCenter", "wrappedLineFirstNonWhitespaceCharacter", "wrappedLineLastNonWhitespaceCharacter", "viewPortTop", "viewPortCenter", "viewPortBottom", "viewPortIfOutside"] }, by: { type: "string", enum: ["line", "wrappedLine", "character", "halfLine"] }, value: { type: "number", default: 1 }, select: { type: "boolean", default: !1 } } } }] }, i.RawDirection = { Left: "left", Right: "right", Up: "up", Down: "down", PrevBlankLine: "prevBlankLine", NextBlankLine: "nextBlankLine", WrappedLineStart: "wrappedLineStart", WrappedLineFirstNonWhitespaceCharacter: "wrappedLineFirstNonWhitespaceCharacter", WrappedLineColumnCenter: "wrappedLineColumnCenter", WrappedLineEnd: "wrappedLineEnd", WrappedLineLastNonWhitespaceCharacter: "wrappedLineLastNonWhitespaceCharacter", ViewPortTop: "viewPortTop", ViewPortCenter: "viewPortCenter", ViewPortBottom: "viewPortBottom", ViewPortIfOutside: "viewPortIfOutside" }, i.RawUnit = { Line: "line", WrappedLine: "wrappedLine", Character: "character", HalfLine: "halfLine" }, i.parse = function(e) {
    if (!e.to) return null;
    let t;
    switch (e.to) {
      case i.RawDirection.Left:
        t = 0;
        break;
      case i.RawDirection.Right:
        t = 1;
        break;
      case i.RawDirection.Up:
        t = 2;
        break;
      case i.RawDirection.Down:
        t = 3;
        break;
      case i.RawDirection.PrevBlankLine:
        t = 4;
        break;
      case i.RawDirection.NextBlankLine:
        t = 5;
        break;
      case i.RawDirection.WrappedLineStart:
        t = 6;
        break;
      case i.RawDirection.WrappedLineFirstNonWhitespaceCharacter:
        t = 7;
        break;
      case i.RawDirection.WrappedLineColumnCenter:
        t = 8;
        break;
      case i.RawDirection.WrappedLineEnd:
        t = 9;
        break;
      case i.RawDirection.WrappedLineLastNonWhitespaceCharacter:
        t = 10;
        break;
      case i.RawDirection.ViewPortTop:
        t = 11;
        break;
      case i.RawDirection.ViewPortBottom:
        t = 13;
        break;
      case i.RawDirection.ViewPortCenter:
        t = 12;
        break;
      case i.RawDirection.ViewPortIfOutside:
        t = 14;
        break;
      default:
        return null;
    }
    let n = 0;
    switch (e.by) {
      case i.RawUnit.Line:
        n = 1;
        break;
      case i.RawUnit.WrappedLine:
        n = 2;
        break;
      case i.RawUnit.Character:
        n = 3;
        break;
      case i.RawUnit.HalfLine:
        n = 4;
    }
    return { direction: t, unit: n, select: !!e.select, value: e.value || 1 };
  };
})(gy || (gy = {}));
var HC, nY = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, sY = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const _D = /* @__PURE__ */ Object.create(null);
function zc(i, e) {
  if (e <= 0) return "";
  _D[i] || (_D[i] = ["", i]);
  const t = _D[i];
  for (let n = t.length; n <= e; n++) t[n] = t[n - 1] + i;
  return t[e];
}
let Ko = HC = class {
  static unshiftIndent(i, e, t, n, s) {
    const o = Gi.visibleColumnFromColumn(i, e, t);
    if (s) {
      const r = zc(" ", n);
      return zc(r, Gi.prevIndentTabStop(o, n) / n);
    }
    return zc("	", Gi.prevRenderTabStop(o, t) / t);
  }
  static shiftIndent(i, e, t, n, s) {
    const o = Gi.visibleColumnFromColumn(i, e, t);
    if (s) {
      const r = zc(" ", n);
      return zc(r, Gi.nextIndentTabStop(o, n) / n);
    }
    return zc("	", Gi.nextRenderTabStop(o, t) / t);
  }
  constructor(i, e, t) {
    this._languageConfigurationService = t, this._opts = e, this._selection = i, this._selectionId = null, this._useLastEditRangeForCursorEndPosition = !1, this._selectionStartColumnStaysPut = !1;
  }
  _addEditOperation(i, e, t) {
    this._useLastEditRangeForCursorEndPosition ? i.addTrackedEditOperation(e, t) : i.addEditOperation(e, t);
  }
  getEditOperations(i, e) {
    const t = this._selection.startLineNumber;
    let n = this._selection.endLineNumber;
    this._selection.endColumn === 1 && t !== n && (n -= 1);
    const { tabSize: s, indentSize: o, insertSpaces: r } = this._opts, a = t === n;
    if (this._opts.useTabStops) {
      this._selection.isEmpty() && /^\s*$/.test(i.getLineContent(t)) && (this._useLastEditRangeForCursorEndPosition = !0);
      let l = 0, d = 0;
      for (let h = t; h <= n; h++, l = d) {
        d = 0;
        const c = i.getLineContent(h);
        let u, g = Jn(c);
        if ((!this._opts.isUnshift || c.length !== 0 && g !== 0) && (a || this._opts.isUnshift || c.length !== 0)) {
          if (g === -1 && (g = c.length), h > 1 && Gi.visibleColumnFromColumn(c, g + 1, s) % o != 0 && i.tokenization.isCheapToTokenize(h - 1)) {
            const p = rm(this._opts.autoIndent, i, new D(h - 1, i.getLineMaxColumn(h - 1), h - 1, i.getLineMaxColumn(h - 1)), this._languageConfigurationService);
            if (p) {
              if (d = l, p.appendText) for (let f = 0, _ = p.appendText.length; f < _ && d < o && p.appendText.charCodeAt(f) === 32; f++) d++;
              p.removeText && (d = Math.max(0, d - p.removeText));
              for (let f = 0; f < d && g !== 0 && c.charCodeAt(g - 1) === 32; f++) g--;
            }
          }
          this._opts.isUnshift && g === 0 || (u = this._opts.isUnshift ? HC.unshiftIndent(c, g + 1, s, o, r) : HC.shiftIndent(c, g + 1, s, o, r), this._addEditOperation(e, new D(h, 1, h, g + 1), u), h !== t || this._selection.isEmpty() || (this._selectionStartColumnStaysPut = this._selection.startColumn <= g + 1));
        }
      }
    } else {
      !this._opts.isUnshift && this._selection.isEmpty() && i.getLineLength(t) === 0 && (this._useLastEditRangeForCursorEndPosition = !0);
      const l = r ? zc(" ", o) : "	";
      for (let d = t; d <= n; d++) {
        const h = i.getLineContent(d);
        let c = Jn(h);
        if ((!this._opts.isUnshift || h.length !== 0 && c !== 0) && (a || this._opts.isUnshift || h.length !== 0) && (c === -1 && (c = h.length), !this._opts.isUnshift || c !== 0)) if (this._opts.isUnshift) {
          c = Math.min(c, o);
          for (let u = 0; u < c; u++)
            if (h.charCodeAt(u) === 9) {
              c = u + 1;
              break;
            }
          this._addEditOperation(e, new D(d, 1, d, c + 1), "");
        } else this._addEditOperation(e, new D(d, 1, d, 1), l), d !== t || this._selection.isEmpty() || (this._selectionStartColumnStaysPut = this._selection.startColumn === 1);
      }
    }
    this._selectionId = e.trackSelection(this._selection);
  }
  computeCursorState(i, e) {
    if (this._useLastEditRangeForCursorEndPosition) {
      const n = e.getInverseEditOperations()[0];
      return new _e(n.range.endLineNumber, n.range.endColumn, n.range.endLineNumber, n.range.endColumn);
    }
    const t = e.getTrackedSelection(this._selectionId);
    if (this._selectionStartColumnStaysPut) {
      const n = this._selection.startColumn;
      return t.startColumn <= n ? t : t.getDirection() === 0 ? new _e(t.startLineNumber, n, t.endLineNumber, t.endColumn) : new _e(t.endLineNumber, t.endColumn, t.startLineNumber, n);
    }
    return t;
  }
};
Ko = HC = nY([sY(2, zt)], Ko);
class oY {
  constructor(e, t, n) {
    this._range = e, this._charBeforeSelection = t, this._charAfterSelection = n;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(new D(this._range.startLineNumber, this._range.startColumn, this._range.startLineNumber, this._range.startColumn), this._charBeforeSelection), t.addTrackedEditOperation(new D(this._range.endLineNumber, this._range.endColumn, this._range.endLineNumber, this._range.endColumn), this._charAfterSelection);
  }
  computeCursorState(e, t) {
    const n = t.getInverseEditOperations(), s = n[0].range, o = n[1].range;
    return new _e(s.endLineNumber, s.endColumn, o.endLineNumber, o.endColumn - this._charAfterSelection.length);
  }
}
class rY {
  constructor(e, t, n) {
    this._position = e, this._text = t, this._charAfter = n;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(new D(this._position.lineNumber, this._position.column, this._position.lineNumber, this._position.column), this._text + this._charAfter);
  }
  computeCursorState(e, t) {
    const n = t.getInverseEditOperations()[0].range;
    return new _e(n.endLineNumber, n.startColumn, n.endLineNumber, n.endColumn - this._charAfter.length);
  }
}
function zC(i, e, t, n = !0, s) {
  if (i < 4) return null;
  const o = s.getLanguageConfiguration(e.tokenization.getLanguageId()).indentRulesSupport;
  if (!o) return null;
  if (t <= 1) return { indentation: "", action: null };
  for (let l = t - 1; l > 0 && e.getLineContent(l) === ""; l--) if (l === 1) return { indentation: "", action: null };
  const r = function(l, d, h) {
    const c = l.tokenization.getLanguageIdAtPosition(d, 0);
    if (d > 1) {
      let u, g = -1;
      for (u = d - 1; u >= 1; u--) {
        if (l.tokenization.getLanguageIdAtPosition(u, 0) !== c) return g;
        const p = l.getLineContent(u);
        if (!h.shouldIgnore(p) && !/^\s+$/.test(p) && p !== "") return u;
        g = u;
      }
    }
    return -1;
  }(e, t, o);
  if (r < 0) return null;
  if (r < 1) return { indentation: "", action: null };
  const a = e.getLineContent(r);
  if (o.shouldIncrease(a) || o.shouldIndentNextLine(a)) return { indentation: Wt(a), action: Oi.Indent, line: r };
  if (o.shouldDecrease(a)) return { indentation: Wt(a), action: null, line: r };
  {
    if (r === 1) return { indentation: Wt(e.getLineContent(r)), action: null, line: r };
    const l = r - 1, d = o.getIndentMetadata(e.getLineContent(l));
    if (!(3 & d) && 4 & d) {
      let h = 0;
      for (let c = l - 1; c > 0; c--) if (!o.shouldIndentNextLine(e.getLineContent(c))) {
        h = c;
        break;
      }
      return { indentation: Wt(e.getLineContent(h + 1)), action: null, line: h + 1 };
    }
    if (n) return { indentation: Wt(e.getLineContent(r)), action: null, line: r };
    for (let h = r; h > 0; h--) {
      const c = e.getLineContent(h);
      if (o.shouldIncrease(c)) return { indentation: Wt(c), action: Oi.Indent, line: h };
      if (o.shouldIndentNextLine(c)) {
        let u = 0;
        for (let g = h - 1; g > 0; g--) if (!o.shouldIndentNextLine(e.getLineContent(h))) {
          u = g;
          break;
        }
        return { indentation: Wt(e.getLineContent(u + 1)), action: null, line: u + 1 };
      }
      if (o.shouldDecrease(c)) return { indentation: Wt(c), action: null, line: h };
    }
    return { indentation: Wt(e.getLineContent(1)), action: null, line: 1 };
  }
}
function n0(i, e, t, n, s, o) {
  if (i < 4) return null;
  const r = o.getLanguageConfiguration(t);
  if (!r) return null;
  const a = o.getLanguageConfiguration(t).indentRulesSupport;
  if (!a) return null;
  const l = zC(i, e, n, void 0, o), d = e.getLineContent(n);
  if (l) {
    const h = l.line;
    if (h !== void 0) {
      let c = !0;
      for (let u = h; u < n - 1; u++) if (!/^\s*$/.test(e.getLineContent(u))) {
        c = !1;
        break;
      }
      if (c) {
        const u = r.onEnter(i, "", e.getLineContent(h), "");
        if (u) {
          let g = Wt(e.getLineContent(h));
          return u.removeText && (g = g.substring(0, g.length - u.removeText)), u.indentAction === Oi.Indent || u.indentAction === Oi.IndentOutdent ? g = s.shiftIndent(g) : u.indentAction === Oi.Outdent && (g = s.unshiftIndent(g)), a.shouldDecrease(d) && (g = s.unshiftIndent(g)), u.appendText && (g += u.appendText), Wt(g);
        }
      }
    }
    return a.shouldDecrease(d) ? l.action === Oi.Indent ? l.indentation : s.unshiftIndent(l.indentation) : l.action === Oi.Indent ? s.shiftIndent(l.indentation) : l.indentation;
  }
  return null;
}
function BB(i, e, t) {
  const n = t.getLanguageConfiguration(i.getLanguageId()).indentRulesSupport;
  return n ? e < 1 || e > i.getLineCount() ? null : n.getIndentMetadata(i.getLineContent(e)) : null;
}
class oi {
  static indent(e, t, n) {
    if (t === null || n === null) return [];
    const s = [];
    for (let o = 0, r = n.length; o < r; o++) s[o] = new Ko(n[o], { isUnshift: !1, tabSize: e.tabSize, indentSize: e.indentSize, insertSpaces: e.insertSpaces, useTabStops: e.useTabStops, autoIndent: e.autoIndent }, e.languageConfigurationService);
    return s;
  }
  static outdent(e, t, n) {
    const s = [];
    for (let o = 0, r = n.length; o < r; o++) s[o] = new Ko(n[o], { isUnshift: !0, tabSize: e.tabSize, indentSize: e.indentSize, insertSpaces: e.insertSpaces, useTabStops: e.useTabStops, autoIndent: e.autoIndent }, e.languageConfigurationService);
    return s;
  }
  static shiftIndent(e, t, n) {
    return n = n || 1, Ko.shiftIndent(t, t.length + n, e.tabSize, e.indentSize, e.insertSpaces);
  }
  static unshiftIndent(e, t, n) {
    return n = n || 1, Ko.unshiftIndent(t, t.length + n, e.tabSize, e.indentSize, e.insertSpaces);
  }
  static _distributedPaste(e, t, n, s) {
    const o = [];
    for (let r = 0, a = n.length; r < a; r++) o[r] = new Dn(n[r], s[r]);
    return new Ls(0, o, { shouldPushStackElementBefore: !0, shouldPushStackElementAfter: !0 });
  }
  static _simplePaste(e, t, n, s, o) {
    const r = [];
    for (let a = 0, l = n.length; a < l; a++) {
      const d = n[a], h = d.getPosition();
      if (o && !d.isEmpty() && (o = !1), o && s.indexOf(`
`) !== s.length - 1 && (o = !1), o) {
        const c = new D(h.lineNumber, 1, h.lineNumber, 1);
        r[a] = new jR(c, s, d, !0);
      } else r[a] = new Dn(d, s);
    }
    return new Ls(0, r, { shouldPushStackElementBefore: !0, shouldPushStackElementAfter: !0 });
  }
  static _distributePasteToCursors(e, t, n, s, o) {
    if (s || t.length === 1) return null;
    if (o && o.length === t.length) return o;
    if (e.multiCursorPaste === "spread") {
      n.charCodeAt(n.length - 1) === 10 && (n = n.substr(0, n.length - 1)), n.charCodeAt(n.length - 1) === 13 && (n = n.substr(0, n.length - 1));
      const r = Sl(n);
      if (r.length === t.length) return r;
    }
    return null;
  }
  static paste(e, t, n, s, o, r) {
    const a = this._distributePasteToCursors(e, n, s, o, r);
    return a ? (n = n.sort(D.compareRangesUsingStarts), this._distributedPaste(e, t, n, a)) : this._simplePaste(e, t, n, s, o);
  }
  static _goodIndentForLine(e, t, n) {
    let s = null, o = "";
    const r = zC(e.autoIndent, t, n, !1, e.languageConfigurationService);
    if (r) s = r.action, o = r.indentation;
    else if (n > 1) {
      let a;
      for (a = n - 1; a >= 1 && !(ra(t.getLineContent(a)) >= 0); a--)
        ;
      if (a < 1) return null;
      const l = t.getLineMaxColumn(a), d = rm(e.autoIndent, t, new D(a, l, a, l), e.languageConfigurationService);
      d && (o = d.indentation + d.appendText);
    }
    return s && (s === Oi.Indent && (o = oi.shiftIndent(e, o)), s === Oi.Outdent && (o = oi.unshiftIndent(e, o)), o = e.normalizeIndentation(o)), o || null;
  }
  static _replaceJumpToNextIndent(e, t, n, s) {
    let o = "";
    const r = n.getStartPosition();
    if (e.insertSpaces) {
      const a = e.visibleColumnFromColumn(t, r), l = e.indentSize, d = l - a % l;
      for (let h = 0; h < d; h++) o += " ";
    } else o = "	";
    return new Dn(n, o, s);
  }
  static tab(e, t, n) {
    const s = [];
    for (let o = 0, r = n.length; o < r; o++) {
      const a = n[o];
      if (a.isEmpty()) {
        const l = t.getLineContent(a.startLineNumber);
        if (/^\s*$/.test(l) && t.tokenization.isCheapToTokenize(a.startLineNumber)) {
          let d = this._goodIndentForLine(e, t, a.startLineNumber);
          d = d || "	";
          const h = e.normalizeIndentation(d);
          if (!l.startsWith(h)) {
            s[o] = new Dn(new D(a.startLineNumber, 1, a.startLineNumber, l.length + 1), h, !0);
            continue;
          }
        }
        s[o] = this._replaceJumpToNextIndent(e, t, a, !0);
      } else {
        if (a.startLineNumber === a.endLineNumber) {
          const l = t.getLineMaxColumn(a.startLineNumber);
          if (a.startColumn !== 1 || a.endColumn !== l) {
            s[o] = this._replaceJumpToNextIndent(e, t, a, !1);
            continue;
          }
        }
        s[o] = new Ko(a, { isUnshift: !1, tabSize: e.tabSize, indentSize: e.indentSize, insertSpaces: e.insertSpaces, useTabStops: e.useTabStops, autoIndent: e.autoIndent }, e.languageConfigurationService);
      }
    }
    return s;
  }
  static compositionType(e, t, n, s, o, r, a, l) {
    const d = s.map((h) => this._compositionType(n, h, o, r, a, l));
    return new Ls(4, d, { shouldPushStackElementBefore: vb(e, 4), shouldPushStackElementAfter: !1 });
  }
  static _compositionType(e, t, n, s, o, r) {
    if (!t.isEmpty()) return null;
    const a = t.getPosition(), l = Math.max(1, a.column - s), d = Math.min(e.getLineMaxColumn(a.lineNumber), a.column + o), h = new D(a.lineNumber, l, a.lineNumber, d);
    return e.getValueInRange(h) === n && r === 0 ? null : new VC(h, n, 0, r);
  }
  static _typeCommand(e, t, n) {
    return n ? new fb(e, t, !0) : new Dn(e, t, !0);
  }
  static _enter(e, t, n, s) {
    if (e.autoIndent === 0) return oi._typeCommand(s, `
`, n);
    if (!t.tokenization.isCheapToTokenize(s.getStartPosition().lineNumber) || e.autoIndent === 1) {
      const a = Wt(t.getLineContent(s.startLineNumber)).substring(0, s.startColumn - 1);
      return oi._typeCommand(s, `
` + e.normalizeIndentation(a), n);
    }
    const o = rm(e.autoIndent, t, s, e.languageConfigurationService);
    if (o) {
      if (o.indentAction === Oi.None || o.indentAction === Oi.Indent) return oi._typeCommand(s, `
` + e.normalizeIndentation(o.indentation + o.appendText), n);
      if (o.indentAction === Oi.IndentOutdent) {
        const a = e.normalizeIndentation(o.indentation), l = e.normalizeIndentation(o.indentation + o.appendText), d = `
` + l + `
` + a;
        return n ? new fb(s, d, !0) : new VC(s, d, -1, l.length - a.length, !0);
      }
      if (o.indentAction === Oi.Outdent) {
        const a = oi.unshiftIndent(e, o.indentation);
        return oi._typeCommand(s, `
` + e.normalizeIndentation(a + o.appendText), n);
      }
    }
    const r = Wt(t.getLineContent(s.startLineNumber)).substring(0, s.startColumn - 1);
    if (e.autoIndent >= 4) {
      const a = function(l, d, h, c, u) {
        if (l < 4) return null;
        d.tokenization.forceTokenization(h.startLineNumber);
        const g = d.tokenization.getLineTokens(h.startLineNumber), p = Yw(g, h.startColumn - 1), f = p.getLineContent();
        let _, v, b = !1;
        p.firstCharOffset > 0 && g.getLanguageId(0) !== p.languageId ? (b = !0, _ = f.substr(0, h.startColumn - 1 - p.firstCharOffset)) : _ = g.getLineContent().substring(0, h.startColumn - 1), v = h.isEmpty() ? f.substr(h.startColumn - 1 - p.firstCharOffset) : em(d, h.endLineNumber, h.endColumn).getLineContent().substr(h.endColumn - 1 - p.firstCharOffset);
        const C = u.getLanguageConfiguration(p.languageId).indentRulesSupport;
        if (!C) return null;
        const w = _, y = Wt(_), L = { tokenization: { getLineTokens: (B) => d.tokenization.getLineTokens(B), getLanguageId: () => d.getLanguageId(), getLanguageIdAtPosition: (B, T) => d.getLanguageIdAtPosition(B, T) }, getLineContent: (B) => B === h.startLineNumber ? w : d.getLineContent(B) }, k = Wt(g.getLineContent()), N = zC(l, L, h.startLineNumber + 1, void 0, u);
        if (!N) {
          const B = b ? k : y;
          return { beforeEnter: B, afterEnter: B };
        }
        let A = b ? k : N.indentation;
        return N.action === Oi.Indent && (A = c.shiftIndent(A)), C.shouldDecrease(v) && (A = c.unshiftIndent(A)), { beforeEnter: b ? k : y, afterEnter: A };
      }(e.autoIndent, t, s, { unshiftIndent: (l) => oi.unshiftIndent(e, l), shiftIndent: (l) => oi.shiftIndent(e, l), normalizeIndentation: (l) => e.normalizeIndentation(l) }, e.languageConfigurationService);
      if (a) {
        let l = e.visibleColumnFromColumn(t, s.getEndPosition());
        const d = s.endColumn, h = Jn(t.getLineContent(s.endLineNumber));
        if (s = h >= 0 ? s.setEndPosition(s.endLineNumber, Math.max(s.endColumn, h + 1)) : s.setEndPosition(s.endLineNumber, t.getLineMaxColumn(s.endLineNumber)), n) return new fb(s, `
` + e.normalizeIndentation(a.afterEnter), !0);
        {
          let c = 0;
          return d <= h + 1 && (e.insertSpaces || (l = Math.ceil(l / e.indentSize)), c = Math.min(l + 1 - e.normalizeIndentation(a.afterEnter).length - 1, 0)), new VC(s, `
` + e.normalizeIndentation(a.afterEnter), 0, c, !0);
        }
      }
    }
    return oi._typeCommand(s, `
` + e.normalizeIndentation(r), n);
  }
  static _isAutoIndentType(e, t, n) {
    if (e.autoIndent < 4) return !1;
    for (let s = 0, o = n.length; s < o; s++) if (!t.tokenization.isCheapToTokenize(n[s].getEndPosition().lineNumber)) return !1;
    return !0;
  }
  static _runAutoIndentType(e, t, n, s) {
    const o = j8(t, n.startLineNumber, n.startColumn), r = function(a, l, d, h, c, u) {
      if (a < 4) return null;
      const g = em(l, d.startLineNumber, d.startColumn);
      if (g.firstCharOffset) return null;
      const p = u.getLanguageConfiguration(g.languageId).indentRulesSupport;
      if (!p) return null;
      const f = g.getLineContent(), _ = f.substr(0, d.startColumn - 1 - g.firstCharOffset);
      let v;
      if (v = d.isEmpty() ? f.substr(d.startColumn - 1 - g.firstCharOffset) : em(l, d.endLineNumber, d.endColumn).getLineContent().substr(d.endColumn - 1 - g.firstCharOffset), !p.shouldDecrease(_ + v) && p.shouldDecrease(_ + h + v)) {
        const b = zC(a, l, d.startLineNumber, !1, u);
        if (!b) return null;
        let C = b.indentation;
        return b.action !== Oi.Indent && (C = c.unshiftIndent(C)), C;
      }
      return null;
    }(e.autoIndent, t, n, s, { shiftIndent: (a) => oi.shiftIndent(e, a), unshiftIndent: (a) => oi.unshiftIndent(e, a) }, e.languageConfigurationService);
    if (r === null) return null;
    if (r !== e.normalizeIndentation(o)) {
      const a = t.getLineFirstNonWhitespaceColumn(n.startLineNumber);
      return a === 0 ? oi._typeCommand(new D(n.startLineNumber, 1, n.endLineNumber, n.endColumn), e.normalizeIndentation(r) + s, !1) : oi._typeCommand(new D(n.startLineNumber, 1, n.endLineNumber, n.endColumn), e.normalizeIndentation(r) + t.getLineContent(n.startLineNumber).substring(a - 1, n.startColumn - 1) + s, !1);
    }
    return null;
  }
  static _isAutoClosingOvertype(e, t, n, s, o) {
    if (e.autoClosingOvertype === "never" || !e.autoClosingPairs.autoClosingPairsCloseSingleChar.has(o)) return !1;
    for (let r = 0, a = n.length; r < a; r++) {
      const l = n[r];
      if (!l.isEmpty()) return !1;
      const d = l.getPosition(), h = t.getLineContent(d.lineNumber);
      if (h.charAt(d.column - 1) !== o) return !1;
      const c = rh(o);
      if ((d.column > 2 ? h.charCodeAt(d.column - 2) : 0) === 92 && c) return !1;
      if (e.autoClosingOvertype === "auto") {
        let u = !1;
        for (let g = 0, p = s.length; g < p; g++) {
          const f = s[g];
          if (d.lineNumber === f.startLineNumber && d.column === f.startColumn) {
            u = !0;
            break;
          }
        }
        if (!u) return !1;
      }
    }
    return !0;
  }
  static _runAutoClosingOvertype(e, t, n, s, o) {
    const r = [];
    for (let a = 0, l = s.length; a < l; a++) {
      const d = s[a].getPosition(), h = new D(d.lineNumber, d.column, d.lineNumber, d.column + 1);
      r[a] = new Dn(h, o);
    }
    return new Ls(4, r, { shouldPushStackElementBefore: vb(e, 4), shouldPushStackElementAfter: !1 });
  }
  static _isBeforeClosingBrace(e, t) {
    const n = t.charAt(0), s = e.autoClosingPairs.autoClosingPairsOpenByStart.get(n) || [], o = e.autoClosingPairs.autoClosingPairsCloseByStart.get(n) || [], r = s.some((l) => t.startsWith(l.open)), a = o.some((l) => t.startsWith(l.close));
    return !r && a;
  }
  static _findAutoClosingPairOpen(e, t, n, s) {
    const o = e.autoClosingPairs.autoClosingPairsOpenByEnd.get(s);
    if (!o) return null;
    let r = null;
    for (const a of o) if (r === null || a.open.length > r.open.length) {
      let l = !0;
      for (const d of n)
        if (t.getValueInRange(new D(d.lineNumber, d.column - a.open.length + 1, d.lineNumber, d.column)) + s !== a.open) {
          l = !1;
          break;
        }
      l && (r = a);
    }
    return r;
  }
  static _findContainedAutoClosingPair(e, t) {
    if (t.open.length <= 1) return null;
    const n = t.close.charAt(t.close.length - 1), s = e.autoClosingPairs.autoClosingPairsCloseByEnd.get(n) || [];
    let o = null;
    for (const r of s) r.open !== t.open && t.open.includes(r.open) && t.close.endsWith(r.close) && (!o || r.open.length > o.open.length) && (o = r);
    return o;
  }
  static _getAutoClosingPairClose(e, t, n, s, o) {
    for (const g of n) if (!g.isEmpty()) return null;
    const r = n.map((g) => {
      const p = g.getPosition();
      return o ? { lineNumber: p.lineNumber, beforeColumn: p.column - s.length, afterColumn: p.column } : { lineNumber: p.lineNumber, beforeColumn: p.column, afterColumn: p.column };
    }), a = this._findAutoClosingPairOpen(e, t, r.map((g) => new W(g.lineNumber, g.beforeColumn)), s);
    if (!a) return null;
    let l, d;
    if (rh(s) ? (l = e.autoClosingQuotes, d = e.shouldAutoCloseBefore.quote) : e.blockCommentStartToken && a.open.includes(e.blockCommentStartToken) ? (l = e.autoClosingComments, d = e.shouldAutoCloseBefore.comment) : (l = e.autoClosingBrackets, d = e.shouldAutoCloseBefore.bracket), l === "never") return null;
    const h = this._findContainedAutoClosingPair(e, a), c = h ? h.close : "";
    let u = !0;
    for (const g of r) {
      const { lineNumber: p, beforeColumn: f, afterColumn: _ } = g, v = t.getLineContent(p), b = v.substring(0, f - 1), C = v.substring(_ - 1);
      if (C.startsWith(c) || (u = !1), C.length > 0) {
        const L = C.charAt(0);
        if (!oi._isBeforeClosingBrace(e, C) && !d(L)) return null;
      }
      if (a.open.length === 1 && (s === "'" || s === '"') && l !== "always") {
        const L = zo(e.wordSeparators, []);
        if (b.length > 0) {
          const k = b.charCodeAt(b.length - 1);
          if (L.get(k) === 0) return null;
        }
      }
      if (!t.tokenization.isCheapToTokenize(p)) return null;
      t.tokenization.forceTokenization(p);
      const w = Yw(t.tokenization.getLineTokens(p), f - 1);
      if (!a.shouldAutoClose(w, f - w.firstCharOffset)) return null;
      const y = a.findNeutralCharacter();
      if (y) {
        const L = t.tokenization.getTokenTypeIfInsertingCharacter(p, f, y);
        if (!a.isOK(L)) return null;
      }
    }
    return u ? a.close.substring(0, a.close.length - c.length) : a.close;
  }
  static _runAutoClosingOpenCharType(e, t, n, s, o, r, a) {
    const l = [];
    for (let d = 0, h = s.length; d < h; d++) {
      const c = s[d];
      l[d] = new WB(c, o, !r, a);
    }
    return new Ls(4, l, { shouldPushStackElementBefore: !0, shouldPushStackElementAfter: !1 });
  }
  static _shouldSurroundChar(e, t) {
    return rh(t) ? e.autoSurround === "quotes" || e.autoSurround === "languageDefined" : e.autoSurround === "brackets" || e.autoSurround === "languageDefined";
  }
  static _isSurroundSelectionType(e, t, n, s) {
    if (!oi._shouldSurroundChar(e, s) || !e.surroundingPairs.hasOwnProperty(s)) return !1;
    const o = rh(s);
    for (const r of n) {
      if (r.isEmpty()) return !1;
      let a = !0;
      for (let l = r.startLineNumber; l <= r.endLineNumber; l++) {
        const d = t.getLineContent(l), h = l === r.startLineNumber ? r.startColumn - 1 : 0, c = l === r.endLineNumber ? r.endColumn - 1 : d.length, u = d.substring(h, c);
        if (/[^ \t]/.test(u)) {
          a = !1;
          break;
        }
      }
      if (a || o && r.startLineNumber === r.endLineNumber && r.startColumn + 1 === r.endColumn && rh(t.getValueInRange(r)))
        return !1;
    }
    return !0;
  }
  static _runSurroundSelectionType(e, t, n, s, o) {
    const r = [];
    for (let a = 0, l = s.length; a < l; a++) {
      const d = s[a], h = t.surroundingPairs[o];
      r[a] = new oY(d, o, h);
    }
    return new Ls(0, r, { shouldPushStackElementBefore: !0, shouldPushStackElementAfter: !0 });
  }
  static _isTypeInterceptorElectricChar(e, t, n) {
    return !(n.length !== 1 || !t.tokenization.isCheapToTokenize(n[0].getEndPosition().lineNumber));
  }
  static _typeInterceptorElectricChar(e, t, n, s, o) {
    if (!t.electricChars.hasOwnProperty(o) || !s.isEmpty()) return null;
    const r = s.getPosition();
    n.tokenization.forceTokenization(r.lineNumber);
    const a = n.tokenization.getLineTokens(r.lineNumber);
    let l;
    try {
      l = t.onElectricCharacter(o, a, r.column);
    } catch (d) {
      return We(d), null;
    }
    if (!l) return null;
    if (l.matchOpenBracket) {
      const d = (a.getLineContent() + o).lastIndexOf(l.matchOpenBracket) + 1, h = n.bracketPairs.findMatchingBracketUp(l.matchOpenBracket, { lineNumber: r.lineNumber, column: d }, 500);
      if (h) {
        if (h.startLineNumber === r.lineNumber) return null;
        const c = Wt(n.getLineContent(h.startLineNumber)), u = t.normalizeIndentation(c), g = n.getLineContent(r.lineNumber), p = n.getLineFirstNonWhitespaceColumn(r.lineNumber) || r.column, f = u + g.substring(p - 1, r.column - 1) + o, _ = new D(r.lineNumber, 1, r.lineNumber, r.column), v = new Dn(_, f);
        return new Ls(vD(f, e), [v], { shouldPushStackElementBefore: !1, shouldPushStackElementAfter: !0 });
      }
    }
    return null;
  }
  static compositionEndWithInterceptors(e, t, n, s, o, r) {
    if (!s) return null;
    let a = null;
    for (const c of s) if (a === null) a = c.insertedText;
    else if (a !== c.insertedText) return null;
    if (!a || a.length !== 1) return null;
    const l = a;
    let d = !1;
    for (const c of s) if (c.deletedText.length !== 0) {
      d = !0;
      break;
    }
    if (d) {
      if (!oi._shouldSurroundChar(t, l) || !t.surroundingPairs.hasOwnProperty(l)) return null;
      const c = rh(l);
      for (const p of s)
        if (p.deletedSelectionStart !== 0 || p.deletedSelectionEnd !== p.deletedText.length || /^[ \t]+$/.test(p.deletedText) || c && rh(p.deletedText)) return null;
      const u = [];
      for (const p of o) {
        if (!p.isEmpty()) return null;
        u.push(p.getPosition());
      }
      if (u.length !== s.length) return null;
      const g = [];
      for (let p = 0, f = u.length; p < f; p++) g.push(new rY(u[p], s[p].deletedText, t.surroundingPairs[l]));
      return new Ls(4, g, { shouldPushStackElementBefore: !0, shouldPushStackElementAfter: !1 });
    }
    if (this._isAutoClosingOvertype(t, n, o, r, l)) {
      const c = o.map((u) => new Dn(new D(u.positionLineNumber, u.positionColumn, u.positionLineNumber, u.positionColumn + 1), "", !1));
      return new Ls(4, c, { shouldPushStackElementBefore: !0, shouldPushStackElementAfter: !1 });
    }
    const h = this._getAutoClosingPairClose(t, n, o, l, !0);
    return h !== null ? this._runAutoClosingOpenCharType(e, t, n, o, l, !0, h) : null;
  }
  static typeWithInterceptors(e, t, n, s, o, r, a) {
    if (!e && a === `
`) {
      const h = [];
      for (let c = 0, u = o.length; c < u; c++) h[c] = oi._enter(n, s, !1, o[c]);
      return new Ls(4, h, { shouldPushStackElementBefore: !0, shouldPushStackElementAfter: !1 });
    }
    if (!e && this._isAutoIndentType(n, s, o)) {
      const h = [];
      let c = !1;
      for (let u = 0, g = o.length; u < g; u++) if (h[u] = this._runAutoIndentType(n, s, o[u], a), !h[u]) {
        c = !0;
        break;
      }
      if (!c) return new Ls(4, h, { shouldPushStackElementBefore: !0, shouldPushStackElementAfter: !1 });
    }
    if (this._isAutoClosingOvertype(n, s, o, r, a)) return this._runAutoClosingOvertype(t, n, s, o, a);
    if (!e) {
      const h = this._getAutoClosingPairClose(n, s, o, a, !1);
      if (h) return this._runAutoClosingOpenCharType(t, n, s, o, a, !1, h);
    }
    if (!e && this._isSurroundSelectionType(n, s, o, a)) return this._runSurroundSelectionType(t, n, s, o, a);
    if (!e && this._isTypeInterceptorElectricChar(n, s, o)) {
      const h = this._typeInterceptorElectricChar(t, n, s, o[0], a);
      if (h) return h;
    }
    const l = [];
    for (let h = 0, c = o.length; h < c; h++) l[h] = new Dn(o[h], a);
    const d = vD(a, t);
    return new Ls(d, l, { shouldPushStackElementBefore: vb(t, d), shouldPushStackElementAfter: !1 });
  }
  static typeWithoutInterceptors(e, t, n, s, o) {
    const r = [];
    for (let l = 0, d = s.length; l < d; l++) r[l] = new Dn(s[l], o);
    const a = vD(o, e);
    return new Ls(a, r, { shouldPushStackElementBefore: vb(e, a), shouldPushStackElementAfter: !1 });
  }
  static lineInsertBefore(e, t, n) {
    if (t === null || n === null) return [];
    const s = [];
    for (let o = 0, r = n.length; o < r; o++) {
      let a = n[o].positionLineNumber;
      if (a === 1) s[o] = new fb(new D(1, 1, 1, 1), `
`);
      else {
        a--;
        const l = t.getLineMaxColumn(a);
        s[o] = this._enter(e, t, !1, new D(a, l, a, l));
      }
    }
    return s;
  }
  static lineInsertAfter(e, t, n) {
    if (t === null || n === null) return [];
    const s = [];
    for (let o = 0, r = n.length; o < r; o++) {
      const a = n[o].positionLineNumber, l = t.getLineMaxColumn(a);
      s[o] = this._enter(e, t, !1, new D(a, l, a, l));
    }
    return s;
  }
  static lineBreakInsert(e, t, n) {
    const s = [];
    for (let o = 0, r = n.length; o < r; o++) s[o] = this._enter(e, t, !0, n[o]);
    return s;
  }
}
class WB extends VC {
  constructor(e, t, n, s) {
    super(e, (n ? t : "") + s, 0, -s.length), this._openCharacter = t, this._closeCharacter = s, this.closeCharacterRange = null, this.enclosingRange = null;
  }
  computeCursorState(e, t) {
    const n = t.getInverseEditOperations()[0].range;
    return this.closeCharacterRange = new D(n.startLineNumber, n.endColumn - this._closeCharacter.length, n.endLineNumber, n.endColumn), this.enclosingRange = new D(n.startLineNumber, n.endColumn - this._openCharacter.length - this._closeCharacter.length, n.endLineNumber, n.endColumn), super.computeCursorState(e, t);
  }
}
class aY {
  constructor(e, t, n, s, o, r) {
    this.deletedText = e, this.deletedSelectionStart = t, this.deletedSelectionEnd = n, this.insertedText = s, this.insertedSelectionStart = o, this.insertedSelectionEnd = r;
  }
}
function vD(i, e) {
  return i === " " ? e === 5 || e === 6 ? 6 : 5 : 4;
}
function vb(i, e) {
  return !(!X4(i) || X4(e)) || i !== 5 && Y4(i) !== Y4(e);
}
function Y4(i) {
  return i === 6 || i === 5 ? "space" : i;
}
function X4(i) {
  return i === 4 || i === 5 || i === 6;
}
var E;
(function(i) {
  i.editorSimpleInput = new ae("editorSimpleInput", !1, !0), i.editorTextFocus = new ae("editorTextFocus", !1, m(0, "Whether the editor text has focus (cursor is blinking)")), i.focus = new ae("editorFocus", !1, m(0, "Whether the editor or an editor widget has focus (e.g. focus is in the find widget)")), i.textInputFocus = new ae("textInputFocus", !1, m(0, "Whether an editor or a rich text input has focus (cursor is blinking)")), i.readOnly = new ae("editorReadonly", !1, m(0, "Whether the editor is read-only")), i.inDiffEditor = new ae("inDiffEditor", !1, m(0, "Whether the context is a diff editor")), i.isEmbeddedDiffEditor = new ae("isEmbeddedDiffEditor", !1, m(0, "Whether the context is an embedded diff editor")), i.inMultiDiffEditor = new ae("inMultiDiffEditor", !1, m(0, "Whether the context is a multi diff editor")), i.multiDiffEditorAllCollapsed = new ae("multiDiffEditorAllCollapsed", void 0, m(0, "Whether all files in multi diff editor are collapsed")), i.hasChanges = new ae("diffEditorHasChanges", !1, m(0, "Whether the diff editor has changes")), i.comparingMovedCode = new ae("comparingMovedCode", !1, m(0, "Whether a moved code block is selected for comparison")), i.accessibleDiffViewerVisible = new ae("accessibleDiffViewerVisible", !1, m(0, "Whether the accessible diff viewer is visible")), i.diffEditorRenderSideBySideInlineBreakpointReached = new ae("diffEditorRenderSideBySideInlineBreakpointReached", !1, m(0, "Whether the diff editor render side by side inline breakpoint is reached")), i.diffEditorInlineMode = new ae("diffEditorInlineMode", !1, m(0, "Whether inline mode is active")), i.diffEditorOriginalWritable = new ae("diffEditorOriginalWritable", !1, m(0, "Whether modified is writable in the diff editor")), i.diffEditorModifiedWritable = new ae("diffEditorModifiedWritable", !1, m(0, "Whether modified is writable in the diff editor")), i.diffEditorOriginalUri = new ae("diffEditorOriginalUri", "", m(0, "The uri of the original document")), i.diffEditorModifiedUri = new ae("diffEditorModifiedUri", "", m(0, "The uri of the modified document")), i.columnSelection = new ae("editorColumnSelection", !1, m(0, "Whether `editor.columnSelection` is enabled")), i.writable = i.readOnly.toNegated(), i.hasNonEmptySelection = new ae("editorHasSelection", !1, m(0, "Whether the editor has text selected")), i.hasOnlyEmptySelection = i.hasNonEmptySelection.toNegated(), i.hasMultipleSelections = new ae("editorHasMultipleSelections", !1, m(0, "Whether the editor has multiple selections")), i.hasSingleSelection = i.hasMultipleSelections.toNegated(), i.tabMovesFocus = new ae("editorTabMovesFocus", !1, m(0, "Whether `Tab` will move focus out of the editor")), i.tabDoesNotMoveFocus = i.tabMovesFocus.toNegated(), i.isInEmbeddedEditor = new ae("isInEmbeddedEditor", !1, !0), i.canUndo = new ae("canUndo", !1, !0), i.canRedo = new ae("canRedo", !1, !0), i.hoverVisible = new ae("editorHoverVisible", !1, m(0, "Whether the editor hover is visible")), i.hoverFocused = new ae("editorHoverFocused", !1, m(0, "Whether the editor hover is focused")), i.stickyScrollFocused = new ae("stickyScrollFocused", !1, m(0, "Whether the sticky scroll is focused")), i.stickyScrollVisible = new ae("stickyScrollVisible", !1, m(0, "Whether the sticky scroll is visible")), i.standaloneColorPickerVisible = new ae("standaloneColorPickerVisible", !1, m(0, "Whether the standalone color picker is visible")), i.standaloneColorPickerFocused = new ae("standaloneColorPickerFocused", !1, m(0, "Whether the standalone color picker is focused")), i.inCompositeEditor = new ae("inCompositeEditor", void 0, m(0, "Whether the editor is part of a larger editor (e.g. notebooks)")), i.notInCompositeEditor = i.inCompositeEditor.toNegated(), i.languageId = new ae("editorLangId", "", m(0, "The language identifier of the editor")), i.hasCompletionItemProvider = new ae("editorHasCompletionItemProvider", !1, m(0, "Whether the editor has a completion item provider")), i.hasCodeActionsProvider = new ae("editorHasCodeActionsProvider", !1, m(0, "Whether the editor has a code actions provider")), i.hasCodeLensProvider = new ae("editorHasCodeLensProvider", !1, m(0, "Whether the editor has a code lens provider")), i.hasDefinitionProvider = new ae("editorHasDefinitionProvider", !1, m(0, "Whether the editor has a definition provider")), i.hasDeclarationProvider = new ae("editorHasDeclarationProvider", !1, m(0, "Whether the editor has a declaration provider")), i.hasImplementationProvider = new ae("editorHasImplementationProvider", !1, m(0, "Whether the editor has an implementation provider")), i.hasTypeDefinitionProvider = new ae("editorHasTypeDefinitionProvider", !1, m(0, "Whether the editor has a type definition provider")), i.hasHoverProvider = new ae("editorHasHoverProvider", !1, m(0, "Whether the editor has a hover provider")), i.hasDocumentHighlightProvider = new ae("editorHasDocumentHighlightProvider", !1, m(0, "Whether the editor has a document highlight provider")), i.hasDocumentSymbolProvider = new ae("editorHasDocumentSymbolProvider", !1, m(0, "Whether the editor has a document symbol provider")), i.hasReferenceProvider = new ae("editorHasReferenceProvider", !1, m(0, "Whether the editor has a reference provider")), i.hasRenameProvider = new ae("editorHasRenameProvider", !1, m(0, "Whether the editor has a rename provider")), i.hasSignatureHelpProvider = new ae("editorHasSignatureHelpProvider", !1, m(0, "Whether the editor has a signature help provider")), i.hasInlayHintsProvider = new ae("editorHasInlayHintsProvider", !1, m(0, "Whether the editor has an inline hints provider")), i.hasDocumentFormattingProvider = new ae("editorHasDocumentFormattingProvider", !1, m(0, "Whether the editor has a document formatting provider")), i.hasDocumentSelectionFormattingProvider = new ae("editorHasDocumentSelectionFormattingProvider", !1, m(0, "Whether the editor has a document selection formatting provider")), i.hasMultipleDocumentFormattingProvider = new ae("editorHasMultipleDocumentFormattingProvider", !1, m(0, "Whether the editor has multiple document formatting providers")), i.hasMultipleDocumentSelectionFormattingProvider = new ae("editorHasMultipleDocumentSelectionFormattingProvider", !1, m(0, "Whether the editor has multiple document selection formatting providers"));
})(E || (E = {}));
class fi extends Zi {
  runEditorCommand(e, t, n) {
    const s = t._getViewModel();
    s && this.runCoreEditorCommand(s, n || {});
  }
}
var kn, Fp, dn;
(function(i) {
  i.metadata = { description: "Scroll editor in the given direction", args: [{ name: "Editor scroll argument object", description: "Property-value pairs that can be passed through this argument:\n					* 'to': A mandatory direction value.\n						```\n						'up', 'down'\n						```\n					* 'by': Unit to move. Default is computed based on 'to' value.\n						```\n						'line', 'wrappedLine', 'page', 'halfPage', 'editor'\n						```\n					* 'value': Number of units to move. Default is '1'.\n					* 'revealCursor': If 'true' reveals the cursor if it is outside view port.\n				", constraint: function(e) {
    if (!ms(e)) return !1;
    const t = e;
    return !!ps(t.to) && !(!$s(t.by) && !ps(t.by)) && !(!$s(t.value) && !gc(t.value)) && !(!$s(t.revealCursor) && !_7(t.revealCursor));
  }, schema: { type: "object", required: ["to"], properties: { to: { type: "string", enum: ["up", "down"] }, by: { type: "string", enum: ["line", "wrappedLine", "page", "halfPage", "editor"] }, value: { type: "number", default: 1 }, revealCursor: { type: "boolean" } } } }] }, i.RawDirection = { Up: "up", Right: "right", Down: "down", Left: "left" }, i.RawUnit = { Line: "line", WrappedLine: "wrappedLine", Page: "page", HalfPage: "halfPage", Editor: "editor", Column: "column" }, i.parse = function(e) {
    let t, n;
    switch (e.to) {
      case i.RawDirection.Up:
        t = 1;
        break;
      case i.RawDirection.Right:
        t = 2;
        break;
      case i.RawDirection.Down:
        t = 3;
        break;
      case i.RawDirection.Left:
        t = 4;
        break;
      default:
        return null;
    }
    switch (e.by) {
      case i.RawUnit.Line:
        n = 1;
        break;
      case i.RawUnit.WrappedLine:
        n = 2;
        break;
      case i.RawUnit.Page:
        n = 3;
        break;
      case i.RawUnit.HalfPage:
        n = 4;
        break;
      case i.RawUnit.Editor:
        n = 5;
        break;
      case i.RawUnit.Column:
        n = 6;
        break;
      default:
        n = 2;
    }
    return { direction: t, unit: n, value: Math.floor(e.value || 1), revealCursor: !!e.revealCursor, select: !!e.select };
  };
})(kn || (kn = {})), function(i) {
  i.metadata = { description: "Reveal the given line at the given logical position", args: [{ name: "Reveal line argument object", description: "Property-value pairs that can be passed through this argument:\n					* 'lineNumber': A mandatory line number value.\n					* 'at': Logical position at which line has to be revealed.\n						```\n						'top', 'center', 'bottom'\n						```\n				", constraint: function(e) {
    if (!ms(e)) return !1;
    const t = e;
    return !(!gc(t.lineNumber) && !ps(t.lineNumber)) && !(!$s(t.at) && !ps(t.at));
  }, schema: { type: "object", required: ["lineNumber"], properties: { lineNumber: { type: ["number", "string"] }, at: { type: "string", enum: ["top", "center", "bottom"] } } } }] }, i.RawAtArgument = { Top: "top", Center: "center", Bottom: "bottom" };
}(Fp || (Fp = {}));
class sI {
  constructor(e) {
    e.addImplementation(1e4, "code-editor", (t, n) => {
      const s = t.get(mt).getFocusedCodeEditor();
      return !(!s || !s.hasTextFocus()) && this._runEditorCommand(t, s, n);
    }), e.addImplementation(1e3, "generic-dom-input-textarea", (t, n) => {
      const s = Mn();
      return !!(s && ["input", "textarea"].indexOf(s.tagName.toLowerCase()) >= 0) && (this.runDOMCommand(s), !0);
    }), e.addImplementation(0, "generic-dom", (t, n) => {
      const s = t.get(mt).getActiveCodeEditor();
      return !!s && (s.focus(), this._runEditorCommand(t, s, n));
    });
  }
  _runEditorCommand(e, t, n) {
    return this.runEditorCommand(e, t, n) || !0;
  }
}
(function(i) {
  class e extends fi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, C) {
      C.position && (b.model.pushStackElement(), b.setCursorStates(C.source, 3, [mn.moveTo(b, b.getPrimaryCursorState(), this._inSelectionMode, C.position, C.viewPosition)]) && C.revealType !== 2 && b.revealAllCursors(C.source, !0, !0));
    }
  }
  i.MoveTo = re(new e({ id: "_moveTo", inSelectionMode: !1, precondition: void 0 })), i.MoveToSelect = re(new e({ id: "_moveToSelect", inSelectionMode: !0, precondition: void 0 }));
  class t extends fi {
    runCoreEditorCommand(b, C) {
      b.model.pushStackElement();
      const w = this._getColumnSelectResult(b, b.getPrimaryCursorState(), b.getCursorColumnSelectData(), C);
      w !== null && (b.setCursorStates(C.source, 3, w.viewStates.map((y) => pt.fromViewState(y))), b.setCursorColumnSelectData({ isReal: !0, fromViewLineNumber: w.fromLineNumber, fromViewVisualColumn: w.fromVisualColumn, toViewLineNumber: w.toLineNumber, toViewVisualColumn: w.toVisualColumn }), w.reversed ? b.revealTopMostCursor(C.source) : b.revealBottomMostCursor(C.source));
    }
  }
  i.ColumnSelect = re(new class extends t {
    constructor() {
      super({ id: "columnSelect", precondition: void 0 });
    }
    _getColumnSelectResult(v, b, C, w) {
      if (w.position === void 0 || w.viewPosition === void 0 || w.mouseColumn === void 0) return null;
      const y = v.model.validatePosition(w.position), L = v.coordinatesConverter.validateViewPosition(new W(w.viewPosition.lineNumber, w.viewPosition.column), y), k = w.doColumnSelect ? C.fromViewLineNumber : L.lineNumber, N = w.doColumnSelect ? C.fromViewVisualColumn : w.mouseColumn - 1;
      return Cu.columnSelect(v.cursorConfig, v, k, N, L.lineNumber, w.mouseColumn - 1);
    }
  }()), i.CursorColumnSelectLeft = re(new class extends t {
    constructor() {
      super({ id: "cursorColumnSelectLeft", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 3599, linux: { primary: 0 } } });
    }
    _getColumnSelectResult(v, b, C, w) {
      return Cu.columnSelectLeft(v.cursorConfig, v, C);
    }
  }()), i.CursorColumnSelectRight = re(new class extends t {
    constructor() {
      super({ id: "cursorColumnSelectRight", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 3601, linux: { primary: 0 } } });
    }
    _getColumnSelectResult(v, b, C, w) {
      return Cu.columnSelectRight(v.cursorConfig, v, C);
    }
  }());
  class n extends t {
    constructor(b) {
      super(b), this._isPaged = b.isPaged;
    }
    _getColumnSelectResult(b, C, w, y) {
      return Cu.columnSelectUp(b.cursorConfig, b, w, this._isPaged);
    }
  }
  i.CursorColumnSelectUp = re(new n({ isPaged: !1, id: "cursorColumnSelectUp", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 3600, linux: { primary: 0 } } })), i.CursorColumnSelectPageUp = re(new n({ isPaged: !0, id: "cursorColumnSelectPageUp", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 3595, linux: { primary: 0 } } }));
  class s extends t {
    constructor(b) {
      super(b), this._isPaged = b.isPaged;
    }
    _getColumnSelectResult(b, C, w, y) {
      return Cu.columnSelectDown(b.cursorConfig, b, w, this._isPaged);
    }
  }
  i.CursorColumnSelectDown = re(new s({ isPaged: !1, id: "cursorColumnSelectDown", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 3602, linux: { primary: 0 } } })), i.CursorColumnSelectPageDown = re(new s({ isPaged: !0, id: "cursorColumnSelectPageDown", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 3596, linux: { primary: 0 } } }));
  class o extends fi {
    constructor() {
      super({ id: "cursorMove", precondition: void 0, metadata: gy.metadata });
    }
    runCoreEditorCommand(b, C) {
      const w = gy.parse(C);
      w && this._runCursorMove(b, C.source, w);
    }
    _runCursorMove(b, C, w) {
      b.model.pushStackElement(), b.setCursorStates(C, 3, o._move(b, b.getCursorStates(), w)), b.revealAllCursors(C, !0);
    }
    static _move(b, C, w) {
      const y = w.select, L = w.value;
      switch (w.direction) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
          return mn.simpleMove(b, C, w.direction, y, L, w.unit);
        case 11:
        case 13:
        case 12:
        case 14:
          return mn.viewportMove(b, C, w.direction, y, L);
        default:
          return null;
      }
    }
  }
  i.CursorMoveImpl = o, i.CursorMove = re(new o());
  class r extends fi {
    constructor(b) {
      super(b), this._staticArgs = b.args;
    }
    runCoreEditorCommand(b, C) {
      let w = this._staticArgs;
      this._staticArgs.value === -1 && (w = { direction: this._staticArgs.direction, unit: this._staticArgs.unit, select: this._staticArgs.select, value: C.pageSize || b.cursorConfig.pageSize }), b.model.pushStackElement(), b.setCursorStates(C.source, 3, mn.simpleMove(b, b.getCursorStates(), w.direction, w.select, w.value, w.unit)), b.revealAllCursors(C.source, !0);
    }
  }
  i.CursorLeft = re(new r({ args: { direction: 0, unit: 0, select: !1, value: 1 }, id: "cursorLeft", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 15, mac: { primary: 15, secondary: [288] } } })), i.CursorLeftSelect = re(new r({ args: { direction: 0, unit: 0, select: !0, value: 1 }, id: "cursorLeftSelect", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 1039 } })), i.CursorRight = re(new r({ args: { direction: 1, unit: 0, select: !1, value: 1 }, id: "cursorRight", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 17, mac: { primary: 17, secondary: [292] } } })), i.CursorRightSelect = re(new r({ args: { direction: 1, unit: 0, select: !0, value: 1 }, id: "cursorRightSelect", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 1041 } })), i.CursorUp = re(new r({ args: { direction: 2, unit: 2, select: !1, value: 1 }, id: "cursorUp", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 16, mac: { primary: 16, secondary: [302] } } })), i.CursorUpSelect = re(new r({ args: { direction: 2, unit: 2, select: !0, value: 1 }, id: "cursorUpSelect", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 1040, secondary: [3088], mac: { primary: 1040 }, linux: { primary: 1040 } } })), i.CursorPageUp = re(new r({ args: { direction: 2, unit: 2, select: !1, value: -1 }, id: "cursorPageUp", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 11 } })), i.CursorPageUpSelect = re(new r({ args: { direction: 2, unit: 2, select: !0, value: -1 }, id: "cursorPageUpSelect", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 1035 } })), i.CursorDown = re(new r({ args: { direction: 3, unit: 2, select: !1, value: 1 }, id: "cursorDown", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 18, mac: { primary: 18, secondary: [300] } } })), i.CursorDownSelect = re(new r({ args: { direction: 3, unit: 2, select: !0, value: 1 }, id: "cursorDownSelect", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 1042, secondary: [3090], mac: { primary: 1042 }, linux: { primary: 1042 } } })), i.CursorPageDown = re(new r({ args: { direction: 3, unit: 2, select: !1, value: -1 }, id: "cursorPageDown", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 12 } })), i.CursorPageDownSelect = re(new r({ args: { direction: 3, unit: 2, select: !0, value: -1 }, id: "cursorPageDownSelect", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 1036 } })), i.CreateCursor = re(new class extends fi {
    constructor() {
      super({ id: "createCursor", precondition: void 0 });
    }
    runCoreEditorCommand(v, b) {
      if (!b.position) return;
      let C;
      C = b.wholeLine ? mn.line(v, v.getPrimaryCursorState(), !1, b.position, b.viewPosition) : mn.moveTo(v, v.getPrimaryCursorState(), !1, b.position, b.viewPosition);
      const w = v.getCursorStates();
      if (w.length > 1) {
        const y = C.modelState ? C.modelState.position : null, L = C.viewState ? C.viewState.position : null;
        for (let k = 0, N = w.length; k < N; k++) {
          const A = w[k];
          if ((!y || A.modelState.selection.containsPosition(y)) && (!L || A.viewState.selection.containsPosition(L))) return w.splice(k, 1), v.model.pushStackElement(), void v.setCursorStates(b.source, 3, w);
        }
      }
      w.push(C), v.model.pushStackElement(), v.setCursorStates(b.source, 3, w);
    }
  }()), i.LastCursorMoveToSelect = re(new class extends fi {
    constructor() {
      super({ id: "_lastCursorMoveToSelect", precondition: void 0 });
    }
    runCoreEditorCommand(v, b) {
      if (!b.position) return;
      const C = v.getLastAddedCursorIndex(), w = v.getCursorStates(), y = w.slice(0);
      y[C] = mn.moveTo(v, w[C], !0, b.position, b.viewPosition), v.model.pushStackElement(), v.setCursorStates(b.source, 3, y);
    }
  }());
  class a extends fi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, C) {
      b.model.pushStackElement(), b.setCursorStates(C.source, 3, mn.moveToBeginningOfLine(b, b.getCursorStates(), this._inSelectionMode)), b.revealAllCursors(C.source, !0);
    }
  }
  i.CursorHome = re(new a({ inSelectionMode: !1, id: "cursorHome", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 14, mac: { primary: 14, secondary: [2063] } } })), i.CursorHomeSelect = re(new a({ inSelectionMode: !0, id: "cursorHomeSelect", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 1038, mac: { primary: 1038, secondary: [3087] } } }));
  class l extends fi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, C) {
      b.model.pushStackElement(), b.setCursorStates(C.source, 3, this._exec(b.getCursorStates())), b.revealAllCursors(C.source, !0);
    }
    _exec(b) {
      const C = [];
      for (let w = 0, y = b.length; w < y; w++) {
        const L = b[w], k = L.modelState.position.lineNumber;
        C[w] = pt.fromModelState(L.modelState.move(this._inSelectionMode, k, 1, 0));
      }
      return C;
    }
  }
  i.CursorLineStart = re(new l({ inSelectionMode: !1, id: "cursorLineStart", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 0, mac: { primary: 287 } } })), i.CursorLineStartSelect = re(new l({ inSelectionMode: !0, id: "cursorLineStartSelect", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 0, mac: { primary: 1311 } } }));
  class d extends fi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, C) {
      b.model.pushStackElement(), b.setCursorStates(C.source, 3, mn.moveToEndOfLine(b, b.getCursorStates(), this._inSelectionMode, C.sticky || !1)), b.revealAllCursors(C.source, !0);
    }
  }
  i.CursorEnd = re(new d({ inSelectionMode: !1, id: "cursorEnd", precondition: void 0, kbOpts: { args: { sticky: !1 }, weight: 0, kbExpr: E.textInputFocus, primary: 13, mac: { primary: 13, secondary: [2065] } }, metadata: { description: "Go to End", args: [{ name: "args", schema: { type: "object", properties: { sticky: { description: m(0, "Stick to the end even when going to longer lines"), type: "boolean", default: !1 } } } }] } })), i.CursorEndSelect = re(new d({ inSelectionMode: !0, id: "cursorEndSelect", precondition: void 0, kbOpts: { args: { sticky: !1 }, weight: 0, kbExpr: E.textInputFocus, primary: 1037, mac: { primary: 1037, secondary: [3089] } }, metadata: { description: "Select to End", args: [{ name: "args", schema: { type: "object", properties: { sticky: { description: m(0, "Stick to the end even when going to longer lines"), type: "boolean", default: !1 } } } }] } }));
  class h extends fi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, C) {
      b.model.pushStackElement(), b.setCursorStates(C.source, 3, this._exec(b, b.getCursorStates())), b.revealAllCursors(C.source, !0);
    }
    _exec(b, C) {
      const w = [];
      for (let y = 0, L = C.length; y < L; y++) {
        const k = C[y], N = k.modelState.position.lineNumber, A = b.model.getLineMaxColumn(N);
        w[y] = pt.fromModelState(k.modelState.move(this._inSelectionMode, N, A, 0));
      }
      return w;
    }
  }
  i.CursorLineEnd = re(new h({ inSelectionMode: !1, id: "cursorLineEnd", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 0, mac: { primary: 291 } } })), i.CursorLineEndSelect = re(new h({ inSelectionMode: !0, id: "cursorLineEndSelect", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 0, mac: { primary: 1315 } } }));
  class c extends fi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, C) {
      b.model.pushStackElement(), b.setCursorStates(C.source, 3, mn.moveToBeginningOfBuffer(b, b.getCursorStates(), this._inSelectionMode)), b.revealAllCursors(C.source, !0);
    }
  }
  i.CursorTop = re(new c({ inSelectionMode: !1, id: "cursorTop", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 2062, mac: { primary: 2064 } } })), i.CursorTopSelect = re(new c({ inSelectionMode: !0, id: "cursorTopSelect", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 3086, mac: { primary: 3088 } } }));
  class u extends fi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, C) {
      b.model.pushStackElement(), b.setCursorStates(C.source, 3, mn.moveToEndOfBuffer(b, b.getCursorStates(), this._inSelectionMode)), b.revealAllCursors(C.source, !0);
    }
  }
  i.CursorBottom = re(new u({ inSelectionMode: !1, id: "cursorBottom", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 2061, mac: { primary: 2066 } } })), i.CursorBottomSelect = re(new u({ inSelectionMode: !0, id: "cursorBottomSelect", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 3085, mac: { primary: 3090 } } }));
  class g extends fi {
    constructor() {
      super({ id: "editorScroll", precondition: void 0, metadata: kn.metadata });
    }
    determineScrollMethod(b) {
      return [6].includes(b.unit) && [4, 2].includes(b.direction) ? this._runHorizontalEditorScroll.bind(this) : [1, 2, 3, 4, 5, 6].includes(b.unit) && [1, 3].includes(b.direction) ? this._runVerticalEditorScroll.bind(this) : null;
    }
    runCoreEditorCommand(b, C) {
      const w = kn.parse(C);
      if (!w) return;
      const y = this.determineScrollMethod(w);
      y && y(b, C.source, w);
    }
    _runVerticalEditorScroll(b, C, w) {
      const y = this._computeDesiredScrollTop(b, w);
      if (w.revealCursor) {
        const L = b.getCompletelyVisibleViewRangeAtScrollTop(y);
        b.setCursorStates(C, 3, [mn.findPositionInViewportIfOutside(b, b.getPrimaryCursorState(), L, w.select)]);
      }
      b.viewLayout.setScrollPosition({ scrollTop: y }, 0);
    }
    _computeDesiredScrollTop(b, C) {
      if (C.unit === 1) {
        const L = b.viewLayout.getFutureViewport(), k = b.getCompletelyVisibleViewRangeAtScrollTop(L.top), N = b.coordinatesConverter.convertViewRangeToModelRange(k);
        let A;
        A = C.direction === 1 ? Math.max(1, N.startLineNumber - C.value) : Math.min(b.model.getLineCount(), N.startLineNumber + C.value);
        const B = b.coordinatesConverter.convertModelPositionToViewPosition(new W(A, 1));
        return b.viewLayout.getVerticalOffsetForLineNumber(B.lineNumber);
      }
      if (C.unit === 5) {
        let L = 0;
        return C.direction === 3 && (L = b.model.getLineCount() - b.cursorConfig.pageSize), b.viewLayout.getVerticalOffsetForLineNumber(L);
      }
      let w;
      w = C.unit === 3 ? b.cursorConfig.pageSize * C.value : C.unit === 4 ? Math.round(b.cursorConfig.pageSize / 2) * C.value : C.value;
      const y = (C.direction === 1 ? -1 : 1) * w;
      return b.viewLayout.getCurrentScrollTop() + y * b.cursorConfig.lineHeight;
    }
    _runHorizontalEditorScroll(b, C, w) {
      const y = this._computeDesiredScrollLeft(b, w);
      b.viewLayout.setScrollPosition({ scrollLeft: y }, 0);
    }
    _computeDesiredScrollLeft(b, C) {
      const w = (C.direction === 4 ? -1 : 1) * C.value;
      return b.viewLayout.getCurrentScrollLeft() + w * b.cursorConfig.typicalHalfwidthCharacterWidth;
    }
  }
  i.EditorScrollImpl = g, i.EditorScroll = re(new g()), i.ScrollLineUp = re(new class extends fi {
    constructor() {
      super({ id: "scrollLineUp", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 2064, mac: { primary: 267 } } });
    }
    runCoreEditorCommand(v, b) {
      i.EditorScroll.runCoreEditorCommand(v, { to: kn.RawDirection.Up, by: kn.RawUnit.WrappedLine, value: 1, revealCursor: !1, select: !1, source: b.source });
    }
  }()), i.ScrollPageUp = re(new class extends fi {
    constructor() {
      super({ id: "scrollPageUp", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 2059, win: { primary: 523 }, linux: { primary: 523 } } });
    }
    runCoreEditorCommand(v, b) {
      i.EditorScroll.runCoreEditorCommand(v, { to: kn.RawDirection.Up, by: kn.RawUnit.Page, value: 1, revealCursor: !1, select: !1, source: b.source });
    }
  }()), i.ScrollEditorTop = re(new class extends fi {
    constructor() {
      super({ id: "scrollEditorTop", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus } });
    }
    runCoreEditorCommand(v, b) {
      i.EditorScroll.runCoreEditorCommand(v, { to: kn.RawDirection.Up, by: kn.RawUnit.Editor, value: 1, revealCursor: !1, select: !1, source: b.source });
    }
  }()), i.ScrollLineDown = re(new class extends fi {
    constructor() {
      super({ id: "scrollLineDown", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 2066, mac: { primary: 268 } } });
    }
    runCoreEditorCommand(v, b) {
      i.EditorScroll.runCoreEditorCommand(v, { to: kn.RawDirection.Down, by: kn.RawUnit.WrappedLine, value: 1, revealCursor: !1, select: !1, source: b.source });
    }
  }()), i.ScrollPageDown = re(new class extends fi {
    constructor() {
      super({ id: "scrollPageDown", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 2060, win: { primary: 524 }, linux: { primary: 524 } } });
    }
    runCoreEditorCommand(v, b) {
      i.EditorScroll.runCoreEditorCommand(v, { to: kn.RawDirection.Down, by: kn.RawUnit.Page, value: 1, revealCursor: !1, select: !1, source: b.source });
    }
  }()), i.ScrollEditorBottom = re(new class extends fi {
    constructor() {
      super({ id: "scrollEditorBottom", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus } });
    }
    runCoreEditorCommand(v, b) {
      i.EditorScroll.runCoreEditorCommand(v, { to: kn.RawDirection.Down, by: kn.RawUnit.Editor, value: 1, revealCursor: !1, select: !1, source: b.source });
    }
  }()), i.ScrollLeft = re(new class extends fi {
    constructor() {
      super({ id: "scrollLeft", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus } });
    }
    runCoreEditorCommand(v, b) {
      i.EditorScroll.runCoreEditorCommand(v, { to: kn.RawDirection.Left, by: kn.RawUnit.Column, value: 2, revealCursor: !1, select: !1, source: b.source });
    }
  }()), i.ScrollRight = re(new class extends fi {
    constructor() {
      super({ id: "scrollRight", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus } });
    }
    runCoreEditorCommand(v, b) {
      i.EditorScroll.runCoreEditorCommand(v, { to: kn.RawDirection.Right, by: kn.RawUnit.Column, value: 2, revealCursor: !1, select: !1, source: b.source });
    }
  }());
  class p extends fi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, C) {
      C.position && (b.model.pushStackElement(), b.setCursorStates(C.source, 3, [mn.word(b, b.getPrimaryCursorState(), this._inSelectionMode, C.position)]), C.revealType !== 2 && b.revealAllCursors(C.source, !0, !0));
    }
  }
  i.WordSelect = re(new p({ inSelectionMode: !1, id: "_wordSelect", precondition: void 0 })), i.WordSelectDrag = re(new p({ inSelectionMode: !0, id: "_wordSelectDrag", precondition: void 0 })), i.LastCursorWordSelect = re(new class extends fi {
    constructor() {
      super({ id: "lastCursorWordSelect", precondition: void 0 });
    }
    runCoreEditorCommand(v, b) {
      if (!b.position) return;
      const C = v.getLastAddedCursorIndex(), w = v.getCursorStates(), y = w.slice(0), L = w[C];
      y[C] = mn.word(v, L, L.modelState.hasSelection(), b.position), v.model.pushStackElement(), v.setCursorStates(b.source, 3, y);
    }
  }());
  class f extends fi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, C) {
      C.position && (b.model.pushStackElement(), b.setCursorStates(C.source, 3, [mn.line(b, b.getPrimaryCursorState(), this._inSelectionMode, C.position, C.viewPosition)]), C.revealType !== 2 && b.revealAllCursors(C.source, !1, !0));
    }
  }
  i.LineSelect = re(new f({ inSelectionMode: !1, id: "_lineSelect", precondition: void 0 })), i.LineSelectDrag = re(new f({ inSelectionMode: !0, id: "_lineSelectDrag", precondition: void 0 }));
  class _ extends fi {
    constructor(b) {
      super(b), this._inSelectionMode = b.inSelectionMode;
    }
    runCoreEditorCommand(b, C) {
      if (!C.position) return;
      const w = b.getLastAddedCursorIndex(), y = b.getCursorStates(), L = y.slice(0);
      L[w] = mn.line(b, y[w], this._inSelectionMode, C.position, C.viewPosition), b.model.pushStackElement(), b.setCursorStates(C.source, 3, L);
    }
  }
  i.LastCursorLineSelect = re(new _({ inSelectionMode: !1, id: "lastCursorLineSelect", precondition: void 0 })), i.LastCursorLineSelectDrag = re(new _({ inSelectionMode: !0, id: "lastCursorLineSelectDrag", precondition: void 0 })), i.CancelSelection = re(new class extends fi {
    constructor() {
      super({ id: "cancelSelection", precondition: E.hasNonEmptySelection, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 9, secondary: [1033] } });
    }
    runCoreEditorCommand(v, b) {
      v.model.pushStackElement(), v.setCursorStates(b.source, 3, [mn.cancelSelection(v, v.getPrimaryCursorState())]), v.revealAllCursors(b.source, !0);
    }
  }()), i.RemoveSecondaryCursors = re(new class extends fi {
    constructor() {
      super({ id: "removeSecondaryCursors", precondition: E.hasMultipleSelections, kbOpts: { weight: 1, kbExpr: E.textInputFocus, primary: 9, secondary: [1033] } });
    }
    runCoreEditorCommand(v, b) {
      v.model.pushStackElement(), v.setCursorStates(b.source, 3, [v.getPrimaryCursorState()]), v.revealAllCursors(b.source, !0), vl(m(0, "Removed secondary cursors"));
    }
  }()), i.RevealLine = re(new class extends fi {
    constructor() {
      super({ id: "revealLine", precondition: void 0, metadata: Fp.metadata });
    }
    runCoreEditorCommand(v, b) {
      const C = b, w = C.lineNumber || 0;
      let y = typeof w == "number" ? w + 1 : parseInt(w) + 1;
      y < 1 && (y = 1);
      const L = v.model.getLineCount();
      y > L && (y = L);
      const k = new D(y, 1, y, v.model.getLineMaxColumn(y));
      let N = 0;
      if (C.at) switch (C.at) {
        case Fp.RawAtArgument.Top:
          N = 3;
          break;
        case Fp.RawAtArgument.Center:
          N = 1;
          break;
        case Fp.RawAtArgument.Bottom:
          N = 4;
      }
      const A = v.coordinatesConverter.convertModelRangeToViewRange(k);
      v.revealRange(b.source, !1, A, N, 0);
    }
  }()), i.SelectAll = new class extends sI {
    constructor() {
      super(Vj);
    }
    runDOMCommand(v) {
      tr && (v.focus(), v.select()), v.ownerDocument.execCommand("selectAll");
    }
    runEditorCommand(v, b, C) {
      const w = b._getViewModel();
      w && this.runCoreEditorCommand(w, C);
    }
    runCoreEditorCommand(v, b) {
      v.model.pushStackElement(), v.setCursorStates("keyboard", 3, [mn.selectAll(v, v.getPrimaryCursorState())]);
    }
  }(), i.SetSelection = re(new class extends fi {
    constructor() {
      super({ id: "setSelection", precondition: void 0 });
    }
    runCoreEditorCommand(v, b) {
      b.selection && (v.model.pushStackElement(), v.setCursorStates(b.source, 3, [pt.fromModelSelection(b.selection)]));
    }
  }());
})(dn || (dn = {}));
const lY = q.and(E.textInputFocus, E.columnSelection);
function Gg(i, e) {
  Es.registerKeybindingRule({ id: i, primary: e, when: lY, weight: 1 });
}
function Q4(i) {
  return i.register(), i;
}
var am, qu;
Gg(dn.CursorColumnSelectLeft.id, 1039), Gg(dn.CursorColumnSelectRight.id, 1041), Gg(dn.CursorColumnSelectUp.id, 1040), Gg(dn.CursorColumnSelectPageUp.id, 1035), Gg(dn.CursorColumnSelectDown.id, 1042), Gg(dn.CursorColumnSelectPageDown.id, 1036), function(i) {
  class e extends Zi {
    runEditorCommand(n, s, o) {
      const r = s._getViewModel();
      r && this.runCoreEditingCommand(s, r, o || {});
    }
  }
  i.CoreEditingCommand = e, i.LineBreakInsert = re(new class extends e {
    constructor() {
      super({ id: "lineBreakInsert", precondition: E.writable, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 0, mac: { primary: 301 } } });
    }
    runCoreEditingCommand(t, n, s) {
      t.pushUndoStop(), t.executeCommands(this.id, oi.lineBreakInsert(n.cursorConfig, n.model, n.getCursorStates().map((o) => o.modelState.selection)));
    }
  }()), i.Outdent = re(new class extends e {
    constructor() {
      super({ id: "outdent", precondition: E.writable, kbOpts: { weight: 0, kbExpr: q.and(E.editorTextFocus, E.tabDoesNotMoveFocus), primary: 1026 } });
    }
    runCoreEditingCommand(t, n, s) {
      t.pushUndoStop(), t.executeCommands(this.id, oi.outdent(n.cursorConfig, n.model, n.getCursorStates().map((o) => o.modelState.selection))), t.pushUndoStop();
    }
  }()), i.Tab = re(new class extends e {
    constructor() {
      super({ id: "tab", precondition: E.writable, kbOpts: { weight: 0, kbExpr: q.and(E.editorTextFocus, E.tabDoesNotMoveFocus), primary: 2 } });
    }
    runCoreEditingCommand(t, n, s) {
      t.pushUndoStop(), t.executeCommands(this.id, oi.tab(n.cursorConfig, n.model, n.getCursorStates().map((o) => o.modelState.selection))), t.pushUndoStop();
    }
  }()), i.DeleteLeft = re(new class extends e {
    constructor() {
      super({ id: "deleteLeft", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 1, secondary: [1025], mac: { primary: 1, secondary: [1025, 294, 257] } } });
    }
    runCoreEditingCommand(t, n, s) {
      const [o, r] = gg.deleteLeft(n.getPrevEditOperationType(), n.cursorConfig, n.model, n.getCursorStates().map((a) => a.modelState.selection), n.getCursorAutoClosedCharacters());
      o && t.pushUndoStop(), t.executeCommands(this.id, r), n.setPrevEditOperationType(2);
    }
  }()), i.DeleteRight = re(new class extends e {
    constructor() {
      super({ id: "deleteRight", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 20, mac: { primary: 20, secondary: [290, 276] } } });
    }
    runCoreEditingCommand(t, n, s) {
      const [o, r] = gg.deleteRight(n.getPrevEditOperationType(), n.cursorConfig, n.model, n.getCursorStates().map((a) => a.modelState.selection));
      o && t.pushUndoStop(), t.executeCommands(this.id, r), n.setPrevEditOperationType(3);
    }
  }()), i.Undo = new class extends sI {
    constructor() {
      super(O8);
    }
    runDOMCommand(t) {
      t.ownerDocument.execCommand("undo");
    }
    runEditorCommand(t, n, s) {
      if (n.hasModel() && n.getOption(91) !== !0) return n.getModel().undo();
    }
  }(), i.Redo = new class extends sI {
    constructor() {
      super(F8);
    }
    runDOMCommand(t) {
      t.ownerDocument.execCommand("redo");
    }
    runEditorCommand(t, n, s) {
      if (n.hasModel() && n.getOption(91) !== !0) return n.getModel().redo();
    }
  }();
}(am || (am = {}));
class J4 extends eL {
  constructor(e, t, n) {
    super({ id: e, precondition: void 0, metadata: n }), this._handlerId = t;
  }
  runCommand(e, t) {
    const n = e.get(mt).getFocusedCodeEditor();
    n && n.trigger("keyboard", this._handlerId, t);
  }
}
function Uc(i, e) {
  Q4(new J4("default:" + i, i)), Q4(new J4(i, i, e));
}
Uc("type", { description: "Type", args: [{ name: "args", schema: { type: "object", required: ["text"], properties: { text: { type: "string" } } } }] }), Uc("replacePreviousChar"), Uc("compositionType"), Uc("compositionStart"), Uc("compositionEnd"), Uc("paste"), Uc("cut");
class dY {
  constructor(e, t, n, s) {
    this.configuration = e, this.viewModel = t, this.userInputEvents = n, this.commandDelegate = s;
  }
  paste(e, t, n, s) {
    this.commandDelegate.paste(e, t, n, s);
  }
  type(e) {
    this.commandDelegate.type(e);
  }
  compositionType(e, t, n, s) {
    this.commandDelegate.compositionType(e, t, n, s);
  }
  compositionStart() {
    this.commandDelegate.startComposition();
  }
  compositionEnd() {
    this.commandDelegate.endComposition();
  }
  cut() {
    this.commandDelegate.cut();
  }
  setSelection(e) {
    dn.SetSelection.runCoreEditorCommand(this.viewModel, { source: "keyboard", selection: e });
  }
  _validateViewColumn(e) {
    const t = this.viewModel.getLineMinColumn(e.lineNumber);
    return e.column < t ? new W(e.lineNumber, t) : e;
  }
  _hasMulticursorModifier(e) {
    switch (this.configuration.options.get(78)) {
      case "altKey":
        return e.altKey;
      case "ctrlKey":
        return e.ctrlKey;
      case "metaKey":
        return e.metaKey;
      default:
        return !1;
    }
  }
  _hasNonMulticursorModifier(e) {
    switch (this.configuration.options.get(78)) {
      case "altKey":
        return e.ctrlKey || e.metaKey;
      case "ctrlKey":
        return e.altKey || e.metaKey;
      case "metaKey":
        return e.ctrlKey || e.altKey;
      default:
        return !1;
    }
  }
  dispatchMouse(e) {
    const t = this.configuration.options, n = Cs && t.get(107), s = t.get(22);
    e.middleButton && !n ? this._columnSelect(e.position, e.mouseColumn, e.inSelectionMode) : e.startedOnLineNumbers ? this._hasMulticursorModifier(e) ? e.inSelectionMode ? this._lastCursorLineSelect(e.position, e.revealType) : this._createCursor(e.position, !0) : e.inSelectionMode ? this._lineSelectDrag(e.position, e.revealType) : this._lineSelect(e.position, e.revealType) : e.mouseDownCount >= 4 ? this._selectAll() : e.mouseDownCount === 3 ? this._hasMulticursorModifier(e) ? e.inSelectionMode ? this._lastCursorLineSelectDrag(e.position, e.revealType) : this._lastCursorLineSelect(e.position, e.revealType) : e.inSelectionMode ? this._lineSelectDrag(e.position, e.revealType) : this._lineSelect(e.position, e.revealType) : e.mouseDownCount === 2 ? e.onInjectedText || (this._hasMulticursorModifier(e) ? this._lastCursorWordSelect(e.position, e.revealType) : e.inSelectionMode ? this._wordSelectDrag(e.position, e.revealType) : this._wordSelect(e.position, e.revealType)) : this._hasMulticursorModifier(e) ? this._hasNonMulticursorModifier(e) || (e.shiftKey ? this._columnSelect(e.position, e.mouseColumn, !0) : e.inSelectionMode ? this._lastCursorMoveToSelect(e.position, e.revealType) : this._createCursor(e.position, !1)) : e.inSelectionMode ? e.altKey || s ? this._columnSelect(e.position, e.mouseColumn, !0) : this._moveToSelect(e.position, e.revealType) : this.moveTo(e.position, e.revealType);
  }
  _usualArgs(e, t) {
    return e = this._validateViewColumn(e), { source: "mouse", position: this._convertViewToModelPosition(e), viewPosition: e, revealType: t };
  }
  moveTo(e, t) {
    dn.MoveTo.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _moveToSelect(e, t) {
    dn.MoveToSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _columnSelect(e, t, n) {
    e = this._validateViewColumn(e), dn.ColumnSelect.runCoreEditorCommand(this.viewModel, { source: "mouse", position: this._convertViewToModelPosition(e), viewPosition: e, mouseColumn: t, doColumnSelect: n });
  }
  _createCursor(e, t) {
    e = this._validateViewColumn(e), dn.CreateCursor.runCoreEditorCommand(this.viewModel, { source: "mouse", position: this._convertViewToModelPosition(e), viewPosition: e, wholeLine: t });
  }
  _lastCursorMoveToSelect(e, t) {
    dn.LastCursorMoveToSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _wordSelect(e, t) {
    dn.WordSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _wordSelectDrag(e, t) {
    dn.WordSelectDrag.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _lastCursorWordSelect(e, t) {
    dn.LastCursorWordSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _lineSelect(e, t) {
    dn.LineSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _lineSelectDrag(e, t) {
    dn.LineSelectDrag.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _lastCursorLineSelect(e, t) {
    dn.LastCursorLineSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _lastCursorLineSelectDrag(e, t) {
    dn.LastCursorLineSelectDrag.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _selectAll() {
    dn.SelectAll.runCoreEditorCommand(this.viewModel, { source: "mouse" });
  }
  _convertViewToModelPosition(e) {
    return this.viewModel.coordinatesConverter.convertViewPositionToModelPosition(e);
  }
  emitKeyDown(e) {
    this.userInputEvents.emitKeyDown(e);
  }
  emitKeyUp(e) {
    this.userInputEvents.emitKeyUp(e);
  }
  emitContextMenu(e) {
    this.userInputEvents.emitContextMenu(e);
  }
  emitMouseMove(e) {
    this.userInputEvents.emitMouseMove(e);
  }
  emitMouseLeave(e) {
    this.userInputEvents.emitMouseLeave(e);
  }
  emitMouseUp(e) {
    this.userInputEvents.emitMouseUp(e);
  }
  emitMouseDown(e) {
    this.userInputEvents.emitMouseDown(e);
  }
  emitMouseDrag(e) {
    this.userInputEvents.emitMouseDrag(e);
  }
  emitMouseDrop(e) {
    this.userInputEvents.emitMouseDrop(e);
  }
  emitMouseDropCanceled() {
    this.userInputEvents.emitMouseDropCanceled();
  }
  emitMouseWheel(e) {
    this.userInputEvents.emitMouseWheel(e);
  }
}
class VB {
  constructor(e) {
    this._createLine = e, this._set(1, []);
  }
  flush() {
    this._set(1, []);
  }
  _set(e, t) {
    this._lines = t, this._rendLineNumberStart = e;
  }
  _get() {
    return { rendLineNumberStart: this._rendLineNumberStart, lines: this._lines };
  }
  getStartLineNumber() {
    return this._rendLineNumberStart;
  }
  getEndLineNumber() {
    return this._rendLineNumberStart + this._lines.length - 1;
  }
  getCount() {
    return this._lines.length;
  }
  getLine(e) {
    const t = e - this._rendLineNumberStart;
    if (t < 0 || t >= this._lines.length) throw new Kt("Illegal value for lineNumber");
    return this._lines[t];
  }
  onLinesDeleted(e, t) {
    if (this.getCount() === 0) return null;
    const n = this.getStartLineNumber(), s = this.getEndLineNumber();
    if (t < n) {
      const a = t - e + 1;
      return this._rendLineNumberStart -= a, null;
    }
    if (e > s) return null;
    let o = 0, r = 0;
    for (let a = n; a <= s; a++) {
      const l = a - this._rendLineNumberStart;
      e <= a && a <= t && (r === 0 ? (o = l, r = 1) : r++);
    }
    if (e < n) {
      let a = 0;
      a = t < n ? t - e + 1 : n - e, this._rendLineNumberStart -= a;
    }
    return this._lines.splice(o, r);
  }
  onLinesChanged(e, t) {
    const n = e + t - 1;
    if (this.getCount() === 0) return !1;
    const s = this.getStartLineNumber(), o = this.getEndLineNumber();
    let r = !1;
    for (let a = e; a <= n; a++) a >= s && a <= o && (this._lines[a - this._rendLineNumberStart].onContentChanged(), r = !0);
    return r;
  }
  onLinesInserted(e, t) {
    if (this.getCount() === 0) return null;
    const n = t - e + 1, s = this.getStartLineNumber(), o = this.getEndLineNumber();
    if (e <= s) return this._rendLineNumberStart += n, null;
    if (e > o) return null;
    if (n + e > o)
      return this._lines.splice(e - this._rendLineNumberStart, o - e + 1);
    const r = [];
    for (let c = 0; c < n; c++) r[c] = this._createLine();
    const a = e - this._rendLineNumberStart, l = this._lines.slice(0, a), d = this._lines.slice(a, this._lines.length - n), h = this._lines.slice(this._lines.length - n, this._lines.length);
    return this._lines = l.concat(r).concat(d), h;
  }
  onTokensChanged(e) {
    if (this.getCount() === 0) return !1;
    const t = this.getStartLineNumber(), n = this.getEndLineNumber();
    let s = !1;
    for (let o = 0, r = e.length; o < r; o++) {
      const a = e[o];
      if (a.toLineNumber < t || a.fromLineNumber > n) continue;
      const l = Math.max(t, a.fromLineNumber), d = Math.min(n, a.toLineNumber);
      for (let h = l; h <= d; h++) {
        const c = h - this._rendLineNumberStart;
        this._lines[c].onTokensChanged(), s = !0;
      }
    }
    return s;
  }
}
class HB {
  constructor(e) {
    this._host = e, this.domNode = this._createDomNode(), this._linesCollection = new VB(() => this._host.createVisibleLine());
  }
  _createDomNode() {
    const e = wt(document.createElement("div"));
    return e.setClassName("view-layer"), e.setPosition("absolute"), e.domNode.setAttribute("role", "presentation"), e.domNode.setAttribute("aria-hidden", "true"), e;
  }
  onConfigurationChanged(e) {
    return !!e.hasChanged(145);
  }
  onFlushed(e) {
    return this._linesCollection.flush(), !0;
  }
  onLinesChanged(e) {
    return this._linesCollection.onLinesChanged(e.fromLineNumber, e.count);
  }
  onLinesDeleted(e) {
    const t = this._linesCollection.onLinesDeleted(e.fromLineNumber, e.toLineNumber);
    if (t) for (let n = 0, s = t.length; n < s; n++) {
      const o = t[n].getDomNode();
      o && this.domNode.domNode.removeChild(o);
    }
    return !0;
  }
  onLinesInserted(e) {
    const t = this._linesCollection.onLinesInserted(e.fromLineNumber, e.toLineNumber);
    if (t) for (let n = 0, s = t.length; n < s; n++) {
      const o = t[n].getDomNode();
      o && this.domNode.domNode.removeChild(o);
    }
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onTokensChanged(e) {
    return this._linesCollection.onTokensChanged(e.ranges);
  }
  onZonesChanged(e) {
    return !0;
  }
  getStartLineNumber() {
    return this._linesCollection.getStartLineNumber();
  }
  getEndLineNumber() {
    return this._linesCollection.getEndLineNumber();
  }
  getVisibleLine(e) {
    return this._linesCollection.getLine(e);
  }
  renderLines(e) {
    const t = this._linesCollection._get(), n = new Jl(this.domNode.domNode, this._host, e), s = { rendLineNumberStart: t.rendLineNumberStart, lines: t.lines, linesLength: t.lines.length }, o = n.render(s, e.startLineNumber, e.endLineNumber, e.relativeVerticalOffset);
    this._linesCollection._set(o.rendLineNumberStart, o.lines);
  }
}
class Jl {
  constructor(e, t, n) {
    this.domNode = e, this.host = t, this.viewportData = n;
  }
  render(e, t, n, s) {
    const o = { rendLineNumberStart: e.rendLineNumberStart, lines: e.lines.slice(0), linesLength: e.linesLength };
    if (o.rendLineNumberStart + o.linesLength - 1 < t || n < o.rendLineNumberStart) {
      o.rendLineNumberStart = t, o.linesLength = n - t + 1, o.lines = [];
      for (let r = t; r <= n; r++) o.lines[r - t] = this.host.createVisibleLine();
      return this._finishRendering(o, !0, s), o;
    }
    if (this._renderUntouchedLines(o, Math.max(t - o.rendLineNumberStart, 0), Math.min(n - o.rendLineNumberStart, o.linesLength - 1), s, t), o.rendLineNumberStart > t) {
      const r = t, a = Math.min(n, o.rendLineNumberStart - 1);
      r <= a && (this._insertLinesBefore(o, r, a, s, t), o.linesLength += a - r + 1);
    } else if (o.rendLineNumberStart < t) {
      const r = Math.min(o.linesLength, t - o.rendLineNumberStart);
      r > 0 && (this._removeLinesBefore(o, r), o.linesLength -= r);
    }
    if (o.rendLineNumberStart = t, o.rendLineNumberStart + o.linesLength - 1 < n) {
      const r = o.rendLineNumberStart + o.linesLength, a = n;
      r <= a && (this._insertLinesAfter(o, r, a, s, t), o.linesLength += a - r + 1);
    } else if (o.rendLineNumberStart + o.linesLength - 1 > n) {
      const r = Math.max(0, n - o.rendLineNumberStart + 1), a = o.linesLength - 1 - r + 1;
      a > 0 && (this._removeLinesAfter(o, a), o.linesLength -= a);
    }
    return this._finishRendering(o, !1, s), o;
  }
  _renderUntouchedLines(e, t, n, s, o) {
    const r = e.rendLineNumberStart, a = e.lines;
    for (let l = t; l <= n; l++) {
      const d = r + l;
      a[l].layoutLine(d, s[d - o], this.viewportData.lineHeight);
    }
  }
  _insertLinesBefore(e, t, n, s, o) {
    const r = [];
    let a = 0;
    for (let l = t; l <= n; l++) r[a++] = this.host.createVisibleLine();
    e.lines = r.concat(e.lines);
  }
  _removeLinesBefore(e, t) {
    for (let n = 0; n < t; n++) {
      const s = e.lines[n].getDomNode();
      s && this.domNode.removeChild(s);
    }
    e.lines.splice(0, t);
  }
  _insertLinesAfter(e, t, n, s, o) {
    const r = [];
    let a = 0;
    for (let l = t; l <= n; l++) r[a++] = this.host.createVisibleLine();
    e.lines = e.lines.concat(r);
  }
  _removeLinesAfter(e, t) {
    const n = e.linesLength - t;
    for (let s = 0; s < t; s++) {
      const o = e.lines[n + s].getDomNode();
      o && this.domNode.removeChild(o);
    }
    e.lines.splice(n, t);
  }
  _finishRenderingNewLines(e, t, n, s) {
    Jl._ttPolicy && (n = Jl._ttPolicy.createHTML(n));
    const o = this.domNode.lastChild;
    t || !o ? this.domNode.innerHTML = n : o.insertAdjacentHTML("afterend", n);
    let r = this.domNode.lastChild;
    for (let a = e.linesLength - 1; a >= 0; a--) {
      const l = e.lines[a];
      s[a] && (l.setDomNode(r), r = r.previousSibling);
    }
  }
  _finishRenderingInvalidLines(e, t, n) {
    const s = document.createElement("div");
    Jl._ttPolicy && (t = Jl._ttPolicy.createHTML(t)), s.innerHTML = t;
    for (let o = 0; o < e.linesLength; o++) {
      const r = e.lines[o];
      if (n[o]) {
        const a = s.firstChild, l = r.getDomNode();
        l.parentNode.replaceChild(a, l), r.setDomNode(a);
      }
    }
  }
  _finishRendering(e, t, n) {
    const s = Jl._sb, o = e.linesLength, r = e.lines, a = e.rendLineNumberStart, l = [];
    {
      s.reset();
      let d = !1;
      for (let h = 0; h < o; h++) {
        const c = r[h];
        l[h] = !1, !c.getDomNode() && c.renderLine(h + a, n[h], this.viewportData.lineHeight, this.viewportData, s) && (l[h] = !0, d = !0);
      }
      d && this._finishRenderingNewLines(e, t, s.build(), l);
    }
    {
      s.reset();
      let d = !1;
      const h = [];
      for (let c = 0; c < o; c++) {
        const u = r[c];
        h[c] = !1, !l[c] && u.renderLine(c + a, n[c], this.viewportData.lineHeight, this.viewportData, s) && (h[c] = !0, d = !0);
      }
      d && this._finishRenderingInvalidLines(e, s.build(), h);
    }
  }
}
Jl._ttPolicy = Hd("editorViewLayer", { createHTML: (i) => i }), Jl._sb = new ff(1e5);
class zB extends to {
  constructor(e) {
    super(e), this._visibleLines = new HB(this), this.domNode = this._visibleLines.domNode;
    const t = this._context.configuration.options.get(50);
    yn(this.domNode, t), this._dynamicOverlays = [], this._isFocused = !1, this.domNode.setClassName("view-overlays");
  }
  shouldRender() {
    if (super.shouldRender()) return !0;
    for (let e = 0, t = this._dynamicOverlays.length; e < t; e++)
      if (this._dynamicOverlays[e].shouldRender()) return !0;
    return !1;
  }
  dispose() {
    super.dispose();
    for (let e = 0, t = this._dynamicOverlays.length; e < t; e++)
      this._dynamicOverlays[e].dispose();
    this._dynamicOverlays = [];
  }
  getDomNode() {
    return this.domNode;
  }
  createVisibleLine() {
    return new hY(this._dynamicOverlays);
  }
  addDynamicOverlay(e) {
    this._dynamicOverlays.push(e);
  }
  onConfigurationChanged(e) {
    this._visibleLines.onConfigurationChanged(e);
    const t = this._context.configuration.options.get(50);
    return yn(this.domNode, t), !0;
  }
  onFlushed(e) {
    return this._visibleLines.onFlushed(e);
  }
  onFocusChanged(e) {
    return this._isFocused = e.isFocused, !0;
  }
  onLinesChanged(e) {
    return this._visibleLines.onLinesChanged(e);
  }
  onLinesDeleted(e) {
    return this._visibleLines.onLinesDeleted(e);
  }
  onLinesInserted(e) {
    return this._visibleLines.onLinesInserted(e);
  }
  onScrollChanged(e) {
    return this._visibleLines.onScrollChanged(e) || !0;
  }
  onTokensChanged(e) {
    return this._visibleLines.onTokensChanged(e);
  }
  onZonesChanged(e) {
    return this._visibleLines.onZonesChanged(e);
  }
  prepareRender(e) {
    const t = this._dynamicOverlays.filter((n) => n.shouldRender());
    for (let n = 0, s = t.length; n < s; n++) {
      const o = t[n];
      o.prepareRender(e), o.onDidRender();
    }
  }
  render(e) {
    this._viewOverlaysRender(e), this.domNode.toggleClassName("focused", this._isFocused);
  }
  _viewOverlaysRender(e) {
    this._visibleLines.renderLines(e.viewportData);
  }
}
class hY {
  constructor(e) {
    this._dynamicOverlays = e, this._domNode = null, this._renderedContent = null;
  }
  getDomNode() {
    return this._domNode ? this._domNode.domNode : null;
  }
  setDomNode(e) {
    this._domNode = wt(e);
  }
  onContentChanged() {
  }
  onTokensChanged() {
  }
  renderLine(e, t, n, s, o) {
    let r = "";
    for (let a = 0, l = this._dynamicOverlays.length; a < l; a++)
      r += this._dynamicOverlays[a].render(s.startLineNumber, e);
    return this._renderedContent !== r && (this._renderedContent = r, o.appendString('<div style="top:'), o.appendString(String(t)), o.appendString("px;height:"), o.appendString(String(n)), o.appendString('px;">'), o.appendString(r), o.appendString("</div>"), !0);
  }
  layoutLine(e, t, n) {
    this._domNode && (this._domNode.setTop(t), this._domNode.setHeight(n));
  }
}
class cY extends zB {
  constructor(e) {
    super(e);
    const t = this._context.configuration.options.get(145);
    this._contentWidth = t.contentWidth, this.domNode.setHeight(0);
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options.get(145);
    return this._contentWidth = t.contentWidth, super.onConfigurationChanged(e) || !0;
  }
  onScrollChanged(e) {
    return super.onScrollChanged(e) || e.scrollWidthChanged;
  }
  _viewOverlaysRender(e) {
    super._viewOverlaysRender(e), this.domNode.setWidth(Math.max(e.scrollWidth, this._contentWidth));
  }
}
class uY extends zB {
  constructor(e) {
    super(e);
    const t = this._context.configuration.options, n = t.get(145);
    this._contentLeft = n.contentLeft, this.domNode.setClassName("margin-view-overlays"), this.domNode.setWidth(1), yn(this.domNode, t.get(50));
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    yn(this.domNode, t.get(50));
    const n = t.get(145);
    return this._contentLeft = n.contentLeft, super.onConfigurationChanged(e) || !0;
  }
  onScrollChanged(e) {
    return super.onScrollChanged(e) || e.scrollHeightChanged;
  }
  _viewOverlaysRender(e) {
    super._viewOverlaysRender(e);
    const t = Math.min(e.scrollHeight, 1e6);
    this.domNode.setHeight(t), this.domNode.setWidth(this._contentLeft);
  }
}
class cL {
  constructor(e) {
    this.onKeyDown = null, this.onKeyUp = null, this.onContextMenu = null, this.onMouseMove = null, this.onMouseLeave = null, this.onMouseDown = null, this.onMouseUp = null, this.onMouseDrag = null, this.onMouseDrop = null, this.onMouseDropCanceled = null, this.onMouseWheel = null, this._coordinatesConverter = e;
  }
  emitKeyDown(e) {
    var t;
    (t = this.onKeyDown) === null || t === void 0 || t.call(this, e);
  }
  emitKeyUp(e) {
    var t;
    (t = this.onKeyUp) === null || t === void 0 || t.call(this, e);
  }
  emitContextMenu(e) {
    var t;
    (t = this.onContextMenu) === null || t === void 0 || t.call(this, this._convertViewToModelMouseEvent(e));
  }
  emitMouseMove(e) {
    var t;
    (t = this.onMouseMove) === null || t === void 0 || t.call(this, this._convertViewToModelMouseEvent(e));
  }
  emitMouseLeave(e) {
    var t;
    (t = this.onMouseLeave) === null || t === void 0 || t.call(this, this._convertViewToModelMouseEvent(e));
  }
  emitMouseDown(e) {
    var t;
    (t = this.onMouseDown) === null || t === void 0 || t.call(this, this._convertViewToModelMouseEvent(e));
  }
  emitMouseUp(e) {
    var t;
    (t = this.onMouseUp) === null || t === void 0 || t.call(this, this._convertViewToModelMouseEvent(e));
  }
  emitMouseDrag(e) {
    var t;
    (t = this.onMouseDrag) === null || t === void 0 || t.call(this, this._convertViewToModelMouseEvent(e));
  }
  emitMouseDrop(e) {
    var t;
    (t = this.onMouseDrop) === null || t === void 0 || t.call(this, this._convertViewToModelMouseEvent(e));
  }
  emitMouseDropCanceled() {
    var e;
    (e = this.onMouseDropCanceled) === null || e === void 0 || e.call(this);
  }
  emitMouseWheel(e) {
    var t;
    (t = this.onMouseWheel) === null || t === void 0 || t.call(this, e);
  }
  _convertViewToModelMouseEvent(e) {
    return e.target ? { event: e.event, target: this._convertViewToModelMouseTarget(e.target) } : e;
  }
  _convertViewToModelMouseTarget(e) {
    return cL.convertViewToModelMouseTarget(e, this._coordinatesConverter);
  }
  static convertViewToModelMouseTarget(e, t) {
    const n = { ...e };
    return n.position && (n.position = t.convertViewPositionToModelPosition(n.position)), n.range && (n.range = t.convertViewRangeToModelRange(n.range)), n.type !== 5 && n.type !== 8 || (n.detail = this.convertViewToModelViewZoneData(n.detail, t)), n;
  }
  static convertViewToModelViewZoneData(e, t) {
    return { viewZoneId: e.viewZoneId, positionBefore: e.positionBefore ? t.convertViewPositionToModelPosition(e.positionBefore) : e.positionBefore, positionAfter: e.positionAfter ? t.convertViewPositionToModelPosition(e.positionAfter) : e.positionAfter, position: t.convertViewPositionToModelPosition(e.position), afterLineNumber: t.convertViewPositionToModelPosition(new W(e.afterLineNumber, 1)).lineNumber };
  }
}
class gY extends to {
  constructor(e) {
    super(e), this.blocks = [], this.contentWidth = -1, this.contentLeft = 0, this.domNode = wt(document.createElement("div")), this.domNode.setAttribute("role", "presentation"), this.domNode.setAttribute("aria-hidden", "true"), this.domNode.setClassName("blockDecorations-container"), this.update();
  }
  update() {
    let e = !1;
    const t = this._context.configuration.options.get(145), n = t.contentWidth - t.verticalScrollbarWidth;
    this.contentWidth !== n && (this.contentWidth = n, e = !0);
    const s = t.contentLeft;
    return this.contentLeft !== s && (this.contentLeft = s, e = !0), e;
  }
  dispose() {
    super.dispose();
  }
  onConfigurationChanged(e) {
    return this.update();
  }
  onScrollChanged(e) {
    return e.scrollTopChanged || e.scrollLeftChanged;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onZonesChanged(e) {
    return !0;
  }
  prepareRender(e) {
  }
  render(e) {
    var t;
    let n = 0;
    const s = e.getDecorationsInViewport();
    for (const o of s) {
      if (!o.options.blockClassName) continue;
      let r, a, l = this.blocks[n];
      l || (l = this.blocks[n] = wt(document.createElement("div")), this.domNode.appendChild(l)), o.options.blockIsAfterEnd ? (r = e.getVerticalOffsetAfterLineNumber(o.range.endLineNumber, !1), a = e.getVerticalOffsetAfterLineNumber(o.range.endLineNumber, !0)) : (r = e.getVerticalOffsetForLineNumber(o.range.startLineNumber, !0), a = o.range.isEmpty() && !o.options.blockDoesNotCollapse ? e.getVerticalOffsetForLineNumber(o.range.startLineNumber, !1) : e.getVerticalOffsetAfterLineNumber(o.range.endLineNumber, !0));
      const [d, h, c, u] = (t = o.options.blockPadding) !== null && t !== void 0 ? t : [0, 0, 0, 0];
      l.setClassName("blockDecorations-block " + o.options.blockClassName), l.setLeft(this.contentLeft - u), l.setWidth(this.contentWidth + u + h), l.setTop(r - e.scrollTop - d), l.setHeight(a - r + d + c), n++;
    }
    for (let o = n; o < this.blocks.length; o++) this.blocks[o].domNode.remove();
    this.blocks.length = n;
  }
}
class pY extends to {
  constructor(e, t) {
    super(e), this._viewDomNode = t, this._widgets = {}, this.domNode = wt(document.createElement("div")), _a.write(this.domNode, 1), this.domNode.setClassName("contentWidgets"), this.domNode.setPosition("absolute"), this.domNode.setTop(0), this.overflowingContentWidgetsDomNode = wt(document.createElement("div")), _a.write(this.overflowingContentWidgetsDomNode, 2), this.overflowingContentWidgetsDomNode.setClassName("overflowingContentWidgets");
  }
  dispose() {
    super.dispose(), this._widgets = {};
  }
  onConfigurationChanged(e) {
    const t = Object.keys(this._widgets);
    for (const n of t) this._widgets[n].onConfigurationChanged(e);
    return !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLineMappingChanged(e) {
    return this._updateAnchorsViewPositions(), !0;
  }
  onLinesChanged(e) {
    return this._updateAnchorsViewPositions(), !0;
  }
  onLinesDeleted(e) {
    return this._updateAnchorsViewPositions(), !0;
  }
  onLinesInserted(e) {
    return this._updateAnchorsViewPositions(), !0;
  }
  onScrollChanged(e) {
    return !0;
  }
  onZonesChanged(e) {
    return !0;
  }
  _updateAnchorsViewPositions() {
    const e = Object.keys(this._widgets);
    for (const t of e) this._widgets[t].updateAnchorViewPosition();
  }
  addWidget(e) {
    const t = new mY(this._context, this._viewDomNode, e);
    this._widgets[t.id] = t, t.allowEditorOverflow ? this.overflowingContentWidgetsDomNode.appendChild(t.domNode) : this.domNode.appendChild(t.domNode), this.setShouldRender();
  }
  setWidgetPosition(e, t, n, s, o) {
    this._widgets[e.getId()].setPosition(t, n, s, o), this.setShouldRender();
  }
  removeWidget(e) {
    const t = e.getId();
    if (this._widgets.hasOwnProperty(t)) {
      const n = this._widgets[t];
      delete this._widgets[t];
      const s = n.domNode.domNode;
      s.parentNode.removeChild(s), s.removeAttribute("monaco-visible-content-widget"), this.setShouldRender();
    }
  }
  shouldSuppressMouseDownOnWidget(e) {
    return !!this._widgets.hasOwnProperty(e) && this._widgets[e].suppressMouseDown;
  }
  onBeforeRender(e) {
    const t = Object.keys(this._widgets);
    for (const n of t) this._widgets[n].onBeforeRender(e);
  }
  prepareRender(e) {
    const t = Object.keys(this._widgets);
    for (const n of t) this._widgets[n].prepareRender(e);
  }
  render(e) {
    const t = Object.keys(this._widgets);
    for (const n of t) this._widgets[n].render(e);
  }
}
class mY {
  constructor(e, t, n) {
    this._primaryAnchor = new Bf(null, null), this._secondaryAnchor = new Bf(null, null), this._context = e, this._viewDomNode = t, this._actual = n, this.domNode = wt(this._actual.getDomNode()), this.id = this._actual.getId(), this.allowEditorOverflow = this._actual.allowEditorOverflow || !1, this.suppressMouseDown = this._actual.suppressMouseDown || !1;
    const s = this._context.configuration.options, o = s.get(145);
    this._fixedOverflowWidgets = s.get(42), this._contentWidth = o.contentWidth, this._contentLeft = o.contentLeft, this._lineHeight = s.get(67), this._affinity = null, this._preference = [], this._cachedDomNodeOffsetWidth = -1, this._cachedDomNodeOffsetHeight = -1, this._maxWidth = this._getMaxWidth(), this._isVisible = !1, this._renderData = null, this.domNode.setPosition(this._fixedOverflowWidgets && this.allowEditorOverflow ? "fixed" : "absolute"), this.domNode.setDisplay("none"), this.domNode.setVisibility("hidden"), this.domNode.setAttribute("widgetId", this.id), this.domNode.setMaxWidth(this._maxWidth);
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    if (this._lineHeight = t.get(67), e.hasChanged(145)) {
      const n = t.get(145);
      this._contentLeft = n.contentLeft, this._contentWidth = n.contentWidth, this._maxWidth = this._getMaxWidth();
    }
  }
  updateAnchorViewPosition() {
    this._setPosition(this._affinity, this._primaryAnchor.modelPosition, this._secondaryAnchor.modelPosition);
  }
  _setPosition(e, t, n) {
    function s(o, r, a) {
      if (!o) return new Bf(null, null);
      const l = r.model.validatePosition(o);
      if (r.coordinatesConverter.modelPositionIsVisible(l)) {
        const d = r.coordinatesConverter.convertModelPositionToViewPosition(l, a ?? void 0);
        return new Bf(o, d);
      }
      return new Bf(o, null);
    }
    this._affinity = e, this._primaryAnchor = s(t, this._context.viewModel, this._affinity), this._secondaryAnchor = s(n, this._context.viewModel, this._affinity);
  }
  _getMaxWidth() {
    const e = this.domNode.domNode.ownerDocument, t = e.defaultView;
    return this.allowEditorOverflow ? (t == null ? void 0 : t.innerWidth) || e.documentElement.offsetWidth || e.body.offsetWidth : this._contentWidth;
  }
  setPosition(e, t, n, s) {
    this._setPosition(s, e, t), this._preference = n, this._primaryAnchor.viewPosition && this._preference && this._preference.length > 0 ? this.domNode.setDisplay("block") : this.domNode.setDisplay("none"), this._cachedDomNodeOffsetWidth = -1, this._cachedDomNodeOffsetHeight = -1;
  }
  _layoutBoxInViewport(e, t, n, s) {
    const o = e.top, r = o, a = e.top + e.height, l = o - n, d = r >= n, h = a, c = s.viewportHeight - a >= n;
    let u = e.left;
    return u + t > s.scrollLeft + s.viewportWidth && (u = s.scrollLeft + s.viewportWidth - t), u < s.scrollLeft && (u = s.scrollLeft), { fitsAbove: d, aboveTop: l, fitsBelow: c, belowTop: h, left: u };
  }
  _layoutHorizontalSegmentInPage(e, t, n, s) {
    var o;
    const r = Math.max(15, t.left - s), a = Math.min(t.left + t.width + s, e.width - 15), l = this._viewDomNode.domNode.ownerDocument.defaultView;
    let d = t.left + n - ((o = l == null ? void 0 : l.scrollX) !== null && o !== void 0 ? o : 0);
    if (d + s > a) {
      const h = d - (a - s);
      d -= h, n -= h;
    }
    if (d < r) {
      const h = d - r;
      d -= h, n -= h;
    }
    return [n, d];
  }
  _layoutBoxInPage(e, t, n, s) {
    var o, r;
    const a = e.top - n, l = e.top + e.height, d = Ti(this._viewDomNode.domNode), h = this._viewDomNode.domNode.ownerDocument, c = h.defaultView, u = d.top + a - ((o = c == null ? void 0 : c.scrollY) !== null && o !== void 0 ? o : 0), g = d.top + l - ((r = c == null ? void 0 : c.scrollY) !== null && r !== void 0 ? r : 0), p = wc(h.body), [f, _] = this._layoutHorizontalSegmentInPage(p, d, e.left - s.scrollLeft + this._contentLeft, t), v = u >= 22, b = g + n <= p.height - 22;
    return this._fixedOverflowWidgets ? { fitsAbove: v, aboveTop: Math.max(u, 22), fitsBelow: b, belowTop: g, left: _ } : { fitsAbove: v, aboveTop: a, fitsBelow: b, belowTop: l, left: f };
  }
  _prepareRenderWidgetAtExactPositionOverflowing(e) {
    return new Wf(e.top, e.left + this._contentLeft);
  }
  _getAnchorsCoordinates(e) {
    var t, n;
    return { primary: s(this._primaryAnchor.viewPosition, this._affinity, this._lineHeight), secondary: s(((t = this._secondaryAnchor.viewPosition) === null || t === void 0 ? void 0 : t.lineNumber) === ((n = this._primaryAnchor.viewPosition) === null || n === void 0 ? void 0 : n.lineNumber) ? this._secondaryAnchor.viewPosition : null, this._affinity, this._lineHeight) };
    function s(o, r, a) {
      if (!o) return null;
      const l = e.visibleRangeForPosition(o);
      if (!l) return null;
      const d = o.column === 1 && r === 3 ? 0 : l.left, h = e.getVerticalOffsetForLineNumber(o.lineNumber) - e.scrollTop;
      return new e5(h, d, a);
    }
  }
  _reduceAnchorCoordinates(e, t, n) {
    if (!t) return e;
    const s = this._context.configuration.options.get(50);
    let o = t.left;
    return o = o < e.left ? Math.max(o, e.left - n + s.typicalFullwidthCharacterWidth) : Math.min(o, e.left + n - s.typicalFullwidthCharacterWidth), new e5(e.top, o, e.height);
  }
  _prepareRenderWidget(e) {
    if (!this._preference || this._preference.length === 0) return null;
    const { primary: t, secondary: n } = this._getAnchorsCoordinates(e);
    if (!t) return null;
    if (this._cachedDomNodeOffsetWidth === -1 || this._cachedDomNodeOffsetHeight === -1) {
      let r = null;
      if (typeof this._actual.beforeRender == "function" && (r = bD(this._actual.beforeRender, this._actual)), r) this._cachedDomNodeOffsetWidth = r.width, this._cachedDomNodeOffsetHeight = r.height;
      else {
        const a = this.domNode.domNode.getBoundingClientRect();
        this._cachedDomNodeOffsetWidth = Math.round(a.width), this._cachedDomNodeOffsetHeight = Math.round(a.height);
      }
    }
    const s = this._reduceAnchorCoordinates(t, n, this._cachedDomNodeOffsetWidth);
    let o;
    o = this.allowEditorOverflow ? this._layoutBoxInPage(s, this._cachedDomNodeOffsetWidth, this._cachedDomNodeOffsetHeight, e) : this._layoutBoxInViewport(s, this._cachedDomNodeOffsetWidth, this._cachedDomNodeOffsetHeight, e);
    for (let r = 1; r <= 2; r++) for (const a of this._preference) if (a === 1) {
      if (!o) return null;
      if (r === 2 || o.fitsAbove) return { coordinate: new Wf(o.aboveTop, o.left), position: 1 };
    } else {
      if (a !== 2) return this.allowEditorOverflow ? { coordinate: this._prepareRenderWidgetAtExactPositionOverflowing(new Wf(s.top, s.left)), position: 0 } : { coordinate: new Wf(s.top, s.left), position: 0 };
      if (!o) return null;
      if (r === 2 || o.fitsBelow) return { coordinate: new Wf(o.belowTop, o.left), position: 2 };
    }
    return null;
  }
  onBeforeRender(e) {
    this._primaryAnchor.viewPosition && this._preference && (this._primaryAnchor.viewPosition.lineNumber < e.startLineNumber || this._primaryAnchor.viewPosition.lineNumber > e.endLineNumber || this.domNode.setMaxWidth(this._maxWidth));
  }
  prepareRender(e) {
    this._renderData = this._prepareRenderWidget(e);
  }
  render(e) {
    if (!this._renderData) return this._isVisible && (this.domNode.removeAttribute("monaco-visible-content-widget"), this._isVisible = !1, this.domNode.setVisibility("hidden")), void (typeof this._actual.afterRender == "function" && bD(this._actual.afterRender, this._actual, null));
    this.allowEditorOverflow ? (this.domNode.setTop(this._renderData.coordinate.top), this.domNode.setLeft(this._renderData.coordinate.left)) : (this.domNode.setTop(this._renderData.coordinate.top + e.scrollTop - e.bigNumbersDelta), this.domNode.setLeft(this._renderData.coordinate.left)), this._isVisible || (this.domNode.setVisibility("inherit"), this.domNode.setAttribute("monaco-visible-content-widget", "true"), this._isVisible = !0), typeof this._actual.afterRender == "function" && bD(this._actual.afterRender, this._actual, this._renderData.position);
  }
}
class Bf {
  constructor(e, t) {
    this.modelPosition = e, this.viewPosition = t;
  }
}
class Wf {
  constructor(e, t) {
    this.top = e, this.left = t, this._coordinateBrand = void 0;
  }
}
class e5 {
  constructor(e, t, n) {
    this.top = e, this.left = t, this.height = n, this._anchorCoordinateBrand = void 0;
  }
}
function bD(i, e, ...t) {
  try {
    return i.call(e, ...t);
  } catch {
    return null;
  }
}
class UB extends Mg {
  constructor(e) {
    super(), this._context = e;
    const t = this._context.configuration.options, n = t.get(145);
    this._renderLineHighlight = t.get(96), this._renderLineHighlightOnlyWhenFocus = t.get(97), this._wordWrap = n.isViewportWrapping, this._contentLeft = n.contentLeft, this._contentWidth = n.contentWidth, this._selectionIsEmpty = !0, this._focused = !1, this._cursorLineNumbers = [1], this._selections = [new _e(1, 1, 1, 1)], this._renderData = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), super.dispose();
  }
  _readFromSelections() {
    let e = !1;
    const t = /* @__PURE__ */ new Set();
    for (const o of this._selections) t.add(o.positionLineNumber);
    const n = Array.from(t);
    n.sort((o, r) => o - r), ri(this._cursorLineNumbers, n) || (this._cursorLineNumbers = n, e = !0);
    const s = this._selections.every((o) => o.isEmpty());
    return this._selectionIsEmpty !== s && (this._selectionIsEmpty = s, e = !0), e;
  }
  onThemeChanged(e) {
    return this._readFromSelections();
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, n = t.get(145);
    return this._renderLineHighlight = t.get(96), this._renderLineHighlightOnlyWhenFocus = t.get(97), this._wordWrap = n.isViewportWrapping, this._contentLeft = n.contentLeft, this._contentWidth = n.contentWidth, !0;
  }
  onCursorStateChanged(e) {
    return this._selections = e.selections, this._readFromSelections();
  }
  onFlushed(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollWidthChanged || e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  onFocusChanged(e) {
    return !!this._renderLineHighlightOnlyWhenFocus && (this._focused = e.isFocused, !0);
  }
  prepareRender(e) {
    if (!this._shouldRenderThis()) return void (this._renderData = null);
    const t = e.visibleRange.startLineNumber, n = e.visibleRange.endLineNumber, s = [];
    for (let r = t; r <= n; r++)
      s[r - t] = "";
    if (this._wordWrap) {
      const r = this._renderOne(e, !1);
      for (const a of this._cursorLineNumbers) {
        const l = this._context.viewModel.coordinatesConverter, d = l.convertViewPositionToModelPosition(new W(a, 1)).lineNumber, h = l.convertModelPositionToViewPosition(new W(d, 1)).lineNumber, c = l.convertModelPositionToViewPosition(new W(d, this._context.viewModel.model.getLineMaxColumn(d))).lineNumber, u = Math.max(h, t), g = Math.min(c, n);
        for (let p = u; p <= g; p++)
          s[p - t] = r;
      }
    }
    const o = this._renderOne(e, !0);
    for (const r of this._cursorLineNumbers)
      r < t || r > n || (s[r - t] = o);
    this._renderData = s;
  }
  render(e, t) {
    if (!this._renderData) return "";
    const n = t - e;
    return n >= this._renderData.length ? "" : this._renderData[n];
  }
  _shouldRenderInMargin() {
    return (this._renderLineHighlight === "gutter" || this._renderLineHighlight === "all") && (!this._renderLineHighlightOnlyWhenFocus || this._focused);
  }
  _shouldRenderInContent() {
    return (this._renderLineHighlight === "line" || this._renderLineHighlight === "all") && this._selectionIsEmpty && (!this._renderLineHighlightOnlyWhenFocus || this._focused);
  }
}
class fY extends UB {
  _renderOne(e, t) {
    return `<div class="${"current-line" + (this._shouldRenderInMargin() ? " current-line-both" : "") + (t ? " current-line-exact" : "")}" style="width:${Math.max(e.scrollWidth, this._contentWidth)}px;"></div>`;
  }
  _shouldRenderThis() {
    return this._shouldRenderInContent();
  }
  _shouldRenderOther() {
    return this._shouldRenderInMargin();
  }
}
class _Y extends UB {
  _renderOne(e, t) {
    return `<div class="${"current-line" + (this._shouldRenderInMargin() ? " current-line-margin" : "") + (this._shouldRenderOther() ? " current-line-margin-both" : "") + (this._shouldRenderInMargin() && t ? " current-line-exact-margin" : "")}" style="width:${this._contentLeft}px"></div>`;
  }
  _shouldRenderThis() {
    return !0;
  }
  _shouldRenderOther() {
    return this._shouldRenderInContent();
  }
}
rr((i, e) => {
  const t = i.getColor(xB);
  if (t && (e.addRule(`.monaco-editor .view-overlays .current-line { background-color: ${t}; }`), e.addRule(`.monaco-editor .margin-view-overlays .current-line-margin { background-color: ${t}; border: none; }`)), !t || t.isTransparent() || i.defines(G4)) {
    const n = i.getColor(G4);
    n && (e.addRule(`.monaco-editor .view-overlays .current-line-exact { border: 2px solid ${n}; }`), e.addRule(`.monaco-editor .margin-view-overlays .current-line-exact-margin { border: 2px solid ${n}; }`), la(i.type) && (e.addRule(".monaco-editor .view-overlays .current-line-exact { border-width: 1px; }"), e.addRule(".monaco-editor .margin-view-overlays .current-line-exact-margin { border-width: 1px; }")));
  }
});
class vY extends Mg {
  constructor(e) {
    super(), this._context = e;
    const t = this._context.configuration.options;
    this._typicalHalfwidthCharacterWidth = t.get(50).typicalHalfwidthCharacterWidth, this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    return this._typicalHalfwidthCharacterWidth = t.get(50).typicalHalfwidthCharacterWidth, !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged || e.scrollWidthChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  prepareRender(e) {
    const t = e.getDecorationsInViewport();
    let n = [], s = 0;
    for (let l = 0, d = t.length; l < d; l++) {
      const h = t[l];
      h.options.className && (n[s++] = h);
    }
    n = n.sort((l, d) => {
      if (l.options.zIndex < d.options.zIndex) return -1;
      if (l.options.zIndex > d.options.zIndex) return 1;
      const h = l.options.className, c = d.options.className;
      return h < c ? -1 : h > c ? 1 : D.compareRangesUsingStarts(l.range, d.range);
    });
    const o = e.visibleRange.startLineNumber, r = e.visibleRange.endLineNumber, a = [];
    for (let l = o; l <= r; l++)
      a[l - o] = "";
    this._renderWholeLineDecorations(e, n, a), this._renderNormalDecorations(e, n, a), this._renderResult = a;
  }
  _renderWholeLineDecorations(e, t, n) {
    const s = e.visibleRange.startLineNumber, o = e.visibleRange.endLineNumber;
    for (let r = 0, a = t.length; r < a; r++) {
      const l = t[r];
      if (!l.options.isWholeLine) continue;
      const d = '<div class="cdr ' + l.options.className + '" style="left:0;width:100%;"></div>', h = Math.max(l.range.startLineNumber, s), c = Math.min(l.range.endLineNumber, o);
      for (let u = h; u <= c; u++)
        n[u - s] += d;
    }
  }
  _renderNormalDecorations(e, t, n) {
    var s;
    const o = e.visibleRange.startLineNumber;
    let r = null, a = !1, l = null, d = !1;
    for (let h = 0, c = t.length; h < c; h++) {
      const u = t[h];
      if (u.options.isWholeLine) continue;
      const g = u.options.className, p = !!u.options.showIfCollapsed;
      let f = u.range;
      p && f.endColumn === 1 && f.endLineNumber !== f.startLineNumber && (f = new D(f.startLineNumber, f.startColumn, f.endLineNumber - 1, this._context.viewModel.getLineMaxColumn(f.endLineNumber - 1))), r === g && a === p && D.areIntersectingOrTouching(l, f) ? l = D.plusRange(l, f) : (r !== null && this._renderNormalDecoration(e, l, r, d, a, o, n), r = g, a = p, l = f, d = (s = u.options.shouldFillLineOnLineBreak) !== null && s !== void 0 && s);
    }
    r !== null && this._renderNormalDecoration(e, l, r, d, a, o, n);
  }
  _renderNormalDecoration(e, t, n, s, o, r, a) {
    const l = e.linesVisibleRangesForRange(t, n === "findMatch");
    if (l) for (let d = 0, h = l.length; d < h; d++) {
      const c = l[d];
      if (c.outsideRenderedLine) continue;
      const u = c.lineNumber - r;
      if (o && c.ranges.length === 1) {
        const g = c.ranges[0];
        if (g.width < this._typicalHalfwidthCharacterWidth) {
          const p = Math.round(g.left + g.width / 2), f = Math.max(0, Math.round(p - this._typicalHalfwidthCharacterWidth / 2));
          c.ranges[0] = new lL(f, this._typicalHalfwidthCharacterWidth);
        }
      }
      for (let g = 0, p = c.ranges.length; g < p; g++) {
        const f = s && c.continuesOnNextLine && p === 1, _ = c.ranges[g], v = '<div class="cdr ' + n + '" style="left:' + String(_.left) + "px;width:" + (f ? "100%;" : String(_.width) + "px;") + '"></div>';
        a[u] += v;
      }
    }
  }
  render(e, t) {
    if (!this._renderResult) return "";
    const n = t - e;
    return n < 0 || n >= this._renderResult.length ? "" : this._renderResult[n];
  }
}
class bY extends to {
  constructor(e, t, n, s) {
    super(e);
    const o = this._context.configuration.options, r = o.get(103), a = o.get(75), l = o.get(40), d = o.get(106), h = { listenOnDomNode: n.domNode, className: "editor-scrollable " + iI(e.theme.type), useShadows: !1, lazyRender: !0, vertical: r.vertical, horizontal: r.horizontal, verticalHasArrows: r.verticalHasArrows, horizontalHasArrows: r.horizontalHasArrows, verticalScrollbarSize: r.verticalScrollbarSize, verticalSliderSize: r.verticalSliderSize, horizontalScrollbarSize: r.horizontalScrollbarSize, horizontalSliderSize: r.horizontalSliderSize, handleMouseWheel: r.handleMouseWheel, alwaysConsumeMouseWheel: r.alwaysConsumeMouseWheel, arrowSize: r.arrowSize, mouseWheelScrollSensitivity: a, fastScrollSensitivity: l, scrollPredominantAxis: d, scrollByPage: r.scrollByPage };
    this.scrollbar = this._register(new dL(t.domNode, h, this._context.viewLayout.getScrollable())), _a.write(this.scrollbar.getDomNode(), 6), this.scrollbarDomNode = wt(this.scrollbar.getDomNode()), this.scrollbarDomNode.setPosition("absolute"), this._setLayout();
    const c = (u, g, p) => {
      const f = {};
      {
        const _ = u.scrollTop;
        _ && (f.scrollTop = this._context.viewLayout.getCurrentScrollTop() + _, u.scrollTop = 0);
      }
      if (p) {
        const _ = u.scrollLeft;
        _ && (f.scrollLeft = this._context.viewLayout.getCurrentScrollLeft() + _, u.scrollLeft = 0);
      }
      this._context.viewModel.viewLayout.setScrollPosition(f, 1);
    };
    this._register(K(n.domNode, "scroll", (u) => c(n.domNode, 0, !0))), this._register(K(t.domNode, "scroll", (u) => c(t.domNode, 0, !1))), this._register(K(s.domNode, "scroll", (u) => c(s.domNode, 0, !1))), this._register(K(this.scrollbarDomNode.domNode, "scroll", (u) => c(this.scrollbarDomNode.domNode, 0, !1)));
  }
  dispose() {
    super.dispose();
  }
  _setLayout() {
    const e = this._context.configuration.options, t = e.get(145);
    this.scrollbarDomNode.setLeft(t.contentLeft), e.get(73).side === "right" ? this.scrollbarDomNode.setWidth(t.contentWidth + t.minimap.minimapWidth) : this.scrollbarDomNode.setWidth(t.contentWidth), this.scrollbarDomNode.setHeight(t.height);
  }
  getOverviewRulerLayoutInfo() {
    return this.scrollbar.getOverviewRulerLayoutInfo();
  }
  getDomNode() {
    return this.scrollbarDomNode;
  }
  delegateVerticalScrollbarPointerDown(e) {
    this.scrollbar.delegateVerticalScrollbarPointerDown(e);
  }
  delegateScrollFromMouseWheelEvent(e) {
    this.scrollbar.delegateScrollFromMouseWheelEvent(e);
  }
  onConfigurationChanged(e) {
    if (e.hasChanged(103) || e.hasChanged(75) || e.hasChanged(40)) {
      const t = this._context.configuration.options, n = t.get(103), s = t.get(75), o = t.get(40), r = t.get(106), a = { vertical: n.vertical, horizontal: n.horizontal, verticalScrollbarSize: n.verticalScrollbarSize, horizontalScrollbarSize: n.horizontalScrollbarSize, scrollByPage: n.scrollByPage, handleMouseWheel: n.handleMouseWheel, mouseWheelScrollSensitivity: s, fastScrollSensitivity: o, scrollPredominantAxis: r };
      this.scrollbar.updateOptions(a);
    }
    return e.hasChanged(145) && this._setLayout(), !0;
  }
  onScrollChanged(e) {
    return !0;
  }
  onThemeChanged(e) {
    return this.scrollbar.updateClassName("editor-scrollable " + iI(this._context.theme.type)), !0;
  }
  prepareRender(e) {
  }
  render(e) {
    this.scrollbar.renderNow();
  }
}
class oI {
  constructor(e, t, n, s, o) {
    this.startLineNumber = e, this.endLineNumber = t, this.className = n, this.tooltip = s, this._decorationToRenderBrand = void 0, this.zIndex = o ?? 0;
  }
}
class CY {
  constructor(e, t, n) {
    this.className = e, this.zIndex = t, this.tooltip = n;
  }
}
class wY {
  constructor() {
    this.decorations = [];
  }
  add(e) {
    this.decorations.push(e);
  }
  getDecorations() {
    return this.decorations;
  }
}
class KB extends Mg {
  _render(e, t, n) {
    const s = [];
    for (let a = e; a <= t; a++)
      s[a - e] = new wY();
    if (n.length === 0) return s;
    n.sort((a, l) => a.className === l.className ? a.startLineNumber === l.startLineNumber ? a.endLineNumber - l.endLineNumber : a.startLineNumber - l.startLineNumber : a.className < l.className ? -1 : 1);
    let o = null, r = 0;
    for (let a = 0, l = n.length; a < l; a++) {
      const d = n[a], h = d.className, c = d.zIndex;
      let u = Math.max(d.startLineNumber, e) - e;
      const g = Math.min(d.endLineNumber, t) - e;
      o === h ? (u = Math.max(r + 1, u), r = Math.max(r, g)) : (o = h, r = g);
      for (let p = u; p <= r; p++) s[p].add(new CY(h, c, d.tooltip));
    }
    return s;
  }
}
class yY extends to {
  constructor(e) {
    super(e), this._widgets = {}, this._context = e;
    const t = this._context.configuration.options, n = t.get(145);
    this.domNode = wt(document.createElement("div")), this.domNode.setClassName("glyph-margin-widgets"), this.domNode.setPosition("absolute"), this.domNode.setTop(0), this._lineHeight = t.get(67), this._glyphMargin = t.get(57), this._glyphMarginLeft = n.glyphMarginLeft, this._glyphMarginWidth = n.glyphMarginWidth, this._glyphMarginDecorationLaneCount = n.glyphMarginDecorationLaneCount, this._managedDomNodes = [], this._decorationGlyphsToRender = [];
  }
  dispose() {
    this._managedDomNodes = [], this._decorationGlyphsToRender = [], this._widgets = {}, super.dispose();
  }
  getWidgets() {
    return Object.values(this._widgets);
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, n = t.get(145);
    return this._lineHeight = t.get(67), this._glyphMargin = t.get(57), this._glyphMarginLeft = n.glyphMarginLeft, this._glyphMarginWidth = n.glyphMarginWidth, this._glyphMarginDecorationLaneCount = n.glyphMarginDecorationLaneCount, !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  addWidget(e) {
    const t = wt(e.getDomNode());
    this._widgets[e.getId()] = { widget: e, preference: e.getPosition(), domNode: t, renderInfo: null }, t.setPosition("absolute"), t.setDisplay("none"), t.setAttribute("widgetId", e.getId()), this.domNode.appendChild(t), this.setShouldRender();
  }
  setWidgetPosition(e, t) {
    const n = this._widgets[e.getId()];
    return (n.preference.lane !== t.lane || n.preference.zIndex !== t.zIndex || !D.equalsRange(n.preference.range, t.range)) && (n.preference = t, this.setShouldRender(), !0);
  }
  removeWidget(e) {
    var t;
    const n = e.getId();
    if (this._widgets[n]) {
      const s = this._widgets[n].domNode.domNode;
      delete this._widgets[n], (t = s.parentNode) === null || t === void 0 || t.removeChild(s), this.setShouldRender();
    }
  }
  _collectDecorationBasedGlyphRenderRequest(e, t) {
    var n, s, o;
    const r = e.visibleRange.startLineNumber, a = e.visibleRange.endLineNumber, l = e.getDecorationsInViewport();
    for (const d of l) {
      const h = d.options.glyphMarginClassName;
      if (!h) continue;
      const c = Math.max(d.range.startLineNumber, r), u = Math.min(d.range.endLineNumber, a), g = (s = (n = d.options.glyphMargin) === null || n === void 0 ? void 0 : n.position) !== null && s !== void 0 ? s : _l.Center, p = (o = d.options.zIndex) !== null && o !== void 0 ? o : 0;
      for (let f = c; f <= u; f++) {
        const _ = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new W(f, 0)), v = this._context.viewModel.glyphLanes.getLanesAtLine(_.lineNumber).indexOf(g);
        t.push(new SY(f, v, p, h));
      }
    }
  }
  _collectWidgetBasedGlyphRenderRequest(e, t) {
    const n = e.visibleRange.startLineNumber, s = e.visibleRange.endLineNumber;
    for (const o of Object.values(this._widgets)) {
      const r = o.preference.range, { startLineNumber: a, endLineNumber: l } = this._context.viewModel.coordinatesConverter.convertModelRangeToViewRange(D.lift(r));
      if (!a || !l || l < n || a > s) continue;
      const d = Math.max(a, n), h = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new W(d, 0)), c = this._context.viewModel.glyphLanes.getLanesAtLine(h.lineNumber).indexOf(o.preference.lane);
      t.push(new LY(d, c, o.preference.zIndex, o));
    }
  }
  _collectSortedGlyphRenderRequests(e) {
    const t = [];
    return this._collectDecorationBasedGlyphRenderRequest(e, t), this._collectWidgetBasedGlyphRenderRequest(e, t), t.sort((n, s) => n.lineNumber === s.lineNumber ? n.laneIndex === s.laneIndex ? n.zIndex === s.zIndex ? s.type === n.type ? n.type === 0 && s.type === 0 ? n.className < s.className ? -1 : 1 : 0 : s.type - n.type : s.zIndex - n.zIndex : n.laneIndex - s.laneIndex : n.lineNumber - s.lineNumber), t;
  }
  prepareRender(e) {
    if (!this._glyphMargin) return void (this._decorationGlyphsToRender = []);
    for (const s of Object.values(this._widgets)) s.renderInfo = null;
    const t = new Pd(this._collectSortedGlyphRenderRequests(e)), n = [];
    for (; t.length > 0; ) {
      const s = t.peek();
      if (!s) break;
      const o = t.takeWhile((a) => a.lineNumber === s.lineNumber && a.laneIndex === s.laneIndex);
      if (!o || o.length === 0) break;
      const r = o[0];
      if (r.type === 0) {
        const a = [];
        for (const l of o) {
          if (l.zIndex !== r.zIndex || l.type !== r.type) break;
          a.length !== 0 && a[a.length - 1] === l.className || a.push(l.className);
        }
        n.push(r.accept(a.join(" ")));
      } else r.widget.renderInfo = { lineNumber: r.lineNumber, laneIndex: r.laneIndex };
    }
    this._decorationGlyphsToRender = n;
  }
  render(e) {
    if (!this._glyphMargin) {
      for (const n of Object.values(this._widgets)) n.domNode.setDisplay("none");
      for (; this._managedDomNodes.length > 0; ) {
        const n = this._managedDomNodes.pop();
        n == null || n.domNode.remove();
      }
      return;
    }
    const t = Math.round(this._glyphMarginWidth / this._glyphMarginDecorationLaneCount);
    for (const n of Object.values(this._widgets)) if (n.renderInfo) {
      const s = e.viewportData.relativeVerticalOffset[n.renderInfo.lineNumber - e.viewportData.startLineNumber], o = this._glyphMarginLeft + n.renderInfo.laneIndex * this._lineHeight;
      n.domNode.setDisplay("block"), n.domNode.setTop(s), n.domNode.setLeft(o), n.domNode.setWidth(t), n.domNode.setHeight(this._lineHeight);
    } else n.domNode.setDisplay("none");
    for (let n = 0; n < this._decorationGlyphsToRender.length; n++) {
      const s = this._decorationGlyphsToRender[n], o = e.viewportData.relativeVerticalOffset[s.lineNumber - e.viewportData.startLineNumber], r = this._glyphMarginLeft + s.laneIndex * this._lineHeight;
      let a;
      n < this._managedDomNodes.length ? a = this._managedDomNodes[n] : (a = wt(document.createElement("div")), this._managedDomNodes.push(a), this.domNode.appendChild(a)), a.setClassName("cgmr codicon " + s.combinedClassName), a.setPosition("absolute"), a.setTop(o), a.setLeft(r), a.setWidth(t), a.setHeight(this._lineHeight);
    }
    for (; this._managedDomNodes.length > this._decorationGlyphsToRender.length; ) {
      const n = this._managedDomNodes.pop();
      n == null || n.domNode.remove();
    }
  }
}
class SY {
  constructor(e, t, n, s) {
    this.lineNumber = e, this.laneIndex = t, this.zIndex = n, this.className = s, this.type = 0;
  }
  accept(e) {
    return new kY(this.lineNumber, this.laneIndex, e);
  }
}
class LY {
  constructor(e, t, n, s) {
    this.lineNumber = e, this.laneIndex = t, this.zIndex = n, this.widget = s, this.type = 1;
  }
}
class kY {
  constructor(e, t, n) {
    this.lineNumber = e, this.laneIndex = t, this.combinedClassName = n;
  }
}
class jB extends V {
  constructor() {
    super(...arguments), this._isDisposed = !1;
  }
  dispose() {
    super.dispose(), this._isDisposed = !0;
  }
  assertNotDisposed() {
    if (this._isDisposed) throw new Error("TextModelPart is disposed!");
  }
}
function uL(i, e) {
  let t = 0, n = 0;
  const s = i.length;
  for (; n < s; ) {
    const o = i.charCodeAt(n);
    if (o === 32) t++;
    else {
      if (o !== 9) break;
      t = t - t % e + e;
    }
    n++;
  }
  return n === s ? -1 : t;
}
(function(i) {
  i[i.Disabled = 0] = "Disabled", i[i.EnabledForActive = 1] = "EnabledForActive", i[i.Enabled = 2] = "Enabled";
})(qu || (qu = {}));
class Tu {
  constructor(e, t, n, s, o, r) {
    if (this.visibleColumn = e, this.column = t, this.className = n, this.horizontalLine = s, this.forWrappedLinesAfterColumn = o, this.forWrappedLinesBeforeOrAtColumn = r, e !== -1 == (t !== -1)) throw new Error();
  }
}
class s0 {
  constructor(e, t) {
    this.top = e, this.endColumn = t;
  }
}
class DY extends jB {
  constructor(e, t) {
    super(), this.textModel = e, this.languageConfigurationService = t;
  }
  getLanguageConfiguration(e) {
    return this.languageConfigurationService.getLanguageConfiguration(e);
  }
  _computeIndentLevel(e) {
    return uL(this.textModel.getLineContent(e + 1), this.textModel.getOptions().tabSize);
  }
  getActiveIndentGuide(e, t, n) {
    this.assertNotDisposed();
    const s = this.textModel.getLineCount();
    if (e < 1 || e > s) throw new Kt("Illegal value for lineNumber");
    const o = this.getLanguageConfiguration(this.textModel.getLanguageId()).foldingRules, r = !!(o && o.offSide);
    let a = -2, l = -1, d = -2, h = -1;
    const c = (k) => {
      if (a !== -1 && (a === -2 || a > k - 1)) {
        a = -1, l = -1;
        for (let N = k - 2; N >= 0; N--) {
          const A = this._computeIndentLevel(N);
          if (A >= 0) {
            a = N, l = A;
            break;
          }
        }
      }
      if (d === -2) {
        d = -1, h = -1;
        for (let N = k; N < s; N++) {
          const A = this._computeIndentLevel(N);
          if (A >= 0) {
            d = N, h = A;
            break;
          }
        }
      }
    };
    let u = -2, g = -1, p = -2, f = -1;
    const _ = (k) => {
      if (u === -2) {
        u = -1, g = -1;
        for (let N = k - 2; N >= 0; N--) {
          const A = this._computeIndentLevel(N);
          if (A >= 0) {
            u = N, g = A;
            break;
          }
        }
      }
      if (p !== -1 && (p === -2 || p < k - 1)) {
        p = -1, f = -1;
        for (let N = k; N < s; N++) {
          const A = this._computeIndentLevel(N);
          if (A >= 0) {
            p = N, f = A;
            break;
          }
        }
      }
    };
    let v = 0, b = !0, C = 0, w = !0, y = 0, L = 0;
    for (let k = 0; b || w; k++) {
      const N = e - k, A = e + k;
      k > 1 && (N < 1 || N < t) && (b = !1), k > 1 && (A > s || A > n) && (w = !1), k > 5e4 && (b = !1, w = !1);
      let B = -1;
      if (b && N >= 1) {
        const O = this._computeIndentLevel(N - 1);
        O >= 0 ? (d = N - 1, h = O, B = Math.ceil(O / this.textModel.getOptions().indentSize)) : (c(N), B = this._getIndentLevelForWhitespaceLine(r, l, h));
      }
      let T = -1;
      if (w && A <= s) {
        const O = this._computeIndentLevel(A - 1);
        O >= 0 ? (u = A - 1, g = O, T = Math.ceil(O / this.textModel.getOptions().indentSize)) : (_(A), T = this._getIndentLevelForWhitespaceLine(r, g, f));
      }
      if (k !== 0) {
        if (k === 1) {
          if (A <= s && T >= 0 && L + 1 === T) {
            b = !1, v = A, C = A, y = T;
            continue;
          }
          if (N >= 1 && B >= 0 && B - 1 === L) {
            w = !1, v = N, C = N, y = B;
            continue;
          }
          if (v = e, C = e, y = L, y === 0) return { startLineNumber: v, endLineNumber: C, indent: y };
        }
        b && (B >= y ? v = N : b = !1), w && (T >= y ? C = A : w = !1);
      } else L = B;
    }
    return { startLineNumber: v, endLineNumber: C, indent: y };
  }
  getLinesBracketGuides(e, t, n, s) {
    var o;
    const r = [];
    for (let c = e; c <= t; c++) r.push([]);
    const a = this.textModel.bracketPairs.getBracketPairsInRangeWithMinIndentation(new D(e, 1, t, this.textModel.getLineMaxColumn(t))).toArray();
    let l;
    n && a.length > 0 && (l = (o = sv((e <= n.lineNumber && n.lineNumber <= t ? a : this.textModel.bracketPairs.getBracketPairsInRange(D.fromPositions(n)).toArray()).filter((c) => D.strictContainsPosition(c.range, n)), (c) => !0)) === null || o === void 0 ? void 0 : o.range);
    const d = this.textModel.getOptions().bracketPairColorizationOptions.independentColorPoolPerBracketType, h = new qB();
    for (const c of a) {
      if (!c.closingBracketRange) continue;
      const u = l && c.range.equalsRange(l);
      if (!u && !s.includeInactive) continue;
      const g = h.getInlineClassName(c.nestingLevel, c.nestingLevelOfEqualBracketType, d) + (s.highlightActive && u ? " " + h.activeClassName : ""), p = c.openingBracketRange.getStartPosition(), f = c.closingBracketRange.getStartPosition(), _ = s.horizontalGuides === qu.Enabled || s.horizontalGuides === qu.EnabledForActive && u;
      if (c.range.startLineNumber === c.range.endLineNumber) {
        _ && r[c.range.startLineNumber - e].push(new Tu(-1, c.openingBracketRange.getEndPosition().column, g, new s0(!1, f.column), -1, -1));
        continue;
      }
      const v = this.getVisibleColumnFromPosition(f), b = this.getVisibleColumnFromPosition(c.openingBracketRange.getStartPosition()), C = Math.min(b, v, c.minVisibleColumnIndentation + 1);
      let w = !1;
      Jn(this.textModel.getLineContent(c.closingBracketRange.startLineNumber)) < c.closingBracketRange.startColumn - 1 && (w = !0);
      const y = Math.max(p.lineNumber, e), L = Math.min(f.lineNumber, t), k = w ? 1 : 0;
      for (let N = y; N < L + k; N++) r[N - e].push(new Tu(C, -1, g, null, N === p.lineNumber ? p.column : -1, N === f.lineNumber ? f.column : -1));
      _ && (p.lineNumber >= e && b > C && r[p.lineNumber - e].push(new Tu(C, -1, g, new s0(!1, p.column), -1, -1)), f.lineNumber <= t && v > C && r[f.lineNumber - e].push(new Tu(C, -1, g, new s0(!w, f.column), -1, -1)));
    }
    for (const c of r) c.sort((u, g) => u.visibleColumn - g.visibleColumn);
    return r;
  }
  getVisibleColumnFromPosition(e) {
    return Gi.visibleColumnFromColumn(this.textModel.getLineContent(e.lineNumber), e.column, this.textModel.getOptions().tabSize) + 1;
  }
  getLinesIndentGuides(e, t) {
    this.assertNotDisposed();
    const n = this.textModel.getLineCount();
    if (e < 1 || e > n) throw new Error("Illegal value for startLineNumber");
    if (t < 1 || t > n) throw new Error("Illegal value for endLineNumber");
    const s = this.textModel.getOptions(), o = this.getLanguageConfiguration(this.textModel.getLanguageId()).foldingRules, r = !!(o && o.offSide), a = new Array(t - e + 1);
    let l = -2, d = -1, h = -2, c = -1;
    for (let u = e; u <= t; u++) {
      const g = u - e, p = this._computeIndentLevel(u - 1);
      if (p >= 0) l = u - 1, d = p, a[g] = Math.ceil(p / s.indentSize);
      else {
        if (l === -2) {
          l = -1, d = -1;
          for (let f = u - 2; f >= 0; f--) {
            const _ = this._computeIndentLevel(f);
            if (_ >= 0) {
              l = f, d = _;
              break;
            }
          }
        }
        if (h !== -1 && (h === -2 || h < u - 1)) {
          h = -1, c = -1;
          for (let f = u; f < n; f++) {
            const _ = this._computeIndentLevel(f);
            if (_ >= 0) {
              h = f, c = _;
              break;
            }
          }
        }
        a[g] = this._getIndentLevelForWhitespaceLine(r, d, c);
      }
    }
    return a;
  }
  _getIndentLevelForWhitespaceLine(e, t, n) {
    const s = this.textModel.getOptions();
    return t === -1 || n === -1 ? 0 : t < n ? 1 + Math.floor(t / s.indentSize) : t === n || e ? Math.ceil(n / s.indentSize) : 1 + Math.floor(n / s.indentSize);
  }
}
class qB {
  constructor() {
    this.activeClassName = "indent-active";
  }
  getInlineClassName(e, t, n) {
    return this.getInlineClassNameOfLevel(n ? t : e);
  }
  getInlineClassNameOfLevel(e) {
    return "bracket-indent-guide lvl-" + e % 30;
  }
}
class xY extends Mg {
  constructor(e) {
    super(), this._context = e, this._primaryPosition = null;
    const t = this._context.configuration.options, n = t.get(146), s = t.get(50);
    this._spaceWidth = s.spaceWidth, this._maxIndentLeft = n.wrappingColumn === -1 ? -1 : n.wrappingColumn * s.typicalHalfwidthCharacterWidth, this._bracketPairGuideOptions = t.get(16), this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, n = t.get(146), s = t.get(50);
    return this._spaceWidth = s.spaceWidth, this._maxIndentLeft = n.wrappingColumn === -1 ? -1 : n.wrappingColumn * s.typicalHalfwidthCharacterWidth, this._bracketPairGuideOptions = t.get(16), !0;
  }
  onCursorStateChanged(e) {
    var t;
    const n = e.selections[0].getPosition();
    return !(!((t = this._primaryPosition) === null || t === void 0) && t.equals(n)) && (this._primaryPosition = n, !0);
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  onLanguageConfigurationChanged(e) {
    return !0;
  }
  prepareRender(e) {
    var t, n, s, o;
    if (!this._bracketPairGuideOptions.indentation && this._bracketPairGuideOptions.bracketPairs === !1) return void (this._renderResult = null);
    const r = e.visibleRange.startLineNumber, a = e.visibleRange.endLineNumber, l = e.scrollWidth, d = this._primaryPosition, h = this.getGuidesByLine(r, Math.min(a + 1, this._context.viewModel.getLineCount()), d), c = [];
    for (let u = r; u <= a; u++) {
      const g = u - r, p = h[g];
      let f = "";
      const _ = (n = (t = e.visibleRangeForPosition(new W(u, 1))) === null || t === void 0 ? void 0 : t.left) !== null && n !== void 0 ? n : 0;
      for (const v of p) {
        const b = v.column === -1 ? _ + (v.visibleColumn - 1) * this._spaceWidth : e.visibleRangeForPosition(new W(u, v.column)).left;
        if (b > l || this._maxIndentLeft > 0 && b > this._maxIndentLeft) break;
        const C = v.horizontalLine ? v.horizontalLine.top ? "horizontal-top" : "horizontal-bottom" : "vertical", w = v.horizontalLine ? ((o = (s = e.visibleRangeForPosition(new W(u, v.horizontalLine.endColumn))) === null || s === void 0 ? void 0 : s.left) !== null && o !== void 0 ? o : b + this._spaceWidth) - b : this._spaceWidth;
        f += `<div class="core-guide ${v.className} ${C}" style="left:${b}px;width:${w}px"></div>`;
      }
      c[g] = f;
    }
    this._renderResult = c;
  }
  getGuidesByLine(e, t, n) {
    const s = this._bracketPairGuideOptions.bracketPairs !== !1 ? this._context.viewModel.getBracketGuidesInRangeByLine(e, t, n, { highlightActive: this._bracketPairGuideOptions.highlightActiveBracketPair, horizontalGuides: this._bracketPairGuideOptions.bracketPairsHorizontal === !0 ? qu.Enabled : this._bracketPairGuideOptions.bracketPairsHorizontal === "active" ? qu.EnabledForActive : qu.Disabled, includeInactive: this._bracketPairGuideOptions.bracketPairs === !0 }) : null, o = this._bracketPairGuideOptions.indentation ? this._context.viewModel.getLinesIndentGuides(e, t) : null;
    let r = 0, a = 0, l = 0;
    if (this._bracketPairGuideOptions.highlightActiveIndentation !== !1 && n) {
      const c = this._context.viewModel.getActiveIndentGuide(n.lineNumber, e, t);
      r = c.startLineNumber, a = c.endLineNumber, l = c.indent;
    }
    const { indentSize: d } = this._context.viewModel.model.getOptions(), h = [];
    for (let c = e; c <= t; c++) {
      const u = new Array();
      h.push(u);
      const g = s ? s[c - e] : [], p = new Pd(g), f = o ? o[c - e] : 0;
      for (let _ = 1; _ <= f; _++) {
        const v = (_ - 1) * d + 1, b = (this._bracketPairGuideOptions.highlightActiveIndentation === "always" || g.length === 0) && r <= c && c <= a && _ === l;
        u.push(...p.takeWhile((w) => w.visibleColumn < v) || []);
        const C = p.peek();
        C && C.visibleColumn === v && !C.horizontalLine || u.push(new Tu(v, -1, "core-guide-indent lvl-" + (_ - 1) % 30 + (b ? " indent-active" : ""), null, -1, -1));
      }
      u.push(...p.takeWhile((_) => !0) || []);
    }
    return h;
  }
  render(e, t) {
    if (!this._renderResult) return "";
    const n = t - e;
    return n < 0 || n >= this._renderResult.length ? "" : this._renderResult[n];
  }
}
function Zg(i) {
  if (!i || !i.isTransparent()) return i;
}
rr((i, e) => {
  const t = [{ bracketColor: MB, guideColor: FZ, guideColorActive: UZ }, { bracketColor: TB, guideColor: BZ, guideColorActive: KZ }, { bracketColor: RB, guideColor: WZ, guideColorActive: jZ }, { bracketColor: AB, guideColor: VZ, guideColorActive: qZ }, { bracketColor: PB, guideColor: HZ, guideColorActive: $Z }, { bracketColor: OB, guideColor: zZ, guideColorActive: GZ }], n = new qB(), s = [{ indentColor: D1, indentColorActive: x1 }, { indentColor: bZ, indentColorActive: LZ }, { indentColor: CZ, indentColorActive: kZ }, { indentColor: wZ, indentColorActive: DZ }, { indentColor: yZ, indentColorActive: xZ }, { indentColor: SZ, indentColorActive: NZ }], o = t.map((a) => {
    var l, d;
    const h = i.getColor(a.bracketColor), c = i.getColor(a.guideColor), u = i.getColor(a.guideColorActive), g = Zg((l = Zg(c)) !== null && l !== void 0 ? l : h == null ? void 0 : h.transparent(0.3)), p = Zg((d = Zg(u)) !== null && d !== void 0 ? d : h);
    if (g && p) return { guideColor: g, guideColorActive: p };
  }).filter(cl), r = s.map((a) => {
    const l = i.getColor(a.indentColor), d = i.getColor(a.indentColorActive), h = Zg(l), c = Zg(d);
    if (h && c) return { indentColor: h, indentColorActive: c };
  }).filter(cl);
  if (o.length > 0) {
    for (let a = 0; a < 30; a++) {
      const l = o[a % o.length];
      e.addRule(`.monaco-editor .${n.getInlineClassNameOfLevel(a).replace(/ /g, ".")} { --guide-color: ${l.guideColor}; --guide-color-active: ${l.guideColorActive}; }`);
    }
    e.addRule(".monaco-editor .vertical { box-shadow: 1px 0 0 0 var(--guide-color) inset; }"), e.addRule(".monaco-editor .horizontal-top { border-top: 1px solid var(--guide-color); }"), e.addRule(".monaco-editor .horizontal-bottom { border-bottom: 1px solid var(--guide-color); }"), e.addRule(`.monaco-editor .vertical.${n.activeClassName} { box-shadow: 1px 0 0 0 var(--guide-color-active) inset; }`), e.addRule(`.monaco-editor .horizontal-top.${n.activeClassName} { border-top: 1px solid var(--guide-color-active); }`), e.addRule(`.monaco-editor .horizontal-bottom.${n.activeClassName} { border-bottom: 1px solid var(--guide-color-active); }`);
  }
  if (r.length > 0) {
    for (let a = 0; a < 30; a++) {
      const l = r[a % r.length];
      e.addRule(`.monaco-editor .lines-content .core-guide-indent.lvl-${a} { --indent-color: ${l.indentColor}; --indent-color-active: ${l.indentColorActive}; }`);
    }
    e.addRule(".monaco-editor .lines-content .core-guide-indent { box-shadow: 1px 0 0 0 var(--indent-color) inset; }"), e.addRule(".monaco-editor .lines-content .core-guide-indent.indent-active { box-shadow: 1px 0 0 0 var(--indent-color-active) inset; }");
  }
});
class CD {
  get didDomLayout() {
    return this._didDomLayout;
  }
  readClientRect() {
    if (!this._clientRectRead) {
      this._clientRectRead = !0;
      const e = this._domNode.getBoundingClientRect();
      this.markDidDomLayout(), this._clientRectDeltaLeft = e.left, this._clientRectScale = e.width / this._domNode.offsetWidth;
    }
  }
  get clientRectDeltaLeft() {
    return this._clientRectRead || this.readClientRect(), this._clientRectDeltaLeft;
  }
  get clientRectScale() {
    return this._clientRectRead || this.readClientRect(), this._clientRectScale;
  }
  constructor(e, t) {
    this._domNode = e, this.endNode = t, this._didDomLayout = !1, this._clientRectDeltaLeft = 0, this._clientRectScale = 1, this._clientRectRead = !1;
  }
  markDidDomLayout() {
    this._didDomLayout = !0;
  }
}
class NY {
  constructor() {
    this._currentVisibleRange = new D(1, 1, 1, 1);
  }
  getCurrentVisibleRange() {
    return this._currentVisibleRange;
  }
  setCurrentVisibleRange(e) {
    this._currentVisibleRange = e;
  }
}
class EY {
  constructor(e, t, n, s, o, r, a) {
    this.minimalReveal = e, this.lineNumber = t, this.startColumn = n, this.endColumn = s, this.startScrollTop = o, this.stopScrollTop = r, this.scrollType = a, this.type = "range", this.minLineNumber = t, this.maxLineNumber = t;
  }
}
class IY {
  constructor(e, t, n, s, o) {
    this.minimalReveal = e, this.selections = t, this.startScrollTop = n, this.stopScrollTop = s, this.scrollType = o, this.type = "selections";
    let r = t[0].startLineNumber, a = t[0].endLineNumber;
    for (let l = 1, d = t.length; l < d; l++) {
      const h = t[l];
      r = Math.min(r, h.startLineNumber), a = Math.max(a, h.endLineNumber);
    }
    this.minLineNumber = r, this.maxLineNumber = a;
  }
}
class gL extends to {
  constructor(e, t) {
    super(e), this._linesContent = t, this._textRangeRestingSpot = document.createElement("div"), this._visibleLines = new HB(this), this.domNode = this._visibleLines.domNode;
    const n = this._context.configuration, s = this._context.configuration.options, o = s.get(50), r = s.get(146);
    this._lineHeight = s.get(67), this._typicalHalfwidthCharacterWidth = o.typicalHalfwidthCharacterWidth, this._isViewportWrapping = r.isViewportWrapping, this._revealHorizontalRightPadding = s.get(100), this._cursorSurroundingLines = s.get(29), this._cursorSurroundingLinesStyle = s.get(30), this._canUseLayerHinting = !s.get(32), this._viewLineOptions = new K4(n, this._context.theme.type), _a.write(this.domNode, 8), this.domNode.setClassName(`view-lines ${om}`), yn(this.domNode, o), this._maxLineWidth = 0, this._asyncUpdateLineWidths = new It(() => {
      this._updateLineWidthsSlow();
    }, 200), this._asyncCheckMonospaceFontAssumptions = new It(() => {
      this._checkMonospaceFontAssumptions();
    }, 2e3), this._lastRenderedData = new NY(), this._horizontalRevealRequest = null, this._stickyScrollEnabled = s.get(115).enabled, this._maxNumberStickyLines = s.get(115).maxLineCount;
  }
  dispose() {
    this._asyncUpdateLineWidths.dispose(), this._asyncCheckMonospaceFontAssumptions.dispose(), super.dispose();
  }
  getDomNode() {
    return this.domNode;
  }
  createVisibleLine() {
    return new Ga(this._viewLineOptions);
  }
  onConfigurationChanged(e) {
    this._visibleLines.onConfigurationChanged(e), e.hasChanged(146) && (this._maxLineWidth = 0);
    const t = this._context.configuration.options, n = t.get(50), s = t.get(146);
    return this._lineHeight = t.get(67), this._typicalHalfwidthCharacterWidth = n.typicalHalfwidthCharacterWidth, this._isViewportWrapping = s.isViewportWrapping, this._revealHorizontalRightPadding = t.get(100), this._cursorSurroundingLines = t.get(29), this._cursorSurroundingLinesStyle = t.get(30), this._canUseLayerHinting = !t.get(32), this._stickyScrollEnabled = t.get(115).enabled, this._maxNumberStickyLines = t.get(115).maxLineCount, yn(this.domNode, n), this._onOptionsMaybeChanged(), e.hasChanged(145) && (this._maxLineWidth = 0), !0;
  }
  _onOptionsMaybeChanged() {
    const e = this._context.configuration, t = new K4(e, this._context.theme.type);
    if (!this._viewLineOptions.equals(t)) {
      this._viewLineOptions = t;
      const n = this._visibleLines.getStartLineNumber(), s = this._visibleLines.getEndLineNumber();
      for (let o = n; o <= s; o++)
        this._visibleLines.getVisibleLine(o).onOptionsChanged(this._viewLineOptions);
      return !0;
    }
    return !1;
  }
  onCursorStateChanged(e) {
    const t = this._visibleLines.getStartLineNumber(), n = this._visibleLines.getEndLineNumber();
    let s = !1;
    for (let o = t; o <= n; o++) s = this._visibleLines.getVisibleLine(o).onSelectionChanged() || s;
    return s;
  }
  onDecorationsChanged(e) {
    {
      const t = this._visibleLines.getStartLineNumber(), n = this._visibleLines.getEndLineNumber();
      for (let s = t; s <= n; s++) this._visibleLines.getVisibleLine(s).onDecorationsChanged();
    }
    return !0;
  }
  onFlushed(e) {
    const t = this._visibleLines.onFlushed(e);
    return this._maxLineWidth = 0, t;
  }
  onLinesChanged(e) {
    return this._visibleLines.onLinesChanged(e);
  }
  onLinesDeleted(e) {
    return this._visibleLines.onLinesDeleted(e);
  }
  onLinesInserted(e) {
    return this._visibleLines.onLinesInserted(e);
  }
  onRevealRangeRequest(e) {
    const t = this._computeScrollTopToRevealRange(this._context.viewLayout.getFutureViewport(), e.source, e.minimalReveal, e.range, e.selections, e.verticalType);
    if (t === -1) return !1;
    let n = this._context.viewLayout.validateScrollPosition({ scrollTop: t });
    e.revealHorizontal ? e.range && e.range.startLineNumber !== e.range.endLineNumber ? n = { scrollTop: n.scrollTop, scrollLeft: 0 } : e.range ? this._horizontalRevealRequest = new EY(e.minimalReveal, e.range.startLineNumber, e.range.startColumn, e.range.endColumn, this._context.viewLayout.getCurrentScrollTop(), n.scrollTop, e.scrollType) : e.selections && e.selections.length > 0 && (this._horizontalRevealRequest = new IY(e.minimalReveal, e.selections, this._context.viewLayout.getCurrentScrollTop(), n.scrollTop, e.scrollType)) : this._horizontalRevealRequest = null;
    const s = Math.abs(this._context.viewLayout.getCurrentScrollTop() - n.scrollTop) <= this._lineHeight ? 1 : e.scrollType;
    return this._context.viewModel.viewLayout.setScrollPosition(n, s), !0;
  }
  onScrollChanged(e) {
    if (this._horizontalRevealRequest && e.scrollLeftChanged && (this._horizontalRevealRequest = null), this._horizontalRevealRequest && e.scrollTopChanged) {
      const t = Math.min(this._horizontalRevealRequest.startScrollTop, this._horizontalRevealRequest.stopScrollTop), n = Math.max(this._horizontalRevealRequest.startScrollTop, this._horizontalRevealRequest.stopScrollTop);
      (e.scrollTop < t || e.scrollTop > n) && (this._horizontalRevealRequest = null);
    }
    return this.domNode.setWidth(e.scrollWidth), this._visibleLines.onScrollChanged(e) || !0;
  }
  onTokensChanged(e) {
    return this._visibleLines.onTokensChanged(e);
  }
  onZonesChanged(e) {
    return this._context.viewModel.viewLayout.setMaxLineWidth(this._maxLineWidth), this._visibleLines.onZonesChanged(e);
  }
  onThemeChanged(e) {
    return this._onOptionsMaybeChanged();
  }
  getPositionFromDOMInfo(e, t) {
    const n = this._getViewLineDomNode(e);
    if (n === null) return null;
    const s = this._getLineNumberFor(n);
    if (s === -1 || s < 1 || s > this._context.viewModel.getLineCount()) return null;
    if (this._context.viewModel.getLineMaxColumn(s) === 1) return new W(s, 1);
    const o = this._visibleLines.getStartLineNumber(), r = this._visibleLines.getEndLineNumber();
    if (s < o || s > r) return null;
    let a = this._visibleLines.getVisibleLine(s).getColumnOfNodeOffset(e, t);
    const l = this._context.viewModel.getLineMinColumn(s);
    return a < l && (a = l), new W(s, a);
  }
  _getViewLineDomNode(e) {
    for (; e && e.nodeType === 1; ) {
      if (e.className === Ga.CLASS_NAME) return e;
      e = e.parentElement;
    }
    return null;
  }
  _getLineNumberFor(e) {
    const t = this._visibleLines.getStartLineNumber(), n = this._visibleLines.getEndLineNumber();
    for (let s = t; s <= n; s++)
      if (e === this._visibleLines.getVisibleLine(s).getDomNode()) return s;
    return -1;
  }
  getLineWidth(e) {
    const t = this._visibleLines.getStartLineNumber(), n = this._visibleLines.getEndLineNumber();
    if (e < t || e > n) return -1;
    const s = new CD(this.domNode.domNode, this._textRangeRestingSpot), o = this._visibleLines.getVisibleLine(e).getWidth(s);
    return this._updateLineWidthsSlowIfDomDidLayout(s), o;
  }
  linesVisibleRangesForRange(e, t) {
    if (this.shouldRender()) return null;
    const n = e.endLineNumber, s = D.intersectRanges(e, this._lastRenderedData.getCurrentVisibleRange());
    if (!s) return null;
    const o = [];
    let r = 0;
    const a = new CD(this.domNode.domNode, this._textRangeRestingSpot);
    let l = 0;
    t && (l = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new W(s.startLineNumber, 1)).lineNumber);
    const d = this._visibleLines.getStartLineNumber(), h = this._visibleLines.getEndLineNumber();
    for (let c = s.startLineNumber; c <= s.endLineNumber; c++) {
      if (c < d || c > h) continue;
      const u = c === s.startLineNumber ? s.startColumn : 1, g = c !== s.endLineNumber, p = g ? this._context.viewModel.getLineMaxColumn(c) : s.endColumn, f = this._visibleLines.getVisibleLine(c).getVisibleRangesForRange(c, u, p, a);
      if (f) {
        if (t && c < n) {
          const _ = l;
          l = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new W(c + 1, 1)).lineNumber, _ !== l && (f.ranges[f.ranges.length - 1].width += this._typicalHalfwidthCharacterWidth);
        }
        o[r++] = new jG(f.outsideRenderedLine, c, lL.from(f.ranges), g);
      }
    }
    return this._updateLineWidthsSlowIfDomDidLayout(a), r === 0 ? null : o;
  }
  _visibleRangesForLineRange(e, t, n) {
    if (this.shouldRender() || e < this._visibleLines.getStartLineNumber() || e > this._visibleLines.getEndLineNumber()) return null;
    const s = new CD(this.domNode.domNode, this._textRangeRestingSpot), o = this._visibleLines.getVisibleLine(e).getVisibleRangesForRange(e, t, n, s);
    return this._updateLineWidthsSlowIfDomDidLayout(s), o;
  }
  visibleRangeForPosition(e) {
    const t = this._visibleRangesForLineRange(e.lineNumber, e.column, e.column);
    return t ? new qG(t.outsideRenderedLine, t.ranges[0].left) : null;
  }
  _updateLineWidthsFast() {
    return this._updateLineWidths(!0);
  }
  _updateLineWidthsSlow() {
    this._updateLineWidths(!1);
  }
  _updateLineWidthsSlowIfDomDidLayout(e) {
    e.didDomLayout && (this._asyncUpdateLineWidths.isScheduled() || (this._asyncUpdateLineWidths.cancel(), this._updateLineWidthsSlow()));
  }
  _updateLineWidths(e) {
    const t = this._visibleLines.getStartLineNumber(), n = this._visibleLines.getEndLineNumber();
    let s = 1, o = !0;
    for (let r = t; r <= n; r++) {
      const a = this._visibleLines.getVisibleLine(r);
      !e || a.getWidthIsFast() ? s = Math.max(s, a.getWidth(null)) : o = !1;
    }
    return o && t === 1 && n === this._context.viewModel.getLineCount() && (this._maxLineWidth = 0), this._ensureMaxLineWidth(s), o;
  }
  _checkMonospaceFontAssumptions() {
    let e = -1, t = -1;
    const n = this._visibleLines.getStartLineNumber(), s = this._visibleLines.getEndLineNumber();
    for (let o = n; o <= s; o++) {
      const r = this._visibleLines.getVisibleLine(o);
      if (r.needsMonospaceFontCheck()) {
        const a = r.getWidth(null);
        a > t && (t = a, e = o);
      }
    }
    if (e !== -1 && !this._visibleLines.getVisibleLine(e).monospaceAssumptionsAreValid()) for (let o = n; o <= s; o++)
      this._visibleLines.getVisibleLine(o).onMonospaceAssumptionsInvalidated();
  }
  prepareRender() {
    throw new Error("Not supported");
  }
  render() {
    throw new Error("Not supported");
  }
  renderText(e) {
    if (this._visibleLines.renderLines(e), this._lastRenderedData.setCurrentVisibleRange(e.visibleRange), this.domNode.setWidth(this._context.viewLayout.getScrollWidth()), this.domNode.setHeight(Math.min(this._context.viewLayout.getScrollHeight(), 1e6)), this._horizontalRevealRequest) {
      const n = this._horizontalRevealRequest;
      if (e.startLineNumber <= n.minLineNumber && n.maxLineNumber <= e.endLineNumber) {
        this._horizontalRevealRequest = null, this.onDidRender();
        const s = this._computeScrollLeftToReveal(n);
        s && (this._isViewportWrapping || this._ensureMaxLineWidth(s.maxHorizontalOffset), this._context.viewModel.viewLayout.setScrollPosition({ scrollLeft: s.scrollLeft }, n.scrollType));
      }
    }
    if (this._updateLineWidthsFast() ? this._asyncUpdateLineWidths.cancel() : this._asyncUpdateLineWidths.schedule(), Cs && !this._asyncCheckMonospaceFontAssumptions.isScheduled()) {
      const n = this._visibleLines.getStartLineNumber(), s = this._visibleLines.getEndLineNumber();
      for (let o = n; o <= s; o++)
        if (this._visibleLines.getVisibleLine(o).needsMonospaceFontCheck()) {
          this._asyncCheckMonospaceFontAssumptions.schedule();
          break;
        }
    }
    this._linesContent.setLayerHinting(this._canUseLayerHinting), this._linesContent.setContain("strict");
    const t = this._context.viewLayout.getCurrentScrollTop() - e.bigNumbersDelta;
    this._linesContent.setTop(-t), this._linesContent.setLeft(-this._context.viewLayout.getCurrentScrollLeft());
  }
  _ensureMaxLineWidth(e) {
    const t = Math.ceil(e);
    this._maxLineWidth < t && (this._maxLineWidth = t, this._context.viewModel.viewLayout.setMaxLineWidth(this._maxLineWidth));
  }
  _computeScrollTopToRevealRange(e, t, n, s, o, r) {
    const a = e.top, l = e.height, d = a + l;
    let h, c, u;
    if (o && o.length > 0) {
      let _ = o[0].startLineNumber, v = o[0].endLineNumber;
      for (let b = 1, C = o.length; b < C; b++) {
        const w = o[b];
        _ = Math.min(_, w.startLineNumber), v = Math.max(v, w.endLineNumber);
      }
      h = !1, c = this._context.viewLayout.getVerticalOffsetForLineNumber(_), u = this._context.viewLayout.getVerticalOffsetForLineNumber(v) + this._lineHeight;
    } else {
      if (!s) return -1;
      h = !0, c = this._context.viewLayout.getVerticalOffsetForLineNumber(s.startLineNumber), u = this._context.viewLayout.getVerticalOffsetForLineNumber(s.endLineNumber) + this._lineHeight;
    }
    let g, p = 0, f = 0;
    if ((t === "mouse" || n) && this._cursorSurroundingLinesStyle === "default") n || (p = this._lineHeight);
    else {
      const _ = Math.min(l / this._lineHeight / 2, this._cursorSurroundingLines);
      p = this._stickyScrollEnabled ? Math.max(_, this._maxNumberStickyLines) * this._lineHeight : _ * this._lineHeight, f = Math.max(0, _ - 1) * this._lineHeight;
    }
    if (n || r !== 0 && r !== 4 || (f += this._lineHeight), c -= p, u += f, u - c > l) {
      if (!h) return -1;
      g = c;
    } else if (r === 5 || r === 6) if (r === 6 && a <= c && u <= d) g = a;
    else {
      const _ = c - Math.max(5 * this._lineHeight, 0.2 * l), v = u - l;
      g = Math.max(v, _);
    }
    else if (r === 1 || r === 2) if (r === 2 && a <= c && u <= d) g = a;
    else {
      const _ = (c + u) / 2;
      g = Math.max(0, _ - l / 2);
    }
    else g = this._computeMinimumScrolling(a, d, c, u, r === 3, r === 4);
    return g;
  }
  _computeScrollLeftToReveal(e) {
    const t = this._context.viewLayout.getCurrentViewport(), n = this._context.configuration.options.get(145), s = t.left, o = s + t.width - n.verticalScrollbarWidth;
    let r = 1073741824, a = 0;
    if (e.type === "range") {
      const l = this._visibleRangesForLineRange(e.lineNumber, e.startColumn, e.endColumn);
      if (!l) return null;
      for (const d of l.ranges) r = Math.min(r, Math.round(d.left)), a = Math.max(a, Math.round(d.left + d.width));
    } else for (const l of e.selections) {
      if (l.startLineNumber !== l.endLineNumber) return null;
      const d = this._visibleRangesForLineRange(l.startLineNumber, l.startColumn, l.endColumn);
      if (!d) return null;
      for (const h of d.ranges) r = Math.min(r, Math.round(h.left)), a = Math.max(a, Math.round(h.left + h.width));
    }
    return e.minimalReveal || (r = Math.max(0, r - gL.HORIZONTAL_EXTRA_PX), a += this._revealHorizontalRightPadding), e.type === "selections" && a - r > t.width ? null : { scrollLeft: this._computeMinimumScrolling(s, o, r, a), maxHorizontalOffset: a };
  }
  _computeMinimumScrolling(e, t, n, s, o, r) {
    o = !!o, r = !!r;
    const a = (t |= 0) - (e |= 0);
    return (s |= 0) - (n |= 0) < a ? o ? n : r ? Math.max(0, s - a) : n < e ? n : s > t ? Math.max(0, s - a) : e : n;
  }
}
gL.HORIZONTAL_EXTRA_PX = 30;
class MY extends KB {
  constructor(e) {
    super(), this._context = e;
    const t = this._context.configuration.options.get(145);
    this._decorationsLeft = t.decorationsLeft, this._decorationsWidth = t.decorationsWidth, this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options.get(145);
    return this._decorationsLeft = t.decorationsLeft, this._decorationsWidth = t.decorationsWidth, !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  _getDecorations(e) {
    var t, n;
    const s = e.getDecorationsInViewport(), o = [];
    let r = 0;
    for (let a = 0, l = s.length; a < l; a++) {
      const d = s[a], h = d.options.linesDecorationsClassName, c = d.options.zIndex;
      h && (o[r++] = new oI(d.range.startLineNumber, d.range.endLineNumber, h, (t = d.options.linesDecorationsTooltip) !== null && t !== void 0 ? t : null, c));
      const u = d.options.firstLineDecorationClassName;
      u && (o[r++] = new oI(d.range.startLineNumber, d.range.startLineNumber, u, (n = d.options.linesDecorationsTooltip) !== null && n !== void 0 ? n : null, c));
    }
    return o;
  }
  prepareRender(e) {
    const t = e.visibleRange.startLineNumber, n = e.visibleRange.endLineNumber, s = this._render(t, n, this._getDecorations(e)), o = '" style="left:' + this._decorationsLeft.toString() + "px;width:" + this._decorationsWidth.toString() + 'px;"></div>', r = [];
    for (let a = t; a <= n; a++) {
      const l = a - t, d = s[l].getDecorations();
      let h = "";
      for (const c of d) {
        let u = '<div class="cldr ' + c.className;
        c.tooltip !== null && (u += '" title="' + c.tooltip), u += o, h += u;
      }
      r[l] = h;
    }
    this._renderResult = r;
  }
  render(e, t) {
    return this._renderResult ? this._renderResult[t - e] : "";
  }
}
class TY extends KB {
  constructor(e) {
    super(), this._context = e, this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  onConfigurationChanged(e) {
    return !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  _getDecorations(e) {
    const t = e.getDecorationsInViewport(), n = [];
    let s = 0;
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o], l = a.options.marginClassName, d = a.options.zIndex;
      l && (n[s++] = new oI(a.range.startLineNumber, a.range.endLineNumber, l, null, d));
    }
    return n;
  }
  prepareRender(e) {
    const t = e.visibleRange.startLineNumber, n = e.visibleRange.endLineNumber, s = this._render(t, n, this._getDecorations(e)), o = [];
    for (let r = t; r <= n; r++) {
      const a = r - t, l = s[a].getDecorations();
      let d = "";
      for (const h of l) d += '<div class="cmdr ' + h.className + '" style=""></div>';
      o[a] = d;
    }
    this._renderResult = o;
  }
  render(e, t) {
    return this._renderResult ? this._renderResult[t - e] : "";
  }
}
class wo {
  constructor(e, t, n, s) {
    this._rgba8Brand = void 0, this.r = wo._clamp(e), this.g = wo._clamp(t), this.b = wo._clamp(n), this.a = wo._clamp(s);
  }
  equals(e) {
    return this.r === e.r && this.g === e.g && this.b === e.b && this.a === e.a;
  }
  static _clamp(e) {
    return e < 0 ? 0 : e > 255 ? 255 : 0 | e;
  }
}
wo.Empty = new wo(0, 0, 0, 0);
class E1 extends V {
  static getInstance() {
    return this._INSTANCE || (this._INSTANCE = new E1()), this._INSTANCE;
  }
  constructor() {
    super(), this._onDidChange = new F(), this.onDidChange = this._onDidChange.event, this._updateColorMap(), this._register(ci.onDidChange((e) => {
      e.changedColorMap && this._updateColorMap();
    }));
  }
  _updateColorMap() {
    const e = ci.getColorMap();
    if (!e) return this._colors = [wo.Empty], void (this._backgroundIsLight = !0);
    this._colors = [wo.Empty];
    for (let n = 1; n < e.length; n++) {
      const s = e[n].rgba;
      this._colors[n] = new wo(s.r, s.g, s.b, Math.round(255 * s.a));
    }
    const t = e[2].getRelativeLuminance();
    this._backgroundIsLight = t >= 0.5, this._onDidChange.fire(void 0);
  }
  getColor(e) {
    return (e < 1 || e >= this._colors.length) && (e = 2), this._colors[e];
  }
  backgroundIsLight() {
    return this._backgroundIsLight;
  }
}
E1._INSTANCE = null;
const RY = (() => {
  const i = [];
  for (let e = 32; e <= 126; e++) i.push(e);
  return i.push(65533), i;
})();
class vv {
  constructor(e, t) {
    this.scale = t, this._minimapCharRendererBrand = void 0, this.charDataNormal = vv.soften(e, 0.8), this.charDataLight = vv.soften(e, 50 / 60);
  }
  static soften(e, t) {
    const n = new Uint8ClampedArray(e.length);
    for (let s = 0, o = e.length; s < o; s++) n[s] = Jw(e[s] * t);
    return n;
  }
  renderChar(e, t, n, s, o, r, a, l, d, h, c) {
    const u = 1 * this.scale, g = 2 * this.scale, p = c ? 1 : g;
    if (t + u > e.width || n + p > e.height) return void console.warn("bad render request outside image data");
    const f = h ? this.charDataLight : this.charDataNormal, _ = ((O, H) => (O -= 32) < 0 || O > 96 ? H <= 2 ? (O + 96) % 96 : 95 : O)(s, d), v = 4 * e.width, b = a.r, C = a.g, w = a.b, y = o.r - b, L = o.g - C, k = o.b - w, N = Math.max(r, l), A = e.data;
    let B = _ * u * g, T = n * v + 4 * t;
    for (let O = 0; O < p; O++) {
      let H = T;
      for (let $ = 0; $ < u; $++) {
        const pe = f[B++] / 255 * (r / 255);
        A[H++] = b + y * pe, A[H++] = C + L * pe, A[H++] = w + k * pe, A[H++] = N;
      }
      T += v;
    }
  }
  blockRenderChar(e, t, n, s, o, r, a, l) {
    const d = 1 * this.scale, h = 2 * this.scale, c = l ? 1 : h;
    if (t + d > e.width || n + c > e.height) return void console.warn("bad render request outside image data");
    const u = 4 * e.width, g = o / 255 * 0.5, p = r.r, f = r.g, _ = r.b, v = p + (s.r - p) * g, b = f + (s.g - f) * g, C = _ + (s.b - _) * g, w = Math.max(o, a), y = e.data;
    let L = n * u + 4 * t;
    for (let k = 0; k < c; k++) {
      let N = L;
      for (let A = 0; A < d; A++) y[N++] = v, y[N++] = b, y[N++] = C, y[N++] = w;
      L += u;
    }
  }
}
const t5 = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15 }, i5 = (i) => {
  const e = new Uint8ClampedArray(i.length / 2);
  for (let t = 0; t < i.length; t += 2) e[t >> 1] = t5[i[t]] << 4 | 15 & t5[i[t + 1]];
  return e;
}, n5 = { 1: mc(() => i5("0000511D6300CF609C709645A78432005642574171487021003C451900274D35D762755E8B629C5BA856AF57BA649530C167D1512A272A3F6038604460398526BCA2A968DB6F8957C768BE5FBE2FB467CF5D8D5B795DC7625B5DFF50DE64C466DB2FC47CD860A65E9A2EB96CB54CE06DA763AB2EA26860524D3763536601005116008177A8705E53AB738E6A982F88BAA35B5F5B626D9C636B449B737E5B7B678598869A662F6B5B8542706C704C80736A607578685B70594A49715A4522E792")), 2: mc(() => i5("000000000000000055394F383D2800008B8B1F210002000081B1CBCBCC820000847AAF6B9AAF2119BE08B8881AD60000A44FD07DCCF107015338130C00000000385972265F390B406E2437634B4B48031B12B8A0847000001E15B29A402F0000000000004B33460B00007A752C2A0000000000004D3900000084394B82013400ABA5CFC7AD9C0302A45A3E5A98AB000089A43382D97900008BA54AA087A70A0248A6A7AE6DBE0000BF6F94987EA40A01A06DCFA7A7A9030496C32F77891D0000A99FB1A0AFA80603B29AB9CA75930D010C0948354D3900000C0948354F37460D0028BE673D8400000000AF9D7B6E00002B007AA8933400007AA642675C2700007984CFB9C3985B768772A8A6B7B20000CAAECAAFC4B700009F94A6009F840009D09F9BA4CA9C0000CC8FC76DC87F0000C991C472A2000000A894A48CA7B501079BA2C9C69BA20000B19A5D3FA89000005CA6009DA2960901B0A7F0669FB200009D009E00B7890000DAD0F5D092820000D294D4C48BD10000B5A7A4A3B1A50402CAB6CBA6A2000000B5A7A4A3B1A8044FCDADD19D9CB00000B7778F7B8AAE0803C9AB5D3F5D3F00009EA09EA0BAB006039EA0989A8C7900009B9EF4D6B7C00000A9A7816CACA80000ABAC84705D3F000096DA635CDC8C00006F486F266F263D4784006124097B00374F6D2D6D2D6D4A3A95872322000000030000000000008D8939130000000000002E22A5C9CBC70600AB25C0B5C9B400061A2DB04CA67001082AA6BEBEBFC606002321DACBC19E03087AA08B6768380000282FBAC0B8CA7A88AD25BBA5A29900004C396C5894A6000040485A6E356E9442A32CD17EADA70000B4237923628600003E2DE9C1D7B500002F25BBA5A2990000231DB6AFB4A804023025C0B5CAB588062B2CBDBEC0C706882435A75CA20000002326BD6A82A908048B4B9A5A668000002423A09CB4BB060025259C9D8A7900001C1FCAB2C7C700002A2A9387ABA200002626A4A47D6E9D14333163A0C87500004B6F9C2D643A257049364936493647358A34438355497F1A0000A24C1D590000D38DFFBDD4CD3126")) };
class o0 {
  static create(e, t) {
    if (this.lastCreated && e === this.lastCreated.scale && t === this.lastFontFamily) return this.lastCreated;
    let n;
    return n = n5[e] ? new vv(n5[e](), e) : o0.createFromSampleData(o0.createSampleData(t).data, e), this.lastFontFamily = t, this.lastCreated = n, n;
  }
  static createSampleData(e) {
    const t = document.createElement("canvas"), n = t.getContext("2d");
    t.style.height = "16px", t.height = 16, t.width = 960, t.style.width = "960px", n.fillStyle = "#ffffff", n.font = `bold 16px ${e}`, n.textBaseline = "middle";
    let s = 0;
    for (const o of RY) n.fillText(String.fromCharCode(o), s, 8), s += 10;
    return n.getImageData(0, 0, 960, 16);
  }
  static createFromSampleData(e, t) {
    if (e.length !== 61440) throw new Error("Unexpected source in MinimapCharRenderer");
    const n = o0._downsample(e, t);
    return new vv(n, t);
  }
  static _downsampleChar(e, t, n, s, o) {
    const r = 1 * o, a = 2 * o;
    let l = s, d = 0;
    for (let h = 0; h < a; h++) {
      const c = h / a * 16, u = (h + 1) / a * 16;
      for (let g = 0; g < r; g++) {
        const p = g / r * 10, f = (g + 1) / r * 10;
        let _ = 0, v = 0;
        for (let C = c; C < u; C++) {
          const w = t + 3840 * Math.floor(C), y = 1 - (C - Math.floor(C));
          for (let L = p; L < f; L++) {
            const k = 1 - (L - Math.floor(L)), N = w + 4 * Math.floor(L), A = k * y;
            v += A, _ += e[N] * e[N + 3] / 255 * A;
          }
        }
        const b = _ / v;
        d = Math.max(d, b), n[l++] = Jw(b);
      }
    }
    return d;
  }
  static _downsample(e, t) {
    const n = 2 * t * 1 * t, s = 96 * n, o = new Uint8ClampedArray(s);
    let r = 0, a = 0, l = 0;
    for (let d = 0; d < 96; d++) l = Math.max(l, this._downsampleChar(e, a, o, r, t)), r += n, a += 40;
    if (l > 0) {
      const d = 255 / l;
      for (let h = 0; h < s; h++) o[h] *= d;
    }
    return o;
  }
}
const AY = Tn ? '"Segoe WPC", "Segoe UI", sans-serif' : Je ? "-apple-system, BlinkMacSystemFont, sans-serif" : 'system-ui, "Ubuntu", "Droid Sans", sans-serif';
class lm {
  constructor(e, t, n) {
    const s = e.options, o = s.get(143), r = s.get(145), a = r.minimap, l = s.get(50), d = s.get(73);
    this.renderMinimap = a.renderMinimap, this.size = d.size, this.minimapHeightIsEditorHeight = a.minimapHeightIsEditorHeight, this.scrollBeyondLastLine = s.get(105), this.paddingTop = s.get(84).top, this.paddingBottom = s.get(84).bottom, this.showSlider = d.showSlider, this.autohide = d.autohide, this.pixelRatio = o, this.typicalHalfwidthCharacterWidth = l.typicalHalfwidthCharacterWidth, this.lineHeight = s.get(67), this.minimapLeft = a.minimapLeft, this.minimapWidth = a.minimapWidth, this.minimapHeight = r.height, this.canvasInnerWidth = a.minimapCanvasInnerWidth, this.canvasInnerHeight = a.minimapCanvasInnerHeight, this.canvasOuterWidth = a.minimapCanvasOuterWidth, this.canvasOuterHeight = a.minimapCanvasOuterHeight, this.isSampling = a.minimapIsSampling, this.editorHeight = r.height, this.fontScale = a.minimapScale, this.minimapLineHeight = a.minimapLineHeight, this.minimapCharWidth = 1 * this.fontScale, this.sectionHeaderFontFamily = AY, this.sectionHeaderFontSize = d.sectionHeaderFontSize * o, this.sectionHeaderFontColor = lm._getSectionHeaderColor(t, n.getColor(1)), this.charRenderer = mc(() => o0.create(this.fontScale, l.fontFamily)), this.defaultBackgroundColor = n.getColor(2), this.backgroundColor = lm._getMinimapBackground(t, this.defaultBackgroundColor), this.foregroundAlpha = lm._getMinimapForegroundOpacity(t);
  }
  static _getMinimapBackground(e, t) {
    const n = e.getColor(B$);
    return n ? new wo(n.rgba.r, n.rgba.g, n.rgba.b, Math.round(255 * n.rgba.a)) : t;
  }
  static _getMinimapForegroundOpacity(e) {
    const t = e.getColor(W$);
    return t ? wo._clamp(Math.round(255 * t.rgba.a)) : 255;
  }
  static _getSectionHeaderColor(e, t) {
    const n = e.getColor(Go);
    return n ? new wo(n.rgba.r, n.rgba.g, n.rgba.b, Math.round(255 * n.rgba.a)) : t;
  }
  equals(e) {
    return this.renderMinimap === e.renderMinimap && this.size === e.size && this.minimapHeightIsEditorHeight === e.minimapHeightIsEditorHeight && this.scrollBeyondLastLine === e.scrollBeyondLastLine && this.paddingTop === e.paddingTop && this.paddingBottom === e.paddingBottom && this.showSlider === e.showSlider && this.autohide === e.autohide && this.pixelRatio === e.pixelRatio && this.typicalHalfwidthCharacterWidth === e.typicalHalfwidthCharacterWidth && this.lineHeight === e.lineHeight && this.minimapLeft === e.minimapLeft && this.minimapWidth === e.minimapWidth && this.minimapHeight === e.minimapHeight && this.canvasInnerWidth === e.canvasInnerWidth && this.canvasInnerHeight === e.canvasInnerHeight && this.canvasOuterWidth === e.canvasOuterWidth && this.canvasOuterHeight === e.canvasOuterHeight && this.isSampling === e.isSampling && this.editorHeight === e.editorHeight && this.fontScale === e.fontScale && this.minimapLineHeight === e.minimapLineHeight && this.minimapCharWidth === e.minimapCharWidth && this.sectionHeaderFontSize === e.sectionHeaderFontSize && this.defaultBackgroundColor && this.defaultBackgroundColor.equals(e.defaultBackgroundColor) && this.backgroundColor && this.backgroundColor.equals(e.backgroundColor) && this.foregroundAlpha === e.foregroundAlpha;
  }
}
class r0 {
  constructor(e, t, n, s, o, r, a, l, d) {
    this.scrollTop = e, this.scrollHeight = t, this.sliderNeeded = n, this._computedSliderRatio = s, this.sliderTop = o, this.sliderHeight = r, this.topPaddingLineCount = a, this.startLineNumber = l, this.endLineNumber = d;
  }
  getDesiredScrollTopFromDelta(e) {
    return Math.round(this.scrollTop + e / this._computedSliderRatio);
  }
  getDesiredScrollTopFromTouchLocation(e) {
    return Math.round((e - this.sliderHeight / 2) / this._computedSliderRatio);
  }
  intersectWithViewport(e) {
    const t = Math.max(this.startLineNumber, e.startLineNumber), n = Math.min(this.endLineNumber, e.endLineNumber);
    return t > n ? null : [t, n];
  }
  getYForLineNumber(e, t) {
    return +(e - this.startLineNumber + this.topPaddingLineCount) * t;
  }
  static create(e, t, n, s, o, r, a, l, d, h, c) {
    const u = e.pixelRatio, g = e.minimapLineHeight, p = Math.floor(e.canvasInnerHeight / g), f = e.lineHeight;
    if (e.minimapHeightIsEditorHeight) {
      let L = l * e.lineHeight + e.paddingTop + e.paddingBottom;
      e.scrollBeyondLastLine && (L += Math.max(0, o - e.lineHeight - e.paddingBottom));
      const k = Math.max(1, Math.floor(o * o / L)), N = Math.max(0, e.minimapHeight - k), A = N / (h - o), B = d * A, T = N > 0, O = Math.floor(e.canvasInnerHeight / e.minimapLineHeight), H = Math.floor(e.paddingTop / e.lineHeight);
      return new r0(d, h, T, A, B, k, H, 1, Math.min(a, O));
    }
    let _;
    if (r && n !== a) {
      const L = n - t + 1;
      _ = Math.floor(L * g / u);
    } else {
      const L = o / f;
      _ = Math.floor(L * g / u);
    }
    const v = Math.floor(e.paddingTop / f);
    let b, C = Math.floor(e.paddingBottom / f);
    if (e.scrollBeyondLastLine) {
      const L = o / f;
      C = Math.max(C, L - 1);
    }
    C > 0 ? b = (v + a + C - o / f - 1) * g / u : b = Math.max(0, (v + a) * g / u - _), b = Math.min(e.minimapHeight - _, b);
    const w = b / (h - o), y = d * w;
    if (p >= v + a + C)
      return new r0(d, h, b > 0, w, y, _, v, 1, a);
    {
      let L, k;
      L = t > 1 ? t + v : Math.max(1, d / f);
      let N = Math.max(1, Math.floor(L - y * u / g));
      N < v ? (k = v - N + 1, N = 1) : (k = 0, N = Math.max(1, N - v)), c && c.scrollHeight === h && (c.scrollTop > d && (N = Math.min(N, c.startLineNumber), k = Math.max(k, c.topPaddingLineCount)), c.scrollTop < d && (N = Math.max(N, c.startLineNumber), k = Math.min(k, c.topPaddingLineCount)));
      const A = Math.min(a, N - k + p - 1), B = (d - s) / f;
      let T;
      return T = d >= e.paddingTop ? (t - N + k + B) * g / u : d / e.paddingTop * (k + B) * g / u, new r0(d, h, !0, w, T, _, k, N, A);
    }
  }
}
class py {
  constructor(e) {
    this.dy = e;
  }
  onContentChanged() {
    this.dy = -1;
  }
  onTokensChanged() {
    this.dy = -1;
  }
}
py.INVALID = new py(-1);
class s5 {
  constructor(e, t, n) {
    this.renderedLayout = e, this._imageData = t, this._renderedLines = new VB(() => py.INVALID), this._renderedLines._set(e.startLineNumber, n);
  }
  linesEquals(e) {
    if (!this.scrollEquals(e)) return !1;
    const t = this._renderedLines._get().lines;
    for (let n = 0, s = t.length; n < s; n++) if (t[n].dy === -1) return !1;
    return !0;
  }
  scrollEquals(e) {
    return this.renderedLayout.startLineNumber === e.startLineNumber && this.renderedLayout.endLineNumber === e.endLineNumber;
  }
  _get() {
    const e = this._renderedLines._get();
    return { imageData: this._imageData, rendLineNumberStart: e.rendLineNumberStart, lines: e.lines };
  }
  onLinesChanged(e, t) {
    return this._renderedLines.onLinesChanged(e, t);
  }
  onLinesDeleted(e, t) {
    this._renderedLines.onLinesDeleted(e, t);
  }
  onLinesInserted(e, t) {
    this._renderedLines.onLinesInserted(e, t);
  }
  onTokensChanged(e) {
    return this._renderedLines.onTokensChanged(e);
  }
}
class qR {
  constructor(e, t, n, s) {
    this._backgroundFillData = qR._createBackgroundFillData(t, n, s), this._buffers = [e.createImageData(t, n), e.createImageData(t, n)], this._lastUsedBuffer = 0;
  }
  getBuffer() {
    this._lastUsedBuffer = 1 - this._lastUsedBuffer;
    const e = this._buffers[this._lastUsedBuffer];
    return e.data.set(this._backgroundFillData), e;
  }
  static _createBackgroundFillData(e, t, n) {
    const s = n.r, o = n.g, r = n.b, a = n.a, l = new Uint8ClampedArray(e * t * 4);
    let d = 0;
    for (let h = 0; h < t; h++) for (let c = 0; c < e; c++) l[d] = s, l[d + 1] = o, l[d + 2] = r, l[d + 3] = a, d += 4;
    return l;
  }
}
class bv {
  static compute(e, t, n) {
    if (e.renderMinimap === 0 || !e.isSampling) return [null, []];
    const { minimapLineCount: s } = Xp.computeContainedMinimapLineCount({ viewLineCount: t, scrollBeyondLastLine: e.scrollBeyondLastLine, paddingTop: e.paddingTop, paddingBottom: e.paddingBottom, height: e.editorHeight, lineHeight: e.lineHeight, pixelRatio: e.pixelRatio }), o = t / s, r = o / 2;
    if (!n || n.minimapLines.length === 0) {
      const f = [];
      if (f[0] = 1, s > 1) {
        for (let _ = 0, v = s - 1; _ < v; _++) f[_] = Math.round(_ * o + r);
        f[s - 1] = t;
      }
      return [new bv(o, f), []];
    }
    const a = n.minimapLines, l = a.length, d = [];
    let h = 0, c = 0, u = 1, g = [], p = null;
    for (let f = 0; f < s; f++) {
      const _ = Math.max(u, Math.round(f * o)), v = Math.max(_, Math.round((f + 1) * o));
      for (; h < l && a[h] < _; ) {
        if (g.length < 10) {
          const C = h + 1 + c;
          p && p.type === "deleted" && p._oldIndex === h - 1 ? p.deleteToLineNumber++ : (p = { type: "deleted", _oldIndex: h, deleteFromLineNumber: C, deleteToLineNumber: C }, g.push(p)), c--;
        }
        h++;
      }
      let b;
      if (h < l && a[h] <= v) b = a[h], h++;
      else if (b = f === 0 ? 1 : f + 1 === s ? t : Math.round(f * o + r), g.length < 10) {
        const C = h + 1 + c;
        p && p.type === "inserted" && p._i === f - 1 ? p.insertToLineNumber++ : (p = { type: "inserted", _i: f, insertFromLineNumber: C, insertToLineNumber: C }, g.push(p)), c++;
      }
      d[f] = b, u = b;
    }
    if (g.length < 10) for (; h < l; ) {
      const f = h + 1 + c;
      p && p.type === "deleted" && p._oldIndex === h - 1 ? p.deleteToLineNumber++ : (p = { type: "deleted", _oldIndex: h, deleteFromLineNumber: f, deleteToLineNumber: f }, g.push(p)), c--, h++;
    }
    else g = [{ type: "flush" }];
    return [new bv(o, d), g];
  }
  constructor(e, t) {
    this.samplingRatio = e, this.minimapLines = t;
  }
  modelLineToMinimapLine(e) {
    return Math.min(this.minimapLines.length, Math.max(1, Math.round(e / this.samplingRatio)));
  }
  modelLineRangeToMinimapLineRange(e, t) {
    let n = this.modelLineToMinimapLine(e) - 1;
    for (; n > 0 && this.minimapLines[n - 1] >= e; ) n--;
    let s = this.modelLineToMinimapLine(t) - 1;
    for (; s + 1 < this.minimapLines.length && this.minimapLines[s + 1] <= t; ) s++;
    if (n === s) {
      const o = this.minimapLines[n];
      if (o < e || o > t) return null;
    }
    return [n + 1, s + 1];
  }
  decorationLineRangeToMinimapLineRange(e, t) {
    let n = this.modelLineToMinimapLine(e), s = this.modelLineToMinimapLine(t);
    return e !== t && s === n && (s === this.minimapLines.length ? n > 1 && n-- : s++), [n, s];
  }
  onLinesDeleted(e) {
    const t = e.toLineNumber - e.fromLineNumber + 1;
    let n = this.minimapLines.length, s = 0;
    for (let o = this.minimapLines.length - 1; o >= 0 && !(this.minimapLines[o] < e.fromLineNumber); o--) this.minimapLines[o] <= e.toLineNumber ? (this.minimapLines[o] = Math.max(1, e.fromLineNumber - 1), n = Math.min(n, o), s = Math.max(s, o)) : this.minimapLines[o] -= t;
    return [n, s];
  }
  onLinesInserted(e) {
    const t = e.toLineNumber - e.fromLineNumber + 1;
    for (let n = this.minimapLines.length - 1; n >= 0 && !(this.minimapLines[n] < e.fromLineNumber); n--) this.minimapLines[n] += t;
  }
}
class PY extends to {
  constructor(e) {
    super(e), this._sectionHeaderCache = new Ll(10, 1.5), this.tokensColorTracker = E1.getInstance(), this._selections = [], this._minimapSelections = null, this.options = new lm(this._context.configuration, this._context.theme, this.tokensColorTracker);
    const [t] = bv.compute(this.options, this._context.viewModel.getLineCount(), null);
    this._samplingState = t, this._shouldCheckSampling = !1, this._actual = new Bp(e.theme, this);
  }
  dispose() {
    this._actual.dispose(), super.dispose();
  }
  getDomNode() {
    return this._actual.getDomNode();
  }
  _onOptionsMaybeChanged() {
    const e = new lm(this._context.configuration, this._context.theme, this.tokensColorTracker);
    return !this.options.equals(e) && (this.options = e, this._recreateLineSampling(), this._actual.onDidChangeOptions(), !0);
  }
  onConfigurationChanged(e) {
    return this._onOptionsMaybeChanged();
  }
  onCursorStateChanged(e) {
    return this._selections = e.selections, this._minimapSelections = null, this._actual.onSelectionChanged();
  }
  onDecorationsChanged(e) {
    return !!e.affectsMinimap && this._actual.onDecorationsChanged();
  }
  onFlushed(e) {
    return this._samplingState && (this._shouldCheckSampling = !0), this._actual.onFlushed();
  }
  onLinesChanged(e) {
    if (this._samplingState) {
      const t = this._samplingState.modelLineRangeToMinimapLineRange(e.fromLineNumber, e.fromLineNumber + e.count - 1);
      return !!t && this._actual.onLinesChanged(t[0], t[1] - t[0] + 1);
    }
    return this._actual.onLinesChanged(e.fromLineNumber, e.count);
  }
  onLinesDeleted(e) {
    if (this._samplingState) {
      const [t, n] = this._samplingState.onLinesDeleted(e);
      return t <= n && this._actual.onLinesChanged(t + 1, n - t + 1), this._shouldCheckSampling = !0, !0;
    }
    return this._actual.onLinesDeleted(e.fromLineNumber, e.toLineNumber);
  }
  onLinesInserted(e) {
    return this._samplingState ? (this._samplingState.onLinesInserted(e), this._shouldCheckSampling = !0, !0) : this._actual.onLinesInserted(e.fromLineNumber, e.toLineNumber);
  }
  onScrollChanged(e) {
    return this._actual.onScrollChanged();
  }
  onThemeChanged(e) {
    return this._actual.onThemeChanged(), this._onOptionsMaybeChanged(), !0;
  }
  onTokensChanged(e) {
    if (this._samplingState) {
      const t = [];
      for (const n of e.ranges) {
        const s = this._samplingState.modelLineRangeToMinimapLineRange(n.fromLineNumber, n.toLineNumber);
        s && t.push({ fromLineNumber: s[0], toLineNumber: s[1] });
      }
      return !!t.length && this._actual.onTokensChanged(t);
    }
    return this._actual.onTokensChanged(e.ranges);
  }
  onTokensColorsChanged(e) {
    return this._onOptionsMaybeChanged(), this._actual.onTokensColorsChanged();
  }
  onZonesChanged(e) {
    return this._actual.onZonesChanged();
  }
  prepareRender(e) {
    this._shouldCheckSampling && (this._shouldCheckSampling = !1, this._recreateLineSampling());
  }
  render(e) {
    let t = e.visibleRange.startLineNumber, n = e.visibleRange.endLineNumber;
    this._samplingState && (t = this._samplingState.modelLineToMinimapLine(t), n = this._samplingState.modelLineToMinimapLine(n));
    const s = { viewportContainsWhitespaceGaps: e.viewportData.whitespaceViewportData.length > 0, scrollWidth: e.scrollWidth, scrollHeight: e.scrollHeight, viewportStartLineNumber: t, viewportEndLineNumber: n, viewportStartLineNumberVerticalOffset: e.getVerticalOffsetForLineNumber(t), scrollTop: e.scrollTop, scrollLeft: e.scrollLeft, viewportWidth: e.viewportWidth, viewportHeight: e.viewportHeight };
    this._actual.render(s);
  }
  _recreateLineSampling() {
    this._minimapSelections = null;
    const e = !!this._samplingState, [t, n] = bv.compute(this.options, this._context.viewModel.getLineCount(), this._samplingState);
    if (this._samplingState = t, e && this._samplingState) for (const s of n) switch (s.type) {
      case "deleted":
        this._actual.onLinesDeleted(s.deleteFromLineNumber, s.deleteToLineNumber);
        break;
      case "inserted":
        this._actual.onLinesInserted(s.insertFromLineNumber, s.insertToLineNumber);
        break;
      case "flush":
        this._actual.onFlushed();
    }
  }
  getLineCount() {
    return this._samplingState ? this._samplingState.minimapLines.length : this._context.viewModel.getLineCount();
  }
  getRealLineCount() {
    return this._context.viewModel.getLineCount();
  }
  getLineContent(e) {
    return this._samplingState ? this._context.viewModel.getLineContent(this._samplingState.minimapLines[e - 1]) : this._context.viewModel.getLineContent(e);
  }
  getLineMaxColumn(e) {
    return this._samplingState ? this._context.viewModel.getLineMaxColumn(this._samplingState.minimapLines[e - 1]) : this._context.viewModel.getLineMaxColumn(e);
  }
  getMinimapLinesRenderingData(e, t, n) {
    if (this._samplingState) {
      const s = [];
      for (let o = 0, r = t - e + 1; o < r; o++) n[o] ? s[o] = this._context.viewModel.getViewLineData(this._samplingState.minimapLines[e + o - 1]) : s[o] = null;
      return s;
    }
    return this._context.viewModel.getMinimapLinesRenderingData(e, t, n).data;
  }
  getSelections() {
    if (this._minimapSelections === null) if (this._samplingState) {
      this._minimapSelections = [];
      for (const e of this._selections) {
        const [t, n] = this._samplingState.decorationLineRangeToMinimapLineRange(e.startLineNumber, e.endLineNumber);
        this._minimapSelections.push(new _e(t, e.startColumn, n, e.endColumn));
      }
    } else this._minimapSelections = this._selections;
    return this._minimapSelections;
  }
  getMinimapDecorationsInViewport(e, t) {
    const n = this._getMinimapDecorationsInViewport(e, t).filter((s) => {
      var o;
      return !(!((o = s.options.minimap) === null || o === void 0) && o.sectionHeaderStyle);
    });
    if (this._samplingState) {
      const s = [];
      for (const o of n) {
        if (!o.options.minimap) continue;
        const r = o.range, a = this._samplingState.modelLineToMinimapLine(r.startLineNumber), l = this._samplingState.modelLineToMinimapLine(r.endLineNumber);
        s.push(new sB(new D(a, r.startColumn, l, r.endColumn), o.options));
      }
      return s;
    }
    return n;
  }
  getSectionHeaderDecorationsInViewport(e, t) {
    const n = this.options.minimapLineHeight, s = this.options.sectionHeaderFontSize / n;
    return e = Math.floor(Math.max(1, e - s)), this._getMinimapDecorationsInViewport(e, t).filter((o) => {
      var r;
      return !!(!((r = o.options.minimap) === null || r === void 0) && r.sectionHeaderStyle);
    });
  }
  _getMinimapDecorationsInViewport(e, t) {
    let n;
    if (this._samplingState) {
      const s = this._samplingState.minimapLines[e - 1], o = this._samplingState.minimapLines[t - 1];
      n = new D(s, 1, o, this._context.viewModel.getLineMaxColumn(o));
    } else n = new D(e, 1, t, this._context.viewModel.getLineMaxColumn(t));
    return this._context.viewModel.getMinimapDecorationsInRange(n);
  }
  getSectionHeaderText(e, t) {
    var n;
    const s = (n = e.options.minimap) === null || n === void 0 ? void 0 : n.sectionHeaderText;
    if (!s) return null;
    const o = this._sectionHeaderCache.get(s);
    if (o) return o;
    const r = t(s);
    return this._sectionHeaderCache.set(s, r), r;
  }
  getOptions() {
    return this._context.viewModel.model.getOptions();
  }
  revealLineNumber(e) {
    this._samplingState && (e = this._samplingState.minimapLines[e - 1]), this._context.viewModel.revealRange("mouse", !1, new D(e, 1, e, 1), 1, 0);
  }
  setScrollTop(e) {
    this._context.viewModel.viewLayout.setScrollPosition({ scrollTop: e }, 1);
  }
}
class Bp extends V {
  constructor(e, t) {
    super(), this._renderDecorations = !1, this._gestureInProgress = !1, this._theme = e, this._model = t, this._lastRenderData = null, this._buffers = null, this._selectionColor = this._theme.getColor(F4), this._domNode = wt(document.createElement("div")), _a.write(this._domNode, 9), this._domNode.setClassName(this._getMinimapDomNodeClassName()), this._domNode.setPosition("absolute"), this._domNode.setAttribute("role", "presentation"), this._domNode.setAttribute("aria-hidden", "true"), this._shadow = wt(document.createElement("div")), this._shadow.setClassName("minimap-shadow-hidden"), this._domNode.appendChild(this._shadow), this._canvas = wt(document.createElement("canvas")), this._canvas.setPosition("absolute"), this._canvas.setLeft(0), this._domNode.appendChild(this._canvas), this._decorationsCanvas = wt(document.createElement("canvas")), this._decorationsCanvas.setPosition("absolute"), this._decorationsCanvas.setClassName("minimap-decorations-layer"), this._decorationsCanvas.setLeft(0), this._domNode.appendChild(this._decorationsCanvas), this._slider = wt(document.createElement("div")), this._slider.setPosition("absolute"), this._slider.setClassName("minimap-slider"), this._slider.setLayerHinting(!0), this._slider.setContain("strict"), this._domNode.appendChild(this._slider), this._sliderHorizontal = wt(document.createElement("div")), this._sliderHorizontal.setPosition("absolute"), this._sliderHorizontal.setClassName("minimap-slider-horizontal"), this._slider.appendChild(this._sliderHorizontal), this._applyLayout(), this._pointerDownListener = bi(this._domNode.domNode, ie.POINTER_DOWN, (n) => {
      if (n.preventDefault(), this._model.options.renderMinimap === 0 || !this._lastRenderData) return;
      if (this._model.options.size !== "proportional") {
        if (n.button === 0 && this._lastRenderData) {
          const a = Ti(this._slider.domNode), l = a.top + a.height / 2;
          this._startSliderDragging(n, l, this._lastRenderData.renderedLayout);
        }
        return;
      }
      const s = this._model.options.minimapLineHeight, o = this._model.options.canvasInnerHeight / this._model.options.canvasOuterHeight * n.offsetY;
      let r = Math.floor(o / s) + this._lastRenderData.renderedLayout.startLineNumber - this._lastRenderData.renderedLayout.topPaddingLineCount;
      r = Math.min(r, this._model.getLineCount()), this._model.revealLineNumber(r);
    }), this._sliderPointerMoveMonitor = new vf(), this._sliderPointerDownListener = bi(this._slider.domNode, ie.POINTER_DOWN, (n) => {
      n.preventDefault(), n.stopPropagation(), n.button === 0 && this._lastRenderData && this._startSliderDragging(n, n.pageY, this._lastRenderData.renderedLayout);
    }), this._gestureDisposable = Bt.addTarget(this._domNode.domNode), this._sliderTouchStartListener = K(this._domNode.domNode, Vt.Start, (n) => {
      n.preventDefault(), n.stopPropagation(), this._lastRenderData && (this._slider.toggleClassName("active", !0), this._gestureInProgress = !0, this.scrollDueToTouchEvent(n));
    }, { passive: !1 }), this._sliderTouchMoveListener = K(this._domNode.domNode, Vt.Change, (n) => {
      n.preventDefault(), n.stopPropagation(), this._lastRenderData && this._gestureInProgress && this.scrollDueToTouchEvent(n);
    }, { passive: !1 }), this._sliderTouchEndListener = bi(this._domNode.domNode, Vt.End, (n) => {
      n.preventDefault(), n.stopPropagation(), this._gestureInProgress = !1, this._slider.toggleClassName("active", !1);
    });
  }
  _startSliderDragging(e, t, n) {
    if (!(e.target && e.target instanceof Element)) return;
    const s = e.pageX;
    this._slider.toggleClassName("active", !0);
    const o = (r, a) => {
      const l = Ti(this._domNode.domNode), d = Math.min(Math.abs(a - s), Math.abs(a - l.left), Math.abs(a - l.left - l.width));
      if (Tn && d > 140) return void this._model.setScrollTop(n.scrollTop);
      const h = r - t;
      this._model.setScrollTop(n.getDesiredScrollTopFromDelta(h));
    };
    e.pageY !== t && o(e.pageY, s), this._sliderPointerMoveMonitor.startMonitoring(e.target, e.pointerId, e.buttons, (r) => o(r.pageY, r.pageX), () => {
      this._slider.toggleClassName("active", !1);
    });
  }
  scrollDueToTouchEvent(e) {
    const t = this._domNode.domNode.getBoundingClientRect().top, n = this._lastRenderData.renderedLayout.getDesiredScrollTopFromTouchLocation(e.pageY - t);
    this._model.setScrollTop(n);
  }
  dispose() {
    this._pointerDownListener.dispose(), this._sliderPointerMoveMonitor.dispose(), this._sliderPointerDownListener.dispose(), this._gestureDisposable.dispose(), this._sliderTouchStartListener.dispose(), this._sliderTouchMoveListener.dispose(), this._sliderTouchEndListener.dispose(), super.dispose();
  }
  _getMinimapDomNodeClassName() {
    const e = ["minimap"];
    return this._model.options.showSlider === "always" ? e.push("slider-always") : e.push("slider-mouseover"), this._model.options.autohide && e.push("autohide"), e.join(" ");
  }
  getDomNode() {
    return this._domNode;
  }
  _applyLayout() {
    this._domNode.setLeft(this._model.options.minimapLeft), this._domNode.setWidth(this._model.options.minimapWidth), this._domNode.setHeight(this._model.options.minimapHeight), this._shadow.setHeight(this._model.options.minimapHeight), this._canvas.setWidth(this._model.options.canvasOuterWidth), this._canvas.setHeight(this._model.options.canvasOuterHeight), this._canvas.domNode.width = this._model.options.canvasInnerWidth, this._canvas.domNode.height = this._model.options.canvasInnerHeight, this._decorationsCanvas.setWidth(this._model.options.canvasOuterWidth), this._decorationsCanvas.setHeight(this._model.options.canvasOuterHeight), this._decorationsCanvas.domNode.width = this._model.options.canvasInnerWidth, this._decorationsCanvas.domNode.height = this._model.options.canvasInnerHeight, this._slider.setWidth(this._model.options.minimapWidth);
  }
  _getBuffer() {
    return this._buffers || this._model.options.canvasInnerWidth > 0 && this._model.options.canvasInnerHeight > 0 && (this._buffers = new qR(this._canvas.domNode.getContext("2d"), this._model.options.canvasInnerWidth, this._model.options.canvasInnerHeight, this._model.options.backgroundColor)), this._buffers ? this._buffers.getBuffer() : null;
  }
  onDidChangeOptions() {
    this._lastRenderData = null, this._buffers = null, this._applyLayout(), this._domNode.setClassName(this._getMinimapDomNodeClassName());
  }
  onSelectionChanged() {
    return this._renderDecorations = !0, !0;
  }
  onDecorationsChanged() {
    return this._renderDecorations = !0, !0;
  }
  onFlushed() {
    return this._lastRenderData = null, !0;
  }
  onLinesChanged(e, t) {
    return !!this._lastRenderData && this._lastRenderData.onLinesChanged(e, t);
  }
  onLinesDeleted(e, t) {
    var n;
    return (n = this._lastRenderData) === null || n === void 0 || n.onLinesDeleted(e, t), !0;
  }
  onLinesInserted(e, t) {
    var n;
    return (n = this._lastRenderData) === null || n === void 0 || n.onLinesInserted(e, t), !0;
  }
  onScrollChanged() {
    return this._renderDecorations = !0, !0;
  }
  onThemeChanged() {
    return this._selectionColor = this._theme.getColor(F4), this._renderDecorations = !0, !0;
  }
  onTokensChanged(e) {
    return !!this._lastRenderData && this._lastRenderData.onTokensChanged(e);
  }
  onTokensColorsChanged() {
    return this._lastRenderData = null, this._buffers = null, !0;
  }
  onZonesChanged() {
    return this._lastRenderData = null, !0;
  }
  render(e) {
    if (this._model.options.renderMinimap === 0) return this._shadow.setClassName("minimap-shadow-hidden"), this._sliderHorizontal.setWidth(0), void this._sliderHorizontal.setHeight(0);
    e.scrollLeft + e.viewportWidth >= e.scrollWidth ? this._shadow.setClassName("minimap-shadow-hidden") : this._shadow.setClassName("minimap-shadow-visible");
    const t = r0.create(this._model.options, e.viewportStartLineNumber, e.viewportEndLineNumber, e.viewportStartLineNumberVerticalOffset, e.viewportHeight, e.viewportContainsWhitespaceGaps, this._model.getLineCount(), this._model.getRealLineCount(), e.scrollTop, e.scrollHeight, this._lastRenderData ? this._lastRenderData.renderedLayout : null);
    this._slider.setDisplay(t.sliderNeeded ? "block" : "none"), this._slider.setTop(t.sliderTop), this._slider.setHeight(t.sliderHeight), this._sliderHorizontal.setLeft(0), this._sliderHorizontal.setWidth(this._model.options.minimapWidth), this._sliderHorizontal.setTop(0), this._sliderHorizontal.setHeight(t.sliderHeight), this.renderDecorations(t), this._lastRenderData = this.renderLines(t);
  }
  renderDecorations(e) {
    if (this._renderDecorations) {
      this._renderDecorations = !1;
      const t = this._model.getSelections();
      t.sort(D.compareRangesUsingStarts);
      const n = this._model.getMinimapDecorationsInViewport(e.startLineNumber, e.endLineNumber);
      n.sort((u, g) => (u.options.zIndex || 0) - (g.options.zIndex || 0));
      const { canvasInnerWidth: s, canvasInnerHeight: o } = this._model.options, r = this._model.options.minimapLineHeight, a = this._model.options.minimapCharWidth, l = this._model.getOptions().tabSize, d = this._decorationsCanvas.domNode.getContext("2d");
      d.clearRect(0, 0, s, o);
      const h = new o5(e.startLineNumber, e.endLineNumber, !1);
      this._renderSelectionLineHighlights(d, t, h, e, r), this._renderDecorationsLineHighlights(d, n, h, e, r);
      const c = new o5(e.startLineNumber, e.endLineNumber, null);
      this._renderSelectionsHighlights(d, t, c, e, r, l, a, s), this._renderDecorationsHighlights(d, n, c, e, r, l, a, s), this._renderSectionHeaders(e);
    }
  }
  _renderSelectionLineHighlights(e, t, n, s, o) {
    if (!this._selectionColor || this._selectionColor.isTransparent()) return;
    e.fillStyle = this._selectionColor.transparent(0.5).toString();
    let r = 0, a = 0;
    for (const l of t) {
      const d = s.intersectWithViewport(l);
      if (!d) continue;
      const [h, c] = d;
      for (let p = h; p <= c; p++) n.set(p, !0);
      const u = s.getYForLineNumber(h, o), g = s.getYForLineNumber(c, o);
      a >= u || (a > r && e.fillRect(8, r, e.canvas.width, a - r), r = u), a = g;
    }
    a > r && e.fillRect(8, r, e.canvas.width, a - r);
  }
  _renderDecorationsLineHighlights(e, t, n, s, o) {
    const r = /* @__PURE__ */ new Map();
    for (let a = t.length - 1; a >= 0; a--) {
      const l = t[a], d = l.options.minimap;
      if (!d || d.position !== 1) continue;
      const h = s.intersectWithViewport(l.range);
      if (!h) continue;
      const [c, u] = h, g = d.getColor(this._theme.value);
      if (!g || g.isTransparent()) continue;
      let p = r.get(g.toString());
      p || (p = g.transparent(0.5).toString(), r.set(g.toString(), p)), e.fillStyle = p;
      for (let f = c; f <= u; f++) {
        if (n.has(f)) continue;
        n.set(f, !0);
        const _ = s.getYForLineNumber(c, o);
        e.fillRect(8, _, e.canvas.width, o);
      }
    }
  }
  _renderSelectionsHighlights(e, t, n, s, o, r, a, l) {
    if (this._selectionColor && !this._selectionColor.isTransparent()) for (const d of t) {
      const h = s.intersectWithViewport(d);
      if (!h) continue;
      const [c, u] = h;
      for (let g = c; g <= u; g++) this.renderDecorationOnLine(e, n, d, this._selectionColor, s, g, o, o, r, a, l);
    }
  }
  _renderDecorationsHighlights(e, t, n, s, o, r, a, l) {
    for (const d of t) {
      const h = d.options.minimap;
      if (!h) continue;
      const c = s.intersectWithViewport(d.range);
      if (!c) continue;
      const [u, g] = c, p = h.getColor(this._theme.value);
      if (p && !p.isTransparent()) for (let f = u; f <= g; f++) switch (h.position) {
        case 1:
          this.renderDecorationOnLine(e, n, d.range, p, s, f, o, o, r, a, l);
          continue;
        case 2: {
          const _ = s.getYForLineNumber(f, o);
          this.renderDecoration(e, p, 2, _, 2, o);
          continue;
        }
      }
    }
  }
  renderDecorationOnLine(e, t, n, s, o, r, a, l, d, h, c) {
    const u = o.getYForLineNumber(r, l);
    if (u + a < 0 || u > this._model.options.canvasInnerHeight) return;
    const { startLineNumber: g, endLineNumber: p } = n, f = g === r ? n.startColumn : 1, _ = p === r ? n.endColumn : this._model.getLineMaxColumn(r), v = this.getXOffsetForPosition(t, r, f, d, h, c), b = this.getXOffsetForPosition(t, r, _, d, h, c);
    this.renderDecoration(e, s, v, u, b - v, a);
  }
  getXOffsetForPosition(e, t, n, s, o, r) {
    if (n === 1) return 8;
    if ((n - 1) * o >= r) return r;
    let a = e.get(t);
    if (!a) {
      const l = this._model.getLineContent(t);
      a = [8];
      let d = 8;
      for (let h = 1; h < l.length + 1; h++) {
        const c = l.charCodeAt(h - 1), u = d + (c === 9 ? s * o : _c(c) ? 2 * o : o);
        if (u >= r) {
          a[h] = r;
          break;
        }
        a[h] = u, d = u;
      }
      e.set(t, a);
    }
    return n - 1 < a.length ? a[n - 1] : r;
  }
  renderDecoration(e, t, n, s, o, r) {
    e.fillStyle = t && t.toString() || "", e.fillRect(n, s, o, r);
  }
  _renderSectionHeaders(e) {
    var t;
    const n = this._model.options.minimapLineHeight, s = this._model.options.sectionHeaderFontSize, o = 1.5 * s, { canvasInnerWidth: r } = this._model.options, a = this._model.options.backgroundColor, l = `rgb(${a.r} ${a.g} ${a.b} / .7)`, d = this._model.options.sectionHeaderFontColor, h = `rgb(${d.r} ${d.g} ${d.b})`, c = h, u = this._decorationsCanvas.domNode.getContext("2d");
    u.font = s + "px " + this._model.options.sectionHeaderFontFamily, u.strokeStyle = c, u.lineWidth = 0.2;
    const g = this._model.getSectionHeaderDecorationsInViewport(e.startLineNumber, e.endLineNumber);
    g.sort((f, _) => f.range.startLineNumber - _.range.startLineNumber);
    const p = Bp._fitSectionHeader.bind(null, u, r - 8);
    for (const f of g) {
      const _ = e.getYForLineNumber(f.range.startLineNumber, n) + s, v = _ - s, b = v + 2, C = this._model.getSectionHeaderText(f, p);
      Bp._renderSectionLabel(u, C, ((t = f.options.minimap) === null || t === void 0 ? void 0 : t.sectionHeaderStyle) === 2, l, h, r, v, o, _, b);
    }
  }
  static _fitSectionHeader(e, t, n) {
    if (!n) return n;
    const s = e.measureText(n).width, o = e.measureText("…").width;
    if (s <= t || s <= o) return n;
    const r = n.length, a = s / n.length, l = Math.floor((t - o) / a) - 1;
    let d = Math.ceil(l / 2);
    for (; d > 0 && /\s/.test(n[d - 1]); ) --d;
    return n.substring(0, d) + "…" + n.substring(r - (l - d));
  }
  static _renderSectionLabel(e, t, n, s, o, r, a, l, d, h) {
    t && (e.fillStyle = s, e.fillRect(0, a, r, l), e.fillStyle = o, e.fillText(t, 8, d)), n && (e.beginPath(), e.moveTo(0, h), e.lineTo(r, h), e.closePath(), e.stroke());
  }
  renderLines(e) {
    const t = e.startLineNumber, n = e.endLineNumber, s = this._model.options.minimapLineHeight;
    if (this._lastRenderData && this._lastRenderData.linesEquals(e)) {
      const O = this._lastRenderData._get();
      return new s5(e, O.imageData, O.lines);
    }
    const o = this._getBuffer();
    if (!o) return null;
    const [r, a, l] = Bp._renderUntouchedLines(o, e.topPaddingLineCount, t, n, s, this._lastRenderData), d = this._model.getMinimapLinesRenderingData(t, n, l), h = this._model.getOptions().tabSize, c = this._model.options.defaultBackgroundColor, u = this._model.options.backgroundColor, g = this._model.options.foregroundAlpha, p = this._model.tokensColorTracker, f = p.backgroundIsLight(), _ = this._model.options.renderMinimap, v = this._model.options.charRenderer(), b = this._model.options.fontScale, C = this._model.options.minimapCharWidth, w = (_ === 1 ? 2 : 3) * b, y = s > w ? Math.floor((s - w) / 2) : 0, L = u.a / 255, k = new wo(Math.round((u.r - c.r) * L + c.r), Math.round((u.g - c.g) * L + c.g), Math.round((u.b - c.b) * L + c.b), 255);
    let N = e.topPaddingLineCount * s;
    const A = [];
    for (let O = 0, H = n - t + 1; O < H; O++) l[O] && Bp._renderLine(o, k, u.a, f, _, C, p, g, v, N, y, h, d[O], b, s), A[O] = new py(N), N += s;
    const B = r === -1 ? 0 : r, T = (a === -1 ? o.height : a) - B;
    return this._canvas.domNode.getContext("2d").putImageData(o, 0, 0, 0, B, o.width, T), new s5(e, o, A);
  }
  static _renderUntouchedLines(e, t, n, s, o, r) {
    const a = [];
    if (!r) {
      for (let k = 0, N = s - n + 1; k < N; k++) a[k] = !0;
      return [-1, -1, a];
    }
    const l = r._get(), d = l.imageData.data, h = l.rendLineNumberStart, c = l.lines, u = c.length, g = e.width, p = e.data, f = (s - n + 1) * o * g * 4;
    let _ = -1, v = -1, b = -1, C = -1, w = -1, y = -1, L = t * o;
    for (let k = n; k <= s; k++) {
      const N = k - n, A = k - h, B = A >= 0 && A < u ? c[A].dy : -1;
      if (B === -1) {
        a[N] = !0, L += o;
        continue;
      }
      const T = B * g * 4, O = (B + o) * g * 4, H = L * g * 4, $ = (L + o) * g * 4;
      C === T && y === H ? (C = O, y = $) : (b !== -1 && (p.set(d.subarray(b, C), w), _ === -1 && b === 0 && b === w && (_ = C), v === -1 && C === f && b === w && (v = b)), b = T, C = O, w = H, y = $), a[N] = !1, L += o;
    }
    return b !== -1 && (p.set(d.subarray(b, C), w), _ === -1 && b === 0 && b === w && (_ = C), v === -1 && C === f && b === w && (v = b)), [_ === -1 ? -1 : _ / (4 * g), v === -1 ? -1 : v / (4 * g), a];
  }
  static _renderLine(e, t, n, s, o, r, a, l, d, h, c, u, g, p, f) {
    const _ = g.content, v = g.tokens, b = e.width - r, C = f === 1;
    let w = 8, y = 0, L = 0;
    for (let k = 0, N = v.getCount(); k < N; k++) {
      const A = v.getEndOffset(k), B = v.getForeground(k), T = a.getColor(B);
      for (; y < A; y++) {
        if (w > b) return;
        const O = _.charCodeAt(y);
        if (O === 9) {
          const H = u - (y + L) % u;
          L += H - 1, w += H * r;
        } else if (O === 32) w += r;
        else {
          const H = _c(O) ? 2 : 1;
          for (let $ = 0; $ < H; $++) if (o === 2 ? d.blockRenderChar(e, w, h + c, T, l, t, n, C) : d.renderChar(e, w, h + c, O, T, l, t, n, p, s, C), w += r, w > b) return;
        }
      }
    }
  }
}
class o5 {
  constructor(e, t, n) {
    this._startLineNumber = e, this._endLineNumber = t, this._defaultValue = n, this._values = [];
    for (let s = 0, o = this._endLineNumber - this._startLineNumber + 1; s < o; s++) this._values[s] = n;
  }
  has(e) {
    return this.get(e) !== this._defaultValue;
  }
  set(e, t) {
    e < this._startLineNumber || e > this._endLineNumber || (this._values[e - this._startLineNumber] = t);
  }
  get(e) {
    return e < this._startLineNumber || e > this._endLineNumber ? this._defaultValue : this._values[e - this._startLineNumber];
  }
}
class OY extends to {
  constructor(e, t) {
    super(e), this._viewDomNode = t;
    const n = this._context.configuration.options.get(145);
    this._widgets = {}, this._verticalScrollbarWidth = n.verticalScrollbarWidth, this._minimapWidth = n.minimap.minimapWidth, this._horizontalScrollbarHeight = n.horizontalScrollbarHeight, this._editorHeight = n.height, this._editorWidth = n.width, this._viewDomNodeRect = { top: 0, left: 0, width: 0, height: 0 }, this._domNode = wt(document.createElement("div")), _a.write(this._domNode, 4), this._domNode.setClassName("overlayWidgets"), this.overflowingOverlayWidgetsDomNode = wt(document.createElement("div")), _a.write(this.overflowingOverlayWidgetsDomNode, 5), this.overflowingOverlayWidgetsDomNode.setClassName("overflowingOverlayWidgets");
  }
  dispose() {
    super.dispose(), this._widgets = {};
  }
  getDomNode() {
    return this._domNode;
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options.get(145);
    return this._verticalScrollbarWidth = t.verticalScrollbarWidth, this._minimapWidth = t.minimap.minimapWidth, this._horizontalScrollbarHeight = t.horizontalScrollbarHeight, this._editorHeight = t.height, this._editorWidth = t.width, !0;
  }
  addWidget(e) {
    const t = wt(e.getDomNode());
    this._widgets[e.getId()] = { widget: e, preference: null, domNode: t }, t.setPosition("absolute"), t.setAttribute("widgetId", e.getId()), e.allowEditorOverflow ? this.overflowingOverlayWidgetsDomNode.appendChild(t) : this._domNode.appendChild(t), this.setShouldRender(), this._updateMaxMinWidth();
  }
  setWidgetPosition(e, t) {
    const n = this._widgets[e.getId()];
    return n.preference === t ? (this._updateMaxMinWidth(), !1) : (n.preference = t, this.setShouldRender(), this._updateMaxMinWidth(), !0);
  }
  removeWidget(e) {
    const t = e.getId();
    if (this._widgets.hasOwnProperty(t)) {
      const n = this._widgets[t].domNode.domNode;
      delete this._widgets[t], n.remove(), this.setShouldRender(), this._updateMaxMinWidth();
    }
  }
  _updateMaxMinWidth() {
    var e, t;
    let n = 0;
    const s = Object.keys(this._widgets);
    for (let o = 0, r = s.length; o < r; o++) {
      const a = s[o], l = (t = (e = this._widgets[a].widget).getMinContentWidthInPx) === null || t === void 0 ? void 0 : t.call(e);
      l !== void 0 && (n = Math.max(n, l));
    }
    this._context.viewLayout.setOverlayWidgetsMinWidth(n);
  }
  _renderWidget(e) {
    const t = e.domNode;
    if (e.preference !== null) if (e.preference === 0) t.setTop(0), t.setRight(2 * this._verticalScrollbarWidth + this._minimapWidth);
    else if (e.preference === 1) {
      const n = t.domNode.clientHeight;
      t.setTop(this._editorHeight - n - 2 * this._horizontalScrollbarHeight), t.setRight(2 * this._verticalScrollbarWidth + this._minimapWidth);
    } else if (e.preference === 2) t.setTop(0), t.domNode.style.right = "50%";
    else {
      const { top: n, left: s } = e.preference;
      if (this._context.configuration.options.get(42) && e.widget.allowEditorOverflow) {
        const o = this._viewDomNodeRect;
        t.setTop(n + o.top), t.setLeft(s + o.left), t.setPosition("fixed");
      } else t.setTop(n), t.setLeft(s), t.setPosition("absolute");
    }
    else t.setTop("");
  }
  prepareRender(e) {
    this._viewDomNodeRect = Ti(this._viewDomNode.domNode);
  }
  render(e) {
    this._domNode.setWidth(this._editorWidth);
    const t = Object.keys(this._widgets);
    for (let n = 0, s = t.length; n < s; n++) {
      const o = t[n];
      this._renderWidget(this._widgets[o]);
    }
  }
}
class FY {
  constructor(e, t) {
    const n = e.options;
    this.lineHeight = n.get(67), this.pixelRatio = n.get(143), this.overviewRulerLanes = n.get(83), this.renderBorder = n.get(82);
    const s = t.getColor(IZ);
    this.borderColor = s ? s.toString() : null, this.hideCursor = n.get(59);
    const o = t.getColor(ll);
    this.cursorColorSingle = o ? o.transparent(0.7).toString() : null;
    const r = t.getColor(NB);
    this.cursorColorPrimary = r ? r.transparent(0.7).toString() : null;
    const a = t.getColor(EB);
    this.cursorColorSecondary = a ? a.transparent(0.7).toString() : null, this.themeType = t.type;
    const l = n.get(73), d = l.enabled, h = l.side, c = t.getColor(MZ), u = ci.getDefaultBackground();
    this.backgroundColor = c || (d && h === "right" ? u : null);
    const g = n.get(145).overviewRuler;
    this.top = g.top, this.right = g.right, this.domWidth = g.width, this.domHeight = g.height, this.overviewRulerLanes === 0 ? (this.canvasWidth = 0, this.canvasHeight = 0) : (this.canvasWidth = this.domWidth * this.pixelRatio | 0, this.canvasHeight = this.domHeight * this.pixelRatio | 0);
    const [p, f] = this._initLanes(1, this.canvasWidth, this.overviewRulerLanes);
    this.x = p, this.w = f;
  }
  _initLanes(e, t, n) {
    const s = t - e;
    if (n >= 3) {
      const o = Math.floor(s / 3), r = Math.floor(s / 3), a = s - o - r, l = e + o;
      return [[0, e, l, e, e + o + a, e, l, e], [0, o, a, o + a, r, o + a + r, a + r, o + a + r]];
    }
    if (n === 2) {
      const o = Math.floor(s / 2), r = s - o;
      return [[0, e, e, e, e + o, e, e, e], [0, o, o, o, r, o + r, o + r, o + r]];
    }
    return [[0, e, e, e, e, e, e, e], [0, s, s, s, s, s, s, s]];
  }
  equals(e) {
    return this.lineHeight === e.lineHeight && this.pixelRatio === e.pixelRatio && this.overviewRulerLanes === e.overviewRulerLanes && this.renderBorder === e.renderBorder && this.borderColor === e.borderColor && this.hideCursor === e.hideCursor && this.cursorColorSingle === e.cursorColorSingle && this.cursorColorPrimary === e.cursorColorPrimary && this.cursorColorSecondary === e.cursorColorSecondary && this.themeType === e.themeType && z.equals(this.backgroundColor, e.backgroundColor) && this.top === e.top && this.right === e.right && this.domWidth === e.domWidth && this.domHeight === e.domHeight && this.canvasWidth === e.canvasWidth && this.canvasHeight === e.canvasHeight;
  }
}
class BY extends to {
  constructor(e) {
    super(e), this._actualShouldRender = 0, this._renderedDecorations = [], this._renderedCursorPositions = [], this._domNode = wt(document.createElement("canvas")), this._domNode.setClassName("decorationsOverviewRuler"), this._domNode.setPosition("absolute"), this._domNode.setLayerHinting(!0), this._domNode.setContain("strict"), this._domNode.setAttribute("aria-hidden", "true"), this._updateSettings(!1), this._tokensColorTrackerListener = ci.onDidChange((t) => {
      t.changedColorMap && this._updateSettings(!0);
    }), this._cursorPositions = [{ position: new W(1, 1), color: this._settings.cursorColorSingle }];
  }
  dispose() {
    super.dispose(), this._tokensColorTrackerListener.dispose();
  }
  _updateSettings(e) {
    const t = new FY(this._context.configuration, this._context.theme);
    return (!this._settings || !this._settings.equals(t)) && (this._settings = t, this._domNode.setTop(this._settings.top), this._domNode.setRight(this._settings.right), this._domNode.setWidth(this._settings.domWidth), this._domNode.setHeight(this._settings.domHeight), this._domNode.domNode.width = this._settings.canvasWidth, this._domNode.domNode.height = this._settings.canvasHeight, e && this._render(), !0);
  }
  _markRenderingIsNeeded() {
    return this._actualShouldRender = 2, !0;
  }
  _markRenderingIsMaybeNeeded() {
    return this._actualShouldRender = 1, !0;
  }
  onConfigurationChanged(e) {
    return !!this._updateSettings(!1) && this._markRenderingIsNeeded();
  }
  onCursorStateChanged(e) {
    this._cursorPositions = [];
    for (let t = 0, n = e.selections.length; t < n; t++) {
      let s = this._settings.cursorColorSingle;
      n > 1 && (s = t === 0 ? this._settings.cursorColorPrimary : this._settings.cursorColorSecondary), this._cursorPositions.push({ position: e.selections[t].getPosition(), color: s });
    }
    return this._cursorPositions.sort((t, n) => W.compare(t.position, n.position)), this._markRenderingIsMaybeNeeded();
  }
  onDecorationsChanged(e) {
    return !!e.affectsOverviewRuler && this._markRenderingIsMaybeNeeded();
  }
  onFlushed(e) {
    return this._markRenderingIsNeeded();
  }
  onScrollChanged(e) {
    return !!e.scrollHeightChanged && this._markRenderingIsNeeded();
  }
  onZonesChanged(e) {
    return this._markRenderingIsNeeded();
  }
  onThemeChanged(e) {
    return !!this._updateSettings(!1) && this._markRenderingIsNeeded();
  }
  getDomNode() {
    return this._domNode.domNode;
  }
  prepareRender(e) {
  }
  render(e) {
    this._render(), this._actualShouldRender = 0;
  }
  _render() {
    const e = this._settings.backgroundColor;
    if (this._settings.overviewRulerLanes === 0) return this._domNode.setBackgroundColor(e ? z.Format.CSS.formatHexA(e) : ""), void this._domNode.setDisplay("none");
    const t = this._context.viewModel.getAllOverviewRulerDecorations(this._context.theme);
    if (t.sort(dv.compareByRenderingProps), this._actualShouldRender !== 1 || dv.equalsArr(this._renderedDecorations, t) || (this._actualShouldRender = 2), this._actualShouldRender !== 1 || ri(this._renderedCursorPositions, this._cursorPositions, (g, p) => g.position.lineNumber === p.position.lineNumber && g.color === p.color) || (this._actualShouldRender = 2), this._actualShouldRender === 1) return;
    this._renderedDecorations = t, this._renderedCursorPositions = this._cursorPositions, this._domNode.setDisplay("block");
    const n = this._settings.canvasWidth, s = this._settings.canvasHeight, o = this._settings.lineHeight, r = this._context.viewLayout, a = s / this._context.viewLayout.getScrollHeight(), l = 6 * this._settings.pixelRatio | 0, d = l / 2 | 0, h = this._domNode.domNode.getContext("2d");
    e ? e.isOpaque() ? (h.fillStyle = z.Format.CSS.formatHexA(e), h.fillRect(0, 0, n, s)) : (h.clearRect(0, 0, n, s), h.fillStyle = z.Format.CSS.formatHexA(e), h.fillRect(0, 0, n, s)) : h.clearRect(0, 0, n, s);
    const c = this._settings.x, u = this._settings.w;
    for (const g of t) {
      const p = g.color, f = g.data;
      h.fillStyle = p;
      let _ = 0, v = 0, b = 0;
      for (let C = 0, w = f.length / 3; C < w; C++) {
        const y = f[3 * C], L = f[3 * C + 1], k = f[3 * C + 2];
        let N = r.getVerticalOffsetForLineNumber(L) * a | 0, A = (r.getVerticalOffsetForLineNumber(k) + o) * a | 0;
        if (A - N < l) {
          let B = (N + A) / 2 | 0;
          B < d ? B = d : B + d > s && (B = s - d), N = B - d, A = B + d;
        }
        N > b + 1 || y !== _ ? (C !== 0 && h.fillRect(c[_], v, u[_], b - v), _ = y, v = N, b = A) : A > b && (b = A);
      }
      h.fillRect(c[_], v, u[_], b - v);
    }
    if (!this._settings.hideCursor) {
      const g = 2 * this._settings.pixelRatio | 0, p = g / 2 | 0, f = this._settings.x[7], _ = this._settings.w[7];
      let v = -100, b = -100, C = null;
      for (let w = 0, y = this._cursorPositions.length; w < y; w++) {
        const L = this._cursorPositions[w].color;
        if (!L) continue;
        const k = this._cursorPositions[w].position;
        let N = r.getVerticalOffsetForLineNumber(k.lineNumber) * a | 0;
        N < p ? N = p : N + p > s && (N = s - p);
        const A = N - p, B = A + g;
        A > b + 1 || L !== C ? (w !== 0 && C && h.fillRect(f, v, _, b - v), v = A, b = B) : B > b && (b = B), C = L, h.fillStyle = L;
      }
      C && h.fillRect(f, v, _, b - v);
    }
    this._settings.renderBorder && this._settings.borderColor && this._settings.overviewRulerLanes > 0 && (h.beginPath(), h.lineWidth = 1, h.strokeStyle = this._settings.borderColor, h.moveTo(0, 0), h.lineTo(0, s), h.stroke(), h.moveTo(0, 0), h.lineTo(n, 0), h.stroke());
  }
}
class r5 {
  constructor(e, t, n) {
    this._colorZoneBrand = void 0, this.from = 0 | e, this.to = 0 | t, this.colorId = 0 | n;
  }
  static compare(e, t) {
    return e.colorId === t.colorId ? e.from === t.from ? e.to - t.to : e.from - t.from : e.colorId - t.colorId;
  }
}
class $B {
  constructor(e, t, n, s) {
    this._overviewRulerZoneBrand = void 0, this.startLineNumber = e, this.endLineNumber = t, this.heightInLines = n, this.color = s, this._colorZone = null;
  }
  static compare(e, t) {
    return e.color === t.color ? e.startLineNumber === t.startLineNumber ? e.heightInLines === t.heightInLines ? e.endLineNumber - t.endLineNumber : e.heightInLines - t.heightInLines : e.startLineNumber - t.startLineNumber : e.color < t.color ? -1 : 1;
  }
  setColorZone(e) {
    this._colorZone = e;
  }
  getColorZones() {
    return this._colorZone;
  }
}
class WY {
  constructor(e) {
    this._getVerticalOffsetForLine = e, this._zones = [], this._colorZonesInvalid = !1, this._lineHeight = 0, this._domWidth = 0, this._domHeight = 0, this._outerHeight = 0, this._pixelRatio = 1, this._lastAssignedId = 0, this._color2Id = /* @__PURE__ */ Object.create(null), this._id2Color = [];
  }
  getId2Color() {
    return this._id2Color;
  }
  setZones(e) {
    this._zones = e, this._zones.sort($B.compare);
  }
  setLineHeight(e) {
    return this._lineHeight !== e && (this._lineHeight = e, this._colorZonesInvalid = !0, !0);
  }
  setPixelRatio(e) {
    this._pixelRatio = e, this._colorZonesInvalid = !0;
  }
  getDOMWidth() {
    return this._domWidth;
  }
  getCanvasWidth() {
    return this._domWidth * this._pixelRatio;
  }
  setDOMWidth(e) {
    return this._domWidth !== e && (this._domWidth = e, this._colorZonesInvalid = !0, !0);
  }
  getDOMHeight() {
    return this._domHeight;
  }
  getCanvasHeight() {
    return this._domHeight * this._pixelRatio;
  }
  setDOMHeight(e) {
    return this._domHeight !== e && (this._domHeight = e, this._colorZonesInvalid = !0, !0);
  }
  getOuterHeight() {
    return this._outerHeight;
  }
  setOuterHeight(e) {
    return this._outerHeight !== e && (this._outerHeight = e, this._colorZonesInvalid = !0, !0);
  }
  resolveColorZones() {
    const e = this._colorZonesInvalid, t = Math.floor(this._lineHeight), n = Math.floor(this.getCanvasHeight()), s = n / Math.floor(this._outerHeight), o = Math.floor(4 * this._pixelRatio / 2), r = [];
    for (let a = 0, l = this._zones.length; a < l; a++) {
      const d = this._zones[a];
      if (!e) {
        const C = d.getColorZones();
        if (C) {
          r.push(C);
          continue;
        }
      }
      const h = this._getVerticalOffsetForLine(d.startLineNumber), c = d.heightInLines === 0 ? this._getVerticalOffsetForLine(d.endLineNumber) + t : h + d.heightInLines * t, u = Math.floor(s * h), g = Math.floor(s * c);
      let p = Math.floor((u + g) / 2), f = g - p;
      f < o && (f = o), p - f < 0 && (p = f), p + f > n && (p = n - f);
      const _ = d.color;
      let v = this._color2Id[_];
      v || (v = ++this._lastAssignedId, this._color2Id[_] = v, this._id2Color[v] = _);
      const b = new r5(p - f, p + f, v);
      d.setColorZone(b), r.push(b);
    }
    return this._colorZonesInvalid = !1, r.sort(r5.compare), r;
  }
}
class VY extends L1 {
  constructor(e, t) {
    super(), this._context = e;
    const n = this._context.configuration.options;
    this._domNode = wt(document.createElement("canvas")), this._domNode.setClassName(t), this._domNode.setPosition("absolute"), this._domNode.setLayerHinting(!0), this._domNode.setContain("strict"), this._zoneManager = new WY((s) => this._context.viewLayout.getVerticalOffsetForLineNumber(s)), this._zoneManager.setDOMWidth(0), this._zoneManager.setDOMHeight(0), this._zoneManager.setOuterHeight(this._context.viewLayout.getScrollHeight()), this._zoneManager.setLineHeight(n.get(67)), this._zoneManager.setPixelRatio(n.get(143)), this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), super.dispose();
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    return e.hasChanged(67) && (this._zoneManager.setLineHeight(t.get(67)), this._render()), e.hasChanged(143) && (this._zoneManager.setPixelRatio(t.get(143)), this._domNode.setWidth(this._zoneManager.getDOMWidth()), this._domNode.setHeight(this._zoneManager.getDOMHeight()), this._domNode.domNode.width = this._zoneManager.getCanvasWidth(), this._domNode.domNode.height = this._zoneManager.getCanvasHeight(), this._render()), !0;
  }
  onFlushed(e) {
    return this._render(), !0;
  }
  onScrollChanged(e) {
    return e.scrollHeightChanged && (this._zoneManager.setOuterHeight(e.scrollHeight), this._render()), !0;
  }
  onZonesChanged(e) {
    return this._render(), !0;
  }
  getDomNode() {
    return this._domNode.domNode;
  }
  setLayout(e) {
    this._domNode.setTop(e.top), this._domNode.setRight(e.right);
    let t = !1;
    t = this._zoneManager.setDOMWidth(e.width) || t, t = this._zoneManager.setDOMHeight(e.height) || t, t && (this._domNode.setWidth(this._zoneManager.getDOMWidth()), this._domNode.setHeight(this._zoneManager.getDOMHeight()), this._domNode.domNode.width = this._zoneManager.getCanvasWidth(), this._domNode.domNode.height = this._zoneManager.getCanvasHeight(), this._render());
  }
  setZones(e) {
    this._zoneManager.setZones(e), this._render();
  }
  _render() {
    if (this._zoneManager.getOuterHeight() === 0) return !1;
    const e = this._zoneManager.getCanvasWidth(), t = this._zoneManager.getCanvasHeight(), n = this._zoneManager.resolveColorZones(), s = this._zoneManager.getId2Color(), o = this._domNode.domNode.getContext("2d");
    return o.clearRect(0, 0, e, t), n.length > 0 && this._renderOneLane(o, n, s, e), !0;
  }
  _renderOneLane(e, t, n, s) {
    let o = 0, r = 0, a = 0;
    for (const l of t) {
      const d = l.colorId, h = l.from, c = l.to;
      d !== o ? (e.fillRect(0, r, s, a - r), o = d, e.fillStyle = n[o], r = h, a = c) : a >= h ? a = Math.max(a, c) : (e.fillRect(0, r, s, a - r), r = h, a = c);
    }
    e.fillRect(0, r, s, a - r);
  }
}
class HY extends to {
  constructor(e) {
    super(e), this.domNode = wt(document.createElement("div")), this.domNode.setAttribute("role", "presentation"), this.domNode.setAttribute("aria-hidden", "true"), this.domNode.setClassName("view-rulers"), this._renderedRulers = [];
    const t = this._context.configuration.options;
    this._rulers = t.get(102), this._typicalHalfwidthCharacterWidth = t.get(50).typicalHalfwidthCharacterWidth;
  }
  dispose() {
    super.dispose();
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    return this._rulers = t.get(102), this._typicalHalfwidthCharacterWidth = t.get(50).typicalHalfwidthCharacterWidth, !0;
  }
  onScrollChanged(e) {
    return e.scrollHeightChanged;
  }
  prepareRender(e) {
  }
  _ensureRulersCount() {
    const e = this._renderedRulers.length, t = this._rulers.length;
    if (e === t) return;
    if (e < t) {
      const { tabSize: s } = this._context.viewModel.model.getOptions(), o = s;
      let r = t - e;
      for (; r > 0; ) {
        const a = wt(document.createElement("div"));
        a.setClassName("view-ruler"), a.setWidth(o), this.domNode.appendChild(a), this._renderedRulers.push(a), r--;
      }
      return;
    }
    let n = e - t;
    for (; n > 0; ) {
      const s = this._renderedRulers.pop();
      this.domNode.removeChild(s), n--;
    }
  }
  render(e) {
    this._ensureRulersCount();
    for (let t = 0, n = this._rulers.length; t < n; t++) {
      const s = this._renderedRulers[t], o = this._rulers[t];
      s.setBoxShadow(o.color ? `1px 0 0 0 ${o.color} inset` : ""), s.setHeight(Math.min(e.scrollHeight, 1e6)), s.setLeft(o.column * this._typicalHalfwidthCharacterWidth);
    }
  }
}
class zY extends to {
  constructor(e) {
    super(e), this._scrollTop = 0, this._width = 0, this._updateWidth(), this._shouldShow = !1;
    const t = this._context.configuration.options.get(103);
    this._useShadows = t.useShadows, this._domNode = wt(document.createElement("div")), this._domNode.setAttribute("role", "presentation"), this._domNode.setAttribute("aria-hidden", "true");
  }
  dispose() {
    super.dispose();
  }
  _updateShouldShow() {
    const e = this._useShadows && this._scrollTop > 0;
    return this._shouldShow !== e && (this._shouldShow = e, !0);
  }
  getDomNode() {
    return this._domNode;
  }
  _updateWidth() {
    const e = this._context.configuration.options.get(145);
    e.minimap.renderMinimap === 0 || e.minimap.minimapWidth > 0 && e.minimap.minimapLeft === 0 ? this._width = e.width : this._width = e.width - e.verticalScrollbarWidth;
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options.get(103);
    return this._useShadows = t.useShadows, this._updateWidth(), this._updateShouldShow(), !0;
  }
  onScrollChanged(e) {
    return this._scrollTop = e.scrollTop, this._updateShouldShow();
  }
  prepareRender(e) {
  }
  render(e) {
    this._domNode.setWidth(this._width), this._domNode.setClassName(this._shouldShow ? "scroll-decoration" : "");
  }
}
class UY {
  constructor(e) {
    this.left = e.left, this.width = e.width, this.startStyle = null, this.endStyle = null;
  }
}
class KY {
  constructor(e, t) {
    this.lineNumber = e, this.ranges = t;
  }
}
function jY(i) {
  return new UY(i);
}
function qY(i) {
  return new KY(i.lineNumber, i.ranges.map(jY));
}
class yi extends Mg {
  constructor(e) {
    super(), this._previousFrameVisibleRangesWithStyle = [], this._context = e;
    const t = this._context.configuration.options;
    this._roundedSelection = t.get(101), this._typicalHalfwidthCharacterWidth = t.get(50).typicalHalfwidthCharacterWidth, this._selections = [], this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    return this._roundedSelection = t.get(101), this._typicalHalfwidthCharacterWidth = t.get(50).typicalHalfwidthCharacterWidth, !0;
  }
  onCursorStateChanged(e) {
    return this._selections = e.selections.slice(0), !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  _visibleRangesHaveGaps(e) {
    for (let t = 0, n = e.length; t < n; t++)
      if (e[t].ranges.length > 1) return !0;
    return !1;
  }
  _enrichVisibleRangesWithStyle(e, t, n) {
    const s = this._typicalHalfwidthCharacterWidth / 4;
    let o = null, r = null;
    if (n && n.length > 0 && t.length > 0) {
      const a = t[0].lineNumber;
      if (a === e.startLineNumber) for (let d = 0; !o && d < n.length; d++) n[d].lineNumber === a && (o = n[d].ranges[0]);
      const l = t[t.length - 1].lineNumber;
      if (l === e.endLineNumber) for (let d = n.length - 1; !r && d >= 0; d--) n[d].lineNumber === l && (r = n[d].ranges[0]);
      o && !o.startStyle && (o = null), r && !r.startStyle && (r = null);
    }
    for (let a = 0, l = t.length; a < l; a++) {
      const d = t[a].ranges[0], h = d.left, c = d.left + d.width, u = { top: 0, bottom: 0 }, g = { top: 0, bottom: 0 };
      if (a > 0) {
        const p = t[a - 1].ranges[0].left, f = t[a - 1].ranges[0].left + t[a - 1].ranges[0].width;
        bb(h - p) < s ? u.top = 2 : h > p && (u.top = 1), bb(c - f) < s ? g.top = 2 : p < c && c < f && (g.top = 1);
      } else o && (u.top = o.startStyle.top, g.top = o.endStyle.top);
      if (a + 1 < l) {
        const p = t[a + 1].ranges[0].left, f = t[a + 1].ranges[0].left + t[a + 1].ranges[0].width;
        bb(h - p) < s ? u.bottom = 2 : p < h && h < f && (u.bottom = 1), bb(c - f) < s ? g.bottom = 2 : c < f && (g.bottom = 1);
      } else r && (u.bottom = r.startStyle.bottom, g.bottom = r.endStyle.bottom);
      d.startStyle = u, d.endStyle = g;
    }
  }
  _getVisibleRangesWithStyle(e, t, n) {
    const s = (t.linesVisibleRangesForRange(e, !0) || []).map(qY);
    return !this._visibleRangesHaveGaps(s) && this._roundedSelection && this._enrichVisibleRangesWithStyle(t.visibleRange, s, n), s;
  }
  _createSelectionPiece(e, t, n, s, o) {
    return '<div class="cslr ' + n + '" style="top:' + e.toString() + "px;bottom:" + t.toString() + "px;left:" + s.toString() + "px;width:" + o.toString() + 'px;"></div>';
  }
  _actualRenderOneSelection(e, t, n, s) {
    if (s.length === 0) return;
    const o = !!s[0].ranges[0].startStyle, r = s[0].lineNumber, a = s[s.length - 1].lineNumber;
    for (let l = 0, d = s.length; l < d; l++) {
      const h = s[l], c = h.lineNumber, u = c - t, g = n && c === r ? 1 : 0, p = n && c !== r && c === a ? 1 : 0;
      let f = "", _ = "";
      for (let v = 0, b = h.ranges.length; v < b; v++) {
        const C = h.ranges[v];
        if (o) {
          const y = C.startStyle, L = C.endStyle;
          if (y.top === 1 || y.bottom === 1) {
            f += this._createSelectionPiece(g, p, yi.SELECTION_CLASS_NAME, C.left - yi.ROUNDED_PIECE_WIDTH, yi.ROUNDED_PIECE_WIDTH);
            let k = yi.EDITOR_BACKGROUND_CLASS_NAME;
            y.top === 1 && (k += " " + yi.SELECTION_TOP_RIGHT), y.bottom === 1 && (k += " " + yi.SELECTION_BOTTOM_RIGHT), f += this._createSelectionPiece(g, p, k, C.left - yi.ROUNDED_PIECE_WIDTH, yi.ROUNDED_PIECE_WIDTH);
          }
          if (L.top === 1 || L.bottom === 1) {
            f += this._createSelectionPiece(g, p, yi.SELECTION_CLASS_NAME, C.left + C.width, yi.ROUNDED_PIECE_WIDTH);
            let k = yi.EDITOR_BACKGROUND_CLASS_NAME;
            L.top === 1 && (k += " " + yi.SELECTION_TOP_LEFT), L.bottom === 1 && (k += " " + yi.SELECTION_BOTTOM_LEFT), f += this._createSelectionPiece(g, p, k, C.left + C.width, yi.ROUNDED_PIECE_WIDTH);
          }
        }
        let w = yi.SELECTION_CLASS_NAME;
        if (o) {
          const y = C.startStyle, L = C.endStyle;
          y.top === 0 && (w += " " + yi.SELECTION_TOP_LEFT), y.bottom === 0 && (w += " " + yi.SELECTION_BOTTOM_LEFT), L.top === 0 && (w += " " + yi.SELECTION_TOP_RIGHT), L.bottom === 0 && (w += " " + yi.SELECTION_BOTTOM_RIGHT);
        }
        _ += this._createSelectionPiece(g, p, w, C.left, C.width);
      }
      e[u][0] += f, e[u][1] += _;
    }
  }
  prepareRender(e) {
    const t = [], n = e.visibleRange.startLineNumber, s = e.visibleRange.endLineNumber;
    for (let r = n; r <= s; r++)
      t[r - n] = ["", ""];
    const o = [];
    for (let r = 0, a = this._selections.length; r < a; r++) {
      const l = this._selections[r];
      if (l.isEmpty()) {
        o[r] = null;
        continue;
      }
      const d = this._getVisibleRangesWithStyle(l, e, this._previousFrameVisibleRangesWithStyle[r]);
      o[r] = d, this._actualRenderOneSelection(t, n, this._selections.length > 1, d);
    }
    this._previousFrameVisibleRangesWithStyle = o, this._renderResult = t.map(([r, a]) => r + a);
  }
  render(e, t) {
    if (!this._renderResult) return "";
    const n = t - e;
    return n < 0 || n >= this._renderResult.length ? "" : this._renderResult[n];
  }
}
function bb(i) {
  return i < 0 ? -i : i;
}
yi.SELECTION_CLASS_NAME = "selected-text", yi.SELECTION_TOP_LEFT = "top-left-radius", yi.SELECTION_BOTTOM_LEFT = "bottom-left-radius", yi.SELECTION_TOP_RIGHT = "top-right-radius", yi.SELECTION_BOTTOM_RIGHT = "bottom-right-radius", yi.EDITOR_BACKGROUND_CLASS_NAME = "monaco-editor-background", yi.ROUNDED_PIECE_WIDTH = 10, rr((i, e) => {
  const t = i.getColor(b$);
  t && !t.isTransparent() && e.addRule(`.monaco-editor .view-line span.inline-selected-text { color: ${t}; }`);
});
class a5 {
  constructor(e, t, n, s, o, r, a) {
    this.top = e, this.left = t, this.paddingLeft = n, this.width = s, this.height = o, this.textContent = r, this.textContentClassName = a;
  }
}
var vd;
(function(i) {
  i[i.Single = 0] = "Single", i[i.MultiPrimary = 1] = "MultiPrimary", i[i.MultiSecondary = 2] = "MultiSecondary";
})(vd || (vd = {}));
class l5 {
  constructor(e, t) {
    this._context = e;
    const n = this._context.configuration.options, s = n.get(50);
    this._cursorStyle = n.get(28), this._lineHeight = n.get(67), this._typicalHalfwidthCharacterWidth = s.typicalHalfwidthCharacterWidth, this._lineCursorWidth = Math.min(n.get(31), this._typicalHalfwidthCharacterWidth), this._isVisible = !0, this._domNode = wt(document.createElement("div")), this._domNode.setClassName(`cursor ${om}`), this._domNode.setHeight(this._lineHeight), this._domNode.setTop(0), this._domNode.setLeft(0), yn(this._domNode, s), this._domNode.setDisplay("none"), this._position = new W(1, 1), this._pluralityClass = "", this.setPlurality(t), this._lastRenderedContent = "", this._renderData = null;
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return this._position;
  }
  setPlurality(e) {
    switch (e) {
      default:
      case vd.Single:
        this._pluralityClass = "";
        break;
      case vd.MultiPrimary:
        this._pluralityClass = "cursor-primary";
        break;
      case vd.MultiSecondary:
        this._pluralityClass = "cursor-secondary";
    }
  }
  show() {
    this._isVisible || (this._domNode.setVisibility("inherit"), this._isVisible = !0);
  }
  hide() {
    this._isVisible && (this._domNode.setVisibility("hidden"), this._isVisible = !1);
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, n = t.get(50);
    return this._cursorStyle = t.get(28), this._lineHeight = t.get(67), this._typicalHalfwidthCharacterWidth = n.typicalHalfwidthCharacterWidth, this._lineCursorWidth = Math.min(t.get(31), this._typicalHalfwidthCharacterWidth), yn(this._domNode, n), !0;
  }
  onCursorPositionChanged(e, t) {
    return this._domNode.domNode.style.transitionProperty = t ? "none" : "", this._position = e, !0;
  }
  _getGraphemeAwarePosition() {
    const { lineNumber: e, column: t } = this._position, n = this._context.viewModel.getLineContent(e), [s, o] = function(r, a) {
      a > 0 && ag(r.charCodeAt(a)) && a--;
      const l = a + aR(r, a);
      return [l - e8(r, l), l];
    }(n, t - 1);
    return [new W(e, s + 1), n.substring(s, o)];
  }
  _prepareRender(e) {
    let t = "", n = "";
    const [s, o] = this._getGraphemeAwarePosition();
    if (this._cursorStyle === vn.Line || this._cursorStyle === vn.LineThin) {
      const u = e.visibleRangeForPosition(s);
      if (!u || u.outsideRenderedLine) return null;
      const g = ke(this._domNode.domNode);
      let p;
      this._cursorStyle === vn.Line ? (p = kO(g, this._lineCursorWidth > 0 ? this._lineCursorWidth : 2), p > 2 && (t = o, n = this._getTokenClassName(s))) : p = kO(g, 1);
      let f = u.left, _ = 0;
      p >= 2 && f >= 1 && (_ = 1, f -= _);
      const v = e.getVerticalOffsetForLineNumber(s.lineNumber) - e.bigNumbersDelta;
      return new a5(v, f, _, p, this._lineHeight, t, n);
    }
    const r = e.linesVisibleRangesForRange(new D(s.lineNumber, s.column, s.lineNumber, s.column + o.length), !1);
    if (!r || r.length === 0) return null;
    const a = r[0];
    if (a.outsideRenderedLine || a.ranges.length === 0) return null;
    const l = a.ranges[0], d = o === "	" || l.width < 1 ? this._typicalHalfwidthCharacterWidth : l.width;
    this._cursorStyle === vn.Block && (t = o, n = this._getTokenClassName(s));
    let h = e.getVerticalOffsetForLineNumber(s.lineNumber) - e.bigNumbersDelta, c = this._lineHeight;
    return this._cursorStyle !== vn.Underline && this._cursorStyle !== vn.UnderlineThin || (h += this._lineHeight - 2, c = 2), new a5(h, l.left, 0, d, c, t, n);
  }
  _getTokenClassName(e) {
    const t = this._context.viewModel.getViewLineData(e.lineNumber), n = t.tokens.findTokenIndexAtOffset(e.column - 1);
    return t.tokens.getClassName(n);
  }
  prepareRender(e) {
    this._renderData = this._prepareRender(e);
  }
  render(e) {
    return this._renderData ? (this._lastRenderedContent !== this._renderData.textContent && (this._lastRenderedContent = this._renderData.textContent, this._domNode.domNode.textContent = this._lastRenderedContent), this._domNode.setClassName(`cursor ${this._pluralityClass} ${om} ${this._renderData.textContentClassName}`), this._domNode.setDisplay("block"), this._domNode.setTop(this._renderData.top), this._domNode.setLeft(this._renderData.left), this._domNode.setPaddingLeft(this._renderData.paddingLeft), this._domNode.setWidth(this._renderData.width), this._domNode.setLineHeight(this._renderData.height), this._domNode.setHeight(this._renderData.height), { domNode: this._domNode.domNode, position: this._position, contentLeft: this._renderData.left, height: this._renderData.height, width: 2 }) : (this._domNode.setDisplay("none"), null);
  }
}
class Cv extends to {
  constructor(e) {
    super(e);
    const t = this._context.configuration.options;
    this._readOnly = t.get(91), this._cursorBlinking = t.get(26), this._cursorStyle = t.get(28), this._cursorSmoothCaretAnimation = t.get(27), this._selectionIsEmpty = !0, this._isComposingInput = !1, this._isVisible = !1, this._primaryCursor = new l5(this._context, vd.Single), this._secondaryCursors = [], this._renderData = [], this._domNode = wt(document.createElement("div")), this._domNode.setAttribute("role", "presentation"), this._domNode.setAttribute("aria-hidden", "true"), this._updateDomClassName(), this._domNode.appendChild(this._primaryCursor.getDomNode()), this._startCursorBlinkAnimation = new Dr(), this._cursorFlatBlinkInterval = new pR(), this._blinkingEnabled = !1, this._editorHasFocus = !1, this._updateBlinking();
  }
  dispose() {
    super.dispose(), this._startCursorBlinkAnimation.dispose(), this._cursorFlatBlinkInterval.dispose();
  }
  getDomNode() {
    return this._domNode;
  }
  onCompositionStart(e) {
    return this._isComposingInput = !0, this._updateBlinking(), !0;
  }
  onCompositionEnd(e) {
    return this._isComposingInput = !1, this._updateBlinking(), !0;
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    this._readOnly = t.get(91), this._cursorBlinking = t.get(26), this._cursorStyle = t.get(28), this._cursorSmoothCaretAnimation = t.get(27), this._updateBlinking(), this._updateDomClassName(), this._primaryCursor.onConfigurationChanged(e);
    for (let n = 0, s = this._secondaryCursors.length; n < s; n++) this._secondaryCursors[n].onConfigurationChanged(e);
    return !0;
  }
  _onCursorPositionChanged(e, t, n) {
    const s = this._secondaryCursors.length !== t.length || this._cursorSmoothCaretAnimation === "explicit" && n !== 3;
    if (this._primaryCursor.setPlurality(t.length ? vd.MultiPrimary : vd.Single), this._primaryCursor.onCursorPositionChanged(e, s), this._updateBlinking(), this._secondaryCursors.length < t.length) {
      const o = t.length - this._secondaryCursors.length;
      for (let r = 0; r < o; r++) {
        const a = new l5(this._context, vd.MultiSecondary);
        this._domNode.domNode.insertBefore(a.getDomNode().domNode, this._primaryCursor.getDomNode().domNode.nextSibling), this._secondaryCursors.push(a);
      }
    } else if (this._secondaryCursors.length > t.length) {
      const o = this._secondaryCursors.length - t.length;
      for (let r = 0; r < o; r++) this._domNode.removeChild(this._secondaryCursors[0].getDomNode()), this._secondaryCursors.splice(0, 1);
    }
    for (let o = 0; o < t.length; o++) this._secondaryCursors[o].onCursorPositionChanged(t[o], s);
  }
  onCursorStateChanged(e) {
    const t = [];
    for (let s = 0, o = e.selections.length; s < o; s++) t[s] = e.selections[s].getPosition();
    this._onCursorPositionChanged(t[0], t.slice(1), e.reason);
    const n = e.selections[0].isEmpty();
    return this._selectionIsEmpty !== n && (this._selectionIsEmpty = n, this._updateDomClassName()), !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onFocusChanged(e) {
    return this._editorHasFocus = e.isFocused, this._updateBlinking(), !1;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return !0;
  }
  onTokensChanged(e) {
    const t = (n) => {
      for (let s = 0, o = e.ranges.length; s < o; s++) if (e.ranges[s].fromLineNumber <= n.lineNumber && n.lineNumber <= e.ranges[s].toLineNumber) return !0;
      return !1;
    };
    if (t(this._primaryCursor.getPosition())) return !0;
    for (const n of this._secondaryCursors) if (t(n.getPosition())) return !0;
    return !1;
  }
  onZonesChanged(e) {
    return !0;
  }
  _getCursorBlinking() {
    return this._isComposingInput ? 0 : this._editorHasFocus ? this._readOnly ? 5 : this._cursorBlinking : 0;
  }
  _updateBlinking() {
    this._startCursorBlinkAnimation.cancel(), this._cursorFlatBlinkInterval.cancel();
    const e = this._getCursorBlinking(), t = e === 0, n = e === 5;
    t ? this._hide() : this._show(), this._blinkingEnabled = !1, this._updateDomClassName(), t || n || (e === 1 ? this._cursorFlatBlinkInterval.cancelAndSet(() => {
      this._isVisible ? this._hide() : this._show();
    }, Cv.BLINK_INTERVAL, ke(this._domNode.domNode)) : this._startCursorBlinkAnimation.setIfNotSet(() => {
      this._blinkingEnabled = !0, this._updateDomClassName();
    }, Cv.BLINK_INTERVAL));
  }
  _updateDomClassName() {
    this._domNode.setClassName(this._getClassName());
  }
  _getClassName() {
    let e = "cursors-layer";
    switch (this._selectionIsEmpty || (e += " has-selection"), this._cursorStyle) {
      case vn.Line:
        e += " cursor-line-style";
        break;
      case vn.Block:
        e += " cursor-block-style";
        break;
      case vn.Underline:
        e += " cursor-underline-style";
        break;
      case vn.LineThin:
        e += " cursor-line-thin-style";
        break;
      case vn.BlockOutline:
        e += " cursor-block-outline-style";
        break;
      case vn.UnderlineThin:
        e += " cursor-underline-thin-style";
        break;
      default:
        e += " cursor-line-style";
    }
    if (this._blinkingEnabled) switch (this._getCursorBlinking()) {
      case 1:
        e += " cursor-blink";
        break;
      case 2:
        e += " cursor-smooth";
        break;
      case 3:
        e += " cursor-phase";
        break;
      case 4:
        e += " cursor-expand";
        break;
      default:
        e += " cursor-solid";
    }
    else e += " cursor-solid";
    return this._cursorSmoothCaretAnimation !== "on" && this._cursorSmoothCaretAnimation !== "explicit" || (e += " cursor-smooth-caret-animation"), e;
  }
  _show() {
    this._primaryCursor.show();
    for (let e = 0, t = this._secondaryCursors.length; e < t; e++) this._secondaryCursors[e].show();
    this._isVisible = !0;
  }
  _hide() {
    this._primaryCursor.hide();
    for (let e = 0, t = this._secondaryCursors.length; e < t; e++) this._secondaryCursors[e].hide();
    this._isVisible = !1;
  }
  prepareRender(e) {
    this._primaryCursor.prepareRender(e);
    for (let t = 0, n = this._secondaryCursors.length; t < n; t++) this._secondaryCursors[t].prepareRender(e);
  }
  render(e) {
    const t = [];
    let n = 0;
    const s = this._primaryCursor.render(e);
    s && (t[n++] = s);
    for (let o = 0, r = this._secondaryCursors.length; o < r; o++) {
      const a = this._secondaryCursors[o].render(e);
      a && (t[n++] = a);
    }
    this._renderData = t;
  }
  getLastRenderData() {
    return this._renderData;
  }
}
Cv.BLINK_INTERVAL = 500, rr((i, e) => {
  const t = [{ class: ".cursor", foreground: ll, background: fd }, { class: ".cursor-primary", foreground: NB, background: fZ }, { class: ".cursor-secondary", foreground: EB, background: _Z }];
  for (const n of t) {
    const s = i.getColor(n.foreground);
    if (s) {
      let o = i.getColor(n.background);
      o || (o = s.opposite()), e.addRule(`.monaco-editor .cursors-layer ${n.class} { background-color: ${s}; border-color: ${s}; color: ${o}; }`), la(i.type) && e.addRule(`.monaco-editor .cursors-layer.has-selection ${n.class} { border-left: 1px solid ${o}; border-right: 1px solid ${o}; }`);
    }
  }
});
const wD = () => {
  throw new Error("Invalid change accessor");
};
class $Y extends to {
  constructor(e) {
    super(e);
    const t = this._context.configuration.options, n = t.get(145);
    this._lineHeight = t.get(67), this._contentWidth = n.contentWidth, this._contentLeft = n.contentLeft, this.domNode = wt(document.createElement("div")), this.domNode.setClassName("view-zones"), this.domNode.setPosition("absolute"), this.domNode.setAttribute("role", "presentation"), this.domNode.setAttribute("aria-hidden", "true"), this.marginDomNode = wt(document.createElement("div")), this.marginDomNode.setClassName("margin-view-zones"), this.marginDomNode.setPosition("absolute"), this.marginDomNode.setAttribute("role", "presentation"), this.marginDomNode.setAttribute("aria-hidden", "true"), this._zones = {};
  }
  dispose() {
    super.dispose(), this._zones = {};
  }
  _recomputeWhitespacesProps() {
    const e = this._context.viewLayout.getWhitespaces(), t = /* @__PURE__ */ new Map();
    for (const s of e) t.set(s.id, s);
    let n = !1;
    return this._context.viewModel.changeWhitespace((s) => {
      const o = Object.keys(this._zones);
      for (let r = 0, a = o.length; r < a; r++) {
        const l = o[r], d = this._zones[l], h = this._computeWhitespaceProps(d.delegate);
        d.isInHiddenArea = h.isInHiddenArea;
        const c = t.get(l);
        !c || c.afterLineNumber === h.afterViewLineNumber && c.height === h.heightInPx || (s.changeOneWhitespace(l, h.afterViewLineNumber, h.heightInPx), this._safeCallOnComputedHeight(d.delegate, h.heightInPx), n = !0);
      }
    }), n;
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, n = t.get(145);
    return this._lineHeight = t.get(67), this._contentWidth = n.contentWidth, this._contentLeft = n.contentLeft, e.hasChanged(67) && this._recomputeWhitespacesProps(), !0;
  }
  onLineMappingChanged(e) {
    return this._recomputeWhitespacesProps();
  }
  onLinesDeleted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged || e.scrollWidthChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  _getZoneOrdinal(e) {
    var t, n;
    return (n = (t = e.ordinal) !== null && t !== void 0 ? t : e.afterColumn) !== null && n !== void 0 ? n : 1e4;
  }
  _computeWhitespaceProps(e) {
    if (e.afterLineNumber === 0) return { isInHiddenArea: !1, afterViewLineNumber: 0, heightInPx: this._heightInPixels(e), minWidthInPx: this._minWidthInPixels(e) };
    let t, n;
    if (e.afterColumn !== void 0) t = this._context.viewModel.model.validatePosition({ lineNumber: e.afterLineNumber, column: e.afterColumn });
    else {
      const r = this._context.viewModel.model.validatePosition({ lineNumber: e.afterLineNumber, column: 1 }).lineNumber;
      t = new W(r, this._context.viewModel.model.getLineMaxColumn(r));
    }
    n = t.column === this._context.viewModel.model.getLineMaxColumn(t.lineNumber) ? this._context.viewModel.model.validatePosition({ lineNumber: t.lineNumber + 1, column: 1 }) : this._context.viewModel.model.validatePosition({ lineNumber: t.lineNumber, column: t.column + 1 });
    const s = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(t, e.afterColumnAffinity, !0), o = e.showInHiddenAreas || this._context.viewModel.coordinatesConverter.modelPositionIsVisible(n);
    return { isInHiddenArea: !o, afterViewLineNumber: s.lineNumber, heightInPx: o ? this._heightInPixels(e) : 0, minWidthInPx: this._minWidthInPixels(e) };
  }
  changeViewZones(e) {
    let t = !1;
    return this._context.viewModel.changeWhitespace((n) => {
      const s = { addZone: (o) => (t = !0, this._addZone(n, o)), removeZone: (o) => {
        o && (t = this._removeZone(n, o) || t);
      }, layoutZone: (o) => {
        o && (t = this._layoutZone(n, o) || t);
      } };
      (function(o, r) {
        try {
          return o(r);
        } catch (a) {
          We(a);
        }
      })(e, s), s.addZone = wD, s.removeZone = wD, s.layoutZone = wD;
    }), t;
  }
  _addZone(e, t) {
    const n = this._computeWhitespaceProps(t), s = { whitespaceId: e.insertWhitespace(n.afterViewLineNumber, this._getZoneOrdinal(t), n.heightInPx, n.minWidthInPx), delegate: t, isInHiddenArea: n.isInHiddenArea, isVisible: !1, domNode: wt(t.domNode), marginDomNode: t.marginDomNode ? wt(t.marginDomNode) : null };
    return this._safeCallOnComputedHeight(s.delegate, n.heightInPx), s.domNode.setPosition("absolute"), s.domNode.domNode.style.width = "100%", s.domNode.setDisplay("none"), s.domNode.setAttribute("monaco-view-zone", s.whitespaceId), this.domNode.appendChild(s.domNode), s.marginDomNode && (s.marginDomNode.setPosition("absolute"), s.marginDomNode.domNode.style.width = "100%", s.marginDomNode.setDisplay("none"), s.marginDomNode.setAttribute("monaco-view-zone", s.whitespaceId), this.marginDomNode.appendChild(s.marginDomNode)), this._zones[s.whitespaceId] = s, this.setShouldRender(), s.whitespaceId;
  }
  _removeZone(e, t) {
    if (this._zones.hasOwnProperty(t)) {
      const n = this._zones[t];
      return delete this._zones[t], e.removeWhitespace(n.whitespaceId), n.domNode.removeAttribute("monaco-visible-view-zone"), n.domNode.removeAttribute("monaco-view-zone"), n.domNode.domNode.parentNode.removeChild(n.domNode.domNode), n.marginDomNode && (n.marginDomNode.removeAttribute("monaco-visible-view-zone"), n.marginDomNode.removeAttribute("monaco-view-zone"), n.marginDomNode.domNode.parentNode.removeChild(n.marginDomNode.domNode)), this.setShouldRender(), !0;
    }
    return !1;
  }
  _layoutZone(e, t) {
    if (this._zones.hasOwnProperty(t)) {
      const n = this._zones[t], s = this._computeWhitespaceProps(n.delegate);
      return n.isInHiddenArea = s.isInHiddenArea, e.changeOneWhitespace(n.whitespaceId, s.afterViewLineNumber, s.heightInPx), this._safeCallOnComputedHeight(n.delegate, s.heightInPx), this.setShouldRender(), !0;
    }
    return !1;
  }
  shouldSuppressMouseDownOnViewZone(e) {
    return this._zones.hasOwnProperty(e) ? !!this._zones[e].delegate.suppressMouseDown : !1;
  }
  _heightInPixels(e) {
    return typeof e.heightInPx == "number" ? e.heightInPx : typeof e.heightInLines == "number" ? this._lineHeight * e.heightInLines : this._lineHeight;
  }
  _minWidthInPixels(e) {
    return typeof e.minWidthInPx == "number" ? e.minWidthInPx : 0;
  }
  _safeCallOnComputedHeight(e, t) {
    if (typeof e.onComputedHeight == "function") try {
      e.onComputedHeight(t);
    } catch (n) {
      We(n);
    }
  }
  _safeCallOnDomNodeTop(e, t) {
    if (typeof e.onDomNodeTop == "function") try {
      e.onDomNodeTop(t);
    } catch (n) {
      We(n);
    }
  }
  prepareRender(e) {
  }
  render(e) {
    const t = e.viewportData.whitespaceViewportData, n = {};
    let s = !1;
    for (const r of t) this._zones[r.id].isInHiddenArea || (n[r.id] = r, s = !0);
    const o = Object.keys(this._zones);
    for (let r = 0, a = o.length; r < a; r++) {
      const l = o[r], d = this._zones[l];
      let h = 0, c = 0, u = "none";
      n.hasOwnProperty(l) ? (h = n[l].verticalOffset - e.bigNumbersDelta, c = n[l].height, u = "block", d.isVisible || (d.domNode.setAttribute("monaco-visible-view-zone", "true"), d.isVisible = !0), this._safeCallOnDomNodeTop(d.delegate, e.getScrolledTopFromAbsoluteTop(n[l].verticalOffset))) : (d.isVisible && (d.domNode.removeAttribute("monaco-visible-view-zone"), d.isVisible = !1), this._safeCallOnDomNodeTop(d.delegate, e.getScrolledTopFromAbsoluteTop(-1e6))), d.domNode.setTop(h), d.domNode.setHeight(c), d.domNode.setDisplay(u), d.marginDomNode && (d.marginDomNode.setTop(h), d.marginDomNode.setHeight(c), d.marginDomNode.setDisplay(u));
    }
    s && (this.domNode.setWidth(Math.max(e.scrollWidth, this._contentWidth)), this.marginDomNode.setWidth(this._contentLeft));
  }
}
class GY extends Mg {
  constructor(e) {
    super(), this._context = e, this._options = new d5(this._context.configuration), this._selection = [], this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  onConfigurationChanged(e) {
    const t = new d5(this._context.configuration);
    return this._options.equals(t) ? e.hasChanged(145) : (this._options = t, !0);
  }
  onCursorStateChanged(e) {
    return this._selection = e.selections, this._options.renderWhitespace === "selection";
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  prepareRender(e) {
    if (this._options.renderWhitespace === "none") return void (this._renderResult = null);
    const t = e.visibleRange.startLineNumber, n = e.visibleRange.endLineNumber - t + 1, s = new Array(n);
    for (let r = 0; r < n; r++) s[r] = !0;
    const o = this._context.viewModel.getMinimapLinesRenderingData(e.viewportData.startLineNumber, e.viewportData.endLineNumber, s);
    this._renderResult = [];
    for (let r = e.viewportData.startLineNumber; r <= e.viewportData.endLineNumber; r++) {
      const a = r - e.viewportData.startLineNumber, l = o.data[a];
      let d = null;
      if (this._options.renderWhitespace === "selection") {
        const h = this._selection;
        for (const c of h) {
          if (c.endLineNumber < r || c.startLineNumber > r) continue;
          const u = c.startLineNumber === r ? c.startColumn : l.minColumn, g = c.endLineNumber === r ? c.endColumn : l.maxColumn;
          u < g && (d || (d = []), d.push(new iB(u - 1, g - 1)));
        }
      }
      this._renderResult[a] = this._applyRenderWhitespace(e, r, d, l);
    }
  }
  _applyRenderWhitespace(e, t, n, s) {
    if (this._options.renderWhitespace === "selection" && !n || this._options.renderWhitespace === "trailing" && s.continuesWithWrappedLine) return "";
    const o = this._context.theme.getColor(_d), r = this._options.renderWithSVG, a = s.content, l = this._options.stopRenderingLineAfter === -1 ? a.length : Math.min(this._options.stopRenderingLineAfter, a.length), d = s.continuesWithWrappedLine, h = s.minColumn - 1, c = this._options.renderWhitespace === "boundary", u = this._options.renderWhitespace === "trailing", g = this._options.lineHeight, p = this._options.middotWidth, f = this._options.wsmiddotWidth, _ = this._options.spaceWidth, v = Math.abs(f - _) < Math.abs(p - _) ? 11825 : 183, b = this._options.canUseHalfwidthRightwardsArrow;
    let C, w = "", y = !1, L = Jn(a);
    L === -1 ? (y = !0, L = l, C = l) : C = ra(a);
    let k = 0, N = n && n[k], A = 0;
    for (let B = h; B < l; B++) {
      const T = a.charCodeAt(B);
      if (N && B >= N.endOffset && (k++, N = n && n[k]), T !== 9 && T !== 32 || u && !y && B <= C) continue;
      if (c && B >= L && B <= C && T === 32) {
        const H = B - 1 >= 0 ? a.charCodeAt(B - 1) : 0, $ = B + 1 < l ? a.charCodeAt(B + 1) : 0;
        if (H !== 32 && $ !== 32) continue;
      }
      if (c && d && B === l - 1) {
        const H = B - 1 >= 0 ? a.charCodeAt(B - 1) : 0;
        if (T === 32 && H !== 32 && H !== 9) continue;
      }
      if (n && (!N || N.startOffset > B || N.endOffset <= B)) continue;
      const O = e.visibleRangeForPosition(new W(t, B + 1));
      O && (r ? (A = Math.max(A, O.left), w += T === 9 ? this._renderArrow(g, _, O.left) : `<circle cx="${(O.left + _ / 2).toFixed(2)}" cy="${(g / 2).toFixed(2)}" r="${(_ / 7).toFixed(2)}" />`) : w += T === 9 ? `<div class="mwh" style="left:${O.left}px;height:${g}px;">${b ? "￫" : "→"}</div>` : `<div class="mwh" style="left:${O.left}px;height:${g}px;">${String.fromCharCode(v)}</div>`);
    }
    return r ? (A = Math.round(A + _), `<svg style="bottom:0;position:absolute;width:${A}px;height:${g}px" viewBox="0 0 ${A} ${g}" xmlns="http://www.w3.org/2000/svg" fill="${o}">` + w + "</svg>") : w;
  }
  _renderArrow(e, t, n) {
    const s = e / 2, o = n, r = { x: 0, y: t / 7 / 2 }, a = { x: 0.8 * t, y: r.y }, l = { x: a.x - 0.2 * a.x, y: a.y + 0.2 * a.x }, d = { x: l.x + 0.1 * a.x, y: l.y + 0.1 * a.x }, h = { x: d.x + 0.35 * a.x, y: d.y - 0.35 * a.x };
    return `<path d="M ${[r, a, l, d, h, { x: h.x, y: -h.y }, { x: d.x, y: -d.y }, { x: l.x, y: -l.y }, { x: a.x, y: -a.y }, { x: r.x, y: -r.y }].map((c) => `${(o + c.x).toFixed(2)} ${(s + c.y).toFixed(2)}`).join(" L ")}" />`;
  }
  render(e, t) {
    if (!this._renderResult) return "";
    const n = t - e;
    return n < 0 || n >= this._renderResult.length ? "" : this._renderResult[n];
  }
}
class d5 {
  constructor(e) {
    const t = e.options, n = t.get(50), s = t.get(38);
    s === "off" ? (this.renderWhitespace = "none", this.renderWithSVG = !1) : s === "svg" ? (this.renderWhitespace = t.get(99), this.renderWithSVG = !0) : (this.renderWhitespace = t.get(99), this.renderWithSVG = !1), this.spaceWidth = n.spaceWidth, this.middotWidth = n.middotWidth, this.wsmiddotWidth = n.wsmiddotWidth, this.canUseHalfwidthRightwardsArrow = n.canUseHalfwidthRightwardsArrow, this.lineHeight = t.get(67), this.stopRenderingLineAfter = t.get(117);
  }
  equals(e) {
    return this.renderWhitespace === e.renderWhitespace && this.renderWithSVG === e.renderWithSVG && this.spaceWidth === e.spaceWidth && this.middotWidth === e.middotWidth && this.wsmiddotWidth === e.wsmiddotWidth && this.canUseHalfwidthRightwardsArrow === e.canUseHalfwidthRightwardsArrow && this.lineHeight === e.lineHeight && this.stopRenderingLineAfter === e.stopRenderingLineAfter;
  }
}
class ZY {
  constructor(e, t, n, s) {
    this.selections = e, this.startLineNumber = 0 | t.startLineNumber, this.endLineNumber = 0 | t.endLineNumber, this.relativeVerticalOffset = t.relativeVerticalOffset, this.bigNumbersDelta = 0 | t.bigNumbersDelta, this.lineHeight = 0 | t.lineHeight, this.whitespaceViewportData = n, this._model = s, this.visibleRange = new D(t.startLineNumber, this._model.getLineMinColumn(t.startLineNumber), t.endLineNumber, this._model.getLineMaxColumn(t.endLineNumber));
  }
  getViewLineRenderingData(e) {
    return this._model.getViewportViewLineRenderingData(this.visibleRange, e);
  }
  getDecorationsInViewport() {
    return this._model.getDecorationsInViewport(this.visibleRange);
  }
}
class YY {
  get type() {
    return this._theme.type;
  }
  get value() {
    return this._theme;
  }
  constructor(e) {
    this._theme = e;
  }
  update(e) {
    this._theme = e;
  }
  getColor(e) {
    return this._theme.getColor(e);
  }
}
class XY {
  constructor(e, t, n) {
    this.configuration = e, this.theme = new YY(t), this.viewModel = n, this.viewLayout = n.viewLayout;
  }
  addEventHandler(e) {
    this.viewModel.addViewEventHandler(e);
  }
  removeEventHandler(e) {
    this.viewModel.removeViewEventHandler(e);
  }
}
var QY = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, JY = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let rI = class extends L1 {
  constructor(i, e, t, n, s, o, r) {
    super(), this._instantiationService = r, this._shouldRecomputeGlyphMarginLanes = !1, this._selections = [new _e(1, 1, 1, 1)], this._renderAnimationFrame = null;
    const a = new dY(e, n, s, i);
    this._context = new XY(e, t, n), this._context.addEventHandler(this), this._viewParts = [], this._textAreaHandler = this._instantiationService.createInstance(nI, this._context, a, this._createTextAreaHandlerHelper()), this._viewParts.push(this._textAreaHandler), this._linesContent = wt(document.createElement("div")), this._linesContent.setClassName("lines-content monaco-editor-background"), this._linesContent.setPosition("absolute"), this.domNode = wt(document.createElement("div")), this.domNode.setClassName(this._getEditorClassName()), this.domNode.setAttribute("role", "code"), this._overflowGuardContainer = wt(document.createElement("div")), _a.write(this._overflowGuardContainer, 3), this._overflowGuardContainer.setClassName("overflow-guard"), this._scrollbar = new bY(this._context, this._linesContent, this.domNode, this._overflowGuardContainer), this._viewParts.push(this._scrollbar), this._viewLines = new gL(this._context, this._linesContent), this._viewZones = new $Y(this._context), this._viewParts.push(this._viewZones);
    const l = new BY(this._context);
    this._viewParts.push(l);
    const d = new zY(this._context);
    this._viewParts.push(d);
    const h = new cY(this._context);
    this._viewParts.push(h), h.addDynamicOverlay(new fY(this._context)), h.addDynamicOverlay(new yi(this._context)), h.addDynamicOverlay(new xY(this._context)), h.addDynamicOverlay(new vY(this._context)), h.addDynamicOverlay(new GY(this._context));
    const c = new uY(this._context);
    this._viewParts.push(c), c.addDynamicOverlay(new _Y(this._context)), c.addDynamicOverlay(new TY(this._context)), c.addDynamicOverlay(new MY(this._context)), c.addDynamicOverlay(new N1(this._context)), this._glyphMarginWidgets = new yY(this._context), this._viewParts.push(this._glyphMarginWidgets);
    const u = new ug(this._context);
    u.getDomNode().appendChild(this._viewZones.marginDomNode), u.getDomNode().appendChild(c.getDomNode()), u.getDomNode().appendChild(this._glyphMarginWidgets.domNode), this._viewParts.push(u), this._contentWidgets = new pY(this._context, this.domNode), this._viewParts.push(this._contentWidgets), this._viewCursors = new Cv(this._context), this._viewParts.push(this._viewCursors), this._overlayWidgets = new OY(this._context, this.domNode), this._viewParts.push(this._overlayWidgets);
    const g = new HY(this._context);
    this._viewParts.push(g);
    const p = new gY(this._context);
    this._viewParts.push(p);
    const f = new PY(this._context);
    if (this._viewParts.push(f), l) {
      const _ = this._scrollbar.getOverviewRulerLayoutInfo();
      _.parent.insertBefore(l.getDomNode(), _.insertBefore);
    }
    this._linesContent.appendChild(h.getDomNode()), this._linesContent.appendChild(g.domNode), this._linesContent.appendChild(this._viewZones.domNode), this._linesContent.appendChild(this._viewLines.getDomNode()), this._linesContent.appendChild(this._contentWidgets.domNode), this._linesContent.appendChild(this._viewCursors.getDomNode()), this._overflowGuardContainer.appendChild(u.getDomNode()), this._overflowGuardContainer.appendChild(this._scrollbar.getDomNode()), this._overflowGuardContainer.appendChild(d.getDomNode()), this._overflowGuardContainer.appendChild(this._textAreaHandler.textArea), this._overflowGuardContainer.appendChild(this._textAreaHandler.textAreaCover), this._overflowGuardContainer.appendChild(this._overlayWidgets.getDomNode()), this._overflowGuardContainer.appendChild(f.getDomNode()), this._overflowGuardContainer.appendChild(p.domNode), this.domNode.appendChild(this._overflowGuardContainer), o ? (o.appendChild(this._contentWidgets.overflowingContentWidgetsDomNode.domNode), o.appendChild(this._overlayWidgets.overflowingOverlayWidgetsDomNode.domNode)) : (this.domNode.appendChild(this._contentWidgets.overflowingContentWidgetsDomNode), this.domNode.appendChild(this._overlayWidgets.overflowingOverlayWidgetsDomNode)), this._applyLayout(), this._pointerHandler = this._register(new pZ(this._context, a, this._createPointerHandlerHelper()));
  }
  _computeGlyphMarginLanes() {
    const i = this._context.viewModel.model, e = this._context.viewModel.glyphLanes;
    let t = [], n = 0;
    t = t.concat(i.getAllMarginDecorations().map((s) => {
      var o, r, a;
      const l = (r = (o = s.options.glyphMargin) === null || o === void 0 ? void 0 : o.position) !== null && r !== void 0 ? r : _l.Center;
      return n = Math.max(n, s.range.endLineNumber), { range: s.range, lane: l, persist: (a = s.options.glyphMargin) === null || a === void 0 ? void 0 : a.persistLane };
    })), t = t.concat(this._glyphMarginWidgets.getWidgets().map((s) => {
      const o = i.validateRange(s.preference.range);
      return n = Math.max(n, o.endLineNumber), { range: o, lane: s.preference.lane };
    })), t.sort((s, o) => D.compareRangesUsingStarts(s.range, o.range)), e.reset(n);
    for (const s of t) e.push(s.lane, s.range, s.persist);
    return e;
  }
  _createPointerHandlerHelper() {
    return { viewDomNode: this.domNode.domNode, linesContentDomNode: this._linesContent.domNode, viewLinesDomNode: this._viewLines.getDomNode().domNode, focusTextArea: () => {
      this.focus();
    }, dispatchTextAreaEvent: (i) => {
      this._textAreaHandler.textArea.domNode.dispatchEvent(i);
    }, getLastRenderData: () => {
      const i = this._viewCursors.getLastRenderData() || [], e = this._textAreaHandler.getLastRenderData();
      return new XG(i, e);
    }, renderNow: () => {
      this.render(!0, !1);
    }, shouldSuppressMouseDownOnViewZone: (i) => this._viewZones.shouldSuppressMouseDownOnViewZone(i), shouldSuppressMouseDownOnWidget: (i) => this._contentWidgets.shouldSuppressMouseDownOnWidget(i), getPositionFromDOMInfo: (i, e) => (this._flushAccumulatedAndRenderNow(), this._viewLines.getPositionFromDOMInfo(i, e)), visibleRangeForPosition: (i, e) => (this._flushAccumulatedAndRenderNow(), this._viewLines.visibleRangeForPosition(new W(i, e))), getLineWidth: (i) => (this._flushAccumulatedAndRenderNow(), this._viewLines.getLineWidth(i)) };
  }
  _createTextAreaHandlerHelper() {
    return { visibleRangeForPosition: (i) => (this._flushAccumulatedAndRenderNow(), this._viewLines.visibleRangeForPosition(i)) };
  }
  _applyLayout() {
    const i = this._context.configuration.options.get(145);
    this.domNode.setWidth(i.width), this.domNode.setHeight(i.height), this._overflowGuardContainer.setWidth(i.width), this._overflowGuardContainer.setHeight(i.height), this._linesContent.setWidth(16777216), this._linesContent.setHeight(16777216);
  }
  _getEditorClassName() {
    const i = this._textAreaHandler.isFocused() ? " focused" : "";
    return this._context.configuration.options.get(142) + " " + iI(this._context.theme.type) + i;
  }
  handleEvents(i) {
    super.handleEvents(i), this._scheduleRender();
  }
  onConfigurationChanged(i) {
    return this.domNode.setClassName(this._getEditorClassName()), this._applyLayout(), !1;
  }
  onCursorStateChanged(i) {
    return this._selections = i.selections, !1;
  }
  onDecorationsChanged(i) {
    return i.affectsGlyphMargin && (this._shouldRecomputeGlyphMarginLanes = !0), !1;
  }
  onFocusChanged(i) {
    return this.domNode.setClassName(this._getEditorClassName()), !1;
  }
  onThemeChanged(i) {
    return this._context.theme.update(i.theme), this.domNode.setClassName(this._getEditorClassName()), !1;
  }
  dispose() {
    this._renderAnimationFrame !== null && (this._renderAnimationFrame.dispose(), this._renderAnimationFrame = null), this._contentWidgets.overflowingContentWidgetsDomNode.domNode.remove(), this._context.removeEventHandler(this), this._viewLines.dispose();
    for (const i of this._viewParts) i.dispose();
    super.dispose();
  }
  _scheduleRender() {
    if (this._store.isDisposed) throw new Kt();
    if (this._renderAnimationFrame === null) {
      const i = this._createCoordinatedRendering();
      this._renderAnimationFrame = aI.INSTANCE.scheduleCoordinatedRendering({ window: ke(this.domNode.domNode), prepareRenderText: () => {
        if (this._store.isDisposed) throw new Kt();
        try {
          return i.prepareRenderText();
        } finally {
          this._renderAnimationFrame = null;
        }
      }, renderText: () => {
        if (this._store.isDisposed) throw new Kt();
        return i.renderText();
      }, prepareRender: (e, t) => {
        if (this._store.isDisposed) throw new Kt();
        return i.prepareRender(e, t);
      }, render: (e, t) => {
        if (this._store.isDisposed) throw new Kt();
        return i.render(e, t);
      } });
    }
  }
  _flushAccumulatedAndRenderNow() {
    const i = this._createCoordinatedRendering();
    Oh(() => i.prepareRenderText());
    const e = Oh(() => i.renderText());
    if (e) {
      const [t, n] = e;
      Oh(() => i.prepareRender(t, n)), Oh(() => i.render(t, n));
    }
  }
  _getViewPartsToRender() {
    const i = [];
    let e = 0;
    for (const t of this._viewParts) t.shouldRender() && (i[e++] = t);
    return i;
  }
  _createCoordinatedRendering() {
    return { prepareRenderText: () => {
      if (this._shouldRecomputeGlyphMarginLanes) {
        this._shouldRecomputeGlyphMarginLanes = !1;
        const i = this._computeGlyphMarginLanes();
        this._context.configuration.setGlyphMarginDecorationLaneCount(i.requiredLanes);
      }
      Mh.onRenderStart();
    }, renderText: () => {
      if (!this.domNode.domNode.isConnected) return null;
      let i = this._getViewPartsToRender();
      if (!this._viewLines.shouldRender() && i.length === 0) return null;
      const e = this._context.viewLayout.getLinesViewportData();
      this._context.viewModel.setViewport(e.startLineNumber, e.endLineNumber, e.centeredLineNumber);
      const t = new ZY(this._selections, e, this._context.viewLayout.getWhitespaceViewportData(), this._context.viewModel);
      return this._contentWidgets.shouldRender() && this._contentWidgets.onBeforeRender(t), this._viewLines.shouldRender() && (this._viewLines.renderText(t), this._viewLines.onDidRender(), i = this._getViewPartsToRender()), [i, new KG(this._context.viewLayout, t, this._viewLines)];
    }, prepareRender: (i, e) => {
      for (const t of i) t.prepareRender(e);
    }, render: (i, e) => {
      for (const t of i) t.render(e), t.onDidRender();
    } };
  }
  delegateVerticalScrollbarPointerDown(i) {
    this._scrollbar.delegateVerticalScrollbarPointerDown(i);
  }
  delegateScrollFromMouseWheelEvent(i) {
    this._scrollbar.delegateScrollFromMouseWheelEvent(i);
  }
  restoreState(i) {
    this._context.viewModel.viewLayout.setScrollPosition({ scrollTop: i.scrollTop, scrollLeft: i.scrollLeft }, 1), this._context.viewModel.visibleLinesStabilized();
  }
  getOffsetForColumn(i, e) {
    const t = this._context.viewModel.model.validatePosition({ lineNumber: i, column: e }), n = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(t);
    this._flushAccumulatedAndRenderNow();
    const s = this._viewLines.visibleRangeForPosition(new W(n.lineNumber, n.column));
    return s ? s.left : -1;
  }
  getTargetAtClientPoint(i, e) {
    const t = this._pointerHandler.getTargetAtClientPoint(i, e);
    return t ? cL.convertViewToModelMouseTarget(t, this._context.viewModel.coordinatesConverter) : null;
  }
  createOverviewRuler(i) {
    return new VY(this._context, i);
  }
  change(i) {
    this._viewZones.changeViewZones(i), this._scheduleRender();
  }
  render(i, e) {
    if (e) {
      this._viewLines.forceShouldRender();
      for (const t of this._viewParts) t.forceShouldRender();
    }
    i ? this._flushAccumulatedAndRenderNow() : this._scheduleRender();
  }
  writeScreenReaderContent(i) {
    this._textAreaHandler.writeScreenReaderContent(i);
  }
  focus() {
    this._textAreaHandler.focusTextArea();
  }
  isFocused() {
    return this._textAreaHandler.isFocused();
  }
  setAriaOptions(i) {
    this._textAreaHandler.setAriaOptions(i);
  }
  addContentWidget(i) {
    this._contentWidgets.addWidget(i.widget), this.layoutContentWidget(i), this._scheduleRender();
  }
  layoutContentWidget(i) {
    var e, t, n, s, o, r, a, l;
    this._contentWidgets.setWidgetPosition(i.widget, (t = (e = i.position) === null || e === void 0 ? void 0 : e.position) !== null && t !== void 0 ? t : null, (s = (n = i.position) === null || n === void 0 ? void 0 : n.secondaryPosition) !== null && s !== void 0 ? s : null, (r = (o = i.position) === null || o === void 0 ? void 0 : o.preference) !== null && r !== void 0 ? r : null, (l = (a = i.position) === null || a === void 0 ? void 0 : a.positionAffinity) !== null && l !== void 0 ? l : null), this._scheduleRender();
  }
  removeContentWidget(i) {
    this._contentWidgets.removeWidget(i.widget), this._scheduleRender();
  }
  addOverlayWidget(i) {
    this._overlayWidgets.addWidget(i.widget), this.layoutOverlayWidget(i), this._scheduleRender();
  }
  layoutOverlayWidget(i) {
    const e = i.position ? i.position.preference : null;
    this._overlayWidgets.setWidgetPosition(i.widget, e) && this._scheduleRender();
  }
  removeOverlayWidget(i) {
    this._overlayWidgets.removeWidget(i.widget), this._scheduleRender();
  }
  addGlyphMarginWidget(i) {
    this._glyphMarginWidgets.addWidget(i.widget), this._shouldRecomputeGlyphMarginLanes = !0, this._scheduleRender();
  }
  layoutGlyphMarginWidget(i) {
    const e = i.position;
    this._glyphMarginWidgets.setWidgetPosition(i.widget, e) && (this._shouldRecomputeGlyphMarginLanes = !0, this._scheduleRender());
  }
  removeGlyphMarginWidget(i) {
    this._glyphMarginWidgets.removeWidget(i.widget), this._shouldRecomputeGlyphMarginLanes = !0, this._scheduleRender();
  }
};
function Oh(i) {
  try {
    return i();
  } catch (e) {
    return We(e), null;
  }
}
rI = QY([JY(6, Se)], rI);
class aI {
  constructor() {
    this._coordinatedRenderings = [], this._animationFrameRunners = /* @__PURE__ */ new Map();
  }
  scheduleCoordinatedRendering(e) {
    return this._coordinatedRenderings.push(e), this._scheduleRender(e.window), { dispose: () => {
      const t = this._coordinatedRenderings.indexOf(e);
      if (t !== -1 && (this._coordinatedRenderings.splice(t, 1), this._coordinatedRenderings.length === 0)) {
        for (const [n, s] of this._animationFrameRunners) s.dispose();
        this._animationFrameRunners.clear();
      }
    } };
  }
  _scheduleRender(e) {
    if (!this._animationFrameRunners.has(e)) {
      const t = () => {
        this._animationFrameRunners.delete(e), this._onRenderScheduled();
      };
      this._animationFrameRunners.set(e, qw(e, t, 100));
    }
  }
  _onRenderScheduled() {
    const e = this._coordinatedRenderings.slice(0);
    this._coordinatedRenderings = [];
    for (const n of e) Oh(() => n.prepareRenderText());
    const t = [];
    for (let n = 0, s = e.length; n < s; n++) {
      const o = e[n];
      t[n] = Oh(() => o.renderText());
    }
    for (let n = 0, s = e.length; n < s; n++) {
      const o = e[n], r = t[n];
      if (!r) continue;
      const [a, l] = r;
      Oh(() => o.prepareRender(a, l));
    }
    for (let n = 0, s = e.length; n < s; n++) {
      const o = e[n], r = t[n];
      if (!r) continue;
      const [a, l] = r;
      Oh(() => o.render(a, l));
    }
  }
}
aI.INSTANCE = new aI();
class a0 {
  constructor(e, t, n, s, o) {
    this.injectionOffsets = e, this.injectionOptions = t, this.breakOffsets = n, this.breakOffsetsVisibleColumn = s, this.wrappedTextIndentLength = o;
  }
  getOutputLineCount() {
    return this.breakOffsets.length;
  }
  getMinOutputOffset(e) {
    return e > 0 ? this.wrappedTextIndentLength : 0;
  }
  getLineLength(e) {
    const t = e > 0 ? this.breakOffsets[e - 1] : 0;
    let n = this.breakOffsets[e] - t;
    return e > 0 && (n += this.wrappedTextIndentLength), n;
  }
  getMaxOutputOffset(e) {
    return this.getLineLength(e);
  }
  translateToInputOffset(e, t) {
    e > 0 && (t = Math.max(0, t - this.wrappedTextIndentLength));
    let n = e === 0 ? t : this.breakOffsets[e - 1] + t;
    if (this.injectionOffsets !== null) for (let s = 0; s < this.injectionOffsets.length && n > this.injectionOffsets[s]; s++) n < this.injectionOffsets[s] + this.injectionOptions[s].content.length ? n = this.injectionOffsets[s] : n -= this.injectionOptions[s].content.length;
    return n;
  }
  translateToOutputPosition(e, t = 2) {
    let n = e;
    if (this.injectionOffsets !== null) for (let s = 0; s < this.injectionOffsets.length && !(e < this.injectionOffsets[s]) && (t === 1 || e !== this.injectionOffsets[s]); s++) n += this.injectionOptions[s].content.length;
    return this.offsetInInputWithInjectionsToOutputPosition(n, t);
  }
  offsetInInputWithInjectionsToOutputPosition(e, t = 2) {
    let n = 0, s = this.breakOffsets.length - 1, o = 0, r = 0;
    for (; n <= s; ) {
      o = n + (s - n) / 2 | 0;
      const l = this.breakOffsets[o];
      if (r = o > 0 ? this.breakOffsets[o - 1] : 0, t === 0) if (e <= r) s = o - 1;
      else {
        if (!(e > l)) break;
        n = o + 1;
      }
      else if (e < r) s = o - 1;
      else {
        if (!(e >= l)) break;
        n = o + 1;
      }
    }
    let a = e - r;
    return o > 0 && (a += this.wrappedTextIndentLength), new Cb(o, a);
  }
  normalizeOutputPosition(e, t, n) {
    if (this.injectionOffsets !== null) {
      const s = this.outputPositionToOffsetInInputWithInjections(e, t), o = this.normalizeOffsetInInputWithInjectionsAroundInjections(s, n);
      if (o !== s) return this.offsetInInputWithInjectionsToOutputPosition(o, n);
    }
    if (n === 0) {
      if (e > 0 && t === this.getMinOutputOffset(e)) return new Cb(e - 1, this.getMaxOutputOffset(e - 1));
    } else if (n === 1 && e < this.getOutputLineCount() - 1 && t === this.getMaxOutputOffset(e))
      return new Cb(e + 1, this.getMinOutputOffset(e + 1));
    return new Cb(e, t);
  }
  outputPositionToOffsetInInputWithInjections(e, t) {
    return e > 0 && (t = Math.max(0, t - this.wrappedTextIndentLength)), (e > 0 ? this.breakOffsets[e - 1] : 0) + t;
  }
  normalizeOffsetInInputWithInjectionsAroundInjections(e, t) {
    const n = this.getInjectedTextAtOffset(e);
    if (!n) return e;
    if (t === 2) {
      if (e === n.offsetInInputWithInjections + n.length && h5(this.injectionOptions[n.injectedTextIndex].cursorStops)) return n.offsetInInputWithInjections + n.length;
      {
        let s = n.offsetInInputWithInjections;
        if (c5(this.injectionOptions[n.injectedTextIndex].cursorStops)) return s;
        let o = n.injectedTextIndex - 1;
        for (; o >= 0 && this.injectionOffsets[o] === this.injectionOffsets[n.injectedTextIndex] && !h5(this.injectionOptions[o].cursorStops) && (s -= this.injectionOptions[o].content.length, !c5(this.injectionOptions[o].cursorStops)); ) o--;
        return s;
      }
    }
    if (t === 1 || t === 4) {
      let s = n.offsetInInputWithInjections + n.length, o = n.injectedTextIndex;
      for (; o + 1 < this.injectionOffsets.length && this.injectionOffsets[o + 1] === this.injectionOffsets[o]; ) s += this.injectionOptions[o + 1].content.length, o++;
      return s;
    }
    if (t === 0 || t === 3) {
      let s = n.offsetInInputWithInjections, o = n.injectedTextIndex;
      for (; o - 1 >= 0 && this.injectionOffsets[o - 1] === this.injectionOffsets[o]; ) s -= this.injectionOptions[o - 1].content.length, o--;
      return s;
    }
    JS();
  }
  getInjectedText(e, t) {
    const n = this.outputPositionToOffsetInInputWithInjections(e, t), s = this.getInjectedTextAtOffset(n);
    return s ? { options: this.injectionOptions[s.injectedTextIndex] } : null;
  }
  getInjectedTextAtOffset(e) {
    const t = this.injectionOffsets, n = this.injectionOptions;
    if (t !== null) {
      let s = 0;
      for (let o = 0; o < t.length; o++) {
        const r = n[o].content.length, a = t[o] + s, l = t[o] + s + r;
        if (a > e) break;
        if (e <= l) return { injectedTextIndex: o, offsetInInputWithInjections: a, length: r };
        s += r;
      }
    }
  }
}
function h5(i) {
  return i == null || i === vr.Right || i === vr.Both;
}
function c5(i) {
  return i == null || i === vr.Left || i === vr.Both;
}
class Cb {
  constructor(e, t) {
    this.outputLineIndex = e, this.outputOffset = t;
  }
  toString() {
    return `${this.outputLineIndex}:${this.outputOffset}`;
  }
  toPosition(e) {
    return new W(e + this.outputLineIndex, this.outputOffset + 1);
  }
}
class eX {
  constructor() {
    this.changeType = 1;
  }
}
class va {
  static applyInjectedText(e, t) {
    if (!t || t.length === 0) return e;
    let n = "", s = 0;
    for (const o of t) n += e.substring(s, o.column - 1), s = o.column - 1, n += o.options.content;
    return n += e.substring(s), n;
  }
  static fromDecorations(e) {
    const t = [];
    for (const n of e) n.options.before && n.options.before.content.length > 0 && t.push(new va(n.ownerId, n.range.startLineNumber, n.range.startColumn, n.options.before, 0)), n.options.after && n.options.after.content.length > 0 && t.push(new va(n.ownerId, n.range.endLineNumber, n.range.endColumn, n.options.after, 1));
    return t.sort((n, s) => n.lineNumber === s.lineNumber ? n.column === s.column ? n.order - s.order : n.column - s.column : n.lineNumber - s.lineNumber), t;
  }
  constructor(e, t, n, s, o) {
    this.ownerId = e, this.lineNumber = t, this.column = n, this.options = s, this.order = o;
  }
}
class u5 {
  constructor(e, t, n) {
    this.changeType = 2, this.lineNumber = e, this.detail = t, this.injectedText = n;
  }
}
class tX {
  constructor(e, t) {
    this.changeType = 3, this.fromLineNumber = e, this.toLineNumber = t;
  }
}
class iX {
  constructor(e, t, n, s) {
    this.changeType = 4, this.injectedTexts = s, this.fromLineNumber = e, this.toLineNumber = t, this.detail = n;
  }
}
class nX {
  constructor() {
    this.changeType = 5;
  }
}
class dm {
  constructor(e, t, n, s) {
    this.changes = e, this.versionId = t, this.isUndoing = n, this.isRedoing = s, this.resultingSelection = null;
  }
  containsEvent(e) {
    for (let t = 0, n = this.changes.length; t < n; t++)
      if (this.changes[t].changeType === e) return !0;
    return !1;
  }
  static merge(e, t) {
    const n = [].concat(e.changes).concat(t.changes), s = t.versionId, o = e.isUndoing || t.isUndoing, r = e.isRedoing || t.isRedoing;
    return new dm(n, s, o, r);
  }
}
class GB {
  constructor(e) {
    this.changes = e;
  }
}
class $u {
  constructor(e, t) {
    this.rawContentChangedEvent = e, this.contentChangedEvent = t;
  }
  merge(e) {
    const t = dm.merge(this.rawContentChangedEvent, e.rawContentChangedEvent), n = $u._mergeChangeEvents(this.contentChangedEvent, e.contentChangedEvent);
    return new $u(t, n);
  }
  static _mergeChangeEvents(e, t) {
    const n = [].concat(e.changes).concat(t.changes), s = t.eol, o = t.versionId, r = e.isUndoing || t.isUndoing, a = e.isRedoing || t.isRedoing, l = e.isFlush || t.isFlush;
    return { changes: n, eol: s, isEolChange: e.isEolChange && t.isEolChange, versionId: o, isUndoing: r, isRedoing: a, isFlush: l };
  }
}
const g5 = Hd("domLineBreaksComputer", { createHTML: (i) => i });
class $R {
  static create(e) {
    return new $R(new WeakRef(e));
  }
  constructor(e) {
    this.targetWindow = e;
  }
  createLineBreaksComputer(e, t, n, s, o) {
    const r = [], a = [];
    return { addRequest: (l, d, h) => {
      r.push(l), a.push(d);
    }, finalize: () => function(l, d, h, c, u, g, p, f) {
      var _;
      function v(ee) {
        const te = f[ee];
        if (te) {
          const be = va.applyInjectedText(d[ee], te), we = te.map((it) => it.options), Re = te.map((it) => it.column - 1);
          return new a0(Re, we, [be.length], [], 0);
        }
        return null;
      }
      if (u === -1) {
        const ee = [];
        for (let te = 0, be = d.length; te < be; te++) ee[te] = v(te);
        return ee;
      }
      const b = Math.round(u * h.typicalHalfwidthCharacterWidth), C = g === 3 ? 2 : g === 2 ? 1 : 0, w = Math.round(c * C), y = Math.ceil(h.spaceWidth * w), L = document.createElement("div");
      yn(L, h);
      const k = new ff(1e4), N = [], A = [], B = [], T = [], O = [];
      for (let ee = 0; ee < d.length; ee++) {
        const te = va.applyInjectedText(d[ee], f[ee]);
        let be = 0, we = 0, Re = b;
        if (g !== 0) if (be = Jn(te), be === -1) be = 0;
        else {
          for (let nt = 0; nt < be; nt++)
            we += te.charCodeAt(nt) === 9 ? c - we % c : 1;
          const Xi = Math.ceil(h.spaceWidth * we);
          Xi + h.typicalFullwidthCharacterWidth > b ? (be = 0, we = 0) : Re = b - Xi;
        }
        const it = te.substr(be), ut = sX(it, we, c, Re, k, y);
        N[ee] = be, A[ee] = we, B[ee] = it, T[ee] = ut[0], O[ee] = ut[1];
      }
      const H = k.build(), $ = (_ = g5 == null ? void 0 : g5.createHTML(H)) !== null && _ !== void 0 ? _ : H;
      L.innerHTML = $, L.style.position = "absolute", L.style.top = "10000", p === "keepAll" ? (L.style.wordBreak = "keep-all", L.style.overflowWrap = "anywhere") : (L.style.wordBreak = "inherit", L.style.overflowWrap = "break-word"), l.document.body.appendChild(L);
      const pe = document.createRange(), me = Array.prototype.slice.call(L.children, 0), ue = [];
      for (let ee = 0; ee < d.length; ee++) {
        const te = oX(pe, me[ee], B[ee], T[ee]);
        if (te === null) {
          ue[ee] = v(ee);
          continue;
        }
        const be = N[ee], we = A[ee] + w, Re = O[ee], it = [];
        for (let De = 0, an = te.length; De < an; De++) it[De] = Re[te[De]];
        if (be !== 0) for (let De = 0, an = te.length; De < an; De++) te[De] += be;
        let ut, Xi;
        const nt = f[ee];
        nt ? (ut = nt.map((De) => De.options), Xi = nt.map((De) => De.column - 1)) : (ut = null, Xi = null), ue[ee] = new a0(Xi, ut, te, it, we);
      }
      return l.document.body.removeChild(L), ue;
    }(xh(this.targetWindow.deref()), r, e, t, n, s, o, a) };
  }
}
function sX(i, e, t, n, s, o) {
  if (o !== 0) {
    const u = String(o);
    s.appendString('<div style="text-indent: -'), s.appendString(u), s.appendString("px; padding-left: "), s.appendString(u), s.appendString("px; box-sizing: border-box; width:");
  } else s.appendString('<div style="width:');
  s.appendString(String(n)), s.appendString('px;">');
  const r = i.length;
  let a = e, l = 0;
  const d = [], h = [];
  let c = 0 < r ? i.charCodeAt(0) : 0;
  s.appendString("<span>");
  for (let u = 0; u < r; u++) {
    u !== 0 && u % 16384 == 0 && s.appendString("</span><span>"), d[u] = l, h[u] = a;
    const g = c;
    c = u + 1 < r ? i.charCodeAt(u + 1) : 0;
    let p = 1, f = 1;
    switch (g) {
      case 9:
        p = t - a % t, f = p;
        for (let _ = 1; _ <= p; _++) _ < p ? s.appendCharCode(160) : s.appendASCIICharCode(32);
        break;
      case 32:
        c === 32 ? s.appendCharCode(160) : s.appendASCIICharCode(32);
        break;
      case 60:
        s.appendString("&lt;");
        break;
      case 62:
        s.appendString("&gt;");
        break;
      case 38:
        s.appendString("&amp;");
        break;
      case 0:
        s.appendString("&#00;");
        break;
      case 65279:
      case 8232:
      case 8233:
      case 133:
        s.appendCharCode(65533);
        break;
      default:
        _c(g) && f++, g < 32 ? s.appendCharCode(9216 + g) : s.appendCharCode(g);
    }
    l += p, a += f;
  }
  return s.appendString("</span>"), d[i.length] = l, h[i.length] = a, s.appendString("</div>"), [d, h];
}
function oX(i, e, t, n) {
  if (t.length <= 1) return null;
  const s = Array.prototype.slice.call(e.children, 0), o = [];
  try {
    lI(i, s, n, 0, null, t.length - 1, null, o);
  } catch (r) {
    return console.log(r), null;
  }
  return o.length === 0 ? null : (o.push(t.length), o);
}
function lI(i, e, t, n, s, o, r, a) {
  if (n === o || (s = s || yD(i, e, t[n], t[n + 1]), r = r || yD(i, e, t[o], t[o + 1]), Math.abs(s[0].top - r[0].top) <= 0.1)) return;
  if (n + 1 === o) return void a.push(o);
  const l = n + (o - n) / 2 | 0, d = yD(i, e, t[l], t[l + 1]);
  lI(i, e, t, n, s, l, d, a), lI(i, e, t, l, d, o, r, a);
}
function yD(i, e, t, n) {
  return i.setStart(e[t / 16384 | 0].firstChild, t % 16384), i.setEnd(e[n / 16384 | 0].firstChild, n % 16384), i.getClientRects();
}
class rX extends V {
  constructor() {
    super(), this._editor = null, this._instantiationService = null, this._instances = this._register(new QT()), this._pending = /* @__PURE__ */ new Map(), this._finishedInstantiation = [], this._finishedInstantiation[0] = !1, this._finishedInstantiation[1] = !1, this._finishedInstantiation[2] = !1, this._finishedInstantiation[3] = !1;
  }
  initialize(e, t, n) {
    this._editor = e, this._instantiationService = n;
    for (const s of t) this._pending.has(s.id) ? We(new Error(`Cannot have two contributions with the same id ${s.id}`)) : this._pending.set(s.id, s);
    this._instantiateSome(0), this._register(g_(ke(this._editor.getDomNode()), () => {
      this._instantiateSome(1);
    })), this._register(g_(ke(this._editor.getDomNode()), () => {
      this._instantiateSome(2);
    })), this._register(g_(ke(this._editor.getDomNode()), () => {
      this._instantiateSome(3);
    }, 5e3));
  }
  saveViewState() {
    const e = {};
    for (const [t, n] of this._instances) typeof n.saveViewState == "function" && (e[t] = n.saveViewState());
    return e;
  }
  restoreViewState(e) {
    for (const [t, n] of this._instances) typeof n.restoreViewState == "function" && n.restoreViewState(e[t]);
  }
  get(e) {
    return this._instantiateById(e), this._instances.get(e) || null;
  }
  onBeforeInteractionEvent() {
    this._instantiateSome(2);
  }
  onAfterModelAttached() {
    var e;
    return g_(ke((e = this._editor) === null || e === void 0 ? void 0 : e.getDomNode()), () => {
      this._instantiateSome(1);
    }, 50);
  }
  _instantiateSome(e) {
    if (this._finishedInstantiation[e]) return;
    this._finishedInstantiation[e] = !0;
    const t = this._findPendingContributionsByInstantiation(e);
    for (const n of t) this._instantiateById(n.id);
  }
  _findPendingContributionsByInstantiation(e) {
    const t = [];
    for (const [, n] of this._pending) n.instantiation === e && t.push(n);
    return t;
  }
  _instantiateById(e) {
    const t = this._pending.get(e);
    if (t) {
      if (this._pending.delete(e), !this._instantiationService || !this._editor) throw new Error("Cannot instantiate contributions before being initialized!");
      try {
        const n = this._instantiationService.createInstance(t.ctor, this._editor);
        this._instances.set(t.id, n), typeof n.restoreViewState == "function" && t.instantiation !== 0 && console.warn(`Editor contribution '${t.id}' should be eager instantiated because it uses saveViewState / restoreViewState.`);
      } catch (n) {
        We(n);
      }
    }
  }
}
class ZB {
  constructor(e, t, n, s, o, r, a) {
    this.id = e, this.label = t, this.alias = n, this.metadata = s, this._precondition = o, this._run = r, this._contextKeyService = a;
  }
  isSupported() {
    return this._contextKeyService.contextMatchesRules(this._precondition);
  }
  run(e) {
    return this.isSupported() ? this._run(e) : Promise.resolve(void 0);
  }
}
function Dc(i) {
  let e = 0, t = 0, n = 0, s = 0;
  for (let o = 0, r = i.length; o < r; o++) {
    const a = i.charCodeAt(o);
    a === 13 ? (e === 0 && (t = o), e++, o + 1 < r && i.charCodeAt(o + 1) === 10 ? (s |= 2, o++) : s |= 3, n = o + 1) : a === 10 && (s |= 1, e === 0 && (t = o), e++, n = o + 1);
  }
  return e === 0 && (t = i.length), [e, t, i.length - n, s];
}
class p5 {
  constructor(e, t, n, s) {
    this.range = e, this.nestingLevel = t, this.nestingLevelOfEqualBracketType = n, this.isInvalid = s;
  }
}
class aX {
  constructor(e, t, n, s, o, r) {
    this.range = e, this.openingBracketRange = t, this.closingBracketRange = n, this.nestingLevel = s, this.nestingLevelOfEqualBracketType = o, this.bracketPairNode = r;
  }
  get openingBracketInfo() {
    return this.bracketPairNode.openingBracket.bracketInfo;
  }
}
class lX extends aX {
  constructor(e, t, n, s, o, r, a) {
    super(e, t, n, s, o, r), this.minVisibleColumnIndentation = a;
  }
}
class kr {
  static ofText(e) {
    let t = 0, n = 0;
    for (const s of e) s === `
` ? (t++, n = 0) : n++;
    return new kr(t, n);
  }
  constructor(e, t) {
    this.lineCount = e, this.columnCount = t;
  }
  createRange(e) {
    return this.lineCount === 0 ? new D(e.lineNumber, e.column, e.lineNumber, e.column + this.columnCount) : new D(e.lineNumber, e.column, e.lineNumber + this.lineCount, this.columnCount + 1);
  }
  addToPosition(e) {
    return this.lineCount === 0 ? new W(e.lineNumber, e.column + this.columnCount) : new W(e.lineNumber + this.lineCount, this.columnCount + 1);
  }
  toString() {
    return `${this.lineCount},${this.columnCount}`;
  }
}
kr.zero = new kr(0, 0);
const vs = 0;
function my(i) {
  return i === 0;
}
const yo = 2 ** 26;
function Mi(i, e) {
  return i * yo + e;
}
function Xo(i) {
  const e = i, t = Math.floor(e / yo);
  return new kr(t, e - t * yo);
}
function gi(i, e) {
  let t = i + e;
  return e >= yo && (t -= i % yo), t;
}
function dX(i, e) {
  return i.reduce((t, n) => gi(t, e(n)), vs);
}
function YB(i, e) {
  return i === e;
}
function wv(i, e) {
  const t = i, n = e;
  if (n - t <= 0) return vs;
  const s = Math.floor(t / yo), o = Math.floor(n / yo), r = n - o * yo;
  return s === o ? Mi(0, r - (t - s * yo)) : Mi(o - s, r);
}
function hm(i, e) {
  return i < e;
}
function cm(i, e) {
  return i <= e;
}
function k_(i, e) {
  return i >= e;
}
function Wp(i) {
  return Mi(i.lineNumber - 1, i.column - 1);
}
function Gu(i, e) {
  const t = i, n = Math.floor(t / yo), s = t - n * yo, o = e, r = Math.floor(o / yo);
  return new D(n + 1, s + 1, r + 1, o - r * yo + 1);
}
class bd {
  static fromModelContentChanges(e) {
    return e.map((n) => {
      const s = D.lift(n.range);
      return new bd(Wp(s.getStartPosition()), Wp(s.getEndPosition()), function(o) {
        const r = Sl(o);
        return Mi(r.length - 1, r[r.length - 1].length);
      }(n.text));
    }).reverse();
  }
  constructor(e, t, n) {
    this.startOffset = e, this.endOffset = t, this.newLength = n;
  }
  toString() {
    return `[${Xo(this.startOffset)}...${Xo(this.endOffset)}) -> ${Xo(this.newLength)}`;
  }
}
class hX {
  constructor(e) {
    this.nextEditIdx = 0, this.deltaOldToNewLineCount = 0, this.deltaOldToNewColumnCount = 0, this.deltaLineIdxInOld = -1, this.edits = e.map((t) => GR.from(t));
  }
  getOffsetBeforeChange(e) {
    return this.adjustNextEdit(e), this.translateCurToOld(e);
  }
  getDistanceToNextChange(e) {
    this.adjustNextEdit(e);
    const t = this.edits[this.nextEditIdx], n = t ? this.translateOldToCur(t.offsetObj) : null;
    return n === null ? null : wv(e, n);
  }
  translateOldToCur(e) {
    return e.lineCount === this.deltaLineIdxInOld ? Mi(e.lineCount + this.deltaOldToNewLineCount, e.columnCount + this.deltaOldToNewColumnCount) : Mi(e.lineCount + this.deltaOldToNewLineCount, e.columnCount);
  }
  translateCurToOld(e) {
    const t = Xo(e);
    return t.lineCount - this.deltaOldToNewLineCount === this.deltaLineIdxInOld ? Mi(t.lineCount - this.deltaOldToNewLineCount, t.columnCount - this.deltaOldToNewColumnCount) : Mi(t.lineCount - this.deltaOldToNewLineCount, t.columnCount);
  }
  adjustNextEdit(e) {
    for (; this.nextEditIdx < this.edits.length; ) {
      const t = this.edits[this.nextEditIdx], n = this.translateOldToCur(t.endOffsetAfterObj);
      if (!cm(n, e)) break;
      {
        this.nextEditIdx++;
        const s = Xo(n), o = Xo(this.translateOldToCur(t.endOffsetBeforeObj)), r = s.lineCount - o.lineCount;
        this.deltaOldToNewLineCount += r;
        const a = this.deltaLineIdxInOld === t.endOffsetBeforeObj.lineCount ? this.deltaOldToNewColumnCount : 0, l = s.columnCount - o.columnCount;
        this.deltaOldToNewColumnCount = a + l, this.deltaLineIdxInOld = t.endOffsetBeforeObj.lineCount;
      }
    }
  }
}
class GR {
  static from(e) {
    return new GR(e.startOffset, e.endOffset, e.newLength);
  }
  constructor(e, t, n) {
    this.endOffsetBeforeObj = Xo(t), this.endOffsetAfterObj = Xo(gi(e, n)), this.offsetObj = Xo(e);
  }
}
const UC = [];
class zi {
  static create(e, t) {
    if (e <= 128 && t.length === 0) {
      let n = zi.cache[e];
      return n || (n = new zi(e, t), zi.cache[e] = n), n;
    }
    return new zi(e, t);
  }
  static getEmpty() {
    return this.empty;
  }
  constructor(e, t) {
    this.items = e, this.additionalItems = t;
  }
  add(e, t) {
    const n = t.getKey(e);
    let s = n >> 5;
    if (s === 0) {
      const r = 1 << n | this.items;
      return r === this.items ? this : zi.create(r, this.additionalItems);
    }
    s--;
    const o = this.additionalItems.slice(0);
    for (; o.length < s; ) o.push(0);
    return o[s] |= 1 << (31 & n), zi.create(this.items, o);
  }
  merge(e) {
    const t = this.items | e.items;
    if (this.additionalItems === UC && e.additionalItems === UC) return t === this.items ? this : t === e.items ? e : zi.create(t, UC);
    const n = [];
    for (let s = 0; s < Math.max(this.additionalItems.length, e.additionalItems.length); s++) {
      const o = this.additionalItems[s] || 0, r = e.additionalItems[s] || 0;
      n.push(o | r);
    }
    return zi.create(t, n);
  }
  intersects(e) {
    if (this.items & e.items) return !0;
    for (let t = 0; t < Math.min(this.additionalItems.length, e.additionalItems.length); t++) if (this.additionalItems[t] & e.additionalItems[t]) return !0;
    return !1;
  }
}
zi.cache = new Array(129), zi.empty = zi.create(0, UC);
const m5 = { getKey: (i) => i };
class XB {
  constructor() {
    this.items = /* @__PURE__ */ new Map();
  }
  getKey(e) {
    let t = this.items.get(e);
    return t === void 0 && (t = this.items.size, this.items.set(e, t)), t;
  }
}
class ZR {
  get length() {
    return this._length;
  }
  constructor(e) {
    this._length = e;
  }
}
class yv extends ZR {
  static create(e, t, n) {
    let s = e.length;
    return t && (s = gi(s, t.length)), n && (s = gi(s, n.length)), new yv(s, e, t, n, t ? t.missingOpeningBracketIds : zi.getEmpty());
  }
  get kind() {
    return 2;
  }
  get listHeight() {
    return 0;
  }
  get childrenLength() {
    return 3;
  }
  getChild(e) {
    switch (e) {
      case 0:
        return this.openingBracket;
      case 1:
        return this.child;
      case 2:
        return this.closingBracket;
    }
    throw new Error("Invalid child index");
  }
  get children() {
    const e = [];
    return e.push(this.openingBracket), this.child && e.push(this.child), this.closingBracket && e.push(this.closingBracket), e;
  }
  constructor(e, t, n, s, o) {
    super(e), this.openingBracket = t, this.child = n, this.closingBracket = s, this.missingOpeningBracketIds = o;
  }
  canBeReused(e) {
    return this.closingBracket !== null && !e.intersects(this.missingOpeningBracketIds);
  }
  deepClone() {
    return new yv(this.length, this.openingBracket.deepClone(), this.child && this.child.deepClone(), this.closingBracket && this.closingBracket.deepClone(), this.missingOpeningBracketIds);
  }
  computeMinIndentation(e, t) {
    return this.child ? this.child.computeMinIndentation(gi(e, this.openingBracket.length), t) : Number.MAX_SAFE_INTEGER;
  }
}
class Za extends ZR {
  static create23(e, t, n, s = !1) {
    let o = e.length, r = e.missingOpeningBracketIds;
    if (e.listHeight !== t.listHeight) throw new Error("Invalid list heights");
    if (o = gi(o, t.length), r = r.merge(t.missingOpeningBracketIds), n) {
      if (e.listHeight !== n.listHeight) throw new Error("Invalid list heights");
      o = gi(o, n.length), r = r.merge(n.missingOpeningBracketIds);
    }
    return s ? new cX(o, e.listHeight + 1, e, t, n, r) : new Sv(o, e.listHeight + 1, e, t, n, r);
  }
  static getEmpty() {
    return new uX(vs, 0, [], zi.getEmpty());
  }
  get kind() {
    return 4;
  }
  get missingOpeningBracketIds() {
    return this._missingOpeningBracketIds;
  }
  constructor(e, t, n) {
    super(e), this.listHeight = t, this._missingOpeningBracketIds = n, this.cachedMinIndentation = -1;
  }
  throwIfImmutable() {
  }
  makeLastElementMutable() {
    this.throwIfImmutable();
    const e = this.childrenLength;
    if (e === 0) return;
    const t = this.getChild(e - 1), n = t.kind === 4 ? t.toMutable() : t;
    return t !== n && this.setChild(e - 1, n), n;
  }
  makeFirstElementMutable() {
    if (this.throwIfImmutable(), this.childrenLength === 0) return;
    const e = this.getChild(0), t = e.kind === 4 ? e.toMutable() : e;
    return e !== t && this.setChild(0, t), t;
  }
  canBeReused(e) {
    if (e.intersects(this.missingOpeningBracketIds) || this.childrenLength === 0) return !1;
    let t = this;
    for (; t.kind === 4; ) {
      const n = t.childrenLength;
      if (n === 0) throw new Kt();
      t = t.getChild(n - 1);
    }
    return t.canBeReused(e);
  }
  handleChildrenChanged() {
    this.throwIfImmutable();
    const e = this.childrenLength;
    let t = this.getChild(0).length, n = this.getChild(0).missingOpeningBracketIds;
    for (let s = 1; s < e; s++) {
      const o = this.getChild(s);
      t = gi(t, o.length), n = n.merge(o.missingOpeningBracketIds);
    }
    this._length = t, this._missingOpeningBracketIds = n, this.cachedMinIndentation = -1;
  }
  computeMinIndentation(e, t) {
    if (this.cachedMinIndentation !== -1) return this.cachedMinIndentation;
    let n = Number.MAX_SAFE_INTEGER, s = e;
    for (let o = 0; o < this.childrenLength; o++) {
      const r = this.getChild(o);
      r && (n = Math.min(n, r.computeMinIndentation(s, t)), s = gi(s, r.length));
    }
    return this.cachedMinIndentation = n, n;
  }
}
class Sv extends Za {
  get childrenLength() {
    return this._item3 !== null ? 3 : 2;
  }
  getChild(e) {
    switch (e) {
      case 0:
        return this._item1;
      case 1:
        return this._item2;
      case 2:
        return this._item3;
    }
    throw new Error("Invalid child index");
  }
  setChild(e, t) {
    switch (e) {
      case 0:
        return void (this._item1 = t);
      case 1:
        return void (this._item2 = t);
      case 2:
        return void (this._item3 = t);
    }
    throw new Error("Invalid child index");
  }
  get children() {
    return this._item3 ? [this._item1, this._item2, this._item3] : [this._item1, this._item2];
  }
  get item1() {
    return this._item1;
  }
  get item2() {
    return this._item2;
  }
  get item3() {
    return this._item3;
  }
  constructor(e, t, n, s, o, r) {
    super(e, t, r), this._item1 = n, this._item2 = s, this._item3 = o;
  }
  deepClone() {
    return new Sv(this.length, this.listHeight, this._item1.deepClone(), this._item2.deepClone(), this._item3 ? this._item3.deepClone() : null, this.missingOpeningBracketIds);
  }
  appendChildOfSameHeight(e) {
    if (this._item3) throw new Error("Cannot append to a full (2,3) tree node");
    this.throwIfImmutable(), this._item3 = e, this.handleChildrenChanged();
  }
  unappendChild() {
    if (!this._item3) throw new Error("Cannot remove from a non-full (2,3) tree node");
    this.throwIfImmutable();
    const e = this._item3;
    return this._item3 = null, this.handleChildrenChanged(), e;
  }
  prependChildOfSameHeight(e) {
    if (this._item3) throw new Error("Cannot prepend to a full (2,3) tree node");
    this.throwIfImmutable(), this._item3 = this._item2, this._item2 = this._item1, this._item1 = e, this.handleChildrenChanged();
  }
  unprependChild() {
    if (!this._item3) throw new Error("Cannot remove from a non-full (2,3) tree node");
    this.throwIfImmutable();
    const e = this._item1;
    return this._item1 = this._item2, this._item2 = this._item3, this._item3 = null, this.handleChildrenChanged(), e;
  }
  toMutable() {
    return this;
  }
}
class cX extends Sv {
  toMutable() {
    return new Sv(this.length, this.listHeight, this.item1, this.item2, this.item3, this.missingOpeningBracketIds);
  }
  throwIfImmutable() {
    throw new Error("this instance is immutable");
  }
}
class fy extends Za {
  get childrenLength() {
    return this._children.length;
  }
  getChild(e) {
    return this._children[e];
  }
  setChild(e, t) {
    this._children[e] = t;
  }
  get children() {
    return this._children;
  }
  constructor(e, t, n, s) {
    super(e, t, s), this._children = n;
  }
  deepClone() {
    const e = new Array(this._children.length);
    for (let t = 0; t < this._children.length; t++) e[t] = this._children[t].deepClone();
    return new fy(this.length, this.listHeight, e, this.missingOpeningBracketIds);
  }
  appendChildOfSameHeight(e) {
    this.throwIfImmutable(), this._children.push(e), this.handleChildrenChanged();
  }
  unappendChild() {
    this.throwIfImmutable();
    const e = this._children.pop();
    return this.handleChildrenChanged(), e;
  }
  prependChildOfSameHeight(e) {
    this.throwIfImmutable(), this._children.unshift(e), this.handleChildrenChanged();
  }
  unprependChild() {
    this.throwIfImmutable();
    const e = this._children.shift();
    return this.handleChildrenChanged(), e;
  }
  toMutable() {
    return this;
  }
}
class uX extends fy {
  toMutable() {
    return new fy(this.length, this.listHeight, [...this.children], this.missingOpeningBracketIds);
  }
  throwIfImmutable() {
    throw new Error("this instance is immutable");
  }
}
const gX = [];
class YR extends ZR {
  get listHeight() {
    return 0;
  }
  get childrenLength() {
    return 0;
  }
  getChild(e) {
    return null;
  }
  get children() {
    return gX;
  }
  deepClone() {
    return this;
  }
}
class wu extends YR {
  get kind() {
    return 0;
  }
  get missingOpeningBracketIds() {
    return zi.getEmpty();
  }
  canBeReused(e) {
    return !0;
  }
  computeMinIndentation(e, t) {
    const n = Xo(e), s = (n.columnCount === 0 ? n.lineCount : n.lineCount + 1) + 1, o = function(a) {
      return Math.floor(a / yo);
    }(gi(e, this.length)) + 1;
    let r = Number.MAX_SAFE_INTEGER;
    for (let a = s; a <= o; a++) {
      const l = t.getLineFirstNonWhitespaceColumn(a), d = t.getLineContent(a);
      if (l === 0) continue;
      const h = Gi.visibleColumnFromColumn(d, l, t.getOptions().tabSize);
      r = Math.min(r, h);
    }
    return r;
  }
}
class _y extends YR {
  static create(e, t, n) {
    return new _y(e, t, n);
  }
  get kind() {
    return 1;
  }
  get missingOpeningBracketIds() {
    return zi.getEmpty();
  }
  constructor(e, t, n) {
    super(e), this.bracketInfo = t, this.bracketIds = n;
  }
  get text() {
    return this.bracketInfo.bracketText;
  }
  get languageId() {
    return this.bracketInfo.languageId;
  }
  canBeReused(e) {
    return !1;
  }
  computeMinIndentation(e, t) {
    return Number.MAX_SAFE_INTEGER;
  }
}
class pX extends YR {
  get kind() {
    return 3;
  }
  constructor(e, t) {
    super(t), this.missingOpeningBracketIds = e;
  }
  canBeReused(e) {
    return !e.intersects(this.missingOpeningBracketIds);
  }
  computeMinIndentation(e, t) {
    return Number.MAX_SAFE_INTEGER;
  }
}
let wh = class {
  constructor(i, e, t, n, s) {
    this.length = i, this.kind = e, this.bracketId = t, this.bracketIds = n, this.astNode = s;
  }
};
class QB {
  constructor(e, t) {
    this.textModel = e, this.bracketTokens = t, this.reader = new mX(this.textModel, this.bracketTokens), this._offset = vs, this.didPeek = !1, this.peeked = null, this.textBufferLineCount = e.getLineCount(), this.textBufferLastLineLength = e.getLineLength(this.textBufferLineCount);
  }
  get offset() {
    return this._offset;
  }
  get length() {
    return Mi(this.textBufferLineCount - 1, this.textBufferLastLineLength);
  }
  skip(e) {
    this.didPeek = !1, this._offset = gi(this._offset, e);
    const t = Xo(this._offset);
    this.reader.setPosition(t.lineCount, t.columnCount);
  }
  read() {
    let e;
    return this.peeked ? (this.didPeek = !1, e = this.peeked) : e = this.reader.read(), e && (this._offset = gi(this._offset, e.length)), e;
  }
  peek() {
    return this.didPeek || (this.peeked = this.reader.read(), this.didPeek = !0), this.peeked;
  }
}
class mX {
  constructor(e, t) {
    this.textModel = e, this.bracketTokens = t, this.lineIdx = 0, this.line = null, this.lineCharOffset = 0, this.lineTokens = null, this.lineTokenOffset = 0, this.peekedToken = null, this.textBufferLineCount = e.getLineCount(), this.textBufferLastLineLength = e.getLineLength(this.textBufferLineCount);
  }
  setPosition(e, t) {
    e === this.lineIdx ? (this.lineCharOffset = t, this.line !== null && (this.lineTokenOffset = this.lineCharOffset === 0 ? 0 : this.lineTokens.findTokenIndexAtOffset(this.lineCharOffset))) : (this.lineIdx = e, this.lineCharOffset = t, this.line = null), this.peekedToken = null;
  }
  read() {
    if (this.peekedToken) {
      const d = this.peekedToken;
      return this.peekedToken = null, this.lineCharOffset += d.length, d;
    }
    if (this.lineIdx > this.textBufferLineCount - 1 || this.lineIdx === this.textBufferLineCount - 1 && this.lineCharOffset >= this.textBufferLastLineLength) return null;
    this.line === null && (this.lineTokens = this.textModel.tokenization.getLineTokens(this.lineIdx + 1), this.line = this.lineTokens.getLineContent(), this.lineTokenOffset = this.lineCharOffset === 0 ? 0 : this.lineTokens.findTokenIndexAtOffset(this.lineCharOffset));
    const e = this.lineIdx, t = this.lineCharOffset;
    let n = 0;
    for (; ; ) {
      const d = this.lineTokens, h = d.getCount();
      let c = null;
      if (this.lineTokenOffset < h) {
        const u = d.getMetadata(this.lineTokenOffset);
        for (; this.lineTokenOffset + 1 < h && u === d.getMetadata(this.lineTokenOffset + 1); ) this.lineTokenOffset++;
        const g = In.getTokenType(u) === 0, p = In.containsBalancedBrackets(u), f = d.getEndOffset(this.lineTokenOffset);
        if (p && g && this.lineCharOffset < f) {
          const _ = d.getLanguageId(this.lineTokenOffset), v = this.line.substring(this.lineCharOffset, f), b = this.bracketTokens.getSingleLanguageBracketTokens(_), C = b.regExpGlobal;
          if (C) {
            C.lastIndex = 0;
            const w = C.exec(v);
            w && (c = b.getToken(w[0]), c && (this.lineCharOffset += w.index));
          }
        }
        if (n += f - this.lineCharOffset, c) {
          if (e !== this.lineIdx || t !== this.lineCharOffset) {
            this.peekedToken = c;
            break;
          }
          return this.lineCharOffset += c.length, c;
        }
        this.lineTokenOffset++, this.lineCharOffset = f;
      } else if (this.lineIdx === this.textBufferLineCount - 1 || (this.lineIdx++, this.lineTokens = this.textModel.tokenization.getLineTokens(this.lineIdx + 1), this.lineTokenOffset = 0, this.line = this.lineTokens.getLineContent(), this.lineCharOffset = 0, n += 33, n > 1e3)) break;
      if (n > 1500) break;
    }
    const s = (o = e, r = t, a = this.lineIdx, l = this.lineCharOffset, o !== a ? Mi(a - o, l) : Mi(0, l - r));
    var o, r, a, l;
    return new wh(s, 0, -1, zi.getEmpty(), new wu(s));
  }
}
class fX {
  constructor(e, t) {
    this.text = e, this._offset = vs, this.idx = 0;
    const n = t.getRegExpStr(), s = n ? new RegExp(n + `|
`, "gi") : null, o = [];
    let r, a = 0, l = 0, d = 0, h = 0;
    const c = [];
    for (let p = 0; p < 60; p++) c.push(new wh(Mi(0, p), 0, -1, zi.getEmpty(), new wu(Mi(0, p))));
    const u = [];
    for (let p = 0; p < 60; p++) u.push(new wh(Mi(1, p), 0, -1, zi.getEmpty(), new wu(Mi(1, p))));
    if (s) for (s.lastIndex = 0; (r = s.exec(e)) !== null; ) {
      const p = r.index, f = r[0];
      if (f === `
`) a++, l = p + 1;
      else {
        if (d !== p) {
          let _;
          if (h === a) {
            const v = p - d;
            if (v < c.length) _ = c[v];
            else {
              const b = Mi(0, v);
              _ = new wh(b, 0, -1, zi.getEmpty(), new wu(b));
            }
          } else {
            const v = a - h, b = p - l;
            if (v === 1 && b < u.length) _ = u[b];
            else {
              const C = Mi(v, b);
              _ = new wh(C, 0, -1, zi.getEmpty(), new wu(C));
            }
          }
          o.push(_);
        }
        o.push(t.getToken(f)), d = p + f.length, h = a;
      }
    }
    const g = e.length;
    if (d !== g) {
      const p = h === a ? Mi(0, g - d) : Mi(a - h, g - l);
      o.push(new wh(p, 0, -1, zi.getEmpty(), new wu(p)));
    }
    this.length = Mi(a, g - l), this.tokens = o;
  }
  get offset() {
    return this._offset;
  }
  read() {
    return this.tokens[this.idx++] || null;
  }
  peek() {
    return this.tokens[this.idx] || null;
  }
  skip(e) {
    throw new sK();
  }
}
class XR {
  static createFromLanguage(e, t) {
    function n(o) {
      return t.getKey(`${o.languageId}:::${o.bracketText}`);
    }
    const s = /* @__PURE__ */ new Map();
    for (const o of e.bracketsNew.openingBrackets) {
      const r = Mi(0, o.bracketText.length), a = n(o), l = zi.getEmpty().add(a, m5);
      s.set(o.bracketText, new wh(r, 1, a, l, _y.create(r, o, l)));
    }
    for (const o of e.bracketsNew.closingBrackets) {
      const r = Mi(0, o.bracketText.length);
      let a = zi.getEmpty();
      const l = o.getOpeningBrackets();
      for (const d of l) a = a.add(n(d), m5);
      s.set(o.bracketText, new wh(r, 2, n(l[0]), a, _y.create(r, o, a)));
    }
    return new XR(s);
  }
  constructor(e) {
    this.map = e, this.hasRegExp = !1, this._regExpGlobal = null;
  }
  getRegExpStr() {
    if (this.isEmpty) return null;
    {
      const e = [...this.map.keys()];
      return e.sort(), e.reverse(), e.map((t) => function(n) {
        let s = No(n);
        return /^[\w ]+/.test(n) && (s = `\\b${s}`), /[\w ]+$/.test(n) && (s = `${s}\\b`), s;
      }(t)).join("|");
    }
  }
  get regExpGlobal() {
    if (!this.hasRegExp) {
      const e = this.getRegExpStr();
      this._regExpGlobal = e ? new RegExp(e, "gi") : null, this.hasRegExp = !0;
    }
    return this._regExpGlobal;
  }
  getToken(e) {
    return this.map.get(e.toLowerCase());
  }
  findClosingTokenText(e) {
    for (const [t, n] of this.map) if (n.kind === 2 && n.bracketIds.intersects(e)) return t;
  }
  get isEmpty() {
    return this.map.size === 0;
  }
}
class JB {
  constructor(e, t) {
    this.denseKeyProvider = e, this.getLanguageConfiguration = t, this.languageIdToBracketTokens = /* @__PURE__ */ new Map();
  }
  didLanguageChange(e) {
    return this.languageIdToBracketTokens.has(e);
  }
  getSingleLanguageBracketTokens(e) {
    let t = this.languageIdToBracketTokens.get(e);
    return t || (t = XR.createFromLanguage(this.getLanguageConfiguration(e), this.denseKeyProvider), this.languageIdToBracketTokens.set(e, t)), t;
  }
}
function f5(i, e = !1) {
  if (i.length === 0) return null;
  if (i.length === 1) return i[0];
  let t = i.length;
  for (; t > 3; ) {
    const n = t >> 1;
    for (let s = 0; s < n; s++) {
      const o = s << 1;
      i[s] = Za.create23(i[o], i[o + 1], o + 3 === t ? i[o + 2] : null, e);
    }
    t = n;
  }
  return Za.create23(i[0], i[1], t >= 3 ? i[2] : null, e);
}
function _5(i, e) {
  return Math.abs(i.listHeight - e.listHeight);
}
function SD(i, e) {
  return i.listHeight === e.listHeight ? Za.create23(i, e, null, !1) : i.listHeight > e.listHeight ? function(t, n) {
    let s = t = t.toMutable();
    const o = [];
    let r;
    for (; ; ) {
      if (n.listHeight === s.listHeight) {
        r = n;
        break;
      }
      if (s.kind !== 4) throw new Error("unexpected");
      o.push(s), s = s.makeLastElementMutable();
    }
    for (let a = o.length - 1; a >= 0; a--) {
      const l = o[a];
      r ? l.childrenLength >= 3 ? r = Za.create23(l.unappendChild(), r, null, !1) : (l.appendChildOfSameHeight(r), r = void 0) : l.handleChildrenChanged();
    }
    return r ? Za.create23(t, r, null, !1) : t;
  }(i, e) : function(t, n) {
    let s = t = t.toMutable();
    const o = [];
    for (; n.listHeight !== s.listHeight; ) {
      if (s.kind !== 4) throw new Error("unexpected");
      o.push(s), s = s.makeFirstElementMutable();
    }
    let r = n;
    for (let a = o.length - 1; a >= 0; a--) {
      const l = o[a];
      r ? l.childrenLength >= 3 ? r = Za.create23(r, l.unprependChild(), null, !1) : (l.prependChildOfSameHeight(r), r = void 0) : l.handleChildrenChanged();
    }
    return r ? Za.create23(r, t, null, !1) : t;
  }(e, i);
}
class _X {
  constructor(e) {
    this.lastOffset = vs, this.nextNodes = [e], this.offsets = [vs], this.idxs = [];
  }
  readLongestNodeAt(e, t) {
    if (hm(e, this.lastOffset)) throw new Error("Invalid offset");
    for (this.lastOffset = e; ; ) {
      const n = Vf(this.nextNodes);
      if (!n) return;
      const s = Vf(this.offsets);
      if (hm(e, s)) return;
      if (hm(s, e)) if (gi(s, n.length) <= e) this.nextNodeAfterCurrent();
      else {
        const o = LD(n);
        o !== -1 ? (this.nextNodes.push(n.getChild(o)), this.offsets.push(s), this.idxs.push(o)) : this.nextNodeAfterCurrent();
      }
      else {
        if (t(n)) return this.nextNodeAfterCurrent(), n;
        {
          const o = LD(n);
          if (o === -1) return void this.nextNodeAfterCurrent();
          this.nextNodes.push(n.getChild(o)), this.offsets.push(s), this.idxs.push(o);
        }
      }
    }
  }
  nextNodeAfterCurrent() {
    for (; ; ) {
      const e = Vf(this.offsets), t = Vf(this.nextNodes);
      if (this.nextNodes.pop(), this.offsets.pop(), this.idxs.length === 0) break;
      const n = Vf(this.nextNodes), s = LD(n, this.idxs[this.idxs.length - 1]);
      if (s !== -1) {
        this.nextNodes.push(n.getChild(s)), this.offsets.push(gi(e, t.length)), this.idxs[this.idxs.length - 1] = s;
        break;
      }
      this.idxs.pop();
    }
  }
}
function LD(i, e = -1) {
  for (; ; ) {
    if (++e >= i.childrenLength) return -1;
    if (i.getChild(e)) return e;
  }
}
function Vf(i) {
  return i.length > 0 ? i[i.length - 1] : void 0;
}
function dI(i, e, t, n) {
  return new vX(i, e, t, n).parseDocument();
}
class vX {
  constructor(e, t, n, s) {
    if (this.tokenizer = e, this.createImmutableLists = s, this._itemsConstructed = 0, this._itemsFromCache = 0, n && s) throw new Error("Not supported");
    this.oldNodeReader = n ? new _X(n) : void 0, this.positionMapper = new hX(t);
  }
  parseDocument() {
    this._itemsConstructed = 0, this._itemsFromCache = 0;
    let e = this.parseList(zi.getEmpty(), 0);
    return e || (e = Za.getEmpty()), e;
  }
  parseList(e, t) {
    const n = [];
    for (; ; ) {
      let o = this.tryReadChildFromCache(e);
      if (!o) {
        const r = this.tokenizer.peek();
        if (!r || r.kind === 2 && r.bracketIds.intersects(e)) break;
        o = this.parseChild(e, t + 1);
      }
      o.kind === 4 && o.childrenLength === 0 || n.push(o);
    }
    return this.oldNodeReader ? function(o) {
      if (o.length === 0) return null;
      if (o.length === 1) return o[0];
      let r = 0;
      function a() {
        if (r >= o.length) return null;
        const h = r, c = o[h].listHeight;
        for (r++; r < o.length && o[r].listHeight === c; ) r++;
        return r - h >= 2 ? f5(h === 0 && r === o.length ? o : o.slice(h, r), !1) : o[h];
      }
      let l = a(), d = a();
      if (!d) return l;
      for (let h = a(); h; h = a()) _5(l, d) <= _5(d, h) ? (l = SD(l, d), d = h) : d = SD(d, h);
      return SD(l, d);
    }(n) : f5(n, this.createImmutableLists);
  }
  tryReadChildFromCache(e) {
    if (this.oldNodeReader) {
      const t = this.positionMapper.getDistanceToNextChange(this.tokenizer.offset);
      if (t === null || !my(t)) {
        const n = this.oldNodeReader.readLongestNodeAt(this.positionMapper.getOffsetBeforeChange(this.tokenizer.offset), (s) => t !== null && !hm(s.length, t) ? !1 : s.canBeReused(e));
        if (n) return this._itemsFromCache++, this.tokenizer.skip(n.length), n;
      }
    }
  }
  parseChild(e, t) {
    this._itemsConstructed++;
    const n = this.tokenizer.read();
    switch (n.kind) {
      case 2:
        return new pX(n.bracketIds, n.length);
      case 0:
        return n.astNode;
      case 1: {
        if (t > 300) return new wu(n.length);
        const s = e.merge(n.bracketIds), o = this.parseList(s, t + 1), r = this.tokenizer.peek();
        return r && r.kind === 2 && (r.bracketId === n.bracketId || r.bracketIds.intersects(n.bracketIds)) ? (this.tokenizer.read(), yv.create(n.astNode, o, r.astNode)) : yv.create(n.astNode, o, null);
      }
      default:
        throw new Error("unexpected");
    }
  }
}
function vy(i, e) {
  if (i.length === 0) return e;
  if (e.length === 0) return i;
  const t = new Pd(v5(i)), n = v5(e);
  n.push({ modified: !1, lengthBefore: void 0, lengthAfter: void 0 });
  let s = t.dequeue();
  function o(d) {
    if (d === void 0) {
      const c = t.takeWhile((u) => !0) || [];
      return s && c.unshift(s), c;
    }
    const h = [];
    for (; s && !my(d); ) {
      const [c, u] = s.splitAt(d);
      h.push(c), d = wv(c.lengthAfter, d), s = u ?? t.dequeue();
    }
    return my(d) || h.push(new Fh(!1, d, d)), h;
  }
  const r = [];
  function a(d, h, c) {
    if (r.length > 0 && YB(r[r.length - 1].endOffset, d)) {
      const u = r[r.length - 1];
      r[r.length - 1] = new bd(u.startOffset, h, gi(u.newLength, c));
    } else r.push({ startOffset: d, endOffset: h, newLength: c });
  }
  let l = vs;
  for (const d of n) {
    const h = o(d.lengthBefore);
    if (d.modified) {
      const c = gi(l, dX(h, (u) => u.lengthBefore));
      a(l, c, d.lengthAfter), l = c;
    } else for (const c of h) {
      const u = l;
      l = gi(l, c.lengthBefore), c.modified && a(u, l, c.lengthAfter);
    }
  }
  return r;
}
class Fh {
  constructor(e, t, n) {
    this.modified = e, this.lengthBefore = t, this.lengthAfter = n;
  }
  splitAt(e) {
    const t = wv(e, this.lengthAfter);
    return YB(t, vs) ? [this, void 0] : this.modified ? [new Fh(this.modified, this.lengthBefore, e), new Fh(this.modified, vs, t)] : [new Fh(this.modified, e, e), new Fh(this.modified, t, t)];
  }
  toString() {
    return `${this.modified ? "M" : "U"}:${Xo(this.lengthBefore)} -> ${Xo(this.lengthAfter)}`;
  }
}
function v5(i) {
  const e = [];
  let t = vs;
  for (const n of i) {
    const s = wv(t, n.startOffset);
    my(s) || e.push(new Fh(!1, s, s));
    const o = wv(n.startOffset, n.endOffset);
    e.push(new Fh(!0, o, n.newLength)), t = n.endOffset;
  }
  return e;
}
class bX extends V {
  didLanguageChange(e) {
    return this.brackets.didLanguageChange(e);
  }
  constructor(e, t) {
    if (super(), this.textModel = e, this.getLanguageConfiguration = t, this.didChangeEmitter = new F(), this.denseKeyProvider = new XB(), this.brackets = new JB(this.denseKeyProvider, this.getLanguageConfiguration), this.onDidChange = this.didChangeEmitter.event, this.queuedTextEditsForInitialAstWithoutTokens = [], this.queuedTextEdits = [], e.tokenization.hasTokens) e.tokenization.backgroundTokenizationState === 2 ? (this.initialAstWithoutTokens = void 0, this.astWithTokens = this.parseDocumentFromTextBuffer([], void 0, !1)) : (this.initialAstWithoutTokens = this.parseDocumentFromTextBuffer([], void 0, !0), this.astWithTokens = this.initialAstWithoutTokens);
    else {
      const n = this.brackets.getSingleLanguageBracketTokens(this.textModel.getLanguageId()), s = new fX(this.textModel.getValue(), n);
      this.initialAstWithoutTokens = dI(s, [], void 0, !0), this.astWithTokens = this.initialAstWithoutTokens;
    }
  }
  handleDidChangeBackgroundTokenizationState() {
    if (this.textModel.tokenization.backgroundTokenizationState === 2) {
      const e = this.initialAstWithoutTokens === void 0;
      this.initialAstWithoutTokens = void 0, e || this.didChangeEmitter.fire();
    }
  }
  handleDidChangeTokens({ ranges: e }) {
    const t = e.map((n) => new bd(Mi(n.fromLineNumber - 1, 0), Mi(n.toLineNumber, 0), Mi(n.toLineNumber - n.fromLineNumber + 1, 0)));
    this.handleEdits(t, !0), this.initialAstWithoutTokens || this.didChangeEmitter.fire();
  }
  handleContentChanged(e) {
    const t = bd.fromModelContentChanges(e.changes);
    this.handleEdits(t, !1);
  }
  handleEdits(e, t) {
    const n = vy(this.queuedTextEdits, e);
    this.queuedTextEdits = n, this.initialAstWithoutTokens && !t && (this.queuedTextEditsForInitialAstWithoutTokens = vy(this.queuedTextEditsForInitialAstWithoutTokens, e));
  }
  flushQueue() {
    this.queuedTextEdits.length > 0 && (this.astWithTokens = this.parseDocumentFromTextBuffer(this.queuedTextEdits, this.astWithTokens, !1), this.queuedTextEdits = []), this.queuedTextEditsForInitialAstWithoutTokens.length > 0 && (this.initialAstWithoutTokens && (this.initialAstWithoutTokens = this.parseDocumentFromTextBuffer(this.queuedTextEditsForInitialAstWithoutTokens, this.initialAstWithoutTokens, !1)), this.queuedTextEditsForInitialAstWithoutTokens = []);
  }
  parseDocumentFromTextBuffer(e, t, n) {
    const s = t;
    return dI(new QB(this.textModel, this.brackets), e, s, n);
  }
  getBracketsInRange(e, t) {
    this.flushQueue();
    const n = Mi(e.startLineNumber - 1, e.startColumn - 1), s = Mi(e.endLineNumber - 1, e.endColumn - 1);
    return new hl((o) => {
      const r = this.initialAstWithoutTokens || this.astWithTokens;
      hI(r, vs, r.length, n, s, o, 0, 0, /* @__PURE__ */ new Map(), t);
    });
  }
  getBracketPairsInRange(e, t) {
    this.flushQueue();
    const n = Wp(e.getStartPosition()), s = Wp(e.getEndPosition());
    return new hl((o) => {
      const r = this.initialAstWithoutTokens || this.astWithTokens, a = new CX(o, t, this.textModel);
      cI(r, vs, r.length, n, s, a, 0, /* @__PURE__ */ new Map());
    });
  }
  getFirstBracketAfter(e) {
    this.flushQueue();
    const t = this.initialAstWithoutTokens || this.astWithTokens;
    return tW(t, vs, t.length, Wp(e));
  }
  getFirstBracketBefore(e) {
    this.flushQueue();
    const t = this.initialAstWithoutTokens || this.astWithTokens;
    return eW(t, vs, t.length, Wp(e));
  }
}
function eW(i, e, t, n) {
  if (i.kind === 4 || i.kind === 2) {
    const s = [];
    for (const o of i.children) t = gi(e, o.length), s.push({ nodeOffsetStart: e, nodeOffsetEnd: t }), e = t;
    for (let o = s.length - 1; o >= 0; o--) {
      const { nodeOffsetStart: r, nodeOffsetEnd: a } = s[o];
      if (hm(r, n)) {
        const l = eW(i.children[o], r, a, n);
        if (l) return l;
      }
    }
    return null;
  }
  if (i.kind === 3) return null;
  if (i.kind === 1) {
    const s = Gu(e, t);
    return { bracketInfo: i.bracketInfo, range: s };
  }
  return null;
}
function tW(i, e, t, n) {
  if (i.kind === 4 || i.kind === 2) {
    for (const s of i.children) {
      if (hm(n, t = gi(e, s.length))) {
        const o = tW(s, e, t, n);
        if (o) return o;
      }
      e = t;
    }
    return null;
  }
  if (i.kind === 3) return null;
  if (i.kind === 1) {
    const s = Gu(e, t);
    return { bracketInfo: i.bracketInfo, range: s };
  }
  return null;
}
function hI(i, e, t, n, s, o, r, a, l, d, h = !1) {
  if (r > 200) return !0;
  e: for (; ; ) switch (i.kind) {
    case 4: {
      const c = i.childrenLength;
      for (let u = 0; u < c; u++) {
        const g = i.getChild(u);
        if (g) {
          if (t = gi(e, g.length), cm(e, s) && k_(t, n)) {
            if (k_(t, s)) {
              i = g;
              continue e;
            }
            if (!hI(g, e, t, n, s, o, r, 0, l, d)) return !1;
          }
          e = t;
        }
      }
      return !0;
    }
    case 2: {
      const c = !d || !i.closingBracket || i.closingBracket.bracketInfo.closesColorized(i.openingBracket.bracketInfo);
      let u = 0;
      if (l) {
        let p = l.get(i.openingBracket.text);
        p === void 0 && (p = 0), u = p, c && (p++, l.set(i.openingBracket.text, p));
      }
      const g = i.childrenLength;
      for (let p = 0; p < g; p++) {
        const f = i.getChild(p);
        if (f) {
          if (t = gi(e, f.length), cm(e, s) && k_(t, n)) {
            if (k_(t, s) && f.kind !== 1) {
              i = f, c ? (r++, a = u + 1) : a = u;
              continue e;
            }
            if ((c || f.kind !== 1 || !i.closingBracket) && !hI(f, e, t, n, s, o, c ? r + 1 : r, c ? u + 1 : u, l, d, !i.closingBracket))
              return !1;
          }
          e = t;
        }
      }
      return l == null || l.set(i.openingBracket.text, u), !0;
    }
    case 3: {
      const c = Gu(e, t);
      return o(new p5(c, r - 1, 0, !0));
    }
    case 1: {
      const c = Gu(e, t);
      return o(new p5(c, r - 1, a - 1, h));
    }
    case 0:
      return !0;
  }
}
class CX {
  constructor(e, t, n) {
    this.push = e, this.includeMinIndentation = t, this.textModel = n;
  }
}
function cI(i, e, t, n, s, o, r, a) {
  var l;
  if (r > 200) return !0;
  let d = !0;
  if (i.kind === 2) {
    let h = 0;
    if (a) {
      let g = a.get(i.openingBracket.text);
      g === void 0 && (g = 0), h = g, g++, a.set(i.openingBracket.text, g);
    }
    const c = gi(e, i.openingBracket.length);
    let u = -1;
    if (o.includeMinIndentation && (u = i.computeMinIndentation(e, o.textModel)), d = o.push(new lX(Gu(e, t), Gu(e, c), i.closingBracket ? Gu(gi(c, ((l = i.child) === null || l === void 0 ? void 0 : l.length) || vs), t) : void 0, r, h, i, u)), e = c, d && i.child) {
      const g = i.child;
      if (t = gi(e, g.length), cm(e, s) && k_(t, n) && (d = cI(g, e, t, n, s, o, r + 1, a), !d)) return !1;
    }
    a == null || a.set(i.openingBracket.text, h);
  } else {
    let h = e;
    for (const c of i.children) {
      const u = h;
      if (h = gi(h, c.length), cm(u, s) && cm(n, h) && (d = cI(c, u, h, n, s, o, r, a), !d)) return !1;
    }
  }
  return d;
}
class wX extends V {
  get canBuildAST() {
    return this.textModel.getValueLength() <= 5e6;
  }
  constructor(e, t) {
    super(), this.textModel = e, this.languageConfigurationService = t, this.bracketPairsTree = this._register(new rn()), this.onDidChangeEmitter = new F(), this.onDidChange = this.onDidChangeEmitter.event, this.bracketsRequested = !1, this._register(this.languageConfigurationService.onDidChange((n) => {
      var s;
      n.languageId && !(!((s = this.bracketPairsTree.value) === null || s === void 0) && s.object.didLanguageChange(n.languageId)) || (this.bracketPairsTree.clear(), this.updateBracketPairsTree());
    }));
  }
  handleDidChangeOptions(e) {
    this.bracketPairsTree.clear(), this.updateBracketPairsTree();
  }
  handleDidChangeLanguage(e) {
    this.bracketPairsTree.clear(), this.updateBracketPairsTree();
  }
  handleDidChangeContent(e) {
    var t;
    (t = this.bracketPairsTree.value) === null || t === void 0 || t.object.handleContentChanged(e);
  }
  handleDidChangeBackgroundTokenizationState() {
    var e;
    (e = this.bracketPairsTree.value) === null || e === void 0 || e.object.handleDidChangeBackgroundTokenizationState();
  }
  handleDidChangeTokens(e) {
    var t;
    (t = this.bracketPairsTree.value) === null || t === void 0 || t.object.handleDidChangeTokens(e);
  }
  updateBracketPairsTree() {
    if (this.bracketsRequested && this.canBuildAST) {
      if (!this.bracketPairsTree.value) {
        const n = new G();
        this.bracketPairsTree.value = (e = n.add(new bX(this.textModel, (s) => this.languageConfigurationService.getLanguageConfiguration(s))), t = n, { object: e, dispose: () => t == null ? void 0 : t.dispose() }), n.add(this.bracketPairsTree.value.object.onDidChange((s) => this.onDidChangeEmitter.fire(s))), this.onDidChangeEmitter.fire();
      }
    } else this.bracketPairsTree.value && (this.bracketPairsTree.clear(), this.onDidChangeEmitter.fire());
    var e, t;
  }
  getBracketPairsInRange(e) {
    var t;
    return this.bracketsRequested = !0, this.updateBracketPairsTree(), ((t = this.bracketPairsTree.value) === null || t === void 0 ? void 0 : t.object.getBracketPairsInRange(e, !1)) || hl.empty;
  }
  getBracketPairsInRangeWithMinIndentation(e) {
    var t;
    return this.bracketsRequested = !0, this.updateBracketPairsTree(), ((t = this.bracketPairsTree.value) === null || t === void 0 ? void 0 : t.object.getBracketPairsInRange(e, !0)) || hl.empty;
  }
  getBracketsInRange(e, t = !1) {
    var n;
    return this.bracketsRequested = !0, this.updateBracketPairsTree(), ((n = this.bracketPairsTree.value) === null || n === void 0 ? void 0 : n.object.getBracketsInRange(e, t)) || hl.empty;
  }
  findMatchingBracketUp(e, t, n) {
    const s = this.textModel.validatePosition(t), o = this.textModel.getLanguageIdAtPosition(s.lineNumber, s.column);
    if (this.canBuildAST) {
      const r = this.languageConfigurationService.getLanguageConfiguration(o).bracketsNew.getClosingBracketInfo(e);
      if (!r) return null;
      const a = this.getBracketPairsInRange(D.fromPositions(t, t)).findLast((l) => r.closes(l.openingBracketInfo));
      return a ? a.openingBracketRange : null;
    }
    {
      const r = e.toLowerCase(), a = this.languageConfigurationService.getLanguageConfiguration(o).brackets;
      if (!a) return null;
      const l = a.textIsBracket[r];
      return l ? wb(this._findMatchingBracketUp(l, s, kD(n))) : null;
    }
  }
  matchBracket(e, t) {
    if (this.canBuildAST) {
      const n = this.getBracketPairsInRange(D.fromPositions(e, e)).filter((s) => s.closingBracketRange !== void 0 && (s.openingBracketRange.containsPosition(e) || s.closingBracketRange.containsPosition(e))).findLastMaxBy(jo((s) => s.openingBracketRange.containsPosition(e) ? s.openingBracketRange : s.closingBracketRange, D.compareRangesUsingStarts));
      return n ? [n.openingBracketRange, n.closingBracketRange] : null;
    }
    {
      const n = kD(t);
      return this._matchBracket(this.textModel.validatePosition(e), n);
    }
  }
  _establishBracketSearchOffsets(e, t, n, s) {
    const o = t.getCount(), r = t.getLanguageId(s);
    let a = Math.max(0, e.column - 1 - n.maxBracketLength);
    for (let d = s - 1; d >= 0; d--) {
      const h = t.getEndOffset(d);
      if (h <= a) break;
      if (Ma(t.getStandardTokenType(d)) || t.getLanguageId(d) !== r) {
        a = h;
        break;
      }
    }
    let l = Math.min(t.getLineContent().length, e.column - 1 + n.maxBracketLength);
    for (let d = s + 1; d < o; d++) {
      const h = t.getStartOffset(d);
      if (h >= l) break;
      if (Ma(t.getStandardTokenType(d)) || t.getLanguageId(d) !== r) {
        l = h;
        break;
      }
    }
    return { searchStartOffset: a, searchEndOffset: l };
  }
  _matchBracket(e, t) {
    const n = e.lineNumber, s = this.textModel.tokenization.getLineTokens(n), o = this.textModel.getLineContent(n), r = s.findTokenIndexAtOffset(e.column - 1);
    if (r < 0) return null;
    const a = this.languageConfigurationService.getLanguageConfiguration(s.getLanguageId(r)).brackets;
    if (a && !Ma(s.getStandardTokenType(r))) {
      let { searchStartOffset: l, searchEndOffset: d } = this._establishBracketSearchOffsets(e, s, a, r), h = null;
      for (; ; ) {
        const c = hr.findNextBracketInRange(a.forwardRegex, n, o, l, d);
        if (!c) break;
        if (c.startColumn <= e.column && e.column <= c.endColumn) {
          const u = o.substring(c.startColumn - 1, c.endColumn - 1).toLowerCase(), g = this._matchFoundBracket(c, a.textIsBracket[u], a.textIsOpenBracket[u], t);
          if (g) {
            if (g instanceof Kl) return null;
            h = g;
          }
        }
        l = c.endColumn - 1;
      }
      if (h) return h;
    }
    if (r > 0 && s.getStartOffset(r) === e.column - 1) {
      const l = r - 1, d = this.languageConfigurationService.getLanguageConfiguration(s.getLanguageId(l)).brackets;
      if (d && !Ma(s.getStandardTokenType(l))) {
        const { searchStartOffset: h, searchEndOffset: c } = this._establishBracketSearchOffsets(e, s, d, l), u = hr.findPrevBracketInRange(d.reversedRegex, n, o, h, c);
        if (u && u.startColumn <= e.column && e.column <= u.endColumn) {
          const g = o.substring(u.startColumn - 1, u.endColumn - 1).toLowerCase(), p = this._matchFoundBracket(u, d.textIsBracket[g], d.textIsOpenBracket[g], t);
          if (p) return p instanceof Kl ? null : p;
        }
      }
    }
    return null;
  }
  _matchFoundBracket(e, t, n, s) {
    if (!t) return null;
    const o = n ? this._findMatchingBracketDown(t, e.getEndPosition(), s) : this._findMatchingBracketUp(t, e.getStartPosition(), s);
    return o ? o instanceof Kl ? o : [e, o] : null;
  }
  _findMatchingBracketUp(e, t, n) {
    const s = e.languageId, o = e.reversedRegex;
    let r = -1, a = 0;
    const l = (d, h, c, u) => {
      for (; ; ) {
        if (n && ++a % 100 == 0 && !n()) return Kl.INSTANCE;
        const g = hr.findPrevBracketInRange(o, d, h, c, u);
        if (!g) break;
        const p = h.substring(g.startColumn - 1, g.endColumn - 1).toLowerCase();
        if (e.isOpen(p) ? r++ : e.isClose(p) && r--, r === 0) return g;
        u = g.startColumn - 1;
      }
      return null;
    };
    for (let d = t.lineNumber; d >= 1; d--) {
      const h = this.textModel.tokenization.getLineTokens(d), c = h.getCount(), u = this.textModel.getLineContent(d);
      let g = c - 1, p = u.length, f = u.length;
      d === t.lineNumber && (g = h.findTokenIndexAtOffset(t.column - 1), p = t.column - 1, f = t.column - 1);
      let _ = !0;
      for (; g >= 0; g--) {
        const v = h.getLanguageId(g) === s && !Ma(h.getStandardTokenType(g));
        if (v) _ ? p = h.getStartOffset(g) : (p = h.getStartOffset(g), f = h.getEndOffset(g));
        else if (_ && p !== f) {
          const b = l(d, u, p, f);
          if (b) return b;
        }
        _ = v;
      }
      if (_ && p !== f) {
        const v = l(d, u, p, f);
        if (v) return v;
      }
    }
    return null;
  }
  _findMatchingBracketDown(e, t, n) {
    const s = e.languageId, o = e.forwardRegex;
    let r = 1, a = 0;
    const l = (h, c, u, g) => {
      for (; ; ) {
        if (n && ++a % 100 == 0 && !n()) return Kl.INSTANCE;
        const p = hr.findNextBracketInRange(o, h, c, u, g);
        if (!p) break;
        const f = c.substring(p.startColumn - 1, p.endColumn - 1).toLowerCase();
        if (e.isOpen(f) ? r++ : e.isClose(f) && r--, r === 0) return p;
        u = p.endColumn - 1;
      }
      return null;
    }, d = this.textModel.getLineCount();
    for (let h = t.lineNumber; h <= d; h++) {
      const c = this.textModel.tokenization.getLineTokens(h), u = c.getCount(), g = this.textModel.getLineContent(h);
      let p = 0, f = 0, _ = 0;
      h === t.lineNumber && (p = c.findTokenIndexAtOffset(t.column - 1), f = t.column - 1, _ = t.column - 1);
      let v = !0;
      for (; p < u; p++) {
        const b = c.getLanguageId(p) === s && !Ma(c.getStandardTokenType(p));
        if (b) v || (f = c.getStartOffset(p)), _ = c.getEndOffset(p);
        else if (v && f !== _) {
          const C = l(h, g, f, _);
          if (C) return C;
        }
        v = b;
      }
      if (v && f !== _) {
        const b = l(h, g, f, _);
        if (b) return b;
      }
    }
    return null;
  }
  findPrevBracket(e) {
    var t;
    const n = this.textModel.validatePosition(e);
    if (this.canBuildAST) return this.bracketsRequested = !0, this.updateBracketPairsTree(), ((t = this.bracketPairsTree.value) === null || t === void 0 ? void 0 : t.object.getFirstBracketBefore(n)) || null;
    let s = null, o = null, r = null;
    for (let a = n.lineNumber; a >= 1; a--) {
      const l = this.textModel.tokenization.getLineTokens(a), d = l.getCount(), h = this.textModel.getLineContent(a);
      let c = d - 1, u = h.length, g = h.length;
      if (a === n.lineNumber) {
        c = l.findTokenIndexAtOffset(n.column - 1), u = n.column - 1, g = n.column - 1;
        const f = l.getLanguageId(c);
        s !== f && (s = f, o = this.languageConfigurationService.getLanguageConfiguration(s).brackets, r = this.languageConfigurationService.getLanguageConfiguration(s).bracketsNew);
      }
      let p = !0;
      for (; c >= 0; c--) {
        const f = l.getLanguageId(c);
        if (s !== f) {
          if (o && r && p && u !== g) {
            const v = hr.findPrevBracketInRange(o.reversedRegex, a, h, u, g);
            if (v) return this._toFoundBracket(r, v);
            p = !1;
          }
          s = f, o = this.languageConfigurationService.getLanguageConfiguration(s).brackets, r = this.languageConfigurationService.getLanguageConfiguration(s).bracketsNew;
        }
        const _ = !!o && !Ma(l.getStandardTokenType(c));
        if (_) p ? u = l.getStartOffset(c) : (u = l.getStartOffset(c), g = l.getEndOffset(c));
        else if (r && o && p && u !== g) {
          const v = hr.findPrevBracketInRange(o.reversedRegex, a, h, u, g);
          if (v) return this._toFoundBracket(r, v);
        }
        p = _;
      }
      if (r && o && p && u !== g) {
        const f = hr.findPrevBracketInRange(o.reversedRegex, a, h, u, g);
        if (f) return this._toFoundBracket(r, f);
      }
    }
    return null;
  }
  findNextBracket(e) {
    var t;
    const n = this.textModel.validatePosition(e);
    if (this.canBuildAST) return this.bracketsRequested = !0, this.updateBracketPairsTree(), ((t = this.bracketPairsTree.value) === null || t === void 0 ? void 0 : t.object.getFirstBracketAfter(n)) || null;
    const s = this.textModel.getLineCount();
    let o = null, r = null, a = null;
    for (let l = n.lineNumber; l <= s; l++) {
      const d = this.textModel.tokenization.getLineTokens(l), h = d.getCount(), c = this.textModel.getLineContent(l);
      let u = 0, g = 0, p = 0;
      if (l === n.lineNumber) {
        u = d.findTokenIndexAtOffset(n.column - 1), g = n.column - 1, p = n.column - 1;
        const _ = d.getLanguageId(u);
        o !== _ && (o = _, r = this.languageConfigurationService.getLanguageConfiguration(o).brackets, a = this.languageConfigurationService.getLanguageConfiguration(o).bracketsNew);
      }
      let f = !0;
      for (; u < h; u++) {
        const _ = d.getLanguageId(u);
        if (o !== _) {
          if (a && r && f && g !== p) {
            const b = hr.findNextBracketInRange(r.forwardRegex, l, c, g, p);
            if (b) return this._toFoundBracket(a, b);
            f = !1;
          }
          o = _, r = this.languageConfigurationService.getLanguageConfiguration(o).brackets, a = this.languageConfigurationService.getLanguageConfiguration(o).bracketsNew;
        }
        const v = !!r && !Ma(d.getStandardTokenType(u));
        if (v) f || (g = d.getStartOffset(u)), p = d.getEndOffset(u);
        else if (a && r && f && g !== p) {
          const b = hr.findNextBracketInRange(r.forwardRegex, l, c, g, p);
          if (b) return this._toFoundBracket(a, b);
        }
        f = v;
      }
      if (a && r && f && g !== p) {
        const _ = hr.findNextBracketInRange(r.forwardRegex, l, c, g, p);
        if (_) return this._toFoundBracket(a, _);
      }
    }
    return null;
  }
  findEnclosingBrackets(e, t) {
    const n = this.textModel.validatePosition(e);
    if (this.canBuildAST) {
      const g = D.fromPositions(n), p = this.getBracketPairsInRange(D.fromPositions(n, n)).findLast((f) => f.closingBracketRange !== void 0 && f.range.strictContainsRange(g));
      return p ? [p.openingBracketRange, p.closingBracketRange] : null;
    }
    const s = kD(t), o = this.textModel.getLineCount(), r = /* @__PURE__ */ new Map();
    let a = [];
    const l = (g, p) => {
      if (!r.has(g)) {
        const f = [];
        for (let _ = 0, v = p ? p.brackets.length : 0; _ < v; _++) f[_] = 0;
        r.set(g, f);
      }
      a = r.get(g);
    };
    let d = 0;
    const h = (g, p, f, _, v) => {
      for (; ; ) {
        if (s && ++d % 100 == 0 && !s()) return Kl.INSTANCE;
        const b = hr.findNextBracketInRange(g.forwardRegex, p, f, _, v);
        if (!b) break;
        const C = f.substring(b.startColumn - 1, b.endColumn - 1).toLowerCase(), w = g.textIsBracket[C];
        if (w && (w.isOpen(C) ? a[w.index]++ : w.isClose(C) && a[w.index]--, a[w.index] === -1)) return this._matchFoundBracket(b, w, !1, s);
        _ = b.endColumn - 1;
      }
      return null;
    };
    let c = null, u = null;
    for (let g = n.lineNumber; g <= o; g++) {
      const p = this.textModel.tokenization.getLineTokens(g), f = p.getCount(), _ = this.textModel.getLineContent(g);
      let v = 0, b = 0, C = 0;
      if (g === n.lineNumber) {
        v = p.findTokenIndexAtOffset(n.column - 1), b = n.column - 1, C = n.column - 1;
        const y = p.getLanguageId(v);
        c !== y && (c = y, u = this.languageConfigurationService.getLanguageConfiguration(c).brackets, l(c, u));
      }
      let w = !0;
      for (; v < f; v++) {
        const y = p.getLanguageId(v);
        if (c !== y) {
          if (u && w && b !== C) {
            const k = h(u, g, _, b, C);
            if (k) return wb(k);
            w = !1;
          }
          c = y, u = this.languageConfigurationService.getLanguageConfiguration(c).brackets, l(c, u);
        }
        const L = !!u && !Ma(p.getStandardTokenType(v));
        if (L) w || (b = p.getStartOffset(v)), C = p.getEndOffset(v);
        else if (u && w && b !== C) {
          const k = h(u, g, _, b, C);
          if (k) return wb(k);
        }
        w = L;
      }
      if (u && w && b !== C) {
        const y = h(u, g, _, b, C);
        if (y) return wb(y);
      }
    }
    return null;
  }
  _toFoundBracket(e, t) {
    if (!t) return null;
    let n = this.textModel.getValueInRange(t);
    n = n.toLowerCase();
    const s = e.getBracketInfo(n);
    return s ? { range: t, bracketInfo: s } : null;
  }
}
function kD(i) {
  if (i === void 0) return () => !0;
  {
    const e = Date.now();
    return () => Date.now() - e <= i;
  }
}
class Kl {
  constructor() {
    this._searchCanceledBrand = void 0;
  }
}
function wb(i) {
  return i instanceof Kl ? null : i;
}
Kl.INSTANCE = new Kl();
class yX extends V {
  constructor(e) {
    super(), this.textModel = e, this.colorProvider = new iW(), this.onDidChangeEmitter = new F(), this.onDidChange = this.onDidChangeEmitter.event, this.colorizationOptions = e.getOptions().bracketPairColorizationOptions, this._register(e.bracketPairs.onDidChange((t) => {
      this.onDidChangeEmitter.fire();
    }));
  }
  handleDidChangeOptions(e) {
    this.colorizationOptions = this.textModel.getOptions().bracketPairColorizationOptions;
  }
  getDecorationsInRange(e, t, n, s) {
    return s ? [] : t === void 0 ? [] : this.colorizationOptions.enabled ? this.textModel.bracketPairs.getBracketsInRange(e, !0).map((o) => ({ id: `bracket${o.range.toString()}-${o.nestingLevel}`, options: { description: "BracketPairColorization", inlineClassName: this.colorProvider.getInlineClassName(o, this.colorizationOptions.independentColorPoolPerBracketType) }, ownerId: 0, range: o.range })).toArray() : [];
  }
  getAllDecorations(e, t) {
    return e === void 0 ? [] : this.colorizationOptions.enabled ? this.getDecorationsInRange(new D(1, 1, this.textModel.getLineCount(), 1), e, t) : [];
  }
}
class iW {
  constructor() {
    this.unexpectedClosingBracketClassName = "unexpected-closing-bracket";
  }
  getInlineClassName(e, t) {
    return e.isInvalid ? this.unexpectedClosingBracketClassName : this.getInlineClassNameOfLevel(t ? e.nestingLevelOfEqualBracketType : e.nestingLevel);
  }
  getInlineClassNameOfLevel(e) {
    return "bracket-highlighting-" + e % 30;
  }
}
function yb(i) {
  return i.replace(/\n/g, "\\n").replace(/\r/g, "\\r");
}
rr((i, e) => {
  const t = [MB, TB, RB, AB, PB, OB], n = new iW();
  e.addRule(`.monaco-editor .${n.unexpectedClosingBracketClassName} { color: ${i.getColor(OZ)}; }`);
  const s = t.map((o) => i.getColor(o)).filter((o) => !!o).filter((o) => !o.isTransparent());
  for (let o = 0; o < 30; o++) {
    const r = s[o % s.length];
    e.addRule(`.monaco-editor .${n.getInlineClassNameOfLevel(o)} { color: ${r}; }`);
  }
});
class xn {
  get oldLength() {
    return this.oldText.length;
  }
  get oldEnd() {
    return this.oldPosition + this.oldText.length;
  }
  get newLength() {
    return this.newText.length;
  }
  get newEnd() {
    return this.newPosition + this.newText.length;
  }
  constructor(e, t, n, s) {
    this.oldPosition = e, this.oldText = t, this.newPosition = n, this.newText = s;
  }
  toString() {
    return this.oldText.length === 0 ? `(insert@${this.oldPosition} "${yb(this.newText)}")` : this.newText.length === 0 ? `(delete@${this.oldPosition} "${yb(this.oldText)}")` : `(replace@${this.oldPosition} "${yb(this.oldText)}" with "${yb(this.newText)}")`;
  }
  static _writeStringSize(e) {
    return 4 + 2 * e.length;
  }
  static _writeString(e, t, n) {
    const s = t.length;
    Hr(e, s, n), n += 4;
    for (let o = 0; o < s; o++) Xj(e, t.charCodeAt(o), n), n += 2;
    return n;
  }
  static _readString(e, t) {
    const n = Vr(e, t);
    return Qj(e, t += 4, n);
  }
  writeSize() {
    return 8 + xn._writeStringSize(this.oldText) + xn._writeStringSize(this.newText);
  }
  write(e, t) {
    return Hr(e, this.oldPosition, t), t += 4, Hr(e, this.newPosition, t), t += 4, t = xn._writeString(e, this.oldText, t), t = xn._writeString(e, this.newText, t);
  }
  static read(e, t, n) {
    const s = Vr(e, t), o = Vr(e, t += 4);
    t += 4;
    const r = xn._readString(e, t);
    t += xn._writeStringSize(r);
    const a = xn._readString(e, t);
    return t += xn._writeStringSize(a), n.push(new xn(s, r, o, a)), t;
  }
}
class Aa {
  constructor(e, t) {
    this._prevEdits = e, this._currEdits = t, this._result = [], this._resultLen = 0, this._prevLen = this._prevEdits.length, this._prevDeltaOffset = 0, this._currLen = this._currEdits.length, this._currDeltaOffset = 0;
  }
  compress() {
    let e = 0, t = 0, n = this._getPrev(e), s = this._getCurr(t);
    for (; e < this._prevLen || t < this._currLen; ) {
      if (n === null) {
        this._acceptCurr(s), s = this._getCurr(++t);
        continue;
      }
      if (s === null) {
        this._acceptPrev(n), n = this._getPrev(++e);
        continue;
      }
      if (s.oldEnd <= n.newPosition) {
        this._acceptCurr(s), s = this._getCurr(++t);
        continue;
      }
      if (n.newEnd <= s.oldPosition) {
        this._acceptPrev(n), n = this._getPrev(++e);
        continue;
      }
      if (s.oldPosition < n.newPosition) {
        const [l, d] = Aa._splitCurr(s, n.newPosition - s.oldPosition);
        this._acceptCurr(l), s = d;
        continue;
      }
      if (n.newPosition < s.oldPosition) {
        const [l, d] = Aa._splitPrev(n, s.oldPosition - n.newPosition);
        this._acceptPrev(l), n = d;
        continue;
      }
      let r, a;
      if (s.oldEnd === n.newEnd) r = n, a = s, n = this._getPrev(++e), s = this._getCurr(++t);
      else if (s.oldEnd < n.newEnd) {
        const [l, d] = Aa._splitPrev(n, s.oldLength);
        r = l, a = s, n = d, s = this._getCurr(++t);
      } else {
        const [l, d] = Aa._splitCurr(s, n.newLength);
        r = n, a = l, n = this._getPrev(++e), s = d;
      }
      this._result[this._resultLen++] = new xn(r.oldPosition, r.oldText, a.newPosition, a.newText), this._prevDeltaOffset += r.newLength - r.oldLength, this._currDeltaOffset += a.newLength - a.oldLength;
    }
    const o = Aa._merge(this._result);
    return Aa._removeNoOps(o);
  }
  _acceptCurr(e) {
    this._result[this._resultLen++] = Aa._rebaseCurr(this._prevDeltaOffset, e), this._currDeltaOffset += e.newLength - e.oldLength;
  }
  _getCurr(e) {
    return e < this._currLen ? this._currEdits[e] : null;
  }
  _acceptPrev(e) {
    this._result[this._resultLen++] = Aa._rebasePrev(this._currDeltaOffset, e), this._prevDeltaOffset += e.newLength - e.oldLength;
  }
  _getPrev(e) {
    return e < this._prevLen ? this._prevEdits[e] : null;
  }
  static _rebaseCurr(e, t) {
    return new xn(t.oldPosition - e, t.oldText, t.newPosition, t.newText);
  }
  static _rebasePrev(e, t) {
    return new xn(t.oldPosition, t.oldText, t.newPosition + e, t.newText);
  }
  static _splitPrev(e, t) {
    const n = e.newText.substr(0, t), s = e.newText.substr(t);
    return [new xn(e.oldPosition, e.oldText, e.newPosition, n), new xn(e.oldEnd, "", e.newPosition + t, s)];
  }
  static _splitCurr(e, t) {
    const n = e.oldText.substr(0, t), s = e.oldText.substr(t);
    return [new xn(e.oldPosition, n, e.newPosition, e.newText), new xn(e.oldPosition + t, s, e.newEnd, "")];
  }
  static _merge(e) {
    if (e.length === 0) return e;
    const t = [];
    let n = 0, s = e[0];
    for (let o = 1; o < e.length; o++) {
      const r = e[o];
      s.oldEnd === r.oldPosition ? s = new xn(s.oldPosition, s.oldText + r.oldText, s.newPosition, s.newText + r.newText) : (t[n++] = s, s = r);
    }
    return t[n++] = s, t;
  }
  static _removeNoOps(e) {
    if (e.length === 0) return e;
    const t = [];
    let n = 0;
    for (let s = 0; s < e.length; s++) {
      const o = e[s];
      o.oldText !== o.newText && (t[n++] = o);
    }
    return t;
  }
}
function Yd(i) {
  return i === 47 || i === 92;
}
function b5(i) {
  return i.replace(/[\\/]/g, Fi.sep);
}
function C5(i, e = Fi.sep) {
  if (!i) return "";
  const t = i.length, n = i.charCodeAt(0);
  if (Yd(n)) {
    if (Yd(i.charCodeAt(1)) && !Yd(i.charCodeAt(2))) {
      let o = 3;
      const r = o;
      for (; o < t && !Yd(i.charCodeAt(o)); o++) ;
      if (r !== o && !Yd(i.charCodeAt(o + 1))) {
        for (o += 1; o < t; o++) if (Yd(i.charCodeAt(o))) return i.slice(0, o + 1).replace(/[\\/]/g, e);
      }
    }
    return e;
  }
  if (nW(n) && i.charCodeAt(1) === 58) return Yd(i.charCodeAt(2)) ? i.slice(0, 2) + e : i.slice(0, 2);
  let s = i.indexOf("://");
  if (s !== -1) {
    for (s += 3; s < t; s++) if (Yd(i.charCodeAt(s))) return i.slice(0, s + 1);
  }
  return "";
}
function uI(i, e, t, n = oa) {
  if (i === e) return !0;
  if (!i || !e || e.length > i.length) return !1;
  if (t) {
    if (!oR(i, e)) return !1;
    if (e.length === i.length) return !0;
    let s = e.length;
    return e.charAt(e.length - 1) === n && s--, i.charAt(s) === n;
  }
  return e.charAt(e.length - 1) !== n && (e += n), i.indexOf(e) === 0;
}
function nW(i) {
  return i >= 65 && i <= 90 || i >= 97 && i <= 122;
}
function Ta(i) {
  return Pw(i, !0);
}
const Yt = new class {
  constructor(i) {
    this._ignorePathCasing = i;
  }
  compare(i, e, t = !1) {
    return i === e ? 0 : Q0(this.getComparisonKey(i, t), this.getComparisonKey(e, t));
  }
  isEqual(i, e, t = !1) {
    return i === e || !(!i || !e) && this.getComparisonKey(i, t) === this.getComparisonKey(e, t);
  }
  getComparisonKey(i, e = !1) {
    return i.with({ path: this._ignorePathCasing(i) ? i.path.toLowerCase() : void 0, fragment: e ? null : void 0 }).toString();
  }
  isEqualOrParent(i, e, t = !1) {
    if (i.scheme === e.scheme) {
      if (i.scheme === Ue.file) return uI(Ta(i), Ta(e), this._ignorePathCasing(i)) && i.query === e.query && (t || i.fragment === e.fragment);
      if (y5(i.authority, e.authority)) return uI(i.path, e.path, this._ignorePathCasing(i), "/") && i.query === e.query && (t || i.fragment === e.fragment);
    }
    return !1;
  }
  joinPath(i, ...e) {
    return Ie.joinPath(i, ...e);
  }
  basenameOrAuthority(i) {
    return ir(i) || i.authority;
  }
  basename(i) {
    return Fi.basename(i.path);
  }
  extname(i) {
    return Fi.extname(i.path);
  }
  dirname(i) {
    if (i.path.length === 0) return i;
    let e;
    return i.scheme === Ue.file ? e = Ie.file(K7(Ta(i))).path : (e = Fi.dirname(i.path), i.authority && e.length && e.charCodeAt(0) !== 47 && (console.error(`dirname("${i.toString})) resulted in a relative path`), e = "/")), i.with({ path: e });
  }
  normalizePath(i) {
    if (!i.path.length) return i;
    let e;
    return e = i.scheme === Ue.file ? Ie.file(U7(Ta(i))).path : Fi.normalize(i.path), i.with({ path: e });
  }
  relativePath(i, e) {
    if (i.scheme !== e.scheme || !y5(i.authority, e.authority)) return;
    if (i.scheme === Ue.file) {
      const s = fK(Ta(i), Ta(e));
      return Tn ? b5(s) : s;
    }
    let t = i.path || "/";
    const n = e.path || "/";
    if (this._ignorePathCasing(i)) {
      let s = 0;
      for (const o = Math.min(t.length, n.length); s < o && (t.charCodeAt(s) === n.charCodeAt(s) || t.charAt(s).toLowerCase() === n.charAt(s).toLowerCase()); s++) ;
      t = n.substr(0, s) + t.substr(s);
    }
    return Fi.relative(t, n);
  }
  resolvePath(i, e) {
    if (i.scheme === Ue.file) {
      const n = Ie.file(mK(Ta(i), e));
      return i.with({ authority: n.authority, path: n.path });
    }
    var t;
    return (t = e).indexOf("/") === -1 && (t = b5(t)), /^[a-zA-Z]:(\/|$)/.test(t) && (t = "/" + t), e = t, i.with({ path: Fi.resolve(i.path, e) });
  }
  isAbsolutePath(i) {
    return !!i.path && i.path[0] === "/";
  }
  isEqualAuthority(i, e) {
    return i === e || i !== void 0 && e !== void 0 && Dp(i, e);
  }
  hasTrailingPathSeparator(i, e = oa) {
    if (i.scheme === Ue.file) {
      const t = Ta(i);
      return t.length > C5(t).length && t[t.length - 1] === e;
    }
    {
      const t = i.path;
      return t.length > 1 && t.charCodeAt(t.length - 1) === 47 && !/^[a-zA-Z]:(\/$|\\$)/.test(i.fsPath);
    }
  }
  removeTrailingPathSeparator(i, e = oa) {
    return S5(i, e) ? i.with({ path: i.path.substr(0, i.path.length - 1) }) : i;
  }
  addTrailingPathSeparator(i, e = oa) {
    let t = !1;
    if (i.scheme === Ue.file) {
      const n = Ta(i);
      t = n !== void 0 && n.length === C5(n).length && n[n.length - 1] === e;
    } else {
      e = "/";
      const n = i.path;
      t = n.length === 1 && n.charCodeAt(n.length - 1) === 47;
    }
    return t || S5(i, e) ? i : i.with({ path: i.path + "/" });
  }
}(() => !1), QR = Yt.isEqual.bind(Yt);
Yt.isEqualOrParent.bind(Yt), Yt.getComparisonKey.bind(Yt);
const SX = Yt.basenameOrAuthority.bind(Yt), ir = Yt.basename.bind(Yt), LX = Yt.extname.bind(Yt), pL = Yt.dirname.bind(Yt), kX = Yt.joinPath.bind(Yt), DX = Yt.normalizePath.bind(Yt), xX = Yt.relativePath.bind(Yt), w5 = Yt.resolvePath.bind(Yt);
Yt.isAbsolutePath.bind(Yt);
const y5 = Yt.isEqualAuthority.bind(Yt), S5 = Yt.hasTrailingPathSeparator.bind(Yt);
var Bh;
function Yg(i) {
  return i.toString();
}
Yt.removeTrailingPathSeparator.bind(Yt), Yt.addTrailingPathSeparator.bind(Yt), function(i) {
  i.META_DATA_LABEL = "label", i.META_DATA_DESCRIPTION = "description", i.META_DATA_SIZE = "size", i.META_DATA_MIME = "mime", i.parseMetaData = function(e) {
    const t = /* @__PURE__ */ new Map();
    e.path.substring(e.path.indexOf(";") + 1, e.path.lastIndexOf(";")).split(";").forEach((s) => {
      const [o, r] = s.split(":");
      o && r && t.set(o, r);
    });
    const n = e.path.substring(0, e.path.indexOf(";"));
    return n && t.set(i.META_DATA_MIME, n), t;
  };
}(Bh || (Bh = {}));
class hn {
  static create(e, t) {
    const n = e.getAlternativeVersionId(), s = gI(e);
    return new hn(n, n, s, s, t, t, []);
  }
  constructor(e, t, n, s, o, r, a) {
    this.beforeVersionId = e, this.afterVersionId = t, this.beforeEOL = n, this.afterEOL = s, this.beforeCursorState = o, this.afterCursorState = r, this.changes = a;
  }
  append(e, t, n, s, o) {
    var r, a;
    t.length > 0 && (this.changes = (r = this.changes, a = t, r === null || r.length === 0 ? a : new Aa(r, a).compress())), this.afterEOL = n, this.afterVersionId = s, this.afterCursorState = o;
  }
  static _writeSelectionsSize(e) {
    return 4 + 16 * (e ? e.length : 0);
  }
  static _writeSelections(e, t, n) {
    if (Hr(e, t ? t.length : 0, n), n += 4, t) for (const s of t) Hr(e, s.selectionStartLineNumber, n), n += 4, Hr(e, s.selectionStartColumn, n), n += 4, Hr(e, s.positionLineNumber, n), n += 4, Hr(e, s.positionColumn, n), n += 4;
    return n;
  }
  static _readSelections(e, t, n) {
    const s = Vr(e, t);
    t += 4;
    for (let o = 0; o < s; o++) {
      const r = Vr(e, t), a = Vr(e, t += 4), l = Vr(e, t += 4), d = Vr(e, t += 4);
      t += 4, n.push(new _e(r, a, l, d));
    }
    return t;
  }
  serialize() {
    let e = 10 + hn._writeSelectionsSize(this.beforeCursorState) + hn._writeSelectionsSize(this.afterCursorState) + 4;
    for (const s of this.changes) e += s.writeSize();
    const t = new Uint8Array(e);
    let n = 0;
    Hr(t, this.beforeVersionId, n), n += 4, Hr(t, this.afterVersionId, n), n += 4, VO(t, this.beforeEOL, n), n += 1, VO(t, this.afterEOL, n), n += 1, n = hn._writeSelections(t, this.beforeCursorState, n), n = hn._writeSelections(t, this.afterCursorState, n), Hr(t, this.changes.length, n), n += 4;
    for (const s of this.changes) n = s.write(t, n);
    return t.buffer;
  }
  static deserialize(e) {
    const t = new Uint8Array(e);
    let n = 0;
    const s = Vr(t, n);
    n += 4;
    const o = Vr(t, n);
    n += 4;
    const r = WO(t, n);
    n += 1;
    const a = WO(t, n);
    n += 1;
    const l = [];
    n = hn._readSelections(t, n, l);
    const d = [];
    n = hn._readSelections(t, n, d);
    const h = Vr(t, n);
    n += 4;
    const c = [];
    for (let u = 0; u < h; u++) n = xn.read(t, n, c);
    return new hn(s, o, r, a, l, d, c);
  }
}
class sW {
  get type() {
    return 0;
  }
  get resource() {
    return Ie.isUri(this.model) ? this.model : this.model.uri;
  }
  constructor(e, t, n, s) {
    this.label = e, this.code = t, this.model = n, this._data = hn.create(n, s);
  }
  toString() {
    return (this._data instanceof hn ? this._data : hn.deserialize(this._data)).changes.map((e) => e.toString()).join(", ");
  }
  matchesResource(e) {
    return (Ie.isUri(this.model) ? this.model : this.model.uri).toString() === e.toString();
  }
  setModel(e) {
    this.model = e;
  }
  canAppend(e) {
    return this.model === e && this._data instanceof hn;
  }
  append(e, t, n, s, o) {
    this._data instanceof hn && this._data.append(e, t, n, s, o);
  }
  close() {
    this._data instanceof hn && (this._data = this._data.serialize());
  }
  open() {
    this._data instanceof hn || (this._data = hn.deserialize(this._data));
  }
  undo() {
    if (Ie.isUri(this.model)) throw new Error("Invalid SingleModelEditStackElement");
    this._data instanceof hn && (this._data = this._data.serialize());
    const e = hn.deserialize(this._data);
    this.model._applyUndo(e.changes, e.beforeEOL, e.beforeVersionId, e.beforeCursorState);
  }
  redo() {
    if (Ie.isUri(this.model)) throw new Error("Invalid SingleModelEditStackElement");
    this._data instanceof hn && (this._data = this._data.serialize());
    const e = hn.deserialize(this._data);
    this.model._applyRedo(e.changes, e.afterEOL, e.afterVersionId, e.afterCursorState);
  }
  heapSize() {
    return this._data instanceof hn && (this._data = this._data.serialize()), this._data.byteLength + 168;
  }
}
class NX {
  get resources() {
    return this._editStackElementsArr.map((e) => e.resource);
  }
  constructor(e, t, n) {
    this.label = e, this.code = t, this.type = 1, this._isOpen = !0, this._editStackElementsArr = n.slice(0), this._editStackElementsMap = /* @__PURE__ */ new Map();
    for (const s of this._editStackElementsArr) {
      const o = Yg(s.resource);
      this._editStackElementsMap.set(o, s);
    }
    this._delegate = null;
  }
  prepareUndoRedo() {
    if (this._delegate) return this._delegate.prepareUndoRedo(this);
  }
  matchesResource(e) {
    const t = Yg(e);
    return this._editStackElementsMap.has(t);
  }
  setModel(e) {
    const t = Yg(Ie.isUri(e) ? e : e.uri);
    this._editStackElementsMap.has(t) && this._editStackElementsMap.get(t).setModel(e);
  }
  canAppend(e) {
    if (!this._isOpen) return !1;
    const t = Yg(e.uri);
    return this._editStackElementsMap.has(t) ? this._editStackElementsMap.get(t).canAppend(e) : !1;
  }
  append(e, t, n, s, o) {
    const r = Yg(e.uri);
    this._editStackElementsMap.get(r).append(e, t, n, s, o);
  }
  close() {
    this._isOpen = !1;
  }
  open() {
  }
  undo() {
    this._isOpen = !1;
    for (const e of this._editStackElementsArr) e.undo();
  }
  redo() {
    for (const e of this._editStackElementsArr) e.redo();
  }
  heapSize(e) {
    const t = Yg(e);
    return this._editStackElementsMap.has(t) ? this._editStackElementsMap.get(t).heapSize() : 0;
  }
  split() {
    return this._editStackElementsArr;
  }
  toString() {
    const e = [];
    for (const t of this._editStackElementsArr) e.push(`${ir(t.resource)}: ${t}`);
    return `{${e.join(", ")}}`;
  }
}
function gI(i) {
  return i.getEOL() === `
` ? 0 : 1;
}
function jl(i) {
  return !!i && (i instanceof sW || i instanceof NX);
}
class JR {
  constructor(e, t) {
    this._model = e, this._undoRedoService = t;
  }
  pushStackElement() {
    const e = this._undoRedoService.getLastElement(this._model.uri);
    jl(e) && e.close();
  }
  popStackElement() {
    const e = this._undoRedoService.getLastElement(this._model.uri);
    jl(e) && e.open();
  }
  clear() {
    this._undoRedoService.removeElements(this._model.uri);
  }
  _getOrCreateEditStackElement(e, t) {
    const n = this._undoRedoService.getLastElement(this._model.uri);
    if (jl(n) && n.canAppend(this._model)) return n;
    const s = new sW(m(0, "Typing"), "undoredo.textBufferEdit", this._model, e);
    return this._undoRedoService.pushElement(s, t), s;
  }
  pushEOL(e) {
    const t = this._getOrCreateEditStackElement(null, void 0);
    this._model.setEOL(e), t.append(this._model, [], gI(this._model), this._model.getAlternativeVersionId(), null);
  }
  pushEditOperation(e, t, n, s) {
    const o = this._getOrCreateEditStackElement(e, s), r = this._model.applyEdits(t, !0), a = JR._computeCursorState(n, r), l = r.map((d, h) => ({ index: h, textChange: d.textChange }));
    return l.sort((d, h) => d.textChange.oldPosition === h.textChange.oldPosition ? d.index - h.index : d.textChange.oldPosition - h.textChange.oldPosition), o.append(this._model, l.map((d) => d.textChange), gI(this._model), this._model.getAlternativeVersionId(), a), a;
  }
  static _computeCursorState(e, t) {
    try {
      return e ? e(t) : null;
    } catch (n) {
      return We(n), null;
    }
  }
}
class EX {
  constructor() {
    this.spacesDiff = 0, this.looksLikeAlignment = !1;
  }
}
function IX(i, e, t, n, s) {
  let o;
  for (s.spacesDiff = 0, s.looksLikeAlignment = !1, o = 0; o < e && o < n && i.charCodeAt(o) === t.charCodeAt(o); o++)
    ;
  let r = 0, a = 0;
  for (let u = o; u < e; u++)
    i.charCodeAt(u) === 32 ? r++ : a++;
  let l = 0, d = 0;
  for (let u = o; u < n; u++)
    t.charCodeAt(u) === 32 ? l++ : d++;
  if (r > 0 && a > 0 || l > 0 && d > 0) return;
  const h = Math.abs(a - d), c = Math.abs(r - l);
  if (h === 0) return s.spacesDiff = c, void (c > 0 && 0 <= l - 1 && l - 1 < i.length && l < t.length && t.charCodeAt(l) !== 32 && i.charCodeAt(l - 1) === 32 && i.charCodeAt(i.length - 1) === 44 && (s.looksLikeAlignment = !0));
  c % h != 0 || (s.spacesDiff = c / h);
}
function L5(i, e, t) {
  const n = Math.min(i.getLineCount(), 1e4);
  let s = 0, o = 0, r = "", a = 0;
  const l = [2, 4, 6, 8, 3, 5, 7], d = [0, 0, 0, 0, 0, 0, 0, 0, 0], h = new EX();
  for (let g = 1; g <= n; g++) {
    const p = i.getLineLength(g), f = i.getLineContent(g), _ = p <= 65536;
    let v = !1, b = 0, C = 0, w = 0;
    for (let L = 0, k = p; L < k; L++) {
      const N = _ ? f.charCodeAt(L) : i.getLineCharCode(g, L);
      if (N === 9) w++;
      else {
        if (N !== 32) {
          v = !0, b = L;
          break;
        }
        C++;
      }
    }
    if (!v || (w > 0 ? s++ : C > 1 && o++, IX(r, a, f, b, h), h.looksLikeAlignment && (!t || e !== h.spacesDiff))) continue;
    const y = h.spacesDiff;
    y <= 8 && d[y]++, r = f, a = b;
  }
  let c = t;
  s !== o && (c = s < o);
  let u = e;
  if (c) {
    let g = c ? 0 : 0.1 * n;
    l.forEach((p) => {
      const f = d[p];
      f > g && (g = f, u = p);
    }), u === 4 && d[4] > 0 && d[2] > 0 && d[2] >= d[4] / 2 && (u = 2);
  }
  return { insertSpaces: c, tabSize: u };
}
function ks(i) {
  return (1 & i.metadata) >>> 0;
}
function $t(i, e) {
  i.metadata = 254 & i.metadata | e;
}
function Ln(i) {
  return (2 & i.metadata) >>> 1 == 1;
}
function Ut(i, e) {
  i.metadata = 253 & i.metadata | (e ? 1 : 0) << 1;
}
function k5(i) {
  return (4 & i.metadata) >>> 2 == 1;
}
function D5(i, e) {
  i.metadata = 251 & i.metadata | (e ? 1 : 0) << 2;
}
function x5(i) {
  return (64 & i.metadata) >>> 6 == 1;
}
function N5(i, e) {
  i.metadata = 191 & i.metadata | (e ? 1 : 0) << 6;
}
function E5(i, e) {
  i.metadata = 231 & i.metadata | e << 3;
}
function I5(i, e) {
  i.metadata = 223 & i.metadata | (e ? 1 : 0) << 5;
}
class oW {
  constructor(e, t, n) {
    this.metadata = 0, this.parent = this, this.left = this, this.right = this, $t(this, 1), this.start = t, this.end = n, this.delta = 0, this.maxEnd = n, this.id = e, this.ownerId = 0, this.options = null, D5(this, !1), N5(this, !1), E5(this, 1), I5(this, !1), this.cachedVersionId = 0, this.cachedAbsoluteStart = t, this.cachedAbsoluteEnd = n, this.range = null, Ut(this, !1);
  }
  reset(e, t, n, s) {
    this.start = t, this.end = n, this.maxEnd = n, this.cachedVersionId = e, this.cachedAbsoluteStart = t, this.cachedAbsoluteEnd = n, this.range = s;
  }
  setOptions(e) {
    this.options = e;
    const t = this.options.className;
    D5(this, t === "squiggly-error" || t === "squiggly-warning" || t === "squiggly-info"), N5(this, this.options.glyphMarginClassName !== null), E5(this, this.options.stickiness), I5(this, this.options.collapseOnReplaceEdit);
  }
  setCachedOffsets(e, t, n) {
    this.cachedVersionId !== n && (this.range = null), this.cachedVersionId = n, this.cachedAbsoluteStart = e, this.cachedAbsoluteEnd = t;
  }
  detach() {
    this.parent = null, this.left = null, this.right = null;
  }
}
const Qe = new oW(null, 0, 0);
Qe.parent = Qe, Qe.left = Qe, Qe.right = Qe, $t(Qe, 0);
class DD {
  constructor() {
    this.root = Qe, this.requestNormalizeDelta = !1;
  }
  intervalSearch(e, t, n, s, o, r) {
    return this.root === Qe ? [] : function(a, l, d, h, c, u, g) {
      let p = a.root, f = 0, _ = 0, v = 0, b = 0;
      const C = [];
      let w = 0;
      for (; p !== Qe; ) if (Ln(p)) Ut(p.left, !1), Ut(p.right, !1), p === p.parent.right && (f -= p.parent.delta), p = p.parent;
      else {
        if (!Ln(p.left)) {
          if (_ = f + p.maxEnd, _ < l) {
            Ut(p, !0);
            continue;
          }
          if (p.left !== Qe) {
            p = p.left;
            continue;
          }
        }
        if (v = f + p.start, v > d) Ut(p, !0);
        else {
          if (b = f + p.end, b >= l) {
            p.setCachedOffsets(v, b, u);
            let y = !0;
            h && p.ownerId && p.ownerId !== h && (y = !1), c && k5(p) && (y = !1), g && !x5(p) && (y = !1), y && (C[w++] = p);
          }
          Ut(p, !0), p.right === Qe || Ln(p.right) || (f += p.delta, p = p.right);
        }
      }
      return Ut(a.root, !1), C;
    }(this, e, t, n, s, o, r);
  }
  search(e, t, n, s) {
    return this.root === Qe ? [] : function(o, r, a, l, d) {
      let h = o.root, c = 0, u = 0, g = 0;
      const p = [];
      let f = 0;
      for (; h !== Qe; ) {
        if (Ln(h)) {
          Ut(h.left, !1), Ut(h.right, !1), h === h.parent.right && (c -= h.parent.delta), h = h.parent;
          continue;
        }
        if (h.left !== Qe && !Ln(h.left)) {
          h = h.left;
          continue;
        }
        u = c + h.start, g = c + h.end, h.setCachedOffsets(u, g, l);
        let _ = !0;
        r && h.ownerId && h.ownerId !== r && (_ = !1), a && k5(h) && (_ = !1), d && !x5(h) && (_ = !1), _ && (p[f++] = h), Ut(h, !0), h.right === Qe || Ln(h.right) || (c += h.delta, h = h.right);
      }
      return Ut(o.root, !1), p;
    }(this, e, t, n, s);
  }
  collectNodesFromOwner(e) {
    return function(t, n) {
      let s = t.root;
      const o = [];
      let r = 0;
      for (; s !== Qe; ) Ln(s) ? (Ut(s.left, !1), Ut(s.right, !1), s = s.parent) : s.left === Qe || Ln(s.left) ? (s.ownerId === n && (o[r++] = s), Ut(s, !0), s.right === Qe || Ln(s.right) || (s = s.right)) : s = s.left;
      return Ut(t.root, !1), o;
    }(this, e);
  }
  collectNodesPostOrder() {
    return function(e) {
      let t = e.root;
      const n = [];
      let s = 0;
      for (; t !== Qe; ) Ln(t) ? (Ut(t.left, !1), Ut(t.right, !1), t = t.parent) : t.left === Qe || Ln(t.left) ? t.right === Qe || Ln(t.right) ? (n[s++] = t, Ut(t, !0)) : t = t.right : t = t.left;
      return Ut(e.root, !1), n;
    }(this);
  }
  insert(e) {
    M5(this, e), this._normalizeDeltaIfNecessary();
  }
  delete(e) {
    T5(this, e), this._normalizeDeltaIfNecessary();
  }
  resolveNode(e, t) {
    const n = e;
    let s = 0;
    for (; e !== this.root; ) e === e.parent.right && (s += e.parent.delta), e = e.parent;
    const o = n.start + s, r = n.end + s;
    n.setCachedOffsets(o, r, t);
  }
  acceptReplace(e, t, n, s) {
    const o = function(r, a, l) {
      let d = r.root, h = 0, c = 0, u = 0, g = 0;
      const p = [];
      let f = 0;
      for (; d !== Qe; ) if (Ln(d)) Ut(d.left, !1), Ut(d.right, !1), d === d.parent.right && (h -= d.parent.delta), d = d.parent;
      else {
        if (!Ln(d.left)) {
          if (c = h + d.maxEnd, c < a) {
            Ut(d, !0);
            continue;
          }
          if (d.left !== Qe) {
            d = d.left;
            continue;
          }
        }
        u = h + d.start, u > l ? Ut(d, !0) : (g = h + d.end, g >= a && (d.setCachedOffsets(u, g, 0), p[f++] = d), Ut(d, !0), d.right === Qe || Ln(d.right) || (h += d.delta, d = d.right));
      }
      return Ut(r.root, !1), p;
    }(this, e, e + t);
    for (let r = 0, a = o.length; r < a; r++)
      T5(this, o[r]);
    this._normalizeDeltaIfNecessary(), function(r, a, l, d) {
      let h = r.root, c = 0, u = 0, g = 0;
      const p = d - (l - a);
      for (; h !== Qe; ) if (Ln(h)) Ut(h.left, !1), Ut(h.right, !1), h === h.parent.right && (c -= h.parent.delta), xc(h), h = h.parent;
      else {
        if (!Ln(h.left)) {
          if (u = c + h.maxEnd, u < a) {
            Ut(h, !0);
            continue;
          }
          if (h.left !== Qe) {
            h = h.left;
            continue;
          }
        }
        g = c + h.start, g > l ? (h.start += p, h.end += p, h.delta += p, (h.delta < -1073741824 || h.delta > 1073741824) && (r.requestNormalizeDelta = !0), Ut(h, !0)) : (Ut(h, !0), h.right === Qe || Ln(h.right) || (c += h.delta, h = h.right));
      }
      Ut(r.root, !1);
    }(this, e, e + t, n), this._normalizeDeltaIfNecessary();
    for (let r = 0, a = o.length; r < a; r++) {
      const l = o[r];
      l.start = l.cachedAbsoluteStart, l.end = l.cachedAbsoluteEnd, MX(l, e, e + t, n, s), l.maxEnd = l.end, M5(this, l);
    }
    this._normalizeDeltaIfNecessary();
  }
  _normalizeDeltaIfNecessary() {
    this.requestNormalizeDelta && (this.requestNormalizeDelta = !1, function(e) {
      let t = e.root, n = 0;
      for (; t !== Qe; ) t.left === Qe || Ln(t.left) ? t.right === Qe || Ln(t.right) ? (t.start = n + t.start, t.end = n + t.end, t.delta = 0, xc(t), Ut(t, !0), Ut(t.left, !1), Ut(t.right, !1), t === t.parent.right && (n -= t.parent.delta), t = t.parent) : (n += t.delta, t = t.right) : t = t.left;
      Ut(e.root, !1);
    }(this));
  }
}
function Xg(i, e, t, n) {
  return i < t || !(i > t) && n !== 1 && (n === 2 || e);
}
function MX(i, e, t, n, s) {
  const o = function(_) {
    return (24 & _.metadata) >>> 3;
  }(i), r = o === 0 || o === 2, a = o === 1 || o === 2, l = t - e, d = n, h = Math.min(l, d), c = i.start;
  let u = !1;
  const g = i.end;
  let p = !1;
  e <= c && g <= t && function(_) {
    return (32 & _.metadata) >>> 5 == 1;
  }(i) && (i.start = e, u = !0, i.end = e, p = !0);
  {
    const _ = s ? 1 : l > 0 ? 2 : 0;
    !u && Xg(c, r, e, _) && (u = !0), !p && Xg(g, a, e, _) && (p = !0);
  }
  if (h > 0 && !s) {
    const _ = l > d ? 2 : 0;
    !u && Xg(c, r, e + h, _) && (u = !0), !p && Xg(g, a, e + h, _) && (p = !0);
  }
  {
    const _ = s ? 1 : 0;
    !u && Xg(c, r, t, _) && (i.start = e + d, u = !0), !p && Xg(g, a, t, _) && (i.end = e + d, p = !0);
  }
  const f = d - l;
  u || (i.start = Math.max(0, c + f)), p || (i.end = Math.max(0, g + f)), i.start > i.end && (i.end = i.start);
}
function M5(i, e) {
  if (i.root === Qe) return e.parent = Qe, e.left = Qe, e.right = Qe, $t(e, 0), i.root = e, i.root;
  (function(n, s) {
    let o = 0, r = n.root;
    const a = s.start, l = s.end;
    for (; ; )
      if (TX(a, l, r.start + o, r.end + o) < 0) {
        if (r.left === Qe) {
          s.start -= o, s.end -= o, s.maxEnd -= o, r.left = s;
          break;
        }
        r = r.left;
      } else {
        if (r.right === Qe) {
          s.start -= o + r.delta, s.end -= o + r.delta, s.maxEnd -= o + r.delta, r.right = s;
          break;
        }
        o += r.delta, r = r.right;
      }
    s.parent = r, s.left = Qe, s.right = Qe, $t(s, 1);
  })(i, e), ah(e.parent);
  let t = e;
  for (; t !== i.root && ks(t.parent) === 1; ) if (t.parent === t.parent.parent.left) {
    const n = t.parent.parent.right;
    ks(n) === 1 ? ($t(t.parent, 0), $t(n, 0), $t(t.parent.parent, 1), t = t.parent.parent) : (t === t.parent.right && (t = t.parent, l0(i, t)), $t(t.parent, 0), $t(t.parent.parent, 1), d0(i, t.parent.parent));
  } else {
    const n = t.parent.parent.left;
    ks(n) === 1 ? ($t(t.parent, 0), $t(n, 0), $t(t.parent.parent, 1), t = t.parent.parent) : (t === t.parent.left && (t = t.parent, d0(i, t)), $t(t.parent, 0), $t(t.parent.parent, 1), l0(i, t.parent.parent));
  }
  return $t(i.root, 0), e;
}
function T5(i, e) {
  let t, n;
  if (e.left === Qe ? (t = e.right, n = e, t.delta += e.delta, (t.delta < -1073741824 || t.delta > 1073741824) && (i.requestNormalizeDelta = !0), t.start += e.delta, t.end += e.delta) : e.right === Qe ? (t = e.left, n = e) : (n = function(r) {
    for (; r.left !== Qe; ) r = r.left;
    return r;
  }(e.right), t = n.right, t.start += n.delta, t.end += n.delta, t.delta += n.delta, (t.delta < -1073741824 || t.delta > 1073741824) && (i.requestNormalizeDelta = !0), n.start += e.delta, n.end += e.delta, n.delta = e.delta, (n.delta < -1073741824 || n.delta > 1073741824) && (i.requestNormalizeDelta = !0)), n === i.root) return i.root = t, $t(t, 0), e.detach(), xD(), xc(t), void (i.root.parent = Qe);
  const s = ks(n) === 1;
  if (n === n.parent.left ? n.parent.left = t : n.parent.right = t, n === e ? t.parent = n.parent : (n.parent === e ? t.parent = n : t.parent = n.parent, n.left = e.left, n.right = e.right, n.parent = e.parent, $t(n, ks(e)), e === i.root ? i.root = n : e === e.parent.left ? e.parent.left = n : e.parent.right = n, n.left !== Qe && (n.left.parent = n), n.right !== Qe && (n.right.parent = n)), e.detach(), s) return ah(t.parent), n !== e && (ah(n), ah(n.parent)), void xD();
  let o;
  for (ah(t), ah(t.parent), n !== e && (ah(n), ah(n.parent)); t !== i.root && ks(t) === 0; ) t === t.parent.left ? (o = t.parent.right, ks(o) === 1 && ($t(o, 0), $t(t.parent, 1), l0(i, t.parent), o = t.parent.right), ks(o.left) === 0 && ks(o.right) === 0 ? ($t(o, 1), t = t.parent) : (ks(o.right) === 0 && ($t(o.left, 0), $t(o, 1), d0(i, o), o = t.parent.right), $t(o, ks(t.parent)), $t(t.parent, 0), $t(o.right, 0), l0(i, t.parent), t = i.root)) : (o = t.parent.left, ks(o) === 1 && ($t(o, 0), $t(t.parent, 1), d0(i, t.parent), o = t.parent.left), ks(o.left) === 0 && ks(o.right) === 0 ? ($t(o, 1), t = t.parent) : (ks(o.left) === 0 && ($t(o.right, 0), $t(o, 1), l0(i, o), o = t.parent.left), $t(o, ks(t.parent)), $t(t.parent, 0), $t(o.left, 0), d0(i, t.parent), t = i.root));
  $t(t, 0), xD();
}
function xD() {
  Qe.parent = Qe, Qe.delta = 0, Qe.start = 0, Qe.end = 0;
}
function l0(i, e) {
  const t = e.right;
  t.delta += e.delta, (t.delta < -1073741824 || t.delta > 1073741824) && (i.requestNormalizeDelta = !0), t.start += e.delta, t.end += e.delta, e.right = t.left, t.left !== Qe && (t.left.parent = e), t.parent = e.parent, e.parent === Qe ? i.root = t : e === e.parent.left ? e.parent.left = t : e.parent.right = t, t.left = e, e.parent = t, xc(e), xc(t);
}
function d0(i, e) {
  const t = e.left;
  e.delta -= t.delta, (e.delta < -1073741824 || e.delta > 1073741824) && (i.requestNormalizeDelta = !0), e.start -= t.delta, e.end -= t.delta, e.left = t.right, t.right !== Qe && (t.right.parent = e), t.parent = e.parent, e.parent === Qe ? i.root = t : e === e.parent.right ? e.parent.right = t : e.parent.left = t, t.right = e, e.parent = t, xc(e), xc(t);
}
function rW(i) {
  let e = i.end;
  if (i.left !== Qe) {
    const t = i.left.maxEnd;
    t > e && (e = t);
  }
  if (i.right !== Qe) {
    const t = i.right.maxEnd + i.delta;
    t > e && (e = t);
  }
  return e;
}
function xc(i) {
  i.maxEnd = rW(i);
}
function ah(i) {
  for (; i !== Qe; ) {
    const e = rW(i);
    if (i.maxEnd === e) return;
    i.maxEnd = e, i = i.parent;
  }
}
function TX(i, e, t, n) {
  return i === t ? e - n : i - t;
}
class pI {
  constructor(e, t) {
    this.piece = e, this.color = t, this.size_left = 0, this.lf_left = 0, this.parent = this, this.left = this, this.right = this;
  }
  next() {
    if (this.right !== ze) return eA(this.right);
    let e = this;
    for (; e.parent !== ze && e.parent.left !== e; ) e = e.parent;
    return e.parent === ze ? ze : e.parent;
  }
  prev() {
    if (this.left !== ze) return aW(this.left);
    let e = this;
    for (; e.parent !== ze && e.parent.right !== e; ) e = e.parent;
    return e.parent === ze ? ze : e.parent;
  }
  detach() {
    this.parent = null, this.left = null, this.right = null;
  }
}
const ze = new pI(null, 0);
function eA(i) {
  for (; i.left !== ze; ) i = i.left;
  return i;
}
function aW(i) {
  for (; i.right !== ze; ) i = i.right;
  return i;
}
function tA(i) {
  return i === ze ? 0 : i.size_left + i.piece.length + tA(i.right);
}
function iA(i) {
  return i === ze ? 0 : i.lf_left + i.piece.lineFeedCnt + iA(i.right);
}
function ND() {
  ze.parent = ze;
}
function h0(i, e) {
  const t = e.right;
  t.size_left += e.size_left + (e.piece ? e.piece.length : 0), t.lf_left += e.lf_left + (e.piece ? e.piece.lineFeedCnt : 0), e.right = t.left, t.left !== ze && (t.left.parent = e), t.parent = e.parent, e.parent === ze ? i.root = t : e.parent.left === e ? e.parent.left = t : e.parent.right = t, t.left = e, e.parent = t;
}
function c0(i, e) {
  const t = e.left;
  e.left = t.right, t.right !== ze && (t.right.parent = e), t.parent = e.parent, e.size_left -= t.size_left + (t.piece ? t.piece.length : 0), e.lf_left -= t.lf_left + (t.piece ? t.piece.lineFeedCnt : 0), e.parent === ze ? i.root = t : e === e.parent.right ? e.parent.right = t : e.parent.left = t, t.right = e, e.parent = t;
}
function Sb(i, e) {
  let t, n;
  if (e.left === ze ? (n = e, t = n.right) : e.right === ze ? (n = e, t = n.left) : (n = eA(e.right), t = n.right), n === i.root) return i.root = t, t.color = 0, e.detach(), ND(), void (i.root.parent = ze);
  const s = n.color === 1;
  if (n === n.parent.left ? n.parent.left = t : n.parent.right = t, n === e ? (t.parent = n.parent, D_(i, t)) : (n.parent === e ? t.parent = n : t.parent = n.parent, D_(i, t), n.left = e.left, n.right = e.right, n.parent = e.parent, n.color = e.color, e === i.root ? i.root = n : e === e.parent.left ? e.parent.left = n : e.parent.right = n, n.left !== ze && (n.left.parent = n), n.right !== ze && (n.right.parent = n), n.size_left = e.size_left, n.lf_left = e.lf_left, D_(i, n)), e.detach(), t.parent.left === t) {
    const r = tA(t), a = iA(t);
    if (r !== t.parent.size_left || a !== t.parent.lf_left) {
      const l = r - t.parent.size_left, d = a - t.parent.lf_left;
      t.parent.size_left = r, t.parent.lf_left = a, Ol(i, t.parent, l, d);
    }
  }
  if (D_(i, t.parent), s) return void ND();
  let o;
  for (; t !== i.root && t.color === 0; ) t === t.parent.left ? (o = t.parent.right, o.color === 1 && (o.color = 0, t.parent.color = 1, h0(i, t.parent), o = t.parent.right), o.left.color === 0 && o.right.color === 0 ? (o.color = 1, t = t.parent) : (o.right.color === 0 && (o.left.color = 0, o.color = 1, c0(i, o), o = t.parent.right), o.color = t.parent.color, t.parent.color = 0, o.right.color = 0, h0(i, t.parent), t = i.root)) : (o = t.parent.left, o.color === 1 && (o.color = 0, t.parent.color = 1, c0(i, t.parent), o = t.parent.left), o.left.color === 0 && o.right.color === 0 ? (o.color = 1, t = t.parent) : (o.left.color === 0 && (o.right.color = 0, o.color = 1, h0(i, o), o = t.parent.left), o.color = t.parent.color, t.parent.color = 0, o.left.color = 0, c0(i, t.parent), t = i.root));
  t.color = 0, ND();
}
function R5(i, e) {
  for (D_(i, e); e !== i.root && e.parent.color === 1; ) if (e.parent === e.parent.parent.left) {
    const t = e.parent.parent.right;
    t.color === 1 ? (e.parent.color = 0, t.color = 0, e.parent.parent.color = 1, e = e.parent.parent) : (e === e.parent.right && h0(i, e = e.parent), e.parent.color = 0, e.parent.parent.color = 1, c0(i, e.parent.parent));
  } else {
    const t = e.parent.parent.left;
    t.color === 1 ? (e.parent.color = 0, t.color = 0, e.parent.parent.color = 1, e = e.parent.parent) : (e === e.parent.left && c0(i, e = e.parent), e.parent.color = 0, e.parent.parent.color = 1, h0(i, e.parent.parent));
  }
  i.root.color = 0;
}
function Ol(i, e, t, n) {
  for (; e !== i.root && e !== ze; ) e.parent.left === e && (e.parent.size_left += t, e.parent.lf_left += n), e = e.parent;
}
function D_(i, e) {
  let t = 0, n = 0;
  if (e !== i.root) {
    for (; e !== i.root && e === e.parent.right; ) e = e.parent;
    if (e !== i.root) for (t = tA((e = e.parent).left) - e.size_left, n = iA(e.left) - e.lf_left, e.size_left += t, e.lf_left += n; e !== i.root && (t !== 0 || n !== 0); ) e.parent.left === e && (e.parent.size_left += t, e.parent.lf_left += n), e = e.parent;
  }
}
ze.parent = ze, ze.left = ze, ze.right = ze, ze.color = 0;
const Qg = 65535;
function lW(i) {
  let e;
  return e = i[i.length - 1] < 65536 ? new Uint16Array(i.length) : new Uint32Array(i.length), e.set(i, 0), e;
}
class RX {
  constructor(e, t, n, s, o) {
    this.lineStarts = e, this.cr = t, this.lf = n, this.crlf = s, this.isBasicASCII = o;
  }
}
function Wl(i, e = !0) {
  const t = [0];
  let n = 1;
  for (let s = 0, o = i.length; s < o; s++) {
    const r = i.charCodeAt(s);
    r === 13 ? s + 1 < o && i.charCodeAt(s + 1) === 10 ? (t[n++] = s + 2, s++) : t[n++] = s + 1 : r === 10 && (t[n++] = s + 1);
  }
  return e ? lW(t) : t;
}
class zs {
  constructor(e, t, n, s, o) {
    this.bufferIndex = e, this.start = t, this.end = n, this.lineFeedCnt = s, this.length = o;
  }
}
class yu {
  constructor(e, t) {
    this.buffer = e, this.lineStarts = t;
  }
}
class AX {
  constructor(e, t) {
    this._pieces = [], this._tree = e, this._BOM = t, this._index = 0, e.root !== ze && e.iterate(e.root, (n) => (n !== ze && this._pieces.push(n.piece), !0));
  }
  read() {
    return this._pieces.length === 0 ? this._index === 0 ? (this._index++, this._BOM) : null : this._index > this._pieces.length - 1 ? null : this._index === 0 ? this._BOM + this._tree.getPieceContent(this._pieces[this._index++]) : this._tree.getPieceContent(this._pieces[this._index++]);
  }
}
class PX {
  constructor(e) {
    this._limit = e, this._cache = [];
  }
  get(e) {
    for (let t = this._cache.length - 1; t >= 0; t--) {
      const n = this._cache[t];
      if (n.nodeStartOffset <= e && n.nodeStartOffset + n.node.piece.length >= e) return n;
    }
    return null;
  }
  get2(e) {
    for (let t = this._cache.length - 1; t >= 0; t--) {
      const n = this._cache[t];
      if (n.nodeStartLineNumber && n.nodeStartLineNumber < e && n.nodeStartLineNumber + n.node.piece.lineFeedCnt >= e) return n;
    }
    return null;
  }
  set(e) {
    this._cache.length >= this._limit && this._cache.shift(), this._cache.push(e);
  }
  validate(e) {
    let t = !1;
    const n = this._cache;
    for (let s = 0; s < n.length; s++) {
      const o = n[s];
      (o.node.parent === null || o.nodeStartOffset >= e) && (n[s] = null, t = !0);
    }
    if (t) {
      const s = [];
      for (const o of n) o !== null && s.push(o);
      this._cache = s;
    }
  }
}
class OX {
  constructor(e, t, n) {
    this.create(e, t, n);
  }
  create(e, t, n) {
    this._buffers = [new yu("", [0])], this._lastChangeBufferPos = { line: 0, column: 0 }, this.root = ze, this._lineCnt = 1, this._length = 0, this._EOL = t, this._EOLLength = t.length, this._EOLNormalized = n;
    let s = null;
    for (let o = 0, r = e.length; o < r; o++) if (e[o].buffer.length > 0) {
      e[o].lineStarts || (e[o].lineStarts = Wl(e[o].buffer));
      const a = new zs(o + 1, { line: 0, column: 0 }, { line: e[o].lineStarts.length - 1, column: e[o].buffer.length - e[o].lineStarts[e[o].lineStarts.length - 1] }, e[o].lineStarts.length - 1, e[o].buffer.length);
      this._buffers.push(e[o]), s = this.rbInsertRight(s, a);
    }
    this._searchCache = new PX(1), this._lastVisitedLine = { lineNumber: 0, value: "" }, this.computeBufferMetadata();
  }
  normalizeEOL(e) {
    const t = Qg, n = t - Math.floor(21845), s = 2 * n;
    let o = "", r = 0;
    const a = [];
    if (this.iterate(this.root, (l) => {
      const d = this.getNodeContent(l), h = d.length;
      if (r <= n || r + h < s) return o += d, r += h, !0;
      const c = o.replace(/\r\n|\r|\n/g, e);
      return a.push(new yu(c, Wl(c))), o = d, r = h, !0;
    }), r > 0) {
      const l = o.replace(/\r\n|\r|\n/g, e);
      a.push(new yu(l, Wl(l)));
    }
    this.create(a, e, !0);
  }
  getEOL() {
    return this._EOL;
  }
  setEOL(e) {
    this._EOL = e, this._EOLLength = this._EOL.length, this.normalizeEOL(e);
  }
  createSnapshot(e) {
    return new AX(this, e);
  }
  getOffsetAt(e, t) {
    let n = 0, s = this.root;
    for (; s !== ze; ) if (s.left !== ze && s.lf_left + 1 >= e) s = s.left;
    else {
      if (s.lf_left + s.piece.lineFeedCnt + 1 >= e)
        return n += s.size_left, n + (this.getAccumulatedValue(s, e - s.lf_left - 2) + t - 1);
      e -= s.lf_left + s.piece.lineFeedCnt, n += s.size_left + s.piece.length, s = s.right;
    }
    return n;
  }
  getPositionAt(e) {
    e = Math.floor(e), e = Math.max(0, e);
    let t = this.root, n = 0;
    const s = e;
    for (; t !== ze; ) if (t.size_left !== 0 && t.size_left >= e) t = t.left;
    else {
      if (t.size_left + t.piece.length >= e) {
        const o = this.getIndexOf(t, e - t.size_left);
        if (n += t.lf_left + o.index, o.index === 0) {
          const r = this.getOffsetAt(n + 1, 1);
          return new W(n + 1, s - r + 1);
        }
        return new W(n + 1, o.remainder + 1);
      }
      if (e -= t.size_left + t.piece.length, n += t.lf_left + t.piece.lineFeedCnt, t.right === ze) {
        const o = this.getOffsetAt(n + 1, 1);
        return new W(n + 1, s - e - o + 1);
      }
      t = t.right;
    }
    return new W(1, 1);
  }
  getValueInRange(e, t) {
    if (e.startLineNumber === e.endLineNumber && e.startColumn === e.endColumn) return "";
    const n = this.nodeAt2(e.startLineNumber, e.startColumn), s = this.nodeAt2(e.endLineNumber, e.endColumn), o = this.getValueInRange2(n, s);
    return t ? t === this._EOL && this._EOLNormalized && t === this.getEOL() && this._EOLNormalized ? o : o.replace(/\r\n|\r|\n/g, t) : o;
  }
  getValueInRange2(e, t) {
    if (e.node === t.node) {
      const a = e.node, l = this._buffers[a.piece.bufferIndex].buffer, d = this.offsetInBuffer(a.piece.bufferIndex, a.piece.start);
      return l.substring(d + e.remainder, d + t.remainder);
    }
    let n = e.node;
    const s = this._buffers[n.piece.bufferIndex].buffer, o = this.offsetInBuffer(n.piece.bufferIndex, n.piece.start);
    let r = s.substring(o + e.remainder, o + n.piece.length);
    for (n = n.next(); n !== ze; ) {
      const a = this._buffers[n.piece.bufferIndex].buffer, l = this.offsetInBuffer(n.piece.bufferIndex, n.piece.start);
      if (n === t.node) {
        r += a.substring(l, l + t.remainder);
        break;
      }
      r += a.substr(l, n.piece.length), n = n.next();
    }
    return r;
  }
  getLinesContent() {
    const e = [];
    let t = 0, n = "", s = !1;
    return this.iterate(this.root, (o) => {
      if (o === ze) return !0;
      const r = o.piece;
      let a = r.length;
      if (a === 0) return !0;
      const l = this._buffers[r.bufferIndex].buffer, d = this._buffers[r.bufferIndex].lineStarts, h = r.start.line, c = r.end.line;
      let u = d[h] + r.start.column;
      if (s && (l.charCodeAt(u) === 10 && (u++, a--), e[t++] = n, n = "", s = !1, a === 0)) return !0;
      if (h === c) return this._EOLNormalized || l.charCodeAt(u + a - 1) !== 13 ? n += l.substr(u, a) : (s = !0, n += l.substr(u, a - 1)), !0;
      n += this._EOLNormalized ? l.substring(u, Math.max(u, d[h + 1] - this._EOLLength)) : l.substring(u, d[h + 1]).replace(/(\r\n|\r|\n)$/, ""), e[t++] = n;
      for (let g = h + 1; g < c; g++) n = this._EOLNormalized ? l.substring(d[g], d[g + 1] - this._EOLLength) : l.substring(d[g], d[g + 1]).replace(/(\r\n|\r|\n)$/, ""), e[t++] = n;
      return this._EOLNormalized || l.charCodeAt(d[c] + r.end.column - 1) !== 13 ? n = l.substr(d[c], r.end.column) : (s = !0, r.end.column === 0 ? t-- : n = l.substr(d[c], r.end.column - 1)), !0;
    }), s && (e[t++] = n, n = ""), e[t++] = n, e;
  }
  getLength() {
    return this._length;
  }
  getLineCount() {
    return this._lineCnt;
  }
  getLineContent(e) {
    return this._lastVisitedLine.lineNumber === e || (this._lastVisitedLine.lineNumber = e, e === this._lineCnt ? this._lastVisitedLine.value = this.getLineRawContent(e) : this._EOLNormalized ? this._lastVisitedLine.value = this.getLineRawContent(e, this._EOLLength) : this._lastVisitedLine.value = this.getLineRawContent(e).replace(/(\r\n|\r|\n)$/, "")), this._lastVisitedLine.value;
  }
  _getCharCode(e) {
    if (e.remainder === e.node.piece.length) {
      const t = e.node.next();
      if (!t) return 0;
      const n = this._buffers[t.piece.bufferIndex], s = this.offsetInBuffer(t.piece.bufferIndex, t.piece.start);
      return n.buffer.charCodeAt(s);
    }
    {
      const t = this._buffers[e.node.piece.bufferIndex], n = this.offsetInBuffer(e.node.piece.bufferIndex, e.node.piece.start) + e.remainder;
      return t.buffer.charCodeAt(n);
    }
  }
  getLineCharCode(e, t) {
    const n = this.nodeAt2(e, t + 1);
    return this._getCharCode(n);
  }
  getLineLength(e) {
    if (e === this.getLineCount()) {
      const t = this.getOffsetAt(e, 1);
      return this.getLength() - t;
    }
    return this.getOffsetAt(e + 1, 1) - this.getOffsetAt(e, 1) - this._EOLLength;
  }
  findMatchesInNode(e, t, n, s, o, r, a, l, d, h, c) {
    const u = this._buffers[e.piece.bufferIndex], g = this.offsetInBuffer(e.piece.bufferIndex, e.piece.start), p = this.offsetInBuffer(e.piece.bufferIndex, o), f = this.offsetInBuffer(e.piece.bufferIndex, r);
    let _;
    const v = { line: 0, column: 0 };
    let b, C;
    t._wordSeparators ? (b = u.buffer.substring(p, f), C = (w) => w + p, t.reset(0)) : (b = u.buffer, C = (w) => w, t.reset(p));
    do
      if (_ = t.next(b), _) {
        if (C(_.index) >= f) return h;
        this.positionInBuffer(e, C(_.index) - g, v);
        const w = this.getLineFeedCnt(e.piece.bufferIndex, o, v), y = v.line === o.line ? v.column - o.column + s : v.column + 1, L = y + _[0].length;
        if (c[h++] = mu(new D(n + w, y, n + w, L), _, l), C(_.index) + _[0].length >= f || h >= d) return h;
      }
    while (_);
    return h;
  }
  findMatchesLineByLine(e, t, n, s) {
    const o = [];
    let r = 0;
    const a = new Ep(t.wordSeparators, t.regex);
    let l = this.nodeAt2(e.startLineNumber, e.startColumn);
    if (l === null) return [];
    const d = this.nodeAt2(e.endLineNumber, e.endColumn);
    if (d === null) return [];
    let h = this.positionInBuffer(l.node, l.remainder);
    const c = this.positionInBuffer(d.node, d.remainder);
    if (l.node === d.node) return this.findMatchesInNode(l.node, a, e.startLineNumber, e.startColumn, h, c, t, n, s, r, o), o;
    let u = e.startLineNumber, g = l.node;
    for (; g !== d.node; ) {
      const f = this.getLineFeedCnt(g.piece.bufferIndex, h, g.piece.end);
      if (f >= 1) {
        const v = this._buffers[g.piece.bufferIndex].lineStarts, b = this.offsetInBuffer(g.piece.bufferIndex, g.piece.start), C = v[h.line + f], w = u === e.startLineNumber ? e.startColumn : 1;
        if (r = this.findMatchesInNode(g, a, u, w, h, this.positionInBuffer(g, C - b), t, n, s, r, o), r >= s) return o;
        u += f;
      }
      const _ = u === e.startLineNumber ? e.startColumn - 1 : 0;
      if (u === e.endLineNumber) {
        const v = this.getLineContent(u).substring(_, e.endColumn - 1);
        return r = this._findMatchesInLine(t, a, v, e.endLineNumber, _, r, o, n, s), o;
      }
      if (r = this._findMatchesInLine(t, a, this.getLineContent(u).substr(_), u, _, r, o, n, s), r >= s) return o;
      u++, l = this.nodeAt2(u, 1), g = l.node, h = this.positionInBuffer(l.node, l.remainder);
    }
    if (u === e.endLineNumber) {
      const f = u === e.startLineNumber ? e.startColumn - 1 : 0, _ = this.getLineContent(u).substring(f, e.endColumn - 1);
      return r = this._findMatchesInLine(t, a, _, e.endLineNumber, f, r, o, n, s), o;
    }
    const p = u === e.startLineNumber ? e.startColumn : 1;
    return r = this.findMatchesInNode(d.node, a, u, p, h, c, t, n, s, r, o), o;
  }
  _findMatchesInLine(e, t, n, s, o, r, a, l, d) {
    const h = e.wordSeparators;
    if (!l && e.simpleSearch) {
      const u = e.simpleSearch, g = u.length, p = n.length;
      let f = -g;
      for (; (f = n.indexOf(u, f + g)) !== -1; ) if ((!h || SR(h, n, p, f, g)) && (a[r++] = new nv(new D(s, f + 1 + o, s, f + 1 + g + o), null), r >= d)) return r;
      return r;
    }
    let c;
    t.reset(0);
    do
      if (c = t.next(n), c && (a[r++] = mu(new D(s, c.index + 1 + o, s, c.index + 1 + c[0].length + o), c, l), r >= d)) return r;
    while (c);
    return r;
  }
  insert(e, t, n = !1) {
    if (this._EOLNormalized = this._EOLNormalized && n, this._lastVisitedLine.lineNumber = 0, this._lastVisitedLine.value = "", this.root !== ze) {
      const { node: s, remainder: o, nodeStartOffset: r } = this.nodeAt(e), a = s.piece, l = a.bufferIndex, d = this.positionInBuffer(s, o);
      if (s.piece.bufferIndex === 0 && a.end.line === this._lastChangeBufferPos.line && a.end.column === this._lastChangeBufferPos.column && r + a.length === e && t.length < Qg) return this.appendToNode(s, t), void this.computeBufferMetadata();
      if (r === e) this.insertContentToNodeLeft(t, s), this._searchCache.validate(e);
      else if (r + s.piece.length > e) {
        const h = [];
        let c = new zs(a.bufferIndex, d, a.end, this.getLineFeedCnt(a.bufferIndex, d, a.end), this.offsetInBuffer(l, a.end) - this.offsetInBuffer(l, d));
        if (this.shouldCheckCRLF() && this.endWithCR(t) && this.nodeCharCodeAt(s, o) === 10) {
          const p = { line: c.start.line + 1, column: 0 };
          c = new zs(c.bufferIndex, p, c.end, this.getLineFeedCnt(c.bufferIndex, p, c.end), c.length - 1), t += `
`;
        }
        if (this.shouldCheckCRLF() && this.startWithLF(t))
          if (this.nodeCharCodeAt(s, o - 1) === 13) {
            const p = this.positionInBuffer(s, o - 1);
            this.deleteNodeTail(s, p), t = "\r" + t, s.piece.length === 0 && h.push(s);
          } else this.deleteNodeTail(s, d);
        else this.deleteNodeTail(s, d);
        const u = this.createNewPieces(t);
        c.length > 0 && this.rbInsertRight(s, c);
        let g = s;
        for (let p = 0; p < u.length; p++) g = this.rbInsertRight(g, u[p]);
        this.deleteNodes(h);
      } else this.insertContentToNodeRight(t, s);
    } else {
      const s = this.createNewPieces(t);
      let o = this.rbInsertLeft(null, s[0]);
      for (let r = 1; r < s.length; r++) o = this.rbInsertRight(o, s[r]);
    }
    this.computeBufferMetadata();
  }
  delete(e, t) {
    if (this._lastVisitedLine.lineNumber = 0, this._lastVisitedLine.value = "", t <= 0 || this.root === ze) return;
    const n = this.nodeAt(e), s = this.nodeAt(e + t), o = n.node, r = s.node;
    if (o === r) {
      const c = this.positionInBuffer(o, n.remainder), u = this.positionInBuffer(o, s.remainder);
      if (n.nodeStartOffset === e) {
        if (t === o.piece.length) {
          const g = o.next();
          return Sb(this, o), this.validateCRLFWithPrevNode(g), void this.computeBufferMetadata();
        }
        return this.deleteNodeHead(o, u), this._searchCache.validate(e), this.validateCRLFWithPrevNode(o), void this.computeBufferMetadata();
      }
      return n.nodeStartOffset + o.piece.length === e + t ? (this.deleteNodeTail(o, c), this.validateCRLFWithNextNode(o), void this.computeBufferMetadata()) : (this.shrinkNode(o, c, u), void this.computeBufferMetadata());
    }
    const a = [], l = this.positionInBuffer(o, n.remainder);
    this.deleteNodeTail(o, l), this._searchCache.validate(e), o.piece.length === 0 && a.push(o);
    const d = this.positionInBuffer(r, s.remainder);
    this.deleteNodeHead(r, d), r.piece.length === 0 && a.push(r);
    for (let c = o.next(); c !== ze && c !== r; c = c.next()) a.push(c);
    const h = o.piece.length === 0 ? o.prev() : o;
    this.deleteNodes(a), this.validateCRLFWithNextNode(h), this.computeBufferMetadata();
  }
  insertContentToNodeLeft(e, t) {
    const n = [];
    if (this.shouldCheckCRLF() && this.endWithCR(e) && this.startWithLF(t)) {
      const r = t.piece, a = { line: r.start.line + 1, column: 0 }, l = new zs(r.bufferIndex, a, r.end, this.getLineFeedCnt(r.bufferIndex, a, r.end), r.length - 1);
      t.piece = l, e += `
`, Ol(this, t, -1, -1), t.piece.length === 0 && n.push(t);
    }
    const s = this.createNewPieces(e);
    let o = this.rbInsertLeft(t, s[s.length - 1]);
    for (let r = s.length - 2; r >= 0; r--) o = this.rbInsertLeft(o, s[r]);
    this.validateCRLFWithPrevNode(o), this.deleteNodes(n);
  }
  insertContentToNodeRight(e, t) {
    this.adjustCarriageReturnFromNext(e, t) && (e += `
`);
    const n = this.createNewPieces(e), s = this.rbInsertRight(t, n[0]);
    let o = s;
    for (let r = 1; r < n.length; r++) o = this.rbInsertRight(o, n[r]);
    this.validateCRLFWithPrevNode(s);
  }
  positionInBuffer(e, t, n) {
    const s = e.piece, o = e.piece.bufferIndex, r = this._buffers[o].lineStarts, a = r[s.start.line] + s.start.column + t;
    let l = s.start.line, d = s.end.line, h = 0, c = 0, u = 0;
    for (; l <= d && (h = l + (d - l) / 2 | 0, u = r[h], h !== d); ) if (c = r[h + 1], a < u) d = h - 1;
    else {
      if (!(a >= c)) break;
      l = h + 1;
    }
    return n ? (n.line = h, n.column = a - u, null) : { line: h, column: a - u };
  }
  getLineFeedCnt(e, t, n) {
    if (n.column === 0) return n.line - t.line;
    const s = this._buffers[e].lineStarts;
    if (n.line === s.length - 1) return n.line - t.line;
    const o = s[n.line + 1], r = s[n.line] + n.column;
    if (o > r + 1) return n.line - t.line;
    const a = r - 1;
    return this._buffers[e].buffer.charCodeAt(a) === 13 ? n.line - t.line + 1 : n.line - t.line;
  }
  offsetInBuffer(e, t) {
    return this._buffers[e].lineStarts[t.line] + t.column;
  }
  deleteNodes(e) {
    for (let t = 0; t < e.length; t++) Sb(this, e[t]);
  }
  createNewPieces(e) {
    if (e.length > Qg) {
      const d = [];
      for (; e.length > Qg; ) {
        const c = e.charCodeAt(65534);
        let u;
        c === 13 || c >= 55296 && c <= 56319 ? (u = e.substring(0, 65534), e = e.substring(65534)) : (u = e.substring(0, Qg), e = e.substring(Qg));
        const g = Wl(u);
        d.push(new zs(this._buffers.length, { line: 0, column: 0 }, { line: g.length - 1, column: u.length - g[g.length - 1] }, g.length - 1, u.length)), this._buffers.push(new yu(u, g));
      }
      const h = Wl(e);
      return d.push(new zs(this._buffers.length, { line: 0, column: 0 }, { line: h.length - 1, column: e.length - h[h.length - 1] }, h.length - 1, e.length)), this._buffers.push(new yu(e, h)), d;
    }
    let t = this._buffers[0].buffer.length;
    const n = Wl(e, !1);
    let s = this._lastChangeBufferPos;
    if (this._buffers[0].lineStarts[this._buffers[0].lineStarts.length - 1] === t && t !== 0 && this.startWithLF(e) && this.endWithCR(this._buffers[0].buffer)) {
      this._lastChangeBufferPos = { line: this._lastChangeBufferPos.line, column: this._lastChangeBufferPos.column + 1 }, s = this._lastChangeBufferPos;
      for (let d = 0; d < n.length; d++) n[d] += t + 1;
      this._buffers[0].lineStarts = this._buffers[0].lineStarts.concat(n.slice(1)), this._buffers[0].buffer += "_" + e, t += 1;
    } else {
      if (t !== 0) for (let d = 0; d < n.length; d++) n[d] += t;
      this._buffers[0].lineStarts = this._buffers[0].lineStarts.concat(n.slice(1)), this._buffers[0].buffer += e;
    }
    const o = this._buffers[0].buffer.length, r = this._buffers[0].lineStarts.length - 1, a = { line: r, column: o - this._buffers[0].lineStarts[r] }, l = new zs(0, s, a, this.getLineFeedCnt(0, s, a), o - t);
    return this._lastChangeBufferPos = a, [l];
  }
  getLineRawContent(e, t = 0) {
    let n = this.root, s = "";
    const o = this._searchCache.get2(e);
    if (o) {
      n = o.node;
      const r = this.getAccumulatedValue(n, e - o.nodeStartLineNumber - 1), a = this._buffers[n.piece.bufferIndex].buffer, l = this.offsetInBuffer(n.piece.bufferIndex, n.piece.start);
      if (o.nodeStartLineNumber + n.piece.lineFeedCnt !== e) {
        const d = this.getAccumulatedValue(n, e - o.nodeStartLineNumber);
        return a.substring(l + r, l + d - t);
      }
      s = a.substring(l + r, l + n.piece.length);
    } else {
      let r = 0;
      const a = e;
      for (; n !== ze; ) if (n.left !== ze && n.lf_left >= e - 1) n = n.left;
      else {
        if (n.lf_left + n.piece.lineFeedCnt > e - 1) {
          const l = this.getAccumulatedValue(n, e - n.lf_left - 2), d = this.getAccumulatedValue(n, e - n.lf_left - 1), h = this._buffers[n.piece.bufferIndex].buffer, c = this.offsetInBuffer(n.piece.bufferIndex, n.piece.start);
          return r += n.size_left, this._searchCache.set({ node: n, nodeStartOffset: r, nodeStartLineNumber: a - (e - 1 - n.lf_left) }), h.substring(c + l, c + d - t);
        }
        if (n.lf_left + n.piece.lineFeedCnt === e - 1) {
          const l = this.getAccumulatedValue(n, e - n.lf_left - 2), d = this._buffers[n.piece.bufferIndex].buffer, h = this.offsetInBuffer(n.piece.bufferIndex, n.piece.start);
          s = d.substring(h + l, h + n.piece.length);
          break;
        }
        e -= n.lf_left + n.piece.lineFeedCnt, r += n.size_left + n.piece.length, n = n.right;
      }
    }
    for (n = n.next(); n !== ze; ) {
      const r = this._buffers[n.piece.bufferIndex].buffer;
      if (n.piece.lineFeedCnt > 0) {
        const a = this.getAccumulatedValue(n, 0), l = this.offsetInBuffer(n.piece.bufferIndex, n.piece.start);
        return s += r.substring(l, l + a - t), s;
      }
      {
        const a = this.offsetInBuffer(n.piece.bufferIndex, n.piece.start);
        s += r.substr(a, n.piece.length);
      }
      n = n.next();
    }
    return s;
  }
  computeBufferMetadata() {
    let e = this.root, t = 1, n = 0;
    for (; e !== ze; ) t += e.lf_left + e.piece.lineFeedCnt, n += e.size_left + e.piece.length, e = e.right;
    this._lineCnt = t, this._length = n, this._searchCache.validate(this._length);
  }
  getIndexOf(e, t) {
    const n = e.piece, s = this.positionInBuffer(e, t), o = s.line - n.start.line;
    if (this.offsetInBuffer(n.bufferIndex, n.end) - this.offsetInBuffer(n.bufferIndex, n.start) === t) {
      const r = this.getLineFeedCnt(e.piece.bufferIndex, n.start, s);
      if (r !== o) return { index: r, remainder: 0 };
    }
    return { index: o, remainder: s.column };
  }
  getAccumulatedValue(e, t) {
    if (t < 0) return 0;
    const n = e.piece, s = this._buffers[n.bufferIndex].lineStarts, o = n.start.line + t + 1;
    return o > n.end.line ? s[n.end.line] + n.end.column - s[n.start.line] - n.start.column : s[o] - s[n.start.line] - n.start.column;
  }
  deleteNodeTail(e, t) {
    const n = e.piece, s = n.lineFeedCnt, o = this.offsetInBuffer(n.bufferIndex, n.end), r = t, a = this.offsetInBuffer(n.bufferIndex, r), l = this.getLineFeedCnt(n.bufferIndex, n.start, r), d = l - s, h = a - o, c = n.length + h;
    e.piece = new zs(n.bufferIndex, n.start, r, l, c), Ol(this, e, h, d);
  }
  deleteNodeHead(e, t) {
    const n = e.piece, s = n.lineFeedCnt, o = this.offsetInBuffer(n.bufferIndex, n.start), r = t, a = this.getLineFeedCnt(n.bufferIndex, r, n.end), l = a - s, d = o - this.offsetInBuffer(n.bufferIndex, r), h = n.length + d;
    e.piece = new zs(n.bufferIndex, r, n.end, a, h), Ol(this, e, d, l);
  }
  shrinkNode(e, t, n) {
    const s = e.piece, o = s.start, r = s.end, a = s.length, l = s.lineFeedCnt, d = t, h = this.getLineFeedCnt(s.bufferIndex, s.start, d), c = this.offsetInBuffer(s.bufferIndex, t) - this.offsetInBuffer(s.bufferIndex, o);
    e.piece = new zs(s.bufferIndex, s.start, d, h, c), Ol(this, e, c - a, h - l);
    const u = new zs(s.bufferIndex, n, r, this.getLineFeedCnt(s.bufferIndex, n, r), this.offsetInBuffer(s.bufferIndex, r) - this.offsetInBuffer(s.bufferIndex, n)), g = this.rbInsertRight(e, u);
    this.validateCRLFWithPrevNode(g);
  }
  appendToNode(e, t) {
    this.adjustCarriageReturnFromNext(t, e) && (t += `
`);
    const n = this.shouldCheckCRLF() && this.startWithLF(t) && this.endWithCR(e), s = this._buffers[0].buffer.length;
    this._buffers[0].buffer += t;
    const o = Wl(t, !1);
    for (let u = 0; u < o.length; u++) o[u] += s;
    if (n) {
      const u = this._buffers[0].lineStarts[this._buffers[0].lineStarts.length - 2];
      this._buffers[0].lineStarts.pop(), this._lastChangeBufferPos = { line: this._lastChangeBufferPos.line - 1, column: s - u };
    }
    this._buffers[0].lineStarts = this._buffers[0].lineStarts.concat(o.slice(1));
    const r = this._buffers[0].lineStarts.length - 1, a = { line: r, column: this._buffers[0].buffer.length - this._buffers[0].lineStarts[r] }, l = e.piece.length + t.length, d = e.piece.lineFeedCnt, h = this.getLineFeedCnt(0, e.piece.start, a), c = h - d;
    e.piece = new zs(e.piece.bufferIndex, e.piece.start, a, h, l), this._lastChangeBufferPos = a, Ol(this, e, t.length, c);
  }
  nodeAt(e) {
    let t = this.root;
    const n = this._searchCache.get(e);
    if (n) return { node: n.node, nodeStartOffset: n.nodeStartOffset, remainder: e - n.nodeStartOffset };
    let s = 0;
    for (; t !== ze; ) if (t.size_left > e) t = t.left;
    else {
      if (t.size_left + t.piece.length >= e) {
        s += t.size_left;
        const o = { node: t, remainder: e - t.size_left, nodeStartOffset: s };
        return this._searchCache.set(o), o;
      }
      e -= t.size_left + t.piece.length, s += t.size_left + t.piece.length, t = t.right;
    }
    return null;
  }
  nodeAt2(e, t) {
    let n = this.root, s = 0;
    for (; n !== ze; ) if (n.left !== ze && n.lf_left >= e - 1) n = n.left;
    else {
      if (n.lf_left + n.piece.lineFeedCnt > e - 1) {
        const o = this.getAccumulatedValue(n, e - n.lf_left - 2), r = this.getAccumulatedValue(n, e - n.lf_left - 1);
        return s += n.size_left, { node: n, remainder: Math.min(o + t - 1, r), nodeStartOffset: s };
      }
      if (n.lf_left + n.piece.lineFeedCnt === e - 1) {
        const o = this.getAccumulatedValue(n, e - n.lf_left - 2);
        if (o + t - 1 <= n.piece.length) return { node: n, remainder: o + t - 1, nodeStartOffset: s };
        t -= n.piece.length - o;
        break;
      }
      e -= n.lf_left + n.piece.lineFeedCnt, s += n.size_left + n.piece.length, n = n.right;
    }
    for (n = n.next(); n !== ze; ) {
      if (n.piece.lineFeedCnt > 0) {
        const o = this.getAccumulatedValue(n, 0), r = this.offsetOfNode(n);
        return { node: n, remainder: Math.min(t - 1, o), nodeStartOffset: r };
      }
      if (n.piece.length >= t - 1)
        return { node: n, remainder: t - 1, nodeStartOffset: this.offsetOfNode(n) };
      t -= n.piece.length, n = n.next();
    }
    return null;
  }
  nodeCharCodeAt(e, t) {
    if (e.piece.lineFeedCnt < 1) return -1;
    const n = this._buffers[e.piece.bufferIndex], s = this.offsetInBuffer(e.piece.bufferIndex, e.piece.start) + t;
    return n.buffer.charCodeAt(s);
  }
  offsetOfNode(e) {
    if (!e) return 0;
    let t = e.size_left;
    for (; e !== this.root; ) e.parent.right === e && (t += e.parent.size_left + e.parent.piece.length), e = e.parent;
    return t;
  }
  shouldCheckCRLF() {
    return !(this._EOLNormalized && this._EOL === `
`);
  }
  startWithLF(e) {
    if (typeof e == "string") return e.charCodeAt(0) === 10;
    if (e === ze || e.piece.lineFeedCnt === 0) return !1;
    const t = e.piece, n = this._buffers[t.bufferIndex].lineStarts, s = t.start.line, o = n[s] + t.start.column;
    return s === n.length - 1 ? !1 : !(n[s + 1] > o + 1) && this._buffers[t.bufferIndex].buffer.charCodeAt(o) === 10;
  }
  endWithCR(e) {
    return typeof e == "string" ? e.charCodeAt(e.length - 1) === 13 : e !== ze && e.piece.lineFeedCnt !== 0 && this.nodeCharCodeAt(e, e.piece.length - 1) === 13;
  }
  validateCRLFWithPrevNode(e) {
    if (this.shouldCheckCRLF() && this.startWithLF(e)) {
      const t = e.prev();
      this.endWithCR(t) && this.fixCRLF(t, e);
    }
  }
  validateCRLFWithNextNode(e) {
    if (this.shouldCheckCRLF() && this.endWithCR(e)) {
      const t = e.next();
      this.startWithLF(t) && this.fixCRLF(e, t);
    }
  }
  fixCRLF(e, t) {
    const n = [], s = this._buffers[e.piece.bufferIndex].lineStarts;
    let o;
    o = e.piece.end.column === 0 ? { line: e.piece.end.line - 1, column: s[e.piece.end.line] - s[e.piece.end.line - 1] - 1 } : { line: e.piece.end.line, column: e.piece.end.column - 1 };
    const r = e.piece.length - 1, a = e.piece.lineFeedCnt - 1;
    e.piece = new zs(e.piece.bufferIndex, e.piece.start, o, a, r), Ol(this, e, -1, -1), e.piece.length === 0 && n.push(e);
    const l = { line: t.piece.start.line + 1, column: 0 }, d = t.piece.length - 1, h = this.getLineFeedCnt(t.piece.bufferIndex, l, t.piece.end);
    t.piece = new zs(t.piece.bufferIndex, l, t.piece.end, h, d), Ol(this, t, -1, -1), t.piece.length === 0 && n.push(t);
    const c = this.createNewPieces(`\r
`);
    this.rbInsertRight(e, c[0]);
    for (let u = 0; u < n.length; u++) Sb(this, n[u]);
  }
  adjustCarriageReturnFromNext(e, t) {
    if (this.shouldCheckCRLF() && this.endWithCR(e)) {
      const n = t.next();
      if (this.startWithLF(n)) {
        if (e += `
`, n.piece.length === 1) Sb(this, n);
        else {
          const s = n.piece, o = { line: s.start.line + 1, column: 0 }, r = s.length - 1, a = this.getLineFeedCnt(s.bufferIndex, o, s.end);
          n.piece = new zs(s.bufferIndex, o, s.end, a, r), Ol(this, n, -1, -1);
        }
        return !0;
      }
    }
    return !1;
  }
  iterate(e, t) {
    if (e === ze) return t(ze);
    const n = this.iterate(e.left, t);
    return n && t(e) && this.iterate(e.right, t);
  }
  getNodeContent(e) {
    if (e === ze) return "";
    const t = this._buffers[e.piece.bufferIndex], n = e.piece, s = this.offsetInBuffer(n.bufferIndex, n.start), o = this.offsetInBuffer(n.bufferIndex, n.end);
    return t.buffer.substring(s, o);
  }
  getPieceContent(e) {
    const t = this._buffers[e.bufferIndex], n = this.offsetInBuffer(e.bufferIndex, e.start), s = this.offsetInBuffer(e.bufferIndex, e.end);
    return t.buffer.substring(n, s);
  }
  rbInsertRight(e, t) {
    const n = new pI(t, 1);
    if (n.left = ze, n.right = ze, n.parent = ze, n.size_left = 0, n.lf_left = 0, this.root === ze) this.root = n, n.color = 0;
    else if (e.right === ze) e.right = n, n.parent = e;
    else {
      const s = eA(e.right);
      s.left = n, n.parent = s;
    }
    return R5(this, n), n;
  }
  rbInsertLeft(e, t) {
    const n = new pI(t, 1);
    if (n.left = ze, n.right = ze, n.parent = ze, n.size_left = 0, n.lf_left = 0, this.root === ze) this.root = n, n.color = 0;
    else if (e.left === ze) e.left = n, n.parent = e;
    else {
      const s = aW(e.left);
      s.right = n, n.parent = s;
    }
    return R5(this, n), n;
  }
}
class um extends V {
  constructor(e, t, n, s, o, r, a) {
    super(), this._onDidChangeContent = this._register(new F()), this._BOM = t, this._mightContainNonBasicASCII = !r, this._mightContainRTL = s, this._mightContainUnusualLineTerminators = o, this._pieceTree = new OX(e, n, a);
  }
  mightContainRTL() {
    return this._mightContainRTL;
  }
  mightContainUnusualLineTerminators() {
    return this._mightContainUnusualLineTerminators;
  }
  resetMightContainUnusualLineTerminators() {
    this._mightContainUnusualLineTerminators = !1;
  }
  mightContainNonBasicASCII() {
    return this._mightContainNonBasicASCII;
  }
  getBOM() {
    return this._BOM;
  }
  getEOL() {
    return this._pieceTree.getEOL();
  }
  createSnapshot(e) {
    return this._pieceTree.createSnapshot(e ? this._BOM : "");
  }
  getOffsetAt(e, t) {
    return this._pieceTree.getOffsetAt(e, t);
  }
  getPositionAt(e) {
    return this._pieceTree.getPositionAt(e);
  }
  getRangeAt(e, t) {
    const n = e + t, s = this.getPositionAt(e), o = this.getPositionAt(n);
    return new D(s.lineNumber, s.column, o.lineNumber, o.column);
  }
  getValueInRange(e, t = 0) {
    if (e.isEmpty()) return "";
    const n = this._getEndOfLine(t);
    return this._pieceTree.getValueInRange(e, n);
  }
  getValueLengthInRange(e, t = 0) {
    if (e.isEmpty()) return 0;
    if (e.startLineNumber === e.endLineNumber) return e.endColumn - e.startColumn;
    const n = this.getOffsetAt(e.startLineNumber, e.startColumn), s = this.getOffsetAt(e.endLineNumber, e.endColumn);
    let o = 0;
    const r = this._getEndOfLine(t), a = this.getEOL();
    return r.length !== a.length && (o = (r.length - a.length) * (e.endLineNumber - e.startLineNumber)), s - n + o;
  }
  getCharacterCountInRange(e, t = 0) {
    if (this._mightContainNonBasicASCII) {
      let n = 0;
      const s = e.startLineNumber, o = e.endLineNumber;
      for (let r = s; r <= o; r++) {
        const a = this.getLineContent(r), l = r === s ? e.startColumn - 1 : 0, d = r === o ? e.endColumn - 1 : a.length;
        for (let h = l; h < d; h++) en(a.charCodeAt(h)) ? (n += 1, h += 1) : n += 1;
      }
      return n += this._getEndOfLine(t).length * (o - s), n;
    }
    return this.getValueLengthInRange(e, t);
  }
  getLength() {
    return this._pieceTree.getLength();
  }
  getLineCount() {
    return this._pieceTree.getLineCount();
  }
  getLinesContent() {
    return this._pieceTree.getLinesContent();
  }
  getLineContent(e) {
    return this._pieceTree.getLineContent(e);
  }
  getLineCharCode(e, t) {
    return this._pieceTree.getLineCharCode(e, t);
  }
  getLineLength(e) {
    return this._pieceTree.getLineLength(e);
  }
  getLineFirstNonWhitespaceColumn(e) {
    const t = Jn(this.getLineContent(e));
    return t === -1 ? 0 : t + 1;
  }
  getLineLastNonWhitespaceColumn(e) {
    const t = ra(this.getLineContent(e));
    return t === -1 ? 0 : t + 2;
  }
  _getEndOfLine(e) {
    switch (e) {
      case 1:
        return `
`;
      case 2:
        return `\r
`;
      case 0:
        return this.getEOL();
      default:
        throw new Error("Unknown EOL preference");
    }
  }
  setEOL(e) {
    this._pieceTree.setEOL(e);
  }
  applyEdits(e, t, n) {
    let s = this._mightContainRTL, o = this._mightContainUnusualLineTerminators, r = this._mightContainNonBasicASCII, a = !0, l = [];
    for (let f = 0; f < e.length; f++) {
      const _ = e[f];
      a && _._isTracked && (a = !1);
      const v = _.range;
      if (_.text) {
        let L = !0;
        r || (L = !f1(_.text), r = L), !s && L && (s = Fm(_.text)), !o && L && (o = i8(_.text));
      }
      let b = "", C = 0, w = 0, y = 0;
      if (_.text) {
        let L;
        [C, w, y, L] = Dc(_.text);
        const k = this.getEOL();
        b = L === 0 || L === (k === `\r
` ? 2 : 1) ? _.text : _.text.replace(/\r\n|\r|\n/g, k);
      }
      l[f] = { sortIndex: f, identifier: _.identifier || null, range: v, rangeOffset: this.getOffsetAt(v.startLineNumber, v.startColumn), rangeLength: this.getValueLengthInRange(v), text: b, eolCount: C, firstLineLength: w, lastLineLength: y, forceMoveMarkers: !!_.forceMoveMarkers, isAutoWhitespaceEdit: _.isAutoWhitespaceEdit || !1 };
    }
    l.sort(um._sortOpsAscending);
    let d = !1;
    for (let f = 0, _ = l.length - 1; f < _; f++) {
      const v = l[f].range.getEndPosition(), b = l[f + 1].range.getStartPosition();
      if (b.isBeforeOrEqual(v)) {
        if (b.isBefore(v)) throw new Error("Overlapping ranges are not allowed!");
        d = !0;
      }
    }
    a && (l = this._reduceOperations(l));
    const h = n || t ? um._getInverseEditRanges(l) : [], c = [];
    if (t) for (let f = 0; f < l.length; f++) {
      const _ = l[f], v = h[f];
      if (_.isAutoWhitespaceEdit && _.range.isEmpty()) for (let b = v.startLineNumber; b <= v.endLineNumber; b++) {
        let C = "";
        b === v.startLineNumber && (C = this.getLineContent(_.range.startLineNumber), Jn(C) !== -1) || c.push({ lineNumber: b, oldContent: C });
      }
    }
    let u = null;
    if (n) {
      let f = 0;
      u = [];
      for (let _ = 0; _ < l.length; _++) {
        const v = l[_], b = h[_], C = this.getValueInRange(v.range), w = v.rangeOffset + f;
        f += v.text.length - C.length, u[_] = { sortIndex: v.sortIndex, identifier: v.identifier, range: b, text: C, textChange: new xn(v.rangeOffset, C, w, v.text) };
      }
      d || u.sort((_, v) => _.sortIndex - v.sortIndex);
    }
    this._mightContainRTL = s, this._mightContainUnusualLineTerminators = o, this._mightContainNonBasicASCII = r;
    const g = this._doApplyEdits(l);
    let p = null;
    if (t && c.length > 0) {
      c.sort((f, _) => _.lineNumber - f.lineNumber), p = [];
      for (let f = 0, _ = c.length; f < _; f++) {
        const v = c[f].lineNumber;
        if (f > 0 && c[f - 1].lineNumber === v) continue;
        const b = c[f].oldContent, C = this.getLineContent(v);
        C.length !== 0 && C !== b && Jn(C) === -1 && p.push(v);
      }
    }
    return this._onDidChangeContent.fire(), new Sq(u, g, p);
  }
  _reduceOperations(e) {
    return e.length < 1e3 ? e : [this._toSingleEditOperation(e)];
  }
  _toSingleEditOperation(e) {
    let t = !1;
    const n = e[0].range, s = e[e.length - 1].range, o = new D(n.startLineNumber, n.startColumn, s.endLineNumber, s.endColumn);
    let r = n.startLineNumber, a = n.startColumn;
    const l = [];
    for (let g = 0, p = e.length; g < p; g++) {
      const f = e[g], _ = f.range;
      t = t || f.forceMoveMarkers, l.push(this.getValueInRange(new D(r, a, _.startLineNumber, _.startColumn))), f.text.length > 0 && l.push(f.text), r = _.endLineNumber, a = _.endColumn;
    }
    const d = l.join(""), [h, c, u] = Dc(d);
    return { sortIndex: 0, identifier: e[0].identifier, range: o, rangeOffset: this.getOffsetAt(o.startLineNumber, o.startColumn), rangeLength: this.getValueLengthInRange(o, 0), text: d, eolCount: h, firstLineLength: c, lastLineLength: u, forceMoveMarkers: t, isAutoWhitespaceEdit: !1 };
  }
  _doApplyEdits(e) {
    e.sort(um._sortOpsDescending);
    const t = [];
    for (let n = 0; n < e.length; n++) {
      const s = e[n], o = s.range.startLineNumber, r = s.range.startColumn, a = s.range.endLineNumber, l = s.range.endColumn;
      if (o === a && r === l && s.text.length === 0) continue;
      s.text ? (this._pieceTree.delete(s.rangeOffset, s.rangeLength), this._pieceTree.insert(s.rangeOffset, s.text, !0)) : this._pieceTree.delete(s.rangeOffset, s.rangeLength);
      const d = new D(o, r, a, l);
      t.push({ range: d, rangeLength: s.rangeLength, text: s.text, rangeOffset: s.rangeOffset, forceMoveMarkers: s.forceMoveMarkers });
    }
    return t;
  }
  findMatchesLineByLine(e, t, n, s) {
    return this._pieceTree.findMatchesLineByLine(e, t, n, s);
  }
  static _getInverseEditRanges(e) {
    const t = [];
    let n = 0, s = 0, o = null;
    for (let r = 0, a = e.length; r < a; r++) {
      const l = e[r];
      let d, h, c;
      if (o ? o.range.endLineNumber === l.range.startLineNumber ? (d = n, h = s + (l.range.startColumn - o.range.endColumn)) : (d = n + (l.range.startLineNumber - o.range.endLineNumber), h = l.range.startColumn) : (d = l.range.startLineNumber, h = l.range.startColumn), l.text.length > 0) {
        const u = l.eolCount + 1;
        c = u === 1 ? new D(d, h, d, h + l.firstLineLength) : new D(d, h, d + u - 1, l.lastLineLength + 1);
      } else c = new D(d, h, d, h);
      n = c.endLineNumber, s = c.endColumn, t.push(c), o = l;
    }
    return t;
  }
  static _sortOpsAscending(e, t) {
    const n = D.compareRangesUsingEnds(e.range, t.range);
    return n === 0 ? e.sortIndex - t.sortIndex : n;
  }
  static _sortOpsDescending(e, t) {
    const n = D.compareRangesUsingEnds(e.range, t.range);
    return n === 0 ? t.sortIndex - e.sortIndex : -n;
  }
}
class FX {
  constructor(e, t, n, s, o, r, a, l, d) {
    this._chunks = e, this._bom = t, this._cr = n, this._lf = s, this._crlf = o, this._containsRTL = r, this._containsUnusualLineTerminators = a, this._isBasicASCII = l, this._normalizeEOL = d;
  }
  _getEOL(e) {
    const t = this._cr + this._lf + this._crlf, n = this._cr + this._crlf;
    return t === 0 ? e === 1 ? `
` : `\r
` : n > t / 2 ? `\r
` : `
`;
  }
  create(e) {
    const t = this._getEOL(e), n = this._chunks;
    if (this._normalizeEOL && (t === `\r
` && (this._cr > 0 || this._lf > 0) || t === `
` && (this._cr > 0 || this._crlf > 0))) for (let o = 0, r = n.length; o < r; o++) {
      const a = n[o].buffer.replace(/\r\n|\r|\n/g, t), l = Wl(a);
      n[o] = new yu(a, l);
    }
    const s = new um(n, this._bom, t, this._containsRTL, this._containsUnusualLineTerminators, this._isBasicASCII, this._normalizeEOL);
    return { textBuffer: s, disposable: s };
  }
}
class A5 {
  constructor() {
    this.chunks = [], this.BOM = "", this._hasPreviousChar = !1, this._previousChar = 0, this._tmpLineStarts = [], this.cr = 0, this.lf = 0, this.crlf = 0, this.containsRTL = !1, this.containsUnusualLineTerminators = !1, this.isBasicASCII = !0;
  }
  acceptChunk(e) {
    if (e.length === 0) return;
    this.chunks.length === 0 && dR(e) && (this.BOM = EK, e = e.substr(1));
    const t = e.charCodeAt(e.length - 1);
    t === 13 || t >= 55296 && t <= 56319 ? (this._acceptChunk1(e.substr(0, e.length - 1), !1), this._hasPreviousChar = !0, this._previousChar = t) : (this._acceptChunk1(e, !1), this._hasPreviousChar = !1, this._previousChar = t);
  }
  _acceptChunk1(e, t) {
    (t || e.length !== 0) && (this._hasPreviousChar ? this._acceptChunk2(String.fromCharCode(this._previousChar) + e) : this._acceptChunk2(e));
  }
  _acceptChunk2(e) {
    const t = function(n, s) {
      n.length = 0, n[0] = 0;
      let o = 1, r = 0, a = 0, l = 0, d = !0;
      for (let c = 0, u = s.length; c < u; c++) {
        const g = s.charCodeAt(c);
        g === 13 ? c + 1 < u && s.charCodeAt(c + 1) === 10 ? (l++, n[o++] = c + 2, c++) : (r++, n[o++] = c + 1) : g === 10 ? (a++, n[o++] = c + 1) : d && g !== 9 && (g < 32 || g > 126) && (d = !1);
      }
      const h = new RX(lW(n), r, a, l, d);
      return n.length = 0, h;
    }(this._tmpLineStarts, e);
    this.chunks.push(new yu(e, t.lineStarts)), this.cr += t.cr, this.lf += t.lf, this.crlf += t.crlf, t.isBasicASCII || (this.isBasicASCII = !1, this.containsRTL || (this.containsRTL = Fm(e)), this.containsUnusualLineTerminators || (this.containsUnusualLineTerminators = i8(e)));
  }
  finish(e = !0) {
    return this._finish(), new FX(this.chunks, this.BOM, this.cr, this.lf, this.crlf, this.containsRTL, this.containsUnusualLineTerminators, this.isBasicASCII, e);
  }
  _finish() {
    if (this.chunks.length === 0 && this._acceptChunk1("", !0), this._hasPreviousChar) {
      this._hasPreviousChar = !1;
      const e = this.chunks[this.chunks.length - 1];
      e.buffer += String.fromCharCode(this._previousChar);
      const t = Wl(e.buffer);
      e.lineStarts = t, this._previousChar === 13 && this.cr++;
    }
  }
}
class BX {
  constructor(e) {
    this._default = e, this._store = [];
  }
  get(e) {
    return e < this._store.length ? this._store[e] : this._default;
  }
  set(e, t) {
    for (; e >= this._store.length; ) this._store[this._store.length] = this._default;
    this._store[e] = t;
  }
  replace(e, t, n) {
    if (e >= this._store.length) return;
    if (t === 0) return void this.insert(e, n);
    if (n === 0) return void this.delete(e, t);
    const s = this._store.slice(0, e), o = this._store.slice(e + t), r = function(a, l) {
      const d = [];
      for (let h = 0; h < a; h++) d[h] = l;
      return d;
    }(n, this._default);
    this._store = s.concat(r, o);
  }
  delete(e, t) {
    t === 0 || e >= this._store.length || this._store.splice(e, t);
  }
  insert(e, t) {
    if (t === 0 || e >= this._store.length) return;
    const n = [];
    for (let s = 0; s < t; s++) n[s] = this._default;
    this._store = PS(this._store, e, n);
  }
}
class WX {
  get startLineNumber() {
    return this._startLineNumber;
  }
  get endLineNumber() {
    return this._startLineNumber + this._tokens.length - 1;
  }
  constructor(e, t) {
    this._startLineNumber = e, this._tokens = t;
  }
  getLineTokens(e) {
    return this._tokens[e - this._startLineNumber];
  }
  appendLineTokens(e) {
    this._tokens.push(e);
  }
}
class mI {
  constructor() {
    this._tokens = [];
  }
  add(e, t) {
    if (this._tokens.length > 0) {
      const n = this._tokens[this._tokens.length - 1];
      if (n.endLineNumber + 1 === e) return void n.appendLineTokens(t);
    }
    this._tokens.push(new WX(e, [t]));
  }
  finalize() {
    return this._tokens;
  }
}
class VX {
  constructor(e, t) {
    this.tokenizationSupport = t, this.initialState = this.tokenizationSupport.getInitialState(), this.store = new fI(e);
  }
  getStartState(e) {
    return this.store.getStartState(e, this.initialState);
  }
  getFirstInvalidLine() {
    return this.store.getFirstInvalidLine(this.initialState);
  }
}
class HX extends VX {
  constructor(e, t, n, s) {
    super(e, t), this._textModel = n, this._languageIdCodec = s;
  }
  updateTokensUntilLine(e, t) {
    const n = this._textModel.getLanguageId();
    for (; ; ) {
      const s = this.getFirstInvalidLine();
      if (!s || s.lineNumber > t) break;
      const o = this._textModel.getLineContent(s.lineNumber), r = Hf(this._languageIdCodec, n, this.tokenizationSupport, o, !0, s.startState);
      e.add(s.lineNumber, r.tokens), this.store.setEndState(s.lineNumber, r.endState);
    }
  }
  getTokenTypeIfInsertingCharacter(e, t) {
    const n = this.getStartState(e.lineNumber);
    if (!n) return 0;
    const s = this._textModel.getLanguageId(), o = this._textModel.getLineContent(e.lineNumber), r = o.substring(0, e.column - 1) + t + o.substring(e.column - 1), a = Hf(this._languageIdCodec, s, this.tokenizationSupport, r, !0, n), l = new nn(a.tokens, r, this._languageIdCodec);
    if (l.getCount() === 0) return 0;
    const d = l.findTokenIndexAtOffset(e.column - 1);
    return l.getStandardTokenType(d);
  }
  tokenizeLineWithEdit(e, t, n) {
    const s = e.lineNumber, o = e.column, r = this.getStartState(s);
    if (!r) return null;
    const a = this._textModel.getLineContent(s), l = a.substring(0, o - 1) + n + a.substring(o - 1 + t), d = this._textModel.getLanguageIdAtPosition(s, 0), h = Hf(this._languageIdCodec, d, this.tokenizationSupport, l, !0, r);
    return new nn(h.tokens, l, this._languageIdCodec);
  }
  hasAccurateTokensForLine(e) {
    return e < this.store.getFirstInvalidEndStateLineNumberOrMax();
  }
  isCheapToTokenize(e) {
    const t = this.store.getFirstInvalidEndStateLineNumberOrMax();
    return e < t || e === t && this._textModel.getLineLength(e) < 2048;
  }
  tokenizeHeuristically(e, t, n) {
    if (n <= this.store.getFirstInvalidEndStateLineNumberOrMax()) return { heuristicTokens: !1 };
    if (t <= this.store.getFirstInvalidEndStateLineNumberOrMax()) return this.updateTokensUntilLine(e, n), { heuristicTokens: !1 };
    let s = this.guessStartState(t);
    const o = this._textModel.getLanguageId();
    for (let r = t; r <= n; r++) {
      const a = this._textModel.getLineContent(r), l = Hf(this._languageIdCodec, o, this.tokenizationSupport, a, !0, s);
      e.add(r, l.tokens), s = l.endState;
    }
    return { heuristicTokens: !0 };
  }
  guessStartState(e) {
    let t = this._textModel.getLineFirstNonWhitespaceColumn(e);
    const n = [];
    let s = null;
    for (let a = e - 1; t > 1 && a >= 1; a--) {
      const l = this._textModel.getLineFirstNonWhitespaceColumn(a);
      if (l !== 0 && l < t && (n.push(this._textModel.getLineContent(a)), t = l, s = this.getStartState(a), s)) break;
    }
    s || (s = this.tokenizationSupport.getInitialState()), n.reverse();
    const o = this._textModel.getLanguageId();
    let r = s;
    for (const a of n)
      r = Hf(this._languageIdCodec, o, this.tokenizationSupport, a, !1, r).endState;
    return r;
  }
}
class fI {
  constructor(e) {
    this.lineCount = e, this._tokenizationStateStore = new zX(), this._invalidEndStatesLineNumbers = new UX(), this._invalidEndStatesLineNumbers.addRange(new qe(1, e + 1));
  }
  getEndState(e) {
    return this._tokenizationStateStore.getEndState(e);
  }
  setEndState(e, t) {
    if (!t) throw new Kt("Cannot set null/undefined state");
    this._invalidEndStatesLineNumbers.delete(e);
    const n = this._tokenizationStateStore.setEndState(e, t);
    return n && e < this.lineCount && this._invalidEndStatesLineNumbers.addRange(new qe(e + 1, e + 2)), n;
  }
  acceptChange(e, t) {
    this.lineCount += t - e.length, this._tokenizationStateStore.acceptChange(e, t), this._invalidEndStatesLineNumbers.addRangeAndResize(new qe(e.startLineNumber, e.endLineNumberExclusive), t);
  }
  acceptChanges(e) {
    for (const t of e) {
      const [n] = Dc(t.text);
      this.acceptChange(new je(t.range.startLineNumber, t.range.endLineNumber + 1), n + 1);
    }
  }
  invalidateEndStateRange(e) {
    this._invalidEndStatesLineNumbers.addRange(new qe(e.startLineNumber, e.endLineNumberExclusive));
  }
  getFirstInvalidEndStateLineNumber() {
    return this._invalidEndStatesLineNumbers.min;
  }
  getFirstInvalidEndStateLineNumberOrMax() {
    return this.getFirstInvalidEndStateLineNumber() || Number.MAX_SAFE_INTEGER;
  }
  allStatesValid() {
    return this._invalidEndStatesLineNumbers.min === null;
  }
  getStartState(e, t) {
    return e === 1 ? t : this.getEndState(e - 1);
  }
  getFirstInvalidLine(e) {
    const t = this.getFirstInvalidEndStateLineNumber();
    if (t === null) return null;
    const n = this.getStartState(t, e);
    if (!n) throw new Kt("Start state must be defined");
    return { lineNumber: t, startState: n };
  }
}
class zX {
  constructor() {
    this._lineEndStates = new BX(null);
  }
  getEndState(e) {
    return this._lineEndStates.get(e);
  }
  setEndState(e, t) {
    const n = this._lineEndStates.get(e);
    return (!n || !n.equals(t)) && (this._lineEndStates.set(e, t), !0);
  }
  acceptChange(e, t) {
    let n = e.length;
    t > 0 && n > 0 && (n--, t--), this._lineEndStates.replace(e.startLineNumber, n, t);
  }
}
class UX {
  constructor() {
    this._ranges = [];
  }
  get min() {
    return this._ranges.length === 0 ? null : this._ranges[0].start;
  }
  delete(e) {
    const t = this._ranges.findIndex((n) => n.contains(e));
    if (t !== -1) {
      const n = this._ranges[t];
      n.start === e ? n.endExclusive === e + 1 ? this._ranges.splice(t, 1) : this._ranges[t] = new qe(e + 1, n.endExclusive) : n.endExclusive === e + 1 ? this._ranges[t] = new qe(n.start, e) : this._ranges.splice(t, 1, new qe(n.start, e), new qe(e + 1, n.endExclusive));
    }
  }
  addRange(e) {
    qe.addRange(e, this._ranges);
  }
  addRangeAndResize(e, t) {
    let n = 0;
    for (; !(n >= this._ranges.length || e.start <= this._ranges[n].endExclusive); ) n++;
    let s = n;
    for (; !(s >= this._ranges.length || e.endExclusive < this._ranges[s].start); ) s++;
    const o = t - e.length;
    for (let r = s; r < this._ranges.length; r++) this._ranges[r] = this._ranges[r].delta(o);
    if (n === s) {
      const r = new qe(e.start, e.start + t);
      r.isEmpty || this._ranges.splice(n, 0, r);
    } else {
      const r = Math.min(e.start, this._ranges[n].start), a = Math.max(e.endExclusive, this._ranges[s - 1].endExclusive), l = new qe(r, a + o);
      l.isEmpty ? this._ranges.splice(n, s - n) : this._ranges.splice(n, s - n, l);
    }
  }
  toString() {
    return this._ranges.map((e) => e.toString()).join(" + ");
  }
}
function Hf(i, e, t, n, s, o) {
  let r = null;
  if (t) try {
    r = t.tokenizeEncoded(n, s, o.clone());
  } catch (a) {
    We(a);
  }
  return r || (r = sL(i.encodeLanguageId(e), o)), nn.convertToEndOffset(r.tokens, n.length), r;
}
class KX {
  constructor(e, t) {
    this._tokenizerWithStateStore = e, this._backgroundTokenStore = t, this._isDisposed = !1, this._isScheduled = !1;
  }
  dispose() {
    this._isDisposed = !0;
  }
  handleChanges() {
    this._beginBackgroundTokenization();
  }
  _beginBackgroundTokenization() {
    !this._isScheduled && this._tokenizerWithStateStore._textModel.isAttachedToEditor() && this._hasLinesToTokenize() && (this._isScheduled = !0, l8((e) => {
      this._isScheduled = !1, this._backgroundTokenizeWithDeadline(e);
    }));
  }
  _backgroundTokenizeWithDeadline(e) {
    const t = Date.now() + e.timeRemaining(), n = () => {
      !this._isDisposed && this._tokenizerWithStateStore._textModel.isAttachedToEditor() && this._hasLinesToTokenize() && (this._backgroundTokenizeForAtLeast1ms(), Date.now() < t ? L7(n) : this._beginBackgroundTokenization());
    };
    n();
  }
  _backgroundTokenizeForAtLeast1ms() {
    const e = this._tokenizerWithStateStore._textModel.getLineCount(), t = new mI(), n = Rn.create(!1);
    do
      if (n.elapsed() > 1 || this._tokenizeOneInvalidLine(t) >= e) break;
    while (this._hasLinesToTokenize());
    this._backgroundTokenStore.setTokens(t.finalize()), this.checkFinished();
  }
  _hasLinesToTokenize() {
    return !!this._tokenizerWithStateStore && !this._tokenizerWithStateStore.store.allStatesValid();
  }
  _tokenizeOneInvalidLine(e) {
    var t;
    const n = (t = this._tokenizerWithStateStore) === null || t === void 0 ? void 0 : t.getFirstInvalidLine();
    return n ? (this._tokenizerWithStateStore.updateTokensUntilLine(e, n.lineNumber), n.lineNumber) : this._tokenizerWithStateStore._textModel.getLineCount() + 1;
  }
  checkFinished() {
    this._isDisposed || this._tokenizerWithStateStore.store.allStatesValid() && this._backgroundTokenStore.backgroundTokenizationFinished();
  }
  requestTokens(e, t) {
    this._tokenizerWithStateStore.store.invalidateEndStateRange(new je(e, t));
  }
}
const Vl = new Uint32Array(0).buffer;
class Pa {
  static deleteBeginning(e, t) {
    return e === null || e === Vl ? e : Pa.delete(e, 0, t);
  }
  static deleteEnding(e, t) {
    if (e === null || e === Vl) return e;
    const n = ed(e), s = n[n.length - 2];
    return Pa.delete(e, t, s);
  }
  static delete(e, t, n) {
    if (e === null || e === Vl || t === n) return e;
    const s = ed(e), o = s.length >>> 1;
    if (t === 0 && s[s.length - 2] === n) return Vl;
    const r = nn.findIndexInTokensArray(s, t), a = r > 0 ? s[r - 1 << 1] : 0;
    if (n < s[r << 1]) {
      const u = n - t;
      for (let g = r; g < o; g++) s[g << 1] -= u;
      return e;
    }
    let l, d;
    a !== t ? (s[r << 1] = t, l = r + 1 << 1, d = t) : (l = r << 1, d = a);
    const h = n - t;
    for (let u = r + 1; u < o; u++) {
      const g = s[u << 1] - h;
      g > d && (s[l++] = g, s[l++] = s[1 + (u << 1)], d = g);
    }
    if (l === s.length) return e;
    const c = new Uint32Array(l);
    return c.set(s.subarray(0, l), 0), c.buffer;
  }
  static append(e, t) {
    if (t === Vl) return e;
    if (e === Vl) return t;
    if (e === null) return e;
    if (t === null) return null;
    const n = ed(e), s = ed(t), o = s.length >>> 1, r = new Uint32Array(n.length + s.length);
    r.set(n, 0);
    let a = n.length;
    const l = n[n.length - 2];
    for (let d = 0; d < o; d++) r[a++] = s[d << 1] + l, r[a++] = s[1 + (d << 1)];
    return r.buffer;
  }
  static insert(e, t, n) {
    if (e === null || e === Vl) return e;
    const s = ed(e), o = s.length >>> 1;
    let r = nn.findIndexInTokensArray(s, t);
    r > 0 && s[r - 1 << 1] === t && r--;
    for (let a = r; a < o; a++) s[a << 1] += n;
    return e;
  }
}
function ed(i) {
  return i instanceof Uint32Array ? i : new Uint32Array(i);
}
class Lv {
  constructor(e) {
    this._lineTokens = [], this._len = 0, this._languageIdCodec = e;
  }
  flush() {
    this._lineTokens = [], this._len = 0;
  }
  get hasTokens() {
    return this._lineTokens.length > 0;
  }
  getTokens(e, t, n) {
    let s = null;
    if (t < this._len && (s = this._lineTokens[t]), s !== null && s !== Vl) return new nn(ed(s), n, this._languageIdCodec);
    const o = new Uint32Array(2);
    return o[0] = n.length, o[1] = P5(this._languageIdCodec.encodeLanguageId(e)), new nn(o, n, this._languageIdCodec);
  }
  static _massageTokens(e, t, n) {
    const s = n ? ed(n) : null;
    if (t === 0) {
      let o = !1;
      if (s && s.length > 1 && (o = In.getLanguageId(s[1]) !== e), !o) return Vl;
    }
    if (!s || s.length === 0) {
      const o = new Uint32Array(2);
      return o[0] = t, o[1] = P5(e), o.buffer;
    }
    return s[s.length - 2] = t, s.byteOffset === 0 && s.byteLength === s.buffer.byteLength ? s.buffer : s;
  }
  _ensureLine(e) {
    for (; e >= this._len; ) this._lineTokens[this._len] = null, this._len++;
  }
  _deleteLines(e, t) {
    t !== 0 && (e + t > this._len && (t = this._len - e), this._lineTokens.splice(e, t), this._len -= t);
  }
  _insertLines(e, t) {
    if (t === 0) return;
    const n = [];
    for (let s = 0; s < t; s++) n[s] = null;
    this._lineTokens = PS(this._lineTokens, e, n), this._len += t;
  }
  setTokens(e, t, n, s, o) {
    const r = Lv._massageTokens(this._languageIdCodec.encodeLanguageId(e), n, s);
    this._ensureLine(t);
    const a = this._lineTokens[t];
    return this._lineTokens[t] = r, !!o && !Lv._equals(a, r);
  }
  static _equals(e, t) {
    if (!e || !t) return !e && !t;
    const n = ed(e), s = ed(t);
    if (n.length !== s.length) return !1;
    for (let o = 0, r = n.length; o < r; o++) if (n[o] !== s[o]) return !1;
    return !0;
  }
  acceptEdit(e, t, n) {
    this._acceptDeleteRange(e), this._acceptInsertText(new W(e.startLineNumber, e.startColumn), t, n);
  }
  _acceptDeleteRange(e) {
    const t = e.startLineNumber - 1;
    if (t >= this._len) return;
    if (e.startLineNumber === e.endLineNumber)
      return e.startColumn === e.endColumn ? void 0 : void (this._lineTokens[t] = Pa.delete(this._lineTokens[t], e.startColumn - 1, e.endColumn - 1));
    this._lineTokens[t] = Pa.deleteEnding(this._lineTokens[t], e.startColumn - 1);
    const n = e.endLineNumber - 1;
    let s = null;
    n < this._len && (s = Pa.deleteBeginning(this._lineTokens[n], e.endColumn - 1)), this._lineTokens[t] = Pa.append(this._lineTokens[t], s), this._deleteLines(e.startLineNumber, e.endLineNumber - e.startLineNumber);
  }
  _acceptInsertText(e, t, n) {
    if (t === 0 && n === 0) return;
    const s = e.lineNumber - 1;
    s >= this._len || (t !== 0 ? (this._lineTokens[s] = Pa.deleteEnding(this._lineTokens[s], e.column - 1), this._lineTokens[s] = Pa.insert(this._lineTokens[s], e.column - 1, n), this._insertLines(e.lineNumber, t)) : this._lineTokens[s] = Pa.insert(this._lineTokens[s], e.column - 1, n));
  }
  setMultilineTokens(e, t) {
    if (e.length === 0) return { changes: [] };
    const n = [];
    for (let s = 0, o = e.length; s < o; s++) {
      const r = e[s];
      let a = 0, l = 0, d = !1;
      for (let h = r.startLineNumber; h <= r.endLineNumber; h++) d ? (this.setTokens(t.getLanguageId(), h - 1, t.getLineLength(h), r.getLineTokens(h), !1), l = h) : this.setTokens(t.getLanguageId(), h - 1, t.getLineLength(h), r.getLineTokens(h), !0) && (d = !0, a = h, l = h);
      d && n.push({ fromLineNumber: a, toLineNumber: l });
    }
    return { changes: n };
  }
}
function P5(i) {
  return (32768 | i | 2 << 24 | 1024) >>> 0;
}
class nA {
  constructor(e) {
    this._pieces = [], this._isComplete = !1, this._languageIdCodec = e;
  }
  flush() {
    this._pieces = [], this._isComplete = !1;
  }
  isEmpty() {
    return this._pieces.length === 0;
  }
  set(e, t) {
    this._pieces = e || [], this._isComplete = t;
  }
  setPartial(e, t) {
    let n = e;
    if (t.length > 0) {
      const o = t[0].getRange(), r = t[t.length - 1].getRange();
      if (!o || !r) return e;
      n = e.plusRange(o).plusRange(r);
    }
    let s = null;
    for (let o = 0, r = this._pieces.length; o < r; o++) {
      const a = this._pieces[o];
      if (a.endLineNumber < n.startLineNumber) continue;
      if (a.startLineNumber > n.endLineNumber) {
        s = s || { index: o };
        break;
      }
      if (a.removeTokens(n), a.isEmpty()) {
        this._pieces.splice(o, 1), o--, r--;
        continue;
      }
      if (a.endLineNumber < n.startLineNumber) continue;
      if (a.startLineNumber > n.endLineNumber) {
        s = s || { index: o };
        continue;
      }
      const [l, d] = a.split(n);
      l.isEmpty() ? s = s || { index: o } : d.isEmpty() || (this._pieces.splice(o, 1, l, d), o++, r++, s = s || { index: o });
    }
    return s = s || { index: this._pieces.length }, t.length > 0 && (this._pieces = PS(this._pieces, s.index, t)), n;
  }
  isComplete() {
    return this._isComplete;
  }
  addSparseTokens(e, t) {
    if (t.getLineContent().length === 0) return t;
    const n = this._pieces;
    if (n.length === 0) return t;
    const s = n[nA._findFirstPieceWithLine(n, e)].getLineTokens(e);
    if (!s) return t;
    const o = t.getCount(), r = s.getCount();
    let a = 0;
    const l = [];
    let d = 0, h = 0;
    const c = (u, g) => {
      u !== h && (h = u, l[d++] = u, l[d++] = g);
    };
    for (let u = 0; u < r; u++) {
      const g = s.getStartCharacter(u), p = s.getEndCharacter(u), f = s.getMetadata(u), _ = ((1 & f ? 2048 : 0) | (2 & f ? 4096 : 0) | (4 & f ? 8192 : 0) | (8 & f ? 16384 : 0) | (16 & f ? 16744448 : 0) | (32 & f ? 4278190080 : 0)) >>> 0, v = ~_ >>> 0;
      for (; a < o && t.getEndOffset(a) <= g; ) c(t.getEndOffset(a), t.getMetadata(a)), a++;
      for (a < o && t.getStartOffset(a) < g && c(g, t.getMetadata(a)); a < o && t.getEndOffset(a) < p; ) c(t.getEndOffset(a), t.getMetadata(a) & v | f & _), a++;
      if (a < o) c(p, t.getMetadata(a) & v | f & _), t.getEndOffset(a) === p && a++;
      else {
        const b = Math.min(Math.max(0, a - 1), o - 1);
        c(p, t.getMetadata(b) & v | f & _);
      }
    }
    for (; a < o; ) c(t.getEndOffset(a), t.getMetadata(a)), a++;
    return new nn(new Uint32Array(l), t.getLineContent(), this._languageIdCodec);
  }
  static _findFirstPieceWithLine(e, t) {
    let n = 0, s = e.length - 1;
    for (; n < s; ) {
      let o = n + Math.floor((s - n) / 2);
      if (e[o].endLineNumber < t) n = o + 1;
      else {
        if (!(e[o].startLineNumber > t)) {
          for (; o > n && e[o - 1].startLineNumber <= t && t <= e[o - 1].endLineNumber; ) o--;
          return o;
        }
        s = o - 1;
      }
    }
    return n;
  }
  acceptEdit(e, t, n, s, o) {
    for (const r of this._pieces) r.acceptEdit(e, t, n, s, o);
  }
}
class by extends jB {
  constructor(e, t, n, s, o, r) {
    super(), this._languageService = e, this._languageConfigurationService = t, this._textModel = n, this._bracketPairsTextModelPart = s, this._languageId = o, this._attachedViews = r, this._semanticTokens = new nA(this._languageService.languageIdCodec), this._onDidChangeLanguage = this._register(new F()), this.onDidChangeLanguage = this._onDidChangeLanguage.event, this._onDidChangeLanguageConfiguration = this._register(new F()), this.onDidChangeLanguageConfiguration = this._onDidChangeLanguageConfiguration.event, this._onDidChangeTokens = this._register(new F()), this.onDidChangeTokens = this._onDidChangeTokens.event, this.grammarTokens = this._register(new jX(this._languageService.languageIdCodec, this._textModel, () => this._languageId, this._attachedViews)), this._register(this._languageConfigurationService.onDidChange((a) => {
      a.affects(this._languageId) && this._onDidChangeLanguageConfiguration.fire({});
    })), this._register(this.grammarTokens.onDidChangeTokens((a) => {
      this._emitModelTokensChangedEvent(a);
    })), this._register(this.grammarTokens.onDidChangeBackgroundTokenizationState((a) => {
      this._bracketPairsTextModelPart.handleDidChangeBackgroundTokenizationState();
    }));
  }
  handleDidChangeContent(e) {
    if (e.isFlush) this._semanticTokens.flush();
    else if (!e.isEolChange) for (const t of e.changes) {
      const [n, s, o] = Dc(t.text);
      this._semanticTokens.acceptEdit(t.range, n, s, o, t.text.length > 0 ? t.text.charCodeAt(0) : 0);
    }
    this.grammarTokens.handleDidChangeContent(e);
  }
  handleDidChangeAttached() {
    this.grammarTokens.handleDidChangeAttached();
  }
  getLineTokens(e) {
    this.validateLineNumber(e);
    const t = this.grammarTokens.getLineTokens(e);
    return this._semanticTokens.addSparseTokens(e, t);
  }
  _emitModelTokensChangedEvent(e) {
    this._textModel._isDisposing() || (this._bracketPairsTextModelPart.handleDidChangeTokens(e), this._onDidChangeTokens.fire(e));
  }
  validateLineNumber(e) {
    if (e < 1 || e > this._textModel.getLineCount()) throw new Kt("Illegal value for lineNumber");
  }
  get hasTokens() {
    return this.grammarTokens.hasTokens;
  }
  resetTokenization() {
    this.grammarTokens.resetTokenization();
  }
  get backgroundTokenizationState() {
    return this.grammarTokens.backgroundTokenizationState;
  }
  forceTokenization(e) {
    this.validateLineNumber(e), this.grammarTokens.forceTokenization(e);
  }
  hasAccurateTokensForLine(e) {
    return this.validateLineNumber(e), this.grammarTokens.hasAccurateTokensForLine(e);
  }
  isCheapToTokenize(e) {
    return this.validateLineNumber(e), this.grammarTokens.isCheapToTokenize(e);
  }
  tokenizeIfCheap(e) {
    this.validateLineNumber(e), this.grammarTokens.tokenizeIfCheap(e);
  }
  getTokenTypeIfInsertingCharacter(e, t, n) {
    return this.grammarTokens.getTokenTypeIfInsertingCharacter(e, t, n);
  }
  tokenizeLineWithEdit(e, t, n) {
    return this.grammarTokens.tokenizeLineWithEdit(e, t, n);
  }
  setSemanticTokens(e, t) {
    this._semanticTokens.set(e, t), this._emitModelTokensChangedEvent({ semanticTokensApplied: e !== null, ranges: [{ fromLineNumber: 1, toLineNumber: this._textModel.getLineCount() }] });
  }
  hasCompleteSemanticTokens() {
    return this._semanticTokens.isComplete();
  }
  hasSomeSemanticTokens() {
    return !this._semanticTokens.isEmpty();
  }
  setPartialSemanticTokens(e, t) {
    if (this.hasCompleteSemanticTokens()) return;
    const n = this._textModel.validateRange(this._semanticTokens.setPartial(e, t));
    this._emitModelTokensChangedEvent({ semanticTokensApplied: !0, ranges: [{ fromLineNumber: n.startLineNumber, toLineNumber: n.endLineNumber }] });
  }
  getWordAtPosition(e) {
    this.assertNotDisposed();
    const t = this._textModel.validatePosition(e), n = this._textModel.getLineContent(t.lineNumber), s = this.getLineTokens(t.lineNumber), o = s.findTokenIndexAtOffset(t.column - 1), [r, a] = by._findLanguageBoundaries(s, o), l = q0(t.column, this.getLanguageConfiguration(s.getLanguageId(o)).getWordDefinition(), n.substring(r, a), r);
    if (l && l.startColumn <= e.column && e.column <= l.endColumn) return l;
    if (o > 0 && r === t.column - 1) {
      const [d, h] = by._findLanguageBoundaries(s, o - 1), c = q0(t.column, this.getLanguageConfiguration(s.getLanguageId(o - 1)).getWordDefinition(), n.substring(d, h), d);
      if (c && c.startColumn <= e.column && e.column <= c.endColumn) return c;
    }
    return null;
  }
  getLanguageConfiguration(e) {
    return this._languageConfigurationService.getLanguageConfiguration(e);
  }
  static _findLanguageBoundaries(e, t) {
    const n = e.getLanguageId(t);
    let s = 0;
    for (let r = t; r >= 0 && e.getLanguageId(r) === n; r--) s = e.getStartOffset(r);
    let o = e.getLineContent().length;
    for (let r = t, a = e.getCount(); r < a && e.getLanguageId(r) === n; r++) o = e.getEndOffset(r);
    return [s, o];
  }
  getWordUntilPosition(e) {
    const t = this.getWordAtPosition(e);
    return t ? { word: t.word.substr(0, e.column - t.startColumn), startColumn: t.startColumn, endColumn: e.column } : { word: "", startColumn: e.column, endColumn: e.column };
  }
  getLanguageId() {
    return this._languageId;
  }
  getLanguageIdAtPosition(e, t) {
    const n = this._textModel.validatePosition(new W(e, t)), s = this.getLineTokens(n.lineNumber);
    return s.getLanguageId(s.findTokenIndexAtOffset(n.column - 1));
  }
  setLanguageId(e, t = "api") {
    if (this._languageId === e) return;
    const n = { oldLanguage: this._languageId, newLanguage: e, source: t };
    this._languageId = e, this._bracketPairsTextModelPart.handleDidChangeLanguage(n), this.grammarTokens.resetTokenization(), this._onDidChangeLanguage.fire(n), this._onDidChangeLanguageConfiguration.fire({});
  }
}
class jX extends V {
  get backgroundTokenizationState() {
    return this._backgroundTokenizationState;
  }
  constructor(e, t, n, s) {
    super(), this._languageIdCodec = e, this._textModel = t, this.getLanguageId = n, this._tokenizer = null, this._defaultBackgroundTokenizer = null, this._backgroundTokenizer = this._register(new rn()), this._tokens = new Lv(this._languageIdCodec), this._debugBackgroundTokenizer = this._register(new rn()), this._backgroundTokenizationState = 1, this._onDidChangeBackgroundTokenizationState = this._register(new F()), this.onDidChangeBackgroundTokenizationState = this._onDidChangeBackgroundTokenizationState.event, this._onDidChangeTokens = this._register(new F()), this.onDidChangeTokens = this._onDidChangeTokens.event, this._attachedViewStates = this._register(new QT()), this._register(ci.onDidChange((o) => {
      const r = this.getLanguageId();
      o.changedLanguages.indexOf(r) !== -1 && this.resetTokenization();
    })), this.resetTokenization(), this._register(s.onDidChangeVisibleRanges(({ view: o, state: r }) => {
      if (r) {
        let a = this._attachedViewStates.get(o);
        a || (a = new qX(() => this.refreshRanges(a.lineRanges)), this._attachedViewStates.set(o, a)), a.handleStateChange(r);
      } else this._attachedViewStates.deleteAndDispose(o);
    }));
  }
  resetTokenization(e = !0) {
    var t;
    this._tokens.flush(), (t = this._debugBackgroundTokens) === null || t === void 0 || t.flush(), this._debugBackgroundStates && (this._debugBackgroundStates = new fI(this._textModel.getLineCount())), e && this._onDidChangeTokens.fire({ semanticTokensApplied: !1, ranges: [{ fromLineNumber: 1, toLineNumber: this._textModel.getLineCount() }] });
    const [n, s] = (() => {
      if (this._textModel.isTooLargeForTokenization()) return [null, null];
      const o = ci.get(this.getLanguageId());
      if (!o) return [null, null];
      let r;
      try {
        r = o.getInitialState();
      } catch (a) {
        return We(a), [null, null];
      }
      return [o, r];
    })();
    if (this._tokenizer = n && s ? new HX(this._textModel.getLineCount(), n, this._textModel, this._languageIdCodec) : null, this._backgroundTokenizer.clear(), this._defaultBackgroundTokenizer = null, this._tokenizer) {
      const o = { setTokens: (r) => {
        this.setTokens(r);
      }, backgroundTokenizationFinished: () => {
        this._backgroundTokenizationState !== 2 && (this._backgroundTokenizationState = 2, this._onDidChangeBackgroundTokenizationState.fire());
      }, setEndState: (r, a) => {
        var l;
        if (!this._tokenizer) return;
        const d = this._tokenizer.store.getFirstInvalidEndStateLineNumber();
        d !== null && r >= d && ((l = this._tokenizer) === null || l === void 0 || l.store.setEndState(r, a));
      } };
      n && n.createBackgroundTokenizer && !n.backgroundTokenizerShouldOnlyVerifyTokens && (this._backgroundTokenizer.value = n.createBackgroundTokenizer(this._textModel, o)), this._backgroundTokenizer.value || this._textModel.isTooLargeForTokenization() || (this._backgroundTokenizer.value = this._defaultBackgroundTokenizer = new KX(this._tokenizer, o), this._defaultBackgroundTokenizer.handleChanges()), n != null && n.backgroundTokenizerShouldOnlyVerifyTokens && n.createBackgroundTokenizer ? (this._debugBackgroundTokens = new Lv(this._languageIdCodec), this._debugBackgroundStates = new fI(this._textModel.getLineCount()), this._debugBackgroundTokenizer.clear(), this._debugBackgroundTokenizer.value = n.createBackgroundTokenizer(this._textModel, { setTokens: (r) => {
        var a;
        (a = this._debugBackgroundTokens) === null || a === void 0 || a.setMultilineTokens(r, this._textModel);
      }, backgroundTokenizationFinished() {
      }, setEndState: (r, a) => {
        var l;
        (l = this._debugBackgroundStates) === null || l === void 0 || l.setEndState(r, a);
      } })) : (this._debugBackgroundTokens = void 0, this._debugBackgroundStates = void 0, this._debugBackgroundTokenizer.value = void 0);
    }
    this.refreshAllVisibleLineTokens();
  }
  handleDidChangeAttached() {
    var e;
    (e = this._defaultBackgroundTokenizer) === null || e === void 0 || e.handleChanges();
  }
  handleDidChangeContent(e) {
    var t, n, s;
    if (e.isFlush) this.resetTokenization(!1);
    else if (!e.isEolChange) {
      for (const o of e.changes) {
        const [r, a] = Dc(o.text);
        this._tokens.acceptEdit(o.range, r, a), (t = this._debugBackgroundTokens) === null || t === void 0 || t.acceptEdit(o.range, r, a);
      }
      (n = this._debugBackgroundStates) === null || n === void 0 || n.acceptChanges(e.changes), this._tokenizer && this._tokenizer.store.acceptChanges(e.changes), (s = this._defaultBackgroundTokenizer) === null || s === void 0 || s.handleChanges();
    }
  }
  setTokens(e) {
    const { changes: t } = this._tokens.setMultilineTokens(e, this._textModel);
    return t.length > 0 && this._onDidChangeTokens.fire({ semanticTokensApplied: !1, ranges: t }), { changes: t };
  }
  refreshAllVisibleLineTokens() {
    const e = je.joinMany([...this._attachedViewStates].map(([t, n]) => n.lineRanges));
    this.refreshRanges(e);
  }
  refreshRanges(e) {
    for (const t of e) this.refreshRange(t.startLineNumber, t.endLineNumberExclusive - 1);
  }
  refreshRange(e, t) {
    var n, s;
    if (!this._tokenizer) return;
    e = Math.max(1, Math.min(this._textModel.getLineCount(), e)), t = Math.min(this._textModel.getLineCount(), t);
    const o = new mI(), { heuristicTokens: r } = this._tokenizer.tokenizeHeuristically(o, e, t), a = this.setTokens(o.finalize());
    if (r) for (const l of a.changes) (n = this._backgroundTokenizer.value) === null || n === void 0 || n.requestTokens(l.fromLineNumber, l.toLineNumber + 1);
    (s = this._defaultBackgroundTokenizer) === null || s === void 0 || s.checkFinished();
  }
  forceTokenization(e) {
    var t, n;
    const s = new mI();
    (t = this._tokenizer) === null || t === void 0 || t.updateTokensUntilLine(s, e), this.setTokens(s.finalize()), (n = this._defaultBackgroundTokenizer) === null || n === void 0 || n.checkFinished();
  }
  hasAccurateTokensForLine(e) {
    return !this._tokenizer || this._tokenizer.hasAccurateTokensForLine(e);
  }
  isCheapToTokenize(e) {
    return !this._tokenizer || this._tokenizer.isCheapToTokenize(e);
  }
  tokenizeIfCheap(e) {
    this.isCheapToTokenize(e) && this.forceTokenization(e);
  }
  getLineTokens(e) {
    var t;
    const n = this._textModel.getLineContent(e), s = this._tokens.getTokens(this._textModel.getLanguageId(), e - 1, n);
    if (this._debugBackgroundTokens && this._debugBackgroundStates && this._tokenizer && this._debugBackgroundStates.getFirstInvalidEndStateLineNumberOrMax() > e && this._tokenizer.store.getFirstInvalidEndStateLineNumberOrMax() > e) {
      const o = this._debugBackgroundTokens.getTokens(this._textModel.getLanguageId(), e - 1, n);
      !s.equals(o) && (!((t = this._debugBackgroundTokenizer.value) === null || t === void 0) && t.reportMismatchingTokens) && this._debugBackgroundTokenizer.value.reportMismatchingTokens(e);
    }
    return s;
  }
  getTokenTypeIfInsertingCharacter(e, t, n) {
    if (!this._tokenizer) return 0;
    const s = this._textModel.validatePosition(new W(e, t));
    return this.forceTokenization(s.lineNumber), this._tokenizer.getTokenTypeIfInsertingCharacter(s, n);
  }
  tokenizeLineWithEdit(e, t, n) {
    if (!this._tokenizer) return null;
    const s = this._textModel.validatePosition(e);
    return this.forceTokenization(s.lineNumber), this._tokenizer.tokenizeLineWithEdit(s, t, n);
  }
  get hasTokens() {
    return this._tokens.hasTokens;
  }
}
class qX extends V {
  get lineRanges() {
    return this._lineRanges;
  }
  constructor(e) {
    super(), this._refreshTokens = e, this.runner = this._register(new It(() => this.update(), 50)), this._computedLineRanges = [], this._lineRanges = [];
  }
  update() {
    ri(this._computedLineRanges, this._lineRanges, (e, t) => e.equals(t)) || (this._computedLineRanges = this._lineRanges, this._refreshTokens());
  }
  handleStateChange(e) {
    this._lineRanges = e.visibleLineRanges, e.stabilized ? (this.runner.cancel(), this.update()) : this.runner.schedule();
  }
}
const mL = tt("undoRedoService");
class dW {
  constructor(e, t) {
    this.resource = e, this.elements = t;
  }
}
class gm {
  constructor() {
    this.id = gm._ID++, this.order = 1;
  }
  nextOrder() {
    return this.id === 0 ? 0 : this.order++;
  }
}
gm._ID = 0, gm.None = new gm();
class Ya {
  constructor() {
    this.id = Ya._ID++, this.order = 1;
  }
  nextOrder() {
    return this.id === 0 ? 0 : this.order++;
  }
}
Ya._ID = 0, Ya.None = new Ya();
var ru, $X = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, ED = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
function O5(i, e) {
  let t;
  var n;
  return typeof i == "string" ? t = function(s) {
    const o = new A5();
    return o.acceptChunk(s), o.finish();
  }(i) : t = (n = i) && typeof n.read == "function" ? function(s) {
    const o = new A5();
    let r;
    for (; typeof (r = s.read()) == "string"; ) o.acceptChunk(r);
    return o.finish();
  }(i) : i, t.create(e);
}
let Lb = 0;
class GX {
  constructor(e) {
    this._source = e, this._eos = !1;
  }
  read() {
    if (this._eos) return null;
    const e = [];
    let t = 0, n = 0;
    for (; ; ) {
      const s = this._source.read();
      if (s === null) return this._eos = !0, t === 0 ? null : e.join("");
      if (s.length > 0 && (e[t++] = s, n += s.length), n >= 65536) return e.join("");
    }
  }
}
const zf = () => {
  throw new Error("Invalid change accessor");
};
let Oa = ru = class extends V {
  static resolveOptions(i, e) {
    if (e.detectIndentation) {
      const t = L5(i, e.tabSize, e.insertSpaces);
      return new AC({ tabSize: t.tabSize, indentSize: "tabSize", insertSpaces: t.insertSpaces, trimAutoWhitespace: e.trimAutoWhitespace, defaultEOL: e.defaultEOL, bracketPairColorizationOptions: e.bracketPairColorizationOptions });
    }
    return new AC(e);
  }
  get onDidChangeLanguage() {
    return this._tokenizationTextModelPart.onDidChangeLanguage;
  }
  get onDidChangeLanguageConfiguration() {
    return this._tokenizationTextModelPart.onDidChangeLanguageConfiguration;
  }
  get onDidChangeTokens() {
    return this._tokenizationTextModelPart.onDidChangeTokens;
  }
  onDidChangeContent(i) {
    return this._eventEmitter.slowEvent((e) => i(e.contentChangedEvent));
  }
  onDidChangeContentOrInjectedText(i) {
    return yr(this._eventEmitter.fastEvent((e) => i(e)), this._onDidChangeInjectedText.event((e) => i(e)));
  }
  _isDisposing() {
    return this.__isDisposing;
  }
  get tokenization() {
    return this._tokenizationTextModelPart;
  }
  get bracketPairs() {
    return this._bracketPairs;
  }
  get guides() {
    return this._guidesTextModelPart;
  }
  constructor(i, e, t, n = null, s, o, r) {
    super(), this._undoRedoService = s, this._languageService = o, this._languageConfigurationService = r, this._onWillDispose = this._register(new F()), this.onWillDispose = this._onWillDispose.event, this._onDidChangeDecorations = this._register(new QX((u) => this.handleBeforeFireDecorationsChangedEvent(u))), this.onDidChangeDecorations = this._onDidChangeDecorations.event, this._onDidChangeOptions = this._register(new F()), this.onDidChangeOptions = this._onDidChangeOptions.event, this._onDidChangeAttached = this._register(new F()), this.onDidChangeAttached = this._onDidChangeAttached.event, this._onDidChangeInjectedText = this._register(new F()), this._eventEmitter = this._register(new JX()), this._languageSelectionListener = this._register(new rn()), this._deltaDecorationCallCnt = 0, this._attachedViews = new eQ(), Lb++, this.id = "$model" + Lb, this.isForSimpleWidget = t.isForSimpleWidget, this._associatedResource = n ?? Ie.parse("inmemory://model/" + Lb), this._attachedEditorCount = 0;
    const { textBuffer: a, disposable: l } = O5(i, t.defaultEOL);
    this._buffer = a, this._bufferDisposable = l, this._options = ru.resolveOptions(this._buffer, t);
    const d = typeof e == "string" ? e : e.languageId;
    typeof e != "string" && (this._languageSelectionListener.value = e.onDidChange(() => this._setLanguage(e.languageId))), this._bracketPairs = this._register(new wX(this, this._languageConfigurationService)), this._guidesTextModelPart = this._register(new DY(this, this._languageConfigurationService)), this._decorationProvider = this._register(new yX(this)), this._tokenizationTextModelPart = new by(this._languageService, this._languageConfigurationService, this, this._bracketPairs, d, this._attachedViews);
    const h = this._buffer.getLineCount(), c = this._buffer.getValueLengthInRange(new D(1, 1, h, this._buffer.getLineLength(h) + 1), 0);
    t.largeFileOptimizations ? (this._isTooLargeForTokenization = c > ru.LARGE_FILE_SIZE_THRESHOLD || h > ru.LARGE_FILE_LINE_COUNT_THRESHOLD, this._isTooLargeForHeapOperation = c > ru.LARGE_FILE_HEAP_OPERATION_THRESHOLD) : (this._isTooLargeForTokenization = !1, this._isTooLargeForHeapOperation = !1), this._isTooLargeForSyncing = c > ru._MODEL_SYNC_LIMIT, this._versionId = 1, this._alternativeVersionId = 1, this._initialUndoRedoSnapshot = null, this._isDisposed = !1, this.__isDisposing = !1, this._instanceId = n8(Lb), this._lastDecorationId = 0, this._decorations = /* @__PURE__ */ Object.create(null), this._decorationsTree = new F5(), this._commandManager = new JR(this, this._undoRedoService), this._isUndoing = !1, this._isRedoing = !1, this._trimAutoWhitespaceLines = null, this._register(this._decorationProvider.onDidChange(() => {
      this._onDidChangeDecorations.beginDeferredEmit(), this._onDidChangeDecorations.fire(), this._onDidChangeDecorations.endDeferredEmit();
    })), this._languageService.requestRichLanguageFeatures(d);
  }
  dispose() {
    this.__isDisposing = !0, this._onWillDispose.fire(), this._tokenizationTextModelPart.dispose(), this._isDisposed = !0, super.dispose(), this._bufferDisposable.dispose(), this.__isDisposing = !1;
    const i = new um([], "", `
`, !1, !1, !0, !0);
    i.dispose(), this._buffer = i, this._bufferDisposable = V.None;
  }
  _assertNotDisposed() {
    if (this._isDisposed) throw new Error("Model is disposed!");
  }
  _emitContentChangedEvent(i, e) {
    this.__isDisposing || (this._tokenizationTextModelPart.handleDidChangeContent(e), this._bracketPairs.handleDidChangeContent(e), this._eventEmitter.fire(new $u(i, e)));
  }
  setValue(i) {
    if (this._assertNotDisposed(), i == null) throw Yo();
    const { textBuffer: e, disposable: t } = O5(i, this._options.defaultEOL);
    this._setValueFromTextBuffer(e, t);
  }
  _createContentChanged2(i, e, t, n, s, o, r, a) {
    return { changes: [{ range: i, rangeOffset: e, rangeLength: t, text: n }], eol: this._buffer.getEOL(), isEolChange: a, versionId: this.getVersionId(), isUndoing: s, isRedoing: o, isFlush: r };
  }
  _setValueFromTextBuffer(i, e) {
    this._assertNotDisposed();
    const t = this.getFullModelRange(), n = this.getValueLengthInRange(t), s = this.getLineCount(), o = this.getLineMaxColumn(s);
    this._buffer = i, this._bufferDisposable.dispose(), this._bufferDisposable = e, this._increaseVersionId(), this._decorations = /* @__PURE__ */ Object.create(null), this._decorationsTree = new F5(), this._commandManager.clear(), this._trimAutoWhitespaceLines = null, this._emitContentChangedEvent(new dm([new eX()], this._versionId, !1, !1), this._createContentChanged2(new D(1, 1, s, o), 0, n, this.getValue(), !1, !1, !0, !1));
  }
  setEOL(i) {
    this._assertNotDisposed();
    const e = i === 1 ? `\r
` : `
`;
    if (this._buffer.getEOL() === e) return;
    const t = this.getFullModelRange(), n = this.getValueLengthInRange(t), s = this.getLineCount(), o = this.getLineMaxColumn(s);
    this._onBeforeEOLChange(), this._buffer.setEOL(e), this._increaseVersionId(), this._onAfterEOLChange(), this._emitContentChangedEvent(new dm([new nX()], this._versionId, !1, !1), this._createContentChanged2(new D(1, 1, s, o), 0, n, this.getValue(), !1, !1, !1, !0));
  }
  _onBeforeEOLChange() {
    this._decorationsTree.ensureAllNodesHaveRanges(this);
  }
  _onAfterEOLChange() {
    const i = this.getVersionId(), e = this._decorationsTree.collectNodesPostOrder();
    for (let t = 0, n = e.length; t < n; t++) {
      const s = e[t], o = s.range, r = s.cachedAbsoluteStart - s.start, a = this._buffer.getOffsetAt(o.startLineNumber, o.startColumn), l = this._buffer.getOffsetAt(o.endLineNumber, o.endColumn);
      s.cachedAbsoluteStart = a, s.cachedAbsoluteEnd = l, s.cachedVersionId = i, s.start = a - r, s.end = l - r, xc(s);
    }
  }
  onBeforeAttached() {
    return this._attachedEditorCount++, this._attachedEditorCount === 1 && (this._tokenizationTextModelPart.handleDidChangeAttached(), this._onDidChangeAttached.fire(void 0)), this._attachedViews.attachView();
  }
  onBeforeDetached(i) {
    this._attachedEditorCount--, this._attachedEditorCount === 0 && (this._tokenizationTextModelPart.handleDidChangeAttached(), this._onDidChangeAttached.fire(void 0)), this._attachedViews.detachView(i);
  }
  isAttachedToEditor() {
    return this._attachedEditorCount > 0;
  }
  getAttachedEditorCount() {
    return this._attachedEditorCount;
  }
  isTooLargeForSyncing() {
    return this._isTooLargeForSyncing;
  }
  isTooLargeForTokenization() {
    return this._isTooLargeForTokenization;
  }
  isTooLargeForHeapOperation() {
    return this._isTooLargeForHeapOperation;
  }
  isDisposed() {
    return this._isDisposed;
  }
  isDominatedByLongLines() {
    if (this._assertNotDisposed(), this.isTooLargeForTokenization()) return !1;
    let i = 0, e = 0;
    const t = this._buffer.getLineCount();
    for (let n = 1; n <= t; n++) {
      const s = this._buffer.getLineLength(n);
      s >= 1e4 ? e += s : i += s;
    }
    return e > i;
  }
  get uri() {
    return this._associatedResource;
  }
  getOptions() {
    return this._assertNotDisposed(), this._options;
  }
  getFormattingOptions() {
    return { tabSize: this._options.indentSize, insertSpaces: this._options.insertSpaces };
  }
  updateOptions(i) {
    this._assertNotDisposed();
    const e = i.tabSize !== void 0 ? i.tabSize : this._options.tabSize, t = i.indentSize !== void 0 ? i.indentSize : this._options.originalIndentSize, n = i.insertSpaces !== void 0 ? i.insertSpaces : this._options.insertSpaces, s = i.trimAutoWhitespace !== void 0 ? i.trimAutoWhitespace : this._options.trimAutoWhitespace, o = i.bracketColorizationOptions !== void 0 ? i.bracketColorizationOptions : this._options.bracketPairColorizationOptions, r = new AC({ tabSize: e, indentSize: t, insertSpaces: n, defaultEOL: this._options.defaultEOL, trimAutoWhitespace: s, bracketPairColorizationOptions: o });
    if (this._options.equals(r)) return;
    const a = this._options.createChangeEvent(r);
    this._options = r, this._bracketPairs.handleDidChangeOptions(a), this._decorationProvider.handleDidChangeOptions(a), this._onDidChangeOptions.fire(a);
  }
  detectIndentation(i, e) {
    this._assertNotDisposed();
    const t = L5(this._buffer, e, i);
    this.updateOptions({ insertSpaces: t.insertSpaces, tabSize: t.tabSize, indentSize: t.tabSize });
  }
  normalizeIndentation(i) {
    return this._assertNotDisposed(), KR(i, this._options.indentSize, this._options.insertSpaces);
  }
  getVersionId() {
    return this._assertNotDisposed(), this._versionId;
  }
  mightContainRTL() {
    return this._buffer.mightContainRTL();
  }
  mightContainUnusualLineTerminators() {
    return this._buffer.mightContainUnusualLineTerminators();
  }
  removeUnusualLineTerminators(i = null) {
    const e = this.findMatches(t8.source, !1, !0, !1, null, !1, 1073741824);
    this._buffer.resetMightContainUnusualLineTerminators(), this.pushEditOperations(i, e.map((t) => ({ range: t.range, text: null })), () => null);
  }
  mightContainNonBasicASCII() {
    return this._buffer.mightContainNonBasicASCII();
  }
  getAlternativeVersionId() {
    return this._assertNotDisposed(), this._alternativeVersionId;
  }
  getInitialUndoRedoSnapshot() {
    return this._assertNotDisposed(), this._initialUndoRedoSnapshot;
  }
  getOffsetAt(i) {
    this._assertNotDisposed();
    const e = this._validatePosition(i.lineNumber, i.column, 0);
    return this._buffer.getOffsetAt(e.lineNumber, e.column);
  }
  getPositionAt(i) {
    this._assertNotDisposed();
    const e = Math.min(this._buffer.getLength(), Math.max(0, i));
    return this._buffer.getPositionAt(e);
  }
  _increaseVersionId() {
    this._versionId = this._versionId + 1, this._alternativeVersionId = this._versionId;
  }
  _overwriteVersionId(i) {
    this._versionId = i;
  }
  _overwriteAlternativeVersionId(i) {
    this._alternativeVersionId = i;
  }
  _overwriteInitialUndoRedoSnapshot(i) {
    this._initialUndoRedoSnapshot = i;
  }
  getValue(i, e = !1) {
    if (this._assertNotDisposed(), this.isTooLargeForHeapOperation()) throw new Kt("Operation would exceed heap memory limits");
    const t = this.getFullModelRange(), n = this.getValueInRange(t, i);
    return e ? this._buffer.getBOM() + n : n;
  }
  createSnapshot(i = !1) {
    return new GX(this._buffer.createSnapshot(i));
  }
  getValueLength(i, e = !1) {
    this._assertNotDisposed();
    const t = this.getFullModelRange(), n = this.getValueLengthInRange(t, i);
    return e ? this._buffer.getBOM().length + n : n;
  }
  getValueInRange(i, e = 0) {
    return this._assertNotDisposed(), this._buffer.getValueInRange(this.validateRange(i), e);
  }
  getValueLengthInRange(i, e = 0) {
    return this._assertNotDisposed(), this._buffer.getValueLengthInRange(this.validateRange(i), e);
  }
  getCharacterCountInRange(i, e = 0) {
    return this._assertNotDisposed(), this._buffer.getCharacterCountInRange(this.validateRange(i), e);
  }
  getLineCount() {
    return this._assertNotDisposed(), this._buffer.getLineCount();
  }
  getLineContent(i) {
    if (this._assertNotDisposed(), i < 1 || i > this.getLineCount()) throw new Kt("Illegal value for lineNumber");
    return this._buffer.getLineContent(i);
  }
  getLineLength(i) {
    if (this._assertNotDisposed(), i < 1 || i > this.getLineCount()) throw new Kt("Illegal value for lineNumber");
    return this._buffer.getLineLength(i);
  }
  getLinesContent() {
    if (this._assertNotDisposed(), this.isTooLargeForHeapOperation()) throw new Kt("Operation would exceed heap memory limits");
    return this._buffer.getLinesContent();
  }
  getEOL() {
    return this._assertNotDisposed(), this._buffer.getEOL();
  }
  getEndOfLineSequence() {
    return this._assertNotDisposed(), this._buffer.getEOL() === `
` ? 0 : 1;
  }
  getLineMinColumn(i) {
    return this._assertNotDisposed(), 1;
  }
  getLineMaxColumn(i) {
    if (this._assertNotDisposed(), i < 1 || i > this.getLineCount()) throw new Kt("Illegal value for lineNumber");
    return this._buffer.getLineLength(i) + 1;
  }
  getLineFirstNonWhitespaceColumn(i) {
    if (this._assertNotDisposed(), i < 1 || i > this.getLineCount()) throw new Kt("Illegal value for lineNumber");
    return this._buffer.getLineFirstNonWhitespaceColumn(i);
  }
  getLineLastNonWhitespaceColumn(i) {
    if (this._assertNotDisposed(), i < 1 || i > this.getLineCount()) throw new Kt("Illegal value for lineNumber");
    return this._buffer.getLineLastNonWhitespaceColumn(i);
  }
  _validateRangeRelaxedNoAllocations(i) {
    const e = this._buffer.getLineCount(), t = i.startLineNumber, n = i.startColumn;
    let s = Math.floor(typeof t != "number" || isNaN(t) ? 1 : t), o = Math.floor(typeof n != "number" || isNaN(n) ? 1 : n);
    if (s < 1) s = 1, o = 1;
    else if (s > e) s = e, o = this.getLineMaxColumn(s);
    else if (o <= 1) o = 1;
    else {
      const h = this.getLineMaxColumn(s);
      o >= h && (o = h);
    }
    const r = i.endLineNumber, a = i.endColumn;
    let l = Math.floor(typeof r != "number" || isNaN(r) ? 1 : r), d = Math.floor(typeof a != "number" || isNaN(a) ? 1 : a);
    if (l < 1) l = 1, d = 1;
    else if (l > e) l = e, d = this.getLineMaxColumn(l);
    else if (d <= 1) d = 1;
    else {
      const h = this.getLineMaxColumn(l);
      d >= h && (d = h);
    }
    return t === s && n === o && r === l && a === d && i instanceof D && !(i instanceof _e) ? i : new D(s, o, l, d);
  }
  _isValidPosition(i, e, t) {
    return typeof i != "number" || typeof e != "number" || isNaN(i) || isNaN(e) || i < 1 || e < 1 || (0 | i) !== i || (0 | e) !== e || i > this._buffer.getLineCount() ? !1 : e === 1 ? !0 : !(e > this.getLineMaxColumn(i) || t === 1 && en(this._buffer.getLineCharCode(i, e - 2)));
  }
  _validatePosition(i, e, t) {
    const n = Math.floor(typeof i != "number" || isNaN(i) ? 1 : i), s = Math.floor(typeof e != "number" || isNaN(e) ? 1 : e), o = this._buffer.getLineCount();
    if (n < 1) return new W(1, 1);
    if (n > o) return new W(o, this.getLineMaxColumn(o));
    if (s <= 1) return new W(n, 1);
    const r = this.getLineMaxColumn(n);
    return s >= r ? new W(n, r) : t === 1 && en(this._buffer.getLineCharCode(n, s - 2)) ? new W(n, s - 1) : new W(n, s);
  }
  validatePosition(i) {
    return this._assertNotDisposed(), i instanceof W && this._isValidPosition(i.lineNumber, i.column, 1) ? i : this._validatePosition(i.lineNumber, i.column, 1);
  }
  _isValidRange(i, e) {
    const t = i.startLineNumber, n = i.startColumn, s = i.endLineNumber, o = i.endColumn;
    if (!this._isValidPosition(t, n, 0) || !this._isValidPosition(s, o, 0)) return !1;
    if (e === 1) {
      const r = n > 1 ? this._buffer.getLineCharCode(t, n - 2) : 0, a = o > 1 && o <= this._buffer.getLineLength(s) ? this._buffer.getLineCharCode(s, o - 2) : 0, l = en(r), d = en(a);
      return !l && !d;
    }
    return !0;
  }
  validateRange(i) {
    if (this._assertNotDisposed(), i instanceof D && !(i instanceof _e) && this._isValidRange(i, 1)) return i;
    const e = this._validatePosition(i.startLineNumber, i.startColumn, 0), t = this._validatePosition(i.endLineNumber, i.endColumn, 0), n = e.lineNumber, s = e.column, o = t.lineNumber, r = t.column;
    {
      const a = s > 1 ? this._buffer.getLineCharCode(n, s - 2) : 0, l = r > 1 && r <= this._buffer.getLineLength(o) ? this._buffer.getLineCharCode(o, r - 2) : 0, d = en(a), h = en(l);
      return d || h ? n === o && s === r ? new D(n, s - 1, o, r - 1) : d && h ? new D(n, s - 1, o, r + 1) : d ? new D(n, s - 1, o, r) : new D(n, s, o, r + 1) : new D(n, s, o, r);
    }
  }
  modifyPosition(i, e) {
    this._assertNotDisposed();
    const t = this.getOffsetAt(i) + e;
    return this.getPositionAt(Math.min(this._buffer.getLength(), Math.max(0, t)));
  }
  getFullModelRange() {
    this._assertNotDisposed();
    const i = this.getLineCount();
    return new D(1, 1, i, this.getLineMaxColumn(i));
  }
  findMatchesLineByLine(i, e, t, n) {
    return this._buffer.findMatchesLineByLine(i, e, t, n);
  }
  findMatches(i, e, t, n, s, o, r = 999) {
    this._assertNotDisposed();
    let a = null;
    e !== null && (Array.isArray(e) || (e = [e]), e.every((h) => D.isIRange(h)) && (a = e.map((h) => this.validateRange(h)))), a === null && (a = [this.getFullModelRange()]), a = a.sort((h, c) => h.startLineNumber - c.startLineNumber || h.startColumn - c.startColumn);
    const l = [];
    let d;
    if (l.push(a.reduce((h, c) => D.areIntersecting(h, c) ? h.plusRange(c) : (l.push(h), c))), !t && i.indexOf(`
`) < 0) {
      const h = new ou(i, t, n, s).parseSearchRequest();
      if (!h) return [];
      d = (c) => this.findMatchesLineByLine(c, h, o, r);
    } else d = (h) => rb.findMatches(this, new ou(i, t, n, s), h, o, r);
    return l.map(d).reduce((h, c) => h.concat(c), []);
  }
  findNextMatch(i, e, t, n, s, o) {
    this._assertNotDisposed();
    const r = this.validatePosition(e);
    if (!t && i.indexOf(`
`) < 0) {
      const a = new ou(i, t, n, s).parseSearchRequest();
      if (!a) return null;
      const l = this.getLineCount();
      let d = new D(r.lineNumber, r.column, l, this.getLineMaxColumn(l)), h = this.findMatchesLineByLine(d, a, o, 1);
      return rb.findNextMatch(this, new ou(i, t, n, s), r, o), h.length > 0 ? h[0] : (d = new D(1, 1, r.lineNumber, this.getLineMaxColumn(r.lineNumber)), h = this.findMatchesLineByLine(d, a, o, 1), h.length > 0 ? h[0] : null);
    }
    return rb.findNextMatch(this, new ou(i, t, n, s), r, o);
  }
  findPreviousMatch(i, e, t, n, s, o) {
    this._assertNotDisposed();
    const r = this.validatePosition(e);
    return rb.findPreviousMatch(this, new ou(i, t, n, s), r, o);
  }
  pushStackElement() {
    this._commandManager.pushStackElement();
  }
  popStackElement() {
    this._commandManager.popStackElement();
  }
  pushEOL(i) {
    if ((this.getEOL() === `
` ? 0 : 1) !== i) try {
      this._onDidChangeDecorations.beginDeferredEmit(), this._eventEmitter.beginDeferredEmit(), this._initialUndoRedoSnapshot === null && (this._initialUndoRedoSnapshot = this._undoRedoService.createSnapshot(this.uri)), this._commandManager.pushEOL(i);
    } finally {
      this._eventEmitter.endDeferredEmit(), this._onDidChangeDecorations.endDeferredEmit();
    }
  }
  _validateEditOperation(i) {
    return i instanceof aD ? i : new aD(i.identifier || null, this.validateRange(i.range), i.text, i.forceMoveMarkers || !1, i.isAutoWhitespaceEdit || !1, i._isTracked || !1);
  }
  _validateEditOperations(i) {
    const e = [];
    for (let t = 0, n = i.length; t < n; t++) e[t] = this._validateEditOperation(i[t]);
    return e;
  }
  pushEditOperations(i, e, t, n) {
    try {
      return this._onDidChangeDecorations.beginDeferredEmit(), this._eventEmitter.beginDeferredEmit(), this._pushEditOperations(i, this._validateEditOperations(e), t, n);
    } finally {
      this._eventEmitter.endDeferredEmit(), this._onDidChangeDecorations.endDeferredEmit();
    }
  }
  _pushEditOperations(i, e, t, n) {
    if (this._options.trimAutoWhitespace && this._trimAutoWhitespaceLines) {
      const s = e.map((r) => ({ range: this.validateRange(r.range), text: r.text }));
      let o = !0;
      if (i) for (let r = 0, a = i.length; r < a; r++) {
        const l = i[r];
        let d = !1;
        for (let h = 0, c = s.length; h < c; h++) {
          const u = s[h].range, g = u.startLineNumber > l.endLineNumber, p = l.startLineNumber > u.endLineNumber;
          if (!g && !p) {
            d = !0;
            break;
          }
        }
        if (!d) {
          o = !1;
          break;
        }
      }
      if (o) for (let r = 0, a = this._trimAutoWhitespaceLines.length; r < a; r++) {
        const l = this._trimAutoWhitespaceLines[r], d = this.getLineMaxColumn(l);
        let h = !0;
        for (let c = 0, u = s.length; c < u; c++) {
          const g = s[c].range, p = s[c].text;
          if (!(l < g.startLineNumber || l > g.endLineNumber) && !(l === g.startLineNumber && g.startColumn === d && g.isEmpty() && p && p.length > 0 && p.charAt(0) === `
` || l === g.startLineNumber && g.startColumn === 1 && g.isEmpty() && p && p.length > 0 && p.charAt(p.length - 1) === `
`)) {
            h = !1;
            break;
          }
        }
        if (h) {
          const c = new D(l, 1, l, d);
          e.push(new aD(null, c, null, !1, !1, !1));
        }
      }
      this._trimAutoWhitespaceLines = null;
    }
    return this._initialUndoRedoSnapshot === null && (this._initialUndoRedoSnapshot = this._undoRedoService.createSnapshot(this.uri)), this._commandManager.pushEditOperation(i, e, t, n);
  }
  _applyUndo(i, e, t, n) {
    const s = i.map((o) => {
      const r = this.getPositionAt(o.newPosition), a = this.getPositionAt(o.newEnd);
      return { range: new D(r.lineNumber, r.column, a.lineNumber, a.column), text: o.oldText };
    });
    this._applyUndoRedoEdits(s, e, !0, !1, t, n);
  }
  _applyRedo(i, e, t, n) {
    const s = i.map((o) => {
      const r = this.getPositionAt(o.oldPosition), a = this.getPositionAt(o.oldEnd);
      return { range: new D(r.lineNumber, r.column, a.lineNumber, a.column), text: o.newText };
    });
    this._applyUndoRedoEdits(s, e, !1, !0, t, n);
  }
  _applyUndoRedoEdits(i, e, t, n, s, o) {
    try {
      this._onDidChangeDecorations.beginDeferredEmit(), this._eventEmitter.beginDeferredEmit(), this._isUndoing = t, this._isRedoing = n, this.applyEdits(i, !1), this.setEOL(e), this._overwriteAlternativeVersionId(s);
    } finally {
      this._isUndoing = !1, this._isRedoing = !1, this._eventEmitter.endDeferredEmit(o), this._onDidChangeDecorations.endDeferredEmit();
    }
  }
  applyEdits(i, e = !1) {
    try {
      this._onDidChangeDecorations.beginDeferredEmit(), this._eventEmitter.beginDeferredEmit();
      const t = this._validateEditOperations(i);
      return this._doApplyEdits(t, e);
    } finally {
      this._eventEmitter.endDeferredEmit(), this._onDidChangeDecorations.endDeferredEmit();
    }
  }
  _doApplyEdits(i, e) {
    const t = this._buffer.getLineCount(), n = this._buffer.applyEdits(i, this._options.trimAutoWhitespace, e), s = this._buffer.getLineCount(), o = n.changes;
    if (this._trimAutoWhitespaceLines = n.trimAutoWhitespaceLineNumbers, o.length !== 0) {
      for (let l = 0, d = o.length; l < d; l++) {
        const h = o[l];
        this._decorationsTree.acceptReplace(h.rangeOffset, h.rangeLength, h.text.length, h.forceMoveMarkers);
      }
      const r = [];
      this._increaseVersionId();
      let a = t;
      for (let l = 0, d = o.length; l < d; l++) {
        const h = o[l], [c] = Dc(h.text);
        this._onDidChangeDecorations.fire();
        const u = h.range.startLineNumber, g = h.range.endLineNumber, p = g - u, f = c, _ = Math.min(p, f), v = f - p, b = s - a - v + u, C = b, w = b + f, y = this._decorationsTree.getInjectedTextInInterval(this, this.getOffsetAt(new W(C, 1)), this.getOffsetAt(new W(w, this.getLineMaxColumn(w))), 0), L = va.fromDecorations(y), k = new Pd(L);
        for (let N = _; N >= 0; N--) {
          const A = u + N, B = b + N;
          k.takeFromEndWhile((O) => O.lineNumber > B);
          const T = k.takeFromEndWhile((O) => O.lineNumber === B);
          r.push(new u5(A, this.getLineContent(B), T));
        }
        if (_ < p) {
          const N = u + _;
          r.push(new tX(N + 1, g));
        }
        if (_ < f) {
          const N = new Pd(L), A = u + _, B = f - _, T = s - a - B + A + 1, O = [], H = [];
          for (let $ = 0; $ < B; $++) {
            const pe = T + $;
            H[$] = this.getLineContent(pe), N.takeWhile((me) => me.lineNumber < pe), O[$] = N.takeWhile((me) => me.lineNumber === pe);
          }
          r.push(new iX(A + 1, u + f, H, O));
        }
        a += v;
      }
      this._emitContentChangedEvent(new dm(r, this.getVersionId(), this._isUndoing, this._isRedoing), { changes: o, eol: this._buffer.getEOL(), isEolChange: !1, versionId: this.getVersionId(), isUndoing: this._isUndoing, isRedoing: this._isRedoing, isFlush: !1 });
    }
    return n.reverseEdits === null ? void 0 : n.reverseEdits;
  }
  undo() {
    return this._undoRedoService.undo(this.uri);
  }
  canUndo() {
    return this._undoRedoService.canUndo(this.uri);
  }
  redo() {
    return this._undoRedoService.redo(this.uri);
  }
  canRedo() {
    return this._undoRedoService.canRedo(this.uri);
  }
  handleBeforeFireDecorationsChangedEvent(i) {
    if (i === null || i.size === 0) return;
    const e = Array.from(i).map((t) => new u5(t, this.getLineContent(t), this._getInjectedTextInLine(t)));
    this._onDidChangeInjectedText.fire(new GB(e));
  }
  changeDecorations(i, e = 0) {
    this._assertNotDisposed();
    try {
      return this._onDidChangeDecorations.beginDeferredEmit(), this._changeDecorations(e, i);
    } finally {
      this._onDidChangeDecorations.endDeferredEmit();
    }
  }
  _changeDecorations(i, e) {
    const t = { addDecoration: (s, o) => this._deltaDecorationsImpl(i, [], [{ range: s, options: o }])[0], changeDecoration: (s, o) => {
      this._changeDecorationImpl(s, o);
    }, changeDecorationOptions: (s, o) => {
      this._changeDecorationOptionsImpl(s, W5(o));
    }, removeDecoration: (s) => {
      this._deltaDecorationsImpl(i, [s], []);
    }, deltaDecorations: (s, o) => s.length === 0 && o.length === 0 ? [] : this._deltaDecorationsImpl(i, s, o) };
    let n = null;
    try {
      n = e(t);
    } catch (s) {
      We(s);
    }
    return t.addDecoration = zf, t.changeDecoration = zf, t.changeDecorationOptions = zf, t.removeDecoration = zf, t.deltaDecorations = zf, n;
  }
  deltaDecorations(i, e, t = 0) {
    if (this._assertNotDisposed(), i || (i = []), i.length === 0 && e.length === 0) return [];
    try {
      return this._deltaDecorationCallCnt++, this._deltaDecorationCallCnt > 1 && (console.warn("Invoking deltaDecorations recursively could lead to leaking decorations."), We(new Error("Invoking deltaDecorations recursively could lead to leaking decorations."))), this._onDidChangeDecorations.beginDeferredEmit(), this._deltaDecorationsImpl(t, i, e);
    } finally {
      this._onDidChangeDecorations.endDeferredEmit(), this._deltaDecorationCallCnt--;
    }
  }
  _getTrackedRange(i) {
    return this.getDecorationRange(i);
  }
  _setTrackedRange(i, e, t) {
    const n = i ? this._decorations[i] : null;
    if (!n) return e ? this._deltaDecorationsImpl(0, [], [{ range: e, options: B5[t] }], !0)[0] : null;
    if (!e) return this._decorationsTree.delete(n), delete this._decorations[n.id], null;
    const s = this._validateRangeRelaxedNoAllocations(e), o = this._buffer.getOffsetAt(s.startLineNumber, s.startColumn), r = this._buffer.getOffsetAt(s.endLineNumber, s.endColumn);
    return this._decorationsTree.delete(n), n.reset(this.getVersionId(), o, r, s), n.setOptions(B5[t]), this._decorationsTree.insert(n), n.id;
  }
  removeAllDecorationsWithOwnerId(i) {
    if (this._isDisposed) return;
    const e = this._decorationsTree.collectNodesFromOwner(i);
    for (let t = 0, n = e.length; t < n; t++) {
      const s = e[t];
      this._decorationsTree.delete(s), delete this._decorations[s.id];
    }
  }
  getDecorationOptions(i) {
    const e = this._decorations[i];
    return e ? e.options : null;
  }
  getDecorationRange(i) {
    const e = this._decorations[i];
    return e ? this._decorationsTree.getNodeRange(this, e) : null;
  }
  getLineDecorations(i, e = 0, t = !1) {
    return i < 1 || i > this.getLineCount() ? [] : this.getLinesDecorations(i, i, e, t);
  }
  getLinesDecorations(i, e, t = 0, n = !1, s = !1) {
    const o = this.getLineCount(), r = Math.min(o, Math.max(1, i)), a = Math.min(o, Math.max(1, e)), l = this.getLineMaxColumn(a), d = new D(r, 1, a, l), h = this._getDecorationsInRange(d, t, n, s);
    return yN(h, this._decorationProvider.getDecorationsInRange(d, t, n)), h;
  }
  getDecorationsInRange(i, e = 0, t = !1, n = !1, s = !1) {
    const o = this.validateRange(i), r = this._getDecorationsInRange(o, e, t, s);
    return yN(r, this._decorationProvider.getDecorationsInRange(o, e, t, n)), r;
  }
  getOverviewRulerDecorations(i = 0, e = !1) {
    return this._decorationsTree.getAll(this, i, e, !0, !1);
  }
  getInjectedTextDecorations(i = 0) {
    return this._decorationsTree.getAllInjectedText(this, i);
  }
  _getInjectedTextInLine(i) {
    const e = this._buffer.getOffsetAt(i, 1), t = e + this._buffer.getLineLength(i), n = this._decorationsTree.getInjectedTextInInterval(this, e, t, 0);
    return va.fromDecorations(n).filter((s) => s.lineNumber === i);
  }
  getAllDecorations(i = 0, e = !1) {
    let t = this._decorationsTree.getAll(this, i, e, !1, !1);
    return t = t.concat(this._decorationProvider.getAllDecorations(i, e)), t;
  }
  getAllMarginDecorations(i = 0) {
    return this._decorationsTree.getAll(this, i, !1, !1, !0);
  }
  _getDecorationsInRange(i, e, t, n) {
    const s = this._buffer.getOffsetAt(i.startLineNumber, i.startColumn), o = this._buffer.getOffsetAt(i.endLineNumber, i.endColumn);
    return this._decorationsTree.getAllInInterval(this, s, o, e, t, n);
  }
  getRangeAt(i, e) {
    return this._buffer.getRangeAt(i, e - i);
  }
  _changeDecorationImpl(i, e) {
    const t = this._decorations[i];
    if (!t) return;
    if (t.options.after) {
      const r = this.getDecorationRange(i);
      this._onDidChangeDecorations.recordLineAffectedByInjectedText(r.endLineNumber);
    }
    if (t.options.before) {
      const r = this.getDecorationRange(i);
      this._onDidChangeDecorations.recordLineAffectedByInjectedText(r.startLineNumber);
    }
    const n = this._validateRangeRelaxedNoAllocations(e), s = this._buffer.getOffsetAt(n.startLineNumber, n.startColumn), o = this._buffer.getOffsetAt(n.endLineNumber, n.endColumn);
    this._decorationsTree.delete(t), t.reset(this.getVersionId(), s, o, n), this._decorationsTree.insert(t), this._onDidChangeDecorations.checkAffectedAndFire(t.options), t.options.after && this._onDidChangeDecorations.recordLineAffectedByInjectedText(n.endLineNumber), t.options.before && this._onDidChangeDecorations.recordLineAffectedByInjectedText(n.startLineNumber);
  }
  _changeDecorationOptionsImpl(i, e) {
    const t = this._decorations[i];
    if (!t) return;
    const n = !(!t.options.overviewRuler || !t.options.overviewRuler.color), s = !(!e.overviewRuler || !e.overviewRuler.color);
    if (this._onDidChangeDecorations.checkAffectedAndFire(t.options), this._onDidChangeDecorations.checkAffectedAndFire(e), t.options.after || e.after) {
      const a = this._decorationsTree.getNodeRange(this, t);
      this._onDidChangeDecorations.recordLineAffectedByInjectedText(a.endLineNumber);
    }
    if (t.options.before || e.before) {
      const a = this._decorationsTree.getNodeRange(this, t);
      this._onDidChangeDecorations.recordLineAffectedByInjectedText(a.startLineNumber);
    }
    const o = n !== s, r = function(a) {
      return !!a.after || !!a.before;
    }(e) !== KC(t);
    o || r ? (this._decorationsTree.delete(t), t.setOptions(e), this._decorationsTree.insert(t)) : t.setOptions(e);
  }
  _deltaDecorationsImpl(i, e, t, n = !1) {
    const s = this.getVersionId(), o = e.length;
    let r = 0;
    const a = t.length;
    let l = 0;
    this._onDidChangeDecorations.beginDeferredEmit();
    try {
      const d = new Array(a);
      for (; r < o || l < a; ) {
        let h = null;
        if (r < o) {
          do
            h = this._decorations[e[r++]];
          while (!h && r < o);
          if (h) {
            if (h.options.after) {
              const c = this._decorationsTree.getNodeRange(this, h);
              this._onDidChangeDecorations.recordLineAffectedByInjectedText(c.endLineNumber);
            }
            if (h.options.before) {
              const c = this._decorationsTree.getNodeRange(this, h);
              this._onDidChangeDecorations.recordLineAffectedByInjectedText(c.startLineNumber);
            }
            this._decorationsTree.delete(h), n || this._onDidChangeDecorations.checkAffectedAndFire(h.options);
          }
        }
        if (l < a) {
          if (!h) {
            const _ = ++this._lastDecorationId, v = `${this._instanceId};${_}`;
            h = new oW(v, 0, 0), this._decorations[v] = h;
          }
          const c = t[l], u = this._validateRangeRelaxedNoAllocations(c.range), g = W5(c.options), p = this._buffer.getOffsetAt(u.startLineNumber, u.startColumn), f = this._buffer.getOffsetAt(u.endLineNumber, u.endColumn);
          h.ownerId = i, h.reset(s, p, f, u), h.setOptions(g), h.options.after && this._onDidChangeDecorations.recordLineAffectedByInjectedText(u.endLineNumber), h.options.before && this._onDidChangeDecorations.recordLineAffectedByInjectedText(u.startLineNumber), n || this._onDidChangeDecorations.checkAffectedAndFire(g), this._decorationsTree.insert(h), d[l] = h.id, l++;
        } else h && delete this._decorations[h.id];
      }
      return d;
    } finally {
      this._onDidChangeDecorations.endDeferredEmit();
    }
  }
  getLanguageId() {
    return this.tokenization.getLanguageId();
  }
  setLanguage(i, e) {
    typeof i == "string" ? (this._languageSelectionListener.clear(), this._setLanguage(i, e)) : (this._languageSelectionListener.value = i.onDidChange(() => this._setLanguage(i.languageId, e)), this._setLanguage(i.languageId, e));
  }
  _setLanguage(i, e) {
    this.tokenization.setLanguageId(i, e), this._languageService.requestRichLanguageFeatures(i);
  }
  getLanguageIdAtPosition(i, e) {
    return this.tokenization.getLanguageIdAtPosition(i, e);
  }
  getWordAtPosition(i) {
    return this._tokenizationTextModelPart.getWordAtPosition(i);
  }
  getWordUntilPosition(i) {
    return this._tokenizationTextModelPart.getWordUntilPosition(i);
  }
  normalizePosition(i, e) {
    return i;
  }
  getLineIndentColumn(i) {
    return function(e) {
      let t = 0;
      for (const n of e) {
        if (n !== " " && n !== "	") break;
        t++;
      }
      return t;
    }(this.getLineContent(i)) + 1;
  }
};
function ID(i) {
  return !(!i.options.overviewRuler || !i.options.overviewRuler.color);
}
function KC(i) {
  return !!i.options.after || !!i.options.before;
}
Oa._MODEL_SYNC_LIMIT = 52428800, Oa.LARGE_FILE_SIZE_THRESHOLD = 20971520, Oa.LARGE_FILE_LINE_COUNT_THRESHOLD = 3e5, Oa.LARGE_FILE_HEAP_OPERATION_THRESHOLD = 268435456, Oa.DEFAULT_CREATION_OPTIONS = { isForSimpleWidget: !1, tabSize: Wn.tabSize, indentSize: Wn.indentSize, insertSpaces: Wn.insertSpaces, detectIndentation: !1, defaultEOL: 1, trimAutoWhitespace: Wn.trimAutoWhitespace, largeFileOptimizations: Wn.largeFileOptimizations, bracketPairColorizationOptions: Wn.bracketPairColorizationOptions }, Oa = ru = $X([ED(4, mL), ED(5, Xt), ED(6, zt)], Oa);
class F5 {
  constructor() {
    this._decorationsTree0 = new DD(), this._decorationsTree1 = new DD(), this._injectedTextDecorationsTree = new DD();
  }
  ensureAllNodesHaveRanges(e) {
    this.getAll(e, 0, !1, !1, !1);
  }
  _ensureNodesHaveRanges(e, t) {
    for (const n of t) n.range === null && (n.range = e.getRangeAt(n.cachedAbsoluteStart, n.cachedAbsoluteEnd));
    return t;
  }
  getAllInInterval(e, t, n, s, o, r) {
    const a = e.getVersionId(), l = this._intervalSearch(t, n, s, o, a, r);
    return this._ensureNodesHaveRanges(e, l);
  }
  _intervalSearch(e, t, n, s, o, r) {
    const a = this._decorationsTree0.intervalSearch(e, t, n, s, o, r), l = this._decorationsTree1.intervalSearch(e, t, n, s, o, r), d = this._injectedTextDecorationsTree.intervalSearch(e, t, n, s, o, r);
    return a.concat(l).concat(d);
  }
  getInjectedTextInInterval(e, t, n, s) {
    const o = e.getVersionId(), r = this._injectedTextDecorationsTree.intervalSearch(t, n, s, !1, o, !1);
    return this._ensureNodesHaveRanges(e, r).filter((a) => a.options.showIfCollapsed || !a.range.isEmpty());
  }
  getAllInjectedText(e, t) {
    const n = e.getVersionId(), s = this._injectedTextDecorationsTree.search(t, !1, n, !1);
    return this._ensureNodesHaveRanges(e, s).filter((o) => o.options.showIfCollapsed || !o.range.isEmpty());
  }
  getAll(e, t, n, s, o) {
    const r = e.getVersionId(), a = this._search(t, n, s, r, o);
    return this._ensureNodesHaveRanges(e, a);
  }
  _search(e, t, n, s, o) {
    if (n) return this._decorationsTree1.search(e, t, s, o);
    {
      const r = this._decorationsTree0.search(e, t, s, o), a = this._decorationsTree1.search(e, t, s, o), l = this._injectedTextDecorationsTree.search(e, t, s, o);
      return r.concat(a).concat(l);
    }
  }
  collectNodesFromOwner(e) {
    const t = this._decorationsTree0.collectNodesFromOwner(e), n = this._decorationsTree1.collectNodesFromOwner(e), s = this._injectedTextDecorationsTree.collectNodesFromOwner(e);
    return t.concat(n).concat(s);
  }
  collectNodesPostOrder() {
    const e = this._decorationsTree0.collectNodesPostOrder(), t = this._decorationsTree1.collectNodesPostOrder(), n = this._injectedTextDecorationsTree.collectNodesPostOrder();
    return e.concat(t).concat(n);
  }
  insert(e) {
    KC(e) ? this._injectedTextDecorationsTree.insert(e) : ID(e) ? this._decorationsTree1.insert(e) : this._decorationsTree0.insert(e);
  }
  delete(e) {
    KC(e) ? this._injectedTextDecorationsTree.delete(e) : ID(e) ? this._decorationsTree1.delete(e) : this._decorationsTree0.delete(e);
  }
  getNodeRange(e, t) {
    const n = e.getVersionId();
    return t.cachedVersionId !== n && this._resolveNode(t, n), t.range === null && (t.range = e.getRangeAt(t.cachedAbsoluteStart, t.cachedAbsoluteEnd)), t.range;
  }
  _resolveNode(e, t) {
    KC(e) ? this._injectedTextDecorationsTree.resolveNode(e, t) : ID(e) ? this._decorationsTree1.resolveNode(e, t) : this._decorationsTree0.resolveNode(e, t);
  }
  acceptReplace(e, t, n, s) {
    this._decorationsTree0.acceptReplace(e, t, n, s), this._decorationsTree1.acceptReplace(e, t, n, s), this._injectedTextDecorationsTree.acceptReplace(e, t, n, s);
  }
}
function Da(i) {
  return i.replace(/[^a-z0-9\-_]/gi, " ");
}
class hW {
  constructor(e) {
    this.color = e.color || "", this.darkColor = e.darkColor || "";
  }
}
class ZX extends hW {
  constructor(e) {
    super(e), this._resolvedColor = null, this.position = typeof e.position == "number" ? e.position : Do.Center;
  }
  getColor(e) {
    return this._resolvedColor || (e.type !== "light" && this.darkColor ? this._resolvedColor = this._resolveColor(this.darkColor, e) : this._resolvedColor = this._resolveColor(this.color, e)), this._resolvedColor;
  }
  invalidateCachedColor() {
    this._resolvedColor = null;
  }
  _resolveColor(e, t) {
    if (typeof e == "string") return e;
    const n = e ? t.getColor(e.id) : null;
    return n ? n.toString() : "";
  }
}
class YX {
  constructor(e) {
    var t;
    this.position = (t = e == null ? void 0 : e.position) !== null && t !== void 0 ? t : _l.Center, this.persistLane = e == null ? void 0 : e.persistLane;
  }
}
class XX extends hW {
  constructor(e) {
    var t, n;
    super(e), this.position = e.position, this.sectionHeaderStyle = (t = e.sectionHeaderStyle) !== null && t !== void 0 ? t : null, this.sectionHeaderText = (n = e.sectionHeaderText) !== null && n !== void 0 ? n : null;
  }
  getColor(e) {
    return this._resolvedColor || (e.type !== "light" && this.darkColor ? this._resolvedColor = this._resolveColor(this.darkColor, e) : this._resolvedColor = this._resolveColor(this.color, e)), this._resolvedColor;
  }
  invalidateCachedColor() {
    this._resolvedColor = void 0;
  }
  _resolveColor(e, t) {
    return typeof e == "string" ? z.fromHex(e) : t.getColor(e.id);
  }
}
class Nc {
  static from(e) {
    return e instanceof Nc ? e : new Nc(e);
  }
  constructor(e) {
    this.content = e.content || "", this.inlineClassName = e.inlineClassName || null, this.inlineClassNameAffectsLetterSpacing = e.inlineClassNameAffectsLetterSpacing || !1, this.attachedData = e.attachedData || null, this.cursorStops = e.cursorStops || null;
  }
}
class Ve {
  static register(e) {
    return new Ve(e);
  }
  static createDynamic(e) {
    return new Ve(e);
  }
  constructor(e) {
    var t, n, s, o, r, a;
    this.description = e.description, this.blockClassName = e.blockClassName ? Da(e.blockClassName) : null, this.blockDoesNotCollapse = (t = e.blockDoesNotCollapse) !== null && t !== void 0 ? t : null, this.blockIsAfterEnd = (n = e.blockIsAfterEnd) !== null && n !== void 0 ? n : null, this.blockPadding = (s = e.blockPadding) !== null && s !== void 0 ? s : null, this.stickiness = e.stickiness || 0, this.zIndex = e.zIndex || 0, this.className = e.className ? Da(e.className) : null, this.shouldFillLineOnLineBreak = (o = e.shouldFillLineOnLineBreak) !== null && o !== void 0 ? o : null, this.hoverMessage = e.hoverMessage || null, this.glyphMarginHoverMessage = e.glyphMarginHoverMessage || null, this.lineNumberHoverMessage = e.lineNumberHoverMessage || null, this.isWholeLine = e.isWholeLine || !1, this.showIfCollapsed = e.showIfCollapsed || !1, this.collapseOnReplaceEdit = e.collapseOnReplaceEdit || !1, this.overviewRuler = e.overviewRuler ? new ZX(e.overviewRuler) : null, this.minimap = e.minimap ? new XX(e.minimap) : null, this.glyphMargin = e.glyphMarginClassName ? new YX(e.glyphMargin) : null, this.glyphMarginClassName = e.glyphMarginClassName ? Da(e.glyphMarginClassName) : null, this.linesDecorationsClassName = e.linesDecorationsClassName ? Da(e.linesDecorationsClassName) : null, this.lineNumberClassName = e.lineNumberClassName ? Da(e.lineNumberClassName) : null, this.linesDecorationsTooltip = e.linesDecorationsTooltip ? e.linesDecorationsTooltip.replace(/[<>"'&]/g, (l) => {
      switch (l) {
        case "<":
          return "&lt;";
        case ">":
          return "&gt;";
        case '"':
          return "&quot;";
        case "'":
          return "&apos;";
        case "&":
          return "&amp;";
      }
      return l;
    }) : null, this.firstLineDecorationClassName = e.firstLineDecorationClassName ? Da(e.firstLineDecorationClassName) : null, this.marginClassName = e.marginClassName ? Da(e.marginClassName) : null, this.inlineClassName = e.inlineClassName ? Da(e.inlineClassName) : null, this.inlineClassNameAffectsLetterSpacing = e.inlineClassNameAffectsLetterSpacing || !1, this.beforeContentClassName = e.beforeContentClassName ? Da(e.beforeContentClassName) : null, this.afterContentClassName = e.afterContentClassName ? Da(e.afterContentClassName) : null, this.after = e.after ? Nc.from(e.after) : null, this.before = e.before ? Nc.from(e.before) : null, this.hideInCommentTokens = (r = e.hideInCommentTokens) !== null && r !== void 0 && r, this.hideInStringTokens = (a = e.hideInStringTokens) !== null && a !== void 0 && a;
  }
}
Ve.EMPTY = Ve.register({ description: "empty" });
const B5 = [Ve.register({ description: "tracked-range-always-grows-when-typing-at-edges", stickiness: 0 }), Ve.register({ description: "tracked-range-never-grows-when-typing-at-edges", stickiness: 1 }), Ve.register({ description: "tracked-range-grows-only-when-typing-before", stickiness: 2 }), Ve.register({ description: "tracked-range-grows-only-when-typing-after", stickiness: 3 })];
function W5(i) {
  return i instanceof Ve ? i : Ve.createDynamic(i);
}
class QX extends V {
  constructor(e) {
    super(), this.handleBeforeFire = e, this._actual = this._register(new F()), this.event = this._actual.event, this._affectedInjectedTextLines = null, this._deferredCnt = 0, this._shouldFireDeferred = !1, this._affectsMinimap = !1, this._affectsOverviewRuler = !1, this._affectsGlyphMargin = !1, this._affectsLineNumber = !1;
  }
  beginDeferredEmit() {
    this._deferredCnt++;
  }
  endDeferredEmit() {
    var e;
    this._deferredCnt--, this._deferredCnt === 0 && (this._shouldFireDeferred && this.doFire(), (e = this._affectedInjectedTextLines) === null || e === void 0 || e.clear(), this._affectedInjectedTextLines = null);
  }
  recordLineAffectedByInjectedText(e) {
    this._affectedInjectedTextLines || (this._affectedInjectedTextLines = /* @__PURE__ */ new Set()), this._affectedInjectedTextLines.add(e);
  }
  checkAffectedAndFire(e) {
    var t, n;
    this._affectsMinimap || (this._affectsMinimap = !!(!((t = e.minimap) === null || t === void 0) && t.position)), this._affectsOverviewRuler || (this._affectsOverviewRuler = !!(!((n = e.overviewRuler) === null || n === void 0) && n.color)), this._affectsGlyphMargin || (this._affectsGlyphMargin = !!e.glyphMarginClassName), this._affectsLineNumber || (this._affectsLineNumber = !!e.lineNumberClassName), this.tryFire();
  }
  fire() {
    this._affectsMinimap = !0, this._affectsOverviewRuler = !0, this._affectsGlyphMargin = !0, this.tryFire();
  }
  tryFire() {
    this._deferredCnt === 0 ? this.doFire() : this._shouldFireDeferred = !0;
  }
  doFire() {
    this.handleBeforeFire(this._affectedInjectedTextLines);
    const e = { affectsMinimap: this._affectsMinimap, affectsOverviewRuler: this._affectsOverviewRuler, affectsGlyphMargin: this._affectsGlyphMargin, affectsLineNumber: this._affectsLineNumber };
    this._shouldFireDeferred = !1, this._affectsMinimap = !1, this._affectsOverviewRuler = !1, this._affectsGlyphMargin = !1, this._actual.fire(e);
  }
}
class JX extends V {
  constructor() {
    super(), this._fastEmitter = this._register(new F()), this.fastEvent = this._fastEmitter.event, this._slowEmitter = this._register(new F()), this.slowEvent = this._slowEmitter.event, this._deferredCnt = 0, this._deferredEvent = null;
  }
  beginDeferredEmit() {
    this._deferredCnt++;
  }
  endDeferredEmit(e = null) {
    if (this._deferredCnt--, this._deferredCnt === 0 && this._deferredEvent !== null) {
      this._deferredEvent.rawContentChangedEvent.resultingSelection = e;
      const t = this._deferredEvent;
      this._deferredEvent = null, this._fastEmitter.fire(t), this._slowEmitter.fire(t);
    }
  }
  fire(e) {
    this._deferredCnt > 0 ? this._deferredEvent ? this._deferredEvent = this._deferredEvent.merge(e) : this._deferredEvent = e : (this._fastEmitter.fire(e), this._slowEmitter.fire(e));
  }
}
class eQ {
  constructor() {
    this._onDidChangeVisibleRanges = new F(), this.onDidChangeVisibleRanges = this._onDidChangeVisibleRanges.event, this._views = /* @__PURE__ */ new Set();
  }
  attachView() {
    const e = new tQ((t) => {
      this._onDidChangeVisibleRanges.fire({ view: e, state: t });
    });
    return this._views.add(e), e;
  }
  detachView(e) {
    this._views.delete(e), this._onDidChangeVisibleRanges.fire({ view: e, state: void 0 });
  }
}
class tQ {
  constructor(e) {
    this.handleStateChange = e;
  }
  setVisibleLines(e, t) {
    const n = e.map((s) => new je(s.startLineNumber, s.endLineNumber + 1));
    this.handleStateChange({ visibleLineRanges: n, stabilized: t });
  }
}
class sA {
  static create(e) {
    return new sA(e.get(134), e.get(133));
  }
  constructor(e, t) {
    this.classifier = new iQ(e, t);
  }
  createLineBreaksComputer(e, t, n, s, o) {
    const r = [], a = [], l = [];
    return { addRequest: (d, h, c) => {
      r.push(d), a.push(h), l.push(c);
    }, finalize: () => {
      const d = e.typicalFullwidthCharacterWidth / e.typicalHalfwidthCharacterWidth, h = [];
      for (let c = 0, u = r.length; c < u; c++) {
        const g = a[c], p = l[c];
        !p || p.injectionOptions || g ? h[c] = sQ(this.classifier, r[c], g, t, n, d, s, o) : h[c] = nQ(this.classifier, p, r[c], t, n, d, s, o);
      }
      return _I.length = 0, vI.length = 0, h;
    } };
  }
}
class iQ extends _f {
  constructor(e, t) {
    super(0);
    for (let n = 0; n < e.length; n++) this.set(e.charCodeAt(n), 1);
    for (let n = 0; n < t.length; n++) this.set(t.charCodeAt(n), 2);
  }
  get(e) {
    return e >= 0 && e < 256 ? this._asciiMap[e] : e >= 12352 && e <= 12543 || e >= 13312 && e <= 19903 || e >= 19968 && e <= 40959 ? 3 : this._map.get(e) || this._defaultValue;
  }
}
let _I = [], vI = [];
function nQ(i, e, t, n, s, o, r, a) {
  if (s === -1) return null;
  const l = t.length;
  if (l <= 1) return null;
  const d = a === "keepAll", h = e.breakOffsets, c = e.breakOffsetsVisibleColumn, u = cW(t, n, s, o, r), g = s - u, p = _I, f = vI;
  let _ = 0, v = 0, b = 0, C = s;
  const w = h.length;
  let y = 0;
  if (y >= 0) {
    let L = Math.abs(c[y] - C);
    for (; y + 1 < w; ) {
      const k = Math.abs(c[y + 1] - C);
      if (k >= L) break;
      L = k, y++;
    }
  }
  for (; y < w; ) {
    let L = y < 0 ? 0 : h[y], k = y < 0 ? 0 : c[y];
    v > L && (L = v, k = b);
    let N = 0, A = 0, B = 0, T = 0;
    if (k <= C) {
      let H = k, $ = L === 0 ? 0 : t.charCodeAt(L - 1), pe = L === 0 ? 0 : i.get($), me = !0;
      for (let ue = L; ue < l; ue++) {
        const ee = ue, te = t.charCodeAt(ue);
        let be, we;
        if (en(te) ? (ue++, be = 0, we = 2) : (be = i.get(te), we = u0(te, H, n, o)), ee > v && bI($, pe, te, be, d) && (N = ee, A = H), H += we, H > C) {
          ee > v ? (B = ee, T = H - we) : (B = ue + 1, T = H), H - A > g && (N = 0), me = !1;
          break;
        }
        $ = te, pe = be;
      }
      if (me) {
        _ > 0 && (p[_] = h[h.length - 1], f[_] = c[h.length - 1], _++);
        break;
      }
    }
    if (N === 0) {
      let H = k, $ = t.charCodeAt(L), pe = i.get($), me = !1;
      for (let ue = L - 1; ue >= v; ue--) {
        const ee = ue + 1, te = t.charCodeAt(ue);
        if (te === 9) {
          me = !0;
          break;
        }
        let be, we;
        if (ag(te) ? (ue--, be = 0, we = 2) : (be = i.get(te), we = _c(te) ? o : 1), H <= C) {
          if (B === 0 && (B = ee, T = H), H <= C - g) break;
          if (bI(te, be, $, pe, d)) {
            N = ee, A = H;
            break;
          }
        }
        H -= we, $ = te, pe = be;
      }
      if (N !== 0) {
        const ue = g - (T - A);
        if (ue <= n) {
          const ee = t.charCodeAt(B);
          let te;
          te = en(ee) ? 2 : u0(ee, T, n, o), ue - te < 0 && (N = 0);
        }
      }
      if (me) {
        y--;
        continue;
      }
    }
    if (N === 0 && (N = B, A = T), N <= v) {
      const H = t.charCodeAt(v);
      en(H) ? (N = v + 2, A = b + 2) : (N = v + 1, A = b + u0(H, b, n, o));
    }
    for (v = N, p[_] = N, b = A, f[_] = A, _++, C = A + g; y < 0 || y < w && c[y] < A; ) y++;
    let O = Math.abs(c[y] - C);
    for (; y + 1 < w; ) {
      const H = Math.abs(c[y + 1] - C);
      if (H >= O) break;
      O = H, y++;
    }
  }
  return _ === 0 ? null : (p.length = _, f.length = _, _I = e.breakOffsets, vI = e.breakOffsetsVisibleColumn, e.breakOffsets = p, e.breakOffsetsVisibleColumn = f, e.wrappedTextIndentLength = u, e);
}
function sQ(i, e, t, n, s, o, r, a) {
  const l = va.applyInjectedText(e, t);
  let d, h;
  if (t && t.length > 0 ? (d = t.map((A) => A.options), h = t.map((A) => A.column - 1)) : (d = null, h = null), s === -1) return d ? new a0(h, d, [l.length], [], 0) : null;
  const c = l.length;
  if (c <= 1) return d ? new a0(h, d, [l.length], [], 0) : null;
  const u = a === "keepAll", g = cW(l, n, s, o, r), p = s - g, f = [], _ = [];
  let v = 0, b = 0, C = 0, w = s, y = l.charCodeAt(0), L = i.get(y), k = u0(y, 0, n, o), N = 1;
  en(y) && (k += 1, y = l.charCodeAt(1), L = i.get(y), N++);
  for (let A = N; A < c; A++) {
    const B = A, T = l.charCodeAt(A);
    let O, H;
    en(T) ? (A++, O = 0, H = 2) : (O = i.get(T), H = u0(T, k, n, o)), bI(y, L, T, O, u) && (b = B, C = k), k += H, k > w && ((b === 0 || k - C > p) && (b = B, C = k - H), f[v] = b, _[v] = C, v++, w = C + p, b = 0), y = T, L = O;
  }
  return v !== 0 || t && t.length !== 0 ? (f[v] = c, _[v] = k, new a0(h, d, f, _, g)) : null;
}
function u0(i, e, t, n) {
  return i === 9 ? t - e % t : _c(i) || i < 32 ? n : 1;
}
function V5(i, e) {
  return e - i % e;
}
function bI(i, e, t, n, s) {
  return t !== 32 && (e === 2 && n !== 2 || e !== 1 && n === 1 || !s && e === 3 && n !== 2 || !s && n === 3 && e !== 1);
}
function cW(i, e, t, n, s) {
  let o = 0;
  if (s !== 0) {
    const r = Jn(i);
    if (r !== -1) {
      for (let l = 0; l < r; l++)
        o += i.charCodeAt(l) === 9 ? V5(o, e) : 1;
      const a = s === 3 ? 2 : s === 2 ? 1 : 0;
      for (let l = 0; l < a; l++)
        o += V5(o, e);
      o + n > t && (o = 0);
    }
  }
  return o;
}
class Cy {
  constructor(e) {
    this._selTrackedRange = null, this._trackSelection = !0, this._setState(e, new bn(new D(1, 1, 1, 1), 0, 0, new W(1, 1), 0), new bn(new D(1, 1, 1, 1), 0, 0, new W(1, 1), 0));
  }
  dispose(e) {
    this._removeTrackedRange(e);
  }
  startTrackingSelection(e) {
    this._trackSelection = !0, this._updateTrackedRange(e);
  }
  stopTrackingSelection(e) {
    this._trackSelection = !1, this._removeTrackedRange(e);
  }
  _updateTrackedRange(e) {
    this._trackSelection && (this._selTrackedRange = e.model._setTrackedRange(this._selTrackedRange, this.modelState.selection, 0));
  }
  _removeTrackedRange(e) {
    this._selTrackedRange = e.model._setTrackedRange(this._selTrackedRange, null, 0);
  }
  asCursorState() {
    return new pt(this.modelState, this.viewState);
  }
  readSelectionFromMarkers(e) {
    const t = e.model._getTrackedRange(this._selTrackedRange);
    return this.modelState.selection.isEmpty() && !t.isEmpty() ? _e.fromRange(t.collapseToEnd(), this.modelState.selection.getDirection()) : _e.fromRange(t, this.modelState.selection.getDirection());
  }
  ensureValidState(e) {
    this._setState(e, this.modelState, this.viewState);
  }
  setState(e, t, n) {
    this._setState(e, t, n);
  }
  static _validatePositionWithCache(e, t, n, s) {
    return t.equals(n) ? s : e.normalizePosition(t, 2);
  }
  static _validateViewState(e, t) {
    const n = t.position, s = t.selectionStart.getStartPosition(), o = t.selectionStart.getEndPosition(), r = e.normalizePosition(n, 2), a = this._validatePositionWithCache(e, s, n, r), l = this._validatePositionWithCache(e, o, s, a);
    return n.equals(r) && s.equals(a) && o.equals(l) ? t : new bn(D.fromPositions(a, l), t.selectionStartKind, t.selectionStartLeftoverVisibleColumns + s.column - a.column, r, t.leftoverVisibleColumns + n.column - r.column);
  }
  _setState(e, t, n) {
    if (n && (n = Cy._validateViewState(e.viewModel, n)), t) {
      const s = e.model.validateRange(t.selectionStart), o = t.selectionStart.equalsRange(s) ? t.selectionStartLeftoverVisibleColumns : 0, r = e.model.validatePosition(t.position), a = t.position.equals(r) ? t.leftoverVisibleColumns : 0;
      t = new bn(s, t.selectionStartKind, o, r, a);
    } else {
      if (!n) return;
      const s = e.model.validateRange(e.coordinatesConverter.convertViewRangeToModelRange(n.selectionStart)), o = e.model.validatePosition(e.coordinatesConverter.convertViewPositionToModelPosition(n.position));
      t = new bn(s, n.selectionStartKind, n.selectionStartLeftoverVisibleColumns, o, n.leftoverVisibleColumns);
    }
    if (n) {
      const s = e.coordinatesConverter.validateViewRange(n.selectionStart, t.selectionStart), o = e.coordinatesConverter.validateViewPosition(n.position, t.position);
      n = new bn(s, t.selectionStartKind, t.selectionStartLeftoverVisibleColumns, o, t.leftoverVisibleColumns);
    } else {
      const s = e.coordinatesConverter.convertModelPositionToViewPosition(new W(t.selectionStart.startLineNumber, t.selectionStart.startColumn)), o = e.coordinatesConverter.convertModelPositionToViewPosition(new W(t.selectionStart.endLineNumber, t.selectionStart.endColumn)), r = new D(s.lineNumber, s.column, o.lineNumber, o.column), a = e.coordinatesConverter.convertModelPositionToViewPosition(t.position);
      n = new bn(r, t.selectionStartKind, t.selectionStartLeftoverVisibleColumns, a, t.leftoverVisibleColumns);
    }
    this.modelState = t, this.viewState = n, this._updateTrackedRange(e);
  }
}
class H5 {
  constructor(e) {
    this.context = e, this.cursors = [new Cy(e)], this.lastAddedCursorIndex = 0;
  }
  dispose() {
    for (const e of this.cursors) e.dispose(this.context);
  }
  startTrackingSelections() {
    for (const e of this.cursors) e.startTrackingSelection(this.context);
  }
  stopTrackingSelections() {
    for (const e of this.cursors) e.stopTrackingSelection(this.context);
  }
  updateContext(e) {
    this.context = e;
  }
  ensureValidState() {
    for (const e of this.cursors) e.ensureValidState(this.context);
  }
  readSelectionFromMarkers() {
    return this.cursors.map((e) => e.readSelectionFromMarkers(this.context));
  }
  getAll() {
    return this.cursors.map((e) => e.asCursorState());
  }
  getViewPositions() {
    return this.cursors.map((e) => e.viewState.position);
  }
  getTopMostViewPosition() {
    return function(e, t) {
      return DR(e, (n, s) => -t(n, s));
    }(this.cursors, jo((e) => e.viewState.position, W.compare)).viewState.position;
  }
  getBottomMostViewPosition() {
    return function(e, t) {
      if (e.length === 0) return;
      let n = e[0];
      for (let s = 1; s < e.length; s++) {
        const o = e[s];
        t(o, n) >= 0 && (n = o);
      }
      return n;
    }(this.cursors, jo((e) => e.viewState.position, W.compare)).viewState.position;
  }
  getSelections() {
    return this.cursors.map((e) => e.modelState.selection);
  }
  getViewSelections() {
    return this.cursors.map((e) => e.viewState.selection);
  }
  setSelections(e) {
    this.setStates(pt.fromModelSelections(e));
  }
  getPrimaryCursor() {
    return this.cursors[0].asCursorState();
  }
  setStates(e) {
    e !== null && (this.cursors[0].setState(this.context, e[0].modelState, e[0].viewState), this._setSecondaryStates(e.slice(1)));
  }
  _setSecondaryStates(e) {
    const t = this.cursors.length - 1, n = e.length;
    if (t < n) {
      const s = n - t;
      for (let o = 0; o < s; o++) this._addSecondaryCursor();
    } else if (t > n) {
      const s = t - n;
      for (let o = 0; o < s; o++) this._removeSecondaryCursor(this.cursors.length - 2);
    }
    for (let s = 0; s < n; s++) this.cursors[s + 1].setState(this.context, e[s].modelState, e[s].viewState);
  }
  killSecondaryCursors() {
    this._setSecondaryStates([]);
  }
  _addSecondaryCursor() {
    this.cursors.push(new Cy(this.context)), this.lastAddedCursorIndex = this.cursors.length - 1;
  }
  getLastAddedCursorIndex() {
    return this.cursors.length === 1 || this.lastAddedCursorIndex === 0 ? 0 : this.lastAddedCursorIndex;
  }
  _removeSecondaryCursor(e) {
    this.lastAddedCursorIndex >= e + 1 && this.lastAddedCursorIndex--, this.cursors[e + 1].dispose(this.context), this.cursors.splice(e + 1, 1);
  }
  normalize() {
    if (this.cursors.length === 1) return;
    const e = this.cursors.slice(0), t = [];
    for (let n = 0, s = e.length; n < s; n++) t.push({ index: n, selection: e[n].modelState.selection });
    t.sort(jo((n) => n.selection, D.compareRangesUsingStarts));
    for (let n = 0; n < t.length - 1; n++) {
      const s = t[n], o = t[n + 1], r = s.selection, a = o.selection;
      if (!this.context.cursorConfig.multiCursorMergeOverlapping) continue;
      let l;
      if (l = a.isEmpty() || r.isEmpty() ? a.getStartPosition().isBeforeOrEqual(r.getEndPosition()) : a.getStartPosition().isBefore(r.getEndPosition()), l) {
        const d = s.index < o.index ? n : n + 1, h = s.index < o.index ? n + 1 : n, c = t[h].index, u = t[d].index, g = t[h].selection, p = t[d].selection;
        if (!g.equalsSelection(p)) {
          const f = g.plusRange(p), _ = g.selectionStartLineNumber === g.startLineNumber && g.selectionStartColumn === g.startColumn, v = p.selectionStartLineNumber === p.startLineNumber && p.selectionStartColumn === p.startColumn;
          let b, C;
          c === this.lastAddedCursorIndex ? (b = _, this.lastAddedCursorIndex = u) : b = v, C = b ? new _e(f.startLineNumber, f.startColumn, f.endLineNumber, f.endColumn) : new _e(f.endLineNumber, f.endColumn, f.startLineNumber, f.startColumn), t[d].selection = C;
          const w = pt.fromModelSelection(C);
          e[u].setState(this.context, w.modelState, w.viewState);
        }
        for (const f of t) f.index > c && f.index--;
        e.splice(c, 1), t.splice(h, 1), this._removeSecondaryCursor(c - 1), n--;
      }
    }
  }
}
class z5 {
  constructor(e, t, n, s) {
    this._cursorContextBrand = void 0, this.model = e, this.viewModel = t, this.coordinatesConverter = n, this.cursorConfig = s;
  }
}
class oQ {
  constructor() {
    this.type = 0;
  }
}
class rQ {
  constructor() {
    this.type = 1;
  }
}
class aQ {
  constructor(e) {
    this.type = 2, this._source = e;
  }
  hasChanged(e) {
    return this._source.hasChanged(e);
  }
}
class lQ {
  constructor(e, t, n) {
    this.selections = e, this.modelSelections = t, this.reason = n, this.type = 3;
  }
}
class Kc {
  constructor(e) {
    this.type = 4, e ? (this.affectsMinimap = e.affectsMinimap, this.affectsOverviewRuler = e.affectsOverviewRuler, this.affectsGlyphMargin = e.affectsGlyphMargin, this.affectsLineNumber = e.affectsLineNumber) : (this.affectsMinimap = !0, this.affectsOverviewRuler = !0, this.affectsGlyphMargin = !0, this.affectsLineNumber = !0);
  }
}
class kb {
  constructor() {
    this.type = 5;
  }
}
class dQ {
  constructor(e) {
    this.type = 6, this.isFocused = e;
  }
}
class hQ {
  constructor() {
    this.type = 7;
  }
}
class Db {
  constructor() {
    this.type = 8;
  }
}
class uW {
  constructor(e, t) {
    this.fromLineNumber = e, this.count = t, this.type = 9;
  }
}
class CI {
  constructor(e, t) {
    this.type = 10, this.fromLineNumber = e, this.toLineNumber = t;
  }
}
class wI {
  constructor(e, t) {
    this.type = 11, this.fromLineNumber = e, this.toLineNumber = t;
  }
}
class g0 {
  constructor(e, t, n, s, o, r, a) {
    this.source = e, this.minimalReveal = t, this.range = n, this.selections = s, this.verticalType = o, this.revealHorizontal = r, this.scrollType = a, this.type = 12;
  }
}
class cQ {
  constructor(e) {
    this.type = 13, this.scrollWidth = e.scrollWidth, this.scrollLeft = e.scrollLeft, this.scrollHeight = e.scrollHeight, this.scrollTop = e.scrollTop, this.scrollWidthChanged = e.scrollWidthChanged, this.scrollLeftChanged = e.scrollLeftChanged, this.scrollHeightChanged = e.scrollHeightChanged, this.scrollTopChanged = e.scrollTopChanged;
  }
}
class uQ {
  constructor(e) {
    this.theme = e, this.type = 14;
  }
}
class gQ {
  constructor(e) {
    this.type = 15, this.ranges = e;
  }
}
class pQ {
  constructor() {
    this.type = 16;
  }
}
let mQ = class {
  constructor() {
    this.type = 17;
  }
};
class fQ extends V {
  constructor() {
    super(), this._onEvent = this._register(new F()), this.onEvent = this._onEvent.event, this._eventHandlers = [], this._viewEventQueue = null, this._isConsumingViewEventQueue = !1, this._collector = null, this._collectorCnt = 0, this._outgoingEvents = [];
  }
  emitOutgoingEvent(e) {
    this._addOutgoingEvent(e), this._emitOutgoingEvents();
  }
  _addOutgoingEvent(e) {
    for (let t = 0, n = this._outgoingEvents.length; t < n; t++) {
      const s = this._outgoingEvents[t].kind === e.kind ? this._outgoingEvents[t].attemptToMerge(e) : null;
      if (s) return void (this._outgoingEvents[t] = s);
    }
    this._outgoingEvents.push(e);
  }
  _emitOutgoingEvents() {
    for (; this._outgoingEvents.length > 0; ) {
      if (this._collector || this._isConsumingViewEventQueue) return;
      const e = this._outgoingEvents.shift();
      e.isNoOp() || this._onEvent.fire(e);
    }
  }
  addViewEventHandler(e) {
    for (let t = 0, n = this._eventHandlers.length; t < n; t++) this._eventHandlers[t] === e && console.warn("Detected duplicate listener in ViewEventDispatcher", e);
    this._eventHandlers.push(e);
  }
  removeViewEventHandler(e) {
    for (let t = 0; t < this._eventHandlers.length; t++) if (this._eventHandlers[t] === e) {
      this._eventHandlers.splice(t, 1);
      break;
    }
  }
  beginEmitViewEvents() {
    return this._collectorCnt++, this._collectorCnt === 1 && (this._collector = new _Q()), this._collector;
  }
  endEmitViewEvents() {
    if (this._collectorCnt--, this._collectorCnt === 0) {
      const e = this._collector.outgoingEvents, t = this._collector.viewEvents;
      this._collector = null;
      for (const n of e) this._addOutgoingEvent(n);
      t.length > 0 && this._emitMany(t);
    }
    this._emitOutgoingEvents();
  }
  emitSingleViewEvent(e) {
    try {
      this.beginEmitViewEvents().emitViewEvent(e);
    } finally {
      this.endEmitViewEvents();
    }
  }
  _emitMany(e) {
    this._viewEventQueue ? this._viewEventQueue = this._viewEventQueue.concat(e) : this._viewEventQueue = e, this._isConsumingViewEventQueue || this._consumeViewEventQueue();
  }
  _consumeViewEventQueue() {
    try {
      this._isConsumingViewEventQueue = !0, this._doConsumeQueue();
    } finally {
      this._isConsumingViewEventQueue = !1;
    }
  }
  _doConsumeQueue() {
    for (; this._viewEventQueue; ) {
      const e = this._viewEventQueue;
      this._viewEventQueue = null;
      const t = this._eventHandlers.slice(0);
      for (const n of t) n.handleEvents(e);
    }
  }
}
class _Q {
  constructor() {
    this.viewEvents = [], this.outgoingEvents = [];
  }
  emitViewEvent(e) {
    this.viewEvents.push(e);
  }
  emitOutgoingEvent(e) {
    this.outgoingEvents.push(e);
  }
}
class oA {
  constructor(e, t, n, s) {
    this.kind = 0, this._oldContentWidth = e, this._oldContentHeight = t, this.contentWidth = n, this.contentHeight = s, this.contentWidthChanged = this._oldContentWidth !== this.contentWidth, this.contentHeightChanged = this._oldContentHeight !== this.contentHeight;
  }
  isNoOp() {
    return !this.contentWidthChanged && !this.contentHeightChanged;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : new oA(this._oldContentWidth, this._oldContentHeight, e.contentWidth, e.contentHeight);
  }
}
class rA {
  constructor(e, t) {
    this.kind = 1, this.oldHasFocus = e, this.hasFocus = t;
  }
  isNoOp() {
    return this.oldHasFocus === this.hasFocus;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : new rA(this.oldHasFocus, e.hasFocus);
  }
}
class aA {
  constructor(e, t, n, s, o, r, a, l) {
    this.kind = 2, this._oldScrollWidth = e, this._oldScrollLeft = t, this._oldScrollHeight = n, this._oldScrollTop = s, this.scrollWidth = o, this.scrollLeft = r, this.scrollHeight = a, this.scrollTop = l, this.scrollWidthChanged = this._oldScrollWidth !== this.scrollWidth, this.scrollLeftChanged = this._oldScrollLeft !== this.scrollLeft, this.scrollHeightChanged = this._oldScrollHeight !== this.scrollHeight, this.scrollTopChanged = this._oldScrollTop !== this.scrollTop;
  }
  isNoOp() {
    return !(this.scrollWidthChanged || this.scrollLeftChanged || this.scrollHeightChanged || this.scrollTopChanged);
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : new aA(this._oldScrollWidth, this._oldScrollLeft, this._oldScrollHeight, this._oldScrollTop, e.scrollWidth, e.scrollLeft, e.scrollHeight, e.scrollTop);
  }
}
class vQ {
  constructor() {
    this.kind = 3;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : this;
  }
}
class bQ {
  constructor() {
    this.kind = 4;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : this;
  }
}
class wy {
  constructor(e, t, n, s, o, r, a) {
    this.kind = 6, this.oldSelections = e, this.selections = t, this.oldModelVersionId = n, this.modelVersionId = s, this.source = o, this.reason = r, this.reachedMaxCursorCount = a;
  }
  static _selectionsAreEqual(e, t) {
    if (!e && !t) return !0;
    if (!e || !t) return !1;
    const n = e.length;
    if (n !== t.length) return !1;
    for (let s = 0; s < n; s++) if (!e[s].equalsSelection(t[s])) return !1;
    return !0;
  }
  isNoOp() {
    return wy._selectionsAreEqual(this.oldSelections, this.selections) && this.oldModelVersionId === this.modelVersionId;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : new wy(this.oldSelections, e.selections, this.oldModelVersionId, e.modelVersionId, e.source, e.reason, this.reachedMaxCursorCount || e.reachedMaxCursorCount);
  }
}
class CQ {
  constructor() {
    this.kind = 5;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : this;
  }
}
class wQ {
  constructor(e) {
    this.event = e, this.kind = 7;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class yQ {
  constructor(e) {
    this.event = e, this.kind = 8;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class SQ {
  constructor(e) {
    this.event = e, this.kind = 9;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class LQ {
  constructor(e) {
    this.event = e, this.kind = 10;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class kQ {
  constructor(e) {
    this.event = e, this.kind = 11;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class DQ {
  constructor(e) {
    this.event = e, this.kind = 12;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class xQ extends V {
  constructor(e, t, n, s) {
    super(), this._model = e, this._knownModelVersionId = this._model.getVersionId(), this._viewModel = t, this._coordinatesConverter = n, this.context = new z5(this._model, this._viewModel, this._coordinatesConverter, s), this._cursors = new H5(this.context), this._hasFocus = !1, this._isHandling = !1, this._compositionState = null, this._columnSelectData = null, this._autoClosedActions = [], this._prevEditOperationType = 0;
  }
  dispose() {
    this._cursors.dispose(), this._autoClosedActions = Ht(this._autoClosedActions), super.dispose();
  }
  updateConfiguration(e) {
    this.context = new z5(this._model, this._viewModel, this._coordinatesConverter, e), this._cursors.updateContext(this.context);
  }
  onLineMappingChanged(e) {
    this._knownModelVersionId === this._model.getVersionId() && this.setStates(e, "viewModel", 0, this.getCursorStates());
  }
  setHasFocus(e) {
    this._hasFocus = e;
  }
  _validateAutoClosedActions() {
    if (this._autoClosedActions.length > 0) {
      const e = this._cursors.getSelections();
      for (let t = 0; t < this._autoClosedActions.length; t++) {
        const n = this._autoClosedActions[t];
        n.isValid(e) || (n.dispose(), this._autoClosedActions.splice(t, 1), t--);
      }
    }
  }
  getPrimaryCursorState() {
    return this._cursors.getPrimaryCursor();
  }
  getLastAddedCursorIndex() {
    return this._cursors.getLastAddedCursorIndex();
  }
  getCursorStates() {
    return this._cursors.getAll();
  }
  setStates(e, t, n, s) {
    let o = !1;
    const r = this.context.cursorConfig.multiCursorLimit;
    s !== null && s.length > r && (s = s.slice(0, r), o = !0);
    const a = p0.from(this._model, this);
    return this._cursors.setStates(s), this._cursors.normalize(), this._columnSelectData = null, this._validateAutoClosedActions(), this._emitStateChangedIfNecessary(e, t, n, a, o);
  }
  setCursorColumnSelectData(e) {
    this._columnSelectData = e;
  }
  revealAll(e, t, n, s, o, r) {
    const a = this._cursors.getViewPositions();
    let l = null, d = null;
    a.length > 1 ? d = this._cursors.getViewSelections() : l = D.fromPositions(a[0], a[0]), e.emitViewEvent(new g0(t, n, l, d, s, o, r));
  }
  revealPrimary(e, t, n, s, o, r) {
    const a = [this._cursors.getPrimaryCursor().viewState.selection];
    e.emitViewEvent(new g0(t, n, null, a, s, o, r));
  }
  saveState() {
    const e = [], t = this._cursors.getSelections();
    for (let n = 0, s = t.length; n < s; n++) {
      const o = t[n];
      e.push({ inSelectionMode: !o.isEmpty(), selectionStart: { lineNumber: o.selectionStartLineNumber, column: o.selectionStartColumn }, position: { lineNumber: o.positionLineNumber, column: o.positionColumn } });
    }
    return e;
  }
  restoreState(e, t) {
    const n = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const r = t[s];
      let a = 1, l = 1;
      r.position && r.position.lineNumber && (a = r.position.lineNumber), r.position && r.position.column && (l = r.position.column);
      let d = a, h = l;
      r.selectionStart && r.selectionStart.lineNumber && (d = r.selectionStart.lineNumber), r.selectionStart && r.selectionStart.column && (h = r.selectionStart.column), n.push({ selectionStartLineNumber: d, selectionStartColumn: h, positionLineNumber: a, positionColumn: l });
    }
    this.setStates(e, "restoreState", 0, pt.fromModelSelections(n)), this.revealAll(e, "restoreState", !1, 0, !0, 1);
  }
  onModelContentChanged(e, t) {
    if (t instanceof GB) {
      if (this._isHandling) return;
      this._isHandling = !0;
      try {
        this.setStates(e, "modelChange", 0, this.getCursorStates());
      } finally {
        this._isHandling = !1;
      }
    } else {
      const n = t.rawContentChangedEvent;
      if (this._knownModelVersionId = n.versionId, this._isHandling) return;
      const s = n.containsEvent(1);
      if (this._prevEditOperationType = 0, s) this._cursors.dispose(), this._cursors = new H5(this.context), this._validateAutoClosedActions(), this._emitStateChangedIfNecessary(e, "model", 1, null, !1);
      else if (this._hasFocus && n.resultingSelection && n.resultingSelection.length > 0) {
        const o = pt.fromModelSelections(n.resultingSelection);
        this.setStates(e, "modelChange", n.isUndoing ? 5 : n.isRedoing ? 6 : 2, o) && this.revealAll(e, "modelChange", !1, 0, !0, 0);
      } else {
        const o = this._cursors.readSelectionFromMarkers();
        this.setStates(e, "modelChange", 2, pt.fromModelSelections(o));
      }
    }
  }
  getSelection() {
    return this._cursors.getPrimaryCursor().modelState.selection;
  }
  getTopMostViewPosition() {
    return this._cursors.getTopMostViewPosition();
  }
  getBottomMostViewPosition() {
    return this._cursors.getBottomMostViewPosition();
  }
  getCursorColumnSelectData() {
    if (this._columnSelectData) return this._columnSelectData;
    const e = this._cursors.getPrimaryCursor(), t = e.viewState.selectionStart.getStartPosition(), n = e.viewState.position;
    return { isReal: !1, fromViewLineNumber: t.lineNumber, fromViewVisualColumn: this.context.cursorConfig.visibleColumnFromColumn(this._viewModel, t), toViewLineNumber: n.lineNumber, toViewVisualColumn: this.context.cursorConfig.visibleColumnFromColumn(this._viewModel, n) };
  }
  getSelections() {
    return this._cursors.getSelections();
  }
  setSelections(e, t, n, s) {
    this.setStates(e, t, s, pt.fromModelSelections(n));
  }
  getPrevEditOperationType() {
    return this._prevEditOperationType;
  }
  setPrevEditOperationType(e) {
    this._prevEditOperationType = e;
  }
  _pushAutoClosedAction(e, t) {
    const n = [], s = [];
    for (let a = 0, l = e.length; a < l; a++) n.push({ range: e[a], options: { description: "auto-closed-character", inlineClassName: "auto-closed-character", stickiness: 1 } }), s.push({ range: t[a], options: { description: "auto-closed-enclosing", stickiness: 1 } });
    const o = this._model.deltaDecorations([], n), r = this._model.deltaDecorations([], s);
    this._autoClosedActions.push(new U5(this._model, o, r));
  }
  _executeEditOperation(e) {
    if (!e) return;
    e.shouldPushStackElementBefore && this._model.pushStackElement();
    const t = NQ.executeCommands(this._model, this._cursors.getSelections(), e.commands);
    if (t) {
      this._interpretCommandResult(t);
      const n = [], s = [];
      for (let o = 0; o < e.commands.length; o++) {
        const r = e.commands[o];
        r instanceof WB && r.enclosingRange && r.closeCharacterRange && (n.push(r.closeCharacterRange), s.push(r.enclosingRange));
      }
      n.length > 0 && this._pushAutoClosedAction(n, s), this._prevEditOperationType = e.type;
    }
    e.shouldPushStackElementAfter && this._model.pushStackElement();
  }
  _interpretCommandResult(e) {
    e && e.length !== 0 || (e = this._cursors.readSelectionFromMarkers()), this._columnSelectData = null, this._cursors.setSelections(e), this._cursors.normalize();
  }
  _emitStateChangedIfNecessary(e, t, n, s, o) {
    const r = p0.from(this._model, this);
    if (r.equals(s)) return !1;
    const a = this._cursors.getSelections(), l = this._cursors.getViewSelections();
    if (e.emitViewEvent(new lQ(l, a, n)), !s || s.cursorState.length !== r.cursorState.length || r.cursorState.some((d, h) => !d.modelState.equals(s.cursorState[h].modelState))) {
      const d = s ? s.cursorState.map((c) => c.modelState.selection) : null, h = s ? s.modelVersionId : 0;
      e.emitOutgoingEvent(new wy(d, a, h, r.modelVersionId, t || "keyboard", n, o));
    }
    return !0;
  }
  _findAutoClosingPairs(e) {
    if (!e.length) return null;
    const t = [];
    for (let n = 0, s = e.length; n < s; n++) {
      const o = e[n];
      if (!o.text || o.text.indexOf(`
`) >= 0) return null;
      const r = o.text.match(/([)\]}>'"`])([^)\]}>'"`]*)$/);
      if (!r) return null;
      const a = r[1], l = this.context.cursorConfig.autoClosingPairs.autoClosingPairsCloseSingleChar.get(a);
      if (!l || l.length !== 1) return null;
      const d = l[0].open, h = o.text.length - r[2].length - 1, c = o.text.lastIndexOf(d, h - 1);
      if (c === -1) return null;
      t.push([c, h]);
    }
    return t;
  }
  executeEdits(e, t, n, s) {
    let o = null;
    t === "snippet" && (o = this._findAutoClosingPairs(n)), o && (n[0]._isTracked = !0);
    const r = [], a = [], l = this._model.pushEditOperations(this.getSelections(), n, (d) => {
      if (o) for (let c = 0, u = o.length; c < u; c++) {
        const [g, p] = o[c], f = d[c], _ = f.range.startLineNumber, v = f.range.startColumn - 1 + g, b = f.range.startColumn - 1 + p;
        r.push(new D(_, b + 1, _, b + 2)), a.push(new D(_, v + 1, _, b + 2));
      }
      const h = s(d);
      return h && (this._isHandling = !0), h;
    });
    l && (this._isHandling = !1, this.setSelections(e, t, l, 0)), r.length > 0 && this._pushAutoClosedAction(r, a);
  }
  _executeEdit(e, t, n, s = 0) {
    if (this.context.cursorConfig.readOnly) return;
    const o = p0.from(this._model, this);
    this._cursors.stopTrackingSelections(), this._isHandling = !0;
    try {
      this._cursors.ensureValidState(), e();
    } catch (r) {
      We(r);
    }
    this._isHandling = !1, this._cursors.startTrackingSelections(), this._validateAutoClosedActions(), this._emitStateChangedIfNecessary(t, n, s, o, !1) && this.revealAll(t, n, !1, 0, !0, 0);
  }
  getAutoClosedCharacters() {
    return U5.getAllAutoClosedCharacters(this._autoClosedActions);
  }
  startComposition(e) {
    this._compositionState = new m0(this._model, this.getSelections());
  }
  endComposition(e, t) {
    const n = this._compositionState ? this._compositionState.deduceOutcome(this._model, this.getSelections()) : null;
    this._compositionState = null, this._executeEdit(() => {
      t === "keyboard" && this._executeEditOperation(oi.compositionEndWithInterceptors(this._prevEditOperationType, this.context.cursorConfig, this._model, n, this.getSelections(), this.getAutoClosedCharacters()));
    }, e, t);
  }
  type(e, t, n) {
    this._executeEdit(() => {
      if (n === "keyboard") {
        const s = t.length;
        let o = 0;
        for (; o < s; ) {
          const r = aR(t, o), a = t.substr(o, r);
          this._executeEditOperation(oi.typeWithInterceptors(!!this._compositionState, this._prevEditOperationType, this.context.cursorConfig, this._model, this.getSelections(), this.getAutoClosedCharacters(), a)), o += r;
        }
      } else this._executeEditOperation(oi.typeWithoutInterceptors(this._prevEditOperationType, this.context.cursorConfig, this._model, this.getSelections(), t));
    }, e, n);
  }
  compositionType(e, t, n, s, o, r) {
    if (t.length !== 0 || n !== 0 || s !== 0) this._executeEdit(() => {
      this._executeEditOperation(oi.compositionType(this._prevEditOperationType, this.context.cursorConfig, this._model, this.getSelections(), t, n, s, o));
    }, e, r);
    else if (o !== 0) {
      const a = this.getSelections().map((l) => {
        const d = l.getPosition();
        return new _e(d.lineNumber, d.column + o, d.lineNumber, d.column + o);
      });
      this.setSelections(e, r, a, 0);
    }
  }
  paste(e, t, n, s, o) {
    this._executeEdit(() => {
      this._executeEditOperation(oi.paste(this.context.cursorConfig, this._model, this.getSelections(), t, n, s || []));
    }, e, o, 4);
  }
  cut(e, t) {
    this._executeEdit(() => {
      this._executeEditOperation(gg.cut(this.context.cursorConfig, this._model, this.getSelections()));
    }, e, t);
  }
  executeCommand(e, t, n) {
    this._executeEdit(() => {
      this._cursors.killSecondaryCursors(), this._executeEditOperation(new Ls(0, [t], { shouldPushStackElementBefore: !1, shouldPushStackElementAfter: !1 }));
    }, e, n);
  }
  executeCommands(e, t, n) {
    this._executeEdit(() => {
      this._executeEditOperation(new Ls(0, t, { shouldPushStackElementBefore: !1, shouldPushStackElementAfter: !1 }));
    }, e, n);
  }
}
class p0 {
  static from(e, t) {
    return new p0(e.getVersionId(), t.getCursorStates());
  }
  constructor(e, t) {
    this.modelVersionId = e, this.cursorState = t;
  }
  equals(e) {
    if (!e || this.modelVersionId !== e.modelVersionId || this.cursorState.length !== e.cursorState.length) return !1;
    for (let t = 0, n = this.cursorState.length; t < n; t++) if (!this.cursorState[t].equals(e.cursorState[t])) return !1;
    return !0;
  }
}
class U5 {
  static getAllAutoClosedCharacters(e) {
    let t = [];
    for (const n of e) t = t.concat(n.getAutoClosedCharactersRanges());
    return t;
  }
  constructor(e, t, n) {
    this._model = e, this._autoClosedCharactersDecorations = t, this._autoClosedEnclosingDecorations = n;
  }
  dispose() {
    this._autoClosedCharactersDecorations = this._model.deltaDecorations(this._autoClosedCharactersDecorations, []), this._autoClosedEnclosingDecorations = this._model.deltaDecorations(this._autoClosedEnclosingDecorations, []);
  }
  getAutoClosedCharactersRanges() {
    const e = [];
    for (let t = 0; t < this._autoClosedCharactersDecorations.length; t++) {
      const n = this._model.getDecorationRange(this._autoClosedCharactersDecorations[t]);
      n && e.push(n);
    }
    return e;
  }
  isValid(e) {
    const t = [];
    for (let n = 0; n < this._autoClosedEnclosingDecorations.length; n++) {
      const s = this._model.getDecorationRange(this._autoClosedEnclosingDecorations[n]);
      if (s && (t.push(s), s.startLineNumber !== s.endLineNumber)) return !1;
    }
    t.sort(D.compareRangesUsingStarts), e.sort(D.compareRangesUsingStarts);
    for (let n = 0; n < e.length; n++)
      if (n >= t.length || !t[n].strictContainsRange(e[n])) return !1;
    return !0;
  }
}
class NQ {
  static executeCommands(e, t, n) {
    const s = { model: e, selectionsBefore: t, trackedRanges: [], trackedRangesDirection: [] }, o = this._innerExecuteCommands(s, n);
    for (let r = 0, a = s.trackedRanges.length; r < a; r++) s.model._setTrackedRange(s.trackedRanges[r], null, 0);
    return o;
  }
  static _innerExecuteCommands(e, t) {
    if (this._arrayIsEmpty(t)) return null;
    const n = this._getEditOperations(e, t);
    if (n.operations.length === 0) return null;
    const s = n.operations, o = this._getLoserCursorMap(s);
    if (o.hasOwnProperty("0")) return console.warn("Ignoring commands"), null;
    const r = [];
    for (let d = 0, h = s.length; d < h; d++) o.hasOwnProperty(s[d].identifier.major.toString()) || r.push(s[d]);
    n.hadTrackedEditOperation && r.length > 0 && (r[0]._isTracked = !0);
    let a = e.model.pushEditOperations(e.selectionsBefore, r, (d) => {
      const h = [];
      for (let g = 0; g < e.selectionsBefore.length; g++) h[g] = [];
      for (const g of d) g.identifier && h[g.identifier.major].push(g);
      const c = (g, p) => g.identifier.minor - p.identifier.minor, u = [];
      for (let g = 0; g < e.selectionsBefore.length; g++) h[g].length > 0 ? (h[g].sort(c), u[g] = t[g].computeCursorState(e.model, { getInverseEditOperations: () => h[g], getTrackedSelection: (p) => {
        const f = parseInt(p, 10), _ = e.model._getTrackedRange(e.trackedRanges[f]);
        return e.trackedRangesDirection[f] === 0 ? new _e(_.startLineNumber, _.startColumn, _.endLineNumber, _.endColumn) : new _e(_.endLineNumber, _.endColumn, _.startLineNumber, _.startColumn);
      } })) : u[g] = e.selectionsBefore[g];
      return u;
    });
    a || (a = e.selectionsBefore);
    const l = [];
    for (const d in o) o.hasOwnProperty(d) && l.push(parseInt(d, 10));
    l.sort((d, h) => h - d);
    for (const d of l) a.splice(d, 1);
    return a;
  }
  static _arrayIsEmpty(e) {
    for (let t = 0, n = e.length; t < n; t++) if (e[t]) return !1;
    return !0;
  }
  static _getEditOperations(e, t) {
    let n = [], s = !1;
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o];
      if (a) {
        const l = this._getEditOperationsFromCommand(e, o, a);
        n = n.concat(l.operations), s = s || l.hadTrackedEditOperation;
      }
    }
    return { operations: n, hadTrackedEditOperation: s };
  }
  static _getEditOperationsFromCommand(e, t, n) {
    const s = [];
    let o = 0;
    const r = (d, h, c = !1) => {
      D.isEmpty(d) && h === "" || s.push({ identifier: { major: t, minor: o++ }, range: d, text: h, forceMoveMarkers: c, isAutoWhitespaceEdit: n.insertsAutoWhitespace });
    };
    let a = !1;
    const l = { addEditOperation: r, addTrackedEditOperation: (d, h, c) => {
      a = !0, r(d, h, c);
    }, trackSelection: (d, h) => {
      const c = _e.liftSelection(d);
      let u;
      if (c.isEmpty()) if (typeof h == "boolean") u = h ? 2 : 3;
      else {
        const f = e.model.getLineMaxColumn(c.startLineNumber);
        u = c.startColumn === f ? 2 : 3;
      }
      else u = 1;
      const g = e.trackedRanges.length, p = e.model._setTrackedRange(null, c, u);
      return e.trackedRanges[g] = p, e.trackedRangesDirection[g] = c.getDirection(), g.toString();
    } };
    try {
      n.getEditOperations(e.model, l);
    } catch (d) {
      return We(d), { operations: [], hadTrackedEditOperation: !1 };
    }
    return { operations: s, hadTrackedEditOperation: a };
  }
  static _getLoserCursorMap(e) {
    (e = e.slice(0)).sort((n, s) => -D.compareRangesUsingEnds(n.range, s.range));
    const t = {};
    for (let n = 1; n < e.length; n++) {
      const s = e[n - 1], o = e[n];
      if (D.getStartPosition(s.range).isBefore(D.getEndPosition(o.range))) {
        let r;
        r = s.identifier.major > o.identifier.major ? s.identifier.major : o.identifier.major, t[r.toString()] = !0;
        for (let a = 0; a < e.length; a++) e[a].identifier.major === r && (e.splice(a, 1), a < n && n--, a--);
        n > 0 && n--;
      }
    }
    return t;
  }
}
class EQ {
  constructor(e, t, n) {
    this.text = e, this.startSelection = t, this.endSelection = n;
  }
}
class m0 {
  static _capture(e, t) {
    const n = [];
    for (const s of t) {
      if (s.startLineNumber !== s.endLineNumber) return null;
      n.push(new EQ(e.getLineContent(s.startLineNumber), s.startColumn - 1, s.endColumn - 1));
    }
    return n;
  }
  constructor(e, t) {
    this._original = m0._capture(e, t);
  }
  deduceOutcome(e, t) {
    if (!this._original) return null;
    const n = m0._capture(e, t);
    if (!n || this._original.length !== n.length) return null;
    const s = [];
    for (let o = 0, r = this._original.length; o < r; o++) s.push(m0._deduceOutcome(this._original[o], n[o]));
    return s;
  }
  static _deduceOutcome(e, t) {
    const n = Math.min(e.startSelection, t.startSelection, fc(e.text, t.text)), s = Math.min(e.text.length - e.endSelection, t.text.length - t.endSelection, Vw(e.text, t.text)), o = e.text.substring(n, e.text.length - s), r = t.text.substring(n, t.text.length - s);
    return new aY(o, e.startSelection - n, e.endSelection - n, r, t.startSelection - n, t.endSelection - n);
  }
}
const K5 = { getInitialState: () => zm, tokenizeEncoded: (i, e, t) => sL(0, t) };
function IQ(i, e, t, n, s, o, r) {
  let a = "<div>", l = n, d = 0, h = !0;
  for (let c = 0, u = e.getCount(); c < u; c++) {
    const g = e.getEndOffset(c);
    if (g <= n) continue;
    let p = "";
    for (; l < g && l < s; l++) {
      const f = i.charCodeAt(l);
      switch (f) {
        case 9: {
          let _ = o - (l + d) % o;
          for (d += _ - 1; _ > 0; ) r && h ? (p += "&#160;", h = !1) : (p += " ", h = !0), _--;
          break;
        }
        case 60:
          p += "&lt;", h = !1;
          break;
        case 62:
          p += "&gt;", h = !1;
          break;
        case 38:
          p += "&amp;", h = !1;
          break;
        case 0:
          p += "&#00;", h = !1;
          break;
        case 65279:
        case 8232:
        case 8233:
        case 133:
          p += "�", h = !1;
          break;
        case 13:
          p += "&#8203", h = !1;
          break;
        case 32:
          r && h ? (p += "&#160;", h = !1) : (p += " ", h = !0);
          break;
        default:
          p += String.fromCharCode(f), h = !1;
      }
    }
    if (a += `<span style="${e.getInlineStyle(c, t)}">${p}</span>`, g > s || l >= s) break;
  }
  return a += "</div>", a;
}
function j5(i, e, t) {
  let n = '<div class="monaco-tokenized-source">';
  const s = Sl(i);
  let o = t.getInitialState();
  for (let r = 0, a = s.length; r < a; r++) {
    const l = s[r];
    r > 0 && (n += "<br/>");
    const d = t.tokenizeEncoded(l, !0, o);
    nn.convertToEndOffset(d.tokens, l.length);
    const h = new nn(d.tokens, l, e).inflate();
    let c = 0;
    for (let u = 0, g = h.getCount(); u < g; u++) {
      const p = h.getClassName(u), f = h.getEndOffset(u);
      n += `<span class="${p}">${Ww(l.substring(c, f))}</span>`, c = f;
    }
    o = d.endState;
  }
  return n += "</div>", n;
}
class MQ {
  constructor() {
    this._hasPending = !1, this._inserts = [], this._changes = [], this._removes = [];
  }
  insert(e) {
    this._hasPending = !0, this._inserts.push(e);
  }
  change(e) {
    this._hasPending = !0, this._changes.push(e);
  }
  remove(e) {
    this._hasPending = !0, this._removes.push(e);
  }
  mustCommit() {
    return this._hasPending;
  }
  commit(e) {
    if (!this._hasPending) return;
    const t = this._inserts, n = this._changes, s = this._removes;
    this._hasPending = !1, this._inserts = [], this._changes = [], this._removes = [], e._commitPendingChanges(t, n, s);
  }
}
class TQ {
  constructor(e, t, n, s, o) {
    this.id = e, this.afterLineNumber = t, this.ordinal = n, this.height = s, this.minWidth = o, this.prefixSum = 0;
  }
}
let gW = class yI {
  constructor(e, t, n, s) {
    this._instanceId = n8(++yI.INSTANCE_COUNT), this._pendingChanges = new MQ(), this._lastWhitespaceId = 0, this._arr = [], this._prefixSumValidIndex = -1, this._minWidth = -1, this._lineCount = e, this._lineHeight = t, this._paddingTop = n, this._paddingBottom = s;
  }
  static findInsertionIndex(e, t, n) {
    let s = 0, o = e.length;
    for (; s < o; ) {
      const r = s + o >>> 1;
      t === e[r].afterLineNumber ? n < e[r].ordinal ? o = r : s = r + 1 : t < e[r].afterLineNumber ? o = r : s = r + 1;
    }
    return s;
  }
  setLineHeight(e) {
    this._checkPendingChanges(), this._lineHeight = e;
  }
  setPadding(e, t) {
    this._paddingTop = e, this._paddingBottom = t;
  }
  onFlushed(e) {
    this._checkPendingChanges(), this._lineCount = e;
  }
  changeWhitespace(e) {
    let t = !1;
    try {
      e({ insertWhitespace: (n, s, o, r) => {
        t = !0, n |= 0, s |= 0, o |= 0, r |= 0;
        const a = this._instanceId + ++this._lastWhitespaceId;
        return this._pendingChanges.insert(new TQ(a, n, s, o, r)), a;
      }, changeOneWhitespace: (n, s, o) => {
        t = !0, s |= 0, o |= 0, this._pendingChanges.change({ id: n, newAfterLineNumber: s, newHeight: o });
      }, removeWhitespace: (n) => {
        t = !0, this._pendingChanges.remove({ id: n });
      } });
    } finally {
      this._pendingChanges.commit(this);
    }
    return t;
  }
  _commitPendingChanges(e, t, n) {
    if ((e.length > 0 || n.length > 0) && (this._minWidth = -1), e.length + t.length + n.length <= 1) {
      for (const l of e) this._insertWhitespace(l);
      for (const l of t) this._changeOneWhitespace(l.id, l.newAfterLineNumber, l.newHeight);
      for (const l of n) {
        const d = this._findWhitespaceIndex(l.id);
        d !== -1 && this._removeWhitespace(d);
      }
      return;
    }
    const s = /* @__PURE__ */ new Set();
    for (const l of n) s.add(l.id);
    const o = /* @__PURE__ */ new Map();
    for (const l of t) o.set(l.id, l);
    const r = (l) => {
      const d = [];
      for (const h of l) if (!s.has(h.id)) {
        if (o.has(h.id)) {
          const c = o.get(h.id);
          h.afterLineNumber = c.newAfterLineNumber, h.height = c.newHeight;
        }
        d.push(h);
      }
      return d;
    }, a = r(this._arr).concat(r(e));
    a.sort((l, d) => l.afterLineNumber === d.afterLineNumber ? l.ordinal - d.ordinal : l.afterLineNumber - d.afterLineNumber), this._arr = a, this._prefixSumValidIndex = -1;
  }
  _checkPendingChanges() {
    this._pendingChanges.mustCommit() && this._pendingChanges.commit(this);
  }
  _insertWhitespace(e) {
    const t = yI.findInsertionIndex(this._arr, e.afterLineNumber, e.ordinal);
    this._arr.splice(t, 0, e), this._prefixSumValidIndex = Math.min(this._prefixSumValidIndex, t - 1);
  }
  _findWhitespaceIndex(e) {
    const t = this._arr;
    for (let n = 0, s = t.length; n < s; n++) if (t[n].id === e) return n;
    return -1;
  }
  _changeOneWhitespace(e, t, n) {
    const s = this._findWhitespaceIndex(e);
    if (s !== -1 && (this._arr[s].height !== n && (this._arr[s].height = n, this._prefixSumValidIndex = Math.min(this._prefixSumValidIndex, s - 1)), this._arr[s].afterLineNumber !== t)) {
      const o = this._arr[s];
      this._removeWhitespace(s), o.afterLineNumber = t, this._insertWhitespace(o);
    }
  }
  _removeWhitespace(e) {
    this._arr.splice(e, 1), this._prefixSumValidIndex = Math.min(this._prefixSumValidIndex, e - 1);
  }
  onLinesDeleted(e, t) {
    this._checkPendingChanges(), e |= 0, t |= 0, this._lineCount -= t - e + 1;
    for (let n = 0, s = this._arr.length; n < s; n++) {
      const o = this._arr[n].afterLineNumber;
      e <= o && o <= t ? this._arr[n].afterLineNumber = e - 1 : o > t && (this._arr[n].afterLineNumber -= t - e + 1);
    }
  }
  onLinesInserted(e, t) {
    this._checkPendingChanges(), e |= 0, t |= 0, this._lineCount += t - e + 1;
    for (let n = 0, s = this._arr.length; n < s; n++)
      e <= this._arr[n].afterLineNumber && (this._arr[n].afterLineNumber += t - e + 1);
  }
  getWhitespacesTotalHeight() {
    return this._checkPendingChanges(), this._arr.length === 0 ? 0 : this.getWhitespacesAccumulatedHeight(this._arr.length - 1);
  }
  getWhitespacesAccumulatedHeight(e) {
    this._checkPendingChanges(), e |= 0;
    let t = Math.max(0, this._prefixSumValidIndex + 1);
    t === 0 && (this._arr[0].prefixSum = this._arr[0].height, t++);
    for (let n = t; n <= e; n++) this._arr[n].prefixSum = this._arr[n - 1].prefixSum + this._arr[n].height;
    return this._prefixSumValidIndex = Math.max(this._prefixSumValidIndex, e), this._arr[e].prefixSum;
  }
  getLinesTotalHeight() {
    return this._checkPendingChanges(), this._lineHeight * this._lineCount + this.getWhitespacesTotalHeight() + this._paddingTop + this._paddingBottom;
  }
  getWhitespaceAccumulatedHeightBeforeLineNumber(e) {
    this._checkPendingChanges(), e |= 0;
    const t = this._findLastWhitespaceBeforeLineNumber(e);
    return t === -1 ? 0 : this.getWhitespacesAccumulatedHeight(t);
  }
  _findLastWhitespaceBeforeLineNumber(e) {
    e |= 0;
    const t = this._arr;
    let n = 0, s = t.length - 1;
    for (; n <= s; ) {
      const o = n + ((s - n | 0) / 2 | 0) | 0;
      if (t[o].afterLineNumber < e) {
        if (o + 1 >= t.length || t[o + 1].afterLineNumber >= e) return o;
        n = o + 1 | 0;
      } else s = o - 1 | 0;
    }
    return -1;
  }
  _findFirstWhitespaceAfterLineNumber(e) {
    e |= 0;
    const t = this._findLastWhitespaceBeforeLineNumber(e) + 1;
    return t < this._arr.length ? t : -1;
  }
  getFirstWhitespaceIndexAfterLineNumber(e) {
    return this._checkPendingChanges(), e |= 0, this._findFirstWhitespaceAfterLineNumber(e);
  }
  getVerticalOffsetForLineNumber(e, t = !1) {
    let n;
    return this._checkPendingChanges(), n = (e |= 0) > 1 ? this._lineHeight * (e - 1) : 0, n + this.getWhitespaceAccumulatedHeightBeforeLineNumber(e - (t ? 1 : 0)) + this._paddingTop;
  }
  getVerticalOffsetAfterLineNumber(e, t = !1) {
    return this._checkPendingChanges(), e |= 0, this._lineHeight * e + this.getWhitespaceAccumulatedHeightBeforeLineNumber(e + (t ? 1 : 0)) + this._paddingTop;
  }
  getWhitespaceMinWidth() {
    if (this._checkPendingChanges(), this._minWidth === -1) {
      let e = 0;
      for (let t = 0, n = this._arr.length; t < n; t++) e = Math.max(e, this._arr[t].minWidth);
      this._minWidth = e;
    }
    return this._minWidth;
  }
  isAfterLines(e) {
    return this._checkPendingChanges(), e > this.getLinesTotalHeight();
  }
  isInTopPadding(e) {
    return this._paddingTop !== 0 && (this._checkPendingChanges(), e < this._paddingTop);
  }
  isInBottomPadding(e) {
    return this._paddingBottom === 0 ? !1 : (this._checkPendingChanges(), e >= this.getLinesTotalHeight() - this._paddingBottom);
  }
  getLineNumberAtOrAfterVerticalOffset(e) {
    if (this._checkPendingChanges(), (e |= 0) < 0) return 1;
    const t = 0 | this._lineCount, n = this._lineHeight;
    let s = 1, o = t;
    for (; s < o; ) {
      const r = (s + o) / 2 | 0, a = 0 | this.getVerticalOffsetForLineNumber(r);
      if (e >= a + n) s = r + 1;
      else {
        if (e >= a) return r;
        o = r;
      }
    }
    return s > t ? t : s;
  }
  getLinesViewportData(e, t) {
    this._checkPendingChanges(), e |= 0, t |= 0;
    const n = this._lineHeight, s = 0 | this.getLineNumberAtOrAfterVerticalOffset(e), o = 0 | this.getVerticalOffsetForLineNumber(s);
    let r = 0 | this._lineCount, a = 0 | this.getFirstWhitespaceIndexAfterLineNumber(s);
    const l = 0 | this.getWhitespacesCount();
    let d, h;
    a === -1 ? (a = l, h = r + 1, d = 0) : (h = 0 | this.getAfterLineNumberForWhitespaceIndex(a), d = 0 | this.getHeightForWhitespaceIndex(a));
    let c = o, u = c;
    const g = 5e5;
    let p = 0;
    o >= g && (p = Math.floor(o / g) * g, p = Math.floor(p / n) * n, u -= p);
    const f = [], _ = e + (t - e) / 2;
    let v = -1;
    for (let y = s; y <= r; y++) {
      for (v === -1 && (c <= _ && _ < c + n || c > _) && (v = y), c += n, f[y - s] = u, u += n; h === y; ) u += d, c += d, a++, a >= l ? h = r + 1 : (h = 0 | this.getAfterLineNumberForWhitespaceIndex(a), d = 0 | this.getHeightForWhitespaceIndex(a));
      if (c >= t) {
        r = y;
        break;
      }
    }
    v === -1 && (v = r);
    const b = 0 | this.getVerticalOffsetForLineNumber(r);
    let C = s, w = r;
    return C < w && o < e && C++, C < w && b + n > t && w--, { bigNumbersDelta: p, startLineNumber: s, endLineNumber: r, relativeVerticalOffset: f, centeredLineNumber: v, completelyVisibleStartLineNumber: C, completelyVisibleEndLineNumber: w, lineHeight: this._lineHeight };
  }
  getVerticalOffsetForWhitespaceIndex(e) {
    this._checkPendingChanges(), e |= 0;
    const t = this.getAfterLineNumberForWhitespaceIndex(e);
    let n, s;
    return n = t >= 1 ? this._lineHeight * t : 0, s = e > 0 ? this.getWhitespacesAccumulatedHeight(e - 1) : 0, n + s + this._paddingTop;
  }
  getWhitespaceIndexAtOrAfterVerticallOffset(e) {
    this._checkPendingChanges(), e |= 0;
    let t = 0, n = this.getWhitespacesCount() - 1;
    if (n < 0 || e >= this.getVerticalOffsetForWhitespaceIndex(n) + this.getHeightForWhitespaceIndex(n)) return -1;
    for (; t < n; ) {
      const s = Math.floor((t + n) / 2), o = this.getVerticalOffsetForWhitespaceIndex(s);
      if (e >= o + this.getHeightForWhitespaceIndex(s)) t = s + 1;
      else {
        if (e >= o) return s;
        n = s;
      }
    }
    return t;
  }
  getWhitespaceAtVerticalOffset(e) {
    this._checkPendingChanges(), e |= 0;
    const t = this.getWhitespaceIndexAtOrAfterVerticallOffset(e);
    if (t < 0 || t >= this.getWhitespacesCount()) return null;
    const n = this.getVerticalOffsetForWhitespaceIndex(t);
    if (n > e) return null;
    const s = this.getHeightForWhitespaceIndex(t);
    return { id: this.getIdForWhitespaceIndex(t), afterLineNumber: this.getAfterLineNumberForWhitespaceIndex(t), verticalOffset: n, height: s };
  }
  getWhitespaceViewportData(e, t) {
    this._checkPendingChanges(), e |= 0, t |= 0;
    const n = this.getWhitespaceIndexAtOrAfterVerticallOffset(e), s = this.getWhitespacesCount() - 1;
    if (n < 0) return [];
    const o = [];
    for (let r = n; r <= s; r++) {
      const a = this.getVerticalOffsetForWhitespaceIndex(r), l = this.getHeightForWhitespaceIndex(r);
      if (a >= t) break;
      o.push({ id: this.getIdForWhitespaceIndex(r), afterLineNumber: this.getAfterLineNumberForWhitespaceIndex(r), verticalOffset: a, height: l });
    }
    return o;
  }
  getWhitespaces() {
    return this._checkPendingChanges(), this._arr.slice(0);
  }
  getWhitespacesCount() {
    return this._checkPendingChanges(), this._arr.length;
  }
  getIdForWhitespaceIndex(e) {
    return this._checkPendingChanges(), e |= 0, this._arr[e].id;
  }
  getAfterLineNumberForWhitespaceIndex(e) {
    return this._checkPendingChanges(), e |= 0, this._arr[e].afterLineNumber;
  }
  getHeightForWhitespaceIndex(e) {
    return this._checkPendingChanges(), e |= 0, this._arr[e].height;
  }
};
gW.INSTANCE_COUNT = 0;
class x_ {
  constructor(e, t, n, s) {
    (e |= 0) < 0 && (e = 0), (t |= 0) < 0 && (t = 0), (n |= 0) < 0 && (n = 0), (s |= 0) < 0 && (s = 0), this.width = e, this.contentWidth = t, this.scrollWidth = Math.max(e, t), this.height = n, this.contentHeight = s, this.scrollHeight = Math.max(n, s);
  }
  equals(e) {
    return this.width === e.width && this.contentWidth === e.contentWidth && this.height === e.height && this.contentHeight === e.contentHeight;
  }
}
class RQ extends V {
  constructor(e, t) {
    super(), this._onDidContentSizeChange = this._register(new F()), this.onDidContentSizeChange = this._onDidContentSizeChange.event, this._dimensions = new x_(0, 0, 0, 0), this._scrollable = this._register(new bf({ forceIntegerValues: !0, smoothScrollDuration: e, scheduleAtNextAnimationFrame: t })), this.onDidScroll = this._scrollable.onScroll;
  }
  getScrollable() {
    return this._scrollable;
  }
  setSmoothScrollDuration(e) {
    this._scrollable.setSmoothScrollDuration(e);
  }
  validateScrollPosition(e) {
    return this._scrollable.validateScrollPosition(e);
  }
  getScrollDimensions() {
    return this._dimensions;
  }
  setScrollDimensions(e) {
    if (this._dimensions.equals(e)) return;
    const t = this._dimensions;
    this._dimensions = e, this._scrollable.setScrollDimensions({ width: e.width, scrollWidth: e.scrollWidth, height: e.height, scrollHeight: e.scrollHeight }, !0);
    const n = t.contentWidth !== e.contentWidth, s = t.contentHeight !== e.contentHeight;
    (n || s) && this._onDidContentSizeChange.fire(new oA(t.contentWidth, t.contentHeight, e.contentWidth, e.contentHeight));
  }
  getFutureScrollPosition() {
    return this._scrollable.getFutureScrollPosition();
  }
  getCurrentScrollPosition() {
    return this._scrollable.getCurrentScrollPosition();
  }
  setScrollPositionNow(e) {
    this._scrollable.setScrollPositionNow(e);
  }
  setScrollPositionSmooth(e) {
    this._scrollable.setScrollPositionSmooth(e);
  }
  hasPendingScrollAnimation() {
    return this._scrollable.hasPendingScrollAnimation();
  }
}
class AQ extends V {
  constructor(e, t, n) {
    super(), this._configuration = e;
    const s = this._configuration.options, o = s.get(145), r = s.get(84);
    this._linesLayout = new gW(t, s.get(67), r.top, r.bottom), this._maxLineWidth = 0, this._overlayWidgetsMinWidth = 0, this._scrollable = this._register(new RQ(0, n)), this._configureSmoothScrollDuration(), this._scrollable.setScrollDimensions(new x_(o.contentWidth, 0, o.height, 0)), this.onDidScroll = this._scrollable.onDidScroll, this.onDidContentSizeChange = this._scrollable.onDidContentSizeChange, this._updateHeight();
  }
  dispose() {
    super.dispose();
  }
  getScrollable() {
    return this._scrollable.getScrollable();
  }
  onHeightMaybeChanged() {
    this._updateHeight();
  }
  _configureSmoothScrollDuration() {
    this._scrollable.setSmoothScrollDuration(this._configuration.options.get(114) ? 125 : 0);
  }
  onConfigurationChanged(e) {
    const t = this._configuration.options;
    if (e.hasChanged(67) && this._linesLayout.setLineHeight(t.get(67)), e.hasChanged(84)) {
      const n = t.get(84);
      this._linesLayout.setPadding(n.top, n.bottom);
    }
    if (e.hasChanged(145)) {
      const n = t.get(145), s = n.contentWidth, o = n.height, r = this._scrollable.getScrollDimensions(), a = r.contentWidth;
      this._scrollable.setScrollDimensions(new x_(s, r.contentWidth, o, this._getContentHeight(s, o, a)));
    } else this._updateHeight();
    e.hasChanged(114) && this._configureSmoothScrollDuration();
  }
  onFlushed(e) {
    this._linesLayout.onFlushed(e);
  }
  onLinesDeleted(e, t) {
    this._linesLayout.onLinesDeleted(e, t);
  }
  onLinesInserted(e, t) {
    this._linesLayout.onLinesInserted(e, t);
  }
  _getHorizontalScrollbarHeight(e, t) {
    const n = this._configuration.options.get(103);
    return n.horizontal === 2 || e >= t ? 0 : n.horizontalScrollbarSize;
  }
  _getContentHeight(e, t, n) {
    const s = this._configuration.options;
    let o = this._linesLayout.getLinesTotalHeight();
    return s.get(105) ? o += Math.max(0, t - s.get(67) - s.get(84).bottom) : s.get(103).ignoreHorizontalScrollbarInContentHeight || (o += this._getHorizontalScrollbarHeight(e, n)), o;
  }
  _updateHeight() {
    const e = this._scrollable.getScrollDimensions(), t = e.width, n = e.height, s = e.contentWidth;
    this._scrollable.setScrollDimensions(new x_(t, e.contentWidth, n, this._getContentHeight(t, n, s)));
  }
  getCurrentViewport() {
    const e = this._scrollable.getScrollDimensions(), t = this._scrollable.getCurrentScrollPosition();
    return new S4(t.scrollTop, t.scrollLeft, e.width, e.height);
  }
  getFutureViewport() {
    const e = this._scrollable.getScrollDimensions(), t = this._scrollable.getFutureScrollPosition();
    return new S4(t.scrollTop, t.scrollLeft, e.width, e.height);
  }
  _computeContentWidth() {
    const e = this._configuration.options, t = this._maxLineWidth, n = e.get(146), s = e.get(50), o = e.get(145);
    if (n.isViewportWrapping) {
      const r = e.get(73);
      return t > o.contentWidth + s.typicalHalfwidthCharacterWidth && r.enabled && r.side === "right" ? t + o.verticalScrollbarWidth : t;
    }
    {
      const r = e.get(104) * s.typicalHalfwidthCharacterWidth, a = this._linesLayout.getWhitespaceMinWidth();
      return Math.max(t + r + o.verticalScrollbarWidth, a, this._overlayWidgetsMinWidth);
    }
  }
  setMaxLineWidth(e) {
    this._maxLineWidth = e, this._updateContentWidth();
  }
  setOverlayWidgetsMinWidth(e) {
    this._overlayWidgetsMinWidth = e, this._updateContentWidth();
  }
  _updateContentWidth() {
    const e = this._scrollable.getScrollDimensions();
    this._scrollable.setScrollDimensions(new x_(e.width, this._computeContentWidth(), e.height, e.contentHeight)), this._updateHeight();
  }
  saveState() {
    const e = this._scrollable.getFutureScrollPosition(), t = e.scrollTop, n = this._linesLayout.getLineNumberAtOrAfterVerticalOffset(t);
    return { scrollTop: t, scrollTopWithoutViewZones: t - this._linesLayout.getWhitespaceAccumulatedHeightBeforeLineNumber(n), scrollLeft: e.scrollLeft };
  }
  changeWhitespace(e) {
    const t = this._linesLayout.changeWhitespace(e);
    return t && this.onHeightMaybeChanged(), t;
  }
  getVerticalOffsetForLineNumber(e, t = !1) {
    return this._linesLayout.getVerticalOffsetForLineNumber(e, t);
  }
  getVerticalOffsetAfterLineNumber(e, t = !1) {
    return this._linesLayout.getVerticalOffsetAfterLineNumber(e, t);
  }
  isAfterLines(e) {
    return this._linesLayout.isAfterLines(e);
  }
  isInTopPadding(e) {
    return this._linesLayout.isInTopPadding(e);
  }
  isInBottomPadding(e) {
    return this._linesLayout.isInBottomPadding(e);
  }
  getLineNumberAtVerticalOffset(e) {
    return this._linesLayout.getLineNumberAtOrAfterVerticalOffset(e);
  }
  getWhitespaceAtVerticalOffset(e) {
    return this._linesLayout.getWhitespaceAtVerticalOffset(e);
  }
  getLinesViewportData() {
    const e = this.getCurrentViewport();
    return this._linesLayout.getLinesViewportData(e.top, e.top + e.height);
  }
  getLinesViewportDataAtScrollTop(e) {
    const t = this._scrollable.getScrollDimensions();
    return e + t.height > t.scrollHeight && (e = t.scrollHeight - t.height), e < 0 && (e = 0), this._linesLayout.getLinesViewportData(e, e + t.height);
  }
  getWhitespaceViewportData() {
    const e = this.getCurrentViewport();
    return this._linesLayout.getWhitespaceViewportData(e.top, e.top + e.height);
  }
  getWhitespaces() {
    return this._linesLayout.getWhitespaces();
  }
  getContentWidth() {
    return this._scrollable.getScrollDimensions().contentWidth;
  }
  getScrollWidth() {
    return this._scrollable.getScrollDimensions().scrollWidth;
  }
  getContentHeight() {
    return this._scrollable.getScrollDimensions().contentHeight;
  }
  getScrollHeight() {
    return this._scrollable.getScrollDimensions().scrollHeight;
  }
  getCurrentScrollLeft() {
    return this._scrollable.getCurrentScrollPosition().scrollLeft;
  }
  getCurrentScrollTop() {
    return this._scrollable.getCurrentScrollPosition().scrollTop;
  }
  validateScrollPosition(e) {
    return this._scrollable.validateScrollPosition(e);
  }
  setScrollPosition(e, t) {
    t === 1 ? this._scrollable.setScrollPositionNow(e) : this._scrollable.setScrollPositionSmooth(e);
  }
  hasPendingScrollAnimation() {
    return this._scrollable.hasPendingScrollAnimation();
  }
  deltaScrollNow(e, t) {
    const n = this._scrollable.getCurrentScrollPosition();
    this._scrollable.setScrollPositionNow({ scrollLeft: n.scrollLeft + e, scrollTop: n.scrollTop + t });
  }
}
class PQ {
  constructor(e, t, n, s, o) {
    this.editorId = e, this.model = t, this.configuration = n, this._linesCollection = s, this._coordinatesConverter = o, this._decorationsCache = /* @__PURE__ */ Object.create(null), this._cachedModelDecorationsResolver = null, this._cachedModelDecorationsResolverViewRange = null;
  }
  _clearCachedModelDecorationsResolver() {
    this._cachedModelDecorationsResolver = null, this._cachedModelDecorationsResolverViewRange = null;
  }
  dispose() {
    this._decorationsCache = /* @__PURE__ */ Object.create(null), this._clearCachedModelDecorationsResolver();
  }
  reset() {
    this._decorationsCache = /* @__PURE__ */ Object.create(null), this._clearCachedModelDecorationsResolver();
  }
  onModelDecorationsChanged() {
    this._decorationsCache = /* @__PURE__ */ Object.create(null), this._clearCachedModelDecorationsResolver();
  }
  onLineMappingChanged() {
    this._decorationsCache = /* @__PURE__ */ Object.create(null), this._clearCachedModelDecorationsResolver();
  }
  _getOrCreateViewModelDecoration(e) {
    const t = e.id;
    let n = this._decorationsCache[t];
    if (!n) {
      const s = e.range, o = e.options;
      let r;
      if (o.isWholeLine) {
        const a = this._coordinatesConverter.convertModelPositionToViewPosition(new W(s.startLineNumber, 1), 0, !1, !0), l = this._coordinatesConverter.convertModelPositionToViewPosition(new W(s.endLineNumber, this.model.getLineMaxColumn(s.endLineNumber)), 1);
        r = new D(a.lineNumber, a.column, l.lineNumber, l.column);
      } else r = this._coordinatesConverter.convertModelRangeToViewRange(s, 1);
      n = new sB(r, o), this._decorationsCache[t] = n;
    }
    return n;
  }
  getMinimapDecorationsInRange(e) {
    return this._getDecorationsInRange(e, !0, !1).decorations;
  }
  getDecorationsViewportData(e) {
    let t = this._cachedModelDecorationsResolver !== null;
    return t = t && e.equalsRange(this._cachedModelDecorationsResolverViewRange), t || (this._cachedModelDecorationsResolver = this._getDecorationsInRange(e, !1, !1), this._cachedModelDecorationsResolverViewRange = e), this._cachedModelDecorationsResolver;
  }
  getInlineDecorationsOnLine(e, t = !1, n = !1) {
    const s = new D(e, this._linesCollection.getViewLineMinColumn(e), e, this._linesCollection.getViewLineMaxColumn(e));
    return this._getDecorationsInRange(s, t, n).inlineDecorations[0];
  }
  _getDecorationsInRange(e, t, n) {
    const s = this._linesCollection.getDecorationsInRange(e, this.editorId, Mw(this.configuration.options), t, n), o = e.startLineNumber, r = e.endLineNumber, a = [];
    let l = 0;
    const d = [];
    for (let h = o; h <= r; h++) d[h - o] = [];
    for (let h = 0, c = s.length; h < c; h++) {
      const u = s[h], g = u.options;
      if (!lA(this.model, u)) continue;
      const p = this._getOrCreateViewModelDecoration(u), f = p.range;
      if (a[l++] = p, g.inlineClassName) {
        const _ = new Q_(f, g.inlineClassName, g.inlineClassNameAffectsLetterSpacing ? 3 : 0), v = Math.max(o, f.startLineNumber), b = Math.min(r, f.endLineNumber);
        for (let C = v; C <= b; C++) d[C - o].push(_);
      }
      if (g.beforeContentClassName && o <= f.startLineNumber && f.startLineNumber <= r) {
        const _ = new Q_(new D(f.startLineNumber, f.startColumn, f.startLineNumber, f.startColumn), g.beforeContentClassName, 1);
        d[f.startLineNumber - o].push(_);
      }
      if (g.afterContentClassName && o <= f.endLineNumber && f.endLineNumber <= r) {
        const _ = new Q_(new D(f.endLineNumber, f.endColumn, f.endLineNumber, f.endColumn), g.afterContentClassName, 2);
        d[f.endLineNumber - o].push(_);
      }
    }
    return { decorations: a, inlineDecorations: d };
  }
}
function lA(i, e) {
  return (!e.options.hideInCommentTokens || !dA(i, e)) && (!e.options.hideInStringTokens || !hA(i, e));
}
function dA(i, e) {
  return pW(i, e.range, (t) => t === 1);
}
function hA(i, e) {
  return pW(i, e.range, (t) => t === 2);
}
function pW(i, e, t) {
  for (let n = e.startLineNumber; n <= e.endLineNumber; n++) {
    const s = i.tokenization.getLineTokens(n), o = n === e.startLineNumber, r = n === e.endLineNumber;
    let a = o ? s.findTokenIndexAtOffset(e.startColumn - 1) : 0;
    for (; a < s.getCount() && !(r && s.getStartOffset(a) > e.endColumn - 1); ) {
      if (!t(s.getStandardTokenType(a))) return !1;
      a++;
    }
  }
  return !0;
}
function MD(i, e) {
  return i === null ? e ? yy.INSTANCE : Sy.INSTANCE : new OQ(i, e);
}
class OQ {
  constructor(e, t) {
    this._projectionData = e, this._isVisible = t;
  }
  isVisible() {
    return this._isVisible;
  }
  setVisible(e) {
    return this._isVisible = e, this;
  }
  getProjectionData() {
    return this._projectionData;
  }
  getViewLineCount() {
    return this._isVisible ? this._projectionData.getOutputLineCount() : 0;
  }
  getViewLineContent(e, t, n) {
    this._assertVisible();
    const s = n > 0 ? this._projectionData.breakOffsets[n - 1] : 0, o = this._projectionData.breakOffsets[n];
    let r;
    if (this._projectionData.injectionOffsets !== null) {
      const a = this._projectionData.injectionOffsets.map((l, d) => new va(0, 0, l + 1, this._projectionData.injectionOptions[d], 0));
      r = va.applyInjectedText(e.getLineContent(t), a).substring(s, o);
    } else r = e.getValueInRange({ startLineNumber: t, startColumn: s + 1, endLineNumber: t, endColumn: o + 1 });
    return n > 0 && (r = q5(this._projectionData.wrappedTextIndentLength) + r), r;
  }
  getViewLineLength(e, t, n) {
    return this._assertVisible(), this._projectionData.getLineLength(n);
  }
  getViewLineMinColumn(e, t, n) {
    return this._assertVisible(), this._projectionData.getMinOutputOffset(n) + 1;
  }
  getViewLineMaxColumn(e, t, n) {
    return this._assertVisible(), this._projectionData.getMaxOutputOffset(n) + 1;
  }
  getViewLineData(e, t, n) {
    const s = new Array();
    return this.getViewLinesData(e, t, n, 1, 0, [!0], s), s[0];
  }
  getViewLinesData(e, t, n, s, o, r, a) {
    this._assertVisible();
    const l = this._projectionData, d = l.injectionOffsets, h = l.injectionOptions;
    let c, u = null;
    if (d) {
      u = [];
      let g = 0, p = 0;
      for (let f = 0; f < l.getOutputLineCount(); f++) {
        const _ = new Array();
        u[f] = _;
        const v = f > 0 ? l.breakOffsets[f - 1] : 0, b = l.breakOffsets[f];
        for (; p < d.length; ) {
          const C = h[p].content.length, w = d[p] + g, y = w + C;
          if (w > b) break;
          if (v < y) {
            const L = h[p];
            if (L.inlineClassName) {
              const k = f > 0 ? l.wrappedTextIndentLength : 0, N = k + Math.max(w - v, 0), A = k + Math.min(y - v, b - v);
              N !== A && _.push(new Jq(N, A, L.inlineClassName, L.inlineClassNameAffectsLetterSpacing));
            }
          }
          if (!(y <= b)) break;
          g += C, p++;
        }
      }
    }
    c = d ? e.tokenization.getLineTokens(t).withInserted(d.map((g, p) => ({ offset: g, text: h[p].content, tokenMetadata: nn.defaultTokenMetadata }))) : e.tokenization.getLineTokens(t);
    for (let g = n; g < n + s; g++) {
      const p = o + g - n;
      r[p] ? a[p] = this._getViewLineData(c, u ? u[g] : null, g) : a[p] = null;
    }
  }
  _getViewLineData(e, t, n) {
    this._assertVisible();
    const s = this._projectionData, o = n > 0 ? s.wrappedTextIndentLength : 0, r = n > 0 ? s.breakOffsets[n - 1] : 0, a = s.breakOffsets[n], l = e.sliceAndInflate(r, a, o);
    let d = l.getLineContent();
    n > 0 && (d = q5(s.wrappedTextIndentLength) + d);
    const h = this._projectionData.getMinOutputOffset(n) + 1, c = d.length + 1, u = n + 1 < this.getViewLineCount(), g = n === 0 ? 0 : s.breakOffsetsVisibleColumn[n - 1];
    return new TR(d, u, h, c, g, l, t);
  }
  getModelColumnOfViewPosition(e, t) {
    return this._assertVisible(), this._projectionData.translateToInputOffset(e, t - 1) + 1;
  }
  getViewPositionOfModelPosition(e, t, n = 2) {
    return this._assertVisible(), this._projectionData.translateToOutputPosition(t - 1, n).toPosition(e);
  }
  getViewLineNumberOfModelPosition(e, t) {
    return this._assertVisible(), e + this._projectionData.translateToOutputPosition(t - 1).outputLineIndex;
  }
  normalizePosition(e, t, n) {
    const s = t.lineNumber - e;
    return this._projectionData.normalizeOutputPosition(e, t.column - 1, n).toPosition(s);
  }
  getInjectedTextAt(e, t) {
    return this._projectionData.getInjectedText(e, t - 1);
  }
  _assertVisible() {
    if (!this._isVisible) throw new Error("Not supported");
  }
}
class yy {
  constructor() {
  }
  isVisible() {
    return !0;
  }
  setVisible(e) {
    return e ? this : Sy.INSTANCE;
  }
  getProjectionData() {
    return null;
  }
  getViewLineCount() {
    return 1;
  }
  getViewLineContent(e, t, n) {
    return e.getLineContent(t);
  }
  getViewLineLength(e, t, n) {
    return e.getLineLength(t);
  }
  getViewLineMinColumn(e, t, n) {
    return e.getLineMinColumn(t);
  }
  getViewLineMaxColumn(e, t, n) {
    return e.getLineMaxColumn(t);
  }
  getViewLineData(e, t, n) {
    const s = e.tokenization.getLineTokens(t), o = s.getLineContent();
    return new TR(o, !1, 1, o.length + 1, 0, s.inflate(), null);
  }
  getViewLinesData(e, t, n, s, o, r, a) {
    r[o] ? a[o] = this.getViewLineData(e, t, 0) : a[o] = null;
  }
  getModelColumnOfViewPosition(e, t) {
    return t;
  }
  getViewPositionOfModelPosition(e, t) {
    return new W(e, t);
  }
  getViewLineNumberOfModelPosition(e, t) {
    return e;
  }
  normalizePosition(e, t, n) {
    return t;
  }
  getInjectedTextAt(e, t) {
    return null;
  }
}
yy.INSTANCE = new yy();
class Sy {
  constructor() {
  }
  isVisible() {
    return !1;
  }
  setVisible(e) {
    return e ? yy.INSTANCE : this;
  }
  getProjectionData() {
    return null;
  }
  getViewLineCount() {
    return 0;
  }
  getViewLineContent(e, t, n) {
    throw new Error("Not supported");
  }
  getViewLineLength(e, t, n) {
    throw new Error("Not supported");
  }
  getViewLineMinColumn(e, t, n) {
    throw new Error("Not supported");
  }
  getViewLineMaxColumn(e, t, n) {
    throw new Error("Not supported");
  }
  getViewLineData(e, t, n) {
    throw new Error("Not supported");
  }
  getViewLinesData(e, t, n, s, o, r, a) {
    throw new Error("Not supported");
  }
  getModelColumnOfViewPosition(e, t) {
    throw new Error("Not supported");
  }
  getViewPositionOfModelPosition(e, t) {
    throw new Error("Not supported");
  }
  getViewLineNumberOfModelPosition(e, t) {
    throw new Error("Not supported");
  }
  normalizePosition(e, t, n) {
    throw new Error("Not supported");
  }
  getInjectedTextAt(e, t) {
    throw new Error("Not supported");
  }
}
Sy.INSTANCE = new Sy();
const TD = [""];
function q5(i) {
  if (i >= TD.length) for (let e = 1; e <= i; e++) TD[e] = FQ(e);
  return TD[i];
}
function FQ(i) {
  return new Array(i + 1).join(" ");
}
class BQ {
  constructor(e, t, n, s, o, r, a, l, d, h) {
    this._editorId = e, this.model = t, this._validModelVersionId = -1, this._domLineBreaksComputerFactory = n, this._monospaceLineBreaksComputerFactory = s, this.fontInfo = o, this.tabSize = r, this.wrappingStrategy = a, this.wrappingColumn = l, this.wrappingIndent = d, this.wordBreak = h, this._constructLines(!0, null);
  }
  dispose() {
    this.hiddenAreasDecorationIds = this.model.deltaDecorations(this.hiddenAreasDecorationIds, []);
  }
  createCoordinatesConverter() {
    return new WQ(this);
  }
  _constructLines(e, t) {
    this.modelLineProjections = [], e && (this.hiddenAreasDecorationIds = this.model.deltaDecorations(this.hiddenAreasDecorationIds, []));
    const n = this.model.getLinesContent(), s = this.model.getInjectedTextDecorations(this._editorId), o = n.length, r = this.createLineBreaksComputer(), a = new Pd(va.fromDecorations(s));
    for (let f = 0; f < o; f++) {
      const _ = a.takeWhile((v) => v.lineNumber === f + 1);
      r.addRequest(n[f], _, t ? t[f] : null);
    }
    const l = r.finalize(), d = [], h = this.hiddenAreasDecorationIds.map((f) => this.model.getDecorationRange(f)).sort(D.compareRangesUsingStarts);
    let c = 1, u = 0, g = -1, p = g + 1 < h.length ? u + 1 : o + 2;
    for (let f = 0; f < o; f++) {
      const _ = f + 1;
      _ === p && (g++, c = h[g].startLineNumber, u = h[g].endLineNumber, p = g + 1 < h.length ? u + 1 : o + 2);
      const v = _ >= c && _ <= u, b = MD(l[f], !v);
      d[f] = b.getViewLineCount(), this.modelLineProjections[f] = b;
    }
    this._validModelVersionId = this.model.getVersionId(), this.projectedModelLineLineCounts = new pq(d);
  }
  getHiddenAreas() {
    return this.hiddenAreasDecorationIds.map((e) => this.model.getDecorationRange(e));
  }
  setHiddenAreas(e) {
    const t = function(c) {
      if (c.length === 0) return [];
      const u = c.slice();
      u.sort(D.compareRangesUsingStarts);
      const g = [];
      let p = u[0].startLineNumber, f = u[0].endLineNumber;
      for (let _ = 1, v = u.length; _ < v; _++) {
        const b = u[_];
        b.startLineNumber > f + 1 ? (g.push(new D(p, 1, f, 1)), p = b.startLineNumber, f = b.endLineNumber) : b.endLineNumber > f && (f = b.endLineNumber);
      }
      return g.push(new D(p, 1, f, 1)), g;
    }(e.map((c) => this.model.validateRange(c))), n = this.hiddenAreasDecorationIds.map((c) => this.model.getDecorationRange(c)).sort(D.compareRangesUsingStarts);
    if (t.length === n.length) {
      let c = !1;
      for (let u = 0; u < t.length; u++) if (!t[u].equalsRange(n[u])) {
        c = !0;
        break;
      }
      if (!c) return !1;
    }
    const s = t.map((c) => ({ range: c, options: Ve.EMPTY }));
    this.hiddenAreasDecorationIds = this.model.deltaDecorations(this.hiddenAreasDecorationIds, s);
    const o = t;
    let r = 1, a = 0, l = -1, d = l + 1 < o.length ? a + 1 : this.modelLineProjections.length + 2, h = !1;
    for (let c = 0; c < this.modelLineProjections.length; c++) {
      const u = c + 1;
      u === d && (l++, r = o[l].startLineNumber, a = o[l].endLineNumber, d = l + 1 < o.length ? a + 1 : this.modelLineProjections.length + 2);
      let g = !1;
      if (u >= r && u <= a ? this.modelLineProjections[c].isVisible() && (this.modelLineProjections[c] = this.modelLineProjections[c].setVisible(!1), g = !0) : (h = !0, this.modelLineProjections[c].isVisible() || (this.modelLineProjections[c] = this.modelLineProjections[c].setVisible(!0), g = !0)), g) {
        const p = this.modelLineProjections[c].getViewLineCount();
        this.projectedModelLineLineCounts.setValue(c, p);
      }
    }
    return h || this.setHiddenAreas([]), !0;
  }
  modelPositionIsVisible(e, t) {
    return !(e < 1 || e > this.modelLineProjections.length) && this.modelLineProjections[e - 1].isVisible();
  }
  getModelLineViewLineCount(e) {
    return e < 1 || e > this.modelLineProjections.length ? 1 : this.modelLineProjections[e - 1].getViewLineCount();
  }
  setTabSize(e) {
    return this.tabSize !== e && (this.tabSize = e, this._constructLines(!1, null), !0);
  }
  setWrappingSettings(e, t, n, s, o) {
    const r = this.fontInfo.equals(e), a = this.wrappingStrategy === t, l = this.wrappingColumn === n, d = this.wrappingIndent === s, h = this.wordBreak === o;
    if (r && a && l && d && h) return !1;
    const c = r && a && !l && d && h;
    this.fontInfo = e, this.wrappingStrategy = t, this.wrappingColumn = n, this.wrappingIndent = s, this.wordBreak = o;
    let u = null;
    if (c) {
      u = [];
      for (let g = 0, p = this.modelLineProjections.length; g < p; g++) u[g] = this.modelLineProjections[g].getProjectionData();
    }
    return this._constructLines(!1, u), !0;
  }
  createLineBreaksComputer() {
    return (this.wrappingStrategy === "advanced" ? this._domLineBreaksComputerFactory : this._monospaceLineBreaksComputerFactory).createLineBreaksComputer(this.fontInfo, this.tabSize, this.wrappingColumn, this.wrappingIndent, this.wordBreak);
  }
  onModelFlushed() {
    this._constructLines(!0, null);
  }
  onModelLinesDeleted(e, t, n) {
    if (!e || e <= this._validModelVersionId) return null;
    const s = t === 1 ? 1 : this.projectedModelLineLineCounts.getPrefixSum(t - 1) + 1, o = this.projectedModelLineLineCounts.getPrefixSum(n);
    return this.modelLineProjections.splice(t - 1, n - t + 1), this.projectedModelLineLineCounts.removeValues(t - 1, n - t + 1), new CI(s, o);
  }
  onModelLinesInserted(e, t, n, s) {
    if (!e || e <= this._validModelVersionId) return null;
    const o = t > 2 && !this.modelLineProjections[t - 2].isVisible(), r = t === 1 ? 1 : this.projectedModelLineLineCounts.getPrefixSum(t - 1) + 1;
    let a = 0;
    const l = [], d = [];
    for (let h = 0, c = s.length; h < c; h++) {
      const u = MD(s[h], !o);
      l.push(u);
      const g = u.getViewLineCount();
      a += g, d[h] = g;
    }
    return this.modelLineProjections = this.modelLineProjections.slice(0, t - 1).concat(l).concat(this.modelLineProjections.slice(t - 1)), this.projectedModelLineLineCounts.insertValues(t - 1, d), new wI(r, r + a - 1);
  }
  onModelLineChanged(e, t, n) {
    if (e !== null && e <= this._validModelVersionId) return [!1, null, null, null];
    const s = t - 1, o = this.modelLineProjections[s].getViewLineCount(), r = MD(n, this.modelLineProjections[s].isVisible());
    this.modelLineProjections[s] = r;
    const a = this.modelLineProjections[s].getViewLineCount();
    let l = !1, d = 0, h = -1, c = 0, u = -1, g = 0, p = -1;
    return o > a ? (d = this.projectedModelLineLineCounts.getPrefixSum(t - 1) + 1, h = d + a - 1, g = h + 1, p = g + (o - a) - 1, l = !0) : o < a ? (d = this.projectedModelLineLineCounts.getPrefixSum(t - 1) + 1, h = d + o - 1, c = h + 1, u = c + (a - o) - 1, l = !0) : (d = this.projectedModelLineLineCounts.getPrefixSum(t - 1) + 1, h = d + a - 1), this.projectedModelLineLineCounts.setValue(s, a), [l, d <= h ? new uW(d, h - d + 1) : null, c <= u ? new wI(c, u) : null, g <= p ? new CI(g, p) : null];
  }
  acceptVersionId(e) {
    this._validModelVersionId = e, this.modelLineProjections.length !== 1 || this.modelLineProjections[0].isVisible() || this.setHiddenAreas([]);
  }
  getViewLineCount() {
    return this.projectedModelLineLineCounts.getTotalSum();
  }
  _toValidViewLineNumber(e) {
    if (e < 1) return 1;
    const t = this.getViewLineCount();
    return e > t ? t : 0 | e;
  }
  getActiveIndentGuide(e, t, n) {
    e = this._toValidViewLineNumber(e), t = this._toValidViewLineNumber(t), n = this._toValidViewLineNumber(n);
    const s = this.convertViewPositionToModelPosition(e, this.getViewLineMinColumn(e)), o = this.convertViewPositionToModelPosition(t, this.getViewLineMinColumn(t)), r = this.convertViewPositionToModelPosition(n, this.getViewLineMinColumn(n)), a = this.model.guides.getActiveIndentGuide(s.lineNumber, o.lineNumber, r.lineNumber), l = this.convertModelPositionToViewPosition(a.startLineNumber, 1), d = this.convertModelPositionToViewPosition(a.endLineNumber, this.model.getLineMaxColumn(a.endLineNumber));
    return { startLineNumber: l.lineNumber, endLineNumber: d.lineNumber, indent: a.indent };
  }
  getViewLineInfo(e) {
    e = this._toValidViewLineNumber(e);
    const t = this.projectedModelLineLineCounts.getIndexOf(e - 1), n = t.index, s = t.remainder;
    return new $5(n + 1, s);
  }
  getMinColumnOfViewLine(e) {
    return this.modelLineProjections[e.modelLineNumber - 1].getViewLineMinColumn(this.model, e.modelLineNumber, e.modelLineWrappedLineIdx);
  }
  getMaxColumnOfViewLine(e) {
    return this.modelLineProjections[e.modelLineNumber - 1].getViewLineMaxColumn(this.model, e.modelLineNumber, e.modelLineWrappedLineIdx);
  }
  getModelStartPositionOfViewLine(e) {
    const t = this.modelLineProjections[e.modelLineNumber - 1], n = t.getViewLineMinColumn(this.model, e.modelLineNumber, e.modelLineWrappedLineIdx), s = t.getModelColumnOfViewPosition(e.modelLineWrappedLineIdx, n);
    return new W(e.modelLineNumber, s);
  }
  getModelEndPositionOfViewLine(e) {
    const t = this.modelLineProjections[e.modelLineNumber - 1], n = t.getViewLineMaxColumn(this.model, e.modelLineNumber, e.modelLineWrappedLineIdx), s = t.getModelColumnOfViewPosition(e.modelLineWrappedLineIdx, n);
    return new W(e.modelLineNumber, s);
  }
  getViewLineInfosGroupedByModelRanges(e, t) {
    const n = this.getViewLineInfo(e), s = this.getViewLineInfo(t), o = new Array();
    let r = this.getModelStartPositionOfViewLine(n), a = new Array();
    for (let l = n.modelLineNumber; l <= s.modelLineNumber; l++) {
      const d = this.modelLineProjections[l - 1];
      if (d.isVisible()) {
        const h = l === n.modelLineNumber ? n.modelLineWrappedLineIdx : 0, c = l === s.modelLineNumber ? s.modelLineWrappedLineIdx + 1 : d.getViewLineCount();
        for (let u = h; u < c; u++) a.push(new $5(l, u));
      }
      if (!d.isVisible() && r) {
        const h = new W(l - 1, this.model.getLineMaxColumn(l - 1) + 1), c = D.fromPositions(r, h);
        o.push(new G5(c, a)), a = [], r = null;
      } else d.isVisible() && !r && (r = new W(l, 1));
    }
    if (r) {
      const l = D.fromPositions(r, this.getModelEndPositionOfViewLine(s));
      o.push(new G5(l, a));
    }
    return o;
  }
  getViewLinesBracketGuides(e, t, n, s) {
    const o = n ? this.convertViewPositionToModelPosition(n.lineNumber, n.column) : null, r = [];
    for (const a of this.getViewLineInfosGroupedByModelRanges(e, t)) {
      const l = a.modelRange.startLineNumber, d = this.model.guides.getLinesBracketGuides(l, a.modelRange.endLineNumber, o, s);
      for (const h of a.viewLines) {
        const c = d[h.modelLineNumber - l].map((u) => {
          if (u.forWrappedLinesAfterColumn !== -1 && this.modelLineProjections[h.modelLineNumber - 1].getViewPositionOfModelPosition(0, u.forWrappedLinesAfterColumn).lineNumber >= h.modelLineWrappedLineIdx || u.forWrappedLinesBeforeOrAtColumn !== -1 && this.modelLineProjections[h.modelLineNumber - 1].getViewPositionOfModelPosition(0, u.forWrappedLinesBeforeOrAtColumn).lineNumber < h.modelLineWrappedLineIdx)
            return;
          if (!u.horizontalLine) return u;
          let g = -1;
          if (u.column !== -1) {
            const _ = this.modelLineProjections[h.modelLineNumber - 1].getViewPositionOfModelPosition(0, u.column);
            if (_.lineNumber === h.modelLineWrappedLineIdx) g = _.column;
            else if (_.lineNumber < h.modelLineWrappedLineIdx) g = this.getMinColumnOfViewLine(h);
            else if (_.lineNumber > h.modelLineWrappedLineIdx) return;
          }
          const p = this.convertModelPositionToViewPosition(h.modelLineNumber, u.horizontalLine.endColumn), f = this.modelLineProjections[h.modelLineNumber - 1].getViewPositionOfModelPosition(0, u.horizontalLine.endColumn);
          return f.lineNumber === h.modelLineWrappedLineIdx ? new Tu(u.visibleColumn, g, u.className, new s0(u.horizontalLine.top, p.column), -1, -1) : f.lineNumber < h.modelLineWrappedLineIdx || u.visibleColumn !== -1 ? void 0 : new Tu(u.visibleColumn, g, u.className, new s0(u.horizontalLine.top, this.getMaxColumnOfViewLine(h)), -1, -1);
        });
        r.push(c.filter((u) => !!u));
      }
    }
    return r;
  }
  getViewLinesIndentGuides(e, t) {
    e = this._toValidViewLineNumber(e), t = this._toValidViewLineNumber(t);
    const n = this.convertViewPositionToModelPosition(e, this.getViewLineMinColumn(e)), s = this.convertViewPositionToModelPosition(t, this.getViewLineMaxColumn(t));
    let o = [];
    const r = [], a = [], l = n.lineNumber - 1, d = s.lineNumber - 1;
    let h = null;
    for (let p = l; p <= d; p++) {
      const f = this.modelLineProjections[p];
      if (f.isVisible()) {
        const _ = f.getViewLineNumberOfModelPosition(0, p === l ? n.column : 1), v = f.getViewLineNumberOfModelPosition(0, this.model.getLineMaxColumn(p + 1)), b = v - _ + 1;
        let C = 0;
        b > 1 && f.getViewLineMinColumn(this.model, p + 1, v) === 1 && (C = _ === 0 ? 1 : 2), r.push(b), a.push(C), h === null && (h = new W(p + 1, 0));
      } else h !== null && (o = o.concat(this.model.guides.getLinesIndentGuides(h.lineNumber, p)), h = null);
    }
    h !== null && (o = o.concat(this.model.guides.getLinesIndentGuides(h.lineNumber, s.lineNumber)), h = null);
    const c = t - e + 1, u = new Array(c);
    let g = 0;
    for (let p = 0, f = o.length; p < f; p++) {
      let _ = o[p];
      const v = Math.min(c - g, r[p]), b = a[p];
      let C;
      C = b === 2 ? 0 : b === 1 ? 1 : v;
      for (let w = 0; w < v; w++) w === C && (_ = 0), u[g++] = _;
    }
    return u;
  }
  getViewLineContent(e) {
    const t = this.getViewLineInfo(e);
    return this.modelLineProjections[t.modelLineNumber - 1].getViewLineContent(this.model, t.modelLineNumber, t.modelLineWrappedLineIdx);
  }
  getViewLineLength(e) {
    const t = this.getViewLineInfo(e);
    return this.modelLineProjections[t.modelLineNumber - 1].getViewLineLength(this.model, t.modelLineNumber, t.modelLineWrappedLineIdx);
  }
  getViewLineMinColumn(e) {
    const t = this.getViewLineInfo(e);
    return this.modelLineProjections[t.modelLineNumber - 1].getViewLineMinColumn(this.model, t.modelLineNumber, t.modelLineWrappedLineIdx);
  }
  getViewLineMaxColumn(e) {
    const t = this.getViewLineInfo(e);
    return this.modelLineProjections[t.modelLineNumber - 1].getViewLineMaxColumn(this.model, t.modelLineNumber, t.modelLineWrappedLineIdx);
  }
  getViewLineData(e) {
    const t = this.getViewLineInfo(e);
    return this.modelLineProjections[t.modelLineNumber - 1].getViewLineData(this.model, t.modelLineNumber, t.modelLineWrappedLineIdx);
  }
  getViewLinesData(e, t, n) {
    e = this._toValidViewLineNumber(e), t = this._toValidViewLineNumber(t);
    const s = this.projectedModelLineLineCounts.getIndexOf(e - 1);
    let o = e;
    const r = s.index, a = s.remainder, l = [];
    for (let d = r, h = this.model.getLineCount(); d < h; d++) {
      const c = this.modelLineProjections[d];
      if (!c.isVisible()) continue;
      const u = d === r ? a : 0;
      let g = c.getViewLineCount() - u, p = !1;
      if (o + g > t && (p = !0, g = t - o + 1), c.getViewLinesData(this.model, d + 1, u, g, o - e, n, l), o += g, p) break;
    }
    return l;
  }
  validateViewPosition(e, t, n) {
    e = this._toValidViewLineNumber(e);
    const s = this.projectedModelLineLineCounts.getIndexOf(e - 1), o = s.index, r = s.remainder, a = this.modelLineProjections[o], l = a.getViewLineMinColumn(this.model, o + 1, r), d = a.getViewLineMaxColumn(this.model, o + 1, r);
    t < l && (t = l), t > d && (t = d);
    const h = a.getModelColumnOfViewPosition(r, t);
    return this.model.validatePosition(new W(o + 1, h)).equals(n) ? new W(e, t) : this.convertModelPositionToViewPosition(n.lineNumber, n.column);
  }
  validateViewRange(e, t) {
    const n = this.validateViewPosition(e.startLineNumber, e.startColumn, t.getStartPosition()), s = this.validateViewPosition(e.endLineNumber, e.endColumn, t.getEndPosition());
    return new D(n.lineNumber, n.column, s.lineNumber, s.column);
  }
  convertViewPositionToModelPosition(e, t) {
    const n = this.getViewLineInfo(e), s = this.modelLineProjections[n.modelLineNumber - 1].getModelColumnOfViewPosition(n.modelLineWrappedLineIdx, t);
    return this.model.validatePosition(new W(n.modelLineNumber, s));
  }
  convertViewRangeToModelRange(e) {
    const t = this.convertViewPositionToModelPosition(e.startLineNumber, e.startColumn), n = this.convertViewPositionToModelPosition(e.endLineNumber, e.endColumn);
    return new D(t.lineNumber, t.column, n.lineNumber, n.column);
  }
  convertModelPositionToViewPosition(e, t, n = 2, s = !1, o = !1) {
    const r = this.model.validatePosition(new W(e, t)), a = r.lineNumber, l = r.column;
    let d = a - 1, h = !1;
    if (o) for (; d < this.modelLineProjections.length && !this.modelLineProjections[d].isVisible(); ) d++, h = !0;
    else for (; d > 0 && !this.modelLineProjections[d].isVisible(); ) d--, h = !0;
    if (d === 0 && !this.modelLineProjections[d].isVisible()) return new W(s ? 0 : 1, 1);
    const c = 1 + this.projectedModelLineLineCounts.getPrefixSum(d);
    let u;
    return u = h ? o ? this.modelLineProjections[d].getViewPositionOfModelPosition(c, 1, n) : this.modelLineProjections[d].getViewPositionOfModelPosition(c, this.model.getLineMaxColumn(d + 1), n) : this.modelLineProjections[a - 1].getViewPositionOfModelPosition(c, l, n), u;
  }
  convertModelRangeToViewRange(e, t = 0) {
    if (e.isEmpty()) {
      const n = this.convertModelPositionToViewPosition(e.startLineNumber, e.startColumn, t);
      return D.fromPositions(n);
    }
    {
      const n = this.convertModelPositionToViewPosition(e.startLineNumber, e.startColumn, 1), s = this.convertModelPositionToViewPosition(e.endLineNumber, e.endColumn, 0);
      return new D(n.lineNumber, n.column, s.lineNumber, s.column);
    }
  }
  getViewLineNumberOfModelPosition(e, t) {
    let n = e - 1;
    if (this.modelLineProjections[n].isVisible()) {
      const o = 1 + this.projectedModelLineLineCounts.getPrefixSum(n);
      return this.modelLineProjections[n].getViewLineNumberOfModelPosition(o, t);
    }
    for (; n > 0 && !this.modelLineProjections[n].isVisible(); ) n--;
    if (n === 0 && !this.modelLineProjections[n].isVisible()) return 1;
    const s = 1 + this.projectedModelLineLineCounts.getPrefixSum(n);
    return this.modelLineProjections[n].getViewLineNumberOfModelPosition(s, this.model.getLineMaxColumn(n + 1));
  }
  getDecorationsInRange(e, t, n, s, o) {
    const r = this.convertViewPositionToModelPosition(e.startLineNumber, e.startColumn), a = this.convertViewPositionToModelPosition(e.endLineNumber, e.endColumn);
    if (a.lineNumber - r.lineNumber <= e.endLineNumber - e.startLineNumber) return this.model.getDecorationsInRange(new D(r.lineNumber, 1, a.lineNumber, a.column), t, n, s, o);
    let l = [];
    const d = r.lineNumber - 1, h = a.lineNumber - 1;
    let c = null;
    for (let f = d; f <= h; f++)
      if (this.modelLineProjections[f].isVisible()) c === null && (c = new W(f + 1, f === d ? r.column : 1));
      else if (c !== null) {
        const _ = this.model.getLineMaxColumn(f);
        l = l.concat(this.model.getDecorationsInRange(new D(c.lineNumber, c.column, f, _), t, n, s)), c = null;
      }
    c !== null && (l = l.concat(this.model.getDecorationsInRange(new D(c.lineNumber, c.column, a.lineNumber, a.column), t, n, s)), c = null), l.sort((f, _) => {
      const v = D.compareRangesUsingStarts(f.range, _.range);
      return v === 0 ? f.id < _.id ? -1 : f.id > _.id ? 1 : 0 : v;
    });
    const u = [];
    let g = 0, p = null;
    for (const f of l) {
      const _ = f.id;
      p !== _ && (p = _, u[g++] = f);
    }
    return u;
  }
  getInjectedTextAt(e) {
    const t = this.getViewLineInfo(e.lineNumber);
    return this.modelLineProjections[t.modelLineNumber - 1].getInjectedTextAt(t.modelLineWrappedLineIdx, e.column);
  }
  normalizePosition(e, t) {
    const n = this.getViewLineInfo(e.lineNumber);
    return this.modelLineProjections[n.modelLineNumber - 1].normalizePosition(n.modelLineWrappedLineIdx, e, t);
  }
  getLineIndentColumn(e) {
    const t = this.getViewLineInfo(e);
    return t.modelLineWrappedLineIdx === 0 ? this.model.getLineIndentColumn(t.modelLineNumber) : 0;
  }
}
class $5 {
  constructor(e, t) {
    this.modelLineNumber = e, this.modelLineWrappedLineIdx = t;
  }
}
class G5 {
  constructor(e, t) {
    this.modelRange = e, this.viewLines = t;
  }
}
class WQ {
  constructor(e) {
    this._lines = e;
  }
  convertViewPositionToModelPosition(e) {
    return this._lines.convertViewPositionToModelPosition(e.lineNumber, e.column);
  }
  convertViewRangeToModelRange(e) {
    return this._lines.convertViewRangeToModelRange(e);
  }
  validateViewPosition(e, t) {
    return this._lines.validateViewPosition(e.lineNumber, e.column, t);
  }
  validateViewRange(e, t) {
    return this._lines.validateViewRange(e, t);
  }
  convertModelPositionToViewPosition(e, t, n, s) {
    return this._lines.convertModelPositionToViewPosition(e.lineNumber, e.column, t, n, s);
  }
  convertModelRangeToViewRange(e, t) {
    return this._lines.convertModelRangeToViewRange(e, t);
  }
  modelPositionIsVisible(e) {
    return this._lines.modelPositionIsVisible(e.lineNumber, e.column);
  }
  getModelLineViewLineCount(e) {
    return this._lines.getModelLineViewLineCount(e);
  }
  getViewLineNumberOfModelPosition(e, t) {
    return this._lines.getViewLineNumberOfModelPosition(e, t);
  }
}
class VQ {
  constructor(e) {
    this.model = e;
  }
  dispose() {
  }
  createCoordinatesConverter() {
    return new HQ(this);
  }
  getHiddenAreas() {
    return [];
  }
  setHiddenAreas(e) {
    return !1;
  }
  setTabSize(e) {
    return !1;
  }
  setWrappingSettings(e, t, n, s) {
    return !1;
  }
  createLineBreaksComputer() {
    const e = [];
    return { addRequest: (t, n, s) => {
      e.push(null);
    }, finalize: () => e };
  }
  onModelFlushed() {
  }
  onModelLinesDeleted(e, t, n) {
    return new CI(t, n);
  }
  onModelLinesInserted(e, t, n, s) {
    return new wI(t, n);
  }
  onModelLineChanged(e, t, n) {
    return [!1, new uW(t, 1), null, null];
  }
  acceptVersionId(e) {
  }
  getViewLineCount() {
    return this.model.getLineCount();
  }
  getActiveIndentGuide(e, t, n) {
    return { startLineNumber: e, endLineNumber: e, indent: 0 };
  }
  getViewLinesBracketGuides(e, t, n) {
    return new Array(t - e + 1).fill([]);
  }
  getViewLinesIndentGuides(e, t) {
    const n = t - e + 1, s = new Array(n);
    for (let o = 0; o < n; o++) s[o] = 0;
    return s;
  }
  getViewLineContent(e) {
    return this.model.getLineContent(e);
  }
  getViewLineLength(e) {
    return this.model.getLineLength(e);
  }
  getViewLineMinColumn(e) {
    return this.model.getLineMinColumn(e);
  }
  getViewLineMaxColumn(e) {
    return this.model.getLineMaxColumn(e);
  }
  getViewLineData(e) {
    const t = this.model.tokenization.getLineTokens(e), n = t.getLineContent();
    return new TR(n, !1, 1, n.length + 1, 0, t.inflate(), null);
  }
  getViewLinesData(e, t, n) {
    const s = this.model.getLineCount();
    e = Math.min(Math.max(1, e), s), t = Math.min(Math.max(1, t), s);
    const o = [];
    for (let r = e; r <= t; r++) {
      const a = r - e;
      o[a] = n[a] ? this.getViewLineData(r) : null;
    }
    return o;
  }
  getDecorationsInRange(e, t, n, s, o) {
    return this.model.getDecorationsInRange(e, t, n, s, o);
  }
  normalizePosition(e, t) {
    return this.model.normalizePosition(e, t);
  }
  getLineIndentColumn(e) {
    return this.model.getLineIndentColumn(e);
  }
  getInjectedTextAt(e) {
    return null;
  }
}
class HQ {
  constructor(e) {
    this._lines = e;
  }
  _validPosition(e) {
    return this._lines.model.validatePosition(e);
  }
  _validRange(e) {
    return this._lines.model.validateRange(e);
  }
  convertViewPositionToModelPosition(e) {
    return this._validPosition(e);
  }
  convertViewRangeToModelRange(e) {
    return this._validRange(e);
  }
  validateViewPosition(e, t) {
    return this._validPosition(t);
  }
  validateViewRange(e, t) {
    return this._validRange(t);
  }
  convertModelPositionToViewPosition(e) {
    return this._validPosition(e);
  }
  convertModelRangeToViewRange(e) {
    return this._validRange(e);
  }
  modelPositionIsVisible(e) {
    const t = this._lines.model.getLineCount();
    return !(e.lineNumber < 1 || e.lineNumber > t);
  }
  getModelLineViewLineCount(e) {
    return 1;
  }
  getViewLineNumberOfModelPosition(e, t) {
    return e;
  }
}
const jc = _l.Right;
class zQ {
  constructor(e) {
    this.persist = 0, this._requiredLanes = 1, this.lanes = new Uint8Array(Math.ceil((e + 1) * jc / 8));
  }
  reset(e) {
    const t = Math.ceil((e + 1) * jc / 8);
    this.lanes.length < t ? this.lanes = new Uint8Array(t) : this.lanes.fill(0), this._requiredLanes = 1;
  }
  get requiredLanes() {
    return this._requiredLanes;
  }
  push(e, t, n) {
    n && (this.persist |= 1 << e - 1);
    for (let s = t.startLineNumber; s <= t.endLineNumber; s++) {
      const o = jc * s + (e - 1);
      this.lanes[o >>> 3] |= 1 << o % 8, this._requiredLanes = Math.max(this._requiredLanes, this.countAtLine(s));
    }
  }
  getLanesAtLine(e) {
    const t = [];
    let n = jc * e;
    for (let s = 0; s < jc; s++) (this.persist & 1 << s || this.lanes[n >>> 3] & 1 << n % 8) && t.push(s + 1), n++;
    return t.length ? t : [_l.Center];
  }
  countAtLine(e) {
    let t = jc * e, n = 0;
    for (let s = 0; s < jc; s++) (this.persist & 1 << s || this.lanes[t >>> 3] & 1 << t % 8) && n++, t++;
    return n;
  }
}
let UQ = class extends V {
  constructor(i, e, t, n, s, o, r, a, l) {
    if (super(), this.languageConfigurationService = r, this._themeService = a, this._attachedView = l, this.hiddenAreasModel = new jQ(), this.previousHiddenAreas = [], this._editorId = i, this._configuration = e, this.model = t, this._eventDispatcher = new fQ(), this.onEvent = this._eventDispatcher.onEvent, this.cursorConfig = new $g(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService), this._updateConfigurationViewLineCount = this._register(new It(() => this._updateConfigurationViewLineCountNow(), 0)), this._hasFocus = !1, this._viewportStart = cA.create(this.model), this.glyphLanes = new zQ(0), this.model.isTooLargeForTokenization()) this._lines = new VQ(this.model);
    else {
      const d = this._configuration.options, h = d.get(50), c = d.get(139), u = d.get(146), g = d.get(138), p = d.get(129);
      this._lines = new BQ(this._editorId, this.model, n, s, h, this.model.getOptions().tabSize, c, u.wrappingColumn, g, p);
    }
    this.coordinatesConverter = this._lines.createCoordinatesConverter(), this._cursor = this._register(new xQ(t, this, this.coordinatesConverter, this.cursorConfig)), this.viewLayout = this._register(new AQ(this._configuration, this.getLineCount(), o)), this._register(this.viewLayout.onDidScroll((d) => {
      d.scrollTopChanged && this._handleVisibleLinesChanged(), d.scrollTopChanged && this._viewportStart.invalidate(), this._eventDispatcher.emitSingleViewEvent(new cQ(d)), this._eventDispatcher.emitOutgoingEvent(new aA(d.oldScrollWidth, d.oldScrollLeft, d.oldScrollHeight, d.oldScrollTop, d.scrollWidth, d.scrollLeft, d.scrollHeight, d.scrollTop));
    })), this._register(this.viewLayout.onDidContentSizeChange((d) => {
      this._eventDispatcher.emitOutgoingEvent(d);
    })), this._decorations = new PQ(this._editorId, this.model, this._configuration, this._lines, this.coordinatesConverter), this._registerModelEvents(), this._register(this._configuration.onDidChangeFast((d) => {
      try {
        const h = this._eventDispatcher.beginEmitViewEvents();
        this._onConfigurationChanged(h, d);
      } finally {
        this._eventDispatcher.endEmitViewEvents();
      }
    })), this._register(E1.getInstance().onDidChange(() => {
      this._eventDispatcher.emitSingleViewEvent(new pQ());
    })), this._register(this._themeService.onDidColorThemeChange((d) => {
      this._invalidateDecorationsColorCache(), this._eventDispatcher.emitSingleViewEvent(new uQ(d));
    })), this._updateConfigurationViewLineCountNow();
  }
  dispose() {
    super.dispose(), this._decorations.dispose(), this._lines.dispose(), this._viewportStart.dispose(), this._eventDispatcher.dispose();
  }
  createLineBreaksComputer() {
    return this._lines.createLineBreaksComputer();
  }
  addViewEventHandler(i) {
    this._eventDispatcher.addViewEventHandler(i);
  }
  removeViewEventHandler(i) {
    this._eventDispatcher.removeViewEventHandler(i);
  }
  _updateConfigurationViewLineCountNow() {
    this._configuration.setViewLineCount(this._lines.getViewLineCount());
  }
  getModelVisibleRanges() {
    const i = this.viewLayout.getLinesViewportData(), e = new D(i.startLineNumber, this.getLineMinColumn(i.startLineNumber), i.endLineNumber, this.getLineMaxColumn(i.endLineNumber));
    return this._toModelVisibleRanges(e);
  }
  visibleLinesStabilized() {
    const i = this.getModelVisibleRanges();
    this._attachedView.setVisibleLines(i, !0);
  }
  _handleVisibleLinesChanged() {
    const i = this.getModelVisibleRanges();
    this._attachedView.setVisibleLines(i, !1);
  }
  setHasFocus(i) {
    this._hasFocus = i, this._cursor.setHasFocus(i), this._eventDispatcher.emitSingleViewEvent(new dQ(i)), this._eventDispatcher.emitOutgoingEvent(new rA(!i, i));
  }
  onCompositionStart() {
    this._eventDispatcher.emitSingleViewEvent(new oQ());
  }
  onCompositionEnd() {
    this._eventDispatcher.emitSingleViewEvent(new rQ());
  }
  _captureStableViewport() {
    if (this._viewportStart.isValid && this.viewLayout.getCurrentScrollTop() > 0) {
      const i = new W(this._viewportStart.viewLineNumber, this.getLineMinColumn(this._viewportStart.viewLineNumber)), e = this.coordinatesConverter.convertViewPositionToModelPosition(i);
      return new Y5(e, this._viewportStart.startLineDelta);
    }
    return new Y5(null, 0);
  }
  _onConfigurationChanged(i, e) {
    const t = this._captureStableViewport(), n = this._configuration.options, s = n.get(50), o = n.get(139), r = n.get(146), a = n.get(138), l = n.get(129);
    this._lines.setWrappingSettings(s, o, r.wrappingColumn, a, l) && (i.emitViewEvent(new kb()), i.emitViewEvent(new Db()), i.emitViewEvent(new Kc(null)), this._cursor.onLineMappingChanged(i), this._decorations.onLineMappingChanged(), this.viewLayout.onFlushed(this.getLineCount()), this._updateConfigurationViewLineCount.schedule()), e.hasChanged(91) && (this._decorations.reset(), i.emitViewEvent(new Kc(null))), e.hasChanged(98) && (this._decorations.reset(), i.emitViewEvent(new Kc(null))), i.emitViewEvent(new aQ(e)), this.viewLayout.onConfigurationChanged(e), t.recoverViewportStart(this.coordinatesConverter, this.viewLayout), $g.shouldRecreate(e) && (this.cursorConfig = new $g(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService), this._cursor.updateConfiguration(this.cursorConfig));
  }
  _registerModelEvents() {
    this._register(this.model.onDidChangeContentOrInjectedText((i) => {
      try {
        const t = this._eventDispatcher.beginEmitViewEvents();
        let n = !1, s = !1;
        const o = i instanceof $u ? i.rawContentChangedEvent.changes : i.changes, r = i instanceof $u ? i.rawContentChangedEvent.versionId : null, a = this._lines.createLineBreaksComputer();
        for (const h of o) switch (h.changeType) {
          case 4:
            for (let c = 0; c < h.detail.length; c++) {
              const u = h.detail[c];
              let g = h.injectedTexts[c];
              g && (g = g.filter((p) => !p.ownerId || p.ownerId === this._editorId)), a.addRequest(u, g, null);
            }
            break;
          case 2: {
            let c = null;
            h.injectedText && (c = h.injectedText.filter((u) => !u.ownerId || u.ownerId === this._editorId)), a.addRequest(h.detail, c, null);
            break;
          }
        }
        const l = a.finalize(), d = new Pd(l);
        for (const h of o) switch (h.changeType) {
          case 1:
            this._lines.onModelFlushed(), t.emitViewEvent(new kb()), this._decorations.reset(), this.viewLayout.onFlushed(this.getLineCount()), n = !0;
            break;
          case 3: {
            const c = this._lines.onModelLinesDeleted(r, h.fromLineNumber, h.toLineNumber);
            c !== null && (t.emitViewEvent(c), this.viewLayout.onLinesDeleted(c.fromLineNumber, c.toLineNumber)), n = !0;
            break;
          }
          case 4: {
            const c = d.takeCount(h.detail.length), u = this._lines.onModelLinesInserted(r, h.fromLineNumber, h.toLineNumber, c);
            u !== null && (t.emitViewEvent(u), this.viewLayout.onLinesInserted(u.fromLineNumber, u.toLineNumber)), n = !0;
            break;
          }
          case 2: {
            const c = d.dequeue(), [u, g, p, f] = this._lines.onModelLineChanged(r, h.lineNumber, c);
            s = u, g && t.emitViewEvent(g), p && (t.emitViewEvent(p), this.viewLayout.onLinesInserted(p.fromLineNumber, p.toLineNumber)), f && (t.emitViewEvent(f), this.viewLayout.onLinesDeleted(f.fromLineNumber, f.toLineNumber));
            break;
          }
        }
        r !== null && this._lines.acceptVersionId(r), this.viewLayout.onHeightMaybeChanged(), !n && s && (t.emitViewEvent(new Db()), t.emitViewEvent(new Kc(null)), this._cursor.onLineMappingChanged(t), this._decorations.onLineMappingChanged());
      } finally {
        this._eventDispatcher.endEmitViewEvents();
      }
      const e = this._viewportStart.isValid;
      if (this._viewportStart.invalidate(), this._configuration.setModelLineCount(this.model.getLineCount()), this._updateConfigurationViewLineCountNow(), !this._hasFocus && this.model.getAttachedEditorCount() >= 2 && e) {
        const t = this.model._getTrackedRange(this._viewportStart.modelTrackedRange);
        if (t) {
          const n = this.coordinatesConverter.convertModelPositionToViewPosition(t.getStartPosition()), s = this.viewLayout.getVerticalOffsetForLineNumber(n.lineNumber);
          this.viewLayout.setScrollPosition({ scrollTop: s + this._viewportStart.startLineDelta }, 1);
        }
      }
      try {
        const t = this._eventDispatcher.beginEmitViewEvents();
        i instanceof $u && t.emitOutgoingEvent(new LQ(i.contentChangedEvent)), this._cursor.onModelContentChanged(t, i);
      } finally {
        this._eventDispatcher.endEmitViewEvents();
      }
      this._handleVisibleLinesChanged();
    })), this._register(this.model.onDidChangeTokens((i) => {
      const e = [];
      for (let t = 0, n = i.ranges.length; t < n; t++) {
        const s = i.ranges[t], o = this.coordinatesConverter.convertModelPositionToViewPosition(new W(s.fromLineNumber, 1)).lineNumber, r = this.coordinatesConverter.convertModelPositionToViewPosition(new W(s.toLineNumber, this.model.getLineMaxColumn(s.toLineNumber))).lineNumber;
        e[t] = { fromLineNumber: o, toLineNumber: r };
      }
      this._eventDispatcher.emitSingleViewEvent(new gQ(e)), this._eventDispatcher.emitOutgoingEvent(new DQ(i));
    })), this._register(this.model.onDidChangeLanguageConfiguration((i) => {
      this._eventDispatcher.emitSingleViewEvent(new hQ()), this.cursorConfig = new $g(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService), this._cursor.updateConfiguration(this.cursorConfig), this._eventDispatcher.emitOutgoingEvent(new SQ(i));
    })), this._register(this.model.onDidChangeLanguage((i) => {
      this.cursorConfig = new $g(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService), this._cursor.updateConfiguration(this.cursorConfig), this._eventDispatcher.emitOutgoingEvent(new yQ(i));
    })), this._register(this.model.onDidChangeOptions((i) => {
      if (this._lines.setTabSize(this.model.getOptions().tabSize)) {
        try {
          const e = this._eventDispatcher.beginEmitViewEvents();
          e.emitViewEvent(new kb()), e.emitViewEvent(new Db()), e.emitViewEvent(new Kc(null)), this._cursor.onLineMappingChanged(e), this._decorations.onLineMappingChanged(), this.viewLayout.onFlushed(this.getLineCount());
        } finally {
          this._eventDispatcher.endEmitViewEvents();
        }
        this._updateConfigurationViewLineCount.schedule();
      }
      this.cursorConfig = new $g(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService), this._cursor.updateConfiguration(this.cursorConfig), this._eventDispatcher.emitOutgoingEvent(new kQ(i));
    })), this._register(this.model.onDidChangeDecorations((i) => {
      this._decorations.onModelDecorationsChanged(), this._eventDispatcher.emitSingleViewEvent(new Kc(i)), this._eventDispatcher.emitOutgoingEvent(new wQ(i));
    }));
  }
  setHiddenAreas(i, e) {
    var t;
    this.hiddenAreasModel.setHiddenAreas(e, i);
    const n = this.hiddenAreasModel.getMergedRanges();
    if (n === this.previousHiddenAreas) return;
    this.previousHiddenAreas = n;
    const s = this._captureStableViewport();
    let o = !1;
    try {
      const r = this._eventDispatcher.beginEmitViewEvents();
      o = this._lines.setHiddenAreas(n), o && (r.emitViewEvent(new kb()), r.emitViewEvent(new Db()), r.emitViewEvent(new Kc(null)), this._cursor.onLineMappingChanged(r), this._decorations.onLineMappingChanged(), this.viewLayout.onFlushed(this.getLineCount()), this.viewLayout.onHeightMaybeChanged());
      const a = (t = s.viewportStartModelPosition) === null || t === void 0 ? void 0 : t.lineNumber;
      a && n.some((d) => d.startLineNumber <= a && a <= d.endLineNumber) || s.recoverViewportStart(this.coordinatesConverter, this.viewLayout);
    } finally {
      this._eventDispatcher.endEmitViewEvents();
    }
    this._updateConfigurationViewLineCount.schedule(), o && this._eventDispatcher.emitOutgoingEvent(new bQ());
  }
  getVisibleRangesPlusViewportAboveBelow() {
    const i = this._configuration.options.get(145), e = this._configuration.options.get(67), t = Math.max(20, Math.round(i.height / e)), n = this.viewLayout.getLinesViewportData(), s = Math.max(1, n.completelyVisibleStartLineNumber - t), o = Math.min(this.getLineCount(), n.completelyVisibleEndLineNumber + t);
    return this._toModelVisibleRanges(new D(s, this.getLineMinColumn(s), o, this.getLineMaxColumn(o)));
  }
  getVisibleRanges() {
    const i = this.getCompletelyVisibleViewRange();
    return this._toModelVisibleRanges(i);
  }
  getHiddenAreas() {
    return this._lines.getHiddenAreas();
  }
  _toModelVisibleRanges(i) {
    const e = this.coordinatesConverter.convertViewRangeToModelRange(i), t = this._lines.getHiddenAreas();
    if (t.length === 0) return [e];
    const n = [];
    let s = 0, o = e.startLineNumber, r = e.startColumn;
    const a = e.endLineNumber, l = e.endColumn;
    for (let d = 0, h = t.length; d < h; d++) {
      const c = t[d].startLineNumber, u = t[d].endLineNumber;
      u < o || c > a || (o < c && (n[s++] = new D(o, r, c - 1, this.model.getLineMaxColumn(c - 1))), o = u + 1, r = 1);
    }
    return (o < a || o === a && r < l) && (n[s++] = new D(o, r, a, l)), n;
  }
  getCompletelyVisibleViewRange() {
    const i = this.viewLayout.getLinesViewportData(), e = i.completelyVisibleStartLineNumber, t = i.completelyVisibleEndLineNumber;
    return new D(e, this.getLineMinColumn(e), t, this.getLineMaxColumn(t));
  }
  getCompletelyVisibleViewRangeAtScrollTop(i) {
    const e = this.viewLayout.getLinesViewportDataAtScrollTop(i), t = e.completelyVisibleStartLineNumber, n = e.completelyVisibleEndLineNumber;
    return new D(t, this.getLineMinColumn(t), n, this.getLineMaxColumn(n));
  }
  saveState() {
    const i = this.viewLayout.saveState(), e = i.scrollTop, t = this.viewLayout.getLineNumberAtVerticalOffset(e), n = this.coordinatesConverter.convertViewPositionToModelPosition(new W(t, this.getLineMinColumn(t))), s = this.viewLayout.getVerticalOffsetForLineNumber(t) - e;
    return { scrollLeft: i.scrollLeft, firstPosition: n, firstPositionDeltaTop: s };
  }
  reduceRestoreState(i) {
    if (i.firstPosition === void 0) return this._reduceRestoreStateCompatibility(i);
    const e = this.model.validatePosition(i.firstPosition), t = this.coordinatesConverter.convertModelPositionToViewPosition(e), n = this.viewLayout.getVerticalOffsetForLineNumber(t.lineNumber) - i.firstPositionDeltaTop;
    return { scrollLeft: i.scrollLeft, scrollTop: n };
  }
  _reduceRestoreStateCompatibility(i) {
    return { scrollLeft: i.scrollLeft, scrollTop: i.scrollTopWithoutViewZones };
  }
  getTabSize() {
    return this.model.getOptions().tabSize;
  }
  getLineCount() {
    return this._lines.getViewLineCount();
  }
  setViewport(i, e, t) {
    this._viewportStart.update(this, i);
  }
  getActiveIndentGuide(i, e, t) {
    return this._lines.getActiveIndentGuide(i, e, t);
  }
  getLinesIndentGuides(i, e) {
    return this._lines.getViewLinesIndentGuides(i, e);
  }
  getBracketGuidesInRangeByLine(i, e, t, n) {
    return this._lines.getViewLinesBracketGuides(i, e, t, n);
  }
  getLineContent(i) {
    return this._lines.getViewLineContent(i);
  }
  getLineLength(i) {
    return this._lines.getViewLineLength(i);
  }
  getLineMinColumn(i) {
    return this._lines.getViewLineMinColumn(i);
  }
  getLineMaxColumn(i) {
    return this._lines.getViewLineMaxColumn(i);
  }
  getLineFirstNonWhitespaceColumn(i) {
    const e = Jn(this.getLineContent(i));
    return e === -1 ? 0 : e + 1;
  }
  getLineLastNonWhitespaceColumn(i) {
    const e = ra(this.getLineContent(i));
    return e === -1 ? 0 : e + 2;
  }
  getMinimapDecorationsInRange(i) {
    return this._decorations.getMinimapDecorationsInRange(i);
  }
  getDecorationsInViewport(i) {
    return this._decorations.getDecorationsViewportData(i).decorations;
  }
  getInjectedTextAt(i) {
    return this._lines.getInjectedTextAt(i);
  }
  getViewportViewLineRenderingData(i, e) {
    const t = this._decorations.getDecorationsViewportData(i).inlineDecorations[e - i.startLineNumber];
    return this._getViewLineRenderingData(e, t);
  }
  getViewLineRenderingData(i) {
    const e = this._decorations.getInlineDecorationsOnLine(i);
    return this._getViewLineRenderingData(i, e);
  }
  _getViewLineRenderingData(i, e) {
    const t = this.model.mightContainRTL(), n = this.model.mightContainNonBasicASCII(), s = this.getTabSize(), o = this._lines.getViewLineData(i);
    return o.inlineDecorations && (e = [...e, ...o.inlineDecorations.map((r) => r.toInlineDecoration(i))]), new Co(o.minColumn, o.maxColumn, o.content, o.continuesWithWrappedLine, t, n, o.tokens, e, s, o.startVisibleColumn);
  }
  getViewLineData(i) {
    return this._lines.getViewLineData(i);
  }
  getMinimapLinesRenderingData(i, e, t) {
    const n = this._lines.getViewLinesData(i, e, t);
    return new Qq(this.getTabSize(), n);
  }
  getAllOverviewRulerDecorations(i) {
    const e = this.model.getOverviewRulerDecorations(this._editorId, Mw(this._configuration.options)), t = new KQ();
    for (const n of e) {
      const s = n.options, o = s.overviewRuler;
      if (!o) continue;
      const r = o.position;
      if (r === 0) continue;
      const a = o.getColor(i.value), l = this.coordinatesConverter.getViewLineNumberOfModelPosition(n.range.startLineNumber, n.range.startColumn), d = this.coordinatesConverter.getViewLineNumberOfModelPosition(n.range.endLineNumber, n.range.endColumn);
      t.accept(a, s.zIndex, l, d, r);
    }
    return t.asArray;
  }
  _invalidateDecorationsColorCache() {
    const i = this.model.getOverviewRulerDecorations();
    for (const e of i) {
      const t = e.options.overviewRuler;
      t == null || t.invalidateCachedColor();
      const n = e.options.minimap;
      n == null || n.invalidateCachedColor();
    }
  }
  getValueInRange(i, e) {
    const t = this.coordinatesConverter.convertViewRangeToModelRange(i);
    return this.model.getValueInRange(t, e);
  }
  getValueLengthInRange(i, e) {
    const t = this.coordinatesConverter.convertViewRangeToModelRange(i);
    return this.model.getValueLengthInRange(t, e);
  }
  modifyPosition(i, e) {
    const t = this.coordinatesConverter.convertViewPositionToModelPosition(i), n = this.model.modifyPosition(t, e);
    return this.coordinatesConverter.convertModelPositionToViewPosition(n);
  }
  deduceModelPositionRelativeToViewPosition(i, e, t) {
    const n = this.coordinatesConverter.convertViewPositionToModelPosition(i);
    this.model.getEOL().length === 2 && (e < 0 ? e -= t : e += t);
    const s = this.model.getOffsetAt(n) + e;
    return this.model.getPositionAt(s);
  }
  getPlainTextToCopy(i, e, t) {
    const n = t ? `\r
` : this.model.getEOL();
    (i = i.slice(0)).sort(D.compareRangesUsingStarts);
    let s = !1, o = !1;
    for (const a of i) a.isEmpty() ? s = !0 : o = !0;
    if (!o) {
      if (!e) return "";
      const a = i.map((d) => d.startLineNumber);
      let l = "";
      for (let d = 0; d < a.length; d++) d > 0 && a[d - 1] === a[d] || (l += this.model.getLineContent(a[d]) + n);
      return l;
    }
    if (s && e) {
      const a = [];
      let l = 0;
      for (const d of i) {
        const h = d.startLineNumber;
        d.isEmpty() ? h !== l && a.push(this.model.getLineContent(h)) : a.push(this.model.getValueInRange(d, t ? 2 : 0)), l = h;
      }
      return a.length === 1 ? a[0] : a;
    }
    const r = [];
    for (const a of i) a.isEmpty() || r.push(this.model.getValueInRange(a, t ? 2 : 0));
    return r.length === 1 ? r[0] : r;
  }
  getRichTextToCopy(i, e) {
    const t = this.model.getLanguageId();
    if (t === ko || i.length !== 1) return null;
    let n = i[0];
    if (n.isEmpty()) {
      if (!e) return null;
      const a = n.startLineNumber;
      n = new D(a, this.model.getLineMinColumn(a), a, this.model.getLineMaxColumn(a));
    }
    const s = this._configuration.options.get(50), o = this._getColorMap();
    let r;
    return /[:;\\\/<>]/.test(s.fontFamily) || s.fontFamily === Is.fontFamily ? r = Is.fontFamily : (r = s.fontFamily, r = r.replace(/"/g, "'"), /[,']/.test(r) || /[+ ]/.test(r) && (r = `'${r}'`), r = `${r}, ${Is.fontFamily}`), { mode: t, html: `<div style="color: ${o[1]};background-color: ${o[2]};font-family: ${r};font-weight: ${s.fontWeight};font-size: ${s.fontSize}px;line-height: ${s.lineHeight}px;white-space: pre;">` + this._getHTMLToCopy(n, o) + "</div>" };
  }
  _getHTMLToCopy(i, e) {
    const t = i.startLineNumber, n = i.startColumn, s = i.endLineNumber, o = i.endColumn, r = this.getTabSize();
    let a = "";
    for (let l = t; l <= s; l++) {
      const d = this.model.tokenization.getLineTokens(l), h = d.getLineContent(), c = l === t ? n - 1 : 0, u = l === s ? o - 1 : h.length;
      a += h === "" ? "<br>" : IQ(h, d.inflate(), e, c, u, r, Tn);
    }
    return a;
  }
  _getColorMap() {
    const i = ci.getColorMap(), e = ["#000000"];
    if (i) for (let t = 1, n = i.length; t < n; t++) e[t] = z.Format.CSS.formatHex(i[t]);
    return e;
  }
  getPrimaryCursorState() {
    return this._cursor.getPrimaryCursorState();
  }
  getLastAddedCursorIndex() {
    return this._cursor.getLastAddedCursorIndex();
  }
  getCursorStates() {
    return this._cursor.getCursorStates();
  }
  setCursorStates(i, e, t) {
    return this._withViewEventsCollector((n) => this._cursor.setStates(n, i, e, t));
  }
  getCursorColumnSelectData() {
    return this._cursor.getCursorColumnSelectData();
  }
  getCursorAutoClosedCharacters() {
    return this._cursor.getAutoClosedCharacters();
  }
  setCursorColumnSelectData(i) {
    this._cursor.setCursorColumnSelectData(i);
  }
  getPrevEditOperationType() {
    return this._cursor.getPrevEditOperationType();
  }
  setPrevEditOperationType(i) {
    this._cursor.setPrevEditOperationType(i);
  }
  getSelection() {
    return this._cursor.getSelection();
  }
  getSelections() {
    return this._cursor.getSelections();
  }
  getPosition() {
    return this._cursor.getPrimaryCursorState().modelState.position;
  }
  setSelections(i, e, t = 0) {
    this._withViewEventsCollector((n) => this._cursor.setSelections(n, i, e, t));
  }
  saveCursorState() {
    return this._cursor.saveState();
  }
  restoreCursorState(i) {
    this._withViewEventsCollector((e) => this._cursor.restoreState(e, i));
  }
  _executeCursorEdit(i) {
    this._cursor.context.cursorConfig.readOnly ? this._eventDispatcher.emitOutgoingEvent(new CQ()) : this._withViewEventsCollector(i);
  }
  executeEdits(i, e, t) {
    this._executeCursorEdit((n) => this._cursor.executeEdits(n, i, e, t));
  }
  startComposition() {
    this._executeCursorEdit((i) => this._cursor.startComposition(i));
  }
  endComposition(i) {
    this._executeCursorEdit((e) => this._cursor.endComposition(e, i));
  }
  type(i, e) {
    this._executeCursorEdit((t) => this._cursor.type(t, i, e));
  }
  compositionType(i, e, t, n, s) {
    this._executeCursorEdit((o) => this._cursor.compositionType(o, i, e, t, n, s));
  }
  paste(i, e, t, n) {
    this._executeCursorEdit((s) => this._cursor.paste(s, i, e, t, n));
  }
  cut(i) {
    this._executeCursorEdit((e) => this._cursor.cut(e, i));
  }
  executeCommand(i, e) {
    this._executeCursorEdit((t) => this._cursor.executeCommand(t, i, e));
  }
  executeCommands(i, e) {
    this._executeCursorEdit((t) => this._cursor.executeCommands(t, i, e));
  }
  revealAllCursors(i, e, t = !1) {
    this._withViewEventsCollector((n) => this._cursor.revealAll(n, i, t, 0, e, 0));
  }
  revealPrimaryCursor(i, e, t = !1) {
    this._withViewEventsCollector((n) => this._cursor.revealPrimary(n, i, t, 0, e, 0));
  }
  revealTopMostCursor(i) {
    const e = this._cursor.getTopMostViewPosition(), t = new D(e.lineNumber, e.column, e.lineNumber, e.column);
    this._withViewEventsCollector((n) => n.emitViewEvent(new g0(i, !1, t, null, 0, !0, 0)));
  }
  revealBottomMostCursor(i) {
    const e = this._cursor.getBottomMostViewPosition(), t = new D(e.lineNumber, e.column, e.lineNumber, e.column);
    this._withViewEventsCollector((n) => n.emitViewEvent(new g0(i, !1, t, null, 0, !0, 0)));
  }
  revealRange(i, e, t, n, s) {
    this._withViewEventsCollector((o) => o.emitViewEvent(new g0(i, !1, t, null, n, e, s)));
  }
  changeWhitespace(i) {
    this.viewLayout.changeWhitespace(i) && (this._eventDispatcher.emitSingleViewEvent(new mQ()), this._eventDispatcher.emitOutgoingEvent(new vQ()));
  }
  _withViewEventsCollector(i) {
    try {
      return i(this._eventDispatcher.beginEmitViewEvents());
    } finally {
      this._eventDispatcher.endEmitViewEvents();
    }
  }
  normalizePosition(i, e) {
    return this._lines.normalizePosition(i, e);
  }
  getLineIndentColumn(i) {
    return this._lines.getLineIndentColumn(i);
  }
};
class cA {
  static create(e) {
    const t = e._setTrackedRange(null, new D(1, 1, 1, 1), 1);
    return new cA(e, 1, !1, t, 0);
  }
  get viewLineNumber() {
    return this._viewLineNumber;
  }
  get isValid() {
    return this._isValid;
  }
  get modelTrackedRange() {
    return this._modelTrackedRange;
  }
  get startLineDelta() {
    return this._startLineDelta;
  }
  constructor(e, t, n, s, o) {
    this._model = e, this._viewLineNumber = t, this._isValid = n, this._modelTrackedRange = s, this._startLineDelta = o;
  }
  dispose() {
    this._model._setTrackedRange(this._modelTrackedRange, null, 1);
  }
  update(e, t) {
    const n = e.coordinatesConverter.convertViewPositionToModelPosition(new W(t, e.getLineMinColumn(t))), s = e.model._setTrackedRange(this._modelTrackedRange, new D(n.lineNumber, n.column, n.lineNumber, n.column), 1), o = e.viewLayout.getVerticalOffsetForLineNumber(t), r = e.viewLayout.getCurrentScrollTop();
    this._viewLineNumber = t, this._isValid = !0, this._modelTrackedRange = s, this._startLineDelta = r - o;
  }
  invalidate() {
    this._isValid = !1;
  }
}
class KQ {
  constructor() {
    this._asMap = /* @__PURE__ */ Object.create(null), this.asArray = [];
  }
  accept(e, t, n, s, o) {
    const r = this._asMap[e];
    if (r) {
      const a = r.data, l = a[a.length - 3], d = a[a.length - 1];
      if (l === o && d + 1 >= n) return void (s > d && (a[a.length - 1] = s));
      a.push(o, n, s);
    } else {
      const a = new dv(e, t, [o, n, s]);
      this._asMap[e] = a, this.asArray.push(a);
    }
  }
}
class jQ {
  constructor() {
    this.hiddenAreas = /* @__PURE__ */ new Map(), this.shouldRecompute = !1, this.ranges = [];
  }
  setHiddenAreas(e, t) {
    const n = this.hiddenAreas.get(e);
    n && Z5(n, t) || (this.hiddenAreas.set(e, t), this.shouldRecompute = !0);
  }
  getMergedRanges() {
    if (!this.shouldRecompute) return this.ranges;
    this.shouldRecompute = !1;
    const e = Array.from(this.hiddenAreas.values()).reduce((t, n) => function(s, o) {
      const r = [];
      let a = 0, l = 0;
      for (; a < s.length && l < o.length; ) {
        const d = s[a], h = o[l];
        if (d.endLineNumber < h.startLineNumber - 1) r.push(s[a++]);
        else if (h.endLineNumber < d.startLineNumber - 1) r.push(o[l++]);
        else {
          const c = Math.min(d.startLineNumber, h.startLineNumber), u = Math.max(d.endLineNumber, h.endLineNumber);
          r.push(new D(c, 1, u, 1)), a++, l++;
        }
      }
      for (; a < s.length; ) r.push(s[a++]);
      for (; l < o.length; ) r.push(o[l++]);
      return r;
    }(t, n), []);
    return Z5(this.ranges, e) || (this.ranges = e), this.ranges;
  }
}
function Z5(i, e) {
  if (i.length !== e.length) return !1;
  for (let t = 0; t < i.length; t++) if (!i[t].equalsRange(e[t])) return !1;
  return !0;
}
class Y5 {
  constructor(e, t) {
    this.viewportStartModelPosition = e, this.startLineDelta = t;
  }
  recoverViewportStart(e, t) {
    if (!this.viewportStartModelPosition) return;
    const n = e.convertModelPositionToViewPosition(this.viewportStartModelPosition), s = t.getVerticalOffsetForLineNumber(n.lineNumber);
    t.setScrollPosition({ scrollTop: s + this.startLineDelta }, 1);
  }
}
class I1 {
  constructor(...e) {
    this._entries = /* @__PURE__ */ new Map();
    for (const [t, n] of e) this.set(t, n);
  }
  set(e, t) {
    const n = this._entries.get(e);
    return this._entries.set(e, t), n;
  }
  get(e) {
    return this._entries.get(e);
  }
}
var N_;
(function(i) {
  i[i.Ignore = 0] = "Ignore", i[i.Info = 1] = "Info", i[i.Warning = 2] = "Warning", i[i.Error = 3] = "Error";
})(N_ || (N_ = {})), function(i) {
  const e = "error", t = "warning", n = "info";
  i.fromValue = function(s) {
    return s ? Dp(e, s) ? i.Error : Dp(t, s) || Dp("warn", s) ? i.Warning : Dp(n, s) ? i.Info : i.Ignore : i.Ignore;
  }, i.toString = function(s) {
    switch (s) {
      case i.Error:
        return e;
      case i.Warning:
        return t;
      case i.Info:
        return n;
      default:
        return "ignore";
    }
  };
}(N_ || (N_ = {}));
const ki = N_;
var fL = ki;
const Ri = tt("notificationService");
var au, qQ = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Nl = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let pm = au = class extends V {
  get isSimpleWidget() {
    return this._configuration.isSimpleWidget;
  }
  constructor(i, e, t, n, s, o, r, a, l, d, h, c) {
    var u;
    super(), this.languageConfigurationService = h, this._deliveryQueue = new F7(), this._contributions = this._register(new rX()), this._onDidDispose = this._register(new F()), this.onDidDispose = this._onDidDispose.event, this._onDidChangeModelContent = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelContent = this._onDidChangeModelContent.event, this._onDidChangeModelLanguage = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelLanguage = this._onDidChangeModelLanguage.event, this._onDidChangeModelLanguageConfiguration = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelLanguageConfiguration = this._onDidChangeModelLanguageConfiguration.event, this._onDidChangeModelOptions = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelOptions = this._onDidChangeModelOptions.event, this._onDidChangeModelDecorations = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelDecorations = this._onDidChangeModelDecorations.event, this._onDidChangeModelTokens = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelTokens = this._onDidChangeModelTokens.event, this._onDidChangeConfiguration = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeConfiguration = this._onDidChangeConfiguration.event, this._onWillChangeModel = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onWillChangeModel = this._onWillChangeModel.event, this._onDidChangeModel = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModel = this._onDidChangeModel.event, this._onDidChangeCursorPosition = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeCursorPosition = this._onDidChangeCursorPosition.event, this._onDidChangeCursorSelection = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeCursorSelection = this._onDidChangeCursorSelection.event, this._onDidAttemptReadOnlyEdit = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onDidAttemptReadOnlyEdit = this._onDidAttemptReadOnlyEdit.event, this._onDidLayoutChange = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidLayoutChange = this._onDidLayoutChange.event, this._editorTextFocus = this._register(new X5({ deliveryQueue: this._deliveryQueue })), this.onDidFocusEditorText = this._editorTextFocus.onDidChangeToTrue, this.onDidBlurEditorText = this._editorTextFocus.onDidChangeToFalse, this._editorWidgetFocus = this._register(new X5({ deliveryQueue: this._deliveryQueue })), this.onDidFocusEditorWidget = this._editorWidgetFocus.onDidChangeToTrue, this.onDidBlurEditorWidget = this._editorWidgetFocus.onDidChangeToFalse, this._onWillType = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onWillType = this._onWillType.event, this._onDidType = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onDidType = this._onDidType.event, this._onDidCompositionStart = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onDidCompositionStart = this._onDidCompositionStart.event, this._onDidCompositionEnd = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onDidCompositionEnd = this._onDidCompositionEnd.event, this._onDidPaste = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onDidPaste = this._onDidPaste.event, this._onMouseUp = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onMouseUp = this._onMouseUp.event, this._onMouseDown = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onMouseDown = this._onMouseDown.event, this._onMouseDrag = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onMouseDrag = this._onMouseDrag.event, this._onMouseDrop = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onMouseDrop = this._onMouseDrop.event, this._onMouseDropCanceled = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onMouseDropCanceled = this._onMouseDropCanceled.event, this._onDropIntoEditor = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onDropIntoEditor = this._onDropIntoEditor.event, this._onContextMenu = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onContextMenu = this._onContextMenu.event, this._onMouseMove = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onMouseMove = this._onMouseMove.event, this._onMouseLeave = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onMouseLeave = this._onMouseLeave.event, this._onMouseWheel = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onMouseWheel = this._onMouseWheel.event, this._onKeyUp = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onKeyUp = this._onKeyUp.event, this._onKeyDown = this._register(new Kn(this._contributions, this._deliveryQueue)), this.onKeyDown = this._onKeyDown.event, this._onDidContentSizeChange = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidContentSizeChange = this._onDidContentSizeChange.event, this._onDidScrollChange = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidScrollChange = this._onDidScrollChange.event, this._onDidChangeViewZones = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeViewZones = this._onDidChangeViewZones.event, this._onDidChangeHiddenAreas = this._register(new F({ deliveryQueue: this._deliveryQueue })), this.onDidChangeHiddenAreas = this._onDidChangeHiddenAreas.event, this._actions = /* @__PURE__ */ new Map(), this._bannerDomNode = null, this._dropIntoEditorDecorations = this.createDecorationsCollection(), s.willCreateCodeEditor();
    const g = { ...e };
    let p;
    this._domElement = i, this._overflowWidgetsDomNode = g.overflowWidgetsDomNode, delete g.overflowWidgetsDomNode, this._id = ++$Q, this._decorationTypeKeysToIds = {}, this._decorationTypeSubtypes = {}, this._telemetryData = t.telemetryData, this._configuration = this._register(this._createConfiguration(t.isSimpleWidget || !1, g, d)), this._register(this._configuration.onDidChange((_) => {
      this._onDidChangeConfiguration.fire(_);
      const v = this._configuration.options;
      if (_.hasChanged(145)) {
        const b = v.get(145);
        this._onDidLayoutChange.fire(b);
      }
    })), this._contextKeyService = this._register(r.createScoped(this._domElement)), this._notificationService = l, this._codeEditorService = s, this._commandService = o, this._themeService = a, this._register(new ZQ(this, this._contextKeyService)), this._register(new YQ(this, this._contextKeyService, c)), this._instantiationService = n.createChild(new I1([Te, this._contextKeyService])), this._modelData = null, this._focusTracker = new XQ(i, this._overflowWidgetsDomNode), this._register(this._focusTracker.onChange(() => {
      this._editorWidgetFocus.setValue(this._focusTracker.hasFocus());
    })), this._contentWidgets = {}, this._overlayWidgets = {}, this._glyphMarginWidgets = {}, p = Array.isArray(t.contributions) ? t.contributions : Jp.getEditorContributions(), this._contributions.initialize(this, p, this._instantiationService);
    for (const _ of Jp.getEditorActions()) {
      if (this._actions.has(_.id)) {
        We(new Error(`Cannot have two actions with the same id ${_.id}`));
        continue;
      }
      const v = new ZB(_.id, _.label, _.alias, _.metadata, (u = _.precondition) !== null && u !== void 0 ? u : void 0, (b) => this._instantiationService.invokeFunction((C) => Promise.resolve(_.runEditorCommand(C, this, b))), this._contextKeyService);
      this._actions.set(v.id, v);
    }
    const f = () => !this._configuration.options.get(91) && this._configuration.options.get(36).enabled;
    this._register(new vj(this._domElement, { onDragOver: (_) => {
      if (!f()) return;
      const v = this.getTargetAtClientPoint(_.clientX, _.clientY);
      v != null && v.position && this.showDropIndicatorAt(v.position);
    }, onDrop: async (_) => {
      if (!f() || (this.removeDropIndicator(), !_.dataTransfer)) return;
      const v = this.getTargetAtClientPoint(_.clientX, _.clientY);
      v != null && v.position && this._onDropIntoEditor.fire({ position: v.position, event: _ });
    }, onDragLeave: () => {
      this.removeDropIndicator();
    }, onDragEnd: () => {
      this.removeDropIndicator();
    } })), this._codeEditorService.addCodeEditor(this);
  }
  writeScreenReaderContent(i) {
    var e;
    (e = this._modelData) === null || e === void 0 || e.view.writeScreenReaderContent(i);
  }
  _createConfiguration(i, e, t) {
    return new ZE(i, e, this._domElement, t);
  }
  getId() {
    return this.getEditorType() + ":" + this._id;
  }
  getEditorType() {
    return w1.ICodeEditor;
  }
  dispose() {
    this._codeEditorService.removeCodeEditor(this), this._focusTracker.dispose(), this._actions.clear(), this._contentWidgets = {}, this._overlayWidgets = {}, this._removeDecorationTypes(), this._postDetachModelCleanup(this._detachModel()), this._onDidDispose.fire(), super.dispose();
  }
  invokeWithinContext(i) {
    return this._instantiationService.invokeFunction(i);
  }
  updateOptions(i) {
    this._configuration.updateOptions(i || {});
  }
  getOptions() {
    return this._configuration.options;
  }
  getOption(i) {
    return this._configuration.options.get(i);
  }
  getRawOptions() {
    return this._configuration.getRawOptions();
  }
  getOverflowWidgetsDomNode() {
    return this._overflowWidgetsDomNode;
  }
  getConfiguredWordAtPosition(i) {
    return this._modelData ? Ct.getWordAtPosition(this._modelData.model, this._configuration.options.get(131), this._configuration.options.get(130), i) : null;
  }
  getValue(i = null) {
    if (!this._modelData) return "";
    const e = !(!i || !i.preserveBOM);
    let t = 0;
    return i && i.lineEnding && i.lineEnding === `
` ? t = 1 : i && i.lineEnding && i.lineEnding === `\r
` && (t = 2), this._modelData.model.getValue(t, e);
  }
  setValue(i) {
    this._modelData && this._modelData.model.setValue(i);
  }
  getModel() {
    return this._modelData ? this._modelData.model : null;
  }
  setModel(i = null) {
    var e;
    const t = i;
    if (this._modelData === null && t === null || this._modelData && this._modelData.model === t) return;
    const n = { oldModelUrl: ((e = this._modelData) === null || e === void 0 ? void 0 : e.model.uri) || null, newModelUrl: (t == null ? void 0 : t.uri) || null };
    this._onWillChangeModel.fire(n);
    const s = this.hasTextFocus(), o = this._detachModel();
    this._attachModel(t), s && this.hasModel() && this.focus(), this._removeDecorationTypes(), this._onDidChangeModel.fire(n), this._postDetachModelCleanup(o), this._contributionsDisposable = this._contributions.onAfterModelAttached();
  }
  _removeDecorationTypes() {
    if (this._decorationTypeKeysToIds = {}, this._decorationTypeSubtypes) {
      for (const i in this._decorationTypeSubtypes) {
        const e = this._decorationTypeSubtypes[i];
        for (const t in e) this._removeDecorationType(i + "-" + t);
      }
      this._decorationTypeSubtypes = {};
    }
  }
  getVisibleRanges() {
    return this._modelData ? this._modelData.viewModel.getVisibleRanges() : [];
  }
  getVisibleRangesPlusViewportAboveBelow() {
    return this._modelData ? this._modelData.viewModel.getVisibleRangesPlusViewportAboveBelow() : [];
  }
  getWhitespaces() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getWhitespaces() : [];
  }
  static _getVerticalOffsetAfterPosition(i, e, t, n) {
    const s = i.model.validatePosition({ lineNumber: e, column: t }), o = i.viewModel.coordinatesConverter.convertModelPositionToViewPosition(s);
    return i.viewModel.viewLayout.getVerticalOffsetAfterLineNumber(o.lineNumber, n);
  }
  getTopForLineNumber(i, e = !1) {
    return this._modelData ? au._getVerticalOffsetForPosition(this._modelData, i, 1, e) : -1;
  }
  getTopForPosition(i, e) {
    return this._modelData ? au._getVerticalOffsetForPosition(this._modelData, i, e, !1) : -1;
  }
  static _getVerticalOffsetForPosition(i, e, t, n = !1) {
    const s = i.model.validatePosition({ lineNumber: e, column: t }), o = i.viewModel.coordinatesConverter.convertModelPositionToViewPosition(s);
    return i.viewModel.viewLayout.getVerticalOffsetForLineNumber(o.lineNumber, n);
  }
  getBottomForLineNumber(i, e = !1) {
    return this._modelData ? au._getVerticalOffsetAfterPosition(this._modelData, i, 1, e) : -1;
  }
  setHiddenAreas(i, e) {
    var t;
    (t = this._modelData) === null || t === void 0 || t.viewModel.setHiddenAreas(i.map((n) => D.lift(n)), e);
  }
  getVisibleColumnFromPosition(i) {
    if (!this._modelData) return i.column;
    const e = this._modelData.model.validatePosition(i), t = this._modelData.model.getOptions().tabSize;
    return Gi.visibleColumnFromColumn(this._modelData.model.getLineContent(e.lineNumber), e.column, t) + 1;
  }
  getPosition() {
    return this._modelData ? this._modelData.viewModel.getPosition() : null;
  }
  setPosition(i, e = "api") {
    if (this._modelData) {
      if (!W.isIPosition(i)) throw new Error("Invalid arguments");
      this._modelData.viewModel.setSelections(e, [{ selectionStartLineNumber: i.lineNumber, selectionStartColumn: i.column, positionLineNumber: i.lineNumber, positionColumn: i.column }]);
    }
  }
  _sendRevealRange(i, e, t, n) {
    if (!this._modelData) return;
    if (!D.isIRange(i)) throw new Error("Invalid arguments");
    const s = this._modelData.model.validateRange(i), o = this._modelData.viewModel.coordinatesConverter.convertModelRangeToViewRange(s);
    this._modelData.viewModel.revealRange("api", t, o, e, n);
  }
  revealLine(i, e = 0) {
    this._revealLine(i, 0, e);
  }
  revealLineInCenter(i, e = 0) {
    this._revealLine(i, 1, e);
  }
  revealLineInCenterIfOutsideViewport(i, e = 0) {
    this._revealLine(i, 2, e);
  }
  revealLineNearTop(i, e = 0) {
    this._revealLine(i, 5, e);
  }
  _revealLine(i, e, t) {
    if (typeof i != "number") throw new Error("Invalid arguments");
    this._sendRevealRange(new D(i, 1, i, 1), e, !1, t);
  }
  revealPosition(i, e = 0) {
    this._revealPosition(i, 0, !0, e);
  }
  revealPositionInCenter(i, e = 0) {
    this._revealPosition(i, 1, !0, e);
  }
  revealPositionInCenterIfOutsideViewport(i, e = 0) {
    this._revealPosition(i, 2, !0, e);
  }
  revealPositionNearTop(i, e = 0) {
    this._revealPosition(i, 5, !0, e);
  }
  _revealPosition(i, e, t, n) {
    if (!W.isIPosition(i)) throw new Error("Invalid arguments");
    this._sendRevealRange(new D(i.lineNumber, i.column, i.lineNumber, i.column), e, t, n);
  }
  getSelection() {
    return this._modelData ? this._modelData.viewModel.getSelection() : null;
  }
  getSelections() {
    return this._modelData ? this._modelData.viewModel.getSelections() : null;
  }
  setSelection(i, e = "api") {
    const t = _e.isISelection(i), n = D.isIRange(i);
    if (!t && !n) throw new Error("Invalid arguments");
    if (t) this._setSelectionImpl(i, e);
    else if (n) {
      const s = { selectionStartLineNumber: i.startLineNumber, selectionStartColumn: i.startColumn, positionLineNumber: i.endLineNumber, positionColumn: i.endColumn };
      this._setSelectionImpl(s, e);
    }
  }
  _setSelectionImpl(i, e) {
    if (!this._modelData) return;
    const t = new _e(i.selectionStartLineNumber, i.selectionStartColumn, i.positionLineNumber, i.positionColumn);
    this._modelData.viewModel.setSelections(e, [t]);
  }
  revealLines(i, e, t = 0) {
    this._revealLines(i, e, 0, t);
  }
  revealLinesInCenter(i, e, t = 0) {
    this._revealLines(i, e, 1, t);
  }
  revealLinesInCenterIfOutsideViewport(i, e, t = 0) {
    this._revealLines(i, e, 2, t);
  }
  revealLinesNearTop(i, e, t = 0) {
    this._revealLines(i, e, 5, t);
  }
  _revealLines(i, e, t, n) {
    if (typeof i != "number" || typeof e != "number") throw new Error("Invalid arguments");
    this._sendRevealRange(new D(i, 1, e, 1), t, !1, n);
  }
  revealRange(i, e = 0, t = !1, n = !0) {
    this._revealRange(i, t ? 1 : 0, n, e);
  }
  revealRangeInCenter(i, e = 0) {
    this._revealRange(i, 1, !0, e);
  }
  revealRangeInCenterIfOutsideViewport(i, e = 0) {
    this._revealRange(i, 2, !0, e);
  }
  revealRangeNearTop(i, e = 0) {
    this._revealRange(i, 5, !0, e);
  }
  revealRangeNearTopIfOutsideViewport(i, e = 0) {
    this._revealRange(i, 6, !0, e);
  }
  revealRangeAtTop(i, e = 0) {
    this._revealRange(i, 3, !0, e);
  }
  _revealRange(i, e, t, n) {
    if (!D.isIRange(i)) throw new Error("Invalid arguments");
    this._sendRevealRange(D.lift(i), e, t, n);
  }
  setSelections(i, e = "api", t = 0) {
    if (this._modelData) {
      if (!i || i.length === 0) throw new Error("Invalid arguments");
      for (let n = 0, s = i.length; n < s; n++) if (!_e.isISelection(i[n])) throw new Error("Invalid arguments");
      this._modelData.viewModel.setSelections(e, i, t);
    }
  }
  getContentWidth() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getContentWidth() : -1;
  }
  getScrollWidth() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getScrollWidth() : -1;
  }
  getScrollLeft() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getCurrentScrollLeft() : -1;
  }
  getContentHeight() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getContentHeight() : -1;
  }
  getScrollHeight() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getScrollHeight() : -1;
  }
  getScrollTop() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getCurrentScrollTop() : -1;
  }
  setScrollLeft(i, e = 1) {
    if (this._modelData) {
      if (typeof i != "number") throw new Error("Invalid arguments");
      this._modelData.viewModel.viewLayout.setScrollPosition({ scrollLeft: i }, e);
    }
  }
  setScrollTop(i, e = 1) {
    if (this._modelData) {
      if (typeof i != "number") throw new Error("Invalid arguments");
      this._modelData.viewModel.viewLayout.setScrollPosition({ scrollTop: i }, e);
    }
  }
  setScrollPosition(i, e = 1) {
    this._modelData && this._modelData.viewModel.viewLayout.setScrollPosition(i, e);
  }
  hasPendingScrollAnimation() {
    return !!this._modelData && this._modelData.viewModel.viewLayout.hasPendingScrollAnimation();
  }
  saveViewState() {
    if (!this._modelData) return null;
    const i = this._contributions.saveViewState();
    return { cursorState: this._modelData.viewModel.saveCursorState(), viewState: this._modelData.viewModel.saveState(), contributionsState: i };
  }
  restoreViewState(i) {
    if (!this._modelData || !this._modelData.hasRealView) return;
    const e = i;
    if (e && e.cursorState && e.viewState) {
      const t = e.cursorState;
      Array.isArray(t) ? t.length > 0 && this._modelData.viewModel.restoreCursorState(t) : this._modelData.viewModel.restoreCursorState([t]), this._contributions.restoreViewState(e.contributionsState || {});
      const n = this._modelData.viewModel.reduceRestoreState(e.viewState);
      this._modelData.view.restoreState(n);
    }
  }
  handleInitialized() {
    var i;
    (i = this._getViewModel()) === null || i === void 0 || i.visibleLinesStabilized();
  }
  getContribution(i) {
    return this._contributions.get(i);
  }
  getActions() {
    return Array.from(this._actions.values());
  }
  getSupportedActions() {
    let i = this.getActions();
    return i = i.filter((e) => e.isSupported()), i;
  }
  getAction(i) {
    return this._actions.get(i) || null;
  }
  trigger(i, e, t) {
    switch (t = t || {}, e) {
      case "compositionStart":
        return void this._startComposition();
      case "compositionEnd":
        return void this._endComposition(i);
      case "type": {
        const s = t;
        return void this._type(i, s.text || "");
      }
      case "replacePreviousChar": {
        const s = t;
        return void this._compositionType(i, s.text || "", s.replaceCharCnt || 0, 0, 0);
      }
      case "compositionType": {
        const s = t;
        return void this._compositionType(i, s.text || "", s.replacePrevCharCnt || 0, s.replaceNextCharCnt || 0, s.positionDelta || 0);
      }
      case "paste": {
        const s = t;
        return void this._paste(i, s.text || "", s.pasteOnNewLine || !1, s.multicursorText || null, s.mode || null, s.clipboardEvent);
      }
      case "cut":
        return void this._cut(i);
    }
    const n = this.getAction(e);
    n ? Promise.resolve(n.run(t)).then(void 0, We) : this._modelData && (this._triggerEditorCommand(i, e, t) || this._triggerCommand(e, t));
  }
  _triggerCommand(i, e) {
    this._commandService.executeCommand(i, e);
  }
  _startComposition() {
    this._modelData && (this._modelData.viewModel.startComposition(), this._onDidCompositionStart.fire());
  }
  _endComposition(i) {
    this._modelData && (this._modelData.viewModel.endComposition(i), this._onDidCompositionEnd.fire());
  }
  _type(i, e) {
    this._modelData && e.length !== 0 && (i === "keyboard" && this._onWillType.fire(e), this._modelData.viewModel.type(e, i), i === "keyboard" && this._onDidType.fire(e));
  }
  _compositionType(i, e, t, n, s) {
    this._modelData && this._modelData.viewModel.compositionType(e, t, n, s, i);
  }
  _paste(i, e, t, n, s, o) {
    if (!this._modelData) return;
    const r = this._modelData.viewModel, a = r.getSelection().getStartPosition();
    r.paste(e, t, n, i);
    const l = r.getSelection().getStartPosition();
    i === "keyboard" && this._onDidPaste.fire({ clipboardEvent: o, range: new D(a.lineNumber, a.column, l.lineNumber, l.column), languageId: s });
  }
  _cut(i) {
    this._modelData && this._modelData.viewModel.cut(i);
  }
  _triggerEditorCommand(i, e, t) {
    const n = Jp.getEditorCommand(e);
    return !!n && ((t = t || {}).source = i, this._instantiationService.invokeFunction((s) => {
      Promise.resolve(n.runEditorCommand(s, this, t)).then(void 0, We);
    }), !0);
  }
  _getViewModel() {
    return this._modelData ? this._modelData.viewModel : null;
  }
  pushUndoStop() {
    return !!this._modelData && !this._configuration.options.get(91) && (this._modelData.model.pushStackElement(), !0);
  }
  popUndoStop() {
    return !!this._modelData && !this._configuration.options.get(91) && (this._modelData.model.popStackElement(), !0);
  }
  executeEdits(i, e, t) {
    if (!this._modelData || this._configuration.options.get(91)) return !1;
    let n;
    return n = t ? Array.isArray(t) ? () => t : t : () => null, this._modelData.viewModel.executeEdits(i, e, n), !0;
  }
  executeCommand(i, e) {
    this._modelData && this._modelData.viewModel.executeCommand(e, i);
  }
  executeCommands(i, e) {
    this._modelData && this._modelData.viewModel.executeCommands(e, i);
  }
  createDecorationsCollection(i) {
    return new QQ(this, i);
  }
  changeDecorations(i) {
    return this._modelData ? this._modelData.model.changeDecorations(i, this._id) : null;
  }
  getLineDecorations(i) {
    return this._modelData ? this._modelData.model.getLineDecorations(i, this._id, Mw(this._configuration.options)) : null;
  }
  getDecorationsInRange(i) {
    return this._modelData ? this._modelData.model.getDecorationsInRange(i, this._id, Mw(this._configuration.options)) : null;
  }
  deltaDecorations(i, e) {
    return this._modelData ? i.length === 0 && e.length === 0 ? i : this._modelData.model.deltaDecorations(i, e, this._id) : [];
  }
  removeDecorations(i) {
    this._modelData && i.length !== 0 && this._modelData.model.changeDecorations((e) => {
      e.deltaDecorations(i, []);
    });
  }
  removeDecorationsByType(i) {
    const e = this._decorationTypeKeysToIds[i];
    e && this.changeDecorations((t) => t.deltaDecorations(e, [])), this._decorationTypeKeysToIds.hasOwnProperty(i) && delete this._decorationTypeKeysToIds[i], this._decorationTypeSubtypes.hasOwnProperty(i) && delete this._decorationTypeSubtypes[i];
  }
  getLayoutInfo() {
    return this._configuration.options.get(145);
  }
  createOverviewRuler(i) {
    return this._modelData && this._modelData.hasRealView ? this._modelData.view.createOverviewRuler(i) : null;
  }
  getContainerDomNode() {
    return this._domElement;
  }
  getDomNode() {
    return this._modelData && this._modelData.hasRealView ? this._modelData.view.domNode.domNode : null;
  }
  delegateVerticalScrollbarPointerDown(i) {
    this._modelData && this._modelData.hasRealView && this._modelData.view.delegateVerticalScrollbarPointerDown(i);
  }
  delegateScrollFromMouseWheelEvent(i) {
    this._modelData && this._modelData.hasRealView && this._modelData.view.delegateScrollFromMouseWheelEvent(i);
  }
  layout(i, e = !1) {
    this._configuration.observeContainer(i), e || this.render();
  }
  focus() {
    this._modelData && this._modelData.hasRealView && this._modelData.view.focus();
  }
  hasTextFocus() {
    return !(!this._modelData || !this._modelData.hasRealView) && this._modelData.view.isFocused();
  }
  hasWidgetFocus() {
    return this._focusTracker && this._focusTracker.hasFocus();
  }
  addContentWidget(i) {
    const e = { widget: i, position: i.getPosition() };
    this._contentWidgets.hasOwnProperty(i.getId()) && console.warn("Overwriting a content widget with the same id:" + i.getId()), this._contentWidgets[i.getId()] = e, this._modelData && this._modelData.hasRealView && this._modelData.view.addContentWidget(e);
  }
  layoutContentWidget(i) {
    const e = i.getId();
    if (this._contentWidgets.hasOwnProperty(e)) {
      const t = this._contentWidgets[e];
      t.position = i.getPosition(), this._modelData && this._modelData.hasRealView && this._modelData.view.layoutContentWidget(t);
    }
  }
  removeContentWidget(i) {
    const e = i.getId();
    if (this._contentWidgets.hasOwnProperty(e)) {
      const t = this._contentWidgets[e];
      delete this._contentWidgets[e], this._modelData && this._modelData.hasRealView && this._modelData.view.removeContentWidget(t);
    }
  }
  addOverlayWidget(i) {
    const e = { widget: i, position: i.getPosition() };
    this._overlayWidgets.hasOwnProperty(i.getId()) && console.warn("Overwriting an overlay widget with the same id."), this._overlayWidgets[i.getId()] = e, this._modelData && this._modelData.hasRealView && this._modelData.view.addOverlayWidget(e);
  }
  layoutOverlayWidget(i) {
    const e = i.getId();
    if (this._overlayWidgets.hasOwnProperty(e)) {
      const t = this._overlayWidgets[e];
      t.position = i.getPosition(), this._modelData && this._modelData.hasRealView && this._modelData.view.layoutOverlayWidget(t);
    }
  }
  removeOverlayWidget(i) {
    const e = i.getId();
    if (this._overlayWidgets.hasOwnProperty(e)) {
      const t = this._overlayWidgets[e];
      delete this._overlayWidgets[e], this._modelData && this._modelData.hasRealView && this._modelData.view.removeOverlayWidget(t);
    }
  }
  addGlyphMarginWidget(i) {
    const e = { widget: i, position: i.getPosition() };
    this._glyphMarginWidgets.hasOwnProperty(i.getId()) && console.warn("Overwriting a glyph margin widget with the same id."), this._glyphMarginWidgets[i.getId()] = e, this._modelData && this._modelData.hasRealView && this._modelData.view.addGlyphMarginWidget(e);
  }
  layoutGlyphMarginWidget(i) {
    const e = i.getId();
    if (this._glyphMarginWidgets.hasOwnProperty(e)) {
      const t = this._glyphMarginWidgets[e];
      t.position = i.getPosition(), this._modelData && this._modelData.hasRealView && this._modelData.view.layoutGlyphMarginWidget(t);
    }
  }
  removeGlyphMarginWidget(i) {
    const e = i.getId();
    if (this._glyphMarginWidgets.hasOwnProperty(e)) {
      const t = this._glyphMarginWidgets[e];
      delete this._glyphMarginWidgets[e], this._modelData && this._modelData.hasRealView && this._modelData.view.removeGlyphMarginWidget(t);
    }
  }
  changeViewZones(i) {
    this._modelData && this._modelData.hasRealView && this._modelData.view.change(i);
  }
  getTargetAtClientPoint(i, e) {
    return this._modelData && this._modelData.hasRealView ? this._modelData.view.getTargetAtClientPoint(i, e) : null;
  }
  getScrolledVisiblePosition(i) {
    if (!this._modelData || !this._modelData.hasRealView) return null;
    const e = this._modelData.model.validatePosition(i), t = this._configuration.options, n = t.get(145);
    return { top: au._getVerticalOffsetForPosition(this._modelData, e.lineNumber, e.column) - this.getScrollTop(), left: this._modelData.view.getOffsetForColumn(e.lineNumber, e.column) + n.glyphMarginWidth + n.lineNumbersWidth + n.decorationsWidth - this.getScrollLeft(), height: t.get(67) };
  }
  getOffsetForColumn(i, e) {
    return this._modelData && this._modelData.hasRealView ? this._modelData.view.getOffsetForColumn(i, e) : -1;
  }
  render(i = !1) {
    this._modelData && this._modelData.hasRealView && this._modelData.view.render(!0, i);
  }
  setAriaOptions(i) {
    this._modelData && this._modelData.hasRealView && this._modelData.view.setAriaOptions(i);
  }
  applyFontInfo(i) {
    yn(i, this._configuration.options.get(50));
  }
  setBanner(i, e) {
    this._bannerDomNode && this._domElement.contains(this._bannerDomNode) && this._domElement.removeChild(this._bannerDomNode), this._bannerDomNode = i, this._configuration.setReservedHeight(i ? e : 0), this._bannerDomNode && this._domElement.prepend(this._bannerDomNode);
  }
  _attachModel(i) {
    if (!i) return void (this._modelData = null);
    const e = [];
    this._domElement.setAttribute("data-mode-id", i.getLanguageId()), this._configuration.setIsDominatedByLongLines(i.isDominatedByLongLines()), this._configuration.setModelLineCount(i.getLineCount());
    const t = i.onBeforeAttached(), n = new UQ(this._id, this._configuration, i, $R.create(ke(this._domElement)), sA.create(this._configuration.options), (r) => Ys(ke(this._domElement), r), this.languageConfigurationService, this._themeService, t);
    e.push(i.onWillDispose(() => this.setModel(null))), e.push(n.onEvent((r) => {
      switch (r.kind) {
        case 0:
          this._onDidContentSizeChange.fire(r);
          break;
        case 1:
          this._editorTextFocus.setValue(r.hasFocus);
          break;
        case 2:
          this._onDidScrollChange.fire(r);
          break;
        case 3:
          this._onDidChangeViewZones.fire();
          break;
        case 4:
          this._onDidChangeHiddenAreas.fire();
          break;
        case 5:
          this._onDidAttemptReadOnlyEdit.fire();
          break;
        case 6: {
          if (r.reachedMaxCursorCount) {
            const h = m(0, "The number of cursors has been limited to {0}. Consider using [find and replace](https://code.visualstudio.com/docs/editor/codebasics#_find-and-replace) for larger changes or increase the editor multi cursor limit setting.", this.getOption(80));
            this._notificationService.prompt(fL.Warning, h, [{ label: "Find and Replace", run: () => {
              this._commandService.executeCommand("editor.action.startFindReplaceAction");
            } }, { label: m(0, "Increase Multi Cursor Limit"), run: () => {
              this._commandService.executeCommand("workbench.action.openSettings2", { query: "editor.multiCursorLimit" });
            } }]);
          }
          const a = [];
          for (let h = 0, c = r.selections.length; h < c; h++) a[h] = r.selections[h].getPosition();
          const l = { position: a[0], secondaryPositions: a.slice(1), reason: r.reason, source: r.source };
          this._onDidChangeCursorPosition.fire(l);
          const d = { selection: r.selections[0], secondarySelections: r.selections.slice(1), modelVersionId: r.modelVersionId, oldSelections: r.oldSelections, oldModelVersionId: r.oldModelVersionId, source: r.source, reason: r.reason };
          this._onDidChangeCursorSelection.fire(d);
          break;
        }
        case 7:
          this._onDidChangeModelDecorations.fire(r.event);
          break;
        case 8:
          this._domElement.setAttribute("data-mode-id", i.getLanguageId()), this._onDidChangeModelLanguage.fire(r.event);
          break;
        case 9:
          this._onDidChangeModelLanguageConfiguration.fire(r.event);
          break;
        case 10:
          this._onDidChangeModelContent.fire(r.event);
          break;
        case 11:
          this._onDidChangeModelOptions.fire(r.event);
          break;
        case 12:
          this._onDidChangeModelTokens.fire(r.event);
      }
    }));
    const [s, o] = this._createView(n);
    if (o) {
      this._domElement.appendChild(s.domNode.domNode);
      let r = Object.keys(this._contentWidgets);
      for (let a = 0, l = r.length; a < l; a++) {
        const d = r[a];
        s.addContentWidget(this._contentWidgets[d]);
      }
      r = Object.keys(this._overlayWidgets);
      for (let a = 0, l = r.length; a < l; a++) {
        const d = r[a];
        s.addOverlayWidget(this._overlayWidgets[d]);
      }
      r = Object.keys(this._glyphMarginWidgets);
      for (let a = 0, l = r.length; a < l; a++) {
        const d = r[a];
        s.addGlyphMarginWidget(this._glyphMarginWidgets[d]);
      }
      s.render(!1, !0), s.domNode.domNode.setAttribute("data-uri", i.uri.toString());
    }
    this._modelData = new GQ(i, n, s, o, e, t);
  }
  _createView(i) {
    let e;
    e = this.isSimpleWidget ? { paste: (n, s, o, r) => {
      this._paste("keyboard", n, s, o, r);
    }, type: (n) => {
      this._type("keyboard", n);
    }, compositionType: (n, s, o, r) => {
      this._compositionType("keyboard", n, s, o, r);
    }, startComposition: () => {
      this._startComposition();
    }, endComposition: () => {
      this._endComposition("keyboard");
    }, cut: () => {
      this._cut("keyboard");
    } } : { paste: (n, s, o, r) => {
      const a = { text: n, pasteOnNewLine: s, multicursorText: o, mode: r };
      this._commandService.executeCommand("paste", a);
    }, type: (n) => {
      const s = { text: n };
      this._commandService.executeCommand("type", s);
    }, compositionType: (n, s, o, r) => {
      if (o || r) {
        const a = { text: n, replacePrevCharCnt: s, replaceNextCharCnt: o, positionDelta: r };
        this._commandService.executeCommand("compositionType", a);
      } else {
        const a = { text: n, replaceCharCnt: s };
        this._commandService.executeCommand("replacePreviousChar", a);
      }
    }, startComposition: () => {
      this._commandService.executeCommand("compositionStart", {});
    }, endComposition: () => {
      this._commandService.executeCommand("compositionEnd", {});
    }, cut: () => {
      this._commandService.executeCommand("cut", {});
    } };
    const t = new cL(i.coordinatesConverter);
    return t.onKeyDown = (n) => this._onKeyDown.fire(n), t.onKeyUp = (n) => this._onKeyUp.fire(n), t.onContextMenu = (n) => this._onContextMenu.fire(n), t.onMouseMove = (n) => this._onMouseMove.fire(n), t.onMouseLeave = (n) => this._onMouseLeave.fire(n), t.onMouseDown = (n) => this._onMouseDown.fire(n), t.onMouseUp = (n) => this._onMouseUp.fire(n), t.onMouseDrag = (n) => this._onMouseDrag.fire(n), t.onMouseDrop = (n) => this._onMouseDrop.fire(n), t.onMouseDropCanceled = (n) => this._onMouseDropCanceled.fire(n), t.onMouseWheel = (n) => this._onMouseWheel.fire(n), [new rI(e, this._configuration, this._themeService.getColorTheme(), i, t, this._overflowWidgetsDomNode, this._instantiationService), !0];
  }
  _postDetachModelCleanup(i) {
    i == null || i.removeAllDecorationsWithOwnerId(this._id);
  }
  _detachModel() {
    var i;
    if ((i = this._contributionsDisposable) === null || i === void 0 || i.dispose(), this._contributionsDisposable = void 0, !this._modelData) return null;
    const e = this._modelData.model, t = this._modelData.hasRealView ? this._modelData.view.domNode.domNode : null;
    return this._modelData.dispose(), this._modelData = null, this._domElement.removeAttribute("data-mode-id"), t && this._domElement.contains(t) && this._domElement.removeChild(t), this._bannerDomNode && this._domElement.contains(this._bannerDomNode) && this._domElement.removeChild(this._bannerDomNode), e;
  }
  _removeDecorationType(i) {
    this._codeEditorService.removeDecorationType(i);
  }
  hasModel() {
    return this._modelData !== null;
  }
  showDropIndicatorAt(i) {
    const e = [{ range: new D(i.lineNumber, i.column, i.lineNumber, i.column), options: au.dropIntoEditorDecorationOptions }];
    this._dropIntoEditorDecorations.set(e), this.revealPosition(i, 1);
  }
  removeDropIndicator() {
    this._dropIntoEditorDecorations.clear();
  }
  setContextValue(i, e) {
    this._contextKeyService.createKey(i, e);
  }
};
pm.dropIntoEditorDecorationOptions = Ve.register({ description: "workbench-dnd-target", className: "dnd-target" }), pm = au = qQ([Nl(3, Se), Nl(4, mt), Nl(5, ai), Nl(6, Te), Nl(7, Yi), Nl(8, Ri), Nl(9, or), Nl(10, zt), Nl(11, fe)], pm);
let $Q = 0, GQ = class {
  constructor(i, e, t, n, s, o) {
    this.model = i, this.viewModel = e, this.view = t, this.hasRealView = n, this.listenersToRemove = s, this.attachedView = o;
  }
  dispose() {
    Ht(this.listenersToRemove), this.model.onBeforeDetached(this.attachedView), this.hasRealView && this.view.dispose(), this.viewModel.dispose();
  }
};
class X5 extends V {
  constructor(e) {
    super(), this._emitterOptions = e, this._onDidChangeToTrue = this._register(new F(this._emitterOptions)), this.onDidChangeToTrue = this._onDidChangeToTrue.event, this._onDidChangeToFalse = this._register(new F(this._emitterOptions)), this.onDidChangeToFalse = this._onDidChangeToFalse.event, this._value = 0;
  }
  setValue(e) {
    const t = e ? 2 : 1;
    this._value !== t && (this._value = t, this._value === 2 ? this._onDidChangeToTrue.fire() : this._value === 1 && this._onDidChangeToFalse.fire());
  }
}
class Kn extends F {
  constructor(e, t) {
    super({ deliveryQueue: t }), this._contributions = e;
  }
  fire(e) {
    this._contributions.onBeforeInteractionEvent(), super.fire(e);
  }
}
class ZQ extends V {
  constructor(e, t) {
    super(), this._editor = e, t.createKey("editorId", e.getId()), this._editorSimpleInput = E.editorSimpleInput.bindTo(t), this._editorFocus = E.focus.bindTo(t), this._textInputFocus = E.textInputFocus.bindTo(t), this._editorTextFocus = E.editorTextFocus.bindTo(t), this._tabMovesFocus = E.tabMovesFocus.bindTo(t), this._editorReadonly = E.readOnly.bindTo(t), this._inDiffEditor = E.inDiffEditor.bindTo(t), this._editorColumnSelection = E.columnSelection.bindTo(t), this._hasMultipleSelections = E.hasMultipleSelections.bindTo(t), this._hasNonEmptySelection = E.hasNonEmptySelection.bindTo(t), this._canUndo = E.canUndo.bindTo(t), this._canRedo = E.canRedo.bindTo(t), this._register(this._editor.onDidChangeConfiguration(() => this._updateFromConfig())), this._register(this._editor.onDidChangeCursorSelection(() => this._updateFromSelection())), this._register(this._editor.onDidFocusEditorWidget(() => this._updateFromFocus())), this._register(this._editor.onDidBlurEditorWidget(() => this._updateFromFocus())), this._register(this._editor.onDidFocusEditorText(() => this._updateFromFocus())), this._register(this._editor.onDidBlurEditorText(() => this._updateFromFocus())), this._register(this._editor.onDidChangeModel(() => this._updateFromModel())), this._register(this._editor.onDidChangeConfiguration(() => this._updateFromModel())), this._register(Um.onDidChangeTabFocus((n) => this._tabMovesFocus.set(n))), this._updateFromConfig(), this._updateFromSelection(), this._updateFromFocus(), this._updateFromModel(), this._editorSimpleInput.set(this._editor.isSimpleWidget);
  }
  _updateFromConfig() {
    const e = this._editor.getOptions();
    this._tabMovesFocus.set(Um.getTabFocusMode()), this._editorReadonly.set(e.get(91)), this._inDiffEditor.set(e.get(61)), this._editorColumnSelection.set(e.get(22));
  }
  _updateFromSelection() {
    const e = this._editor.getSelections();
    e ? (this._hasMultipleSelections.set(e.length > 1), this._hasNonEmptySelection.set(e.some((t) => !t.isEmpty()))) : (this._hasMultipleSelections.reset(), this._hasNonEmptySelection.reset());
  }
  _updateFromFocus() {
    this._editorFocus.set(this._editor.hasWidgetFocus() && !this._editor.isSimpleWidget), this._editorTextFocus.set(this._editor.hasTextFocus() && !this._editor.isSimpleWidget), this._textInputFocus.set(this._editor.hasTextFocus());
  }
  _updateFromModel() {
    const e = this._editor.getModel();
    this._canUndo.set(!!(e && e.canUndo())), this._canRedo.set(!!(e && e.canRedo()));
  }
}
class YQ extends V {
  constructor(e, t, n) {
    super(), this._editor = e, this._contextKeyService = t, this._languageFeaturesService = n, this._langId = E.languageId.bindTo(t), this._hasCompletionItemProvider = E.hasCompletionItemProvider.bindTo(t), this._hasCodeActionsProvider = E.hasCodeActionsProvider.bindTo(t), this._hasCodeLensProvider = E.hasCodeLensProvider.bindTo(t), this._hasDefinitionProvider = E.hasDefinitionProvider.bindTo(t), this._hasDeclarationProvider = E.hasDeclarationProvider.bindTo(t), this._hasImplementationProvider = E.hasImplementationProvider.bindTo(t), this._hasTypeDefinitionProvider = E.hasTypeDefinitionProvider.bindTo(t), this._hasHoverProvider = E.hasHoverProvider.bindTo(t), this._hasDocumentHighlightProvider = E.hasDocumentHighlightProvider.bindTo(t), this._hasDocumentSymbolProvider = E.hasDocumentSymbolProvider.bindTo(t), this._hasReferenceProvider = E.hasReferenceProvider.bindTo(t), this._hasRenameProvider = E.hasRenameProvider.bindTo(t), this._hasSignatureHelpProvider = E.hasSignatureHelpProvider.bindTo(t), this._hasInlayHintsProvider = E.hasInlayHintsProvider.bindTo(t), this._hasDocumentFormattingProvider = E.hasDocumentFormattingProvider.bindTo(t), this._hasDocumentSelectionFormattingProvider = E.hasDocumentSelectionFormattingProvider.bindTo(t), this._hasMultipleDocumentFormattingProvider = E.hasMultipleDocumentFormattingProvider.bindTo(t), this._hasMultipleDocumentSelectionFormattingProvider = E.hasMultipleDocumentSelectionFormattingProvider.bindTo(t), this._isInEmbeddedEditor = E.isInEmbeddedEditor.bindTo(t);
    const s = () => this._update();
    this._register(e.onDidChangeModel(s)), this._register(e.onDidChangeModelLanguage(s)), this._register(n.completionProvider.onDidChange(s)), this._register(n.codeActionProvider.onDidChange(s)), this._register(n.codeLensProvider.onDidChange(s)), this._register(n.definitionProvider.onDidChange(s)), this._register(n.declarationProvider.onDidChange(s)), this._register(n.implementationProvider.onDidChange(s)), this._register(n.typeDefinitionProvider.onDidChange(s)), this._register(n.hoverProvider.onDidChange(s)), this._register(n.documentHighlightProvider.onDidChange(s)), this._register(n.documentSymbolProvider.onDidChange(s)), this._register(n.referenceProvider.onDidChange(s)), this._register(n.renameProvider.onDidChange(s)), this._register(n.documentFormattingEditProvider.onDidChange(s)), this._register(n.documentRangeFormattingEditProvider.onDidChange(s)), this._register(n.signatureHelpProvider.onDidChange(s)), this._register(n.inlayHintsProvider.onDidChange(s)), s();
  }
  dispose() {
    super.dispose();
  }
  reset() {
    this._contextKeyService.bufferChangeEvents(() => {
      this._langId.reset(), this._hasCompletionItemProvider.reset(), this._hasCodeActionsProvider.reset(), this._hasCodeLensProvider.reset(), this._hasDefinitionProvider.reset(), this._hasDeclarationProvider.reset(), this._hasImplementationProvider.reset(), this._hasTypeDefinitionProvider.reset(), this._hasHoverProvider.reset(), this._hasDocumentHighlightProvider.reset(), this._hasDocumentSymbolProvider.reset(), this._hasReferenceProvider.reset(), this._hasRenameProvider.reset(), this._hasDocumentFormattingProvider.reset(), this._hasDocumentSelectionFormattingProvider.reset(), this._hasSignatureHelpProvider.reset(), this._isInEmbeddedEditor.reset();
    });
  }
  _update() {
    const e = this._editor.getModel();
    e ? this._contextKeyService.bufferChangeEvents(() => {
      this._langId.set(e.getLanguageId()), this._hasCompletionItemProvider.set(this._languageFeaturesService.completionProvider.has(e)), this._hasCodeActionsProvider.set(this._languageFeaturesService.codeActionProvider.has(e)), this._hasCodeLensProvider.set(this._languageFeaturesService.codeLensProvider.has(e)), this._hasDefinitionProvider.set(this._languageFeaturesService.definitionProvider.has(e)), this._hasDeclarationProvider.set(this._languageFeaturesService.declarationProvider.has(e)), this._hasImplementationProvider.set(this._languageFeaturesService.implementationProvider.has(e)), this._hasTypeDefinitionProvider.set(this._languageFeaturesService.typeDefinitionProvider.has(e)), this._hasHoverProvider.set(this._languageFeaturesService.hoverProvider.has(e)), this._hasDocumentHighlightProvider.set(this._languageFeaturesService.documentHighlightProvider.has(e)), this._hasDocumentSymbolProvider.set(this._languageFeaturesService.documentSymbolProvider.has(e)), this._hasReferenceProvider.set(this._languageFeaturesService.referenceProvider.has(e)), this._hasRenameProvider.set(this._languageFeaturesService.renameProvider.has(e)), this._hasSignatureHelpProvider.set(this._languageFeaturesService.signatureHelpProvider.has(e)), this._hasInlayHintsProvider.set(this._languageFeaturesService.inlayHintsProvider.has(e)), this._hasDocumentFormattingProvider.set(this._languageFeaturesService.documentFormattingEditProvider.has(e) || this._languageFeaturesService.documentRangeFormattingEditProvider.has(e)), this._hasDocumentSelectionFormattingProvider.set(this._languageFeaturesService.documentRangeFormattingEditProvider.has(e)), this._hasMultipleDocumentFormattingProvider.set(this._languageFeaturesService.documentFormattingEditProvider.all(e).length + this._languageFeaturesService.documentRangeFormattingEditProvider.all(e).length > 1), this._hasMultipleDocumentSelectionFormattingProvider.set(this._languageFeaturesService.documentRangeFormattingEditProvider.all(e).length > 1), this._isInEmbeddedEditor.set(e.uri.scheme === Ue.walkThroughSnippet || e.uri.scheme === Ue.vscodeChatCodeBlock);
    }) : this.reset();
  }
}
class XQ extends V {
  constructor(e, t) {
    super(), this._onChange = this._register(new F()), this.onChange = this._onChange.event, this._hadFocus = void 0, this._hasDomElementFocus = !1, this._domFocusTracker = this._register(ma(e)), this._overflowWidgetsDomNodeHasFocus = !1, this._register(this._domFocusTracker.onDidFocus(() => {
      this._hasDomElementFocus = !0, this._update();
    })), this._register(this._domFocusTracker.onDidBlur(() => {
      this._hasDomElementFocus = !1, this._update();
    })), t && (this._overflowWidgetsDomNode = this._register(ma(t)), this._register(this._overflowWidgetsDomNode.onDidFocus(() => {
      this._overflowWidgetsDomNodeHasFocus = !0, this._update();
    })), this._register(this._overflowWidgetsDomNode.onDidBlur(() => {
      this._overflowWidgetsDomNodeHasFocus = !1, this._update();
    })));
  }
  _update() {
    const e = this._hasDomElementFocus || this._overflowWidgetsDomNodeHasFocus;
    this._hadFocus !== e && (this._hadFocus = e, this._onChange.fire(void 0));
  }
  hasFocus() {
    var e;
    return (e = this._hadFocus) !== null && e !== void 0 && e;
  }
}
class QQ {
  get length() {
    return this._decorationIds.length;
  }
  constructor(e, t) {
    this._editor = e, this._decorationIds = [], this._isChangingDecorations = !1, Array.isArray(t) && t.length > 0 && this.set(t);
  }
  onDidChange(e, t, n) {
    return this._editor.onDidChangeModelDecorations((s) => {
      this._isChangingDecorations || e.call(t, s);
    }, n);
  }
  getRange(e) {
    return this._editor.hasModel() ? e >= this._decorationIds.length ? null : this._editor.getModel().getDecorationRange(this._decorationIds[e]) : null;
  }
  getRanges() {
    if (!this._editor.hasModel()) return [];
    const e = this._editor.getModel(), t = [];
    for (const n of this._decorationIds) {
      const s = e.getDecorationRange(n);
      s && t.push(s);
    }
    return t;
  }
  has(e) {
    return this._decorationIds.includes(e.id);
  }
  clear() {
    this._decorationIds.length !== 0 && this.set([]);
  }
  set(e) {
    try {
      this._isChangingDecorations = !0, this._editor.changeDecorations((t) => {
        this._decorationIds = t.deltaDecorations(this._decorationIds, e);
      });
    } finally {
      this._isChangingDecorations = !1;
    }
    return this._decorationIds;
  }
  append(e) {
    let t = [];
    try {
      this._isChangingDecorations = !0, this._editor.changeDecorations((n) => {
        t = n.deltaDecorations([], e), this._decorationIds = this._decorationIds.concat(t);
      });
    } finally {
      this._isChangingDecorations = !1;
    }
    return t;
  }
}
const JQ = encodeURIComponent("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 3' enable-background='new 0 0 6 3' height='3' width='6'><g fill='"), eJ = encodeURIComponent("'><polygon points='5.5,0 2.5,3 1.1,3 4.1,0'/><polygon points='4,0 6,2 6,0.6 5.4,0'/><polygon points='0,2 1,3 2.4,3 0,0.6'/></g></svg>");
function RD(i) {
  return JQ + encodeURIComponent(i.toString()) + eJ;
}
const tJ = encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" height="3" width="12"><g fill="'), iJ = encodeURIComponent('"><circle cx="1" cy="1" r="1"/><circle cx="5" cy="1" r="1"/><circle cx="9" cy="1" r="1"/></g></svg>');
rr((i, e) => {
  const t = i.getColor(ol);
  t && e.addRule(`.monaco-editor .squiggly-error { background: url("data:image/svg+xml,${RD(t)}") repeat-x bottom left; }`);
  const n = i.getColor(Qn);
  n && e.addRule(`.monaco-editor .squiggly-warning { background: url("data:image/svg+xml,${RD(n)}") repeat-x bottom left; }`);
  const s = i.getColor(Rs);
  s && e.addRule(`.monaco-editor .squiggly-info { background: url("data:image/svg+xml,${RD(s)}") repeat-x bottom left; }`);
  const o = i.getColor(_$);
  var r;
  o && e.addRule(`.monaco-editor .squiggly-hint { background: url("data:image/svg+xml,${r = o, tJ + encodeURIComponent(r.toString()) + iJ}") no-repeat bottom left; }`);
  const a = i.getColor(TZ);
  a && e.addRule(`.monaco-editor.showUnused .squiggly-inline-unnecessary { opacity: ${a.rgba.a}; }`);
});
var nJ = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, sJ = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let SI = class extends V {
  constructor(i) {
    super(), this._themeService = i, this._onWillCreateCodeEditor = this._register(new F()), this._onCodeEditorAdd = this._register(new F()), this.onCodeEditorAdd = this._onCodeEditorAdd.event, this._onCodeEditorRemove = this._register(new F()), this.onCodeEditorRemove = this._onCodeEditorRemove.event, this._onWillCreateDiffEditor = this._register(new F()), this._onDiffEditorAdd = this._register(new F()), this.onDiffEditorAdd = this._onDiffEditorAdd.event, this._onDiffEditorRemove = this._register(new F()), this.onDiffEditorRemove = this._onDiffEditorRemove.event, this._decorationOptionProviders = /* @__PURE__ */ new Map(), this._codeEditorOpenHandlers = new fs(), this._modelProperties = /* @__PURE__ */ new Map(), this._codeEditors = /* @__PURE__ */ Object.create(null), this._diffEditors = /* @__PURE__ */ Object.create(null), this._globalStyleSheet = null;
  }
  willCreateCodeEditor() {
    this._onWillCreateCodeEditor.fire();
  }
  addCodeEditor(i) {
    this._codeEditors[i.getId()] = i, this._onCodeEditorAdd.fire(i);
  }
  removeCodeEditor(i) {
    delete this._codeEditors[i.getId()] && this._onCodeEditorRemove.fire(i);
  }
  listCodeEditors() {
    return Object.keys(this._codeEditors).map((i) => this._codeEditors[i]);
  }
  willCreateDiffEditor() {
    this._onWillCreateDiffEditor.fire();
  }
  addDiffEditor(i) {
    this._diffEditors[i.getId()] = i, this._onDiffEditorAdd.fire(i);
  }
  listDiffEditors() {
    return Object.keys(this._diffEditors).map((i) => this._diffEditors[i]);
  }
  getFocusedCodeEditor() {
    let i = null;
    const e = this.listCodeEditors();
    for (const t of e) {
      if (t.hasTextFocus()) return t;
      t.hasWidgetFocus() && (i = t);
    }
    return i;
  }
  removeDecorationType(i) {
    const e = this._decorationOptionProviders.get(i);
    e && (e.refCount--, e.refCount <= 0 && (this._decorationOptionProviders.delete(i), e.dispose(), this.listCodeEditors().forEach((t) => t.removeDecorationsByType(i))));
  }
  setModelProperty(i, e, t) {
    const n = i.toString();
    let s;
    this._modelProperties.has(n) ? s = this._modelProperties.get(n) : (s = /* @__PURE__ */ new Map(), this._modelProperties.set(n, s)), s.set(e, t);
  }
  getModelProperty(i, e) {
    const t = i.toString();
    if (this._modelProperties.has(t))
      return this._modelProperties.get(t).get(e);
  }
  async openCodeEditor(i, e, t) {
    for (const n of this._codeEditorOpenHandlers) {
      const s = await n(i, e, t);
      if (s !== null) return s;
    }
    return null;
  }
  registerCodeEditorOpenHandler(i) {
    return ye(this._codeEditorOpenHandlers.unshift(i));
  }
};
SI = nJ([sJ(0, Yi)], SI);
var oJ = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Q5 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let jC = class extends SI {
  constructor(i, e) {
    super(e), this._register(this.onCodeEditorAdd(() => this._checkContextKey())), this._register(this.onCodeEditorRemove(() => this._checkContextKey())), this._editorIsOpen = i.createKey("editorIsOpen", !1), this._activeCodeEditor = null, this._register(this.registerCodeEditorOpenHandler(async (t, n, s) => n ? this.doOpenEditor(n, t) : null));
  }
  _checkContextKey() {
    let i = !1;
    for (const e of this.listCodeEditors()) if (!e.isSimpleWidget) {
      i = !0;
      break;
    }
    this._editorIsOpen.set(i);
  }
  setActiveCodeEditor(i) {
    this._activeCodeEditor = i;
  }
  getActiveCodeEditor() {
    return this._activeCodeEditor;
  }
  doOpenEditor(i, e) {
    if (!this.findModel(i, e.resource)) {
      if (e.resource) {
        const n = e.resource.scheme;
        if (n === Ue.http || n === Ue.https) return D8(e.resource.toString()), i;
      }
      return null;
    }
    const t = e.options ? e.options.selection : null;
    if (t) if (typeof t.endLineNumber == "number" && typeof t.endColumn == "number") i.setSelection(t), i.revealRangeInCenter(t, 1);
    else {
      const n = { lineNumber: t.startLineNumber, column: t.startColumn };
      i.setPosition(n), i.revealPositionInCenter(n, 1);
    }
    return i;
  }
  findModel(i, e) {
    const t = i.getModel();
    return t && t.uri.toString() !== e.toString() ? null : t;
  }
};
jC = oJ([Q5(0, Te), Q5(1, Yi)], jC), rt(mt, jC, 0);
const Pc = tt("layoutService");
var mW = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, fW = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let Ly = class {
  get mainContainer() {
    var i, e;
    return (e = (i = UT(this._codeEditorService.listCodeEditors())) === null || i === void 0 ? void 0 : i.getContainerDomNode()) !== null && e !== void 0 ? e : Et.document.body;
  }
  get activeContainer() {
    var i, e;
    const t = (i = this._codeEditorService.getFocusedCodeEditor()) !== null && i !== void 0 ? i : this._codeEditorService.getActiveCodeEditor();
    return (e = t == null ? void 0 : t.getContainerDomNode()) !== null && e !== void 0 ? e : this.mainContainer;
  }
  get mainContainerDimension() {
    return wc(this.mainContainer);
  }
  get activeContainerDimension() {
    return wc(this.activeContainer);
  }
  get containers() {
    return ca(this._codeEditorService.listCodeEditors().map((i) => i.getContainerDomNode()));
  }
  getContainer() {
    return this.activeContainer;
  }
  whenContainerStylesLoaded() {
  }
  focus() {
    var i;
    (i = this._codeEditorService.getFocusedCodeEditor()) === null || i === void 0 || i.focus();
  }
  constructor(i) {
    this._codeEditorService = i, this.onDidLayoutMainContainer = se.None, this.onDidLayoutActiveContainer = se.None, this.onDidLayoutContainer = se.None, this.onDidChangeActiveContainer = se.None, this.onDidAddContainer = se.None, this.mainContainerOffset = { top: 0, quickPickTop: 0 }, this.activeContainerOffset = { top: 0, quickPickTop: 0 };
  }
};
Ly = mW([fW(0, mt)], Ly);
let LI = class extends Ly {
  get mainContainer() {
    return this._container;
  }
  constructor(i, e) {
    super(e), this._container = i;
  }
};
LI = mW([fW(1, mt)], LI), rt(Pc, Ly, 1);
const M1 = tt("dialogService");
var rJ = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, J5 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
function xb(i) {
  return i.scheme === Ue.file ? i.fsPath : i.path;
}
let _W = 0;
class Nb {
  constructor(e, t, n, s, o, r, a) {
    this.id = ++_W, this.type = 0, this.actual = e, this.label = e.label, this.confirmBeforeUndo = e.confirmBeforeUndo || !1, this.resourceLabel = t, this.strResource = n, this.resourceLabels = [this.resourceLabel], this.strResources = [this.strResource], this.groupId = s, this.groupOrder = o, this.sourceId = r, this.sourceOrder = a, this.isValid = !0;
  }
  setValid(e) {
    this.isValid = e;
  }
  toString() {
    return `[id:${this.id}] [group:${this.groupId}] [${this.isValid ? "  VALID" : "INVALID"}] ${this.actual.constructor.name} - ${this.actual}`;
  }
}
class e3 {
  constructor(e, t) {
    this.resourceLabel = e, this.reason = t;
  }
}
class t3 {
  constructor() {
    this.elements = /* @__PURE__ */ new Map();
  }
  createMessage() {
    const e = [], t = [];
    for (const [, s] of this.elements)
      (s.reason === 0 ? e : t).push(s.resourceLabel);
    const n = [];
    return e.length > 0 && n.push(m(0, "The following files have been closed and modified on disk: {0}.", e.join(", "))), t.length > 0 && n.push(m(0, "The following files have been modified in an incompatible way: {0}.", t.join(", "))), n.join(`
`);
  }
  get size() {
    return this.elements.size;
  }
  has(e) {
    return this.elements.has(e);
  }
  set(e, t) {
    this.elements.set(e, t);
  }
  delete(e) {
    return this.elements.delete(e);
  }
}
class aJ {
  constructor(e, t, n, s, o, r, a) {
    this.id = ++_W, this.type = 1, this.actual = e, this.label = e.label, this.confirmBeforeUndo = e.confirmBeforeUndo || !1, this.resourceLabels = t, this.strResources = n, this.groupId = s, this.groupOrder = o, this.sourceId = r, this.sourceOrder = a, this.removedResources = null, this.invalidatedResources = null;
  }
  canSplit() {
    return typeof this.actual.split == "function";
  }
  removeResource(e, t, n) {
    this.removedResources || (this.removedResources = new t3()), this.removedResources.has(t) || this.removedResources.set(t, new e3(e, n));
  }
  setValid(e, t, n) {
    n ? this.invalidatedResources && (this.invalidatedResources.delete(t), this.invalidatedResources.size === 0 && (this.invalidatedResources = null)) : (this.invalidatedResources || (this.invalidatedResources = new t3()), this.invalidatedResources.has(t) || this.invalidatedResources.set(t, new e3(e, 0)));
  }
  toString() {
    return `[id:${this.id}] [group:${this.groupId}] [${this.invalidatedResources ? "INVALID" : "  VALID"}] ${this.actual.constructor.name} - ${this.actual}`;
  }
}
class vW {
  constructor(e, t) {
    this.resourceLabel = e, this.strResource = t, this._past = [], this._future = [], this.locked = !1, this.versionId = 1;
  }
  dispose() {
    for (const e of this._past) e.type === 1 && e.removeResource(this.resourceLabel, this.strResource, 0);
    for (const e of this._future) e.type === 1 && e.removeResource(this.resourceLabel, this.strResource, 0);
    this.versionId++;
  }
  toString() {
    const e = [];
    e.push(`* ${this.strResource}:`);
    for (let t = 0; t < this._past.length; t++) e.push(`   * [UNDO] ${this._past[t]}`);
    for (let t = this._future.length - 1; t >= 0; t--) e.push(`   * [REDO] ${this._future[t]}`);
    return e.join(`
`);
  }
  flushAllElements() {
    this._past = [], this._future = [], this.versionId++;
  }
  _setElementValidFlag(e, t) {
    e.type === 1 ? e.setValid(this.resourceLabel, this.strResource, t) : e.setValid(t);
  }
  setElementsValidFlag(e, t) {
    for (const n of this._past) t(n.actual) && this._setElementValidFlag(n, e);
    for (const n of this._future) t(n.actual) && this._setElementValidFlag(n, e);
  }
  pushElement(e) {
    for (const t of this._future) t.type === 1 && t.removeResource(this.resourceLabel, this.strResource, 1);
    this._future = [], this._past.push(e), this.versionId++;
  }
  createSnapshot(e) {
    const t = [];
    for (let n = 0, s = this._past.length; n < s; n++) t.push(this._past[n].id);
    for (let n = this._future.length - 1; n >= 0; n--) t.push(this._future[n].id);
    return new dW(e, t);
  }
  restoreSnapshot(e) {
    const t = e.elements.length;
    let n = !0, s = 0, o = -1;
    for (let a = 0, l = this._past.length; a < l; a++, s++) {
      const d = this._past[a];
      n && (s >= t || d.id !== e.elements[s]) && (n = !1, o = 0), n || d.type !== 1 || d.removeResource(this.resourceLabel, this.strResource, 0);
    }
    let r = -1;
    for (let a = this._future.length - 1; a >= 0; a--, s++) {
      const l = this._future[a];
      n && (s >= t || l.id !== e.elements[s]) && (n = !1, r = a), n || l.type !== 1 || l.removeResource(this.resourceLabel, this.strResource, 0);
    }
    o !== -1 && (this._past = this._past.slice(0, o)), r !== -1 && (this._future = this._future.slice(r + 1)), this.versionId++;
  }
  getElements() {
    const e = [], t = [];
    for (const n of this._past) e.push(n.actual);
    for (const n of this._future) t.push(n.actual);
    return { past: e, future: t };
  }
  getClosestPastElement() {
    return this._past.length === 0 ? null : this._past[this._past.length - 1];
  }
  getSecondClosestPastElement() {
    return this._past.length < 2 ? null : this._past[this._past.length - 2];
  }
  getClosestFutureElement() {
    return this._future.length === 0 ? null : this._future[this._future.length - 1];
  }
  hasPastElements() {
    return this._past.length > 0;
  }
  hasFutureElements() {
    return this._future.length > 0;
  }
  splitPastWorkspaceElement(e, t) {
    for (let n = this._past.length - 1; n >= 0; n--) if (this._past[n] === e) {
      t.has(this.strResource) ? this._past[n] = t.get(this.strResource) : this._past.splice(n, 1);
      break;
    }
    this.versionId++;
  }
  splitFutureWorkspaceElement(e, t) {
    for (let n = this._future.length - 1; n >= 0; n--) if (this._future[n] === e) {
      t.has(this.strResource) ? this._future[n] = t.get(this.strResource) : this._future.splice(n, 1);
      break;
    }
    this.versionId++;
  }
  moveBackward(e) {
    this._past.pop(), this._future.push(e), this.versionId++;
  }
  moveForward(e) {
    this._future.pop(), this._past.push(e), this.versionId++;
  }
}
class AD {
  constructor(e) {
    this.editStacks = e, this._versionIds = [];
    for (let t = 0, n = this.editStacks.length; t < n; t++) this._versionIds[t] = this.editStacks[t].versionId;
  }
  isValid() {
    for (let e = 0, t = this.editStacks.length; e < t; e++) if (this._versionIds[e] !== this.editStacks[e].versionId) return !1;
    return !0;
  }
}
const bW = new vW("", "");
bW.locked = !0;
let kI = class {
  constructor(i, e) {
    this._dialogService = i, this._notificationService = e, this._editStacks = /* @__PURE__ */ new Map(), this._uriComparisonKeyComputers = [];
  }
  getUriComparisonKey(i) {
    for (const e of this._uriComparisonKeyComputers) if (e[0] === i.scheme) return e[1].getComparisonKey(i);
    return i.toString();
  }
  _print(i) {
    console.log("------------------------------------"), console.log(`AFTER ${i}: `);
    const e = [];
    for (const t of this._editStacks) e.push(t[1].toString());
    console.log(e.join(`
`));
  }
  pushElement(i, e = gm.None, t = Ya.None) {
    if (i.type === 0) {
      const n = xb(i.resource), s = this.getUriComparisonKey(i.resource);
      this._pushElement(new Nb(i, n, s, e.id, e.nextOrder(), t.id, t.nextOrder()));
    } else {
      const n = /* @__PURE__ */ new Set(), s = [], o = [];
      for (const r of i.resources) {
        const a = xb(r), l = this.getUriComparisonKey(r);
        n.has(l) || (n.add(l), s.push(a), o.push(l));
      }
      s.length === 1 ? this._pushElement(new Nb(i, s[0], o[0], e.id, e.nextOrder(), t.id, t.nextOrder())) : this._pushElement(new aJ(i, s, o, e.id, e.nextOrder(), t.id, t.nextOrder()));
    }
  }
  _pushElement(i) {
    for (let e = 0, t = i.strResources.length; e < t; e++) {
      const n = i.resourceLabels[e], s = i.strResources[e];
      let o;
      this._editStacks.has(s) ? o = this._editStacks.get(s) : (o = new vW(n, s), this._editStacks.set(s, o)), o.pushElement(i);
    }
  }
  getLastElement(i) {
    const e = this.getUriComparisonKey(i);
    if (this._editStacks.has(e)) {
      const t = this._editStacks.get(e);
      if (t.hasFutureElements()) return null;
      const n = t.getClosestPastElement();
      return n ? n.actual : null;
    }
    return null;
  }
  _splitPastWorkspaceElement(i, e) {
    const t = i.actual.split(), n = /* @__PURE__ */ new Map();
    for (const s of t) {
      const o = xb(s.resource), r = this.getUriComparisonKey(s.resource), a = new Nb(s, o, r, 0, 0, 0, 0);
      n.set(a.strResource, a);
    }
    for (const s of i.strResources)
      e && e.has(s) || this._editStacks.get(s).splitPastWorkspaceElement(i, n);
  }
  _splitFutureWorkspaceElement(i, e) {
    const t = i.actual.split(), n = /* @__PURE__ */ new Map();
    for (const s of t) {
      const o = xb(s.resource), r = this.getUriComparisonKey(s.resource), a = new Nb(s, o, r, 0, 0, 0, 0);
      n.set(a.strResource, a);
    }
    for (const s of i.strResources)
      e && e.has(s) || this._editStacks.get(s).splitFutureWorkspaceElement(i, n);
  }
  removeElements(i) {
    const e = typeof i == "string" ? i : this.getUriComparisonKey(i);
    this._editStacks.has(e) && (this._editStacks.get(e).dispose(), this._editStacks.delete(e));
  }
  setElementsValidFlag(i, e, t) {
    const n = this.getUriComparisonKey(i);
    this._editStacks.has(n) && this._editStacks.get(n).setElementsValidFlag(e, t);
  }
  createSnapshot(i) {
    const e = this.getUriComparisonKey(i);
    return this._editStacks.has(e) ? this._editStacks.get(e).createSnapshot(i) : new dW(i, []);
  }
  restoreSnapshot(i) {
    const e = this.getUriComparisonKey(i.resource);
    if (this._editStacks.has(e)) {
      const t = this._editStacks.get(e);
      t.restoreSnapshot(i), t.hasPastElements() || t.hasFutureElements() || (t.dispose(), this._editStacks.delete(e));
    }
  }
  getElements(i) {
    const e = this.getUriComparisonKey(i);
    return this._editStacks.has(e) ? this._editStacks.get(e).getElements() : { past: [], future: [] };
  }
  _findClosestUndoElementWithSource(i) {
    if (!i) return [null, null];
    let e = null, t = null;
    for (const [n, s] of this._editStacks) {
      const o = s.getClosestPastElement();
      o && o.sourceId === i && (!e || o.sourceOrder > e.sourceOrder) && (e = o, t = n);
    }
    return [e, t];
  }
  canUndo(i) {
    if (i instanceof Ya) {
      const [, t] = this._findClosestUndoElementWithSource(i.id);
      return !!t;
    }
    const e = this.getUriComparisonKey(i);
    return this._editStacks.has(e) ? this._editStacks.get(e).hasPastElements() : !1;
  }
  _onError(i, e) {
    We(i);
    for (const t of e.strResources) this.removeElements(t);
    this._notificationService.error(i);
  }
  _acquireLocks(i) {
    for (const e of i.editStacks) if (e.locked) throw new Error("Cannot acquire edit stack lock");
    for (const e of i.editStacks) e.locked = !0;
    return () => {
      for (const e of i.editStacks) e.locked = !1;
    };
  }
  _safeInvokeWithLocks(i, e, t, n, s) {
    const o = this._acquireLocks(t);
    let r;
    try {
      r = e();
    } catch (a) {
      return o(), n.dispose(), this._onError(a, i);
    }
    return r ? r.then(() => (o(), n.dispose(), s()), (a) => (o(), n.dispose(), this._onError(a, i))) : (o(), n.dispose(), s());
  }
  async _invokeWorkspacePrepare(i) {
    if (i.actual.prepareUndoRedo === void 0) return V.None;
    const e = i.actual.prepareUndoRedo();
    return e === void 0 ? V.None : e;
  }
  _invokeResourcePrepare(i, e) {
    if (i.actual.type !== 1 || i.actual.prepareUndoRedo === void 0) return e(V.None);
    const t = i.actual.prepareUndoRedo();
    return t ? XT(t) ? e(t) : t.then((n) => e(n)) : e(V.None);
  }
  _getAffectedEditStacks(i) {
    const e = [];
    for (const t of i.strResources) e.push(this._editStacks.get(t) || bW);
    return new AD(e);
  }
  _tryToSplitAndUndo(i, e, t, n) {
    if (e.canSplit()) return this._splitPastWorkspaceElement(e, t), this._notificationService.warn(n), new Eb(this._undo(i, 0, !0));
    for (const s of e.strResources) this.removeElements(s);
    return this._notificationService.warn(n), new Eb();
  }
  _checkWorkspaceUndo(i, e, t, n) {
    if (e.removedResources) return this._tryToSplitAndUndo(i, e, e.removedResources, m(0, "Could not undo '{0}' across all files. {1}", e.label, e.removedResources.createMessage()));
    if (n && e.invalidatedResources) return this._tryToSplitAndUndo(i, e, e.invalidatedResources, m(0, "Could not undo '{0}' across all files. {1}", e.label, e.invalidatedResources.createMessage()));
    const s = [];
    for (const r of t.editStacks) r.getClosestPastElement() !== e && s.push(r.resourceLabel);
    if (s.length > 0) return this._tryToSplitAndUndo(i, e, null, m(0, "Could not undo '{0}' across all files because changes were made to {1}", e.label, s.join(", ")));
    const o = [];
    for (const r of t.editStacks) r.locked && o.push(r.resourceLabel);
    return o.length > 0 ? this._tryToSplitAndUndo(i, e, null, m(0, "Could not undo '{0}' across all files because there is already an undo or redo operation running on {1}", e.label, o.join(", "))) : t.isValid() ? null : this._tryToSplitAndUndo(i, e, null, m(0, "Could not undo '{0}' across all files because an undo or redo operation occurred in the meantime", e.label));
  }
  _workspaceUndo(i, e, t) {
    const n = this._getAffectedEditStacks(e), s = this._checkWorkspaceUndo(i, e, n, !1);
    return s ? s.returnValue : this._confirmAndExecuteWorkspaceUndo(i, e, n, t);
  }
  _isPartOfUndoGroup(i) {
    if (!i.groupId) return !1;
    for (const [, e] of this._editStacks) {
      const t = e.getClosestPastElement();
      if (t) {
        if (t === i) {
          const n = e.getSecondClosestPastElement();
          if (n && n.groupId === i.groupId) return !0;
        }
        if (t.groupId === i.groupId) return !0;
      }
    }
    return !1;
  }
  async _confirmAndExecuteWorkspaceUndo(i, e, t, n) {
    if (e.canSplit() && !this._isPartOfUndoGroup(e)) {
      let r;
      (function(d) {
        d[d.All = 0] = "All", d[d.This = 1] = "This", d[d.Cancel = 2] = "Cancel";
      })(r || (r = {}));
      const { result: a } = await this._dialogService.prompt({ type: ki.Info, message: m(0, "Would you like to undo '{0}' across all files?", e.label), buttons: [{ label: m(0, "&&Undo in {0} Files", t.editStacks.length), run: () => r.All }, { label: m(0, "Undo this &&File"), run: () => r.This }], cancelButton: { run: () => r.Cancel } });
      if (a === r.Cancel) return;
      if (a === r.This) return this._splitPastWorkspaceElement(e, null), this._undo(i, 0, !0);
      const l = this._checkWorkspaceUndo(i, e, t, !1);
      if (l) return l.returnValue;
      n = !0;
    }
    let s;
    try {
      s = await this._invokeWorkspacePrepare(e);
    } catch (r) {
      return this._onError(r, e);
    }
    const o = this._checkWorkspaceUndo(i, e, t, !0);
    if (o) return s.dispose(), o.returnValue;
    for (const r of t.editStacks) r.moveBackward(e);
    return this._safeInvokeWithLocks(e, () => e.actual.undo(), t, s, () => this._continueUndoInGroup(e.groupId, n));
  }
  _resourceUndo(i, e, t) {
    if (e.isValid) {
      if (!i.locked) return this._invokeResourcePrepare(e, (n) => (i.moveBackward(e), this._safeInvokeWithLocks(e, () => e.actual.undo(), new AD([i]), n, () => this._continueUndoInGroup(e.groupId, t))));
      {
        const n = m(0, "Could not undo '{0}' because there is already an undo or redo operation running.", e.label);
        this._notificationService.warn(n);
      }
    } else i.flushAllElements();
  }
  _findClosestUndoElementInGroup(i) {
    if (!i) return [null, null];
    let e = null, t = null;
    for (const [n, s] of this._editStacks) {
      const o = s.getClosestPastElement();
      o && o.groupId === i && (!e || o.groupOrder > e.groupOrder) && (e = o, t = n);
    }
    return [e, t];
  }
  _continueUndoInGroup(i, e) {
    if (!i) return;
    const [, t] = this._findClosestUndoElementInGroup(i);
    return t ? this._undo(t, 0, e) : void 0;
  }
  undo(i) {
    if (i instanceof Ya) {
      const [, e] = this._findClosestUndoElementWithSource(i.id);
      return e ? this._undo(e, i.id, !1) : void 0;
    }
    return typeof i == "string" ? this._undo(i, 0, !1) : this._undo(this.getUriComparisonKey(i), 0, !1);
  }
  _undo(i, e = 0, t) {
    if (!this._editStacks.has(i)) return;
    const n = this._editStacks.get(i), s = n.getClosestPastElement();
    if (s) {
      if (s.groupId) {
        const [o, r] = this._findClosestUndoElementInGroup(s.groupId);
        if (s !== o && r) return this._undo(r, e, t);
      }
      if ((s.sourceId !== e || s.confirmBeforeUndo) && !t) return this._confirmAndContinueUndo(i, e, s);
      try {
        return s.type === 1 ? this._workspaceUndo(i, s, t) : this._resourceUndo(n, s, t);
      } finally {
      }
    }
  }
  async _confirmAndContinueUndo(i, e, t) {
    if ((await this._dialogService.confirm({ message: m(0, "Would you like to undo '{0}'?", t.label), primaryButton: m(0, "&&Yes"), cancelButton: m(0, "No") })).confirmed) return this._undo(i, e, !0);
  }
  _findClosestRedoElementWithSource(i) {
    if (!i) return [null, null];
    let e = null, t = null;
    for (const [n, s] of this._editStacks) {
      const o = s.getClosestFutureElement();
      o && o.sourceId === i && (!e || o.sourceOrder < e.sourceOrder) && (e = o, t = n);
    }
    return [e, t];
  }
  canRedo(i) {
    if (i instanceof Ya) {
      const [, t] = this._findClosestRedoElementWithSource(i.id);
      return !!t;
    }
    const e = this.getUriComparisonKey(i);
    return this._editStacks.has(e) ? this._editStacks.get(e).hasFutureElements() : !1;
  }
  _tryToSplitAndRedo(i, e, t, n) {
    if (e.canSplit()) return this._splitFutureWorkspaceElement(e, t), this._notificationService.warn(n), new Eb(this._redo(i));
    for (const s of e.strResources) this.removeElements(s);
    return this._notificationService.warn(n), new Eb();
  }
  _checkWorkspaceRedo(i, e, t, n) {
    if (e.removedResources) return this._tryToSplitAndRedo(i, e, e.removedResources, m(0, "Could not redo '{0}' across all files. {1}", e.label, e.removedResources.createMessage()));
    if (n && e.invalidatedResources) return this._tryToSplitAndRedo(i, e, e.invalidatedResources, m(0, "Could not redo '{0}' across all files. {1}", e.label, e.invalidatedResources.createMessage()));
    const s = [];
    for (const r of t.editStacks) r.getClosestFutureElement() !== e && s.push(r.resourceLabel);
    if (s.length > 0) return this._tryToSplitAndRedo(i, e, null, m(0, "Could not redo '{0}' across all files because changes were made to {1}", e.label, s.join(", ")));
    const o = [];
    for (const r of t.editStacks) r.locked && o.push(r.resourceLabel);
    return o.length > 0 ? this._tryToSplitAndRedo(i, e, null, m(0, "Could not redo '{0}' across all files because there is already an undo or redo operation running on {1}", e.label, o.join(", "))) : t.isValid() ? null : this._tryToSplitAndRedo(i, e, null, m(0, "Could not redo '{0}' across all files because an undo or redo operation occurred in the meantime", e.label));
  }
  _workspaceRedo(i, e) {
    const t = this._getAffectedEditStacks(e), n = this._checkWorkspaceRedo(i, e, t, !1);
    return n ? n.returnValue : this._executeWorkspaceRedo(i, e, t);
  }
  async _executeWorkspaceRedo(i, e, t) {
    let n;
    try {
      n = await this._invokeWorkspacePrepare(e);
    } catch (o) {
      return this._onError(o, e);
    }
    const s = this._checkWorkspaceRedo(i, e, t, !0);
    if (s) return n.dispose(), s.returnValue;
    for (const o of t.editStacks) o.moveForward(e);
    return this._safeInvokeWithLocks(e, () => e.actual.redo(), t, n, () => this._continueRedoInGroup(e.groupId));
  }
  _resourceRedo(i, e) {
    if (e.isValid) {
      if (!i.locked) return this._invokeResourcePrepare(e, (t) => (i.moveForward(e), this._safeInvokeWithLocks(e, () => e.actual.redo(), new AD([i]), t, () => this._continueRedoInGroup(e.groupId))));
      {
        const t = m(0, "Could not redo '{0}' because there is already an undo or redo operation running.", e.label);
        this._notificationService.warn(t);
      }
    } else i.flushAllElements();
  }
  _findClosestRedoElementInGroup(i) {
    if (!i) return [null, null];
    let e = null, t = null;
    for (const [n, s] of this._editStacks) {
      const o = s.getClosestFutureElement();
      o && o.groupId === i && (!e || o.groupOrder < e.groupOrder) && (e = o, t = n);
    }
    return [e, t];
  }
  _continueRedoInGroup(i) {
    if (!i) return;
    const [, e] = this._findClosestRedoElementInGroup(i);
    return e ? this._redo(e) : void 0;
  }
  redo(i) {
    if (i instanceof Ya) {
      const [, e] = this._findClosestRedoElementWithSource(i.id);
      return e ? this._redo(e) : void 0;
    }
    return typeof i == "string" ? this._redo(i) : this._redo(this.getUriComparisonKey(i));
  }
  _redo(i) {
    if (!this._editStacks.has(i)) return;
    const e = this._editStacks.get(i), t = e.getClosestFutureElement();
    if (t) {
      if (t.groupId) {
        const [n, s] = this._findClosestRedoElementInGroup(t.groupId);
        if (t !== n && s) return this._redo(s);
      }
      try {
        return t.type === 1 ? this._workspaceRedo(i, t) : this._resourceRedo(e, t);
      } finally {
      }
    }
  }
};
kI = rJ([J5(0, M1), J5(1, Ri)], kI);
class Eb {
  constructor(e) {
    this.returnValue = e;
  }
}
function as(i, e, t) {
  return Math.min(Math.max(i, e), t);
}
rt(mL, kI, 1);
class CW {
  constructor() {
    this._n = 1, this._val = 0;
  }
  update(e) {
    return this._val = this._val + (e - this._val) / this._n, this._n += 1, this._val;
  }
  get value() {
    return this._val;
  }
}
class lJ {
  constructor(e) {
    this._n = 0, this._val = 0, this._values = [], this._index = 0, this._sum = 0, this._values = new Array(e), this._values.fill(0, 0, e);
  }
  update(e) {
    const t = this._values[this._index];
    return this._values[this._index] = e, this._index = (this._index + 1) % this._values.length, this._sum -= t, this._sum += e, this._n < this._values.length && (this._n += 1), this._val = this._sum / this._n, this._val;
  }
  get value() {
    return this._val;
  }
}
const uA = tt("environmentService");
var dJ = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, i3 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const ar = tt("ILanguageFeatureDebounceService");
var ky;
(function(i) {
  const e = /* @__PURE__ */ new WeakMap();
  let t = 0;
  i.of = function(n) {
    let s = e.get(n);
    return s === void 0 && (s = ++t, e.set(n, s)), s;
  };
})(ky || (ky = {}));
class hJ {
  constructor(e) {
    this._default = e;
  }
  get(e) {
    return this._default;
  }
  update(e, t) {
    return this._default;
  }
  default() {
    return this._default;
  }
}
class cJ {
  constructor(e, t, n, s, o, r) {
    this._logService = e, this._name = t, this._registry = n, this._default = s, this._min = o, this._max = r, this._cache = new Ll(50, 0.7);
  }
  _key(e) {
    return e.id + this._registry.all(e).reduce((t, n) => Kw(ky.of(n), t), 0);
  }
  get(e) {
    const t = this._key(e), n = this._cache.get(t);
    return n ? as(n.value, this._min, this._max) : this.default();
  }
  update(e, t) {
    const n = this._key(e);
    let s = this._cache.get(n);
    s || (s = new lJ(6), this._cache.set(n, s));
    const o = as(s.update(t), this._min, this._max);
    return gR(e.uri, "output") || this._logService.trace(`[DEBOUNCE: ${this._name}] for ${e.uri.toString()} is ${o}ms`), o;
  }
  _overall() {
    const e = new CW();
    for (const [, t] of this._cache) e.update(t.value);
    return e.value;
  }
  default() {
    return as(0 | this._overall() || this._default, this._min, this._max);
  }
}
let PD = class {
  constructor(i, e) {
    this._logService = i, this._data = /* @__PURE__ */ new Map(), this._isDev = e.isExtensionDevelopment || !e.isBuilt;
  }
  for(i, e, t) {
    var n, s, o;
    const r = (n = t == null ? void 0 : t.min) !== null && n !== void 0 ? n : 50, a = (s = t == null ? void 0 : t.max) !== null && s !== void 0 ? s : r ** 2, l = (o = t == null ? void 0 : t.key) !== null && o !== void 0 ? o : void 0, d = `${ky.of(i)},${r}${l ? "," + l : ""}`;
    let h = this._data.get(d);
    return h || (this._isDev ? h = new cJ(this._logService, e, i, 0 | this._overallAverage() || 1.5 * r, r, a) : (this._logService.debug(`[DEBOUNCE: ${e}] is disabled in developed mode`), h = new hJ(1.5 * r)), this._data.set(d, h)), h;
  }
  _overallAverage() {
    const i = new CW();
    for (const e of this._data.values()) i.update(e.default());
    return i.value;
  }
};
PD = dJ([i3(0, ts), i3(1, uA)], PD), rt(ar, PD, 1);
class f0 {
  static create(e, t) {
    return new f0(e, new Dy(t));
  }
  get startLineNumber() {
    return this._startLineNumber;
  }
  get endLineNumber() {
    return this._endLineNumber;
  }
  constructor(e, t) {
    this._startLineNumber = e, this._tokens = t, this._endLineNumber = this._startLineNumber + this._tokens.getMaxDeltaLine();
  }
  toString() {
    return this._tokens.toString(this._startLineNumber);
  }
  _updateEndLineNumber() {
    this._endLineNumber = this._startLineNumber + this._tokens.getMaxDeltaLine();
  }
  isEmpty() {
    return this._tokens.isEmpty();
  }
  getLineTokens(e) {
    return this._startLineNumber <= e && e <= this._endLineNumber ? this._tokens.getLineTokens(e - this._startLineNumber) : null;
  }
  getRange() {
    const e = this._tokens.getRange();
    return e && new D(this._startLineNumber + e.startLineNumber, e.startColumn, this._startLineNumber + e.endLineNumber, e.endColumn);
  }
  removeTokens(e) {
    const t = e.startLineNumber - this._startLineNumber, n = e.endLineNumber - this._startLineNumber;
    this._startLineNumber += this._tokens.removeTokens(t, e.startColumn - 1, n, e.endColumn - 1), this._updateEndLineNumber();
  }
  split(e) {
    const t = e.startLineNumber - this._startLineNumber, n = e.endLineNumber - this._startLineNumber, [s, o, r] = this._tokens.split(t, e.startColumn - 1, n, e.endColumn - 1);
    return [new f0(this._startLineNumber, s), new f0(this._startLineNumber + r, o)];
  }
  applyEdit(e, t) {
    const [n, s, o] = Dc(t);
    this.acceptEdit(e, n, s, o, t.length > 0 ? t.charCodeAt(0) : 0);
  }
  acceptEdit(e, t, n, s, o) {
    this._acceptDeleteRange(e), this._acceptInsertText(new W(e.startLineNumber, e.startColumn), t, n, s, o), this._updateEndLineNumber();
  }
  _acceptDeleteRange(e) {
    if (e.startLineNumber === e.endLineNumber && e.startColumn === e.endColumn) return;
    const t = e.startLineNumber - this._startLineNumber, n = e.endLineNumber - this._startLineNumber;
    if (n < 0) {
      const o = n - t;
      return void (this._startLineNumber -= o);
    }
    const s = this._tokens.getMaxDeltaLine();
    if (!(t >= s + 1)) {
      if (t < 0 && n >= s + 1) return this._startLineNumber = 0, void this._tokens.clear();
      if (t < 0) {
        const o = -t;
        this._startLineNumber -= o, this._tokens.acceptDeleteRange(e.startColumn - 1, 0, 0, n, e.endColumn - 1);
      } else this._tokens.acceptDeleteRange(0, t, e.startColumn - 1, n, e.endColumn - 1);
    }
  }
  _acceptInsertText(e, t, n, s, o) {
    if (t === 0 && n === 0) return;
    const r = e.lineNumber - this._startLineNumber;
    if (r < 0) return void (this._startLineNumber += t);
    r >= this._tokens.getMaxDeltaLine() + 1 || this._tokens.acceptInsertText(r, e.column - 1, t, n, s, o);
  }
}
class Dy {
  constructor(e) {
    this._tokens = e, this._tokenCount = e.length / 4;
  }
  toString(e) {
    const t = [];
    for (let n = 0; n < this._tokenCount; n++) t.push(`(${this._getDeltaLine(n) + e},${this._getStartCharacter(n)}-${this._getEndCharacter(n)})`);
    return `[${t.join(",")}]`;
  }
  getMaxDeltaLine() {
    const e = this._getTokenCount();
    return e === 0 ? -1 : this._getDeltaLine(e - 1);
  }
  getRange() {
    const e = this._getTokenCount();
    if (e === 0) return null;
    const t = this._getStartCharacter(0), n = this._getDeltaLine(e - 1), s = this._getEndCharacter(e - 1);
    return new D(0, t + 1, n, s + 1);
  }
  _getTokenCount() {
    return this._tokenCount;
  }
  _getDeltaLine(e) {
    return this._tokens[4 * e];
  }
  _getStartCharacter(e) {
    return this._tokens[4 * e + 1];
  }
  _getEndCharacter(e) {
    return this._tokens[4 * e + 2];
  }
  isEmpty() {
    return this._getTokenCount() === 0;
  }
  getLineTokens(e) {
    let t = 0, n = this._getTokenCount() - 1;
    for (; t < n; ) {
      const s = t + Math.floor((n - t) / 2), o = this._getDeltaLine(s);
      if (o < e) t = s + 1;
      else {
        if (!(o > e)) {
          let r = s;
          for (; r > t && this._getDeltaLine(r - 1) === e; ) r--;
          let a = s;
          for (; a < n && this._getDeltaLine(a + 1) === e; ) a++;
          return new n3(this._tokens.subarray(4 * r, 4 * a + 4));
        }
        n = s - 1;
      }
    }
    return this._getDeltaLine(t) === e ? new n3(this._tokens.subarray(4 * t, 4 * t + 4)) : null;
  }
  clear() {
    this._tokenCount = 0;
  }
  removeTokens(e, t, n, s) {
    const o = this._tokens, r = this._tokenCount;
    let a = 0, l = !1, d = 0;
    for (let h = 0; h < r; h++) {
      const c = 4 * h, u = o[c], g = o[c + 1], p = o[c + 2], f = o[c + 3];
      if ((u > e || u === e && p >= t) && (u < n || u === n && g <= s)) l = !0;
      else {
        if (a === 0 && (d = u), l) {
          const _ = 4 * a;
          o[_] = u - d, o[_ + 1] = g, o[_ + 2] = p, o[_ + 3] = f;
        }
        a++;
      }
    }
    return this._tokenCount = a, d;
  }
  split(e, t, n, s) {
    const o = this._tokens, r = this._tokenCount, a = [], l = [];
    let d = a, h = 0, c = 0;
    for (let u = 0; u < r; u++) {
      const g = 4 * u, p = o[g], f = o[g + 1], _ = o[g + 2], v = o[g + 3];
      if (p > e || p === e && _ >= t) {
        if (p < n || p === n && f <= s) continue;
        d !== l && (d = l, h = 0, c = p);
      }
      d[h++] = p - c, d[h++] = f, d[h++] = _, d[h++] = v;
    }
    return [new Dy(new Uint32Array(a)), new Dy(new Uint32Array(l)), c];
  }
  acceptDeleteRange(e, t, n, s, o) {
    const r = this._tokens, a = this._tokenCount, l = s - t;
    let d = 0, h = !1;
    for (let c = 0; c < a; c++) {
      const u = 4 * c;
      let g = r[u], p = r[u + 1], f = r[u + 2];
      const _ = r[u + 3];
      if (g < t || g === t && f <= n) {
        d++;
        continue;
      }
      if (g === t && p < n) g === s && f > o ? f -= o - n : f = n;
      else if (g === t && p === n) {
        if (!(g === s && f > o)) {
          h = !0;
          continue;
        }
        f -= o - n;
      } else if (g < s || g === s && p < o) {
        if (!(g === s && f > o)) {
          h = !0;
          continue;
        }
        g = t, p = n, f = p + (f - o);
      } else if (g > s) {
        if (l === 0 && !h) {
          d = a;
          break;
        }
        g -= l;
      } else {
        if (!(g === s && p >= o)) throw new Error("Not possible!");
        e && g === 0 && (p += e, f += e), g -= l, p -= o - n, f -= o - n;
      }
      const v = 4 * d;
      r[v] = g, r[v + 1] = p, r[v + 2] = f, r[v + 3] = _, d++;
    }
    this._tokenCount = d;
  }
  acceptInsertText(e, t, n, s, o, r) {
    const a = n === 0 && s === 1 && (r >= 48 && r <= 57 || r >= 65 && r <= 90 || r >= 97 && r <= 122), l = this._tokens, d = this._tokenCount;
    for (let h = 0; h < d; h++) {
      const c = 4 * h;
      let u = l[c], g = l[c + 1], p = l[c + 2];
      if (!(u < e || u === e && p < t)) {
        if (u === e && p === t) {
          if (!a) continue;
          p += 1;
        } else if (u === e && g < t && t < p) n === 0 ? p += s : p = t;
        else {
          if (u === e && g === t && a) continue;
          if (u === e) if (u += n, n === 0) g += s, p += s;
          else {
            const f = p - g;
            g = o + (g - t), p = g + f;
          }
          else u += n;
        }
        l[c] = u, l[c + 1] = g, l[c + 2] = p;
      }
    }
  }
}
class n3 {
  constructor(e) {
    this._tokens = e;
  }
  getCount() {
    return this._tokens.length / 4;
  }
  getStartCharacter(e) {
    return this._tokens[4 * e + 1];
  }
  getEndCharacter(e) {
    return this._tokens[4 * e + 2];
  }
  getMetadata(e) {
    return this._tokens[4 * e + 3];
  }
}
var uJ = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, OD = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let DI = class {
  constructor(i, e, t, n) {
    this._legend = i, this._themeService = e, this._languageService = t, this._logService = n, this._hasWarnedOverlappingTokens = !1, this._hasWarnedInvalidLengthTokens = !1, this._hasWarnedInvalidEditStart = !1, this._hashTable = new ql();
  }
  getMetadata(i, e, t) {
    const n = this._languageService.languageIdCodec.encodeLanguageId(t), s = this._hashTable.get(i, e, n);
    let o;
    if (s) o = s.metadata, this._logService.getLevel() === Nn.Trace && this._logService.trace(`SemanticTokensProviderStyling [CACHED] ${i} / ${e}: foreground ${In.getForeground(o)}, fontStyle ${In.getFontStyle(o).toString(2)}`);
    else {
      let r = this._legend.tokenTypes[i];
      const a = [];
      if (r) {
        let l = e;
        for (let h = 0; l > 0 && h < this._legend.tokenModifiers.length; h++) 1 & l && a.push(this._legend.tokenModifiers[h]), l >>= 1;
        l > 0 && this._logService.getLevel() === Nn.Trace && (this._logService.trace(`SemanticTokensProviderStyling: unknown token modifier index: ${e.toString(2)} for legend: ${JSON.stringify(this._legend.tokenModifiers)}`), a.push("not-in-legend"));
        const d = this._themeService.getColorTheme().getTokenStyleMetadata(r, a, t);
        d === void 0 ? o = 2147483647 : (o = 0, d.italic !== void 0 && (o |= 1 | (d.italic ? 1 : 0) << 11), d.bold !== void 0 && (o |= 2 | (d.bold ? 2 : 0) << 11), d.underline !== void 0 && (o |= 4 | (d.underline ? 4 : 0) << 11), d.strikethrough !== void 0 && (o |= 8 | (d.strikethrough ? 8 : 0) << 11), d.foreground && (o |= 16 | d.foreground << 15), o === 0 && (o = 2147483647));
      } else this._logService.getLevel() === Nn.Trace && this._logService.trace(`SemanticTokensProviderStyling: unknown token type index: ${i} for legend: ${JSON.stringify(this._legend.tokenTypes)}`), o = 2147483647, r = "not-in-legend";
      this._hashTable.add(i, e, n, o), this._logService.getLevel() === Nn.Trace && this._logService.trace(`SemanticTokensProviderStyling ${i} (${r}) / ${e} (${a.join(" ")}): foreground ${In.getForeground(o)}, fontStyle ${In.getFontStyle(o).toString(2)}`);
    }
    return o;
  }
  warnOverlappingSemanticTokens(i, e) {
    this._hasWarnedOverlappingTokens || (this._hasWarnedOverlappingTokens = !0, this._logService.warn(`Overlapping semantic tokens detected at lineNumber ${i}, column ${e}`));
  }
  warnInvalidLengthSemanticTokens(i, e) {
    this._hasWarnedInvalidLengthTokens || (this._hasWarnedInvalidLengthTokens = !0, this._logService.warn(`Semantic token with invalid length detected at lineNumber ${i}, column ${e}`));
  }
  warnInvalidEditStart(i, e, t, n, s) {
    this._hasWarnedInvalidEditStart || (this._hasWarnedInvalidEditStart = !0, this._logService.warn(`Invalid semantic tokens edit detected (previousResultId: ${i}, resultId: ${e}) at edit #${t}: The provided start offset ${n} is outside the previous data (length ${s}).`));
  }
};
function wW(i, e, t) {
  const n = i.data, s = i.data.length / 5 | 0, o = Math.max(Math.ceil(s / 1024), 400), r = [];
  let a = 0, l = 1, d = 0;
  for (; a < s; ) {
    const h = a;
    let c = Math.min(h + o, s);
    if (c < s) {
      let b = c;
      for (; b - 1 > h && n[5 * b] === 0; ) b--;
      if (b - 1 === h) {
        let C = c;
        for (; C + 1 < s && n[5 * C] === 0; ) C++;
        c = C;
      } else c = b;
    }
    let u = new Uint32Array(4 * (c - h)), g = 0, p = 0, f = 0, _ = 0;
    for (; a < c; ) {
      const b = 5 * a, C = n[b], w = n[b + 1], y = l + C | 0, L = C === 0 ? d + w | 0 : w, k = L + n[b + 2] | 0, N = n[b + 3], A = n[b + 4];
      if (k <= L) e.warnInvalidLengthSemanticTokens(y, L + 1);
      else if (f === y && _ > L) e.warnOverlappingSemanticTokens(y, L + 1);
      else {
        const B = e.getMetadata(N, A, t);
        B !== 2147483647 && (p === 0 && (p = y), u[g] = y - p, u[g + 1] = L, u[g + 2] = k, u[g + 3] = B, g += 4, f = y, _ = k);
      }
      l = y, d = L, a++;
    }
    g !== u.length && (u = u.subarray(0, g));
    const v = f0.create(p, u);
    r.push(v);
  }
  return r;
}
DI = uJ([OD(1, Yi), OD(2, Xt), OD(3, ts)], DI);
class gJ {
  constructor(e, t, n, s) {
    this.tokenTypeIndex = e, this.tokenModifierSet = t, this.languageId = n, this.metadata = s, this.next = null;
  }
}
class ql {
  constructor() {
    this._elementsCount = 0, this._currentLengthIndex = 0, this._currentLength = ql._SIZES[this._currentLengthIndex], this._growCount = Math.round(this._currentLengthIndex + 1 < ql._SIZES.length ? 2 / 3 * this._currentLength : 0), this._elements = [], ql._nullOutEntries(this._elements, this._currentLength);
  }
  static _nullOutEntries(e, t) {
    for (let n = 0; n < t; n++) e[n] = null;
  }
  _hash2(e, t) {
    return (e << 5) - e + t | 0;
  }
  _hashFunc(e, t, n) {
    return this._hash2(this._hash2(e, t), n) % this._currentLength;
  }
  get(e, t, n) {
    const s = this._hashFunc(e, t, n);
    let o = this._elements[s];
    for (; o; ) {
      if (o.tokenTypeIndex === e && o.tokenModifierSet === t && o.languageId === n) return o;
      o = o.next;
    }
    return null;
  }
  add(e, t, n, s) {
    if (this._elementsCount++, this._growCount !== 0 && this._elementsCount >= this._growCount) {
      const o = this._elements;
      this._currentLengthIndex++, this._currentLength = ql._SIZES[this._currentLengthIndex], this._growCount = Math.round(this._currentLengthIndex + 1 < ql._SIZES.length ? 2 / 3 * this._currentLength : 0), this._elements = [], ql._nullOutEntries(this._elements, this._currentLength);
      for (const r of o) {
        let a = r;
        for (; a; ) {
          const l = a.next;
          a.next = null, this._add(a), a = l;
        }
      }
    }
    this._add(new gJ(e, t, n, s));
  }
  _add(e) {
    const t = this._hashFunc(e.tokenTypeIndex, e.tokenModifierSet, e.languageId);
    e.next = this._elements[t], this._elements[t] = e;
  }
}
ql._SIZES = [3, 7, 13, 31, 61, 127, 251, 509, 1021, 2039, 4093, 8191, 16381, 32749, 65521, 131071, 262139, 524287, 1048573, 2097143];
const _L = tt("semanticTokensStylingService");
var pJ = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, FD = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let BD = class extends V {
  constructor(i, e, t) {
    super(), this._themeService = i, this._logService = e, this._languageService = t, this._caches = /* @__PURE__ */ new WeakMap(), this._register(this._themeService.onDidColorThemeChange(() => {
      this._caches = /* @__PURE__ */ new WeakMap();
    }));
  }
  getStyling(i) {
    return this._caches.has(i) || this._caches.set(i, new DI(i.getLegend(), this._themeService, this._languageService, this._logService)), this._caches.get(i);
  }
};
BD = pJ([FD(0, Yi), FD(1, ts), FD(2, Xt)], BD), rt(_L, BD, 1);
const Ib = "**", s3 = "/", qC = "[/\\\\]", $C = "[^/\\\\]", mJ = /\//g;
function o3(i, e) {
  switch (i) {
    case 0:
      return "";
    case 1:
      return `${$C}*?`;
    default:
      return `(?:${qC}|${$C}+${qC}${e ? `|${qC}${$C}+` : ""})*?`;
  }
}
function r3(i, e) {
  if (!i) return [];
  const t = [];
  let n = !1, s = !1, o = "";
  for (const r of i) {
    switch (r) {
      case e:
        if (!n && !s) {
          t.push(o), o = "";
          continue;
        }
        break;
      case "{":
        n = !0;
        break;
      case "}":
        n = !1;
        break;
      case "[":
        s = !0;
        break;
      case "]":
        s = !1;
    }
    o += r;
  }
  return o && t.push(o), t;
}
function yW(i) {
  if (!i) return "";
  let e = "";
  const t = r3(i, s3);
  if (t.every((n) => n === Ib)) e = ".*";
  else {
    let n = !1;
    t.forEach((s, o) => {
      if (s === Ib) {
        if (n) return;
        e += o3(2, o === t.length - 1);
      } else {
        let r = !1, a = "", l = !1, d = "";
        for (const h of s) if (h !== "}" && r) a += h;
        else if (!l || h === "]" && d) switch (h) {
          case "{":
            r = !0;
            continue;
          case "[":
            l = !0;
            continue;
          case "}": {
            const c = `(?:${r3(a, ",").map((u) => yW(u)).join("|")})`;
            e += c, r = !1, a = "";
            break;
          }
          case "]":
            e += "[" + d + "]", l = !1, d = "";
            break;
          case "?":
            e += $C;
            continue;
          case "*":
            e += o3(1);
            continue;
          default:
            e += No(h);
        }
        else {
          let c;
          c = h === "-" ? h : h !== "^" && h !== "!" || d ? h === s3 ? "" : No(h) : "^", d += c;
        }
        o < t.length - 1 && (t[o + 1] !== Ib || o + 2 < t.length) && (e += qC);
      }
      n = s === Ib;
    });
  }
  return e;
}
const fJ = /^\*\*\/\*\.[\w\.-]+$/, _J = /^\*\*\/([\w\.-]+)\/?$/, vJ = /^{\*\*\/\*?[\w\.-]+\/?(,\*\*\/\*?[\w\.-]+\/?)*}$/, bJ = /^{\*\*\/\*?[\w\.-]+(\/(\*\*)?)?(,\*\*\/\*?[\w\.-]+(\/(\*\*)?)?)*}$/, CJ = /^\*\*((\/[\w\.-]+)+)\/?$/, wJ = /^([\w\.-]+(\/[\w\.-]+)*)\/?$/, a3 = new Ll(1e4), l3 = function() {
  return !1;
}, za = function() {
  return null;
};
function xI(i, e) {
  if (!i) return za;
  let t;
  t = typeof i != "string" ? i.pattern : i, t = t.trim();
  const n = `${t}_${!!e.trimForExclusions}`;
  let s, o = a3.get(n);
  return o || (o = fJ.test(t) ? /* @__PURE__ */ function(r, a) {
    return function(l, d) {
      return typeof l == "string" && l.endsWith(r) ? a : null;
    };
  }(t.substr(4), t) : (s = _J.exec(WD(t, e))) ? function(r, a) {
    const l = `/${r}`, d = `\\${r}`, h = function(u, g) {
      return typeof u != "string" ? null : g ? g === r ? a : null : u === r || u.endsWith(l) || u.endsWith(d) ? a : null;
    }, c = [r];
    return h.basenames = c, h.patterns = [a], h.allBasenames = c, h;
  }(s[1], t) : (e.trimForExclusions ? bJ : vJ).test(t) ? function(r, a) {
    const l = LW(r.slice(1, -1).split(",").map((g) => xI(g, a)).filter((g) => g !== za), r), d = l.length;
    if (!d) return za;
    if (d === 1) return l[0];
    const h = function(g, p) {
      for (let f = 0, _ = l.length; f < _; f++) if (l[f](g, p)) return r;
      return null;
    }, c = l.find((g) => !!g.allBasenames);
    c && (h.allBasenames = c.allBasenames);
    const u = l.reduce((g, p) => p.allPaths ? g.concat(p.allPaths) : g, []);
    return u.length && (h.allPaths = u), h;
  }(t, e) : (s = CJ.exec(WD(t, e))) ? d3(s[1].substr(1), t, !0) : (s = wJ.exec(WD(t, e))) ? d3(s[1], t, !1) : function(r) {
    try {
      const a = new RegExp(`^${yW(r)}$`);
      return function(l) {
        return a.lastIndex = 0, typeof l == "string" && a.test(l) ? r : null;
      };
    } catch {
      return za;
    }
  }(t), a3.set(n, o)), yJ(o, i);
}
function yJ(i, e) {
  if (typeof e == "string") return i;
  const t = function(n, s) {
    return uI(n, e.base, !Cs) ? i(p1(n.substr(e.base.length), oa), s) : null;
  };
  return t.allBasenames = i.allBasenames, t.allPaths = i.allPaths, t.basenames = i.basenames, t.patterns = i.patterns, t;
}
function WD(i, e) {
  return e.trimForExclusions && i.endsWith("/**") ? i.substr(0, i.length - 2) : i;
}
function d3(i, e, t) {
  const n = oa === Fi.sep, s = n ? i : i.replace(mJ, oa), o = oa + s, r = Fi.sep + i;
  let a;
  return a = t ? function(l, d) {
    return typeof l != "string" || l !== s && !l.endsWith(o) && (n || l !== i && !l.endsWith(r)) ? null : e;
  } : function(l, d) {
    return typeof l != "string" || l !== s && (n || l !== i) ? null : e;
  }, a.allPaths = [(t ? "*/" : "./") + i], a;
}
function SW(i, e = {}) {
  if (!i) return l3;
  if (typeof i == "string" || function(t) {
    const n = t;
    return n ? typeof n.base == "string" && typeof n.pattern == "string" : !1;
  }(i)) {
    const t = xI(i, e);
    if (t === za) return l3;
    const n = function(s, o) {
      return !!t(s, o);
    };
    return t.allBasenames && (n.allBasenames = t.allBasenames), t.allPaths && (n.allPaths = t.allPaths), n;
  }
  return function(t, n) {
    const s = LW(Object.getOwnPropertyNames(t).map((d) => function(h, c, u) {
      if (c === !1) return za;
      const g = xI(h, u);
      if (g === za) return za;
      if (typeof c == "boolean") return g;
      if (c) {
        const p = c.when;
        if (typeof p == "string") {
          const f = (_, v, b, C) => {
            if (!C || !g(_, v)) return null;
            const w = C(p.replace("$(basename)", () => b));
            return Fk(w) ? w.then((y) => y ? h : null) : w ? h : null;
          };
          return f.requiresSiblings = !0, f;
        }
      }
      return g;
    }(d, t[d], n)).filter((d) => d !== za)), o = s.length;
    if (!o) return za;
    if (!s.some((d) => !!d.requiresSiblings)) {
      if (o === 1) return s[0];
      const d = function(u, g) {
        let p;
        for (let f = 0, _ = s.length; f < _; f++) {
          const v = s[f](u, g);
          if (typeof v == "string") return v;
          Fk(v) && (p || (p = []), p.push(v));
        }
        return p ? (async () => {
          for (const f of p) {
            const _ = await f;
            if (typeof _ == "string") return _;
          }
          return null;
        })() : null;
      }, h = s.find((u) => !!u.allBasenames);
      h && (d.allBasenames = h.allBasenames);
      const c = s.reduce((u, g) => g.allPaths ? u.concat(g.allPaths) : u, []);
      return c.length && (d.allPaths = c), d;
    }
    const r = function(d, h, c) {
      let u, g;
      for (let p = 0, f = s.length; p < f; p++) {
        const _ = s[p];
        _.requiresSiblings && c && (h || (h = Nh(d)), u || (u = h.substr(0, h.length - _K(d).length)));
        const v = _(d, h, u, c);
        if (typeof v == "string") return v;
        Fk(v) && (g || (g = []), g.push(v));
      }
      return g ? (async () => {
        for (const p of g) {
          const f = await p;
          if (typeof f == "string") return f;
        }
        return null;
      })() : null;
    }, a = s.find((d) => !!d.allBasenames);
    a && (r.allBasenames = a.allBasenames);
    const l = s.reduce((d, h) => h.allPaths ? d.concat(h.allPaths) : d, []);
    return l.length && (r.allPaths = l), r;
  }(i, e);
}
function LW(i, e) {
  const t = i.filter((a) => !!a.basenames);
  if (t.length < 2) return i;
  const n = t.reduce((a, l) => {
    const d = l.basenames;
    return d ? a.concat(d) : a;
  }, []);
  let s;
  if (e) {
    s = [];
    for (let a = 0, l = n.length; a < l; a++) s.push(e);
  } else s = t.reduce((a, l) => {
    const d = l.patterns;
    return d ? a.concat(d) : a;
  }, []);
  const o = function(a, l) {
    if (typeof a != "string") return null;
    if (!l) {
      let h;
      for (h = a.length; h > 0; h--) {
        const c = a.charCodeAt(h - 1);
        if (c === 47 || c === 92) break;
      }
      l = a.substr(h);
    }
    const d = n.indexOf(l);
    return d !== -1 ? s[d] : null;
  };
  o.basenames = n, o.patterns = s, o.allBasenames = n;
  const r = i.filter((a) => !a.basenames);
  return r.push(o), r;
}
function gA(i, e, t, n, s, o) {
  if (Array.isArray(i)) {
    let d = 0;
    for (const h of i) {
      const c = gA(h, e, t, n, s, o);
      if (c === 10) return c;
      c > d && (d = c);
    }
    return d;
  }
  if (typeof i == "string") return n ? i === "*" ? 5 : i === t ? 10 : 0 : 0;
  if (i) {
    const { language: d, pattern: h, scheme: c, hasAccessToAllModels: u, notebookType: g } = i;
    if (!n && !u) return 0;
    g && s && (e = s);
    let p = 0;
    if (c) if (c === e.scheme) p = 10;
    else {
      if (c !== "*") return 0;
      p = 5;
    }
    if (d) if (d === t) p = 10;
    else {
      if (d !== "*") return 0;
      p = Math.max(p, 5);
    }
    if (g) if (g === o) p = 10;
    else {
      if (g !== "*" || o === void 0) return 0;
      p = Math.max(p, 5);
    }
    if (h) {
      let f;
      if (f = typeof h == "string" ? h : { ...h, base: U7(h.base) }, f !== e.fsPath && (r = f, a = e.fsPath, !r || typeof a != "string" || !SW(r)(a, void 0, l))) return 0;
      p = 10;
    }
    return p;
  }
  return 0;
  var r, a, l;
}
function kW(i) {
  return typeof i != "string" && (Array.isArray(i) ? i.every(kW) : !!i.exclusive);
}
class h3 {
  constructor(e, t, n, s) {
    this.uri = e, this.languageId = t, this.notebookUri = n, this.notebookType = s;
  }
  equals(e) {
    var t, n;
    return this.notebookType === e.notebookType && this.languageId === e.languageId && this.uri.toString() === e.uri.toString() && ((t = this.notebookUri) === null || t === void 0 ? void 0 : t.toString()) === ((n = e.notebookUri) === null || n === void 0 ? void 0 : n.toString());
  }
}
class ei {
  constructor(e) {
    this._notebookInfoResolver = e, this._clock = 0, this._entries = [], this._onDidChange = new F(), this.onDidChange = this._onDidChange.event;
  }
  register(e, t) {
    let n = { selector: e, provider: t, _score: -1, _time: this._clock++ };
    return this._entries.push(n), this._lastCandidate = void 0, this._onDidChange.fire(this._entries.length), ye(() => {
      if (n) {
        const s = this._entries.indexOf(n);
        s >= 0 && (this._entries.splice(s, 1), this._lastCandidate = void 0, this._onDidChange.fire(this._entries.length), n = void 0);
      }
    });
  }
  has(e) {
    return this.all(e).length > 0;
  }
  all(e) {
    if (!e) return [];
    this._updateScores(e);
    const t = [];
    for (const n of this._entries) n._score > 0 && t.push(n.provider);
    return t;
  }
  ordered(e) {
    const t = [];
    return this._orderedForEach(e, (n) => t.push(n.provider)), t;
  }
  orderedGroups(e) {
    const t = [];
    let n, s;
    return this._orderedForEach(e, (o) => {
      n && s === o._score ? n.push(o.provider) : (s = o._score, n = [o.provider], t.push(n));
    }), t;
  }
  _orderedForEach(e, t) {
    this._updateScores(e);
    for (const n of this._entries) n._score > 0 && t(n);
  }
  _updateScores(e) {
    var t, n;
    const s = (t = this._notebookInfoResolver) === null || t === void 0 ? void 0 : t.call(this, e.uri), o = s ? new h3(e.uri, e.getLanguageId(), s.uri, s.type) : new h3(e.uri, e.getLanguageId(), void 0, void 0);
    if (!(!((n = this._lastCandidate) === null || n === void 0) && n.equals(o))) {
      this._lastCandidate = o;
      for (const r of this._entries) if (r._score = gA(r.selector, o.uri, o.languageId, G8(e), o.notebookUri, o.notebookType), kW(r.selector) && r._score > 0) {
        for (const a of this._entries) a._score = 0;
        r._score = 1e3;
        break;
      }
      this._entries.sort(ei._compareByScoreAndTime);
    }
  }
  static _compareByScoreAndTime(e, t) {
    return e._score < t._score ? 1 : e._score > t._score ? -1 : E_(e.selector) && !E_(t.selector) ? 1 : !E_(e.selector) && E_(t.selector) ? -1 : e._time < t._time ? 1 : e._time > t._time ? -1 : 0;
  }
}
function E_(i) {
  return typeof i != "string" && (Array.isArray(i) ? i.some(E_) : !!i.isBuiltin);
}
rt(fe, class {
  constructor() {
    this.referenceProvider = new ei(this._score.bind(this)), this.renameProvider = new ei(this._score.bind(this)), this.newSymbolNamesProvider = new ei(this._score.bind(this)), this.codeActionProvider = new ei(this._score.bind(this)), this.definitionProvider = new ei(this._score.bind(this)), this.typeDefinitionProvider = new ei(this._score.bind(this)), this.declarationProvider = new ei(this._score.bind(this)), this.implementationProvider = new ei(this._score.bind(this)), this.documentSymbolProvider = new ei(this._score.bind(this)), this.inlayHintsProvider = new ei(this._score.bind(this)), this.colorProvider = new ei(this._score.bind(this)), this.codeLensProvider = new ei(this._score.bind(this)), this.documentFormattingEditProvider = new ei(this._score.bind(this)), this.documentRangeFormattingEditProvider = new ei(this._score.bind(this)), this.onTypeFormattingEditProvider = new ei(this._score.bind(this)), this.signatureHelpProvider = new ei(this._score.bind(this)), this.hoverProvider = new ei(this._score.bind(this)), this.documentHighlightProvider = new ei(this._score.bind(this)), this.multiDocumentHighlightProvider = new ei(this._score.bind(this)), this.selectionRangeProvider = new ei(this._score.bind(this)), this.foldingRangeProvider = new ei(this._score.bind(this)), this.linkProvider = new ei(this._score.bind(this)), this.inlineCompletionsProvider = new ei(this._score.bind(this)), this.inlineEditProvider = new ei(this._score.bind(this)), this.completionProvider = new ei(this._score.bind(this)), this.linkedEditingRangeProvider = new ei(this._score.bind(this)), this.documentRangeSemanticTokensProvider = new ei(this._score.bind(this)), this.documentSemanticTokensProvider = new ei(this._score.bind(this)), this.documentOnDropEditProvider = new ei(this._score.bind(this)), this.documentPasteEditProvider = new ei(this._score.bind(this));
  }
  _score(i) {
    var e;
    return (e = this._notebookTypeResolver) === null || e === void 0 ? void 0 : e.call(this, i);
  }
}, 1);
var SJ = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, c3 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const pA = tt("hoverService");
let kv = class extends V {
  get delay() {
    return this.isInstantlyHovering() ? 0 : this._delay;
  }
  constructor(i, e, t = {}, n, s) {
    super(), this.placement = i, this.instantHover = e, this.overrideOptions = t, this.configurationService = n, this.hoverService = s, this.lastHoverHideTime = 0, this.timeLimit = 200, this.hoverDisposables = this._register(new G()), this._delay = this.configurationService.getValue("workbench.hover.delay"), this._register(this.configurationService.onDidChangeConfiguration((o) => {
      o.affectsConfiguration("workbench.hover.delay") && (this._delay = this.configurationService.getValue("workbench.hover.delay"));
    }));
  }
  showHover(i, e) {
    const t = typeof this.overrideOptions == "function" ? this.overrideOptions(i, e) : this.overrideOptions;
    this.hoverDisposables.clear();
    const n = i.target instanceof HTMLElement ? [i.target] : i.target.targetElements;
    for (const o of n) this.hoverDisposables.add(bi(o, "keydown", (r) => {
      r.equals(9) && this.hoverService.hideHover();
    }));
    const s = i.content instanceof HTMLElement ? void 0 : i.content.toString();
    return this.hoverService.showHover({ ...i, ...t, persistence: { hideOnKeyDown: !0, ...t.persistence }, id: s, appearance: { ...i.appearance, compact: !0, skipFadeInAnimation: this.isInstantlyHovering(), ...t.appearance } }, e);
  }
  isInstantlyHovering() {
    return this.instantHover && Date.now() - this.lastHoverHideTime < this.timeLimit;
  }
  onDidHideHover() {
    this.hoverDisposables.clear(), this.instantHover && (this.lastHoverHideTime = Date.now());
  }
};
kv = SJ([c3(3, Ye), c3(4, pA)], kv);
const zd = tt("contextViewService"), io = tt("contextMenuService"), Mb = Q;
let mA = class extends V {
  constructor() {
    super(), this.containerDomNode = document.createElement("div"), this.containerDomNode.className = "monaco-hover", this.containerDomNode.tabIndex = 0, this.containerDomNode.setAttribute("role", "tooltip"), this.contentsDomNode = document.createElement("div"), this.contentsDomNode.className = "monaco-hover-content", this.scrollbar = this._register(new k1(this.contentsDomNode, { consumeMouseWheelIfScrollbarIsNeeded: !0 })), this.containerDomNode.appendChild(this.scrollbar.getDomNode());
  }
  onContentsChanged() {
    this.scrollbar.scanDomNode();
  }
};
class vL extends V {
  static render(e, t, n) {
    return new vL(e, t, n);
  }
  constructor(e, t, n) {
    super(), this.actionContainer = Z(e, Mb("div.action-container")), this.actionContainer.setAttribute("tabindex", "0"), this.action = Z(this.actionContainer, Mb("a.action")), this.action.setAttribute("role", "button"), t.iconClass && Z(this.action, Mb(`span.icon.${t.iconClass}`)), Z(this.action, Mb("span")).textContent = n ? `${t.label} (${n})` : t.label, this._register(K(this.actionContainer, ie.CLICK, (s) => {
      s.stopPropagation(), s.preventDefault(), t.run(this.actionContainer);
    })), this._register(K(this.actionContainer, ie.KEY_DOWN, (s) => {
      const o = new jt(s);
      (o.equals(3) || o.equals(10)) && (s.stopPropagation(), s.preventDefault(), t.run(this.actionContainer));
    })), this.setEnabled(!0);
  }
  setEnabled(e) {
    e ? (this.actionContainer.classList.remove("disabled"), this.actionContainer.removeAttribute("aria-disabled")) : (this.actionContainer.classList.add("disabled"), this.actionContainer.setAttribute("aria-disabled", "true"));
  }
}
function DW(i, e) {
  return i && e ? m(0, "Inspect this in the accessible view with {0}.", e) : i ? m(0, "Inspect this in the accessible view via the command Open Accessible View which is currently not triggerable via keybinding.") : "";
}
const Fs = tt("openerService");
function LJ(i, e = {}) {
  const t = fA(e);
  return xW(t, function(n, s) {
    const o = { type: 1, children: [] };
    let r = 0, a = o;
    const l = [], d = new kJ(n);
    for (; !d.eos(); ) {
      let h = d.next();
      const c = h === "\\" && NI(d.peek(), s) !== 0;
      if (c && (h = d.next()), !c && DJ(h, s) && h === d.peek()) {
        d.advance(), a.type === 2 && (a = l.pop());
        const u = NI(h, s);
        if (a.type === u || a.type === 5 && u === 6) a = l.pop();
        else {
          const g = { type: u, children: [] };
          u === 5 && (g.index = r, r++), a.children.push(g), l.push(a), a = g;
        }
      } else if (h === `
`) a.type === 2 && (a = l.pop()), a.children.push({ type: 8 });
      else if (a.type !== 2) {
        const u = { type: 2, content: h };
        a.children.push(u), l.push(a), a = u;
      } else a.content += h;
    }
    return a.type === 2 && (a = l.pop()), o;
  }(i, !!e.renderCodeSegments), e.actionHandler, e.renderCodeSegments), t;
}
function fA(i) {
  const e = i.inline ? "span" : "div", t = document.createElement(e);
  return i.className && (t.className = i.className), t;
}
class kJ {
  constructor(e) {
    this.source = e, this.index = 0;
  }
  eos() {
    return this.index >= this.source.length;
  }
  next() {
    const e = this.peek();
    return this.advance(), e;
  }
  peek() {
    return this.source[this.index];
  }
  advance() {
    this.index++;
  }
}
function xW(i, e, t, n) {
  let s;
  if (e.type === 2) s = document.createTextNode(e.content || "");
  else if (e.type === 3) s = document.createElement("b");
  else if (e.type === 4) s = document.createElement("i");
  else if (e.type === 7 && n) s = document.createElement("code");
  else if (e.type === 5 && t) {
    const o = document.createElement("a");
    t.disposables.add(bi(o, "click", (r) => {
      t.callback(String(e.index), r);
    })), s = o;
  } else e.type === 8 ? s = document.createElement("br") : e.type === 1 && (s = i);
  s && i !== s && i.appendChild(s), s && Array.isArray(e.children) && e.children.forEach((o) => {
    xW(s, o, t, n);
  });
}
function DJ(i, e) {
  return NI(i, e) !== 0;
}
function NI(i, e) {
  switch (i) {
    case "*":
      return 3;
    case "_":
      return 4;
    case "[":
      return 5;
    case "]":
      return 6;
    case "`":
      return e ? 7 : 0;
    default:
      return 0;
  }
}
const xJ = new RegExp(`(\\\\)?\\$\\((${Ee.iconNameExpression}(?:${Ee.iconModifierExpression})?)\\)`, "g");
function ic(i) {
  const e = new Array();
  let t, n = 0, s = 0;
  for (; (t = xJ.exec(i)) !== null; ) {
    s = t.index || 0, n < s && e.push(i.substring(n, s)), n = (t.index || 0) + t[0].length;
    const [, o, r] = t;
    e.push(o ? `$(${r})` : Dv({ id: r }));
  }
  return n < i.length && e.push(i.substring(n)), e;
}
function Dv(i) {
  const e = Q("span");
  return e.classList.add(...Ee.asClassNameArray(i)), e;
}
function NJ(i) {
  const e = function(t) {
    if (ao = 0, xa(t, VD, 4352), ao > 0 || (xa(t, HD, 4449), ao > 0) || (xa(t, zD, 4520), ao > 0) || (xa(t, qc, 12593), ao)) return yh.subarray(0, ao);
    if (t >= 44032 && t <= 55203) {
      const n = t - 44032, s = n % 588, o = Math.floor(n / 588), r = Math.floor(s / 28), a = s % 28 - 1;
      if (o < VD.length ? xa(o, VD, 0) : 4352 + o - 12593 < qc.length && xa(4352 + o, qc, 12593), r < HD.length ? xa(r, HD, 0) : 4449 + r - 12593 < qc.length && xa(4449 + r - 12593, qc, 12593), a >= 0 && (a < zD.length ? xa(a, zD, 0) : 4520 + a - 12593 < qc.length && xa(4520 + a - 12593, qc, 12593)), ao > 0) return yh.subarray(0, ao);
    }
  }(i);
  if (e && e.length > 0) return new Uint32Array(e);
}
let ao = 0;
const yh = new Uint32Array(10);
function xa(i, e, t) {
  i >= t && i < t + e.length && function(n) {
    n !== 0 && (yh[ao++] = 255 & n, n >> 8 && (yh[ao++] = n >> 8 & 255), n >> 16 && (yh[ao++] = n >> 16 & 255));
  }(e[i - t]);
}
const VD = new Uint8Array([114, 82, 115, 101, 69, 102, 97, 113, 81, 116, 84, 100, 119, 87, 99, 122, 120, 118, 103]), HD = new Uint16Array([107, 111, 105, 79, 106, 112, 117, 80, 104, 27496, 28520, 27752, 121, 110, 27246, 28782, 27758, 98, 109, 27757, 108]), zD = new Uint16Array([114, 82, 29810, 115, 30579, 26483, 101, 102, 29286, 24934, 29030, 29798, 30822, 30310, 26470, 97, 113, 29809, 116, 84, 100, 119, 99, 122, 120, 118, 103]), qc = new Uint16Array([114, 82, 29810, 115, 30579, 26483, 101, 69, 102, 29286, 24934, 29030, 29798, 30822, 30310, 26470, 97, 113, 81, 29809, 116, 84, 100, 119, 87, 99, 122, 120, 118, 103, 107, 111, 105, 79, 106, 112, 117, 80, 104, 27496, 28520, 27752, 121, 110, 27246, 28782, 27758, 98, 109, 27757, 108]);
function _A(...i) {
  return function(e, t) {
    for (let n = 0, s = i.length; n < s; n++) {
      const o = i[n](e, t);
      if (o) return o;
    }
    return null;
  };
}
NW.bind(void 0, !1);
const xv = NW.bind(void 0, !0);
function NW(i, e, t) {
  if (!t || t.length < e.length) return null;
  let n;
  return n = i ? oR(t, e) : t.indexOf(e) === 0, n ? e.length > 0 ? [{ start: 0, end: e.length }] : [] : null;
}
function EW(i, e) {
  const t = e.toLowerCase().indexOf(i.toLowerCase());
  return t === -1 ? null : [{ start: t, end: t + i.length }];
}
function IW(i, e) {
  return EI(i.toLowerCase(), e.toLowerCase(), 0, 0);
}
function EI(i, e, t, n) {
  if (t === i.length) return [];
  if (n === e.length) return null;
  if (i[t] === e[n]) {
    let s = null;
    return (s = EI(i, e, t + 1, n + 1)) ? bA({ start: n, end: n + 1 }, s) : null;
  }
  return EI(i, e, t, n + 1);
}
function II(i) {
  return 97 <= i && i <= 122;
}
function xy(i) {
  return 65 <= i && i <= 90;
}
function vA(i) {
  return 48 <= i && i <= 57;
}
function MW(i) {
  return i === 32 || i === 9 || i === 10 || i === 13;
}
const TW = /* @__PURE__ */ new Set();
function Ny(i) {
  return MW(i) || TW.has(i);
}
function u3(i, e) {
  return i === e || Ny(i) && Ny(e);
}
"()[]{}<>`'\"-/;:,.?!".split("").forEach((i) => TW.add(i.charCodeAt(0)));
const UD = /* @__PURE__ */ new Map();
function g3(i) {
  if (UD.has(i)) return UD.get(i);
  let e;
  const t = NJ(i);
  return t && (e = t), UD.set(i, e), e;
}
function RW(i) {
  return II(i) || xy(i) || vA(i);
}
function bA(i, e) {
  return e.length === 0 ? e = [i] : i.end === e[0].start ? e[0].start = i.start : e.unshift(i), e;
}
function AW(i, e) {
  for (let t = e; t < i.length; t++) {
    const n = i.charCodeAt(t);
    if (xy(n) || vA(n) || t > 0 && !RW(i.charCodeAt(t - 1))) return t;
  }
  return i.length;
}
function MI(i, e, t, n) {
  if (t === i.length) return [];
  if (n === e.length || i[t] !== e[n].toLowerCase()) return null;
  {
    let s = null, o = n + 1;
    for (s = MI(i, e, t + 1, n + 1); !s && (o = AW(e, o)) < e.length; ) s = MI(i, e, t + 1, o), o++;
    return s === null ? null : bA({ start: n, end: n + 1 }, s);
  }
}
function PW(i, e) {
  if (!e || (e = e.trim()).length === 0 || !function(o) {
    let r = 0, a = 0, l = 0, d = 0;
    for (let h = 0; h < o.length; h++) l = o.charCodeAt(h), xy(l) && r++, II(l) && a++, MW(l) && d++;
    return r !== 0 && a !== 0 || d !== 0 ? r <= 5 : o.length <= 30;
  }(i)) return null;
  e.length > 60 && (e = e.substring(0, 60));
  const t = function(o) {
    let r = 0, a = 0, l = 0, d = 0, h = 0;
    for (let c = 0; c < o.length; c++) h = o.charCodeAt(c), xy(h) && r++, II(h) && a++, RW(h) && l++, vA(h) && d++;
    return { upperPercent: r / o.length, lowerPercent: a / o.length, alphaPercent: l / o.length, numericPercent: d / o.length };
  }(e);
  if (!function(o) {
    const { upperPercent: r, lowerPercent: a, alphaPercent: l, numericPercent: d } = o;
    return a > 0.2 && r < 0.8 && l > 0.6 && d < 0.2;
  }(t)) {
    if (!function(o) {
      const { upperPercent: r, lowerPercent: a } = o;
      return a === 0 && r > 0.6;
    }(t)) return null;
    e = e.toLowerCase();
  }
  let n = null, s = 0;
  for (i = i.toLowerCase(); s < e.length && (n = MI(i, e, 0, s)) === null; ) s = AW(e, s + 1);
  return n;
}
function TI(i, e, t, n, s) {
  let o = 0;
  if (t === i.length) return [];
  if (n === e.length) return null;
  if (!u3(i.charCodeAt(t), e.charCodeAt(n))) {
    const l = g3(i.charCodeAt(t));
    if (!l) return null;
    for (let d = 0; d < l.length; d++) if (!u3(l[d], e.charCodeAt(n + d))) return null;
    o += l.length - 1;
  }
  let r = null, a = n + o + 1;
  if (r = TI(i, e, t + 1, a, s), !s) for (; !r && (a = OW(e, a)) < e.length; ) r = TI(i, e, t + 1, a, s), a++;
  if (!r) return null;
  if (i.charCodeAt(t) !== e.charCodeAt(n)) {
    const l = g3(i.charCodeAt(t));
    if (!l) return r;
    for (let d = 0; d < l.length; d++) if (l[d] !== e.charCodeAt(n + d)) return r;
  }
  return bA({ start: n, end: n + o + 1 }, r);
}
function OW(i, e) {
  for (let t = e; t < i.length; t++) if (Ny(i.charCodeAt(t)) || t > 0 && Ny(i.charCodeAt(t - 1))) return t;
  return i.length;
}
const EJ = _A(xv, PW, EW), IJ = _A(xv, PW, IW), p3 = new Ll(1e4);
function m3(i, e, t = !1) {
  if (typeof i != "string" || typeof e != "string") return null;
  let n = p3.get(i);
  n || (n = new RegExp(i.replace(/[\-\\\{\}\+\?\|\^\$\.\,\[\]\(\)\#\s]/g, "\\$&").replace(/[\*]/g, ".*"), "i"), p3.set(i, n));
  const s = n.exec(e);
  return s ? [{ start: s.index, end: s.index + s[0].length }] : t ? IJ(i, e) : EJ(i, e);
}
function MJ(i, e) {
  const t = pg(i, i.toLowerCase(), 0, e, e.toLowerCase(), 0, { firstMatchCanBeWeak: !0, boostFullMatch: !0 });
  return t ? T1(t) : null;
}
function TJ(i, e, t, n, s, o) {
  const r = Math.min(13, i.length);
  for (; t < r; t++) {
    const a = pg(i, e, t, n, s, o, { firstMatchCanBeWeak: !0, boostFullMatch: !0 });
    if (a) return a;
  }
  return [0, o];
}
function T1(i) {
  if (i === void 0) return [];
  const e = [], t = i[1];
  for (let n = i.length - 1; n > 1; n--) {
    const s = i[n] + t, o = e[e.length - 1];
    o && o.end === s ? o.end = s + 1 : e.push({ start: s, end: s + 1 });
  }
  return e;
}
const Wh = 128;
function CA() {
  const i = [], e = [];
  for (let t = 0; t <= Wh; t++) e[t] = 0;
  for (let t = 0; t <= Wh; t++) i.push(e.slice(0));
  return i;
}
function FW(i) {
  const e = [];
  for (let t = 0; t <= i; t++) e[t] = 0;
  return e;
}
const f3 = FW(2 * Wh), KD = FW(2 * Wh), El = CA(), $c = CA(), Tb = CA();
function Rb(i, e) {
  if (e < 0 || e >= i.length) return !1;
  const t = i.codePointAt(e);
  switch (t) {
    case 95:
    case 45:
    case 46:
    case 32:
    case 47:
    case 92:
    case 39:
    case 34:
    case 58:
    case 36:
    case 60:
    case 62:
    case 40:
    case 41:
    case 91:
    case 93:
    case 123:
    case 125:
      return !0;
    case void 0:
      return !1;
    default:
      return !!lR(t);
  }
}
function _3(i, e) {
  if (e < 0 || e >= i.length) return !1;
  switch (i.charCodeAt(e)) {
    case 32:
    case 9:
      return !0;
    default:
      return !1;
  }
}
function GC(i, e, t) {
  return e[i] !== t[i];
}
var da;
(function(i) {
  i.Default = [-100, 0], i.isDefault = function(e) {
    return !e || e.length === 2 && e[0] === -100 && e[1] === 0;
  };
})(da || (da = {}));
class bL {
  constructor(e, t) {
    this.firstMatchCanBeWeak = e, this.boostFullMatch = t;
  }
}
function pg(i, e, t, n, s, o, r = bL.default) {
  const a = i.length > Wh ? Wh : i.length, l = n.length > Wh ? Wh : n.length;
  if (t >= a || o >= l || a - t > l - o || !function(b, C, w, y, L, k, N = !1) {
    for (; C < w && L < k; ) b[C] === y[L] && (N && (f3[C] = L), C += 1), L += 1;
    return C === w;
  }(e, t, a, s, o, l, !0)) return;
  (function(b, C, w, y, L, k) {
    let N = b - 1, A = C - 1;
    for (; N >= w && A >= y; ) L[N] === k[A] && (KD[N] = A, N--), A--;
  })(a, l, t, o, e, s);
  let d = 1, h = 1, c = t, u = o;
  const g = [!1];
  for (d = 1, c = t; c < a; d++, c++) {
    const b = f3[c], C = KD[c], w = c + 1 < a ? KD[c + 1] : l;
    for (h = b - o + 1, u = b; u < w; h++, u++) {
      let y = Number.MIN_SAFE_INTEGER, L = !1;
      u <= C && (y = RJ(i, e, c, t, n, s, u, l, o, El[d - 1][h - 1] === 0, g));
      let k = 0;
      y !== Number.MAX_SAFE_INTEGER && (L = !0, k = y + $c[d - 1][h - 1]);
      const N = u > b, A = N ? $c[d][h - 1] + (El[d][h - 1] > 0 ? -5 : 0) : 0, B = u > b + 1 && El[d][h - 1] > 0, T = B ? $c[d][h - 2] + (El[d][h - 2] > 0 ? -5 : 0) : 0;
      if (B && (!N || T >= A) && (!L || T >= k)) $c[d][h] = T, Tb[d][h] = 3, El[d][h] = 0;
      else if (N && (!L || A >= k)) $c[d][h] = A, Tb[d][h] = 2, El[d][h] = 0;
      else {
        if (!L) throw new Error("not possible");
        $c[d][h] = k, Tb[d][h] = 1, El[d][h] = El[d - 1][h - 1] + 1;
      }
    }
  }
  if (!g[0] && !r.firstMatchCanBeWeak) return;
  d--, h--;
  const p = [$c[d][h], o];
  let f = 0, _ = 0;
  for (; d >= 1; ) {
    let b = h;
    do {
      const C = Tb[d][b];
      if (C === 3) b -= 2;
      else {
        if (C !== 2) break;
        b -= 1;
      }
    } while (b >= 1);
    f > 1 && e[t + d - 1] === s[o + h - 1] && !GC(b + o - 1, n, s) && f + 1 > El[d][b] && (b = h), b === h ? f++ : f = 1, _ || (_ = b), d--, h = b - 1, p.push(h);
  }
  l === a && r.boostFullMatch && (p[0] += 2);
  const v = _ - a;
  return p[0] -= v, p;
}
function RJ(i, e, t, n, s, o, r, a, l, d, h) {
  if (e[t] !== o[r]) return Number.MIN_SAFE_INTEGER;
  let c = 1, u = !1;
  return r === t - n ? c = i[t] === s[r] ? 7 : 5 : !GC(r, s, o) || r !== 0 && GC(r - 1, s, o) ? !Rb(o, r) || r !== 0 && Rb(o, r - 1) ? (Rb(o, r - 1) || _3(o, r - 1)) && (c = 5, u = !0) : c = 5 : (c = i[t] === s[r] ? 7 : 5, u = !0), c > 1 && t === n && (h[0] = !0), u || (u = GC(r, s, o) || Rb(o, r - 1) || _3(o, r - 1)), t === n ? r > l && (c -= u ? 3 : 5) : c += d ? u ? 2 : 0 : u ? 0 : 1, r + 1 === a && (c -= u ? 3 : 5), c;
}
function AJ(i, e, t, n, s, o, r) {
  return function(a, l, d, h, c, u, g, p) {
    let f = pg(a, l, d, h, c, u, p);
    if (f && !g) return f;
    if (a.length >= 3) {
      const _ = Math.min(7, a.length - 1);
      for (let v = d + 1; v < _; v++) {
        const b = PJ(a, v);
        if (b) {
          const C = pg(b, b.toLowerCase(), d, h, c, u, p);
          C && (C[0] -= 3, (!f || C[0] > f[0]) && (f = C));
        }
      }
    }
    return f;
  }(i, e, t, n, s, o, !0, r);
}
function PJ(i, e) {
  if (e + 1 >= i.length) return;
  const t = i[e], n = i[e + 1];
  return t !== n ? i.slice(0, e) + n + t + i.slice(e + 2) : void 0;
}
bL.default = { boostFullMatch: !0, firstMatchCanBeWeak: !1 };
const OJ = "$(", wA = new RegExp(`\\$\\(${Ee.iconNameExpression}(?:${Ee.iconModifierExpression})?\\)`, "g"), FJ = new RegExp(`(\\\\)?${wA.source}`, "g"), BJ = new RegExp(`\\\\${wA.source}`, "g"), WJ = new RegExp(`(\\s)?(\\\\)?${wA.source}(\\s)?`, "g");
function yA(i) {
  return i.indexOf(OJ) === -1 ? i : i.replace(WJ, (e, t, n, s) => n ? e : t || s || "");
}
const jD = new RegExp(`\\$\\(${Ee.iconNameCharacter}+\\)`, "g");
function I_(i) {
  jD.lastIndex = 0;
  let e = "";
  const t = [];
  let n = 0;
  for (; ; ) {
    const s = jD.lastIndex, o = jD.exec(i), r = i.substring(s, o == null ? void 0 : o.index);
    if (r.length > 0) {
      e += r;
      for (let a = 0; a < r.length; a++) t.push(n);
    }
    if (!o) break;
    n += o[0].length;
  }
  return { text: e, iconOffsets: t };
}
function qD(i, e, t = !1) {
  const { text: n, iconOffsets: s } = e;
  if (!s || s.length === 0) return m3(i, n, t);
  const o = p1(n, " "), r = n.length - o.length, a = m3(i, o, t);
  if (a) for (const l of a) {
    const d = s[l.start + r] + r;
    l.start += d, l.end += d;
  }
  return a;
}
class Vn {
  constructor(e = "", t = !1) {
    var n, s, o;
    if (this.value = e, typeof this.value != "string") throw Yo("value");
    typeof t == "boolean" ? (this.isTrusted = t, this.supportThemeIcons = !1, this.supportHtml = !1) : (this.isTrusted = (n = t.isTrusted) !== null && n !== void 0 ? n : void 0, this.supportThemeIcons = (s = t.supportThemeIcons) !== null && s !== void 0 && s, this.supportHtml = (o = t.supportHtml) !== null && o !== void 0 && o);
  }
  appendText(e, t = 0) {
    return this.value += function(n) {
      return n.replace(/[\\`*_{}[\]()#+\-!~]/g, "\\$&");
    }(this.supportThemeIcons ? function(n) {
      return n.replace(FJ, (s, o) => o ? s : `\\${s}`);
    }(e) : e).replace(/([ \t]+)/g, (n, s) => "&nbsp;".repeat(s.length)).replace(/\>/gm, "\\>").replace(/\n/g, t === 1 ? `\\
` : `

`), this;
  }
  appendMarkdown(e) {
    return this.value += e, this;
  }
  appendCodeblock(e, t) {
    return this.value += `
${function(n, s) {
      var o, r;
      const a = (r = (o = n.match(/^`+/gm)) === null || o === void 0 ? void 0 : o.reduce((d, h) => d.length > h.length ? d : h).length) !== null && r !== void 0 ? r : 0, l = a >= 3 ? a + 1 : 3;
      return [`${"`".repeat(l)}${s}`, n, `${"`".repeat(l)}`].join(`
`);
    }(t, e)}
`, this;
  }
  appendLink(e, t, n) {
    return this.value += "[", this.value += this._escape(t, "]"), this.value += "](", this.value += this._escape(String(e), ")"), n && (this.value += ` "${this._escape(this._escape(n, '"'), ")")}"`), this.value += ")", this;
  }
  _escape(e, t) {
    const n = new RegExp(No(t), "g");
    return e.replace(n, (s, o) => e.charAt(o - 1) !== "\\" ? `\\${s}` : s);
  }
}
function $m(i) {
  return ha(i) ? !i.value : !Array.isArray(i) || i.every($m);
}
function ha(i) {
  return i instanceof Vn || !(!i || typeof i != "object") && !(typeof i.value != "string" || typeof i.isTrusted != "boolean" && typeof i.isTrusted != "object" && i.isTrusted !== void 0 || typeof i.supportThemeIcons != "boolean" && i.supportThemeIcons !== void 0);
}
function Ab(i) {
  return i.replace(/"/g, "&quot;");
}
function $D(i) {
  return i && i.replace(/\\([\\`*_{}[\]()#+\-.!~])/g, "$1");
}
class SA {
  constructor(e) {
    this._prefix = e, this._lastId = 0;
  }
  nextId() {
    return this._prefix + ++this._lastId;
  }
}
const RI = new SA("id#");
let rs = {};
(function() {
  function i(n, s) {
    s(rs);
  }
  var e, t;
  i.amd = !0, e = this, t = function(n) {
    function s(le, Y, M) {
      return M && function(R, P) {
        for (var U = 0; U < P.length; U++) {
          var ce = P[U];
          ce.enumerable = ce.enumerable || !1, ce.configurable = !0, "value" in ce && (ce.writable = !0), Object.defineProperty(R, ce.key, ce);
        }
      }(le, M), Object.defineProperty(le, "prototype", { writable: !1 }), le;
    }
    function o(le, Y) {
      (Y == null || Y > le.length) && (Y = le.length);
      for (var M = 0, R = new Array(Y); M < Y; M++) R[M] = le[M];
      return R;
    }
    function r(le, Y) {
      var M = typeof Symbol < "u" && le[Symbol.iterator] || le["@@iterator"];
      if (M) return (M = M.call(le)).next.bind(M);
      if (Array.isArray(le) || (M = function(P, U) {
        if (P) {
          if (typeof P == "string") return o(P, U);
          var ce = Object.prototype.toString.call(P).slice(8, -1);
          return ce === "Object" && P.constructor && (ce = P.constructor.name), ce === "Map" || ce === "Set" ? Array.from(P) : ce === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ce) ? o(P, U) : void 0;
        }
      }(le)) || Y) {
        M && (le = M);
        var R = 0;
        return function() {
          return R >= le.length ? { done: !0 } : { done: !1, value: le[R++] };
        };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function a() {
      return { async: !1, baseUrl: null, breaks: !1, extensions: null, gfm: !0, headerIds: !0, headerPrefix: "", highlight: null, langPrefix: "language-", mangle: !0, pedantic: !1, renderer: null, sanitize: !1, sanitizer: null, silent: !1, smartLists: !1, smartypants: !1, tokenizer: null, walkTokens: null, xhtml: !1 };
    }
    n.defaults = { async: !1, baseUrl: null, breaks: !1, extensions: null, gfm: !0, headerIds: !0, headerPrefix: "", highlight: null, langPrefix: "language-", mangle: !0, pedantic: !1, renderer: null, sanitize: !1, sanitizer: null, silent: !1, smartLists: !1, smartypants: !1, tokenizer: null, walkTokens: null, xhtml: !1 };
    var l = /[&<>"']/, d = /[&<>"']/g, h = /[<>"']|&(?!#?\w+;)/, c = /[<>"']|&(?!#?\w+;)/g, u = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }, g = function(le) {
      return u[le];
    };
    function p(le, Y) {
      if (Y) {
        if (l.test(le)) return le.replace(d, g);
      } else if (h.test(le)) return le.replace(c, g);
      return le;
    }
    var f = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/gi;
    function _(le) {
      return le.replace(f, function(Y, M) {
        return (M = M.toLowerCase()) === "colon" ? ":" : M.charAt(0) === "#" ? M.charAt(1) === "x" ? String.fromCharCode(parseInt(M.substring(2), 16)) : String.fromCharCode(+M.substring(1)) : "";
      });
    }
    var v = /(^|[^\[])\^/g;
    function b(le, Y) {
      le = typeof le == "string" ? le : le.source, Y = Y || "";
      var M = { replace: function(R, P) {
        return P = (P = P.source || P).replace(v, "$1"), le = le.replace(R, P), M;
      }, getRegex: function() {
        return new RegExp(le, Y);
      } };
      return M;
    }
    var C = /[^\w:]/g, w = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
    function y(le, Y, M) {
      if (le) {
        var R;
        try {
          R = decodeURIComponent(_(M)).replace(C, "").toLowerCase();
        } catch {
          return null;
        }
        if (R.indexOf("javascript:") === 0 || R.indexOf("vbscript:") === 0 || R.indexOf("data:") === 0) return null;
      }
      Y && !w.test(M) && (M = function(P, U) {
        L[" " + P] || (k.test(P) ? L[" " + P] = P + "/" : L[" " + P] = H(P, "/", !0));
        var ce = (P = L[" " + P]).indexOf(":") === -1;
        return U.substring(0, 2) === "//" ? ce ? U : P.replace(N, "$1") + U : U.charAt(0) === "/" ? ce ? U : P.replace(A, "$1") + U : P + U;
      }(Y, M));
      try {
        M = encodeURI(M).replace(/%25/g, "%");
      } catch {
        return null;
      }
      return M;
    }
    var L = {}, k = /^[^:]+:\/*[^/]*$/, N = /^([^:]+:)[\s\S]*$/, A = /^([^:]+:\/*[^/]*)[\s\S]*$/, B = { exec: function() {
    } };
    function T(le) {
      for (var Y, M, R = 1; R < arguments.length; R++) for (M in Y = arguments[R]) Object.prototype.hasOwnProperty.call(Y, M) && (le[M] = Y[M]);
      return le;
    }
    function O(le, Y) {
      var M = le.replace(/\|/g, function(P, U, ce) {
        for (var Ae = !1, ge = U; --ge >= 0 && ce[ge] === "\\"; ) Ae = !Ae;
        return Ae ? "|" : " |";
      }).split(/ \|/), R = 0;
      if (M[0].trim() || M.shift(), M.length > 0 && !M[M.length - 1].trim() && M.pop(), M.length > Y) M.splice(Y);
      else for (; M.length < Y; ) M.push("");
      for (; R < M.length; R++) M[R] = M[R].trim().replace(/\\\|/g, "|");
      return M;
    }
    function H(le, Y, M) {
      var R = le.length;
      if (R === 0) return "";
      for (var P = 0; P < R; ) {
        var U = le.charAt(R - P - 1);
        if (U !== Y || M) {
          if (U === Y || !M) break;
          P++;
        } else P++;
      }
      return le.slice(0, R - P);
    }
    function $(le) {
      le && le.sanitize && !le.silent && console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options");
    }
    function pe(le, Y) {
      if (Y < 1) return "";
      for (var M = ""; Y > 1; ) 1 & Y && (M += le), Y >>= 1, le += le;
      return M + le;
    }
    function me(le, Y, M, R) {
      var P = Y.href, U = Y.title ? p(Y.title) : null, ce = le[1].replace(/\\([\[\]])/g, "$1");
      if (le[0].charAt(0) !== "!") {
        R.state.inLink = !0;
        var Ae = { type: "link", raw: M, href: P, title: U, text: ce, tokens: R.inlineTokens(ce) };
        return R.state.inLink = !1, Ae;
      }
      return { type: "image", raw: M, href: P, title: U, text: p(ce) };
    }
    var ue = function() {
      function le(M) {
        this.options = M || n.defaults;
      }
      var Y = le.prototype;
      return Y.space = function(M) {
        var R = this.rules.block.newline.exec(M);
        if (R && R[0].length > 0) return { type: "space", raw: R[0] };
      }, Y.code = function(M) {
        var R = this.rules.block.code.exec(M);
        if (R) {
          var P = R[0].replace(/^ {1,4}/gm, "");
          return { type: "code", raw: R[0], codeBlockStyle: "indented", text: this.options.pedantic ? P : H(P, `
`) };
        }
      }, Y.fences = function(M) {
        var R = this.rules.block.fences.exec(M);
        if (R) {
          var P = R[0], U = function(ce, Ae) {
            var ge = ce.match(/^(\s+)(?:```)/);
            if (ge === null) return Ae;
            var Ne = ge[1];
            return Ae.split(`
`).map(function(Xe) {
              var Oe = Xe.match(/^\s+/);
              return Oe === null ? Xe : Oe[0].length >= Ne.length ? Xe.slice(Ne.length) : Xe;
            }).join(`
`);
          }(P, R[3] || "");
          return { type: "code", raw: P, lang: R[2] ? R[2].trim() : R[2], text: U };
        }
      }, Y.heading = function(M) {
        var R = this.rules.block.heading.exec(M);
        if (R) {
          var P = R[2].trim();
          if (/#$/.test(P)) {
            var U = H(P, "#");
            this.options.pedantic ? P = U.trim() : U && !/ $/.test(U) || (P = U.trim());
          }
          return { type: "heading", raw: R[0], depth: R[1].length, text: P, tokens: this.lexer.inline(P) };
        }
      }, Y.hr = function(M) {
        var R = this.rules.block.hr.exec(M);
        if (R) return { type: "hr", raw: R[0] };
      }, Y.blockquote = function(M) {
        var R = this.rules.block.blockquote.exec(M);
        if (R) {
          var P = R[0].replace(/^ *>[ \t]?/gm, "");
          return { type: "blockquote", raw: R[0], tokens: this.lexer.blockTokens(P, []), text: P };
        }
      }, Y.list = function(M) {
        var R = this.rules.block.list.exec(M);
        if (R) {
          var P, U, ce, Ae, ge, Ne, Xe, Oe, _t, Ke, Lt, Mt, si = R[1].trim(), Vs = si.length > 1, At = { type: "list", raw: "", ordered: Vs, start: Vs ? +si.slice(0, -1) : "", loose: !1, items: [] };
          si = Vs ? "\\d{1,9}\\" + si.slice(-1) : "\\" + si, this.options.pedantic && (si = Vs ? si : "[*+-]");
          for (var Vc = new RegExp("^( {0,3}" + si + ")((?:[	 ][^\\n]*)?(?:\\n|$))"); M && (Mt = !1, R = Vc.exec(M)) && !this.rules.block.hr.test(M); ) {
            if (P = R[0], M = M.substring(P.length), Oe = R[2].split(`
`, 1)[0], _t = M.split(`
`, 1)[0], this.options.pedantic ? (Ae = 2, Lt = Oe.trimLeft()) : (Ae = (Ae = R[2].search(/[^ ]/)) > 4 ? 1 : Ae, Lt = Oe.slice(Ae), Ae += R[1].length), Ne = !1, !Oe && /^ *$/.test(_t) && (P += _t + `
`, M = M.substring(_t.length + 1), Mt = !0), !Mt) for (var Mr = new RegExp("^ {0," + Math.min(3, Ae - 1) + "}(?:[*+-]|\\d{1,9}[.)])((?: [^\\n]*)?(?:\\n|$))"), Dl = new RegExp("^ {0," + Math.min(3, Ae - 1) + "}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)"), Qi = new RegExp("^ {0," + Math.min(3, Ae - 1) + "}(?:```|~~~)"), Sn = new RegExp("^ {0," + Math.min(3, Ae - 1) + "}#"); M && (Oe = Ke = M.split(`
`, 1)[0], this.options.pedantic && (Oe = Oe.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ")), !Qi.test(Oe)) && !Sn.test(Oe) && !Mr.test(Oe) && !Dl.test(M); ) {
              if (Oe.search(/[^ ]/) >= Ae || !Oe.trim()) Lt += `
` + Oe.slice(Ae);
              else {
                if (Ne) break;
                Lt += `
` + Oe;
              }
              Ne || Oe.trim() || (Ne = !0), P += Ke + `
`, M = M.substring(Ke.length + 1);
            }
            At.loose || (Xe ? At.loose = !0 : /\n *\n *$/.test(P) && (Xe = !0)), this.options.gfm && (U = /^\[[ xX]\] /.exec(Lt)) && (ce = U[0] !== "[ ] ", Lt = Lt.replace(/^\[[ xX]\] +/, "")), At.items.push({ type: "list_item", raw: P, task: !!U, checked: ce, loose: !1, text: Lt }), At.raw += P;
          }
          At.items[At.items.length - 1].raw = P.trimRight(), At.items[At.items.length - 1].text = Lt.trimRight(), At.raw = At.raw.trimRight();
          var Og = At.items.length;
          for (ge = 0; ge < Og; ge++) {
            this.lexer.state.top = !1, At.items[ge].tokens = this.lexer.blockTokens(At.items[ge].text, []);
            var qd = At.items[ge].tokens.filter(function(Fg) {
              return Fg.type === "space";
            }), xf = qd.every(function(Fg) {
              for (var Nf, j1 = 0, Bg = r(Fg.raw.split("")); !(Nf = Bg()).done; ) if (Nf.value === `
` && (j1 += 1), j1 > 1) return !0;
              return !1;
            });
            !At.loose && qd.length && xf && (At.loose = !0, At.items[ge].loose = !0);
          }
          return At;
        }
      }, Y.html = function(M) {
        var R = this.rules.block.html.exec(M);
        if (R) {
          var P = { type: "html", raw: R[0], pre: !this.options.sanitizer && (R[1] === "pre" || R[1] === "script" || R[1] === "style"), text: R[0] };
          if (this.options.sanitize) {
            var U = this.options.sanitizer ? this.options.sanitizer(R[0]) : p(R[0]);
            P.type = "paragraph", P.text = U, P.tokens = this.lexer.inline(U);
          }
          return P;
        }
      }, Y.def = function(M) {
        var R = this.rules.block.def.exec(M);
        if (R) return R[3] && (R[3] = R[3].substring(1, R[3].length - 1)), { type: "def", tag: R[1].toLowerCase().replace(/\s+/g, " "), raw: R[0], href: R[2], title: R[3] };
      }, Y.table = function(M) {
        var R = this.rules.block.table.exec(M);
        if (R) {
          var P = { type: "table", header: O(R[1]).map(function(Xe) {
            return { text: Xe };
          }), align: R[2].replace(/^ *|\| *$/g, "").split(/ *\| */), rows: R[3] && R[3].trim() ? R[3].replace(/\n[ \t]*$/, "").split(`
`) : [] };
          if (P.header.length === P.align.length) {
            P.raw = R[0];
            var U, ce, Ae, ge, Ne = P.align.length;
            for (U = 0; U < Ne; U++) /^ *-+: *$/.test(P.align[U]) ? P.align[U] = "right" : /^ *:-+: *$/.test(P.align[U]) ? P.align[U] = "center" : /^ *:-+ *$/.test(P.align[U]) ? P.align[U] = "left" : P.align[U] = null;
            for (Ne = P.rows.length, U = 0; U < Ne; U++) P.rows[U] = O(P.rows[U], P.header.length).map(function(Xe) {
              return { text: Xe };
            });
            for (Ne = P.header.length, ce = 0; ce < Ne; ce++) P.header[ce].tokens = this.lexer.inline(P.header[ce].text);
            for (Ne = P.rows.length, ce = 0; ce < Ne; ce++) for (ge = P.rows[ce], Ae = 0; Ae < ge.length; Ae++) ge[Ae].tokens = this.lexer.inline(ge[Ae].text);
            return P;
          }
        }
      }, Y.lheading = function(M) {
        var R = this.rules.block.lheading.exec(M);
        if (R) return { type: "heading", raw: R[0], depth: R[2].charAt(0) === "=" ? 1 : 2, text: R[1], tokens: this.lexer.inline(R[1]) };
      }, Y.paragraph = function(M) {
        var R = this.rules.block.paragraph.exec(M);
        if (R) {
          var P = R[1].charAt(R[1].length - 1) === `
` ? R[1].slice(0, -1) : R[1];
          return { type: "paragraph", raw: R[0], text: P, tokens: this.lexer.inline(P) };
        }
      }, Y.text = function(M) {
        var R = this.rules.block.text.exec(M);
        if (R) return { type: "text", raw: R[0], text: R[0], tokens: this.lexer.inline(R[0]) };
      }, Y.escape = function(M) {
        var R = this.rules.inline.escape.exec(M);
        if (R) return { type: "escape", raw: R[0], text: p(R[1]) };
      }, Y.tag = function(M) {
        var R = this.rules.inline.tag.exec(M);
        if (R) return !this.lexer.state.inLink && /^<a /i.test(R[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && /^<\/a>/i.test(R[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(R[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(R[0]) && (this.lexer.state.inRawBlock = !1), { type: this.options.sanitize ? "text" : "html", raw: R[0], inLink: this.lexer.state.inLink, inRawBlock: this.lexer.state.inRawBlock, text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(R[0]) : p(R[0]) : R[0] };
      }, Y.link = function(M) {
        var R = this.rules.inline.link.exec(M);
        if (R) {
          var P = R[2].trim();
          if (!this.options.pedantic && /^</.test(P)) {
            if (!/>$/.test(P)) return;
            var U = H(P.slice(0, -1), "\\");
            if ((P.length - U.length) % 2 == 0) return;
          } else {
            var ce = function(Oe, _t) {
              if (Oe.indexOf(_t[1]) === -1) return -1;
              for (var Ke = Oe.length, Lt = 0, Mt = 0; Mt < Ke; Mt++) if (Oe[Mt] === "\\") Mt++;
              else if (Oe[Mt] === _t[0]) Lt++;
              else if (Oe[Mt] === _t[1] && --Lt < 0) return Mt;
              return -1;
            }(R[2], "()");
            if (ce > -1) {
              var Ae = (R[0].indexOf("!") === 0 ? 5 : 4) + R[1].length + ce;
              R[2] = R[2].substring(0, ce), R[0] = R[0].substring(0, Ae).trim(), R[3] = "";
            }
          }
          var ge = R[2], Ne = "";
          if (this.options.pedantic) {
            var Xe = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(ge);
            Xe && (ge = Xe[1], Ne = Xe[3]);
          } else Ne = R[3] ? R[3].slice(1, -1) : "";
          return ge = ge.trim(), /^</.test(ge) && (ge = this.options.pedantic && !/>$/.test(P) ? ge.slice(1) : ge.slice(1, -1)), me(R, { href: ge && ge.replace(this.rules.inline._escapes, "$1"), title: Ne && Ne.replace(this.rules.inline._escapes, "$1") }, R[0], this.lexer);
        }
      }, Y.reflink = function(M, R) {
        var P;
        if ((P = this.rules.inline.reflink.exec(M)) || (P = this.rules.inline.nolink.exec(M))) {
          var U = (P[2] || P[1]).replace(/\s+/g, " ");
          if (!(U = R[U.toLowerCase()]) || !U.href) {
            var ce = P[0].charAt(0);
            return { type: "text", raw: ce, text: ce };
          }
          return me(P, U, P[0], this.lexer);
        }
      }, Y.emStrong = function(M, R, P) {
        P === void 0 && (P = "");
        var U = this.rules.inline.emStrong.lDelim.exec(M);
        if (U && (!U[3] || !P.match(/(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDF70-\uDF81\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDF00-\uDF1A\uDF30-\uDF3B\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])/))) {
          var ce = U[1] || U[2] || "";
          if (!ce || ce && (P === "" || this.rules.inline.punctuation.exec(P))) {
            var Ae, ge, Ne = U[0].length - 1, Xe = Ne, Oe = 0, _t = U[0][0] === "*" ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
            for (_t.lastIndex = 0, R = R.slice(-1 * M.length + Ne); (U = _t.exec(R)) != null; ) if (Ae = U[1] || U[2] || U[3] || U[4] || U[5] || U[6]) if (ge = Ae.length, U[3] || U[4]) Xe += ge;
            else if (!((U[5] || U[6]) && Ne % 3) || (Ne + ge) % 3) {
              if (!((Xe -= ge) > 0)) {
                if (ge = Math.min(ge, ge + Xe + Oe), Math.min(Ne, ge) % 2) {
                  var Ke = M.slice(1, Ne + U.index + ge);
                  return { type: "em", raw: M.slice(0, Ne + U.index + ge + 1), text: Ke, tokens: this.lexer.inlineTokens(Ke) };
                }
                var Lt = M.slice(2, Ne + U.index + ge - 1);
                return { type: "strong", raw: M.slice(0, Ne + U.index + ge + 1), text: Lt, tokens: this.lexer.inlineTokens(Lt) };
              }
            } else Oe += ge;
          }
        }
      }, Y.codespan = function(M) {
        var R = this.rules.inline.code.exec(M);
        if (R) {
          var P = R[2].replace(/\n/g, " "), U = /[^ ]/.test(P), ce = /^ /.test(P) && / $/.test(P);
          return U && ce && (P = P.substring(1, P.length - 1)), P = p(P, !0), { type: "codespan", raw: R[0], text: P };
        }
      }, Y.br = function(M) {
        var R = this.rules.inline.br.exec(M);
        if (R) return { type: "br", raw: R[0] };
      }, Y.del = function(M) {
        var R = this.rules.inline.del.exec(M);
        if (R) return { type: "del", raw: R[0], text: R[2], tokens: this.lexer.inlineTokens(R[2]) };
      }, Y.autolink = function(M, R) {
        var P, U, ce = this.rules.inline.autolink.exec(M);
        if (ce) return U = ce[2] === "@" ? "mailto:" + (P = p(this.options.mangle ? R(ce[1]) : ce[1])) : P = p(ce[1]), { type: "link", raw: ce[0], text: P, href: U, tokens: [{ type: "text", raw: P, text: P }] };
      }, Y.url = function(M, R) {
        var P;
        if (P = this.rules.inline.url.exec(M)) {
          var U, ce;
          if (P[2] === "@") ce = "mailto:" + (U = p(this.options.mangle ? R(P[0]) : P[0]));
          else {
            var Ae;
            do
              Ae = P[0], P[0] = this.rules.inline._backpedal.exec(P[0])[0];
            while (Ae !== P[0]);
            U = p(P[0]), ce = P[1] === "www." ? "http://" + U : U;
          }
          return { type: "link", raw: P[0], text: U, href: ce, tokens: [{ type: "text", raw: U, text: U }] };
        }
      }, Y.inlineText = function(M, R) {
        var P, U = this.rules.inline.text.exec(M);
        if (U) return P = this.lexer.state.inRawBlock ? this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(U[0]) : p(U[0]) : U[0] : p(this.options.smartypants ? R(U[0]) : U[0]), { type: "text", raw: U[0], text: P };
      }, le;
    }(), ee = { newline: /^(?: *(?:\n|$))+/, code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/, fences: /^ {0,3}(`{3,}(?=[^`\n]*\n)|~{3,})([^\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?=\n|$)|$)/, hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/, list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/, html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))", def: /^ {0,3}\[(label)\]: *(?:\n *)?<?([^\s>]+)>?(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/, table: B, lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/, _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, text: /^[^\n]+/, _label: /(?!\s*\])(?:\\.|[^\[\]\\])+/, _title: /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/ };
    ee.def = b(ee.def).replace("label", ee._label).replace("title", ee._title).getRegex(), ee.bullet = /(?:[*+-]|\d{1,9}[.)])/, ee.listItemStart = b(/^( *)(bull) */).replace("bull", ee.bullet).getRegex(), ee.list = b(ee.list).replace(/bull/g, ee.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + ee.def.source + ")").getRegex(), ee._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", ee._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/, ee.html = b(ee.html, "i").replace("comment", ee._comment).replace("tag", ee._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), ee.paragraph = b(ee._paragraph).replace("hr", ee.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", ee._tag).getRegex(), ee.blockquote = b(ee.blockquote).replace("paragraph", ee.paragraph).getRegex(), ee.normal = T({}, ee), ee.gfm = T({}, ee.normal, { table: "^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)" }), ee.gfm.table = b(ee.gfm.table).replace("hr", ee.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", ee._tag).getRegex(), ee.gfm.paragraph = b(ee._paragraph).replace("hr", ee.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("table", ee.gfm.table).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", ee._tag).getRegex(), ee.pedantic = T({}, ee.normal, { html: b(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", ee._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(), def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/, heading: /^(#{1,6})(.*)(?:\n+|$)/, fences: B, paragraph: b(ee.normal._paragraph).replace("hr", ee.hr).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", ee.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex() });
    var te = { escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/, url: B, tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>", link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/, reflink: /^!?\[(label)\]\[(ref)\]/, nolink: /^!?\[(ref)\](?:\[\])?/, reflinkSearch: "reflink|nolink(?!\\()", emStrong: { lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/, rDelimAst: /^[^_*]*?\_\_[^_*]*?\*[^_*]*?(?=\_\_)|[^*]+(?=[^*])|[punct_](\*+)(?=[\s]|$)|[^punct*_\s](\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|[^punct*_\s](\*+)(?=[^punct*_\s])/, rDelimUnd: /^[^_*]*?\*\*[^_*]*?\_[^_*]*?(?=\*\*)|[^_]+(?=[^_])|[punct*](\_+)(?=[\s]|$)|[^punct*_\s](\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/ }, code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, br: /^( {2,}|\\)\n(?!\s*$)/, del: B, text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, punctuation: /^([\spunctuation])/ };
    function be(le) {
      return le.replace(/---/g, "—").replace(/--/g, "–").replace(/(^|[-\u2014/(\[{"\s])'/g, "$1‘").replace(/'/g, "’").replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1“").replace(/"/g, "”").replace(/\.{3}/g, "…");
    }
    function we(le) {
      var Y, M, R = "", P = le.length;
      for (Y = 0; Y < P; Y++) M = le.charCodeAt(Y), Math.random() > 0.5 && (M = "x" + M.toString(16)), R += "&#" + M + ";";
      return R;
    }
    te._punctuation = "!\"#$%&'()+\\-.,/:;<=>?@\\[\\]`^{|}~", te.punctuation = b(te.punctuation).replace(/punctuation/g, te._punctuation).getRegex(), te.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g, te.escapedEmSt = /\\\*|\\_/g, te._comment = b(ee._comment).replace("(?:-->|$)", "-->").getRegex(), te.emStrong.lDelim = b(te.emStrong.lDelim).replace(/punct/g, te._punctuation).getRegex(), te.emStrong.rDelimAst = b(te.emStrong.rDelimAst, "g").replace(/punct/g, te._punctuation).getRegex(), te.emStrong.rDelimUnd = b(te.emStrong.rDelimUnd, "g").replace(/punct/g, te._punctuation).getRegex(), te._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g, te._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/, te._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/, te.autolink = b(te.autolink).replace("scheme", te._scheme).replace("email", te._email).getRegex(), te._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/, te.tag = b(te.tag).replace("comment", te._comment).replace("attribute", te._attribute).getRegex(), te._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/, te._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/, te._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/, te.link = b(te.link).replace("label", te._label).replace("href", te._href).replace("title", te._title).getRegex(), te.reflink = b(te.reflink).replace("label", te._label).replace("ref", ee._label).getRegex(), te.nolink = b(te.nolink).replace("ref", ee._label).getRegex(), te.reflinkSearch = b(te.reflinkSearch, "g").replace("reflink", te.reflink).replace("nolink", te.nolink).getRegex(), te.normal = T({}, te), te.pedantic = T({}, te.normal, { strong: { start: /^__|\*\*/, middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/, endAst: /\*\*(?!\*)/g, endUnd: /__(?!_)/g }, em: { start: /^_|\*/, middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/, endAst: /\*(?!\*)/g, endUnd: /_(?!_)/g }, link: b(/^!?\[(label)\]\((.*?)\)/).replace("label", te._label).getRegex(), reflink: b(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", te._label).getRegex() }), te.gfm = T({}, te.normal, { escape: b(te.escape).replace("])", "~|])").getRegex(), _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/, url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/, del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/, text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/ }), te.gfm.url = b(te.gfm.url, "i").replace("email", te.gfm._extended_email).getRegex(), te.breaks = T({}, te.gfm, { br: b(te.br).replace("{2,}", "*").getRegex(), text: b(te.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex() });
    var Re = function() {
      function le(M) {
        this.tokens = [], this.tokens.links = /* @__PURE__ */ Object.create(null), this.options = M || n.defaults, this.options.tokenizer = this.options.tokenizer || new ue(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = { inLink: !1, inRawBlock: !1, top: !0 };
        var R = { block: ee.normal, inline: te.normal };
        this.options.pedantic ? (R.block = ee.pedantic, R.inline = te.pedantic) : this.options.gfm && (R.block = ee.gfm, this.options.breaks ? R.inline = te.breaks : R.inline = te.gfm), this.tokenizer.rules = R;
      }
      le.lex = function(M, R) {
        return new le(R).lex(M);
      }, le.lexInline = function(M, R) {
        return new le(R).inlineTokens(M);
      };
      var Y = le.prototype;
      return Y.lex = function(M) {
        var R;
        for (M = M.replace(/\r\n|\r/g, `
`), this.blockTokens(M, this.tokens); R = this.inlineQueue.shift(); ) this.inlineTokens(R.src, R.tokens);
        return this.tokens;
      }, Y.blockTokens = function(M, R) {
        var P, U, ce, Ae, ge = this;
        for (R === void 0 && (R = []), M = this.options.pedantic ? M.replace(/\t/g, "    ").replace(/^ +$/gm, "") : M.replace(/^( *)(\t+)/gm, function(Xe, Oe, _t) {
          return Oe + "    ".repeat(_t.length);
        }); M; ) if (!(this.options.extensions && this.options.extensions.block && this.options.extensions.block.some(function(Xe) {
          return !!(P = Xe.call({ lexer: ge }, M, R)) && (M = M.substring(P.raw.length), R.push(P), !0);
        }))) {
          if (P = this.tokenizer.space(M)) M = M.substring(P.raw.length), P.raw.length === 1 && R.length > 0 ? R[R.length - 1].raw += `
` : R.push(P);
          else if (P = this.tokenizer.code(M)) M = M.substring(P.raw.length), !(U = R[R.length - 1]) || U.type !== "paragraph" && U.type !== "text" ? R.push(P) : (U.raw += `
` + P.raw, U.text += `
` + P.text, this.inlineQueue[this.inlineQueue.length - 1].src = U.text);
          else if (P = this.tokenizer.fences(M)) M = M.substring(P.raw.length), R.push(P);
          else if (P = this.tokenizer.heading(M)) M = M.substring(P.raw.length), R.push(P);
          else if (P = this.tokenizer.hr(M)) M = M.substring(P.raw.length), R.push(P);
          else if (P = this.tokenizer.blockquote(M)) M = M.substring(P.raw.length), R.push(P);
          else if (P = this.tokenizer.list(M)) M = M.substring(P.raw.length), R.push(P);
          else if (P = this.tokenizer.html(M)) M = M.substring(P.raw.length), R.push(P);
          else if (P = this.tokenizer.def(M)) M = M.substring(P.raw.length), !(U = R[R.length - 1]) || U.type !== "paragraph" && U.type !== "text" ? this.tokens.links[P.tag] || (this.tokens.links[P.tag] = { href: P.href, title: P.title }) : (U.raw += `
` + P.raw, U.text += `
` + P.raw, this.inlineQueue[this.inlineQueue.length - 1].src = U.text);
          else if (P = this.tokenizer.table(M)) M = M.substring(P.raw.length), R.push(P);
          else if (P = this.tokenizer.lheading(M)) M = M.substring(P.raw.length), R.push(P);
          else if (ce = M, this.options.extensions && this.options.extensions.startBlock && function() {
            var Xe = 1 / 0, Oe = M.slice(1), _t = void 0;
            ge.options.extensions.startBlock.forEach(function(Ke) {
              typeof (_t = Ke.call({ lexer: this }, Oe)) == "number" && _t >= 0 && (Xe = Math.min(Xe, _t));
            }), Xe < 1 / 0 && Xe >= 0 && (ce = M.substring(0, Xe + 1));
          }(), this.state.top && (P = this.tokenizer.paragraph(ce))) U = R[R.length - 1], Ae && U.type === "paragraph" ? (U.raw += `
` + P.raw, U.text += `
` + P.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = U.text) : R.push(P), Ae = ce.length !== M.length, M = M.substring(P.raw.length);
          else if (P = this.tokenizer.text(M)) M = M.substring(P.raw.length), (U = R[R.length - 1]) && U.type === "text" ? (U.raw += `
` + P.raw, U.text += `
` + P.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = U.text) : R.push(P);
          else if (M) {
            var Ne = "Infinite loop on byte: " + M.charCodeAt(0);
            if (this.options.silent) {
              console.error(Ne);
              break;
            }
            throw new Error(Ne);
          }
        }
        return this.state.top = !0, R;
      }, Y.inline = function(M, R) {
        return R === void 0 && (R = []), this.inlineQueue.push({ src: M, tokens: R }), R;
      }, Y.inlineTokens = function(M, R) {
        var P, U, ce, Ae = this;
        R === void 0 && (R = []);
        var ge, Ne, Xe, Oe = M;
        if (this.tokens.links) {
          var _t = Object.keys(this.tokens.links);
          if (_t.length > 0) for (; (ge = this.tokenizer.rules.inline.reflinkSearch.exec(Oe)) != null; ) _t.includes(ge[0].slice(ge[0].lastIndexOf("[") + 1, -1)) && (Oe = Oe.slice(0, ge.index) + "[" + pe("a", ge[0].length - 2) + "]" + Oe.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
        }
        for (; (ge = this.tokenizer.rules.inline.blockSkip.exec(Oe)) != null; ) Oe = Oe.slice(0, ge.index) + "[" + pe("a", ge[0].length - 2) + "]" + Oe.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
        for (; (ge = this.tokenizer.rules.inline.escapedEmSt.exec(Oe)) != null; ) Oe = Oe.slice(0, ge.index) + "++" + Oe.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
        for (; M; ) if (Ne || (Xe = ""), Ne = !1, !(this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some(function(Lt) {
          return !!(P = Lt.call({ lexer: Ae }, M, R)) && (M = M.substring(P.raw.length), R.push(P), !0);
        }))) if (P = this.tokenizer.escape(M)) M = M.substring(P.raw.length), R.push(P);
        else if (P = this.tokenizer.tag(M)) M = M.substring(P.raw.length), (U = R[R.length - 1]) && P.type === "text" && U.type === "text" ? (U.raw += P.raw, U.text += P.text) : R.push(P);
        else if (P = this.tokenizer.link(M)) M = M.substring(P.raw.length), R.push(P);
        else if (P = this.tokenizer.reflink(M, this.tokens.links)) M = M.substring(P.raw.length), (U = R[R.length - 1]) && P.type === "text" && U.type === "text" ? (U.raw += P.raw, U.text += P.text) : R.push(P);
        else if (P = this.tokenizer.emStrong(M, Oe, Xe)) M = M.substring(P.raw.length), R.push(P);
        else if (P = this.tokenizer.codespan(M)) M = M.substring(P.raw.length), R.push(P);
        else if (P = this.tokenizer.br(M)) M = M.substring(P.raw.length), R.push(P);
        else if (P = this.tokenizer.del(M)) M = M.substring(P.raw.length), R.push(P);
        else if (P = this.tokenizer.autolink(M, we)) M = M.substring(P.raw.length), R.push(P);
        else if (this.state.inLink || !(P = this.tokenizer.url(M, we))) {
          if (ce = M, this.options.extensions && this.options.extensions.startInline && function() {
            var Lt = 1 / 0, Mt = M.slice(1), si = void 0;
            Ae.options.extensions.startInline.forEach(function(Vs) {
              typeof (si = Vs.call({ lexer: this }, Mt)) == "number" && si >= 0 && (Lt = Math.min(Lt, si));
            }), Lt < 1 / 0 && Lt >= 0 && (ce = M.substring(0, Lt + 1));
          }(), P = this.tokenizer.inlineText(ce, be)) M = M.substring(P.raw.length), P.raw.slice(-1) !== "_" && (Xe = P.raw.slice(-1)), Ne = !0, (U = R[R.length - 1]) && U.type === "text" ? (U.raw += P.raw, U.text += P.text) : R.push(P);
          else if (M) {
            var Ke = "Infinite loop on byte: " + M.charCodeAt(0);
            if (this.options.silent) {
              console.error(Ke);
              break;
            }
            throw new Error(Ke);
          }
        } else M = M.substring(P.raw.length), R.push(P);
        return R;
      }, s(le, 0, [{ key: "rules", get: function() {
        return { block: ee, inline: te };
      } }]), le;
    }(), it = function() {
      function le(M) {
        this.options = M || n.defaults;
      }
      var Y = le.prototype;
      return Y.code = function(M, R, P) {
        var U = (R || "").match(/\S*/)[0];
        if (this.options.highlight) {
          var ce = this.options.highlight(M, U);
          ce != null && ce !== M && (P = !0, M = ce);
        }
        return M = M.replace(/\n$/, "") + `
`, U ? '<pre><code class="' + this.options.langPrefix + p(U, !0) + '">' + (P ? M : p(M, !0)) + `</code></pre>
` : "<pre><code>" + (P ? M : p(M, !0)) + `</code></pre>
`;
      }, Y.blockquote = function(M) {
        return `<blockquote>
` + M + `</blockquote>
`;
      }, Y.html = function(M) {
        return M;
      }, Y.heading = function(M, R, P, U) {
        return this.options.headerIds ? "<h" + R + ' id="' + (this.options.headerPrefix + U.slug(P)) + '">' + M + "</h" + R + `>
` : "<h" + R + ">" + M + "</h" + R + `>
`;
      }, Y.hr = function() {
        return this.options.xhtml ? `<hr/>
` : `<hr>
`;
      }, Y.list = function(M, R, P) {
        var U = R ? "ol" : "ul";
        return "<" + U + (R && P !== 1 ? ' start="' + P + '"' : "") + `>
` + M + "</" + U + `>
`;
      }, Y.listitem = function(M) {
        return "<li>" + M + `</li>
`;
      }, Y.checkbox = function(M) {
        return "<input " + (M ? 'checked="" ' : "") + 'disabled="" type="checkbox"' + (this.options.xhtml ? " /" : "") + "> ";
      }, Y.paragraph = function(M) {
        return "<p>" + M + `</p>
`;
      }, Y.table = function(M, R) {
        return R && (R = "<tbody>" + R + "</tbody>"), `<table>
<thead>
` + M + `</thead>
` + R + `</table>
`;
      }, Y.tablerow = function(M) {
        return `<tr>
` + M + `</tr>
`;
      }, Y.tablecell = function(M, R) {
        var P = R.header ? "th" : "td";
        return (R.align ? "<" + P + ' align="' + R.align + '">' : "<" + P + ">") + M + "</" + P + `>
`;
      }, Y.strong = function(M) {
        return "<strong>" + M + "</strong>";
      }, Y.em = function(M) {
        return "<em>" + M + "</em>";
      }, Y.codespan = function(M) {
        return "<code>" + M + "</code>";
      }, Y.br = function() {
        return this.options.xhtml ? "<br/>" : "<br>";
      }, Y.del = function(M) {
        return "<del>" + M + "</del>";
      }, Y.link = function(M, R, P) {
        if ((M = y(this.options.sanitize, this.options.baseUrl, M)) === null) return P;
        var U = '<a href="' + p(M) + '"';
        return R && (U += ' title="' + R + '"'), U += ">" + P + "</a>";
      }, Y.image = function(M, R, P) {
        if ((M = y(this.options.sanitize, this.options.baseUrl, M)) === null) return P;
        var U = '<img src="' + M + '" alt="' + P + '"';
        return R && (U += ' title="' + R + '"'), U += this.options.xhtml ? "/>" : ">";
      }, Y.text = function(M) {
        return M;
      }, le;
    }(), ut = function() {
      function le() {
      }
      var Y = le.prototype;
      return Y.strong = function(M) {
        return M;
      }, Y.em = function(M) {
        return M;
      }, Y.codespan = function(M) {
        return M;
      }, Y.del = function(M) {
        return M;
      }, Y.html = function(M) {
        return M;
      }, Y.text = function(M) {
        return M;
      }, Y.link = function(M, R, P) {
        return "" + P;
      }, Y.image = function(M, R, P) {
        return "" + P;
      }, Y.br = function() {
        return "";
      }, le;
    }(), Xi = function() {
      function le() {
        this.seen = {};
      }
      var Y = le.prototype;
      return Y.serialize = function(M) {
        return M.toLowerCase().trim().replace(/<[!\/a-z].*?>/gi, "").replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, "").replace(/\s/g, "-");
      }, Y.getNextSafeSlug = function(M, R) {
        var P = M, U = 0;
        if (this.seen.hasOwnProperty(P)) {
          U = this.seen[M];
          do
            P = M + "-" + ++U;
          while (this.seen.hasOwnProperty(P));
        }
        return R || (this.seen[M] = U, this.seen[P] = 0), P;
      }, Y.slug = function(M, R) {
        R === void 0 && (R = {});
        var P = this.serialize(M);
        return this.getNextSafeSlug(P, R.dryrun);
      }, le;
    }(), nt = function() {
      function le(M) {
        this.options = M || n.defaults, this.options.renderer = this.options.renderer || new it(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.textRenderer = new ut(), this.slugger = new Xi();
      }
      le.parse = function(M, R) {
        return new le(R).parse(M);
      }, le.parseInline = function(M, R) {
        return new le(R).parseInline(M);
      };
      var Y = le.prototype;
      return Y.parse = function(M, R) {
        R === void 0 && (R = !0);
        var P, U, ce, Ae, ge, Ne, Xe, Oe, _t, Ke, Lt, Mt, si, Vs, At, Vc, Mr, Dl, Qi, Sn = "", Og = M.length;
        for (P = 0; P < Og; P++) if (Ke = M[P], !(this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[Ke.type]) || (Qi = this.options.extensions.renderers[Ke.type].call({ parser: this }, Ke)) === !1 && ["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(Ke.type)) switch (Ke.type) {
          case "space":
            continue;
          case "hr":
            Sn += this.renderer.hr();
            continue;
          case "heading":
            Sn += this.renderer.heading(this.parseInline(Ke.tokens), Ke.depth, _(this.parseInline(Ke.tokens, this.textRenderer)), this.slugger);
            continue;
          case "code":
            Sn += this.renderer.code(Ke.text, Ke.lang, Ke.escaped);
            continue;
          case "table":
            for (Oe = "", Xe = "", Ae = Ke.header.length, U = 0; U < Ae; U++) Xe += this.renderer.tablecell(this.parseInline(Ke.header[U].tokens), { header: !0, align: Ke.align[U] });
            for (Oe += this.renderer.tablerow(Xe), _t = "", Ae = Ke.rows.length, U = 0; U < Ae; U++) {
              for (Xe = "", ge = (Ne = Ke.rows[U]).length, ce = 0; ce < ge; ce++) Xe += this.renderer.tablecell(this.parseInline(Ne[ce].tokens), { header: !1, align: Ke.align[ce] });
              _t += this.renderer.tablerow(Xe);
            }
            Sn += this.renderer.table(Oe, _t);
            continue;
          case "blockquote":
            _t = this.parse(Ke.tokens), Sn += this.renderer.blockquote(_t);
            continue;
          case "list":
            for (Lt = Ke.ordered, Mt = Ke.start, si = Ke.loose, Ae = Ke.items.length, _t = "", U = 0; U < Ae; U++) Vc = (At = Ke.items[U]).checked, Mr = At.task, Vs = "", At.task && (Dl = this.renderer.checkbox(Vc), si ? At.tokens.length > 0 && At.tokens[0].type === "paragraph" ? (At.tokens[0].text = Dl + " " + At.tokens[0].text, At.tokens[0].tokens && At.tokens[0].tokens.length > 0 && At.tokens[0].tokens[0].type === "text" && (At.tokens[0].tokens[0].text = Dl + " " + At.tokens[0].tokens[0].text)) : At.tokens.unshift({ type: "text", text: Dl }) : Vs += Dl), Vs += this.parse(At.tokens, si), _t += this.renderer.listitem(Vs, Mr, Vc);
            Sn += this.renderer.list(_t, Lt, Mt);
            continue;
          case "html":
            Sn += this.renderer.html(Ke.text);
            continue;
          case "paragraph":
            Sn += this.renderer.paragraph(this.parseInline(Ke.tokens));
            continue;
          case "text":
            for (_t = Ke.tokens ? this.parseInline(Ke.tokens) : Ke.text; P + 1 < Og && M[P + 1].type === "text"; ) _t += `
` + ((Ke = M[++P]).tokens ? this.parseInline(Ke.tokens) : Ke.text);
            Sn += R ? this.renderer.paragraph(_t) : _t;
            continue;
          default:
            var qd = 'Token with "' + Ke.type + '" type was not found.';
            if (this.options.silent) return void console.error(qd);
            throw new Error(qd);
        }
        else Sn += Qi || "";
        return Sn;
      }, Y.parseInline = function(M, R) {
        R = R || this.renderer;
        var P, U, ce, Ae = "", ge = M.length;
        for (P = 0; P < ge; P++) if (U = M[P], !(this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[U.type]) || (ce = this.options.extensions.renderers[U.type].call({ parser: this }, U)) === !1 && ["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(U.type)) switch (U.type) {
          case "escape":
          case "text":
            Ae += R.text(U.text);
            break;
          case "html":
            Ae += R.html(U.text);
            break;
          case "link":
            Ae += R.link(U.href, U.title, this.parseInline(U.tokens, R));
            break;
          case "image":
            Ae += R.image(U.href, U.title, U.text);
            break;
          case "strong":
            Ae += R.strong(this.parseInline(U.tokens, R));
            break;
          case "em":
            Ae += R.em(this.parseInline(U.tokens, R));
            break;
          case "codespan":
            Ae += R.codespan(U.text);
            break;
          case "br":
            Ae += R.br();
            break;
          case "del":
            Ae += R.del(this.parseInline(U.tokens, R));
            break;
          default:
            var Ne = 'Token with "' + U.type + '" type was not found.';
            if (this.options.silent) return void console.error(Ne);
            throw new Error(Ne);
        }
        else Ae += ce || "";
        return Ae;
      }, le;
    }();
    function De(le, Y, M) {
      if (le == null) throw new Error("marked(): input parameter is undefined or null");
      if (typeof le != "string") throw new Error("marked(): input parameter is of type " + Object.prototype.toString.call(le) + ", string expected");
      if (typeof Y == "function" && (M = Y, Y = null), $(Y = T({}, De.defaults, Y || {})), M) {
        var R, P = Y.highlight;
        try {
          R = Re.lex(le, Y);
        } catch (Ne) {
          return M(Ne);
        }
        var U = function(Ne) {
          var Xe;
          if (!Ne) try {
            Y.walkTokens && De.walkTokens(R, Y.walkTokens), Xe = nt.parse(R, Y);
          } catch (Oe) {
            Ne = Oe;
          }
          return Y.highlight = P, Ne ? M(Ne) : M(null, Xe);
        };
        if (!P || P.length < 3 || (delete Y.highlight, !R.length)) return U();
        var ce = 0;
        return De.walkTokens(R, function(Ne) {
          Ne.type === "code" && (ce++, setTimeout(function() {
            P(Ne.text, Ne.lang, function(Xe, Oe) {
              if (Xe) return U(Xe);
              Oe != null && Oe !== Ne.text && (Ne.text = Oe, Ne.escaped = !0), --ce == 0 && U();
            });
          }, 0));
        }), void (ce === 0 && U());
      }
      function Ae(Ne) {
        if (Ne.message += `
Please report this to https://github.com/markedjs/marked.`, Y.silent) return "<p>An error occurred:</p><pre>" + p(Ne.message + "", !0) + "</pre>";
        throw Ne;
      }
      try {
        var ge = Re.lex(le, Y);
        if (Y.walkTokens) {
          if (Y.async) return Promise.all(De.walkTokens(ge, Y.walkTokens)).then(function() {
            return nt.parse(ge, Y);
          }).catch(Ae);
          De.walkTokens(ge, Y.walkTokens);
        }
        return nt.parse(ge, Y);
      } catch (Ne) {
        Ae(Ne);
      }
    }
    De.options = De.setOptions = function(le) {
      var Y;
      return T(De.defaults, le), Y = De.defaults, n.defaults = Y, De;
    }, De.getDefaults = a, De.defaults = n.defaults, De.use = function() {
      for (var le = arguments.length, Y = new Array(le), M = 0; M < le; M++) Y[M] = arguments[M];
      var R, P = T.apply(void 0, [{}].concat(Y)), U = De.defaults.extensions || { renderers: {}, childTokens: {} };
      Y.forEach(function(ce) {
        if (ce.extensions && (R = !0, ce.extensions.forEach(function(ge) {
          if (!ge.name) throw new Error("extension name required");
          if (ge.renderer) {
            var Ne = U.renderers ? U.renderers[ge.name] : null;
            U.renderers[ge.name] = Ne ? function() {
              for (var Xe = arguments.length, Oe = new Array(Xe), _t = 0; _t < Xe; _t++) Oe[_t] = arguments[_t];
              var Ke = ge.renderer.apply(this, Oe);
              return Ke === !1 && (Ke = Ne.apply(this, Oe)), Ke;
            } : ge.renderer;
          }
          if (ge.tokenizer) {
            if (!ge.level || ge.level !== "block" && ge.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
            U[ge.level] ? U[ge.level].unshift(ge.tokenizer) : U[ge.level] = [ge.tokenizer], ge.start && (ge.level === "block" ? U.startBlock ? U.startBlock.push(ge.start) : U.startBlock = [ge.start] : ge.level === "inline" && (U.startInline ? U.startInline.push(ge.start) : U.startInline = [ge.start]));
          }
          ge.childTokens && (U.childTokens[ge.name] = ge.childTokens);
        })), ce.renderer && function() {
          var ge = De.defaults.renderer || new it(), Ne = function(Oe) {
            var _t = ge[Oe];
            ge[Oe] = function() {
              for (var Ke = arguments.length, Lt = new Array(Ke), Mt = 0; Mt < Ke; Mt++) Lt[Mt] = arguments[Mt];
              var si = ce.renderer[Oe].apply(ge, Lt);
              return si === !1 && (si = _t.apply(ge, Lt)), si;
            };
          };
          for (var Xe in ce.renderer) Ne(Xe);
          P.renderer = ge;
        }(), ce.tokenizer && function() {
          var ge = De.defaults.tokenizer || new ue(), Ne = function(Oe) {
            var _t = ge[Oe];
            ge[Oe] = function() {
              for (var Ke = arguments.length, Lt = new Array(Ke), Mt = 0; Mt < Ke; Mt++) Lt[Mt] = arguments[Mt];
              var si = ce.tokenizer[Oe].apply(ge, Lt);
              return si === !1 && (si = _t.apply(ge, Lt)), si;
            };
          };
          for (var Xe in ce.tokenizer) Ne(Xe);
          P.tokenizer = ge;
        }(), ce.walkTokens) {
          var Ae = De.defaults.walkTokens;
          P.walkTokens = function(ge) {
            var Ne = [];
            return Ne.push(ce.walkTokens.call(this, ge)), Ae && (Ne = Ne.concat(Ae.call(this, ge))), Ne;
          };
        }
        R && (P.extensions = U), De.setOptions(P);
      });
    }, De.walkTokens = function(le, Y) {
      for (var M, R = [], P = function() {
        var ce = M.value;
        switch (R = R.concat(Y.call(De, ce)), ce.type) {
          case "table":
            for (var Ae, ge = r(ce.header); !(Ae = ge()).done; ) {
              var Ne = Ae.value;
              R = R.concat(De.walkTokens(Ne.tokens, Y));
            }
            for (var Xe, Oe = r(ce.rows); !(Xe = Oe()).done; ) for (var _t, Ke = r(Xe.value); !(_t = Ke()).done; ) {
              var Lt = _t.value;
              R = R.concat(De.walkTokens(Lt.tokens, Y));
            }
            break;
          case "list":
            R = R.concat(De.walkTokens(ce.items, Y));
            break;
          default:
            De.defaults.extensions && De.defaults.extensions.childTokens && De.defaults.extensions.childTokens[ce.type] ? De.defaults.extensions.childTokens[ce.type].forEach(function(Mt) {
              R = R.concat(De.walkTokens(ce[Mt], Y));
            }) : ce.tokens && (R = R.concat(De.walkTokens(ce.tokens, Y)));
        }
      }, U = r(le); !(M = U()).done; ) P();
      return R;
    }, De.parseInline = function(le, Y) {
      if (le == null) throw new Error("marked.parseInline(): input parameter is undefined or null");
      if (typeof le != "string") throw new Error("marked.parseInline(): input parameter is of type " + Object.prototype.toString.call(le) + ", string expected");
      $(Y = T({}, De.defaults, Y || {}));
      try {
        var M = Re.lexInline(le, Y);
        return Y.walkTokens && De.walkTokens(M, Y.walkTokens), nt.parseInline(M, Y);
      } catch (R) {
        if (R.message += `
Please report this to https://github.com/markedjs/marked.`, Y.silent) return "<p>An error occurred:</p><pre>" + p(R.message + "", !0) + "</pre>";
        throw R;
      }
    }, De.Parser = nt, De.parser = nt.parse, De.Renderer = it, De.TextRenderer = ut, De.Lexer = Re, De.lexer = Re.lex, De.Tokenizer = ue, De.Slugger = Xi, De.parse = De;
    var an = De.options, ka = De.setOptions, Er = De.use, Ws = De.walkTokens, Ss = De.parseInline, Ir = De, jd = nt.parse, Ki = Re.lex;
    n.Lexer = Re, n.Parser = nt, n.Renderer = it, n.Slugger = Xi, n.TextRenderer = ut, n.Tokenizer = ue, n.getDefaults = a, n.lexer = Ki, n.marked = De, n.options = an, n.parse = Ir, n.parseInline = Ss, n.parser = jd, n.setOptions = ka, n.use = Er, n.walkTokens = Ws, Object.defineProperty(n, "__esModule", { value: !0 });
  }, i.amd ? i(0, t) : t(typeof exports == "object" && typeof module < "u" ? exports : (e = typeof globalThis < "u" ? globalThis : e || self).marked = {});
})(), rs.Lexer || exports.Lexer, rs.Parser || exports.Parser, rs.Renderer || exports.Renderer, rs.Slugger || exports.Slugger, rs.TextRenderer || exports.TextRenderer, rs.Tokenizer || exports.Tokenizer, rs.getDefaults || exports.getDefaults, rs.lexer || exports.lexer;
var Xa = rs.marked || exports.marked;
function AI(i) {
  let e = JSON.parse(i);
  return e = PI(e), e;
}
function VJ(i, e) {
  return e instanceof RegExp ? { $mid: 2, source: e.source, flags: e.flags } : e;
}
function PI(i, e = 0) {
  if (!i || e > 200) return i;
  if (typeof i == "object") {
    switch (i.$mid) {
      case 1:
        return Ie.revive(i);
      case 2:
        return new RegExp(i.source, i.flags);
      case 17:
        return new Date(i.source);
    }
    if (i instanceof iL || i instanceof Uint8Array) return i;
    if (Array.isArray(i)) for (let t = 0; t < i.length; ++t) i[t] = PI(i[t], e + 1);
    else for (const t in i) Object.hasOwnProperty.call(i, t) && (i[t] = PI(i[t], e + 1));
  }
  return i;
}
rs.options || exports.options, rs.parse || exports.parse, rs.parseInline || exports.parseInline, rs.parser || exports.parser, rs.setOptions || exports.setOptions, rs.use || exports.use, rs.walkTokens || exports.walkTokens;
const GD = Object.freeze({ image: (i, e, t) => {
  let n = [], s = [];
  return i && ({ href: i, dimensions: n } = function(o) {
    const r = [], a = o.split("|").map((d) => d.trim());
    o = a[0];
    const l = a[1];
    if (l) {
      const d = /height=(\d+)/.exec(l), h = /width=(\d+)/.exec(l), c = d ? d[1] : "", u = h ? h[1] : "", g = isFinite(parseInt(u)), p = isFinite(parseInt(c));
      g && r.push(`width="${u}"`), p && r.push(`height="${c}"`);
    }
    return { href: o, dimensions: r };
  }(i), s.push(`src="${Ab(i)}"`)), t && s.push(`alt="${Ab(t)}"`), e && s.push(`title="${Ab(e)}"`), n.length && (s = s.concat(n)), "<img " + s.join(" ") + ">";
}, paragraph: (i) => `<p>${i}</p>`, link: (i, e, t) => typeof i != "string" ? "" : (i === t && (t = $D(t)), e = typeof e == "string" ? Ab($D(e)) : "", `<a href="${i = (i = $D(i)).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;")}" title="${e || i}" draggable="false">${t}</a>`) });
function CL(i, e = {}, t = {}) {
  var n, s;
  const o = new G();
  let r = !1;
  const a = fA(e), l = function(_) {
    let v;
    try {
      v = AI(decodeURIComponent(_));
    } catch {
    }
    return v ? (v = b7(v, (b) => i.uris && i.uris[b] ? Ie.revive(i.uris[b]) : void 0), encodeURIComponent(JSON.stringify(v))) : _;
  }, d = function(_, v) {
    const b = i.uris && i.uris[_];
    let C = Ie.revive(b);
    return v ? _.startsWith(Ue.data + ":") ? _ : (C || (C = Ie.parse(_)), m8.uriToBrowserUri(C).toString(!0)) : C ? Ie.parse(_).toString() === C.toString() ? _ : (C.query && (C = C.with({ query: l(C.query) })), C.toString()) : _;
  }, h = new Xa.Renderer();
  h.image = GD.image, h.link = GD.link, h.paragraph = GD.paragraph;
  const c = [], u = [];
  if (e.codeBlockRendererSync ? h.code = (_, v) => {
    const b = RI.nextId(), C = e.codeBlockRendererSync(v3(v), _);
    return u.push([b, C]), `<div class="code" data-code="${b}">${Ww(_)}</div>`;
  } : e.codeBlockRenderer && (h.code = (_, v) => {
    const b = RI.nextId(), C = e.codeBlockRenderer(v3(v), _);
    return c.push(C.then((w) => [b, w])), `<div class="code" data-code="${b}">${Ww(_)}</div>`;
  }), e.actionHandler) {
    const _ = function(C) {
      let w = C.target;
      if (w.tagName === "A" || (w = w.parentElement, w && w.tagName === "A")) try {
        let y = w.dataset.href;
        y && (i.baseUri && (y = ZD(Ie.from(i.baseUri), y)), e.actionHandler.callback(y, C));
      } catch (y) {
        We(y);
      } finally {
        C.preventDefault();
      }
    }, v = e.actionHandler.disposables.add(new st(a, "click")), b = e.actionHandler.disposables.add(new st(a, "auxclick"));
    e.actionHandler.disposables.add(se.any(v.event, b.event)((C) => {
      const w = new _r(ke(a), C);
      (w.leftButton || w.middleButton) && _(w);
    })), e.actionHandler.disposables.add(K(a, "keydown", (C) => {
      const w = new jt(C);
      (w.equals(10) || w.equals(3)) && _(w);
    }));
  }
  i.supportHtml || (t.sanitizer = (_) => i.isTrusted && _.match(/^(<span[^>]+>)|(<\/\s*span>)$/) ? _ : "", t.sanitize = !0, t.silent = !0), t.renderer = h;
  let g, p = (n = i.value) !== null && n !== void 0 ? n : "";
  if (p.length > 1e5 && (p = `${p.substr(0, 1e5)}…`), i.supportThemeIcons && (p = function(_) {
    return _.replace(BJ, (v) => `\\${v}`);
  }(p)), e.fillInIncompleteTokens) {
    const _ = { ...Xa.defaults, ...t }, v = function(b) {
      let C, w;
      for (C = 0; C < b.length; C++) {
        const y = b[C];
        let L;
        if (y.type === "paragraph" && (L = y.raw.match(/(\n|^)(````*)/))) {
          const k = L[2];
          w = qJ(b.slice(C), k);
          break;
        }
        if (y.type === "paragraph" && y.raw.match(/(\n|^)\|/)) {
          w = JJ(b.slice(C));
          break;
        }
        if (C === b.length - 1 && y.type === "paragraph") {
          const k = jJ(y);
          if (k) {
            w = [k];
            break;
          }
        }
      }
      if (w) {
        const y = [...b.slice(0, C), ...w];
        return y.links = b.links, y;
      }
      return b;
    }(Xa.lexer(p, _));
    g = Xa.parser(v, _);
  } else g = Xa.parse(p, t);
  i.supportThemeIcons && (g = ic(g).map((_) => typeof _ == "string" ? _ : _.outerHTML).join(""));
  const f = new DOMParser().parseFromString(OI(i, g), "text/html");
  if (f.body.querySelectorAll("img").forEach((_) => {
    const v = _.getAttribute("src");
    if (v) {
      let b = v;
      try {
        i.baseUri && (b = ZD(Ie.from(i.baseUri), b));
      } catch {
      }
      _.src = d(b, !0);
    }
  }), f.body.querySelectorAll("a").forEach((_) => {
    const v = _.getAttribute("href");
    if (_.setAttribute("href", ""), !v || /^data:|javascript:/i.test(v) || /^command:/i.test(v) && !i.isTrusted || /^command:(\/\/\/)?_workbench\.downloadResource/i.test(v)) _.replaceWith(..._.childNodes);
    else {
      let b = d(v, !1);
      i.baseUri && (b = ZD(Ie.from(i.baseUri), v)), _.dataset.href = b;
    }
  }), a.innerHTML = OI(i, f.body.innerHTML), c.length > 0) Promise.all(c).then((_) => {
    var v, b;
    if (r) return;
    const C = new Map(_), w = a.querySelectorAll("div[data-code]");
    for (const y of w) {
      const L = C.get((v = y.dataset.code) !== null && v !== void 0 ? v : "");
      L && wn(y, L);
    }
    (b = e.asyncRenderCallback) === null || b === void 0 || b.call(e);
  });
  else if (u.length > 0) {
    const _ = new Map(u), v = a.querySelectorAll("div[data-code]");
    for (const b of v) {
      const C = _.get((s = b.dataset.code) !== null && s !== void 0 ? s : "");
      C && wn(b, C);
    }
  }
  if (e.asyncRenderCallback) for (const _ of a.getElementsByTagName("img")) {
    const v = o.add(K(_, "load", () => {
      v.dispose(), e.asyncRenderCallback();
    }));
  }
  return { element: a, dispose: () => {
    r = !0, o.dispose();
  } };
}
function v3(i) {
  if (!i) return "";
  const e = i.split(/[\s+|:|,|\{|\?]/, 1);
  return e.length ? e[0] : i;
}
function ZD(i, e) {
  return /^\w[\w\d+.-]*:/.test(e) ? e : i.path.endsWith("/") ? w5(i, e).toString() : w5(pL(i), e).toString();
}
function OI(i, e) {
  const { config: t, allowedSchemes: n } = function(o) {
    const r = [Ue.http, Ue.https, Ue.mailto, Ue.data, Ue.file, Ue.vscodeFileResource, Ue.vscodeRemote, Ue.vscodeRemoteResource];
    return o.isTrusted && r.push(Ue.command), { config: { ALLOWED_TAGS: [..._j], ALLOWED_ATTR: HJ, ALLOW_UNKNOWN_PROTOCOLS: !0 }, allowedSchemes: r };
  }(i);
  Uk("uponSanitizeAttribute", (o, r) => {
    var a;
    if (r.attrName !== "style" && r.attrName !== "class") {
      if (o.tagName === "INPUT" && ((a = o.attributes.getNamedItem("type")) === null || a === void 0 ? void 0 : a.value) === "checkbox") {
        if (r.attrName === "type" && r.attrValue === "checkbox" || r.attrName === "disabled" || r.attrName === "checked") return void (r.keepAttr = !0);
        r.keepAttr = !1;
      }
    } else {
      if (o.tagName === "SPAN") {
        if (r.attrName === "style") return void (r.keepAttr = /^(color\:(#[0-9a-fA-F]+|var\(--vscode(-[a-zA-Z]+)+\));)?(background-color\:(#[0-9a-fA-F]+|var\(--vscode(-[a-zA-Z]+)+\));)?$/.test(r.attrValue));
        if (r.attrName === "class") return void (r.keepAttr = /^codicon codicon-[a-z\-]+( codicon-modifier-[a-z\-]+)?$/.test(r.attrValue));
      }
      r.keepAttr = !1;
    }
  }), Uk("uponSanitizeElement", (o, r) => {
    var a, l;
    r.tagName === "input" && (((a = o.attributes.getNamedItem("type")) === null || a === void 0 ? void 0 : a.value) === "checkbox" ? o.setAttribute("disabled", "") : (l = o.parentElement) === null || l === void 0 || l.removeChild(o));
  });
  const s = function(o, r = !1) {
    const a = document.createElement("a");
    return Uk("afterSanitizeAttributes", (l) => {
      for (const d of ["href", "src"]) if (l.hasAttribute(d)) {
        const h = l.getAttribute(d);
        if (d === "href" && h.startsWith("#")) continue;
        if (a.href = h, !o.includes(a.protocol.replace(/:$/, ""))) {
          if (r && d === "src" && a.href.startsWith("data:")) continue;
          l.removeAttribute(d);
        }
      }
    }), ye(() => {
      CO("afterSanitizeAttributes");
    });
  }(n);
  try {
    return g8(e, { ...t, RETURN_TRUSTED_TYPE: !0 });
  } finally {
    CO("uponSanitizeAttribute"), s.dispose();
  }
}
const HJ = ["align", "autoplay", "alt", "checked", "class", "controls", "data-code", "data-href", "disabled", "draggable", "height", "href", "loop", "muted", "playsinline", "poster", "src", "style", "target", "title", "type", "width", "start"];
function zJ(i) {
  return typeof i == "string" ? i : function(e) {
    var t;
    let n = (t = e.value) !== null && t !== void 0 ? t : "";
    n.length > 1e5 && (n = `${n.substr(0, 1e5)}…`);
    const s = Xa.parse(n, { renderer: KJ.value }).replace(/&(#\d+|[a-zA-Z]+);/g, (o) => {
      var r;
      return (r = UJ.get(o)) !== null && r !== void 0 ? r : o;
    });
    return OI({ isTrusted: !1 }, s).toString();
  }(i);
}
const UJ = /* @__PURE__ */ new Map([["&quot;", '"'], ["&nbsp;", " "], ["&amp;", "&"], ["&#39;", "'"], ["&lt;", "<"], ["&gt;", ">"]]), KJ = new ga(() => {
  const i = new Xa.Renderer();
  return i.code = (e) => e, i.blockquote = (e) => e, i.html = (e) => "", i.heading = (e, t, n) => e + `
`, i.hr = () => "", i.list = (e, t) => e, i.listitem = (e) => e + `
`, i.paragraph = (e) => e + `
`, i.table = (e, t) => e + t + `
`, i.tablerow = (e) => e, i.tablecell = (e, t) => e + " ", i.strong = (e) => e, i.em = (e) => e, i.codespan = (e) => e, i.br = () => `
`, i.del = (e) => e, i.image = (e, t, n) => "", i.text = (e) => e, i.link = (e, t, n) => n, i;
});
function LA(i) {
  let e = "";
  return i.forEach((t) => {
    e += t.raw;
  }), e;
}
function jJ(i) {
  var e, t;
  for (let n = 0; n < i.tokens.length; n++) {
    const s = i.tokens[n];
    if (s.type === "text") {
      const o = s.raw.split(`
`), r = o[o.length - 1];
      if (r.includes("`")) return $J(i);
      if (r.includes("**")) return Oc(i, "**");
      if (r.match(/\*\w/)) return GJ(i);
      if (r.match(/(^|\s)__\w/)) return QJ(i);
      if (r.match(/(^|\s)_\w/)) return ZJ(i);
      if (r.match(/(^|\s)\[.*\]\(\w*/)) {
        const a = i.tokens.slice(n + 1);
        return ((e = a[0]) === null || e === void 0 ? void 0 : e.type) === "link" && ((t = a[1]) === null || t === void 0 ? void 0 : t.type) === "text" && a[1].raw.match(/^ *"[^"]*$/) ? YJ(i) : C3(i);
      }
      if (b3(r)) return C3(i);
      if (r.match(/(^|\s)\[\w/) && !i.tokens.slice(n + 1).some((a) => b3(a.raw))) return XJ(i);
    }
  }
}
function b3(i) {
  return !!i.match(/^[^\[]*\]\([^\)]*$/);
}
function qJ(i, e) {
  const t = LA(i);
  return Xa.lexer(t + `
${e}`);
}
function $J(i) {
  return Oc(i, "`");
}
function GJ(i) {
  return Oc(i, "*");
}
function ZJ(i) {
  return Oc(i, "_");
}
function C3(i) {
  return Oc(i, ")");
}
function YJ(i) {
  return Oc(i, '")');
}
function XJ(i) {
  return Oc(i, "](about:blank)");
}
function QJ(i) {
  return Oc(i, "__");
}
function Oc(i, e) {
  const t = LA(Array.isArray(i) ? i : [i]);
  return Xa.lexer(t + e)[0];
}
function JJ(i) {
  const e = LA(i), t = e.split(`
`);
  let n, s = !1;
  for (let o = 0; o < t.length; o++) {
    const r = t[o].trim();
    if (n === void 0 && r.match(/^\s*\|/)) {
      const a = r.match(/(\|[^\|]+)(?=\||$)/g);
      a && (n = a.length);
    } else if (typeof n == "number") {
      if (!r.match(/^\s*\|/) || o !== t.length - 1) return;
      s = !0;
    }
  }
  if (typeof n == "number" && n > 0) {
    const o = s ? t.slice(0, -1).join(`
`) : e, r = !!o.match(/\|\s*$/), a = o + (r ? "" : "|") + `
|${" --- |".repeat(n)}`;
    return Xa.lexer(a);
  }
}
var FI, eee = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, w3 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let ml = FI = class {
  constructor(i, e, t) {
    this._options = i, this._languageService = e, this._openerService = t, this._onDidRenderAsync = new F(), this.onDidRenderAsync = this._onDidRenderAsync.event;
  }
  dispose() {
    this._onDidRenderAsync.dispose();
  }
  render(i, e, t) {
    if (!i)
      return { element: document.createElement("span"), dispose: () => {
      } };
    const n = new G(), s = n.add(CL(i, { ...this._getRenderOptions(i, n), ...e }, t));
    return s.element.classList.add("rendered-markdown"), { element: s.element, dispose: () => n.dispose() };
  }
  _getRenderOptions(i, e) {
    return { codeBlockRenderer: async (t, n) => {
      var s, o, r;
      let a;
      t ? a = this._languageService.getLanguageIdByLanguageName(t) : this._options.editor && (a = (s = this._options.editor.getModel()) === null || s === void 0 ? void 0 : s.getLanguageId()), a || (a = ko);
      const l = await async function(h, c, u) {
        if (!u) return j5(c, h.languageIdCodec, K5);
        const g = await ci.getOrCreate(u);
        return j5(c, h.languageIdCodec, g || K5);
      }(this._languageService, n, a), d = document.createElement("span");
      return d.innerHTML = (r = (o = FI._ttpTokenizer) === null || o === void 0 ? void 0 : o.createHTML(l)) !== null && r !== void 0 ? r : l, this._options.editor ? yn(d, this._options.editor.getOption(50)) : this._options.codeBlockFontFamily && (d.style.fontFamily = this._options.codeBlockFontFamily), this._options.codeBlockFontSize !== void 0 && (d.style.fontSize = this._options.codeBlockFontSize), d;
    }, asyncRenderCallback: () => this._onDidRenderAsync.fire(), actionHandler: { callback: (t) => kA(this._openerService, t, i.isTrusted), disposables: e } };
  }
};
async function kA(i, e, t) {
  try {
    return await i.open(e, { fromUserGesture: !0, allowContributedOpeners: !0, allowCommands: tee(t) });
  } catch (n) {
    return We(n), !1;
  }
}
function tee(i) {
  return i === !0 || !(!i || !Array.isArray(i.enabledCommands)) && i.enabledCommands;
}
ml._ttpTokenizer = Hd("tokenizeToString", { createHTML: (i) => i }), ml = FI = eee([w3(1, Xt), w3(2, Fs)], ml);
var iee = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Uf = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const Na = Q;
let BI = class extends To {
  get _targetWindow() {
    return ke(this._target.targetElements[0]);
  }
  get _targetDocumentElement() {
    return ke(this._target.targetElements[0]).document.documentElement;
  }
  get isDisposed() {
    return this._isDisposed;
  }
  get isMouseIn() {
    return this._lockMouseTracker.isMouseIn;
  }
  get domNode() {
    return this._hover.containerDomNode;
  }
  get onDispose() {
    return this._onDispose.event;
  }
  get onRequestLayout() {
    return this._onRequestLayout.event;
  }
  get anchor() {
    return this._hoverPosition === 2 ? 0 : 1;
  }
  get x() {
    return this._x;
  }
  get y() {
    return this._y;
  }
  get isLocked() {
    return this._isLocked;
  }
  set isLocked(i) {
    this._isLocked !== i && (this._isLocked = i, this._hoverContainer.classList.toggle("locked", this._isLocked));
  }
  constructor(i, e, t, n, s, o) {
    var r, a, l, d, h, c, u, g;
    super(), this._keybindingService = e, this._configurationService = t, this._openerService = n, this._instantiationService = s, this._accessibilityService = o, this._messageListeners = new G(), this._isDisposed = !1, this._forcePosition = !1, this._x = 0, this._y = 0, this._isLocked = !1, this._enableFocusTraps = !1, this._addedFocusTrap = !1, this._onDispose = this._register(new F()), this._onRequestLayout = this._register(new F()), this._linkHandler = i.linkHandler || ((C) => kA(this._openerService, C, ha(i.content) ? i.content.isTrusted : void 0)), this._target = "targetElements" in i.target ? i.target : new nee(i.target), this._hoverPointer = !((r = i.appearance) === null || r === void 0) && r.showPointer ? Na("div.workbench-hover-pointer") : void 0, this._hover = this._register(new mA()), this._hover.containerDomNode.classList.add("workbench-hover", "fadeIn"), !((a = i.appearance) === null || a === void 0) && a.compact && this._hover.containerDomNode.classList.add("workbench-hover", "compact"), !((l = i.appearance) === null || l === void 0) && l.skipFadeInAnimation && this._hover.containerDomNode.classList.add("skip-fade-in"), i.additionalClasses && this._hover.containerDomNode.classList.add(...i.additionalClasses), !((d = i.position) === null || d === void 0) && d.forcePosition && (this._forcePosition = !0), i.trapFocus && (this._enableFocusTraps = !0), this._hoverPosition = (c = (h = i.position) === null || h === void 0 ? void 0 : h.hoverPosition) !== null && c !== void 0 ? c : 3, this.onmousedown(this._hover.containerDomNode, (C) => C.stopPropagation()), this.onkeydown(this._hover.containerDomNode, (C) => {
      C.equals(9) && this.dispose();
    }), this._register(K(this._targetWindow, "blur", () => this.dispose()));
    const p = Na("div.hover-row.markdown-hover"), f = Na("div.hover-contents");
    if (typeof i.content == "string") f.textContent = i.content, f.style.whiteSpace = "pre-wrap";
    else if (i.content instanceof HTMLElement) f.appendChild(i.content), f.classList.add("html-hover-contents");
    else {
      const C = i.content, w = this._instantiationService.createInstance(ml, { codeBlockFontFamily: this._configurationService.getValue("editor").fontFamily || Is.fontFamily }), { element: y } = w.render(C, { actionHandler: { callback: (L) => this._linkHandler(L), disposables: this._messageListeners }, asyncRenderCallback: () => {
        f.classList.add("code-hover-contents"), this.layout(), this._onRequestLayout.fire();
      } });
      f.appendChild(y);
    }
    if (p.appendChild(f), this._hover.contentsDomNode.appendChild(p), i.actions && i.actions.length > 0) {
      const C = Na("div.hover-row.status-bar"), w = Na("div.actions");
      i.actions.forEach((y) => {
        const L = this._keybindingService.lookupKeybinding(y.commandId), k = L ? L.getLabel() : null;
        vL.render(w, { label: y.label, commandId: y.commandId, run: (N) => {
          y.run(N), this.dispose();
        }, iconClass: y.iconClass }, k);
      }), C.appendChild(w), this._hover.containerDomNode.appendChild(C);
    }
    let _;
    if (this._hoverContainer = Na("div.workbench-hover-container"), this._hoverPointer && this._hoverContainer.appendChild(this._hoverPointer), this._hoverContainer.appendChild(this._hover.containerDomNode), _ = !(i.actions && i.actions.length > 0) && (((u = i.persistence) === null || u === void 0 ? void 0 : u.hideOnHover) === void 0 ? typeof i.content == "string" || ha(i.content) && !i.content.value.includes("](") && !i.content.value.includes("</a>") : i.persistence.hideOnHover), _ && ((g = i.appearance) === null || g === void 0 ? void 0 : g.showHoverHint)) {
      const C = Na("div.hover-row.status-bar"), w = Na("div.info");
      w.textContent = m(0, "Hold {0} key to mouse over", Je ? "Option" : "Alt"), C.appendChild(w), this._hover.containerDomNode.appendChild(C);
    }
    const v = [...this._target.targetElements];
    _ || v.push(this._hoverContainer);
    const b = this._register(new y3(v));
    if (this._register(b.onMouseOut(() => {
      this._isLocked || this.dispose();
    })), _) {
      const C = [...this._target.targetElements, this._hoverContainer];
      this._lockMouseTracker = this._register(new y3(C)), this._register(this._lockMouseTracker.onMouseOut(() => {
        this._isLocked || this.dispose();
      }));
    } else this._lockMouseTracker = b;
  }
  addFocusTrap() {
    if (!this._enableFocusTraps || this._addedFocusTrap) return;
    this._addedFocusTrap = !0;
    const i = this._hover.containerDomNode, e = this.findLastFocusableChild(this._hover.containerDomNode);
    if (e) {
      const t = _R(this._hoverContainer, Na("div")), n = Z(this._hoverContainer, Na("div"));
      t.tabIndex = 0, n.tabIndex = 0, this._register(K(n, "focus", (s) => {
        i.focus(), s.preventDefault();
      })), this._register(K(t, "focus", (s) => {
        e.focus(), s.preventDefault();
      }));
    }
  }
  findLastFocusableChild(i) {
    if (i.hasChildNodes()) for (let e = 0; e < i.childNodes.length; e++) {
      const t = i.childNodes.item(i.childNodes.length - e - 1);
      if (t.nodeType === t.ELEMENT_NODE) {
        const s = t;
        if (typeof s.tabIndex == "number" && s.tabIndex >= 0) return s;
      }
      const n = this.findLastFocusableChild(t);
      if (n) return n;
    }
  }
  render(i) {
    var e;
    i.appendChild(this._hoverContainer);
    const t = this._hoverContainer.contains(this._hoverContainer.ownerDocument.activeElement) && DW(this._configurationService.getValue("accessibility.verbosity.hover") === !0 && this._accessibilityService.isScreenReaderOptimized(), (e = this._keybindingService.lookupKeybinding("editor.action.accessibleView")) === null || e === void 0 ? void 0 : e.getAriaLabel());
    t && vl(t), this.layout(), this.addFocusTrap();
  }
  layout() {
    this._hover.containerDomNode.classList.remove("right-aligned"), this._hover.contentsDomNode.style.maxHeight = "";
    const i = this._target.targetElements.map((l) => ((d) => {
      const h = b8(d), c = d.getBoundingClientRect();
      return { top: c.top * h, bottom: c.bottom * h, right: c.right * h, left: c.left * h };
    })(l)), { top: e, right: t, bottom: n, left: s } = i[0], o = t - s, r = n - e, a = { top: e, right: t, bottom: n, left: s, width: o, height: r, center: { x: s + o / 2, y: e + r / 2 } };
    if (this.adjustHorizontalHoverPosition(a), this.adjustVerticalHoverPosition(a), this.adjustHoverMaxHeight(a), this._hoverContainer.style.padding = "", this._hoverContainer.style.margin = "", this._hoverPointer) {
      switch (this._hoverPosition) {
        case 1:
          a.left += 3, a.right += 3, this._hoverContainer.style.paddingLeft = "3px", this._hoverContainer.style.marginLeft = "-3px";
          break;
        case 0:
          a.left -= 3, a.right -= 3, this._hoverContainer.style.paddingRight = "3px", this._hoverContainer.style.marginRight = "-3px";
          break;
        case 2:
          a.top += 3, a.bottom += 3, this._hoverContainer.style.paddingTop = "3px", this._hoverContainer.style.marginTop = "-3px";
          break;
        case 3:
          a.top -= 3, a.bottom -= 3, this._hoverContainer.style.paddingBottom = "3px", this._hoverContainer.style.marginBottom = "-3px";
      }
      a.center.x = a.left + o / 2, a.center.y = a.top + r / 2;
    }
    this.computeXCordinate(a), this.computeYCordinate(a), this._hoverPointer && (this._hoverPointer.classList.remove("top"), this._hoverPointer.classList.remove("left"), this._hoverPointer.classList.remove("right"), this._hoverPointer.classList.remove("bottom"), this.setHoverPointerPosition(a)), this._hover.onContentsChanged();
  }
  computeXCordinate(i) {
    const e = this._hover.containerDomNode.clientWidth + 2;
    this._target.x !== void 0 ? this._x = this._target.x : this._hoverPosition === 1 ? this._x = i.right : this._hoverPosition === 0 ? this._x = i.left - e : (this._hoverPointer ? this._x = i.center.x - this._hover.containerDomNode.clientWidth / 2 : this._x = i.left, this._x + e >= this._targetDocumentElement.clientWidth && (this._hover.containerDomNode.classList.add("right-aligned"), this._x = Math.max(this._targetDocumentElement.clientWidth - e - 2, this._targetDocumentElement.clientLeft))), this._x < this._targetDocumentElement.clientLeft && (this._x = i.left + 2);
  }
  computeYCordinate(i) {
    this._target.y !== void 0 ? this._y = this._target.y : this._hoverPosition === 3 ? this._y = i.top : this._hoverPosition === 2 ? this._y = i.bottom - 2 : this._hoverPointer ? this._y = i.center.y + this._hover.containerDomNode.clientHeight / 2 : this._y = i.bottom, this._y > this._targetWindow.innerHeight && (this._y = i.bottom);
  }
  adjustHorizontalHoverPosition(i) {
    if (this._target.x !== void 0) return;
    const e = this._hoverPointer ? 3 : 0;
    if (this._forcePosition) {
      const t = e + 2;
      this._hoverPosition === 1 ? this._hover.containerDomNode.style.maxWidth = this._targetDocumentElement.clientWidth - i.right - t + "px" : this._hoverPosition === 0 && (this._hover.containerDomNode.style.maxWidth = i.left - t + "px");
    } else this._hoverPosition === 1 ? this._targetDocumentElement.clientWidth - i.right < this._hover.containerDomNode.clientWidth + e && (i.left >= this._hover.containerDomNode.clientWidth + e ? this._hoverPosition = 0 : this._hoverPosition = 2) : this._hoverPosition === 0 && (i.left < this._hover.containerDomNode.clientWidth + e && (this._targetDocumentElement.clientWidth - i.right >= this._hover.containerDomNode.clientWidth + e ? this._hoverPosition = 1 : this._hoverPosition = 2), i.left - this._hover.containerDomNode.clientWidth - e <= this._targetDocumentElement.clientLeft && (this._hoverPosition = 1));
  }
  adjustVerticalHoverPosition(i) {
    if (this._target.y !== void 0 || this._forcePosition) return;
    const e = this._hoverPointer ? 3 : 0;
    this._hoverPosition === 3 ? i.top - this._hover.containerDomNode.clientHeight - e < 0 && (this._hoverPosition = 2) : this._hoverPosition === 2 && i.bottom + this._hover.containerDomNode.clientHeight + e > this._targetWindow.innerHeight && (this._hoverPosition = 3);
  }
  adjustHoverMaxHeight(i) {
    let e = this._targetWindow.innerHeight / 2;
    if (this._forcePosition) {
      const t = 2 + (this._hoverPointer ? 3 : 0);
      this._hoverPosition === 3 ? e = Math.min(e, i.top - t) : this._hoverPosition === 2 && (e = Math.min(e, this._targetWindow.innerHeight - i.bottom - t));
    }
    if (this._hover.containerDomNode.style.maxHeight = `${e}px`, this._hover.contentsDomNode.clientHeight < this._hover.contentsDomNode.scrollHeight) {
      const t = `${this._hover.scrollbar.options.verticalScrollbarSize}px`;
      this._hover.contentsDomNode.style.paddingRight !== t && (this._hover.contentsDomNode.style.paddingRight = t);
    }
  }
  setHoverPointerPosition(i) {
    if (this._hoverPointer) switch (this._hoverPosition) {
      case 0:
      case 1: {
        this._hoverPointer.classList.add(this._hoverPosition === 0 ? "right" : "left");
        const e = this._hover.containerDomNode.clientHeight;
        e > i.height ? this._hoverPointer.style.top = i.center.y - (this._y - e) - 3 + "px" : this._hoverPointer.style.top = Math.round(e / 2) - 3 + "px";
        break;
      }
      case 3:
      case 2: {
        this._hoverPointer.classList.add(this._hoverPosition === 3 ? "bottom" : "top");
        const e = this._hover.containerDomNode.clientWidth;
        let t = Math.round(e / 2) - 3;
        const n = this._x + t;
        (n < i.left || n > i.right) && (t = i.center.x - this._x - 3), this._hoverPointer.style.left = `${t}px`;
        break;
      }
    }
  }
  focus() {
    this._hover.containerDomNode.focus();
  }
  dispose() {
    this._isDisposed || (this._onDispose.fire(), this._hoverContainer.remove(), this._messageListeners.dispose(), this._target.dispose(), super.dispose()), this._isDisposed = !0;
  }
};
BI = iee([Uf(1, Dt), Uf(2, Ye), Uf(3, Fs), Uf(4, Se), Uf(5, or)], BI);
class y3 extends To {
  get onMouseOut() {
    return this._onMouseOut.event;
  }
  get isMouseIn() {
    return this._isMouseIn;
  }
  constructor(e) {
    super(), this._elements = e, this._isMouseIn = !0, this._onMouseOut = this._register(new F()), this._elements.forEach((t) => this.onmouseover(t, () => this._onTargetMouseOver(t))), this._elements.forEach((t) => this.onmouseleave(t, () => this._onTargetMouseLeave(t)));
  }
  _onTargetMouseOver(e) {
    this._isMouseIn = !0, this._clearEvaluateMouseStateTimeout(e);
  }
  _onTargetMouseLeave(e) {
    this._isMouseIn = !1, this._evaluateMouseState(e);
  }
  _evaluateMouseState(e) {
    this._clearEvaluateMouseStateTimeout(e), this._mouseTimeout = ke(e).setTimeout(() => this._fireIfMouseOutside(), 0);
  }
  _clearEvaluateMouseStateTimeout(e) {
    this._mouseTimeout && (ke(e).clearTimeout(this._mouseTimeout), this._mouseTimeout = void 0);
  }
  _fireIfMouseOutside() {
    this._isMouseIn || this._onMouseOut.fire();
  }
}
class nee {
  constructor(e) {
    this._element = e, this.targetElements = [this._element];
  }
  dispose() {
  }
}
var Fn, Vh;
function Vp(i, e, t) {
  const n = t.mode === Vh.ALIGN ? t.offset : t.offset + t.size, s = t.mode === Vh.ALIGN ? t.offset + t.size : t.offset;
  return t.position === 0 ? e <= i - n ? n : e <= s ? s - e : Math.max(i - e, 0) : e <= s ? s - e : e <= i - n ? n : 0;
}
(function(i) {
  function e(n, s) {
    if (n.start >= s.end || s.start >= n.end) return { start: 0, end: 0 };
    const o = Math.max(n.start, s.start), r = Math.min(n.end, s.end);
    return r - o <= 0 ? { start: 0, end: 0 } : { start: o, end: r };
  }
  function t(n) {
    return n.end - n.start <= 0;
  }
  i.intersect = e, i.isEmpty = t, i.intersects = function(n, s) {
    return !t(e(n, s));
  }, i.relativeComplement = function(n, s) {
    const o = [], r = { start: n.start, end: Math.min(s.start, n.end) }, a = { start: Math.max(s.end, n.start), end: n.end };
    return t(r) || o.push(r), t(a) || o.push(a), o;
  };
})(Fn || (Fn = {})), function(i) {
  i[i.AVOID = 0] = "AVOID", i[i.ALIGN = 1] = "ALIGN";
}(Vh || (Vh = {}));
class Gm extends V {
  constructor(e, t) {
    super(), this.container = null, this.useFixedPosition = !1, this.useShadowDOM = !1, this.delegate = null, this.toDisposeOnClean = V.None, this.toDisposeOnSetContainer = V.None, this.shadowRoot = null, this.shadowRootHostElement = null, this.view = Q(".context-view"), Ts(this.view), this.setContainer(e, t), this._register(ye(() => this.setContainer(null, 1)));
  }
  setContainer(e, t) {
    var n;
    this.useFixedPosition = t !== 1;
    const s = this.useShadowDOM;
    if (this.useShadowDOM = t === 3, (e !== this.container || s !== this.useShadowDOM) && (this.container && (this.toDisposeOnSetContainer.dispose(), this.shadowRoot ? (this.shadowRoot.removeChild(this.view), this.shadowRoot = null, (n = this.shadowRootHostElement) === null || n === void 0 || n.remove(), this.shadowRootHostElement = null) : this.container.removeChild(this.view), this.container = null), e)) {
      if (this.container = e, this.useShadowDOM) {
        this.shadowRootHostElement = Q(".shadow-root-host"), this.container.appendChild(this.shadowRootHostElement), this.shadowRoot = this.shadowRootHostElement.attachShadow({ mode: "open" });
        const r = document.createElement("style");
        r.textContent = see, this.shadowRoot.appendChild(r), this.shadowRoot.appendChild(this.view), this.shadowRoot.appendChild(Q("slot"));
      } else this.container.appendChild(this.view);
      const o = new G();
      Gm.BUBBLE_UP_EVENTS.forEach((r) => {
        o.add(bi(this.container, r, (a) => {
          this.onDOMEvent(a, !1);
        }));
      }), Gm.BUBBLE_DOWN_EVENTS.forEach((r) => {
        o.add(bi(this.container, r, (a) => {
          this.onDOMEvent(a, !0);
        }, !0));
      }), this.toDisposeOnSetContainer = o;
    }
  }
  show(e) {
    var t, n, s;
    this.isVisible() && this.hide(), Un(this.view), this.view.className = "context-view", this.view.style.top = "0px", this.view.style.left = "0px", this.view.style.zIndex = `${2575 + ((t = e.layer) !== null && t !== void 0 ? t : 0)}`, this.view.style.position = this.useFixedPosition ? "fixed" : "absolute", bo(this.view), this.toDisposeOnClean = e.render(this.view) || V.None, this.delegate = e, this.doLayout(), (s = (n = this.delegate).focus) === null || s === void 0 || s.call(n);
  }
  getViewElement() {
    return this.view;
  }
  layout() {
    var e, t;
    this.isVisible() && (this.delegate.canRelayout !== !1 || ua && hR ? ((t = (e = this.delegate) === null || e === void 0 ? void 0 : e.layout) === null || t === void 0 || t.call(e), this.doLayout()) : this.hide());
  }
  doLayout() {
    if (!this.isVisible()) return;
    const e = this.delegate.getAnchor();
    let t;
    if (e instanceof HTMLElement) {
      const u = Ti(e), g = b8(e);
      t = { top: u.top * g, left: u.left * g, width: u.width * g, height: u.height * g };
    } else t = function(u) {
      const g = u;
      return !!g && typeof g.x == "number" && typeof g.y == "number";
    }(e) ? { top: e.y, left: e.x, width: e.width || 1, height: e.height || 2 } : { top: e.posy, left: e.posx, width: 2, height: 2 };
    const n = os(this.view), s = rd(this.view), o = this.delegate.anchorPosition || 0, r = this.delegate.anchorAlignment || 0, a = this.delegate.anchorAxisAlignment || 0;
    let l, d;
    const h = function() {
      var u, g;
      return (g = (u = gf().defaultView) === null || u === void 0 ? void 0 : u.window) !== null && g !== void 0 ? g : Et;
    }();
    if (a === 0) {
      const u = { offset: t.top - h.pageYOffset, size: t.height, position: o === 0 ? 0 : 1 }, g = { offset: t.left, size: t.width, position: r === 0 ? 0 : 1, mode: Vh.ALIGN };
      l = Vp(h.innerHeight, s, u) + h.pageYOffset, Fn.intersects({ start: l, end: l + s }, { start: u.offset, end: u.offset + u.size }) && (g.mode = Vh.AVOID), d = Vp(h.innerWidth, n, g);
    } else {
      const u = { offset: t.left, size: t.width, position: r === 0 ? 0 : 1 }, g = { offset: t.top, size: t.height, position: o === 0 ? 0 : 1, mode: Vh.ALIGN };
      d = Vp(h.innerWidth, n, u), Fn.intersects({ start: d, end: d + n }, { start: u.offset, end: u.offset + u.size }) && (g.mode = Vh.AVOID), l = Vp(h.innerHeight, s, g) + h.pageYOffset;
    }
    this.view.classList.remove("top", "bottom", "left", "right"), this.view.classList.add(o === 0 ? "bottom" : "top"), this.view.classList.add(r === 0 ? "left" : "right"), this.view.classList.toggle("fixed", this.useFixedPosition);
    const c = Ti(this.container);
    this.view.style.top = l - (this.useFixedPosition ? Ti(this.view).top : c.top) + "px", this.view.style.left = d - (this.useFixedPosition ? Ti(this.view).left : c.left) + "px", this.view.style.width = "initial";
  }
  hide(e) {
    const t = this.delegate;
    this.delegate = null, t != null && t.onHide && t.onHide(e), this.toDisposeOnClean.dispose(), Ts(this.view);
  }
  isVisible() {
    return !!this.delegate;
  }
  onDOMEvent(e, t) {
    this.delegate && (this.delegate.onDOMEvent ? this.delegate.onDOMEvent(e, ke(e).document.activeElement) : t && !gn(e.target, this.container) && this.hide());
  }
  dispose() {
    this.hide(), super.dispose();
  }
}
Gm.BUBBLE_UP_EVENTS = ["click", "keydown", "focus", "blur"], Gm.BUBBLE_DOWN_EVENTS = ["click"];
const see = `
	:host {
		all: initial; /* 1st rule so subsequent properties are reset. */
	}

	.codicon[class*='codicon-'] {
		font: normal normal normal 16px/1 codicon;
		display: inline-block;
		text-decoration: none;
		text-rendering: auto;
		text-align: center;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
	}

	:host {
		font-family: -apple-system, BlinkMacSystemFont, "Segoe WPC", "Segoe UI", "HelveticaNeue-Light", system-ui, "Ubuntu", "Droid Sans", sans-serif;
	}

	:host-context(.mac) { font-family: -apple-system, BlinkMacSystemFont, sans-serif; }
	:host-context(.mac:lang(zh-Hans)) { font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Hiragino Sans GB", sans-serif; }
	:host-context(.mac:lang(zh-Hant)) { font-family: -apple-system, BlinkMacSystemFont, "PingFang TC", sans-serif; }
	:host-context(.mac:lang(ja)) { font-family: -apple-system, BlinkMacSystemFont, "Hiragino Kaku Gothic Pro", sans-serif; }
	:host-context(.mac:lang(ko)) { font-family: -apple-system, BlinkMacSystemFont, "Nanum Gothic", "Apple SD Gothic Neo", "AppleGothic", sans-serif; }

	:host-context(.windows) { font-family: "Segoe WPC", "Segoe UI", sans-serif; }
	:host-context(.windows:lang(zh-Hans)) { font-family: "Segoe WPC", "Segoe UI", "Microsoft YaHei", sans-serif; }
	:host-context(.windows:lang(zh-Hant)) { font-family: "Segoe WPC", "Segoe UI", "Microsoft Jhenghei", sans-serif; }
	:host-context(.windows:lang(ja)) { font-family: "Segoe WPC", "Segoe UI", "Yu Gothic UI", "Meiryo UI", sans-serif; }
	:host-context(.windows:lang(ko)) { font-family: "Segoe WPC", "Segoe UI", "Malgun Gothic", "Dotom", sans-serif; }

	:host-context(.linux) { font-family: system-ui, "Ubuntu", "Droid Sans", sans-serif; }
	:host-context(.linux:lang(zh-Hans)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans SC", "Source Han Sans CN", "Source Han Sans", sans-serif; }
	:host-context(.linux:lang(zh-Hant)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans TC", "Source Han Sans TW", "Source Han Sans", sans-serif; }
	:host-context(.linux:lang(ja)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans J", "Source Han Sans JP", "Source Han Sans", sans-serif; }
	:host-context(.linux:lang(ko)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans K", "Source Han Sans JR", "Source Han Sans", "UnDotum", "FBaekmuk Gulim", sans-serif; }
`;
var oee = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, ree = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let Ey = class extends V {
  constructor(i) {
    super(), this.layoutService = i, this.currentViewDisposable = this._register(new rn()), this.contextView = this._register(new Gm(this.layoutService.mainContainer, 1)), this.layout(), this._register(i.onDidLayoutContainer(() => this.layout()));
  }
  showContextView(i, e, t) {
    let n;
    n = e ? e === this.layoutService.getContainer(ke(e)) ? 1 : t ? 3 : 2 : 1, this.contextView.setContainer(e ?? this.layoutService.activeContainer, n), this.contextView.show(i);
    const s = ye(() => {
      this.currentViewDisposable === s && this.hideContextView();
    });
    return this.currentViewDisposable.value = s, s;
  }
  layout() {
    this.contextView.layout();
  }
  hideContextView(i) {
    this.contextView.hide(i);
  }
};
Ey = oee([ree(0, Pc)], Ey);
class aee extends Ey {
  getContextViewElement() {
    return this.contextView.getViewElement();
  }
}
var lee = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Kf = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let WI = class extends V {
  constructor(i, e, t, n, s) {
    super(), this._instantiationService = i, this._keybindingService = t, this._layoutService = n, this._accessibilityService = s, e.onDidShowContextMenu(() => this.hideHover()), this._contextViewHandler = this._register(new Ey(this._layoutService));
  }
  showHover(i, e, t) {
    var n, s, o, r;
    if (S3(this._currentHoverOptions) === S3(i) || this._currentHover && (!((s = (n = this._currentHoverOptions) === null || n === void 0 ? void 0 : n.persistence) === null || s === void 0) && s.sticky)) return;
    this._currentHoverOptions = i, this._lastHoverOptions = i;
    const a = i.trapFocus || this._accessibilityService.isScreenReaderOptimized(), l = Mn();
    t || (this._lastFocusedElementBeforeOpen = a && l ? l : void 0);
    const d = new G(), h = this._instantiationService.createInstance(BI, i);
    if (!((o = i.persistence) === null || o === void 0) && o.sticky && (h.isLocked = !0), h.onDispose(() => {
      var c, u;
      !((c = this._currentHover) === null || c === void 0) && c.domNode && w8(this._currentHover.domNode) && ((u = this._lastFocusedElementBeforeOpen) === null || u === void 0 || u.focus()), this._currentHoverOptions === i && (this._currentHoverOptions = void 0), d.dispose();
    }), !i.container) {
      const c = i.target instanceof HTMLElement ? i.target : i.target.targetElements[0];
      i.container = this._layoutService.getContainer(ke(c));
    }
    if (this._contextViewHandler.showContextView(new dee(h, e), i.container), h.onRequestLayout(() => this._contextViewHandler.layout()), (r = i.persistence) === null || r === void 0 ? void 0 : r.sticky) d.add(K(ke(i.container).document, ie.MOUSE_DOWN, (c) => {
      gn(c.target, h.domNode) || this.doHideHover();
    }));
    else {
      if ("targetElements" in i.target) for (const u of i.target.targetElements) d.add(K(u, ie.CLICK, () => this.hideHover()));
      else d.add(K(i.target, ie.CLICK, () => this.hideHover()));
      const c = Mn();
      if (c) {
        const u = ke(c).document;
        d.add(K(c, ie.KEY_DOWN, (g) => {
          var p;
          return this._keyDown(g, h, !!(!((p = i.persistence) === null || p === void 0) && p.hideOnKeyDown));
        })), d.add(K(u, ie.KEY_DOWN, (g) => {
          var p;
          return this._keyDown(g, h, !!(!((p = i.persistence) === null || p === void 0) && p.hideOnKeyDown));
        })), d.add(K(c, ie.KEY_UP, (g) => this._keyUp(g, h))), d.add(K(u, ie.KEY_UP, (g) => this._keyUp(g, h)));
      }
    }
    if ("IntersectionObserver" in Et) {
      const c = new IntersectionObserver((g) => this._intersectionChange(g, h), { threshold: 0 }), u = "targetElements" in i.target ? i.target.targetElements[0] : i.target;
      c.observe(u), d.add(ye(() => c.disconnect()));
    }
    return this._currentHover = h, h;
  }
  hideHover() {
    var i;
    !(!((i = this._currentHover) === null || i === void 0) && i.isLocked) && this._currentHoverOptions && this.doHideHover();
  }
  doHideHover() {
    this._currentHover = void 0, this._currentHoverOptions = void 0, this._contextViewHandler.hideContextView();
  }
  _intersectionChange(i, e) {
    i[i.length - 1].isIntersecting || e.dispose();
  }
  _keyDown(i, e, t) {
    var n, s;
    if (i.key === "Alt") return void (e.isLocked = !0);
    const o = new jt(i);
    this._keybindingService.resolveKeyboardEvent(o).getSingleModifierDispatchChords().some((r) => !!r) || this._keybindingService.softDispatch(o, o.target).kind !== 0 || !t || !((n = this._currentHoverOptions) === null || n === void 0) && n.trapFocus && i.key === "Tab" || (this.hideHover(), (s = this._lastFocusedElementBeforeOpen) === null || s === void 0 || s.focus());
  }
  _keyUp(i, e) {
    var t;
    i.key === "Alt" && (e.isLocked = !1, e.isMouseIn || (this.hideHover(), (t = this._lastFocusedElementBeforeOpen) === null || t === void 0 || t.focus()));
  }
};
function S3(i) {
  var e;
  if (i !== void 0) return (e = i == null ? void 0 : i.id) !== null && e !== void 0 ? e : i;
}
WI = lee([Kf(0, Se), Kf(1, io), Kf(2, Dt), Kf(3, Pc), Kf(4, or)], WI);
class dee {
  get anchorPosition() {
    return this._hover.anchor;
  }
  constructor(e, t = !1) {
    this._hover = e, this._focus = t, this.layer = 1;
  }
  render(e) {
    return this._hover.render(e), this._focus && this._hover.focus(), this._hover;
  }
  getAnchor() {
    return { x: this._hover.x, y: this._hover.y };
  }
  layout() {
    this._hover.layout();
  }
}
rt(pA, WI, 1), rr((i, e) => {
  const t = i.getColor(cB);
  t && (e.addRule(`.monaco-workbench .workbench-hover .hover-row:not(:first-child):not(:empty) { border-top: 1px solid ${t.transparent(0.5)}; }`), e.addRule(`.monaco-workbench .workbench-hover hr { border-top: 1px solid ${t.transparent(0.5)}; }`));
});
const R1 = tt("IWorkspaceEditService");
class DA {
  constructor(e) {
    this.metadata = e;
  }
  static convert(e) {
    return e.edits.map((t) => {
      if (nc.is(t)) return nc.lift(t);
      if (mm.is(t)) return mm.lift(t);
      throw new Error("Unsupported edit");
    });
  }
}
class nc extends DA {
  static is(e) {
    return e instanceof nc || ms(e) && Ie.isUri(e.resource) && ms(e.textEdit);
  }
  static lift(e) {
    return e instanceof nc ? e : new nc(e.resource, e.textEdit, e.versionId, e.metadata);
  }
  constructor(e, t, n = void 0, s) {
    super(s), this.resource = e, this.textEdit = t, this.versionId = n;
  }
}
class mm extends DA {
  static is(e) {
    return e instanceof mm || ms(e) && (!!e.newResource || !!e.oldResource);
  }
  static lift(e) {
    return e instanceof mm ? e : new mm(e.oldResource, e.newResource, e.options, e.metadata);
  }
  constructor(e, t, n = {}, s) {
    super(s), this.oldResource = e, this.newResource = t, this.options = n;
  }
}
const An = { enableSplitViewResizing: !0, splitViewDefaultRatio: 0.5, renderSideBySide: !0, renderMarginRevertIcon: !0, renderGutterMenu: !0, maxComputationTime: 5e3, maxFileSize: 50, ignoreTrimWhitespace: !0, renderIndicators: !0, originalEditable: !1, diffCodeLens: !1, renderOverviewRuler: !0, diffWordWrap: "inherit", diffAlgorithm: "advanced", accessibilityVerbose: !1, experimental: { showMoves: !1, showEmptyDecorations: !0 }, hideUnchangedRegions: { enabled: !1, contextLineCount: 3, minimumLineCount: 3, revealLineCount: 20 }, isInEmbeddedEditor: !1, onlyShowAccessibleDiffViewer: !1, renderSideBySideInlineBreakpoint: 900, useInlineViewWhenSpaceIsLimited: !0 }, Iy = Object.freeze({ id: "editor", order: 5, type: "object", title: m(0, "Editor"), scope: 5 }), My = { ...Iy, properties: { "editor.tabSize": { type: "number", default: Wn.tabSize, minimum: 1, markdownDescription: m(0, "The number of spaces a tab is equal to. This setting is overridden based on the file contents when {0} is on.", "`#editor.detectIndentation#`") }, "editor.indentSize": { anyOf: [{ type: "string", enum: ["tabSize"] }, { type: "number", minimum: 1 }], default: "tabSize", markdownDescription: m(0, 'The number of spaces used for indentation or `"tabSize"` to use the value from `#editor.tabSize#`. This setting is overridden based on the file contents when `#editor.detectIndentation#` is on.') }, "editor.insertSpaces": { type: "boolean", default: Wn.insertSpaces, markdownDescription: m(0, "Insert spaces when pressing `Tab`. This setting is overridden based on the file contents when {0} is on.", "`#editor.detectIndentation#`") }, "editor.detectIndentation": { type: "boolean", default: Wn.detectIndentation, markdownDescription: m(0, "Controls whether {0} and {1} will be automatically detected when a file is opened based on the file contents.", "`#editor.tabSize#`", "`#editor.insertSpaces#`") }, "editor.trimAutoWhitespace": { type: "boolean", default: Wn.trimAutoWhitespace, description: m(0, "Remove trailing auto inserted whitespace.") }, "editor.largeFileOptimizations": { type: "boolean", default: Wn.largeFileOptimizations, description: m(0, "Special handling for large files to disable certain memory intensive features.") }, "editor.wordBasedSuggestions": { enum: ["off", "currentDocument", "matchingDocuments", "allDocuments"], default: "matchingDocuments", enumDescriptions: [m(0, "Turn off Word Based Suggestions."), m(0, "Only suggest words from the active document."), m(0, "Suggest words from all open documents of the same language."), m(0, "Suggest words from all open documents.")], description: m(0, "Controls whether completions should be computed based on words in the document and from which documents they are computed.") }, "editor.semanticHighlighting.enabled": { enum: [!0, !1, "configuredByTheme"], enumDescriptions: [m(0, "Semantic highlighting enabled for all color themes."), m(0, "Semantic highlighting disabled for all color themes."), m(0, "Semantic highlighting is configured by the current color theme's `semanticHighlighting` setting.")], default: "configuredByTheme", description: m(0, "Controls whether the semanticHighlighting is shown for the languages that support it.") }, "editor.stablePeek": { type: "boolean", default: !1, markdownDescription: m(0, "Keep peek editors open even when double-clicking their content or when hitting `Escape`.") }, "editor.maxTokenizationLineLength": { type: "integer", default: 2e4, description: m(0, "Lines above this length will not be tokenized for performance reasons") }, "editor.experimental.asyncTokenization": { type: "boolean", default: !1, description: m(0, "Controls whether the tokenization should happen asynchronously on a web worker."), tags: ["experimental"] }, "editor.experimental.asyncTokenizationLogging": { type: "boolean", default: !1, description: m(0, "Controls whether async tokenization should be logged. For debugging only.") }, "editor.experimental.asyncTokenizationVerification": { type: "boolean", default: !1, description: m(0, "Controls whether async tokenization should be verified against legacy background tokenization. Might slow down tokenization. For debugging only."), tags: ["experimental"] }, "editor.language.brackets": { type: ["array", "null"], default: null, description: m(0, "Defines the bracket symbols that increase or decrease the indentation."), items: { type: "array", items: [{ type: "string", description: m(0, "The opening bracket character or string sequence.") }, { type: "string", description: m(0, "The closing bracket character or string sequence.") }] } }, "editor.language.colorizedBracketPairs": { type: ["array", "null"], default: null, description: m(0, "Defines the bracket pairs that are colorized by their nesting level if bracket pair colorization is enabled."), items: { type: "array", items: [{ type: "string", description: m(0, "The opening bracket character or string sequence.") }, { type: "string", description: m(0, "The closing bracket character or string sequence.") }] } }, "diffEditor.maxComputationTime": { type: "number", default: An.maxComputationTime, description: m(0, "Timeout in milliseconds after which diff computation is cancelled. Use 0 for no timeout.") }, "diffEditor.maxFileSize": { type: "number", default: An.maxFileSize, description: m(0, "Maximum file size in MB for which to compute diffs. Use 0 for no limit.") }, "diffEditor.renderSideBySide": { type: "boolean", default: An.renderSideBySide, description: m(0, "Controls whether the diff editor shows the diff side by side or inline.") }, "diffEditor.renderSideBySideInlineBreakpoint": { type: "number", default: An.renderSideBySideInlineBreakpoint, description: m(0, "If the diff editor width is smaller than this value, the inline view is used.") }, "diffEditor.useInlineViewWhenSpaceIsLimited": { type: "boolean", default: An.useInlineViewWhenSpaceIsLimited, description: m(0, "If enabled and the editor width is too small, the inline view is used.") }, "diffEditor.renderMarginRevertIcon": { type: "boolean", default: An.renderMarginRevertIcon, description: m(0, "When enabled, the diff editor shows arrows in its glyph margin to revert changes.") }, "diffEditor.renderGutterMenu": { type: "boolean", default: An.renderGutterMenu, description: m(0, "When enabled, the diff editor shows a special gutter for revert and stage actions.") }, "diffEditor.ignoreTrimWhitespace": { type: "boolean", default: An.ignoreTrimWhitespace, description: m(0, "When enabled, the diff editor ignores changes in leading or trailing whitespace.") }, "diffEditor.renderIndicators": { type: "boolean", default: An.renderIndicators, description: m(0, "Controls whether the diff editor shows +/- indicators for added/removed changes.") }, "diffEditor.codeLens": { type: "boolean", default: An.diffCodeLens, description: m(0, "Controls whether the editor shows CodeLens.") }, "diffEditor.wordWrap": { type: "string", enum: ["off", "on", "inherit"], default: An.diffWordWrap, markdownEnumDescriptions: [m(0, "Lines will never wrap."), m(0, "Lines will wrap at the viewport width."), m(0, "Lines will wrap according to the {0} setting.", "`#editor.wordWrap#`")] }, "diffEditor.diffAlgorithm": { type: "string", enum: ["legacy", "advanced"], default: An.diffAlgorithm, markdownEnumDescriptions: [m(0, "Uses the legacy diffing algorithm."), m(0, "Uses the advanced diffing algorithm.")], tags: ["experimental"] }, "diffEditor.hideUnchangedRegions.enabled": { type: "boolean", default: An.hideUnchangedRegions.enabled, markdownDescription: m(0, "Controls whether the diff editor shows unchanged regions.") }, "diffEditor.hideUnchangedRegions.revealLineCount": { type: "integer", default: An.hideUnchangedRegions.revealLineCount, markdownDescription: m(0, "Controls how many lines are used for unchanged regions."), minimum: 1 }, "diffEditor.hideUnchangedRegions.minimumLineCount": { type: "integer", default: An.hideUnchangedRegions.minimumLineCount, markdownDescription: m(0, "Controls how many lines are used as a minimum for unchanged regions."), minimum: 1 }, "diffEditor.hideUnchangedRegions.contextLineCount": { type: "integer", default: An.hideUnchangedRegions.contextLineCount, markdownDescription: m(0, "Controls how many lines are used as context when comparing unchanged regions."), minimum: 1 }, "diffEditor.experimental.showMoves": { type: "boolean", default: An.experimental.showMoves, markdownDescription: m(0, "Controls whether the diff editor should show detected code moves.") }, "diffEditor.experimental.showEmptyDecorations": { type: "boolean", default: An.experimental.showEmptyDecorations, description: m(0, "Controls whether the diff editor shows empty decorations to see where characters got inserted or deleted.") } } };
for (const i of Lp) {
  const e = i.schema;
  if (e !== void 0) if ((L3 = e).type !== void 0 || L3.anyOf !== void 0) My.properties[`editor.${i.name}`] = e;
  else for (const t in e) Object.hasOwnProperty.call(e, t) && (My.properties[t] = e[t]);
}
var L3;
let Pb = null;
function k3() {
  return Pb === null && (Pb = /* @__PURE__ */ Object.create(null), Object.keys(My.properties).forEach((i) => {
    Pb[i] = !0;
  })), Pb;
}
li.as(fa).registerConfiguration(My);
class ii {
  static insert(e, t) {
    return { range: new D(e.lineNumber, e.column, e.lineNumber, e.column), text: t, forceMoveMarkers: !0 };
  }
  static delete(e) {
    return { range: e, text: null };
  }
  static replace(e, t) {
    return { range: e, text: t };
  }
  static replaceMove(e, t) {
    return { range: e, text: t, forceMoveMarkers: !0 };
  }
}
function Ob(i) {
  return Object.isFrozen(i) ? i : function(e) {
    if (!e || typeof e != "object") return e;
    const t = [e];
    for (; t.length > 0; ) {
      const n = t.shift();
      Object.freeze(n);
      for (const s in n) if (v7.call(n, s)) {
        const o = n[s];
        typeof o != "object" || Object.isFrozen(o) || KU(o) || t.push(o);
      }
    }
    return e;
  }(i);
}
class En {
  constructor(e = {}, t = [], n = [], s) {
    this._contents = e, this._keys = t, this._overrides = n, this.raw = s, this.overrideConfigurations = /* @__PURE__ */ new Map();
  }
  get rawConfiguration() {
    var e;
    if (!this._rawConfiguration) if (!((e = this.raw) === null || e === void 0) && e.length) {
      const t = this.raw.map((n) => {
        if (n instanceof En) return n;
        const s = new hee("");
        return s.parseRaw(n), s.configurationModel;
      });
      this._rawConfiguration = t.reduce((n, s) => s === n ? s : n.merge(s), t[0]);
    } else this._rawConfiguration = this;
    return this._rawConfiguration;
  }
  get contents() {
    return this._contents;
  }
  get overrides() {
    return this._overrides;
  }
  get keys() {
    return this._keys;
  }
  isEmpty() {
    return this._keys.length === 0 && Object.keys(this._contents).length === 0 && this._overrides.length === 0;
  }
  getValue(e) {
    return e ? UO(this.contents, e) : this.contents;
  }
  inspect(e, t) {
    const n = this;
    return { get value() {
      return Ob(n.rawConfiguration.getValue(e));
    }, get override() {
      return t ? Ob(n.rawConfiguration.getOverrideValue(e, t)) : void 0;
    }, get merged() {
      return Ob(t ? n.rawConfiguration.override(t).getValue(e) : n.rawConfiguration.getValue(e));
    }, get overrides() {
      const s = [];
      for (const { contents: o, identifiers: r, keys: a } of n.rawConfiguration.overrides) {
        const l = new En(o, a).getValue(e);
        l !== void 0 && s.push({ identifiers: r, value: l });
      }
      return s.length ? Ob(s) : void 0;
    } };
  }
  getOverrideValue(e, t) {
    const n = this.getContentsForOverrideIdentifer(t);
    return n ? e ? UO(n, e) : n : void 0;
  }
  override(e) {
    let t = this.overrideConfigurations.get(e);
    return t || (t = this.createOverrideConfigurationModel(e), this.overrideConfigurations.set(e, t)), t;
  }
  merge(...e) {
    var t, n;
    const s = Ul(this.contents), o = Ul(this.overrides), r = [...this.keys], a = !((t = this.raw) === null || t === void 0) && t.length ? [...this.raw] : [this];
    for (const l of e) if (a.push(...!((n = l.raw) === null || n === void 0) && n.length ? l.raw : [l]), !l.isEmpty()) {
      this.mergeContents(s, l.contents);
      for (const d of l.overrides) {
        const [h] = o.filter((c) => ri(c.identifiers, d.identifiers));
        h ? (this.mergeContents(h.contents, d.contents), h.keys.push(...d.keys), h.keys = Ad(h.keys)) : o.push(Ul(d));
      }
      for (const d of l.keys) r.indexOf(d) === -1 && r.push(d);
    }
    return new En(s, r, o, a.every((l) => l instanceof En) ? void 0 : a);
  }
  createOverrideConfigurationModel(e) {
    const t = this.getContentsForOverrideIdentifer(e);
    if (!t || typeof t != "object" || !Object.keys(t).length) return this;
    const n = {};
    for (const s of Ad([...Object.keys(this.contents), ...Object.keys(t)])) {
      let o = this.contents[s];
      const r = t[s];
      r && (typeof o == "object" && typeof r == "object" ? (o = Ul(o), this.mergeContents(o, r)) : o = r), n[s] = o;
    }
    return new En(n, this.keys, this.overrides);
  }
  mergeContents(e, t) {
    for (const n of Object.keys(t)) n in e && ms(e[n]) && ms(t[n]) ? this.mergeContents(e[n], t[n]) : e[n] = Ul(t[n]);
  }
  getContentsForOverrideIdentifer(e) {
    let t = null, n = null;
    const s = (o) => {
      o && (n ? this.mergeContents(n, o) : n = Ul(o));
    };
    for (const o of this.overrides) o.identifiers.length === 1 && o.identifiers[0] === e ? t = o.contents : o.identifiers.includes(e) && s(o.contents);
    return s(t), n;
  }
  toJSON() {
    return { contents: this.contents, overrides: this.overrides, keys: this.keys };
  }
  addValue(e, t) {
    this.updateValue(e, t, !0);
  }
  setValue(e, t) {
    this.updateValue(e, t, !1);
  }
  removeValue(e) {
    const t = this.keys.indexOf(e);
    t !== -1 && (this.keys.splice(t, 1), nq(this.contents, e), Sc.test(e) && this.overrides.splice(this.overrides.findIndex((n) => ri(n.identifiers, Qw(e))), 1));
  }
  updateValue(e, t, n) {
    V8(this.contents, e, t, (s) => console.error(s)), (n = n || this.keys.indexOf(e) === -1) && this.keys.push(e), Sc.test(e) && this.overrides.push({ identifiers: Qw(e), keys: Object.keys(this.contents[e]), contents: BE(this.contents[e], (s) => console.error(s)) });
  }
}
class hee {
  constructor(e) {
    this._name = e, this._raw = null, this._configurationModel = null, this._restrictedConfigurations = [];
  }
  get configurationModel() {
    return this._configurationModel || new En();
  }
  parseRaw(e, t) {
    this._raw = e;
    const { contents: n, keys: s, overrides: o, restricted: r, hasExcludedProperties: a } = this.doParseRaw(e, t);
    this._configurationModel = new En(n, s, o, a ? [e] : void 0), this._restrictedConfigurations = r || [];
  }
  doParseRaw(e, t) {
    const n = li.as(fa).getConfigurationProperties(), s = this.filter(e, n, !0, t);
    return { contents: BE(e = s.raw, (o) => console.error(`Conflict in settings file ${this._name}: ${o}`)), keys: Object.keys(e), overrides: this.toOverrides(e, (o) => console.error(`Conflict in settings file ${this._name}: ${o}`)), restricted: s.restricted, hasExcludedProperties: s.hasExcludedProperties };
  }
  filter(e, t, n, s) {
    var o, r, a;
    let l = !1;
    if (!(s != null && s.scopes) && !(s != null && s.skipRestricted) && !(!((o = s == null ? void 0 : s.exclude) === null || o === void 0) && o.length)) return { raw: e, restricted: [], hasExcludedProperties: l };
    const d = {}, h = [];
    for (const c in e) if (Sc.test(c) && n) {
      const u = this.filter(e[c], t, !1, s);
      d[c] = u.raw, l = l || u.hasExcludedProperties, h.push(...u.restricted);
    } else {
      const u = t[c], g = u ? u.scope !== void 0 ? u.scope : 3 : void 0;
      u != null && u.restricted && h.push(c), !((r = s.exclude) === null || r === void 0) && r.includes(c) || !(!((a = s.include) === null || a === void 0) && a.includes(c)) && (g !== void 0 && s.scopes !== void 0 && !s.scopes.includes(g) || s.skipRestricted && (u != null && u.restricted)) ? l = !0 : d[c] = e[c];
    }
    return { raw: d, restricted: h, hasExcludedProperties: l };
  }
  toOverrides(e, t) {
    const n = [];
    for (const s of Object.keys(e)) if (Sc.test(s)) {
      const o = {};
      for (const r in e[s]) o[r] = e[s][r];
      n.push({ identifiers: Qw(s), keys: Object.keys(o), contents: BE(o, t) });
    }
    return n;
  }
}
class cee {
  constructor(e, t, n, s, o, r, a, l, d, h, c, u, g) {
    this.key = e, this.overrides = t, this._value = n, this.overrideIdentifiers = s, this.defaultConfiguration = o, this.policyConfiguration = r, this.applicationConfiguration = a, this.userConfiguration = l, this.localUserConfiguration = d, this.remoteUserConfiguration = h, this.workspaceConfiguration = c, this.folderConfigurationModel = u, this.memoryConfigurationModel = g;
  }
  toInspectValue(e) {
    return (e == null ? void 0 : e.value) !== void 0 || (e == null ? void 0 : e.override) !== void 0 || (e == null ? void 0 : e.overrides) !== void 0 ? e : void 0;
  }
  get userInspectValue() {
    return this._userInspectValue || (this._userInspectValue = this.userConfiguration.inspect(this.key, this.overrides.overrideIdentifier)), this._userInspectValue;
  }
  get user() {
    return this.toInspectValue(this.userInspectValue);
  }
}
class wL {
  constructor(e, t, n, s, o = new En(), r = new En(), a = new Di(), l = new En(), d = new Di()) {
    this._defaultConfiguration = e, this._policyConfiguration = t, this._applicationConfiguration = n, this._localUserConfiguration = s, this._remoteUserConfiguration = o, this._workspaceConfiguration = r, this._folderConfigurations = a, this._memoryConfiguration = l, this._memoryConfigurationByResource = d, this._workspaceConsolidatedConfiguration = null, this._foldersConsolidatedConfigurations = new Di(), this._userConfiguration = null;
  }
  getValue(e, t, n) {
    return this.getConsolidatedConfigurationModel(e, t, n).getValue(e);
  }
  updateValue(e, t, n = {}) {
    let s;
    n.resource ? (s = this._memoryConfigurationByResource.get(n.resource), s || (s = new En(), this._memoryConfigurationByResource.set(n.resource, s))) : s = this._memoryConfiguration, t === void 0 ? s.removeValue(e) : s.setValue(e, t), n.resource || (this._workspaceConsolidatedConfiguration = null);
  }
  inspect(e, t, n) {
    const s = this.getConsolidatedConfigurationModel(e, t, n), o = this.getFolderConfigurationModelForResource(t.resource, n), r = t.resource && this._memoryConfigurationByResource.get(t.resource) || this._memoryConfiguration, a = /* @__PURE__ */ new Set();
    for (const l of s.overrides) for (const d of l.identifiers) s.getOverrideValue(e, d) !== void 0 && a.add(d);
    return new cee(e, t, s.getValue(e), a.size ? [...a] : void 0, this._defaultConfiguration, this._policyConfiguration.isEmpty() ? void 0 : this._policyConfiguration, this.applicationConfiguration.isEmpty() ? void 0 : this.applicationConfiguration, this.userConfiguration, this.localUserConfiguration, this.remoteUserConfiguration, n ? this._workspaceConfiguration : void 0, o || void 0, r);
  }
  get applicationConfiguration() {
    return this._applicationConfiguration;
  }
  get userConfiguration() {
    return this._userConfiguration || (this._userConfiguration = this._remoteUserConfiguration.isEmpty() ? this._localUserConfiguration : this._localUserConfiguration.merge(this._remoteUserConfiguration)), this._userConfiguration;
  }
  get localUserConfiguration() {
    return this._localUserConfiguration;
  }
  get remoteUserConfiguration() {
    return this._remoteUserConfiguration;
  }
  getConsolidatedConfigurationModel(e, t, n) {
    let s = this.getConsolidatedConfigurationModelForResource(t, n);
    return t.overrideIdentifier && (s = s.override(t.overrideIdentifier)), this._policyConfiguration.isEmpty() || this._policyConfiguration.getValue(e) === void 0 || (s = s.merge(this._policyConfiguration)), s;
  }
  getConsolidatedConfigurationModelForResource({ resource: e }, t) {
    let n = this.getWorkspaceConsolidatedConfiguration();
    if (t && e) {
      const s = t.getFolder(e);
      s && (n = this.getFolderConsolidatedConfiguration(s.uri) || n);
      const o = this._memoryConfigurationByResource.get(e);
      o && (n = n.merge(o));
    }
    return n;
  }
  getWorkspaceConsolidatedConfiguration() {
    return this._workspaceConsolidatedConfiguration || (this._workspaceConsolidatedConfiguration = this._defaultConfiguration.merge(this.applicationConfiguration, this.userConfiguration, this._workspaceConfiguration, this._memoryConfiguration)), this._workspaceConsolidatedConfiguration;
  }
  getFolderConsolidatedConfiguration(e) {
    let t = this._foldersConsolidatedConfigurations.get(e);
    if (!t) {
      const n = this.getWorkspaceConsolidatedConfiguration(), s = this._folderConfigurations.get(e);
      s ? (t = n.merge(s), this._foldersConsolidatedConfigurations.set(e, t)) : t = n;
    }
    return t;
  }
  getFolderConfigurationModelForResource(e, t) {
    if (t && e) {
      const n = t.getFolder(e);
      if (n) return this._folderConfigurations.get(n.uri);
    }
  }
  toData() {
    return { defaults: { contents: this._defaultConfiguration.contents, overrides: this._defaultConfiguration.overrides, keys: this._defaultConfiguration.keys }, policy: { contents: this._policyConfiguration.contents, overrides: this._policyConfiguration.overrides, keys: this._policyConfiguration.keys }, application: { contents: this.applicationConfiguration.contents, overrides: this.applicationConfiguration.overrides, keys: this.applicationConfiguration.keys }, user: { contents: this.userConfiguration.contents, overrides: this.userConfiguration.overrides, keys: this.userConfiguration.keys }, workspace: { contents: this._workspaceConfiguration.contents, overrides: this._workspaceConfiguration.overrides, keys: this._workspaceConfiguration.keys }, folders: [...this._folderConfigurations.keys()].reduce((e, t) => {
      const { contents: n, overrides: s, keys: o } = this._folderConfigurations.get(t);
      return e.push([t, { contents: n, overrides: s, keys: o }]), e;
    }, []) };
  }
  static parse(e) {
    const t = this.parseConfigurationModel(e.defaults), n = this.parseConfigurationModel(e.policy), s = this.parseConfigurationModel(e.application), o = this.parseConfigurationModel(e.user), r = this.parseConfigurationModel(e.workspace), a = e.folders.reduce((l, d) => (l.set(Ie.revive(d[0]), this.parseConfigurationModel(d[1])), l), new Di());
    return new wL(t, n, s, o, new En(), r, a, new En(), new Di());
  }
  static parseConfigurationModel(e) {
    return new En(e.contents, e.keys, e.overrides);
  }
}
class uee {
  constructor(e, t, n, s) {
    this.change = e, this.previous = t, this.currentConfiguraiton = n, this.currentWorkspace = s, this._marker = `
`, this._markerCode1 = this._marker.charCodeAt(0), this._markerCode2 = 46, this.affectedKeys = /* @__PURE__ */ new Set(), this._previousConfiguration = void 0;
    for (const o of e.keys) this.affectedKeys.add(o);
    for (const [, o] of e.overrides) for (const r of o) this.affectedKeys.add(r);
    this._affectsConfigStr = this._marker;
    for (const o of this.affectedKeys) this._affectsConfigStr += o + this._marker;
  }
  get previousConfiguration() {
    return !this._previousConfiguration && this.previous && (this._previousConfiguration = wL.parse(this.previous.data)), this._previousConfiguration;
  }
  affectsConfiguration(e, t) {
    var n;
    const s = this._marker + e, o = this._affectsConfigStr.indexOf(s);
    if (o < 0) return !1;
    const r = o + s.length;
    if (r >= this._affectsConfigStr.length) return !1;
    const a = this._affectsConfigStr.charCodeAt(r);
    return a !== this._markerCode1 && a !== this._markerCode2 ? !1 : t ? !So(this.previousConfiguration ? this.previousConfiguration.getValue(e, t, (n = this.previous) === null || n === void 0 ? void 0 : n.workspace) : void 0, this.currentConfiguraiton.getValue(e, t, this.currentWorkspace)) : !0;
  }
}
const Ty = { kind: 0 }, gee = { kind: 1 };
class _0 {
  constructor(e, t, n) {
    var s;
    this._log = n, this._defaultKeybindings = e, this._defaultBoundCommands = /* @__PURE__ */ new Map();
    for (const o of e) {
      const r = o.command;
      r && r.charAt(0) !== "-" && this._defaultBoundCommands.set(r, !0);
    }
    this._map = /* @__PURE__ */ new Map(), this._lookupMap = /* @__PURE__ */ new Map(), this._keybindings = _0.handleRemovals([].concat(e).concat(t));
    for (let o = 0, r = this._keybindings.length; o < r; o++) {
      const a = this._keybindings[o];
      if (a.chords.length === 0) continue;
      const l = (s = a.when) === null || s === void 0 ? void 0 : s.substituteConstants();
      l && l.type === 0 || this._addKeyPress(a.chords[0], a);
    }
  }
  static _isTargetedForRemoval(e, t, n) {
    if (t) {
      for (let s = 0; s < t.length; s++) if (t[s] !== e.chords[s]) return !1;
    }
    return !(n && n.type !== 1 && (!e.when || !function(s, o) {
      const r = s ? s.substituteConstants() : void 0, a = o ? o.substituteConstants() : void 0;
      return !r && !a || !(!r || !a) && r.equals(a);
    }(n, e.when)));
  }
  static handleRemovals(e) {
    const t = /* @__PURE__ */ new Map();
    for (let s = 0, o = e.length; s < o; s++) {
      const r = e[s];
      if (r.command && r.command.charAt(0) === "-") {
        const a = r.command.substring(1);
        t.has(a) ? t.get(a).push(r) : t.set(a, [r]);
      }
    }
    if (t.size === 0) return e;
    const n = [];
    for (let s = 0, o = e.length; s < o; s++) {
      const r = e[s];
      if (!r.command || r.command.length === 0) {
        n.push(r);
        continue;
      }
      if (r.command.charAt(0) === "-") continue;
      const a = t.get(r.command);
      if (!a || !r.isDefault) {
        n.push(r);
        continue;
      }
      let l = !1;
      for (const d of a) {
        const h = d.when;
        if (this._isTargetedForRemoval(r, d.chords, h)) {
          l = !0;
          break;
        }
      }
      l || n.push(r);
    }
    return n;
  }
  _addKeyPress(e, t) {
    const n = this._map.get(e);
    if (n === void 0) return this._map.set(e, [t]), void this._addToLookupMap(t);
    for (let s = n.length - 1; s >= 0; s--) {
      const o = n[s];
      if (o.command === t.command) continue;
      let r = !0;
      for (let a = 1; a < o.chords.length && a < t.chords.length; a++) if (o.chords[a] !== t.chords[a]) {
        r = !1;
        break;
      }
      r && _0.whenIsEntirelyIncluded(o.when, t.when) && this._removeFromLookupMap(o);
    }
    n.push(t), this._addToLookupMap(t);
  }
  _addToLookupMap(e) {
    if (!e.command) return;
    let t = this._lookupMap.get(e.command);
    t === void 0 ? (t = [e], this._lookupMap.set(e.command, t)) : t.push(e);
  }
  _removeFromLookupMap(e) {
    if (!e.command) return;
    const t = this._lookupMap.get(e.command);
    if (t !== void 0) {
      for (let n = 0, s = t.length; n < s; n++) if (t[n] === e) return void t.splice(n, 1);
    }
  }
  static whenIsEntirelyIncluded(e, t) {
    return !t || t.type === 1 || !(!e || e.type === 1) && PE(e, t);
  }
  getKeybindings() {
    return this._keybindings;
  }
  lookupPrimaryKeybinding(e, t) {
    const n = this._lookupMap.get(e);
    if (n === void 0 || n.length === 0) return null;
    if (n.length === 1) return n[0];
    for (let s = n.length - 1; s >= 0; s--) {
      const o = n[s];
      if (t.contextMatchesRules(o.when)) return o;
    }
    return n[n.length - 1];
  }
  resolve(e, t, n) {
    const s = [...t, n];
    this._log(`| Resolving ${s}`);
    const o = this._map.get(s[0]);
    if (o === void 0) return this._log("\\ No keybinding entries."), Ty;
    let r = null;
    if (s.length < 2) r = o;
    else {
      r = [];
      for (let c = 0, u = o.length; c < u; c++) {
        const g = o[c];
        if (s.length > g.chords.length) continue;
        let p = !0;
        for (let f = 1; f < s.length; f++) if (g.chords[f] !== s[f]) {
          p = !1;
          break;
        }
        p && r.push(g);
      }
    }
    const a = this._findCommand(e, r);
    return a ? s.length < a.chords.length ? (this._log(`\\ From ${r.length} keybinding entries, awaiting ${a.chords.length - s.length} more chord(s), when: ${D3(a.when)}, source: ${x3(a)}.`), gee) : (this._log(`\\ From ${r.length} keybinding entries, matched ${a.command}, when: ${D3(a.when)}, source: ${x3(a)}.`), l = a.command, d = a.commandArgs, h = a.bubble, { kind: 2, commandId: l, commandArgs: d, isBubble: h }) : (this._log(`\\ From ${r.length} keybinding entries, no when clauses matched the context.`), Ty);
    var l, d, h;
  }
  _findCommand(e, t) {
    for (let n = t.length - 1; n >= 0; n--) {
      const s = t[n];
      if (_0._contextMatchesRules(e, s.when)) return s;
    }
    return null;
  }
  static _contextMatchesRules(e, t) {
    return !t || t.evaluate(e);
  }
}
function D3(i) {
  return i ? `${i.serialize()}` : "no when condition";
}
function x3(i) {
  return i.extensionId ? i.isBuiltinExtension ? `built-in extension ${i.extensionId}` : `user extension ${i.extensionId}` : i.isDefault ? "built-in" : "user";
}
const pee = /^(cursor|delete|undo|redo|tab|editor\.action\.clipboard)/;
class mee extends V {
  get onDidUpdateKeybindings() {
    return this._onDidUpdateKeybindings ? this._onDidUpdateKeybindings.event : se.None;
  }
  get inChordMode() {
    return this._currentChords.length > 0;
  }
  constructor(e, t, n, s, o) {
    super(), this._contextKeyService = e, this._commandService = t, this._telemetryService = n, this._notificationService = s, this._logService = o, this._onDidUpdateKeybindings = this._register(new F()), this._currentChords = [], this._currentChordChecker = new uR(), this._currentChordStatusMessage = null, this._ignoreSingleModifiers = Hp.EMPTY, this._currentSingleModifier = null, this._currentSingleModifierClearTimeout = new Dr(), this._currentlyDispatchingCommandId = null, this._logging = !1;
  }
  dispose() {
    super.dispose();
  }
  _log(e) {
    this._logging && this._logService.info(`[KeybindingService]: ${e}`);
  }
  getKeybindings() {
    return this._getResolver().getKeybindings();
  }
  lookupKeybinding(e, t) {
    const n = this._getResolver().lookupPrimaryKeybinding(e, t || this._contextKeyService);
    if (n) return n.resolvedKeybinding;
  }
  dispatchEvent(e, t) {
    return this._dispatch(e, t);
  }
  softDispatch(e, t) {
    this._log("/ Soft dispatching keyboard event");
    const n = this.resolveKeyboardEvent(e);
    if (n.hasMultipleChords()) return console.warn("keyboard event should not be mapped to multiple chords"), Ty;
    const [s] = n.getDispatchChords();
    if (s === null) return this._log("\\ Keyboard event cannot be dispatched"), Ty;
    const o = this._contextKeyService.getContext(t), r = this._currentChords.map(({ keypress: a }) => a);
    return this._getResolver().resolve(o, r, s);
  }
  _scheduleLeaveChordMode() {
    const e = Date.now();
    this._currentChordChecker.cancelAndSet(() => {
      this._documentHasFocus() ? Date.now() - e > 5e3 && this._leaveChordMode() : this._leaveChordMode();
    }, 500);
  }
  _expectAnotherChord(e, t) {
    switch (this._currentChords.push({ keypress: e, label: t }), this._currentChords.length) {
      case 0:
        throw YT("impossible");
      case 1:
        this._currentChordStatusMessage = this._notificationService.status(m(0, "({0}) was pressed. Waiting for second key of chord...", t));
        break;
      default: {
        const n = this._currentChords.map(({ label: s }) => s).join(", ");
        this._currentChordStatusMessage = this._notificationService.status(m(0, "({0}) was pressed. Waiting for next key of chord...", n));
      }
    }
    this._scheduleLeaveChordMode(), i0.enabled && i0.disable();
  }
  _leaveChordMode() {
    this._currentChordStatusMessage && (this._currentChordStatusMessage.dispose(), this._currentChordStatusMessage = null), this._currentChordChecker.cancel(), this._currentChords = [], i0.enable();
  }
  _dispatch(e, t) {
    return this._doDispatch(this.resolveKeyboardEvent(e), t, !1);
  }
  _singleModifierDispatch(e, t) {
    const n = this.resolveKeyboardEvent(e), [s] = n.getSingleModifierDispatchChords();
    if (s) return this._ignoreSingleModifiers.has(s) ? (this._log(`+ Ignoring single modifier ${s} due to it being pressed together with other keys.`), this._ignoreSingleModifiers = Hp.EMPTY, this._currentSingleModifierClearTimeout.cancel(), this._currentSingleModifier = null, !1) : (this._ignoreSingleModifiers = Hp.EMPTY, this._currentSingleModifier === null ? (this._log(`+ Storing single modifier for possible chord ${s}.`), this._currentSingleModifier = s, this._currentSingleModifierClearTimeout.cancelAndSet(() => {
      this._log("+ Clearing single modifier due to 300ms elapsed."), this._currentSingleModifier = null;
    }, 300), !1) : s === this._currentSingleModifier ? (this._log(`/ Dispatching single modifier chord ${s} ${s}`), this._currentSingleModifierClearTimeout.cancel(), this._currentSingleModifier = null, this._doDispatch(n, t, !0)) : (this._log(`+ Clearing single modifier due to modifier mismatch: ${this._currentSingleModifier} ${s}`), this._currentSingleModifierClearTimeout.cancel(), this._currentSingleModifier = null, !1));
    const [o] = n.getChords();
    return this._ignoreSingleModifiers = new Hp(o), this._currentSingleModifier !== null && this._log("+ Clearing single modifier due to other key up."), this._currentSingleModifierClearTimeout.cancel(), this._currentSingleModifier = null, !1;
  }
  _doDispatch(e, t, n = !1) {
    var s;
    let o = !1;
    if (e.hasMultipleChords()) return console.warn("Unexpected keyboard event mapped to multiple chords"), !1;
    let r = null, a = null;
    if (n) {
      const [c] = e.getSingleModifierDispatchChords();
      r = c, a = c ? [c] : [];
    } else [r] = e.getDispatchChords(), a = this._currentChords.map(({ keypress: c }) => c);
    if (r === null) return this._log("\\ Keyboard event cannot be dispatched in keydown phase."), o;
    const l = this._contextKeyService.getContext(t), d = e.getLabel(), h = this._getResolver().resolve(l, a, r);
    switch (h.kind) {
      case 0:
        if (this._logService.trace("KeybindingService#dispatch", d, "[ No matching keybinding ]"), this.inChordMode) {
          const c = this._currentChords.map(({ label: u }) => u).join(", ");
          this._log(`+ Leaving multi-chord mode: Nothing bound to "${c}, ${d}".`), this._notificationService.status(m(0, "The key combination ({0}, {1}) is not a command.", c, d), { hideAfter: 1e4 }), this._leaveChordMode(), o = !0;
        }
        return o;
      case 1:
        return this._logService.trace("KeybindingService#dispatch", d, "[ Several keybindings match - more chords needed ]"), o = !0, this._expectAnotherChord(r, d), this._log(this._currentChords.length === 1 ? "+ Entering multi-chord mode..." : "+ Continuing multi-chord mode..."), o;
      case 2:
        if (this._logService.trace("KeybindingService#dispatch", d, `[ Will dispatch command ${h.commandId} ]`), h.commandId === null || h.commandId === "") {
          if (this.inChordMode) {
            const c = this._currentChords.map(({ label: u }) => u).join(", ");
            this._log(`+ Leaving chord mode: Nothing bound to "${c}, ${d}".`), this._notificationService.status(m(0, "The key combination ({0}, {1}) is not a command.", c, d), { hideAfter: 1e4 }), this._leaveChordMode(), o = !0;
          }
        } else {
          this.inChordMode && this._leaveChordMode(), h.isBubble || (o = !0), this._log(`+ Invoking command ${h.commandId}.`), this._currentlyDispatchingCommandId = h.commandId;
          try {
            h.commandArgs === void 0 ? this._commandService.executeCommand(h.commandId).then(void 0, (c) => this._notificationService.warn(c)) : this._commandService.executeCommand(h.commandId, h.commandArgs).then(void 0, (c) => this._notificationService.warn(c));
          } finally {
            this._currentlyDispatchingCommandId = null;
          }
          pee.test(h.commandId) || this._telemetryService.publicLog2("workbenchActionExecuted", { id: h.commandId, from: "keybinding", detail: (s = e.getUserSettingsLabel()) !== null && s !== void 0 ? s : void 0 });
        }
        return o;
    }
  }
  mightProducePrintableCharacter(e) {
    return !e.ctrlKey && !e.metaKey && (e.keyCode >= 31 && e.keyCode <= 56 || e.keyCode >= 21 && e.keyCode <= 30);
  }
}
class Hp {
  constructor(e) {
    this._ctrlKey = !!e && e.ctrlKey, this._shiftKey = !!e && e.shiftKey, this._altKey = !!e && e.altKey, this._metaKey = !!e && e.metaKey;
  }
  has(e) {
    switch (e) {
      case "ctrl":
        return this._ctrlKey;
      case "shift":
        return this._shiftKey;
      case "alt":
        return this._altKey;
      case "meta":
        return this._metaKey;
    }
  }
}
Hp.EMPTY = new Hp(null);
class N3 {
  constructor(e, t, n, s, o, r, a) {
    this._resolvedKeybindingItemBrand = void 0, this.resolvedKeybinding = e, this.chords = e ? VI(e.getDispatchChords()) : [], e && this.chords.length === 0 && (this.chords = VI(e.getSingleModifierDispatchChords())), this.bubble = !!t && t.charCodeAt(0) === 94, this.command = this.bubble ? t.substr(1) : t, this.commandArgs = n, this.when = s, this.isDefault = o, this.extensionId = r, this.isBuiltinExtension = a;
  }
}
function VI(i) {
  const e = [];
  for (let t = 0, n = i.length; t < n; t++) {
    const s = i[t];
    if (!s) return [];
    e.push(s);
  }
  return e;
}
class yL {
  constructor(e, t, n = t) {
    this.modifierLabels = [null], this.modifierLabels[2] = e, this.modifierLabels[1] = t, this.modifierLabels[3] = n;
  }
  toLabel(e, t, n) {
    if (t.length === 0) return null;
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o], l = n(a);
      if (l === null) return null;
      s[o] = bee(a, l, this.modifierLabels[e]);
    }
    return s.join(" ");
  }
}
const xA = new yL({ ctrlKey: "⌃", shiftKey: "⇧", altKey: "⌥", metaKey: "⌘", separator: "" }, { ctrlKey: m(0, "Ctrl"), shiftKey: m(0, "Shift"), altKey: m(0, "Alt"), metaKey: m(0, "Windows"), separator: "+" }, { ctrlKey: m(0, "Ctrl"), shiftKey: m(0, "Shift"), altKey: m(0, "Alt"), metaKey: m(0, "Super"), separator: "+" }), fee = new yL({ ctrlKey: m(0, "Control"), shiftKey: m(0, "Shift"), altKey: m(0, "Option"), metaKey: m(0, "Command"), separator: "+" }, { ctrlKey: m(0, "Control"), shiftKey: m(0, "Shift"), altKey: m(0, "Alt"), metaKey: m(0, "Windows"), separator: "+" }, { ctrlKey: m(0, "Control"), shiftKey: m(0, "Shift"), altKey: m(0, "Alt"), metaKey: m(0, "Super"), separator: "+" }), _ee = new yL({ ctrlKey: "Ctrl", shiftKey: "Shift", altKey: "Alt", metaKey: "Cmd", separator: "+" }, { ctrlKey: "Ctrl", shiftKey: "Shift", altKey: "Alt", metaKey: "Super", separator: "+" }), vee = new yL({ ctrlKey: "ctrl", shiftKey: "shift", altKey: "alt", metaKey: "cmd", separator: "+" }, { ctrlKey: "ctrl", shiftKey: "shift", altKey: "alt", metaKey: "win", separator: "+" }, { ctrlKey: "ctrl", shiftKey: "shift", altKey: "alt", metaKey: "meta", separator: "+" });
function bee(i, e, t) {
  if (e === null) return "";
  const n = [];
  return i.ctrlKey && n.push(t.ctrlKey), i.shiftKey && n.push(t.shiftKey), i.altKey && n.push(t.altKey), i.metaKey && n.push(t.metaKey), e !== "" && n.push(e), n.join(t.separator);
}
class Cee extends RK {
  constructor(e, t) {
    if (super(), t.length === 0) throw Yo("chords");
    this._os = e, this._chords = t;
  }
  getLabel() {
    return xA.toLabel(this._os, this._chords, (e) => this._getLabel(e));
  }
  getAriaLabel() {
    return fee.toLabel(this._os, this._chords, (e) => this._getAriaLabel(e));
  }
  getElectronAccelerator() {
    return this._chords.length > 1 || this._chords[0].isDuplicateModifierCase() ? null : _ee.toLabel(this._os, this._chords, (e) => this._getElectronAccelerator(e));
  }
  getUserSettingsLabel() {
    return vee.toLabel(this._os, this._chords, (e) => this._getUserSettingsLabel(e));
  }
  hasMultipleChords() {
    return this._chords.length > 1;
  }
  getChords() {
    return this._chords.map((e) => this._getChord(e));
  }
  _getChord(e) {
    return new TK(e.ctrlKey, e.shiftKey, e.altKey, e.metaKey, this._getLabel(e), this._getAriaLabel(e));
  }
  getDispatchChords() {
    return this._chords.map((e) => this._getChordDispatch(e));
  }
  getSingleModifierDispatchChords() {
    return this._chords.map((e) => this._getSingleModifierChordDispatch(e));
  }
}
class Nv extends Cee {
  constructor(e, t) {
    super(t, e);
  }
  _keyCodeToUILabel(e) {
    if (this._os === 2) switch (e) {
      case 15:
        return "←";
      case 16:
        return "↑";
      case 17:
        return "→";
      case 18:
        return "↓";
    }
    return Yl.toString(e);
  }
  _getLabel(e) {
    return e.isDuplicateModifierCase() ? "" : this._keyCodeToUILabel(e.keyCode);
  }
  _getAriaLabel(e) {
    return e.isDuplicateModifierCase() ? "" : Yl.toString(e.keyCode);
  }
  _getElectronAccelerator(e) {
    return Yl.toElectronAccelerator(e.keyCode);
  }
  _getUserSettingsLabel(e) {
    if (e.isDuplicateModifierCase()) return "";
    const t = Yl.toUserSettingsUS(e.keyCode);
    return t && t.toLowerCase();
  }
  _getChordDispatch(e) {
    return Nv.getDispatchStr(e);
  }
  static getDispatchStr(e) {
    if (e.isModifierKey()) return null;
    let t = "";
    return e.ctrlKey && (t += "ctrl+"), e.shiftKey && (t += "shift+"), e.altKey && (t += "alt+"), e.metaKey && (t += "meta+"), t += Yl.toString(e.keyCode), t;
  }
  _getSingleModifierChordDispatch(e) {
    return e.keyCode !== 5 || e.shiftKey || e.altKey || e.metaKey ? e.keyCode !== 4 || e.ctrlKey || e.altKey || e.metaKey ? e.keyCode !== 6 || e.ctrlKey || e.shiftKey || e.metaKey ? e.keyCode !== 57 || e.ctrlKey || e.shiftKey || e.altKey ? null : "meta" : "alt" : "shift" : "ctrl";
  }
  static _scanCodeToKeyCode(e) {
    const t = iR[e];
    if (t !== -1) return t;
    switch (e) {
      case 10:
        return 31;
      case 11:
        return 32;
      case 12:
        return 33;
      case 13:
        return 34;
      case 14:
        return 35;
      case 15:
        return 36;
      case 16:
        return 37;
      case 17:
        return 38;
      case 18:
        return 39;
      case 19:
        return 40;
      case 20:
        return 41;
      case 21:
        return 42;
      case 22:
        return 43;
      case 23:
        return 44;
      case 24:
        return 45;
      case 25:
        return 46;
      case 26:
        return 47;
      case 27:
        return 48;
      case 28:
        return 49;
      case 29:
        return 50;
      case 30:
        return 51;
      case 31:
        return 52;
      case 32:
        return 53;
      case 33:
        return 54;
      case 34:
        return 55;
      case 35:
        return 56;
      case 36:
        return 22;
      case 37:
        return 23;
      case 38:
        return 24;
      case 39:
        return 25;
      case 40:
        return 26;
      case 41:
        return 27;
      case 42:
        return 28;
      case 43:
        return 29;
      case 44:
        return 30;
      case 45:
        return 21;
      case 51:
        return 88;
      case 52:
        return 86;
      case 53:
        return 92;
      case 54:
        return 94;
      case 55:
        return 93;
      case 56:
        return 0;
      case 57:
        return 85;
      case 58:
        return 95;
      case 59:
        return 91;
      case 60:
        return 87;
      case 61:
        return 89;
      case 62:
        return 90;
      case 106:
        return 97;
    }
    return 0;
  }
  static _toKeyCodeChord(e) {
    if (!e) return null;
    if (e instanceof Od) return e;
    const t = this._scanCodeToKeyCode(e.scanCode);
    return t === 0 ? null : new Od(e.ctrlKey, e.shiftKey, e.altKey, e.metaKey, t);
  }
  static resolveKeybinding(e, t) {
    const n = VI(e.chords.map((s) => this._toKeyCodeChord(s)));
    return n.length > 0 ? [new Nv(n, t)] : [];
  }
}
const Zm = tt("labelService"), BW = tt("progressService");
class Nd {
  constructor(e) {
    this.callback = e;
  }
  report(e) {
    this._value = e, this.callback(this._value);
  }
}
Nd.None = Object.freeze({ report() {
} });
const Ec = tt("editorProgressService");
class wee {
  constructor() {
    this._value = "", this._pos = 0;
  }
  reset(e) {
    return this._value = e, this._pos = 0, this;
  }
  next() {
    return this._pos += 1, this;
  }
  hasNext() {
    return this._pos < this._value.length - 1;
  }
  cmp(e) {
    return e.charCodeAt(0) - this._value.charCodeAt(this._pos);
  }
  value() {
    return this._value[this._pos];
  }
}
class yee {
  constructor(e = !0) {
    this._caseSensitive = e;
  }
  reset(e) {
    return this._value = e, this._from = 0, this._to = 0, this.next();
  }
  hasNext() {
    return this._to < this._value.length;
  }
  next() {
    this._from = this._to;
    let e = !0;
    for (; this._to < this._value.length; this._to++)
      if (this._value.charCodeAt(this._to) === 46) {
        if (!e) break;
        this._from++;
      } else e = !1;
    return this;
  }
  cmp(e) {
    return this._caseSensitive ? sR(e, this._value, 0, e.length, this._from, this._to) : m1(e, this._value, 0, e.length, this._from, this._to);
  }
  value() {
    return this._value.substring(this._from, this._to);
  }
}
class See {
  constructor(e = !0, t = !0) {
    this._splitOnBackslash = e, this._caseSensitive = t;
  }
  reset(e) {
    this._from = 0, this._to = 0, this._value = e, this._valueLen = e.length;
    for (let t = e.length - 1; t >= 0; t--, this._valueLen--) {
      const n = this._value.charCodeAt(t);
      if (!(n === 47 || this._splitOnBackslash && n === 92)) break;
    }
    return this.next();
  }
  hasNext() {
    return this._to < this._valueLen;
  }
  next() {
    this._from = this._to;
    let e = !0;
    for (; this._to < this._valueLen; this._to++) {
      const t = this._value.charCodeAt(this._to);
      if (t === 47 || this._splitOnBackslash && t === 92) {
        if (!e) break;
        this._from++;
      } else e = !1;
    }
    return this;
  }
  cmp(e) {
    return this._caseSensitive ? sR(e, this._value, 0, e.length, this._from, this._to) : m1(e, this._value, 0, e.length, this._from, this._to);
  }
  value() {
    return this._value.substring(this._from, this._to);
  }
}
class Lee {
  constructor(e, t) {
    this._ignorePathCasing = e, this._ignoreQueryAndFragment = t, this._states = [], this._stateIdx = 0;
  }
  reset(e) {
    return this._value = e, this._states = [], this._value.scheme && this._states.push(1), this._value.authority && this._states.push(2), this._value.path && (this._pathIterator = new See(!1, !this._ignorePathCasing(e)), this._pathIterator.reset(e.path), this._pathIterator.value() && this._states.push(3)), this._ignoreQueryAndFragment(e) || (this._value.query && this._states.push(4), this._value.fragment && this._states.push(5)), this._stateIdx = 0, this;
  }
  next() {
    return this._states[this._stateIdx] === 3 && this._pathIterator.hasNext() ? this._pathIterator.next() : this._stateIdx += 1, this;
  }
  hasNext() {
    return this._states[this._stateIdx] === 3 && this._pathIterator.hasNext() || this._stateIdx < this._states.length - 1;
  }
  cmp(e) {
    if (this._states[this._stateIdx] === 1) return SE(e, this._value.scheme);
    if (this._states[this._stateIdx] === 2) return SE(e, this._value.authority);
    if (this._states[this._stateIdx] === 3) return this._pathIterator.cmp(e);
    if (this._states[this._stateIdx] === 4) return Q0(e, this._value.query);
    if (this._states[this._stateIdx] === 5) return Q0(e, this._value.fragment);
    throw new Error();
  }
  value() {
    if (this._states[this._stateIdx] === 1) return this._value.scheme;
    if (this._states[this._stateIdx] === 2) return this._value.authority;
    if (this._states[this._stateIdx] === 3) return this._pathIterator.value();
    if (this._states[this._stateIdx] === 4) return this._value.query;
    if (this._states[this._stateIdx] === 5) return this._value.fragment;
    throw new Error();
  }
}
class Fb {
  constructor() {
    this.height = 1;
  }
  rotateLeft() {
    const e = this.right;
    return this.right = e.left, e.left = this, this.updateHeight(), e.updateHeight(), e;
  }
  rotateRight() {
    const e = this.left;
    return this.left = e.right, e.right = this, this.updateHeight(), e.updateHeight(), e;
  }
  updateHeight() {
    this.height = 1 + Math.max(this.heightLeft, this.heightRight);
  }
  balanceFactor() {
    return this.heightRight - this.heightLeft;
  }
  get heightLeft() {
    var e, t;
    return (t = (e = this.left) === null || e === void 0 ? void 0 : e.height) !== null && t !== void 0 ? t : 0;
  }
  get heightRight() {
    var e, t;
    return (t = (e = this.right) === null || e === void 0 ? void 0 : e.height) !== null && t !== void 0 ? t : 0;
  }
}
class fm {
  static forUris(e = () => !1, t = () => !1) {
    return new fm(new Lee(e, t));
  }
  static forStrings() {
    return new fm(new wee());
  }
  static forConfigKeys() {
    return new fm(new yee());
  }
  constructor(e) {
    this._iter = e;
  }
  clear() {
    this._root = void 0;
  }
  set(e, t) {
    const n = this._iter.reset(e);
    let s;
    this._root || (this._root = new Fb(), this._root.segment = n.value());
    const o = [];
    for (s = this._root; ; ) {
      const a = n.cmp(s.segment);
      if (a > 0) s.left || (s.left = new Fb(), s.left.segment = n.value()), o.push([-1, s]), s = s.left;
      else if (a < 0) s.right || (s.right = new Fb(), s.right.segment = n.value()), o.push([1, s]), s = s.right;
      else {
        if (!n.hasNext()) break;
        n.next(), s.mid || (s.mid = new Fb(), s.mid.segment = n.value()), o.push([0, s]), s = s.mid;
      }
    }
    const r = s.value;
    s.value = t, s.key = e;
    for (let a = o.length - 1; a >= 0; a--) {
      const l = o[a][1];
      l.updateHeight();
      const d = l.balanceFactor();
      if (d < -1 || d > 1) {
        const h = o[a][0], c = o[a + 1][0];
        if (h === 1 && c === 1) o[a][1] = l.rotateLeft();
        else if (h === -1 && c === -1) o[a][1] = l.rotateRight();
        else if (h === 1 && c === -1) l.right = o[a + 1][1] = o[a + 1][1].rotateRight(), o[a][1] = l.rotateLeft();
        else {
          if (h !== -1 || c !== 1) throw new Error();
          l.left = o[a + 1][1] = o[a + 1][1].rotateLeft(), o[a][1] = l.rotateRight();
        }
        if (a > 0) switch (o[a - 1][0]) {
          case -1:
            o[a - 1][1].left = o[a][1];
            break;
          case 1:
            o[a - 1][1].right = o[a][1];
            break;
          case 0:
            o[a - 1][1].mid = o[a][1];
        }
        else this._root = o[0][1];
      }
    }
    return r;
  }
  get(e) {
    var t;
    return (t = this._getNode(e)) === null || t === void 0 ? void 0 : t.value;
  }
  _getNode(e) {
    const t = this._iter.reset(e);
    let n = this._root;
    for (; n; ) {
      const s = t.cmp(n.segment);
      if (s > 0) n = n.left;
      else if (s < 0) n = n.right;
      else {
        if (!t.hasNext()) break;
        t.next(), n = n.mid;
      }
    }
    return n;
  }
  has(e) {
    const t = this._getNode(e);
    return !((t == null ? void 0 : t.value) === void 0 && (t == null ? void 0 : t.mid) === void 0);
  }
  delete(e) {
    return this._delete(e, !1);
  }
  deleteSuperstr(e) {
    return this._delete(e, !0);
  }
  _delete(e, t) {
    var n;
    const s = this._iter.reset(e), o = [];
    let r = this._root;
    for (; r; ) {
      const a = s.cmp(r.segment);
      if (a > 0) o.push([-1, r]), r = r.left;
      else if (a < 0) o.push([1, r]), r = r.right;
      else {
        if (!s.hasNext()) break;
        s.next(), o.push([0, r]), r = r.mid;
      }
    }
    if (r) {
      if (t ? (r.left = void 0, r.mid = void 0, r.right = void 0, r.height = 1) : (r.key = void 0, r.value = void 0), !r.mid && !r.value) if (r.left && r.right) {
        const a = this._min(r.right);
        if (a.key) {
          const { key: l, value: d, segment: h } = a;
          this._delete(a.key, !1), r.key = l, r.value = d, r.segment = h;
        }
      } else {
        const a = (n = r.left) !== null && n !== void 0 ? n : r.right;
        if (o.length > 0) {
          const [l, d] = o[o.length - 1];
          switch (l) {
            case -1:
              d.left = a;
              break;
            case 0:
              d.mid = a;
              break;
            case 1:
              d.right = a;
          }
        } else this._root = a;
      }
      for (let a = o.length - 1; a >= 0; a--) {
        const l = o[a][1];
        l.updateHeight();
        const d = l.balanceFactor();
        if (d > 1 ? (l.right.balanceFactor() >= 0 || (l.right = l.right.rotateRight()), o[a][1] = l.rotateLeft()) : d < -1 && (l.left.balanceFactor() <= 0 || (l.left = l.left.rotateLeft()), o[a][1] = l.rotateRight()), a > 0) switch (o[a - 1][0]) {
          case -1:
            o[a - 1][1].left = o[a][1];
            break;
          case 1:
            o[a - 1][1].right = o[a][1];
            break;
          case 0:
            o[a - 1][1].mid = o[a][1];
        }
        else this._root = o[0][1];
      }
    }
  }
  _min(e) {
    for (; e.left; ) e = e.left;
    return e;
  }
  findSubstr(e) {
    const t = this._iter.reset(e);
    let n, s = this._root;
    for (; s; ) {
      const o = t.cmp(s.segment);
      if (o > 0) s = s.left;
      else if (o < 0) s = s.right;
      else {
        if (!t.hasNext()) break;
        t.next(), n = s.value || n, s = s.mid;
      }
    }
    return s && s.value || n;
  }
  findSuperstr(e) {
    return this._findSuperstrOrElement(e, !1);
  }
  _findSuperstrOrElement(e, t) {
    const n = this._iter.reset(e);
    let s = this._root;
    for (; s; ) {
      const o = n.cmp(s.segment);
      if (o > 0) s = s.left;
      else if (o < 0) s = s.right;
      else {
        if (!n.hasNext()) return s.mid ? this._entries(s.mid) : t ? s.value : void 0;
        n.next(), s = s.mid;
      }
    }
  }
  forEach(e) {
    for (const [t, n] of this) e(n, t);
  }
  *[Symbol.iterator]() {
    yield* this._entries(this._root);
  }
  _entries(e) {
    const t = [];
    return this._dfsEntries(e, t), t[Symbol.iterator]();
  }
  _dfsEntries(e, t) {
    e && (e.left && this._dfsEntries(e.left, t), e.value && t.push([e.key, e.value]), e.mid && this._dfsEntries(e.mid, t), e.right && this._dfsEntries(e.right, t));
  }
}
const mg = tt("contextService");
function HI(i) {
  const e = i;
  return typeof (e == null ? void 0 : e.id) == "string" && Ie.isUri(e.uri);
}
function kee(i) {
  const e = i;
  return typeof (e == null ? void 0 : e.id) == "string" && !HI(i) && !function(t) {
    const n = t;
    return typeof (n == null ? void 0 : n.id) == "string" && Ie.isUri(n.configPath);
  }(i);
}
const Dee = { id: "empty-window" };
class xee {
  constructor(e, t) {
    this.raw = t, this.uri = e.uri, this.index = e.index, this.name = e.name;
  }
  toJSON() {
    return { uri: this.uri, name: this.name, index: this.index };
  }
}
const Nee = "code-workspace";
m(0, "Code Workspace");
const WW = "4064f6ec-cb38-4ad0-af64-ee6467e63c82";
var zI, Ry, UI, Ay, Ev, Py, KI, jI;
(function(i) {
  i.inspectTokensAction = m(0, "Developer: Inspect Tokens");
})(zI || (zI = {})), function(i) {
  i.gotoLineActionLabel = m(0, "Go to Line/Column...");
}(Ry || (Ry = {})), function(i) {
  i.helpQuickAccessActionLabel = m(0, "Show all Quick Access Providers");
}(UI || (UI = {})), function(i) {
  i.quickCommandActionLabel = m(0, "Command Palette"), i.quickCommandHelp = m(0, "Show And Run Commands");
}(Ay || (Ay = {})), function(i) {
  i.quickOutlineActionLabel = m(0, "Go to Symbol..."), i.quickOutlineByCategoryActionLabel = m(0, "Go to Symbol by Category...");
}(Ev || (Ev = {})), function(i) {
  i.editorViewAccessibleLabel = m(0, "Editor content"), i.accessibilityHelpMessage = m(0, "Press Alt+F1 for Accessibility Options.");
}(Py || (Py = {})), function(i) {
  i.toggleHighContrast = m(0, "Toggle High Contrast Theme");
}(KI || (KI = {})), function(i) {
  i.bulkEditServiceSummary = m(0, "Made {0} edits in {1} files");
}(jI || (jI = {}));
const VW = tt("workspaceTrustManagementService");
let Ym = [], NA = [], HW = [];
function Bb(i, e = !1) {
  (function(t, n, s) {
    const o = function(r, a) {
      return { id: r.id, mime: r.mime, filename: r.filename, extension: r.extension, filepattern: r.filepattern, firstline: r.firstline, userConfigured: a, filenameLowercase: r.filename ? r.filename.toLowerCase() : void 0, extensionLowercase: r.extension ? r.extension.toLowerCase() : void 0, filepatternLowercase: r.filepattern ? SW(r.filepattern.toLowerCase()) : void 0, filepatternOnPath: !!r.filepattern && r.filepattern.indexOf(Fi.sep) >= 0 };
    }(t, n);
    Ym.push(o), o.userConfigured ? HW.push(o) : NA.push(o), s && !o.userConfigured && Ym.forEach((r) => {
      r.mime === o.mime || r.userConfigured || (o.extension && r.extension === o.extension && console.warn(`Overwriting extension <<${o.extension}>> to now point to mime <<${o.mime}>>`), o.filename && r.filename === o.filename && console.warn(`Overwriting filename <<${o.filename}>> to now point to mime <<${o.mime}>>`), o.filepattern && r.filepattern === o.filepattern && console.warn(`Overwriting filepattern <<${o.filepattern}>> to now point to mime <<${o.mime}>>`), o.firstline && r.firstline === o.firstline && console.warn(`Overwriting firstline <<${o.firstline}>> to now point to mime <<${o.mime}>>`));
    });
  })(i, !1, e);
}
function Eee(i, e) {
  return function(t, n) {
    let s;
    if (t) switch (t.scheme) {
      case Ue.file:
        s = t.fsPath;
        break;
      case Ue.data:
        s = Bh.parseMetaData(t).get(Bh.META_DATA_LABEL);
        break;
      case Ue.vscodeNotebookCell:
        s = void 0;
        break;
      default:
        s = t.path;
    }
    if (!s) return [{ id: "unknown", mime: vi.unknown }];
    s = s.toLowerCase();
    const o = Nh(s), r = E3(s, o, HW);
    if (r) return [r, { id: ko, mime: vi.text }];
    const a = E3(s, o, NA);
    if (a) return [a, { id: ko, mime: vi.text }];
    if (n) {
      const l = function(d) {
        if (dR(d) && (d = d.substr(1)), d.length > 0) for (let h = Ym.length - 1; h >= 0; h--) {
          const c = Ym[h];
          if (!c.firstline) continue;
          const u = d.match(c.firstline);
          if (u && u.length > 0) return c;
        }
      }(n);
      if (l) return [l, { id: ko, mime: vi.text }];
    }
    return [{ id: "unknown", mime: vi.unknown }];
  }(i, e).map((t) => t.id);
}
function E3(i, e, t) {
  var n;
  let s, o, r;
  for (let a = t.length - 1; a >= 0; a--) {
    const l = t[a];
    if (e === l.filenameLowercase) {
      s = l;
      break;
    }
    if (l.filepattern && (!o || l.filepattern.length > o.filepattern.length)) {
      const d = l.filepatternOnPath ? i : e;
      !((n = l.filepatternLowercase) === null || n === void 0) && n.call(l, d) && (o = l);
    }
    l.extension && (!r || l.extension.length > r.extension.length) && e.endsWith(l.extensionLowercase) && (r = l);
  }
  return s || o || r || void 0;
}
const Wb = Object.prototype.hasOwnProperty, I3 = "vs.editor.nullLanguage";
class Iee {
  constructor() {
    this._languageIdToLanguage = [], this._languageToLanguageId = /* @__PURE__ */ new Map(), this._register(I3, 0), this._register(ko, 1), this._nextLanguageId = 2;
  }
  _register(e, t) {
    this._languageIdToLanguage[t] = e, this._languageToLanguageId.set(e, t);
  }
  register(e) {
    if (this._languageToLanguageId.has(e)) return;
    const t = this._nextLanguageId++;
    this._register(e, t);
  }
  encodeLanguageId(e) {
    return this._languageToLanguageId.get(e) || 0;
  }
  decodeLanguageId(e) {
    return this._languageIdToLanguage[e] || I3;
  }
}
class Iv extends V {
  constructor(e = !0, t = !1) {
    super(), this._onDidChange = this._register(new F()), this.onDidChange = this._onDidChange.event, Iv.instanceCount++, this._warnOnOverwrite = t, this.languageIdCodec = new Iee(), this._dynamicLanguages = [], this._languages = {}, this._mimeTypesMap = {}, this._nameMap = {}, this._lowercaseNameMap = {}, e && (this._initializeFromRegistry(), this._register(Vm.onDidChangeLanguages((n) => {
      this._initializeFromRegistry();
    })));
  }
  dispose() {
    Iv.instanceCount--, super.dispose();
  }
  _initializeFromRegistry() {
    this._languages = {}, this._mimeTypesMap = {}, this._nameMap = {}, this._lowercaseNameMap = {}, Ym = Ym.filter((t) => t.userConfigured), NA = [];
    const e = [].concat(Vm.getLanguages()).concat(this._dynamicLanguages);
    this._registerLanguages(e);
  }
  _registerLanguages(e) {
    for (const t of e) this._registerLanguage(t);
    this._mimeTypesMap = {}, this._nameMap = {}, this._lowercaseNameMap = {}, Object.keys(this._languages).forEach((t) => {
      const n = this._languages[t];
      n.name && (this._nameMap[n.name] = n.identifier), n.aliases.forEach((s) => {
        this._lowercaseNameMap[s.toLowerCase()] = n.identifier;
      }), n.mimetypes.forEach((s) => {
        this._mimeTypesMap[s] = n.identifier;
      });
    }), li.as(fa).registerOverrideIdentifiers(this.getRegisteredLanguageIds()), this._onDidChange.fire();
  }
  _registerLanguage(e) {
    const t = e.id;
    let n;
    Wb.call(this._languages, t) ? n = this._languages[t] : (this.languageIdCodec.register(t), n = { identifier: t, name: null, mimetypes: [], aliases: [], extensions: [], filenames: [], configurationFiles: [], icons: [] }, this._languages[t] = n), this._mergeLanguage(n, e);
  }
  _mergeLanguage(e, t) {
    const n = t.id;
    let s = null;
    if (Array.isArray(t.mimetypes) && t.mimetypes.length > 0 && (e.mimetypes.push(...t.mimetypes), s = t.mimetypes[0]), s || (s = `text/x-${n}`, e.mimetypes.push(s)), Array.isArray(t.extensions)) {
      t.configuration ? e.extensions = t.extensions.concat(e.extensions) : e.extensions = e.extensions.concat(t.extensions);
      for (const l of t.extensions) Bb({ id: n, mime: s, extension: l }, this._warnOnOverwrite);
    }
    if (Array.isArray(t.filenames)) for (const l of t.filenames) Bb({ id: n, mime: s, filename: l }, this._warnOnOverwrite), e.filenames.push(l);
    if (Array.isArray(t.filenamePatterns)) for (const l of t.filenamePatterns) Bb({ id: n, mime: s, filepattern: l }, this._warnOnOverwrite);
    if (typeof t.firstLine == "string" && t.firstLine.length > 0) {
      let l = t.firstLine;
      l.charAt(0) !== "^" && (l = "^" + l);
      try {
        const d = new RegExp(l);
        (o = d).source !== "^" && o.source !== "^$" && o.source !== "$" && o.source !== "^\\s*$" && o.exec("") && o.lastIndex === 0 || Bb({ id: n, mime: s, firstline: d }, this._warnOnOverwrite);
      } catch (d) {
        console.warn(`[${t.id}]: Invalid regular expression \`${l}\`: `, d);
      }
    }
    var o;
    e.aliases.push(n);
    let r = null;
    if (t.aliases !== void 0 && Array.isArray(t.aliases) && (r = t.aliases.length === 0 ? [null] : t.aliases), r !== null) for (const l of r) l && l.length !== 0 && e.aliases.push(l);
    const a = r !== null && r.length > 0;
    if (!(a && r[0] === null)) {
      const l = (a ? r[0] : null) || n;
      !a && e.name || (e.name = l);
    }
    t.configuration && e.configurationFiles.push(t.configuration), t.icon && e.icons.push(t.icon);
  }
  isRegisteredLanguageId(e) {
    return !!e && Wb.call(this._languages, e);
  }
  getRegisteredLanguageIds() {
    return Object.keys(this._languages);
  }
  getLanguageIdByLanguageName(e) {
    const t = e.toLowerCase();
    return Wb.call(this._lowercaseNameMap, t) ? this._lowercaseNameMap[t] : null;
  }
  getLanguageIdByMimeType(e) {
    return e && Wb.call(this._mimeTypesMap, e) ? this._mimeTypesMap[e] : null;
  }
  guessLanguageIdByFilepathOrFirstLine(e, t) {
    return e || t ? Eee(e, t) : [];
  }
}
Iv.instanceCount = 0;
class Mv extends V {
  constructor(e = !1) {
    super(), this._onDidRequestBasicLanguageFeatures = this._register(new F()), this.onDidRequestBasicLanguageFeatures = this._onDidRequestBasicLanguageFeatures.event, this._onDidRequestRichLanguageFeatures = this._register(new F()), this.onDidRequestRichLanguageFeatures = this._onDidRequestRichLanguageFeatures.event, this._onDidChange = this._register(new F({ leakWarningThreshold: 200 })), this.onDidChange = this._onDidChange.event, this._requestedBasicLanguages = /* @__PURE__ */ new Set(), this._requestedRichLanguages = /* @__PURE__ */ new Set(), Mv.instanceCount++, this._registry = this._register(new Iv(!0, e)), this.languageIdCodec = this._registry.languageIdCodec, this._register(this._registry.onDidChange(() => this._onDidChange.fire()));
  }
  dispose() {
    Mv.instanceCount--, super.dispose();
  }
  isRegisteredLanguageId(e) {
    return this._registry.isRegisteredLanguageId(e);
  }
  getLanguageIdByLanguageName(e) {
    return this._registry.getLanguageIdByLanguageName(e);
  }
  getLanguageIdByMimeType(e) {
    return this._registry.getLanguageIdByMimeType(e);
  }
  guessLanguageIdByFilepathOrFirstLine(e, t) {
    return UT(this._registry.guessLanguageIdByFilepathOrFirstLine(e, t), null);
  }
  createById(e) {
    return new M3(this.onDidChange, () => this._createAndGetLanguageIdentifier(e));
  }
  createByFilepathOrFirstLine(e, t) {
    return new M3(this.onDidChange, () => {
      const n = this.guessLanguageIdByFilepathOrFirstLine(e, t);
      return this._createAndGetLanguageIdentifier(n);
    });
  }
  _createAndGetLanguageIdentifier(e) {
    return e && this.isRegisteredLanguageId(e) || (e = ko), e;
  }
  requestBasicLanguageFeatures(e) {
    this._requestedBasicLanguages.has(e) || (this._requestedBasicLanguages.add(e), this._onDidRequestBasicLanguageFeatures.fire(e));
  }
  requestRichLanguageFeatures(e) {
    this._requestedRichLanguages.has(e) || (this._requestedRichLanguages.add(e), this.requestBasicLanguageFeatures(e), ci.getOrCreate(e), this._onDidRequestRichLanguageFeatures.fire(e));
  }
}
Mv.instanceCount = 0;
class M3 {
  constructor(e, t) {
    this._onDidChangeLanguages = e, this._selector = t, this._listener = null, this._emitter = null, this.languageId = this._selector();
  }
  _dispose() {
    this._listener && (this._listener.dispose(), this._listener = null), this._emitter && (this._emitter.dispose(), this._emitter = null);
  }
  get onDidChange() {
    return this._listener || (this._listener = this._onDidChangeLanguages(() => this._evaluate())), this._emitter || (this._emitter = new F({ onDidRemoveLastListener: () => {
      this._dispose();
    } })), this._emitter.event;
  }
  _evaluate() {
    var e;
    const t = this._selector();
    t !== this.languageId && (this.languageId = t, (e = this._emitter) === null || e === void 0 || e.fire(this.languageId));
  }
}
const Tv = { RESOURCES: "ResourceURLs", DOWNLOAD_URL: "DownloadURL", FILES: "Files", TEXT: vi.text, INTERNAL_URI_LIST: "application/vnd.code.uri-list" };
let SL = () => ({ get delay() {
  return -1;
}, dispose: () => {
}, showHover: () => {
} });
const Mee = new ga(() => SL("mouse", !1)), Tee = new ga(() => SL("element", !1));
function Bs(i) {
  return i === "element" ? Tee.value : Mee.value;
}
function Xm() {
  return SL("element", !0);
}
class Ree {
  constructor(e, t, n) {
    this.hoverDelegate = e, this.target = t, this.fadeInAnimation = n;
  }
  async update(e, t, n) {
    var s;
    if (this._cancellationTokenSource && (this._cancellationTokenSource.dispose(!0), this._cancellationTokenSource = void 0), this.isDisposed) return;
    let o;
    if (e === void 0 || ps(e) || e instanceof HTMLElement) o = e;
    else if (j0(e.markdown)) {
      this._hoverWidget || this.show(m(0, "Loading..."), t), this._cancellationTokenSource = new Ci();
      const r = this._cancellationTokenSource.token;
      if (o = await e.markdown(r), o === void 0 && (o = e.markdownNotSupportedFallback), this.isDisposed || r.isCancellationRequested) return;
    } else o = (s = e.markdown) !== null && s !== void 0 ? s : e.markdownNotSupportedFallback;
    this.show(o, t, n);
  }
  show(e, t, n) {
    const s = this._hoverWidget;
    if (this.hasContent(e)) {
      const o = { content: e, target: this.target, appearance: { showPointer: this.hoverDelegate.placement === "element", skipFadeInAnimation: !this.fadeInAnimation || !!s }, position: { hoverPosition: 2 }, ...n };
      this._hoverWidget = this.hoverDelegate.showHover(o, t);
    }
    s == null || s.dispose();
  }
  hasContent(e) {
    return !!e && (!ha(e) || !!e.value);
  }
  get isDisposed() {
    var e;
    return (e = this._hoverWidget) === null || e === void 0 ? void 0 : e.isDisposed;
  }
  dispose() {
    var e, t;
    (e = this._hoverWidget) === null || e === void 0 || e.dispose(), (t = this._cancellationTokenSource) === null || t === void 0 || t.dispose(!0), this._cancellationTokenSource = void 0;
  }
}
function T3(i, e) {
  for (e = e ?? ke(i).document.body; !i.hasAttribute("custom-hover") && i !== e; ) i = i.parentElement;
  return i;
}
function xr(i, e, t, n) {
  let s, o;
  e.setAttribute("custom-hover", "true"), e.title !== "" && (console.warn("HTML element already has a title attribute, which will conflict with the custom hover. Please remove the title attribute."), console.trace("Stack trace:", e.title), e.title = "");
  const r = (_, v) => {
    var b;
    const C = o !== void 0;
    _ && (o == null || o.dispose(), o = void 0), v && (s == null || s.dispose(), s = void 0), C && ((b = i.onDidHideHover) === null || b === void 0 || b.call(i), o = void 0);
  }, a = (_, v, b) => new Dr(async () => {
    o && !o.isDisposed || (o = new Ree(i, b || e, _ > 0), await o.update(typeof t == "function" ? t() : t, v, n));
  }, _);
  let l = !1;
  const d = K(e, ie.MOUSE_DOWN, () => {
    l = !0, r(!0, !0);
  }, !0), h = K(e, ie.MOUSE_UP, () => {
    l = !1;
  }, !0), c = K(e, ie.MOUSE_LEAVE, (_) => {
    l = !1, r(!1, _.fromElement === e);
  }, !0), u = K(e, ie.MOUSE_OVER, (_) => {
    if (s) return;
    const v = new G(), b = { targetElements: [e], dispose: () => {
    } };
    if (i.placement === void 0 || i.placement === "mouse") {
      const C = (w) => {
        b.x = w.x + 10, w.target instanceof HTMLElement && T3(w.target, e) !== e && r(!0, !0);
      };
      v.add(K(e, ie.MOUSE_MOVE, C, !0));
    }
    s = v, _.target instanceof HTMLElement && T3(_.target, e) !== e || v.add(a(i.delay, !1, b));
  }, !0), g = () => {
    if (l || s) return;
    const _ = { targetElements: [e], dispose: () => {
    } }, v = new G();
    v.add(K(e, ie.BLUR, () => r(!0, !0), !0)), v.add(a(i.delay, !1, _)), s = v;
  };
  let p;
  const f = e.tagName.toLowerCase();
  return f !== "input" && f !== "textarea" && (p = K(e, ie.FOCUS, g, !0)), { show: (_) => {
    r(!1, !0), a(0, _);
  }, hide: () => {
    r(!0, !0);
  }, update: async (_, v) => {
    t = _, await (o == null ? void 0 : o.update(t, void 0, v));
  }, dispose: () => {
    u.dispose(), c.dispose(), d.dispose(), h.dispose(), p == null || p.dispose(), r(!0, !0);
  } };
}
class Aee {
  constructor(e) {
    this.spliceables = e;
  }
  splice(e, t, n) {
    this.spliceables.forEach((s) => s.splice(e, t, n));
  }
}
class Gc extends Error {
  constructor(e, t) {
    super(`ListError [${e}] ${t}`);
  }
}
function R3(i, e) {
  const t = [];
  for (const n of e) {
    if (i.start >= n.range.end) continue;
    if (i.end < n.range.start) break;
    const s = Fn.intersect(i, n.range);
    Fn.isEmpty(s) || t.push({ range: s, size: n.size });
  }
  return t;
}
function qI({ start: i, end: e }, t) {
  return { start: i + t, end: e + t };
}
class Pee {
  get paddingTop() {
    return this._paddingTop;
  }
  set paddingTop(e) {
    this._size = this._size + e - this._paddingTop, this._paddingTop = e;
  }
  constructor(e) {
    this.groups = [], this._size = 0, this._paddingTop = 0, this._paddingTop = e ?? 0, this._size = this._paddingTop;
  }
  splice(e, t, n = []) {
    const s = n.length - t, o = R3({ start: 0, end: e }, this.groups), r = R3({ start: e + t, end: Number.POSITIVE_INFINITY }, this.groups).map((l) => ({ range: qI(l.range, s), size: l.size })), a = n.map((l, d) => ({ range: { start: e + d, end: e + d + 1 }, size: l.size }));
    this.groups = function(...l) {
      return function(d) {
        const h = [];
        let c = null;
        for (const u of d) {
          const g = u.range.start, p = u.range.end, f = u.size;
          c && f === c.size ? c.range.end = p : (c = { range: { start: g, end: p }, size: f }, h.push(c));
        }
        return h;
      }(l.reduce((d, h) => d.concat(h), []));
    }(o, a, r), this._size = this._paddingTop + this.groups.reduce((l, d) => l + d.size * (d.range.end - d.range.start), 0);
  }
  get count() {
    const e = this.groups.length;
    return e ? this.groups[e - 1].range.end : 0;
  }
  get size() {
    return this._size;
  }
  indexAt(e) {
    if (e < 0) return -1;
    if (e < this._paddingTop) return 0;
    let t = 0, n = this._paddingTop;
    for (const s of this.groups) {
      const o = s.range.end - s.range.start, r = n + o * s.size;
      if (e < r) return t + Math.floor((e - n) / s.size);
      t += o, n = r;
    }
    return t;
  }
  indexAfter(e) {
    return Math.min(this.indexAt(e) + 1, this.count);
  }
  positionAt(e) {
    if (e < 0) return -1;
    let t = 0, n = 0;
    for (const s of this.groups) {
      const o = s.range.end - s.range.start, r = n + o;
      if (e < r) return this._paddingTop + t + (e - n) * s.size;
      t += o * s.size, n = r;
    }
    return -1;
  }
}
class Oee {
  constructor(e) {
    this.renderers = e, this.cache = /* @__PURE__ */ new Map(), this.transactionNodesPendingRemoval = /* @__PURE__ */ new Set(), this.inTransaction = !1;
  }
  alloc(e) {
    let t = this.getTemplateCache(e).pop(), n = !1;
    if (t) n = this.transactionNodesPendingRemoval.has(t.domNode), n && this.transactionNodesPendingRemoval.delete(t.domNode);
    else {
      const s = Q(".monaco-list-row");
      t = { domNode: s, templateId: e, templateData: this.getRenderer(e).renderTemplate(s) };
    }
    return { row: t, isReusingConnectedDomNode: n };
  }
  release(e) {
    e && this.releaseRow(e);
  }
  transact(e) {
    if (this.inTransaction) throw new Error("Already in transaction");
    this.inTransaction = !0;
    try {
      e();
    } finally {
      for (const t of this.transactionNodesPendingRemoval) this.doRemoveNode(t);
      this.transactionNodesPendingRemoval.clear(), this.inTransaction = !1;
    }
  }
  releaseRow(e) {
    const { domNode: t, templateId: n } = e;
    t && (this.inTransaction ? this.transactionNodesPendingRemoval.add(t) : this.doRemoveNode(t)), this.getTemplateCache(n).push(e);
  }
  doRemoveNode(e) {
    e.classList.remove("scrolling"), function(t) {
      var n;
      try {
        (n = t.parentElement) === null || n === void 0 || n.removeChild(t);
      } catch {
      }
    }(e);
  }
  getTemplateCache(e) {
    let t = this.cache.get(e);
    return t || (t = [], this.cache.set(e, t)), t;
  }
  dispose() {
    this.cache.forEach((e, t) => {
      for (const n of e)
        this.getRenderer(t).disposeTemplate(n.templateData), n.templateData = null;
    }), this.cache.clear(), this.transactionNodesPendingRemoval.clear();
  }
  getRenderer(e) {
    const t = this.renderers.get(e);
    if (!t) throw new Error(`No renderer found for ${e}`);
    return t;
  }
}
var Il = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
};
const Zc = { CurrentDragAndDropData: void 0 }, Ea = { useShadows: !0, verticalScrollMode: 1, setRowLineHeight: !0, setRowHeight: !0, supportDynamicHeights: !1, dnd: { getDragElements: (i) => [i], getDragURI: () => null, onDragStart() {
}, onDragOver: () => !1, drop() {
}, dispose() {
} }, horizontalScrolling: !1, transformOptimization: !0, alwaysConsumeMouseWheel: !0 };
class A1 {
  constructor(e) {
    this.elements = e;
  }
  update() {
  }
  getData() {
    return this.elements;
  }
}
class Fee {
  constructor(e) {
    this.elements = e;
  }
  update() {
  }
  getData() {
    return this.elements;
  }
}
class Bee {
  constructor() {
    this.types = [], this.files = [];
  }
  update(e) {
    if (e.types && this.types.splice(0, this.types.length, ...e.types), e.files) {
      this.files.splice(0, this.files.length);
      for (let t = 0; t < e.files.length; t++) {
        const n = e.files.item(t);
        n && (n.size || n.type) && this.files.push(n);
      }
    }
  }
  getData() {
    return { types: this.types, files: this.files };
  }
}
class Wee {
  constructor(e) {
    e != null && e.getSetSize ? this.getSetSize = e.getSetSize.bind(e) : this.getSetSize = (t, n, s) => s, e != null && e.getPosInSet ? this.getPosInSet = e.getPosInSet.bind(e) : this.getPosInSet = (t, n) => n + 1, e != null && e.getRole ? this.getRole = e.getRole.bind(e) : this.getRole = (t) => "listitem", e != null && e.isChecked ? this.isChecked = e.isChecked.bind(e) : this.isChecked = (t) => {
    };
  }
}
class Oo {
  get contentHeight() {
    return this.rangeMap.size;
  }
  get onDidScroll() {
    return this.scrollableElement.onScroll;
  }
  get scrollableElementDomNode() {
    return this.scrollableElement.getDomNode();
  }
  get horizontalScrolling() {
    return this._horizontalScrolling;
  }
  set horizontalScrolling(e) {
    if (e !== this._horizontalScrolling) {
      if (e && this.supportDynamicHeights) throw new Error("Horizontal scrolling and dynamic heights not supported simultaneously");
      if (this._horizontalScrolling = e, this.domNode.classList.toggle("horizontal-scrolling", this._horizontalScrolling), this._horizontalScrolling) {
        for (const t of this.items) this.measureItemWidth(t);
        this.updateScrollWidth(), this.scrollableElement.setScrollDimensions({ width: $k(this.domNode) }), this.rowsContainer.style.width = `${Math.max(this.scrollWidth || 0, this.renderWidth)}px`;
      } else this.scrollableElementWidthDelayer.cancel(), this.scrollableElement.setScrollDimensions({ width: this.renderWidth, scrollWidth: this.renderWidth }), this.rowsContainer.style.width = "";
    }
  }
  constructor(e, t, n, s = Ea) {
    var o, r, a, l, d, h, c, u, g, p, f, _, v;
    if (this.virtualDelegate = t, this.domId = "list_id_" + ++Oo.InstanceCount, this.renderers = /* @__PURE__ */ new Map(), this.renderWidth = 0, this._scrollHeight = 0, this.scrollableElementUpdateDisposable = null, this.scrollableElementWidthDelayer = new Sr(50), this.splicing = !1, this.dragOverAnimationStopDisposable = V.None, this.dragOverMouseY = 0, this.canDrop = !1, this.currentDragFeedbackDisposable = V.None, this.onDragLeaveTimeout = V.None, this.disposables = new G(), this._onDidChangeContentHeight = new F(), this._onDidChangeContentWidth = new F(), this.onDidChangeContentHeight = se.latch(this._onDidChangeContentHeight.event, void 0, this.disposables), this._horizontalScrolling = !1, s.horizontalScrolling && s.supportDynamicHeights) throw new Error("Horizontal scrolling and dynamic heights not supported simultaneously");
    this.items = [], this.itemId = 0, this.rangeMap = this.createRangeMap((o = s.paddingTop) !== null && o !== void 0 ? o : 0);
    for (const b of n) this.renderers.set(b.templateId, b);
    this.cache = this.disposables.add(new Oee(this.renderers)), this.lastRenderTop = 0, this.lastRenderHeight = 0, this.domNode = document.createElement("div"), this.domNode.className = "monaco-list", this.domNode.classList.add(this.domId), this.domNode.tabIndex = 0, this.domNode.classList.toggle("mouse-support", typeof s.mouseSupport != "boolean" || s.mouseSupport), this._horizontalScrolling = (r = s.horizontalScrolling) !== null && r !== void 0 ? r : Ea.horizontalScrolling, this.domNode.classList.toggle("horizontal-scrolling", this._horizontalScrolling), this.paddingBottom = s.paddingBottom === void 0 ? 0 : s.paddingBottom, this.accessibilityProvider = new Wee(s.accessibilityProvider), this.rowsContainer = document.createElement("div"), this.rowsContainer.className = "monaco-list-rows", ((a = s.transformOptimization) !== null && a !== void 0 ? a : Ea.transformOptimization) && (this.rowsContainer.style.transform = "translate3d(0px, 0px, 0px)", this.rowsContainer.style.overflow = "hidden", this.rowsContainer.style.contain = "strict"), this.disposables.add(Bt.addTarget(this.rowsContainer)), this.scrollable = this.disposables.add(new bf({ forceIntegerValues: !0, smoothScrollDuration: (l = s.smoothScrolling) !== null && l !== void 0 && l ? 125 : 0, scheduleAtNextAnimationFrame: (b) => Ys(ke(this.domNode), b) })), this.scrollableElement = this.disposables.add(new dL(this.rowsContainer, { alwaysConsumeMouseWheel: (d = s.alwaysConsumeMouseWheel) !== null && d !== void 0 ? d : Ea.alwaysConsumeMouseWheel, horizontal: 1, vertical: (h = s.verticalScrollMode) !== null && h !== void 0 ? h : Ea.verticalScrollMode, useShadows: (c = s.useShadows) !== null && c !== void 0 ? c : Ea.useShadows, mouseWheelScrollSensitivity: s.mouseWheelScrollSensitivity, fastScrollSensitivity: s.fastScrollSensitivity, scrollByPage: s.scrollByPage }, this.scrollable)), this.domNode.appendChild(this.scrollableElement.getDomNode()), e.appendChild(this.domNode), this.scrollableElement.onScroll(this.onScroll, this, this.disposables), this.disposables.add(K(this.rowsContainer, Vt.Change, (b) => this.onTouchChange(b))), this.disposables.add(K(this.scrollableElement.getDomNode(), "scroll", (b) => b.target.scrollTop = 0)), this.disposables.add(K(this.domNode, "dragover", (b) => this.onDragOver(this.toDragEvent(b)))), this.disposables.add(K(this.domNode, "drop", (b) => this.onDrop(this.toDragEvent(b)))), this.disposables.add(K(this.domNode, "dragleave", (b) => this.onDragLeave(this.toDragEvent(b)))), this.disposables.add(K(this.domNode, "dragend", (b) => this.onDragEnd(b))), this.setRowLineHeight = (u = s.setRowLineHeight) !== null && u !== void 0 ? u : Ea.setRowLineHeight, this.setRowHeight = (g = s.setRowHeight) !== null && g !== void 0 ? g : Ea.setRowHeight, this.supportDynamicHeights = (p = s.supportDynamicHeights) !== null && p !== void 0 ? p : Ea.supportDynamicHeights, this.dnd = (f = s.dnd) !== null && f !== void 0 ? f : this.disposables.add(Ea.dnd), this.layout((_ = s.initialSize) === null || _ === void 0 ? void 0 : _.height, (v = s.initialSize) === null || v === void 0 ? void 0 : v.width);
  }
  updateOptions(e) {
    let t;
    if (e.paddingBottom !== void 0 && (this.paddingBottom = e.paddingBottom, this.scrollableElement.setScrollDimensions({ scrollHeight: this.scrollHeight })), e.smoothScrolling !== void 0 && this.scrollable.setSmoothScrollDuration(e.smoothScrolling ? 125 : 0), e.horizontalScrolling !== void 0 && (this.horizontalScrolling = e.horizontalScrolling), e.scrollByPage !== void 0 && (t = { ...t ?? {}, scrollByPage: e.scrollByPage }), e.mouseWheelScrollSensitivity !== void 0 && (t = { ...t ?? {}, mouseWheelScrollSensitivity: e.mouseWheelScrollSensitivity }), e.fastScrollSensitivity !== void 0 && (t = { ...t ?? {}, fastScrollSensitivity: e.fastScrollSensitivity }), t && this.scrollableElement.updateOptions(t), e.paddingTop !== void 0 && e.paddingTop !== this.rangeMap.paddingTop) {
      const n = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight), s = e.paddingTop - this.rangeMap.paddingTop;
      this.rangeMap.paddingTop = e.paddingTop, this.render(n, Math.max(0, this.lastRenderTop + s), this.lastRenderHeight, void 0, void 0, !0), this.setScrollTop(this.lastRenderTop), this.eventuallyUpdateScrollDimensions(), this.supportDynamicHeights && this._rerender(this.lastRenderTop, this.lastRenderHeight);
    }
  }
  createRangeMap(e) {
    return new Pee(e);
  }
  splice(e, t, n = []) {
    if (this.splicing) throw new Error("Can't run recursive splices.");
    this.splicing = !0;
    try {
      return this._splice(e, t, n);
    } finally {
      this.splicing = !1, this._onDidChangeContentHeight.fire(this.contentHeight);
    }
  }
  _splice(e, t, n = []) {
    const s = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight), o = { start: e, end: e + t }, r = Fn.intersect(s, o), a = /* @__PURE__ */ new Map();
    for (let w = r.end - 1; w >= r.start; w--) {
      const y = this.items[w];
      if (y.dragStartDisposable.dispose(), y.checkedDisposable.dispose(), y.row) {
        let L = a.get(y.templateId);
        L || (L = [], a.set(y.templateId, L));
        const k = this.renderers.get(y.templateId);
        k && k.disposeElement && k.disposeElement(y.element, w, y.row.templateData, y.size), L.push(y.row);
      }
      y.row = null, y.stale = !0;
    }
    const l = { start: e + t, end: this.items.length }, d = Fn.intersect(l, s), h = Fn.relativeComplement(l, s), c = n.map((w) => ({ id: String(this.itemId++), element: w, templateId: this.virtualDelegate.getTemplateId(w), size: this.virtualDelegate.getHeight(w), width: void 0, hasDynamicHeight: !!this.virtualDelegate.hasDynamicHeight && this.virtualDelegate.hasDynamicHeight(w), lastDynamicHeightWidth: void 0, row: null, uri: void 0, dropTarget: !1, dragStartDisposable: V.None, checkedDisposable: V.None, stale: !1 }));
    let u;
    e === 0 && t >= this.items.length ? (this.rangeMap = this.createRangeMap(this.rangeMap.paddingTop), this.rangeMap.splice(0, 0, c), u = this.items, this.items = c) : (this.rangeMap.splice(e, t, c), u = this.items.splice(e, t, ...c));
    const g = n.length - t, p = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight), f = qI(d, g), _ = Fn.intersect(p, f);
    for (let w = _.start; w < _.end; w++) this.updateItemInDOM(this.items[w], w);
    const v = Fn.relativeComplement(f, p);
    for (const w of v) for (let y = w.start; y < w.end; y++) this.removeItemFromDOM(y);
    const b = h.map((w) => qI(w, g)), C = [{ start: e, end: e + n.length }, ...b].map((w) => Fn.intersect(p, w)).reverse();
    for (const w of C) for (let y = w.end - 1; y >= w.start; y--) {
      const L = this.items[y], k = a.get(L.templateId), N = k == null ? void 0 : k.pop();
      this.insertItemInDOM(y, N);
    }
    for (const w of a.values()) for (const y of w) this.cache.release(y);
    return this.eventuallyUpdateScrollDimensions(), this.supportDynamicHeights && this._rerender(this.scrollTop, this.renderHeight), u.map((w) => w.element);
  }
  eventuallyUpdateScrollDimensions() {
    this._scrollHeight = this.contentHeight, this.rowsContainer.style.height = `${this._scrollHeight}px`, this.scrollableElementUpdateDisposable || (this.scrollableElementUpdateDisposable = Ys(ke(this.domNode), () => {
      this.scrollableElement.setScrollDimensions({ scrollHeight: this.scrollHeight }), this.updateScrollWidth(), this.scrollableElementUpdateDisposable = null;
    }));
  }
  eventuallyUpdateScrollWidth() {
    this.horizontalScrolling ? this.scrollableElementWidthDelayer.trigger(() => this.updateScrollWidth()) : this.scrollableElementWidthDelayer.cancel();
  }
  updateScrollWidth() {
    if (!this.horizontalScrolling) return;
    let e = 0;
    for (const t of this.items) t.width !== void 0 && (e = Math.max(e, t.width));
    this.scrollWidth = e, this.scrollableElement.setScrollDimensions({ scrollWidth: e === 0 ? 0 : e + 10 }), this._onDidChangeContentWidth.fire(this.scrollWidth);
  }
  rerender() {
    if (this.supportDynamicHeights) {
      for (const e of this.items) e.lastDynamicHeightWidth = void 0;
      this._rerender(this.lastRenderTop, this.lastRenderHeight);
    }
  }
  get length() {
    return this.items.length;
  }
  get renderHeight() {
    return this.scrollableElement.getScrollDimensions().height;
  }
  get firstVisibleIndex() {
    return this.getRenderRange(this.lastRenderTop, this.lastRenderHeight).start;
  }
  element(e) {
    return this.items[e].element;
  }
  indexOf(e) {
    return this.items.findIndex((t) => t.element === e);
  }
  domElement(e) {
    const t = this.items[e].row;
    return t && t.domNode;
  }
  elementHeight(e) {
    return this.items[e].size;
  }
  elementTop(e) {
    return this.rangeMap.positionAt(e);
  }
  indexAt(e) {
    return this.rangeMap.indexAt(e);
  }
  indexAfter(e) {
    return this.rangeMap.indexAfter(e);
  }
  layout(e, t) {
    const n = { height: typeof e == "number" ? e : hj(this.domNode) };
    this.scrollableElementUpdateDisposable && (this.scrollableElementUpdateDisposable.dispose(), this.scrollableElementUpdateDisposable = null, n.scrollHeight = this.scrollHeight), this.scrollableElement.setScrollDimensions(n), t !== void 0 && (this.renderWidth = t, this.supportDynamicHeights && this._rerender(this.scrollTop, this.renderHeight)), this.horizontalScrolling && this.scrollableElement.setScrollDimensions({ width: typeof t == "number" ? t : $k(this.domNode) });
  }
  render(e, t, n, s, o, r = !1) {
    const a = this.getRenderRange(t, n), l = Fn.relativeComplement(a, e).reverse(), d = Fn.relativeComplement(e, a);
    if (r) {
      const h = Fn.intersect(e, a);
      for (let c = h.start; c < h.end; c++) this.updateItemInDOM(this.items[c], c);
    }
    this.cache.transact(() => {
      for (const h of d) for (let c = h.start; c < h.end; c++) this.removeItemFromDOM(c);
      for (const h of l) for (let c = h.end - 1; c >= h.start; c--) this.insertItemInDOM(c);
    }), s !== void 0 && (this.rowsContainer.style.left = `-${s}px`), this.rowsContainer.style.top = `-${t}px`, this.horizontalScrolling && o !== void 0 && (this.rowsContainer.style.width = `${Math.max(o, this.renderWidth)}px`), this.lastRenderTop = t, this.lastRenderHeight = n;
  }
  insertItemInDOM(e, t) {
    var n, s, o;
    const r = this.items[e];
    if (!r.row) if (t) r.row = t, r.stale = !0;
    else {
      const c = this.cache.alloc(r.templateId);
      r.row = c.row, r.stale || (r.stale = c.isReusingConnectedDomNode);
    }
    const a = this.accessibilityProvider.getRole(r.element) || "listitem";
    r.row.domNode.setAttribute("role", a);
    const l = this.accessibilityProvider.isChecked(r.element);
    if (typeof l == "boolean") r.row.domNode.setAttribute("aria-checked", String(!!l));
    else if (l) {
      const c = (u) => r.row.domNode.setAttribute("aria-checked", String(!!u));
      c(l.value), r.checkedDisposable = l.onDidChange(c);
    }
    if (r.stale || !r.row.domNode.parentElement) {
      const c = (o = (s = (n = this.items.at(e + 1)) === null || n === void 0 ? void 0 : n.row) === null || s === void 0 ? void 0 : s.domNode) !== null && o !== void 0 ? o : null;
      this.rowsContainer.insertBefore(r.row.domNode, c), r.stale = !1;
    }
    this.updateItemInDOM(r, e);
    const d = this.renderers.get(r.templateId);
    if (!d) throw new Error(`No renderer found for template id ${r.templateId}`);
    d == null || d.renderElement(r.element, e, r.row.templateData, r.size);
    const h = this.dnd.getDragURI(r.element);
    r.dragStartDisposable.dispose(), r.row.domNode.draggable = !!h, h && (r.dragStartDisposable = K(r.row.domNode, "dragstart", (c) => this.onDragStart(r.element, h, c))), this.horizontalScrolling && (this.measureItemWidth(r), this.eventuallyUpdateScrollWidth());
  }
  measureItemWidth(e) {
    if (!e.row || !e.row.domNode) return;
    e.row.domNode.style.width = "fit-content", e.width = $k(e.row.domNode);
    const t = ke(e.row.domNode).getComputedStyle(e.row.domNode);
    t.paddingLeft && (e.width += parseFloat(t.paddingLeft)), t.paddingRight && (e.width += parseFloat(t.paddingRight)), e.row.domNode.style.width = "";
  }
  updateItemInDOM(e, t) {
    e.row.domNode.style.top = `${this.elementTop(t)}px`, this.setRowHeight && (e.row.domNode.style.height = `${e.size}px`), this.setRowLineHeight && (e.row.domNode.style.lineHeight = `${e.size}px`), e.row.domNode.setAttribute("data-index", `${t}`), e.row.domNode.setAttribute("data-last-element", t === this.length - 1 ? "true" : "false"), e.row.domNode.setAttribute("data-parity", t % 2 == 0 ? "even" : "odd"), e.row.domNode.setAttribute("aria-setsize", String(this.accessibilityProvider.getSetSize(e.element, t, this.length))), e.row.domNode.setAttribute("aria-posinset", String(this.accessibilityProvider.getPosInSet(e.element, t))), e.row.domNode.setAttribute("id", this.getElementDomId(t)), e.row.domNode.classList.toggle("drop-target", e.dropTarget);
  }
  removeItemFromDOM(e) {
    const t = this.items[e];
    if (t.dragStartDisposable.dispose(), t.checkedDisposable.dispose(), t.row) {
      const n = this.renderers.get(t.templateId);
      n && n.disposeElement && n.disposeElement(t.element, e, t.row.templateData, t.size), this.cache.release(t.row), t.row = null;
    }
    this.horizontalScrolling && this.eventuallyUpdateScrollWidth();
  }
  getScrollTop() {
    return this.scrollableElement.getScrollPosition().scrollTop;
  }
  setScrollTop(e, t) {
    this.scrollableElementUpdateDisposable && (this.scrollableElementUpdateDisposable.dispose(), this.scrollableElementUpdateDisposable = null, this.scrollableElement.setScrollDimensions({ scrollHeight: this.scrollHeight })), this.scrollableElement.setScrollPosition({ scrollTop: e, reuseAnimation: t });
  }
  get scrollTop() {
    return this.getScrollTop();
  }
  set scrollTop(e) {
    this.setScrollTop(e);
  }
  get scrollHeight() {
    return this._scrollHeight + (this.horizontalScrolling ? 10 : 0) + this.paddingBottom;
  }
  get onMouseClick() {
    return se.map(this.disposables.add(new st(this.domNode, "click")).event, (e) => this.toMouseEvent(e), this.disposables);
  }
  get onMouseDblClick() {
    return se.map(this.disposables.add(new st(this.domNode, "dblclick")).event, (e) => this.toMouseEvent(e), this.disposables);
  }
  get onMouseMiddleClick() {
    return se.filter(se.map(this.disposables.add(new st(this.domNode, "auxclick")).event, (e) => this.toMouseEvent(e), this.disposables), (e) => e.browserEvent.button === 1, this.disposables);
  }
  get onMouseDown() {
    return se.map(this.disposables.add(new st(this.domNode, "mousedown")).event, (e) => this.toMouseEvent(e), this.disposables);
  }
  get onMouseOver() {
    return se.map(this.disposables.add(new st(this.domNode, "mouseover")).event, (e) => this.toMouseEvent(e), this.disposables);
  }
  get onMouseOut() {
    return se.map(this.disposables.add(new st(this.domNode, "mouseout")).event, (e) => this.toMouseEvent(e), this.disposables);
  }
  get onContextMenu() {
    return se.any(se.map(this.disposables.add(new st(this.domNode, "contextmenu")).event, (e) => this.toMouseEvent(e), this.disposables), se.map(this.disposables.add(new st(this.domNode, Vt.Contextmenu)).event, (e) => this.toGestureEvent(e), this.disposables));
  }
  get onTouchStart() {
    return se.map(this.disposables.add(new st(this.domNode, "touchstart")).event, (e) => this.toTouchEvent(e), this.disposables);
  }
  get onTap() {
    return se.map(this.disposables.add(new st(this.rowsContainer, Vt.Tap)).event, (e) => this.toGestureEvent(e), this.disposables);
  }
  toMouseEvent(e) {
    const t = this.getItemIndexFromEventTarget(e.target || null), n = t === void 0 ? void 0 : this.items[t];
    return { browserEvent: e, index: t, element: n && n.element };
  }
  toTouchEvent(e) {
    const t = this.getItemIndexFromEventTarget(e.target || null), n = t === void 0 ? void 0 : this.items[t];
    return { browserEvent: e, index: t, element: n && n.element };
  }
  toGestureEvent(e) {
    const t = this.getItemIndexFromEventTarget(e.initialTarget || null), n = t === void 0 ? void 0 : this.items[t];
    return { browserEvent: e, index: t, element: n && n.element };
  }
  toDragEvent(e) {
    const t = this.getItemIndexFromEventTarget(e.target || null), n = t === void 0 ? void 0 : this.items[t];
    return { browserEvent: e, index: t, element: n && n.element, sector: this.getTargetSector(e, t) };
  }
  onScroll(e) {
    try {
      const t = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight);
      this.render(t, e.scrollTop, e.height, e.scrollLeft, e.scrollWidth), this.supportDynamicHeights && this._rerender(e.scrollTop, e.height, e.inSmoothScrolling);
    } catch (t) {
      throw console.error("Got bad scroll event:", e), t;
    }
  }
  onTouchChange(e) {
    e.preventDefault(), e.stopPropagation(), this.scrollTop -= e.translationY;
  }
  onDragStart(e, t, n) {
    var s, o;
    if (!n.dataTransfer) return;
    const r = this.dnd.getDragElements(e);
    if (n.dataTransfer.effectAllowed = "copyMove", n.dataTransfer.setData(Tv.TEXT, t), n.dataTransfer.setDragImage) {
      let a;
      this.dnd.getDragLabel && (a = this.dnd.getDragLabel(r, n)), a === void 0 && (a = String(r.length));
      const l = Q(".monaco-drag-image");
      l.textContent = a;
      const d = ((h) => {
        for (; h && !h.classList.contains("monaco-workbench"); ) h = h.parentElement;
        return h || this.domNode.ownerDocument;
      })(this.domNode);
      d.appendChild(l), n.dataTransfer.setDragImage(l, -10, -10), setTimeout(() => d.removeChild(l), 0);
    }
    this.domNode.classList.add("dragging"), this.currentDragData = new A1(r), Zc.CurrentDragAndDropData = new Fee(r), (o = (s = this.dnd).onDragStart) === null || o === void 0 || o.call(s, this.currentDragData, n);
  }
  onDragOver(e) {
    var t, n;
    if (e.browserEvent.preventDefault(), this.onDragLeaveTimeout.dispose(), Zc.CurrentDragAndDropData && Zc.CurrentDragAndDropData.getData() === "vscode-ui" || (this.setupDragAndDropScrollTopAnimation(e.browserEvent), !e.browserEvent.dataTransfer)) return !1;
    if (!this.currentDragData) if (Zc.CurrentDragAndDropData) this.currentDragData = Zc.CurrentDragAndDropData;
    else {
      if (!e.browserEvent.dataTransfer.types) return !1;
      this.currentDragData = new Bee();
    }
    const s = this.dnd.onDragOver(this.currentDragData, e.element, e.index, e.sector, e.browserEvent);
    if (this.canDrop = typeof s == "boolean" ? s : s.accept, !this.canDrop) return this.currentDragFeedback = void 0, this.currentDragFeedbackDisposable.dispose(), !1;
    let o;
    e.browserEvent.dataTransfer.dropEffect = typeof s != "boolean" && ((t = s.effect) === null || t === void 0 ? void 0 : t.type) === 0 ? "copy" : "move", o = typeof s != "boolean" && s.feedback ? s.feedback : e.index === void 0 ? [-1] : [e.index], o = Ad(o).filter((d) => d >= -1 && d < this.length).sort((d, h) => d - h), o = o[0] === -1 ? [-1] : o;
    let r = typeof s != "boolean" && s.effect && s.effect.position ? s.effect.position : "drop-target";
    if (a = this.currentDragFeedback, l = o, (Array.isArray(a) && Array.isArray(l) ? ri(a, l) : a === l) && this.currentDragFeedbackPosition === r) return !0;
    var a, l;
    if (this.currentDragFeedback = o, this.currentDragFeedbackPosition = r, this.currentDragFeedbackDisposable.dispose(), o[0] === -1) this.domNode.classList.add(r), this.rowsContainer.classList.add(r), this.currentDragFeedbackDisposable = ye(() => {
      this.domNode.classList.remove(r), this.rowsContainer.classList.remove(r);
    });
    else {
      if (o.length > 1 && r !== "drop-target") throw new Error("Can't use multiple feedbacks with position different than 'over'");
      r === "drop-target-after" && o[0] < this.length - 1 && (o[0] += 1, r = "drop-target-before");
      for (const d of o) {
        const h = this.items[d];
        h.dropTarget = !0, (n = h.row) === null || n === void 0 || n.domNode.classList.add(r);
      }
      this.currentDragFeedbackDisposable = ye(() => {
        var d;
        for (const h of o) {
          const c = this.items[h];
          c.dropTarget = !1, (d = c.row) === null || d === void 0 || d.domNode.classList.remove(r);
        }
      });
    }
    return !0;
  }
  onDragLeave(e) {
    var t, n;
    this.onDragLeaveTimeout.dispose(), this.onDragLeaveTimeout = Cc(() => this.clearDragOverFeedback(), 100, this.disposables), this.currentDragData && ((n = (t = this.dnd).onDragLeave) === null || n === void 0 || n.call(t, this.currentDragData, e.element, e.index, e.browserEvent));
  }
  onDrop(e) {
    if (!this.canDrop) return;
    const t = this.currentDragData;
    this.teardownDragAndDropScrollTopAnimation(), this.clearDragOverFeedback(), this.domNode.classList.remove("dragging"), this.currentDragData = void 0, Zc.CurrentDragAndDropData = void 0, t && e.browserEvent.dataTransfer && (e.browserEvent.preventDefault(), t.update(e.browserEvent.dataTransfer), this.dnd.drop(t, e.element, e.index, e.sector, e.browserEvent));
  }
  onDragEnd(e) {
    var t, n;
    this.canDrop = !1, this.teardownDragAndDropScrollTopAnimation(), this.clearDragOverFeedback(), this.domNode.classList.remove("dragging"), this.currentDragData = void 0, Zc.CurrentDragAndDropData = void 0, (n = (t = this.dnd).onDragEnd) === null || n === void 0 || n.call(t, e);
  }
  clearDragOverFeedback() {
    this.currentDragFeedback = void 0, this.currentDragFeedbackPosition = void 0, this.currentDragFeedbackDisposable.dispose(), this.currentDragFeedbackDisposable = V.None;
  }
  setupDragAndDropScrollTopAnimation(e) {
    if (!this.dragOverAnimationDisposable) {
      const t = v8(this.domNode).top;
      this.dragOverAnimationDisposable = function(n, s) {
        const o = () => {
          s(), r = Ys(n, o);
        };
        let r = Ys(n, o);
        return ye(() => r.dispose());
      }(ke(this.domNode), this.animateDragAndDropScrollTop.bind(this, t));
    }
    this.dragOverAnimationStopDisposable.dispose(), this.dragOverAnimationStopDisposable = Cc(() => {
      this.dragOverAnimationDisposable && (this.dragOverAnimationDisposable.dispose(), this.dragOverAnimationDisposable = void 0);
    }, 1e3, this.disposables), this.dragOverMouseY = e.pageY;
  }
  animateDragAndDropScrollTop(e) {
    if (this.dragOverMouseY === void 0) return;
    const t = this.dragOverMouseY - e, n = this.renderHeight - 35;
    t < 35 ? this.scrollTop += Math.max(-14, Math.floor(0.3 * (t - 35))) : t > n && (this.scrollTop += Math.min(14, Math.floor(0.3 * (t - n))));
  }
  teardownDragAndDropScrollTopAnimation() {
    this.dragOverAnimationStopDisposable.dispose(), this.dragOverAnimationDisposable && (this.dragOverAnimationDisposable.dispose(), this.dragOverAnimationDisposable = void 0);
  }
  getTargetSector(e, t) {
    if (t === void 0) return;
    const n = e.offsetY / this.items[t].size;
    return as(Math.floor(n / 0.25), 0, 3);
  }
  getItemIndexFromEventTarget(e) {
    const t = this.scrollableElement.getDomNode();
    let n = e;
    for (; n instanceof HTMLElement && n !== this.rowsContainer && t.contains(n); ) {
      const s = n.getAttribute("data-index");
      if (s) {
        const o = Number(s);
        if (!isNaN(o)) return o;
      }
      n = n.parentElement;
    }
  }
  getRenderRange(e, t) {
    return { start: this.rangeMap.indexAt(e), end: this.rangeMap.indexAfter(e + t - 1) };
  }
  _rerender(e, t, n) {
    const s = this.getRenderRange(e, t);
    let o, r;
    e === this.elementTop(s.start) ? (o = s.start, r = 0) : s.end - s.start > 1 && (o = s.start + 1, r = this.elementTop(o) - e);
    let a = 0;
    for (; ; ) {
      const l = this.getRenderRange(e, t);
      let d = !1;
      for (let h = l.start; h < l.end; h++) {
        const c = this.probeDynamicHeight(h);
        c !== 0 && this.rangeMap.splice(h, 1, [this.items[h]]), a += c, d = d || c !== 0;
      }
      if (!d) {
        a !== 0 && this.eventuallyUpdateScrollDimensions();
        const h = Fn.relativeComplement(s, l);
        for (const u of h) for (let g = u.start; g < u.end; g++) this.items[g].row && this.removeItemFromDOM(g);
        const c = Fn.relativeComplement(l, s).reverse();
        for (const u of c) for (let g = u.end - 1; g >= u.start; g--) this.insertItemInDOM(g);
        for (let u = l.start; u < l.end; u++) this.items[u].row && this.updateItemInDOM(this.items[u], u);
        if (typeof o == "number") {
          const u = this.scrollable.getFutureScrollPosition().scrollTop - e, g = this.elementTop(o) - r + u;
          this.setScrollTop(g, n);
        }
        return void this._onDidChangeContentHeight.fire(this.contentHeight);
      }
    }
  }
  probeDynamicHeight(e) {
    var t, n, s;
    const o = this.items[e];
    if (this.virtualDelegate.getDynamicHeight) {
      const d = this.virtualDelegate.getDynamicHeight(o.element);
      if (d !== null) {
        const h = o.size;
        return o.size = d, o.lastDynamicHeightWidth = this.renderWidth, d - h;
      }
    }
    if (!o.hasDynamicHeight || o.lastDynamicHeightWidth === this.renderWidth || this.virtualDelegate.hasDynamicHeight && !this.virtualDelegate.hasDynamicHeight(o.element)) return 0;
    const r = o.size;
    if (o.row) return o.row.domNode.style.height = "", o.size = o.row.domNode.offsetHeight, o.size !== 0 || gn(o.row.domNode, ke(o.row.domNode).document.body) || console.warn("Measuring item node that is not in DOM! Add ListView to the DOM before measuring row height!"), o.lastDynamicHeightWidth = this.renderWidth, o.size - r;
    const { row: a } = this.cache.alloc(o.templateId);
    a.domNode.style.height = "", this.rowsContainer.appendChild(a.domNode);
    const l = this.renderers.get(o.templateId);
    if (!l) throw new Kt("Missing renderer for templateId: " + o.templateId);
    return l.renderElement(o.element, e, a.templateData, void 0), o.size = a.domNode.offsetHeight, (t = l.disposeElement) === null || t === void 0 || t.call(l, o.element, e, a.templateData, void 0), (s = (n = this.virtualDelegate).setDynamicHeight) === null || s === void 0 || s.call(n, o.element, o.size), o.lastDynamicHeightWidth = this.renderWidth, this.rowsContainer.removeChild(a.domNode), this.cache.release(a), o.size - r;
  }
  getElementDomId(e) {
    return `${this.domId}_${e}`;
  }
  dispose() {
    var e, t;
    for (const n of this.items) if (n.dragStartDisposable.dispose(), n.checkedDisposable.dispose(), n.row) {
      const s = this.renderers.get(n.row.templateId);
      s && ((e = s.disposeElement) === null || e === void 0 || e.call(s, n.element, -1, n.row.templateData, void 0), s.disposeTemplate(n.row.templateData));
    }
    this.items = [], this.domNode && this.domNode.parentNode && this.domNode.parentNode.removeChild(this.domNode), (t = this.dragOverAnimationDisposable) === null || t === void 0 || t.dispose(), this.disposables.dispose();
  }
}
Oo.InstanceCount = 0, Il([Li], Oo.prototype, "onMouseClick", null), Il([Li], Oo.prototype, "onMouseDblClick", null), Il([Li], Oo.prototype, "onMouseMiddleClick", null), Il([Li], Oo.prototype, "onMouseDown", null), Il([Li], Oo.prototype, "onMouseOver", null), Il([Li], Oo.prototype, "onMouseOut", null), Il([Li], Oo.prototype, "onContextMenu", null), Il([Li], Oo.prototype, "onTouchStart", null), Il([Li], Oo.prototype, "onTap", null);
class ba {
  constructor(e, t, n) {
    this.owner = e, this.debugNameSource = t, this.referenceFn = n;
  }
  getDebugName(e) {
    return function(t, n) {
      var s;
      const o = YD.get(t);
      if (o) return o;
      const r = function(a, l) {
        const d = YD.get(a);
        if (d) return d;
        const h = l.owner ? function(p) {
          var f;
          const _ = O3.get(p);
          if (_) return _;
          const v = function(w) {
            const y = w.constructor;
            return y ? y.name : "Object";
          }(p);
          let b = (f = P3.get(v)) !== null && f !== void 0 ? f : 0;
          b++, P3.set(v, b);
          const C = b === 1 ? v : `${v}#${b}`;
          return O3.set(p, C), C;
        }(l.owner) + "." : "";
        let c;
        const u = l.debugNameSource;
        if (u !== void 0) {
          if (typeof u != "function") return h + u;
          if (c = u(), c !== void 0) return h + c;
        }
        const g = l.referenceFn;
        if (g !== void 0 && (c = LL(g), c !== void 0)) return h + c;
        if (l.owner !== void 0) {
          const p = function(f, _) {
            for (const v in f) if (f[v] === _) return v;
          }(l.owner, a);
          if (p !== void 0) return h + p;
        }
      }(t, n);
      if (r) {
        let a = (s = A3.get(r)) !== null && s !== void 0 ? s : 0;
        a++, A3.set(r, a);
        const l = a === 1 ? r : `${r}#${a}`;
        return YD.set(t, l), l;
      }
    }(e, this);
  }
}
const A3 = /* @__PURE__ */ new Map(), YD = /* @__PURE__ */ new WeakMap(), P3 = /* @__PURE__ */ new Map(), O3 = /* @__PURE__ */ new WeakMap();
function LL(i) {
  const e = i.toString(), t = /\/\*\*\s*@description\s*([^*]*)\*\//.exec(e), n = t ? t[1] : void 0;
  return n == null ? void 0 : n.trim();
}
let zW, UW, Vb;
class KW {
  get TChange() {
    return null;
  }
  reportChanges() {
    this.get();
  }
  read(e) {
    return e ? e.readObservable(this) : this.get();
  }
  map(e, t) {
    const n = t === void 0 ? void 0 : e, s = t === void 0 ? e : t;
    return UW({ owner: n, debugName: () => {
      const o = LL(s);
      if (o !== void 0) return o;
      const r = /^\s*\(?\s*([a-zA-Z_$][a-zA-Z_$0-9]*)\s*\)?\s*=>\s*\1(?:\??)\.([a-zA-Z_$][a-zA-Z_$0-9]*)\s*$/.exec(s.toString());
      return r ? `${this.debugName}.${r[2]}` : n ? void 0 : `${this.debugName} (mapped)`;
    } }, (o) => s(this.read(o), o));
  }
  recomputeInitiallyAndOnChange(e, t) {
    return e.add(zW(this, t)), this;
  }
}
class P1 extends KW {
  constructor() {
    super(...arguments), this.observers = /* @__PURE__ */ new Set();
  }
  addObserver(e) {
    const t = this.observers.size;
    this.observers.add(e), t === 0 && this.onFirstObserverAdded();
  }
  removeObserver(e) {
    this.observers.delete(e) && this.observers.size === 0 && this.onLastObserverRemoved();
  }
  onFirstObserverAdded() {
  }
  onLastObserverRemoved() {
  }
}
function Tt(i, e) {
  const t = new kL(i, e);
  try {
    i(t);
  } finally {
    t.finish();
  }
}
function ZC(i) {
  if (Vb) i(Vb);
  else {
    const e = new kL(i, void 0);
    Vb = e;
    try {
      i(e);
    } finally {
      e.finish(), Vb = void 0;
    }
  }
}
function Rv(i, e, t) {
  i ? e(i) : Tt(e, t);
}
class kL {
  constructor(e, t) {
    var n;
    this._fn = e, this._getDebugName = t, this.updatingObservers = [], (n = void 0) === null || n === void 0 || n.handleBeginTransaction(this);
  }
  getDebugName() {
    return this._getDebugName ? this._getDebugName() : LL(this._fn);
  }
  updateObserver(e, t) {
    this.updatingObservers.push({ observer: e, observable: t }), e.beginUpdate(t);
  }
  finish() {
    var e;
    const t = this.updatingObservers;
    for (let n = 0; n < t.length; n++) {
      const { observer: s, observable: o } = t[n];
      s.endUpdate(o);
    }
    this.updatingObservers = null, (e = void 0) === null || e === void 0 || e.handleEndTransaction();
  }
}
function lt(i, e) {
  return typeof i == "string" ? new $I(void 0, i, e) : new $I(i, void 0, e);
}
class $I extends P1 {
  get debugName() {
    var e;
    return (e = new ba(this._owner, this._debugName, void 0).getDebugName(this)) !== null && e !== void 0 ? e : "ObservableValue";
  }
  constructor(e, t, n) {
    super(), this._owner = e, this._debugName = t, this._value = n;
  }
  get() {
    return this._value;
  }
  set(e, t, n) {
    var s;
    if (this._value === e) return;
    let o;
    t || (t = o = new kL(() => {
    }, () => `Setting ${this.debugName}`));
    try {
      const r = this._value;
      this._setValue(e), (s = void 0) === null || s === void 0 || s.handleObservableChanged(this, { oldValue: r, newValue: e, change: n, didChange: !0, hadValue: !0 });
      for (const a of this.observers) t.updateObserver(a, this), a.handleChange(this, n);
    } finally {
      o && o.finish();
    }
  }
  toString() {
    return `${this.debugName}: ${this._value}`;
  }
  _setValue(e) {
    this._value = e;
  }
}
function Av(i, e) {
  return typeof i == "string" ? new F3(void 0, i, e) : new F3(i, void 0, e);
}
class F3 extends $I {
  _setValue(e) {
    this._value !== e && (this._value && this._value.dispose(), this._value = e);
  }
  dispose() {
    var e;
    (e = this._value) === null || e === void 0 || e.dispose();
  }
}
const Qm = (i, e) => i === e;
function Fe(i, e) {
  return e !== void 0 ? new Jm(new ba(i, void 0, e), e, void 0, void 0, void 0, Qm) : new Jm(new ba(void 0, void 0, i), i, void 0, void 0, void 0, Qm);
}
function _m(i, e) {
  var t;
  return new Jm(new ba(i.owner, i.debugName, i.debugReferenceFn), e, void 0, void 0, i.onLastObserverRemoved, (t = i.equalityComparer) !== null && t !== void 0 ? t : Qm);
}
function Cf(i, e) {
  let t, n;
  e === void 0 ? (t = i, n = void 0) : (n = i, t = e);
  const s = new G();
  return new Jm(new ba(n, void 0, t), (o) => (s.clear(), t(o, s)), void 0, void 0, () => s.dispose(), Qm);
}
function Fl(i, e) {
  let t, n;
  e === void 0 ? (t = i, n = void 0) : (n = i, t = e);
  const s = new G();
  return new Jm(new ba(n, void 0, t), (o) => {
    s.clear();
    const r = t(o);
    return r && s.add(r), r;
  }, void 0, void 0, () => s.dispose(), Qm);
}
(function(i) {
  UW = i;
})(_m);
class Jm extends P1 {
  get debugName() {
    var e;
    return (e = this._debugNameData.getDebugName(this)) !== null && e !== void 0 ? e : "(anonymous)";
  }
  constructor(e, t, n, s, o = void 0, r) {
    var a, l;
    super(), this._debugNameData = e, this._computeFn = t, this.createChangeSummary = n, this._handleChange = s, this._handleLastObserverRemoved = o, this._equalityComparator = r, this.state = 0, this.value = void 0, this.updateCount = 0, this.dependencies = /* @__PURE__ */ new Set(), this.dependenciesToBeRemoved = /* @__PURE__ */ new Set(), this.changeSummary = void 0, this.changeSummary = (a = this.createChangeSummary) === null || a === void 0 ? void 0 : a.call(this), (l = void 0) === null || l === void 0 || l.handleDerivedCreated(this);
  }
  onLastObserverRemoved() {
    var e;
    this.state = 0, this.value = void 0;
    for (const t of this.dependencies) t.removeObserver(this);
    this.dependencies.clear(), (e = this._handleLastObserverRemoved) === null || e === void 0 || e.call(this);
  }
  get() {
    var e;
    if (this.observers.size === 0) {
      const t = this._computeFn(this, (e = this.createChangeSummary) === null || e === void 0 ? void 0 : e.call(this));
      return this.onLastObserverRemoved(), t;
    }
    do {
      if (this.state === 1) {
        for (const t of this.dependencies) if (t.reportChanges(), this.state === 2) break;
      }
      this.state === 1 && (this.state = 3), this._recomputeIfNeeded();
    } while (this.state !== 3);
    return this.value;
  }
  _recomputeIfNeeded() {
    var e, t;
    if (this.state === 3) return;
    const n = this.dependenciesToBeRemoved;
    this.dependenciesToBeRemoved = this.dependencies, this.dependencies = n;
    const s = this.state !== 0, o = this.value;
    this.state = 3;
    const r = this.changeSummary;
    this.changeSummary = (e = this.createChangeSummary) === null || e === void 0 ? void 0 : e.call(this);
    try {
      this.value = this._computeFn(this, r);
    } finally {
      for (const l of this.dependenciesToBeRemoved) l.removeObserver(this);
      this.dependenciesToBeRemoved.clear();
    }
    const a = s && !this._equalityComparator(o, this.value);
    if ((t = void 0) === null || t === void 0 || t.handleDerivedRecomputed(this, { oldValue: o, newValue: this.value, change: void 0, didChange: a, hadValue: s }), a) for (const l of this.observers) l.handleChange(this, void 0);
  }
  toString() {
    return `LazyDerived<${this.debugName}>`;
  }
  beginUpdate(e) {
    this.updateCount++;
    const t = this.updateCount === 1;
    if (this.state === 3 && (this.state = 1, !t)) for (const n of this.observers) n.handlePossibleChange(this);
    if (t) for (const n of this.observers) n.beginUpdate(this);
  }
  endUpdate(e) {
    if (this.updateCount--, this.updateCount === 0) {
      const t = [...this.observers];
      for (const n of t) n.endUpdate(this);
    }
    cg(() => this.updateCount >= 0);
  }
  handlePossibleChange(e) {
    if (this.state === 3 && this.dependencies.has(e) && !this.dependenciesToBeRemoved.has(e)) {
      this.state = 1;
      for (const t of this.observers) t.handlePossibleChange(this);
    }
  }
  handleChange(e, t) {
    if (this.dependencies.has(e) && !this.dependenciesToBeRemoved.has(e)) {
      const n = !this._handleChange || this._handleChange({ changedObservable: e, change: t, didChange: (o) => o === e }, this.changeSummary), s = this.state === 3;
      if (n && (this.state === 1 || s) && (this.state = 2, s)) for (const o of this.observers) o.handlePossibleChange(this);
    }
  }
  readObservable(e) {
    e.addObserver(this);
    const t = e.get();
    return this.dependencies.add(e), this.dependenciesToBeRemoved.delete(e), t;
  }
  addObserver(e) {
    const t = !this.observers.has(e) && this.updateCount > 0;
    super.addObserver(e), t && e.beginUpdate(this);
  }
  removeObserver(e) {
    const t = this.observers.has(e) && this.updateCount > 0;
    super.removeObserver(e), t && e.endUpdate(this);
  }
}
function Ge(i) {
  return new xL(new ba(void 0, void 0, i), i, void 0, void 0);
}
function DL(i, e) {
  var t;
  return new xL(new ba(i.owner, i.debugName, (t = i.debugReferenceFn) !== null && t !== void 0 ? t : e), e, void 0, void 0);
}
function O1(i, e) {
  var t;
  return new xL(new ba(i.owner, i.debugName, (t = i.debugReferenceFn) !== null && t !== void 0 ? t : e), e, i.createEmptyChangeSummary, i.handleChange);
}
function nr(i) {
  const e = new G(), t = DL({ owner: void 0, debugName: void 0, debugReferenceFn: i }, (n) => {
    e.clear(), i(n, e);
  });
  return ye(() => {
    t.dispose(), e.dispose();
  });
}
class xL {
  get debugName() {
    var e;
    return (e = this._debugNameData.getDebugName(this)) !== null && e !== void 0 ? e : "(anonymous)";
  }
  constructor(e, t, n, s) {
    var o, r;
    this._debugNameData = e, this._runFn = t, this.createChangeSummary = n, this._handleChange = s, this.state = 2, this.updateCount = 0, this.disposed = !1, this.dependencies = /* @__PURE__ */ new Set(), this.dependenciesToBeRemoved = /* @__PURE__ */ new Set(), this.changeSummary = (o = this.createChangeSummary) === null || o === void 0 ? void 0 : o.call(this), (r = void 0) === null || r === void 0 || r.handleAutorunCreated(this), this._runIfNeeded();
  }
  dispose() {
    this.disposed = !0;
    for (const e of this.dependencies) e.removeObserver(this);
    this.dependencies.clear();
  }
  _runIfNeeded() {
    var e, t, n;
    if (this.state === 3) return;
    const s = this.dependenciesToBeRemoved;
    this.dependenciesToBeRemoved = this.dependencies, this.dependencies = s, this.state = 3;
    const o = this.disposed;
    try {
      if (!o) {
        (e = void 0) === null || e === void 0 || e.handleAutorunTriggered(this);
        const r = this.changeSummary;
        this.changeSummary = (t = this.createChangeSummary) === null || t === void 0 ? void 0 : t.call(this), this._runFn(this, r);
      }
    } finally {
      o || (n = void 0) === null || n === void 0 || n.handleAutorunFinished(this);
      for (const r of this.dependenciesToBeRemoved) r.removeObserver(this);
      this.dependenciesToBeRemoved.clear();
    }
  }
  toString() {
    return `Autorun<${this.debugName}>`;
  }
  beginUpdate() {
    this.state === 3 && (this.state = 1), this.updateCount++;
  }
  endUpdate() {
    if (this.updateCount === 1) do {
      if (this.state === 1) {
        this.state = 3;
        for (const e of this.dependencies) if (e.reportChanges(), this.state === 2) break;
      }
      this._runIfNeeded();
    } while (this.state !== 3);
    this.updateCount--, cg(() => this.updateCount >= 0);
  }
  handlePossibleChange(e) {
    this.state === 3 && this.dependencies.has(e) && !this.dependenciesToBeRemoved.has(e) && (this.state = 1);
  }
  handleChange(e, t) {
    this.dependencies.has(e) && !this.dependenciesToBeRemoved.has(e) && (!this._handleChange || this._handleChange({ changedObservable: e, change: t, didChange: (n) => n === e }, this.changeSummary)) && (this.state = 2);
  }
  readObservable(e) {
    if (this.disposed) return e.get();
    e.addObserver(this);
    const t = e.get();
    return this.dependencies.add(e), this.dependenciesToBeRemoved.delete(e), t;
  }
}
function ia(i) {
  return new Vee(i);
}
(function(i) {
  i.Observer = xL;
})(Ge || (Ge = {}));
class Vee extends KW {
  constructor(e) {
    super(), this.value = e;
  }
  get debugName() {
    return this.toString();
  }
  get() {
    return this.value;
  }
  addObserver(e) {
  }
  removeObserver(e) {
  }
  toString() {
    return `Const: ${this.value}`;
  }
}
function Rt(i, e) {
  return new Ru(i, e);
}
class Ru extends P1 {
  constructor(e, t) {
    super(), this.event = e, this._getValue = t, this.hasValue = !1, this.handleEvent = (n) => {
      var s;
      const o = this._getValue(n), r = this.value, a = !this.hasValue || r !== o;
      let l = !1;
      a && (this.value = o, this.hasValue && (l = !0, Rv(Ru.globalTransaction, (d) => {
        var h;
        (h = void 0) === null || h === void 0 || h.handleFromEventObservableTriggered(this, { oldValue: r, newValue: o, change: void 0, didChange: a, hadValue: this.hasValue });
        for (const c of this.observers) d.updateObserver(c, this), c.handleChange(this, void 0);
      }, () => {
        const d = this.getDebugName();
        return "Event fired" + (d ? `: ${d}` : "");
      })), this.hasValue = !0), l || (s = void 0) === null || s === void 0 || s.handleFromEventObservableTriggered(this, { oldValue: r, newValue: o, change: void 0, didChange: a, hadValue: this.hasValue });
    };
  }
  getDebugName() {
    return LL(this._getValue);
  }
  get debugName() {
    const e = this.getDebugName();
    return "From Event" + (e ? `: ${e}` : "");
  }
  onFirstObserverAdded() {
    this.subscription = this.event(this.handleEvent);
  }
  onLastObserverRemoved() {
    this.subscription.dispose(), this.subscription = void 0, this.hasValue = !1, this.value = void 0;
  }
  get() {
    return this.subscription ? (this.hasValue || this.handleEvent(void 0), this.value) : this._getValue(void 0);
  }
}
function Hn(i, e) {
  return new Hee(i, e);
}
(function(i) {
  i.Observer = Ru, i.batchEventsGlobally = function(e, t) {
    let n = !1;
    Ru.globalTransaction === void 0 && (Ru.globalTransaction = e, n = !0);
    try {
      t();
    } finally {
      n && (Ru.globalTransaction = void 0);
    }
  };
})(Rt || (Rt = {}));
class Hee extends P1 {
  constructor(e, t) {
    super(), this.debugName = e, this.event = t, this.handleEvent = () => {
      Tt((n) => {
        for (const s of this.observers) n.updateObserver(s, this), s.handleChange(this, void 0);
      }, () => this.debugName);
    };
  }
  onFirstObserverAdded() {
    this.subscription = this.event(this.handleEvent);
  }
  onLastObserverRemoved() {
    this.subscription.dispose(), this.subscription = void 0;
  }
  get() {
  }
}
function NL(i) {
  return typeof i == "string" ? new B3(i) : new B3(void 0, i);
}
class B3 extends P1 {
  get debugName() {
    var e;
    return (e = new ba(this._owner, this._debugName, void 0).getDebugName(this)) !== null && e !== void 0 ? e : "Observable Signal";
  }
  constructor(e, t) {
    super(), this._debugName = e, this._owner = t;
  }
  trigger(e, t) {
    if (e) for (const n of this.observers) e.updateObserver(n, this), n.handleChange(this, t);
    else Tt((n) => {
      this.trigger(n, t);
    }, () => `Trigger signal ${this.debugName}`);
  }
  get() {
  }
}
function F1(i, e) {
  const t = new zee(!0, e);
  return i.addObserver(t), e ? e(i.get()) : i.reportChanges(), ye(() => {
    i.removeObserver(t);
  });
}
(function(i) {
  zW = i;
})(F1);
class zee {
  constructor(e, t) {
    this._forceRecompute = e, this._handleValue = t, this._counter = 0;
  }
  beginUpdate(e) {
    this._counter++;
  }
  endUpdate(e) {
    this._counter--, this._counter === 0 && this._forceRecompute && (this._handleValue ? this._handleValue(e.get()) : e.reportChanges());
  }
  handlePossibleChange(e) {
  }
  handleChange(e, t) {
  }
}
class W3 {
  constructor(e, t) {
    this._map = e, this._keySelector = t, this._cache = /* @__PURE__ */ new Map(), this._items = [];
  }
  dispose() {
    this._cache.forEach((e) => e.store.dispose()), this._cache.clear();
  }
  setItems(e) {
    const t = [], n = new Set(this._cache.keys());
    for (const s of e) {
      const o = this._keySelector ? this._keySelector(s) : s;
      let r = this._cache.get(o);
      if (r) n.delete(o);
      else {
        const a = new G();
        r = { out: this._map(s, a), store: a }, this._cache.set(o, r);
      }
      t.push(r.out);
    }
    for (const s of n)
      this._cache.get(s).store.dispose(), this._cache.delete(s);
    this._items = t;
  }
  getItems() {
    return this._items;
  }
}
var ph = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
};
class Uee {
  constructor(e) {
    this.trait = e, this.renderedElements = [];
  }
  get templateId() {
    return `template:${this.trait.name}`;
  }
  renderTemplate(e) {
    return e;
  }
  renderElement(e, t, n) {
    const s = this.renderedElements.findIndex((o) => o.templateData === n);
    if (s >= 0) {
      const o = this.renderedElements[s];
      this.trait.unrender(n), o.index = t;
    } else {
      const o = { index: t, templateData: n };
      this.renderedElements.push(o);
    }
    this.trait.renderIndex(t, n);
  }
  splice(e, t, n) {
    const s = [];
    for (const o of this.renderedElements) o.index < e ? s.push(o) : o.index >= e + t && s.push({ index: o.index + n - t, templateData: o.templateData });
    this.renderedElements = s;
  }
  renderIndexes(e) {
    for (const { index: t, templateData: n } of this.renderedElements) e.indexOf(t) > -1 && this.trait.renderIndex(t, n);
  }
  disposeTemplate(e) {
    const t = this.renderedElements.findIndex((n) => n.templateData === e);
    t < 0 || this.renderedElements.splice(t, 1);
  }
}
let Oy = class {
  get name() {
    return this._trait;
  }
  get renderer() {
    return new Uee(this);
  }
  constructor(i) {
    this._trait = i, this.indexes = [], this.sortedIndexes = [], this._onChange = new F(), this.onChange = this._onChange.event;
  }
  splice(i, e, t) {
    const n = t.length - e, s = i + e, o = [];
    let r = 0;
    for (; r < this.sortedIndexes.length && this.sortedIndexes[r] < i; ) o.push(this.sortedIndexes[r++]);
    for (let a = 0; a < t.length; a++) t[a] && o.push(a + i);
    for (; r < this.sortedIndexes.length && this.sortedIndexes[r] >= s; ) o.push(this.sortedIndexes[r++] + n);
    this.renderer.splice(i, e, t.length), this._set(o, o);
  }
  renderIndex(i, e) {
    e.classList.toggle(this._trait, this.contains(i));
  }
  unrender(i) {
    i.classList.remove(this._trait);
  }
  set(i, e) {
    return this._set(i, [...i].sort(H3), e);
  }
  _set(i, e, t) {
    const n = this.indexes, s = this.sortedIndexes;
    this.indexes = i, this.sortedIndexes = e;
    const o = GI(s, i);
    return this.renderer.renderIndexes(o), this._onChange.fire({ indexes: i, browserEvent: t }), n;
  }
  get() {
    return this.indexes;
  }
  contains(i) {
    return U0(this.sortedIndexes, i, H3) >= 0;
  }
  dispose() {
    Ht(this._onChange);
  }
};
ph([Li], Oy.prototype, "renderer", null);
class Kee extends Oy {
  constructor(e) {
    super("selected"), this.setAriaSelected = e;
  }
  renderIndex(e, t) {
    super.renderIndex(e, t), this.setAriaSelected && (this.contains(e) ? t.setAttribute("aria-selected", "true") : t.setAttribute("aria-selected", "false"));
  }
}
class XD {
  constructor(e, t, n) {
    this.trait = e, this.view = t, this.identityProvider = n;
  }
  splice(e, t, n) {
    if (!this.identityProvider) return this.trait.splice(e, t, new Array(n.length).fill(!1));
    const s = this.trait.get().map((a) => this.identityProvider.getId(this.view.element(a)).toString());
    if (s.length === 0) return this.trait.splice(e, t, new Array(n.length).fill(!1));
    const o = new Set(s), r = n.map((a) => o.has(this.identityProvider.getId(a).toString()));
    this.trait.splice(e, t, r);
  }
}
function sc(i) {
  return i.tagName === "INPUT" || i.tagName === "TEXTAREA";
}
function Pv(i, e) {
  return !!i.classList.contains(e) || !i.classList.contains("monaco-list") && !!i.parentElement && Pv(i.parentElement, e);
}
function M_(i) {
  return Pv(i, "monaco-editor");
}
function v0(i) {
  return Pv(i, "monaco-tree-sticky-row");
}
function Ov(i) {
  return i.classList.contains("monaco-tree-sticky-container");
}
function jW(i) {
  return !!(i.tagName === "A" && i.classList.contains("monaco-button") || i.tagName === "DIV" && i.classList.contains("monaco-button-dropdown")) || !i.classList.contains("monaco-list") && !!i.parentElement && jW(i.parentElement);
}
class qW {
  get onKeyDown() {
    return se.chain(this.disposables.add(new st(this.view.domNode, "keydown")).event, (e) => e.filter((t) => !sc(t.target)).map((t) => new jt(t)));
  }
  constructor(e, t, n) {
    this.list = e, this.view = t, this.disposables = new G(), this.multipleSelectionDisposables = new G(), this.multipleSelectionSupport = n.multipleSelectionSupport, this.disposables.add(this.onKeyDown((s) => {
      switch (s.keyCode) {
        case 3:
          return this.onEnter(s);
        case 16:
          return this.onUpArrow(s);
        case 18:
          return this.onDownArrow(s);
        case 11:
          return this.onPageUpArrow(s);
        case 12:
          return this.onPageDownArrow(s);
        case 9:
          return this.onEscape(s);
        case 31:
          this.multipleSelectionSupport && (Je ? s.metaKey : s.ctrlKey) && this.onCtrlA(s);
      }
    }));
  }
  updateOptions(e) {
    e.multipleSelectionSupport !== void 0 && (this.multipleSelectionSupport = e.multipleSelectionSupport);
  }
  onEnter(e) {
    e.preventDefault(), e.stopPropagation(), this.list.setSelection(this.list.getFocus(), e.browserEvent);
  }
  onUpArrow(e) {
    e.preventDefault(), e.stopPropagation(), this.list.focusPrevious(1, !1, e.browserEvent);
    const t = this.list.getFocus()[0];
    this.list.setAnchor(t), this.list.reveal(t), this.view.domNode.focus();
  }
  onDownArrow(e) {
    e.preventDefault(), e.stopPropagation(), this.list.focusNext(1, !1, e.browserEvent);
    const t = this.list.getFocus()[0];
    this.list.setAnchor(t), this.list.reveal(t), this.view.domNode.focus();
  }
  onPageUpArrow(e) {
    e.preventDefault(), e.stopPropagation(), this.list.focusPreviousPage(e.browserEvent);
    const t = this.list.getFocus()[0];
    this.list.setAnchor(t), this.list.reveal(t), this.view.domNode.focus();
  }
  onPageDownArrow(e) {
    e.preventDefault(), e.stopPropagation(), this.list.focusNextPage(e.browserEvent);
    const t = this.list.getFocus()[0];
    this.list.setAnchor(t), this.list.reveal(t), this.view.domNode.focus();
  }
  onCtrlA(e) {
    e.preventDefault(), e.stopPropagation(), this.list.setSelection(Ds(this.list.length), e.browserEvent), this.list.setAnchor(void 0), this.view.domNode.focus();
  }
  onEscape(e) {
    this.list.getSelection().length && (e.preventDefault(), e.stopPropagation(), this.list.setSelection([], e.browserEvent), this.list.setAnchor(void 0), this.view.domNode.focus());
  }
  dispose() {
    this.disposables.dispose(), this.multipleSelectionDisposables.dispose();
  }
}
var Qa, zp;
ph([Li], qW.prototype, "onKeyDown", null), function(i) {
  i[i.Automatic = 0] = "Automatic", i[i.Trigger = 1] = "Trigger";
}(Qa || (Qa = {})), function(i) {
  i[i.Idle = 0] = "Idle", i[i.Typing = 1] = "Typing";
}(zp || (zp = {}));
const jee = new class {
  mightProducePrintableCharacter(i) {
    return !(i.ctrlKey || i.metaKey || i.altKey) && (i.keyCode >= 31 && i.keyCode <= 56 || i.keyCode >= 21 && i.keyCode <= 30 || i.keyCode >= 98 && i.keyCode <= 107 || i.keyCode >= 85 && i.keyCode <= 95);
  }
}();
class qee {
  constructor(e, t, n, s, o) {
    this.list = e, this.view = t, this.keyboardNavigationLabelProvider = n, this.keyboardNavigationEventFilter = s, this.delegate = o, this.enabled = !1, this.state = zp.Idle, this.mode = Qa.Automatic, this.triggered = !1, this.previouslyFocused = -1, this.enabledDisposables = new G(), this.disposables = new G(), this.updateOptions(e.options);
  }
  updateOptions(e) {
    var t, n;
    (t = e.typeNavigationEnabled) === null || t === void 0 || t ? this.enable() : this.disable(), this.mode = (n = e.typeNavigationMode) !== null && n !== void 0 ? n : Qa.Automatic;
  }
  enable() {
    if (this.enabled) return;
    let e = !1;
    const t = se.chain(this.enabledDisposables.add(new st(this.view.domNode, "keydown")).event, (s) => s.filter((o) => !sc(o.target)).filter(() => this.mode === Qa.Automatic || this.triggered).map((o) => new jt(o)).filter((o) => e || this.keyboardNavigationEventFilter(o)).filter((o) => this.delegate.mightProducePrintableCharacter(o)).forEach((o) => Ze(o, !0)).map((o) => o.browserEvent.key)), n = se.debounce(t, () => null, 800, void 0, void 0, void 0, this.enabledDisposables);
    se.reduce(se.any(t, n), (s, o) => o === null ? null : (s || "") + o, void 0, this.enabledDisposables)(this.onInput, this, this.enabledDisposables), n(this.onClear, this, this.enabledDisposables), t(() => e = !0, void 0, this.enabledDisposables), n(() => e = !1, void 0, this.enabledDisposables), this.enabled = !0, this.triggered = !1;
  }
  disable() {
    this.enabled && (this.enabledDisposables.clear(), this.enabled = !1, this.triggered = !1);
  }
  onClear() {
    var e;
    const t = this.list.getFocus();
    if (t.length > 0 && t[0] === this.previouslyFocused) {
      const n = (e = this.list.options.accessibilityProvider) === null || e === void 0 ? void 0 : e.getAriaLabel(this.list.element(t[0]));
      typeof n == "string" ? Io(n) : n && Io(n.get());
    }
    this.previouslyFocused = -1;
  }
  onInput(e) {
    if (!e) return this.state = zp.Idle, void (this.triggered = !1);
    const t = this.list.getFocus(), n = t.length > 0 ? t[0] : 0, s = this.state === zp.Idle ? 1 : 0;
    this.state = zp.Typing;
    for (let o = 0; o < this.list.length; o++) {
      const r = (n + o + s) % this.list.length, a = this.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(this.view.element(r)), l = a && a.toString();
      if (this.list.options.typeNavigationEnabled) {
        if (l !== void 0) {
          if (xv(e, l)) return this.previouslyFocused = n, this.list.setFocus([r]), void this.list.reveal(r);
          const d = MJ(e, l);
          if (d && d[0].end - d[0].start > 1 && d.length === 1)
            return this.previouslyFocused = n, this.list.setFocus([r]), void this.list.reveal(r);
        }
      } else if (l === void 0 || xv(e, l)) return this.previouslyFocused = n, this.list.setFocus([r]), void this.list.reveal(r);
    }
  }
  dispose() {
    this.disable(), this.enabledDisposables.dispose(), this.disposables.dispose();
  }
}
class $ee {
  constructor(e, t) {
    this.list = e, this.view = t, this.disposables = new G();
    const n = se.chain(this.disposables.add(new st(t.domNode, "keydown")).event, (o) => o.filter((r) => !sc(r.target)).map((r) => new jt(r)));
    se.chain(n, (o) => o.filter((r) => !(r.keyCode !== 2 || r.ctrlKey || r.metaKey || r.shiftKey || r.altKey)))(this.onTab, this, this.disposables);
  }
  onTab(e) {
    if (e.target !== this.view.domNode) return;
    const t = this.list.getFocus();
    if (t.length === 0) return;
    const n = this.view.domElement(t[0]);
    if (!n) return;
    const s = n.querySelector("[tabIndex]");
    if (!(s && s instanceof HTMLElement && s.tabIndex !== -1)) return;
    const o = ke(s).getComputedStyle(s);
    o.visibility !== "hidden" && o.display !== "none" && (e.preventDefault(), e.stopPropagation(), s.focus());
  }
  dispose() {
    this.disposables.dispose();
  }
}
function $W(i) {
  return Je ? i.browserEvent.metaKey : i.browserEvent.ctrlKey;
}
function GW(i) {
  return i.browserEvent.shiftKey;
}
const V3 = { isSelectionSingleChangeEvent: $W, isSelectionRangeChangeEvent: GW };
class ZW {
  constructor(e) {
    this.list = e, this.disposables = new G(), this._onPointer = new F(), this.onPointer = this._onPointer.event, e.options.multipleSelectionSupport !== !1 && (this.multipleSelectionController = this.list.options.multipleSelectionController || V3), this.mouseSupport = e.options.mouseSupport === void 0 || !!e.options.mouseSupport, this.mouseSupport && (e.onMouseDown(this.onMouseDown, this, this.disposables), e.onContextMenu(this.onContextMenu, this, this.disposables), e.onMouseDblClick(this.onDoubleClick, this, this.disposables), e.onTouchStart(this.onMouseDown, this, this.disposables), this.disposables.add(Bt.addTarget(e.getHTMLElement()))), se.any(e.onMouseClick, e.onMouseMiddleClick, e.onTap)(this.onViewPointer, this, this.disposables);
  }
  updateOptions(e) {
    e.multipleSelectionSupport !== void 0 && (this.multipleSelectionController = void 0, e.multipleSelectionSupport && (this.multipleSelectionController = this.list.options.multipleSelectionController || V3));
  }
  isSelectionSingleChangeEvent(e) {
    return !!this.multipleSelectionController && this.multipleSelectionController.isSelectionSingleChangeEvent(e);
  }
  isSelectionRangeChangeEvent(e) {
    return !!this.multipleSelectionController && this.multipleSelectionController.isSelectionRangeChangeEvent(e);
  }
  isSelectionChangeEvent(e) {
    return this.isSelectionSingleChangeEvent(e) || this.isSelectionRangeChangeEvent(e);
  }
  onMouseDown(e) {
    M_(e.browserEvent.target) || Mn() !== e.browserEvent.target && this.list.domFocus();
  }
  onContextMenu(e) {
    if (sc(e.browserEvent.target) || M_(e.browserEvent.target)) return;
    const t = e.index === void 0 ? [] : [e.index];
    this.list.setFocus(t, e.browserEvent);
  }
  onViewPointer(e) {
    if (!this.mouseSupport || sc(e.browserEvent.target) || M_(e.browserEvent.target) || e.browserEvent.isHandledByList) return;
    e.browserEvent.isHandledByList = !0;
    const t = e.index;
    return t === void 0 ? (this.list.setFocus([], e.browserEvent), this.list.setSelection([], e.browserEvent), void this.list.setAnchor(void 0)) : this.isSelectionChangeEvent(e) ? this.changeSelection(e) : (this.list.setFocus([t], e.browserEvent), this.list.setAnchor(t), fR(n = e.browserEvent) && n.button === 2 || this.list.setSelection([t], e.browserEvent), void this._onPointer.fire(e));
    var n;
  }
  onDoubleClick(e) {
    if (sc(e.browserEvent.target) || M_(e.browserEvent.target) || this.isSelectionChangeEvent(e) || e.browserEvent.isHandledByList) return;
    e.browserEvent.isHandledByList = !0;
    const t = this.list.getFocus();
    this.list.setSelection(t, e.browserEvent);
  }
  changeSelection(e) {
    const t = e.index;
    let n = this.list.getAnchor();
    if (this.isSelectionRangeChangeEvent(e)) {
      if (n === void 0) {
        const l = this.list.getFocus()[0];
        n = l ?? t, this.list.setAnchor(n);
      }
      const s = Ds(Math.min(n, t), Math.max(n, t) + 1), o = this.list.getSelection(), r = function(l, d) {
        const h = l.indexOf(d);
        if (h === -1) return [];
        const c = [];
        let u = h - 1;
        for (; u >= 0 && l[u] === d - (h - u); ) c.push(l[u--]);
        for (c.reverse(), u = h; u < l.length && l[u] === d + (u - h); ) c.push(l[u++]);
        return c;
      }(GI(o, [n]), n);
      if (r.length === 0) return;
      const a = GI(s, function(l, d) {
        const h = [];
        let c = 0, u = 0;
        for (; c < l.length || u < d.length; ) if (c >= l.length) h.push(d[u++]);
        else if (u >= d.length) h.push(l[c++]);
        else {
          if (l[c] === d[u]) {
            c++, u++;
            continue;
          }
          l[c] < d[u] ? h.push(l[c++]) : u++;
        }
        return h;
      }(o, r));
      this.list.setSelection(a, e.browserEvent), this.list.setFocus([t], e.browserEvent);
    } else if (this.isSelectionSingleChangeEvent(e)) {
      const s = this.list.getSelection(), o = s.filter((r) => r !== t);
      this.list.setFocus([t]), this.list.setAnchor(t), s.length === o.length ? this.list.setSelection([...o, t], e.browserEvent) : this.list.setSelection(o, e.browserEvent);
    }
  }
  dispose() {
    this.disposables.dispose();
  }
}
class YW {
  constructor(e, t) {
    this.styleElement = e, this.selectorSuffix = t;
  }
  style(e) {
    var t, n;
    const s = this.selectorSuffix && `.${this.selectorSuffix}`, o = [];
    e.listBackground && o.push(`.monaco-list${s} .monaco-list-rows { background: ${e.listBackground}; }`), e.listFocusBackground && (o.push(`.monaco-list${s}:focus .monaco-list-row.focused { background-color: ${e.listFocusBackground}; }`), o.push(`.monaco-list${s}:focus .monaco-list-row.focused:hover { background-color: ${e.listFocusBackground}; }`)), e.listFocusForeground && o.push(`.monaco-list${s}:focus .monaco-list-row.focused { color: ${e.listFocusForeground}; }`), e.listActiveSelectionBackground && (o.push(`.monaco-list${s}:focus .monaco-list-row.selected { background-color: ${e.listActiveSelectionBackground}; }`), o.push(`.monaco-list${s}:focus .monaco-list-row.selected:hover { background-color: ${e.listActiveSelectionBackground}; }`)), e.listActiveSelectionForeground && o.push(`.monaco-list${s}:focus .monaco-list-row.selected { color: ${e.listActiveSelectionForeground}; }`), e.listActiveSelectionIconForeground && o.push(`.monaco-list${s}:focus .monaco-list-row.selected .codicon { color: ${e.listActiveSelectionIconForeground}; }`), e.listFocusAndSelectionBackground && o.push(`
				.monaco-drag-image,
				.monaco-list${s}:focus .monaco-list-row.selected.focused { background-color: ${e.listFocusAndSelectionBackground}; }
			`), e.listFocusAndSelectionForeground && o.push(`
				.monaco-drag-image,
				.monaco-list${s}:focus .monaco-list-row.selected.focused { color: ${e.listFocusAndSelectionForeground}; }
			`), e.listInactiveFocusForeground && (o.push(`.monaco-list${s} .monaco-list-row.focused { color:  ${e.listInactiveFocusForeground}; }`), o.push(`.monaco-list${s} .monaco-list-row.focused:hover { color:  ${e.listInactiveFocusForeground}; }`)), e.listInactiveSelectionIconForeground && o.push(`.monaco-list${s} .monaco-list-row.focused .codicon { color:  ${e.listInactiveSelectionIconForeground}; }`), e.listInactiveFocusBackground && (o.push(`.monaco-list${s} .monaco-list-row.focused { background-color:  ${e.listInactiveFocusBackground}; }`), o.push(`.monaco-list${s} .monaco-list-row.focused:hover { background-color:  ${e.listInactiveFocusBackground}; }`)), e.listInactiveSelectionBackground && (o.push(`.monaco-list${s} .monaco-list-row.selected { background-color:  ${e.listInactiveSelectionBackground}; }`), o.push(`.monaco-list${s} .monaco-list-row.selected:hover { background-color:  ${e.listInactiveSelectionBackground}; }`)), e.listInactiveSelectionForeground && o.push(`.monaco-list${s} .monaco-list-row.selected { color: ${e.listInactiveSelectionForeground}; }`), e.listHoverBackground && o.push(`.monaco-list${s}:not(.drop-target):not(.dragging) .monaco-list-row:hover:not(.selected):not(.focused) { background-color: ${e.listHoverBackground}; }`), e.listHoverForeground && o.push(`.monaco-list${s}:not(.drop-target):not(.dragging) .monaco-list-row:hover:not(.selected):not(.focused) { color:  ${e.listHoverForeground}; }`);
    const r = kd(e.listFocusAndSelectionOutline, kd(e.listSelectionOutline, (t = e.listFocusOutline) !== null && t !== void 0 ? t : ""));
    r && o.push(`.monaco-list${s}:focus .monaco-list-row.focused.selected { outline: 1px solid ${r}; outline-offset: -1px;}`), e.listFocusOutline && o.push(`
				.monaco-drag-image,
				.monaco-list${s}:focus .monaco-list-row.focused { outline: 1px solid ${e.listFocusOutline}; outline-offset: -1px; }
				.monaco-workbench.context-menu-visible .monaco-list${s}.last-focused .monaco-list-row.focused { outline: 1px solid ${e.listFocusOutline}; outline-offset: -1px; }
			`);
    const a = kd(e.listSelectionOutline, (n = e.listInactiveFocusOutline) !== null && n !== void 0 ? n : "");
    a && o.push(`.monaco-list${s} .monaco-list-row.focused.selected { outline: 1px dotted ${a}; outline-offset: -1px; }`), e.listSelectionOutline && o.push(`.monaco-list${s} .monaco-list-row.selected { outline: 1px dotted ${e.listSelectionOutline}; outline-offset: -1px; }`), e.listInactiveFocusOutline && o.push(`.monaco-list${s} .monaco-list-row.focused { outline: 1px dotted ${e.listInactiveFocusOutline}; outline-offset: -1px; }`), e.listHoverOutline && o.push(`.monaco-list${s} .monaco-list-row:hover { outline: 1px dashed ${e.listHoverOutline}; outline-offset: -1px; }`), e.listDropOverBackground && o.push(`
				.monaco-list${s}.drop-target,
				.monaco-list${s} .monaco-list-rows.drop-target,
				.monaco-list${s} .monaco-list-row.drop-target { background-color: ${e.listDropOverBackground} !important; color: inherit !important; }
			`), e.listDropBetweenBackground && (o.push(`
			.monaco-list${s} .monaco-list-rows.drop-target-before .monaco-list-row:first-child::before,
			.monaco-list${s} .monaco-list-row.drop-target-before::before {
				content: ""; position: absolute; top: 0px; left: 0px; width: 100%; height: 1px;
				background-color: ${e.listDropBetweenBackground};
			}`), o.push(`
			.monaco-list${s} .monaco-list-rows.drop-target-after .monaco-list-row:last-child::after,
			.monaco-list${s} .monaco-list-row.drop-target-after::after {
				content: ""; position: absolute; bottom: 0px; left: 0px; width: 100%; height: 1px;
				background-color: ${e.listDropBetweenBackground};
			}`)), e.tableColumnsBorder && o.push(`
				.monaco-table > .monaco-split-view2,
				.monaco-table > .monaco-split-view2 .monaco-sash.vertical::before,
				.monaco-workbench:not(.reduce-motion) .monaco-table:hover > .monaco-split-view2,
				.monaco-workbench:not(.reduce-motion) .monaco-table:hover > .monaco-split-view2 .monaco-sash.vertical::before {
					border-color: ${e.tableColumnsBorder};
				}

				.monaco-workbench:not(.reduce-motion) .monaco-table > .monaco-split-view2,
				.monaco-workbench:not(.reduce-motion) .monaco-table > .monaco-split-view2 .monaco-sash.vertical::before {
					border-color: transparent;
				}
			`), e.tableOddRowsBackgroundColor && o.push(`
				.monaco-table .monaco-list-row[data-parity=odd]:not(.focused):not(.selected):not(:hover) .monaco-table-tr,
				.monaco-table .monaco-list:not(:focus) .monaco-list-row[data-parity=odd].focused:not(.selected):not(:hover) .monaco-table-tr,
				.monaco-table .monaco-list:not(.focused) .monaco-list-row[data-parity=odd].focused:not(.selected):not(:hover) .monaco-table-tr {
					background-color: ${e.tableOddRowsBackgroundColor};
				}
			`), this.styleElement.textContent = o.join(`
`);
  }
}
const Gee = { listFocusBackground: "#7FB0D0", listActiveSelectionBackground: "#0E639C", listActiveSelectionForeground: "#FFFFFF", listActiveSelectionIconForeground: "#FFFFFF", listFocusAndSelectionOutline: "#90C2F9", listFocusAndSelectionBackground: "#094771", listFocusAndSelectionForeground: "#FFFFFF", listInactiveSelectionBackground: "#3F3F46", listInactiveSelectionIconForeground: "#FFFFFF", listHoverBackground: "#2A2D2E", listDropOverBackground: "#383B3D", listDropBetweenBackground: "#EEEEEE", treeIndentGuidesStroke: "#a9a9a9", treeInactiveIndentGuidesStroke: z.fromHex("#a9a9a9").transparent(0.4).toString(), tableColumnsBorder: z.fromHex("#cccccc").transparent(0.2).toString(), tableOddRowsBackgroundColor: z.fromHex("#cccccc").transparent(0.04).toString(), listBackground: void 0, listFocusForeground: void 0, listInactiveSelectionForeground: void 0, listInactiveFocusForeground: void 0, listInactiveFocusBackground: void 0, listHoverForeground: void 0, listFocusOutline: void 0, listInactiveFocusOutline: void 0, listSelectionOutline: void 0, listHoverOutline: void 0 }, Zee = { keyboardSupport: !0, mouseSupport: !0, multipleSelectionSupport: !0, dnd: { getDragURI: () => null, onDragStart() {
}, onDragOver: () => !1, drop() {
}, dispose() {
} } };
function GI(i, e) {
  const t = [];
  let n = 0, s = 0;
  for (; n < i.length || s < e.length; ) if (n >= i.length) t.push(e[s++]);
  else if (s >= e.length) t.push(i[n++]);
  else {
    if (i[n] === e[s]) {
      t.push(i[n]), n++, s++;
      continue;
    }
    i[n] < e[s] ? t.push(i[n++]) : t.push(e[s++]);
  }
  return t;
}
const H3 = (i, e) => i - e;
class Yee {
  constructor(e, t) {
    this._templateId = e, this.renderers = t;
  }
  get templateId() {
    return this._templateId;
  }
  renderTemplate(e) {
    return this.renderers.map((t) => t.renderTemplate(e));
  }
  renderElement(e, t, n, s) {
    let o = 0;
    for (const r of this.renderers) r.renderElement(e, t, n[o++], s);
  }
  disposeElement(e, t, n, s) {
    var o;
    let r = 0;
    for (const a of this.renderers) (o = a.disposeElement) === null || o === void 0 || o.call(a, e, t, n[r], s), r += 1;
  }
  disposeTemplate(e) {
    let t = 0;
    for (const n of this.renderers) n.disposeTemplate(e[t++]);
  }
}
class Xee {
  constructor(e) {
    this.accessibilityProvider = e, this.templateId = "a18n";
  }
  renderTemplate(e) {
    return { container: e, disposables: new G() };
  }
  renderElement(e, t, n) {
    const s = this.accessibilityProvider.getAriaLabel(e), o = s && typeof s != "string" ? s : ia(s);
    n.disposables.add(Ge((a) => {
      this.setAriaLabel(a.readObservable(o), n.container);
    }));
    const r = this.accessibilityProvider.getAriaLevel && this.accessibilityProvider.getAriaLevel(e);
    typeof r == "number" ? n.container.setAttribute("aria-level", `${r}`) : n.container.removeAttribute("aria-level");
  }
  setAriaLabel(e, t) {
    e ? t.setAttribute("aria-label", e) : t.removeAttribute("aria-label");
  }
  disposeElement(e, t, n, s) {
    n.disposables.clear();
  }
  disposeTemplate(e) {
    e.disposables.dispose();
  }
}
class Qee {
  constructor(e, t) {
    this.list = e, this.dnd = t;
  }
  getDragElements(e) {
    const t = this.list.getSelectedElements();
    return t.indexOf(e) > -1 ? t : [e];
  }
  getDragURI(e) {
    return this.dnd.getDragURI(e);
  }
  getDragLabel(e, t) {
    if (this.dnd.getDragLabel) return this.dnd.getDragLabel(e, t);
  }
  onDragStart(e, t) {
    var n, s;
    (s = (n = this.dnd).onDragStart) === null || s === void 0 || s.call(n, e, t);
  }
  onDragOver(e, t, n, s, o) {
    return this.dnd.onDragOver(e, t, n, s, o);
  }
  onDragLeave(e, t, n, s) {
    var o, r;
    (r = (o = this.dnd).onDragLeave) === null || r === void 0 || r.call(o, e, t, n, s);
  }
  onDragEnd(e) {
    var t, n;
    (n = (t = this.dnd).onDragEnd) === null || n === void 0 || n.call(t, e);
  }
  drop(e, t, n, s, o) {
    this.dnd.drop(e, t, n, s, o);
  }
  dispose() {
    this.dnd.dispose();
  }
}
class uo {
  get onDidChangeFocus() {
    return se.map(this.eventBufferer.wrapEvent(this.focus.onChange), (e) => this.toListEvent(e), this.disposables);
  }
  get onDidChangeSelection() {
    return se.map(this.eventBufferer.wrapEvent(this.selection.onChange), (e) => this.toListEvent(e), this.disposables);
  }
  get domId() {
    return this.view.domId;
  }
  get onDidScroll() {
    return this.view.onDidScroll;
  }
  get onMouseClick() {
    return this.view.onMouseClick;
  }
  get onMouseDblClick() {
    return this.view.onMouseDblClick;
  }
  get onMouseMiddleClick() {
    return this.view.onMouseMiddleClick;
  }
  get onPointer() {
    return this.mouseController.onPointer;
  }
  get onMouseDown() {
    return this.view.onMouseDown;
  }
  get onMouseOver() {
    return this.view.onMouseOver;
  }
  get onMouseOut() {
    return this.view.onMouseOut;
  }
  get onTouchStart() {
    return this.view.onTouchStart;
  }
  get onTap() {
    return this.view.onTap;
  }
  get onContextMenu() {
    let e = !1;
    const t = se.chain(this.disposables.add(new st(this.view.domNode, "keydown")).event, (o) => o.map((r) => new jt(r)).filter((r) => e = r.keyCode === 58 || r.shiftKey && r.keyCode === 68).map((r) => Ze(r, !0)).filter(() => !1)), n = se.chain(this.disposables.add(new st(this.view.domNode, "keyup")).event, (o) => o.forEach(() => e = !1).map((r) => new jt(r)).filter((r) => r.keyCode === 58 || r.shiftKey && r.keyCode === 68).map((r) => Ze(r, !0)).map(({ browserEvent: r }) => {
      const a = this.getFocus(), l = a.length ? a[0] : void 0;
      return { index: l, element: l !== void 0 ? this.view.element(l) : void 0, anchor: l !== void 0 ? this.view.domElement(l) : this.view.domNode, browserEvent: r };
    })), s = se.chain(this.view.onContextMenu, (o) => o.filter((r) => !e).map(({ element: r, index: a, browserEvent: l }) => ({ element: r, index: a, anchor: new _r(ke(this.view.domNode), l), browserEvent: l })));
    return se.any(t, n, s);
  }
  get onKeyDown() {
    return this.disposables.add(new st(this.view.domNode, "keydown")).event;
  }
  get onDidFocus() {
    return se.signal(this.disposables.add(new st(this.view.domNode, "focus", !0)).event);
  }
  get onDidBlur() {
    return se.signal(this.disposables.add(new st(this.view.domNode, "blur", !0)).event);
  }
  constructor(e, t, n, s, o = Zee) {
    var r, a, l, d;
    this.user = e, this._options = o, this.focus = new Oy("focused"), this.anchor = new Oy("anchor"), this.eventBufferer = new eR(), this._ariaLabel = "", this.disposables = new G(), this._onDidDispose = new F(), this.onDidDispose = this._onDidDispose.event;
    const h = this._options.accessibilityProvider && this._options.accessibilityProvider.getWidgetRole ? (r = this._options.accessibilityProvider) === null || r === void 0 ? void 0 : r.getWidgetRole() : "list";
    this.selection = new Kee(h !== "listbox");
    const c = [this.focus.renderer, this.selection.renderer];
    this.accessibilityProvider = o.accessibilityProvider, this.accessibilityProvider && (c.push(new Xee(this.accessibilityProvider)), (l = (a = this.accessibilityProvider).onDidChangeActiveDescendant) === null || l === void 0 || l.call(a, this.onDidChangeActiveDescendant, this, this.disposables)), s = s.map((g) => new Yee(g.templateId, [...c, g]));
    const u = { ...o, dnd: o.dnd && new Qee(this, o.dnd) };
    if (this.view = this.createListView(t, n, s, u), this.view.domNode.setAttribute("role", h), o.styleController) this.styleController = o.styleController(this.view.domId);
    else {
      const g = Lo(this.view.domNode);
      this.styleController = new YW(g, this.view.domId);
    }
    if (this.spliceable = new Aee([new XD(this.focus, this.view, o.identityProvider), new XD(this.selection, this.view, o.identityProvider), new XD(this.anchor, this.view, o.identityProvider), this.view]), this.disposables.add(this.focus), this.disposables.add(this.selection), this.disposables.add(this.anchor), this.disposables.add(this.view), this.disposables.add(this._onDidDispose), this.disposables.add(new $ee(this, this.view)), (typeof o.keyboardSupport != "boolean" || o.keyboardSupport) && (this.keyboardController = new qW(this, this.view, o), this.disposables.add(this.keyboardController)), o.keyboardNavigationLabelProvider) {
      const g = o.keyboardNavigationDelegate || jee;
      this.typeNavigationController = new qee(this, this.view, o.keyboardNavigationLabelProvider, (d = o.keyboardNavigationEventFilter) !== null && d !== void 0 ? d : () => !0, g), this.disposables.add(this.typeNavigationController);
    }
    this.mouseController = this.createMouseController(o), this.disposables.add(this.mouseController), this.onDidChangeFocus(this._onFocusChange, this, this.disposables), this.onDidChangeSelection(this._onSelectionChange, this, this.disposables), this.accessibilityProvider && (this.ariaLabel = this.accessibilityProvider.getWidgetAriaLabel()), this._options.multipleSelectionSupport !== !1 && this.view.domNode.setAttribute("aria-multiselectable", "true");
  }
  createListView(e, t, n, s) {
    return new Oo(e, t, n, s);
  }
  createMouseController(e) {
    return new ZW(this);
  }
  updateOptions(e = {}) {
    var t, n;
    this._options = { ...this._options, ...e }, (t = this.typeNavigationController) === null || t === void 0 || t.updateOptions(this._options), this._options.multipleSelectionController !== void 0 && (this._options.multipleSelectionSupport ? this.view.domNode.setAttribute("aria-multiselectable", "true") : this.view.domNode.removeAttribute("aria-multiselectable")), this.mouseController.updateOptions(e), (n = this.keyboardController) === null || n === void 0 || n.updateOptions(e), this.view.updateOptions(e);
  }
  get options() {
    return this._options;
  }
  splice(e, t, n = []) {
    if (e < 0 || e > this.view.length) throw new Gc(this.user, `Invalid start index: ${e}`);
    if (t < 0) throw new Gc(this.user, `Invalid delete count: ${t}`);
    t === 0 && n.length === 0 || this.eventBufferer.bufferEvents(() => this.spliceable.splice(e, t, n));
  }
  rerender() {
    this.view.rerender();
  }
  element(e) {
    return this.view.element(e);
  }
  indexOf(e) {
    return this.view.indexOf(e);
  }
  indexAt(e) {
    return this.view.indexAt(e);
  }
  get length() {
    return this.view.length;
  }
  get contentHeight() {
    return this.view.contentHeight;
  }
  get onDidChangeContentHeight() {
    return this.view.onDidChangeContentHeight;
  }
  get scrollTop() {
    return this.view.getScrollTop();
  }
  set scrollTop(e) {
    this.view.setScrollTop(e);
  }
  get scrollHeight() {
    return this.view.scrollHeight;
  }
  get renderHeight() {
    return this.view.renderHeight;
  }
  get firstVisibleIndex() {
    return this.view.firstVisibleIndex;
  }
  get ariaLabel() {
    return this._ariaLabel;
  }
  set ariaLabel(e) {
    this._ariaLabel = e, this.view.domNode.setAttribute("aria-label", e);
  }
  domFocus() {
    this.view.domNode.focus({ preventScroll: !0 });
  }
  layout(e, t) {
    this.view.layout(e, t);
  }
  setSelection(e, t) {
    for (const n of e) if (n < 0 || n >= this.length) throw new Gc(this.user, `Invalid index ${n}`);
    this.selection.set(e, t);
  }
  getSelection() {
    return this.selection.get();
  }
  getSelectedElements() {
    return this.getSelection().map((e) => this.view.element(e));
  }
  setAnchor(e) {
    if (e !== void 0) {
      if (e < 0 || e >= this.length) throw new Gc(this.user, `Invalid index ${e}`);
      this.anchor.set([e]);
    } else this.anchor.set([]);
  }
  getAnchor() {
    return UT(this.anchor.get(), void 0);
  }
  getAnchorElement() {
    const e = this.getAnchor();
    return e === void 0 ? void 0 : this.element(e);
  }
  setFocus(e, t) {
    for (const n of e) if (n < 0 || n >= this.length) throw new Gc(this.user, `Invalid index ${n}`);
    this.focus.set(e, t);
  }
  focusNext(e = 1, t = !1, n, s) {
    if (this.length === 0) return;
    const o = this.focus.get(), r = this.findNextIndex(o.length > 0 ? o[0] + e : 0, t, s);
    r > -1 && this.setFocus([r], n);
  }
  focusPrevious(e = 1, t = !1, n, s) {
    if (this.length === 0) return;
    const o = this.focus.get(), r = this.findPreviousIndex(o.length > 0 ? o[0] - e : 0, t, s);
    r > -1 && this.setFocus([r], n);
  }
  async focusNextPage(e, t) {
    let n = this.view.indexAt(this.view.getScrollTop() + this.view.renderHeight);
    n = n === 0 ? 0 : n - 1;
    const s = this.getFocus()[0];
    if (s !== n && (s === void 0 || n > s)) {
      const o = this.findPreviousIndex(n, !1, t);
      o > -1 && s !== o ? this.setFocus([o], e) : this.setFocus([n], e);
    } else {
      const o = this.view.getScrollTop();
      let r = o + this.view.renderHeight;
      n > s && (r -= this.view.elementHeight(n)), this.view.setScrollTop(r), this.view.getScrollTop() !== o && (this.setFocus([]), await bc(0), await this.focusNextPage(e, t));
    }
  }
  async focusPreviousPage(e, t, n = () => 0) {
    let s;
    const o = n(), r = this.view.getScrollTop() + o;
    s = r === 0 ? this.view.indexAt(r) : this.view.indexAfter(r - 1);
    const a = this.getFocus()[0];
    if (a !== s && (a === void 0 || a >= s)) {
      const l = this.findNextIndex(s, !1, t);
      l > -1 && a !== l ? this.setFocus([l], e) : this.setFocus([s], e);
    } else {
      const l = r;
      this.view.setScrollTop(r - this.view.renderHeight - o), this.view.getScrollTop() + n() !== l && (this.setFocus([]), await bc(0), await this.focusPreviousPage(e, t, n));
    }
  }
  focusLast(e, t) {
    if (this.length === 0) return;
    const n = this.findPreviousIndex(this.length - 1, !1, t);
    n > -1 && this.setFocus([n], e);
  }
  focusFirst(e, t) {
    this.focusNth(0, e, t);
  }
  focusNth(e, t, n) {
    if (this.length === 0) return;
    const s = this.findNextIndex(e, !1, n);
    s > -1 && this.setFocus([s], t);
  }
  findNextIndex(e, t = !1, n) {
    for (let s = 0; s < this.length; s++) {
      if (e >= this.length && !t) return -1;
      if (e %= this.length, !n || n(this.element(e))) return e;
      e++;
    }
    return -1;
  }
  findPreviousIndex(e, t = !1, n) {
    for (let s = 0; s < this.length; s++) {
      if (e < 0 && !t) return -1;
      if (e = (this.length + e % this.length) % this.length, !n || n(this.element(e))) return e;
      e--;
    }
    return -1;
  }
  getFocus() {
    return this.focus.get();
  }
  getFocusedElements() {
    return this.getFocus().map((e) => this.view.element(e));
  }
  reveal(e, t, n = 0) {
    if (e < 0 || e >= this.length) throw new Gc(this.user, `Invalid index ${e}`);
    const s = this.view.getScrollTop(), o = this.view.elementTop(e), r = this.view.elementHeight(e);
    if (gc(t)) {
      const a = r - this.view.renderHeight + n;
      this.view.setScrollTop(a * as(t, 0, 1) + o - n);
    } else {
      const a = o + r, l = s + this.view.renderHeight;
      o < s + n && a >= l || (o < s + n || a >= l && r >= this.view.renderHeight ? this.view.setScrollTop(o - n) : a >= l && this.view.setScrollTop(a - this.view.renderHeight));
    }
  }
  getRelativeTop(e, t = 0) {
    if (e < 0 || e >= this.length) throw new Gc(this.user, `Invalid index ${e}`);
    const n = this.view.getScrollTop(), s = this.view.elementTop(e), o = this.view.elementHeight(e);
    if (s < n + t || s + o > n + this.view.renderHeight) return null;
    const r = o - this.view.renderHeight + t;
    return Math.abs((n + t - s) / r);
  }
  getHTMLElement() {
    return this.view.domNode;
  }
  getScrollableElement() {
    return this.view.scrollableElementDomNode;
  }
  getElementID(e) {
    return this.view.getElementDomId(e);
  }
  getElementTop(e) {
    return this.view.elementTop(e);
  }
  style(e) {
    this.styleController.style(e);
  }
  toListEvent({ indexes: e, browserEvent: t }) {
    return { indexes: e, elements: e.map((n) => this.view.element(n)), browserEvent: t };
  }
  _onFocusChange() {
    const e = this.focus.get();
    this.view.domNode.classList.toggle("element-focused", e.length > 0), this.onDidChangeActiveDescendant();
  }
  onDidChangeActiveDescendant() {
    var e;
    const t = this.focus.get();
    if (t.length > 0) {
      let n;
      !((e = this.accessibilityProvider) === null || e === void 0) && e.getActiveDescendantId && (n = this.accessibilityProvider.getActiveDescendantId(this.view.element(t[0]))), this.view.domNode.setAttribute("aria-activedescendant", n || this.view.getElementDomId(t[0]));
    } else this.view.domNode.removeAttribute("aria-activedescendant");
  }
  _onSelectionChange() {
    const e = this.selection.get();
    this.view.domNode.classList.toggle("selection-none", e.length === 0), this.view.domNode.classList.toggle("selection-single", e.length === 1), this.view.domNode.classList.toggle("selection-multiple", e.length > 1);
  }
  dispose() {
    this._onDidDispose.fire(), this.disposables.dispose(), this._onDidDispose.dispose();
  }
}
ph([Li], uo.prototype, "onDidChangeFocus", null), ph([Li], uo.prototype, "onDidChangeSelection", null), ph([Li], uo.prototype, "onContextMenu", null), ph([Li], uo.prototype, "onKeyDown", null), ph([Li], uo.prototype, "onDidFocus", null), ph([Li], uo.prototype, "onDidBlur", null);
const Au = Q, XW = "selectOption.entry.template";
class Jee {
  get templateId() {
    return XW;
  }
  renderTemplate(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return t.root = e, t.text = Z(e, Au(".option-text")), t.detail = Z(e, Au(".option-detail")), t.decoratorRight = Z(e, Au(".option-decorator-right")), t;
  }
  renderElement(e, t, n) {
    const s = n, o = e.text, r = e.detail, a = e.decoratorRight, l = e.isDisabled;
    s.text.textContent = o, s.detail.textContent = r || "", s.decoratorRight.innerText = a || "", l ? s.root.classList.add("option-disabled") : s.root.classList.remove("option-disabled");
  }
  disposeTemplate(e) {
  }
}
class Ja extends V {
  constructor(e, t, n, s, o) {
    super(), this.options = [], this._currentSelection = 0, this._hasDetails = !1, this._skipLayout = !1, this._sticky = !1, this._isVisible = !1, this.styles = s, this.selectBoxOptions = o || /* @__PURE__ */ Object.create(null), typeof this.selectBoxOptions.minBottomMargin != "number" ? this.selectBoxOptions.minBottomMargin = Ja.DEFAULT_DROPDOWN_MINIMUM_BOTTOM_MARGIN : this.selectBoxOptions.minBottomMargin < 0 && (this.selectBoxOptions.minBottomMargin = 0), this.selectElement = document.createElement("select"), this.selectElement.className = "monaco-select-box monaco-select-box-dropdown-padding", typeof this.selectBoxOptions.ariaLabel == "string" && this.selectElement.setAttribute("aria-label", this.selectBoxOptions.ariaLabel), typeof this.selectBoxOptions.ariaDescription == "string" && this.selectElement.setAttribute("aria-description", this.selectBoxOptions.ariaDescription), this._onDidSelect = new F(), this._register(this._onDidSelect), this.registerListeners(), this.constructSelectDropDown(n), this.selected = t || 0, e && this.setOptions(e, t), this.initStyleSheet();
  }
  setTitle(e) {
    !this._hover && e ? this._hover = this._register(xr(Bs("mouse"), this.selectElement, e)) : this._hover && this._hover.update(e);
  }
  getHeight() {
    return 22;
  }
  getTemplateId() {
    return XW;
  }
  constructSelectDropDown(e) {
    this.contextViewProvider = e, this.selectDropDownContainer = Q(".monaco-select-box-dropdown-container"), this.selectDropDownContainer.classList.add("monaco-select-box-dropdown-padding"), this.selectionDetailsPane = Z(this.selectDropDownContainer, Au(".select-box-details-pane"));
    const t = Z(this.selectDropDownContainer, Au(".select-box-dropdown-container-width-control")), n = Z(t, Au(".width-control-div"));
    this.widthControlElement = document.createElement("span"), this.widthControlElement.className = "option-text-width-control", Z(n, this.widthControlElement), this._dropDownPosition = 0, this.styleElement = Lo(this.selectDropDownContainer), this.selectDropDownContainer.setAttribute("draggable", "true"), this._register(K(this.selectDropDownContainer, ie.DRAG_START, (s) => {
      Ze(s, !0);
    }));
  }
  registerListeners() {
    let e;
    this._register(bi(this.selectElement, "change", (t) => {
      this.selected = t.target.selectedIndex, this._onDidSelect.fire({ index: t.target.selectedIndex, selected: t.target.value }), this.options[this.selected] && this.options[this.selected].text && this.setTitle(this.options[this.selected].text);
    })), this._register(K(this.selectElement, ie.CLICK, (t) => {
      Ze(t), this._isVisible ? this.hideSelectDropDown(!0) : this.showSelectDropDown();
    })), this._register(K(this.selectElement, ie.MOUSE_DOWN, (t) => {
      Ze(t);
    })), this._register(K(this.selectElement, "touchstart", (t) => {
      e = this._isVisible;
    })), this._register(K(this.selectElement, "touchend", (t) => {
      Ze(t), e ? this.hideSelectDropDown(!0) : this.showSelectDropDown();
    })), this._register(K(this.selectElement, ie.KEY_DOWN, (t) => {
      const n = new jt(t);
      let s = !1;
      Je ? n.keyCode !== 18 && n.keyCode !== 16 && n.keyCode !== 10 && n.keyCode !== 3 || (s = !0) : (n.keyCode === 18 && n.altKey || n.keyCode === 16 && n.altKey || n.keyCode === 10 || n.keyCode === 3) && (s = !0), s && (this.showSelectDropDown(), Ze(t, !0));
    }));
  }
  get onDidSelect() {
    return this._onDidSelect.event;
  }
  setOptions(e, t) {
    ri(this.options, e) || (this.options = e, this.selectElement.options.length = 0, this._hasDetails = !1, this._cachedMaxDetailsHeight = void 0, this.options.forEach((n, s) => {
      this.selectElement.add(this.createOption(n.text, s, n.isDisabled)), typeof n.description == "string" && (this._hasDetails = !0);
    })), t !== void 0 && (this.select(t), this._currentSelection = this.selected);
  }
  setOptionsList() {
    var e;
    (e = this.selectList) === null || e === void 0 || e.splice(0, this.selectList.length, this.options);
  }
  select(e) {
    e >= 0 && e < this.options.length ? this.selected = e : e > this.options.length - 1 ? this.select(this.options.length - 1) : this.selected < 0 && (this.selected = 0), this.selectElement.selectedIndex = this.selected, this.options[this.selected] && this.options[this.selected].text && this.setTitle(this.options[this.selected].text);
  }
  focus() {
    this.selectElement && (this.selectElement.tabIndex = 0, this.selectElement.focus());
  }
  blur() {
    this.selectElement && (this.selectElement.tabIndex = -1, this.selectElement.blur());
  }
  setFocusable(e) {
    this.selectElement.tabIndex = e ? 0 : -1;
  }
  render(e) {
    this.container = e, e.classList.add("select-container"), e.appendChild(this.selectElement), this.styleSelectElement();
  }
  initStyleSheet() {
    const e = [];
    this.styles.listFocusBackground && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.focused { background-color: ${this.styles.listFocusBackground} !important; }`), this.styles.listFocusForeground && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.focused { color: ${this.styles.listFocusForeground} !important; }`), this.styles.decoratorRightForeground && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.focused) .option-decorator-right { color: ${this.styles.decoratorRightForeground}; }`), this.styles.selectBackground && this.styles.selectBorder && this.styles.selectBorder !== this.styles.selectBackground ? (e.push(`.monaco-select-box-dropdown-container { border: 1px solid ${this.styles.selectBorder} } `), e.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-top { border-top: 1px solid ${this.styles.selectBorder} } `), e.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-bottom { border-bottom: 1px solid ${this.styles.selectBorder} } `)) : this.styles.selectListBorder && (e.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-top { border-top: 1px solid ${this.styles.selectListBorder} } `), e.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-bottom { border-bottom: 1px solid ${this.styles.selectListBorder} } `)), this.styles.listHoverForeground && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.option-disabled):not(.focused):hover { color: ${this.styles.listHoverForeground} !important; }`), this.styles.listHoverBackground && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.option-disabled):not(.focused):hover { background-color: ${this.styles.listHoverBackground} !important; }`), this.styles.listFocusOutline && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.focused { outline: 1.6px dotted ${this.styles.listFocusOutline} !important; outline-offset: -1.6px !important; }`), this.styles.listHoverOutline && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.option-disabled):not(.focused):hover { outline: 1.6px dashed ${this.styles.listHoverOutline} !important; outline-offset: -1.6px !important; }`), e.push(".monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.option-disabled.focused { background-color: transparent !important; color: inherit !important; outline: none !important; }"), e.push(".monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.option-disabled:hover { background-color: transparent !important; color: inherit !important; outline: none !important; }"), this.styleElement.textContent = e.join(`
`);
  }
  styleSelectElement() {
    var e, t, n;
    const s = (e = this.styles.selectBackground) !== null && e !== void 0 ? e : "", o = (t = this.styles.selectForeground) !== null && t !== void 0 ? t : "", r = (n = this.styles.selectBorder) !== null && n !== void 0 ? n : "";
    this.selectElement.style.backgroundColor = s, this.selectElement.style.color = o, this.selectElement.style.borderColor = r;
  }
  styleList() {
    var e, t;
    const n = (e = this.styles.selectBackground) !== null && e !== void 0 ? e : "", s = kd(this.styles.selectListBackground, n);
    this.selectDropDownListContainer.style.backgroundColor = s, this.selectionDetailsPane.style.backgroundColor = s;
    const o = (t = this.styles.focusBorder) !== null && t !== void 0 ? t : "";
    this.selectDropDownContainer.style.outlineColor = o, this.selectDropDownContainer.style.outlineOffset = "-1px", this.selectList.style(this.styles);
  }
  createOption(e, t, n) {
    const s = document.createElement("option");
    return s.value = e, s.text = e, s.disabled = !!n, s;
  }
  showSelectDropDown() {
    this.selectionDetailsPane.innerText = "", this.contextViewProvider && !this._isVisible && (this.createSelectList(this.selectDropDownContainer), this.setOptionsList(), this.contextViewProvider.showContextView({ getAnchor: () => this.selectElement, render: (e) => this.renderSelectDropDown(e, !0), layout: () => {
      this.layoutSelectDropDown();
    }, onHide: () => {
      this.selectDropDownContainer.classList.remove("visible"), this.selectElement.classList.remove("synthetic-focus");
    }, anchorPosition: this._dropDownPosition }, this.selectBoxOptions.optionsAsChildren ? this.container : void 0), this._isVisible = !0, this.hideSelectDropDown(!1), this.contextViewProvider.showContextView({ getAnchor: () => this.selectElement, render: (e) => this.renderSelectDropDown(e), layout: () => this.layoutSelectDropDown(), onHide: () => {
      this.selectDropDownContainer.classList.remove("visible"), this.selectElement.classList.remove("synthetic-focus");
    }, anchorPosition: this._dropDownPosition }, this.selectBoxOptions.optionsAsChildren ? this.container : void 0), this._currentSelection = this.selected, this._isVisible = !0, this.selectElement.setAttribute("aria-expanded", "true"));
  }
  hideSelectDropDown(e) {
    this.contextViewProvider && this._isVisible && (this._isVisible = !1, this.selectElement.setAttribute("aria-expanded", "false"), e && this.selectElement.focus(), this.contextViewProvider.hideContextView());
  }
  renderSelectDropDown(e, t) {
    return e.appendChild(this.selectDropDownContainer), this.layoutSelectDropDown(t), { dispose: () => {
      try {
        e.removeChild(this.selectDropDownContainer);
      } catch {
      }
    } };
  }
  measureMaxDetailsHeight() {
    let e = 0;
    return this.options.forEach((t, n) => {
      this.updateDetail(n), this.selectionDetailsPane.offsetHeight > e && (e = this.selectionDetailsPane.offsetHeight);
    }), e;
  }
  layoutSelectDropDown(e) {
    if (this._skipLayout) return !1;
    if (this.selectList) {
      this.selectDropDownContainer.classList.add("visible");
      const t = ke(this.selectElement), n = Ti(this.selectElement), s = ke(this.selectElement).getComputedStyle(this.selectElement), o = parseFloat(s.getPropertyValue("--dropdown-padding-top")) + parseFloat(s.getPropertyValue("--dropdown-padding-bottom")), r = t.innerHeight - n.top - n.height - (this.selectBoxOptions.minBottomMargin || 0), a = n.top - Ja.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN, l = this.selectElement.offsetWidth, d = this.setWidthControlElement(this.widthControlElement), h = Math.max(d, Math.round(l)).toString() + "px";
      this.selectDropDownContainer.style.width = h, this.selectList.getHTMLElement().style.height = "", this.selectList.layout();
      let c = this.selectList.contentHeight;
      this._hasDetails && this._cachedMaxDetailsHeight === void 0 && (this._cachedMaxDetailsHeight = this.measureMaxDetailsHeight());
      const u = this._hasDetails ? this._cachedMaxDetailsHeight : 0, g = c + o + u, p = Math.floor((r - o - u) / this.getHeight()), f = Math.floor((a - o - u) / this.getHeight());
      if (e) return !(n.top + n.height > t.innerHeight - 22 || n.top < Ja.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN || p < 1 && f < 1) && (p < Ja.DEFAULT_MINIMUM_VISIBLE_OPTIONS && f > p && this.options.length > p ? (this._dropDownPosition = 1, this.selectDropDownContainer.removeChild(this.selectDropDownListContainer), this.selectDropDownContainer.removeChild(this.selectionDetailsPane), this.selectDropDownContainer.appendChild(this.selectionDetailsPane), this.selectDropDownContainer.appendChild(this.selectDropDownListContainer), this.selectionDetailsPane.classList.remove("border-top"), this.selectionDetailsPane.classList.add("border-bottom")) : (this._dropDownPosition = 0, this.selectDropDownContainer.removeChild(this.selectDropDownListContainer), this.selectDropDownContainer.removeChild(this.selectionDetailsPane), this.selectDropDownContainer.appendChild(this.selectDropDownListContainer), this.selectDropDownContainer.appendChild(this.selectionDetailsPane), this.selectionDetailsPane.classList.remove("border-bottom"), this.selectionDetailsPane.classList.add("border-top")), !0);
      if (n.top + n.height > t.innerHeight - 22 || n.top < Ja.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN || this._dropDownPosition === 0 && p < 1 || this._dropDownPosition === 1 && f < 1) return this.hideSelectDropDown(!0), !1;
      if (this._dropDownPosition === 0) {
        if (this._isVisible && p + f < 1) return this.hideSelectDropDown(!0), !1;
        g > r && (c = p * this.getHeight());
      } else g > a && (c = f * this.getHeight());
      return this.selectList.layout(c), this.selectList.domFocus(), this.selectList.length > 0 && (this.selectList.setFocus([this.selected || 0]), this.selectList.reveal(this.selectList.getFocus()[0] || 0)), this._hasDetails ? (this.selectList.getHTMLElement().style.height = c + o + "px", this.selectDropDownContainer.style.height = "") : this.selectDropDownContainer.style.height = c + o + "px", this.updateDetail(this.selected), this.selectDropDownContainer.style.width = h, this.selectDropDownListContainer.setAttribute("tabindex", "0"), this.selectElement.classList.add("synthetic-focus"), this.selectDropDownContainer.classList.add("synthetic-focus"), !0;
    }
    return !1;
  }
  setWidthControlElement(e) {
    let t = 0;
    if (e) {
      let n = 0, s = 0;
      this.options.forEach((o, r) => {
        const a = o.detail ? o.detail.length : 0, l = o.decoratorRight ? o.decoratorRight.length : 0, d = o.text.length + a + l;
        d > s && (n = r, s = d);
      }), e.textContent = this.options[n].text + (this.options[n].decoratorRight ? this.options[n].decoratorRight + " " : ""), t = os(e);
    }
    return t;
  }
  createSelectList(e) {
    if (this.selectList) return;
    this.selectDropDownListContainer = Z(e, Au(".select-box-dropdown-list-container")), this.listRenderer = new Jee(), this.selectList = new uo("SelectBoxCustom", this.selectDropDownListContainer, this, [this.listRenderer], { useShadows: !1, verticalScrollMode: 3, keyboardSupport: !1, mouseSupport: !1, accessibilityProvider: { getAriaLabel: (s) => {
      let o = s.text;
      return s.detail && (o += `. ${s.detail}`), s.decoratorRight && (o += `. ${s.decoratorRight}`), s.description && (o += `. ${s.description}`), o;
    }, getWidgetAriaLabel: () => m(0, "Select Box"), getRole: () => Je ? "" : "option", getWidgetRole: () => "listbox" } }), this.selectBoxOptions.ariaLabel && (this.selectList.ariaLabel = this.selectBoxOptions.ariaLabel);
    const t = this._register(new st(this.selectDropDownListContainer, "keydown")), n = se.chain(t.event, (s) => s.filter(() => this.selectList.length > 0).map((o) => new jt(o)));
    this._register(se.chain(n, (s) => s.filter((o) => o.keyCode === 3))(this.onEnter, this)), this._register(se.chain(n, (s) => s.filter((o) => o.keyCode === 2))(this.onEnter, this)), this._register(se.chain(n, (s) => s.filter((o) => o.keyCode === 9))(this.onEscape, this)), this._register(se.chain(n, (s) => s.filter((o) => o.keyCode === 16))(this.onUpArrow, this)), this._register(se.chain(n, (s) => s.filter((o) => o.keyCode === 18))(this.onDownArrow, this)), this._register(se.chain(n, (s) => s.filter((o) => o.keyCode === 12))(this.onPageDown, this)), this._register(se.chain(n, (s) => s.filter((o) => o.keyCode === 11))(this.onPageUp, this)), this._register(se.chain(n, (s) => s.filter((o) => o.keyCode === 14))(this.onHome, this)), this._register(se.chain(n, (s) => s.filter((o) => o.keyCode === 13))(this.onEnd, this)), this._register(se.chain(n, (s) => s.filter((o) => o.keyCode >= 21 && o.keyCode <= 56 || o.keyCode >= 85 && o.keyCode <= 113))(this.onCharacter, this)), this._register(K(this.selectList.getHTMLElement(), ie.POINTER_UP, (s) => this.onPointerUp(s))), this._register(this.selectList.onMouseOver((s) => s.index !== void 0 && this.selectList.setFocus([s.index]))), this._register(this.selectList.onDidChangeFocus((s) => this.onListFocus(s))), this._register(K(this.selectDropDownContainer, ie.FOCUS_OUT, (s) => {
      this._isVisible && !gn(s.relatedTarget, this.selectDropDownContainer) && this.onListBlur();
    })), this.selectList.getHTMLElement().setAttribute("aria-label", this.selectBoxOptions.ariaLabel || ""), this.selectList.getHTMLElement().setAttribute("aria-expanded", "true"), this.styleList();
  }
  onPointerUp(e) {
    if (!this.selectList.length) return;
    Ze(e);
    const t = e.target;
    if (!t || t.classList.contains("slider")) return;
    const n = t.closest(".monaco-list-row");
    if (!n) return;
    const s = Number(n.getAttribute("data-index")), o = n.classList.contains("option-disabled");
    s >= 0 && s < this.options.length && !o && (this.selected = s, this.select(this.selected), this.selectList.setFocus([this.selected]), this.selectList.reveal(this.selectList.getFocus()[0]), this.selected !== this._currentSelection && (this._currentSelection = this.selected, this._onDidSelect.fire({ index: this.selectElement.selectedIndex, selected: this.options[this.selected].text }), this.options[this.selected] && this.options[this.selected].text && this.setTitle(this.options[this.selected].text)), this.hideSelectDropDown(!0));
  }
  onListBlur() {
    this._sticky || (this.selected !== this._currentSelection && this.select(this._currentSelection), this.hideSelectDropDown(!1));
  }
  renderDescriptionMarkdown(e, t) {
    const n = (o) => {
      for (let r = 0; r < o.childNodes.length; r++) {
        const a = o.childNodes.item(r);
        (a.tagName && a.tagName.toLowerCase()) === "img" ? o.removeChild(a) : n(a);
      }
    }, s = CL({ value: e, supportThemeIcons: !0 }, { actionHandler: t });
    return s.element.classList.add("select-box-description-markdown"), n(s.element), s.element;
  }
  onListFocus(e) {
    this._isVisible && this._hasDetails && this.updateDetail(e.indexes[0]);
  }
  updateDetail(e) {
    var t, n;
    this.selectionDetailsPane.innerText = "";
    const s = this.options[e], o = (t = s == null ? void 0 : s.description) !== null && t !== void 0 ? t : "", r = (n = s == null ? void 0 : s.descriptionIsMarkdown) !== null && n !== void 0 && n;
    if (o) {
      if (r) {
        const a = s.descriptionMarkdownActionHandler;
        this.selectionDetailsPane.appendChild(this.renderDescriptionMarkdown(o, a));
      } else this.selectionDetailsPane.innerText = o;
      this.selectionDetailsPane.style.display = "block";
    } else this.selectionDetailsPane.style.display = "none";
    this._skipLayout = !0, this.contextViewProvider.layout(), this._skipLayout = !1;
  }
  onEscape(e) {
    Ze(e), this.select(this._currentSelection), this.hideSelectDropDown(!0);
  }
  onEnter(e) {
    Ze(e), this.selected !== this._currentSelection && (this._currentSelection = this.selected, this._onDidSelect.fire({ index: this.selectElement.selectedIndex, selected: this.options[this.selected].text }), this.options[this.selected] && this.options[this.selected].text && this.setTitle(this.options[this.selected].text)), this.hideSelectDropDown(!0);
  }
  onDownArrow(e) {
    if (this.selected < this.options.length - 1) {
      Ze(e, !0);
      const t = this.options[this.selected + 1].isDisabled;
      if (t && this.options.length > this.selected + 2) this.selected += 2;
      else {
        if (t) return;
        this.selected++;
      }
      this.select(this.selected), this.selectList.setFocus([this.selected]), this.selectList.reveal(this.selectList.getFocus()[0]);
    }
  }
  onUpArrow(e) {
    this.selected > 0 && (Ze(e, !0), this.options[this.selected - 1].isDisabled && this.selected > 1 ? this.selected -= 2 : this.selected--, this.select(this.selected), this.selectList.setFocus([this.selected]), this.selectList.reveal(this.selectList.getFocus()[0]));
  }
  onPageUp(e) {
    Ze(e), this.selectList.focusPreviousPage(), setTimeout(() => {
      this.selected = this.selectList.getFocus()[0], this.options[this.selected].isDisabled && this.selected < this.options.length - 1 && (this.selected++, this.selectList.setFocus([this.selected])), this.selectList.reveal(this.selected), this.select(this.selected);
    }, 1);
  }
  onPageDown(e) {
    Ze(e), this.selectList.focusNextPage(), setTimeout(() => {
      this.selected = this.selectList.getFocus()[0], this.options[this.selected].isDisabled && this.selected > 0 && (this.selected--, this.selectList.setFocus([this.selected])), this.selectList.reveal(this.selected), this.select(this.selected);
    }, 1);
  }
  onHome(e) {
    Ze(e), this.options.length < 2 || (this.selected = 0, this.options[this.selected].isDisabled && this.selected > 1 && this.selected++, this.selectList.setFocus([this.selected]), this.selectList.reveal(this.selected), this.select(this.selected));
  }
  onEnd(e) {
    Ze(e), this.options.length < 2 || (this.selected = this.options.length - 1, this.options[this.selected].isDisabled && this.selected > 1 && this.selected--, this.selectList.setFocus([this.selected]), this.selectList.reveal(this.selected), this.select(this.selected));
  }
  onCharacter(e) {
    const t = Yl.toString(e.keyCode);
    let n = -1;
    for (let s = 0; s < this.options.length - 1; s++) if (n = (s + this.selected + 1) % this.options.length, this.options[n].text.charAt(0).toUpperCase() === t && !this.options[n].isDisabled) {
      this.select(n), this.selectList.setFocus([n]), this.selectList.reveal(this.selectList.getFocus()[0]), Ze(e);
      break;
    }
  }
  dispose() {
    this.hideSelectDropDown(!1), super.dispose();
  }
}
Ja.DEFAULT_DROPDOWN_MINIMUM_BOTTOM_MARGIN = 32, Ja.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN = 2, Ja.DEFAULT_MINIMUM_VISIBLE_OPTIONS = 3;
class ete extends V {
  constructor(e, t, n, s) {
    super(), this.selected = 0, this.selectBoxOptions = s || /* @__PURE__ */ Object.create(null), this.options = [], this.selectElement = document.createElement("select"), this.selectElement.className = "monaco-select-box", typeof this.selectBoxOptions.ariaLabel == "string" && this.selectElement.setAttribute("aria-label", this.selectBoxOptions.ariaLabel), typeof this.selectBoxOptions.ariaDescription == "string" && this.selectElement.setAttribute("aria-description", this.selectBoxOptions.ariaDescription), this._onDidSelect = this._register(new F()), this.styles = n, this.registerListeners(), this.setOptions(e, t);
  }
  registerListeners() {
    this._register(Bt.addTarget(this.selectElement)), [Vt.Tap].forEach((e) => {
      this._register(K(this.selectElement, e, (t) => {
        this.selectElement.focus();
      }));
    }), this._register(bi(this.selectElement, "click", (e) => {
      Ze(e, !0);
    })), this._register(bi(this.selectElement, "change", (e) => {
      this.selectElement.title = e.target.value, this._onDidSelect.fire({ index: e.target.selectedIndex, selected: e.target.value });
    })), this._register(bi(this.selectElement, "keydown", (e) => {
      let t = !1;
      Je ? e.keyCode !== 18 && e.keyCode !== 16 && e.keyCode !== 10 || (t = !0) : (e.keyCode === 18 && e.altKey || e.keyCode === 10 || e.keyCode === 3) && (t = !0), t && e.stopPropagation();
    }));
  }
  get onDidSelect() {
    return this._onDidSelect.event;
  }
  setOptions(e, t) {
    this.options && ri(this.options, e) || (this.options = e, this.selectElement.options.length = 0, this.options.forEach((n, s) => {
      this.selectElement.add(this.createOption(n.text, s, n.isDisabled));
    })), t !== void 0 && this.select(t);
  }
  select(e) {
    this.options.length === 0 ? this.selected = 0 : e >= 0 && e < this.options.length ? this.selected = e : e > this.options.length - 1 ? this.select(this.options.length - 1) : this.selected < 0 && (this.selected = 0), this.selectElement.selectedIndex = this.selected, this.selected < this.options.length && typeof this.options[this.selected].text == "string" ? this.selectElement.title = this.options[this.selected].text : this.selectElement.title = "";
  }
  focus() {
    this.selectElement && (this.selectElement.tabIndex = 0, this.selectElement.focus());
  }
  blur() {
    this.selectElement && (this.selectElement.tabIndex = -1, this.selectElement.blur());
  }
  setFocusable(e) {
    this.selectElement.tabIndex = e ? 0 : -1;
  }
  render(e) {
    e.classList.add("select-container"), e.appendChild(this.selectElement), this.setOptions(this.options, this.selected), this.applyStyles();
  }
  applyStyles() {
    var e, t, n;
    this.selectElement && (this.selectElement.style.backgroundColor = (e = this.styles.selectBackground) !== null && e !== void 0 ? e : "", this.selectElement.style.color = (t = this.styles.selectForeground) !== null && t !== void 0 ? t : "", this.selectElement.style.borderColor = (n = this.styles.selectBorder) !== null && n !== void 0 ? n : "");
  }
  createOption(e, t, n) {
    const s = document.createElement("option");
    return s.value = e, s.text = e, s.disabled = !!n, s;
  }
}
class tte extends To {
  constructor(e, t, n, s, o) {
    super(), Je && !(o != null && o.useCustomDrawn) ? this.selectBoxDelegate = new ete(e, t, s, o) : this.selectBoxDelegate = new Ja(e, t, n, s, o), this._register(this.selectBoxDelegate);
  }
  get onDidSelect() {
    return this.selectBoxDelegate.onDidSelect;
  }
  setOptions(e, t) {
    this.selectBoxDelegate.setOptions(e, t);
  }
  select(e) {
    this.selectBoxDelegate.select(e);
  }
  focus() {
    this.selectBoxDelegate.focus();
  }
  blur() {
    this.selectBoxDelegate.blur();
  }
  setFocusable(e) {
    this.selectBoxDelegate.setFocusable(e);
  }
  render(e) {
    this.selectBoxDelegate.render(e);
  }
}
class Gr extends V {
  get action() {
    return this._action;
  }
  constructor(e, t, n = {}) {
    super(), this.options = n, this._context = e || this, this._action = t, t instanceof Qs && this._register(t.onDidChange((s) => {
      this.element && this.handleActionChangeEvent(s);
    }));
  }
  handleActionChangeEvent(e) {
    e.enabled !== void 0 && this.updateEnabled(), e.checked !== void 0 && this.updateChecked(), e.class !== void 0 && this.updateClass(), e.label !== void 0 && (this.updateLabel(), this.updateTooltip()), e.tooltip !== void 0 && this.updateTooltip();
  }
  get actionRunner() {
    return this._actionRunner || (this._actionRunner = this._register(new hg())), this._actionRunner;
  }
  set actionRunner(e) {
    this._actionRunner = e;
  }
  isEnabled() {
    return this._action.enabled;
  }
  setActionContext(e) {
    this._context = e;
  }
  render(e) {
    const t = this.element = e;
    this._register(Bt.addTarget(e));
    const n = this.options && this.options.draggable;
    n && (e.draggable = !0, tr && this._register(K(e, ie.DRAG_START, (s) => {
      var o;
      return (o = s.dataTransfer) === null || o === void 0 ? void 0 : o.setData(Tv.TEXT, this._action.label);
    }))), this._register(K(t, Vt.Tap, (s) => this.onClick(s, !0))), this._register(K(t, ie.MOUSE_DOWN, (s) => {
      n || Ze(s, !0), this._action.enabled && s.button === 0 && t.classList.add("active");
    })), Je && this._register(K(t, ie.CONTEXT_MENU, (s) => {
      s.button === 0 && s.ctrlKey === !0 && this.onClick(s);
    })), this._register(K(t, ie.CLICK, (s) => {
      Ze(s, !0), this.options && this.options.isMenu || this.onClick(s);
    })), this._register(K(t, ie.DBLCLICK, (s) => {
      Ze(s, !0);
    })), [ie.MOUSE_UP, ie.MOUSE_OUT].forEach((s) => {
      this._register(K(t, s, (o) => {
        Ze(o), t.classList.remove("active");
      }));
    });
  }
  onClick(e, t = !1) {
    var n;
    Ze(e, !0);
    const s = mo(this._context) ? !((n = this.options) === null || n === void 0) && n.useEventAsContext ? e : { preserveFocus: t } : this._context;
    this.actionRunner.run(this._action, s);
  }
  focus() {
    this.element && (this.element.tabIndex = 0, this.element.focus(), this.element.classList.add("focused"));
  }
  blur() {
    this.element && (this.element.blur(), this.element.tabIndex = -1, this.element.classList.remove("focused"));
  }
  setFocusable(e) {
    this.element && (this.element.tabIndex = e ? 0 : -1);
  }
  get trapsArrowNavigation() {
    return !1;
  }
  updateEnabled() {
  }
  updateLabel() {
  }
  getClass() {
    return this.action.class;
  }
  getTooltip() {
    return this.action.tooltip;
  }
  updateTooltip() {
    var e, t, n;
    if (!this.element) return;
    const s = (e = this.getTooltip()) !== null && e !== void 0 ? e : "";
    if (this.updateAriaLabel(), (t = this.options.hoverDelegate) === null || t === void 0 ? void 0 : t.showNativeHover) this.element.title = s;
    else if (this.customHover || s === "") this.customHover && this.customHover.update(s);
    else {
      const o = (n = this.options.hoverDelegate) !== null && n !== void 0 ? n : Bs("element");
      this.customHover = this._store.add(xr(o, this.element, s));
    }
  }
  updateAriaLabel() {
    var e;
    if (this.element) {
      const t = (e = this.getTooltip()) !== null && e !== void 0 ? e : "";
      this.element.setAttribute("aria-label", t);
    }
  }
  updateClass() {
  }
  updateChecked() {
  }
  dispose() {
    this.element && (this.element.remove(), this.element = void 0), this._context = void 0, super.dispose();
  }
}
class ef extends Gr {
  constructor(e, t, n) {
    super(e, t, n), this.options = n, this.options.icon = n.icon !== void 0 && n.icon, this.options.label = n.label === void 0 || n.label, this.cssClass = "";
  }
  render(e) {
    super.render(e), vt(this.element);
    const t = document.createElement("a");
    if (t.classList.add("action-label"), t.setAttribute("role", this.getDefaultAriaRole()), this.label = t, this.element.appendChild(t), this.options.label && this.options.keybinding) {
      const n = document.createElement("span");
      n.classList.add("keybinding"), n.textContent = this.options.keybinding, this.element.appendChild(n);
    }
    this.updateClass(), this.updateLabel(), this.updateTooltip(), this.updateEnabled(), this.updateChecked();
  }
  getDefaultAriaRole() {
    return this._action.id === Ui.ID ? "presentation" : this.options.isMenu ? "menuitem" : "button";
  }
  focus() {
    this.label && (this.label.tabIndex = 0, this.label.focus());
  }
  blur() {
    this.label && (this.label.tabIndex = -1);
  }
  setFocusable(e) {
    this.label && (this.label.tabIndex = e ? 0 : -1);
  }
  updateLabel() {
    this.options.label && this.label && (this.label.textContent = this.action.label);
  }
  getTooltip() {
    let e = null;
    return this.action.tooltip ? e = this.action.tooltip : !this.options.label && this.action.label && this.options.icon && (e = this.action.label, this.options.keybinding && (e = m(0, "{0} ({1})", e, this.options.keybinding))), e ?? void 0;
  }
  updateClass() {
    var e;
    this.cssClass && this.label && this.label.classList.remove(...this.cssClass.split(" ")), this.options.icon ? (this.cssClass = this.getClass(), this.label && (this.label.classList.add("codicon"), this.cssClass && this.label.classList.add(...this.cssClass.split(" "))), this.updateEnabled()) : (e = this.label) === null || e === void 0 || e.classList.remove("codicon");
  }
  updateEnabled() {
    var e, t;
    this.action.enabled ? (this.label && (this.label.removeAttribute("aria-disabled"), this.label.classList.remove("disabled")), (e = this.element) === null || e === void 0 || e.classList.remove("disabled")) : (this.label && (this.label.setAttribute("aria-disabled", "true"), this.label.classList.add("disabled")), (t = this.element) === null || t === void 0 || t.classList.add("disabled"));
  }
  updateAriaLabel() {
    var e;
    if (this.label) {
      const t = (e = this.getTooltip()) !== null && e !== void 0 ? e : "";
      this.label.setAttribute("aria-label", t);
    }
  }
  updateChecked() {
    this.label && (this.action.checked !== void 0 ? (this.label.classList.toggle("checked", this.action.checked), this.label.setAttribute("aria-checked", this.action.checked ? "true" : "false"), this.label.setAttribute("role", "checkbox")) : (this.label.classList.remove("checked"), this.label.removeAttribute("aria-checked"), this.label.setAttribute("role", this.getDefaultAriaRole())));
  }
}
class ite extends Gr {
  constructor(e, t, n, s, o, r, a) {
    super(e, t), this.selectBox = new tte(n, s, o, r, a), this.selectBox.setFocusable(!1), this._register(this.selectBox), this.registerListeners();
  }
  select(e) {
    this.selectBox.select(e);
  }
  registerListeners() {
    this._register(this.selectBox.onDidSelect((e) => this.runAction(e.selected, e.index)));
  }
  runAction(e, t) {
    this.actionRunner.run(this._action, this.getActionContext(e, t));
  }
  getActionContext(e, t) {
    return e;
  }
  setFocusable(e) {
    this.selectBox.setFocusable(e);
  }
  focus() {
    var e;
    (e = this.selectBox) === null || e === void 0 || e.focus();
  }
  blur() {
    var e;
    (e = this.selectBox) === null || e === void 0 || e.blur();
  }
  render(e) {
    this.selectBox.render(e);
  }
}
class nte extends hg {
  constructor(e, t) {
    super(), this._onDidChangeVisibility = this._register(new F()), this.onDidChangeVisibility = this._onDidChangeVisibility.event, this._element = Z(e, Q(".monaco-dropdown")), this._label = Z(this._element, Q(".dropdown-label"));
    let n = t.labelRenderer;
    n || (n = (o) => (o.textContent = t.label || "", null));
    for (const o of [ie.CLICK, ie.MOUSE_DOWN, Vt.Tap]) this._register(K(this.element, o, (r) => Ze(r, !0)));
    for (const o of [ie.MOUSE_DOWN, Vt.Tap]) this._register(K(this._label, o, (r) => {
      fR(r) && (r.detail > 1 || r.button !== 0) || (this.visible ? this.hide() : this.show());
    }));
    this._register(K(this._label, ie.KEY_UP, (o) => {
      const r = new jt(o);
      (r.equals(3) || r.equals(10)) && (Ze(o, !0), this.visible ? this.hide() : this.show());
    }));
    const s = n(this._label);
    s && this._register(s), this._register(Bt.addTarget(this._label));
  }
  get element() {
    return this._element;
  }
  show() {
    this.visible || (this.visible = !0, this._onDidChangeVisibility.fire(!0));
  }
  hide() {
    this.visible && (this.visible = !1, this._onDidChangeVisibility.fire(!1));
  }
  dispose() {
    super.dispose(), this.hide(), this.boxContainer && (this.boxContainer.remove(), this.boxContainer = void 0), this.contents && (this.contents.remove(), this.contents = void 0), this._label && (this._label.remove(), this._label = void 0);
  }
}
class ste extends nte {
  constructor(e, t) {
    super(e, t), this._options = t, this._actions = [], this.actions = t.actions || [];
  }
  set menuOptions(e) {
    this._menuOptions = e;
  }
  get menuOptions() {
    return this._menuOptions;
  }
  get actions() {
    return this._options.actionProvider ? this._options.actionProvider.getActions() : this._actions;
  }
  set actions(e) {
    this._actions = e;
  }
  show() {
    super.show(), this.element.classList.add("active"), this._options.contextMenuProvider.showContextMenu({ getAnchor: () => this.element, getActions: () => this.actions, getActionsContext: () => this.menuOptions ? this.menuOptions.context : null, getActionViewItem: (e, t) => this.menuOptions && this.menuOptions.actionViewItemProvider ? this.menuOptions.actionViewItemProvider(e, t) : void 0, getKeyBinding: (e) => this.menuOptions && this.menuOptions.getKeyBinding ? this.menuOptions.getKeyBinding(e) : void 0, getMenuClassName: () => this._options.menuClassName || "", onHide: () => this.onHide(), actionRunner: this.menuOptions ? this.menuOptions.actionRunner : void 0, anchorAlignment: this.menuOptions ? this.menuOptions.anchorAlignment : 0, domForShadowRoot: this._options.menuAsChild ? this.element : void 0, skipTelemetry: this._options.skipTelemetry });
  }
  hide() {
    super.hide();
  }
  onHide() {
    this.hide(), this.element.classList.remove("active");
  }
}
class Fy extends Gr {
  constructor(e, t, n, s = /* @__PURE__ */ Object.create(null)) {
    super(null, e, s), this.actionItem = null, this._onDidChangeVisibility = this._register(new F()), this.onDidChangeVisibility = this._onDidChangeVisibility.event, this.menuActionsOrProvider = t, this.contextMenuProvider = n, this.options = s, this.options.actionRunner && (this.actionRunner = this.options.actionRunner);
  }
  render(e) {
    this.actionItem = e;
    const t = Array.isArray(this.menuActionsOrProvider), n = { contextMenuProvider: this.contextMenuProvider, labelRenderer: (s) => {
      var o;
      this.element = Z(s, Q("a.action-label"));
      let r = [];
      return typeof this.options.classNames == "string" ? r = this.options.classNames.split(/\s+/g).filter((a) => !!a) : this.options.classNames && (r = this.options.classNames), r.find((a) => a === "icon") || r.push("codicon"), this.element.classList.add(...r), this.element.setAttribute("role", "button"), this.element.setAttribute("aria-haspopup", "true"), this.element.setAttribute("aria-expanded", "false"), this._action.label && this._register(xr((o = this.options.hoverDelegate) !== null && o !== void 0 ? o : Bs("mouse"), this.element, this._action.label)), this.element.ariaLabel = this._action.label || "", null;
    }, menuAsChild: this.options.menuAsChild, actions: t ? this.menuActionsOrProvider : void 0, actionProvider: t ? void 0 : this.menuActionsOrProvider, skipTelemetry: this.options.skipTelemetry };
    if (this.dropdownMenu = this._register(new ste(e, n)), this._register(this.dropdownMenu.onDidChangeVisibility((s) => {
      var o;
      (o = this.element) === null || o === void 0 || o.setAttribute("aria-expanded", `${s}`), this._onDidChangeVisibility.fire(s);
    })), this.dropdownMenu.menuOptions = { actionViewItemProvider: this.options.actionViewItemProvider, actionRunner: this.actionRunner, getKeyBinding: this.options.keybindingProvider, context: this._context }, this.options.anchorAlignmentProvider) {
      const s = this;
      this.dropdownMenu.menuOptions = { ...this.dropdownMenu.menuOptions, get anchorAlignment() {
        return s.options.anchorAlignmentProvider();
      } };
    }
    this.updateTooltip(), this.updateEnabled();
  }
  getTooltip() {
    let e = null;
    return this.action.tooltip ? e = this.action.tooltip : this.action.label && (e = this.action.label), e ?? void 0;
  }
  setActionContext(e) {
    super.setActionContext(e), this.dropdownMenu && (this.dropdownMenu.menuOptions ? this.dropdownMenu.menuOptions.context = e : this.dropdownMenu.menuOptions = { context: e });
  }
  show() {
    var e;
    (e = this.dropdownMenu) === null || e === void 0 || e.show();
  }
  updateEnabled() {
    var e, t;
    const n = !this.action.enabled;
    (e = this.actionItem) === null || e === void 0 || e.classList.toggle("disabled", n), (t = this.element) === null || t === void 0 || t.classList.toggle("disabled", n);
  }
}
var vm, Up;
(function(i) {
  i[i.STORAGE_DOES_NOT_EXIST = 0] = "STORAGE_DOES_NOT_EXIST", i[i.STORAGE_IN_MEMORY = 1] = "STORAGE_IN_MEMORY";
})(vm || (vm = {})), function(i) {
  i[i.None = 0] = "None", i[i.Initialized = 1] = "Initialized", i[i.Closed = 2] = "Closed";
}(Up || (Up = {}));
class bm extends V {
  constructor(e, t = /* @__PURE__ */ Object.create(null)) {
    super(), this.database = e, this.options = t, this._onDidChangeStorage = this._register(new og()), this.onDidChangeStorage = this._onDidChangeStorage.event, this.state = Up.None, this.cache = /* @__PURE__ */ new Map(), this.flushDelayer = this._register(new a8(bm.DEFAULT_FLUSH_DELAY)), this.pendingDeletes = /* @__PURE__ */ new Set(), this.pendingInserts = /* @__PURE__ */ new Map(), this.whenFlushedCallbacks = [], this.registerListeners();
  }
  registerListeners() {
    this._register(this.database.onDidChangeItemsExternal((e) => this.onDidChangeItemsExternal(e)));
  }
  onDidChangeItemsExternal(e) {
    var t, n;
    this._onDidChangeStorage.pause();
    try {
      (t = e.changed) === null || t === void 0 || t.forEach((s, o) => this.acceptExternal(o, s)), (n = e.deleted) === null || n === void 0 || n.forEach((s) => this.acceptExternal(s, void 0));
    } finally {
      this._onDidChangeStorage.resume();
    }
  }
  acceptExternal(e, t) {
    if (this.state === Up.Closed) return;
    let n = !1;
    mo(t) ? n = this.cache.delete(e) : this.cache.get(e) !== t && (this.cache.set(e, t), n = !0), n && this._onDidChangeStorage.fire({ key: e, external: !0 });
  }
  get(e, t) {
    const n = this.cache.get(e);
    return mo(n) ? t : n;
  }
  getBoolean(e, t) {
    const n = this.get(e);
    return mo(n) ? t : n === "true";
  }
  getNumber(e, t) {
    const n = this.get(e);
    return mo(n) ? t : parseInt(n, 10);
  }
  async set(e, t, n = !1) {
    if (this.state === Up.Closed) return;
    if (mo(t)) return this.delete(e, n);
    const s = ms(t) || Array.isArray(t) ? (o = t, JSON.stringify(o, VJ)) : String(t);
    var o;
    return this.cache.get(e) !== s ? (this.cache.set(e, s), this.pendingInserts.set(e, s), this.pendingDeletes.delete(e), this._onDidChangeStorage.fire({ key: e, external: n }), this.doFlush()) : void 0;
  }
  async delete(e, t = !1) {
    if (this.state !== Up.Closed)
      return this.cache.delete(e) ? (this.pendingDeletes.has(e) || this.pendingDeletes.add(e), this.pendingInserts.delete(e), this._onDidChangeStorage.fire({ key: e, external: t }), this.doFlush()) : void 0;
  }
  get hasPending() {
    return this.pendingInserts.size > 0 || this.pendingDeletes.size > 0;
  }
  async flushPending() {
    if (!this.hasPending) return;
    const e = { insert: this.pendingInserts, delete: this.pendingDeletes };
    return this.pendingDeletes = /* @__PURE__ */ new Set(), this.pendingInserts = /* @__PURE__ */ new Map(), this.database.updateItems(e).finally(() => {
      var t;
      if (!this.hasPending) for (; this.whenFlushedCallbacks.length; ) (t = this.whenFlushedCallbacks.pop()) === null || t === void 0 || t();
    });
  }
  async doFlush(e) {
    return this.options.hint === vm.STORAGE_IN_MEMORY ? this.flushPending() : this.flushDelayer.trigger(() => this.flushPending(), e);
  }
}
bm.DEFAULT_FLUSH_DELAY = 100;
class QD {
  constructor() {
    this.onDidChangeItemsExternal = se.None, this.items = /* @__PURE__ */ new Map();
  }
  async updateItems(e) {
    var t, n;
    (t = e.insert) === null || t === void 0 || t.forEach((s, o) => this.items.set(o, s)), (n = e.delete) === null || n === void 0 || n.forEach((s) => this.items.delete(s));
  }
}
const Hb = "__$__targetStorageMarker", Nr = tt("storageService");
var Fv;
(function(i) {
  i[i.NONE = 0] = "NONE", i[i.SHUTDOWN = 1] = "SHUTDOWN";
})(Fv || (Fv = {}));
class EL extends V {
  constructor(e = { flushInterval: EL.DEFAULT_FLUSH_INTERVAL }) {
    super(), this.options = e, this._onDidChangeValue = this._register(new og()), this._onDidChangeTarget = this._register(new og()), this._onWillSaveState = this._register(new F()), this.onWillSaveState = this._onWillSaveState.event, this._workspaceKeyTargets = void 0, this._profileKeyTargets = void 0, this._applicationKeyTargets = void 0;
  }
  onDidChangeValue(e, t, n) {
    return se.filter(this._onDidChangeValue.event, (s) => s.scope === e && (t === void 0 || s.key === t), n);
  }
  emitDidChangeValue(e, t) {
    const { key: n, external: s } = t;
    if (n === Hb) {
      switch (e) {
        case -1:
          this._applicationKeyTargets = void 0;
          break;
        case 0:
          this._profileKeyTargets = void 0;
          break;
        case 1:
          this._workspaceKeyTargets = void 0;
      }
      this._onDidChangeTarget.fire({ scope: e });
    } else this._onDidChangeValue.fire({ scope: e, key: n, target: this.getKeyTargets(e)[n], external: s });
  }
  get(e, t, n) {
    var s;
    return (s = this.getStorage(t)) === null || s === void 0 ? void 0 : s.get(e, n);
  }
  getBoolean(e, t, n) {
    var s;
    return (s = this.getStorage(t)) === null || s === void 0 ? void 0 : s.getBoolean(e, n);
  }
  getNumber(e, t, n) {
    var s;
    return (s = this.getStorage(t)) === null || s === void 0 ? void 0 : s.getNumber(e, n);
  }
  store(e, t, n, s, o = !1) {
    mo(t) ? this.remove(e, n, o) : this.withPausedEmitters(() => {
      var r;
      this.updateKeyTarget(e, n, s), (r = this.getStorage(n)) === null || r === void 0 || r.set(e, t, o);
    });
  }
  remove(e, t, n = !1) {
    this.withPausedEmitters(() => {
      var s;
      this.updateKeyTarget(e, t, void 0), (s = this.getStorage(t)) === null || s === void 0 || s.delete(e, n);
    });
  }
  withPausedEmitters(e) {
    this._onDidChangeValue.pause(), this._onDidChangeTarget.pause();
    try {
      e();
    } finally {
      this._onDidChangeValue.resume(), this._onDidChangeTarget.resume();
    }
  }
  updateKeyTarget(e, t, n, s = !1) {
    var o, r;
    const a = this.getKeyTargets(t);
    typeof n == "number" ? a[e] !== n && (a[e] = n, (o = this.getStorage(t)) === null || o === void 0 || o.set(Hb, JSON.stringify(a), s)) : typeof a[e] == "number" && (delete a[e], (r = this.getStorage(t)) === null || r === void 0 || r.set(Hb, JSON.stringify(a), s));
  }
  get workspaceKeyTargets() {
    return this._workspaceKeyTargets || (this._workspaceKeyTargets = this.loadKeyTargets(1)), this._workspaceKeyTargets;
  }
  get profileKeyTargets() {
    return this._profileKeyTargets || (this._profileKeyTargets = this.loadKeyTargets(0)), this._profileKeyTargets;
  }
  get applicationKeyTargets() {
    return this._applicationKeyTargets || (this._applicationKeyTargets = this.loadKeyTargets(-1)), this._applicationKeyTargets;
  }
  getKeyTargets(e) {
    switch (e) {
      case -1:
        return this.applicationKeyTargets;
      case 0:
        return this.profileKeyTargets;
      default:
        return this.workspaceKeyTargets;
    }
  }
  loadKeyTargets(e) {
    const t = this.getStorage(e);
    return t ? function(n) {
      const s = n.get(Hb);
      if (s) try {
        return JSON.parse(s);
      } catch {
      }
      return /* @__PURE__ */ Object.create(null);
    }(t) : /* @__PURE__ */ Object.create(null);
  }
}
EL.DEFAULT_FLUSH_INTERVAL = 6e4;
const ote = { keybindingLabelBackground: de(sG), keybindingLabelForeground: de(oG), keybindingLabelBorder: de(rG), keybindingLabelBottomBorder: de(aG), keybindingLabelShadow: de(gd) }, rte = { buttonForeground: de(w_), buttonSeparator: de(Y$), buttonBackground: de(y_), buttonHoverBackground: de(X$), buttonSecondaryForeground: de(J$), buttonSecondaryBackground: de(QE), buttonSecondaryHoverBackground: de(eG), buttonBorder: de(Q$) }, ate = { progressBarBackground: de(m$) }, By = { inputActiveOptionBorder: de(FR), inputActiveOptionForeground: de(BR), inputActiveOptionBackground: de(Iu) };
de(tG), de(nG), de(iG), de(xi), de(ld), de(gd), de(ot), de(T$), de(R$), de(A$), de(g$);
const Wy = { inputBackground: de(gB), inputForeground: de(pB), inputBorder: de(mB), inputValidationInfoBorder: de(z$), inputValidationInfoBackground: de(V$), inputValidationInfoForeground: de(H$), inputValidationWarningBorder: de(j$), inputValidationWarningBackground: de(U$), inputValidationWarningForeground: de(K$), inputValidationErrorBorder: de(G$), inputValidationErrorBackground: de(q$), inputValidationErrorForeground: de($$) }, lte = { listFilterWidgetBackground: de(bG), listFilterWidgetOutline: de(CG), listFilterWidgetNoMatchesOutline: de(wG), listFilterWidgetShadow: de(yG), inputBoxStyles: Wy, toggleStyles: By }, QW = { badgeBackground: de(BC), badgeForeground: de(p$), badgeBorder: de(ot) };
de(I$), de(E$), de(R4), de(R4), de(M$);
const Tg = { listBackground: void 0, listInactiveFocusForeground: void 0, listFocusBackground: de(lG), listFocusForeground: de(dG), listFocusOutline: de(hG), listActiveSelectionBackground: de(md), listActiveSelectionForeground: de(al), listActiveSelectionIconForeground: de(S_), listFocusAndSelectionOutline: de(cG), listFocusAndSelectionBackground: de(md), listFocusAndSelectionForeground: de(al), listInactiveSelectionBackground: de(uG), listInactiveSelectionIconForeground: de(pG), listInactiveSelectionForeground: de(gG), listInactiveFocusBackground: de(mG), listInactiveFocusOutline: de(fG), listHoverBackground: de(fB), listHoverForeground: de(_B), listDropOverBackground: de(_G), listDropBetweenBackground: de(vG), listSelectionOutline: de(Zt), listHoverOutline: de(Zt), treeIndentGuidesStroke: de(L_), treeInactiveIndentGuidesStroke: de(SG), tableColumnsBorder: de(LG), tableOddRowsBackgroundColor: de(kG) };
function Rg(i) {
  return function(e, t) {
    const n = { ...t };
    for (const s in e) {
      const o = e[s];
      n[s] = o !== void 0 ? de(o) : void 0;
    }
    return n;
  }(i, Tg);
}
const dte = { selectBackground: de(rl), selectListBackground: de(Z$), selectForeground: de(pd), decoratorRightForeground: de(vB), selectBorder: de(Ap), focusBorder: de($o), listFocusBackground: de(Ph), listInactiveSelectionIconForeground: de(Pp), listFocusForeground: de(Ah), listFocusOutline: (z3 = Zt, U3 = z.transparent.toString(), `var(${PR(z3)}, ${U3})`), listHoverBackground: de(fB), listHoverForeground: de(_B), listHoverOutline: de(Zt), selectListBorder: de(dd), listBackground: void 0, listActiveSelectionBackground: void 0, listActiveSelectionForeground: void 0, listActiveSelectionIconForeground: void 0, listFocusAndSelectionBackground: void 0, listDropOverBackground: void 0, listDropBetweenBackground: void 0, listInactiveSelectionBackground: void 0, listInactiveSelectionForeground: void 0, listInactiveFocusBackground: void 0, listInactiveFocusOutline: void 0, listSelectionOutline: void 0, listFocusAndSelectionForeground: void 0, listFocusAndSelectionOutline: void 0, listInactiveFocusForeground: void 0, tableColumnsBorder: void 0, tableOddRowsBackgroundColor: void 0, treeIndentGuidesStroke: void 0, treeInactiveIndentGuidesStroke: void 0 };
var z3, U3;
const hte = { shadowColor: de(gd), borderColor: de(DG), foregroundColor: de(xG), backgroundColor: de(NG), selectionForegroundColor: de(EG), selectionBackgroundColor: de(IG), selectionBorderColor: de(MG), separatorColor: de(TG), scrollbarShadow: de(f_), scrollbarSliderBackground: de(__), scrollbarSliderHoverBackground: de(v_), scrollbarSliderActiveBackground: de(b_) };
var IL = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Ms = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
function ML(i, e, t, n, s, o) {
  JW(i.getActions(e), t, !1, typeof n == "string" ? (r) => r === n : n, s, o);
}
function JW(i, e, t, n = (r) => r === "navigation", s = () => !1, o = !1) {
  let r, a;
  Array.isArray(e) ? (r = e, a = e) : (r = e.primary, a = e.secondary);
  const l = /* @__PURE__ */ new Set();
  for (const [d, h] of i) {
    let c;
    n(d) ? (c = r, c.length > 0 && o && c.push(new Ui())) : (c = a, c.length > 0 && c.push(new Ui()));
    for (let u of h) {
      t && (u = u instanceof Eo && u.alt ? u.alt : u);
      const g = c.push(u);
      u instanceof Bm && l.add({ group: d, action: u, index: g - 1 });
    }
  }
  for (const { group: d, action: h, index: c } of l) {
    const u = n(d) ? r : a, g = h.actions;
    s(h, d, u.length) && u.splice(c, 1, ...g);
  }
}
let Ic = class extends ef {
  constructor(i, e, t, n, s, o, r, a) {
    super(void 0, i, { icon: !(!i.class && !i.item.icon), label: !i.class && !i.item.icon, draggable: e == null ? void 0 : e.draggable, keybinding: e == null ? void 0 : e.keybinding, hoverDelegate: e == null ? void 0 : e.hoverDelegate }), this._keybindingService = t, this._notificationService = n, this._contextKeyService = s, this._themeService = o, this._contextMenuService = r, this._accessibilityService = a, this._wantsAltCommand = !1, this._itemClassDispose = this._register(new rn()), this._altKey = ad.getInstance();
  }
  get _menuItemAction() {
    return this._action;
  }
  get _commandAction() {
    return this._wantsAltCommand && this._menuItemAction.alt || this._menuItemAction;
  }
  async onClick(i) {
    i.preventDefault(), i.stopPropagation();
    try {
      await this.actionRunner.run(this._commandAction, this._context);
    } catch (e) {
      this._notificationService.error(e);
    }
  }
  render(i) {
    if (super.render(i), i.classList.add("menu-entry"), this.options.icon && this._updateItemClass(this._menuItemAction.item), this._menuItemAction.alt) {
      let e = !1;
      const t = () => {
        var n;
        const s = !!(!((n = this._menuItemAction.alt) === null || n === void 0) && n.enabled) && (!this._accessibilityService.isMotionReduced() || e) && (this._altKey.keyStatus.altKey || this._altKey.keyStatus.shiftKey && e);
        s !== this._wantsAltCommand && (this._wantsAltCommand = s, this.updateLabel(), this.updateTooltip(), this.updateClass());
      };
      this._register(this._altKey.event(t)), this._register(K(i, "mouseleave", (n) => {
        e = !1, t();
      })), this._register(K(i, "mouseenter", (n) => {
        e = !0, t();
      })), t();
    }
  }
  updateLabel() {
    this.options.label && this.label && (this.label.textContent = this._commandAction.label);
  }
  getTooltip() {
    var i;
    const e = this._keybindingService.lookupKeybinding(this._commandAction.id, this._contextKeyService), t = e && e.getLabel(), n = this._commandAction.tooltip || this._commandAction.label;
    let s = t ? m(0, "{0} ({1})", n, t) : n;
    if (!this._wantsAltCommand && (!((i = this._menuItemAction.alt) === null || i === void 0) && i.enabled)) {
      const o = this._menuItemAction.alt.tooltip || this._menuItemAction.alt.label, r = this._keybindingService.lookupKeybinding(this._menuItemAction.alt.id, this._contextKeyService), a = r && r.getLabel(), l = a ? m(0, "{0} ({1})", o, a) : o;
      s = m(0, `{0}
[{1}] {2}`, s, xA.modifierLabels[Gs].altKey, l);
    }
    return s;
  }
  updateClass() {
    this.options.icon && (this._commandAction !== this._menuItemAction ? this._menuItemAction.alt && this._updateItemClass(this._menuItemAction.alt.item) : this._updateItemClass(this._menuItemAction.item));
  }
  _updateItemClass(i) {
    this._itemClassDispose.value = void 0;
    const { element: e, label: t } = this;
    if (!e || !t) return;
    const n = this._commandAction.checked && (s = i.toggled) && s.condition !== void 0 && i.toggled.icon ? i.toggled.icon : i.icon;
    var s;
    if (n) if (Ee.isThemeIcon(n)) {
      const o = Ee.asClassNameArray(n);
      t.classList.add(...o), this._itemClassDispose.value = ye(() => {
        t.classList.remove(...o);
      });
    } else t.style.backgroundImage = Km(this._themeService.getColorTheme().type) ? yc(n.dark) : yc(n.light), t.classList.add("icon"), this._itemClassDispose.value = yr(ye(() => {
      t.style.backgroundImage = "", t.classList.remove("icon");
    }), this._themeService.onDidColorThemeChange(() => {
      this.updateClass();
    }));
  }
};
Ic = IL([Ms(2, Dt), Ms(3, Ri), Ms(4, Te), Ms(5, Yi), Ms(6, io), Ms(7, or)], Ic);
let ZI = class extends Fy {
  constructor(i, e, t, n, s) {
    var o, r, a;
    const l = { ...e, menuAsChild: (o = e == null ? void 0 : e.menuAsChild) !== null && o !== void 0 && o, classNames: (r = e == null ? void 0 : e.classNames) !== null && r !== void 0 ? r : Ee.isThemeIcon(i.item.icon) ? Ee.asClassName(i.item.icon) : void 0, keybindingProvider: (a = e == null ? void 0 : e.keybindingProvider) !== null && a !== void 0 ? a : (d) => t.lookupKeybinding(d.id) };
    super(i, { getActions: () => i.actions }, n, l), this._keybindingService = t, this._contextMenuService = n, this._themeService = s;
  }
  render(i) {
    super.render(i), vt(this.element), i.classList.add("menu-entry");
    const e = this._action, { icon: t } = e.item;
    if (t && !Ee.isThemeIcon(t)) {
      this.element.classList.add("icon");
      const n = () => {
        this.element && (this.element.style.backgroundImage = Km(this._themeService.getColorTheme().type) ? yc(t.dark) : yc(t.light));
      };
      n(), this._register(this._themeService.onDidColorThemeChange(() => {
        n();
      }));
    }
  }
};
ZI = IL([Ms(2, Dt), Ms(3, io), Ms(4, Yi)], ZI);
let YI = class extends Gr {
  constructor(i, e, t, n, s, o, r, a) {
    var l, d, h;
    let c;
    super(null, i), this._keybindingService = t, this._notificationService = n, this._contextMenuService = s, this._menuService = o, this._instaService = r, this._storageService = a, this._container = null, this._options = e, this._storageKey = `${i.item.submenu.id}_lastActionId`;
    const u = e != null && e.persistLastActionId ? a.get(this._storageKey, 1) : void 0;
    u && (c = i.actions.find((p) => u === p.id)), c || (c = i.actions[0]), this._defaultAction = this._instaService.createInstance(Ic, c, { keybinding: this._getDefaultActionKeybindingLabel(c) });
    const g = { keybindingProvider: (p) => this._keybindingService.lookupKeybinding(p.id), ...e, menuAsChild: (l = e == null ? void 0 : e.menuAsChild) === null || l === void 0 || l, classNames: (d = e == null ? void 0 : e.classNames) !== null && d !== void 0 ? d : ["codicon", "codicon-chevron-down"], actionRunner: (h = e == null ? void 0 : e.actionRunner) !== null && h !== void 0 ? h : new hg() };
    this._dropdown = new Fy(i, i.actions, this._contextMenuService, g), this._register(this._dropdown.actionRunner.onDidRun((p) => {
      p.action instanceof Eo && this.update(p.action);
    }));
  }
  update(i) {
    var e;
    !((e = this._options) === null || e === void 0) && e.persistLastActionId && this._storageService.store(this._storageKey, i.id, 1, 1), this._defaultAction.dispose(), this._defaultAction = this._instaService.createInstance(Ic, i, { keybinding: this._getDefaultActionKeybindingLabel(i) }), this._defaultAction.actionRunner = new class extends hg {
      async runAction(t, n) {
        await t.run(void 0);
      }
    }(), this._container && this._defaultAction.render(_R(this._container, Q(".action-container")));
  }
  _getDefaultActionKeybindingLabel(i) {
    var e;
    let t;
    if (!((e = this._options) === null || e === void 0) && e.renderKeybindingWithDefaultActionLabel) {
      const n = this._keybindingService.lookupKeybinding(i.id);
      n && (t = `(${n.getLabel()})`);
    }
    return t;
  }
  setActionContext(i) {
    super.setActionContext(i), this._defaultAction.setActionContext(i), this._dropdown.setActionContext(i);
  }
  render(i) {
    this._container = i, super.render(this._container), this._container.classList.add("monaco-dropdown-with-default");
    const e = Q(".action-container");
    this._defaultAction.render(Z(this._container, e)), this._register(K(e, ie.KEY_DOWN, (n) => {
      const s = new jt(n);
      s.equals(17) && (this._defaultAction.element.tabIndex = -1, this._dropdown.focus(), s.stopPropagation());
    }));
    const t = Q(".dropdown-action-container");
    this._dropdown.render(Z(this._container, t)), this._register(K(t, ie.KEY_DOWN, (n) => {
      var s;
      const o = new jt(n);
      o.equals(15) && (this._defaultAction.element.tabIndex = 0, this._dropdown.setFocusable(!1), (s = this._defaultAction.element) === null || s === void 0 || s.focus(), o.stopPropagation());
    }));
  }
  focus(i) {
    i ? this._dropdown.focus() : (this._defaultAction.element.tabIndex = 0, this._defaultAction.element.focus());
  }
  blur() {
    this._defaultAction.element.tabIndex = -1, this._dropdown.blur(), this._container.blur();
  }
  setFocusable(i) {
    i ? this._defaultAction.element.tabIndex = 0 : (this._defaultAction.element.tabIndex = -1, this._dropdown.setFocusable(!1));
  }
  dispose() {
    this._defaultAction.dispose(), this._dropdown.dispose(), super.dispose();
  }
};
YI = IL([Ms(2, Dt), Ms(3, Ri), Ms(4, io), Ms(5, Mo), Ms(6, Se), Ms(7, Nr)], YI);
let XI = class extends ite {
  constructor(i, e) {
    super(null, i, i.actions.map((t) => ({ text: t.id === Ui.ID ? "─────────" : t.label, isDisabled: !t.enabled })), 0, e, dte, { ariaLabel: i.tooltip, optionsAsChildren: !0 }), this.select(Math.max(0, i.actions.findIndex((t) => t.checked)));
  }
  render(i) {
    super.render(i), i.style.borderColor = de(Ap);
  }
  runAction(i, e) {
    const t = this.action.actions[e];
    t && this.actionRunner.run(t);
  }
};
function eV(i, e, t) {
  return e instanceof Eo ? i.createInstance(Ic, e, t) : e instanceof iv ? e.item.isSelection ? i.createInstance(XI, e) : e.item.rememberDefaultAction ? i.createInstance(YI, e, { ...t, persistLastActionId: !0 }) : i.createInstance(ZI, e, t) : void 0;
}
XI = IL([Ms(1, zd)], XI);
class sr extends V {
  constructor(e, t = {}) {
    var n, s, o, r, a, l, d;
    let h, c;
    switch (super(), this._actionRunnerDisposables = this._register(new G()), this.viewItemDisposables = this._register(new QT()), this.triggerKeyDown = !1, this.focusable = !0, this._onDidBlur = this._register(new F()), this.onDidBlur = this._onDidBlur.event, this._onDidCancel = this._register(new F({ onWillAddFirstListener: () => this.cancelHasListener = !0 })), this.onDidCancel = this._onDidCancel.event, this.cancelHasListener = !1, this._onDidRun = this._register(new F()), this.onDidRun = this._onDidRun.event, this._onWillRun = this._register(new F()), this.onWillRun = this._onWillRun.event, this.options = t, this._context = (n = t.context) !== null && n !== void 0 ? n : null, this._orientation = (s = this.options.orientation) !== null && s !== void 0 ? s : 0, this._triggerKeys = { keyDown: (r = (o = this.options.triggerKeys) === null || o === void 0 ? void 0 : o.keyDown) !== null && r !== void 0 && r, keys: (l = (a = this.options.triggerKeys) === null || a === void 0 ? void 0 : a.keys) !== null && l !== void 0 ? l : [3, 10] }, this._hoverDelegate = (d = t.hoverDelegate) !== null && d !== void 0 ? d : this._register(Xm()), this.options.actionRunner ? this._actionRunner = this.options.actionRunner : (this._actionRunner = new hg(), this._actionRunnerDisposables.add(this._actionRunner)), this._actionRunnerDisposables.add(this._actionRunner.onDidRun((u) => this._onDidRun.fire(u))), this._actionRunnerDisposables.add(this._actionRunner.onWillRun((u) => this._onWillRun.fire(u))), this.viewItems = [], this.focusedItem = void 0, this.domNode = document.createElement("div"), this.domNode.className = "monaco-action-bar", this._orientation) {
      case 0:
        h = [15], c = [17];
        break;
      case 1:
        h = [16], c = [18], this.domNode.className += " vertical";
    }
    this._register(K(this.domNode, ie.KEY_DOWN, (u) => {
      const g = new jt(u);
      let p = !0;
      const f = typeof this.focusedItem == "number" ? this.viewItems[this.focusedItem] : void 0;
      h && (g.equals(h[0]) || g.equals(h[1])) ? p = this.focusPrevious() : c && (g.equals(c[0]) || g.equals(c[1])) ? p = this.focusNext() : g.equals(9) && this.cancelHasListener ? this._onDidCancel.fire() : g.equals(14) ? p = this.focusFirst() : g.equals(13) ? p = this.focusLast() : g.equals(2) && f instanceof Gr && f.trapsArrowNavigation ? p = this.focusNext() : this.isTriggerKeyEvent(g) ? this._triggerKeys.keyDown ? this.doTrigger(g) : this.triggerKeyDown = !0 : p = !1, p && (g.preventDefault(), g.stopPropagation());
    })), this._register(K(this.domNode, ie.KEY_UP, (u) => {
      const g = new jt(u);
      this.isTriggerKeyEvent(g) ? (!this._triggerKeys.keyDown && this.triggerKeyDown && (this.triggerKeyDown = !1, this.doTrigger(g)), g.preventDefault(), g.stopPropagation()) : (g.equals(2) || g.equals(1026) || g.equals(16) || g.equals(18) || g.equals(15) || g.equals(17)) && this.updateFocusedItem();
    })), this.focusTracker = this._register(ma(this.domNode)), this._register(this.focusTracker.onDidBlur(() => {
      Mn() !== this.domNode && gn(Mn(), this.domNode) || (this._onDidBlur.fire(), this.previouslyFocusedItem = this.focusedItem, this.focusedItem = void 0, this.triggerKeyDown = !1);
    })), this._register(this.focusTracker.onDidFocus(() => this.updateFocusedItem())), this.actionsList = document.createElement("ul"), this.actionsList.className = "actions-container", this.options.highlightToggledItems && this.actionsList.classList.add("highlight-toggled"), this.actionsList.setAttribute("role", this.options.ariaRole || "toolbar"), this.options.ariaLabel && this.actionsList.setAttribute("aria-label", this.options.ariaLabel), this.domNode.appendChild(this.actionsList), e.appendChild(this.domNode);
  }
  refreshRole() {
    this.length() >= 1 ? this.actionsList.setAttribute("role", this.options.ariaRole || "toolbar") : this.actionsList.setAttribute("role", "presentation");
  }
  setFocusable(e) {
    if (this.focusable = e, this.focusable) {
      const t = this.viewItems.find((n) => n instanceof Gr && n.isEnabled());
      t instanceof Gr && t.setFocusable(!0);
    } else this.viewItems.forEach((t) => {
      t instanceof Gr && t.setFocusable(!1);
    });
  }
  isTriggerKeyEvent(e) {
    let t = !1;
    return this._triggerKeys.keys.forEach((n) => {
      t = t || e.equals(n);
    }), t;
  }
  updateFocusedItem() {
    var e, t;
    for (let n = 0; n < this.actionsList.children.length; n++) {
      const s = this.actionsList.children[n];
      if (gn(Mn(), s)) {
        this.focusedItem = n, (t = (e = this.viewItems[this.focusedItem]) === null || e === void 0 ? void 0 : e.showHover) === null || t === void 0 || t.call(e);
        break;
      }
    }
  }
  get context() {
    return this._context;
  }
  set context(e) {
    this._context = e, this.viewItems.forEach((t) => t.setActionContext(e));
  }
  get actionRunner() {
    return this._actionRunner;
  }
  set actionRunner(e) {
    this._actionRunner = e, this._actionRunnerDisposables.clear(), this._actionRunnerDisposables.add(this._actionRunner.onDidRun((t) => this._onDidRun.fire(t))), this._actionRunnerDisposables.add(this._actionRunner.onWillRun((t) => this._onWillRun.fire(t))), this.viewItems.forEach((t) => t.actionRunner = e);
  }
  getContainer() {
    return this.domNode;
  }
  getAction(e) {
    var t;
    if (typeof e == "number") return (t = this.viewItems[e]) === null || t === void 0 ? void 0 : t.action;
    if (e instanceof HTMLElement) {
      for (; e.parentElement !== this.actionsList; ) {
        if (!e.parentElement) return;
        e = e.parentElement;
      }
      for (let n = 0; n < this.actionsList.childNodes.length; n++) if (this.actionsList.childNodes[n] === e) return this.viewItems[n].action;
    }
  }
  push(e, t = {}) {
    const n = Array.isArray(e) ? e : [e];
    let s = gc(t.index) ? t.index : null;
    n.forEach((o) => {
      const r = document.createElement("li");
      let a;
      r.className = "action-item", r.setAttribute("role", "presentation");
      const l = { hoverDelegate: this._hoverDelegate, ...t };
      this.options.actionViewItemProvider && (a = this.options.actionViewItemProvider(o, l)), a || (a = new ef(this.context, o, l)), this.options.allowContextMenu || this.viewItemDisposables.set(a, K(r, ie.CONTEXT_MENU, (d) => {
        Ze(d, !0);
      })), a.actionRunner = this._actionRunner, a.setActionContext(this.context), a.render(r), this.focusable && a instanceof Gr && this.viewItems.length === 0 && a.setFocusable(!0), s === null || s < 0 || s >= this.actionsList.children.length ? (this.actionsList.appendChild(r), this.viewItems.push(a)) : (this.actionsList.insertBefore(r, this.actionsList.children[s]), this.viewItems.splice(s, 0, a), s++);
    }), typeof this.focusedItem == "number" && this.focus(this.focusedItem), this.refreshRole();
  }
  clear() {
    this.isEmpty() || (this.viewItems = Ht(this.viewItems), this.viewItemDisposables.clearAndDisposeAll(), Un(this.actionsList), this.refreshRole());
  }
  length() {
    return this.viewItems.length;
  }
  isEmpty() {
    return this.viewItems.length === 0;
  }
  focus(e) {
    let t, n = !1;
    if (e === void 0 ? n = !0 : typeof e == "number" ? t = e : typeof e == "boolean" && (n = e), n && this.focusedItem === void 0) {
      const s = this.viewItems.findIndex((o) => o.isEnabled());
      this.focusedItem = s === -1 ? void 0 : s, this.updateFocus(void 0, void 0, !0);
    } else t !== void 0 && (this.focusedItem = t), this.updateFocus(void 0, void 0, !0);
  }
  focusFirst() {
    return this.focusedItem = this.length() - 1, this.focusNext(!0);
  }
  focusLast() {
    return this.focusedItem = 0, this.focusPrevious(!0);
  }
  focusNext(e) {
    if (this.focusedItem === void 0) this.focusedItem = this.viewItems.length - 1;
    else if (this.viewItems.length <= 1) return !1;
    const t = this.focusedItem;
    let n;
    do {
      if (!e && this.options.preventLoopNavigation && this.focusedItem + 1 >= this.viewItems.length) return this.focusedItem = t, !1;
      this.focusedItem = (this.focusedItem + 1) % this.viewItems.length, n = this.viewItems[this.focusedItem];
    } while (this.focusedItem !== t && (this.options.focusOnlyEnabledItems && !n.isEnabled() || n.action.id === Ui.ID));
    return this.updateFocus(), !0;
  }
  focusPrevious(e) {
    if (this.focusedItem === void 0) this.focusedItem = 0;
    else if (this.viewItems.length <= 1) return !1;
    const t = this.focusedItem;
    let n;
    do {
      if (this.focusedItem = this.focusedItem - 1, this.focusedItem < 0) {
        if (!e && this.options.preventLoopNavigation) return this.focusedItem = t, !1;
        this.focusedItem = this.viewItems.length - 1;
      }
      n = this.viewItems[this.focusedItem];
    } while (this.focusedItem !== t && (this.options.focusOnlyEnabledItems && !n.isEnabled() || n.action.id === Ui.ID));
    return this.updateFocus(!0), !0;
  }
  updateFocus(e, t, n = !1) {
    var s, o;
    this.focusedItem === void 0 && this.actionsList.focus({ preventScroll: t }), this.previouslyFocusedItem !== void 0 && this.previouslyFocusedItem !== this.focusedItem && ((s = this.viewItems[this.previouslyFocusedItem]) === null || s === void 0 || s.blur());
    const r = this.focusedItem !== void 0 ? this.viewItems[this.focusedItem] : void 0;
    if (r) {
      let a = !0;
      j0(r.focus) || (a = !1), this.options.focusOnlyEnabledItems && j0(r.isEnabled) && !r.isEnabled() && (a = !1), r.action.id === Ui.ID && (a = !1), a ? (n || this.previouslyFocusedItem !== this.focusedItem) && (r.focus(e), this.previouslyFocusedItem = this.focusedItem) : (this.actionsList.focus({ preventScroll: t }), this.previouslyFocusedItem = void 0), a && ((o = r.showHover) === null || o === void 0 || o.call(r));
    }
  }
  doTrigger(e) {
    if (this.focusedItem === void 0) return;
    const t = this.viewItems[this.focusedItem];
    if (t instanceof Gr) {
      const n = t._context === null || t._context === void 0 ? e : t._context;
      this.run(t._action, n);
    }
  }
  async run(e, t) {
    await this._actionRunner.run(e, t);
  }
  dispose() {
    this._context = void 0, this.viewItems = Ht(this.viewItems), this.getContainer().remove(), super.dispose();
  }
}
const JD = /\(&([^\s&])\)|(^|[^&])&([^\s&])/, ex = /(&amp;)?(&amp;)([^\s&])/g;
var Vy, QI;
(function(i) {
  i[i.Right = 0] = "Right", i[i.Left = 1] = "Left";
})(Vy || (Vy = {})), function(i) {
  i[i.Above = 0] = "Above", i[i.Below = 1] = "Below";
}(QI || (QI = {}));
class Cm extends sr {
  constructor(e, t, n, s) {
    e.classList.add("monaco-menu-container"), e.setAttribute("role", "presentation");
    const o = document.createElement("div");
    o.classList.add("monaco-menu"), o.setAttribute("role", "presentation"), super(o, { orientation: 1, actionViewItemProvider: (d) => this.doGetActionViewItem(d, n, r), context: n.context, actionRunner: n.actionRunner, ariaLabel: n.ariaLabel, ariaRole: "menu", focusOnlyEnabledItems: !0, triggerKeys: { keys: [3, ...Je || Cs ? [10] : []], keyDown: !0 } }), this.menuStyles = s, this.menuElement = o, this.actionsList.tabIndex = 0, this.initializeOrUpdateStyleSheet(e, s), this._register(Bt.addTarget(o)), this._register(K(o, ie.KEY_DOWN, (d) => {
      new jt(d).equals(2) && d.preventDefault();
    })), n.enableMnemonics && this._register(K(o, ie.KEY_DOWN, (d) => {
      const h = d.key.toLocaleLowerCase();
      if (this.mnemonics.has(h)) {
        Ze(d, !0);
        const c = this.mnemonics.get(h);
        if (c.length === 1 && (c[0] instanceof K3 && c[0].container && this.focusItemByElement(c[0].container), c[0].onClick(d)), c.length > 1) {
          const u = c.shift();
          u && u.container && (this.focusItemByElement(u.container), c.push(u)), this.mnemonics.set(h, c);
        }
      }
    })), Cs && this._register(K(o, ie.KEY_DOWN, (d) => {
      const h = new jt(d);
      h.equals(14) || h.equals(11) ? (this.focusedItem = this.viewItems.length - 1, this.focusNext(), Ze(d, !0)) : (h.equals(13) || h.equals(12)) && (this.focusedItem = 0, this.focusPrevious(), Ze(d, !0));
    })), this._register(K(this.domNode, ie.MOUSE_OUT, (d) => {
      gn(d.relatedTarget, this.domNode) || (this.focusedItem = void 0, this.updateFocus(), d.stopPropagation());
    })), this._register(K(this.actionsList, ie.MOUSE_OVER, (d) => {
      let h = d.target;
      if (h && gn(h, this.actionsList) && h !== this.actionsList) {
        for (; h.parentElement !== this.actionsList && h.parentElement !== null; ) h = h.parentElement;
        if (h.classList.contains("action-item")) {
          const c = this.focusedItem;
          this.setFocusedItem(h), c !== this.focusedItem && this.updateFocus();
        }
      }
    })), this._register(Bt.addTarget(this.actionsList)), this._register(K(this.actionsList, Vt.Tap, (d) => {
      let h = d.initialTarget;
      if (h && gn(h, this.actionsList) && h !== this.actionsList) {
        for (; h.parentElement !== this.actionsList && h.parentElement !== null; ) h = h.parentElement;
        if (h.classList.contains("action-item")) {
          const c = this.focusedItem;
          this.setFocusedItem(h), c !== this.focusedItem && this.updateFocus();
        }
      }
    }));
    const r = { parent: this };
    this.mnemonics = /* @__PURE__ */ new Map(), this.scrollableElement = this._register(new k1(o, { alwaysConsumeMouseWheel: !0, horizontal: 2, vertical: 3, verticalScrollbarSize: 7, handleMouseWheel: !0, useShadows: !0 }));
    const a = this.scrollableElement.getDomNode();
    a.style.position = "", this.styleScrollElement(a, s), this._register(K(o, Vt.Change, (d) => {
      Ze(d, !0);
      const h = this.scrollableElement.getScrollPosition().scrollTop;
      this.scrollableElement.setScrollPosition({ scrollTop: h - d.translationY });
    })), this._register(K(a, ie.MOUSE_UP, (d) => {
      d.preventDefault();
    }));
    const l = ke(e);
    o.style.maxHeight = `${Math.max(10, l.innerHeight - e.getBoundingClientRect().top - 35)}px`, t = t.filter((d, h) => {
      var c;
      return !((c = n.submenuIds) === null || c === void 0) && c.has(d.id) ? (console.warn(`Found submenu cycle: ${d.id}`), !1) : !(d instanceof Ui && (h === t.length - 1 || h === 0 || t[h - 1] instanceof Ui));
    }), this.push(t, { icon: !0, label: !0, isMenu: !0 }), e.appendChild(this.scrollableElement.getDomNode()), this.scrollableElement.scanDomNode(), this.viewItems.filter((d) => !(d instanceof j3)).forEach((d, h, c) => {
      d.updatePositionInSet(h + 1, c.length);
    });
  }
  initializeOrUpdateStyleSheet(e, t) {
    this.styleSheet || ($w(e) ? this.styleSheet = Lo(e) : (Cm.globalStyleSheet || (Cm.globalStyleSheet = Lo()), this.styleSheet = Cm.globalStyleSheet)), this.styleSheet.textContent = function(n, s) {
      let o = `
.monaco-menu {
	font-size: 13px;
	border-radius: 5px;
	min-width: 160px;
}

${q3(ne.menuSelection)}
${q3(ne.menuSubmenu)}

.monaco-menu .monaco-action-bar {
	text-align: right;
	overflow: hidden;
	white-space: nowrap;
}

.monaco-menu .monaco-action-bar .actions-container {
	display: flex;
	margin: 0 auto;
	padding: 0;
	width: 100%;
	justify-content: flex-end;
}

.monaco-menu .monaco-action-bar.vertical .actions-container {
	display: inline-block;
}

.monaco-menu .monaco-action-bar.reverse .actions-container {
	flex-direction: row-reverse;
}

.monaco-menu .monaco-action-bar .action-item {
	cursor: pointer;
	display: inline-block;
	transition: transform 50ms ease;
	position: relative;  /* DO NOT REMOVE - this is the key to preventing the ghosting icon bug in Chrome 42 */
}

.monaco-menu .monaco-action-bar .action-item.disabled {
	cursor: default;
}

.monaco-menu .monaco-action-bar .action-item .icon,
.monaco-menu .monaco-action-bar .action-item .codicon {
	display: inline-block;
}

.monaco-menu .monaco-action-bar .action-item .codicon {
	display: flex;
	align-items: center;
}

.monaco-menu .monaco-action-bar .action-label {
	font-size: 11px;
	margin-right: 4px;
}

.monaco-menu .monaco-action-bar .action-item.disabled .action-label,
.monaco-menu .monaco-action-bar .action-item.disabled .action-label:hover {
	color: var(--vscode-disabledForeground);
}

/* Vertical actions */

.monaco-menu .monaco-action-bar.vertical {
	text-align: left;
}

.monaco-menu .monaco-action-bar.vertical .action-item {
	display: block;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator {
	display: block;
	border-bottom: 1px solid var(--vscode-menu-separatorBackground);
	padding-top: 1px;
	padding: 30px;
}

.monaco-menu .secondary-actions .monaco-action-bar .action-label {
	margin-left: 6px;
}

/* Action Items */
.monaco-menu .monaco-action-bar .action-item.select-container {
	overflow: hidden; /* somehow the dropdown overflows its container, we prevent it here to not push */
	flex: 1;
	max-width: 170px;
	min-width: 60px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 10px;
}

.monaco-menu .monaco-action-bar.vertical {
	margin-left: 0;
	overflow: visible;
}

.monaco-menu .monaco-action-bar.vertical .actions-container {
	display: block;
}

.monaco-menu .monaco-action-bar.vertical .action-item {
	padding: 0;
	transform: none;
	display: flex;
}

.monaco-menu .monaco-action-bar.vertical .action-item.active {
	transform: none;
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item {
	flex: 1 1 auto;
	display: flex;
	height: 2em;
	align-items: center;
	position: relative;
	margin: 0 4px;
	border-radius: 4px;
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item:hover .keybinding,
.monaco-menu .monaco-action-bar.vertical .action-menu-item:focus .keybinding {
	opacity: unset;
}

.monaco-menu .monaco-action-bar.vertical .action-label {
	flex: 1 1 auto;
	text-decoration: none;
	padding: 0 1em;
	background: none;
	font-size: 12px;
	line-height: 1;
}

.monaco-menu .monaco-action-bar.vertical .keybinding,
.monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	display: inline-block;
	flex: 2 1 auto;
	padding: 0 1em;
	text-align: right;
	font-size: 12px;
	line-height: 1;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	height: 100%;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator.codicon {
	font-size: 16px !important;
	display: flex;
	align-items: center;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator.codicon::before {
	margin-left: auto;
	margin-right: -20px;
}

.monaco-menu .monaco-action-bar.vertical .action-item.disabled .keybinding,
.monaco-menu .monaco-action-bar.vertical .action-item.disabled .submenu-indicator {
	opacity: 0.4;
}

.monaco-menu .monaco-action-bar.vertical .action-label:not(.separator) {
	display: inline-block;
	box-sizing: border-box;
	margin: 0;
}

.monaco-menu .monaco-action-bar.vertical .action-item {
	position: static;
	overflow: visible;
}

.monaco-menu .monaco-action-bar.vertical .action-item .monaco-submenu {
	position: absolute;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator {
	width: 100%;
	height: 0px !important;
	opacity: 1;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator.text {
	padding: 0.7em 1em 0.1em 1em;
	font-weight: bold;
	opacity: 1;
}

.monaco-menu .monaco-action-bar.vertical .action-label:hover {
	color: inherit;
}

.monaco-menu .monaco-action-bar.vertical .menu-item-check {
	position: absolute;
	visibility: hidden;
	width: 1em;
	height: 100%;
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item.checked .menu-item-check {
	visibility: visible;
	display: flex;
	align-items: center;
	justify-content: center;
}

/* Context Menu */

.context-view.monaco-menu-container {
	outline: 0;
	border: none;
	animation: fadeIn 0.083s linear;
	-webkit-app-region: no-drag;
}

.context-view.monaco-menu-container :focus,
.context-view.monaco-menu-container .monaco-action-bar.vertical:focus,
.context-view.monaco-menu-container .monaco-action-bar.vertical :focus {
	outline: 0;
}

.hc-black .context-view.monaco-menu-container,
.hc-light .context-view.monaco-menu-container,
:host-context(.hc-black) .context-view.monaco-menu-container,
:host-context(.hc-light) .context-view.monaco-menu-container {
	box-shadow: none;
}

.hc-black .monaco-menu .monaco-action-bar.vertical .action-item.focused,
.hc-light .monaco-menu .monaco-action-bar.vertical .action-item.focused,
:host-context(.hc-black) .monaco-menu .monaco-action-bar.vertical .action-item.focused,
:host-context(.hc-light) .monaco-menu .monaco-action-bar.vertical .action-item.focused {
	background: none;
}

/* Vertical Action Bar Styles */

.monaco-menu .monaco-action-bar.vertical {
	padding: 4px 0;
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item {
	height: 2em;
}

.monaco-menu .monaco-action-bar.vertical .action-label:not(.separator),
.monaco-menu .monaco-action-bar.vertical .keybinding {
	font-size: inherit;
	padding: 0 2em;
}

.monaco-menu .monaco-action-bar.vertical .menu-item-check {
	font-size: inherit;
	width: 2em;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator {
	font-size: inherit;
	margin: 5px 0 !important;
	padding: 0;
	border-radius: 0;
}

.linux .monaco-menu .monaco-action-bar.vertical .action-label.separator,
:host-context(.linux) .monaco-menu .monaco-action-bar.vertical .action-label.separator {
	margin-left: 0;
	margin-right: 0;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	font-size: 60%;
	padding: 0 1.8em;
}

.linux .monaco-menu .monaco-action-bar.vertical .submenu-indicator,
:host-context(.linux) .monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	height: 100%;
	mask-size: 10px 10px;
	-webkit-mask-size: 10px 10px;
}

.monaco-menu .action-item {
	cursor: default;
}`;
      if (s) {
        o += `
			/* Arrows */
			.monaco-scrollable-element > .scrollbar > .scra {
				cursor: pointer;
				font-size: 11px !important;
			}

			.monaco-scrollable-element > .visible {
				opacity: 1;

				/* Background rule added for IE9 - to allow clicks on dom node */
				background:rgba(0,0,0,0);

				transition: opacity 100ms linear;
			}
			.monaco-scrollable-element > .invisible {
				opacity: 0;
				pointer-events: none;
			}
			.monaco-scrollable-element > .invisible.fade {
				transition: opacity 800ms linear;
			}

			/* Scrollable Content Inset Shadow */
			.monaco-scrollable-element > .shadow {
				position: absolute;
				display: none;
			}
			.monaco-scrollable-element > .shadow.top {
				display: block;
				top: 0;
				left: 3px;
				height: 3px;
				width: 100%;
			}
			.monaco-scrollable-element > .shadow.left {
				display: block;
				top: 3px;
				left: 0;
				height: 100%;
				width: 3px;
			}
			.monaco-scrollable-element > .shadow.top-left-corner {
				display: block;
				top: 0;
				left: 0;
				height: 3px;
				width: 3px;
			}
		`;
        const r = n.scrollbarShadow;
        r && (o += `
				.monaco-scrollable-element > .shadow.top {
					box-shadow: ${r} 0 6px 6px -6px inset;
				}

				.monaco-scrollable-element > .shadow.left {
					box-shadow: ${r} 6px 0 6px -6px inset;
				}

				.monaco-scrollable-element > .shadow.top.left {
					box-shadow: ${r} 6px 6px 6px -6px inset;
				}
			`);
        const a = n.scrollbarSliderBackground;
        a && (o += `
				.monaco-scrollable-element > .scrollbar > .slider {
					background: ${a};
				}
			`);
        const l = n.scrollbarSliderHoverBackground;
        l && (o += `
				.monaco-scrollable-element > .scrollbar > .slider:hover {
					background: ${l};
				}
			`);
        const d = n.scrollbarSliderActiveBackground;
        d && (o += `
				.monaco-scrollable-element > .scrollbar > .slider.active {
					background: ${d};
				}
			`);
      }
      return o;
    }(t, $w(e));
  }
  styleScrollElement(e, t) {
    var n, s;
    const o = (n = t.foregroundColor) !== null && n !== void 0 ? n : "", r = (s = t.backgroundColor) !== null && s !== void 0 ? s : "", a = t.borderColor ? `1px solid ${t.borderColor}` : "", l = t.shadowColor ? `0 2px 8px ${t.shadowColor}` : "";
    e.style.outline = a, e.style.borderRadius = "5px", e.style.color = o, e.style.backgroundColor = r, e.style.boxShadow = l;
  }
  getContainer() {
    return this.scrollableElement.getDomNode();
  }
  get onScroll() {
    return this.scrollableElement.onScroll;
  }
  focusItemByElement(e) {
    const t = this.focusedItem;
    this.setFocusedItem(e), t !== this.focusedItem && this.updateFocus();
  }
  setFocusedItem(e) {
    for (let t = 0; t < this.actionsList.children.length; t++)
      if (e === this.actionsList.children[t]) {
        this.focusedItem = t;
        break;
      }
  }
  updateFocus(e) {
    super.updateFocus(e, !0, !0), this.focusedItem !== void 0 && this.scrollableElement.setScrollPosition({ scrollTop: Math.round(this.menuElement.scrollTop) });
  }
  doGetActionViewItem(e, t, n) {
    if (e instanceof Ui) return new j3(t.context, e, { icon: !0 }, this.menuStyles);
    if (e instanceof Bm) {
      const s = new K3(e, e.actions, n, { ...t, submenuIds: /* @__PURE__ */ new Set([...t.submenuIds || [], e.id]) }, this.menuStyles);
      if (t.enableMnemonics) {
        const o = s.getMnemonic();
        if (o && s.isEnabled()) {
          let r = [];
          this.mnemonics.has(o) && (r = this.mnemonics.get(o)), r.push(s), this.mnemonics.set(o, r);
        }
      }
      return s;
    }
    {
      const s = { enableMnemonics: t.enableMnemonics, useEventAsContext: t.useEventAsContext };
      if (t.getKeyBinding) {
        const r = t.getKeyBinding(e);
        if (r) {
          const a = r.getLabel();
          a && (s.keybinding = a);
        }
      }
      const o = new tV(t.context, e, s, this.menuStyles);
      if (t.enableMnemonics) {
        const r = o.getMnemonic();
        if (r && o.isEnabled()) {
          let a = [];
          this.mnemonics.has(r) && (a = this.mnemonics.get(r)), a.push(o), this.mnemonics.set(r, a);
        }
      }
      return o;
    }
  }
}
class tV extends Gr {
  constructor(e, t, n, s) {
    if (n.isMenu = !0, super(t, t, n), this.menuStyle = s, this.options = n, this.options.icon = n.icon !== void 0 && n.icon, this.options.label = n.label === void 0 || n.label, this.cssClass = "", this.options.label && n.enableMnemonics) {
      const o = this.action.label;
      if (o) {
        const r = JD.exec(o);
        r && (this.mnemonic = (r[1] ? r[1] : r[3]).toLocaleLowerCase());
      }
    }
    this.runOnceToEnableMouseUp = new It(() => {
      this.element && (this._register(K(this.element, ie.MOUSE_UP, (o) => {
        if (Ze(o, !0), tr) {
          if (new _r(ke(this.element), o).rightButton) return;
          this.onClick(o);
        } else setTimeout(() => {
          this.onClick(o);
        }, 0);
      })), this._register(K(this.element, ie.CONTEXT_MENU, (o) => {
        Ze(o, !0);
      })));
    }, 100), this._register(this.runOnceToEnableMouseUp);
  }
  render(e) {
    super.render(e), this.element && (this.container = e, this.item = Z(this.element, Q("a.action-menu-item")), this._action.id === Ui.ID ? this.item.setAttribute("role", "presentation") : (this.item.setAttribute("role", "menuitem"), this.mnemonic && this.item.setAttribute("aria-keyshortcuts", `${this.mnemonic}`)), this.check = Z(this.item, Q("span.menu-item-check" + Ee.asCSSSelector(ne.menuSelection))), this.check.setAttribute("role", "none"), this.label = Z(this.item, Q("span.action-label")), this.options.label && this.options.keybinding && (Z(this.item, Q("span.keybinding")).textContent = this.options.keybinding), this.runOnceToEnableMouseUp.schedule(), this.updateClass(), this.updateLabel(), this.updateTooltip(), this.updateEnabled(), this.updateChecked(), this.applyStyle());
  }
  blur() {
    super.blur(), this.applyStyle();
  }
  focus() {
    var e;
    super.focus(), (e = this.item) === null || e === void 0 || e.focus(), this.applyStyle();
  }
  updatePositionInSet(e, t) {
    this.item && (this.item.setAttribute("aria-posinset", `${e}`), this.item.setAttribute("aria-setsize", `${t}`));
  }
  updateLabel() {
    var e;
    if (this.label && this.options.label) {
      Un(this.label);
      let t = yA(this.action.label);
      if (t) {
        const n = function(o) {
          const r = JD, a = r.exec(o);
          if (!a) return o;
          const l = !a[1];
          return o.replace(r, l ? "$2$3" : "").trim();
        }(t);
        this.options.enableMnemonics || (t = n), this.label.setAttribute("aria-label", n.replace(/&&/g, "&"));
        const s = JD.exec(t);
        if (s) {
          t = Ww(t), ex.lastIndex = 0;
          let o = ex.exec(t);
          for (; o && o[1]; ) o = ex.exec(t);
          const r = (a) => a.replace(/&amp;&amp;/g, "&amp;");
          o ? this.label.append(p1(r(t.substr(0, o.index)), " "), Q("u", { "aria-hidden": "true" }, o[3]), Q7(r(t.substr(o.index + o[0].length)), " ")) : this.label.innerText = r(t).trim(), (e = this.item) === null || e === void 0 || e.setAttribute("aria-keyshortcuts", (s[1] ? s[1] : s[3]).toLocaleLowerCase());
        } else this.label.innerText = t.replace(/&&/g, "&").trim();
      }
    }
  }
  updateTooltip() {
  }
  updateClass() {
    this.cssClass && this.item && this.item.classList.remove(...this.cssClass.split(" ")), this.options.icon && this.label ? (this.cssClass = this.action.class || "", this.label.classList.add("icon"), this.cssClass && this.label.classList.add(...this.cssClass.split(" ")), this.updateEnabled()) : this.label && this.label.classList.remove("icon");
  }
  updateEnabled() {
    this.action.enabled ? (this.element && (this.element.classList.remove("disabled"), this.element.removeAttribute("aria-disabled")), this.item && (this.item.classList.remove("disabled"), this.item.removeAttribute("aria-disabled"), this.item.tabIndex = 0)) : (this.element && (this.element.classList.add("disabled"), this.element.setAttribute("aria-disabled", "true")), this.item && (this.item.classList.add("disabled"), this.item.setAttribute("aria-disabled", "true")));
  }
  updateChecked() {
    if (!this.item) return;
    const e = this.action.checked;
    this.item.classList.toggle("checked", !!e), e !== void 0 ? (this.item.setAttribute("role", "menuitemcheckbox"), this.item.setAttribute("aria-checked", e ? "true" : "false")) : (this.item.setAttribute("role", "menuitem"), this.item.setAttribute("aria-checked", ""));
  }
  getMnemonic() {
    return this.mnemonic;
  }
  applyStyle() {
    const e = this.element && this.element.classList.contains("focused"), t = e && this.menuStyle.selectionForegroundColor ? this.menuStyle.selectionForegroundColor : this.menuStyle.foregroundColor, n = e && this.menuStyle.selectionBackgroundColor ? this.menuStyle.selectionBackgroundColor : void 0, s = e && this.menuStyle.selectionBorderColor ? `1px solid ${this.menuStyle.selectionBorderColor}` : "", o = e && this.menuStyle.selectionBorderColor ? "-1px" : "";
    this.item && (this.item.style.color = t ?? "", this.item.style.backgroundColor = n ?? "", this.item.style.outline = s, this.item.style.outlineOffset = o), this.check && (this.check.style.color = t ?? "");
  }
}
class K3 extends tV {
  constructor(e, t, n, s, o) {
    super(e, e, s, o), this.submenuActions = t, this.parentData = n, this.submenuOptions = s, this.mysubmenu = null, this.submenuDisposables = this._register(new G()), this.mouseOver = !1, this.expandDirection = s && s.expandDirection !== void 0 ? s.expandDirection : { horizontal: Vy.Right, vertical: QI.Below }, this.showScheduler = new It(() => {
      this.mouseOver && (this.cleanupExistingSubmenu(!1), this.createSubmenu(!1));
    }, 250), this.hideScheduler = new It(() => {
      this.element && !gn(Mn(), this.element) && this.parentData.submenu === this.mysubmenu && (this.parentData.parent.focus(!1), this.cleanupExistingSubmenu(!0));
    }, 750);
  }
  render(e) {
    super.render(e), this.element && (this.item && (this.item.classList.add("monaco-submenu-item"), this.item.tabIndex = 0, this.item.setAttribute("aria-haspopup", "true"), this.updateAriaExpanded("false"), this.submenuIndicator = Z(this.item, Q("span.submenu-indicator" + Ee.asCSSSelector(ne.menuSubmenu))), this.submenuIndicator.setAttribute("aria-hidden", "true")), this._register(K(this.element, ie.KEY_UP, (t) => {
      const n = new jt(t);
      (n.equals(17) || n.equals(3)) && (Ze(t, !0), this.createSubmenu(!0));
    })), this._register(K(this.element, ie.KEY_DOWN, (t) => {
      const n = new jt(t);
      Mn() === this.item && (n.equals(17) || n.equals(3)) && Ze(t, !0);
    })), this._register(K(this.element, ie.MOUSE_OVER, (t) => {
      this.mouseOver || (this.mouseOver = !0, this.showScheduler.schedule());
    })), this._register(K(this.element, ie.MOUSE_LEAVE, (t) => {
      this.mouseOver = !1;
    })), this._register(K(this.element, ie.FOCUS_OUT, (t) => {
      this.element && !gn(Mn(), this.element) && this.hideScheduler.schedule();
    })), this._register(this.parentData.parent.onScroll(() => {
      this.parentData.submenu === this.mysubmenu && (this.parentData.parent.focus(!1), this.cleanupExistingSubmenu(!0));
    })));
  }
  updateEnabled() {
  }
  onClick(e) {
    Ze(e, !0), this.cleanupExistingSubmenu(!1), this.createSubmenu(!0);
  }
  cleanupExistingSubmenu(e) {
    if (this.parentData.submenu && (e || this.parentData.submenu !== this.mysubmenu)) {
      try {
        this.parentData.submenu.dispose();
      } catch {
      }
      this.parentData.submenu = void 0, this.updateAriaExpanded("false"), this.submenuContainer && (this.submenuDisposables.clear(), this.submenuContainer = void 0);
    }
  }
  calculateSubmenuMenuLayout(e, t, n, s) {
    const o = { top: 0, left: 0 };
    return o.left = Vp(e.width, t.width, { position: s.horizontal === Vy.Right ? 0 : 1, offset: n.left, size: n.width }), o.left >= n.left && o.left < n.left + n.width && (n.left + 10 + t.width <= e.width && (o.left = n.left + 10), n.top += 10, n.height = 0), o.top = Vp(e.height, t.height, { position: 0, offset: n.top, size: 0 }), o.top + t.height === n.top && o.top + n.height + t.height <= e.height && (o.top += n.height), o;
  }
  createSubmenu(e = !0) {
    if (this.element) if (this.parentData.submenu) this.parentData.submenu.focus(!1);
    else {
      this.updateAriaExpanded("true"), this.submenuContainer = Z(this.element, Q("div.monaco-submenu")), this.submenuContainer.classList.add("menubar-menu-items-holder", "context-view");
      const t = ke(this.parentData.parent.domNode).getComputedStyle(this.parentData.parent.domNode), n = parseFloat(t.paddingTop || "0") || 0;
      this.submenuContainer.style.zIndex = "1", this.submenuContainer.style.position = "fixed", this.submenuContainer.style.top = "0", this.submenuContainer.style.left = "0", this.parentData.submenu = new Cm(this.submenuContainer, this.submenuActions.length ? this.submenuActions : [new KS()], this.submenuOptions, this.menuStyle);
      const s = this.element.getBoundingClientRect(), o = { top: s.top - n, left: s.left, height: s.height + 2 * n, width: s.width }, r = this.submenuContainer.getBoundingClientRect(), a = ke(this.element), { top: l, left: d } = this.calculateSubmenuMenuLayout(new bt(a.innerWidth, a.innerHeight), bt.lift(r), o, this.expandDirection);
      this.submenuContainer.style.left = d - r.left + "px", this.submenuContainer.style.top = l - r.top + "px", this.submenuDisposables.add(K(this.submenuContainer, ie.KEY_UP, (h) => {
        new jt(h).equals(15) && (Ze(h, !0), this.parentData.parent.focus(), this.cleanupExistingSubmenu(!0));
      })), this.submenuDisposables.add(K(this.submenuContainer, ie.KEY_DOWN, (h) => {
        new jt(h).equals(15) && Ze(h, !0);
      })), this.submenuDisposables.add(this.parentData.submenu.onDidCancel(() => {
        this.parentData.parent.focus(), this.cleanupExistingSubmenu(!0);
      })), this.parentData.submenu.focus(e), this.mysubmenu = this.parentData.submenu;
    }
  }
  updateAriaExpanded(e) {
    var t;
    this.item && ((t = this.item) === null || t === void 0 || t.setAttribute("aria-expanded", e));
  }
  applyStyle() {
    super.applyStyle();
    const e = this.element && this.element.classList.contains("focused") && this.menuStyle.selectionForegroundColor ? this.menuStyle.selectionForegroundColor : this.menuStyle.foregroundColor;
    this.submenuIndicator && (this.submenuIndicator.style.color = e ?? "");
  }
  dispose() {
    super.dispose(), this.hideScheduler.dispose(), this.mysubmenu && (this.mysubmenu.dispose(), this.mysubmenu = null), this.submenuContainer && (this.submenuContainer = void 0);
  }
}
class j3 extends ef {
  constructor(e, t, n, s) {
    super(e, t, n), this.menuStyles = s;
  }
  render(e) {
    super.render(e), this.label && (this.label.style.borderBottomColor = this.menuStyles.separatorColor ? `${this.menuStyles.separatorColor}` : "");
  }
}
function q3(i) {
  const e = G7()[i.id];
  return `.codicon-${i.id}:before { content: '\\${e.toString(16)}'; }`;
}
class cte {
  constructor(e, t, n, s) {
    this.contextViewService = e, this.telemetryService = t, this.notificationService = n, this.keybindingService = s, this.focusToReturn = null, this.lastContainer = null, this.block = null, this.blockDisposable = null, this.options = { blockMouse: !0 };
  }
  configure(e) {
    this.options = e;
  }
  showContextMenu(e) {
    const t = e.getActions();
    if (!t.length) return;
    let n;
    this.focusToReturn = Mn();
    const s = e.domForShadowRoot instanceof HTMLElement ? e.domForShadowRoot : void 0;
    this.contextViewService.showContextView({ getAnchor: () => e.getAnchor(), canRelayout: !1, anchorAlignment: e.anchorAlignment, anchorAxisAlignment: e.anchorAxisAlignment, render: (o) => {
      var r;
      this.lastContainer = o;
      const a = e.getMenuClassName ? e.getMenuClassName() : "";
      a && (o.className += " " + a), this.options.blockMouse && (this.block = o.appendChild(Q(".context-view-block")), this.block.style.position = "fixed", this.block.style.cursor = "initial", this.block.style.left = "0", this.block.style.top = "0", this.block.style.width = "100%", this.block.style.height = "100%", this.block.style.zIndex = "-1", (r = this.blockDisposable) === null || r === void 0 || r.dispose(), this.blockDisposable = K(this.block, ie.MOUSE_DOWN, (c) => c.stopPropagation()));
      const l = new G(), d = e.actionRunner || new hg();
      d.onWillRun((c) => this.onActionRun(c, !e.skipTelemetry), this, l), d.onDidRun(this.onDidActionRun, this, l), n = new Cm(o, t, { actionViewItemProvider: e.getActionViewItem, context: e.getActionsContext ? e.getActionsContext() : null, actionRunner: d, getKeyBinding: e.getKeyBinding ? e.getKeyBinding : (c) => this.keybindingService.lookupKeybinding(c.id) }, hte), n.onDidCancel(() => this.contextViewService.hideContextView(!0), null, l), n.onDidBlur(() => this.contextViewService.hideContextView(!0), null, l);
      const h = ke(o);
      return l.add(K(h, ie.BLUR, () => this.contextViewService.hideContextView(!0))), l.add(K(h, ie.MOUSE_DOWN, (c) => {
        if (c.defaultPrevented) return;
        const u = new _r(h, c);
        let g = u.target;
        if (!u.rightButton) {
          for (; g; ) {
            if (g === o) return;
            g = g.parentElement;
          }
          this.contextViewService.hideContextView(!0);
        }
      })), yr(l, n);
    }, focus: () => {
      n == null || n.focus(!!e.autoSelectFirstItem);
    }, onHide: (o) => {
      var r, a, l;
      (r = e.onHide) === null || r === void 0 || r.call(e, !!o), this.block && (this.block.remove(), this.block = null), (a = this.blockDisposable) === null || a === void 0 || a.dispose(), this.blockDisposable = null, this.lastContainer && (Mn() === this.lastContainer || gn(Mn(), this.lastContainer)) && ((l = this.focusToReturn) === null || l === void 0 || l.focus()), this.lastContainer = null;
    } }, s, !!s);
  }
  onActionRun(e, t) {
    t && this.telemetryService.publicLog2("workbenchActionExecuted", { id: e.action.id, from: "contextMenu" }), this.contextViewService.hideContextView(!1);
  }
  onDidActionRun(e) {
    e.error && !Sa(e.error) && this.notificationService.error(e.error);
  }
}
var ute = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Jg = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let JI = class extends V {
  get contextMenuHandler() {
    return this._contextMenuHandler || (this._contextMenuHandler = new cte(this.contextViewService, this.telemetryService, this.notificationService, this.keybindingService)), this._contextMenuHandler;
  }
  constructor(i, e, t, n, s, o) {
    super(), this.telemetryService = i, this.notificationService = e, this.contextViewService = t, this.keybindingService = n, this.menuService = s, this.contextKeyService = o, this._contextMenuHandler = void 0, this._onDidShowContextMenu = this._store.add(new F()), this.onDidShowContextMenu = this._onDidShowContextMenu.event, this._onDidHideContextMenu = this._store.add(new F());
  }
  configure(i) {
    this.contextMenuHandler.configure(i);
  }
  showContextMenu(i) {
    i = e2.transform(i, this.menuService, this.contextKeyService), this.contextMenuHandler.showContextMenu({ ...i, onHide: (e) => {
      var t;
      (t = i.onHide) === null || t === void 0 || t.call(i, e), this._onDidHideContextMenu.fire();
    } }), ad.getInstance().resetKeyStatus(), this._onDidShowContextMenu.fire();
  }
};
var e2, Hy;
JI = ute([Jg(0, es), Jg(1, Ri), Jg(2, zd), Jg(3, Dt), Jg(4, Mo), Jg(5, Te)], JI), function(i) {
  i.transform = function(e, t, n) {
    if (!((s = e) && s.menuId instanceof x)) return e;
    var s;
    const { menuId: o, menuActionOptions: r, contextKeyService: a } = e;
    return { ...e, getActions: () => {
      const l = [];
      if (o) {
        const d = t.createMenu(o, a ?? n);
        (function(h, c, u, g) {
          const p = h.getActions(c), f = ad.getInstance();
          JW(p, u, f.keyStatus.altKey || (Tn || Cs) && f.keyStatus.shiftKey, (_) => _ === "navigation");
        })(d, r, l), d.dispose();
      }
      return e.getActions ? Ui.join(e.getActions(), l) : l;
    } };
  };
}(e2 || (e2 = {})), function(i) {
  i[i.API = 0] = "API", i[i.USER = 1] = "USER";
}(Hy || (Hy = {}));
var EA = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, zy = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let t2 = class {
  constructor(i) {
    this._commandService = i;
  }
  async open(i, e) {
    if (!gR(i, Ue.command)) return !1;
    if (!(e != null && e.allowCommands) || (typeof i == "string" && (i = Ie.parse(i)), Array.isArray(e.allowCommands) && !e.allowCommands.includes(i.path))) return !0;
    let t = [];
    try {
      t = AI(decodeURIComponent(i.query));
    } catch {
      try {
        t = AI(i.query);
      } catch {
      }
    }
    return Array.isArray(t) || (t = [t]), await this._commandService.executeCommand(i.path, ...t), !0;
  }
};
t2 = EA([zy(0, ai)], t2);
let i2 = class {
  constructor(i) {
    this._editorService = i;
  }
  async open(i, e) {
    typeof i == "string" && (i = Ie.parse(i));
    const { selection: t, uri: n } = function(s) {
      let o;
      const r = /^L?(\d+)(?:,(\d+))?(-L?(\d+)(?:,(\d+))?)?/.exec(s.fragment);
      return r && (o = { startLineNumber: parseInt(r[1]), startColumn: r[2] ? parseInt(r[2]) : 1, endLineNumber: r[4] ? parseInt(r[4]) : void 0, endColumn: r[4] ? r[5] ? parseInt(r[5]) : 1 : void 0 }, s = s.with({ fragment: "" })), { selection: o, uri: s };
    }(i);
    return (i = n).scheme === Ue.file && (i = DX(i)), await this._editorService.openCodeEditor({ resource: i, options: { selection: t, source: e != null && e.fromUserGesture ? Hy.USER : Hy.API, ...e == null ? void 0 : e.editorOptions } }, this._editorService.getFocusedCodeEditor(), e == null ? void 0 : e.openToSide), !0;
  }
};
i2 = EA([zy(0, mt)], i2);
let n2 = class {
  constructor(i, e) {
    this._openers = new fs(), this._validators = new fs(), this._resolvers = new fs(), this._resolvedUriTargets = new Di((t) => t.with({ path: null, fragment: null, query: null }).toString()), this._externalOpeners = new fs(), this._defaultExternalOpener = { openExternal: async (t) => (wO(t, Ue.http, Ue.https) ? D8(t) : Et.location.href = t, !0) }, this._openers.push({ open: async (t, n) => !(!(n != null && n.openExternal) && !wO(t, Ue.mailto, Ue.http, Ue.https, Ue.vsls)) && (await this._doOpenExternal(t, n), !0) }), this._openers.push(new t2(e)), this._openers.push(new i2(i));
  }
  registerOpener(i) {
    return { dispose: this._openers.unshift(i) };
  }
  async open(i, e) {
    var t;
    const n = typeof i == "string" ? Ie.parse(i) : i, s = (t = this._resolvedUriTargets.get(n)) !== null && t !== void 0 ? t : i;
    for (const o of this._validators) if (!await o.shouldOpen(s, e)) return !1;
    for (const o of this._openers)
      if (await o.open(i, e)) return !0;
    return !1;
  }
  async resolveExternalUri(i, e) {
    for (const t of this._resolvers) try {
      const n = await t.resolveExternalUri(i, e);
      if (n) return this._resolvedUriTargets.has(n.resolved) || this._resolvedUriTargets.set(n.resolved, i), n;
    } catch {
    }
    throw new Error("Could not resolve external URI: " + i.toString());
  }
  async _doOpenExternal(i, e) {
    const t = typeof i == "string" ? Ie.parse(i) : i;
    let n, s;
    try {
      n = (await this.resolveExternalUri(t, e)).resolved;
    } catch {
      n = t;
    }
    if (s = typeof i == "string" && t.toString() === n.toString() ? i : encodeURI(n.toString(!0)), e == null ? void 0 : e.allowContributedOpeners) {
      const o = typeof (e == null ? void 0 : e.allowContributedOpeners) == "string" ? e == null ? void 0 : e.allowContributedOpeners : void 0;
      for (const r of this._externalOpeners)
        if (await r.openExternal(s, { sourceUri: t, preferredOpenerId: o }, et.None)) return !0;
    }
    return this._defaultExternalOpener.openExternal(s, { sourceUri: t }, et.None);
  }
  dispose() {
    this._validators.clear();
  }
};
n2 = EA([zy(0, mt), zy(1, ai)], n2);
const Qo = tt("editorWorkerService");
var pi, Uy;
(function(i) {
  i[i.Hint = 1] = "Hint", i[i.Info = 2] = "Info", i[i.Warning = 4] = "Warning", i[i.Error = 8] = "Error";
})(pi || (pi = {})), function(i) {
  i.compare = function(t, n) {
    return n - t;
  };
  const e = /* @__PURE__ */ Object.create(null);
  e[i.Error] = m(0, "Error"), e[i.Warning] = m(0, "Warning"), e[i.Info] = m(0, "Info"), i.toString = function(t) {
    return e[t] || "";
  }, i.fromSeverity = function(t) {
    switch (t) {
      case ki.Error:
        return i.Error;
      case ki.Warning:
        return i.Warning;
      case ki.Info:
        return i.Info;
      case ki.Ignore:
        return i.Hint;
    }
  }, i.toSeverity = function(t) {
    switch (t) {
      case i.Error:
        return ki.Error;
      case i.Warning:
        return ki.Warning;
      case i.Info:
        return ki.Info;
      case i.Hint:
        return ki.Ignore;
    }
  };
}(pi || (pi = {})), function(i) {
  const e = "";
  function t(n, s) {
    const o = [e];
    return n.source ? o.push(n.source.replace("¦", "\\¦")) : o.push(e), n.code ? typeof n.code == "string" ? o.push(n.code.replace("¦", "\\¦")) : o.push(n.code.value.replace("¦", "\\¦")) : o.push(e), n.severity !== void 0 && n.severity !== null ? o.push(pi.toString(n.severity)) : o.push(e), n.message && s ? o.push(n.message.replace("¦", "\\¦")) : o.push(e), n.startLineNumber !== void 0 && n.startLineNumber !== null ? o.push(n.startLineNumber.toString()) : o.push(e), n.startColumn !== void 0 && n.startColumn !== null ? o.push(n.startColumn.toString()) : o.push(e), n.endLineNumber !== void 0 && n.endLineNumber !== null ? o.push(n.endLineNumber.toString()) : o.push(e), n.endColumn !== void 0 && n.endColumn !== null ? o.push(n.endColumn.toString()) : o.push(e), o.push(e), o.join("¦");
  }
  i.makeKey = function(n) {
    return t(n, !0);
  }, i.makeKeyOptionalMessage = t;
}(Uy || (Uy = {}));
const kl = tt("markerService");
var gte = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, $3 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let s2 = class extends V {
  constructor(i, e) {
    super(), this._markerService = e, this._onDidChangeMarker = this._register(new F()), this._markerDecorations = new Di(), i.getModels().forEach((t) => this._onModelAdded(t)), this._register(i.onModelAdded(this._onModelAdded, this)), this._register(i.onModelRemoved(this._onModelRemoved, this)), this._register(this._markerService.onMarkerChanged(this._handleMarkerChange, this));
  }
  dispose() {
    super.dispose(), this._markerDecorations.forEach((i) => i.dispose()), this._markerDecorations.clear();
  }
  getMarker(i, e) {
    const t = this._markerDecorations.get(i);
    return t && t.getMarker(e) || null;
  }
  _handleMarkerChange(i) {
    i.forEach((e) => {
      const t = this._markerDecorations.get(e);
      t && this._updateDecorations(t);
    });
  }
  _onModelAdded(i) {
    const e = new pte(i);
    this._markerDecorations.set(i.uri, e), this._updateDecorations(e);
  }
  _onModelRemoved(i) {
    var e;
    const t = this._markerDecorations.get(i.uri);
    t && (t.dispose(), this._markerDecorations.delete(i.uri)), i.uri.scheme !== Ue.inMemory && i.uri.scheme !== Ue.internal && i.uri.scheme !== Ue.vscode || (e = this._markerService) === null || e === void 0 || e.read({ resource: i.uri }).map((n) => n.owner).forEach((n) => this._markerService.remove(n, [i.uri]));
  }
  _updateDecorations(i) {
    const e = this._markerService.read({ resource: i.model.uri, take: 500 });
    i.update(e) && this._onDidChangeMarker.fire(i.model);
  }
};
s2 = gte([$3(0, ni), $3(1, kl)], s2);
class pte extends V {
  constructor(e) {
    super(), this.model = e, this._map = new Cq(), this._register(ye(() => {
      this.model.deltaDecorations([...this._map.values()], []), this._map.clear();
    }));
  }
  update(e) {
    const { added: t, removed: n } = function(a, l) {
      const d = [], h = [];
      for (const c of a) l.has(c) || d.push(c);
      for (const c of l) a.has(c) || h.push(c);
      return { removed: d, added: h };
    }(new Set(this._map.keys()), new Set(e));
    if (t.length === 0 && n.length === 0) return !1;
    const s = n.map((a) => this._map.get(a)), o = t.map((a) => ({ range: this._createDecorationRange(this.model, a), options: this._createDecorationOption(a) })), r = this.model.deltaDecorations(s, o);
    for (const a of n) this._map.delete(a);
    for (let a = 0; a < r.length; a++) this._map.set(t[a], r[a]);
    return !0;
  }
  getMarker(e) {
    return this._map.getKey(e.id);
  }
  _createDecorationRange(e, t) {
    let n = D.lift(t);
    if (t.severity !== pi.Hint || this._hasMarkerTag(t, 1) || this._hasMarkerTag(t, 2) || (n = n.setEndPosition(n.startLineNumber, n.startColumn + 2)), n = e.validateRange(n), n.isEmpty()) {
      const s = e.getLineLastNonWhitespaceColumn(n.startLineNumber) || e.getLineMaxColumn(n.startLineNumber);
      if (s === 1 || n.endColumn >= s) return n;
      const o = e.getWordAtPosition(n.getStartPosition());
      o && (n = new D(n.startLineNumber, o.startColumn, n.endLineNumber, o.endColumn));
    } else if (t.endColumn === Number.MAX_VALUE && t.startColumn === 1 && n.startLineNumber === n.endLineNumber) {
      const s = e.getLineFirstNonWhitespaceColumn(t.startLineNumber);
      s < n.endColumn && (n = new D(n.startLineNumber, s, n.endLineNumber, n.endColumn), t.startColumn = s);
    }
    return n;
  }
  _createDecorationOption(e) {
    let t, n, s, o, r;
    switch (e.severity) {
      case pi.Hint:
        t = this._hasMarkerTag(e, 2) ? void 0 : this._hasMarkerTag(e, 1) ? "squiggly-unnecessary" : "squiggly-hint", s = 0;
        break;
      case pi.Info:
        t = "squiggly-info", n = ui(PZ), s = 10, r = { color: ui(P$), position: 1 };
        break;
      case pi.Warning:
        t = "squiggly-warning", n = ui(AZ), s = 20, r = { color: ui(O$), position: 1 };
        break;
      case pi.Error:
      default:
        t = "squiggly-error", n = ui(RZ), s = 30, r = { color: ui(F$), position: 1 };
    }
    return e.tags && (e.tags.indexOf(1) !== -1 && (o = "squiggly-inline-unnecessary"), e.tags.indexOf(2) !== -1 && (o = "squiggly-inline-deprecated")), { description: "marker-decoration", stickiness: 1, className: t, showIfCollapsed: !0, overviewRuler: { color: n, position: Do.Right }, minimap: r, zIndex: s, inlineClassName: o };
  }
  _hasMarkerTag(e, t) {
    return !!e.tags && e.tags.indexOf(t) >= 0;
  }
}
var mp, mte = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, jf = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
function Yc(i) {
  return i.toString();
}
class fte {
  constructor(e, t, n) {
    this.model = e, this._modelEventListeners = new G(), this.model = e, this._modelEventListeners.add(e.onWillDispose(() => t(e))), this._modelEventListeners.add(e.onDidChangeLanguage((s) => n(e, s)));
  }
  dispose() {
    this._modelEventListeners.dispose();
  }
}
const _te = Cs || Je ? 1 : 2;
class vte {
  constructor(e, t, n, s, o, r, a, l) {
    this.uri = e, this.initialUndoRedoSnapshot = t, this.time = n, this.sharesUndoRedoStack = s, this.heapSize = o, this.sha1 = r, this.versionId = a, this.alternativeVersionId = l;
  }
}
let YC = mp = class extends V {
  constructor(i, e, t, n, s) {
    super(), this._configurationService = i, this._resourcePropertiesService = e, this._undoRedoService = t, this._languageService = n, this._languageConfigurationService = s, this._onModelAdded = this._register(new F()), this.onModelAdded = this._onModelAdded.event, this._onModelRemoved = this._register(new F()), this.onModelRemoved = this._onModelRemoved.event, this._onModelModeChanged = this._register(new F()), this.onModelLanguageChanged = this._onModelModeChanged.event, this._modelCreationOptionsByLanguageAndResource = /* @__PURE__ */ Object.create(null), this._models = {}, this._disposedModels = /* @__PURE__ */ new Map(), this._disposedModelsHeapSize = 0, this._register(this._configurationService.onDidChangeConfiguration((o) => this._updateModelOptions(o))), this._updateModelOptions(void 0);
  }
  static _readModelOptions(i, e) {
    var t;
    let n = Wn.tabSize;
    if (i.editor && i.editor.tabSize !== void 0) {
      const u = parseInt(i.editor.tabSize, 10);
      isNaN(u) || (n = u), n < 1 && (n = 1);
    }
    let s = "tabSize";
    if (i.editor && i.editor.indentSize !== void 0 && i.editor.indentSize !== "tabSize") {
      const u = parseInt(i.editor.indentSize, 10);
      isNaN(u) || (s = Math.max(u, 1));
    }
    let o = Wn.insertSpaces;
    i.editor && i.editor.insertSpaces !== void 0 && (o = i.editor.insertSpaces !== "false" && !!i.editor.insertSpaces);
    let r = _te;
    const a = i.eol;
    a === `\r
` ? r = 2 : a === `
` && (r = 1);
    let l = Wn.trimAutoWhitespace;
    i.editor && i.editor.trimAutoWhitespace !== void 0 && (l = i.editor.trimAutoWhitespace !== "false" && !!i.editor.trimAutoWhitespace);
    let d = Wn.detectIndentation;
    i.editor && i.editor.detectIndentation !== void 0 && (d = i.editor.detectIndentation !== "false" && !!i.editor.detectIndentation);
    let h = Wn.largeFileOptimizations;
    i.editor && i.editor.largeFileOptimizations !== void 0 && (h = i.editor.largeFileOptimizations !== "false" && !!i.editor.largeFileOptimizations);
    let c = Wn.bracketPairColorizationOptions;
    return !((t = i.editor) === null || t === void 0) && t.bracketPairColorization && typeof i.editor.bracketPairColorization == "object" && (c = { enabled: !!i.editor.bracketPairColorization.enabled, independentColorPoolPerBracketType: !!i.editor.bracketPairColorization.independentColorPoolPerBracketType }), { isForSimpleWidget: e, tabSize: n, indentSize: s, insertSpaces: o, detectIndentation: d, defaultEOL: r, trimAutoWhitespace: l, largeFileOptimizations: h, bracketPairColorizationOptions: c };
  }
  _getEOL(i, e) {
    if (i) return this._resourcePropertiesService.getEOL(i, e);
    const t = this._configurationService.getValue("files.eol", { overrideIdentifier: e });
    return t && typeof t == "string" && t !== "auto" ? t : Gs === 3 || Gs === 2 ? `
` : `\r
`;
  }
  _shouldRestoreUndoStack() {
    const i = this._configurationService.getValue("files.restoreUndoStack");
    return typeof i != "boolean" || i;
  }
  getCreationOptions(i, e, t) {
    const n = typeof i == "string" ? i : i.languageId;
    let s = this._modelCreationOptionsByLanguageAndResource[n + e];
    if (!s) {
      const o = this._configurationService.getValue("editor", { overrideIdentifier: n, resource: e }), r = this._getEOL(e, n);
      s = mp._readModelOptions({ editor: o, eol: r }, t), this._modelCreationOptionsByLanguageAndResource[n + e] = s;
    }
    return s;
  }
  _updateModelOptions(i) {
    const e = this._modelCreationOptionsByLanguageAndResource;
    this._modelCreationOptionsByLanguageAndResource = /* @__PURE__ */ Object.create(null);
    const t = Object.keys(this._models);
    for (let n = 0, s = t.length; n < s; n++) {
      const o = t[n], r = this._models[o], a = r.model.getLanguageId(), l = r.model.uri;
      if (i && !i.affectsConfiguration("editor", { overrideIdentifier: a, resource: l }) && !i.affectsConfiguration("files.eol", { overrideIdentifier: a, resource: l })) continue;
      const d = e[a + l], h = this.getCreationOptions(a, l, r.model.isForSimpleWidget);
      mp._setModelOptionsForModel(r.model, h, d);
    }
  }
  static _setModelOptionsForModel(i, e, t) {
    t && t.defaultEOL !== e.defaultEOL && i.getLineCount() === 1 && i.setEOL(e.defaultEOL === 1 ? 0 : 1), t && t.detectIndentation === e.detectIndentation && t.insertSpaces === e.insertSpaces && t.tabSize === e.tabSize && t.indentSize === e.indentSize && t.trimAutoWhitespace === e.trimAutoWhitespace && So(t.bracketPairColorizationOptions, e.bracketPairColorizationOptions) || (e.detectIndentation ? (i.detectIndentation(e.insertSpaces, e.tabSize), i.updateOptions({ trimAutoWhitespace: e.trimAutoWhitespace, bracketColorizationOptions: e.bracketPairColorizationOptions })) : i.updateOptions({ insertSpaces: e.insertSpaces, tabSize: e.tabSize, indentSize: e.indentSize, trimAutoWhitespace: e.trimAutoWhitespace, bracketColorizationOptions: e.bracketPairColorizationOptions }));
  }
  _insertDisposedModel(i) {
    this._disposedModels.set(Yc(i.uri), i), this._disposedModelsHeapSize += i.heapSize;
  }
  _removeDisposedModel(i) {
    const e = this._disposedModels.get(Yc(i));
    return e && (this._disposedModelsHeapSize -= e.heapSize), this._disposedModels.delete(Yc(i)), e;
  }
  _ensureDisposedModelsHeapSize(i) {
    if (this._disposedModelsHeapSize > i) {
      const e = [];
      for (this._disposedModels.forEach((t) => {
        t.sharesUndoRedoStack || e.push(t);
      }), e.sort((t, n) => t.time - n.time); e.length > 0 && this._disposedModelsHeapSize > i; ) {
        const t = e.shift();
        this._removeDisposedModel(t.uri), t.initialUndoRedoSnapshot !== null && this._undoRedoService.restoreSnapshot(t.initialUndoRedoSnapshot);
      }
    }
  }
  _createModelData(i, e, t, n) {
    const s = this.getCreationOptions(e, t, n), o = new Oa(i, e, s, t, this._undoRedoService, this._languageService, this._languageConfigurationService);
    if (t && this._disposedModels.has(Yc(t))) {
      const l = this._removeDisposedModel(t), d = this._undoRedoService.getElements(t), h = this._getSHA1Computer(), c = !!h.canComputeSHA1(o) && h.computeSHA1(o) === l.sha1;
      if (c || l.sharesUndoRedoStack) {
        for (const u of d.past) jl(u) && u.matchesResource(t) && u.setModel(o);
        for (const u of d.future) jl(u) && u.matchesResource(t) && u.setModel(o);
        this._undoRedoService.setElementsValidFlag(t, !0, (u) => jl(u) && u.matchesResource(t)), c && (o._overwriteVersionId(l.versionId), o._overwriteAlternativeVersionId(l.alternativeVersionId), o._overwriteInitialUndoRedoSnapshot(l.initialUndoRedoSnapshot));
      } else l.initialUndoRedoSnapshot !== null && this._undoRedoService.restoreSnapshot(l.initialUndoRedoSnapshot);
    }
    const r = Yc(o.uri);
    if (this._models[r]) throw new Error("ModelService: Cannot add model because it already exists!");
    const a = new fte(o, (l) => this._onWillDispose(l), (l, d) => this._onDidChangeLanguage(l, d));
    return this._models[r] = a, a;
  }
  createModel(i, e, t, n = !1) {
    let s;
    return s = e ? this._createModelData(i, e, t, n) : this._createModelData(i, ko, t, n), this._onModelAdded.fire(s.model), s.model;
  }
  getModels() {
    const i = [], e = Object.keys(this._models);
    for (let t = 0, n = e.length; t < n; t++) {
      const s = e[t];
      i.push(this._models[s].model);
    }
    return i;
  }
  getModel(i) {
    const e = Yc(i), t = this._models[e];
    return t ? t.model : null;
  }
  _schemaShouldMaintainUndoRedoElements(i) {
    return i.scheme === Ue.file || i.scheme === Ue.vscodeRemote || i.scheme === Ue.vscodeUserData || i.scheme === Ue.vscodeNotebookCell || i.scheme === "fake-fs";
  }
  _onWillDispose(i) {
    const e = Yc(i.uri), t = this._models[e], n = this._undoRedoService.getUriComparisonKey(i.uri) !== i.uri.toString();
    let s = !1, o = 0;
    if (n || this._shouldRestoreUndoStack() && this._schemaShouldMaintainUndoRedoElements(i.uri)) {
      const l = this._undoRedoService.getElements(i.uri);
      if (l.past.length > 0 || l.future.length > 0) {
        for (const d of l.past) jl(d) && d.matchesResource(i.uri) && (s = !0, o += d.heapSize(i.uri), d.setModel(i.uri));
        for (const d of l.future) jl(d) && d.matchesResource(i.uri) && (s = !0, o += d.heapSize(i.uri), d.setModel(i.uri));
      }
    }
    const r = mp.MAX_MEMORY_FOR_CLOSED_FILES_UNDO_STACK, a = this._getSHA1Computer();
    if (s) if (n || !(o > r) && a.canComputeSHA1(i)) this._ensureDisposedModelsHeapSize(r - o), this._undoRedoService.setElementsValidFlag(i.uri, !1, (l) => jl(l) && l.matchesResource(i.uri)), this._insertDisposedModel(new vte(i.uri, t.model.getInitialUndoRedoSnapshot(), Date.now(), n, o, a.computeSHA1(i), i.getVersionId(), i.getAlternativeVersionId()));
    else {
      const l = t.model.getInitialUndoRedoSnapshot();
      l !== null && this._undoRedoService.restoreSnapshot(l);
    }
    else if (!n) {
      const l = t.model.getInitialUndoRedoSnapshot();
      l !== null && this._undoRedoService.restoreSnapshot(l);
    }
    delete this._models[e], t.dispose(), delete this._modelCreationOptionsByLanguageAndResource[i.getLanguageId() + i.uri], this._onModelRemoved.fire(i);
  }
  _onDidChangeLanguage(i, e) {
    const t = e.oldLanguage, n = i.getLanguageId(), s = this.getCreationOptions(t, i.uri, i.isForSimpleWidget), o = this.getCreationOptions(n, i.uri, i.isForSimpleWidget);
    mp._setModelOptionsForModel(i, o, s), this._onModelModeChanged.fire({ model: i, oldLanguageId: t });
  }
  _getSHA1Computer() {
    return new TL();
  }
};
YC.MAX_MEMORY_FOR_CLOSED_FILES_UNDO_STACK = 20971520, YC = mp = mte([jf(0, Ye), jf(1, tB), jf(2, mL), jf(3, Xt), jf(4, zt)], YC);
class TL {
  canComputeSHA1(e) {
    return e.getValueLength() <= TL.MAX_MODEL_SIZE;
  }
  computeSHA1(e) {
    const t = new VS(), n = e.createSnapshot();
    let s;
    for (; s = n.read(); ) t.update(s);
    return t.digest();
  }
}
var o2;
TL.MAX_MODEL_SIZE = 10485760, function(i) {
  i[i.PRESERVE = 0] = "PRESERVE", i[i.LAST = 1] = "LAST";
}(o2 || (o2 = {}));
const Ag = "workbench.contributions.quickaccess";
li.add(Ag, new class {
  constructor() {
    this.providers = [], this.defaultProvider = void 0;
  }
  registerQuickAccessProvider(i) {
    return i.prefix.length === 0 ? this.defaultProvider = i : this.providers.push(i), this.providers.sort((e, t) => t.prefix.length - e.prefix.length), ye(() => {
      this.providers.splice(this.providers.indexOf(i), 1), this.defaultProvider === i && (this.defaultProvider = void 0);
    });
  }
  getQuickAccessProviders() {
    return ca([this.defaultProvider, ...this.providers]);
  }
  getQuickAccessProvider(i) {
    return i && this.providers.find((e) => i.startsWith(e.prefix)) || void 0 || this.defaultProvider;
  }
}());
const bte = { ctrlCmd: !1, alt: !1 };
var tf, Kr;
(function(i) {
  i[i.Blur = 1] = "Blur", i[i.Gesture = 2] = "Gesture", i[i.Other = 3] = "Other";
})(tf || (tf = {})), function(i) {
  i[i.NONE = 0] = "NONE", i[i.FIRST = 1] = "FIRST", i[i.SECOND = 2] = "SECOND", i[i.LAST = 3] = "LAST";
}(Kr || (Kr = {}));
const La = tt("quickInputService");
var Cte = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, G3 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let r2 = class extends V {
  constructor(i, e) {
    super(), this.quickInputService = i, this.instantiationService = e, this.registry = li.as(Ag), this.mapProviderToDescriptor = /* @__PURE__ */ new Map(), this.lastAcceptedPickerValues = /* @__PURE__ */ new Map(), this.visibleQuickAccess = void 0;
  }
  show(i = "", e) {
    this.doShowOrPick(i, !1, e);
  }
  doShowOrPick(i, e, t) {
    var n, s, o;
    const [r, a] = this.getOrInstantiateProvider(i), l = this.visibleQuickAccess, d = l == null ? void 0 : l.descriptor;
    if (l && a && d === a) return i === a.prefix || t != null && t.preserveValue || (l.picker.value = i), void this.adjustValueSelection(l.picker, a, t);
    if (a && !(t != null && t.preserveValue)) {
      let _;
      if (l && d && d !== a) {
        const v = l.value.substr(d.prefix.length);
        v && (_ = `${a.prefix}${v}`);
      }
      if (!_) {
        const v = r == null ? void 0 : r.defaultFilterValue;
        v === o2.LAST ? _ = this.lastAcceptedPickerValues.get(a) : typeof v == "string" && (_ = `${a.prefix}${v}`);
      }
      typeof _ == "string" && (i = _);
    }
    const h = (n = l == null ? void 0 : l.picker) === null || n === void 0 ? void 0 : n.valueSelection, c = (s = l == null ? void 0 : l.picker) === null || s === void 0 ? void 0 : s.value, u = new G(), g = u.add(this.quickInputService.createQuickPick());
    let p;
    g.value = i, this.adjustValueSelection(g, a, t), g.placeholder = a == null ? void 0 : a.placeholder, g.quickNavigate = t == null ? void 0 : t.quickNavigateConfiguration, g.hideInput = !!g.quickNavigate && !l, (typeof (t == null ? void 0 : t.itemActivation) == "number" || t != null && t.quickNavigateConfiguration) && (g.itemActivation = (o = t == null ? void 0 : t.itemActivation) !== null && o !== void 0 ? o : Kr.SECOND), g.contextKey = a == null ? void 0 : a.contextKey, g.filterValue = (_) => _.substring(a ? a.prefix.length : 0), e && (p = new b1(), u.add(se.once(g.onWillAccept)((_) => {
      _.veto(), g.hide();
    }))), u.add(this.registerPickerListeners(g, r, a, i, t == null ? void 0 : t.providerOptions));
    const f = u.add(new Ci());
    return r && u.add(r.provide(g, f.token, t == null ? void 0 : t.providerOptions)), se.once(g.onDidHide)(() => {
      g.selectedItems.length === 0 && f.cancel(), u.dispose(), p == null || p.complete(g.selectedItems.slice(0));
    }), g.show(), h && c === i && (g.valueSelection = h), e ? p == null ? void 0 : p.p : void 0;
  }
  adjustValueSelection(i, e, t) {
    var n;
    let s;
    s = t != null && t.preserveValue ? [i.value.length, i.value.length] : [(n = e == null ? void 0 : e.prefix.length) !== null && n !== void 0 ? n : 0, i.value.length], i.valueSelection = s;
  }
  registerPickerListeners(i, e, t, n, s) {
    const o = new G(), r = this.visibleQuickAccess = { picker: i, descriptor: t, value: n };
    return o.add(ye(() => {
      r === this.visibleQuickAccess && (this.visibleQuickAccess = void 0);
    })), o.add(i.onDidChangeValue((a) => {
      const [l] = this.getOrInstantiateProvider(a);
      l !== e ? this.show(a, { preserveValue: !0, providerOptions: s }) : r.value = a;
    })), t && o.add(i.onDidAccept(() => {
      this.lastAcceptedPickerValues.set(t, i.value);
    })), o;
  }
  getOrInstantiateProvider(i) {
    const e = this.registry.getQuickAccessProvider(i);
    if (!e) return [void 0, void 0];
    let t = this.mapProviderToDescriptor.get(e);
    return t || (t = this.instantiationService.createInstance(e.ctor), this.mapProviderToDescriptor.set(e, t)), [t, e];
  }
};
r2 = Cte([G3(0, La), G3(1, Se)], r2);
class wf extends To {
  constructor(e) {
    var t;
    super(), this._onChange = this._register(new F()), this.onChange = this._onChange.event, this._onKeyDown = this._register(new F()), this.onKeyDown = this._onKeyDown.event, this._opts = e, this._checked = this._opts.isChecked;
    const n = ["monaco-custom-toggle"];
    this._opts.icon && (this._icon = this._opts.icon, n.push(...Ee.asClassNameArray(this._icon))), this._opts.actionClassName && n.push(...this._opts.actionClassName.split(" ")), this._checked && n.push("checked"), this.domNode = document.createElement("div"), this._hover = this._register(xr((t = e.hoverDelegate) !== null && t !== void 0 ? t : Bs("mouse"), this.domNode, this._opts.title)), this.domNode.classList.add(...n), this._opts.notFocusable || (this.domNode.tabIndex = 0), this.domNode.setAttribute("role", "checkbox"), this.domNode.setAttribute("aria-checked", String(this._checked)), this.domNode.setAttribute("aria-label", this._opts.title), this.applyStyles(), this.onclick(this.domNode, (s) => {
      this.enabled && (this.checked = !this._checked, this._onChange.fire(!1), s.preventDefault());
    }), this._register(this.ignoreGesture(this.domNode)), this.onkeydown(this.domNode, (s) => {
      if (s.keyCode === 10 || s.keyCode === 3) return this.checked = !this._checked, this._onChange.fire(!0), s.preventDefault(), void s.stopPropagation();
      this._onKeyDown.fire(s);
    });
  }
  get enabled() {
    return this.domNode.getAttribute("aria-disabled") !== "true";
  }
  focus() {
    this.domNode.focus();
  }
  get checked() {
    return this._checked;
  }
  set checked(e) {
    this._checked = e, this.domNode.setAttribute("aria-checked", String(this._checked)), this.domNode.classList.toggle("checked", this._checked), this.applyStyles();
  }
  width() {
    return 22;
  }
  applyStyles() {
    this.domNode && (this.domNode.style.borderColor = this._checked && this._opts.inputActiveOptionBorder || "", this.domNode.style.color = this._checked && this._opts.inputActiveOptionForeground || "inherit", this.domNode.style.backgroundColor = this._checked && this._opts.inputActiveOptionBackground || "");
  }
  enable() {
    this.domNode.setAttribute("aria-disabled", String(!1));
  }
  disable() {
    this.domNode.setAttribute("aria-disabled", String(!0));
  }
}
var wte = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
};
class iV {
  constructor(e) {
    this.nodes = e;
  }
  toString() {
    return this.nodes.map((e) => typeof e == "string" ? e : e.label).join("");
  }
}
wte([Li], iV.prototype, "toString", null);
const yte = /\[([^\]]+)\]\(((?:https?:\/\/|command:|file:)[^\)\s]+)(?: (["'])(.+?)(\3))?\)/gi, tx = {}, Ste = new SA("quick-input-button-icon-");
function Ky(i, e, t) {
  let n = i.iconClass || function(s) {
    if (!s) return;
    let o;
    const r = s.dark.toString();
    return tx[r] ? o = tx[r] : (o = Ste.nextId(), Gw(`.${o}, .hc-light .${o}`, `background-image: ${yc(s.light || s.dark)}`), Gw(`.vs-dark .${o}, .hc-black .${o}`, `background-image: ${yc(s.dark)}`), tx[r] = o), o;
  }(i.iconPath);
  return i.alwaysVisible && (n = n ? `${n} always-visible` : "always-visible"), { id: e, label: "", tooltip: i.tooltip || "", class: n, enabled: !0, run: t };
}
function Lte(i, e, t) {
  wn(e);
  const n = function(o) {
    const r = [];
    let a, l = 0;
    for (; a = yte.exec(o); ) {
      a.index - l > 0 && r.push(o.substring(l, a.index));
      const [, d, h, , c] = a;
      c ? r.push({ label: d, href: h, title: c }) : r.push({ label: d, href: h }), l = a.index + a[0].length;
    }
    return l < o.length && r.push(o.substring(l)), new iV(r);
  }(i);
  let s = 0;
  for (const o of n.nodes) if (typeof o == "string") e.append(...ic(o));
  else {
    let r = o.title;
    !r && o.href.startsWith("command:") ? r = m(0, "Click to execute command '{0}'", o.href.substring(8)) : r || (r = o.href);
    const a = Q("a", { href: o.href, title: r, tabIndex: s++ }, o.label);
    a.style.textDecoration = "underline";
    const l = (g) => {
      mj(g) && Ze(g, !0), t.callback(o.href);
    }, d = t.disposables.add(new st(a, ie.CLICK)).event, h = t.disposables.add(new st(a, ie.KEY_DOWN)).event, c = se.chain(h, (g) => g.filter((p) => {
      const f = new jt(p);
      return f.equals(10) || f.equals(3);
    }));
    t.disposables.add(Bt.addTarget(a));
    const u = t.disposables.add(new st(a, Vt.Tap)).event;
    se.any(d, u, c)(l, null, t.disposables), e.appendChild(a);
  }
}
class kte {
  get templateId() {
    return this.renderer.templateId;
  }
  constructor(e, t) {
    this.renderer = e, this.modelProvider = t;
  }
  renderTemplate(e) {
    return { data: this.renderer.renderTemplate(e), disposable: V.None };
  }
  renderElement(e, t, n, s) {
    var o;
    if ((o = n.disposable) === null || o === void 0 || o.dispose(), !n.data) return;
    const r = this.modelProvider();
    if (r.isResolved(e)) return this.renderer.renderElement(r.get(e), e, n.data, s);
    const a = new Ci(), l = r.resolve(e, a.token);
    n.disposable = { dispose: () => a.cancel() }, this.renderer.renderPlaceholder(e, n.data), l.then((d) => this.renderer.renderElement(d, e, n.data, s));
  }
  disposeTemplate(e) {
    e.disposable && (e.disposable.dispose(), e.disposable = void 0), e.data && (this.renderer.disposeTemplate(e.data), e.data = void 0);
  }
}
class Dte {
  constructor(e, t) {
    this.modelProvider = e, this.accessibilityProvider = t;
  }
  getWidgetAriaLabel() {
    return this.accessibilityProvider.getWidgetAriaLabel();
  }
  getAriaLabel(e) {
    const t = this.modelProvider();
    return t.isResolved(e) ? this.accessibilityProvider.getAriaLabel(t.get(e)) : null;
  }
}
class xte {
  constructor(e, t, n, s, o = {}) {
    const r = () => this.model, a = s.map((l) => new kte(l, r));
    this.list = new uo(e, t, n, a, function(l, d) {
      return { ...d, accessibilityProvider: d.accessibilityProvider && new Dte(l, d.accessibilityProvider) };
    }(r, o));
  }
  updateOptions(e) {
    this.list.updateOptions(e);
  }
  getHTMLElement() {
    return this.list.getHTMLElement();
  }
  get onDidFocus() {
    return this.list.onDidFocus;
  }
  get widget() {
    return this.list;
  }
  get onDidDispose() {
    return this.list.onDidDispose;
  }
  get onMouseDblClick() {
    return se.map(this.list.onMouseDblClick, ({ element: e, index: t, browserEvent: n }) => ({ element: e === void 0 ? void 0 : this._model.get(e), index: t, browserEvent: n }));
  }
  get onPointer() {
    return se.map(this.list.onPointer, ({ element: e, index: t, browserEvent: n }) => ({ element: e === void 0 ? void 0 : this._model.get(e), index: t, browserEvent: n }));
  }
  get onDidChangeSelection() {
    return se.map(this.list.onDidChangeSelection, ({ elements: e, indexes: t, browserEvent: n }) => ({ elements: e.map((s) => this._model.get(s)), indexes: t, browserEvent: n }));
  }
  get model() {
    return this._model;
  }
  set model(e) {
    this._model = e, this.list.splice(0, this.list.length, Ds(e.length));
  }
  getFocus() {
    return this.list.getFocus();
  }
  getSelection() {
    return this.list.getSelection();
  }
  getSelectedElements() {
    return this.getSelection().map((e) => this.model.get(e));
  }
  style(e) {
    this.list.style(e);
  }
  dispose() {
    this.list.dispose();
  }
}
var nf = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, jy;
(function(i) {
  i.North = "north", i.South = "south", i.East = "east", i.West = "west";
})(jy || (jy = {}));
const Nte = new F(), Ete = new F();
class a2 {
  constructor(e) {
    this.el = e, this.disposables = new G();
  }
  get onPointerMove() {
    return this.disposables.add(new st(ke(this.el), "mousemove")).event;
  }
  get onPointerUp() {
    return this.disposables.add(new st(ke(this.el), "mouseup")).event;
  }
  dispose() {
    this.disposables.dispose();
  }
}
nf([Li], a2.prototype, "onPointerMove", null), nf([Li], a2.prototype, "onPointerUp", null);
class l2 {
  get onPointerMove() {
    return this.disposables.add(new st(this.el, Vt.Change)).event;
  }
  get onPointerUp() {
    return this.disposables.add(new st(this.el, Vt.End)).event;
  }
  constructor(e) {
    this.el = e, this.disposables = new G();
  }
  dispose() {
    this.disposables.dispose();
  }
}
nf([Li], l2.prototype, "onPointerMove", null), nf([Li], l2.prototype, "onPointerUp", null);
class qy {
  get onPointerMove() {
    return this.factory.onPointerMove;
  }
  get onPointerUp() {
    return this.factory.onPointerUp;
  }
  constructor(e) {
    this.factory = e;
  }
  dispose() {
  }
}
nf([Li], qy.prototype, "onPointerMove", null), nf([Li], qy.prototype, "onPointerUp", null);
const Z3 = "pointer-events-disabled";
class Bn extends V {
  get state() {
    return this._state;
  }
  get orthogonalStartSash() {
    return this._orthogonalStartSash;
  }
  get orthogonalEndSash() {
    return this._orthogonalEndSash;
  }
  set state(e) {
    this._state !== e && (this.el.classList.toggle("disabled", e === 0), this.el.classList.toggle("minimum", e === 1), this.el.classList.toggle("maximum", e === 2), this._state = e, this.onDidEnablementChange.fire(e));
  }
  set orthogonalStartSash(e) {
    if (this._orthogonalStartSash !== e) {
      if (this.orthogonalStartDragHandleDisposables.clear(), this.orthogonalStartSashDisposables.clear(), e) {
        const t = (n) => {
          this.orthogonalStartDragHandleDisposables.clear(), n !== 0 && (this._orthogonalStartDragHandle = Z(this.el, Q(".orthogonal-drag-handle.start")), this.orthogonalStartDragHandleDisposables.add(ye(() => this._orthogonalStartDragHandle.remove())), this.orthogonalStartDragHandleDisposables.add(new st(this._orthogonalStartDragHandle, "mouseenter")).event(() => Bn.onMouseEnter(e), void 0, this.orthogonalStartDragHandleDisposables), this.orthogonalStartDragHandleDisposables.add(new st(this._orthogonalStartDragHandle, "mouseleave")).event(() => Bn.onMouseLeave(e), void 0, this.orthogonalStartDragHandleDisposables));
        };
        this.orthogonalStartSashDisposables.add(e.onDidEnablementChange.event(t, this)), t(e.state);
      }
      this._orthogonalStartSash = e;
    }
  }
  set orthogonalEndSash(e) {
    if (this._orthogonalEndSash !== e) {
      if (this.orthogonalEndDragHandleDisposables.clear(), this.orthogonalEndSashDisposables.clear(), e) {
        const t = (n) => {
          this.orthogonalEndDragHandleDisposables.clear(), n !== 0 && (this._orthogonalEndDragHandle = Z(this.el, Q(".orthogonal-drag-handle.end")), this.orthogonalEndDragHandleDisposables.add(ye(() => this._orthogonalEndDragHandle.remove())), this.orthogonalEndDragHandleDisposables.add(new st(this._orthogonalEndDragHandle, "mouseenter")).event(() => Bn.onMouseEnter(e), void 0, this.orthogonalEndDragHandleDisposables), this.orthogonalEndDragHandleDisposables.add(new st(this._orthogonalEndDragHandle, "mouseleave")).event(() => Bn.onMouseLeave(e), void 0, this.orthogonalEndDragHandleDisposables));
        };
        this.orthogonalEndSashDisposables.add(e.onDidEnablementChange.event(t, this)), t(e.state);
      }
      this._orthogonalEndSash = e;
    }
  }
  constructor(e, t, n) {
    super(), this.hoverDelay = 300, this.hoverDelayer = this._register(new Sr(this.hoverDelay)), this._state = 3, this.onDidEnablementChange = this._register(new F()), this._onDidStart = this._register(new F()), this._onDidChange = this._register(new F()), this._onDidReset = this._register(new F()), this._onDidEnd = this._register(new F()), this.orthogonalStartSashDisposables = this._register(new G()), this.orthogonalStartDragHandleDisposables = this._register(new G()), this.orthogonalEndSashDisposables = this._register(new G()), this.orthogonalEndDragHandleDisposables = this._register(new G()), this.onDidStart = this._onDidStart.event, this.onDidChange = this._onDidChange.event, this.onDidReset = this._onDidReset.event, this.onDidEnd = this._onDidEnd.event, this.linkedSash = void 0, this.el = Z(e, Q(".monaco-sash")), n.orthogonalEdge && this.el.classList.add(`orthogonal-edge-${n.orthogonalEdge}`), Je && this.el.classList.add("mac");
    const s = this._register(new st(this.el, "mousedown")).event;
    this._register(s((c) => this.onPointerStart(c, new a2(e)), this));
    const o = this._register(new st(this.el, "dblclick")).event;
    this._register(o(this.onPointerDoublePress, this));
    const r = this._register(new st(this.el, "mouseenter")).event;
    this._register(r(() => Bn.onMouseEnter(this)));
    const a = this._register(new st(this.el, "mouseleave")).event;
    this._register(a(() => Bn.onMouseLeave(this))), this._register(Bt.addTarget(this.el));
    const l = this._register(new st(this.el, Vt.Start)).event;
    this._register(l((c) => this.onPointerStart(c, new l2(this.el)), this));
    const d = this._register(new st(this.el, Vt.Tap)).event;
    let h;
    this._register(d((c) => {
      if (h) return clearTimeout(h), h = void 0, void this.onPointerDoublePress(c);
      clearTimeout(h), h = setTimeout(() => h = void 0, 250);
    }, this)), typeof n.size == "number" ? (this.size = n.size, n.orientation === 0 ? this.el.style.width = `${this.size}px` : this.el.style.height = `${this.size}px`) : (this.size = 4, this._register(Nte.event((c) => {
      this.size = c, this.layout();
    }))), this._register(Ete.event((c) => this.hoverDelay = c)), this.layoutProvider = t, this.orthogonalStartSash = n.orthogonalStartSash, this.orthogonalEndSash = n.orthogonalEndSash, this.orientation = n.orientation || 0, this.orientation === 1 ? (this.el.classList.add("horizontal"), this.el.classList.remove("vertical")) : (this.el.classList.remove("horizontal"), this.el.classList.add("vertical")), this.el.classList.toggle("debug", !1), this.layout();
  }
  onPointerStart(e, t) {
    Ze(e);
    let n = !1;
    if (!e.__orthogonalSashEvent) {
      const u = this.getOrthogonalSash(e);
      u && (n = !0, e.__orthogonalSashEvent = !0, u.onPointerStart(e, new qy(t)));
    }
    if (this.linkedSash && !e.__linkedSashEvent && (e.__linkedSashEvent = !0, this.linkedSash.onPointerStart(e, new qy(t))), !this.state) return;
    const s = this.el.ownerDocument.getElementsByTagName("iframe");
    for (const u of s) u.classList.add(Z3);
    const o = e.pageX, r = e.pageY, a = e.altKey, l = { startX: o, currentX: o, startY: r, currentY: r, altKey: a };
    this.el.classList.add("active"), this._onDidStart.fire(l);
    const d = Lo(this.el), h = () => {
      let u = "";
      u = n ? "all-scroll" : this.orientation === 1 ? this.state === 1 ? "s-resize" : this.state === 2 ? "n-resize" : Je ? "row-resize" : "ns-resize" : this.state === 1 ? "e-resize" : this.state === 2 ? "w-resize" : Je ? "col-resize" : "ew-resize", d.textContent = `* { cursor: ${u} !important; }`;
    }, c = new G();
    h(), n || this.onDidEnablementChange.event(h, null, c), t.onPointerMove((u) => {
      Ze(u, !1);
      const g = { startX: o, currentX: u.pageX, startY: r, currentY: u.pageY, altKey: a };
      this._onDidChange.fire(g);
    }, null, c), t.onPointerUp((u) => {
      Ze(u, !1), this.el.removeChild(d), this.el.classList.remove("active"), this._onDidEnd.fire(), c.dispose();
      for (const g of s) g.classList.remove(Z3);
    }, null, c), c.add(t);
  }
  onPointerDoublePress(e) {
    const t = this.getOrthogonalSash(e);
    t && t._onDidReset.fire(), this.linkedSash && this.linkedSash._onDidReset.fire(), this._onDidReset.fire();
  }
  static onMouseEnter(e, t = !1) {
    e.el.classList.contains("active") ? (e.hoverDelayer.cancel(), e.el.classList.add("hover")) : e.hoverDelayer.trigger(() => e.el.classList.add("hover"), e.hoverDelay).then(void 0, () => {
    }), !t && e.linkedSash && Bn.onMouseEnter(e.linkedSash, !0);
  }
  static onMouseLeave(e, t = !1) {
    e.hoverDelayer.cancel(), e.el.classList.remove("hover"), !t && e.linkedSash && Bn.onMouseLeave(e.linkedSash, !0);
  }
  clearSashHoverState() {
    Bn.onMouseLeave(this);
  }
  layout() {
    if (this.orientation === 0) {
      const e = this.layoutProvider;
      this.el.style.left = e.getVerticalSashLeft(this) - this.size / 2 + "px", e.getVerticalSashTop && (this.el.style.top = e.getVerticalSashTop(this) + "px"), e.getVerticalSashHeight && (this.el.style.height = e.getVerticalSashHeight(this) + "px");
    } else {
      const e = this.layoutProvider;
      this.el.style.top = e.getHorizontalSashTop(this) - this.size / 2 + "px", e.getHorizontalSashLeft && (this.el.style.left = e.getHorizontalSashLeft(this) + "px"), e.getHorizontalSashWidth && (this.el.style.width = e.getHorizontalSashWidth(this) + "px");
    }
  }
  getOrthogonalSash(e) {
    var t;
    const n = (t = e.initialTarget) !== null && t !== void 0 ? t : e.target;
    if (n && n instanceof HTMLElement) return n.classList.contains("orthogonal-drag-handle") ? n.classList.contains("start") ? this.orthogonalStartSash : this.orthogonalEndSash : void 0;
  }
  dispose() {
    super.dispose(), this.el.remove();
  }
}
const Ite = { separatorBorder: z.transparent };
class nV {
  set size(e) {
    this._size = e;
  }
  get size() {
    return this._size;
  }
  get visible() {
    return this._cachedVisibleSize === void 0;
  }
  setVisible(e, t) {
    var n, s;
    if (e !== this.visible) {
      e ? (this.size = as(this._cachedVisibleSize, this.viewMinimumSize, this.viewMaximumSize), this._cachedVisibleSize = void 0) : (this._cachedVisibleSize = typeof t == "number" ? t : this.size, this.size = 0), this.container.classList.toggle("visible", e);
      try {
        (s = (n = this.view).setVisible) === null || s === void 0 || s.call(n, e);
      } catch (o) {
        console.error("Splitview: Failed to set visible view"), console.error(o);
      }
    }
  }
  get minimumSize() {
    return this.visible ? this.view.minimumSize : 0;
  }
  get viewMinimumSize() {
    return this.view.minimumSize;
  }
  get maximumSize() {
    return this.visible ? this.view.maximumSize : 0;
  }
  get viewMaximumSize() {
    return this.view.maximumSize;
  }
  get priority() {
    return this.view.priority;
  }
  get proportionalLayout() {
    var e;
    return (e = this.view.proportionalLayout) === null || e === void 0 || e;
  }
  get snap() {
    return !!this.view.snap;
  }
  set enabled(e) {
    this.container.style.pointerEvents = e ? "" : "none";
  }
  constructor(e, t, n, s) {
    this.container = e, this.view = t, this.disposable = s, this._cachedVisibleSize = void 0, typeof n == "number" ? (this._size = n, this._cachedVisibleSize = void 0, e.classList.add("visible")) : (this._size = 0, this._cachedVisibleSize = n.cachedVisibleSize);
  }
  layout(e, t) {
    this.layoutContainer(e);
    try {
      this.view.layout(this.size, e, t);
    } catch (n) {
      console.error("Splitview: Failed to layout view"), console.error(n);
    }
  }
  dispose() {
    this.disposable.dispose();
  }
}
class Mte extends nV {
  layoutContainer(e) {
    this.container.style.top = `${e}px`, this.container.style.height = `${this.size}px`;
  }
}
class Tte extends nV {
  layoutContainer(e) {
    this.container.style.left = `${e}px`, this.container.style.width = `${this.size}px`;
  }
}
var Hl, $y;
(function(i) {
  i[i.Idle = 0] = "Idle", i[i.Busy = 1] = "Busy";
})(Hl || (Hl = {})), function(i) {
  i.Distribute = { type: "distribute" }, i.Split = function(e) {
    return { type: "split", index: e };
  }, i.Auto = function(e) {
    return { type: "auto", index: e };
  }, i.Invisible = function(e) {
    return { type: "invisible", cachedVisibleSize: e };
  };
}($y || ($y = {}));
class sV extends V {
  get orthogonalStartSash() {
    return this._orthogonalStartSash;
  }
  get orthogonalEndSash() {
    return this._orthogonalEndSash;
  }
  get startSnappingEnabled() {
    return this._startSnappingEnabled;
  }
  get endSnappingEnabled() {
    return this._endSnappingEnabled;
  }
  set orthogonalStartSash(e) {
    for (const t of this.sashItems) t.sash.orthogonalStartSash = e;
    this._orthogonalStartSash = e;
  }
  set orthogonalEndSash(e) {
    for (const t of this.sashItems) t.sash.orthogonalEndSash = e;
    this._orthogonalEndSash = e;
  }
  set startSnappingEnabled(e) {
    this._startSnappingEnabled !== e && (this._startSnappingEnabled = e, this.updateSashEnablement());
  }
  set endSnappingEnabled(e) {
    this._endSnappingEnabled !== e && (this._endSnappingEnabled = e, this.updateSashEnablement());
  }
  constructor(e, t = {}) {
    var n, s, o, r, a;
    super(), this.size = 0, this._contentSize = 0, this.proportions = void 0, this.viewItems = [], this.sashItems = [], this.state = Hl.Idle, this._onDidSashChange = this._register(new F()), this._onDidSashReset = this._register(new F()), this._startSnappingEnabled = !0, this._endSnappingEnabled = !0, this.onDidSashChange = this._onDidSashChange.event, this.onDidSashReset = this._onDidSashReset.event, this.orientation = (n = t.orientation) !== null && n !== void 0 ? n : 0, this.inverseAltBehavior = (s = t.inverseAltBehavior) !== null && s !== void 0 && s, this.proportionalLayout = (o = t.proportionalLayout) === null || o === void 0 || o, this.getSashOrthogonalSize = t.getSashOrthogonalSize, this.el = document.createElement("div"), this.el.classList.add("monaco-split-view2"), this.el.classList.add(this.orientation === 0 ? "vertical" : "horizontal"), e.appendChild(this.el), this.sashContainer = Z(this.el, Q(".sash-container")), this.viewContainer = Q(".split-view-container"), this.scrollable = this._register(new bf({ forceIntegerValues: !0, smoothScrollDuration: 125, scheduleAtNextAnimationFrame: (d) => Ys(ke(this.el), d) })), this.scrollableElement = this._register(new dL(this.viewContainer, { vertical: this.orientation === 0 ? (r = t.scrollbarVisibility) !== null && r !== void 0 ? r : 1 : 2, horizontal: this.orientation === 1 ? (a = t.scrollbarVisibility) !== null && a !== void 0 ? a : 1 : 2 }, this.scrollable));
    const l = this._register(new st(this.viewContainer, "scroll")).event;
    this._register(l((d) => {
      const h = this.scrollableElement.getScrollPosition(), c = Math.abs(this.viewContainer.scrollLeft - h.scrollLeft) <= 1 ? void 0 : this.viewContainer.scrollLeft, u = Math.abs(this.viewContainer.scrollTop - h.scrollTop) <= 1 ? void 0 : this.viewContainer.scrollTop;
      c === void 0 && u === void 0 || this.scrollableElement.setScrollPosition({ scrollLeft: c, scrollTop: u });
    })), this.onDidScroll = this.scrollableElement.onScroll, this._register(this.onDidScroll((d) => {
      d.scrollTopChanged && (this.viewContainer.scrollTop = d.scrollTop), d.scrollLeftChanged && (this.viewContainer.scrollLeft = d.scrollLeft);
    })), Z(this.el, this.scrollableElement.getDomNode()), this.style(t.styles || Ite), t.descriptor && (this.size = t.descriptor.size, t.descriptor.views.forEach((d, h) => {
      const c = $s(d.visible) || d.visible ? d.size : { type: "invisible", cachedVisibleSize: d.size }, u = d.view;
      this.doAddView(u, c, h, !0);
    }), this._contentSize = this.viewItems.reduce((d, h) => d + h.size, 0), this.saveProportions());
  }
  style(e) {
    e.separatorBorder.isTransparent() ? (this.el.classList.remove("separator-border"), this.el.style.removeProperty("--separator-border")) : (this.el.classList.add("separator-border"), this.el.style.setProperty("--separator-border", e.separatorBorder.toString()));
  }
  addView(e, t, n = this.viewItems.length, s) {
    this.doAddView(e, t, n, s);
  }
  layout(e, t) {
    const n = Math.max(this.size, this._contentSize);
    if (this.size = e, this.layoutContext = t, this.proportions) {
      let s = 0;
      for (let o = 0; o < this.viewItems.length; o++) {
        const r = this.viewItems[o], a = this.proportions[o];
        typeof a == "number" ? s += a : e -= r.size;
      }
      for (let o = 0; o < this.viewItems.length; o++) {
        const r = this.viewItems[o], a = this.proportions[o];
        typeof a == "number" && s > 0 && (r.size = as(Math.round(a * e / s), r.minimumSize, r.maximumSize));
      }
    } else {
      const s = Ds(this.viewItems.length), o = s.filter((a) => this.viewItems[a].priority === 1), r = s.filter((a) => this.viewItems[a].priority === 2);
      this.resize(this.viewItems.length - 1, e - n, void 0, o, r);
    }
    this.distributeEmptySpace(), this.layoutViews();
  }
  saveProportions() {
    this.proportionalLayout && this._contentSize > 0 && (this.proportions = this.viewItems.map((e) => e.proportionalLayout && e.visible ? e.size / this._contentSize : void 0));
  }
  onSashStart({ sash: e, start: t, alt: n }) {
    for (const a of this.viewItems) a.enabled = !1;
    const s = this.sashItems.findIndex((a) => a.sash === e), o = yr(K(this.el.ownerDocument.body, "keydown", (a) => r(this.sashDragState.current, a.altKey)), K(this.el.ownerDocument.body, "keyup", () => r(this.sashDragState.current, !1))), r = (a, l) => {
      const d = this.viewItems.map((p) => p.size);
      let h, c, u = Number.NEGATIVE_INFINITY, g = Number.POSITIVE_INFINITY;
      if (this.inverseAltBehavior && (l = !l), l)
        if (s === this.sashItems.length - 1) {
          const p = this.viewItems[s];
          u = (p.minimumSize - p.size) / 2, g = (p.maximumSize - p.size) / 2;
        } else {
          const p = this.viewItems[s + 1];
          u = (p.size - p.maximumSize) / 2, g = (p.size - p.minimumSize) / 2;
        }
      if (!l) {
        const p = Ds(s, -1), f = Ds(s + 1, this.viewItems.length), _ = p.reduce((N, A) => N + (this.viewItems[A].minimumSize - d[A]), 0), v = p.reduce((N, A) => N + (this.viewItems[A].viewMaximumSize - d[A]), 0), b = f.length === 0 ? Number.POSITIVE_INFINITY : f.reduce((N, A) => N + (d[A] - this.viewItems[A].minimumSize), 0), C = f.length === 0 ? Number.NEGATIVE_INFINITY : f.reduce((N, A) => N + (d[A] - this.viewItems[A].viewMaximumSize), 0), w = Math.max(_, C), y = Math.min(b, v), L = this.findFirstSnapIndex(p), k = this.findFirstSnapIndex(f);
        if (typeof L == "number") {
          const N = this.viewItems[L], A = Math.floor(N.viewMinimumSize / 2);
          h = { index: L, limitDelta: N.visible ? w - A : w + A, size: N.size };
        }
        if (typeof k == "number") {
          const N = this.viewItems[k], A = Math.floor(N.viewMinimumSize / 2);
          c = { index: k, limitDelta: N.visible ? y + A : y - A, size: N.size };
        }
      }
      this.sashDragState = { start: a, current: a, index: s, sizes: d, minDelta: u, maxDelta: g, alt: l, snapBefore: h, snapAfter: c, disposable: o };
    };
    r(t, n);
  }
  onSashChange({ current: e }) {
    const { index: t, start: n, sizes: s, alt: o, minDelta: r, maxDelta: a, snapBefore: l, snapAfter: d } = this.sashDragState;
    this.sashDragState.current = e;
    const h = e - n, c = this.resize(t, h, s, void 0, void 0, r, a, l, d);
    if (o) {
      const u = t === this.sashItems.length - 1, g = this.viewItems.map((C) => C.size), p = u ? t : t + 1, f = this.viewItems[p], _ = f.size - f.maximumSize, v = f.size - f.minimumSize, b = u ? t - 1 : t + 1;
      this.resize(b, -c, g, void 0, void 0, _, v);
    }
    this.distributeEmptySpace(), this.layoutViews();
  }
  onSashEnd(e) {
    this._onDidSashChange.fire(e), this.sashDragState.disposable.dispose(), this.saveProportions();
    for (const t of this.viewItems) t.enabled = !0;
  }
  onViewChange(e, t) {
    const n = this.viewItems.indexOf(e);
    n < 0 || n >= this.viewItems.length || (t = as(t = typeof t == "number" ? t : e.size, e.minimumSize, e.maximumSize), this.inverseAltBehavior && n > 0 ? (this.resize(n - 1, Math.floor((e.size - t) / 2)), this.distributeEmptySpace(), this.layoutViews()) : (e.size = t, this.relayout([n], void 0)));
  }
  resizeView(e, t) {
    if (!(e < 0 || e >= this.viewItems.length)) {
      if (this.state !== Hl.Idle) throw new Error("Cant modify splitview");
      this.state = Hl.Busy;
      try {
        const n = Ds(this.viewItems.length).filter((a) => a !== e), s = [...n.filter((a) => this.viewItems[a].priority === 1), e], o = n.filter((a) => this.viewItems[a].priority === 2), r = this.viewItems[e];
        t = as(t = Math.round(t), r.minimumSize, Math.min(r.maximumSize, this.size)), r.size = t, this.relayout(s, o);
      } finally {
        this.state = Hl.Idle;
      }
    }
  }
  distributeViewSizes() {
    const e = [];
    let t = 0;
    for (const a of this.viewItems) a.maximumSize - a.minimumSize > 0 && (e.push(a), t += a.size);
    const n = Math.floor(t / e.length);
    for (const a of e) a.size = as(n, a.minimumSize, a.maximumSize);
    const s = Ds(this.viewItems.length), o = s.filter((a) => this.viewItems[a].priority === 1), r = s.filter((a) => this.viewItems[a].priority === 2);
    this.relayout(o, r);
  }
  getViewSize(e) {
    return e < 0 || e >= this.viewItems.length ? -1 : this.viewItems[e].size;
  }
  doAddView(e, t, n = this.viewItems.length, s) {
    if (this.state !== Hl.Idle) throw new Error("Cant modify splitview");
    this.state = Hl.Busy;
    try {
      const o = Q(".split-view-view");
      n === this.viewItems.length ? this.viewContainer.appendChild(o) : this.viewContainer.insertBefore(o, this.viewContainer.children.item(n));
      const r = e.onDidChange((c) => this.onViewChange(d, c)), a = yr(r, ye(() => this.viewContainer.removeChild(o)));
      let l;
      typeof t == "number" ? l = t : (t.type === "auto" && (t = this.areViewsDistributed() ? { type: "distribute" } : { type: "split", index: t.index }), l = t.type === "split" ? this.getViewSize(t.index) / 2 : t.type === "invisible" ? { cachedVisibleSize: t.cachedVisibleSize } : e.minimumSize);
      const d = this.orientation === 0 ? new Mte(o, e, l, a) : new Tte(o, e, l, a);
      if (this.viewItems.splice(n, 0, d), this.viewItems.length > 1) {
        const c = { orthogonalStartSash: this.orthogonalStartSash, orthogonalEndSash: this.orthogonalEndSash }, u = this.orientation === 0 ? new Bn(this.sashContainer, { getHorizontalSashTop: (y) => this.getSashPosition(y), getHorizontalSashWidth: this.getSashOrthogonalSize }, { ...c, orientation: 1 }) : new Bn(this.sashContainer, { getVerticalSashLeft: (y) => this.getSashPosition(y), getVerticalSashHeight: this.getSashOrthogonalSize }, { ...c, orientation: 0 }), g = this.orientation === 0 ? (y) => ({ sash: u, start: y.startY, current: y.currentY, alt: y.altKey }) : (y) => ({ sash: u, start: y.startX, current: y.currentX, alt: y.altKey }), p = se.map(u.onDidStart, g)(this.onSashStart, this), f = se.map(u.onDidChange, g)(this.onSashChange, this), _ = se.map(u.onDidEnd, () => this.sashItems.findIndex((y) => y.sash === u)), v = _(this.onSashEnd, this), b = u.onDidReset(() => {
          const y = this.sashItems.findIndex((B) => B.sash === u), L = Ds(y, -1), k = Ds(y + 1, this.viewItems.length), N = this.findFirstSnapIndex(L), A = this.findFirstSnapIndex(k);
          (typeof N != "number" || this.viewItems[N].visible) && (typeof A != "number" || this.viewItems[A].visible) && this._onDidSashReset.fire(y);
        }), C = yr(p, f, v, b, u), w = { sash: u, disposable: C };
        this.sashItems.splice(n - 1, 0, w);
      }
      let h;
      o.appendChild(e.element), typeof t != "number" && t.type === "split" && (h = [t.index]), s || this.relayout([n], h), s || typeof t == "number" || t.type !== "distribute" || this.distributeViewSizes();
    } finally {
      this.state = Hl.Idle;
    }
  }
  relayout(e, t) {
    const n = this.viewItems.reduce((s, o) => s + o.size, 0);
    this.resize(this.viewItems.length - 1, this.size - n, void 0, e, t), this.distributeEmptySpace(), this.layoutViews(), this.saveProportions();
  }
  resize(e, t, n = this.viewItems.map((h) => h.size), s, o, r = Number.NEGATIVE_INFINITY, a = Number.POSITIVE_INFINITY, l, d) {
    if (e < 0 || e >= this.viewItems.length) return 0;
    const h = Ds(e, -1), c = Ds(e + 1, this.viewItems.length);
    if (o) for (const k of o) Ek(h, k), Ek(c, k);
    if (s) for (const k of s) $1(h, k), $1(c, k);
    const u = h.map((k) => this.viewItems[k]), g = h.map((k) => n[k]), p = c.map((k) => this.viewItems[k]), f = c.map((k) => n[k]), _ = h.reduce((k, N) => k + (this.viewItems[N].minimumSize - n[N]), 0), v = h.reduce((k, N) => k + (this.viewItems[N].maximumSize - n[N]), 0), b = c.length === 0 ? Number.POSITIVE_INFINITY : c.reduce((k, N) => k + (n[N] - this.viewItems[N].minimumSize), 0), C = c.length === 0 ? Number.NEGATIVE_INFINITY : c.reduce((k, N) => k + (n[N] - this.viewItems[N].maximumSize), 0), w = Math.max(_, C, r), y = Math.min(b, v, a);
    let L = !1;
    if (l) {
      const k = this.viewItems[l.index], N = t >= l.limitDelta;
      L = N !== k.visible, k.setVisible(N, l.size);
    }
    if (!L && d) {
      const k = this.viewItems[d.index], N = t < d.limitDelta;
      L = N !== k.visible, k.setVisible(N, d.size);
    }
    if (L) return this.resize(e, t, n, s, o, r, a);
    for (let k = 0, N = t = as(t, w, y); k < u.length; k++) {
      const A = u[k], B = as(g[k] + N, A.minimumSize, A.maximumSize);
      N -= B - g[k], A.size = B;
    }
    for (let k = 0, N = t; k < p.length; k++) {
      const A = p[k], B = as(f[k] - N, A.minimumSize, A.maximumSize);
      N += B - f[k], A.size = B;
    }
    return t;
  }
  distributeEmptySpace(e) {
    const t = this.viewItems.reduce((a, l) => a + l.size, 0);
    let n = this.size - t;
    const s = Ds(this.viewItems.length - 1, -1), o = s.filter((a) => this.viewItems[a].priority === 1), r = s.filter((a) => this.viewItems[a].priority === 2);
    for (const a of r) Ek(s, a);
    for (const a of o) $1(s, a);
    typeof e == "number" && $1(s, e);
    for (let a = 0; n !== 0 && a < s.length; a++) {
      const l = this.viewItems[s[a]], d = as(l.size + n, l.minimumSize, l.maximumSize);
      n -= d - l.size, l.size = d;
    }
  }
  layoutViews() {
    this._contentSize = this.viewItems.reduce((t, n) => t + n.size, 0);
    let e = 0;
    for (const t of this.viewItems) t.layout(e, this.layoutContext), e += t.size;
    this.sashItems.forEach((t) => t.sash.layout()), this.updateSashEnablement(), this.updateScrollableElement();
  }
  updateScrollableElement() {
    this.orientation === 0 ? this.scrollableElement.setScrollDimensions({ height: this.size, scrollHeight: this._contentSize }) : this.scrollableElement.setScrollDimensions({ width: this.size, scrollWidth: this._contentSize });
  }
  updateSashEnablement() {
    let e = !1;
    const t = this.viewItems.map((l) => e = l.size - l.minimumSize > 0 || e);
    e = !1;
    const n = this.viewItems.map((l) => e = l.maximumSize - l.size > 0 || e), s = [...this.viewItems].reverse();
    e = !1;
    const o = s.map((l) => e = l.size - l.minimumSize > 0 || e).reverse();
    e = !1;
    const r = s.map((l) => e = l.maximumSize - l.size > 0 || e).reverse();
    let a = 0;
    for (let l = 0; l < this.sashItems.length; l++) {
      const { sash: d } = this.sashItems[l];
      a += this.viewItems[l].size;
      const h = !(t[l] && r[l + 1]), c = !(n[l] && o[l + 1]);
      if (h && c) {
        const u = Ds(l, -1), g = Ds(l + 1, this.viewItems.length), p = this.findFirstSnapIndex(u), f = this.findFirstSnapIndex(g), _ = typeof p == "number" && !this.viewItems[p].visible, v = typeof f == "number" && !this.viewItems[f].visible;
        _ && o[l] && (a > 0 || this.startSnappingEnabled) ? d.state = 1 : v && t[l] && (a < this._contentSize || this.endSnappingEnabled) ? d.state = 2 : d.state = 0;
      } else d.state = h && !c ? 1 : !h && c ? 2 : 3;
    }
  }
  getSashPosition(e) {
    let t = 0;
    for (let n = 0; n < this.sashItems.length; n++) if (t += this.viewItems[n].size, this.sashItems[n].sash === e) return t;
    return 0;
  }
  findFirstSnapIndex(e) {
    for (const t of e) {
      const n = this.viewItems[t];
      if (n.visible && n.snap) return t;
    }
    for (const t of e) {
      const n = this.viewItems[t];
      if (n.visible && n.maximumSize - n.minimumSize > 0) return;
      if (!n.visible && n.snap) return t;
    }
  }
  areViewsDistributed() {
    let e, t;
    for (const n of this.viewItems) if (e = e === void 0 ? n.size : Math.min(e, n.size), t = t === void 0 ? n.size : Math.max(t, n.size), t - e > 2) return !1;
    return !0;
  }
  dispose() {
    var e;
    (e = this.sashDragState) === null || e === void 0 || e.disposable.dispose(), Ht(this.viewItems), this.viewItems = [], this.sashItems.forEach((t) => t.disposable.dispose()), this.sashItems = [], super.dispose();
  }
}
class Bv {
  constructor(e, t, n) {
    this.columns = e, this.getColumnSize = n, this.templateId = Bv.TemplateId, this.renderedTemplates = /* @__PURE__ */ new Set();
    const s = new Map(t.map((o) => [o.templateId, o]));
    this.renderers = [];
    for (const o of e) {
      const r = s.get(o.templateId);
      if (!r) throw new Error(`Table cell renderer for template id ${o.templateId} not found.`);
      this.renderers.push(r);
    }
  }
  renderTemplate(e) {
    const t = Z(e, Q(".monaco-table-tr")), n = [], s = [];
    for (let r = 0; r < this.columns.length; r++) {
      const a = this.renderers[r], l = Z(t, Q(".monaco-table-td", { "data-col-index": r }));
      l.style.width = `${this.getColumnSize(r)}px`, n.push(l), s.push(a.renderTemplate(l));
    }
    const o = { container: e, cellContainers: n, cellTemplateData: s };
    return this.renderedTemplates.add(o), o;
  }
  renderElement(e, t, n, s) {
    for (let o = 0; o < this.columns.length; o++) {
      const r = this.columns[o].project(e);
      this.renderers[o].renderElement(r, t, n.cellTemplateData[o], s);
    }
  }
  disposeElement(e, t, n, s) {
    for (let o = 0; o < this.columns.length; o++) {
      const r = this.renderers[o];
      if (r.disposeElement) {
        const a = this.columns[o].project(e);
        r.disposeElement(a, t, n.cellTemplateData[o], s);
      }
    }
  }
  disposeTemplate(e) {
    for (let t = 0; t < this.columns.length; t++)
      this.renderers[t].disposeTemplate(e.cellTemplateData[t]);
    Un(e.container), this.renderedTemplates.delete(e);
  }
  layoutColumn(e, t) {
    for (const { cellContainers: n } of this.renderedTemplates) n[e].style.width = `${t}px`;
  }
}
Bv.TemplateId = "row";
class Rte extends V {
  get minimumSize() {
    var e;
    return (e = this.column.minimumWidth) !== null && e !== void 0 ? e : 120;
  }
  get maximumSize() {
    var e;
    return (e = this.column.maximumWidth) !== null && e !== void 0 ? e : Number.POSITIVE_INFINITY;
  }
  get onDidChange() {
    var e;
    return (e = this.column.onDidChangeWidthConstraints) !== null && e !== void 0 ? e : se.None;
  }
  constructor(e, t) {
    super(), this.column = e, this.index = t, this._onDidLayout = new F(), this.onDidLayout = this._onDidLayout.event, this.element = Q(".monaco-table-th", { "data-col-index": t }, e.label), e.tooltip && this._register(xr(Bs("mouse"), this.element, e.tooltip));
  }
  layout(e) {
    this._onDidLayout.fire([this.index, e]);
  }
}
class RL {
  get onDidChangeFocus() {
    return this.list.onDidChangeFocus;
  }
  get onDidChangeSelection() {
    return this.list.onDidChangeSelection;
  }
  get onDidScroll() {
    return this.list.onDidScroll;
  }
  get onMouseDblClick() {
    return this.list.onMouseDblClick;
  }
  get onPointer() {
    return this.list.onPointer;
  }
  get onDidFocus() {
    return this.list.onDidFocus;
  }
  get scrollTop() {
    return this.list.scrollTop;
  }
  set scrollTop(e) {
    this.list.scrollTop = e;
  }
  get scrollHeight() {
    return this.list.scrollHeight;
  }
  get renderHeight() {
    return this.list.renderHeight;
  }
  get onDidDispose() {
    return this.list.onDidDispose;
  }
  constructor(e, t, n, s, o, r) {
    this.virtualDelegate = n, this.domId = "table_id_" + ++RL.InstanceCount, this.disposables = new G(), this.cachedWidth = 0, this.cachedHeight = 0, this.domNode = Z(t, Q(`.monaco-table.${this.domId}`));
    const a = s.map((c, u) => this.disposables.add(new Rte(c, u))), l = { size: a.reduce((c, u) => c + u.column.weight, 0), views: a.map((c) => ({ size: c.column.weight, view: c })) };
    this.splitview = this.disposables.add(new sV(this.domNode, { orientation: 1, scrollbarVisibility: 2, getSashOrthogonalSize: () => this.cachedHeight, descriptor: l })), this.splitview.el.style.height = `${n.headerRowHeight}px`, this.splitview.el.style.lineHeight = `${n.headerRowHeight}px`;
    const d = new Bv(s, o, (c) => this.splitview.getViewSize(c));
    var h;
    this.list = this.disposables.add(new uo(e, this.domNode, (h = n, { getHeight: (c) => h.getHeight(c), getTemplateId: () => Bv.TemplateId }), [d], r)), se.any(...a.map((c) => c.onDidLayout))(([c, u]) => d.layoutColumn(c, u), null, this.disposables), this.splitview.onDidSashReset((c) => {
      const u = s.reduce((p, f) => p + f.weight, 0), g = s[c].weight / u * this.cachedWidth;
      this.splitview.resizeView(c, g);
    }, null, this.disposables), this.styleElement = Lo(this.domNode), this.style(Gee);
  }
  updateOptions(e) {
    this.list.updateOptions(e);
  }
  splice(e, t, n = []) {
    this.list.splice(e, t, n);
  }
  getHTMLElement() {
    return this.domNode;
  }
  style(e) {
    const t = [];
    t.push(`.monaco-table.${this.domId} > .monaco-split-view2 .monaco-sash.vertical::before {
			top: ${this.virtualDelegate.headerRowHeight + 1}px;
			height: calc(100% - ${this.virtualDelegate.headerRowHeight}px);
		}`), this.styleElement.textContent = t.join(`
`), this.list.style(e);
  }
  getSelectedElements() {
    return this.list.getSelectedElements();
  }
  getSelection() {
    return this.list.getSelection();
  }
  getFocus() {
    return this.list.getFocus();
  }
  dispose() {
    this.disposables.dispose();
  }
}
RL.InstanceCount = 0;
const Ate = m(0, "Match Case"), Pte = m(0, "Match Whole Word"), Ote = m(0, "Use Regular Expression");
class oV extends wf {
  constructor(e) {
    var t;
    super({ icon: ne.caseSensitive, title: Ate + e.appendTitle, isChecked: e.isChecked, hoverDelegate: (t = e.hoverDelegate) !== null && t !== void 0 ? t : Bs("element"), inputActiveOptionBorder: e.inputActiveOptionBorder, inputActiveOptionForeground: e.inputActiveOptionForeground, inputActiveOptionBackground: e.inputActiveOptionBackground });
  }
}
class rV extends wf {
  constructor(e) {
    var t;
    super({ icon: ne.wholeWord, title: Pte + e.appendTitle, isChecked: e.isChecked, hoverDelegate: (t = e.hoverDelegate) !== null && t !== void 0 ? t : Bs("element"), inputActiveOptionBorder: e.inputActiveOptionBorder, inputActiveOptionForeground: e.inputActiveOptionForeground, inputActiveOptionBackground: e.inputActiveOptionBackground });
  }
}
class aV extends wf {
  constructor(e) {
    var t;
    super({ icon: ne.regex, title: Ote + e.appendTitle, isChecked: e.isChecked, hoverDelegate: (t = e.hoverDelegate) !== null && t !== void 0 ? t : Bs("element"), inputActiveOptionBorder: e.inputActiveOptionBorder, inputActiveOptionForeground: e.inputActiveOptionForeground, inputActiveOptionBackground: e.inputActiveOptionBackground });
  }
}
class Fte {
  constructor(e, t = 0, n = e.length, s = t - 1) {
    this.items = e, this.start = t, this.end = n, this.index = s;
  }
  current() {
    return this.index === this.start - 1 || this.index === this.end ? null : this.items[this.index];
  }
  next() {
    return this.index = Math.min(this.index + 1, this.end), this.current();
  }
  previous() {
    return this.index = Math.max(this.index - 1, this.start - 1), this.current();
  }
  first() {
    return this.index = this.start, this.current();
  }
  last() {
    return this.index = this.end - 1, this.current();
  }
}
class Bte {
  constructor(e = [], t = 10) {
    this._initialize(e), this._limit = t, this._onChange();
  }
  getHistory() {
    return this._elements;
  }
  add(e) {
    this._history.delete(e), this._history.add(e), this._onChange();
  }
  next() {
    return this._navigator.next();
  }
  previous() {
    return this._currentPosition() !== 0 ? this._navigator.previous() : null;
  }
  current() {
    return this._navigator.current();
  }
  first() {
    return this._navigator.first();
  }
  last() {
    return this._navigator.last();
  }
  isLast() {
    return this._currentPosition() >= this._elements.length - 1;
  }
  isNowhere() {
    return this._navigator.current() === null;
  }
  has(e) {
    return this._history.has(e);
  }
  _onChange() {
    this._reduceToLimit();
    const e = this._elements;
    this._navigator = new Fte(e, 0, e.length, e.length);
  }
  _reduceToLimit() {
    const e = this._elements;
    e.length > this._limit && this._initialize(e.slice(e.length - this._limit));
  }
  _currentPosition() {
    const e = this._navigator.current();
    return e ? this._elements.indexOf(e) : -1;
  }
  _initialize(e) {
    this._history = /* @__PURE__ */ new Set();
    for (const t of e) this._history.add(t);
  }
  get _elements() {
    const e = [];
    return this._history.forEach((t) => e.push(t)), e;
  }
}
const qf = Q;
let Wte = class extends To {
  constructor(i, e, t) {
    var n;
    super(), this.state = "idle", this.maxHeight = Number.POSITIVE_INFINITY, this._onDidChange = this._register(new F()), this.onDidChange = this._onDidChange.event, this._onDidHeightChange = this._register(new F()), this.onDidHeightChange = this._onDidHeightChange.event, this.contextViewProvider = e, this.options = t, this.message = null, this.placeholder = this.options.placeholder || "", this.tooltip = (n = this.options.tooltip) !== null && n !== void 0 ? n : this.placeholder || "", this.ariaLabel = this.options.ariaLabel || "", this.options.validationOptions && (this.validation = this.options.validationOptions.validation), this.element = Z(i, qf(".monaco-inputbox.idle"));
    const s = this.options.flexibleHeight ? "textarea" : "input", o = Z(this.element, qf(".ibwrapper"));
    if (this.input = Z(o, qf(s + ".input.empty")), this.input.setAttribute("autocorrect", "off"), this.input.setAttribute("autocapitalize", "off"), this.input.setAttribute("spellcheck", "false"), this.onfocus(this.input, () => this.element.classList.add("synthetic-focus")), this.onblur(this.input, () => this.element.classList.remove("synthetic-focus")), this.options.flexibleHeight) {
      this.maxHeight = typeof this.options.flexibleMaxHeight == "number" ? this.options.flexibleMaxHeight : Number.POSITIVE_INFINITY, this.mirror = Z(o, qf("div.mirror")), this.mirror.innerText = " ", this.scrollableElement = new LB(this.element, { vertical: 1 }), this.options.flexibleWidth && (this.input.setAttribute("wrap", "off"), this.mirror.style.whiteSpace = "pre", this.mirror.style.wordWrap = "initial"), Z(i, this.scrollableElement.getDomNode()), this._register(this.scrollableElement), this._register(this.scrollableElement.onScroll((l) => this.input.scrollTop = l.scrollTop));
      const r = this._register(new st(i.ownerDocument, "selectionchange")), a = se.filter(r.event, () => {
        const l = i.ownerDocument.getSelection();
        return (l == null ? void 0 : l.anchorNode) === o;
      });
      this._register(a(this.updateScrollDimensions, this)), this._register(this.onDidHeightChange(this.updateScrollDimensions, this));
    } else this.input.type = this.options.type || "text", this.input.setAttribute("wrap", "off");
    this.ariaLabel && this.input.setAttribute("aria-label", this.ariaLabel), this.placeholder && !this.options.showPlaceholderOnFocus && this.setPlaceHolder(this.placeholder), this.tooltip && this.setTooltip(this.tooltip), this.oninput(this.input, () => this.onValueChange()), this.onblur(this.input, () => this.onBlur()), this.onfocus(this.input, () => this.onFocus()), this._register(this.ignoreGesture(this.input)), setTimeout(() => this.updateMirror(), 0), this.options.actions && (this.actionbar = this._register(new sr(this.element)), this.actionbar.push(this.options.actions, { icon: !0, label: !1 })), this.applyStyles();
  }
  onBlur() {
    this._hideMessage(), this.options.showPlaceholderOnFocus && this.input.setAttribute("placeholder", "");
  }
  onFocus() {
    this._showMessage(), this.options.showPlaceholderOnFocus && this.input.setAttribute("placeholder", this.placeholder || "");
  }
  setPlaceHolder(i) {
    this.placeholder = i, this.input.setAttribute("placeholder", i);
  }
  setTooltip(i) {
    this.tooltip = i, this.hover ? this.hover.update(i) : this.hover = this._register(xr(Bs("mouse"), this.input, i));
  }
  get inputElement() {
    return this.input;
  }
  get value() {
    return this.input.value;
  }
  set value(i) {
    this.input.value !== i && (this.input.value = i, this.onValueChange());
  }
  get height() {
    return typeof this.cachedHeight == "number" ? this.cachedHeight : rd(this.element);
  }
  focus() {
    this.input.focus();
  }
  blur() {
    this.input.blur();
  }
  hasFocus() {
    return US(this.input);
  }
  select(i = null) {
    this.input.select(), i && (this.input.setSelectionRange(i.start, i.end), i.end === this.input.value.length && (this.input.scrollLeft = this.input.scrollWidth));
  }
  isSelectionAtEnd() {
    return this.input.selectionEnd === this.input.value.length && this.input.selectionStart === this.input.selectionEnd;
  }
  getSelection() {
    var i;
    const e = this.input.selectionStart;
    return e === null ? null : { start: e, end: (i = this.input.selectionEnd) !== null && i !== void 0 ? i : e };
  }
  enable() {
    this.input.removeAttribute("disabled");
  }
  disable() {
    this.blur(), this.input.disabled = !0, this._hideMessage();
  }
  set paddingRight(i) {
    this.input.style.width = `calc(100% - ${i}px)`, this.mirror && (this.mirror.style.paddingRight = i + "px");
  }
  updateScrollDimensions() {
    if (typeof this.cachedContentHeight != "number" || typeof this.cachedHeight != "number" || !this.scrollableElement) return;
    const i = this.cachedContentHeight, e = this.cachedHeight, t = this.input.scrollTop;
    this.scrollableElement.setScrollDimensions({ scrollHeight: i, height: e }), this.scrollableElement.setScrollPosition({ scrollTop: t });
  }
  showMessage(i, e) {
    if (this.state === "open" && So(this.message, i)) return;
    this.message = i, this.element.classList.remove("idle"), this.element.classList.remove("info"), this.element.classList.remove("warning"), this.element.classList.remove("error"), this.element.classList.add(this.classForType(i.type));
    const t = this.stylesForType(this.message.type);
    this.element.style.border = `1px solid ${kd(t.border, "transparent")}`, this.message.content && (this.hasFocus() || e) && this._showMessage();
  }
  hideMessage() {
    this.message = null, this.element.classList.remove("info"), this.element.classList.remove("warning"), this.element.classList.remove("error"), this.element.classList.add("idle"), this._hideMessage(), this.applyStyles();
  }
  validate() {
    let i = null;
    return this.validation && (i = this.validation(this.value), i ? (this.inputElement.setAttribute("aria-invalid", "true"), this.showMessage(i)) : this.inputElement.hasAttribute("aria-invalid") && (this.inputElement.removeAttribute("aria-invalid"), this.hideMessage())), i == null ? void 0 : i.type;
  }
  stylesForType(i) {
    const e = this.options.inputBoxStyles;
    switch (i) {
      case 1:
        return { border: e.inputValidationInfoBorder, background: e.inputValidationInfoBackground, foreground: e.inputValidationInfoForeground };
      case 2:
        return { border: e.inputValidationWarningBorder, background: e.inputValidationWarningBackground, foreground: e.inputValidationWarningForeground };
      default:
        return { border: e.inputValidationErrorBorder, background: e.inputValidationErrorBackground, foreground: e.inputValidationErrorForeground };
    }
  }
  classForType(i) {
    switch (i) {
      case 1:
        return "info";
      case 2:
        return "warning";
      default:
        return "error";
    }
  }
  _showMessage() {
    if (!this.contextViewProvider || !this.message) return;
    let i;
    const e = () => i.style.width = os(this.element) + "px";
    let t;
    this.contextViewProvider.showContextView({ getAnchor: () => this.element, anchorAlignment: 1, render: (n) => {
      var s, o;
      if (!this.message) return null;
      i = Z(n, qf(".monaco-inputbox-container")), e();
      const r = { inline: !0, className: "monaco-inputbox-message" }, a = this.message.formatContent ? LJ(this.message.content, r) : function(d, h = {}) {
        const c = fA(h);
        return c.textContent = d, c;
      }(this.message.content, r);
      a.classList.add(this.classForType(this.message.type));
      const l = this.stylesForType(this.message.type);
      return a.style.backgroundColor = (s = l.background) !== null && s !== void 0 ? s : "", a.style.color = (o = l.foreground) !== null && o !== void 0 ? o : "", a.style.border = l.border ? `1px solid ${l.border}` : "", Z(i, a), null;
    }, onHide: () => {
      this.state = "closed";
    }, layout: e }), t = this.message.type === 3 ? m(0, "Error: {0}", this.message.content) : this.message.type === 2 ? m(0, "Warning: {0}", this.message.content) : m(0, "Info: {0}", this.message.content), Io(t), this.state = "open";
  }
  _hideMessage() {
    this.contextViewProvider && (this.state === "open" && this.contextViewProvider.hideContextView(), this.state = "idle");
  }
  onValueChange() {
    this._onDidChange.fire(this.value), this.validate(), this.updateMirror(), this.input.classList.toggle("empty", !this.value), this.state === "open" && this.contextViewProvider && this.contextViewProvider.layout();
  }
  updateMirror() {
    if (!this.mirror) return;
    const i = this.value, e = i.charCodeAt(i.length - 1) === 10 ? " " : "";
    (i + e).replace(/\u000c/g, "") ? this.mirror.textContent = i + e : this.mirror.innerText = " ", this.layout();
  }
  applyStyles() {
    var i, e, t;
    const n = this.options.inputBoxStyles, s = (i = n.inputBackground) !== null && i !== void 0 ? i : "", o = (e = n.inputForeground) !== null && e !== void 0 ? e : "", r = (t = n.inputBorder) !== null && t !== void 0 ? t : "";
    this.element.style.backgroundColor = s, this.element.style.color = o, this.input.style.backgroundColor = "inherit", this.input.style.color = o, this.element.style.border = `1px solid ${kd(r, "transparent")}`;
  }
  layout() {
    if (!this.mirror) return;
    const i = this.cachedContentHeight;
    this.cachedContentHeight = rd(this.mirror), i !== this.cachedContentHeight && (this.cachedHeight = Math.min(this.cachedContentHeight, this.maxHeight), this.input.style.height = this.cachedHeight + "px", this._onDidHeightChange.fire(this.cachedContentHeight));
  }
  insertAtCursor(i) {
    const e = this.inputElement, t = e.selectionStart, n = e.selectionEnd, s = e.value;
    t !== null && n !== null && (this.value = s.substr(0, t) + i + s.substr(n), e.setSelectionRange(t + 1, t + 1), this.layout());
  }
  dispose() {
    var i;
    this._hideMessage(), this.message = null, (i = this.actionbar) === null || i === void 0 || i.dispose(), super.dispose();
  }
};
class lV extends Wte {
  constructor(e, t, n) {
    const s = m(0, " or {0} for history", "⇅"), o = m(0, " ({0} for history)", "⇅");
    super(e, t, n), this._onDidFocus = this._register(new F()), this.onDidFocus = this._onDidFocus.event, this._onDidBlur = this._register(new F()), this.onDidBlur = this._onDidBlur.event, this.history = new Bte(n.history, 100);
    const r = () => {
      if (n.showHistoryHint && n.showHistoryHint() && !this.placeholder.endsWith(s) && !this.placeholder.endsWith(o) && this.history.getHistory().length) {
        const a = this.placeholder.endsWith(")") ? s : o, l = this.placeholder + a;
        n.showPlaceholderOnFocus && !US(this.input) ? this.placeholder = l : this.setPlaceHolder(l);
      }
    };
    this.observer = new MutationObserver((a, l) => {
      a.forEach((d) => {
        d.target.textContent || r();
      });
    }), this.observer.observe(this.input, { attributeFilter: ["class"] }), this.onfocus(this.input, () => r()), this.onblur(this.input, () => {
      const a = (l) => {
        if (this.placeholder.endsWith(l)) {
          const d = this.placeholder.slice(0, this.placeholder.length - l.length);
          return n.showPlaceholderOnFocus ? this.placeholder = d : this.setPlaceHolder(d), !0;
        }
        return !1;
      };
      a(o) || a(s);
    });
  }
  dispose() {
    super.dispose(), this.observer && (this.observer.disconnect(), this.observer = void 0);
  }
  addToHistory(e) {
    this.value && (e || this.value !== this.getCurrentValue()) && this.history.add(this.value);
  }
  isAtLastInHistory() {
    return this.history.isLast();
  }
  isNowhereInHistory() {
    return this.history.isNowhere();
  }
  showNextValue() {
    this.history.has(this.value) || this.addToHistory();
    let e = this.getNextValue();
    e && (e = e === this.value ? this.getNextValue() : e), this.value = e ?? "", vl(this.value ? this.value : m(0, "Cleared Input"));
  }
  showPreviousValue() {
    this.history.has(this.value) || this.addToHistory();
    let e = this.getPreviousValue();
    e && (e = e === this.value ? this.getPreviousValue() : e), e && (this.value = e, vl(this.value));
  }
  setPlaceHolder(e) {
    super.setPlaceHolder(e), this.setTooltip(e);
  }
  onBlur() {
    super.onBlur(), this._onDidBlur.fire();
  }
  onFocus() {
    super.onFocus(), this._onDidFocus.fire();
  }
  getCurrentValue() {
    let e = this.history.current();
    return e || (e = this.history.last(), this.history.next()), e;
  }
  getPreviousValue() {
    return this.history.previous() || this.history.first();
  }
  getNextValue() {
    return this.history.next();
  }
}
const Vte = m(0, "input");
class dV extends To {
  constructor(e, t, n) {
    super(), this.fixFocusOnOptionClickEnabled = !0, this.imeSessionInProgress = !1, this.additionalTogglesDisposables = this._register(new rn()), this.additionalToggles = [], this._onDidOptionChange = this._register(new F()), this.onDidOptionChange = this._onDidOptionChange.event, this._onKeyDown = this._register(new F()), this.onKeyDown = this._onKeyDown.event, this._onMouseDown = this._register(new F()), this.onMouseDown = this._onMouseDown.event, this._onInput = this._register(new F()), this._onKeyUp = this._register(new F()), this._onCaseSensitiveKeyDown = this._register(new F()), this.onCaseSensitiveKeyDown = this._onCaseSensitiveKeyDown.event, this._onRegexKeyDown = this._register(new F()), this.onRegexKeyDown = this._onRegexKeyDown.event, this._lastHighlightFindOptions = 0, this.placeholder = n.placeholder || "", this.validation = n.validation, this.label = n.label || Vte, this.showCommonFindToggles = !!n.showCommonFindToggles;
    const s = n.appendCaseSensitiveLabel || "", o = n.appendWholeWordsLabel || "", r = n.appendRegexLabel || "", a = n.history || [], l = !!n.flexibleHeight, d = !!n.flexibleWidth, h = n.flexibleMaxHeight;
    this.domNode = document.createElement("div"), this.domNode.classList.add("monaco-findInput"), this.inputBox = this._register(new lV(this.domNode, t, { placeholder: this.placeholder || "", ariaLabel: this.label || "", validationOptions: { validation: this.validation }, history: a, showHistoryHint: n.showHistoryHint, flexibleHeight: l, flexibleWidth: d, flexibleMaxHeight: h, inputBoxStyles: n.inputBoxStyles }));
    const c = this._register(Xm());
    if (this.showCommonFindToggles) {
      this.regex = this._register(new aV({ appendTitle: r, isChecked: !1, hoverDelegate: c, ...n.toggleStyles })), this._register(this.regex.onChange((g) => {
        this._onDidOptionChange.fire(g), !g && this.fixFocusOnOptionClickEnabled && this.inputBox.focus(), this.validate();
      })), this._register(this.regex.onKeyDown((g) => {
        this._onRegexKeyDown.fire(g);
      })), this.wholeWords = this._register(new rV({ appendTitle: o, isChecked: !1, hoverDelegate: c, ...n.toggleStyles })), this._register(this.wholeWords.onChange((g) => {
        this._onDidOptionChange.fire(g), !g && this.fixFocusOnOptionClickEnabled && this.inputBox.focus(), this.validate();
      })), this.caseSensitive = this._register(new oV({ appendTitle: s, isChecked: !1, hoverDelegate: c, ...n.toggleStyles })), this._register(this.caseSensitive.onChange((g) => {
        this._onDidOptionChange.fire(g), !g && this.fixFocusOnOptionClickEnabled && this.inputBox.focus(), this.validate();
      })), this._register(this.caseSensitive.onKeyDown((g) => {
        this._onCaseSensitiveKeyDown.fire(g);
      }));
      const u = [this.caseSensitive.domNode, this.wholeWords.domNode, this.regex.domNode];
      this.onkeydown(this.domNode, (g) => {
        if (g.equals(15) || g.equals(17) || g.equals(9)) {
          const p = u.indexOf(this.domNode.ownerDocument.activeElement);
          if (p >= 0) {
            let f = -1;
            g.equals(17) ? f = (p + 1) % u.length : g.equals(15) && (f = p === 0 ? u.length - 1 : p - 1), g.equals(9) ? (u[p].blur(), this.inputBox.focus()) : f >= 0 && u[f].focus(), Ze(g, !0);
          }
        }
      });
    }
    this.controls = document.createElement("div"), this.controls.className = "controls", this.controls.style.display = this.showCommonFindToggles ? "" : "none", this.caseSensitive && this.controls.append(this.caseSensitive.domNode), this.wholeWords && this.controls.appendChild(this.wholeWords.domNode), this.regex && this.controls.appendChild(this.regex.domNode), this.setAdditionalToggles(n == null ? void 0 : n.additionalToggles), this.controls && this.domNode.appendChild(this.controls), e == null || e.appendChild(this.domNode), this._register(K(this.inputBox.inputElement, "compositionstart", (u) => {
      this.imeSessionInProgress = !0;
    })), this._register(K(this.inputBox.inputElement, "compositionend", (u) => {
      this.imeSessionInProgress = !1, this._onInput.fire();
    })), this.onkeydown(this.inputBox.inputElement, (u) => this._onKeyDown.fire(u)), this.onkeyup(this.inputBox.inputElement, (u) => this._onKeyUp.fire(u)), this.oninput(this.inputBox.inputElement, (u) => this._onInput.fire()), this.onmousedown(this.inputBox.inputElement, (u) => this._onMouseDown.fire(u));
  }
  get onDidChange() {
    return this.inputBox.onDidChange;
  }
  layout(e) {
    this.inputBox.layout(), this.updateInputBoxPadding(e.collapsedFindWidget);
  }
  enable() {
    var e, t, n;
    this.domNode.classList.remove("disabled"), this.inputBox.enable(), (e = this.regex) === null || e === void 0 || e.enable(), (t = this.wholeWords) === null || t === void 0 || t.enable(), (n = this.caseSensitive) === null || n === void 0 || n.enable();
    for (const s of this.additionalToggles) s.enable();
  }
  disable() {
    var e, t, n;
    this.domNode.classList.add("disabled"), this.inputBox.disable(), (e = this.regex) === null || e === void 0 || e.disable(), (t = this.wholeWords) === null || t === void 0 || t.disable(), (n = this.caseSensitive) === null || n === void 0 || n.disable();
    for (const s of this.additionalToggles) s.disable();
  }
  setFocusInputOnOptionClick(e) {
    this.fixFocusOnOptionClickEnabled = e;
  }
  setEnabled(e) {
    e ? this.enable() : this.disable();
  }
  setAdditionalToggles(e) {
    for (const t of this.additionalToggles) t.domNode.remove();
    this.additionalToggles = [], this.additionalTogglesDisposables.value = new G();
    for (const t of e ?? []) this.additionalTogglesDisposables.value.add(t), this.controls.appendChild(t.domNode), this.additionalTogglesDisposables.value.add(t.onChange((n) => {
      this._onDidOptionChange.fire(n), !n && this.fixFocusOnOptionClickEnabled && this.inputBox.focus();
    })), this.additionalToggles.push(t);
    this.additionalToggles.length > 0 && (this.controls.style.display = ""), this.updateInputBoxPadding();
  }
  updateInputBoxPadding(e = !1) {
    var t, n, s, o, r, a;
    this.inputBox.paddingRight = e ? 0 : ((n = (t = this.caseSensitive) === null || t === void 0 ? void 0 : t.width()) !== null && n !== void 0 ? n : 0) + ((o = (s = this.wholeWords) === null || s === void 0 ? void 0 : s.width()) !== null && o !== void 0 ? o : 0) + ((a = (r = this.regex) === null || r === void 0 ? void 0 : r.width()) !== null && a !== void 0 ? a : 0) + this.additionalToggles.reduce((l, d) => l + d.width(), 0);
  }
  getValue() {
    return this.inputBox.value;
  }
  setValue(e) {
    this.inputBox.value !== e && (this.inputBox.value = e);
  }
  select() {
    this.inputBox.select();
  }
  focus() {
    this.inputBox.focus();
  }
  getCaseSensitive() {
    var e, t;
    return (t = (e = this.caseSensitive) === null || e === void 0 ? void 0 : e.checked) !== null && t !== void 0 && t;
  }
  setCaseSensitive(e) {
    this.caseSensitive && (this.caseSensitive.checked = e);
  }
  getWholeWords() {
    var e, t;
    return (t = (e = this.wholeWords) === null || e === void 0 ? void 0 : e.checked) !== null && t !== void 0 && t;
  }
  setWholeWords(e) {
    this.wholeWords && (this.wholeWords.checked = e);
  }
  getRegex() {
    var e, t;
    return (t = (e = this.regex) === null || e === void 0 ? void 0 : e.checked) !== null && t !== void 0 && t;
  }
  setRegex(e) {
    this.regex && (this.regex.checked = e, this.validate());
  }
  focusOnCaseSensitive() {
    var e;
    (e = this.caseSensitive) === null || e === void 0 || e.focus();
  }
  highlightFindOptions() {
    this.domNode.classList.remove("highlight-" + this._lastHighlightFindOptions), this._lastHighlightFindOptions = 1 - this._lastHighlightFindOptions, this.domNode.classList.add("highlight-" + this._lastHighlightFindOptions);
  }
  validate() {
    this.inputBox.validate();
  }
  showMessage(e) {
    this.inputBox.showMessage(e);
  }
  clearMessage() {
    this.inputBox.hideMessage();
  }
}
var co, Pu, sf, Cd, fg;
(function(i) {
  i[i.Expanded = 0] = "Expanded", i[i.Collapsed = 1] = "Collapsed", i[i.PreserveOrExpanded = 2] = "PreserveOrExpanded", i[i.PreserveOrCollapsed = 3] = "PreserveOrCollapsed";
})(co || (co = {})), function(i) {
  i[i.Unknown = 0] = "Unknown", i[i.Twistie = 1] = "Twistie", i[i.Element = 2] = "Element", i[i.Filter = 3] = "Filter";
}(Pu || (Pu = {}));
class _o extends Error {
  constructor(e, t) {
    super(`TreeError [${e}] ${t}`);
  }
}
class IA {
  constructor(e) {
    this.fn = e, this._map = /* @__PURE__ */ new WeakMap();
  }
  map(e) {
    let t = this._map.get(e);
    return t || (t = this.fn(e), this._map.set(e, t)), t;
  }
}
function MA(i) {
  return typeof i == "object" && "visibility" in i && "data" in i;
}
function Wv(i) {
  switch (i) {
    case !0:
      return 1;
    case !1:
      return 0;
    default:
      return i;
  }
}
function ix(i) {
  return typeof i.collapsible == "boolean";
}
class Hte {
  constructor(e, t, n, s = {}) {
    var o;
    this.user = e, this.list = t, this.rootRef = [], this.eventBufferer = new eR(), this._onDidChangeCollapseState = new F(), this.onDidChangeCollapseState = this.eventBufferer.wrapEvent(this._onDidChangeCollapseState.event), this._onDidChangeRenderNodeCount = new F(), this.onDidChangeRenderNodeCount = this.eventBufferer.wrapEvent(this._onDidChangeRenderNodeCount.event), this._onDidSplice = new F(), this.onDidSplice = this._onDidSplice.event, this.refilterDelayer = new Sr(r8), this.collapseByDefault = s.collapseByDefault !== void 0 && s.collapseByDefault, this.allowNonCollapsibleParents = (o = s.allowNonCollapsibleParents) !== null && o !== void 0 && o, this.filter = s.filter, this.autoExpandSingleChildren = s.autoExpandSingleChildren !== void 0 && s.autoExpandSingleChildren, this.root = { parent: void 0, element: n, children: [], depth: 0, visibleChildrenCount: 0, visibleChildIndex: -1, collapsible: !1, collapsed: !1, renderNodeCount: 0, visibility: 1, visible: !0, filterData: void 0 };
  }
  splice(e, t, n = at.empty(), s = {}) {
    if (e.length === 0) throw new _o(this.user, "Invalid tree location");
    s.diffIdentityProvider ? this.spliceSmart(s.diffIdentityProvider, e, t, n, s) : this.spliceSimple(e, t, n, s);
  }
  spliceSmart(e, t, n, s, o, r) {
    var a;
    s === void 0 && (s = at.empty()), r === void 0 && (r = (a = o.diffDepth) !== null && a !== void 0 ? a : 0);
    const { parentNode: l } = this.getParentNodeWithListIndex(t);
    if (!l.lastDiffIds) return this.spliceSimple(t, n, s, o);
    const d = [...s], h = t[t.length - 1], c = new $a({ getElements: () => l.lastDiffIds }, { getElements: () => [...l.children.slice(0, h), ...d, ...l.children.slice(h + n)].map((_) => e.getId(_.element).toString()) }).ComputeDiff(!1);
    if (c.quitEarly) return l.lastDiffIds = void 0, this.spliceSimple(t, n, d, o);
    const u = t.slice(0, -1), g = (_, v, b) => {
      if (r > 0) for (let C = 0; C < b; C++) _--, v--, this.spliceSmart(e, [...u, _, 0], Number.MAX_SAFE_INTEGER, d[v].children, o, r - 1);
    };
    let p = Math.min(l.children.length, h + n), f = d.length;
    for (const _ of c.changes.sort((v, b) => b.originalStart - v.originalStart)) g(p, f, p - (_.originalStart + _.originalLength)), p = _.originalStart, f = _.modifiedStart - h, this.spliceSimple([...u, p], _.originalLength, at.slice(d, f, f + _.modifiedLength), o);
    g(p, f, p);
  }
  spliceSimple(e, t, n = at.empty(), { onDidCreateNode: s, onDidDeleteNode: o, diffIdentityProvider: r }) {
    const { parentNode: a, listIndex: l, revealed: d, visible: h } = this.getParentNodeWithListIndex(e), c = [], u = at.map(n, (y) => this.createTreeNode(y, a, a.visible ? 1 : 0, d, c, s)), g = e[e.length - 1];
    let p = 0;
    for (let y = g; y >= 0 && y < a.children.length; y--) {
      const L = a.children[y];
      if (L.visible) {
        p = L.visibleChildIndex;
        break;
      }
    }
    const f = [];
    let _ = 0, v = 0;
    for (const y of u) f.push(y), v += y.renderNodeCount, y.visible && (y.visibleChildIndex = p + _++);
    const b = YP(a.children, g, t, f);
    r ? a.lastDiffIds ? YP(a.lastDiffIds, g, t, f.map((y) => r.getId(y.element).toString())) : a.lastDiffIds = a.children.map((y) => r.getId(y.element).toString()) : a.lastDiffIds = void 0;
    let C = 0;
    for (const y of b) y.visible && C++;
    if (C !== 0) for (let y = g + f.length; y < a.children.length; y++) {
      const L = a.children[y];
      L.visible && (L.visibleChildIndex -= C);
    }
    if (a.visibleChildrenCount += _ - C, d && h) {
      const y = b.reduce((L, k) => L + (k.visible ? k.renderNodeCount : 0), 0);
      this._updateAncestorsRenderNodeCount(a, v - y), this.list.splice(l, y, c);
    }
    if (b.length > 0 && o) {
      const y = (L) => {
        o(L), L.children.forEach(y);
      };
      b.forEach(y);
    }
    this._onDidSplice.fire({ insertedNodes: f, deletedNodes: b });
    let w = a;
    for (; w; ) {
      if (w.visibility === 2) {
        this.refilterDelayer.trigger(() => this.refilter());
        break;
      }
      w = w.parent;
    }
  }
  rerender(e) {
    if (e.length === 0) throw new _o(this.user, "Invalid tree location");
    const { node: t, listIndex: n, revealed: s } = this.getTreeNodeWithListIndex(e);
    t.visible && s && this.list.splice(n, 1, [t]);
  }
  has(e) {
    return this.hasTreeNode(e);
  }
  getListIndex(e) {
    const { listIndex: t, visible: n, revealed: s } = this.getTreeNodeWithListIndex(e);
    return n && s ? t : -1;
  }
  getListRenderCount(e) {
    return this.getTreeNode(e).renderNodeCount;
  }
  isCollapsible(e) {
    return this.getTreeNode(e).collapsible;
  }
  setCollapsible(e, t) {
    const n = this.getTreeNode(e);
    t === void 0 && (t = !n.collapsible);
    const s = { collapsible: t };
    return this.eventBufferer.bufferEvents(() => this._setCollapseState(e, s));
  }
  isCollapsed(e) {
    return this.getTreeNode(e).collapsed;
  }
  setCollapsed(e, t, n) {
    const s = this.getTreeNode(e);
    t === void 0 && (t = !s.collapsed);
    const o = { collapsed: t, recursive: n || !1 };
    return this.eventBufferer.bufferEvents(() => this._setCollapseState(e, o));
  }
  _setCollapseState(e, t) {
    const { node: n, listIndex: s, revealed: o } = this.getTreeNodeWithListIndex(e), r = this._setListNodeCollapseState(n, s, o, t);
    if (n !== this.root && this.autoExpandSingleChildren && r && !ix(t) && n.collapsible && !n.collapsed && !t.recursive) {
      let a = -1;
      for (let l = 0; l < n.children.length; l++)
        if (n.children[l].visible) {
          if (a > -1) {
            a = -1;
            break;
          }
          a = l;
        }
      a > -1 && this._setCollapseState([...e, a], t);
    }
    return r;
  }
  _setListNodeCollapseState(e, t, n, s) {
    const o = this._setNodeCollapseState(e, s, !1);
    if (!n || !e.visible || !o) return o;
    const r = e.renderNodeCount, a = this.updateNodeAfterCollapseChange(e), l = r - (t === -1 ? 0 : 1);
    return this.list.splice(t + 1, l, a.slice(1)), o;
  }
  _setNodeCollapseState(e, t, n) {
    let s;
    if (e === this.root ? s = !1 : (ix(t) ? (s = e.collapsible !== t.collapsible, e.collapsible = t.collapsible) : e.collapsible ? (s = e.collapsed !== t.collapsed, e.collapsed = t.collapsed) : s = !1, s && this._onDidChangeCollapseState.fire({ node: e, deep: n })), !ix(t) && t.recursive) for (const o of e.children) s = this._setNodeCollapseState(o, t, !0) || s;
    return s;
  }
  expandTo(e) {
    this.eventBufferer.bufferEvents(() => {
      let t = this.getTreeNode(e);
      for (; t.parent; ) t = t.parent, e = e.slice(0, e.length - 1), t.collapsed && this._setCollapseState(e, { collapsed: !1, recursive: !1 });
    });
  }
  refilter() {
    const e = this.root.renderNodeCount, t = this.updateNodeAfterFilterChange(this.root);
    this.list.splice(0, e, t), this.refilterDelayer.cancel();
  }
  createTreeNode(e, t, n, s, o, r) {
    const a = { parent: t, element: e.element, children: [], depth: t.depth + 1, visibleChildrenCount: 0, visibleChildIndex: -1, collapsible: typeof e.collapsible == "boolean" ? e.collapsible : e.collapsed !== void 0, collapsed: e.collapsed === void 0 ? this.collapseByDefault : e.collapsed, renderNodeCount: 1, visibility: 1, visible: !0, filterData: void 0 }, l = this._filterNode(a, n);
    a.visibility = l, s && o.push(a);
    const d = e.children || at.empty(), h = s && l !== 0 && !a.collapsed;
    let c = 0, u = 1;
    for (const g of d) {
      const p = this.createTreeNode(g, a, l, h, o, r);
      a.children.push(p), u += p.renderNodeCount, p.visible && (p.visibleChildIndex = c++);
    }
    return this.allowNonCollapsibleParents || (a.collapsible = a.collapsible || a.children.length > 0), a.visibleChildrenCount = c, a.visible = l === 2 ? c > 0 : l === 1, a.visible ? a.collapsed || (a.renderNodeCount = u) : (a.renderNodeCount = 0, s && o.pop()), r == null || r(a), a;
  }
  updateNodeAfterCollapseChange(e) {
    const t = e.renderNodeCount, n = [];
    return this._updateNodeAfterCollapseChange(e, n), this._updateAncestorsRenderNodeCount(e.parent, n.length - t), n;
  }
  _updateNodeAfterCollapseChange(e, t) {
    if (e.visible === !1) return 0;
    if (t.push(e), e.renderNodeCount = 1, !e.collapsed) for (const n of e.children) e.renderNodeCount += this._updateNodeAfterCollapseChange(n, t);
    return this._onDidChangeRenderNodeCount.fire(e), e.renderNodeCount;
  }
  updateNodeAfterFilterChange(e) {
    const t = e.renderNodeCount, n = [];
    return this._updateNodeAfterFilterChange(e, e.visible ? 1 : 0, n), this._updateAncestorsRenderNodeCount(e.parent, n.length - t), n;
  }
  _updateNodeAfterFilterChange(e, t, n, s = !0) {
    let o;
    if (e !== this.root) {
      if (o = this._filterNode(e, t), o === 0) return e.visible = !1, e.renderNodeCount = 0, !1;
      s && n.push(e);
    }
    const r = n.length;
    e.renderNodeCount = e === this.root ? 0 : 1;
    let a = !1;
    if (e.collapsed && o === 0) e.visibleChildrenCount = 0;
    else {
      let l = 0;
      for (const d of e.children) a = this._updateNodeAfterFilterChange(d, o, n, s && !e.collapsed) || a, d.visible && (d.visibleChildIndex = l++);
      e.visibleChildrenCount = l;
    }
    return e !== this.root && (e.visible = o === 2 ? a : o === 1, e.visibility = o), e.visible ? e.collapsed || (e.renderNodeCount += n.length - r) : (e.renderNodeCount = 0, s && n.pop()), this._onDidChangeRenderNodeCount.fire(e), e.visible;
  }
  _updateAncestorsRenderNodeCount(e, t) {
    if (t !== 0) for (; e; ) e.renderNodeCount += t, this._onDidChangeRenderNodeCount.fire(e), e = e.parent;
  }
  _filterNode(e, t) {
    const n = this.filter ? this.filter.filter(e.element, t) : 1;
    return typeof n == "boolean" ? (e.filterData = void 0, n ? 1 : 0) : MA(n) ? (e.filterData = n.data, Wv(n.visibility)) : (e.filterData = void 0, Wv(n));
  }
  hasTreeNode(e, t = this.root) {
    if (!e || e.length === 0) return !0;
    const [n, ...s] = e;
    return !(n < 0 || n > t.children.length) && this.hasTreeNode(s, t.children[n]);
  }
  getTreeNode(e, t = this.root) {
    if (!e || e.length === 0) return t;
    const [n, ...s] = e;
    if (n < 0 || n > t.children.length) throw new _o(this.user, "Invalid tree location");
    return this.getTreeNode(s, t.children[n]);
  }
  getTreeNodeWithListIndex(e) {
    if (e.length === 0) return { node: this.root, listIndex: -1, revealed: !0, visible: !1 };
    const { parentNode: t, listIndex: n, revealed: s, visible: o } = this.getParentNodeWithListIndex(e), r = e[e.length - 1];
    if (r < 0 || r > t.children.length) throw new _o(this.user, "Invalid tree location");
    const a = t.children[r];
    return { node: a, listIndex: n, revealed: s, visible: o && a.visible };
  }
  getParentNodeWithListIndex(e, t = this.root, n = 0, s = !0, o = !0) {
    const [r, ...a] = e;
    if (r < 0 || r > t.children.length) throw new _o(this.user, "Invalid tree location");
    for (let l = 0; l < r; l++) n += t.children[l].renderNodeCount;
    return s = s && !t.collapsed, o = o && t.visible, a.length === 0 ? { parentNode: t, listIndex: n, revealed: s, visible: o } : this.getParentNodeWithListIndex(a, t.children[r], n + 1, s, o);
  }
  getNode(e = []) {
    return this.getTreeNode(e);
  }
  getNodeLocation(e) {
    const t = [];
    let n = e;
    for (; n.parent; ) t.push(n.parent.children.indexOf(n)), n = n.parent;
    return t.reverse();
  }
  getParentNodeLocation(e) {
    return e.length === 0 ? void 0 : e.length === 1 ? [] : function(t) {
      if (t.length === 0) throw new Error("Invalid tail call");
      return [t.slice(0, t.length - 1), t[t.length - 1]];
    }(e)[0];
  }
  getFirstElementChild(e) {
    const t = this.getTreeNode(e);
    if (t.children.length !== 0) return t.children[0].element;
  }
}
class zte extends A1 {
  constructor(e) {
    super(e.elements.map((t) => t.element)), this.data = e;
  }
}
function nx(i) {
  return i instanceof A1 ? new zte(i) : i;
}
class Ute {
  constructor(e, t) {
    this.modelProvider = e, this.dnd = t, this.autoExpandDisposable = V.None, this.disposables = new G();
  }
  getDragURI(e) {
    return this.dnd.getDragURI(e.element);
  }
  getDragLabel(e, t) {
    if (this.dnd.getDragLabel) return this.dnd.getDragLabel(e.map((n) => n.element), t);
  }
  onDragStart(e, t) {
    var n, s;
    (s = (n = this.dnd).onDragStart) === null || s === void 0 || s.call(n, nx(e), t);
  }
  onDragOver(e, t, n, s, o, r = !0) {
    const a = this.dnd.onDragOver(nx(e), t && t.element, n, s, o), l = this.autoExpandNode !== t;
    if (l && (this.autoExpandDisposable.dispose(), this.autoExpandNode = t), t === void 0) return a;
    if (l && typeof a != "boolean" && a.autoExpand && (this.autoExpandDisposable = Cc(() => {
      const g = this.modelProvider(), p = g.getNodeLocation(t);
      g.isCollapsed(p) && g.setCollapsed(p, !1), this.autoExpandNode = void 0;
    }, 500, this.disposables)), typeof a == "boolean" || !a.accept || a.bubble === void 0 || a.feedback)
      return r ? a : { accept: typeof a == "boolean" ? a : a.accept, effect: typeof a == "boolean" ? void 0 : a.effect, feedback: [n] };
    if (a.bubble === 1) {
      const g = this.modelProvider(), p = g.getNodeLocation(t), f = g.getParentNodeLocation(p), _ = g.getNode(f), v = f && g.getListIndex(f);
      return this.onDragOver(e, _, v, s, o, !1);
    }
    const d = this.modelProvider(), h = d.getNodeLocation(t), c = d.getListIndex(h), u = d.getListRenderCount(h);
    return { ...a, feedback: Ds(c, c + u) };
  }
  drop(e, t, n, s, o) {
    this.autoExpandDisposable.dispose(), this.autoExpandNode = void 0, this.dnd.drop(nx(e), t && t.element, n, s, o);
  }
  onDragEnd(e) {
    var t, n;
    (n = (t = this.dnd).onDragEnd) === null || n === void 0 || n.call(t, e);
  }
  dispose() {
    this.disposables.dispose(), this.dnd.dispose();
  }
}
class TA {
  constructor(e) {
    this.delegate = e;
  }
  getHeight(e) {
    return this.delegate.getHeight(e.element);
  }
  getTemplateId(e) {
    return this.delegate.getTemplateId(e.element);
  }
  hasDynamicHeight(e) {
    return !!this.delegate.hasDynamicHeight && this.delegate.hasDynamicHeight(e.element);
  }
  setDynamicHeight(e, t) {
    var n, s;
    (s = (n = this.delegate).setDynamicHeight) === null || s === void 0 || s.call(n, e.element, t);
  }
}
(function(i) {
  i.None = "none", i.OnHover = "onHover", i.Always = "always";
})(sf || (sf = {}));
class Kte {
  get elements() {
    return this._elements;
  }
  constructor(e, t = []) {
    this._elements = t, this.disposables = new G(), this.onDidChange = se.forEach(e, (n) => this._elements = n, this.disposables);
  }
  dispose() {
    this.disposables.dispose();
  }
}
class Vv {
  constructor(e, t, n, s, o, r = {}) {
    var a;
    this.renderer = e, this.modelProvider = t, this.activeNodes = s, this.renderedIndentGuides = o, this.renderedElements = /* @__PURE__ */ new Map(), this.renderedNodes = /* @__PURE__ */ new Map(), this.indent = Vv.DefaultIndent, this.hideTwistiesOfChildlessElements = !1, this.shouldRenderIndentGuides = !1, this.activeIndentNodes = /* @__PURE__ */ new Set(), this.indentGuidesDisposable = V.None, this.disposables = new G(), this.templateId = e.templateId, this.updateOptions(r), se.map(n, (l) => l.node)(this.onDidChangeNodeTwistieState, this, this.disposables), (a = e.onDidChangeTwistieState) === null || a === void 0 || a.call(e, this.onDidChangeTwistieState, this, this.disposables);
  }
  updateOptions(e = {}) {
    if (e.indent !== void 0) {
      const t = as(e.indent, 0, 40);
      if (t !== this.indent) {
        this.indent = t;
        for (const [n, s] of this.renderedNodes) this.renderTreeElement(n, s);
      }
    }
    if (e.renderIndentGuides !== void 0) {
      const t = e.renderIndentGuides !== sf.None;
      if (t !== this.shouldRenderIndentGuides) {
        this.shouldRenderIndentGuides = t;
        for (const [n, s] of this.renderedNodes) this._renderIndentGuides(n, s);
        if (this.indentGuidesDisposable.dispose(), t) {
          const n = new G();
          this.activeNodes.onDidChange(this._onDidChangeActiveNodes, this, n), this.indentGuidesDisposable = n, this._onDidChangeActiveNodes(this.activeNodes.elements);
        }
      }
    }
    e.hideTwistiesOfChildlessElements !== void 0 && (this.hideTwistiesOfChildlessElements = e.hideTwistiesOfChildlessElements);
  }
  renderTemplate(e) {
    const t = Z(e, Q(".monaco-tl-row")), n = Z(t, Q(".monaco-tl-indent")), s = Z(t, Q(".monaco-tl-twistie")), o = Z(t, Q(".monaco-tl-contents")), r = this.renderer.renderTemplate(o);
    return { container: e, indent: n, twistie: s, indentGuidesDisposable: V.None, templateData: r };
  }
  renderElement(e, t, n, s) {
    this.renderedNodes.set(e, n), this.renderedElements.set(e.element, e), this.renderTreeElement(e, n), this.renderer.renderElement(e, t, n.templateData, s);
  }
  disposeElement(e, t, n, s) {
    var o, r;
    n.indentGuidesDisposable.dispose(), (r = (o = this.renderer).disposeElement) === null || r === void 0 || r.call(o, e, t, n.templateData, s), typeof s == "number" && (this.renderedNodes.delete(e), this.renderedElements.delete(e.element));
  }
  disposeTemplate(e) {
    this.renderer.disposeTemplate(e.templateData);
  }
  onDidChangeTwistieState(e) {
    const t = this.renderedElements.get(e);
    t && this.onDidChangeNodeTwistieState(t);
  }
  onDidChangeNodeTwistieState(e) {
    const t = this.renderedNodes.get(e);
    t && (this._onDidChangeActiveNodes(this.activeNodes.elements), this.renderTreeElement(e, t));
  }
  renderTreeElement(e, t) {
    const n = Vv.DefaultIndent + (e.depth - 1) * this.indent;
    t.twistie.style.paddingLeft = `${n}px`, t.indent.style.width = n + this.indent - 16 + "px", e.collapsible ? t.container.setAttribute("aria-expanded", String(!e.collapsed)) : t.container.removeAttribute("aria-expanded"), t.twistie.classList.remove(...Ee.asClassNameArray(ne.treeItemExpanded));
    let s = !1;
    this.renderer.renderTwistie && (s = this.renderer.renderTwistie(e.element, t.twistie)), e.collapsible && (!this.hideTwistiesOfChildlessElements || e.visibleChildrenCount > 0) ? (s || t.twistie.classList.add(...Ee.asClassNameArray(ne.treeItemExpanded)), t.twistie.classList.add("collapsible"), t.twistie.classList.toggle("collapsed", e.collapsed)) : t.twistie.classList.remove("collapsible", "collapsed"), this._renderIndentGuides(e, t);
  }
  _renderIndentGuides(e, t) {
    if (Un(t.indent), t.indentGuidesDisposable.dispose(), !this.shouldRenderIndentGuides) return;
    const n = new G(), s = this.modelProvider();
    for (; ; ) {
      const o = s.getNodeLocation(e), r = s.getParentNodeLocation(o);
      if (!r) break;
      const a = s.getNode(r), l = Q(".indent-guide", { style: `width: ${this.indent}px` });
      this.activeIndentNodes.has(a) && l.classList.add("active"), t.indent.childElementCount === 0 ? t.indent.appendChild(l) : t.indent.insertBefore(l, t.indent.firstElementChild), this.renderedIndentGuides.add(a, l), n.add(ye(() => this.renderedIndentGuides.delete(a, l))), e = a;
    }
    t.indentGuidesDisposable = n;
  }
  _onDidChangeActiveNodes(e) {
    if (!this.shouldRenderIndentGuides) return;
    const t = /* @__PURE__ */ new Set(), n = this.modelProvider();
    e.forEach((s) => {
      const o = n.getNodeLocation(s);
      try {
        const r = n.getParentNodeLocation(o);
        s.collapsible && s.children.length > 0 && !s.collapsed ? t.add(s) : r && t.add(n.getNode(r));
      } catch {
      }
    }), this.activeIndentNodes.forEach((s) => {
      t.has(s) || this.renderedIndentGuides.forEach(s, (o) => o.classList.remove("active"));
    }), t.forEach((s) => {
      this.activeIndentNodes.has(s) || this.renderedIndentGuides.forEach(s, (o) => o.classList.add("active"));
    }), this.activeIndentNodes = t;
  }
  dispose() {
    this.renderedNodes.clear(), this.renderedElements.clear(), this.indentGuidesDisposable.dispose(), Ht(this.disposables);
  }
}
Vv.DefaultIndent = 8;
class jte {
  get totalCount() {
    return this._totalCount;
  }
  get matchCount() {
    return this._matchCount;
  }
  constructor(e, t, n) {
    this.tree = e, this.keyboardNavigationLabelProvider = t, this._filter = n, this._totalCount = 0, this._matchCount = 0, this._pattern = "", this._lowercasePattern = "", this.disposables = new G(), e.onWillRefilter(this.reset, this, this.disposables);
  }
  filter(e, t) {
    let n = 1;
    if (this._filter) {
      const r = this._filter.filter(e, t);
      if (n = typeof r == "boolean" ? r ? 1 : 0 : MA(r) ? Wv(r.visibility) : r, n === 0) return !1;
    }
    if (this._totalCount++, !this._pattern) return this._matchCount++, { data: da.Default, visibility: n };
    const s = this.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(e), o = Array.isArray(s) ? s : [s];
    for (const r of o) {
      const a = r && r.toString();
      if (a === void 0) return { data: da.Default, visibility: n };
      let l;
      if (this.tree.findMatchType === fg.Contiguous) {
        const d = a.toLowerCase().indexOf(this._lowercasePattern);
        if (d > -1) {
          l = [Number.MAX_SAFE_INTEGER, 0];
          for (let h = this._lowercasePattern.length; h > 0; h--) l.push(d + h - 1);
        }
      } else l = pg(this._pattern, this._lowercasePattern, 0, a, a.toLowerCase(), 0, { firstMatchCanBeWeak: !0, boostFullMatch: !0 });
      if (l) return this._matchCount++, o.length === 1 ? { data: l, visibility: n } : { data: { label: a, score: l }, visibility: n };
    }
    return this.tree.findMode === Cd.Filter ? typeof this.tree.options.defaultFindVisibility == "number" ? this.tree.options.defaultFindVisibility : this.tree.options.defaultFindVisibility ? this.tree.options.defaultFindVisibility(e) : 2 : { data: da.Default, visibility: n };
  }
  reset() {
    this._totalCount = 0, this._matchCount = 0;
  }
  dispose() {
    Ht(this.disposables);
  }
}
(function(i) {
  i[i.Highlight = 0] = "Highlight", i[i.Filter = 1] = "Filter";
})(Cd || (Cd = {})), function(i) {
  i[i.Fuzzy = 0] = "Fuzzy", i[i.Contiguous = 1] = "Contiguous";
}(fg || (fg = {}));
let qte = class {
  get pattern() {
    return this._pattern;
  }
  get mode() {
    return this._mode;
  }
  set mode(i) {
    i !== this._mode && (this._mode = i, this.widget && (this.widget.mode = this._mode), this.tree.refilter(), this.render(), this._onDidChangeMode.fire(i));
  }
  get matchType() {
    return this._matchType;
  }
  set matchType(i) {
    i !== this._matchType && (this._matchType = i, this.widget && (this.widget.matchType = this._matchType), this.tree.refilter(), this.render(), this._onDidChangeMatchType.fire(i));
  }
  constructor(i, e, t, n, s, o = {}) {
    var r, a;
    this.tree = i, this.view = t, this.filter = n, this.contextViewProvider = s, this.options = o, this._pattern = "", this.width = 0, this._onDidChangeMode = new F(), this.onDidChangeMode = this._onDidChangeMode.event, this._onDidChangeMatchType = new F(), this.onDidChangeMatchType = this._onDidChangeMatchType.event, this._onDidChangePattern = new F(), this._onDidChangeOpenState = new F(), this.onDidChangeOpenState = this._onDidChangeOpenState.event, this.enabledDisposables = new G(), this.disposables = new G(), this._mode = (r = i.options.defaultFindMode) !== null && r !== void 0 ? r : Cd.Highlight, this._matchType = (a = i.options.defaultFindMatchType) !== null && a !== void 0 ? a : fg.Fuzzy, e.onDidSplice(this.onDidSpliceModel, this, this.disposables);
  }
  updateOptions(i = {}) {
    i.defaultFindMode !== void 0 && (this.mode = i.defaultFindMode), i.defaultFindMatchType !== void 0 && (this.matchType = i.defaultFindMatchType);
  }
  onDidSpliceModel() {
    this.widget && this.pattern.length !== 0 && (this.tree.refilter(), this.render());
  }
  render() {
    var i, e, t, n;
    const s = this.filter.totalCount > 0 && this.filter.matchCount === 0;
    this.pattern && s ? (i = this.tree.options.showNotFoundMessage) === null || i === void 0 || i ? (e = this.widget) === null || e === void 0 || e.showMessage({ type: 2, content: m(0, "No elements found.") }) : (t = this.widget) === null || t === void 0 || t.showMessage({ type: 2 }) : (n = this.widget) === null || n === void 0 || n.clearMessage();
  }
  shouldAllowFocus(i) {
    return !this.widget || !this.pattern || this.filter.totalCount > 0 && this.filter.matchCount <= 1 || !da.isDefault(i.filterData);
  }
  layout(i) {
    var e;
    this.width = i, (e = this.widget) === null || e === void 0 || e.layout(i);
  }
  dispose() {
    this._history = void 0, this._onDidChangePattern.dispose(), this.enabledDisposables.dispose(), this.disposables.dispose();
  }
};
function $te(i, e) {
  return i.position === e.position && hV(i, e);
}
function hV(i, e) {
  return i.node.element === e.node.element && i.startIndex === e.startIndex && i.height === e.height && i.endIndex === e.endIndex;
}
class Gte {
  constructor(e = []) {
    this.stickyNodes = e;
  }
  get count() {
    return this.stickyNodes.length;
  }
  equal(e) {
    return ri(this.stickyNodes, e.stickyNodes, $te);
  }
  lastNodePartiallyVisible() {
    if (this.count === 0) return !1;
    const e = this.stickyNodes[this.count - 1];
    if (this.count === 1) return e.position !== 0;
    const t = this.stickyNodes[this.count - 2];
    return t.position + t.height !== e.position;
  }
  animationStateChanged(e) {
    if (!ri(this.stickyNodes, e.stickyNodes, hV) || this.count === 0) return !1;
    const t = this.stickyNodes[this.count - 1], n = e.stickyNodes[e.count - 1];
    return t.position !== n.position;
  }
}
class Zte {
  constrainStickyScrollNodes(e, t, n) {
    for (let s = 0; s < e.length; s++) {
      const o = e[s];
      if (o.position + o.height > n || s >= t) return e.slice(0, s);
    }
    return e;
  }
}
let Y3 = class extends V {
  constructor(i, e, t, n, s, o = {}) {
    var r;
    super(), this.tree = i, this.model = e, this.view = t, this.treeDelegate = s, this.maxWidgetViewRatio = 0.4;
    const a = this.validateStickySettings(o);
    this.stickyScrollMaxItemCount = a.stickyScrollMaxItemCount, this.stickyScrollDelegate = (r = o.stickyScrollDelegate) !== null && r !== void 0 ? r : new Zte(), this._widget = this._register(new Yte(t.getScrollableElement(), t, i, n, s, o.accessibilityProvider)), this.onDidChangeHasFocus = this._widget.onDidChangeHasFocus, this.onContextMenu = this._widget.onContextMenu, this._register(t.onDidScroll(() => this.update())), this._register(t.onDidChangeContentHeight(() => this.update())), this._register(i.onDidChangeCollapseState(() => this.update())), this.update();
  }
  get height() {
    return this._widget.height;
  }
  getNodeAtHeight(i) {
    let e;
    if (e = i === 0 ? this.view.firstVisibleIndex : this.view.indexAt(i + this.view.scrollTop), !(e < 0 || e >= this.view.length)) return this.view.element(e);
  }
  update() {
    const i = this.getNodeAtHeight(0);
    if (!i || this.tree.scrollTop === 0) return void this._widget.setState(void 0);
    const e = this.findStickyState(i);
    this._widget.setState(e);
  }
  findStickyState(i) {
    const e = [];
    let t = i, n = 0, s = this.getNextStickyNode(t, void 0, n);
    for (; s && (e.push(s), n += s.height, !(e.length <= this.stickyScrollMaxItemCount) || (t = this.getNextVisibleNode(s), t)); ) s = this.getNextStickyNode(t, s.node, n);
    const o = this.constrainStickyNodes(e);
    return o.length ? new Gte(o) : void 0;
  }
  getNextVisibleNode(i) {
    return this.getNodeAtHeight(i.position + i.height);
  }
  getNextStickyNode(i, e, t) {
    const n = this.getAncestorUnderPrevious(i, e);
    if (n)
      return n === i && (!this.nodeIsUncollapsedParent(i) || this.nodeTopAlignsWithStickyNodesBottom(i, t)) ? void 0 : this.createStickyScrollNode(n, t);
  }
  nodeTopAlignsWithStickyNodesBottom(i, e) {
    const t = this.getNodeIndex(i), n = this.view.getElementTop(t), s = e;
    return this.view.scrollTop === n - s;
  }
  createStickyScrollNode(i, e) {
    const t = this.treeDelegate.getHeight(i), { startIndex: n, endIndex: s } = this.getNodeRange(i);
    return { node: i, position: this.calculateStickyNodePosition(s, e, t), height: t, startIndex: n, endIndex: s };
  }
  getAncestorUnderPrevious(i, e = void 0) {
    let t = i, n = this.getParentNode(t);
    for (; n; ) {
      if (n === e) return t;
      t = n, n = this.getParentNode(t);
    }
    if (e === void 0) return t;
  }
  calculateStickyNodePosition(i, e, t) {
    let n = this.view.getRelativeTop(i);
    if (n === null && this.view.firstVisibleIndex === i && i + 1 < this.view.length) {
      const a = this.treeDelegate.getHeight(this.view.element(i)), l = this.view.getRelativeTop(i + 1);
      n = l ? l - a / this.view.renderHeight : null;
    }
    if (n === null) return e;
    const s = this.view.element(i), o = this.treeDelegate.getHeight(s), r = n * this.view.renderHeight + o;
    return e + t > r && e <= r ? r - t : e;
  }
  constrainStickyNodes(i) {
    if (i.length === 0) return [];
    const e = this.view.renderHeight * this.maxWidgetViewRatio, t = i[i.length - 1];
    if (i.length <= this.stickyScrollMaxItemCount && t.position + t.height <= e) return i;
    const n = this.stickyScrollDelegate.constrainStickyScrollNodes(i, this.stickyScrollMaxItemCount, e);
    if (!n.length) return [];
    const s = n[n.length - 1];
    if (n.length > this.stickyScrollMaxItemCount || s.position + s.height > e) throw new Error("stickyScrollDelegate violates constraints");
    return n;
  }
  getParentNode(i) {
    const e = this.model.getNodeLocation(i), t = this.model.getParentNodeLocation(e);
    return t ? this.model.getNode(t) : void 0;
  }
  nodeIsUncollapsedParent(i) {
    const e = this.model.getNodeLocation(i);
    return this.model.getListRenderCount(e) > 1;
  }
  getNodeIndex(i) {
    const e = this.model.getNodeLocation(i);
    return this.model.getListIndex(e);
  }
  getNodeRange(i) {
    const e = this.model.getNodeLocation(i), t = this.model.getListIndex(e);
    if (t < 0) throw new Error("Node not found in tree");
    return { startIndex: t, endIndex: t + this.model.getListRenderCount(e) - 1 };
  }
  nodePositionTopBelowWidget(i) {
    const e = [];
    let t = this.getParentNode(i);
    for (; t; ) e.push(t), t = this.getParentNode(t);
    let n = 0;
    for (let s = 0; s < e.length && s < this.stickyScrollMaxItemCount; s++) n += this.treeDelegate.getHeight(e[s]);
    return n;
  }
  domFocus() {
    this._widget.domFocus();
  }
  focusedLast() {
    return this._widget.focusedLast();
  }
  updateOptions(i = {}) {
    if (!i.stickyScrollMaxItemCount) return;
    const e = this.validateStickySettings(i);
    this.stickyScrollMaxItemCount !== e.stickyScrollMaxItemCount && (this.stickyScrollMaxItemCount = e.stickyScrollMaxItemCount, this.update());
  }
  validateStickySettings(i) {
    let e = 7;
    return typeof i.stickyScrollMaxItemCount == "number" && (e = Math.max(i.stickyScrollMaxItemCount, 1)), { stickyScrollMaxItemCount: e };
  }
}, Yte = class {
  constructor(i, e, t, n, s, o) {
    this.view = e, this.tree = t, this.treeRenderers = n, this.treeDelegate = s, this.accessibilityProvider = o, this._previousElements = [], this._previousStateDisposables = new G(), this._rootDomNode = Q(".monaco-tree-sticky-container.empty"), i.appendChild(this._rootDomNode);
    const r = Q(".monaco-tree-sticky-container-shadow");
    this._rootDomNode.appendChild(r), this.stickyScrollFocus = new Xte(this._rootDomNode, e), this.onDidChangeHasFocus = this.stickyScrollFocus.onDidChangeHasFocus, this.onContextMenu = this.stickyScrollFocus.onContextMenu;
  }
  get height() {
    if (!this._previousState) return 0;
    const i = this._previousState.stickyNodes[this._previousState.count - 1];
    return i.position + i.height;
  }
  setState(i) {
    const e = !!this._previousState && this._previousState.count > 0, t = !!i && i.count > 0;
    if (!e && !t || e && t && this._previousState.equal(i)) return;
    if (e !== t && this.setVisible(t), !t) return this._previousState = void 0, this._previousElements = [], void this._previousStateDisposables.clear();
    const n = i.stickyNodes[i.count - 1];
    if (this._previousState && i.animationStateChanged(this._previousState)) this._previousElements[this._previousState.count - 1].style.top = `${n.position}px`;
    else {
      this._previousStateDisposables.clear();
      const s = Array(i.count);
      for (let o = i.count - 1; o >= 0; o--) {
        const r = i.stickyNodes[o], { element: a, disposable: l } = this.createElement(r, o, i.count);
        s[o] = a, this._rootDomNode.appendChild(a), this._previousStateDisposables.add(l);
      }
      this.stickyScrollFocus.updateElements(s, i), this._previousElements = s;
    }
    this._previousState = i, this._rootDomNode.style.height = `${n.position + n.height}px`;
  }
  createElement(i, e, t) {
    const n = i.startIndex, s = document.createElement("div");
    s.style.top = `${i.position}px`, this.tree.options.setRowHeight !== !1 && (s.style.height = `${i.height}px`), this.tree.options.setRowLineHeight !== !1 && (s.style.lineHeight = `${i.height}px`), s.classList.add("monaco-tree-sticky-row"), s.classList.add("monaco-list-row"), s.setAttribute("data-index", `${n}`), s.setAttribute("data-parity", n % 2 == 0 ? "even" : "odd"), s.setAttribute("id", this.view.getElementID(n));
    const o = this.setAccessibilityAttributes(s, i.node.element, e, t), r = this.treeDelegate.getTemplateId(i.node), a = this.treeRenderers.find((c) => c.templateId === r);
    if (!a) throw new Error(`No renderer found for template id ${r}`);
    let l = i.node;
    l === this.tree.getNode(this.tree.getNodeLocation(i.node)) && (l = new Proxy(i.node, {}));
    const d = a.renderTemplate(s);
    a.renderElement(l, i.startIndex, d, i.height);
    const h = ye(() => {
      o.dispose(), a.disposeElement(l, i.startIndex, d, i.height), a.disposeTemplate(d), s.remove();
    });
    return { element: s, disposable: h };
  }
  setAccessibilityAttributes(i, e, t, n) {
    var s;
    if (!this.accessibilityProvider) return V.None;
    this.accessibilityProvider.getSetSize && i.setAttribute("aria-setsize", String(this.accessibilityProvider.getSetSize(e, t, n))), this.accessibilityProvider.getPosInSet && i.setAttribute("aria-posinset", String(this.accessibilityProvider.getPosInSet(e, t))), this.accessibilityProvider.getRole && i.setAttribute("role", (s = this.accessibilityProvider.getRole(e)) !== null && s !== void 0 ? s : "treeitem");
    const o = this.accessibilityProvider.getAriaLabel(e), r = o && typeof o != "string" ? o : ia(o), a = Ge((d) => {
      const h = d.readObservable(r);
      h ? i.setAttribute("aria-label", h) : i.removeAttribute("aria-label");
    });
    typeof o == "string" || o && i.setAttribute("aria-label", o.get());
    const l = this.accessibilityProvider.getAriaLevel && this.accessibilityProvider.getAriaLevel(e);
    return typeof l == "number" && i.setAttribute("aria-level", `${l}`), i.setAttribute("aria-selected", String(!1)), a;
  }
  setVisible(i) {
    this._rootDomNode.classList.toggle("empty", !i), i || this.stickyScrollFocus.updateElements([], void 0);
  }
  domFocus() {
    this.stickyScrollFocus.domFocus();
  }
  focusedLast() {
    return this.stickyScrollFocus.focusedLast();
  }
  dispose() {
    this.stickyScrollFocus.dispose(), this._previousStateDisposables.dispose(), this._rootDomNode.remove();
  }
};
class Xte extends V {
  get domHasFocus() {
    return this._domHasFocus;
  }
  set domHasFocus(e) {
    e !== this._domHasFocus && (this._onDidChangeHasFocus.fire(e), this._domHasFocus = e);
  }
  constructor(e, t) {
    super(), this.container = e, this.view = t, this.focusedIndex = -1, this.elements = [], this._onDidChangeHasFocus = new F(), this.onDidChangeHasFocus = this._onDidChangeHasFocus.event, this._onContextMenu = new F(), this.onContextMenu = this._onContextMenu.event, this._domHasFocus = !1, this.container.addEventListener("focus", () => this.onFocus()), this.container.addEventListener("blur", () => this.onBlur()), this._register(this.view.onDidFocus(() => this.toggleStickyScrollFocused(!1))), this._register(this.view.onKeyDown((n) => this.onKeyDown(n))), this._register(this.view.onMouseDown((n) => this.onMouseDown(n))), this._register(this.view.onContextMenu((n) => this.handleContextMenu(n)));
  }
  handleContextMenu(e) {
    const t = e.browserEvent.target;
    if (!Ov(t) && !v0(t)) return void (this.focusedLast() && this.view.domFocus());
    if (!_h(e.browserEvent)) {
      if (!this.state) throw new Error("Context menu should not be triggered when state is undefined");
      const o = this.state.stickyNodes.findIndex((r) => {
        var a;
        return r.node.element === ((a = e.element) === null || a === void 0 ? void 0 : a.element);
      });
      if (o === -1) throw new Error("Context menu should not be triggered when element is not in sticky scroll widget");
      return this.container.focus(), void this.setFocus(o);
    }
    if (!this.state || this.focusedIndex < 0) throw new Error("Context menu key should not be triggered when focus is not in sticky scroll widget");
    const n = this.state.stickyNodes[this.focusedIndex].node.element, s = this.elements[this.focusedIndex];
    this._onContextMenu.fire({ element: n, anchor: s, browserEvent: e.browserEvent, isStickyScroll: !0 });
  }
  onKeyDown(e) {
    if (this.domHasFocus && this.state) {
      if (e.key === "ArrowUp") this.setFocusedElement(Math.max(0, this.focusedIndex - 1)), e.preventDefault(), e.stopPropagation();
      else if (e.key === "ArrowDown" || e.key === "ArrowRight") {
        if (this.focusedIndex >= this.state.count - 1) {
          const t = this.state.stickyNodes[this.state.count - 1].startIndex + 1;
          this.view.domFocus(), this.view.setFocus([t]), this.scrollNodeUnderWidget(t, this.state);
        } else this.setFocusedElement(this.focusedIndex + 1);
        e.preventDefault(), e.stopPropagation();
      }
    }
  }
  onMouseDown(e) {
    const t = e.browserEvent.target;
    (Ov(t) || v0(t)) && (e.browserEvent.preventDefault(), e.browserEvent.stopPropagation());
  }
  updateElements(e, t) {
    if (t && t.count === 0) throw new Error("Sticky scroll state must be undefined when there are no sticky nodes");
    if (t && t.count !== e.length) throw new Error("Sticky scroll focus received illigel state");
    const n = this.focusedIndex;
    if (this.removeFocus(), this.elements = e, this.state = t, t) {
      const s = as(n, 0, t.count - 1);
      this.setFocus(s);
    } else this.domHasFocus && this.view.domFocus();
    this.container.tabIndex = t ? 0 : -1;
  }
  setFocusedElement(e) {
    const t = this.state;
    if (!t) throw new Error("Cannot set focus when state is undefined");
    if (this.setFocus(e), !(e < t.count - 1) && t.lastNodePartiallyVisible()) {
      const n = t.stickyNodes[e];
      this.scrollNodeUnderWidget(n.endIndex + 1, t);
    }
  }
  scrollNodeUnderWidget(e, t) {
    const n = t.stickyNodes[t.count - 1], s = t.count > 1 ? t.stickyNodes[t.count - 2] : void 0, o = this.view.getElementTop(e), r = s ? s.position + s.height + n.height : n.height;
    this.view.scrollTop = o - r;
  }
  domFocus() {
    if (!this.state) throw new Error("Cannot focus when state is undefined");
    this.container.focus();
  }
  focusedLast() {
    return !!this.state && this.view.getHTMLElement().classList.contains("sticky-scroll-focused");
  }
  removeFocus() {
    this.focusedIndex !== -1 && (this.toggleElementFocus(this.elements[this.focusedIndex], !1), this.focusedIndex = -1);
  }
  setFocus(e) {
    if (0 > e) throw new Error("addFocus() can not remove focus");
    if (!this.state && e >= 0) throw new Error("Cannot set focus index when state is undefined");
    if (this.state && e >= this.state.count) throw new Error("Cannot set focus index to an index that does not exist");
    const t = this.focusedIndex;
    t >= 0 && this.toggleElementFocus(this.elements[t], !1), e >= 0 && this.toggleElementFocus(this.elements[e], !0), this.focusedIndex = e;
  }
  toggleElementFocus(e, t) {
    this.toggleElementActiveFocus(e, t && this.domHasFocus), this.toggleElementPassiveFocus(e, t);
  }
  toggleCurrentElementActiveFocus(e) {
    this.focusedIndex !== -1 && this.toggleElementActiveFocus(this.elements[this.focusedIndex], e);
  }
  toggleElementActiveFocus(e, t) {
    e.classList.toggle("focused", t);
  }
  toggleElementPassiveFocus(e, t) {
    e.classList.toggle("passive-focused", t);
  }
  toggleStickyScrollFocused(e) {
    this.view.getHTMLElement().classList.toggle("sticky-scroll-focused", e);
  }
  onFocus() {
    if (!this.state || this.elements.length === 0) throw new Error("Cannot focus when state is undefined or elements are empty");
    this.domHasFocus = !0, this.toggleStickyScrollFocused(!0), this.toggleCurrentElementActiveFocus(!0), this.focusedIndex === -1 && this.setFocus(0);
  }
  onBlur() {
    this.domHasFocus = !1, this.toggleCurrentElementActiveFocus(!1);
  }
  dispose() {
    this.toggleStickyScrollFocused(!1), this._onDidChangeHasFocus.fire(!1), super.dispose();
  }
}
function zb(i) {
  let e = Pu.Unknown;
  return Gk(i.browserEvent.target, "monaco-tl-twistie", "monaco-tl-row") ? e = Pu.Twistie : Gk(i.browserEvent.target, "monaco-tl-contents", "monaco-tl-row") ? e = Pu.Element : Gk(i.browserEvent.target, "monaco-tree-type-filter", "monaco-list") && (e = Pu.Filter), { browserEvent: i.browserEvent, element: i.element ? i.element.element : null, target: e };
}
function Qte(i) {
  const e = Ov(i.browserEvent.target);
  return { element: i.element ? i.element.element : null, browserEvent: i.browserEvent, anchor: i.anchor, isStickyScroll: e };
}
function XC(i, e) {
  e(i), i.children.forEach((t) => XC(t, e));
}
class sx {
  get nodeSet() {
    return this._nodeSet || (this._nodeSet = this.createNodeSet()), this._nodeSet;
  }
  constructor(e, t) {
    this.getFirstViewElementWithTrait = e, this.identityProvider = t, this.nodes = [], this._onDidChange = new F(), this.onDidChange = this._onDidChange.event;
  }
  set(e, t) {
    !(t != null && t.__forceEvent) && ri(this.nodes, e) || this._set(e, !1, t);
  }
  _set(e, t, n) {
    if (this.nodes = [...e], this.elements = void 0, this._nodeSet = void 0, !t) {
      const s = this;
      this._onDidChange.fire({ get elements() {
        return s.get();
      }, browserEvent: n });
    }
  }
  get() {
    return this.elements || (this.elements = this.nodes.map((e) => e.element)), [...this.elements];
  }
  getNodes() {
    return this.nodes;
  }
  has(e) {
    return this.nodeSet.has(e);
  }
  onDidModelSplice({ insertedNodes: e, deletedNodes: t }) {
    if (!this.identityProvider) {
      const l = this.createNodeSet(), d = (h) => l.delete(h);
      return t.forEach((h) => XC(h, d)), void this.set([...l.values()]);
    }
    const n = /* @__PURE__ */ new Set(), s = (l) => n.add(this.identityProvider.getId(l.element).toString());
    t.forEach((l) => XC(l, s));
    const o = /* @__PURE__ */ new Map(), r = (l) => o.set(this.identityProvider.getId(l.element).toString(), l);
    e.forEach((l) => XC(l, r));
    const a = [];
    for (const l of this.nodes) {
      const d = this.identityProvider.getId(l.element).toString();
      if (n.has(d)) {
        const h = o.get(d);
        h && h.visible && a.push(h);
      } else a.push(l);
    }
    if (this.nodes.length > 0 && a.length === 0) {
      const l = this.getFirstViewElementWithTrait();
      l && a.push(l);
    }
    this._set(a, !0);
  }
  createNodeSet() {
    const e = /* @__PURE__ */ new Set();
    for (const t of this.nodes) e.add(t);
    return e;
  }
}
class Jte extends ZW {
  constructor(e, t, n) {
    super(e), this.tree = t, this.stickyScrollProvider = n;
  }
  onViewPointer(e) {
    if (jW(e.browserEvent.target) || sc(e.browserEvent.target) || M_(e.browserEvent.target) || e.browserEvent.isHandledByList) return;
    const t = e.element;
    if (!t) return super.onViewPointer(e);
    if (this.isSelectionRangeChangeEvent(e) || this.isSelectionSingleChangeEvent(e)) return super.onViewPointer(e);
    const n = e.browserEvent.target, s = n.classList.contains("monaco-tl-twistie") || n.classList.contains("monaco-icon-label") && n.classList.contains("folder-icon") && e.browserEvent.offsetX < 16, o = v0(e.browserEvent.target);
    let r = !1;
    if (r = !!o || (typeof this.tree.expandOnlyOnTwistieClick == "function" ? this.tree.expandOnlyOnTwistieClick(t.element) : !!this.tree.expandOnlyOnTwistieClick), o) this.handleStickyScrollMouseEvent(e, t);
    else {
      if (r && !s && e.browserEvent.detail !== 2) return super.onViewPointer(e);
      if (!this.tree.expandOnDoubleClick && e.browserEvent.detail === 2) return super.onViewPointer(e);
    }
    if (t.collapsible && (!o || s)) {
      const a = this.tree.getNodeLocation(t), l = e.browserEvent.altKey;
      if (this.tree.setFocus([a]), this.tree.toggleCollapsed(a, l), r && s) return void (e.browserEvent.isHandledByList = !0);
    }
    o || super.onViewPointer(e);
  }
  handleStickyScrollMouseEvent(e, t) {
    if (function(a) {
      return Pv(a, "monaco-custom-toggle");
    }(e.browserEvent.target) || function(a) {
      return Pv(a, "action-item");
    }(e.browserEvent.target)) return;
    const n = this.stickyScrollProvider();
    if (!n) throw new Error("Sticky scroll controller not found");
    const s = this.list.indexOf(t), o = this.list.getElementTop(s), r = n.nodePositionTopBelowWidget(t);
    this.tree.scrollTop = o - r, this.list.domFocus(), this.list.setFocus([s]), this.list.setSelection([s]);
  }
  onDoubleClick(e) {
    !e.browserEvent.target.classList.contains("monaco-tl-twistie") && this.tree.expandOnDoubleClick && (e.browserEvent.isHandledByList || super.onDoubleClick(e));
  }
  onMouseDown(e) {
    const t = e.browserEvent.target;
    Ov(t) || v0(t) || super.onMouseDown(e);
  }
  onContextMenu(e) {
    const t = e.browserEvent.target;
    Ov(t) || v0(t) || super.onContextMenu(e);
  }
}
class eie extends uo {
  constructor(e, t, n, s, o, r, a, l) {
    super(e, t, n, s, l), this.focusTrait = o, this.selectionTrait = r, this.anchorTrait = a;
  }
  createMouseController(e) {
    return new Jte(this, e.tree, e.stickyScrollProvider);
  }
  splice(e, t, n = []) {
    if (super.splice(e, t, n), n.length === 0) return;
    const s = [], o = [];
    let r;
    n.forEach((a, l) => {
      this.focusTrait.has(a) && s.push(e + l), this.selectionTrait.has(a) && o.push(e + l), this.anchorTrait.has(a) && (r = e + l);
    }), s.length > 0 && super.setFocus(Ad([...super.getFocus(), ...s])), o.length > 0 && super.setSelection(Ad([...super.getSelection(), ...o])), typeof r == "number" && super.setAnchor(r);
  }
  setFocus(e, t, n = !1) {
    super.setFocus(e, t), n || this.focusTrait.set(e.map((s) => this.element(s)), t);
  }
  setSelection(e, t, n = !1) {
    super.setSelection(e, t), n || this.selectionTrait.set(e.map((s) => this.element(s)), t);
  }
  setAnchor(e, t = !1) {
    super.setAnchor(e), t || (e === void 0 ? this.anchorTrait.set([]) : this.anchorTrait.set([this.element(e)]));
  }
}
class cV {
  get onDidScroll() {
    return this.view.onDidScroll;
  }
  get onDidChangeFocus() {
    return this.eventBufferer.wrapEvent(this.focus.onDidChange);
  }
  get onDidChangeSelection() {
    return this.eventBufferer.wrapEvent(this.selection.onDidChange);
  }
  get onMouseDblClick() {
    return se.filter(se.map(this.view.onMouseDblClick, zb), (e) => e.target !== Pu.Filter);
  }
  get onMouseOver() {
    return se.map(this.view.onMouseOver, zb);
  }
  get onMouseOut() {
    return se.map(this.view.onMouseOut, zb);
  }
  get onContextMenu() {
    var e, t;
    return se.any(se.filter(se.map(this.view.onContextMenu, Qte), (n) => !n.isStickyScroll), (t = (e = this.stickyScrollController) === null || e === void 0 ? void 0 : e.onContextMenu) !== null && t !== void 0 ? t : se.None);
  }
  get onPointer() {
    return se.map(this.view.onPointer, zb);
  }
  get onKeyDown() {
    return this.view.onKeyDown;
  }
  get onDidFocus() {
    return this.view.onDidFocus;
  }
  get onDidChangeModel() {
    return se.signal(this.model.onDidSplice);
  }
  get onDidChangeCollapseState() {
    return this.model.onDidChangeCollapseState;
  }
  get findMode() {
    var e, t;
    return (t = (e = this.findController) === null || e === void 0 ? void 0 : e.mode) !== null && t !== void 0 ? t : Cd.Highlight;
  }
  set findMode(e) {
    this.findController && (this.findController.mode = e);
  }
  get findMatchType() {
    var e, t;
    return (t = (e = this.findController) === null || e === void 0 ? void 0 : e.matchType) !== null && t !== void 0 ? t : fg.Fuzzy;
  }
  set findMatchType(e) {
    this.findController && (this.findController.matchType = e);
  }
  get expandOnDoubleClick() {
    return this._options.expandOnDoubleClick === void 0 || this._options.expandOnDoubleClick;
  }
  get expandOnlyOnTwistieClick() {
    return this._options.expandOnlyOnTwistieClick === void 0 || this._options.expandOnlyOnTwistieClick;
  }
  get onDidDispose() {
    return this.view.onDidDispose;
  }
  constructor(e, t, n, s, o = {}) {
    var r;
    this._user = e, this._options = o, this.eventBufferer = new eR(), this.onDidChangeFindOpenState = se.None, this.onDidChangeStickyScrollFocused = se.None, this.disposables = new G(), this._onWillRefilter = new F(), this.onWillRefilter = this._onWillRefilter.event, this._onDidUpdateOptions = new F(), this.treeDelegate = new TA(n);
    const a = new sO(), l = new sO(), d = this.disposables.add(new Kte(l.event)), h = new yR();
    this.renderers = s.map((v) => new Vv(v, () => this.model, a.event, d, h, o));
    for (const v of this.renderers) this.disposables.add(v);
    let c;
    var u, g;
    o.keyboardNavigationLabelProvider && (c = new jte(this, o.keyboardNavigationLabelProvider, o.filter), o = { ...o, filter: c }, this.disposables.add(c)), this.focus = new sx(() => this.view.getFocusedElements()[0], o.identityProvider), this.selection = new sx(() => this.view.getSelectedElements()[0], o.identityProvider), this.anchor = new sx(() => this.view.getAnchorElement(), o.identityProvider), this.view = new eie(e, t, this.treeDelegate, this.renderers, this.focus, this.selection, this.anchor, { ...(u = () => this.model, g = o, g && { ...g, identityProvider: g.identityProvider && { getId: (v) => g.identityProvider.getId(v.element) }, dnd: g.dnd && new Ute(u, g.dnd), multipleSelectionController: g.multipleSelectionController && { isSelectionSingleChangeEvent: (v) => g.multipleSelectionController.isSelectionSingleChangeEvent({ ...v, element: v.element }), isSelectionRangeChangeEvent: (v) => g.multipleSelectionController.isSelectionRangeChangeEvent({ ...v, element: v.element }) }, accessibilityProvider: g.accessibilityProvider && { ...g.accessibilityProvider, getSetSize(v) {
      const b = u(), C = b.getNodeLocation(v), w = b.getParentNodeLocation(C);
      return b.getNode(w).visibleChildrenCount;
    }, getPosInSet: (v) => v.visibleChildIndex + 1, isChecked: g.accessibilityProvider && g.accessibilityProvider.isChecked ? (v) => g.accessibilityProvider.isChecked(v.element) : void 0, getRole: g.accessibilityProvider && g.accessibilityProvider.getRole ? (v) => g.accessibilityProvider.getRole(v.element) : () => "treeitem", getAriaLabel: (v) => g.accessibilityProvider.getAriaLabel(v.element), getWidgetAriaLabel: () => g.accessibilityProvider.getWidgetAriaLabel(), getWidgetRole: g.accessibilityProvider && g.accessibilityProvider.getWidgetRole ? () => g.accessibilityProvider.getWidgetRole() : () => "tree", getAriaLevel: g.accessibilityProvider && g.accessibilityProvider.getAriaLevel ? (v) => g.accessibilityProvider.getAriaLevel(v.element) : (v) => v.depth, getActiveDescendantId: g.accessibilityProvider.getActiveDescendantId && ((v) => g.accessibilityProvider.getActiveDescendantId(v.element)) }, keyboardNavigationLabelProvider: g.keyboardNavigationLabelProvider && { ...g.keyboardNavigationLabelProvider, getKeyboardNavigationLabel: (v) => g.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(v.element) } }), tree: this, stickyScrollProvider: () => this.stickyScrollController }), this.model = this.createModel(e, this.view, o), a.input = this.model.onDidChangeCollapseState;
    const p = se.forEach(this.model.onDidSplice, (v) => {
      this.eventBufferer.bufferEvents(() => {
        this.focus.onDidModelSplice(v), this.selection.onDidModelSplice(v);
      });
    }, this.disposables);
    p(() => null, null, this.disposables);
    const f = this.disposables.add(new F()), _ = this.disposables.add(new Sr(0));
    if (this.disposables.add(se.any(p, this.focus.onDidChange, this.selection.onDidChange)(() => {
      _.trigger(() => {
        const v = /* @__PURE__ */ new Set();
        for (const b of this.focus.getNodes()) v.add(b);
        for (const b of this.selection.getNodes()) v.add(b);
        f.fire([...v.values()]);
      });
    })), l.input = f.event, o.keyboardSupport !== !1) {
      const v = se.chain(this.view.onKeyDown, (b) => b.filter((C) => !sc(C.target)).map((C) => new jt(C)));
      se.chain(v, (b) => b.filter((C) => C.keyCode === 15))(this.onLeftArrow, this, this.disposables), se.chain(v, (b) => b.filter((C) => C.keyCode === 17))(this.onRightArrow, this, this.disposables), se.chain(v, (b) => b.filter((C) => C.keyCode === 10))(this.onSpace, this, this.disposables);
    }
    if (((r = o.findWidgetEnabled) === null || r === void 0 || r) && o.keyboardNavigationLabelProvider && o.contextViewProvider) {
      const v = this.options.findWidgetStyles ? { styles: this.options.findWidgetStyles } : void 0;
      this.findController = new qte(this, this.model, this.view, c, o.contextViewProvider, v), this.focusNavigationFilter = (b) => this.findController.shouldAllowFocus(b), this.onDidChangeFindOpenState = this.findController.onDidChangeOpenState, this.disposables.add(this.findController), this.onDidChangeFindMode = this.findController.onDidChangeMode, this.onDidChangeFindMatchType = this.findController.onDidChangeMatchType;
    } else this.onDidChangeFindMode = se.None, this.onDidChangeFindMatchType = se.None;
    o.enableStickyScroll && (this.stickyScrollController = new Y3(this, this.model, this.view, this.renderers, this.treeDelegate, o), this.onDidChangeStickyScrollFocused = this.stickyScrollController.onDidChangeHasFocus), this.styleElement = Lo(this.view.getHTMLElement()), this.getHTMLElement().classList.toggle("always", this._options.renderIndentGuides === sf.Always);
  }
  updateOptions(e = {}) {
    var t;
    this._options = { ...this._options, ...e };
    for (const n of this.renderers) n.updateOptions(e);
    this.view.updateOptions(this._options), (t = this.findController) === null || t === void 0 || t.updateOptions(e), this.updateStickyScroll(e), this._onDidUpdateOptions.fire(this._options), this.getHTMLElement().classList.toggle("always", this._options.renderIndentGuides === sf.Always);
  }
  get options() {
    return this._options;
  }
  updateStickyScroll(e) {
    var t;
    !this.stickyScrollController && this._options.enableStickyScroll ? (this.stickyScrollController = new Y3(this, this.model, this.view, this.renderers, this.treeDelegate, this._options), this.onDidChangeStickyScrollFocused = this.stickyScrollController.onDidChangeHasFocus) : this.stickyScrollController && !this._options.enableStickyScroll && (this.onDidChangeStickyScrollFocused = se.None, this.stickyScrollController.dispose(), this.stickyScrollController = void 0), (t = this.stickyScrollController) === null || t === void 0 || t.updateOptions(e);
  }
  getHTMLElement() {
    return this.view.getHTMLElement();
  }
  get scrollTop() {
    return this.view.scrollTop;
  }
  set scrollTop(e) {
    this.view.scrollTop = e;
  }
  get scrollHeight() {
    return this.view.scrollHeight;
  }
  get renderHeight() {
    return this.view.renderHeight;
  }
  get ariaLabel() {
    return this.view.ariaLabel;
  }
  set ariaLabel(e) {
    this.view.ariaLabel = e;
  }
  domFocus() {
    var e;
    !((e = this.stickyScrollController) === null || e === void 0) && e.focusedLast() ? this.stickyScrollController.domFocus() : this.view.domFocus();
  }
  layout(e, t) {
    var n;
    this.view.layout(e, t), gc(t) && ((n = this.findController) === null || n === void 0 || n.layout(t));
  }
  style(e) {
    var t;
    const n = `.${this.view.domId}`, s = [];
    e.treeIndentGuidesStroke && (s.push(`.monaco-list${n}:hover .monaco-tl-indent > .indent-guide, .monaco-list${n}.always .monaco-tl-indent > .indent-guide  { border-color: ${e.treeInactiveIndentGuidesStroke}; }`), s.push(`.monaco-list${n} .monaco-tl-indent > .indent-guide.active { border-color: ${e.treeIndentGuidesStroke}; }`)), e.listBackground && (s.push(`.monaco-list${n} .monaco-scrollable-element .monaco-tree-sticky-container { background-color: ${e.listBackground}; }`), s.push(`.monaco-list${n} .monaco-scrollable-element .monaco-tree-sticky-container .monaco-tree-sticky-row { background-color: ${e.listBackground}; }`)), e.listFocusForeground && (s.push(`.monaco-list${n}.sticky-scroll-focused .monaco-scrollable-element .monaco-tree-sticky-container:focus .monaco-list-row.focused { color: ${e.listFocusForeground}; }`), s.push(`.monaco-list${n}:not(.sticky-scroll-focused) .monaco-scrollable-element .monaco-tree-sticky-container .monaco-list-row.focused { color: inherit; }`));
    const o = kd(e.listFocusAndSelectionOutline, kd(e.listSelectionOutline, (t = e.listFocusOutline) !== null && t !== void 0 ? t : ""));
    o && (s.push(`.monaco-list${n}.sticky-scroll-focused .monaco-scrollable-element .monaco-tree-sticky-container:focus .monaco-list-row.focused.selected { outline: 1px solid ${o}; outline-offset: -1px;}`), s.push(`.monaco-list${n}:not(.sticky-scroll-focused) .monaco-scrollable-element .monaco-tree-sticky-container .monaco-list-row.focused.selected { outline: inherit;}`)), e.listFocusOutline && (s.push(`.monaco-list${n}.sticky-scroll-focused .monaco-scrollable-element .monaco-tree-sticky-container:focus .monaco-list-row.focused { outline: 1px solid ${e.listFocusOutline}; outline-offset: -1px; }`), s.push(`.monaco-list${n}:not(.sticky-scroll-focused) .monaco-scrollable-element .monaco-tree-sticky-container .monaco-list-row.focused { outline: inherit; }`), s.push(`.monaco-workbench.context-menu-visible .monaco-list${n}.last-focused.sticky-scroll-focused .monaco-scrollable-element .monaco-tree-sticky-container .monaco-list-row.passive-focused { outline: 1px solid ${e.listFocusOutline}; outline-offset: -1px; }`), s.push(`.monaco-workbench.context-menu-visible .monaco-list${n}.last-focused.sticky-scroll-focused .monaco-list-rows .monaco-list-row.focused { outline: inherit; }`), s.push(`.monaco-workbench.context-menu-visible .monaco-list${n}.last-focused:not(.sticky-scroll-focused) .monaco-tree-sticky-container .monaco-list-rows .monaco-list-row.focused { outline: inherit; }`)), this.styleElement.textContent = s.join(`
`), this.view.style(e);
  }
  getParentElement(e) {
    const t = this.model.getParentNodeLocation(e);
    return this.model.getNode(t).element;
  }
  getFirstElementChild(e) {
    return this.model.getFirstElementChild(e);
  }
  getNode(e) {
    return this.model.getNode(e);
  }
  getNodeLocation(e) {
    return this.model.getNodeLocation(e);
  }
  collapse(e, t = !1) {
    return this.model.setCollapsed(e, !0, t);
  }
  expand(e, t = !1) {
    return this.model.setCollapsed(e, !1, t);
  }
  toggleCollapsed(e, t = !1) {
    return this.model.setCollapsed(e, void 0, t);
  }
  isCollapsible(e) {
    return this.model.isCollapsible(e);
  }
  setCollapsible(e, t) {
    return this.model.setCollapsible(e, t);
  }
  isCollapsed(e) {
    return this.model.isCollapsed(e);
  }
  refilter() {
    this._onWillRefilter.fire(void 0), this.model.refilter();
  }
  setSelection(e, t) {
    this.eventBufferer.bufferEvents(() => {
      const n = e.map((o) => this.model.getNode(o));
      this.selection.set(n, t);
      const s = e.map((o) => this.model.getListIndex(o)).filter((o) => o > -1);
      this.view.setSelection(s, t, !0);
    });
  }
  getSelection() {
    return this.selection.get();
  }
  setFocus(e, t) {
    this.eventBufferer.bufferEvents(() => {
      const n = e.map((o) => this.model.getNode(o));
      this.focus.set(n, t);
      const s = e.map((o) => this.model.getListIndex(o)).filter((o) => o > -1);
      this.view.setFocus(s, t, !0);
    });
  }
  focusNext(e = 1, t = !1, n, s = _h(n) && n.altKey ? void 0 : this.focusNavigationFilter) {
    this.view.focusNext(e, t, n, s);
  }
  focusPrevious(e = 1, t = !1, n, s = _h(n) && n.altKey ? void 0 : this.focusNavigationFilter) {
    this.view.focusPrevious(e, t, n, s);
  }
  focusNextPage(e, t = _h(e) && e.altKey ? void 0 : this.focusNavigationFilter) {
    return this.view.focusNextPage(e, t);
  }
  focusPreviousPage(e, t = _h(e) && e.altKey ? void 0 : this.focusNavigationFilter) {
    return this.view.focusPreviousPage(e, t, () => {
      var n, s;
      return (s = (n = this.stickyScrollController) === null || n === void 0 ? void 0 : n.height) !== null && s !== void 0 ? s : 0;
    });
  }
  focusFirst(e, t = _h(e) && e.altKey ? void 0 : this.focusNavigationFilter) {
    this.view.focusFirst(e, t);
  }
  getFocus() {
    return this.focus.get();
  }
  reveal(e, t) {
    this.model.expandTo(e);
    const n = this.model.getListIndex(e);
    if (n !== -1) if (this.stickyScrollController) {
      const s = this.stickyScrollController.nodePositionTopBelowWidget(this.getNode(e));
      this.view.reveal(n, t, s);
    } else this.view.reveal(n, t);
  }
  onLeftArrow(e) {
    e.preventDefault(), e.stopPropagation();
    const t = this.view.getFocusedElements();
    if (t.length === 0) return;
    const n = t[0], s = this.model.getNodeLocation(n);
    if (!this.model.setCollapsed(s, !0)) {
      const o = this.model.getParentNodeLocation(s);
      if (!o) return;
      const r = this.model.getListIndex(o);
      this.view.reveal(r), this.view.setFocus([r]);
    }
  }
  onRightArrow(e) {
    e.preventDefault(), e.stopPropagation();
    const t = this.view.getFocusedElements();
    if (t.length === 0) return;
    const n = t[0], s = this.model.getNodeLocation(n);
    if (!this.model.setCollapsed(s, !1)) {
      if (!n.children.some((a) => a.visible)) return;
      const [o] = this.view.getFocus(), r = o + 1;
      this.view.reveal(r), this.view.setFocus([r]);
    }
  }
  onSpace(e) {
    e.preventDefault(), e.stopPropagation();
    const t = this.view.getFocusedElements();
    if (t.length === 0) return;
    const n = t[0], s = this.model.getNodeLocation(n), o = e.browserEvent.altKey;
    this.model.setCollapsed(s, void 0, o);
  }
  dispose() {
    var e;
    Ht(this.disposables), (e = this.stickyScrollController) === null || e === void 0 || e.dispose(), this.view.dispose();
  }
}
class RA {
  constructor(e, t, n = {}) {
    this.user = e, this.rootRef = null, this.nodes = /* @__PURE__ */ new Map(), this.nodesByIdentity = /* @__PURE__ */ new Map(), this.model = new Hte(e, t, null, n), this.onDidSplice = this.model.onDidSplice, this.onDidChangeCollapseState = this.model.onDidChangeCollapseState, this.onDidChangeRenderNodeCount = this.model.onDidChangeRenderNodeCount, n.sorter && (this.sorter = { compare: (s, o) => n.sorter.compare(s.element, o.element) }), this.identityProvider = n.identityProvider;
  }
  setChildren(e, t = at.empty(), n = {}) {
    const s = this.getElementLocation(e);
    this._setChildren(s, this.preserveCollapseState(t), n);
  }
  _setChildren(e, t = at.empty(), n) {
    const s = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Set();
    this.model.splice([...e, 0], Number.MAX_VALUE, t, { ...n, onDidCreateNode: (r) => {
      var a;
      if (r.element === null) return;
      const l = r;
      if (s.add(l.element), this.nodes.set(l.element, l), this.identityProvider) {
        const d = this.identityProvider.getId(l.element).toString();
        o.add(d), this.nodesByIdentity.set(d, l);
      }
      (a = n.onDidCreateNode) === null || a === void 0 || a.call(n, l);
    }, onDidDeleteNode: (r) => {
      var a;
      if (r.element === null) return;
      const l = r;
      if (s.has(l.element) || this.nodes.delete(l.element), this.identityProvider) {
        const d = this.identityProvider.getId(l.element).toString();
        o.has(d) || this.nodesByIdentity.delete(d);
      }
      (a = n.onDidDeleteNode) === null || a === void 0 || a.call(n, l);
    } });
  }
  preserveCollapseState(e = at.empty()) {
    return this.sorter && (e = [...e].sort(this.sorter.compare.bind(this.sorter))), at.map(e, (t) => {
      let n = this.nodes.get(t.element);
      if (!n && this.identityProvider) {
        const r = this.identityProvider.getId(t.element).toString();
        n = this.nodesByIdentity.get(r);
      }
      if (!n) {
        let r;
        return r = t.collapsed === void 0 ? void 0 : t.collapsed === co.Collapsed || t.collapsed === co.PreserveOrCollapsed || t.collapsed !== co.Expanded && t.collapsed !== co.PreserveOrExpanded && !!t.collapsed, { ...t, children: this.preserveCollapseState(t.children), collapsed: r };
      }
      const s = typeof t.collapsible == "boolean" ? t.collapsible : n.collapsible;
      let o;
      return o = t.collapsed === void 0 || t.collapsed === co.PreserveOrCollapsed || t.collapsed === co.PreserveOrExpanded ? n.collapsed : t.collapsed === co.Collapsed || t.collapsed !== co.Expanded && !!t.collapsed, { ...t, collapsible: s, collapsed: o, children: this.preserveCollapseState(t.children) };
    });
  }
  rerender(e) {
    const t = this.getElementLocation(e);
    this.model.rerender(t);
  }
  getFirstElementChild(e = null) {
    const t = this.getElementLocation(e);
    return this.model.getFirstElementChild(t);
  }
  has(e) {
    return this.nodes.has(e);
  }
  getListIndex(e) {
    const t = this.getElementLocation(e);
    return this.model.getListIndex(t);
  }
  getListRenderCount(e) {
    const t = this.getElementLocation(e);
    return this.model.getListRenderCount(t);
  }
  isCollapsible(e) {
    const t = this.getElementLocation(e);
    return this.model.isCollapsible(t);
  }
  setCollapsible(e, t) {
    const n = this.getElementLocation(e);
    return this.model.setCollapsible(n, t);
  }
  isCollapsed(e) {
    const t = this.getElementLocation(e);
    return this.model.isCollapsed(t);
  }
  setCollapsed(e, t, n) {
    const s = this.getElementLocation(e);
    return this.model.setCollapsed(s, t, n);
  }
  expandTo(e) {
    const t = this.getElementLocation(e);
    this.model.expandTo(t);
  }
  refilter() {
    this.model.refilter();
  }
  getNode(e = null) {
    if (e === null) return this.model.getNode(this.model.rootRef);
    const t = this.nodes.get(e);
    if (!t) throw new _o(this.user, `Tree element not found: ${e}`);
    return t;
  }
  getNodeLocation(e) {
    return e.element;
  }
  getParentNodeLocation(e) {
    if (e === null) throw new _o(this.user, "Invalid getParentNodeLocation call");
    const t = this.nodes.get(e);
    if (!t) throw new _o(this.user, `Tree element not found: ${e}`);
    const n = this.model.getNodeLocation(t), s = this.model.getParentNodeLocation(n);
    return this.model.getNode(s).element;
  }
  getElementLocation(e) {
    if (e === null) return [];
    const t = this.nodes.get(e);
    if (!t) throw new _o(this.user, `Tree element not found: ${e}`);
    return this.model.getNodeLocation(t);
  }
}
function QC(i) {
  return { element: { elements: [i.element], incompressible: i.incompressible || !1 }, children: at.map(at.from(i.children), QC), collapsible: i.collapsible, collapsed: i.collapsed };
}
function JC(i) {
  const e = [i.element], t = i.incompressible || !1;
  let n, s;
  for (; [s, n] = at.consume(at.from(i.children), 2), s.length === 1 && !s[0].incompressible; ) i = s[0], e.push(i.element);
  return { element: { elements: e, incompressible: t }, children: at.map(at.concat(s, n), JC), collapsible: i.collapsible, collapsed: i.collapsed };
}
function d2(i, e = 0) {
  let t;
  return t = e < i.element.elements.length - 1 ? [d2(i, e + 1)] : at.map(at.from(i.children), (n) => d2(n, 0)), e === 0 && i.element.incompressible ? { element: i.element.elements[e], children: t, incompressible: !0, collapsible: i.collapsible, collapsed: i.collapsed } : { element: i.element.elements[e], children: t, collapsible: i.collapsible, collapsed: i.collapsed };
}
function X3(i) {
  return d2(i, 0);
}
function uV(i, e, t) {
  return i.element === e ? { ...i, children: t } : { ...i, children: at.map(at.from(i.children), (n) => uV(n, e, t)) };
}
class tie {
  get onDidSplice() {
    return this.model.onDidSplice;
  }
  get onDidChangeCollapseState() {
    return this.model.onDidChangeCollapseState;
  }
  get onDidChangeRenderNodeCount() {
    return this.model.onDidChangeRenderNodeCount;
  }
  constructor(e, t, n = {}) {
    this.user = e, this.rootRef = null, this.nodes = /* @__PURE__ */ new Map(), this.model = new RA(e, t, n), this.enabled = n.compressionEnabled === void 0 || n.compressionEnabled, this.identityProvider = n.identityProvider;
  }
  setChildren(e, t = at.empty(), n) {
    const s = n.diffIdentityProvider && (o = n.diffIdentityProvider, { getId: (p) => p.elements.map((f) => o.getId(f).toString()).join("\0") });
    var o;
    if (e === null) {
      const p = at.map(t, this.enabled ? JC : QC);
      return void this._setChildren(null, p, { diffIdentityProvider: s, diffDepth: 1 / 0 });
    }
    const r = this.nodes.get(e);
    if (!r) throw new _o(this.user, "Unknown compressed tree node");
    const a = this.model.getNode(r), l = this.model.getParentNodeLocation(r), d = this.model.getNode(l), h = uV(X3(a), e, t), c = (this.enabled ? JC : QC)(h), u = n.diffIdentityProvider ? (p, f) => n.diffIdentityProvider.getId(p) === n.diffIdentityProvider.getId(f) : void 0;
    if (ri(c.element.elements, a.element.elements, u)) return void this._setChildren(r, c.children || at.empty(), { diffIdentityProvider: s, diffDepth: 1 });
    const g = d.children.map((p) => p === a ? c : p);
    this._setChildren(d.element, g, { diffIdentityProvider: s, diffDepth: a.depth - d.depth });
  }
  isCompressionEnabled() {
    return this.enabled;
  }
  setCompressionEnabled(e) {
    if (e === this.enabled) return;
    this.enabled = e;
    const t = this.model.getNode().children, n = at.map(t, X3), s = at.map(n, e ? JC : QC);
    this._setChildren(null, s, { diffIdentityProvider: this.identityProvider, diffDepth: 1 / 0 });
  }
  _setChildren(e, t, n) {
    const s = /* @__PURE__ */ new Set();
    this.model.setChildren(e, t, { ...n, onDidCreateNode: (o) => {
      for (const r of o.element.elements) s.add(r), this.nodes.set(r, o.element);
    }, onDidDeleteNode: (o) => {
      for (const r of o.element.elements) s.has(r) || this.nodes.delete(r);
    } });
  }
  has(e) {
    return this.nodes.has(e);
  }
  getListIndex(e) {
    const t = this.getCompressedNode(e);
    return this.model.getListIndex(t);
  }
  getListRenderCount(e) {
    const t = this.getCompressedNode(e);
    return this.model.getListRenderCount(t);
  }
  getNode(e) {
    if (e === void 0) return this.model.getNode();
    const t = this.getCompressedNode(e);
    return this.model.getNode(t);
  }
  getNodeLocation(e) {
    const t = this.model.getNodeLocation(e);
    return t === null ? null : t.elements[t.elements.length - 1];
  }
  getParentNodeLocation(e) {
    const t = this.getCompressedNode(e), n = this.model.getParentNodeLocation(t);
    return n === null ? null : n.elements[n.elements.length - 1];
  }
  getFirstElementChild(e) {
    const t = this.getCompressedNode(e);
    return this.model.getFirstElementChild(t);
  }
  isCollapsible(e) {
    const t = this.getCompressedNode(e);
    return this.model.isCollapsible(t);
  }
  setCollapsible(e, t) {
    const n = this.getCompressedNode(e);
    return this.model.setCollapsible(n, t);
  }
  isCollapsed(e) {
    const t = this.getCompressedNode(e);
    return this.model.isCollapsed(t);
  }
  setCollapsed(e, t, n) {
    const s = this.getCompressedNode(e);
    return this.model.setCollapsed(s, t, n);
  }
  expandTo(e) {
    const t = this.getCompressedNode(e);
    this.model.expandTo(t);
  }
  rerender(e) {
    const t = this.getCompressedNode(e);
    this.model.rerender(t);
  }
  refilter() {
    this.model.refilter();
  }
  getCompressedNode(e) {
    if (e === null) return null;
    const t = this.nodes.get(e);
    if (!t) throw new _o(this.user, `Tree element not found: ${e}`);
    return t;
  }
}
const iie = (i) => i[i.length - 1];
class AA {
  get element() {
    return this.node.element === null ? null : this.unwrapper(this.node.element);
  }
  get children() {
    return this.node.children.map((e) => new AA(this.unwrapper, e));
  }
  get depth() {
    return this.node.depth;
  }
  get visibleChildrenCount() {
    return this.node.visibleChildrenCount;
  }
  get visibleChildIndex() {
    return this.node.visibleChildIndex;
  }
  get collapsible() {
    return this.node.collapsible;
  }
  get collapsed() {
    return this.node.collapsed;
  }
  get visible() {
    return this.node.visible;
  }
  get filterData() {
    return this.node.filterData;
  }
  constructor(e, t) {
    this.unwrapper = e, this.node = t;
  }
}
class nie {
  get onDidSplice() {
    return se.map(this.model.onDidSplice, ({ insertedNodes: e, deletedNodes: t }) => ({ insertedNodes: e.map((n) => this.nodeMapper.map(n)), deletedNodes: t.map((n) => this.nodeMapper.map(n)) }));
  }
  get onDidChangeCollapseState() {
    return se.map(this.model.onDidChangeCollapseState, ({ node: e, deep: t }) => ({ node: this.nodeMapper.map(e), deep: t }));
  }
  get onDidChangeRenderNodeCount() {
    return se.map(this.model.onDidChangeRenderNodeCount, (e) => this.nodeMapper.map(e));
  }
  constructor(e, t, n = {}) {
    this.rootRef = null, this.elementMapper = n.elementMapper || iie;
    const s = (o) => this.elementMapper(o.elements);
    this.nodeMapper = new IA((o) => new AA(s, o)), this.model = new tie(e, /* @__PURE__ */ function(o, r) {
      return { splice(a, l, d) {
        r.splice(a, l, d.map((h) => o.map(h)));
      }, updateElementHeight(a, l) {
        r.updateElementHeight(a, l);
      } };
    }(this.nodeMapper, t), function(o, r) {
      return { ...r, identityProvider: r.identityProvider && { getId: (a) => r.identityProvider.getId(o(a)) }, sorter: r.sorter && { compare: (a, l) => r.sorter.compare(a.elements[0], l.elements[0]) }, filter: r.filter && { filter: (a, l) => r.filter.filter(o(a), l) } };
    }(s, n));
  }
  setChildren(e, t = at.empty(), n = {}) {
    this.model.setChildren(e, t, n);
  }
  isCompressionEnabled() {
    return this.model.isCompressionEnabled();
  }
  setCompressionEnabled(e) {
    this.model.setCompressionEnabled(e);
  }
  has(e) {
    return this.model.has(e);
  }
  getListIndex(e) {
    return this.model.getListIndex(e);
  }
  getListRenderCount(e) {
    return this.model.getListRenderCount(e);
  }
  getNode(e) {
    return this.nodeMapper.map(this.model.getNode(e));
  }
  getNodeLocation(e) {
    return e.element;
  }
  getParentNodeLocation(e) {
    return this.model.getParentNodeLocation(e);
  }
  getFirstElementChild(e) {
    const t = this.model.getFirstElementChild(e);
    return t == null ? t : this.elementMapper(t.elements);
  }
  isCollapsible(e) {
    return this.model.isCollapsible(e);
  }
  setCollapsible(e, t) {
    return this.model.setCollapsible(e, t);
  }
  isCollapsed(e) {
    return this.model.isCollapsed(e);
  }
  setCollapsed(e, t, n) {
    return this.model.setCollapsed(e, t, n);
  }
  expandTo(e) {
    return this.model.expandTo(e);
  }
  rerender(e) {
    return this.model.rerender(e);
  }
  refilter() {
    return this.model.refilter();
  }
  getCompressedTreeNode(e = null) {
    return this.model.getNode(e);
  }
}
var sie = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
};
class PA extends cV {
  get onDidChangeCollapseState() {
    return this.model.onDidChangeCollapseState;
  }
  constructor(e, t, n, s, o = {}) {
    super(e, t, n, s, o), this.user = e;
  }
  setChildren(e, t = at.empty(), n) {
    this.model.setChildren(e, t, n);
  }
  rerender(e) {
    e !== void 0 ? this.model.rerender(e) : this.view.rerender();
  }
  hasElement(e) {
    return this.model.has(e);
  }
  createModel(e, t, n) {
    return new RA(e, t, n);
  }
}
class gV {
  get compressedTreeNodeProvider() {
    return this._compressedTreeNodeProvider();
  }
  constructor(e, t, n) {
    this._compressedTreeNodeProvider = e, this.stickyScrollDelegate = t, this.renderer = n, this.templateId = n.templateId, n.onDidChangeTwistieState && (this.onDidChangeTwistieState = n.onDidChangeTwistieState);
  }
  renderTemplate(e) {
    return { compressedTreeNode: void 0, data: this.renderer.renderTemplate(e) };
  }
  renderElement(e, t, n, s) {
    let o = this.stickyScrollDelegate.getCompressedNode(e);
    o || (o = this.compressedTreeNodeProvider.getCompressedTreeNode(e.element)), o.element.elements.length === 1 ? (n.compressedTreeNode = void 0, this.renderer.renderElement(e, t, n.data, s)) : (n.compressedTreeNode = o, this.renderer.renderCompressedElements(o, t, n.data, s));
  }
  disposeElement(e, t, n, s) {
    var o, r, a, l;
    n.compressedTreeNode ? (r = (o = this.renderer).disposeCompressedElements) === null || r === void 0 || r.call(o, n.compressedTreeNode, t, n.data, s) : (l = (a = this.renderer).disposeElement) === null || l === void 0 || l.call(a, e, t, n.data, s);
  }
  disposeTemplate(e) {
    this.renderer.disposeTemplate(e.data);
  }
  renderTwistie(e, t) {
    return !!this.renderer.renderTwistie && this.renderer.renderTwistie(e, t);
  }
}
sie([Li], gV.prototype, "compressedTreeNodeProvider", null);
class oie {
  constructor(e) {
    this.modelProvider = e, this.compressedStickyNodes = /* @__PURE__ */ new Map();
  }
  getCompressedNode(e) {
    return this.compressedStickyNodes.get(e);
  }
  constrainStickyScrollNodes(e, t, n) {
    if (this.compressedStickyNodes.clear(), e.length === 0) return [];
    for (let s = 0; s < e.length; s++) {
      const o = e[s], r = o.position + o.height;
      if (s + 1 < e.length && r + e[s + 1].height > n || s >= t - 1 && t < e.length) {
        const a = e.slice(0, s), l = e.slice(s);
        return [...a, this.compressStickyNodes(l)];
      }
    }
    return e;
  }
  compressStickyNodes(e) {
    if (e.length === 0) throw new Error("Can't compress empty sticky nodes");
    if (!this.modelProvider().isCompressionEnabled()) return e[0];
    const t = [];
    for (const l of e) {
      const d = this.modelProvider().getCompressedTreeNode(l.node.element);
      if (d.element) {
        if (d.element.incompressible) break;
        t.push(...d.element.elements);
      }
    }
    if (t.length < 2) return e[0];
    const n = e[e.length - 1], s = { elements: t, incompressible: !1 }, o = { ...n.node, children: [], element: s }, r = new Proxy(e[0].node, {}), a = { node: r, startIndex: e[0].startIndex, endIndex: n.endIndex, position: e[0].position, height: e[0].height };
    return this.compressedStickyNodes.set(r, o), a;
  }
}
function rie(i, e) {
  return e && { ...e, keyboardNavigationLabelProvider: e.keyboardNavigationLabelProvider && { getKeyboardNavigationLabel(t) {
    let n;
    try {
      n = i().getCompressedTreeNode(t);
    } catch {
      return e.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(t);
    }
    return n.element.elements.length === 1 ? e.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(t) : e.keyboardNavigationLabelProvider.getCompressedNodeKeyboardNavigationLabel(n.element.elements);
  } } };
}
class pV extends PA {
  constructor(e, t, n, s, o = {}) {
    const r = () => this, a = new oie(() => this.model);
    super(e, t, n, s.map((l) => new gV(r, a, l)), { ...rie(r, o), stickyScrollDelegate: a });
  }
  setChildren(e, t = at.empty(), n) {
    this.model.setChildren(e, t, n);
  }
  createModel(e, t, n) {
    return new nie(e, t, n);
  }
  updateOptions(e = {}) {
    super.updateOptions(e), e.compressionEnabled !== void 0 && this.model.setCompressionEnabled(e.compressionEnabled);
  }
  getCompressedTreeNode(e = null) {
    return this.model.getCompressedTreeNode(e);
  }
}
function ox(i) {
  return { ...i, children: [], refreshPromise: void 0, stale: !0, slow: !1, forceExpanded: !1 };
}
function h2(i, e) {
  return !!e.parent && (e.parent === i || h2(i, e.parent));
}
class OA {
  get element() {
    return this.node.element.element;
  }
  get children() {
    return this.node.children.map((e) => new OA(e));
  }
  get depth() {
    return this.node.depth;
  }
  get visibleChildrenCount() {
    return this.node.visibleChildrenCount;
  }
  get visibleChildIndex() {
    return this.node.visibleChildIndex;
  }
  get collapsible() {
    return this.node.collapsible;
  }
  get collapsed() {
    return this.node.collapsed;
  }
  get visible() {
    return this.node.visible;
  }
  get filterData() {
    return this.node.filterData;
  }
  constructor(e) {
    this.node = e;
  }
}
class aie {
  constructor(e, t, n) {
    this.renderer = e, this.nodeMapper = t, this.onDidChangeTwistieState = n, this.renderedNodes = /* @__PURE__ */ new Map(), this.templateId = e.templateId;
  }
  renderTemplate(e) {
    return { templateData: this.renderer.renderTemplate(e) };
  }
  renderElement(e, t, n, s) {
    this.renderer.renderElement(this.nodeMapper.map(e), t, n.templateData, s);
  }
  renderTwistie(e, t) {
    return e.slow ? (t.classList.add(...Ee.asClassNameArray(ne.treeItemLoading)), !0) : (t.classList.remove(...Ee.asClassNameArray(ne.treeItemLoading)), !1);
  }
  disposeElement(e, t, n, s) {
    var o, r;
    (r = (o = this.renderer).disposeElement) === null || r === void 0 || r.call(o, this.nodeMapper.map(e), t, n.templateData, s);
  }
  disposeTemplate(e) {
    this.renderer.disposeTemplate(e.templateData);
  }
  dispose() {
    this.renderedNodes.clear();
  }
}
function Q3(i) {
  return { browserEvent: i.browserEvent, elements: i.elements.map((e) => e.element) };
}
function J3(i) {
  return { browserEvent: i.browserEvent, element: i.element && i.element.element, target: i.target };
}
class lie extends A1 {
  constructor(e) {
    super(e.elements.map((t) => t.element)), this.data = e;
  }
}
function rx(i) {
  return i instanceof A1 ? new lie(i) : i;
}
class die {
  constructor(e) {
    this.dnd = e;
  }
  getDragURI(e) {
    return this.dnd.getDragURI(e.element);
  }
  getDragLabel(e, t) {
    if (this.dnd.getDragLabel) return this.dnd.getDragLabel(e.map((n) => n.element), t);
  }
  onDragStart(e, t) {
    var n, s;
    (s = (n = this.dnd).onDragStart) === null || s === void 0 || s.call(n, rx(e), t);
  }
  onDragOver(e, t, n, s, o, r = !0) {
    return this.dnd.onDragOver(rx(e), t && t.element, n, s, o);
  }
  drop(e, t, n, s, o) {
    this.dnd.drop(rx(e), t && t.element, n, s, o);
  }
  onDragEnd(e) {
    var t, n;
    (n = (t = this.dnd).onDragEnd) === null || n === void 0 || n.call(t, e);
  }
  dispose() {
    this.dnd.dispose();
  }
}
function mV(i) {
  return i && { ...i, collapseByDefault: !0, identityProvider: i.identityProvider && { getId: (e) => i.identityProvider.getId(e.element) }, dnd: i.dnd && new die(i.dnd), multipleSelectionController: i.multipleSelectionController && { isSelectionSingleChangeEvent: (e) => i.multipleSelectionController.isSelectionSingleChangeEvent({ ...e, element: e.element }), isSelectionRangeChangeEvent: (e) => i.multipleSelectionController.isSelectionRangeChangeEvent({ ...e, element: e.element }) }, accessibilityProvider: i.accessibilityProvider && { ...i.accessibilityProvider, getPosInSet: void 0, getSetSize: void 0, getRole: i.accessibilityProvider.getRole ? (e) => i.accessibilityProvider.getRole(e.element) : () => "treeitem", isChecked: i.accessibilityProvider.isChecked ? (e) => {
    var t;
    return !!(!((t = i.accessibilityProvider) === null || t === void 0) && t.isChecked(e.element));
  } : void 0, getAriaLabel: (e) => i.accessibilityProvider.getAriaLabel(e.element), getWidgetAriaLabel: () => i.accessibilityProvider.getWidgetAriaLabel(), getWidgetRole: i.accessibilityProvider.getWidgetRole ? () => i.accessibilityProvider.getWidgetRole() : () => "tree", getAriaLevel: i.accessibilityProvider.getAriaLevel && ((e) => i.accessibilityProvider.getAriaLevel(e.element)), getActiveDescendantId: i.accessibilityProvider.getActiveDescendantId && ((e) => i.accessibilityProvider.getActiveDescendantId(e.element)) }, filter: i.filter && { filter: (e, t) => i.filter.filter(e.element, t) }, keyboardNavigationLabelProvider: i.keyboardNavigationLabelProvider && { ...i.keyboardNavigationLabelProvider, getKeyboardNavigationLabel: (e) => i.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(e.element) }, sorter: void 0, expandOnlyOnTwistieClick: i.expandOnlyOnTwistieClick === void 0 ? void 0 : typeof i.expandOnlyOnTwistieClick != "function" ? i.expandOnlyOnTwistieClick : (e) => i.expandOnlyOnTwistieClick(e.element), defaultFindVisibility: (e) => e.hasChildren && e.stale ? 1 : typeof i.defaultFindVisibility == "number" ? i.defaultFindVisibility : i.defaultFindVisibility === void 0 ? 2 : i.defaultFindVisibility(e.element) };
}
function c2(i, e) {
  e(i), i.children.forEach((t) => c2(t, e));
}
class fV {
  get onDidScroll() {
    return this.tree.onDidScroll;
  }
  get onDidChangeFocus() {
    return se.map(this.tree.onDidChangeFocus, Q3);
  }
  get onDidChangeSelection() {
    return se.map(this.tree.onDidChangeSelection, Q3);
  }
  get onMouseDblClick() {
    return se.map(this.tree.onMouseDblClick, J3);
  }
  get onPointer() {
    return se.map(this.tree.onPointer, J3);
  }
  get onDidFocus() {
    return this.tree.onDidFocus;
  }
  get onDidChangeModel() {
    return this.tree.onDidChangeModel;
  }
  get onDidChangeCollapseState() {
    return this.tree.onDidChangeCollapseState;
  }
  get onDidChangeFindOpenState() {
    return this.tree.onDidChangeFindOpenState;
  }
  get onDidChangeStickyScrollFocused() {
    return this.tree.onDidChangeStickyScrollFocused;
  }
  get onDidDispose() {
    return this.tree.onDidDispose;
  }
  constructor(e, t, n, s, o, r = {}) {
    this.user = e, this.dataSource = o, this.nodes = /* @__PURE__ */ new Map(), this.subTreeRefreshPromises = /* @__PURE__ */ new Map(), this.refreshPromises = /* @__PURE__ */ new Map(), this._onDidRender = new F(), this._onDidChangeNodeSlowState = new F(), this.nodeMapper = new IA((a) => new OA(a)), this.disposables = new G(), this.identityProvider = r.identityProvider, this.autoExpandSingleChildren = r.autoExpandSingleChildren !== void 0 && r.autoExpandSingleChildren, this.sorter = r.sorter, this.getDefaultCollapseState = (a) => r.collapseByDefault ? r.collapseByDefault(a) ? co.PreserveOrCollapsed : co.PreserveOrExpanded : void 0, this.tree = this.createTree(e, t, n, s, r), this.onDidChangeFindMode = this.tree.onDidChangeFindMode, this.onDidChangeFindMatchType = this.tree.onDidChangeFindMatchType, this.root = ox({ element: void 0, parent: null, hasChildren: !0, defaultCollapseState: void 0 }), this.identityProvider && (this.root = { ...this.root, id: null }), this.nodes.set(null, this.root), this.tree.onDidChangeCollapseState(this._onDidChangeCollapseState, this, this.disposables);
  }
  createTree(e, t, n, s, o) {
    const r = new TA(n), a = s.map((d) => new aie(d, this.nodeMapper, this._onDidChangeNodeSlowState.event)), l = mV(o) || {};
    return new PA(e, t, r, a, l);
  }
  updateOptions(e = {}) {
    this.tree.updateOptions(e);
  }
  getHTMLElement() {
    return this.tree.getHTMLElement();
  }
  get scrollTop() {
    return this.tree.scrollTop;
  }
  set scrollTop(e) {
    this.tree.scrollTop = e;
  }
  get scrollHeight() {
    return this.tree.scrollHeight;
  }
  get renderHeight() {
    return this.tree.renderHeight;
  }
  domFocus() {
    this.tree.domFocus();
  }
  layout(e, t) {
    this.tree.layout(e, t);
  }
  style(e) {
    this.tree.style(e);
  }
  getInput() {
    return this.root.element;
  }
  async setInput(e, t) {
    this.refreshPromises.forEach((s) => s.cancel()), this.refreshPromises.clear(), this.root.element = e;
    const n = t && { viewState: t, focus: [], selection: [] };
    await this._updateChildren(e, !0, !1, n), n && (this.tree.setFocus(n.focus), this.tree.setSelection(n.selection)), t && typeof t.scrollTop == "number" && (this.scrollTop = t.scrollTop);
  }
  async _updateChildren(e = this.root.element, t = !0, n = !1, s, o) {
    if (this.root.element === void 0) throw new _o(this.user, "Tree input not set");
    this.root.refreshPromise && (await this.root.refreshPromise, await se.toPromise(this._onDidRender.event));
    const r = this.getDataNode(e);
    if (await this.refreshAndRenderNode(r, t, s, o), n) try {
      this.tree.rerender(r);
    } catch {
    }
  }
  rerender(e) {
    if (e === void 0 || e === this.root.element) return void this.tree.rerender();
    const t = this.getDataNode(e);
    this.tree.rerender(t);
  }
  getNode(e = this.root.element) {
    const t = this.getDataNode(e), n = this.tree.getNode(t === this.root ? null : t);
    return this.nodeMapper.map(n);
  }
  collapse(e, t = !1) {
    const n = this.getDataNode(e);
    return this.tree.collapse(n === this.root ? null : n, t);
  }
  async expand(e, t = !1) {
    if (this.root.element === void 0) throw new _o(this.user, "Tree input not set");
    this.root.refreshPromise && (await this.root.refreshPromise, await se.toPromise(this._onDidRender.event));
    const n = this.getDataNode(e);
    if (this.tree.hasElement(n) && !this.tree.isCollapsible(n) || (n.refreshPromise && (await this.root.refreshPromise, await se.toPromise(this._onDidRender.event)), n !== this.root && !n.refreshPromise && !this.tree.isCollapsed(n))) return !1;
    const s = this.tree.expand(n === this.root ? null : n, t);
    return n.refreshPromise && (await this.root.refreshPromise, await se.toPromise(this._onDidRender.event)), s;
  }
  setSelection(e, t) {
    const n = e.map((s) => this.getDataNode(s));
    this.tree.setSelection(n, t);
  }
  getSelection() {
    return this.tree.getSelection().map((e) => e.element);
  }
  setFocus(e, t) {
    const n = e.map((s) => this.getDataNode(s));
    this.tree.setFocus(n, t);
  }
  getFocus() {
    return this.tree.getFocus().map((e) => e.element);
  }
  reveal(e, t) {
    this.tree.reveal(this.getDataNode(e), t);
  }
  getParentElement(e) {
    const t = this.tree.getParentElement(this.getDataNode(e));
    return t && t.element;
  }
  getFirstElementChild(e = this.root.element) {
    const t = this.getDataNode(e), n = this.tree.getFirstElementChild(t === this.root ? null : t);
    return n && n.element;
  }
  getDataNode(e) {
    const t = this.nodes.get(e === this.root.element ? null : e);
    if (!t) throw new _o(this.user, `Data tree node not found: ${e}`);
    return t;
  }
  async refreshAndRenderNode(e, t, n, s) {
    await this.refreshNode(e, t, n), this.disposables.isDisposed || this.render(e, n, s);
  }
  async refreshNode(e, t, n) {
    let s;
    return this.subTreeRefreshPromises.forEach((o, r) => {
      !s && function(a, l) {
        return a === l || h2(a, l) || h2(l, a);
      }(r, e) && (s = o.then(() => this.refreshNode(e, t, n)));
    }), s || (e !== this.root && this.tree.getNode(e).collapsed ? (e.hasChildren = !!this.dataSource.hasChildren(e.element), e.stale = !0, void this.setChildren(e, [], t, n)) : this.doRefreshSubTree(e, t, n));
  }
  async doRefreshSubTree(e, t, n) {
    let s;
    e.refreshPromise = new Promise((o) => s = o), this.subTreeRefreshPromises.set(e, e.refreshPromise), e.refreshPromise.finally(() => {
      e.refreshPromise = void 0, this.subTreeRefreshPromises.delete(e);
    });
    try {
      const o = await this.doRefreshNode(e, t, n);
      e.stale = !1, await xE.settled(o.map((r) => this.doRefreshSubTree(r, t, n)));
    } finally {
      s();
    }
  }
  async doRefreshNode(e, t, n) {
    let s;
    if (e.hasChildren = !!this.dataSource.hasChildren(e.element), e.hasChildren) {
      const o = this.doGetChildren(e);
      if (QP(o)) s = Promise.resolve(o);
      else {
        const r = bc(800);
        r.then(() => {
          e.slow = !0, this._onDidChangeNodeSlowState.fire(e);
        }, (a) => null), s = o.finally(() => r.cancel());
      }
    } else s = Promise.resolve(at.empty());
    try {
      const o = await s;
      return this.setChildren(e, o, t, n);
    } catch (o) {
      if (e !== this.root && this.tree.hasElement(e) && this.tree.collapse(e), Sa(o)) return [];
      throw o;
    } finally {
      e.slow && (e.slow = !1, this._onDidChangeNodeSlowState.fire(e));
    }
  }
  doGetChildren(e) {
    let t = this.refreshPromises.get(e);
    if (t) return t;
    const n = this.dataSource.getChildren(e.element);
    return QP(n) ? this.processChildren(n) : (t = on(async () => this.processChildren(await n)), this.refreshPromises.set(e, t), t.finally(() => {
      this.refreshPromises.delete(e);
    }));
  }
  _onDidChangeCollapseState({ node: e, deep: t }) {
    e.element !== null && !e.collapsed && e.element.stale && (t ? this.collapse(e.element.element) : this.refreshAndRenderNode(e.element, !1).catch(We));
  }
  setChildren(e, t, n, s) {
    const o = [...t];
    if (e.children.length === 0 && o.length === 0) return [];
    const r = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
    for (const h of e.children) r.set(h.element, h), this.identityProvider && a.set(h.id, { node: h, collapsed: this.tree.hasElement(h) && this.tree.isCollapsed(h) });
    const l = [], d = o.map((h) => {
      const c = !!this.dataSource.hasChildren(h);
      if (!this.identityProvider) {
        const f = ox({ element: h, parent: e, hasChildren: c, defaultCollapseState: this.getDefaultCollapseState(h) });
        return c && f.defaultCollapseState === co.PreserveOrExpanded && l.push(f), f;
      }
      const u = this.identityProvider.getId(h).toString(), g = a.get(u);
      if (g) {
        const f = g.node;
        return r.delete(f.element), this.nodes.delete(f.element), this.nodes.set(h, f), f.element = h, f.hasChildren = c, n ? g.collapsed ? (f.children.forEach((_) => c2(_, (v) => this.nodes.delete(v.element))), f.children.splice(0, f.children.length), f.stale = !0) : l.push(f) : c && !g.collapsed && l.push(f), f;
      }
      const p = ox({ element: h, parent: e, id: u, hasChildren: c, defaultCollapseState: this.getDefaultCollapseState(h) });
      return s && s.viewState.focus && s.viewState.focus.indexOf(u) > -1 && s.focus.push(p), s && s.viewState.selection && s.viewState.selection.indexOf(u) > -1 && s.selection.push(p), (s && s.viewState.expanded && s.viewState.expanded.indexOf(u) > -1 || c && p.defaultCollapseState === co.PreserveOrExpanded) && l.push(p), p;
    });
    for (const h of r.values()) c2(h, (c) => this.nodes.delete(c.element));
    for (const h of d) this.nodes.set(h.element, h);
    return e.children.splice(0, e.children.length, ...d), e !== this.root && this.autoExpandSingleChildren && d.length === 1 && l.length === 0 && (d[0].forceExpanded = !0, l.push(d[0])), l;
  }
  render(e, t, n) {
    const s = e.children.map((r) => this.asTreeElement(r, t)), o = n && { ...n, diffIdentityProvider: n.diffIdentityProvider && { getId: (r) => n.diffIdentityProvider.getId(r.element) } };
    this.tree.setChildren(e === this.root ? null : e, s, o), e !== this.root && this.tree.setCollapsible(e, e.hasChildren), this._onDidRender.fire();
  }
  asTreeElement(e, t) {
    if (e.stale) return { element: e, collapsible: e.hasChildren, collapsed: !0 };
    let n;
    return t && t.viewState.expanded && e.id && t.viewState.expanded.indexOf(e.id) > -1 ? n = !1 : e.forceExpanded ? (n = !1, e.forceExpanded = !1) : n = e.defaultCollapseState, { element: e, children: e.hasChildren ? at.map(e.children, (s) => this.asTreeElement(s, t)) : [], collapsible: e.hasChildren, collapsed: n };
  }
  processChildren(e) {
    return this.sorter && (e = [...e].sort(this.sorter.compare.bind(this.sorter))), e;
  }
  dispose() {
    this.disposables.dispose(), this.tree.dispose();
  }
}
class FA {
  get element() {
    return { elements: this.node.element.elements.map((e) => e.element), incompressible: this.node.element.incompressible };
  }
  get children() {
    return this.node.children.map((e) => new FA(e));
  }
  get depth() {
    return this.node.depth;
  }
  get visibleChildrenCount() {
    return this.node.visibleChildrenCount;
  }
  get visibleChildIndex() {
    return this.node.visibleChildIndex;
  }
  get collapsible() {
    return this.node.collapsible;
  }
  get collapsed() {
    return this.node.collapsed;
  }
  get visible() {
    return this.node.visible;
  }
  get filterData() {
    return this.node.filterData;
  }
  constructor(e) {
    this.node = e;
  }
}
class hie {
  constructor(e, t, n, s) {
    this.renderer = e, this.nodeMapper = t, this.compressibleNodeMapperProvider = n, this.onDidChangeTwistieState = s, this.renderedNodes = /* @__PURE__ */ new Map(), this.disposables = [], this.templateId = e.templateId;
  }
  renderTemplate(e) {
    return { templateData: this.renderer.renderTemplate(e) };
  }
  renderElement(e, t, n, s) {
    this.renderer.renderElement(this.nodeMapper.map(e), t, n.templateData, s);
  }
  renderCompressedElements(e, t, n, s) {
    this.renderer.renderCompressedElements(this.compressibleNodeMapperProvider().map(e), t, n.templateData, s);
  }
  renderTwistie(e, t) {
    return e.slow ? (t.classList.add(...Ee.asClassNameArray(ne.treeItemLoading)), !0) : (t.classList.remove(...Ee.asClassNameArray(ne.treeItemLoading)), !1);
  }
  disposeElement(e, t, n, s) {
    var o, r;
    (r = (o = this.renderer).disposeElement) === null || r === void 0 || r.call(o, this.nodeMapper.map(e), t, n.templateData, s);
  }
  disposeCompressedElements(e, t, n, s) {
    var o, r;
    (r = (o = this.renderer).disposeCompressedElements) === null || r === void 0 || r.call(o, this.compressibleNodeMapperProvider().map(e), t, n.templateData, s);
  }
  disposeTemplate(e) {
    this.renderer.disposeTemplate(e.templateData);
  }
  dispose() {
    this.renderedNodes.clear(), this.disposables = Ht(this.disposables);
  }
}
class cie extends fV {
  constructor(e, t, n, s, o, r, a = {}) {
    super(e, t, n, o, r, a), this.compressionDelegate = s, this.compressibleNodeMapper = new IA((l) => new FA(l)), this.filter = a.filter;
  }
  createTree(e, t, n, s, o) {
    const r = new TA(n), a = s.map((d) => new hie(d, this.nodeMapper, () => this.compressibleNodeMapper, this._onDidChangeNodeSlowState.event)), l = function(d) {
      const h = d && mV(d);
      return h && { ...h, keyboardNavigationLabelProvider: h.keyboardNavigationLabelProvider && { ...h.keyboardNavigationLabelProvider, getCompressedNodeKeyboardNavigationLabel: (c) => d.keyboardNavigationLabelProvider.getCompressedNodeKeyboardNavigationLabel(c.map((u) => u.element)) } };
    }(o) || {};
    return new pV(e, t, r, a, l);
  }
  asTreeElement(e, t) {
    return { incompressible: this.compressionDelegate.isIncompressible(e.element), ...super.asTreeElement(e, t) };
  }
  updateOptions(e = {}) {
    this.tree.updateOptions(e);
  }
  render(e, t, n) {
    if (!this.identityProvider) return super.render(e, t);
    const s = (g) => this.identityProvider.getId(g).toString(), o = (g) => {
      const p = /* @__PURE__ */ new Set();
      for (const f of g) {
        const _ = this.tree.getCompressedTreeNode(f === this.root ? null : f);
        if (_.element) for (const v of _.element.elements) p.add(s(v.element));
      }
      return p;
    }, r = o(this.tree.getSelection()), a = o(this.tree.getFocus());
    super.render(e, t, n);
    const l = this.getSelection();
    let d = !1;
    const h = this.getFocus();
    let c = !1;
    const u = (g) => {
      const p = g.element;
      if (p) for (let f = 0; f < p.elements.length; f++) {
        const _ = s(p.elements[f].element), v = p.elements[p.elements.length - 1].element;
        r.has(_) && l.indexOf(v) === -1 && (l.push(v), d = !0), a.has(_) && h.indexOf(v) === -1 && (h.push(v), c = !0);
      }
      g.children.forEach(u);
    };
    u(this.tree.getCompressedTreeNode(e === this.root ? null : e)), d && this.setSelection(l), c && this.setFocus(h);
  }
  processChildren(e) {
    return this.filter && (e = at.filter(e, (t) => {
      const n = this.filter.filter(t, 1), s = typeof (o = n) == "boolean" ? o ? 1 : 0 : MA(o) ? Wv(o.visibility) : Wv(o);
      var o;
      if (s === 2) throw new Error("Recursive tree visibility not supported in async data compressed trees");
      return s === 1;
    })), super.processChildren(e);
  }
}
class uie extends cV {
  constructor(e, t, n, s, o, r = {}) {
    super(e, t, n, s, r), this.user = e, this.dataSource = o, this.identityProvider = r.identityProvider;
  }
  createModel(e, t, n) {
    return new RA(e, t, n);
  }
}
new ae("isMac", Je, m(0, "Whether the operating system is macOS")), new ae("isLinux", Cs, m(0, "Whether the operating system is Linux"));
const Ub = new ae("isWindows", Tn, m(0, "Whether the operating system is Windows")), eF = new ae("isWeb", pc, m(0, "Whether the platform is a web browser"));
new ae("isMacNative", Je && !pc, m(0, "Whether the operating system is macOS on a non-browser platform")), new ae("isIOS", ua, m(0, "Whether the operating system is iOS")), new ae("isMobile", S7, m(0, "Whether the platform is a mobile web browser")), new ae("isDevelopment", !1, !0), new ae("productQualityType", "", m(0, "Quality type of VS Code"));
const _V = "inputFocus", gie = new ae(_V, !1, m(0, "Whether keyboard focus is inside an input box"));
var Ud = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, qt = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const Jo = tt("listService"), T_ = new ae("listScrollAtBoundary", "none");
q.or(T_.isEqualTo("top"), T_.isEqualTo("both")), q.or(T_.isEqualTo("bottom"), T_.isEqualTo("both"));
const vV = new ae("listFocus", !0), bV = new ae("treestickyScrollFocused", !1), AL = new ae("listSupportsMultiselect", !0), tF = q.and(vV, q.not(_V), bV.negate()), BA = new ae("listHasSelectionOrFocus", !1), WA = new ae("listDoubleSelection", !1), VA = new ae("listMultiSelection", !1), PL = new ae("listSelectionNavigation", !1), pie = new ae("listSupportsFind", !0), u2 = new ae("treeElementCanCollapse", !1), mie = new ae("treeElementHasParent", !1), g2 = new ae("treeElementCanExpand", !1), fie = new ae("treeElementHasChild", !1), _ie = new ae("treeFindOpen", !1), CV = "listTypeNavigationMode", wV = "listAutomaticKeyboardNavigation";
function OL(i, e) {
  const t = i.createScoped(e.getHTMLElement());
  return vV.bindTo(t), t;
}
function FL(i, e) {
  const t = T_.bindTo(i), n = () => {
    const s = e.scrollTop === 0, o = e.scrollHeight - e.renderHeight - e.scrollTop < 1;
    s && o ? t.set("both") : s ? t.set("top") : o ? t.set("bottom") : t.set("none");
  };
  return n(), e.onDidScroll(n);
}
const Pg = "workbench.list.multiSelectModifier", ew = "workbench.list.openMode", er = "workbench.list.horizontalScrolling", HA = "workbench.list.defaultFindMode", zA = "workbench.list.typeNavigationMode", Gy = "workbench.list.keyboardNavigation", Ca = "workbench.list.scrollByPage", UA = "workbench.list.defaultFindMatchType", Hv = "workbench.tree.indent", Zy = "workbench.tree.renderIndentGuides", wa = "workbench.list.smoothScrolling", bl = "workbench.list.mouseWheelScrollSensitivity", Cl = "workbench.list.fastScrollSensitivity", Yy = "workbench.tree.expandMode", Xy = "workbench.tree.enableStickyScroll", Qy = "workbench.tree.stickyScrollMaxItemCount";
function wl(i) {
  return i.getValue(Pg) === "alt";
}
class vie extends V {
  constructor(e) {
    super(), this.configurationService = e, this.useAltAsMultipleSelectionModifier = wl(e), this.registerListeners();
  }
  registerListeners() {
    this._register(this.configurationService.onDidChangeConfiguration((e) => {
      e.affectsConfiguration(Pg) && (this.useAltAsMultipleSelectionModifier = wl(this.configurationService));
    }));
  }
  isSelectionSingleChangeEvent(e) {
    return this.useAltAsMultipleSelectionModifier ? e.browserEvent.altKey : $W(e);
  }
  isSelectionRangeChangeEvent(e) {
    return GW(e);
  }
}
function BL(i, e) {
  var t;
  const n = i.get(Ye), s = i.get(Dt), o = new G();
  return [{ ...e, keyboardNavigationDelegate: { mightProducePrintableCharacter: (r) => s.mightProducePrintableCharacter(r) }, smoothScrolling: !!n.getValue(wa), mouseWheelScrollSensitivity: n.getValue(bl), fastScrollSensitivity: n.getValue(Cl), multipleSelectionController: (t = e.multipleSelectionController) !== null && t !== void 0 ? t : o.add(new vie(n)), keyboardNavigationEventFilter: wie(s), scrollByPage: !!n.getValue(Ca) }, o];
}
let iF = class extends uo {
  constructor(i, e, t, n, s, o, r, a, l) {
    const d = s.horizontalScrolling !== void 0 ? s.horizontalScrolling : !!a.getValue(er), [h, c] = l.invokeFunction(BL, s);
    super(i, e, t, n, { keyboardSupport: !1, ...h, horizontalScrolling: d }), this.disposables.add(c), this.contextKeyService = OL(o, this), this.disposables.add(FL(this.contextKeyService, this)), this.listSupportsMultiSelect = AL.bindTo(this.contextKeyService), this.listSupportsMultiSelect.set(s.multipleSelectionSupport !== !1), PL.bindTo(this.contextKeyService).set(!!s.selectionNavigation), this.listHasSelectionOrFocus = BA.bindTo(this.contextKeyService), this.listDoubleSelection = WA.bindTo(this.contextKeyService), this.listMultiSelection = VA.bindTo(this.contextKeyService), this.horizontalScrolling = s.horizontalScrolling, this._useAltAsMultipleSelectionModifier = wl(a), this.disposables.add(this.contextKeyService), this.disposables.add(r.register(this)), this.updateStyles(s.overrideStyles), this.disposables.add(this.onDidChangeSelection(() => {
      const u = this.getSelection(), g = this.getFocus();
      this.contextKeyService.bufferChangeEvents(() => {
        this.listHasSelectionOrFocus.set(u.length > 0 || g.length > 0), this.listMultiSelection.set(u.length > 1), this.listDoubleSelection.set(u.length === 2);
      });
    })), this.disposables.add(this.onDidChangeFocus(() => {
      const u = this.getSelection(), g = this.getFocus();
      this.listHasSelectionOrFocus.set(u.length > 0 || g.length > 0);
    })), this.disposables.add(a.onDidChangeConfiguration((u) => {
      u.affectsConfiguration(Pg) && (this._useAltAsMultipleSelectionModifier = wl(a));
      let g = {};
      if (u.affectsConfiguration(er) && this.horizontalScrolling === void 0) {
        const p = !!a.getValue(er);
        g = { ...g, horizontalScrolling: p };
      }
      if (u.affectsConfiguration(Ca)) {
        const p = !!a.getValue(Ca);
        g = { ...g, scrollByPage: p };
      }
      if (u.affectsConfiguration(wa)) {
        const p = !!a.getValue(wa);
        g = { ...g, smoothScrolling: p };
      }
      if (u.affectsConfiguration(bl)) {
        const p = a.getValue(bl);
        g = { ...g, mouseWheelScrollSensitivity: p };
      }
      if (u.affectsConfiguration(Cl)) {
        const p = a.getValue(Cl);
        g = { ...g, fastScrollSensitivity: p };
      }
      Object.keys(g).length > 0 && this.updateOptions(g);
    })), this.navigator = new yV(this, { configurationService: a, ...s }), this.disposables.add(this.navigator);
  }
  updateOptions(i) {
    super.updateOptions(i), i.overrideStyles !== void 0 && this.updateStyles(i.overrideStyles), i.multipleSelectionSupport !== void 0 && this.listSupportsMultiSelect.set(!!i.multipleSelectionSupport);
  }
  updateStyles(i) {
    this.style(i ? Rg(i) : Tg);
  }
};
iF = Ud([qt(5, Te), qt(6, Jo), qt(7, Ye), qt(8, Se)], iF);
let nF = class extends xte {
  constructor(i, e, t, n, s, o, r, a, l) {
    const d = s.horizontalScrolling !== void 0 ? s.horizontalScrolling : !!a.getValue(er), [h, c] = l.invokeFunction(BL, s);
    super(i, e, t, n, { keyboardSupport: !1, ...h, horizontalScrolling: d }), this.disposables = new G(), this.disposables.add(c), this.contextKeyService = OL(o, this), this.disposables.add(FL(this.contextKeyService, this.widget)), this.horizontalScrolling = s.horizontalScrolling, this.listSupportsMultiSelect = AL.bindTo(this.contextKeyService), this.listSupportsMultiSelect.set(s.multipleSelectionSupport !== !1), PL.bindTo(this.contextKeyService).set(!!s.selectionNavigation), this._useAltAsMultipleSelectionModifier = wl(a), this.disposables.add(this.contextKeyService), this.disposables.add(r.register(this)), this.updateStyles(s.overrideStyles), this.disposables.add(a.onDidChangeConfiguration((u) => {
      u.affectsConfiguration(Pg) && (this._useAltAsMultipleSelectionModifier = wl(a));
      let g = {};
      if (u.affectsConfiguration(er) && this.horizontalScrolling === void 0) {
        const p = !!a.getValue(er);
        g = { ...g, horizontalScrolling: p };
      }
      if (u.affectsConfiguration(Ca)) {
        const p = !!a.getValue(Ca);
        g = { ...g, scrollByPage: p };
      }
      if (u.affectsConfiguration(wa)) {
        const p = !!a.getValue(wa);
        g = { ...g, smoothScrolling: p };
      }
      if (u.affectsConfiguration(bl)) {
        const p = a.getValue(bl);
        g = { ...g, mouseWheelScrollSensitivity: p };
      }
      if (u.affectsConfiguration(Cl)) {
        const p = a.getValue(Cl);
        g = { ...g, fastScrollSensitivity: p };
      }
      Object.keys(g).length > 0 && this.updateOptions(g);
    })), this.navigator = new yV(this, { configurationService: a, ...s }), this.disposables.add(this.navigator);
  }
  updateOptions(i) {
    super.updateOptions(i), i.overrideStyles !== void 0 && this.updateStyles(i.overrideStyles), i.multipleSelectionSupport !== void 0 && this.listSupportsMultiSelect.set(!!i.multipleSelectionSupport);
  }
  updateStyles(i) {
    this.style(i ? Rg(i) : Tg);
  }
  dispose() {
    this.disposables.dispose(), super.dispose();
  }
};
nF = Ud([qt(5, Te), qt(6, Jo), qt(7, Ye), qt(8, Se)], nF);
let sF = class extends RL {
  constructor(i, e, t, n, s, o, r, a, l, d) {
    const h = o.horizontalScrolling !== void 0 ? o.horizontalScrolling : !!l.getValue(er), [c, u] = d.invokeFunction(BL, o);
    super(i, e, t, n, s, { keyboardSupport: !1, ...c, horizontalScrolling: h }), this.disposables.add(u), this.contextKeyService = OL(r, this), this.disposables.add(FL(this.contextKeyService, this)), this.listSupportsMultiSelect = AL.bindTo(this.contextKeyService), this.listSupportsMultiSelect.set(o.multipleSelectionSupport !== !1), PL.bindTo(this.contextKeyService).set(!!o.selectionNavigation), this.listHasSelectionOrFocus = BA.bindTo(this.contextKeyService), this.listDoubleSelection = WA.bindTo(this.contextKeyService), this.listMultiSelection = VA.bindTo(this.contextKeyService), this.horizontalScrolling = o.horizontalScrolling, this._useAltAsMultipleSelectionModifier = wl(l), this.disposables.add(this.contextKeyService), this.disposables.add(a.register(this)), this.updateStyles(o.overrideStyles), this.disposables.add(this.onDidChangeSelection(() => {
      const g = this.getSelection(), p = this.getFocus();
      this.contextKeyService.bufferChangeEvents(() => {
        this.listHasSelectionOrFocus.set(g.length > 0 || p.length > 0), this.listMultiSelection.set(g.length > 1), this.listDoubleSelection.set(g.length === 2);
      });
    })), this.disposables.add(this.onDidChangeFocus(() => {
      const g = this.getSelection(), p = this.getFocus();
      this.listHasSelectionOrFocus.set(g.length > 0 || p.length > 0);
    })), this.disposables.add(l.onDidChangeConfiguration((g) => {
      g.affectsConfiguration(Pg) && (this._useAltAsMultipleSelectionModifier = wl(l));
      let p = {};
      if (g.affectsConfiguration(er) && this.horizontalScrolling === void 0) {
        const f = !!l.getValue(er);
        p = { ...p, horizontalScrolling: f };
      }
      if (g.affectsConfiguration(Ca)) {
        const f = !!l.getValue(Ca);
        p = { ...p, scrollByPage: f };
      }
      if (g.affectsConfiguration(wa)) {
        const f = !!l.getValue(wa);
        p = { ...p, smoothScrolling: f };
      }
      if (g.affectsConfiguration(bl)) {
        const f = l.getValue(bl);
        p = { ...p, mouseWheelScrollSensitivity: f };
      }
      if (g.affectsConfiguration(Cl)) {
        const f = l.getValue(Cl);
        p = { ...p, fastScrollSensitivity: f };
      }
      Object.keys(p).length > 0 && this.updateOptions(p);
    })), this.navigator = new bie(this, { configurationService: l, ...o }), this.disposables.add(this.navigator);
  }
  updateOptions(i) {
    super.updateOptions(i), i.overrideStyles !== void 0 && this.updateStyles(i.overrideStyles), i.multipleSelectionSupport !== void 0 && this.listSupportsMultiSelect.set(!!i.multipleSelectionSupport);
  }
  updateStyles(i) {
    this.style(i ? Rg(i) : Tg);
  }
  dispose() {
    this.disposables.dispose(), super.dispose();
  }
};
sF = Ud([qt(6, Te), qt(7, Jo), qt(8, Ye), qt(9, Se)], sF);
class KA extends V {
  constructor(e, t) {
    var n;
    super(), this.widget = e, this._onDidOpen = this._register(new F()), this.onDidOpen = this._onDidOpen.event, this._register(se.filter(this.widget.onDidChangeSelection, (s) => _h(s.browserEvent))((s) => this.onSelectionFromKeyboard(s))), this._register(this.widget.onPointer((s) => this.onPointer(s.element, s.browserEvent))), this._register(this.widget.onMouseDblClick((s) => this.onMouseDblClick(s.element, s.browserEvent))), typeof (t == null ? void 0 : t.openOnSingleClick) != "boolean" && (t != null && t.configurationService) ? (this.openOnSingleClick = (t == null ? void 0 : t.configurationService.getValue(ew)) !== "doubleClick", this._register(t == null ? void 0 : t.configurationService.onDidChangeConfiguration((s) => {
      s.affectsConfiguration(ew) && (this.openOnSingleClick = (t == null ? void 0 : t.configurationService.getValue(ew)) !== "doubleClick");
    }))) : this.openOnSingleClick = (n = t == null ? void 0 : t.openOnSingleClick) === null || n === void 0 || n;
  }
  onSelectionFromKeyboard(e) {
    if (e.elements.length !== 1) return;
    const t = e.browserEvent, n = typeof t.preserveFocus != "boolean" || t.preserveFocus, s = typeof t.pinned == "boolean" ? t.pinned : !n;
    this._open(this.getSelectedElement(), n, s, !1, e.browserEvent);
  }
  onPointer(e, t) {
    if (!this.openOnSingleClick || t.detail === 2) return;
    const n = t.button === 1, s = t.ctrlKey || t.metaKey || t.altKey;
    this._open(e, !0, n, s, t);
  }
  onMouseDblClick(e, t) {
    if (!t) return;
    const n = t.target;
    if (n.classList.contains("monaco-tl-twistie") || n.classList.contains("monaco-icon-label") && n.classList.contains("folder-icon") && t.offsetX < 16) return;
    const s = t.ctrlKey || t.metaKey || t.altKey;
    this._open(e, !1, !0, s, t);
  }
  _open(e, t, n, s, o) {
    e && this._onDidOpen.fire({ editorOptions: { preserveFocus: t, pinned: n, revealIfVisible: !0 }, sideBySide: s, element: e, browserEvent: o });
  }
}
class yV extends KA {
  constructor(e, t) {
    super(e, t), this.widget = e;
  }
  getSelectedElement() {
    return this.widget.getSelectedElements()[0];
  }
}
class bie extends KA {
  constructor(e, t) {
    super(e, t);
  }
  getSelectedElement() {
    return this.widget.getSelectedElements()[0];
  }
}
class Cie extends KA {
  constructor(e, t) {
    super(e, t);
  }
  getSelectedElement() {
    var e;
    return (e = this.widget.getSelection()[0]) !== null && e !== void 0 ? e : void 0;
  }
}
function wie(i) {
  let e = !1;
  return (t) => {
    if (t.toKeyCodeChord().isModifierKey()) return !1;
    if (e) return e = !1, !1;
    const n = i.softDispatch(t, t.target);
    return n.kind === 1 ? (e = !0, !1) : (e = !1, n.kind === 0);
  };
}
let p2 = class extends PA {
  constructor(i, e, t, n, s, o, r, a, l) {
    const { options: d, getTypeNavigationMode: h, disposable: c } = o.invokeFunction(B1, s);
    super(i, e, t, n, d), this.disposables.add(c), this.internals = new _g(this, s, h, s.overrideStyles, r, a, l), this.disposables.add(this.internals);
  }
  updateOptions(i) {
    super.updateOptions(i), this.internals.updateOptions(i);
  }
};
p2 = Ud([qt(5, Se), qt(6, Te), qt(7, Jo), qt(8, Ye)], p2);
let oF = class extends pV {
  constructor(i, e, t, n, s, o, r, a, l) {
    const { options: d, getTypeNavigationMode: h, disposable: c } = o.invokeFunction(B1, s);
    super(i, e, t, n, d), this.disposables.add(c), this.internals = new _g(this, s, h, s.overrideStyles, r, a, l), this.disposables.add(this.internals);
  }
  updateOptions(i = {}) {
    super.updateOptions(i), i.overrideStyles && this.internals.updateStyleOverrides(i.overrideStyles), this.internals.updateOptions(i);
  }
};
oF = Ud([qt(5, Se), qt(6, Te), qt(7, Jo), qt(8, Ye)], oF);
let rF = class extends uie {
  constructor(i, e, t, n, s, o, r, a, l, d) {
    const { options: h, getTypeNavigationMode: c, disposable: u } = r.invokeFunction(B1, o);
    super(i, e, t, n, s, h), this.disposables.add(u), this.internals = new _g(this, o, c, o.overrideStyles, a, l, d), this.disposables.add(this.internals);
  }
  updateOptions(i = {}) {
    super.updateOptions(i), i.overrideStyles !== void 0 && this.internals.updateStyleOverrides(i.overrideStyles), this.internals.updateOptions(i);
  }
};
rF = Ud([qt(6, Se), qt(7, Te), qt(8, Jo), qt(9, Ye)], rF);
let m2 = class extends fV {
  get onDidOpen() {
    return this.internals.onDidOpen;
  }
  constructor(i, e, t, n, s, o, r, a, l, d) {
    const { options: h, getTypeNavigationMode: c, disposable: u } = r.invokeFunction(B1, o);
    super(i, e, t, n, s, h), this.disposables.add(u), this.internals = new _g(this, o, c, o.overrideStyles, a, l, d), this.disposables.add(this.internals);
  }
  updateOptions(i = {}) {
    super.updateOptions(i), i.overrideStyles && this.internals.updateStyleOverrides(i.overrideStyles), this.internals.updateOptions(i);
  }
};
m2 = Ud([qt(6, Se), qt(7, Te), qt(8, Jo), qt(9, Ye)], m2);
let aF = class extends cie {
  constructor(i, e, t, n, s, o, r, a, l, d, h) {
    const { options: c, getTypeNavigationMode: u, disposable: g } = a.invokeFunction(B1, r);
    super(i, e, t, n, s, o, c), this.disposables.add(g), this.internals = new _g(this, r, u, r.overrideStyles, l, d, h), this.disposables.add(this.internals);
  }
  updateOptions(i) {
    super.updateOptions(i), this.internals.updateOptions(i);
  }
};
function SV(i) {
  const e = i.getValue(HA);
  if (e === "highlight") return Cd.Highlight;
  if (e === "filter") return Cd.Filter;
  const t = i.getValue(Gy);
  return t === "simple" || t === "highlight" ? Cd.Highlight : t === "filter" ? Cd.Filter : void 0;
}
function LV(i) {
  const e = i.getValue(UA);
  return e === "fuzzy" ? fg.Fuzzy : e === "contiguous" ? fg.Contiguous : void 0;
}
function B1(i, e) {
  var t;
  const n = i.get(Ye), s = i.get(zd), o = i.get(Te), r = i.get(Se), a = e.horizontalScrolling !== void 0 ? e.horizontalScrolling : !!n.getValue(er), [l, d] = r.invokeFunction(BL, e), h = e.paddingBottom, c = e.renderIndentGuides !== void 0 ? e.renderIndentGuides : n.getValue(Zy);
  return { getTypeNavigationMode: () => {
    const u = o.getContextKeyValue(CV);
    if (u === "automatic") return Qa.Automatic;
    if (u === "trigger" || o.getContextKeyValue(wV) === !1) return Qa.Trigger;
    const g = n.getValue(zA);
    return g === "automatic" ? Qa.Automatic : g === "trigger" ? Qa.Trigger : void 0;
  }, disposable: d, options: { keyboardSupport: !1, ...l, indent: typeof n.getValue(Hv) == "number" ? n.getValue(Hv) : void 0, renderIndentGuides: c, smoothScrolling: !!n.getValue(wa), defaultFindMode: SV(n), defaultFindMatchType: LV(n), horizontalScrolling: a, scrollByPage: !!n.getValue(Ca), paddingBottom: h, hideTwistiesOfChildlessElements: e.hideTwistiesOfChildlessElements, expandOnlyOnTwistieClick: (t = e.expandOnlyOnTwistieClick) !== null && t !== void 0 ? t : n.getValue(Yy) === "doubleClick", contextViewProvider: s, findWidgetStyles: lte, enableStickyScroll: !!n.getValue(Xy), stickyScrollMaxItemCount: Number(n.getValue(Qy)) } };
}
aF = Ud([qt(7, Se), qt(8, Te), qt(9, Jo), qt(10, Ye)], aF);
let _g = class {
  get onDidOpen() {
    return this.navigator.onDidOpen;
  }
  constructor(i, e, t, n, s, o, r) {
    var a;
    this.tree = i, this.disposables = [], this.contextKeyService = OL(s, i), this.disposables.push(FL(this.contextKeyService, i)), this.listSupportsMultiSelect = AL.bindTo(this.contextKeyService), this.listSupportsMultiSelect.set(e.multipleSelectionSupport !== !1), PL.bindTo(this.contextKeyService).set(!!e.selectionNavigation), this.listSupportFindWidget = pie.bindTo(this.contextKeyService), this.listSupportFindWidget.set((a = e.findWidgetEnabled) === null || a === void 0 || a), this.hasSelectionOrFocus = BA.bindTo(this.contextKeyService), this.hasDoubleSelection = WA.bindTo(this.contextKeyService), this.hasMultiSelection = VA.bindTo(this.contextKeyService), this.treeElementCanCollapse = u2.bindTo(this.contextKeyService), this.treeElementHasParent = mie.bindTo(this.contextKeyService), this.treeElementCanExpand = g2.bindTo(this.contextKeyService), this.treeElementHasChild = fie.bindTo(this.contextKeyService), this.treeFindOpen = _ie.bindTo(this.contextKeyService), this.treeStickyScrollFocused = bV.bindTo(this.contextKeyService), this._useAltAsMultipleSelectionModifier = wl(r), this.updateStyleOverrides(n);
    const l = () => {
      const h = i.getFocus()[0];
      if (!h) return;
      const c = i.getNode(h);
      this.treeElementCanCollapse.set(c.collapsible && !c.collapsed), this.treeElementHasParent.set(!!i.getParentElement(h)), this.treeElementCanExpand.set(c.collapsible && c.collapsed), this.treeElementHasChild.set(!!i.getFirstElementChild(h));
    }, d = /* @__PURE__ */ new Set();
    d.add(CV), d.add(wV), this.disposables.push(this.contextKeyService, o.register(i), i.onDidChangeSelection(() => {
      const h = i.getSelection(), c = i.getFocus();
      this.contextKeyService.bufferChangeEvents(() => {
        this.hasSelectionOrFocus.set(h.length > 0 || c.length > 0), this.hasMultiSelection.set(h.length > 1), this.hasDoubleSelection.set(h.length === 2);
      });
    }), i.onDidChangeFocus(() => {
      const h = i.getSelection(), c = i.getFocus();
      this.hasSelectionOrFocus.set(h.length > 0 || c.length > 0), l();
    }), i.onDidChangeCollapseState(l), i.onDidChangeModel(l), i.onDidChangeFindOpenState((h) => this.treeFindOpen.set(h)), i.onDidChangeStickyScrollFocused((h) => this.treeStickyScrollFocused.set(h)), r.onDidChangeConfiguration((h) => {
      let c = {};
      if (h.affectsConfiguration(Pg) && (this._useAltAsMultipleSelectionModifier = wl(r)), h.affectsConfiguration(Hv)) {
        const u = r.getValue(Hv);
        c = { ...c, indent: u };
      }
      if (h.affectsConfiguration(Zy) && e.renderIndentGuides === void 0) {
        const u = r.getValue(Zy);
        c = { ...c, renderIndentGuides: u };
      }
      if (h.affectsConfiguration(wa)) {
        const u = !!r.getValue(wa);
        c = { ...c, smoothScrolling: u };
      }
      if (h.affectsConfiguration(HA) || h.affectsConfiguration(Gy)) {
        const u = SV(r);
        c = { ...c, defaultFindMode: u };
      }
      if (h.affectsConfiguration(zA) || h.affectsConfiguration(Gy)) {
        const u = t();
        c = { ...c, typeNavigationMode: u };
      }
      if (h.affectsConfiguration(UA)) {
        const u = LV(r);
        c = { ...c, defaultFindMatchType: u };
      }
      if (h.affectsConfiguration(er) && e.horizontalScrolling === void 0) {
        const u = !!r.getValue(er);
        c = { ...c, horizontalScrolling: u };
      }
      if (h.affectsConfiguration(Ca)) {
        const u = !!r.getValue(Ca);
        c = { ...c, scrollByPage: u };
      }
      if (h.affectsConfiguration(Yy) && e.expandOnlyOnTwistieClick === void 0 && (c = { ...c, expandOnlyOnTwistieClick: r.getValue(Yy) === "doubleClick" }), h.affectsConfiguration(Xy)) {
        const u = r.getValue(Xy);
        c = { ...c, enableStickyScroll: u };
      }
      if (h.affectsConfiguration(Qy)) {
        const u = Math.max(1, r.getValue(Qy));
        c = { ...c, stickyScrollMaxItemCount: u };
      }
      if (h.affectsConfiguration(bl)) {
        const u = r.getValue(bl);
        c = { ...c, mouseWheelScrollSensitivity: u };
      }
      if (h.affectsConfiguration(Cl)) {
        const u = r.getValue(Cl);
        c = { ...c, fastScrollSensitivity: u };
      }
      Object.keys(c).length > 0 && i.updateOptions(c);
    }), this.contextKeyService.onDidChangeContext((h) => {
      h.affectsSome(d) && i.updateOptions({ typeNavigationMode: t() });
    })), this.navigator = new Cie(i, { configurationService: r, ...e }), this.disposables.push(this.navigator);
  }
  updateOptions(i) {
    i.multipleSelectionSupport !== void 0 && this.listSupportsMultiSelect.set(!!i.multipleSelectionSupport);
  }
  updateStyleOverrides(i) {
    this.tree.style(i ? Rg(i) : Tg);
  }
  dispose() {
    this.disposables = Ht(this.disposables);
  }
};
_g = Ud([qt(4, Te), qt(5, Jo), qt(6, Ye)], _g);
li.as(fa).registerConfiguration({ id: "workbench", order: 7, title: m(0, "Workbench"), type: "object", properties: { [Pg]: { type: "string", enum: ["ctrlCmd", "alt"], markdownEnumDescriptions: [m(0, "Maps to `Control` on Windows and Linux and to `Command` on macOS."), m(0, "Maps to `Alt` on Windows and Linux and to `Option` on macOS.")], default: "ctrlCmd", description: m(0, "The modifier to be used to add an item in trees and lists to a multi-selection with the mouse (for example in the explorer, open editors and scm view). The 'Open to Side' mouse gestures - if supported - will adapt such that they do not conflict with the multiselect modifier.") }, [ew]: { type: "string", enum: ["singleClick", "doubleClick"], default: "singleClick", description: m(0, "Controls how to open items in trees and lists using the mouse (if supported). Note that some trees and lists might choose to ignore this setting if it is not applicable.") }, [er]: { type: "boolean", default: !1, description: m(0, "Controls whether lists and trees support horizontal scrolling in the workbench. Warning: turning on this setting has a performance implication.") }, [Ca]: { type: "boolean", default: !1, description: m(0, "Controls whether clicks in the scrollbar scroll page by page.") }, [Hv]: { type: "number", default: 8, minimum: 4, maximum: 40, description: m(0, "Controls tree indentation in pixels.") }, [Zy]: { type: "string", enum: ["none", "onHover", "always"], default: "onHover", description: m(0, "Controls whether the tree should render indent guides.") }, [wa]: { type: "boolean", default: !1, description: m(0, "Controls whether lists and trees have smooth scrolling.") }, [bl]: { type: "number", default: 1, markdownDescription: m(0, "A multiplier to be used on the `deltaX` and `deltaY` of mouse wheel scroll events.") }, [Cl]: { type: "number", default: 5, markdownDescription: m(0, "Scrolling speed multiplier when pressing `Alt`.") }, [HA]: { type: "string", enum: ["highlight", "filter"], enumDescriptions: [m(0, "Highlight elements when searching. Further up and down navigation will traverse only the highlighted elements."), m(0, "Filter elements when searching.")], default: "highlight", description: m(0, "Controls the default find mode for lists and trees in the workbench.") }, [Gy]: { type: "string", enum: ["simple", "highlight", "filter"], enumDescriptions: [m(0, "Simple keyboard navigation focuses elements which match the keyboard input. Matching is done only on prefixes."), m(0, "Highlight keyboard navigation highlights elements which match the keyboard input. Further up and down navigation will traverse only the highlighted elements."), m(0, "Filter keyboard navigation will filter out and hide all the elements which do not match the keyboard input.")], default: "highlight", description: m(0, "Controls the keyboard navigation style for lists and trees in the workbench. Can be simple, highlight and filter."), deprecated: !0, deprecationMessage: m(0, "Please use 'workbench.list.defaultFindMode' and	'workbench.list.typeNavigationMode' instead.") }, [UA]: { type: "string", enum: ["fuzzy", "contiguous"], enumDescriptions: [m(0, "Use fuzzy matching when searching."), m(0, "Use contiguous matching when searching.")], default: "fuzzy", description: m(0, "Controls the type of matching used when searching lists and trees in the workbench.") }, [Yy]: { type: "string", enum: ["singleClick", "doubleClick"], default: "singleClick", description: m(0, "Controls how tree folders are expanded when clicking the folder names. Note that some trees and lists might choose to ignore this setting if it is not applicable.") }, [Xy]: { type: "boolean", default: !0, description: m(0, "Controls whether sticky scrolling is enabled in trees.") }, [Qy]: { type: "number", minimum: 1, default: 7, markdownDescription: m(0, "Controls the number of sticky elements displayed in the tree when `#workbench.tree.enableStickyScroll#` is enabled.") }, [zA]: { type: "string", enum: ["automatic", "trigger"], default: "automatic", markdownDescription: m(0, "Controls how type navigation works in lists and trees in the workbench. When set to `trigger`, type navigation begins once the `list.triggerTypeNavigation` command is run.") } } });
class oc extends V {
  constructor(e, t) {
    var n;
    super(), this.options = t, this.text = "", this.title = "", this.highlights = [], this.didEverRender = !1, this.supportIcons = (n = t == null ? void 0 : t.supportIcons) !== null && n !== void 0 && n, this.domNode = Z(e, Q("span.monaco-highlighted-label"));
  }
  get element() {
    return this.domNode;
  }
  set(e, t = [], n = "", s) {
    e || (e = ""), s && (e = oc.escapeNewLines(e, t)), this.didEverRender && this.text === e && this.title === n && So(this.highlights, t) || (this.text = e, this.title = n, this.highlights = t, this.render());
  }
  render() {
    var e, t, n, s;
    const o = [];
    let r = 0;
    for (const a of this.highlights) {
      if (a.end === a.start) continue;
      if (r < a.start) {
        const h = this.text.substring(r, a.start);
        this.supportIcons ? o.push(...ic(h)) : o.push(h), r = a.start;
      }
      const l = this.text.substring(r, a.end), d = Q("span.highlight", void 0, ...this.supportIcons ? ic(l) : [l]);
      a.extraClasses && d.classList.add(...a.extraClasses), o.push(d), r = a.end;
    }
    if (r < this.text.length) {
      const a = this.text.substring(r);
      this.supportIcons ? o.push(...ic(a)) : o.push(a);
    }
    if (wn(this.domNode, ...o), (t = (e = this.options) === null || e === void 0 ? void 0 : e.hoverDelegate) === null || t === void 0 ? void 0 : t.showNativeHover) this.domNode.title = this.title;
    else if (this.customHover || this.title === "") this.customHover && this.customHover.update(this.title);
    else {
      const a = (s = (n = this.options) === null || n === void 0 ? void 0 : n.hoverDelegate) !== null && s !== void 0 ? s : Bs("mouse");
      this.customHover = this._register(xr(a, this.domNode, this.title));
    }
    this.didEverRender = !0;
  }
  static escapeNewLines(e, t) {
    let n = 0, s = 0;
    return e.replace(/\r\n|\r|\n/g, (o, r) => {
      s = o === `\r
` ? -1 : 0, r += n;
      for (const a of t) a.end <= r || (a.start >= r && (a.start += s), a.end >= r && (a.end += s));
      return n += s, "⏎";
    });
  }
}
class $f {
  constructor(e) {
    this._element = e;
  }
  get element() {
    return this._element;
  }
  set textContent(e) {
    this.disposed || e === this._textContent || (this._textContent = e, this._element.textContent = e);
  }
  set className(e) {
    this.disposed || e === this._className || (this._className = e, this._element.className = e);
  }
  set empty(e) {
    this.disposed || e === this._empty || (this._empty = e, this._element.style.marginLeft = e ? "0" : "");
  }
  dispose() {
    this.disposed = !0;
  }
}
class Jy extends V {
  constructor(e, t) {
    var n;
    super(), this.customHovers = /* @__PURE__ */ new Map(), this.creationOptions = t, this.domNode = this._register(new $f(Z(e, Q(".monaco-icon-label")))), this.labelContainer = Z(this.domNode.element, Q(".monaco-icon-label-container")), this.nameContainer = Z(this.labelContainer, Q("span.monaco-icon-name-container")), t != null && t.supportHighlights || t != null && t.supportIcons ? this.nameNode = this._register(new Sie(this.nameContainer, !!t.supportIcons)) : this.nameNode = new yie(this.nameContainer), this.hoverDelegate = (n = t == null ? void 0 : t.hoverDelegate) !== null && n !== void 0 ? n : Bs("mouse");
  }
  get element() {
    return this.domNode.element;
  }
  setLabel(e, t, n) {
    var s;
    const o = ["monaco-icon-label"], r = ["monaco-icon-label-container"];
    let a = "";
    if (n && (n.extraClasses && o.push(...n.extraClasses), n.italic && o.push("italic"), n.strikethrough && o.push("strikethrough"), n.disabledCommand && r.push("disabled"), n.title && (typeof n.title == "string" ? a += n.title : a += e)), this.domNode.className = o.join(" "), this.domNode.element.setAttribute("aria-label", a), this.labelContainer.className = r.join(" "), this.setupHover(n != null && n.descriptionTitle ? this.labelContainer : this.element, n == null ? void 0 : n.title), this.nameNode.setLabel(e, n), t || this.descriptionNode) {
      const l = this.getOrCreateDescriptionNode();
      l instanceof oc ? (l.set(t || "", n ? n.descriptionMatches : void 0, void 0, n == null ? void 0 : n.labelEscapeNewLines), this.setupHover(l.element, n == null ? void 0 : n.descriptionTitle)) : (l.textContent = t && (n != null && n.labelEscapeNewLines) ? oc.escapeNewLines(t, []) : t || "", this.setupHover(l.element, (n == null ? void 0 : n.descriptionTitle) || ""), l.empty = !t);
    }
    (n != null && n.suffix || this.suffixNode) && (this.getOrCreateSuffixNode().textContent = (s = n == null ? void 0 : n.suffix) !== null && s !== void 0 ? s : "");
  }
  setupHover(e, t) {
    const n = this.customHovers.get(e);
    if (n && (n.dispose(), this.customHovers.delete(e)), t) if (this.hoverDelegate.showNativeHover) (function(s, o) {
      ps(o) ? s.title = yA(o) : o != null && o.markdownNotSupportedFallback ? s.title = o.markdownNotSupportedFallback : s.removeAttribute("title");
    })(e, t);
    else {
      const s = xr(this.hoverDelegate, e, t);
      s && this.customHovers.set(e, s);
    }
    else e.removeAttribute("title");
  }
  dispose() {
    super.dispose();
    for (const e of this.customHovers.values()) e.dispose();
    this.customHovers.clear();
  }
  getOrCreateSuffixNode() {
    if (!this.suffixNode) {
      const n = this._register(new $f((e = this.nameContainer, t = Q("span.monaco-icon-suffix-container"), e.after(t), t)));
      this.suffixNode = this._register(new $f(Z(n.element, Q("span.label-suffix"))));
    }
    var e, t;
    return this.suffixNode;
  }
  getOrCreateDescriptionNode() {
    var e;
    if (!this.descriptionNode) {
      const t = this._register(new $f(Z(this.labelContainer, Q("span.monaco-icon-description-container"))));
      !((e = this.creationOptions) === null || e === void 0) && e.supportDescriptionHighlights ? this.descriptionNode = this._register(new oc(Z(t.element, Q("span.label-description")), { supportIcons: !!this.creationOptions.supportIcons })) : this.descriptionNode = this._register(new $f(Z(t.element, Q("span.label-description"))));
    }
    return this.descriptionNode;
  }
}
class yie {
  constructor(e) {
    this.container = e, this.label = void 0, this.singleLabel = void 0;
  }
  setLabel(e, t) {
    if (this.label !== e || !So(this.options, t)) if (this.label = e, this.options = t, typeof e == "string") this.singleLabel || (this.container.innerText = "", this.container.classList.remove("multiple"), this.singleLabel = Z(this.container, Q("a.label-name", { id: t == null ? void 0 : t.domId }))), this.singleLabel.textContent = e;
    else {
      this.container.innerText = "", this.container.classList.add("multiple"), this.singleLabel = void 0;
      for (let n = 0; n < e.length; n++) {
        const s = e[n], o = (t == null ? void 0 : t.domId) && `${t == null ? void 0 : t.domId}_${n}`;
        Z(this.container, Q("a.label-name", { id: o, "data-icon-label-count": e.length, "data-icon-label-index": n, role: "treeitem" }, s)), n < e.length - 1 && Z(this.container, Q("span.label-separator", void 0, (t == null ? void 0 : t.separator) || "/"));
      }
    }
  }
}
class Sie extends V {
  constructor(e, t) {
    super(), this.container = e, this.supportIcons = t, this.label = void 0, this.singleLabel = void 0;
  }
  setLabel(e, t) {
    if (this.label !== e || !So(this.options, t)) if (this.label = e, this.options = t, typeof e == "string") this.singleLabel || (this.container.innerText = "", this.container.classList.remove("multiple"), this.singleLabel = this._register(new oc(Z(this.container, Q("a.label-name", { id: t == null ? void 0 : t.domId })), { supportIcons: this.supportIcons }))), this.singleLabel.set(e, t == null ? void 0 : t.matches, void 0, t == null ? void 0 : t.labelEscapeNewLines);
    else {
      this.container.innerText = "", this.container.classList.add("multiple"), this.singleLabel = void 0;
      const n = (t == null ? void 0 : t.separator) || "/", s = function(o, r, a) {
        if (!a) return;
        let l = 0;
        return o.map((d) => {
          const h = { start: l, end: l + d.length }, c = a.map((u) => Fn.intersect(h, u)).filter((u) => !Fn.isEmpty(u)).map(({ start: u, end: g }) => ({ start: u - l, end: g - l }));
          return l = h.end + r.length, c;
        });
      }(e, n, t == null ? void 0 : t.matches);
      for (let o = 0; o < e.length; o++) {
        const r = e[o], a = s ? s[o] : void 0, l = Q("a.label-name", { id: (t == null ? void 0 : t.domId) && `${t == null ? void 0 : t.domId}_${o}`, "data-icon-label-count": e.length, "data-icon-label-index": o, role: "treeitem" });
        this._register(new oc(Z(this.container, l), { supportIcons: this.supportIcons })).set(r, a, void 0, t == null ? void 0 : t.labelEscapeNewLines), o < e.length - 1 && Z(l, Q("span.label-separator", void 0, n));
      }
    }
  }
}
const Kb = Q, kV = { keybindingLabelBackground: void 0, keybindingLabelForeground: void 0, keybindingLabelBorder: void 0, keybindingLabelBottomBorder: void 0, keybindingLabelShadow: void 0 };
class yf extends V {
  constructor(e, t, n) {
    super(), this.os = t, this.keyElements = /* @__PURE__ */ new Set(), this.options = n || /* @__PURE__ */ Object.create(null);
    const s = this.options.keybindingLabelForeground;
    this.domNode = Z(e, Kb(".monaco-keybinding")), s && (this.domNode.style.color = s), this.hover = this._register(xr(Bs("mouse"), this.domNode, "")), this.didEverRender = !1, e.appendChild(this.domNode);
  }
  get element() {
    return this.domNode;
  }
  set(e, t) {
    this.didEverRender && this.keybinding === e && yf.areSame(this.matches, t) || (this.keybinding = e, this.matches = t, this.render());
  }
  render() {
    var e;
    if (this.clear(), this.keybinding) {
      const t = this.keybinding.getChords();
      t[0] && this.renderChord(this.domNode, t[0], this.matches ? this.matches.firstPart : null);
      for (let s = 1; s < t.length; s++) Z(this.domNode, Kb("span.monaco-keybinding-key-chord-separator", void 0, " ")), this.renderChord(this.domNode, t[s], this.matches ? this.matches.chordPart : null);
      const n = (e = this.options.disableTitle) !== null && e !== void 0 && e ? void 0 : this.keybinding.getAriaLabel() || void 0;
      this.hover.update(n), this.domNode.setAttribute("aria-label", n || "");
    } else this.options && this.options.renderUnboundKeybindings && this.renderUnbound(this.domNode);
    this.didEverRender = !0;
  }
  clear() {
    Un(this.domNode), this.keyElements.clear();
  }
  renderChord(e, t, n) {
    const s = xA.modifierLabels[this.os];
    t.ctrlKey && this.renderKey(e, s.ctrlKey, !!(n != null && n.ctrlKey), s.separator), t.shiftKey && this.renderKey(e, s.shiftKey, !!(n != null && n.shiftKey), s.separator), t.altKey && this.renderKey(e, s.altKey, !!(n != null && n.altKey), s.separator), t.metaKey && this.renderKey(e, s.metaKey, !!(n != null && n.metaKey), s.separator);
    const o = t.keyLabel;
    o && this.renderKey(e, o, !!(n != null && n.keyCode), "");
  }
  renderKey(e, t, n, s) {
    Z(e, this.createKeyElement(t, n ? ".highlight" : "")), s && Z(e, Kb("span.monaco-keybinding-key-separator", void 0, s));
  }
  renderUnbound(e) {
    Z(e, this.createKeyElement(m(0, "Unbound")));
  }
  createKeyElement(e, t = "") {
    const n = Kb("span.monaco-keybinding-key" + t, void 0, e);
    return this.keyElements.add(n), this.options.keybindingLabelBackground && (n.style.backgroundColor = this.options.keybindingLabelBackground), this.options.keybindingLabelBorder && (n.style.borderColor = this.options.keybindingLabelBorder), this.options.keybindingLabelBottomBorder && (n.style.borderBottomColor = this.options.keybindingLabelBottomBorder), this.options.keybindingLabelShadow && (n.style.boxShadow = `inset 0 -1px 0 ${this.options.keybindingLabelShadow}`), n;
  }
  static areSame(e, t) {
    return e === t || !e && !t || !!e && !!t && So(e.firstPart, t.firstPart) && So(e.chordPart, t.chordPart);
  }
}
const lF = new ga(() => {
  const i = new Intl.Collator(void 0, { numeric: !0, sensitivity: "base" });
  return { collator: i, collatorIsNumeric: i.resolvedOptions().numeric };
});
function Lie(i, e, t) {
  const n = i.toLowerCase(), s = e.toLowerCase(), o = function(l, d, h) {
    const c = l.toLowerCase(), u = d.toLowerCase(), g = c.startsWith(h), p = u.startsWith(h);
    if (g !== p) return g ? -1 : 1;
    if (g && p) {
      if (c.length < u.length) return -1;
      if (c.length > u.length) return 1;
    }
    return 0;
  }(i, e, t);
  if (o) return o;
  const r = n.endsWith(t);
  if (r !== s.endsWith(t)) return r ? -1 : 1;
  const a = function(l, d, h = !1) {
    const c = l || "", u = d || "", g = lF.value.collator.compare(c, u);
    return lF.value.collatorIsNumeric && g === 0 && c !== u ? c < u ? -1 : 1 : g;
  }(n, s);
  return a !== 0 ? a : n.localeCompare(s);
}
var f2, tw = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, DV = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const Or = Q;
var Hi, Fa;
(function(i) {
  i[i.First = 1] = "First", i[i.Second = 2] = "Second", i[i.Last = 3] = "Last", i[i.Next = 4] = "Next", i[i.Previous = 5] = "Previous", i[i.NextPage = 6] = "NextPage", i[i.PreviousPage = 7] = "PreviousPage", i[i.NextSeparator = 8] = "NextSeparator", i[i.PreviousSeparator = 9] = "PreviousSeparator";
})(Hi || (Hi = {}));
class xV {
  constructor(e, t, n) {
    this.index = e, this.hasCheckbox = t, this._hidden = !1, this._init = new ga(() => {
      var s;
      const o = (s = n.label) !== null && s !== void 0 ? s : "", r = I_(o).text.trim(), a = n.ariaLabel || [o, this.saneDescription, this.saneDetail].map((l) => function(d) {
        return d ? d.replace(/\$\((.*?)\)/g, (h, c) => ` ${c} `).trim() : "";
      }(l)).filter((l) => !!l).join(", ");
      return { saneLabel: o, saneSortLabel: r, saneAriaLabel: a };
    }), this._saneDescription = n.description, this._saneTooltip = n.tooltip;
  }
  get saneLabel() {
    return this._init.value.saneLabel;
  }
  get saneSortLabel() {
    return this._init.value.saneSortLabel;
  }
  get saneAriaLabel() {
    return this._init.value.saneAriaLabel;
  }
  get element() {
    return this._element;
  }
  set element(e) {
    this._element = e;
  }
  get hidden() {
    return this._hidden;
  }
  set hidden(e) {
    this._hidden = e;
  }
  get saneDescription() {
    return this._saneDescription;
  }
  set saneDescription(e) {
    this._saneDescription = e;
  }
  get saneDetail() {
    return this._saneDetail;
  }
  set saneDetail(e) {
    this._saneDetail = e;
  }
  get saneTooltip() {
    return this._saneTooltip;
  }
  set saneTooltip(e) {
    this._saneTooltip = e;
  }
  get labelHighlights() {
    return this._labelHighlights;
  }
  set labelHighlights(e) {
    this._labelHighlights = e;
  }
  get descriptionHighlights() {
    return this._descriptionHighlights;
  }
  set descriptionHighlights(e) {
    this._descriptionHighlights = e;
  }
  get detailHighlights() {
    return this._detailHighlights;
  }
  set detailHighlights(e) {
    this._detailHighlights = e;
  }
}
class qn extends xV {
  constructor(e, t, n, s, o, r) {
    var a, l, d;
    super(e, t, o), this.fireButtonTriggered = n, this._onChecked = s, this.item = o, this._separator = r, this._checked = !1, this.onChecked = t ? se.map(se.filter(this._onChecked.event, (h) => h.element === this), (h) => h.checked) : se.None, this._saneDetail = o.detail, this._labelHighlights = (a = o.highlights) === null || a === void 0 ? void 0 : a.label, this._descriptionHighlights = (l = o.highlights) === null || l === void 0 ? void 0 : l.description, this._detailHighlights = (d = o.highlights) === null || d === void 0 ? void 0 : d.detail;
  }
  get separator() {
    return this._separator;
  }
  set separator(e) {
    this._separator = e;
  }
  get checked() {
    return this._checked;
  }
  set checked(e) {
    e !== this._checked && (this._checked = e, this._onChecked.fire({ element: this, checked: e }));
  }
  get checkboxDisabled() {
    return !!this.item.disabled;
  }
}
(function(i) {
  i[i.NONE = 0] = "NONE", i[i.MOUSE_HOVER = 1] = "MOUSE_HOVER", i[i.ACTIVE_ITEM = 2] = "ACTIVE_ITEM";
})(Fa || (Fa = {}));
class lh extends xV {
  constructor(e, t, n) {
    super(e, !1, n), this.fireSeparatorButtonTriggered = t, this.separator = n, this.children = new Array(), this.focusInsideSeparator = Fa.NONE;
  }
}
class kie {
  getHeight(e) {
    return e instanceof lh ? 30 : e.saneDetail ? 44 : 22;
  }
  getTemplateId(e) {
    return e instanceof qn ? b0.ID : W1.ID;
  }
}
class Die {
  getWidgetAriaLabel() {
    return m(0, "Quick Input");
  }
  getAriaLabel(e) {
    var t;
    return !((t = e.separator) === null || t === void 0) && t.label ? `${e.saneAriaLabel}, ${e.separator.label}` : e.saneAriaLabel;
  }
  getWidgetRole() {
    return "listbox";
  }
  getRole(e) {
    return e.hasCheckbox ? "checkbox" : "option";
  }
  isChecked(e) {
    if (e.hasCheckbox && e instanceof qn) return { value: e.checked, onDidChange: e.onChecked };
  }
}
class NV {
  constructor(e) {
    this.hoverDelegate = e;
  }
  renderTemplate(e) {
    const t = /* @__PURE__ */ Object.create(null);
    t.toDisposeElement = new G(), t.toDisposeTemplate = new G(), t.entry = Z(e, Or(".quick-input-list-entry"));
    const n = Z(t.entry, Or("label.quick-input-list-label"));
    t.toDisposeTemplate.add(bi(n, ie.CLICK, (d) => {
      t.checkbox.offsetParent || d.preventDefault();
    })), t.checkbox = Z(n, Or("input.quick-input-list-checkbox")), t.checkbox.type = "checkbox";
    const s = Z(n, Or(".quick-input-list-rows")), o = Z(s, Or(".quick-input-list-row")), r = Z(s, Or(".quick-input-list-row"));
    t.label = new Jy(o, { supportHighlights: !0, supportDescriptionHighlights: !0, supportIcons: !0, hoverDelegate: this.hoverDelegate }), t.toDisposeTemplate.add(t.label), t.icon = _R(t.label.element, Or(".quick-input-list-icon"));
    const a = Z(o, Or(".quick-input-list-entry-keybinding"));
    t.keybinding = new yf(a, Gs), t.toDisposeTemplate.add(t.keybinding);
    const l = Z(r, Or(".quick-input-list-label-meta"));
    return t.detail = new Jy(l, { supportHighlights: !0, supportIcons: !0, hoverDelegate: this.hoverDelegate }), t.toDisposeTemplate.add(t.detail), t.separator = Z(t.entry, Or(".quick-input-list-separator")), t.actionBar = new sr(t.entry, this.hoverDelegate ? { hoverDelegate: this.hoverDelegate } : void 0), t.actionBar.domNode.classList.add("quick-input-list-entry-action-bar"), t.toDisposeTemplate.add(t.actionBar), t;
  }
  disposeTemplate(e) {
    e.toDisposeElement.dispose(), e.toDisposeTemplate.dispose();
  }
  disposeElement(e, t, n) {
    n.toDisposeElement.clear(), n.actionBar.clear();
  }
}
let b0 = f2 = class extends NV {
  constructor(i, e) {
    super(i), this.themeService = e, this._itemsWithSeparatorsFrequency = /* @__PURE__ */ new Map();
  }
  get templateId() {
    return f2.ID;
  }
  renderTemplate(i) {
    const e = super.renderTemplate(i);
    return e.toDisposeTemplate.add(bi(e.checkbox, ie.CHANGE, (t) => {
      e.element.checked = e.checkbox.checked;
    })), e;
  }
  renderElement(i, e, t) {
    var n, s, o;
    const r = i.element;
    t.element = r, r.element = (n = t.entry) !== null && n !== void 0 ? n : void 0;
    const a = r.item;
    t.checkbox.checked = r.checked, t.toDisposeElement.add(r.onChecked((p) => t.checkbox.checked = p)), t.checkbox.disabled = r.checkboxDisabled;
    const { labelHighlights: l, descriptionHighlights: d, detailHighlights: h } = r;
    if (a.iconPath) {
      const p = Km(this.themeService.getColorTheme().type) ? a.iconPath.dark : (s = a.iconPath.light) !== null && s !== void 0 ? s : a.iconPath.dark, f = Ie.revive(p);
      t.icon.className = "quick-input-list-icon", t.icon.style.backgroundImage = yc(f);
    } else t.icon.style.backgroundImage = "", t.icon.className = a.iconClass ? `quick-input-list-icon ${a.iconClass}` : "";
    let c;
    !r.saneTooltip && r.saneDescription && (c = { markdown: { value: r.saneDescription, supportThemeIcons: !0 }, markdownNotSupportedFallback: r.saneDescription });
    const u = { matches: l || [], descriptionTitle: c, descriptionMatches: d || [], labelEscapeNewLines: !0 };
    if (u.extraClasses = a.iconClasses, u.italic = a.italic, u.strikethrough = a.strikethrough, t.entry.classList.remove("quick-input-list-separator-as-item"), t.label.setLabel(r.saneLabel, r.saneDescription, u), t.keybinding.set(a.keybinding), r.saneDetail) {
      let p;
      r.saneTooltip || (p = { markdown: { value: r.saneDetail, supportThemeIcons: !0 }, markdownNotSupportedFallback: r.saneDetail }), t.detail.element.style.display = "", t.detail.setLabel(r.saneDetail, void 0, { matches: h, title: p, labelEscapeNewLines: !0 });
    } else t.detail.element.style.display = "none";
    !((o = r.separator) === null || o === void 0) && o.label ? (t.separator.textContent = r.separator.label, t.separator.style.display = "", this.addItemWithSeparator(r)) : t.separator.style.display = "none", t.entry.classList.toggle("quick-input-list-separator-border", !!r.separator);
    const g = a.buttons;
    g && g.length ? (t.actionBar.push(g.map((p, f) => Ky(p, `id-${f}`, () => r.fireButtonTriggered({ button: p, item: r.item }))), { icon: !0, label: !1 }), t.entry.classList.add("has-actions")) : t.entry.classList.remove("has-actions");
  }
  disposeElement(i, e, t) {
    this.removeItemWithSeparator(i.element), super.disposeElement(i, e, t);
  }
  isItemWithSeparatorVisible(i) {
    return this._itemsWithSeparatorsFrequency.has(i);
  }
  addItemWithSeparator(i) {
    this._itemsWithSeparatorsFrequency.set(i, (this._itemsWithSeparatorsFrequency.get(i) || 0) + 1);
  }
  removeItemWithSeparator(i) {
    const e = this._itemsWithSeparatorsFrequency.get(i) || 0;
    e > 1 ? this._itemsWithSeparatorsFrequency.set(i, e - 1) : this._itemsWithSeparatorsFrequency.delete(i);
  }
};
b0.ID = "quickpickitem", b0 = f2 = tw([DV(1, Yi)], b0);
class W1 extends NV {
  constructor() {
    super(...arguments), this._visibleSeparatorsFrequency = /* @__PURE__ */ new Map();
  }
  get templateId() {
    return W1.ID;
  }
  get visibleSeparators() {
    return [...this._visibleSeparatorsFrequency.keys()];
  }
  isSeparatorVisible(e) {
    return this._visibleSeparatorsFrequency.has(e);
  }
  renderElement(e, t, n) {
    var s;
    const o = e.element;
    n.element = o, o.element = (s = n.entry) !== null && s !== void 0 ? s : void 0, o.element.classList.toggle("focus-inside", !!o.focusInsideSeparator);
    const r = o.separator, { labelHighlights: a, descriptionHighlights: l, detailHighlights: d } = o;
    let h;
    n.icon.style.backgroundImage = "", n.icon.className = "", !o.saneTooltip && o.saneDescription && (h = { markdown: { value: o.saneDescription, supportThemeIcons: !0 }, markdownNotSupportedFallback: o.saneDescription });
    const c = { matches: a || [], descriptionTitle: h, descriptionMatches: l || [], labelEscapeNewLines: !0 };
    if (n.entry.classList.add("quick-input-list-separator-as-item"), n.label.setLabel(o.saneLabel, o.saneDescription, c), o.saneDetail) {
      let g;
      o.saneTooltip || (g = { markdown: { value: o.saneDetail, supportThemeIcons: !0 }, markdownNotSupportedFallback: o.saneDetail }), n.detail.element.style.display = "", n.detail.setLabel(o.saneDetail, void 0, { matches: d, title: g, labelEscapeNewLines: !0 });
    } else n.detail.element.style.display = "none";
    n.separator.style.display = "none", n.entry.classList.add("quick-input-list-separator-border");
    const u = r.buttons;
    u && u.length ? (n.actionBar.push(u.map((g, p) => Ky(g, `id-${p}`, () => o.fireSeparatorButtonTriggered({ button: g, separator: o.separator }))), { icon: !0, label: !1 }), n.entry.classList.add("has-actions")) : n.entry.classList.remove("has-actions"), this.addSeparator(o);
  }
  disposeElement(e, t, n) {
    var s;
    this.removeSeparator(e.element), this.isSeparatorVisible(e.element) || (s = e.element.element) === null || s === void 0 || s.classList.remove("focus-inside"), super.disposeElement(e, t, n);
  }
  addSeparator(e) {
    this._visibleSeparatorsFrequency.set(e, (this._visibleSeparatorsFrequency.get(e) || 0) + 1);
  }
  removeSeparator(e) {
    const t = this._visibleSeparatorsFrequency.get(e) || 0;
    t > 1 ? this._visibleSeparatorsFrequency.set(e, t - 1) : this._visibleSeparatorsFrequency.delete(e);
  }
}
W1.ID = "quickpickseparator";
let R_ = class extends V {
  constructor(i, e, t, n, s) {
    super(), this.parent = i, this.hoverDelegate = e, this.linkOpenerDelegate = t, this._onKeyDown = new F(), this.onKeyDown = this._onKeyDown.event, this._onLeave = new F(), this.onLeave = this._onLeave.event, this._onChangedAllVisibleChecked = new F(), this.onChangedAllVisibleChecked = this._onChangedAllVisibleChecked.event, this._onChangedCheckedCount = new F(), this.onChangedCheckedCount = this._onChangedCheckedCount.event, this._onChangedVisibleCount = new F(), this.onChangedVisibleCount = this._onChangedVisibleCount.event, this._onChangedCheckedElements = new F(), this.onChangedCheckedElements = this._onChangedCheckedElements.event, this._onButtonTriggered = new F(), this.onButtonTriggered = this._onButtonTriggered.event, this._onSeparatorButtonTriggered = new F(), this.onSeparatorButtonTriggered = this._onSeparatorButtonTriggered.event, this._onTriggerEmptySelectionOrFocus = new F(), this._elementChecked = new F(), this._inputElements = new Array(), this._elementTree = new Array(), this._itemElements = new Array(), this._elementDisposable = this._register(new G()), this._shouldFireCheckedEvents = !0, this._matchOnDescription = !1, this._matchOnDetail = !1, this._matchOnLabel = !0, this._matchOnLabelMode = "fuzzy", this._sortByLabel = !0, this._container = Z(this.parent, Or(".quick-input-list")), this._separatorRenderer = new W1(e), this._itemRenderer = s.createInstance(b0, e), this._tree = this._register(s.createInstance(p2, "QuickInput", this._container, new kie(), [this._itemRenderer, this._separatorRenderer], { accessibilityProvider: new Die(), setRowLineHeight: !1, multipleSelectionSupport: !1, hideTwistiesOfChildlessElements: !0, renderIndentGuides: sf.None, findWidgetEnabled: !1, indent: 0, horizontalScrolling: !1, allowNonCollapsibleParents: !0, identityProvider: { getId: (o) => {
      var r, a, l, d, h, c, u, g;
      return (g = (c = (d = (a = (r = o.item) === null || r === void 0 ? void 0 : r.id) !== null && a !== void 0 ? a : (l = o.item) === null || l === void 0 ? void 0 : l.label) !== null && d !== void 0 ? d : (h = o.separator) === null || h === void 0 ? void 0 : h.id) !== null && c !== void 0 ? c : (u = o.separator) === null || u === void 0 ? void 0 : u.label) !== null && g !== void 0 ? g : "";
    } }, alwaysConsumeMouseWheel: !0 })), this._tree.getHTMLElement().id = n, this._registerListeners();
  }
  get onDidChangeFocus() {
    return se.map(se.any(this._tree.onDidChangeFocus, this._onTriggerEmptySelectionOrFocus.event), (i) => i.elements.filter((e) => e instanceof qn).map((e) => e.item));
  }
  get onDidChangeSelection() {
    return se.map(se.any(this._tree.onDidChangeSelection, this._onTriggerEmptySelectionOrFocus.event), (i) => ({ items: i.elements.filter((e) => e instanceof qn).map((e) => e.item), event: i.browserEvent }));
  }
  get scrollTop() {
    return this._tree.scrollTop;
  }
  set scrollTop(i) {
    this._tree.scrollTop = i;
  }
  get ariaLabel() {
    return this._tree.ariaLabel;
  }
  set ariaLabel(i) {
    this._tree.ariaLabel = i ?? "";
  }
  set enabled(i) {
    this._tree.getHTMLElement().style.pointerEvents = i ? "" : "none";
  }
  get matchOnDescription() {
    return this._matchOnDescription;
  }
  set matchOnDescription(i) {
    this._matchOnDescription = i;
  }
  get matchOnDetail() {
    return this._matchOnDetail;
  }
  set matchOnDetail(i) {
    this._matchOnDetail = i;
  }
  get matchOnLabel() {
    return this._matchOnLabel;
  }
  set matchOnLabel(i) {
    this._matchOnLabel = i;
  }
  get matchOnLabelMode() {
    return this._matchOnLabelMode;
  }
  set matchOnLabelMode(i) {
    this._matchOnLabelMode = i;
  }
  get sortByLabel() {
    return this._sortByLabel;
  }
  set sortByLabel(i) {
    this._sortByLabel = i;
  }
  _registerListeners() {
    this._registerOnKeyDown(), this._registerOnContainerClick(), this._registerOnMouseMiddleClick(), this._registerOnElementChecked(), this._registerOnContextMenu(), this._registerHoverListeners(), this._registerSelectionChangeListener(), this._registerSeparatorActionShowingListeners();
  }
  _registerOnKeyDown() {
    this._register(this._tree.onKeyDown((i) => {
      const e = new jt(i);
      switch (e.keyCode) {
        case 10:
          this.toggleCheckbox();
          break;
        case 31:
          (Je ? i.metaKey : i.ctrlKey) && this._tree.setFocus(this._itemElements);
          break;
        case 16: {
          const t = this._tree.getFocus();
          t.length === 1 && t[0] === this._itemElements[0] && this._onLeave.fire();
          break;
        }
        case 18: {
          const t = this._tree.getFocus();
          t.length === 1 && t[0] === this._itemElements[this._itemElements.length - 1] && this._onLeave.fire();
          break;
        }
      }
      this._onKeyDown.fire(e);
    }));
  }
  _registerOnContainerClick() {
    this._register(K(this._container, ie.CLICK, (i) => {
      (i.x || i.y) && this._onLeave.fire();
    }));
  }
  _registerOnMouseMiddleClick() {
    this._register(K(this._container, ie.AUXCLICK, (i) => {
      i.button === 1 && this._onLeave.fire();
    }));
  }
  _registerOnElementChecked() {
    this._register(this._elementChecked.event((i) => this._fireCheckedEvents()));
  }
  _registerOnContextMenu() {
    this._register(this._tree.onContextMenu((i) => {
      i.element && (i.browserEvent.preventDefault(), this._tree.setSelection([i.element]));
    }));
  }
  _registerHoverListeners() {
    const i = this._register(new a8(this.hoverDelegate.delay));
    this._register(this._tree.onMouseOver(async (e) => {
      var t;
      if (e.browserEvent.target instanceof HTMLAnchorElement) i.cancel();
      else if (e.browserEvent.relatedTarget instanceof HTMLAnchorElement || !gn(e.browserEvent.relatedTarget, (t = e.element) === null || t === void 0 ? void 0 : t.element)) try {
        await i.trigger(async () => {
          e.element instanceof qn && this.showHover(e.element);
        });
      } catch (n) {
        if (!Sa(n)) throw n;
      }
    })), this._register(this._tree.onMouseOut((e) => {
      var t;
      gn(e.browserEvent.relatedTarget, (t = e.element) === null || t === void 0 ? void 0 : t.element) || i.cancel();
    }));
  }
  _registerSeparatorActionShowingListeners() {
    this._register(this._tree.onDidChangeFocus((i) => {
      const e = i.elements[0] ? this._tree.getParentElement(i.elements[0]) : null;
      for (const t of this._separatorRenderer.visibleSeparators) {
        const n = t === e;
        !!(t.focusInsideSeparator & Fa.ACTIVE_ITEM) !== n && (n ? t.focusInsideSeparator |= Fa.ACTIVE_ITEM : t.focusInsideSeparator &= ~Fa.ACTIVE_ITEM, this._tree.rerender(t));
      }
    })), this._register(this._tree.onMouseOver((i) => {
      const e = i.element ? this._tree.getParentElement(i.element) : null;
      for (const t of this._separatorRenderer.visibleSeparators)
        t === e && (t.focusInsideSeparator & Fa.MOUSE_HOVER || (t.focusInsideSeparator |= Fa.MOUSE_HOVER, this._tree.rerender(t)));
    })), this._register(this._tree.onMouseOut((i) => {
      const e = i.element ? this._tree.getParentElement(i.element) : null;
      for (const t of this._separatorRenderer.visibleSeparators)
        t === e && t.focusInsideSeparator & Fa.MOUSE_HOVER && (t.focusInsideSeparator &= ~Fa.MOUSE_HOVER, this._tree.rerender(t));
    }));
  }
  _registerSelectionChangeListener() {
    this._register(this._tree.onDidChangeSelection((i) => {
      const e = i.elements.filter((t) => t instanceof qn);
      e.length !== i.elements.length && (i.elements.length === 1 && i.elements[0] instanceof lh && (this._tree.setFocus([i.elements[0].children[0]]), this._tree.reveal(i.elements[0], 0)), this._tree.setSelection(e));
    }));
  }
  getAllVisibleChecked() {
    return this._allVisibleChecked(this._itemElements, !1);
  }
  getCheckedCount() {
    return this._itemElements.filter((i) => i.checked).length;
  }
  getVisibleCount() {
    return this._itemElements.filter((i) => !i.hidden).length;
  }
  setAllVisibleChecked(i) {
    try {
      this._shouldFireCheckedEvents = !1, this._itemElements.forEach((e) => {
        e.hidden || e.checkboxDisabled || (e.checked = i);
      });
    } finally {
      this._shouldFireCheckedEvents = !0, this._fireCheckedEvents();
    }
  }
  setElements(i) {
    this._elementDisposable.clear(), this._inputElements = i;
    const e = this.parent.classList.contains("show-checkboxes");
    let t;
    this._itemElements = new Array(), this._elementTree = i.reduce((o, r, a) => {
      let l;
      if (r.type === "separator") {
        if (!r.buttons) return o;
        t = new lh(a, (d) => this.fireSeparatorButtonTriggered(d), r), l = t;
      } else {
        const d = a > 0 ? i[a - 1] : void 0;
        let h;
        d && d.type === "separator" && !d.buttons && (t = void 0, h = d);
        const c = new qn(a, e, (u) => this.fireButtonTriggered(u), this._elementChecked, r, h);
        if (this._itemElements.push(c), t) return t.children.push(c), o;
        l = c;
      }
      return o.push(l), o;
    }, new Array());
    const n = new Array();
    let s = 0;
    for (const o of this._elementTree) o instanceof lh ? (n.push({ element: o, collapsible: !1, collapsed: !1, children: o.children.map((r) => ({ element: r, collapsible: !1, collapsed: !1 })) }), s += o.children.length + 1) : (n.push({ element: o, collapsible: !1, collapsed: !1 }), s++);
    this._tree.setChildren(null, n), this._onChangedVisibleCount.fire(s);
  }
  setFocusedElements(i) {
    const e = i.map((t) => this._itemElements.find((n) => n.item === t)).filter((t) => !!t);
    if (this._tree.setFocus(e), i.length > 0) {
      const t = this._tree.getFocus()[0];
      t && this._tree.reveal(t);
    }
  }
  getActiveDescendant() {
    return this._tree.getHTMLElement().getAttribute("aria-activedescendant");
  }
  setSelectedElements(i) {
    const e = i.map((t) => this._itemElements.find((n) => n.item === t)).filter((t) => !!t);
    this._tree.setSelection(e);
  }
  getCheckedElements() {
    return this._itemElements.filter((i) => i.checked).map((i) => i.item);
  }
  setCheckedElements(i) {
    try {
      this._shouldFireCheckedEvents = !1;
      const e = /* @__PURE__ */ new Set();
      for (const t of i) e.add(t);
      for (const t of this._itemElements) t.checked = e.has(t.item);
    } finally {
      this._shouldFireCheckedEvents = !0, this._fireCheckedEvents();
    }
  }
  focus(i) {
    var e;
    if (this._itemElements.length) switch (i === Hi.Second && this._itemElements.length < 2 && (i = Hi.First), i) {
      case Hi.First:
        this._tree.scrollTop = 0, this._tree.focusFirst(void 0, (t) => t.element instanceof qn);
        break;
      case Hi.Second:
        this._tree.scrollTop = 0, this._tree.setFocus([this._itemElements[1]]);
        break;
      case Hi.Last:
        this._tree.scrollTop = this._tree.scrollHeight, this._tree.setFocus([this._itemElements[this._itemElements.length - 1]]);
        break;
      case Hi.Next:
        this._tree.focusNext(void 0, !0, void 0, (t) => t.element instanceof qn && (this._tree.reveal(t.element), !0));
        break;
      case Hi.Previous:
        this._tree.focusPrevious(void 0, !0, void 0, (t) => {
          if (!(t.element instanceof qn)) return !1;
          const n = this._tree.getParentElement(t.element);
          return n === null || n.children[0] !== t.element ? this._tree.reveal(t.element) : this._tree.reveal(n), !0;
        });
        break;
      case Hi.NextPage:
        this._tree.focusNextPage(void 0, (t) => t.element instanceof qn && (this._tree.reveal(t.element), !0));
        break;
      case Hi.PreviousPage:
        this._tree.focusPreviousPage(void 0, (t) => {
          if (!(t.element instanceof qn)) return !1;
          const n = this._tree.getParentElement(t.element);
          return n === null || n.children[0] !== t.element ? this._tree.reveal(t.element) : this._tree.reveal(n), !0;
        });
        break;
      case Hi.NextSeparator: {
        let t = !1;
        const n = this._tree.getFocus()[0];
        this._tree.focusNext(void 0, !0, void 0, (s) => {
          if (t) return !0;
          if (s.element instanceof lh) t = !0, this._separatorRenderer.isSeparatorVisible(s.element) ? this._tree.reveal(s.element.children[0]) : this._tree.reveal(s.element, 0);
          else if (s.element instanceof qn) {
            if (s.element.separator) return this._itemRenderer.isItemWithSeparatorVisible(s.element) ? this._tree.reveal(s.element) : this._tree.reveal(s.element, 0), !0;
            if (s.element === this._elementTree[0]) return this._tree.reveal(s.element, 0), !0;
          }
          return !1;
        }), n === this._tree.getFocus()[0] && (this._tree.scrollTop = this._tree.scrollHeight, this._tree.setFocus([this._itemElements[this._itemElements.length - 1]]));
        break;
      }
      case Hi.PreviousSeparator: {
        let t, n = !!(!((e = this._tree.getFocus()[0]) === null || e === void 0) && e.separator);
        this._tree.focusPrevious(void 0, !0, void 0, (s) => {
          if (s.element instanceof lh) n ? t || (this._separatorRenderer.isSeparatorVisible(s.element) ? this._tree.reveal(s.element) : this._tree.reveal(s.element, 0), t = s.element.children[0]) : n = !0;
          else if (s.element instanceof qn && !t) {
            if (s.element.separator) this._itemRenderer.isItemWithSeparatorVisible(s.element) ? this._tree.reveal(s.element) : this._tree.reveal(s.element, 0), t = s.element;
            else if (s.element === this._elementTree[0]) return this._tree.reveal(s.element, 0), !0;
          }
          return !1;
        }), t && this._tree.setFocus([t]);
        break;
      }
    }
  }
  clearFocus() {
    this._tree.setFocus([]);
  }
  domFocus() {
    this._tree.domFocus();
  }
  layout(i) {
    this._tree.getHTMLElement().style.maxHeight = i ? 44 * Math.floor(i / 44) + 6 + "px" : "", this._tree.layout();
  }
  filter(i) {
    if (!(this._sortByLabel || this._matchOnLabel || this._matchOnDescription || this._matchOnDetail)) return this._tree.layout(), !1;
    const e = i;
    if ((i = i.trim()) && (this.matchOnLabel || this.matchOnDescription || this.matchOnDetail)) {
      let a;
      this._elementTree.forEach((l) => {
        var d, h, c, u;
        let g;
        g = this.matchOnLabelMode === "fuzzy" ? this.matchOnLabel && (d = qD(i, I_(l.saneLabel))) !== null && d !== void 0 ? d : void 0 : this.matchOnLabel && (h = function(_, v) {
          const { text: b, iconOffsets: C } = v;
          if (!C || C.length === 0) return dF(_, b);
          const w = p1(b, " "), y = b.length - w.length, L = dF(_, w);
          if (L) for (const k of L) {
            const N = C[k.start + y] + y;
            k.start += N, k.end += N;
          }
          return L;
        }(e, I_(l.saneLabel))) !== null && h !== void 0 ? h : void 0;
        const p = this.matchOnDescription && (c = qD(i, I_(l.saneDescription || ""))) !== null && c !== void 0 ? c : void 0, f = this.matchOnDetail && (u = qD(i, I_(l.saneDetail || ""))) !== null && u !== void 0 ? u : void 0;
        if (g || p || f ? (l.labelHighlights = g, l.descriptionHighlights = p, l.detailHighlights = f, l.hidden = !1) : (l.labelHighlights = void 0, l.descriptionHighlights = void 0, l.detailHighlights = void 0, l.hidden = !l.item || !l.item.alwaysShow), l.item ? l.separator = void 0 : l.separator && (l.hidden = !0), !this.sortByLabel) {
          const _ = l.index && this._inputElements[l.index - 1];
          a = _ && _.type === "separator" ? _ : a, a && !l.hidden && (l.separator = a, a = void 0);
        }
      });
    } else this._itemElements.forEach((a) => {
      a.labelHighlights = void 0, a.descriptionHighlights = void 0, a.detailHighlights = void 0, a.hidden = !1;
      const l = a.index && this._inputElements[a.index - 1];
      a.item && (a.separator = l && l.type === "separator" && !l.buttons ? l : void 0);
    });
    const t = this._elementTree.filter((a) => !a.hidden);
    if (this.sortByLabel && i) {
      const a = i.toLowerCase();
      t.sort((l, d) => function(h, c, u) {
        const g = h.labelHighlights || [], p = c.labelHighlights || [];
        return g.length && !p.length ? -1 : !g.length && p.length ? 1 : g.length === 0 && p.length === 0 ? 0 : Lie(h.saneSortLabel, c.saneSortLabel, u);
      }(l, d, a));
    }
    let n;
    const s = t.reduce((a, l, d) => (l instanceof qn ? n ? n.children.push(l) : a.push(l) : l instanceof lh && (l.children = [], n = l, a.push(l)), a), new Array()), o = new Array();
    for (const a of s) a instanceof lh ? o.push({ element: a, collapsible: !1, collapsed: !1, children: a.children.map((l) => ({ element: l, collapsible: !1, collapsed: !1 })) }) : o.push({ element: a, collapsible: !1, collapsed: !1 });
    const r = this._tree.getFocus().length;
    return this._tree.setChildren(null, o), r > 0 && o.length === 0 && this._onTriggerEmptySelectionOrFocus.fire({ elements: [] }), this._tree.layout(), this._onChangedAllVisibleChecked.fire(this.getAllVisibleChecked()), this._onChangedVisibleCount.fire(t.length), !0;
  }
  toggleCheckbox() {
    try {
      this._shouldFireCheckedEvents = !1;
      const i = this._tree.getFocus().filter((t) => t instanceof qn), e = this._allVisibleChecked(i);
      for (const t of i) t.checkboxDisabled || (t.checked = !e);
    } finally {
      this._shouldFireCheckedEvents = !0, this._fireCheckedEvents();
    }
  }
  display(i) {
    this._container.style.display = i ? "" : "none";
  }
  isDisplayed() {
    return this._container.style.display !== "none";
  }
  style(i) {
    this._tree.style(i);
  }
  toggleHover() {
    const i = this._tree.getFocus()[0];
    if (!(i != null && i.saneTooltip && i instanceof qn)) return;
    if (this._lastHover && !this._lastHover.isDisposed) return void this._lastHover.dispose();
    this.showHover(i);
    const e = new G();
    e.add(this._tree.onDidChangeFocus((t) => {
      t.elements[0] instanceof qn && this.showHover(t.elements[0]);
    })), this._lastHover && e.add(this._lastHover), this._elementDisposable.add(e);
  }
  _allVisibleChecked(i, e = !0) {
    for (let t = 0, n = i.length; t < n; t++) {
      const s = i[t];
      if (!s.hidden) {
        if (!s.checked) return !1;
        e = !0;
      }
    }
    return e;
  }
  _fireCheckedEvents() {
    this._shouldFireCheckedEvents && (this._onChangedAllVisibleChecked.fire(this.getAllVisibleChecked()), this._onChangedCheckedCount.fire(this.getCheckedCount()), this._onChangedCheckedElements.fire(this.getCheckedElements()));
  }
  fireButtonTriggered(i) {
    this._onButtonTriggered.fire(i);
  }
  fireSeparatorButtonTriggered(i) {
    this._onSeparatorButtonTriggered.fire(i);
  }
  showHover(i) {
    var e, t, n;
    this._lastHover && !this._lastHover.isDisposed && ((t = (e = this.hoverDelegate).onDidHideHover) === null || t === void 0 || t.call(e), (n = this._lastHover) === null || n === void 0 || n.dispose()), i.element && i.saneTooltip && (this._lastHover = this.hoverDelegate.showHover({ content: i.saneTooltip, target: i.element, linkHandler: (s) => {
      this.linkOpenerDelegate(s);
    }, appearance: { showPointer: !0 }, container: this._container, position: { hoverPosition: 1 } }, !1));
  }
};
function dF(i, e) {
  const t = e.toLowerCase().indexOf(i.toLowerCase());
  return t !== -1 ? [{ start: t, end: t + i.length }] : null;
}
tw([Li], R_.prototype, "onDidChangeFocus", null), tw([Li], R_.prototype, "onDidChangeSelection", null), R_ = tw([DV(4, Se)], R_);
var xie = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, hF = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const _2 = { iconClass: Ee.asClassName(ne.quickInputBack), tooltip: m(0, "Back"), handle: -1 };
class V1 extends V {
  constructor(e) {
    super(), this.ui = e, this._widgetUpdated = !1, this.visible = !1, this._enabled = !0, this._busy = !1, this._ignoreFocusOut = !1, this._buttons = [], this.buttonsUpdated = !1, this._toggles = [], this.togglesUpdated = !1, this.noValidationMessage = V1.noPromptMessage, this._severity = ki.Ignore, this.onDidTriggerButtonEmitter = this._register(new F()), this.onDidHideEmitter = this._register(new F()), this.onWillHideEmitter = this._register(new F()), this.onDisposeEmitter = this._register(new F()), this.visibleDisposables = this._register(new G()), this.onDidHide = this.onDidHideEmitter.event;
  }
  get title() {
    return this._title;
  }
  set title(e) {
    this._title = e, this.update();
  }
  get description() {
    return this._description;
  }
  set description(e) {
    this._description = e, this.update();
  }
  get step() {
    return this._steps;
  }
  set step(e) {
    this._steps = e, this.update();
  }
  get totalSteps() {
    return this._totalSteps;
  }
  set totalSteps(e) {
    this._totalSteps = e, this.update();
  }
  get enabled() {
    return this._enabled;
  }
  set enabled(e) {
    this._enabled = e, this.update();
  }
  get contextKey() {
    return this._contextKey;
  }
  set contextKey(e) {
    this._contextKey = e, this.update();
  }
  get busy() {
    return this._busy;
  }
  set busy(e) {
    this._busy = e, this.update();
  }
  get ignoreFocusOut() {
    return this._ignoreFocusOut;
  }
  set ignoreFocusOut(e) {
    const t = this._ignoreFocusOut !== e && !ua;
    this._ignoreFocusOut = e && !ua, t && this.update();
  }
  get buttons() {
    return this._buttons;
  }
  set buttons(e) {
    this._buttons = e, this.buttonsUpdated = !0, this.update();
  }
  get toggles() {
    return this._toggles;
  }
  set toggles(e) {
    this._toggles = e ?? [], this.togglesUpdated = !0, this.update();
  }
  get validationMessage() {
    return this._validationMessage;
  }
  set validationMessage(e) {
    this._validationMessage = e, this.update();
  }
  get severity() {
    return this._severity;
  }
  set severity(e) {
    this._severity = e, this.update();
  }
  show() {
    this.visible || (this.visibleDisposables.add(this.ui.onDidTriggerButton((e) => {
      this.buttons.indexOf(e) !== -1 && this.onDidTriggerButtonEmitter.fire(e);
    })), this.ui.show(this), this.visible = !0, this._lastValidationMessage = void 0, this._lastSeverity = void 0, this.buttons.length && (this.buttonsUpdated = !0), this.toggles.length && (this.togglesUpdated = !0), this.update());
  }
  hide() {
    this.visible && this.ui.hide();
  }
  didHide(e = tf.Other) {
    this.visible = !1, this.visibleDisposables.clear(), this.onDidHideEmitter.fire({ reason: e });
  }
  willHide(e = tf.Other) {
    this.onWillHideEmitter.fire({ reason: e });
  }
  update() {
    var e, t;
    if (!this.visible) return;
    const n = this.getTitle();
    n && this.ui.title.textContent !== n ? this.ui.title.textContent = n : n || this.ui.title.innerHTML === "&nbsp;" || (this.ui.title.innerText = " ");
    const s = this.getDescription();
    if (this.ui.description1.textContent !== s && (this.ui.description1.textContent = s), this.ui.description2.textContent !== s && (this.ui.description2.textContent = s), this._widgetUpdated && (this._widgetUpdated = !1, this._widget ? wn(this.ui.widget, this._widget) : wn(this.ui.widget)), this.busy && !this.busyDelay && (this.busyDelay = new Dr(), this.busyDelay.setIfNotSet(() => {
      this.visible && this.ui.progressBar.infinite();
    }, 800)), !this.busy && this.busyDelay && (this.ui.progressBar.stop(), this.busyDelay.cancel(), this.busyDelay = void 0), this.buttonsUpdated) {
      this.buttonsUpdated = !1, this.ui.leftActionBar.clear();
      const r = this.buttons.filter((l) => l === _2).map((l, d) => Ky(l, `id-${d}`, async () => this.onDidTriggerButtonEmitter.fire(l)));
      this.ui.leftActionBar.push(r, { icon: !0, label: !1 }), this.ui.rightActionBar.clear();
      const a = this.buttons.filter((l) => l !== _2).map((l, d) => Ky(l, `id-${d}`, async () => this.onDidTriggerButtonEmitter.fire(l)));
      this.ui.rightActionBar.push(a, { icon: !0, label: !1 });
    }
    if (this.togglesUpdated) {
      this.togglesUpdated = !1;
      const r = (t = (e = this.toggles) === null || e === void 0 ? void 0 : e.filter((a) => a instanceof wf)) !== null && t !== void 0 ? t : [];
      this.ui.inputBox.toggles = r;
    }
    this.ui.ignoreFocusOut = this.ignoreFocusOut, this.ui.setEnabled(this.enabled), this.ui.setContextKey(this.contextKey);
    const o = this.validationMessage || this.noValidationMessage;
    this._lastValidationMessage !== o && (this._lastValidationMessage = o, wn(this.ui.message), Lte(o, this.ui.message, { callback: (r) => {
      this.ui.linkOpenerDelegate(r);
    }, disposables: this.visibleDisposables })), this._lastSeverity !== this.severity && (this._lastSeverity = this.severity, this.showMessageDecoration(this.severity));
  }
  getTitle() {
    return this.title && this.step ? `${this.title} (${this.getSteps()})` : this.title ? this.title : this.step ? this.getSteps() : "";
  }
  getDescription() {
    return this.description || "";
  }
  getSteps() {
    return this.step && this.totalSteps ? m(0, "{0}/{1}", this.step, this.totalSteps) : this.step ? String(this.step) : "";
  }
  showMessageDecoration(e) {
    if (this.ui.inputBox.showDecoration(e), e !== ki.Ignore) {
      const t = this.ui.inputBox.stylesForType(e);
      this.ui.message.style.color = t.foreground ? `${t.foreground}` : "", this.ui.message.style.backgroundColor = t.background ? `${t.background}` : "", this.ui.message.style.border = t.border ? `1px solid ${t.border}` : "", this.ui.message.style.marginBottom = "-2px";
    } else this.ui.message.style.color = "", this.ui.message.style.backgroundColor = "", this.ui.message.style.border = "", this.ui.message.style.marginBottom = "";
  }
  dispose() {
    this.hide(), this.onDisposeEmitter.fire(), super.dispose();
  }
}
V1.noPromptMessage = m(0, "Press 'Enter' to confirm your input or 'Escape' to cancel");
class zv extends V1 {
  constructor() {
    super(...arguments), this._value = "", this.onDidChangeValueEmitter = this._register(new F()), this.onWillAcceptEmitter = this._register(new F()), this.onDidAcceptEmitter = this._register(new F()), this.onDidCustomEmitter = this._register(new F()), this._items = [], this.itemsUpdated = !1, this._canSelectMany = !1, this._canAcceptInBackground = !1, this._matchOnDescription = !1, this._matchOnDetail = !1, this._matchOnLabel = !0, this._matchOnLabelMode = "fuzzy", this._sortByLabel = !0, this._keepScrollPosition = !1, this._itemActivation = Kr.FIRST, this._activeItems = [], this.activeItemsUpdated = !1, this.activeItemsToConfirm = [], this.onDidChangeActiveEmitter = this._register(new F()), this._selectedItems = [], this.selectedItemsUpdated = !1, this.selectedItemsToConfirm = [], this.onDidChangeSelectionEmitter = this._register(new F()), this.onDidTriggerItemButtonEmitter = this._register(new F()), this.onDidTriggerSeparatorButtonEmitter = this._register(new F()), this.valueSelectionUpdated = !0, this._ok = "default", this._customButton = !1, this.filterValue = (e) => e, this.onDidChangeValue = this.onDidChangeValueEmitter.event, this.onWillAccept = this.onWillAcceptEmitter.event, this.onDidAccept = this.onDidAcceptEmitter.event, this.onDidChangeActive = this.onDidChangeActiveEmitter.event, this.onDidChangeSelection = this.onDidChangeSelectionEmitter.event, this.onDidTriggerItemButton = this.onDidTriggerItemButtonEmitter.event, this.onDidTriggerSeparatorButton = this.onDidTriggerSeparatorButtonEmitter.event;
  }
  get quickNavigate() {
    return this._quickNavigate;
  }
  set quickNavigate(e) {
    this._quickNavigate = e, this.update();
  }
  get value() {
    return this._value;
  }
  set value(e) {
    this.doSetValue(e);
  }
  doSetValue(e, t) {
    this._value !== e && (this._value = e, t || this.update(), this.visible && this.ui.list.filter(this.filterValue(this._value)) && this.trySelectFirst(), this.onDidChangeValueEmitter.fire(this._value));
  }
  set ariaLabel(e) {
    this._ariaLabel = e, this.update();
  }
  get ariaLabel() {
    return this._ariaLabel;
  }
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(e) {
    this._placeholder = e, this.update();
  }
  get items() {
    return this._items;
  }
  get scrollTop() {
    return this.ui.list.scrollTop;
  }
  set scrollTop(e) {
    this.ui.list.scrollTop = e;
  }
  set items(e) {
    this._items = e, this.itemsUpdated = !0, this.update();
  }
  get canSelectMany() {
    return this._canSelectMany;
  }
  set canSelectMany(e) {
    this._canSelectMany = e, this.update();
  }
  get canAcceptInBackground() {
    return this._canAcceptInBackground;
  }
  set canAcceptInBackground(e) {
    this._canAcceptInBackground = e;
  }
  get matchOnDescription() {
    return this._matchOnDescription;
  }
  set matchOnDescription(e) {
    this._matchOnDescription = e, this.update();
  }
  get matchOnDetail() {
    return this._matchOnDetail;
  }
  set matchOnDetail(e) {
    this._matchOnDetail = e, this.update();
  }
  get matchOnLabel() {
    return this._matchOnLabel;
  }
  set matchOnLabel(e) {
    this._matchOnLabel = e, this.update();
  }
  get matchOnLabelMode() {
    return this._matchOnLabelMode;
  }
  set matchOnLabelMode(e) {
    this._matchOnLabelMode = e, this.update();
  }
  get sortByLabel() {
    return this._sortByLabel;
  }
  set sortByLabel(e) {
    this._sortByLabel = e, this.update();
  }
  get keepScrollPosition() {
    return this._keepScrollPosition;
  }
  set keepScrollPosition(e) {
    this._keepScrollPosition = e;
  }
  get itemActivation() {
    return this._itemActivation;
  }
  set itemActivation(e) {
    this._itemActivation = e;
  }
  get activeItems() {
    return this._activeItems;
  }
  set activeItems(e) {
    this._activeItems = e, this.activeItemsUpdated = !0, this.update();
  }
  get selectedItems() {
    return this._selectedItems;
  }
  set selectedItems(e) {
    this._selectedItems = e, this.selectedItemsUpdated = !0, this.update();
  }
  get keyMods() {
    return this._quickNavigate ? bte : this.ui.keyMods;
  }
  get valueSelection() {
    const e = this.ui.inputBox.getSelection();
    if (e) return [e.start, e.end];
  }
  set valueSelection(e) {
    this._valueSelection = e, this.valueSelectionUpdated = !0, this.update();
  }
  get customButton() {
    return this._customButton;
  }
  set customButton(e) {
    this._customButton = e, this.update();
  }
  get customLabel() {
    return this._customButtonLabel;
  }
  set customLabel(e) {
    this._customButtonLabel = e, this.update();
  }
  get customHover() {
    return this._customButtonHover;
  }
  set customHover(e) {
    this._customButtonHover = e, this.update();
  }
  get ok() {
    return this._ok;
  }
  set ok(e) {
    this._ok = e, this.update();
  }
  get hideInput() {
    return !!this._hideInput;
  }
  set hideInput(e) {
    this._hideInput = e, this.update();
  }
  trySelectFirst() {
    this.canSelectMany || this.ui.list.focus(Hi.First);
  }
  show() {
    this.visible || (this.visibleDisposables.add(this.ui.inputBox.onDidChange((e) => {
      this.doSetValue(e, !0);
    })), this.visibleDisposables.add((this._hideInput ? this.ui.list : this.ui.inputBox).onKeyDown((e) => {
      switch (e.keyCode) {
        case 18:
          (Je ? e.metaKey : e.altKey) ? this.ui.list.focus(Hi.NextSeparator) : this.ui.list.focus(Hi.Next), this.canSelectMany && this.ui.list.domFocus(), Ze(e, !0);
          break;
        case 16:
          (Je ? e.metaKey : e.altKey) ? this.ui.list.focus(Hi.PreviousSeparator) : this.ui.list.focus(Hi.Previous), this.canSelectMany && this.ui.list.domFocus(), Ze(e, !0);
          break;
        case 12:
          this.ui.list.focus(Hi.NextPage), this.canSelectMany && this.ui.list.domFocus(), Ze(e, !0);
          break;
        case 11:
          this.ui.list.focus(Hi.PreviousPage), this.canSelectMany && this.ui.list.domFocus(), Ze(e, !0);
          break;
        case 17:
          if (!this._canAcceptInBackground || !this.ui.inputBox.isSelectionAtEnd()) return;
          this.activeItems[0] && (this._selectedItems = [this.activeItems[0]], this.onDidChangeSelectionEmitter.fire(this.selectedItems), this.handleAccept(!0));
          break;
        case 14:
          !e.ctrlKey && !e.metaKey || e.shiftKey || e.altKey || (this.ui.list.focus(Hi.First), Ze(e, !0));
          break;
        case 13:
          !e.ctrlKey && !e.metaKey || e.shiftKey || e.altKey || (this.ui.list.focus(Hi.Last), Ze(e, !0));
      }
    })), this.visibleDisposables.add(this.ui.onDidAccept(() => {
      this.canSelectMany ? this.ui.list.getCheckedElements().length || (this._selectedItems = [], this.onDidChangeSelectionEmitter.fire(this.selectedItems)) : this.activeItems[0] && (this._selectedItems = [this.activeItems[0]], this.onDidChangeSelectionEmitter.fire(this.selectedItems)), this.handleAccept(!1);
    })), this.visibleDisposables.add(this.ui.onDidCustom(() => {
      this.onDidCustomEmitter.fire();
    })), this.visibleDisposables.add(this.ui.list.onDidChangeFocus((e) => {
      this.activeItemsUpdated || this.activeItemsToConfirm !== this._activeItems && ri(e, this._activeItems, (t, n) => t === n) || (this._activeItems = e, this.onDidChangeActiveEmitter.fire(e));
    })), this.visibleDisposables.add(this.ui.list.onDidChangeSelection(({ items: e, event: t }) => {
      this.canSelectMany ? e.length && this.ui.list.setSelectedElements([]) : this.selectedItemsToConfirm !== this._selectedItems && ri(e, this._selectedItems, (n, s) => n === s) || (this._selectedItems = e, this.onDidChangeSelectionEmitter.fire(e), e.length && this.handleAccept(fR(t) && t.button === 1));
    })), this.visibleDisposables.add(this.ui.list.onChangedCheckedElements((e) => {
      this.canSelectMany && (this.selectedItemsToConfirm !== this._selectedItems && ri(e, this._selectedItems, (t, n) => t === n) || (this._selectedItems = e, this.onDidChangeSelectionEmitter.fire(e)));
    })), this.visibleDisposables.add(this.ui.list.onButtonTriggered((e) => this.onDidTriggerItemButtonEmitter.fire(e))), this.visibleDisposables.add(this.ui.list.onSeparatorButtonTriggered((e) => this.onDidTriggerSeparatorButtonEmitter.fire(e))), this.visibleDisposables.add(this.registerQuickNavigation()), this.valueSelectionUpdated = !0), super.show();
  }
  handleAccept(e) {
    let t = !1;
    this.onWillAcceptEmitter.fire({ veto: () => t = !0 }), t || this.onDidAcceptEmitter.fire({ inBackground: e });
  }
  registerQuickNavigation() {
    return K(this.ui.container, ie.KEY_UP, (e) => {
      if (this.canSelectMany || !this._quickNavigate) return;
      const t = new jt(e), n = t.keyCode;
      this._quickNavigate.keybindings.some((s) => {
        const o = s.getChords();
        return !(o.length > 1) && (o[0].shiftKey && n === 4 ? !(t.ctrlKey || t.altKey || t.metaKey) : !(!o[0].altKey || n !== 6) || !(!o[0].ctrlKey || n !== 5) || !(!o[0].metaKey || n !== 57));
      }) && (this.activeItems[0] && (this._selectedItems = [this.activeItems[0]], this.onDidChangeSelectionEmitter.fire(this.selectedItems), this.handleAccept(!1)), this._quickNavigate = void 0);
    });
  }
  update() {
    if (!this.visible) return;
    const e = this.keepScrollPosition ? this.scrollTop : 0, t = !!this.description, n = { title: !!this.title || !!this.step || !!this.buttons.length, description: t, checkAll: this.canSelectMany && !this._hideCheckAll, checkBox: this.canSelectMany, inputBox: !this._hideInput, progressBar: !this._hideInput || t, visibleCount: !0, count: this.canSelectMany && !this._hideCountBadge, ok: this.ok === "default" ? this.canSelectMany : this.ok, list: !0, message: !!this.validationMessage, customButton: this.customButton };
    this.ui.setVisibilities(n), super.update(), this.ui.inputBox.value !== this.value && (this.ui.inputBox.value = this.value), this.valueSelectionUpdated && (this.valueSelectionUpdated = !1, this.ui.inputBox.select(this._valueSelection && { start: this._valueSelection[0], end: this._valueSelection[1] })), this.ui.inputBox.placeholder !== (this.placeholder || "") && (this.ui.inputBox.placeholder = this.placeholder || "");
    let s = this.ariaLabel;
    if (!s && n.inputBox && (s = this.placeholder || zv.DEFAULT_ARIA_LABEL, this.title && (s += ` - ${this.title}`)), this.ui.list.ariaLabel !== s && (this.ui.list.ariaLabel = s ?? null), this.ui.list.matchOnDescription = this.matchOnDescription, this.ui.list.matchOnDetail = this.matchOnDetail, this.ui.list.matchOnLabel = this.matchOnLabel, this.ui.list.matchOnLabelMode = this.matchOnLabelMode, this.ui.list.sortByLabel = this.sortByLabel, this.itemsUpdated) {
      this.itemsUpdated = !1;
      const o = this._activeItems;
      switch (this.ui.list.setElements(this.items), this.ui.list.filter(this.filterValue(this.ui.inputBox.value)), this.ui.checkAll.checked = this.ui.list.getAllVisibleChecked(), this.ui.visibleCount.setCount(this.ui.list.getVisibleCount()), this.ui.count.setCount(this.ui.list.getCheckedCount()), this._itemActivation) {
        case Kr.NONE:
          o.length > 0 && (this._activeItems = [], this.onDidChangeActiveEmitter.fire(this._activeItems)), this._itemActivation = Kr.FIRST;
          break;
        case Kr.SECOND:
          this.ui.list.focus(Hi.Second), this._itemActivation = Kr.FIRST;
          break;
        case Kr.LAST:
          this.ui.list.focus(Hi.Last), this._itemActivation = Kr.FIRST;
          break;
        default:
          this.trySelectFirst();
      }
    }
    this.ui.container.classList.contains("show-checkboxes") !== !!this.canSelectMany && (this.canSelectMany ? this.ui.list.clearFocus() : this.trySelectFirst()), this.activeItemsUpdated && (this.activeItemsUpdated = !1, this.activeItemsToConfirm = this._activeItems, this.ui.list.setFocusedElements(this.activeItems), this.activeItemsToConfirm === this._activeItems && (this.activeItemsToConfirm = null)), this.selectedItemsUpdated && (this.selectedItemsUpdated = !1, this.selectedItemsToConfirm = this._selectedItems, this.canSelectMany ? this.ui.list.setCheckedElements(this.selectedItems) : this.ui.list.setSelectedElements(this.selectedItems), this.selectedItemsToConfirm === this._selectedItems && (this.selectedItemsToConfirm = null)), this.ui.customButton.label = this.customLabel || "", this.ui.customButton.element.title = this.customHover || "", n.inputBox || (this.ui.list.domFocus(), this.canSelectMany && this.ui.list.focus(Hi.First)), this.keepScrollPosition && (this.scrollTop = e);
  }
}
zv.DEFAULT_ARIA_LABEL = m(0, "Type to narrow down results.");
class Nie extends V1 {
  constructor() {
    super(...arguments), this._value = "", this.valueSelectionUpdated = !0, this._password = !1, this.onDidValueChangeEmitter = this._register(new F()), this.onDidAcceptEmitter = this._register(new F()), this.onDidChangeValue = this.onDidValueChangeEmitter.event, this.onDidAccept = this.onDidAcceptEmitter.event;
  }
  get value() {
    return this._value;
  }
  set value(e) {
    this._value = e || "", this.update();
  }
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(e) {
    this._placeholder = e, this.update();
  }
  get password() {
    return this._password;
  }
  set password(e) {
    this._password = e, this.update();
  }
  show() {
    this.visible || (this.visibleDisposables.add(this.ui.inputBox.onDidChange((e) => {
      e !== this.value && (this._value = e, this.onDidValueChangeEmitter.fire(e));
    })), this.visibleDisposables.add(this.ui.onDidAccept(() => this.onDidAcceptEmitter.fire())), this.valueSelectionUpdated = !0), super.show();
  }
  update() {
    if (!this.visible) return;
    this.ui.container.classList.remove("hidden-input");
    const e = { title: !!this.title || !!this.step || !!this.buttons.length, description: !!this.description || !!this.step, inputBox: !0, message: !0, progressBar: !0 };
    this.ui.setVisibilities(e), super.update(), this.ui.inputBox.value !== this.value && (this.ui.inputBox.value = this.value), this.valueSelectionUpdated && (this.valueSelectionUpdated = !1, this.ui.inputBox.select(this._valueSelection && { start: this._valueSelection[0], end: this._valueSelection[1] })), this.ui.inputBox.placeholder !== (this.placeholder || "") && (this.ui.inputBox.placeholder = this.placeholder || ""), this.ui.inputBox.password !== this.password && (this.ui.inputBox.password = this.password);
  }
}
let v2 = class extends kv {
  constructor(i, e) {
    super("element", !1, (t) => this.getOverrideOptions(t), i, e);
  }
  getOverrideOptions(i) {
    var e;
    return { persistence: { hideOnKeyDown: !1 }, appearance: { showHoverHint: (i.content instanceof HTMLElement ? (e = i.content.textContent) !== null && e !== void 0 ? e : "" : typeof i.content == "string" ? i.content : i.content.value).includes(`
`), skipFadeInAnimation: !0 } };
  }
};
v2 = xie([hF(0, Ye), hF(1, pA)], v2), z.white.toString(), z.white.toString();
class eS extends V {
  get onDidClick() {
    return this._onDidClick.event;
  }
  constructor(e, t) {
    super(), this._label = "", this._onDidClick = this._register(new F()), this._onDidEscape = this._register(new F()), this.options = t, this._element = document.createElement("a"), this._element.classList.add("monaco-button"), this._element.tabIndex = 0, this._element.setAttribute("role", "button"), this._element.classList.toggle("secondary", !!t.secondary);
    const n = t.secondary ? t.buttonSecondaryBackground : t.buttonBackground, s = t.secondary ? t.buttonSecondaryForeground : t.buttonForeground;
    this._element.style.color = s || "", this._element.style.backgroundColor = n || "", t.supportShortLabel && (this._labelShortElement = document.createElement("div"), this._labelShortElement.classList.add("monaco-button-label-short"), this._element.appendChild(this._labelShortElement), this._labelElement = document.createElement("div"), this._labelElement.classList.add("monaco-button-label"), this._element.appendChild(this._labelElement), this._element.classList.add("monaco-text-button-with-short-label")), typeof t.title == "string" && this.setTitle(t.title), typeof t.ariaLabel == "string" && this._element.setAttribute("aria-label", t.ariaLabel), e.appendChild(this._element), this._register(Bt.addTarget(this._element)), [ie.CLICK, Vt.Tap].forEach((o) => {
      this._register(K(this._element, o, (r) => {
        this.enabled ? this._onDidClick.fire(r) : Ze(r);
      }));
    }), this._register(K(this._element, ie.KEY_DOWN, (o) => {
      const r = new jt(o);
      let a = !1;
      this.enabled && (r.equals(3) || r.equals(10)) ? (this._onDidClick.fire(o), a = !0) : r.equals(9) && (this._onDidEscape.fire(o), this._element.blur(), a = !0), a && Ze(r, !0);
    })), this._register(K(this._element, ie.MOUSE_OVER, (o) => {
      this._element.classList.contains("disabled") || this.updateBackground(!0);
    })), this._register(K(this._element, ie.MOUSE_OUT, (o) => {
      this.updateBackground(!1);
    })), this.focusTracker = this._register(ma(this._element)), this._register(this.focusTracker.onDidFocus(() => {
      this.enabled && this.updateBackground(!0);
    })), this._register(this.focusTracker.onDidBlur(() => {
      this.enabled && this.updateBackground(!1);
    }));
  }
  dispose() {
    super.dispose(), this._element.remove();
  }
  getContentElements(e) {
    const t = [];
    for (let n of ic(e)) if (typeof n == "string") {
      if (n = n.trim(), n === "") continue;
      const s = document.createElement("span");
      s.textContent = n, t.push(s);
    } else t.push(n);
    return t;
  }
  updateBackground(e) {
    let t;
    t = this.options.secondary ? e ? this.options.buttonSecondaryHoverBackground : this.options.buttonSecondaryBackground : e ? this.options.buttonHoverBackground : this.options.buttonBackground, t && (this._element.style.backgroundColor = t);
  }
  get element() {
    return this._element;
  }
  set label(e) {
    var t, n, s;
    if (this._label === e || ha(this._label) && ha(e) && ((n = this._label) === (s = e) || n && s && n.value === s.value && n.isTrusted === s.isTrusted && n.supportThemeIcons === s.supportThemeIcons && n.supportHtml === s.supportHtml && (n.baseUri === s.baseUri || n.baseUri && s.baseUri && QR(Ie.from(n.baseUri), Ie.from(s.baseUri))))) return;
    this._element.classList.add("monaco-text-button");
    const o = this.options.supportShortLabel ? this._labelElement : this._element;
    if (ha(e)) {
      const a = CL(e, { inline: !0 });
      a.dispose();
      const l = (t = a.element.querySelector("p")) === null || t === void 0 ? void 0 : t.innerHTML;
      if (l) {
        const d = g8(l, { ADD_TAGS: ["b", "i", "u", "code", "span"], ALLOWED_ATTR: ["class"], RETURN_TRUSTED_TYPE: !0 });
        o.innerHTML = d;
      } else wn(o);
    } else this.options.supportIcons ? wn(o, ...this.getContentElements(e)) : o.textContent = e;
    let r = "";
    typeof this.options.title == "string" ? r = this.options.title : this.options.title && (r = zJ(e)), this.setTitle(r), typeof this.options.ariaLabel == "string" ? this._element.setAttribute("aria-label", this.options.ariaLabel) : this.options.ariaLabel && this._element.setAttribute("aria-label", r), this._label = e;
  }
  get label() {
    return this._label;
  }
  set icon(e) {
    this._element.classList.add(...Ee.asClassNameArray(e));
  }
  set enabled(e) {
    e ? (this._element.classList.remove("disabled"), this._element.setAttribute("aria-disabled", String(!1)), this._element.tabIndex = 0) : (this._element.classList.add("disabled"), this._element.setAttribute("aria-disabled", String(!0)));
  }
  get enabled() {
    return !this._element.classList.contains("disabled");
  }
  setTitle(e) {
    var t;
    this._hover || e === "" ? this._hover && this._hover.update(e) : this._hover = this._register(xr((t = this.options.hoverDelegate) !== null && t !== void 0 ? t : Bs("mouse"), this._element, e));
  }
}
class b2 {
  constructor(e, t, n) {
    this.options = t, this.styles = n, this.count = 0, this.element = Z(e, Q(".monaco-count-badge")), this.countFormat = this.options.countFormat || "{0}", this.titleFormat = this.options.titleFormat || "", this.setCount(this.options.count || 0);
  }
  setCount(e) {
    this.count = e, this.render();
  }
  setTitleFormat(e) {
    this.titleFormat = e, this.render();
  }
  render() {
    var e, t;
    this.element.textContent = rg(this.countFormat, this.count), this.element.title = rg(this.titleFormat, this.count), this.element.style.backgroundColor = (e = this.styles.badgeBackground) !== null && e !== void 0 ? e : "", this.element.style.color = (t = this.styles.badgeForeground) !== null && t !== void 0 ? t : "", this.styles.badgeBorder && (this.element.style.border = `1px solid ${this.styles.badgeBorder}`);
  }
}
const cF = "done", uF = "active", ax = "infinite", lx = "infinite-long-running", gF = "discrete";
class WL extends V {
  constructor(e, t) {
    super(), this.workedVal = 0, this.showDelayedScheduler = this._register(new It(() => bo(this.element), 0)), this.longRunningScheduler = this._register(new It(() => this.infiniteLongRunning(), WL.LONG_RUNNING_INFINITE_THRESHOLD)), this.create(e, t);
  }
  create(e, t) {
    this.element = document.createElement("div"), this.element.classList.add("monaco-progress-container"), this.element.setAttribute("role", "progressbar"), this.element.setAttribute("aria-valuemin", "0"), e.appendChild(this.element), this.bit = document.createElement("div"), this.bit.classList.add("progress-bit"), this.bit.style.backgroundColor = (t == null ? void 0 : t.progressBarBackground) || "#0E70C0", this.element.appendChild(this.bit);
  }
  off() {
    this.bit.style.width = "inherit", this.bit.style.opacity = "1", this.element.classList.remove(uF, ax, lx, gF), this.workedVal = 0, this.totalWork = void 0, this.longRunningScheduler.cancel();
  }
  stop() {
    return this.doDone(!1);
  }
  doDone(e) {
    return this.element.classList.add(cF), this.element.classList.contains(ax) ? (this.bit.style.opacity = "0", e ? setTimeout(() => this.off(), 200) : this.off()) : (this.bit.style.width = "inherit", e ? setTimeout(() => this.off(), 200) : this.off()), this;
  }
  infinite() {
    return this.bit.style.width = "2%", this.bit.style.opacity = "1", this.element.classList.remove(gF, cF, lx), this.element.classList.add(uF, ax), this.longRunningScheduler.schedule(), this;
  }
  infiniteLongRunning() {
    this.element.classList.add(lx);
  }
  getContainer() {
    return this.element;
  }
}
WL.LONG_RUNNING_INFINITE_THRESHOLD = 1e4;
const Eie = Q;
class Iie extends V {
  constructor(e, t, n) {
    super(), this.parent = e, this.onKeyDown = (o) => bi(this.findInput.inputBox.inputElement, ie.KEY_DOWN, o), this.onDidChange = (o) => this.findInput.onDidChange(o), this.container = Z(this.parent, Eie(".quick-input-box")), this.findInput = this._register(new dV(this.container, void 0, { label: "", inputBoxStyles: t, toggleStyles: n }));
    const s = this.findInput.inputBox.inputElement;
    s.role = "combobox", s.ariaHasPopup = "menu", s.ariaAutoComplete = "list", s.ariaExpanded = "true";
  }
  get value() {
    return this.findInput.getValue();
  }
  set value(e) {
    this.findInput.setValue(e);
  }
  select(e = null) {
    this.findInput.inputBox.select(e);
  }
  getSelection() {
    return this.findInput.inputBox.getSelection();
  }
  isSelectionAtEnd() {
    return this.findInput.inputBox.isSelectionAtEnd();
  }
  get placeholder() {
    return this.findInput.inputBox.inputElement.getAttribute("placeholder") || "";
  }
  set placeholder(e) {
    this.findInput.inputBox.setPlaceHolder(e);
  }
  get password() {
    return this.findInput.inputBox.inputElement.type === "password";
  }
  set password(e) {
    this.findInput.inputBox.inputElement.type = e ? "password" : "text";
  }
  set enabled(e) {
    this.findInput.inputBox.inputElement.toggleAttribute("readonly", !e);
  }
  set toggles(e) {
    this.findInput.setAdditionalToggles(e);
  }
  setAttribute(e, t) {
    this.findInput.inputBox.inputElement.setAttribute(e, t);
  }
  showDecoration(e) {
    e === ki.Ignore ? this.findInput.clearMessage() : this.findInput.showMessage({ type: e === ki.Info ? 1 : e === ki.Warning ? 2 : 3, content: "" });
  }
  stylesForType(e) {
    return this.findInput.inputBox.stylesForType(e === ki.Info ? 1 : e === ki.Warning ? 2 : 3);
  }
  setFocus() {
    this.findInput.focus();
  }
  layout() {
    this.findInput.inputBox.layout();
  }
}
var C2, Mie = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, pF = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const Us = Q;
let iw = C2 = class extends V {
  get container() {
    return this._container;
  }
  constructor(i, e, t) {
    super(), this.options = i, this.layoutService = e, this.instantiationService = t, this.enabled = !0, this.onDidAcceptEmitter = this._register(new F()), this.onDidCustomEmitter = this._register(new F()), this.onDidTriggerButtonEmitter = this._register(new F()), this.keyMods = { ctrlCmd: !1, alt: !1 }, this.controller = null, this.onShowEmitter = this._register(new F()), this.onShow = this.onShowEmitter.event, this.onHideEmitter = this._register(new F()), this.onHide = this.onHideEmitter.event, this.idPrefix = i.idPrefix, this._container = i.container, this.styles = i.styles, this._register(se.runAndSubscribe(HS, ({ window: n, disposables: s }) => this.registerKeyModsListeners(n, s), { window: Et, disposables: this._store })), this._register(rj((n) => {
      this.ui && ke(this.ui.container) === n && (this.reparentUI(this.layoutService.mainContainer), this.layout(this.layoutService.mainContainerDimension, this.layoutService.mainContainerOffset.quickPickTop));
    }));
  }
  registerKeyModsListeners(i, e) {
    const t = (n) => {
      this.keyMods.ctrlCmd = n.ctrlKey || n.metaKey, this.keyMods.alt = n.altKey;
    };
    for (const n of [ie.KEY_DOWN, ie.KEY_UP, ie.MOUSE_DOWN]) e.add(K(i, n, t, !0));
  }
  getUI(i) {
    if (this.ui) return i && ke(this._container) !== ke(this.layoutService.activeContainer) && (this.reparentUI(this.layoutService.activeContainer), this.layout(this.layoutService.activeContainerDimension, this.layoutService.activeContainerOffset.quickPickTop)), this.ui;
    const e = Z(this._container, Us(".quick-input-widget.show-file-icons"));
    e.tabIndex = -1, e.style.display = "none";
    const t = Lo(e), n = Z(e, Us(".quick-input-titlebar")), s = this._register(new sr(n, { hoverDelegate: this.options.hoverDelegate }));
    s.domNode.classList.add("quick-input-left-action-bar");
    const o = Z(n, Us(".quick-input-title")), r = this._register(new sr(n, { hoverDelegate: this.options.hoverDelegate }));
    r.domNode.classList.add("quick-input-right-action-bar");
    const a = Z(e, Us(".quick-input-header")), l = Z(a, Us("input.quick-input-check-all"));
    l.type = "checkbox", l.setAttribute("aria-label", m(0, "Toggle all checkboxes")), this._register(bi(l, ie.CHANGE, (O) => {
      const H = l.checked;
      B.setAllVisibleChecked(H);
    })), this._register(K(l, ie.CLICK, (O) => {
      (O.x || O.y) && u.setFocus();
    }));
    const d = Z(a, Us(".quick-input-description")), h = Z(a, Us(".quick-input-and-message")), c = Z(h, Us(".quick-input-filter")), u = this._register(new Iie(c, this.styles.inputBox, this.styles.toggle));
    u.setAttribute("aria-describedby", `${this.idPrefix}message`);
    const g = Z(c, Us(".quick-input-visible-count"));
    g.setAttribute("aria-live", "polite"), g.setAttribute("aria-atomic", "true");
    const p = new b2(g, { countFormat: m(0, "{0} Results") }, this.styles.countBadge), f = Z(c, Us(".quick-input-count"));
    f.setAttribute("aria-live", "polite");
    const _ = new b2(f, { countFormat: m(0, "{0} Selected") }, this.styles.countBadge), v = Z(a, Us(".quick-input-action")), b = this._register(new eS(v, this.styles.button));
    b.label = m(0, "OK"), this._register(b.onDidClick((O) => {
      this.onDidAcceptEmitter.fire();
    }));
    const C = Z(a, Us(".quick-input-action")), w = this._register(new eS(C, { ...this.styles.button, supportIcons: !0 }));
    w.label = m(0, "Custom"), this._register(w.onDidClick((O) => {
      this.onDidCustomEmitter.fire();
    }));
    const y = Z(h, Us(`#${this.idPrefix}message.quick-input-message`)), L = this._register(new WL(e, this.styles.progressBar));
    L.getContainer().classList.add("quick-input-progress");
    const k = Z(e, Us(".quick-input-html-widget"));
    k.tabIndex = -1;
    const N = Z(e, Us(".quick-input-description")), A = this.idPrefix + "list", B = this._register(this.instantiationService.createInstance(R_, e, this.options.hoverDelegate, this.options.linkOpenerDelegate, A));
    u.setAttribute("aria-controls", A), this._register(B.onDidChangeFocus(() => {
      var O;
      u.setAttribute("aria-activedescendant", (O = B.getActiveDescendant()) !== null && O !== void 0 ? O : "");
    })), this._register(B.onChangedAllVisibleChecked((O) => {
      l.checked = O;
    })), this._register(B.onChangedVisibleCount((O) => {
      p.setCount(O);
    })), this._register(B.onChangedCheckedCount((O) => {
      _.setCount(O);
    })), this._register(B.onLeave(() => {
      setTimeout(() => {
        this.controller && (u.setFocus(), this.controller instanceof zv && this.controller.canSelectMany && B.clearFocus());
      }, 0);
    }));
    const T = ma(e);
    return this._register(T), this._register(K(e, ie.FOCUS, (O) => {
      gn(O.relatedTarget, e) || (this.previousFocusElement = O.relatedTarget instanceof HTMLElement ? O.relatedTarget : void 0);
    }, !0)), this._register(T.onDidBlur(() => {
      this.getUI().ignoreFocusOut || this.options.ignoreFocusOut() || this.hide(tf.Blur), this.previousFocusElement = void 0;
    })), this._register(K(e, ie.FOCUS, (O) => {
      u.setFocus();
    })), this._register(bi(e, ie.KEY_DOWN, (O) => {
      if (!gn(O.target, k)) switch (O.keyCode) {
        case 3:
          Ze(O, !0), this.enabled && this.onDidAcceptEmitter.fire();
          break;
        case 9:
          Ze(O, !0), this.hide(tf.Gesture);
          break;
        case 2:
          if (!O.altKey && !O.ctrlKey && !O.metaKey) {
            const H = [".quick-input-list .monaco-action-bar .always-visible", ".quick-input-list-entry:hover .monaco-action-bar", ".monaco-list-row.focused .monaco-action-bar"];
            if (e.classList.contains("show-checkboxes") ? H.push("input") : H.push("input[type=text]"), this.getUI().list.isDisplayed() && H.push(".monaco-list"), this.getUI().message && H.push(".quick-input-message a"), this.getUI().widget) {
              if (gn(O.target, this.getUI().widget)) break;
              H.push(".quick-input-html-widget");
            }
            const $ = e.querySelectorAll(H.join(", "));
            O.shiftKey && O.target === $[0] ? (Ze(O, !0), B.clearFocus()) : !O.shiftKey && gn(O.target, $[$.length - 1]) && (Ze(O, !0), $[0].focus());
          }
          break;
        case 10:
          O.ctrlKey && (Ze(O, !0), this.getUI().list.toggleHover());
      }
    })), this.ui = { container: e, styleSheet: t, leftActionBar: s, titleBar: n, title: o, description1: N, description2: d, widget: k, rightActionBar: r, checkAll: l, inputContainer: h, filterContainer: c, inputBox: u, visibleCountContainer: g, visibleCount: p, countContainer: f, count: _, okContainer: v, ok: b, message: y, customButtonContainer: C, customButton: w, list: B, progressBar: L, onDidAccept: this.onDidAcceptEmitter.event, onDidCustom: this.onDidCustomEmitter.event, onDidTriggerButton: this.onDidTriggerButtonEmitter.event, ignoreFocusOut: !1, keyMods: this.keyMods, show: (O) => this.show(O), hide: () => this.hide(), setVisibilities: (O) => this.setVisibilities(O), setEnabled: (O) => this.setEnabled(O), setContextKey: (O) => this.options.setContextKey(O), linkOpenerDelegate: (O) => this.options.linkOpenerDelegate(O) }, this.updateStyles(), this.ui;
  }
  reparentUI(i) {
    this.ui && (this._container = i, Z(this._container, this.ui.container));
  }
  pick(i, e = {}, t = et.None) {
    return new Promise((n, s) => {
      let o = (d) => {
        var h;
        o = n, (h = e.onKeyMods) === null || h === void 0 || h.call(e, r.keyMods), n(d);
      };
      if (t.isCancellationRequested) return void o(void 0);
      const r = this.createQuickPick();
      let a;
      const l = [r, r.onDidAccept(() => {
        if (r.canSelectMany) o(r.selectedItems.slice()), r.hide();
        else {
          const d = r.activeItems[0];
          d && (o(d), r.hide());
        }
      }), r.onDidChangeActive((d) => {
        const h = d[0];
        h && e.onDidFocus && e.onDidFocus(h);
      }), r.onDidChangeSelection((d) => {
        if (!r.canSelectMany) {
          const h = d[0];
          h && (o(h), r.hide());
        }
      }), r.onDidTriggerItemButton((d) => e.onDidTriggerItemButton && e.onDidTriggerItemButton({ ...d, removeItem: () => {
        const h = r.items.indexOf(d.item);
        if (h !== -1) {
          const c = r.items.slice(), u = c.splice(h, 1), g = r.activeItems.filter((f) => f !== u[0]), p = r.keepScrollPosition;
          r.keepScrollPosition = !0, r.items = c, g && (r.activeItems = g), r.keepScrollPosition = p;
        }
      } })), r.onDidTriggerSeparatorButton((d) => {
        var h;
        return (h = e.onDidTriggerSeparatorButton) === null || h === void 0 ? void 0 : h.call(e, d);
      }), r.onDidChangeValue((d) => {
        !a || d || r.activeItems.length === 1 && r.activeItems[0] === a || (r.activeItems = [a]);
      }), t.onCancellationRequested(() => {
        r.hide();
      }), r.onDidHide(() => {
        Ht(l), o(void 0);
      })];
      r.title = e.title, r.canSelectMany = !!e.canPickMany, r.placeholder = e.placeHolder, r.ignoreFocusOut = !!e.ignoreFocusLost, r.matchOnDescription = !!e.matchOnDescription, r.matchOnDetail = !!e.matchOnDetail, r.matchOnLabel = e.matchOnLabel === void 0 || e.matchOnLabel, r.quickNavigate = e.quickNavigate, r.hideInput = !!e.hideInput, r.contextKey = e.contextKey, r.busy = !0, Promise.all([i, e.activeItem]).then(([d, h]) => {
        a = h, r.busy = !1, r.items = d, r.canSelectMany && (r.selectedItems = d.filter((c) => c.type !== "separator" && c.picked)), a && (r.activeItems = [a]);
      }), r.show(), Promise.resolve(i).then(void 0, (d) => {
        s(d), r.hide();
      });
    });
  }
  createQuickPick() {
    const i = this.getUI(!0);
    return new zv(i);
  }
  createInputBox() {
    const i = this.getUI(!0);
    return new Nie(i);
  }
  show(i) {
    const e = this.getUI(!0);
    this.onShowEmitter.fire();
    const t = this.controller;
    this.controller = i, t == null || t.didHide(), this.setEnabled(!0), e.leftActionBar.clear(), e.title.textContent = "", e.description1.textContent = "", e.description2.textContent = "", wn(e.widget), e.rightActionBar.clear(), e.checkAll.checked = !1, e.inputBox.placeholder = "", e.inputBox.password = !1, e.inputBox.showDecoration(ki.Ignore), e.visibleCount.setCount(0), e.count.setCount(0), wn(e.message), e.progressBar.stop(), e.list.setElements([]), e.list.matchOnDescription = !1, e.list.matchOnDetail = !1, e.list.matchOnLabel = !0, e.list.sortByLabel = !0, e.ignoreFocusOut = !1, e.inputBox.toggles = void 0;
    const n = this.options.backKeybindingLabel();
    _2.tooltip = n ? m(0, "Back ({0})", n) : m(0, "Back"), e.container.style.display = "", this.updateLayout(), e.inputBox.setFocus();
  }
  isVisible() {
    return !!this.ui && this.ui.container.style.display !== "none";
  }
  setVisibilities(i) {
    const e = this.getUI();
    e.title.style.display = i.title ? "" : "none", e.description1.style.display = i.description && (i.inputBox || i.checkAll) ? "" : "none", e.description2.style.display = !i.description || i.inputBox || i.checkAll ? "none" : "", e.checkAll.style.display = i.checkAll ? "" : "none", e.inputContainer.style.display = i.inputBox ? "" : "none", e.filterContainer.style.display = i.inputBox ? "" : "none", e.visibleCountContainer.style.display = i.visibleCount ? "" : "none", e.countContainer.style.display = i.count ? "" : "none", e.okContainer.style.display = i.ok ? "" : "none", e.customButtonContainer.style.display = i.customButton ? "" : "none", e.message.style.display = i.message ? "" : "none", e.progressBar.getContainer().style.display = i.progressBar ? "" : "none", e.list.display(!!i.list), e.container.classList.toggle("show-checkboxes", !!i.checkBox), e.container.classList.toggle("hidden-input", !i.inputBox && !i.description), this.updateLayout();
  }
  setEnabled(i) {
    if (i !== this.enabled) {
      this.enabled = i;
      for (const e of this.getUI().leftActionBar.viewItems) e.action.enabled = i;
      for (const e of this.getUI().rightActionBar.viewItems) e.action.enabled = i;
      this.getUI().checkAll.disabled = !i, this.getUI().inputBox.enabled = i, this.getUI().ok.enabled = i, this.getUI().list.enabled = i;
    }
  }
  hide(i) {
    var e, t;
    const n = this.controller;
    if (!n) return;
    n.willHide(i);
    const s = (e = this.ui) === null || e === void 0 ? void 0 : e.container, o = s && !w8(s);
    if (this.controller = null, this.onHideEmitter.fire(), s && (s.style.display = "none"), !o) {
      let r = this.previousFocusElement;
      for (; r && !r.offsetParent; ) r = (t = r.parentElement) !== null && t !== void 0 ? t : void 0;
      r != null && r.offsetParent ? (r.focus(), this.previousFocusElement = void 0) : this.options.returnFocus();
    }
    n.didHide(i);
  }
  layout(i, e) {
    this.dimension = i, this.titleBarOffset = e, this.updateLayout();
  }
  updateLayout() {
    if (this.ui && this.isVisible()) {
      this.ui.container.style.top = `${this.titleBarOffset}px`;
      const i = this.ui.container.style, e = Math.min(0.62 * this.dimension.width, C2.MAX_WIDTH);
      i.width = e + "px", i.marginLeft = "-" + e / 2 + "px", this.ui.inputBox.layout(), this.ui.list.layout(this.dimension && 0.4 * this.dimension.height);
    }
  }
  applyStyles(i) {
    this.styles = i, this.updateStyles();
  }
  updateStyles() {
    if (this.ui) {
      const { quickInputTitleBackground: i, quickInputBackground: e, quickInputForeground: t, widgetBorder: n, widgetShadow: s } = this.styles.widget;
      this.ui.titleBar.style.backgroundColor = i ?? "", this.ui.container.style.backgroundColor = e ?? "", this.ui.container.style.color = t ?? "", this.ui.container.style.border = n ? `1px solid ${n}` : "", this.ui.container.style.boxShadow = s ? `0 0 8px 2px ${s}` : "", this.ui.list.style(this.styles.list);
      const o = [];
      this.styles.pickerGroup.pickerGroupBorder && o.push(`.quick-input-list .quick-input-list-entry { border-top-color:  ${this.styles.pickerGroup.pickerGroupBorder}; }`), this.styles.pickerGroup.pickerGroupForeground && o.push(`.quick-input-list .quick-input-list-separator { color:  ${this.styles.pickerGroup.pickerGroupForeground}; }`), this.styles.pickerGroup.pickerGroupForeground && o.push(".quick-input-list .quick-input-list-separator-as-item { color: var(--vscode-descriptionForeground); }"), (this.styles.keybindingLabel.keybindingLabelBackground || this.styles.keybindingLabel.keybindingLabelBorder || this.styles.keybindingLabel.keybindingLabelBottomBorder || this.styles.keybindingLabel.keybindingLabelShadow || this.styles.keybindingLabel.keybindingLabelForeground) && (o.push(".quick-input-list .monaco-keybinding > .monaco-keybinding-key {"), this.styles.keybindingLabel.keybindingLabelBackground && o.push(`background-color: ${this.styles.keybindingLabel.keybindingLabelBackground};`), this.styles.keybindingLabel.keybindingLabelBorder && o.push(`border-color: ${this.styles.keybindingLabel.keybindingLabelBorder};`), this.styles.keybindingLabel.keybindingLabelBottomBorder && o.push(`border-bottom-color: ${this.styles.keybindingLabel.keybindingLabelBottomBorder};`), this.styles.keybindingLabel.keybindingLabelShadow && o.push(`box-shadow: inset 0 -1px 0 ${this.styles.keybindingLabel.keybindingLabelShadow};`), this.styles.keybindingLabel.keybindingLabelForeground && o.push(`color: ${this.styles.keybindingLabel.keybindingLabelForeground};`), o.push("}"));
      const r = o.join(`
`);
      r !== this.ui.styleSheet.textContent && (this.ui.styleSheet.textContent = r);
    }
  }
};
iw.MAX_WIDTH = 600, iw = C2 = Mie([pF(1, Pc), pF(2, Se)], iw);
var Tie = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Gf = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let w2 = class extends mZ {
  get controller() {
    return this._controller || (this._controller = this._register(this.createController())), this._controller;
  }
  get hasController() {
    return !!this._controller;
  }
  get quickAccess() {
    return this._quickAccess || (this._quickAccess = this._register(this.instantiationService.createInstance(r2))), this._quickAccess;
  }
  constructor(i, e, t, n, s) {
    super(t), this.instantiationService = i, this.contextKeyService = e, this.layoutService = n, this.configurationService = s, this._onShow = this._register(new F()), this._onHide = this._register(new F()), this.contexts = /* @__PURE__ */ new Map();
  }
  createController(i = this.layoutService, e) {
    const t = { idPrefix: "quickInput_", container: i.activeContainer, ignoreFocusOut: () => !1, backKeybindingLabel: () => {
    }, setContextKey: (s) => this.setContextKey(s), linkOpenerDelegate: (s) => {
      this.instantiationService.invokeFunction((o) => {
        o.get(Fs).open(s, { allowCommands: !0, fromUserGesture: !0 });
      });
    }, returnFocus: () => i.focus(), styles: this.computeStyles(), hoverDelegate: this._register(this.instantiationService.createInstance(v2)) }, n = this._register(this.instantiationService.createInstance(iw, { ...t, ...e }));
    return n.layout(i.activeContainerDimension, i.activeContainerOffset.quickPickTop), this._register(i.onDidLayoutActiveContainer((s) => {
      ke(i.activeContainer) === ke(n.container) && n.layout(s, i.activeContainerOffset.quickPickTop);
    })), this._register(i.onDidChangeActiveContainer(() => {
      n.isVisible() || n.layout(i.activeContainerDimension, i.activeContainerOffset.quickPickTop);
    })), this._register(n.onShow(() => {
      this.resetContextKeys(), this._onShow.fire();
    })), this._register(n.onHide(() => {
      this.resetContextKeys(), this._onHide.fire();
    })), n;
  }
  setContextKey(i) {
    let e;
    i && (e = this.contexts.get(i), e || (e = new ae(i, !1).bindTo(this.contextKeyService), this.contexts.set(i, e))), e && e.get() || (this.resetContextKeys(), e == null || e.set(!0));
  }
  resetContextKeys() {
    this.contexts.forEach((i) => {
      i.get() && i.reset();
    });
  }
  pick(i, e = {}, t = et.None) {
    return this.controller.pick(i, e, t);
  }
  createQuickPick() {
    return this.controller.createQuickPick();
  }
  createInputBox() {
    return this.controller.createInputBox();
  }
  updateStyles() {
    this.hasController && this.controller.applyStyles(this.computeStyles());
  }
  computeStyles() {
    return { widget: { quickInputBackground: de(H4), quickInputForeground: de(RG), quickInputTitleBackground: de(AG), widgetBorder: de(uB), widgetShadow: de(gd) }, inputBox: Wy, toggle: By, countBadge: QW, button: rte, progressBar: ate, keybindingLabel: ote, list: Rg({ listBackground: H4, listFocusBackground: Ph, listFocusForeground: Ah, listInactiveFocusForeground: Ah, listInactiveSelectionIconForeground: Pp, listInactiveFocusBackground: Ph, listFocusOutline: Zt, listInactiveFocusOutline: Zt }), pickerGroup: { pickerGroupBorder: de(PG), pickerGroupForeground: de(vB) } };
  }
};
w2 = Tie([Gf(0, Se), Gf(1, Te), Gf(2, Yi), Gf(3, Pc), Gf(4, Ye)], w2);
var EV = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Su = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let y2 = class extends w2 {
  constructor(i, e, t, n, s, o) {
    super(e, t, n, new LI(i.getContainerDomNode(), s), o), this.host = void 0;
    const r = of.get(i);
    if (r) {
      const a = r.widget;
      this.host = { _serviceBrand: void 0, get mainContainer() {
        return a.getDomNode();
      }, getContainer: () => a.getDomNode(), whenContainerStylesLoaded() {
      }, get containers() {
        return [a.getDomNode()];
      }, get activeContainer() {
        return a.getDomNode();
      }, get mainContainerDimension() {
        return i.getLayoutInfo();
      }, get activeContainerDimension() {
        return i.getLayoutInfo();
      }, get onDidLayoutMainContainer() {
        return i.onDidLayoutChange;
      }, get onDidLayoutActiveContainer() {
        return i.onDidLayoutChange;
      }, get onDidLayoutContainer() {
        return se.map(i.onDidLayoutChange, (l) => ({ container: a.getDomNode(), dimension: l }));
      }, get onDidChangeActiveContainer() {
        return se.None;
      }, get onDidAddContainer() {
        return se.None;
      }, get mainContainerOffset() {
        return { top: 0, quickPickTop: 0 };
      }, get activeContainerOffset() {
        return { top: 0, quickPickTop: 0 };
      }, focus: () => i.focus() };
    } else this.host = void 0;
  }
  createController() {
    return super.createController(this.host);
  }
};
y2 = EV([Su(1, Se), Su(2, Te), Su(3, Yi), Su(4, mt), Su(5, Ye)], y2);
let S2 = class {
  get activeService() {
    const i = this.codeEditorService.getFocusedCodeEditor();
    if (!i) throw new Error("Quick input service needs a focused editor to work.");
    let e = this.mapEditorToService.get(i);
    if (!e) {
      const t = e = this.instantiationService.createInstance(y2, i);
      this.mapEditorToService.set(i, e), mc(i.onDidDispose)(() => {
        t.dispose(), this.mapEditorToService.delete(i);
      });
    }
    return e;
  }
  get quickAccess() {
    return this.activeService.quickAccess;
  }
  constructor(i, e) {
    this.instantiationService = i, this.codeEditorService = e, this.mapEditorToService = /* @__PURE__ */ new Map();
  }
  pick(i, e = {}, t = et.None) {
    return this.activeService.pick(i, e, t);
  }
  createQuickPick() {
    return this.activeService.createQuickPick();
  }
  createInputBox() {
    return this.activeService.createInputBox();
  }
};
S2 = EV([Su(0, Se), Su(1, mt)], S2);
class of {
  static get(e) {
    return e.getContribution(of.ID);
  }
  constructor(e) {
    this.editor = e, this.widget = new VL(this.editor);
  }
  dispose() {
    this.widget.dispose();
  }
}
of.ID = "editor.controller.quickInput";
class VL {
  constructor(e) {
    this.codeEditor = e, this.domNode = document.createElement("div"), this.codeEditor.addOverlayWidget(this);
  }
  getId() {
    return VL.ID;
  }
  getDomNode() {
    return this.domNode;
  }
  getPosition() {
    return { preference: 2 };
  }
  dispose() {
    this.codeEditor.removeOverlayWidget(this);
  }
}
VL.ID = "editor.contrib.quickInputWidget", ft(of.ID, of, 4);
class Rie {
  constructor(e, t, n, s, o) {
    this._parsedThemeRuleBrand = void 0, this.token = e, this.index = t, this.fontStyle = n, this.foreground = s, this.background = o;
  }
}
const Aie = /^#?([0-9A-Fa-f]{6})([0-9A-Fa-f]{2})?$/;
class Pie {
  constructor() {
    this._lastColorId = 0, this._id2color = [], this._color2id = /* @__PURE__ */ new Map();
  }
  getId(e) {
    if (e === null) return 0;
    const t = e.match(Aie);
    if (!t) throw new Error("Illegal value for token color: " + e);
    e = t[1].toUpperCase();
    let n = this._color2id.get(e);
    return n || (n = ++this._lastColorId, this._color2id.set(e, n), this._id2color[n] = z.fromHex("#" + e), n);
  }
  getColorMap() {
    return this._id2color.slice(0);
  }
}
class jA {
  static createFromRawTokenTheme(e, t) {
    return this.createFromParsedTokenTheme(function(n) {
      if (!n || !Array.isArray(n)) return [];
      const s = [];
      let o = 0;
      for (let r = 0, a = n.length; r < a; r++) {
        const l = n[r];
        let d = -1;
        if (typeof l.fontStyle == "string") {
          d = 0;
          const u = l.fontStyle.split(" ");
          for (let g = 0, p = u.length; g < p; g++) switch (u[g]) {
            case "italic":
              d |= 1;
              break;
            case "bold":
              d |= 2;
              break;
            case "underline":
              d |= 4;
              break;
            case "strikethrough":
              d |= 8;
          }
        }
        let h = null;
        typeof l.foreground == "string" && (h = l.foreground);
        let c = null;
        typeof l.background == "string" && (c = l.background), s[o++] = new Rie(l.token || "", r, d, h, c);
      }
      return s;
    }(e), t);
  }
  static createFromParsedTokenTheme(e, t) {
    return function(n, s) {
      n.sort((g, p) => {
        const f = function(_, v) {
          return _ < v ? -1 : _ > v ? 1 : 0;
        }(g.token, p.token);
        return f !== 0 ? f : g.index - p.index;
      });
      let o = 0, r = "000000", a = "ffffff";
      for (; n.length >= 1 && n[0].token === ""; ) {
        const g = n.shift();
        g.fontStyle !== -1 && (o = g.fontStyle), g.foreground !== null && (r = g.foreground), g.background !== null && (a = g.background);
      }
      const l = new Pie();
      for (const g of s) l.getId(g);
      const d = l.getId(r), h = l.getId(a), c = new qA(o, d, h), u = new $A(c);
      for (let g = 0, p = n.length; g < p; g++) {
        const f = n[g];
        u.insert(f.token, f.fontStyle, l.getId(f.foreground), l.getId(f.background));
      }
      return new jA(l, u);
    }(e, t);
  }
  constructor(e, t) {
    this._colorMap = e, this._root = t, this._cache = /* @__PURE__ */ new Map();
  }
  getColorMap() {
    return this._colorMap.getColorMap();
  }
  _match(e) {
    return this._root.match(e);
  }
  match(e, t) {
    let n = this._cache.get(t);
    if (n === void 0) {
      const s = this._match(t), o = function(r) {
        const a = r.match(Oie);
        if (!a) return 0;
        switch (a[1]) {
          case "comment":
            return 1;
          case "string":
            return 2;
          case "regex":
          case "regexp":
            return 3;
        }
        throw new Error("Unexpected match for standard token type!");
      }(t);
      n = (s.metadata | o << 8) >>> 0, this._cache.set(t, n);
    }
    return (n | e) >>> 0;
  }
}
const Oie = /\b(comment|string|regex|regexp)\b/;
class qA {
  constructor(e, t, n) {
    this._themeTrieElementRuleBrand = void 0, this._fontStyle = e, this._foreground = t, this._background = n, this.metadata = (this._fontStyle << 11 | this._foreground << 15 | this._background << 24) >>> 0;
  }
  clone() {
    return new qA(this._fontStyle, this._foreground, this._background);
  }
  acceptOverwrite(e, t, n) {
    e !== -1 && (this._fontStyle = e), t !== 0 && (this._foreground = t), n !== 0 && (this._background = n), this.metadata = (this._fontStyle << 11 | this._foreground << 15 | this._background << 24) >>> 0;
  }
}
class $A {
  constructor(e) {
    this._themeTrieElementBrand = void 0, this._mainRule = e, this._children = /* @__PURE__ */ new Map();
  }
  match(e) {
    if (e === "") return this._mainRule;
    const t = e.indexOf(".");
    let n, s;
    t === -1 ? (n = e, s = "") : (n = e.substring(0, t), s = e.substring(t + 1));
    const o = this._children.get(n);
    return o !== void 0 ? o.match(s) : this._mainRule;
  }
  insert(e, t, n, s) {
    if (e === "") return void this._mainRule.acceptOverwrite(t, n, s);
    const o = e.indexOf(".");
    let r, a;
    o === -1 ? (r = e, a = "") : (r = e.substring(0, o), a = e.substring(o + 1));
    let l = this._children.get(r);
    l === void 0 && (l = new $A(this._mainRule.clone()), this._children.set(r, l)), l.insert(a, t, n, s);
  }
}
const Fie = { base: "vs", inherit: !1, rules: [{ token: "", foreground: "000000", background: "fffffe" }, { token: "invalid", foreground: "cd3131" }, { token: "emphasis", fontStyle: "italic" }, { token: "strong", fontStyle: "bold" }, { token: "variable", foreground: "001188" }, { token: "variable.predefined", foreground: "4864AA" }, { token: "constant", foreground: "dd0000" }, { token: "comment", foreground: "008000" }, { token: "number", foreground: "098658" }, { token: "number.hex", foreground: "3030c0" }, { token: "regexp", foreground: "800000" }, { token: "annotation", foreground: "808080" }, { token: "type", foreground: "008080" }, { token: "delimiter", foreground: "000000" }, { token: "delimiter.html", foreground: "383838" }, { token: "delimiter.xml", foreground: "0000FF" }, { token: "tag", foreground: "800000" }, { token: "tag.id.pug", foreground: "4F76AC" }, { token: "tag.class.pug", foreground: "4F76AC" }, { token: "meta.scss", foreground: "800000" }, { token: "metatag", foreground: "e00000" }, { token: "metatag.content.html", foreground: "FF0000" }, { token: "metatag.html", foreground: "808080" }, { token: "metatag.xml", foreground: "808080" }, { token: "metatag.php", fontStyle: "bold" }, { token: "key", foreground: "863B00" }, { token: "string.key.json", foreground: "A31515" }, { token: "string.value.json", foreground: "0451A5" }, { token: "attribute.name", foreground: "FF0000" }, { token: "attribute.value", foreground: "0451A5" }, { token: "attribute.value.number", foreground: "098658" }, { token: "attribute.value.unit", foreground: "098658" }, { token: "attribute.value.html", foreground: "0000FF" }, { token: "attribute.value.xml", foreground: "0000FF" }, { token: "string", foreground: "A31515" }, { token: "string.html", foreground: "0000FF" }, { token: "string.sql", foreground: "FF0000" }, { token: "string.yaml", foreground: "0451A5" }, { token: "keyword", foreground: "0000FF" }, { token: "keyword.json", foreground: "0451A5" }, { token: "keyword.flow", foreground: "AF00DB" }, { token: "keyword.flow.scss", foreground: "0000FF" }, { token: "operator.scss", foreground: "666666" }, { token: "operator.sql", foreground: "778899" }, { token: "operator.swift", foreground: "666666" }, { token: "predefined.sql", foreground: "C700C7" }], colors: { [sn]: "#FFFFFE", [Go]: "#000000", [hB]: "#E5EBF1", [D1]: "#D3D3D3", [x1]: "#939393", [OR]: "#ADD6FF4D" } }, Bie = { base: "vs-dark", inherit: !1, rules: [{ token: "", foreground: "D4D4D4", background: "1E1E1E" }, { token: "invalid", foreground: "f44747" }, { token: "emphasis", fontStyle: "italic" }, { token: "strong", fontStyle: "bold" }, { token: "variable", foreground: "74B0DF" }, { token: "variable.predefined", foreground: "4864AA" }, { token: "variable.parameter", foreground: "9CDCFE" }, { token: "constant", foreground: "569CD6" }, { token: "comment", foreground: "608B4E" }, { token: "number", foreground: "B5CEA8" }, { token: "number.hex", foreground: "5BB498" }, { token: "regexp", foreground: "B46695" }, { token: "annotation", foreground: "cc6666" }, { token: "type", foreground: "3DC9B0" }, { token: "delimiter", foreground: "DCDCDC" }, { token: "delimiter.html", foreground: "808080" }, { token: "delimiter.xml", foreground: "808080" }, { token: "tag", foreground: "569CD6" }, { token: "tag.id.pug", foreground: "4F76AC" }, { token: "tag.class.pug", foreground: "4F76AC" }, { token: "meta.scss", foreground: "A79873" }, { token: "meta.tag", foreground: "CE9178" }, { token: "metatag", foreground: "DD6A6F" }, { token: "metatag.content.html", foreground: "9CDCFE" }, { token: "metatag.html", foreground: "569CD6" }, { token: "metatag.xml", foreground: "569CD6" }, { token: "metatag.php", fontStyle: "bold" }, { token: "key", foreground: "9CDCFE" }, { token: "string.key.json", foreground: "9CDCFE" }, { token: "string.value.json", foreground: "CE9178" }, { token: "attribute.name", foreground: "9CDCFE" }, { token: "attribute.value", foreground: "CE9178" }, { token: "attribute.value.number.css", foreground: "B5CEA8" }, { token: "attribute.value.unit.css", foreground: "B5CEA8" }, { token: "attribute.value.hex.css", foreground: "D4D4D4" }, { token: "string", foreground: "CE9178" }, { token: "string.sql", foreground: "FF0000" }, { token: "keyword", foreground: "569CD6" }, { token: "keyword.flow", foreground: "C586C0" }, { token: "keyword.json", foreground: "CE9178" }, { token: "keyword.flow.scss", foreground: "569CD6" }, { token: "operator.scss", foreground: "909090" }, { token: "operator.sql", foreground: "778899" }, { token: "operator.swift", foreground: "909090" }, { token: "predefined.sql", foreground: "FF00FF" }], colors: { [sn]: "#1E1E1E", [Go]: "#D4D4D4", [hB]: "#3A3D41", [D1]: "#404040", [x1]: "#707070", [OR]: "#ADD6FF26" } }, Wie = { base: "hc-black", inherit: !1, rules: [{ token: "", foreground: "FFFFFF", background: "000000" }, { token: "invalid", foreground: "f44747" }, { token: "emphasis", fontStyle: "italic" }, { token: "strong", fontStyle: "bold" }, { token: "variable", foreground: "1AEBFF" }, { token: "variable.parameter", foreground: "9CDCFE" }, { token: "constant", foreground: "569CD6" }, { token: "comment", foreground: "608B4E" }, { token: "number", foreground: "FFFFFF" }, { token: "regexp", foreground: "C0C0C0" }, { token: "annotation", foreground: "569CD6" }, { token: "type", foreground: "3DC9B0" }, { token: "delimiter", foreground: "FFFF00" }, { token: "delimiter.html", foreground: "FFFF00" }, { token: "tag", foreground: "569CD6" }, { token: "tag.id.pug", foreground: "4F76AC" }, { token: "tag.class.pug", foreground: "4F76AC" }, { token: "meta", foreground: "D4D4D4" }, { token: "meta.tag", foreground: "CE9178" }, { token: "metatag", foreground: "569CD6" }, { token: "metatag.content.html", foreground: "1AEBFF" }, { token: "metatag.html", foreground: "569CD6" }, { token: "metatag.xml", foreground: "569CD6" }, { token: "metatag.php", fontStyle: "bold" }, { token: "key", foreground: "9CDCFE" }, { token: "string.key", foreground: "9CDCFE" }, { token: "string.value", foreground: "CE9178" }, { token: "attribute.name", foreground: "569CD6" }, { token: "attribute.value", foreground: "3FF23F" }, { token: "string", foreground: "CE9178" }, { token: "string.sql", foreground: "FF0000" }, { token: "keyword", foreground: "569CD6" }, { token: "keyword.flow", foreground: "C586C0" }, { token: "operator.sql", foreground: "778899" }, { token: "operator.swift", foreground: "909090" }, { token: "predefined.sql", foreground: "FF00FF" }], colors: { [sn]: "#000000", [Go]: "#FFFFFF", [D1]: "#FFFFFF", [x1]: "#FFFFFF" } }, Vie = { base: "hc-light", inherit: !1, rules: [{ token: "", foreground: "292929", background: "FFFFFF" }, { token: "invalid", foreground: "B5200D" }, { token: "emphasis", fontStyle: "italic" }, { token: "strong", fontStyle: "bold" }, { token: "variable", foreground: "264F70" }, { token: "variable.predefined", foreground: "4864AA" }, { token: "constant", foreground: "dd0000" }, { token: "comment", foreground: "008000" }, { token: "number", foreground: "098658" }, { token: "number.hex", foreground: "3030c0" }, { token: "regexp", foreground: "800000" }, { token: "annotation", foreground: "808080" }, { token: "type", foreground: "008080" }, { token: "delimiter", foreground: "000000" }, { token: "delimiter.html", foreground: "383838" }, { token: "tag", foreground: "800000" }, { token: "tag.id.pug", foreground: "4F76AC" }, { token: "tag.class.pug", foreground: "4F76AC" }, { token: "meta.scss", foreground: "800000" }, { token: "metatag", foreground: "e00000" }, { token: "metatag.content.html", foreground: "B5200D" }, { token: "metatag.html", foreground: "808080" }, { token: "metatag.xml", foreground: "808080" }, { token: "metatag.php", fontStyle: "bold" }, { token: "key", foreground: "863B00" }, { token: "string.key.json", foreground: "A31515" }, { token: "string.value.json", foreground: "0451A5" }, { token: "attribute.name", foreground: "264F78" }, { token: "attribute.value", foreground: "0451A5" }, { token: "string", foreground: "A31515" }, { token: "string.sql", foreground: "B5200D" }, { token: "keyword", foreground: "0000FF" }, { token: "keyword.flow", foreground: "AF00DB" }, { token: "operator.sql", foreground: "778899" }, { token: "operator.swift", foreground: "666666" }, { token: "predefined.sql", foreground: "C700C7" }], colors: { [sn]: "#FFFFFF", [Go]: "#292929", [D1]: "#292929", [x1]: "#292929" } };
var mF, fF;
(function(i) {
  i.getDefinition = function(e, t) {
    let n = e.defaults;
    for (; Ee.isThemeIcon(n); ) {
      const s = vg.getIcon(n.id);
      if (!s) return;
      n = s.defaults;
    }
    return n;
  };
})(mF || (mF = {})), function(i) {
  i.toJSONObject = function(e) {
    return { weight: e.weight, style: e.style, src: e.src.map((t) => ({ format: t.format, location: t.location.toString() })) };
  }, i.fromJSONObject = function(e) {
    const t = (n) => ps(n) ? n : void 0;
    if (e && Array.isArray(e.src) && e.src.every((n) => ps(n.format) && ps(n.location))) return { weight: t(e.weight), style: t(e.style), src: e.src.map((n) => ({ format: n.format, location: Ie.parse(n.location) })) };
  };
}(fF || (fF = {}));
const vg = new class {
  constructor() {
    this._onDidChange = new F(), this.onDidChange = this._onDidChange.event, this.iconSchema = { definitions: { icons: { type: "object", properties: { fontId: { type: "string", description: m(0, "The id of the font to use. If not set, the font that is defined first is used.") }, fontCharacter: { type: "string", description: m(0, "The font character associated with the icon definition.") } }, additionalProperties: !1, defaultSnippets: [{ body: { fontCharacter: "\\\\e030" } }] } }, type: "object", properties: {} }, this.iconReferenceSchema = { type: "string", pattern: `^${Ee.iconNameExpression}$`, enum: [], enumDescriptions: [] }, this.iconsById = {}, this.iconFontsById = {};
  }
  registerIcon(i, e, t, n) {
    const s = this.iconsById[i];
    if (s) {
      if (t && !s.description) {
        s.description = t, this.iconSchema.properties[i].markdownDescription = `${t} $(${i})`;
        const a = this.iconReferenceSchema.enum.indexOf(i);
        a !== -1 && (this.iconReferenceSchema.enumDescriptions[a] = t), this._onDidChange.fire();
      }
      return s;
    }
    const o = { id: i, description: t, defaults: e, deprecationMessage: n };
    this.iconsById[i] = o;
    const r = { $ref: "#/definitions/icons" };
    return n && (r.deprecationMessage = n), t && (r.markdownDescription = `${t}: $(${i})`), this.iconSchema.properties[i] = r, this.iconReferenceSchema.enum.push(i), this.iconReferenceSchema.enumDescriptions.push(t || ""), this._onDidChange.fire(), { id: i };
  }
  getIcons() {
    return Object.keys(this.iconsById).map((i) => this.iconsById[i]);
  }
  getIcon(i) {
    return this.iconsById[i];
  }
  getIconSchema() {
    return this.iconSchema;
  }
  toString() {
    const i = (s, o) => s.id.localeCompare(o.id), e = (s) => {
      for (; Ee.isThemeIcon(s.defaults); ) s = this.iconsById[s.defaults.id];
      return `codicon codicon-${s ? s.id : ""}`;
    }, t = [];
    t.push("| preview     | identifier                        | default codicon ID                | description"), t.push("| ----------- | --------------------------------- | --------------------------------- | --------------------------------- |");
    const n = Object.keys(this.iconsById).map((s) => this.iconsById[s]);
    for (const s of n.filter((o) => !!o.description).sort(i)) t.push(`|<i class="${e(s)}"></i>|${s.id}|${Ee.isThemeIcon(s.defaults) ? s.defaults.id : s.id}|${s.description || ""}|`);
    t.push("| preview     | identifier                        "), t.push("| ----------- | --------------------------------- |");
    for (const s of n.filter((o) => !Ee.isThemeIcon(o.defaults)).sort(i)) t.push(`|<i class="${e(s)}"></i>|${s.id}|`);
    return t.join(`
`);
  }
}();
function Ei(i, e, t, n) {
  return vg.registerIcon(i, e, t, n);
}
function IV() {
  return vg;
}
li.add("base.contributions.icons", vg), function() {
  const i = G7();
  for (const e in i) {
    const t = "\\" + i[e].toString(16);
    vg.registerIcon(e, { fontCharacter: t });
  }
}();
const MV = "vscode://schemas/icons", TV = li.as(nL);
TV.registerSchema(MV, vg.getIconSchema());
const _F = new It(() => TV.notifySchemaChanged(MV), 200);
vg.onDidChange(() => {
  _F.isScheduled() || _F.schedule();
});
const RV = Ei("widget-close", ne.close, m(0, "Icon for the close action in widgets."));
Ei("goto-previous-location", ne.arrowUp, m(0, "Icon for goto previous editor location.")), Ei("goto-next-location", ne.arrowDown, m(0, "Icon for goto next editor location.")), Ee.modify(ne.sync, "spin"), Ee.modify(ne.loading, "spin");
class vF {
  getIcon(e) {
    const t = IV();
    let n = e.defaults;
    for (; Ee.isThemeIcon(n); ) {
      const s = t.getIcon(n.id);
      if (!s) return;
      n = s.defaults;
    }
    return n;
  }
}
const td = "vs", wm = "vs-dark", Zu = "hc-black", Yu = "hc-light", AV = li.as(aB), Hie = li.as(kB);
class PV {
  constructor(e, t) {
    this.semanticHighlighting = !1, this.themeData = t;
    const n = t.base;
    e.length > 0 ? (nw(e) ? this.id = e : this.id = n + " " + e, this.themeName = e) : (this.id = n, this.themeName = n), this.colors = null, this.defaultColors = /* @__PURE__ */ Object.create(null), this._tokenTheme = null;
  }
  get base() {
    return this.themeData.base;
  }
  notifyBaseUpdated() {
    this.themeData.inherit && (this.colors = null, this._tokenTheme = null);
  }
  getColors() {
    if (!this.colors) {
      const e = /* @__PURE__ */ new Map();
      for (const t in this.themeData.colors) e.set(t, z.fromHex(this.themeData.colors[t]));
      if (this.themeData.inherit) {
        const t = L2(this.themeData.base);
        for (const n in t.colors) e.has(n) || e.set(n, z.fromHex(t.colors[n]));
      }
      this.colors = e;
    }
    return this.colors;
  }
  getColor(e, t) {
    return this.getColors().get(e) || (t !== !1 ? this.getDefault(e) : void 0);
  }
  getDefault(e) {
    let t = this.defaultColors[e];
    return t || (t = AV.resolveDefaultColor(e, this), this.defaultColors[e] = t, t);
  }
  defines(e) {
    return this.getColors().has(e);
  }
  get type() {
    switch (this.base) {
      case td:
        return Zo.LIGHT;
      case Zu:
        return Zo.HIGH_CONTRAST_DARK;
      case Yu:
        return Zo.HIGH_CONTRAST_LIGHT;
      default:
        return Zo.DARK;
    }
  }
  get tokenTheme() {
    if (!this._tokenTheme) {
      let e = [], t = [];
      if (this.themeData.inherit) {
        const o = L2(this.themeData.base);
        e = o.rules, o.encodedTokensColors && (t = o.encodedTokensColors);
      }
      const n = this.themeData.colors["editor.foreground"], s = this.themeData.colors["editor.background"];
      if (n || s) {
        const o = { token: "" };
        n && (o.foreground = n), s && (o.background = s), e.push(o);
      }
      e = e.concat(this.themeData.rules), this.themeData.encodedTokensColors && (t = this.themeData.encodedTokensColors), this._tokenTheme = jA.createFromRawTokenTheme(e, t);
    }
    return this._tokenTheme;
  }
  getTokenStyleMetadata(e, t, n) {
    const s = this.tokenTheme._match([e].concat(t).join(".")).metadata, o = In.getForeground(s), r = In.getFontStyle(s);
    return { foreground: o, italic: !!(1 & r), bold: !!(2 & r), underline: !!(4 & r), strikethrough: !!(8 & r) };
  }
}
function nw(i) {
  return i === td || i === wm || i === Zu || i === Yu;
}
function L2(i) {
  switch (i) {
    case td:
      return Fie;
    case wm:
      return Bie;
    case Zu:
      return Wie;
    case Yu:
      return Vie;
  }
}
function jb(i) {
  const e = L2(i);
  return new PV(i, e);
}
const Ro = tt("themeService");
var zie = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, dx = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let k2 = class extends V {
  constructor(i, e, t) {
    super(), this._contextKeyService = i, this._layoutService = e, this._configurationService = t, this._accessibilitySupport = 0, this._onDidChangeScreenReaderOptimized = new F(), this._onDidChangeReducedMotion = new F(), this._accessibilityModeEnabledContext = m_.bindTo(this._contextKeyService);
    const n = () => this._accessibilityModeEnabledContext.set(this.isScreenReaderOptimized());
    this._register(this._configurationService.onDidChangeConfiguration((o) => {
      o.affectsConfiguration("editor.accessibilitySupport") && (n(), this._onDidChangeScreenReaderOptimized.fire()), o.affectsConfiguration("workbench.reduceMotion") && (this._configMotionReduced = this._configurationService.getValue("workbench.reduceMotion"), this._onDidChangeReducedMotion.fire());
    })), n(), this._register(this.onDidChangeScreenReaderOptimized(() => n()));
    const s = Et.matchMedia("(prefers-reduced-motion: reduce)");
    this._systemMotionReduced = s.matches, this._configMotionReduced = this._configurationService.getValue("workbench.reduceMotion"), this.initReducedMotionListeners(s);
  }
  initReducedMotionListeners(i) {
    this._register(K(i, "change", () => {
      this._systemMotionReduced = i.matches, this._configMotionReduced === "auto" && this._onDidChangeReducedMotion.fire();
    }));
    const e = () => {
      const t = this.isMotionReduced();
      this._layoutService.mainContainer.classList.toggle("reduce-motion", t), this._layoutService.mainContainer.classList.toggle("enable-motion", !t);
    };
    e(), this._register(this.onDidChangeReducedMotion(() => e()));
  }
  get onDidChangeScreenReaderOptimized() {
    return this._onDidChangeScreenReaderOptimized.event;
  }
  isScreenReaderOptimized() {
    const i = this._configurationService.getValue("editor.accessibilitySupport");
    return i === "on" || i === "auto" && this._accessibilitySupport === 2;
  }
  get onDidChangeReducedMotion() {
    return this._onDidChangeReducedMotion.event;
  }
  isMotionReduced() {
    const i = this._configMotionReduced;
    return i === "on" || i === "auto" && this._systemMotionReduced;
  }
  getAccessibilitySupport() {
    return this._accessibilitySupport;
  }
};
k2 = zie([dx(0, Te), dx(1, Pc), dx(2, Ye)], k2);
var fp, dh, HL = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, bg = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let D2 = class {
  constructor(i, e) {
    this._commandService = i, this._hiddenStates = new sw(e);
  }
  createMenu(i, e, t) {
    return new N2(i, this._hiddenStates, { emitEventsForSubmenuChanges: !1, eventDebounceDelay: 50, ...t }, this._commandService, e);
  }
  resetHiddenStates(i) {
    this._hiddenStates.reset(i);
  }
};
D2 = HL([bg(0, ai), bg(1, Nr)], D2);
let sw = fp = class {
  constructor(i) {
    this._storageService = i, this._disposables = new G(), this._onDidChange = new F(), this.onDidChange = this._onDidChange.event, this._ignoreChangeEvent = !1, this._hiddenByDefaultCache = /* @__PURE__ */ new Map();
    try {
      const e = i.get(fp._key, 0, "{}");
      this._data = JSON.parse(e);
    } catch {
      this._data = /* @__PURE__ */ Object.create(null);
    }
    this._disposables.add(i.onDidChangeValue(0, fp._key, this._disposables)(() => {
      if (!this._ignoreChangeEvent) try {
        const e = i.get(fp._key, 0, "{}");
        this._data = JSON.parse(e);
      } catch (e) {
        console.log("FAILED to read storage after UPDATE", e);
      }
      this._onDidChange.fire();
    }));
  }
  dispose() {
    this._onDidChange.dispose(), this._disposables.dispose();
  }
  _isHiddenByDefault(i, e) {
    var t;
    return (t = this._hiddenByDefaultCache.get(`${i.id}/${e}`)) !== null && t !== void 0 && t;
  }
  setDefaultState(i, e, t) {
    this._hiddenByDefaultCache.set(`${i.id}/${e}`, t);
  }
  isHidden(i, e) {
    var t, n;
    const s = this._isHiddenByDefault(i, e), o = (n = (t = this._data[i.id]) === null || t === void 0 ? void 0 : t.includes(e)) !== null && n !== void 0 && n;
    return s ? !o : o;
  }
  updateHidden(i, e, t) {
    this._isHiddenByDefault(i, e) && (t = !t);
    const n = this._data[i.id];
    if (t) n ? n.indexOf(e) < 0 && n.push(e) : this._data[i.id] = [e];
    else if (n) {
      const s = n.indexOf(e);
      s >= 0 && function(o, r) {
        const a = o.length - 1;
        r < a && (o[r] = o[a]), o.pop();
      }(n, s), n.length === 0 && delete this._data[i.id];
    }
    this._persist();
  }
  reset(i) {
    if (i === void 0) this._data = /* @__PURE__ */ Object.create(null), this._persist();
    else {
      for (const { id: e } of i) this._data[e] && delete this._data[e];
      this._persist();
    }
  }
  _persist() {
    try {
      this._ignoreChangeEvent = !0;
      const i = JSON.stringify(this._data);
      this._storageService.store(fp._key, i, 0, 0);
    } finally {
      this._ignoreChangeEvent = !1;
    }
  }
};
sw._key = "menu.hiddenCommands", sw = fp = HL([bg(0, Nr)], sw);
let x2 = dh = class {
  constructor(i, e, t, n, s) {
    this._id = i, this._hiddenStates = e, this._collectContextKeysForSubmenus = t, this._commandService = n, this._contextKeyService = s, this._menuGroups = [], this._structureContextKeys = /* @__PURE__ */ new Set(), this._preconditionContextKeys = /* @__PURE__ */ new Set(), this._toggledContextKeys = /* @__PURE__ */ new Set(), this.refresh();
  }
  get structureContextKeys() {
    return this._structureContextKeys;
  }
  get preconditionContextKeys() {
    return this._preconditionContextKeys;
  }
  get toggledContextKeys() {
    return this._toggledContextKeys;
  }
  refresh() {
    this._menuGroups.length = 0, this._structureContextKeys.clear(), this._preconditionContextKeys.clear(), this._toggledContextKeys.clear();
    const i = tn.getMenuItems(this._id);
    let e;
    i.sort(dh._compareMenuItems);
    for (const t of i) {
      const n = t.group || "";
      e && e[0] === n || (e = [n, []], this._menuGroups.push(e)), e[1].push(t), this._collectContextKeys(t);
    }
  }
  _collectContextKeys(i) {
    if (dh._fillInKbExprKeys(i.when, this._structureContextKeys), xp(i)) {
      if (i.command.precondition && dh._fillInKbExprKeys(i.command.precondition, this._preconditionContextKeys), i.command.toggled) {
        const e = i.command.toggled.condition || i.command.toggled;
        dh._fillInKbExprKeys(e, this._toggledContextKeys);
      }
    } else this._collectContextKeysForSubmenus && tn.getMenuItems(i.submenu).forEach(this._collectContextKeys, this);
  }
  createActionGroups(i) {
    const e = [];
    for (const t of this._menuGroups) {
      const [n, s] = t, o = [];
      for (const r of s) if (this._contextKeyService.contextMatchesRules(r.when)) {
        const a = xp(r);
        a && this._hiddenStates.setDefaultState(this._id, r.command.id, !!r.isHiddenByDefault);
        const l = Uie(this._id, a ? r.command : r, this._hiddenStates);
        if (a) o.push(new Eo(r.command, r.alt, i, l, this._contextKeyService, this._commandService));
        else {
          const d = new dh(r.submenu, this._hiddenStates, this._collectContextKeysForSubmenus, this._commandService, this._contextKeyService).createActionGroups(i), h = Ui.join(...d.map((c) => c[1]));
          h.length > 0 && o.push(new iv(r, l, h));
        }
      }
      o.length > 0 && e.push([n, o]);
    }
    return e;
  }
  static _fillInKbExprKeys(i, e) {
    if (i) for (const t of i.keys()) e.add(t);
  }
  static _compareMenuItems(i, e) {
    const t = i.group, n = e.group;
    if (t !== n) {
      if (!t) return 1;
      if (!n || t === "navigation") return -1;
      if (n === "navigation") return 1;
      const r = t.localeCompare(n);
      if (r !== 0) return r;
    }
    const s = i.order || 0, o = e.order || 0;
    return s < o ? -1 : s > o ? 1 : dh._compareTitles(xp(i) ? i.command.title : i.title, xp(e) ? e.command.title : e.title);
  }
  static _compareTitles(i, e) {
    const t = typeof i == "string" ? i : i.original, n = typeof e == "string" ? e : e.original;
    return t.localeCompare(n);
  }
};
x2 = dh = HL([bg(3, ai), bg(4, Te)], x2);
let N2 = class {
  constructor(i, e, t, n, s) {
    this._disposables = new G(), this._menuInfo = new x2(i, e, t.emitEventsForSubmenuChanges, n, s);
    const o = new It(() => {
      this._menuInfo.refresh(), this._onDidChange.fire({ menu: this, isStructuralChange: !0, isEnablementChange: !0, isToggleChange: !0 });
    }, t.eventDebounceDelay);
    this._disposables.add(o), this._disposables.add(tn.onDidChangeMenu((a) => {
      a.has(i) && o.schedule();
    }));
    const r = this._disposables.add(new G());
    this._onDidChange = new B7({ onWillAddFirstListener: () => {
      r.add(s.onDidChangeContext((a) => {
        const l = a.affectsSome(this._menuInfo.structureContextKeys), d = a.affectsSome(this._menuInfo.preconditionContextKeys), h = a.affectsSome(this._menuInfo.toggledContextKeys);
        (l || d || h) && this._onDidChange.fire({ menu: this, isStructuralChange: l, isEnablementChange: d, isToggleChange: h });
      })), r.add(e.onDidChange((a) => {
        this._onDidChange.fire({ menu: this, isStructuralChange: !0, isEnablementChange: !1, isToggleChange: !1 });
      }));
    }, onDidRemoveLastListener: r.clear.bind(r), delay: t.eventDebounceDelay, merge: (a) => {
      let l = !1, d = !1, h = !1;
      for (const c of a) if (l = l || c.isStructuralChange, d = d || c.isEnablementChange, h = h || c.isToggleChange, l && d && h) break;
      return { menu: this, isStructuralChange: l, isEnablementChange: d, isToggleChange: h };
    } }), this.onDidChange = this._onDidChange.event;
  }
  getActions(i) {
    return this._menuInfo.createActionGroups(i);
  }
  dispose() {
    this._disposables.dispose(), this._onDidChange.dispose();
  }
};
function Uie(i, e, t) {
  const n = e.submenu !== void 0 ? e.submenu.id : e.id, s = typeof e.title == "string" ? e.title : e.title.value, o = Qp({ id: `hide/${i.id}/${n}`, label: m(0, "Hide '{0}'", s), run() {
    t.updateHidden(i, n, !0);
  } }), r = Qp({ id: `toggle/${i.id}/${n}`, label: s, get checked() {
    return !t.isHidden(i, n);
  }, run() {
    t.updateHidden(i, n, !!this.checked);
  } });
  return { hide: o, toggle: r, get isHidden() {
    return !r.checked;
  } };
}
N2 = HL([bg(3, ai), bg(4, Te)], N2);
var E2, Kie = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, bF = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let ow = E2 = class extends V {
  constructor(i, e) {
    super(), this.layoutService = i, this.logService = e, this.mapTextToType = /* @__PURE__ */ new Map(), this.findText = "", this.resources = [], this.resourcesStateHash = void 0, (vc || o8) && this.installWebKitWriteTextWorkaround(), this._register(se.runAndSubscribe(HS, ({ window: t, disposables: n }) => {
      n.add(K(t.document, "copy", () => this.clearResources()));
    }, { window: Et, disposables: this._store }));
  }
  installWebKitWriteTextWorkaround() {
    const i = () => {
      const e = new b1();
      this.webKitPendingClipboardWritePromise && !this.webKitPendingClipboardWritePromise.isSettled && this.webKitPendingClipboardWritePromise.cancel(), this.webKitPendingClipboardWritePromise = e, navigator.clipboard.write([new ClipboardItem({ "text/plain": e.p })]).catch(async (t) => {
        t instanceof Error && t.name === "NotAllowedError" && e.isRejected || this.logService.error(t);
      });
    };
    this._register(se.runAndSubscribe(this.layoutService.onDidAddContainer, ({ container: e, disposables: t }) => {
      t.add(K(e, "click", i)), t.add(K(e, "keydown", i));
    }, { container: this.layoutService.mainContainer, disposables: this._store }));
  }
  async writeText(i, e) {
    if (this.writeResources([]), e) this.mapTextToType.set(e, i);
    else {
      if (this.webKitPendingClipboardWritePromise) return this.webKitPendingClipboardWritePromise.complete(i);
      try {
        return await navigator.clipboard.writeText(i);
      } catch (t) {
        console.error(t);
      }
      this.fallbackWriteText(i);
    }
  }
  fallbackWriteText(i) {
    const e = gf(), t = e.activeElement, n = e.body.appendChild(Q("textarea", { "aria-hidden": !0 }));
    n.style.height = "1px", n.style.width = "1px", n.style.position = "absolute", n.value = i, n.focus(), n.select(), e.execCommand("copy"), t instanceof HTMLElement && t.focus(), e.body.removeChild(n);
  }
  async readText(i) {
    if (i) return this.mapTextToType.get(i) || "";
    try {
      return await navigator.clipboard.readText();
    } catch (e) {
      console.error(e);
    }
    return "";
  }
  async readFindText() {
    return this.findText;
  }
  async writeFindText(i) {
    this.findText = i;
  }
  async writeResources(i) {
    i.length === 0 ? this.clearResources() : (this.resources = i, this.resourcesStateHash = await this.computeResourcesStateHash());
  }
  async readResources() {
    const i = await this.computeResourcesStateHash();
    return this.resourcesStateHash !== i && this.clearResources(), this.resources;
  }
  async computeResourcesStateHash() {
    if (this.resources.length !== 0)
      return WS((await this.readText()).substring(0, E2.MAX_RESOURCE_STATE_SOURCE_LENGTH));
  }
  clearResources() {
    this.resources = [], this.resourcesStateHash = void 0;
  }
};
ow.MAX_RESOURCE_STATE_SOURCE_LENGTH = 1e3, ow = E2 = Kie([bF(0, Pc), bF(1, ts)], ow);
const Kd = tt("clipboardService");
var jie = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, qie = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const C0 = "data-keybinding-context";
let GA = class {
  constructor(i, e) {
    this._id = i, this._parent = e, this._value = /* @__PURE__ */ Object.create(null), this._value._contextId = i;
  }
  get value() {
    return { ...this._value };
  }
  setValue(i, e) {
    return this._value[i] !== e && (this._value[i] = e, !0);
  }
  removeValue(i) {
    return i in this._value && (delete this._value[i], !0);
  }
  getValue(i) {
    const e = this._value[i];
    return e === void 0 && this._parent ? this._parent.getValue(i) : e;
  }
};
class rf extends GA {
  constructor() {
    super(-1, null);
  }
  setValue(e, t) {
    return !1;
  }
  removeValue(e) {
    return !1;
  }
  getValue(e) {
  }
}
rf.INSTANCE = new rf();
class Uv extends GA {
  constructor(e, t, n) {
    super(e, null), this._configurationService = t, this._values = fm.forConfigKeys(), this._listener = this._configurationService.onDidChangeConfiguration((s) => {
      if (s.source === 7) {
        const o = Array.from(this._values, ([r]) => r);
        this._values.clear(), n.fire(new wF(o));
      } else {
        const o = [];
        for (const r of s.affectedKeys) {
          const a = `config.${r}`, l = this._values.findSuperstr(a);
          l !== void 0 && (o.push(...at.map(l, ([d]) => d)), this._values.deleteSuperstr(a)), this._values.has(a) && (o.push(a), this._values.delete(a));
        }
        n.fire(new wF(o));
      }
    });
  }
  dispose() {
    this._listener.dispose();
  }
  getValue(e) {
    if (e.indexOf(Uv._keyPrefix) !== 0) return super.getValue(e);
    if (this._values.has(e)) return this._values.get(e);
    const t = e.substr(Uv._keyPrefix.length), n = this._configurationService.getValue(t);
    let s;
    switch (typeof n) {
      case "number":
      case "boolean":
      case "string":
        s = n;
        break;
      default:
        s = Array.isArray(n) ? JSON.stringify(n) : n;
    }
    return this._values.set(e, s), s;
  }
  setValue(e, t) {
    return super.setValue(e, t);
  }
  removeValue(e) {
    return super.removeValue(e);
  }
}
Uv._keyPrefix = "config.";
class $ie {
  constructor(e, t, n) {
    this._service = e, this._key = t, this._defaultValue = n, this.reset();
  }
  set(e) {
    this._service.setContext(this._key, e);
  }
  reset() {
    this._defaultValue === void 0 ? this._service.removeContext(this._key) : this._service.setContext(this._key, this._defaultValue);
  }
  get() {
    return this._service.getContextKeyValue(this._key);
  }
}
class CF {
  constructor(e) {
    this.key = e;
  }
  affectsSome(e) {
    return e.has(this.key);
  }
  allKeysContainedIn(e) {
    return this.affectsSome(e);
  }
}
class wF {
  constructor(e) {
    this.keys = e;
  }
  affectsSome(e) {
    for (const t of this.keys) if (e.has(t)) return !0;
    return !1;
  }
  allKeysContainedIn(e) {
    return this.keys.every((t) => e.has(t));
  }
}
class Gie {
  constructor(e) {
    this.events = e;
  }
  affectsSome(e) {
    for (const t of this.events) if (t.affectsSome(e)) return !0;
    return !1;
  }
  allKeysContainedIn(e) {
    return this.events.every((t) => t.allKeysContainedIn(e));
  }
}
class OV extends V {
  constructor(e) {
    super(), this._onDidChangeContext = this._register(new og({ merge: (t) => new Gie(t) })), this.onDidChangeContext = this._onDidChangeContext.event, this._isDisposed = !1, this._myContextId = e;
  }
  createKey(e, t) {
    if (this._isDisposed) throw new Error("AbstractContextKeyService has been disposed");
    return new $ie(this, e, t);
  }
  bufferChangeEvents(e) {
    this._onDidChangeContext.pause();
    try {
      e();
    } finally {
      this._onDidChangeContext.resume();
    }
  }
  createScoped(e) {
    if (this._isDisposed) throw new Error("AbstractContextKeyService has been disposed");
    return new Zie(this, e);
  }
  contextMatchesRules(e) {
    if (this._isDisposed) throw new Error("AbstractContextKeyService has been disposed");
    const t = this.getContextValuesContainer(this._myContextId);
    return !e || e.evaluate(t);
  }
  getContextKeyValue(e) {
    if (!this._isDisposed) return this.getContextValuesContainer(this._myContextId).getValue(e);
  }
  setContext(e, t) {
    if (this._isDisposed) return;
    const n = this.getContextValuesContainer(this._myContextId);
    n && n.setValue(e, t) && this._onDidChangeContext.fire(new CF(e));
  }
  removeContext(e) {
    this._isDisposed || this.getContextValuesContainer(this._myContextId).removeValue(e) && this._onDidChangeContext.fire(new CF(e));
  }
  getContext(e) {
    return this._isDisposed ? rf.INSTANCE : this.getContextValuesContainer(function(t) {
      for (; t; ) {
        if (t.hasAttribute(C0)) {
          const n = t.getAttribute(C0);
          return n ? parseInt(n, 10) : NaN;
        }
        t = t.parentElement;
      }
      return 0;
    }(e));
  }
  dispose() {
    super.dispose(), this._isDisposed = !0;
  }
}
let I2 = class extends OV {
  constructor(i) {
    super(0), this._contexts = /* @__PURE__ */ new Map(), this._lastContextId = 0;
    const e = this._register(new Uv(this._myContextId, i, this._onDidChangeContext));
    this._contexts.set(this._myContextId, e);
  }
  getContextValuesContainer(i) {
    return this._isDisposed ? rf.INSTANCE : this._contexts.get(i) || rf.INSTANCE;
  }
  createChildContext(i = this._myContextId) {
    if (this._isDisposed) throw new Error("ContextKeyService has been disposed");
    const e = ++this._lastContextId;
    return this._contexts.set(e, new GA(e, this.getContextValuesContainer(i))), e;
  }
  disposeContext(i) {
    this._isDisposed || this._contexts.delete(i);
  }
};
I2 = jie([qie(0, Ye)], I2);
class Zie extends OV {
  constructor(e, t) {
    if (super(e.createChildContext()), this._parentChangeListener = this._register(new rn()), this._parent = e, this._updateParentChangeListener(), this._domNode = t, this._domNode.hasAttribute(C0)) {
      let n = "";
      this._domNode.classList && (n = Array.from(this._domNode.classList.values()).join(", ")), console.error("Element already has context attribute" + (n ? ": " + n : ""));
    }
    this._domNode.setAttribute(C0, String(this._myContextId));
  }
  _updateParentChangeListener() {
    this._parentChangeListener.value = this._parent.onDidChangeContext((e) => {
      const t = this._parent.getContextValuesContainer(this._myContextId).value;
      var n;
      n = t, e.allKeysContainedIn(new Set(Object.keys(n))) || this._onDidChangeContext.fire(e);
    });
  }
  dispose() {
    this._isDisposed || (this._parent.disposeContext(this._myContextId), this._domNode.removeAttribute(C0), super.dispose());
  }
  getContextValuesContainer(e) {
    return this._isDisposed ? rf.INSTANCE : this._parent.getContextValuesContainer(e);
  }
  createChildContext(e = this._myContextId) {
    if (this._isDisposed) throw new Error("ScopedContextKeyService has been disposed");
    return this._parent.createChildContext(e);
  }
  disposeContext(e) {
    this._isDisposed || this._parent.disposeContext(e);
  }
}
dt.registerCommand("_setContext", function(i, e, t) {
  i.get(Te).createKey(String(e), function(n) {
    return b7(n, (s) => typeof s == "object" && s.$mid === 1 ? Ie.revive(s).toString() : s instanceof Ie ? s.toString() : void 0);
  }(t));
}), dt.registerCommand({ id: "getContextKeyInfo", handler: () => [...ae.all()].sort((i, e) => i.key.localeCompare(e.key)), metadata: { description: m(0, "A command that returns information about context keys"), args: [] } }), dt.registerCommand("_generateContextKeyInfo", function() {
  const i = [], e = /* @__PURE__ */ new Set();
  for (const t of ae.all()) e.has(t.key) || (e.add(t.key), i.push(t));
  i.sort((t, n) => t.key.localeCompare(n.key)), console.log(JSON.stringify(i, void 0, 2));
});
let Yie = class {
  constructor(i, e) {
    this.key = i, this.data = e, this.incoming = /* @__PURE__ */ new Map(), this.outgoing = /* @__PURE__ */ new Map();
  }
};
class yF {
  constructor(e) {
    this._hashFn = e, this._nodes = /* @__PURE__ */ new Map();
  }
  roots() {
    const e = [];
    for (const t of this._nodes.values()) t.outgoing.size === 0 && e.push(t);
    return e;
  }
  insertEdge(e, t) {
    const n = this.lookupOrInsertNode(e), s = this.lookupOrInsertNode(t);
    n.outgoing.set(s.key, s), s.incoming.set(n.key, n);
  }
  removeNode(e) {
    const t = this._hashFn(e);
    this._nodes.delete(t);
    for (const n of this._nodes.values()) n.outgoing.delete(t), n.incoming.delete(t);
  }
  lookupOrInsertNode(e) {
    const t = this._hashFn(e);
    let n = this._nodes.get(t);
    return n || (n = new Yie(t, e), this._nodes.set(t, n)), n;
  }
  isEmpty() {
    return this._nodes.size === 0;
  }
  toString() {
    const e = [];
    for (const [t, n] of this._nodes) e.push(`${t}
	(-> incoming)[${[...n.incoming.keys()].join(", ")}]
	(outgoing ->)[${[...n.outgoing.keys()].join(",")}]
`);
    return e.join(`
`);
  }
  findCycleSlow() {
    for (const [e, t] of this._nodes) {
      const n = /* @__PURE__ */ new Set([e]), s = this._findCycle(t, n);
      if (s) return s;
    }
  }
  _findCycle(e, t) {
    for (const [n, s] of e.outgoing) {
      if (t.has(n)) return [...t, n].join(" -> ");
      t.add(n);
      const o = this._findCycle(s, t);
      if (o) return o;
      t.delete(n);
    }
  }
}
class SF extends Error {
  constructor(e) {
    var t;
    super("cyclic dependency between services"), this.message = (t = e.findCycleSlow()) !== null && t !== void 0 ? t : `UNABLE to detect cycle, dumping graph: 
${e.toString()}`;
  }
}
class tS {
  constructor(e = new I1(), t = !1, n, s = !1) {
    var o;
    this._services = e, this._strict = t, this._parent = n, this._enableTracing = s, this._activeInstantiations = /* @__PURE__ */ new Set(), this._services.set(Se, this), this._globalGraph = s ? (o = n == null ? void 0 : n._globalGraph) !== null && o !== void 0 ? o : new yF((r) => r) : void 0;
  }
  createChild(e) {
    return new tS(e, this._strict, this, this._enableTracing);
  }
  invokeFunction(e, ...t) {
    const n = Ns.traceInvocation(this._enableTracing, e);
    let s = !1;
    try {
      return e({ get: (o) => {
        if (s) throw YT("service accessor is only valid during the invocation of its target method");
        const r = this._getOrCreateServiceInstance(o, n);
        if (!r) throw new Error(`[invokeFunction] unknown service '${o}'`);
        return r;
      } }, ...t);
    } finally {
      s = !0, n.stop();
    }
  }
  createInstance(e, ...t) {
    let n, s;
    return e instanceof Va ? (n = Ns.traceCreation(this._enableTracing, e.ctor), s = this._createInstance(e.ctor, e.staticArguments.concat(t), n)) : (n = Ns.traceCreation(this._enableTracing, e), s = this._createInstance(e, t, n)), n.stop(), s;
  }
  _createInstance(e, t = [], n) {
    const s = zr.getServiceDependencies(e).sort((a, l) => a.index - l.index), o = [];
    for (const a of s) {
      const l = this._getOrCreateServiceInstance(a.id, n);
      l || this._throwIfStrict(`[createInstance] ${e.name} depends on UNKNOWN service ${a.id}.`, !1), o.push(l);
    }
    const r = s.length > 0 ? s[0].index : t.length;
    if (t.length !== r) {
      console.trace(`[createInstance] First service dependency of ${e.name} at position ${r + 1} conflicts with ${t.length} static arguments`);
      const a = r - t.length;
      t = a > 0 ? t.concat(new Array(a)) : t.slice(0, r);
    }
    return Reflect.construct(e, t.concat(o));
  }
  _setServiceInstance(e, t) {
    if (this._services.get(e) instanceof Va) this._services.set(e, t);
    else {
      if (!this._parent) throw new Error("illegalState - setting UNKNOWN service instance");
      this._parent._setServiceInstance(e, t);
    }
  }
  _getServiceInstanceOrDescriptor(e) {
    const t = this._services.get(e);
    return !t && this._parent ? this._parent._getServiceInstanceOrDescriptor(e) : t;
  }
  _getOrCreateServiceInstance(e, t) {
    this._globalGraph && this._globalGraphImplicitDependency && this._globalGraph.insertEdge(this._globalGraphImplicitDependency, String(e));
    const n = this._getServiceInstanceOrDescriptor(e);
    return n instanceof Va ? this._safeCreateAndCacheServiceInstance(e, n, t.branch(e, !0)) : (t.branch(e, !1), n);
  }
  _safeCreateAndCacheServiceInstance(e, t, n) {
    if (this._activeInstantiations.has(e)) throw new Error(`illegal state - RECURSIVELY instantiating service '${e}'`);
    this._activeInstantiations.add(e);
    try {
      return this._createAndCacheServiceInstance(e, t, n);
    } finally {
      this._activeInstantiations.delete(e);
    }
  }
  _createAndCacheServiceInstance(e, t, n) {
    var s;
    const o = new yF((l) => l.id.toString());
    let r = 0;
    const a = [{ id: e, desc: t, _trace: n }];
    for (; a.length; ) {
      const l = a.pop();
      if (o.lookupOrInsertNode(l), r++ > 1e3) throw new SF(o);
      for (const d of zr.getServiceDependencies(l.desc.ctor)) {
        const h = this._getServiceInstanceOrDescriptor(d.id);
        if (h || this._throwIfStrict(`[createInstance] ${e} depends on ${d.id} which is NOT registered.`, !0), (s = this._globalGraph) === null || s === void 0 || s.insertEdge(String(l.id), String(d.id)), h instanceof Va) {
          const c = { id: d.id, desc: h, _trace: l._trace.branch(d.id, !0) };
          o.insertEdge(l, c), a.push(c);
        }
      }
    }
    for (; ; ) {
      const l = o.roots();
      if (l.length === 0) {
        if (!o.isEmpty()) throw new SF(o);
        break;
      }
      for (const { data: d } of l) {
        if (this._getServiceInstanceOrDescriptor(d.id) instanceof Va) {
          const h = this._createServiceInstanceWithOwner(d.id, d.desc.ctor, d.desc.staticArguments, d.desc.supportsDelayedInstantiation, d._trace);
          this._setServiceInstance(d.id, h);
        }
        o.removeNode(d);
      }
    }
    return this._getServiceInstanceOrDescriptor(e);
  }
  _createServiceInstanceWithOwner(e, t, n = [], s, o) {
    if (this._services.get(e) instanceof Va) return this._createServiceInstance(e, t, n, s, o);
    if (this._parent) return this._parent._createServiceInstanceWithOwner(e, t, n, s, o);
    throw new Error(`illegalState - creating UNKNOWN service instance ${t.name}`);
  }
  _createServiceInstance(e, t, n = [], s, o) {
    if (s) {
      const r = new tS(void 0, this._strict, this, this._enableTracing);
      r._globalGraphImplicitDependency = String(e);
      const a = /* @__PURE__ */ new Map(), l = new WK(() => {
        const d = r._createInstance(t, n, o);
        for (const [h, c] of a) {
          const u = d[h];
          if (typeof u == "function") for (const g of c) g.disposable = u.apply(d, g.listener);
        }
        return a.clear(), d;
      });
      return new Proxy(/* @__PURE__ */ Object.create(null), { get(d, h) {
        if (!l.isInitialized && typeof h == "string" && (h.startsWith("onDid") || h.startsWith("onWill"))) {
          let g = a.get(h);
          return g || (g = new fs(), a.set(h, g)), (f, _, v) => {
            if (l.isInitialized) return l.value[h](f, _, v);
            {
              const b = { listener: [f, _, v], disposable: void 0 }, C = g.push(b);
              return ye(() => {
                var y;
                C(), (y = b.disposable) === null || y === void 0 || y.dispose();
              });
            }
          };
        }
        if (h in d) return d[h];
        const c = l.value;
        let u = c[h];
        return typeof u != "function" || (u = u.bind(c), d[h] = u), u;
      }, set: (d, h, c) => (l.value[h] = c, !0), getPrototypeOf: (d) => t.prototype });
    }
    return this._createInstance(t, n, o);
  }
  _throwIfStrict(e, t) {
    if (t && console.warn(e), this._strict) throw new Error(e);
  }
}
class Ns {
  static traceInvocation(e, t) {
    return e ? new Ns(2, t.name || new Error().stack.split(`
`).slice(3, 4).join(`
`)) : Ns._None;
  }
  static traceCreation(e, t) {
    return e ? new Ns(1, t.name) : Ns._None;
  }
  constructor(e, t) {
    this.type = e, this.name = t, this._start = Date.now(), this._dep = [];
  }
  branch(e, t) {
    const n = new Ns(3, e.toString());
    return this._dep.push([e, t, n]), n;
  }
  stop() {
    const e = Date.now() - this._start;
    Ns._totals += e;
    let t = !1;
    const n = [`${this.type === 1 ? "CREATE" : "CALL"} ${this.name}`, `${function s(o, r) {
      const a = [], l = new Array(o + 1).join("	");
      for (const [d, h, c] of r._dep) if (h && c) {
        t = !0, a.push(`${l}CREATES -> ${d}`);
        const u = s(o + 1, c);
        u && a.push(u);
      } else a.push(`${l}uses -> ${d}`);
      return a.join(`
`);
    }(1, this)}`, `DONE, took ${e.toFixed(2)}ms (grand total ${Ns._totals.toFixed(2)}ms)`];
    (e > 2 || t) && Ns.all.add(n.join(`
`));
  }
}
Ns.all = /* @__PURE__ */ new Set(), Ns._None = new class extends Ns {
  constructor() {
    super(0, null);
  }
  stop() {
  }
  branch() {
    return this;
  }
}(), Ns._totals = 0;
const Xie = /* @__PURE__ */ new Set([Ue.inMemory, Ue.vscodeSourceControl, Ue.walkThrough, Ue.walkThroughSnippet, Ue.vscodeChatCodeBlock]);
class Qie {
  constructor() {
    this._byResource = new Di(), this._byOwner = /* @__PURE__ */ new Map();
  }
  set(e, t, n) {
    let s = this._byResource.get(e);
    s || (s = /* @__PURE__ */ new Map(), this._byResource.set(e, s)), s.set(t, n);
    let o = this._byOwner.get(t);
    o || (o = new Di(), this._byOwner.set(t, o)), o.set(e, n);
  }
  get(e, t) {
    const n = this._byResource.get(e);
    return n == null ? void 0 : n.get(t);
  }
  delete(e, t) {
    let n = !1, s = !1;
    const o = this._byResource.get(e);
    o && (n = o.delete(t));
    const r = this._byOwner.get(t);
    if (r && (s = r.delete(e)), n !== s) throw new Error("illegal state");
    return n && s;
  }
  values(e) {
    var t, n, s, o;
    return typeof e == "string" ? (n = (t = this._byOwner.get(e)) === null || t === void 0 ? void 0 : t.values()) !== null && n !== void 0 ? n : at.empty() : Ie.isUri(e) ? (o = (s = this._byResource.get(e)) === null || s === void 0 ? void 0 : s.values()) !== null && o !== void 0 ? o : at.empty() : at.map(at.concat(...this._byOwner.values()), (r) => r[1]);
  }
}
class Jie {
  constructor(e) {
    this.errors = 0, this.infos = 0, this.warnings = 0, this.unknowns = 0, this._data = new Di(), this._service = e, this._subscription = e.onMarkerChanged(this._update, this);
  }
  dispose() {
    this._subscription.dispose();
  }
  _update(e) {
    for (const t of e) {
      const n = this._data.get(t);
      n && this._substract(n);
      const s = this._resourceStats(t);
      this._add(s), this._data.set(t, s);
    }
  }
  _resourceStats(e) {
    const t = { errors: 0, warnings: 0, infos: 0, unknowns: 0 };
    if (Xie.has(e.scheme)) return t;
    for (const { severity: n } of this._service.read({ resource: e })) n === pi.Error ? t.errors += 1 : n === pi.Warning ? t.warnings += 1 : n === pi.Info ? t.infos += 1 : t.unknowns += 1;
    return t;
  }
  _substract(e) {
    this.errors -= e.errors, this.warnings -= e.warnings, this.infos -= e.infos, this.unknowns -= e.unknowns;
  }
  _add(e) {
    this.errors += e.errors, this.warnings += e.warnings, this.infos += e.infos, this.unknowns += e.unknowns;
  }
}
class mh {
  constructor() {
    this._onMarkerChanged = new B7({ delay: 0, merge: mh._merge }), this.onMarkerChanged = this._onMarkerChanged.event, this._data = new Qie(), this._stats = new Jie(this);
  }
  dispose() {
    this._stats.dispose(), this._onMarkerChanged.dispose();
  }
  remove(e, t) {
    for (const n of t || []) this.changeOne(e, n, []);
  }
  changeOne(e, t, n) {
    if (m7(n))
      this._data.delete(t, e) && this._onMarkerChanged.fire([t]);
    else {
      const s = [];
      for (const o of n) {
        const r = mh._toMarker(e, t, o);
        r && s.push(r);
      }
      this._data.set(t, e, s), this._onMarkerChanged.fire([t]);
    }
  }
  static _toMarker(e, t, n) {
    let { code: s, severity: o, message: r, source: a, startLineNumber: l, startColumn: d, endLineNumber: h, endColumn: c, relatedInformation: u, tags: g } = n;
    if (r) return l = l > 0 ? l : 1, d = d > 0 ? d : 1, h = h >= l ? h : l, c = c > 0 ? c : d, { resource: t, owner: e, code: s, severity: o, message: r, source: a, startLineNumber: l, startColumn: d, endLineNumber: h, endColumn: c, relatedInformation: u, tags: g };
  }
  changeAll(e, t) {
    const n = [], s = this._data.values(e);
    if (s) for (const o of s) {
      const r = at.first(o);
      r && (n.push(r.resource), this._data.delete(r.resource, e));
    }
    if (zn(t)) {
      const o = new Di();
      for (const { resource: r, marker: a } of t) {
        const l = mh._toMarker(e, r, a);
        if (!l) continue;
        const d = o.get(r);
        d ? d.push(l) : (o.set(r, [l]), n.push(r));
      }
      for (const [r, a] of o) this._data.set(r, e, a);
    }
    n.length > 0 && this._onMarkerChanged.fire(n);
  }
  read(e = /* @__PURE__ */ Object.create(null)) {
    let { owner: t, resource: n, severities: s, take: o } = e;
    if ((!o || o < 0) && (o = -1), t && n) {
      const r = this._data.get(n, t);
      if (r) {
        const a = [];
        for (const l of r) if (mh._accept(l, s)) {
          const d = a.push(l);
          if (o > 0 && d === o) break;
        }
        return a;
      }
      return [];
    }
    if (t || n) {
      const r = this._data.values(n ?? t), a = [];
      for (const l of r) for (const d of l) if (mh._accept(d, s)) {
        const h = a.push(d);
        if (o > 0 && h === o) return a;
      }
      return a;
    }
    {
      const r = [];
      for (const a of this._data.values()) for (const l of a) if (mh._accept(l, s)) {
        const d = r.push(l);
        if (o > 0 && d === o) return r;
      }
      return r;
    }
  }
  static _accept(e, t) {
    return t === void 0 || (t & e.severity) === e.severity;
  }
  static _merge(e) {
    const t = new Di();
    for (const n of e) for (const s of n) t.set(s, !0);
    return Array.from(t.keys());
  }
}
class ene extends V {
  constructor() {
    super(...arguments), this._configurationModel = new En();
  }
  get configurationModel() {
    return this._configurationModel;
  }
  reload() {
    return this.resetConfigurationModel(), this.configurationModel;
  }
  getConfigurationDefaultOverrides() {
    return {};
  }
  resetConfigurationModel() {
    this._configurationModel = new En();
    const e = li.as(fa).getConfigurationProperties();
    this.updateConfigurationModel(Object.keys(e), e);
  }
  updateConfigurationModel(e, t) {
    const n = this.getConfigurationDefaultOverrides();
    for (const s of e) {
      const o = n[s], r = t[s];
      o !== void 0 ? this._configurationModel.addValue(s, o) : r ? this._configurationModel.addValue(s, r.default) : this._configurationModel.removeValue(s);
    }
  }
}
const Fc = tt("accessibilitySignalService");
class Pe {
  static register(e) {
    return new Pe(e.fileName);
  }
  constructor(e) {
    this.fileName = e;
  }
}
Pe.error = Pe.register({ fileName: "error.mp3" }), Pe.warning = Pe.register({ fileName: "warning.mp3" }), Pe.foldedArea = Pe.register({ fileName: "foldedAreas.mp3" }), Pe.break = Pe.register({ fileName: "break.mp3" }), Pe.quickFixes = Pe.register({ fileName: "quickFixes.mp3" }), Pe.taskCompleted = Pe.register({ fileName: "taskCompleted.mp3" }), Pe.taskFailed = Pe.register({ fileName: "taskFailed.mp3" }), Pe.terminalBell = Pe.register({ fileName: "terminalBell.mp3" }), Pe.diffLineInserted = Pe.register({ fileName: "diffLineInserted.mp3" }), Pe.diffLineDeleted = Pe.register({ fileName: "diffLineDeleted.mp3" }), Pe.diffLineModified = Pe.register({ fileName: "diffLineModified.mp3" }), Pe.chatRequestSent = Pe.register({ fileName: "chatRequestSent.mp3" }), Pe.chatResponsePending = Pe.register({ fileName: "chatResponsePending.mp3" }), Pe.chatResponseReceived1 = Pe.register({ fileName: "chatResponseReceived1.mp3" }), Pe.chatResponseReceived2 = Pe.register({ fileName: "chatResponseReceived2.mp3" }), Pe.chatResponseReceived3 = Pe.register({ fileName: "chatResponseReceived3.mp3" }), Pe.chatResponseReceived4 = Pe.register({ fileName: "chatResponseReceived4.mp3" }), Pe.clear = Pe.register({ fileName: "clear.mp3" }), Pe.save = Pe.register({ fileName: "save.mp3" }), Pe.format = Pe.register({ fileName: "format.mp3" }), Pe.voiceRecordingStarted = Pe.register({ fileName: "voiceRecordingStarted.mp3" }), Pe.voiceRecordingStopped = Pe.register({ fileName: "voiceRecordingStopped.mp3" });
class tne {
  constructor(e) {
    this.randomOneOf = e;
  }
}
class He {
  static register(e) {
    const t = new tne("randomOneOf" in e.sound ? e.sound.randomOneOf : [e.sound]), n = new He(t, e.name, e.legacySoundSettingsKey, e.settingsKey, e.legacyAnnouncementSettingsKey, e.announcementMessage);
    return He._signals.add(n), n;
  }
  constructor(e, t, n, s, o, r) {
    this.sound = e, this.name = t, this.legacySoundSettingsKey = n, this.settingsKey = s, this.legacyAnnouncementSettingsKey = o, this.announcementMessage = r;
  }
}
He._signals = /* @__PURE__ */ new Set(), He.error = He.register({ name: m(0, "Error on Line"), sound: Pe.error, legacySoundSettingsKey: "audioCues.lineHasError", legacyAnnouncementSettingsKey: "accessibility.alert.error", announcementMessage: m(0, "Error"), settingsKey: "accessibility.signals.lineHasError" }), He.warning = He.register({ name: m(0, "Warning on Line"), sound: Pe.warning, legacySoundSettingsKey: "audioCues.lineHasWarning", legacyAnnouncementSettingsKey: "accessibility.alert.warning", announcementMessage: m(0, "Warning"), settingsKey: "accessibility.signals.lineHasWarning" }), He.foldedArea = He.register({ name: m(0, "Folded Area on Line"), sound: Pe.foldedArea, legacySoundSettingsKey: "audioCues.lineHasFoldedArea", legacyAnnouncementSettingsKey: "accessibility.alert.foldedArea", announcementMessage: m(0, "Folded"), settingsKey: "accessibility.signals.lineHasFoldedArea" }), He.break = He.register({ name: m(0, "Breakpoint on Line"), sound: Pe.break, legacySoundSettingsKey: "audioCues.lineHasBreakpoint", legacyAnnouncementSettingsKey: "accessibility.alert.breakpoint", announcementMessage: m(0, "Breakpoint"), settingsKey: "accessibility.signals.lineHasBreakpoint" }), He.inlineSuggestion = He.register({ name: m(0, "Inline Suggestion on Line"), sound: Pe.quickFixes, legacySoundSettingsKey: "audioCues.lineHasInlineSuggestion", settingsKey: "accessibility.signals.lineHasInlineSuggestion" }), He.terminalQuickFix = He.register({ name: m(0, "Terminal Quick Fix"), sound: Pe.quickFixes, legacySoundSettingsKey: "audioCues.terminalQuickFix", legacyAnnouncementSettingsKey: "accessibility.alert.terminalQuickFix", announcementMessage: m(0, "Quick Fix"), settingsKey: "accessibility.signals.terminalQuickFix" }), He.onDebugBreak = He.register({ name: m(0, "Debugger Stopped on Breakpoint"), sound: Pe.break, legacySoundSettingsKey: "audioCues.onDebugBreak", legacyAnnouncementSettingsKey: "accessibility.alert.onDebugBreak", announcementMessage: m(0, "Breakpoint"), settingsKey: "accessibility.signals.onDebugBreak" }), He.noInlayHints = He.register({ name: m(0, "No Inlay Hints on Line"), sound: Pe.error, legacySoundSettingsKey: "audioCues.noInlayHints", legacyAnnouncementSettingsKey: "accessibility.alert.noInlayHints", announcementMessage: m(0, "No Inlay Hints"), settingsKey: "accessibility.signals.noInlayHints" }), He.taskCompleted = He.register({ name: m(0, "Task Completed"), sound: Pe.taskCompleted, legacySoundSettingsKey: "audioCues.taskCompleted", legacyAnnouncementSettingsKey: "accessibility.alert.taskCompleted", announcementMessage: m(0, "Task Completed"), settingsKey: "accessibility.signals.taskCompleted" }), He.taskFailed = He.register({ name: m(0, "Task Failed"), sound: Pe.taskFailed, legacySoundSettingsKey: "audioCues.taskFailed", legacyAnnouncementSettingsKey: "accessibility.alert.taskFailed", announcementMessage: m(0, "Task Failed"), settingsKey: "accessibility.signals.taskFailed" }), He.terminalCommandFailed = He.register({ name: m(0, "Terminal Command Failed"), sound: Pe.error, legacySoundSettingsKey: "audioCues.terminalCommandFailed", legacyAnnouncementSettingsKey: "accessibility.alert.terminalCommandFailed", announcementMessage: m(0, "Command Failed"), settingsKey: "accessibility.signals.terminalCommandFailed" }), He.terminalBell = He.register({ name: m(0, "Terminal Bell"), sound: Pe.terminalBell, legacySoundSettingsKey: "audioCues.terminalBell", legacyAnnouncementSettingsKey: "accessibility.alert.terminalBell", announcementMessage: m(0, "Terminal Bell"), settingsKey: "accessibility.signals.terminalBell" }), He.notebookCellCompleted = He.register({ name: m(0, "Notebook Cell Completed"), sound: Pe.taskCompleted, legacySoundSettingsKey: "audioCues.notebookCellCompleted", legacyAnnouncementSettingsKey: "accessibility.alert.notebookCellCompleted", announcementMessage: m(0, "Notebook Cell Completed"), settingsKey: "accessibility.signals.notebookCellCompleted" }), He.notebookCellFailed = He.register({ name: m(0, "Notebook Cell Failed"), sound: Pe.taskFailed, legacySoundSettingsKey: "audioCues.notebookCellFailed", legacyAnnouncementSettingsKey: "accessibility.alert.notebookCellFailed", announcementMessage: m(0, "Notebook Cell Failed"), settingsKey: "accessibility.signals.notebookCellFailed" }), He.diffLineInserted = He.register({ name: m(0, "Diff Line Inserted"), sound: Pe.diffLineInserted, legacySoundSettingsKey: "audioCues.diffLineInserted", settingsKey: "accessibility.signals.diffLineInserted" }), He.diffLineDeleted = He.register({ name: m(0, "Diff Line Deleted"), sound: Pe.diffLineDeleted, legacySoundSettingsKey: "audioCues.diffLineDeleted", settingsKey: "accessibility.signals.diffLineDeleted" }), He.diffLineModified = He.register({ name: m(0, "Diff Line Modified"), sound: Pe.diffLineModified, legacySoundSettingsKey: "audioCues.diffLineModified", settingsKey: "accessibility.signals.diffLineModified" }), He.chatRequestSent = He.register({ name: m(0, "Chat Request Sent"), sound: Pe.chatRequestSent, legacySoundSettingsKey: "audioCues.chatRequestSent", legacyAnnouncementSettingsKey: "accessibility.alert.chatRequestSent", announcementMessage: m(0, "Chat Request Sent"), settingsKey: "accessibility.signals.chatRequestSent" }), He.chatResponseReceived = He.register({ name: m(0, "Chat Response Received"), legacySoundSettingsKey: "audioCues.chatResponseReceived", sound: { randomOneOf: [Pe.chatResponseReceived1, Pe.chatResponseReceived2, Pe.chatResponseReceived3, Pe.chatResponseReceived4] }, settingsKey: "accessibility.signals.chatResponseReceived" }), He.chatResponsePending = He.register({ name: m(0, "Chat Response Pending"), sound: Pe.chatResponsePending, legacySoundSettingsKey: "audioCues.chatResponsePending", legacyAnnouncementSettingsKey: "accessibility.alert.chatResponsePending", announcementMessage: m(0, "Chat Response Pending"), settingsKey: "accessibility.signals.chatResponsePending" }), He.clear = He.register({ name: m(0, "Clear"), sound: Pe.clear, legacySoundSettingsKey: "audioCues.clear", legacyAnnouncementSettingsKey: "accessibility.alert.clear", announcementMessage: m(0, "Clear"), settingsKey: "accessibility.signals.clear" }), He.save = He.register({ name: m(0, "Save"), sound: Pe.save, legacySoundSettingsKey: "audioCues.save", legacyAnnouncementSettingsKey: "accessibility.alert.save", announcementMessage: m(0, "Save"), settingsKey: "accessibility.signals.save" }), He.format = He.register({ name: m(0, "Format"), sound: Pe.format, legacySoundSettingsKey: "audioCues.format", legacyAnnouncementSettingsKey: "accessibility.alert.format", announcementMessage: m(0, "Format"), settingsKey: "accessibility.signals.format" }), He.voiceRecordingStarted = He.register({ name: m(0, "Voice Recording Started"), sound: Pe.voiceRecordingStarted, legacySoundSettingsKey: "audioCues.voiceRecordingStarted", settingsKey: "accessibility.signals.voiceRecordingStarted" }), He.voiceRecordingStopped = He.register({ name: m(0, "Voice Recording Stopped"), sound: Pe.voiceRecordingStopped, legacySoundSettingsKey: "audioCues.voiceRecordingStopped", settingsKey: "accessibility.signals.voiceRecordingStopped" });
class ine extends V {
  constructor(e, t = []) {
    super(), this.logger = new Wj([e, ...t]), this._register(e.onDidChangeLogLevel((n) => this.setLevel(n)));
  }
  get onDidChangeLogLevel() {
    return this.logger.onDidChangeLogLevel;
  }
  setLevel(e) {
    this.logger.setLevel(e);
  }
  getLevel() {
    return this.logger.getLevel();
  }
  trace(e, ...t) {
    this.logger.trace(e, ...t);
  }
  debug(e, ...t) {
    this.logger.debug(e, ...t);
  }
  info(e, ...t) {
    this.logger.info(e, ...t);
  }
  warn(e, ...t) {
    this.logger.warn(e, ...t);
  }
  error(e, ...t) {
    this.logger.error(e, ...t);
  }
}
const FV = [];
function H1(i) {
  FV.push(i);
}
function nne() {
  return FV.slice(0);
}
var Bc = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Cn = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class sne {
  constructor(e) {
    this.disposed = !1, this.model = e, this._onWillDispose = new F();
  }
  get textEditorModel() {
    return this.model;
  }
  dispose() {
    this.disposed = !0, this._onWillDispose.fire();
  }
}
let M2 = class {
  constructor(i) {
    this.modelService = i;
  }
  createModelReference(i) {
    const e = this.modelService.getModel(i);
    return e ? Promise.resolve(new rK(new sne(e))) : Promise.reject(new Error("Model not found"));
  }
};
M2 = Bc([Cn(0, ni)], M2);
class zL {
  show() {
    return zL.NULL_PROGRESS_RUNNER;
  }
  async showWhile(e, t) {
    await e;
  }
}
zL.NULL_PROGRESS_RUNNER = { done: () => {
}, total: () => {
}, worked: () => {
} };
class Kv {
  info(e) {
    return this.notify({ severity: ki.Info, message: e });
  }
  warn(e) {
    return this.notify({ severity: ki.Warning, message: e });
  }
  error(e) {
    return this.notify({ severity: ki.Error, message: e });
  }
  notify(e) {
    switch (e.severity) {
      case ki.Error:
        console.error(e.message);
        break;
      case ki.Warning:
        console.warn(e.message);
        break;
      default:
        console.log(e.message);
    }
    return Kv.NO_OP;
  }
  prompt(e, t, n, s) {
    return Kv.NO_OP;
  }
  status(e, t) {
    return V.None;
  }
}
Kv.NO_OP = new class {
}();
let T2 = class {
  constructor(i) {
    this._onWillExecuteCommand = new F(), this._onDidExecuteCommand = new F(), this.onDidExecuteCommand = this._onDidExecuteCommand.event, this._instantiationService = i;
  }
  executeCommand(i, ...e) {
    const t = dt.getCommand(i);
    if (!t) return Promise.reject(new Error(`command '${i}' not found`));
    try {
      this._onWillExecuteCommand.fire({ commandId: i, args: e });
      const n = this._instantiationService.invokeFunction.apply(this._instantiationService, [t.handler, ...e]);
      return this._onDidExecuteCommand.fire({ commandId: i, args: e }), Promise.resolve(n);
    } catch (n) {
      return Promise.reject(n);
    }
  }
};
T2 = Bc([Cn(0, Se)], T2);
let af = class extends mee {
  constructor(i, e, t, n, s, o) {
    super(i, e, t, n, s), this._cachedResolver = null, this._dynamicKeybindings = [], this._domNodeListeners = [];
    const r = (h) => {
      const c = new G();
      c.add(K(h, ie.KEY_DOWN, (u) => {
        const g = new jt(u);
        this._dispatch(g, g.target) && (g.preventDefault(), g.stopPropagation());
      })), c.add(K(h, ie.KEY_UP, (u) => {
        const g = new jt(u);
        this._singleModifierDispatch(g, g.target) && g.preventDefault();
      })), this._domNodeListeners.push(new one(h, c));
    }, a = (h) => {
      for (let c = 0; c < this._domNodeListeners.length; c++) {
        const u = this._domNodeListeners[c];
        u.domNode === h && (this._domNodeListeners.splice(c, 1), u.dispose());
      }
    }, l = (h) => {
      h.getOption(61) || r(h.getContainerDomNode());
    };
    this._register(o.onCodeEditorAdd(l)), this._register(o.onCodeEditorRemove((h) => {
      h.getOption(61) || a(h.getContainerDomNode());
    })), o.listCodeEditors().forEach(l);
    const d = (h) => {
      r(h.getContainerDomNode());
    };
    this._register(o.onDiffEditorAdd(d)), this._register(o.onDiffEditorRemove((h) => {
      a(h.getContainerDomNode());
    })), o.listDiffEditors().forEach(d);
  }
  addDynamicKeybinding(i, e, t, n) {
    return yr(dt.registerCommand(i, t), this.addDynamicKeybindings([{ keybinding: e, command: i, when: n }]));
  }
  addDynamicKeybindings(i) {
    const e = i.map((t) => {
      var n;
      return { keybinding: DE(t.keybinding, Gs), command: (n = t.command) !== null && n !== void 0 ? n : null, commandArgs: t.commandArgs, when: t.when, weight1: 1e3, weight2: 0, extensionId: null, isBuiltinExtension: !1 };
    });
    return this._dynamicKeybindings = this._dynamicKeybindings.concat(e), this.updateResolver(), ye(() => {
      for (let t = 0; t < this._dynamicKeybindings.length; t++) if (this._dynamicKeybindings[t] === e[0]) return this._dynamicKeybindings.splice(t, e.length), void this.updateResolver();
    });
  }
  updateResolver() {
    this._cachedResolver = null, this._onDidUpdateKeybindings.fire();
  }
  _getResolver() {
    if (!this._cachedResolver) {
      const i = this._toNormalizedKeybindingItems(Es.getDefaultKeybindings(), !0), e = this._toNormalizedKeybindingItems(this._dynamicKeybindings, !1);
      this._cachedResolver = new _0(i, e, (t) => this._log(t));
    }
    return this._cachedResolver;
  }
  _documentHasFocus() {
    return Et.document.hasFocus();
  }
  _toNormalizedKeybindingItems(i, e) {
    const t = [];
    let n = 0;
    for (const s of i) {
      const o = s.when || void 0, r = s.keybinding;
      if (r) {
        const a = Nv.resolveKeybinding(r, Gs);
        for (const l of a) t[n++] = new N3(l, s.command, s.commandArgs, o, e, null, !1);
      } else t[n++] = new N3(void 0, s.command, s.commandArgs, o, e, null, !1);
    }
    return t;
  }
  resolveKeyboardEvent(i) {
    const e = new Od(i.ctrlKey, i.shiftKey, i.altKey, i.metaKey, i.keyCode);
    return new Nv([e], Gs);
  }
};
af = Bc([Cn(0, Te), Cn(1, ai), Cn(2, es), Cn(3, Ri), Cn(4, ts), Cn(5, mt)], af);
class one extends V {
  constructor(e, t) {
    super(), this.domNode = e, this._register(t);
  }
}
function LF(i) {
  return i && typeof i == "object" && (!i.overrideIdentifier || typeof i.overrideIdentifier == "string") && (!i.resource || i.resource instanceof Ie);
}
class BV {
  constructor() {
    this._onDidChangeConfiguration = new F(), this.onDidChangeConfiguration = this._onDidChangeConfiguration.event;
    const e = new ene();
    this._configuration = new wL(e.reload(), new En(), new En(), new En()), e.dispose();
  }
  getValue(e, t) {
    const n = typeof e == "string" ? e : void 0, s = LF(e) ? e : LF(t) ? t : {};
    return this._configuration.getValue(n, s, void 0);
  }
  updateValues(e) {
    const t = { data: this._configuration.toData() }, n = [];
    for (const s of e) {
      const [o, r] = s;
      this.getValue(o) !== r && (this._configuration.updateValue(o, r), n.push(o));
    }
    if (n.length > 0) {
      const s = new uee({ keys: n, overrides: [] }, t, this._configuration);
      s.source = 8, this._onDidChangeConfiguration.fire(s);
    }
    return Promise.resolve();
  }
  updateValue(e, t, n, s) {
    return this.updateValues([[e, t]]);
  }
  inspect(e, t = {}) {
    return this._configuration.inspect(e, t, void 0);
  }
}
let R2 = class {
  constructor(i, e, t) {
    this.configurationService = i, this.modelService = e, this.languageService = t, this._onDidChangeConfiguration = new F(), this.configurationService.onDidChangeConfiguration((n) => {
      this._onDidChangeConfiguration.fire({ affectedKeys: n.affectedKeys, affectsConfiguration: (s, o) => n.affectsConfiguration(o) });
    });
  }
  getValue(i, e, t) {
    const n = W.isIPosition(e) ? e : null, s = n ? typeof t == "string" ? t : void 0 : typeof e == "string" ? e : void 0, o = i ? this.getLanguage(i, n) : void 0;
    return s === void 0 ? this.configurationService.getValue({ resource: i, overrideIdentifier: o }) : this.configurationService.getValue(s, { resource: i, overrideIdentifier: o });
  }
  getLanguage(i, e) {
    const t = this.modelService.getModel(i);
    return t ? e ? t.getLanguageIdAtPosition(e.lineNumber, e.column) : t.getLanguageId() : this.languageService.guessLanguageIdByFilepathOrFirstLine(i);
  }
};
R2 = Bc([Cn(0, Ye), Cn(1, ni), Cn(2, Xt)], R2);
let A2 = class {
  constructor(i) {
    this.configurationService = i;
  }
  getEOL(i, e) {
    const t = this.configurationService.getValue("files.eol", { overrideIdentifier: e, resource: i });
    return t && typeof t == "string" && t !== "auto" ? t : Cs || Je ? `
` : `\r
`;
  }
};
A2 = Bc([Cn(0, Ye)], A2);
class jv {
  constructor() {
    const e = Ie.from({ scheme: jv.SCHEME, authority: "model", path: "/" });
    this.workspace = { id: WW, folders: [new xee({ uri: e, name: "", index: 0 })] };
  }
  getWorkspace() {
    return this.workspace;
  }
  getWorkspaceFolder(e) {
    return e && e.scheme === jv.SCHEME ? this.workspace.folders[0] : null;
  }
}
function iS(i, e, t) {
  if (!e || !(i instanceof BV)) return;
  const n = [];
  Object.keys(e).forEach((s) => {
    (function(o) {
      return k3()[`editor.${o}`] || !1;
    })(s) && n.push([`editor.${s}`, e[s]]), t && function(o) {
      return k3()[`diffEditor.${o}`] || !1;
    }(s) && n.push([`diffEditor.${s}`, e[s]]);
  }), n.length > 0 && i.updateValues(n);
}
jv.SCHEME = "inmemory";
let P2 = class {
  constructor(i) {
    this._modelService = i;
  }
  hasPreviewHandler() {
    return !1;
  }
  async apply(i, e) {
    const t = Array.isArray(i) ? i : DA.convert(i), n = /* @__PURE__ */ new Map();
    for (const r of t) {
      if (!(r instanceof nc)) throw new Error("bad edit - only text edits are supported");
      const a = this._modelService.getModel(r.resource);
      if (!a) throw new Error("bad edit - model not found");
      if (typeof r.versionId == "number" && a.getVersionId() !== r.versionId) throw new Error("bad state - model changed in the meantime");
      let l = n.get(a);
      l || (l = [], n.set(a, l)), l.push(ii.replaceMove(D.lift(r.textEdit.range), r.textEdit.text));
    }
    let s = 0, o = 0;
    for (const [r, a] of n) r.pushStackElement(), r.pushEditOperations([], a, () => []), r.pushStackElement(), o += 1, s += a.length;
    return { ariaSummary: rg(jI.bulkEditServiceSummary, s, o), isApplied: s > 0 };
  }
};
P2 = Bc([Cn(0, ni)], P2);
let O2 = class extends aee {
  constructor(i, e) {
    super(i), this._codeEditorService = e;
  }
  showContextView(i, e, t) {
    if (!e) {
      const n = this._codeEditorService.getFocusedCodeEditor() || this._codeEditorService.getActiveCodeEditor();
      n && (e = n.getContainerDomNode());
    }
    return super.showContextView(i, e, t);
  }
};
O2 = Bc([Cn(0, Pc), Cn(1, mt)], O2);
let F2 = class extends JI {
  constructor(i, e, t, n, s, o) {
    super(i, e, t, n, s, o), this.configure({ blockMouse: !1 });
  }
};
F2 = Bc([Cn(0, es), Cn(1, Ri), Cn(2, zd), Cn(3, Dt), Cn(4, Mo), Cn(5, Te)], F2);
var Me;
rt(Ye, BV, 0), rt(NR, R2, 0), rt(tB, A2, 0), rt(mg, jv, 0), rt(Zm, class {
  getUriLabel(i, e) {
    return i.scheme === "file" ? i.fsPath : i.path;
  }
  getUriBasenameLabel(i) {
    return ir(i);
  }
}, 0), rt(es, class {
  publicLog2() {
  }
}, 0), rt(M1, class {
  async confirm(i) {
    return { confirmed: this.doConfirm(i.message, i.detail), checkboxChecked: !1 };
  }
  doConfirm(i, e) {
    let t = i;
    return e && (t = t + `

` + e), Et.confirm(t);
  }
  async prompt(i) {
    var e, t;
    let n;
    if (this.doConfirm(i.message, i.detail)) {
      const s = [...(e = i.buttons) !== null && e !== void 0 ? e : []];
      i.cancelButton && typeof i.cancelButton != "string" && typeof i.cancelButton != "boolean" && s.push(i.cancelButton), n = await ((t = s[0]) === null || t === void 0 ? void 0 : t.run({ checkboxChecked: !1 }));
    }
    return { result: n };
  }
  async error(i, e) {
    await this.prompt({ type: ki.Error, message: i, detail: e });
  }
}, 0), rt(uA, class {
  constructor() {
    this.isExtensionDevelopment = !1, this.isBuilt = !1;
  }
}, 0), rt(Ri, Kv, 0), rt(kl, mh, 0), rt(Xt, class extends Mv {
  constructor() {
    super();
  }
}, 0), rt(Ro, class extends V {
  constructor() {
    super(), this._onColorThemeChange = this._register(new F()), this.onDidColorThemeChange = this._onColorThemeChange.event, this._onProductIconThemeChange = this._register(new F()), this.onDidProductIconThemeChange = this._onProductIconThemeChange.event, this._environment = /* @__PURE__ */ Object.create(null), this._builtInProductIconTheme = new vF(), this._autoDetectHighContrast = !0, this._knownThemes = /* @__PURE__ */ new Map(), this._knownThemes.set(td, jb(td)), this._knownThemes.set(wm, jb(wm)), this._knownThemes.set(Zu, jb(Zu)), this._knownThemes.set(Yu, jb(Yu));
    const i = this._register(function(e) {
      const t = new G(), n = t.add(new F()), s = IV();
      return t.add(s.onDidChange(() => n.fire())), e && t.add(e.onDidProductIconThemeChange(() => n.fire())), { dispose: () => t.dispose(), onDidChange: n.event, getCSS() {
        const o = e ? e.getProductIconTheme() : new vF(), r = {}, a = (d) => {
          const h = o.getIcon(d);
          if (!h) return;
          const c = h.font;
          return c ? (r[c.id] = c.definition, `.codicon-${d.id}:before { content: '${h.fontCharacter}'; font-family: ${DO(c.id)}; }`) : `.codicon-${d.id}:before { content: '${h.fontCharacter}'; }`;
        }, l = [];
        for (const d of s.getIcons()) {
          const h = a(d);
          h && l.push(h);
        }
        for (const d in r) {
          const h = r[d], c = h.weight ? `font-weight: ${h.weight};` : "", u = h.style ? `font-style: ${h.style};` : "", g = h.src.map((p) => `${yc(p.location)} format('${p.format}')`).join(", ");
          l.push(`@font-face { src: ${g}; font-family: ${DO(d)};${c}${u} font-display: block; }`);
        }
        return l.join(`
`);
      } };
    }(this));
    this._codiconCSS = i.getCSS(), this._themeCSS = "", this._allCSS = `${this._codiconCSS}
${this._themeCSS}`, this._globalStyleElement = null, this._styleElements = [], this._colorMapOverride = null, this.setTheme(td), this._onOSSchemeChanged(), this._register(i.onDidChange(() => {
      this._codiconCSS = i.getCSS(), this._updateCSS();
    })), s8(Et, "(forced-colors: active)", () => {
      this._onOSSchemeChanged();
    });
  }
  registerEditorContainer(i) {
    return $w(i) ? this._registerShadowDomContainer(i) : this._registerRegularEditorContainer();
  }
  _registerRegularEditorContainer() {
    return this._globalStyleElement || (this._globalStyleElement = Lo(void 0, (i) => {
      i.className = "monaco-colors", i.textContent = this._allCSS;
    }), this._styleElements.push(this._globalStyleElement)), V.None;
  }
  _registerShadowDomContainer(i) {
    const e = Lo(i, (t) => {
      t.className = "monaco-colors", t.textContent = this._allCSS;
    });
    return this._styleElements.push(e), { dispose: () => {
      for (let t = 0; t < this._styleElements.length; t++) if (this._styleElements[t] === e) return void this._styleElements.splice(t, 1);
    } };
  }
  defineTheme(i, e) {
    if (!/^[a-z0-9\-]+$/i.test(i)) throw new Error("Illegal theme name!");
    if (!nw(e.base) && !nw(i)) throw new Error("Illegal theme base!");
    this._knownThemes.set(i, new PV(i, e)), nw(i) && this._knownThemes.forEach((t) => {
      t.base === i && t.notifyBaseUpdated();
    }), this._theme.themeName === i && this.setTheme(i);
  }
  getColorTheme() {
    return this._theme;
  }
  setColorMapOverride(i) {
    this._colorMapOverride = i, this._updateThemeOrColorMap();
  }
  setTheme(i) {
    let e;
    e = this._knownThemes.has(i) ? this._knownThemes.get(i) : this._knownThemes.get(td), this._updateActualTheme(e);
  }
  _updateActualTheme(i) {
    i && this._theme !== i && (this._theme = i, this._updateThemeOrColorMap());
  }
  _onOSSchemeChanged() {
    if (this._autoDetectHighContrast) {
      const i = Et.matchMedia("(forced-colors: active)").matches;
      if (i !== la(this._theme.type)) {
        let e;
        e = Km(this._theme.type) ? i ? Zu : wm : i ? Yu : td, this._updateActualTheme(this._knownThemes.get(e));
      }
    }
  }
  setAutoDetectHighContrast(i) {
    this._autoDetectHighContrast = i, this._onOSSchemeChanged();
  }
  _updateThemeOrColorMap() {
    const i = [], e = {}, t = { addRule: (o) => {
      e[o] || (i.push(o), e[o] = !0);
    } };
    Hie.getThemingParticipants().forEach((o) => o(this._theme, t, this._environment));
    const n = [];
    for (const o of AV.getColors()) {
      const r = this._theme.getColor(o.id, !0);
      r && n.push(`${PR(o.id)}: ${r.toString()};`);
    }
    t.addRule(`.monaco-editor, .monaco-diff-editor, .monaco-component { ${n.join(`
`)} }`);
    const s = this._colorMapOverride || this._theme.tokenTheme.getColorMap();
    t.addRule(function(o) {
      const r = [];
      for (let a = 1, l = o.length; a < l; a++) {
        const d = o[a];
        r[a] = `.mtk${a} { color: ${d}; }`;
      }
      return r.push(".mtki { font-style: italic; }"), r.push(".mtkb { font-weight: bold; }"), r.push(".mtku { text-decoration: underline; text-underline-position: under; }"), r.push(".mtks { text-decoration: line-through; }"), r.push(".mtks.mtku { text-decoration: underline line-through; text-underline-position: under; }"), r.join(`
`);
    }(s)), this._themeCSS = i.join(`
`), this._updateCSS(), ci.setColorMap(s), this._onColorThemeChange.fire(this._theme);
  }
  _updateCSS() {
    this._allCSS = `${this._codiconCSS}
${this._themeCSS}`, this._styleElements.forEach((i) => i.textContent = this._allCSS);
  }
  getFileIconTheme() {
    return { hasFileIcons: !1, hasFolderIcons: !1, hidesExplorerArrows: !1 };
  }
  getProductIconTheme() {
    return this._builtInProductIconTheme;
  }
}, 0), rt(ts, class extends ine {
  constructor() {
    super(new Bj());
  }
}, 0), rt(ni, YC, 0), rt(AR, s2, 0), rt(Te, I2, 0), rt(BW, class {
  withProgress(i, e, t) {
    return e({ report: () => {
    } });
  }
}, 0), rt(Ec, zL, 0), rt(Nr, class extends EL {
  constructor() {
    super(), this.applicationStorage = this._register(new bm(new QD(), { hint: vm.STORAGE_IN_MEMORY })), this.profileStorage = this._register(new bm(new QD(), { hint: vm.STORAGE_IN_MEMORY })), this.workspaceStorage = this._register(new bm(new QD(), { hint: vm.STORAGE_IN_MEMORY })), this._register(this.workspaceStorage.onDidChangeStorage((i) => this.emitDidChangeValue(1, i))), this._register(this.profileStorage.onDidChangeStorage((i) => this.emitDidChangeValue(0, i))), this._register(this.applicationStorage.onDidChangeStorage((i) => this.emitDidChangeValue(-1, i)));
  }
  getStorage(i) {
    switch (i) {
      case -1:
        return this.applicationStorage;
      case 0:
        return this.profileStorage;
      default:
        return this.workspaceStorage;
    }
  }
}, 0), rt(Qo, jE, 0), rt(R1, P2, 0), rt(VW, class {
  constructor() {
    this._neverEmitter = new F(), this.onDidChangeTrust = this._neverEmitter.event;
  }
  isWorkspaceTrusted() {
    return !0;
  }
}, 0), rt(Ps, M2, 0), rt(or, k2, 0), rt(Jo, class {
  get lastFocusedList() {
    return this._lastFocusedWidget;
  }
  constructor() {
    this.disposables = new G(), this.lists = [], this._lastFocusedWidget = void 0, this._hasCreatedStyleController = !1;
  }
  setLastFocusedList(i) {
    var e, t;
    i !== this._lastFocusedWidget && ((e = this._lastFocusedWidget) === null || e === void 0 || e.getHTMLElement().classList.remove("last-focused"), this._lastFocusedWidget = i, (t = this._lastFocusedWidget) === null || t === void 0 || t.getHTMLElement().classList.add("last-focused"));
  }
  register(i, e) {
    if (this._hasCreatedStyleController || (this._hasCreatedStyleController = !0, new YW(Lo(), "").style(Tg)), this.lists.some((n) => n.widget === i)) throw new Error("Cannot register the same widget multiple times");
    const t = { widget: i, extraContextKeys: e };
    return this.lists.push(t), US(i.getHTMLElement()) && this.setLastFocusedList(i), yr(i.onDidFocus(() => this.setLastFocusedList(i)), ye(() => this.lists.splice(this.lists.indexOf(t), 1)), i.onDidDispose(() => {
      this.lists = this.lists.filter((n) => n !== t), this._lastFocusedWidget === i && this.setLastFocusedList(void 0);
    }));
  }
  dispose() {
    this.disposables.dispose();
  }
}, 0), rt(ai, T2, 0), rt(Dt, af, 0), rt(La, S2, 0), rt(zd, O2, 0), rt(Fs, n2, 0), rt(Kd, ow, 0), rt(io, F2, 0), rt(Mo, D2, 0), rt(Fc, class {
  async playSignal(i, e) {
  }
}, 0), function(i) {
  const e = new I1();
  for (const [r, a] of KO()) e.set(r, a);
  const t = new tS(e, !0);
  e.set(Se, t), i.get = function(r) {
    n || o({});
    const a = e.get(r);
    if (!a) throw new Error("Missing service " + r);
    return a instanceof Va ? t.invokeFunction((l) => l.get(r)) : a;
  };
  let n = !1;
  const s = new F();
  function o(r) {
    if (n) return t;
    n = !0;
    for (const [l, d] of KO()) e.get(l) || e.set(l, d);
    for (const l in r) if (r.hasOwnProperty(l)) {
      const d = tt(l);
      e.get(d) instanceof Va && e.set(d, r[l]);
    }
    const a = nne();
    for (const l of a) try {
      t.createInstance(l);
    } catch (d) {
      We(d);
    }
    return s.fire(), t;
  }
  i.initialize = o, i.withServices = function(r) {
    if (n) return r();
    const a = new G(), l = a.add(s.event(() => {
      l.dispose(), a.add(r());
    }));
    return a;
  };
}(Me || (Me = {}));
class ya {
  static capture(e) {
    if (e.getScrollTop() === 0 || e.hasPendingScrollAnimation()) return new ya(e.getScrollTop(), e.getContentHeight(), null, 0, null);
    let t = null, n = 0;
    const s = e.getVisibleRanges();
    if (s.length > 0) {
      t = s[0].getStartPosition();
      const o = e.getTopForPosition(t.lineNumber, t.column);
      n = e.getScrollTop() - o;
    }
    return new ya(e.getScrollTop(), e.getContentHeight(), t, n, e.getPosition());
  }
  constructor(e, t, n, s, o) {
    this._initialScrollTop = e, this._initialContentHeight = t, this._visiblePosition = n, this._visiblePositionScrollDelta = s, this._cursorPosition = o;
  }
  restore(e) {
    if ((this._initialContentHeight !== e.getContentHeight() || this._initialScrollTop !== e.getScrollTop()) && this._visiblePosition) {
      const t = e.getTopForPosition(this._visiblePosition.lineNumber, this._visiblePosition.column);
      e.setScrollTop(t + this._visiblePositionScrollDelta);
    }
  }
  restoreRelativeVerticalPositionOfCursor(e) {
    if (this._initialContentHeight === e.getContentHeight() && this._initialScrollTop === e.getScrollTop()) return;
    const t = e.getPosition();
    if (!this._cursorPosition || !t) return;
    const n = e.getTopForLineNumber(t.lineNumber) - e.getTopForLineNumber(this._cursorPosition.lineNumber);
    e.setScrollTop(e.getScrollTop() + n);
  }
}
function ZA() {
  return xN && !!xN.VSCODE_DEV;
}
function WV(i) {
  if (ZA()) {
    const e = function() {
      qb || (qb = /* @__PURE__ */ new Set());
      const t = globalThis;
      return t.$hotReload_applyNewExports || (t.$hotReload_applyNewExports = (n) => {
        const s = { config: { mode: void 0 }, ...n };
        for (const o of qb) {
          const r = o(s);
          if (r) return r;
        }
      }), qb;
    }();
    return e.add(i), { dispose() {
      e.delete(i);
    } };
  }
  return { dispose() {
  } };
}
let qb;
function nS(i, e) {
  const t = new G(), n = i.createDecorationsCollection();
  return t.add(DL({ debugName: () => `Apply decorations from ${e.debugName}` }, (s) => {
    const o = e.read(s);
    n.set(o);
  })), t.add({ dispose: () => {
    n.clear();
  } }), t;
}
function A_(i, e) {
  return i.appendChild(e), ye(() => {
    i.removeChild(e);
  });
}
ZA() && WV(({ oldExports: i, newSrc: e, config: t }) => {
  if (t.mode === "patch-prototype") return (n) => {
    var s, o;
    for (const r in n) {
      const a = n[r];
      if (console.log(`[hot-reload] Patching prototype methods of '${r}'`, { exportedItem: a }), typeof a == "function" && a.prototype) {
        const l = i[r];
        if (l) {
          for (const d of Object.getOwnPropertyNames(a.prototype)) {
            const h = Object.getOwnPropertyDescriptor(a.prototype, d), c = Object.getOwnPropertyDescriptor(l.prototype, d);
            ((s = h == null ? void 0 : h.value) === null || s === void 0 ? void 0 : s.toString()) !== ((o = c == null ? void 0 : c.value) === null || o === void 0 ? void 0 : o.toString()) && console.log(`[hot-reload] Patching prototype method '${r}.${d}'`), Object.defineProperty(l.prototype, d, h);
          }
          n[r] = l;
        }
      }
    }
    return !0;
  };
});
class VV extends V {
  get width() {
    return this._width;
  }
  get height() {
    return this._height;
  }
  constructor(e, t) {
    super(), this.elementSizeObserver = this._register(new rB(e, t)), this._width = lt(this, this.elementSizeObserver.getWidth()), this._height = lt(this, this.elementSizeObserver.getHeight()), this._register(this.elementSizeObserver.onDidChange((n) => Tt((s) => {
      this._width.set(this.elementSizeObserver.getWidth(), s), this._height.set(this.elementSizeObserver.getHeight(), s);
    })));
  }
  observe(e) {
    this.elementSizeObserver.observe(e);
  }
  setAutomaticLayout(e) {
    e ? this.elementSizeObserver.startObserving() : this.elementSizeObserver.stopObserving();
  }
}
function kF(i, e, t) {
  let n = e.get(), s = n, o = n;
  const r = lt("animatedValue", n);
  let a = -1, l;
  function d() {
    const h = Date.now() - a;
    var c, u, g, p;
    o = Math.floor((u = s, g = n - s, (c = h) === (p = 300) ? u + g : g * (1 - Math.pow(2, -10 * c / p)) + u)), h < 300 ? l = i.requestAnimationFrame(d) : o = n, r.set(o, void 0);
  }
  return t.add(O1({ createEmptyChangeSummary: () => ({ animate: !1 }), handleChange: (h, c) => (h.didChange(e) && (c.animate = c.animate || h.change), !0) }, (h, c) => {
    l !== void 0 && (i.cancelAnimationFrame(l), l = void 0), s = o, n = e.read(h), a = Date.now() - (c.animate ? 0 : 300), d();
  })), r;
}
class HV extends V {
  constructor(e, t, n) {
    super(), this._register(new UL(e, n)), this._register(Ed(n, { height: t.actualHeight, top: t.actualTop }));
  }
}
class sS {
  get afterLineNumber() {
    return this._afterLineNumber.get();
  }
  constructor(e, t) {
    this._afterLineNumber = e, this.heightInPx = t, this.domNode = document.createElement("div"), this._actualTop = lt(this, void 0), this._actualHeight = lt(this, void 0), this.actualTop = this._actualTop, this.actualHeight = this._actualHeight, this.showInHiddenAreas = !0, this.onChange = this._afterLineNumber, this.onDomNodeTop = (n) => {
      this._actualTop.set(n, void 0);
    }, this.onComputedHeight = (n) => {
      this._actualHeight.set(n, void 0);
    };
  }
}
class UL {
  constructor(e, t) {
    this._editor = e, this._domElement = t, this._overlayWidgetId = "managedOverlayWidget-" + UL._counter++, this._overlayWidget = { getId: () => this._overlayWidgetId, getDomNode: () => this._domElement, getPosition: () => null }, this._editor.addOverlayWidget(this._overlayWidget);
  }
  dispose() {
    this._editor.removeOverlayWidget(this._overlayWidget);
  }
}
function Ed(i, e) {
  return Ge((t) => {
    for (let [n, s] of Object.entries(e)) s && typeof s == "object" && "read" in s && (s = s.read(t)), typeof s == "number" && (s = `${s}px`), n = n.replace(/[A-Z]/g, (o) => "-" + o.toLowerCase()), i.style[n] = s;
  });
}
function gr(i, e) {
  return function(t, n) {
    ZA() && Hn("reload", (s) => WV(({ oldExports: o }) => {
      if ([...Object.values(o)].some((r) => t.includes(r))) return (r) => (s(void 0), !0);
    })).read(n);
  }([i], e), i;
}
function oS(i, e, t, n) {
  const s = new G(), o = [];
  return s.add(nr((r, a) => {
    const l = e.read(r), d = /* @__PURE__ */ new Map(), h = /* @__PURE__ */ new Map();
    t && t(!0), i.changeViewZones((c) => {
      for (const u of o) c.removeZone(u), n == null || n.delete(u);
      o.length = 0;
      for (const u of l) {
        const g = c.addZone(u);
        u.setZoneId && u.setZoneId(g), o.push(g), n == null || n.add(g), d.set(u, g);
      }
    }), t && t(!1), a.add(O1({ createEmptyChangeSummary: () => ({ zoneIds: [] }), handleChange(c, u) {
      const g = h.get(c.changedObservable);
      return g !== void 0 && u.zoneIds.push(g), !0;
    } }, (c, u) => {
      for (const g of l) g.onChange && (h.set(g.onChange, d.get(g)), g.onChange.read(c));
      t && t(!0), i.changeViewZones((g) => {
        for (const p of u.zoneIds) g.layoutZone(p);
      }), t && t(!1);
    }));
  })), s.add({ dispose() {
    t && t(!0), i.changeViewZones((r) => {
      for (const a of o) r.removeZone(a);
    }), n == null || n.clear(), t && t(!1);
  } }), s;
}
UL._counter = 0;
class rne extends Ci {
  dispose() {
    super.dispose(!0);
  }
}
function DF(i, e) {
  const t = sv(e, (r) => r.original.startLineNumber <= i.lineNumber);
  if (!t) return D.fromPositions(i);
  if (t.original.endLineNumberExclusive <= i.lineNumber) {
    const r = i.lineNumber - t.original.endLineNumberExclusive + t.modified.endLineNumberExclusive;
    return D.fromPositions(new W(r, i.column));
  }
  if (!t.innerChanges) return D.fromPositions(new W(t.modified.startLineNumber, 1));
  const n = sv(t.innerChanges, (r) => r.originalRange.getStartPosition().isBeforeOrEqual(i));
  if (!n) {
    const r = i.lineNumber - t.original.startLineNumber + t.modified.startLineNumber;
    return D.fromPositions(new W(r, i.column));
  }
  if (n.originalRange.containsPosition(i)) return n.modifiedRange;
  {
    const r = (s = n.originalRange.getEndPosition(), o = i, s.lineNumber === o.lineNumber ? new kr(0, o.column - s.column) : new kr(o.lineNumber - s.lineNumber, o.column - 1));
    return D.fromPositions(r.addToPosition(n.modifiedRange.getEndPosition()));
  }
  var s, o;
}
function Ml(i, e, t) {
  const n = i.bindTo(e);
  return DL({ debugName: () => `Set Context Key "${i.key}"` }, (s) => {
    n.set(t(s));
  });
}
var YA = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, XA = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const ane = Ei("diff-review-insert", ne.add, m(0, "Icon for 'Insert' in accessible diff viewer.")), lne = Ei("diff-review-remove", ne.remove, m(0, "Icon for 'Remove' in accessible diff viewer.")), dne = Ei("diff-review-close", ne.close, m(0, "Icon for 'Close' in accessible diff viewer."));
let Hh = class extends V {
  constructor(i, e, t, n, s, o, r, a, l) {
    super(), this._parentNode = i, this._visible = e, this._setVisible = t, this._canClose = n, this._width = s, this._height = o, this._diffs = r, this._models = a, this._instantiationService = l, this._state = Cf(this, (d, h) => {
      const c = this._visible.read(d);
      if (this._parentNode.style.visibility = c ? "visible" : "hidden", !c) return null;
      const u = h.add(this._instantiationService.createInstance(B2, this._diffs, this._models, this._setVisible, this._canClose));
      return { model: u, view: h.add(this._instantiationService.createInstance(W2, this._parentNode, u, this._width, this._height, this._models)) };
    }).recomputeInitiallyAndOnChange(this._store);
  }
  next() {
    Tt((i) => {
      const e = this._visible.get();
      this._setVisible(!0, i), e && this._state.get().model.nextGroup(i);
    });
  }
  prev() {
    Tt((i) => {
      this._setVisible(!0, i), this._state.get().model.previousGroup(i);
    });
  }
  close() {
    Tt((i) => {
      this._setVisible(!1, i);
    });
  }
};
Hh._ttPolicy = Hd("diffReview", { createHTML: (i) => i }), Hh = YA([XA(8, Se)], Hh);
let B2 = class extends V {
  constructor(i, e, t, n, s) {
    super(), this._diffs = i, this._models = e, this._setVisible = t, this.canClose = n, this._accessibilitySignalService = s, this._groups = lt(this, []), this._currentGroupIdx = lt(this, 0), this._currentElementIdx = lt(this, 0), this.groups = this._groups, this.currentGroup = this._currentGroupIdx.map((o, r) => this._groups.read(r)[o]), this.currentGroupIndex = this._currentGroupIdx, this.currentElement = this._currentElementIdx.map((o, r) => {
      var a;
      return (a = this.currentGroup.read(r)) === null || a === void 0 ? void 0 : a.lines[o];
    }), this._register(Ge((o) => {
      const r = this._diffs.read(o);
      if (!r) return void this._groups.set([], void 0);
      const a = function(l, d, h) {
        const c = [];
        for (const u of zT(l, (g, p) => p.modified.startLineNumber - g.modified.endLineNumberExclusive < 2 * Zf)) {
          const g = [];
          g.push(new cne());
          const p = new je(Math.max(1, u[0].original.startLineNumber - Zf), Math.min(u[u.length - 1].original.endLineNumberExclusive + Zf, d + 1)), f = new je(Math.max(1, u[0].modified.startLineNumber - Zf), Math.min(u[u.length - 1].modified.endLineNumberExclusive + Zf, h + 1));
          p7(u, (b, C) => {
            const w = new je(b ? b.original.endLineNumberExclusive : p.startLineNumber, C ? C.original.startLineNumber : p.endLineNumberExclusive), y = new je(b ? b.modified.endLineNumberExclusive : f.startLineNumber, C ? C.modified.startLineNumber : f.endLineNumberExclusive);
            w.forEach((L) => {
              g.push(new pne(L, y.startLineNumber + (L - w.startLineNumber)));
            }), C && (C.original.forEach((L) => {
              g.push(new une(C, L));
            }), C.modified.forEach((L) => {
              g.push(new gne(C, L));
            }));
          });
          const _ = u[0].modified.join(u[u.length - 1].modified), v = u[0].original.join(u[u.length - 1].original);
          c.push(new hne(new us(_, v), g));
        }
        return c;
      }(r, this._models.getOriginalModel().getLineCount(), this._models.getModifiedModel().getLineCount());
      Tt((l) => {
        const d = this._models.getModifiedPosition();
        if (d) {
          const h = a.findIndex((c) => (d == null ? void 0 : d.lineNumber) < c.range.modified.endLineNumberExclusive);
          h !== -1 && this._currentGroupIdx.set(h, l);
        }
        this._groups.set(a, l);
      });
    })), this._register(Ge((o) => {
      const r = this.currentElement.read(o);
      (r == null ? void 0 : r.type) === ds.Deleted ? this._accessibilitySignalService.playSignal(He.diffLineDeleted, { source: "accessibleDiffViewer.currentElementChanged" }) : (r == null ? void 0 : r.type) === ds.Added && this._accessibilitySignalService.playSignal(He.diffLineInserted, { source: "accessibleDiffViewer.currentElementChanged" });
    })), this._register(Ge((o) => {
      var r;
      const a = this.currentElement.read(o);
      if (a && a.type !== ds.Header) {
        const l = (r = a.modifiedLineNumber) !== null && r !== void 0 ? r : a.diff.modified.startLineNumber;
        this._models.modifiedSetSelection(D.fromPositions(new W(l, 1)));
      }
    }));
  }
  _goToGroupDelta(i, e) {
    const t = this.groups.get();
    !t || t.length <= 1 || Rv(e, (n) => {
      this._currentGroupIdx.set(qe.ofLength(t.length).clipCyclic(this._currentGroupIdx.get() + i), n), this._currentElementIdx.set(0, n);
    });
  }
  nextGroup(i) {
    this._goToGroupDelta(1, i);
  }
  previousGroup(i) {
    this._goToGroupDelta(-1, i);
  }
  _goToLineDelta(i) {
    const e = this.currentGroup.get();
    !e || e.lines.length <= 1 || Tt((t) => {
      this._currentElementIdx.set(qe.ofLength(e.lines.length).clip(this._currentElementIdx.get() + i), t);
    });
  }
  goToNextLine() {
    this._goToLineDelta(1);
  }
  goToPreviousLine() {
    this._goToLineDelta(-1);
  }
  goToLine(i) {
    const e = this.currentGroup.get();
    if (!e) return;
    const t = e.lines.indexOf(i);
    t !== -1 && Tt((n) => {
      this._currentElementIdx.set(t, n);
    });
  }
  revealCurrentElementInEditor() {
    if (!this.canClose.get()) return;
    this._setVisible(!1, void 0);
    const i = this.currentElement.get();
    i && (i.type === ds.Deleted ? this._models.originalReveal(D.fromPositions(new W(i.originalLineNumber, 1))) : this._models.modifiedReveal(i.type !== ds.Header ? D.fromPositions(new W(i.modifiedLineNumber, 1)) : void 0));
  }
  close() {
    this.canClose.get() && (this._setVisible(!1, void 0), this._models.modifiedFocus());
  }
};
B2 = YA([XA(4, Fc)], B2);
const Zf = 3;
var ds;
(function(i) {
  i[i.Header = 0] = "Header", i[i.Unchanged = 1] = "Unchanged", i[i.Deleted = 2] = "Deleted", i[i.Added = 3] = "Added";
})(ds || (ds = {}));
class hne {
  constructor(e, t) {
    this.range = e, this.lines = t;
  }
}
class cne {
  constructor() {
    this.type = ds.Header;
  }
}
class une {
  constructor(e, t) {
    this.diff = e, this.originalLineNumber = t, this.type = ds.Deleted, this.modifiedLineNumber = void 0;
  }
}
class gne {
  constructor(e, t) {
    this.diff = e, this.modifiedLineNumber = t, this.type = ds.Added, this.originalLineNumber = void 0;
  }
}
class pne {
  constructor(e, t) {
    this.originalLineNumber = e, this.modifiedLineNumber = t, this.type = ds.Unchanged;
  }
}
let W2 = class extends V {
  constructor(i, e, t, n, s, o) {
    super(), this._element = i, this._model = e, this._width = t, this._height = n, this._models = s, this._languageService = o, this.domNode = this._element, this.domNode.className = "monaco-component diff-review monaco-editor-background";
    const r = document.createElement("div");
    r.className = "diff-review-actions", this._actionBar = this._register(new sr(r)), this._register(Ge((a) => {
      this._actionBar.clear(), this._model.canClose.read(a) && this._actionBar.push(new Qs("diffreview.close", m(0, "Close"), "close-diff-review " + Ee.asClassName(dne), !0, async () => e.close()), { label: !1, icon: !0 });
    })), this._content = document.createElement("div"), this._content.className = "diff-review-content", this._content.setAttribute("role", "code"), this._scrollbar = this._register(new k1(this._content, {})), wn(this.domNode, this._scrollbar.getDomNode(), r), this._register(Ge((a) => {
      this._height.read(a), this._width.read(a), this._scrollbar.scanDomNode();
    })), this._register(ye(() => {
      wn(this.domNode);
    })), this._register(Ed(this.domNode, { width: this._width, height: this._height })), this._register(Ed(this._content, { width: this._width, height: this._height })), this._register(nr((a, l) => {
      this._model.currentGroup.read(a), this._render(l);
    })), this._register(bi(this.domNode, "keydown", (a) => {
      (a.equals(18) || a.equals(2066) || a.equals(530)) && (a.preventDefault(), this._model.goToNextLine()), (a.equals(16) || a.equals(2064) || a.equals(528)) && (a.preventDefault(), this._model.goToPreviousLine()), (a.equals(9) || a.equals(2057) || a.equals(521) || a.equals(1033)) && (a.preventDefault(), this._model.close()), (a.equals(10) || a.equals(3)) && (a.preventDefault(), this._model.revealCurrentElementInEditor());
    }));
  }
  _render(i) {
    const e = this._models.getOriginalOptions(), t = this._models.getModifiedOptions(), n = document.createElement("div");
    n.className = "diff-review-table", n.setAttribute("role", "list"), n.setAttribute("aria-label", m(0, "Accessible Diff Viewer. Use arrow up and down to navigate.")), yn(n, t.get(50)), wn(this._content, n);
    const s = this._models.getOriginalModel(), o = this._models.getModifiedModel();
    if (!s || !o) return;
    const r = s.getOptions(), a = o.getOptions(), l = t.get(67), d = this._model.currentGroup.get();
    for (const h of (d == null ? void 0 : d.lines) || []) {
      if (!d) break;
      let c;
      if (h.type === ds.Header) {
        const g = document.createElement("div");
        g.className = "diff-review-row", g.setAttribute("role", "listitem");
        const p = d.range, f = this._model.currentGroupIndex.get(), _ = this._model.groups.get().length, v = (y) => y === 0 ? m(0, "no lines changed") : y === 1 ? m(0, "1 line changed") : m(0, "{0} lines changed", y), b = v(p.original.length), C = v(p.modified.length);
        g.setAttribute("aria-label", m(0, "Difference {0} of {1}: original line {2}, {3}, modified line {4}, {5}", f + 1, _, p.original.startLineNumber, b, p.modified.startLineNumber, C));
        const w = document.createElement("div");
        w.className = "diff-review-cell diff-review-summary", w.appendChild(document.createTextNode(`${f + 1}/${_}: @@ -${p.original.startLineNumber},${p.original.length} +${p.modified.startLineNumber},${p.modified.length} @@`)), g.appendChild(w), c = g;
      } else c = this._createRow(h, l, this._width.get(), e, s, r, t, o, a);
      n.appendChild(c);
      const u = Fe((g) => this._model.currentElement.read(g) === h);
      i.add(Ge((g) => {
        const p = u.read(g);
        c.tabIndex = p ? 0 : -1, p && c.focus();
      })), i.add(K(c, "focus", () => {
        this._model.goToLine(h);
      }));
    }
    this._scrollbar.scanDomNode();
  }
  _createRow(i, e, t, n, s, o, r, a, l) {
    const d = n.get(145), h = d.glyphMarginWidth + d.lineNumbersWidth, c = r.get(145), u = 10 + c.glyphMarginWidth + c.lineNumbersWidth;
    let g = "diff-review-row", p = "", f = null;
    switch (i.type) {
      case ds.Added:
        g = "diff-review-row line-insert", p = " char-insert", f = ane;
        break;
      case ds.Deleted:
        g = "diff-review-row line-delete", p = " char-delete", f = lne;
    }
    const _ = document.createElement("div");
    _.style.minWidth = t + "px", _.className = g, _.setAttribute("role", "listitem"), _.ariaLevel = "";
    const v = document.createElement("div");
    v.className = "diff-review-cell", v.style.height = `${e}px`, _.appendChild(v);
    const b = document.createElement("span");
    b.style.width = h + "px", b.style.minWidth = h + "px", b.className = "diff-review-line-number" + p, i.originalLineNumber !== void 0 ? b.appendChild(document.createTextNode(String(i.originalLineNumber))) : b.innerText = " ", v.appendChild(b);
    const C = document.createElement("span");
    C.style.width = u + "px", C.style.minWidth = u + "px", C.style.paddingRight = "10px", C.className = "diff-review-line-number" + p, i.modifiedLineNumber !== void 0 ? C.appendChild(document.createTextNode(String(i.modifiedLineNumber))) : C.innerText = " ", v.appendChild(C);
    const w = document.createElement("span");
    if (w.className = "diff-review-spacer", f) {
      const k = document.createElement("span");
      k.className = Ee.asClassName(f), k.innerText = "  ", w.appendChild(k);
    } else w.innerText = "  ";
    let y;
    if (v.appendChild(w), i.modifiedLineNumber !== void 0) {
      let k = this._getLineHtml(a, r, l.tabSize, i.modifiedLineNumber, this._languageService.languageIdCodec);
      Hh._ttPolicy && (k = Hh._ttPolicy.createHTML(k)), v.insertAdjacentHTML("beforeend", k), y = a.getLineContent(i.modifiedLineNumber);
    } else {
      let k = this._getLineHtml(s, n, o.tabSize, i.originalLineNumber, this._languageService.languageIdCodec);
      Hh._ttPolicy && (k = Hh._ttPolicy.createHTML(k)), v.insertAdjacentHTML("beforeend", k), y = s.getLineContent(i.originalLineNumber);
    }
    y.length === 0 && (y = m(0, "blank"));
    let L = "";
    switch (i.type) {
      case ds.Unchanged:
        L = i.originalLineNumber === i.modifiedLineNumber ? m(0, "{0} unchanged line {1}", y, i.originalLineNumber) : m(0, "{0} original line {1} modified line {2}", y, i.originalLineNumber, i.modifiedLineNumber);
        break;
      case ds.Added:
        L = m(0, "+ {0} modified line {1}", y, i.modifiedLineNumber);
        break;
      case ds.Deleted:
        L = m(0, "- {0} original line {1}", y, i.originalLineNumber);
    }
    return _.setAttribute("aria-label", L), _;
  }
  _getLineHtml(i, e, t, n, s) {
    const o = i.getLineContent(n), r = e.get(50), a = nn.createEmpty(o, s), l = Co.isBasicASCII(o, i.mightContainNonBasicASCII()), d = Co.containsRTL(o, l, i.mightContainRTL());
    return sy(new Lc(r.isMonospace && !e.get(33), r.canUseHalfwidthRightwardsArrow, o, !1, l, d, 0, a, [], t, 0, r.spaceWidth, r.middotWidth, r.wsmiddotWidth, e.get(117), e.get(99), e.get(94), e.get(51) !== fo.OFF, null)).html;
  }
};
W2 = YA([XA(5, Xt)], W2);
class mne {
  constructor(e) {
    this.editors = e;
  }
  getOriginalModel() {
    return this.editors.original.getModel();
  }
  getOriginalOptions() {
    return this.editors.original.getOptions();
  }
  originalReveal(e) {
    this.editors.original.revealRange(e), this.editors.original.setSelection(e), this.editors.original.focus();
  }
  getModifiedModel() {
    return this.editors.modified.getModel();
  }
  getModifiedOptions() {
    return this.editors.modified.getOptions();
  }
  modifiedReveal(e) {
    e && (this.editors.modified.revealRange(e), this.editors.modified.setSelection(e)), this.editors.modified.focus();
  }
  modifiedSetSelection(e) {
    this.editors.modified.setSelection(e);
  }
  modifiedFocus() {
    this.editors.modified.focus();
  }
  getModifiedPosition() {
    var e;
    return (e = this.editors.modified.getPosition()) !== null && e !== void 0 ? e : void 0;
  }
}
class rc extends V {
  constructor(e, t, n, s, o) {
    super(), this._rootElement = e, this._diffModel = t, this._originalEditorLayoutInfo = n, this._modifiedEditorLayoutInfo = s, this._editors = o, this._originalScrollTop = Rt(this._editors.original.onDidScrollChange, () => this._editors.original.getScrollTop()), this._modifiedScrollTop = Rt(this._editors.modified.onDidScrollChange, () => this._editors.modified.getScrollTop()), this._viewZonesChanged = Hn("onDidChangeViewZones", this._editors.modified.onDidChangeViewZones), this.width = lt(this, 0), this._modifiedViewZonesChangedSignal = Hn("modified.onDidChangeViewZones", this._editors.modified.onDidChangeViewZones), this._originalViewZonesChangedSignal = Hn("original.onDidChangeViewZones", this._editors.original.onDidChangeViewZones), this._state = Cf(this, (h, c) => {
      var u;
      this._element.replaceChildren();
      const g = this._diffModel.read(h), p = (u = g == null ? void 0 : g.diff.read(h)) === null || u === void 0 ? void 0 : u.movedTexts;
      if (!p || p.length === 0) return void this.width.set(0, void 0);
      this._viewZonesChanged.read(h);
      const f = this._originalEditorLayoutInfo.read(h), _ = this._modifiedEditorLayoutInfo.read(h);
      if (!f || !_) return void this.width.set(0, void 0);
      this._modifiedViewZonesChangedSignal.read(h), this._originalViewZonesChangedSignal.read(h);
      const v = p.map((k) => {
        function N(me, ue) {
          return (ue.getTopForLineNumber(me.startLineNumber, !0) + ue.getTopForLineNumber(me.endLineNumberExclusive, !0)) / 2;
        }
        const A = N(k.lineRangeMapping.original, this._editors.original), B = this._originalScrollTop.read(h), T = N(k.lineRangeMapping.modified, this._editors.modified), O = A - B, H = T - this._modifiedScrollTop.read(h), $ = Math.min(A, T), pe = Math.max(A, T);
        return { range: new qe($, pe), from: O, to: H, fromWithoutScroll: A, toWithoutScroll: T, move: k };
      });
      v.sort(/* @__PURE__ */ function(...k) {
        return (N, A) => {
          for (const B of k) {
            const T = B(N, A);
            if (!K0.isNeitherLessOrGreaterThan(T)) return T;
          }
          return K0.neitherLessOrGreaterThan;
        };
      }(jo((k) => k.fromWithoutScroll > k.toWithoutScroll, UU), jo((k) => k.fromWithoutScroll > k.toWithoutScroll ? k.fromWithoutScroll : -k.toWithoutScroll, od)));
      const b = QA.compute(v.map((k) => k.range)), C = f.verticalScrollbarWidth, w = 10 * (b.getTrackCount() - 1) + 20, y = C + w + (_.contentLeft - rc.movedCodeBlockPadding);
      let L = 0;
      for (const k of v) {
        const N = C + 10 + 10 * b.getTrack(L), A = 15, B = 15, T = y, O = _.glyphMarginWidth + _.lineNumbersWidth, H = 18, $ = document.createElementNS("http://www.w3.org/2000/svg", "rect");
        $.classList.add("arrow-rectangle"), $.setAttribute("x", "" + (T - O)), $.setAttribute("y", "" + (k.to - H / 2)), $.setAttribute("width", `${O}`), $.setAttribute("height", `${H}`), this._element.appendChild($);
        const pe = document.createElementNS("http://www.w3.org/2000/svg", "g"), me = document.createElementNS("http://www.w3.org/2000/svg", "path");
        me.setAttribute("d", `M 0 ${k.from} L ${N} ${k.from} L ${N} ${k.to} L ${T - B} ${k.to}`), me.setAttribute("fill", "none"), pe.appendChild(me);
        const ue = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
        ue.classList.add("arrow"), c.add(Ge((ee) => {
          me.classList.toggle("currentMove", k.move === g.activeMovedText.read(ee)), ue.classList.toggle("currentMove", k.move === g.activeMovedText.read(ee));
        })), ue.setAttribute("points", `${T - B},${k.to - A / 2} ${T},${k.to} ${T - B},${k.to + A / 2}`), pe.appendChild(ue), this._element.appendChild(pe), L++;
      }
      this.width.set(w, void 0);
    }), this._element = document.createElementNS("http://www.w3.org/2000/svg", "svg"), this._element.setAttribute("class", "moved-blocks-lines"), this._rootElement.appendChild(this._element), this._register(ye(() => this._element.remove())), this._register(Ge((h) => {
      const c = this._originalEditorLayoutInfo.read(h), u = this._modifiedEditorLayoutInfo.read(h);
      c && u && (this._element.style.left = c.width - c.verticalScrollbarWidth + "px", this._element.style.height = `${c.height}px`, this._element.style.width = `${c.verticalScrollbarWidth + c.contentLeft - rc.movedCodeBlockPadding + this.width.read(h)}px`);
    })), this._register(F1(this._state));
    const r = Fe((h) => {
      const c = this._diffModel.read(h), u = c == null ? void 0 : c.diff.read(h);
      return u ? u.movedTexts.map((g) => ({ move: g, original: new sS(ia(g.lineRangeMapping.original.startLineNumber - 1), 18), modified: new sS(ia(g.lineRangeMapping.modified.startLineNumber - 1), 18) })) : [];
    });
    this._register(oS(this._editors.original, r.map((h) => h.map((c) => c.original)))), this._register(oS(this._editors.modified, r.map((h) => h.map((c) => c.modified)))), this._register(nr((h, c) => {
      const u = r.read(h);
      for (const g of u) c.add(new xF(this._editors.original, g.original, g.move, "original", this._diffModel.get())), c.add(new xF(this._editors.modified, g.modified, g.move, "modified", this._diffModel.get()));
    }));
    const a = Hn("original.onDidFocusEditorWidget", (h) => this._editors.original.onDidFocusEditorWidget(() => setTimeout(() => h(void 0), 0))), l = Hn("modified.onDidFocusEditorWidget", (h) => this._editors.modified.onDidFocusEditorWidget(() => setTimeout(() => h(void 0), 0)));
    let d = "modified";
    this._register(O1({ createEmptyChangeSummary: () => {
    }, handleChange: (h, c) => (h.didChange(a) && (d = "original"), h.didChange(l) && (d = "modified"), !0) }, (h) => {
      a.read(h), l.read(h);
      const c = this._diffModel.read(h);
      if (!c) return;
      const u = c.diff.read(h);
      let g;
      if (u && d === "original") {
        const p = this._editors.originalCursor.read(h);
        p && (g = u.movedTexts.find((f) => f.lineRangeMapping.original.contains(p.lineNumber)));
      }
      if (u && d === "modified") {
        const p = this._editors.modifiedCursor.read(h);
        p && (g = u.movedTexts.find((f) => f.lineRangeMapping.modified.contains(p.lineNumber)));
      }
      g !== c.movedTextToCompare.get() && c.movedTextToCompare.set(void 0, void 0), c.setActiveMovedText(g);
    }));
  }
}
rc.movedCodeBlockPadding = 4;
class QA {
  static compute(e) {
    const t = [], n = [];
    for (const s of e) {
      let o = t.findIndex((r) => !r.intersectsStrict(s));
      o === -1 && (t.length >= 6 ? o = Lq(t, jo((a) => a.intersectWithRangeLength(s), od)) : (o = t.length, t.push(new kR()))), t[o].addRange(s), n.push(o);
    }
    return new QA(t.length, n);
  }
  constructor(e, t) {
    this._trackCount = e, this.trackPerLineIdx = t;
  }
  getTrack(e) {
    return this.trackPerLineIdx[e];
  }
  getTrackCount() {
    return this._trackCount;
  }
}
class xF extends HV {
  constructor(e, t, n, s, o) {
    const r = yt("div.diff-hidden-lines-widget");
    super(e, t, r.root), this._editor = e, this._move = n, this._kind = s, this._diffModel = o, this._nodes = yt("div.diff-moved-code-block", { style: { marginRight: "4px" } }, [yt("div.text-content@textContent"), yt("div.action-bar@actionBar")]), r.root.appendChild(this._nodes.root);
    const a = Rt(this._editor.onDidLayoutChange, () => this._editor.getLayoutInfo());
    let l;
    this._register(Ed(this._nodes.root, { paddingRight: a.map((u) => u.verticalScrollbarWidth) })), l = n.changes.length > 0 ? this._kind === "original" ? m(0, "Code moved with changes to line {0}-{1}", this._move.lineRangeMapping.modified.startLineNumber, this._move.lineRangeMapping.modified.endLineNumberExclusive - 1) : m(0, "Code moved with changes from line {0}-{1}", this._move.lineRangeMapping.original.startLineNumber, this._move.lineRangeMapping.original.endLineNumberExclusive - 1) : this._kind === "original" ? m(0, "Code moved to line {0}-{1}", this._move.lineRangeMapping.modified.startLineNumber, this._move.lineRangeMapping.modified.endLineNumberExclusive - 1) : m(0, "Code moved from line {0}-{1}", this._move.lineRangeMapping.original.startLineNumber, this._move.lineRangeMapping.original.endLineNumberExclusive - 1);
    const d = this._register(new sr(this._nodes.actionBar, { highlightToggledItems: !0 })), h = new Qs("", l, "", !1);
    d.push(h, { icon: !1, label: !0 });
    const c = new Qs("", "Compare", Ee.asClassName(ne.compareChanges), !0, () => {
      this._editor.focus(), this._diffModel.movedTextToCompare.set(this._diffModel.movedTextToCompare.get() === n ? void 0 : this._move, void 0);
    });
    this._register(Ge((u) => {
      const g = this._diffModel.movedTextToCompare.read(u) === n;
      c.checked = g;
    })), d.push(c, { icon: !1, label: !0 });
  }
}
I("diffEditor.move.border", { dark: "#8b8b8b9c", light: "#8b8b8b9c", hcDark: "#8b8b8b9c", hcLight: "#8b8b8b9c" }, m(0, "The border color for text that got moved in the diff editor.")), I("diffEditor.moveActive.border", { dark: "#FFA500", light: "#FFA500", hcDark: "#FFA500", hcLight: "#FFA500" }, m(0, "The active border color for text that got moved in the diff editor.")), I("diffEditor.unchangedRegionShadow", { dark: "#000000", light: "#737373BF", hcDark: "#000000", hcLight: "#737373BF" }, m(0, "The color of the shadow around unchanged region widgets."));
const fne = Ei("diff-insert", ne.add, m(0, "Line decoration for inserts in the diff editor.")), zV = Ei("diff-remove", ne.remove, m(0, "Line decoration for removals in the diff editor.")), NF = Ve.register({ className: "line-insert", description: "line-insert", isWholeLine: !0, linesDecorationsClassName: "insert-sign " + Ee.asClassName(fne), marginClassName: "gutter-insert" }), EF = Ve.register({ className: "line-delete", description: "line-delete", isWholeLine: !0, linesDecorationsClassName: "delete-sign " + Ee.asClassName(zV), marginClassName: "gutter-delete" }), IF = Ve.register({ className: "line-insert", description: "line-insert", isWholeLine: !0, marginClassName: "gutter-insert" }), MF = Ve.register({ className: "line-delete", description: "line-delete", isWholeLine: !0, marginClassName: "gutter-delete" }), TF = Ve.register({ className: "char-insert", description: "char-insert", shouldFillLineOnLineBreak: !0 }), _ne = Ve.register({ className: "char-insert", description: "char-insert", isWholeLine: !0 }), vne = Ve.register({ className: "char-insert diff-range-empty", description: "char-insert diff-range-empty" }), V2 = Ve.register({ className: "char-delete", description: "char-delete", shouldFillLineOnLineBreak: !0 }), bne = Ve.register({ className: "char-delete", description: "char-delete", isWholeLine: !0 }), Cne = Ve.register({ className: "char-delete diff-range-empty", description: "char-delete diff-range-empty" });
class wne extends V {
  constructor(e, t, n, s) {
    super(), this._editors = e, this._diffModel = t, this._options = n, this._decorations = Fe(this, (o) => {
      var r;
      const a = (r = this._diffModel.read(o)) === null || r === void 0 ? void 0 : r.diff.read(o);
      if (!a) return null;
      const l = this._diffModel.read(o).movedTextToCompare.read(o), d = this._options.renderIndicators.read(o), h = this._options.showEmptyDecorations.read(o), c = [], u = [];
      if (!l) for (const p of a.mappings) if (p.lineRangeMapping.original.isEmpty || c.push({ range: p.lineRangeMapping.original.toInclusiveRange(), options: d ? EF : MF }), p.lineRangeMapping.modified.isEmpty || u.push({ range: p.lineRangeMapping.modified.toInclusiveRange(), options: d ? NF : IF }), p.lineRangeMapping.modified.isEmpty || p.lineRangeMapping.original.isEmpty) p.lineRangeMapping.original.isEmpty || c.push({ range: p.lineRangeMapping.original.toInclusiveRange(), options: bne }), p.lineRangeMapping.modified.isEmpty || u.push({ range: p.lineRangeMapping.modified.toInclusiveRange(), options: _ne });
      else for (const f of p.lineRangeMapping.innerChanges || []) p.lineRangeMapping.original.contains(f.originalRange.startLineNumber) && c.push({ range: f.originalRange, options: f.originalRange.isEmpty() && h ? Cne : V2 }), p.lineRangeMapping.modified.contains(f.modifiedRange.startLineNumber) && u.push({ range: f.modifiedRange, options: f.modifiedRange.isEmpty() && h ? vne : TF });
      if (l) for (const p of l.changes) {
        const f = p.original.toInclusiveRange();
        f && c.push({ range: f, options: d ? EF : MF });
        const _ = p.modified.toInclusiveRange();
        _ && u.push({ range: _, options: d ? NF : IF });
        for (const v of p.innerChanges || []) c.push({ range: v.originalRange, options: V2 }), u.push({ range: v.modifiedRange, options: TF });
      }
      const g = this._diffModel.read(o).activeMovedText.read(o);
      for (const p of a.movedTexts) c.push({ range: p.lineRangeMapping.original.toInclusiveRange(), options: { description: "moved", blockClassName: "movedOriginal" + (p === g ? " currentMove" : ""), blockPadding: [rc.movedCodeBlockPadding, 0, rc.movedCodeBlockPadding, rc.movedCodeBlockPadding] } }), u.push({ range: p.lineRangeMapping.modified.toInclusiveRange(), options: { description: "moved", blockClassName: "movedModified" + (p === g ? " currentMove" : ""), blockPadding: [4, 0, 4, 4] } });
      return { originalDecorations: c, modifiedDecorations: u };
    }), this._register(nS(this._editors.original, this._decorations.map((o) => (o == null ? void 0 : o.originalDecorations) || []))), this._register(nS(this._editors.modified, this._decorations.map((o) => (o == null ? void 0 : o.modifiedDecorations) || [])));
  }
}
class yne extends V {
  constructor(e, t, n, s) {
    super(), this._options = e, this._domNode = t, this._dimensions = n, this._sashes = s, this._sashRatio = lt(this, void 0), this.sashLeft = Fe(this, (o) => {
      var r;
      const a = (r = this._sashRatio.read(o)) !== null && r !== void 0 ? r : this._options.splitViewDefaultRatio.read(o);
      return this._computeSashLeft(a, o);
    }), this._sash = this._register(new Bn(this._domNode, { getVerticalSashTop: (o) => 0, getVerticalSashLeft: (o) => this.sashLeft.get(), getVerticalSashHeight: (o) => this._dimensions.height.get() }, { orientation: 0 })), this._startSashPosition = void 0, this._register(this._sash.onDidStart(() => {
      this._startSashPosition = this.sashLeft.get();
    })), this._register(this._sash.onDidChange((o) => {
      const r = this._dimensions.width.get(), a = this._computeSashLeft((this._startSashPosition + (o.currentX - o.startX)) / r, void 0);
      this._sashRatio.set(a / r, void 0);
    })), this._register(this._sash.onDidEnd(() => this._sash.layout())), this._register(this._sash.onDidReset(() => this._sashRatio.set(void 0, void 0))), this._register(Ge((o) => {
      const r = this._sashes.read(o);
      r && (this._sash.orthogonalEndSash = r.bottom);
    })), this._register(Ge((o) => {
      const r = this._options.enableSplitViewResizing.read(o);
      this._sash.state = r ? 3 : 0, this.sashLeft.read(o), this._dimensions.height.read(o), this._sash.layout();
    }));
  }
  _computeSashLeft(e, t) {
    const n = this._dimensions.width.read(t), s = Math.floor(this._options.splitViewDefaultRatio.read(t) * n), o = this._options.enableSplitViewResizing.read(t) ? Math.floor(e * n) : s, r = 100;
    return n <= 200 ? s : o < r ? r : o > n - r ? n - r : o;
  }
}
var lu, UV = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, H2 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const KV = tt("diffProviderFactoryService");
let hx = class {
  constructor(i) {
    this.instantiationService = i;
  }
  createDiffProvider(i) {
    return this.instantiationService.createInstance(rw, i);
  }
};
hx = UV([H2(0, Se)], hx), rt(KV, hx, 1);
let rw = lu = class {
  constructor(i, e, t) {
    this.editorWorkerService = e, this.telemetryService = t, this.onDidChangeEventEmitter = new F(), this.onDidChange = this.onDidChangeEventEmitter.event, this.diffAlgorithm = "advanced", this.diffAlgorithmOnDidChangeSubscription = void 0, this.setOptions(i);
  }
  dispose() {
    var i;
    (i = this.diffAlgorithmOnDidChangeSubscription) === null || i === void 0 || i.dispose();
  }
  async computeDiff(i, e, t, n) {
    var s, o;
    if (typeof this.diffAlgorithm != "string") return this.diffAlgorithm.computeDiff(i, e, t, n);
    if (i.getLineCount() === 1 && i.getLineMaxColumn(1) === 1) return e.getLineCount() === 1 && e.getLineMaxColumn(1) === 1 ? { changes: [], identical: !0, quitEarly: !1, moves: [] } : { changes: [new xo(new je(1, 2), new je(1, e.getLineCount() + 1), [new Fd(i.getFullModelRange(), e.getFullModelRange())])], identical: !1, quitEarly: !1, moves: [] };
    const r = JSON.stringify([i.uri.toString(), e.uri.toString()]), a = JSON.stringify([i.id, e.id, i.getAlternativeVersionId(), e.getAlternativeVersionId(), JSON.stringify(t)]), l = lu.diffCache.get(r);
    if (l && l.context === a) return l.result;
    const d = Rn.create(), h = await this.editorWorkerService.computeDiff(i.uri, e.uri, t, this.diffAlgorithm), c = d.elapsed();
    if (this.telemetryService.publicLog2("diffEditor.computeDiff", { timeMs: c, timedOut: (s = h == null ? void 0 : h.quitEarly) === null || s === void 0 || s, detectedMoves: t.computeMoves ? (o = h == null ? void 0 : h.moves.length) !== null && o !== void 0 ? o : 0 : -1 }), n.isCancellationRequested) return { changes: [], identical: !1, quitEarly: !0, moves: [] };
    if (!h) throw new Error("no diff result available");
    return lu.diffCache.size > 10 && lu.diffCache.delete(lu.diffCache.keys().next().value), lu.diffCache.set(r, { result: h, context: a }), h;
  }
  setOptions(i) {
    var e;
    let t = !1;
    i.diffAlgorithm && this.diffAlgorithm !== i.diffAlgorithm && ((e = this.diffAlgorithmOnDidChangeSubscription) === null || e === void 0 || e.dispose(), this.diffAlgorithmOnDidChangeSubscription = void 0, this.diffAlgorithm = i.diffAlgorithm, typeof i.diffAlgorithm != "string" && (this.diffAlgorithmOnDidChangeSubscription = i.diffAlgorithm.onDidChange(() => this.onDidChangeEventEmitter.fire())), t = !0), t && this.onDidChangeEventEmitter.fire();
  }
};
rw.diffCache = /* @__PURE__ */ new Map(), rw = lu = UV([H2(1, Qo), H2(2, es)], rw);
var Sne = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Lne = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let z2 = class extends V {
  setActiveMovedText(i) {
    this._activeMovedText.set(i, void 0);
  }
  constructor(i, e, t) {
    super(), this.model = i, this._options = e, this._diffProviderFactoryService = t, this._isDiffUpToDate = lt(this, !1), this.isDiffUpToDate = this._isDiffUpToDate, this._diff = lt(this, void 0), this.diff = this._diff, this._unchangedRegions = lt(this, void 0), this.unchangedRegions = Fe(this, (r) => {
      var a, l;
      return this._options.hideUnchangedRegions.read(r) ? (l = (a = this._unchangedRegions.read(r)) === null || a === void 0 ? void 0 : a.regions) !== null && l !== void 0 ? l : [] : (Tt((d) => {
        var h;
        for (const c of ((h = this._unchangedRegions.get()) === null || h === void 0 ? void 0 : h.regions) || []) c.collapseAll(d);
      }), []);
    }), this.movedTextToCompare = lt(this, void 0), this._activeMovedText = lt(this, void 0), this._hoveredMovedText = lt(this, void 0), this.activeMovedText = Fe(this, (r) => {
      var a, l;
      return (l = (a = this.movedTextToCompare.read(r)) !== null && a !== void 0 ? a : this._hoveredMovedText.read(r)) !== null && l !== void 0 ? l : this._activeMovedText.read(r);
    }), this._cancellationTokenSource = new Ci(), this._diffProvider = Fe(this, (r) => {
      const a = this._diffProviderFactoryService.createDiffProvider({ diffAlgorithm: this._options.diffAlgorithm.read(r) });
      return { diffProvider: a, onChangeSignal: Hn("onDidChange", a.onDidChange) };
    }), this._register(ye(() => this._cancellationTokenSource.cancel()));
    const n = NL("contentChangedSignal"), s = this._register(new It(() => n.trigger(void 0), 200));
    this._register(Ge((r) => {
      const a = this._unchangedRegions.read(r);
      if (!a || a.regions.some((g) => g.isDragged.read(r))) return;
      const l = a.originalDecorationIds.map((g) => i.original.getDecorationRange(g)).map((g) => g ? je.fromRangeInclusive(g) : void 0), d = a.modifiedDecorationIds.map((g) => i.modified.getDecorationRange(g)).map((g) => g ? je.fromRangeInclusive(g) : void 0), h = a.regions.map((g, p) => l[p] && d[p] ? new zh(l[p].startLineNumber, d[p].startLineNumber, l[p].length, g.visibleLineCountTop.read(r), g.visibleLineCountBottom.read(r)) : void 0).filter(cl), c = [];
      let u = !1;
      for (const g of zT(h, (p, f) => p.getHiddenModifiedRange(r).endLineNumberExclusive === f.getHiddenModifiedRange(r).startLineNumber)) if (g.length > 1) {
        u = !0;
        const p = g.reduce((_, v) => _ + v.lineCount, 0), f = new zh(g[0].originalLineNumber, g[0].modifiedLineNumber, p, g[0].visibleLineCountTop.get(), g[g.length - 1].visibleLineCountBottom.get());
        c.push(f);
      } else c.push(g[0]);
      if (u) {
        const g = i.original.deltaDecorations(a.originalDecorationIds, c.map((f) => ({ range: f.originalUnchangedRange.toInclusiveRange(), options: { description: "unchanged" } }))), p = i.modified.deltaDecorations(a.modifiedDecorationIds, c.map((f) => ({ range: f.modifiedUnchangedRange.toInclusiveRange(), options: { description: "unchanged" } })));
        Tt((f) => {
          this._unchangedRegions.set({ regions: c, originalDecorationIds: g, modifiedDecorationIds: p }, f);
        });
      }
    }));
    const o = (r, a, l) => {
      const d = zh.fromDiffs(r.changes, i.original.getLineCount(), i.modified.getLineCount(), this._options.hideUnchangedRegionsMinimumLineCount.read(l), this._options.hideUnchangedRegionsContextLineCount.read(l));
      let h;
      const c = this._unchangedRegions.get();
      if (c) {
        const f = c.originalDecorationIds.map((C) => i.original.getDecorationRange(C)).map((C) => C ? je.fromRangeInclusive(C) : void 0), _ = c.modifiedDecorationIds.map((C) => i.modified.getDecorationRange(C)).map((C) => C ? je.fromRangeInclusive(C) : void 0);
        let b = function(C, w) {
          let y;
          return C.filter((L) => {
            const k = w(L, y);
            return y = L, k;
          });
        }(c.regions.map((C, w) => {
          if (!f[w] || !_[w]) return;
          const y = f[w].length;
          return new zh(f[w].startLineNumber, _[w].startLineNumber, y, Math.min(C.visibleLineCountTop.get(), y), Math.min(C.visibleLineCountBottom.get(), y - C.visibleLineCountTop.get()));
        }).filter(cl), (C, w) => !w || C.modifiedLineNumber >= w.modifiedLineNumber + w.lineCount && C.originalLineNumber >= w.originalLineNumber + w.lineCount).map((C) => new us(C.getHiddenOriginalRange(l), C.getHiddenModifiedRange(l)));
        b = us.clip(b, je.ofLength(1, i.original.getLineCount()), je.ofLength(1, i.modified.getLineCount())), h = us.inverse(b, i.original.getLineCount(), i.modified.getLineCount());
      }
      const u = [];
      if (h) for (const f of d) {
        const _ = h.filter((v) => v.original.intersectsStrict(f.originalUnchangedRange) && v.modified.intersectsStrict(f.modifiedUnchangedRange));
        u.push(...f.setVisibleRanges(_, a));
      }
      else u.push(...d);
      const g = i.original.deltaDecorations((c == null ? void 0 : c.originalDecorationIds) || [], u.map((f) => ({ range: f.originalUnchangedRange.toInclusiveRange(), options: { description: "unchanged" } }))), p = i.modified.deltaDecorations((c == null ? void 0 : c.modifiedDecorationIds) || [], u.map((f) => ({ range: f.modifiedUnchangedRange.toInclusiveRange(), options: { description: "unchanged" } })));
      this._unchangedRegions.set({ regions: u, originalDecorationIds: g, modifiedDecorationIds: p }, a);
    };
    this._register(i.modified.onDidChangeContent((r) => {
      if (this._diff.get()) {
        const a = bd.fromModelContentChanges(r.changes);
        this._lastDiff, i.original, i.modified;
      }
      this._isDiffUpToDate.set(!1, void 0), s.schedule();
    })), this._register(i.original.onDidChangeContent((r) => {
      if (this._diff.get()) {
        const a = bd.fromModelContentChanges(r.changes);
        this._lastDiff, i.original, i.modified;
      }
      this._isDiffUpToDate.set(!1, void 0), s.schedule();
    })), this._register(nr(async (r, a) => {
      var l, d;
      this._options.hideUnchangedRegionsMinimumLineCount.read(r), this._options.hideUnchangedRegionsContextLineCount.read(r), s.cancel(), n.read(r);
      const h = this._diffProvider.read(r);
      h.onChangeSignal.read(r), gr(Q8, r), gr(KE, r), this._isDiffUpToDate.set(!1, void 0);
      let c = [];
      a.add(i.original.onDidChangeContent((v) => {
        const b = bd.fromModelContentChanges(v.changes);
        c = vy(c, b);
      }));
      let u = [];
      a.add(i.modified.onDidChangeContent((v) => {
        const b = bd.fromModelContentChanges(v.changes);
        u = vy(u, b);
      }));
      let g = await h.diffProvider.computeDiff(i.original, i.modified, { ignoreTrimWhitespace: this._options.ignoreTrimWhitespace.read(r), maxComputationTimeMs: this._options.maxComputationTimeMs.read(r), computeMoves: this._options.showMoves.read(r) }, this._cancellationTokenSource.token);
      var p, f, _;
      this._cancellationTokenSource.token.isCancellationRequested || (p = g, f = i.original, _ = i.modified, g = { changes: p.changes.map((v) => new xo(v.original, v.modified, v.innerChanges ? v.innerChanges.map((b) => function(C, w, y) {
        let L = C.originalRange, k = C.modifiedRange;
        return (L.endColumn !== 1 || k.endColumn !== 1) && L.endColumn === w.getLineMaxColumn(L.endLineNumber) && k.endColumn === y.getLineMaxColumn(k.endLineNumber) && L.endLineNumber < w.getLineCount() && k.endLineNumber < y.getLineCount() && (L = L.setEndPosition(L.endLineNumber + 1, 1), k = k.setEndPosition(k.endLineNumber + 1, 1)), new Fd(L, k);
      }(b, f, _)) : void 0)), moves: p.moves, identical: p.identical, quitEarly: p.quitEarly }, g = (l = (i.original, i.modified, void 0)) !== null && l !== void 0 ? l : g, g = (d = (i.original, i.modified, void 0)) !== null && d !== void 0 ? d : g, Tt((v) => {
        o(g, v), this._lastDiff = g;
        const b = JA.fromDiffResult(g);
        this._diff.set(b, v), this._isDiffUpToDate.set(!0, v);
        const C = this.movedTextToCompare.get();
        this.movedTextToCompare.set(C ? this._lastDiff.moves.find((w) => w.lineRangeMapping.modified.intersect(C.lineRangeMapping.modified)) : void 0, v);
      }));
    }));
  }
  ensureModifiedLineIsVisible(i, e, t) {
    var n, s;
    if (((n = this.diff.get()) === null || n === void 0 ? void 0 : n.mappings.length) === 0) return;
    const o = ((s = this._unchangedRegions.get()) === null || s === void 0 ? void 0 : s.regions) || [];
    for (const r of o) if (r.getHiddenModifiedRange(void 0).contains(i)) return void r.showModifiedLine(i, e, t);
  }
  ensureOriginalLineIsVisible(i, e, t) {
    var n, s;
    if (((n = this.diff.get()) === null || n === void 0 ? void 0 : n.mappings.length) === 0) return;
    const o = ((s = this._unchangedRegions.get()) === null || s === void 0 ? void 0 : s.regions) || [];
    for (const r of o) if (r.getHiddenOriginalRange(void 0).contains(i)) return void r.showOriginalLine(i, e, t);
  }
  async waitForDiff() {
    var i, e;
    await (i = this.isDiffUpToDate, e = (t) => t, new Promise((t, n) => {
      let s = !0, o = !1;
      const r = i.map((l) => ({ isFinished: e(l), error: !1, state: l })), a = Ge((l) => {
        const { isFinished: d, error: h, state: c } = r.read(l);
        (d || h) && (s ? o = !0 : a.dispose(), h ? n(h === !0 ? c : h) : t(c));
      });
      s = !1, o && a.dispose();
    }));
  }
  serializeState() {
    const i = this._unchangedRegions.get();
    return { collapsedRegions: i == null ? void 0 : i.regions.map((e) => ({ range: e.getHiddenModifiedRange(void 0).serialize() })) };
  }
  restoreSerializedState(i) {
    var e;
    const t = (e = i.collapsedRegions) === null || e === void 0 ? void 0 : e.map((s) => je.deserialize(s.range)), n = this._unchangedRegions.get();
    n && t && Tt((s) => {
      for (const o of n.regions) for (const r of t) if (o.modifiedUnchangedRange.intersect(r)) {
        o.setHiddenModifiedRange(r, s);
        break;
      }
    });
  }
};
z2 = Sne([Lne(2, KV)], z2);
class JA {
  static fromDiffResult(e) {
    return new JA(e.changes.map((t) => new jV(t)), e.moves || [], e.identical, e.quitEarly);
  }
  constructor(e, t, n, s) {
    this.mappings = e, this.movedTexts = t, this.identical = n, this.quitEarly = s;
  }
}
class jV {
  constructor(e) {
    this.lineRangeMapping = e;
  }
}
class zh {
  static fromDiffs(e, t, n, s, o) {
    const r = xo.inverse(e, t, n), a = [];
    for (const l of r) {
      let d = l.original.startLineNumber, h = l.modified.startLineNumber, c = l.original.length;
      const u = d === 1 && h === 1, g = d + c === t + 1 && h + c === n + 1;
      (u || g) && c >= o + s ? (u && !g && (c -= o), g && !u && (d += o, h += o, c -= o), a.push(new zh(d, h, c, 0, 0))) : c >= 2 * o + s && (d += o, h += o, c -= 2 * o, a.push(new zh(d, h, c, 0, 0)));
    }
    return a;
  }
  get originalUnchangedRange() {
    return je.ofLength(this.originalLineNumber, this.lineCount);
  }
  get modifiedUnchangedRange() {
    return je.ofLength(this.modifiedLineNumber, this.lineCount);
  }
  constructor(e, t, n, s, o) {
    this.originalLineNumber = e, this.modifiedLineNumber = t, this.lineCount = n, this._visibleLineCountTop = lt(this, 0), this.visibleLineCountTop = this._visibleLineCountTop, this._visibleLineCountBottom = lt(this, 0), this.visibleLineCountBottom = this._visibleLineCountBottom, this._shouldHideControls = Fe(this, (l) => this.visibleLineCountTop.read(l) + this.visibleLineCountBottom.read(l) === this.lineCount && !this.isDragged.read(l)), this.isDragged = lt(this, void 0);
    const r = Math.max(Math.min(s, this.lineCount), 0), a = Math.max(Math.min(o, this.lineCount - s), 0);
    MO(s === r), MO(o === a), this._visibleLineCountTop.set(r, void 0), this._visibleLineCountBottom.set(a, void 0);
  }
  setVisibleRanges(e, t) {
    const n = [], s = new Uo(e.map((l) => l.modified)).subtractFrom(this.modifiedUnchangedRange);
    let o = this.originalLineNumber, r = this.modifiedLineNumber;
    const a = this.modifiedLineNumber + this.lineCount;
    if (s.ranges.length === 0) this.showAll(t), n.push(this);
    else {
      let l = 0;
      for (const d of s.ranges) {
        const h = l === s.ranges.length - 1;
        l++;
        const c = (h ? a : d.endLineNumberExclusive) - r, u = new zh(o, r, c, 0, 0);
        u.setHiddenModifiedRange(d, t), n.push(u), o = u.originalUnchangedRange.endLineNumberExclusive, r = u.modifiedUnchangedRange.endLineNumberExclusive;
      }
    }
    return n;
  }
  shouldHideControls(e) {
    return this._shouldHideControls.read(e);
  }
  getHiddenOriginalRange(e) {
    return je.ofLength(this.originalLineNumber + this._visibleLineCountTop.read(e), this.lineCount - this._visibleLineCountTop.read(e) - this._visibleLineCountBottom.read(e));
  }
  getHiddenModifiedRange(e) {
    return je.ofLength(this.modifiedLineNumber + this._visibleLineCountTop.read(e), this.lineCount - this._visibleLineCountTop.read(e) - this._visibleLineCountBottom.read(e));
  }
  setHiddenModifiedRange(e, t) {
    const n = e.startLineNumber - this.modifiedLineNumber, s = this.modifiedLineNumber + this.lineCount - e.endLineNumberExclusive;
    this.setState(n, s, t);
  }
  getMaxVisibleLineCountTop() {
    return this.lineCount - this._visibleLineCountBottom.get();
  }
  getMaxVisibleLineCountBottom() {
    return this.lineCount - this._visibleLineCountTop.get();
  }
  showMoreAbove(e = 10, t) {
    const n = this.getMaxVisibleLineCountTop();
    this._visibleLineCountTop.set(Math.min(this._visibleLineCountTop.get() + e, n), t);
  }
  showMoreBelow(e = 10, t) {
    const n = this.lineCount - this._visibleLineCountTop.get();
    this._visibleLineCountBottom.set(Math.min(this._visibleLineCountBottom.get() + e, n), t);
  }
  showAll(e) {
    this._visibleLineCountBottom.set(this.lineCount - this._visibleLineCountTop.get(), e);
  }
  showModifiedLine(e, t, n) {
    const s = e + 1 - (this.modifiedLineNumber + this._visibleLineCountTop.get()), o = this.modifiedLineNumber - this._visibleLineCountBottom.get() + this.lineCount - e;
    t === 0 && s < o || t === 1 ? this._visibleLineCountTop.set(this._visibleLineCountTop.get() + s, n) : this._visibleLineCountBottom.set(this._visibleLineCountBottom.get() + o, n);
  }
  showOriginalLine(e, t, n) {
    const s = e - this.originalLineNumber, o = this.originalLineNumber + this.lineCount - e;
    t === 0 && s < o || t === 1 ? this._visibleLineCountTop.set(Math.min(this._visibleLineCountTop.get() + o - s, this.getMaxVisibleLineCountTop()), n) : this._visibleLineCountBottom.set(Math.min(this._visibleLineCountBottom.get() + s - o, this.getMaxVisibleLineCountBottom()), n);
  }
  collapseAll(e) {
    this._visibleLineCountTop.set(0, e), this._visibleLineCountBottom.set(0, e);
  }
  setState(e, t, n) {
    e = Math.max(Math.min(e, this.lineCount), 0), t = Math.max(Math.min(t, this.lineCount - e), 0), this._visibleLineCountTop.set(e, n), this._visibleLineCountBottom.set(t, n);
  }
}
class kne extends V {
  get visibility() {
    return this._visibility;
  }
  set visibility(e) {
    this._visibility !== e && (this._visibility = e, this._diffActions.style.visibility = e ? "visible" : "hidden");
  }
  constructor(e, t, n, s, o, r, a, l, d) {
    super(), this._getViewZoneId = e, this._marginDomNode = t, this._modifiedEditor = n, this._diff = s, this._editor = o, this._viewLineCounts = r, this._originalTextModel = a, this._contextMenuService = l, this._clipboardService = d, this._visibility = !1, this._marginDomNode.style.zIndex = "10", this._diffActions = document.createElement("div"), this._diffActions.className = Ee.asClassName(ne.lightBulb) + " lightbulb-glyph", this._diffActions.style.position = "absolute";
    const h = this._modifiedEditor.getOption(67);
    this._diffActions.style.right = "0px", this._diffActions.style.visibility = "hidden", this._diffActions.style.height = `${h}px`, this._diffActions.style.lineHeight = `${h}px`, this._marginDomNode.appendChild(this._diffActions);
    let c = 0;
    const u = n.getOption(127) && !ua, g = (p, f) => {
      var _;
      this._contextMenuService.showContextMenu({ domForShadowRoot: u && (_ = n.getDomNode()) !== null && _ !== void 0 ? _ : void 0, getAnchor: () => ({ x: p, y: f }), getActions: () => {
        const v = [], b = s.modified.isEmpty;
        return v.push(new Qs("diff.clipboard.copyDeletedContent", b ? s.original.length > 1 ? m(0, "Copy deleted lines") : m(0, "Copy deleted line") : s.original.length > 1 ? m(0, "Copy changed lines") : m(0, "Copy changed line"), void 0, !0, async () => {
          const C = this._originalTextModel.getValueInRange(s.original.toExclusiveRange());
          await this._clipboardService.writeText(C);
        })), s.original.length > 1 && v.push(new Qs("diff.clipboard.copyDeletedLineContent", m(0, b ? "Copy deleted line ({0})" : "Copy changed line ({0})", s.original.startLineNumber + c), void 0, !0, async () => {
          let C = this._originalTextModel.getLineContent(s.original.startLineNumber + c);
          C === "" && (C = this._originalTextModel.getEndOfLineSequence() === 0 ? `
` : `\r
`), await this._clipboardService.writeText(C);
        })), n.getOption(91) || v.push(new Qs("diff.inline.revertChange", m(0, "Revert this change"), void 0, !0, async () => {
          this._editor.revert(this._diff);
        })), v;
      }, autoSelectFirstItem: !0 });
    };
    this._register(bi(this._diffActions, "mousedown", (p) => {
      if (!p.leftButton) return;
      const { top: f, height: _ } = Ti(this._diffActions), v = Math.floor(h / 3);
      p.preventDefault(), g(p.posx, f + _ + v);
    })), this._register(n.onMouseMove((p) => {
      p.target.type !== 8 && p.target.type !== 5 || p.target.detail.viewZoneId !== this._getViewZoneId() ? this.visibility = !1 : (c = this._updateLightBulbPosition(this._marginDomNode, p.event.browserEvent.y, h), this.visibility = !0);
    })), this._register(n.onMouseDown((p) => {
      p.event.leftButton && (p.target.type === 8 || p.target.type === 5) && p.target.detail.viewZoneId === this._getViewZoneId() && (p.event.preventDefault(), c = this._updateLightBulbPosition(this._marginDomNode, p.event.browserEvent.y, h), g(p.event.posx, p.event.posy + h));
    }));
  }
  _updateLightBulbPosition(e, t, n) {
    const { top: s } = Ti(e), o = t - s, r = Math.floor(o / n), a = r * n;
    if (this._diffActions.style.top = `${a}px`, this._viewLineCounts) {
      let l = 0;
      for (let d = 0; d < this._viewLineCounts.length; d++) if (l += this._viewLineCounts[d], r < l) return d;
    }
    return r;
  }
}
const RF = Hd("diffEditorWidget", { createHTML: (i) => i });
function Dne(i, e, t, n) {
  yn(n, e.fontInfo);
  const s = t.length > 0, o = new ff(1e4);
  let r = 0, a = 0;
  const l = [];
  for (let c = 0; c < i.lineTokens.length; c++) {
    const u = c + 1, g = i.lineTokens[c], p = i.lineBreakData[c], f = _s.filter(t, u, 1, Number.MAX_SAFE_INTEGER);
    if (p) {
      let _ = 0;
      for (const v of p.breakOffsets) {
        const b = g.sliceAndInflate(_, v, 0);
        r = Math.max(r, AF(a, b, _s.extractWrapped(f, _, v), s, i.mightContainNonBasicASCII, i.mightContainRTL, e, o)), a++, _ = v;
      }
      l.push(p.breakOffsets.length);
    } else l.push(1), r = Math.max(r, AF(a, g, f, s, i.mightContainNonBasicASCII, i.mightContainRTL, e, o)), a++;
  }
  r += e.scrollBeyondLastColumn;
  const d = o.build(), h = RF ? RF.createHTML(d) : d;
  return n.innerHTML = h, { heightInLines: a, minWidthInPx: r * e.typicalHalfwidthCharacterWidth, viewLineCounts: l };
}
class xne {
  constructor(e, t, n, s) {
    this.lineTokens = e, this.lineBreakData = t, this.mightContainNonBasicASCII = n, this.mightContainRTL = s;
  }
}
class eP {
  static fromEditor(e) {
    var t;
    const n = e.getOptions(), s = n.get(50), o = n.get(145);
    return new eP(((t = e.getModel()) === null || t === void 0 ? void 0 : t.getOptions().tabSize) || 0, s, n.get(33), s.typicalHalfwidthCharacterWidth, n.get(104), n.get(67), o.decorationsWidth, n.get(117), n.get(99), n.get(94), n.get(51));
  }
  constructor(e, t, n, s, o, r, a, l, d, h, c) {
    this.tabSize = e, this.fontInfo = t, this.disableMonospaceOptimizations = n, this.typicalHalfwidthCharacterWidth = s, this.scrollBeyondLastColumn = o, this.lineHeight = r, this.lineDecorationsWidth = a, this.stopRenderingLineAfter = l, this.renderWhitespace = d, this.renderControlCharacters = h, this.fontLigatures = c;
  }
}
function AF(i, e, t, n, s, o, r, a) {
  a.appendString('<div class="view-line'), n || a.appendString(" char-delete"), a.appendString('" style="top:'), a.appendString(String(i * r.lineHeight)), a.appendString('px;width:1000000px;">');
  const l = e.getLineContent(), d = Co.isBasicASCII(l, s), h = Co.containsRTL(l, d, o), c = y1(new Lc(r.fontInfo.isMonospace && !r.disableMonospaceOptimizations, r.fontInfo.canUseHalfwidthRightwardsArrow, l, !1, d, h, 0, e, t, r.tabSize, 0, r.fontInfo.spaceWidth, r.fontInfo.middotWidth, r.fontInfo.wsmiddotWidth, r.stopRenderingLineAfter, r.renderWhitespace, r.renderControlCharacters, r.fontLigatures !== fo.OFF, null), a);
  return a.appendString("</div>"), c.characterMapping.getHorizontalOffset(c.characterMapping.length);
}
var Nne = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, PF = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let U2 = class extends V {
  constructor(i, e, t, n, s, o, r, a, l, d) {
    super(), this._targetWindow = i, this._editors = e, this._diffModel = t, this._options = n, this._diffEditorWidget = s, this._canIgnoreViewZoneUpdateEvent = o, this._origViewZonesToIgnore = r, this._modViewZonesToIgnore = a, this._clipboardService = l, this._contextMenuService = d, this._originalTopPadding = lt(this, 0), this._originalScrollOffset = lt(this, 0), this._originalScrollOffsetAnimated = kF(this._targetWindow, this._originalScrollOffset, this._store), this._modifiedTopPadding = lt(this, 0), this._modifiedScrollOffset = lt(this, 0), this._modifiedScrollOffsetAnimated = kF(this._targetWindow, this._modifiedScrollOffset, this._store);
    const h = lt("invalidateAlignmentsState", 0), c = this._register(new It(() => {
      h.set(h.get() + 1, void 0);
    }, 0));
    this._register(this._editors.original.onDidChangeViewZones((b) => {
      this._canIgnoreViewZoneUpdateEvent() || c.schedule();
    })), this._register(this._editors.modified.onDidChangeViewZones((b) => {
      this._canIgnoreViewZoneUpdateEvent() || c.schedule();
    })), this._register(this._editors.original.onDidChangeConfiguration((b) => {
      (b.hasChanged(146) || b.hasChanged(67)) && c.schedule();
    })), this._register(this._editors.modified.onDidChangeConfiguration((b) => {
      (b.hasChanged(146) || b.hasChanged(67)) && c.schedule();
    }));
    const u = this._diffModel.map((b) => b ? Rt(b.model.original.onDidChangeTokens, () => b.model.original.tokenization.backgroundTokenizationState === 2) : void 0).map((b, C) => b == null ? void 0 : b.read(C)), g = Fe((b) => {
      const C = this._diffModel.read(b), w = C == null ? void 0 : C.diff.read(b);
      if (!C || !w) return null;
      h.read(b);
      const y = this._options.renderSideBySide.read(b);
      return OF(this._editors.original, this._editors.modified, w.mappings, this._origViewZonesToIgnore, this._modViewZonesToIgnore, y);
    }), p = Fe((b) => {
      var C;
      const w = (C = this._diffModel.read(b)) === null || C === void 0 ? void 0 : C.movedTextToCompare.read(b);
      if (!w) return null;
      h.read(b);
      const y = w.changes.map((L) => new jV(L));
      return OF(this._editors.original, this._editors.modified, y, this._origViewZonesToIgnore, this._modViewZonesToIgnore, !0);
    });
    function f() {
      const b = document.createElement("div");
      return b.className = "diagonal-fill", b;
    }
    const _ = this._register(new G());
    this.viewZones = Cf(this, (b, C) => {
      var w, y, L, k, N, A, B, T;
      _.clear();
      const O = g.read(b) || [], H = [], $ = [], pe = this._modifiedTopPadding.read(b);
      pe > 0 && $.push({ afterLineNumber: 0, domNode: document.createElement("div"), heightInPx: pe, showInHiddenAreas: !0, suppressMouseDown: !0 });
      const me = this._originalTopPadding.read(b);
      me > 0 && H.push({ afterLineNumber: 0, domNode: document.createElement("div"), heightInPx: me, showInHiddenAreas: !0, suppressMouseDown: !0 });
      const ue = this._options.renderSideBySide.read(b), ee = ue || (w = this._editors.modified._getViewModel()) === null || w === void 0 ? void 0 : w.createLineBreaksComputer();
      if (ee) {
        const nt = this._editors.original.getModel();
        for (const De of O) if (De.diff) for (let an = De.originalRange.startLineNumber; an < De.originalRange.endLineNumberExclusive; an++) {
          if (an > nt.getLineCount()) return { orig: H, mod: $ };
          ee == null || ee.addRequest(nt.getLineContent(an), null, null);
        }
      }
      const te = (y = ee == null ? void 0 : ee.finalize()) !== null && y !== void 0 ? y : [];
      let be = 0;
      const we = this._editors.modified.getOption(67), Re = (L = this._diffModel.read(b)) === null || L === void 0 ? void 0 : L.movedTextToCompare.read(b), it = (N = (k = this._editors.original.getModel()) === null || k === void 0 ? void 0 : k.mightContainNonBasicASCII()) !== null && N !== void 0 && N, ut = (B = (A = this._editors.original.getModel()) === null || A === void 0 ? void 0 : A.mightContainRTL()) !== null && B !== void 0 && B, Xi = eP.fromEditor(this._editors.modified);
      for (const nt of O) if (nt.diff && !ue) {
        if (!nt.originalRange.isEmpty) {
          u.read(b);
          const an = document.createElement("div");
          an.classList.add("view-lines", "line-delete", "monaco-mouse-cursor-text");
          const ka = this._editors.original.getModel();
          if (nt.originalRange.endLineNumberExclusive - 1 > ka.getLineCount()) return { orig: H, mod: $ };
          const Er = new xne(nt.originalRange.mapToLineArray((Ki) => ka.tokenization.getLineTokens(Ki)), nt.originalRange.mapToLineArray((Ki) => te[be++]), it, ut), Ws = [];
          for (const Ki of nt.diff.innerChanges || []) Ws.push(new Q_(Ki.originalRange.delta(-(nt.diff.original.startLineNumber - 1)), V2.className, 0));
          const Ss = Dne(Er, Xi, Ws, an), Ir = document.createElement("div");
          if (Ir.className = "inline-deleted-margin-view-zone", yn(Ir, Xi.fontInfo), this._options.renderIndicators.read(b)) for (let Ki = 0; Ki < Ss.heightInLines; Ki++) {
            const le = document.createElement("div");
            le.className = `delete-sign ${Ee.asClassName(zV)}`, le.setAttribute("style", `position:absolute;top:${Ki * we}px;width:${Xi.lineDecorationsWidth}px;height:${we}px;right:0;`), Ir.appendChild(le);
          }
          let jd;
          _.add(new kne(() => xh(jd), Ir, this._editors.modified, nt.diff, this._diffEditorWidget, Ss.viewLineCounts, this._editors.original.getModel(), this._contextMenuService, this._clipboardService));
          for (let Ki = 0; Ki < Ss.viewLineCounts.length; Ki++) {
            const le = Ss.viewLineCounts[Ki];
            le > 1 && H.push({ afterLineNumber: nt.originalRange.startLineNumber + Ki, domNode: f(), heightInPx: (le - 1) * we, showInHiddenAreas: !0, suppressMouseDown: !0 });
          }
          $.push({ afterLineNumber: nt.modifiedRange.startLineNumber - 1, domNode: an, heightInPx: Ss.heightInLines * we, minWidthInPx: Ss.minWidthInPx, marginDomNode: Ir, setZoneId(Ki) {
            jd = Ki;
          }, showInHiddenAreas: !0, suppressMouseDown: !0 });
        }
        const De = document.createElement("div");
        De.className = "gutter-delete", H.push({ afterLineNumber: nt.originalRange.endLineNumberExclusive - 1, domNode: f(), heightInPx: nt.modifiedHeightInPx, marginDomNode: De, showInHiddenAreas: !0, suppressMouseDown: !0 });
      } else {
        const De = nt.modifiedHeightInPx - nt.originalHeightInPx;
        if (De > 0) {
          if (Re != null && Re.lineRangeMapping.original.delta(-1).deltaLength(2).contains(nt.originalRange.endLineNumberExclusive - 1)) continue;
          H.push({ afterLineNumber: nt.originalRange.endLineNumberExclusive - 1, domNode: f(), heightInPx: De, showInHiddenAreas: !0, suppressMouseDown: !0 });
        } else {
          let an = function() {
            const Er = document.createElement("div");
            return Er.className = "arrow-revert-change " + Ee.asClassName(ne.arrowRight), C.add(K(Er, "mousedown", (Ws) => Ws.stopPropagation())), C.add(K(Er, "click", (Ws) => {
              Ws.stopPropagation(), s.revert(nt.diff);
            })), Q("div", {}, Er);
          };
          if (Re != null && Re.lineRangeMapping.modified.delta(-1).deltaLength(2).contains(nt.modifiedRange.endLineNumberExclusive - 1)) continue;
          let ka;
          nt.diff && nt.diff.modified.isEmpty && this._options.shouldRenderOldRevertArrows.read(b) && (ka = an()), $.push({ afterLineNumber: nt.modifiedRange.endLineNumberExclusive - 1, domNode: f(), heightInPx: -De, marginDomNode: ka, showInHiddenAreas: !0, suppressMouseDown: !0 });
        }
      }
      for (const nt of (T = p.read(b)) !== null && T !== void 0 ? T : []) {
        if (!(Re != null && Re.lineRangeMapping.original.intersect(nt.originalRange)) || !(Re != null && Re.lineRangeMapping.modified.intersect(nt.modifiedRange))) continue;
        const De = nt.modifiedHeightInPx - nt.originalHeightInPx;
        De > 0 ? H.push({ afterLineNumber: nt.originalRange.endLineNumberExclusive - 1, domNode: f(), heightInPx: De, showInHiddenAreas: !0, suppressMouseDown: !0 }) : $.push({ afterLineNumber: nt.modifiedRange.endLineNumberExclusive - 1, domNode: f(), heightInPx: -De, showInHiddenAreas: !0, suppressMouseDown: !0 });
      }
      return { orig: H, mod: $ };
    });
    let v = !1;
    this._register(this._editors.original.onDidScrollChange((b) => {
      b.scrollLeftChanged && !v && (v = !0, this._editors.modified.setScrollLeft(b.scrollLeft), v = !1);
    })), this._register(this._editors.modified.onDidScrollChange((b) => {
      b.scrollLeftChanged && !v && (v = !0, this._editors.original.setScrollLeft(b.scrollLeft), v = !1);
    })), this._originalScrollTop = Rt(this._editors.original.onDidScrollChange, () => this._editors.original.getScrollTop()), this._modifiedScrollTop = Rt(this._editors.modified.onDidScrollChange, () => this._editors.modified.getScrollTop()), this._register(Ge((b) => {
      const C = this._originalScrollTop.read(b) - (this._originalScrollOffsetAnimated.get() - this._modifiedScrollOffsetAnimated.read(b)) - (this._originalTopPadding.get() - this._modifiedTopPadding.read(b));
      C !== this._editors.modified.getScrollTop() && this._editors.modified.setScrollTop(C, 1);
    })), this._register(Ge((b) => {
      const C = this._modifiedScrollTop.read(b) - (this._modifiedScrollOffsetAnimated.get() - this._originalScrollOffsetAnimated.read(b)) - (this._modifiedTopPadding.get() - this._originalTopPadding.read(b));
      C !== this._editors.original.getScrollTop() && this._editors.original.setScrollTop(C, 1);
    })), this._register(Ge((b) => {
      var C;
      const w = (C = this._diffModel.read(b)) === null || C === void 0 ? void 0 : C.movedTextToCompare.read(b);
      let y = 0;
      if (w) {
        const L = this._editors.original.getTopForLineNumber(w.lineRangeMapping.original.startLineNumber, !0) - this._originalTopPadding.get();
        y = this._editors.modified.getTopForLineNumber(w.lineRangeMapping.modified.startLineNumber, !0) - this._modifiedTopPadding.get() - L;
      }
      y > 0 ? (this._modifiedTopPadding.set(0, void 0), this._originalTopPadding.set(y, void 0)) : y < 0 ? (this._modifiedTopPadding.set(-y, void 0), this._originalTopPadding.set(0, void 0)) : setTimeout(() => {
        this._modifiedTopPadding.set(0, void 0), this._originalTopPadding.set(0, void 0);
      }, 400), this._editors.modified.hasTextFocus() ? this._originalScrollOffset.set(this._modifiedScrollOffset.get() - y, void 0, !0) : this._modifiedScrollOffset.set(this._originalScrollOffset.get() + y, void 0, !0);
    }));
  }
};
function OF(i, e, t, n, s, o) {
  const r = new Pd(FF(i, n)), a = new Pd(FF(e, s)), l = i.getOption(67), d = e.getOption(67), h = [];
  let c = 0, u = 0;
  function g(p, f) {
    for (; ; ) {
      let _ = r.peek(), v = a.peek();
      if (_ && _.lineNumber >= p && (_ = void 0), v && v.lineNumber >= f && (v = void 0), !_ && !v) break;
      const b = _ ? _.lineNumber - c : Number.MAX_VALUE, C = v ? v.lineNumber - u : Number.MAX_VALUE;
      b < C ? (r.dequeue(), v = { lineNumber: _.lineNumber - c + u, heightInPx: 0 }) : b > C ? (a.dequeue(), _ = { lineNumber: v.lineNumber - u + c, heightInPx: 0 }) : (r.dequeue(), a.dequeue()), h.push({ originalRange: je.ofLength(_.lineNumber, 1), modifiedRange: je.ofLength(v.lineNumber, 1), originalHeightInPx: l + _.heightInPx, modifiedHeightInPx: d + v.heightInPx, diff: void 0 });
    }
  }
  for (const p of t) {
    let C = function(w, y) {
      var L, k, N, A;
      if (w < b || y < v) return;
      if (_) _ = !1;
      else if (w === b || y === v) return;
      const B = new je(b, w), T = new je(v, y);
      if (B.isEmpty && T.isEmpty) return;
      const O = (k = (L = r.takeWhile(($) => $.lineNumber < w)) === null || L === void 0 ? void 0 : L.reduce(($, pe) => $ + pe.heightInPx, 0)) !== null && k !== void 0 ? k : 0, H = (A = (N = a.takeWhile(($) => $.lineNumber < y)) === null || N === void 0 ? void 0 : N.reduce(($, pe) => $ + pe.heightInPx, 0)) !== null && A !== void 0 ? A : 0;
      h.push({ originalRange: B, modifiedRange: T, originalHeightInPx: B.length * l + O, modifiedHeightInPx: T.length * d + H, diff: p.lineRangeMapping }), b = w, v = y;
    };
    const f = p.lineRangeMapping;
    g(f.original.startLineNumber, f.modified.startLineNumber);
    let _ = !0, v = f.modified.startLineNumber, b = f.original.startLineNumber;
    if (o) for (const w of f.innerChanges || []) {
      w.originalRange.startColumn > 1 && w.modifiedRange.startColumn > 1 && C(w.originalRange.startLineNumber, w.modifiedRange.startLineNumber);
      const y = i.getModel(), L = w.originalRange.endLineNumber <= y.getLineCount() ? y.getLineMaxColumn(w.originalRange.endLineNumber) : Number.MAX_SAFE_INTEGER;
      w.originalRange.endColumn < L && C(w.originalRange.endLineNumber, w.modifiedRange.endLineNumber);
    }
    C(f.original.endLineNumberExclusive, f.modified.endLineNumberExclusive), c = f.original.endLineNumberExclusive, u = f.modified.endLineNumberExclusive;
  }
  return g(Number.MAX_VALUE, Number.MAX_VALUE), h;
}
function FF(i, e) {
  const t = [], n = [], s = i.getOption(146).wrappingColumn !== -1, o = i._getViewModel().coordinatesConverter, r = i.getOption(67);
  if (s) for (let a = 1; a <= i.getModel().getLineCount(); a++) {
    const l = o.getModelLineViewLineCount(a);
    l > 1 && n.push({ lineNumber: a, heightInPx: r * (l - 1) });
  }
  for (const a of i.getWhitespaces()) {
    if (e.has(a.id)) continue;
    const l = a.afterLineNumber === 0 ? 0 : o.convertViewPositionToModelPosition(new W(a.afterLineNumber, 1)).lineNumber;
    t.push({ lineNumber: l, heightInPx: a.height });
  }
  return function(a, l, d, h) {
    if (a.length === 0) return l;
    if (l.length === 0) return a;
    const c = [];
    let u = 0, g = 0;
    for (; u < a.length && g < l.length; ) {
      const p = a[u], f = l[g], _ = d(p), v = d(f);
      _ < v ? (c.push(p), u++) : _ > v ? (c.push(f), g++) : (c.push(h(p, f)), u++, g++);
    }
    for (; u < a.length; ) c.push(a[u]), u++;
    for (; g < l.length; ) c.push(l[g]), g++;
    return c;
  }(t, n, (a) => a.lineNumber, (a, l) => ({ lineNumber: a.lineNumber, heightInPx: a.heightInPx + l.heightInPx }));
}
U2 = Nne([PF(8, Kd), PF(9, io)], U2);
var K2, Ene = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Ine = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let w0 = K2 = class extends V {
  static setBreadcrumbsSourceFactory(i) {
    this._breadcrumbsSourceFactory.set(i, void 0);
  }
  get isUpdatingHiddenAreas() {
    return this._isUpdatingHiddenAreas;
  }
  constructor(i, e, t, n) {
    super(), this._editors = i, this._diffModel = e, this._options = t, this._instantiationService = n, this._modifiedOutlineSource = Fl(this, (a) => {
      const l = this._editors.modifiedModel.read(a), d = K2._breadcrumbsSourceFactory.read(a);
      return l && d ? d(l, this._instantiationService) : void 0;
    }), this._isUpdatingHiddenAreas = !1, this._register(this._editors.original.onDidChangeCursorPosition((a) => {
      if (a.reason === 1) return;
      const l = this._diffModel.get();
      Tt((d) => {
        for (const h of this._editors.original.getSelections() || []) l == null || l.ensureOriginalLineIsVisible(h.getStartPosition().lineNumber, 0, d), l == null || l.ensureOriginalLineIsVisible(h.getEndPosition().lineNumber, 0, d);
      });
    })), this._register(this._editors.modified.onDidChangeCursorPosition((a) => {
      if (a.reason === 1) return;
      const l = this._diffModel.get();
      Tt((d) => {
        for (const h of this._editors.modified.getSelections() || []) l == null || l.ensureModifiedLineIsVisible(h.getStartPosition().lineNumber, 0, d), l == null || l.ensureModifiedLineIsVisible(h.getEndPosition().lineNumber, 0, d);
      });
    }));
    const s = this._diffModel.map((a, l) => {
      var d, h;
      const c = (d = a == null ? void 0 : a.unchangedRegions.read(l)) !== null && d !== void 0 ? d : [];
      return c.length === 1 && c[0].modifiedLineNumber === 1 && c[0].lineCount === ((h = this._editors.modifiedModel.read(l)) === null || h === void 0 ? void 0 : h.getLineCount()) ? [] : c;
    });
    this.viewZones = Cf(this, (a, l) => {
      const d = this._modifiedOutlineSource.read(a);
      if (!d) return { origViewZones: [], modViewZones: [] };
      const h = [], c = [], u = this._options.renderSideBySide.read(a), g = s.read(a);
      for (const p of g) if (!p.shouldHideControls(a)) {
        {
          const f = Fe(this, (v) => p.getHiddenOriginalRange(v).startLineNumber - 1), _ = new sS(f, 24);
          h.push(_), l.add(new BF(this._editors.original, _, p, p.originalUnchangedRange, !u, d, (v) => this._diffModel.get().ensureModifiedLineIsVisible(v, 2, void 0), this._options));
        }
        {
          const f = Fe(this, (v) => p.getHiddenModifiedRange(v).startLineNumber - 1), _ = new sS(f, 24);
          c.push(_), l.add(new BF(this._editors.modified, _, p, p.modifiedUnchangedRange, !1, d, (v) => this._diffModel.get().ensureModifiedLineIsVisible(v, 2, void 0), this._options));
        }
      }
      return { origViewZones: h, modViewZones: c };
    });
    const o = { description: "unchanged lines", className: "diff-unchanged-lines", isWholeLine: !0 }, r = { description: "Fold Unchanged", glyphMarginHoverMessage: new Vn(void 0, { isTrusted: !0, supportThemeIcons: !0 }).appendMarkdown(m(0, "Fold Unchanged Region")), glyphMarginClassName: "fold-unchanged " + Ee.asClassName(ne.fold), zIndex: 10001 };
    this._register(nS(this._editors.original, Fe(this, (a) => {
      const l = s.read(a), d = l.map((h) => ({ range: h.originalUnchangedRange.toInclusiveRange(), options: o }));
      for (const h of l) h.shouldHideControls(a) && d.push({ range: D.fromPositions(new W(h.originalLineNumber, 1)), options: r });
      return d;
    }))), this._register(nS(this._editors.modified, Fe(this, (a) => {
      const l = s.read(a), d = l.map((h) => ({ range: h.modifiedUnchangedRange.toInclusiveRange(), options: o }));
      for (const h of l) h.shouldHideControls(a) && d.push({ range: je.ofLength(h.modifiedLineNumber, 1).toInclusiveRange(), options: r });
      return d;
    }))), this._register(Ge((a) => {
      const l = s.read(a);
      this._isUpdatingHiddenAreas = !0;
      try {
        this._editors.original.setHiddenAreas(l.map((d) => d.getHiddenOriginalRange(a).toInclusiveRange()).filter(cl)), this._editors.modified.setHiddenAreas(l.map((d) => d.getHiddenModifiedRange(a).toInclusiveRange()).filter(cl));
      } finally {
        this._isUpdatingHiddenAreas = !1;
      }
    })), this._register(this._editors.modified.onMouseUp((a) => {
      var l;
      if (!a.event.rightButton && a.target.position && (!((l = a.target.element) === null || l === void 0) && l.className.includes("fold-unchanged"))) {
        const d = a.target.position.lineNumber, h = this._diffModel.get();
        if (!h) return;
        const c = h.unchangedRegions.get().find((u) => u.modifiedUnchangedRange.includes(d));
        if (!c) return;
        c.collapseAll(void 0), a.event.stopPropagation(), a.event.preventDefault();
      }
    })), this._register(this._editors.original.onMouseUp((a) => {
      var l;
      if (!a.event.rightButton && a.target.position && (!((l = a.target.element) === null || l === void 0) && l.className.includes("fold-unchanged"))) {
        const d = a.target.position.lineNumber, h = this._diffModel.get();
        if (!h) return;
        const c = h.unchangedRegions.get().find((u) => u.originalUnchangedRange.includes(d));
        if (!c) return;
        c.collapseAll(void 0), a.event.stopPropagation(), a.event.preventDefault();
      }
    }));
  }
};
w0._breadcrumbsSourceFactory = lt("breadcrumbsSourceFactory", void 0), w0 = K2 = Ene([Ine(3, Se)], w0);
class BF extends HV {
  constructor(e, t, n, s, o, r, a, l) {
    const d = yt("div.diff-hidden-lines-widget");
    super(e, t, d.root), this._editor = e, this._unchangedRegion = n, this._unchangedRegionRange = s, this._hide = o, this._modifiedOutlineSource = r, this._revealModifiedHiddenLine = a, this._options = l, this._nodes = yt("div.diff-hidden-lines", [yt("div.top@top", { title: m(0, "Click or drag to show more above") }), yt("div.center@content", { style: { display: "flex" } }, [yt("div@first", { style: { display: "flex", justifyContent: "center", alignItems: "center", flexShrink: "0" } }, [Q("a", { title: m(0, "Show Unchanged Region"), role: "button", onclick: () => {
      this._unchangedRegion.showAll(void 0);
    } }, ...ic("$(unfold)"))]), yt("div@others", { style: { display: "flex", justifyContent: "center", alignItems: "center" } })]), yt("div.bottom@bottom", { title: m(0, "Click or drag to show more below"), role: "button" })]), d.root.appendChild(this._nodes.root);
    const h = Rt(this._editor.onDidLayoutChange, () => this._editor.getLayoutInfo());
    this._hide ? wn(this._nodes.first) : this._register(Ed(this._nodes.first, { width: h.map((u) => u.contentLeft) })), this._register(Ge((u) => {
      const g = this._unchangedRegion.visibleLineCountTop.read(u) + this._unchangedRegion.visibleLineCountBottom.read(u) === this._unchangedRegion.lineCount;
      this._nodes.bottom.classList.toggle("canMoveTop", !g), this._nodes.bottom.classList.toggle("canMoveBottom", this._unchangedRegion.visibleLineCountBottom.read(u) > 0), this._nodes.top.classList.toggle("canMoveTop", this._unchangedRegion.visibleLineCountTop.read(u) > 0), this._nodes.top.classList.toggle("canMoveBottom", !g);
      const p = this._unchangedRegion.isDragged.read(u), f = this._editor.getDomNode();
      f && (f.classList.toggle("draggingUnchangedRegion", !!p), p === "top" ? (f.classList.toggle("canMoveTop", this._unchangedRegion.visibleLineCountTop.read(u) > 0), f.classList.toggle("canMoveBottom", !g)) : p === "bottom" ? (f.classList.toggle("canMoveTop", !g), f.classList.toggle("canMoveBottom", this._unchangedRegion.visibleLineCountBottom.read(u) > 0)) : (f.classList.toggle("canMoveTop", !1), f.classList.toggle("canMoveBottom", !1)));
    }));
    const c = this._editor;
    this._register(K(this._nodes.top, "mousedown", (u) => {
      if (u.button !== 0) return;
      this._nodes.top.classList.toggle("dragging", !0), this._nodes.root.classList.toggle("dragging", !0), u.preventDefault();
      const g = u.clientY;
      let p = !1;
      const f = this._unchangedRegion.visibleLineCountTop.get();
      this._unchangedRegion.isDragged.set("top", void 0);
      const _ = ke(this._nodes.top), v = K(_, "mousemove", (C) => {
        const w = C.clientY - g;
        p = p || Math.abs(w) > 2;
        const y = Math.round(w / c.getOption(67)), L = Math.max(0, Math.min(f + y, this._unchangedRegion.getMaxVisibleLineCountTop()));
        this._unchangedRegion.visibleLineCountTop.set(L, void 0);
      }), b = K(_, "mouseup", (C) => {
        p || this._unchangedRegion.showMoreAbove(this._options.hideUnchangedRegionsRevealLineCount.get(), void 0), this._nodes.top.classList.toggle("dragging", !1), this._nodes.root.classList.toggle("dragging", !1), this._unchangedRegion.isDragged.set(void 0, void 0), v.dispose(), b.dispose();
      });
    })), this._register(K(this._nodes.bottom, "mousedown", (u) => {
      if (u.button !== 0) return;
      this._nodes.bottom.classList.toggle("dragging", !0), this._nodes.root.classList.toggle("dragging", !0), u.preventDefault();
      const g = u.clientY;
      let p = !1;
      const f = this._unchangedRegion.visibleLineCountBottom.get();
      this._unchangedRegion.isDragged.set("bottom", void 0);
      const _ = ke(this._nodes.bottom), v = K(_, "mousemove", (C) => {
        const w = C.clientY - g;
        p = p || Math.abs(w) > 2;
        const y = Math.round(w / c.getOption(67)), L = Math.max(0, Math.min(f - y, this._unchangedRegion.getMaxVisibleLineCountBottom())), k = this._unchangedRegionRange.endLineNumberExclusive > c.getModel().getLineCount() ? c.getContentHeight() : c.getTopForLineNumber(this._unchangedRegionRange.endLineNumberExclusive);
        this._unchangedRegion.visibleLineCountBottom.set(L, void 0);
        const N = this._unchangedRegionRange.endLineNumberExclusive > c.getModel().getLineCount() ? c.getContentHeight() : c.getTopForLineNumber(this._unchangedRegionRange.endLineNumberExclusive);
        c.setScrollTop(c.getScrollTop() + (N - k));
      }), b = K(_, "mouseup", (C) => {
        if (this._unchangedRegion.isDragged.set(void 0, void 0), !p) {
          const w = c.getTopForLineNumber(this._unchangedRegionRange.endLineNumberExclusive);
          this._unchangedRegion.showMoreBelow(this._options.hideUnchangedRegionsRevealLineCount.get(), void 0);
          const y = c.getTopForLineNumber(this._unchangedRegionRange.endLineNumberExclusive);
          c.setScrollTop(c.getScrollTop() + (y - w));
        }
        this._nodes.bottom.classList.toggle("dragging", !1), this._nodes.root.classList.toggle("dragging", !1), v.dispose(), b.dispose();
      });
    })), this._register(Ge((u) => {
      const g = [];
      if (!this._hide) {
        const p = m(0, "{0} hidden lines", n.getHiddenModifiedRange(u).length), f = Q("span", { title: m(0, "Double click to unfold") }, p);
        f.addEventListener("dblclick", (b) => {
          b.button === 0 && (b.preventDefault(), this._unchangedRegion.showAll(void 0));
        }), g.push(f);
        const _ = this._unchangedRegion.getHiddenModifiedRange(u), v = this._modifiedOutlineSource.getBreadcrumbItems(_, u);
        if (v.length > 0) {
          g.push(Q("span", void 0, "  |  "));
          for (let b = 0; b < v.length; b++) {
            const C = v[b], w = yt("div.breadcrumb-item", { style: { display: "flex", alignItems: "center" } }, [Dv(Ow.toIcon(C.kind)), " ", C.name, ...b === v.length - 1 ? [] : [Dv(ne.chevronRight)]]).root;
            g.push(w), w.onclick = () => {
              this._revealModifiedHiddenLine(C.startLineNumber);
            };
          }
        }
      }
      wn(this._nodes.others, ...g);
    }));
  }
}
var cr, Mne = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Tne = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let Ou = cr = class extends V {
  constructor(i, e, t, n, s, o, r) {
    super(), this._editors = i, this._rootElement = e, this._diffModel = t, this._rootWidth = n, this._rootHeight = s, this._modifiedEditorLayoutInfo = o, this._themeService = r, this.width = cr.ENTIRE_DIFF_OVERVIEW_WIDTH;
    const a = Rt(this._themeService.onDidColorThemeChange, () => this._themeService.getColorTheme()), l = Fe((c) => {
      const u = a.read(c);
      return { insertColor: u.getColor(x$) || (u.getColor(k$) || YE).transparent(2), removeColor: u.getColor(N$) || (u.getColor(D$) || XE).transparent(2) };
    }), d = wt(document.createElement("div"));
    d.setClassName("diffViewport"), d.setPosition("absolute");
    const h = yt("div.diffOverview", { style: { position: "absolute", top: "0px", width: cr.ENTIRE_DIFF_OVERVIEW_WIDTH + "px" } }).root;
    this._register(A_(h, d.domNode)), this._register(bi(h, ie.POINTER_DOWN, (c) => {
      this._editors.modified.delegateVerticalScrollbarPointerDown(c);
    })), this._register(K(h, ie.MOUSE_WHEEL, (c) => {
      this._editors.modified.delegateScrollFromMouseWheelEvent(c);
    }, { passive: !1 })), this._register(A_(this._rootElement, h)), this._register(nr((c, u) => {
      const g = this._diffModel.read(c), p = this._editors.original.createOverviewRuler("original diffOverviewRuler");
      p && (u.add(p), u.add(A_(h, p.getDomNode())));
      const f = this._editors.modified.createOverviewRuler("modified diffOverviewRuler");
      if (f && (u.add(f), u.add(A_(h, f.getDomNode()))), !p || !f) return;
      const _ = Hn("viewZoneChanged", this._editors.original.onDidChangeViewZones), v = Hn("viewZoneChanged", this._editors.modified.onDidChangeViewZones), b = Hn("hiddenRangesChanged", this._editors.original.onDidChangeHiddenAreas), C = Hn("hiddenRangesChanged", this._editors.modified.onDidChangeHiddenAreas);
      u.add(Ge((w) => {
        var y;
        _.read(w), v.read(w), b.read(w), C.read(w);
        const L = l.read(w), k = (y = g == null ? void 0 : g.diff.read(w)) === null || y === void 0 ? void 0 : y.mappings;
        function N(T, O, H) {
          const $ = H._getViewModel();
          return $ ? T.filter((pe) => pe.length > 0).map((pe) => {
            const me = $.coordinatesConverter.convertModelPositionToViewPosition(new W(pe.startLineNumber, 1)), ue = $.coordinatesConverter.convertModelPositionToViewPosition(new W(pe.endLineNumberExclusive, 1)), ee = ue.lineNumber - me.lineNumber;
            return new $B(me.lineNumber, ue.lineNumber, ee, O.toString());
          }) : [];
        }
        const A = N((k || []).map((T) => T.lineRangeMapping.original), L.removeColor, this._editors.original), B = N((k || []).map((T) => T.lineRangeMapping.modified), L.insertColor, this._editors.modified);
        p == null || p.setZones(A), f == null || f.setZones(B);
      })), u.add(Ge((w) => {
        const y = this._rootHeight.read(w), L = this._rootWidth.read(w), k = this._modifiedEditorLayoutInfo.read(w);
        if (k) {
          const N = cr.ENTIRE_DIFF_OVERVIEW_WIDTH - 2 * cr.ONE_OVERVIEW_WIDTH;
          p.setLayout({ top: 0, height: y, right: N + cr.ONE_OVERVIEW_WIDTH, width: cr.ONE_OVERVIEW_WIDTH }), f.setLayout({ top: 0, height: y, right: 0, width: cr.ONE_OVERVIEW_WIDTH });
          const A = this._editors.modifiedScrollTop.read(w), B = this._editors.modifiedScrollHeight.read(w), T = this._editors.modified.getOption(103), O = new qm(T.verticalHasArrows ? T.arrowSize : 0, T.verticalScrollbarSize, 0, k.height, B, A);
          d.setTop(O.getSliderPosition()), d.setHeight(O.getSliderSize());
        } else d.setTop(0), d.setHeight(0);
        h.style.height = y + "px", h.style.left = L - cr.ENTIRE_DIFF_OVERVIEW_WIDTH + "px", d.setWidth(cr.ENTIRE_DIFF_OVERVIEW_WIDTH);
      }));
    }));
  }
};
Ou.ONE_OVERVIEW_WIDTH = 15, Ou.ENTIRE_DIFF_OVERVIEW_WIDTH = 2 * cr.ONE_OVERVIEW_WIDTH, Ou = cr = Mne([Tne(6, Yi)], Ou);
const cx = [];
class Rne extends V {
  constructor(e, t, n, s) {
    super(), this._editors = e, this._diffModel = t, this._options = n, this._widget = s, this._selectedDiffs = Fe(this, (o) => {
      const r = this._diffModel.read(o), a = r == null ? void 0 : r.diff.read(o);
      if (!a) return cx;
      const l = this._editors.modifiedSelections.read(o);
      if (l.every((c) => c.isEmpty())) return cx;
      const d = new Uo(l.map((c) => je.fromRangeInclusive(c))), h = a.mappings.filter((c) => c.lineRangeMapping.innerChanges && d.intersects(c.lineRangeMapping.modified)).map((c) => ({ mapping: c, rangeMappings: c.lineRangeMapping.innerChanges.filter((u) => l.some((g) => D.areIntersecting(u.modifiedRange, g))) }));
      return h.length === 0 || h.every((c) => c.rangeMappings.length === 0) ? cx : h;
    }), this._register(nr((o, r) => {
      if (!this._options.shouldRenderOldRevertArrows.read(o)) return;
      const a = this._diffModel.read(o), l = a == null ? void 0 : a.diff.read(o);
      if (!a || !l || a.movedTextToCompare.read(o)) return;
      const d = [], h = this._selectedDiffs.read(o), c = new Set(h.map((u) => u.mapping));
      if (h.length > 0) {
        const u = this._editors.modifiedSelections.read(o), g = r.add(new qv(u[u.length - 1].positionLineNumber, this._widget, h.flatMap((p) => p.rangeMappings), !0));
        this._editors.modified.addGlyphMarginWidget(g), d.push(g);
      }
      for (const u of l.mappings) if (!c.has(u) && !u.lineRangeMapping.modified.isEmpty && u.lineRangeMapping.innerChanges) {
        const g = r.add(new qv(u.lineRangeMapping.modified.startLineNumber, this._widget, u.lineRangeMapping, !1));
        this._editors.modified.addGlyphMarginWidget(g), d.push(g);
      }
      r.add(ye(() => {
        for (const u of d) this._editors.modified.removeGlyphMarginWidget(u);
      }));
    }));
  }
}
class qv extends V {
  getId() {
    return this._id;
  }
  constructor(e, t, n, s) {
    super(), this._lineNumber = e, this._widget = t, this._diffs = n, this._revertSelection = s, this._id = "revertButton" + qv.counter++, this._domNode = yt("div.revertButton", { title: this._revertSelection ? m(0, "Revert Selected Changes") : m(0, "Revert Change") }, [Dv(ne.arrowRight)]).root, this._register(K(this._domNode, ie.MOUSE_DOWN, (o) => {
      o.button !== 2 && (o.stopPropagation(), o.preventDefault());
    })), this._register(K(this._domNode, ie.MOUSE_UP, (o) => {
      o.stopPropagation(), o.preventDefault();
    })), this._register(K(this._domNode, ie.CLICK, (o) => {
      this._diffs instanceof us ? this._widget.revert(this._diffs) : this._widget.revertRangeMappings(this._diffs), o.stopPropagation(), o.preventDefault();
    }));
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return { lane: _l.Right, range: { startColumn: 1, startLineNumber: this._lineNumber, endColumn: 1, endLineNumber: this._lineNumber }, zIndex: 10001 };
  }
}
qv.counter = 0;
var Ane = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, WF = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let j2 = class extends V {
  get onDidContentSizeChange() {
    return this._onDidContentSizeChange.event;
  }
  constructor(i, e, t, n, s, o, r) {
    super(), this.originalEditorElement = i, this.modifiedEditorElement = e, this._options = t, this._argCodeEditorWidgetOptions = n, this._createInnerEditor = s, this._instantiationService = o, this._keybindingService = r, this.original = this._register(this._createLeftHandSideEditor(this._options.editorOptions.get(), this._argCodeEditorWidgetOptions.originalEditor || {})), this.modified = this._register(this._createRightHandSideEditor(this._options.editorOptions.get(), this._argCodeEditorWidgetOptions.modifiedEditor || {})), this._onDidContentSizeChange = this._register(new F()), this.modifiedScrollTop = Rt(this.modified.onDidScrollChange, () => this.modified.getScrollTop()), this.modifiedScrollHeight = Rt(this.modified.onDidScrollChange, () => this.modified.getScrollHeight()), this.modifiedModel = Rt(this.modified.onDidChangeModel, () => this.modified.getModel()), this.modifiedSelections = Rt(this.modified.onDidChangeCursorSelection, () => {
      var a;
      return (a = this.modified.getSelections()) !== null && a !== void 0 ? a : [];
    }), this.modifiedCursor = _m({ owner: this, equalityComparer: W.equals }, (a) => {
      var l, d;
      return (d = (l = this.modifiedSelections.read(a)[0]) === null || l === void 0 ? void 0 : l.getPosition()) !== null && d !== void 0 ? d : new W(1, 1);
    }), this.originalCursor = Rt(this.original.onDidChangeCursorPosition, () => {
      var a;
      return (a = this.original.getPosition()) !== null && a !== void 0 ? a : new W(1, 1);
    }), this._argCodeEditorWidgetOptions = null, this._register(O1({ createEmptyChangeSummary: () => ({}), handleChange: (a, l) => (a.didChange(t.editorOptions) && Object.assign(l, a.change.changedOptions), !0) }, (a, l) => {
      t.editorOptions.read(a), this._options.renderSideBySide.read(a), this.modified.updateOptions(this._adjustOptionsForRightHandSide(a, l)), this.original.updateOptions(this._adjustOptionsForLeftHandSide(a, l));
    }));
  }
  _createLeftHandSideEditor(i, e) {
    const t = this._adjustOptionsForLeftHandSide(void 0, i), n = this._constructInnerEditor(this._instantiationService, this.originalEditorElement, t, e);
    return n.setContextValue("isInDiffLeftEditor", !0), n;
  }
  _createRightHandSideEditor(i, e) {
    const t = this._adjustOptionsForRightHandSide(void 0, i), n = this._constructInnerEditor(this._instantiationService, this.modifiedEditorElement, t, e);
    return n.setContextValue("isInDiffRightEditor", !0), n;
  }
  _constructInnerEditor(i, e, t, n) {
    const s = this._createInnerEditor(i, e, t, n);
    return this._register(s.onDidContentSizeChange((o) => {
      const r = this.original.getContentWidth() + this.modified.getContentWidth() + Ou.ENTIRE_DIFF_OVERVIEW_WIDTH, a = Math.max(this.modified.getContentHeight(), this.original.getContentHeight());
      this._onDidContentSizeChange.fire({ contentHeight: a, contentWidth: r, contentHeightChanged: o.contentHeightChanged, contentWidthChanged: o.contentWidthChanged });
    })), s;
  }
  _adjustOptionsForLeftHandSide(i, e) {
    const t = this._adjustOptionsForSubEditor(e);
    return this._options.renderSideBySide.get() ? (t.unicodeHighlight = this._options.editorOptions.get().unicodeHighlight || {}, t.wordWrapOverride1 = this._options.diffWordWrap.get()) : (t.wordWrapOverride1 = "off", t.wordWrapOverride2 = "off", t.stickyScroll = { enabled: !1 }, t.unicodeHighlight = { nonBasicASCII: !1, ambiguousCharacters: !1, invisibleCharacters: !1 }), t.glyphMargin = this._options.renderSideBySide.get(), e.originalAriaLabel && (t.ariaLabel = e.originalAriaLabel), t.ariaLabel = this._updateAriaLabel(t.ariaLabel), t.readOnly = !this._options.originalEditable.get(), t.dropIntoEditor = { enabled: !t.readOnly }, t.extraEditorClassName = "original-in-monaco-diff-editor", t;
  }
  _adjustOptionsForRightHandSide(i, e) {
    const t = this._adjustOptionsForSubEditor(e);
    return e.modifiedAriaLabel && (t.ariaLabel = e.modifiedAriaLabel), t.ariaLabel = this._updateAriaLabel(t.ariaLabel), t.wordWrapOverride1 = this._options.diffWordWrap.get(), t.revealHorizontalRightPadding = ta.revealHorizontalRightPadding.defaultValue + Ou.ENTIRE_DIFF_OVERVIEW_WIDTH, t.scrollbar.verticalHasArrows = !1, t.extraEditorClassName = "modified-in-monaco-diff-editor", t;
  }
  _adjustOptionsForSubEditor(i) {
    const e = { ...i, dimension: { height: 0, width: 0 } };
    return e.inDiffEditor = !0, e.automaticLayout = !1, e.scrollbar = { ...e.scrollbar || {} }, e.folding = !1, e.codeLens = this._options.diffCodeLens.get(), e.fixedOverflowWidgets = !0, e.minimap = { ...e.minimap || {} }, e.minimap.enabled = !1, this._options.hideUnchangedRegions.get() ? e.stickyScroll = { enabled: !1 } : e.stickyScroll = this._options.editorOptions.get().stickyScroll, e;
  }
  _updateAriaLabel(i) {
    var e;
    i || (i = "");
    const t = m(0, " use {0} to open the accessibility help.", (e = this._keybindingService.lookupKeybinding("editor.action.accessibilityHelp")) === null || e === void 0 ? void 0 : e.getAriaLabel());
    return this._options.accessibilityVerbose.get() ? i + t : i ? i.replaceAll(t, "") : "";
  }
};
j2 = Ane([WF(5, Se), WF(6, Dt)], j2);
class KL extends V {
  constructor() {
    super(...arguments), this._id = ++KL.idCounter, this._onDidDispose = this._register(new F()), this.onDidDispose = this._onDidDispose.event;
  }
  getId() {
    return this.getEditorType() + ":v2:" + this._id;
  }
  getVisibleColumnFromPosition(e) {
    return this._targetEditor.getVisibleColumnFromPosition(e);
  }
  getPosition() {
    return this._targetEditor.getPosition();
  }
  setPosition(e, t = "api") {
    this._targetEditor.setPosition(e, t);
  }
  revealLine(e, t = 0) {
    this._targetEditor.revealLine(e, t);
  }
  revealLineInCenter(e, t = 0) {
    this._targetEditor.revealLineInCenter(e, t);
  }
  revealLineInCenterIfOutsideViewport(e, t = 0) {
    this._targetEditor.revealLineInCenterIfOutsideViewport(e, t);
  }
  revealLineNearTop(e, t = 0) {
    this._targetEditor.revealLineNearTop(e, t);
  }
  revealPosition(e, t = 0) {
    this._targetEditor.revealPosition(e, t);
  }
  revealPositionInCenter(e, t = 0) {
    this._targetEditor.revealPositionInCenter(e, t);
  }
  revealPositionInCenterIfOutsideViewport(e, t = 0) {
    this._targetEditor.revealPositionInCenterIfOutsideViewport(e, t);
  }
  revealPositionNearTop(e, t = 0) {
    this._targetEditor.revealPositionNearTop(e, t);
  }
  getSelection() {
    return this._targetEditor.getSelection();
  }
  getSelections() {
    return this._targetEditor.getSelections();
  }
  setSelection(e, t = "api") {
    this._targetEditor.setSelection(e, t);
  }
  setSelections(e, t = "api") {
    this._targetEditor.setSelections(e, t);
  }
  revealLines(e, t, n = 0) {
    this._targetEditor.revealLines(e, t, n);
  }
  revealLinesInCenter(e, t, n = 0) {
    this._targetEditor.revealLinesInCenter(e, t, n);
  }
  revealLinesInCenterIfOutsideViewport(e, t, n = 0) {
    this._targetEditor.revealLinesInCenterIfOutsideViewport(e, t, n);
  }
  revealLinesNearTop(e, t, n = 0) {
    this._targetEditor.revealLinesNearTop(e, t, n);
  }
  revealRange(e, t = 0, n = !1, s = !0) {
    this._targetEditor.revealRange(e, t, n, s);
  }
  revealRangeInCenter(e, t = 0) {
    this._targetEditor.revealRangeInCenter(e, t);
  }
  revealRangeInCenterIfOutsideViewport(e, t = 0) {
    this._targetEditor.revealRangeInCenterIfOutsideViewport(e, t);
  }
  revealRangeNearTop(e, t = 0) {
    this._targetEditor.revealRangeNearTop(e, t);
  }
  revealRangeNearTopIfOutsideViewport(e, t = 0) {
    this._targetEditor.revealRangeNearTopIfOutsideViewport(e, t);
  }
  revealRangeAtTop(e, t = 0) {
    this._targetEditor.revealRangeAtTop(e, t);
  }
  getSupportedActions() {
    return this._targetEditor.getSupportedActions();
  }
  focus() {
    this._targetEditor.focus();
  }
  trigger(e, t, n) {
    this._targetEditor.trigger(e, t, n);
  }
  createDecorationsCollection(e) {
    return this._targetEditor.createDecorationsCollection(e);
  }
  changeDecorations(e) {
    return this._targetEditor.changeDecorations(e);
  }
}
KL.idCounter = 0;
var Pne = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, One = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let q2 = class {
  get editorOptions() {
    return this._options;
  }
  constructor(i, e) {
    this._accessibilityService = e, this._diffEditorWidth = lt(this, 0), this._screenReaderMode = Rt(this._accessibilityService.onDidChangeScreenReaderOptimized, () => this._accessibilityService.isScreenReaderOptimized()), this.couldShowInlineViewBecauseOfSize = Fe(this, (n) => this._options.read(n).renderSideBySide && this._diffEditorWidth.read(n) <= this._options.read(n).renderSideBySideInlineBreakpoint), this.renderOverviewRuler = Fe(this, (n) => this._options.read(n).renderOverviewRuler), this.renderSideBySide = Fe(this, (n) => this._options.read(n).renderSideBySide && !(this._options.read(n).useInlineViewWhenSpaceIsLimited && this.couldShowInlineViewBecauseOfSize.read(n) && !this._screenReaderMode.read(n))), this.readOnly = Fe(this, (n) => this._options.read(n).readOnly), this.shouldRenderOldRevertArrows = Fe(this, (n) => !!this._options.read(n).renderMarginRevertIcon && !!this.renderSideBySide.read(n) && !this.readOnly.read(n) && !this.shouldRenderGutterMenu.read(n)), this.shouldRenderGutterMenu = Fe(this, (n) => this._options.read(n).renderGutterMenu), this.renderIndicators = Fe(this, (n) => this._options.read(n).renderIndicators), this.enableSplitViewResizing = Fe(this, (n) => this._options.read(n).enableSplitViewResizing), this.splitViewDefaultRatio = Fe(this, (n) => this._options.read(n).splitViewDefaultRatio), this.ignoreTrimWhitespace = Fe(this, (n) => this._options.read(n).ignoreTrimWhitespace), this.maxComputationTimeMs = Fe(this, (n) => this._options.read(n).maxComputationTime), this.showMoves = Fe(this, (n) => this._options.read(n).experimental.showMoves && this.renderSideBySide.read(n)), this.isInEmbeddedEditor = Fe(this, (n) => this._options.read(n).isInEmbeddedEditor), this.diffWordWrap = Fe(this, (n) => this._options.read(n).diffWordWrap), this.originalEditable = Fe(this, (n) => this._options.read(n).originalEditable), this.diffCodeLens = Fe(this, (n) => this._options.read(n).diffCodeLens), this.accessibilityVerbose = Fe(this, (n) => this._options.read(n).accessibilityVerbose), this.diffAlgorithm = Fe(this, (n) => this._options.read(n).diffAlgorithm), this.showEmptyDecorations = Fe(this, (n) => this._options.read(n).experimental.showEmptyDecorations), this.onlyShowAccessibleDiffViewer = Fe(this, (n) => this._options.read(n).onlyShowAccessibleDiffViewer), this.hideUnchangedRegions = Fe(this, (n) => this._options.read(n).hideUnchangedRegions.enabled), this.hideUnchangedRegionsRevealLineCount = Fe(this, (n) => this._options.read(n).hideUnchangedRegions.revealLineCount), this.hideUnchangedRegionsContextLineCount = Fe(this, (n) => this._options.read(n).hideUnchangedRegions.contextLineCount), this.hideUnchangedRegionsMinimumLineCount = Fe(this, (n) => this._options.read(n).hideUnchangedRegions.minimumLineCount);
    const t = { ...i, ...VF(i, An) };
    this._options = lt(this, t);
  }
  updateOptions(i) {
    const e = VF(i, this._options.get()), t = { ...this._options.get(), ...i, ...e };
    this._options.set(t, void 0, { changedOptions: i });
  }
  setWidth(i) {
    this._diffEditorWidth.set(i, void 0);
  }
};
function VF(i, e) {
  var t, n, s, o, r, a, l, d;
  return { enableSplitViewResizing: ve(i.enableSplitViewResizing, e.enableSplitViewResizing), splitViewDefaultRatio: nK(i.splitViewDefaultRatio, 0.5, 0.1, 0.9), renderSideBySide: ve(i.renderSideBySide, e.renderSideBySide), renderMarginRevertIcon: ve(i.renderMarginRevertIcon, e.renderMarginRevertIcon), maxComputationTime: nu(i.maxComputationTime, e.maxComputationTime, 0, 1073741824), maxFileSize: nu(i.maxFileSize, e.maxFileSize, 0, 1073741824), ignoreTrimWhitespace: ve(i.ignoreTrimWhitespace, e.ignoreTrimWhitespace), renderIndicators: ve(i.renderIndicators, e.renderIndicators), originalEditable: ve(i.originalEditable, e.originalEditable), diffCodeLens: ve(i.diffCodeLens, e.diffCodeLens), renderOverviewRuler: ve(i.renderOverviewRuler, e.renderOverviewRuler), diffWordWrap: _i(i.diffWordWrap, e.diffWordWrap, ["off", "on", "inherit"]), diffAlgorithm: _i(i.diffAlgorithm, e.diffAlgorithm, ["legacy", "advanced"], { smart: "legacy", experimental: "advanced" }), accessibilityVerbose: ve(i.accessibilityVerbose, e.accessibilityVerbose), experimental: { showMoves: ve((t = i.experimental) === null || t === void 0 ? void 0 : t.showMoves, e.experimental.showMoves), showEmptyDecorations: ve((n = i.experimental) === null || n === void 0 ? void 0 : n.showEmptyDecorations, e.experimental.showEmptyDecorations) }, hideUnchangedRegions: { enabled: ve((o = (s = i.hideUnchangedRegions) === null || s === void 0 ? void 0 : s.enabled) !== null && o !== void 0 ? o : (r = i.experimental) === null || r === void 0 ? void 0 : r.collapseUnchangedRegions, e.hideUnchangedRegions.enabled), contextLineCount: nu((a = i.hideUnchangedRegions) === null || a === void 0 ? void 0 : a.contextLineCount, e.hideUnchangedRegions.contextLineCount, 0, 1073741824), minimumLineCount: nu((l = i.hideUnchangedRegions) === null || l === void 0 ? void 0 : l.minimumLineCount, e.hideUnchangedRegions.minimumLineCount, 0, 1073741824), revealLineCount: nu((d = i.hideUnchangedRegions) === null || d === void 0 ? void 0 : d.revealLineCount, e.hideUnchangedRegions.revealLineCount, 0, 1073741824) }, isInEmbeddedEditor: ve(i.isInEmbeddedEditor, e.isInEmbeddedEditor), onlyShowAccessibleDiffViewer: ve(i.onlyShowAccessibleDiffViewer, e.onlyShowAccessibleDiffViewer), renderSideBySideInlineBreakpoint: nu(i.renderSideBySideInlineBreakpoint, e.renderSideBySideInlineBreakpoint, 0, 1073741824), useInlineViewWhenSpaceIsLimited: ve(i.useInlineViewWhenSpaceIsLimited, e.useInlineViewWhenSpaceIsLimited), renderGutterMenu: ve(i.renderGutterMenu, e.renderGutterMenu) };
}
q2 = Pne([One(1, or)], q2);
class Fne extends V {
  constructor(e, t, n) {
    super(), this._editor = e, this._domNode = t, this.itemProvider = n, this.scrollTop = Rt(this._editor.onDidScrollChange, (r) => this._editor.getScrollTop()), this.isScrollTopZero = this.scrollTop.map((r) => r === 0), this.modelAttached = Rt(this._editor.onDidChangeModel, (r) => this._editor.hasModel()), this.editorOnDidChangeViewZones = Hn("onDidChangeViewZones", this._editor.onDidChangeViewZones), this.editorOnDidContentSizeChange = Hn("onDidContentSizeChange", this._editor.onDidContentSizeChange), this.domNodeSizeChanged = NL("domNodeSizeChanged"), this.views = /* @__PURE__ */ new Map(), this._domNode.className = "gutter monaco-editor";
    const s = this._domNode.appendChild(yt("div.scroll-decoration", { role: "presentation", ariaHidden: "true", style: { width: "100%" } }).root), o = new ResizeObserver(() => {
      Tt((r) => {
        this.domNodeSizeChanged.trigger(r);
      });
    });
    o.observe(this._domNode), this._register(ye(() => o.disconnect())), this._register(Ge((r) => {
      s.className = this.isScrollTopZero.read(r) ? "" : "scroll-decoration";
    })), this._register(Ge((r) => this.render(r)));
  }
  dispose() {
    super.dispose(), wn(this._domNode);
  }
  render(e) {
    if (!this.modelAttached.read(e)) return;
    this.domNodeSizeChanged.read(e), this.editorOnDidChangeViewZones.read(e), this.editorOnDidContentSizeChange.read(e);
    const t = this.scrollTop.read(e), n = this._editor.getVisibleRanges(), s = new Set(this.views.keys()), o = qe.ofStartAndLength(0, this._domNode.clientHeight);
    if (!o.isEmpty) for (const r of n) {
      const a = new je(r.startLineNumber, r.endLineNumber + 1), l = this.itemProvider.getIntersectingGutterItems(a, e);
      Tt((d) => {
        for (const h of l) {
          if (!h.range.intersect(a)) continue;
          s.delete(h.id);
          let c = this.views.get(h.id);
          if (c) c.item.set(h, d);
          else {
            const p = document.createElement("div");
            this._domNode.appendChild(p);
            const f = lt("item", h), _ = this.itemProvider.createView(f, p);
            c = new Bne(f, _, p), this.views.set(h.id, c);
          }
          const u = h.range.startLineNumber <= this._editor.getModel().getLineCount() ? this._editor.getTopForLineNumber(h.range.startLineNumber, !0) - t : this._editor.getBottomForLineNumber(h.range.startLineNumber - 1, !1) - t, g = (h.range.isEmpty ? u : this._editor.getBottomForLineNumber(h.range.endLineNumberExclusive - 1, !0) - t) - u;
          c.domNode.style.top = `${u}px`, c.domNode.style.height = `${g}px`, c.gutterItemView.layout(qe.ofStartAndLength(u, g), o);
        }
      });
    }
    for (const r of s) {
      const a = this.views.get(r);
      a.gutterItemView.dispose(), this._domNode.removeChild(a.domNode), this.views.delete(r);
    }
  }
}
class Bne {
  constructor(e, t, n) {
    this.item = e, this.gutterItemView = t, this.domNode = n;
  }
}
class qV extends hg {
  constructor(e) {
    super(), this._getContext = e;
  }
  runAction(e, t) {
    const n = this._getContext();
    return super.runAction(e, n);
  }
}
class Wne {
  constructor(e) {
    this.text = e, this.lineStartOffsetByLineIdx = [], this.lineStartOffsetByLineIdx.push(0);
    for (let t = 0; t < e.length; t++) e.charAt(t) === `
` && this.lineStartOffsetByLineIdx.push(t + 1);
  }
  getOffset(e) {
    return this.lineStartOffsetByLineIdx[e.lineNumber - 1] + e.column - 1;
  }
  getOffsetRange(e) {
    return new qe(this.getOffset(e.getStartPosition()), this.getOffset(e.getEndPosition()));
  }
  get textLength() {
    const e = this.lineStartOffsetByLineIdx.length - 1;
    return new kr(e, this.text.length - this.lineStartOffsetByLineIdx[e]);
  }
}
class tP {
  constructor(e) {
    this.edits = e, cg(() => CR(e, (t, n) => t.range.getEndPosition().isBeforeOrEqual(n.range.getStartPosition())));
  }
  apply(e) {
    let t = "", n = new W(1, 1);
    for (const o of this.edits) {
      const r = o.range, a = r.getStartPosition(), l = r.getEndPosition(), d = HF(n, a);
      d.isEmpty() || (t += e.getValueOfRange(d)), t += o.text, n = l;
    }
    const s = HF(n, e.endPositionExclusive);
    return s.isEmpty() || (t += e.getValueOfRange(s)), t;
  }
  applyToString(e) {
    const t = new Vne(e);
    return this.apply(t);
  }
  getNewRanges() {
    const e = [];
    let t = 0, n = 0, s = 0;
    for (const o of this.edits) {
      const r = kr.ofText(o.text), a = W.lift({ lineNumber: o.range.startLineNumber + n, column: o.range.startColumn + (o.range.startLineNumber === t ? s : 0) }), l = r.createRange(a);
      e.push(l), n = l.endLineNumber - o.range.endLineNumber, s = l.endColumn - o.range.endColumn, t = o.range.endLineNumber;
    }
    return e;
  }
}
class Bd {
  constructor(e, t) {
    this.range = e, this.text = t;
  }
}
function HF(i, e) {
  if (!i.isBeforeOrEqual(e)) throw new Kt("start must be before end");
  return new D(i.lineNumber, i.column, e.lineNumber, e.column);
}
class $V {
  get endPositionExclusive() {
    return this.length.addToPosition(new W(1, 1));
  }
}
class Vne extends $V {
  constructor(e) {
    super(), this.value = e, this._t = new Wne(this.value);
  }
  getValueOfRange(e) {
    return this._t.getOffsetRange(e).substring(this.value);
  }
  get length() {
    return this._t.textLength;
  }
}
class Hne extends $V {
  constructor(e) {
    super(), this._textModel = e;
  }
  getValueOfRange(e) {
    return this._textModel.getValueInRange(e);
  }
  get length() {
    const e = this._textModel.getLineCount(), t = this._textModel.getLineLength(e);
    return new kr(e - 1, t);
  }
}
class zne extends V {
  constructor(e, t, n = { orientation: 0 }) {
    var s;
    super(), this.submenuActionViewItems = [], this.hasSecondaryActions = !1, this._onDidChangeDropdownVisibility = this._register(new hK()), this.onDidChangeDropdownVisibility = this._onDidChangeDropdownVisibility.event, this.disposables = this._register(new G()), n.hoverDelegate = (s = n.hoverDelegate) !== null && s !== void 0 ? s : this._register(Xm()), this.options = n, this.lookupKeybindings = typeof this.options.getKeyBinding == "function", this.toggleMenuAction = this._register(new $v(() => {
      var o;
      return (o = this.toggleMenuActionViewItem) === null || o === void 0 ? void 0 : o.show();
    }, n.toggleMenuTitle)), this.element = document.createElement("div"), this.element.className = "monaco-toolbar", e.appendChild(this.element), this.actionBar = this._register(new sr(this.element, { orientation: n.orientation, ariaLabel: n.ariaLabel, actionRunner: n.actionRunner, allowContextMenu: n.allowContextMenu, highlightToggledItems: n.highlightToggledItems, hoverDelegate: n.hoverDelegate, actionViewItemProvider: (o, r) => {
      var a;
      if (o.id === $v.ID) return this.toggleMenuActionViewItem = new Fy(o, o.menuActions, t, { actionViewItemProvider: this.options.actionViewItemProvider, actionRunner: this.actionRunner, keybindingProvider: this.options.getKeyBinding, classNames: Ee.asClassNameArray((a = n.moreIcon) !== null && a !== void 0 ? a : ne.toolBarMore), anchorAlignmentProvider: this.options.anchorAlignmentProvider, menuAsChild: !!this.options.renderDropdownAsChildElement, skipTelemetry: this.options.skipTelemetry, isMenu: !0, hoverDelegate: this.options.hoverDelegate }), this.toggleMenuActionViewItem.setActionContext(this.actionBar.context), this.disposables.add(this._onDidChangeDropdownVisibility.add(this.toggleMenuActionViewItem.onDidChangeVisibility)), this.toggleMenuActionViewItem;
      if (n.actionViewItemProvider) {
        const l = n.actionViewItemProvider(o, r);
        if (l) return l;
      }
      if (o instanceof Bm) {
        const l = new Fy(o, o.actions, t, { actionViewItemProvider: this.options.actionViewItemProvider, actionRunner: this.actionRunner, keybindingProvider: this.options.getKeyBinding, classNames: o.class, anchorAlignmentProvider: this.options.anchorAlignmentProvider, menuAsChild: !!this.options.renderDropdownAsChildElement, skipTelemetry: this.options.skipTelemetry, hoverDelegate: this.options.hoverDelegate });
        return l.setActionContext(this.actionBar.context), this.submenuActionViewItems.push(l), this.disposables.add(this._onDidChangeDropdownVisibility.add(l.onDidChangeVisibility)), l;
      }
    } }));
  }
  set actionRunner(e) {
    this.actionBar.actionRunner = e;
  }
  get actionRunner() {
    return this.actionBar.actionRunner;
  }
  getElement() {
    return this.element;
  }
  getItemAction(e) {
    return this.actionBar.getAction(e);
  }
  setActions(e, t) {
    this.clear();
    const n = e ? e.slice(0) : [];
    this.hasSecondaryActions = !!(t && t.length > 0), this.hasSecondaryActions && t && (this.toggleMenuAction.menuActions = t.slice(0), n.push(this.toggleMenuAction)), n.forEach((s) => {
      this.actionBar.push(s, { icon: !0, label: !1, keybinding: this.getKeybindingLabel(s) });
    });
  }
  getKeybindingLabel(e) {
    var t, n, s;
    const o = this.lookupKeybindings ? (n = (t = this.options).getKeyBinding) === null || n === void 0 ? void 0 : n.call(t, e) : void 0;
    return (s = o == null ? void 0 : o.getLabel()) !== null && s !== void 0 ? s : void 0;
  }
  clear() {
    this.submenuActionViewItems = [], this.disposables.clear(), this.actionBar.clear();
  }
  dispose() {
    this.clear(), this.disposables.dispose(), super.dispose();
  }
}
class $v extends Qs {
  constructor(e, t) {
    t = t || m(0, "More Actions..."), super($v.ID, t, void 0, !0), this._menuActions = [], this.toggleDropdownMenu = e;
  }
  async run() {
    this.toggleDropdownMenu();
  }
  get menuActions() {
    return this._menuActions;
  }
  set menuActions(e) {
    this._menuActions = e;
  }
}
$v.ID = "toolbar.toggle.more";
var GV = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, el = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let Gv = class extends zne {
  constructor(i, e, t, n, s, o, r) {
    super(i, s, { getKeyBinding: (l) => {
      var d;
      return (d = o.lookupKeybinding(l.id)) !== null && d !== void 0 ? d : void 0;
    }, ...e, allowContextMenu: !0, skipTelemetry: typeof (e == null ? void 0 : e.telemetrySource) == "string" }), this._options = e, this._menuService = t, this._contextKeyService = n, this._contextMenuService = s, this._sessionDisposables = this._store.add(new G());
    const a = e == null ? void 0 : e.telemetrySource;
    a && this._store.add(this.actionBar.onDidRun((l) => r.publicLog2("workbenchActionExecuted", { id: l.action.id, from: a })));
  }
  setActions(i, e = [], t) {
    var n, s, o;
    this._sessionDisposables.clear();
    const r = i.slice(), a = e.slice(), l = [];
    let d = 0;
    const h = [];
    let c = !1;
    if (((n = this._options) === null || n === void 0 ? void 0 : n.hiddenItemStrategy) !== -1) for (let u = 0; u < r.length; u++) {
      const g = r[u];
      (g instanceof Eo || g instanceof iv) && g.hideActions && (l.push(g.hideActions.toggle), g.hideActions.toggle.checked && d++, g.hideActions.isHidden && (c = !0, r[u] = void 0, ((s = this._options) === null || s === void 0 ? void 0 : s.hiddenItemStrategy) !== 0 && (h[u] = g)));
    }
    if (((o = this._options) === null || o === void 0 ? void 0 : o.overflowBehavior) !== void 0) {
      const u = function(f, _) {
        const v = /* @__PURE__ */ new Set();
        for (const b of _) f.has(b) && v.add(b);
        return v;
      }(new Set(this._options.overflowBehavior.exempted), at.map(r, (f) => f == null ? void 0 : f.id)), g = this._options.overflowBehavior.maxItems - u.size;
      let p = 0;
      for (let f = 0; f < r.length; f++) {
        const _ = r[f];
        _ && (p++, u.has(_.id) || p >= g && (r[f] = void 0, h[f] = _));
      }
    }
    ZP(r), ZP(h), super.setActions(r, Ui.join(h, a)), l.length > 0 && this._sessionDisposables.add(K(this.getElement(), "contextmenu", (u) => {
      var g, p, f, _, v;
      const b = new _r(ke(this.getElement()), u), C = this.getItemAction(b.target);
      if (!C) return;
      b.preventDefault(), b.stopPropagation();
      let w, y = !1;
      if (d === 1 && ((g = this._options) === null || g === void 0 ? void 0 : g.hiddenItemStrategy) === 0) {
        y = !0;
        for (let k = 0; k < l.length; k++) if (l[k].checked) {
          l[k] = Qp({ id: C.id, label: C.label, checked: !0, enabled: !1, run() {
          } });
          break;
        }
      }
      if (!y && (C instanceof Eo || C instanceof iv)) {
        if (!C.hideActions) return;
        w = C.hideActions.hide;
      } else w = Qp({ id: "label", label: m(0, "Hide"), enabled: !1, run() {
      } });
      const L = Ui.join([w], l);
      !((p = this._options) === null || p === void 0) && p.resetMenu && !t && (t = [this._options.resetMenu]), c && t && (L.push(new Ui()), L.push(Qp({ id: "resetThisMenu", label: m(0, "Reset Menu"), run: () => this._menuService.resetHiddenStates(t) }))), this._contextMenuService.showContextMenu({ getAnchor: () => b, getActions: () => L, menuId: (f = this._options) === null || f === void 0 ? void 0 : f.contextMenu, menuActionOptions: { renderShortTitle: !0, ...(_ = this._options) === null || _ === void 0 ? void 0 : _.menuOptions }, skipTelemetry: typeof ((v = this._options) === null || v === void 0 ? void 0 : v.telemetrySource) == "string", contextKeyService: this._contextKeyService });
    }));
  }
};
Gv = GV([el(2, Mo), el(3, Te), el(4, io), el(5, Dt), el(6, es)], Gv);
let rS = class extends Gv {
  constructor(i, e, t, n, s, o, r, a) {
    super(i, { resetMenu: e, ...t }, n, s, o, r, a), this._onDidChangeMenuItems = this._store.add(new F()), this.onDidChangeMenuItems = this._onDidChangeMenuItems.event;
    const l = this._store.add(n.createMenu(e, s, { emitEventsForSubmenuChanges: !0 })), d = () => {
      var h, c, u;
      const g = [], p = [];
      ML(l, t == null ? void 0 : t.menuOptions, { primary: g, secondary: p }, (h = t == null ? void 0 : t.toolbarOptions) === null || h === void 0 ? void 0 : h.primaryGroup, (c = t == null ? void 0 : t.toolbarOptions) === null || c === void 0 ? void 0 : c.shouldInlineSubmenu, (u = t == null ? void 0 : t.toolbarOptions) === null || u === void 0 ? void 0 : u.useSeparatorsInPrimaryActions), i.classList.toggle("has-no-actions", g.length === 0 && p.length === 0), super.setActions(g, p);
    };
    this._store.add(l.onDidChange(() => {
      d(), this._onDidChangeMenuItems.fire(this);
    })), d();
  }
  setActions() {
    throw new Kt("This toolbar is populated from a menu.");
  }
};
rS = GV([el(3, Mo), el(4, Te), el(5, io), el(6, Dt), el(7, es)], rS);
var ZV = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, aw = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const ux = [];
let $2 = class extends V {
  constructor(i, e, t, n, s, o) {
    var r, a;
    super(), this._diffModel = e, this._editors = t, this._instantiationService = n, this._contextKeyService = s, this._menuService = o, this._menu = this._register(this._menuService.createMenu(x.DiffEditorHunkToolbar, this._contextKeyService)), this._actions = Rt(this._menu.onDidChange, () => this._menu.getActions()), this._hasActions = this._actions.map((l) => l.length > 0), this.width = Fe(this, (l) => this._hasActions.read(l) ? 35 : 0), this.elements = yt("div.gutter@gutter", { style: { position: "absolute", height: "100%", width: "35px" } }, []), this._currentDiff = Fe(this, (l) => {
      var d;
      const h = this._diffModel.read(l);
      if (!h) return;
      const c = (d = h.diff.read(l)) === null || d === void 0 ? void 0 : d.mappings, u = this._editors.modifiedCursor.read(l);
      return u ? c == null ? void 0 : c.find((g) => g.lineRangeMapping.modified.contains(u.lineNumber)) : void 0;
    }), this._selectedDiffs = Fe(this, (l) => {
      const d = this._diffModel.read(l), h = d == null ? void 0 : d.diff.read(l);
      if (!h) return ux;
      const c = this._editors.modifiedSelections.read(l);
      if (c.every((p) => p.isEmpty())) return ux;
      const u = new Uo(c.map((p) => je.fromRangeInclusive(p))), g = h.mappings.filter((p) => p.lineRangeMapping.innerChanges && u.intersects(p.lineRangeMapping.modified)).map((p) => ({ mapping: p, rangeMappings: p.lineRangeMapping.innerChanges.filter((f) => c.some((_) => D.areIntersecting(f.modifiedRange, _))) }));
      return g.length === 0 || g.every((p) => p.rangeMappings.length === 0) ? ux : g;
    }), this._register((r = i, a = this.elements.root, r.prepend(a), ye(() => {
      r.removeChild(a);
    }))), this._register(K(this.elements.root, "click", () => {
      this._editors.modified.focus();
    })), this._register(Ed(this.elements.root, { display: this._hasActions.map((l) => l ? "block" : "none") })), this._register(new Fne(this._editors.modified, this.elements.root, { getIntersectingGutterItems: (l, d) => {
      const h = this._diffModel.read(d);
      if (!h) return [];
      const c = h.diff.read(d);
      if (!c) return [];
      const u = this._selectedDiffs.read(d);
      if (u.length > 0) {
        const p = xo.fromRangeMappings(u.flatMap((f) => f.rangeMappings));
        return [new zF(p, !0, x.DiffEditorSelectionToolbar, void 0, h.model.original.uri, h.model.modified.uri)];
      }
      const g = this._currentDiff.read(d);
      return c.mappings.map((p) => new zF(p.lineRangeMapping.withInnerChangesFromLineRanges(), p.lineRangeMapping === (g == null ? void 0 : g.lineRangeMapping), x.DiffEditorHunkToolbar, void 0, h.model.original.uri, h.model.modified.uri));
    }, createView: (l, d) => this._instantiationService.createInstance(G2, l, d, this) })), this._register(K(this.elements.gutter, ie.MOUSE_WHEEL, (l) => {
      this._editors.modified.getOption(103).handleMouseWheel && this._editors.modified.delegateScrollFromMouseWheelEvent(l);
    }, { passive: !1 }));
  }
  computeStagedValue(i) {
    var e;
    const t = (e = i.innerChanges) !== null && e !== void 0 ? e : [];
    return new tP(t.map((n) => new Bd(n.originalRange, this._editors.modifiedModel.get().getValueInRange(n.modifiedRange)))).apply(new Hne(this._editors.original.getModel()));
  }
  layout(i) {
    this.elements.gutter.style.left = i + "px";
  }
};
$2 = ZV([aw(3, Se), aw(4, Te), aw(5, Mo)], $2);
class zF {
  constructor(e, t, n, s, o, r) {
    this.mapping = e, this.showAlways = t, this.menuId = n, this.rangeOverride = s, this.originalUri = o, this.modifiedUri = r;
  }
  get id() {
    return this.mapping.modified.toString();
  }
  get range() {
    var e;
    return (e = this.rangeOverride) !== null && e !== void 0 ? e : this.mapping.modified;
  }
}
let G2 = class extends V {
  constructor(i, e, t, n) {
    super(), this._item = i, this._elements = yt("div.gutterItem", { style: { height: "20px", width: "34px" } }, [yt("div.background@background", {}, []), yt("div.buttons@buttons", {}, [])]), this._showAlways = this._item.map(this, (o) => o.showAlways), this._menuId = this._item.map(this, (o) => o.menuId), this._isSmall = lt(this, !1), this._lastItemRange = void 0, this._lastViewRange = void 0;
    const s = this._register(n.createInstance(kv, "element", !0, { position: { hoverPosition: 1 } }));
    this._register(A_(e, this._elements.root)), this._register(Ge((o) => {
      const r = this._showAlways.read(o);
      this._elements.root.classList.toggle("noTransition", !0), this._elements.root.classList.toggle("showAlways", r), setTimeout(() => {
        this._elements.root.classList.toggle("noTransition", !1);
      }, 0);
    })), this._register(nr((o, r) => {
      this._elements.buttons.replaceChildren();
      const a = r.add(n.createInstance(rS, this._elements.buttons, this._menuId.read(o), { orientation: 1, hoverDelegate: s, toolbarOptions: { primaryGroup: (l) => l.startsWith("primary") }, overflowBehavior: { maxItems: this._isSmall.read(o) ? 1 : 3 }, hiddenItemStrategy: 0, actionRunner: new qV(() => {
        const l = this._item.get(), d = l.mapping;
        return { mapping: d, originalWithModifiedChanges: t.computeStagedValue(d), originalUri: l.originalUri, modifiedUri: l.modifiedUri };
      }), menuOptions: { shouldForwardArgs: !0 } }));
      r.add(a.onDidChangeMenuItems(() => {
        this._lastItemRange && this.layout(this._lastItemRange, this._lastViewRange);
      }));
    }));
  }
  layout(i, e) {
    this._lastItemRange = i, this._lastViewRange = e;
    let t = this._elements.buttons.clientHeight;
    this._isSmall.set(this._item.get().mapping.original.startLineNumber === 1 && i.length < 30, void 0), t = this._elements.buttons.clientHeight, this._elements.root.style.top = i.start + "px", this._elements.root.style.height = i.length + "px";
    const n = i.length / 2 - t / 2, s = t;
    let o = i.start + n;
    const r = qe.tryCreate(s, e.endExclusive - s - t), a = qe.tryCreate(i.start + s, i.endExclusive - t - s);
    a && r && a.start < a.endExclusive && (o = r.clip(o), o = a.clip(o)), this._elements.buttons.style.top = o - i.start + "px";
  }
};
G2 = ZV([aw(3, Se)], G2);
var Une = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Yf = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let wd = class extends KL {
  get onDidContentSizeChange() {
    return this._editors.onDidContentSizeChange;
  }
  constructor(i, e, t, n, s, o, r, a) {
    var l;
    super(), this._domElement = i, this._parentContextKeyService = n, this._parentInstantiationService = s, this._accessibilitySignalService = r, this._editorProgressService = a, this.elements = yt("div.monaco-diff-editor.side-by-side", { style: { position: "relative", height: "100%" } }, [yt("div.noModificationsOverlay@overlay", { style: { position: "absolute", height: "100%", visibility: "hidden" } }, [Q("span", {}, "No Changes")]), yt("div.editor.original@original", { style: { position: "absolute", height: "100%" } }), yt("div.editor.modified@modified", { style: { position: "absolute", height: "100%" } }), yt("div.accessibleDiffViewer@accessibleDiffViewer", { style: { position: "absolute", height: "100%" } })]), this._diffModel = lt(this, void 0), this._shouldDisposeDiffModel = !1, this.onDidChangeModel = se.fromObservableLight(this._diffModel), this._contextKeyService = this._register(this._parentContextKeyService.createScoped(this._domElement)), this._instantiationService = this._parentInstantiationService.createChild(new I1([Te, this._contextKeyService])), this._boundarySashes = lt(this, void 0), this._accessibleDiffViewerShouldBeVisible = lt(this, !1), this._accessibleDiffViewerVisible = Fe(this, (C) => !!this._options.onlyShowAccessibleDiffViewer.read(C) || this._accessibleDiffViewerShouldBeVisible.read(C)), this._movedBlocksLinesPart = lt(this, void 0), this._layoutInfo = Fe(this, (C) => {
      var w, y, L, k, N;
      const A = this._rootSizeObserver.width.read(C), B = this._rootSizeObserver.height.read(C), T = this._sash.read(C), O = this._gutter.read(C), H = (w = O == null ? void 0 : O.width.read(C)) !== null && w !== void 0 ? w : 0, $ = (L = (y = this._overviewRulerPart.read(C)) === null || y === void 0 ? void 0 : y.width) !== null && L !== void 0 ? L : 0;
      let pe, me, ue, ee, te;
      if (T) {
        const be = T.sashLeft.read(C);
        pe = 0, me = be - H - ((N = (k = this._movedBlocksLinesPart.read(C)) === null || k === void 0 ? void 0 : k.width.read(C)) !== null && N !== void 0 ? N : 0), te = be - H, ue = be, ee = A - ue - $;
      } else te = 0, pe = H, me = Math.max(5, this._editors.original.getLayoutInfo().decorationsLeft), ue = H + me, ee = A - ue - $;
      return this.elements.original.style.left = pe + "px", this.elements.original.style.width = me + "px", this._editors.original.layout({ width: me, height: B }, !0), O == null || O.layout(te), this.elements.modified.style.left = ue + "px", this.elements.modified.style.width = ee + "px", this._editors.modified.layout({ width: ee, height: B }, !0), { modifiedEditor: this._editors.modified.getLayoutInfo(), originalEditor: this._editors.original.getLayoutInfo() };
    }), this._diffValue = this._diffModel.map((C, w) => C == null ? void 0 : C.diff.read(w)), this.onDidUpdateDiff = se.fromObservableLight(this._diffValue), o.willCreateDiffEditor(), this._contextKeyService.createKey("isInDiffEditor", !0), this._domElement.appendChild(this.elements.root), this._register(ye(() => this._domElement.removeChild(this.elements.root))), this._rootSizeObserver = this._register(new VV(this.elements.root, e.dimension)), this._rootSizeObserver.setAutomaticLayout((l = e.automaticLayout) !== null && l !== void 0 && l), this._options = this._instantiationService.createInstance(q2, e), this._register(Ge((C) => {
      this._options.setWidth(this._rootSizeObserver.width.read(C));
    })), this._contextKeyService.createKey(E.isEmbeddedDiffEditor.key, !1), this._register(Ml(E.isEmbeddedDiffEditor, this._contextKeyService, (C) => this._options.isInEmbeddedEditor.read(C))), this._register(Ml(E.comparingMovedCode, this._contextKeyService, (C) => {
      var w;
      return !!(!((w = this._diffModel.read(C)) === null || w === void 0) && w.movedTextToCompare.read(C));
    })), this._register(Ml(E.diffEditorRenderSideBySideInlineBreakpointReached, this._contextKeyService, (C) => this._options.couldShowInlineViewBecauseOfSize.read(C))), this._register(Ml(E.diffEditorInlineMode, this._contextKeyService, (C) => !this._options.renderSideBySide.read(C))), this._register(Ml(E.hasChanges, this._contextKeyService, (C) => {
      var w, y, L;
      return ((L = (y = (w = this._diffModel.read(C)) === null || w === void 0 ? void 0 : w.diff.read(C)) === null || y === void 0 ? void 0 : y.mappings.length) !== null && L !== void 0 ? L : 0) > 0;
    })), this._editors = this._register(this._instantiationService.createInstance(j2, this.elements.original, this.elements.modified, this._options, t, (C, w, y, L) => this._createInnerEditor(C, w, y, L))), this._register(Ml(E.diffEditorOriginalWritable, this._contextKeyService, (C) => this._options.originalEditable.read(C))), this._register(Ml(E.diffEditorModifiedWritable, this._contextKeyService, (C) => !this._options.readOnly.read(C))), this._register(Ml(E.diffEditorOriginalUri, this._contextKeyService, (C) => {
      var w, y;
      return (y = (w = this._diffModel.read(C)) === null || w === void 0 ? void 0 : w.model.original.uri.toString()) !== null && y !== void 0 ? y : "";
    })), this._register(Ml(E.diffEditorModifiedUri, this._contextKeyService, (C) => {
      var w, y;
      return (y = (w = this._diffModel.read(C)) === null || w === void 0 ? void 0 : w.model.modified.uri.toString()) !== null && y !== void 0 ? y : "";
    })), this._overviewRulerPart = Fl(this, (C) => this._options.renderOverviewRuler.read(C) ? this._instantiationService.createInstance(gr(Ou, C), this._editors, this.elements.root, this._diffModel, this._rootSizeObserver.width, this._rootSizeObserver.height, this._layoutInfo.map((w) => w.modifiedEditor)) : void 0).recomputeInitiallyAndOnChange(this._store), this._sash = Fl(this, (C) => {
      const w = this._options.renderSideBySide.read(C);
      return this.elements.root.classList.toggle("side-by-side", w), w ? new yne(this._options, this.elements.root, { height: this._rootSizeObserver.height, width: this._rootSizeObserver.width.map((y, L) => {
        var k, N;
        return y - ((N = (k = this._overviewRulerPart.read(L)) === null || k === void 0 ? void 0 : k.width) !== null && N !== void 0 ? N : 0);
      }) }, this._boundarySashes) : void 0;
    }).recomputeInitiallyAndOnChange(this._store);
    const d = Fl(this, (C) => this._instantiationService.createInstance(gr(w0, C), this._editors, this._diffModel, this._options)).recomputeInitiallyAndOnChange(this._store);
    Fl(this, (C) => this._instantiationService.createInstance(gr(wne, C), this._editors, this._diffModel, this._options, this)).recomputeInitiallyAndOnChange(this._store);
    const h = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set();
    let u = !1;
    const g = Fl(this, (C) => this._instantiationService.createInstance(gr(U2, C), ke(this._domElement), this._editors, this._diffModel, this._options, this, () => u || d.get().isUpdatingHiddenAreas, h, c)).recomputeInitiallyAndOnChange(this._store), p = Fe(this, (C) => {
      const w = g.read(C).viewZones.read(C).orig, y = d.read(C).viewZones.read(C).origViewZones;
      return w.concat(y);
    }), f = Fe(this, (C) => {
      const w = g.read(C).viewZones.read(C).mod, y = d.read(C).viewZones.read(C).modViewZones;
      return w.concat(y);
    });
    let _;
    this._register(oS(this._editors.original, p, (C) => {
      u = C;
    }, h)), this._register(oS(this._editors.modified, f, (C) => {
      u = C, u ? _ = ya.capture(this._editors.modified) : (_ == null || _.restore(this._editors.modified), _ = void 0);
    }, c)), this._accessibleDiffViewer = Fl(this, (C) => this._instantiationService.createInstance(gr(Hh, C), this.elements.accessibleDiffViewer, this._accessibleDiffViewerVisible, (w, y) => this._accessibleDiffViewerShouldBeVisible.set(w, y), this._options.onlyShowAccessibleDiffViewer.map((w) => !w), this._rootSizeObserver.width, this._rootSizeObserver.height, this._diffModel.map((w, y) => {
      var L;
      return (L = w == null ? void 0 : w.diff.read(y)) === null || L === void 0 ? void 0 : L.mappings.map((k) => k.lineRangeMapping);
    }), new mne(this._editors))).recomputeInitiallyAndOnChange(this._store);
    const v = this._accessibleDiffViewerVisible.map((C) => C ? "hidden" : "visible");
    this._register(Ed(this.elements.modified, { visibility: v })), this._register(Ed(this.elements.original, { visibility: v })), this._createDiffEditorContributions(), o.addDiffEditor(this), this._gutter = Fl(this, (C) => this._options.shouldRenderGutterMenu.read(C) ? this._instantiationService.createInstance(gr($2, C), this.elements.root, this._diffModel, this._editors) : void 0), this._register(F1(this._layoutInfo)), Fl(this, (C) => new (gr(rc, C))(this.elements.root, this._diffModel, this._layoutInfo.map((w) => w.originalEditor), this._layoutInfo.map((w) => w.modifiedEditor), this._editors)).recomputeInitiallyAndOnChange(this._store, (C) => {
      this._movedBlocksLinesPart.set(C, void 0);
    }), this._register(Ed(this.elements.overlay, { width: this._layoutInfo.map((C, w) => C.originalEditor.width + (this._options.renderSideBySide.read(w) ? 0 : C.modifiedEditor.width)), visibility: Fe((C) => {
      var w, y;
      return this._options.hideUnchangedRegions.read(C) && ((y = (w = this._diffModel.read(C)) === null || w === void 0 ? void 0 : w.diff.read(C)) === null || y === void 0 ? void 0 : y.mappings.length) === 0 ? "visible" : "hidden";
    }) })), this._register(se.runAndSubscribe(this._editors.modified.onDidChangeCursorPosition, (C) => this._handleCursorPositionChange(C, !0))), this._register(se.runAndSubscribe(this._editors.original.onDidChangeCursorPosition, (C) => this._handleCursorPositionChange(C, !1)));
    const b = this._diffModel.map(this, (C, w) => {
      if (C) return C.diff.read(w) === void 0 && !C.isDiffUpToDate.read(w);
    });
    this._register(nr((C, w) => {
      if (b.read(C) === !0) {
        const y = this._editorProgressService.show(!0, 1e3);
        w.add(ye(() => y.done()));
      }
    })), this._register(ye(() => {
      var C;
      this._shouldDisposeDiffModel && ((C = this._diffModel.get()) === null || C === void 0 || C.dispose());
    })), this._register(nr((C, w) => {
      w.add(new (gr(Rne, C))(this._editors, this._diffModel, this._options, this));
    }));
  }
  _createInnerEditor(i, e, t, n) {
    return i.createInstance(pm, e, t, n);
  }
  _createDiffEditorContributions() {
    const i = Jp.getDiffEditorContributions();
    for (const e of i) try {
      this._register(this._instantiationService.createInstance(e.ctor, this));
    } catch (t) {
      We(t);
    }
  }
  get _targetEditor() {
    return this._editors.modified;
  }
  getEditorType() {
    return w1.IDiffEditor;
  }
  layout(i) {
    this._rootSizeObserver.observe(i);
  }
  hasTextFocus() {
    return this._editors.original.hasTextFocus() || this._editors.modified.hasTextFocus();
  }
  saveViewState() {
    var i;
    return { original: this._editors.original.saveViewState(), modified: this._editors.modified.saveViewState(), modelState: (i = this._diffModel.get()) === null || i === void 0 ? void 0 : i.serializeState() };
  }
  restoreViewState(i) {
    var e;
    if (i && i.original && i.modified) {
      const t = i;
      this._editors.original.restoreViewState(t.original), this._editors.modified.restoreViewState(t.modified), t.modelState && ((e = this._diffModel.get()) === null || e === void 0 || e.restoreSerializedState(t.modelState));
    }
  }
  handleInitialized() {
    this._editors.original.handleInitialized(), this._editors.modified.handleInitialized();
  }
  createViewModel(i) {
    return this._instantiationService.createInstance(z2, i, this._options);
  }
  getModel() {
    var i, e;
    return (e = (i = this._diffModel.get()) === null || i === void 0 ? void 0 : i.model) !== null && e !== void 0 ? e : null;
  }
  setModel(i, e) {
    !i && this._diffModel.get() && this._accessibleDiffViewer.get().close();
    const t = i ? "model" in i ? { model: i, shouldDispose: !1 } : { model: this.createViewModel(i), shouldDispose: !0 } : void 0;
    this._diffModel.get() !== (t == null ? void 0 : t.model) && Rv(e, (n) => {
      var s;
      Rt.batchEventsGlobally(n, () => {
        this._editors.original.setModel(t ? t.model.model.original : null), this._editors.modified.setModel(t ? t.model.model.modified : null);
      });
      const o = this._diffModel.get(), r = this._shouldDisposeDiffModel;
      this._shouldDisposeDiffModel = (s = t == null ? void 0 : t.shouldDispose) !== null && s !== void 0 && s, this._diffModel.set(t == null ? void 0 : t.model, n), r && (o == null || o.dispose());
    });
  }
  updateOptions(i) {
    this._options.updateOptions(i);
  }
  getContainerDomNode() {
    return this._domElement;
  }
  getOriginalEditor() {
    return this._editors.original;
  }
  getModifiedEditor() {
    return this._editors.modified;
  }
  getLineChanges() {
    var i;
    const e = (i = this._diffModel.get()) === null || i === void 0 ? void 0 : i.diff.get();
    return e ? e.mappings.map((t) => {
      const n = t.lineRangeMapping;
      let s, o, r, a, l = n.innerChanges;
      return n.original.isEmpty ? (s = n.original.startLineNumber - 1, o = 0, l = void 0) : (s = n.original.startLineNumber, o = n.original.endLineNumberExclusive - 1), n.modified.isEmpty ? (r = n.modified.startLineNumber - 1, a = 0, l = void 0) : (r = n.modified.startLineNumber, a = n.modified.endLineNumberExclusive - 1), { originalStartLineNumber: s, originalEndLineNumber: o, modifiedStartLineNumber: r, modifiedEndLineNumber: a, charChanges: l == null ? void 0 : l.map((d) => ({ originalStartLineNumber: d.originalRange.startLineNumber, originalStartColumn: d.originalRange.startColumn, originalEndLineNumber: d.originalRange.endLineNumber, originalEndColumn: d.originalRange.endColumn, modifiedStartLineNumber: d.modifiedRange.startLineNumber, modifiedStartColumn: d.modifiedRange.startColumn, modifiedEndLineNumber: d.modifiedRange.endLineNumber, modifiedEndColumn: d.modifiedRange.endColumn })) };
    }) : null;
  }
  revert(i) {
    const e = this._diffModel.get();
    e && e.isDiffUpToDate.get() && this._editors.modified.executeEdits("diffEditor", [{ range: i.modified.toExclusiveRange(), text: e.model.original.getValueInRange(i.original.toExclusiveRange()) }]);
  }
  revertRangeMappings(i) {
    const e = this._diffModel.get();
    if (!e || !e.isDiffUpToDate.get()) return;
    const t = i.map((n) => ({ range: n.modifiedRange, text: e.model.original.getValueInRange(n.originalRange) }));
    this._editors.modified.executeEdits("diffEditor", t);
  }
  _goTo(i) {
    this._editors.modified.setPosition(new W(i.lineRangeMapping.modified.startLineNumber, 1)), this._editors.modified.revealRangeInCenter(i.lineRangeMapping.modified.toExclusiveRange());
  }
  goToDiff(i) {
    var e, t, n, s;
    const o = (t = (e = this._diffModel.get()) === null || e === void 0 ? void 0 : e.diff.get()) === null || t === void 0 ? void 0 : t.mappings;
    if (!o || o.length === 0) return;
    const r = this._editors.modified.getPosition().lineNumber;
    let a;
    a = i === "next" ? (n = o.find((l) => l.lineRangeMapping.modified.startLineNumber > r)) !== null && n !== void 0 ? n : o[0] : (s = sv(o, (l) => l.lineRangeMapping.modified.startLineNumber < r)) !== null && s !== void 0 ? s : o[o.length - 1], this._goTo(a), a.lineRangeMapping.modified.isEmpty ? this._accessibilitySignalService.playSignal(He.diffLineDeleted, { source: "diffEditor.goToDiff" }) : a.lineRangeMapping.original.isEmpty ? this._accessibilitySignalService.playSignal(He.diffLineInserted, { source: "diffEditor.goToDiff" }) : a && this._accessibilitySignalService.playSignal(He.diffLineModified, { source: "diffEditor.goToDiff" });
  }
  revealFirstDiff() {
    const i = this._diffModel.get();
    i && this.waitForDiff().then(() => {
      var e;
      const t = (e = i.diff.get()) === null || e === void 0 ? void 0 : e.mappings;
      t && t.length !== 0 && this._goTo(t[0]);
    });
  }
  accessibleDiffViewerNext() {
    this._accessibleDiffViewer.get().next();
  }
  accessibleDiffViewerPrev() {
    this._accessibleDiffViewer.get().prev();
  }
  async waitForDiff() {
    const i = this._diffModel.get();
    i && await i.waitForDiff();
  }
  mapToOtherSide() {
    var i, e;
    const t = this._editors.modified.hasWidgetFocus(), n = t ? this._editors.modified : this._editors.original, s = t ? this._editors.original : this._editors.modified;
    let o;
    const r = n.getSelection();
    if (r) {
      const a = (e = (i = this._diffModel.get()) === null || i === void 0 ? void 0 : i.diff.get()) === null || e === void 0 ? void 0 : e.mappings.map((l) => t ? l.lineRangeMapping.flip() : l.lineRangeMapping);
      if (a) {
        const l = DF(r.getStartPosition(), a), d = DF(r.getEndPosition(), a);
        o = D.plusRange(l, d);
      }
    }
    return { destination: s, destinationSelection: o };
  }
  switchSide() {
    const { destination: i, destinationSelection: e } = this.mapToOtherSide();
    i.focus(), e && i.setSelection(e);
  }
  exitCompareMove() {
    const i = this._diffModel.get();
    i && i.movedTextToCompare.set(void 0, void 0);
  }
  collapseAllUnchangedRegions() {
    var i;
    const e = (i = this._diffModel.get()) === null || i === void 0 ? void 0 : i.unchangedRegions.get();
    e && Tt((t) => {
      for (const n of e) n.collapseAll(t);
    });
  }
  showAllUnchangedRegions() {
    var i;
    const e = (i = this._diffModel.get()) === null || i === void 0 ? void 0 : i.unchangedRegions.get();
    e && Tt((t) => {
      for (const n of e) n.showAll(t);
    });
  }
  _handleCursorPositionChange(i, e) {
    var t, n;
    if ((i == null ? void 0 : i.reason) === 3) {
      const s = (n = (t = this._diffModel.get()) === null || t === void 0 ? void 0 : t.diff.get()) === null || n === void 0 ? void 0 : n.mappings.find((o) => e ? o.lineRangeMapping.modified.contains(i.position.lineNumber) : o.lineRangeMapping.original.contains(i.position.lineNumber));
      s != null && s.lineRangeMapping.modified.isEmpty ? this._accessibilitySignalService.playSignal(He.diffLineDeleted, { source: "diffEditor.cursorPositionChanged" }) : s != null && s.lineRangeMapping.original.isEmpty ? this._accessibilitySignalService.playSignal(He.diffLineInserted, { source: "diffEditor.cursorPositionChanged" }) : s && this._accessibilitySignalService.playSignal(He.diffLineModified, { source: "diffEditor.cursorPositionChanged" });
    }
  }
};
wd = Une([Yf(3, Te), Yf(4, Se), Yf(5, mt), Yf(6, Fc), Yf(7, Ec)], wd);
var iP = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Jt = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let Kne = 0, UF = !1;
function jne(i) {
  if (!i) {
    if (UF) return;
    UF = !0;
  }
  (function(e) {
    vu = document.createElement("div"), vu.className = "monaco-aria-container";
    const t = () => {
      const s = document.createElement("div");
      return s.className = "monaco-alert", s.setAttribute("role", "alert"), s.setAttribute("aria-atomic", "true"), vu.appendChild(s), s;
    };
    OC = t(), $E = t();
    const n = () => {
      const s = document.createElement("div");
      return s.className = "monaco-status", s.setAttribute("aria-live", "polite"), s.setAttribute("aria-atomic", "true"), vu.appendChild(s), s;
    };
    FC = n(), GE = n(), e.appendChild(vu);
  })(i || Et.document.body);
}
let aS = class extends pm {
  constructor(i, e, t, n, s, o, r, a, l, d, h, c) {
    const u = { ...e };
    u.ariaLabel = u.ariaLabel || Py.editorViewAccessibleLabel, u.ariaLabel = u.ariaLabel + ";" + Py.accessibilityHelpMessage, super(i, u, {}, t, n, s, o, a, l, d, h, c), this._standaloneKeybindingService = r instanceof af ? r : null, jne(u.ariaContainerElement), SL = (g, p) => t.createInstance(kv, g, p, {});
  }
  addCommand(i, e, t) {
    if (!this._standaloneKeybindingService) return console.warn("Cannot add command because the editor is configured with an unrecognized KeybindingService"), null;
    const n = "DYNAMIC_" + ++Kne, s = q.deserialize(t);
    return this._standaloneKeybindingService.addDynamicKeybinding(n, i, e, s), n;
  }
  createContextKey(i, e) {
    return this._contextKeyService.createKey(i, e);
  }
  addAction(i) {
    if (typeof i.id != "string" || typeof i.label != "string" || typeof i.run != "function") throw new Error("Invalid action descriptor, `id`, `label` and `run` are required properties!");
    if (!this._standaloneKeybindingService) return console.warn("Cannot add keybinding because the editor is configured with an unrecognized KeybindingService"), V.None;
    const e = i.id, t = i.label, n = q.and(q.equals("editorId", this.getId()), q.deserialize(i.precondition)), s = i.keybindings, o = q.and(n, q.deserialize(i.keybindingContext)), r = i.contextMenuGroupId || null, a = i.contextMenuOrder || 0, l = (u, ...g) => Promise.resolve(i.run(this, ...g)), d = new G(), h = this.getId() + ":" + e;
    if (d.add(dt.registerCommand(h, l)), r) {
      const u = { command: { id: h, title: t }, when: n, group: r, order: a };
      d.add(tn.appendMenuItem(x.EditorContext, u));
    }
    if (Array.isArray(s)) for (const u of s) d.add(this._standaloneKeybindingService.addDynamicKeybinding(h, u, l, o));
    const c = new ZB(h, t, t, void 0, n, (...u) => Promise.resolve(i.run(this, ...u)), this._contextKeyService);
    return this._actions.set(e, c), d.add(ye(() => {
      this._actions.delete(e);
    })), d;
  }
  _triggerCommand(i, e) {
    if (this._codeEditorService instanceof jC) try {
      this._codeEditorService.setActiveCodeEditor(this), super._triggerCommand(i, e);
    } finally {
      this._codeEditorService.setActiveCodeEditor(null);
    }
    else super._triggerCommand(i, e);
  }
};
aS = iP([Jt(2, Se), Jt(3, mt), Jt(4, ai), Jt(5, Te), Jt(6, Dt), Jt(7, Yi), Jt(8, Ri), Jt(9, or), Jt(10, zt), Jt(11, fe)], aS);
let Z2 = class extends aS {
  constructor(i, e, t, n, s, o, r, a, l, d, h, c, u, g, p) {
    const f = { ...e };
    iS(d, f, !1);
    const _ = a.registerEditorContainer(i);
    typeof f.theme == "string" && a.setTheme(f.theme), f.autoDetectHighContrast !== void 0 && a.setAutoDetectHighContrast(!!f.autoDetectHighContrast);
    const v = f.model;
    let b;
    if (delete f.model, super(i, f, t, n, s, o, r, a, l, h, g, p), this._configurationService = d, this._standaloneThemeService = a, this._register(_), v === void 0) {
      const C = u.getLanguageIdByMimeType(f.language) || f.language || ko;
      b = YV(c, u, f.value || "", C, void 0), this._ownsModel = !0;
    } else b = v, this._ownsModel = !1;
    if (this._attachModel(b), b) {
      const C = { oldModelUrl: null, newModelUrl: b.uri };
      this._onDidChangeModel.fire(C);
    }
  }
  dispose() {
    super.dispose();
  }
  updateOptions(i) {
    iS(this._configurationService, i, !1), typeof i.theme == "string" && this._standaloneThemeService.setTheme(i.theme), i.autoDetectHighContrast !== void 0 && this._standaloneThemeService.setAutoDetectHighContrast(!!i.autoDetectHighContrast), super.updateOptions(i);
  }
  _postDetachModelCleanup(i) {
    super._postDetachModelCleanup(i), i && this._ownsModel && (i.dispose(), this._ownsModel = !1);
  }
};
Z2 = iP([Jt(2, Se), Jt(3, mt), Jt(4, ai), Jt(5, Te), Jt(6, Dt), Jt(7, Ro), Jt(8, Ri), Jt(9, Ye), Jt(10, or), Jt(11, ni), Jt(12, Xt), Jt(13, zt), Jt(14, fe)], Z2);
let Y2 = class extends wd {
  constructor(i, e, t, n, s, o, r, a, l, d, h, c) {
    const u = { ...e };
    iS(a, u, !0);
    const g = o.registerEditorContainer(i);
    typeof u.theme == "string" && o.setTheme(u.theme), u.autoDetectHighContrast !== void 0 && o.setAutoDetectHighContrast(!!u.autoDetectHighContrast), super(i, u, {}, n, t, s, c, d), this._configurationService = a, this._standaloneThemeService = o, this._register(g);
  }
  dispose() {
    super.dispose();
  }
  updateOptions(i) {
    iS(this._configurationService, i, !0), typeof i.theme == "string" && this._standaloneThemeService.setTheme(i.theme), i.autoDetectHighContrast !== void 0 && this._standaloneThemeService.setAutoDetectHighContrast(!!i.autoDetectHighContrast), super.updateOptions(i);
  }
  _createInnerEditor(i, e, t) {
    return i.createInstance(aS, e, t);
  }
  getOriginalEditor() {
    return super.getOriginalEditor();
  }
  getModifiedEditor() {
    return super.getModifiedEditor();
  }
  addCommand(i, e, t) {
    return this.getModifiedEditor().addCommand(i, e, t);
  }
  createContextKey(i, e) {
    return this.getModifiedEditor().createContextKey(i, e);
  }
  addAction(i) {
    return this.getModifiedEditor().addAction(i);
  }
};
function YV(i, e, t, n, s) {
  if (t = t || "", !n) {
    const o = t.indexOf(`
`);
    let r = t;
    return o !== -1 && (r = t.substring(0, o)), KF(i, t, e.createByFilepathOrFirstLine(s || null, r), s);
  }
  return KF(i, t, e.createById(n), s);
}
function KF(i, e, t, n) {
  return i.createModel(e, t, n);
}
Y2 = iP([Jt(2, Se), Jt(3, Te), Jt(4, mt), Jt(5, Ro), Jt(6, Ri), Jt(7, Ye), Jt(8, io), Jt(9, Ec), Jt(10, Kd), Jt(11, Fc)], Y2);
var qne = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, $ne = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class Gne {
  constructor(e, t) {
    this.viewModel = e, this.deltaScrollVertical = t;
  }
  getId() {
    return this.viewModel;
  }
}
let lS = class extends V {
  constructor(i, e, t, n) {
    super(), this._container = i, this._overflowWidgetsDomNode = e, this._workbenchUIElementFactory = t, this._instantiationService = n, this._viewModel = lt(this, void 0), this._collapsed = Fe(this, (o) => {
      var r;
      return (r = this._viewModel.read(o)) === null || r === void 0 ? void 0 : r.collapsed.read(o);
    }), this._editorContentHeight = lt(this, 500), this.contentHeight = Fe(this, (o) => (this._collapsed.read(o) ? 0 : this._editorContentHeight.read(o)) + this._outerEditorHeight), this._modifiedContentWidth = lt(this, 0), this._modifiedWidth = lt(this, 0), this._originalContentWidth = lt(this, 0), this._originalWidth = lt(this, 0), this.maxScroll = Fe(this, (o) => {
      const r = this._modifiedContentWidth.read(o) - this._modifiedWidth.read(o), a = this._originalContentWidth.read(o) - this._originalWidth.read(o);
      return r > a ? { maxScroll: r, width: this._modifiedWidth.read(o) } : { maxScroll: a, width: this._originalWidth.read(o) };
    }), this._elements = yt("div.multiDiffEntry", [yt("div.header@header", [yt("div.header-content", [yt("div.collapse-button@collapseButton"), yt("div.file-path", [yt("div.title.modified.show-file-icons@primaryPath", []), yt("div.status.deleted@status", ["R"]), yt("div.title.original.show-file-icons@secondaryPath", [])]), yt("div.actions@actions")])]), yt("div.editorParent", [yt("div.editorContainer@editor")])]), this.editor = this._register(this._instantiationService.createInstance(wd, this._elements.editor, { overflowWidgetsDomNode: this._overflowWidgetsDomNode }, {})), this.isModifedFocused = jF(this.editor.getModifiedEditor()), this.isOriginalFocused = jF(this.editor.getOriginalEditor()), this.isFocused = Fe(this, (o) => this.isModifedFocused.read(o) || this.isOriginalFocused.read(o)), this._resourceLabel = this._workbenchUIElementFactory.createResourceLabel ? this._register(this._workbenchUIElementFactory.createResourceLabel(this._elements.primaryPath)) : void 0, this._resourceLabel2 = this._workbenchUIElementFactory.createResourceLabel ? this._register(this._workbenchUIElementFactory.createResourceLabel(this._elements.secondaryPath)) : void 0, this._dataStore = new G(), this._headerHeight = 40, this._lastScrollTop = -1, this._isSettingScrollTop = !1;
    const s = new eS(this._elements.collapseButton, {});
    this._register(Ge((o) => {
      s.element.className = "", s.icon = this._collapsed.read(o) ? ne.chevronRight : ne.chevronDown;
    })), this._register(s.onDidClick(() => {
      var o;
      (o = this._viewModel.get()) === null || o === void 0 || o.collapsed.set(!this._collapsed.get(), void 0);
    })), this._register(Ge((o) => {
      this._elements.editor.style.display = this._collapsed.read(o) ? "none" : "block";
    })), this._register(this.editor.getModifiedEditor().onDidLayoutChange((o) => {
      const r = this.editor.getModifiedEditor().getLayoutInfo().contentWidth;
      this._modifiedWidth.set(r, void 0);
    })), this._register(this.editor.getOriginalEditor().onDidLayoutChange((o) => {
      const r = this.editor.getOriginalEditor().getLayoutInfo().contentWidth;
      this._originalWidth.set(r, void 0);
    })), this._register(this.editor.onDidContentSizeChange((o) => {
      ZC((r) => {
        this._editorContentHeight.set(o.contentHeight, r), this._modifiedContentWidth.set(this.editor.getModifiedEditor().getContentWidth(), r), this._originalContentWidth.set(this.editor.getOriginalEditor().getContentWidth(), r);
      });
    })), this._register(this.editor.getOriginalEditor().onDidScrollChange((o) => {
      if (this._isSettingScrollTop || !o.scrollTopChanged || !this._data) return;
      const r = o.scrollTop - this._lastScrollTop;
      this._data.deltaScrollVertical(r);
    })), this._register(Ge((o) => {
      const r = this.isFocused.read(o);
      this._elements.root.classList.toggle("focused", r);
    })), this._container.appendChild(this._elements.root), this._outerEditorHeight = this._headerHeight, this._register(this._instantiationService.createInstance(rS, this._elements.actions, x.MultiDiffEditorFileToolbar, { actionRunner: this._register(new qV(() => {
      var o;
      return (o = this._viewModel.get()) === null || o === void 0 ? void 0 : o.modifiedUri;
    })), menuOptions: { shouldForwardArgs: !0 }, toolbarOptions: { primaryGroup: (o) => o.startsWith("navigation") }, actionViewItemProvider: (o, r) => eV(n, o, r) }));
  }
  setScrollLeft(i) {
    this._modifiedContentWidth.get() - this._modifiedWidth.get() > this._originalContentWidth.get() - this._originalWidth.get() ? this.editor.getModifiedEditor().setScrollLeft(i) : this.editor.getOriginalEditor().setScrollLeft(i);
  }
  setData(i) {
    function e(n) {
      return { ...n, scrollBeyondLastLine: !1, hideUnchangedRegions: { enabled: !0 }, scrollbar: { vertical: "hidden", horizontal: "hidden", handleMouseWheel: !1, useShadows: !1 }, renderOverviewRuler: !1, fixedOverflowWidgets: !0, overviewRulerBorder: !1 };
    }
    this._data = i;
    const t = i.viewModel.entry.value;
    t.onOptionsDidChange && this._dataStore.add(t.onOptionsDidChange(() => {
      var n;
      this.editor.updateOptions(e((n = t.options) !== null && n !== void 0 ? n : {}));
    })), ZC((n) => {
      var s, o, r, a;
      (s = this._resourceLabel) === null || s === void 0 || s.setUri((o = i.viewModel.modifiedUri) !== null && o !== void 0 ? o : i.viewModel.originalUri, { strikethrough: i.viewModel.modifiedUri === void 0 });
      let l = !1, d = !1, h = !1, c = "";
      i.viewModel.modifiedUri && i.viewModel.originalUri && i.viewModel.modifiedUri.path !== i.viewModel.originalUri.path ? (c = "R", l = !0) : i.viewModel.modifiedUri ? i.viewModel.originalUri || (c = "A", h = !0) : (c = "D", d = !0), this._elements.status.classList.toggle("renamed", l), this._elements.status.classList.toggle("deleted", d), this._elements.status.classList.toggle("added", h), this._elements.status.innerText = c, (r = this._resourceLabel2) === null || r === void 0 || r.setUri(l ? i.viewModel.originalUri : void 0, { strikethrough: !0 }), this._dataStore.clear(), this._viewModel.set(i.viewModel, n), this.editor.setModel(i.viewModel.diffEditorViewModel, n), this.editor.updateOptions(e((a = t.options) !== null && a !== void 0 ? a : {}));
    });
  }
  render(i, e, t, n) {
    this._elements.root.style.visibility = "visible", this._elements.root.style.top = `${i.start}px`, this._elements.root.style.height = `${i.length}px`, this._elements.root.style.width = `${e}px`, this._elements.root.style.position = "absolute";
    const s = i.length - this._headerHeight, o = Math.max(0, Math.min(n.start - i.start, s));
    this._elements.header.style.transform = `translateY(${o}px)`, ZC((r) => {
      this.editor.layout({ width: e - 16 - 2, height: i.length - this._outerEditorHeight });
    });
    try {
      this._isSettingScrollTop = !0, this._lastScrollTop = t, this.editor.getOriginalEditor().setScrollTop(t);
    } finally {
      this._isSettingScrollTop = !1;
    }
    this._elements.header.classList.toggle("shadow", o > 0 || t > 0), this._elements.header.classList.toggle("collapsed", o === s);
  }
  hide() {
    this._elements.root.style.top = "-100000px", this._elements.root.style.visibility = "hidden";
  }
};
function jF(i) {
  return Rt((e) => {
    const t = new G();
    return t.add(i.onDidFocusEditorWidget(() => e(!0))), t.add(i.onDidBlurEditorWidget(() => e(!1))), t;
  }, () => i.hasTextFocus());
}
lS = qne([$ne(3, Se)], lS);
class Zne {
  constructor(e) {
    this._create = e, this._unused = /* @__PURE__ */ new Set(), this._used = /* @__PURE__ */ new Set(), this._itemData = /* @__PURE__ */ new Map();
  }
  getUnusedObj(e) {
    var t;
    let n;
    if (this._unused.size === 0) n = this._create(e), this._itemData.set(n, e);
    else {
      const s = [...this._unused.values()];
      n = (t = s.find((o) => this._itemData.get(o).getId() === e.getId())) !== null && t !== void 0 ? t : s[0], this._unused.delete(n), this._itemData.set(n, e), n.setData(e);
    }
    return this._used.add(n), { object: n, dispose: () => {
      this._used.delete(n), this._unused.size > 5 ? n.dispose() : this._unused.add(n);
    } };
  }
  dispose() {
    for (const e of this._used) e.dispose();
    for (const e of this._unused) e.dispose();
    this._used.clear(), this._unused.clear();
  }
}
var Yne = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, qF = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let X2 = class extends V {
  constructor(i, e, t, n, s, o) {
    super(), this._element = i, this._dimension = e, this._viewModel = t, this._workbenchUIElementFactory = n, this._parentContextKeyService = s, this._parentInstantiationService = o, this._elements = yt("div.monaco-component.multiDiffEditor", [yt("div@content", { style: { overflow: "hidden" } }), yt("div.monaco-editor@overflowWidgetsDomNode", {})]), this._sizeObserver = this._register(new VV(this._element, void 0)), this._objectPool = this._register(new Zne((a) => {
      const l = this._instantiationService.createInstance(lS, this._elements.content, this._elements.overflowWidgetsDomNode, this._workbenchUIElementFactory);
      return l.setData(a), l;
    })), this._scrollable = this._register(new bf({ forceIntegerValues: !1, scheduleAtNextAnimationFrame: (a) => Ys(ke(this._element), a), smoothScrollDuration: 100 })), this._scrollableElement = this._register(new dL(this._elements.root, { vertical: 1, horizontal: 1, useShadows: !1 }, this._scrollable)), this.scrollTop = Rt(this._scrollableElement.onScroll, () => this._scrollableElement.getScrollPosition().scrollTop), this.scrollLeft = Rt(this._scrollableElement.onScroll, () => this._scrollableElement.getScrollPosition().scrollLeft), this._viewItems = Cf(this, (a, l) => {
      const d = this._viewModel.read(a);
      return d ? d.items.read(a).map((h) => {
        var c;
        const u = l.add(new Xne(h, this._objectPool, this.scrollLeft, (p) => {
          this._scrollableElement.setScrollPosition({ scrollTop: this._scrollableElement.getScrollPosition().scrollTop + p });
        })), g = (c = this._lastDocStates) === null || c === void 0 ? void 0 : c[u.getKey()];
        return g && Tt((p) => {
          u.setViewState(g, p);
        }), u;
      }) : [];
    }), this._spaceBetweenPx = 0, this._totalHeight = this._viewItems.map(this, (a, l) => a.reduce((d, h) => d + h.contentHeight.read(l) + this._spaceBetweenPx, 0)), this.activeDiffItem = Fe(this, (a) => this._viewItems.read(a).find((l) => {
      var d;
      return (d = l.template.read(a)) === null || d === void 0 ? void 0 : d.isFocused.read(a);
    })), this.lastActiveDiffItem = function(a) {
      let l;
      return Fe((d) => (l = a(d, l), l));
    }((a, l) => {
      var d;
      return (d = this.activeDiffItem.read(a)) !== null && d !== void 0 ? d : l;
    }), this._contextKeyService = this._register(this._parentContextKeyService.createScoped(this._element)), this._instantiationService = this._parentInstantiationService.createChild(new I1([Te, this._contextKeyService])), this._lastDocStates = {}, this._contextKeyService.createKey(E.inMultiDiffEditor.key, !0), this._register(nr((a, l) => {
      const d = this._viewModel.read(a);
      if (d && d.contextKeys) for (const [h, c] of Object.entries(d.contextKeys)) {
        const u = this._contextKeyService.createKey(h, void 0);
        u.set(c), l.add(ye(() => u.reset()));
      }
    }));
    const r = this._parentContextKeyService.createKey(E.multiDiffEditorAllCollapsed.key, !1);
    this._register(Ge((a) => {
      const l = this._viewModel.read(a);
      if (l) {
        const d = l.items.read(a).every((h) => h.collapsed.read(a));
        r.set(d);
      }
    })), this._register(Ge((a) => {
      const l = this.lastActiveDiffItem.read(a);
      Tt((d) => {
        var h;
        (h = this._viewModel.read(a)) === null || h === void 0 || h.activeDiffItem.set(l == null ? void 0 : l.viewModel, d);
      });
    })), this._register(Ge((a) => {
      const l = this._dimension.read(a);
      this._sizeObserver.observe(l);
    })), this._elements.content.style.position = "relative", this._register(Ge((a) => {
      const l = this._sizeObserver.height.read(a);
      this._elements.root.style.height = `${l}px`;
      const d = this._totalHeight.read(a);
      this._elements.content.style.height = `${d}px`;
      const h = this._sizeObserver.width.read(a);
      let c = h;
      const u = DR(this._viewItems.read(a), (g) => g.maxScroll.read(a).maxScroll);
      u && (c = h + u.maxScroll.read(a).maxScroll), this._scrollableElement.setScrollDimensions({ width: h, height: l, scrollHeight: d, scrollWidth: c });
    })), i.replaceChildren(this._scrollableElement.getDomNode()), this._register(ye(() => {
      i.replaceChildren();
    })), this._register(this._register(Ge((a) => {
      ZC((l) => {
        this.render(a);
      });
    })));
  }
  render(i) {
    const e = this.scrollTop.read(i);
    let t = 0, n = 0, s = 0;
    const o = this._sizeObserver.height.read(i), r = qe.ofStartAndLength(e, o), a = this._sizeObserver.width.read(i);
    for (const l of this._viewItems.read(i)) {
      const d = l.contentHeight.read(i), h = Math.min(d, o), c = qe.ofStartAndLength(n, h), u = qe.ofStartAndLength(s, d);
      if (u.isBefore(r)) t -= d - h, l.hide();
      else if (u.isAfter(r)) l.hide();
      else {
        const g = Math.max(0, Math.min(r.start - u.start, d - h));
        t -= g;
        const p = qe.ofStartAndLength(e + t, o);
        l.render(c, g, a, p);
      }
      n += h + this._spaceBetweenPx, s += d + this._spaceBetweenPx;
    }
    this._elements.content.style.transform = `translateY(${-(e + t)}px)`;
  }
};
X2 = Yne([qF(4, Te), qF(5, Se)], X2);
class Xne extends V {
  constructor(e, t, n, s) {
    super(), this.viewModel = e, this._objectPool = t, this._scrollLeft = n, this._deltaScrollVertical = s, this._templateRef = this._register(Av(this, void 0)), this.contentHeight = Fe(this, (o) => {
      var r, a, l;
      return (l = (a = (r = this._templateRef.read(o)) === null || r === void 0 ? void 0 : r.object.contentHeight) === null || a === void 0 ? void 0 : a.read(o)) !== null && l !== void 0 ? l : this.viewModel.lastTemplateData.read(o).contentHeight;
    }), this.maxScroll = Fe(this, (o) => {
      var r, a;
      return (a = (r = this._templateRef.read(o)) === null || r === void 0 ? void 0 : r.object.maxScroll.read(o)) !== null && a !== void 0 ? a : { maxScroll: 0, scrollWidth: 0 };
    }), this.template = Fe(this, (o) => {
      var r;
      return (r = this._templateRef.read(o)) === null || r === void 0 ? void 0 : r.object;
    }), this._isHidden = lt(this, !1), this._register(Ge((o) => {
      var r;
      const a = this._scrollLeft.read(o);
      (r = this._templateRef.read(o)) === null || r === void 0 || r.object.setScrollLeft(a);
    })), this._register(Ge((o) => {
      const r = this._templateRef.read(o);
      r && this._isHidden.read(o) && (r.object.isFocused.read(o) || this._clear());
    }));
  }
  dispose() {
    this._clear(), super.dispose();
  }
  toString() {
    var e;
    return `VirtualViewItem(${(e = this.viewModel.entry.value.modified) === null || e === void 0 ? void 0 : e.uri.toString()})`;
  }
  getKey() {
    return this.viewModel.getKey();
  }
  setViewState(e, t) {
    var n;
    this.viewModel.collapsed.set(e.collapsed, t), this._updateTemplateData(t);
    const s = this.viewModel.lastTemplateData.get(), o = (n = e.selections) === null || n === void 0 ? void 0 : n.map(_e.liftSelection);
    this.viewModel.lastTemplateData.set({ ...s, selections: o }, t);
    const r = this._templateRef.get();
    r && o && r.object.editor.setSelections(o);
  }
  _updateTemplateData(e) {
    var t;
    const n = this._templateRef.get();
    n && this.viewModel.lastTemplateData.set({ contentHeight: n.object.contentHeight.get(), selections: (t = n.object.editor.getSelections()) !== null && t !== void 0 ? t : void 0 }, e);
  }
  _clear() {
    const e = this._templateRef.get();
    e && Tt((t) => {
      this._updateTemplateData(t), e.object.hide(), this._templateRef.set(void 0, t);
    });
  }
  hide() {
    this._isHidden.set(!0, void 0);
  }
  render(e, t, n, s) {
    this._isHidden.set(!1, void 0);
    let o = this._templateRef.get();
    if (!o) {
      o = this._objectPool.getUnusedObj(new Gne(this.viewModel, this._deltaScrollVertical)), this._templateRef.set(o, void 0);
      const r = this.viewModel.lastTemplateData.get().selections;
      r && o.object.editor.setSelections(r);
    }
    o.object.render(e, n, t, s);
  }
}
I("multiDiffEditor.headerBackground", { dark: "#262626", light: "tab.inactiveBackground", hcDark: "tab.inactiveBackground", hcLight: "tab.inactiveBackground" }, m(0, "The background color of the diff editor's header")), I("multiDiffEditor.background", { dark: "editorBackground", light: "editorBackground", hcDark: "editorBackground", hcLight: "editorBackground" }, m(0, "The background color of the multi file diff editor")), I("multiDiffEditor.border", { dark: "sideBarSectionHeader.border", light: "#cccccc", hcDark: "sideBarSectionHeader.border", hcLight: "#cccccc" }, m(0, "The border color of the multi file diff editor"));
var Qne = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Jne = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let Q2 = class extends V {
  constructor(i, e, t) {
    super(), this._element = i, this._workbenchUIElementFactory = e, this._instantiationService = t, this._dimension = lt(this, void 0), this._viewModel = lt(this, void 0), this._widgetImpl = Cf(this, (n, s) => (gr(lS, n), s.add(this._instantiationService.createInstance(gr(X2, n), this._element, this._dimension, this._viewModel, this._workbenchUIElementFactory)))), this._register(F1(this._widgetImpl));
  }
};
function ese(i, e, t) {
  return Me.initialize(t || {}).createInstance(Z2, i, e);
}
function tse(i) {
  return Me.get(mt).onCodeEditorAdd((e) => {
    i(e);
  });
}
function ise(i) {
  return Me.get(mt).onDiffEditorAdd((e) => {
    i(e);
  });
}
function nse() {
  return Me.get(mt).listCodeEditors();
}
function sse() {
  return Me.get(mt).listDiffEditors();
}
function ose(i, e, t) {
  return Me.initialize(t || {}).createInstance(Y2, i, e);
}
function rse(i, e) {
  const t = Me.initialize(e || {});
  return new Q2(i, {}, t);
}
function ase(i) {
  if (typeof i.id != "string" || typeof i.run != "function") throw new Error("Invalid command descriptor, `id` and `run` are required properties!");
  return dt.registerCommand(i.id, i.run);
}
function lse(i) {
  if (typeof i.id != "string" || typeof i.label != "string" || typeof i.run != "function") throw new Error("Invalid action descriptor, `id`, `label` and `run` are required properties!");
  const e = q.deserialize(i.precondition), t = new G();
  if (t.add(dt.registerCommand(i.id, (n, ...s) => Zi.runEditorCommand(n, s, e, (o, r, a) => Promise.resolve(i.run(r, ...a))))), i.contextMenuGroupId) {
    const n = { command: { id: i.id, title: i.label }, when: e, group: i.contextMenuGroupId, order: i.contextMenuOrder || 0 };
    t.add(tn.appendMenuItem(x.EditorContext, n));
  }
  if (Array.isArray(i.keybindings)) {
    const n = Me.get(Dt);
    if (n instanceof af) {
      const s = q.and(e, q.deserialize(i.keybindingContext));
      t.add(n.addDynamicKeybindings(i.keybindings.map((o) => ({ keybinding: o, command: i.id, when: s }))));
    } else console.warn("Cannot add keybinding because the editor is configured with an unrecognized KeybindingService");
  }
  return t;
}
function dse(i) {
  return XV([i]);
}
function XV(i) {
  const e = Me.get(Dt);
  return e instanceof af ? e.addDynamicKeybindings(i.map((t) => ({ keybinding: t.keybinding, command: t.command, commandArgs: t.commandArgs, when: q.deserialize(t.when) }))) : (console.warn("Cannot add keybinding because the editor is configured with an unrecognized KeybindingService"), V.None);
}
function hse(i, e, t) {
  const n = Me.get(Xt), s = n.getLanguageIdByMimeType(e) || e;
  return YV(Me.get(ni), n, i, s, t);
}
function cse(i, e) {
  const t = Me.get(Xt), n = t.getLanguageIdByMimeType(e) || e || ko;
  i.setLanguage(t.createById(n));
}
function use(i, e, t) {
  i && Me.get(kl).changeOne(e, i.uri, t);
}
function gse(i) {
  Me.get(kl).changeAll(i, []);
}
function pse(i) {
  return Me.get(kl).read(i);
}
function mse(i) {
  return Me.get(kl).onMarkerChanged(i);
}
function fse(i) {
  return Me.get(ni).getModel(i);
}
function _se() {
  return Me.get(ni).getModels();
}
function vse(i) {
  return Me.get(ni).onModelAdded(i);
}
function bse(i) {
  return Me.get(ni).onModelRemoved(i);
}
function Cse(i) {
  return Me.get(ni).onModelLanguageChanged((e) => {
    i({ model: e.model, oldLanguage: e.oldLanguageId });
  });
}
function wse(i) {
  return function(e, t, n) {
    return new $q(e, t, n);
  }(Me.get(ni), Me.get(zt), i);
}
function yse(i, e) {
  const t = Me.get(Xt), n = Me.get(Ro);
  return RR.colorizeElement(n, t, i, e).then(() => {
    n.registerEditorContainer(i);
  });
}
function Sse(i, e, t) {
  const n = Me.get(Xt);
  return Me.get(Ro).registerEditorContainer(Et.document.body), RR.colorize(n, i, e, t);
}
function Lse(i, e, t = 4) {
  return Me.get(Ro).registerEditorContainer(Et.document.body), RR.colorizeModelLine(i, e, t);
}
function kse(i, e) {
  ci.getOrCreate(e);
  const t = function(r) {
    return ci.get(r) || { getInitialState: () => zm, tokenize: (l, d, h) => IR(r, h) };
  }(e), n = Sl(i), s = [];
  let o = t.getInitialState();
  for (let r = 0, a = n.length; r < a; r++) {
    const l = n[r], d = t.tokenize(l, !0, o);
    s[r] = d.tokens, o = d.endState;
  }
  return s;
}
function Dse(i, e) {
  Me.get(Ro).defineTheme(i, e);
}
function xse(i) {
  Me.get(Ro).setTheme(i);
}
function Nse() {
  RE.clearAllFontInfos();
}
function Ese(i, e) {
  return dt.registerCommand({ id: i, handler: e });
}
function Ise(i) {
  return Me.get(Fs).registerOpener({ open: async (e) => (typeof e == "string" && (e = Ie.parse(e)), i.open(e)) });
}
function Mse(i) {
  return Me.get(mt).registerCodeEditorOpenHandler(async (e, t, n) => {
    var s;
    if (!t) return null;
    const o = (s = e.options) === null || s === void 0 ? void 0 : s.selection;
    let r;
    return o && typeof o.endLineNumber == "number" && typeof o.endColumn == "number" ? r = o : o && (r = { lineNumber: o.startLineNumber, column: o.startColumn }), await i.openCodeEditor(t, e.resource, r) ? t : null;
  });
}
function $b(i, e) {
  return typeof i == "boolean" ? i : e;
}
function $F(i, e) {
  return typeof i == "string" ? i : e;
}
function GF(i, e = !1) {
  e && (i = i.map(function(n) {
    return n.toLowerCase();
  }));
  const t = function(n) {
    const s = {};
    for (const o of n) s[o] = !0;
    return s;
  }(i);
  return e ? function(n) {
    return t[n.toLowerCase()] !== void 0 && t.hasOwnProperty(n.toLowerCase());
  } : function(n) {
    return t[n] !== void 0 && t.hasOwnProperty(n);
  };
}
function J2(i, e, t) {
  e = e.replace(/@@/g, "");
  let n, s = 0;
  do
    n = !1, e = e.replace(/@(\w+)/g, function(r, a) {
      n = !0;
      let l = "";
      if (typeof i[a] == "string") l = i[a];
      else {
        if (!(i[a] && i[a] instanceof RegExp)) throw i[a] === void 0 ? Gt(i, "language definition does not contain attribute '" + a + "', used at: " + e) : Gt(i, "attribute reference '" + a + "' must be a string, used at: " + e);
        l = i[a].source;
      }
      return _u(l) ? "" : "(?:" + l + ")";
    }), s++;
  while (n && s < 5);
  e = e.replace(/\x01/g, "@");
  const o = (i.ignoreCase ? "i" : "") + (i.unicode ? "u" : "");
  if (t && e.match(/\$[sS](\d\d?)/g)) {
    let r = null, a = null;
    return (l) => (a && r === l || (r = l, a = new RegExp(function(d, h, c) {
      let u = null;
      return h.replace(/\$[sS](\d\d?)/g, function(g, p) {
        return u === null && (u = c.split("."), u.unshift(c)), !_u(p) && p < u.length ? xd(d, u[p]) : "";
      });
    }(i, e, l), o)), a);
  }
  return new RegExp(e, o);
}
function Tse(i, e, t, n) {
  let s = -1, o = t, r = t.match(/^\$(([sS]?)(\d\d?)|#)(.*)$/);
  r && (r[3] && (s = parseInt(r[3]), r[2] && (s += 100)), o = r[4]);
  let a, l = "~", d = o;
  if (o && o.length !== 0 ? /^\w*$/.test(d) ? l = "==" : (r = o.match(/^(@|!@|~|!~|==|!=)(.*)$/), r && (l = r[1], d = r[2])) : (l = "!=", d = ""), l !== "~" && l !== "!~" || !/^(\w|\|)*$/.test(d)) if (l === "@" || l === "!@") {
    const h = i[d];
    if (!h) throw Gt(i, "the @ match target '" + d + "' is not defined, in rule: " + e);
    if (!function(u, g) {
      if (!g || !Array.isArray(g)) return !1;
      for (const p of g) if (!u(p)) return !1;
      return !0;
    }(function(u) {
      return typeof u == "string";
    }, h)) throw Gt(i, "the @ match target '" + d + "' must be an array of strings, in rule: " + e);
    const c = GF(h, i.ignoreCase);
    a = function(u) {
      return l === "@" ? c(u) : !c(u);
    };
  } else if (l === "~" || l === "!~") if (d.indexOf("$") < 0) {
    const h = J2(i, "^" + d + "$", !1);
    a = function(c) {
      return l === "~" ? h.test(c) : !h.test(c);
    };
  } else a = function(h, c, u, g) {
    return J2(i, "^" + vh(i, d, c, u, g) + "$", !1).test(h);
  };
  else if (d.indexOf("$") < 0) {
    const h = xd(i, d);
    a = function(c) {
      return l === "==" ? c === h : c !== h;
    };
  } else {
    const h = xd(i, d);
    a = function(c, u, g, p, f) {
      const _ = vh(i, h, u, g, p);
      return l === "==" ? c === _ : c !== _;
    };
  }
  else {
    const h = GF(d.split("|"), i.ignoreCase);
    a = function(c) {
      return l === "~" ? h(c) : !h(c);
    };
  }
  return s === -1 ? { name: t, value: n, test: function(h, c, u, g) {
    return a(h, h, c, u, g);
  } } : { name: t, value: n, test: function(h, c, u, g) {
    const p = function(f, _, v, b) {
      if (b < 0) return f;
      if (b < _.length) return _[b];
      if (b >= 100) {
        b -= 100;
        const C = v.split(".");
        if (C.unshift(v), b < C.length) return C[b];
      }
      return null;
    }(h, c, u, s);
    return a(p || "", h, c, u, g);
  } };
}
function eM(i, e, t) {
  if (t) {
    if (typeof t == "string") return t;
    if (t.token || t.token === "") {
      if (typeof t.token != "string") throw Gt(i, "a 'token' attribute must be of type string, in rule: " + e);
      {
        const n = { token: t.token };
        if (t.token.indexOf("$") >= 0 && (n.tokenSubst = !0), typeof t.bracket == "string") if (t.bracket === "@open") n.bracket = 1;
        else {
          if (t.bracket !== "@close") throw Gt(i, "a 'bracket' attribute must be either '@open' or '@close', in rule: " + e);
          n.bracket = -1;
        }
        if (t.next) {
          if (typeof t.next != "string") throw Gt(i, "the next state must be a string value in rule: " + e);
          {
            let s = t.next;
            if (!/^(@pop|@push|@popall)$/.test(s) && (s[0] === "@" && (s = s.substr(1)), s.indexOf("$") < 0 && !function(o, r) {
              let a = r;
              for (; a && a.length > 0; ) {
                if (o.stateNames[a]) return !0;
                const l = a.lastIndexOf(".");
                a = l < 0 ? null : a.substr(0, l);
              }
              return !1;
            }(i, vh(i, s, "", [], "")))) throw Gt(i, "the next state '" + t.next + "' is not defined in rule: " + e);
            n.next = s;
          }
        }
        return typeof t.goBack == "number" && (n.goBack = t.goBack), typeof t.switchTo == "string" && (n.switchTo = t.switchTo), typeof t.log == "string" && (n.log = t.log), typeof t.nextEmbedded == "string" && (n.nextEmbedded = t.nextEmbedded, i.usesEmbedded = !0), n;
      }
    }
    if (Array.isArray(t)) {
      const n = [];
      for (let s = 0, o = t.length; s < o; s++) n[s] = eM(i, e, t[s]);
      return { group: n };
    }
    if (t.cases) {
      const n = [];
      for (const o in t.cases) if (t.cases.hasOwnProperty(o)) {
        const r = eM(i, e, t.cases[o]);
        o === "@default" || o === "@" || o === "" ? n.push({ test: void 0, value: r, name: o }) : o === "@eos" ? n.push({ test: function(a, l, d, h) {
          return h;
        }, value: r, name: o }) : n.push(Tse(i, e, o, r));
      }
      const s = i.defaultToken;
      return { test: function(o, r, a, l) {
        for (const d of n)
          if (!d.test || d.test(o, r, a, l)) return d.value;
        return s;
      } };
    }
    throw Gt(i, "an action must be a string, an object with a 'token' or 'cases' attribute, or an array of actions; in rule: " + e);
  }
  return { token: "" };
}
Q2 = Qne([Jne(2, Se)], Q2);
class Rse {
  constructor(e) {
    this.regex = new RegExp(""), this.action = { token: "" }, this.matchOnlyAtLineStart = !1, this.name = "", this.name = e;
  }
  setRegex(e, t) {
    let n;
    if (typeof t == "string") n = t;
    else {
      if (!(t instanceof RegExp)) throw Gt(e, "rules must start with a match string or regular expression: " + this.name);
      n = t.source;
    }
    this.matchOnlyAtLineStart = n.length > 0 && n[0] === "^", this.name = this.name + ": " + n, this.regex = J2(e, "^(?:" + (this.matchOnlyAtLineStart ? n.substr(1) : n) + ")", !0);
  }
  setAction(e, t) {
    this.action = eM(e, this.name, t);
  }
  resolveRegex(e) {
    return this.regex instanceof RegExp ? this.regex : this.regex(e);
  }
}
function QV(i, e) {
  if (!e || typeof e != "object") throw new Error("Monarch: expecting a language definition object");
  const t = {};
  t.languageId = i, t.includeLF = $b(e.includeLF, !1), t.noThrow = !1, t.maxStack = 100, t.start = typeof e.start == "string" ? e.start : null, t.ignoreCase = $b(e.ignoreCase, !1), t.unicode = $b(e.unicode, !1), t.tokenPostfix = $F(e.tokenPostfix, "." + t.languageId), t.defaultToken = $F(e.defaultToken, "source"), t.usesEmbedded = !1;
  const n = e;
  function s(r, a, l) {
    for (const d of l) {
      let h = d.include;
      if (h) {
        if (typeof h != "string") throw Gt(t, "an 'include' attribute must be a string at: " + r);
        if (h[0] === "@" && (h = h.substr(1)), !e.tokenizer[h]) throw Gt(t, "include target '" + h + "' is not defined at: " + r);
        s(r + "." + h, a, e.tokenizer[h]);
      } else {
        const c = new Rse(r);
        if (Array.isArray(d) && d.length >= 1 && d.length <= 3) if (c.setRegex(n, d[0]), d.length >= 3) if (typeof d[1] == "string") c.setAction(n, { token: d[1], next: d[2] });
        else {
          if (typeof d[1] != "object") throw Gt(t, "a next state as the last element of a rule can only be given if the action is either an object or a string, at: " + r);
          {
            const u = d[1];
            u.next = d[2], c.setAction(n, u);
          }
        }
        else c.setAction(n, d[1]);
        else {
          if (!d.regex) throw Gt(t, "a rule must either be an array, or an object with a 'regex' or 'include' field at: " + r);
          d.name && typeof d.name == "string" && (c.name = d.name), d.matchOnlyAtStart && (c.matchOnlyAtLineStart = $b(d.matchOnlyAtLineStart, !1)), c.setRegex(n, d.regex), c.setAction(n, d.action);
        }
        a.push(c);
      }
    }
  }
  if (n.languageId = i, n.includeLF = t.includeLF, n.ignoreCase = t.ignoreCase, n.unicode = t.unicode, n.noThrow = t.noThrow, n.usesEmbedded = t.usesEmbedded, n.stateNames = e.tokenizer, n.defaultToken = t.defaultToken, !e.tokenizer || typeof e.tokenizer != "object") throw Gt(t, "a language definition must define the 'tokenizer' attribute as an object");
  t.tokenizer = [];
  for (const r in e.tokenizer) if (e.tokenizer.hasOwnProperty(r)) {
    t.start || (t.start = r);
    const a = e.tokenizer[r];
    t.tokenizer[r] = new Array(), s("tokenizer." + r, t.tokenizer[r], a);
  }
  if (t.usesEmbedded = n.usesEmbedded, e.brackets) {
    if (!Array.isArray(e.brackets)) throw Gt(t, "the 'brackets' attribute must be defined as an array");
  } else e.brackets = [{ open: "{", close: "}", token: "delimiter.curly" }, { open: "[", close: "]", token: "delimiter.square" }, { open: "(", close: ")", token: "delimiter.parenthesis" }, { open: "<", close: ">", token: "delimiter.angle" }];
  const o = [];
  for (const r of e.brackets) {
    let a = r;
    if (a && Array.isArray(a) && a.length === 3 && (a = { token: a[2], open: a[0], close: a[1] }), a.open === a.close) throw Gt(t, "open and close brackets in a 'brackets' attribute must be different: " + a.open + `
 hint: use the 'bracket' attribute if matching on equal brackets is required.`);
    if (typeof a.open != "string" || typeof a.token != "string" || typeof a.close != "string") throw Gt(t, "every element in the 'brackets' array must be a '{open,close,token}' object or array");
    o.push({ token: a.token + t.tokenPostfix, open: xd(t, a.open), close: xd(t, a.close) });
  }
  return t.brackets = o, t.noThrow = !0, t;
}
function Ase(i) {
  Vm.registerLanguage(i);
}
function Pse() {
  let i = [];
  return i = i.concat(Vm.getLanguages()), i;
}
function Ose(i) {
  return Me.get(Xt).languageIdCodec.encodeLanguageId(i);
}
function Fse(i, e) {
  return Me.withServices(() => {
    const t = Me.get(Xt).onDidRequestRichLanguageFeatures((n) => {
      n === i && (t.dispose(), e());
    });
    return t;
  });
}
function Bse(i, e) {
  return Me.withServices(() => {
    const t = Me.get(Xt).onDidRequestBasicLanguageFeatures((n) => {
      n === i && (t.dispose(), e());
    });
    return t;
  });
}
function Wse(i, e) {
  if (!Me.get(Xt).isRegisteredLanguageId(i)) throw new Error(`Cannot set configuration for unknown language ${i}`);
  return Me.get(zt).register(i, e, 100);
}
class Vse {
  constructor(e, t) {
    this._languageId = e, this._actual = t;
  }
  dispose() {
  }
  getInitialState() {
    return this._actual.getInitialState();
  }
  tokenize(e, t, n) {
    if (typeof this._actual.tokenize == "function") return Zv.adaptTokenize(this._languageId, this._actual, e, n);
    throw new Error("Not supported!");
  }
  tokenizeEncoded(e, t, n) {
    const s = this._actual.tokenizeEncoded(e, n);
    return new BS(s.tokens, s.endState);
  }
}
class Zv {
  constructor(e, t, n, s) {
    this._languageId = e, this._actual = t, this._languageService = n, this._standaloneThemeService = s;
  }
  dispose() {
  }
  getInitialState() {
    return this._actual.getInitialState();
  }
  static _toClassicTokens(e, t) {
    const n = [];
    let s = 0;
    for (let o = 0, r = e.length; o < r; o++) {
      const a = e[o];
      let l = a.startIndex;
      o === 0 ? l = 0 : l < s && (l = s), n[o] = new G0(l, a.scopes, t), s = l;
    }
    return n;
  }
  static adaptTokenize(e, t, n, s) {
    const o = t.tokenize(n, s), r = Zv._toClassicTokens(o.tokens, e);
    let a;
    return a = o.endState.equals(s) ? s : o.endState, new nR(r, a);
  }
  tokenize(e, t, n) {
    return Zv.adaptTokenize(this._languageId, this._actual, e, n);
  }
  _toBinaryTokens(e, t) {
    const n = e.encodeLanguageId(this._languageId), s = this._standaloneThemeService.getColorTheme().tokenTheme, o = [];
    let r = 0, a = 0;
    for (let d = 0, h = t.length; d < h; d++) {
      const c = t[d], u = 1024 | s.match(n, c.scopes);
      if (r > 0 && o[r - 1] === u) continue;
      let g = c.startIndex;
      d === 0 ? g = 0 : g < a && (g = a), o[r++] = g, o[r++] = u, a = g;
    }
    const l = new Uint32Array(r);
    for (let d = 0; d < r; d++) l[d] = o[d];
    return l;
  }
  tokenizeEncoded(e, t, n) {
    const s = this._actual.tokenize(e, n), o = this._toBinaryTokens(this._languageService.languageIdCodec, s.tokens);
    let r;
    return r = s.endState.equals(n) ? n : s.endState, new BS(o, r);
  }
}
function JV(i) {
  return i && typeof i.then == "function";
}
function Hse(i) {
  const e = Me.get(Ro);
  if (i) {
    const t = [null];
    for (let n = 1, s = i.length; n < s; n++) t[n] = z.fromHex(i[n]);
    e.setColorMapOverride(t);
  } else e.setColorMapOverride(null);
}
function eH(i, e) {
  return function(t) {
    return "tokenizeEncoded" in t;
  }(e) ? new Vse(i, e) : new Zv(i, e, Me.get(Xt), Me.get(Ro));
}
function nP(i, e) {
  const t = new kK(async () => {
    const n = await Promise.resolve(e.create());
    return n ? typeof n.getInitialState == "function" ? eH(i, n) : new cv(Me.get(Xt), Me.get(Ro), i, QV(i, n), Me.get(Ye)) : null;
  });
  return ci.registerFactory(i, t);
}
function zse(i, e) {
  if (!Me.get(Xt).isRegisteredLanguageId(i)) throw new Error(`Cannot set tokens provider for unknown language ${i}`);
  return JV(e) ? nP(i, { create: () => e }) : ci.register(i, eH(i, e));
}
function Use(i, e) {
  return JV(e) ? nP(i, { create: () => e }) : ci.register(i, ((t) => new cv(Me.get(Xt), Me.get(Ro), i, QV(i, t), Me.get(Ye)))(e));
}
function Kse(i, e) {
  return Me.get(fe).referenceProvider.register(i, e);
}
function jse(i, e) {
  return Me.get(fe).renameProvider.register(i, e);
}
function qse(i, e) {
  return Me.get(fe).newSymbolNamesProvider.register(i, e);
}
function $se(i, e) {
  return Me.get(fe).signatureHelpProvider.register(i, e);
}
function Gse(i, e) {
  return Me.get(fe).hoverProvider.register(i, { provideHover: (t, n, s) => {
    const o = t.getWordAtPosition(n);
    return Promise.resolve(e.provideHover(t, n, s)).then((r) => {
      if (r) return !r.range && o && (r.range = new D(n.lineNumber, o.startColumn, n.lineNumber, o.endColumn)), r.range || (r.range = new D(n.lineNumber, n.column, n.lineNumber, n.column)), r;
    });
  } });
}
function Zse(i, e) {
  return Me.get(fe).documentSymbolProvider.register(i, e);
}
function Yse(i, e) {
  return Me.get(fe).documentHighlightProvider.register(i, e);
}
function Xse(i, e) {
  return Me.get(fe).linkedEditingRangeProvider.register(i, e);
}
function Qse(i, e) {
  return Me.get(fe).definitionProvider.register(i, e);
}
function Jse(i, e) {
  return Me.get(fe).implementationProvider.register(i, e);
}
function eoe(i, e) {
  return Me.get(fe).typeDefinitionProvider.register(i, e);
}
function toe(i, e) {
  return Me.get(fe).codeLensProvider.register(i, e);
}
function ioe(i, e, t) {
  return Me.get(fe).codeActionProvider.register(i, { providedCodeActionKinds: t == null ? void 0 : t.providedCodeActionKinds, documentation: t == null ? void 0 : t.documentation, provideCodeActions: (n, s, o, r) => {
    const a = Me.get(kl).read({ resource: n.uri }).filter((l) => D.areIntersectingOrTouching(l, s));
    return e.provideCodeActions(n, s, { markers: a, only: o.only, trigger: o.trigger }, r);
  }, resolveCodeAction: e.resolveCodeAction });
}
function noe(i, e) {
  return Me.get(fe).documentFormattingEditProvider.register(i, e);
}
function soe(i, e) {
  return Me.get(fe).documentRangeFormattingEditProvider.register(i, e);
}
function ooe(i, e) {
  return Me.get(fe).onTypeFormattingEditProvider.register(i, e);
}
function roe(i, e) {
  return Me.get(fe).linkProvider.register(i, e);
}
function aoe(i, e) {
  return Me.get(fe).completionProvider.register(i, e);
}
function loe(i, e) {
  return Me.get(fe).colorProvider.register(i, e);
}
function doe(i, e) {
  return Me.get(fe).foldingRangeProvider.register(i, e);
}
function hoe(i, e) {
  return Me.get(fe).declarationProvider.register(i, e);
}
function coe(i, e) {
  return Me.get(fe).selectionRangeProvider.register(i, e);
}
function uoe(i, e) {
  return Me.get(fe).documentSemanticTokensProvider.register(i, e);
}
function goe(i, e) {
  return Me.get(fe).documentRangeSemanticTokensProvider.register(i, e);
}
function poe(i, e) {
  return Me.get(fe).inlineCompletionsProvider.register(i, e);
}
function moe(i, e) {
  return Me.get(fe).inlineEditProvider.register(i, e);
}
function foe(i, e) {
  return Me.get(fe).inlayHintsProvider.register(i, e);
}
const sP = tt("IEditorCancelService"), tH = new ae("cancellableOperation", !1, m(0, "Whether the editor runs a cancellable operation, e.g. like 'Peek References'"));
rt(sP, class {
  constructor() {
    this._tokens = /* @__PURE__ */ new WeakMap();
  }
  add(i, e) {
    let t, n = this._tokens.get(i);
    return n || (n = i.invokeWithinContext((s) => ({ key: tH.bindTo(s.get(Te)), tokens: new fs() })), this._tokens.set(i, n)), n.key.set(!0), t = n.tokens.push(e), () => {
      t && (t(), n.key.set(!n.tokens.isEmpty()), t = void 0);
    };
  }
  cancel(i) {
    const e = this._tokens.get(i);
    if (!e) return;
    const t = e.tokens.pop();
    t && (t.cancel(), e.key.set(!e.tokens.isEmpty()));
  }
}, 1);
class _oe extends Ci {
  constructor(e, t) {
    super(t), this.editor = e, this._unregister = e.invokeWithinContext((n) => n.get(sP).add(e, this));
  }
  dispose() {
    this._unregister(), super.dispose();
  }
}
re(new class extends Zi {
  constructor() {
    super({ id: "editor.cancelOperation", kbOpts: { weight: 100, primary: 9 }, precondition: tH });
  }
  runEditorCommand(i, e) {
    i.get(sP).cancel(e);
  }
}());
let iH = class tM {
  constructor(e, t) {
    if (this.flags = t, 1 & this.flags) {
      const n = e.getModel();
      this.modelVersionId = n ? rg("{0}#{1}", n.uri.toString(), n.getVersionId()) : null;
    } else this.modelVersionId = null;
    4 & this.flags ? this.position = e.getPosition() : this.position = null, 2 & this.flags ? this.selection = e.getSelection() : this.selection = null, 8 & this.flags ? (this.scrollLeft = e.getScrollLeft(), this.scrollTop = e.getScrollTop()) : (this.scrollLeft = -1, this.scrollTop = -1);
  }
  _equals(e) {
    if (!(e instanceof tM)) return !1;
    const t = e;
    return this.modelVersionId === t.modelVersionId && this.scrollLeft === t.scrollLeft && this.scrollTop === t.scrollTop && !(!this.position && t.position || this.position && !t.position || this.position && t.position && !this.position.equals(t.position)) && !(!this.selection && t.selection || this.selection && !t.selection || this.selection && t.selection && !this.selection.equalsRange(t.selection));
  }
  validate(e) {
    return this._equals(new tM(e, this.flags));
  }
};
class Mc extends _oe {
  constructor(e, t, n, s) {
    super(e, s), this._listener = new G(), 4 & t && this._listener.add(e.onDidChangeCursorPosition((o) => {
      n && D.containsPosition(n, o.position) || this.cancel();
    })), 2 & t && this._listener.add(e.onDidChangeCursorSelection((o) => {
      n && D.containsRange(n, o.selection) || this.cancel();
    })), 8 & t && this._listener.add(e.onDidScrollChange((o) => this.cancel())), 1 & t && (this._listener.add(e.onDidChangeModel((o) => this.cancel())), this._listener.add(e.onDidChangeModelContent((o) => this.cancel())));
  }
  dispose() {
    this._listener.dispose(), super.dispose();
  }
}
class oP extends Ci {
  constructor(e, t) {
    super(t), this._listener = e.onDidChangeContent(() => this.cancel());
  }
  dispose() {
    this._listener.dispose(), super.dispose();
  }
}
function yl(i) {
  return !(!i || typeof i.getEditorType != "function") && i.getEditorType() === w1.ICodeEditor;
}
function rP(i) {
  return !(!i || typeof i.getEditorType != "function") && i.getEditorType() === w1.IDiffEditor;
}
function nH(i) {
  return yl(i) ? i : rP(i) ? i.getModifiedEditor() : function(e) {
    return !!e && typeof e == "object" && typeof e.onDidChangeActiveEditor == "function";
  }(i) && yl(i.activeCodeEditor) ? i.activeCodeEditor : null;
}
class lf {
  static _handleEolEdits(e, t) {
    let n;
    const s = [];
    for (const o of t) typeof o.eol == "number" && (n = o.eol), o.range && typeof o.text == "string" && s.push(o);
    return typeof n == "number" && e.hasModel() && e.getModel().pushEOL(n), s;
  }
  static _isFullModelReplaceEdit(e, t) {
    if (!e.hasModel()) return !1;
    const n = e.getModel(), s = n.validateRange(t.range);
    return n.getFullModelRange().equalsRange(s);
  }
  static execute(e, t, n) {
    n && e.pushUndoStop();
    const s = ya.capture(e), o = lf._handleEolEdits(e, t);
    o.length === 1 && lf._isFullModelReplaceEdit(e, o[0]) ? e.executeEdits("formatEditsCommand", o.map((r) => ii.replace(D.lift(r.range), r.text))) : e.executeEdits("formatEditsCommand", o.map((r) => ii.replaceMove(D.lift(r.range), r.text))), n && e.pushUndoStop(), s.restoreRelativeVerticalPositionOfCursor(e);
  }
}
class ZF {
  constructor(e) {
    this.value = e, this._lower = e.toLowerCase();
  }
  static toKey(e) {
    return typeof e == "string" ? e.toLowerCase() : e._lower;
  }
}
class voe {
  constructor(e) {
    if (this._set = /* @__PURE__ */ new Set(), e) for (const t of e) this.add(t);
  }
  add(e) {
    this._set.add(ZF.toKey(e));
  }
  has(e) {
    return this._set.has(ZF.toKey(e));
  }
}
function sH(i, e, t) {
  const n = [], s = new voe(), o = i.ordered(t);
  for (const a of o) n.push(a), a.extensionId && s.add(a.extensionId);
  const r = e.ordered(t);
  for (const a of r) {
    if (a.extensionId) {
      if (s.has(a.extensionId)) continue;
      s.add(a.extensionId);
    }
    n.push({ displayName: a.displayName, extensionId: a.extensionId, provideDocumentFormattingEdits: (l, d, h) => a.provideDocumentRangeFormattingEdits(l, l.getFullModelRange(), d, h) });
  }
  return n;
}
class Cg {
  static setFormatterSelector(e) {
    return { dispose: Cg._selectors.unshift(e) };
  }
  static async select(e, t, n, s) {
    if (e.length === 0) return;
    const o = at.first(Cg._selectors);
    return o ? await o(e, t, n, s) : void 0;
  }
}
async function oH(i, e, t, n, s, o, r) {
  const a = i.get(Se), { documentRangeFormattingEditProvider: l } = i.get(fe), d = yl(e) ? e.getModel() : e, h = l.ordered(d), c = await Cg.select(h, d, n, 2);
  c && (s.report(c), await a.invokeFunction(boe, c, e, t, o, r));
}
async function boe(i, e, t, n, s, o) {
  var r, a;
  const l = i.get(Qo), d = i.get(ts), h = i.get(Fc);
  let c, u;
  yl(t) ? (c = t.getModel(), u = new Mc(t, 5, void 0, s)) : (c = t, u = new oP(t, s));
  const g = [];
  let p = 0;
  for (const C of KT(n).sort(D.compareRangesUsingStarts)) p > 0 && D.areIntersectingOrTouching(g[p - 1], C) ? g[p - 1] = D.fromPositions(g[p - 1].getStartPosition(), C.getEndPosition()) : p = g.push(C);
  const f = async (C) => {
    var w, y;
    d.trace("[format][provideDocumentRangeFormattingEdits] (request)", (w = e.extensionId) === null || w === void 0 ? void 0 : w.value, C);
    const L = await e.provideDocumentRangeFormattingEdits(c, C, c.getFormattingOptions(), u.token) || [];
    return d.trace("[format][provideDocumentRangeFormattingEdits] (response)", (y = e.extensionId) === null || y === void 0 ? void 0 : y.value, L), L;
  }, _ = (C, w) => {
    if (!C.length || !w.length) return !1;
    const y = C.reduce((L, k) => D.plusRange(L, k.range), C[0].range);
    if (!w.some((L) => D.intersectRanges(y, L.range))) return !1;
    for (const L of C) for (const k of w) if (D.intersectRanges(L.range, k.range)) return !0;
    return !1;
  }, v = [], b = [];
  try {
    if (typeof e.provideDocumentRangesFormattingEdits == "function") {
      d.trace("[format][provideDocumentRangeFormattingEdits] (request)", (r = e.extensionId) === null || r === void 0 ? void 0 : r.value, g);
      const C = await e.provideDocumentRangesFormattingEdits(c, g, c.getFormattingOptions(), u.token) || [];
      d.trace("[format][provideDocumentRangeFormattingEdits] (response)", (a = e.extensionId) === null || a === void 0 ? void 0 : a.value, C), b.push(C);
    } else {
      for (const C of g) {
        if (u.token.isCancellationRequested) return !0;
        b.push(await f(C));
      }
      for (let C = 0; C < g.length; ++C) for (let w = C + 1; w < g.length; ++w) {
        if (u.token.isCancellationRequested) return !0;
        if (_(b[C], b[w])) {
          const y = D.plusRange(g[C], g[w]), L = await f(y);
          g.splice(w, 1), g.splice(C, 1), g.push(y), b.splice(w, 1), b.splice(C, 1), b.push(L), C = 0, w = 0;
        }
      }
    }
    for (const C of b) {
      if (u.token.isCancellationRequested) return !0;
      const w = await l.computeMoreMinimalEdits(c.uri, C);
      w && v.push(...w);
    }
  } finally {
    u.dispose();
  }
  if (v.length === 0) return !1;
  if (yl(t)) lf.execute(t, v, !0), t.revealPositionInCenterIfOutsideViewport(t.getPosition(), 1);
  else {
    const [{ range: C }] = v, w = new _e(C.startLineNumber, C.startColumn, C.endLineNumber, C.endColumn);
    c.pushEditOperations([w], v.map((y) => ({ text: y.text, range: D.lift(y.range), forceMoveMarkers: !0 })), (y) => {
      for (const { range: L } of y) if (D.areIntersectingOrTouching(L, w)) return [new _e(L.startLineNumber, L.startColumn, L.endLineNumber, L.endColumn)];
      return null;
    });
  }
  return h.playSignal(He.format, { userGesture: o }), !0;
}
async function Coe(i, e, t, n, s, o) {
  const r = i.get(Se), a = i.get(fe), l = yl(e) ? e.getModel() : e, d = sH(a.documentFormattingEditProvider, a.documentRangeFormattingEditProvider, l), h = await Cg.select(d, l, t, 1);
  h && (n.report(h), await r.invokeFunction(woe, h, e, t, s, o));
}
async function woe(i, e, t, n, s, o) {
  const r = i.get(Qo), a = i.get(Fc);
  let l, d, h;
  yl(t) ? (l = t.getModel(), d = new Mc(t, 5, void 0, s)) : (l = t, d = new oP(t, s));
  try {
    const c = await e.provideDocumentFormattingEdits(l, l.getFormattingOptions(), d.token);
    if (h = await r.computeMoreMinimalEdits(l.uri, c), d.token.isCancellationRequested) return !0;
  } finally {
    d.dispose();
  }
  if (!h || h.length === 0) return !1;
  if (yl(t)) lf.execute(t, h, n !== 2), n !== 2 && t.revealPositionInCenterIfOutsideViewport(t.getPosition(), 1);
  else {
    const [{ range: c }] = h, u = new _e(c.startLineNumber, c.startColumn, c.endLineNumber, c.endColumn);
    l.pushEditOperations([u], h.map((g) => ({ text: g.text, range: D.lift(g.range), forceMoveMarkers: !0 })), (g) => {
      for (const { range: p } of g) if (D.areIntersectingOrTouching(p, u)) return [new _e(p.startLineNumber, p.startColumn, p.endLineNumber, p.endColumn)];
      return null;
    });
  }
  return a.playSignal(He.format, { userGesture: o }), !0;
}
function rH(i, e, t, n, s, o, r) {
  const a = e.onTypeFormattingEditProvider.ordered(t);
  return a.length === 0 || a[0].autoFormatTriggerCharacters.indexOf(s) < 0 ? Promise.resolve(void 0) : Promise.resolve(a[0].provideOnTypeFormattingEdits(t, n, s, o, r)).catch(Ni).then((l) => i.computeMoreMinimalEdits(t.uri, l));
}
Cg._selectors = new fs(), dt.registerCommand("_executeFormatRangeProvider", async function(i, ...e) {
  const [t, n, s] = e;
  vt(Ie.isUri(t)), vt(D.isIRange(n));
  const o = i.get(Ps), r = i.get(Qo), a = i.get(fe), l = await o.createModelReference(t);
  try {
    return async function(d, h, c, u, g, p) {
      const f = h.documentRangeFormattingEditProvider.ordered(c);
      for (const _ of f) {
        const v = await Promise.resolve(_.provideDocumentRangeFormattingEdits(c, u, g, p)).catch(Ni);
        if (zn(v)) return await d.computeMoreMinimalEdits(c.uri, v);
      }
    }(r, a, l.object.textEditorModel, D.lift(n), s, et.None);
  } finally {
    l.dispose();
  }
}), dt.registerCommand("_executeFormatDocumentProvider", async function(i, ...e) {
  const [t, n] = e;
  vt(Ie.isUri(t));
  const s = i.get(Ps), o = i.get(Qo), r = i.get(fe), a = await s.createModelReference(t);
  try {
    return async function(l, d, h, c, u) {
      const g = sH(d.documentFormattingEditProvider, d.documentRangeFormattingEditProvider, h);
      for (const p of g) {
        const f = await Promise.resolve(p.provideDocumentFormattingEdits(h, c, u)).catch(Ni);
        if (zn(f)) return await l.computeMoreMinimalEdits(h.uri, f);
      }
    }(o, r, a.object.textEditorModel, n, et.None);
  } finally {
    a.dispose();
  }
}), dt.registerCommand("_executeFormatOnTypeProvider", async function(i, ...e) {
  const [t, n, s, o] = e;
  vt(Ie.isUri(t)), vt(W.isIPosition(n)), vt(typeof s == "string");
  const r = i.get(Ps), a = i.get(Qo), l = i.get(fe), d = await r.createModelReference(t);
  try {
    return rH(a, l, d.object.textEditorModel, W.lift(n), s, o, et.None);
  } finally {
    d.dispose();
  }
}), ta.wrappingIndent.defaultValue = 0, ta.glyphMargin.defaultValue = !1, ta.autoIndent.defaultValue = 3, ta.overviewRulerLanes.defaultValue = 2, Cg.setFormatterSelector((i, e, t) => Promise.resolve(i[0]));
const ys = Y7();
ys.editor = { create: ese, getEditors: nse, getDiffEditors: sse, onDidCreateEditor: tse, onDidCreateDiffEditor: ise, createDiffEditor: ose, addCommand: ase, addEditorAction: lse, addKeybindingRule: dse, addKeybindingRules: XV, createModel: hse, setModelLanguage: cse, setModelMarkers: use, getModelMarkers: pse, removeAllMarkers: gse, onDidChangeMarkers: mse, getModels: _se, getModel: fse, onDidCreateModel: vse, onWillDisposeModel: bse, onDidChangeModelLanguage: Cse, createWebWorker: wse, colorizeElement: yse, colorize: Sse, colorizeModelLine: Lse, tokenize: kse, defineTheme: Dse, setTheme: xse, remeasureFonts: Nse, registerCommand: Ese, registerLinkOpener: Ise, registerEditorOpener: Mse, AccessibilitySupport: RN, ContentWidgetPositionPreference: WN, CursorChangeReason: VN, DefaultEndOfLine: HN, EditorAutoIndentStrategy: UN, EditorOption: KN, EndOfLinePreference: jN, EndOfLineSequence: qN, MinimapPosition: iE, MinimapSectionHeaderStyle: nE, MouseTargetType: sE, OverlayWidgetPositionPreference: rE, OverviewRulerLane: aE, GlyphMarginLane: $N, RenderLineNumbersType: hE, RenderMinimap: cE, ScrollbarVisibility: gE, ScrollType: uE, TextEditorCursorBlinkingStyle: bE, TextEditorCursorStyle: CE, TrackedRangeStickiness: wE, WrappingIndent: yE, InjectedTextCursorStops: ZN, PositionAffinity: dE, ShowLightbulbIconMode: mE, ConfigurationChangedEvent: E7, BareFontInfo: Ku, FontInfo: TE, TextModelResolvedOptions: AC, FindMatch: nv, ApplyUpdateResult: G_, EditorZoom: Vo, createMultiFileDiffEditor: rse, EditorType: w1, EditorOptions: ta }, ys.languages = { register: Ase, getLanguages: Pse, onLanguage: Fse, onLanguageEncountered: Bse, getEncodedLanguageId: Ose, setLanguageConfiguration: Wse, setColorMap: Hse, registerTokensProviderFactory: nP, setTokensProvider: zse, setMonarchTokensProvider: Use, registerReferenceProvider: Kse, registerRenameProvider: jse, registerNewSymbolNameProvider: qse, registerCompletionItemProvider: aoe, registerSignatureHelpProvider: $se, registerHoverProvider: Gse, registerDocumentSymbolProvider: Zse, registerDocumentHighlightProvider: Yse, registerLinkedEditingRangeProvider: Xse, registerDefinitionProvider: Qse, registerImplementationProvider: Jse, registerTypeDefinitionProvider: eoe, registerCodeLensProvider: toe, registerCodeActionProvider: ioe, registerDocumentFormattingEditProvider: noe, registerDocumentRangeFormattingEditProvider: soe, registerOnTypeFormattingEditProvider: ooe, registerLinkProvider: roe, registerColorProvider: loe, registerFoldingRangeProvider: doe, registerDeclarationProvider: hoe, registerSelectionRangeProvider: coe, registerDocumentSemanticTokensProvider: uoe, registerDocumentRangeSemanticTokensProvider: goe, registerInlineCompletionsProvider: poe, registerInlineEditProvider: moe, registerInlayHintsProvider: foe, DocumentHighlightKind: zN, CompletionItemKind: ON, CompletionItemTag: FN, CompletionItemInsertTextRule: PN, SymbolKind: _E, SymbolTag: vE, IndentAction: GN, CompletionTriggerKind: BN, SignatureHelpTriggerKind: fE, InlayHintKind: YN, InlineCompletionTriggerKind: XN, InlineEditTriggerKind: QN, CodeActionTriggerType: AN, NewSymbolNameTag: oE, PartialAcceptTriggerKind: lE, FoldingRangeKind: ls, SelectedSuggestionInfo: Z7 };
const aH = ys.CancellationTokenSource, aP = ys.Emitter, lH = ys.KeyCode, dH = ys.KeyMod, hH = ys.Position, cH = ys.Range, uH = ys.Selection, gH = ys.SelectionDirection, pH = ys.MarkerSeverity, mH = ys.MarkerTag, fH = ys.Uri, _H = ys.Token, vH = ys.editor, y0 = ys.languages, YF = globalThis.MonacoEnvironment;
(YF != null && YF.globalAPI || typeof define == "function" && define.amd) && (globalThis.monaco = ys), globalThis.require !== void 0 && typeof globalThis.require.config == "function" && globalThis.require.config({ ignoreDuplicateModules: ["vscode-languageserver-types", "vscode-languageserver-types/main", "vscode-languageserver-textdocument", "vscode-languageserver-textdocument/main", "vscode-nls", "vscode-nls/vscode-nls", "jsonc-parser", "jsonc-parser/main", "vscode-uri", "vscode-uri/index", "vs/basic-languages/typescript/typescript"] });
const jL = Object.freeze(Object.defineProperty({ __proto__: null, CancellationTokenSource: aH, Emitter: aP, KeyCode: lH, KeyMod: dH, MarkerSeverity: pH, MarkerTag: mH, Position: hH, Range: cH, Selection: uH, SelectionDirection: gH, Token: _H, Uri: fH, editor: vH, languages: y0 }, Symbol.toStringTag, { value: "Module" }));
var yoe = Object.defineProperty, Soe = Object.getOwnPropertyDescriptor, Loe = Object.getOwnPropertyNames, koe = Object.prototype.hasOwnProperty, P_ = {};
((i, e, t, n) => {
  if (e && typeof e == "object" || typeof e == "function") for (let s of Loe(e)) koe.call(i, s) || s === t || yoe(i, s, { get: () => e[s], enumerable: !(n = Soe(e, s)) || n.enumerable });
})(P_, jL, "default");
var bH = {}, gx = {}, Doe = class CH {
  static getOrCreate(e) {
    return gx[e] || (gx[e] = new CH(e)), gx[e];
  }
  constructor(e) {
    this._languageId = e, this._loadingTriggered = !1, this._lazyLoadPromise = new Promise((t, n) => {
      this._lazyLoadPromiseResolve = t, this._lazyLoadPromiseReject = n;
    });
  }
  load() {
    return this._loadingTriggered || (this._loadingTriggered = !0, bH[this._languageId].loader().then((e) => this._lazyLoadPromiseResolve(e), (e) => this._lazyLoadPromiseReject(e))), this._lazyLoadPromise;
  }
};
function Le(i) {
  const e = i.id;
  bH[e] = i, P_.languages.register(i);
  const t = Doe.getOrCreate(e);
  P_.languages.registerTokensProviderFactory(e, { create: async () => (await t.load()).language }), P_.languages.onLanguageEncountered(e, async () => {
    const n = await t.load();
    P_.languages.setLanguageConfiguration(e, n.conf);
  });
}
Le({ id: "abap", extensions: [".abap"], aliases: ["abap", "ABAP"], loader: () => import("./abap-Tr56a1Zm.js") }), Le({ id: "apex", extensions: [".cls"], aliases: ["Apex", "apex"], mimetypes: ["text/x-apex-source", "text/x-apex"], loader: () => import("./apex-B2QPdE43.js") }), Le({ id: "azcli", extensions: [".azcli"], aliases: ["Azure CLI", "azcli"], loader: () => import("./azcli-Btn7m3fD.js") }), Le({ id: "bat", extensions: [".bat", ".cmd"], aliases: ["Batch", "bat"], loader: () => import("./bat-ByTATCOl.js") }), Le({ id: "bicep", extensions: [".bicep"], aliases: ["Bicep"], loader: () => import("./bicep-BhEnY-uZ.js") }), Le({ id: "cameligo", extensions: [".mligo"], aliases: ["Cameligo"], loader: () => import("./cameligo-3LdHYQL-.js") }), Le({ id: "clojure", extensions: [".clj", ".cljs", ".cljc", ".edn"], aliases: ["clojure", "Clojure"], loader: () => import("./clojure-DjbhrUaB.js") }), Le({ id: "coffeescript", extensions: [".coffee"], aliases: ["CoffeeScript", "coffeescript", "coffee"], mimetypes: ["text/x-coffeescript", "text/coffeescript"], loader: () => import("./coffee-7FzaZYLM.js") }), Le({ id: "c", extensions: [".c", ".h"], aliases: ["C", "c"], loader: () => import("./cpp-Dv-XAjCK.js") }), Le({ id: "cpp", extensions: [".cpp", ".cc", ".cxx", ".hpp", ".hh", ".hxx"], aliases: ["C++", "Cpp", "cpp"], loader: () => import("./cpp-Dv-XAjCK.js") }), Le({ id: "csharp", extensions: [".cs", ".csx", ".cake"], aliases: ["C#", "csharp"], loader: () => import("./csharp-BZz0OSMf.js") }), Le({ id: "csp", extensions: [], aliases: ["CSP", "csp"], loader: () => import("./csp-ZfKUTqW0.js") }), Le({ id: "css", extensions: [".css"], aliases: ["CSS", "css"], mimetypes: ["text/css"], loader: () => import("./css-Bnm3Iei0.js") }), Le({ id: "cypher", extensions: [".cypher", ".cyp"], aliases: ["Cypher", "OpenCypher"], loader: () => import("./cypher-BFvd4W4v.js") }), Le({ id: "dart", extensions: [".dart"], aliases: ["Dart", "dart"], mimetypes: ["text/x-dart-source", "text/x-dart"], loader: () => import("./dart-DkaMDnmt.js") }), Le({ id: "dockerfile", extensions: [".dockerfile"], filenames: ["Dockerfile"], aliases: ["Dockerfile"], loader: () => import("./dockerfile-DFtjHw12.js") }), Le({ id: "ecl", extensions: [".ecl"], aliases: ["ECL", "Ecl", "ecl"], loader: () => import("./ecl-BtT9Hws7.js") }), Le({ id: "elixir", extensions: [".ex", ".exs"], aliases: ["Elixir", "elixir", "ex"], loader: () => import("./elixir-CZV6vub2.js") }), Le({ id: "flow9", extensions: [".flow"], aliases: ["Flow9", "Flow", "flow9", "flow"], loader: () => import("./flow9-elQvKHRe.js") }), Le({ id: "fsharp", extensions: [".fs", ".fsi", ".ml", ".mli", ".fsx", ".fsscript"], aliases: ["F#", "FSharp", "fsharp"], loader: () => import("./fsharp-CQsoCURP.js") }), Le({ id: "freemarker2", extensions: [".ftl", ".ftlh", ".ftlx"], aliases: ["FreeMarker2", "Apache FreeMarker2"], loader: () => import("./freemarker2-CsWRwxYA.js").then((i) => i.TagAutoInterpolationDollar) }), Le({ id: "freemarker2.tag-angle.interpolation-dollar", aliases: ["FreeMarker2 (Angle/Dollar)", "Apache FreeMarker2 (Angle/Dollar)"], loader: () => import("./freemarker2-CsWRwxYA.js").then((i) => i.TagAngleInterpolationDollar) }), Le({ id: "freemarker2.tag-bracket.interpolation-dollar", aliases: ["FreeMarker2 (Bracket/Dollar)", "Apache FreeMarker2 (Bracket/Dollar)"], loader: () => import("./freemarker2-CsWRwxYA.js").then((i) => i.TagBracketInterpolationDollar) }), Le({ id: "freemarker2.tag-angle.interpolation-bracket", aliases: ["FreeMarker2 (Angle/Bracket)", "Apache FreeMarker2 (Angle/Bracket)"], loader: () => import("./freemarker2-CsWRwxYA.js").then((i) => i.TagAngleInterpolationBracket) }), Le({ id: "freemarker2.tag-bracket.interpolation-bracket", aliases: ["FreeMarker2 (Bracket/Bracket)", "Apache FreeMarker2 (Bracket/Bracket)"], loader: () => import("./freemarker2-CsWRwxYA.js").then((i) => i.TagBracketInterpolationBracket) }), Le({ id: "freemarker2.tag-auto.interpolation-dollar", aliases: ["FreeMarker2 (Auto/Dollar)", "Apache FreeMarker2 (Auto/Dollar)"], loader: () => import("./freemarker2-CsWRwxYA.js").then((i) => i.TagAutoInterpolationDollar) }), Le({ id: "freemarker2.tag-auto.interpolation-bracket", aliases: ["FreeMarker2 (Auto/Bracket)", "Apache FreeMarker2 (Auto/Bracket)"], loader: () => import("./freemarker2-CsWRwxYA.js").then((i) => i.TagAutoInterpolationBracket) }), Le({ id: "go", extensions: [".go"], aliases: ["Go"], loader: () => import("./go-B6ANsLBK.js") }), Le({ id: "graphql", extensions: [".graphql", ".gql"], aliases: ["GraphQL", "graphql", "gql"], mimetypes: ["application/graphql"], loader: () => import("./graphql-CRNCUg8Q.js") }), Le({ id: "handlebars", extensions: [".handlebars", ".hbs"], aliases: ["Handlebars", "handlebars", "hbs"], mimetypes: ["text/x-handlebars-template"], loader: () => import("./handlebars-ska6UZG3.js") }), Le({ id: "hcl", extensions: [".tf", ".tfvars", ".hcl"], aliases: ["Terraform", "tf", "HCL", "hcl"], loader: () => import("./hcl-Dmsg-7yr.js") }), Le({ id: "html", extensions: [".html", ".htm", ".shtml", ".xhtml", ".mdoc", ".jsp", ".asp", ".aspx", ".jshtm"], aliases: ["HTML", "htm", "html", "xhtml"], mimetypes: ["text/html", "text/x-jshtm", "text/template", "text/ng-template"], loader: () => import("./html-DKQvtY-w.js") }), Le({ id: "ini", extensions: [".ini", ".properties", ".gitconfig"], filenames: ["config", ".gitattributes", ".gitconfig", ".editorconfig"], aliases: ["Ini", "ini"], loader: () => import("./ini-BJUuYG3X.js") }), Le({ id: "java", extensions: [".java", ".jav"], aliases: ["Java", "java"], mimetypes: ["text/x-java-source", "text/x-java"], loader: () => import("./java-Dyma2_Zy.js") }), Le({ id: "javascript", extensions: [".js", ".es6", ".jsx", ".mjs", ".cjs"], firstLine: "^#!.*\\bnode", filenames: ["jakefile"], aliases: ["JavaScript", "javascript", "js"], mimetypes: ["text/javascript"], loader: () => import("./javascript-BQjQnDFD.js") }), Le({ id: "julia", extensions: [".jl"], aliases: ["julia", "Julia"], loader: () => import("./julia-Bf8d5Nbk.js") }), Le({ id: "kotlin", extensions: [".kt", ".kts"], aliases: ["Kotlin", "kotlin"], mimetypes: ["text/x-kotlin-source", "text/x-kotlin"], loader: () => import("./kotlin-DX5ll4GS.js") }), Le({ id: "less", extensions: [".less"], aliases: ["Less", "less"], mimetypes: ["text/x-less", "text/less"], loader: () => import("./less-Cla7PKqn.js") }), Le({ id: "lexon", extensions: [".lex"], aliases: ["Lexon"], loader: () => import("./lexon-pCFSm_JI.js") }), Le({ id: "lua", extensions: [".lua"], aliases: ["Lua", "lua"], loader: () => import("./lua-DmFtFri_.js") }), Le({ id: "liquid", extensions: [".liquid", ".html.liquid"], aliases: ["Liquid", "liquid"], mimetypes: ["application/liquid"], loader: () => import("./liquid-BrC-Ey2T.js") }), Le({ id: "m3", extensions: [".m3", ".i3", ".mg", ".ig"], aliases: ["Modula-3", "Modula3", "modula3", "m3"], loader: () => import("./m3-CcliCMX8.js") }), Le({ id: "markdown", extensions: [".md", ".markdown", ".mdown", ".mkdn", ".mkd", ".mdwn", ".mdtxt", ".mdtext"], aliases: ["Markdown", "markdown"], loader: () => import("./markdown-BE16CdWC.js") }), Le({ id: "mdx", extensions: [".mdx"], aliases: ["MDX", "mdx"], loader: () => import("./mdx-Dp6RcUav.js") }), Le({ id: "mips", extensions: [".s"], aliases: ["MIPS", "MIPS-V"], mimetypes: ["text/x-mips", "text/mips", "text/plaintext"], loader: () => import("./mips-CZ5rJTWg.js") }), Le({ id: "msdax", extensions: [".dax", ".msdax"], aliases: ["DAX", "MSDAX"], loader: () => import("./msdax-Bvmv6_-6.js") }), Le({ id: "mysql", extensions: [], aliases: ["MySQL", "mysql"], loader: () => import("./mysql-CCUiKRFH.js") }), Le({ id: "objective-c", extensions: [".m"], aliases: ["Objective-C"], loader: () => import("./objective-c-DpBn7jMI.js") }), Le({ id: "pascal", extensions: [".pas", ".p", ".pp"], aliases: ["Pascal", "pas"], mimetypes: ["text/x-pascal-source", "text/x-pascal"], loader: () => import("./pascal-DheuMH6q.js") }), Le({ id: "pascaligo", extensions: [".ligo"], aliases: ["Pascaligo", "ligo"], loader: () => import("./pascaligo-EZ4nPFs_.js") }), Le({ id: "perl", extensions: [".pl", ".pm"], aliases: ["Perl", "pl"], loader: () => import("./perl-DsA-aB-_.js") }), Le({ id: "pgsql", extensions: [], aliases: ["PostgreSQL", "postgres", "pg", "postgre"], loader: () => import("./pgsql-DuAX-GK2.js") }), Le({ id: "php", extensions: [".php", ".php4", ".php5", ".phtml", ".ctp"], aliases: ["PHP", "php"], mimetypes: ["application/x-php"], loader: () => import("./php-BCR7iqV8.js") }), Le({ id: "pla", extensions: [".pla"], loader: () => import("./pla-B2fYjXXB.js") }), Le({ id: "postiats", extensions: [".dats", ".sats", ".hats"], aliases: ["ATS", "ATS/Postiats"], loader: () => import("./postiats-I3fntyTX.js") }), Le({ id: "powerquery", extensions: [".pq", ".pqm"], aliases: ["PQ", "M", "Power Query", "Power Query M"], loader: () => import("./powerquery-DXoCgcvh.js") }), Le({ id: "powershell", extensions: [".ps1", ".psm1", ".psd1"], aliases: ["PowerShell", "powershell", "ps", "ps1"], loader: () => import("./powershell-BOW6ItqY.js") }), Le({ id: "proto", extensions: [".proto"], aliases: ["protobuf", "Protocol Buffers"], loader: () => import("./protobuf-DUYs5q6s.js") }), Le({ id: "pug", extensions: [".jade", ".pug"], aliases: ["Pug", "Jade", "jade"], loader: () => import("./pug-DrAJxA5u.js") }), Le({ id: "python", extensions: [".py", ".rpy", ".pyw", ".cpy", ".gyp", ".gypi"], aliases: ["Python", "py"], firstLine: "^#!/.*\\bpython[0-9.-]*\\b", loader: () => import("./python-DykSTOx0.js") }), Le({ id: "qsharp", extensions: [".qs"], aliases: ["Q#", "qsharp"], loader: () => import("./qsharp-D1xHloYg.js") }), Le({ id: "r", extensions: [".r", ".rhistory", ".rmd", ".rprofile", ".rt"], aliases: ["R", "r"], loader: () => import("./r-CMHxhNVv.js") }), Le({ id: "razor", extensions: [".cshtml"], aliases: ["Razor", "razor"], mimetypes: ["text/x-cshtml"], loader: () => import("./razor-BhyV3JAg.js") }), Le({ id: "redis", extensions: [".redis"], aliases: ["redis"], loader: () => import("./redis-BcdKgvB8.js") }), Le({ id: "redshift", extensions: [], aliases: ["Redshift", "redshift"], loader: () => import("./redshift-CpWQF0fU.js") }), Le({ id: "restructuredtext", extensions: [".rst"], aliases: ["reStructuredText", "restructuredtext"], loader: () => import("./restructuredtext-CMNZjQgw.js") }), Le({ id: "ruby", extensions: [".rb", ".rbx", ".rjs", ".gemspec", ".pp"], filenames: ["rakefile", "Gemfile"], aliases: ["Ruby", "rb"], loader: () => import("./ruby-B_DAwuyk.js") }), Le({ id: "rust", extensions: [".rs", ".rlib"], aliases: ["Rust", "rust"], loader: () => import("./rust-BSPxeqCM.js") }), Le({ id: "sb", extensions: [".sb"], aliases: ["Small Basic", "sb"], loader: () => import("./sb-0xs4WOZO.js") }), Le({ id: "scala", extensions: [".scala", ".sc", ".sbt"], aliases: ["Scala", "scala", "SBT", "Sbt", "sbt", "Dotty", "dotty"], mimetypes: ["text/x-scala-source", "text/x-scala", "text/x-sbt", "text/x-dotty"], loader: () => import("./scala-CDUtQgZP.js") }), Le({ id: "scheme", extensions: [".scm", ".ss", ".sch", ".rkt"], aliases: ["scheme", "Scheme"], loader: () => import("./scheme-DTT6HxEC.js") }), Le({ id: "scss", extensions: [".scss"], aliases: ["Sass", "sass", "scss"], mimetypes: ["text/x-scss", "text/scss"], loader: () => import("./scss-bnVM9Ces.js") }), Le({ id: "shell", extensions: [".sh", ".bash"], aliases: ["Shell", "sh"], loader: () => import("./shell-CK2WEEgP.js") }), Le({ id: "sol", extensions: [".sol"], aliases: ["sol", "solidity", "Solidity"], loader: () => import("./solidity-qIY78QOQ.js") }), Le({ id: "aes", extensions: [".aes"], aliases: ["aes", "sophia", "Sophia"], loader: () => import("./sophia-dUW-Rpx-.js") }), Le({ id: "sparql", extensions: [".rq"], aliases: ["sparql", "SPARQL"], loader: () => import("./sparql-BeGvre3N.js") }), Le({ id: "sql", extensions: [".sql"], aliases: ["SQL"], loader: () => import("./sql-CK5iI7_1.js") }), Le({ id: "st", extensions: [".st", ".iecst", ".iecplc", ".lc3lib", ".TcPOU", ".TcDUT", ".TcGVL", ".TcIO"], aliases: ["StructuredText", "scl", "stl"], loader: () => import("./st-CwX2pLFB.js") }), Le({ id: "swift", aliases: ["Swift", "swift"], extensions: [".swift"], mimetypes: ["text/swift"], loader: () => import("./swift-C-YOpDhl.js") }), Le({ id: "systemverilog", extensions: [".sv", ".svh"], aliases: ["SV", "sv", "SystemVerilog", "systemverilog"], loader: () => import("./systemverilog-TF1oBkzk.js") }), Le({ id: "verilog", extensions: [".v", ".vh"], aliases: ["V", "v", "Verilog", "verilog"], loader: () => import("./systemverilog-TF1oBkzk.js") }), Le({ id: "tcl", extensions: [".tcl"], aliases: ["tcl", "Tcl", "tcltk", "TclTk", "tcl/tk", "Tcl/Tk"], loader: () => import("./tcl-Cm0weSIy.js") }), Le({ id: "twig", extensions: [".twig"], aliases: ["Twig", "twig"], mimetypes: ["text/x-twig"], loader: () => import("./twig-DsWCP9to.js") }), Le({ id: "typescript", extensions: [".ts", ".tsx", ".cts", ".mts"], aliases: ["TypeScript", "ts", "typescript"], mimetypes: ["text/typescript"], loader: () => import("./typescript-BRdUhxYR.js") }), Le({ id: "vb", extensions: [".vb"], aliases: ["Visual Basic", "vb"], loader: () => import("./vb-Dhcs4wOP.js") }), Le({ id: "wgsl", extensions: [".wgsl"], aliases: ["WebGPU Shading Language", "WGSL", "wgsl"], loader: () => import("./wgsl-vmUf8Zkn.js") }), Le({ id: "xml", extensions: [".xml", ".xsd", ".dtd", ".ascx", ".csproj", ".config", ".props", ".targets", ".wxi", ".wxl", ".wxs", ".xaml", ".svg", ".svgz", ".opf", ".xslt", ".xsl"], firstLine: "(\\<\\?xml.*)|(\\<svg)|(\\<\\!doctype\\s+svg)", aliases: ["XML", "xml"], mimetypes: ["text/xml", "application/xml", "application/xaml+xml", "application/xml-dtd"], loader: () => import("./xml-CIdW9u4N.js") }), Le({ id: "yaml", extensions: [".yaml", ".yml"], aliases: ["YAML", "yaml", "YML", "yml"], mimetypes: ["application/x-yaml", "text/x-yaml"], loader: () => import("./yaml-B5Q-vGBN.js") });
var xoe = Object.defineProperty, Noe = Object.getOwnPropertyDescriptor, Eoe = Object.getOwnPropertyNames, Ioe = Object.prototype.hasOwnProperty, Kp = {};
((i, e, t) => {
  ((n, s, o, r) => {
    if (s && typeof s == "object" || typeof s == "function") for (let a of Eoe(s)) Ioe.call(n, a) || a === o || xoe(n, a, { get: () => s[a], enumerable: !(r = Noe(s, a)) || r.enumerable });
  })(i, e, "default");
})(Kp, jL);
var lP = class {
  constructor(i, e, t) {
    this._onDidChange = new Kp.Emitter(), this._languageId = i, this.setOptions(e), this.setModeConfiguration(t);
  }
  get onDidChange() {
    return this._onDidChange.event;
  }
  get languageId() {
    return this._languageId;
  }
  get modeConfiguration() {
    return this._modeConfiguration;
  }
  get diagnosticsOptions() {
    return this.options;
  }
  get options() {
    return this._options;
  }
  setOptions(i) {
    this._options = i || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(this);
  }
  setDiagnosticsOptions(i) {
    this.setOptions(i);
  }
  setModeConfiguration(i) {
    this._modeConfiguration = i || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(this);
  }
}, dP = { validate: !0, lint: { compatibleVendorPrefixes: "ignore", vendorPrefix: "warning", duplicateProperties: "warning", emptyRules: "warning", importStatement: "ignore", boxModel: "ignore", universalSelector: "ignore", zeroUnits: "ignore", fontFaceProperties: "warning", hexColorLength: "error", argumentsInColorFunction: "error", unknownProperties: "warning", ieHack: "ignore", unknownVendorSpecificProperties: "ignore", propertyIgnoredDueToDisplay: "warning", important: "ignore", float: "ignore", idSelector: "ignore" }, data: { useDefaultDataProvider: !0 }, format: { newlineBetweenSelectors: !0, newlineBetweenRules: !0, spaceAroundSelectorSeparator: !1, braceStyle: "collapse", maxPreserveNewLines: void 0, preserveNewLines: !0 } }, hP = { completionItems: !0, hovers: !0, documentSymbols: !0, definitions: !0, references: !0, documentHighlights: !0, rename: !0, colors: !0, foldingRanges: !0, diagnostics: !0, selectionRanges: !0, documentFormattingEdits: !0, documentRangeFormattingEdits: !0 }, XF = new lP("css", dP, hP), QF = new lP("scss", dP, hP), JF = new lP("less", dP, hP);
function px() {
  return import("./cssMode-BuwNCwK7.js");
}
Kp.languages.css = { cssDefaults: XF, lessDefaults: JF, scssDefaults: QF }, Kp.languages.onLanguage("less", () => {
  px().then((i) => i.setupMode(JF));
}), Kp.languages.onLanguage("scss", () => {
  px().then((i) => i.setupMode(QF));
}), Kp.languages.onLanguage("css", () => {
  px().then((i) => i.setupMode(XF));
});
var Moe = Object.defineProperty, Toe = Object.getOwnPropertyDescriptor, Roe = Object.getOwnPropertyNames, Aoe = Object.prototype.hasOwnProperty, qL = {};
((i, e, t) => {
  ((n, s, o, r) => {
    if (s && typeof s == "object" || typeof s == "function") for (let a of Roe(s)) Aoe.call(n, a) || a === o || Moe(n, a, { get: () => s[a], enumerable: !(r = Toe(s, a)) || r.enumerable });
  })(i, e, "default");
})(qL, jL);
var Poe = class {
  constructor(i, e, t) {
    this._onDidChange = new qL.Emitter(), this._languageId = i, this.setOptions(e), this.setModeConfiguration(t);
  }
  get onDidChange() {
    return this._onDidChange.event;
  }
  get languageId() {
    return this._languageId;
  }
  get options() {
    return this._options;
  }
  get modeConfiguration() {
    return this._modeConfiguration;
  }
  setOptions(i) {
    this._options = i || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(this);
  }
  setModeConfiguration(i) {
    this._modeConfiguration = i || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(this);
  }
}, $L = { format: { tabSize: 4, insertSpaces: !1, wrapLineLength: 120, unformatted: 'default": "a, abbr, acronym, b, bdo, big, br, button, cite, code, dfn, em, i, img, input, kbd, label, map, object, q, samp, select, small, span, strong, sub, sup, textarea, tt, var', contentUnformatted: "pre", indentInnerHtml: !1, preserveNewLines: !0, maxPreserveNewLines: void 0, indentHandlebars: !1, endWithNewline: !1, extraLiners: "head, body, /html", wrapAttributes: "auto" }, suggest: {}, data: { useDefaultDataProvider: !0 } };
function GL(i) {
  return { completionItems: !0, hovers: !0, documentSymbols: !0, links: !0, documentHighlights: !0, rename: !0, colors: !0, foldingRanges: !0, selectionRanges: !0, diagnostics: i === S0, documentFormattingEdits: i === S0, documentRangeFormattingEdits: i === S0 };
}
var S0 = "html", e6 = "handlebars", t6 = "razor", wH = ZL(S0, $L, GL(S0)), Ooe = wH.defaults, yH = ZL(e6, $L, GL(e6)), Foe = yH.defaults, SH = ZL(t6, $L, GL(t6)), Boe = SH.defaults;
function ZL(i, e = $L, t = GL(i)) {
  const n = new Poe(i, e, t);
  let s;
  const o = qL.languages.onLanguage(i, async () => {
    s = (await import("./htmlMode-BDfUpOQv.js")).setupMode(n);
  });
  return { defaults: n, dispose() {
    o.dispose(), s == null || s.dispose(), s = void 0;
  } };
}
qL.languages.html = { htmlDefaults: Ooe, razorDefaults: Boe, handlebarDefaults: Foe, htmlLanguageService: wH, handlebarLanguageService: yH, razorLanguageService: SH, registerHTMLLanguageService: ZL };
var i6 = new class {
  constructor(i, e, t) {
    this._onDidChange = new aP(), this._languageId = i, this.setDiagnosticsOptions(e), this.setModeConfiguration(t);
  }
  get onDidChange() {
    return this._onDidChange.event;
  }
  get languageId() {
    return this._languageId;
  }
  get modeConfiguration() {
    return this._modeConfiguration;
  }
  get diagnosticsOptions() {
    return this._diagnosticsOptions;
  }
  setDiagnosticsOptions(i) {
    this._diagnosticsOptions = i || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(this);
  }
  setModeConfiguration(i) {
    this._modeConfiguration = i || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(this);
  }
}("json", { validate: !0, allowComments: !0, schemas: [], enableSchemaRequest: !1, schemaRequest: "warning", schemaValidation: "warning", comments: "error", trailingCommas: "error" }, { documentFormattingEdits: !0, documentRangeFormattingEdits: !0, completionItems: !0, hovers: !0, documentSymbols: !0, tokens: !0, colors: !0, foldingRanges: !0, diagnostics: !0, selectionRanges: !0 });
function n6() {
  return import("./jsonMode-B260-GUT.js");
}
y0.json = { jsonDefaults: i6, getWorker: () => n6().then((i) => i.getWorker()) }, y0.register({ id: "json", extensions: [".json", ".bowerrc", ".jshintrc", ".jscsrc", ".eslintrc", ".babelrc", ".har"], aliases: ["JSON", "json"], mimetypes: ["application/json"] }), y0.onLanguage("json", () => {
  n6().then((i) => i.setupMode(i6));
});
var Woe = Object.defineProperty, Voe = Object.getOwnPropertyDescriptor, Hoe = Object.getOwnPropertyNames, zoe = Object.prototype.hasOwnProperty, ym = {};
((i, e, t) => {
  ((n, s, o, r) => {
    if (s && typeof s == "object" || typeof s == "function") for (let a of Hoe(s)) zoe.call(n, a) || a === o || Woe(n, a, { get: () => s[a], enumerable: !(r = Voe(s, a)) || r.enumerable });
  })(i, e, "default");
})(ym, jL);
var LH = ((i) => (i[i.None = 0] = "None", i[i.CommonJS = 1] = "CommonJS", i[i.AMD = 2] = "AMD", i[i.UMD = 3] = "UMD", i[i.System = 4] = "System", i[i.ES2015 = 5] = "ES2015", i[i.ESNext = 99] = "ESNext", i))(LH || {}), kH = ((i) => (i[i.None = 0] = "None", i[i.Preserve = 1] = "Preserve", i[i.React = 2] = "React", i[i.ReactNative = 3] = "ReactNative", i[i.ReactJSX = 4] = "ReactJSX", i[i.ReactJSXDev = 5] = "ReactJSXDev", i))(kH || {}), DH = ((i) => (i[i.CarriageReturnLineFeed = 0] = "CarriageReturnLineFeed", i[i.LineFeed = 1] = "LineFeed", i))(DH || {}), xH = ((i) => (i[i.ES3 = 0] = "ES3", i[i.ES5 = 1] = "ES5", i[i.ES2015 = 2] = "ES2015", i[i.ES2016 = 3] = "ES2016", i[i.ES2017 = 4] = "ES2017", i[i.ES2018 = 5] = "ES2018", i[i.ES2019 = 6] = "ES2019", i[i.ES2020 = 7] = "ES2020", i[i.ESNext = 99] = "ESNext", i[i.JSON = 100] = "JSON", i[i.Latest = 99] = "Latest", i))(xH || {}), NH = ((i) => (i[i.Classic = 1] = "Classic", i[i.NodeJs = 2] = "NodeJs", i))(NH || {}), EH = class {
  constructor(i, e, t, n, s) {
    this._onDidChange = new ym.Emitter(), this._onDidExtraLibsChange = new ym.Emitter(), this._extraLibs = /* @__PURE__ */ Object.create(null), this._removedExtraLibs = /* @__PURE__ */ Object.create(null), this._eagerModelSync = !1, this.setCompilerOptions(i), this.setDiagnosticsOptions(e), this.setWorkerOptions(t), this.setInlayHintsOptions(n), this.setModeConfiguration(s), this._onDidExtraLibsChangeTimeout = -1;
  }
  get onDidChange() {
    return this._onDidChange.event;
  }
  get onDidExtraLibsChange() {
    return this._onDidExtraLibsChange.event;
  }
  get modeConfiguration() {
    return this._modeConfiguration;
  }
  get workerOptions() {
    return this._workerOptions;
  }
  get inlayHintsOptions() {
    return this._inlayHintsOptions;
  }
  getExtraLibs() {
    return this._extraLibs;
  }
  addExtraLib(i, e) {
    let t;
    if (t = e === void 0 ? `ts:extralib-${Math.random().toString(36).substring(2, 15)}` : e, this._extraLibs[t] && this._extraLibs[t].content === i) return { dispose: () => {
    } };
    let n = 1;
    return this._removedExtraLibs[t] && (n = this._removedExtraLibs[t] + 1), this._extraLibs[t] && (n = this._extraLibs[t].version + 1), this._extraLibs[t] = { content: i, version: n }, this._fireOnDidExtraLibsChangeSoon(), { dispose: () => {
      let s = this._extraLibs[t];
      s && s.version === n && (delete this._extraLibs[t], this._removedExtraLibs[t] = n, this._fireOnDidExtraLibsChangeSoon());
    } };
  }
  setExtraLibs(i) {
    for (const e in this._extraLibs) this._removedExtraLibs[e] = this._extraLibs[e].version;
    if (this._extraLibs = /* @__PURE__ */ Object.create(null), i && i.length > 0) for (const e of i) {
      const t = e.filePath || `ts:extralib-${Math.random().toString(36).substring(2, 15)}`, n = e.content;
      let s = 1;
      this._removedExtraLibs[t] && (s = this._removedExtraLibs[t] + 1), this._extraLibs[t] = { content: n, version: s };
    }
    this._fireOnDidExtraLibsChangeSoon();
  }
  _fireOnDidExtraLibsChangeSoon() {
    this._onDidExtraLibsChangeTimeout === -1 && (this._onDidExtraLibsChangeTimeout = window.setTimeout(() => {
      this._onDidExtraLibsChangeTimeout = -1, this._onDidExtraLibsChange.fire(void 0);
    }, 0));
  }
  getCompilerOptions() {
    return this._compilerOptions;
  }
  setCompilerOptions(i) {
    this._compilerOptions = i || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(void 0);
  }
  getDiagnosticsOptions() {
    return this._diagnosticsOptions;
  }
  setDiagnosticsOptions(i) {
    this._diagnosticsOptions = i || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(void 0);
  }
  setWorkerOptions(i) {
    this._workerOptions = i || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(void 0);
  }
  setInlayHintsOptions(i) {
    this._inlayHintsOptions = i || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(void 0);
  }
  setMaximumWorkerIdleTime(i) {
  }
  setEagerModelSync(i) {
    this._eagerModelSync = i;
  }
  getEagerModelSync() {
    return this._eagerModelSync;
  }
  setModeConfiguration(i) {
    this._modeConfiguration = i || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(void 0);
  }
}, IH = { completionItems: !0, hovers: !0, documentSymbols: !0, definitions: !0, references: !0, documentHighlights: !0, rename: !0, diagnostics: !0, documentRangeFormattingEdits: !0, signatureHelp: !0, onTypeFormattingEdits: !0, codeActions: !0, inlayHints: !0 }, s6 = new EH({ allowNonTsExtensions: !0, target: 99 }, { noSemanticValidation: !1, noSyntaxValidation: !1, onlyVisible: !1 }, {}, {}, IH), o6 = new EH({ allowNonTsExtensions: !0, allowJs: !0, target: 99 }, { noSemanticValidation: !0, noSyntaxValidation: !1, onlyVisible: !1 }, {}, {}, IH);
function Gb() {
  return import("./tsMode-D3GdzCuv.js");
}
ym.languages.typescript = { ModuleKind: LH, JsxEmit: kH, NewLineKind: DH, ScriptTarget: xH, ModuleResolutionKind: NH, typescriptVersion: "5.0.2", typescriptDefaults: s6, javascriptDefaults: o6, getTypeScriptWorker: () => Gb().then((i) => i.getTypeScriptWorker()), getJavaScriptWorker: () => Gb().then((i) => i.getJavaScriptWorker()) }, ym.languages.onLanguage("typescript", () => Gb().then((i) => i.setupTypeScript(s6))), ym.languages.onLanguage("javascript", () => Gb().then((i) => i.setupJavaScript(o6)));
class r6 extends cs {
  constructor() {
    super({ id: "diffEditor.toggleShowMovedCodeBlocks", title: ct(0, "Toggle Show Moved Code Blocks"), precondition: q.has("isInDiffEditor") });
  }
  run(e, ...t) {
    const n = e.get(Ye), s = !n.getValue("diffEditor.experimental.showMoves");
    n.updateValue("diffEditor.experimental.showMoves", s);
  }
}
class a6 extends cs {
  constructor() {
    super({ id: "diffEditor.toggleUseInlineViewWhenSpaceIsLimited", title: ct(0, "Toggle Use Inline View When Space Is Limited"), precondition: q.has("isInDiffEditor") });
  }
  run(e, ...t) {
    const n = e.get(Ye), s = !n.getValue("diffEditor.useInlineViewWhenSpaceIsLimited");
    n.updateValue("diffEditor.useInlineViewWhenSpaceIsLimited", s);
  }
}
const O_ = ct(0, "Diff Editor");
class iM extends cs {
  constructor() {
    super({ id: "diffEditor.revert", title: ct(0, "Revert"), f1: !1, category: O_ });
  }
  run(e, t) {
    var n;
    const s = function(o, r, a) {
      return o.get(mt).listDiffEditors().find((d) => {
        var h, c;
        const u = d.getModifiedEditor(), g = d.getOriginalEditor();
        return u && ((h = u.getModel()) === null || h === void 0 ? void 0 : h.uri.toString()) === a.toString() && g && ((c = g.getModel()) === null || c === void 0 ? void 0 : c.uri.toString()) === r.toString();
      }) || null;
    }(e, t.originalUri, t.modifiedUri);
    s instanceof wd && s.revertRangeMappings((n = t.mapping.innerChanges) !== null && n !== void 0 ? n : []);
  }
}
const MH = ct(0, "Accessible Diff Viewer");
class Sm extends cs {
  constructor() {
    super({ id: Sm.id, title: ct(0, "Go to Next Difference"), category: MH, precondition: q.has("isInDiffEditor"), keybinding: { primary: 65, weight: 100 }, f1: !0 });
  }
  run(e) {
    const t = jp(e);
    t == null || t.accessibleDiffViewerNext();
  }
}
Sm.id = "editor.action.accessibleDiffViewer.next";
class Yv extends cs {
  constructor() {
    super({ id: Yv.id, title: ct(0, "Go to Previous Difference"), category: MH, precondition: q.has("isInDiffEditor"), keybinding: { primary: 1089, weight: 100 }, f1: !0 });
  }
  run(e) {
    const t = jp(e);
    t == null || t.accessibleDiffViewerPrev();
  }
}
function jp(i) {
  const e = i.get(mt).listDiffEditors(), t = Mn();
  if (t) {
    for (const n of e)
      if (Uoe(n.getContainerDomNode(), t)) return n;
  }
  return null;
}
function Uoe(i, e) {
  let t = e;
  for (; t; ) {
    if (t === i) return !0;
    t = t.parentElement;
  }
  return !1;
}
Yv.id = "editor.action.accessibleDiffViewer.prev", Ft(class extends cs {
  constructor() {
    super({ id: "diffEditor.toggleCollapseUnchangedRegions", title: ct(0, "Toggle Collapse Unchanged Regions"), icon: ne.map, toggled: q.has("config.diffEditor.hideUnchangedRegions.enabled"), precondition: q.has("isInDiffEditor"), menu: { when: q.has("isInDiffEditor"), id: x.EditorTitle, order: 22, group: "navigation" } });
  }
  run(i, ...e) {
    const t = i.get(Ye), n = !t.getValue("diffEditor.hideUnchangedRegions.enabled");
    t.updateValue("diffEditor.hideUnchangedRegions.enabled", n);
  }
}), Ft(r6), Ft(a6), tn.appendMenuItem(x.EditorTitle, { command: { id: new a6().desc.id, title: m(0, "Use Inline View When Space Is Limited"), toggled: q.has("config.diffEditor.useInlineViewWhenSpaceIsLimited"), precondition: q.has("isInDiffEditor") }, order: 11, group: "1_diff", when: q.and(E.diffEditorRenderSideBySideInlineBreakpointReached, q.has("isInDiffEditor")) }), tn.appendMenuItem(x.EditorTitle, { command: { id: new r6().desc.id, title: m(0, "Show Moved Code Blocks"), icon: ne.move, toggled: pf.create("config.diffEditor.experimental.showMoves", !0), precondition: q.has("isInDiffEditor") }, order: 10, group: "1_diff", when: q.has("isInDiffEditor") }), Ft(iM);
for (const i of [{ icon: ne.arrowRight, key: E.diffEditorInlineMode.toNegated() }, { icon: ne.discard, key: E.diffEditorInlineMode }]) tn.appendMenuItem(x.DiffEditorHunkToolbar, { command: { id: new iM().desc.id, title: m(0, "Revert Block"), icon: i.icon }, when: q.and(E.diffEditorModifiedWritable, i.key), order: 5, group: "primary" }), tn.appendMenuItem(x.DiffEditorSelectionToolbar, { command: { id: new iM().desc.id, title: m(0, "Revert Selection"), icon: i.icon }, when: q.and(E.diffEditorModifiedWritable, i.key), order: 5, group: "primary" });
Ft(class extends Qr {
  constructor() {
    super({ id: "diffEditor.switchSide", title: ct(0, "Switch Side"), icon: ne.arrowSwap, precondition: q.has("isInDiffEditor"), f1: !0, category: O_ });
  }
  runEditorCommand(i, e, t) {
    const n = jp(i);
    if (n instanceof wd) {
      if (t && t.dryRun) return { destinationSelection: n.mapToOtherSide().destinationSelection };
      n.switchSide();
    }
  }
}), Ft(class extends Qr {
  constructor() {
    super({ id: "diffEditor.exitCompareMove", title: ct(0, "Exit Compare Move"), icon: ne.close, precondition: E.comparingMovedCode, f1: !1, category: O_, keybinding: { weight: 1e4, primary: 9 } });
  }
  runEditorCommand(i, e, ...t) {
    const n = jp(i);
    n instanceof wd && n.exitCompareMove();
  }
}), Ft(class extends Qr {
  constructor() {
    super({ id: "diffEditor.collapseAllUnchangedRegions", title: ct(0, "Collapse All Unchanged Regions"), icon: ne.fold, precondition: q.has("isInDiffEditor"), f1: !0, category: O_ });
  }
  runEditorCommand(i, e, ...t) {
    const n = jp(i);
    n instanceof wd && n.collapseAllUnchangedRegions();
  }
}), Ft(class extends Qr {
  constructor() {
    super({ id: "diffEditor.showAllUnchangedRegions", title: ct(0, "Show All Unchanged Regions"), icon: ne.unfold, precondition: q.has("isInDiffEditor"), f1: !0, category: O_ });
  }
  runEditorCommand(i, e, ...t) {
    const n = jp(i);
    n instanceof wd && n.showAllUnchangedRegions();
  }
}), tn.appendMenuItem(x.EditorTitle, { command: { id: Sm.id, title: m(0, "Open Accessible Diff Viewer"), precondition: q.has("isInDiffEditor") }, order: 10, group: "2_diff", when: q.and(E.accessibleDiffViewerVisible.negate(), q.has("isInDiffEditor")) }), dt.registerCommandAlias("editor.action.diffReview.next", Sm.id), Ft(Sm), dt.registerCommandAlias("editor.action.diffReview.prev", Yv.id), Ft(Yv);
var nM, Koe = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, joe = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const lw = new ae("selectionAnchorSet", !1);
let $l = nM = class {
  static get(i) {
    return i.getContribution(nM.ID);
  }
  constructor(i, e) {
    this.editor = i, this.selectionAnchorSetContextKey = lw.bindTo(e), this.modelChangeListener = i.onDidChangeModel(() => this.selectionAnchorSetContextKey.reset());
  }
  setSelectionAnchor() {
    if (this.editor.hasModel()) {
      const i = this.editor.getPosition();
      this.editor.changeDecorations((e) => {
        this.decorationId && e.removeDecoration(this.decorationId), this.decorationId = e.addDecoration(_e.fromPositions(i, i), { description: "selection-anchor", stickiness: 1, hoverMessage: new Vn().appendText(m(0, "Selection Anchor")), className: "selection-anchor" });
      }), this.selectionAnchorSetContextKey.set(!!this.decorationId), Io(m(0, "Anchor set at {0}:{1}", i.lineNumber, i.column));
    }
  }
  goToSelectionAnchor() {
    if (this.editor.hasModel() && this.decorationId) {
      const i = this.editor.getModel().getDecorationRange(this.decorationId);
      i && this.editor.setPosition(i.getStartPosition());
    }
  }
  selectFromAnchorToCursor() {
    if (this.editor.hasModel() && this.decorationId) {
      const i = this.editor.getModel().getDecorationRange(this.decorationId);
      if (i) {
        const e = this.editor.getPosition();
        this.editor.setSelection(_e.fromPositions(i.getStartPosition(), e)), this.cancelSelectionAnchor();
      }
    }
  }
  cancelSelectionAnchor() {
    if (this.decorationId) {
      const i = this.decorationId;
      this.editor.changeDecorations((e) => {
        e.removeDecoration(i), this.decorationId = void 0;
      }), this.selectionAnchorSetContextKey.set(!1);
    }
  }
  dispose() {
    this.cancelSelectionAnchor(), this.modelChangeListener.dispose();
  }
};
$l.ID = "editor.contrib.selectionAnchorController", $l = nM = Koe([joe(1, Te)], $l);
ft($l.ID, $l, 4), X(class extends he {
  constructor() {
    super({ id: "editor.action.setSelectionAnchor", label: m(0, "Set Selection Anchor"), alias: "Set Selection Anchor", precondition: void 0, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2080), weight: 100 } });
  }
  async run(i, e) {
    var t;
    (t = $l.get(e)) === null || t === void 0 || t.setSelectionAnchor();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.goToSelectionAnchor", label: m(0, "Go to Selection Anchor"), alias: "Go to Selection Anchor", precondition: lw });
  }
  async run(i, e) {
    var t;
    (t = $l.get(e)) === null || t === void 0 || t.goToSelectionAnchor();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.selectFromAnchorToCursor", label: m(0, "Select from Anchor to Cursor"), alias: "Select from Anchor to Cursor", precondition: lw, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2089), weight: 100 } });
  }
  async run(i, e) {
    var t;
    (t = $l.get(e)) === null || t === void 0 || t.selectFromAnchorToCursor();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.cancelSelectionAnchor", label: m(0, "Cancel Selection Anchor"), alias: "Cancel Selection Anchor", precondition: lw, kbOpts: { kbExpr: E.editorTextFocus, primary: 9, weight: 100 } });
  }
  async run(i, e) {
    var t;
    (t = $l.get(e)) === null || t === void 0 || t.cancelSelectionAnchor();
  }
});
const qoe = I("editorOverviewRuler.bracketMatchForeground", { dark: "#A0A0A0", light: "#A0A0A0", hcDark: "#A0A0A0", hcLight: "#A0A0A0" }, m(0, "Overview ruler marker color for matching brackets."));
class $oe {
  constructor(e, t, n) {
    this.position = e, this.brackets = t, this.options = n;
  }
}
class pr extends V {
  static get(e) {
    return e.getContribution(pr.ID);
  }
  constructor(e) {
    super(), this._editor = e, this._lastBracketsData = [], this._lastVersionId = 0, this._decorations = this._editor.createDecorationsCollection(), this._updateBracketsSoon = this._register(new It(() => this._updateBrackets(), 50)), this._matchBrackets = this._editor.getOption(72), this._updateBracketsSoon.schedule(), this._register(e.onDidChangeCursorPosition((t) => {
      this._matchBrackets !== "never" && this._updateBracketsSoon.schedule();
    })), this._register(e.onDidChangeModelContent((t) => {
      this._updateBracketsSoon.schedule();
    })), this._register(e.onDidChangeModel((t) => {
      this._lastBracketsData = [], this._updateBracketsSoon.schedule();
    })), this._register(e.onDidChangeModelLanguageConfiguration((t) => {
      this._lastBracketsData = [], this._updateBracketsSoon.schedule();
    })), this._register(e.onDidChangeConfiguration((t) => {
      t.hasChanged(72) && (this._matchBrackets = this._editor.getOption(72), this._decorations.clear(), this._lastBracketsData = [], this._lastVersionId = 0, this._updateBracketsSoon.schedule());
    })), this._register(e.onDidBlurEditorWidget(() => {
      this._updateBracketsSoon.schedule();
    })), this._register(e.onDidFocusEditorWidget(() => {
      this._updateBracketsSoon.schedule();
    }));
  }
  jumpToBracket() {
    if (!this._editor.hasModel()) return;
    const e = this._editor.getModel(), t = this._editor.getSelections().map((n) => {
      const s = n.getStartPosition(), o = e.bracketPairs.matchBracket(s);
      let r = null;
      if (o) o[0].containsPosition(s) && !o[1].containsPosition(s) ? r = o[1].getStartPosition() : o[1].containsPosition(s) && (r = o[0].getStartPosition());
      else {
        const a = e.bracketPairs.findEnclosingBrackets(s);
        if (a) r = a[1].getStartPosition();
        else {
          const l = e.bracketPairs.findNextBracket(s);
          l && l.range && (r = l.range.getStartPosition());
        }
      }
      return r ? new _e(r.lineNumber, r.column, r.lineNumber, r.column) : new _e(s.lineNumber, s.column, s.lineNumber, s.column);
    });
    this._editor.setSelections(t), this._editor.revealRange(t[0]);
  }
  selectToBracket(e) {
    if (!this._editor.hasModel()) return;
    const t = this._editor.getModel(), n = [];
    this._editor.getSelections().forEach((s) => {
      const o = s.getStartPosition();
      let r = t.bracketPairs.matchBracket(o);
      if (!r && (r = t.bracketPairs.findEnclosingBrackets(o), !r)) {
        const d = t.bracketPairs.findNextBracket(o);
        d && d.range && (r = t.bracketPairs.matchBracket(d.range.getStartPosition()));
      }
      let a = null, l = null;
      if (r) {
        r.sort(D.compareRangesUsingStarts);
        const [d, h] = r;
        if (a = e ? d.getStartPosition() : d.getEndPosition(), l = e ? h.getEndPosition() : h.getStartPosition(), h.containsPosition(o)) {
          const c = a;
          a = l, l = c;
        }
      }
      a && l && n.push(new _e(a.lineNumber, a.column, l.lineNumber, l.column));
    }), n.length > 0 && (this._editor.setSelections(n), this._editor.revealRange(n[0]));
  }
  removeBrackets(e) {
    if (!this._editor.hasModel()) return;
    const t = this._editor.getModel();
    this._editor.getSelections().forEach((n) => {
      const s = n.getPosition();
      let o = t.bracketPairs.matchBracket(s);
      o || (o = t.bracketPairs.findEnclosingBrackets(s)), o && (this._editor.pushUndoStop(), this._editor.executeEdits(e, [{ range: o[0], text: "" }, { range: o[1], text: "" }]), this._editor.pushUndoStop());
    });
  }
  _updateBrackets() {
    if (this._matchBrackets === "never") return;
    this._recomputeBrackets();
    const e = [];
    let t = 0;
    for (const n of this._lastBracketsData) {
      const s = n.brackets;
      s && (e[t++] = { range: s[0], options: n.options }, e[t++] = { range: s[1], options: n.options });
    }
    this._decorations.set(e);
  }
  _recomputeBrackets() {
    if (!this._editor.hasModel() || !this._editor.hasWidgetFocus()) return this._lastBracketsData = [], void (this._lastVersionId = 0);
    const e = this._editor.getSelections();
    if (e.length > 100) return this._lastBracketsData = [], void (this._lastVersionId = 0);
    const t = this._editor.getModel(), n = t.getVersionId();
    let s = [];
    this._lastVersionId === n && (s = this._lastBracketsData);
    const o = [];
    let r = 0;
    for (let c = 0, u = e.length; c < u; c++) {
      const g = e[c];
      g.isEmpty() && (o[r++] = g.getStartPosition());
    }
    o.length > 1 && o.sort(W.compare);
    const a = [];
    let l = 0, d = 0;
    const h = s.length;
    for (let c = 0, u = o.length; c < u; c++) {
      const g = o[c];
      for (; d < h && s[d].position.isBefore(g); ) d++;
      if (d < h && s[d].position.equals(g)) a[l++] = s[d];
      else {
        let p = t.bracketPairs.matchBracket(g, 20), f = pr._DECORATION_OPTIONS_WITH_OVERVIEW_RULER;
        p || this._matchBrackets !== "always" || (p = t.bracketPairs.findEnclosingBrackets(g, 20), f = pr._DECORATION_OPTIONS_WITHOUT_OVERVIEW_RULER), a[l++] = new $oe(g, p, f);
      }
    }
    this._lastBracketsData = a, this._lastVersionId = n;
  }
}
pr.ID = "editor.contrib.bracketMatchingController", pr._DECORATION_OPTIONS_WITH_OVERVIEW_RULER = Ve.register({ description: "bracket-match-overview", stickiness: 1, className: "bracket-match", overviewRuler: { color: ui(qoe), position: Do.Center } }), pr._DECORATION_OPTIONS_WITHOUT_OVERVIEW_RULER = Ve.register({ description: "bracket-match-no-overview", stickiness: 1, className: "bracket-match" }), ft(pr.ID, pr, 1), X(class extends he {
  constructor() {
    super({ id: "editor.action.selectToBracket", label: m(0, "Select to Bracket"), alias: "Select to Bracket", precondition: void 0, metadata: { description: ct(0, "Select the text inside and including the brackets or curly braces"), args: [{ name: "args", schema: { type: "object", properties: { selectBrackets: { type: "boolean", default: !0 } } } }] } });
  }
  run(i, e, t) {
    var n;
    let s = !0;
    t && t.selectBrackets === !1 && (s = !1), (n = pr.get(e)) === null || n === void 0 || n.selectToBracket(s);
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.jumpToBracket", label: m(0, "Go to Bracket"), alias: "Go to Bracket", precondition: void 0, kbOpts: { kbExpr: E.editorTextFocus, primary: 3165, weight: 100 } });
  }
  run(i, e) {
    var t;
    (t = pr.get(e)) === null || t === void 0 || t.jumpToBracket();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.removeBrackets", label: m(0, "Remove Brackets"), alias: "Remove Brackets", precondition: void 0, kbOpts: { kbExpr: E.editorTextFocus, primary: 2561, weight: 100 } });
  }
  run(i, e) {
    var t;
    (t = pr.get(e)) === null || t === void 0 || t.removeBrackets(this.id);
  }
}), tn.appendMenuItem(x.MenubarGoMenu, { group: "5_infile_nav", command: { id: "editor.action.jumpToBracket", title: m(0, "Go to &&Bracket") }, order: 2 });
class Goe {
  constructor(e, t) {
    this._selection = e, this._isMovingLeft = t;
  }
  getEditOperations(e, t) {
    if (this._selection.startLineNumber !== this._selection.endLineNumber || this._selection.isEmpty()) return;
    const n = this._selection.startLineNumber, s = this._selection.startColumn, o = this._selection.endColumn;
    if ((!this._isMovingLeft || s !== 1) && (this._isMovingLeft || o !== e.getLineMaxColumn(n))) if (this._isMovingLeft) {
      const r = new D(n, s - 1, n, s), a = e.getValueInRange(r);
      t.addEditOperation(r, null), t.addEditOperation(new D(n, o, n, o), a);
    } else {
      const r = new D(n, o, n, o + 1), a = e.getValueInRange(r);
      t.addEditOperation(r, null), t.addEditOperation(new D(n, s, n, s), a);
    }
  }
  computeCursorState(e, t) {
    return this._isMovingLeft ? new _e(this._selection.startLineNumber, this._selection.startColumn - 1, this._selection.endLineNumber, this._selection.endColumn - 1) : new _e(this._selection.startLineNumber, this._selection.startColumn + 1, this._selection.endLineNumber, this._selection.endColumn + 1);
  }
}
class l6 extends he {
  constructor(e, t) {
    super(t), this.left = e;
  }
  run(e, t) {
    if (!t.hasModel()) return;
    const n = [], s = t.getSelections();
    for (const o of s) n.push(new Goe(o, this.left));
    t.pushUndoStop(), t.executeCommands(this.id, n), t.pushUndoStop();
  }
}
X(class extends l6 {
  constructor() {
    super(!0, { id: "editor.action.moveCarretLeftAction", label: m(0, "Move Selected Text Left"), alias: "Move Selected Text Left", precondition: E.writable });
  }
}), X(class extends l6 {
  constructor() {
    super(!1, { id: "editor.action.moveCarretRightAction", label: m(0, "Move Selected Text Right"), alias: "Move Selected Text Right", precondition: E.writable });
  }
});
X(class extends he {
  constructor() {
    super({ id: "editor.action.transposeLetters", label: m(0, "Transpose Letters"), alias: "Transpose Letters", precondition: E.writable, kbOpts: { kbExpr: E.textInputFocus, primary: 0, mac: { primary: 306 }, weight: 100 } });
  }
  run(i, e) {
    if (!e.hasModel()) return;
    const t = e.getModel(), n = [], s = e.getSelections();
    for (const o of s) {
      if (!o.isEmpty()) continue;
      const r = o.startLineNumber, a = o.startColumn, l = t.getLineMaxColumn(r);
      if (r === 1 && (a === 1 || a === 2 && l === 2)) continue;
      const d = a === l ? o.getPosition() : St.rightPosition(t, o.getPosition().lineNumber, o.getPosition().column), h = St.leftPosition(t, d), c = St.leftPosition(t, h), u = t.getValueInRange(D.fromPositions(c, h)), g = t.getValueInRange(D.fromPositions(h, d)), p = D.fromPositions(c, d);
      n.push(new Dn(p, g + u));
    }
    n.length > 0 && (e.pushUndoStop(), e.executeCommands(this.id, n), e.pushUndoStop());
  }
});
const YL = function() {
  if (typeof crypto == "object" && typeof crypto.randomUUID == "function") return crypto.randomUUID.bind(crypto);
  let i;
  i = typeof crypto == "object" && typeof crypto.getRandomValues == "function" ? crypto.getRandomValues.bind(crypto) : function(n) {
    for (let s = 0; s < n.length; s++) n[s] = Math.floor(256 * Math.random());
    return n;
  };
  const e = new Uint8Array(16), t = [];
  for (let n = 0; n < 256; n++) t.push(n.toString(16).padStart(2, "0"));
  return function() {
    i(e), e[6] = 15 & e[6] | 64, e[8] = 63 & e[8] | 128;
    let n = 0, s = "";
    return s += t[e[n++]], s += t[e[n++]], s += t[e[n++]], s += t[e[n++]], s += "-", s += t[e[n++]], s += t[e[n++]], s += "-", s += t[e[n++]], s += t[e[n++]], s += "-", s += t[e[n++]], s += t[e[n++]], s += "-", s += t[e[n++]], s += t[e[n++]], s += t[e[n++]], s += t[e[n++]], s += t[e[n++]], s += t[e[n++]], s;
  };
}();
function cP(i) {
  return { asString: async () => i, asFile: () => {
  }, value: typeof i == "string" ? i : void 0 };
}
class TH {
  constructor() {
    this._entries = /* @__PURE__ */ new Map();
  }
  get size() {
    let e = 0;
    for (const t of this._entries) e++;
    return e;
  }
  has(e) {
    return this._entries.has(this.toKey(e));
  }
  matches(e) {
    const t = [...this._entries.keys()];
    return at.some(this, ([n, s]) => s.asFile()) && t.push("files"), AH(dS(e), t);
  }
  get(e) {
    var t;
    return (t = this._entries.get(this.toKey(e))) === null || t === void 0 ? void 0 : t[0];
  }
  append(e, t) {
    const n = this._entries.get(e);
    n ? n.push(t) : this._entries.set(this.toKey(e), [t]);
  }
  replace(e, t) {
    this._entries.set(this.toKey(e), [t]);
  }
  delete(e) {
    this._entries.delete(this.toKey(e));
  }
  *[Symbol.iterator]() {
    for (const [e, t] of this._entries) for (const n of t) yield [e, n];
  }
  toKey(e) {
    return dS(e);
  }
}
function dS(i) {
  return i.toLowerCase();
}
function RH(i, e) {
  return AH(dS(i), e.map(dS));
}
function AH(i, e) {
  if (i === "*/*") return e.length > 0;
  if (e.includes(i)) return !0;
  const t = i.match(/^([a-z]+)\/([a-z]+|\*)$/i);
  if (!t) return !1;
  const [n, s, o] = t;
  return o === "*" && e.some((r) => r.startsWith(s + "/"));
}
const XL = Object.freeze({ create: (i) => Ad(i.map((e) => e.toString())).join(`\r
`), split: (i) => i.split(`\r
`), parse: (i) => XL.split(i).filter((e) => !e.startsWith("#")) });
class Nt {
  constructor(e) {
    this.value = e;
  }
  equals(e) {
    return this.value === e.value;
  }
  contains(e) {
    return this.equals(e) || this.value === "" || e.value.startsWith(this.value + Nt.sep);
  }
  intersects(e) {
    return this.contains(e) || e.contains(this);
  }
  append(...e) {
    return new Nt((this.value ? [this.value, ...e] : e).join(Nt.sep));
  }
}
Nt.sep = ".", Nt.None = new Nt("@@none@@"), Nt.Empty = new Nt("");
const Zoe = "CodeEditors", Yoe = "CodeFiles";
li.add("workbench.contributions.dragAndDrop", new class {
}());
class Xv {
  constructor() {
  }
  static getInstance() {
    return Xv.INSTANCE;
  }
  hasData(e) {
    return e && e === this.proto;
  }
  getData(e) {
    if (this.hasData(e)) return this.data;
  }
}
function PH(i) {
  const e = new TH();
  for (const t of i.items) {
    const n = t.type;
    if (t.kind === "string") {
      const s = new Promise((o) => t.getAsString(o));
      e.append(n, cP(s));
    } else if (t.kind === "file") {
      const s = t.getAsFile();
      s && e.append(n, Xoe(s));
    }
  }
  return e;
}
function Xoe(i) {
  const e = i.path ? Ie.parse(i.path) : void 0;
  return function(t, n, s) {
    const o = { id: YL(), name: t, uri: n, data: s };
    return { asString: async () => "", asFile: () => o, value: void 0 };
  }(i.name, e, async () => new Uint8Array(await i.arrayBuffer()));
}
Xv.INSTANCE = new Xv();
const Qoe = Object.freeze([Zoe, Yoe, Tv.RESOURCES, Tv.INTERNAL_URI_LIST]);
function OH(i, e = !1) {
  const t = PH(i), n = t.get(Tv.INTERNAL_URI_LIST);
  if (n) t.replace(vi.uriList, n);
  else if (e || !t.has(vi.uriList)) {
    const s = [];
    for (const o of i.items) {
      const r = o.getAsFile();
      if (r) {
        const a = r.path;
        try {
          a ? s.push(Ie.file(a).toString()) : s.push(Ie.parse(r.name, !0).toString());
        } catch {
        }
      }
    }
    s.length && t.replace(vi.uriList, cP(XL.create(s)));
  }
  for (const s of Qoe) t.delete(s);
  return t;
}
var uP = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Qv = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class gP {
  async provideDocumentPasteEdits(e, t, n, s, o) {
    const r = await this.getEdit(n, o);
    if (r) return { dispose() {
    }, edits: [{ insertText: r.insertText, title: r.title, kind: r.kind, handledMimeType: r.handledMimeType, yieldTo: r.yieldTo }] };
  }
  async provideDocumentOnDropEdits(e, t, n, s) {
    const o = await this.getEdit(n, s);
    return o ? [{ insertText: o.insertText, title: o.title, kind: o.kind, handledMimeType: o.handledMimeType, yieldTo: o.yieldTo }] : void 0;
  }
}
class Wd extends gP {
  constructor() {
    super(...arguments), this.kind = Wd.kind, this.dropMimeTypes = [vi.text], this.pasteMimeTypes = [vi.text];
  }
  async getEdit(e, t) {
    const n = e.get(vi.text);
    if (!n || e.has(vi.uriList)) return;
    const s = await n.asString();
    return { handledMimeType: vi.text, title: m(0, "Insert Plain Text"), insertText: s, kind: this.kind };
  }
}
Wd.id = "text", Wd.kind = new Nt("text.plain");
class FH extends gP {
  constructor() {
    super(...arguments), this.kind = new Nt("uri.absolute"), this.dropMimeTypes = [vi.uriList], this.pasteMimeTypes = [vi.uriList];
  }
  async getEdit(e, t) {
    const n = await BH(e);
    if (!n.length || t.isCancellationRequested) return;
    let s = 0;
    const o = n.map(({ uri: a, originalText: l }) => a.scheme === Ue.file ? a.fsPath : (s++, l)).join(" ");
    let r;
    return r = s > 0 ? n.length > 1 ? m(0, "Insert Uris") : m(0, "Insert Uri") : n.length > 1 ? m(0, "Insert Paths") : m(0, "Insert Path"), { handledMimeType: vi.uriList, insertText: o, title: r, kind: this.kind };
  }
}
let hS = class extends gP {
  constructor(i) {
    super(), this._workspaceContextService = i, this.kind = new Nt("uri.relative"), this.dropMimeTypes = [vi.uriList], this.pasteMimeTypes = [vi.uriList];
  }
  async getEdit(i, e) {
    const t = await BH(i);
    if (!t.length || e.isCancellationRequested) return;
    const n = ca(t.map(({ uri: s }) => {
      const o = this._workspaceContextService.getWorkspaceFolder(s);
      return o ? xX(o.uri, s) : void 0;
    }));
    return n.length ? { handledMimeType: vi.uriList, insertText: n.join(" "), title: t.length > 1 ? m(0, "Insert Relative Paths") : m(0, "Insert Relative Path"), kind: this.kind } : void 0;
  }
};
hS = uP([Qv(0, mg)], hS);
class Joe {
  constructor() {
    this.kind = new Nt("html"), this.pasteMimeTypes = ["text/html"], this._yieldTo = [{ mimeType: vi.text }];
  }
  async provideDocumentPasteEdits(e, t, n, s, o) {
    var r;
    if (s.triggerKind !== Y0.PasteAs && !(!((r = s.only) === null || r === void 0) && r.contains(this.kind))) return;
    const a = n.get("text/html"), l = await (a == null ? void 0 : a.asString());
    return l && !o.isCancellationRequested ? { dispose() {
    }, edits: [{ insertText: l, yieldTo: this._yieldTo, title: m(0, "Insert HTML"), kind: this.kind }] } : void 0;
  }
}
async function BH(i) {
  const e = i.get(vi.uriList);
  if (!e) return [];
  const t = await e.asString(), n = [];
  for (const s of XL.parse(t)) try {
    n.push({ uri: Ie.parse(s), originalText: s });
  } catch {
  }
  return n;
}
let sM = class extends V {
  constructor(i, e) {
    super(), this._register(i.documentOnDropEditProvider.register("*", new Wd())), this._register(i.documentOnDropEditProvider.register("*", new FH())), this._register(i.documentOnDropEditProvider.register("*", new hS(e)));
  }
};
sM = uP([Qv(0, fe), Qv(1, mg)], sM);
let oM = class extends V {
  constructor(i, e) {
    super(), this._register(i.documentPasteEditProvider.register("*", new Wd())), this._register(i.documentPasteEditProvider.register("*", new FH())), this._register(i.documentPasteEditProvider.register("*", new hS(e))), this._register(i.documentPasteEditProvider.register("*", new Joe()));
  }
};
oM = uP([Qv(0, fe), Qv(1, mg)], oM);
class ur {
  constructor() {
    this.value = "", this.pos = 0;
  }
  static isDigitCharacter(e) {
    return e >= 48 && e <= 57;
  }
  static isVariableCharacter(e) {
    return e === 95 || e >= 97 && e <= 122 || e >= 65 && e <= 90;
  }
  text(e) {
    this.value = e, this.pos = 0;
  }
  tokenText(e) {
    return this.value.substr(e.pos, e.len);
  }
  next() {
    if (this.pos >= this.value.length) return { type: 14, pos: this.pos, len: 0 };
    const e = this.pos;
    let t, n = 0, s = this.value.charCodeAt(e);
    if (t = ur._table[s], typeof t == "number") return this.pos += 1, { type: t, pos: e, len: 1 };
    if (ur.isDigitCharacter(s)) {
      t = 8;
      do
        n += 1, s = this.value.charCodeAt(e + n);
      while (ur.isDigitCharacter(s));
      return this.pos += n, { type: t, pos: e, len: n };
    }
    if (ur.isVariableCharacter(s)) {
      t = 9;
      do
        s = this.value.charCodeAt(e + ++n);
      while (ur.isVariableCharacter(s) || ur.isDigitCharacter(s));
      return this.pos += n, { type: t, pos: e, len: n };
    }
    t = 10;
    do
      n += 1, s = this.value.charCodeAt(e + n);
    while (!isNaN(s) && ur._table[s] === void 0 && !ur.isDigitCharacter(s) && !ur.isVariableCharacter(s));
    return this.pos += n, { type: t, pos: e, len: n };
  }
}
ur._table = { 36: 0, 58: 1, 44: 2, 123: 3, 125: 4, 92: 5, 47: 6, 124: 7, 43: 11, 45: 12, 63: 13 };
class Sf {
  constructor() {
    this._children = [];
  }
  appendChild(e) {
    return e instanceof hs && this._children[this._children.length - 1] instanceof hs ? this._children[this._children.length - 1].value += e.value : (e.parent = this, this._children.push(e)), this;
  }
  replace(e, t) {
    const { parent: n } = e, s = n.children.indexOf(e), o = n.children.slice(0);
    o.splice(s, 1, ...t), n._children = o, function r(a, l) {
      for (const d of a) d.parent = l, r(d.children, d);
    }(t, n);
  }
  get children() {
    return this._children;
  }
  get rightMostDescendant() {
    return this._children.length > 0 ? this._children[this._children.length - 1].rightMostDescendant : this;
  }
  get snippet() {
    let e = this;
    for (; ; ) {
      if (!e) return;
      if (e instanceof z1) return e;
      e = e.parent;
    }
  }
  toString() {
    return this.children.reduce((e, t) => e + t.toString(), "");
  }
  len() {
    return 0;
  }
}
class hs extends Sf {
  constructor(e) {
    super(), this.value = e;
  }
  toString() {
    return this.value;
  }
  len() {
    return this.value.length;
  }
  clone() {
    return new hs(this.value);
  }
}
class WH extends Sf {
}
class Wo extends WH {
  static compareByIndex(e, t) {
    return e.index === t.index ? 0 : e.isFinalTabstop ? 1 : t.isFinalTabstop || e.index < t.index ? -1 : e.index > t.index ? 1 : 0;
  }
  constructor(e) {
    super(), this.index = e;
  }
  get isFinalTabstop() {
    return this.index === 0;
  }
  get choice() {
    return this._children.length === 1 && this._children[0] instanceof Lf ? this._children[0] : void 0;
  }
  clone() {
    const e = new Wo(this.index);
    return this.transform && (e.transform = this.transform.clone()), e._children = this.children.map((t) => t.clone()), e;
  }
}
class Lf extends Sf {
  constructor() {
    super(...arguments), this.options = [];
  }
  appendChild(e) {
    return e instanceof hs && (e.parent = this, this.options.push(e)), this;
  }
  toString() {
    return this.options[0].value;
  }
  len() {
    return this.options[0].len();
  }
  clone() {
    const e = new Lf();
    return this.options.forEach(e.appendChild, e), e;
  }
}
class pP extends Sf {
  constructor() {
    super(...arguments), this.regexp = new RegExp("");
  }
  resolve(e) {
    const t = this;
    let n = !1, s = e.replace(this.regexp, function() {
      return n = !0, t._replace(Array.prototype.slice.call(arguments, 0, -2));
    });
    return !n && this._children.some((o) => o instanceof jr && !!o.elseValue) && (s = this._replace([])), s;
  }
  _replace(e) {
    let t = "";
    for (const n of this._children) if (n instanceof jr) {
      let s = e[n.index] || "";
      s = n.resolve(s), t += s;
    } else t += n.toString();
    return t;
  }
  toString() {
    return "";
  }
  clone() {
    const e = new pP();
    return e.regexp = new RegExp(this.regexp.source, (this.regexp.ignoreCase ? "i" : "") + (this.regexp.global ? "g" : "")), e._children = this.children.map((t) => t.clone()), e;
  }
}
class jr extends Sf {
  constructor(e, t, n, s) {
    super(), this.index = e, this.shorthandName = t, this.ifValue = n, this.elseValue = s;
  }
  resolve(e) {
    return this.shorthandName === "upcase" ? e ? e.toLocaleUpperCase() : "" : this.shorthandName === "downcase" ? e ? e.toLocaleLowerCase() : "" : this.shorthandName === "capitalize" ? e ? e[0].toLocaleUpperCase() + e.substr(1) : "" : this.shorthandName === "pascalcase" ? e ? this._toPascalCase(e) : "" : this.shorthandName === "camelcase" ? e ? this._toCamelCase(e) : "" : e && typeof this.ifValue == "string" ? this.ifValue : e || typeof this.elseValue != "string" ? e || "" : this.elseValue;
  }
  _toPascalCase(e) {
    const t = e.match(/[a-z0-9]+/gi);
    return t ? t.map((n) => n.charAt(0).toUpperCase() + n.substr(1)).join("") : e;
  }
  _toCamelCase(e) {
    const t = e.match(/[a-z0-9]+/gi);
    return t ? t.map((n, s) => s === 0 ? n.charAt(0).toLowerCase() + n.substr(1) : n.charAt(0).toUpperCase() + n.substr(1)).join("") : e;
  }
  clone() {
    return new jr(this.index, this.shorthandName, this.ifValue, this.elseValue);
  }
}
class Jv extends WH {
  constructor(e) {
    super(), this.name = e;
  }
  resolve(e) {
    let t = e.resolve(this);
    return this.transform && (t = this.transform.resolve(t || "")), t !== void 0 && (this._children = [new hs(t)], !0);
  }
  clone() {
    const e = new Jv(this.name);
    return this.transform && (e.transform = this.transform.clone()), e._children = this.children.map((t) => t.clone()), e;
  }
}
function d6(i, e) {
  const t = [...i];
  for (; t.length > 0; ) {
    const n = t.shift();
    if (!e(n)) break;
    t.unshift(...n.children);
  }
}
class z1 extends Sf {
  get placeholderInfo() {
    if (!this._placeholders) {
      const e = [];
      let t;
      this.walk(function(n) {
        return n instanceof Wo && (e.push(n), t = !t || t.index < n.index ? n : t), !0;
      }), this._placeholders = { all: e, last: t };
    }
    return this._placeholders;
  }
  get placeholders() {
    const { all: e } = this.placeholderInfo;
    return e;
  }
  offset(e) {
    let t = 0, n = !1;
    return this.walk((s) => s === e ? (n = !0, !1) : (t += s.len(), !0)), n ? t : -1;
  }
  fullLen(e) {
    let t = 0;
    return d6([e], (n) => (t += n.len(), !0)), t;
  }
  enclosingPlaceholders(e) {
    const t = [];
    let { parent: n } = e;
    for (; n; ) n instanceof Wo && t.push(n), n = n.parent;
    return t;
  }
  resolveVariables(e) {
    return this.walk((t) => (t instanceof Jv && t.resolve(e) && (this._placeholders = void 0), !0)), this;
  }
  appendChild(e) {
    return this._placeholders = void 0, super.appendChild(e);
  }
  replace(e, t) {
    return this._placeholders = void 0, super.replace(e, t);
  }
  clone() {
    const e = new z1();
    return this._children = this.children.map((t) => t.clone()), e;
  }
  walk(e) {
    d6(this.children, e);
  }
}
class wg {
  constructor() {
    this._scanner = new ur(), this._token = { type: 14, pos: 0, len: 0 };
  }
  static escape(e) {
    return e.replace(/\$|}|\\/g, "\\$&");
  }
  static guessNeedsClipboard(e) {
    return /\${?CLIPBOARD/.test(e);
  }
  parse(e, t, n) {
    const s = new z1();
    return this.parseFragment(e, s), this.ensureFinalTabstop(s, n != null && n, t != null && t), s;
  }
  parseFragment(e, t) {
    const n = t.children.length;
    for (this._scanner.text(e), this._token = this._scanner.next(); this._parse(t); ) ;
    const s = /* @__PURE__ */ new Map(), o = [];
    t.walk((l) => (l instanceof Wo && (l.isFinalTabstop ? s.set(0, void 0) : !s.has(l.index) && l.children.length > 0 ? s.set(l.index, l.children) : o.push(l)), !0));
    const r = (l, d) => {
      const h = s.get(l.index);
      if (!h) return;
      const c = new Wo(l.index);
      c.transform = l.transform;
      for (const u of h) {
        const g = u.clone();
        c.appendChild(g), g instanceof Wo && s.has(g.index) && !d.has(g.index) && (d.add(g.index), r(g, d), d.delete(g.index));
      }
      t.replace(l, [c]);
    }, a = /* @__PURE__ */ new Set();
    for (const l of o) r(l, a);
    return t.children.slice(n);
  }
  ensureFinalTabstop(e, t, n) {
    (t || n && e.placeholders.length > 0) && (e.placeholders.find((s) => s.index === 0) || e.appendChild(new Wo(0)));
  }
  _accept(e, t) {
    if (e === void 0 || this._token.type === e) {
      const n = !t || this._scanner.tokenText(this._token);
      return this._token = this._scanner.next(), n;
    }
    return !1;
  }
  _backTo(e) {
    return this._scanner.pos = e.pos + e.len, this._token = e, !1;
  }
  _until(e) {
    const t = this._token;
    for (; this._token.type !== e; ) {
      if (this._token.type === 14) return !1;
      if (this._token.type === 5) {
        const s = this._scanner.next();
        if (s.type !== 0 && s.type !== 4 && s.type !== 5) return !1;
      }
      this._token = this._scanner.next();
    }
    const n = this._scanner.value.substring(t.pos, this._token.pos).replace(/\\(\$|}|\\)/g, "$1");
    return this._token = this._scanner.next(), n;
  }
  _parse(e) {
    return this._parseEscaped(e) || this._parseTabstopOrVariableName(e) || this._parseComplexPlaceholder(e) || this._parseComplexVariable(e) || this._parseAnything(e);
  }
  _parseEscaped(e) {
    let t;
    return !!(t = this._accept(5, !0)) && (t = this._accept(0, !0) || this._accept(4, !0) || this._accept(5, !0) || t, e.appendChild(new hs(t)), !0);
  }
  _parseTabstopOrVariableName(e) {
    let t;
    const n = this._token;
    return this._accept(0) && (t = this._accept(9, !0) || this._accept(8, !0)) ? (e.appendChild(/^\d+$/.test(t) ? new Wo(Number(t)) : new Jv(t)), !0) : this._backTo(n);
  }
  _parseComplexPlaceholder(e) {
    let t;
    const n = this._token;
    if (!(this._accept(0) && this._accept(3) && (t = this._accept(8, !0)))) return this._backTo(n);
    const s = new Wo(Number(t));
    if (this._accept(1)) for (; ; ) {
      if (this._accept(4)) return e.appendChild(s), !0;
      if (!this._parse(s)) return e.appendChild(new hs("${" + t + ":")), s.children.forEach(e.appendChild, e), !0;
    }
    else {
      if (!(s.index > 0 && this._accept(7))) return this._accept(6) ? this._parseTransform(s) ? (e.appendChild(s), !0) : (this._backTo(n), !1) : this._accept(4) ? (e.appendChild(s), !0) : this._backTo(n);
      {
        const o = new Lf();
        for (; ; ) {
          if (this._parseChoiceElement(o)) {
            if (this._accept(2)) continue;
            if (this._accept(7) && (s.appendChild(o), this._accept(4))) return e.appendChild(s), !0;
          }
          return this._backTo(n), !1;
        }
      }
    }
  }
  _parseChoiceElement(e) {
    const t = this._token, n = [];
    for (; this._token.type !== 2 && this._token.type !== 7; ) {
      let s;
      if (s = (s = this._accept(5, !0)) ? this._accept(2, !0) || this._accept(7, !0) || this._accept(5, !0) || s : this._accept(void 0, !0), !s) return this._backTo(t), !1;
      n.push(s);
    }
    return n.length === 0 ? (this._backTo(t), !1) : (e.appendChild(new hs(n.join(""))), !0);
  }
  _parseComplexVariable(e) {
    let t;
    const n = this._token;
    if (!(this._accept(0) && this._accept(3) && (t = this._accept(9, !0)))) return this._backTo(n);
    const s = new Jv(t);
    if (!this._accept(1)) return this._accept(6) ? this._parseTransform(s) ? (e.appendChild(s), !0) : (this._backTo(n), !1) : this._accept(4) ? (e.appendChild(s), !0) : this._backTo(n);
    for (; ; ) {
      if (this._accept(4)) return e.appendChild(s), !0;
      if (!this._parse(s)) return e.appendChild(new hs("${" + t + ":")), s.children.forEach(e.appendChild, e), !0;
    }
  }
  _parseTransform(e) {
    const t = new pP();
    let n = "", s = "";
    for (; !this._accept(6); ) {
      let o;
      if (o = this._accept(5, !0)) o = this._accept(6, !0) || o, n += o;
      else {
        if (this._token.type === 14) return !1;
        n += this._accept(void 0, !0);
      }
    }
    for (; !this._accept(6); ) {
      let o;
      if (o = this._accept(5, !0)) o = this._accept(5, !0) || this._accept(6, !0) || o, t.appendChild(new hs(o));
      else if (!this._parseFormatString(t) && !this._parseAnything(t)) return !1;
    }
    for (; !this._accept(4); ) {
      if (this._token.type === 14) return !1;
      s += this._accept(void 0, !0);
    }
    try {
      t.regexp = new RegExp(n, s);
    } catch {
      return !1;
    }
    return e.transform = t, !0;
  }
  _parseFormatString(e) {
    const t = this._token;
    if (!this._accept(0)) return !1;
    let n = !1;
    this._accept(3) && (n = !0);
    const s = this._accept(8, !0);
    if (!s) return this._backTo(t), !1;
    if (!n) return e.appendChild(new jr(Number(s))), !0;
    if (this._accept(4)) return e.appendChild(new jr(Number(s))), !0;
    if (!this._accept(1)) return this._backTo(t), !1;
    if (this._accept(6)) {
      const o = this._accept(9, !0);
      return o && this._accept(4) ? (e.appendChild(new jr(Number(s), o)), !0) : (this._backTo(t), !1);
    }
    if (this._accept(11)) {
      const o = this._until(4);
      if (o) return e.appendChild(new jr(Number(s), void 0, o, void 0)), !0;
    } else if (this._accept(12)) {
      const o = this._until(4);
      if (o) return e.appendChild(new jr(Number(s), void 0, void 0, o)), !0;
    } else if (this._accept(13)) {
      const o = this._until(1);
      if (o) {
        const r = this._until(4);
        if (r) return e.appendChild(new jr(Number(s), void 0, o, r)), !0;
      }
    } else {
      const o = this._until(4);
      if (o) return e.appendChild(new jr(Number(s), void 0, void 0, o)), !0;
    }
    return this._backTo(t), !1;
  }
  _parseAnything(e) {
    return this._token.type !== 14 && (e.appendChild(new hs(this._scanner.tokenText(this._token))), this._accept(void 0), !0);
  }
}
function VH(i, e, t) {
  var n, s, o, r;
  return (typeof t.insertText == "string" ? t.insertText === "" : t.insertText.snippet === "") ? { edits: (s = (n = t.additionalEdit) === null || n === void 0 ? void 0 : n.edits) !== null && s !== void 0 ? s : [] } : { edits: [...e.map((a) => new nc(i, { range: a, text: typeof t.insertText == "string" ? wg.escape(t.insertText) + "$0" : t.insertText.snippet, insertAsSnippet: !0 })), ...(r = (o = t.additionalEdit) === null || o === void 0 ? void 0 : o.edits) !== null && r !== void 0 ? r : []] };
}
function HH(i) {
  var e;
  function t(r, a) {
    return "mimeType" in r ? r.mimeType === a.handledMimeType : !!a.kind && r.kind.contains(a.kind);
  }
  const n = /* @__PURE__ */ new Map();
  for (const r of i) for (const a of (e = r.yieldTo) !== null && e !== void 0 ? e : []) for (const l of i) if (l !== r && t(a, l)) {
    let d = n.get(r);
    d || (d = [], n.set(r, d)), d.push(l);
  }
  if (!n.size) return Array.from(i);
  const s = /* @__PURE__ */ new Set(), o = [];
  return function r(a) {
    if (!a.length) return [];
    const l = a[0];
    if (o.includes(l)) return console.warn("Yield to cycle detected", l), a;
    if (s.has(l)) return r(a.slice(1));
    let d = [];
    const h = n.get(l);
    return h && (o.push(l), d = r(h), o.pop()), s.add(l), [...d, l, ...r(a.slice(1))];
  }(Array.from(i));
}
var ere = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, tre = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const ire = Ve.register({ description: "inline-progress-widget", stickiness: 1, showIfCollapsed: !0, after: { content: " ", inlineClassName: "inline-editor-progress-decoration", inlineClassNameAffectsLetterSpacing: !0 } });
class QL extends V {
  constructor(e, t, n, s, o) {
    super(), this.typeId = e, this.editor = t, this.range = n, this.delegate = o, this.allowEditorOverflow = !1, this.suppressMouseDown = !0, this.create(s), this.editor.addContentWidget(this), this.editor.layoutContentWidget(this);
  }
  create(e) {
    this.domNode = Q(".inline-progress-widget"), this.domNode.role = "button", this.domNode.title = e;
    const t = Q("span.icon");
    this.domNode.append(t), t.classList.add(...Ee.asClassNameArray(ne.loading), "codicon-modifier-spin");
    const n = () => {
      const s = this.editor.getOption(67);
      this.domNode.style.height = `${s}px`, this.domNode.style.width = `${Math.ceil(0.8 * s)}px`;
    };
    n(), this._register(this.editor.onDidChangeConfiguration((s) => {
      (s.hasChanged(52) || s.hasChanged(67)) && n();
    })), this._register(K(this.domNode, ie.CLICK, (s) => {
      this.delegate.cancel();
    }));
  }
  getId() {
    return QL.baseId + "." + this.typeId;
  }
  getDomNode() {
    return this.domNode;
  }
  getPosition() {
    return { position: { lineNumber: this.range.startLineNumber, column: this.range.startColumn }, preference: [0] };
  }
  dispose() {
    super.dispose(), this.editor.removeContentWidget(this);
  }
}
QL.baseId = "editor.widget.inlineProgressWidget";
let cS = class extends V {
  constructor(i, e, t) {
    super(), this.id = i, this._editor = e, this._instantiationService = t, this._showDelay = 500, this._showPromise = this._register(new rn()), this._currentWidget = new rn(), this._operationIdPool = 0, this._currentDecorations = e.createDecorationsCollection();
  }
  async showWhile(i, e, t) {
    const n = this._operationIdPool++;
    this._currentOperation = n, this.clear(), this._showPromise.value = Cc(() => {
      const s = D.fromPositions(i);
      this._currentDecorations.set([{ range: s, options: ire }]).length > 0 && (this._currentWidget.value = this._instantiationService.createInstance(QL, this.id, this._editor, s, e, t));
    }, this._showDelay);
    try {
      return await t;
    } finally {
      this._currentOperation === n && (this.clear(), this._currentOperation = void 0);
    }
  }
  clear() {
    this._showPromise.clear(), this._currentDecorations.clear(), this._currentWidget.clear();
  }
};
cS = ere([tre(2, Se)], cS);
var dw, nre = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, h6 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let bs = dw = class {
  static get(i) {
    return i.getContribution(dw.ID);
  }
  constructor(i, e, t) {
    this._openerService = t, this._messageWidget = new rn(), this._messageListeners = new G(), this._mouseOverMessage = !1, this._editor = i, this._visible = dw.MESSAGE_VISIBLE.bindTo(e);
  }
  dispose() {
    var i;
    (i = this._message) === null || i === void 0 || i.dispose(), this._messageListeners.dispose(), this._messageWidget.dispose(), this._visible.reset();
  }
  showMessage(i, e) {
    let t;
    Io(ha(i) ? i.value : i), this._visible.set(!0), this._messageWidget.clear(), this._messageListeners.clear(), this._message = ha(i) ? CL(i, { actionHandler: { callback: (n) => {
      this.closeMessage(), kA(this._openerService, n, ha(i) ? i.isTrusted : void 0);
    }, disposables: this._messageListeners } }) : void 0, this._messageWidget.value = new c6(this._editor, e, typeof i == "string" ? i : this._message.element), this._messageListeners.add(se.debounce(this._editor.onDidBlurEditorText, (n, s) => s, 0)(() => {
      this._mouseOverMessage || this._messageWidget.value && gn(Mn(), this._messageWidget.value.getDomNode()) || this.closeMessage();
    })), this._messageListeners.add(this._editor.onDidChangeCursorPosition(() => this.closeMessage())), this._messageListeners.add(this._editor.onDidDispose(() => this.closeMessage())), this._messageListeners.add(this._editor.onDidChangeModel(() => this.closeMessage())), this._messageListeners.add(K(this._messageWidget.value.getDomNode(), ie.MOUSE_ENTER, () => this._mouseOverMessage = !0, !0)), this._messageListeners.add(K(this._messageWidget.value.getDomNode(), ie.MOUSE_LEAVE, () => this._mouseOverMessage = !1, !0)), this._messageListeners.add(this._editor.onMouseMove((n) => {
      n.target.position && (t ? t.containsPosition(n.target.position) || this.closeMessage() : t = new D(e.lineNumber - 3, 1, n.target.position.lineNumber + 3, 1));
    }));
  }
  closeMessage() {
    this._visible.reset(), this._messageListeners.clear(), this._messageWidget.value && this._messageListeners.add(c6.fadeOut(this._messageWidget.value));
  }
};
bs.ID = "editor.contrib.messageController", bs.MESSAGE_VISIBLE = new ae("messageVisible", !1, m(0, "Whether the editor is currently showing an inline message")), bs = dw = nre([h6(1, Te), h6(2, Fs)], bs);
re(new (Zi.bindToContribution(bs.get))({ id: "leaveEditorMessage", precondition: bs.MESSAGE_VISIBLE, handler: (i) => i.closeMessage(), kbOpts: { weight: 130, primary: 9 } }));
let c6 = class {
  static fadeOut(i) {
    const e = () => {
      i.dispose(), clearTimeout(t), i.getDomNode().removeEventListener("animationend", e);
    }, t = setTimeout(e, 110);
    return i.getDomNode().addEventListener("animationend", e), i.getDomNode().classList.add("fadeOut"), { dispose: e };
  }
  constructor(i, { lineNumber: e, column: t }, n) {
    this.allowEditorOverflow = !0, this.suppressMouseDown = !1, this._editor = i, this._editor.revealLinesInCenterIfOutsideViewport(e, e, 0), this._position = { lineNumber: e, column: t }, this._domNode = document.createElement("div"), this._domNode.classList.add("monaco-editor-overlaymessage"), this._domNode.style.marginLeft = "-6px";
    const s = document.createElement("div");
    s.classList.add("anchor", "top"), this._domNode.appendChild(s);
    const o = document.createElement("div");
    typeof n == "string" ? (o.classList.add("message"), o.textContent = n) : (n.classList.add("message"), o.appendChild(n)), this._domNode.appendChild(o);
    const r = document.createElement("div");
    r.classList.add("anchor", "below"), this._domNode.appendChild(r), this._editor.addContentWidget(this), this._domNode.classList.add("fadeIn");
  }
  dispose() {
    this._editor.removeContentWidget(this);
  }
  getId() {
    return "messageoverlay";
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return { position: this._position, preference: [1, 2], positionAffinity: 1 };
  }
  afterRender(i) {
    this._domNode.classList.toggle("below", i === 2);
  }
};
ft(bs.ID, bs, 4);
var rM, zH = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, L0 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let hw = rM = class extends V {
  constructor(i, e, t, n, s, o, r, a, l, d) {
    super(), this.typeId = i, this.editor = e, this.showCommand = n, this.range = s, this.edits = o, this.onSelectNewEdit = r, this._contextMenuService = a, this._keybindingService = d, this.allowEditorOverflow = !0, this.suppressMouseDown = !0, this.create(), this.visibleContext = t.bindTo(l), this.visibleContext.set(!0), this._register(ye(() => this.visibleContext.reset())), this.editor.addContentWidget(this), this.editor.layoutContentWidget(this), this._register(ye(() => this.editor.removeContentWidget(this))), this._register(this.editor.onDidChangeCursorPosition((h) => {
      s.containsPosition(h.position) || this.dispose();
    })), this._register(se.runAndSubscribe(d.onDidUpdateKeybindings, () => {
      this._updateButtonTitle();
    }));
  }
  _updateButtonTitle() {
    var i;
    const e = (i = this._keybindingService.lookupKeybinding(this.showCommand.id)) === null || i === void 0 ? void 0 : i.getLabel();
    this.button.element.title = this.showCommand.label + (e ? ` (${e})` : "");
  }
  create() {
    this.domNode = Q(".post-edit-widget"), this.button = this._register(new eS(this.domNode, { supportIcons: !0 })), this.button.label = "$(insert)", this._register(K(this.domNode, ie.CLICK, () => this.showSelector()));
  }
  getId() {
    return rM.baseId + "." + this.typeId;
  }
  getDomNode() {
    return this.domNode;
  }
  getPosition() {
    return { position: this.range.getEndPosition(), preference: [2] };
  }
  showSelector() {
    this._contextMenuService.showContextMenu({ getAnchor: () => {
      const i = Ti(this.button.element);
      return { x: i.left + i.width, y: i.top + i.height };
    }, getActions: () => this.edits.allEdits.map((i, e) => Qp({ id: "", label: i.title, checked: e === this.edits.activeEditIndex, run: () => {
      if (e !== this.edits.activeEditIndex) return this.onSelectNewEdit(e);
    } })) });
  }
};
hw.baseId = "editor.widget.postEditWidget", hw = rM = zH([L0(7, io), L0(8, Te), L0(9, Dt)], hw);
let uS = class extends V {
  constructor(i, e, t, n, s, o) {
    super(), this._id = i, this._editor = e, this._visibleContext = t, this._showCommand = n, this._instantiationService = s, this._bulkEditService = o, this._currentWidget = this._register(new rn()), this._register(se.any(e.onDidChangeModel, e.onDidChangeModelContent)(() => this.clear()));
  }
  async applyEditAndShowIfNeeded(i, e, t, n, s) {
    const o = this._editor.getModel();
    if (!o || !i.length) return;
    const r = e.allEdits.at(e.activeEditIndex);
    if (!r) return;
    const a = await n(r, s), l = VH(o.uri, i, a), d = i[0], h = o.deltaDecorations([], [{ range: d, options: { description: "paste-line-suffix", stickiness: 0 } }]);
    let c, u;
    try {
      c = await this._bulkEditService.apply(l, { editor: this._editor, token: s }), u = o.getDecorationRange(h[0]);
    } finally {
      o.deltaDecorations(h, []);
    }
    t && c.isApplied && e.allEdits.length > 1 && this.show(u ?? d, e, async (g) => {
      const p = this._editor.getModel();
      p && (await p.undo(), this.applyEditAndShowIfNeeded(i, { activeEditIndex: g, allEdits: e.allEdits }, t, n, s));
    });
  }
  show(i, e, t) {
    this.clear(), this._editor.hasModel() && (this._currentWidget.value = this._instantiationService.createInstance(hw, this._id, this._editor, this._visibleContext, this._showCommand, i, e, t));
  }
  clear() {
    this._currentWidget.clear();
  }
  tryShowSelector() {
    var i;
    (i = this._currentWidget.value) === null || i === void 0 || i.showSelector();
  }
};
uS = zH([L0(4, Se), L0(5, R1)], uS);
var du, sre = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, ep = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const UH = "editor.changePasteType", aM = new ae("pasteWidgetVisible", !1, m(0, "Whether the paste widget is showing")), mx = "application/vnd.code.copyMetadata";
let Ua = du = class extends V {
  static get(i) {
    return i.getContribution(du.ID);
  }
  constructor(i, e, t, n, s, o, r) {
    super(), this._bulkEditService = t, this._clipboardService = n, this._languageFeaturesService = s, this._quickInputService = o, this._progressService = r, this._editor = i;
    const a = i.getContainerDomNode();
    this._register(K(a, "copy", (l) => this.handleCopy(l))), this._register(K(a, "cut", (l) => this.handleCopy(l))), this._register(K(a, "paste", (l) => this.handlePaste(l), !0)), this._pasteProgressManager = this._register(new cS("pasteIntoEditor", i, e)), this._postPasteWidgetManager = this._register(e.createInstance(uS, "pasteIntoEditor", i, aM, { id: UH, label: m(0, "Show paste options...") }));
  }
  changePasteType() {
    this._postPasteWidgetManager.tryShowSelector();
  }
  pasteAs(i) {
    this._editor.focus();
    try {
      this._pasteAsActionContext = { preferred: i }, gf().execCommand("paste");
    } finally {
      this._pasteAsActionContext = void 0;
    }
  }
  clearWidgets() {
    this._postPasteWidgetManager.clear();
  }
  isPasteAsEnabled() {
    return this._editor.getOption(85).enabled && !this._editor.getOption(91);
  }
  async finishedPaste() {
    await this._currentPasteOperation;
  }
  handleCopy(i) {
    var e, t;
    if (!this._editor.hasTextFocus() || (pc && this._clipboardService.writeResources([]), !i.clipboardData || !this.isPasteAsEnabled())) return;
    const n = this._editor.getModel(), s = this._editor.getSelections();
    if (!n || !(s != null && s.length)) return;
    const o = this._editor.getOption(37);
    let r = s;
    const a = s.length === 1 && s[0].isEmpty();
    if (a) {
      if (!o) return;
      r = [new D(r[0].startLineNumber, 1, r[0].startLineNumber, 1 + n.getLineLength(r[0].startLineNumber))];
    }
    const l = (e = this._editor._getViewModel()) === null || e === void 0 ? void 0 : e.getPlainTextToCopy(s, o, Tn), d = { multicursorText: Array.isArray(l) ? l : null, pasteOnNewLine: a, mode: null }, h = this._languageFeaturesService.documentPasteEditProvider.ordered(n).filter((f) => !!f.prepareDocumentPaste);
    if (!h.length) return void this.setCopyMetadata(i.clipboardData, { defaultPastePayload: d });
    const c = PH(i.clipboardData), u = h.flatMap((f) => {
      var _;
      return (_ = f.copyMimeTypes) !== null && _ !== void 0 ? _ : [];
    }), g = YL();
    this.setCopyMetadata(i.clipboardData, { id: g, providerCopyMimeTypes: u, defaultPastePayload: d });
    const p = on(async (f) => {
      const _ = ca(await Promise.all(h.map(async (v) => {
        try {
          return await v.prepareDocumentPaste(n, r, c, f);
        } catch (b) {
          return void console.error(b);
        }
      })));
      _.reverse();
      for (const v of _) for (const [b, C] of v) c.replace(b, C);
      return c;
    });
    (t = du._currentCopyOperation) === null || t === void 0 || t.dataTransferPromise.cancel(), du._currentCopyOperation = { handle: g, dataTransferPromise: p };
  }
  async handlePaste(i) {
    var e, t, n, s;
    if (!i.clipboardData || !this._editor.hasTextFocus()) return;
    (e = bs.get(this._editor)) === null || e === void 0 || e.closeMessage(), (t = this._currentPasteOperation) === null || t === void 0 || t.cancel(), this._currentPasteOperation = void 0;
    const o = this._editor.getModel(), r = this._editor.getSelections();
    if (!(r != null && r.length) || !o || !this.isPasteAsEnabled() && !this._pasteAsActionContext) return;
    const a = this.fetchCopyMetadata(i), l = OH(i.clipboardData);
    l.delete(mx);
    const d = [...i.clipboardData.types, ...(n = a == null ? void 0 : a.providerCopyMimeTypes) !== null && n !== void 0 ? n : [], vi.uriList], h = this._languageFeaturesService.documentPasteEditProvider.ordered(o).filter((c) => {
      var u, g;
      const p = (u = this._pasteAsActionContext) === null || u === void 0 ? void 0 : u.preferred;
      return !(p && c.providedPasteEditKinds && !this.providerMatchesPreference(c, p)) && ((g = c.pasteMimeTypes) === null || g === void 0 ? void 0 : g.some((f) => RH(f, d)));
    });
    h.length ? (i.preventDefault(), i.stopImmediatePropagation(), this._pasteAsActionContext ? this.showPasteAsPick(this._pasteAsActionContext.preferred, h, r, l, a) : this.doPasteInline(h, r, l, a, i)) : !((s = this._pasteAsActionContext) === null || s === void 0) && s.preferred && this.showPasteAsNoEditMessage(r, this._pasteAsActionContext.preferred);
  }
  showPasteAsNoEditMessage(i, e) {
    var t;
    (t = bs.get(this._editor)) === null || t === void 0 || t.showMessage(m(0, "No paste edits for '{0}' found", e instanceof Nt ? e.value : e.providerId), i[0].getStartPosition());
  }
  doPasteInline(i, e, t, n, s) {
    const o = on(async (r) => {
      const a = this._editor;
      if (!a.hasModel()) return;
      const l = a.getModel(), d = new Mc(a, 3, void 0, r);
      try {
        if (await this.mergeInDataFromCopy(t, n, d.token), d.token.isCancellationRequested) return;
        const h = i.filter((g) => this.isSupportedPasteProvider(g, t));
        if (!h.length || h.length === 1 && h[0] instanceof Wd) return this.applyDefaultPasteHandler(t, n, d.token, s);
        const c = { triggerKind: Y0.Automatic }, u = await this.getPasteEdits(h, t, l, e, c, d.token);
        if (d.token.isCancellationRequested) return;
        if (u.length === 1 && u[0].provider instanceof Wd) return this.applyDefaultPasteHandler(t, n, d.token, s);
        if (u.length) {
          const g = a.getOption(85).showPasteSelector === "afterPaste";
          return this._postPasteWidgetManager.applyEditAndShowIfNeeded(e, { activeEditIndex: 0, allEdits: u }, g, async (p, f) => {
            var _, v;
            const b = await ((v = (_ = p.provider).resolveDocumentPasteEdit) === null || v === void 0 ? void 0 : v.call(_, p, f));
            return b && (p.additionalEdit = b.additionalEdit), p;
          }, d.token);
        }
        await this.applyDefaultPasteHandler(t, n, d.token, s);
      } finally {
        d.dispose(), this._currentPasteOperation === o && (this._currentPasteOperation = void 0);
      }
    });
    this._pasteProgressManager.showWhile(e[0].getEndPosition(), m(0, "Running paste handlers. Click to cancel"), o), this._currentPasteOperation = o;
  }
  showPasteAsPick(i, e, t, n, s) {
    const o = on(async (r) => {
      const a = this._editor;
      if (!a.hasModel()) return;
      const l = a.getModel(), d = new Mc(a, 3, void 0, r);
      try {
        if (await this.mergeInDataFromCopy(n, s, d.token), d.token.isCancellationRequested) return;
        let h = e.filter((f) => this.isSupportedPasteProvider(f, n, i));
        i && (h = h.filter((f) => this.providerMatchesPreference(f, i)));
        const c = { triggerKind: Y0.PasteAs, only: i && i instanceof Nt ? i : void 0 };
        let u, g = await this.getPasteEdits(h, n, l, t, c, d.token);
        if (d.token.isCancellationRequested) return;
        if (i && (g = g.filter((f) => i instanceof Nt ? i.contains(f.kind) : i.providerId === f.provider.id)), !g.length) return void (c.only && this.showPasteAsNoEditMessage(t, c.only));
        if (i) u = g.at(0);
        else {
          const f = await this._quickInputService.pick(g.map((_) => {
            var v;
            return { label: _.title, description: (v = _.kind) === null || v === void 0 ? void 0 : v.value, edit: _ };
          }), { placeHolder: m(0, "Select Paste Action") });
          u = f == null ? void 0 : f.edit;
        }
        if (!u) return;
        const p = VH(l.uri, t, u);
        await this._bulkEditService.apply(p, { editor: this._editor });
      } finally {
        d.dispose(), this._currentPasteOperation === o && (this._currentPasteOperation = void 0);
      }
    });
    this._progressService.withProgress({ location: 10, title: m(0, "Running paste handlers") }, () => o);
  }
  setCopyMetadata(i, e) {
    i.setData(mx, JSON.stringify(e));
  }
  fetchCopyMetadata(i) {
    var e;
    if (!i.clipboardData) return;
    const t = i.clipboardData.getData(mx);
    if (t) try {
      return JSON.parse(t);
    } catch {
      return;
    }
    const [n, s] = tI.getTextData(i.clipboardData);
    return s ? { defaultPastePayload: { mode: s.mode, multicursorText: (e = s.multicursorText) !== null && e !== void 0 ? e : null, pasteOnNewLine: !!s.isFromEmptySelection } } : void 0;
  }
  async mergeInDataFromCopy(i, e, t) {
    var n;
    if (e != null && e.id && ((n = du._currentCopyOperation) === null || n === void 0 ? void 0 : n.handle) === e.id) {
      const s = await du._currentCopyOperation.dataTransferPromise;
      if (t.isCancellationRequested) return;
      for (const [o, r] of s) i.replace(o, r);
    }
    if (!i.has(vi.uriList)) {
      const s = await this._clipboardService.readResources();
      if (t.isCancellationRequested) return;
      s.length && i.append(vi.uriList, cP(XL.create(s)));
    }
  }
  async getPasteEdits(i, e, t, n, s, o) {
    const r = await v1(Promise.all(i.map(async (a) => {
      var l, d;
      try {
        const h = await ((l = a.provideDocumentPasteEdits) === null || l === void 0 ? void 0 : l.call(a, t, n, e, s, o));
        return (d = h == null ? void 0 : h.edits) === null || d === void 0 ? void 0 : d.map((c) => ({ ...c, provider: a }));
      } catch (h) {
        console.error(h);
      }
    })), o);
    return HH(ca(r ?? []).flat().filter((a) => !s.only || s.only.contains(a.kind)));
  }
  async applyDefaultPasteHandler(i, e, t, n) {
    var s, o, r, a;
    const l = (s = i.get(vi.text)) !== null && s !== void 0 ? s : i.get("text"), d = (o = await (l == null ? void 0 : l.asString())) !== null && o !== void 0 ? o : "";
    if (t.isCancellationRequested) return;
    const h = { clipboardEvent: n, text: d, pasteOnNewLine: (r = e == null ? void 0 : e.defaultPastePayload.pasteOnNewLine) !== null && r !== void 0 && r, multicursorText: (a = e == null ? void 0 : e.defaultPastePayload.multicursorText) !== null && a !== void 0 ? a : null, mode: null };
    this._editor.trigger("keyboard", "paste", h);
  }
  isSupportedPasteProvider(i, e, t) {
    var n;
    return !!(!((n = i.pasteMimeTypes) === null || n === void 0) && n.some((s) => e.matches(s))) && (!t || this.providerMatchesPreference(i, t));
  }
  providerMatchesPreference(i, e) {
    return e instanceof Nt ? !i.providedPasteEditKinds || i.providedPasteEditKinds.some((t) => e.contains(t)) : i.id === e.providerId;
  }
};
Ua.ID = "editor.contrib.copyPasteActionController", Ua = du = sre([ep(1, Se), ep(2, R1), ep(3, Kd), ep(4, fe), ep(5, La), ep(6, BW)], Ua);
const yg = "9_cutcopypaste", ore = sa || document.queryCommandSupported("cut"), KH = sa || document.queryCommandSupported("copy"), rre = navigator.clipboard !== void 0 && !tr || document.queryCommandSupported("paste");
function mP(i) {
  return i.register(), i;
}
const are = ore ? mP(new mf({ id: "editor.action.clipboardCutAction", precondition: void 0, kbOpts: sa ? { primary: 2102, win: { primary: 2102, secondary: [1044] }, weight: 100 } : void 0, menuOpts: [{ menuId: x.MenubarEditMenu, group: "2_ccp", title: m(0, "Cu&&t"), order: 1 }, { menuId: x.EditorContext, group: yg, title: m(0, "Cut"), when: E.writable, order: 1 }, { menuId: x.CommandPalette, group: "", title: m(0, "Cut"), order: 1 }, { menuId: x.SimpleEditorContext, group: yg, title: m(0, "Cut"), when: E.writable, order: 1 }] })) : void 0, lre = KH ? mP(new mf({ id: "editor.action.clipboardCopyAction", precondition: void 0, kbOpts: sa ? { primary: 2081, win: { primary: 2081, secondary: [2067] }, weight: 100 } : void 0, menuOpts: [{ menuId: x.MenubarEditMenu, group: "2_ccp", title: m(0, "&&Copy"), order: 2 }, { menuId: x.EditorContext, group: yg, title: m(0, "Copy"), order: 2 }, { menuId: x.CommandPalette, group: "", title: m(0, "Copy"), order: 1 }, { menuId: x.SimpleEditorContext, group: yg, title: m(0, "Copy"), order: 2 }] })) : void 0;
tn.appendMenuItem(x.MenubarEditMenu, { submenu: x.MenubarCopy, title: ct(0, "Copy As"), group: "2_ccp", order: 3 }), tn.appendMenuItem(x.EditorContext, { submenu: x.EditorContextCopy, title: ct(0, "Copy As"), group: yg, order: 3 }), tn.appendMenuItem(x.EditorContext, { submenu: x.EditorContextShare, title: ct(0, "Share"), group: "11_share", order: -1, when: q.and(q.notEquals("resourceScheme", "output"), E.editorTextFocus) }), tn.appendMenuItem(x.EditorTitleContext, { submenu: x.EditorTitleContextShare, title: ct(0, "Share"), group: "11_share", order: -1 }), tn.appendMenuItem(x.ExplorerContext, { submenu: x.ExplorerContextShare, title: ct(0, "Share"), group: "11_share", order: -1 });
const fx = rre ? mP(new mf({ id: "editor.action.clipboardPasteAction", precondition: void 0, kbOpts: sa ? { primary: 2100, win: { primary: 2100, secondary: [1043] }, linux: { primary: 2100, secondary: [1043] }, weight: 100 } : void 0, menuOpts: [{ menuId: x.MenubarEditMenu, group: "2_ccp", title: m(0, "&&Paste"), order: 4 }, { menuId: x.EditorContext, group: yg, title: m(0, "Paste"), when: E.writable, order: 4 }, { menuId: x.CommandPalette, group: "", title: m(0, "Paste"), order: 1 }, { menuId: x.SimpleEditorContext, group: yg, title: m(0, "Paste"), when: E.writable, order: 4 }] })) : void 0;
class dre extends he {
  constructor() {
    super({ id: "editor.action.clipboardCopyWithSyntaxHighlightingAction", label: m(0, "Copy With Syntax Highlighting"), alias: "Copy With Syntax Highlighting", precondition: void 0, kbOpts: { kbExpr: E.textInputFocus, primary: 0, weight: 100 } });
  }
  run(e, t) {
    t.hasModel() && (!t.getOption(37) && t.getSelection().isEmpty() || (JE.forceCopyWithSyntaxHighlighting = !0, t.focus(), t.getContainerDomNode().ownerDocument.execCommand("copy"), JE.forceCopyWithSyntaxHighlighting = !1));
  }
}
function u6(i, e) {
  i && (i.addImplementation(1e4, "code-editor", (t, n) => {
    const s = t.get(mt).getFocusedCodeEditor();
    if (s && s.hasTextFocus()) {
      const o = s.getOption(37), r = s.getSelection();
      return r && r.isEmpty() && !o || s.getContainerDomNode().ownerDocument.execCommand(e), !0;
    }
    return !1;
  }), i.addImplementation(0, "generic-dom", (t, n) => (gf().execCommand(e), !0)));
}
u6(are, "cut"), u6(lre, "copy"), fx && (fx.addImplementation(1e4, "code-editor", (i, e) => {
  var t, n;
  const s = i.get(mt), o = i.get(Kd), r = s.getFocusedCodeEditor();
  return r && r.hasTextFocus() ? r.getContainerDomNode().ownerDocument.execCommand("paste") ? (n = (t = Ua.get(r)) === null || t === void 0 ? void 0 : t.finishedPaste()) !== null && n !== void 0 ? n : Promise.resolve() : !pc || (async () => {
    const a = await o.readText();
    if (a !== "") {
      const l = _v.INSTANCE.get(a);
      let d = !1, h = null, c = null;
      l && (d = r.getOption(37) && !!l.isFromEmptySelection, h = l.multicursorText !== void 0 ? l.multicursorText : null, c = l.mode), r.trigger("keyboard", "paste", { text: a, pasteOnNewLine: d, multicursorText: h, mode: c });
    }
  })() : !1;
}), fx.addImplementation(0, "generic-dom", (i, e) => (gf().execCommand("paste"), !0))), KH && X(dre);
const ti = new class {
  constructor() {
    this.QuickFix = new Nt("quickfix"), this.Refactor = new Nt("refactor"), this.RefactorExtract = this.Refactor.append("extract"), this.RefactorInline = this.Refactor.append("inline"), this.RefactorMove = this.Refactor.append("move"), this.RefactorRewrite = this.Refactor.append("rewrite"), this.Notebook = new Nt("notebook"), this.Source = new Nt("source"), this.SourceOrganizeImports = this.Source.append("organizeImports"), this.SourceFixAll = this.Source.append("fixAll"), this.SurroundWith = this.Refactor.append("surround");
  }
}();
var qs;
function g6(i, e, t) {
  return !!e.contains(i) && (!t || !e.contains(t));
}
(function(i) {
  i.Refactor = "refactor", i.RefactorPreview = "refactor preview", i.Lightbulb = "lightbulb", i.Default = "other (default)", i.SourceAction = "source action", i.QuickFix = "quick fix action", i.FixAll = "fix all", i.OrganizeImports = "organize imports", i.AutoFix = "auto fix", i.QuickFixHover = "quick fix hover window", i.OnSave = "save participants", i.ProblemsView = "problems view";
})(qs || (qs = {}));
class tl {
  static fromUser(e, t) {
    return e && typeof e == "object" ? new tl(tl.getKindFromUser(e, t.kind), tl.getApplyFromUser(e, t.apply), tl.getPreferredUser(e)) : new tl(t.kind, t.apply, !1);
  }
  static getApplyFromUser(e, t) {
    switch (typeof e.apply == "string" ? e.apply.toLowerCase() : "") {
      case "first":
        return "first";
      case "never":
        return "never";
      case "ifsingle":
        return "ifSingle";
      default:
        return t;
    }
  }
  static getKindFromUser(e, t) {
    return typeof e.kind == "string" ? new Nt(e.kind) : t;
  }
  static getPreferredUser(e) {
    return typeof e.preferred == "boolean" && e.preferred;
  }
  constructor(e, t, n) {
    this.kind = e, this.apply = t, this.preferred = n;
  }
}
class hre {
  constructor(e, t, n) {
    this.action = e, this.provider = t, this.highlightRange = n;
  }
  async resolve(e) {
    var t;
    if (!((t = this.provider) === null || t === void 0) && t.resolveCodeAction && !this.action.edit) {
      let n;
      try {
        n = await this.provider.resolveCodeAction(this.action, e);
      } catch (s) {
        Ni(s);
      }
      n && (this.action.edit = n.edit);
    }
    return this;
  }
}
const jH = "editor.action.codeAction", fP = "editor.action.quickFix", qH = "editor.action.autoFix", $H = "editor.action.refactor", GH = "editor.action.sourceAction", _P = "editor.action.organizeImports", vP = "editor.action.fixAll";
class k0 extends V {
  static codeActionsPreferredComparator(e, t) {
    return e.isPreferred && !t.isPreferred ? -1 : !e.isPreferred && t.isPreferred ? 1 : 0;
  }
  static codeActionsComparator({ action: e }, { action: t }) {
    return e.isAI && !t.isAI ? 1 : !e.isAI && t.isAI ? -1 : zn(e.diagnostics) ? zn(t.diagnostics) ? k0.codeActionsPreferredComparator(e, t) : -1 : zn(t.diagnostics) ? 1 : k0.codeActionsPreferredComparator(e, t);
  }
  constructor(e, t, n) {
    super(), this.documentation = t, this._register(n), this.allActions = [...e].sort(k0.codeActionsComparator), this.validActions = this.allActions.filter(({ action: s }) => !s.disabled);
  }
  get hasAutoFix() {
    return this.validActions.some(({ action: e }) => !!e.kind && ti.QuickFix.contains(new Nt(e.kind)) && !!e.isPreferred);
  }
  get hasAIFix() {
    return this.validActions.some(({ action: e }) => !!e.isAI);
  }
  get allAIFixes() {
    return this.validActions.every(({ action: e }) => !!e.isAI);
  }
}
const p6 = { actions: [], documentation: void 0 };
async function D0(i, e, t, n, s, o) {
  var r;
  const a = n.filter || {}, l = { ...a, excludes: [...a.excludes || [], ti.Notebook] }, d = { only: (r = a.include) === null || r === void 0 ? void 0 : r.value, trigger: n.type }, h = new oP(e, o), c = n.type === 2, u = function(_, v, b) {
    return _.all(v).filter((C) => !C.providedCodeActionKinds || C.providedCodeActionKinds.some((w) => function(y, L) {
      return !(y.include && !y.include.intersects(L) || y.excludes && y.excludes.some((k) => g6(L, k, y.include)) || !y.includeSourceActions && ti.Source.contains(L));
    }(b, new Nt(w))));
  }(i, e, c ? l : a), g = new G(), p = u.map(async (_) => {
    try {
      s.report(_);
      const v = await _.provideCodeActions(e, t, d, h.token);
      if (v && g.add(v), h.token.isCancellationRequested) return p6;
      const b = ((v == null ? void 0 : v.actions) || []).filter((w) => w && function(y, L) {
        const k = L.kind ? new Nt(L.kind) : void 0;
        return !(!(!y.include || k && y.include.contains(k)) || y.excludes && k && y.excludes.some((N) => g6(k, N, y.include)) || !y.includeSourceActions && k && ti.Source.contains(k) || y.onlyIncludePreferredActions && !L.isPreferred);
      }(a, w)), C = function(w, y, L) {
        if (!w.documentation) return;
        const k = w.documentation.map((N) => ({ kind: new Nt(N.kind), command: N.command }));
        if (L) {
          let N;
          for (const A of k) A.kind.contains(L) && (N ? N.kind.contains(A.kind) && (N = A) : N = A);
          if (N) return N == null ? void 0 : N.command;
        }
        for (const N of y) if (N.kind) {
          for (const A of k) if (A.kind.contains(new Nt(N.kind))) return A.command;
        }
      }(_, b, a.include);
      return { actions: b.map((w) => new hre(w, _)), documentation: C };
    } catch (v) {
      if (Sa(v)) throw v;
      return Ni(v), p6;
    }
  }), f = i.onDidChange(() => {
    ri(i.all(e), u) || h.cancel();
  });
  try {
    const _ = await Promise.all(p), v = _.map((C) => C.actions).flat(), b = [...ca(_.map((C) => C.documentation)), ...cre(i, e, n, v)];
    return new k0(v, b, g);
  } finally {
    f.dispose(), h.dispose();
  }
}
function* cre(i, e, t, n) {
  var s, o, r;
  if (e && n.length) for (const a of i.all(e)) a._getAdditionalMenuItems && (yield* (s = a._getAdditionalMenuItems) === null || s === void 0 ? void 0 : s.call(a, { trigger: t.type, only: (r = (o = t.filter) === null || o === void 0 ? void 0 : o.include) === null || r === void 0 ? void 0 : r.value }, n.map((l) => l.action)));
}
var Lm;
async function ure(i, e, t, n, s = et.None) {
  var o;
  const r = i.get(R1), a = i.get(ai), l = i.get(es), d = i.get(Ri);
  if (l.publicLog2("codeAction.applyCodeAction", { codeActionTitle: e.action.title, codeActionKind: e.action.kind, codeActionIsPreferred: !!e.action.isPreferred, reason: t }), await e.resolve(s), !s.isCancellationRequested) {
    if (!((o = e.action.edit) === null || o === void 0) && o.edits.length && !(await r.apply(e.action.edit, { editor: n == null ? void 0 : n.editor, label: e.action.title, quotableLabel: e.action.title, code: "undoredo.codeAction", respectAutoSaveConfig: t !== Lm.OnSave, showPreview: n == null ? void 0 : n.preview })).isApplied)
      return;
    if (e.action.command) try {
      await a.executeCommand(e.action.command.id, ...e.action.command.arguments || []);
    } catch (h) {
      const c = function(u) {
        return typeof u == "string" ? u : u instanceof Error && typeof u.message == "string" ? u.message : void 0;
      }(h);
      d.error(typeof c == "string" ? c : m(0, "An unknown error occurred while applying the code action"));
    }
  }
}
(function(i) {
  i.OnSave = "onSave", i.FromProblemsView = "fromProblemsView", i.FromCodeActions = "fromCodeActions", i.FromAILightbulb = "fromAILightbulb";
})(Lm || (Lm = {})), dt.registerCommand("_executeCodeActionProvider", async function(i, e, t, n, s) {
  if (!(e instanceof Ie)) throw Yo();
  const { codeActionProvider: o } = i.get(fe), r = i.get(ni).getModel(e);
  if (!r) throw Yo();
  const a = _e.isISelection(t) ? _e.liftSelection(t) : D.isIRange(t) ? r.validateRange(t) : void 0;
  if (!a) throw Yo();
  const l = typeof n == "string" ? new Nt(n) : void 0, d = await D0(o, r, a, { type: 1, triggerAction: qs.Default, filter: { includeSourceActions: !0, include: l } }, Nd.None, et.None), h = [], c = Math.min(d.validActions.length, typeof s == "number" ? s : 0);
  for (let u = 0; u < c; u++) h.push(d.validActions[u].resolve(et.None));
  try {
    return await Promise.all(h), d.validActions.map((u) => u.action);
  } finally {
    setTimeout(() => d.dispose(), 100);
  }
});
var lM, gre = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, pre = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let cw = lM = class {
  constructor(i) {
    this.keybindingService = i;
  }
  getResolver() {
    const i = new ga(() => this.keybindingService.getKeybindings().filter((e) => lM.codeActionCommands.indexOf(e.command) >= 0).filter((e) => e.resolvedKeybinding).map((e) => {
      let t = e.commandArgs;
      return e.command === _P ? t = { kind: ti.SourceOrganizeImports.value } : e.command === vP && (t = { kind: ti.SourceFixAll.value }), { resolvedKeybinding: e.resolvedKeybinding, ...tl.fromUser(t, { kind: Nt.None, apply: "never" }) };
    }));
    return (e) => {
      if (e.kind) {
        const t = this.bestKeybindingForCodeAction(e, i.value);
        return t == null ? void 0 : t.resolvedKeybinding;
      }
    };
  }
  bestKeybindingForCodeAction(i, e) {
    if (!i.kind) return;
    const t = new Nt(i.kind);
    return e.filter((n) => n.kind.contains(t)).filter((n) => !n.preferred || i.isPreferred).reduceRight((n, s) => n ? n.kind.contains(s.kind) ? s : n : s, void 0);
  }
};
cw.codeActionCommands = [$H, jH, GH, _P, vP], cw = lM = gre([pre(0, Dt)], cw), I("symbolIcon.arrayForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for array symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.booleanForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for boolean symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.classForeground", { dark: "#EE9D28", light: "#D67E00", hcDark: "#EE9D28", hcLight: "#D67E00" }, m(0, "The foreground color for class symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.colorForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for color symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.constantForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for constant symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.constructorForeground", { dark: "#B180D7", light: "#652D90", hcDark: "#B180D7", hcLight: "#652D90" }, m(0, "The foreground color for constructor symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.enumeratorForeground", { dark: "#EE9D28", light: "#D67E00", hcDark: "#EE9D28", hcLight: "#D67E00" }, m(0, "The foreground color for enumerator symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.enumeratorMemberForeground", { dark: "#75BEFF", light: "#007ACC", hcDark: "#75BEFF", hcLight: "#007ACC" }, m(0, "The foreground color for enumerator member symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.eventForeground", { dark: "#EE9D28", light: "#D67E00", hcDark: "#EE9D28", hcLight: "#D67E00" }, m(0, "The foreground color for event symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.fieldForeground", { dark: "#75BEFF", light: "#007ACC", hcDark: "#75BEFF", hcLight: "#007ACC" }, m(0, "The foreground color for field symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.fileForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for file symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.folderForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for folder symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.functionForeground", { dark: "#B180D7", light: "#652D90", hcDark: "#B180D7", hcLight: "#652D90" }, m(0, "The foreground color for function symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.interfaceForeground", { dark: "#75BEFF", light: "#007ACC", hcDark: "#75BEFF", hcLight: "#007ACC" }, m(0, "The foreground color for interface symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.keyForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for key symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.keywordForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for keyword symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.methodForeground", { dark: "#B180D7", light: "#652D90", hcDark: "#B180D7", hcLight: "#652D90" }, m(0, "The foreground color for method symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.moduleForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for module symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.namespaceForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for namespace symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.nullForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for null symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.numberForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for number symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.objectForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for object symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.operatorForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for operator symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.packageForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for package symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.propertyForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for property symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.referenceForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for reference symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.snippetForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for snippet symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.stringForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for string symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.structForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for struct symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.textForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for text symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.typeParameterForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for type parameter symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.unitForeground", { dark: oe, light: oe, hcDark: oe, hcLight: oe }, m(0, "The foreground color for unit symbols. These symbols appear in the outline, breadcrumb, and suggest widget.")), I("symbolIcon.variableForeground", { dark: "#75BEFF", light: "#007ACC", hcDark: "#75BEFF", hcLight: "#007ACC" }, m(0, "The foreground color for variable symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const ZH = Object.freeze({ kind: Nt.Empty, title: m(0, "More Actions...") }), mre = Object.freeze([{ kind: ti.QuickFix, title: m(0, "Quick Fix") }, { kind: ti.RefactorExtract, title: m(0, "Extract"), icon: ne.wrench }, { kind: ti.RefactorInline, title: m(0, "Inline"), icon: ne.wrench }, { kind: ti.RefactorRewrite, title: m(0, "Rewrite"), icon: ne.wrench }, { kind: ti.RefactorMove, title: m(0, "Move"), icon: ne.wrench }, { kind: ti.SurroundWith, title: m(0, "Surround With"), icon: ne.surroundWith }, { kind: ti.Source, title: m(0, "Source Action"), icon: ne.symbolFile }, ZH]);
var dM, qp, fre = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, m6 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
(function(i) {
  i.Hidden = { type: 0 }, i.Showing = class {
    constructor(e, t, n, s) {
      this.actions = e, this.trigger = t, this.editorPosition = n, this.widgetPosition = s, this.type = 1;
    }
  };
})(qp || (qp = {}));
let Fu = dM = class extends V {
  constructor(i, e, t) {
    super(), this._editor = i, this._keybindingService = e, this._onClick = this._register(new F()), this.onClick = this._onClick.event, this._state = qp.Hidden, this._iconClasses = [], this._domNode = Q("div.lightBulbWidget"), this._register(Bt.ignoreTarget(this._domNode)), this._editor.addContentWidget(this), this._register(this._editor.onDidChangeModelContent((n) => {
      const s = this._editor.getModel();
      (this.state.type !== 1 || !s || this.state.editorPosition.lineNumber >= s.getLineCount()) && this.hide();
    })), this._register(dj(this._domNode, (n) => {
      if (this.state.type !== 1) return;
      this._editor.focus(), n.preventDefault();
      const { top: s, height: o } = Ti(this._domNode), r = this._editor.getOption(67);
      let a = Math.floor(r / 3);
      this.state.widgetPosition.position !== null && this.state.widgetPosition.position.lineNumber < this.state.editorPosition.lineNumber && (a += r), this._onClick.fire({ x: n.posx, y: s + o + a, actions: this.state.actions, trigger: this.state.trigger });
    })), this._register(K(this._domNode, "mouseenter", (n) => {
      1 & ~n.buttons || this.hide();
    })), this._register(se.runAndSubscribe(this._keybindingService.onDidUpdateKeybindings, () => {
      var n, s, o, r;
      this._preferredKbLabel = (s = (n = this._keybindingService.lookupKeybinding(qH)) === null || n === void 0 ? void 0 : n.getLabel()) !== null && s !== void 0 ? s : void 0, this._quickFixKbLabel = (r = (o = this._keybindingService.lookupKeybinding(fP)) === null || o === void 0 ? void 0 : o.getLabel()) !== null && r !== void 0 ? r : void 0, this._updateLightBulbTitleAndIcon();
    }));
  }
  dispose() {
    super.dispose(), this._editor.removeContentWidget(this);
  }
  getId() {
    return "LightBulbWidget";
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return this._state.type === 1 ? this._state.widgetPosition : null;
  }
  update(i, e, t) {
    if (i.validActions.length <= 0) return this.hide();
    if (!this._editor.getOptions().get(65).enabled) return this.hide();
    const n = this._editor.getModel();
    if (!n) return this.hide();
    const { lineNumber: s, column: o } = n.validatePosition(t), r = n.getOptions().tabSize, a = this._editor.getOptions().get(50), l = uL(n.getLineContent(s), r), d = (u) => u > 2 && this._editor.getTopForLineNumber(u) === this._editor.getTopForLineNumber(u - 1);
    let h = s, c = 1;
    if (!(a.spaceWidth * l > 22)) {
      if (s > 1 && !d(s - 1)) h -= 1;
      else if (s < n.getLineCount() && !d(s + 1)) h += 1;
      else if (o * a.spaceWidth < 22) return this.hide();
      c = /^\S\s*$/.test(n.getLineContent(h)) ? 2 : 1;
    }
    this.state = new qp.Showing(i, e, t, { position: { lineNumber: h, column: c }, preference: dM._posPref }), this._editor.layoutContentWidget(this);
  }
  hide() {
    this.state !== qp.Hidden && (this.state = qp.Hidden, this._editor.layoutContentWidget(this));
  }
  get state() {
    return this._state;
  }
  set state(i) {
    this._state = i, this._updateLightBulbTitleAndIcon();
  }
  _updateLightBulbTitleAndIcon() {
    if (this._domNode.classList.remove(...this._iconClasses), this._iconClasses = [], this.state.type !== 1) return;
    let i, e = !1;
    this.state.actions.allAIFixes ? (i = ne.sparkleFilled, this.state.actions.validActions.length === 1 && (e = !0)) : i = this.state.actions.hasAutoFix ? this.state.actions.hasAIFix ? ne.lightbulbSparkleAutofix : ne.lightbulbAutofix : this.state.actions.hasAIFix ? ne.lightbulbSparkle : ne.lightBulb, this._updateLightbulbTitle(this.state.actions.hasAutoFix, e), this._iconClasses = Ee.asClassNameArray(i), this._domNode.classList.add(...this._iconClasses);
  }
  _updateLightbulbTitle(i, e) {
    this.state.type === 1 && (e ? this.title = m(0, "Run: {0}", this.state.actions.validActions[0].action.title) : i && this._preferredKbLabel ? this.title = m(0, "Show Code Actions. Preferred Quick Fix Available ({0})", this._preferredKbLabel) : !i && this._quickFixKbLabel ? this.title = m(0, "Show Code Actions ({0})", this._quickFixKbLabel) : i || (this.title = m(0, "Show Code Actions")));
  }
  set title(i) {
    this._domNode.title = i;
  }
};
Fu.ID = "editor.contrib.lightbulbWidget", Fu._posPref = [0], Fu = dM = fre([m6(1, Dt), m6(2, ai)], Fu);
var YH = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, hM = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const XH = "acceptSelectedCodeAction", QH = "previewSelectedCodeAction";
class _re {
  get templateId() {
    return "header";
  }
  renderTemplate(e) {
    e.classList.add("group-header");
    const t = document.createElement("span");
    return e.append(t), { container: e, text: t };
  }
  renderElement(e, t, n) {
    var s, o;
    n.text.textContent = (o = (s = e.group) === null || s === void 0 ? void 0 : s.title) !== null && o !== void 0 ? o : "";
  }
  disposeTemplate(e) {
  }
}
let cM = class {
  get templateId() {
    return "action";
  }
  constructor(i, e) {
    this._supportsPreview = i, this._keybindingService = e;
  }
  renderTemplate(i) {
    i.classList.add(this.templateId);
    const e = document.createElement("div");
    e.className = "icon", i.append(e);
    const t = document.createElement("span");
    return t.className = "title", i.append(t), { container: i, icon: e, text: t, keybinding: new yf(i, Gs) };
  }
  renderElement(i, e, t) {
    var n, s, o;
    if (!((n = i.group) === null || n === void 0) && n.icon ? (t.icon.className = Ee.asClassName(i.group.icon), i.group.icon.color && (t.icon.style.color = de(i.group.icon.color.id))) : (t.icon.className = Ee.asClassName(ne.lightBulb), t.icon.style.color = "var(--vscode-editorLightBulb-foreground)"), !i.item || !i.label) return;
    t.text.textContent = JH(i.label), t.keybinding.set(i.keybinding), function(l, ...d) {
      l ? bo(...d) : Ts(...d);
    }(!!i.keybinding, t.keybinding.element);
    const r = (s = this._keybindingService.lookupKeybinding(XH)) === null || s === void 0 ? void 0 : s.getLabel(), a = (o = this._keybindingService.lookupKeybinding(QH)) === null || o === void 0 ? void 0 : o.getLabel();
    t.container.classList.toggle("option-disabled", i.disabled), i.disabled ? t.container.title = i.label : r && a ? this._supportsPreview && i.canPreview ? t.container.title = m(0, "{0} to Apply, {1} to Preview", r, a) : t.container.title = m(0, "{0} to Apply", r) : t.container.title = "";
  }
  disposeTemplate(i) {
    i.keybinding.dispose();
  }
};
cM = YH([hM(1, Dt)], cM);
class vre extends UIEvent {
  constructor() {
    super("acceptSelectedAction");
  }
}
class f6 extends UIEvent {
  constructor() {
    super("previewSelectedAction");
  }
}
function bre(i) {
  if (i.kind === "action") return i.label;
}
let uM = class extends V {
  constructor(i, e, t, n, s, o) {
    super(), this._delegate = n, this._contextViewService = s, this._keybindingService = o, this._actionLineHeight = 24, this._headerLineHeight = 26, this.cts = this._register(new Ci()), this.domNode = document.createElement("div"), this.domNode.classList.add("actionList");
    const r = { getHeight: (a) => a.kind === "header" ? this._headerLineHeight : this._actionLineHeight, getTemplateId: (a) => a.kind };
    this._list = this._register(new uo(i, this.domNode, r, [new cM(e, this._keybindingService), new _re()], { keyboardSupport: !1, typeNavigationEnabled: !0, keyboardNavigationLabelProvider: { getKeyboardNavigationLabel: bre }, accessibilityProvider: { getAriaLabel: (a) => {
      if (a.kind === "action") {
        let l = a.label ? JH(a == null ? void 0 : a.label) : "";
        return a.disabled && (l = m(0, "{0}, Disabled Reason: {1}", l, a.disabled)), l;
      }
      return null;
    }, getWidgetAriaLabel: () => m(0, "Action Widget"), getRole: (a) => a.kind === "action" ? "option" : "separator", getWidgetRole: () => "listbox" } })), this._list.style(Tg), this._register(this._list.onMouseClick((a) => this.onListClick(a))), this._register(this._list.onMouseOver((a) => this.onListHover(a))), this._register(this._list.onDidChangeFocus(() => this.onFocus())), this._register(this._list.onDidChangeSelection((a) => this.onListSelection(a))), this._allMenuItems = t, this._list.splice(0, this._list.length, this._allMenuItems), this._list.length && this.focusNext();
  }
  focusCondition(i) {
    return !i.disabled && i.kind === "action";
  }
  hide(i) {
    this._delegate.onHide(i), this.cts.cancel(), this._contextViewService.hideContextView();
  }
  layout(i) {
    const e = this._allMenuItems.filter((o) => o.kind === "header").length, t = this._allMenuItems.length * this._actionLineHeight + e * this._headerLineHeight - e * this._actionLineHeight;
    this._list.layout(t);
    let n = i;
    if (this._allMenuItems.length >= 50) n = 380;
    else {
      const o = this._allMenuItems.map((r, a) => {
        const l = this.domNode.ownerDocument.getElementById(this._list.getElementID(a));
        if (l) {
          l.style.width = "auto";
          const d = l.getBoundingClientRect().width;
          return l.style.width = "", d;
        }
        return 0;
      });
      n = Math.max(...o, i);
    }
    const s = Math.min(t, 0.7 * this.domNode.ownerDocument.body.clientHeight);
    return this._list.layout(s, n), this.domNode.style.height = `${s}px`, this._list.domFocus(), n;
  }
  focusPrevious() {
    this._list.focusPrevious(1, !0, void 0, this.focusCondition);
  }
  focusNext() {
    this._list.focusNext(1, !0, void 0, this.focusCondition);
  }
  acceptSelected(i) {
    const e = this._list.getFocus();
    if (e.length === 0) return;
    const t = e[0], n = this._list.element(t);
    if (!this.focusCondition(n)) return;
    const s = i ? new f6() : new vre();
    this._list.setSelection([t], s);
  }
  onListSelection(i) {
    if (!i.elements.length) return;
    const e = i.elements[0];
    e.item && this.focusCondition(e) ? this._delegate.onSelect(e.item, i.browserEvent instanceof f6) : this._list.setSelection([]);
  }
  onFocus() {
    var i, e;
    const t = this._list.getFocus();
    if (t.length === 0) return;
    const n = t[0], s = this._list.element(n);
    (e = (i = this._delegate).onFocus) === null || e === void 0 || e.call(i, s.item);
  }
  async onListHover(i) {
    const e = i.element;
    if (e && e.item && this.focusCondition(e)) {
      if (this._delegate.onHover && !e.disabled && e.kind === "action") {
        const t = await this._delegate.onHover(e.item, this.cts.token);
        e.canPreview = t ? t.canPreview : void 0;
      }
      i.index && this._list.splice(i.index, 1, [e]);
    }
    this._list.setFocus(typeof i.index == "number" ? [i.index] : []);
  }
  onListClick(i) {
    i.element && this.focusCondition(i.element) && this._list.setFocus([]);
  }
};
function JH(i) {
  return i.replace(/\r\n|\r|\n/g, " ");
}
uM = YH([hM(4, zd), hM(5, Dt)], uM);
var Cre = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, _x = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
I("actionBar.toggledBackground", { dark: Iu, light: Iu, hcDark: Iu, hcLight: Iu }, m(0, "Background color for toggled action items in action bar."));
const Lu = { Visible: new ae("codeActionMenuVisible", !1, m(0, "Whether the action widget list is visible")) }, ku = tt("actionWidgetService");
let Bu = class extends V {
  get isVisible() {
    return Lu.Visible.getValue(this._contextKeyService) || !1;
  }
  constructor(i, e, t) {
    super(), this._contextViewService = i, this._contextKeyService = e, this._instantiationService = t, this._list = this._register(new rn());
  }
  show(i, e, t, n, s, o, r) {
    const a = Lu.Visible.bindTo(this._contextKeyService), l = this._instantiationService.createInstance(uM, i, e, t, n);
    this._contextViewService.showContextView({ getAnchor: () => s, render: (d) => (a.set(!0), this._renderWidget(d, l, r ?? [])), onHide: (d) => {
      a.reset(), this._onWidgetClosed(d);
    } }, o, !1);
  }
  acceptSelected(i) {
    var e;
    (e = this._list.value) === null || e === void 0 || e.acceptSelected(i);
  }
  focusPrevious() {
    var i, e;
    (e = (i = this._list) === null || i === void 0 ? void 0 : i.value) === null || e === void 0 || e.focusPrevious();
  }
  focusNext() {
    var i, e;
    (e = (i = this._list) === null || i === void 0 ? void 0 : i.value) === null || e === void 0 || e.focusNext();
  }
  hide() {
    var i;
    (i = this._list.value) === null || i === void 0 || i.hide(), this._list.clear();
  }
  _renderWidget(i, e, t) {
    var n;
    const s = document.createElement("div");
    if (s.classList.add("action-widget"), i.appendChild(s), this._list.value = e, !this._list.value) throw new Error("List has no value");
    s.appendChild(this._list.value.domNode);
    const o = new G(), r = document.createElement("div"), a = i.appendChild(r);
    a.classList.add("context-view-block"), o.add(K(a, ie.MOUSE_DOWN, (g) => g.stopPropagation()));
    const l = document.createElement("div"), d = i.appendChild(l);
    d.classList.add("context-view-pointerBlock"), o.add(K(d, ie.POINTER_MOVE, () => d.remove())), o.add(K(d, ie.MOUSE_DOWN, () => d.remove()));
    let h = 0;
    if (t.length) {
      const g = this._createActionBar(".action-widget-action-bar", t);
      g && (s.appendChild(g.getContainer().parentElement), o.add(g), h = g.getContainer().offsetWidth);
    }
    const c = (n = this._list.value) === null || n === void 0 ? void 0 : n.layout(h);
    s.style.width = `${c}px`;
    const u = o.add(ma(i));
    return o.add(u.onDidBlur(() => this.hide())), o;
  }
  _createActionBar(i, e) {
    if (!e.length) return;
    const t = Q(i), n = new sr(t);
    return n.push(e, { icon: !1, label: !0 }), n;
  }
  _onWidgetClosed(i) {
    var e;
    (e = this._list.value) === null || e === void 0 || e.hide(i);
  }
};
Bu = Cre([_x(0, zd), _x(1, Te), _x(2, Se)], Bu), rt(ku, Bu, 1);
const Xf = 1100;
Ft(class extends cs {
  constructor() {
    super({ id: "hideCodeActionWidget", title: ct(0, "Hide action widget"), precondition: Lu.Visible, keybinding: { weight: Xf, primary: 9, secondary: [1033] } });
  }
  run(i) {
    i.get(ku).hide();
  }
}), Ft(class extends cs {
  constructor() {
    super({ id: "selectPrevCodeAction", title: ct(0, "Select previous action"), precondition: Lu.Visible, keybinding: { weight: Xf, primary: 16, secondary: [2064], mac: { primary: 16, secondary: [2064, 302] } } });
  }
  run(i) {
    const e = i.get(ku);
    e instanceof Bu && e.focusPrevious();
  }
}), Ft(class extends cs {
  constructor() {
    super({ id: "selectNextCodeAction", title: ct(0, "Select next action"), precondition: Lu.Visible, keybinding: { weight: Xf, primary: 18, secondary: [2066], mac: { primary: 18, secondary: [2066, 300] } } });
  }
  run(i) {
    const e = i.get(ku);
    e instanceof Bu && e.focusNext();
  }
}), Ft(class extends cs {
  constructor() {
    super({ id: XH, title: ct(0, "Accept selected action"), precondition: Lu.Visible, keybinding: { weight: Xf, primary: 3, secondary: [2137] } });
  }
  run(i) {
    const e = i.get(ku);
    e instanceof Bu && e.acceptSelected();
  }
}), Ft(class extends cs {
  constructor() {
    super({ id: QH, title: ct(0, "Preview selected action"), precondition: Lu.Visible, keybinding: { weight: Xf, primary: 2051 } });
  }
  run(i) {
    const e = i.get(ku);
    e instanceof Bu && e.acceptSelected(!0);
  }
});
const ez = new ae("supportedCodeAction", ""), _6 = "_typescript.applyFixAllCodeAction";
class wre extends V {
  constructor(e, t, n, s = 250) {
    super(), this._editor = e, this._markerService = t, this._signalChange = n, this._delay = s, this._autoTriggerTimer = this._register(new Dr()), this._register(this._markerService.onMarkerChanged((o) => this._onMarkerChanges(o))), this._register(this._editor.onDidChangeCursorPosition(() => this._tryAutoTrigger()));
  }
  trigger(e) {
    const t = this._getRangeOfSelectionUnlessWhitespaceEnclosed(e);
    this._signalChange(t ? { trigger: e, selection: t } : void 0);
  }
  _onMarkerChanges(e) {
    const t = this._editor.getModel();
    t && e.some((n) => QR(n, t.uri)) && this._tryAutoTrigger();
  }
  _tryAutoTrigger() {
    this._autoTriggerTimer.cancelAndSet(() => {
      this.trigger({ type: 2, triggerAction: qs.Default });
    }, this._delay);
  }
  _getRangeOfSelectionUnlessWhitespaceEnclosed(e) {
    if (!this._editor.hasModel()) return;
    const t = this._editor.getSelection();
    if (e.type === 1) return t;
    const n = this._editor.getOption(65).enabled;
    if (n !== mr.Off) {
      if (n === mr.On) return t;
      if (n === mr.OnCode) {
        if (!t.isEmpty()) return t;
        const s = this._editor.getModel(), { lineNumber: o, column: r } = t.getPosition(), a = s.getLineContent(o);
        if (a.length === 0) return;
        if (r === 1) {
          if (/\s/.test(a[0])) return;
        } else if (r === s.getLineMaxColumn(o)) {
          if (/\s/.test(a[a.length - 1])) return;
        } else if (/\s/.test(a[r - 2]) && /\s/.test(a[r - 1])) return;
      }
      return t;
    }
  }
}
var Du;
(function(i) {
  i.Empty = { type: 0 }, i.Triggered = class {
    constructor(e, t, n) {
      this.trigger = e, this.position = t, this._cancellablePromise = n, this.type = 1, this.actions = n.catch((s) => {
        if (Sa(s)) return tz;
        throw s;
      });
    }
    cancel() {
      this._cancellablePromise.cancel();
    }
  };
})(Du || (Du = {}));
const tz = Object.freeze({ allActions: [], validActions: [], dispose: () => {
}, documentation: [], hasAutoFix: !1, hasAIFix: !1, allAIFixes: !1 });
class yre extends V {
  constructor(e, t, n, s, o, r) {
    super(), this._editor = e, this._registry = t, this._markerService = n, this._progressService = o, this._configurationService = r, this._codeActionOracle = this._register(new rn()), this._state = Du.Empty, this._onDidChangeState = this._register(new F()), this.onDidChangeState = this._onDidChangeState.event, this._disposed = !1, this._supportedCodeActions = ez.bindTo(s), this._register(this._editor.onDidChangeModel(() => this._update())), this._register(this._editor.onDidChangeModelLanguage(() => this._update())), this._register(this._registry.onDidChange(() => this._update())), this._register(this._editor.onDidChangeConfiguration((a) => {
      a.hasChanged(65) && this._update();
    })), this._update();
  }
  dispose() {
    this._disposed || (this._disposed = !0, super.dispose(), this.setState(Du.Empty, !0));
  }
  _settingEnabledNearbyQuickfixes() {
    var e;
    const t = (e = this._editor) === null || e === void 0 ? void 0 : e.getModel();
    return !!this._configurationService && this._configurationService.getValue("editor.codeActionWidget.includeNearbyQuickFixes", { resource: t == null ? void 0 : t.uri });
  }
  _update() {
    if (this._disposed) return;
    this._codeActionOracle.value = void 0, this.setState(Du.Empty);
    const e = this._editor.getModel();
    if (e && this._registry.has(e) && !this._editor.getOption(91)) {
      const t = this._registry.all(e).flatMap((n) => {
        var s;
        return (s = n.providedCodeActionKinds) !== null && s !== void 0 ? s : [];
      });
      this._supportedCodeActions.set(t.join(" ")), this._codeActionOracle.value = new wre(this._editor, this._markerService, (n) => {
        var s;
        if (!n) return void this.setState(Du.Empty);
        const o = n.selection.getStartPosition(), r = on(async (d) => {
          var h, c, u, g, p, f, _, v, b, C;
          if (this._settingEnabledNearbyQuickfixes() && n.trigger.type === 1 && (n.trigger.triggerAction === qs.QuickFix || !((c = (h = n.trigger.filter) === null || h === void 0 ? void 0 : h.include) === null || c === void 0) && c.contains(ti.QuickFix))) {
            const w = await D0(this._registry, e, n.selection, n.trigger, Nd.None, d), y = [...w.allActions];
            if (d.isCancellationRequested) return tz;
            const L = (u = w.validActions) === null || u === void 0 ? void 0 : u.some((N) => !!N.action.kind && ti.QuickFix.contains(new Nt(N.action.kind))), k = this._markerService.read({ resource: e.uri });
            if (L) {
              for (const N of w.validActions) !((p = (g = N.action.command) === null || g === void 0 ? void 0 : g.arguments) === null || p === void 0) && p.some((A) => typeof A == "string" && A.includes(_6)) && (N.action.diagnostics = [...k.filter((A) => A.relatedInformation)]);
              return { validActions: w.validActions, allActions: y, documentation: w.documentation, hasAutoFix: w.hasAutoFix, hasAIFix: w.hasAIFix, allAIFixes: w.allAIFixes, dispose: () => {
                w.dispose();
              } };
            }
            if (!L && k.length > 0) {
              const N = n.selection.getPosition();
              let A = N, B = Number.MAX_VALUE;
              const T = [...w.validActions];
              for (const H of k) {
                const $ = H.endColumn, pe = H.endLineNumber, me = H.startLineNumber;
                if (pe === N.lineNumber || me === N.lineNumber) {
                  A = new W(pe, $);
                  const ue = { type: n.trigger.type, triggerAction: n.trigger.triggerAction, filter: { include: !((f = n.trigger.filter) === null || f === void 0) && f.include ? (_ = n.trigger.filter) === null || _ === void 0 ? void 0 : _.include : ti.QuickFix }, autoApply: n.trigger.autoApply, context: { notAvailableMessage: ((v = n.trigger.context) === null || v === void 0 ? void 0 : v.notAvailableMessage) || "", position: A } }, ee = new _e(A.lineNumber, A.column, A.lineNumber, A.column), te = await D0(this._registry, e, ee, ue, Nd.None, d);
                  if (te.validActions.length !== 0) {
                    for (const be of te.validActions) !((C = (b = be.action.command) === null || b === void 0 ? void 0 : b.arguments) === null || C === void 0) && C.some((we) => typeof we == "string" && we.includes(_6)) && (be.action.diagnostics = [...k.filter((we) => we.relatedInformation)]);
                    w.allActions.length === 0 && y.push(...te.allActions), Math.abs(N.column - $) < B ? T.unshift(...te.validActions) : T.push(...te.validActions);
                  }
                  B = Math.abs(N.column - $);
                }
              }
              const O = T.filter((H, $, pe) => pe.findIndex((me) => me.action.title === H.action.title) === $);
              return O.sort((H, $) => H.action.isPreferred && !$.action.isPreferred ? -1 : !H.action.isPreferred && $.action.isPreferred || H.action.isAI && !$.action.isAI ? 1 : !H.action.isAI && $.action.isAI ? -1 : 0), { validActions: O, allActions: y, documentation: w.documentation, hasAutoFix: w.hasAutoFix, hasAIFix: w.hasAIFix, allAIFixes: w.allAIFixes, dispose: () => {
                w.dispose();
              } };
            }
          }
          return D0(this._registry, e, n.selection, n.trigger, Nd.None, d);
        });
        n.trigger.type === 1 && ((s = this._progressService) === null || s === void 0 || s.showWhile(r, 250));
        const a = new Du.Triggered(n.trigger, o, r);
        let l = !1;
        this._state.type === 1 && (l = this._state.trigger.type === 1 && a.type === 1 && a.trigger.type === 2 && this._state.position !== a.position), l || this.setState(a);
      }, void 0), this._codeActionOracle.value.trigger({ type: 2, triggerAction: qs.Default });
    } else this._supportedCodeActions.reset();
  }
  trigger(e) {
    var t;
    (t = this._codeActionOracle.value) === null || t === void 0 || t.trigger(e);
  }
  setState(e, t) {
    e !== this._state && (this._state.type === 1 && this._state.cancel(), this._state = e, t || this._disposed || this._onDidChangeState.fire(e));
  }
}
var _p, Sre = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Tl = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let Uh = _p = class extends V {
  static get(i) {
    return i.getContribution(_p.ID);
  }
  constructor(i, e, t, n, s, o, r, a, l, d) {
    super(), this._commandService = r, this._configurationService = a, this._actionWidgetService = l, this._instantiationService = d, this._activeCodeActions = this._register(new rn()), this._showDisabled = !1, this._disposed = !1, this._editor = i, this._model = this._register(new yre(this._editor, s.codeActionProvider, e, t, o, a)), this._register(this._model.onDidChangeState((h) => this.update(h))), this._lightBulbWidget = new ga(() => {
      const h = this._editor.getContribution(Fu.ID);
      return h && this._register(h.onClick((c) => this.showCodeActionsFromLightbulb(c.actions, c))), h;
    }), this._resolver = n.createInstance(cw), this._register(this._editor.onDidLayoutChange(() => this._actionWidgetService.hide()));
  }
  dispose() {
    this._disposed = !0, super.dispose();
  }
  async showCodeActionsFromLightbulb(i, e) {
    if (i.allAIFixes && i.validActions.length === 1) {
      const t = i.validActions[0], n = t.action.command;
      return n && n.id === "inlineChat.start" && n.arguments && n.arguments.length >= 1 && (n.arguments[0] = { ...n.arguments[0], autoSend: !1 }), void await this._applyCodeAction(t, !1, !1, Lm.FromAILightbulb);
    }
    await this.showCodeActionList(i, e, { includeDisabledActions: !1, fromLightbulb: !0 });
  }
  showCodeActions(i, e, t) {
    return this.showCodeActionList(e, t, { includeDisabledActions: !1, fromLightbulb: !1 });
  }
  manualTriggerAtCurrentPosition(i, e, t, n) {
    var s;
    if (!this._editor.hasModel()) return;
    (s = bs.get(this._editor)) === null || s === void 0 || s.closeMessage();
    const o = this._editor.getPosition();
    this._trigger({ type: 1, triggerAction: e, filter: t, autoApply: n, context: { notAvailableMessage: i, position: o } });
  }
  _trigger(i) {
    return this._model.trigger(i);
  }
  async _applyCodeAction(i, e, t, n) {
    try {
      await this._instantiationService.invokeFunction(ure, i, n, { preview: t, editor: this._editor });
    } finally {
      e && this._trigger({ type: 2, triggerAction: qs.QuickFix, filter: {} });
    }
  }
  async update(i) {
    var e, t, n, s, o, r, a;
    if (i.type !== 1) return void ((e = this._lightBulbWidget.rawValue) === null || e === void 0 || e.hide());
    let l;
    try {
      l = await i.actions;
    } catch (d) {
      return void We(d);
    }
    if (!this._disposed) if ((t = this._lightBulbWidget.value) === null || t === void 0 || t.update(l, i.trigger, i.position), i.trigger.type === 1) {
      if (!((n = i.trigger.filter) === null || n === void 0) && n.include) {
        const h = this.tryGetValidActionToApply(i.trigger, l);
        if (h) {
          try {
            (s = this._lightBulbWidget.value) === null || s === void 0 || s.hide(), await this._applyCodeAction(h, !1, !1, Lm.FromCodeActions);
          } finally {
            l.dispose();
          }
          return;
        }
        if (i.trigger.context) {
          const c = this.getInvalidActionThatWouldHaveBeenApplied(i.trigger, l);
          if (c && c.action.disabled) return (o = bs.get(this._editor)) === null || o === void 0 || o.showMessage(c.action.disabled, i.trigger.context.position), void l.dispose();
        }
      }
      const d = !!(!((r = i.trigger.filter) === null || r === void 0) && r.include);
      if (i.trigger.context && (!l.allActions.length || !d && !l.validActions.length)) return (a = bs.get(this._editor)) === null || a === void 0 || a.showMessage(i.trigger.context.notAvailableMessage, i.trigger.context.position), this._activeCodeActions.value = l, void l.dispose();
      this._activeCodeActions.value = l, this.showCodeActionList(l, this.toCoords(i.position), { includeDisabledActions: d, fromLightbulb: !1 });
    } else this._actionWidgetService.isVisible ? l.dispose() : this._activeCodeActions.value = l;
  }
  getInvalidActionThatWouldHaveBeenApplied(i, e) {
    if (e.allActions.length) return i.autoApply === "first" && e.validActions.length === 0 || i.autoApply === "ifSingle" && e.allActions.length === 1 ? e.allActions.find(({ action: t }) => t.disabled) : void 0;
  }
  tryGetValidActionToApply(i, e) {
    if (e.validActions.length) return i.autoApply === "first" && e.validActions.length > 0 || i.autoApply === "ifSingle" && e.validActions.length === 1 ? e.validActions[0] : void 0;
  }
  async showCodeActionList(i, e, t) {
    const n = this._editor.createDecorationsCollection(), s = this._editor.getDomNode();
    if (!s) return;
    const o = t.includeDisabledActions && (this._showDisabled || i.validActions.length === 0) ? i.allActions : i.validActions;
    if (!o.length) return;
    const r = W.isIPosition(e) ? this.toCoords(e) : e, a = { onSelect: async (l, d) => {
      this._applyCodeAction(l, !0, !!d, Lm.FromCodeActions), this._actionWidgetService.hide(), n.clear();
    }, onHide: () => {
      var l;
      (l = this._editor) === null || l === void 0 || l.focus(), n.clear();
    }, onHover: async (l, d) => {
      var h;
      if (d.isCancellationRequested) return;
      let c = !1;
      const u = l.action.kind;
      if (u) {
        const g = new Nt(u);
        c = [ti.RefactorExtract, ti.RefactorInline, ti.RefactorRewrite].some((p) => p.contains(g));
      }
      return { canPreview: c || !!(!((h = l.action.edit) === null || h === void 0) && h.edits.length) };
    }, onFocus: (l) => {
      var d, h;
      if (l && l.action) {
        const c = l.action.ranges, u = l.action.diagnostics;
        if (n.clear(), c && c.length > 0) {
          const g = u && (u == null ? void 0 : u.length) > 1 ? u.map((p) => ({ range: p, options: _p.DECORATION })) : c.map((p) => ({ range: p, options: _p.DECORATION }));
          n.set(g);
        } else if (u && u.length > 0) {
          const g = u.map((f) => ({ range: f, options: _p.DECORATION }));
          n.set(g);
          const p = u[0];
          p.startLineNumber && p.startColumn && vl(m(0, "Context: {0} at line {1} and column {2}.", (h = (d = this._editor.getModel()) === null || d === void 0 ? void 0 : d.getWordAtPosition({ lineNumber: p.startLineNumber, column: p.startColumn })) === null || h === void 0 ? void 0 : h.word, p.startLineNumber, p.startColumn));
        }
      } else n.clear();
    } };
    this._actionWidgetService.show("codeActionWidget", !0, function(l, d, h) {
      if (!d) return l.map((g) => {
        var p;
        return { kind: "action", item: g, group: ZH, disabled: !!g.action.disabled, label: g.action.disabled || g.action.title, canPreview: !!(!((p = g.action.edit) === null || p === void 0) && p.edits.length) };
      });
      const c = mre.map((g) => ({ group: g, actions: [] }));
      for (const g of l) {
        const p = g.action.kind ? new Nt(g.action.kind) : Nt.None;
        for (const f of c) if (f.group.kind.contains(p)) {
          f.actions.push(g);
          break;
        }
      }
      const u = [];
      for (const g of c) if (g.actions.length) {
        u.push({ kind: "header", group: g.group });
        for (const p of g.actions) {
          const f = g.group;
          u.push({ kind: "action", item: p, group: p.action.isAI ? { title: f.title, kind: f.kind, icon: ne.sparkle } : f, label: p.action.title, disabled: !!p.action.disabled, keybinding: h(p.action) });
        }
      }
      return u;
    }(o, this._shouldShowHeaders(), this._resolver.getResolver()), a, r, s, this._getActionBarActions(i, e, t));
  }
  toCoords(i) {
    if (!this._editor.hasModel()) return { x: 0, y: 0 };
    this._editor.revealPosition(i, 1), this._editor.render();
    const e = this._editor.getScrolledVisiblePosition(i), t = Ti(this._editor.getDomNode());
    return { x: t.left + e.left, y: t.top + e.top + e.height };
  }
  _shouldShowHeaders() {
    var i;
    const e = (i = this._editor) === null || i === void 0 ? void 0 : i.getModel();
    return this._configurationService.getValue("editor.codeActionWidget.showHeaders", { resource: e == null ? void 0 : e.uri });
  }
  _getActionBarActions(i, e, t) {
    if (t.fromLightbulb) return [];
    const n = i.documentation.map((s) => {
      var o;
      return { id: s.id, label: s.title, tooltip: (o = s.tooltip) !== null && o !== void 0 ? o : "", class: void 0, enabled: !0, run: () => {
        var r;
        return this._commandService.executeCommand(s.id, ...(r = s.arguments) !== null && r !== void 0 ? r : []);
      } };
    });
    return t.includeDisabledActions && i.validActions.length > 0 && i.allActions.length !== i.validActions.length && n.push(this._showDisabled ? { id: "hideMoreActions", label: m(0, "Hide Disabled"), enabled: !0, tooltip: "", class: void 0, run: () => (this._showDisabled = !1, this.showCodeActionList(i, e, t)) } : { id: "showMoreActions", label: m(0, "Show Disabled"), enabled: !0, tooltip: "", class: void 0, run: () => (this._showDisabled = !0, this.showCodeActionList(i, e, t)) }), n;
  }
};
function Qf(i) {
  return q.regex(ez.keys()[0], new RegExp("(\\s|^)" + No(i.value) + "\\b"));
}
Uh.ID = "editor.contrib.codeActionController", Uh.DECORATION = Ve.register({ description: "quickfix-highlight", className: "quickfix-edit-highlight" }), Uh = _p = Sre([Tl(1, kl), Tl(2, Te), Tl(3, Se), Tl(4, fe), Tl(5, Ec), Tl(6, ai), Tl(7, Ye), Tl(8, ku), Tl(9, Se)], Uh), rr((i, e) => {
  ((n, s) => {
    s && e.addRule(`.monaco-editor ${n} { background-color: ${s}; }`);
  })(".quickfix-edit-highlight", i.getColor(hd));
  const t = i.getColor(Rh);
  t && e.addRule(`.monaco-editor .quickfix-edit-highlight { border: 1px ${la(i.type) ? "dotted" : "solid"} ${t}; box-sizing: border-box; }`);
});
const vx = { type: "object", defaultSnippets: [{ body: { kind: "" } }], properties: { kind: { type: "string", description: m(0, "Kind of the code action to run.") }, apply: { type: "string", description: m(0, "Controls when the returned actions are applied."), default: "ifSingle", enum: ["first", "ifSingle", "never"], enumDescriptions: [m(0, "Always apply the first returned code action."), m(0, "Apply the first returned code action if it is the only one."), m(0, "Do not apply the returned code actions.")] }, preferred: { type: "boolean", default: !1, description: m(0, "Controls if only preferred code actions should be returned.") } } };
function Xc(i, e, t, n, s = qs.Default) {
  if (i.hasModel()) {
    const o = Uh.get(i);
    o == null || o.manualTriggerAtCurrentPosition(e, s, t, n);
  }
}
ft(Uh.ID, Uh, 3), ft(Fu.ID, Fu, 4), X(class extends he {
  constructor() {
    super({ id: fP, label: m(0, "Quick Fix..."), alias: "Quick Fix...", precondition: q.and(E.writable, E.hasCodeActionsProvider), kbOpts: { kbExpr: E.textInputFocus, primary: 2137, weight: 100 } });
  }
  run(i, e) {
    return Xc(e, m(0, "No code actions available"), void 0, void 0, qs.QuickFix);
  }
}), X(class extends he {
  constructor() {
    super({ id: $H, label: m(0, "Refactor..."), alias: "Refactor...", precondition: q.and(E.writable, E.hasCodeActionsProvider), kbOpts: { kbExpr: E.textInputFocus, primary: 3120, mac: { primary: 1328 }, weight: 100 }, contextMenuOpts: { group: "1_modification", order: 2, when: q.and(E.writable, Qf(ti.Refactor)) }, metadata: { description: "Refactor...", args: [{ name: "args", schema: vx }] } });
  }
  run(i, e, t) {
    const n = tl.fromUser(t, { kind: ti.Refactor, apply: "never" });
    return Xc(e, typeof (t == null ? void 0 : t.kind) == "string" ? n.preferred ? m(0, "No preferred refactorings for '{0}' available", t.kind) : m(0, "No refactorings for '{0}' available", t.kind) : n.preferred ? m(0, "No preferred refactorings available") : m(0, "No refactorings available"), { include: ti.Refactor.contains(n.kind) ? n.kind : Nt.None, onlyIncludePreferredActions: n.preferred }, n.apply, qs.Refactor);
  }
}), X(class extends he {
  constructor() {
    super({ id: GH, label: m(0, "Source Action..."), alias: "Source Action...", precondition: q.and(E.writable, E.hasCodeActionsProvider), contextMenuOpts: { group: "1_modification", order: 2.1, when: q.and(E.writable, Qf(ti.Source)) }, metadata: { description: "Source Action...", args: [{ name: "args", schema: vx }] } });
  }
  run(i, e, t) {
    const n = tl.fromUser(t, { kind: ti.Source, apply: "never" });
    return Xc(e, typeof (t == null ? void 0 : t.kind) == "string" ? n.preferred ? m(0, "No preferred source actions for '{0}' available", t.kind) : m(0, "No source actions for '{0}' available", t.kind) : n.preferred ? m(0, "No preferred source actions available") : m(0, "No source actions available"), { include: ti.Source.contains(n.kind) ? n.kind : Nt.None, includeSourceActions: !0, onlyIncludePreferredActions: n.preferred }, n.apply, qs.SourceAction);
  }
}), X(class extends he {
  constructor() {
    super({ id: _P, label: m(0, "Organize Imports"), alias: "Organize Imports", precondition: q.and(E.writable, Qf(ti.SourceOrganizeImports)), kbOpts: { kbExpr: E.textInputFocus, primary: 1581, weight: 100 } });
  }
  run(i, e) {
    return Xc(e, m(0, "No organize imports action available"), { include: ti.SourceOrganizeImports, includeSourceActions: !0 }, "ifSingle", qs.OrganizeImports);
  }
}), X(class extends he {
  constructor() {
    super({ id: qH, label: m(0, "Auto Fix..."), alias: "Auto Fix...", precondition: q.and(E.writable, Qf(ti.QuickFix)), kbOpts: { kbExpr: E.textInputFocus, primary: 1625, mac: { primary: 2649 }, weight: 100 } });
  }
  run(i, e) {
    return Xc(e, m(0, "No auto fixes available"), { include: ti.QuickFix, onlyIncludePreferredActions: !0 }, "ifSingle", qs.AutoFix);
  }
}), X(class extends he {
  constructor() {
    super({ id: vP, label: m(0, "Fix All"), alias: "Fix All", precondition: q.and(E.writable, Qf(ti.SourceFixAll)) });
  }
  run(i, e) {
    return Xc(e, m(0, "No fix all action available"), { include: ti.SourceFixAll, includeSourceActions: !0 }, "ifSingle", qs.FixAll);
  }
}), re(new class extends Zi {
  constructor() {
    super({ id: jH, precondition: q.and(E.writable, E.hasCodeActionsProvider), metadata: { description: "Trigger a code action", args: [{ name: "args", schema: vx }] } });
  }
  runEditorCommand(i, e, t) {
    const n = tl.fromUser(t, { kind: Nt.Empty, apply: "ifSingle" });
    return Xc(e, typeof (t == null ? void 0 : t.kind) == "string" ? n.preferred ? m(0, "No preferred code actions for '{0}' available", t.kind) : m(0, "No code actions for '{0}' available", t.kind) : n.preferred ? m(0, "No preferred code actions available") : m(0, "No code actions available"), { include: n.kind, includeSourceActions: !0, onlyIncludePreferredActions: n.preferred }, n.apply);
  }
}()), li.as(fa).registerConfiguration({ ...Iy, properties: { "editor.codeActionWidget.showHeaders": { type: "boolean", scope: 5, description: m(0, "Enable/disable showing group headers in the Code Action menu."), default: !0 } } }), li.as(fa).registerConfiguration({ ...Iy, properties: { "editor.codeActionWidget.includeNearbyQuickFixes": { type: "boolean", scope: 5, description: m(0, "Enable/disable showing nearest Quick Fix within a line when not currently on a diagnostic."), default: !0 } } });
class gM {
  constructor() {
    this.lenses = [], this._disposables = new G();
  }
  dispose() {
    this._disposables.dispose();
  }
  get isDisposed() {
    return this._disposables.isDisposed;
  }
  add(e, t) {
    this._disposables.add(e);
    for (const n of e.lenses) this.lenses.push({ symbol: n, provider: t });
  }
}
async function iz(i, e, t) {
  const n = i.ordered(e), s = /* @__PURE__ */ new Map(), o = new gM(), r = n.map(async (a, l) => {
    s.set(a, l);
    try {
      const d = await Promise.resolve(a.provideCodeLenses(e, t));
      d && o.add(d, a);
    } catch (d) {
      Ni(d);
    }
  });
  return await Promise.all(r), o.lenses = o.lenses.sort((a, l) => a.symbol.range.startLineNumber < l.symbol.range.startLineNumber ? -1 : a.symbol.range.startLineNumber > l.symbol.range.startLineNumber ? 1 : s.get(a.provider) < s.get(l.provider) ? -1 : s.get(a.provider) > s.get(l.provider) ? 1 : a.symbol.range.startColumn < l.symbol.range.startColumn ? -1 : a.symbol.range.startColumn > l.symbol.range.startColumn ? 1 : 0), o;
}
dt.registerCommand("_executeCodeLensProvider", function(i, ...e) {
  let [t, n] = e;
  vt(Ie.isUri(t)), vt(typeof n == "number" || !n);
  const { codeLensProvider: s } = i.get(fe), o = i.get(ni).getModel(t);
  if (!o) throw Yo();
  const r = [], a = new G();
  return iz(s, o, et.None).then((l) => {
    a.add(l);
    const d = [];
    for (const h of l.lenses) n == null || h.symbol.command ? r.push(h.symbol) : n-- > 0 && h.provider.resolveCodeLens && d.push(Promise.resolve(h.provider.resolveCodeLens(o, h.symbol, et.None)).then((c) => r.push(c || h.symbol)));
    return Promise.all(d);
  }).then(() => r).finally(() => {
    setTimeout(() => a.dispose(), 100);
  });
});
var Lre = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, kre = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const nz = tt("ICodeLensCache");
class v6 {
  constructor(e, t) {
    this.lineCount = e, this.data = t;
  }
}
let bx = class {
  constructor(i) {
    this._fakeProvider = new class {
      provideCodeLenses() {
        throw new Error("not supported");
      }
    }(), this._cache = new Ll(20, 0.75), g_(Et, () => i.remove("codelens/cache", 1));
    const e = "codelens/cache2", t = i.get(e, 1, "{}");
    this._deserialize(t), se.once(i.onWillSaveState)((n) => {
      n.reason === Fv.SHUTDOWN && i.store(e, this._serialize(), 1, 1);
    });
  }
  put(i, e) {
    const t = e.lenses.map((o) => {
      var r;
      return { range: o.symbol.range, command: o.symbol.command && { id: "", title: (r = o.symbol.command) === null || r === void 0 ? void 0 : r.title } };
    }), n = new gM();
    n.add({ lenses: t, dispose: () => {
    } }, this._fakeProvider);
    const s = new v6(i.getLineCount(), n);
    this._cache.set(i.uri.toString(), s);
  }
  get(i) {
    const e = this._cache.get(i.uri.toString());
    return e && e.lineCount === i.getLineCount() ? e.data : void 0;
  }
  delete(i) {
    this._cache.delete(i.uri.toString());
  }
  _serialize() {
    const i = /* @__PURE__ */ Object.create(null);
    for (const [e, t] of this._cache) {
      const n = /* @__PURE__ */ new Set();
      for (const s of t.data.lenses) n.add(s.symbol.range.startLineNumber);
      i[e] = { lineCount: t.lineCount, lines: [...n.values()] };
    }
    return JSON.stringify(i);
  }
  _deserialize(i) {
    try {
      const e = JSON.parse(i);
      for (const t in e) {
        const n = e[t], s = [];
        for (const r of n.lines) s.push({ range: new D(r, 1, r, 11) });
        const o = new gM();
        o.add({ lenses: s, dispose() {
        } }, this._fakeProvider), this._cache.set(t, new v6(n.lineCount, o));
      }
    } catch {
    }
  }
};
bx = Lre([kre(0, Nr)], bx), rt(nz, bx, 1);
class Dre {
  constructor(e, t, n) {
    this.afterColumn = 1073741824, this.afterLineNumber = e, this.heightInPx = t, this._onHeight = n, this.suppressMouseDown = !0, this.domNode = document.createElement("div");
  }
  onComputedHeight(e) {
    this._lastHeight === void 0 ? this._lastHeight = e : this._lastHeight !== e && (this._lastHeight = e, this._onHeight());
  }
  isVisible() {
    return this._lastHeight !== 0 && this.domNode.hasAttribute("monaco-visible-view-zone");
  }
}
class e1 {
  constructor(e, t) {
    this.allowEditorOverflow = !1, this.suppressMouseDown = !0, this._commands = /* @__PURE__ */ new Map(), this._isEmpty = !0, this._editor = e, this._id = "codelens.widget-" + e1._idPool++, this.updatePosition(t), this._domNode = document.createElement("span"), this._domNode.className = "codelens-decoration";
  }
  withCommands(e, t) {
    this._commands.clear();
    const n = [];
    let s = !1;
    for (let o = 0; o < e.length; o++) {
      const r = e[o];
      if (r && (s = !0, r.command)) {
        const a = ic(r.command.title.trim());
        if (r.command.id) {
          const l = "c" + e1._idPool++;
          n.push(Q("a", { id: l, title: r.command.tooltip, role: "button" }, ...a)), this._commands.set(l, r.command);
        } else n.push(Q("span", { title: r.command.tooltip }, ...a));
        o + 1 < e.length && n.push(Q("span", void 0, " | "));
      }
    }
    s ? (wn(this._domNode, ...n), this._isEmpty && t && this._domNode.classList.add("fadein"), this._isEmpty = !1) : wn(this._domNode, Q("span", void 0, "no commands"));
  }
  getCommand(e) {
    return e.parentElement === this._domNode ? this._commands.get(e.id) : void 0;
  }
  getId() {
    return this._id;
  }
  getDomNode() {
    return this._domNode;
  }
  updatePosition(e) {
    const t = this._editor.getModel().getLineFirstNonWhitespaceColumn(e);
    this._widgetPosition = { position: { lineNumber: e, column: t }, preference: [1] };
  }
  getPosition() {
    return this._widgetPosition || null;
  }
}
e1._idPool = 0;
class Cx {
  constructor() {
    this._removeDecorations = [], this._addDecorations = [], this._addDecorationsCallbacks = [];
  }
  addDecoration(e, t) {
    this._addDecorations.push(e), this._addDecorationsCallbacks.push(t);
  }
  removeDecoration(e) {
    this._removeDecorations.push(e);
  }
  commit(e) {
    const t = e.deltaDecorations(this._removeDecorations, this._addDecorations);
    for (let n = 0, s = t.length; n < s; n++) this._addDecorationsCallbacks[n](t[n]);
  }
}
const b6 = Ve.register({ collapseOnReplaceEdit: !0, description: "codelens" });
class C6 {
  constructor(e, t, n, s, o, r) {
    let a;
    this._isDisposed = !1, this._editor = t, this._data = e, this._decorationIds = [];
    const l = [];
    this._data.forEach((d, h) => {
      d.symbol.command && l.push(d.symbol), n.addDecoration({ range: d.symbol.range, options: b6 }, (c) => this._decorationIds[h] = c), a = a ? D.plusRange(a, d.symbol.range) : D.lift(d.symbol.range);
    }), this._viewZone = new Dre(a.startLineNumber - 1, o, r), this._viewZoneId = s.addZone(this._viewZone), l.length > 0 && (this._createContentWidgetIfNecessary(), this._contentWidget.withCommands(l, !1));
  }
  _createContentWidgetIfNecessary() {
    this._contentWidget ? this._editor.layoutContentWidget(this._contentWidget) : (this._contentWidget = new e1(this._editor, this._viewZone.afterLineNumber + 1), this._editor.addContentWidget(this._contentWidget));
  }
  dispose(e, t) {
    this._decorationIds.forEach(e.removeDecoration, e), this._decorationIds = [], t == null || t.removeZone(this._viewZoneId), this._contentWidget && (this._editor.removeContentWidget(this._contentWidget), this._contentWidget = void 0), this._isDisposed = !0;
  }
  isDisposed() {
    return this._isDisposed;
  }
  isValid() {
    return this._decorationIds.some((e, t) => {
      const n = this._editor.getModel().getDecorationRange(e), s = this._data[t].symbol;
      return !(!n || D.isEmpty(s.range) !== n.isEmpty());
    });
  }
  updateCodeLensSymbols(e, t) {
    this._decorationIds.forEach(t.removeDecoration, t), this._decorationIds = [], this._data = e, this._data.forEach((n, s) => {
      t.addDecoration({ range: n.symbol.range, options: b6 }, (o) => this._decorationIds[s] = o);
    });
  }
  updateHeight(e, t) {
    this._viewZone.heightInPx = e, t.layoutZone(this._viewZoneId), this._contentWidget && this._editor.layoutContentWidget(this._contentWidget);
  }
  computeIfNecessary(e) {
    if (!this._viewZone.isVisible()) return null;
    for (let t = 0; t < this._decorationIds.length; t++) {
      const n = e.getDecorationRange(this._decorationIds[t]);
      n && (this._data[t].symbol.range = n);
    }
    return this._data;
  }
  updateCommands(e) {
    this._createContentWidgetIfNecessary(), this._contentWidget.withCommands(e, !0);
    for (let t = 0; t < this._data.length; t++) {
      const n = e[t];
      if (n) {
        const { symbol: s } = this._data[t];
        s.command = n.command || s.command;
      }
    }
  }
  getCommand(e) {
    var t;
    return (t = this._contentWidget) === null || t === void 0 ? void 0 : t.getCommand(e);
  }
  getLineNumber() {
    const e = this._editor.getModel().getDecorationRange(this._decorationIds[0]);
    return e ? e.startLineNumber : -1;
  }
  update(e) {
    if (this.isValid()) {
      const t = this._editor.getModel().getDecorationRange(this._decorationIds[0]);
      t && (this._viewZone.afterLineNumber = t.startLineNumber - 1, e.layoutZone(this._viewZoneId), this._contentWidget && (this._contentWidget.updatePosition(t.startLineNumber), this._editor.layoutContentWidget(this._contentWidget)));
    }
  }
}
var xre = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Jf = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let tp = class {
  constructor(i, e, t, n, s, o) {
    this._editor = i, this._languageFeaturesService = e, this._commandService = n, this._notificationService = s, this._codeLensCache = o, this._disposables = new G(), this._localToDispose = new G(), this._lenses = [], this._oldCodeLensModels = new G(), this._provideCodeLensDebounce = t.for(e.codeLensProvider, "CodeLensProvide", { min: 250 }), this._resolveCodeLensesDebounce = t.for(e.codeLensProvider, "CodeLensResolve", { min: 250, salt: "resolve" }), this._resolveCodeLensesScheduler = new It(() => this._resolveCodeLensesInViewport(), this._resolveCodeLensesDebounce.default()), this._disposables.add(this._editor.onDidChangeModel(() => this._onModelChange())), this._disposables.add(this._editor.onDidChangeModelLanguage(() => this._onModelChange())), this._disposables.add(this._editor.onDidChangeConfiguration((r) => {
      (r.hasChanged(50) || r.hasChanged(19) || r.hasChanged(18)) && this._updateLensStyle(), r.hasChanged(17) && this._onModelChange();
    })), this._disposables.add(e.codeLensProvider.onDidChange(this._onModelChange, this)), this._onModelChange(), this._updateLensStyle();
  }
  dispose() {
    var i;
    this._localDispose(), this._disposables.dispose(), this._oldCodeLensModels.dispose(), (i = this._currentCodeLensModel) === null || i === void 0 || i.dispose();
  }
  _getLayoutInfo() {
    const i = Math.max(1.3, this._editor.getOption(67) / this._editor.getOption(52));
    let e = this._editor.getOption(19);
    return (!e || e < 5) && (e = 0.9 * this._editor.getOption(52) | 0), { fontSize: e, codeLensHeight: e * i | 0 };
  }
  _updateLensStyle() {
    const { codeLensHeight: i, fontSize: e } = this._getLayoutInfo(), t = this._editor.getOption(18), n = this._editor.getOption(50), { style: s } = this._editor.getContainerDomNode();
    s.setProperty("--vscode-editorCodeLens-lineHeight", `${i}px`), s.setProperty("--vscode-editorCodeLens-fontSize", `${e}px`), s.setProperty("--vscode-editorCodeLens-fontFeatureSettings", n.fontFeatureSettings), t && (s.setProperty("--vscode-editorCodeLens-fontFamily", t), s.setProperty("--vscode-editorCodeLens-fontFamilyDefault", Is.fontFamily)), this._editor.changeViewZones((o) => {
      for (const r of this._lenses) r.updateHeight(i, o);
    });
  }
  _localDispose() {
    var i, e, t;
    (i = this._getCodeLensModelPromise) === null || i === void 0 || i.cancel(), this._getCodeLensModelPromise = void 0, (e = this._resolveCodeLensesPromise) === null || e === void 0 || e.cancel(), this._resolveCodeLensesPromise = void 0, this._localToDispose.clear(), this._oldCodeLensModels.clear(), (t = this._currentCodeLensModel) === null || t === void 0 || t.dispose();
  }
  _onModelChange() {
    this._localDispose();
    const i = this._editor.getModel();
    if (!i || !this._editor.getOption(17) || i.isTooLargeForTokenization()) return;
    const e = this._codeLensCache.get(i);
    if (e && this._renderCodeLensSymbols(e), !this._languageFeaturesService.codeLensProvider.has(i)) return void (e && Cc(() => {
      const n = this._codeLensCache.get(i);
      e === n && (this._codeLensCache.delete(i), this._onModelChange());
    }, 3e4, this._localToDispose));
    for (const n of this._languageFeaturesService.codeLensProvider.all(i)) if (typeof n.onDidChange == "function") {
      const s = n.onDidChange(() => t.schedule());
      this._localToDispose.add(s);
    }
    const t = new It(() => {
      var n;
      const s = Date.now();
      (n = this._getCodeLensModelPromise) === null || n === void 0 || n.cancel(), this._getCodeLensModelPromise = on((o) => iz(this._languageFeaturesService.codeLensProvider, i, o)), this._getCodeLensModelPromise.then((o) => {
        this._currentCodeLensModel && this._oldCodeLensModels.add(this._currentCodeLensModel), this._currentCodeLensModel = o, this._codeLensCache.put(i, o);
        const r = this._provideCodeLensDebounce.update(i, Date.now() - s);
        t.delay = r, this._renderCodeLensSymbols(o), this._resolveCodeLensesInViewportSoon();
      }, We);
    }, this._provideCodeLensDebounce.get(i));
    this._localToDispose.add(t), this._localToDispose.add(ye(() => this._resolveCodeLensesScheduler.cancel())), this._localToDispose.add(this._editor.onDidChangeModelContent(() => {
      var n;
      this._editor.changeDecorations((s) => {
        this._editor.changeViewZones((o) => {
          const r = [];
          let a = -1;
          this._lenses.forEach((d) => {
            d.isValid() && a !== d.getLineNumber() ? (d.update(o), a = d.getLineNumber()) : r.push(d);
          });
          const l = new Cx();
          r.forEach((d) => {
            d.dispose(l, o), this._lenses.splice(this._lenses.indexOf(d), 1);
          }), l.commit(s);
        });
      }), t.schedule(), this._resolveCodeLensesScheduler.cancel(), (n = this._resolveCodeLensesPromise) === null || n === void 0 || n.cancel(), this._resolveCodeLensesPromise = void 0;
    })), this._localToDispose.add(this._editor.onDidFocusEditorWidget(() => {
      t.schedule();
    })), this._localToDispose.add(this._editor.onDidBlurEditorText(() => {
      t.cancel();
    })), this._localToDispose.add(this._editor.onDidScrollChange((n) => {
      n.scrollTopChanged && this._lenses.length > 0 && this._resolveCodeLensesInViewportSoon();
    })), this._localToDispose.add(this._editor.onDidLayoutChange(() => {
      this._resolveCodeLensesInViewportSoon();
    })), this._localToDispose.add(ye(() => {
      if (this._editor.getModel()) {
        const n = ya.capture(this._editor);
        this._editor.changeDecorations((s) => {
          this._editor.changeViewZones((o) => {
            this._disposeAllLenses(s, o);
          });
        }), n.restore(this._editor);
      } else this._disposeAllLenses(void 0, void 0);
    })), this._localToDispose.add(this._editor.onMouseDown((n) => {
      if (n.target.type !== 9) return;
      let s = n.target.element;
      if ((s == null ? void 0 : s.tagName) === "SPAN" && (s = s.parentElement), (s == null ? void 0 : s.tagName) === "A") for (const o of this._lenses) {
        const r = o.getCommand(s);
        if (r) {
          this._commandService.executeCommand(r.id, ...r.arguments || []).catch((a) => this._notificationService.error(a));
          break;
        }
      }
    })), t.schedule();
  }
  _disposeAllLenses(i, e) {
    const t = new Cx();
    for (const n of this._lenses) n.dispose(t, e);
    i && t.commit(i), this._lenses.length = 0;
  }
  _renderCodeLensSymbols(i) {
    if (!this._editor.hasModel()) return;
    const e = this._editor.getModel().getLineCount(), t = [];
    let n;
    for (const r of i.lenses) {
      const a = r.symbol.range.startLineNumber;
      a < 1 || a > e || (n && n[n.length - 1].symbol.range.startLineNumber === a ? n.push(r) : (n = [r], t.push(n)));
    }
    if (!t.length && !this._lenses.length) return;
    const s = ya.capture(this._editor), o = this._getLayoutInfo();
    this._editor.changeDecorations((r) => {
      this._editor.changeViewZones((a) => {
        const l = new Cx();
        let d = 0, h = 0;
        for (; h < t.length && d < this._lenses.length; ) {
          const c = t[h][0].symbol.range.startLineNumber, u = this._lenses[d].getLineNumber();
          u < c ? (this._lenses[d].dispose(l, a), this._lenses.splice(d, 1)) : u === c ? (this._lenses[d].updateCodeLensSymbols(t[h], l), h++, d++) : (this._lenses.splice(d, 0, new C6(t[h], this._editor, l, a, o.codeLensHeight, () => this._resolveCodeLensesInViewportSoon())), d++, h++);
        }
        for (; d < this._lenses.length; ) this._lenses[d].dispose(l, a), this._lenses.splice(d, 1);
        for (; h < t.length; ) this._lenses.push(new C6(t[h], this._editor, l, a, o.codeLensHeight, () => this._resolveCodeLensesInViewportSoon())), h++;
        l.commit(r);
      });
    }), s.restore(this._editor);
  }
  _resolveCodeLensesInViewportSoon() {
    this._editor.getModel() && this._resolveCodeLensesScheduler.schedule();
  }
  _resolveCodeLensesInViewport() {
    var i;
    (i = this._resolveCodeLensesPromise) === null || i === void 0 || i.cancel(), this._resolveCodeLensesPromise = void 0;
    const e = this._editor.getModel();
    if (!e) return;
    const t = [], n = [];
    if (this._lenses.forEach((r) => {
      const a = r.computeIfNecessary(e);
      a && (t.push(a), n.push(r));
    }), t.length === 0) return;
    const s = Date.now(), o = on((r) => {
      const a = t.map((l, d) => {
        const h = new Array(l.length), c = l.map((u, g) => u.symbol.command || typeof u.provider.resolveCodeLens != "function" ? (h[g] = u.symbol, Promise.resolve(void 0)) : Promise.resolve(u.provider.resolveCodeLens(e, u.symbol, r)).then((p) => {
          h[g] = p;
        }, Ni));
        return Promise.all(c).then(() => {
          r.isCancellationRequested || n[d].isDisposed() || n[d].updateCommands(h);
        });
      });
      return Promise.all(a);
    });
    this._resolveCodeLensesPromise = o, this._resolveCodeLensesPromise.then(() => {
      const r = this._resolveCodeLensesDebounce.update(e, Date.now() - s);
      this._resolveCodeLensesScheduler.delay = r, this._currentCodeLensModel && this._codeLensCache.put(e, this._currentCodeLensModel), this._oldCodeLensModels.clear(), o === this._resolveCodeLensesPromise && (this._resolveCodeLensesPromise = void 0);
    }, (r) => {
      We(r), o === this._resolveCodeLensesPromise && (this._resolveCodeLensesPromise = void 0);
    });
  }
  async getModel() {
    var i;
    return await this._getCodeLensModelPromise, await this._resolveCodeLensesPromise, !((i = this._currentCodeLensModel) === null || i === void 0) && i.isDisposed ? void 0 : this._currentCodeLensModel;
  }
};
tp.ID = "css.editor.codeLens", tp = xre([Jf(1, fe), Jf(2, ar), Jf(3, ai), Jf(4, Ri), Jf(5, nz)], tp), ft(tp.ID, tp, 1), X(class extends he {
  constructor() {
    super({ id: "codelens.showLensesInCurrentLine", precondition: E.hasCodeLensProvider, label: m(0, "Show CodeLens Commands For Current Line"), alias: "Show CodeLens Commands For Current Line" });
  }
  async run(i, e) {
    if (!e.hasModel()) return;
    const t = i.get(La), n = i.get(ai), s = i.get(Ri), o = e.getSelection().positionLineNumber, r = e.getContribution(tp.ID);
    if (!r) return;
    const a = await r.getModel();
    if (!a) return;
    const l = [];
    for (const c of a.lenses) c.symbol.command && c.symbol.range.startLineNumber === o && l.push({ label: c.symbol.command.title, command: c.symbol.command });
    if (l.length === 0) return;
    const d = await t.pick(l, { canPickMany: !1, placeHolder: m(0, "Select a command") });
    if (!d) return;
    let h = d.command;
    if (a.isDisposed) {
      const c = await r.getModel(), u = c == null ? void 0 : c.lenses.find((g) => {
        var p;
        return g.symbol.range.startLineNumber === o && ((p = g.symbol.command) === null || p === void 0 ? void 0 : p.title) === h.title;
      });
      if (!u || !u.symbol.command) return;
      h = u.symbol.command;
    }
    try {
      await n.executeCommand(h.id, ...h.arguments || []);
    } catch (c) {
      s.error(c);
    }
  }
});
var Nre = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, wx = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class bP {
  constructor(e, t) {
    this._editorWorkerClient = new ER(e, !1, "editorWorkerService", t);
  }
  async provideDocumentColors(e, t) {
    return this._editorWorkerClient.computeDefaultDocumentColors(e.uri);
  }
  provideColorPresentations(e, t, n) {
    const s = t.range, o = t.color, r = o.alpha, a = new z(new ht(Math.round(255 * o.red), Math.round(255 * o.green), Math.round(255 * o.blue), r)), l = r ? z.Format.CSS.formatRGB(a) : z.Format.CSS.formatRGBA(a), d = r ? z.Format.CSS.formatHSL(a) : z.Format.CSS.formatHSLA(a), h = r ? z.Format.CSS.formatHex(a) : z.Format.CSS.formatHexA(a), c = [];
    return c.push({ label: l, textEdit: { range: s, text: l } }), c.push({ label: d, textEdit: { range: s, text: d } }), c.push({ label: h, textEdit: { range: s, text: h } }), c;
  }
}
let yx = class extends V {
  constructor(i, e, t) {
    super(), this._register(t.colorProvider.register("*", new bP(i, e)));
  }
};
async function sz(i, e, t, n = !0) {
  return pM(new Ere(), i, e, t, n);
}
function oz(i, e, t, n) {
  return Promise.resolve(t.provideColorPresentations(i, e, n));
}
yx = Nre([wx(0, ni), wx(1, zt), wx(2, fe)], yx), H1(yx);
class Ere {
  constructor() {
  }
  async compute(e, t, n, s) {
    const o = await e.provideDocumentColors(t, n);
    if (Array.isArray(o)) for (const r of o) s.push({ colorInfo: r, provider: e });
    return Array.isArray(o);
  }
}
class Ire {
  constructor() {
  }
  async compute(e, t, n, s) {
    const o = await e.provideDocumentColors(t, n);
    if (Array.isArray(o)) for (const r of o) s.push({ range: r.range, color: [r.color.red, r.color.green, r.color.blue, r.color.alpha] });
    return Array.isArray(o);
  }
}
class Mre {
  constructor(e) {
    this.colorInfo = e;
  }
  async compute(e, t, n, s) {
    const o = await e.provideColorPresentations(t, this.colorInfo, et.None);
    return Array.isArray(o) && s.push(...o), Array.isArray(o);
  }
}
async function pM(i, e, t, n, s) {
  let o, r = !1;
  const a = [], l = e.ordered(t);
  for (let d = l.length - 1; d >= 0; d--) {
    const h = l[d];
    if (h instanceof bP) o = h;
    else try {
      await i.compute(h, t, n, a) && (r = !0);
    } catch (c) {
      Ni(c);
    }
  }
  return r ? a : o && s ? (await i.compute(o, t, n, a), a) : [];
}
function w6(i, e) {
  const { colorProvider: t } = i.get(fe), n = i.get(ni).getModel(e);
  if (!n) throw Yo();
  return { model: n, colorProviderRegistry: t, isDefaultColorDecoratorsEnabled: i.get(Ye).getValue("editor.defaultColorDecorators", { resource: e }) };
}
dt.registerCommand("_executeDocumentColorProvider", function(i, ...e) {
  const [t] = e;
  if (!(t instanceof Ie)) throw Yo();
  const { model: n, colorProviderRegistry: s, isDefaultColorDecoratorsEnabled: o } = w6(i, t);
  return pM(new Ire(), s, n, et.None, o);
}), dt.registerCommand("_executeColorPresentationProvider", function(i, ...e) {
  const [t, n] = e, { uri: s, range: o } = n;
  if (!(s instanceof Ie && Array.isArray(t) && t.length === 4 && D.isIRange(o))) throw Yo();
  const { model: r, colorProviderRegistry: a, isDefaultColorDecoratorsEnabled: l } = w6(i, s), [d, h, c, u] = t;
  return pM(new Mre({ range: o, color: { red: d, green: h, blue: c, alpha: u } }), a, r, et.None, l);
});
var mM, Tre = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Sx = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const rz = /* @__PURE__ */ Object.create({});
let Kh = mM = class extends V {
  constructor(i, e, t, n) {
    super(), this._editor = i, this._configurationService = e, this._languageFeaturesService = t, this._localToDispose = this._register(new G()), this._decorationsIds = [], this._colorDatas = /* @__PURE__ */ new Map(), this._colorDecoratorIds = this._editor.createDecorationsCollection(), this._ruleFactory = new S1(this._editor), this._decoratorLimitReporter = new Rre(), this._colorDecorationClassRefs = this._register(new G()), this._debounceInformation = n.for(t.colorProvider, "Document Colors", { min: mM.RECOMPUTE_TIME }), this._register(i.onDidChangeModel(() => {
      this._isColorDecoratorsEnabled = this.isEnabled(), this.updateColors();
    })), this._register(i.onDidChangeModelLanguage(() => this.updateColors())), this._register(t.colorProvider.onDidChange(() => this.updateColors())), this._register(i.onDidChangeConfiguration((s) => {
      const o = this._isColorDecoratorsEnabled;
      this._isColorDecoratorsEnabled = this.isEnabled(), this._isDefaultColorDecoratorsEnabled = this._editor.getOption(147);
      const r = o !== this._isColorDecoratorsEnabled || s.hasChanged(21), a = s.hasChanged(147);
      (r || a) && (this._isColorDecoratorsEnabled ? this.updateColors() : this.removeAllDecorations());
    })), this._timeoutTimer = null, this._computePromise = null, this._isColorDecoratorsEnabled = this.isEnabled(), this._isDefaultColorDecoratorsEnabled = this._editor.getOption(147), this.updateColors();
  }
  isEnabled() {
    const i = this._editor.getModel();
    if (!i) return !1;
    const e = i.getLanguageId(), t = this._configurationService.getValue(e);
    if (t && typeof t == "object") {
      const n = t.colorDecorators;
      if (n && n.enable !== void 0 && !n.enable) return n.enable;
    }
    return this._editor.getOption(20);
  }
  static get(i) {
    return i.getContribution(this.ID);
  }
  dispose() {
    this.stop(), this.removeAllDecorations(), super.dispose();
  }
  updateColors() {
    if (this.stop(), !this._isColorDecoratorsEnabled) return;
    const i = this._editor.getModel();
    i && this._languageFeaturesService.colorProvider.has(i) && (this._localToDispose.add(this._editor.onDidChangeModelContent(() => {
      this._timeoutTimer || (this._timeoutTimer = new Dr(), this._timeoutTimer.cancelAndSet(() => {
        this._timeoutTimer = null, this.beginCompute();
      }, this._debounceInformation.get(i)));
    })), this.beginCompute());
  }
  async beginCompute() {
    this._computePromise = on(async (i) => {
      const e = this._editor.getModel();
      if (!e) return [];
      const t = new Rn(!1), n = await sz(this._languageFeaturesService.colorProvider, e, i, this._isDefaultColorDecoratorsEnabled);
      return this._debounceInformation.update(e, t.elapsed()), n;
    });
    try {
      const i = await this._computePromise;
      this.updateDecorations(i), this.updateColorDecorators(i), this._computePromise = null;
    } catch (i) {
      We(i);
    }
  }
  stop() {
    this._timeoutTimer && (this._timeoutTimer.cancel(), this._timeoutTimer = null), this._computePromise && (this._computePromise.cancel(), this._computePromise = null), this._localToDispose.clear();
  }
  updateDecorations(i) {
    const e = i.map((t) => ({ range: { startLineNumber: t.colorInfo.range.startLineNumber, startColumn: t.colorInfo.range.startColumn, endLineNumber: t.colorInfo.range.endLineNumber, endColumn: t.colorInfo.range.endColumn }, options: Ve.EMPTY }));
    this._editor.changeDecorations((t) => {
      this._decorationsIds = t.deltaDecorations(this._decorationsIds, e), this._colorDatas = /* @__PURE__ */ new Map(), this._decorationsIds.forEach((n, s) => this._colorDatas.set(n, i[s]));
    });
  }
  updateColorDecorators(i) {
    this._colorDecorationClassRefs.clear();
    const e = [], t = this._editor.getOption(21);
    for (let s = 0; s < i.length && e.length < t; s++) {
      const { red: o, green: r, blue: a, alpha: l } = i[s].colorInfo.color, d = new ht(Math.round(255 * o), Math.round(255 * r), Math.round(255 * a), l), h = `rgba(${d.r}, ${d.g}, ${d.b}, ${d.a})`, c = this._colorDecorationClassRefs.add(this._ruleFactory.createClassNameRef({ backgroundColor: h }));
      e.push({ range: { startLineNumber: i[s].colorInfo.range.startLineNumber, startColumn: i[s].colorInfo.range.startColumn, endLineNumber: i[s].colorInfo.range.endLineNumber, endColumn: i[s].colorInfo.range.endColumn }, options: { description: "colorDetector", before: { content: " ", inlineClassName: `${c.className} colorpicker-color-decoration`, inlineClassNameAffectsLetterSpacing: !0, attachedData: rz } } });
    }
    const n = t < i.length && t;
    this._decoratorLimitReporter.update(i.length, n), this._colorDecoratorIds.set(e);
  }
  removeAllDecorations() {
    this._editor.removeDecorations(this._decorationsIds), this._decorationsIds = [], this._colorDecoratorIds.clear(), this._colorDecorationClassRefs.clear();
  }
  getColorData(i) {
    const e = this._editor.getModel();
    if (!e) return null;
    const t = e.getDecorationsInRange(D.fromPositions(i, i)).filter((n) => this._colorDatas.has(n.id));
    return t.length === 0 ? null : this._colorDatas.get(t[0].id);
  }
  isColorDecoration(i) {
    return this._colorDecoratorIds.has(i);
  }
};
Kh.ID = "editor.contrib.colorDetector", Kh.RECOMPUTE_TIME = 1e3, Kh = mM = Tre([Sx(1, Ye), Sx(2, fe), Sx(3, ar)], Kh);
class Rre {
  constructor() {
    this._onDidChange = new F(), this._computed = 0, this._limited = !1;
  }
  update(e, t) {
    e === this._computed && t === this._limited || (this._computed = e, this._limited = t, this._onDidChange.fire());
  }
}
ft(Kh.ID, Kh, 1);
class Are {
  get color() {
    return this._color;
  }
  set color(e) {
    this._color.equals(e) || (this._color = e, this._onDidChangeColor.fire(e));
  }
  get presentation() {
    return this.colorPresentations[this.presentationIndex];
  }
  get colorPresentations() {
    return this._colorPresentations;
  }
  set colorPresentations(e) {
    this._colorPresentations = e, this.presentationIndex > e.length - 1 && (this.presentationIndex = 0), this._onDidChangePresentation.fire(this.presentation);
  }
  constructor(e, t, n) {
    this.presentationIndex = n, this._onColorFlushed = new F(), this.onColorFlushed = this._onColorFlushed.event, this._onDidChangeColor = new F(), this.onDidChangeColor = this._onDidChangeColor.event, this._onDidChangePresentation = new F(), this.onDidChangePresentation = this._onDidChangePresentation.event, this.originalColor = e, this._color = e, this._colorPresentations = t;
  }
  selectNextColorPresentation() {
    this.presentationIndex = (this.presentationIndex + 1) % this.colorPresentations.length, this.flushColor(), this._onDidChangePresentation.fire(this.presentation);
  }
  guessColorPresentation(e, t) {
    let n = -1;
    for (let s = 0; s < this.colorPresentations.length; s++) if (t.toLowerCase() === this.colorPresentations[s].label) {
      n = s;
      break;
    }
    if (n === -1) {
      const s = t.split("(")[0].toLowerCase();
      for (let o = 0; o < this.colorPresentations.length; o++) if (this.colorPresentations[o].label.toLowerCase().startsWith(s)) {
        n = o;
        break;
      }
    }
    n !== -1 && n !== this.presentationIndex && (this.presentationIndex = n, this._onDidChangePresentation.fire(this.presentation));
  }
  flushColor() {
    this._onColorFlushed.fire(this._color);
  }
}
const vo = Q;
class Pre extends V {
  constructor(e, t, n, s = !1) {
    super(), this.model = t, this.showingStandaloneColorPicker = s, this._closeButton = null, this._domNode = vo(".colorpicker-header"), Z(e, this._domNode), this._pickedColorNode = Z(this._domNode, vo(".picked-color")), Z(this._pickedColorNode, vo("span.codicon.codicon-color-mode")), this._pickedColorPresentation = Z(this._pickedColorNode, document.createElement("span")), this._pickedColorPresentation.classList.add("picked-color-presentation");
    const o = m(0, "Click to toggle color options (rgb/hsl/hex)");
    this._pickedColorNode.setAttribute("title", o), this._originalColorNode = Z(this._domNode, vo(".original-color")), this._originalColorNode.style.backgroundColor = z.Format.CSS.format(this.model.originalColor) || "", this.backgroundColor = n.getColorTheme().getColor(ay) || z.white, this._register(n.onDidColorThemeChange((r) => {
      this.backgroundColor = r.getColor(ay) || z.white;
    })), this._register(K(this._pickedColorNode, ie.CLICK, () => this.model.selectNextColorPresentation())), this._register(K(this._originalColorNode, ie.CLICK, () => {
      this.model.color = this.model.originalColor, this.model.flushColor();
    })), this._register(t.onDidChangeColor(this.onDidChangeColor, this)), this._register(t.onDidChangePresentation(this.onDidChangePresentation, this)), this._pickedColorNode.style.backgroundColor = z.Format.CSS.format(t.color) || "", this._pickedColorNode.classList.toggle("light", t.color.rgba.a < 0.5 ? this.backgroundColor.isLighter() : t.color.isLighter()), this.onDidChangeColor(this.model.color), this.showingStandaloneColorPicker && (this._domNode.classList.add("standalone-colorpicker"), this._closeButton = this._register(new Ore(this._domNode)));
  }
  get closeButton() {
    return this._closeButton;
  }
  get pickedColorNode() {
    return this._pickedColorNode;
  }
  get originalColorNode() {
    return this._originalColorNode;
  }
  onDidChangeColor(e) {
    this._pickedColorNode.style.backgroundColor = z.Format.CSS.format(e) || "", this._pickedColorNode.classList.toggle("light", e.rgba.a < 0.5 ? this.backgroundColor.isLighter() : e.isLighter()), this.onDidChangePresentation();
  }
  onDidChangePresentation() {
    this._pickedColorPresentation.textContent = this.model.presentation ? this.model.presentation.label : "";
  }
}
class Ore extends V {
  constructor(e) {
    super(), this._onClicked = this._register(new F()), this.onClicked = this._onClicked.event, this._button = document.createElement("div"), this._button.classList.add("close-button"), Z(e, this._button);
    const t = document.createElement("div");
    t.classList.add("close-button-inner-div"), Z(this._button, t), Z(t, vo(".button" + Ee.asCSSSelector(Ei("color-picker-close", ne.close, m(0, "Icon to close the color picker"))))).classList.add("close-icon"), this._register(K(this._button, ie.CLICK, () => {
      this._onClicked.fire();
    }));
  }
}
class Fre extends V {
  constructor(e, t, n, s = !1) {
    super(), this.model = t, this.pixelRatio = n, this._insertButton = null, this._domNode = vo(".colorpicker-body"), Z(e, this._domNode), this._saturationBox = new Bre(this._domNode, this.model, this.pixelRatio), this._register(this._saturationBox), this._register(this._saturationBox.onDidChange(this.onDidSaturationValueChange, this)), this._register(this._saturationBox.onColorFlushed(this.flushColor, this)), this._opacityStrip = new Wre(this._domNode, this.model, s), this._register(this._opacityStrip), this._register(this._opacityStrip.onDidChange(this.onDidOpacityChange, this)), this._register(this._opacityStrip.onColorFlushed(this.flushColor, this)), this._hueStrip = new Vre(this._domNode, this.model, s), this._register(this._hueStrip), this._register(this._hueStrip.onDidChange(this.onDidHueChange, this)), this._register(this._hueStrip.onColorFlushed(this.flushColor, this)), s && (this._insertButton = this._register(new Hre(this._domNode)), this._domNode.classList.add("standalone-colorpicker"));
  }
  flushColor() {
    this.model.flushColor();
  }
  onDidSaturationValueChange({ s: e, v: t }) {
    const n = this.model.color.hsva;
    this.model.color = new z(new nl(n.h, e, t, n.a));
  }
  onDidOpacityChange(e) {
    const t = this.model.color.hsva;
    this.model.color = new z(new nl(t.h, t.s, t.v, e));
  }
  onDidHueChange(e) {
    const t = this.model.color.hsva, n = 360 * (1 - e);
    this.model.color = new z(new nl(n === 360 ? 0 : n, t.s, t.v, t.a));
  }
  get domNode() {
    return this._domNode;
  }
  get saturationBox() {
    return this._saturationBox;
  }
  get enterButton() {
    return this._insertButton;
  }
  layout() {
    this._saturationBox.layout(), this._opacityStrip.layout(), this._hueStrip.layout();
  }
}
class Bre extends V {
  constructor(e, t, n) {
    super(), this.model = t, this.pixelRatio = n, this._onDidChange = new F(), this.onDidChange = this._onDidChange.event, this._onColorFlushed = new F(), this.onColorFlushed = this._onColorFlushed.event, this._domNode = vo(".saturation-wrap"), Z(e, this._domNode), this._canvas = document.createElement("canvas"), this._canvas.className = "saturation-box", Z(this._domNode, this._canvas), this.selection = vo(".saturation-selection"), Z(this._domNode, this.selection), this.layout(), this._register(K(this._domNode, ie.POINTER_DOWN, (s) => this.onPointerDown(s))), this._register(this.model.onDidChangeColor(this.onDidChangeColor, this)), this.monitor = null;
  }
  get domNode() {
    return this._domNode;
  }
  onPointerDown(e) {
    if (!(e.target && e.target instanceof Element)) return;
    this.monitor = this._register(new vf());
    const t = Ti(this._domNode);
    e.target !== this.selection && this.onDidChangePosition(e.offsetX, e.offsetY), this.monitor.startMonitoring(e.target, e.pointerId, e.buttons, (s) => this.onDidChangePosition(s.pageX - t.left, s.pageY - t.top), () => null);
    const n = K(e.target.ownerDocument, ie.POINTER_UP, () => {
      this._onColorFlushed.fire(), n.dispose(), this.monitor && (this.monitor.stopMonitoring(!0), this.monitor = null);
    }, !0);
  }
  onDidChangePosition(e, t) {
    const n = Math.max(0, Math.min(1, e / this.width)), s = Math.max(0, Math.min(1, 1 - t / this.height));
    this.paintSelection(n, s), this._onDidChange.fire({ s: n, v: s });
  }
  layout() {
    this.width = this._domNode.offsetWidth, this.height = this._domNode.offsetHeight, this._canvas.width = this.width * this.pixelRatio, this._canvas.height = this.height * this.pixelRatio, this.paint();
    const e = this.model.color.hsva;
    this.paintSelection(e.s, e.v);
  }
  paint() {
    const e = this.model.color.hsva, t = new z(new nl(e.h, 1, 1, 1)), n = this._canvas.getContext("2d"), s = n.createLinearGradient(0, 0, this._canvas.width, 0);
    s.addColorStop(0, "rgba(255, 255, 255, 1)"), s.addColorStop(0.5, "rgba(255, 255, 255, 0.5)"), s.addColorStop(1, "rgba(255, 255, 255, 0)");
    const o = n.createLinearGradient(0, 0, 0, this._canvas.height);
    o.addColorStop(0, "rgba(0, 0, 0, 0)"), o.addColorStop(1, "rgba(0, 0, 0, 1)"), n.rect(0, 0, this._canvas.width, this._canvas.height), n.fillStyle = z.Format.CSS.format(t), n.fill(), n.fillStyle = s, n.fill(), n.fillStyle = o, n.fill();
  }
  paintSelection(e, t) {
    this.selection.style.left = e * this.width + "px", this.selection.style.top = this.height - t * this.height + "px";
  }
  onDidChangeColor(e) {
    if (this.monitor && this.monitor.isMonitoring()) return;
    this.paint();
    const t = e.hsva;
    this.paintSelection(t.s, t.v);
  }
}
class az extends V {
  constructor(e, t, n = !1) {
    super(), this.model = t, this._onDidChange = new F(), this.onDidChange = this._onDidChange.event, this._onColorFlushed = new F(), this.onColorFlushed = this._onColorFlushed.event, n ? (this.domNode = Z(e, vo(".standalone-strip")), this.overlay = Z(this.domNode, vo(".standalone-overlay"))) : (this.domNode = Z(e, vo(".strip")), this.overlay = Z(this.domNode, vo(".overlay"))), this.slider = Z(this.domNode, vo(".slider")), this.slider.style.top = "0px", this._register(K(this.domNode, ie.POINTER_DOWN, (s) => this.onPointerDown(s))), this._register(t.onDidChangeColor(this.onDidChangeColor, this)), this.layout();
  }
  layout() {
    this.height = this.domNode.offsetHeight - this.slider.offsetHeight;
    const e = this.getValue(this.model.color);
    this.updateSliderPosition(e);
  }
  onDidChangeColor(e) {
    const t = this.getValue(e);
    this.updateSliderPosition(t);
  }
  onPointerDown(e) {
    if (!(e.target && e.target instanceof Element)) return;
    const t = this._register(new vf()), n = Ti(this.domNode);
    this.domNode.classList.add("grabbing"), e.target !== this.slider && this.onDidChangeTop(e.offsetY), t.startMonitoring(e.target, e.pointerId, e.buttons, (o) => this.onDidChangeTop(o.pageY - n.top), () => null);
    const s = K(e.target.ownerDocument, ie.POINTER_UP, () => {
      this._onColorFlushed.fire(), s.dispose(), t.stopMonitoring(!0), this.domNode.classList.remove("grabbing");
    }, !0);
  }
  onDidChangeTop(e) {
    const t = Math.max(0, Math.min(1, 1 - e / this.height));
    this.updateSliderPosition(t), this._onDidChange.fire(t);
  }
  updateSliderPosition(e) {
    this.slider.style.top = (1 - e) * this.height + "px";
  }
}
class Wre extends az {
  constructor(e, t, n = !1) {
    super(e, t, n), this.domNode.classList.add("opacity-strip"), this.onDidChangeColor(this.model.color);
  }
  onDidChangeColor(e) {
    super.onDidChangeColor(e);
    const { r: t, g: n, b: s } = e.rgba, o = new z(new ht(t, n, s, 1)), r = new z(new ht(t, n, s, 0));
    this.overlay.style.background = `linear-gradient(to bottom, ${o} 0%, ${r} 100%)`;
  }
  getValue(e) {
    return e.hsva.a;
  }
}
class Vre extends az {
  constructor(e, t, n = !1) {
    super(e, t, n), this.domNode.classList.add("hue-strip");
  }
  getValue(e) {
    return 1 - e.hsva.h / 360;
  }
}
class Hre extends V {
  constructor(e) {
    super(), this._onClicked = this._register(new F()), this.onClicked = this._onClicked.event, this._button = Z(e, document.createElement("button")), this._button.classList.add("insert-button"), this._button.textContent = "Insert", this._register(K(this._button, ie.CLICK, () => {
      this._onClicked.fire();
    }));
  }
  get button() {
    return this._button;
  }
}
class zre extends To {
  constructor(e, t, n, s, o = !1) {
    super(), this.model = t, this.pixelRatio = n, this._register(ev.getInstance(ke(e)).onDidChange(() => this.layout()));
    const r = vo(".colorpicker-widget");
    e.appendChild(r), this.header = this._register(new Pre(r, this.model, s, o)), this.body = this._register(new Fre(r, this.model, this.pixelRatio, o));
  }
  layout() {
    this.body.layout();
  }
}
var lz = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, dz = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class Ure {
  constructor(e, t, n, s) {
    this.owner = e, this.range = t, this.model = n, this.provider = s, this.forceShowAtRange = !0;
  }
  isValidForHoverAnchor(e) {
    return e.type === 1 && this.range.startColumn <= e.range.startColumn && this.range.endColumn >= e.range.endColumn;
  }
}
let gS = class {
  constructor(i, e) {
    this._editor = i, this._themeService = e, this.hoverOrdinal = 2;
  }
  computeSync(i, e) {
    return [];
  }
  computeAsync(i, e, t) {
    return Pi.fromPromise(this._computeAsync(i, e, t));
  }
  async _computeAsync(i, e, t) {
    if (!this._editor.hasModel()) return [];
    const n = Kh.get(this._editor);
    if (!n) return [];
    for (const s of e) {
      if (!n.isColorDecoration(s)) continue;
      const o = n.getColorData(s.range.getStartPosition());
      if (o)
        return [await hz(this, this._editor.getModel(), o.colorInfo, o.provider)];
    }
    return [];
  }
  renderHoverParts(i, e) {
    return cz(this, this._editor, this._themeService, e, i);
  }
};
gS = lz([dz(1, Yi)], gS);
class Kre {
  constructor(e, t, n, s) {
    this.owner = e, this.range = t, this.model = n, this.provider = s;
  }
}
let t1 = class {
  constructor(i, e) {
    this._editor = i, this._themeService = e, this._color = null;
  }
  async createColorHover(i, e, t) {
    if (!this._editor.hasModel() || !Kh.get(this._editor)) return null;
    const n = await sz(t, this._editor.getModel(), et.None);
    let s = null, o = null;
    for (const d of n) {
      const h = d.colorInfo;
      D.containsRange(h.range, i.range) && (s = h, o = d.provider);
    }
    const r = s ?? i, a = o ?? e, l = !!s;
    return { colorHover: await hz(this, this._editor.getModel(), r, a), foundInEditor: l };
  }
  async updateEditorModel(i) {
    if (!this._editor.hasModel()) return;
    const e = i.model;
    let t = new D(i.range.startLineNumber, i.range.startColumn, i.range.endLineNumber, i.range.endColumn);
    this._color && (await uw(this._editor.getModel(), e, this._color, t, i), t = uz(this._editor, t, e));
  }
  renderHoverParts(i, e) {
    return cz(this, this._editor, this._themeService, e, i);
  }
  set color(i) {
    this._color = i;
  }
  get color() {
    return this._color;
  }
};
async function hz(i, e, t, n) {
  const s = e.getValueInRange(t.range), { red: o, green: r, blue: a, alpha: l } = t.color, d = new ht(Math.round(255 * o), Math.round(255 * r), Math.round(255 * a), l), h = new z(d), c = await oz(e, t, n, et.None), u = new Are(h, [], 0);
  return u.colorPresentations = c || [], u.guessColorPresentation(h, s), i instanceof gS ? new Ure(i, D.lift(t.range), u, n) : new Kre(i, D.lift(t.range), u, n);
}
function cz(i, e, t, n, s) {
  if (n.length === 0 || !e.hasModel()) return V.None;
  if (s.setMinimumDimensions) {
    const u = e.getOption(67) + 8;
    s.setMinimumDimensions(new bt(302, u));
  }
  const o = new G(), r = n[0], a = e.getModel(), l = r.model, d = o.add(new zre(s.fragment, l, e.getOption(143), t, i instanceof t1));
  s.setColorPicker(d);
  let h = !1, c = new D(r.range.startLineNumber, r.range.startColumn, r.range.endLineNumber, r.range.endColumn);
  if (i instanceof t1) {
    const u = n[0].model.color;
    i.color = u, uw(a, l, u, c, r), o.add(l.onColorFlushed((g) => {
      i.color = g;
    }));
  } else o.add(l.onColorFlushed(async (u) => {
    await uw(a, l, u, c, r), h = !0, c = uz(e, c, l);
  }));
  return o.add(l.onDidChangeColor((u) => {
    uw(a, l, u, c, r);
  })), o.add(e.onDidChangeModelContent((u) => {
    h ? h = !1 : (s.hide(), e.focus());
  })), o;
}
function uz(i, e, t) {
  var n, s;
  const o = [], r = (n = t.presentation.textEdit) !== null && n !== void 0 ? n : { range: e, text: t.presentation.label, forceMoveMarkers: !1 };
  o.push(r), t.presentation.additionalTextEdits && o.push(...t.presentation.additionalTextEdits);
  const a = D.lift(r.range), l = i.getModel()._setTrackedRange(null, a, 3);
  return i.executeEdits("colorpicker", o), i.pushUndoStop(), (s = i.getModel()._getTrackedRange(l)) !== null && s !== void 0 ? s : a;
}
async function uw(i, e, t, n, s) {
  const o = await oz(i, { range: n, color: { red: t.rgba.r / 255, green: t.rgba.g / 255, blue: t.rgba.b / 255, alpha: t.rgba.a } }, s.provider, et.None);
  e.colorPresentations = o || [];
}
function fM(i, e) {
  return !!i[e];
}
t1 = lz([dz(1, Yi)], t1);
class Lx {
  constructor(e, t) {
    this.target = e.target, this.isLeftClick = e.event.leftButton, this.isMiddleClick = e.event.middleButton, this.isRightClick = e.event.rightButton, this.hasTriggerModifier = fM(e.event, t.triggerModifier), this.hasSideBySideModifier = fM(e.event, t.triggerSideBySideModifier), this.isNoneOrSingleMouseDown = e.event.detail <= 1;
  }
}
class y6 {
  constructor(e, t) {
    this.keyCodeIsTriggerKey = e.keyCode === t.triggerKey, this.keyCodeIsSideBySideKey = e.keyCode === t.triggerSideBySideKey, this.hasTriggerModifier = fM(e, t.triggerModifier);
  }
}
class Zb {
  constructor(e, t, n, s) {
    this.triggerKey = e, this.triggerModifier = t, this.triggerSideBySideKey = n, this.triggerSideBySideModifier = s;
  }
  equals(e) {
    return this.triggerKey === e.triggerKey && this.triggerModifier === e.triggerModifier && this.triggerSideBySideKey === e.triggerSideBySideKey && this.triggerSideBySideModifier === e.triggerSideBySideModifier;
  }
}
function S6(i) {
  return i === "altKey" ? Je ? new Zb(57, "metaKey", 6, "altKey") : new Zb(5, "ctrlKey", 6, "altKey") : Je ? new Zb(6, "altKey", 57, "metaKey") : new Zb(6, "altKey", 5, "ctrlKey");
}
class JL extends V {
  constructor(e, t) {
    var n;
    super(), this._onMouseMoveOrRelevantKeyDown = this._register(new F()), this.onMouseMoveOrRelevantKeyDown = this._onMouseMoveOrRelevantKeyDown.event, this._onExecute = this._register(new F()), this.onExecute = this._onExecute.event, this._onCancel = this._register(new F()), this.onCancel = this._onCancel.event, this._editor = e, this._extractLineNumberFromMouseEvent = (n = t == null ? void 0 : t.extractLineNumberFromMouseEvent) !== null && n !== void 0 ? n : (s) => s.target.position ? s.target.position.lineNumber : 0, this._opts = S6(this._editor.getOption(78)), this._lastMouseMoveEvent = null, this._hasTriggerKeyOnMouseDown = !1, this._lineNumberOnMouseDown = 0, this._register(this._editor.onDidChangeConfiguration((s) => {
      if (s.hasChanged(78)) {
        const o = S6(this._editor.getOption(78));
        if (this._opts.equals(o)) return;
        this._opts = o, this._lastMouseMoveEvent = null, this._hasTriggerKeyOnMouseDown = !1, this._lineNumberOnMouseDown = 0, this._onCancel.fire();
      }
    })), this._register(this._editor.onMouseMove((s) => this._onEditorMouseMove(new Lx(s, this._opts)))), this._register(this._editor.onMouseDown((s) => this._onEditorMouseDown(new Lx(s, this._opts)))), this._register(this._editor.onMouseUp((s) => this._onEditorMouseUp(new Lx(s, this._opts)))), this._register(this._editor.onKeyDown((s) => this._onEditorKeyDown(new y6(s, this._opts)))), this._register(this._editor.onKeyUp((s) => this._onEditorKeyUp(new y6(s, this._opts)))), this._register(this._editor.onMouseDrag(() => this._resetHandler())), this._register(this._editor.onDidChangeCursorSelection((s) => this._onDidChangeCursorSelection(s))), this._register(this._editor.onDidChangeModel((s) => this._resetHandler())), this._register(this._editor.onDidChangeModelContent(() => this._resetHandler())), this._register(this._editor.onDidScrollChange((s) => {
      (s.scrollTopChanged || s.scrollLeftChanged) && this._resetHandler();
    }));
  }
  _onDidChangeCursorSelection(e) {
    e.selection && e.selection.startColumn !== e.selection.endColumn && this._resetHandler();
  }
  _onEditorMouseMove(e) {
    this._lastMouseMoveEvent = e, this._onMouseMoveOrRelevantKeyDown.fire([e, null]);
  }
  _onEditorMouseDown(e) {
    this._hasTriggerKeyOnMouseDown = e.hasTriggerModifier, this._lineNumberOnMouseDown = this._extractLineNumberFromMouseEvent(e);
  }
  _onEditorMouseUp(e) {
    const t = this._extractLineNumberFromMouseEvent(e);
    this._hasTriggerKeyOnMouseDown && this._lineNumberOnMouseDown && this._lineNumberOnMouseDown === t && this._onExecute.fire(e);
  }
  _onEditorKeyDown(e) {
    this._lastMouseMoveEvent && (e.keyCodeIsTriggerKey || e.keyCodeIsSideBySideKey && e.hasTriggerModifier) ? this._onMouseMoveOrRelevantKeyDown.fire([this._lastMouseMoveEvent, e]) : e.hasTriggerModifier && this._onCancel.fire();
  }
  _onEditorKeyUp(e) {
    e.keyCodeIsTriggerKey && this._onCancel.fire();
  }
  _resetHandler() {
    this._lastMouseMoveEvent = null, this._hasTriggerKeyOnMouseDown = !1, this._onCancel.fire();
  }
}
var jre = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Rl = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let Tc = class extends pm {
  constructor(i, e, t, n, s, o, r, a, l, d, h, c, u) {
    super(i, { ...n.getRawOptions(), overflowWidgetsDomNode: n.getOverflowWidgetsDomNode() }, t, s, o, r, a, l, d, h, c, u), this._parentEditor = n, this._overwriteOptions = e, super.updateOptions(this._overwriteOptions), this._register(n.onDidChangeConfiguration((g) => this._onParentConfigurationChanged(g)));
  }
  getParentEditor() {
    return this._parentEditor;
  }
  _onParentConfigurationChanged(i) {
    super.updateOptions(this._parentEditor.getRawOptions()), super.updateOptions(this._overwriteOptions);
  }
  updateOptions(i) {
    OS(this._overwriteOptions, i, !0), super.updateOptions(this._overwriteOptions);
  }
};
Tc = jre([Rl(4, Se), Rl(5, mt), Rl(6, ai), Rl(7, Te), Rl(8, Yi), Rl(9, Ri), Rl(10, or), Rl(11, zt), Rl(12, fe)], Tc);
const L6 = new z(new ht(0, 122, 204)), qre = { showArrow: !0, showFrame: !0, className: "", frameColor: L6, arrowColor: L6, keepEditorSelection: !1 };
class $re {
  constructor(e, t, n, s, o, r, a, l) {
    this.id = "", this.domNode = e, this.afterLineNumber = t, this.afterColumn = n, this.heightInLines = s, this.showInHiddenAreas = a, this.ordinal = l, this._onDomNodeTop = o, this._onComputedHeight = r;
  }
  onDomNodeTop(e) {
    this._onDomNodeTop(e);
  }
  onComputedHeight(e) {
    this._onComputedHeight(e);
  }
}
class Gre {
  constructor(e, t) {
    this._id = e, this._domNode = t;
  }
  getId() {
    return this._id;
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return null;
  }
}
class ek {
  constructor(e) {
    this._editor = e, this._ruleName = ek._IdGenerator.nextId(), this._decorations = this._editor.createDecorationsCollection(), this._color = null, this._height = -1;
  }
  dispose() {
    this.hide(), ME(this._ruleName);
  }
  set color(e) {
    this._color !== e && (this._color = e, this._updateStyle());
  }
  set height(e) {
    this._height !== e && (this._height = e, this._updateStyle());
  }
  _updateStyle() {
    ME(this._ruleName), Gw(`.monaco-editor ${this._ruleName}`, `border-style: solid; border-color: transparent; border-bottom-color: ${this._color}; border-width: ${this._height}px; bottom: -${this._height}px !important; margin-left: -${this._height}px; `);
  }
  show(e) {
    e.column === 1 && (e = { lineNumber: e.lineNumber, column: 2 }), this._decorations.set([{ range: D.fromPositions(e), options: { description: "zone-widget-arrow", className: this._ruleName, stickiness: 1 } }]);
  }
  hide() {
    this._decorations.clear();
  }
}
ek._IdGenerator = new SA(".arrow-decoration-");
class Zre {
  constructor(e, t = {}) {
    this._arrow = null, this._overlayWidget = null, this._resizeSash = null, this._viewZone = null, this._disposables = new G(), this.container = null, this._isShowing = !1, this.editor = e, this._positionMarkerId = this.editor.createDecorationsCollection(), this.options = Ul(t), OS(this.options, qre, !1), this.domNode = document.createElement("div"), this.options.isAccessible || (this.domNode.setAttribute("aria-hidden", "true"), this.domNode.setAttribute("role", "presentation")), this._disposables.add(this.editor.onDidLayoutChange((n) => {
      const s = this._getWidth(n);
      this.domNode.style.width = s + "px", this.domNode.style.left = this._getLeft(n) + "px", this._onWidth(s);
    }));
  }
  dispose() {
    this._overlayWidget && (this.editor.removeOverlayWidget(this._overlayWidget), this._overlayWidget = null), this._viewZone && this.editor.changeViewZones((e) => {
      this._viewZone && e.removeZone(this._viewZone.id), this._viewZone = null;
    }), this._positionMarkerId.clear(), this._disposables.dispose();
  }
  create() {
    this.domNode.classList.add("zone-widget"), this.options.className && this.domNode.classList.add(this.options.className), this.container = document.createElement("div"), this.container.classList.add("zone-widget-container"), this.domNode.appendChild(this.container), this.options.showArrow && (this._arrow = new ek(this.editor), this._disposables.add(this._arrow)), this._fillContainer(this.container), this._initSash(), this._applyStyles();
  }
  style(e) {
    e.frameColor && (this.options.frameColor = e.frameColor), e.arrowColor && (this.options.arrowColor = e.arrowColor), this._applyStyles();
  }
  _applyStyles() {
    if (this.container && this.options.frameColor) {
      const e = this.options.frameColor.toString();
      this.container.style.borderTopColor = e, this.container.style.borderBottomColor = e;
    }
    if (this._arrow && this.options.arrowColor) {
      const e = this.options.arrowColor.toString();
      this._arrow.color = e;
    }
  }
  _getWidth(e) {
    return e.width - e.minimap.minimapWidth - e.verticalScrollbarWidth;
  }
  _getLeft(e) {
    return e.minimap.minimapWidth > 0 && e.minimap.minimapLeft === 0 ? e.minimap.minimapWidth : 0;
  }
  _onViewZoneTop(e) {
    this.domNode.style.top = e + "px";
  }
  _onViewZoneHeight(e) {
    var t;
    if (this.domNode.style.height = `${e}px`, this.container) {
      const n = e - this._decoratingElementsHeight();
      this.container.style.height = `${n}px`;
      const s = this.editor.getLayoutInfo();
      this._doLayout(n, this._getWidth(s));
    }
    (t = this._resizeSash) === null || t === void 0 || t.layout();
  }
  get position() {
    const e = this._positionMarkerId.getRange(0);
    if (e) return e.getStartPosition();
  }
  show(e, t) {
    const n = D.isIRange(e) ? D.lift(e) : D.fromPositions(e);
    this._isShowing = !0, this._showImpl(n, t), this._isShowing = !1, this._positionMarkerId.set([{ range: n, options: Ve.EMPTY }]);
  }
  hide() {
    var e;
    this._viewZone && (this.editor.changeViewZones((t) => {
      this._viewZone && t.removeZone(this._viewZone.id);
    }), this._viewZone = null), this._overlayWidget && (this.editor.removeOverlayWidget(this._overlayWidget), this._overlayWidget = null), (e = this._arrow) === null || e === void 0 || e.hide(), this._positionMarkerId.clear();
  }
  _decoratingElementsHeight() {
    const e = this.editor.getOption(67);
    let t = 0;
    return this.options.showArrow && (t += 2 * Math.round(e / 3)), this.options.showFrame && (t += 2 * Math.round(e / 9)), t;
  }
  _showImpl(e, t) {
    const n = e.getStartPosition(), s = this.editor.getLayoutInfo(), o = this._getWidth(s);
    this.domNode.style.width = `${o}px`, this.domNode.style.left = this._getLeft(s) + "px";
    const r = document.createElement("div");
    r.style.overflow = "hidden";
    const a = this.editor.getOption(67);
    if (!this.options.allowUnlimitedHeight) {
      const u = Math.max(12, this.editor.getLayoutInfo().height / a * 0.8);
      t = Math.min(t, u);
    }
    let l = 0, d = 0;
    if (this._arrow && this.options.showArrow && (l = Math.round(a / 3), this._arrow.height = l, this._arrow.show(n)), this.options.showFrame && (d = Math.round(a / 9)), this.editor.changeViewZones((u) => {
      this._viewZone && u.removeZone(this._viewZone.id), this._overlayWidget && (this.editor.removeOverlayWidget(this._overlayWidget), this._overlayWidget = null), this.domNode.style.top = "-1000px", this._viewZone = new $re(r, n.lineNumber, n.column, t, (g) => this._onViewZoneTop(g), (g) => this._onViewZoneHeight(g), this.options.showInHiddenAreas, this.options.ordinal), this._viewZone.id = u.addZone(this._viewZone), this._overlayWidget = new Gre("vs.editor.contrib.zoneWidget" + this._viewZone.id, this.domNode), this.editor.addOverlayWidget(this._overlayWidget);
    }), this.container && this.options.showFrame) {
      const u = this.options.frameWidth ? this.options.frameWidth : d;
      this.container.style.borderTopWidth = u + "px", this.container.style.borderBottomWidth = u + "px";
    }
    const h = t * a - this._decoratingElementsHeight();
    this.container && (this.container.style.top = l + "px", this.container.style.height = h + "px", this.container.style.overflow = "hidden"), this._doLayout(h, o), this.options.keepEditorSelection || this.editor.setSelection(e);
    const c = this.editor.getModel();
    if (c) {
      const u = c.validateRange(new D(e.startLineNumber, 1, e.endLineNumber + 1, 1));
      this.revealRange(u, u.startLineNumber === c.getLineCount());
    }
  }
  revealRange(e, t) {
    t ? this.editor.revealLineNearTop(e.endLineNumber, 0) : this.editor.revealRange(e, 0);
  }
  setCssClass(e, t) {
    this.container && (t && this.container.classList.remove(t), this.container.classList.add(e));
  }
  _onWidth(e) {
  }
  _doLayout(e, t) {
  }
  _relayout(e) {
    this._viewZone && this._viewZone.heightInLines !== e && this.editor.changeViewZones((t) => {
      this._viewZone && (this._viewZone.heightInLines = e, t.layoutZone(this._viewZone.id));
    });
  }
  _initSash() {
    if (this._resizeSash) return;
    let e;
    this._resizeSash = this._disposables.add(new Bn(this.domNode, this, { orientation: 1 })), this.options.isResizeable || (this._resizeSash.state = 0), this._disposables.add(this._resizeSash.onDidStart((t) => {
      this._viewZone && (e = { startY: t.startY, heightInLines: this._viewZone.heightInLines });
    })), this._disposables.add(this._resizeSash.onDidEnd(() => {
      e = void 0;
    })), this._disposables.add(this._resizeSash.onDidChange((t) => {
      if (e) {
        const n = (t.currentY - e.startY) / this.editor.getOption(67), s = n < 0 ? Math.ceil(n) : Math.floor(n), o = e.heightInLines + s;
        o > 5 && o < 35 && this._relayout(o);
      }
    }));
  }
  getHorizontalSashLeft() {
    return 0;
  }
  getHorizontalSashTop() {
    return (this.domNode.style.height === null ? 0 : parseInt(this.domNode.style.height)) - this._decoratingElementsHeight() / 2;
  }
  getHorizontalSashWidth() {
    const e = this.editor.getLayoutInfo();
    return e.width - e.minimap.minimapWidth;
  }
}
var gz = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, pz = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const mz = tt("IPeekViewService");
var As;
rt(mz, class {
  constructor() {
    this._widgets = /* @__PURE__ */ new Map();
  }
  addExclusiveWidget(i, e) {
    const t = this._widgets.get(i);
    t && (t.listener.dispose(), t.widget.dispose()), this._widgets.set(i, { widget: e, listener: e.onDidClose(() => {
      const n = this._widgets.get(i);
      n && n.widget === e && (n.listener.dispose(), this._widgets.delete(i));
    }) });
  }
}, 1), function(i) {
  i.inPeekEditor = new ae("inReferenceSearchEditor", !0, m(0, "Whether the current code editor is embedded inside peek")), i.notInPeekEditor = i.inPeekEditor.toNegated();
}(As || (As = {}));
let e_ = class {
  constructor(i, e) {
    i instanceof Tc && As.inPeekEditor.bindTo(e);
  }
  dispose() {
  }
};
e_.ID = "editor.contrib.referenceController", e_ = gz([pz(1, Te)], e_), ft(e_.ID, e_, 0);
const Yre = { headerBackgroundColor: z.white, primaryHeadingColor: z.fromHex("#333333"), secondaryHeadingColor: z.fromHex("#6c6c6cb3") };
let pS = class extends Zre {
  constructor(i, e, t) {
    super(i, e), this.instantiationService = t, this._onDidClose = new F(), this.onDidClose = this._onDidClose.event, OS(this.options, Yre, !1);
  }
  dispose() {
    this.disposed || (this.disposed = !0, super.dispose(), this._onDidClose.fire(this));
  }
  style(i) {
    const e = this.options;
    i.headerBackgroundColor && (e.headerBackgroundColor = i.headerBackgroundColor), i.primaryHeadingColor && (e.primaryHeadingColor = i.primaryHeadingColor), i.secondaryHeadingColor && (e.secondaryHeadingColor = i.secondaryHeadingColor), super.style(i);
  }
  _applyStyles() {
    super._applyStyles();
    const i = this.options;
    this._headElement && i.headerBackgroundColor && (this._headElement.style.backgroundColor = i.headerBackgroundColor.toString()), this._primaryHeading && i.primaryHeadingColor && (this._primaryHeading.style.color = i.primaryHeadingColor.toString()), this._secondaryHeading && i.secondaryHeadingColor && (this._secondaryHeading.style.color = i.secondaryHeadingColor.toString()), this._bodyElement && i.frameColor && (this._bodyElement.style.borderColor = i.frameColor.toString());
  }
  _fillContainer(i) {
    this.setCssClass("peekview-widget"), this._headElement = Q(".head"), this._bodyElement = Q(".body"), this._fillHead(this._headElement), this._fillBody(this._bodyElement), i.appendChild(this._headElement), i.appendChild(this._bodyElement);
  }
  _fillHead(i, e) {
    this._titleElement = Q(".peekview-title"), this.options.supportOnTitleClick && (this._titleElement.classList.add("clickable"), bi(this._titleElement, "click", (s) => this._onTitleClick(s))), Z(this._headElement, this._titleElement), this._fillTitleIcon(this._titleElement), this._primaryHeading = Q("span.filename"), this._secondaryHeading = Q("span.dirname"), this._metaHeading = Q("span.meta"), Z(this._titleElement, this._primaryHeading, this._secondaryHeading, this._metaHeading);
    const t = Q(".peekview-actions");
    Z(this._headElement, t);
    const n = this._getActionBarOptions();
    this._actionbarWidget = new sr(t, n), this._disposables.add(this._actionbarWidget), e || this._actionbarWidget.push(new Qs("peekview.close", m(0, "Close"), Ee.asClassName(ne.close), !0, () => (this.dispose(), Promise.resolve())), { label: !1, icon: !0 });
  }
  _fillTitleIcon(i) {
  }
  _getActionBarOptions() {
    return { actionViewItemProvider: eV.bind(void 0, this.instantiationService), orientation: 0 };
  }
  _onTitleClick(i) {
  }
  setTitle(i, e) {
    this._primaryHeading && this._secondaryHeading && (this._primaryHeading.innerText = i, this._primaryHeading.setAttribute("title", i), e ? this._secondaryHeading.innerText = e : Un(this._secondaryHeading));
  }
  setMetaTitle(i) {
    this._metaHeading && (i ? (this._metaHeading.innerText = i, bo(this._metaHeading)) : Ts(this._metaHeading));
  }
  _doLayout(i, e) {
    if (!this._isShowing && i < 0) return void this.dispose();
    const t = Math.ceil(1.2 * this.editor.getOption(67)), n = Math.round(i - (t + 2));
    this._doLayoutHead(t, e), this._doLayoutBody(n, e);
  }
  _doLayoutHead(i, e) {
    this._headElement && (this._headElement.style.height = `${i}px`, this._headElement.style.lineHeight = this._headElement.style.height);
  }
  _doLayoutBody(i, e) {
    this._bodyElement && (this._bodyElement.style.height = `${i}px`);
  }
};
pS = gz([pz(2, Se)], pS);
const Xre = I("peekViewTitle.background", { dark: "#252526", light: "#F3F3F3", hcDark: z.black, hcLight: z.white }, m(0, "Background color of the peek view title area.")), fz = I("peekViewTitleLabel.foreground", { dark: z.white, light: z.black, hcDark: z.white, hcLight: Go }, m(0, "Color of the peek view title.")), _z = I("peekViewTitleDescription.foreground", { dark: "#ccccccb3", light: "#616161", hcDark: "#FFFFFF99", hcLight: "#292929" }, m(0, "Color of the peek view title info.")), Qre = I("peekView.border", { dark: Rs, light: Rs, hcDark: ot, hcLight: ot }, m(0, "Color of the peek view borders and arrow.")), Jre = I("peekViewResult.background", { dark: "#252526", light: "#F3F3F3", hcDark: z.black, hcLight: z.white }, m(0, "Background color of the peek view result list."));
I("peekViewResult.lineForeground", { dark: "#bbbbbb", light: "#646465", hcDark: z.white, hcLight: Go }, m(0, "Foreground color for line nodes in the peek view result list.")), I("peekViewResult.fileForeground", { dark: z.white, light: "#1E1E1E", hcDark: z.white, hcLight: Go }, m(0, "Foreground color for file nodes in the peek view result list.")), I("peekViewResult.selectionBackground", { dark: "#3399ff33", light: "#3399ff33", hcDark: null, hcLight: null }, m(0, "Background color of the selected entry in the peek view result list.")), I("peekViewResult.selectionForeground", { dark: z.white, light: "#6C6C6C", hcDark: z.white, hcLight: Go }, m(0, "Foreground color of the selected entry in the peek view result list."));
const Xd = I("peekViewEditor.background", { dark: "#001F33", light: "#F2F8FC", hcDark: z.black, hcLight: z.white }, m(0, "Background color of the peek view editor."));
I("peekViewEditorGutter.background", { dark: Xd, light: Xd, hcDark: Xd, hcLight: Xd }, m(0, "Background color of the gutter in the peek view editor.")), I("peekViewEditorStickyScroll.background", { dark: Xd, light: Xd, hcDark: Xd, hcLight: Xd }, m(0, "Background color of sticky scroll in the peek view editor.")), I("peekViewResult.matchHighlightBackground", { dark: "#ea5c004d", light: "#ea5c004d", hcDark: null, hcLight: null }, m(0, "Match highlight color in the peek view result list.")), I("peekViewEditor.matchHighlightBackground", { dark: "#ff8f0099", light: "#f5d802de", hcDark: null, hcLight: null }, m(0, "Match highlight color in the peek view editor.")), I("peekViewEditor.matchHighlightBorder", { dark: null, light: null, hcDark: Zt, hcLight: Zt }, m(0, "Match highlight border in the peek view editor."));
class ac {
  constructor(e, t, n, s) {
    this.isProviderFirst = e, this.parent = t, this.link = n, this._rangeCallback = s, this.id = RI.nextId();
  }
  get uri() {
    return this.link.uri;
  }
  get range() {
    var e, t;
    return (t = (e = this._range) !== null && e !== void 0 ? e : this.link.targetSelectionRange) !== null && t !== void 0 ? t : this.link.range;
  }
  set range(e) {
    this._range = e, this._rangeCallback(this);
  }
  get ariaMessage() {
    var e;
    const t = (e = this.parent.getPreview(this)) === null || e === void 0 ? void 0 : e.preview(this.range);
    return t ? m(0, "{0} in {1} on line {2} at column {3}", t.value, ir(this.uri), this.range.startLineNumber, this.range.startColumn) : m(0, "in {0} on line {1} at column {2}", ir(this.uri), this.range.startLineNumber, this.range.startColumn);
  }
}
class eae {
  constructor(e) {
    this._modelReference = e;
  }
  dispose() {
    this._modelReference.dispose();
  }
  preview(e, t = 8) {
    const n = this._modelReference.object.textEditorModel;
    if (!n) return;
    const { startLineNumber: s, startColumn: o, endLineNumber: r, endColumn: a } = e, l = n.getWordUntilPosition({ lineNumber: s, column: o - t }), d = new D(s, l.startColumn, s, o), h = new D(r, a, r, 1073741824), c = n.getValueInRange(d).replace(/^\s+/, ""), u = n.getValueInRange(e);
    return { value: c + u + n.getValueInRange(h).replace(/\s+$/, ""), highlight: { start: c.length, end: c.length + u.length } };
  }
}
class i1 {
  constructor(e, t) {
    this.parent = e, this.uri = t, this.children = [], this._previews = new Di();
  }
  dispose() {
    Ht(this._previews.values()), this._previews.clear();
  }
  getPreview(e) {
    return this._previews.get(e.uri);
  }
  get ariaMessage() {
    const e = this.children.length;
    return e === 1 ? m(0, "1 symbol in {0}, full path {1}", ir(this.uri), this.uri.fsPath) : m(0, "{0} symbols in {1}, full path {2}", e, ir(this.uri), this.uri.fsPath);
  }
  async resolve(e) {
    if (this._previews.size !== 0) return this;
    for (const t of this.children) if (!this._previews.has(t.uri)) try {
      const n = await e.createModelReference(t.uri);
      this._previews.set(t.uri, new eae(n));
    } catch (n) {
      We(n);
    }
    return this;
  }
}
class Js {
  constructor(e, t) {
    this.groups = [], this.references = [], this._onDidChangeReferenceRange = new F(), this.onDidChangeReferenceRange = this._onDidChangeReferenceRange.event, this._links = e, this._title = t;
    const [n] = e;
    let s;
    e.sort(Js._compareReferences);
    for (const o of e) if (s && Yt.isEqual(s.uri, o.uri, !0) || (s = new i1(this, o.uri), this.groups.push(s)), s.children.length === 0 || Js._compareReferences(o, s.children[s.children.length - 1]) !== 0) {
      const r = new ac(n === o, s, o, (a) => this._onDidChangeReferenceRange.fire(a));
      this.references.push(r), s.children.push(r);
    }
  }
  dispose() {
    Ht(this.groups), this._onDidChangeReferenceRange.dispose(), this.groups.length = 0;
  }
  clone() {
    return new Js(this._links, this._title);
  }
  get title() {
    return this._title;
  }
  get isEmpty() {
    return this.groups.length === 0;
  }
  get ariaMessage() {
    return this.isEmpty ? m(0, "No results found") : this.references.length === 1 ? m(0, "Found 1 symbol in {0}", this.references[0].uri.fsPath) : this.groups.length === 1 ? m(0, "Found {0} symbols in {1}", this.references.length, this.groups[0].uri.fsPath) : m(0, "Found {0} symbols in {1} files", this.references.length, this.groups.length);
  }
  nextOrPreviousReference(e, t) {
    const { parent: n } = e;
    let s = n.children.indexOf(e);
    const o = n.children.length, r = n.parent.groups.length;
    return r === 1 || t && s + 1 < o || !t && s > 0 ? (s = t ? (s + 1) % o : (s + o - 1) % o, n.children[s]) : (s = n.parent.groups.indexOf(n), t ? (s = (s + 1) % r, n.parent.groups[s].children[0]) : (s = (s + r - 1) % r, n.parent.groups[s].children[n.parent.groups[s].children.length - 1]));
  }
  nearestReference(e, t) {
    const n = this.references.map((s, o) => ({ idx: o, prefixLen: fc(s.uri.toString(), e.toString()), offsetDist: 100 * Math.abs(s.range.startLineNumber - t.lineNumber) + Math.abs(s.range.startColumn - t.column) })).sort((s, o) => s.prefixLen > o.prefixLen ? -1 : s.prefixLen < o.prefixLen ? 1 : s.offsetDist < o.offsetDist ? -1 : s.offsetDist > o.offsetDist ? 1 : 0)[0];
    if (n) return this.references[n.idx];
  }
  referenceAt(e, t) {
    for (const n of this.references) if (n.uri.toString() === e.toString() && D.containsPosition(n.range, t)) return n;
  }
  firstReference() {
    for (const e of this.references) if (e.isProviderFirst) return e;
    return this.references[0];
  }
  static _compareReferences(e, t) {
    return Yt.compare(e.uri, t.uri) || D.compareRangesUsingStarts(e.range, t.range);
  }
}
var _M, tk = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, ik = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let vM = class {
  constructor(i) {
    this._resolverService = i;
  }
  hasChildren(i) {
    return i instanceof Js || i instanceof i1;
  }
  getChildren(i) {
    if (i instanceof Js) return i.groups;
    if (i instanceof i1) return i.resolve(this._resolverService).then((e) => e.children);
    throw new Error("bad tree");
  }
};
vM = tk([ik(0, Ps)], vM);
class tae {
  getHeight() {
    return 23;
  }
  getTemplateId(e) {
    return e instanceof i1 ? x0.id : U1.id;
  }
}
let bM = class {
  constructor(i) {
    this._keybindingService = i;
  }
  getKeyboardNavigationLabel(i) {
    var e;
    if (i instanceof ac) {
      const t = (e = i.parent.getPreview(i)) === null || e === void 0 ? void 0 : e.preview(i.range);
      if (t) return t.value;
    }
    return ir(i.uri);
  }
};
bM = tk([ik(0, Dt)], bM);
class iae {
  getId(e) {
    return e instanceof ac ? e.id : e.uri;
  }
}
let CM = class extends V {
  constructor(i, e) {
    super(), this._labelService = e;
    const t = document.createElement("div");
    t.classList.add("reference-file"), this.file = this._register(new Jy(t, { supportHighlights: !0 })), this.badge = new b2(Z(t, Q(".count")), {}, QW), i.appendChild(t);
  }
  set(i, e) {
    const t = pL(i.uri);
    this.file.setLabel(this._labelService.getUriBasenameLabel(i.uri), this._labelService.getUriLabel(t, { relative: !0 }), { title: this._labelService.getUriLabel(i.uri), matches: e });
    const n = i.children.length;
    this.badge.setCount(n), n > 1 ? this.badge.setTitleFormat(m(0, "{0} references", n)) : this.badge.setTitleFormat(m(0, "{0} reference", n));
  }
};
CM = tk([ik(1, Zm)], CM);
let x0 = _M = class {
  constructor(i) {
    this._instantiationService = i, this.templateId = _M.id;
  }
  renderTemplate(i) {
    return this._instantiationService.createInstance(CM, i);
  }
  renderElement(i, e, t) {
    t.set(i.element, T1(i.filterData));
  }
  disposeTemplate(i) {
    i.dispose();
  }
};
x0.id = "FileReferencesRenderer", x0 = _M = tk([ik(0, Se)], x0);
class nae extends V {
  constructor(e) {
    super(), this.label = this._register(new oc(e));
  }
  set(e, t) {
    var n;
    const s = (n = e.parent.getPreview(e)) === null || n === void 0 ? void 0 : n.preview(e.range);
    if (s && s.value) {
      const { value: o, highlight: r } = s;
      t && !da.isDefault(t) ? (this.label.element.classList.toggle("referenceMatch", !1), this.label.set(o, T1(t))) : (this.label.element.classList.toggle("referenceMatch", !0), this.label.set(o, [r]));
    } else this.label.set(`${ir(e.uri)}:${e.range.startLineNumber + 1}:${e.range.startColumn + 1}`);
  }
}
class U1 {
  constructor() {
    this.templateId = U1.id;
  }
  renderTemplate(e) {
    return new nae(e);
  }
  renderElement(e, t, n) {
    n.set(e.element, e.filterData);
  }
  disposeTemplate(e) {
    e.dispose();
  }
}
U1.id = "OneReferenceRenderer";
class sae {
  getWidgetAriaLabel() {
    return m(0, "References");
  }
  getAriaLabel(e) {
    return e.ariaMessage;
  }
}
var oae = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Al = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class nk {
  constructor(e, t) {
    this._editor = e, this._model = t, this._decorations = /* @__PURE__ */ new Map(), this._decorationIgnoreSet = /* @__PURE__ */ new Set(), this._callOnDispose = new G(), this._callOnModelChange = new G(), this._callOnDispose.add(this._editor.onDidChangeModel(() => this._onModelChanged())), this._onModelChanged();
  }
  dispose() {
    this._callOnModelChange.dispose(), this._callOnDispose.dispose(), this.removeDecorations();
  }
  _onModelChanged() {
    this._callOnModelChange.clear();
    const e = this._editor.getModel();
    if (e) {
      for (const t of this._model.references) if (t.uri.toString() === e.uri.toString()) return void this._addDecorations(t.parent);
    }
  }
  _addDecorations(e) {
    if (!this._editor.hasModel()) return;
    this._callOnModelChange.add(this._editor.getModel().onDidChangeDecorations(() => this._onDecorationChanged()));
    const t = [], n = [];
    for (let s = 0, o = e.children.length; s < o; s++) {
      const r = e.children[s];
      this._decorationIgnoreSet.has(r.id) || r.uri.toString() === this._editor.getModel().uri.toString() && (t.push({ range: r.range, options: nk.DecorationOptions }), n.push(s));
    }
    this._editor.changeDecorations((s) => {
      const o = s.deltaDecorations([], t);
      for (let r = 0; r < o.length; r++) this._decorations.set(o[r], e.children[n[r]]);
    });
  }
  _onDecorationChanged() {
    const e = [], t = this._editor.getModel();
    if (t) {
      for (const [n, s] of this._decorations) {
        const o = t.getDecorationRange(n);
        if (!o) continue;
        let r = !1;
        D.equalsRange(o, s.range) || ((D.spansMultipleLines(o) || s.range.endColumn - s.range.startColumn !== o.endColumn - o.startColumn) && (r = !0), r ? (this._decorationIgnoreSet.add(s.id), e.push(n)) : s.range = o);
      }
      for (let n = 0, s = e.length; n < s; n++) this._decorations.delete(e[n]);
      this._editor.removeDecorations(e);
    }
  }
  removeDecorations() {
    this._editor.removeDecorations([...this._decorations.keys()]), this._decorations.clear();
  }
}
nk.DecorationOptions = Ve.register({ description: "reference-decoration", stickiness: 1, className: "reference-decoration" });
class rae {
  constructor() {
    this.ratio = 0.7, this.heightInLines = 18;
  }
  static fromJSON(e) {
    let t, n;
    try {
      const s = JSON.parse(e);
      t = s.ratio, n = s.heightInLines;
    } catch {
    }
    return { ratio: t || 0.7, heightInLines: n || 18 };
  }
}
class aae extends m2 {
}
let wM = class extends pS {
  constructor(i, e, t, n, s, o, r, a, l, d, h, c) {
    super(i, { showFrame: !1, showArrow: !0, isResizeable: !0, isAccessible: !0, supportOnTitleClick: !0 }, o), this._defaultTreeKeyboardSupport = e, this.layoutData = t, this._textModelResolverService = s, this._instantiationService = o, this._peekViewService = r, this._uriLabel = a, this._undoRedoService = l, this._keybindingService = d, this._languageService = h, this._languageConfigurationService = c, this._disposeOnNewModel = new G(), this._callOnDispose = new G(), this._onDidSelectReference = new F(), this.onDidSelectReference = this._onDidSelectReference.event, this._dim = new bt(0, 0), this._applyTheme(n.getColorTheme()), this._callOnDispose.add(n.onDidColorThemeChange(this._applyTheme.bind(this))), this._peekViewService.addExclusiveWidget(i, this), this.create();
  }
  dispose() {
    this.setModel(void 0), this._callOnDispose.dispose(), this._disposeOnNewModel.dispose(), Ht(this._preview), Ht(this._previewNotAvailableMessage), Ht(this._tree), Ht(this._previewModelReference), this._splitView.dispose(), super.dispose();
  }
  _applyTheme(i) {
    const e = i.getColor(Qre) || z.transparent;
    this.style({ arrowColor: e, frameColor: e, headerBackgroundColor: i.getColor(Xre) || z.transparent, primaryHeadingColor: i.getColor(fz), secondaryHeadingColor: i.getColor(_z) });
  }
  show(i) {
    super.show(i, this.layoutData.heightInLines || 18);
  }
  focusOnReferenceTree() {
    this._tree.domFocus();
  }
  focusOnPreviewEditor() {
    this._preview.focus();
  }
  isPreviewEditorFocused() {
    return this._preview.hasTextFocus();
  }
  _onTitleClick(i) {
    this._preview && this._preview.getModel() && this._onDidSelectReference.fire({ element: this._getFocusedReference(), kind: i.ctrlKey || i.metaKey || i.altKey ? "side" : "open", source: "title" });
  }
  _fillBody(i) {
    this.setCssClass("reference-zone-widget"), this._messageContainer = Z(i, Q("div.messages")), Ts(this._messageContainer), this._splitView = new sV(i, { orientation: 1 }), this._previewContainer = Z(i, Q("div.preview.inline")), this._preview = this._instantiationService.createInstance(Tc, this._previewContainer, { scrollBeyondLastLine: !1, scrollbar: { verticalScrollbarSize: 14, horizontal: "auto", useShadows: !0, verticalHasArrows: !1, horizontalHasArrows: !1, alwaysConsumeMouseWheel: !0 }, overviewRulerLanes: 2, fixedOverflowWidgets: !0, minimap: { enabled: !1 } }, {}, this.editor), Ts(this._previewContainer), this._previewNotAvailableMessage = new Oa(m(0, "no preview available"), ko, Oa.DEFAULT_CREATION_OPTIONS, null, this._undoRedoService, this._languageService, this._languageConfigurationService), this._treeContainer = Z(i, Q("div.ref-tree.inline"));
    const e = { keyboardSupport: this._defaultTreeKeyboardSupport, accessibilityProvider: new sae(), keyboardNavigationLabelProvider: this._instantiationService.createInstance(bM), identityProvider: new iae(), openOnSingleClick: !0, selectionNavigation: !0, overrideStyles: { listBackground: Jre } };
    this._defaultTreeKeyboardSupport && this._callOnDispose.add(bi(this._treeContainer, "keydown", (n) => {
      n.equals(9) && (this._keybindingService.dispatchEvent(n, n.target), n.stopPropagation());
    }, !0)), this._tree = this._instantiationService.createInstance(aae, "ReferencesWidget", this._treeContainer, new tae(), [this._instantiationService.createInstance(x0), this._instantiationService.createInstance(U1)], this._instantiationService.createInstance(vM), e), this._splitView.addView({ onDidChange: se.None, element: this._previewContainer, minimumSize: 200, maximumSize: Number.MAX_VALUE, layout: (n) => {
      this._preview.layout({ height: this._dim.height, width: n });
    } }, $y.Distribute), this._splitView.addView({ onDidChange: se.None, element: this._treeContainer, minimumSize: 100, maximumSize: Number.MAX_VALUE, layout: (n) => {
      this._treeContainer.style.height = `${this._dim.height}px`, this._treeContainer.style.width = `${n}px`, this._tree.layout(this._dim.height, n);
    } }, $y.Distribute), this._disposables.add(this._splitView.onDidSashChange(() => {
      this._dim.width && (this.layoutData.ratio = this._splitView.getViewSize(0) / this._dim.width);
    }, void 0));
    const t = (n, s) => {
      n instanceof ac && (s === "show" && this._revealReference(n, !1), this._onDidSelectReference.fire({ element: n, kind: s, source: "tree" }));
    };
    this._tree.onDidOpen((n) => {
      n.sideBySide ? t(n.element, "side") : n.editorOptions.pinned ? t(n.element, "goto") : t(n.element, "show");
    }), Ts(this._treeContainer);
  }
  _onWidth(i) {
    this._dim && this._doLayoutBody(this._dim.height, i);
  }
  _doLayoutBody(i, e) {
    super._doLayoutBody(i, e), this._dim = new bt(e, i), this.layoutData.heightInLines = this._viewZone ? this._viewZone.heightInLines : this.layoutData.heightInLines, this._splitView.layout(e), this._splitView.resizeView(0, e * this.layoutData.ratio);
  }
  setSelection(i) {
    return this._revealReference(i, !0).then(() => {
      this._model && (this._tree.setSelection([i]), this._tree.setFocus([i]));
    });
  }
  setModel(i) {
    return this._disposeOnNewModel.clear(), this._model = i, this._model ? this._onNewModel() : Promise.resolve();
  }
  _onNewModel() {
    return this._model ? this._model.isEmpty ? (this.setTitle(""), this._messageContainer.innerText = m(0, "No results"), bo(this._messageContainer), Promise.resolve(void 0)) : (Ts(this._messageContainer), this._decorationsManager = new nk(this._preview, this._model), this._disposeOnNewModel.add(this._decorationsManager), this._disposeOnNewModel.add(this._model.onDidChangeReferenceRange((i) => this._tree.rerender(i))), this._disposeOnNewModel.add(this._preview.onMouseDown((i) => {
      const { event: e, target: t } = i;
      if (e.detail !== 2) return;
      const n = this._getFocusedReference();
      n && this._onDidSelectReference.fire({ element: { uri: n.uri, range: t.range }, kind: e.ctrlKey || e.metaKey || e.altKey ? "side" : "open", source: "editor" });
    })), this.container.classList.add("results-loaded"), bo(this._treeContainer), bo(this._previewContainer), this._splitView.layout(this._dim.width), this.focusOnReferenceTree(), this._tree.setInput(this._model.groups.length === 1 ? this._model.groups[0] : this._model)) : Promise.resolve(void 0);
  }
  _getFocusedReference() {
    const [i] = this._tree.getFocus();
    return i instanceof ac ? i : i instanceof i1 && i.children.length > 0 ? i.children[0] : void 0;
  }
  async revealReference(i) {
    await this._revealReference(i, !1), this._onDidSelectReference.fire({ element: i, kind: "goto", source: "tree" });
  }
  async _revealReference(i, e) {
    if (this._revealedReference === i) return;
    this._revealedReference = i, i.uri.scheme !== Ue.inMemory ? this.setTitle(SX(i.uri), this._uriLabel.getUriLabel(pL(i.uri))) : this.setTitle(m(0, "References"));
    const t = this._textModelResolverService.createModelReference(i.uri);
    this._tree.getInput() === i.parent || (e && this._tree.reveal(i.parent), await this._tree.expand(i.parent)), this._tree.reveal(i);
    const n = await t;
    if (!this._model) return void n.dispose();
    Ht(this._previewModelReference);
    const s = n.object;
    if (s) {
      const o = this._preview.getModel() === s.textEditorModel ? 0 : 1, r = D.lift(i.range).collapseToStart();
      this._previewModelReference = n, this._preview.setModel(s.textEditorModel), this._preview.setSelection(r), this._preview.revealRangeInCenter(r, o);
    } else this._preview.setModel(this._previewNotAvailableMessage), n.dispose();
  }
};
wM = oae([Al(3, Yi), Al(4, Ps), Al(5, Se), Al(6, mz), Al(7, Zm), Al(8, mL), Al(9, Dt), Al(10, Xt), Al(11, zt)], wM);
var gw, lae = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, ip = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const hu = new ae("referenceSearchVisible", !1, m(0, "Whether reference peek is visible, like 'Peek References' or 'Peek Definition'"));
let lc = gw = class {
  static get(i) {
    return i.getContribution(gw.ID);
  }
  constructor(i, e, t, n, s, o, r, a) {
    this._defaultTreeKeyboardSupport = i, this._editor = e, this._editorService = n, this._notificationService = s, this._instantiationService = o, this._storageService = r, this._configurationService = a, this._disposables = new G(), this._requestIdPool = 0, this._ignoreModelChangeEvent = !1, this._referenceSearchVisible = hu.bindTo(t);
  }
  dispose() {
    var i, e;
    this._referenceSearchVisible.reset(), this._disposables.dispose(), (i = this._widget) === null || i === void 0 || i.dispose(), (e = this._model) === null || e === void 0 || e.dispose(), this._widget = void 0, this._model = void 0;
  }
  toggleWidget(i, e, t) {
    let n;
    if (this._widget && (n = this._widget.position), this.closeWidget(), n && i.containsPosition(n)) return;
    this._peekMode = t, this._referenceSearchVisible.set(!0), this._disposables.add(this._editor.onDidChangeModelLanguage(() => {
      this.closeWidget();
    })), this._disposables.add(this._editor.onDidChangeModel(() => {
      this._ignoreModelChangeEvent || this.closeWidget();
    }));
    const s = "peekViewLayout", o = rae.fromJSON(this._storageService.get(s, 0, "{}"));
    this._widget = this._instantiationService.createInstance(wM, this._editor, this._defaultTreeKeyboardSupport, o), this._widget.setTitle(m(0, "Loading...")), this._widget.show(i), this._disposables.add(this._widget.onDidClose(() => {
      e.cancel(), this._widget && (this._storageService.store(s, JSON.stringify(this._widget.layoutData), 0, 1), this._widget = void 0), this.closeWidget();
    })), this._disposables.add(this._widget.onDidSelectReference((a) => {
      const { element: l, kind: d } = a;
      if (l) switch (d) {
        case "open":
          a.source === "editor" && this._configurationService.getValue("editor.stablePeek") || this.openReference(l, !1, !1);
          break;
        case "side":
          this.openReference(l, !0, !1);
          break;
        case "goto":
          t ? this._gotoReference(l, !0) : this.openReference(l, !1, !0);
      }
    }));
    const r = ++this._requestIdPool;
    e.then((a) => {
      var l;
      if (r === this._requestIdPool && this._widget) return (l = this._model) === null || l === void 0 || l.dispose(), this._model = a, this._widget.setModel(this._model).then(() => {
        if (this._widget && this._model && this._editor.hasModel()) {
          this._model.isEmpty ? this._widget.setMetaTitle("") : this._widget.setMetaTitle(m(0, "{0} ({1})", this._model.title, this._model.references.length));
          const d = this._editor.getModel().uri, h = new W(i.startLineNumber, i.startColumn), c = this._model.nearestReference(d, h);
          if (c) return this._widget.setSelection(c).then(() => {
            this._widget && this._editor.getOption(87) === "editor" && this._widget.focusOnPreviewEditor();
          });
        }
      });
      a.dispose();
    }, (a) => {
      this._notificationService.error(a);
    });
  }
  changeFocusBetweenPreviewAndReferences() {
    this._widget && (this._widget.isPreviewEditorFocused() ? this._widget.focusOnReferenceTree() : this._widget.focusOnPreviewEditor());
  }
  async goToNextOrPreviousReference(i) {
    if (!this._editor.hasModel() || !this._model || !this._widget) return;
    const e = this._widget.position;
    if (!e) return;
    const t = this._model.nearestReference(this._editor.getModel().uri, e);
    if (!t) return;
    const n = this._model.nextOrPreviousReference(t, i), s = this._editor.hasTextFocus(), o = this._widget.isPreviewEditorFocused();
    await this._widget.setSelection(n), await this._gotoReference(n, !1), s ? this._editor.focus() : this._widget && o && this._widget.focusOnPreviewEditor();
  }
  async revealReference(i) {
    this._editor.hasModel() && this._model && this._widget && await this._widget.revealReference(i);
  }
  closeWidget(i = !0) {
    var e, t;
    (e = this._widget) === null || e === void 0 || e.dispose(), (t = this._model) === null || t === void 0 || t.dispose(), this._referenceSearchVisible.reset(), this._disposables.clear(), this._widget = void 0, this._model = void 0, i && this._editor.focus(), this._requestIdPool += 1;
  }
  _gotoReference(i, e) {
    var t;
    (t = this._widget) === null || t === void 0 || t.hide(), this._ignoreModelChangeEvent = !0;
    const n = D.lift(i.range).collapseToStart();
    return this._editorService.openCodeEditor({ resource: i.uri, options: { selection: n, selectionSource: "code.jump", pinned: e } }, this._editor).then((s) => {
      var o;
      if (this._ignoreModelChangeEvent = !1, s && this._widget) if (this._editor === s) this._widget.show(n), this._widget.focusOnReferenceTree();
      else {
        const r = gw.get(s), a = this._model.clone();
        this.closeWidget(), s.focus(), r == null || r.toggleWidget(n, on((l) => Promise.resolve(a)), (o = this._peekMode) !== null && o !== void 0 && o);
      }
      else this.closeWidget();
    }, (s) => {
      this._ignoreModelChangeEvent = !1, We(s);
    });
  }
  openReference(i, e, t) {
    e || this.closeWidget();
    const { uri: n, range: s } = i;
    this._editorService.openCodeEditor({ resource: n, options: { selection: s, selectionSource: "code.jump", pinned: t } }, this._editor, e);
  }
};
function Qc(i, e) {
  const t = function(s) {
    const o = s.get(mt).getFocusedCodeEditor();
    return o instanceof Tc ? o.getParentEditor() : o;
  }(i);
  if (!t) return;
  const n = lc.get(t);
  n && e(n);
}
lc.ID = "editor.contrib.referencesController", lc = gw = lae([ip(2, Te), ip(3, mt), ip(4, Ri), ip(5, Se), ip(6, Nr), ip(7, Ye)], lc), Es.registerCommandAndKeybindingRule({ id: "togglePeekWidgetFocus", weight: 100, primary: Vi(2089, 60), when: q.or(hu, As.inPeekEditor), handler(i) {
  Qc(i, (e) => {
    e.changeFocusBetweenPreviewAndReferences();
  });
} }), Es.registerCommandAndKeybindingRule({ id: "goToNextReference", weight: 90, primary: 62, secondary: [70], when: q.or(hu, As.inPeekEditor), handler(i) {
  Qc(i, (e) => {
    e.goToNextOrPreviousReference(!0);
  });
} }), Es.registerCommandAndKeybindingRule({ id: "goToPreviousReference", weight: 90, primary: 1086, secondary: [1094], when: q.or(hu, As.inPeekEditor), handler(i) {
  Qc(i, (e) => {
    e.goToNextOrPreviousReference(!1);
  });
} }), dt.registerCommandAlias("goToNextReferenceFromEmbeddedEditor", "goToNextReference"), dt.registerCommandAlias("goToPreviousReferenceFromEmbeddedEditor", "goToPreviousReference"), dt.registerCommandAlias("closeReferenceSearchEditor", "closeReferenceSearch"), dt.registerCommand("closeReferenceSearch", (i) => Qc(i, (e) => e.closeWidget())), Es.registerKeybindingRule({ id: "closeReferenceSearch", weight: -1, primary: 9, secondary: [1033], when: q.and(As.inPeekEditor, q.not("config.editor.stablePeek")) }), Es.registerKeybindingRule({ id: "closeReferenceSearch", weight: 250, primary: 9, secondary: [1033], when: q.and(hu, q.not("config.editor.stablePeek"), q.or(E.editorTextFocus, gie.negate())) }), Es.registerCommandAndKeybindingRule({ id: "revealReference", weight: 200, primary: 3, mac: { primary: 3, secondary: [2066] }, when: q.and(hu, tF, u2.negate(), g2.negate()), handler(i) {
  var e;
  const t = (e = i.get(Jo).lastFocusedList) === null || e === void 0 ? void 0 : e.getFocus();
  Array.isArray(t) && t[0] instanceof ac && Qc(i, (n) => n.revealReference(t[0]));
} }), Es.registerCommandAndKeybindingRule({ id: "openReferenceToSide", weight: 100, primary: 2051, mac: { primary: 259 }, when: q.and(hu, tF, u2.negate(), g2.negate()), handler(i) {
  var e;
  const t = (e = i.get(Jo).lastFocusedList) === null || e === void 0 ? void 0 : e.getFocus();
  Array.isArray(t) && t[0] instanceof ac && Qc(i, (n) => n.openReference(t[0], !0, !0));
} }), dt.registerCommand("openReference", (i) => {
  var e;
  const t = (e = i.get(Jo).lastFocusedList) === null || e === void 0 ? void 0 : e.getFocus();
  Array.isArray(t) && t[0] instanceof ac && Qc(i, (n) => n.openReference(t[0], !1, !0));
});
var vz = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, F_ = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const yM = new ae("hasSymbols", !1, m(0, "Whether there are symbol locations that can be navigated via keyboard-only.")), pw = tt("ISymbolNavigationService");
let kx = class {
  constructor(i, e, t, n) {
    this._editorService = e, this._notificationService = t, this._keybindingService = n, this._currentModel = void 0, this._currentIdx = -1, this._ignoreEditorChange = !1, this._ctxHasSymbols = yM.bindTo(i);
  }
  reset() {
    var i, e;
    this._ctxHasSymbols.reset(), (i = this._currentState) === null || i === void 0 || i.dispose(), (e = this._currentMessage) === null || e === void 0 || e.dispose(), this._currentModel = void 0, this._currentIdx = -1;
  }
  put(i) {
    const e = i.parent.parent;
    if (e.references.length <= 1) return void this.reset();
    this._currentModel = e, this._currentIdx = e.references.indexOf(i), this._ctxHasSymbols.set(!0), this._showMessage();
    const t = new SM(this._editorService), n = t.onDidChange((s) => {
      if (this._ignoreEditorChange) return;
      const o = this._editorService.getActiveCodeEditor();
      if (!o) return;
      const r = o.getModel(), a = o.getPosition();
      if (!r || !a) return;
      let l = !1, d = !1;
      for (const h of e.references) if (QR(h.uri, r.uri)) l = !0, d = d || D.containsPosition(h.range, a);
      else if (l) break;
      l && d || this.reset();
    });
    this._currentState = yr(t, n);
  }
  revealNext(i) {
    if (!this._currentModel) return Promise.resolve();
    this._currentIdx += 1, this._currentIdx %= this._currentModel.references.length;
    const e = this._currentModel.references[this._currentIdx];
    return this._showMessage(), this._ignoreEditorChange = !0, this._editorService.openCodeEditor({ resource: e.uri, options: { selection: D.collapseToStart(e.range), selectionRevealType: 3 } }, i).finally(() => {
      this._ignoreEditorChange = !1;
    });
  }
  _showMessage() {
    var i;
    (i = this._currentMessage) === null || i === void 0 || i.dispose();
    const e = this._keybindingService.lookupKeybinding("editor.gotoNextSymbolFromResult"), t = e ? m(0, "Symbol {0} of {1}, {2} for next", this._currentIdx + 1, this._currentModel.references.length, e.getLabel()) : m(0, "Symbol {0} of {1}", this._currentIdx + 1, this._currentModel.references.length);
    this._currentMessage = this._notificationService.status(t);
  }
};
kx = vz([F_(0, Te), F_(1, mt), F_(2, Ri), F_(3, Dt)], kx), rt(pw, kx, 1), re(new class extends Zi {
  constructor() {
    super({ id: "editor.gotoNextSymbolFromResult", precondition: yM, kbOpts: { weight: 100, primary: 70 } });
  }
  runEditorCommand(i, e) {
    return i.get(pw).revealNext(e);
  }
}()), Es.registerCommandAndKeybindingRule({ id: "editor.gotoNextSymbolFromResult.cancel", weight: 100, when: yM, primary: 9, handler(i) {
  i.get(pw).reset();
} });
let SM = class {
  constructor(i) {
    this._listener = /* @__PURE__ */ new Map(), this._disposables = new G(), this._onDidChange = new F(), this.onDidChange = this._onDidChange.event, this._disposables.add(i.onCodeEditorRemove(this._onDidRemoveEditor, this)), this._disposables.add(i.onCodeEditorAdd(this._onDidAddEditor, this)), i.listCodeEditors().forEach(this._onDidAddEditor, this);
  }
  dispose() {
    this._disposables.dispose(), this._onDidChange.dispose(), Ht(this._listener.values());
  }
  _onDidAddEditor(i) {
    this._listener.set(i, yr(i.onDidChangeCursorPosition((e) => this._onDidChange.fire({ editor: i })), i.onDidChangeModelContent((e) => this._onDidChange.fire({ editor: i }))));
  }
  _onDidRemoveEditor(i) {
    var e;
    (e = this._listener.get(i)) === null || e === void 0 || e.dispose(), this._listener.delete(i);
  }
};
async function K1(i, e, t, n) {
  const s = t.ordered(i).map((o) => Promise.resolve(n(o, i, e)).then(void 0, (r) => {
    Ni(r);
  }));
  return ca((await Promise.all(s)).flat());
}
function sk(i, e, t, n) {
  return K1(e, t, i, (s, o, r) => s.provideDefinition(o, r, n));
}
function bz(i, e, t, n) {
  return K1(e, t, i, (s, o, r) => s.provideDeclaration(o, r, n));
}
function Cz(i, e, t, n) {
  return K1(e, t, i, (s, o, r) => s.provideImplementation(o, r, n));
}
function wz(i, e, t, n) {
  return K1(e, t, i, (s, o, r) => s.provideTypeDefinition(o, r, n));
}
function mS(i, e, t, n, s) {
  return K1(e, t, i, async (o, r, a) => {
    const l = await o.provideReferences(r, a, { includeDeclaration: !0 }, s);
    if (!n || !l || l.length !== 2) return l;
    const d = await o.provideReferences(r, a, { includeDeclaration: !1 }, s);
    return d && d.length === 1 ? d : l;
  });
}
async function t_(i) {
  const e = await i(), t = new Js(e, ""), n = t.references.map((s) => s.link);
  return t.dispose(), n;
}
var Yb, Xb, Qb, Dx, xx, Nx, Ex, Ix;
SM = vz([F_(0, mt)], SM), qa("_executeDefinitionProvider", (i, e, t) => {
  const n = sk(i.get(fe).definitionProvider, e, t, et.None);
  return t_(() => n);
}), qa("_executeTypeDefinitionProvider", (i, e, t) => {
  const n = wz(i.get(fe).typeDefinitionProvider, e, t, et.None);
  return t_(() => n);
}), qa("_executeDeclarationProvider", (i, e, t) => {
  const n = bz(i.get(fe).declarationProvider, e, t, et.None);
  return t_(() => n);
}), qa("_executeReferenceProvider", (i, e, t) => {
  const n = mS(i.get(fe).referenceProvider, e, t, !1, et.None);
  return t_(() => n);
}), qa("_executeImplementationProvider", (i, e, t) => {
  const n = Cz(i.get(fe).implementationProvider, e, t, et.None);
  return t_(() => n);
}), tn.appendMenuItem(x.EditorContext, { submenu: x.EditorContextPeek, title: m(0, "Peek"), group: "navigation", order: 100 });
class df {
  static is(e) {
    return !(!e || typeof e != "object") && (e instanceof df || !(!W.isIPosition(e.position) || !e.model));
  }
  constructor(e, t) {
    this.model = e, this.position = t;
  }
}
class Xn extends Qr {
  static all() {
    return Xn._allSymbolNavigationCommands.values();
  }
  static _patchConfig(e) {
    const t = { ...e, f1: !0 };
    if (t.menu) for (const n of at.wrap(t.menu)) n.id !== x.EditorContext && n.id !== x.EditorContextPeek || (n.when = q.and(e.precondition, n.when));
    return t;
  }
  constructor(e, t) {
    super(Xn._patchConfig(t)), this.configuration = e, Xn._allSymbolNavigationCommands.set(t.id, this);
  }
  runEditorCommand(e, t, n, s) {
    if (!t.hasModel()) return Promise.resolve(void 0);
    const o = e.get(Ri), r = e.get(mt), a = e.get(Ec), l = e.get(pw), d = e.get(fe), h = e.get(Se), c = t.getModel(), u = t.getPosition(), g = df.is(n) ? n : new df(c, u), p = new Mc(t, 5), f = v1(this._getLocationModel(d, g.model, g.position, p.token), p.token).then(async (_) => {
      var v;
      if (!_ || p.token.isCancellationRequested) return;
      let b;
      if (Io(_.ariaMessage), _.referenceAt(c.uri, u)) {
        const w = this._getAlternativeCommand(t);
        !Xn._activeAlternativeCommands.has(w) && Xn._allSymbolNavigationCommands.has(w) && (b = Xn._allSymbolNavigationCommands.get(w));
      }
      const C = _.references.length;
      if (C === 0) {
        if (!this.configuration.muteMessage) {
          const w = c.getWordAtPosition(u);
          (v = bs.get(t)) === null || v === void 0 || v.showMessage(this._getNoResultFoundMessage(w), u);
        }
      } else {
        if (C !== 1 || !b) return this._onResult(r, l, t, _, s);
        Xn._activeAlternativeCommands.add(this.desc.id), h.invokeFunction((w) => b.runEditorCommand(w, t, n, s).finally(() => {
          Xn._activeAlternativeCommands.delete(this.desc.id);
        }));
      }
    }, (_) => {
      o.error(_);
    }).finally(() => {
      p.dispose();
    });
    return a.showWhile(f, 250), f;
  }
  async _onResult(e, t, n, s, o) {
    const r = this._getGoToPreference(n);
    if (n instanceof Tc || !(this.configuration.openInPeek || r === "peek" && s.references.length > 1)) {
      const a = s.firstReference(), l = s.references.length > 1 && r === "gotoAndPeek", d = await this._openReference(n, e, a, this.configuration.openToSide, !l);
      l && d ? this._openInPeek(d, s, o) : s.dispose(), r === "goto" && t.put(a);
    } else this._openInPeek(n, s, o);
  }
  async _openReference(e, t, n, s, o) {
    let r;
    var a;
    if ((a = n) && Ie.isUri(a.uri) && D.isIRange(a.range) && (D.isIRange(a.originSelectionRange) || D.isIRange(a.targetSelectionRange)) && (r = n.targetSelectionRange), r || (r = n.range), !r) return;
    const l = await t.openCodeEditor({ resource: n.uri, options: { selection: D.collapseToStart(r), selectionRevealType: 3, selectionSource: "code.jump" } }, e, s);
    if (l) {
      if (o) {
        const d = l.getModel(), h = l.createDecorationsCollection([{ range: r, options: { description: "symbol-navigate-action-highlight", className: "symbolHighlight" } }]);
        setTimeout(() => {
          l.getModel() === d && h.clear();
        }, 350);
      }
      return l;
    }
  }
  _openInPeek(e, t, n) {
    const s = lc.get(e);
    s && e.hasModel() ? s.toggleWidget(n ?? e.getSelection(), on((o) => Promise.resolve(t)), this.configuration.openInPeek) : t.dispose();
  }
}
Xn._allSymbolNavigationCommands = /* @__PURE__ */ new Map(), Xn._activeAlternativeCommands = /* @__PURE__ */ new Set();
class N0 extends Xn {
  async _getLocationModel(e, t, n, s) {
    return new Js(await sk(e.definitionProvider, t, n, s), m(0, "Definitions"));
  }
  _getNoResultFoundMessage(e) {
    return e && e.word ? m(0, "No definition found for '{0}'", e.word) : m(0, "No definition found");
  }
  _getAlternativeCommand(e) {
    return e.getOption(58).alternativeDefinitionCommand;
  }
  _getGoToPreference(e) {
    return e.getOption(58).multipleDefinitions;
  }
}
Ft(((Yb = class extends N0 {
  constructor() {
    super({ openToSide: !1, openInPeek: !1, muteMessage: !1 }, { id: Yb.id, title: { ...ct(0, "Go to Definition"), mnemonicTitle: m(0, "Go to &&Definition") }, precondition: E.hasDefinitionProvider, keybinding: [{ when: E.editorTextFocus, primary: 70, weight: 100 }, { when: q.and(E.editorTextFocus, eF), primary: 2118, weight: 100 }], menu: [{ id: x.EditorContext, group: "navigation", order: 1.1 }, { id: x.MenubarGoMenu, precondition: null, group: "4_symbol_nav", order: 2 }] }), dt.registerCommandAlias("editor.action.goToDeclaration", Yb.id);
  }
}).id = "editor.action.revealDefinition", Yb)), Ft(((Xb = class extends N0 {
  constructor() {
    super({ openToSide: !0, openInPeek: !1, muteMessage: !1 }, { id: Xb.id, title: ct(0, "Open Definition to the Side"), precondition: q.and(E.hasDefinitionProvider, E.isInEmbeddedEditor.toNegated()), keybinding: [{ when: E.editorTextFocus, primary: Vi(2089, 70), weight: 100 }, { when: q.and(E.editorTextFocus, eF), primary: Vi(2089, 2118), weight: 100 }] }), dt.registerCommandAlias("editor.action.openDeclarationToTheSide", Xb.id);
  }
}).id = "editor.action.revealDefinitionAside", Xb)), Ft(((Qb = class extends N0 {
  constructor() {
    super({ openToSide: !1, openInPeek: !0, muteMessage: !1 }, { id: Qb.id, title: ct(0, "Peek Definition"), precondition: q.and(E.hasDefinitionProvider, As.notInPeekEditor, E.isInEmbeddedEditor.toNegated()), keybinding: { when: E.editorTextFocus, primary: 582, linux: { primary: 3140 }, weight: 100 }, menu: { id: x.EditorContextPeek, group: "peek", order: 2 } }), dt.registerCommandAlias("editor.action.previewDeclaration", Qb.id);
  }
}).id = "editor.action.peekDefinition", Qb));
class k6 extends Xn {
  async _getLocationModel(e, t, n, s) {
    return new Js(await bz(e.declarationProvider, t, n, s), m(0, "Declarations"));
  }
  _getNoResultFoundMessage(e) {
    return e && e.word ? m(0, "No declaration found for '{0}'", e.word) : m(0, "No declaration found");
  }
  _getAlternativeCommand(e) {
    return e.getOption(58).alternativeDeclarationCommand;
  }
  _getGoToPreference(e) {
    return e.getOption(58).multipleDeclarations;
  }
}
Ft(((Dx = class extends k6 {
  constructor() {
    super({ openToSide: !1, openInPeek: !1, muteMessage: !1 }, { id: Dx.id, title: { ...ct(0, "Go to Declaration"), mnemonicTitle: m(0, "Go to &&Declaration") }, precondition: q.and(E.hasDeclarationProvider, E.isInEmbeddedEditor.toNegated()), menu: [{ id: x.EditorContext, group: "navigation", order: 1.3 }, { id: x.MenubarGoMenu, precondition: null, group: "4_symbol_nav", order: 3 }] });
  }
  _getNoResultFoundMessage(i) {
    return i && i.word ? m(0, "No declaration found for '{0}'", i.word) : m(0, "No declaration found");
  }
}).id = "editor.action.revealDeclaration", Dx)), Ft(class extends k6 {
  constructor() {
    super({ openToSide: !1, openInPeek: !0, muteMessage: !1 }, { id: "editor.action.peekDeclaration", title: ct(0, "Peek Declaration"), precondition: q.and(E.hasDeclarationProvider, As.notInPeekEditor, E.isInEmbeddedEditor.toNegated()), menu: { id: x.EditorContextPeek, group: "peek", order: 3 } });
  }
});
class D6 extends Xn {
  async _getLocationModel(e, t, n, s) {
    return new Js(await wz(e.typeDefinitionProvider, t, n, s), m(0, "Type Definitions"));
  }
  _getNoResultFoundMessage(e) {
    return e && e.word ? m(0, "No type definition found for '{0}'", e.word) : m(0, "No type definition found");
  }
  _getAlternativeCommand(e) {
    return e.getOption(58).alternativeTypeDefinitionCommand;
  }
  _getGoToPreference(e) {
    return e.getOption(58).multipleTypeDefinitions;
  }
}
Ft(((xx = class extends D6 {
  constructor() {
    super({ openToSide: !1, openInPeek: !1, muteMessage: !1 }, { id: xx.ID, title: { ...ct(0, "Go to Type Definition"), mnemonicTitle: m(0, "Go to &&Type Definition") }, precondition: E.hasTypeDefinitionProvider, keybinding: { when: E.editorTextFocus, primary: 0, weight: 100 }, menu: [{ id: x.EditorContext, group: "navigation", order: 1.4 }, { id: x.MenubarGoMenu, precondition: null, group: "4_symbol_nav", order: 3 }] });
  }
}).ID = "editor.action.goToTypeDefinition", xx)), Ft(((Nx = class extends D6 {
  constructor() {
    super({ openToSide: !1, openInPeek: !0, muteMessage: !1 }, { id: Nx.ID, title: ct(0, "Peek Type Definition"), precondition: q.and(E.hasTypeDefinitionProvider, As.notInPeekEditor, E.isInEmbeddedEditor.toNegated()), menu: { id: x.EditorContextPeek, group: "peek", order: 4 } });
  }
}).ID = "editor.action.peekTypeDefinition", Nx));
class x6 extends Xn {
  async _getLocationModel(e, t, n, s) {
    return new Js(await Cz(e.implementationProvider, t, n, s), m(0, "Implementations"));
  }
  _getNoResultFoundMessage(e) {
    return e && e.word ? m(0, "No implementation found for '{0}'", e.word) : m(0, "No implementation found");
  }
  _getAlternativeCommand(e) {
    return e.getOption(58).alternativeImplementationCommand;
  }
  _getGoToPreference(e) {
    return e.getOption(58).multipleImplementations;
  }
}
Ft(((Ex = class extends x6 {
  constructor() {
    super({ openToSide: !1, openInPeek: !1, muteMessage: !1 }, { id: Ex.ID, title: { ...ct(0, "Go to Implementations"), mnemonicTitle: m(0, "Go to &&Implementations") }, precondition: E.hasImplementationProvider, keybinding: { when: E.editorTextFocus, primary: 2118, weight: 100 }, menu: [{ id: x.EditorContext, group: "navigation", order: 1.45 }, { id: x.MenubarGoMenu, precondition: null, group: "4_symbol_nav", order: 4 }] });
  }
}).ID = "editor.action.goToImplementation", Ex)), Ft(((Ix = class extends x6 {
  constructor() {
    super({ openToSide: !1, openInPeek: !0, muteMessage: !1 }, { id: Ix.ID, title: ct(0, "Peek Implementations"), precondition: q.and(E.hasImplementationProvider, As.notInPeekEditor, E.isInEmbeddedEditor.toNegated()), keybinding: { when: E.editorTextFocus, primary: 3142, weight: 100 }, menu: { id: x.EditorContextPeek, group: "peek", order: 5 } });
  }
}).ID = "editor.action.peekImplementation", Ix));
class N6 extends Xn {
  _getNoResultFoundMessage(e) {
    return e ? m(0, "No references found for '{0}'", e.word) : m(0, "No references found");
  }
  _getAlternativeCommand(e) {
    return e.getOption(58).alternativeReferenceCommand;
  }
  _getGoToPreference(e) {
    return e.getOption(58).multipleReferences;
  }
}
Ft(class extends N6 {
  constructor() {
    super({ openToSide: !1, openInPeek: !1, muteMessage: !1 }, { id: "editor.action.goToReferences", title: { ...ct(0, "Go to References"), mnemonicTitle: m(0, "Go to &&References") }, precondition: q.and(E.hasReferenceProvider, As.notInPeekEditor, E.isInEmbeddedEditor.toNegated()), keybinding: { when: E.editorTextFocus, primary: 1094, weight: 100 }, menu: [{ id: x.EditorContext, group: "navigation", order: 1.45 }, { id: x.MenubarGoMenu, precondition: null, group: "4_symbol_nav", order: 5 }] });
  }
  async _getLocationModel(i, e, t, n) {
    return new Js(await mS(i.referenceProvider, e, t, !0, n), m(0, "References"));
  }
}), Ft(class extends N6 {
  constructor() {
    super({ openToSide: !1, openInPeek: !0, muteMessage: !1 }, { id: "editor.action.referenceSearch.trigger", title: ct(0, "Peek References"), precondition: q.and(E.hasReferenceProvider, As.notInPeekEditor, E.isInEmbeddedEditor.toNegated()), menu: { id: x.EditorContextPeek, group: "peek", order: 6 } });
  }
  async _getLocationModel(i, e, t, n) {
    return new Js(await mS(i.referenceProvider, e, t, !1, n), m(0, "References"));
  }
});
class dae extends Xn {
  constructor(e, t, n) {
    super(e, { id: "editor.action.goToLocation", title: ct(0, "Go to Any Symbol"), precondition: q.and(As.notInPeekEditor, E.isInEmbeddedEditor.toNegated()) }), this._references = t, this._gotoMultipleBehaviour = n;
  }
  async _getLocationModel(e, t, n, s) {
    return new Js(this._references, m(0, "Locations"));
  }
  _getNoResultFoundMessage(e) {
    return e && m(0, "No results for '{0}'", e.word) || "";
  }
  _getGoToPreference(e) {
    var t;
    return (t = this._gotoMultipleBehaviour) !== null && t !== void 0 ? t : e.getOption(58).multipleReferences;
  }
  _getAlternativeCommand() {
    return "";
  }
}
dt.registerCommand({ id: "editor.action.goToLocations", metadata: { description: "Go to locations from a position in a file", args: [{ name: "uri", description: "The text document in which to start", constraint: Ie }, { name: "position", description: "The position at which to start", constraint: W.isIPosition }, { name: "locations", description: "An array of locations.", constraint: Array }, { name: "multiple", description: "Define what to do when having multiple results, either `peek`, `gotoAndPeek`, or `goto`" }, { name: "noResultsMessage", description: "Human readable message that shows when locations is empty." }] }, handler: async (i, e, t, n, s, o, r) => {
  vt(Ie.isUri(e)), vt(W.isIPosition(t)), vt(Array.isArray(n)), vt(s === void 0 || typeof s == "string"), vt(r === void 0 || typeof r == "boolean");
  const a = i.get(mt), l = await a.openCodeEditor({ resource: e }, a.getFocusedCodeEditor());
  if (yl(l)) return l.setPosition(t), l.revealPositionInCenterIfOutsideViewport(t, 0), l.invokeWithinContext((d) => {
    const h = new class extends dae {
      _getNoResultFoundMessage(c) {
        return o || super._getNoResultFoundMessage(c);
      }
    }({ muteMessage: !o, openInPeek: !!r, openToSide: !1 }, n, s);
    d.get(Se).invokeFunction(h.run.bind(h), l);
  });
} }), dt.registerCommand({ id: "editor.action.peekLocations", metadata: { description: "Peek locations from a position in a file", args: [{ name: "uri", description: "The text document in which to start", constraint: Ie }, { name: "position", description: "The position at which to start", constraint: W.isIPosition }, { name: "locations", description: "An array of locations.", constraint: Array }, { name: "multiple", description: "Define what to do when having multiple results, either `peek`, `gotoAndPeek`, or `goto`" }] }, handler: async (i, e, t, n, s) => {
  i.get(ai).executeCommand("editor.action.goToLocations", e, t, n, s, void 0, !0);
} }), dt.registerCommand({ id: "editor.action.findReferences", handler: (i, e, t) => {
  vt(Ie.isUri(e)), vt(W.isIPosition(t));
  const n = i.get(fe), s = i.get(mt);
  return s.openCodeEditor({ resource: e }, s.getFocusedCodeEditor()).then((o) => {
    if (!yl(o) || !o.hasModel()) return;
    const r = lc.get(o);
    if (!r) return;
    const a = on((d) => mS(n.referenceProvider, o.getModel(), W.lift(t), !1, d).then((h) => new Js(h, m(0, "References")))), l = new D(t.lineNumber, t.column, t.lineNumber, t.column);
    return Promise.resolve(r.toggleWidget(l, a, !1));
  });
} }), dt.registerCommandAlias("editor.action.showReferences", "editor.action.peekLocations");
var B_, hae = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Mx = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let cu = B_ = class {
  constructor(i, e, t, n) {
    this.textModelResolverService = e, this.languageService = t, this.languageFeaturesService = n, this.toUnhook = new G(), this.toUnhookForKeyboard = new G(), this.currentWordAtPosition = null, this.previousPromise = null, this.editor = i, this.linkDecorations = this.editor.createDecorationsCollection();
    const s = new JL(i);
    this.toUnhook.add(s), this.toUnhook.add(s.onMouseMoveOrRelevantKeyDown(([o, r]) => {
      this.startFindDefinitionFromMouse(o, r ?? void 0);
    })), this.toUnhook.add(s.onExecute((o) => {
      this.isEnabled(o) && this.gotoDefinition(o.target.position, o.hasSideBySideModifier).catch((r) => {
        We(r);
      }).finally(() => {
        this.removeLinkDecorations();
      });
    })), this.toUnhook.add(s.onCancel(() => {
      this.removeLinkDecorations(), this.currentWordAtPosition = null;
    }));
  }
  static get(i) {
    return i.getContribution(B_.ID);
  }
  async startFindDefinitionFromCursor(i) {
    await this.startFindDefinition(i), this.toUnhookForKeyboard.add(this.editor.onDidChangeCursorPosition(() => {
      this.currentWordAtPosition = null, this.removeLinkDecorations(), this.toUnhookForKeyboard.clear();
    })), this.toUnhookForKeyboard.add(this.editor.onKeyDown((e) => {
      e && (this.currentWordAtPosition = null, this.removeLinkDecorations(), this.toUnhookForKeyboard.clear());
    }));
  }
  startFindDefinitionFromMouse(i, e) {
    if (i.target.type === 9 && this.linkDecorations.length > 0) return;
    if (!this.editor.hasModel() || !this.isEnabled(i, e)) return this.currentWordAtPosition = null, void this.removeLinkDecorations();
    const t = i.target.position;
    this.startFindDefinition(t);
  }
  async startFindDefinition(i) {
    var e;
    this.toUnhookForKeyboard.clear();
    const t = i ? (e = this.editor.getModel()) === null || e === void 0 ? void 0 : e.getWordAtPosition(i) : null;
    if (!t) return this.currentWordAtPosition = null, void this.removeLinkDecorations();
    if (this.currentWordAtPosition && this.currentWordAtPosition.startColumn === t.startColumn && this.currentWordAtPosition.endColumn === t.endColumn && this.currentWordAtPosition.word === t.word) return;
    this.currentWordAtPosition = t;
    const n = new iH(this.editor, 15);
    let s;
    this.previousPromise && (this.previousPromise.cancel(), this.previousPromise = null), this.previousPromise = on((r) => this.findDefinition(i, r));
    try {
      s = await this.previousPromise;
    } catch (r) {
      return void We(r);
    }
    if (!s || !s.length || !n.validate(this.editor)) return void this.removeLinkDecorations();
    const o = s[0].originSelectionRange ? D.lift(s[0].originSelectionRange) : new D(i.lineNumber, t.startColumn, i.lineNumber, t.endColumn);
    if (s.length > 1) {
      let r = o;
      for (const { originSelectionRange: a } of s) a && (r = D.plusRange(r, a));
      this.addDecoration(r, new Vn().appendText(m(0, "Click to show {0} definitions.", s.length)));
    } else {
      const r = s[0];
      if (!r.uri) return;
      this.textModelResolverService.createModelReference(r.uri).then((a) => {
        if (!a.object || !a.object.textEditorModel) return void a.dispose();
        const { object: { textEditorModel: l } } = a, { startLineNumber: d } = r.range;
        if (d < 1 || d > l.getLineCount()) return void a.dispose();
        const h = this.getPreviewValue(l, d, r), c = this.languageService.guessLanguageIdByFilepathOrFirstLine(l.uri);
        this.addDecoration(o, h ? new Vn().appendCodeblock(c || "", h) : void 0), a.dispose();
      });
    }
  }
  getPreviewValue(i, e, t) {
    let n = t.range;
    return n.endLineNumber - n.startLineNumber >= B_.MAX_SOURCE_PREVIEW_LINES && (n = this.getPreviewRangeBasedOnIndentation(i, e)), this.stripIndentationFromPreviewRange(i, e, n);
  }
  stripIndentationFromPreviewRange(i, e, t) {
    let n = i.getLineFirstNonWhitespaceColumn(e);
    for (let s = e + 1; s < t.endLineNumber; s++) {
      const o = i.getLineFirstNonWhitespaceColumn(s);
      n = Math.min(n, o);
    }
    return i.getValueInRange(t).replace(new RegExp(`^\\s{${n - 1}}`, "gm"), "").trim();
  }
  getPreviewRangeBasedOnIndentation(i, e) {
    const t = i.getLineFirstNonWhitespaceColumn(e), n = Math.min(i.getLineCount(), e + B_.MAX_SOURCE_PREVIEW_LINES);
    let s = e + 1;
    for (; s < n && t !== i.getLineFirstNonWhitespaceColumn(s); s++)
      ;
    return new D(e, 1, s + 1, 1);
  }
  addDecoration(i, e) {
    const t = { range: i, options: { description: "goto-definition-link", inlineClassName: "goto-definition-link", hoverMessage: e } };
    this.linkDecorations.set([t]);
  }
  removeLinkDecorations() {
    this.linkDecorations.clear();
  }
  isEnabled(i, e) {
    var t;
    return this.editor.hasModel() && i.isLeftClick && i.isNoneOrSingleMouseDown && i.target.type === 6 && !(((t = i.target.detail.injectedText) === null || t === void 0 ? void 0 : t.options) instanceof Nc) && (i.hasTriggerModifier || !!e && e.keyCodeIsTriggerKey) && this.languageFeaturesService.definitionProvider.has(this.editor.getModel());
  }
  findDefinition(i, e) {
    const t = this.editor.getModel();
    return t ? sk(this.languageFeaturesService.definitionProvider, t, i, e) : Promise.resolve(null);
  }
  gotoDefinition(i, e) {
    return this.editor.setPosition(i), this.editor.invokeWithinContext((t) => {
      const n = !e && this.editor.getOption(88) && !this.isInPeekEditor(t);
      return new N0({ openToSide: e, openInPeek: n, muteMessage: !0 }, { title: { value: "", original: "" }, id: "", precondition: void 0 }).run(t);
    });
  }
  isInPeekEditor(i) {
    const e = i.get(Te);
    return As.inPeekEditor.getValue(e);
  }
  dispose() {
    this.toUnhook.dispose(), this.toUnhookForKeyboard.dispose();
  }
};
cu.ID = "editor.contrib.gotodefinitionatposition", cu.MAX_SOURCE_PREVIEW_LINES = 8, cu = B_ = hae([Mx(1, Ps), Mx(2, Xt), Mx(3, fe)], cu), ft(cu.ID, cu, 2);
let cae = class {
  constructor(i, e, t) {
    this.value = i, this.isComplete = e, this.hasLoadingMessage = t;
  }
};
class yz extends V {
  constructor(e, t) {
    super(), this._editor = e, this._computer = t, this._onResult = this._register(new F()), this.onResult = this._onResult.event, this._firstWaitScheduler = this._register(new It(() => this._triggerAsyncComputation(), 0)), this._secondWaitScheduler = this._register(new It(() => this._triggerSyncComputation(), 0)), this._loadingMessageScheduler = this._register(new It(() => this._triggerLoadingMessage(), 0)), this._state = 0, this._asyncIterable = null, this._asyncIterableDone = !1, this._result = [];
  }
  dispose() {
    this._asyncIterable && (this._asyncIterable.cancel(), this._asyncIterable = null), super.dispose();
  }
  get _hoverTime() {
    return this._editor.getOption(60).delay;
  }
  get _firstWaitTime() {
    return this._hoverTime / 2;
  }
  get _secondWaitTime() {
    return this._hoverTime - this._firstWaitTime;
  }
  get _loadingMessageTime() {
    return 3 * this._hoverTime;
  }
  _setState(e, t = !0) {
    this._state = e, t && this._fireResult();
  }
  _triggerAsyncComputation() {
    this._setState(2), this._secondWaitScheduler.schedule(this._secondWaitTime), this._computer.computeAsync ? (this._asyncIterableDone = !1, this._asyncIterable = function(e) {
      const t = new Ci(), n = e(t.token);
      return new VK(t, async (s) => {
        const o = t.token.onCancellationRequested(() => {
          o.dispose(), t.dispose(), s.reject(new Vd());
        });
        try {
          for await (const r of n) {
            if (t.token.isCancellationRequested) return;
            s.emitOne(r);
          }
          o.dispose(), t.dispose();
        } catch (r) {
          o.dispose(), t.dispose(), s.reject(r);
        }
      });
    }((e) => this._computer.computeAsync(e)), (async () => {
      try {
        for await (const e of this._asyncIterable) e && (this._result.push(e), this._fireResult());
        this._asyncIterableDone = !0, this._state !== 3 && this._state !== 4 || this._setState(0);
      } catch (e) {
        We(e);
      }
    })()) : this._asyncIterableDone = !0;
  }
  _triggerSyncComputation() {
    this._computer.computeSync && (this._result = this._result.concat(this._computer.computeSync())), this._setState(this._asyncIterableDone ? 0 : 3);
  }
  _triggerLoadingMessage() {
    this._state === 3 && this._setState(4);
  }
  _fireResult() {
    if (this._state === 1 || this._state === 2) return;
    const e = this._state === 0, t = this._state === 4;
    this._onResult.fire(new cae(this._result.slice(0), e, t));
  }
  start(e) {
    if (e === 0) this._state === 0 && (this._setState(1), this._firstWaitScheduler.schedule(this._firstWaitTime), this._loadingMessageScheduler.schedule(this._loadingMessageTime));
    else switch (this._state) {
      case 0:
        this._triggerAsyncComputation(), this._secondWaitScheduler.cancel(), this._triggerSyncComputation();
        break;
      case 2:
        this._secondWaitScheduler.cancel(), this._triggerSyncComputation();
    }
  }
  cancel() {
    this._firstWaitScheduler.cancel(), this._secondWaitScheduler.cancel(), this._loadingMessageScheduler.cancel(), this._asyncIterable && (this._asyncIterable.cancel(), this._asyncIterable = null), this._result = [], this._setState(0, !1);
  }
}
class Tx {
  constructor(e, t, n, s) {
    this.priority = e, this.range = t, this.initialMousePosX = n, this.initialMousePosY = s, this.type = 1;
  }
  equals(e) {
    return e.type === 1 && this.range.equalsRange(e.range);
  }
  canAdoptVisibleHover(e, t) {
    return e.type === 1 && t.lineNumber === this.range.startLineNumber;
  }
}
class Xu {
  constructor(e, t, n, s, o, r) {
    this.priority = e, this.owner = t, this.range = n, this.initialMousePosX = s, this.initialMousePosY = o, this.supportsMarkerHover = r, this.type = 2;
  }
  equals(e) {
    return e.type === 2 && this.owner === e.owner;
  }
  canAdoptVisibleHover(e, t) {
    return e.type === 2 && this.owner === e.owner;
  }
}
const Rc = new class {
  constructor() {
    this._participants = [];
  }
  register(i) {
    this._participants.push(i);
  }
  getAll() {
    return this._participants;
  }
}();
class CP {
  constructor() {
    let e;
    this._onDidWillResize = new F(), this.onDidWillResize = this._onDidWillResize.event, this._onDidResize = new F(), this.onDidResize = this._onDidResize.event, this._sashListener = new G(), this._size = new bt(0, 0), this._minSize = new bt(0, 0), this._maxSize = new bt(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER), this.domNode = document.createElement("div"), this._eastSash = new Bn(this.domNode, { getVerticalSashLeft: () => this._size.width }, { orientation: 0 }), this._westSash = new Bn(this.domNode, { getVerticalSashLeft: () => 0 }, { orientation: 0 }), this._northSash = new Bn(this.domNode, { getHorizontalSashTop: () => 0 }, { orientation: 1, orthogonalEdge: jy.North }), this._southSash = new Bn(this.domNode, { getHorizontalSashTop: () => this._size.height }, { orientation: 1, orthogonalEdge: jy.South }), this._northSash.orthogonalStartSash = this._westSash, this._northSash.orthogonalEndSash = this._eastSash, this._southSash.orthogonalStartSash = this._westSash, this._southSash.orthogonalEndSash = this._eastSash;
    let t = 0, n = 0;
    this._sashListener.add(se.any(this._northSash.onDidStart, this._eastSash.onDidStart, this._southSash.onDidStart, this._westSash.onDidStart)(() => {
      e === void 0 && (this._onDidWillResize.fire(), e = this._size, t = 0, n = 0);
    })), this._sashListener.add(se.any(this._northSash.onDidEnd, this._eastSash.onDidEnd, this._southSash.onDidEnd, this._westSash.onDidEnd)(() => {
      e !== void 0 && (e = void 0, t = 0, n = 0, this._onDidResize.fire({ dimension: this._size, done: !0 }));
    })), this._sashListener.add(this._eastSash.onDidChange((s) => {
      e && (n = s.currentX - s.startX, this.layout(e.height + t, e.width + n), this._onDidResize.fire({ dimension: this._size, done: !1, east: !0 }));
    })), this._sashListener.add(this._westSash.onDidChange((s) => {
      e && (n = -(s.currentX - s.startX), this.layout(e.height + t, e.width + n), this._onDidResize.fire({ dimension: this._size, done: !1, west: !0 }));
    })), this._sashListener.add(this._northSash.onDidChange((s) => {
      e && (t = -(s.currentY - s.startY), this.layout(e.height + t, e.width + n), this._onDidResize.fire({ dimension: this._size, done: !1, north: !0 }));
    })), this._sashListener.add(this._southSash.onDidChange((s) => {
      e && (t = s.currentY - s.startY, this.layout(e.height + t, e.width + n), this._onDidResize.fire({ dimension: this._size, done: !1, south: !0 }));
    })), this._sashListener.add(se.any(this._eastSash.onDidReset, this._westSash.onDidReset)((s) => {
      this._preferredSize && (this.layout(this._size.height, this._preferredSize.width), this._onDidResize.fire({ dimension: this._size, done: !0 }));
    })), this._sashListener.add(se.any(this._northSash.onDidReset, this._southSash.onDidReset)((s) => {
      this._preferredSize && (this.layout(this._preferredSize.height, this._size.width), this._onDidResize.fire({ dimension: this._size, done: !0 }));
    }));
  }
  dispose() {
    this._northSash.dispose(), this._southSash.dispose(), this._eastSash.dispose(), this._westSash.dispose(), this._sashListener.dispose(), this._onDidResize.dispose(), this._onDidWillResize.dispose(), this.domNode.remove();
  }
  enableSashes(e, t, n, s) {
    this._northSash.state = e ? 3 : 0, this._eastSash.state = t ? 3 : 0, this._southSash.state = n ? 3 : 0, this._westSash.state = s ? 3 : 0;
  }
  layout(e = this.size.height, t = this.size.width) {
    const { height: n, width: s } = this._minSize, { height: o, width: r } = this._maxSize;
    e = Math.max(n, Math.min(o, e)), t = Math.max(s, Math.min(r, t));
    const a = new bt(t, e);
    bt.equals(a, this._size) || (this.domNode.style.height = e + "px", this.domNode.style.width = t + "px", this._size = a, this._northSash.layout(), this._eastSash.layout(), this._southSash.layout(), this._westSash.layout());
  }
  clearSashHoverState() {
    this._eastSash.clearSashHoverState(), this._westSash.clearSashHoverState(), this._northSash.clearSashHoverState(), this._southSash.clearSashHoverState();
  }
  get size() {
    return this._size;
  }
  set maxSize(e) {
    this._maxSize = e;
  }
  get maxSize() {
    return this._maxSize;
  }
  set minSize(e) {
    this._minSize = e;
  }
  get minSize() {
    return this._minSize;
  }
  set preferredSize(e) {
    this._preferredSize = e;
  }
  get preferredSize() {
    return this._preferredSize;
  }
}
class uae extends V {
  constructor(e, t = new bt(10, 10)) {
    super(), this._editor = e, this.allowEditorOverflow = !0, this.suppressMouseDown = !1, this._resizableNode = this._register(new CP()), this._contentPosition = null, this._isResizing = !1, this._resizableNode.domNode.style.position = "absolute", this._resizableNode.minSize = bt.lift(t), this._resizableNode.layout(t.height, t.width), this._resizableNode.enableSashes(!0, !0, !0, !0), this._register(this._resizableNode.onDidResize((n) => {
      this._resize(new bt(n.dimension.width, n.dimension.height)), n.done && (this._isResizing = !1);
    })), this._register(this._resizableNode.onDidWillResize(() => {
      this._isResizing = !0;
    }));
  }
  get isResizing() {
    return this._isResizing;
  }
  getDomNode() {
    return this._resizableNode.domNode;
  }
  getPosition() {
    return this._contentPosition;
  }
  get position() {
    var e;
    return !((e = this._contentPosition) === null || e === void 0) && e.position ? W.lift(this._contentPosition.position) : void 0;
  }
  _availableVerticalSpaceAbove(e) {
    const t = this._editor.getDomNode(), n = this._editor.getScrolledVisiblePosition(e);
    if (!(!t || !n))
      return Ti(t).top + n.top - 30;
  }
  _availableVerticalSpaceBelow(e) {
    const t = this._editor.getDomNode(), n = this._editor.getScrolledVisiblePosition(e);
    if (!t || !n) return;
    const s = Ti(t), o = wc(t.ownerDocument.body), r = s.top + n.top + n.height;
    return o.height - r - 24;
  }
  _findPositionPreference(e, t) {
    var n, s;
    const o = Math.min((n = this._availableVerticalSpaceBelow(t)) !== null && n !== void 0 ? n : 1 / 0, e), r = Math.min((s = this._availableVerticalSpaceAbove(t)) !== null && s !== void 0 ? s : 1 / 0, e), a = Math.min(Math.max(r, o), e), l = Math.min(e, a);
    let d;
    return d = this._editor.getOption(60).above ? l <= r ? 1 : 2 : l <= o ? 2 : 1, d === 1 ? this._resizableNode.enableSashes(!0, !0, !1, !1) : this._resizableNode.enableSashes(!1, !0, !0, !1), d;
  }
  _resize(e) {
    this._resizableNode.layout(e.height, e.width);
  }
}
var mw, Ra, wP = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Wu = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const E6 = Q;
let fw = mw = class extends V {
  constructor(i, e, t) {
    super(), this._editor = i, this._instantiationService = e, this._keybindingService = t, this._currentResult = null, this._widget = this._register(this._instantiationService.createInstance(jh, this._editor)), this._participants = [];
    for (const n of Rc.getAll()) this._participants.push(this._instantiationService.createInstance(n, this._editor));
    this._participants.sort((n, s) => n.hoverOrdinal - s.hoverOrdinal), this._computer = new _S(this._editor, this._participants), this._hoverOperation = this._register(new yz(this._editor, this._computer)), this._register(this._hoverOperation.onResult((n) => {
      if (!this._computer.anchor) return;
      const s = n.hasLoadingMessage ? this._addLoadingMessage(n.value) : n.value;
      this._withResult(new Sz(this._computer.anchor, s, n.isComplete));
    })), this._register(bi(this._widget.getDomNode(), "keydown", (n) => {
      n.equals(9) && this.hide();
    })), this._register(ci.onDidChange(() => {
      this._widget.position && this._currentResult && this._setCurrentResult(this._currentResult);
    }));
  }
  _startShowingOrUpdateHover(i, e, t, n, s) {
    return !this._widget.position || !this._currentResult ? !!i && (this._startHoverOperationIfNecessary(i, e, t, n, !1), !0) : this._editor.getOption(60).sticky && s && this._widget.isMouseGettingCloser(s.event.posx, s.event.posy) ? (i && this._startHoverOperationIfNecessary(i, e, t, n, !0), !0) : i ? !(!i || !this._currentResult.anchor.equals(i)) || (i.canAdoptVisibleHover(this._currentResult.anchor, this._widget.position) ? (this._setCurrentResult(this._currentResult.filter(i)), this._startHoverOperationIfNecessary(i, e, t, n, !1), !0) : (this._setCurrentResult(null), this._startHoverOperationIfNecessary(i, e, t, n, !1), !0)) : (this._setCurrentResult(null), !1);
  }
  _startHoverOperationIfNecessary(i, e, t, n, s) {
    this._computer.anchor && this._computer.anchor.equals(i) || (this._hoverOperation.cancel(), this._computer.anchor = i, this._computer.shouldFocus = n, this._computer.source = t, this._computer.insistOnKeepingHoverVisible = s, this._hoverOperation.start(e));
  }
  _setCurrentResult(i) {
    this._currentResult !== i && (i && i.messages.length === 0 && (i = null), this._currentResult = i, this._currentResult ? this._renderMessages(this._currentResult.anchor, this._currentResult.messages) : this._widget.hide());
  }
  _addLoadingMessage(i) {
    if (this._computer.anchor) {
      for (const e of this._participants) if (e.createLoadingMessage) {
        const t = e.createLoadingMessage(this._computer.anchor);
        if (t) return i.slice(0).concat([t]);
      }
    }
    return i;
  }
  _withResult(i) {
    this._widget.position && this._currentResult && this._currentResult.isComplete && (!i.isComplete || this._computer.insistOnKeepingHoverVisible && i.messages.length === 0) || this._setCurrentResult(i);
  }
  _renderMessages(i, e) {
    const { showAtPosition: t, showAtSecondaryPosition: n, highlightRange: s } = mw.computeHoverRanges(this._editor, i.range, e), o = new G(), r = o.add(new fS(this._keybindingService)), a = document.createDocumentFragment();
    let l = null;
    const d = { fragment: a, statusBar: r, setColorPicker: (c) => l = c, onContentsChanged: () => this._widget.onContentsChanged(), setMinimumDimensions: (c) => this._widget.setMinimumDimensions(c), hide: () => this.hide() };
    for (const c of this._participants) {
      const u = e.filter((g) => g.owner === c);
      u.length > 0 && o.add(c.renderHoverParts(d, u));
    }
    const h = e.some((c) => c.isBeforeContent);
    if (r.hasContent && a.appendChild(r.hoverElement), a.hasChildNodes()) {
      if (s) {
        const c = this._editor.createDecorationsCollection();
        c.set([{ range: s, options: mw._DECORATION_OPTIONS }]), o.add(ye(() => {
          c.clear();
        }));
      }
      this._widget.showAt(a, new pae(i.initialMousePosX, i.initialMousePosY, l, t, n, this._editor.getOption(60).above, this._computer.shouldFocus, this._computer.source, h, o));
    } else o.dispose();
  }
  static computeHoverRanges(i, e, t) {
    let n = 1;
    if (i.hasModel()) {
      const l = i._getViewModel(), d = l.coordinatesConverter, h = d.convertModelRangeToViewRange(e), c = new W(h.startLineNumber, l.getLineMinColumn(h.startLineNumber));
      n = d.convertViewPositionToModelPosition(c).column;
    }
    const s = e.startLineNumber;
    let o = e.startColumn, r = t[0].range, a = null;
    for (const l of t) r = D.plusRange(r, l.range), l.range.startLineNumber === s && l.range.endLineNumber === s && (o = Math.max(Math.min(o, l.range.startColumn), n)), l.forceShowAtRange && (a = l.range);
    return { showAtPosition: a ? a.getStartPosition() : new W(s, e.startColumn), showAtSecondaryPosition: a ? a.getStartPosition() : new W(s, o), highlightRange: r };
  }
  showsOrWillShow(i) {
    if (this._widget.isResizing) return !0;
    const e = [];
    for (const n of this._participants) if (n.suggestHoverAnchor) {
      const s = n.suggestHoverAnchor(i);
      s && e.push(s);
    }
    const t = i.target;
    if (t.type === 6 && e.push(new Tx(0, t.range, i.event.posx, i.event.posy)), t.type === 7) {
      const n = this._editor.getOption(50).typicalHalfwidthCharacterWidth / 2;
      !t.detail.isAfterLines && typeof t.detail.horizontalDistanceToText == "number" && t.detail.horizontalDistanceToText < n && e.push(new Tx(0, t.range, i.event.posx, i.event.posy));
    }
    return e.length === 0 ? this._startShowingOrUpdateHover(null, 0, 0, !1, i) : (e.sort((n, s) => s.priority - n.priority), this._startShowingOrUpdateHover(e[0], 0, 0, !1, i));
  }
  startShowingAtRange(i, e, t, n) {
    this._startShowingOrUpdateHover(new Tx(0, i, void 0, void 0), e, t, n, null);
  }
  containsNode(i) {
    return !!i && this._widget.getDomNode().contains(i);
  }
  focus() {
    this._widget.focus();
  }
  scrollUp() {
    this._widget.scrollUp();
  }
  scrollDown() {
    this._widget.scrollDown();
  }
  scrollLeft() {
    this._widget.scrollLeft();
  }
  scrollRight() {
    this._widget.scrollRight();
  }
  pageUp() {
    this._widget.pageUp();
  }
  pageDown() {
    this._widget.pageDown();
  }
  goToTop() {
    this._widget.goToTop();
  }
  goToBottom() {
    this._widget.goToBottom();
  }
  hide() {
    this._computer.anchor = null, this._hoverOperation.cancel(), this._setCurrentResult(null);
  }
  get isColorPickerVisible() {
    return this._widget.isColorPickerVisible;
  }
  get isVisibleFromKeyboard() {
    return this._widget.isVisibleFromKeyboard;
  }
  get isVisible() {
    return this._widget.isVisible;
  }
  get isFocused() {
    return this._widget.isFocused;
  }
  get isResizing() {
    return this._widget.isResizing;
  }
  get widget() {
    return this._widget;
  }
};
fw._DECORATION_OPTIONS = Ve.register({ description: "content-hover-highlight", className: "hoverHighlight" }), fw = mw = wP([Wu(1, Se), Wu(2, Dt)], fw);
class Sz {
  constructor(e, t, n) {
    this.anchor = e, this.messages = t, this.isComplete = n;
  }
  filter(e) {
    const t = this.messages.filter((n) => n.isValidForHoverAnchor(e));
    return t.length === this.messages.length ? this : new gae(this, this.anchor, t, this.isComplete);
  }
}
class gae extends Sz {
  constructor(e, t, n, s) {
    super(t, n, s), this.original = e;
  }
  filter(e) {
    return this.original.filter(e);
  }
}
class pae {
  constructor(e, t, n, s, o, r, a, l, d, h) {
    this.initialMousePosX = e, this.initialMousePosY = t, this.colorPicker = n, this.showAtPosition = s, this.showAtSecondaryPosition = o, this.preferAbove = r, this.stoleFocus = a, this.source = l, this.isBeforeContent = d, this.disposables = h, this.closestMouseDistance = void 0;
  }
}
let jh = Ra = class extends uae {
  get isColorPickerVisible() {
    var i;
    return !!(!((i = this._visibleData) === null || i === void 0) && i.colorPicker);
  }
  get isVisibleFromKeyboard() {
    var i;
    return ((i = this._visibleData) === null || i === void 0 ? void 0 : i.source) === 1;
  }
  get isVisible() {
    var i;
    return (i = this._hoverVisibleKey.get()) !== null && i !== void 0 && i;
  }
  get isFocused() {
    var i;
    return (i = this._hoverFocusedKey.get()) !== null && i !== void 0 && i;
  }
  constructor(i, e, t, n, s) {
    const o = i.getOption(67) + 8, r = new bt(150, o);
    super(i, r), this._configurationService = t, this._accessibilityService = n, this._keybindingService = s, this._hover = this._register(new mA()), this._minimumSize = r, this._hoverVisibleKey = E.hoverVisible.bindTo(e), this._hoverFocusedKey = E.hoverFocused.bindTo(e), Z(this._resizableNode.domNode, this._hover.containerDomNode), this._resizableNode.domNode.style.zIndex = "50", this._register(this._editor.onDidLayoutChange(() => {
      this.isVisible && this._updateMaxDimensions();
    })), this._register(this._editor.onDidChangeConfiguration((l) => {
      l.hasChanged(50) && this._updateFont();
    }));
    const a = this._register(ma(this._resizableNode.domNode));
    this._register(a.onDidFocus(() => {
      this._hoverFocusedKey.set(!0);
    })), this._register(a.onDidBlur(() => {
      this._hoverFocusedKey.set(!1);
    })), this._setHoverData(void 0), this._editor.addContentWidget(this);
  }
  dispose() {
    var i;
    super.dispose(), (i = this._visibleData) === null || i === void 0 || i.disposables.dispose(), this._editor.removeContentWidget(this);
  }
  getId() {
    return Ra.ID;
  }
  static _applyDimensions(i, e, t) {
    const n = typeof e == "number" ? `${e}px` : e, s = typeof t == "number" ? `${t}px` : t;
    i.style.width = n, i.style.height = s;
  }
  _setContentsDomNodeDimensions(i, e) {
    const t = this._hover.contentsDomNode;
    return Ra._applyDimensions(t, i, e);
  }
  _setContainerDomNodeDimensions(i, e) {
    const t = this._hover.containerDomNode;
    return Ra._applyDimensions(t, i, e);
  }
  _setHoverWidgetDimensions(i, e) {
    this._setContentsDomNodeDimensions(i, e), this._setContainerDomNodeDimensions(i, e), this._layoutContentWidget();
  }
  static _applyMaxDimensions(i, e, t) {
    const n = typeof e == "number" ? `${e}px` : e, s = typeof t == "number" ? `${t}px` : t;
    i.style.maxWidth = n, i.style.maxHeight = s;
  }
  _setHoverWidgetMaxDimensions(i, e) {
    Ra._applyMaxDimensions(this._hover.contentsDomNode, i, e), Ra._applyMaxDimensions(this._hover.containerDomNode, i, e), this._hover.containerDomNode.style.setProperty("--vscode-hover-maxWidth", typeof i == "number" ? `${i}px` : i), this._layoutContentWidget();
  }
  _hasHorizontalScrollbar() {
    const i = this._hover.scrollbar.getScrollDimensions();
    return i.scrollWidth > i.width;
  }
  _adjustContentsBottomPadding() {
    const i = this._hover.contentsDomNode, e = `${this._hover.scrollbar.options.horizontalScrollbarSize}px`;
    i.style.paddingBottom !== e && (i.style.paddingBottom = e);
  }
  _setAdjustedHoverWidgetDimensions(i) {
    this._setHoverWidgetMaxDimensions("none", "none");
    const e = i.width, t = i.height;
    this._setHoverWidgetDimensions(e, t), this._hasHorizontalScrollbar() && (this._adjustContentsBottomPadding(), this._setContentsDomNodeDimensions(e, t - 10));
  }
  _updateResizableNodeMaxDimensions() {
    var i, e;
    const t = (i = this._findMaximumRenderingWidth()) !== null && i !== void 0 ? i : 1 / 0, n = (e = this._findMaximumRenderingHeight()) !== null && e !== void 0 ? e : 1 / 0;
    this._resizableNode.maxSize = new bt(t, n), this._setHoverWidgetMaxDimensions(t, n);
  }
  _resize(i) {
    var e, t;
    Ra._lastDimensions = new bt(i.width, i.height), this._setAdjustedHoverWidgetDimensions(i), this._resizableNode.layout(i.height, i.width), this._updateResizableNodeMaxDimensions(), this._hover.scrollbar.scanDomNode(), this._editor.layoutContentWidget(this), (t = (e = this._visibleData) === null || e === void 0 ? void 0 : e.colorPicker) === null || t === void 0 || t.layout();
  }
  _findAvailableSpaceVertically() {
    var i;
    const e = (i = this._visibleData) === null || i === void 0 ? void 0 : i.showAtPosition;
    if (e) return this._positionPreference === 1 ? this._availableVerticalSpaceAbove(e) : this._availableVerticalSpaceBelow(e);
  }
  _findMaximumRenderingHeight() {
    const i = this._findAvailableSpaceVertically();
    if (!i) return;
    let e = 6;
    return Array.from(this._hover.contentsDomNode.children).forEach((t) => {
      e += t.clientHeight;
    }), this._hasHorizontalScrollbar() && (e += 10), Math.min(i, e);
  }
  _isHoverTextOverflowing() {
    this._hover.containerDomNode.style.setProperty("--vscode-hover-whiteSpace", "nowrap"), this._hover.containerDomNode.style.setProperty("--vscode-hover-sourceWhiteSpace", "nowrap");
    const i = Array.from(this._hover.contentsDomNode.children).some((e) => e.scrollWidth > e.clientWidth);
    return this._hover.containerDomNode.style.removeProperty("--vscode-hover-whiteSpace"), this._hover.containerDomNode.style.removeProperty("--vscode-hover-sourceWhiteSpace"), i;
  }
  _findMaximumRenderingWidth() {
    if (!this._editor || !this._editor.hasModel()) return;
    const i = this._isHoverTextOverflowing(), e = this._contentWidth === void 0 ? 0 : this._contentWidth - 2;
    return i || this._hover.containerDomNode.clientWidth < e ? wc(this._hover.containerDomNode.ownerDocument.body).width - 14 : this._hover.containerDomNode.clientWidth + 2;
  }
  isMouseGettingCloser(i, e) {
    if (!this._visibleData) return !1;
    if (this._visibleData.initialMousePosX === void 0 || this._visibleData.initialMousePosY === void 0) return this._visibleData.initialMousePosX = i, this._visibleData.initialMousePosY = e, !1;
    const t = Ti(this.getDomNode());
    this._visibleData.closestMouseDistance === void 0 && (this._visibleData.closestMouseDistance = I6(this._visibleData.initialMousePosX, this._visibleData.initialMousePosY, t.left, t.top, t.width, t.height));
    const n = I6(i, e, t.left, t.top, t.width, t.height);
    return !(n > this._visibleData.closestMouseDistance + 4) && (this._visibleData.closestMouseDistance = Math.min(this._visibleData.closestMouseDistance, n), !0);
  }
  _setHoverData(i) {
    var e;
    (e = this._visibleData) === null || e === void 0 || e.disposables.dispose(), this._visibleData = i, this._hoverVisibleKey.set(!!i), this._hover.containerDomNode.classList.toggle("hidden", !i);
  }
  _updateFont() {
    const { fontSize: i, lineHeight: e } = this._editor.getOption(50), t = this._hover.contentsDomNode;
    t.style.fontSize = `${i}px`, t.style.lineHeight = "" + e / i, Array.prototype.slice.call(this._hover.contentsDomNode.getElementsByClassName("code")).forEach((n) => this._editor.applyFontInfo(n));
  }
  _updateContent(i) {
    const e = this._hover.contentsDomNode;
    e.style.paddingBottom = "", e.textContent = "", e.appendChild(i);
  }
  _layoutContentWidget() {
    this._editor.layoutContentWidget(this), this._hover.onContentsChanged();
  }
  _updateMaxDimensions() {
    const i = Math.max(this._editor.getLayoutInfo().height / 4, 250, Ra._lastDimensions.height), e = Math.max(0.66 * this._editor.getLayoutInfo().width, 500, Ra._lastDimensions.width);
    this._setHoverWidgetMaxDimensions(e, i);
  }
  _render(i, e) {
    this._setHoverData(e), this._updateFont(), this._updateContent(i), this._updateMaxDimensions(), this.onContentsChanged(), this._editor.render();
  }
  getPosition() {
    var i;
    return this._visibleData ? { position: this._visibleData.showAtPosition, secondaryPosition: this._visibleData.showAtSecondaryPosition, positionAffinity: this._visibleData.isBeforeContent ? 3 : void 0, preference: [(i = this._positionPreference) !== null && i !== void 0 ? i : 1] } : null;
  }
  showAt(i, e) {
    var t, n, s, o;
    if (!this._editor || !this._editor.hasModel()) return;
    this._render(i, e);
    const r = rd(this._hover.containerDomNode), a = e.showAtPosition;
    this._positionPreference = (t = this._findPositionPreference(r, a)) !== null && t !== void 0 ? t : 1, this.onContentsChanged(), e.stoleFocus && this._hover.containerDomNode.focus(), (n = e.colorPicker) === null || n === void 0 || n.layout();
    const l = this._hover.containerDomNode.ownerDocument.activeElement === this._hover.containerDomNode && DW(this._configurationService.getValue("accessibility.verbosity.hover") === !0 && this._accessibilityService.isScreenReaderOptimized(), (o = (s = this._keybindingService.lookupKeybinding("editor.action.accessibleView")) === null || s === void 0 ? void 0 : s.getAriaLabel()) !== null && o !== void 0 ? o : "");
    l && (this._hover.contentsDomNode.ariaLabel = this._hover.contentsDomNode.textContent + ", " + l);
  }
  hide() {
    if (!this._visibleData) return;
    const i = this._visibleData.stoleFocus || this._hoverFocusedKey.get();
    this._setHoverData(void 0), this._resizableNode.maxSize = new bt(1 / 0, 1 / 0), this._resizableNode.clearSashHoverState(), this._hoverFocusedKey.set(!1), this._editor.layoutContentWidget(this), i && this._editor.focus();
  }
  _removeConstraintsRenderNormally() {
    const i = this._editor.getLayoutInfo();
    this._resizableNode.layout(i.height, i.width), this._setHoverWidgetDimensions("auto", "auto");
  }
  _adjustHoverHeightForScrollbar(i) {
    var e;
    const t = this._hover.containerDomNode, n = this._hover.contentsDomNode, s = (e = this._findMaximumRenderingHeight()) !== null && e !== void 0 ? e : 1 / 0;
    this._setContainerDomNodeDimensions(os(t), Math.min(s, i)), this._setContentsDomNodeDimensions(os(n), Math.min(s, i - 10));
  }
  setMinimumDimensions(i) {
    this._minimumSize = new bt(Math.max(this._minimumSize.width, i.width), Math.max(this._minimumSize.height, i.height)), this._updateMinimumWidth();
  }
  _updateMinimumWidth() {
    const i = this._contentWidth === void 0 ? this._minimumSize.width : Math.min(this._contentWidth, this._minimumSize.width);
    this._resizableNode.minSize = new bt(i, this._minimumSize.height);
  }
  onContentsChanged() {
    var i;
    this._removeConstraintsRenderNormally();
    const e = this._hover.containerDomNode;
    let t = rd(e), n = os(e);
    if (this._resizableNode.layout(t, n), this._setHoverWidgetDimensions(n, t), t = rd(e), n = os(e), this._contentWidth = n, this._updateMinimumWidth(), this._resizableNode.layout(t, n), this._hasHorizontalScrollbar() && (this._adjustContentsBottomPadding(), this._adjustHoverHeightForScrollbar(t)), (i = this._visibleData) === null || i === void 0 ? void 0 : i.showAtPosition) {
      const s = rd(this._hover.containerDomNode);
      this._positionPreference = this._findPositionPreference(s, this._visibleData.showAtPosition);
    }
    this._layoutContentWidget();
  }
  focus() {
    this._hover.containerDomNode.focus();
  }
  scrollUp() {
    const i = this._hover.scrollbar.getScrollPosition().scrollTop, e = this._editor.getOption(50);
    this._hover.scrollbar.setScrollPosition({ scrollTop: i - e.lineHeight });
  }
  scrollDown() {
    const i = this._hover.scrollbar.getScrollPosition().scrollTop, e = this._editor.getOption(50);
    this._hover.scrollbar.setScrollPosition({ scrollTop: i + e.lineHeight });
  }
  scrollLeft() {
    const i = this._hover.scrollbar.getScrollPosition().scrollLeft;
    this._hover.scrollbar.setScrollPosition({ scrollLeft: i - 30 });
  }
  scrollRight() {
    const i = this._hover.scrollbar.getScrollPosition().scrollLeft;
    this._hover.scrollbar.setScrollPosition({ scrollLeft: i + 30 });
  }
  pageUp() {
    const i = this._hover.scrollbar.getScrollPosition().scrollTop, e = this._hover.scrollbar.getScrollDimensions().height;
    this._hover.scrollbar.setScrollPosition({ scrollTop: i - e });
  }
  pageDown() {
    const i = this._hover.scrollbar.getScrollPosition().scrollTop, e = this._hover.scrollbar.getScrollDimensions().height;
    this._hover.scrollbar.setScrollPosition({ scrollTop: i + e });
  }
  goToTop() {
    this._hover.scrollbar.setScrollPosition({ scrollTop: 0 });
  }
  goToBottom() {
    this._hover.scrollbar.setScrollPosition({ scrollTop: this._hover.scrollbar.getScrollDimensions().scrollHeight });
  }
};
jh.ID = "editor.contrib.resizableContentHoverWidget", jh._lastDimensions = new bt(0, 0), jh = Ra = wP([Wu(1, Te), Wu(2, Ye), Wu(3, or), Wu(4, Dt)], jh);
let fS = class extends V {
  get hasContent() {
    return this._hasContent;
  }
  constructor(i) {
    super(), this._keybindingService = i, this._hasContent = !1, this.hoverElement = E6("div.hover-row.status-bar"), this.actionsElement = Z(this.hoverElement, E6("div.actions"));
  }
  addAction(i) {
    const e = this._keybindingService.lookupKeybinding(i.commandId), t = e ? e.getLabel() : null;
    return this._hasContent = !0, this._register(vL.render(this.actionsElement, i, t));
  }
  append(i) {
    const e = Z(this.actionsElement, i);
    return this._hasContent = !0, e;
  }
};
fS = wP([Wu(0, Dt)], fS);
class _S {
  get anchor() {
    return this._anchor;
  }
  set anchor(e) {
    this._anchor = e;
  }
  get shouldFocus() {
    return this._shouldFocus;
  }
  set shouldFocus(e) {
    this._shouldFocus = e;
  }
  get source() {
    return this._source;
  }
  set source(e) {
    this._source = e;
  }
  get insistOnKeepingHoverVisible() {
    return this._insistOnKeepingHoverVisible;
  }
  set insistOnKeepingHoverVisible(e) {
    this._insistOnKeepingHoverVisible = e;
  }
  constructor(e, t) {
    this._editor = e, this._participants = t, this._anchor = null, this._shouldFocus = !1, this._source = 0, this._insistOnKeepingHoverVisible = !1;
  }
  static _getLineDecorations(e, t) {
    if (t.type !== 1 && !t.supportsMarkerHover) return [];
    const n = e.getModel(), s = t.range.startLineNumber;
    if (s > n.getLineCount()) return [];
    const o = n.getLineMaxColumn(s);
    return e.getLineDecorations(s).filter((r) => {
      if (r.options.isWholeLine) return !0;
      const a = r.range.startLineNumber === s ? r.range.startColumn : 1, l = r.range.endLineNumber === s ? r.range.endColumn : o;
      if (r.options.showIfCollapsed) {
        if (a > t.range.startColumn + 1 || t.range.endColumn - 1 > l) return !1;
      } else if (a > t.range.startColumn || t.range.endColumn > l) return !1;
      return !0;
    });
  }
  computeAsync(e) {
    const t = this._anchor;
    if (!this._editor.hasModel() || !t) return Pi.EMPTY;
    const n = _S._getLineDecorations(this._editor, t);
    return Pi.merge(this._participants.map((s) => s.computeAsync ? s.computeAsync(t, n, e) : Pi.EMPTY));
  }
  computeSync() {
    if (!this._editor.hasModel() || !this._anchor) return [];
    const e = _S._getLineDecorations(this._editor, this._anchor);
    let t = [];
    for (const n of this._participants) t = t.concat(n.computeSync(this._anchor, e));
    return ca(t);
  }
}
function I6(i, e, t, n, s, o) {
  const r = t + s / 2, a = n + o / 2, l = Math.max(Math.abs(i - r) - s / 2, 0), d = Math.max(Math.abs(e - a) - o / 2, 0);
  return Math.sqrt(l * l + d * d);
}
const M6 = Q;
class km extends V {
  constructor(e, t, n) {
    super(), this._renderDisposeables = this._register(new G()), this._editor = e, this._isVisible = !1, this._messages = [], this._hover = this._register(new mA()), this._hover.containerDomNode.classList.toggle("hidden", !this._isVisible), this._markdownRenderer = this._register(new ml({ editor: this._editor }, t, n)), this._computer = new mae(this._editor), this._hoverOperation = this._register(new yz(this._editor, this._computer)), this._register(this._hoverOperation.onResult((s) => {
      this._withResult(s.value);
    })), this._register(this._editor.onDidChangeModelDecorations(() => this._onModelDecorationsChanged())), this._register(this._editor.onDidChangeConfiguration((s) => {
      s.hasChanged(50) && this._updateFont();
    })), this._editor.addOverlayWidget(this);
  }
  dispose() {
    this._editor.removeOverlayWidget(this), super.dispose();
  }
  getId() {
    return km.ID;
  }
  getDomNode() {
    return this._hover.containerDomNode;
  }
  getPosition() {
    return null;
  }
  _updateFont() {
    Array.prototype.slice.call(this._hover.contentsDomNode.getElementsByClassName("code")).forEach((e) => this._editor.applyFontInfo(e));
  }
  _onModelDecorationsChanged() {
    this._isVisible && (this._hoverOperation.cancel(), this._hoverOperation.start(0));
  }
  startShowingAt(e, t) {
    this._computer.lineNumber === e && this._computer.lane === t || (this._hoverOperation.cancel(), this.hide(), this._computer.lineNumber = e, this._computer.lane = t, this._hoverOperation.start(0));
  }
  hide() {
    this._computer.lineNumber = -1, this._hoverOperation.cancel(), this._isVisible && (this._isVisible = !1, this._hover.containerDomNode.classList.toggle("hidden", !this._isVisible));
  }
  _withResult(e) {
    this._messages = e, this._messages.length > 0 ? this._renderMessages(this._computer.lineNumber, this._messages) : this.hide();
  }
  _renderMessages(e, t) {
    this._renderDisposeables.clear();
    const n = document.createDocumentFragment();
    for (const s of t) {
      const o = M6("div.hover-row.markdown-hover"), r = Z(o, M6("div.hover-contents")), a = this._renderDisposeables.add(this._markdownRenderer.render(s.value));
      r.appendChild(a.element), n.appendChild(o);
    }
    this._updateContents(n), this._showAt(e);
  }
  _updateContents(e) {
    this._hover.contentsDomNode.textContent = "", this._hover.contentsDomNode.appendChild(e), this._updateFont();
  }
  _showAt(e) {
    this._isVisible || (this._isVisible = !0, this._hover.containerDomNode.classList.toggle("hidden", !this._isVisible));
    const t = this._editor.getLayoutInfo(), n = this._editor.getTopForLineNumber(e), s = this._editor.getScrollTop(), o = this._editor.getOption(67), r = n - s - (this._hover.containerDomNode.clientHeight - o) / 2, a = t.glyphMarginLeft + t.glyphMarginWidth + (this._computer.lane === "lineNo" ? t.lineNumbersWidth : 0);
    this._hover.containerDomNode.style.left = `${a}px`, this._hover.containerDomNode.style.top = `${Math.max(Math.round(r), 0)}px`;
  }
}
km.ID = "editor.contrib.modesGlyphHoverWidget";
class mae {
  get lineNumber() {
    return this._lineNumber;
  }
  set lineNumber(e) {
    this._lineNumber = e;
  }
  get lane() {
    return this._laneOrLine;
  }
  set lane(e) {
    this._laneOrLine = e;
  }
  constructor(e) {
    this._editor = e, this._lineNumber = -1, this._laneOrLine = _l.Center;
  }
  computeSync() {
    var e, t;
    const n = (a) => ({ value: a }), s = this._editor.getLineDecorations(this._lineNumber), o = [], r = this._laneOrLine === "lineNo";
    if (!s) return o;
    for (const a of s) {
      const l = (t = (e = a.options.glyphMargin) === null || e === void 0 ? void 0 : e.position) !== null && t !== void 0 ? t : _l.Center;
      if (!r && l !== this._laneOrLine) continue;
      const d = r ? a.options.lineNumberHoverMessage : a.options.glyphMarginHoverMessage;
      d && !$m(d) && o.push(...KT(d).map(n));
    }
    return o;
  }
}
class fae {
  constructor(e, t, n) {
    this.provider = e, this.hover = t, this.ordinal = n;
  }
}
function yP(i, e, t, n) {
  const s = i.ordered(e).map((o, r) => async function(a, l, d, h, c) {
    try {
      const u = await Promise.resolve(a.provideHover(d, h, c));
      if (u && function(g) {
        const p = g.range !== void 0, f = g.contents !== void 0 && g.contents && g.contents.length > 0;
        return p && f;
      }(u)) return new fae(a, u, l);
    } catch (u) {
      Ni(u);
    }
  }(o, r, e, t, n));
  return Pi.fromPromises(s).coalesce();
}
qa("_executeHoverProvider", (i, e, t) => function(n, s, o, r) {
  return yP(n, s, o, r).map((a) => a.hover).toPromise();
}(i.get(fe).hoverProvider, e, t, et.None));
var _ae = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Jb = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const T6 = Q;
class Jr {
  constructor(e, t, n, s, o) {
    this.owner = e, this.range = t, this.contents = n, this.isBeforeContent = s, this.ordinal = o;
  }
  isValidForHoverAnchor(e) {
    return e.type === 1 && this.range.startColumn <= e.range.startColumn && this.range.endColumn >= e.range.endColumn;
  }
}
let vS = class {
  constructor(i, e, t, n, s) {
    this._editor = i, this._languageService = e, this._openerService = t, this._configurationService = n, this._languageFeaturesService = s, this.hoverOrdinal = 3;
  }
  createLoadingMessage(i) {
    return new Jr(this, i.range, [new Vn().appendText(m(0, "Loading..."))], !1, 2e3);
  }
  computeSync(i, e) {
    if (!this._editor.hasModel() || i.type !== 1) return [];
    const t = this._editor.getModel(), n = i.range.startLineNumber, s = t.getLineMaxColumn(n), o = [];
    let r = 1e3;
    const a = t.getLineLength(n), l = t.getLanguageIdAtPosition(i.range.startLineNumber, i.range.startColumn), d = this._editor.getOption(117), h = this._configurationService.getValue("editor.maxTokenizationLineLength", { overrideIdentifier: l });
    let c = !1;
    d >= 0 && a > d && i.range.startColumn >= d && (c = !0, o.push(new Jr(this, i.range, [{ value: m(0, "Rendering paused for long line for performance reasons. This can be configured via `editor.stopRenderingLineAfter`.") }], !1, r++))), !c && typeof h == "number" && a >= h && o.push(new Jr(this, i.range, [{ value: m(0, "Tokenization is skipped for long lines for performance reasons. This can be configured via `editor.maxTokenizationLineLength`.") }], !1, r++));
    let u = !1;
    for (const g of e) {
      const p = g.range.startLineNumber === n ? g.range.startColumn : 1, f = g.range.endLineNumber === n ? g.range.endColumn : s, _ = g.options.hoverMessage;
      if (!_ || $m(_)) continue;
      g.options.beforeContentClassName && (u = !0);
      const v = new D(i.range.startLineNumber, p, i.range.startLineNumber, f);
      o.push(new Jr(this, v, KT(_), u, r++));
    }
    return o;
  }
  computeAsync(i, e, t) {
    if (!this._editor.hasModel() || i.type !== 1) return Pi.EMPTY;
    const n = this._editor.getModel();
    if (!this._languageFeaturesService.hoverProvider.has(n)) return Pi.EMPTY;
    const s = new W(i.range.startLineNumber, i.range.startColumn);
    return yP(this._languageFeaturesService.hoverProvider, n, s, t).filter((o) => !$m(o.hover.contents)).map((o) => {
      const r = o.hover.range ? D.lift(o.hover.range) : i.range;
      return new Jr(this, r, o.hover.contents, !1, o.ordinal);
    });
  }
  renderHoverParts(i, e) {
    return Lz(i, e, this._editor, this._languageService, this._openerService);
  }
};
function Lz(i, e, t, n, s) {
  e.sort((r, a) => r.ordinal - a.ordinal);
  const o = new G();
  for (const r of e) for (const a of r.contents) {
    if ($m(a)) continue;
    const l = T6("div.hover-row.markdown-hover"), d = Z(l, T6("div.hover-contents")), h = o.add(new ml({ editor: t }, n, s));
    o.add(h.onDidRenderAsync(() => {
      d.className = "hover-contents code-hover-contents", i.onContentsChanged();
    }));
    const c = o.add(h.render(a));
    d.appendChild(c.element), i.fragment.appendChild(l);
  }
  return o;
}
vS = _ae([Jb(1, Xt), Jb(2, Fs), Jb(3, Ye), Jb(4, fe)], vS);
var kz = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, bS = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class R6 {
  constructor(e, t, n) {
    this.marker = e, this.index = t, this.total = n;
  }
}
let LM = class {
  constructor(i, e, t) {
    this._markerService = e, this._configService = t, this._onDidChange = new F(), this.onDidChange = this._onDidChange.event, this._dispoables = new G(), this._markers = [], this._nextIdx = -1, Ie.isUri(i) ? this._resourceFilter = (r) => r.toString() === i.toString() : i && (this._resourceFilter = i);
    const n = this._configService.getValue("problems.sortOrder"), s = (r, a) => {
      let l = Q0(r.resource.toString(), a.resource.toString());
      return l === 0 && (l = n === "position" ? D.compareRangesUsingStarts(r, a) || pi.compare(r.severity, a.severity) : pi.compare(r.severity, a.severity) || D.compareRangesUsingStarts(r, a)), l;
    }, o = () => {
      this._markers = this._markerService.read({ resource: Ie.isUri(i) ? i : void 0, severities: pi.Error | pi.Warning | pi.Info }), typeof i == "function" && (this._markers = this._markers.filter((r) => this._resourceFilter(r.resource))), this._markers.sort(s);
    };
    o(), this._dispoables.add(e.onMarkerChanged((r) => {
      this._resourceFilter && !r.some((a) => this._resourceFilter(a)) || (o(), this._nextIdx = -1, this._onDidChange.fire());
    }));
  }
  dispose() {
    this._dispoables.dispose(), this._onDidChange.dispose();
  }
  matches(i) {
    return !this._resourceFilter && !i || !(!this._resourceFilter || !i) && this._resourceFilter(i);
  }
  get selected() {
    const i = this._markers[this._nextIdx];
    return i && new R6(i, this._nextIdx + 1, this._markers.length);
  }
  _initIdx(i, e, t) {
    let n = !1, s = this._markers.findIndex((o) => o.resource.toString() === i.uri.toString());
    s < 0 && (s = U0(this._markers, { resource: i.uri }, (o, r) => Q0(o.resource.toString(), r.resource.toString())), s < 0 && (s = ~s));
    for (let o = s; o < this._markers.length; o++) {
      let r = D.lift(this._markers[o]);
      if (r.isEmpty()) {
        const a = i.getWordAtPosition(r.getStartPosition());
        a && (r = new D(r.startLineNumber, a.startColumn, r.startLineNumber, a.endColumn));
      }
      if (e && (r.containsPosition(e) || e.isBeforeOrEqual(r.getStartPosition()))) {
        this._nextIdx = o, n = !0;
        break;
      }
      if (this._markers[o].resource.toString() !== i.uri.toString()) break;
    }
    n || (this._nextIdx = t ? 0 : this._markers.length - 1), this._nextIdx < 0 && (this._nextIdx = this._markers.length - 1);
  }
  resetIndex() {
    this._nextIdx = -1;
  }
  move(i, e, t) {
    if (this._markers.length === 0) return !1;
    const n = this._nextIdx;
    return this._nextIdx === -1 ? this._initIdx(e, t, i) : i ? this._nextIdx = (this._nextIdx + 1) % this._markers.length : i || (this._nextIdx = (this._nextIdx - 1 + this._markers.length) % this._markers.length), n !== this._nextIdx;
  }
  find(i, e) {
    let t = this._markers.findIndex((n) => n.resource.toString() === i.toString());
    if (!(t < 0)) {
      for (; t < this._markers.length; t++) if (D.containsPosition(this._markers[t], e)) return new R6(this._markers[t], t + 1, this._markers.length);
    }
  }
};
LM = kz([bS(1, kl), bS(2, Ye)], LM);
const Dz = tt("IMarkerNavigationService");
let Rx = class {
  constructor(i, e) {
    this._markerService = i, this._configService = e, this._provider = new fs();
  }
  getMarkerList(i) {
    for (const e of this._provider) {
      const t = e.getMarkerList(i);
      if (t) return t;
    }
    return new LM(i, this._markerService, this._configService);
  }
};
var kM;
Rx = kz([bS(0, kl), bS(1, Ye)], Rx), rt(Dz, Rx, 1), function(i) {
  i.className = function(e) {
    switch (e) {
      case ki.Ignore:
        return "severity-ignore " + Ee.asClassName(ne.info);
      case ki.Info:
        return Ee.asClassName(ne.info);
      case ki.Warning:
        return Ee.asClassName(ne.warning);
      case ki.Error:
        return Ee.asClassName(ne.error);
      default:
        return "";
    }
  };
}(kM || (kM = {}));
var DM, vae = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, np = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class bae {
  constructor(e, t, n, s, o) {
    this._openerService = s, this._labelService = o, this._lines = 0, this._longestLineLength = 0, this._relatedDiagnostics = /* @__PURE__ */ new WeakMap(), this._disposables = new G(), this._editor = t;
    const r = document.createElement("div");
    r.className = "descriptioncontainer", this._messageBlock = document.createElement("div"), this._messageBlock.classList.add("message"), this._messageBlock.setAttribute("aria-live", "assertive"), this._messageBlock.setAttribute("role", "alert"), r.appendChild(this._messageBlock), this._relatedBlock = document.createElement("div"), r.appendChild(this._relatedBlock), this._disposables.add(bi(this._relatedBlock, "click", (a) => {
      a.preventDefault();
      const l = this._relatedDiagnostics.get(a.target);
      l && n(l);
    })), this._scrollable = new LB(r, { horizontal: 1, vertical: 1, useShadows: !1, horizontalScrollbarSize: 6, verticalScrollbarSize: 6 }), e.appendChild(this._scrollable.getDomNode()), this._disposables.add(this._scrollable.onScroll((a) => {
      r.style.left = `-${a.scrollLeft}px`, r.style.top = `-${a.scrollTop}px`;
    })), this._disposables.add(this._scrollable);
  }
  dispose() {
    Ht(this._disposables);
  }
  update(e) {
    const { source: t, message: n, relatedInformation: s, code: o } = e;
    let r = ((t == null ? void 0 : t.length) || 0) + 2;
    o && (r += typeof o == "string" ? o.length : o.value.length);
    const a = Sl(n);
    this._lines = a.length, this._longestLineLength = 0;
    for (const u of a) this._longestLineLength = Math.max(u.length + r, this._longestLineLength);
    Un(this._messageBlock), this._messageBlock.setAttribute("aria-label", this.getAriaLabel(e)), this._editor.applyFontInfo(this._messageBlock);
    let l = this._messageBlock;
    for (const u of a) l = document.createElement("div"), l.innerText = u, u === "" && (l.style.height = this._messageBlock.style.lineHeight), this._messageBlock.appendChild(l);
    if (t || o) {
      const u = document.createElement("span");
      if (u.classList.add("details"), l.appendChild(u), t) {
        const g = document.createElement("span");
        g.innerText = t, g.classList.add("source"), u.appendChild(g);
      }
      if (o) if (typeof o == "string") {
        const g = document.createElement("span");
        g.innerText = `(${o})`, g.classList.add("code"), u.appendChild(g);
      } else
        this._codeLink = Q("a.code-link"), this._codeLink.setAttribute("href", `${o.target.toString()}`), this._codeLink.onclick = (g) => {
          this._openerService.open(o.target, { allowCommands: !0 }), g.preventDefault(), g.stopPropagation();
        }, Z(this._codeLink, Q("span")).innerText = o.value, u.appendChild(this._codeLink);
    }
    if (Un(this._relatedBlock), this._editor.applyFontInfo(this._relatedBlock), zn(s)) {
      const u = this._relatedBlock.appendChild(document.createElement("div"));
      u.style.paddingTop = `${Math.floor(0.66 * this._editor.getOption(67))}px`, this._lines += 1;
      for (const g of s) {
        const p = document.createElement("div"), f = document.createElement("a");
        f.classList.add("filename"), f.innerText = `${this._labelService.getUriBasenameLabel(g.resource)}(${g.startLineNumber}, ${g.startColumn}): `, f.title = this._labelService.getUriLabel(g.resource), this._relatedDiagnostics.set(f, g);
        const _ = document.createElement("span");
        _.innerText = g.message, p.appendChild(f), p.appendChild(_), this._lines += 1, u.appendChild(p);
      }
    }
    const d = this._editor.getOption(50), h = Math.ceil(d.typicalFullwidthCharacterWidth * this._longestLineLength * 0.75), c = d.lineHeight * this._lines;
    this._scrollable.setScrollDimensions({ scrollWidth: h, scrollHeight: c });
  }
  layout(e, t) {
    this._scrollable.getDomNode().style.height = `${e}px`, this._scrollable.getDomNode().style.width = `${t}px`, this._scrollable.setScrollDimensions({ width: t, height: e });
  }
  getHeightInLines() {
    return Math.min(17, this._lines);
  }
  getAriaLabel(e) {
    let t = "";
    switch (e.severity) {
      case pi.Error:
        t = m(0, "Error");
        break;
      case pi.Warning:
        t = m(0, "Warning");
        break;
      case pi.Info:
        t = m(0, "Info");
        break;
      case pi.Hint:
        t = m(0, "Hint");
    }
    let n = m(0, "{0} at {1}. ", t, e.startLineNumber + ":" + e.startColumn);
    const s = this._editor.getModel();
    return s && e.startLineNumber <= s.getLineCount() && e.startLineNumber >= 1 && (n = `${s.getLineContent(e.startLineNumber)}, ${n}`), n;
  }
}
let Dm = DM = class extends pS {
  constructor(i, e, t, n, s, o, r) {
    super(i, { showArrow: !0, showFrame: !0, isAccessible: !0, frameWidth: 1 }, s), this._themeService = e, this._openerService = t, this._menuService = n, this._contextKeyService = o, this._labelService = r, this._callOnDispose = new G(), this._onDidSelectRelatedInformation = new F(), this.onDidSelectRelatedInformation = this._onDidSelectRelatedInformation.event, this._severity = pi.Warning, this._backgroundColor = z.white, this._applyTheme(e.getColorTheme()), this._callOnDispose.add(e.onDidColorThemeChange(this._applyTheme.bind(this))), this.create();
  }
  _applyTheme(i) {
    this._backgroundColor = i.getColor(Sae);
    let e = xM, t = Cae;
    this._severity === pi.Warning ? (e = _w, t = wae) : this._severity === pi.Info && (e = NM, t = yae);
    const n = i.getColor(e), s = i.getColor(t);
    this.style({ arrowColor: n, frameColor: n, headerBackgroundColor: s, primaryHeadingColor: i.getColor(fz), secondaryHeadingColor: i.getColor(_z) });
  }
  _applyStyles() {
    this._parentContainer && (this._parentContainer.style.backgroundColor = this._backgroundColor ? this._backgroundColor.toString() : ""), super._applyStyles();
  }
  dispose() {
    this._callOnDispose.dispose(), super.dispose();
  }
  _fillHead(i) {
    super._fillHead(i), this._disposables.add(this._actionbarWidget.actionRunner.onWillRun((n) => this.editor.focus()));
    const e = [], t = this._menuService.createMenu(DM.TitleMenu, this._contextKeyService);
    ML(t, void 0, e), this._actionbarWidget.push(e, { label: !1, icon: !0, index: 0 }), t.dispose();
  }
  _fillTitleIcon(i) {
    this._icon = Z(i, Q(""));
  }
  _fillBody(i) {
    this._parentContainer = i, i.classList.add("marker-widget"), this._parentContainer.tabIndex = 0, this._parentContainer.setAttribute("role", "tooltip"), this._container = document.createElement("div"), i.appendChild(this._container), this._message = new bae(this._container, this.editor, (e) => this._onDidSelectRelatedInformation.fire(e), this._openerService, this._labelService), this._disposables.add(this._message);
  }
  show() {
    throw new Error("call showAtMarker");
  }
  showAtMarker(i, e, t) {
    this._container.classList.remove("stale"), this._message.update(i), this._severity = i.severity, this._applyTheme(this._themeService.getColorTheme());
    const n = D.lift(i), s = this.editor.getPosition(), o = s && n.containsPosition(s) ? s : n.getStartPosition();
    super.show(o, this.computeRequiredHeight());
    const r = this.editor.getModel();
    if (r) {
      const a = m(0, t > 1 ? "{0} of {1} problems" : "{0} of {1} problem", e, t);
      this.setTitle(ir(r.uri), a);
    }
    this._icon.className = `codicon ${kM.className(pi.toSeverity(this._severity))}`, this.editor.revealPositionNearTop(o, 0), this.editor.focus();
  }
  updateMarker(i) {
    this._container.classList.remove("stale"), this._message.update(i);
  }
  showStale() {
    this._container.classList.add("stale"), this._relayout();
  }
  _doLayoutBody(i, e) {
    super._doLayoutBody(i, e), this._heightInPixel = i, this._message.layout(i, e), this._container.style.height = `${i}px`;
  }
  _onWidth(i) {
    this._message.layout(this._heightInPixel, i);
  }
  _relayout() {
    super._relayout(this.computeRequiredHeight());
  }
  computeRequiredHeight() {
    return 3 + this._message.getHeightInLines();
  }
};
Dm.TitleMenu = new x("gotoErrorTitleMenu"), Dm = DM = vae([np(1, Yi), np(2, Fs), np(3, Mo), np(4, Se), np(5, Te), np(6, Zm)], Dm);
const A6 = uv(ol, f$), P6 = uv(Qn, gv), O6 = uv(Rs, pv), xM = I("editorMarkerNavigationError.background", { dark: A6, light: A6, hcDark: ot, hcLight: ot }, m(0, "Editor marker navigation widget error color.")), Cae = I("editorMarkerNavigationError.headerBackground", { dark: Ce(xM, 0.1), light: Ce(xM, 0.1), hcDark: null, hcLight: null }, m(0, "Editor marker navigation widget error heading background.")), _w = I("editorMarkerNavigationWarning.background", { dark: P6, light: P6, hcDark: ot, hcLight: ot }, m(0, "Editor marker navigation widget warning color.")), wae = I("editorMarkerNavigationWarning.headerBackground", { dark: Ce(_w, 0.1), light: Ce(_w, 0.1), hcDark: "#0C141F", hcLight: Ce(_w, 0.2) }, m(0, "Editor marker navigation widget warning heading background.")), NM = I("editorMarkerNavigationInfo.background", { dark: O6, light: O6, hcDark: ot, hcLight: ot }, m(0, "Editor marker navigation widget info color.")), yae = I("editorMarkerNavigationInfo.headerBackground", { dark: Ce(NM, 0.1), light: Ce(NM, 0.1), hcDark: null, hcLight: null }, m(0, "Editor marker navigation widget info heading background.")), Sae = I("editorMarkerNavigation.background", { dark: sn, light: sn, hcDark: sn, hcLight: sn }, m(0, "Editor marker navigation widget background."));
var W_, Lae = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, eC = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let dc = W_ = class {
  static get(i) {
    return i.getContribution(W_.ID);
  }
  constructor(i, e, t, n, s) {
    this._markerNavigationService = e, this._contextKeyService = t, this._editorService = n, this._instantiationService = s, this._sessionDispoables = new G(), this._editor = i, this._widgetVisible = xz.bindTo(this._contextKeyService);
  }
  dispose() {
    this._cleanUp(), this._sessionDispoables.dispose();
  }
  _cleanUp() {
    this._widgetVisible.reset(), this._sessionDispoables.clear(), this._widget = void 0, this._model = void 0;
  }
  _getOrCreateModel(i) {
    if (this._model && this._model.matches(i)) return this._model;
    let e = !1;
    return this._model && (e = !0, this._cleanUp()), this._model = this._markerNavigationService.getMarkerList(i), e && this._model.move(!0, this._editor.getModel(), this._editor.getPosition()), this._widget = this._instantiationService.createInstance(Dm, this._editor), this._widget.onDidClose(() => this.close(), this, this._sessionDispoables), this._widgetVisible.set(!0), this._sessionDispoables.add(this._model), this._sessionDispoables.add(this._widget), this._sessionDispoables.add(this._editor.onDidChangeCursorPosition((t) => {
      var n, s, o;
      !((n = this._model) === null || n === void 0) && n.selected && D.containsPosition((s = this._model) === null || s === void 0 ? void 0 : s.selected.marker, t.position) || (o = this._model) === null || o === void 0 || o.resetIndex();
    })), this._sessionDispoables.add(this._model.onDidChange(() => {
      if (!this._widget || !this._widget.position || !this._model) return;
      const t = this._model.find(this._editor.getModel().uri, this._widget.position);
      t ? this._widget.updateMarker(t.marker) : this._widget.showStale();
    })), this._sessionDispoables.add(this._widget.onDidSelectRelatedInformation((t) => {
      this._editorService.openCodeEditor({ resource: t.resource, options: { pinned: !0, revealIfOpened: !0, selection: D.lift(t).collapseToStart() } }, this._editor), this.close(!1);
    })), this._sessionDispoables.add(this._editor.onDidChangeModel(() => this._cleanUp())), this._model;
  }
  close(i = !0) {
    this._cleanUp(), i && this._editor.focus();
  }
  showAtMarker(i) {
    if (this._editor.hasModel()) {
      const e = this._getOrCreateModel(this._editor.getModel().uri);
      e.resetIndex(), e.move(!0, this._editor.getModel(), new W(i.startLineNumber, i.startColumn)), e.selected && this._widget.showAtMarker(e.selected.marker, e.selected.index, e.selected.total);
    }
  }
  async nagivate(i, e) {
    var t, n;
    if (this._editor.hasModel()) {
      const s = this._getOrCreateModel(e ? void 0 : this._editor.getModel().uri);
      if (s.move(i, this._editor.getModel(), this._editor.getPosition()), !s.selected) return;
      if (s.selected.marker.resource.toString() !== this._editor.getModel().uri.toString()) {
        this._cleanUp();
        const o = await this._editorService.openCodeEditor({ resource: s.selected.marker.resource, options: { pinned: !1, revealIfOpened: !0, selectionRevealType: 2, selection: s.selected.marker } }, this._editor);
        o && ((t = W_.get(o)) === null || t === void 0 || t.close(), (n = W_.get(o)) === null || n === void 0 || n.nagivate(i, e));
      } else this._widget.showAtMarker(s.selected.marker, s.selected.index, s.selected.total);
    }
  }
};
dc.ID = "editor.contrib.markerController", dc = W_ = Lae([eC(1, Dz), eC(2, Te), eC(3, mt), eC(4, Se)], dc);
class CS extends he {
  constructor(e, t, n) {
    super(n), this._next = e, this._multiFile = t;
  }
  async run(e, t) {
    var n;
    t.hasModel() && ((n = dc.get(t)) === null || n === void 0 || n.nagivate(this._next, this._multiFile));
  }
}
class hc extends CS {
  constructor() {
    super(!0, !1, { id: hc.ID, label: hc.LABEL, alias: "Go to Next Problem (Error, Warning, Info)", precondition: void 0, kbOpts: { kbExpr: E.focus, primary: 578, weight: 100 }, menuOpts: { menuId: Dm.TitleMenu, title: hc.LABEL, icon: Ei("marker-navigation-next", ne.arrowDown, m(0, "Icon for goto next marker.")), group: "navigation", order: 1 } });
  }
}
hc.ID = "editor.action.marker.next", hc.LABEL = m(0, "Go to Next Problem (Error, Warning, Info)");
class Qu extends CS {
  constructor() {
    super(!1, !1, { id: Qu.ID, label: Qu.LABEL, alias: "Go to Previous Problem (Error, Warning, Info)", precondition: void 0, kbOpts: { kbExpr: E.focus, primary: 1602, weight: 100 }, menuOpts: { menuId: Dm.TitleMenu, title: Qu.LABEL, icon: Ei("marker-navigation-previous", ne.arrowUp, m(0, "Icon for goto previous marker.")), group: "navigation", order: 2 } });
  }
}
Qu.ID = "editor.action.marker.prev", Qu.LABEL = m(0, "Go to Previous Problem (Error, Warning, Info)");
ft(dc.ID, dc, 4), X(hc), X(Qu), X(class extends CS {
  constructor() {
    super(!0, !0, { id: "editor.action.marker.nextInFiles", label: m(0, "Go to Next Problem in Files (Error, Warning, Info)"), alias: "Go to Next Problem in Files (Error, Warning, Info)", precondition: void 0, kbOpts: { kbExpr: E.focus, primary: 66, weight: 100 }, menuOpts: { menuId: x.MenubarGoMenu, title: m(0, "Next &&Problem"), group: "6_problem_nav", order: 1 } });
  }
}), X(class extends CS {
  constructor() {
    super(!1, !0, { id: "editor.action.marker.prevInFiles", label: m(0, "Go to Previous Problem in Files (Error, Warning, Info)"), alias: "Go to Previous Problem in Files (Error, Warning, Info)", precondition: void 0, kbOpts: { kbExpr: E.focus, primary: 1090, weight: 100 }, menuOpts: { menuId: x.MenubarGoMenu, title: m(0, "Previous &&Problem"), group: "6_problem_nav", order: 2 } });
  }
});
const xz = new ae("markersNavigationVisible", !1);
re(new (Zi.bindToContribution(dc.get))({ id: "closeMarkersNavigation", precondition: xz, handler: (i) => i.close(), kbOpts: { weight: 150, kbExpr: E.focus, primary: 9, secondary: [1033] } }));
var kae = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Ax = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const lr = Q;
class Dae {
  constructor(e, t, n) {
    this.owner = e, this.range = t, this.marker = n;
  }
  isValidForHoverAnchor(e) {
    return e.type === 1 && this.range.startColumn <= e.range.startColumn && this.range.endColumn >= e.range.endColumn;
  }
}
const F6 = { type: 1, filter: { include: ti.QuickFix }, triggerAction: qs.QuickFixHover };
let EM = class {
  constructor(i, e, t, n) {
    this._editor = i, this._markerDecorationsService = e, this._openerService = t, this._languageFeaturesService = n, this.hoverOrdinal = 1, this.recentMarkerCodeActionsInfo = void 0;
  }
  computeSync(i, e) {
    if (!this._editor.hasModel() || i.type !== 1 && !i.supportsMarkerHover) return [];
    const t = this._editor.getModel(), n = i.range.startLineNumber, s = t.getLineMaxColumn(n), o = [];
    for (const r of e) {
      const a = r.range.startLineNumber === n ? r.range.startColumn : 1, l = r.range.endLineNumber === n ? r.range.endColumn : s, d = this._markerDecorationsService.getMarker(t.uri, r);
      if (!d) continue;
      const h = new D(i.range.startLineNumber, a, i.range.startLineNumber, l);
      o.push(new Dae(this, h, d));
    }
    return o;
  }
  renderHoverParts(i, e) {
    if (!e.length) return V.None;
    const t = new G();
    e.forEach((s) => i.fragment.appendChild(this.renderMarkerHover(s, t)));
    const n = e.length === 1 ? e[0] : e.sort((s, o) => pi.compare(s.marker.severity, o.marker.severity))[0];
    return this.renderMarkerStatusbar(i, n, t), t;
  }
  renderMarkerHover(i, e) {
    const t = lr("div.hover-row"), n = Z(t, lr("div.marker.hover-contents")), { source: s, message: o, code: r, relatedInformation: a } = i.marker;
    this._editor.applyFontInfo(n);
    const l = Z(n, lr("span"));
    if (l.style.whiteSpace = "pre-wrap", l.innerText = o, s || r) if (r && typeof r != "string") {
      const d = lr("span");
      s && (Z(d, lr("span")).innerText = s);
      const h = Z(d, lr("a.code-link"));
      h.setAttribute("href", r.target.toString()), e.add(K(h, "click", (u) => {
        this._openerService.open(r.target, { allowCommands: !0 }), u.preventDefault(), u.stopPropagation();
      })), Z(h, lr("span")).innerText = r.value;
      const c = Z(n, d);
      c.style.opacity = "0.6", c.style.paddingLeft = "6px";
    } else {
      const d = Z(n, lr("span"));
      d.style.opacity = "0.6", d.style.paddingLeft = "6px", d.innerText = s && r ? `${s}(${r})` : s || `(${r})`;
    }
    if (zn(a)) for (const { message: d, resource: h, startLineNumber: c, startColumn: u } of a) {
      const g = Z(n, lr("div"));
      g.style.marginTop = "8px";
      const p = Z(g, lr("a"));
      p.innerText = `${ir(h)}(${c}, ${u}): `, p.style.cursor = "pointer", e.add(K(p, "click", (_) => {
        _.stopPropagation(), _.preventDefault(), this._openerService && this._openerService.open(h, { fromUserGesture: !0, editorOptions: { selection: { startLineNumber: c, startColumn: u } } }).catch(We);
      }));
      const f = Z(g, lr("span"));
      f.innerText = d, this._editor.applyFontInfo(f);
    }
    return t;
  }
  renderMarkerStatusbar(i, e, t) {
    if (e.marker.severity === pi.Error || e.marker.severity === pi.Warning || e.marker.severity === pi.Info) {
      const n = dc.get(this._editor);
      n && i.statusBar.addAction({ label: m(0, "View Problem"), commandId: hc.ID, run: () => {
        i.hide(), n.showAtMarker(e.marker), this._editor.focus();
      } });
    }
    if (!this._editor.getOption(91)) {
      const n = i.statusBar.append(lr("div"));
      this.recentMarkerCodeActionsInfo && (Uy.makeKey(this.recentMarkerCodeActionsInfo.marker) === Uy.makeKey(e.marker) ? this.recentMarkerCodeActionsInfo.hasCodeActions || (n.textContent = m(0, "No quick fixes available")) : this.recentMarkerCodeActionsInfo = void 0);
      const s = this.recentMarkerCodeActionsInfo && !this.recentMarkerCodeActionsInfo.hasCodeActions ? V.None : Cc(() => n.textContent = m(0, "Checking for quick fixes..."), 200, t);
      n.textContent || (n.textContent = " ");
      const o = this.getCodeActions(e.marker);
      t.add(ye(() => o.cancel())), o.then((r) => {
        if (s.dispose(), this.recentMarkerCodeActionsInfo = { marker: e.marker, hasCodeActions: r.validActions.length > 0 }, !this.recentMarkerCodeActionsInfo.hasCodeActions) return r.dispose(), void (n.textContent = m(0, "No quick fixes available"));
        n.style.display = "none";
        let a = !1;
        t.add(ye(() => {
          a || r.dispose();
        })), i.statusBar.addAction({ label: m(0, "Quick Fix..."), commandId: fP, run: (l) => {
          a = !0;
          const d = Uh.get(this._editor), h = Ti(l);
          i.hide(), d == null || d.showCodeActions(F6, r, { x: h.left, y: h.top, width: h.width, height: h.height });
        } });
      }, We);
    }
  }
  getCodeActions(i) {
    return on((e) => D0(this._languageFeaturesService.codeActionProvider, this._editor.getModel(), new D(i.startLineNumber, i.startColumn, i.endLineNumber, i.endColumn), F6, Nd.None, e));
  }
};
EM = kae([Ax(1, AR), Ax(2, Fs), Ax(3, fe)], EM);
const Nz = "editor.action.inlineSuggest.commit", Ez = "editor.action.inlineSuggest.showPrevious", Iz = "editor.action.inlineSuggest.showNext";
var vw, SP = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, ea = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let IM = class extends V {
  constructor(i, e, t) {
    super(), this.editor = i, this.model = e, this.instantiationService = t, this.alwaysShowToolbar = Rt(this.editor.onDidChangeConfiguration, () => this.editor.getOption(62).showToolbar === "always"), this.sessionPosition = void 0, this.position = Fe(this, (n) => {
      var s, o, r;
      const a = (s = this.model.read(n)) === null || s === void 0 ? void 0 : s.primaryGhostText.read(n);
      if (!this.alwaysShowToolbar.read(n) || !a || a.parts.length === 0) return this.sessionPosition = void 0, null;
      const l = a.parts[0].column;
      this.sessionPosition && this.sessionPosition.lineNumber !== a.lineNumber && (this.sessionPosition = void 0);
      const d = new W(a.lineNumber, Math.min(l, (r = (o = this.sessionPosition) === null || o === void 0 ? void 0 : o.column) !== null && r !== void 0 ? r : Number.MAX_SAFE_INTEGER));
      return this.sessionPosition = d, d;
    }), this._register(nr((n, s) => {
      const o = this.model.read(n);
      if (!o || !this.alwaysShowToolbar.read(n)) return;
      const r = s.add(this.instantiationService.createInstance(qh, this.editor, !0, this.position, o.selectedInlineCompletionIndex, o.inlineCompletionsCount, o.selectedInlineCompletion.map((a) => {
        var l;
        return (l = a == null ? void 0 : a.inlineCompletion.source.inlineCompletions.commands) !== null && l !== void 0 ? l : [];
      })));
      i.addContentWidget(r), s.add(ye(() => i.removeContentWidget(r))), s.add(Ge((a) => {
        this.position.read(a) && o.lastTriggerKind.read(a) !== Ld.Explicit && o.triggerExplicitly();
      }));
    }));
  }
};
IM = SP([ea(2, Se)], IM);
const xae = Ei("inline-suggestion-hints-next", ne.chevronRight, m(0, "Icon for show next parameter hint.")), Nae = Ei("inline-suggestion-hints-previous", ne.chevronLeft, m(0, "Icon for show previous parameter hint."));
let qh = vw = class extends V {
  static get dropDownVisible() {
    return this._dropDownVisible;
  }
  createCommandAction(i, e, t) {
    const n = new Qs(i, e, t, !0, () => this._commandService.executeCommand(i)), s = this.keybindingService.lookupKeybinding(i, this._contextKeyService);
    let o = e;
    return s && (o = m(0, "{0} ({1})", e, s.getLabel())), n.tooltip = o, n;
  }
  constructor(i, e, t, n, s, o, r, a, l, d, h) {
    super(), this.editor = i, this.withBorder = e, this._position = t, this._currentSuggestionIdx = n, this._suggestionCount = s, this._extraCommands = o, this._commandService = r, this.keybindingService = l, this._contextKeyService = d, this._menuService = h, this.id = "InlineSuggestionHintsContentWidget" + vw.id++, this.allowEditorOverflow = !0, this.suppressMouseDown = !1, this.nodes = yt("div.inlineSuggestionsHints", { className: this.withBorder ? ".withBorder" : "" }, [yt("div@toolBar")]), this.previousAction = this.createCommandAction(Ez, m(0, "Previous"), Ee.asClassName(Nae)), this.availableSuggestionCountAction = new Qs("inlineSuggestionHints.availableSuggestionCount", "", void 0, !1), this.nextAction = this.createCommandAction(Iz, m(0, "Next"), Ee.asClassName(xae)), this.inlineCompletionsActionsMenus = this._register(this._menuService.createMenu(x.InlineCompletionsActions, this._contextKeyService)), this.clearAvailableSuggestionCountLabelDebounced = this._register(new It(() => {
      this.availableSuggestionCountAction.label = "";
    }, 100)), this.disableButtonsDebounced = this._register(new It(() => {
      this.previousAction.enabled = this.nextAction.enabled = !1;
    }, 100)), this.lastCommands = [], this.toolBar = this._register(a.createInstance(MM, this.nodes.toolBar, x.InlineSuggestionToolbar, { menuOptions: { renderShortTitle: !0 }, toolbarOptions: { primaryGroup: (c) => c.startsWith("primary") }, actionViewItemProvider: (c, u) => {
      if (c instanceof Eo) return a.createInstance(Iae, c, void 0);
      if (c === this.availableSuggestionCountAction) {
        const g = new Eae(void 0, c, { label: !0, icon: !1 });
        return g.setClass("availableSuggestionCount"), g;
      }
    }, telemetrySource: "InlineSuggestionToolbar" })), this.toolBar.setPrependedPrimaryActions([this.previousAction, this.availableSuggestionCountAction, this.nextAction]), this._register(this.toolBar.onDidChangeDropdownVisibility((c) => {
      vw._dropDownVisible = c;
    })), this._register(Ge((c) => {
      this._position.read(c), this.editor.layoutContentWidget(this);
    })), this._register(Ge((c) => {
      const u = this._suggestionCount.read(c), g = this._currentSuggestionIdx.read(c);
      u !== void 0 ? (this.clearAvailableSuggestionCountLabelDebounced.cancel(), this.availableSuggestionCountAction.label = `${g + 1}/${u}`) : this.clearAvailableSuggestionCountLabelDebounced.schedule(), u !== void 0 && u > 1 ? (this.disableButtonsDebounced.cancel(), this.previousAction.enabled = this.nextAction.enabled = !0) : this.disableButtonsDebounced.schedule();
    })), this._register(Ge((c) => {
      const u = this._extraCommands.read(c);
      if (ri(this.lastCommands, u)) return;
      this.lastCommands = u;
      const g = u.map((p) => ({ class: void 0, id: p.id, enabled: !0, tooltip: p.tooltip || "", label: p.title, run: (f) => this._commandService.executeCommand(p.id) }));
      for (const [p, f] of this.inlineCompletionsActionsMenus.getActions()) for (const _ of f) _ instanceof Eo && g.push(_);
      g.length > 0 && g.unshift(new Ui()), this.toolBar.setAdditionalSecondaryActions(g);
    }));
  }
  getId() {
    return this.id;
  }
  getDomNode() {
    return this.nodes.root;
  }
  getPosition() {
    return { position: this._position.get(), preference: [1, 2], positionAffinity: 3 };
  }
};
qh._dropDownVisible = !1, qh.id = 0, qh = vw = SP([ea(6, ai), ea(7, Se), ea(8, Dt), ea(9, Te), ea(10, Mo)], qh);
class Eae extends ef {
  constructor() {
    super(...arguments), this._className = void 0;
  }
  setClass(e) {
    this._className = e;
  }
  render(e) {
    super.render(e), this._className && e.classList.add(this._className);
  }
  updateTooltip() {
  }
}
let Iae = class extends Ic {
  updateLabel() {
    const i = this._keybindingService.lookupKeybinding(this._action.id, this._contextKeyService);
    if (!i) return super.updateLabel();
    if (this.label) {
      const e = yt("div.keybinding").root;
      this._register(new yf(e, Gs, { disableTitle: !0, ...kV })).set(i), this.label.textContent = this._action.label, this.label.appendChild(e), this.label.classList.add("inlineSuggestionStatusBarItemLabel");
    }
  }
  updateTooltip() {
  }
}, MM = class extends Gv {
  constructor(i, e, t, n, s, o, r, a) {
    super(i, { resetMenu: e, ...t }, n, s, o, r, a), this.menuId = e, this.options2 = t, this.menuService = n, this.contextKeyService = s, this.menu = this._store.add(this.menuService.createMenu(this.menuId, this.contextKeyService, { emitEventsForSubmenuChanges: !0 })), this.additionalActions = [], this.prependedPrimaryActions = [], this._store.add(this.menu.onDidChange(() => this.updateToolbar())), this.updateToolbar();
  }
  updateToolbar() {
    var i, e, t, n, s, o, r;
    const a = [], l = [];
    ML(this.menu, (i = this.options2) === null || i === void 0 ? void 0 : i.menuOptions, { primary: a, secondary: l }, (t = (e = this.options2) === null || e === void 0 ? void 0 : e.toolbarOptions) === null || t === void 0 ? void 0 : t.primaryGroup, (s = (n = this.options2) === null || n === void 0 ? void 0 : n.toolbarOptions) === null || s === void 0 ? void 0 : s.shouldInlineSubmenu, (r = (o = this.options2) === null || o === void 0 ? void 0 : o.toolbarOptions) === null || r === void 0 ? void 0 : r.useSeparatorsInPrimaryActions), l.push(...this.additionalActions), a.unshift(...this.prependedPrimaryActions), this.setActions(a, l);
  }
  setPrependedPrimaryActions(i) {
    ri(this.prependedPrimaryActions, i, (e, t) => e === t) || (this.prependedPrimaryActions = i, this.updateToolbar());
  }
  setAdditionalSecondaryActions(i) {
    ri(this.additionalActions, i, (e, t) => e === t) || (this.additionalActions = i, this.updateToolbar());
  }
};
MM = SP([ea(3, Mo), ea(4, Te), ea(5, io), ea(6, Dt), ea(7, es)], MM);
var TM, Mae = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, tC = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let xs = TM = class extends V {
  constructor(i, e, t, n, s) {
    super(), this._editor = i, this._instantiationService = e, this._openerService = t, this._languageService = n, this._keybindingService = s, this._listenersStore = new G(), this._hoverState = { mouseDown: !1, contentHoverFocused: !1, activatedByDecoratorClick: !1 }, this._reactToEditorMouseMoveRunner = this._register(new It(() => this._reactToEditorMouseMove(this._mouseMoveEvent), 0)), this._hookListeners(), this._register(this._editor.onDidChangeConfiguration((o) => {
      o.hasChanged(60) && (this._unhookListeners(), this._hookListeners());
    }));
  }
  static get(i) {
    return i.getContribution(TM.ID);
  }
  _hookListeners() {
    const i = this._editor.getOption(60);
    this._hoverSettings = { enabled: i.enabled, sticky: i.sticky, hidingDelay: i.delay }, i.enabled ? (this._listenersStore.add(this._editor.onMouseDown((e) => this._onEditorMouseDown(e))), this._listenersStore.add(this._editor.onMouseUp(() => this._onEditorMouseUp())), this._listenersStore.add(this._editor.onMouseMove((e) => this._onEditorMouseMove(e))), this._listenersStore.add(this._editor.onKeyDown((e) => this._onKeyDown(e)))) : (this._listenersStore.add(this._editor.onMouseMove((e) => this._onEditorMouseMove(e))), this._listenersStore.add(this._editor.onKeyDown((e) => this._onKeyDown(e)))), this._listenersStore.add(this._editor.onMouseLeave((e) => this._onEditorMouseLeave(e))), this._listenersStore.add(this._editor.onDidChangeModel(() => {
      this._cancelScheduler(), this._hideWidgets();
    })), this._listenersStore.add(this._editor.onDidChangeModelContent(() => this._cancelScheduler())), this._listenersStore.add(this._editor.onDidScrollChange((e) => this._onEditorScrollChanged(e)));
  }
  _unhookListeners() {
    this._listenersStore.clear();
  }
  _cancelScheduler() {
    this._mouseMoveEvent = void 0, this._reactToEditorMouseMoveRunner.cancel();
  }
  _onEditorScrollChanged(i) {
    (i.scrollTopChanged || i.scrollLeftChanged) && this._hideWidgets();
  }
  _onEditorMouseDown(i) {
    var e;
    this._hoverState.mouseDown = !0;
    const t = i.target;
    t.type !== 9 || t.detail !== jh.ID ? t.type === 12 && t.detail === km.ID || (t.type !== 12 && (this._hoverState.contentHoverFocused = !1), !((e = this._contentWidget) === null || e === void 0) && e.widget.isResizing || this._hideWidgets()) : this._hoverState.contentHoverFocused = !0;
  }
  _onEditorMouseUp() {
    this._hoverState.mouseDown = !1;
  }
  _onEditorMouseLeave(i) {
    var e, t;
    this._cancelScheduler();
    const n = i.event.browserEvent.relatedTarget;
    !((e = this._contentWidget) === null || e === void 0) && e.widget.isResizing || !((t = this._contentWidget) === null || t === void 0) && t.containsNode(n) || this._hideWidgets();
  }
  _isMouseOverWidget(i) {
    var e, t, n, s, o;
    const r = i.target, a = this._hoverSettings.sticky;
    return !(!a || r.type !== 9 || r.detail !== jh.ID) || !(!a || !(!((e = this._contentWidget) === null || e === void 0) && e.containsNode((t = i.event.browserEvent.view) === null || t === void 0 ? void 0 : t.document.activeElement)) || !((s = (n = i.event.browserEvent.view) === null || n === void 0 ? void 0 : n.getSelection()) === null || s === void 0) && s.isCollapsed) || !(a || r.type !== 9 || r.detail !== jh.ID || !(!((o = this._contentWidget) === null || o === void 0) && o.isColorPickerVisible)) || !(!a || r.type !== 12 || r.detail !== km.ID);
  }
  _onEditorMouseMove(i) {
    var e, t, n, s;
    if (this._mouseMoveEvent = i, ((e = this._contentWidget) === null || e === void 0 ? void 0 : e.isFocused) || ((t = this._contentWidget) === null || t === void 0 ? void 0 : t.isResizing) || this._hoverState.mouseDown && this._hoverState.contentHoverFocused) return;
    const o = this._hoverSettings.sticky;
    if (o && (!((n = this._contentWidget) === null || n === void 0) && n.isVisibleFromKeyboard)) return;
    if (this._isMouseOverWidget(i)) return void this._reactToEditorMouseMoveRunner.cancel();
    const r = this._hoverSettings.hidingDelay;
    !((s = this._contentWidget) === null || s === void 0) && s.isVisible && o && r > 0 ? this._reactToEditorMouseMoveRunner.isScheduled() || this._reactToEditorMouseMoveRunner.schedule(r) : this._reactToEditorMouseMove(i);
  }
  _reactToEditorMouseMove(i) {
    var e, t, n, s;
    if (!i) return;
    const o = i.target, r = (e = o.element) === null || e === void 0 ? void 0 : e.classList.contains("colorpicker-color-decoration"), a = this._editor.getOption(148), l = this._hoverSettings.enabled, d = this._hoverState.activatedByDecoratorClick;
    if (r && (a === "click" && !d || a === "hover" && !l || a === "clickAndHover" && !l && !d) || !r && !l && !d) return void this._hideWidgets();
    this._getOrCreateContentWidget().showsOrWillShow(i) ? (t = this._glyphWidget) === null || t === void 0 || t.hide() : o.type === 2 && o.position && o.detail.glyphMarginLane ? ((n = this._contentWidget) === null || n === void 0 || n.hide(), this._getOrCreateGlyphWidget().startShowingAt(o.position.lineNumber, o.detail.glyphMarginLane)) : o.type === 3 && o.position ? ((s = this._contentWidget) === null || s === void 0 || s.hide(), this._getOrCreateGlyphWidget().startShowingAt(o.position.lineNumber, "lineNo")) : this._hideWidgets();
  }
  _onKeyDown(i) {
    var e;
    if (!this._editor.hasModel()) return;
    const t = this._keybindingService.softDispatch(i, this._editor.getDomNode()), n = t.kind === 1 || t.kind === 2 && t.commandId === "editor.action.showHover" && ((e = this._contentWidget) === null || e === void 0 ? void 0 : e.isVisible);
    i.keyCode === 5 || i.keyCode === 6 || i.keyCode === 57 || i.keyCode === 4 || n || this._hideWidgets();
  }
  _hideWidgets() {
    var i, e, t;
    this._hoverState.mouseDown && this._hoverState.contentHoverFocused && (!((i = this._contentWidget) === null || i === void 0) && i.isColorPickerVisible) || qh.dropDownVisible || (this._hoverState.activatedByDecoratorClick = !1, this._hoverState.contentHoverFocused = !1, (e = this._glyphWidget) === null || e === void 0 || e.hide(), (t = this._contentWidget) === null || t === void 0 || t.hide());
  }
  _getOrCreateContentWidget() {
    return this._contentWidget || (this._contentWidget = this._instantiationService.createInstance(fw, this._editor)), this._contentWidget;
  }
  _getOrCreateGlyphWidget() {
    return this._glyphWidget || (this._glyphWidget = new km(this._editor, this._languageService, this._openerService)), this._glyphWidget;
  }
  showContentHover(i, e, t, n, s = !1) {
    this._hoverState.activatedByDecoratorClick = s, this._getOrCreateContentWidget().startShowingAtRange(i, e, t, n);
  }
  focus() {
    var i;
    (i = this._contentWidget) === null || i === void 0 || i.focus();
  }
  scrollUp() {
    var i;
    (i = this._contentWidget) === null || i === void 0 || i.scrollUp();
  }
  scrollDown() {
    var i;
    (i = this._contentWidget) === null || i === void 0 || i.scrollDown();
  }
  scrollLeft() {
    var i;
    (i = this._contentWidget) === null || i === void 0 || i.scrollLeft();
  }
  scrollRight() {
    var i;
    (i = this._contentWidget) === null || i === void 0 || i.scrollRight();
  }
  pageUp() {
    var i;
    (i = this._contentWidget) === null || i === void 0 || i.pageUp();
  }
  pageDown() {
    var i;
    (i = this._contentWidget) === null || i === void 0 || i.pageDown();
  }
  goToTop() {
    var i;
    (i = this._contentWidget) === null || i === void 0 || i.goToTop();
  }
  goToBottom() {
    var i;
    (i = this._contentWidget) === null || i === void 0 || i.goToBottom();
  }
  get isColorPickerVisible() {
    var i;
    return (i = this._contentWidget) === null || i === void 0 ? void 0 : i.isColorPickerVisible;
  }
  get isHoverVisible() {
    var i;
    return (i = this._contentWidget) === null || i === void 0 ? void 0 : i.isVisible;
  }
  dispose() {
    var i, e;
    super.dispose(), this._unhookListeners(), this._listenersStore.dispose(), (i = this._glyphWidget) === null || i === void 0 || i.dispose(), (e = this._contentWidget) === null || e === void 0 || e.dispose();
  }
};
var Wr;
xs.ID = "editor.contrib.hover", xs = TM = Mae([tC(1, Se), tC(2, Fs), tC(3, Xt), tC(4, Dt)], xs), function(i) {
  i.NoAutoFocus = "noAutoFocus", i.FocusIfVisible = "focusIfVisible", i.AutoFocusImmediately = "autoFocusImmediately";
}(Wr || (Wr = {}));
ft(xs.ID, xs, 2), X(class extends he {
  constructor() {
    super({ id: "editor.action.showHover", label: m(0, "Show or Focus Hover"), metadata: { description: "Show or Focus Hover", args: [{ name: "args", schema: { type: "object", properties: { focus: { description: "Controls if and when the hover should take focus upon being triggered by this action.", enum: [Wr.NoAutoFocus, Wr.FocusIfVisible, Wr.AutoFocusImmediately], enumDescriptions: [m(0, "The hover will not automatically take focus."), m(0, "The hover will take focus only if it is already visible."), m(0, "The hover will automatically take focus when it appears.")], default: Wr.FocusIfVisible } } } }] }, alias: "Show or Focus Hover", precondition: void 0, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2087), weight: 100 } });
  }
  run(i, e, t) {
    if (!e.hasModel()) return;
    const n = xs.get(e);
    if (!n) return;
    const s = t == null ? void 0 : t.focus;
    let o = Wr.FocusIfVisible;
    Object.values(Wr).includes(s) ? o = s : typeof s == "boolean" && s && (o = Wr.AutoFocusImmediately);
    const r = (l) => {
      const d = e.getPosition(), h = new D(d.lineNumber, d.column, d.lineNumber, d.column);
      n.showContentHover(h, 1, 1, l);
    }, a = e.getOption(2) === 2;
    n.isHoverVisible ? o !== Wr.NoAutoFocus ? n.focus() : r(a) : r(a || o === Wr.AutoFocusImmediately);
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.showDefinitionPreviewHover", label: m(0, "Show Definition Preview Hover"), alias: "Show Definition Preview Hover", precondition: void 0 });
  }
  run(i, e) {
    const t = xs.get(e);
    if (!t) return;
    const n = e.getPosition();
    if (!n) return;
    const s = new D(n.lineNumber, n.column, n.lineNumber, n.column), o = cu.get(e);
    o && o.startFindDefinitionFromCursor(n).then(() => {
      t.showContentHover(s, 1, 1, !0);
    });
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.scrollUpHover", label: m(0, "Scroll Up Hover"), alias: "Scroll Up Hover", precondition: E.hoverFocused, kbOpts: { kbExpr: E.hoverFocused, primary: 16, weight: 100 } });
  }
  run(i, e) {
    const t = xs.get(e);
    t && t.scrollUp();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.scrollDownHover", label: m(0, "Scroll Down Hover"), alias: "Scroll Down Hover", precondition: E.hoverFocused, kbOpts: { kbExpr: E.hoverFocused, primary: 18, weight: 100 } });
  }
  run(i, e) {
    const t = xs.get(e);
    t && t.scrollDown();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.scrollLeftHover", label: m(0, "Scroll Left Hover"), alias: "Scroll Left Hover", precondition: E.hoverFocused, kbOpts: { kbExpr: E.hoverFocused, primary: 15, weight: 100 } });
  }
  run(i, e) {
    const t = xs.get(e);
    t && t.scrollLeft();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.scrollRightHover", label: m(0, "Scroll Right Hover"), alias: "Scroll Right Hover", precondition: E.hoverFocused, kbOpts: { kbExpr: E.hoverFocused, primary: 17, weight: 100 } });
  }
  run(i, e) {
    const t = xs.get(e);
    t && t.scrollRight();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.pageUpHover", label: m(0, "Page Up Hover"), alias: "Page Up Hover", precondition: E.hoverFocused, kbOpts: { kbExpr: E.hoverFocused, primary: 11, secondary: [528], weight: 100 } });
  }
  run(i, e) {
    const t = xs.get(e);
    t && t.pageUp();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.pageDownHover", label: m(0, "Page Down Hover"), alias: "Page Down Hover", precondition: E.hoverFocused, kbOpts: { kbExpr: E.hoverFocused, primary: 12, secondary: [530], weight: 100 } });
  }
  run(i, e) {
    const t = xs.get(e);
    t && t.pageDown();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.goToTopHover", label: m(0, "Go To Top Hover"), alias: "Go To Bottom Hover", precondition: E.hoverFocused, kbOpts: { kbExpr: E.hoverFocused, primary: 14, secondary: [2064], weight: 100 } });
  }
  run(i, e) {
    const t = xs.get(e);
    t && t.goToTop();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.goToBottomHover", label: m(0, "Go To Bottom Hover"), alias: "Go To Bottom Hover", precondition: E.hoverFocused, kbOpts: { kbExpr: E.hoverFocused, primary: 13, secondary: [2066], weight: 100 } });
  }
  run(i, e) {
    const t = xs.get(e);
    t && t.goToBottom();
  }
}), Rc.register(vS), Rc.register(EM), rr((i, e) => {
  const t = i.getColor(cB);
  t && (e.addRule(`.monaco-editor .monaco-hover .hover-row:not(:first-child):not(:empty) { border-top: 1px solid ${t.transparent(0.5)}; }`), e.addRule(`.monaco-editor .monaco-hover hr { border-top: 1px solid ${t.transparent(0.5)}; }`), e.addRule(`.monaco-editor .monaco-hover hr { border-bottom: 0px solid ${t.transparent(0.5)}; }`));
});
class Px extends V {
  constructor(e) {
    super(), this._editor = e, this._register(e.onMouseDown((t) => this.onMouseDown(t)));
  }
  dispose() {
    super.dispose();
  }
  onMouseDown(e) {
    const t = this._editor.getOption(148);
    if (t !== "click" && t !== "clickAndHover") return;
    const n = e.target;
    if (n.type !== 6 || !n.detail.injectedText || n.detail.injectedText.options.attachedData !== rz || !n.range) return;
    const s = this._editor.getContribution(xs.ID);
    if (s && !s.isColorPickerVisible) {
      const o = new D(n.range.startLineNumber, n.range.startColumn + 1, n.range.endLineNumber, n.range.endColumn + 1);
      s.showContentHover(o, 1, 0, !1, !0);
    }
  }
}
Px.ID = "editor.contrib.colorContribution", ft(Px.ID, Px, 2), Rc.register(gS);
var RM, AM, Mz = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Zr = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let Sh = RM = class extends V {
  constructor(i, e, t, n, s, o, r) {
    super(), this._editor = i, this._modelService = t, this._keybindingService = n, this._instantiationService = s, this._languageFeatureService = o, this._languageConfigurationService = r, this._standaloneColorPickerWidget = null, this._standaloneColorPickerVisible = E.standaloneColorPickerVisible.bindTo(e), this._standaloneColorPickerFocused = E.standaloneColorPickerFocused.bindTo(e);
  }
  showOrFocus() {
    var i;
    this._editor.hasModel() && (this._standaloneColorPickerVisible.get() ? this._standaloneColorPickerFocused.get() || (i = this._standaloneColorPickerWidget) === null || i === void 0 || i.focus() : this._standaloneColorPickerWidget = new bw(this._editor, this._standaloneColorPickerVisible, this._standaloneColorPickerFocused, this._instantiationService, this._modelService, this._keybindingService, this._languageFeatureService, this._languageConfigurationService));
  }
  hide() {
    var i;
    this._standaloneColorPickerFocused.set(!1), this._standaloneColorPickerVisible.set(!1), (i = this._standaloneColorPickerWidget) === null || i === void 0 || i.hide(), this._editor.focus();
  }
  insertColor() {
    var i;
    (i = this._standaloneColorPickerWidget) === null || i === void 0 || i.updateEditor(), this.hide();
  }
  static get(i) {
    return i.getContribution(RM.ID);
  }
};
Sh.ID = "editor.contrib.standaloneColorPickerController", Sh = RM = Mz([Zr(1, Te), Zr(2, ni), Zr(3, Dt), Zr(4, Se), Zr(5, fe), Zr(6, zt)], Sh), ft(Sh.ID, Sh, 1);
let bw = AM = class extends V {
  constructor(i, e, t, n, s, o, r, a) {
    var l;
    super(), this._editor = i, this._standaloneColorPickerVisible = e, this._standaloneColorPickerFocused = t, this._modelService = s, this._keybindingService = o, this._languageFeaturesService = r, this._languageConfigurationService = a, this.allowEditorOverflow = !0, this._position = void 0, this._body = document.createElement("div"), this._colorHover = null, this._selectionSetInEditor = !1, this._onResult = this._register(new F()), this.onResult = this._onResult.event, this._standaloneColorPickerVisible.set(!0), this._standaloneColorPickerParticipant = n.createInstance(t1, this._editor), this._position = (l = this._editor._getViewModel()) === null || l === void 0 ? void 0 : l.getPrimaryCursorState().modelState.position;
    const d = this._editor.getSelection(), h = d ? { startLineNumber: d.startLineNumber, startColumn: d.startColumn, endLineNumber: d.endLineNumber, endColumn: d.endColumn } : { startLineNumber: 0, endLineNumber: 0, endColumn: 0, startColumn: 0 }, c = this._register(ma(this._body));
    this._register(c.onDidBlur((u) => {
      this.hide();
    })), this._register(c.onDidFocus((u) => {
      this.focus();
    })), this._register(this._editor.onDidChangeCursorPosition(() => {
      this._selectionSetInEditor ? this._selectionSetInEditor = !1 : this.hide();
    })), this._register(this._editor.onMouseMove((u) => {
      var g;
      const p = (g = u.target.element) === null || g === void 0 ? void 0 : g.classList;
      p && p.contains("colorpicker-color-decoration") && this.hide();
    })), this._register(this.onResult((u) => {
      this._render(u.value, u.foundInEditor);
    })), this._start(h), this._body.style.zIndex = "50", this._editor.addContentWidget(this);
  }
  updateEditor() {
    this._colorHover && this._standaloneColorPickerParticipant.updateEditorModel(this._colorHover);
  }
  getId() {
    return AM.ID;
  }
  getDomNode() {
    return this._body;
  }
  getPosition() {
    if (!this._position) return null;
    const i = this._editor.getOption(60).above;
    return { position: this._position, secondaryPosition: this._position, preference: i ? [1, 2] : [2, 1], positionAffinity: 2 };
  }
  hide() {
    this.dispose(), this._standaloneColorPickerVisible.set(!1), this._standaloneColorPickerFocused.set(!1), this._editor.removeContentWidget(this), this._editor.focus();
  }
  focus() {
    this._standaloneColorPickerFocused.set(!0), this._body.focus();
  }
  async _start(i) {
    const e = await this._computeAsync(i);
    e && this._onResult.fire(new Tae(e.result, e.foundInEditor));
  }
  async _computeAsync(i) {
    if (!this._editor.hasModel()) return null;
    const e = { range: i, color: { red: 0, green: 0, blue: 0, alpha: 1 } }, t = await this._standaloneColorPickerParticipant.createColorHover(e, new bP(this._modelService, this._languageConfigurationService), this._languageFeaturesService.colorProvider);
    return t ? { result: t.colorHover, foundInEditor: t.foundInEditor } : null;
  }
  _render(i, e) {
    const t = document.createDocumentFragment();
    let n;
    const s = { fragment: t, statusBar: this._register(new fS(this._keybindingService)), setColorPicker: (c) => n = c, onContentsChanged: () => {
    }, hide: () => this.hide() };
    if (this._colorHover = i, this._register(this._standaloneColorPickerParticipant.renderHoverParts(s, [i])), n === void 0) return;
    this._body.classList.add("standalone-colorpicker-body"), this._body.style.maxHeight = Math.max(this._editor.getLayoutInfo().height / 4, 250) + "px", this._body.style.maxWidth = Math.max(0.66 * this._editor.getLayoutInfo().width, 500) + "px", this._body.tabIndex = 0, this._body.appendChild(t), n.layout();
    const o = n.body, r = o.saturationBox.domNode.clientWidth, a = o.domNode.clientWidth - r - 22 - 8, l = n.body.enterButton;
    l == null || l.onClicked(() => {
      this.updateEditor(), this.hide();
    });
    const d = n.header;
    d.pickedColorNode.style.width = r + 8 + "px", d.originalColorNode.style.width = a + "px";
    const h = n.header.closeButton;
    h == null || h.onClicked(() => {
      this.hide();
    }), e && (l && (l.button.textContent = "Replace"), this._selectionSetInEditor = !0, this._editor.setSelection(i.range)), this._editor.layoutContentWidget(this);
  }
};
bw.ID = "editor.contrib.standaloneColorPickerWidget", bw = AM = Mz([Zr(3, Se), Zr(4, ni), Zr(5, Dt), Zr(6, fe), Zr(7, zt)], bw);
class Tae {
  constructor(e, t) {
    this.value = e, this.foundInEditor = t;
  }
}
X(class extends he {
  constructor() {
    super({ id: "editor.action.hideColorPicker", label: m(0, "Hide the Color Picker"), alias: "Hide the Color Picker", precondition: E.standaloneColorPickerVisible.isEqualTo(!0), kbOpts: { primary: 9, weight: 100 } });
  }
  run(i, e) {
    var t;
    (t = Sh.get(e)) === null || t === void 0 || t.hide();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.insertColorWithStandaloneColorPicker", label: m(0, "Insert Color with Standalone Color Picker"), alias: "Insert Color with Standalone Color Picker", precondition: E.standaloneColorPickerFocused.isEqualTo(!0), kbOpts: { primary: 3, weight: 100 } });
  }
  run(i, e) {
    var t;
    (t = Sh.get(e)) === null || t === void 0 || t.insertColor();
  }
}), Ft(class extends Qr {
  constructor() {
    super({ id: "editor.action.showOrFocusStandaloneColorPicker", title: { ...ct(0, "Show or Focus Standalone Color Picker"), mnemonicTitle: m(0, "&&Show or Focus Standalone Color Picker") }, precondition: void 0, menu: [{ id: x.CommandPalette }] });
  }
  runEditorCommand(i, e) {
    var t;
    (t = Sh.get(e)) === null || t === void 0 || t.showOrFocus();
  }
});
class $h {
  constructor(e, t, n) {
    this.languageConfigurationService = n, this._selection = e, this._insertSpace = t, this._usedEndToken = null;
  }
  static _haystackHasNeedleAtOffset(e, t, n) {
    if (n < 0) return !1;
    const s = t.length;
    if (n + s > e.length) return !1;
    for (let o = 0; o < s; o++) {
      const r = e.charCodeAt(n + o), a = t.charCodeAt(o);
      if (r !== a && !(r >= 65 && r <= 90 && r + 32 === a || a >= 65 && a <= 90 && a + 32 === r)) return !1;
    }
    return !0;
  }
  _createOperationsForBlockComment(e, t, n, s, o, r) {
    const a = e.startLineNumber, l = e.startColumn, d = e.endLineNumber, h = e.endColumn, c = o.getLineContent(a), u = o.getLineContent(d);
    let g, p = c.lastIndexOf(t, l - 1 + t.length), f = u.indexOf(n, h - 1 - n.length);
    if (p !== -1 && f !== -1) if (a === d)
      c.substring(p + t.length, f).indexOf(n) >= 0 && (p = -1, f = -1);
    else {
      const _ = c.substring(p + t.length), v = u.substring(0, f);
      (_.indexOf(n) >= 0 || v.indexOf(n) >= 0) && (p = -1, f = -1);
    }
    p !== -1 && f !== -1 ? (s && p + t.length < c.length && c.charCodeAt(p + t.length) === 32 && (t += " "), s && f > 0 && u.charCodeAt(f - 1) === 32 && (n = " " + n, f -= 1), g = $h._createRemoveBlockCommentOperations(new D(a, p + t.length + 1, d, f + 1), t, n)) : (g = $h._createAddBlockCommentOperations(e, t, n, this._insertSpace), this._usedEndToken = g.length === 1 ? n : null);
    for (const _ of g) r.addTrackedEditOperation(_.range, _.text);
  }
  static _createRemoveBlockCommentOperations(e, t, n) {
    const s = [];
    return D.isEmpty(e) ? s.push(ii.delete(new D(e.startLineNumber, e.startColumn - t.length, e.endLineNumber, e.endColumn + n.length))) : (s.push(ii.delete(new D(e.startLineNumber, e.startColumn - t.length, e.startLineNumber, e.startColumn))), s.push(ii.delete(new D(e.endLineNumber, e.endColumn, e.endLineNumber, e.endColumn + n.length)))), s;
  }
  static _createAddBlockCommentOperations(e, t, n, s) {
    const o = [];
    return D.isEmpty(e) ? o.push(ii.replace(new D(e.startLineNumber, e.startColumn, e.endLineNumber, e.endColumn), t + "  " + n)) : (o.push(ii.insert(new W(e.startLineNumber, e.startColumn), t + (s ? " " : ""))), o.push(ii.insert(new W(e.endLineNumber, e.endColumn), (s ? " " : "") + n))), o;
  }
  getEditOperations(e, t) {
    const n = this._selection.startLineNumber, s = this._selection.startColumn;
    e.tokenization.tokenizeIfCheap(n);
    const o = e.getLanguageIdAtPosition(n, s), r = this.languageConfigurationService.getLanguageConfiguration(o).comments;
    r && r.blockCommentStartToken && r.blockCommentEndToken && this._createOperationsForBlockComment(this._selection, r.blockCommentStartToken, r.blockCommentEndToken, this._insertSpace, e, t);
  }
  computeCursorState(e, t) {
    const n = t.getInverseEditOperations();
    if (n.length === 2) {
      const s = n[0], o = n[1];
      return new _e(s.range.endLineNumber, s.range.endColumn, o.range.startLineNumber, o.range.startColumn);
    }
    {
      const s = n[0].range, o = this._usedEndToken ? -this._usedEndToken.length - 1 : 0;
      return new _e(s.endLineNumber, s.endColumn + o, s.endLineNumber, s.endColumn + o);
    }
  }
}
class zl {
  constructor(e, t, n, s, o, r, a) {
    this.languageConfigurationService = e, this._selection = t, this._indentSize = n, this._type = s, this._insertSpace = o, this._selectionId = null, this._deltaColumn = 0, this._moveEndPositionDown = !1, this._ignoreEmptyLines = r, this._ignoreFirstLine = a || !1;
  }
  static _gatherPreflightCommentStrings(e, t, n, s) {
    e.tokenization.tokenizeIfCheap(t);
    const o = e.getLanguageIdAtPosition(t, 1), r = s.getLanguageConfiguration(o).comments, a = r ? r.lineCommentToken : null;
    if (!a) return null;
    const l = [];
    for (let d = 0, h = n - t + 1; d < h; d++) l[d] = { ignore: !1, commentStr: a, commentStrOffset: 0, commentStrLength: a.length };
    return l;
  }
  static _analyzeLines(e, t, n, s, o, r, a, l) {
    let d, h = !0;
    d = e === 0 || e !== 1;
    for (let c = 0, u = s.length; c < u; c++) {
      const g = s[c], p = o + c;
      if (p === o && a) {
        g.ignore = !0;
        continue;
      }
      const f = n.getLineContent(p), _ = Jn(f);
      if (_ !== -1) {
        if (h = !1, g.ignore = !1, g.commentStrOffset = _, d && !$h._haystackHasNeedleAtOffset(f, g.commentStr, _) && (e === 0 ? d = !1 : e === 1 || (g.ignore = !0)), d && t) {
          const v = _ + g.commentStrLength;
          v < f.length && f.charCodeAt(v) === 32 && (g.commentStrLength += 1);
        }
      } else g.ignore = r, g.commentStrOffset = f.length;
    }
    if (e === 0 && h) {
      d = !1;
      for (let c = 0, u = s.length; c < u; c++) s[c].ignore = !1;
    }
    return { supported: !0, shouldRemoveComments: d, lines: s };
  }
  static _gatherPreflightData(e, t, n, s, o, r, a, l) {
    const d = zl._gatherPreflightCommentStrings(n, s, o, l);
    return d === null ? { supported: !1 } : zl._analyzeLines(e, t, n, d, s, r, a, l);
  }
  _executeLineComments(e, t, n, s) {
    let o;
    n.shouldRemoveComments ? o = zl._createRemoveLineCommentsOperations(n.lines, s.startLineNumber) : (zl._normalizeInsertionPoint(e, n.lines, s.startLineNumber, this._indentSize), o = this._createAddLineCommentsOperations(n.lines, s.startLineNumber));
    const r = new W(s.positionLineNumber, s.positionColumn);
    for (let a = 0, l = o.length; a < l; a++) t.addEditOperation(o[a].range, o[a].text), D.isEmpty(o[a].range) && D.getStartPosition(o[a].range).equals(r) && e.getLineContent(r.lineNumber).length + 1 === r.column && (this._deltaColumn = (o[a].text || "").length);
    this._selectionId = t.trackSelection(s);
  }
  _attemptRemoveBlockComment(e, t, n, s) {
    let o = t.startLineNumber, r = t.endLineNumber;
    const a = s.length + Math.max(e.getLineFirstNonWhitespaceColumn(t.startLineNumber), t.startColumn);
    let l = e.getLineContent(o).lastIndexOf(n, a - 1), d = e.getLineContent(r).indexOf(s, t.endColumn - 1 - n.length);
    return l !== -1 && d === -1 && (d = e.getLineContent(o).indexOf(s, l + n.length), r = o), l === -1 && d !== -1 && (l = e.getLineContent(r).lastIndexOf(n, d), o = r), !t.isEmpty() || l !== -1 && d !== -1 || (l = e.getLineContent(o).indexOf(n), l !== -1 && (d = e.getLineContent(o).indexOf(s, l + n.length))), l !== -1 && e.getLineContent(o).charCodeAt(l + n.length) === 32 && (n += " "), d !== -1 && e.getLineContent(r).charCodeAt(d - 1) === 32 && (s = " " + s, d -= 1), l !== -1 && d !== -1 ? $h._createRemoveBlockCommentOperations(new D(o, l + n.length + 1, r, d + 1), n, s) : null;
  }
  _executeBlockComment(e, t, n) {
    e.tokenization.tokenizeIfCheap(n.startLineNumber);
    const s = e.getLanguageIdAtPosition(n.startLineNumber, 1), o = this.languageConfigurationService.getLanguageConfiguration(s).comments;
    if (!o || !o.blockCommentStartToken || !o.blockCommentEndToken) return;
    const r = o.blockCommentStartToken, a = o.blockCommentEndToken;
    let l = this._attemptRemoveBlockComment(e, n, r, a);
    if (!l) {
      if (n.isEmpty()) {
        const d = e.getLineContent(n.startLineNumber);
        let h = Jn(d);
        h === -1 && (h = d.length), l = $h._createAddBlockCommentOperations(new D(n.startLineNumber, h + 1, n.startLineNumber, d.length + 1), r, a, this._insertSpace);
      } else l = $h._createAddBlockCommentOperations(new D(n.startLineNumber, e.getLineFirstNonWhitespaceColumn(n.startLineNumber), n.endLineNumber, e.getLineMaxColumn(n.endLineNumber)), r, a, this._insertSpace);
      l.length === 1 && (this._deltaColumn = r.length + 1);
    }
    this._selectionId = t.trackSelection(n);
    for (const d of l) t.addEditOperation(d.range, d.text);
  }
  getEditOperations(e, t) {
    let n = this._selection;
    if (this._moveEndPositionDown = !1, n.startLineNumber === n.endLineNumber && this._ignoreFirstLine) return t.addEditOperation(new D(n.startLineNumber, e.getLineMaxColumn(n.startLineNumber), n.startLineNumber + 1, 1), n.startLineNumber === e.getLineCount() ? "" : `
`), void (this._selectionId = t.trackSelection(n));
    n.startLineNumber < n.endLineNumber && n.endColumn === 1 && (this._moveEndPositionDown = !0, n = n.setEndPosition(n.endLineNumber - 1, e.getLineMaxColumn(n.endLineNumber - 1)));
    const s = zl._gatherPreflightData(this._type, this._insertSpace, e, n.startLineNumber, n.endLineNumber, this._ignoreEmptyLines, this._ignoreFirstLine, this.languageConfigurationService);
    return s.supported ? this._executeLineComments(e, t, s, n) : this._executeBlockComment(e, t, n);
  }
  computeCursorState(e, t) {
    let n = t.getTrackedSelection(this._selectionId);
    return this._moveEndPositionDown && (n = n.setEndPosition(n.endLineNumber + 1, 1)), new _e(n.selectionStartLineNumber, n.selectionStartColumn + this._deltaColumn, n.positionLineNumber, n.positionColumn + this._deltaColumn);
  }
  static _createRemoveLineCommentsOperations(e, t) {
    const n = [];
    for (let s = 0, o = e.length; s < o; s++) {
      const r = e[s];
      r.ignore || n.push(ii.delete(new D(t + s, r.commentStrOffset + 1, t + s, r.commentStrOffset + r.commentStrLength + 1)));
    }
    return n;
  }
  _createAddLineCommentsOperations(e, t) {
    const n = [], s = this._insertSpace ? " " : "";
    for (let o = 0, r = e.length; o < r; o++) {
      const a = e[o];
      a.ignore || n.push(ii.insert(new W(t + o, a.commentStrOffset + 1), a.commentStr + s));
    }
    return n;
  }
  static nextVisibleColumn(e, t, n, s) {
    return n ? e + (t - e % t) : e + s;
  }
  static _normalizeInsertionPoint(e, t, n, s) {
    let o, r, a = 1073741824;
    for (let l = 0, d = t.length; l < d; l++) {
      if (t[l].ignore) continue;
      const h = e.getLineContent(n + l);
      let c = 0;
      for (let u = 0, g = t[l].commentStrOffset; c < a && u < g; u++) c = zl.nextVisibleColumn(c, s, h.charCodeAt(u) === 9, 1);
      c < a && (a = c);
    }
    a = Math.floor(a / s) * s;
    for (let l = 0, d = t.length; l < d; l++) {
      if (t[l].ignore) continue;
      const h = e.getLineContent(n + l);
      let c = 0;
      for (o = 0, r = t[l].commentStrOffset; c < a && o < r; o++) c = zl.nextVisibleColumn(c, s, h.charCodeAt(o) === 9, 1);
      t[l].commentStrOffset = c > a ? o - 1 : o;
    }
  }
}
class Ox extends he {
  constructor(e, t) {
    super(t), this._type = e;
  }
  run(e, t) {
    const n = e.get(zt);
    if (!t.hasModel()) return;
    const s = [], o = t.getModel().getOptions(), r = t.getOption(23), a = t.getSelections().map((d, h) => ({ selection: d, index: h, ignoreFirstLine: !1 }));
    a.sort((d, h) => D.compareRangesUsingStarts(d.selection, h.selection));
    let l = a[0];
    for (let d = 1; d < a.length; d++) {
      const h = a[d];
      l.selection.endLineNumber === h.selection.startLineNumber && (l.index < h.index ? h.ignoreFirstLine = !0 : (l.ignoreFirstLine = !0, l = h));
    }
    for (const d of a) s.push(new zl(n, d.selection, o.indentSize, this._type, r.insertSpace, r.ignoreEmptyLines, d.ignoreFirstLine));
    t.pushUndoStop(), t.executeCommands(this.id, s), t.pushUndoStop();
  }
}
X(class extends Ox {
  constructor() {
    super(0, { id: "editor.action.commentLine", label: m(0, "Toggle Line Comment"), alias: "Toggle Line Comment", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 2138, weight: 100 }, menuOpts: { menuId: x.MenubarEditMenu, group: "5_insert", title: m(0, "&&Toggle Line Comment"), order: 1 } });
  }
}), X(class extends Ox {
  constructor() {
    super(1, { id: "editor.action.addCommentLine", label: m(0, "Add Line Comment"), alias: "Add Line Comment", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2081), weight: 100 } });
  }
}), X(class extends Ox {
  constructor() {
    super(2, { id: "editor.action.removeCommentLine", label: m(0, "Remove Line Comment"), alias: "Remove Line Comment", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2099), weight: 100 } });
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.blockComment", label: m(0, "Toggle Block Comment"), alias: "Toggle Block Comment", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 1567, linux: { primary: 3103 }, weight: 100 }, menuOpts: { menuId: x.MenubarEditMenu, group: "5_insert", title: m(0, "Toggle &&Block Comment"), order: 2 } });
  }
  run(i, e) {
    const t = i.get(zt);
    if (!e.hasModel()) return;
    const n = e.getOption(23), s = [], o = e.getSelections();
    for (const r of o) s.push(new $h(r, n.insertSpace, t));
    e.pushUndoStop(), e.executeCommands(this.id, s), e.pushUndoStop();
  }
});
var PM, Rae = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Jc = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let xm = PM = class {
  static get(i) {
    return i.getContribution(PM.ID);
  }
  constructor(i, e, t, n, s, o, r, a) {
    this._contextMenuService = e, this._contextViewService = t, this._contextKeyService = n, this._keybindingService = s, this._menuService = o, this._configurationService = r, this._workspaceContextService = a, this._toDispose = new G(), this._contextMenuIsBeingShownCount = 0, this._editor = i, this._toDispose.add(this._editor.onContextMenu((l) => this._onContextMenu(l))), this._toDispose.add(this._editor.onMouseWheel((l) => {
      if (this._contextMenuIsBeingShownCount > 0) {
        const d = this._contextViewService.getContextViewElement(), h = l.srcElement;
        h.shadowRoot && dg(d) === h.shadowRoot || this._contextViewService.hideContextView();
      }
    })), this._toDispose.add(this._editor.onKeyDown((l) => {
      this._editor.getOption(24) && l.keyCode === 58 && (l.preventDefault(), l.stopPropagation(), this.showContextMenu());
    }));
  }
  _onContextMenu(i) {
    if (!this._editor.hasModel()) return;
    if (!this._editor.getOption(24)) return this._editor.focus(), void (i.target.position && !this._editor.getSelection().containsPosition(i.target.position) && this._editor.setPosition(i.target.position));
    if (i.target.type === 12 || i.target.type === 6 && i.target.detail.injectedText) return;
    if (i.event.preventDefault(), i.event.stopPropagation(), i.target.type === 11) return this._showScrollbarContextMenu(i.event);
    if (i.target.type !== 6 && i.target.type !== 7 && i.target.type !== 1) return;
    if (this._editor.focus(), i.target.position) {
      let t = !1;
      for (const n of this._editor.getSelections()) if (n.containsPosition(i.target.position)) {
        t = !0;
        break;
      }
      t || this._editor.setPosition(i.target.position);
    }
    let e = null;
    i.target.type !== 1 && (e = i.event), this.showContextMenu(e);
  }
  showContextMenu(i) {
    if (!this._editor.getOption(24) || !this._editor.hasModel()) return;
    const e = this._getMenuActions(this._editor.getModel(), this._editor.isSimpleWidget ? x.SimpleEditorContext : x.EditorContext);
    e.length > 0 && this._doShowContextMenu(e, i);
  }
  _getMenuActions(i, e) {
    const t = [], n = this._menuService.createMenu(e, this._contextKeyService), s = n.getActions({ arg: i.uri });
    n.dispose();
    for (const o of s) {
      const [, r] = o;
      let a = 0;
      for (const l of r) if (l instanceof iv) {
        const d = this._getMenuActions(i, l.item.submenu);
        d.length > 0 && (t.push(new Bm(l.id, l.label, d)), a++);
      } else t.push(l), a++;
      a && t.push(new Ui());
    }
    return t.length && t.pop(), t;
  }
  _doShowContextMenu(i, e = null) {
    if (!this._editor.hasModel()) return;
    const t = this._editor.getOption(60);
    this._editor.updateOptions({ hover: { enabled: !1 } });
    let n = e;
    if (!n) {
      this._editor.revealPosition(this._editor.getPosition(), 1), this._editor.render();
      const o = this._editor.getScrolledVisiblePosition(this._editor.getPosition()), r = Ti(this._editor.getDomNode()), a = r.left + o.left, l = r.top + o.top + o.height;
      n = { x: a, y: l };
    }
    const s = this._editor.getOption(127) && !ua;
    this._contextMenuIsBeingShownCount++, this._contextMenuService.showContextMenu({ domForShadowRoot: s ? this._editor.getDomNode() : void 0, getAnchor: () => n, getActions: () => i, getActionViewItem: (o) => {
      const r = this._keybindingFor(o);
      if (r) return new ef(o, o, { label: !0, keybinding: r.getLabel(), isMenu: !0 });
      const a = o;
      return typeof a.getActionViewItem == "function" ? a.getActionViewItem() : new ef(o, o, { icon: !0, label: !0, isMenu: !0 });
    }, getKeyBinding: (o) => this._keybindingFor(o), onHide: (o) => {
      this._contextMenuIsBeingShownCount--, this._editor.updateOptions({ hover: t });
    } });
  }
  _showScrollbarContextMenu(i) {
    if (!this._editor.hasModel() || this._workspaceContextService.getWorkspace().id === WW) return;
    const e = this._editor.getOption(73);
    let t = 0;
    const n = (a) => ({ id: "menu-action-" + ++t, label: a.label, tooltip: "", class: void 0, enabled: a.enabled === void 0 || a.enabled, checked: a.checked, run: a.run }), s = (a, l, d, h, c) => {
      if (!l) return n({ label: a, enabled: l, run: () => {
      } });
      const u = (p) => () => {
        this._configurationService.updateValue(d, p);
      }, g = [];
      for (const p of c) g.push(n({ label: p.label, checked: h === p.value, run: u(p.value) }));
      return ((p, f) => new Bm("menu-action-" + ++t, p, f, void 0))(a, g);
    }, o = [];
    o.push(n({ label: m(0, "Minimap"), checked: e.enabled, run: () => {
      this._configurationService.updateValue("editor.minimap.enabled", !e.enabled);
    } })), o.push(new Ui()), o.push(n({ label: m(0, "Render Characters"), enabled: e.enabled, checked: e.renderCharacters, run: () => {
      this._configurationService.updateValue("editor.minimap.renderCharacters", !e.renderCharacters);
    } })), o.push(s(m(0, "Vertical size"), e.enabled, "editor.minimap.size", e.size, [{ label: m(0, "Proportional"), value: "proportional" }, { label: m(0, "Fill"), value: "fill" }, { label: m(0, "Fit"), value: "fit" }])), o.push(s(m(0, "Slider"), e.enabled, "editor.minimap.showSlider", e.showSlider, [{ label: m(0, "Mouse Over"), value: "mouseover" }, { label: m(0, "Always"), value: "always" }]));
    const r = this._editor.getOption(127) && !ua;
    this._contextMenuIsBeingShownCount++, this._contextMenuService.showContextMenu({ domForShadowRoot: r ? this._editor.getDomNode() : void 0, getAnchor: () => i, getActions: () => o, onHide: (a) => {
      this._contextMenuIsBeingShownCount--, this._editor.focus();
    } });
  }
  _keybindingFor(i) {
    return this._keybindingService.lookupKeybinding(i.id);
  }
  dispose() {
    this._contextMenuIsBeingShownCount > 0 && this._contextViewService.hideContextView(), this._toDispose.dispose();
  }
};
xm.ID = "editor.contrib.contextmenu", xm = PM = Rae([Jc(1, io), Jc(2, zd), Jc(3, Te), Jc(4, Dt), Jc(5, Mo), Jc(6, Ye), Jc(7, mg)], xm);
ft(xm.ID, xm, 2), X(class extends he {
  constructor() {
    super({ id: "editor.action.showContextMenu", label: m(0, "Show Editor Context Menu"), alias: "Show Editor Context Menu", precondition: void 0, kbOpts: { kbExpr: E.textInputFocus, primary: 1092, weight: 100 } });
  }
  run(i, e) {
    var t;
    (t = xm.get(e)) === null || t === void 0 || t.showContextMenu();
  }
});
class Fx {
  constructor(e) {
    this.selections = e;
  }
  equals(e) {
    const t = this.selections.length;
    if (t !== e.selections.length) return !1;
    for (let n = 0; n < t; n++) if (!this.selections[n].equalsSelection(e.selections[n])) return !1;
    return !0;
  }
}
class Bx {
  constructor(e, t, n) {
    this.cursorState = e, this.scrollTop = t, this.scrollLeft = n;
  }
}
class Vu extends V {
  static get(e) {
    return e.getContribution(Vu.ID);
  }
  constructor(e) {
    super(), this._editor = e, this._isCursorUndoRedo = !1, this._undoStack = [], this._redoStack = [], this._register(e.onDidChangeModel((t) => {
      this._undoStack = [], this._redoStack = [];
    })), this._register(e.onDidChangeModelContent((t) => {
      this._undoStack = [], this._redoStack = [];
    })), this._register(e.onDidChangeCursorSelection((t) => {
      if (this._isCursorUndoRedo || !t.oldSelections || t.oldModelVersionId !== t.modelVersionId) return;
      const n = new Fx(t.oldSelections);
      this._undoStack.length > 0 && this._undoStack[this._undoStack.length - 1].cursorState.equals(n) || (this._undoStack.push(new Bx(n, e.getScrollTop(), e.getScrollLeft())), this._redoStack = [], this._undoStack.length > 50 && this._undoStack.shift());
    }));
  }
  cursorUndo() {
    this._editor.hasModel() && this._undoStack.length !== 0 && (this._redoStack.push(new Bx(new Fx(this._editor.getSelections()), this._editor.getScrollTop(), this._editor.getScrollLeft())), this._applyState(this._undoStack.pop()));
  }
  cursorRedo() {
    this._editor.hasModel() && this._redoStack.length !== 0 && (this._undoStack.push(new Bx(new Fx(this._editor.getSelections()), this._editor.getScrollTop(), this._editor.getScrollLeft())), this._applyState(this._redoStack.pop()));
  }
  _applyState(e) {
    this._isCursorUndoRedo = !0, this._editor.setSelections(e.cursorState.selections), this._editor.setScrollPosition({ scrollTop: e.scrollTop, scrollLeft: e.scrollLeft }), this._isCursorUndoRedo = !1;
  }
}
Vu.ID = "editor.contrib.cursorUndoRedoController";
ft(Vu.ID, Vu, 0), X(class extends he {
  constructor() {
    super({ id: "cursorUndo", label: m(0, "Cursor Undo"), alias: "Cursor Undo", precondition: void 0, kbOpts: { kbExpr: E.textInputFocus, primary: 2099, weight: 100 } });
  }
  run(i, e, t) {
    var n;
    (n = Vu.get(e)) === null || n === void 0 || n.cursorUndo();
  }
}), X(class extends he {
  constructor() {
    super({ id: "cursorRedo", label: m(0, "Cursor Redo"), alias: "Cursor Redo", precondition: void 0 });
  }
  run(i, e, t) {
    var n;
    (n = Vu.get(e)) === null || n === void 0 || n.cursorRedo();
  }
});
class Aae {
  constructor(e, t, n) {
    this.selection = e, this.targetPosition = t, this.copy = n, this.targetSelection = null;
  }
  getEditOperations(e, t) {
    const n = e.getValueInRange(this.selection);
    this.copy || t.addEditOperation(this.selection, null), t.addEditOperation(new D(this.targetPosition.lineNumber, this.targetPosition.column, this.targetPosition.lineNumber, this.targetPosition.column), n), !this.selection.containsPosition(this.targetPosition) || this.copy && (this.selection.getEndPosition().equals(this.targetPosition) || this.selection.getStartPosition().equals(this.targetPosition)) ? this.copy ? this.targetSelection = new _e(this.targetPosition.lineNumber, this.targetPosition.column, this.selection.endLineNumber - this.selection.startLineNumber + this.targetPosition.lineNumber, this.selection.startLineNumber === this.selection.endLineNumber ? this.targetPosition.column + this.selection.endColumn - this.selection.startColumn : this.selection.endColumn) : this.targetPosition.lineNumber > this.selection.endLineNumber ? this.targetSelection = new _e(this.targetPosition.lineNumber - this.selection.endLineNumber + this.selection.startLineNumber, this.targetPosition.column, this.targetPosition.lineNumber, this.selection.startLineNumber === this.selection.endLineNumber ? this.targetPosition.column + this.selection.endColumn - this.selection.startColumn : this.selection.endColumn) : this.targetPosition.lineNumber < this.selection.endLineNumber ? this.targetSelection = new _e(this.targetPosition.lineNumber, this.targetPosition.column, this.targetPosition.lineNumber + this.selection.endLineNumber - this.selection.startLineNumber, this.selection.startLineNumber === this.selection.endLineNumber ? this.targetPosition.column + this.selection.endColumn - this.selection.startColumn : this.selection.endColumn) : this.selection.endColumn <= this.targetPosition.column ? this.targetSelection = new _e(this.targetPosition.lineNumber - this.selection.endLineNumber + this.selection.startLineNumber, (this.selection.startLineNumber, this.selection.endLineNumber, this.targetPosition.column - this.selection.endColumn + this.selection.startColumn), this.targetPosition.lineNumber, this.selection.startLineNumber === this.selection.endLineNumber ? this.targetPosition.column : this.selection.endColumn) : this.targetSelection = new _e(this.targetPosition.lineNumber - this.selection.endLineNumber + this.selection.startLineNumber, this.targetPosition.column, this.targetPosition.lineNumber, this.targetPosition.column + this.selection.endColumn - this.selection.startColumn) : this.targetSelection = this.selection;
  }
  computeCursorState(e, t) {
    return this.targetSelection;
  }
}
function sp(i) {
  return Je ? i.altKey : i.ctrlKey;
}
class id extends V {
  constructor(e) {
    super(), this._editor = e, this._dndDecorationIds = this._editor.createDecorationsCollection(), this._register(this._editor.onMouseDown((t) => this._onEditorMouseDown(t))), this._register(this._editor.onMouseUp((t) => this._onEditorMouseUp(t))), this._register(this._editor.onMouseDrag((t) => this._onEditorMouseDrag(t))), this._register(this._editor.onMouseDrop((t) => this._onEditorMouseDrop(t))), this._register(this._editor.onMouseDropCanceled(() => this._onEditorMouseDropCanceled())), this._register(this._editor.onKeyDown((t) => this.onEditorKeyDown(t))), this._register(this._editor.onKeyUp((t) => this.onEditorKeyUp(t))), this._register(this._editor.onDidBlurEditorWidget(() => this.onEditorBlur())), this._register(this._editor.onDidBlurEditorText(() => this.onEditorBlur())), this._mouseDown = !1, this._modifierPressed = !1, this._dragSelection = null;
  }
  onEditorBlur() {
    this._removeDecoration(), this._dragSelection = null, this._mouseDown = !1, this._modifierPressed = !1;
  }
  onEditorKeyDown(e) {
    this._editor.getOption(35) && !this._editor.getOption(22) && (sp(e) && (this._modifierPressed = !0), this._mouseDown && sp(e) && this._editor.updateOptions({ mouseStyle: "copy" }));
  }
  onEditorKeyUp(e) {
    this._editor.getOption(35) && !this._editor.getOption(22) && (sp(e) && (this._modifierPressed = !1), this._mouseDown && e.keyCode === id.TRIGGER_KEY_VALUE && this._editor.updateOptions({ mouseStyle: "default" }));
  }
  _onEditorMouseDown(e) {
    this._mouseDown = !0;
  }
  _onEditorMouseUp(e) {
    this._mouseDown = !1, this._editor.updateOptions({ mouseStyle: "text" });
  }
  _onEditorMouseDrag(e) {
    const t = e.target;
    if (this._dragSelection === null) {
      const n = (this._editor.getSelections() || []).filter((s) => t.position && s.containsPosition(t.position));
      if (n.length !== 1) return;
      this._dragSelection = n[0];
    }
    sp(e.event) ? this._editor.updateOptions({ mouseStyle: "copy" }) : this._editor.updateOptions({ mouseStyle: "default" }), t.position && (this._dragSelection.containsPosition(t.position) ? this._removeDecoration() : this.showAt(t.position));
  }
  _onEditorMouseDropCanceled() {
    this._editor.updateOptions({ mouseStyle: "text" }), this._removeDecoration(), this._dragSelection = null, this._mouseDown = !1;
  }
  _onEditorMouseDrop(e) {
    if (e.target && (this._hitContent(e.target) || this._hitMargin(e.target)) && e.target.position) {
      const t = new W(e.target.position.lineNumber, e.target.position.column);
      if (this._dragSelection === null) {
        let n = null;
        if (e.event.shiftKey) {
          const s = this._editor.getSelection();
          if (s) {
            const { selectionStartLineNumber: o, selectionStartColumn: r } = s;
            n = [new _e(o, r, t.lineNumber, t.column)];
          }
        } else n = (this._editor.getSelections() || []).map((s) => s.containsPosition(t) ? new _e(t.lineNumber, t.column, t.lineNumber, t.column) : s);
        this._editor.setSelections(n || [], "mouse", 3);
      } else (!this._dragSelection.containsPosition(t) || (sp(e.event) || this._modifierPressed) && (this._dragSelection.getEndPosition().equals(t) || this._dragSelection.getStartPosition().equals(t))) && (this._editor.pushUndoStop(), this._editor.executeCommand(id.ID, new Aae(this._dragSelection, t, sp(e.event) || this._modifierPressed)), this._editor.pushUndoStop());
    }
    this._editor.updateOptions({ mouseStyle: "text" }), this._removeDecoration(), this._dragSelection = null, this._mouseDown = !1;
  }
  showAt(e) {
    this._dndDecorationIds.set([{ range: new D(e.lineNumber, e.column, e.lineNumber, e.column), options: id._DECORATION_OPTIONS }]), this._editor.revealPosition(e, 1);
  }
  _removeDecoration() {
    this._dndDecorationIds.clear();
  }
  _hitContent(e) {
    return e.type === 6 || e.type === 7;
  }
  _hitMargin(e) {
    return e.type === 2 || e.type === 3 || e.type === 4;
  }
  dispose() {
    this._removeDecoration(), this._dragSelection = null, this._mouseDown = !1, this._modifierPressed = !1, super.dispose();
  }
}
var iC;
id.ID = "editor.contrib.dragAndDrop", id.TRIGGER_KEY_VALUE = Je ? 6 : 5, id._DECORATION_OPTIONS = Ve.register({ description: "dnd-target", className: "dnd-target" }), ft(id.ID, id, 2), ft(Ua.ID, Ua, 0), H1(oM), re(new class extends Zi {
  constructor() {
    super({ id: UH, precondition: aM, kbOpts: { weight: 100, primary: 2137 } });
  }
  runEditorCommand(i, e) {
    var t;
    return (t = Ua.get(e)) === null || t === void 0 ? void 0 : t.changePasteType();
  }
}()), re(new class extends Zi {
  constructor() {
    super({ id: "editor.hidePasteWidget", precondition: aM, kbOpts: { weight: 100, primary: 9 } });
  }
  runEditorCommand(i, e) {
    var t;
    (t = Ua.get(e)) === null || t === void 0 || t.clearWidgets();
  }
}()), X((iC = class extends he {
  constructor() {
    super({ id: "editor.action.pasteAs", label: m(0, "Paste As..."), alias: "Paste As...", precondition: E.writable, metadata: { description: "Paste as", args: [{ name: "args", schema: iC.argsSchema }] } });
  }
  run(i, e, t) {
    var n;
    let s = typeof (t == null ? void 0 : t.kind) == "string" ? t.kind : void 0;
    return !s && t && (s = typeof t.id == "string" ? t.id : void 0), (n = Ua.get(e)) === null || n === void 0 ? void 0 : n.pasteAs(s ? new Nt(s) : void 0);
  }
}, iC.argsSchema = { type: "object", properties: { kind: { type: "string", description: m(0, "The kind of the paste edit to try applying. If not provided or there are multiple edits for this kind, the editor will show a picker.") } } }, iC)), X(class extends he {
  constructor() {
    super({ id: "editor.action.pasteAsText", label: m(0, "Paste as Text"), alias: "Paste as Text", precondition: E.writable });
  }
  run(i, e) {
    var t;
    return (t = Ua.get(e)) === null || t === void 0 ? void 0 : t.pasteAs({ providerId: Wd.id });
  }
});
class B6 {
  constructor(e) {
    this.identifier = e;
  }
}
const Tz = tt("treeViewsDndService");
rt(Tz, class {
  constructor() {
    this._dragOperations = /* @__PURE__ */ new Map();
  }
  removeDragOperationTransfer(i) {
    if (i && this._dragOperations.has(i)) {
      const e = this._dragOperations.get(i);
      return this._dragOperations.delete(i), e;
    }
  }
}, 1);
var OM, Pae = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, nC = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const Rz = "editor.experimental.dropIntoEditor.defaultProvider", Az = "editor.changeDropType", FM = new ae("dropWidgetVisible", !1, m(0, "Whether the drop widget is showing"));
let eu = OM = class extends V {
  static get(i) {
    return i.getContribution(OM.ID);
  }
  constructor(i, e, t, n, s) {
    super(), this._configService = t, this._languageFeaturesService = n, this._treeViewsDragAndDropService = s, this.treeItemsTransfer = Xv.getInstance(), this._dropProgressManager = this._register(e.createInstance(cS, "dropIntoEditor", i)), this._postDropWidgetManager = this._register(e.createInstance(uS, "dropIntoEditor", i, FM, { id: Az, label: m(0, "Show drop options...") })), this._register(i.onDropIntoEditor((o) => this.onDropIntoEditor(i, o.position, o.event)));
  }
  clearWidgets() {
    this._postDropWidgetManager.clear();
  }
  changeDropType() {
    this._postDropWidgetManager.tryShowSelector();
  }
  async onDropIntoEditor(i, e, t) {
    var n;
    if (!t.dataTransfer || !i.hasModel()) return;
    (n = this._currentOperation) === null || n === void 0 || n.cancel(), i.focus(), i.setPosition(e);
    const s = on(async (o) => {
      const r = new Mc(i, 1, void 0, o);
      try {
        const a = await this.extractDataTransferData(t);
        if (a.size === 0 || r.token.isCancellationRequested) return;
        const l = i.getModel();
        if (!l) return;
        const d = this._languageFeaturesService.documentOnDropEditProvider.ordered(l).filter((c) => !c.dropMimeTypes || c.dropMimeTypes.some((u) => a.matches(u))), h = await this.getDropEdits(d, l, e, a, r);
        if (r.token.isCancellationRequested) return;
        if (h.length) {
          const c = this.getInitialActiveEditIndex(l, h), u = i.getOption(36).showDropSelector === "afterDrop";
          await this._postDropWidgetManager.applyEditAndShowIfNeeded([D.fromPositions(e)], { activeEditIndex: c, allEdits: h }, u, async (g) => g, o);
        }
      } finally {
        r.dispose(), this._currentOperation === s && (this._currentOperation = void 0);
      }
    });
    this._dropProgressManager.showWhile(e, m(0, "Running drop handlers. Click to cancel"), s), this._currentOperation = s;
  }
  async getDropEdits(i, e, t, n, s) {
    const o = await v1(Promise.all(i.map(async (r) => {
      try {
        const a = await r.provideDocumentOnDropEdits(e, t, n, s.token);
        return a == null ? void 0 : a.map((l) => ({ ...l, providerId: r.id }));
      } catch (a) {
        console.error(a);
      }
    })), s.token);
    return HH(ca(o ?? []).flat());
  }
  getInitialActiveEditIndex(i, e) {
    const t = this._configService.getValue(Rz, { resource: i.uri });
    for (const [n, s] of Object.entries(t)) {
      const o = new Nt(s), r = e.findIndex((a) => o.value === a.providerId && a.handledMimeType && RH(n, [a.handledMimeType]));
      if (r >= 0) return r;
    }
    return 0;
  }
  async extractDataTransferData(i) {
    if (!i.dataTransfer) return new TH();
    const e = OH(i.dataTransfer);
    if (this.treeItemsTransfer.hasData(B6.prototype)) {
      const t = this.treeItemsTransfer.getData(B6.prototype);
      if (Array.isArray(t)) for (const n of t) {
        const s = await this._treeViewsDragAndDropService.removeDragOperationTransfer(n.identifier);
        if (s) for (const [o, r] of s) e.replace(o, r);
      }
    }
    return e;
  }
};
eu.ID = "editor.contrib.dropIntoEditorController", eu = OM = Pae([nC(1, Se), nC(2, Ye), nC(3, fe), nC(4, Tz)], eu), ft(eu.ID, eu, 2), H1(sM), re(new class extends Zi {
  constructor() {
    super({ id: Az, precondition: FM, kbOpts: { weight: 100, primary: 2137 } });
  }
  runEditorCommand(i, e, t) {
    var n;
    (n = eu.get(e)) === null || n === void 0 || n.changeDropType();
  }
}()), re(new class extends Zi {
  constructor() {
    super({ id: "editor.hideDropWidget", precondition: FM, kbOpts: { weight: 100, primary: 9 } });
  }
  runEditorCommand(i, e, t) {
    var n;
    (n = eu.get(e)) === null || n === void 0 || n.clearWidgets();
  }
}()), li.as(fa).registerConfiguration({ ...Iy, properties: { [Rz]: { type: "object", scope: 5, description: m(0, "Configures the default drop provider to use for content of a given mime type."), default: {}, additionalProperties: { type: "string" } } } });
class Zn {
  constructor(e) {
    this._editor = e, this._decorations = [], this._overviewRulerApproximateDecorations = [], this._findScopeDecorationIds = [], this._rangeHighlightDecorationId = null, this._highlightedDecorationId = null, this._startPosition = this._editor.getPosition();
  }
  dispose() {
    this._editor.removeDecorations(this._allDecorations()), this._decorations = [], this._overviewRulerApproximateDecorations = [], this._findScopeDecorationIds = [], this._rangeHighlightDecorationId = null, this._highlightedDecorationId = null;
  }
  reset() {
    this._decorations = [], this._overviewRulerApproximateDecorations = [], this._findScopeDecorationIds = [], this._rangeHighlightDecorationId = null, this._highlightedDecorationId = null;
  }
  getCount() {
    return this._decorations.length;
  }
  getFindScope() {
    return this._findScopeDecorationIds[0] ? this._editor.getModel().getDecorationRange(this._findScopeDecorationIds[0]) : null;
  }
  getFindScopes() {
    if (this._findScopeDecorationIds.length) {
      const e = this._findScopeDecorationIds.map((t) => this._editor.getModel().getDecorationRange(t)).filter((t) => !!t);
      if (e.length) return e;
    }
    return null;
  }
  getStartPosition() {
    return this._startPosition;
  }
  setStartPosition(e) {
    this._startPosition = e, this.setCurrentFindMatch(null);
  }
  _getDecorationIndex(e) {
    const t = this._decorations.indexOf(e);
    return t >= 0 ? t + 1 : 1;
  }
  getDecorationRangeAt(e) {
    const t = e < this._decorations.length ? this._decorations[e] : null;
    return t ? this._editor.getModel().getDecorationRange(t) : null;
  }
  getCurrentMatchesPosition(e) {
    const t = this._editor.getModel().getDecorationsInRange(e);
    for (const n of t) {
      const s = n.options;
      if (s === Zn._FIND_MATCH_DECORATION || s === Zn._CURRENT_FIND_MATCH_DECORATION) return this._getDecorationIndex(n.id);
    }
    return 0;
  }
  setCurrentFindMatch(e) {
    let t = null, n = 0;
    if (e) for (let s = 0, o = this._decorations.length; s < o; s++) {
      const r = this._editor.getModel().getDecorationRange(this._decorations[s]);
      if (e.equalsRange(r)) {
        t = this._decorations[s], n = s + 1;
        break;
      }
    }
    return this._highlightedDecorationId === null && t === null || this._editor.changeDecorations((s) => {
      if (this._highlightedDecorationId !== null && (s.changeDecorationOptions(this._highlightedDecorationId, Zn._FIND_MATCH_DECORATION), this._highlightedDecorationId = null), t !== null && (this._highlightedDecorationId = t, s.changeDecorationOptions(this._highlightedDecorationId, Zn._CURRENT_FIND_MATCH_DECORATION)), this._rangeHighlightDecorationId !== null && (s.removeDecoration(this._rangeHighlightDecorationId), this._rangeHighlightDecorationId = null), t !== null) {
        let o = this._editor.getModel().getDecorationRange(t);
        if (o.startLineNumber !== o.endLineNumber && o.endColumn === 1) {
          const r = o.endLineNumber - 1, a = this._editor.getModel().getLineMaxColumn(r);
          o = new D(o.startLineNumber, o.startColumn, r, a);
        }
        this._rangeHighlightDecorationId = s.addDecoration(o, Zn._RANGE_HIGHLIGHT_DECORATION);
      }
    }), n;
  }
  set(e, t) {
    this._editor.changeDecorations((n) => {
      let s = Zn._FIND_MATCH_DECORATION;
      const o = [];
      if (e.length > 1e3) {
        s = Zn._FIND_MATCH_NO_OVERVIEW_DECORATION;
        const a = this._editor.getModel().getLineCount(), l = this._editor.getLayoutInfo().height / a, d = Math.max(2, Math.ceil(3 / l));
        let h = e[0].range.startLineNumber, c = e[0].range.endLineNumber;
        for (let u = 1, g = e.length; u < g; u++) {
          const p = e[u].range;
          c + d >= p.startLineNumber ? p.endLineNumber > c && (c = p.endLineNumber) : (o.push({ range: new D(h, 1, c, 1), options: Zn._FIND_MATCH_ONLY_OVERVIEW_DECORATION }), h = p.startLineNumber, c = p.endLineNumber);
        }
        o.push({ range: new D(h, 1, c, 1), options: Zn._FIND_MATCH_ONLY_OVERVIEW_DECORATION });
      }
      const r = new Array(e.length);
      for (let a = 0, l = e.length; a < l; a++) r[a] = { range: e[a].range, options: s };
      this._decorations = n.deltaDecorations(this._decorations, r), this._overviewRulerApproximateDecorations = n.deltaDecorations(this._overviewRulerApproximateDecorations, o), this._rangeHighlightDecorationId && (n.removeDecoration(this._rangeHighlightDecorationId), this._rangeHighlightDecorationId = null), this._findScopeDecorationIds.length && (this._findScopeDecorationIds.forEach((a) => n.removeDecoration(a)), this._findScopeDecorationIds = []), t != null && t.length && (this._findScopeDecorationIds = t.map((a) => n.addDecoration(a, Zn._FIND_SCOPE_DECORATION)));
    });
  }
  matchBeforePosition(e) {
    if (this._decorations.length === 0) return null;
    for (let t = this._decorations.length - 1; t >= 0; t--) {
      const n = this._decorations[t], s = this._editor.getModel().getDecorationRange(n);
      if (s && !(s.endLineNumber > e.lineNumber) && (s.endLineNumber < e.lineNumber || !(s.endColumn > e.column)))
        return s;
    }
    return this._editor.getModel().getDecorationRange(this._decorations[this._decorations.length - 1]);
  }
  matchAfterPosition(e) {
    if (this._decorations.length === 0) return null;
    for (let t = 0, n = this._decorations.length; t < n; t++) {
      const s = this._decorations[t], o = this._editor.getModel().getDecorationRange(s);
      if (o && !(o.startLineNumber < e.lineNumber) && (o.startLineNumber > e.lineNumber || !(o.startColumn < e.column)))
        return o;
    }
    return this._editor.getModel().getDecorationRange(this._decorations[0]);
  }
  _allDecorations() {
    let e = [];
    return e = e.concat(this._decorations), e = e.concat(this._overviewRulerApproximateDecorations), this._findScopeDecorationIds.length && e.push(...this._findScopeDecorationIds), this._rangeHighlightDecorationId && e.push(this._rangeHighlightDecorationId), e;
  }
}
Zn._CURRENT_FIND_MATCH_DECORATION = Ve.register({ description: "current-find-match", stickiness: 1, zIndex: 13, className: "currentFindMatch", showIfCollapsed: !0, overviewRuler: { color: ui(uD), position: Do.Center }, minimap: { color: ui(Rp), position: 1 } }), Zn._FIND_MATCH_DECORATION = Ve.register({ description: "find-match", stickiness: 1, zIndex: 10, className: "findMatch", showIfCollapsed: !0, overviewRuler: { color: ui(uD), position: Do.Center }, minimap: { color: ui(Rp), position: 1 } }), Zn._FIND_MATCH_NO_OVERVIEW_DECORATION = Ve.register({ description: "find-match-no-overview", stickiness: 1, className: "findMatch", showIfCollapsed: !0 }), Zn._FIND_MATCH_ONLY_OVERVIEW_DECORATION = Ve.register({ description: "find-match-only-overview", stickiness: 1, overviewRuler: { color: ui(uD), position: Do.Center } }), Zn._RANGE_HIGHLIGHT_DECORATION = Ve.register({ description: "find-range-highlight", stickiness: 1, className: "rangeHighlight", isWholeLine: !0 }), Zn._FIND_SCOPE_DECORATION = Ve.register({ description: "find-scope", className: "findScope", isWholeLine: !0 });
class Oae {
  constructor(e, t, n) {
    this._editorSelection = e, this._ranges = t, this._replaceStrings = n, this._trackedEditorSelectionId = null;
  }
  getEditOperations(e, t) {
    if (this._ranges.length > 0) {
      const n = [];
      for (let r = 0; r < this._ranges.length; r++) n.push({ range: this._ranges[r], text: this._replaceStrings[r] });
      n.sort((r, a) => D.compareRangesUsingStarts(r.range, a.range));
      const s = [];
      let o = n[0];
      for (let r = 1; r < n.length; r++) o.range.endLineNumber === n[r].range.startLineNumber && o.range.endColumn === n[r].range.startColumn ? (o.range = o.range.plusRange(n[r].range), o.text = o.text + n[r].text) : (s.push(o), o = n[r]);
      s.push(o);
      for (const r of s) t.addEditOperation(r.range, r.text);
    }
    this._trackedEditorSelectionId = t.trackSelection(this._editorSelection);
  }
  computeCursorState(e, t) {
    return t.getTrackedSelection(this._trackedEditorSelectionId);
  }
}
function Pz(i, e) {
  if (i && i[0] !== "") {
    const t = W6(i, e, "-"), n = W6(i, e, "_");
    return t && !n ? V6(i, e, "-") : !t && n ? V6(i, e, "_") : i[0].toUpperCase() === i[0] ? e.toUpperCase() : i[0].toLowerCase() === i[0] ? e.toLowerCase() : function(s, o = !1) {
      return !!s && (o && (s = s.replace(/\\./g, "")), s.toLowerCase() !== s);
    }(i[0][0]) && e.length > 0 ? e[0].toUpperCase() + e.substr(1) : i[0][0].toUpperCase() !== i[0][0] && e.length > 0 ? e[0].toLowerCase() + e.substr(1) : e;
  }
  return e;
}
function W6(i, e, t) {
  return i[0].indexOf(t) !== -1 && e.indexOf(t) !== -1 && i[0].split(t).length === e.split(t).length;
}
function V6(i, e, t) {
  const n = e.split(t), s = i[0].split(t);
  let o = "";
  return n.forEach((r, a) => {
    o += Pz([s[a]], r) + t;
  }), o.slice(0, -1);
}
class H6 {
  constructor(e) {
    this.staticValue = e, this.kind = 0;
  }
}
class Fae {
  constructor(e) {
    this.pieces = e, this.kind = 1;
  }
}
class hf {
  static fromStaticValue(e) {
    return new hf([Ju.staticValue(e)]);
  }
  get hasReplacementPatterns() {
    return this._state.kind === 1;
  }
  constructor(e) {
    e && e.length !== 0 ? e.length === 1 && e[0].staticValue !== null ? this._state = new H6(e[0].staticValue) : this._state = new Fae(e) : this._state = new H6("");
  }
  buildReplaceString(e, t) {
    if (this._state.kind === 0) return t ? Pz(e, this._state.staticValue) : this._state.staticValue;
    let n = "";
    for (let s = 0, o = this._state.pieces.length; s < o; s++) {
      const r = this._state.pieces[s];
      if (r.staticValue !== null) {
        n += r.staticValue;
        continue;
      }
      let a = hf._substitute(r.matchIndex, e);
      if (r.caseOps !== null && r.caseOps.length > 0) {
        const l = [], d = r.caseOps.length;
        let h = 0;
        for (let c = 0, u = a.length; c < u; c++) {
          if (h >= d) {
            l.push(a.slice(c));
            break;
          }
          switch (r.caseOps[h]) {
            case "U":
              l.push(a[c].toUpperCase());
              break;
            case "u":
              l.push(a[c].toUpperCase()), h++;
              break;
            case "L":
              l.push(a[c].toLowerCase());
              break;
            case "l":
              l.push(a[c].toLowerCase()), h++;
              break;
            default:
              l.push(a[c]);
          }
        }
        a = l.join("");
      }
      n += a;
    }
    return n;
  }
  static _substitute(e, t) {
    if (t === null) return "";
    if (e === 0) return t[0];
    let n = "";
    for (; e > 0; ) {
      if (e < t.length)
        return (t[e] || "") + n;
      n = String(e % 10) + n, e = Math.floor(e / 10);
    }
    return "$" + n;
  }
}
class Ju {
  static staticValue(e) {
    return new Ju(e, -1, null);
  }
  static caseOps(e, t) {
    return new Ju(null, e, t);
  }
  constructor(e, t, n) {
    this.staticValue = e, this.matchIndex = t, n && n.length !== 0 ? this.caseOps = n.slice(0) : this.caseOps = null;
  }
}
class Bae {
  constructor(e) {
    this._source = e, this._lastCharIndex = 0, this._result = [], this._resultLen = 0, this._currentStaticPiece = "";
  }
  emitUnchanged(e) {
    this._emitStatic(this._source.substring(this._lastCharIndex, e)), this._lastCharIndex = e;
  }
  emitStatic(e, t) {
    this._emitStatic(e), this._lastCharIndex = t;
  }
  _emitStatic(e) {
    e.length !== 0 && (this._currentStaticPiece += e);
  }
  emitMatchIndex(e, t, n) {
    this._currentStaticPiece.length !== 0 && (this._result[this._resultLen++] = Ju.staticValue(this._currentStaticPiece), this._currentStaticPiece = ""), this._result[this._resultLen++] = Ju.caseOps(e, n), this._lastCharIndex = t;
  }
  finalize() {
    return this.emitUnchanged(this._source.length), this._currentStaticPiece.length !== 0 && (this._result[this._resultLen++] = Ju.staticValue(this._currentStaticPiece), this._currentStaticPiece = ""), new hf(this._result);
  }
}
const Gl = new ae("findWidgetVisible", !1);
Gl.toNegated();
const wS = new ae("findInputFocussed", !1), BM = new ae("replaceInputFocussed", !1), sC = { primary: 545, mac: { primary: 2593 } }, oC = { primary: 565, mac: { primary: 2613 } }, rC = { primary: 560, mac: { primary: 2608 } }, aC = { primary: 554, mac: { primary: 2602 } }, lC = { primary: 558, mac: { primary: 2606 } }, Wae = "actions.find", Vae = "actions.findWithSelection", Hae = "editor.actions.findWithArgs", WM = "editor.action.nextMatchFindAction", VM = "editor.action.previousMatchFindAction", zae = "editor.action.goToMatchFindAction", Uae = "editor.action.nextSelectionMatchFindAction", Kae = "editor.action.previousSelectionMatchFindAction", jae = "editor.action.startFindReplaceAction", Oz = "closeFindWidget", LP = "toggleFindCaseSensitive", kP = "toggleFindWholeWord", DP = "toggleFindRegex", Fz = "toggleFindInSelection", Bz = "togglePreserveCase", HM = "editor.action.replaceOne", zM = "editor.action.replaceAll", qae = "editor.action.selectAllMatches", Gh = 19999;
class E0 {
  constructor(e, t) {
    this._toDispose = new G(), this._editor = e, this._state = t, this._isDisposed = !1, this._startSearchingTimer = new Dr(), this._decorations = new Zn(e), this._toDispose.add(this._decorations), this._updateDecorationsScheduler = new It(() => this.research(!1), 100), this._toDispose.add(this._updateDecorationsScheduler), this._toDispose.add(this._editor.onDidChangeCursorPosition((n) => {
      n.reason !== 3 && n.reason !== 5 && n.reason !== 6 || this._decorations.setStartPosition(this._editor.getPosition());
    })), this._ignoreModelContentChanged = !1, this._toDispose.add(this._editor.onDidChangeModelContent((n) => {
      this._ignoreModelContentChanged || (n.isFlush && this._decorations.reset(), this._decorations.setStartPosition(this._editor.getPosition()), this._updateDecorationsScheduler.schedule());
    })), this._toDispose.add(this._state.onFindReplaceStateChange((n) => this._onStateChanged(n))), this.research(!1, this._state.searchScope);
  }
  dispose() {
    this._isDisposed = !0, Ht(this._startSearchingTimer), this._toDispose.dispose();
  }
  _onStateChanged(e) {
    !this._isDisposed && this._editor.hasModel() && (e.searchString || e.isReplaceRevealed || e.isRegex || e.wholeWord || e.matchCase || e.searchScope) && (this._editor.getModel().isTooLargeForSyncing() ? (this._startSearchingTimer.cancel(), this._startSearchingTimer.setIfNotSet(() => {
      e.searchScope ? this.research(e.moveCursor, this._state.searchScope) : this.research(e.moveCursor);
    }, 240)) : e.searchScope ? this.research(e.moveCursor, this._state.searchScope) : this.research(e.moveCursor));
  }
  static _getSearchRange(e, t) {
    return t || e.getFullModelRange();
  }
  research(e, t) {
    let n = null;
    t !== void 0 ? t !== null && (n = Array.isArray(t) ? t : [t]) : n = this._decorations.getFindScopes(), n !== null && (n = n.map((a) => {
      if (a.startLineNumber !== a.endLineNumber) {
        let l = a.endLineNumber;
        return a.endColumn === 1 && (l -= 1), new D(a.startLineNumber, 1, l, this._editor.getModel().getLineMaxColumn(l));
      }
      return a;
    }));
    const s = this._findMatches(n, !1, Gh);
    this._decorations.set(s, n);
    const o = this._editor.getSelection();
    let r = this._decorations.getCurrentMatchesPosition(o);
    if (r === 0 && s.length > 0) {
      const a = rv(s.map((l) => l.range), (l) => D.compareRangesUsingStarts(l, o) >= 0);
      r = a > 0 ? a - 1 + 1 : r;
    }
    this._state.changeMatchInfo(r, this._decorations.getCount(), void 0), e && this._editor.getOption(41).cursorMoveOnType && this._moveToNextMatch(this._decorations.getStartPosition());
  }
  _hasMatches() {
    return this._state.matchesCount > 0;
  }
  _cannotFind() {
    if (!this._hasMatches()) {
      const e = this._decorations.getFindScope();
      return e && this._editor.revealRangeInCenterIfOutsideViewport(e, 0), !0;
    }
    return !1;
  }
  _setCurrentFindMatch(e) {
    const t = this._decorations.setCurrentFindMatch(e);
    this._state.changeMatchInfo(t, this._decorations.getCount(), e), this._editor.setSelection(e), this._editor.revealRangeInCenterIfOutsideViewport(e, 0);
  }
  _prevSearchPosition(e) {
    const t = this._state.isRegex && (this._state.searchString.indexOf("^") >= 0 || this._state.searchString.indexOf("$") >= 0);
    let { lineNumber: n, column: s } = e;
    const o = this._editor.getModel();
    return t || s === 1 ? (n === 1 ? n = o.getLineCount() : n--, s = o.getLineMaxColumn(n)) : s--, new W(n, s);
  }
  _moveToPrevMatch(e, t = !1) {
    if (!this._state.canNavigateBack()) {
      const h = this._decorations.matchAfterPosition(e);
      return void (h && this._setCurrentFindMatch(h));
    }
    if (this._decorations.getCount() < Gh) {
      let h = this._decorations.matchBeforePosition(e);
      return h && h.isEmpty() && h.getStartPosition().equals(e) && (e = this._prevSearchPosition(e), h = this._decorations.matchBeforePosition(e)), void (h && this._setCurrentFindMatch(h));
    }
    if (this._cannotFind()) return;
    const n = this._decorations.getFindScope(), s = E0._getSearchRange(this._editor.getModel(), n);
    s.getEndPosition().isBefore(e) && (e = s.getEndPosition()), e.isBefore(s.getStartPosition()) && (e = s.getEndPosition());
    const { lineNumber: o, column: r } = e, a = this._editor.getModel();
    let l = new W(o, r), d = a.findPreviousMatch(this._state.searchString, l, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(131) : null, !1);
    return d && d.range.isEmpty() && d.range.getStartPosition().equals(l) && (l = this._prevSearchPosition(l), d = a.findPreviousMatch(this._state.searchString, l, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(131) : null, !1)), d ? t || s.containsRange(d.range) ? void this._setCurrentFindMatch(d.range) : this._moveToPrevMatch(d.range.getStartPosition(), !0) : void 0;
  }
  moveToPrevMatch() {
    this._moveToPrevMatch(this._editor.getSelection().getStartPosition());
  }
  _nextSearchPosition(e) {
    const t = this._state.isRegex && (this._state.searchString.indexOf("^") >= 0 || this._state.searchString.indexOf("$") >= 0);
    let { lineNumber: n, column: s } = e;
    const o = this._editor.getModel();
    return t || s === o.getLineMaxColumn(n) ? (n === o.getLineCount() ? n = 1 : n++, s = 1) : s++, new W(n, s);
  }
  _moveToNextMatch(e) {
    if (!this._state.canNavigateForward()) {
      const n = this._decorations.matchBeforePosition(e);
      return void (n && this._setCurrentFindMatch(n));
    }
    if (this._decorations.getCount() < Gh) {
      let n = this._decorations.matchAfterPosition(e);
      return n && n.isEmpty() && n.getStartPosition().equals(e) && (e = this._nextSearchPosition(e), n = this._decorations.matchAfterPosition(e)), void (n && this._setCurrentFindMatch(n));
    }
    const t = this._getNextMatch(e, !1, !0);
    t && this._setCurrentFindMatch(t.range);
  }
  _getNextMatch(e, t, n, s = !1) {
    if (this._cannotFind()) return null;
    const o = this._decorations.getFindScope(), r = E0._getSearchRange(this._editor.getModel(), o);
    r.getEndPosition().isBefore(e) && (e = r.getStartPosition()), e.isBefore(r.getStartPosition()) && (e = r.getStartPosition());
    const { lineNumber: a, column: l } = e, d = this._editor.getModel();
    let h = new W(a, l), c = d.findNextMatch(this._state.searchString, h, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(131) : null, t);
    return n && c && c.range.isEmpty() && c.range.getStartPosition().equals(h) && (h = this._nextSearchPosition(h), c = d.findNextMatch(this._state.searchString, h, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(131) : null, t)), c ? s || r.containsRange(c.range) ? c : this._getNextMatch(c.range.getEndPosition(), t, n, !0) : null;
  }
  moveToNextMatch() {
    this._moveToNextMatch(this._editor.getSelection().getEndPosition());
  }
  _moveToMatch(e) {
    const t = this._decorations.getDecorationRangeAt(e);
    t && this._setCurrentFindMatch(t);
  }
  moveToMatch(e) {
    this._moveToMatch(e);
  }
  _getReplacePattern() {
    return this._state.isRegex ? function(e) {
      if (!e || e.length === 0) return new hf(null);
      const t = [], n = new Bae(e);
      for (let s = 0, o = e.length; s < o; s++) {
        const r = e.charCodeAt(s);
        if (r !== 92) {
          if (r === 36) {
            if (s++, s >= o) break;
            const a = e.charCodeAt(s);
            if (a === 36) {
              n.emitUnchanged(s - 1), n.emitStatic("$", s + 1);
              continue;
            }
            if (a === 48 || a === 38) {
              n.emitUnchanged(s - 1), n.emitMatchIndex(0, s + 1, t), t.length = 0;
              continue;
            }
            if (49 <= a && a <= 57) {
              let l = a - 48;
              if (s + 1 < o) {
                const d = e.charCodeAt(s + 1);
                if (48 <= d && d <= 57) {
                  s++, l = 10 * l + (d - 48), n.emitUnchanged(s - 2), n.emitMatchIndex(l, s + 1, t), t.length = 0;
                  continue;
                }
              }
              n.emitUnchanged(s - 1), n.emitMatchIndex(l, s + 1, t), t.length = 0;
              continue;
            }
          }
        } else {
          if (s++, s >= o) break;
          const a = e.charCodeAt(s);
          switch (a) {
            case 92:
              n.emitUnchanged(s - 1), n.emitStatic("\\", s + 1);
              break;
            case 110:
              n.emitUnchanged(s - 1), n.emitStatic(`
`, s + 1);
              break;
            case 116:
              n.emitUnchanged(s - 1), n.emitStatic("	", s + 1);
              break;
            case 117:
            case 85:
            case 108:
            case 76:
              n.emitUnchanged(s - 1), n.emitStatic("", s + 1), t.push(String.fromCharCode(a));
          }
        }
      }
      return n.finalize();
    }(this._state.replaceString) : hf.fromStaticValue(this._state.replaceString);
  }
  replace() {
    if (!this._hasMatches()) return;
    const e = this._getReplacePattern(), t = this._editor.getSelection(), n = this._getNextMatch(t.getStartPosition(), !0, !1);
    if (n) if (t.equalsRange(n.range)) {
      const s = e.buildReplaceString(n.matches, this._state.preserveCase), o = new Dn(t, s);
      this._executeEditorCommand("replace", o), this._decorations.setStartPosition(new W(t.startLineNumber, t.startColumn + s.length)), this.research(!0);
    } else this._decorations.setStartPosition(this._editor.getPosition()), this._setCurrentFindMatch(n.range);
  }
  _findMatches(e, t, n) {
    const s = (e || [null]).map((o) => E0._getSearchRange(this._editor.getModel(), o));
    return this._editor.getModel().findMatches(this._state.searchString, s, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(131) : null, t, n);
  }
  replaceAll() {
    if (!this._hasMatches()) return;
    const e = this._decorations.getFindScopes();
    e === null && this._state.matchesCount >= Gh ? this._largeReplaceAll() : this._regularReplaceAll(e), this.research(!1);
  }
  _largeReplaceAll() {
    const e = new ou(this._state.searchString, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(131) : null).parseSearchRequest();
    if (!e) return;
    let t = e.regex;
    if (!t.multiline) {
      let h = "mu";
      t.ignoreCase && (h += "i"), t.global && (h += "g"), t = new RegExp(t.source, h);
    }
    const n = this._editor.getModel(), s = n.getValue(1), o = n.getFullModelRange(), r = this._getReplacePattern();
    let a;
    const l = this._state.preserveCase;
    a = r.hasReplacementPatterns || l ? s.replace(t, function() {
      return r.buildReplaceString(arguments, l);
    }) : s.replace(t, r.buildReplaceString(null, l));
    const d = new jR(o, a, this._editor.getSelection());
    this._executeEditorCommand("replaceAll", d);
  }
  _regularReplaceAll(e) {
    const t = this._getReplacePattern(), n = this._findMatches(e, t.hasReplacementPatterns || this._state.preserveCase, 1073741824), s = [];
    for (let r = 0, a = n.length; r < a; r++) s[r] = t.buildReplaceString(n[r].matches, this._state.preserveCase);
    const o = new Oae(this._editor.getSelection(), n.map((r) => r.range), s);
    this._executeEditorCommand("replaceAll", o);
  }
  selectAllMatches() {
    if (!this._hasMatches()) return;
    const e = this._decorations.getFindScopes();
    let t = this._findMatches(e, !1, 1073741824).map((s) => new _e(s.range.startLineNumber, s.range.startColumn, s.range.endLineNumber, s.range.endColumn));
    const n = this._editor.getSelection();
    for (let s = 0, o = t.length; s < o; s++)
      if (t[s].equalsRange(n)) {
        t = [n].concat(t.slice(0, s)).concat(t.slice(s + 1));
        break;
      }
    this._editor.setSelections(t);
  }
  _executeEditorCommand(e, t) {
    try {
      this._ignoreModelContentChanged = !0, this._editor.pushUndoStop(), this._editor.executeCommand(e, t), this._editor.pushUndoStop();
    } finally {
      this._ignoreModelContentChanged = !1;
    }
  }
}
class ok extends To {
  constructor(e, t, n) {
    super(), this._hideSoon = this._register(new It(() => this._hide(), 2e3)), this._isVisible = !1, this._editor = e, this._state = t, this._keybindingService = n, this._domNode = document.createElement("div"), this._domNode.className = "findOptionsWidget", this._domNode.style.display = "none", this._domNode.style.top = "10px", this._domNode.style.zIndex = "12", this._domNode.setAttribute("role", "presentation"), this._domNode.setAttribute("aria-hidden", "true");
    const s = { inputActiveOptionBorder: de(FR), inputActiveOptionForeground: de(BR), inputActiveOptionBackground: de(Iu) }, o = this._register(Xm());
    this.caseSensitive = this._register(new oV({ appendTitle: this._keybindingLabelFor(LP), isChecked: this._state.matchCase, hoverDelegate: o, ...s })), this._domNode.appendChild(this.caseSensitive.domNode), this._register(this.caseSensitive.onChange(() => {
      this._state.change({ matchCase: this.caseSensitive.checked }, !1);
    })), this.wholeWords = this._register(new rV({ appendTitle: this._keybindingLabelFor(kP), isChecked: this._state.wholeWord, hoverDelegate: o, ...s })), this._domNode.appendChild(this.wholeWords.domNode), this._register(this.wholeWords.onChange(() => {
      this._state.change({ wholeWord: this.wholeWords.checked }, !1);
    })), this.regex = this._register(new aV({ appendTitle: this._keybindingLabelFor(DP), isChecked: this._state.isRegex, hoverDelegate: o, ...s })), this._domNode.appendChild(this.regex.domNode), this._register(this.regex.onChange(() => {
      this._state.change({ isRegex: this.regex.checked }, !1);
    })), this._editor.addOverlayWidget(this), this._register(this._state.onFindReplaceStateChange((r) => {
      let a = !1;
      r.isRegex && (this.regex.checked = this._state.isRegex, a = !0), r.wholeWord && (this.wholeWords.checked = this._state.wholeWord, a = !0), r.matchCase && (this.caseSensitive.checked = this._state.matchCase, a = !0), !this._state.isRevealed && a && this._revealTemporarily();
    })), this._register(K(this._domNode, ie.MOUSE_LEAVE, (r) => this._onMouseLeave())), this._register(K(this._domNode, "mouseover", (r) => this._onMouseOver()));
  }
  _keybindingLabelFor(e) {
    const t = this._keybindingService.lookupKeybinding(e);
    return t ? ` (${t.getLabel()})` : "";
  }
  dispose() {
    this._editor.removeOverlayWidget(this), super.dispose();
  }
  getId() {
    return ok.ID;
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return { preference: 0 };
  }
  highlightFindOptions() {
    this._revealTemporarily();
  }
  _revealTemporarily() {
    this._show(), this._hideSoon.schedule();
  }
  _onMouseLeave() {
    this._hideSoon.schedule();
  }
  _onMouseOver() {
    this._hideSoon.cancel();
  }
  _show() {
    this._isVisible || (this._isVisible = !0, this._domNode.style.display = "block");
  }
  _hide() {
    this._isVisible && (this._isVisible = !1, this._domNode.style.display = "none");
  }
}
function dC(i, e) {
  return i === 1 || i !== 2 && e;
}
ok.ID = "editor.contrib.findOptionsWidget";
class $ae extends V {
  get searchString() {
    return this._searchString;
  }
  get replaceString() {
    return this._replaceString;
  }
  get isRevealed() {
    return this._isRevealed;
  }
  get isReplaceRevealed() {
    return this._isReplaceRevealed;
  }
  get isRegex() {
    return dC(this._isRegexOverride, this._isRegex);
  }
  get wholeWord() {
    return dC(this._wholeWordOverride, this._wholeWord);
  }
  get matchCase() {
    return dC(this._matchCaseOverride, this._matchCase);
  }
  get preserveCase() {
    return dC(this._preserveCaseOverride, this._preserveCase);
  }
  get actualIsRegex() {
    return this._isRegex;
  }
  get actualWholeWord() {
    return this._wholeWord;
  }
  get actualMatchCase() {
    return this._matchCase;
  }
  get actualPreserveCase() {
    return this._preserveCase;
  }
  get searchScope() {
    return this._searchScope;
  }
  get matchesPosition() {
    return this._matchesPosition;
  }
  get matchesCount() {
    return this._matchesCount;
  }
  get currentMatch() {
    return this._currentMatch;
  }
  constructor() {
    super(), this._onFindReplaceStateChange = this._register(new F()), this.onFindReplaceStateChange = this._onFindReplaceStateChange.event, this._searchString = "", this._replaceString = "", this._isRevealed = !1, this._isReplaceRevealed = !1, this._isRegex = !1, this._isRegexOverride = 0, this._wholeWord = !1, this._wholeWordOverride = 0, this._matchCase = !1, this._matchCaseOverride = 0, this._preserveCase = !1, this._preserveCaseOverride = 0, this._searchScope = null, this._matchesPosition = 0, this._matchesCount = 0, this._currentMatch = null, this._loop = !0, this._isSearching = !1, this._filters = null;
  }
  changeMatchInfo(e, t, n) {
    const s = { moveCursor: !1, updateHistory: !1, searchString: !1, replaceString: !1, isRevealed: !1, isReplaceRevealed: !1, isRegex: !1, wholeWord: !1, matchCase: !1, preserveCase: !1, searchScope: !1, matchesPosition: !1, matchesCount: !1, currentMatch: !1, loop: !1, isSearching: !1, filters: !1 };
    let o = !1;
    t === 0 && (e = 0), e > t && (e = t), this._matchesPosition !== e && (this._matchesPosition = e, s.matchesPosition = !0, o = !0), this._matchesCount !== t && (this._matchesCount = t, s.matchesCount = !0, o = !0), n !== void 0 && (D.equalsRange(this._currentMatch, n) || (this._currentMatch = n, s.currentMatch = !0, o = !0)), o && this._onFindReplaceStateChange.fire(s);
  }
  change(e, t, n = !0) {
    var s;
    const o = { moveCursor: t, updateHistory: n, searchString: !1, replaceString: !1, isRevealed: !1, isReplaceRevealed: !1, isRegex: !1, wholeWord: !1, matchCase: !1, preserveCase: !1, searchScope: !1, matchesPosition: !1, matchesCount: !1, currentMatch: !1, loop: !1, isSearching: !1, filters: !1 };
    let r = !1;
    const a = this.isRegex, l = this.wholeWord, d = this.matchCase, h = this.preserveCase;
    e.searchString !== void 0 && this._searchString !== e.searchString && (this._searchString = e.searchString, o.searchString = !0, r = !0), e.replaceString !== void 0 && this._replaceString !== e.replaceString && (this._replaceString = e.replaceString, o.replaceString = !0, r = !0), e.isRevealed !== void 0 && this._isRevealed !== e.isRevealed && (this._isRevealed = e.isRevealed, o.isRevealed = !0, r = !0), e.isReplaceRevealed !== void 0 && this._isReplaceRevealed !== e.isReplaceRevealed && (this._isReplaceRevealed = e.isReplaceRevealed, o.isReplaceRevealed = !0, r = !0), e.isRegex !== void 0 && (this._isRegex = e.isRegex), e.wholeWord !== void 0 && (this._wholeWord = e.wholeWord), e.matchCase !== void 0 && (this._matchCase = e.matchCase), e.preserveCase !== void 0 && (this._preserveCase = e.preserveCase), e.searchScope !== void 0 && (!((s = e.searchScope) === null || s === void 0) && s.every((c) => {
      var u;
      return (u = this._searchScope) === null || u === void 0 ? void 0 : u.some((g) => !D.equalsRange(g, c));
    }) || (this._searchScope = e.searchScope, o.searchScope = !0, r = !0)), e.loop !== void 0 && this._loop !== e.loop && (this._loop = e.loop, o.loop = !0, r = !0), e.isSearching !== void 0 && this._isSearching !== e.isSearching && (this._isSearching = e.isSearching, o.isSearching = !0, r = !0), e.filters !== void 0 && (this._filters ? this._filters.update(e.filters) : this._filters = e.filters, o.filters = !0, r = !0), this._isRegexOverride = e.isRegexOverride !== void 0 ? e.isRegexOverride : 0, this._wholeWordOverride = e.wholeWordOverride !== void 0 ? e.wholeWordOverride : 0, this._matchCaseOverride = e.matchCaseOverride !== void 0 ? e.matchCaseOverride : 0, this._preserveCaseOverride = e.preserveCaseOverride !== void 0 ? e.preserveCaseOverride : 0, a !== this.isRegex && (r = !0, o.isRegex = !0), l !== this.wholeWord && (r = !0, o.wholeWord = !0), d !== this.matchCase && (r = !0, o.matchCase = !0), h !== this.preserveCase && (r = !0, o.preserveCase = !0), r && this._onFindReplaceStateChange.fire(o);
  }
  canNavigateBack() {
    return this.canNavigateInLoop() || this.matchesPosition !== 1;
  }
  canNavigateForward() {
    return this.canNavigateInLoop() || this.matchesPosition < this.matchesCount;
  }
  canNavigateInLoop() {
    return this._loop || this.matchesCount >= Gh;
  }
}
const Gae = m(0, "input"), Zae = m(0, "Preserve Case");
class Yae extends wf {
  constructor(e) {
    var t;
    super({ icon: ne.preserveCase, title: Zae + e.appendTitle, isChecked: e.isChecked, hoverDelegate: (t = e.hoverDelegate) !== null && t !== void 0 ? t : Bs("element"), inputActiveOptionBorder: e.inputActiveOptionBorder, inputActiveOptionForeground: e.inputActiveOptionForeground, inputActiveOptionBackground: e.inputActiveOptionBackground });
  }
}
class Xae extends To {
  constructor(e, t, n, s) {
    super(), this._showOptionButtons = n, this.fixFocusOnOptionClickEnabled = !0, this.cachedOptionsWidth = 0, this._onDidOptionChange = this._register(new F()), this.onDidOptionChange = this._onDidOptionChange.event, this._onKeyDown = this._register(new F()), this.onKeyDown = this._onKeyDown.event, this._onMouseDown = this._register(new F()), this._onInput = this._register(new F()), this._onKeyUp = this._register(new F()), this._onPreserveCaseKeyDown = this._register(new F()), this.onPreserveCaseKeyDown = this._onPreserveCaseKeyDown.event, this.contextViewProvider = t, this.placeholder = s.placeholder || "", this.validation = s.validation, this.label = s.label || Gae;
    const o = s.appendPreserveCaseLabel || "", r = s.history || [], a = !!s.flexibleHeight, l = !!s.flexibleWidth, d = s.flexibleMaxHeight;
    this.domNode = document.createElement("div"), this.domNode.classList.add("monaco-findInput"), this.inputBox = this._register(new lV(this.domNode, this.contextViewProvider, { ariaLabel: this.label || "", placeholder: this.placeholder || "", validationOptions: { validation: this.validation }, history: r, showHistoryHint: s.showHistoryHint, flexibleHeight: a, flexibleWidth: l, flexibleMaxHeight: d, inputBoxStyles: s.inputBoxStyles })), this.preserveCase = this._register(new Yae({ appendTitle: o, isChecked: !1, ...s.toggleStyles })), this._register(this.preserveCase.onChange((u) => {
      this._onDidOptionChange.fire(u), !u && this.fixFocusOnOptionClickEnabled && this.inputBox.focus(), this.validate();
    })), this._register(this.preserveCase.onKeyDown((u) => {
      this._onPreserveCaseKeyDown.fire(u);
    })), this._showOptionButtons ? this.cachedOptionsWidth = this.preserveCase.width() : this.cachedOptionsWidth = 0;
    const h = [this.preserveCase.domNode];
    this.onkeydown(this.domNode, (u) => {
      if (u.equals(15) || u.equals(17) || u.equals(9)) {
        const g = h.indexOf(this.domNode.ownerDocument.activeElement);
        if (g >= 0) {
          let p = -1;
          u.equals(17) ? p = (g + 1) % h.length : u.equals(15) && (p = g === 0 ? h.length - 1 : g - 1), u.equals(9) ? (h[g].blur(), this.inputBox.focus()) : p >= 0 && h[p].focus(), Ze(u, !0);
        }
      }
    });
    const c = document.createElement("div");
    c.className = "controls", c.style.display = this._showOptionButtons ? "block" : "none", c.appendChild(this.preserveCase.domNode), this.domNode.appendChild(c), e == null || e.appendChild(this.domNode), this.onkeydown(this.inputBox.inputElement, (u) => this._onKeyDown.fire(u)), this.onkeyup(this.inputBox.inputElement, (u) => this._onKeyUp.fire(u)), this.oninput(this.inputBox.inputElement, (u) => this._onInput.fire()), this.onmousedown(this.inputBox.inputElement, (u) => this._onMouseDown.fire(u));
  }
  enable() {
    this.domNode.classList.remove("disabled"), this.inputBox.enable(), this.preserveCase.enable();
  }
  disable() {
    this.domNode.classList.add("disabled"), this.inputBox.disable(), this.preserveCase.disable();
  }
  setEnabled(e) {
    e ? this.enable() : this.disable();
  }
  select() {
    this.inputBox.select();
  }
  focus() {
    this.inputBox.focus();
  }
  getPreserveCase() {
    return this.preserveCase.checked;
  }
  setPreserveCase(e) {
    this.preserveCase.checked = e;
  }
  focusOnPreserve() {
    this.preserveCase.focus();
  }
  validate() {
    var e;
    (e = this.inputBox) === null || e === void 0 || e.validate();
  }
  set width(e) {
    this.inputBox.paddingRight = this.cachedOptionsWidth, this.domNode.style.width = e + "px";
  }
  dispose() {
    super.dispose();
  }
}
var Wz = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Vz = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const UM = new ae("suggestWidgetVisible", !1, m(0, "Whether suggestion are visible")), KM = "historyNavigationWidgetFocus", Hz = "historyNavigationForwardsEnabled", zz = "historyNavigationBackwardsEnabled";
let Hu;
const hC = [];
function Uz(i, e) {
  if (hC.includes(e)) throw new Error("Cannot register the same widget multiple times");
  hC.push(e);
  const t = new G(), n = new ae(KM, !1).bindTo(i), s = new ae(Hz, !0).bindTo(i), o = new ae(zz, !0).bindTo(i), r = () => {
    n.set(!0), Hu = e;
  }, a = () => {
    n.set(!1), Hu === e && (Hu = void 0);
  };
  return US(e.element) && r(), t.add(e.onDidFocus(() => r())), t.add(e.onDidBlur(() => a())), t.add(ye(() => {
    hC.splice(hC.indexOf(e), 1), a();
  })), { historyNavigationForwardsEnablement: s, historyNavigationBackwardsEnablement: o, dispose() {
    t.dispose();
  } };
}
let jM = class extends dV {
  constructor(i, e, t, n) {
    super(i, e, t);
    const s = this._register(n.createScoped(this.inputBox.element));
    this._register(Uz(s, this.inputBox));
  }
};
jM = Wz([Vz(3, Te)], jM);
let qM = class extends Xae {
  constructor(i, e, t, n, s = !1) {
    super(i, e, s, t);
    const o = this._register(n.createScoped(this.inputBox.element));
    this._register(Uz(o, this.inputBox));
  }
};
function z6(i) {
  var e, t;
  return ((e = i.lookupKeybinding("history.showPrevious")) === null || e === void 0 ? void 0 : e.getElectronAccelerator()) === "Up" && ((t = i.lookupKeybinding("history.showNext")) === null || t === void 0 ? void 0 : t.getElectronAccelerator()) === "Down";
}
qM = Wz([Vz(3, Te)], qM), Es.registerCommandAndKeybindingRule({ id: "history.showPrevious", weight: 200, when: q.and(q.has(KM), q.equals(zz, !0), q.not("isComposing"), UM.isEqualTo(!1)), primary: 16, secondary: [528], handler: (i) => {
  Hu == null || Hu.showPreviousValue();
} }), Es.registerCommandAndKeybindingRule({ id: "history.showNext", weight: 200, when: q.and(q.has(KM), q.equals(Hz, !0), q.not("isComposing"), UM.isEqualTo(!1)), primary: 18, secondary: [530], handler: (i) => {
  Hu == null || Hu.showNextValue();
} });
const Qae = Ei("find-selection", ne.selection, m(0, "Icon for 'Find in Selection' in the editor find widget.")), U6 = Ei("find-collapsed", ne.chevronRight, m(0, "Icon to indicate that the editor find widget is collapsed.")), K6 = Ei("find-expanded", ne.chevronDown, m(0, "Icon to indicate that the editor find widget is expanded.")), Jae = Ei("find-replace", ne.replace, m(0, "Icon for 'Replace' in the editor find widget.")), ele = Ei("find-replace-all", ne.replaceAll, m(0, "Icon for 'Replace All' in the editor find widget.")), tle = Ei("find-previous-match", ne.arrowUp, m(0, "Icon for 'Find Previous' in the editor find widget.")), ile = Ei("find-next-match", ne.arrowDown, m(0, "Icon for 'Find Next' in the editor find widget.")), nle = m(0, "Find / Replace"), sle = m(0, "Find"), ole = m(0, "Find"), rle = m(0, "Previous Match"), ale = m(0, "Next Match"), lle = m(0, "Find in Selection"), dle = m(0, "Close"), hle = m(0, "Replace"), cle = m(0, "Replace"), ule = m(0, "Replace"), gle = m(0, "Replace All"), ple = m(0, "Toggle Replace"), mle = m(0, "Only the first {0} results are highlighted, but all find operations work on the entire text.", Gh), fle = m(0, "{0} of {1}"), j6 = m(0, "No results"), op = 419;
let i_ = 69;
const q6 = "ctrlEnterReplaceAll.windows.donotask", $6 = Je ? 256 : 2048;
class Wx {
  constructor(e) {
    this.afterLineNumber = e, this.heightInPx = 33, this.suppressMouseDown = !1, this.domNode = document.createElement("div"), this.domNode.className = "dock-find-viewzone";
  }
}
function G6(i, e, t) {
  const n = !!e.match(/\n/);
  t && n && t.selectionStart > 0 && i.stopPropagation();
}
function Z6(i, e, t) {
  const n = !!e.match(/\n/);
  t && n && t.selectionEnd < t.value.length && i.stopPropagation();
}
class rk extends To {
  constructor(e, t, n, s, o, r, a, l, d) {
    super(), this._cachedHeight = null, this._revealTimeouts = [], this._codeEditor = e, this._controller = t, this._state = n, this._contextViewProvider = s, this._keybindingService = o, this._contextKeyService = r, this._storageService = l, this._notificationService = d, this._ctrlEnterReplaceAllWarningPrompted = !!l.getBoolean(q6, 0), this._isVisible = !1, this._isReplaceVisible = !1, this._ignoreChangeEvent = !1, this._updateHistoryDelayer = new Sr(500), this._register(ye(() => this._updateHistoryDelayer.cancel())), this._register(this._state.onFindReplaceStateChange((h) => this._onStateChanged(h))), this._buildDomNode(), this._updateButtons(), this._tryUpdateWidgetWidth(), this._findInput.inputBox.layout(), this._register(this._codeEditor.onDidChangeConfiguration((h) => {
      if (h.hasChanged(91) && (this._codeEditor.getOption(91) && this._state.change({ isReplaceRevealed: !1 }, !1), this._updateButtons()), h.hasChanged(145) && this._tryUpdateWidgetWidth(), h.hasChanged(2) && this.updateAccessibilitySupport(), h.hasChanged(41)) {
        const c = this._codeEditor.getOption(41).loop;
        this._state.change({ loop: c }, !1);
        const u = this._codeEditor.getOption(41).addExtraSpaceOnTop;
        u && !this._viewZone && (this._viewZone = new Wx(0), this._showViewZone()), !u && this._viewZone && this._removeViewZone();
      }
    })), this.updateAccessibilitySupport(), this._register(this._codeEditor.onDidChangeCursorSelection(() => {
      this._isVisible && this._updateToggleSelectionFindButton();
    })), this._register(this._codeEditor.onDidFocusEditorWidget(async () => {
      if (this._isVisible) {
        const h = await this._controller.getGlobalBufferTerm();
        h && h !== this._state.searchString && (this._state.change({ searchString: h }, !1), this._findInput.select());
      }
    })), this._findInputFocused = wS.bindTo(r), this._findFocusTracker = this._register(ma(this._findInput.inputBox.inputElement)), this._register(this._findFocusTracker.onDidFocus(() => {
      this._findInputFocused.set(!0), this._updateSearchScope();
    })), this._register(this._findFocusTracker.onDidBlur(() => {
      this._findInputFocused.set(!1);
    })), this._replaceInputFocused = BM.bindTo(r), this._replaceFocusTracker = this._register(ma(this._replaceInput.inputBox.inputElement)), this._register(this._replaceFocusTracker.onDidFocus(() => {
      this._replaceInputFocused.set(!0), this._updateSearchScope();
    })), this._register(this._replaceFocusTracker.onDidBlur(() => {
      this._replaceInputFocused.set(!1);
    })), this._codeEditor.addOverlayWidget(this), this._codeEditor.getOption(41).addExtraSpaceOnTop && (this._viewZone = new Wx(0)), this._register(this._codeEditor.onDidChangeModel(() => {
      this._isVisible && (this._viewZoneId = void 0);
    })), this._register(this._codeEditor.onDidScrollChange((h) => {
      h.scrollTopChanged ? this._layoutViewZone() : setTimeout(() => {
        this._layoutViewZone();
      }, 0);
    }));
  }
  getId() {
    return rk.ID;
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return this._isVisible ? { preference: 0 } : null;
  }
  _onStateChanged(e) {
    if (e.searchString) {
      try {
        this._ignoreChangeEvent = !0, this._findInput.setValue(this._state.searchString);
      } finally {
        this._ignoreChangeEvent = !1;
      }
      this._updateButtons();
    }
    if (e.replaceString && (this._replaceInput.inputBox.value = this._state.replaceString), e.isRevealed && (this._state.isRevealed ? this._reveal() : this._hide(!0)), e.isReplaceRevealed && (this._state.isReplaceRevealed ? this._codeEditor.getOption(91) || this._isReplaceVisible || (this._isReplaceVisible = !0, this._replaceInput.width = os(this._findInput.domNode), this._updateButtons(), this._replaceInput.inputBox.layout()) : this._isReplaceVisible && (this._isReplaceVisible = !1, this._updateButtons())), (e.isRevealed || e.isReplaceRevealed) && (this._state.isRevealed || this._state.isReplaceRevealed) && this._tryUpdateHeight() && this._showViewZone(), e.isRegex && this._findInput.setRegex(this._state.isRegex), e.wholeWord && this._findInput.setWholeWords(this._state.wholeWord), e.matchCase && this._findInput.setCaseSensitive(this._state.matchCase), e.preserveCase && this._replaceInput.setPreserveCase(this._state.preserveCase), e.searchScope && (this._state.searchScope ? this._toggleSelectionFind.checked = !0 : this._toggleSelectionFind.checked = !1, this._updateToggleSelectionFindButton()), e.searchString || e.matchesCount || e.matchesPosition) {
      const t = this._state.searchString.length > 0 && this._state.matchesCount === 0;
      this._domNode.classList.toggle("no-results", t), this._updateMatchesCount(), this._updateButtons();
    }
    (e.searchString || e.currentMatch) && this._layoutViewZone(), e.updateHistory && this._delayedUpdateHistory(), e.loop && this._updateButtons();
  }
  _delayedUpdateHistory() {
    this._updateHistoryDelayer.trigger(this._updateHistory.bind(this)).then(void 0, We);
  }
  _updateHistory() {
    this._state.searchString && this._findInput.inputBox.addToHistory(), this._state.replaceString && this._replaceInput.inputBox.addToHistory();
  }
  _updateMatchesCount() {
    let e;
    if (this._matchesCount.style.minWidth = i_ + "px", this._state.matchesCount >= Gh ? this._matchesCount.title = mle : this._matchesCount.title = "", this._matchesCount.firstChild && this._matchesCount.removeChild(this._matchesCount.firstChild), this._state.matchesCount > 0) {
      let t = String(this._state.matchesCount);
      this._state.matchesCount >= Gh && (t += "+");
      let n = String(this._state.matchesPosition);
      n === "0" && (n = "?"), e = rg(fle, n, t);
    } else e = j6;
    this._matchesCount.appendChild(document.createTextNode(e)), Io(this._getAriaLabel(e, this._state.currentMatch, this._state.searchString)), i_ = Math.max(i_, this._matchesCount.clientWidth);
  }
  _getAriaLabel(e, t, n) {
    if (e === j6) return n === "" ? m(0, "{0} found", e) : m(0, "{0} found for '{1}'", e, n);
    if (t) {
      const s = m(0, "{0} found for '{1}', at {2}", e, n, t.startLineNumber + ":" + t.startColumn), o = this._codeEditor.getModel();
      return o && t.startLineNumber <= o.getLineCount() && t.startLineNumber >= 1 ? `${o.getLineContent(t.startLineNumber)}, ${s}` : s;
    }
    return m(0, "{0} found for '{1}'", e, n);
  }
  _updateToggleSelectionFindButton() {
    const e = this._codeEditor.getSelection(), t = !!e && (e.startLineNumber !== e.endLineNumber || e.startColumn !== e.endColumn), n = this._toggleSelectionFind.checked;
    this._isVisible && (n || t) ? this._toggleSelectionFind.enable() : this._toggleSelectionFind.disable();
  }
  _updateButtons() {
    this._findInput.setEnabled(this._isVisible), this._replaceInput.setEnabled(this._isVisible && this._isReplaceVisible), this._updateToggleSelectionFindButton(), this._closeBtn.setEnabled(this._isVisible);
    const e = this._state.searchString.length > 0, t = !!this._state.matchesCount;
    this._prevBtn.setEnabled(this._isVisible && e && t && this._state.canNavigateBack()), this._nextBtn.setEnabled(this._isVisible && e && t && this._state.canNavigateForward()), this._replaceBtn.setEnabled(this._isVisible && this._isReplaceVisible && e), this._replaceAllBtn.setEnabled(this._isVisible && this._isReplaceVisible && e), this._domNode.classList.toggle("replaceToggled", this._isReplaceVisible), this._toggleReplaceBtn.setExpanded(this._isReplaceVisible);
    const n = !this._codeEditor.getOption(91);
    this._toggleReplaceBtn.setEnabled(this._isVisible && n);
  }
  _reveal() {
    if (this._revealTimeouts.forEach((e) => {
      clearTimeout(e);
    }), this._revealTimeouts = [], !this._isVisible) {
      this._isVisible = !0;
      const e = this._codeEditor.getSelection();
      switch (this._codeEditor.getOption(41).autoFindInSelection) {
        case "always":
          this._toggleSelectionFind.checked = !0;
          break;
        case "never":
          this._toggleSelectionFind.checked = !1;
          break;
        case "multiline": {
          const n = !!e && e.startLineNumber !== e.endLineNumber;
          this._toggleSelectionFind.checked = n;
          break;
        }
      }
      this._tryUpdateWidgetWidth(), this._updateButtons(), this._revealTimeouts.push(setTimeout(() => {
        this._domNode.classList.add("visible"), this._domNode.setAttribute("aria-hidden", "false");
      }, 0)), this._revealTimeouts.push(setTimeout(() => {
        this._findInput.validate();
      }, 200)), this._codeEditor.layoutOverlayWidget(this);
      let t = !0;
      if (this._codeEditor.getOption(41).seedSearchStringFromSelection && e) {
        const n = this._codeEditor.getDomNode();
        if (n) {
          const s = Ti(n), o = this._codeEditor.getScrolledVisiblePosition(e.getStartPosition()), r = s.left + (o ? o.left : 0), a = o ? o.top : 0;
          if (this._viewZone && a < this._viewZone.heightInPx) {
            e.endLineNumber > e.startLineNumber && (t = !1);
            const l = v8(this._domNode).left;
            r > l && (t = !1);
            const d = this._codeEditor.getScrolledVisiblePosition(e.getEndPosition());
            s.left + (d ? d.left : 0) > l && (t = !1);
          }
        }
      }
      this._showViewZone(t);
    }
  }
  _hide(e) {
    this._revealTimeouts.forEach((t) => {
      clearTimeout(t);
    }), this._revealTimeouts = [], this._isVisible && (this._isVisible = !1, this._updateButtons(), this._domNode.classList.remove("visible"), this._domNode.setAttribute("aria-hidden", "true"), this._findInput.clearMessage(), e && this._codeEditor.focus(), this._codeEditor.layoutOverlayWidget(this), this._removeViewZone());
  }
  _layoutViewZone(e) {
    if (!this._codeEditor.getOption(41).addExtraSpaceOnTop) return void this._removeViewZone();
    if (!this._isVisible) return;
    const t = this._viewZone;
    this._viewZoneId === void 0 && t && this._codeEditor.changeViewZones((n) => {
      t.heightInPx = this._getHeight(), this._viewZoneId = n.addZone(t), this._codeEditor.setScrollTop(e || this._codeEditor.getScrollTop() + t.heightInPx);
    });
  }
  _showViewZone(e = !0) {
    if (!this._isVisible || !this._codeEditor.getOption(41).addExtraSpaceOnTop) return;
    this._viewZone === void 0 && (this._viewZone = new Wx(0));
    const t = this._viewZone;
    this._codeEditor.changeViewZones((n) => {
      if (this._viewZoneId !== void 0) {
        const s = this._getHeight();
        if (s === t.heightInPx) return;
        const o = s - t.heightInPx;
        return t.heightInPx = s, n.layoutZone(this._viewZoneId), void (e && this._codeEditor.setScrollTop(this._codeEditor.getScrollTop() + o));
      }
      {
        let s = this._getHeight();
        if (s -= this._codeEditor.getOption(84).top, s <= 0) return;
        t.heightInPx = s, this._viewZoneId = n.addZone(t), e && this._codeEditor.setScrollTop(this._codeEditor.getScrollTop() + s);
      }
    });
  }
  _removeViewZone() {
    this._codeEditor.changeViewZones((e) => {
      this._viewZoneId !== void 0 && (e.removeZone(this._viewZoneId), this._viewZoneId = void 0, this._viewZone && (this._codeEditor.setScrollTop(this._codeEditor.getScrollTop() - this._viewZone.heightInPx), this._viewZone = void 0));
    });
  }
  _tryUpdateWidgetWidth() {
    if (!this._isVisible || !this._domNode.isConnected) return;
    const e = this._codeEditor.getLayoutInfo();
    if (e.contentWidth <= 0) return void this._domNode.classList.add("hiddenEditor");
    this._domNode.classList.contains("hiddenEditor") && this._domNode.classList.remove("hiddenEditor");
    const t = e.width, n = e.minimap.minimapWidth;
    let s = !1, o = !1, r = !1;
    if (this._resized && os(this._domNode) > op)
      return this._domNode.style.maxWidth = t - 28 - n - 15 + "px", void (this._replaceInput.width = os(this._findInput.domNode));
    if (447 + n >= t && (o = !0), 447 + n - i_ >= t && (r = !0), 447 + n - i_ >= t + 50 && (s = !0), this._domNode.classList.toggle("collapsed-find-widget", s), this._domNode.classList.toggle("narrow-find-widget", r), this._domNode.classList.toggle("reduced-find-widget", o), r || s || (this._domNode.style.maxWidth = t - 28 - n - 15 + "px"), this._findInput.layout({ collapsedFindWidget: s, narrowFindWidget: r, reducedFindWidget: o }), this._resized) {
      const a = this._findInput.inputBox.element.clientWidth;
      a > 0 && (this._replaceInput.width = a);
    } else this._isReplaceVisible && (this._replaceInput.width = os(this._findInput.domNode));
  }
  _getHeight() {
    let e = 0;
    return e += 4, e += this._findInput.inputBox.height + 2, this._isReplaceVisible && (e += 4, e += this._replaceInput.inputBox.height + 2), e += 4, e;
  }
  _tryUpdateHeight() {
    const e = this._getHeight();
    return (this._cachedHeight === null || this._cachedHeight !== e) && (this._cachedHeight = e, this._domNode.style.height = `${e}px`, !0);
  }
  focusFindInput() {
    this._findInput.select(), this._findInput.focus();
  }
  focusReplaceInput() {
    this._replaceInput.select(), this._replaceInput.focus();
  }
  highlightFindOptions() {
    this._findInput.highlightFindOptions();
  }
  _updateSearchScope() {
    if (this._codeEditor.hasModel() && this._toggleSelectionFind.checked) {
      const e = this._codeEditor.getSelections();
      e.map((t) => {
        t.endColumn === 1 && t.endLineNumber > t.startLineNumber && (t = t.setEndPosition(t.endLineNumber - 1, this._codeEditor.getModel().getLineMaxColumn(t.endLineNumber - 1)));
        const n = this._state.currentMatch;
        return t.startLineNumber === t.endLineNumber || D.equalsRange(t, n) ? null : t;
      }).filter((t) => !!t), e.length && this._state.change({ searchScope: e }, !0);
    }
  }
  _onFindInputMouseDown(e) {
    e.middleButton && e.stopPropagation();
  }
  _onFindInputKeyDown(e) {
    return e.equals(3 | $6) ? (this._keybindingService.dispatchEvent(e, e.target) || this._findInput.inputBox.insertAtCursor(`
`), void e.preventDefault()) : e.equals(2) ? (this._isReplaceVisible ? this._replaceInput.focus() : this._findInput.focusOnCaseSensitive(), void e.preventDefault()) : e.equals(2066) ? (this._codeEditor.focus(), void e.preventDefault()) : e.equals(16) ? G6(e, this._findInput.getValue(), this._findInput.domNode.querySelector("textarea")) : e.equals(18) ? Z6(e, this._findInput.getValue(), this._findInput.domNode.querySelector("textarea")) : void 0;
  }
  _onReplaceInputKeyDown(e) {
    return e.equals(3 | $6) ? (this._keybindingService.dispatchEvent(e, e.target) || (Tn && sa && !this._ctrlEnterReplaceAllWarningPrompted && (this._notificationService.info(m(0, "Ctrl+Enter now inserts line break instead of replacing all. You can modify the keybinding for editor.action.replaceAll to override this behavior.")), this._ctrlEnterReplaceAllWarningPrompted = !0, this._storageService.store(q6, !0, 0, 0)), this._replaceInput.inputBox.insertAtCursor(`
`)), void e.preventDefault()) : e.equals(2) ? (this._findInput.focusOnCaseSensitive(), void e.preventDefault()) : e.equals(1026) ? (this._findInput.focus(), void e.preventDefault()) : e.equals(2066) ? (this._codeEditor.focus(), void e.preventDefault()) : e.equals(16) ? G6(e, this._replaceInput.inputBox.value, this._replaceInput.inputBox.element.querySelector("textarea")) : e.equals(18) ? Z6(e, this._replaceInput.inputBox.value, this._replaceInput.inputBox.element.querySelector("textarea")) : void 0;
  }
  getVerticalSashLeft(e) {
    return 0;
  }
  _keybindingLabelFor(e) {
    const t = this._keybindingService.lookupKeybinding(e);
    return t ? ` (${t.getLabel()})` : "";
  }
  _buildDomNode() {
    this._findInput = this._register(new jM(null, this._contextViewProvider, { width: 221, label: sle, placeholder: ole, appendCaseSensitiveLabel: this._keybindingLabelFor(LP), appendWholeWordsLabel: this._keybindingLabelFor(kP), appendRegexLabel: this._keybindingLabelFor(DP), validation: (h) => {
      if (h.length === 0 || !this._findInput.getRegex()) return null;
      try {
        return new RegExp(h, "gu"), null;
      } catch (c) {
        return { content: c.message };
      }
    }, flexibleHeight: !0, flexibleWidth: !0, flexibleMaxHeight: 118, showCommonFindToggles: !0, showHistoryHint: () => z6(this._keybindingService), inputBoxStyles: Wy, toggleStyles: By }, this._contextKeyService)), this._findInput.setRegex(!!this._state.isRegex), this._findInput.setCaseSensitive(!!this._state.matchCase), this._findInput.setWholeWords(!!this._state.wholeWord), this._register(this._findInput.onKeyDown((h) => this._onFindInputKeyDown(h))), this._register(this._findInput.inputBox.onDidChange(() => {
      this._ignoreChangeEvent || this._state.change({ searchString: this._findInput.getValue() }, !0);
    })), this._register(this._findInput.onDidOptionChange(() => {
      this._state.change({ isRegex: this._findInput.getRegex(), wholeWord: this._findInput.getWholeWords(), matchCase: this._findInput.getCaseSensitive() }, !0);
    })), this._register(this._findInput.onCaseSensitiveKeyDown((h) => {
      h.equals(1026) && this._isReplaceVisible && (this._replaceInput.focus(), h.preventDefault());
    })), this._register(this._findInput.onRegexKeyDown((h) => {
      h.equals(2) && this._isReplaceVisible && (this._replaceInput.focusOnPreserve(), h.preventDefault());
    })), this._register(this._findInput.inputBox.onDidHeightChange((h) => {
      this._tryUpdateHeight() && this._showViewZone();
    })), Cs && this._register(this._findInput.onMouseDown((h) => this._onFindInputMouseDown(h))), this._matchesCount = document.createElement("div"), this._matchesCount.className = "matchesCount", this._updateMatchesCount();
    const n = this._register(Xm());
    this._prevBtn = this._register(new rp({ label: rle + this._keybindingLabelFor(VM), icon: tle, hoverDelegate: n, onTrigger: () => {
      xh(this._codeEditor.getAction(VM)).run().then(void 0, We);
    } })), this._nextBtn = this._register(new rp({ label: ale + this._keybindingLabelFor(WM), icon: ile, hoverDelegate: n, onTrigger: () => {
      xh(this._codeEditor.getAction(WM)).run().then(void 0, We);
    } }));
    const s = document.createElement("div");
    s.className = "find-part", s.appendChild(this._findInput.domNode);
    const o = document.createElement("div");
    o.className = "find-actions", s.appendChild(o), o.appendChild(this._matchesCount), o.appendChild(this._prevBtn.domNode), o.appendChild(this._nextBtn.domNode), this._toggleSelectionFind = this._register(new wf({ icon: Qae, title: lle + this._keybindingLabelFor(Fz), isChecked: !1, hoverDelegate: n, inputActiveOptionBackground: de(Iu), inputActiveOptionBorder: de(FR), inputActiveOptionForeground: de(BR) })), this._register(this._toggleSelectionFind.onChange(() => {
      if (this._toggleSelectionFind.checked) {
        if (this._codeEditor.hasModel()) {
          let h = this._codeEditor.getSelections();
          h = h.map((c) => (c.endColumn === 1 && c.endLineNumber > c.startLineNumber && (c = c.setEndPosition(c.endLineNumber - 1, this._codeEditor.getModel().getLineMaxColumn(c.endLineNumber - 1))), c.isEmpty() ? null : c)).filter((c) => !!c), h.length && this._state.change({ searchScope: h }, !0);
        }
      } else this._state.change({ searchScope: null }, !0);
    })), o.appendChild(this._toggleSelectionFind.domNode), this._closeBtn = this._register(new rp({ label: dle + this._keybindingLabelFor(Oz), icon: RV, hoverDelegate: n, onTrigger: () => {
      this._state.change({ isRevealed: !1, searchScope: null }, !1);
    }, onKeyDown: (h) => {
      h.equals(2) && this._isReplaceVisible && (this._replaceBtn.isEnabled() ? this._replaceBtn.focus() : this._codeEditor.focus(), h.preventDefault());
    } })), this._replaceInput = this._register(new qM(null, void 0, { label: hle, placeholder: cle, appendPreserveCaseLabel: this._keybindingLabelFor(Bz), history: [], flexibleHeight: !0, flexibleWidth: !0, flexibleMaxHeight: 118, showHistoryHint: () => z6(this._keybindingService), inputBoxStyles: Wy, toggleStyles: By }, this._contextKeyService, !0)), this._replaceInput.setPreserveCase(!!this._state.preserveCase), this._register(this._replaceInput.onKeyDown((h) => this._onReplaceInputKeyDown(h))), this._register(this._replaceInput.inputBox.onDidChange(() => {
      this._state.change({ replaceString: this._replaceInput.inputBox.value }, !1);
    })), this._register(this._replaceInput.inputBox.onDidHeightChange((h) => {
      this._isReplaceVisible && this._tryUpdateHeight() && this._showViewZone();
    })), this._register(this._replaceInput.onDidOptionChange(() => {
      this._state.change({ preserveCase: this._replaceInput.getPreserveCase() }, !0);
    })), this._register(this._replaceInput.onPreserveCaseKeyDown((h) => {
      h.equals(2) && (this._prevBtn.isEnabled() ? this._prevBtn.focus() : this._nextBtn.isEnabled() ? this._nextBtn.focus() : this._toggleSelectionFind.enabled ? this._toggleSelectionFind.focus() : this._closeBtn.isEnabled() && this._closeBtn.focus(), h.preventDefault());
    }));
    const r = this._register(Xm());
    this._replaceBtn = this._register(new rp({ label: ule + this._keybindingLabelFor(HM), icon: Jae, hoverDelegate: r, onTrigger: () => {
      this._controller.replace();
    }, onKeyDown: (h) => {
      h.equals(1026) && (this._closeBtn.focus(), h.preventDefault());
    } })), this._replaceAllBtn = this._register(new rp({ label: gle + this._keybindingLabelFor(zM), icon: ele, hoverDelegate: r, onTrigger: () => {
      this._controller.replaceAll();
    } }));
    const a = document.createElement("div");
    a.className = "replace-part", a.appendChild(this._replaceInput.domNode);
    const l = document.createElement("div");
    l.className = "replace-actions", a.appendChild(l), l.appendChild(this._replaceBtn.domNode), l.appendChild(this._replaceAllBtn.domNode), this._toggleReplaceBtn = this._register(new rp({ label: ple, className: "codicon toggle left", onTrigger: () => {
      this._state.change({ isReplaceRevealed: !this._isReplaceVisible }, !1), this._isReplaceVisible && (this._replaceInput.width = os(this._findInput.domNode), this._replaceInput.inputBox.layout()), this._showViewZone();
    } })), this._toggleReplaceBtn.setExpanded(this._isReplaceVisible), this._domNode = document.createElement("div"), this._domNode.className = "editor-widget find-widget", this._domNode.setAttribute("aria-hidden", "true"), this._domNode.ariaLabel = nle, this._domNode.role = "dialog", this._domNode.style.width = "419px", this._domNode.appendChild(this._toggleReplaceBtn.domNode), this._domNode.appendChild(s), this._domNode.appendChild(this._closeBtn.domNode), this._domNode.appendChild(a), this._resizeSash = this._register(new Bn(this._domNode, this, { orientation: 0, size: 2 })), this._resized = !1;
    let d = op;
    this._register(this._resizeSash.onDidStart(() => {
      d = os(this._domNode);
    })), this._register(this._resizeSash.onDidChange((h) => {
      this._resized = !0;
      const c = d + h.startX - h.currentX;
      c < op || c > (parseFloat(zS(this._domNode).maxWidth) || 0) || (this._domNode.style.width = `${c}px`, this._isReplaceVisible && (this._replaceInput.width = os(this._findInput.domNode)), this._findInput.inputBox.layout(), this._tryUpdateHeight());
    })), this._register(this._resizeSash.onDidReset(() => {
      const h = os(this._domNode);
      if (h < op) return;
      let c = op;
      if (!this._resized || h === op) {
        const u = this._codeEditor.getLayoutInfo();
        c = u.width - 28 - u.minimap.minimapWidth - 15, this._resized = !0;
      }
      this._domNode.style.width = `${c}px`, this._isReplaceVisible && (this._replaceInput.width = os(this._findInput.domNode)), this._findInput.inputBox.layout();
    }));
  }
  updateAccessibilitySupport() {
    const e = this._codeEditor.getOption(2);
    this._findInput.setFocusInputOnOptionClick(e !== 2);
  }
}
rk.ID = "editor.contrib.findWidget";
class rp extends To {
  constructor(e) {
    var t;
    super(), this._opts = e;
    let n = "button";
    this._opts.className && (n = n + " " + this._opts.className), this._opts.icon && (n = n + " " + Ee.asClassName(this._opts.icon)), this._domNode = document.createElement("div"), this._domNode.tabIndex = 0, this._domNode.className = n, this._domNode.setAttribute("role", "button"), this._domNode.setAttribute("aria-label", this._opts.label), this._register(xr((t = e.hoverDelegate) !== null && t !== void 0 ? t : Bs("element"), this._domNode, this._opts.label)), this.onclick(this._domNode, (s) => {
      this._opts.onTrigger(), s.preventDefault();
    }), this.onkeydown(this._domNode, (s) => {
      var o, r;
      if (s.equals(10) || s.equals(3)) return this._opts.onTrigger(), void s.preventDefault();
      (r = (o = this._opts).onKeyDown) === null || r === void 0 || r.call(o, s);
    });
  }
  get domNode() {
    return this._domNode;
  }
  isEnabled() {
    return this._domNode.tabIndex >= 0;
  }
  focus() {
    this._domNode.focus();
  }
  setEnabled(e) {
    this._domNode.classList.toggle("disabled", !e), this._domNode.setAttribute("aria-disabled", String(!e)), this._domNode.tabIndex = e ? 0 : -1;
  }
  setExpanded(e) {
    this._domNode.setAttribute("aria-expanded", String(!!e)), e ? (this._domNode.classList.remove(...Ee.asClassNameArray(U6)), this._domNode.classList.add(...Ee.asClassNameArray(K6))) : (this._domNode.classList.remove(...Ee.asClassNameArray(K6)), this._domNode.classList.add(...Ee.asClassNameArray(U6)));
  }
}
rr((i, e) => {
  const t = i.getColor(Rh);
  t && e.addRule(`.monaco-editor .findMatch { border: 1px ${la(i.type) ? "dotted" : "solid"} ${t}; box-sizing: border-box; }`);
  const n = i.getColor(C$);
  n && e.addRule(`.monaco-editor .findScope { border: 1px ${la(i.type) ? "dashed" : "solid"} ${n}; }`);
  const s = i.getColor(ot);
  s && e.addRule(`.monaco-editor .find-widget { border: 1px solid ${s}; }`);
});
var $M, Kz = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, qr = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
function GM(i, e = "single", t = !1) {
  if (!i.hasModel()) return null;
  const n = i.getSelection();
  if (e === "single" && n.startLineNumber === n.endLineNumber || e === "multiple") {
    if (n.isEmpty()) {
      const s = i.getConfiguredWordAtPosition(n.getStartPosition());
      if (s && t === !1) return s.word;
    } else if (i.getModel().getValueLengthInRange(n) < 524288) return i.getModel().getValueInRange(n);
  }
  return null;
}
let gs = $M = class extends V {
  get editor() {
    return this._editor;
  }
  static get(i) {
    return i.getContribution($M.ID);
  }
  constructor(i, e, t, n, s) {
    super(), this._editor = i, this._findWidgetVisible = Gl.bindTo(e), this._contextKeyService = e, this._storageService = t, this._clipboardService = n, this._notificationService = s, this._updateHistoryDelayer = new Sr(500), this._state = this._register(new $ae()), this.loadQueryState(), this._register(this._state.onFindReplaceStateChange((o) => this._onStateChanged(o))), this._model = null, this._register(this._editor.onDidChangeModel(() => {
      const o = this._editor.getModel() && this._state.isRevealed;
      this.disposeModel(), this._state.change({ searchScope: null, matchCase: this._storageService.getBoolean("editor.matchCase", 1, !1), wholeWord: this._storageService.getBoolean("editor.wholeWord", 1, !1), isRegex: this._storageService.getBoolean("editor.isRegex", 1, !1), preserveCase: this._storageService.getBoolean("editor.preserveCase", 1, !1) }, !1), o && this._start({ forceRevealReplace: !1, seedSearchStringFromSelection: "none", seedSearchStringFromNonEmptySelection: !1, seedSearchStringFromGlobalClipboard: !1, shouldFocus: 0, shouldAnimate: !1, updateSearchScope: !1, loop: this._editor.getOption(41).loop });
    }));
  }
  dispose() {
    this.disposeModel(), super.dispose();
  }
  disposeModel() {
    this._model && (this._model.dispose(), this._model = null);
  }
  _onStateChanged(i) {
    this.saveQueryState(i), i.isRevealed && (this._state.isRevealed ? this._findWidgetVisible.set(!0) : (this._findWidgetVisible.reset(), this.disposeModel())), i.searchString && this.setGlobalBufferTerm(this._state.searchString);
  }
  saveQueryState(i) {
    i.isRegex && this._storageService.store("editor.isRegex", this._state.actualIsRegex, 1, 1), i.wholeWord && this._storageService.store("editor.wholeWord", this._state.actualWholeWord, 1, 1), i.matchCase && this._storageService.store("editor.matchCase", this._state.actualMatchCase, 1, 1), i.preserveCase && this._storageService.store("editor.preserveCase", this._state.actualPreserveCase, 1, 1);
  }
  loadQueryState() {
    this._state.change({ matchCase: this._storageService.getBoolean("editor.matchCase", 1, this._state.matchCase), wholeWord: this._storageService.getBoolean("editor.wholeWord", 1, this._state.wholeWord), isRegex: this._storageService.getBoolean("editor.isRegex", 1, this._state.isRegex), preserveCase: this._storageService.getBoolean("editor.preserveCase", 1, this._state.preserveCase) }, !1);
  }
  isFindInputFocused() {
    return !!wS.getValue(this._contextKeyService);
  }
  getState() {
    return this._state;
  }
  closeFindWidget() {
    this._state.change({ isRevealed: !1, searchScope: null }, !1), this._editor.focus();
  }
  toggleCaseSensitive() {
    this._state.change({ matchCase: !this._state.matchCase }, !1), this._state.isRevealed || this.highlightFindOptions();
  }
  toggleWholeWords() {
    this._state.change({ wholeWord: !this._state.wholeWord }, !1), this._state.isRevealed || this.highlightFindOptions();
  }
  toggleRegex() {
    this._state.change({ isRegex: !this._state.isRegex }, !1), this._state.isRevealed || this.highlightFindOptions();
  }
  togglePreserveCase() {
    this._state.change({ preserveCase: !this._state.preserveCase }, !1), this._state.isRevealed || this.highlightFindOptions();
  }
  toggleSearchScope() {
    if (this._state.searchScope) this._state.change({ searchScope: null }, !0);
    else if (this._editor.hasModel()) {
      let i = this._editor.getSelections();
      i = i.map((e) => (e.endColumn === 1 && e.endLineNumber > e.startLineNumber && (e = e.setEndPosition(e.endLineNumber - 1, this._editor.getModel().getLineMaxColumn(e.endLineNumber - 1))), e.isEmpty() ? null : e)).filter((e) => !!e), i.length && this._state.change({ searchScope: i }, !0);
    }
  }
  setSearchString(i) {
    this._state.isRegex && (i = No(i)), this._state.change({ searchString: i }, !1);
  }
  highlightFindOptions(i = !1) {
  }
  async _start(i, e) {
    if (this.disposeModel(), !this._editor.hasModel()) return;
    const t = { ...e, isRevealed: !0 };
    if (i.seedSearchStringFromSelection === "single") {
      const n = GM(this._editor, i.seedSearchStringFromSelection, i.seedSearchStringFromNonEmptySelection);
      n && (this._state.isRegex ? t.searchString = No(n) : t.searchString = n);
    } else if (i.seedSearchStringFromSelection === "multiple" && !i.updateSearchScope) {
      const n = GM(this._editor, i.seedSearchStringFromSelection);
      n && (t.searchString = n);
    }
    if (!t.searchString && i.seedSearchStringFromGlobalClipboard) {
      const n = await this.getGlobalBufferTerm();
      if (!this._editor.hasModel()) return;
      n && (t.searchString = n);
    }
    if (i.forceRevealReplace || t.isReplaceRevealed ? t.isReplaceRevealed = !0 : this._findWidgetVisible.get() || (t.isReplaceRevealed = !1), i.updateSearchScope) {
      const n = this._editor.getSelections();
      n.some((s) => !s.isEmpty()) && (t.searchScope = n);
    }
    t.loop = i.loop, this._state.change(t, !1), this._model || (this._model = new E0(this._editor, this._state));
  }
  start(i, e) {
    return this._start(i, e);
  }
  moveToNextMatch() {
    return !!this._model && (this._model.moveToNextMatch(), !0);
  }
  moveToPrevMatch() {
    return !!this._model && (this._model.moveToPrevMatch(), !0);
  }
  goToMatch(i) {
    return !!this._model && (this._model.moveToMatch(i), !0);
  }
  replace() {
    return !!this._model && (this._model.replace(), !0);
  }
  replaceAll() {
    var i;
    return !!this._model && (!((i = this._editor.getModel()) === null || i === void 0) && i.isTooLargeForHeapOperation() ? (this._notificationService.warn(m(0, "The file is too large to perform a replace all operation.")), !1) : (this._model.replaceAll(), !0));
  }
  selectAllMatches() {
    return !!this._model && (this._model.selectAllMatches(), this._editor.focus(), !0);
  }
  async getGlobalBufferTerm() {
    return this._editor.getOption(41).globalFindClipboard && this._editor.hasModel() && !this._editor.getModel().isTooLargeForSyncing() ? this._clipboardService.readFindText() : "";
  }
  setGlobalBufferTerm(i) {
    this._editor.getOption(41).globalFindClipboard && this._editor.hasModel() && !this._editor.getModel().isTooLargeForSyncing() && this._clipboardService.writeFindText(i);
  }
};
gs.ID = "editor.contrib.findController", gs = $M = Kz([qr(1, Te), qr(2, Nr), qr(3, Kd), qr(4, Ri)], gs);
let ZM = class extends gs {
  constructor(i, e, t, n, s, o, r, a) {
    super(i, t, r, a, o), this._contextViewService = e, this._keybindingService = n, this._themeService = s, this._widget = null, this._findOptionsWidget = null;
  }
  async _start(i, e) {
    this._widget || this._createFindWidget();
    const t = this._editor.getSelection();
    let n = !1;
    switch (this._editor.getOption(41).autoFindInSelection) {
      case "always":
        n = !0;
        break;
      case "never":
        n = !1;
        break;
      case "multiline":
        n = !!t && t.startLineNumber !== t.endLineNumber;
        break;
    }
    i.updateSearchScope = i.updateSearchScope || n, await super._start(i, e), this._widget && (i.shouldFocus === 2 ? this._widget.focusReplaceInput() : i.shouldFocus === 1 && this._widget.focusFindInput());
  }
  highlightFindOptions(i = !1) {
    this._widget || this._createFindWidget(), this._state.isRevealed && !i ? this._widget.highlightFindOptions() : this._findOptionsWidget.highlightFindOptions();
  }
  _createFindWidget() {
    this._widget = this._register(new rk(this._editor, this, this._state, this._contextViewService, this._keybindingService, this._contextKeyService, this._themeService, this._storageService, this._notificationService)), this._findOptionsWidget = this._register(new ok(this._editor, this._state, this._keybindingService));
  }
};
ZM = Kz([qr(1, zd), qr(2, Te), qr(3, Dt), qr(4, Yi), qr(5, Ri), qr(6, Nr), qr(7, Kd)], ZM);
P8(new A8({ id: Wae, label: m(0, "Find"), alias: "Find", precondition: q.or(E.focus, q.has("editorIsOpen")), kbOpts: { kbExpr: null, primary: 2084, weight: 100 }, menuOpts: { menuId: x.MenubarEditMenu, group: "3_find", title: m(0, "&&Find"), order: 1 } })).addImplementation(0, (i, e, t) => {
  const n = gs.get(e);
  return !!n && n.start({ forceRevealReplace: !1, seedSearchStringFromSelection: e.getOption(41).seedSearchStringFromSelection !== "never" ? "single" : "none", seedSearchStringFromNonEmptySelection: e.getOption(41).seedSearchStringFromSelection === "selection", seedSearchStringFromGlobalClipboard: e.getOption(41).globalFindClipboard, shouldFocus: 1, shouldAnimate: !0, updateSearchScope: !1, loop: e.getOption(41).loop });
});
const _le = { description: "Open a new In-Editor Find Widget.", args: [{ name: "Open a new In-Editor Find Widget args", schema: { properties: { searchString: { type: "string" }, replaceString: { type: "string" }, isRegex: { type: "boolean" }, matchWholeWord: { type: "boolean" }, isCaseSensitive: { type: "boolean" }, preserveCase: { type: "boolean" }, findInSelection: { type: "boolean" } } } }] };
class Y6 extends he {
  async run(e, t) {
    const n = gs.get(t);
    n && !this._run(n) && (await n.start({ forceRevealReplace: !1, seedSearchStringFromSelection: n.getState().searchString.length === 0 && t.getOption(41).seedSearchStringFromSelection !== "never" ? "single" : "none", seedSearchStringFromNonEmptySelection: t.getOption(41).seedSearchStringFromSelection === "selection", seedSearchStringFromGlobalClipboard: !0, shouldFocus: 0, shouldAnimate: !0, updateSearchScope: !1, loop: t.getOption(41).loop }), this._run(n));
  }
}
class X6 extends he {
  async run(e, t) {
    const n = gs.get(t);
    if (!n) return;
    const s = GM(t, "single", !1);
    s && n.setSearchString(s), this._run(n) || (await n.start({ forceRevealReplace: !1, seedSearchStringFromSelection: "none", seedSearchStringFromNonEmptySelection: !1, seedSearchStringFromGlobalClipboard: !1, shouldFocus: 0, shouldAnimate: !0, updateSearchScope: !1, loop: t.getOption(41).loop }), this._run(n));
  }
}
P8(new A8({ id: jae, label: m(0, "Replace"), alias: "Replace", precondition: q.or(E.focus, q.has("editorIsOpen")), kbOpts: { kbExpr: null, primary: 2086, mac: { primary: 2596 }, weight: 100 }, menuOpts: { menuId: x.MenubarEditMenu, group: "3_find", title: m(0, "&&Replace"), order: 2 } })).addImplementation(0, (i, e, t) => {
  if (!e.hasModel() || e.getOption(91)) return !1;
  const n = gs.get(e);
  if (!n) return !1;
  const s = e.getSelection(), o = n.isFindInputFocused(), r = !s.isEmpty() && s.startLineNumber === s.endLineNumber && e.getOption(41).seedSearchStringFromSelection !== "never" && !o, a = o || r ? 2 : 1;
  return n.start({ forceRevealReplace: !0, seedSearchStringFromSelection: r ? "single" : "none", seedSearchStringFromNonEmptySelection: e.getOption(41).seedSearchStringFromSelection === "selection", seedSearchStringFromGlobalClipboard: e.getOption(41).seedSearchStringFromSelection !== "never", shouldFocus: a, shouldAnimate: !0, updateSearchScope: !1, loop: e.getOption(41).loop });
}), ft(gs.ID, ZM, 0), X(class extends he {
  constructor() {
    super({ id: Hae, label: m(0, "Find With Arguments"), alias: "Find With Arguments", precondition: void 0, kbOpts: { kbExpr: null, primary: 0, weight: 100 }, metadata: _le });
  }
  async run(i, e, t) {
    const n = gs.get(e);
    if (n) {
      const s = t ? { searchString: t.searchString, replaceString: t.replaceString, isReplaceRevealed: t.replaceString !== void 0, isRegex: t.isRegex, wholeWord: t.matchWholeWord, matchCase: t.isCaseSensitive, preserveCase: t.preserveCase } : {};
      await n.start({ forceRevealReplace: !1, seedSearchStringFromSelection: n.getState().searchString.length === 0 && e.getOption(41).seedSearchStringFromSelection !== "never" ? "single" : "none", seedSearchStringFromNonEmptySelection: e.getOption(41).seedSearchStringFromSelection === "selection", seedSearchStringFromGlobalClipboard: !0, shouldFocus: 1, shouldAnimate: !0, updateSearchScope: (t == null ? void 0 : t.findInSelection) || !1, loop: e.getOption(41).loop }, s), n.setGlobalBufferTerm(n.getState().searchString);
    }
  }
}), X(class extends he {
  constructor() {
    super({ id: Vae, label: m(0, "Find With Selection"), alias: "Find With Selection", precondition: void 0, kbOpts: { kbExpr: null, primary: 0, mac: { primary: 2083 }, weight: 100 } });
  }
  async run(i, e) {
    const t = gs.get(e);
    t && (await t.start({ forceRevealReplace: !1, seedSearchStringFromSelection: "multiple", seedSearchStringFromNonEmptySelection: !1, seedSearchStringFromGlobalClipboard: !1, shouldFocus: 0, shouldAnimate: !0, updateSearchScope: !1, loop: e.getOption(41).loop }), t.setGlobalBufferTerm(t.getState().searchString));
  }
}), X(class extends Y6 {
  constructor() {
    super({ id: WM, label: m(0, "Find Next"), alias: "Find Next", precondition: void 0, kbOpts: [{ kbExpr: E.focus, primary: 61, mac: { primary: 2085, secondary: [61] }, weight: 100 }, { kbExpr: q.and(E.focus, wS), primary: 3, weight: 100 }] });
  }
  _run(i) {
    return !!i.moveToNextMatch() && (i.editor.pushUndoStop(), !0);
  }
}), X(class extends Y6 {
  constructor() {
    super({ id: VM, label: m(0, "Find Previous"), alias: "Find Previous", precondition: void 0, kbOpts: [{ kbExpr: E.focus, primary: 1085, mac: { primary: 3109, secondary: [1085] }, weight: 100 }, { kbExpr: q.and(E.focus, wS), primary: 1027, weight: 100 }] });
  }
  _run(i) {
    return i.moveToPrevMatch();
  }
}), X(class extends he {
  constructor() {
    super({ id: zae, label: m(0, "Go to Match..."), alias: "Go to Match...", precondition: Gl }), this._highlightDecorations = [];
  }
  run(i, e, t) {
    const n = gs.get(e);
    if (!n) return;
    const s = n.getState().matchesCount;
    if (s < 1)
      return void i.get(Ri).notify({ severity: fL.Warning, message: m(0, "No matches. Try searching for something else.") });
    const o = i.get(La).createInputBox();
    o.placeholder = m(0, "Type a number to go to a specific match (between 1 and {0})", s);
    const r = (l) => {
      const d = parseInt(l);
      if (isNaN(d)) return;
      const h = n.getState().matchesCount;
      return d > 0 && d <= h ? d - 1 : d < 0 && d >= -h ? h + d : void 0;
    }, a = (l) => {
      const d = r(l);
      if (typeof d == "number") {
        o.validationMessage = void 0, n.goToMatch(d);
        const h = n.getState().currentMatch;
        h && this.addDecorations(e, h);
      } else o.validationMessage = m(0, "Please type a number between 1 and {0}", n.getState().matchesCount), this.clearDecorations(e);
    };
    o.onDidChangeValue((l) => {
      a(l);
    }), o.onDidAccept(() => {
      const l = r(o.value);
      typeof l == "number" ? (n.goToMatch(l), o.hide()) : o.validationMessage = m(0, "Please type a number between 1 and {0}", n.getState().matchesCount);
    }), o.onDidHide(() => {
      this.clearDecorations(e), o.dispose();
    }), o.show();
  }
  clearDecorations(i) {
    i.changeDecorations((e) => {
      this._highlightDecorations = e.deltaDecorations(this._highlightDecorations, []);
    });
  }
  addDecorations(i, e) {
    i.changeDecorations((t) => {
      this._highlightDecorations = t.deltaDecorations(this._highlightDecorations, [{ range: e, options: { description: "find-match-quick-access-range-highlight", className: "rangeHighlight", isWholeLine: !0 } }, { range: e, options: { description: "find-match-quick-access-range-highlight-overview", overviewRuler: { color: ui(IB), position: Do.Full } } }]);
    });
  }
}), X(class extends X6 {
  constructor() {
    super({ id: Uae, label: m(0, "Find Next Selection"), alias: "Find Next Selection", precondition: void 0, kbOpts: { kbExpr: E.focus, primary: 2109, weight: 100 } });
  }
  _run(i) {
    return i.moveToNextMatch();
  }
}), X(class extends X6 {
  constructor() {
    super({ id: Kae, label: m(0, "Find Previous Selection"), alias: "Find Previous Selection", precondition: void 0, kbOpts: { kbExpr: E.focus, primary: 3133, weight: 100 } });
  }
  _run(i) {
    return i.moveToPrevMatch();
  }
});
const Ar = Zi.bindToContribution(gs.get);
re(new Ar({ id: Oz, precondition: Gl, handler: (i) => i.closeFindWidget(), kbOpts: { weight: 105, kbExpr: q.and(E.focus, q.not("isComposing")), primary: 9, secondary: [1033] } })), re(new Ar({ id: LP, precondition: void 0, handler: (i) => i.toggleCaseSensitive(), kbOpts: { weight: 105, kbExpr: E.focus, primary: sC.primary, mac: sC.mac, win: sC.win, linux: sC.linux } })), re(new Ar({ id: kP, precondition: void 0, handler: (i) => i.toggleWholeWords(), kbOpts: { weight: 105, kbExpr: E.focus, primary: oC.primary, mac: oC.mac, win: oC.win, linux: oC.linux } })), re(new Ar({ id: DP, precondition: void 0, handler: (i) => i.toggleRegex(), kbOpts: { weight: 105, kbExpr: E.focus, primary: rC.primary, mac: rC.mac, win: rC.win, linux: rC.linux } })), re(new Ar({ id: Fz, precondition: void 0, handler: (i) => i.toggleSearchScope(), kbOpts: { weight: 105, kbExpr: E.focus, primary: aC.primary, mac: aC.mac, win: aC.win, linux: aC.linux } })), re(new Ar({ id: Bz, precondition: void 0, handler: (i) => i.togglePreserveCase(), kbOpts: { weight: 105, kbExpr: E.focus, primary: lC.primary, mac: lC.mac, win: lC.win, linux: lC.linux } })), re(new Ar({ id: HM, precondition: Gl, handler: (i) => i.replace(), kbOpts: { weight: 105, kbExpr: E.focus, primary: 3094 } })), re(new Ar({ id: HM, precondition: Gl, handler: (i) => i.replace(), kbOpts: { weight: 105, kbExpr: q.and(E.focus, BM), primary: 3 } })), re(new Ar({ id: zM, precondition: Gl, handler: (i) => i.replaceAll(), kbOpts: { weight: 105, kbExpr: E.focus, primary: 2563 } })), re(new Ar({ id: zM, precondition: Gl, handler: (i) => i.replaceAll(), kbOpts: { weight: 105, kbExpr: q.and(E.focus, BM), primary: void 0, mac: { primary: 2051 } } })), re(new Ar({ id: qae, precondition: Gl, handler: (i) => i.selectAllMatches(), kbOpts: { weight: 105, kbExpr: E.focus, primary: 515 } }));
const vle = { 0: " ", 1: "u", 2: "r" }, $r = 16777215, Q6 = 4278190080;
class Vx {
  constructor(e) {
    const t = Math.ceil(e / 32);
    this._states = new Uint32Array(t);
  }
  get(e) {
    const t = e / 32 | 0, n = e % 32;
    return !!(this._states[t] & 1 << n);
  }
  set(e, t) {
    const n = e / 32 | 0, s = e % 32, o = this._states[n];
    this._states[n] = t ? o | 1 << s : o & ~(1 << s);
  }
}
class go {
  constructor(e, t, n) {
    if (e.length !== t.length || e.length > 65535) throw new Error("invalid startIndexes or endIndexes size");
    this._startIndexes = e, this._endIndexes = t, this._collapseStates = new Vx(e.length), this._userDefinedStates = new Vx(e.length), this._recoveredStates = new Vx(e.length), this._types = n, this._parentsComputed = !1;
  }
  ensureParentIndices() {
    if (!this._parentsComputed) {
      this._parentsComputed = !0;
      const e = [], t = (n, s) => {
        const o = e[e.length - 1];
        return this.getStartLineNumber(o) <= n && this.getEndLineNumber(o) >= s;
      };
      for (let n = 0, s = this._startIndexes.length; n < s; n++) {
        const o = this._startIndexes[n], r = this._endIndexes[n];
        if (o > $r || r > $r) throw new Error("startLineNumber or endLineNumber must not exceed " + $r);
        for (; e.length > 0 && !t(o, r); ) e.pop();
        const a = e.length > 0 ? e[e.length - 1] : -1;
        e.push(n), this._startIndexes[n] = o + ((255 & a) << 24), this._endIndexes[n] = r + ((65280 & a) << 16);
      }
    }
  }
  get length() {
    return this._startIndexes.length;
  }
  getStartLineNumber(e) {
    return this._startIndexes[e] & $r;
  }
  getEndLineNumber(e) {
    return this._endIndexes[e] & $r;
  }
  getType(e) {
    return this._types ? this._types[e] : void 0;
  }
  hasTypes() {
    return !!this._types;
  }
  isCollapsed(e) {
    return this._collapseStates.get(e);
  }
  setCollapsed(e, t) {
    this._collapseStates.set(e, t);
  }
  isUserDefined(e) {
    return this._userDefinedStates.get(e);
  }
  setUserDefined(e, t) {
    return this._userDefinedStates.set(e, t);
  }
  isRecovered(e) {
    return this._recoveredStates.get(e);
  }
  setRecovered(e, t) {
    return this._recoveredStates.set(e, t);
  }
  getSource(e) {
    return this.isUserDefined(e) ? 1 : this.isRecovered(e) ? 2 : 0;
  }
  setSource(e, t) {
    t === 1 ? (this.setUserDefined(e, !0), this.setRecovered(e, !1)) : t === 2 ? (this.setUserDefined(e, !1), this.setRecovered(e, !0)) : (this.setUserDefined(e, !1), this.setRecovered(e, !1));
  }
  setCollapsedAllOfType(e, t) {
    let n = !1;
    if (this._types) for (let s = 0; s < this._types.length; s++) this._types[s] === e && (this.setCollapsed(s, t), n = !0);
    return n;
  }
  toRegion(e) {
    return new ble(this, e);
  }
  getParentIndex(e) {
    this.ensureParentIndices();
    const t = ((this._startIndexes[e] & Q6) >>> 24) + ((this._endIndexes[e] & Q6) >>> 16);
    return t === 65535 ? -1 : t;
  }
  contains(e, t) {
    return this.getStartLineNumber(e) <= t && this.getEndLineNumber(e) >= t;
  }
  findIndex(e) {
    let t = 0, n = this._startIndexes.length;
    if (n === 0) return -1;
    for (; t < n; ) {
      const s = Math.floor((t + n) / 2);
      e < this.getStartLineNumber(s) ? n = s : t = s + 1;
    }
    return t - 1;
  }
  findRange(e) {
    let t = this.findIndex(e);
    if (t >= 0) {
      if (this.getEndLineNumber(t) >= e) return t;
      for (t = this.getParentIndex(t); t !== -1; ) {
        if (this.contains(t, e)) return t;
        t = this.getParentIndex(t);
      }
    }
    return -1;
  }
  toString() {
    const e = [];
    for (let t = 0; t < this.length; t++) e[t] = `[${vle[this.getSource(t)]}${this.isCollapsed(t) ? "+" : "-"}] ${this.getStartLineNumber(t)}/${this.getEndLineNumber(t)}`;
    return e.join(", ");
  }
  toFoldRange(e) {
    return { startLineNumber: this._startIndexes[e] & $r, endLineNumber: this._endIndexes[e] & $r, type: this._types ? this._types[e] : void 0, isCollapsed: this.isCollapsed(e), source: this.getSource(e) };
  }
  static fromFoldRanges(e) {
    const t = e.length, n = new Uint32Array(t), s = new Uint32Array(t);
    let o = [], r = !1;
    for (let l = 0; l < t; l++) {
      const d = e[l];
      n[l] = d.startLineNumber, s[l] = d.endLineNumber, o.push(d.type), d.type && (r = !0);
    }
    r || (o = void 0);
    const a = new go(n, s, o);
    for (let l = 0; l < t; l++) e[l].isCollapsed && a.setCollapsed(l, !0), a.setSource(l, e[l].source);
    return a;
  }
  static sanitizeAndMerge(e, t, n) {
    n = n ?? Number.MAX_VALUE;
    const s = (f, _) => Array.isArray(f) ? (v) => v < _ ? f[v] : void 0 : (v) => v < _ ? f.toFoldRange(v) : void 0, o = s(e, e.length), r = s(t, t.length);
    let a = 0, l = 0, d = o(0), h = r(0);
    const c = [];
    let u, g = 0;
    const p = [];
    for (; d || h; ) {
      let f;
      if (h && (!d || d.startLineNumber >= h.startLineNumber)) d && d.startLineNumber === h.startLineNumber ? (h.source === 1 ? f = h : (f = d, f.isCollapsed = h.isCollapsed && d.endLineNumber === h.endLineNumber, f.source = 0), d = o(++a)) : (f = h, h.isCollapsed && h.source === 0 && (f.source = 2)), h = r(++l);
      else {
        let _ = l, v = h;
        for (; ; ) {
          if (!v || v.startLineNumber > d.endLineNumber) {
            f = d;
            break;
          }
          if (v.source === 1 && v.endLineNumber > d.endLineNumber) break;
          v = r(++_);
        }
        d = o(++a);
      }
      if (f) {
        for (; u && u.endLineNumber < f.startLineNumber; ) u = c.pop();
        f.endLineNumber > f.startLineNumber && f.startLineNumber > g && f.endLineNumber <= n && (!u || u.endLineNumber >= f.endLineNumber) && (p.push(f), g = f.startLineNumber, u && c.push(u), u = f);
      }
    }
    return p;
  }
}
class ble {
  constructor(e, t) {
    this.ranges = e, this.index = t;
  }
  get startLineNumber() {
    return this.ranges.getStartLineNumber(this.index);
  }
  get endLineNumber() {
    return this.ranges.getEndLineNumber(this.index);
  }
  get regionIndex() {
    return this.index;
  }
  get parentIndex() {
    return this.ranges.getParentIndex(this.index);
  }
  get isCollapsed() {
    return this.ranges.isCollapsed(this.index);
  }
  containedBy(e) {
    return e.startLineNumber <= this.startLineNumber && e.endLineNumber >= this.endLineNumber;
  }
  containsLine(e) {
    return this.startLineNumber <= e && e <= this.endLineNumber;
  }
}
class Cle {
  get regions() {
    return this._regions;
  }
  get textModel() {
    return this._textModel;
  }
  constructor(e, t) {
    this._updateEventEmitter = new F(), this.onDidChange = this._updateEventEmitter.event, this._textModel = e, this._decorationProvider = t, this._regions = new go(new Uint32Array(0), new Uint32Array(0)), this._editorDecorationIds = [];
  }
  toggleCollapseState(e) {
    if (!e.length) return;
    e = e.sort((n, s) => n.regionIndex - s.regionIndex);
    const t = {};
    this._decorationProvider.changeDecorations((n) => {
      let s = 0, o = -1, r = -1;
      const a = (l) => {
        for (; s < l; ) {
          const d = this._regions.getEndLineNumber(s), h = this._regions.isCollapsed(s);
          if (d <= o) {
            const c = this.regions.getSource(s) !== 0;
            n.changeDecorationOptions(this._editorDecorationIds[s], this._decorationProvider.getDecorationOption(h, d <= r, c));
          }
          h && d > r && (r = d), s++;
        }
      };
      for (const l of e) {
        const d = l.regionIndex, h = this._editorDecorationIds[d];
        if (h && !t[h]) {
          t[h] = !0, a(d);
          const c = !this._regions.isCollapsed(d);
          this._regions.setCollapsed(d, c), o = Math.max(o, this._regions.getEndLineNumber(d));
        }
      }
      a(this._regions.length);
    }), this._updateEventEmitter.fire({ model: this, collapseStateChanged: e });
  }
  removeManualRanges(e) {
    const t = new Array(), n = (s) => {
      for (const o of e) if (!(o.startLineNumber > s.endLineNumber || s.startLineNumber > o.endLineNumber)) return !0;
      return !1;
    };
    for (let s = 0; s < this._regions.length; s++) {
      const o = this._regions.toFoldRange(s);
      o.source !== 0 && n(o) || t.push(o);
    }
    this.updatePost(go.fromFoldRanges(t));
  }
  update(e, t = []) {
    const n = this._currentFoldedOrManualRanges(t), s = go.sanitizeAndMerge(e, n, this._textModel.getLineCount());
    this.updatePost(go.fromFoldRanges(s));
  }
  updatePost(e) {
    const t = [];
    let n = -1;
    for (let s = 0, o = e.length; s < o; s++) {
      const r = e.getStartLineNumber(s), a = e.getEndLineNumber(s), l = e.isCollapsed(s), d = e.getSource(s) !== 0, h = { startLineNumber: r, startColumn: this._textModel.getLineMaxColumn(r), endLineNumber: a, endColumn: this._textModel.getLineMaxColumn(a) + 1 };
      t.push({ range: h, options: this._decorationProvider.getDecorationOption(l, a <= n, d) }), l && a > n && (n = a);
    }
    this._decorationProvider.changeDecorations((s) => this._editorDecorationIds = s.deltaDecorations(this._editorDecorationIds, t)), this._regions = e, this._updateEventEmitter.fire({ model: this });
  }
  _currentFoldedOrManualRanges(e = []) {
    const t = (s, o) => {
      for (const r of e) if (s < r && r <= o) return !0;
      return !1;
    }, n = [];
    for (let s = 0, o = this._regions.length; s < o; s++) {
      let r = this.regions.isCollapsed(s);
      const a = this.regions.getSource(s);
      if (r || a !== 0) {
        const l = this._regions.toFoldRange(s), d = this._textModel.getDecorationRange(this._editorDecorationIds[s]);
        d && (r && t(d.startLineNumber, d.endLineNumber) && (r = !1), n.push({ startLineNumber: d.startLineNumber, endLineNumber: d.endLineNumber, type: l.type, isCollapsed: r, source: a }));
      }
    }
    return n;
  }
  getMemento() {
    const e = this._currentFoldedOrManualRanges(), t = [], n = this._textModel.getLineCount();
    for (let s = 0, o = e.length; s < o; s++) {
      const r = e[s];
      if (r.startLineNumber >= r.endLineNumber || r.startLineNumber < 1 || r.endLineNumber > n) continue;
      const a = this._getLinesChecksum(r.startLineNumber + 1, r.endLineNumber);
      t.push({ startLineNumber: r.startLineNumber, endLineNumber: r.endLineNumber, isCollapsed: r.isCollapsed, source: r.source, checksum: a });
    }
    return t.length > 0 ? t : void 0;
  }
  applyMemento(e) {
    var t, n;
    if (!Array.isArray(e)) return;
    const s = [], o = this._textModel.getLineCount();
    for (const a of e) {
      if (a.startLineNumber >= a.endLineNumber || a.startLineNumber < 1 || a.endLineNumber > o) continue;
      const l = this._getLinesChecksum(a.startLineNumber + 1, a.endLineNumber);
      a.checksum && l !== a.checksum || s.push({ startLineNumber: a.startLineNumber, endLineNumber: a.endLineNumber, type: void 0, isCollapsed: (t = a.isCollapsed) === null || t === void 0 || t, source: (n = a.source) !== null && n !== void 0 ? n : 0 });
    }
    const r = go.sanitizeAndMerge(this._regions, s, o);
    this.updatePost(go.fromFoldRanges(r));
  }
  _getLinesChecksum(e, t) {
    return WS(this._textModel.getLineContent(e) + this._textModel.getLineContent(t)) % 1e6;
  }
  dispose() {
    this._decorationProvider.removeDecorations(this._editorDecorationIds);
  }
  getAllRegionsAtLine(e, t) {
    const n = [];
    if (this._regions) {
      let s = this._regions.findRange(e), o = 1;
      for (; s >= 0; ) {
        const r = this._regions.toRegion(s);
        t && !t(r, o) || n.push(r), o++, s = r.parentIndex;
      }
    }
    return n;
  }
  getRegionAtLine(e) {
    if (this._regions) {
      const t = this._regions.findRange(e);
      if (t >= 0) return this._regions.toRegion(t);
    }
    return null;
  }
  getRegionsInside(e, t) {
    const n = [], s = e ? e.regionIndex + 1 : 0, o = e ? e.endLineNumber : Number.MAX_VALUE;
    if (t && t.length === 2) {
      const r = [];
      for (let a = s, l = this._regions.length; a < l; a++) {
        const d = this._regions.toRegion(a);
        if (!(this._regions.getStartLineNumber(a) < o)) break;
        for (; r.length > 0 && !d.containedBy(r[r.length - 1]); ) r.pop();
        r.push(d), t(d, r.length) && n.push(d);
      }
    } else for (let r = s, a = this._regions.length; r < a; r++) {
      const l = this._regions.toRegion(r);
      if (!(this._regions.getStartLineNumber(r) < o)) break;
      t && !t(l) || n.push(l);
    }
    return n;
  }
}
function jz(i, e, t) {
  const n = [];
  for (const s of t) {
    const o = i.getRegionAtLine(s);
    if (o) {
      const r = !o.isCollapsed;
      if (n.push(o), e > 1) {
        const a = i.getRegionsInside(o, (l, d) => l.isCollapsed !== r && d < e);
        n.push(...a);
      }
    }
  }
  i.toggleCollapseState(n);
}
function ap(i, e, t = Number.MAX_VALUE, n) {
  const s = [];
  if (n && n.length > 0) for (const o of n) {
    const r = i.getRegionAtLine(o);
    if (r && (r.isCollapsed !== e && s.push(r), t > 1)) {
      const a = i.getRegionsInside(r, (l, d) => l.isCollapsed !== e && d < t);
      s.push(...a);
    }
  }
  else {
    const o = i.getRegionsInside(null, (r, a) => r.isCollapsed !== e && a < t);
    s.push(...o);
  }
  i.toggleCollapseState(s);
}
function J6(i, e, t, n) {
  const s = [];
  for (const o of n) {
    const r = i.getAllRegionsAtLine(o, (a, l) => a.isCollapsed !== e && l <= t);
    s.push(...r);
  }
  i.toggleCollapseState(s);
}
function e9(i, e, t) {
  const n = [];
  for (const o of t) {
    const r = i.getAllRegionsAtLine(o, void 0);
    r.length > 0 && n.push(r[0]);
  }
  const s = i.getRegionsInside(null, (o) => n.every((r) => !r.containedBy(o) && !o.containedBy(r)) && o.isCollapsed !== e);
  i.toggleCollapseState(s);
}
function Hx(i, e, t) {
  const n = i.textModel, s = i.regions, o = [];
  for (let r = s.length - 1; r >= 0; r--) if (t !== s.isCollapsed(r)) {
    const a = s.getStartLineNumber(r);
    e.test(n.getLineContent(a)) && o.push(s.toRegion(r));
  }
  i.toggleCollapseState(o);
}
function zx(i, e, t) {
  const n = i.regions, s = [];
  for (let o = n.length - 1; o >= 0; o--) t !== n.isCollapsed(o) && e === n.getType(o) && s.push(n.toRegion(o));
  i.toggleCollapseState(s);
}
class wle {
  get onDidChange() {
    return this._updateEventEmitter.event;
  }
  get hiddenRanges() {
    return this._hiddenRanges;
  }
  constructor(e) {
    this._updateEventEmitter = new F(), this._hasLineChanges = !1, this._foldingModel = e, this._foldingModelListener = e.onDidChange((t) => this.updateHiddenRanges()), this._hiddenRanges = [], e.regions.length && this.updateHiddenRanges();
  }
  notifyChangeModelContent(e) {
    this._hiddenRanges.length && !this._hasLineChanges && (this._hasLineChanges = e.changes.some((t) => t.range.endLineNumber !== t.range.startLineNumber || Dc(t.text)[0] !== 0));
  }
  updateHiddenRanges() {
    let e = !1;
    const t = [];
    let n = 0, s = 0, o = Number.MAX_VALUE, r = -1;
    const a = this._foldingModel.regions;
    for (; n < a.length; n++) {
      if (!a.isCollapsed(n)) continue;
      const l = a.getStartLineNumber(n) + 1, d = a.getEndLineNumber(n);
      o <= l && d <= r || (!e && s < this._hiddenRanges.length && this._hiddenRanges[s].startLineNumber === l && this._hiddenRanges[s].endLineNumber === d ? (t.push(this._hiddenRanges[s]), s++) : (e = !0, t.push(new D(l, 1, d, 1))), o = l, r = d);
    }
    (this._hasLineChanges || e || s < this._hiddenRanges.length) && this.applyHiddenRanges(t);
  }
  applyHiddenRanges(e) {
    this._hiddenRanges = e, this._hasLineChanges = !1, this._updateEventEmitter.fire(e);
  }
  hasRanges() {
    return this._hiddenRanges.length > 0;
  }
  isHidden(e) {
    return t9(this._hiddenRanges, e) !== null;
  }
  adjustSelections(e) {
    let t = !1;
    const n = this._foldingModel.textModel;
    let s = null;
    const o = (r) => (s && function(a, l) {
      return a >= l.startLineNumber && a <= l.endLineNumber;
    }(r, s) || (s = t9(this._hiddenRanges, r)), s ? s.startLineNumber - 1 : null);
    for (let r = 0, a = e.length; r < a; r++) {
      let l = e[r];
      const d = o(l.startLineNumber);
      d && (l = l.setStartPosition(d, n.getLineMaxColumn(d)), t = !0);
      const h = o(l.endLineNumber);
      h && (l = l.setEndPosition(h, n.getLineMaxColumn(h)), t = !0), e[r] = l;
    }
    return t;
  }
  dispose() {
    this.hiddenRanges.length > 0 && (this._hiddenRanges = [], this._updateEventEmitter.fire(this._hiddenRanges)), this._foldingModelListener && (this._foldingModelListener.dispose(), this._foldingModelListener = null);
  }
}
function t9(i, e) {
  const t = rv(i, (n) => e < n.startLineNumber) - 1;
  return t >= 0 && i[t].endLineNumber >= e ? i[t] : null;
}
class xP {
  constructor(e, t, n) {
    this.editorModel = e, this.languageConfigurationService = t, this.foldingRangesLimit = n, this.id = "indent";
  }
  dispose() {
  }
  compute(e) {
    const t = this.languageConfigurationService.getLanguageConfiguration(this.editorModel.getLanguageId()).foldingRules, n = t && !!t.offSide, s = t && t.markers;
    return Promise.resolve(function(o, r, a, l = Sle) {
      const d = o.getOptions().tabSize, h = new yle(l);
      let c;
      a && (c = new RegExp(`(${a.start.source})|(?:${a.end.source})`));
      const u = [], g = o.getLineCount() + 1;
      u.push({ indent: -1, endAbove: g, line: g });
      for (let p = o.getLineCount(); p > 0; p--) {
        const f = o.getLineContent(p), _ = uL(f, d);
        let v, b = u[u.length - 1];
        if (_ !== -1) {
          if (c && (v = f.match(c))) {
            if (!v[1]) {
              u.push({ indent: -2, endAbove: p, line: p });
              continue;
            }
            {
              let C = u.length - 1;
              for (; C > 0 && u[C].indent !== -2; ) C--;
              if (C > 0) {
                u.length = C + 1, b = u[C], h.insertFirst(p, b.line, _), b.line = p, b.indent = _, b.endAbove = p;
                continue;
              }
            }
          }
          if (b.indent > _) {
            do
              u.pop(), b = u[u.length - 1];
            while (b.indent > _);
            const C = b.endAbove - 1;
            C - p >= 1 && h.insertFirst(p, C, _);
          }
          b.indent === _ ? b.endAbove = p : u.push({ indent: _, endAbove: p, line: p });
        } else r && (b.endAbove = p);
      }
      return h.toIndentRanges(o);
    }(this.editorModel, n, s, this.foldingRangesLimit));
  }
}
let yle = class {
  constructor(i) {
    this._startIndexes = [], this._endIndexes = [], this._indentOccurrences = [], this._length = 0, this._foldingRangesLimit = i;
  }
  insertFirst(i, e, t) {
    if (i > $r || e > $r) return;
    const n = this._length;
    this._startIndexes[n] = i, this._endIndexes[n] = e, this._length++, t < 1e3 && (this._indentOccurrences[t] = (this._indentOccurrences[t] || 0) + 1);
  }
  toIndentRanges(i) {
    const e = this._foldingRangesLimit.limit;
    if (this._length <= e) {
      this._foldingRangesLimit.update(this._length, !1);
      const t = new Uint32Array(this._length), n = new Uint32Array(this._length);
      for (let s = this._length - 1, o = 0; s >= 0; s--, o++) t[o] = this._startIndexes[s], n[o] = this._endIndexes[s];
      return new go(t, n);
    }
    {
      this._foldingRangesLimit.update(this._length, e);
      let t = 0, n = this._indentOccurrences.length;
      for (let a = 0; a < this._indentOccurrences.length; a++) {
        const l = this._indentOccurrences[a];
        if (l) {
          if (l + t > e) {
            n = a;
            break;
          }
          t += l;
        }
      }
      const s = i.getOptions().tabSize, o = new Uint32Array(e), r = new Uint32Array(e);
      for (let a = this._length - 1, l = 0; a >= 0; a--) {
        const d = this._startIndexes[a], h = uL(i.getLineContent(d), s);
        (h < n || h === n && t++ < e) && (o[l] = d, r[l] = this._endIndexes[a], l++);
      }
      return new go(o, r);
    }
  }
};
const Sle = { limit: 5e3, update: () => {
} }, Lle = I("editor.foldBackground", { light: Ce(Th, 0.3), dark: Ce(Th, 0.3), hcDark: null, hcLight: null }, m(0, "Background color behind folded ranges. The color must not be opaque so as not to hide underlying decorations."), !0);
I("editorGutter.foldingControlForeground", { dark: sl, light: sl, hcDark: sl, hcLight: sl }, m(0, "Color of the folding control in the editor gutter."));
const yS = Ei("folding-expanded", ne.chevronDown, m(0, "Icon for expanded ranges in the editor glyph margin.")), SS = Ei("folding-collapsed", ne.chevronRight, m(0, "Icon for collapsed ranges in the editor glyph margin.")), i9 = Ei("folding-manual-collapsed", SS, m(0, "Icon for manually collapsed ranges in the editor glyph margin.")), n9 = Ei("folding-manual-expanded", yS, m(0, "Icon for manually expanded ranges in the editor glyph margin.")), Ux = { color: ui(Lle), position: 1 }, lp = m(0, "Click to expand the range."), cC = m(0, "Click to collapse the range.");
class Ai {
  constructor(e) {
    this.editor = e, this.showFoldingControls = "mouseover", this.showFoldingHighlights = !0;
  }
  getDecorationOption(e, t, n) {
    return t ? Ai.HIDDEN_RANGE_DECORATION : this.showFoldingControls === "never" ? e ? this.showFoldingHighlights ? Ai.NO_CONTROLS_COLLAPSED_HIGHLIGHTED_RANGE_DECORATION : Ai.NO_CONTROLS_COLLAPSED_RANGE_DECORATION : Ai.NO_CONTROLS_EXPANDED_RANGE_DECORATION : e ? n ? this.showFoldingHighlights ? Ai.MANUALLY_COLLAPSED_HIGHLIGHTED_VISUAL_DECORATION : Ai.MANUALLY_COLLAPSED_VISUAL_DECORATION : this.showFoldingHighlights ? Ai.COLLAPSED_HIGHLIGHTED_VISUAL_DECORATION : Ai.COLLAPSED_VISUAL_DECORATION : this.showFoldingControls === "mouseover" ? n ? Ai.MANUALLY_EXPANDED_AUTO_HIDE_VISUAL_DECORATION : Ai.EXPANDED_AUTO_HIDE_VISUAL_DECORATION : n ? Ai.MANUALLY_EXPANDED_VISUAL_DECORATION : Ai.EXPANDED_VISUAL_DECORATION;
  }
  changeDecorations(e) {
    return this.editor.changeDecorations(e);
  }
  removeDecorations(e) {
    this.editor.removeDecorations(e);
  }
}
Ai.COLLAPSED_VISUAL_DECORATION = Ve.register({ description: "folding-collapsed-visual-decoration", stickiness: 0, afterContentClassName: "inline-folded", isWholeLine: !0, linesDecorationsTooltip: lp, firstLineDecorationClassName: Ee.asClassName(SS) }), Ai.COLLAPSED_HIGHLIGHTED_VISUAL_DECORATION = Ve.register({ description: "folding-collapsed-highlighted-visual-decoration", stickiness: 0, afterContentClassName: "inline-folded", className: "folded-background", minimap: Ux, isWholeLine: !0, linesDecorationsTooltip: lp, firstLineDecorationClassName: Ee.asClassName(SS) }), Ai.MANUALLY_COLLAPSED_VISUAL_DECORATION = Ve.register({ description: "folding-manually-collapsed-visual-decoration", stickiness: 0, afterContentClassName: "inline-folded", isWholeLine: !0, linesDecorationsTooltip: lp, firstLineDecorationClassName: Ee.asClassName(i9) }), Ai.MANUALLY_COLLAPSED_HIGHLIGHTED_VISUAL_DECORATION = Ve.register({ description: "folding-manually-collapsed-highlighted-visual-decoration", stickiness: 0, afterContentClassName: "inline-folded", className: "folded-background", minimap: Ux, isWholeLine: !0, linesDecorationsTooltip: lp, firstLineDecorationClassName: Ee.asClassName(i9) }), Ai.NO_CONTROLS_COLLAPSED_RANGE_DECORATION = Ve.register({ description: "folding-no-controls-range-decoration", stickiness: 0, afterContentClassName: "inline-folded", isWholeLine: !0, linesDecorationsTooltip: lp }), Ai.NO_CONTROLS_COLLAPSED_HIGHLIGHTED_RANGE_DECORATION = Ve.register({ description: "folding-no-controls-range-decoration", stickiness: 0, afterContentClassName: "inline-folded", className: "folded-background", minimap: Ux, isWholeLine: !0, linesDecorationsTooltip: lp }), Ai.EXPANDED_VISUAL_DECORATION = Ve.register({ description: "folding-expanded-visual-decoration", stickiness: 1, isWholeLine: !0, firstLineDecorationClassName: "alwaysShowFoldIcons " + Ee.asClassName(yS), linesDecorationsTooltip: cC }), Ai.EXPANDED_AUTO_HIDE_VISUAL_DECORATION = Ve.register({ description: "folding-expanded-auto-hide-visual-decoration", stickiness: 1, isWholeLine: !0, firstLineDecorationClassName: Ee.asClassName(yS), linesDecorationsTooltip: cC }), Ai.MANUALLY_EXPANDED_VISUAL_DECORATION = Ve.register({ description: "folding-manually-expanded-visual-decoration", stickiness: 0, isWholeLine: !0, firstLineDecorationClassName: "alwaysShowFoldIcons " + Ee.asClassName(n9), linesDecorationsTooltip: cC }), Ai.MANUALLY_EXPANDED_AUTO_HIDE_VISUAL_DECORATION = Ve.register({ description: "folding-manually-expanded-auto-hide-visual-decoration", stickiness: 0, isWholeLine: !0, firstLineDecorationClassName: Ee.asClassName(n9), linesDecorationsTooltip: cC }), Ai.NO_CONTROLS_EXPANDED_RANGE_DECORATION = Ve.register({ description: "folding-no-controls-range-decoration", stickiness: 0, isWholeLine: !0 }), Ai.HIDDEN_RANGE_DECORATION = Ve.register({ description: "folding-hidden-range-decoration", stickiness: 1 });
const kle = {};
class NP {
  constructor(e, t, n, s, o) {
    this.editorModel = e, this.providers = t, this.handleFoldingRangesChange = n, this.foldingRangesLimit = s, this.fallbackRangeProvider = o, this.id = "syntax", this.disposables = new G(), o && this.disposables.add(o);
    for (const r of t) typeof r.onDidChange == "function" && this.disposables.add(r.onDidChange(n));
  }
  compute(e) {
    return function(t, n, s) {
      let o = null;
      const r = t.map((a, l) => Promise.resolve(a.provideFoldingRanges(n, kle, s)).then((d) => {
        if (!s.isCancellationRequested && Array.isArray(d)) {
          Array.isArray(o) || (o = []);
          const h = n.getLineCount();
          for (const c of d) c.start > 0 && c.end > c.start && c.end <= h && o.push({ start: c.start, end: c.end, rank: l, kind: c.kind });
        }
      }, Ni));
      return Promise.all(r).then((a) => o);
    }(this.providers, this.editorModel, e).then((t) => {
      var n, s;
      return t ? function(o, r) {
        const a = o.sort((c, u) => {
          let g = c.start - u.start;
          return g === 0 && (g = c.rank - u.rank), g;
        }), l = new Dle(r);
        let d;
        const h = [];
        for (const c of a) if (d) {
          if (c.start > d.start) if (c.end <= d.end) h.push(d), d = c, l.add(c.start, c.end, c.kind && c.kind.value, h.length);
          else {
            if (c.start > d.end) {
              do
                d = h.pop();
              while (d && c.start > d.end);
              d && h.push(d), d = c;
            }
            l.add(c.start, c.end, c.kind && c.kind.value, h.length);
          }
        } else d = c, l.add(c.start, c.end, c.kind && c.kind.value, h.length);
        return l.toIndentRanges();
      }(t, this.foldingRangesLimit) : (s = (n = this.fallbackRangeProvider) === null || n === void 0 ? void 0 : n.compute(e)) !== null && s !== void 0 ? s : null;
    });
  }
  dispose() {
    this.disposables.dispose();
  }
}
class Dle {
  constructor(e) {
    this._startIndexes = [], this._endIndexes = [], this._nestingLevels = [], this._nestingLevelCounts = [], this._types = [], this._length = 0, this._foldingRangesLimit = e;
  }
  add(e, t, n, s) {
    if (e > $r || t > $r) return;
    const o = this._length;
    this._startIndexes[o] = e, this._endIndexes[o] = t, this._nestingLevels[o] = s, this._types[o] = n, this._length++, s < 30 && (this._nestingLevelCounts[s] = (this._nestingLevelCounts[s] || 0) + 1);
  }
  toIndentRanges() {
    const e = this._foldingRangesLimit.limit;
    if (this._length <= e) {
      this._foldingRangesLimit.update(this._length, !1);
      const t = new Uint32Array(this._length), n = new Uint32Array(this._length);
      for (let s = 0; s < this._length; s++) t[s] = this._startIndexes[s], n[s] = this._endIndexes[s];
      return new go(t, n, this._types);
    }
    {
      this._foldingRangesLimit.update(this._length, e);
      let t = 0, n = this._nestingLevelCounts.length;
      for (let a = 0; a < this._nestingLevelCounts.length; a++) {
        const l = this._nestingLevelCounts[a];
        if (l) {
          if (l + t > e) {
            n = a;
            break;
          }
          t += l;
        }
      }
      const s = new Uint32Array(e), o = new Uint32Array(e), r = [];
      for (let a = 0, l = 0; a < this._length; a++) {
        const d = this._nestingLevels[a];
        (d < n || d === n && t++ < e) && (s[l] = this._startIndexes[a], o[l] = this._endIndexes[a], r[l] = this._types[a], l++);
      }
      return new go(s, o, r);
    }
  }
}
var vp, xle = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, n_ = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const Pn = new ae("foldingEnabled", !1);
let Id = vp = class extends V {
  static get(i) {
    return i.getContribution(vp.ID);
  }
  static getFoldingRangeProviders(i, e) {
    var t, n;
    const s = i.foldingRangeProvider.ordered(e);
    return (n = (t = vp._foldingRangeSelector) === null || t === void 0 ? void 0 : t.call(vp, s, e)) !== null && n !== void 0 ? n : s;
  }
  constructor(i, e, t, n, s, o) {
    super(), this.contextKeyService = e, this.languageConfigurationService = t, this.languageFeaturesService = o, this.localToDispose = this._register(new G()), this.editor = i, this._foldingLimitReporter = new qz(i);
    const r = this.editor.getOptions();
    this._isEnabled = r.get(43), this._useFoldingProviders = r.get(44) !== "indentation", this._unfoldOnClickAfterEndOfLine = r.get(48), this._restoringViewState = !1, this._currentModelHasFoldedImports = !1, this._foldingImportsByDefault = r.get(46), this.updateDebounceInfo = s.for(o.foldingRangeProvider, "Folding", { min: 200 }), this.foldingModel = null, this.hiddenRangeModel = null, this.rangeProvider = null, this.foldingRegionPromise = null, this.foldingModelPromise = null, this.updateScheduler = null, this.cursorChangedScheduler = null, this.mouseDownInfo = null, this.foldingDecorationProvider = new Ai(i), this.foldingDecorationProvider.showFoldingControls = r.get(110), this.foldingDecorationProvider.showFoldingHighlights = r.get(45), this.foldingEnabled = Pn.bindTo(this.contextKeyService), this.foldingEnabled.set(this._isEnabled), this._register(this.editor.onDidChangeModel(() => this.onModelChanged())), this._register(this.editor.onDidChangeConfiguration((a) => {
      if (a.hasChanged(43) && (this._isEnabled = this.editor.getOptions().get(43), this.foldingEnabled.set(this._isEnabled), this.onModelChanged()), a.hasChanged(47) && this.onModelChanged(), a.hasChanged(110) || a.hasChanged(45)) {
        const l = this.editor.getOptions();
        this.foldingDecorationProvider.showFoldingControls = l.get(110), this.foldingDecorationProvider.showFoldingHighlights = l.get(45), this.triggerFoldingModelChanged();
      }
      a.hasChanged(44) && (this._useFoldingProviders = this.editor.getOptions().get(44) !== "indentation", this.onFoldingStrategyChanged()), a.hasChanged(48) && (this._unfoldOnClickAfterEndOfLine = this.editor.getOptions().get(48)), a.hasChanged(46) && (this._foldingImportsByDefault = this.editor.getOptions().get(46));
    })), this.onModelChanged();
  }
  saveViewState() {
    const i = this.editor.getModel();
    if (!i || !this._isEnabled || i.isTooLargeForTokenization()) return {};
    if (this.foldingModel) {
      const e = this.foldingModel.getMemento(), t = this.rangeProvider ? this.rangeProvider.id : void 0;
      return { collapsedRegions: e, lineCount: i.getLineCount(), provider: t, foldedImports: this._currentModelHasFoldedImports };
    }
  }
  restoreViewState(i) {
    const e = this.editor.getModel();
    if (e && this._isEnabled && !e.isTooLargeForTokenization() && this.hiddenRangeModel && i && (this._currentModelHasFoldedImports = !!i.foldedImports, i.collapsedRegions && i.collapsedRegions.length > 0 && this.foldingModel)) {
      this._restoringViewState = !0;
      try {
        this.foldingModel.applyMemento(i.collapsedRegions);
      } finally {
        this._restoringViewState = !1;
      }
    }
  }
  onModelChanged() {
    this.localToDispose.clear();
    const i = this.editor.getModel();
    this._isEnabled && i && !i.isTooLargeForTokenization() && (this._currentModelHasFoldedImports = !1, this.foldingModel = new Cle(i, this.foldingDecorationProvider), this.localToDispose.add(this.foldingModel), this.hiddenRangeModel = new wle(this.foldingModel), this.localToDispose.add(this.hiddenRangeModel), this.localToDispose.add(this.hiddenRangeModel.onDidChange((e) => this.onHiddenRangesChanges(e))), this.updateScheduler = new Sr(this.updateDebounceInfo.get(i)), this.cursorChangedScheduler = new It(() => this.revealCursor(), 200), this.localToDispose.add(this.cursorChangedScheduler), this.localToDispose.add(this.languageFeaturesService.foldingRangeProvider.onDidChange(() => this.onFoldingStrategyChanged())), this.localToDispose.add(this.editor.onDidChangeModelLanguageConfiguration(() => this.onFoldingStrategyChanged())), this.localToDispose.add(this.editor.onDidChangeModelContent((e) => this.onDidChangeModelContent(e))), this.localToDispose.add(this.editor.onDidChangeCursorPosition(() => this.onCursorPositionChanged())), this.localToDispose.add(this.editor.onMouseDown((e) => this.onEditorMouseDown(e))), this.localToDispose.add(this.editor.onMouseUp((e) => this.onEditorMouseUp(e))), this.localToDispose.add({ dispose: () => {
      var e, t;
      this.foldingRegionPromise && (this.foldingRegionPromise.cancel(), this.foldingRegionPromise = null), (e = this.updateScheduler) === null || e === void 0 || e.cancel(), this.updateScheduler = null, this.foldingModel = null, this.foldingModelPromise = null, this.hiddenRangeModel = null, this.cursorChangedScheduler = null, (t = this.rangeProvider) === null || t === void 0 || t.dispose(), this.rangeProvider = null;
    } }), this.triggerFoldingModelChanged());
  }
  onFoldingStrategyChanged() {
    var i;
    (i = this.rangeProvider) === null || i === void 0 || i.dispose(), this.rangeProvider = null, this.triggerFoldingModelChanged();
  }
  getRangeProvider(i) {
    if (this.rangeProvider) return this.rangeProvider;
    const e = new xP(i, this.languageConfigurationService, this._foldingLimitReporter);
    if (this.rangeProvider = e, this._useFoldingProviders && this.foldingModel) {
      const t = vp.getFoldingRangeProviders(this.languageFeaturesService, i);
      t.length > 0 && (this.rangeProvider = new NP(i, t, () => this.triggerFoldingModelChanged(), this._foldingLimitReporter, e));
    }
    return this.rangeProvider;
  }
  getFoldingModel() {
    return this.foldingModelPromise;
  }
  onDidChangeModelContent(i) {
    var e;
    (e = this.hiddenRangeModel) === null || e === void 0 || e.notifyChangeModelContent(i), this.triggerFoldingModelChanged();
  }
  triggerFoldingModelChanged() {
    this.updateScheduler && (this.foldingRegionPromise && (this.foldingRegionPromise.cancel(), this.foldingRegionPromise = null), this.foldingModelPromise = this.updateScheduler.trigger(() => {
      const i = this.foldingModel;
      if (!i) return null;
      const e = new Rn(), t = this.getRangeProvider(i.textModel), n = this.foldingRegionPromise = on((s) => t.compute(s));
      return n.then((s) => {
        if (s && n === this.foldingRegionPromise) {
          let o;
          if (this._foldingImportsByDefault && !this._currentModelHasFoldedImports) {
            const d = s.setCollapsedAllOfType(ls.Imports.value, !0);
            d && (o = ya.capture(this.editor), this._currentModelHasFoldedImports = d);
          }
          const r = this.editor.getSelections(), a = r ? r.map((d) => d.startLineNumber) : [];
          i.update(s, a), o == null || o.restore(this.editor);
          const l = this.updateDebounceInfo.update(i.textModel, e.elapsed());
          this.updateScheduler && (this.updateScheduler.defaultDelay = l);
        }
        return i;
      });
    }).then(void 0, (i) => (We(i), null)));
  }
  onHiddenRangesChanges(i) {
    if (this.hiddenRangeModel && i.length && !this._restoringViewState) {
      const e = this.editor.getSelections();
      e && this.hiddenRangeModel.adjustSelections(e) && this.editor.setSelections(e);
    }
    this.editor.setHiddenAreas(i, this);
  }
  onCursorPositionChanged() {
    this.hiddenRangeModel && this.hiddenRangeModel.hasRanges() && this.cursorChangedScheduler.schedule();
  }
  revealCursor() {
    const i = this.getFoldingModel();
    i && i.then((e) => {
      if (e) {
        const t = this.editor.getSelections();
        if (t && t.length > 0) {
          const n = [];
          for (const s of t) {
            const o = s.selectionStartLineNumber;
            this.hiddenRangeModel && this.hiddenRangeModel.isHidden(o) && n.push(...e.getAllRegionsAtLine(o, (r) => r.isCollapsed && o > r.startLineNumber));
          }
          n.length && (e.toggleCollapseState(n), this.reveal(t[0].getPosition()));
        }
      }
    }).then(void 0, We);
  }
  onEditorMouseDown(i) {
    if (this.mouseDownInfo = null, !this.hiddenRangeModel || !i.target || !i.target.range || !i.event.leftButton && !i.event.middleButton) return;
    const e = i.target.range;
    let t = !1;
    switch (i.target.type) {
      case 4: {
        const n = i.target.detail, s = i.target.element.offsetLeft;
        if (n.offsetX - s < 4) return;
        t = !0;
        break;
      }
      case 7:
        if (this._unfoldOnClickAfterEndOfLine && this.hiddenRangeModel.hasRanges() && !i.target.detail.isAfterLines)
          break;
        return;
      case 6:
        if (this.hiddenRangeModel.hasRanges()) {
          const n = this.editor.getModel();
          if (n && e.startColumn === n.getLineMaxColumn(e.startLineNumber)) break;
        }
        return;
      default:
        return;
    }
    this.mouseDownInfo = { lineNumber: e.startLineNumber, iconClicked: t };
  }
  onEditorMouseUp(i) {
    const e = this.foldingModel;
    if (!e || !this.mouseDownInfo || !i.target) return;
    const t = this.mouseDownInfo.lineNumber, n = this.mouseDownInfo.iconClicked, s = i.target.range;
    if (!s || s.startLineNumber !== t) return;
    if (n) {
      if (i.target.type !== 4) return;
    } else {
      const r = this.editor.getModel();
      if (!r || s.startColumn !== r.getLineMaxColumn(t)) return;
    }
    const o = e.getRegionAtLine(t);
    if (o && o.startLineNumber === t) {
      const r = o.isCollapsed;
      if (n || r) {
        let a = [];
        if (i.event.altKey) {
          const l = (h) => !h.containedBy(o) && !o.containedBy(h), d = e.getRegionsInside(null, l);
          for (const h of d) h.isCollapsed && a.push(h);
          a.length === 0 && (a = d);
        } else {
          const l = i.event.middleButton || i.event.shiftKey;
          if (l) for (const d of e.getRegionsInside(o)) d.isCollapsed === r && a.push(d);
          !r && l && a.length !== 0 || a.push(o);
        }
        e.toggleCollapseState(a), this.reveal({ lineNumber: t, column: 1 });
      }
    }
  }
  reveal(i) {
    this.editor.revealPositionInCenterIfOutsideViewport(i, 0);
  }
};
Id.ID = "editor.contrib.folding", Id = vp = xle([n_(1, Te), n_(2, zt), n_(3, Ri), n_(4, ar), n_(5, fe)], Id);
class qz {
  constructor(e) {
    this.editor = e, this._onDidChange = new F(), this._computed = 0, this._limited = !1;
  }
  get limit() {
    return this.editor.getOptions().get(47);
  }
  update(e, t) {
    e === this._computed && t === this._limited || (this._computed = e, this._limited = t, this._onDidChange.fire());
  }
}
class jn extends he {
  runEditorCommand(e, t, n) {
    const s = e.get(zt), o = Id.get(t);
    if (!o) return;
    const r = o.getFoldingModel();
    return r ? (this.reportTelemetry(e, t), r.then((a) => {
      if (a) {
        this.invoke(o, a, t, n, s);
        const l = t.getSelection();
        l && o.reveal(l.getStartPosition());
      }
    })) : void 0;
  }
  getSelectedLines(e) {
    const t = e.getSelections();
    return t ? t.map((n) => n.startLineNumber) : [];
  }
  getLineNumbers(e, t) {
    return e && e.selectionLines ? e.selectionLines.map((n) => n + 1) : this.getSelectedLines(t);
  }
  run(e, t) {
  }
}
function s9(i) {
  if (!$s(i)) {
    if (!ms(i)) return !1;
    const e = i;
    if (!$s(e.levels) && !gc(e.levels) || !$s(e.direction) && !ps(e.direction) || !($s(e.selectionLines) || Array.isArray(e.selectionLines) && e.selectionLines.every(gc))) return !1;
  }
  return !0;
}
class eg extends jn {
  getFoldingLevel() {
    return parseInt(this.id.substr(eg.ID_PREFIX.length));
  }
  invoke(e, t, n) {
    (function(s, o, r, a) {
      const l = s.getRegionsInside(null, (d, h) => h === o && d.isCollapsed !== r && !a.some((c) => d.containsLine(c)));
      s.toggleCollapseState(l);
    })(t, this.getFoldingLevel(), !0, this.getSelectedLines(n));
  }
}
eg.ID_PREFIX = "editor.foldLevel", eg.ID = (i) => eg.ID_PREFIX + i;
ft(Id.ID, Id, 0), X(class extends jn {
  constructor() {
    super({ id: "editor.unfold", label: m(0, "Unfold"), alias: "Unfold", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: 3166, mac: { primary: 2654 }, weight: 100 }, metadata: { description: "Unfold the content in the editor", args: [{ name: "Unfold editor argument", description: `Property-value pairs that can be passed through this argument:
						* 'levels': Number of levels to unfold. If not set, defaults to 1.
						* 'direction': If 'up', unfold given number of levels up otherwise unfolds down.
						* 'selectionLines': Array of the start lines (0-based) of the editor selections to apply the unfold action to. If not set, the active selection(s) will be used.
						`, constraint: s9, schema: { type: "object", properties: { levels: { type: "number", default: 1 }, direction: { type: "string", enum: ["up", "down"], default: "down" }, selectionLines: { type: "array", items: { type: "number" } } } } }] } });
  }
  invoke(i, e, t, n) {
    const s = n && n.levels || 1, o = this.getLineNumbers(n, t);
    n && n.direction === "up" ? J6(e, !1, s, o) : ap(e, !1, s, o);
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.unfoldRecursively", label: m(0, "Unfold Recursively"), alias: "Unfold Recursively", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2142), weight: 100 } });
  }
  invoke(i, e, t, n) {
    ap(e, !1, Number.MAX_VALUE, this.getSelectedLines(t));
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.fold", label: m(0, "Fold"), alias: "Fold", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: 3164, mac: { primary: 2652 }, weight: 100 }, metadata: { description: "Fold the content in the editor", args: [{ name: "Fold editor argument", description: `Property-value pairs that can be passed through this argument:
							* 'levels': Number of levels to fold.
							* 'direction': If 'up', folds given number of levels up otherwise folds down.
							* 'selectionLines': Array of the start lines (0-based) of the editor selections to apply the fold action to. If not set, the active selection(s) will be used.
							If no levels or direction is set, folds the region at the locations or if already collapsed, the first uncollapsed parent instead.
						`, constraint: s9, schema: { type: "object", properties: { levels: { type: "number" }, direction: { type: "string", enum: ["up", "down"] }, selectionLines: { type: "array", items: { type: "number" } } } } }] } });
  }
  invoke(i, e, t, n) {
    const s = this.getLineNumbers(n, t), o = n && n.levels, r = n && n.direction;
    typeof o != "number" && typeof r != "string" ? function(a, l, d) {
      const h = [];
      for (const c of d) {
        const u = a.getAllRegionsAtLine(c, (g) => g.isCollapsed !== l);
        u.length > 0 && h.push(u[0]);
      }
      a.toggleCollapseState(h);
    }(e, !0, s) : r === "up" ? J6(e, !0, o || 1, s) : ap(e, !0, o || 1, s);
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.foldRecursively", label: m(0, "Fold Recursively"), alias: "Fold Recursively", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2140), weight: 100 } });
  }
  invoke(i, e, t) {
    const n = this.getSelectedLines(t);
    ap(e, !0, Number.MAX_VALUE, n);
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.foldAll", label: m(0, "Fold All"), alias: "Fold All", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2069), weight: 100 } });
  }
  invoke(i, e, t) {
    ap(e, !0);
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.unfoldAll", label: m(0, "Unfold All"), alias: "Unfold All", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2088), weight: 100 } });
  }
  invoke(i, e, t) {
    ap(e, !1);
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.foldAllBlockComments", label: m(0, "Fold All Block Comments"), alias: "Fold All Block Comments", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2138), weight: 100 } });
  }
  invoke(i, e, t, n, s) {
    if (e.regions.hasTypes()) zx(e, ls.Comment.value, !0);
    else {
      const o = t.getModel();
      if (!o) return;
      const r = s.getLanguageConfiguration(o.getLanguageId()).comments;
      r && r.blockCommentStartToken && Hx(e, new RegExp("^\\s*" + No(r.blockCommentStartToken)), !0);
    }
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.foldAllMarkerRegions", label: m(0, "Fold All Regions"), alias: "Fold All Regions", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2077), weight: 100 } });
  }
  invoke(i, e, t, n, s) {
    if (e.regions.hasTypes()) zx(e, ls.Region.value, !0);
    else {
      const o = t.getModel();
      if (!o) return;
      const r = s.getLanguageConfiguration(o.getLanguageId()).foldingRules;
      r && r.markers && r.markers.start && Hx(e, new RegExp(r.markers.start), !0);
    }
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.unfoldAllMarkerRegions", label: m(0, "Unfold All Regions"), alias: "Unfold All Regions", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2078), weight: 100 } });
  }
  invoke(i, e, t, n, s) {
    if (e.regions.hasTypes()) zx(e, ls.Region.value, !1);
    else {
      const o = t.getModel();
      if (!o) return;
      const r = s.getLanguageConfiguration(o.getLanguageId()).foldingRules;
      r && r.markers && r.markers.start && Hx(e, new RegExp(r.markers.start), !1);
    }
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.foldAllExcept", label: m(0, "Fold All Except Selected"), alias: "Fold All Except Selected", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2136), weight: 100 } });
  }
  invoke(i, e, t) {
    e9(e, !0, this.getSelectedLines(t));
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.unfoldAllExcept", label: m(0, "Unfold All Except Selected"), alias: "Unfold All Except Selected", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2134), weight: 100 } });
  }
  invoke(i, e, t) {
    e9(e, !1, this.getSelectedLines(t));
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.toggleFold", label: m(0, "Toggle Fold"), alias: "Toggle Fold", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2090), weight: 100 } });
  }
  invoke(i, e, t) {
    jz(e, 1, this.getSelectedLines(t));
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.gotoParentFold", label: m(0, "Go to Parent Fold"), alias: "Go to Parent Fold", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, weight: 100 } });
  }
  invoke(i, e, t) {
    const n = this.getSelectedLines(t);
    if (n.length > 0) {
      const s = function(o, r) {
        let a = null;
        const l = r.getRegionAtLine(o);
        if (l !== null && (a = l.startLineNumber, o === a)) {
          const d = l.parentIndex;
          a = d !== -1 ? r.regions.getStartLineNumber(d) : null;
        }
        return a;
      }(n[0], e);
      s !== null && t.setSelection({ startLineNumber: s, startColumn: 1, endLineNumber: s, endColumn: 1 });
    }
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.gotoPreviousFold", label: m(0, "Go to Previous Folding Range"), alias: "Go to Previous Folding Range", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, weight: 100 } });
  }
  invoke(i, e, t) {
    const n = this.getSelectedLines(t);
    if (n.length > 0) {
      const s = function(o, r) {
        let a = r.getRegionAtLine(o);
        if (a !== null && a.startLineNumber === o) {
          if (o !== a.startLineNumber) return a.startLineNumber;
          {
            const l = a.parentIndex;
            let d = 0;
            for (l !== -1 && (d = r.regions.getStartLineNumber(a.parentIndex)); a !== null; ) {
              if (!(a.regionIndex > 0) || (a = r.regions.toRegion(a.regionIndex - 1), a.startLineNumber <= d)) return null;
              if (a.parentIndex === l) return a.startLineNumber;
            }
          }
        } else if (r.regions.length > 0) for (a = r.regions.toRegion(r.regions.length - 1); a !== null; ) {
          if (a.startLineNumber < o) return a.startLineNumber;
          a = a.regionIndex > 0 ? r.regions.toRegion(a.regionIndex - 1) : null;
        }
        return null;
      }(n[0], e);
      s !== null && t.setSelection({ startLineNumber: s, startColumn: 1, endLineNumber: s, endColumn: 1 });
    }
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.gotoNextFold", label: m(0, "Go to Next Folding Range"), alias: "Go to Next Folding Range", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, weight: 100 } });
  }
  invoke(i, e, t) {
    const n = this.getSelectedLines(t);
    if (n.length > 0) {
      const s = function(o, r) {
        let a = r.getRegionAtLine(o);
        if (a !== null && a.startLineNumber === o) {
          const l = a.parentIndex;
          let d = 0;
          if (l !== -1) d = r.regions.getEndLineNumber(a.parentIndex);
          else {
            if (r.regions.length === 0) return null;
            d = r.regions.getEndLineNumber(r.regions.length - 1);
          }
          for (; a !== null; ) {
            if (!(a.regionIndex < r.regions.length) || (a = r.regions.toRegion(a.regionIndex + 1), a.startLineNumber >= d)) return null;
            if (a.parentIndex === l) return a.startLineNumber;
          }
        } else if (r.regions.length > 0) for (a = r.regions.toRegion(0); a !== null; ) {
          if (a.startLineNumber > o) return a.startLineNumber;
          a = a.regionIndex < r.regions.length ? r.regions.toRegion(a.regionIndex + 1) : null;
        }
        return null;
      }(n[0], e);
      s !== null && t.setSelection({ startLineNumber: s, startColumn: 1, endLineNumber: s, endColumn: 1 });
    }
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.createFoldingRangeFromSelection", label: m(0, "Create Folding Range from Selection"), alias: "Create Folding Range from Selection", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2135), weight: 100 } });
  }
  invoke(i, e, t) {
    var n;
    const s = [], o = t.getSelections();
    if (o) {
      for (const r of o) {
        let a = r.endLineNumber;
        r.endColumn === 1 && --a, a > r.startLineNumber && (s.push({ startLineNumber: r.startLineNumber, endLineNumber: a, type: void 0, isCollapsed: !0, source: 1 }), t.setSelection({ startLineNumber: r.startLineNumber, startColumn: 1, endLineNumber: r.startLineNumber, endColumn: 1 }));
      }
      if (s.length > 0) {
        s.sort((a, l) => a.startLineNumber - l.startLineNumber);
        const r = go.sanitizeAndMerge(e.regions, s, (n = t.getModel()) === null || n === void 0 ? void 0 : n.getLineCount());
        e.updatePost(go.fromFoldRanges(r));
      }
    }
  }
}), X(class extends jn {
  constructor() {
    super({ id: "editor.removeManualFoldingRanges", label: m(0, "Remove Manual Folding Ranges"), alias: "Remove Manual Folding Ranges", precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2137), weight: 100 } });
  }
  invoke(i, e, t) {
    const n = t.getSelections();
    if (n) {
      const s = [];
      for (const o of n) {
        const { startLineNumber: r, endLineNumber: a } = o;
        s.push(a >= r ? { startLineNumber: r, endLineNumber: a } : { endLineNumber: a, startLineNumber: r });
      }
      e.removeManualRanges(s), i.triggerFoldingModelChanged();
    }
  }
});
for (let i = 1; i <= 7; i++) o9 = new eg({ id: eg.ID(i), label: m(0, "Fold Level {0}", i), alias: `Fold Level ${i}`, precondition: Pn, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2048 | 21 + i), weight: 100 } }), Ho.INSTANCE.registerEditorAction(o9);
var o9;
dt.registerCommand("_executeFoldingRangeProvider", async function(i, ...e) {
  const [t] = e;
  if (!(t instanceof Ie)) throw Yo();
  const n = i.get(fe), s = i.get(ni).getModel(t);
  if (!s) throw Yo();
  const o = i.get(Ye);
  if (!o.getValue("editor.folding", { resource: t })) return [];
  const r = i.get(zt), a = o.getValue("editor.foldingStrategy", { resource: t }), l = { get limit() {
    return o.getValue("editor.foldingMaximumRegions", { resource: t });
  }, update: (g, p) => {
  } }, d = new xP(s, r, l);
  let h = d;
  if (a !== "indentation") {
    const g = Id.getFoldingRangeProviders(n, s);
    g.length && (h = new NP(s, g, () => {
    }, l, d));
  }
  const c = await h.compute(et.None), u = [];
  try {
    if (c) for (let g = 0; g < c.length; g++) {
      const p = c.getType(g);
      u.push({ start: c.getStartLineNumber(g), end: c.getEndLineNumber(g), kind: p ? ls.fromValue(p) : void 0 });
    }
    return u;
  } finally {
    h.dispose();
  }
});
X(class extends he {
  constructor() {
    super({ id: "editor.action.fontZoomIn", label: m(0, "Increase Editor Font Size"), alias: "Increase Editor Font Size", precondition: void 0 });
  }
  run(i, e) {
    Vo.setZoomLevel(Vo.getZoomLevel() + 1);
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.fontZoomOut", label: m(0, "Decrease Editor Font Size"), alias: "Decrease Editor Font Size", precondition: void 0 });
  }
  run(i, e) {
    Vo.setZoomLevel(Vo.getZoomLevel() - 1);
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.fontZoomReset", label: m(0, "Reset Editor Font Size"), alias: "Reset Editor Font Size", precondition: void 0 });
  }
  run(i, e) {
    Vo.setZoomLevel(0);
  }
});
var $z = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, I0 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let M0 = class {
  constructor(i, e, t, n) {
    this._editor = i, this._languageFeaturesService = e, this._workerService = t, this._accessibilitySignalService = n, this._disposables = new G(), this._sessionDisposables = new G(), this._disposables.add(e.onTypeFormattingEditProvider.onDidChange(this._update, this)), this._disposables.add(i.onDidChangeModel(() => this._update())), this._disposables.add(i.onDidChangeModelLanguage(() => this._update())), this._disposables.add(i.onDidChangeConfiguration((s) => {
      s.hasChanged(56) && this._update();
    })), this._update();
  }
  dispose() {
    this._disposables.dispose(), this._sessionDisposables.dispose();
  }
  _update() {
    if (this._sessionDisposables.clear(), !this._editor.getOption(56) || !this._editor.hasModel()) return;
    const i = this._editor.getModel(), [e] = this._languageFeaturesService.onTypeFormattingEditProvider.ordered(i);
    if (!e || !e.autoFormatTriggerCharacters) return;
    const t = new ey();
    for (const n of e.autoFormatTriggerCharacters) t.add(n.charCodeAt(0));
    this._sessionDisposables.add(this._editor.onDidType((n) => {
      const s = n.charCodeAt(n.length - 1);
      t.has(s) && this._trigger(String.fromCharCode(s));
    }));
  }
  _trigger(i) {
    if (!this._editor.hasModel() || this._editor.getSelections().length > 1 || !this._editor.getSelection().isEmpty()) return;
    const e = this._editor.getModel(), t = this._editor.getPosition(), n = new Ci(), s = this._editor.onDidChangeModelContent((o) => {
      if (o.isFlush) return n.cancel(), void s.dispose();
      for (let r = 0, a = o.changes.length; r < a; r++)
        if (o.changes[r].range.endLineNumber <= t.lineNumber) return n.cancel(), void s.dispose();
    });
    rH(this._workerService, this._languageFeaturesService, e, t, i, e.getFormattingOptions(), n.token).then((o) => {
      n.token.isCancellationRequested || zn(o) && (this._accessibilitySignalService.playSignal(He.format, { userGesture: !1 }), lf.execute(this._editor, o, !0));
    }).finally(() => {
      s.dispose();
    });
  }
};
M0.ID = "editor.contrib.autoFormat", M0 = $z([I0(1, fe), I0(2, Qo), I0(3, Fc)], M0);
let T0 = class {
  constructor(i, e, t) {
    this.editor = i, this._languageFeaturesService = e, this._instantiationService = t, this._callOnDispose = new G(), this._callOnModel = new G(), this._callOnDispose.add(i.onDidChangeConfiguration(() => this._update())), this._callOnDispose.add(i.onDidChangeModel(() => this._update())), this._callOnDispose.add(i.onDidChangeModelLanguage(() => this._update())), this._callOnDispose.add(e.documentRangeFormattingEditProvider.onDidChange(this._update, this));
  }
  dispose() {
    this._callOnDispose.dispose(), this._callOnModel.dispose();
  }
  _update() {
    this._callOnModel.clear(), this.editor.getOption(55) && this.editor.hasModel() && this._languageFeaturesService.documentRangeFormattingEditProvider.has(this.editor.getModel()) && this._callOnModel.add(this.editor.onDidPaste(({ range: i }) => this._trigger(i)));
  }
  _trigger(i) {
    this.editor.hasModel() && (this.editor.getSelections().length > 1 || this._instantiationService.invokeFunction(oH, this.editor, i, 2, Nd.None, et.None, !1).catch(We));
  }
};
T0.ID = "editor.contrib.formatOnPaste", T0 = $z([I0(1, fe), I0(2, Se)], T0);
ft(M0.ID, M0, 2), ft(T0.ID, T0, 2), X(class extends he {
  constructor() {
    super({ id: "editor.action.formatDocument", label: m(0, "Format Document"), alias: "Format Document", precondition: q.and(E.notInCompositeEditor, E.writable, E.hasDocumentFormattingProvider), kbOpts: { kbExpr: E.editorTextFocus, primary: 1572, linux: { primary: 3111 }, weight: 100 }, contextMenuOpts: { group: "1_modification", order: 1.3 } });
  }
  async run(i, e) {
    if (e.hasModel()) {
      const t = i.get(Se);
      await i.get(Ec).showWhile(t.invokeFunction(Coe, e, 1, Nd.None, et.None, !0), 250);
    }
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.formatSelection", label: m(0, "Format Selection"), alias: "Format Selection", precondition: q.and(E.writable, E.hasDocumentSelectionFormattingProvider), kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2084), weight: 100 }, contextMenuOpts: { when: E.hasNonEmptySelection, group: "1_modification", order: 1.31 } });
  }
  async run(i, e) {
    if (!e.hasModel()) return;
    const t = i.get(Se), n = e.getModel(), s = e.getSelections().map((r) => r.isEmpty() ? new D(r.startLineNumber, 1, r.startLineNumber, n.getLineMaxColumn(r.startLineNumber)) : r);
    await i.get(Ec).showWhile(t.invokeFunction(oH, e, s, 1, Nd.None, et.None, !0), 250);
  }
}), dt.registerCommand("editor.action.format", async (i) => {
  const e = i.get(mt).getFocusedCodeEditor();
  if (!e || !e.hasModel()) return;
  const t = i.get(ai);
  e.getSelection().isEmpty() ? await t.executeCommand("editor.action.formatDocument") : await t.executeCommand("editor.action.formatSelection");
});
var Nle = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Kx = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class $p {
  remove() {
    var e;
    (e = this.parent) === null || e === void 0 || e.children.delete(this.id);
  }
  static findId(e, t) {
    let n;
    typeof e == "string" ? n = `${t.id}/${e}` : (n = `${t.id}/${e.name}`, t.children.get(n) !== void 0 && (n = `${t.id}/${e.name}_${e.range.startLineNumber}_${e.range.startColumn}`));
    let s = n;
    for (let o = 0; t.children.get(s) !== void 0; o++) s = `${n}_${o}`;
    return s;
  }
  static empty(e) {
    return e.children.size === 0;
  }
}
class YM extends $p {
  constructor(e, t, n) {
    super(), this.id = e, this.parent = t, this.symbol = n, this.children = /* @__PURE__ */ new Map();
  }
}
class Gz extends $p {
  constructor(e, t, n, s) {
    super(), this.id = e, this.parent = t, this.label = n, this.order = s, this.children = /* @__PURE__ */ new Map();
  }
}
class Zl extends $p {
  static create(e, t, n) {
    const s = new Ci(n), o = new Zl(t.uri), r = e.ordered(t), a = r.map((d, h) => {
      var c;
      const u = $p.findId(`provider_${h}`, o), g = new Gz(u, o, (c = d.displayName) !== null && c !== void 0 ? c : "Unknown Outline Provider", h);
      return Promise.resolve(d.provideDocumentSymbols(t, s.token)).then((p) => {
        for (const f of p || []) Zl._makeOutlineElement(f, g);
        return g;
      }, (p) => (Ni(p), g)).then((p) => {
        $p.empty(p) ? p.remove() : o._groups.set(u, p);
      });
    }), l = e.onDidChange(() => {
      ri(e.ordered(t), r) || s.cancel();
    });
    return Promise.all(a).then(() => s.token.isCancellationRequested && !n.isCancellationRequested ? Zl.create(e, t, n) : o._compact()).finally(() => {
      s.dispose(), l.dispose(), s.dispose();
    });
  }
  static _makeOutlineElement(e, t) {
    const n = $p.findId(e, t), s = new YM(n, t, e);
    if (e.children) for (const o of e.children) Zl._makeOutlineElement(o, s);
    t.children.set(s.id, s);
  }
  constructor(e) {
    super(), this.uri = e, this.id = "root", this.parent = void 0, this._groups = /* @__PURE__ */ new Map(), this.children = /* @__PURE__ */ new Map(), this.id = "root", this.parent = void 0;
  }
  _compact() {
    let e = 0;
    for (const [t, n] of this._groups) n.children.size === 0 ? this._groups.delete(t) : e += 1;
    if (e !== 1) this.children = this._groups;
    else {
      const t = at.first(this._groups.values());
      for (const [, n] of t.children) n.parent = this, this.children.set(n.id, n);
    }
    return this;
  }
  getTopLevelSymbols() {
    const e = [];
    for (const t of this.children.values()) t instanceof YM ? e.push(t.symbol) : e.push(...at.map(t.children.values(), (n) => n.symbol));
    return e.sort((t, n) => D.compareRangesUsingStarts(t.range, n.range));
  }
  asListOfDocumentSymbols() {
    const e = this.getTopLevelSymbols(), t = [];
    return Zl._flattenDocumentSymbols(t, e, ""), t.sort((n, s) => W.compare(D.getStartPosition(n.range), D.getStartPosition(s.range)) || W.compare(D.getEndPosition(s.range), D.getEndPosition(n.range)));
  }
  static _flattenDocumentSymbols(e, t, n) {
    for (const s of t) e.push({ kind: s.kind, tags: s.tags, name: s.name, detail: s.detail, containerName: s.containerName || n, range: s.range, selectionRange: s.selectionRange, children: void 0 }), s.children && Zl._flattenDocumentSymbols(e, s.children, s.name);
  }
}
const n1 = tt("IOutlineModelService");
let jx = class {
  constructor(i, e, t) {
    this._languageFeaturesService = i, this._disposables = new G(), this._cache = new Ll(10, 0.7), this._debounceInformation = e.for(i.documentSymbolProvider, "DocumentSymbols", { min: 350 }), this._disposables.add(t.onModelRemoved((n) => {
      this._cache.delete(n.id);
    }));
  }
  dispose() {
    this._disposables.dispose();
  }
  async getOrCreate(i, e) {
    const t = this._languageFeaturesService.documentSymbolProvider, n = t.ordered(i);
    let s = this._cache.get(i.id);
    if (!s || s.versionId !== i.getVersionId() || !ri(s.provider, n)) {
      const r = new Ci();
      s = { versionId: i.getVersionId(), provider: n, promiseCnt: 0, source: r, promise: Zl.create(t, i, r.token), model: void 0 }, this._cache.set(i.id, s);
      const a = Date.now();
      s.promise.then((l) => {
        s.model = l, this._debounceInformation.update(i, Date.now() - a);
      }).catch((l) => {
        this._cache.delete(i.id);
      });
    }
    if (s.model) return s.model;
    s.promiseCnt += 1;
    const o = e.onCancellationRequested(() => {
      --s.promiseCnt == 0 && (s.source.cancel(), this._cache.delete(i.id));
    });
    try {
      return await s.promise;
    } finally {
      o.dispose();
    }
  }
};
jx = Nle([Kx(0, fe), Kx(1, ar), Kx(2, ni)], jx), rt(n1, jx, 1), dt.registerCommand("_executeDocumentSymbolProvider", async function(i, ...e) {
  const [t] = e;
  vt(Ie.isUri(t));
  const n = i.get(n1), s = i.get(Ps), o = await s.createModelReference(t);
  try {
    return (await n.getOrCreate(o.object.textEditorModel, et.None)).getTopLevelSymbols();
  } finally {
    o.dispose();
  }
});
class un extends V {
  constructor(e, t) {
    super(), this.contextKeyService = e, this.model = t, this.inlineCompletionVisible = un.inlineSuggestionVisible.bindTo(this.contextKeyService), this.inlineCompletionSuggestsIndentation = un.inlineSuggestionHasIndentation.bindTo(this.contextKeyService), this.inlineCompletionSuggestsIndentationLessThanTabSize = un.inlineSuggestionHasIndentationLessThanTabSize.bindTo(this.contextKeyService), this.suppressSuggestions = un.suppressSuggestions.bindTo(this.contextKeyService), this._register(Ge((n) => {
      const s = this.model.read(n), o = s == null ? void 0 : s.state.read(n), r = !!(o != null && o.inlineCompletion) && (o == null ? void 0 : o.primaryGhostText) !== void 0 && !(o != null && o.primaryGhostText.isEmpty());
      this.inlineCompletionVisible.set(r), o != null && o.primaryGhostText && (o != null && o.inlineCompletion) && this.suppressSuggestions.set(o.inlineCompletion.inlineCompletion.source.inlineCompletions.suppressSuggestions);
    })), this._register(Ge((n) => {
      const s = this.model.read(n);
      let o = !1, r = !0;
      const a = s == null ? void 0 : s.primaryGhostText.read(n);
      if (s != null && s.selectedSuggestItem && a && a.parts.length > 0) {
        const { column: l, lines: d } = a.parts[0], h = d[0];
        if (l <= s.textModel.getLineIndentColumn(a.lineNumber)) {
          let c = Jn(h);
          c === -1 && (c = h.length - 1), o = c > 0;
          const u = s.textModel.getOptions().tabSize;
          r = Gi.visibleColumnFromColumn(h, c + 1, u) < u;
        }
      }
      this.inlineCompletionSuggestsIndentation.set(o), this.inlineCompletionSuggestsIndentationLessThanTabSize.set(r);
    }));
  }
}
un.inlineSuggestionVisible = new ae("inlineSuggestionVisible", !1, m(0, "Whether an inline suggestion is visible")), un.inlineSuggestionHasIndentation = new ae("inlineSuggestionHasIndentation", !1, m(0, "Whether the inline suggestion starts with whitespace")), un.inlineSuggestionHasIndentationLessThanTabSize = new ae("inlineSuggestionHasIndentationLessThanTabSize", !0, m(0, "Whether the inline suggestion starts with whitespace that is less than what would be inserted by tab")), un.suppressSuggestions = new ae("inlineSuggestionSuppressSuggestions", void 0, m(0, "Whether suggestions should be suppressed for the current suggestion"));
class s1 {
  constructor(e, t) {
    this.lineNumber = e, this.parts = t;
  }
  equals(e) {
    return this.lineNumber === e.lineNumber && this.parts.length === e.parts.length && this.parts.every((t, n) => t.equals(e.parts[n]));
  }
  renderForScreenReader(e) {
    if (this.parts.length === 0) return "";
    const t = this.parts[this.parts.length - 1], n = e.substr(0, t.column - 1);
    return new tP([...this.parts.map((s) => new Bd(D.fromPositions(new W(1, s.column)), s.lines.join(`
`)))]).applyToString(n).substring(this.parts[0].column - 1);
  }
  isEmpty() {
    return this.parts.every((e) => e.lines.length === 0);
  }
  get lineCount() {
    return 1 + this.parts.reduce((e, t) => e + t.lines.length - 1, 0);
  }
}
class LS {
  constructor(e, t, n) {
    this.column = e, this.text = t, this.preview = n, this.lines = Sl(this.text);
  }
  equals(e) {
    return this.column === e.column && this.lines.length === e.lines.length && this.lines.every((t, n) => t === e.lines[n]);
  }
}
class XM {
  constructor(e, t, n, s = 0) {
    this.lineNumber = e, this.columnRange = t, this.text = n, this.additionalReservedLineCount = s, this.parts = [new LS(this.columnRange.endColumnExclusive, this.text, !1)], this.newLines = Sl(this.text);
  }
  renderForScreenReader(e) {
    return this.newLines.join(`
`);
  }
  get lineCount() {
    return this.newLines.length;
  }
  isEmpty() {
    return this.parts.every((e) => e.lines.length === 0);
  }
  equals(e) {
    return this.lineNumber === e.lineNumber && this.columnRange.equals(e.columnRange) && this.newLines.length === e.newLines.length && this.newLines.every((t, n) => t === e.newLines[n]) && this.additionalReservedLineCount === e.additionalReservedLineCount;
  }
}
function r9(i, e) {
  return ri(i, e, Zz);
}
function Zz(i, e) {
  return i === e || !(!i || !e) && (i instanceof s1 && e instanceof s1 || i instanceof XM && e instanceof XM) && i.equals(e);
}
const Ele = [];
class Yz {
  constructor(e, t) {
    if (this.startColumn = e, this.endColumnExclusive = t, e > t) throw new Kt(`startColumn ${e} cannot be after endColumnExclusive ${t}`);
  }
  toRange(e) {
    return new D(e, this.startColumn, e, this.endColumnExclusive);
  }
  equals(e) {
    return this.startColumn === e.startColumn && this.endColumnExclusive === e.endColumnExclusive;
  }
}
function Xz(i, e) {
  const t = new G(), n = i.createDecorationsCollection();
  return t.add(DL({ debugName: () => `Apply decorations from ${e.debugName}` }, (s) => {
    const o = e.read(s);
    n.set(o);
  })), t.add({ dispose: () => {
    n.clear();
  } }), t;
}
function a9(i, e) {
  return new W(i.lineNumber - e.lineNumber + 1, i.lineNumber - e.lineNumber == 0 ? i.column - e.column + 1 : i.column);
}
var Ile = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Mle = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const l9 = "ghost-text";
let QM = class extends V {
  constructor(i, e, t) {
    super(), this.editor = i, this.model = e, this.languageService = t, this.isDisposed = lt(this, !1), this.currentTextModel = Rt(this.editor.onDidChangeModel, () => this.editor.getModel()), this.uiState = Fe(this, (n) => {
      if (this.isDisposed.read(n)) return;
      const s = this.currentTextModel.read(n);
      if (s !== this.model.targetTextModel.read(n)) return;
      const o = this.model.ghostText.read(n);
      if (!o) return;
      const r = o instanceof XM ? o.columnRange : void 0, a = [], l = [];
      function d(p, f) {
        if (l.length > 0) {
          const _ = l[l.length - 1];
          f && _.decorations.push(new _s(_.content.length + 1, _.content.length + 1 + p[0].length, f, 0)), _.content += p[0], p = p.slice(1);
        }
        for (const _ of p) l.push({ content: _, decorations: f ? [new _s(1, _.length + 1, f, 0)] : [] });
      }
      const h = s.getLineContent(o.lineNumber);
      let c, u = 0;
      for (const p of o.parts) {
        let f = p.lines;
        c === void 0 ? (a.push({ column: p.column, text: f[0], preview: p.preview }), f = f.slice(1)) : d([h.substring(u, p.column - 1)], void 0), f.length > 0 && (d(f, l9), c === void 0 && p.column <= h.length && (c = p.column)), u = p.column - 1;
      }
      c !== void 0 && d([h.substring(u)], void 0);
      const g = c !== void 0 ? new Yz(c, h.length + 1) : void 0;
      return { replacedRange: r, inlineTexts: a, additionalLines: l, hiddenRange: g, lineNumber: o.lineNumber, additionalReservedLineCount: this.model.minReservedLineCount.read(n), targetTextModel: s };
    }), this.decorations = Fe(this, (n) => {
      const s = this.uiState.read(n);
      if (!s) return [];
      const o = [];
      s.replacedRange && o.push({ range: s.replacedRange.toRange(s.lineNumber), options: { inlineClassName: "inline-completion-text-to-replace", description: "GhostTextReplacement" } }), s.hiddenRange && o.push({ range: s.hiddenRange.toRange(s.lineNumber), options: { inlineClassName: "ghost-text-hidden", description: "ghost-text-hidden" } });
      for (const r of s.inlineTexts) o.push({ range: D.fromPositions(new W(s.lineNumber, r.column)), options: { description: l9, after: { content: r.text, inlineClassName: r.preview ? "ghost-text-decoration-preview" : "ghost-text-decoration", cursorStops: vr.Left }, showIfCollapsed: !0 } });
      return o;
    }), this.additionalLinesWidget = this._register(new Qz(this.editor, this.languageService.languageIdCodec, Fe((n) => {
      const s = this.uiState.read(n);
      return s ? { lineNumber: s.lineNumber, additionalLines: s.additionalLines, minReservedLineCount: s.additionalReservedLineCount, targetTextModel: s.targetTextModel } : void 0;
    }))), this._register(ye(() => {
      this.isDisposed.set(!0, void 0);
    })), this._register(Xz(this.editor, this.decorations));
  }
  ownsViewZone(i) {
    return this.additionalLinesWidget.viewZoneId === i;
  }
};
QM = Ile([Mle(2, Xt)], QM);
class Qz extends V {
  get viewZoneId() {
    return this._viewZoneId;
  }
  constructor(e, t, n) {
    super(), this.editor = e, this.languageIdCodec = t, this.lines = n, this._viewZoneId = void 0, this.editorOptionsChanged = Hn("editorOptionChanged", se.filter(this.editor.onDidChangeConfiguration, (s) => s.hasChanged(33) || s.hasChanged(117) || s.hasChanged(99) || s.hasChanged(94) || s.hasChanged(51) || s.hasChanged(50) || s.hasChanged(67))), this._register(Ge((s) => {
      const o = this.lines.read(s);
      this.editorOptionsChanged.read(s), o ? this.updateLines(o.lineNumber, o.additionalLines, o.minReservedLineCount) : this.clear();
    }));
  }
  dispose() {
    super.dispose(), this.clear();
  }
  clear() {
    this.editor.changeViewZones((e) => {
      this._viewZoneId && (e.removeZone(this._viewZoneId), this._viewZoneId = void 0);
    });
  }
  updateLines(e, t, n) {
    const s = this.editor.getModel();
    if (!s) return;
    const { tabSize: o } = s.getOptions();
    this.editor.changeViewZones((r) => {
      this._viewZoneId && (r.removeZone(this._viewZoneId), this._viewZoneId = void 0);
      const a = Math.max(t.length, n);
      if (a > 0) {
        const l = document.createElement("div");
        (function(d, h, c, u, g) {
          const p = u.get(33), f = u.get(117), _ = "none", v = u.get(94), b = u.get(51), C = u.get(50), w = u.get(67), y = new ff(1e4);
          y.appendString('<div class="suggest-preview-text">');
          for (let N = 0, A = c.length; N < A; N++) {
            const B = c[N], T = B.content;
            y.appendString('<div class="view-line'), y.appendString('" style="top:'), y.appendString(String(N * w)), y.appendString('px;width:1000000px;">');
            const O = f1(T), H = Fm(T), $ = nn.createEmpty(T, g);
            y1(new Lc(C.isMonospace && !p, C.canUseHalfwidthRightwardsArrow, T, !1, O, H, 0, $, B.decorations, h, 0, C.spaceWidth, C.middotWidth, C.wsmiddotWidth, f, _, v, b !== fo.OFF, null), y), y.appendString("</div>");
          }
          y.appendString("</div>"), yn(d, C);
          const L = y.build(), k = d9 ? d9.createHTML(L) : L;
          d.innerHTML = k;
        })(l, o, t, this.editor.getOptions(), this.languageIdCodec), this._viewZoneId = r.addZone({ afterLineNumber: e, heightInLines: a, domNode: l, afterColumnAffinity: 1 });
      }
    });
  }
}
const d9 = Hd("editorGhostText", { createHTML: (i) => i });
class Tle {
  constructor(e) {
    this.lines = e, this.tokenization = { getLineTokens: (t) => this.lines[t - 1] };
  }
  getLineCount() {
    return this.lines.length;
  }
  getLineLength(e) {
    return this.lines[e - 1].getLineContent().length;
  }
}
async function Rle(i, e, t, n, s = et.None, o) {
  const r = function(v, b) {
    const C = b.getWordAtPosition(v), w = b.getLineMaxColumn(v.lineNumber);
    return C ? new D(v.lineNumber, C.startColumn, v.lineNumber, w) : D.fromPositions(v, v.with(void 0, w));
  }(e, t), a = i.all(t), l = new yR();
  for (const v of a) v.groupId && l.add(v.groupId, v);
  function d(v) {
    if (!v.yieldsToGroupIds) return [];
    const b = [];
    for (const C of v.yieldsToGroupIds || []) {
      const w = l.get(C);
      for (const y of w) b.push(y);
    }
    return b;
  }
  const h = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Set();
  function u(v, b) {
    if (b = [...b, v], c.has(v)) return b;
    c.add(v);
    try {
      const C = d(v);
      for (const w of C) {
        const y = u(w, b);
        if (y) return y;
      }
    } finally {
      c.delete(v);
    }
  }
  function g(v) {
    const b = h.get(v);
    if (b) return b;
    const C = u(v, []);
    C && Ni(new Error(`Inline completions: cyclic yield-to dependency detected. Path: ${C.map((y) => y.toString ? y.toString() : "" + y).join(" -> ")}`));
    const w = new b1();
    return h.set(v, w.p), (async () => {
      if (!C) {
        const y = d(v);
        for (const L of y) {
          const k = await g(L);
          if (k && k.items.length > 0) return;
        }
      }
      try {
        return await v.provideInlineCompletions(t, e, n, s);
      } catch (y) {
        return void Ni(y);
      }
    })().then((y) => w.complete(y), (y) => w.error(y)), w.p;
  }
  const p = await Promise.all(a.map(async (v) => ({ provider: v, completions: await g(v) }))), f = /* @__PURE__ */ new Map(), _ = [];
  for (const v of p) {
    const b = v.completions;
    if (!b) continue;
    const C = new Ple(b, v.provider);
    _.push(C);
    for (const w of b.items) {
      const y = kS.from(w, C, r, t, o);
      f.set(y.hash(), y);
    }
  }
  return new Ale(Array.from(f.values()), new Set(f.keys()), _);
}
class Ale {
  constructor(e, t, n) {
    this.completions = e, this.hashs = t, this.providerResults = n;
  }
  has(e) {
    return this.hashs.has(e.hash());
  }
  dispose() {
    for (const e of this.providerResults) e.removeRef();
  }
}
class Ple {
  constructor(e, t) {
    this.inlineCompletions = e, this.provider = t, this.refCount = 1;
  }
  addRef() {
    this.refCount++;
  }
  removeRef() {
    this.refCount--, this.refCount === 0 && this.provider.freeInlineCompletions(this.inlineCompletions);
  }
}
class kS {
  static from(e, t, n, s, o) {
    let r, a, l = e.range ? D.lift(e.range) : n;
    if (typeof e.insertText == "string") {
      if (r = e.insertText, o && e.completeBracketPairs) {
        r = h9(r, l.getStartPosition(), s, o);
        const d = r.length - e.insertText.length;
        d !== 0 && (l = new D(l.startLineNumber, l.startColumn, l.endLineNumber, l.endColumn + d));
      }
      a = void 0;
    } else if ("snippet" in e.insertText) {
      const d = e.insertText.snippet.length;
      if (o && e.completeBracketPairs) {
        e.insertText.snippet = h9(e.insertText.snippet, l.getStartPosition(), s, o);
        const c = e.insertText.snippet.length - d;
        c !== 0 && (l = new D(l.startLineNumber, l.startColumn, l.endLineNumber, l.endColumn + c));
      }
      const h = new wg().parse(e.insertText.snippet);
      h.children.length === 1 && h.children[0] instanceof hs ? (r = h.children[0].value, a = void 0) : (r = h.toString(), a = { snippet: e.insertText.snippet, range: l });
    } else JS(e.insertText);
    return new kS(r, e.command, l, r, a, e.additionalTextEdits || Ele, e, t);
  }
  constructor(e, t, n, s, o, r, a, l) {
    this.filterText = e, this.command = t, this.range = n, this.insertText = s, this.snippetInfo = o, this.additionalTextEdits = r, this.sourceInlineCompletion = a, this.source = l, s = (e = e.replace(/\r\n|\r/g, `
`)).replace(/\r\n|\r/g, `
`);
  }
  withRange(e) {
    return new kS(this.filterText, this.command, e, this.insertText, this.snippetInfo, this.additionalTextEdits, this.sourceInlineCompletion, this.source);
  }
  hash() {
    return JSON.stringify({ insertText: this.insertText, range: this.range.toString() });
  }
}
function h9(i, e, t, n) {
  const s = t.getLineContent(e.lineNumber).substring(0, e.column - 1) + i, o = t.tokenization.tokenizeLineWithEdit(e, s.length - (e.column - 1), i), r = o == null ? void 0 : o.sliceAndInflate(e.column - 1, s.length, 0);
  return r ? function(l, d) {
    const h = new XB(), c = new JB(h, (f) => d.getLanguageConfiguration(f)), u = dI(new QB(new Tle([l]), c), [], void 0, !0);
    let g = "";
    const p = l.getLineContent();
    return function f(_, v) {
      if (_.kind === 2) if (f(_.openingBracket, v), v = gi(v, _.openingBracket.length), _.child && (f(_.child, v), v = gi(v, _.child.length)), _.closingBracket) f(_.closingBracket, v), v = gi(v, _.closingBracket.length);
      else {
        const b = c.getSingleLanguageBracketTokens(_.openingBracket.languageId).findClosingTokenText(_.openingBracket.bracketIds);
        g += b;
      }
      else if (_.kind !== 3) {
        if (_.kind === 0 || _.kind === 1) g += p.substring(v, gi(v, _.length));
        else if (_.kind === 4) for (const b of _.children) f(b, v), v = gi(v, b.length);
      }
    }(u, vs), g;
  }(r, n) : i;
}
function tg(i, e, t) {
  const n = t ? i.range.intersectRanges(t) : i.range;
  if (!n) return i;
  const s = e.getValueInRange(n, 1), o = fc(s, i.text), r = kr.ofText(s.substring(0, o)).addToPosition(i.range.getStartPosition()), a = i.text.substring(o), l = D.fromPositions(r, i.range.getEndPosition());
  return new Bd(l, a);
}
function Jz(i, e) {
  return i.text.startsWith(e.text) && (t = i.range, (n = e.range).getStartPosition().equals(t.getStartPosition()) && n.getEndPosition().isBeforeOrEqual(t.getEndPosition()));
  var t, n;
}
function c9(i, e, t, n, s = 0) {
  let o = tg(i, e);
  if (o.range.endLineNumber !== o.range.startLineNumber) return;
  const r = e.getLineContent(o.range.startLineNumber), a = Wt(r).length;
  if (o.range.startColumn - 1 <= a) {
    const g = Wt(o.text).length, p = r.substring(o.range.startColumn - 1, a), [f, _] = [o.range.getStartPosition(), o.range.getEndPosition()], v = f.column + p.length <= _.column ? f.delta(0, p.length) : _, b = D.fromPositions(v, _), C = o.text.startsWith(p) ? o.text.substring(p.length) : o.text.substring(g);
    o = new Bd(b, C);
  }
  const l = e.getValueInRange(o.range), d = function(g, p) {
    if ((tu == null ? void 0 : tu.originalValue) === g && (tu == null ? void 0 : tu.newValue) === p) return tu == null ? void 0 : tu.changes;
    {
      let f = g9(g, p, !0);
      if (f) {
        const _ = u9(f);
        if (_ > 0) {
          const v = g9(g, p, !1);
          v && u9(v) < _ && (f = v);
        }
      }
      return tu = { originalValue: g, newValue: p, changes: f }, f;
    }
  }(l, o.text);
  if (!d) return;
  const h = o.range.startLineNumber, c = new Array();
  if (t === "prefix") {
    const g = d.filter((p) => p.originalLength === 0);
    if (g.length > 1 || g.length === 1 && g[0].originalStart !== l.length) return;
  }
  const u = o.text.length - s;
  for (const g of d) {
    const p = o.range.startColumn + g.originalStart + g.originalLength;
    if (t === "subwordSmart" && n && n.lineNumber === o.range.startLineNumber && p < n.column || g.originalLength > 0) return;
    if (g.modifiedLength === 0) continue;
    const f = g.modifiedStart + g.modifiedLength, _ = Math.max(g.modifiedStart, Math.min(f, u)), v = o.text.substring(g.modifiedStart, _), b = o.text.substring(_, Math.max(g.modifiedStart, f));
    v.length > 0 && c.push(new LS(p, v, !1)), b.length > 0 && c.push(new LS(p, b, !0));
  }
  return new s1(h, c);
}
let tu;
function u9(i) {
  let e = 0;
  for (const t of i) e += t.originalLength;
  return e;
}
function g9(i, e, t) {
  if (i.length > 5e3 || e.length > 5e3) return;
  function n(d) {
    let h = 0;
    for (let c = 0, u = d.length; c < u; c++) {
      const g = d.charCodeAt(c);
      g > h && (h = g);
    }
    return h;
  }
  const s = Math.max(n(i), n(e));
  function o(d) {
    if (d < 0) throw new Error("unexpected");
    return s + d + 1;
  }
  function r(d) {
    let h = 0, c = 0;
    const u = new Int32Array(d.length);
    for (let g = 0, p = d.length; g < p; g++) if (t && d[g] === "(") {
      const f = 100 * c + h;
      u[g] = o(2 * f), h++;
    } else if (t && d[g] === ")") {
      h = Math.max(h - 1, 0);
      const f = 100 * c + h;
      u[g] = o(2 * f + 1), h === 0 && c++;
    } else u[g] = d.charCodeAt(g);
    return u;
  }
  const a = r(i), l = r(e);
  return new $a({ getElements: () => a }, { getElements: () => l }).ComputeDiff(!1).changes;
}
var Ole = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, p9 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let JM = class extends V {
  constructor(i, e, t, n, s) {
    super(), this.textModel = i, this.versionId = e, this._debounceValue = t, this.languageFeaturesService = n, this.languageConfigurationService = s, this._updateOperation = this._register(new rn()), this.inlineCompletions = Av("inlineCompletions", void 0), this.suggestWidgetInlineCompletions = Av("suggestWidgetInlineCompletions", void 0), this._register(this.textModel.onDidChangeContent(() => {
      this._updateOperation.clear();
    }));
  }
  fetch(i, e, t) {
    var n, s;
    const o = new Fle(i, e, this.textModel.getVersionId()), r = e.selectedSuggestionInfo ? this.suggestWidgetInlineCompletions : this.inlineCompletions;
    if (!((n = this._updateOperation.value) === null || n === void 0) && n.request.satisfies(o)) return this._updateOperation.value.promise;
    if (!((s = r.get()) === null || s === void 0) && s.request.satisfies(o)) return Promise.resolve(!0);
    const a = !!this._updateOperation.value;
    this._updateOperation.clear();
    const l = new Ci(), d = (async () => {
      var c, u;
      if ((a || e.triggerKind === Ld.Automatic) && await (c = this._debounceValue.get(this.textModel), u = l.token, new Promise((v) => {
        let b;
        const C = setTimeout(() => {
          b && b.dispose(), v();
        }, c);
        u && (b = u.onCancellationRequested(() => {
          clearTimeout(C), b && b.dispose(), v();
        }));
      })), l.token.isCancellationRequested || this.textModel.getVersionId() !== o.versionId) return !1;
      const g = /* @__PURE__ */ new Date(), p = await Rle(this.languageFeaturesService.inlineCompletionsProvider, i, this.textModel, e, l.token, this.languageConfigurationService);
      if (l.token.isCancellationRequested || this.textModel.getVersionId() !== o.versionId) return !1;
      const f = /* @__PURE__ */ new Date();
      this._debounceValue.update(this.textModel, f.getTime() - g.getTime());
      const _ = new Wle(p, o, this.textModel, this.versionId);
      if (t) {
        const v = t.toInlineCompletion(void 0);
        t.canBeReused(this.textModel, i) && !p.has(v) && _.prepend(t.inlineCompletion, v.range, !0);
      }
      return this._updateOperation.clear(), Tt((v) => {
        r.set(_, v);
      }), !0;
    })(), h = new Ble(o, l, d);
    return this._updateOperation.value = h, d;
  }
  clear(i) {
    this._updateOperation.clear(), this.inlineCompletions.set(void 0, i), this.suggestWidgetInlineCompletions.set(void 0, i);
  }
  clearSuggestWidgetInlineCompletions(i) {
    var e;
    !((e = this._updateOperation.value) === null || e === void 0) && e.request.context.selectedSuggestionInfo && this._updateOperation.clear(), this.suggestWidgetInlineCompletions.set(void 0, i);
  }
  cancelUpdate() {
    this._updateOperation.clear();
  }
};
JM = Ole([p9(3, fe), p9(4, zt)], JM);
class Fle {
  constructor(e, t, n) {
    this.position = e, this.context = t, this.versionId = n;
  }
  satisfies(e) {
    return this.position.equals(e.position) && function(t, n, s) {
      return !t || !n ? t === n : s(t, n);
    }(this.context.selectedSuggestionInfo, e.context.selectedSuggestionInfo, (t, n) => t.equals(n)) && (e.context.triggerKind === Ld.Automatic || this.context.triggerKind === Ld.Explicit) && this.versionId === e.versionId;
  }
}
class Ble {
  constructor(e, t, n) {
    this.request = e, this.cancellationTokenSource = t, this.promise = n;
  }
  dispose() {
    this.cancellationTokenSource.cancel();
  }
}
class Wle {
  get inlineCompletions() {
    return this._inlineCompletions;
  }
  constructor(e, t, n, s) {
    this.inlineCompletionProviderResult = e, this.request = t, this.textModel = n, this.versionId = s, this._refCount = 1, this._prependedInlineCompletionItems = [], this._rangeVersionIdValue = 0, this._rangeVersionId = Fe(this, (r) => {
      this.versionId.read(r);
      let a = !1;
      for (const l of this._inlineCompletions) a = a || l._updateRange(this.textModel);
      return a && this._rangeVersionIdValue++, this._rangeVersionIdValue;
    });
    const o = n.deltaDecorations([], e.completions.map((r) => ({ range: r.range, options: { description: "inline-completion-tracking-range" } })));
    this._inlineCompletions = e.completions.map((r, a) => new m9(r, o[a], this._rangeVersionId));
  }
  clone() {
    return this._refCount++, this;
  }
  dispose() {
    if (this._refCount--, this._refCount === 0) {
      setTimeout(() => {
        this.textModel.isDisposed() || this.textModel.deltaDecorations(this._inlineCompletions.map((e) => e.decorationId), []);
      }, 0), this.inlineCompletionProviderResult.dispose();
      for (const e of this._prependedInlineCompletionItems) e.source.removeRef();
    }
  }
  prepend(e, t, n) {
    n && e.source.addRef();
    const s = this.textModel.deltaDecorations([], [{ range: t, options: { description: "inline-completion-tracking-range" } }])[0];
    this._inlineCompletions.unshift(new m9(e, s, this._rangeVersionId, t)), this._prependedInlineCompletionItems.push(e);
  }
}
class m9 {
  get forwardStable() {
    var e;
    return (e = this.inlineCompletion.source.inlineCompletions.enableForwardStability) !== null && e !== void 0 && e;
  }
  constructor(e, t, n, s) {
    this.inlineCompletion = e, this.decorationId = t, this.rangeVersion = n, this.semanticId = JSON.stringify([this.inlineCompletion.filterText, this.inlineCompletion.insertText, this.inlineCompletion.range.getStartPosition().toString()]), this._isValid = !0, this._updatedRange = s ?? e.range;
  }
  toInlineCompletion(e) {
    return this.inlineCompletion.withRange(this._getUpdatedRange(e));
  }
  toSingleTextEdit(e) {
    return new Bd(this._getUpdatedRange(e), this.inlineCompletion.insertText);
  }
  isVisible(e, t, n) {
    const s = tg(this._toFilterTextReplacement(n), e);
    if (!this._isValid || !this.inlineCompletion.range.getStartPosition().equals(this._getUpdatedRange(n).getStartPosition()) || t.lineNumber !== s.range.startLineNumber) return !1;
    const o = e.getValueInRange(s.range, 1), r = s.text, a = Math.max(0, t.column - s.range.startColumn);
    let l = r.substring(0, a), d = r.substring(a), h = o.substring(0, a), c = o.substring(a);
    const u = e.getLineIndentColumn(s.range.startLineNumber);
    return s.range.startColumn <= u && (h = h.trimStart(), h.length === 0 && (c = c.trimStart()), l = l.trimStart(), l.length === 0 && (d = d.trimStart())), l.startsWith(h) && !!IW(c, d);
  }
  canBeReused(e, t) {
    return this._isValid && this._getUpdatedRange(void 0).containsPosition(t) && this.isVisible(e, t, void 0) && !this._isSmallerThanOriginal(void 0);
  }
  _toFilterTextReplacement(e) {
    return new Bd(this._getUpdatedRange(e), this.inlineCompletion.filterText);
  }
  _isSmallerThanOriginal(e) {
    return f9(this._getUpdatedRange(e)).isBefore(f9(this.inlineCompletion.range));
  }
  _getUpdatedRange(e) {
    return this.rangeVersion.read(e), this._updatedRange;
  }
  _updateRange(e) {
    const t = e.getDecorationRange(this.decorationId);
    return t ? !this._updatedRange.equalsRange(t) && (this._updatedRange = t, !0) : (this._isValid = !1, !0);
  }
}
function f9(i) {
  return i.startLineNumber === i.endLineNumber ? new W(1, 1 + i.endColumn - i.startColumn) : new W(1 + i.endLineNumber - i.startLineNumber, i.endColumn);
}
const $e = { Visible: UM, HasFocusedSuggestion: new ae("suggestWidgetHasFocusedSuggestion", !1, m(0, "Whether any suggestion is focused")), DetailsVisible: new ae("suggestWidgetDetailsVisible", !1, m(0, "Whether suggestion details are visible")), MultipleSuggestions: new ae("suggestWidgetMultipleSuggestions", !1, m(0, "Whether there are multiple suggestions to pick from")), MakesTextEdit: new ae("suggestionMakesTextEdit", !0, m(0, "Whether inserting the current suggestion yields in a change or has everything already been typed")), AcceptSuggestionsOnEnter: new ae("acceptSuggestionOnEnter", !0, m(0, "Whether suggestions are inserted when pressing Enter")), HasInsertAndReplaceRange: new ae("suggestionHasInsertAndReplaceRange", !1, m(0, "Whether the current suggestion has insert and replace behaviour")), InsertMode: new ae("suggestionInsertMode", void 0, { type: "string", description: m(0, "Whether the default behaviour is to insert or replace") }), CanResolve: new ae("suggestionCanResolve", !1, m(0, "Whether the current suggestion supports to resolve further details")) }, hh = new x("suggestWidgetStatusBar");
class Vle {
  constructor(e, t, n, s) {
    var o;
    this.position = e, this.completion = t, this.container = n, this.provider = s, this.isInvalid = !1, this.score = da.Default, this.distance = 0, this.textLabel = typeof t.label == "string" ? t.label : (o = t.label) === null || o === void 0 ? void 0 : o.label, this.labelLow = this.textLabel.toLowerCase(), this.isInvalid = !this.textLabel, this.sortTextLow = t.sortText && t.sortText.toLowerCase(), this.filterTextLow = t.filterText && t.filterText.toLowerCase(), this.extensionId = t.extensionId, D.isIRange(t.range) ? (this.editStart = new W(t.range.startLineNumber, t.range.startColumn), this.editInsertEnd = new W(t.range.endLineNumber, t.range.endColumn), this.editReplaceEnd = new W(t.range.endLineNumber, t.range.endColumn), this.isInvalid = this.isInvalid || D.spansMultipleLines(t.range) || t.range.startLineNumber !== e.lineNumber) : (this.editStart = new W(t.range.insert.startLineNumber, t.range.insert.startColumn), this.editInsertEnd = new W(t.range.insert.endLineNumber, t.range.insert.endColumn), this.editReplaceEnd = new W(t.range.replace.endLineNumber, t.range.replace.endColumn), this.isInvalid = this.isInvalid || D.spansMultipleLines(t.range.insert) || D.spansMultipleLines(t.range.replace) || t.range.insert.startLineNumber !== e.lineNumber || t.range.replace.startLineNumber !== e.lineNumber || t.range.insert.startColumn !== t.range.replace.startColumn), typeof s.resolveCompletionItem != "function" && (this._resolveCache = Promise.resolve(), this._resolveDuration = 0);
  }
  get isResolved() {
    return this._resolveDuration !== void 0;
  }
  get resolveDuration() {
    return this._resolveDuration !== void 0 ? this._resolveDuration : -1;
  }
  async resolve(e) {
    if (!this._resolveCache) {
      const t = e.onCancellationRequested(() => {
        this._resolveCache = void 0, this._resolveDuration = void 0;
      }), n = new Rn(!0);
      this._resolveCache = Promise.resolve(this.provider.resolveCompletionItem(this.completion, e)).then((s) => {
        Object.assign(this.completion, s), this._resolveDuration = n.elapsed();
      }, (s) => {
        Sa(s) && (this._resolveCache = void 0, this._resolveDuration = void 0);
      }).finally(() => {
        t.dispose();
      });
    }
    return this._resolveCache;
  }
}
class o1 {
  constructor(e = 2, t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Map(), o = !0) {
    this.snippetSortOrder = e, this.kindFilter = t, this.providerFilter = n, this.providerItemsToReuse = s, this.showDeprecated = o;
  }
}
o1.default = new o1();
class Hle {
  constructor(e, t, n, s) {
    this.items = e, this.needsClipboard = t, this.durations = n, this.disposable = s;
  }
}
async function EP(i, e, t, n = o1.default, s = { triggerKind: 0 }, o = et.None) {
  const r = new Rn();
  t = t.clone();
  const a = e.getWordAtPosition(t), l = a ? new D(t.lineNumber, a.startColumn, t.lineNumber, a.endColumn) : D.fromPositions(t), d = { replace: l, insert: l.setEndPosition(t.lineNumber, t.column) }, h = [], c = new G(), u = [];
  let g = !1;
  const p = (v, b, C) => {
    var w, y, L;
    let k = !1;
    if (!b) return k;
    for (const N of b.suggestions) if (!n.kindFilter.has(N.kind)) {
      if (!n.showDeprecated && (!((w = N == null ? void 0 : N.tags) === null || w === void 0) && w.includes(1))) continue;
      N.range || (N.range = d), N.sortText || (N.sortText = typeof N.label == "string" ? N.label : N.label.label), !g && N.insertTextRules && 4 & N.insertTextRules && (g = wg.guessNeedsClipboard(N.insertText)), h.push(new Vle(t, N, b, v)), k = !0;
    }
    return XT(b) && c.add(b), u.push({ providerName: (y = v._debugDisplayName) !== null && y !== void 0 ? y : "unknown_provider", elapsedProvider: (L = b.duration) !== null && L !== void 0 ? L : -1, elapsedOverall: C.elapsed() }), k;
  }, f = (async () => {
  })();
  for (const v of i.orderedGroups(e)) {
    let b = !1;
    if (await Promise.all(v.map(async (C) => {
      if (n.providerItemsToReuse.has(C)) {
        const w = n.providerItemsToReuse.get(C);
        return w.forEach((y) => h.push(y)), void (b = b || w.length > 0);
      }
      if (!(n.providerFilter.size > 0) || n.providerFilter.has(C)) try {
        const w = new Rn(), y = await C.provideCompletionItems(e, t, s, o);
        b = p(C, y, w) || b;
      } catch (w) {
        Ni(w);
      }
    })), b || o.isCancellationRequested) break;
  }
  return await f, o.isCancellationRequested ? (c.dispose(), Promise.reject(new Vd())) : new Hle(h.sort((_ = n.snippetSortOrder, Cw.get(_))), g, { entries: u, elapsed: r.elapsed() }, c);
  var _;
}
function qx(i, e) {
  if (i.sortTextLow && e.sortTextLow) {
    if (i.sortTextLow < e.sortTextLow) return -1;
    if (i.sortTextLow > e.sortTextLow) return 1;
  }
  return i.textLabel < e.textLabel ? -1 : i.textLabel > e.textLabel ? 1 : i.completion.kind - e.completion.kind;
}
const Cw = /* @__PURE__ */ new Map();
Cw.set(0, function(i, e) {
  if (i.completion.kind !== e.completion.kind) {
    if (i.completion.kind === 27) return -1;
    if (e.completion.kind === 27) return 1;
  }
  return qx(i, e);
}), Cw.set(2, function(i, e) {
  if (i.completion.kind !== e.completion.kind) {
    if (i.completion.kind === 27) return 1;
    if (e.completion.kind === 27) return -1;
  }
  return qx(i, e);
}), Cw.set(1, qx), dt.registerCommand("_executeCompletionItemProvider", async (i, ...e) => {
  const [t, n, s, o] = e;
  vt(Ie.isUri(t)), vt(W.isIPosition(n)), vt(typeof s == "string" || !s), vt(typeof o == "number" || !o);
  const { completionProvider: r } = i.get(fe), a = await i.get(Ps).createModelReference(t);
  try {
    const l = { incomplete: !1, suggestions: [] }, d = [], h = a.object.textEditorModel.validatePosition(n), c = await EP(r, a.object.textEditorModel, h, void 0, { triggerCharacter: s ?? void 0, triggerKind: s ? 1 : 0 });
    for (const u of c.items) d.length < (o ?? 0) && d.push(u.resolve(et.None)), l.incomplete = l.incomplete || u.container.incomplete, l.suggestions.push(u.completion);
    try {
      return await Promise.all(d), l;
    } finally {
      setTimeout(() => c.disposable.dispose(), 100);
    }
  } finally {
    a.dispose();
  }
});
class Gp {
  static isAllOff(e) {
    return e.other === "off" && e.comments === "off" && e.strings === "off";
  }
  static isAllOn(e) {
    return e.other === "on" && e.comments === "on" && e.strings === "on";
  }
  static valueFor(e, t) {
    switch (t) {
      case 1:
        return e.comments;
      case 2:
        return e.strings;
      default:
        return e.other;
    }
  }
}
function _9(i, e = Tn) {
  return function(t, n = Tn) {
    return !!n && nW(t.charCodeAt(0)) && t.charCodeAt(1) === 58;
  }(i, e) ? i.charAt(0).toUpperCase() + i.slice(1) : i;
}
var zle = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Ule = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class v9 {
  constructor(e) {
    this._delegates = e;
  }
  resolve(e) {
    for (const t of this._delegates) {
      const n = t.resolve(e);
      if (n !== void 0) return n;
    }
  }
}
class b9 {
  constructor(e, t, n, s) {
    this._model = e, this._selection = t, this._selectionIdx = n, this._overtypingCapturer = s;
  }
  resolve(e) {
    const { name: t } = e;
    if (t === "SELECTION" || t === "TM_SELECTED_TEXT") {
      let n = this._model.getValueInRange(this._selection) || void 0, s = this._selection.startLineNumber !== this._selection.endLineNumber;
      if (!n && this._overtypingCapturer) {
        const o = this._overtypingCapturer.getLastOvertypedInfo(this._selectionIdx);
        o && (n = o.value, s = o.multiline);
      }
      if (n && s && e.snippet) {
        const o = Wt(this._model.getLineContent(this._selection.startLineNumber), 0, this._selection.startColumn - 1);
        let r = o;
        e.snippet.walk((l) => l !== e && (l instanceof hs && (r = Wt(Sl(l.value).pop())), !0));
        const a = fc(r, o);
        n = n.replace(/(\r\n|\r|\n)(.*)/g, (l, d, h) => `${d}${r.substr(a)}${h}`);
      }
      return n;
    }
    if (t === "TM_CURRENT_LINE") return this._model.getLineContent(this._selection.positionLineNumber);
    if (t === "TM_CURRENT_WORD") {
      const n = this._model.getWordAtPosition({ lineNumber: this._selection.positionLineNumber, column: this._selection.positionColumn });
      return n && n.word || void 0;
    }
    return t === "TM_LINE_INDEX" ? String(this._selection.positionLineNumber - 1) : t === "TM_LINE_NUMBER" ? String(this._selection.positionLineNumber) : t === "CURSOR_INDEX" ? String(this._selectionIdx) : t === "CURSOR_NUMBER" ? String(this._selectionIdx + 1) : void 0;
  }
}
class C9 {
  constructor(e, t) {
    this._labelService = e, this._model = t;
  }
  resolve(e) {
    const { name: t } = e;
    if (t === "TM_FILENAME") return Nh(this._model.uri.fsPath);
    if (t === "TM_FILENAME_BASE") {
      const n = Nh(this._model.uri.fsPath), s = n.lastIndexOf(".");
      return s <= 0 ? n : n.slice(0, s);
    }
    return t === "TM_DIRECTORY" ? K7(this._model.uri.fsPath) === "." ? "" : this._labelService.getUriLabel(pL(this._model.uri)) : t === "TM_FILEPATH" ? this._labelService.getUriLabel(this._model.uri) : t === "RELATIVE_FILEPATH" ? this._labelService.getUriLabel(this._model.uri, { relative: !0, noPrefix: !0 }) : void 0;
  }
}
class w9 {
  constructor(e, t, n, s) {
    this._readClipboardText = e, this._selectionIdx = t, this._selectionCount = n, this._spread = s;
  }
  resolve(e) {
    if (e.name !== "CLIPBOARD") return;
    const t = this._readClipboardText();
    if (t) {
      if (this._spread) {
        const n = t.split(/\r\n|\n|\r/).filter((s) => !X7(s));
        if (n.length === this._selectionCount) return n[this._selectionIdx];
      }
      return t;
    }
  }
}
let DS = class {
  constructor(i, e, t) {
    this._model = i, this._selection = e, this._languageConfigurationService = t;
  }
  resolve(i) {
    const { name: e } = i, t = this._model.getLanguageIdAtPosition(this._selection.selectionStartLineNumber, this._selection.selectionStartColumn), n = this._languageConfigurationService.getLanguageConfiguration(t).comments;
    if (n) return e === "LINE_COMMENT" ? n.lineCommentToken || void 0 : e === "BLOCK_COMMENT_START" ? n.blockCommentStartToken || void 0 : e === "BLOCK_COMMENT_END" && n.blockCommentEndToken || void 0;
  }
};
DS = zle([Ule(2, zt)], DS);
class na {
  constructor() {
    this._date = /* @__PURE__ */ new Date();
  }
  resolve(e) {
    const { name: t } = e;
    if (t === "CURRENT_YEAR") return String(this._date.getFullYear());
    if (t === "CURRENT_YEAR_SHORT") return String(this._date.getFullYear()).slice(-2);
    if (t === "CURRENT_MONTH") return String(this._date.getMonth().valueOf() + 1).padStart(2, "0");
    if (t === "CURRENT_DATE") return String(this._date.getDate().valueOf()).padStart(2, "0");
    if (t === "CURRENT_HOUR") return String(this._date.getHours().valueOf()).padStart(2, "0");
    if (t === "CURRENT_MINUTE") return String(this._date.getMinutes().valueOf()).padStart(2, "0");
    if (t === "CURRENT_SECOND") return String(this._date.getSeconds().valueOf()).padStart(2, "0");
    if (t === "CURRENT_DAY_NAME") return na.dayNames[this._date.getDay()];
    if (t === "CURRENT_DAY_NAME_SHORT") return na.dayNamesShort[this._date.getDay()];
    if (t === "CURRENT_MONTH_NAME") return na.monthNames[this._date.getMonth()];
    if (t === "CURRENT_MONTH_NAME_SHORT") return na.monthNamesShort[this._date.getMonth()];
    if (t === "CURRENT_SECONDS_UNIX") return String(Math.floor(this._date.getTime() / 1e3));
    if (t === "CURRENT_TIMEZONE_OFFSET") {
      const n = this._date.getTimezoneOffset(), s = n > 0 ? "-" : "+", o = Math.trunc(Math.abs(n / 60)), r = o < 10 ? "0" + o : o, a = Math.abs(n) - 60 * o;
      return s + r + ":" + (a < 10 ? "0" + a : a);
    }
  }
}
na.dayNames = [m(0, "Sunday"), m(0, "Monday"), m(0, "Tuesday"), m(0, "Wednesday"), m(0, "Thursday"), m(0, "Friday"), m(0, "Saturday")], na.dayNamesShort = [m(0, "Sun"), m(0, "Mon"), m(0, "Tue"), m(0, "Wed"), m(0, "Thu"), m(0, "Fri"), m(0, "Sat")], na.monthNames = [m(0, "January"), m(0, "February"), m(0, "March"), m(0, "April"), m(0, "May"), m(0, "June"), m(0, "July"), m(0, "August"), m(0, "September"), m(0, "October"), m(0, "November"), m(0, "December")], na.monthNamesShort = [m(0, "Jan"), m(0, "Feb"), m(0, "Mar"), m(0, "Apr"), m(0, "May"), m(0, "Jun"), m(0, "Jul"), m(0, "Aug"), m(0, "Sep"), m(0, "Oct"), m(0, "Nov"), m(0, "Dec")];
class y9 {
  constructor(e) {
    this._workspaceService = e;
  }
  resolve(e) {
    if (!this._workspaceService) return;
    const t = function(n, s) {
      if (typeof n == "string" || n === void 0) return typeof n == "string" ? { id: Nh(n) } : Dee;
      const o = n;
      return o.configuration ? { id: o.id, configPath: o.configuration } : o.folders.length === 1 ? { id: o.id, uri: o.folders[0].uri } : { id: o.id };
    }(this._workspaceService.getWorkspace());
    return kee(t) ? void 0 : e.name === "WORKSPACE_NAME" ? this._resolveWorkspaceName(t) : e.name === "WORKSPACE_FOLDER" ? this._resoveWorkspacePath(t) : void 0;
  }
  _resolveWorkspaceName(e) {
    if (HI(e)) return Nh(e.uri.path);
    let t = Nh(e.configPath.path);
    return t.endsWith(Nee) && (t = t.substr(0, t.length - 14 - 1)), t;
  }
  _resoveWorkspacePath(e) {
    if (HI(e)) return _9(e.uri.fsPath);
    const t = Nh(e.configPath.path);
    let n = e.configPath.fsPath;
    return n.endsWith(t) && (n = n.substr(0, n.length - t.length - 1)), n ? _9(n) : "/";
  }
}
class S9 {
  resolve(e) {
    const { name: t } = e;
    return t === "RANDOM" ? Math.random().toString().slice(-6) : t === "RANDOM_HEX" ? Math.random().toString(16).slice(-6) : t === "UUID" ? YL() : void 0;
  }
}
var Fr, Kle = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, jle = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class Bo {
  constructor(e, t, n) {
    this._editor = e, this._snippet = t, this._snippetLineLeadingWhitespace = n, this._offset = -1, this._nestingLevel = 1, this._placeholderGroups = GP(t.placeholders, Wo.compareByIndex), this._placeholderGroupsIdx = -1;
  }
  initialize(e) {
    this._offset = e.newPosition;
  }
  dispose() {
    this._placeholderDecorations && this._editor.removeDecorations([...this._placeholderDecorations.values()]), this._placeholderGroups.length = 0;
  }
  _initDecorations() {
    if (this._offset === -1) throw new Error("Snippet not initialized!");
    if (this._placeholderDecorations) return;
    this._placeholderDecorations = /* @__PURE__ */ new Map();
    const e = this._editor.getModel();
    this._editor.changeDecorations((t) => {
      for (const n of this._snippet.placeholders) {
        const s = this._snippet.offset(n), o = this._snippet.fullLen(n), r = D.fromPositions(e.getPositionAt(this._offset + s), e.getPositionAt(this._offset + s + o)), a = n.isFinalTabstop ? Bo._decor.inactiveFinal : Bo._decor.inactive, l = t.addDecoration(r, a);
        this._placeholderDecorations.set(n, l);
      }
    });
  }
  move(e) {
    if (!this._editor.hasModel()) return [];
    if (this._initDecorations(), this._placeholderGroupsIdx >= 0) {
      const s = [];
      for (const o of this._placeholderGroups[this._placeholderGroupsIdx]) if (o.transform) {
        const r = this._placeholderDecorations.get(o), a = this._editor.getModel().getDecorationRange(r), l = this._editor.getModel().getValueInRange(a), d = o.transform.resolve(l).split(/\r\n|\r|\n/);
        for (let h = 1; h < d.length; h++) d[h] = this._editor.getModel().normalizeIndentation(this._snippetLineLeadingWhitespace + d[h]);
        s.push(ii.replace(a, d.join(this._editor.getModel().getEOL())));
      }
      s.length > 0 && this._editor.executeEdits("snippet.placeholderTransform", s);
    }
    let t = !1;
    e === !0 && this._placeholderGroupsIdx < this._placeholderGroups.length - 1 ? (this._placeholderGroupsIdx += 1, t = !0) : e === !1 && this._placeholderGroupsIdx > 0 && (this._placeholderGroupsIdx -= 1, t = !0);
    const n = this._editor.getModel().changeDecorations((s) => {
      const o = /* @__PURE__ */ new Set(), r = [];
      for (const a of this._placeholderGroups[this._placeholderGroupsIdx]) {
        const l = this._placeholderDecorations.get(a), d = this._editor.getModel().getDecorationRange(l);
        r.push(new _e(d.startLineNumber, d.startColumn, d.endLineNumber, d.endColumn)), t = t && this._hasPlaceholderBeenCollapsed(a), s.changeDecorationOptions(l, a.isFinalTabstop ? Bo._decor.activeFinal : Bo._decor.active), o.add(a);
        for (const h of this._snippet.enclosingPlaceholders(a)) {
          const c = this._placeholderDecorations.get(h);
          s.changeDecorationOptions(c, h.isFinalTabstop ? Bo._decor.activeFinal : Bo._decor.active), o.add(h);
        }
      }
      for (const [a, l] of this._placeholderDecorations) o.has(a) || s.changeDecorationOptions(l, a.isFinalTabstop ? Bo._decor.inactiveFinal : Bo._decor.inactive);
      return r;
    });
    return t ? this.move(e) : n ?? [];
  }
  _hasPlaceholderBeenCollapsed(e) {
    let t = e;
    for (; t; ) {
      if (t instanceof Wo) {
        const n = this._placeholderDecorations.get(t);
        if (this._editor.getModel().getDecorationRange(n).isEmpty() && t.toString().length > 0) return !0;
      }
      t = t.parent;
    }
    return !1;
  }
  get isAtFirstPlaceholder() {
    return this._placeholderGroupsIdx <= 0 || this._placeholderGroups.length === 0;
  }
  get isAtLastPlaceholder() {
    return this._placeholderGroupsIdx === this._placeholderGroups.length - 1;
  }
  get hasPlaceholder() {
    return this._snippet.placeholders.length > 0;
  }
  get isTrivialSnippet() {
    if (this._snippet.placeholders.length === 0) return !0;
    if (this._snippet.placeholders.length === 1) {
      const [e] = this._snippet.placeholders;
      if (e.isFinalTabstop && this._snippet.rightMostDescendant === e) return !0;
    }
    return !1;
  }
  computePossibleSelections() {
    const e = /* @__PURE__ */ new Map();
    for (const t of this._placeholderGroups) {
      let n;
      for (const s of t) {
        if (s.isFinalTabstop) break;
        n || (n = [], e.set(s.index, n));
        const o = this._placeholderDecorations.get(s), r = this._editor.getModel().getDecorationRange(o);
        if (!r) {
          e.delete(s.index);
          break;
        }
        n.push(r);
      }
    }
    return e;
  }
  get activeChoice() {
    if (!this._placeholderDecorations) return;
    const e = this._placeholderGroups[this._placeholderGroupsIdx][0];
    if (!(e != null && e.choice)) return;
    const t = this._placeholderDecorations.get(e);
    if (!t) return;
    const n = this._editor.getModel().getDecorationRange(t);
    return n ? { range: n, choice: e.choice } : void 0;
  }
  get hasChoice() {
    let e = !1;
    return this._snippet.walk((t) => (e = t instanceof Lf, !e)), e;
  }
  merge(e) {
    const t = this._editor.getModel();
    this._nestingLevel *= 10, this._editor.changeDecorations((n) => {
      for (const s of this._placeholderGroups[this._placeholderGroupsIdx]) {
        const o = e.shift();
        console.assert(o._offset !== -1), console.assert(!o._placeholderDecorations);
        const r = o._snippet.placeholderInfo.last.index;
        for (const l of o._snippet.placeholderInfo.all) l.isFinalTabstop ? l.index = s.index + (r + 1) / this._nestingLevel : l.index = s.index + l.index / this._nestingLevel;
        this._snippet.replace(s, o._snippet.children);
        const a = this._placeholderDecorations.get(s);
        n.removeDecoration(a), this._placeholderDecorations.delete(s);
        for (const l of o._snippet.placeholders) {
          const d = o._snippet.offset(l), h = o._snippet.fullLen(l), c = D.fromPositions(t.getPositionAt(o._offset + d), t.getPositionAt(o._offset + d + h)), u = n.addDecoration(c, Bo._decor.inactive);
          this._placeholderDecorations.set(l, u);
        }
      }
      this._placeholderGroups = GP(this._snippet.placeholders, Wo.compareByIndex);
    });
  }
}
Bo._decor = { active: Ve.register({ description: "snippet-placeholder-1", stickiness: 0, className: "snippet-placeholder" }), inactive: Ve.register({ description: "snippet-placeholder-2", stickiness: 1, className: "snippet-placeholder" }), activeFinal: Ve.register({ description: "snippet-placeholder-3", stickiness: 1, className: "finish-snippet-placeholder" }), inactiveFinal: Ve.register({ description: "snippet-placeholder-4", stickiness: 1, className: "finish-snippet-placeholder" }) };
const L9 = { overwriteBefore: 0, overwriteAfter: 0, adjustWhitespace: !0, clipboardText: void 0, overtypingCapturer: void 0 };
let xS = Fr = class {
  static adjustWhitespace(i, e, t, n, s) {
    const o = Wt(i.getLineContent(e.lineNumber), 0, e.column - 1);
    let r;
    return n.walk((a) => {
      if (!(a instanceof hs) || a.parent instanceof Lf || s && !s.has(a)) return !0;
      const l = a.value.split(/\r\n|\r|\n/);
      if (t) {
        const h = n.offset(a);
        if (h === 0) l[0] = i.normalizeIndentation(l[0]);
        else {
          r = r ?? n.toString();
          const c = r.charCodeAt(h - 1);
          c !== 10 && c !== 13 || (l[0] = i.normalizeIndentation(o + l[0]));
        }
        for (let c = 1; c < l.length; c++) l[c] = i.normalizeIndentation(o + l[c]);
      }
      const d = l.join(i.getEOL());
      return d !== a.value && (a.parent.replace(a, [new hs(d)]), r = void 0), !0;
    }), o;
  }
  static adjustSelection(i, e, t, n) {
    if (t !== 0 || n !== 0) {
      const { positionLineNumber: s, positionColumn: o } = e, r = o - t, a = o + n, l = i.validateRange({ startLineNumber: s, startColumn: r, endLineNumber: s, endColumn: a });
      e = _e.createWithDirection(l.startLineNumber, l.startColumn, l.endLineNumber, l.endColumn, e.getDirection());
    }
    return e;
  }
  static createEditsAndSnippetsFromSelections(i, e, t, n, s, o, r, a, l) {
    const d = [], h = [];
    if (!i.hasModel()) return { edits: d, snippets: h };
    const c = i.getModel(), u = i.invokeWithinContext((C) => C.get(mg)), g = i.invokeWithinContext((C) => new C9(C.get(Zm), c)), p = () => r, f = c.getValueInRange(Fr.adjustSelection(c, i.getSelection(), t, 0)), _ = c.getValueInRange(Fr.adjustSelection(c, i.getSelection(), 0, n)), v = c.getLineFirstNonWhitespaceColumn(i.getSelection().positionLineNumber), b = i.getSelections().map((C, w) => ({ selection: C, idx: w })).sort((C, w) => D.compareRangesUsingStarts(C.selection, w.selection));
    for (const { selection: C, idx: w } of b) {
      let y = Fr.adjustSelection(c, C, t, 0), L = Fr.adjustSelection(c, C, 0, n);
      f !== c.getValueInRange(y) && (y = C), _ !== c.getValueInRange(L) && (L = C);
      const k = C.setStartPosition(y.startLineNumber, y.startColumn).setEndPosition(L.endLineNumber, L.endColumn), N = new wg().parse(e, !0, s), A = k.getStartPosition(), B = Fr.adjustWhitespace(c, A, o || w > 0 && v !== c.getLineFirstNonWhitespaceColumn(C.positionLineNumber), N);
      N.resolveVariables(new v9([g, new w9(p, w, b.length, i.getOption(79) === "spread"), new b9(c, C, w, a), new DS(c, C, l), new na(), new y9(u), new S9()])), d[w] = ii.replace(k, N.toString()), d[w].identifier = { major: w, minor: 0 }, d[w]._isTracked = !0, h[w] = new Bo(i, N, B);
    }
    return { edits: d, snippets: h };
  }
  static createEditsAndSnippetsFromEdits(i, e, t, n, s, o, r) {
    if (!i.hasModel() || e.length === 0) return { edits: [], snippets: [] };
    const a = [], l = i.getModel(), d = new wg(), h = new z1(), c = new v9([i.invokeWithinContext((g) => new C9(g.get(Zm), l)), new w9(() => s, 0, i.getSelections().length, i.getOption(79) === "spread"), new b9(l, i.getSelection(), 0, o), new DS(l, i.getSelection(), r), new na(), new y9(i.invokeWithinContext((g) => g.get(mg))), new S9()]);
    e = e.sort((g, p) => D.compareRangesUsingStarts(g.range, p.range));
    let u = 0;
    for (let g = 0; g < e.length; g++) {
      const { range: p, template: f } = e[g];
      if (g > 0) {
        const w = e[g - 1].range, y = D.fromPositions(w.getEndPosition(), p.getStartPosition()), L = new hs(l.getValueInRange(y));
        h.appendChild(L), u += L.value.length;
      }
      const _ = d.parseFragment(f, h);
      Fr.adjustWhitespace(l, p.getStartPosition(), !0, h, new Set(_)), h.resolveVariables(c);
      const v = h.toString(), b = v.slice(u);
      u = v.length;
      const C = ii.replace(p, b);
      C.identifier = { major: g, minor: 0 }, C._isTracked = !0, a.push(C);
    }
    return d.ensureFinalTabstop(h, t, !0), { edits: a, snippets: [new Bo(i, h, "")] };
  }
  constructor(i, e, t = L9, n) {
    this._editor = i, this._template = e, this._options = t, this._languageConfigurationService = n, this._templateMerges = [], this._snippets = [];
  }
  dispose() {
    Ht(this._snippets);
  }
  _logInfo() {
    return `template="${this._template}", merged_templates="${this._templateMerges.join(" -> ")}"`;
  }
  insert() {
    if (!this._editor.hasModel()) return;
    const { edits: i, snippets: e } = typeof this._template == "string" ? Fr.createEditsAndSnippetsFromSelections(this._editor, this._template, this._options.overwriteBefore, this._options.overwriteAfter, !1, this._options.adjustWhitespace, this._options.clipboardText, this._options.overtypingCapturer, this._languageConfigurationService) : Fr.createEditsAndSnippetsFromEdits(this._editor, this._template, !1, this._options.adjustWhitespace, this._options.clipboardText, this._options.overtypingCapturer, this._languageConfigurationService);
    this._snippets = e, this._editor.executeEdits("snippet", i, (t) => {
      const n = t.filter((s) => !!s.identifier);
      for (let s = 0; s < e.length; s++) e[s].initialize(n[s].textChange);
      return this._snippets[0].hasPlaceholder ? this._move(!0) : n.map((s) => _e.fromPositions(s.range.getEndPosition()));
    }), this._editor.revealRange(this._editor.getSelections()[0]);
  }
  merge(i, e = L9) {
    if (!this._editor.hasModel()) return;
    this._templateMerges.push([this._snippets[0]._nestingLevel, this._snippets[0]._placeholderGroupsIdx, i]);
    const { edits: t, snippets: n } = Fr.createEditsAndSnippetsFromSelections(this._editor, i, e.overwriteBefore, e.overwriteAfter, !0, e.adjustWhitespace, e.clipboardText, e.overtypingCapturer, this._languageConfigurationService);
    this._editor.executeEdits("snippet", t, (s) => {
      const o = s.filter((a) => !!a.identifier);
      for (let a = 0; a < n.length; a++) n[a].initialize(o[a].textChange);
      const r = n[0].isTrivialSnippet;
      if (!r) {
        for (const a of this._snippets) a.merge(n);
        console.assert(n.length === 0);
      }
      return this._snippets[0].hasPlaceholder && !r ? this._move(void 0) : o.map((a) => _e.fromPositions(a.range.getEndPosition()));
    });
  }
  next() {
    const i = this._move(!0);
    this._editor.setSelections(i), this._editor.revealPositionInCenterIfOutsideViewport(i[0].getPosition());
  }
  prev() {
    const i = this._move(!1);
    this._editor.setSelections(i), this._editor.revealPositionInCenterIfOutsideViewport(i[0].getPosition());
  }
  _move(i) {
    const e = [];
    for (const t of this._snippets) {
      const n = t.move(i);
      e.push(...n);
    }
    return e;
  }
  get isAtFirstPlaceholder() {
    return this._snippets[0].isAtFirstPlaceholder;
  }
  get isAtLastPlaceholder() {
    return this._snippets[0].isAtLastPlaceholder;
  }
  get hasPlaceholder() {
    return this._snippets[0].hasPlaceholder;
  }
  get hasChoice() {
    return this._snippets[0].hasChoice;
  }
  get activeChoice() {
    return this._snippets[0].activeChoice;
  }
  isSelectionWithinPlaceholders() {
    if (!this.hasPlaceholder) return !1;
    const i = this._editor.getSelections();
    if (i.length < this._snippets.length) return !1;
    const e = /* @__PURE__ */ new Map();
    for (const t of this._snippets) {
      const n = t.computePossibleSelections();
      if (e.size === 0) for (const [s, o] of n) {
        o.sort(D.compareRangesUsingStarts);
        for (const r of i) if (o[0].containsRange(r)) {
          e.set(s, []);
          break;
        }
      }
      if (e.size === 0) return !1;
      e.forEach((s, o) => {
        s.push(...n.get(o));
      });
    }
    i.sort(D.compareRangesUsingStarts);
    for (const [t, n] of e) if (n.length === i.length) {
      n.sort(D.compareRangesUsingStarts);
      for (let s = 0; s < n.length; s++) n[s].containsRange(i[s]) || e.delete(t);
    } else e.delete(t);
    return e.size > 0;
  }
};
xS = Fr = Kle([jle(3, zt)], xS);
var bp, qle = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, uC = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const k9 = { overwriteBefore: 0, overwriteAfter: 0, undoStopBefore: !0, undoStopAfter: !0, adjustWhitespace: !0, clipboardText: void 0, overtypingCapturer: void 0 };
let _n = bp = class {
  static get(i) {
    return i.getContribution(bp.ID);
  }
  constructor(i, e, t, n, s) {
    this._editor = i, this._logService = e, this._languageFeaturesService = t, this._languageConfigurationService = s, this._snippetListener = new G(), this._modelVersionId = -1, this._inSnippet = bp.InSnippetMode.bindTo(n), this._hasNextTabstop = bp.HasNextTabstop.bindTo(n), this._hasPrevTabstop = bp.HasPrevTabstop.bindTo(n);
  }
  dispose() {
    var i;
    this._inSnippet.reset(), this._hasPrevTabstop.reset(), this._hasNextTabstop.reset(), (i = this._session) === null || i === void 0 || i.dispose(), this._snippetListener.dispose();
  }
  insert(i, e) {
    try {
      this._doInsert(i, e === void 0 ? k9 : { ...k9, ...e });
    } catch (t) {
      this.cancel(), this._logService.error(t), this._logService.error("snippet_error"), this._logService.error("insert_template=", i), this._logService.error("existing_template=", this._session ? this._session._logInfo() : "<no_session>");
    }
  }
  _doInsert(i, e) {
    var t;
    if (this._editor.hasModel()) {
      if (this._snippetListener.clear(), e.undoStopBefore && this._editor.getModel().pushStackElement(), this._session && typeof i != "string" && this.cancel(), this._session ? (vt(typeof i == "string"), this._session.merge(i, e)) : (this._modelVersionId = this._editor.getModel().getAlternativeVersionId(), this._session = new xS(this._editor, i, e, this._languageConfigurationService), this._session.insert()), e.undoStopAfter && this._editor.getModel().pushStackElement(), (t = this._session) === null || t === void 0 ? void 0 : t.hasChoice) {
        const n = { _debugDisplayName: "snippetChoiceCompletions", provideCompletionItems: (d, h) => {
          if (!this._session || d !== this._editor.getModel() || !W.equals(this._editor.getPosition(), h)) return;
          const { activeChoice: c } = this._session;
          if (!c || c.choice.options.length === 0) return;
          const u = d.getValueInRange(c.range), g = !!c.choice.options.find((f) => f.value === u), p = [];
          for (let f = 0; f < c.choice.options.length; f++) {
            const _ = c.choice.options[f];
            p.push({ kind: 13, label: _.value, insertText: _.value, sortText: "a".repeat(f + 1), range: c.range, filterText: g ? `${u}_${_.value}` : void 0, command: { id: "jumpToNextSnippetPlaceholder", title: m(0, "Go to next placeholder...") } });
          }
          return { suggestions: p };
        } }, s = this._editor.getModel();
        let o, r = !1;
        const a = () => {
          o == null || o.dispose(), r = !1;
        }, l = () => {
          r || (o = this._languageFeaturesService.completionProvider.register({ language: s.getLanguageId(), pattern: s.uri.fsPath, scheme: s.uri.scheme, exclusive: !0 }, n), this._snippetListener.add(o), r = !0);
        };
        this._choiceCompletions = { provider: n, enable: l, disable: a };
      }
      this._updateState(), this._snippetListener.add(this._editor.onDidChangeModelContent((n) => n.isFlush && this.cancel())), this._snippetListener.add(this._editor.onDidChangeModel(() => this.cancel())), this._snippetListener.add(this._editor.onDidChangeCursorSelection(() => this._updateState()));
    }
  }
  _updateState() {
    if (this._session && this._editor.hasModel()) {
      if (this._modelVersionId === this._editor.getModel().getAlternativeVersionId()) return this.cancel();
      if (!this._session.hasPlaceholder) return this.cancel();
      if (this._session.isAtLastPlaceholder || !this._session.isSelectionWithinPlaceholders()) return this._editor.getModel().pushStackElement(), this.cancel();
      this._inSnippet.set(!0), this._hasPrevTabstop.set(!this._session.isAtFirstPlaceholder), this._hasNextTabstop.set(!this._session.isAtLastPlaceholder), this._handleChoice();
    }
  }
  _handleChoice() {
    var i;
    if (!this._session || !this._editor.hasModel()) return void (this._currentChoice = void 0);
    const { activeChoice: e } = this._session;
    if (!e || !this._choiceCompletions) return (i = this._choiceCompletions) === null || i === void 0 || i.disable(), void (this._currentChoice = void 0);
    this._currentChoice !== e.choice && (this._currentChoice = e.choice, this._choiceCompletions.enable(), queueMicrotask(() => {
      (function(t, n) {
        var s;
        (s = t.getContribution("editor.contrib.suggestController")) === null || s === void 0 || s.triggerSuggest((/* @__PURE__ */ new Set()).add(n), void 0, !0);
      })(this._editor, this._choiceCompletions.provider);
    }));
  }
  finish() {
    for (; this._inSnippet.get(); ) this.next();
  }
  cancel(i = !1) {
    var e;
    this._inSnippet.reset(), this._hasPrevTabstop.reset(), this._hasNextTabstop.reset(), this._snippetListener.clear(), this._currentChoice = void 0, (e = this._session) === null || e === void 0 || e.dispose(), this._session = void 0, this._modelVersionId = -1, i && this._editor.setSelections([this._editor.getSelection()]);
  }
  prev() {
    var i;
    (i = this._session) === null || i === void 0 || i.prev(), this._updateState();
  }
  next() {
    var i;
    (i = this._session) === null || i === void 0 || i.next(), this._updateState();
  }
  isInSnippet() {
    return !!this._inSnippet.get();
  }
};
_n.ID = "snippetController2", _n.InSnippetMode = new ae("inSnippetMode", !1, m(0, "Whether the editor in current in snippet mode")), _n.HasNextTabstop = new ae("hasNextTabstop", !1, m(0, "Whether there is a next tab stop when in snippet mode")), _n.HasPrevTabstop = new ae("hasPrevTabstop", !1, m(0, "Whether there is a previous tab stop when in snippet mode")), _n = bp = qle([uC(1, ts), uC(2, fe), uC(3, Te), uC(4, zt)], _n), ft(_n.ID, _n, 4);
const gC = Zi.bindToContribution(_n.get);
re(new gC({ id: "jumpToNextSnippetPlaceholder", precondition: q.and(_n.InSnippetMode, _n.HasNextTabstop), handler: (i) => i.next(), kbOpts: { weight: 130, kbExpr: E.editorTextFocus, primary: 2 } })), re(new gC({ id: "jumpToPrevSnippetPlaceholder", precondition: q.and(_n.InSnippetMode, _n.HasPrevTabstop), handler: (i) => i.prev(), kbOpts: { weight: 130, kbExpr: E.editorTextFocus, primary: 1026 } })), re(new gC({ id: "leaveSnippet", precondition: _n.InSnippetMode, handler: (i) => i.cancel(!0), kbOpts: { weight: 130, kbExpr: E.editorTextFocus, primary: 9, secondary: [1033] } })), re(new gC({ id: "acceptSnippet", precondition: _n.InSnippetMode, handler: (i) => i.finish() }));
var lo, $le = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, $x = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
(function(i) {
  i[i.Undo = 0] = "Undo", i[i.Redo = 1] = "Redo", i[i.AcceptWord = 2] = "AcceptWord", i[i.Other = 3] = "Other";
})(lo || (lo = {}));
let eT = class extends V {
  get isAcceptingPartially() {
    return this._isAcceptingPartially;
  }
  constructor(i, e, t, n, s, o, r, a, l, d, h, c) {
    let u;
    super(), this.textModel = i, this.selectedSuggestItem = e, this.textModelVersionId = t, this._positions = n, this._debounceValue = s, this._suggestPreviewEnabled = o, this._suggestPreviewMode = r, this._inlineSuggestMode = a, this._enabled = l, this._instantiationService = d, this._commandService = h, this._languageConfigurationService = c, this._source = this._register(this._instantiationService.createInstance(JM, this.textModel, this.textModelVersionId, this._debounceValue)), this._isActive = lt(this, !1), this._forceUpdateSignal = NL("forceUpdate"), this._selectedInlineCompletionId = lt(this, void 0), this._primaryPosition = Fe(this, (g) => {
      var p;
      return (p = this._positions.read(g)[0]) !== null && p !== void 0 ? p : new W(1, 1);
    }), this._isAcceptingPartially = !1, this._preserveCurrentCompletionReasons = /* @__PURE__ */ new Set([lo.Redo, lo.Undo, lo.AcceptWord]), this._fetchInlineCompletions = function(g, p) {
      var f;
      return new Jm(new ba(g.owner, g.debugName, void 0), p, g.createEmptyChangeSummary, g.handleChange, void 0, (f = g.equalityComparer) !== null && f !== void 0 ? f : Qm);
    }({ owner: this, createEmptyChangeSummary: () => ({ preserveCurrentCompletion: !1, inlineCompletionTriggerKind: Ld.Automatic }), handleChange: (g, p) => (g.didChange(this.textModelVersionId) && this._preserveCurrentCompletionReasons.has(g.change) ? p.preserveCurrentCompletion = !0 : g.didChange(this._forceUpdateSignal) && (p.inlineCompletionTriggerKind = g.change), !0) }, (g, p) => {
      if (this._forceUpdateSignal.read(g), !(this._enabled.read(g) && this.selectedSuggestItem.read(g) || this._isActive.read(g))) return void this._source.cancelUpdate();
      this.textModelVersionId.read(g);
      const f = this.selectedInlineCompletion.get(), _ = p.preserveCurrentCompletion || f != null && f.forwardStable ? f : void 0, v = this._source.suggestWidgetInlineCompletions.get(), b = this.selectedSuggestItem.read(g);
      if (v && !b) {
        const y = this._source.inlineCompletions.get();
        Tt((L) => {
          (!y || v.request.versionId > y.request.versionId) && this._source.inlineCompletions.set(v.clone(), L), this._source.clearSuggestWidgetInlineCompletions(L);
        });
      }
      const C = this._primaryPosition.read(g), w = { triggerKind: p.inlineCompletionTriggerKind, selectedSuggestionInfo: b == null ? void 0 : b.toSelectedSuggestionInfo() };
      return this._source.fetch(C, w, _);
    }), this._filteredInlineCompletionItems = Fe(this, (g) => {
      const p = this._source.inlineCompletions.read(g);
      if (!p) return [];
      const f = this._primaryPosition.read(g);
      return p.inlineCompletions.filter((v) => v.isVisible(this.textModel, f, g));
    }), this.selectedInlineCompletionIndex = Fe(this, (g) => {
      const p = this._selectedInlineCompletionId.read(g), f = this._filteredInlineCompletionItems.read(g), _ = this._selectedInlineCompletionId === void 0 ? -1 : f.findIndex((v) => v.semanticId === p);
      return _ === -1 ? (this._selectedInlineCompletionId.set(void 0, void 0), 0) : _;
    }), this.selectedInlineCompletion = Fe(this, (g) => this._filteredInlineCompletionItems.read(g)[this.selectedInlineCompletionIndex.read(g)]), this.lastTriggerKind = this._source.inlineCompletions.map(this, (g) => g == null ? void 0 : g.request.context.triggerKind), this.inlineCompletionsCount = Fe(this, (g) => this.lastTriggerKind.read(g) === Ld.Explicit ? this._filteredInlineCompletionItems.read(g).length : void 0), this.state = _m({ owner: this, equalityComparer: (g, p) => g && p ? r9(g.ghostTexts, p.ghostTexts) && g.inlineCompletion === p.inlineCompletion && g.suggestItem === p.suggestItem : g === p }, (g) => {
      var p, f;
      const _ = this.textModel, v = this.selectedSuggestItem.read(g);
      if (v) {
        const b = tg(v.toSingleTextEdit(), _), C = this._computeAugmentation(b, g);
        if (!this._suggestPreviewEnabled.read(g) && !C) return;
        const w = (p = C == null ? void 0 : C.edit) !== null && p !== void 0 ? p : b, y = C ? C.edit.text.length - b.text.length : 0, L = this._suggestPreviewMode.read(g), k = this._positions.read(g), N = [w, ...Gx(this.textModel, k, w)], A = N.map((B, T) => c9(B, _, L, k[T], y)).filter(cl);
        return { edits: N, primaryGhostText: (f = A[0]) !== null && f !== void 0 ? f : new s1(w.range.endLineNumber, []), ghostTexts: A, inlineCompletion: C == null ? void 0 : C.completion, suggestItem: v };
      }
      {
        if (!this._isActive.read(g)) return;
        const b = this.selectedInlineCompletion.read(g);
        if (!b) return;
        const C = b.toSingleTextEdit(g), w = this._inlineSuggestMode.read(g), y = this._positions.read(g), L = [C, ...Gx(this.textModel, y, C)], k = L.map((N, A) => c9(N, _, w, y[A], 0)).filter(cl);
        return k[0] ? { edits: L, primaryGhostText: k[0], ghostTexts: k, inlineCompletion: b, suggestItem: void 0 } : void 0;
      }
    }), this.ghostTexts = _m({ owner: this, equalityComparer: r9 }, (g) => {
      const p = this.state.read(g);
      if (p) return p.ghostTexts;
    }), this.primaryGhostText = _m({ owner: this, equalityComparer: Zz }, (g) => {
      const p = this.state.read(g);
      if (p) return p == null ? void 0 : p.primaryGhostText;
    }), this._register(F1(this._fetchInlineCompletions)), this._register(Ge((g) => {
      var p, f;
      const _ = this.state.read(g), v = _ == null ? void 0 : _.inlineCompletion;
      if ((v == null ? void 0 : v.semanticId) !== (u == null ? void 0 : u.semanticId) && (u = v, v)) {
        const b = v.inlineCompletion, C = b.source;
        (f = (p = C.provider).handleItemDidShow) === null || f === void 0 || f.call(p, C.inlineCompletions, b.sourceInlineCompletion, b.insertText);
      }
    }));
  }
  async trigger(i) {
    this._isActive.set(!0, i), await this._fetchInlineCompletions.get();
  }
  async triggerExplicitly(i) {
    Rv(i, (e) => {
      this._isActive.set(!0, e), this._forceUpdateSignal.trigger(e, Ld.Explicit);
    }), await this._fetchInlineCompletions.get();
  }
  stop(i) {
    Rv(i, (e) => {
      this._isActive.set(!1, e), this._source.clear(e);
    });
  }
  _computeAugmentation(i, e) {
    const t = this.textModel, n = this._source.suggestWidgetInlineCompletions.read(e);
    return function(s, o) {
      for (const r of s) {
        const a = o(r);
        if (a !== void 0) return a;
      }
    }(n ? n.inlineCompletions : [this.selectedInlineCompletion.read(e)].filter(cl), (s) => {
      let o = s.toSingleTextEdit(e);
      return o = tg(o, t, D.fromPositions(o.range.getStartPosition(), i.range.getEndPosition())), Jz(o, i) ? { completion: s, edit: o } : void 0;
    });
  }
  async _deltaSelectedInlineCompletionIndex(i) {
    await this.triggerExplicitly();
    const e = this._filteredInlineCompletionItems.get() || [];
    if (e.length > 0) {
      const t = (this.selectedInlineCompletionIndex.get() + i + e.length) % e.length;
      this._selectedInlineCompletionId.set(e[t].semanticId, void 0);
    } else this._selectedInlineCompletionId.set(void 0, void 0);
  }
  async next() {
    await this._deltaSelectedInlineCompletionIndex(1);
  }
  async previous() {
    await this._deltaSelectedInlineCompletionIndex(-1);
  }
  async accept(i) {
    var e;
    if (i.getModel() !== this.textModel) throw new Kt();
    const t = this.state.get();
    if (!t || t.primaryGhostText.isEmpty() || !t.inlineCompletion) return;
    const n = t.inlineCompletion.toInlineCompletion(void 0);
    if (i.pushUndoStop(), n.snippetInfo) i.executeEdits("inlineSuggestion.accept", [ii.replaceMove(n.range, ""), ...n.additionalTextEdits]), i.setPosition(n.snippetInfo.range.getStartPosition(), "inlineCompletionAccept"), (e = _n.get(i)) === null || e === void 0 || e.insert(n.snippetInfo.snippet, { undoStopBefore: !1 });
    else {
      const s = t.edits, o = D9(s).map((r) => _e.fromPositions(r));
      i.executeEdits("inlineSuggestion.accept", [...s.map((r) => ii.replaceMove(r.range, r.text)), ...n.additionalTextEdits]), i.setSelections(o, "inlineCompletionAccept");
    }
    n.command && n.source.addRef(), Tt((s) => {
      this._source.clear(s), this._isActive.set(!1, s);
    }), n.command && (await this._commandService.executeCommand(n.command.id, ...n.command.arguments || []).then(void 0, Ni), n.source.removeRef());
  }
  async acceptNextWord(i) {
    await this._acceptNext(i, (e, t) => {
      const n = this.textModel.getLanguageIdAtPosition(e.lineNumber, e.column), s = this._languageConfigurationService.getLanguageConfiguration(n), o = new RegExp(s.wordDefinition.source, s.wordDefinition.flags.replace("g", "")), r = t.match(o);
      let a = 0;
      a = r && r.index !== void 0 ? r.index === 0 ? r[0].length : r.index : t.length;
      const l = /\s+/g.exec(t);
      return l && l.index !== void 0 && l.index + l[0].length < a && (a = l.index + l[0].length), a;
    }, 0);
  }
  async acceptNextLine(i) {
    await this._acceptNext(i, (e, t) => {
      const n = t.match(/\n/);
      return n && n.index !== void 0 ? n.index + 1 : t.length;
    }, 1);
  }
  async _acceptNext(i, e, t) {
    if (i.getModel() !== this.textModel) throw new Kt();
    const n = this.state.get();
    if (!n || n.primaryGhostText.isEmpty() || !n.inlineCompletion) return;
    const s = n.primaryGhostText, o = n.inlineCompletion.toInlineCompletion(void 0);
    if (o.snippetInfo || o.filterText !== o.insertText) return void await this.accept(i);
    const r = s.parts[0], a = new W(s.lineNumber, r.column), l = r.text, d = e(a, l);
    if (d === l.length && s.parts.length === 1) return void this.accept(i);
    const h = l.substring(0, d), c = this._positions.get(), u = c[0];
    o.source.addRef();
    try {
      this._isAcceptingPartially = !0;
      try {
        i.pushUndoStop();
        const g = D.fromPositions(u, a), p = i.getModel().getValueInRange(g) + h, f = new Bd(g, p), _ = [f, ...Gx(this.textModel, c, f)], v = D9(_).map((b) => _e.fromPositions(b));
        i.executeEdits("inlineSuggestion.accept", _.map((b) => ii.replaceMove(b.range, b.text))), i.setSelections(v, "inlineCompletionPartialAccept");
      } finally {
        this._isAcceptingPartially = !1;
      }
      if (o.source.provider.handlePartialAccept) {
        const g = D.fromPositions(o.range.getStartPosition(), kr.ofText(h).addToPosition(a)), p = i.getModel().getValueInRange(g, 1);
        o.source.provider.handlePartialAccept(o.source.inlineCompletions, o.sourceInlineCompletion, p.length, { kind: t });
      }
    } finally {
      o.source.removeRef();
    }
  }
  handleSuggestAccepted(i) {
    var e, t;
    const n = tg(i.toSingleTextEdit(), this.textModel), s = this._computeAugmentation(n, void 0);
    if (!s) return;
    const o = s.completion.inlineCompletion;
    (t = (e = o.source.provider).handlePartialAccept) === null || t === void 0 || t.call(e, o.source.inlineCompletions, o.sourceInlineCompletion, n.text.length, { kind: 2 });
  }
};
function Gx(i, e, t) {
  if (e.length === 1) return [];
  const n = e[0], s = e.slice(1), o = t.range.getStartPosition(), r = t.range.getEndPosition(), a = i.getValueInRange(D.fromPositions(n, r)), l = a9(n, o);
  if (l.lineNumber < 1) return We(new Kt(`positionWithinTextEdit line number should be bigger than 0.
			Invalid subtraction between ${n.toString()} and ${o.toString()}`)), [];
  const d = function(h, c) {
    let u = "";
    const g = function(p) {
      var f;
      const _ = [], v = p.split(/(\r\n|\r|\n)/);
      for (let b = 0; b < Math.ceil(v.length / 2); b++) _.push(v[2 * b] + ((f = v[2 * b + 1]) !== null && f !== void 0 ? f : ""));
      return _;
    }(h);
    for (let p = c.lineNumber - 1; p < g.length; p++) u += g[p].substring(p === c.lineNumber - 1 ? c.column - 1 : 0);
    return u;
  }(t.text, l);
  return s.map((h) => {
    const c = (u = a9(h, o), g = r, new W(u.lineNumber + g.lineNumber - 1, g.lineNumber === 1 ? u.column + g.column - 1 : g.column));
    var u, g;
    const p = i.getValueInRange(D.fromPositions(h, c)), f = fc(a, p), _ = D.fromPositions(h, h.delta(0, f));
    return new Bd(_, d);
  });
}
function D9(i) {
  const e = Nw.createSortPermutation(i, (n, s) => D.compareRangesUsingStarts(n.range, s.range)), t = new tP(e.apply(i)).getNewRanges();
  return e.inverse().apply(t).map((n) => n.getEndPosition());
}
eT = $le([$x(9, Se), $x(10, ai), $x(11, zt)], eT);
var V_, Gle = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, x9 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class tT {
  constructor(e) {
    this.name = e;
  }
  select(e, t, n) {
    if (n.length === 0) return 0;
    const s = n[0].score[0];
    for (let o = 0; o < n.length; o++) {
      const { score: r, completion: a } = n[o];
      if (r[0] !== s) break;
      if (a.preselect) return o;
    }
    return 0;
  }
}
class eU extends tT {
  constructor() {
    super("first");
  }
  memorize(e, t, n) {
  }
  toJSON() {
  }
  fromJSON() {
  }
}
let H_ = V_ = class {
  constructor(i, e) {
    this._storageService = i, this._configService = e, this._disposables = new G(), this._persistSoon = new It(() => this._saveState(), 500), this._disposables.add(i.onWillSaveState((t) => {
      t.reason === Fv.SHUTDOWN && this._saveState();
    }));
  }
  dispose() {
    this._disposables.dispose(), this._persistSoon.dispose();
  }
  memorize(i, e, t) {
    this._withStrategy(i, e).memorize(i, e, t), this._persistSoon.schedule();
  }
  select(i, e, t) {
    return this._withStrategy(i, e).select(i, e, t);
  }
  _withStrategy(i, e) {
    var t;
    const n = this._configService.getValue("editor.suggestSelection", { overrideIdentifier: i.getLanguageIdAtPosition(e.lineNumber, e.column), resource: i.uri });
    if (((t = this._strategy) === null || t === void 0 ? void 0 : t.name) !== n) {
      this._saveState();
      const s = V_._strategyCtors.get(n) || eU;
      this._strategy = new s();
      try {
        const o = this._configService.getValue("editor.suggest.shareSuggestSelections") ? 0 : 1, r = this._storageService.get(`${V_._storagePrefix}/${n}`, o);
        r && this._strategy.fromJSON(JSON.parse(r));
      } catch {
      }
    }
    return this._strategy;
  }
  _saveState() {
    if (this._strategy) {
      const i = this._configService.getValue("editor.suggest.shareSuggestSelections") ? 0 : 1, e = JSON.stringify(this._strategy);
      this._storageService.store(`${V_._storagePrefix}/${this._strategy.name}`, e, i, 1);
    }
  }
};
H_._strategyCtors = /* @__PURE__ */ new Map([["recentlyUsedByPrefix", class extends tT {
  constructor() {
    super("recentlyUsedByPrefix"), this._trie = fm.forStrings(), this._seq = 0;
  }
  memorize(i, e, t) {
    const { word: n } = i.getWordUntilPosition(e), s = `${i.getLanguageId()}/${n}`;
    this._trie.set(s, { type: t.completion.kind, insertText: t.completion.insertText, touch: this._seq++ });
  }
  select(i, e, t) {
    const { word: n } = i.getWordUntilPosition(e);
    if (!n) return super.select(i, e, t);
    const s = `${i.getLanguageId()}/${n}`;
    let o = this._trie.get(s);
    if (o || (o = this._trie.findSubstr(s)), o) for (let r = 0; r < t.length; r++) {
      const { kind: a, insertText: l } = t[r].completion;
      if (a === o.type && l === o.insertText) return r;
    }
    return super.select(i, e, t);
  }
  toJSON() {
    const i = [];
    return this._trie.forEach((e, t) => i.push([t, e])), i.sort((e, t) => -(e[1].touch - t[1].touch)).forEach((e, t) => e[1].touch = t), i.slice(0, 200);
  }
  fromJSON(i) {
    if (this._trie.clear(), i.length > 0) {
      this._seq = i[0][1].touch + 1;
      for (const [e, t] of i) t.type = typeof t.type == "number" ? t.type : Z0.fromString(t.type), this._trie.set(e, t);
    }
  }
}], ["recentlyUsed", class extends tT {
  constructor() {
    super("recentlyUsed"), this._cache = new Ll(300, 0.66), this._seq = 0;
  }
  memorize(i, e, t) {
    const n = `${i.getLanguageId()}/${t.textLabel}`;
    this._cache.set(n, { touch: this._seq++, type: t.completion.kind, insertText: t.completion.insertText });
  }
  select(i, e, t) {
    if (t.length === 0) return 0;
    const n = i.getLineContent(e.lineNumber).substr(e.column - 10, e.column - 1);
    if (/\s$/.test(n)) return super.select(i, e, t);
    const s = t[0].score[0];
    let o = -1, r = -1, a = -1;
    for (let l = 0; l < t.length && t[l].score[0] === s; l++) {
      const d = `${i.getLanguageId()}/${t[l].textLabel}`, h = this._cache.peek(d);
      if (h && h.touch > a && h.type === t[l].completion.kind && h.insertText === t[l].completion.insertText && (a = h.touch, r = l), t[l].completion.preselect && o === -1) return l;
    }
    return r !== -1 ? r : o !== -1 ? o : 0;
  }
  toJSON() {
    return this._cache.toJSON();
  }
  fromJSON(i) {
    this._cache.clear();
    for (const [e, t] of i) t.touch = 0, t.type = typeof t.type == "number" ? t.type : Z0.fromString(t.type), this._cache.set(e, t);
    this._seq = this._cache.size;
  }
}], ["first", eU]]), H_._storagePrefix = "suggest/memories", H_ = V_ = Gle([x9(0, Nr), x9(1, Ye)], H_);
const ak = tt("ISuggestMemories");
rt(ak, H_, 1);
var iT, Zle = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Yle = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let R0 = iT = class {
  constructor(i, e) {
    this._editor = i, this._enabled = !1, this._ckAtEnd = iT.AtEnd.bindTo(e), this._configListener = this._editor.onDidChangeConfiguration((t) => t.hasChanged(123) && this._update()), this._update();
  }
  dispose() {
    var i;
    this._configListener.dispose(), (i = this._selectionListener) === null || i === void 0 || i.dispose(), this._ckAtEnd.reset();
  }
  _update() {
    const i = this._editor.getOption(123) === "on";
    if (this._enabled !== i) if (this._enabled = i, this._enabled) {
      const e = () => {
        if (!this._editor.hasModel()) return void this._ckAtEnd.set(!1);
        const t = this._editor.getModel(), n = this._editor.getSelection(), s = t.getWordAtPosition(n.getStartPosition());
        s ? this._ckAtEnd.set(s.endColumn === n.getStartPosition().column) : this._ckAtEnd.set(!1);
      };
      this._selectionListener = this._editor.onDidChangeCursorSelection(e), e();
    } else this._selectionListener && (this._ckAtEnd.reset(), this._selectionListener.dispose(), this._selectionListener = void 0);
  }
};
R0.AtEnd = new ae("atEndOfWord", !1), R0 = iT = Zle([Yle(1, Te)], R0);
var z_, Xle = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Qle = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let ig = z_ = class {
  constructor(i, e) {
    this._editor = i, this._index = 0, this._ckOtherSuggestions = z_.OtherSuggestions.bindTo(e);
  }
  dispose() {
    this.reset();
  }
  reset() {
    var i;
    this._ckOtherSuggestions.reset(), (i = this._listener) === null || i === void 0 || i.dispose(), this._model = void 0, this._acceptNext = void 0, this._ignore = !1;
  }
  set({ model: i, index: e }, t) {
    if (i.items.length === 0) return void this.reset();
    z_._moveIndex(!0, i, e) !== e ? (this._acceptNext = t, this._model = i, this._index = e, this._listener = this._editor.onDidChangeCursorPosition(() => {
      this._ignore || this.reset();
    }), this._ckOtherSuggestions.set(!0)) : this.reset();
  }
  static _moveIndex(i, e, t) {
    let n = t;
    for (let s = e.items.length; s > 0 && (n = (n + e.items.length + (i ? 1 : -1)) % e.items.length, n !== t) && e.items[n].completion.additionalTextEdits; s--) ;
    return n;
  }
  next() {
    this._move(!0);
  }
  prev() {
    this._move(!1);
  }
  _move(i) {
    if (this._model) try {
      this._ignore = !0, this._index = z_._moveIndex(i, this._model, this._index), this._acceptNext({ index: this._index, item: this._model.items[this._index], model: this._model });
    } finally {
      this._ignore = !1;
    }
  }
};
ig.OtherSuggestions = new ae("hasOtherSuggestions", !1), ig = z_ = Xle([Qle(1, Te)], ig);
class Jle {
  constructor(e, t, n, s) {
    this._disposables = new G(), this._disposables.add(n.onDidSuggest((o) => {
      o.completionModel.items.length === 0 && this.reset();
    })), this._disposables.add(n.onDidCancel((o) => {
      this.reset();
    })), this._disposables.add(t.onDidShow(() => this._onItem(t.getFocusedItem()))), this._disposables.add(t.onDidFocus(this._onItem, this)), this._disposables.add(t.onDidHide(this.reset, this)), this._disposables.add(e.onWillType((o) => {
      if (this._active && !t.isFrozen() && n.state !== 0) {
        const r = o.charCodeAt(o.length - 1);
        this._active.acceptCharacters.has(r) && e.getOption(0) && s(this._active.item);
      }
    }));
  }
  _onItem(e) {
    if (!e || !zn(e.item.completion.commitCharacters)) return void this.reset();
    if (this._active && this._active.item.item === e.item) return;
    const t = new ey();
    for (const n of e.item.completion.commitCharacters) n.length > 0 && t.add(n.charCodeAt(0));
    this._active = { acceptCharacters: t, item: e };
  }
  reset() {
    this._active = void 0;
  }
  dispose() {
    this._disposables.dispose();
  }
}
class ho {
  async provideSelectionRanges(e, t) {
    const n = [];
    for (const s of t) {
      const o = [];
      n.push(o);
      const r = /* @__PURE__ */ new Map();
      await new Promise((a) => ho._bracketsRightYield(a, 0, e, s, r)), await new Promise((a) => ho._bracketsLeftYield(a, 0, e, s, r, o));
    }
    return n;
  }
  static _bracketsRightYield(e, t, n, s, o) {
    const r = /* @__PURE__ */ new Map(), a = Date.now();
    for (; ; ) {
      if (t >= ho._maxRounds) {
        e();
        break;
      }
      if (!s) {
        e();
        break;
      }
      const l = n.bracketPairs.findNextBracket(s);
      if (!l) {
        e();
        break;
      }
      if (Date.now() - a > ho._maxDuration) {
        setTimeout(() => ho._bracketsRightYield(e, t + 1, n, s, o));
        break;
      }
      if (l.bracketInfo.isOpeningBracket) {
        const d = l.bracketInfo.bracketText, h = r.has(d) ? r.get(d) : 0;
        r.set(d, h + 1);
      } else {
        const d = l.bracketInfo.getOpeningBrackets()[0].bracketText;
        let h = r.has(d) ? r.get(d) : 0;
        if (h -= 1, r.set(d, Math.max(0, h)), h < 0) {
          let c = o.get(d);
          c || (c = new fs(), o.set(d, c)), c.push(l.range);
        }
      }
      s = l.range.getEndPosition();
    }
  }
  static _bracketsLeftYield(e, t, n, s, o, r) {
    const a = /* @__PURE__ */ new Map(), l = Date.now();
    for (; ; ) {
      if (t >= ho._maxRounds && o.size === 0) {
        e();
        break;
      }
      if (!s) {
        e();
        break;
      }
      const d = n.bracketPairs.findPrevBracket(s);
      if (!d) {
        e();
        break;
      }
      if (Date.now() - l > ho._maxDuration) {
        setTimeout(() => ho._bracketsLeftYield(e, t + 1, n, s, o, r));
        break;
      }
      if (d.bracketInfo.isOpeningBracket) {
        const h = d.bracketInfo.bracketText;
        let c = a.has(h) ? a.get(h) : 0;
        if (c -= 1, a.set(h, Math.max(0, c)), c < 0) {
          const u = o.get(h);
          if (u) {
            const g = u.shift();
            u.size === 0 && o.delete(h);
            const p = D.fromPositions(d.range.getEndPosition(), g.getStartPosition()), f = D.fromPositions(d.range.getStartPosition(), g.getEndPosition());
            r.push({ range: p }), r.push({ range: f }), ho._addBracketLeading(n, f, r);
          }
        }
      } else {
        const h = d.bracketInfo.getOpeningBrackets()[0].bracketText, c = a.has(h) ? a.get(h) : 0;
        a.set(h, c + 1);
      }
      s = d.range.getStartPosition();
    }
  }
  static _addBracketLeading(e, t, n) {
    if (t.startLineNumber === t.endLineNumber) return;
    const s = t.startLineNumber, o = e.getLineFirstNonWhitespaceColumn(s);
    o !== 0 && o !== t.startColumn && (n.push({ range: D.fromPositions(new W(s, o), t.getEndPosition()) }), n.push({ range: D.fromPositions(new W(s, 1), t.getEndPosition()) }));
    const r = s - 1;
    if (r > 0) {
      const a = e.getLineFirstNonWhitespaceColumn(r);
      a === t.startColumn && a !== e.getLineLastNonWhitespaceColumn(r) && (n.push({ range: D.fromPositions(new W(r, a), t.getEndPosition()) }), n.push({ range: D.fromPositions(new W(r, 1), t.getEndPosition()) }));
    }
  }
}
ho._maxDuration = 30, ho._maxRounds = 2;
class Yr {
  static async create(e, t) {
    if (!t.getOption(118).localityBonus || !t.hasModel()) return Yr.None;
    const n = t.getModel(), s = t.getPosition();
    if (!e.canComputeWordRanges(n.uri)) return Yr.None;
    const [o] = await new ho().provideSelectionRanges(n, [s]);
    if (o.length === 0) return Yr.None;
    const r = await e.computeWordRanges(n.uri, o[0].range);
    if (!r) return Yr.None;
    const a = n.getWordUntilPosition(s);
    return delete r[a.word], new class extends Yr {
      distance(l, d) {
        if (!s.equals(t.getPosition())) return 0;
        if (d.kind === 17) return 2 << 20;
        const h = typeof d.label == "string" ? d.label : d.label.label, c = r[h];
        if (m7(c)) return 2 << 20;
        const u = U0(c, D.fromPositions(l), D.compareRangesUsingStarts), g = u >= 0 ? c[u] : c[Math.max(0, ~u - 1)];
        let p = o.length;
        for (const f of o) {
          if (!D.containsRange(f.range, g)) break;
          p -= 1;
        }
        return p;
      }
    }();
  }
}
Yr.None = new class extends Yr {
  distance() {
    return 0;
  }
}();
let N9 = class {
  constructor(i, e) {
    this.leadingLineContent = i, this.characterCountDelta = e;
  }
};
class Lh {
  constructor(e, t, n, s, o, r, a = bL.default, l = void 0) {
    this.clipboardText = l, this._snippetCompareFn = Lh._compareCompletionItems, this._items = e, this._column = t, this._wordDistance = s, this._options = o, this._refilterKind = 1, this._lineContext = n, this._fuzzyScoreOptions = a, r === "top" ? this._snippetCompareFn = Lh._compareCompletionItemsSnippetsUp : r === "bottom" && (this._snippetCompareFn = Lh._compareCompletionItemsSnippetsDown);
  }
  get lineContext() {
    return this._lineContext;
  }
  set lineContext(e) {
    this._lineContext.leadingLineContent === e.leadingLineContent && this._lineContext.characterCountDelta === e.characterCountDelta || (this._refilterKind = this._lineContext.characterCountDelta < e.characterCountDelta && this._filteredItems ? 2 : 1, this._lineContext = e);
  }
  get items() {
    return this._ensureCachedState(), this._filteredItems;
  }
  getItemsByProvider() {
    return this._ensureCachedState(), this._itemsByProvider;
  }
  getIncompleteProvider() {
    this._ensureCachedState();
    const e = /* @__PURE__ */ new Set();
    for (const [t, n] of this.getItemsByProvider()) n.length > 0 && n[0].container.incomplete && e.add(t);
    return e;
  }
  get stats() {
    return this._ensureCachedState(), this._stats;
  }
  _ensureCachedState() {
    this._refilterKind !== 0 && this._createCachedState();
  }
  _createCachedState() {
    this._itemsByProvider = /* @__PURE__ */ new Map();
    const e = [], { leadingLineContent: t, characterCountDelta: n } = this._lineContext;
    let s = "", o = "";
    const r = this._refilterKind === 1 ? this._items : this._filteredItems, a = [], l = !this._options.filterGraceful || r.length > 2e3 ? pg : AJ;
    for (let d = 0; d < r.length; d++) {
      const h = r[d];
      if (h.isInvalid) continue;
      const c = this._itemsByProvider.get(h.provider);
      c ? c.push(h) : this._itemsByProvider.set(h.provider, [h]);
      const u = h.position.column - h.editStart.column, g = u + n - (h.position.column - this._column);
      if (s.length !== g && (s = g === 0 ? "" : t.slice(-g), o = s.toLowerCase()), h.word = s, g === 0) h.score = da.Default;
      else {
        let p = 0;
        for (; p < u; ) {
          const f = s.charCodeAt(p);
          if (f !== 32 && f !== 9) break;
          p += 1;
        }
        if (p >= g) h.score = da.Default;
        else if (typeof h.completion.filterText == "string") {
          const f = l(s, o, p, h.completion.filterText, h.filterTextLow, 0, this._fuzzyScoreOptions);
          if (!f) continue;
          SE(h.completion.filterText, h.textLabel) === 0 ? h.score = f : (h.score = TJ(s, o, p, h.textLabel, h.labelLow, 0), h.score[0] = f[0]);
        } else {
          const f = l(s, o, p, h.textLabel, h.labelLow, 0, this._fuzzyScoreOptions);
          if (!f) continue;
          h.score = f;
        }
      }
      h.idx = d, h.distance = this._wordDistance.distance(h.position, h.completion), a.push(h), e.push(h.textLabel.length);
    }
    this._filteredItems = a.sort(this._snippetCompareFn), this._refilterKind = 0, this._stats = { pLabelLen: e.length ? wN(e.length - 0.85, e, (d, h) => d - h) : 0 };
  }
  static _compareCompletionItems(e, t) {
    return e.score[0] > t.score[0] ? -1 : e.score[0] < t.score[0] ? 1 : e.distance < t.distance ? -1 : e.distance > t.distance ? 1 : e.idx < t.idx ? -1 : e.idx > t.idx ? 1 : 0;
  }
  static _compareCompletionItemsSnippetsDown(e, t) {
    if (e.completion.kind !== t.completion.kind) {
      if (e.completion.kind === 27) return 1;
      if (t.completion.kind === 27) return -1;
    }
    return Lh._compareCompletionItems(e, t);
  }
  static _compareCompletionItemsSnippetsUp(e, t) {
    if (e.completion.kind !== t.completion.kind) {
      if (e.completion.kind === 27) return -1;
      if (t.completion.kind === 27) return 1;
    }
    return Lh._compareCompletionItems(e, t);
  }
}
var nT, ede = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Qd = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class iu {
  static shouldAutoTrigger(e) {
    if (!e.hasModel()) return !1;
    const t = e.getModel(), n = e.getPosition();
    t.tokenization.tokenizeIfCheap(n.lineNumber);
    const s = t.getWordAtPosition(n);
    return !!s && (s.endColumn === n.column || s.startColumn + 1 === n.column) && !!isNaN(Number(s.word));
  }
  constructor(e, t, n) {
    this.leadingLineContent = e.getLineContent(t.lineNumber).substr(0, t.column - 1), this.leadingWord = e.getWordUntilPosition(t), this.lineNumber = t.lineNumber, this.column = t.column, this.triggerOptions = n;
  }
}
let NS = nT = class {
  constructor(i, e, t, n, s, o, r, a, l) {
    this._editor = i, this._editorWorkerService = e, this._clipboardService = t, this._telemetryService = n, this._logService = s, this._contextKeyService = o, this._configurationService = r, this._languageFeaturesService = a, this._envService = l, this._toDispose = new G(), this._triggerCharacterListener = new G(), this._triggerQuickSuggest = new Dr(), this._triggerState = void 0, this._completionDisposables = new G(), this._onDidCancel = new F(), this._onDidTrigger = new F(), this._onDidSuggest = new F(), this.onDidCancel = this._onDidCancel.event, this.onDidTrigger = this._onDidTrigger.event, this.onDidSuggest = this._onDidSuggest.event, this._telemetryGate = 0, this._currentSelection = this._editor.getSelection() || new _e(1, 1, 1, 1), this._toDispose.add(this._editor.onDidChangeModel(() => {
      this._updateTriggerCharacters(), this.cancel();
    })), this._toDispose.add(this._editor.onDidChangeModelLanguage(() => {
      this._updateTriggerCharacters(), this.cancel();
    })), this._toDispose.add(this._editor.onDidChangeConfiguration(() => {
      this._updateTriggerCharacters();
    })), this._toDispose.add(this._languageFeaturesService.completionProvider.onDidChange(() => {
      this._updateTriggerCharacters(), this._updateActiveSuggestSession();
    }));
    let d = !1;
    this._toDispose.add(this._editor.onDidCompositionStart(() => {
      d = !0;
    })), this._toDispose.add(this._editor.onDidCompositionEnd(() => {
      d = !1, this._onCompositionEnd();
    })), this._toDispose.add(this._editor.onDidChangeCursorSelection((h) => {
      d || this._onCursorChange(h);
    })), this._toDispose.add(this._editor.onDidChangeModelContent(() => {
      d || this._triggerState === void 0 || this._refilterCompletionItems();
    })), this._updateTriggerCharacters();
  }
  dispose() {
    Ht(this._triggerCharacterListener), Ht([this._onDidCancel, this._onDidSuggest, this._onDidTrigger, this._triggerQuickSuggest]), this._toDispose.dispose(), this._completionDisposables.dispose(), this.cancel();
  }
  _updateTriggerCharacters() {
    if (this._triggerCharacterListener.clear(), this._editor.getOption(91) || !this._editor.hasModel() || !this._editor.getOption(121)) return;
    const i = /* @__PURE__ */ new Map();
    for (const t of this._languageFeaturesService.completionProvider.all(this._editor.getModel())) for (const n of t.triggerCharacters || []) {
      let s = i.get(n);
      s || (s = /* @__PURE__ */ new Set(), s.add(void 0), i.set(n, s)), s.add(t);
    }
    const e = (t) => {
      var n;
      if (!function(r, a, l) {
        if (!a.getContextKeyValue("inlineSuggestionVisible")) return !0;
        const d = a.getContextKeyValue(un.suppressSuggestions.key);
        return d !== void 0 ? !d : !r.getOption(62).suppressSuggestions;
      }(this._editor, this._contextKeyService, this._configurationService) || iu.shouldAutoTrigger(this._editor)) return;
      if (!t) {
        const r = this._editor.getPosition();
        t = this._editor.getModel().getLineContent(r.lineNumber).substr(0, r.column - 1);
      }
      let s = "";
      ag(t.charCodeAt(t.length - 1)) ? en(t.charCodeAt(t.length - 2)) && (s = t.substr(t.length - 2)) : s = t.charAt(t.length - 1);
      const o = i.get(s);
      if (o) {
        const r = /* @__PURE__ */ new Map();
        if (this._completionModel) for (const [a, l] of this._completionModel.getItemsByProvider()) o.has(a) || r.set(a, l);
        this.trigger({ auto: !0, triggerKind: 1, triggerCharacter: s, retrigger: !!this._completionModel, clipboardText: (n = this._completionModel) === null || n === void 0 ? void 0 : n.clipboardText, completionOptions: { providerFilter: o, providerItemsToReuse: r } });
      }
    };
    this._triggerCharacterListener.add(this._editor.onDidType(e)), this._triggerCharacterListener.add(this._editor.onDidCompositionEnd(() => e()));
  }
  get state() {
    return this._triggerState ? this._triggerState.auto ? 2 : 1 : 0;
  }
  cancel(i = !1) {
    var e;
    this._triggerState !== void 0 && (this._triggerQuickSuggest.cancel(), (e = this._requestToken) === null || e === void 0 || e.cancel(), this._requestToken = void 0, this._triggerState = void 0, this._completionModel = void 0, this._context = void 0, this._onDidCancel.fire({ retrigger: i }));
  }
  clear() {
    this._completionDisposables.clear();
  }
  _updateActiveSuggestSession() {
    this._triggerState !== void 0 && (this._editor.hasModel() && this._languageFeaturesService.completionProvider.has(this._editor.getModel()) ? this.trigger({ auto: this._triggerState.auto, retrigger: !0 }) : this.cancel());
  }
  _onCursorChange(i) {
    if (!this._editor.hasModel()) return;
    const e = this._currentSelection;
    this._currentSelection = this._editor.getSelection(), !i.selection.isEmpty() || i.reason !== 0 && i.reason !== 3 || i.source !== "keyboard" && i.source !== "deleteLeft" ? this.cancel() : this._triggerState === void 0 && i.reason === 0 ? (e.containsRange(this._currentSelection) || e.getEndPosition().isBeforeOrEqual(this._currentSelection.getPosition())) && this._doTriggerQuickSuggest() : this._triggerState !== void 0 && i.reason === 3 && this._refilterCompletionItems();
  }
  _onCompositionEnd() {
    this._triggerState === void 0 ? this._doTriggerQuickSuggest() : this._refilterCompletionItems();
  }
  _doTriggerQuickSuggest() {
    var i;
    Gp.isAllOff(this._editor.getOption(89)) || this._editor.getOption(118).snippetsPreventQuickSuggestions && (!((i = _n.get(this._editor)) === null || i === void 0) && i.isInSnippet()) || (this.cancel(), this._triggerQuickSuggest.cancelAndSet(() => {
      if (this._triggerState !== void 0 || !iu.shouldAutoTrigger(this._editor) || !this._editor.hasModel() || !this._editor.hasWidgetFocus()) return;
      const e = this._editor.getModel(), t = this._editor.getPosition(), n = this._editor.getOption(89);
      if (!Gp.isAllOff(n)) {
        if (!Gp.isAllOn(n)) {
          e.tokenization.tokenizeIfCheap(t.lineNumber);
          const s = e.tokenization.getLineTokens(t.lineNumber), o = s.getStandardTokenType(s.findTokenIndexAtOffset(Math.max(t.column - 1 - 1, 0)));
          if (Gp.valueFor(n, o) !== "on") return;
        }
        (function(s, o, r) {
          if (!o.getContextKeyValue(un.inlineSuggestionVisible.key)) return !0;
          const a = o.getContextKeyValue(un.suppressSuggestions.key);
          return a !== void 0 ? !a : !s.getOption(62).suppressSuggestions;
        })(this._editor, this._contextKeyService, this._configurationService) && this._languageFeaturesService.completionProvider.has(e) && this.trigger({ auto: !0 });
      }
    }, this._editor.getOption(90)));
  }
  _refilterCompletionItems() {
    vt(this._editor.hasModel()), vt(this._triggerState !== void 0);
    const i = this._editor.getModel(), e = this._editor.getPosition(), t = new iu(i, e, { ...this._triggerState, refilter: !0 });
    this._onNewContext(t);
  }
  trigger(i) {
    var e, t, n, s, o, r;
    if (!this._editor.hasModel()) return;
    const a = this._editor.getModel(), l = new iu(a, this._editor.getPosition(), i);
    this.cancel(i.retrigger), this._triggerState = i, this._onDidTrigger.fire({ auto: i.auto, shy: (e = i.shy) !== null && e !== void 0 && e, position: this._editor.getPosition() }), this._context = l;
    let d = { triggerKind: (t = i.triggerKind) !== null && t !== void 0 ? t : 0 };
    i.triggerCharacter && (d = { triggerKind: 1, triggerCharacter: i.triggerCharacter }), this._requestToken = new Ci();
    let h = 1;
    switch (this._editor.getOption(112)) {
      case "top":
        h = 0;
        break;
      case "bottom":
        h = 2;
    }
    const { itemKind: c, showDeprecated: u } = nT.createSuggestFilter(this._editor), g = new o1(h, (s = (n = i.completionOptions) === null || n === void 0 ? void 0 : n.kindFilter) !== null && s !== void 0 ? s : c, (o = i.completionOptions) === null || o === void 0 ? void 0 : o.providerFilter, (r = i.completionOptions) === null || r === void 0 ? void 0 : r.providerItemsToReuse, u), p = Yr.create(this._editorWorkerService, this._editor), f = EP(this._languageFeaturesService.completionProvider, a, this._editor.getPosition(), g, d, this._requestToken.token);
    Promise.all([f, p]).then(async ([_, v]) => {
      var b;
      if ((b = this._requestToken) === null || b === void 0 || b.dispose(), !this._editor.hasModel()) return;
      let C = i == null ? void 0 : i.clipboardText;
      if (!C && _.needsClipboard && (C = await this._clipboardService.readText()), this._triggerState === void 0) return;
      const w = this._editor.getModel(), y = new iu(w, this._editor.getPosition(), i), L = { ...bL.default, firstMatchCanBeWeak: !this._editor.getOption(118).matchOnWordStartOnly };
      if (this._completionModel = new Lh(_.items, this._context.column, { leadingLineContent: y.leadingLineContent, characterCountDelta: y.column - this._context.column }, v, this._editor.getOption(118), this._editor.getOption(112), L, C), this._completionDisposables.add(_.disposable), this._onNewContext(y), this._reportDurationsTelemetry(_.durations), !this._envService.isBuilt || this._envService.isExtensionDevelopment) for (const k of _.items) k.isInvalid && this._logService.warn(`[suggest] did IGNORE invalid completion item from ${k.provider._debugDisplayName}`, k.completion);
    }).catch(We);
  }
  _reportDurationsTelemetry(i) {
    this._telemetryGate++ % 230 == 0 && setTimeout(() => {
      this._telemetryService.publicLog2("suggest.durations.json", { data: JSON.stringify(i) }), this._logService.debug("suggest.durations.json", i);
    });
  }
  static createSuggestFilter(i) {
    const e = /* @__PURE__ */ new Set();
    i.getOption(112) === "none" && e.add(27);
    const t = i.getOption(118);
    return t.showMethods || e.add(0), t.showFunctions || e.add(1), t.showConstructors || e.add(2), t.showFields || e.add(3), t.showVariables || e.add(4), t.showClasses || e.add(5), t.showStructs || e.add(6), t.showInterfaces || e.add(7), t.showModules || e.add(8), t.showProperties || e.add(9), t.showEvents || e.add(10), t.showOperators || e.add(11), t.showUnits || e.add(12), t.showValues || e.add(13), t.showConstants || e.add(14), t.showEnums || e.add(15), t.showEnumMembers || e.add(16), t.showKeywords || e.add(17), t.showWords || e.add(18), t.showColors || e.add(19), t.showFiles || e.add(20), t.showReferences || e.add(21), t.showColors || e.add(22), t.showFolders || e.add(23), t.showTypeParameters || e.add(24), t.showSnippets || e.add(27), t.showUsers || e.add(25), t.showIssues || e.add(26), { itemKind: e, showDeprecated: t.showDeprecated };
  }
  _onNewContext(i) {
    if (this._context) if (i.lineNumber === this._context.lineNumber) if (Wt(i.leadingLineContent) === Wt(this._context.leadingLineContent)) {
      if (i.column < this._context.column) i.leadingWord.word ? this.trigger({ auto: this._context.triggerOptions.auto, retrigger: !0 }) : this.cancel();
      else if (this._completionModel) if (i.leadingWord.word.length !== 0 && i.leadingWord.startColumn > this._context.leadingWord.startColumn) {
        if (iu.shouldAutoTrigger(this._editor) && this._context) {
          const e = this._completionModel.getItemsByProvider();
          this.trigger({ auto: this._context.triggerOptions.auto, retrigger: !0, clipboardText: this._completionModel.clipboardText, completionOptions: { providerItemsToReuse: e } });
        }
      } else if (i.column > this._context.column && this._completionModel.getIncompleteProvider().size > 0 && i.leadingWord.word.length !== 0) {
        const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set();
        for (const [n, s] of this._completionModel.getItemsByProvider()) s.length > 0 && s[0].container.incomplete ? t.add(n) : e.set(n, s);
        this.trigger({ auto: this._context.triggerOptions.auto, triggerKind: 2, retrigger: !0, clipboardText: this._completionModel.clipboardText, completionOptions: { providerFilter: t, providerItemsToReuse: e } });
      } else {
        const e = this._completionModel.lineContext;
        let t = !1;
        if (this._completionModel.lineContext = { leadingLineContent: i.leadingLineContent, characterCountDelta: i.column - this._context.column }, this._completionModel.items.length === 0) {
          const n = iu.shouldAutoTrigger(this._editor);
          if (!this._context) return void this.cancel();
          if (n && this._context.leadingWord.endColumn < i.leadingWord.startColumn) return void this.trigger({ auto: this._context.triggerOptions.auto, retrigger: !0 });
          if (this._context.triggerOptions.auto) return void this.cancel();
          if (this._completionModel.lineContext = e, t = this._completionModel.items.length > 0, t && i.leadingWord.word.length === 0) return void this.cancel();
        }
        this._onDidSuggest.fire({ completionModel: this._completionModel, triggerOptions: i.triggerOptions, isFrozen: t });
      }
    } else this.cancel();
    else this.cancel();
  }
};
NS = nT = ede([Qd(1, Qo), Qd(2, Kd), Qd(3, es), Qd(4, ts), Qd(5, Te), Qd(6, Ye), Qd(7, fe), Qd(8, uA)], NS);
class lk {
  constructor(e, t) {
    this._disposables = new G(), this._lastOvertyped = [], this._locked = !1, this._disposables.add(e.onWillType(() => {
      if (this._locked || !e.hasModel()) return;
      const n = e.getSelections(), s = n.length;
      let o = !1;
      for (let a = 0; a < s; a++) if (!n[a].isEmpty()) {
        o = !0;
        break;
      }
      if (!o) return void (this._lastOvertyped.length !== 0 && (this._lastOvertyped.length = 0));
      this._lastOvertyped = [];
      const r = e.getModel();
      for (let a = 0; a < s; a++) {
        const l = n[a];
        if (r.getValueLengthInRange(l) > lk._maxSelectionLength) return;
        this._lastOvertyped[a] = { value: r.getValueInRange(l), multiline: l.startLineNumber !== l.endLineNumber };
      }
    })), this._disposables.add(t.onDidTrigger((n) => {
      this._locked = !0;
    })), this._disposables.add(t.onDidCancel((n) => {
      this._locked = !1;
    }));
  }
  getLastOvertypedInfo(e) {
    if (e >= 0 && e < this._lastOvertyped.length) return this._lastOvertyped[e];
  }
  dispose() {
    this._disposables.dispose();
  }
}
lk._maxSelectionLength = 51200;
var tde = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Zx = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let ide = class tU extends Ic {
  updateLabel() {
    const e = this._keybindingService.lookupKeybinding(this._action.id, this._contextKeyService);
    if (!e) return super.updateLabel();
    this.label && (this.label.textContent = m(0, "{0} ({1})", this._action.label, tU.symbolPrintEnter(e)));
  }
  static symbolPrintEnter(e) {
    var t;
    return (t = e.getLabel()) === null || t === void 0 ? void 0 : t.replace(/\benter\b/gi, "⏎");
  }
}, sT = class {
  constructor(i, e, t, n, s) {
    this._menuId = e, this._menuService = n, this._contextKeyService = s, this._menuDisposables = new G(), this.element = Z(i, Q(".suggest-status-bar"));
    const o = (r) => r instanceof Eo ? t.createInstance(ide, r, void 0) : void 0;
    this._leftActions = new sr(this.element, { actionViewItemProvider: o }), this._rightActions = new sr(this.element, { actionViewItemProvider: o }), this._leftActions.domNode.classList.add("left"), this._rightActions.domNode.classList.add("right");
  }
  dispose() {
    this._menuDisposables.dispose(), this._leftActions.dispose(), this._rightActions.dispose(), this.element.remove();
  }
  show() {
    const i = this._menuService.createMenu(this._menuId, this._contextKeyService), e = () => {
      const t = [], n = [];
      for (const [s, o] of i.getActions()) s === "left" ? t.push(...o) : n.push(...o);
      this._leftActions.clear(), this._leftActions.push(t), this._rightActions.clear(), this._rightActions.push(n);
    };
    this._menuDisposables.add(i.onDidChange(() => e())), this._menuDisposables.add(i);
  }
  hide() {
    this._menuDisposables.clear();
  }
};
sT = tde([Zx(2, Se), Zx(3, Mo), Zx(4, Te)], sT);
var nde = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, sde = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
function IP(i) {
  return !!i && !!(i.completion.documentation || i.completion.detail && i.completion.detail !== i.completion.label);
}
let oT = class {
  constructor(i, e) {
    this._editor = i, this._onDidClose = new F(), this.onDidClose = this._onDidClose.event, this._onDidChangeContents = new F(), this.onDidChangeContents = this._onDidChangeContents.event, this._disposables = new G(), this._renderDisposeable = new G(), this._borderWidth = 1, this._size = new bt(330, 0), this.domNode = Q(".suggest-details"), this.domNode.classList.add("no-docs"), this._markdownRenderer = e.createInstance(ml, { editor: i }), this._body = Q(".body"), this._scrollbar = new k1(this._body, { alwaysConsumeMouseWheel: !0 }), Z(this.domNode, this._scrollbar.getDomNode()), this._disposables.add(this._scrollbar), this._header = Z(this._body, Q(".header")), this._close = Z(this._header, Q("span" + Ee.asCSSSelector(ne.close))), this._close.title = m(0, "Close"), this._type = Z(this._header, Q("p.type")), this._docs = Z(this._body, Q("p.docs")), this._configureFont(), this._disposables.add(this._editor.onDidChangeConfiguration((t) => {
      t.hasChanged(50) && this._configureFont();
    }));
  }
  dispose() {
    this._disposables.dispose(), this._renderDisposeable.dispose();
  }
  _configureFont() {
    const i = this._editor.getOptions(), e = i.get(50), t = e.getMassagedFontFamily(), n = i.get(119) || e.fontSize, s = i.get(120) || e.lineHeight, o = e.fontWeight, r = `${n}px`, a = `${s}px`;
    this.domNode.style.fontSize = r, this.domNode.style.lineHeight = "" + s / n, this.domNode.style.fontWeight = o, this.domNode.style.fontFeatureSettings = e.fontFeatureSettings, this._type.style.fontFamily = t, this._close.style.height = a, this._close.style.width = a;
  }
  getLayoutInfo() {
    const i = this._editor.getOption(120) || this._editor.getOption(50).lineHeight, e = this._borderWidth;
    return { lineHeight: i, borderWidth: e, borderHeight: 2 * e, verticalPadding: 22, horizontalPadding: 14 };
  }
  renderLoading() {
    this._type.textContent = m(0, "Loading..."), this._docs.textContent = "", this.domNode.classList.remove("no-docs", "no-type"), this.layout(this.size.width, 2 * this.getLayoutInfo().lineHeight), this._onDidChangeContents.fire(this);
  }
  renderItem(i, e) {
    var t, n;
    this._renderDisposeable.clear();
    let { detail: s, documentation: o } = i.completion;
    if (e) {
      let r = "";
      r += `score: ${i.score[0]}
`, r += `prefix: ${(t = i.word) !== null && t !== void 0 ? t : "(no prefix)"}
`, r += `word: ${i.completion.filterText ? i.completion.filterText + " (filterText)" : i.textLabel}
`, r += `distance: ${i.distance} (localityBonus-setting)
`, r += `index: ${i.idx}, based on ${i.completion.sortText && `sortText: "${i.completion.sortText}"` || "label"}
`, r += `commit_chars: ${(n = i.completion.commitCharacters) === null || n === void 0 ? void 0 : n.join("")}
`, o = new Vn().appendCodeblock("empty", r), s = `Provider: ${i.provider._debugDisplayName}`;
    }
    if (e || IP(i)) {
      if (this.domNode.classList.remove("no-docs", "no-type"), s) {
        const r = s.length > 1e5 ? `${s.substr(0, 1e5)}…` : s;
        this._type.textContent = r, this._type.title = r, bo(this._type), this._type.classList.toggle("auto-wrap", !/\r?\n^\s+/gim.test(r));
      } else Un(this._type), this._type.title = "", Ts(this._type), this.domNode.classList.add("no-type");
      if (Un(this._docs), typeof o == "string") this._docs.classList.remove("markdown-docs"), this._docs.textContent = o;
      else if (o) {
        this._docs.classList.add("markdown-docs"), Un(this._docs);
        const r = this._markdownRenderer.render(o);
        this._docs.appendChild(r.element), this._renderDisposeable.add(r), this._renderDisposeable.add(this._markdownRenderer.onDidRenderAsync(() => {
          this.layout(this._size.width, this._type.clientHeight + this._docs.clientHeight), this._onDidChangeContents.fire(this);
        }));
      }
      this.domNode.style.userSelect = "text", this.domNode.tabIndex = -1, this._close.onmousedown = (r) => {
        r.preventDefault(), r.stopPropagation();
      }, this._close.onclick = (r) => {
        r.preventDefault(), r.stopPropagation(), this._onDidClose.fire();
      }, this._body.scrollTop = 0, this.layout(this._size.width, this._type.clientHeight + this._docs.clientHeight), this._onDidChangeContents.fire(this);
    } else this.clearContents();
  }
  clearContents() {
    this.domNode.classList.add("no-docs"), this._type.textContent = "", this._docs.textContent = "";
  }
  get isEmpty() {
    return this.domNode.classList.contains("no-docs");
  }
  get size() {
    return this._size;
  }
  layout(i, e) {
    const t = new bt(i, e);
    bt.equals(t, this._size) || (this._size = t, function(n, s, o) {
      typeof s == "number" && (n.style.width = `${s}px`), typeof o == "number" && (n.style.height = `${o}px`);
    }(this.domNode, i, e)), this._scrollbar.scanDomNode();
  }
  scrollDown(i = 8) {
    this._body.scrollTop += i;
  }
  scrollUp(i = 8) {
    this._body.scrollTop -= i;
  }
  scrollTop() {
    this._body.scrollTop = 0;
  }
  scrollBottom() {
    this._body.scrollTop = this._body.scrollHeight;
  }
  pageDown() {
    this.scrollDown(80);
  }
  pageUp() {
    this.scrollUp(80);
  }
  set borderWidth(i) {
    this._borderWidth = i;
  }
  get borderWidth() {
    return this._borderWidth;
  }
};
oT = nde([sde(1, Se)], oT);
class ode {
  constructor(e, t) {
    let n, s;
    this.widget = e, this._editor = t, this.allowEditorOverflow = !0, this._disposables = new G(), this._added = !1, this._preferAlignAtTop = !0, this._resizable = new CP(), this._resizable.domNode.classList.add("suggest-details-container"), this._resizable.domNode.appendChild(e.domNode), this._resizable.enableSashes(!1, !0, !0, !1);
    let o = 0, r = 0;
    this._disposables.add(this._resizable.onDidWillResize(() => {
      n = this._topLeft, s = this._resizable.size;
    })), this._disposables.add(this._resizable.onDidResize((a) => {
      if (n && s) {
        this.widget.layout(a.dimension.width, a.dimension.height);
        let l = !1;
        a.west && (r = s.width - a.dimension.width, l = !0), a.north && (o = s.height - a.dimension.height, l = !0), l && this._applyTopLeft({ top: n.top + o, left: n.left + r });
      }
      a.done && (n = void 0, s = void 0, o = 0, r = 0, this._userSize = a.dimension);
    })), this._disposables.add(this.widget.onDidChangeContents(() => {
      var a;
      this._anchorBox && this._placeAtAnchor(this._anchorBox, (a = this._userSize) !== null && a !== void 0 ? a : this.widget.size, this._preferAlignAtTop);
    }));
  }
  dispose() {
    this._resizable.dispose(), this._disposables.dispose(), this.hide();
  }
  getId() {
    return "suggest.details";
  }
  getDomNode() {
    return this._resizable.domNode;
  }
  getPosition() {
    return this._topLeft ? { preference: this._topLeft } : null;
  }
  show() {
    this._added || (this._editor.addOverlayWidget(this), this._added = !0);
  }
  hide(e = !1) {
    this._resizable.clearSashHoverState(), this._added && (this._editor.removeOverlayWidget(this), this._added = !1, this._anchorBox = void 0, this._topLeft = void 0), e && (this._userSize = void 0, this.widget.clearContents());
  }
  placeAtAnchor(e, t) {
    var n;
    const s = e.getBoundingClientRect();
    this._anchorBox = s, this._preferAlignAtTop = t, this._placeAtAnchor(this._anchorBox, (n = this._userSize) !== null && n !== void 0 ? n : this.widget.size, t);
  }
  _placeAtAnchor(e, t, n) {
    var s;
    const o = wc(this.getDomNode().ownerDocument.body), r = this.widget.getLayoutInfo(), a = new bt(220, 2 * r.lineHeight), l = e.top, d = function() {
      const L = o.width - (e.left + e.width + r.borderWidth + r.horizontalPadding), k = -r.borderWidth + e.left + e.width, N = new bt(L, o.height - e.top - r.borderHeight - r.verticalPadding), A = N.with(void 0, e.top + e.height - r.borderHeight - r.verticalPadding);
      return { top: l, left: k, fit: L - t.width, maxSizeTop: N, maxSizeBottom: A, minSize: a.with(Math.min(L, a.width)) };
    }(), h = function() {
      const L = e.left - r.borderWidth - r.horizontalPadding, k = Math.max(r.horizontalPadding, e.left - t.width - r.borderWidth), N = new bt(L, o.height - e.top - r.borderHeight - r.verticalPadding), A = N.with(void 0, e.top + e.height - r.borderHeight - r.verticalPadding);
      return { top: l, left: k, fit: L - t.width, maxSizeTop: N, maxSizeBottom: A, minSize: a.with(Math.min(L, a.width)) };
    }(), c = function() {
      const L = e.left, k = -r.borderWidth + e.top + e.height, N = new bt(e.width - r.borderHeight, o.height - e.top - e.height - r.verticalPadding);
      return { top: k, left: L, fit: N.height - t.height, maxSizeBottom: N, maxSizeTop: N, minSize: a.with(N.width) };
    }(), u = [d, h, c], g = (s = u.find((L) => L.fit >= 0)) !== null && s !== void 0 ? s : u.sort((L, k) => k.fit - L.fit)[0], p = e.top + e.height - r.borderHeight;
    let f, _ = t.height;
    const v = Math.max(g.maxSizeTop.height, g.maxSizeBottom.height);
    let b;
    _ > v && (_ = v), n ? _ <= g.maxSizeTop.height ? (f = !0, b = g.maxSizeTop) : (f = !1, b = g.maxSizeBottom) : _ <= g.maxSizeBottom.height ? (f = !1, b = g.maxSizeBottom) : (f = !0, b = g.maxSizeTop);
    let { top: C, left: w } = g;
    !f && _ > e.height && (C = p - _);
    const y = this._editor.getDomNode();
    if (y) {
      const L = y.getBoundingClientRect();
      C -= L.top, w -= L.left;
    }
    this._applyTopLeft({ left: w, top: C }), this._resizable.enableSashes(!f, g === d, f, g !== d), this._resizable.minSize = g.minSize, this._resizable.maxSize = b, this._resizable.layout(_, Math.min(b.width, t.width)), this.widget.layout(this._resizable.size.width, this._resizable.size.height);
  }
  _applyTopLeft(e) {
    this._topLeft = e, this._editor.layoutOverlayWidget(this);
  }
}
var dl;
(function(i) {
  i[i.FILE = 0] = "FILE", i[i.FOLDER = 1] = "FOLDER", i[i.ROOT_FOLDER = 2] = "ROOT_FOLDER";
})(dl || (dl = {}));
const rde = /(?:\/|^)(?:([^\/]+)\/)?([^\/]+)$/;
function pC(i, e, t, n, s) {
  const o = n === dl.ROOT_FOLDER ? ["rootfolder-icon"] : n === dl.FOLDER ? ["folder-icon"] : ["file-icon"];
  if (t) {
    let r;
    if (t.scheme === Ue.data)
      r = Bh.parseMetaData(t).get(Bh.META_DATA_LABEL);
    else {
      const a = t.path.match(rde);
      a ? (r = mC(a[2].toLowerCase()), a[1] && o.push(`${mC(a[1].toLowerCase())}-name-dir-icon`)) : r = mC(t.authority.toLowerCase());
    }
    if (n === dl.ROOT_FOLDER) o.push(`${r}-root-name-folder-icon`);
    else if (n === dl.FOLDER) o.push(`${r}-name-folder-icon`);
    else {
      if (r) {
        if (o.push(`${r}-name-file-icon`), o.push("name-file-icon"), r.length <= 255) {
          const l = r.split(".");
          for (let d = 1; d < l.length; d++) o.push(`${l.slice(d).join(".")}-ext-file-icon`);
        }
        o.push("ext-file-icon");
      }
      const a = function(l, d, h) {
        if (!h) return null;
        let c = null;
        if (h.scheme === Ue.data) {
          const u = Bh.parseMetaData(h).get(Bh.META_DATA_MIME);
          u && (c = d.getLanguageIdByMimeType(u));
        } else {
          const u = l.getModel(h);
          u && (c = u.getLanguageId());
        }
        return c && c !== ko ? c : d.guessLanguageIdByFilepathOrFirstLine(h);
      }(i, e, t);
      a && o.push(`${mC(a)}-lang-file-icon`);
    }
  }
  return o;
}
function mC(i) {
  return i.replace(/[\11\12\14\15\40]/g, "/");
}
var Jd, ade = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Yx = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
function iU(i) {
  return `suggest-aria-id:${i}`;
}
const lde = Ei("suggest-more-info", ne.chevronRight, m(0, "Icon for more information in the suggest widget.")), dde = new (Jd = class {
  extract(i, e) {
    if (i.textLabel.match(Jd._regexStrict)) return e[0] = i.textLabel, !0;
    if (i.completion.detail && i.completion.detail.match(Jd._regexStrict)) return e[0] = i.completion.detail, !0;
    if (i.completion.documentation) {
      const t = typeof i.completion.documentation == "string" ? i.completion.documentation : i.completion.documentation.value, n = Jd._regexRelaxed.exec(t);
      if (n && (n.index === 0 || n.index + n[0].length === t.length)) return e[0] = n[0], !0;
    }
    return !1;
  }
}, Jd._regexRelaxed = /(#([\da-fA-F]{3}){1,2}|(rgb|hsl)a\(\s*(\d{1,3}%?\s*,\s*){3}(1|0?\.\d+)\)|(rgb|hsl)\(\s*\d{1,3}%?(\s*,\s*\d{1,3}%?){2}\s*\))/, Jd._regexStrict = new RegExp(`^${Jd._regexRelaxed.source}$`, "i"), Jd)();
let rT = class {
  constructor(i, e, t, n) {
    this._editor = i, this._modelService = e, this._languageService = t, this._themeService = n, this._onDidToggleDetails = new F(), this.onDidToggleDetails = this._onDidToggleDetails.event, this.templateId = "suggestion";
  }
  dispose() {
    this._onDidToggleDetails.dispose();
  }
  renderTemplate(i) {
    const e = new G(), t = i;
    t.classList.add("show-file-icons");
    const n = Z(i, Q(".icon")), s = Z(n, Q("span.colorspan")), o = Z(i, Q(".contents")), r = Z(o, Q(".main")), a = Z(r, Q(".icon-label.codicon")), l = Z(r, Q("span.left")), d = Z(r, Q("span.right")), h = new Jy(l, { supportHighlights: !0, supportIcons: !0 });
    e.add(h);
    const c = Z(l, Q("span.signature-label")), u = Z(l, Q("span.qualifier-label")), g = Z(d, Q("span.details-label")), p = Z(d, Q("span.readMore" + Ee.asCSSSelector(lde)));
    return p.title = m(0, "Read More"), { root: t, left: l, right: d, icon: n, colorspan: s, iconLabel: h, iconContainer: a, parametersLabel: c, qualifierLabel: u, detailsLabel: g, readMore: p, disposables: e, configureFont: () => {
      const f = this._editor.getOptions(), _ = f.get(50), v = _.getMassagedFontFamily(), b = _.fontFeatureSettings, C = f.get(119) || _.fontSize, w = f.get(120) || _.lineHeight, y = _.fontWeight, L = `${C}px`, k = `${w}px`, N = `${_.letterSpacing}px`;
      t.style.fontSize = L, t.style.fontWeight = y, t.style.letterSpacing = N, r.style.fontFamily = v, r.style.fontFeatureSettings = b, r.style.lineHeight = k, n.style.height = k, n.style.width = k, p.style.height = k, p.style.width = k;
    } };
  }
  renderElement(i, e, t) {
    t.configureFont();
    const { completion: n } = i;
    t.root.id = iU(e), t.colorspan.style.backgroundColor = "";
    const s = { labelEscapeNewLines: !0, matches: T1(i.score) }, o = [];
    if (n.kind === 19 && dde.extract(i, o)) t.icon.className = "icon customcolor", t.iconContainer.className = "icon hide", t.colorspan.style.backgroundColor = o[0];
    else if (n.kind === 20 && this._themeService.getFileIconTheme().hasFileIcons) {
      t.icon.className = "icon hide", t.iconContainer.className = "icon hide";
      const r = pC(this._modelService, this._languageService, Ie.from({ scheme: "fake", path: i.textLabel }), dl.FILE), a = pC(this._modelService, this._languageService, Ie.from({ scheme: "fake", path: n.detail }), dl.FILE);
      s.extraClasses = r.length > a.length ? r : a;
    } else n.kind === 23 && this._themeService.getFileIconTheme().hasFolderIcons ? (t.icon.className = "icon hide", t.iconContainer.className = "icon hide", s.extraClasses = [pC(this._modelService, this._languageService, Ie.from({ scheme: "fake", path: i.textLabel }), dl.FOLDER), pC(this._modelService, this._languageService, Ie.from({ scheme: "fake", path: n.detail }), dl.FOLDER)].flat()) : (t.icon.className = "icon hide", t.iconContainer.className = "", t.iconContainer.classList.add("suggest-icon", ...Ee.asClassNameArray(Z0.toIcon(n.kind))));
    n.tags && n.tags.indexOf(1) >= 0 && (s.extraClasses = (s.extraClasses || []).concat(["deprecated"]), s.matches = []), t.iconLabel.setLabel(i.textLabel, void 0, s), typeof n.label == "string" ? (t.parametersLabel.textContent = "", t.detailsLabel.textContent = Xx(n.detail || ""), t.root.classList.add("string-label")) : (t.parametersLabel.textContent = Xx(n.label.detail || ""), t.detailsLabel.textContent = Xx(n.label.description || ""), t.root.classList.remove("string-label")), this._editor.getOption(118).showInlineDetails ? bo(t.detailsLabel) : Ts(t.detailsLabel), IP(i) ? (t.right.classList.add("can-expand-details"), bo(t.readMore), t.readMore.onmousedown = (r) => {
      r.stopPropagation(), r.preventDefault();
    }, t.readMore.onclick = (r) => {
      r.stopPropagation(), r.preventDefault(), this._onDidToggleDetails.fire();
    }) : (t.right.classList.remove("can-expand-details"), Ts(t.readMore), t.readMore.onmousedown = null, t.readMore.onclick = null);
  }
  disposeTemplate(i) {
    i.disposables.dispose();
  }
};
function Xx(i) {
  return i.replace(/\r\n|\r|\n/g, "");
}
rT = ade([Yx(1, ni), Yx(2, Xt), Yx(3, Yi)], rT);
var Cp, hde = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, fC = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
I("editorSuggestWidget.background", { dark: xi, light: xi, hcDark: xi, hcLight: xi }, m(0, "Background color of the suggest widget.")), I("editorSuggestWidget.border", { dark: dd, light: dd, hcDark: dd, hcLight: dd }, m(0, "Border color of the suggest widget."));
const _C = I("editorSuggestWidget.foreground", { dark: Go, light: Go, hcDark: Go, hcLight: Go }, m(0, "Foreground color of the suggest widget."));
I("editorSuggestWidget.selectedForeground", { dark: Ah, light: Ah, hcDark: Ah, hcLight: Ah }, m(0, "Foreground color of the selected entry in the suggest widget.")), I("editorSuggestWidget.selectedIconForeground", { dark: Pp, light: Pp, hcDark: Pp, hcLight: Pp }, m(0, "Icon foreground color of the selected entry in the suggest widget."));
const cde = I("editorSuggestWidget.selectedBackground", { dark: Ph, light: Ph, hcDark: Ph, hcLight: Ph }, m(0, "Background color of the selected entry in the suggest widget."));
I("editorSuggestWidget.highlightForeground", { dark: Cr, light: Cr, hcDark: Cr, hcLight: Cr }, m(0, "Color of the match highlights in the suggest widget.")), I("editorSuggestWidget.focusHighlightForeground", { dark: hb, light: hb, hcDark: hb, hcLight: hb }, m(0, "Color of the match highlights in the suggest widget when an item is focused.")), I("editorSuggestWidgetStatus.foreground", { dark: Ce(_C, 0.5), light: Ce(_C, 0.5), hcDark: Ce(_C, 0.5), hcLight: Ce(_C, 0.5) }, m(0, "Foreground color of the suggest widget status."));
class ude {
  constructor(e, t) {
    this._service = e, this._key = `suggestWidget.size/${t.getEditorType()}/${t instanceof Tc}`;
  }
  restore() {
    var e;
    const t = (e = this._service.get(this._key, 0)) !== null && e !== void 0 ? e : "";
    try {
      const n = JSON.parse(t);
      if (bt.is(n)) return bt.lift(n);
    } catch {
    }
  }
  store(e) {
    this._service.store(this._key, JSON.stringify(e), 0, 1);
  }
  reset() {
    this._service.remove(this._key, 0);
  }
}
let U_ = Cp = class {
  constructor(i, e, t, n, s) {
    this.editor = i, this._storageService = e, this._state = 0, this._isAuto = !1, this._pendingLayout = new rn(), this._pendingShowDetails = new rn(), this._ignoreFocusEvents = !1, this._forceRenderingAbove = !1, this._explainMode = !1, this._showTimeout = new Dr(), this._disposables = new G(), this._onDidSelect = new og(), this._onDidFocus = new og(), this._onDidHide = new F(), this._onDidShow = new F(), this.onDidSelect = this._onDidSelect.event, this.onDidFocus = this._onDidFocus.event, this.onDidHide = this._onDidHide.event, this.onDidShow = this._onDidShow.event, this._onDetailsKeydown = new F(), this.onDetailsKeyDown = this._onDetailsKeydown.event, this.element = new CP(), this.element.domNode.classList.add("editor-widget", "suggest-widget"), this._contentWidget = new gde(this, i), this._persistedSize = new ude(e, i);
    class o {
      constructor(u, g, p = !1, f = !1) {
        this.persistedSize = u, this.currentSize = g, this.persistHeight = p, this.persistWidth = f;
      }
    }
    let r;
    this._disposables.add(this.element.onDidWillResize(() => {
      this._contentWidget.lockPreference(), r = new o(this._persistedSize.restore(), this.element.size);
    })), this._disposables.add(this.element.onDidResize((c) => {
      var u, g, p, f;
      if (this._resize(c.dimension.width, c.dimension.height), r && (r.persistHeight = r.persistHeight || !!c.north || !!c.south, r.persistWidth = r.persistWidth || !!c.east || !!c.west), c.done) {
        if (r) {
          const { itemHeight: _, defaultSize: v } = this.getLayoutInfo(), b = Math.round(_ / 2);
          let { width: C, height: w } = this.element.size;
          (!r.persistHeight || Math.abs(r.currentSize.height - w) <= b) && (w = (g = (u = r.persistedSize) === null || u === void 0 ? void 0 : u.height) !== null && g !== void 0 ? g : v.height), (!r.persistWidth || Math.abs(r.currentSize.width - C) <= b) && (C = (f = (p = r.persistedSize) === null || p === void 0 ? void 0 : p.width) !== null && f !== void 0 ? f : v.width), this._persistedSize.store(new bt(C, w));
        }
        this._contentWidget.unlockPreference(), r = void 0;
      }
    })), this._messageElement = Z(this.element.domNode, Q(".message")), this._listElement = Z(this.element.domNode, Q(".tree"));
    const a = this._disposables.add(s.createInstance(oT, this.editor));
    a.onDidClose(this.toggleDetails, this, this._disposables), this._details = new ode(a, this.editor);
    const l = () => this.element.domNode.classList.toggle("no-icons", !this.editor.getOption(118).showIcons);
    l();
    const d = s.createInstance(rT, this.editor);
    this._disposables.add(d), this._disposables.add(d.onDidToggleDetails(() => this.toggleDetails())), this._list = new uo("SuggestWidget", this._listElement, { getHeight: (c) => this.getLayoutInfo().itemHeight, getTemplateId: (c) => "suggestion" }, [d], { alwaysConsumeMouseWheel: !0, useShadows: !1, mouseSupport: !1, multipleSelectionSupport: !1, accessibilityProvider: { getRole: () => "option", getWidgetAriaLabel: () => m(0, "Suggest"), getWidgetRole: () => "listbox", getAriaLabel: (c) => {
      let u = c.textLabel;
      if (typeof c.completion.label != "string") {
        const { detail: f, description: _ } = c.completion.label;
        f && _ ? u = m(0, "{0} {1}, {2}", u, f, _) : f ? u = m(0, "{0} {1}", u, f) : _ && (u = m(0, "{0}, {1}", u, _));
      }
      if (!c.isResolved || !this._isDetailsVisible()) return u;
      const { documentation: g, detail: p } = c.completion;
      return m(0, "{0}, docs: {1}", u, rg("{0}{1}", p || "", g ? typeof g == "string" ? g : g.value : ""));
    } } }), this._list.style(Rg({ listInactiveFocusBackground: cde, listInactiveFocusOutline: Zt })), this._status = s.createInstance(sT, this.element.domNode, hh);
    const h = () => this.element.domNode.classList.toggle("with-status-bar", this.editor.getOption(118).showStatusBar);
    h(), this._disposables.add(n.onDidColorThemeChange((c) => this._onThemeChange(c))), this._onThemeChange(n.getColorTheme()), this._disposables.add(this._list.onMouseDown((c) => this._onListMouseDownOrTap(c))), this._disposables.add(this._list.onTap((c) => this._onListMouseDownOrTap(c))), this._disposables.add(this._list.onDidChangeSelection((c) => this._onListSelection(c))), this._disposables.add(this._list.onDidChangeFocus((c) => this._onListFocus(c))), this._disposables.add(this.editor.onDidChangeCursorSelection(() => this._onCursorSelectionChanged())), this._disposables.add(this.editor.onDidChangeConfiguration((c) => {
      c.hasChanged(118) && (h(), l()), this._completionModel && (c.hasChanged(50) || c.hasChanged(119) || c.hasChanged(120)) && this._list.splice(0, this._list.length, this._completionModel.items);
    })), this._ctxSuggestWidgetVisible = $e.Visible.bindTo(t), this._ctxSuggestWidgetDetailsVisible = $e.DetailsVisible.bindTo(t), this._ctxSuggestWidgetMultipleSuggestions = $e.MultipleSuggestions.bindTo(t), this._ctxSuggestWidgetHasFocusedSuggestion = $e.HasFocusedSuggestion.bindTo(t), this._disposables.add(bi(this._details.widget.domNode, "keydown", (c) => {
      this._onDetailsKeydown.fire(c);
    })), this._disposables.add(this.editor.onMouseDown((c) => this._onEditorMouseDown(c)));
  }
  dispose() {
    var i;
    this._details.widget.dispose(), this._details.dispose(), this._list.dispose(), this._status.dispose(), this._disposables.dispose(), (i = this._loadingTimeout) === null || i === void 0 || i.dispose(), this._pendingLayout.dispose(), this._pendingShowDetails.dispose(), this._showTimeout.dispose(), this._contentWidget.dispose(), this.element.dispose();
  }
  _onEditorMouseDown(i) {
    this._details.widget.domNode.contains(i.target.element) ? this._details.widget.domNode.focus() : this.element.domNode.contains(i.target.element) && this.editor.focus();
  }
  _onCursorSelectionChanged() {
    this._state !== 0 && this._contentWidget.layout();
  }
  _onListMouseDownOrTap(i) {
    i.element !== void 0 && i.index !== void 0 && (i.browserEvent.preventDefault(), i.browserEvent.stopPropagation(), this._select(i.element, i.index));
  }
  _onListSelection(i) {
    i.elements.length && this._select(i.elements[0], i.indexes[0]);
  }
  _select(i, e) {
    const t = this._completionModel;
    t && (this._onDidSelect.fire({ item: i, index: e, model: t }), this.editor.focus());
  }
  _onThemeChange(i) {
    this._details.widget.borderWidth = la(i.type) ? 2 : 1;
  }
  _onListFocus(i) {
    var e;
    if (this._ignoreFocusEvents) return;
    if (!i.elements.length) return this._currentSuggestionDetails && (this._currentSuggestionDetails.cancel(), this._currentSuggestionDetails = void 0, this._focusedItem = void 0), this.editor.setAriaOptions({ activeDescendant: void 0 }), void this._ctxSuggestWidgetHasFocusedSuggestion.set(!1);
    if (!this._completionModel) return;
    this._ctxSuggestWidgetHasFocusedSuggestion.set(!0);
    const t = i.elements[0], n = i.indexes[0];
    t !== this._focusedItem && ((e = this._currentSuggestionDetails) === null || e === void 0 || e.cancel(), this._currentSuggestionDetails = void 0, this._focusedItem = t, this._list.reveal(n), this._currentSuggestionDetails = on(async (s) => {
      const o = Cc(() => {
        this._isDetailsVisible() && this.showDetails(!0);
      }, 250), r = s.onCancellationRequested(() => o.dispose());
      try {
        return await t.resolve(s);
      } finally {
        o.dispose(), r.dispose();
      }
    }), this._currentSuggestionDetails.then(() => {
      n >= this._list.length || t !== this._list.element(n) || (this._ignoreFocusEvents = !0, this._list.splice(n, 1, [t]), this._list.setFocus([n]), this._ignoreFocusEvents = !1, this._isDetailsVisible() ? this.showDetails(!1) : this.element.domNode.classList.remove("docs-side"), this.editor.setAriaOptions({ activeDescendant: iU(n) }));
    }).catch(We)), this._onDidFocus.fire({ item: t, index: n, model: this._completionModel });
  }
  _setState(i) {
    if (this._state !== i) switch (this._state = i, this.element.domNode.classList.toggle("frozen", i === 4), this.element.domNode.classList.remove("message"), i) {
      case 0:
        Ts(this._messageElement, this._listElement, this._status.element), this._details.hide(!0), this._status.hide(), this._contentWidget.hide(), this._ctxSuggestWidgetVisible.reset(), this._ctxSuggestWidgetMultipleSuggestions.reset(), this._ctxSuggestWidgetHasFocusedSuggestion.reset(), this._showTimeout.cancel(), this.element.domNode.classList.remove("visible"), this._list.splice(0, this._list.length), this._focusedItem = void 0, this._cappedHeight = void 0, this._explainMode = !1;
        break;
      case 1:
        this.element.domNode.classList.add("message"), this._messageElement.textContent = Cp.LOADING_MESSAGE, Ts(this._listElement, this._status.element), bo(this._messageElement), this._details.hide(), this._show(), this._focusedItem = void 0, vl(Cp.LOADING_MESSAGE);
        break;
      case 2:
        this.element.domNode.classList.add("message"), this._messageElement.textContent = Cp.NO_SUGGESTIONS_MESSAGE, Ts(this._listElement, this._status.element), bo(this._messageElement), this._details.hide(), this._show(), this._focusedItem = void 0, vl(Cp.NO_SUGGESTIONS_MESSAGE);
        break;
      case 3:
      case 4:
        Ts(this._messageElement), bo(this._listElement, this._status.element), this._show();
        break;
      case 5:
        Ts(this._messageElement), bo(this._listElement, this._status.element), this._details.show(), this._show();
    }
  }
  _show() {
    this._status.show(), this._contentWidget.show(), this._layout(this._persistedSize.restore()), this._ctxSuggestWidgetVisible.set(!0), this._showTimeout.cancelAndSet(() => {
      this.element.domNode.classList.add("visible"), this._onDidShow.fire(this);
    }, 100);
  }
  showTriggered(i, e) {
    this._state === 0 && (this._contentWidget.setPosition(this.editor.getPosition()), this._isAuto = !!i, this._isAuto || (this._loadingTimeout = Cc(() => this._setState(1), e)));
  }
  showSuggestions(i, e, t, n, s) {
    var o, r;
    if (this._contentWidget.setPosition(this.editor.getPosition()), (o = this._loadingTimeout) === null || o === void 0 || o.dispose(), (r = this._currentSuggestionDetails) === null || r === void 0 || r.cancel(), this._currentSuggestionDetails = void 0, this._completionModel !== i && (this._completionModel = i), t && this._state !== 2 && this._state !== 0) return void this._setState(4);
    const a = this._completionModel.items.length, l = a === 0;
    if (this._ctxSuggestWidgetMultipleSuggestions.set(a > 1), l) return this._setState(n ? 0 : 2), void (this._completionModel = void 0);
    this._focusedItem = void 0, this._onDidFocus.pause(), this._onDidSelect.pause();
    try {
      this._list.splice(0, this._list.length, this._completionModel.items), this._setState(t ? 4 : 3), this._list.reveal(e, 0), this._list.setFocus(s ? [] : [e]);
    } finally {
      this._onDidFocus.resume(), this._onDidSelect.resume();
    }
    this._pendingLayout.value = qw(ke(this.element.domNode), () => {
      this._pendingLayout.clear(), this._layout(this.element.size), this._details.widget.domNode.classList.remove("focused");
    });
  }
  focusSelected() {
    this._list.length > 0 && this._list.setFocus([0]);
  }
  selectNextPage() {
    switch (this._state) {
      case 0:
        return !1;
      case 5:
        return this._details.widget.pageDown(), !0;
      case 1:
        return !this._isAuto;
      default:
        return this._list.focusNextPage(), !0;
    }
  }
  selectNext() {
    switch (this._state) {
      case 0:
        return !1;
      case 1:
        return !this._isAuto;
      default:
        return this._list.focusNext(1, !0), !0;
    }
  }
  selectLast() {
    switch (this._state) {
      case 0:
        return !1;
      case 5:
        return this._details.widget.scrollBottom(), !0;
      case 1:
        return !this._isAuto;
      default:
        return this._list.focusLast(), !0;
    }
  }
  selectPreviousPage() {
    switch (this._state) {
      case 0:
        return !1;
      case 5:
        return this._details.widget.pageUp(), !0;
      case 1:
        return !this._isAuto;
      default:
        return this._list.focusPreviousPage(), !0;
    }
  }
  selectPrevious() {
    switch (this._state) {
      case 0:
        return !1;
      case 1:
        return !this._isAuto;
      default:
        return this._list.focusPrevious(1, !0), !1;
    }
  }
  selectFirst() {
    switch (this._state) {
      case 0:
        return !1;
      case 5:
        return this._details.widget.scrollTop(), !0;
      case 1:
        return !this._isAuto;
      default:
        return this._list.focusFirst(), !0;
    }
  }
  getFocusedItem() {
    if (this._state !== 0 && this._state !== 2 && this._state !== 1 && this._completionModel && this._list.getFocus().length > 0) return { item: this._list.getFocusedElements()[0], index: this._list.getFocus()[0], model: this._completionModel };
  }
  toggleDetailsFocus() {
    this._state === 5 ? (this._setState(3), this._details.widget.domNode.classList.remove("focused")) : this._state === 3 && this._isDetailsVisible() && (this._setState(5), this._details.widget.domNode.classList.add("focused"));
  }
  toggleDetails() {
    this._isDetailsVisible() ? (this._pendingShowDetails.clear(), this._ctxSuggestWidgetDetailsVisible.set(!1), this._setDetailsVisible(!1), this._details.hide(), this.element.domNode.classList.remove("shows-details")) : !IP(this._list.getFocusedElements()[0]) && !this._explainMode || this._state !== 3 && this._state !== 5 && this._state !== 4 || (this._ctxSuggestWidgetDetailsVisible.set(!0), this._setDetailsVisible(!0), this.showDetails(!1));
  }
  showDetails(i) {
    this._pendingShowDetails.value = qw(ke(this.element.domNode), () => {
      this._pendingShowDetails.clear(), this._details.show(), i ? this._details.widget.renderLoading() : this._details.widget.renderItem(this._list.getFocusedElements()[0], this._explainMode), this._details.widget.isEmpty ? this._details.hide() : (this._positionDetails(), this.element.domNode.classList.add("shows-details")), this.editor.focus();
    });
  }
  toggleExplainMode() {
    this._list.getFocusedElements()[0] && (this._explainMode = !this._explainMode, this._isDetailsVisible() ? this.showDetails(!1) : this.toggleDetails());
  }
  resetPersistedSize() {
    this._persistedSize.reset();
  }
  hideWidget() {
    var i;
    this._pendingLayout.clear(), this._pendingShowDetails.clear(), (i = this._loadingTimeout) === null || i === void 0 || i.dispose(), this._setState(0), this._onDidHide.fire(this), this.element.clearSashHoverState();
    const e = this._persistedSize.restore(), t = Math.ceil(4.3 * this.getLayoutInfo().itemHeight);
    e && e.height < t && this._persistedSize.store(e.with(void 0, t));
  }
  isFrozen() {
    return this._state === 4;
  }
  _afterRender(i) {
    i !== null ? this._state !== 2 && this._state !== 1 && (this._isDetailsVisible() && !this._details.widget.isEmpty && this._details.show(), this._positionDetails()) : this._isDetailsVisible() && this._details.hide();
  }
  _layout(i) {
    var e, t, n;
    if (!this.editor.hasModel() || !this.editor.getDomNode()) return;
    const s = wc(this.element.domNode.ownerDocument.body), o = this.getLayoutInfo();
    i || (i = o.defaultSize);
    let r = i.height, a = i.width;
    if (this._status.element.style.height = `${o.itemHeight}px`, this._state === 2 || this._state === 1) r = o.itemHeight + o.borderHeight, a = o.defaultSize.width / 2, this.element.enableSashes(!1, !1, !1, !1), this.element.minSize = this.element.maxSize = new bt(a, r), this._contentWidget.setPreference(2);
    else {
      const l = s.width - o.borderHeight - 2 * o.horizontalPadding;
      a > l && (a = l);
      const d = this._completionModel ? this._completionModel.stats.pLabelLen * o.typicalHalfwidthCharacterWidth : a, h = o.statusBarHeight + this._list.contentHeight + o.borderHeight, c = o.itemHeight + o.statusBarHeight, u = Ti(this.editor.getDomNode()), g = this.editor.getScrolledVisiblePosition(this.editor.getPosition()), p = u.top + g.top + g.height, f = Math.min(s.height - p - o.verticalPadding, h), _ = u.top + g.top - o.verticalPadding, v = Math.min(_, h);
      let b = Math.min(Math.max(v, f) + o.borderHeight, h);
      r === ((e = this._cappedHeight) === null || e === void 0 ? void 0 : e.capped) && (r = this._cappedHeight.wanted), r < c && (r = c), r > b && (r = b), r > f || this._forceRenderingAbove && _ > 150 ? (this._contentWidget.setPreference(1), this.element.enableSashes(!0, !0, !1, !1), b = v) : (this._contentWidget.setPreference(2), this.element.enableSashes(!1, !0, !0, !1), b = f), this.element.preferredSize = new bt(d, o.defaultSize.height), this.element.maxSize = new bt(l, b), this.element.minSize = new bt(220, c), this._cappedHeight = r === h ? { wanted: (n = (t = this._cappedHeight) === null || t === void 0 ? void 0 : t.wanted) !== null && n !== void 0 ? n : i.height, capped: r } : void 0;
    }
    this._resize(a, r);
  }
  _resize(i, e) {
    const { width: t, height: n } = this.element.maxSize;
    i = Math.min(t, i), e = Math.min(n, e);
    const { statusBarHeight: s } = this.getLayoutInfo();
    this._list.layout(e - s, i), this._listElement.style.height = e - s + "px", this.element.layout(e, i), this._contentWidget.layout(), this._positionDetails();
  }
  _positionDetails() {
    var i;
    this._isDetailsVisible() && this._details.placeAtAnchor(this.element.domNode, ((i = this._contentWidget.getPosition()) === null || i === void 0 ? void 0 : i.preference[0]) === 2);
  }
  getLayoutInfo() {
    const i = this.editor.getOption(50), e = as(this.editor.getOption(120) || i.lineHeight, 8, 1e3), t = this.editor.getOption(118).showStatusBar && this._state !== 2 && this._state !== 1 ? e : 0, n = this._details.widget.borderWidth, s = 2 * n;
    return { itemHeight: e, statusBarHeight: t, borderWidth: n, borderHeight: s, typicalHalfwidthCharacterWidth: i.typicalHalfwidthCharacterWidth, verticalPadding: 22, horizontalPadding: 14, defaultSize: new bt(430, t + 12 * e + s) };
  }
  _isDetailsVisible() {
    return this._storageService.getBoolean("expandSuggestionDocs", 0, !1);
  }
  _setDetailsVisible(i) {
    this._storageService.store("expandSuggestionDocs", i, 0, 0);
  }
  forceRenderingAbove() {
    this._forceRenderingAbove || (this._forceRenderingAbove = !0, this._layout(this._persistedSize.restore()));
  }
  stopForceRenderingAbove() {
    this._forceRenderingAbove = !1;
  }
};
U_.LOADING_MESSAGE = m(0, "Loading..."), U_.NO_SUGGESTIONS_MESSAGE = m(0, "No suggestions."), U_ = Cp = hde([fC(1, Nr), fC(2, Te), fC(3, Yi), fC(4, Se)], U_);
class gde {
  constructor(e, t) {
    this._widget = e, this._editor = t, this.allowEditorOverflow = !0, this.suppressMouseDown = !1, this._preferenceLocked = !1, this._added = !1, this._hidden = !1;
  }
  dispose() {
    this._added && (this._added = !1, this._editor.removeContentWidget(this));
  }
  getId() {
    return "editor.widget.suggestWidget";
  }
  getDomNode() {
    return this._widget.element.domNode;
  }
  show() {
    this._hidden = !1, this._added || (this._added = !0, this._editor.addContentWidget(this));
  }
  hide() {
    this._hidden || (this._hidden = !0, this.layout());
  }
  layout() {
    this._editor.layoutContentWidget(this);
  }
  getPosition() {
    return !this._hidden && this._position && this._preference ? { position: this._position, preference: [this._preference] } : null;
  }
  beforeRender() {
    const { height: e, width: t } = this._widget.element.size, { borderWidth: n, horizontalPadding: s } = this._widget.getLayoutInfo();
    return new bt(t + 2 * n + s, e + 2 * n);
  }
  afterRender(e) {
    this._widget._afterRender(e);
  }
  setPreference(e) {
    this._preferenceLocked || (this._preference = e);
  }
  lockPreference() {
    this._preferenceLocked = !0;
  }
  unlockPreference() {
    this._preferenceLocked = !1;
  }
  setPosition(e) {
    this._position = e;
  }
}
var aT, pde = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, dp = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class mde {
  constructor(e, t) {
    if (this._model = e, this._position = t, this._decorationOptions = Ve.register({ description: "suggest-line-suffix", stickiness: 1 }), e.getLineMaxColumn(t.lineNumber) !== t.column) {
      const n = e.getOffsetAt(t), s = e.getPositionAt(n + 1);
      e.changeDecorations((o) => {
        this._marker && o.removeDecoration(this._marker), this._marker = o.addDecoration(D.fromPositions(t, s), this._decorationOptions);
      });
    }
  }
  dispose() {
    this._marker && !this._model.isDisposed() && this._model.changeDecorations((e) => {
      e.removeDecoration(this._marker), this._marker = void 0;
    });
  }
  delta(e) {
    if (this._model.isDisposed() || this._position.lineNumber !== e.lineNumber) return 0;
    if (this._marker) {
      const t = this._model.getDecorationRange(this._marker);
      return this._model.getOffsetAt(t.getStartPosition()) - this._model.getOffsetAt(e);
    }
    return this._model.getLineMaxColumn(e.lineNumber) - e.column;
  }
}
let wr = aT = class {
  static get(i) {
    return i.getContribution(aT.ID);
  }
  constructor(i, e, t, n, s, o, r) {
    this._memoryService = e, this._commandService = t, this._contextKeyService = n, this._instantiationService = s, this._logService = o, this._telemetryService = r, this._lineSuffix = new rn(), this._toDispose = new G(), this._selectors = new fde((h) => h.priority), this._onWillInsertSuggestItem = new F(), this.onWillInsertSuggestItem = this._onWillInsertSuggestItem.event, this.editor = i, this.model = s.createInstance(NS, this.editor), this._selectors.register({ priority: 0, select: (h, c, u) => this._memoryService.select(h, c, u) });
    const a = $e.InsertMode.bindTo(n);
    a.set(i.getOption(118).insertMode), this._toDispose.add(this.model.onDidTrigger(() => a.set(i.getOption(118).insertMode))), this.widget = this._toDispose.add(new jk(ke(i.getDomNode()), () => {
      const h = this._instantiationService.createInstance(U_, this.editor);
      this._toDispose.add(h), this._toDispose.add(h.onDidSelect((f) => this._insertSuggestion(f, 0), this));
      const c = new Jle(this.editor, h, this.model, (f) => this._insertSuggestion(f, 2));
      this._toDispose.add(c);
      const u = $e.MakesTextEdit.bindTo(this._contextKeyService), g = $e.HasInsertAndReplaceRange.bindTo(this._contextKeyService), p = $e.CanResolve.bindTo(this._contextKeyService);
      return this._toDispose.add(ye(() => {
        u.reset(), g.reset(), p.reset();
      })), this._toDispose.add(h.onDidFocus(({ item: f }) => {
        const _ = this.editor.getPosition(), v = f.editStart.column, b = _.column;
        let C = !0;
        this.editor.getOption(1) !== "smart" || this.model.state !== 2 || f.completion.additionalTextEdits || 4 & f.completion.insertTextRules || b - v !== f.completion.insertText.length || (C = this.editor.getModel().getValueInRange({ startLineNumber: _.lineNumber, startColumn: v, endLineNumber: _.lineNumber, endColumn: b }) !== f.completion.insertText), u.set(C), g.set(!W.equals(f.editInsertEnd, f.editReplaceEnd)), p.set(!!f.provider.resolveCompletionItem || !!f.completion.documentation || f.completion.detail !== f.completion.label);
      })), this._toDispose.add(h.onDetailsKeyDown((f) => {
        f.toKeyCodeChord().equals(new Od(!0, !1, !1, !1, 33)) || Je && f.toKeyCodeChord().equals(new Od(!1, !1, !1, !0, 33)) ? f.stopPropagation() : f.toKeyCodeChord().isModifierKey() || this.editor.focus();
      })), h;
    })), this._overtypingCapturer = this._toDispose.add(new jk(ke(i.getDomNode()), () => this._toDispose.add(new lk(this.editor, this.model)))), this._alternatives = this._toDispose.add(new jk(ke(i.getDomNode()), () => this._toDispose.add(new ig(this.editor, this._contextKeyService)))), this._toDispose.add(s.createInstance(R0, i)), this._toDispose.add(this.model.onDidTrigger((h) => {
      this.widget.value.showTriggered(h.auto, h.shy ? 250 : 50), this._lineSuffix.value = new mde(this.editor.getModel(), h.position);
    })), this._toDispose.add(this.model.onDidSuggest((h) => {
      if (h.triggerOptions.shy) return;
      let c = -1;
      for (const g of this._selectors.itemsOrderedByPriorityDesc) if (c = g.select(this.editor.getModel(), this.editor.getPosition(), h.completionModel.items), c !== -1) break;
      if (c === -1 && (c = 0), this.model.state === 0) return;
      let u = !1;
      if (h.triggerOptions.auto) {
        const g = this.editor.getOption(118);
        g.selectionMode === "never" || g.selectionMode === "always" ? u = g.selectionMode === "never" : g.selectionMode === "whenTriggerCharacter" ? u = h.triggerOptions.triggerKind !== 1 : g.selectionMode === "whenQuickSuggestion" && (u = h.triggerOptions.triggerKind === 1 && !h.triggerOptions.refilter);
      }
      this.widget.value.showSuggestions(h.completionModel, c, h.isFrozen, h.triggerOptions.auto, u);
    })), this._toDispose.add(this.model.onDidCancel((h) => {
      h.retrigger || this.widget.value.hideWidget();
    })), this._toDispose.add(this.editor.onDidBlurEditorWidget(() => {
      this.model.cancel(), this.model.clear();
    }));
    const l = $e.AcceptSuggestionsOnEnter.bindTo(n), d = () => {
      const h = this.editor.getOption(1);
      l.set(h === "on" || h === "smart");
    };
    this._toDispose.add(this.editor.onDidChangeConfiguration(() => d())), d();
  }
  dispose() {
    this._alternatives.dispose(), this._toDispose.dispose(), this.widget.dispose(), this.model.dispose(), this._lineSuffix.dispose(), this._onWillInsertSuggestItem.dispose();
  }
  _insertSuggestion(i, e) {
    if (!i || !i.item) return this._alternatives.value.reset(), this.model.cancel(), void this.model.clear();
    if (!this.editor.hasModel()) return;
    const t = _n.get(this.editor);
    if (!t) return;
    this._onWillInsertSuggestItem.fire({ item: i.item });
    const n = this.editor.getModel(), s = n.getAlternativeVersionId(), { item: o } = i, r = [], a = new Ci();
    1 & e || this.editor.pushUndoStop();
    const l = this.getOverwriteInfo(o, !!(8 & e));
    this._memoryService.memorize(n, this.editor.getPosition(), o);
    const d = o.isResolved;
    let h = -1, c = -1;
    if (Array.isArray(o.completion.additionalTextEdits)) {
      this.model.cancel();
      const g = ya.capture(this.editor);
      this.editor.executeEdits("suggestController.additionalTextEdits.sync", o.completion.additionalTextEdits.map((p) => {
        let f = D.lift(p.range);
        if (f.startLineNumber === o.position.lineNumber && f.startColumn > o.position.column) {
          const _ = this.editor.getPosition().column - o.position.column, v = _, b = D.spansMultipleLines(f) ? 0 : _;
          f = new D(f.startLineNumber, f.startColumn + v, f.endLineNumber, f.endColumn + b);
        }
        return ii.replaceMove(f, p.text);
      })), g.restoreRelativeVerticalPositionOfCursor(this.editor);
    } else if (!d) {
      const g = new Rn();
      let p;
      const f = n.onDidChangeContent((C) => {
        if (C.isFlush) return a.cancel(), void f.dispose();
        for (const w of C.changes) {
          const y = D.getEndPosition(w.range);
          p && !W.isBefore(y, p) || (p = y);
        }
      }), _ = e;
      e |= 2;
      let v = !1;
      const b = this.editor.onWillType(() => {
        b.dispose(), v = !0, 2 & _ || this.editor.pushUndoStop();
      });
      r.push(o.resolve(a.token).then(() => {
        if (!o.completion.additionalTextEdits || a.token.isCancellationRequested) return;
        if (p && o.completion.additionalTextEdits.some((w) => W.isBefore(p, D.getStartPosition(w.range)))) return !1;
        v && this.editor.pushUndoStop();
        const C = ya.capture(this.editor);
        return this.editor.executeEdits("suggestController.additionalTextEdits.async", o.completion.additionalTextEdits.map((w) => ii.replaceMove(D.lift(w.range), w.text))), C.restoreRelativeVerticalPositionOfCursor(this.editor), !v && 2 & _ || this.editor.pushUndoStop(), !0;
      }).then((C) => {
        this._logService.trace("[suggest] async resolving of edits DONE (ms, applied?)", g.elapsed(), C), c = C === !0 ? 1 : C === !1 ? 0 : -2;
      }).finally(() => {
        f.dispose(), b.dispose();
      }));
    }
    let { insertText: u } = o.completion;
    if (4 & o.completion.insertTextRules || (u = wg.escape(u)), this.model.cancel(), t.insert(u, { overwriteBefore: l.overwriteBefore, overwriteAfter: l.overwriteAfter, undoStopBefore: !1, undoStopAfter: !1, adjustWhitespace: !(1 & o.completion.insertTextRules), clipboardText: i.model.clipboardText, overtypingCapturer: this._overtypingCapturer.value }), 2 & e || this.editor.pushUndoStop(), o.completion.command) if (o.completion.command.id === r1.id) this.model.trigger({ auto: !0, retrigger: !0 });
    else {
      const g = new Rn();
      r.push(this._commandService.executeCommand(o.completion.command.id, ...o.completion.command.arguments ? [...o.completion.command.arguments] : []).catch((p) => {
        o.completion.extensionId ? Ni(p) : We(p);
      }).finally(() => {
        h = g.elapsed();
      }));
    }
    4 & e && this._alternatives.value.set(i, (g) => {
      for (a.cancel(); n.canUndo(); ) {
        s !== n.getAlternativeVersionId() && n.undo(), this._insertSuggestion(g, 3 | (8 & e ? 8 : 0));
        break;
      }
    }), this._alertCompletionItem(o), Promise.all(r).finally(() => {
      this._reportSuggestionAcceptedTelemetry(o, n, d, h, c), this.model.clear(), a.dispose();
    });
  }
  _reportSuggestionAcceptedTelemetry(i, e, t, n, s) {
    var o, r, a;
    Math.floor(100 * Math.random()) !== 0 && this._telemetryService.publicLog2("suggest.acceptedSuggestion", { extensionId: (r = (o = i.extensionId) === null || o === void 0 ? void 0 : o.value) !== null && r !== void 0 ? r : "unknown", providerId: (a = i.provider._debugDisplayName) !== null && a !== void 0 ? a : "unknown", kind: i.completion.kind, basenameHash: WS(ir(e.uri)).toString(16), languageId: e.getLanguageId(), fileExtension: LX(e.uri), resolveInfo: i.provider.resolveCompletionItem ? t ? 1 : 0 : -1, resolveDuration: i.resolveDuration, commandDuration: n, additionalEditsAsync: s });
  }
  getOverwriteInfo(i, e) {
    vt(this.editor.hasModel());
    let t = this.editor.getOption(118).insertMode === "replace";
    e && (t = !t);
    const n = i.position.column - i.editStart.column, s = (t ? i.editReplaceEnd.column : i.editInsertEnd.column) - i.position.column;
    return { overwriteBefore: n + (this.editor.getPosition().column - i.position.column), overwriteAfter: s + (this._lineSuffix.value ? this._lineSuffix.value.delta(this.editor.getPosition()) : 0) };
  }
  _alertCompletionItem(i) {
    zn(i.completion.additionalTextEdits) && Io(m(0, "Accepting '{0}' made {1} additional edits", i.textLabel, i.completion.additionalTextEdits.length));
  }
  triggerSuggest(i, e, t) {
    this.editor.hasModel() && (this.model.trigger({ auto: e != null && e, completionOptions: { providerFilter: i, kindFilter: t ? /* @__PURE__ */ new Set() : void 0 } }), this.editor.revealPosition(this.editor.getPosition(), 0), this.editor.focus());
  }
  triggerSuggestAndAcceptBest(i) {
    if (!this.editor.hasModel()) return;
    const e = this.editor.getPosition(), t = () => {
      e.equals(this.editor.getPosition()) && this._commandService.executeCommand(i.fallback);
    }, n = (s) => {
      if (4 & s.completion.insertTextRules || s.completion.additionalTextEdits) return !0;
      const o = this.editor.getPosition(), r = s.editStart.column, a = o.column;
      return a - r !== s.completion.insertText.length ? !0 : this.editor.getModel().getValueInRange({ startLineNumber: o.lineNumber, startColumn: r, endLineNumber: o.lineNumber, endColumn: a }) !== s.completion.insertText;
    };
    se.once(this.model.onDidTrigger)((s) => {
      const o = [];
      se.any(this.model.onDidTrigger, this.model.onDidCancel)(() => {
        Ht(o), t();
      }, void 0, o), this.model.onDidSuggest(({ completionModel: r }) => {
        if (Ht(o), r.items.length === 0) return void t();
        const a = this._memoryService.select(this.editor.getModel(), this.editor.getPosition(), r.items), l = r.items[a];
        n(l) ? (this.editor.pushUndoStop(), this._insertSuggestion({ index: a, item: l, model: r }, 7)) : t();
      }, void 0, o);
    }), this.model.trigger({ auto: !1, shy: !0 }), this.editor.revealPosition(e, 0), this.editor.focus();
  }
  acceptSelectedSuggestion(i, e) {
    const t = this.widget.value.getFocusedItem();
    let n = 0;
    i && (n |= 4), e && (n |= 8), this._insertSuggestion(t, n);
  }
  acceptNextSuggestion() {
    this._alternatives.value.next();
  }
  acceptPrevSuggestion() {
    this._alternatives.value.prev();
  }
  cancelSuggestWidget() {
    this.model.cancel(), this.model.clear(), this.widget.value.hideWidget();
  }
  focusSuggestion() {
    this.widget.value.focusSelected();
  }
  selectNextSuggestion() {
    this.widget.value.selectNext();
  }
  selectNextPageSuggestion() {
    this.widget.value.selectNextPage();
  }
  selectLastSuggestion() {
    this.widget.value.selectLast();
  }
  selectPrevSuggestion() {
    this.widget.value.selectPrevious();
  }
  selectPrevPageSuggestion() {
    this.widget.value.selectPreviousPage();
  }
  selectFirstSuggestion() {
    this.widget.value.selectFirst();
  }
  toggleSuggestionDetails() {
    this.widget.value.toggleDetails();
  }
  toggleExplainMode() {
    this.widget.value.toggleExplainMode();
  }
  toggleSuggestionFocus() {
    this.widget.value.toggleDetailsFocus();
  }
  resetWidgetSize() {
    this.widget.value.resetPersistedSize();
  }
  forceRenderingAbove() {
    this.widget.value.forceRenderingAbove();
  }
  stopForceRenderingAbove() {
    this.widget.isInitialized && this.widget.value.stopForceRenderingAbove();
  }
  registerSelector(i) {
    return this._selectors.register(i);
  }
};
wr.ID = "editor.contrib.suggestController", wr = aT = pde([dp(1, ak), dp(2, ai), dp(3, Te), dp(4, Se), dp(5, ts), dp(6, es)], wr);
class fde {
  constructor(e) {
    this.prioritySelector = e, this._items = new Array();
  }
  register(e) {
    if (this._items.indexOf(e) !== -1) throw new Error("Value is already registered");
    return this._items.push(e), this._items.sort((t, n) => this.prioritySelector(n) - this.prioritySelector(t)), { dispose: () => {
      const t = this._items.indexOf(e);
      t >= 0 && this._items.splice(t, 1);
    } };
  }
  get itemsOrderedByPriorityDesc() {
    return this._items;
  }
}
class r1 extends he {
  constructor() {
    super({ id: r1.id, label: m(0, "Trigger Suggest"), alias: "Trigger Suggest", precondition: q.and(E.writable, E.hasCompletionItemProvider, $e.Visible.toNegated()), kbOpts: { kbExpr: E.textInputFocus, primary: 2058, secondary: [2087], mac: { primary: 266, secondary: [521, 2087] }, weight: 100 } });
  }
  run(e, t, n) {
    const s = wr.get(t);
    if (!s) return;
    let o;
    n && typeof n == "object" && n.auto === !0 && (o = !0), s.triggerSuggest(void 0, o, void 0);
  }
}
r1.id = "editor.action.triggerSuggest", ft(wr.ID, wr, 2), X(r1);
const no = 190, ns = Zi.bindToContribution(wr.get);
re(new ns({ id: "acceptSelectedSuggestion", precondition: q.and($e.Visible, $e.HasFocusedSuggestion), handler(i) {
  i.acceptSelectedSuggestion(!0, !1);
}, kbOpts: [{ primary: 2, kbExpr: q.and($e.Visible, E.textInputFocus), weight: no }, { primary: 3, kbExpr: q.and($e.Visible, E.textInputFocus, $e.AcceptSuggestionsOnEnter, $e.MakesTextEdit), weight: no }], menuOpts: [{ menuId: hh, title: m(0, "Insert"), group: "left", order: 1, when: $e.HasInsertAndReplaceRange.toNegated() }, { menuId: hh, title: m(0, "Insert"), group: "left", order: 1, when: q.and($e.HasInsertAndReplaceRange, $e.InsertMode.isEqualTo("insert")) }, { menuId: hh, title: m(0, "Replace"), group: "left", order: 1, when: q.and($e.HasInsertAndReplaceRange, $e.InsertMode.isEqualTo("replace")) }] })), re(new ns({ id: "acceptAlternativeSelectedSuggestion", precondition: q.and($e.Visible, E.textInputFocus, $e.HasFocusedSuggestion), kbOpts: { weight: no, kbExpr: E.textInputFocus, primary: 1027, secondary: [1026] }, handler(i) {
  i.acceptSelectedSuggestion(!1, !0);
}, menuOpts: [{ menuId: hh, group: "left", order: 2, when: q.and($e.HasInsertAndReplaceRange, $e.InsertMode.isEqualTo("insert")), title: m(0, "Replace") }, { menuId: hh, group: "left", order: 2, when: q.and($e.HasInsertAndReplaceRange, $e.InsertMode.isEqualTo("replace")), title: m(0, "Insert") }] })), dt.registerCommandAlias("acceptSelectedSuggestionOnEnter", "acceptSelectedSuggestion"), re(new ns({ id: "hideSuggestWidget", precondition: $e.Visible, handler: (i) => i.cancelSuggestWidget(), kbOpts: { weight: no, kbExpr: E.textInputFocus, primary: 9, secondary: [1033] } })), re(new ns({ id: "selectNextSuggestion", precondition: q.and($e.Visible, q.or($e.MultipleSuggestions, $e.HasFocusedSuggestion.negate())), handler: (i) => i.selectNextSuggestion(), kbOpts: { weight: no, kbExpr: E.textInputFocus, primary: 18, secondary: [2066], mac: { primary: 18, secondary: [2066, 300] } } })), re(new ns({ id: "selectNextPageSuggestion", precondition: q.and($e.Visible, q.or($e.MultipleSuggestions, $e.HasFocusedSuggestion.negate())), handler: (i) => i.selectNextPageSuggestion(), kbOpts: { weight: no, kbExpr: E.textInputFocus, primary: 12, secondary: [2060] } })), re(new ns({ id: "selectLastSuggestion", precondition: q.and($e.Visible, q.or($e.MultipleSuggestions, $e.HasFocusedSuggestion.negate())), handler: (i) => i.selectLastSuggestion() })), re(new ns({ id: "selectPrevSuggestion", precondition: q.and($e.Visible, q.or($e.MultipleSuggestions, $e.HasFocusedSuggestion.negate())), handler: (i) => i.selectPrevSuggestion(), kbOpts: { weight: no, kbExpr: E.textInputFocus, primary: 16, secondary: [2064], mac: { primary: 16, secondary: [2064, 302] } } })), re(new ns({ id: "selectPrevPageSuggestion", precondition: q.and($e.Visible, q.or($e.MultipleSuggestions, $e.HasFocusedSuggestion.negate())), handler: (i) => i.selectPrevPageSuggestion(), kbOpts: { weight: no, kbExpr: E.textInputFocus, primary: 11, secondary: [2059] } })), re(new ns({ id: "selectFirstSuggestion", precondition: q.and($e.Visible, q.or($e.MultipleSuggestions, $e.HasFocusedSuggestion.negate())), handler: (i) => i.selectFirstSuggestion() })), re(new ns({ id: "focusSuggestion", precondition: q.and($e.Visible, $e.HasFocusedSuggestion.negate()), handler: (i) => i.focusSuggestion(), kbOpts: { weight: no, kbExpr: E.textInputFocus, primary: 2058, secondary: [2087], mac: { primary: 266, secondary: [2087] } } })), re(new ns({ id: "focusAndAcceptSuggestion", precondition: q.and($e.Visible, $e.HasFocusedSuggestion.negate()), handler: (i) => {
  i.focusSuggestion(), i.acceptSelectedSuggestion(!0, !1);
} })), re(new ns({ id: "toggleSuggestionDetails", precondition: q.and($e.Visible, $e.HasFocusedSuggestion), handler: (i) => i.toggleSuggestionDetails(), kbOpts: { weight: no, kbExpr: E.textInputFocus, primary: 2058, secondary: [2087], mac: { primary: 266, secondary: [2087] } }, menuOpts: [{ menuId: hh, group: "right", order: 1, when: q.and($e.DetailsVisible, $e.CanResolve), title: m(0, "show less") }, { menuId: hh, group: "right", order: 1, when: q.and($e.DetailsVisible.toNegated(), $e.CanResolve), title: m(0, "show more") }] })), re(new ns({ id: "toggleExplainMode", precondition: $e.Visible, handler: (i) => i.toggleExplainMode(), kbOpts: { weight: 100, primary: 2138 } })), re(new ns({ id: "toggleSuggestionFocus", precondition: $e.Visible, handler: (i) => i.toggleSuggestionFocus(), kbOpts: { weight: no, kbExpr: E.textInputFocus, primary: 2570, mac: { primary: 778 } } })), re(new ns({ id: "insertBestCompletion", precondition: q.and(E.textInputFocus, q.equals("config.editor.tabCompletion", "on"), R0.AtEnd, $e.Visible.toNegated(), ig.OtherSuggestions.toNegated(), _n.InSnippetMode.toNegated()), handler: (i, e) => {
  i.triggerSuggestAndAcceptBest(ms(e) ? { fallback: "tab", ...e } : { fallback: "tab" });
}, kbOpts: { weight: no, primary: 2 } })), re(new ns({ id: "insertNextSuggestion", precondition: q.and(E.textInputFocus, q.equals("config.editor.tabCompletion", "on"), ig.OtherSuggestions, $e.Visible.toNegated(), _n.InSnippetMode.toNegated()), handler: (i) => i.acceptNextSuggestion(), kbOpts: { weight: no, kbExpr: E.textInputFocus, primary: 2 } })), re(new ns({ id: "insertPrevSuggestion", precondition: q.and(E.textInputFocus, q.equals("config.editor.tabCompletion", "on"), ig.OtherSuggestions, $e.Visible.toNegated(), _n.InSnippetMode.toNegated()), handler: (i) => i.acceptPrevSuggestion(), kbOpts: { weight: no, kbExpr: E.textInputFocus, primary: 1026 } })), X(class extends he {
  constructor() {
    super({ id: "editor.action.resetSuggestSize", label: m(0, "Reset Suggest Widget Size"), alias: "Reset Suggest Widget Size", precondition: void 0 });
  }
  run(i, e) {
    var t;
    (t = wr.get(e)) === null || t === void 0 || t.resetWidgetSize();
  }
});
class _de extends V {
  get selectedItem() {
    return this._selectedItem;
  }
  constructor(e, t, n, s) {
    super(), this.editor = e, this.suggestControllerPreselector = t, this.checkModelVersion = n, this.onWillAccept = s, this.isSuggestWidgetVisible = !1, this.isShiftKeyPressed = !1, this._isActive = !1, this._currentSuggestItemInfo = void 0, this._selectedItem = lt(this, void 0), this._register(e.onKeyDown((r) => {
      r.shiftKey && !this.isShiftKeyPressed && (this.isShiftKeyPressed = !0, this.update(this._isActive));
    })), this._register(e.onKeyUp((r) => {
      r.shiftKey && this.isShiftKeyPressed && (this.isShiftKeyPressed = !1, this.update(this._isActive));
    }));
    const o = wr.get(this.editor);
    if (o) {
      this._register(o.registerSelector({ priority: 100, select: (l, d, h) => {
        Tt((_) => this.checkModelVersion(_));
        const c = this.editor.getModel();
        if (!c) return -1;
        const u = this.suggestControllerPreselector(), g = u ? tg(u, c) : void 0;
        if (!g) return -1;
        const p = W.lift(d), f = DR(h.map((_, v) => {
          const b = tg(A0.fromSuggestion(o, c, p, _, this.isShiftKeyPressed).toSingleTextEdit(), c);
          return { index: v, valid: Jz(g, b), prefixLength: b.text.length, suggestItem: _ };
        }).filter((_) => _ && _.valid && _.prefixLength > 0), jo((_) => _.prefixLength, od));
        return f ? f.index : -1;
      } }));
      let r = !1;
      const a = () => {
        r || (r = !0, this._register(o.widget.value.onDidShow(() => {
          this.isSuggestWidgetVisible = !0, this.update(!0);
        })), this._register(o.widget.value.onDidHide(() => {
          this.isSuggestWidgetVisible = !1, this.update(!1);
        })), this._register(o.widget.value.onDidFocus(() => {
          this.isSuggestWidgetVisible = !0, this.update(!0);
        })));
      };
      this._register(se.once(o.model.onDidTrigger)((l) => {
        a();
      })), this._register(o.onWillInsertSuggestItem((l) => {
        const d = this.editor.getPosition(), h = this.editor.getModel();
        if (!d || !h) return;
        const c = A0.fromSuggestion(o, h, d, l.item, this.isShiftKeyPressed);
        this.onWillAccept(c);
      }));
    }
    this.update(this._isActive);
  }
  update(e) {
    const t = this.getSuggestItemInfo();
    this._isActive === e && function(n, s) {
      return n === s ? !0 : !n || !s ? !1 : n.equals(s);
    }(this._currentSuggestItemInfo, t) || (this._isActive = e, this._currentSuggestItemInfo = t, Tt((n) => {
      this.checkModelVersion(n), this._selectedItem.set(this._isActive ? this._currentSuggestItemInfo : void 0, n);
    }));
  }
  getSuggestItemInfo() {
    const e = wr.get(this.editor);
    if (!e || !this.isSuggestWidgetVisible) return;
    const t = e.widget.value.getFocusedItem(), n = this.editor.getPosition(), s = this.editor.getModel();
    return t && n && s ? A0.fromSuggestion(e, s, n, t.item, this.isShiftKeyPressed) : void 0;
  }
  stopForceRenderingAbove() {
    const e = wr.get(this.editor);
    e == null || e.stopForceRenderingAbove();
  }
  forceRenderingAbove() {
    const e = wr.get(this.editor);
    e == null || e.forceRenderingAbove();
  }
}
class A0 {
  static fromSuggestion(e, t, n, s, o) {
    let { insertText: r } = s.completion, a = !1;
    if (4 & s.completion.insertTextRules) {
      const d = new wg().parse(r);
      d.children.length < 100 && xS.adjustWhitespace(t, n, !0, d), r = d.toString(), a = !0;
    }
    const l = e.getOverwriteInfo(s, o);
    return new A0(D.fromPositions(n.delta(0, -l.overwriteBefore), n.delta(0, Math.max(l.overwriteAfter, 0))), r, s.completion.kind, a);
  }
  constructor(e, t, n, s) {
    this.range = e, this.insertText = t, this.completionItemKind = n, this.isSnippetText = s;
  }
  equals(e) {
    return this.range.equalsRange(e.range) && this.insertText === e.insertText && this.completionItemKind === e.completionItemKind && this.isSnippetText === e.isSnippetText;
  }
  toSelectedSuggestionInfo() {
    return new Z7(this.range, this.insertText, this.completionItemKind, this.isSnippetText);
  }
  toSingleTextEdit() {
    return new Bd(this.range, this.insertText);
  }
}
var lT, vde = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, eh = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let po = lT = class extends V {
  static get(i) {
    return i.getContribution(lT.ID);
  }
  constructor(i, e, t, n, s, o, r, a, l) {
    super(), this.editor = i, this._instantiationService = e, this._contextKeyService = t, this._configurationService = n, this._commandService = s, this._debounceService = o, this._languageFeaturesService = r, this._accessibilitySignalService = a, this._keybindingService = l, this.model = this._register(Av("inlineCompletionModel", void 0)), this._textModelVersionId = lt(this, -1), this._positions = lt(this, [new W(1, 1)]), this._suggestWidgetAdaptor = this._register(new _de(this.editor, () => {
      var u, g;
      return (g = (u = this.model.get()) === null || u === void 0 ? void 0 : u.selectedInlineCompletion.get()) === null || g === void 0 ? void 0 : g.toSingleTextEdit(void 0);
    }, (u) => this.updateObservables(u, lo.Other), (u) => {
      Tt((g) => {
        var p;
        this.updateObservables(g, lo.Other), (p = this.model.get()) === null || p === void 0 || p.handleSuggestAccepted(u);
      });
    })), this._enabled = Rt(this.editor.onDidChangeConfiguration, () => this.editor.getOption(62).enabled), this._fontFamily = Rt(this.editor.onDidChangeConfiguration, () => this.editor.getOption(62).fontFamily), this._ghostTexts = Fe(this, (u) => {
      var g;
      const p = this.model.read(u);
      return (g = p == null ? void 0 : p.ghostTexts.read(u)) !== null && g !== void 0 ? g : [];
    }), this._stablizedGhostTexts = function(u, g) {
      const p = lt("result", []), f = [];
      return g.add(Ge((_) => {
        const v = u.read(_);
        Tt((b) => {
          if (v.length !== f.length) {
            f.length = v.length;
            for (let C = 0; C < f.length; C++) f[C] || (f[C] = lt("item", v[C]));
            p.set([...f], b);
          }
          f.forEach((C, w) => C.set(v[w], b));
        });
      })), p;
    }(this._ghostTexts, this._store), this._ghostTextWidgets = function(u, g, p, f) {
      let _ = new W3(p, f);
      return _m({ debugReferenceFn: p, owner: u, onLastObserverRemoved: () => {
        _.dispose(), _ = new W3(p);
      } }, (v) => (_.setItems(g.read(v)), _.getItems()));
    }(this, this._stablizedGhostTexts, (u, g) => g.add(this._instantiationService.createInstance(QM, this.editor, { ghostText: u, minReservedLineCount: ia(0), targetTextModel: this.model.map((p) => p == null ? void 0 : p.textModel) }))).recomputeInitiallyAndOnChange(this._store), this._debounceValue = this._debounceService.for(this._languageFeaturesService.inlineCompletionsProvider, "InlineCompletionsDebounce", { min: 50, max: 50 }), this._playAccessibilitySignal = NL(this), this._isReadonly = Rt(this.editor.onDidChangeConfiguration, () => this.editor.getOption(91)), this._textModel = Rt(this.editor.onDidChangeModel, () => this.editor.getModel()), this._textModelIfWritable = Fe((u) => this._isReadonly.read(u) ? void 0 : this._textModel.read(u)), this._register(new un(this._contextKeyService, this.model)), this._register(Ge((u) => {
      const g = this._textModelIfWritable.read(u);
      Tt((p) => {
        if (this.model.set(void 0, p), this.updateObservables(p, lo.Other), g) {
          const f = e.createInstance(eT, g, this._suggestWidgetAdaptor.selectedItem, this._textModelVersionId, this._positions, this._debounceValue, Rt(i.onDidChangeConfiguration, () => i.getOption(118).preview), Rt(i.onDidChangeConfiguration, () => i.getOption(118).previewMode), Rt(i.onDidChangeConfiguration, () => i.getOption(62).mode), this._enabled);
          this.model.set(f, p);
        }
      });
    }));
    const d = this._register(y8());
    this._register(Ge((u) => {
      const g = this._fontFamily.read(u);
      d.setStyle(g === "" || g === "default" ? "" : `
.monaco-editor .ghost-text-decoration,
.monaco-editor .ghost-text-decoration-preview,
.monaco-editor .ghost-text {
	font-family: ${g};
}`);
    }));
    const h = (u) => {
      var g;
      return u.isUndoing ? lo.Undo : u.isRedoing ? lo.Redo : !((g = this.model.get()) === null || g === void 0) && g.isAcceptingPartially ? lo.AcceptWord : lo.Other;
    };
    let c;
    this._register(i.onDidChangeModelContent((u) => Tt((g) => this.updateObservables(g, h(u))))), this._register(i.onDidChangeCursorPosition((u) => Tt((g) => {
      var p;
      this.updateObservables(g, lo.Other), u.reason !== 3 && u.source !== "api" || (p = this.model.get()) === null || p === void 0 || p.stop(g);
    }))), this._register(i.onDidType(() => Tt((u) => {
      var g;
      this.updateObservables(u, lo.Other), this._enabled.get() && ((g = this.model.get()) === null || g === void 0 || g.trigger(u));
    }))), this._register(this._commandService.onDidExecuteCommand((u) => {
      (/* @__PURE__ */ new Set([am.Tab.id, am.DeleteLeft.id, am.DeleteRight.id, Nz, "acceptSelectedSuggestion"])).has(u.commandId) && i.hasTextFocus() && this._enabled.get() && Tt((g) => {
        var p;
        (p = this.model.get()) === null || p === void 0 || p.trigger(g);
      });
    })), this._register(this.editor.onDidBlurEditorWidget(() => {
      this._contextKeyService.getContextKeyValue("accessibleViewIsShown") || this._configurationService.getValue("editor.inlineSuggest.keepOnBlur") || i.getOption(62).keepOnBlur || qh.dropDownVisible || Tt((u) => {
        var g;
        (g = this.model.get()) === null || g === void 0 || g.stop(u);
      });
    })), this._register(Ge((u) => {
      var g;
      const p = (g = this.model.read(u)) === null || g === void 0 ? void 0 : g.state.read(u);
      p != null && p.suggestItem ? p.primaryGhostText.lineCount >= 2 && this._suggestWidgetAdaptor.forceRenderingAbove() : this._suggestWidgetAdaptor.stopForceRenderingAbove();
    })), this._register(ye(() => {
      this._suggestWidgetAdaptor.stopForceRenderingAbove();
    })), this._register(O1({ handleChange: (u, g) => (u.didChange(this._playAccessibilitySignal) && (c = void 0), !0) }, async (u) => {
      this._playAccessibilitySignal.read(u);
      const g = this.model.read(u), p = g == null ? void 0 : g.state.read(u);
      if (g && p && p.inlineCompletion) {
        if (p.inlineCompletion.semanticId !== c) {
          c = p.inlineCompletion.semanticId;
          const f = g.textModel.getLineContent(p.primaryGhostText.lineNumber);
          this._accessibilitySignalService.playSignal(He.inlineSuggestion).then(() => {
            this.editor.getOption(8) && this.provideScreenReaderUpdate(p.primaryGhostText.renderForScreenReader(f));
          });
        }
      } else c = void 0;
    })), this._register(new IM(this.editor, this.model, this._instantiationService)), this._register(this._configurationService.onDidChangeConfiguration((u) => {
      u.affectsConfiguration("accessibility.verbosity.inlineCompletions") && this.editor.updateOptions({ inlineCompletionsAccessibilityVerbose: this._configurationService.getValue("accessibility.verbosity.inlineCompletions") });
    })), this.editor.updateOptions({ inlineCompletionsAccessibilityVerbose: this._configurationService.getValue("accessibility.verbosity.inlineCompletions") });
  }
  playAccessibilitySignal(i) {
    this._playAccessibilitySignal.trigger(i);
  }
  provideScreenReaderUpdate(i) {
    const e = this._contextKeyService.getContextKeyValue("accessibleViewIsShown"), t = this._keybindingService.lookupKeybinding("editor.action.accessibleView");
    let n;
    !e && t && this.editor.getOption(149) && (n = m(0, "Inspect this in the accessible view ({0})", t.getAriaLabel())), Io(n ? i + ", " + n : i);
  }
  updateObservables(i, e) {
    var t, n, s;
    const o = this.editor.getModel();
    this._textModelVersionId.set((t = o == null ? void 0 : o.getVersionId()) !== null && t !== void 0 ? t : -1, i, e), this._positions.set((s = (n = this.editor.getSelections()) === null || n === void 0 ? void 0 : n.map((r) => r.getPosition())) !== null && s !== void 0 ? s : [new W(1, 1)], i);
  }
  shouldShowHoverAt(i) {
    var e;
    const t = (e = this.model.get()) === null || e === void 0 ? void 0 : e.primaryGhostText.get();
    return !!t && t.parts.some((n) => i.containsPosition(new W(t.lineNumber, n.column)));
  }
  shouldShowHoverAtViewZone(i) {
    var e, t;
    return (t = (e = this._ghostTextWidgets.get()[0]) === null || e === void 0 ? void 0 : e.ownsViewZone(i)) !== null && t !== void 0 && t;
  }
};
po.ID = "editor.contrib.inlineCompletionsController", po = lT = vde([eh(1, Se), eh(2, Te), eh(3, Ye), eh(4, ai), eh(5, ar), eh(6, fe), eh(7, Fc), eh(8, Dt)], po);
class dk extends he {
  constructor() {
    super({ id: dk.ID, label: m(0, "Show Next Inline Suggestion"), alias: "Show Next Inline Suggestion", precondition: q.and(E.writable, un.inlineSuggestionVisible), kbOpts: { weight: 100, primary: 606 } });
  }
  async run(e, t) {
    var n;
    const s = po.get(t);
    (n = s == null ? void 0 : s.model.get()) === null || n === void 0 || n.next();
  }
}
dk.ID = Iz;
class hk extends he {
  constructor() {
    super({ id: hk.ID, label: m(0, "Show Previous Inline Suggestion"), alias: "Show Previous Inline Suggestion", precondition: q.and(E.writable, un.inlineSuggestionVisible), kbOpts: { weight: 100, primary: 604 } });
  }
  async run(e, t) {
    var n;
    const s = po.get(t);
    (n = s == null ? void 0 : s.model.get()) === null || n === void 0 || n.previous();
  }
}
hk.ID = Ez;
class ck extends he {
  constructor() {
    super({ id: ck.ID, label: m(0, "Hide Inline Suggestion"), alias: "Hide Inline Suggestion", precondition: un.inlineSuggestionVisible, kbOpts: { weight: 100, primary: 9 } });
  }
  async run(e, t) {
    const n = po.get(t);
    Tt((s) => {
      var o;
      (o = n == null ? void 0 : n.model.get()) === null || o === void 0 || o.stop(s);
    });
  }
}
ck.ID = "editor.action.inlineSuggest.hide";
class uk extends cs {
  constructor() {
    super({ id: uk.ID, title: m(0, "Always Show Toolbar"), f1: !1, precondition: void 0, menu: [{ id: x.InlineSuggestionToolbar, group: "secondary", order: 10 }], toggled: q.equals("config.editor.inlineSuggest.showToolbar", "always") });
  }
  async run(e, t) {
    const n = e.get(Ye), s = n.getValue("editor.inlineSuggest.showToolbar") === "always" ? "onHover" : "always";
    n.updateValue("editor.inlineSuggest.showToolbar", s);
  }
}
uk.ID = "editor.action.inlineSuggest.toggleAlwaysShowToolbar";
var bde = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, s_ = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class Cde {
  constructor(e, t, n) {
    this.owner = e, this.range = t, this.controller = n;
  }
  isValidForHoverAnchor(e) {
    return e.type === 1 && this.range.startColumn <= e.range.startColumn && this.range.endColumn >= e.range.endColumn;
  }
}
let Qx = class {
  constructor(i, e, t, n, s, o) {
    this._editor = i, this._languageService = e, this._openerService = t, this.accessibilityService = n, this._instantiationService = s, this._telemetryService = o, this.hoverOrdinal = 4;
  }
  suggestHoverAnchor(i) {
    const e = po.get(this._editor);
    if (!e) return null;
    const t = i.target;
    if (t.type === 8) {
      const n = t.detail;
      if (e.shouldShowHoverAtViewZone(n.viewZoneId)) return new Xu(1e3, this, D.fromPositions(this._editor.getModel().validatePosition(n.positionBefore || n.position)), i.event.posx, i.event.posy, !1);
    }
    return t.type === 7 && e.shouldShowHoverAt(t.range) ? new Xu(1e3, this, t.range, i.event.posx, i.event.posy, !1) : t.type === 6 && t.detail.mightBeForeignElement && e.shouldShowHoverAt(t.range) ? new Xu(1e3, this, t.range, i.event.posx, i.event.posy, !1) : null;
  }
  computeSync(i, e) {
    if (this._editor.getOption(62).showToolbar !== "onHover") return [];
    const t = po.get(this._editor);
    return t && t.shouldShowHoverAt(i.range) ? [new Cde(this, i.range, t)] : [];
  }
  renderHoverParts(i, e) {
    const t = new G(), n = e[0];
    this._telemetryService.publicLog2("inlineCompletionHover.shown"), this.accessibilityService.isScreenReaderOptimized() && !this._editor.getOption(8) && this.renderScreenReaderText(i, n, t);
    const s = n.controller.model.get(), o = this._instantiationService.createInstance(qh, this._editor, !1, ia(null), s.selectedInlineCompletionIndex, s.inlineCompletionsCount, s.selectedInlineCompletion.map((r) => {
      var a;
      return (a = r == null ? void 0 : r.inlineCompletion.source.inlineCompletions.commands) !== null && a !== void 0 ? a : [];
    }));
    return i.fragment.appendChild(o.getDomNode()), s.triggerExplicitly(), t.add(o), t;
  }
  renderScreenReaderText(i, e, t) {
    const n = Q, s = n("div.hover-row.markdown-hover"), o = Z(s, n("div.hover-contents", { "aria-live": "assertive" })), r = t.add(new ml({ editor: this._editor }, this._languageService, this._openerService));
    t.add(Ge((a) => {
      var l;
      const d = (l = e.controller.model.read(a)) === null || l === void 0 ? void 0 : l.primaryGhostText.read(a);
      if (d) {
        const h = this._editor.getModel().getLineContent(d.lineNumber);
        ((c) => {
          t.add(r.onDidRenderAsync(() => {
            o.className = "hover-contents code-hover-contents", i.onContentsChanged();
          }));
          const u = m(0, "Suggestion:"), g = t.add(r.render(new Vn().appendText(u).appendCodeblock("text", c)));
          o.replaceChildren(g.element);
        })(d.renderForScreenReader(h));
      } else wn(o);
    })), i.fragment.appendChild(s);
  }
};
function Ks(i, e) {
  let t = 0;
  for (let n = 0; n < i.length; n++) i.charAt(n) === "	" ? t += e : t++;
  return t;
}
function P0(i, e, t) {
  i = i < 0 ? 0 : i;
  let n = "";
  if (!t) {
    const s = Math.floor(i / e);
    i %= e;
    for (let o = 0; o < s; o++) n += "	";
  }
  for (let s = 0; s < i; s++) n += " ";
  return n;
}
function E9(i, e, t, n, s) {
  if (i.getLineCount() === 1 && i.getLineMaxColumn(1) === 1) return [];
  const o = e.getLanguageConfiguration(i.getLanguageId()).indentationRules;
  if (!o) return [];
  for (n = Math.min(n, i.getLineCount()); t <= n && o.unIndentedLinePattern; ) {
    const _ = i.getLineContent(t);
    if (!o.unIndentedLinePattern.test(_)) break;
    t++;
  }
  if (t > n - 1) return [];
  const { tabSize: r, indentSize: a, insertSpaces: l } = i.getOptions(), d = (_, v) => (v = v || 1, Ko.shiftIndent(_, _.length + v, r, a, l)), h = (_, v) => (v = v || 1, Ko.unshiftIndent(_, _.length + v, r, a, l)), c = [];
  let u;
  const g = i.getLineContent(t);
  let p = g;
  u = Wt(g);
  let f = u;
  o.increaseIndentPattern && o.increaseIndentPattern.test(p) ? (f = d(f), u = d(u)) : o.indentNextLinePattern && o.indentNextLinePattern.test(p) && (f = d(f));
  for (let _ = ++t; _ <= n; _++) {
    const v = i.getLineContent(_), b = Wt(v), C = f + v.substring(b.length);
    o.decreaseIndentPattern && o.decreaseIndentPattern.test(C) && (f = h(f), u = h(u)), b !== f && c.push(ii.replaceMove(new _e(_, 1, _, b.length + 1), KR(f, a, l))), o.unIndentedLinePattern && o.unIndentedLinePattern.test(v) || (o.increaseIndentPattern && o.increaseIndentPattern.test(C) ? (u = d(u), f = u) : f = o.indentNextLinePattern && o.indentNextLinePattern.test(C) ? d(f) : u);
  }
  return c;
}
Qx = bde([s_(1, Xt), s_(2, Fs), s_(3, or), s_(4, Se), s_(5, es)], Qx), ft(po.ID, po, 3), X(class extends he {
  constructor() {
    super({ id: "editor.action.inlineSuggest.trigger", label: m(0, "Trigger Inline Suggestion"), alias: "Trigger Inline Suggestion", precondition: E.writable });
  }
  async run(i, e) {
    const t = po.get(e);
    await async function(n, s) {
      const o = new kL(n, s);
      try {
        await n(o);
      } finally {
        o.finish();
      }
    }(async (n) => {
      var s;
      await ((s = t == null ? void 0 : t.model.get()) === null || s === void 0 ? void 0 : s.triggerExplicitly(n)), t == null || t.playAccessibilitySignal(n);
    });
  }
}), X(dk), X(hk), X(class extends he {
  constructor() {
    super({ id: "editor.action.inlineSuggest.acceptNextWord", label: m(0, "Accept Next Word Of Inline Suggestion"), alias: "Accept Next Word Of Inline Suggestion", precondition: q.and(E.writable, un.inlineSuggestionVisible), kbOpts: { weight: 101, primary: 2065, kbExpr: q.and(E.writable, un.inlineSuggestionVisible) }, menuOpts: [{ menuId: x.InlineSuggestionToolbar, title: m(0, "Accept Word"), group: "primary", order: 2 }] });
  }
  async run(i, e) {
    var t;
    const n = po.get(e);
    await ((t = n == null ? void 0 : n.model.get()) === null || t === void 0 ? void 0 : t.acceptNextWord(n.editor));
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.inlineSuggest.acceptNextLine", label: m(0, "Accept Next Line Of Inline Suggestion"), alias: "Accept Next Line Of Inline Suggestion", precondition: q.and(E.writable, un.inlineSuggestionVisible), kbOpts: { weight: 101 }, menuOpts: [{ menuId: x.InlineSuggestionToolbar, title: m(0, "Accept Line"), group: "secondary", order: 2 }] });
  }
  async run(i, e) {
    var t;
    const n = po.get(e);
    await ((t = n == null ? void 0 : n.model.get()) === null || t === void 0 ? void 0 : t.acceptNextLine(n.editor));
  }
}), X(class extends he {
  constructor() {
    super({ id: Nz, label: m(0, "Accept Inline Suggestion"), alias: "Accept Inline Suggestion", precondition: un.inlineSuggestionVisible, menuOpts: [{ menuId: x.InlineSuggestionToolbar, title: m(0, "Accept"), group: "primary", order: 1 }], kbOpts: { primary: 2, weight: 200, kbExpr: q.and(un.inlineSuggestionVisible, E.tabMovesFocus.toNegated(), un.inlineSuggestionHasIndentationLessThanTabSize, $e.Visible.toNegated(), E.hoverFocused.toNegated()) } });
  }
  async run(i, e) {
    var t;
    const n = po.get(e);
    n && ((t = n.model.get()) === null || t === void 0 || t.accept(n.editor), n.editor.focus());
  }
}), X(ck), Ft(uk), Rc.register(Qx);
var wde = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, yde = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class gk extends he {
  constructor() {
    super({ id: gk.ID, label: m(0, "Convert Indentation to Spaces"), alias: "Convert Indentation to Spaces", precondition: E.writable });
  }
  run(e, t) {
    const n = t.getModel();
    if (!n) return;
    const s = n.getOptions(), o = t.getSelection();
    if (!o) return;
    const r = new Lde(o, s.tabSize);
    t.pushUndoStop(), t.executeCommands(this.id, [r]), t.pushUndoStop(), n.updateOptions({ insertSpaces: !0 });
  }
}
gk.ID = "editor.action.indentationToSpaces";
class pk extends he {
  constructor() {
    super({ id: pk.ID, label: m(0, "Convert Indentation to Tabs"), alias: "Convert Indentation to Tabs", precondition: E.writable });
  }
  run(e, t) {
    const n = t.getModel();
    if (!n) return;
    const s = n.getOptions(), o = t.getSelection();
    if (!o) return;
    const r = new kde(o, s.tabSize);
    t.pushUndoStop(), t.executeCommands(this.id, [r]), t.pushUndoStop(), n.updateOptions({ insertSpaces: !1 });
  }
}
pk.ID = "editor.action.indentationToTabs";
class MP extends he {
  constructor(e, t, n) {
    super(n), this.insertSpaces = e, this.displaySizeOnly = t;
  }
  run(e, t) {
    const n = e.get(La), s = e.get(ni), o = t.getModel();
    if (!o) return;
    const r = s.getCreationOptions(o.getLanguageId(), o.uri, o.isForSimpleWidget), a = o.getOptions(), l = [1, 2, 3, 4, 5, 6, 7, 8].map((h) => ({ id: h.toString(), label: h.toString(), description: h === r.tabSize && h === a.tabSize ? m(0, "Configured Tab Size") : h === r.tabSize ? m(0, "Default Tab Size") : h === a.tabSize ? m(0, "Current Tab Size") : void 0 })), d = Math.min(o.getOptions().tabSize - 1, 7);
    setTimeout(() => {
      n.pick(l, { placeHolder: m(0, "Select Tab Size for Current File"), activeItem: l[d] }).then((h) => {
        if (h && o && !o.isDisposed()) {
          const c = parseInt(h.label, 10);
          this.displaySizeOnly ? o.updateOptions({ tabSize: c }) : o.updateOptions({ tabSize: c, indentSize: c, insertSpaces: this.insertSpaces });
        }
      });
    }, 50);
  }
}
class mk extends MP {
  constructor() {
    super(!1, !1, { id: mk.ID, label: m(0, "Indent Using Tabs"), alias: "Indent Using Tabs", precondition: void 0 });
  }
}
mk.ID = "editor.action.indentUsingTabs";
class fk extends MP {
  constructor() {
    super(!0, !1, { id: fk.ID, label: m(0, "Indent Using Spaces"), alias: "Indent Using Spaces", precondition: void 0 });
  }
}
fk.ID = "editor.action.indentUsingSpaces";
class _k extends MP {
  constructor() {
    super(!0, !0, { id: _k.ID, label: m(0, "Change Tab Display Size"), alias: "Change Tab Display Size", precondition: void 0 });
  }
}
_k.ID = "editor.action.changeTabDisplaySize";
class vk extends he {
  constructor() {
    super({ id: vk.ID, label: m(0, "Detect Indentation from Content"), alias: "Detect Indentation from Content", precondition: void 0 });
  }
  run(e, t) {
    const n = e.get(ni), s = t.getModel();
    if (!s) return;
    const o = n.getCreationOptions(s.getLanguageId(), s.uri, s.isForSimpleWidget);
    s.detectIndentation(o.insertSpaces, o.tabSize);
  }
}
vk.ID = "editor.action.detectIndentation";
class Sde {
  constructor(e, t) {
    this._initialSelection = t, this._edits = [], this._selectionId = null;
    for (const n of e) n.range && typeof n.text == "string" && this._edits.push(n);
  }
  getEditOperations(e, t) {
    for (const s of this._edits) t.addEditOperation(D.lift(s.range), s.text);
    let n = !1;
    Array.isArray(this._edits) && this._edits.length === 1 && this._initialSelection.isEmpty() && (this._edits[0].range.startColumn === this._initialSelection.endColumn && this._edits[0].range.startLineNumber === this._initialSelection.endLineNumber ? (n = !0, this._selectionId = t.trackSelection(this._initialSelection, !0)) : this._edits[0].range.endColumn === this._initialSelection.startColumn && this._edits[0].range.endLineNumber === this._initialSelection.startLineNumber && (n = !0, this._selectionId = t.trackSelection(this._initialSelection, !1))), n || (this._selectionId = t.trackSelection(this._initialSelection));
  }
  computeCursorState(e, t) {
    return t.getTrackedSelection(this._selectionId);
  }
}
let O0 = class {
  constructor(i, e) {
    this.editor = i, this._languageConfigurationService = e, this.callOnDispose = new G(), this.callOnModel = new G(), this.callOnDispose.add(i.onDidChangeConfiguration(() => this.update())), this.callOnDispose.add(i.onDidChangeModel(() => this.update())), this.callOnDispose.add(i.onDidChangeModelLanguage(() => this.update()));
  }
  update() {
    this.callOnModel.clear(), this.editor.getOption(12) < 4 || this.editor.getOption(55) || this.editor.hasModel() && this.callOnModel.add(this.editor.onDidPaste(({ range: i }) => {
      this.trigger(i);
    }));
  }
  trigger(i) {
    const e = this.editor.getSelections();
    if (e === null || e.length > 1) return;
    const t = this.editor.getModel();
    if (!t || !t.tokenization.isCheapToTokenize(i.getStartPosition().lineNumber)) return;
    const n = this.editor.getOption(12), { tabSize: s, indentSize: o, insertSpaces: r } = t.getOptions(), a = [], l = { shiftIndent: (u) => Ko.shiftIndent(u, u.length + 1, s, o, r), unshiftIndent: (u) => Ko.unshiftIndent(u, u.length + 1, s, o, r) };
    let d = i.startLineNumber;
    for (; d <= i.endLineNumber && this.shouldIgnoreLine(t, d); ) d++;
    if (d > i.endLineNumber) return;
    let h = t.getLineContent(d);
    if (!/\S/.test(h.substring(0, i.startColumn - 1))) {
      const u = n0(n, t, t.getLanguageId(), d, l, this._languageConfigurationService);
      if (u !== null) {
        const g = Wt(h), p = Ks(u, s);
        if (p !== Ks(g, s)) {
          const f = P0(p, s, r);
          a.push({ range: new D(d, 1, d, g.length + 1), text: f }), h = f + h.substr(g.length);
        } else {
          const f = BB(t, d, this._languageConfigurationService);
          if (f === 0 || f === 8) return;
        }
      }
    }
    const c = d;
    for (; d < i.endLineNumber && !/\S/.test(t.getLineContent(d + 1)); ) d++;
    if (d !== i.endLineNumber) {
      const u = n0(n, { tokenization: { getLineTokens: (g) => t.tokenization.getLineTokens(g), getLanguageId: () => t.getLanguageId(), getLanguageIdAtPosition: (g, p) => t.getLanguageIdAtPosition(g, p) }, getLineContent: (g) => g === c ? h : t.getLineContent(g) }, t.getLanguageId(), d + 1, l, this._languageConfigurationService);
      if (u !== null) {
        const g = Ks(u, s), p = Ks(Wt(t.getLineContent(d + 1)), s);
        if (g !== p) {
          const f = g - p;
          for (let _ = d + 1; _ <= i.endLineNumber; _++) {
            const v = Wt(t.getLineContent(_)), b = P0(Ks(v, s) + f, s, r);
            b !== v && a.push({ range: new D(_, 1, _, v.length + 1), text: b });
          }
        }
      }
    }
    if (a.length > 0) {
      this.editor.pushUndoStop();
      const u = new Sde(a, this.editor.getSelection());
      this.editor.executeCommand("autoIndentOnPaste", u), this.editor.pushUndoStop();
    }
  }
  shouldIgnoreLine(i, e) {
    i.tokenization.forceTokenization(e);
    const t = i.getLineFirstNonWhitespaceColumn(e);
    if (t === 0) return !0;
    const n = i.tokenization.getLineTokens(e);
    if (n.getCount() > 0) {
      const s = n.findTokenIndexAtOffset(t);
      if (s >= 0 && n.getStandardTokenType(s) === 1) return !0;
    }
    return !1;
  }
  dispose() {
    this.callOnDispose.dispose(), this.callOnModel.dispose();
  }
};
function nU(i, e, t, n) {
  if (i.getLineCount() === 1 && i.getLineMaxColumn(1) === 1) return;
  let s = "";
  for (let r = 0; r < t; r++) s += " ";
  const o = new RegExp(s, "gi");
  for (let r = 1, a = i.getLineCount(); r <= a; r++) {
    let l = i.getLineFirstNonWhitespaceColumn(r);
    if (l === 0 && (l = i.getLineMaxColumn(r)), l === 1) continue;
    const d = new D(r, 1, r, l), h = i.getValueInRange(d), c = n ? h.replace(/\t/gi, s) : h.replace(o, "	");
    e.addEditOperation(d, c);
  }
}
O0.ID = "editor.contrib.autoIndentOnPaste", O0 = wde([yde(1, zt)], O0);
class Lde {
  constructor(e, t) {
    this.selection = e, this.tabSize = t, this.selectionId = null;
  }
  getEditOperations(e, t) {
    this.selectionId = t.trackSelection(this.selection), nU(e, t, this.tabSize, !0);
  }
  computeCursorState(e, t) {
    return t.getTrackedSelection(this.selectionId);
  }
}
class kde {
  constructor(e, t) {
    this.selection = e, this.tabSize = t, this.selectionId = null;
  }
  getEditOperations(e, t) {
    this.selectionId = t.trackSelection(this.selection), nU(e, t, this.tabSize, !1);
  }
  computeCursorState(e, t) {
    return t.getTrackedSelection(this.selectionId);
  }
}
ft(O0.ID, O0, 2), X(gk), X(pk), X(mk), X(fk), X(_k), X(vk), X(class extends he {
  constructor() {
    super({ id: "editor.action.reindentlines", label: m(0, "Reindent Lines"), alias: "Reindent Lines", precondition: E.writable });
  }
  run(i, e) {
    const t = i.get(zt), n = e.getModel();
    if (!n) return;
    const s = E9(n, t, 1, n.getLineCount());
    s.length > 0 && (e.pushUndoStop(), e.executeEdits(this.id, s), e.pushUndoStop());
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.reindentselectedlines", label: m(0, "Reindent Selected Lines"), alias: "Reindent Selected Lines", precondition: E.writable });
  }
  run(i, e) {
    const t = i.get(zt), n = e.getModel();
    if (!n) return;
    const s = e.getSelections();
    if (s === null) return;
    const o = [];
    for (const r of s) {
      let a = r.startLineNumber, l = r.endLineNumber;
      if (a !== l && r.endColumn === 1 && l--, a === 1) {
        if (a === l) continue;
      } else a--;
      const d = E9(n, t, a, l);
      o.push(...d);
    }
    o.length > 0 && (e.pushUndoStop(), e.executeEdits(this.id, o), e.pushUndoStop());
  }
});
class sU {
  constructor(e, t) {
    this.range = e, this.direction = t;
  }
}
class TP {
  constructor(e, t, n) {
    this.hint = e, this.anchor = t, this.provider = n, this._isResolved = !1;
  }
  with(e) {
    const t = new TP(this.hint, e.anchor, this.provider);
    return t._isResolved = this._isResolved, t._currentResolve = this._currentResolve, t;
  }
  async resolve(e) {
    if (typeof this.provider.resolveInlayHint == "function") {
      if (this._currentResolve)
        return await this._currentResolve, e.isCancellationRequested ? void 0 : this.resolve(e);
      this._isResolved || (this._currentResolve = this._doResolve(e).finally(() => this._currentResolve = void 0)), await this._currentResolve;
    }
  }
  async _doResolve(e) {
    var t, n, s;
    try {
      const o = await Promise.resolve(this.provider.resolveInlayHint(this.hint, e));
      this.hint.tooltip = (t = o == null ? void 0 : o.tooltip) !== null && t !== void 0 ? t : this.hint.tooltip, this.hint.label = (n = o == null ? void 0 : o.label) !== null && n !== void 0 ? n : this.hint.label, this.hint.textEdits = (s = o == null ? void 0 : o.textEdits) !== null && s !== void 0 ? s : this.hint.textEdits, this._isResolved = !0;
    } catch (o) {
      Ni(o), this._isResolved = !1;
    }
  }
}
class ng {
  static async create(e, t, n, s) {
    const o = [], r = e.ordered(t).reverse().map((a) => n.map(async (l) => {
      try {
        const d = await a.provideInlayHints(t, l, s);
        (d != null && d.hints.length || a.onDidChangeInlayHints) && o.push([d ?? ng._emptyInlayHintList, a]);
      } catch (d) {
        Ni(d);
      }
    }));
    if (await Promise.all(r.flat()), s.isCancellationRequested || t.isDisposed()) throw new Vd();
    return new ng(n, o, t);
  }
  constructor(e, t, n) {
    this._disposables = new G(), this.ranges = e, this.provider = /* @__PURE__ */ new Set();
    const s = [];
    for (const [o, r] of t) {
      this._disposables.add(o), this.provider.add(r);
      for (const a of o.hints) {
        const l = n.validatePosition(a.position);
        let d = "before";
        const h = ng._getRangeAtPosition(n, l);
        let c;
        h.getStartPosition().isBefore(l) ? (c = D.fromPositions(h.getStartPosition(), l), d = "after") : (c = D.fromPositions(l, h.getEndPosition()), d = "before"), s.push(new TP(a, new sU(c, d), r));
      }
    }
    this.items = s.sort((o, r) => W.compare(o.hint.position, r.hint.position));
  }
  dispose() {
    this._disposables.dispose();
  }
  static _getRangeAtPosition(e, t) {
    const n = t.lineNumber, s = e.getWordAtPosition(t);
    if (s) return new D(n, s.startColumn, n, s.endColumn);
    e.tokenization.tokenizeIfCheap(n);
    const o = e.tokenization.getLineTokens(n), r = t.column - 1, a = o.findTokenIndexAtOffset(r);
    let l = o.getStartOffset(a), d = o.getEndOffset(a);
    return d - l == 1 && (l === r && a > 1 ? (l = o.getStartOffset(a - 1), d = o.getEndOffset(a - 1)) : d === r && a < o.getCount() - 1 && (l = o.getStartOffset(a + 1), d = o.getEndOffset(a + 1))), new D(n, l + 1, n, d + 1);
  }
}
async function Dde(i, e, t, n) {
  var s;
  const o = i.get(Ps), r = i.get(io), a = i.get(ai), l = i.get(Se), d = i.get(Ri);
  if (await n.item.resolve(et.None), !n.part.location) return;
  const h = n.part.location, c = [], u = new Set(tn.getMenuItems(x.EditorContext).map((p) => xp(p) ? p.command.id : YL()));
  for (const p of Xn.all()) u.has(p.desc.id) && c.push(new Qs(p.desc.id, Eo.label(p.desc, { renderShortTitle: !0 }), void 0, !0, async () => {
    const f = await o.createModelReference(h.uri);
    try {
      const _ = new df(f.object.textEditorModel, D.getStartPosition(h.range)), v = n.item.anchor.range;
      await l.invokeFunction(p.runEditorCommand.bind(p), e, _, v);
    } finally {
      f.dispose();
    }
  }));
  if (n.part.command) {
    const { command: p } = n.part;
    c.push(new Ui()), c.push(new Qs(p.id, p.title, void 0, !0, async () => {
      var f;
      try {
        await a.executeCommand(p.id, ...(f = p.arguments) !== null && f !== void 0 ? f : []);
      } catch (_) {
        d.notify({ severity: fL.Error, source: n.item.provider.displayName, message: _ });
      }
    }));
  }
  const g = e.getOption(127);
  r.showContextMenu({ domForShadowRoot: g && (s = e.getDomNode()) !== null && s !== void 0 ? s : void 0, getAnchor: () => {
    const p = Ti(t);
    return { x: p.left, y: p.top + p.height + 8 };
  }, getActions: () => c, onHide: () => {
    e.focus();
  }, autoSelectFirstItem: !0 });
}
async function oU(i, e, t, n) {
  const s = i.get(Ps), o = await s.createModelReference(n.uri);
  await t.invokeWithinContext(async (r) => {
    const a = e.hasSideBySideModifier, l = r.get(Te), d = As.inPeekEditor.getValue(l), h = !a && t.getOption(88) && !d;
    return new N0({ openToSide: a, openInPeek: h, muteMessage: !0 }, { title: { value: "", original: "" }, id: "", precondition: void 0 }).run(r, new df(o.object.textEditorModel, D.getStartPosition(n.range)), D.lift(n.range));
  }), o.dispose();
}
ng._emptyInlayHintList = Object.freeze({ dispose() {
}, hints: [] });
var wp, xde = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, hp = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class ES {
  constructor() {
    this._entries = new Ll(50);
  }
  get(e) {
    const t = ES._key(e);
    return this._entries.get(t);
  }
  set(e, t) {
    const n = ES._key(e);
    this._entries.set(n, t);
  }
  static _key(e) {
    return `${e.uri.toString()}/${e.getVersionId()}`;
  }
}
const rU = tt("IInlayHintsCache");
rt(rU, ES, 1);
class dT {
  constructor(e, t) {
    this.item = e, this.index = t;
  }
  get part() {
    const e = this.item.hint.label;
    return typeof e == "string" ? { label: e } : e[this.index];
  }
}
class Nde {
  constructor(e, t) {
    this.part = e, this.hasTriggerModifier = t;
  }
}
let kh = wp = class {
  static get(i) {
    var e;
    return (e = i.getContribution(wp.ID)) !== null && e !== void 0 ? e : void 0;
  }
  constructor(i, e, t, n, s, o, r) {
    this._editor = i, this._languageFeaturesService = e, this._inlayHintsCache = n, this._commandService = s, this._notificationService = o, this._instaService = r, this._disposables = new G(), this._sessionDisposables = new G(), this._decorationsMetadata = /* @__PURE__ */ new Map(), this._ruleFactory = new S1(this._editor), this._activeRenderMode = 0, this._debounceInfo = t.for(e.inlayHintsProvider, "InlayHint", { min: 25 }), this._disposables.add(e.inlayHintsProvider.onDidChange(() => this._update())), this._disposables.add(i.onDidChangeModel(() => this._update())), this._disposables.add(i.onDidChangeModelLanguage(() => this._update())), this._disposables.add(i.onDidChangeConfiguration((a) => {
      a.hasChanged(141) && this._update();
    })), this._update();
  }
  dispose() {
    this._sessionDisposables.dispose(), this._removeAllDecorations(), this._disposables.dispose();
  }
  _update() {
    this._sessionDisposables.clear(), this._removeAllDecorations();
    const i = this._editor.getOption(141);
    if (i.enabled === "off") return;
    const e = this._editor.getModel();
    if (!e || !this._languageFeaturesService.inlayHintsProvider.has(e)) return;
    if (i.enabled === "on") this._activeRenderMode = 0;
    else {
      let r, a;
      i.enabled === "onUnlessPressed" ? (r = 0, a = 1) : (r = 1, a = 0), this._activeRenderMode = r, this._sessionDisposables.add(ad.getInstance().event((l) => {
        if (!this._editor.hasModel()) return;
        const d = l.altKey && l.ctrlKey && !l.shiftKey && !l.metaKey ? a : r;
        if (d !== this._activeRenderMode) {
          this._activeRenderMode = d;
          const h = this._editor.getModel(), c = this._copyInlayHintsWithCurrentAnchor(h);
          this._updateHintsDecorators([h.getFullModelRange()], c), o.schedule(0);
        }
      }));
    }
    const t = this._inlayHintsCache.get(e);
    let n;
    t && this._updateHintsDecorators([e.getFullModelRange()], t), this._sessionDisposables.add(ye(() => {
      e.isDisposed() || this._cacheHintsForFastRestore(e);
    }));
    const s = /* @__PURE__ */ new Set(), o = new It(async () => {
      const r = Date.now();
      n == null || n.dispose(!0), n = new Ci();
      const a = e.onWillDispose(() => n == null ? void 0 : n.cancel());
      try {
        const l = n.token, d = await ng.create(this._languageFeaturesService.inlayHintsProvider, e, this._getHintsRanges(), l);
        if (o.delay = this._debounceInfo.update(e, Date.now() - r), l.isCancellationRequested) return void d.dispose();
        for (const h of d.provider) typeof h.onDidChangeInlayHints != "function" || s.has(h) || (s.add(h), this._sessionDisposables.add(h.onDidChangeInlayHints(() => {
          o.isScheduled() || o.schedule();
        })));
        this._sessionDisposables.add(d), this._updateHintsDecorators(d.ranges, d.items), this._cacheHintsForFastRestore(e);
      } catch (l) {
        We(l);
      } finally {
        n.dispose(), a.dispose();
      }
    }, this._debounceInfo.get(e));
    this._sessionDisposables.add(o), this._sessionDisposables.add(ye(() => n == null ? void 0 : n.dispose(!0))), o.schedule(0), this._sessionDisposables.add(this._editor.onDidScrollChange((r) => {
      !r.scrollTopChanged && o.isScheduled() || o.schedule();
    })), this._sessionDisposables.add(this._editor.onDidChangeModelContent((r) => {
      n == null || n.cancel();
      const a = Math.max(o.delay, 1250);
      o.schedule(a);
    })), this._sessionDisposables.add(this._installDblClickGesture(() => o.schedule(0))), this._sessionDisposables.add(this._installLinkGesture()), this._sessionDisposables.add(this._installContextMenu());
  }
  _installLinkGesture() {
    const i = new G(), e = i.add(new JL(this._editor)), t = new G();
    return i.add(t), i.add(e.onMouseMoveOrRelevantKeyDown((n) => {
      const [s] = n, o = this._getInlayHintLabelPart(s), r = this._editor.getModel();
      if (!o || !r) return void t.clear();
      const a = new Ci();
      t.add(ye(() => a.dispose(!0))), o.item.resolve(a.token), this._activeInlayHintPart = o.part.command || o.part.location ? new Nde(o, s.hasTriggerModifier) : void 0;
      const l = r.validatePosition(o.item.hint.position).lineNumber, d = new D(l, 1, l, r.getLineMaxColumn(l)), h = this._getInlineHintsForRange(d);
      this._updateHintsDecorators([d], h), t.add(ye(() => {
        this._activeInlayHintPart = void 0, this._updateHintsDecorators([d], h);
      }));
    })), i.add(e.onCancel(() => t.clear())), i.add(e.onExecute(async (n) => {
      const s = this._getInlayHintLabelPart(n);
      if (s) {
        const o = s.part;
        o.location ? this._instaService.invokeFunction(oU, n, this._editor, o.location) : TN.is(o.command) && await this._invokeCommand(o.command, s.item);
      }
    })), i;
  }
  _getInlineHintsForRange(i) {
    const e = /* @__PURE__ */ new Set();
    for (const t of this._decorationsMetadata.values()) i.containsRange(t.item.anchor.range) && e.add(t.item);
    return Array.from(e);
  }
  _installDblClickGesture(i) {
    return this._editor.onMouseUp(async (e) => {
      if (e.event.detail !== 2) return;
      const t = this._getInlayHintLabelPart(e);
      if (t && (e.event.preventDefault(), await t.item.resolve(et.None), zn(t.item.hint.textEdits))) {
        const n = t.item.hint.textEdits.map((s) => ii.replace(D.lift(s.range), s.text));
        this._editor.executeEdits("inlayHint.default", n), i();
      }
    });
  }
  _installContextMenu() {
    return this._editor.onContextMenu(async (i) => {
      if (!(i.event.target instanceof HTMLElement)) return;
      const e = this._getInlayHintLabelPart(i);
      e && await this._instaService.invokeFunction(Dde, this._editor, i.event.target, e);
    });
  }
  _getInlayHintLabelPart(i) {
    var e;
    if (i.target.type !== 6) return;
    const t = (e = i.target.detail.injectedText) === null || e === void 0 ? void 0 : e.options;
    return t instanceof Nc && (t == null ? void 0 : t.attachedData) instanceof dT ? t.attachedData : void 0;
  }
  async _invokeCommand(i, e) {
    var t;
    try {
      await this._commandService.executeCommand(i.id, ...(t = i.arguments) !== null && t !== void 0 ? t : []);
    } catch (n) {
      this._notificationService.notify({ severity: fL.Error, source: e.provider.displayName, message: n });
    }
  }
  _cacheHintsForFastRestore(i) {
    const e = this._copyInlayHintsWithCurrentAnchor(i);
    this._inlayHintsCache.set(i, e);
  }
  _copyInlayHintsWithCurrentAnchor(i) {
    const e = /* @__PURE__ */ new Map();
    for (const [t, n] of this._decorationsMetadata) {
      if (e.has(n.item)) continue;
      const s = i.getDecorationRange(t);
      if (s) {
        const o = new sU(s, n.item.anchor.direction), r = n.item.with({ anchor: o });
        e.set(n.item, r);
      }
    }
    return Array.from(e.values());
  }
  _getHintsRanges() {
    const i = this._editor.getModel(), e = this._editor.getVisibleRangesPlusViewportAboveBelow(), t = [];
    for (const n of e.sort(D.compareRangesUsingStarts)) {
      const s = i.validateRange(new D(n.startLineNumber - 30, n.startColumn, n.endLineNumber + 30, n.endColumn));
      t.length !== 0 && D.areIntersectingOrTouching(t[t.length - 1], s) ? t[t.length - 1] = D.plusRange(t[t.length - 1], s) : t.push(s);
    }
    return t;
  }
  _updateHintsDecorators(i, e) {
    var t, n;
    const s = [], o = (f, _, v, b, C) => {
      const w = { content: v, inlineClassNameAffectsLetterSpacing: !0, inlineClassName: _.className, cursorStops: b, attachedData: C };
      s.push({ item: f, classNameRef: _, decoration: { range: f.anchor.range, options: { description: "InlayHint", showIfCollapsed: f.anchor.range.isEmpty(), collapseOnReplaceEdit: !f.anchor.range.isEmpty(), stickiness: 0, [f.anchor.direction]: this._activeRenderMode === 0 ? w : void 0 } } });
    }, r = (f, _) => {
      const v = this._ruleFactory.createClassNameRef({ width: (a / 3 | 0) + "px", display: "inline-block" });
      o(f, v, " ", _ ? vr.Right : vr.None);
    }, { fontSize: a, fontFamily: l, padding: d, isUniform: h } = this._getLayoutInfo(), c = "--code-editorInlayHintsFontFamily";
    this._editor.getContainerDomNode().style.setProperty(c, l);
    let u = { line: 0, totalLen: 0 };
    for (const f of e) {
      if (u.line !== f.anchor.range.startLineNumber && (u = { line: f.anchor.range.startLineNumber, totalLen: 0 }), u.totalLen > wp._MAX_LABEL_LEN) continue;
      f.hint.paddingLeft && r(f, !1);
      const _ = typeof f.hint.label == "string" ? [{ label: f.hint.label }] : f.hint.label;
      for (let v = 0; v < _.length; v++) {
        const b = _[v], C = v === 0, w = v === _.length - 1, y = { fontSize: `${a}px`, fontFamily: `var(${c}), ${Is.fontFamily}`, verticalAlign: h ? "baseline" : "middle", unicodeBidi: "isolate" };
        zn(f.hint.textEdits) && (y.cursor = "default"), this._fillInColors(y, f.hint), (b.command || b.location) && ((t = this._activeInlayHintPart) === null || t === void 0 ? void 0 : t.part.item) === f && this._activeInlayHintPart.part.index === v && (y.textDecoration = "underline", this._activeInlayHintPart.hasTriggerModifier && (y.color = ui(v$), y.cursor = "pointer")), d && (C && w ? (y.padding = `1px ${0 | Math.max(1, a / 4)}px`, y.borderRadius = (a / 4 | 0) + "px") : C ? (y.padding = `1px 0 1px ${0 | Math.max(1, a / 4)}px`, y.borderRadius = `${a / 4 | 0}px 0 0 ${a / 4 | 0}px`) : w ? (y.padding = `1px ${0 | Math.max(1, a / 4)}px 1px 0`, y.borderRadius = `0 ${a / 4 | 0}px ${a / 4 | 0}px 0`) : y.padding = "1px 0 1px 0");
        let L = b.label;
        u.totalLen += L.length;
        let k = !1;
        const N = u.totalLen - wp._MAX_LABEL_LEN;
        if (N > 0 && (L = L.slice(0, -N) + "…", k = !0), o(f, this._ruleFactory.createClassNameRef(y), Ede(L), w && !f.hint.paddingRight ? vr.Right : vr.None, new dT(f, v)), k) break;
      }
      if (f.hint.paddingRight && r(f, !0), s.length > wp._MAX_DECORATORS) break;
    }
    const g = [];
    for (const [f, _] of this._decorationsMetadata) {
      const v = (n = this._editor.getModel()) === null || n === void 0 ? void 0 : n.getDecorationRange(f);
      v && i.some((b) => b.containsRange(v)) && (g.push(f), _.classNameRef.dispose(), this._decorationsMetadata.delete(f));
    }
    const p = ya.capture(this._editor);
    this._editor.changeDecorations((f) => {
      const _ = f.deltaDecorations(g, s.map((v) => v.decoration));
      for (let v = 0; v < _.length; v++) {
        const b = s[v];
        this._decorationsMetadata.set(_[v], b);
      }
    }), p.restore(this._editor);
  }
  _fillInColors(i, e) {
    e.kind === Fw.Parameter ? (i.backgroundColor = ui(L$), i.color = ui(S$)) : e.kind === Fw.Type ? (i.backgroundColor = ui(y$), i.color = ui(w$)) : (i.backgroundColor = ui(ud), i.color = ui(cd));
  }
  _getLayoutInfo() {
    const i = this._editor.getOption(141), e = i.padding, t = this._editor.getOption(52), n = this._editor.getOption(49);
    let s = i.fontSize;
    (!s || s < 5 || s > t) && (s = t);
    const o = i.fontFamily || n;
    return { fontSize: s, fontFamily: o, padding: e, isUniform: !e && o === n && s === t };
  }
  _removeAllDecorations() {
    this._editor.removeDecorations(Array.from(this._decorationsMetadata.keys()));
    for (const i of this._decorationsMetadata.values()) i.classNameRef.dispose();
    this._decorationsMetadata.clear();
  }
};
function Ede(i) {
  return i.replace(/[ \t]/g, " ");
}
kh.ID = "editor.contrib.InlayHints", kh._MAX_DECORATORS = 1500, kh._MAX_LABEL_LEN = 43, kh = wp = xde([hp(1, fe), hp(2, ar), hp(3, rU), hp(4, ai), hp(5, Ri), hp(6, Se)], kh), dt.registerCommand("_executeInlayHintProvider", async (i, ...e) => {
  const [t, n] = e;
  vt(Ie.isUri(t)), vt(D.isIRange(n));
  const { inlayHintsProvider: s } = i.get(fe), o = await i.get(Ps).createModelReference(t);
  try {
    const r = await ng.create(s, o.object.textEditorModel, [D.lift(n)], et.None), a = r.items.map((l) => l.hint);
    return setTimeout(() => r.dispose(), 0), a;
  } finally {
    o.dispose();
  }
});
var Ide = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, o_ = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class I9 extends Xu {
  constructor(e, t, n, s) {
    super(10, t, e.item.anchor.range, n, s, !0), this.part = e;
  }
}
let Jx = class extends vS {
  constructor(i, e, t, n, s, o) {
    super(i, e, t, n, o), this._resolverService = s, this.hoverOrdinal = 6;
  }
  suggestHoverAnchor(i) {
    var e;
    if (!kh.get(this._editor) || i.target.type !== 6) return null;
    const t = (e = i.target.detail.injectedText) === null || e === void 0 ? void 0 : e.options;
    return t instanceof Nc && t.attachedData instanceof dT ? new I9(t.attachedData, this, i.event.posx, i.event.posy) : null;
  }
  computeSync() {
    return [];
  }
  computeAsync(i, e, t) {
    return i instanceof I9 ? new Pi(async (n) => {
      const { part: s } = i;
      if (await s.item.resolve(t), t.isCancellationRequested) return;
      let o, r;
      if (typeof s.item.hint.tooltip == "string" ? o = new Vn().appendText(s.item.hint.tooltip) : s.item.hint.tooltip && (o = s.item.hint.tooltip), o && n.emitOne(new Jr(this, i.range, [o], !1, 0)), zn(s.item.hint.textEdits) && n.emitOne(new Jr(this, i.range, [new Vn().appendText(m(0, "Double-click to insert"))], !1, 10001)), typeof s.part.tooltip == "string" ? r = new Vn().appendText(s.part.tooltip) : s.part.tooltip && (r = s.part.tooltip), r && n.emitOne(new Jr(this, i.range, [r], !1, 1)), s.part.location || s.part.command) {
        let d;
        const h = m(0, this._editor.getOption(78) === "altKey" ? Je ? "cmd + click" : "ctrl + click" : Je ? "option + click" : "alt + click");
        s.part.location && s.part.command ? d = new Vn().appendText(m(0, "Go to Definition ({0}), right click for more", h)) : s.part.location ? d = new Vn().appendText(m(0, "Go to Definition ({0})", h)) : s.part.command && (d = new Vn(`[${m(0, "Execute Command")}](${a = s.part.command, Ie.from({ scheme: Ue.command, path: a.id, query: a.arguments && encodeURIComponent(JSON.stringify(a.arguments)) }).toString()} "${s.part.command.title}") (${h})`, { isTrusted: !0 })), d && n.emitOne(new Jr(this, i.range, [d], !1, 1e4));
      }
      var a;
      const l = await this._resolveInlayHintLabelPartHover(s, t);
      for await (const d of l) n.emitOne(d);
    }) : Pi.EMPTY;
  }
  async _resolveInlayHintLabelPartHover(i, e) {
    if (!i.part.location) return Pi.EMPTY;
    const { uri: t, range: n } = i.part.location, s = await this._resolverService.createModelReference(t);
    try {
      const o = s.object.textEditorModel;
      return this._languageFeaturesService.hoverProvider.has(o) ? yP(this._languageFeaturesService.hoverProvider, o, new W(n.startLineNumber, n.startColumn), e).filter((r) => !$m(r.hover.contents)).map((r) => new Jr(this, i.item.anchor.range, r.hover.contents, !1, 2 + r.ordinal)) : Pi.EMPTY;
    } finally {
      s.dispose();
    }
  }
};
Jx = Ide([o_(1, Xt), o_(2, Fs), o_(3, Ye), o_(4, Ps), o_(5, fe)], Jx), ft(kh.ID, kh, 1), Rc.register(Jx);
class Mde {
  constructor(e, t, n) {
    this._editRange = e, this._originalSelection = t, this._text = n;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(this._editRange, this._text);
  }
  computeCursorState(e, t) {
    const n = t.getInverseEditOperations()[0].range;
    return this._originalSelection.isEmpty() ? new _e(n.endLineNumber, Math.min(this._originalSelection.positionColumn, n.endColumn), n.endLineNumber, Math.min(this._originalSelection.positionColumn, n.endColumn)) : new _e(n.endLineNumber, n.endColumn - this._text.length, n.endLineNumber, n.endColumn);
  }
}
var ww, Tde = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Rde = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let Zh = ww = class {
  static get(i) {
    return i.getContribution(ww.ID);
  }
  constructor(i, e) {
    this.editor = i, this.editorWorkerService = e, this.decorations = this.editor.createDecorationsCollection();
  }
  dispose() {
  }
  run(i, e) {
    var t;
    (t = this.currentRequest) === null || t === void 0 || t.cancel();
    const n = this.editor.getSelection(), s = this.editor.getModel();
    if (!s || !n) return;
    let o = n;
    if (o.startLineNumber !== o.endLineNumber) return;
    const r = new iH(this.editor, 5), a = s.uri;
    return this.editorWorkerService.canNavigateValueSet(a) ? (this.currentRequest = on((l) => this.editorWorkerService.navigateValueSet(a, o, e)), this.currentRequest.then((l) => {
      var d;
      if (!l || !l.range || !l.value || !r.validate(this.editor)) return;
      const h = D.lift(l.range);
      let c = l.range;
      const u = l.value.length - (o.endColumn - o.startColumn);
      c = { startLineNumber: c.startLineNumber, startColumn: c.startColumn, endLineNumber: c.endLineNumber, endColumn: c.startColumn + l.value.length }, u > 1 && (o = new _e(o.startLineNumber, o.startColumn, o.endLineNumber, o.endColumn + u - 1));
      const g = new Mde(h, o, l.value);
      this.editor.pushUndoStop(), this.editor.executeCommand(i, g), this.editor.pushUndoStop(), this.decorations.set([{ range: c, options: ww.DECORATION }]), (d = this.decorationRemover) === null || d === void 0 || d.cancel(), this.decorationRemover = bc(350), this.decorationRemover.then(() => this.decorations.clear()).catch(We);
    }).catch(We)) : Promise.resolve(void 0);
  }
};
Zh.ID = "editor.contrib.inPlaceReplaceController", Zh.DECORATION = Ve.register({ description: "in-place-replace", className: "valueSetReplacement" }), Zh = ww = Tde([Rde(1, Qo)], Zh);
ft(Zh.ID, Zh, 4), X(class extends he {
  constructor() {
    super({ id: "editor.action.inPlaceReplace.up", label: m(0, "Replace with Previous Value"), alias: "Replace with Previous Value", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 3159, weight: 100 } });
  }
  run(i, e) {
    const t = Zh.get(e);
    return t ? t.run(this.id, !1) : Promise.resolve(void 0);
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.inPlaceReplace.down", label: m(0, "Replace with Next Value"), alias: "Replace with Next Value", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 3161, weight: 100 } });
  }
  run(i, e) {
    const t = Zh.get(e);
    return t ? t.run(this.id, !0) : Promise.resolve(void 0);
  }
});
X(class extends he {
  constructor() {
    super({ id: "expandLineSelection", label: m(0, "Expand Line Selection"), alias: "Expand Line Selection", precondition: void 0, kbOpts: { weight: 0, kbExpr: E.textInputFocus, primary: 2090 } });
  }
  run(i, e, t) {
    if (t = t || {}, !e.hasModel()) return;
    const n = e._getViewModel();
    n.model.pushStackElement(), n.setCursorStates(t.source, 3, mn.expandLineSelection(n, n.getCursorStates())), n.revealAllCursors(t.source, !0);
  }
});
class Ade {
  constructor(e, t, n) {
    this._selection = e, this._cursors = t, this._selectionId = null, this._trimInRegexesAndStrings = n;
  }
  getEditOperations(e, t) {
    const n = function(s, o, r) {
      o.sort((c, u) => c.lineNumber === u.lineNumber ? c.column - u.column : c.lineNumber - u.lineNumber);
      for (let c = o.length - 2; c >= 0; c--) o[c].lineNumber === o[c + 1].lineNumber && o.splice(c, 1);
      const a = [];
      let l = 0, d = 0;
      const h = o.length;
      for (let c = 1, u = s.getLineCount(); c <= u; c++) {
        const g = s.getLineContent(c), p = g.length + 1;
        let f = 0;
        if (d < h && o[d].lineNumber === c && (f = o[d].column, d++, f === p) || g.length === 0) continue;
        const _ = ra(g);
        let v = 0;
        if (_ === -1) v = 1;
        else {
          if (_ === g.length - 1) continue;
          v = _ + 2;
        }
        if (!r) {
          if (!s.tokenization.hasAccurateTokensForLine(c)) continue;
          const b = s.tokenization.getLineTokens(c), C = b.getStandardTokenType(b.findTokenIndexAtOffset(v));
          if (C === 2 || C === 3) continue;
        }
        v = Math.max(f, v), a[l++] = ii.delete(new D(c, v, c, p));
      }
      return a;
    }(e, this._cursors, this._trimInRegexesAndStrings);
    for (let s = 0, o = n.length; s < o; s++) {
      const r = n[s];
      t.addEditOperation(r.range, r.text);
    }
    this._selectionId = t.trackSelection(this._selection);
  }
  computeCursorState(e, t) {
    return t.getTrackedSelection(this._selectionId);
  }
}
class aU {
  constructor(e, t, n) {
    this._selection = e, this._isCopyingDown = t, this._noop = n || !1, this._selectionDirection = 0, this._selectionId = null, this._startLineNumberDelta = 0, this._endLineNumberDelta = 0;
  }
  getEditOperations(e, t) {
    let n = this._selection;
    this._startLineNumberDelta = 0, this._endLineNumberDelta = 0, n.startLineNumber < n.endLineNumber && n.endColumn === 1 && (this._endLineNumberDelta = 1, n = n.setEndPosition(n.endLineNumber - 1, e.getLineMaxColumn(n.endLineNumber - 1)));
    const s = [];
    for (let r = n.startLineNumber; r <= n.endLineNumber; r++) s.push(e.getLineContent(r));
    const o = s.join(`
`);
    o === "" && this._isCopyingDown && (this._startLineNumberDelta++, this._endLineNumberDelta++), this._noop ? t.addEditOperation(new D(n.endLineNumber, e.getLineMaxColumn(n.endLineNumber), n.endLineNumber + 1, 1), n.endLineNumber === e.getLineCount() ? "" : `
`) : this._isCopyingDown ? t.addEditOperation(new D(n.startLineNumber, 1, n.startLineNumber, 1), o + `
`) : t.addEditOperation(new D(n.endLineNumber, e.getLineMaxColumn(n.endLineNumber), n.endLineNumber, e.getLineMaxColumn(n.endLineNumber)), `
` + o), this._selectionId = t.trackSelection(n), this._selectionDirection = this._selection.getDirection();
  }
  computeCursorState(e, t) {
    let n = t.getTrackedSelection(this._selectionId);
    if (this._startLineNumberDelta !== 0 || this._endLineNumberDelta !== 0) {
      let s = n.startLineNumber, o = n.startColumn, r = n.endLineNumber, a = n.endColumn;
      this._startLineNumberDelta !== 0 && (s += this._startLineNumberDelta, o = 1), this._endLineNumberDelta !== 0 && (r += this._endLineNumberDelta, a = 1), n = _e.createWithDirection(s, o, r, a, this._selectionDirection);
    }
    return n;
  }
}
var Pde = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Ode = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let hT = class {
  constructor(i, e, t, n) {
    this._languageConfigurationService = n, this._selection = i, this._isMovingDown = e, this._autoIndent = t, this._selectionId = null, this._moveEndLineSelectionShrink = !1;
  }
  getEditOperations(i, e) {
    const t = i.getLineCount();
    if (this._isMovingDown && this._selection.endLineNumber === t) return void (this._selectionId = e.trackSelection(this._selection));
    if (!this._isMovingDown && this._selection.startLineNumber === 1) return void (this._selectionId = e.trackSelection(this._selection));
    this._moveEndPositionDown = !1;
    let n = this._selection;
    n.startLineNumber < n.endLineNumber && n.endColumn === 1 && (this._moveEndPositionDown = !0, n = n.setEndPosition(n.endLineNumber - 1, i.getLineMaxColumn(n.endLineNumber - 1)));
    const { tabSize: s, indentSize: o, insertSpaces: r } = i.getOptions(), a = this.buildIndentConverter(s, o, r), l = { tokenization: { getLineTokens: (d) => i.tokenization.getLineTokens(d), getLanguageId: () => i.getLanguageId(), getLanguageIdAtPosition: (d, h) => i.getLanguageIdAtPosition(d, h) }, getLineContent: null };
    if (n.startLineNumber === n.endLineNumber && i.getLineMaxColumn(n.startLineNumber) === 1) {
      const d = n.startLineNumber, h = this._isMovingDown ? d + 1 : d - 1;
      i.getLineMaxColumn(h) === 1 ? e.addEditOperation(new D(1, 1, 1, 1), null) : (e.addEditOperation(new D(d, 1, d, 1), i.getLineContent(h)), e.addEditOperation(new D(h, 1, h, i.getLineMaxColumn(h)), null)), n = new _e(h, 1, h, 1);
    } else {
      let d, h;
      if (this._isMovingDown) {
        d = n.endLineNumber + 1, h = i.getLineContent(d), e.addEditOperation(new D(d - 1, i.getLineMaxColumn(d - 1), d, i.getLineMaxColumn(d)), null);
        let c = h;
        if (this.shouldAutoIndent(i, n)) {
          const u = this.matchEnterRule(i, a, s, d, n.startLineNumber - 1);
          if (u !== null)
            c = P0(u + Ks(Wt(i.getLineContent(d)), s), s, r) + this.trimStart(h);
          else {
            l.getLineContent = (f) => f === n.startLineNumber ? i.getLineContent(d) : i.getLineContent(f);
            const p = n0(this._autoIndent, l, i.getLanguageIdAtPosition(d, 1), n.startLineNumber, a, this._languageConfigurationService);
            if (p !== null) {
              const f = Wt(i.getLineContent(d)), _ = Ks(p, s);
              _ !== Ks(f, s) && (c = P0(_, s, r) + this.trimStart(h));
            }
          }
          e.addEditOperation(new D(n.startLineNumber, 1, n.startLineNumber, 1), c + `
`);
          const g = this.matchEnterRuleMovingDown(i, a, s, n.startLineNumber, d, c);
          if (g !== null) g !== 0 && this.getIndentEditsOfMovingBlock(i, e, n, s, r, g);
          else {
            l.getLineContent = (f) => f === n.startLineNumber ? c : f >= n.startLineNumber + 1 && f <= n.endLineNumber + 1 ? i.getLineContent(f - 1) : i.getLineContent(f);
            const p = n0(this._autoIndent, l, i.getLanguageIdAtPosition(d, 1), n.startLineNumber + 1, a, this._languageConfigurationService);
            if (p !== null) {
              const f = Wt(i.getLineContent(n.startLineNumber)), _ = Ks(p, s), v = Ks(f, s);
              if (_ !== v) {
                const b = _ - v;
                this.getIndentEditsOfMovingBlock(i, e, n, s, r, b);
              }
            }
          }
        } else e.addEditOperation(new D(n.startLineNumber, 1, n.startLineNumber, 1), c + `
`);
      } else if (d = n.startLineNumber - 1, h = i.getLineContent(d), e.addEditOperation(new D(d, 1, d + 1, 1), null), e.addEditOperation(new D(n.endLineNumber, i.getLineMaxColumn(n.endLineNumber), n.endLineNumber, i.getLineMaxColumn(n.endLineNumber)), `
` + h), this.shouldAutoIndent(i, n)) {
        l.getLineContent = (u) => u === d ? i.getLineContent(n.startLineNumber) : i.getLineContent(u);
        const c = this.matchEnterRule(i, a, s, n.startLineNumber, n.startLineNumber - 2);
        if (c !== null) c !== 0 && this.getIndentEditsOfMovingBlock(i, e, n, s, r, c);
        else {
          const u = n0(this._autoIndent, l, i.getLanguageIdAtPosition(n.startLineNumber, 1), d, a, this._languageConfigurationService);
          if (u !== null) {
            const g = Wt(i.getLineContent(n.startLineNumber)), p = Ks(u, s), f = Ks(g, s);
            if (p !== f) {
              const _ = p - f;
              this.getIndentEditsOfMovingBlock(i, e, n, s, r, _);
            }
          }
        }
      }
    }
    this._selectionId = e.trackSelection(n);
  }
  buildIndentConverter(i, e, t) {
    return { shiftIndent: (n) => Ko.shiftIndent(n, n.length + 1, i, e, t), unshiftIndent: (n) => Ko.unshiftIndent(n, n.length + 1, i, e, t) };
  }
  parseEnterResult(i, e, t, n, s) {
    if (s) {
      let o = s.indentation;
      s.indentAction === Oi.None || s.indentAction === Oi.Indent ? o = s.indentation + s.appendText : s.indentAction === Oi.IndentOutdent ? o = s.indentation : s.indentAction === Oi.Outdent && (o = e.unshiftIndent(s.indentation) + s.appendText);
      const r = i.getLineContent(n);
      if (this.trimStart(r).indexOf(this.trimStart(o)) >= 0) {
        const a = Wt(i.getLineContent(n));
        let l = Wt(o);
        const d = BB(i, n, this._languageConfigurationService);
        return d !== null && 2 & d && (l = e.unshiftIndent(l)), Ks(l, t) - Ks(a, t);
      }
    }
    return null;
  }
  matchEnterRuleMovingDown(i, e, t, n, s, o) {
    if (ra(o) >= 0) {
      const r = i.getLineMaxColumn(s), a = rm(this._autoIndent, i, new D(s, r, s, r), this._languageConfigurationService);
      return this.parseEnterResult(i, e, t, n, a);
    }
    {
      let r = n - 1;
      for (; r >= 1 && !(ra(i.getLineContent(r)) >= 0); )
        r--;
      if (r < 1 || n > i.getLineCount()) return null;
      const a = i.getLineMaxColumn(r), l = rm(this._autoIndent, i, new D(r, a, r, a), this._languageConfigurationService);
      return this.parseEnterResult(i, e, t, n, l);
    }
  }
  matchEnterRule(i, e, t, n, s, o) {
    let r = s;
    for (; r >= 1; ) {
      let d;
      if (d = r === s && o !== void 0 ? o : i.getLineContent(r), ra(d) >= 0) break;
      r--;
    }
    if (r < 1 || n > i.getLineCount()) return null;
    const a = i.getLineMaxColumn(r), l = rm(this._autoIndent, i, new D(r, a, r, a), this._languageConfigurationService);
    return this.parseEnterResult(i, e, t, n, l);
  }
  trimStart(i) {
    return i.replace(/^\s+/, "");
  }
  shouldAutoIndent(i, e) {
    if (this._autoIndent < 4 || !i.tokenization.isCheapToTokenize(e.startLineNumber)) return !1;
    const t = i.getLanguageIdAtPosition(e.startLineNumber, 1);
    return t === i.getLanguageIdAtPosition(e.endLineNumber, 1) && this._languageConfigurationService.getLanguageConfiguration(t).indentRulesSupport !== null;
  }
  getIndentEditsOfMovingBlock(i, e, t, n, s, o) {
    for (let r = t.startLineNumber; r <= t.endLineNumber; r++) {
      const a = Wt(i.getLineContent(r)), l = P0(Ks(a, n) + o, n, s);
      l !== a && (e.addEditOperation(new D(r, 1, r, a.length + 1), l), r === t.endLineNumber && t.endColumn <= a.length + 1 && l === "" && (this._moveEndLineSelectionShrink = !0));
    }
  }
  computeCursorState(i, e) {
    let t = e.getTrackedSelection(this._selectionId);
    return this._moveEndPositionDown && (t = t.setEndPosition(t.endLineNumber + 1, 1)), this._moveEndLineSelectionShrink && t.startLineNumber < t.endLineNumber && (t = t.setEndPosition(t.endLineNumber, 2)), t;
  }
};
hT = Pde([Ode(3, zt)], hT);
class cc {
  static getCollator() {
    return cc._COLLATOR || (cc._COLLATOR = new Intl.Collator()), cc._COLLATOR;
  }
  constructor(e, t) {
    this.selection = e, this.descending = t, this.selectionId = null;
  }
  getEditOperations(e, t) {
    const n = function(s, o, r) {
      const a = M9(s, o, r);
      return a ? ii.replace(new D(a.startLineNumber, 1, a.endLineNumber, s.getLineMaxColumn(a.endLineNumber)), a.after.join(`
`)) : null;
    }(e, this.selection, this.descending);
    n && t.addEditOperation(n.range, n.text), this.selectionId = t.trackSelection(this.selection);
  }
  computeCursorState(e, t) {
    return t.getTrackedSelection(this.selectionId);
  }
  static canRun(e, t, n) {
    if (e === null) return !1;
    const s = M9(e, t, n);
    if (!s) return !1;
    for (let o = 0, r = s.before.length; o < r; o++) if (s.before[o] !== s.after[o]) return !0;
    return !1;
  }
}
function M9(i, e, t) {
  const n = e.startLineNumber;
  let s = e.endLineNumber;
  if (e.endColumn === 1 && s--, n >= s) return null;
  const o = [];
  for (let a = n; a <= s; a++) o.push(i.getLineContent(a));
  let r = o.slice(0);
  return r.sort(cc.getCollator().compare), t === !0 && (r = r.reverse()), { startLineNumber: n, endLineNumber: s, before: o, after: r };
}
cc._COLLATOR = null;
class T9 extends he {
  constructor(e, t) {
    super(t), this.down = e;
  }
  run(e, t) {
    if (!t.hasModel()) return;
    const n = t.getSelections().map((r, a) => ({ selection: r, index: a, ignore: !1 }));
    n.sort((r, a) => D.compareRangesUsingStarts(r.selection, a.selection));
    let s = n[0];
    for (let r = 1; r < n.length; r++) {
      const a = n[r];
      s.selection.endLineNumber === a.selection.startLineNumber && (s.index < a.index ? a.ignore = !0 : (s.ignore = !0, s = a));
    }
    const o = [];
    for (const r of n) o.push(new aU(r.selection, this.down, r.ignore));
    t.pushUndoStop(), t.executeCommands(this.id, o), t.pushUndoStop();
  }
}
class R9 extends he {
  constructor(e, t) {
    super(t), this.down = e;
  }
  run(e, t) {
    const n = e.get(zt), s = [], o = t.getSelections() || [], r = t.getOption(12);
    for (const a of o) s.push(new hT(a, this.down, r, n));
    t.pushUndoStop(), t.executeCommands(this.id, s), t.pushUndoStop();
  }
}
class A9 extends he {
  constructor(e, t) {
    super(t), this.descending = e;
  }
  run(e, t) {
    if (!t.hasModel()) return;
    const n = t.getModel();
    let s = t.getSelections();
    s.length === 1 && s[0].isEmpty() && (s = [new _e(1, 1, n.getLineCount(), n.getLineMaxColumn(n.getLineCount()))]);
    for (const r of s) if (!cc.canRun(t.getModel(), r, this.descending)) return;
    const o = [];
    for (let r = 0, a = s.length; r < a; r++) o[r] = new cc(s[r], this.descending);
    t.pushUndoStop(), t.executeCommands(this.id, o), t.pushUndoStop();
  }
}
class bk extends he {
  constructor() {
    super({ id: bk.ID, label: m(0, "Trim Trailing Whitespace"), alias: "Trim Trailing Whitespace", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: Vi(2089, 2102), weight: 100 } });
  }
  run(e, t, n) {
    let s = [];
    n.reason === "auto-save" && (s = (t.getSelections() || []).map((h) => new W(h.positionLineNumber, h.positionColumn)));
    const o = t.getSelection();
    if (o === null) return;
    const r = e.get(Ye), a = t.getModel(), l = r.getValue("files.trimTrailingWhitespaceInRegexAndStrings", { overrideIdentifier: a == null ? void 0 : a.getLanguageId(), resource: a == null ? void 0 : a.uri }), d = new Ade(o, s, l);
    t.pushUndoStop(), t.executeCommands(this.id, [d]), t.pushUndoStop();
  }
}
bk.ID = "editor.action.trimTrailingWhitespace";
class P9 extends he {
  run(e, t) {
    if (!t.hasModel()) return;
    const n = t.getSelection(), s = this._getRangesToDelete(t), o = [];
    for (let l = 0, d = s.length - 1; l < d; l++) {
      const h = s[l], c = s[l + 1];
      D.intersectRanges(h, c) === null ? o.push(h) : s[l + 1] = D.plusRange(h, c);
    }
    o.push(s[s.length - 1]);
    const r = this._getEndCursorState(n, o), a = o.map((l) => ii.replace(l, ""));
    t.pushUndoStop(), t.executeEdits(this.id, a, r), t.pushUndoStop();
  }
}
class Sg extends he {
  run(e, t) {
    const n = t.getSelections();
    if (n === null) return;
    const s = t.getModel();
    if (s === null) return;
    const o = t.getOption(131), r = [];
    for (const a of n) if (a.isEmpty()) {
      const l = a.getStartPosition(), d = t.getConfiguredWordAtPosition(l);
      if (!d) continue;
      const h = new D(l.lineNumber, d.startColumn, l.lineNumber, d.endColumn), c = s.getValueInRange(h);
      r.push(ii.replace(h, this._modifyText(c, o)));
    } else {
      const l = s.getValueInRange(a);
      r.push(ii.replace(a, this._modifyText(l, o)));
    }
    t.pushUndoStop(), t.executeEdits(this.id, r), t.pushUndoStop();
  }
}
class Md {
  constructor(e, t) {
    this._pattern = e, this._flags = t, this._actual = null, this._evaluated = !1;
  }
  get() {
    if (!this._evaluated) {
      this._evaluated = !0;
      try {
        this._actual = new RegExp(this._pattern, this._flags);
      } catch {
      }
    }
    return this._actual;
  }
  isSupported() {
    return this.get() !== null;
  }
}
class a1 extends Sg {
  constructor() {
    super({ id: "editor.action.transformToTitlecase", label: m(0, "Transform to Title Case"), alias: "Transform to Title Case", precondition: E.writable });
  }
  _modifyText(e, t) {
    const n = a1.titleBoundary.get();
    return n ? e.toLocaleLowerCase().replace(n, (s) => s.toLocaleUpperCase()) : e;
  }
}
a1.titleBoundary = new Md("(^|[^\\p{L}\\p{N}']|((^|\\P{L})'))\\p{L}", "gmu");
class uc extends Sg {
  constructor() {
    super({ id: "editor.action.transformToSnakecase", label: m(0, "Transform to Snake Case"), alias: "Transform to Snake Case", precondition: E.writable });
  }
  _modifyText(e, t) {
    const n = uc.caseBoundary.get(), s = uc.singleLetters.get();
    return n && s ? e.replace(n, "$1_$2").replace(s, "$1_$2$3").toLocaleLowerCase() : e;
  }
}
uc.caseBoundary = new Md("(\\p{Ll})(\\p{Lu})", "gmu"), uc.singleLetters = new Md("(\\p{Lu}|\\p{N})(\\p{Lu})(\\p{Ll})", "gmu");
class l1 extends Sg {
  constructor() {
    super({ id: "editor.action.transformToCamelcase", label: m(0, "Transform to Camel Case"), alias: "Transform to Camel Case", precondition: E.writable });
  }
  _modifyText(e, t) {
    const n = l1.wordBoundary.get();
    if (!n) return e;
    const s = e.split(n);
    return s.shift() + s.map((o) => o.substring(0, 1).toLocaleUpperCase() + o.substring(1)).join("");
  }
}
l1.wordBoundary = new Md("[_\\s-]", "gm");
class Lg extends Sg {
  constructor() {
    super({ id: "editor.action.transformToPascalcase", label: m(0, "Transform to Pascal Case"), alias: "Transform to Pascal Case", precondition: E.writable });
  }
  _modifyText(e, t) {
    const n = Lg.wordBoundary.get(), s = Lg.wordBoundaryToMaintain.get();
    return !n || !s ? e : e.split(s).map((o) => o.split(n)).flat().map((o) => o.substring(0, 1).toLocaleUpperCase() + o.substring(1)).join("");
  }
}
Lg.wordBoundary = new Md("[_\\s-]", "gm"), Lg.wordBoundaryToMaintain = new Md("(?<=\\.)", "gm");
class nd extends Sg {
  static isSupported() {
    return [this.caseBoundary, this.singleLetters, this.underscoreBoundary].every((e) => e.isSupported());
  }
  constructor() {
    super({ id: "editor.action.transformToKebabcase", label: m(0, "Transform to Kebab Case"), alias: "Transform to Kebab Case", precondition: E.writable });
  }
  _modifyText(e, t) {
    const n = nd.caseBoundary.get(), s = nd.singleLetters.get(), o = nd.underscoreBoundary.get();
    return n && s && o ? e.replace(o, "$1-$3").replace(n, "$1-$2").replace(s, "$1-$2").toLocaleLowerCase() : e;
  }
}
nd.caseBoundary = new Md("(\\p{Ll})(\\p{Lu})", "gmu"), nd.singleLetters = new Md("(\\p{Lu}|\\p{N})(\\p{Lu}\\p{Ll})", "gmu"), nd.underscoreBoundary = new Md("(\\S)(_)(\\S)", "gm"), X(class extends T9 {
  constructor() {
    super(!1, { id: "editor.action.copyLinesUpAction", label: m(0, "Copy Line Up"), alias: "Copy Line Up", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 1552, linux: { primary: 3600 }, weight: 100 }, menuOpts: { menuId: x.MenubarSelectionMenu, group: "2_line", title: m(0, "&&Copy Line Up"), order: 1 } });
  }
}), X(class extends T9 {
  constructor() {
    super(!0, { id: "editor.action.copyLinesDownAction", label: m(0, "Copy Line Down"), alias: "Copy Line Down", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 1554, linux: { primary: 3602 }, weight: 100 }, menuOpts: { menuId: x.MenubarSelectionMenu, group: "2_line", title: m(0, "Co&&py Line Down"), order: 2 } });
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.duplicateSelection", label: m(0, "Duplicate Selection"), alias: "Duplicate Selection", precondition: E.writable, menuOpts: { menuId: x.MenubarSelectionMenu, group: "2_line", title: m(0, "&&Duplicate Selection"), order: 5 } });
  }
  run(i, e, t) {
    if (!e.hasModel()) return;
    const n = [], s = e.getSelections(), o = e.getModel();
    for (const r of s) if (r.isEmpty()) n.push(new aU(r, !0));
    else {
      const a = new _e(r.endLineNumber, r.endColumn, r.endLineNumber, r.endColumn);
      n.push(new iY(a, o.getValueInRange(r)));
    }
    e.pushUndoStop(), e.executeCommands(this.id, n), e.pushUndoStop();
  }
}), X(class extends R9 {
  constructor() {
    super(!1, { id: "editor.action.moveLinesUpAction", label: m(0, "Move Line Up"), alias: "Move Line Up", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 528, linux: { primary: 528 }, weight: 100 }, menuOpts: { menuId: x.MenubarSelectionMenu, group: "2_line", title: m(0, "Mo&&ve Line Up"), order: 3 } });
  }
}), X(class extends R9 {
  constructor() {
    super(!0, { id: "editor.action.moveLinesDownAction", label: m(0, "Move Line Down"), alias: "Move Line Down", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 530, linux: { primary: 530 }, weight: 100 }, menuOpts: { menuId: x.MenubarSelectionMenu, group: "2_line", title: m(0, "Move &&Line Down"), order: 4 } });
  }
}), X(class extends A9 {
  constructor() {
    super(!1, { id: "editor.action.sortLinesAscending", label: m(0, "Sort Lines Ascending"), alias: "Sort Lines Ascending", precondition: E.writable });
  }
}), X(class extends A9 {
  constructor() {
    super(!0, { id: "editor.action.sortLinesDescending", label: m(0, "Sort Lines Descending"), alias: "Sort Lines Descending", precondition: E.writable });
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.removeDuplicateLines", label: m(0, "Delete Duplicate Lines"), alias: "Delete Duplicate Lines", precondition: E.writable });
  }
  run(i, e) {
    if (!e.hasModel()) return;
    const t = e.getModel();
    if (t.getLineCount() === 1 && t.getLineMaxColumn(1) === 1) return;
    const n = [], s = [];
    let o = 0, r = !0, a = e.getSelections();
    a.length === 1 && a[0].isEmpty() && (a = [new _e(1, 1, t.getLineCount(), t.getLineMaxColumn(t.getLineCount()))], r = !1);
    for (const l of a) {
      const d = /* @__PURE__ */ new Set(), h = [];
      for (let p = l.startLineNumber; p <= l.endLineNumber; p++) {
        const f = t.getLineContent(p);
        d.has(f) || (h.push(f), d.add(f));
      }
      const c = new _e(l.startLineNumber, 1, l.endLineNumber, t.getLineMaxColumn(l.endLineNumber)), u = l.startLineNumber - o, g = new _e(u, 1, u + h.length - 1, h[h.length - 1].length);
      n.push(ii.replace(c, h.join(`
`))), s.push(g), o += l.endLineNumber - l.startLineNumber + 1 - h.length;
    }
    e.pushUndoStop(), e.executeEdits(this.id, n, r ? s : void 0), e.pushUndoStop();
  }
}), X(bk), X(class extends he {
  constructor() {
    super({ id: "editor.action.deleteLines", label: m(0, "Delete Line"), alias: "Delete Line", precondition: E.writable, kbOpts: { kbExpr: E.textInputFocus, primary: 3113, weight: 100 } });
  }
  run(i, e) {
    if (!e.hasModel()) return;
    const t = this._getLinesToRemove(e), n = e.getModel();
    if (n.getLineCount() === 1 && n.getLineMaxColumn(1) === 1) return;
    let s = 0;
    const o = [], r = [];
    for (let a = 0, l = t.length; a < l; a++) {
      const d = t[a];
      let h = d.startLineNumber, c = d.endLineNumber, u = 1, g = n.getLineMaxColumn(c);
      c < n.getLineCount() ? (c += 1, g = 1) : h > 1 && (h -= 1, u = n.getLineMaxColumn(h)), o.push(ii.replace(new _e(h, u, c, g), "")), r.push(new _e(h - s, d.positionColumn, h - s, d.positionColumn)), s += d.endLineNumber - d.startLineNumber + 1;
    }
    e.pushUndoStop(), e.executeEdits(this.id, o, r), e.pushUndoStop();
  }
  _getLinesToRemove(i) {
    const e = i.getSelections().map((s) => {
      let o = s.endLineNumber;
      return s.startLineNumber < s.endLineNumber && s.endColumn === 1 && (o -= 1), { startLineNumber: s.startLineNumber, selectionStartColumn: s.selectionStartColumn, endLineNumber: o, positionColumn: s.positionColumn };
    });
    e.sort((s, o) => s.startLineNumber === o.startLineNumber ? s.endLineNumber - o.endLineNumber : s.startLineNumber - o.startLineNumber);
    const t = [];
    let n = e[0];
    for (let s = 1; s < e.length; s++) n.endLineNumber + 1 >= e[s].startLineNumber ? n.endLineNumber = e[s].endLineNumber : (t.push(n), n = e[s]);
    return t.push(n), t;
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.indentLines", label: m(0, "Indent Line"), alias: "Indent Line", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 2142, weight: 100 } });
  }
  run(i, e) {
    const t = e._getViewModel();
    t && (e.pushUndoStop(), e.executeCommands(this.id, oi.indent(t.cursorConfig, e.getModel(), e.getSelections())), e.pushUndoStop());
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.outdentLines", label: m(0, "Outdent Line"), alias: "Outdent Line", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 2140, weight: 100 } });
  }
  run(i, e) {
    am.Outdent.runEditorCommand(i, e, null);
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.insertLineBefore", label: m(0, "Insert Line Above"), alias: "Insert Line Above", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 3075, weight: 100 } });
  }
  run(i, e) {
    const t = e._getViewModel();
    t && (e.pushUndoStop(), e.executeCommands(this.id, oi.lineInsertBefore(t.cursorConfig, e.getModel(), e.getSelections())));
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.insertLineAfter", label: m(0, "Insert Line Below"), alias: "Insert Line Below", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 2051, weight: 100 } });
  }
  run(i, e) {
    const t = e._getViewModel();
    t && (e.pushUndoStop(), e.executeCommands(this.id, oi.lineInsertAfter(t.cursorConfig, e.getModel(), e.getSelections())));
  }
}), X(class extends P9 {
  constructor() {
    super({ id: "deleteAllLeft", label: m(0, "Delete All Left"), alias: "Delete All Left", precondition: E.writable, kbOpts: { kbExpr: E.textInputFocus, primary: 0, mac: { primary: 2049 }, weight: 100 } });
  }
  _getEndCursorState(i, e) {
    let t = null;
    const n = [];
    let s = 0;
    return e.forEach((o) => {
      let r;
      if (o.endColumn === 1 && s > 0) {
        const a = o.startLineNumber - s;
        r = new _e(a, o.startColumn, a, o.startColumn);
      } else r = new _e(o.startLineNumber, o.startColumn, o.startLineNumber, o.startColumn);
      s += o.endLineNumber - o.startLineNumber, o.intersectRanges(i) ? t = r : n.push(r);
    }), t && n.unshift(t), n;
  }
  _getRangesToDelete(i) {
    const e = i.getSelections();
    if (e === null) return [];
    let t = e;
    const n = i.getModel();
    return n === null ? [] : (t.sort(D.compareRangesUsingStarts), t = t.map((s) => {
      if (s.isEmpty()) {
        if (s.startColumn === 1) {
          const o = Math.max(1, s.startLineNumber - 1), r = s.startLineNumber === 1 ? 1 : n.getLineLength(o) + 1;
          return new D(o, r, s.startLineNumber, 1);
        }
        return new D(s.startLineNumber, 1, s.startLineNumber, s.startColumn);
      }
      return new D(s.startLineNumber, 1, s.endLineNumber, s.endColumn);
    }), t);
  }
}), X(class extends P9 {
  constructor() {
    super({ id: "deleteAllRight", label: m(0, "Delete All Right"), alias: "Delete All Right", precondition: E.writable, kbOpts: { kbExpr: E.textInputFocus, primary: 0, mac: { primary: 297, secondary: [2068] }, weight: 100 } });
  }
  _getEndCursorState(i, e) {
    let t = null;
    const n = [];
    for (let s = 0, o = e.length, r = 0; s < o; s++) {
      const a = e[s], l = new _e(a.startLineNumber - r, a.startColumn, a.startLineNumber - r, a.startColumn);
      a.intersectRanges(i) ? t = l : n.push(l);
    }
    return t && n.unshift(t), n;
  }
  _getRangesToDelete(i) {
    const e = i.getModel();
    if (e === null) return [];
    const t = i.getSelections();
    if (t === null) return [];
    const n = t.map((s) => {
      if (s.isEmpty()) {
        const o = e.getLineMaxColumn(s.startLineNumber);
        return s.startColumn === o ? new D(s.startLineNumber, s.startColumn, s.startLineNumber + 1, 1) : new D(s.startLineNumber, s.startColumn, s.startLineNumber, o);
      }
      return s;
    });
    return n.sort(D.compareRangesUsingStarts), n;
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.joinLines", label: m(0, "Join Lines"), alias: "Join Lines", precondition: E.writable, kbOpts: { kbExpr: E.editorTextFocus, primary: 0, mac: { primary: 296 }, weight: 100 } });
  }
  run(i, e) {
    const t = e.getSelections();
    if (t === null) return;
    let n = e.getSelection();
    if (n === null) return;
    t.sort(D.compareRangesUsingStarts);
    const s = [], o = t.reduce((c, u) => c.isEmpty() ? c.endLineNumber === u.startLineNumber ? (n.equalsSelection(c) && (n = u), u) : u.startLineNumber > c.endLineNumber + 1 ? (s.push(c), u) : new _e(c.startLineNumber, c.startColumn, u.endLineNumber, u.endColumn) : u.startLineNumber > c.endLineNumber ? (s.push(c), u) : new _e(c.startLineNumber, c.startColumn, u.endLineNumber, u.endColumn));
    s.push(o);
    const r = e.getModel();
    if (r === null) return;
    const a = [], l = [];
    let d = n, h = 0;
    for (let c = 0, u = s.length; c < u; c++) {
      const g = s[c], p = g.startLineNumber, f = 1;
      let _, v, b = 0;
      const C = r.getLineLength(g.endLineNumber) - g.endColumn;
      if (g.isEmpty() || g.startLineNumber === g.endLineNumber) {
        const L = g.getStartPosition();
        L.lineNumber < r.getLineCount() ? (_ = p + 1, v = r.getLineMaxColumn(_)) : (_ = L.lineNumber, v = r.getLineMaxColumn(L.lineNumber));
      } else _ = g.endLineNumber, v = r.getLineMaxColumn(_);
      let w = r.getLineContent(p);
      for (let L = p + 1; L <= _; L++) {
        const k = r.getLineContent(L), N = r.getLineFirstNonWhitespaceColumn(L);
        if (N >= 1) {
          let A = !0;
          w === "" && (A = !1), !A || w.charAt(w.length - 1) !== " " && w.charAt(w.length - 1) !== "	" || (A = !1, w = w.replace(/[\s\uFEFF\xA0]+$/g, " "));
          const B = k.substr(N - 1);
          w += (A ? " " : "") + B, b = A ? B.length + 1 : B.length;
        } else b = 0;
      }
      const y = new D(p, f, _, v);
      if (!y.isEmpty()) {
        let L;
        g.isEmpty() ? (a.push(ii.replace(y, w)), L = new _e(y.startLineNumber - h, w.length - b + 1, p - h, w.length - b + 1)) : g.startLineNumber === g.endLineNumber ? (a.push(ii.replace(y, w)), L = new _e(g.startLineNumber - h, g.startColumn, g.endLineNumber - h, g.endColumn)) : (a.push(ii.replace(y, w)), L = new _e(g.startLineNumber - h, g.startColumn, g.startLineNumber - h, w.length - C)), D.intersectRanges(y, n) !== null ? d = L : l.push(L);
      }
      h += y.endLineNumber - y.startLineNumber;
    }
    l.unshift(d), e.pushUndoStop(), e.executeEdits(this.id, a, l), e.pushUndoStop();
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.transpose", label: m(0, "Transpose Characters around the Cursor"), alias: "Transpose Characters around the Cursor", precondition: E.writable });
  }
  run(i, e) {
    const t = e.getSelections();
    if (t === null) return;
    const n = e.getModel();
    if (n === null) return;
    const s = [];
    for (let o = 0, r = t.length; o < r; o++) {
      const a = t[o];
      if (!a.isEmpty()) continue;
      const l = a.getStartPosition(), d = n.getLineMaxColumn(l.lineNumber);
      if (l.column >= d) {
        if (l.lineNumber === n.getLineCount()) continue;
        const h = new D(l.lineNumber, Math.max(1, l.column - 1), l.lineNumber + 1, 1), c = n.getValueInRange(h).split("").reverse().join("");
        s.push(new Dn(new _e(l.lineNumber, Math.max(1, l.column - 1), l.lineNumber + 1, 1), c));
      } else {
        const h = new D(l.lineNumber, Math.max(1, l.column - 1), l.lineNumber, l.column + 1), c = n.getValueInRange(h).split("").reverse().join("");
        s.push(new jR(h, c, new _e(l.lineNumber, l.column + 1, l.lineNumber, l.column + 1)));
      }
    }
    e.pushUndoStop(), e.executeCommands(this.id, s), e.pushUndoStop();
  }
}), X(class extends Sg {
  constructor() {
    super({ id: "editor.action.transformToUppercase", label: m(0, "Transform to Uppercase"), alias: "Transform to Uppercase", precondition: E.writable });
  }
  _modifyText(i, e) {
    return i.toLocaleUpperCase();
  }
}), X(class extends Sg {
  constructor() {
    super({ id: "editor.action.transformToLowercase", label: m(0, "Transform to Lowercase"), alias: "Transform to Lowercase", precondition: E.writable });
  }
  _modifyText(i, e) {
    return i.toLocaleLowerCase();
  }
}), uc.caseBoundary.isSupported() && uc.singleLetters.isSupported() && X(uc), l1.wordBoundary.isSupported() && X(l1), Lg.wordBoundary.isSupported() && X(Lg), a1.titleBoundary.isSupported() && X(a1), nd.isSupported() && X(nd);
var yw, Fde = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, vC = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const lU = new ae("LinkedEditingInputVisible", !1);
let Yh = yw = class extends V {
  static get(i) {
    return i.getContribution(yw.ID);
  }
  constructor(i, e, t, n, s) {
    super(), this.languageConfigurationService = n, this._syncRangesToken = 0, this._localToDispose = this._register(new G()), this._editor = i, this._providers = t.linkedEditingRangeProvider, this._enabled = !1, this._visibleContextKey = lU.bindTo(e), this._debounceInformation = s.for(this._providers, "Linked Editing", { max: 200 }), this._currentDecorations = this._editor.createDecorationsCollection(), this._languageWordPattern = null, this._currentWordPattern = null, this._ignoreChangeEvent = !1, this._localToDispose = this._register(new G()), this._rangeUpdateTriggerPromise = null, this._rangeSyncTriggerPromise = null, this._currentRequestCts = null, this._currentRequestPosition = null, this._currentRequestModelVersion = null, this._register(this._editor.onDidChangeModel(() => this.reinitialize(!0))), this._register(this._editor.onDidChangeConfiguration((o) => {
      (o.hasChanged(70) || o.hasChanged(93)) && this.reinitialize(!1);
    })), this._register(this._providers.onDidChange(() => this.reinitialize(!1))), this._register(this._editor.onDidChangeModelLanguage(() => this.reinitialize(!0))), this.reinitialize(!0);
  }
  reinitialize(i) {
    const e = this._editor.getModel(), t = e !== null && (this._editor.getOption(70) || this._editor.getOption(93)) && this._providers.has(e);
    if (t === this._enabled && !i || (this._enabled = t, this.clearRanges(), this._localToDispose.clear(), !t || e === null)) return;
    this._localToDispose.add(se.runAndSubscribe(e.onDidChangeLanguageConfiguration, () => {
      this._languageWordPattern = this.languageConfigurationService.getLanguageConfiguration(e.getLanguageId()).getWordDefinition();
    }));
    const n = new Sr(this._debounceInformation.get(e)), s = () => {
      var a;
      this._rangeUpdateTriggerPromise = n.trigger(() => this.updateRanges(), (a = this._debounceDuration) !== null && a !== void 0 ? a : this._debounceInformation.get(e));
    }, o = new Sr(0), r = (a) => {
      this._rangeSyncTriggerPromise = o.trigger(() => this._syncRanges(a));
    };
    this._localToDispose.add(this._editor.onDidChangeCursorPosition(() => {
      s();
    })), this._localToDispose.add(this._editor.onDidChangeModelContent((a) => {
      if (!this._ignoreChangeEvent && this._currentDecorations.length > 0) {
        const l = this._currentDecorations.getRange(0);
        if (l && a.changes.every((d) => l.intersectRanges(d.range))) return void r(this._syncRangesToken);
      }
      s();
    })), this._localToDispose.add({ dispose: () => {
      n.dispose(), o.dispose();
    } }), this.updateRanges();
  }
  _syncRanges(i) {
    if (!this._editor.hasModel() || i !== this._syncRangesToken || this._currentDecorations.length === 0) return;
    const e = this._editor.getModel(), t = this._currentDecorations.getRange(0);
    if (!t || t.startLineNumber !== t.endLineNumber) return this.clearRanges();
    const n = e.getValueInRange(t);
    if (this._currentWordPattern) {
      const o = n.match(this._currentWordPattern);
      if ((o ? o[0].length : 0) !== n.length) return this.clearRanges();
    }
    const s = [];
    for (let o = 1, r = this._currentDecorations.length; o < r; o++) {
      const a = this._currentDecorations.getRange(o);
      if (a) if (a.startLineNumber !== a.endLineNumber) s.push({ range: a, text: n });
      else {
        let l = e.getValueInRange(a), d = n, h = a.startColumn, c = a.endColumn;
        const u = fc(l, d);
        h += u, l = l.substr(u), d = d.substr(u);
        const g = Vw(l, d);
        c -= g, l = l.substr(0, l.length - g), d = d.substr(0, d.length - g), h === c && d.length === 0 || s.push({ range: new D(a.startLineNumber, h, a.endLineNumber, c), text: d });
      }
    }
    if (s.length !== 0) try {
      this._editor.popUndoStop(), this._ignoreChangeEvent = !0;
      const o = this._editor._getViewModel().getPrevEditOperationType();
      this._editor.executeEdits("linkedEditing", s), this._editor._getViewModel().setPrevEditOperationType(o);
    } finally {
      this._ignoreChangeEvent = !1;
    }
  }
  dispose() {
    this.clearRanges(), super.dispose();
  }
  clearRanges() {
    this._visibleContextKey.set(!1), this._currentDecorations.clear(), this._currentRequestCts && (this._currentRequestCts.cancel(), this._currentRequestCts = null, this._currentRequestPosition = null);
  }
  async updateRanges(i = !1) {
    if (!this._editor.hasModel()) return void this.clearRanges();
    const e = this._editor.getPosition();
    if (!this._enabled && !i || this._editor.getSelections().length > 1) return void this.clearRanges();
    const t = this._editor.getModel(), n = t.getVersionId();
    if (this._currentRequestPosition && this._currentRequestModelVersion === n) {
      if (e.equals(this._currentRequestPosition)) return;
      if (this._currentDecorations.length > 0) {
        const o = this._currentDecorations.getRange(0);
        if (o && o.containsPosition(e)) return;
      }
    }
    this.clearRanges(), this._currentRequestPosition = e, this._currentRequestModelVersion = n;
    const s = this._currentRequestCts = new Ci();
    try {
      const o = new Rn(!1), r = await dU(this._providers, t, e, s.token);
      if (this._debounceInformation.update(t, o.elapsed()), s !== this._currentRequestCts || (this._currentRequestCts = null, n !== t.getVersionId())) return;
      let a = [];
      r != null && r.ranges && (a = r.ranges), this._currentWordPattern = (r == null ? void 0 : r.wordPattern) || this._languageWordPattern;
      let l = !1;
      for (let h = 0, c = a.length; h < c; h++) if (D.containsPosition(a[h], e)) {
        if (l = !0, h !== 0) {
          const u = a[h];
          a.splice(h, 1), a.unshift(u);
        }
        break;
      }
      if (!l) return void this.clearRanges();
      const d = a.map((h) => ({ range: h, options: yw.DECORATION }));
      this._visibleContextKey.set(!0), this._currentDecorations.set(d), this._syncRangesToken++;
    } catch (o) {
      Sa(o) || We(o), this._currentRequestCts !== s && this._currentRequestCts || this.clearRanges();
    }
  }
};
Yh.ID = "editor.contrib.linkedEditing", Yh.DECORATION = Ve.register({ description: "linked-editing", stickiness: 0, className: "linked-editing-decoration" }), Yh = yw = Fde([vC(1, Te), vC(2, fe), vC(3, zt), vC(4, ar)], Yh);
function dU(i, e, t, n) {
  return cR(i.ordered(e).map((s) => async () => {
    try {
      return await s.provideLinkedEditingRanges(e, t, n);
    } catch (o) {
      return void Ni(o);
    }
  }), (s) => !!s && zn(s == null ? void 0 : s.ranges));
}
re(new (Zi.bindToContribution(Yh.get))({ id: "cancelLinkedEditingInput", precondition: lU, handler: (i) => i.clearRanges(), kbOpts: { kbExpr: E.editorTextFocus, weight: 199, primary: 9, secondary: [1033] } })), I("editor.linkedEditingBackground", { dark: z.fromHex("#f00").transparent(0.3), light: z.fromHex("#f00").transparent(0.3), hcDark: z.fromHex("#f00").transparent(0.3), hcLight: z.white }, m(0, "Background color when the editor auto renames on type.")), qa("_executeLinkedEditingProvider", (i, e, t) => {
  const { linkedEditingRangeProvider: n } = i.get(fe);
  return dU(n, e, t, et.None);
}), ft(Yh.ID, Yh, 1), X(class extends he {
  constructor() {
    super({ id: "editor.action.linkedEditing", label: m(0, "Start Linked Editing"), alias: "Start Linked Editing", precondition: q.and(E.writable, E.hasRenameProvider), kbOpts: { kbExpr: E.editorTextFocus, primary: 3132, weight: 100 } });
  }
  runCommand(i, e) {
    const t = i.get(mt), [n, s] = Array.isArray(e) && e || [void 0, void 0];
    return Ie.isUri(n) && W.isIPosition(s) ? t.openCodeEditor({ resource: n }, t.getActiveCodeEditor()).then((o) => {
      o && (o.setPosition(s), o.invokeWithinContext((r) => (this.reportTelemetry(r, o), this.run(r, o))));
    }, We) : super.runCommand(i, e);
  }
  run(i, e) {
    const t = Yh.get(e);
    return t ? Promise.resolve(t.updateRanges(!0)) : Promise.resolve();
  }
});
let Bde = class {
  constructor(i, e) {
    this._link = i, this._provider = e;
  }
  toJSON() {
    return { range: this.range, url: this.url, tooltip: this.tooltip };
  }
  get range() {
    return this._link.range;
  }
  get url() {
    return this._link.url;
  }
  get tooltip() {
    return this._link.tooltip;
  }
  async resolve(i) {
    return this._link.url ? this._link.url : typeof this._provider.resolveLink == "function" ? Promise.resolve(this._provider.resolveLink(this._link, i)).then((e) => (this._link = e || this._link, this._link.url ? this.resolve(i) : Promise.reject(new Error("missing")))) : Promise.reject(new Error("missing"));
  }
};
class IS {
  constructor(e) {
    this._disposables = new G();
    let t = [];
    for (const [n, s] of e) {
      const o = n.links.map((r) => new Bde(r, s));
      t = IS._union(t, o), XT(n) && this._disposables.add(n);
    }
    this.links = t;
  }
  dispose() {
    this._disposables.dispose(), this.links.length = 0;
  }
  static _union(e, t) {
    const n = [];
    let s, o, r, a;
    for (s = 0, r = 0, o = e.length, a = t.length; s < o && r < a; ) {
      const l = e[s], d = t[r];
      if (D.areIntersectingOrTouching(l.range, d.range)) {
        s++;
        continue;
      }
      D.compareRangesUsingStarts(l.range, d.range) < 0 ? (n.push(l), s++) : (n.push(d), r++);
    }
    for (; s < o; s++) n.push(e[s]);
    for (; r < a; r++) n.push(t[r]);
    return n;
  }
}
function hU(i, e, t) {
  const n = [], s = i.ordered(e).reverse().map((o, r) => Promise.resolve(o.provideLinks(e, t)).then((a) => {
    a && (n[r] = [a, o]);
  }, Ni));
  return Promise.all(s).then(() => {
    const o = new IS(ca(n));
    return t.isCancellationRequested ? (o.dispose(), new IS([])) : o;
  });
}
dt.registerCommand("_executeLinkProvider", async (i, ...e) => {
  let [t, n] = e;
  vt(t instanceof Ie), typeof n != "number" && (n = 0);
  const { linkProvider: s } = i.get(fe), o = i.get(ni).getModel(t);
  if (!o) return [];
  const r = await hU(s, o, et.None);
  if (!r) return [];
  for (let l = 0; l < Math.min(n, r.links.length); l++) await r.links[l].resolve(et.None);
  const a = r.links.slice(0);
  return r.dispose(), a;
});
var cT, Wde = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, bC = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let Nm = cT = class extends V {
  static get(i) {
    return i.getContribution(cT.ID);
  }
  constructor(i, e, t, n, s) {
    super(), this.editor = i, this.openerService = e, this.notificationService = t, this.languageFeaturesService = n, this.providers = this.languageFeaturesService.linkProvider, this.debounceInformation = s.for(this.providers, "Links", { min: 1e3, max: 4e3 }), this.computeLinks = this._register(new It(() => this.computeLinksNow(), 1e3)), this.computePromise = null, this.activeLinksList = null, this.currentOccurrences = {}, this.activeLinkDecorationId = null;
    const o = this._register(new JL(i));
    this._register(o.onMouseMoveOrRelevantKeyDown(([r, a]) => {
      this._onEditorMouseMove(r, a);
    })), this._register(o.onExecute((r) => {
      this.onEditorMouseUp(r);
    })), this._register(o.onCancel((r) => {
      this.cleanUpActiveLinkDecoration();
    })), this._register(i.onDidChangeConfiguration((r) => {
      r.hasChanged(71) && (this.updateDecorations([]), this.stop(), this.computeLinks.schedule(0));
    })), this._register(i.onDidChangeModelContent((r) => {
      this.editor.hasModel() && this.computeLinks.schedule(this.debounceInformation.get(this.editor.getModel()));
    })), this._register(i.onDidChangeModel((r) => {
      this.currentOccurrences = {}, this.activeLinkDecorationId = null, this.stop(), this.computeLinks.schedule(0);
    })), this._register(i.onDidChangeModelLanguage((r) => {
      this.stop(), this.computeLinks.schedule(0);
    })), this._register(this.providers.onDidChange((r) => {
      this.stop(), this.computeLinks.schedule(0);
    })), this.computeLinks.schedule(0);
  }
  async computeLinksNow() {
    if (!this.editor.hasModel() || !this.editor.getOption(71)) return;
    const i = this.editor.getModel();
    if (!i.isTooLargeForSyncing() && this.providers.has(i)) {
      this.activeLinksList && (this.activeLinksList.dispose(), this.activeLinksList = null), this.computePromise = on((e) => hU(this.providers, i, e));
      try {
        const e = new Rn(!1);
        if (this.activeLinksList = await this.computePromise, this.debounceInformation.update(i, e.elapsed()), i.isDisposed()) return;
        this.updateDecorations(this.activeLinksList.links);
      } catch (e) {
        We(e);
      } finally {
        this.computePromise = null;
      }
    }
  }
  updateDecorations(i) {
    const e = this.editor.getOption(78) === "altKey", t = [], n = Object.keys(this.currentOccurrences);
    for (const o of n) {
      const r = this.currentOccurrences[o];
      t.push(r.decorationId);
    }
    const s = [];
    if (i) for (const o of i) s.push(Em.decoration(o, e));
    this.editor.changeDecorations((o) => {
      const r = o.deltaDecorations(t, s);
      this.currentOccurrences = {}, this.activeLinkDecorationId = null;
      for (let a = 0, l = r.length; a < l; a++) {
        const d = new Em(i[a], r[a]);
        this.currentOccurrences[d.decorationId] = d;
      }
    });
  }
  _onEditorMouseMove(i, e) {
    const t = this.editor.getOption(78) === "altKey";
    if (this.isEnabled(i, e)) {
      this.cleanUpActiveLinkDecoration();
      const n = this.getLinkOccurrence(i.target.position);
      n && this.editor.changeDecorations((s) => {
        n.activate(s, t), this.activeLinkDecorationId = n.decorationId;
      });
    } else this.cleanUpActiveLinkDecoration();
  }
  cleanUpActiveLinkDecoration() {
    const i = this.editor.getOption(78) === "altKey";
    if (this.activeLinkDecorationId) {
      const e = this.currentOccurrences[this.activeLinkDecorationId];
      e && this.editor.changeDecorations((t) => {
        e.deactivate(t, i);
      }), this.activeLinkDecorationId = null;
    }
  }
  onEditorMouseUp(i) {
    if (!this.isEnabled(i)) return;
    const e = this.getLinkOccurrence(i.target.position);
    e && this.openLinkOccurrence(e, i.hasSideBySideModifier, !0);
  }
  openLinkOccurrence(i, e, t = !1) {
    if (!this.openerService) return;
    const { link: n } = i;
    n.resolve(et.None).then((s) => {
      if (typeof s == "string" && this.editor.hasModel()) {
        const o = this.editor.getModel().uri;
        if (o.scheme === Ue.file && s.startsWith(`${Ue.file}:`)) {
          const r = Ie.parse(s);
          if (r.scheme === Ue.file) {
            const a = Ta(r);
            let l = null;
            a.startsWith("/./") || a.startsWith("\\.\\") ? l = `.${a.substr(1)}` : (a.startsWith("//./") || a.startsWith("\\\\.\\")) && (l = `.${a.substr(2)}`), l && (s = kX(o, l));
          }
        }
      }
      return this.openerService.open(s, { openToSide: e, fromUserGesture: t, allowContributedOpeners: !0, allowCommands: !0, fromWorkspace: !0 });
    }, (s) => {
      const o = s instanceof Error ? s.message : s;
      o === "invalid" ? this.notificationService.warn(m(0, "Failed to open this link because it is not well-formed: {0}", n.url.toString())) : o === "missing" ? this.notificationService.warn(m(0, "Failed to open this link because its target is missing.")) : We(s);
    });
  }
  getLinkOccurrence(i) {
    if (!this.editor.hasModel() || !i) return null;
    const e = this.editor.getModel().getDecorationsInRange({ startLineNumber: i.lineNumber, startColumn: i.column, endLineNumber: i.lineNumber, endColumn: i.column }, 0, !0);
    for (const t of e) {
      const n = this.currentOccurrences[t.id];
      if (n) return n;
    }
    return null;
  }
  isEnabled(i, e) {
    return !!(i.target.type === 6 && (i.hasTriggerModifier || e && e.keyCodeIsTriggerKey));
  }
  stop() {
    var i;
    this.computeLinks.cancel(), this.activeLinksList && ((i = this.activeLinksList) === null || i === void 0 || i.dispose(), this.activeLinksList = null), this.computePromise && (this.computePromise.cancel(), this.computePromise = null);
  }
  dispose() {
    super.dispose(), this.stop();
  }
};
Nm.ID = "editor.linkDetector", Nm = cT = Wde([bC(1, Fs), bC(2, Ri), bC(3, fe), bC(4, ar)], Nm);
const Vde = Ve.register({ description: "detected-link", stickiness: 1, collapseOnReplaceEdit: !0, inlineClassName: "detected-link" }), Hde = Ve.register({ description: "detected-link-active", stickiness: 1, collapseOnReplaceEdit: !0, inlineClassName: "detected-link-active" });
class Em {
  static decoration(e, t) {
    return { range: e.range, options: Em._getOptions(e, t, !1) };
  }
  static _getOptions(e, t, n) {
    const s = { ...n ? Hde : Vde };
    return s.hoverMessage = function(o, r) {
      const a = o.url && /^command:/i.test(o.url.toString()), l = o.tooltip ? o.tooltip : m(0, a ? "Execute command" : "Follow link"), d = m(0, r ? Je ? "cmd + click" : "ctrl + click" : Je ? "option + click" : "alt + click");
      if (o.url) {
        let h = "";
        if (/^command:/i.test(o.url.toString())) {
          const c = o.url.toString().match(/^command:([^?#]+)/);
          c && (h = m(0, "Execute command {0}", c[1]));
        }
        return new Vn("", !0).appendLink(o.url.toString(!0).replace(/ /g, "%20"), l, h).appendMarkdown(` (${d})`);
      }
      return new Vn().appendText(`${l} (${d})`);
    }(e, t), s;
  }
  constructor(e, t) {
    this.link = e, this.decorationId = t;
  }
  activate(e, t) {
    e.changeDecorationOptions(this.decorationId, Em._getOptions(this.link, t, !0));
  }
  deactivate(e, t) {
    e.changeDecorationOptions(this.decorationId, Em._getOptions(this.link, t, !1));
  }
}
ft(Nm.ID, Nm, 1), X(class extends he {
  constructor() {
    super({ id: "editor.action.openLink", label: m(0, "Open Link"), alias: "Open Link", precondition: void 0 });
  }
  run(i, e) {
    const t = Nm.get(e);
    if (!t || !e.hasModel()) return;
    const n = e.getSelections();
    for (const s of n) {
      const o = t.getLinkOccurrence(s.getEndPosition());
      o && t.openLinkOccurrence(o, !1);
    }
  }
});
class eN extends V {
  constructor(e) {
    super(), this._editor = e, this._register(this._editor.onMouseDown((t) => {
      const n = this._editor.getOption(117);
      n >= 0 && t.target.type === 6 && t.target.position.column >= n && this._editor.updateOptions({ stopRenderingLineAfter: -1 });
    }));
  }
}
eN.ID = "editor.contrib.longLinesHelper", ft(eN.ID, eN, 2);
const CC = I("editor.wordHighlightBackground", { dark: "#575757B8", light: "#57575740", hcDark: null, hcLight: null }, m(0, "Background color of a symbol during read-access, like reading a variable. The color must not be opaque so as not to hide underlying decorations."), !0);
I("editor.wordHighlightStrongBackground", { dark: "#004972B8", light: "#0e639c40", hcDark: null, hcLight: null }, m(0, "Background color of a symbol during write-access, like writing to a variable. The color must not be opaque so as not to hide underlying decorations."), !0), I("editor.wordHighlightTextBackground", { light: CC, dark: CC, hcDark: CC, hcLight: CC }, m(0, "Background color of a textual occurrence for a symbol. The color must not be opaque so as not to hide underlying decorations."), !0);
const wC = I("editor.wordHighlightBorder", { light: null, dark: null, hcDark: Zt, hcLight: Zt }, m(0, "Border color of a symbol during read-access, like reading a variable."));
I("editor.wordHighlightStrongBorder", { light: null, dark: null, hcDark: Zt, hcLight: Zt }, m(0, "Border color of a symbol during write-access, like writing to a variable.")), I("editor.wordHighlightTextBorder", { light: wC, dark: wC, hcDark: wC, hcLight: wC }, m(0, "Border color of a textual occurrence for a symbol."));
const zde = I("editorOverviewRuler.wordHighlightForeground", { dark: "#A0A0A0CC", light: "#A0A0A0CC", hcDark: "#A0A0A0CC", hcLight: "#A0A0A0CC" }, m(0, "Overview ruler marker color for symbol highlights. The color must not be opaque so as not to hide underlying decorations."), !0), Ude = I("editorOverviewRuler.wordHighlightStrongForeground", { dark: "#C0A0C0CC", light: "#C0A0C0CC", hcDark: "#C0A0C0CC", hcLight: "#C0A0C0CC" }, m(0, "Overview ruler marker color for write-access symbol highlights. The color must not be opaque so as not to hide underlying decorations."), !0), Kde = I("editorOverviewRuler.wordHighlightTextForeground", { dark: C_, light: C_, hcDark: C_, hcLight: C_ }, m(0, "Overview ruler marker color of a textual occurrence for a symbol. The color must not be opaque so as not to hide underlying decorations."), !0), jde = Ve.register({ description: "word-highlight-strong", stickiness: 1, className: "wordHighlightStrong", overviewRuler: { color: ui(Ude), position: Do.Center }, minimap: { color: ui(rL), position: 1 } }), qde = Ve.register({ description: "word-highlight-text", stickiness: 1, className: "wordHighlightText", overviewRuler: { color: ui(Kde), position: Do.Center }, minimap: { color: ui(rL), position: 1 } }), $de = Ve.register({ description: "selection-highlight-overview", stickiness: 1, className: "selectionHighlight", overviewRuler: { color: ui(C_), position: Do.Center }, minimap: { color: ui(rL), position: 1 } }), Gde = Ve.register({ description: "selection-highlight", stickiness: 1, className: "selectionHighlight" }), Zde = Ve.register({ description: "word-highlight", stickiness: 1, className: "wordHighlight", overviewRuler: { color: ui(zde), position: Do.Center }, minimap: { color: ui(rL), position: 1 } });
function Yde(i) {
  return i ? Gde : $de;
}
rr((i, e) => {
  const t = i.getColor(OR);
  t && e.addRule(`.monaco-editor .selectionHighlight { background-color: ${t.transparent(0.5)}; }`);
});
var uT, Xde = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Qde = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
function ch(i, e) {
  const t = e.filter((n) => !i.find((s) => s.equals(n)));
  if (t.length >= 1) {
    const n = t.map((s) => `line ${s.viewState.position.lineNumber} column ${s.viewState.position.column}`).join(", ");
    vl(t.length === 1 ? m(0, "Cursor added: {0}", n) : m(0, "Cursors added: {0}", n));
  }
}
class yC {
  constructor(e, t, n) {
    this.selections = e, this.revealRange = t, this.revealScrollType = n;
  }
}
class d1 {
  static create(e, t) {
    if (!e.hasModel()) return null;
    const n = t.getState();
    if (!e.hasTextFocus() && n.isRevealed && n.searchString.length > 0) return new d1(e, t, !1, n.searchString, n.wholeWord, n.matchCase, null);
    let s, o, r = !1;
    const a = e.getSelections();
    a.length === 1 && a[0].isEmpty() ? (r = !0, s = !0, o = !0) : (s = n.wholeWord, o = n.matchCase);
    const l = e.getSelection();
    let d, h = null;
    if (l.isEmpty()) {
      const c = e.getConfiguredWordAtPosition(l.getStartPosition());
      if (!c) return null;
      d = c.word, h = new _e(l.startLineNumber, c.startColumn, l.startLineNumber, c.endColumn);
    } else d = e.getModel().getValueInRange(l).replace(/\r\n/g, `
`);
    return new d1(e, t, r, d, s, o, h);
  }
  constructor(e, t, n, s, o, r, a) {
    this._editor = e, this.findController = t, this.isDisconnectedFromFindController = n, this.searchText = s, this.wholeWord = o, this.matchCase = r, this.currentMatch = a;
  }
  addSelectionToNextFindMatch() {
    if (!this._editor.hasModel()) return null;
    const e = this._getNextMatch();
    if (!e) return null;
    const t = this._editor.getSelections();
    return new yC(t.concat(e), e, 0);
  }
  moveSelectionToNextFindMatch() {
    if (!this._editor.hasModel()) return null;
    const e = this._getNextMatch();
    if (!e) return null;
    const t = this._editor.getSelections();
    return new yC(t.slice(0, t.length - 1).concat(e), e, 0);
  }
  _getNextMatch() {
    if (!this._editor.hasModel()) return null;
    if (this.currentMatch) {
      const s = this.currentMatch;
      return this.currentMatch = null, s;
    }
    this.findController.highlightFindOptions();
    const e = this._editor.getSelections(), t = e[e.length - 1], n = this._editor.getModel().findNextMatch(this.searchText, t.getEndPosition(), !1, this.matchCase, this.wholeWord ? this._editor.getOption(131) : null, !1);
    return n ? new _e(n.range.startLineNumber, n.range.startColumn, n.range.endLineNumber, n.range.endColumn) : null;
  }
  addSelectionToPreviousFindMatch() {
    if (!this._editor.hasModel()) return null;
    const e = this._getPreviousMatch();
    if (!e) return null;
    const t = this._editor.getSelections();
    return new yC(t.concat(e), e, 0);
  }
  moveSelectionToPreviousFindMatch() {
    if (!this._editor.hasModel()) return null;
    const e = this._getPreviousMatch();
    if (!e) return null;
    const t = this._editor.getSelections();
    return new yC(t.slice(0, t.length - 1).concat(e), e, 0);
  }
  _getPreviousMatch() {
    if (!this._editor.hasModel()) return null;
    if (this.currentMatch) {
      const s = this.currentMatch;
      return this.currentMatch = null, s;
    }
    this.findController.highlightFindOptions();
    const e = this._editor.getSelections(), t = e[e.length - 1], n = this._editor.getModel().findPreviousMatch(this.searchText, t.getStartPosition(), !1, this.matchCase, this.wholeWord ? this._editor.getOption(131) : null, !1);
    return n ? new _e(n.range.startLineNumber, n.range.startColumn, n.range.endLineNumber, n.range.endColumn) : null;
  }
  selectAll(e) {
    if (!this._editor.hasModel()) return [];
    this.findController.highlightFindOptions();
    const t = this._editor.getModel();
    return e ? t.findMatches(this.searchText, e, !1, this.matchCase, this.wholeWord ? this._editor.getOption(131) : null, !1, 1073741824) : t.findMatches(this.searchText, !0, !1, this.matchCase, this.wholeWord ? this._editor.getOption(131) : null, !1, 1073741824);
  }
}
class kg extends V {
  static get(e) {
    return e.getContribution(kg.ID);
  }
  constructor(e) {
    super(), this._sessionDispose = this._register(new G()), this._editor = e, this._ignoreSelectionChange = !1, this._session = null;
  }
  dispose() {
    this._endSession(), super.dispose();
  }
  _beginSessionIfNeeded(e) {
    if (!this._session) {
      const t = d1.create(this._editor, e);
      if (!t) return;
      this._session = t;
      const n = { searchString: this._session.searchText };
      this._session.isDisconnectedFromFindController && (n.wholeWordOverride = 1, n.matchCaseOverride = 1, n.isRegexOverride = 2), e.getState().change(n, !1), this._sessionDispose.add(this._editor.onDidChangeCursorSelection((s) => {
        this._ignoreSelectionChange || this._endSession();
      })), this._sessionDispose.add(this._editor.onDidBlurEditorText(() => {
        this._endSession();
      })), this._sessionDispose.add(e.getState().onFindReplaceStateChange((s) => {
        (s.matchCase || s.wholeWord) && this._endSession();
      }));
    }
  }
  _endSession() {
    if (this._sessionDispose.clear(), this._session && this._session.isDisconnectedFromFindController) {
      const e = { wholeWordOverride: 0, matchCaseOverride: 0, isRegexOverride: 0 };
      this._session.findController.getState().change(e, !1);
    }
    this._session = null;
  }
  _setSelections(e) {
    this._ignoreSelectionChange = !0, this._editor.setSelections(e), this._ignoreSelectionChange = !1;
  }
  _expandEmptyToWord(e, t) {
    if (!t.isEmpty()) return t;
    const n = this._editor.getConfiguredWordAtPosition(t.getStartPosition());
    return n ? new _e(t.startLineNumber, n.startColumn, t.startLineNumber, n.endColumn) : t;
  }
  _applySessionResult(e) {
    e && (this._setSelections(e.selections), e.revealRange && this._editor.revealRangeInCenterIfOutsideViewport(e.revealRange, e.revealScrollType));
  }
  getSession(e) {
    return this._session;
  }
  addSelectionToNextFindMatch(e) {
    if (this._editor.hasModel()) {
      if (!this._session) {
        const t = this._editor.getSelections();
        if (t.length > 1) {
          const n = e.getState().matchCase;
          if (!cU(this._editor.getModel(), t, n)) {
            const s = this._editor.getModel(), o = [];
            for (let r = 0, a = t.length; r < a; r++) o[r] = this._expandEmptyToWord(s, t[r]);
            return void this._editor.setSelections(o);
          }
        }
      }
      this._beginSessionIfNeeded(e), this._session && this._applySessionResult(this._session.addSelectionToNextFindMatch());
    }
  }
  addSelectionToPreviousFindMatch(e) {
    this._beginSessionIfNeeded(e), this._session && this._applySessionResult(this._session.addSelectionToPreviousFindMatch());
  }
  moveSelectionToNextFindMatch(e) {
    this._beginSessionIfNeeded(e), this._session && this._applySessionResult(this._session.moveSelectionToNextFindMatch());
  }
  moveSelectionToPreviousFindMatch(e) {
    this._beginSessionIfNeeded(e), this._session && this._applySessionResult(this._session.moveSelectionToPreviousFindMatch());
  }
  selectAll(e) {
    if (!this._editor.hasModel()) return;
    let t = null;
    const n = e.getState();
    if (n.isRevealed && n.searchString.length > 0 && n.isRegex) {
      const s = this._editor.getModel();
      t = n.searchScope ? s.findMatches(n.searchString, n.searchScope, n.isRegex, n.matchCase, n.wholeWord ? this._editor.getOption(131) : null, !1, 1073741824) : s.findMatches(n.searchString, !0, n.isRegex, n.matchCase, n.wholeWord ? this._editor.getOption(131) : null, !1, 1073741824);
    } else {
      if (this._beginSessionIfNeeded(e), !this._session) return;
      t = this._session.selectAll(n.searchScope);
    }
    if (t.length > 0) {
      const s = this._editor.getSelection();
      for (let o = 0, r = t.length; o < r; o++) {
        const a = t[o];
        if (a.range.intersectRanges(s)) {
          t[o] = t[0], t[0] = a;
          break;
        }
      }
      this._setSelections(t.map((o) => new _e(o.range.startLineNumber, o.range.startColumn, o.range.endLineNumber, o.range.endColumn)));
    }
  }
}
kg.ID = "editor.contrib.multiCursorController";
class cp extends he {
  run(e, t) {
    const n = kg.get(t);
    if (!n) return;
    const s = t._getViewModel();
    if (s) {
      const o = s.getCursorStates(), r = gs.get(t);
      if (r) this._run(n, r);
      else {
        const a = e.get(Se).createInstance(gs, t);
        this._run(n, a), a.dispose();
      }
      ch(o, s.getCursorStates());
    }
  }
}
class Jde {
  constructor(e, t, n, s, o) {
    this._model = e, this._searchText = t, this._matchCase = n, this._wordSeparators = s, this._modelVersionId = this._model.getVersionId(), this._cachedFindMatches = null, o && this._model === o._model && this._searchText === o._searchText && this._matchCase === o._matchCase && this._wordSeparators === o._wordSeparators && this._modelVersionId === o._modelVersionId && (this._cachedFindMatches = o._cachedFindMatches);
  }
  findMatches() {
    return this._cachedFindMatches === null && (this._cachedFindMatches = this._model.findMatches(this._searchText, !0, !1, this._matchCase, this._wordSeparators, !1).map((e) => e.range), this._cachedFindMatches.sort(D.compareRangesUsingStarts)), this._cachedFindMatches;
  }
}
let F0 = uT = class extends V {
  constructor(i, e) {
    super(), this._languageFeaturesService = e, this.editor = i, this._isEnabled = i.getOption(108), this._decorations = i.createDecorationsCollection(), this.updateSoon = this._register(new It(() => this._update(), 300)), this.state = null, this._register(i.onDidChangeConfiguration((n) => {
      this._isEnabled = i.getOption(108);
    })), this._register(i.onDidChangeCursorSelection((n) => {
      this._isEnabled && (n.selection.isEmpty() ? n.reason === 3 ? (this.state && this._setState(null), this.updateSoon.schedule()) : this._setState(null) : this._update());
    })), this._register(i.onDidChangeModel((n) => {
      this._setState(null);
    })), this._register(i.onDidChangeModelContent((n) => {
      this._isEnabled && this.updateSoon.schedule();
    }));
    const t = gs.get(i);
    t && this._register(t.getState().onFindReplaceStateChange((n) => {
      this._update();
    })), this.updateSoon.schedule();
  }
  _update() {
    this._setState(uT._createState(this.state, this._isEnabled, this.editor));
  }
  static _createState(i, e, t) {
    if (!e || !t.hasModel()) return null;
    const n = t.getSelection();
    if (n.startLineNumber !== n.endLineNumber) return null;
    const s = kg.get(t);
    if (!s) return null;
    const o = gs.get(t);
    if (!o) return null;
    let r = s.getSession(o);
    if (!r) {
      const d = t.getSelections();
      if (d.length > 1) {
        const h = o.getState().matchCase;
        if (!cU(t.getModel(), d, h)) return null;
      }
      r = d1.create(t, o);
    }
    if (!r || r.currentMatch || /^[ \t]+$/.test(r.searchText) || r.searchText.length > 200) return null;
    const a = o.getState(), l = a.matchCase;
    if (a.isRevealed) {
      let d = a.searchString;
      l || (d = d.toLowerCase());
      let h = r.searchText;
      if (l || (h = h.toLowerCase()), d === h && r.matchCase === a.matchCase && r.wholeWord === a.wholeWord && !a.isRegex) return null;
    }
    return new Jde(t.getModel(), r.searchText, r.matchCase, r.wholeWord ? t.getOption(131) : null, i);
  }
  _setState(i) {
    if (this.state = i, !this.state) return void this._decorations.clear();
    if (!this.editor.hasModel()) return;
    const e = this.editor.getModel();
    if (e.isTooLargeForTokenization()) return;
    const t = this.state.findMatches(), n = this.editor.getSelections();
    n.sort(D.compareRangesUsingStarts);
    const s = [];
    for (let l = 0, d = 0, h = t.length, c = n.length; l < h; ) {
      const u = t[l];
      if (d >= c) s.push(u), l++;
      else {
        const g = D.compareRangesUsingStarts(u, n[d]);
        g < 0 ? (!n[d].isEmpty() && D.areIntersecting(u, n[d]) || s.push(u), l++) : (g > 0 || l++, d++);
      }
    }
    const o = this.editor.getOption(81) !== "off", r = this._languageFeaturesService.documentHighlightProvider.has(e) && o, a = s.map((l) => ({ range: l, options: Yde(r) }));
    this._decorations.set(a);
  }
  dispose() {
    this._setState(null), super.dispose();
  }
};
function cU(i, e, t) {
  const n = O9(i, e[0], !t);
  for (let s = 1, o = e.length; s < o; s++) {
    const r = e[s];
    if (r.isEmpty() || n !== O9(i, r, !t)) return !1;
  }
  return !0;
}
function O9(i, e, t) {
  const n = i.getValueInRange(e);
  return t ? n.toLowerCase() : n;
}
F0.ID = "editor.contrib.selectionHighlighter", F0 = uT = Xde([Qde(1, fe)], F0);
ft(kg.ID, kg, 4), ft(F0.ID, F0, 1), X(class extends he {
  constructor() {
    super({ id: "editor.action.insertCursorAbove", label: m(0, "Add Cursor Above"), alias: "Add Cursor Above", precondition: void 0, kbOpts: { kbExpr: E.editorTextFocus, primary: 2576, linux: { primary: 1552, secondary: [3088] }, weight: 100 }, menuOpts: { menuId: x.MenubarSelectionMenu, group: "3_multi", title: m(0, "&&Add Cursor Above"), order: 2 } });
  }
  run(i, e, t) {
    if (!e.hasModel()) return;
    let n = !0;
    t && t.logicalLine === !1 && (n = !1);
    const s = e._getViewModel();
    if (s.cursorConfig.readOnly) return;
    s.model.pushStackElement();
    const o = s.getCursorStates();
    s.setCursorStates(t.source, 3, mn.addCursorUp(s, o, n)), s.revealTopMostCursor(t.source), ch(o, s.getCursorStates());
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.insertCursorBelow", label: m(0, "Add Cursor Below"), alias: "Add Cursor Below", precondition: void 0, kbOpts: { kbExpr: E.editorTextFocus, primary: 2578, linux: { primary: 1554, secondary: [3090] }, weight: 100 }, menuOpts: { menuId: x.MenubarSelectionMenu, group: "3_multi", title: m(0, "A&&dd Cursor Below"), order: 3 } });
  }
  run(i, e, t) {
    if (!e.hasModel()) return;
    let n = !0;
    t && t.logicalLine === !1 && (n = !1);
    const s = e._getViewModel();
    if (s.cursorConfig.readOnly) return;
    s.model.pushStackElement();
    const o = s.getCursorStates();
    s.setCursorStates(t.source, 3, mn.addCursorDown(s, o, n)), s.revealBottomMostCursor(t.source), ch(o, s.getCursorStates());
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.insertCursorAtEndOfEachLineSelected", label: m(0, "Add Cursors to Line Ends"), alias: "Add Cursors to Line Ends", precondition: void 0, kbOpts: { kbExpr: E.editorTextFocus, primary: 1575, weight: 100 }, menuOpts: { menuId: x.MenubarSelectionMenu, group: "3_multi", title: m(0, "Add C&&ursors to Line Ends"), order: 4 } });
  }
  getCursorsForSelection(i, e, t) {
    if (!i.isEmpty()) {
      for (let n = i.startLineNumber; n < i.endLineNumber; n++) {
        const s = e.getLineMaxColumn(n);
        t.push(new _e(n, s, n, s));
      }
      i.endColumn > 1 && t.push(new _e(i.endLineNumber, i.endColumn, i.endLineNumber, i.endColumn));
    }
  }
  run(i, e) {
    if (!e.hasModel()) return;
    const t = e.getModel(), n = e.getSelections(), s = e._getViewModel(), o = s.getCursorStates(), r = [];
    n.forEach((a) => this.getCursorsForSelection(a, t, r)), r.length > 0 && e.setSelections(r), ch(o, s.getCursorStates());
  }
}), X(class extends cp {
  constructor() {
    super({ id: "editor.action.addSelectionToNextFindMatch", label: m(0, "Add Selection To Next Find Match"), alias: "Add Selection To Next Find Match", precondition: void 0, kbOpts: { kbExpr: E.focus, primary: 2082, weight: 100 }, menuOpts: { menuId: x.MenubarSelectionMenu, group: "3_multi", title: m(0, "Add &&Next Occurrence"), order: 5 } });
  }
  _run(i, e) {
    i.addSelectionToNextFindMatch(e);
  }
}), X(class extends cp {
  constructor() {
    super({ id: "editor.action.addSelectionToPreviousFindMatch", label: m(0, "Add Selection To Previous Find Match"), alias: "Add Selection To Previous Find Match", precondition: void 0, menuOpts: { menuId: x.MenubarSelectionMenu, group: "3_multi", title: m(0, "Add P&&revious Occurrence"), order: 6 } });
  }
  _run(i, e) {
    i.addSelectionToPreviousFindMatch(e);
  }
}), X(class extends cp {
  constructor() {
    super({ id: "editor.action.moveSelectionToNextFindMatch", label: m(0, "Move Last Selection To Next Find Match"), alias: "Move Last Selection To Next Find Match", precondition: void 0, kbOpts: { kbExpr: E.focus, primary: Vi(2089, 2082), weight: 100 } });
  }
  _run(i, e) {
    i.moveSelectionToNextFindMatch(e);
  }
}), X(class extends cp {
  constructor() {
    super({ id: "editor.action.moveSelectionToPreviousFindMatch", label: m(0, "Move Last Selection To Previous Find Match"), alias: "Move Last Selection To Previous Find Match", precondition: void 0 });
  }
  _run(i, e) {
    i.moveSelectionToPreviousFindMatch(e);
  }
}), X(class extends cp {
  constructor() {
    super({ id: "editor.action.selectHighlights", label: m(0, "Select All Occurrences of Find Match"), alias: "Select All Occurrences of Find Match", precondition: void 0, kbOpts: { kbExpr: E.focus, primary: 3114, weight: 100 }, menuOpts: { menuId: x.MenubarSelectionMenu, group: "3_multi", title: m(0, "Select All &&Occurrences"), order: 7 } });
  }
  _run(i, e) {
    i.selectAll(e);
  }
}), X(class extends cp {
  constructor() {
    super({ id: "editor.action.changeAll", label: m(0, "Change All Occurrences"), alias: "Change All Occurrences", precondition: q.and(E.writable, E.editorTextFocus), kbOpts: { kbExpr: E.editorTextFocus, primary: 2108, weight: 100 }, contextMenuOpts: { group: "1_modification", order: 1.2 } });
  }
  _run(i, e) {
    i.selectAll(e);
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.addCursorsToBottom", label: m(0, "Add Cursors To Bottom"), alias: "Add Cursors To Bottom", precondition: void 0 });
  }
  run(i, e) {
    if (!e.hasModel()) return;
    const t = e.getSelections(), n = e.getModel().getLineCount(), s = [];
    for (let a = t[0].startLineNumber; a <= n; a++) s.push(new _e(a, t[0].startColumn, a, t[0].endColumn));
    const o = e._getViewModel(), r = o.getCursorStates();
    s.length > 0 && e.setSelections(s), ch(r, o.getCursorStates());
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.addCursorsToTop", label: m(0, "Add Cursors To Top"), alias: "Add Cursors To Top", precondition: void 0 });
  }
  run(i, e) {
    if (!e.hasModel()) return;
    const t = e.getSelections(), n = [];
    for (let r = t[0].startLineNumber; r >= 1; r--) n.push(new _e(r, t[0].startColumn, r, t[0].endColumn));
    const s = e._getViewModel(), o = s.getCursorStates();
    n.length > 0 && e.setSelections(n), ch(o, s.getCursorStates());
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.focusNextCursor", label: m(0, "Focus Next Cursor"), metadata: { description: m(0, "Focuses the next cursor"), args: [] }, alias: "Focus Next Cursor", precondition: void 0 });
  }
  run(i, e, t) {
    if (!e.hasModel()) return;
    const n = e._getViewModel();
    if (n.cursorConfig.readOnly) return;
    n.model.pushStackElement();
    const s = Array.from(n.getCursorStates()), o = s.shift();
    o && (s.push(o), n.setCursorStates(t.source, 3, s), n.revealPrimaryCursor(t.source, !0), ch(s, n.getCursorStates()));
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.focusPreviousCursor", label: m(0, "Focus Previous Cursor"), metadata: { description: m(0, "Focuses the previous cursor"), args: [] }, alias: "Focus Previous Cursor", precondition: void 0 });
  }
  run(i, e, t) {
    if (!e.hasModel()) return;
    const n = e._getViewModel();
    if (n.cursorConfig.readOnly) return;
    n.model.pushStackElement();
    const s = Array.from(n.getCursorStates()), o = s.pop();
    o && (s.unshift(o), n.setCursorStates(t.source, 3, s), n.revealPrimaryCursor(t.source, !0), ch(s, n.getCursorStates()));
  }
});
var ehe = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, the = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const tN = "inline-edit";
let gT = class extends V {
  constructor(i, e, t) {
    super(), this.editor = i, this.model = e, this.languageService = t, this.isDisposed = lt(this, !1), this.currentTextModel = Rt(this.editor.onDidChangeModel, () => this.editor.getModel()), this.uiState = Fe(this, (n) => {
      var s;
      if (this.isDisposed.read(n)) return;
      const o = this.currentTextModel.read(n);
      if (o !== this.model.targetTextModel.read(n)) return;
      const r = this.model.ghostText.read(n);
      if (!r) return;
      let a = (s = this.model.range) === null || s === void 0 ? void 0 : s.read(n);
      a && a.startLineNumber === a.endLineNumber && a.startColumn === a.endColumn && (a = void 0);
      const l = (!a || a.startLineNumber === a.endLineNumber) && r.parts.length === 1 && r.parts[0].lines.length === 1, d = r.parts.length === 1 && r.parts[0].lines.every((b) => b.length === 0), h = [], c = [];
      function u(b, C) {
        if (c.length > 0) {
          const w = c[c.length - 1];
          C && w.decorations.push(new _s(w.content.length + 1, w.content.length + 1 + b[0].length, C, 0)), w.content += b[0], b = b.slice(1);
        }
        for (const w of b) c.push({ content: w, decorations: C ? [new _s(1, w.length + 1, C, 0)] : [] });
      }
      const g = o.getLineContent(r.lineNumber);
      let p, f = 0;
      if (!d) {
        for (const b of r.parts) {
          let C = b.lines;
          a && !l && (u(C, tN), C = []), p === void 0 ? (h.push({ column: b.column, text: C[0], preview: b.preview }), C = C.slice(1)) : u([g.substring(f, b.column - 1)], void 0), C.length > 0 && (u(C, tN), p === void 0 && b.column <= g.length && (p = b.column)), f = b.column - 1;
        }
        p !== void 0 && u([g.substring(f)], void 0);
      }
      const _ = p !== void 0 ? new Yz(p, g.length + 1) : void 0, v = l || !a ? r.lineNumber : a.endLineNumber - 1;
      return { inlineTexts: h, additionalLines: c, hiddenRange: _, lineNumber: v, additionalReservedLineCount: this.model.minReservedLineCount.read(n), targetTextModel: o, range: a, isSingleLine: l, isPureRemove: d, backgroundColoring: this.model.backgroundColoring.read(n) };
    }), this.decorations = Fe(this, (n) => {
      const s = this.uiState.read(n);
      if (!s) return [];
      const o = [];
      if (s.hiddenRange && o.push({ range: s.hiddenRange.toRange(s.lineNumber), options: { inlineClassName: "inline-edit-hidden", description: "inline-edit-hidden" } }), s.range) {
        const r = [];
        if (s.isSingleLine) r.push(s.range);
        else if (s.isPureRemove) {
          const l = s.range.endLineNumber - s.range.startLineNumber;
          for (let d = 0; d < l; d++) {
            const h = s.range.startLineNumber + d, c = s.targetTextModel.getLineFirstNonWhitespaceColumn(h), u = s.targetTextModel.getLineLastNonWhitespaceColumn(h), g = new D(h, c, h, u);
            r.push(g);
          }
        } else {
          const l = s.range.endLineNumber - s.range.startLineNumber;
          for (let d = 0; d < l; d++) {
            const h = s.range.startLineNumber + d, c = s.targetTextModel.getLineFirstNonWhitespaceColumn(h), u = s.targetTextModel.getLineLastNonWhitespaceColumn(h), g = new D(h, c, h, u);
            r.push(g);
          }
        }
        const a = s.backgroundColoring ? "inline-edit-remove backgroundColoring" : "inline-edit-remove";
        for (const l of r) o.push({ range: l, options: { inlineClassName: a, description: "inline-edit-remove" } });
      }
      for (const r of s.inlineTexts) o.push({ range: D.fromPositions(new W(s.lineNumber, r.column)), options: { description: tN, after: { content: r.text, inlineClassName: r.preview ? "inline-edit-decoration-preview" : "inline-edit-decoration", cursorStops: vr.Left }, showIfCollapsed: !0 } });
      return o;
    }), this.additionalLinesWidget = this._register(new Qz(this.editor, this.languageService.languageIdCodec, Fe((n) => {
      const s = this.uiState.read(n);
      return s && !s.isPureRemove ? { lineNumber: s.lineNumber, additionalLines: s.additionalLines, minReservedLineCount: s.additionalReservedLineCount, targetTextModel: s.targetTextModel } : void 0;
    }))), this._register(ye(() => {
      this.isDisposed.set(!0, void 0);
    })), this._register(Xz(this.editor, this.decorations));
  }
  ownsViewZone(i) {
    return this.additionalLinesWidget.viewZoneId === i;
  }
};
gT = ehe([the(2, Xt)], gT);
var Sw, RP = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, sd = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let pT = class extends V {
  constructor(i, e, t) {
    super(), this.editor = i, this.model = e, this.instantiationService = t, this.alwaysShowToolbar = Rt(this.editor.onDidChangeConfiguration, () => this.editor.getOption(63).showToolbar === "always"), this.sessionPosition = void 0, this.position = Fe(this, (n) => {
      var s, o, r;
      const a = (s = this.model.read(n)) === null || s === void 0 ? void 0 : s.widget.model.ghostText.read(n);
      if (!this.alwaysShowToolbar.read(n) || !a || a.parts.length === 0) return this.sessionPosition = void 0, null;
      const l = a.parts[0].column;
      this.sessionPosition && this.sessionPosition.lineNumber !== a.lineNumber && (this.sessionPosition = void 0);
      const d = new W(a.lineNumber, Math.min(l, (r = (o = this.sessionPosition) === null || o === void 0 ? void 0 : o.column) !== null && r !== void 0 ? r : Number.MAX_SAFE_INTEGER));
      return this.sessionPosition = d, d;
    }), this._register(nr((n, s) => {
      if (!this.model.read(n) || !this.alwaysShowToolbar.read(n)) return;
      const o = s.add(this.instantiationService.createInstance(Zp, this.editor, !0, this.position));
      i.addContentWidget(o), s.add(ye(() => i.removeContentWidget(o)));
    }));
  }
};
pT = RP([sd(2, Se)], pT);
let Zp = Sw = class extends V {
  constructor(i, e, t, n, s, o) {
    super(), this.editor = i, this.withBorder = e, this._position = t, this._contextKeyService = s, this._menuService = o, this.id = "InlineEditHintsContentWidget" + Sw.id++, this.allowEditorOverflow = !0, this.suppressMouseDown = !1, this.nodes = yt("div.inlineEditHints", { className: this.withBorder ? ".withBorder" : "" }, [yt("div@toolBar")]), this.inlineCompletionsActionsMenus = this._register(this._menuService.createMenu(x.InlineEditActions, this._contextKeyService)), this.toolBar = this._register(n.createInstance(mT, this.nodes.toolBar, this.editor, x.InlineEditToolbar, { menuOptions: { renderShortTitle: !0 }, toolbarOptions: { primaryGroup: (r) => r.startsWith("primary") }, actionViewItemProvider: (r, a) => {
      if (r instanceof Eo) return n.createInstance(ihe, r, void 0);
    }, telemetrySource: "InlineEditToolbar" })), this._register(this.toolBar.onDidChangeDropdownVisibility((r) => {
      Sw._dropDownVisible = r;
    })), this._register(Ge((r) => {
      this._position.read(r), this.editor.layoutContentWidget(this);
    })), this._register(Ge((r) => {
      const a = [];
      for (const [l, d] of this.inlineCompletionsActionsMenus.getActions()) for (const h of d) h instanceof Eo && a.push(h);
      a.length > 0 && a.unshift(new Ui()), this.toolBar.setAdditionalSecondaryActions(a);
    }));
  }
  getId() {
    return this.id;
  }
  getDomNode() {
    return this.nodes.root;
  }
  getPosition() {
    return { position: this._position.get(), preference: [1, 2], positionAffinity: 3 };
  }
};
Zp._dropDownVisible = !1, Zp.id = 0, Zp = Sw = RP([sd(3, Se), sd(4, Te), sd(5, Mo)], Zp);
class ihe extends Ic {
  updateLabel() {
    const e = this._keybindingService.lookupKeybinding(this._action.id, this._contextKeyService);
    if (!e) return super.updateLabel();
    if (this.label) {
      const t = yt("div.keybinding").root;
      this._register(new yf(t, Gs, { disableTitle: !0, ...kV })).set(e), this.label.textContent = this._action.label, this.label.appendChild(t), this.label.classList.add("inlineEditStatusBarItemLabel");
    }
  }
  updateTooltip() {
  }
}
let mT = class extends Gv {
  constructor(i, e, t, n, s, o, r, a, l) {
    super(i, { resetMenu: t, ...n }, s, o, r, a, l), this.editor = e, this.menuId = t, this.options2 = n, this.menuService = s, this.contextKeyService = o, this.menu = this._store.add(this.menuService.createMenu(this.menuId, this.contextKeyService, { emitEventsForSubmenuChanges: !0 })), this.additionalActions = [], this.prependedPrimaryActions = [], this._store.add(this.menu.onDidChange(() => this.updateToolbar())), this._store.add(this.editor.onDidChangeCursorPosition(() => this.updateToolbar())), this.updateToolbar();
  }
  updateToolbar() {
    var i, e, t, n, s, o, r;
    const a = [], l = [];
    ML(this.menu, (i = this.options2) === null || i === void 0 ? void 0 : i.menuOptions, { primary: a, secondary: l }, (t = (e = this.options2) === null || e === void 0 ? void 0 : e.toolbarOptions) === null || t === void 0 ? void 0 : t.primaryGroup, (s = (n = this.options2) === null || n === void 0 ? void 0 : n.toolbarOptions) === null || s === void 0 ? void 0 : s.shouldInlineSubmenu, (r = (o = this.options2) === null || o === void 0 ? void 0 : o.toolbarOptions) === null || r === void 0 ? void 0 : r.useSeparatorsInPrimaryActions), l.push(...this.additionalActions), a.unshift(...this.prependedPrimaryActions), this.setActions(a, l);
  }
  setAdditionalSecondaryActions(i) {
    ri(this.additionalActions, i, (e, t) => e === t) || (this.additionalActions = i, this.updateToolbar());
  }
};
mT = RP([sd(4, Mo), sd(5, Te), sd(6, io), sd(7, Dt), sd(8, es)], mT);
var zu, nhe = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, r_ = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class she {
  constructor(e, t) {
    this.widget = e, this.edit = t;
  }
  dispose() {
    this.widget.dispose();
  }
}
let $i = zu = class extends V {
  static get(i) {
    return i.getContribution(zu.ID);
  }
  constructor(i, e, t, n, s, o) {
    super(), this.editor = i, this.instantiationService = e, this.contextKeyService = t, this.languageFeaturesService = n, this._commandService = s, this._configurationService = o, this._isVisibleContext = zu.inlineEditVisibleContext.bindTo(this.contextKeyService), this._isCursorAtInlineEditContext = zu.cursorAtInlineEditContext.bindTo(this.contextKeyService), this._currentEdit = this._register(Av(this, void 0)), this._isAccepting = lt(this, !1), this._enabled = Rt(this.editor.onDidChangeConfiguration, () => this.editor.getOption(63).enabled), this._fontFamily = Rt(this.editor.onDidChangeConfiguration, () => this.editor.getOption(63).fontFamily), this._backgroundColoring = Rt(this.editor.onDidChangeConfiguration, () => this.editor.getOption(63).backgroundColoring);
    const r = Hn("InlineEditController.modelContentChangedSignal", i.onDidChangeModelContent);
    this._register(Ge((c) => {
      this._enabled.read(c) && (r.read(c), this._isAccepting.read(c) || this.getInlineEdit(i, !0));
    }));
    const a = Rt(i.onDidChangeCursorPosition, () => i.getPosition());
    this._register(Ge((c) => {
      if (!this._enabled.read(c)) return;
      const u = a.read(c);
      u && this.checkCursorPosition(u);
    })), this._register(Ge((c) => {
      const u = this._currentEdit.read(c);
      if (this._isCursorAtInlineEditContext.set(!1), !u) return void this._isVisibleContext.set(!1);
      this._isVisibleContext.set(!0);
      const g = i.getPosition();
      g && this.checkCursorPosition(g);
    }));
    const l = Hn("InlineEditController.editorBlurSignal", i.onDidBlurEditorWidget);
    this._register(Ge(async (c) => {
      var u;
      this._enabled.read(c) && (l.read(c), this._configurationService.getValue("editor.experimentalInlineEdit.keepOnBlur") || i.getOption(63).keepOnBlur || ((u = this._currentRequestCts) === null || u === void 0 || u.dispose(!0), this._currentRequestCts = void 0, await this.clear(!1)));
    }));
    const d = Hn("InlineEditController.editorFocusSignal", i.onDidFocusEditorText);
    this._register(Ge((c) => {
      this._enabled.read(c) && (d.read(c), this.getInlineEdit(i, !0));
    }));
    const h = this._register(y8());
    this._register(Ge((c) => {
      const u = this._fontFamily.read(c);
      h.setStyle(u === "" || u === "default" ? "" : `
.monaco-editor .inline-edit-decoration,
.monaco-editor .inline-edit-decoration-preview,
.monaco-editor .inline-edit {
	font-family: ${u};
}`);
    })), this._register(new pT(this.editor, this._currentEdit, this.instantiationService));
  }
  checkCursorPosition(i) {
    var e;
    if (!this._currentEdit) return void this._isCursorAtInlineEditContext.set(!1);
    const t = (e = this._currentEdit.get()) === null || e === void 0 ? void 0 : e.edit;
    t ? this._isCursorAtInlineEditContext.set(D.containsPosition(t.range, i)) : this._isCursorAtInlineEditContext.set(!1);
  }
  validateInlineEdit(i, e) {
    var t, n;
    if (e.text.includes(`
`) && e.range.startLineNumber !== e.range.endLineNumber && e.range.startColumn !== e.range.endColumn) {
      if (e.range.startColumn !== 1) return !1;
      const s = e.range.endLineNumber;
      if (e.range.endColumn !== ((n = (t = i.getModel()) === null || t === void 0 ? void 0 : t.getLineLength(s)) !== null && n !== void 0 ? n : 0) + 1) return !1;
    }
    return !0;
  }
  async fetchInlineEdit(i, e) {
    this._currentRequestCts && this._currentRequestCts.dispose(!0);
    const t = i.getModel();
    if (!t) return;
    const n = t.getVersionId(), s = this.languageFeaturesService.inlineEditProvider.all(t);
    if (s.length === 0) return;
    const o = s[0];
    this._currentRequestCts = new Ci();
    const r = this._currentRequestCts.token, a = e ? Bw.Automatic : Bw.Invoke;
    var l, d;
    if (e && await (l = 50, d = r, new Promise((c) => {
      let u;
      const g = setTimeout(() => {
        u && u.dispose(), c();
      }, l);
      d && (u = d.onCancellationRequested(() => {
        clearTimeout(g), u && u.dispose(), c();
      }));
    })), r.isCancellationRequested || t.isDisposed() || t.getVersionId() !== n) return;
    const h = await o.provideInlineEdit(t, { triggerKind: a }, r);
    return h && !r.isCancellationRequested && !t.isDisposed() && t.getVersionId() === n && this.validateInlineEdit(i, h) ? h : void 0;
  }
  async getInlineEdit(i, e) {
    var t;
    this._isCursorAtInlineEditContext.set(!1), await this.clear();
    const n = await this.fetchInlineEdit(i, e);
    if (!n) return;
    const s = n.range.endLineNumber, o = n.range.endColumn, r = new s1(s, [new LS(o, n.text, !1)]), a = this.instantiationService.createInstance(gT, this.editor, { ghostText: ia(r), minReservedLineCount: ia(0), targetTextModel: ia((t = this.editor.getModel()) !== null && t !== void 0 ? t : void 0), range: ia(n.range), backgroundColoring: this._backgroundColoring });
    this._currentEdit.set(new she(a, n), void 0);
  }
  async trigger() {
    await this.getInlineEdit(this.editor, !1);
  }
  async jumpBack() {
    this._jumpBackPosition && (this.editor.setPosition(this._jumpBackPosition), this.editor.revealPositionInCenterIfOutsideViewport(this._jumpBackPosition));
  }
  async accept() {
    var i;
    this._isAccepting.set(!0, void 0);
    const e = (i = this._currentEdit.get()) === null || i === void 0 ? void 0 : i.edit;
    if (!e) return;
    let t = e.text;
    e.text.startsWith(`
`) && (t = e.text.substring(1)), this.editor.pushUndoStop(), this.editor.executeEdits("acceptCurrent", [ii.replace(D.lift(e.range), t)]), e.accepted && await this._commandService.executeCommand(e.accepted.id, ...e.accepted.arguments || []).then(void 0, Ni), this.freeEdit(e), Tt((n) => {
      this._currentEdit.set(void 0, n), this._isAccepting.set(!1, n);
    });
  }
  jumpToCurrent() {
    var i, e;
    this._jumpBackPosition = (i = this.editor.getSelection()) === null || i === void 0 ? void 0 : i.getStartPosition();
    const t = (e = this._currentEdit.get()) === null || e === void 0 ? void 0 : e.edit;
    if (!t) return;
    const n = W.lift({ lineNumber: t.range.startLineNumber, column: t.range.startColumn });
    this.editor.setPosition(n), this.editor.revealPositionInCenterIfOutsideViewport(n);
  }
  async clear(i = !0) {
    var e;
    const t = (e = this._currentEdit.get()) === null || e === void 0 ? void 0 : e.edit;
    t && (t != null && t.rejected) && i && await this._commandService.executeCommand(t.rejected.id, ...t.rejected.arguments || []).then(void 0, Ni), t && this.freeEdit(t), this._currentEdit.set(void 0, void 0);
  }
  freeEdit(i) {
    const e = this.editor.getModel();
    if (!e) return;
    const t = this.languageFeaturesService.inlineEditProvider.all(e);
    t.length !== 0 && t[0].freeInlineEdit(i);
  }
  shouldShowHoverAt(i) {
    const e = this._currentEdit.get();
    if (!e) return !1;
    const t = e.edit, n = e.widget.model;
    if (D.containsPosition(t.range, i.getStartPosition()) || D.containsPosition(t.range, i.getEndPosition())) return !0;
    const s = n.ghostText.get();
    return !!s && s.parts.some((o) => i.containsPosition(new W(s.lineNumber, o.column)));
  }
  shouldShowHoverAtViewZone(i) {
    var e, t;
    return (t = (e = this._currentEdit.get()) === null || e === void 0 ? void 0 : e.widget.ownsViewZone(i)) !== null && t !== void 0 && t;
  }
};
$i.ID = "editor.contrib.inlineEditController", $i.inlineEditVisibleKey = "inlineEditVisible", $i.inlineEditVisibleContext = new ae(zu.inlineEditVisibleKey, !1), $i.cursorAtInlineEditKey = "cursorAtInlineEdit", $i.cursorAtInlineEditContext = new ae(zu.cursorAtInlineEditKey, !1), $i = zu = nhe([r_(1, Se), r_(2, Te), r_(3, fe), r_(4, ai), r_(5, Ye)], $i);
var ohe = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, F9 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class rhe {
  constructor(e, t, n) {
    this.owner = e, this.range = t, this.controller = n;
  }
  isValidForHoverAnchor(e) {
    return e.type === 1 && this.range.startColumn <= e.range.startColumn && this.range.endColumn >= e.range.endColumn;
  }
}
let iN = class {
  constructor(i, e, t) {
    this._editor = i, this._instantiationService = e, this._telemetryService = t, this.hoverOrdinal = 5;
  }
  suggestHoverAnchor(i) {
    const e = $i.get(this._editor);
    if (!e) return null;
    const t = i.target;
    if (t.type === 8) {
      const n = t.detail;
      if (e.shouldShowHoverAtViewZone(n.viewZoneId)) {
        const s = t.range;
        return new Xu(1e3, this, s, i.event.posx, i.event.posy, !1);
      }
    }
    return t.type === 7 && e.shouldShowHoverAt(t.range) ? new Xu(1e3, this, t.range, i.event.posx, i.event.posy, !1) : t.type === 6 && t.detail.mightBeForeignElement && e.shouldShowHoverAt(t.range) ? new Xu(1e3, this, t.range, i.event.posx, i.event.posy, !1) : null;
  }
  computeSync(i, e) {
    if (this._editor.getOption(63).showToolbar !== "onHover") return [];
    const t = $i.get(this._editor);
    return t && t.shouldShowHoverAt(i.range) ? [new rhe(this, i.range, t)] : [];
  }
  renderHoverParts(i, e) {
    const t = new G();
    this._telemetryService.publicLog2("inlineEditHover.shown");
    const n = this._instantiationService.createInstance(Zp, this._editor, !1, ia(null));
    return i.fragment.appendChild(n.getDomNode()), t.add(n), t;
  }
};
iN = ohe([F9(1, Se), F9(2, es)], iN), X(class extends he {
  constructor() {
    super({ id: "editor.action.inlineEdit.accept", label: "Accept Inline Edit", alias: "Accept Inline Edit", precondition: q.and(E.writable, $i.inlineEditVisibleContext), kbOpts: [{ weight: 101, primary: 2, kbExpr: q.and(E.writable, $i.inlineEditVisibleContext, $i.cursorAtInlineEditContext) }], menuOpts: [{ menuId: x.InlineEditToolbar, title: "Accept", group: "primary", order: 1 }] });
  }
  async run(i, e) {
    const t = $i.get(e);
    await (t == null ? void 0 : t.accept());
  }
}), X(class extends he {
  constructor() {
    const i = q.and(E.writable, $i.inlineEditVisibleContext);
    super({ id: "editor.action.inlineEdit.reject", label: "Reject Inline Edit", alias: "Reject Inline Edit", precondition: i, kbOpts: { weight: 100, primary: 9, kbExpr: i }, menuOpts: [{ menuId: x.InlineEditToolbar, title: "Reject", group: "secondary", order: 2 }] });
  }
  async run(i, e) {
    const t = $i.get(e);
    await (t == null ? void 0 : t.clear());
  }
}), X(class extends he {
  constructor() {
    const i = q.and(E.writable, $i.inlineEditVisibleContext, q.not($i.cursorAtInlineEditKey));
    super({ id: "editor.action.inlineEdit.jumpTo", label: "Jump to Inline Edit", alias: "Jump to Inline Edit", precondition: i, kbOpts: { weight: 101, primary: 2646, kbExpr: i }, menuOpts: [{ menuId: x.InlineEditToolbar, title: "Jump To Edit", group: "primary", order: 3, when: i }] });
  }
  async run(i, e) {
    const t = $i.get(e);
    t == null || t.jumpToCurrent();
  }
}), X(class extends he {
  constructor() {
    const i = q.and(E.writable, $i.cursorAtInlineEditContext);
    super({ id: "editor.action.inlineEdit.jumpBack", label: "Jump Back from Inline Edit", alias: "Jump Back from Inline Edit", precondition: i, kbOpts: { weight: 110, primary: 2646, kbExpr: i }, menuOpts: [{ menuId: x.InlineEditToolbar, title: "Jump Back", group: "primary", order: 3, when: i }] });
  }
  async run(i, e) {
    const t = $i.get(e);
    t == null || t.jumpBack();
  }
}), X(class extends he {
  constructor() {
    const i = q.and(E.writable, q.not($i.inlineEditVisibleKey));
    super({ id: "editor.action.inlineEdit.trigger", label: "Trigger Inline Edit", alias: "Trigger Inline Edit", precondition: i, kbOpts: { weight: 101, primary: 2646, kbExpr: i } });
  }
  async run(i, e) {
    const t = $i.get(e);
    t == null || t.trigger();
  }
}), ft($i.ID, $i, 3), Rc.register(iN);
const xu = { Visible: new ae("parameterHintsVisible", !1), MultipleSignatures: new ae("parameterHintsMultipleSignatures", !1) };
async function uU(i, e, t, n, s) {
  const o = i.ordered(e);
  for (const r of o) try {
    const a = await r.provideSignatureHelp(e, t, s, n);
    if (a) return a;
  } catch (a) {
    Ni(a);
  }
}
var fh;
dt.registerCommand("_executeSignatureHelpProvider", async (i, ...e) => {
  const [t, n, s] = e;
  vt(Ie.isUri(t)), vt(W.isIPosition(n)), vt(typeof s == "string" || !s);
  const o = i.get(fe), r = await i.get(Ps).createModelReference(t);
  try {
    const a = await uU(o.signatureHelpProvider, r.object.textEditorModel, W.lift(n), { triggerKind: ul.Invoke, isRetrigger: !1, triggerCharacter: s }, et.None);
    return a ? (setTimeout(() => a.dispose(), 0), a.value) : void 0;
  } finally {
    r.dispose();
  }
}), function(i) {
  i.Default = { type: 0 }, i.Pending = class {
    constructor(e, t) {
      this.request = e, this.previouslyActiveHints = t, this.type = 2;
    }
  }, i.Active = class {
    constructor(e) {
      this.hints = e, this.type = 1;
    }
  };
}(fh || (fh = {}));
class Ck extends V {
  constructor(e, t, n = Ck.DEFAULT_DELAY) {
    super(), this._onChangedHints = this._register(new F()), this.onChangedHints = this._onChangedHints.event, this.triggerOnType = !1, this._state = fh.Default, this._pendingTriggers = [], this._lastSignatureHelpResult = this._register(new rn()), this.triggerChars = new ey(), this.retriggerChars = new ey(), this.triggerId = 0, this.editor = e, this.providers = t, this.throttledDelayer = new Sr(n), this._register(this.editor.onDidBlurEditorWidget(() => this.cancel())), this._register(this.editor.onDidChangeConfiguration(() => this.onEditorConfigurationChange())), this._register(this.editor.onDidChangeModel((s) => this.onModelChanged())), this._register(this.editor.onDidChangeModelLanguage((s) => this.onModelChanged())), this._register(this.editor.onDidChangeCursorSelection((s) => this.onCursorChange(s))), this._register(this.editor.onDidChangeModelContent((s) => this.onModelContentChange())), this._register(this.providers.onDidChange(this.onModelChanged, this)), this._register(this.editor.onDidType((s) => this.onDidType(s))), this.onEditorConfigurationChange(), this.onModelChanged();
  }
  get state() {
    return this._state;
  }
  set state(e) {
    this._state.type === 2 && this._state.request.cancel(), this._state = e;
  }
  cancel(e = !1) {
    this.state = fh.Default, this.throttledDelayer.cancel(), e || this._onChangedHints.fire(void 0);
  }
  trigger(e, t) {
    const n = this.editor.getModel();
    if (!n || !this.providers.has(n)) return;
    const s = ++this.triggerId;
    this._pendingTriggers.push(e), this.throttledDelayer.trigger(() => this.doTrigger(s), t).catch(We);
  }
  next() {
    if (this.state.type !== 1) return;
    const e = this.state.hints.signatures.length, t = this.state.hints.activeSignature, n = t % e == e - 1, s = this.editor.getOption(86).cycle;
    !(e < 2 || n) || s ? this.updateActiveSignature(n && s ? 0 : t + 1) : this.cancel();
  }
  previous() {
    if (this.state.type !== 1) return;
    const e = this.state.hints.signatures.length, t = this.state.hints.activeSignature, n = t === 0, s = this.editor.getOption(86).cycle;
    !(e < 2 || n) || s ? this.updateActiveSignature(n && s ? e - 1 : t - 1) : this.cancel();
  }
  updateActiveSignature(e) {
    this.state.type === 1 && (this.state = new fh.Active({ ...this.state.hints, activeSignature: e }), this._onChangedHints.fire(this.state.hints));
  }
  async doTrigger(e) {
    const t = this.state.type === 1 || this.state.type === 2, n = this.getLastActiveHints();
    if (this.cancel(!0), this._pendingTriggers.length === 0) return !1;
    const s = this._pendingTriggers.reduce(ahe);
    this._pendingTriggers = [];
    const o = { triggerKind: s.triggerKind, triggerCharacter: s.triggerCharacter, isRetrigger: t, activeSignatureHelp: n };
    if (!this.editor.hasModel()) return !1;
    const r = this.editor.getModel(), a = this.editor.getPosition();
    this.state = new fh.Pending(on((l) => uU(this.providers, r, a, o, l)), n);
    try {
      const l = await this.state.request;
      return e !== this.triggerId ? (l == null || l.dispose(), !1) : l && l.value.signatures && l.value.signatures.length !== 0 ? (this.state = new fh.Active(l.value), this._lastSignatureHelpResult.value = l, this._onChangedHints.fire(this.state.hints), !0) : (l == null || l.dispose(), this._lastSignatureHelpResult.clear(), this.cancel(), !1);
    } catch (l) {
      return e === this.triggerId && (this.state = fh.Default), We(l), !1;
    }
  }
  getLastActiveHints() {
    switch (this.state.type) {
      case 1:
        return this.state.hints;
      case 2:
        return this.state.previouslyActiveHints;
      default:
        return;
    }
  }
  get isTriggered() {
    return this.state.type === 1 || this.state.type === 2 || this.throttledDelayer.isTriggered();
  }
  onModelChanged() {
    this.cancel(), this.triggerChars.clear(), this.retriggerChars.clear();
    const e = this.editor.getModel();
    if (e) for (const t of this.providers.ordered(e)) {
      for (const n of t.signatureHelpTriggerCharacters || []) if (n.length) {
        const s = n.charCodeAt(0);
        this.triggerChars.add(s), this.retriggerChars.add(s);
      }
      for (const n of t.signatureHelpRetriggerCharacters || []) n.length && this.retriggerChars.add(n.charCodeAt(0));
    }
  }
  onDidType(e) {
    if (!this.triggerOnType) return;
    const t = e.length - 1, n = e.charCodeAt(t);
    (this.triggerChars.has(n) || this.isTriggered && this.retriggerChars.has(n)) && this.trigger({ triggerKind: ul.TriggerCharacter, triggerCharacter: e.charAt(t) });
  }
  onCursorChange(e) {
    e.source === "mouse" ? this.cancel() : this.isTriggered && this.trigger({ triggerKind: ul.ContentChange });
  }
  onModelContentChange() {
    this.isTriggered && this.trigger({ triggerKind: ul.ContentChange });
  }
  onEditorConfigurationChange() {
    this.triggerOnType = this.editor.getOption(86).enabled, this.triggerOnType || this.cancel();
  }
  dispose() {
    this.cancel(!0), super.dispose();
  }
}
function ahe(i, e) {
  switch (e.triggerKind) {
    case ul.Invoke:
      return e;
    case ul.ContentChange:
      return i;
    case ul.TriggerCharacter:
    default:
      return e;
  }
}
Ck.DEFAULT_DELAY = 120;
var fT, lhe = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, nN = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const so = Q, dhe = Ei("parameter-hints-next", ne.chevronDown, m(0, "Icon for show next parameter hint.")), hhe = Ei("parameter-hints-previous", ne.chevronUp, m(0, "Icon for show previous parameter hint."));
let Lw = fT = class extends V {
  constructor(i, e, t, n, s) {
    super(), this.editor = i, this.model = e, this.renderDisposeables = this._register(new G()), this.visible = !1, this.announcedLabel = null, this.allowEditorOverflow = !0, this.markdownRenderer = this._register(new ml({ editor: i }, s, n)), this.keyVisible = xu.Visible.bindTo(t), this.keyMultipleSignatures = xu.MultipleSignatures.bindTo(t);
  }
  createParameterHintDOMNodes() {
    const i = so(".editor-widget.parameter-hints-widget"), e = Z(i, so(".phwrapper"));
    e.tabIndex = -1;
    const t = Z(e, so(".controls")), n = Z(t, so(".button" + Ee.asCSSSelector(hhe))), s = Z(t, so(".overloads")), o = Z(t, so(".button" + Ee.asCSSSelector(dhe)));
    this._register(K(n, "click", (c) => {
      Ze(c), this.previous();
    })), this._register(K(o, "click", (c) => {
      Ze(c), this.next();
    }));
    const r = so(".body"), a = new k1(r, { alwaysConsumeMouseWheel: !0 });
    this._register(a), e.appendChild(a.getDomNode());
    const l = Z(r, so(".signature")), d = Z(r, so(".docs"));
    i.style.userSelect = "text", this.domNodes = { element: i, signature: l, overloads: s, docs: d, scrollbar: a }, this.editor.addContentWidget(this), this.hide(), this._register(this.editor.onDidChangeCursorSelection((c) => {
      this.visible && this.editor.layoutContentWidget(this);
    }));
    const h = () => {
      if (!this.domNodes) return;
      const c = this.editor.getOption(50);
      this.domNodes.element.style.fontSize = `${c.fontSize}px`, this.domNodes.element.style.lineHeight = "" + c.lineHeight / c.fontSize;
    };
    h(), this._register(se.chain(this.editor.onDidChangeConfiguration.bind(this.editor), (c) => c.filter((u) => u.hasChanged(50)))(h)), this._register(this.editor.onDidLayoutChange((c) => this.updateMaxHeight())), this.updateMaxHeight();
  }
  show() {
    this.visible || (this.domNodes || this.createParameterHintDOMNodes(), this.keyVisible.set(!0), this.visible = !0, setTimeout(() => {
      var i;
      (i = this.domNodes) === null || i === void 0 || i.element.classList.add("visible");
    }, 100), this.editor.layoutContentWidget(this));
  }
  hide() {
    var i;
    this.renderDisposeables.clear(), this.visible && (this.keyVisible.reset(), this.visible = !1, this.announcedLabel = null, (i = this.domNodes) === null || i === void 0 || i.element.classList.remove("visible"), this.editor.layoutContentWidget(this));
  }
  getPosition() {
    return this.visible ? { position: this.editor.getPosition(), preference: [1, 2] } : null;
  }
  render(i) {
    var e;
    if (this.renderDisposeables.clear(), !this.domNodes) return;
    const t = i.signatures.length > 1;
    this.domNodes.element.classList.toggle("multiple", t), this.keyMultipleSignatures.set(t), this.domNodes.signature.innerText = "", this.domNodes.docs.innerText = "";
    const n = i.signatures[i.activeSignature];
    if (!n) return;
    const s = Z(this.domNodes.signature, so(".code")), o = this.editor.getOption(50);
    s.style.fontSize = `${o.fontSize}px`, s.style.fontFamily = o.fontFamily;
    const r = n.parameters.length > 0, a = (e = n.activeParameter) !== null && e !== void 0 ? e : i.activeParameter;
    r ? this.renderParameters(s, n, a) : Z(s, so("span")).textContent = n.label;
    const l = n.parameters[a];
    if (l != null && l.documentation) {
      const h = so("span.documentation");
      if (typeof l.documentation == "string") h.textContent = l.documentation;
      else {
        const c = this.renderMarkdownDocs(l.documentation);
        h.appendChild(c.element);
      }
      Z(this.domNodes.docs, so("p", {}, h));
    }
    if (n.documentation !== void 0) if (typeof n.documentation == "string") Z(this.domNodes.docs, so("p", {}, n.documentation));
    else {
      const h = this.renderMarkdownDocs(n.documentation);
      Z(this.domNodes.docs, h.element);
    }
    const d = this.hasDocs(n, l);
    if (this.domNodes.signature.classList.toggle("has-docs", d), this.domNodes.docs.classList.toggle("empty", !d), this.domNodes.overloads.textContent = String(i.activeSignature + 1).padStart(i.signatures.length.toString().length, "0") + "/" + i.signatures.length, l) {
      let h = "";
      const c = n.parameters[a];
      h = Array.isArray(c.label) ? n.label.substring(c.label[0], c.label[1]) : c.label, c.documentation && (h += typeof c.documentation == "string" ? `, ${c.documentation}` : `, ${c.documentation.value}`), n.documentation && (h += typeof n.documentation == "string" ? `, ${n.documentation}` : `, ${n.documentation.value}`), this.announcedLabel !== h && (Io(m(0, "{0}, hint", h)), this.announcedLabel = h);
    }
    this.editor.layoutContentWidget(this), this.domNodes.scrollbar.scanDomNode();
  }
  renderMarkdownDocs(i) {
    const e = this.renderDisposeables.add(this.markdownRenderer.render(i, { asyncRenderCallback: () => {
      var t;
      (t = this.domNodes) === null || t === void 0 || t.scrollbar.scanDomNode();
    } }));
    return e.element.classList.add("markdown-docs"), e;
  }
  hasDocs(i, e) {
    return !!(e && typeof e.documentation == "string" && xh(e.documentation).length > 0) || !!(e && typeof e.documentation == "object" && xh(e.documentation).value.length > 0) || !!(i.documentation && typeof i.documentation == "string" && xh(i.documentation).length > 0) || !!(i.documentation && typeof i.documentation == "object" && xh(i.documentation.value).length > 0);
  }
  renderParameters(i, e, t) {
    const [n, s] = this.getParameterLabelOffsets(e, t), o = document.createElement("span");
    o.textContent = e.label.substring(0, n);
    const r = document.createElement("span");
    r.textContent = e.label.substring(n, s), r.className = "parameter active";
    const a = document.createElement("span");
    a.textContent = e.label.substring(s), Z(i, o, r, a);
  }
  getParameterLabelOffsets(i, e) {
    const t = i.parameters[e];
    if (t) {
      if (Array.isArray(t.label)) return t.label;
      if (t.label.length) {
        const n = new RegExp(`(\\W|^)${No(t.label)}(?=\\W|$)`, "g");
        n.test(i.label);
        const s = n.lastIndex - t.label.length;
        return s >= 0 ? [s, n.lastIndex] : [0, 0];
      }
      return [0, 0];
    }
    return [0, 0];
  }
  next() {
    this.editor.focus(), this.model.next();
  }
  previous() {
    this.editor.focus(), this.model.previous();
  }
  getDomNode() {
    return this.domNodes || this.createParameterHintDOMNodes(), this.domNodes.element;
  }
  getId() {
    return fT.ID;
  }
  updateMaxHeight() {
    if (!this.domNodes) return;
    const i = `${Math.max(this.editor.getLayoutInfo().height / 4, 250)}px`;
    this.domNodes.element.style.maxHeight = i;
    const e = this.domNodes.element.getElementsByClassName("phwrapper");
    e.length && (e[0].style.maxHeight = i);
  }
};
Lw.ID = "editor.widget.parameterHintsWidget", Lw = fT = lhe([nN(2, Te), nN(3, Fs), nN(4, Xt)], Lw), I("editorHoverWidget.highlightForeground", { dark: Cr, light: Cr, hcDark: Cr, hcLight: Cr }, m(0, "Foreground color of the active item in the parameter hint."));
var _T, che = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, B9 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let sg = _T = class extends V {
  static get(i) {
    return i.getContribution(_T.ID);
  }
  constructor(i, e, t) {
    super(), this.editor = i, this.model = this._register(new Ck(i, t.signatureHelpProvider)), this._register(this.model.onChangedHints((n) => {
      var s;
      n ? (this.widget.value.show(), this.widget.value.render(n)) : (s = this.widget.rawValue) === null || s === void 0 || s.hide();
    })), this.widget = new ga(() => this._register(e.createInstance(Lw, this.editor, this.model)));
  }
  cancel() {
    this.model.cancel();
  }
  previous() {
    var i;
    (i = this.widget.rawValue) === null || i === void 0 || i.previous();
  }
  next() {
    var i;
    (i = this.widget.rawValue) === null || i === void 0 || i.next();
  }
  trigger(i) {
    this.model.trigger(i, 0);
  }
};
sg.ID = "editor.controller.parameterHints", sg = _T = che([B9(1, Se), B9(2, fe)], sg);
ft(sg.ID, sg, 2), X(class extends he {
  constructor() {
    super({ id: "editor.action.triggerParameterHints", label: m(0, "Trigger Parameter Hints"), alias: "Trigger Parameter Hints", precondition: E.hasSignatureHelpProvider, kbOpts: { kbExpr: E.editorTextFocus, primary: 3082, weight: 100 } });
  }
  run(i, e) {
    const t = sg.get(e);
    t == null || t.trigger({ triggerKind: ul.Invoke });
  }
});
const sN = Zi.bindToContribution(sg.get);
re(new sN({ id: "closeParameterHints", precondition: xu.Visible, handler: (i) => i.cancel(), kbOpts: { weight: 175, kbExpr: E.focus, primary: 9, secondary: [1033] } })), re(new sN({ id: "showPrevParameterHint", precondition: q.and(xu.Visible, xu.MultipleSignatures), handler: (i) => i.previous(), kbOpts: { weight: 175, kbExpr: E.focus, primary: 16, secondary: [528], mac: { primary: 16, secondary: [528, 302] } } })), re(new sN({ id: "showNextParameterHint", precondition: q.and(xu.Visible, xu.MultipleSignatures), handler: (i) => i.next(), kbOpts: { weight: 175, kbExpr: E.focus, primary: 18, secondary: [530], mac: { primary: 18, secondary: [530, 300] } } }));
var uhe = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, SC = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const yp = new ae("renameInputVisible", !1, m(0, "Whether the rename input widget is visible"));
new ae("renameInputFocused", !1, m(0, "Whether the rename input widget is focused"));
let vT = class {
  constructor(i, e, t, n, s, o) {
    this._editor = i, this._acceptKeybindings = e, this._themeService = t, this._keybindingService = n, this._logService = o, this.allowEditorOverflow = !0, this._disposables = new G(), this._visibleContextKey = yp.bindTo(s), this._isEditingRenameCandidate = !1, this._beforeFirstInputFieldEditSW = new Rn(), this._input = new ghe(), this._disposables.add(this._input), this._editor.addContentWidget(this), this._disposables.add(this._editor.onDidChangeConfiguration((r) => {
      r.hasChanged(50) && this._updateFont();
    })), this._disposables.add(t.onDidColorThemeChange(this._updateStyles, this));
  }
  dispose() {
    this._disposables.dispose(), this._editor.removeContentWidget(this);
  }
  getId() {
    return "__renameInputWidget";
  }
  getDomNode() {
    return this._domNode || (this._domNode = document.createElement("div"), this._domNode.className = "monaco-editor rename-box", this._domNode.appendChild(this._input.domNode), this._renameCandidateListView = this._disposables.add(new AP(this._domNode, { fontInfo: this._editor.getOption(50), onFocusChange: (i) => {
      this._input.domNode.value = i, this._isEditingRenameCandidate = !1;
    }, onSelectionChange: () => {
      this._isEditingRenameCandidate = !1, this.acceptInput(!1);
    } })), this._disposables.add(this._input.onDidChange(() => {
      var i, e, t, n;
      ((i = this._renameCandidateListView) === null || i === void 0 ? void 0 : i.focusedCandidate) !== void 0 && (this._isEditingRenameCandidate = !0), (e = this._timeBeforeFirstInputFieldEdit) !== null && e !== void 0 || (this._timeBeforeFirstInputFieldEdit = this._beforeFirstInputFieldEditSW.elapsed()), ((t = this._renameCandidateProvidersCts) === null || t === void 0 ? void 0 : t.token.isCancellationRequested) === !1 && this._renameCandidateProvidersCts.cancel(), (n = this._renameCandidateListView) === null || n === void 0 || n.clearFocus();
    })), this._label = document.createElement("div"), this._label.className = "rename-label", this._domNode.appendChild(this._label), this._updateFont(), this._updateStyles(this._themeService.getColorTheme())), this._domNode;
  }
  _updateStyles(i) {
    var e, t, n, s;
    if (!this._domNode) return;
    const o = i.getColor(gd), r = i.getColor(uB);
    this._domNode.style.backgroundColor = String((e = i.getColor(xi)) !== null && e !== void 0 ? e : ""), this._domNode.style.boxShadow = o ? ` 0 0 8px 2px ${o}` : "", this._domNode.style.border = r ? `1px solid ${r}` : "", this._domNode.style.color = String((t = i.getColor(pB)) !== null && t !== void 0 ? t : ""), this._input.domNode.style.backgroundColor = String((n = i.getColor(gB)) !== null && n !== void 0 ? n : "");
    const a = i.getColor(mB);
    this._input.domNode.style.borderWidth = a ? "1px" : "0px", this._input.domNode.style.borderStyle = a ? "solid" : "none", this._input.domNode.style.borderColor = (s = a == null ? void 0 : a.toString()) !== null && s !== void 0 ? s : "none";
  }
  _updateFont() {
    if (this._domNode === void 0) return;
    vt(this._label !== void 0, "RenameWidget#_updateFont: _label must not be undefined given _domNode is defined"), this._editor.applyFontInfo(this._input.domNode);
    const i = this._editor.getOption(50);
    this._label.style.fontSize = `${this._computeLabelFontSize(i.fontSize)}px`;
  }
  _computeLabelFontSize(i) {
    return 0.8 * i;
  }
  getPosition() {
    if (!this._visible || !this._editor.hasModel() || !this._editor.getDomNode()) return null;
    const i = wc(this.getDomNode().ownerDocument.body), e = Ti(this._editor.getDomNode()), t = this._getTopForPosition();
    this._nPxAvailableAbove = t + e.top, this._nPxAvailableBelow = i.height - this._nPxAvailableAbove;
    const n = this._editor.getOption(67), { totalHeight: s } = Dg.getLayoutInfo({ lineHeight: n }), o = this._nPxAvailableBelow > 6 * s ? [2, 1] : [1, 2];
    return { position: this._position, preference: o };
  }
  beforeRender() {
    var i, e;
    const [t, n] = this._acceptKeybindings;
    return this._label.innerText = m(0, "{0} to Rename, {1} to Preview", (i = this._keybindingService.lookupKeybinding(t)) === null || i === void 0 ? void 0 : i.getLabel(), (e = this._keybindingService.lookupKeybinding(n)) === null || e === void 0 ? void 0 : e.getLabel()), this._domNode.style.minWidth = "200px", null;
  }
  afterRender(i) {
    if (this._trace("invoking afterRender, position: ", i ? "not null" : "null"), i === null) return void this.cancelInput(!0, "afterRender (because position is null)");
    if (!this._editor.hasModel() || !this._editor.getDomNode()) return;
    vt(this._renameCandidateListView), vt(this._nPxAvailableAbove !== void 0), vt(this._nPxAvailableBelow !== void 0);
    const e = rd(this._input.domNode), t = rd(this._label);
    let n;
    n = i === 2 ? this._nPxAvailableBelow : this._nPxAvailableAbove, this._renameCandidateListView.layout({ height: n - t - e, width: os(this._input.domNode) });
  }
  acceptInput(i) {
    var e;
    this._trace("invoking acceptInput"), (e = this._currentAcceptInput) === null || e === void 0 || e.call(this, i);
  }
  cancelInput(i, e) {
    var t;
    this._trace(`invoking cancelInput, caller: ${e}, _currentCancelInput: ${this._currentAcceptInput ? "not undefined" : "undefined"}`), (t = this._currentCancelInput) === null || t === void 0 || t.call(this, i);
  }
  focusNextRenameSuggestion() {
    var i;
    !((i = this._renameCandidateListView) === null || i === void 0) && i.focusNext() || (this._input.domNode.value = this._currentName);
  }
  focusPreviousRenameSuggestion() {
    var i;
    !((i = this._renameCandidateListView) === null || i === void 0) && i.focusPrevious() || (this._input.domNode.value = this._currentName);
  }
  getInput(i, e, t, n, s) {
    const { start: o, end: r } = this._getSelection(i, e);
    this._renameCandidateProvidersCts = new Ci();
    const a = n(this._renameCandidateProvidersCts.token);
    this._updateRenameCandidates(a, e, s.token), this._isEditingRenameCandidate = !1, this._domNode.classList.toggle("preview", t), this._position = new W(i.startLineNumber, i.startColumn), this._currentName = e, this._input.domNode.value = e, this._input.domNode.setAttribute("selectionStart", o.toString()), this._input.domNode.setAttribute("selectionEnd", r.toString()), this._input.domNode.size = Math.max(1.1 * (i.endColumn - i.startColumn), 20), this._beforeFirstInputFieldEditSW.reset();
    const l = new G();
    l.add(ye(() => s.dispose(!0))), l.add(ye(() => {
      this._renameCandidateProvidersCts !== void 0 && (this._renameCandidateProvidersCts.dispose(!0), this._renameCandidateProvidersCts = void 0);
    }));
    const d = new b1();
    return d.p.finally(() => {
      l.dispose(), this._hide();
    }), this._currentCancelInput = (h) => {
      var c;
      return this._trace("invoking _currentCancelInput"), this._currentAcceptInput = void 0, this._currentCancelInput = void 0, (c = this._renameCandidateListView) === null || c === void 0 || c.clearCandidates(), d.complete(h), !0;
    }, this._currentAcceptInput = (h) => {
      this._trace("invoking _currentAcceptInput"), vt(this._renameCandidateListView !== void 0);
      const c = this._renameCandidateListView.nCandidates;
      let u, g;
      const p = this._renameCandidateListView.focusedCandidate;
      p !== void 0 ? (this._trace("using new name from renameSuggestion"), u = p, g = { k: "renameSuggestion" }) : (this._trace("using new name from inputField"), u = this._input.domNode.value, g = this._isEditingRenameCandidate ? { k: "userEditedRenameSuggestion" } : { k: "inputField" }), u !== e && u.trim().length !== 0 ? (this._currentAcceptInput = void 0, this._currentCancelInput = void 0, this._renameCandidateListView.clearCandidates(), d.complete({ newName: u, wantsPreview: t && h, stats: { source: g, nRenameSuggestions: c, timeBeforeFirstInputFieldEdit: this._timeBeforeFirstInputFieldEdit } })) : this.cancelInput(!0, "_currentAcceptInput (because newName === value || newName.trim().length === 0)");
    }, l.add(s.token.onCancellationRequested(() => this.cancelInput(!0, "cts.token.onCancellationRequested"))), l.add(this._editor.onDidBlurEditorWidget(() => {
      var h;
      return this.cancelInput(!(!((h = this._domNode) === null || h === void 0) && h.ownerDocument.hasFocus()), "editor.onDidBlurEditorWidget");
    })), this._show(), d.p;
  }
  _getSelection(i, e) {
    vt(this._editor.hasModel());
    const t = this._editor.getSelection();
    let n = 0, s = e.length;
    return D.isEmpty(t) || D.spansMultipleLines(t) || !D.containsRange(i, t) || (n = Math.max(0, t.startColumn - i.startColumn), s = Math.min(i.endColumn, t.endColumn) - i.startColumn), { start: n, end: s };
  }
  _show() {
    this._trace("invoking _show"), this._editor.revealLineInCenterIfOutsideViewport(this._position.lineNumber, 0), this._visible = !0, this._visibleContextKey.set(!0), this._editor.layoutContentWidget(this), setTimeout(() => {
      this._input.domNode.focus(), this._input.domNode.setSelectionRange(parseInt(this._input.domNode.getAttribute("selectionStart")), parseInt(this._input.domNode.getAttribute("selectionEnd")));
    }, 100);
  }
  async _updateRenameCandidates(i, e, t) {
    const n = (...l) => this._trace("_updateRenameCandidates", ...l);
    n("start");
    const s = await v1(Promise.allSettled(i), t);
    if (s === void 0) return void n("returning early - received updateRenameCandidates results - undefined");
    const o = s.flatMap((l) => l.status === "fulfilled" && cl(l.value) ? l.value : []);
    n(`received updateRenameCandidates results - total (unfiltered) ${o.length} candidates.`);
    const r = Ad(o, (l) => l.newSymbolName);
    n(`distinct candidates - ${r.length} candidates.`);
    const a = r.filter(({ newSymbolName: l }) => l.trim().length > 0 && l !== this._input.domNode.value && l !== e);
    n(`valid distinct candidates - ${o.length} candidates.`), a.length < 1 ? n("returning early - no valid distinct candidates") : (n("setting candidates"), this._renameCandidateListView.setCandidates(a), n("asking editor to re-layout"), this._editor.layoutContentWidget(this));
  }
  _hide() {
    this._trace("invoked _hide"), this._visible = !1, this._visibleContextKey.reset(), this._editor.layoutContentWidget(this);
  }
  _getTopForPosition() {
    const i = this._editor.getVisibleRanges();
    let e;
    return i.length > 0 ? e = i[0].startLineNumber : (this._logService.warn("RenameWidget#_getTopForPosition: this should not happen - visibleRanges is empty"), e = Math.max(1, this._position.lineNumber - 5)), this._editor.getTopForLineNumber(this._position.lineNumber) - this._editor.getTopForLineNumber(e);
  }
  _trace(...i) {
    this._logService.trace("RenameWidget", ...i);
  }
};
vT = uhe([SC(2, Yi), SC(3, Dt), SC(4, Te), SC(5, ts)], vT);
class AP {
  constructor(e, t) {
    this._disposables = new G(), this._availableHeight = 0, this._minimumWidth = 0, this._lineHeight = t.fontInfo.lineHeight, this._typicalHalfwidthCharacterWidth = t.fontInfo.typicalHalfwidthCharacterWidth, this._listContainer = document.createElement("div"), e.appendChild(this._listContainer), this._listWidget = AP._createListWidget(this._listContainer, this._candidateViewHeight, t.fontInfo), this._listWidget.onDidChangeFocus((n) => {
      n.elements.length === 1 && t.onFocusChange(n.elements[0].newSymbolName);
    }, this._disposables), this._listWidget.onDidChangeSelection((n) => {
      n.elements.length === 1 && t.onSelectionChange();
    }, this._disposables), this._disposables.add(this._listWidget.onDidBlur((n) => {
      this._listWidget.setFocus([]);
    })), this._listWidget.style(Rg({ listInactiveFocusForeground: Ah, listInactiveFocusBackground: Ph }));
  }
  dispose() {
    this._listWidget.dispose(), this._disposables.dispose();
  }
  layout({ height: e, width: t }) {
    this._availableHeight = e, this._minimumWidth = t;
  }
  setCandidates(e) {
    this._listWidget.splice(0, 0, e);
    const t = this._pickListHeight(e.length), n = this._pickListWidth(e);
    this._listWidget.layout(t, n), this._listContainer.style.height = `${t}px`, this._listContainer.style.width = `${n}px`, vl(m(0, "Received {0} rename suggestions", e.length));
  }
  clearCandidates() {
    this._listContainer.style.height = "0px", this._listContainer.style.width = "0px", this._listWidget.splice(0, this._listWidget.length, []);
  }
  get nCandidates() {
    return this._listWidget.length;
  }
  get focusedCandidate() {
    if (this._listWidget.length === 0) return;
    const e = this._listWidget.getSelectedElements()[0];
    if (e !== void 0) return e.newSymbolName;
    const t = this._listWidget.getFocusedElements()[0];
    return t !== void 0 ? t.newSymbolName : void 0;
  }
  focusNext() {
    if (this._listWidget.length === 0) return !1;
    const e = this._listWidget.getFocus();
    return e.length === 0 ? (this._listWidget.focusFirst(), !0) : e[0] === this._listWidget.length - 1 ? (this._listWidget.setFocus([]), !1) : (this._listWidget.focusNext(), !0);
  }
  focusPrevious() {
    if (this._listWidget.length === 0) return !1;
    const e = this._listWidget.getFocus();
    return e.length === 0 ? (this._listWidget.focusLast(), !0) : e[0] === 0 ? (this._listWidget.setFocus([]), !1) : (this._listWidget.focusPrevious(), !0);
  }
  clearFocus() {
    this._listWidget.setFocus([]);
  }
  get _candidateViewHeight() {
    const { totalHeight: e } = Dg.getLayoutInfo({ lineHeight: this._lineHeight });
    return e;
  }
  _pickListHeight(e) {
    const t = this._candidateViewHeight * e;
    return Math.min(t, this._availableHeight, 7 * this._candidateViewHeight);
  }
  _pickListWidth(e) {
    const t = Math.ceil(Math.max(...e.map((n) => n.newSymbolName.length)) * this._typicalHalfwidthCharacterWidth);
    return Math.max(this._minimumWidth, 25 + t + 10);
  }
  static _createListWidget(e, t, n) {
    const s = new class {
      getTemplateId(r) {
        return "candidate";
      }
      getHeight(r) {
        return t;
      }
    }(), o = new class {
      constructor() {
        this.templateId = "candidate";
      }
      renderTemplate(r) {
        return new Dg(r, n);
      }
      renderElement(r, a, l) {
        l.populate(r);
      }
      disposeTemplate(r) {
        r.dispose();
      }
    }();
    return new uo("NewSymbolNameCandidates", e, s, [o], { keyboardSupport: !1, mouseSupport: !0, multipleSelectionSupport: !1 });
  }
}
class ghe {
  constructor() {
    this._onDidChange = new F(), this.onDidChange = this._onDidChange.event, this._disposables = new G();
  }
  get domNode() {
    return this._domNode || (this._domNode = document.createElement("input"), this._domNode.className = "rename-input", this._domNode.type = "text", this._domNode.setAttribute("aria-label", m(0, "Rename input. Type new name and press Enter to commit.")), this._disposables.add(K(this._domNode, "input", () => this._onDidChange.fire()))), this._domNode;
  }
  dispose() {
    this._onDidChange.dispose(), this._disposables.dispose();
  }
}
class Dg {
  constructor(e, t) {
    this._domNode = document.createElement("div"), this._domNode.style.display = "flex", this._domNode.style.columnGap = "5px", this._domNode.style.alignItems = "center", this._domNode.style.height = `${t.lineHeight}px`, this._domNode.style.padding = `${Dg._PADDING}px`;
    const n = document.createElement("div");
    n.style.display = "flex", n.style.alignItems = "center", n.style.width = n.style.height = 0.8 * t.lineHeight + "px", this._domNode.appendChild(n), this._icon = Dv(ne.sparkle), this._icon.style.display = "none", n.appendChild(this._icon), this._label = document.createElement("div"), yn(this._label, t), this._domNode.appendChild(this._label), e.appendChild(this._domNode);
  }
  populate(e) {
    this._updateIcon(e), this._updateLabel(e);
  }
  _updateIcon(e) {
    var t;
    const n = !!(!((t = e.tags) === null || t === void 0) && t.includes(MN.AIGenerated));
    this._icon.style.display = n ? "inherit" : "none";
  }
  _updateLabel(e) {
    this._label.innerText = e.newSymbolName;
  }
  static getLayoutInfo({ lineHeight: e }) {
    return { totalHeight: e + 2 * Dg._PADDING };
  }
  dispose() {
  }
}
Dg._PADDING = 2;
var bT, phe = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, th = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class CT {
  constructor(e, t, n) {
    this.model = e, this.position = t, this._providerRenameIdx = 0, this._providers = n.ordered(e);
  }
  hasProvider() {
    return this._providers.length > 0;
  }
  async resolveRenameLocation(e) {
    const t = [];
    for (this._providerRenameIdx = 0; this._providerRenameIdx < this._providers.length; this._providerRenameIdx++) {
      const s = this._providers[this._providerRenameIdx];
      if (!s.resolveRenameLocation) break;
      const o = await s.resolveRenameLocation(this.model, this.position, e);
      if (o) {
        if (!o.rejectReason) return o;
        t.push(o.rejectReason);
      }
    }
    this._providerRenameIdx = 0;
    const n = this.model.getWordAtPosition(this.position);
    return n ? { range: new D(this.position.lineNumber, n.startColumn, this.position.lineNumber, n.endColumn), text: n.word, rejectReason: t.length > 0 ? t.join(`
`) : void 0 } : { range: D.fromPositions(this.position), text: "", rejectReason: t.length > 0 ? t.join(`
`) : void 0 };
  }
  async provideRenameEdits(e, t) {
    return this._provideRenameEdits(e, this._providerRenameIdx, [], t);
  }
  async _provideRenameEdits(e, t, n, s) {
    const o = this._providers[t];
    if (!o) return { edits: [], rejectReason: n.join(`
`) };
    const r = await o.provideRenameEdits(this.model, this.position, e, s);
    return r ? r.rejectReason ? this._provideRenameEdits(e, t + 1, n.concat(r.rejectReason), s) : r : this._provideRenameEdits(e, t + 1, n.concat(m(0, "No result.")), s);
  }
}
let Td = bT = class {
  static get(i) {
    return i.getContribution(bT.ID);
  }
  constructor(i, e, t, n, s, o, r, a, l) {
    this.editor = i, this._instaService = e, this._notificationService = t, this._bulkEditService = n, this._progressService = s, this._logService = o, this._configService = r, this._languageFeaturesService = a, this._telemetryService = l, this._disposableStore = new G(), this._cts = new Ci(), this._renameWidget = this._disposableStore.add(this._instaService.createInstance(vT, this.editor, ["acceptRenameInput", "acceptRenameInputWithPreview"]));
  }
  dispose() {
    this._disposableStore.dispose(), this._cts.dispose(!0);
  }
  async run() {
    var i, e;
    const t = this._logService.trace.bind(this._logService, "[rename]");
    if (this._cts.dispose(!0), this._cts = new Ci(), !this.editor.hasModel()) return void t("editor has no model");
    const n = this.editor.getPosition(), s = new CT(this.editor.getModel(), n, this._languageFeaturesService.renameProvider);
    if (!s.hasProvider()) return void t("skeleton has no provider");
    const o = new Mc(this.editor, 5, void 0, this._cts.token);
    let r;
    try {
      t("resolving rename location");
      const g = s.resolveRenameLocation(o.token);
      this._progressService.showWhile(g, 250), r = await g, t("resolved rename location");
    } catch (g) {
      return void (g instanceof Vd ? t("resolve rename location cancelled", JSON.stringify(g, null, "	")) : (t("resolve rename location failed", g instanceof Error ? g : JSON.stringify(g, null, "	")), (typeof g == "string" || ha(g)) && ((i = bs.get(this.editor)) === null || i === void 0 || i.showMessage(g || m(0, "An unknown error occurred while resolving rename location"), n))));
    } finally {
      o.dispose();
    }
    if (!r) return void t("returning early - no loc");
    if (r.rejectReason) return t(`returning early - rejected with reason: ${r.rejectReason}`, r.rejectReason), void ((e = bs.get(this.editor)) === null || e === void 0 || e.showMessage(r.rejectReason, n));
    if (o.token.isCancellationRequested) return void t("returning early - cts1 cancelled");
    const a = new Mc(this.editor, 5, r.range, this._cts.token), l = this.editor.getModel(), d = this._languageFeaturesService.newSymbolNamesProvider.all(l);
    t("creating rename input field and awaiting its result");
    const h = this._bulkEditService.hasPreviewHandler() && this._configService.getValue(this.editor.getModel().uri, "editor.rename.enablePreview"), c = await this._renameWidget.getInput(r.range, r.text, h, (g) => d.map((p) => p.provideNewSymbolNames(l, r.range, g)), a);
    if (t("received response from rename input field"), d.length > 0 && this._reportTelemetry(d.length, l.getLanguageId(), c), typeof c == "boolean") return t(`returning early - rename input field response - ${c}`), c && this.editor.focus(), void a.dispose();
    this.editor.focus(), t("requesting rename edits");
    const u = v1(s.provideRenameEdits(c.newName, a.token), a.token).then(async (g) => {
      if (g) if (this.editor.hasModel()) {
        if (g.rejectReason) return t(`returning early - rejected with reason: ${g.rejectReason}`), void this._notificationService.info(g.rejectReason);
        this.editor.setSelection(D.fromPositions(this.editor.getSelection().getPosition())), t("applying edits"), this._bulkEditService.apply(g, { editor: this.editor, showPreview: c.wantsPreview, label: m(0, "Renaming '{0}' to '{1}'", r == null ? void 0 : r.text, c.newName), code: "undoredo.rename", quotableLabel: m(0, "Renaming {0} to {1}", r == null ? void 0 : r.text, c.newName), respectAutoSaveConfig: !0 }).then((p) => {
          t("edits applied"), p.ariaSummary && Io(m(0, "Successfully renamed '{0}' to '{1}'. Summary: {2}", r.text, c.newName, p.ariaSummary));
        }).catch((p) => {
          t(`error when applying edits ${JSON.stringify(p, null, "	")}`), this._notificationService.error(m(0, "Rename failed to apply edits")), this._logService.error(p);
        });
      } else t("returning early - no model after rename edits are provided");
      else t("returning early - no rename edits result");
    }, (g) => {
      t("error when providing rename edits", JSON.stringify(g, null, "	")), this._notificationService.error(m(0, "Rename failed to compute edits")), this._logService.error(g);
    }).finally(() => {
      a.dispose();
    });
    return t("returning rename operation"), this._progressService.showWhile(u, 250), u;
  }
  acceptRenameInput(i) {
    this._renameWidget.acceptInput(i);
  }
  cancelRenameInput() {
    this._renameWidget.cancelInput(!0, "cancelRenameInput command");
  }
  focusNextRenameSuggestion() {
    this._renameWidget.focusNextRenameSuggestion();
  }
  focusPreviousRenameSuggestion() {
    this._renameWidget.focusPreviousRenameSuggestion();
  }
  _reportTelemetry(i, e, t) {
    const n = typeof t == "boolean" ? { kind: "cancelled", languageId: e, nRenameSuggestionProviders: i } : { kind: "accepted", languageId: e, nRenameSuggestionProviders: i, source: t.stats.source.k, nRenameSuggestions: t.stats.nRenameSuggestions, timeBeforeFirstInputFieldEdit: t.stats.timeBeforeFirstInputFieldEdit, wantsPreview: t.wantsPreview };
    this._telemetryService.publicLog2("renameInvokedEvent", n);
  }
};
Td.ID = "editor.contrib.renameController", Td = bT = phe([th(1, Se), th(2, Ri), th(3, R1), th(4, Ec), th(5, ts), th(6, NR), th(7, fe), th(8, es)], Td);
ft(Td.ID, Td, 4), X(class extends he {
  constructor() {
    super({ id: "editor.action.rename", label: m(0, "Rename Symbol"), alias: "Rename Symbol", precondition: q.and(E.writable, E.hasRenameProvider), kbOpts: { kbExpr: E.editorTextFocus, primary: 60, weight: 100 }, contextMenuOpts: { group: "1_modification", order: 1.1 } });
  }
  runCommand(i, e) {
    const t = i.get(mt), [n, s] = Array.isArray(e) && e || [void 0, void 0];
    return Ie.isUri(n) && W.isIPosition(s) ? t.openCodeEditor({ resource: n }, t.getActiveCodeEditor()).then((o) => {
      o && (o.setPosition(s), o.invokeWithinContext((r) => (this.reportTelemetry(r, o), this.run(r, o))));
    }, We) : super.runCommand(i, e);
  }
  run(i, e) {
    const t = i.get(ts), n = Td.get(e);
    return n ? (t.trace("[RenameAction] got controller, running..."), n.run()) : (t.trace("[RenameAction] returning early - controller missing"), Promise.resolve());
  }
});
const oN = Zi.bindToContribution(Td.get);
re(new oN({ id: "acceptRenameInput", precondition: yp, handler: (i) => i.acceptRenameInput(!1), kbOpts: { weight: 199, kbExpr: q.and(E.focus, q.not("isComposing")), primary: 3 } })), re(new oN({ id: "acceptRenameInputWithPreview", precondition: q.and(yp, q.has("config.editor.rename.enablePreview")), handler: (i) => i.acceptRenameInput(!0), kbOpts: { weight: 199, kbExpr: q.and(E.focus, q.not("isComposing")), primary: 2051 } })), re(new oN({ id: "cancelRenameInput", precondition: yp, handler: (i) => i.cancelRenameInput(), kbOpts: { weight: 199, kbExpr: E.focus, primary: 9, secondary: [1033] } })), Ft(class extends cs {
  constructor() {
    super({ id: "focusNextRenameSuggestion", title: { ...ct(0, "Focus Next Rename Suggestion") }, precondition: yp, keybinding: [{ primary: 2, secondary: [18], weight: 199 }] });
  }
  run(i) {
    const e = i.get(mt).getFocusedCodeEditor();
    if (!e) return;
    const t = Td.get(e);
    t && t.focusNextRenameSuggestion();
  }
}), Ft(class extends cs {
  constructor() {
    super({ id: "focusPreviousRenameSuggestion", title: { ...ct(0, "Focus Previous Rename Suggestion") }, precondition: yp, keybinding: [{ primary: 1026, secondary: [16], weight: 199 }] });
  }
  run(i) {
    const e = i.get(mt).getFocusedCodeEditor();
    if (!e) return;
    const t = Td.get(e);
    t && t.focusPreviousRenameSuggestion();
  }
}), qa("_executeDocumentRenameProvider", function(i, e, t, ...n) {
  const [s] = n;
  vt(typeof s == "string");
  const { renameProvider: o } = i.get(fe);
  return async function(r, a, l, d) {
    const h = new CT(a, l, r), c = await h.resolveRenameLocation(et.None);
    return c != null && c.rejectReason ? { edits: [], rejectReason: c.rejectReason } : h.provideRenameEdits(d, et.None);
  }(o, e, t, s);
}), qa("_executePrepareRename", async function(i, e, t) {
  const { renameProvider: n } = i.get(fe), s = new CT(e, t, n), o = await s.resolveRenameLocation(et.None);
  if (o != null && o.rejectReason) throw new Error(o.rejectReason);
  return o;
}), li.as(fa).registerConfiguration({ id: "editor", properties: { "editor.rename.enablePreview": { scope: 5, description: m(0, "Enable/disable the ability to preview changes before renaming"), default: !0, type: "boolean" } } });
var mhe = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, W9 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let a_ = class extends V {
  constructor(i, e, t) {
    super(), this.editor = i, this.languageConfigurationService = e, this.editorWorkerService = t, this.decorations = this.editor.createDecorationsCollection(), this.options = this.createOptions(i.getOption(73)), this.computePromise = null, this.currentOccurrences = {}, this._register(i.onDidChangeModel((n) => {
      this.currentOccurrences = {}, this.options = this.createOptions(i.getOption(73)), this.stop(), this.computeSectionHeaders.schedule(0);
    })), this._register(i.onDidChangeModelLanguage((n) => {
      this.currentOccurrences = {}, this.options = this.createOptions(i.getOption(73)), this.stop(), this.computeSectionHeaders.schedule(0);
    })), this._register(e.onDidChange((n) => {
      var s;
      const o = (s = this.editor.getModel()) === null || s === void 0 ? void 0 : s.getLanguageId();
      o && n.affects(o) && (this.currentOccurrences = {}, this.options = this.createOptions(i.getOption(73)), this.stop(), this.computeSectionHeaders.schedule(0));
    })), this._register(i.onDidChangeConfiguration((n) => {
      this.options && !n.hasChanged(73) || (this.options = this.createOptions(i.getOption(73)), this.updateDecorations([]), this.stop(), this.computeSectionHeaders.schedule(0));
    })), this._register(this.editor.onDidChangeModelContent((n) => {
      this.computeSectionHeaders.schedule();
    })), this.computeSectionHeaders = this._register(new It(() => {
      this.findSectionHeaders();
    }, 250)), this.computeSectionHeaders.schedule(0);
  }
  createOptions(i) {
    if (!i || !this.editor.hasModel()) return;
    const e = this.editor.getModel().getLanguageId();
    if (!e) return;
    const t = this.languageConfigurationService.getLanguageConfiguration(e).comments, n = this.languageConfigurationService.getLanguageConfiguration(e).foldingRules;
    return t || n != null && n.markers ? { foldingRules: n, findMarkSectionHeaders: i.showMarkSectionHeaders, findRegionSectionHeaders: i.showRegionSectionHeaders } : void 0;
  }
  findSectionHeaders() {
    var i, e;
    if (!this.editor.hasModel() || !(!((i = this.options) === null || i === void 0) && i.findMarkSectionHeaders) && !(!((e = this.options) === null || e === void 0) && e.findRegionSectionHeaders)) return;
    const t = this.editor.getModel();
    if (t.isDisposed() || t.isTooLargeForSyncing()) return;
    const n = t.getVersionId();
    this.editorWorkerService.findSectionHeaders(t.uri, this.options).then((s) => {
      t.isDisposed() || t.getVersionId() !== n || this.updateDecorations(s);
    });
  }
  updateDecorations(i) {
    const e = this.editor.getModel();
    e && (i = i.filter((s) => {
      if (!s.shouldBeInComments) return !0;
      const o = e.validateRange(s.range), r = e.tokenization.getLineTokens(o.startLineNumber), a = r.findTokenIndexAtOffset(o.startColumn - 1), l = r.getStandardTokenType(a);
      return r.getLanguageId(a) === e.getLanguageId() && l === 1;
    }));
    const t = Object.values(this.currentOccurrences).map((s) => s.decorationId), n = i.map((s) => function(o) {
      return { range: o.range, options: Ve.createDynamic({ description: "section-header", stickiness: 3, collapseOnReplaceEdit: !0, minimap: { color: void 0, position: 1, sectionHeaderStyle: o.hasSeparatorLine ? 2 : 1, sectionHeaderText: o.text } }) };
    }(s));
    this.editor.changeDecorations((s) => {
      const o = s.deltaDecorations(t, n);
      this.currentOccurrences = {};
      for (let r = 0, a = o.length; r < a; r++) {
        const l = { sectionHeader: i[r], decorationId: o[r] };
        this.currentOccurrences[l.decorationId] = l;
      }
    });
  }
  stop() {
    this.computeSectionHeaders.cancel(), this.computePromise && (this.computePromise.cancel(), this.computePromise = null);
  }
  dispose() {
    super.dispose(), this.stop(), this.decorations.clear();
  }
};
function V9(i) {
  const e = new Uint32Array(function(n) {
    let s = 0;
    if (s += 2, n.type === "full") s += 1 + n.data.length;
    else {
      s += 1, s += 3 * n.deltas.length;
      for (const o of n.deltas) o.data && (s += o.data.length);
    }
    return s;
  }(i));
  let t = 0;
  if (e[t++] = i.id, i.type === "full") e[t++] = 1, e[t++] = i.data.length, e.set(i.data, t), t += i.data.length;
  else {
    e[t++] = 2, e[t++] = i.deltas.length;
    for (const n of i.deltas) e[t++] = n.start, e[t++] = n.deleteCount, n.data ? (e[t++] = n.data.length, e.set(n.data, t), t += n.data.length) : e[t++] = 0;
  }
  return function(n) {
    const s = new Uint8Array(n.buffer, n.byteOffset, 4 * n.length);
    return k7() || function(o) {
      for (let r = 0, a = o.length; r < a; r += 4) {
        const l = o[r + 0], d = o[r + 1], h = o[r + 2], c = o[r + 3];
        o[r + 0] = c, o[r + 1] = h, o[r + 2] = d, o[r + 3] = l;
      }
    }(s), iL.wrap(s);
  }(e);
}
function wk(i) {
  return i && !!i.data;
}
function gU(i) {
  return i && Array.isArray(i.edits);
}
a_.ID = "editor.sectionHeaderDetector", a_ = mhe([W9(1, zt), W9(2, Qo)], a_), ft(a_.ID, a_, 1);
class fhe {
  constructor(e, t, n) {
    this.provider = e, this.tokens = t, this.error = n;
  }
}
function pU(i, e) {
  return i.has(e);
}
async function mU(i, e, t, n, s) {
  const o = function(a, l) {
    const d = a.orderedGroups(l);
    return d.length > 0 ? d[0] : [];
  }(i, e), r = await Promise.all(o.map(async (a) => {
    let l, d = null;
    try {
      l = await a.provideDocumentSemanticTokens(e, a === t ? n : null, s);
    } catch (h) {
      d = h, l = null;
    }
    return l && (wk(l) || gU(l)) || (l = null), new fhe(a, l, d);
  }));
  for (const a of r) {
    if (a.error) throw a.error;
    if (a.tokens) return a;
  }
  return r.length > 0 ? r[0] : null;
}
class _he {
  constructor(e, t) {
    this.provider = e, this.tokens = t;
  }
}
function fU(i, e) {
  const t = i.orderedGroups(e);
  return t.length > 0 ? t[0] : [];
}
async function wT(i, e, t, n) {
  const s = fU(i, e), o = await Promise.all(s.map(async (r) => {
    let a;
    try {
      a = await r.provideDocumentRangeSemanticTokens(e, t, n);
    } catch (l) {
      Ni(l), a = null;
    }
    return a && wk(a) || (a = null), new _he(r, a);
  }));
  for (const r of o) if (r.tokens) return r;
  return o.length > 0 ? o[0] : null;
}
dt.registerCommand("_provideDocumentSemanticTokensLegend", async (i, ...e) => {
  const [t] = e;
  vt(t instanceof Ie);
  const n = i.get(ni).getModel(t);
  if (!n) return;
  const { documentSemanticTokensProvider: s } = i.get(fe), o = function(r, a) {
    const l = r.orderedGroups(a);
    return l.length > 0 ? l[0] : null;
  }(s, n);
  return o ? o[0].getLegend() : i.get(ai).executeCommand("_provideDocumentRangeSemanticTokensLegend", t);
}), dt.registerCommand("_provideDocumentSemanticTokens", async (i, ...e) => {
  const [t] = e;
  vt(t instanceof Ie);
  const n = i.get(ni).getModel(t);
  if (!n) return;
  const { documentSemanticTokensProvider: s } = i.get(fe);
  if (!pU(s, n)) return i.get(ai).executeCommand("_provideDocumentRangeSemanticTokens", t, n.getFullModelRange());
  const o = await mU(s, n, null, null, et.None);
  if (!o) return;
  const { provider: r, tokens: a } = o;
  if (!a || !wk(a)) return;
  const l = V9({ id: 0, type: "full", data: a.data });
  return a.resultId && r.releaseDocumentSemanticTokens(a.resultId), l;
}), dt.registerCommand("_provideDocumentRangeSemanticTokensLegend", async (i, ...e) => {
  const [t, n] = e;
  vt(t instanceof Ie);
  const s = i.get(ni).getModel(t);
  if (!s) return;
  const { documentRangeSemanticTokensProvider: o } = i.get(fe), r = fU(o, s);
  if (r.length === 0) return;
  if (r.length === 1) return r[0].getLegend();
  if (!n || !D.isIRange(n)) return console.warn("provideDocumentRangeSemanticTokensLegend might be out-of-sync with provideDocumentRangeSemanticTokens unless a range argument is passed in"), r[0].getLegend();
  const a = await wT(o, s, D.lift(n), et.None);
  return a ? a.provider.getLegend() : void 0;
}), dt.registerCommand("_provideDocumentRangeSemanticTokens", async (i, ...e) => {
  const [t, n] = e;
  vt(t instanceof Ie), vt(D.isIRange(n));
  const s = i.get(ni).getModel(t);
  if (!s) return;
  const { documentRangeSemanticTokensProvider: o } = i.get(fe), r = await wT(o, s, D.lift(n), et.None);
  return r && r.tokens ? V9({ id: 0, type: "full", data: r.tokens.data }) : void 0;
});
const PP = "editor.semanticHighlighting";
function kw(i, e, t) {
  var n;
  const s = (n = t.getValue(PP, { overrideIdentifier: i.getLanguageId(), resource: i.uri })) === null || n === void 0 ? void 0 : n.enabled;
  return typeof s == "boolean" ? s : e.getColorTheme().semanticHighlighting;
}
var uh, _U = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Ka = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let yT = class extends V {
  constructor(i, e, t, n, s, o) {
    super(), this._watchers = /* @__PURE__ */ Object.create(null);
    const r = (d) => {
      this._watchers[d.uri.toString()] = new K_(d, i, t, s, o);
    }, a = (d, h) => {
      h.dispose(), delete this._watchers[d.uri.toString()];
    }, l = () => {
      for (const d of e.getModels()) {
        const h = this._watchers[d.uri.toString()];
        kw(d, t, n) ? h || r(d) : h && a(d, h);
      }
    };
    e.getModels().forEach((d) => {
      kw(d, t, n) && r(d);
    }), this._register(e.onModelAdded((d) => {
      kw(d, t, n) && r(d);
    })), this._register(e.onModelRemoved((d) => {
      const h = this._watchers[d.uri.toString()];
      h && a(d, h);
    })), this._register(n.onDidChangeConfiguration((d) => {
      d.affectsConfiguration(PP) && l();
    })), this._register(t.onDidColorThemeChange(l));
  }
  dispose() {
    for (const i of Object.values(this._watchers)) i.dispose();
    super.dispose();
  }
};
yT = _U([Ka(0, _L), Ka(1, ni), Ka(2, Yi), Ka(3, Ye), Ka(4, ar), Ka(5, fe)], yT);
let K_ = uh = class extends V {
  constructor(i, e, t, n, s) {
    super(), this._semanticTokensStylingService = e, this._isDisposed = !1, this._model = i, this._provider = s.documentSemanticTokensProvider, this._debounceInformation = n.for(this._provider, "DocumentSemanticTokens", { min: uh.REQUEST_MIN_DELAY, max: uh.REQUEST_MAX_DELAY }), this._fetchDocumentSemanticTokens = this._register(new It(() => this._fetchDocumentSemanticTokensNow(), uh.REQUEST_MIN_DELAY)), this._currentDocumentResponse = null, this._currentDocumentRequestCancellationTokenSource = null, this._documentProvidersChangeListeners = [], this._providersChangedDuringRequest = !1, this._register(this._model.onDidChangeContent(() => {
      this._fetchDocumentSemanticTokens.isScheduled() || this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model));
    })), this._register(this._model.onDidChangeAttached(() => {
      this._fetchDocumentSemanticTokens.isScheduled() || this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model));
    })), this._register(this._model.onDidChangeLanguage(() => {
      this._currentDocumentResponse && (this._currentDocumentResponse.dispose(), this._currentDocumentResponse = null), this._currentDocumentRequestCancellationTokenSource && (this._currentDocumentRequestCancellationTokenSource.cancel(), this._currentDocumentRequestCancellationTokenSource = null), this._setDocumentSemanticTokens(null, null, null, []), this._fetchDocumentSemanticTokens.schedule(0);
    }));
    const o = () => {
      Ht(this._documentProvidersChangeListeners), this._documentProvidersChangeListeners = [];
      for (const r of this._provider.all(i)) typeof r.onDidChange == "function" && this._documentProvidersChangeListeners.push(r.onDidChange(() => {
        this._currentDocumentRequestCancellationTokenSource ? this._providersChangedDuringRequest = !0 : this._fetchDocumentSemanticTokens.schedule(0);
      }));
    };
    o(), this._register(this._provider.onDidChange(() => {
      o(), this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model));
    })), this._register(t.onDidColorThemeChange((r) => {
      this._setDocumentSemanticTokens(null, null, null, []), this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model));
    })), this._fetchDocumentSemanticTokens.schedule(0);
  }
  dispose() {
    this._currentDocumentResponse && (this._currentDocumentResponse.dispose(), this._currentDocumentResponse = null), this._currentDocumentRequestCancellationTokenSource && (this._currentDocumentRequestCancellationTokenSource.cancel(), this._currentDocumentRequestCancellationTokenSource = null), Ht(this._documentProvidersChangeListeners), this._documentProvidersChangeListeners = [], this._setDocumentSemanticTokens(null, null, null, []), this._isDisposed = !0, super.dispose();
  }
  _fetchDocumentSemanticTokensNow() {
    if (this._currentDocumentRequestCancellationTokenSource) return;
    if (!pU(this._provider, this._model)) return void (this._currentDocumentResponse && this._model.tokenization.setSemanticTokens(null, !1));
    if (!this._model.isAttachedToEditor()) return;
    const i = new Ci(), e = this._currentDocumentResponse ? this._currentDocumentResponse.provider : null, t = this._currentDocumentResponse && this._currentDocumentResponse.resultId || null, n = mU(this._provider, this._model, e, t, i.token);
    this._currentDocumentRequestCancellationTokenSource = i, this._providersChangedDuringRequest = !1;
    const s = [], o = this._model.onDidChangeContent((a) => {
      s.push(a);
    }), r = new Rn(!1);
    n.then((a) => {
      if (this._debounceInformation.update(this._model, r.elapsed()), this._currentDocumentRequestCancellationTokenSource = null, o.dispose(), a) {
        const { provider: l, tokens: d } = a, h = this._semanticTokensStylingService.getStyling(l);
        this._setDocumentSemanticTokens(l, d || null, h, s);
      } else this._setDocumentSemanticTokens(null, null, null, s);
    }, (a) => {
      a && (Sa(a) || typeof a.message == "string" && a.message.indexOf("busy") !== -1) || We(a), this._currentDocumentRequestCancellationTokenSource = null, o.dispose(), (s.length > 0 || this._providersChangedDuringRequest) && (this._fetchDocumentSemanticTokens.isScheduled() || this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model)));
    });
  }
  static _copy(i, e, t, n, s) {
    s = Math.min(s, t.length - n, i.length - e);
    for (let o = 0; o < s; o++) t[n + o] = i[e + o];
  }
  _setDocumentSemanticTokens(i, e, t, n) {
    const s = this._currentDocumentResponse, o = () => {
      (n.length > 0 || this._providersChangedDuringRequest) && !this._fetchDocumentSemanticTokens.isScheduled() && this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model));
    };
    if (this._currentDocumentResponse && (this._currentDocumentResponse.dispose(), this._currentDocumentResponse = null), this._isDisposed) i && e && i.releaseDocumentSemanticTokens(e.resultId);
    else if (i && t) {
      if (!e) return this._model.tokenization.setSemanticTokens(null, !0), void o();
      if (gU(e)) {
        if (!s) return void this._model.tokenization.setSemanticTokens(null, !0);
        if (e.edits.length === 0) e = { resultId: e.resultId, data: s.data };
        else {
          let r = 0;
          for (const c of e.edits) r += (c.data ? c.data.length : 0) - c.deleteCount;
          const a = s.data, l = new Uint32Array(a.length + r);
          let d = a.length, h = l.length;
          for (let c = e.edits.length - 1; c >= 0; c--) {
            const u = e.edits[c];
            if (u.start > a.length) return t.warnInvalidEditStart(s.resultId, e.resultId, c, u.start, a.length), void this._model.tokenization.setSemanticTokens(null, !0);
            const g = d - (u.start + u.deleteCount);
            g > 0 && (uh._copy(a, d - g, l, h - g, g), h -= g), u.data && (uh._copy(u.data, 0, l, h - u.data.length, u.data.length), h -= u.data.length), d = u.start;
          }
          d > 0 && uh._copy(a, 0, l, 0, d), e = { resultId: e.resultId, data: l };
        }
      }
      if (wk(e)) {
        this._currentDocumentResponse = new vhe(i, e.resultId, e.data);
        const r = wW(e, t, this._model.getLanguageId());
        if (n.length > 0) for (const a of n) for (const l of r) for (const d of a.changes) l.applyEdit(d.range, d.text);
        this._model.tokenization.setSemanticTokens(r, !0);
      } else this._model.tokenization.setSemanticTokens(null, !0);
      o();
    } else this._model.tokenization.setSemanticTokens(null, !1);
  }
};
K_.REQUEST_MIN_DELAY = 300, K_.REQUEST_MAX_DELAY = 2e3, K_ = uh = _U([Ka(1, _L), Ka(2, Yi), Ka(3, ar), Ka(4, fe)], K_);
class vhe {
  constructor(e, t, n) {
    this.provider = e, this.resultId = t, this.data = n;
  }
  dispose() {
    this.provider.releaseDocumentSemanticTokens(this.resultId);
  }
}
H1(yT);
var bhe = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, l_ = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let d_ = class extends V {
  constructor(i, e, t, n, s, o) {
    super(), this._semanticTokensStylingService = e, this._themeService = t, this._configurationService = n, this._editor = i, this._provider = o.documentRangeSemanticTokensProvider, this._debounceInformation = s.for(this._provider, "DocumentRangeSemanticTokens", { min: 100, max: 500 }), this._tokenizeViewport = this._register(new It(() => this._tokenizeViewportNow(), 100)), this._outstandingRequests = [];
    const r = () => {
      this._editor.hasModel() && this._tokenizeViewport.schedule(this._debounceInformation.get(this._editor.getModel()));
    };
    this._register(this._editor.onDidScrollChange(() => {
      r();
    })), this._register(this._editor.onDidChangeModel(() => {
      this._cancelAll(), r();
    })), this._register(this._editor.onDidChangeModelContent((a) => {
      this._cancelAll(), r();
    })), this._register(this._provider.onDidChange(() => {
      this._cancelAll(), r();
    })), this._register(this._configurationService.onDidChangeConfiguration((a) => {
      a.affectsConfiguration(PP) && (this._cancelAll(), r());
    })), this._register(this._themeService.onDidColorThemeChange(() => {
      this._cancelAll(), r();
    })), r();
  }
  _cancelAll() {
    for (const i of this._outstandingRequests) i.cancel();
    this._outstandingRequests = [];
  }
  _removeOutstandingRequest(i) {
    for (let e = 0, t = this._outstandingRequests.length; e < t; e++) if (this._outstandingRequests[e] === i) return void this._outstandingRequests.splice(e, 1);
  }
  _tokenizeViewportNow() {
    if (!this._editor.hasModel()) return;
    const i = this._editor.getModel();
    if (i.tokenization.hasCompleteSemanticTokens()) return;
    if (!kw(i, this._themeService, this._configurationService) || !function(t, n) {
      return t.has(n);
    }(this._provider, i)) return void (i.tokenization.hasSomeSemanticTokens() && i.tokenization.setSemanticTokens(null, !1));
    const e = this._editor.getVisibleRangesPlusViewportAboveBelow();
    this._outstandingRequests = this._outstandingRequests.concat(e.map((t) => this._requestRange(i, t)));
  }
  _requestRange(i, e) {
    const t = i.getVersionId(), n = on((o) => Promise.resolve(wT(this._provider, i, e, o))), s = new Rn(!1);
    return n.then((o) => {
      if (this._debounceInformation.update(i, s.elapsed()), !o || !o.tokens || i.isDisposed() || i.getVersionId() !== t) return;
      const { provider: r, tokens: a } = o, l = this._semanticTokensStylingService.getStyling(r);
      i.tokenization.setPartialSemanticTokens(e, wW(a, l, i.getLanguageId()));
    }).then(() => this._removeOutstandingRequest(n), () => this._removeOutstandingRequest(n)), n;
  }
};
d_.ID = "editor.contrib.viewportSemanticTokens", d_ = bhe([l_(1, _L), l_(2, Yi), l_(3, Ye), l_(4, ar), l_(5, fe)], d_), ft(d_.ID, d_, 1);
class Che {
  constructor(e = !0) {
    this.selectSubwords = e;
  }
  provideSelectionRanges(e, t) {
    const n = [];
    for (const s of t) {
      const o = [];
      n.push(o), this.selectSubwords && this._addInWordRanges(o, e, s), this._addWordRanges(o, e, s), this._addWhitespaceLine(o, e, s), o.push({ range: e.getFullModelRange() });
    }
    return n;
  }
  _addInWordRanges(e, t, n) {
    const s = t.getWordAtPosition(n);
    if (!s) return;
    const { word: o, startColumn: r } = s, a = n.column - r;
    let l = a, d = a, h = 0;
    for (; l >= 0; l--) {
      const c = o.charCodeAt(l);
      if (l !== a && (c === 95 || c === 45) || Eh(c) && Wa(h)) break;
      h = c;
    }
    for (l += 1; d < o.length; d++) {
      const c = o.charCodeAt(d);
      if (Wa(c) && Eh(h) || c === 95 || c === 45) break;
      h = c;
    }
    l < d && e.push({ range: new D(n.lineNumber, r + l, n.lineNumber, r + d) });
  }
  _addWordRanges(e, t, n) {
    const s = t.getWordAtPosition(n);
    s && e.push({ range: new D(n.lineNumber, s.startColumn, n.lineNumber, s.endColumn) });
  }
  _addWhitespaceLine(e, t, n) {
    t.getLineLength(n.lineNumber) > 0 && t.getLineFirstNonWhitespaceColumn(n.lineNumber) === 0 && t.getLineLastNonWhitespaceColumn(n.lineNumber) === 0 && e.push({ range: new D(n.lineNumber, 1, n.lineNumber, t.getLineMaxColumn(n.lineNumber)) });
  }
}
var ST, whe = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, yhe = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class OP {
  constructor(e, t) {
    this.index = e, this.ranges = t;
  }
  mov(e) {
    const t = this.index + (e ? 1 : -1);
    if (t < 0 || t >= this.ranges.length) return this;
    const n = new OP(t, this.ranges);
    return n.ranges[t].equalsRange(this.ranges[this.index]) ? n.mov(e) : n;
  }
}
let Im = ST = class {
  static get(i) {
    return i.getContribution(ST.ID);
  }
  constructor(i, e) {
    this._editor = i, this._languageFeaturesService = e, this._ignoreSelection = !1;
  }
  dispose() {
    var i;
    (i = this._selectionListener) === null || i === void 0 || i.dispose();
  }
  async run(i) {
    if (!this._editor.hasModel()) return;
    const e = this._editor.getSelections(), t = this._editor.getModel();
    if (this._state || await vU(this._languageFeaturesService.selectionRangeProvider, t, e.map((s) => s.getPosition()), this._editor.getOption(113), et.None).then((s) => {
      var o;
      if (zn(s) && s.length === e.length && this._editor.hasModel() && ri(this._editor.getSelections(), e, (r, a) => r.equalsSelection(a))) {
        for (let r = 0; r < s.length; r++) s[r] = s[r].filter((a) => a.containsPosition(e[r].getStartPosition()) && a.containsPosition(e[r].getEndPosition())), s[r].unshift(e[r]);
        this._state = s.map((r) => new OP(0, r)), (o = this._selectionListener) === null || o === void 0 || o.dispose(), this._selectionListener = this._editor.onDidChangeCursorPosition(() => {
          var r;
          this._ignoreSelection || ((r = this._selectionListener) === null || r === void 0 || r.dispose(), this._state = void 0);
        });
      }
    }), !this._state) return;
    this._state = this._state.map((s) => s.mov(i));
    const n = this._state.map((s) => _e.fromPositions(s.ranges[s.index].getStartPosition(), s.ranges[s.index].getEndPosition()));
    this._ignoreSelection = !0;
    try {
      this._editor.setSelections(n);
    } finally {
      this._ignoreSelection = !1;
    }
  }
};
Im.ID = "editor.contrib.smartSelectController", Im = ST = whe([yhe(1, fe)], Im);
class H9 extends he {
  constructor(e, t) {
    super(t), this._forward = e;
  }
  async run(e, t) {
    const n = Im.get(t);
    n && await n.run(this._forward);
  }
}
dt.registerCommandAlias("editor.action.smartSelect.grow", "editor.action.smartSelect.expand");
async function vU(i, e, t, n, s) {
  const o = i.all(e).concat(new Che(n.selectSubwords));
  o.length === 1 && o.unshift(new ho());
  const r = [], a = [];
  for (const l of o) r.push(Promise.resolve(l.provideSelectionRanges(e, t, s)).then((d) => {
    if (zn(d) && d.length === t.length) for (let h = 0; h < t.length; h++) {
      a[h] || (a[h] = []);
      for (const c of d[h]) D.isIRange(c.range) && D.containsPosition(c.range, t[h]) && a[h].push(D.lift(c.range));
    }
  }, Ni));
  return await Promise.all(r), a.map((l) => {
    if (l.length === 0) return [];
    l.sort((u, g) => W.isBefore(u.getStartPosition(), g.getStartPosition()) ? 1 : W.isBefore(g.getStartPosition(), u.getStartPosition()) || W.isBefore(u.getEndPosition(), g.getEndPosition()) ? -1 : W.isBefore(g.getEndPosition(), u.getEndPosition()) ? 1 : 0);
    const d = [];
    let h;
    for (const u of l) (!h || D.containsRange(u, h) && !D.equalsRange(u, h)) && (d.push(u), h = u);
    if (!n.selectLeadingAndTrailingWhitespace) return d;
    const c = [d[0]];
    for (let u = 1; u < d.length; u++) {
      const g = d[u - 1], p = d[u];
      if (p.startLineNumber !== g.startLineNumber || p.endLineNumber !== g.endLineNumber) {
        const f = new D(g.startLineNumber, e.getLineFirstNonWhitespaceColumn(g.startLineNumber), g.endLineNumber, e.getLineLastNonWhitespaceColumn(g.endLineNumber));
        f.containsRange(g) && !f.equalsRange(g) && p.containsRange(f) && !p.equalsRange(f) && c.push(f);
        const _ = new D(g.startLineNumber, 1, g.endLineNumber, e.getLineMaxColumn(g.endLineNumber));
        _.containsRange(g) && !_.equalsRange(f) && p.containsRange(_) && !p.equalsRange(_) && c.push(_);
      }
      c.push(p);
    }
    return c;
  });
}
ft(Im.ID, Im, 4), X(class extends H9 {
  constructor() {
    super(!0, { id: "editor.action.smartSelect.expand", label: m(0, "Expand Selection"), alias: "Expand Selection", precondition: void 0, kbOpts: { kbExpr: E.editorTextFocus, primary: 1553, mac: { primary: 3345, secondary: [1297] }, weight: 100 }, menuOpts: { menuId: x.MenubarSelectionMenu, group: "1_basic", title: m(0, "&&Expand Selection"), order: 2 } });
  }
}), X(class extends H9 {
  constructor() {
    super(!1, { id: "editor.action.smartSelect.shrink", label: m(0, "Shrink Selection"), alias: "Shrink Selection", precondition: void 0, kbOpts: { kbExpr: E.editorTextFocus, primary: 1551, mac: { primary: 3343, secondary: [1295] }, weight: 100 }, menuOpts: { menuId: x.MenubarSelectionMenu, group: "1_basic", title: m(0, "&&Shrink Selection"), order: 3 } });
  }
}), dt.registerCommand("_executeSelectionRangeProvider", async function(i, ...e) {
  const [t, n] = e;
  vt(Ie.isUri(t));
  const s = i.get(fe).selectionRangeProvider, o = await i.get(Ps).createModelReference(t);
  try {
    return vU(s, o.object.textEditorModel, n, { selectLeadingAndTrailingWhitespace: !0, selectSubwords: !0 }, et.None);
  } finally {
    o.dispose();
  }
});
const She = Object.freeze({ View: ct(0, "View"), Help: ct(0, "Help"), Test: ct(0, "Test"), File: ct(0, "File"), Preferences: ct(0, "Preferences"), Developer: ct(0, "Developer") });
class z9 {
  constructor(e, t, n, s = null) {
    this.startLineNumbers = e, this.endLineNumbers = t, this.lastLineRelativePosition = n, this.showEndForLine = s;
  }
  equals(e) {
    return !!e && this.lastLineRelativePosition === e.lastLineRelativePosition && this.showEndForLine === e.showEndForLine && ri(this.startLineNumbers, e.startLineNumbers) && ri(this.endLineNumbers, e.endLineNumbers);
  }
}
const U9 = Hd("stickyScrollViewLayer", { createHTML: (i) => i }), rN = "data-sticky-line-index", K9 = "data-sticky-is-line", j9 = "data-sticky-is-folding-icon";
class Lhe extends V {
  constructor(e) {
    super(), this._editor = e, this._foldingIconStore = new G(), this._rootDomNode = document.createElement("div"), this._lineNumbersDomNode = document.createElement("div"), this._linesDomNodeScrollable = document.createElement("div"), this._linesDomNode = document.createElement("div"), this._lineHeight = this._editor.getOption(67), this._renderedStickyLines = [], this._lineNumbers = [], this._lastLineRelativePosition = 0, this._minContentWidthInPx = 0, this._isOnGlyphMargin = !1, this._lineNumbersDomNode.className = "sticky-widget-line-numbers", this._lineNumbersDomNode.setAttribute("role", "none"), this._linesDomNode.className = "sticky-widget-lines", this._linesDomNode.setAttribute("role", "list"), this._linesDomNodeScrollable.className = "sticky-widget-lines-scrollable", this._linesDomNodeScrollable.appendChild(this._linesDomNode), this._rootDomNode.className = "sticky-widget", this._rootDomNode.classList.toggle("peek", e instanceof Tc), this._rootDomNode.appendChild(this._lineNumbersDomNode), this._rootDomNode.appendChild(this._linesDomNodeScrollable);
    const t = () => {
      this._linesDomNode.style.left = this._editor.getOption(115).scrollWithEditor ? `-${this._editor.getScrollLeft()}px` : "0px";
    };
    this._register(this._editor.onDidChangeConfiguration((n) => {
      n.hasChanged(115) && t(), n.hasChanged(67) && (this._lineHeight = this._editor.getOption(67));
    })), this._register(this._editor.onDidScrollChange((n) => {
      n.scrollLeftChanged && t(), n.scrollWidthChanged && this._updateWidgetWidth();
    })), this._register(this._editor.onDidChangeModel(() => {
      t(), this._updateWidgetWidth();
    })), this._register(this._foldingIconStore), t(), this._register(this._editor.onDidLayoutChange((n) => {
      this._updateWidgetWidth();
    })), this._updateWidgetWidth();
  }
  get lineNumbers() {
    return this._lineNumbers;
  }
  get lineNumberCount() {
    return this._lineNumbers.length;
  }
  getRenderedStickyLine(e) {
    return this._renderedStickyLines.find((t) => t.lineNumber === e);
  }
  getCurrentLines() {
    return this._lineNumbers;
  }
  setState(e, t, n) {
    if (n === void 0 && (!this._previousState && !e || this._previousState && this._previousState.equals(e))) return;
    const s = this._isWidgetHeightZero(e), o = s ? void 0 : e, r = s ? 0 : this._findLineToRebuildWidgetFrom(e, n);
    this._renderRootNode(o, t, r), this._previousState = e;
  }
  _isWidgetHeightZero(e) {
    if (!e) return !0;
    const t = e.startLineNumbers.length * this._lineHeight + e.lastLineRelativePosition;
    if (t > 0) {
      this._lastLineRelativePosition = e.lastLineRelativePosition;
      const n = [...e.startLineNumbers];
      e.showEndForLine !== null && (n[e.showEndForLine] = e.endLineNumbers[e.showEndForLine]), this._lineNumbers = n;
    } else this._lastLineRelativePosition = 0, this._lineNumbers = [];
    return t === 0;
  }
  _findLineToRebuildWidgetFrom(e, t) {
    if (!e || !this._previousState) return 0;
    if (t !== void 0) return t;
    const n = this._previousState, s = e.startLineNumbers.findIndex((o) => !n.startLineNumbers.includes(o));
    return s === -1 ? 0 : s;
  }
  _updateWidgetWidth() {
    const e = this._editor.getLayoutInfo(), t = e.contentLeft;
    this._lineNumbersDomNode.style.width = `${t}px`, this._linesDomNodeScrollable.style.setProperty("--vscode-editorStickyScroll-scrollableWidth", this._editor.getScrollWidth() - e.verticalScrollbarWidth + "px"), this._rootDomNode.style.width = e.width - e.verticalScrollbarWidth + "px";
  }
  _clearStickyLinesFromLine(e) {
    this._foldingIconStore.clear();
    for (let t = e; t < this._renderedStickyLines.length; t++) {
      const n = this._renderedStickyLines[t];
      n.lineNumberDomNode.remove(), n.lineDomNode.remove();
    }
    this._renderedStickyLines = this._renderedStickyLines.slice(0, e), this._rootDomNode.style.display = "none";
  }
  _useFoldingOpacityTransition(e) {
    this._lineNumbersDomNode.style.setProperty("--vscode-editorStickyScroll-foldingOpacityTransition", `opacity ${e ? 0.5 : 0}s`);
  }
  _setFoldingIconsVisibility(e) {
    for (const t of this._renderedStickyLines) {
      const n = t.foldingIcon;
      n && n.setVisible(!!e || n.isCollapsed);
    }
  }
  async _renderRootNode(e, t, n) {
    if (this._clearStickyLinesFromLine(n), !e) return;
    for (const a of this._renderedStickyLines) this._updateTopAndZIndexOfStickyLine(a);
    const s = this._editor.getLayoutInfo(), o = this._lineNumbers.slice(n);
    for (const [a, l] of o.entries()) {
      const d = this._renderChildNode(a + n, l, t, s);
      d && (this._linesDomNode.appendChild(d.lineDomNode), this._lineNumbersDomNode.appendChild(d.lineNumberDomNode), this._renderedStickyLines.push(d));
    }
    t && (this._setFoldingHoverListeners(), this._useFoldingOpacityTransition(!this._isOnGlyphMargin));
    const r = this._lineNumbers.length * this._lineHeight + this._lastLineRelativePosition;
    this._rootDomNode.style.display = "block", this._lineNumbersDomNode.style.height = `${r}px`, this._linesDomNodeScrollable.style.height = `${r}px`, this._rootDomNode.style.height = `${r}px`, this._rootDomNode.style.marginLeft = "0px", this._minContentWidthInPx = Math.max(...this._renderedStickyLines.map((a) => a.scrollWidth)) + s.verticalScrollbarWidth, this._editor.layoutOverlayWidget(this);
  }
  _setFoldingHoverListeners() {
    this._editor.getOption(110) === "mouseover" && (this._foldingIconStore.add(K(this._lineNumbersDomNode, ie.MOUSE_ENTER, () => {
      this._isOnGlyphMargin = !0, this._setFoldingIconsVisibility(!0);
    })), this._foldingIconStore.add(K(this._lineNumbersDomNode, ie.MOUSE_LEAVE, () => {
      this._isOnGlyphMargin = !1, this._useFoldingOpacityTransition(!0), this._setFoldingIconsVisibility(!1);
    })));
  }
  _renderChildNode(e, t, n, s) {
    const o = this._editor._getViewModel();
    if (!o) return;
    const r = o.coordinatesConverter.convertModelPositionToViewPosition(new W(t, 1)).lineNumber, a = o.getViewLineRenderingData(r), l = this._editor.getOption(68);
    let d;
    try {
      d = _s.filter(a.inlineDecorations, r, a.minColumn, a.maxColumn);
    } catch {
      d = [];
    }
    const h = new Lc(!0, !0, a.content, a.continuesWithWrappedLine, a.isBasicASCII, a.containsRTL, 0, a.tokens, d, a.tabSize, a.startVisibleColumn, 1, 1, 1, 500, "none", !0, !0, null), c = new ff(2e3), u = y1(h, c);
    let g;
    g = U9 ? U9.createHTML(c.build()) : c.build();
    const p = document.createElement("span");
    p.setAttribute(rN, String(e)), p.setAttribute(K9, ""), p.setAttribute("role", "listitem"), p.tabIndex = 0, p.className = "sticky-line-content", p.classList.add(`stickyLine${t}`), p.style.lineHeight = `${this._lineHeight}px`, p.innerHTML = g;
    const f = document.createElement("span");
    f.setAttribute(rN, String(e)), f.setAttribute("data-sticky-is-line-number", ""), f.className = "sticky-line-number", f.style.lineHeight = `${this._lineHeight}px`;
    const _ = s.contentLeft;
    f.style.width = `${_}px`;
    const v = document.createElement("span");
    l.renderType === 1 || l.renderType === 3 && t % 10 == 0 ? v.innerText = t.toString() : l.renderType === 2 && (v.innerText = Math.abs(t - this._editor.getPosition().lineNumber).toString()), v.className = "sticky-line-number-inner", v.style.lineHeight = `${this._lineHeight}px`, v.style.width = `${s.lineNumbersWidth}px`, v.style.paddingLeft = `${s.lineNumbersLeft}px`, f.appendChild(v);
    const b = this._renderFoldingIconForLine(n, t);
    b && f.appendChild(b.domNode), this._editor.applyFontInfo(p), this._editor.applyFontInfo(v), f.style.lineHeight = `${this._lineHeight}px`, p.style.lineHeight = `${this._lineHeight}px`, f.style.height = `${this._lineHeight}px`, p.style.height = `${this._lineHeight}px`;
    const C = new khe(e, t, p, f, b, u.characterMapping, p.scrollWidth);
    return this._updateTopAndZIndexOfStickyLine(C);
  }
  _updateTopAndZIndexOfStickyLine(e) {
    var t;
    const n = e.index, s = e.lineDomNode, o = e.lineNumberDomNode, r = n === this._lineNumbers.length - 1;
    s.style.zIndex = r ? "0" : "1", o.style.zIndex = r ? "0" : "1";
    const a = `${n * this._lineHeight + this._lastLineRelativePosition + (!((t = e.foldingIcon) === null || t === void 0) && t.isCollapsed ? 1 : 0)}px`, l = n * this._lineHeight + "px";
    return s.style.top = r ? a : l, o.style.top = r ? a : l, e;
  }
  _renderFoldingIconForLine(e, t) {
    const n = this._editor.getOption(110);
    if (!e || n === "never") return;
    const s = e.regions, o = s.findRange(t), r = s.getStartLineNumber(o);
    if (t !== r) return;
    const a = s.isCollapsed(o), l = new Dhe(a, r, s.getEndLineNumber(o), this._lineHeight);
    return l.setVisible(!!this._isOnGlyphMargin || a || n === "always"), l.domNode.setAttribute(j9, ""), l;
  }
  getId() {
    return "editor.contrib.stickyScrollWidget";
  }
  getDomNode() {
    return this._rootDomNode;
  }
  getPosition() {
    return { preference: null };
  }
  getMinContentWidthInPx() {
    return this._minContentWidthInPx;
  }
  focusLineWithIndex(e) {
    0 <= e && e < this._renderedStickyLines.length && this._renderedStickyLines[e].lineDomNode.focus();
  }
  getEditorPositionFromNode(e) {
    if (!e || e.children.length > 0) return null;
    const t = this._getRenderedStickyLineFromChildDomNode(e);
    if (!t) return null;
    const n = HR(t.characterMapping, e, 0);
    return new W(t.lineNumber, n);
  }
  getLineNumberFromChildDomNode(e) {
    var t, n;
    return (n = (t = this._getRenderedStickyLineFromChildDomNode(e)) === null || t === void 0 ? void 0 : t.lineNumber) !== null && n !== void 0 ? n : null;
  }
  _getRenderedStickyLineFromChildDomNode(e) {
    const t = this.getLineIndexFromChildDomNode(e);
    return t === null || t < 0 || t >= this._renderedStickyLines.length ? null : this._renderedStickyLines[t];
  }
  getLineIndexFromChildDomNode(e) {
    const t = this._getAttributeValue(e, rN);
    return t ? parseInt(t, 10) : null;
  }
  isInStickyLine(e) {
    return this._getAttributeValue(e, K9) !== void 0;
  }
  isInFoldingIconDomNode(e) {
    return this._getAttributeValue(e, j9) !== void 0;
  }
  _getAttributeValue(e, t) {
    for (; e && e !== this._rootDomNode; ) {
      const n = e.getAttribute(t);
      if (n !== null) return n;
      e = e.parentElement;
    }
  }
}
class khe {
  constructor(e, t, n, s, o, r, a) {
    this.index = e, this.lineNumber = t, this.lineDomNode = n, this.lineNumberDomNode = s, this.foldingIcon = o, this.characterMapping = r, this.scrollWidth = a;
  }
}
class Dhe {
  constructor(e, t, n, s) {
    this.isCollapsed = e, this.foldingStartLine = t, this.foldingEndLine = n, this.dimension = s, this.domNode = document.createElement("div"), this.domNode.style.width = `${s}px`, this.domNode.style.height = `${s}px`, this.domNode.className = Ee.asClassName(e ? SS : yS);
  }
  setVisible(e) {
    this.domNode.style.cursor = e ? "pointer" : "default", this.domNode.style.opacity = e ? "1" : "0";
  }
}
class B0 {
  constructor(e, t) {
    this.startLineNumber = e, this.endLineNumber = t;
  }
}
class MS {
  constructor(e, t, n) {
    this.range = e, this.children = t, this.parent = n;
  }
}
class bU {
  constructor(e, t, n, s) {
    this.uri = e, this.version = t, this.element = n, this.outlineProviderId = s;
  }
}
var W0, Xh, yk = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, h1 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
(function(i) {
  i.OUTLINE_MODEL = "outlineModel", i.FOLDING_PROVIDER_MODEL = "foldingProviderModel", i.INDENTATION_MODEL = "indentationModel";
})(W0 || (W0 = {})), function(i) {
  i[i.VALID = 0] = "VALID", i[i.INVALID = 1] = "INVALID", i[i.CANCELED = 2] = "CANCELED";
}(Xh || (Xh = {}));
let LT = class extends V {
  constructor(i, e, t, n) {
    switch (super(), this._editor = i, this._languageConfigurationService = t, this._languageFeaturesService = n, this._modelProviders = [], this._modelPromise = null, this._updateScheduler = this._register(new Sr(300)), this._updateOperation = this._register(new G()), this._editor.getOption(115).defaultModel) {
      case W0.OUTLINE_MODEL:
        this._modelProviders.push(new kT(this._editor, n));
      case W0.FOLDING_PROVIDER_MODEL:
        this._modelProviders.push(new xT(this._editor, e, n));
      case W0.INDENTATION_MODEL:
        this._modelProviders.push(new DT(this._editor, t));
    }
  }
  dispose() {
    this._modelProviders.forEach((i) => i.dispose()), this._updateOperation.clear(), this._cancelModelPromise(), super.dispose();
  }
  _cancelModelPromise() {
    this._modelPromise && (this._modelPromise.cancel(), this._modelPromise = null);
  }
  async update(i) {
    return this._updateOperation.clear(), this._updateOperation.add({ dispose: () => {
      this._cancelModelPromise(), this._updateScheduler.cancel();
    } }), this._cancelModelPromise(), await this._updateScheduler.trigger(async () => {
      for (const e of this._modelProviders) {
        const { statusPromise: t, modelPromise: n } = e.computeStickyModel(i);
        this._modelPromise = n;
        const s = await t;
        if (this._modelPromise !== n) return null;
        switch (s) {
          case Xh.CANCELED:
            return this._updateOperation.clear(), null;
          case Xh.VALID:
            return e.stickyModel;
        }
      }
      return null;
    }).catch((e) => (We(e), null));
  }
};
LT = yk([h1(2, Se), h1(3, fe)], LT);
class CU extends V {
  constructor(e) {
    super(), this._editor = e, this._stickyModel = null;
  }
  get stickyModel() {
    return this._stickyModel;
  }
  _invalid() {
    return this._stickyModel = null, Xh.INVALID;
  }
  computeStickyModel(e) {
    if (e.isCancellationRequested || !this.isProviderValid()) return { statusPromise: this._invalid(), modelPromise: null };
    const t = on((n) => this.createModelFromProvider(n));
    return { statusPromise: t.then((n) => this.isModelValid(n) ? e.isCancellationRequested ? Xh.CANCELED : (this._stickyModel = this.createStickyModel(e, n), Xh.VALID) : this._invalid()).then(void 0, (n) => (We(n), Xh.CANCELED)), modelPromise: t };
  }
  isModelValid(e) {
    return !0;
  }
  isProviderValid() {
    return !0;
  }
}
let kT = class extends CU {
  constructor(i, e) {
    super(i), this._languageFeaturesService = e;
  }
  createModelFromProvider(i) {
    return Zl.create(this._languageFeaturesService.documentSymbolProvider, this._editor.getModel(), i);
  }
  createStickyModel(i, e) {
    var t;
    const { stickyOutlineElement: n, providerID: s } = this._stickyModelFromOutlineModel(e, (t = this._stickyModel) === null || t === void 0 ? void 0 : t.outlineProviderId), o = this._editor.getModel();
    return new bU(o.uri, o.getVersionId(), n, s);
  }
  isModelValid(i) {
    return i && i.children.size > 0;
  }
  _stickyModelFromOutlineModel(i, e) {
    let t;
    if (at.first(i.children.values()) instanceof Gz) {
      const o = at.find(i.children.values(), (r) => r.id === e);
      if (o) t = o.children;
      else {
        let r, a = "", l = -1;
        for (const [d, h] of i.children.entries()) {
          const c = this._findSumOfRangesOfGroup(h);
          c > l && (r = h, l = c, a = h.id);
        }
        e = a, t = r.children;
      }
    } else t = i.children;
    const n = [], s = Array.from(t.values()).sort((o, r) => {
      const a = new B0(o.symbol.range.startLineNumber, o.symbol.range.endLineNumber), l = new B0(r.symbol.range.startLineNumber, r.symbol.range.endLineNumber);
      return this._comparator(a, l);
    });
    for (const o of s) n.push(this._stickyModelFromOutlineElement(o, o.symbol.selectionRange.startLineNumber));
    return { stickyOutlineElement: new MS(void 0, n, void 0), providerID: e };
  }
  _stickyModelFromOutlineElement(i, e) {
    const t = [];
    for (const s of i.children.values()) if (s.symbol.selectionRange.startLineNumber !== s.symbol.range.endLineNumber) if (s.symbol.selectionRange.startLineNumber !== e) t.push(this._stickyModelFromOutlineElement(s, s.symbol.selectionRange.startLineNumber));
    else for (const o of s.children.values()) t.push(this._stickyModelFromOutlineElement(o, s.symbol.selectionRange.startLineNumber));
    t.sort((s, o) => this._comparator(s.range, o.range));
    const n = new B0(i.symbol.selectionRange.startLineNumber, i.symbol.range.endLineNumber);
    return new MS(n, t, void 0);
  }
  _comparator(i, e) {
    return i.startLineNumber !== e.startLineNumber ? i.startLineNumber - e.startLineNumber : e.endLineNumber - i.endLineNumber;
  }
  _findSumOfRangesOfGroup(i) {
    let e = 0;
    for (const t of i.children.values()) e += this._findSumOfRangesOfGroup(t);
    return i instanceof YM ? e + i.symbol.range.endLineNumber - i.symbol.selectionRange.startLineNumber : e;
  }
};
kT = yk([h1(1, fe)], kT);
class wU extends CU {
  constructor(e) {
    super(e), this._foldingLimitReporter = new qz(e);
  }
  createStickyModel(e, t) {
    const n = this._fromFoldingRegions(t), s = this._editor.getModel();
    return new bU(s.uri, s.getVersionId(), n, void 0);
  }
  isModelValid(e) {
    return e !== null;
  }
  _fromFoldingRegions(e) {
    const t = e.length, n = [], s = new MS(void 0, [], void 0);
    for (let o = 0; o < t; o++) {
      const r = e.getParentIndex(o);
      let a;
      a = r !== -1 ? n[r] : s;
      const l = new MS(new B0(e.getStartLineNumber(o), e.getEndLineNumber(o) + 1), [], a);
      a.children.push(l), n.push(l);
    }
    return s;
  }
}
let DT = class extends wU {
  constructor(i, e) {
    super(i), this._languageConfigurationService = e, this.provider = this._register(new xP(i.getModel(), this._languageConfigurationService, this._foldingLimitReporter));
  }
  async createModelFromProvider(i) {
    return this.provider.compute(i);
  }
};
DT = yk([h1(1, zt)], DT);
let xT = class extends wU {
  constructor(i, e, t) {
    super(i), this._languageFeaturesService = t;
    const n = Id.getFoldingRangeProviders(this._languageFeaturesService, i.getModel());
    n.length > 0 && (this.provider = this._register(new NP(i.getModel(), n, e, this._foldingLimitReporter, void 0)));
  }
  isProviderValid() {
    return this.provider !== void 0;
  }
  async createModelFromProvider(i) {
    var e, t;
    return (t = (e = this.provider) === null || e === void 0 ? void 0 : e.compute(i)) !== null && t !== void 0 ? t : null;
  }
};
xT = yk([h1(2, fe)], xT);
var xhe = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, q9 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class Nhe {
  constructor(e, t, n) {
    this.startLineNumber = e, this.endLineNumber = t, this.nestingDepth = n;
  }
}
let NT = class extends V {
  constructor(i, e, t) {
    super(), this._languageFeaturesService = e, this._languageConfigurationService = t, this._onDidChangeStickyScroll = this._register(new F()), this.onDidChangeStickyScroll = this._onDidChangeStickyScroll.event, this._model = null, this._cts = null, this._stickyModelProvider = null, this._editor = i, this._sessionStore = this._register(new G()), this._updateSoon = this._register(new It(() => this.update(), 50)), this._register(this._editor.onDidChangeConfiguration((n) => {
      n.hasChanged(115) && this.readConfiguration();
    })), this.readConfiguration();
  }
  readConfiguration() {
    this._sessionStore.clear(), this._editor.getOption(115).enabled && (this._sessionStore.add(this._editor.onDidChangeModel(() => {
      this._model = null, this.updateStickyModelProvider(), this._onDidChangeStickyScroll.fire(), this.update();
    })), this._sessionStore.add(this._editor.onDidChangeHiddenAreas(() => this.update())), this._sessionStore.add(this._editor.onDidChangeModelContent(() => this._updateSoon.schedule())), this._sessionStore.add(this._languageFeaturesService.documentSymbolProvider.onDidChange(() => this.update())), this._sessionStore.add(ye(() => {
      var i;
      (i = this._stickyModelProvider) === null || i === void 0 || i.dispose(), this._stickyModelProvider = null;
    })), this.updateStickyModelProvider(), this.update());
  }
  getVersionId() {
    var i;
    return (i = this._model) === null || i === void 0 ? void 0 : i.version;
  }
  updateStickyModelProvider() {
    var i;
    (i = this._stickyModelProvider) === null || i === void 0 || i.dispose(), this._stickyModelProvider = null;
    const e = this._editor;
    e.hasModel() && (this._stickyModelProvider = new LT(e, () => this._updateSoon.schedule(), this._languageConfigurationService, this._languageFeaturesService));
  }
  async update() {
    var i;
    (i = this._cts) === null || i === void 0 || i.dispose(!0), this._cts = new Ci(), await this.updateStickyModel(this._cts.token), this._onDidChangeStickyScroll.fire();
  }
  async updateStickyModel(i) {
    if (!this._editor.hasModel() || !this._stickyModelProvider || this._editor.getModel().isTooLargeForTokenization()) return void (this._model = null);
    const e = await this._stickyModelProvider.update(i);
    i.isCancellationRequested || (this._model = e);
  }
  updateIndex(i) {
    return i === -1 ? i = 0 : i < 0 && (i = -i - 2), i;
  }
  getCandidateStickyLinesIntersectingFromStickyModel(i, e, t, n, s) {
    if (e.children.length === 0) return;
    let o = s;
    const r = [];
    for (let d = 0; d < e.children.length; d++) {
      const h = e.children[d];
      h.range && r.push(h.range.startLineNumber);
    }
    const a = this.updateIndex(U0(r, i.startLineNumber, (d, h) => d - h)), l = this.updateIndex(U0(r, i.startLineNumber + n, (d, h) => d - h));
    for (let d = a; d <= l; d++) {
      const h = e.children[d];
      if (!h) return;
      if (h.range) {
        const c = h.range.startLineNumber, u = h.range.endLineNumber;
        i.startLineNumber <= u + 1 && c - 1 <= i.endLineNumber && c !== o && (o = c, t.push(new Nhe(c, u - 1, n + 1)), this.getCandidateStickyLinesIntersectingFromStickyModel(i, h, t, n + 1, c));
      } else this.getCandidateStickyLinesIntersectingFromStickyModel(i, h, t, n, s);
    }
  }
  getCandidateStickyLinesIntersecting(i) {
    var e, t;
    if (!(!((e = this._model) === null || e === void 0) && e.element)) return [];
    let n = [];
    this.getCandidateStickyLinesIntersectingFromStickyModel(i, this._model.element, n, 0, -1);
    const s = (t = this._editor._getViewModel()) === null || t === void 0 ? void 0 : t.getHiddenAreas();
    if (s) for (const o of s) n = n.filter((r) => !(r.startLineNumber >= o.startLineNumber && r.endLineNumber <= o.endLineNumber + 1));
    return n;
  }
};
NT = xhe([q9(1, fe), q9(2, zt)], NT);
var ET, Ehe = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, up = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let Ba = ET = class extends V {
  constructor(i, e, t, n, s, o, r) {
    super(), this._editor = i, this._contextMenuService = e, this._languageFeaturesService = t, this._instaService = n, this._contextKeyService = r, this._sessionStore = new G(), this._foldingModel = null, this._maxStickyLines = Number.MAX_SAFE_INTEGER, this._candidateDefinitionsLength = -1, this._focusedStickyElementIndex = -1, this._enabled = !1, this._focused = !1, this._positionRevealed = !1, this._onMouseDown = !1, this._endLineNumbers = [], this._showEndForLine = null, this._stickyScrollWidget = new Lhe(this._editor), this._stickyLineCandidateProvider = new NT(this._editor, t, s), this._register(this._stickyScrollWidget), this._register(this._stickyLineCandidateProvider), this._widgetState = new z9([], [], 0), this._onDidResize(), this._readConfiguration();
    const a = this._stickyScrollWidget.getDomNode();
    this._register(this._editor.onDidChangeConfiguration((d) => {
      (d.hasChanged(115) || d.hasChanged(73) || d.hasChanged(67) || d.hasChanged(110)) && this._readConfiguration();
    })), this._register(K(a, ie.CONTEXT_MENU, async (d) => {
      this._onContextMenu(ke(a), d);
    })), this._stickyScrollFocusedContextKey = E.stickyScrollFocused.bindTo(this._contextKeyService), this._stickyScrollVisibleContextKey = E.stickyScrollVisible.bindTo(this._contextKeyService);
    const l = this._register(ma(a));
    this._register(l.onDidBlur((d) => {
      this._positionRevealed === !1 && a.clientHeight === 0 ? (this._focusedStickyElementIndex = -1, this.focus()) : this._disposeFocusStickyScrollStore();
    })), this._register(l.onDidFocus((d) => {
      this.focus();
    })), this._registerMouseListeners(), this._register(K(a, ie.MOUSE_DOWN, (d) => {
      this._onMouseDown = !0;
    }));
  }
  static get(i) {
    return i.getContribution(ET.ID);
  }
  _disposeFocusStickyScrollStore() {
    var i;
    this._stickyScrollFocusedContextKey.set(!1), (i = this._focusDisposableStore) === null || i === void 0 || i.dispose(), this._focused = !1, this._positionRevealed = !1, this._onMouseDown = !1;
  }
  focus() {
    if (this._onMouseDown) return this._onMouseDown = !1, void this._editor.focus();
    this._stickyScrollFocusedContextKey.get() !== !0 && (this._focused = !0, this._focusDisposableStore = new G(), this._stickyScrollFocusedContextKey.set(!0), this._focusedStickyElementIndex = this._stickyScrollWidget.lineNumbers.length - 1, this._stickyScrollWidget.focusLineWithIndex(this._focusedStickyElementIndex));
  }
  focusNext() {
    this._focusedStickyElementIndex < this._stickyScrollWidget.lineNumberCount - 1 && this._focusNav(!0);
  }
  focusPrevious() {
    this._focusedStickyElementIndex > 0 && this._focusNav(!1);
  }
  selectEditor() {
    this._editor.focus();
  }
  _focusNav(i) {
    this._focusedStickyElementIndex = i ? this._focusedStickyElementIndex + 1 : this._focusedStickyElementIndex - 1, this._stickyScrollWidget.focusLineWithIndex(this._focusedStickyElementIndex);
  }
  goToFocused() {
    const i = this._stickyScrollWidget.lineNumbers;
    this._disposeFocusStickyScrollStore(), this._revealPosition({ lineNumber: i[this._focusedStickyElementIndex], column: 1 });
  }
  _revealPosition(i) {
    this._reveaInEditor(i, () => this._editor.revealPosition(i));
  }
  _revealLineInCenterIfOutsideViewport(i) {
    this._reveaInEditor(i, () => this._editor.revealLineInCenterIfOutsideViewport(i.lineNumber, 0));
  }
  _reveaInEditor(i, e) {
    this._focused && this._disposeFocusStickyScrollStore(), this._positionRevealed = !0, e(), this._editor.setSelection(D.fromPositions(i)), this._editor.focus();
  }
  _registerMouseListeners() {
    const i = this._register(new G()), e = this._register(new JL(this._editor, { extractLineNumberFromMouseEvent: (s) => {
      const o = this._stickyScrollWidget.getEditorPositionFromNode(s.target.element);
      return o ? o.lineNumber : 0;
    } })), t = (s) => {
      if (!this._editor.hasModel() || s.target.type !== 12 || s.target.detail !== this._stickyScrollWidget.getId()) return null;
      const o = s.target.element;
      if (!o || o.innerText !== o.innerHTML) return null;
      const r = this._stickyScrollWidget.getEditorPositionFromNode(o);
      return r ? { range: new D(r.lineNumber, r.column, r.lineNumber, r.column + o.innerText.length), textElement: o } : null;
    }, n = this._stickyScrollWidget.getDomNode();
    this._register(bi(n, ie.CLICK, (s) => {
      if (s.ctrlKey || s.altKey || s.metaKey || !s.leftButton) return;
      if (s.shiftKey) {
        const r = this._stickyScrollWidget.getLineIndexFromChildDomNode(s.target);
        if (r === null) return;
        const a = new W(this._endLineNumbers[r], 1);
        return void this._revealLineInCenterIfOutsideViewport(a);
      }
      if (this._stickyScrollWidget.isInFoldingIconDomNode(s.target)) {
        const r = this._stickyScrollWidget.getLineNumberFromChildDomNode(s.target);
        return void this._toggleFoldingRegionForLine(r);
      }
      if (!this._stickyScrollWidget.isInStickyLine(s.target)) return;
      let o = this._stickyScrollWidget.getEditorPositionFromNode(s.target);
      if (!o) {
        const r = this._stickyScrollWidget.getLineNumberFromChildDomNode(s.target);
        if (r === null) return;
        o = new W(r, 1);
      }
      this._revealPosition(o);
    })), this._register(bi(n, ie.MOUSE_MOVE, (s) => {
      if (s.shiftKey) {
        const o = this._stickyScrollWidget.getLineIndexFromChildDomNode(s.target);
        return o === null || this._showEndForLine !== null && this._showEndForLine === o ? void 0 : (this._showEndForLine = o, void this._renderStickyScroll());
      }
      this._showEndForLine !== null && (this._showEndForLine = null, this._renderStickyScroll());
    })), this._register(K(n, ie.MOUSE_LEAVE, (s) => {
      this._showEndForLine !== null && (this._showEndForLine = null, this._renderStickyScroll());
    })), this._register(e.onMouseMoveOrRelevantKeyDown(([s, o]) => {
      const r = t(s);
      if (!r || !s.hasTriggerModifier || !this._editor.hasModel()) return void i.clear();
      const { range: a, textElement: l } = r;
      if (a.equalsRange(this._stickyRangeProjectedOnEditor)) {
        if (l.style.textDecoration === "underline") return;
      } else this._stickyRangeProjectedOnEditor = a, i.clear();
      const d = new Ci();
      let h;
      i.add(ye(() => d.dispose(!0))), sk(this._languageFeaturesService.definitionProvider, this._editor.getModel(), new W(a.startLineNumber, a.startColumn + 1), d.token).then((c) => {
        if (!d.token.isCancellationRequested) if (c.length !== 0) {
          this._candidateDefinitionsLength = c.length;
          const u = l;
          h !== u ? (i.clear(), h = u, h.style.textDecoration = "underline", i.add(ye(() => {
            h.style.textDecoration = "none";
          }))) : h || (h = u, h.style.textDecoration = "underline", i.add(ye(() => {
            h.style.textDecoration = "none";
          })));
        } else i.clear();
      });
    })), this._register(e.onCancel(() => {
      i.clear();
    })), this._register(e.onExecute(async (s) => {
      if (s.target.type !== 12 || s.target.detail !== this._stickyScrollWidget.getId()) return;
      const o = this._stickyScrollWidget.getEditorPositionFromNode(s.target.element);
      o && this._editor.hasModel() && this._stickyRangeProjectedOnEditor && (this._candidateDefinitionsLength > 1 && (this._focused && this._disposeFocusStickyScrollStore(), this._revealPosition({ lineNumber: o.lineNumber, column: 1 })), this._instaService.invokeFunction(oU, s, this._editor, { uri: this._editor.getModel().uri, range: this._stickyRangeProjectedOnEditor }));
    }));
  }
  _onContextMenu(i, e) {
    const t = new _r(i, e);
    this._contextMenuService.showContextMenu({ menuId: x.StickyScrollContext, getAnchor: () => t });
  }
  _toggleFoldingRegionForLine(i) {
    if (!this._foldingModel || i === null) return;
    const e = this._stickyScrollWidget.getRenderedStickyLine(i), t = e == null ? void 0 : e.foldingIcon;
    if (!t) return;
    jz(this._foldingModel, Number.MAX_VALUE, [i]), t.isCollapsed = !t.isCollapsed;
    const n = (t.isCollapsed ? this._editor.getTopForLineNumber(t.foldingEndLine) : this._editor.getTopForLineNumber(t.foldingStartLine)) - this._editor.getOption(67) * e.index + 1;
    this._editor.setScrollTop(n), this._renderStickyScroll(i);
  }
  _readConfiguration() {
    const i = this._editor.getOption(115);
    if (i.enabled === !1) return this._editor.removeOverlayWidget(this._stickyScrollWidget), this._sessionStore.clear(), void (this._enabled = !1);
    i.enabled && !this._enabled && (this._editor.addOverlayWidget(this._stickyScrollWidget), this._sessionStore.add(this._editor.onDidScrollChange((e) => {
      e.scrollTopChanged && (this._showEndForLine = null, this._renderStickyScroll());
    })), this._sessionStore.add(this._editor.onDidLayoutChange(() => this._onDidResize())), this._sessionStore.add(this._editor.onDidChangeModelTokens((e) => this._onTokensChange(e))), this._sessionStore.add(this._stickyLineCandidateProvider.onDidChangeStickyScroll(() => {
      this._showEndForLine = null, this._renderStickyScroll();
    })), this._enabled = !0), this._editor.getOption(68).renderType === 2 && this._sessionStore.add(this._editor.onDidChangeCursorPosition(() => {
      this._showEndForLine = null, this._renderStickyScroll(0);
    }));
  }
  _needsUpdate(i) {
    const e = this._stickyScrollWidget.getCurrentLines();
    for (const t of e) for (const n of i.ranges) if (t >= n.fromLineNumber && t <= n.toLineNumber) return !0;
    return !1;
  }
  _onTokensChange(i) {
    this._needsUpdate(i) && this._renderStickyScroll(0);
  }
  _onDidResize() {
    const i = this._editor.getLayoutInfo().height / this._editor.getOption(67);
    this._maxStickyLines = Math.round(0.25 * i);
  }
  async _renderStickyScroll(i) {
    var e, t;
    const n = this._editor.getModel();
    if (!n || n.isTooLargeForTokenization()) return this._foldingModel = null, void this._stickyScrollWidget.setState(void 0, null);
    const s = this._stickyLineCandidateProvider.getVersionId();
    if (s === void 0 || s === n.getVersionId()) if (this._foldingModel = (t = await ((e = Id.get(this._editor)) === null || e === void 0 ? void 0 : e.getFoldingModel())) !== null && t !== void 0 ? t : null, this._widgetState = this.findScrollWidgetState(), this._stickyScrollVisibleContextKey.set(this._widgetState.startLineNumbers.length !== 0), this._focused) if (this._focusedStickyElementIndex === -1) this._stickyScrollWidget.setState(this._widgetState, this._foldingModel, i), this._focusedStickyElementIndex = this._stickyScrollWidget.lineNumberCount - 1, this._focusedStickyElementIndex !== -1 && this._stickyScrollWidget.focusLineWithIndex(this._focusedStickyElementIndex);
    else {
      const o = this._stickyScrollWidget.lineNumbers[this._focusedStickyElementIndex];
      this._stickyScrollWidget.setState(this._widgetState, this._foldingModel, i), this._stickyScrollWidget.lineNumberCount === 0 ? this._focusedStickyElementIndex = -1 : (this._stickyScrollWidget.lineNumbers.includes(o) || (this._focusedStickyElementIndex = this._stickyScrollWidget.lineNumberCount - 1), this._stickyScrollWidget.focusLineWithIndex(this._focusedStickyElementIndex));
    }
    else this._stickyScrollWidget.setState(this._widgetState, this._foldingModel, i);
  }
  findScrollWidgetState() {
    const i = this._editor.getOption(67), e = Math.min(this._maxStickyLines, this._editor.getOption(115).maxLineCount), t = this._editor.getScrollTop();
    let n = 0;
    const s = [], o = [], r = this._editor.getVisibleRanges();
    if (r.length !== 0) {
      const a = new B0(r[0].startLineNumber, r[r.length - 1].endLineNumber), l = this._stickyLineCandidateProvider.getCandidateStickyLinesIntersecting(a);
      for (const d of l) {
        const h = d.startLineNumber, c = d.endLineNumber, u = d.nestingDepth;
        if (c - h > 0) {
          const g = (u - 1) * i, p = u * i, f = this._editor.getBottomForLineNumber(h) - t, _ = this._editor.getTopForLineNumber(c) - t, v = this._editor.getBottomForLineNumber(c) - t;
          if (g > _ && g <= v) {
            s.push(h), o.push(c + 1), n = v - p;
            break;
          }
          if (p > f && p <= v && (s.push(h), o.push(c + 1)), s.length === e) break;
        }
      }
    }
    return this._endLineNumbers = o, new z9(s, o, n, this._showEndForLine);
  }
  dispose() {
    super.dispose(), this._sessionStore.dispose();
  }
};
Ba.ID = "store.contrib.stickyScrollController", Ba = ET = Ehe([up(1, io), up(2, fe), up(3, Se), up(4, zt), up(5, ar), up(6, Te)], Ba);
const LC = 100;
ft(Ba.ID, Ba, 1), Ft(class extends cs {
  constructor() {
    super({ id: "editor.action.toggleStickyScroll", title: { ...ct(0, "Toggle Editor Sticky Scroll"), mnemonicTitle: m(0, "&&Toggle Editor Sticky Scroll") }, category: She.View, toggled: { condition: q.equals("config.editor.stickyScroll.enabled", !0), title: m(0, "Sticky Scroll"), mnemonicTitle: m(0, "&&Sticky Scroll") }, menu: [{ id: x.CommandPalette }, { id: x.MenubarAppearanceMenu, group: "4_editor", order: 3 }, { id: x.StickyScrollContext }] });
  }
  async run(i) {
    const e = i.get(Ye), t = !e.getValue("editor.stickyScroll.enabled");
    return e.updateValue("editor.stickyScroll.enabled", t);
  }
}), Ft(class extends Qr {
  constructor() {
    super({ id: "editor.action.focusStickyScroll", title: { ...ct(0, "Focus Sticky Scroll"), mnemonicTitle: m(0, "&&Focus Sticky Scroll") }, precondition: q.and(q.has("config.editor.stickyScroll.enabled"), E.stickyScrollVisible), menu: [{ id: x.CommandPalette }] });
  }
  runEditorCommand(i, e) {
    var t;
    (t = Ba.get(e)) === null || t === void 0 || t.focus();
  }
}), Ft(class extends Qr {
  constructor() {
    super({ id: "editor.action.selectPreviousStickyScrollLine", title: ct(0, "Select previous sticky scroll line"), precondition: E.stickyScrollFocused.isEqualTo(!0), keybinding: { weight: LC, primary: 16 } });
  }
  runEditorCommand(i, e) {
    var t;
    (t = Ba.get(e)) === null || t === void 0 || t.focusPrevious();
  }
}), Ft(class extends Qr {
  constructor() {
    super({ id: "editor.action.selectNextStickyScrollLine", title: ct(0, "Select next sticky scroll line"), precondition: E.stickyScrollFocused.isEqualTo(!0), keybinding: { weight: LC, primary: 18 } });
  }
  runEditorCommand(i, e) {
    var t;
    (t = Ba.get(e)) === null || t === void 0 || t.focusNext();
  }
}), Ft(class extends Qr {
  constructor() {
    super({ id: "editor.action.goToFocusedStickyScrollLine", title: ct(0, "Go to focused sticky scroll line"), precondition: E.stickyScrollFocused.isEqualTo(!0), keybinding: { weight: LC, primary: 3 } });
  }
  runEditorCommand(i, e) {
    var t;
    (t = Ba.get(e)) === null || t === void 0 || t.goToFocused();
  }
}), Ft(class extends Qr {
  constructor() {
    super({ id: "editor.action.selectEditor", title: ct(0, "Select Editor"), precondition: E.stickyScrollFocused.isEqualTo(!0), keybinding: { weight: LC, primary: 9 } });
  }
  runEditorCommand(i, e) {
    var t;
    (t = Ba.get(e)) === null || t === void 0 || t.selectEditor();
  }
});
var yU = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, j_ = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
class Ihe {
  constructor(e, t, n, s, o, r) {
    this.range = e, this.insertText = t, this.filterText = n, this.additionalTextEdits = s, this.command = o, this.completion = r;
  }
}
let IT = class extends oK {
  constructor(i, e, t, n, s, o) {
    super(s.disposable), this.model = i, this.line = e, this.word = t, this.completionModel = n, this._suggestMemoryService = o;
  }
  canBeReused(i, e, t) {
    return this.model === i && this.line === e && this.word.word.length > 0 && this.word.startColumn === t.startColumn && this.word.endColumn < t.endColumn && this.completionModel.getIncompleteProvider().size === 0;
  }
  get items() {
    var i;
    const e = [], { items: t } = this.completionModel, n = this._suggestMemoryService.select(this.model, { lineNumber: this.line, column: this.word.endColumn + this.completionModel.lineContext.characterCountDelta }, t), s = at.slice(t, n), o = at.slice(t, 0, n);
    let r = 5;
    for (const a of at.concat(s, o)) {
      if (a.score === da.Default) continue;
      const l = new D(a.editStart.lineNumber, a.editStart.column, a.editInsertEnd.lineNumber, a.editInsertEnd.column + this.completionModel.lineContext.characterCountDelta), d = a.completion.insertTextRules && 4 & a.completion.insertTextRules ? { snippet: a.completion.insertText } : a.completion.insertText;
      e.push(new Ihe(l, d, (i = a.filterTextLow) !== null && i !== void 0 ? i : a.labelLow, a.completion.additionalTextEdits, a.completion.command, a)), r-- >= 0 && a.resolve(et.None);
    }
    return e;
  }
};
IT = yU([j_(5, ak)], IT);
let aN = class extends V {
  constructor(i, e, t, n) {
    super(), this._languageFeatureService = i, this._clipboardService = e, this._suggestMemoryService = t, this._editorService = n, this._store.add(i.inlineCompletionsProvider.register("*", this));
  }
  async provideInlineCompletions(i, e, t, n) {
    var s;
    if (t.selectedSuggestionInfo) return;
    let o;
    for (const g of this._editorService.listCodeEditors()) if (g.getModel() === i) {
      o = g;
      break;
    }
    if (!o) return;
    const r = o.getOption(89);
    if (Gp.isAllOff(r)) return;
    i.tokenization.tokenizeIfCheap(e.lineNumber);
    const a = i.tokenization.getLineTokens(e.lineNumber), l = a.getStandardTokenType(a.findTokenIndexAtOffset(Math.max(e.column - 1 - 1, 0)));
    if (Gp.valueFor(r, l) !== "inline") return;
    let d, h, c = i.getWordAtPosition(e);
    if (c != null && c.word || (d = this._getTriggerCharacterInfo(i, e)), !(c != null && c.word) && !d || (c || (c = i.getWordUntilPosition(e)), c.endColumn !== e.column)) return;
    const u = i.getValueInRange(new D(e.lineNumber, 1, e.lineNumber, e.column));
    if (!d && (!((s = this._lastResult) === null || s === void 0) && s.canBeReused(i, e.lineNumber, c))) {
      const g = new N9(u, e.column - this._lastResult.word.endColumn);
      this._lastResult.completionModel.lineContext = g, this._lastResult.acquire(), h = this._lastResult;
    } else {
      const g = await EP(this._languageFeatureService.completionProvider, i, e, new o1(void 0, NS.createSuggestFilter(o).itemKind, d == null ? void 0 : d.providers), d && { triggerKind: 1, triggerCharacter: d.ch }, n);
      let p;
      g.needsClipboard && (p = await this._clipboardService.readText());
      const f = new Lh(g.items, e.column, new N9(u, 0), Yr.None, o.getOption(118), o.getOption(112), { boostFullMatch: !1, firstMatchCanBeWeak: !1 }, p);
      h = new IT(i, e.lineNumber, c, f, g, this._suggestMemoryService);
    }
    return this._lastResult = h, h;
  }
  handleItemDidShow(i, e) {
    e.completion.resolve(et.None);
  }
  freeInlineCompletions(i) {
    i.release();
  }
  _getTriggerCharacterInfo(i, e) {
    var t;
    const n = i.getValueInRange(D.fromPositions({ lineNumber: e.lineNumber, column: e.column - 1 }, e)), s = /* @__PURE__ */ new Set();
    for (const o of this._languageFeatureService.completionProvider.all(i)) !((t = o.triggerCharacters) === null || t === void 0) && t.includes(n) && s.add(o);
    if (s.size !== 0) return { providers: s, ch: n };
  }
};
aN = yU([j_(0, fe), j_(1, Kd), j_(2, ak), j_(3, mt)], aN), H1(aN);
X(class extends he {
  constructor() {
    super({ id: "editor.action.forceRetokenize", label: m(0, "Developer: Force Retokenize"), alias: "Developer: Force Retokenize", precondition: void 0 });
  }
  run(i, e) {
    if (!e.hasModel()) return;
    const t = e.getModel();
    t.tokenization.resetTokenization();
    const n = new Rn();
    t.tokenization.forceTokenization(t.getLineCount()), n.stop(), console.log(`tokenization took ${n.elapsed()}`);
  }
});
class TS extends cs {
  constructor() {
    super({ id: TS.ID, title: ct(0, "Toggle Tab Key Moves Focus"), precondition: void 0, keybinding: { primary: 2091, mac: { primary: 1323 }, weight: 100 }, f1: !0 });
  }
  run() {
    const e = !Um.getTabFocusMode();
    Um.setTabFocusMode(e), Io(m(0, e ? "Pressing Tab will now move focus to the next focusable element" : "Pressing Tab will now insert the tab character"));
  }
}
TS.ID = "editor.action.toggleTabFocusMode", Ft(TS);
var Mhe = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, The = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let MT = class extends V {
  get enabled() {
    return this._enabled;
  }
  set enabled(i) {
    i ? (this.el.setAttribute("aria-disabled", "false"), this.el.tabIndex = 0, this.el.style.pointerEvents = "auto", this.el.style.opacity = "1", this.el.style.cursor = "pointer", this._enabled = !1) : (this.el.setAttribute("aria-disabled", "true"), this.el.tabIndex = -1, this.el.style.pointerEvents = "none", this.el.style.opacity = "0.4", this.el.style.cursor = "default", this._enabled = !0), this._enabled = i;
  }
  constructor(i, e, t = {}, n) {
    var s, o;
    super(), this._link = e, this._enabled = !0, this.el = Z(i, Q("a.monaco-link", { tabIndex: (s = e.tabIndex) !== null && s !== void 0 ? s : 0, href: e.href }, e.label)), this.hoverDelegate = (o = t.hoverDelegate) !== null && o !== void 0 ? o : Bs("mouse"), this.setTooltip(e.title), this.el.setAttribute("role", "button");
    const r = this._register(new st(this.el, "click")), a = this._register(new st(this.el, "keypress")), l = se.chain(a.event, (c) => c.map((u) => new jt(u)).filter((u) => u.keyCode === 3)), d = this._register(new st(this.el, Vt.Tap)).event;
    this._register(Bt.addTarget(this.el));
    const h = se.any(r.event, l, d);
    this._register(h((c) => {
      this.enabled && (Ze(c, !0), t != null && t.opener ? t.opener(this._link.href) : n.open(this._link.href, { allowCommands: !0 }));
    })), this.enabled = !0;
  }
  setTooltip(i) {
    this.hoverDelegate.showNativeHover ? this.el.title = i ?? "" : !this.hover && i ? this.hover = this._register(xr(this.hoverDelegate, this.el, i)) : this.hover && this.hover.update(i);
  }
};
MT = Mhe([The(3, Fs)], MT);
var SU = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, LU = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let TT = class extends V {
  constructor(i, e) {
    super(), this._editor = i, this.instantiationService = e, this.banner = this._register(this.instantiationService.createInstance(RT));
  }
  hide() {
    this._editor.setBanner(null, 0), this.banner.clear();
  }
  show(i) {
    this.banner.show({ ...i, onClose: () => {
      var e;
      this.hide(), (e = i.onClose) === null || e === void 0 || e.call(i);
    } }), this._editor.setBanner(this.banner.element, 26);
  }
};
TT = SU([LU(1, Se)], TT);
let RT = class extends V {
  constructor(i) {
    super(), this.instantiationService = i, this.markdownRenderer = this.instantiationService.createInstance(ml, {}), this.element = Q("div.editor-banner"), this.element.tabIndex = 0;
  }
  getAriaLabel(i) {
    return i.ariaLabel ? i.ariaLabel : typeof i.message == "string" ? i.message : void 0;
  }
  getBannerMessage(i) {
    if (typeof i == "string") {
      const e = Q("span");
      return e.innerText = i, e;
    }
    return this.markdownRenderer.render(i).element;
  }
  clear() {
    Un(this.element);
  }
  show(i) {
    Un(this.element);
    const e = this.getAriaLabel(i);
    e && this.element.setAttribute("aria-label", e);
    const t = Z(this.element, Q("div.icon-container"));
    t.setAttribute("aria-hidden", "true"), i.icon && t.appendChild(Q(`div${Ee.asCSSSelector(i.icon)}`));
    const n = Z(this.element, Q("div.message-container"));
    if (n.setAttribute("aria-hidden", "true"), n.appendChild(this.getBannerMessage(i.message)), this.messageActionsContainer = Z(this.element, Q("div.message-actions-container")), i.actions) for (const o of i.actions) this._register(this.instantiationService.createInstance(MT, this.messageActionsContainer, { ...o, tabIndex: -1 }, {}));
    const s = Z(this.element, Q("div.action-container"));
    this.actionBar = this._register(new sr(s)), this.actionBar.push(this._register(new Qs("banner.close", "Close Banner", Ee.asClassName(RV), !0, () => {
      typeof i.onClose == "function" && i.onClose();
    })), { icon: !0, label: !1 }), this.actionBar.setFocusable(!1);
  }
};
RT = SU([LU(0, Se)], RT);
var FP = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Mm = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const Rhe = Ei("extensions-warning-message", ne.warning, m(0, "Icon shown with a warning message in the extensions editor."));
let Tm = class extends V {
  constructor(i, e, t, n) {
    super(), this._editor = i, this._editorWorkerService = e, this._workspaceTrustService = t, this._highlighter = null, this._bannerClosed = !1, this._updateState = (s) => {
      if (s && s.hasMore) {
        if (this._bannerClosed) return;
        const o = Math.max(s.ambiguousCharacterCount, s.nonBasicAsciiCharacterCount, s.invisibleCharacterCount);
        let r;
        if (s.nonBasicAsciiCharacterCount >= o) r = { message: m(0, "This document contains many non-basic ASCII unicode characters"), command: new Df() };
        else if (s.ambiguousCharacterCount >= o) r = { message: m(0, "This document contains many ambiguous unicode characters"), command: new Wc() };
        else {
          if (!(s.invisibleCharacterCount >= o)) throw new Error("Unreachable");
          r = { message: m(0, "This document contains many invisible unicode characters"), command: new kf() };
        }
        this._bannerController.show({ id: "unicodeHighlightBanner", message: r.message, icon: Rhe, actions: [{ label: r.command.shortLabel, href: `command:${r.command.id}` }], onClose: () => {
          this._bannerClosed = !0;
        } });
      } else this._bannerController.hide();
    }, this._bannerController = this._register(n.createInstance(TT, i)), this._register(this._editor.onDidChangeModel(() => {
      this._bannerClosed = !1, this._updateHighlighter();
    })), this._options = i.getOption(125), this._register(t.onDidChangeTrust((s) => {
      this._updateHighlighter();
    })), this._register(i.onDidChangeConfiguration((s) => {
      s.hasChanged(125) && (this._options = i.getOption(125), this._updateHighlighter());
    })), this._updateHighlighter();
  }
  dispose() {
    this._highlighter && (this._highlighter.dispose(), this._highlighter = null), super.dispose();
  }
  _updateHighlighter() {
    if (this._updateState(null), this._highlighter && (this._highlighter.dispose(), this._highlighter = null), !this._editor.hasModel()) return;
    const i = function(t, n) {
      return { nonBasicASCII: n.nonBasicASCII === ro ? !t : n.nonBasicASCII, ambiguousCharacters: n.ambiguousCharacters, invisibleCharacters: n.invisibleCharacters, includeComments: n.includeComments === ro ? !t : n.includeComments, includeStrings: n.includeStrings === ro ? !t : n.includeStrings, allowedCharacters: n.allowedCharacters, allowedLocales: n.allowedLocales };
    }(this._workspaceTrustService.isWorkspaceTrusted(), this._options);
    if ([i.nonBasicASCII, i.ambiguousCharacters, i.invisibleCharacters].every((t) => t === !1)) return;
    const e = { nonBasicASCII: i.nonBasicASCII, ambiguousCharacters: i.ambiguousCharacters, invisibleCharacters: i.invisibleCharacters, includeComments: i.includeComments, includeStrings: i.includeStrings, allowedCodePoints: Object.keys(i.allowedCharacters).map((t) => t.codePointAt(0)), allowedLocales: Object.keys(i.allowedLocales).map((t) => t === "_os" ? new Intl.NumberFormat().resolvedOptions().locale : t === "_vscode" ? YU : t) };
    this._editorWorkerService.canComputeUnicodeHighlights(this._editor.getModel().uri) ? this._highlighter = new AT(this._editor, e, this._updateState, this._editorWorkerService) : this._highlighter = new Ahe(this._editor, e, this._updateState);
  }
  getDecorationInfo(i) {
    return this._highlighter ? this._highlighter.getDecorationInfo(i) : null;
  }
};
Tm.ID = "editor.contrib.unicodeHighlighter", Tm = FP([Mm(1, Qo), Mm(2, VW), Mm(3, Se)], Tm);
let AT = class extends V {
  constructor(i, e, t, n) {
    super(), this._editor = i, this._options = e, this._updateState = t, this._editorWorkerService = n, this._model = this._editor.getModel(), this._decorations = this._editor.createDecorationsCollection(), this._updateSoon = this._register(new It(() => this._update(), 250)), this._register(this._editor.onDidChangeModelContent(() => {
      this._updateSoon.schedule();
    })), this._updateSoon.schedule();
  }
  dispose() {
    this._decorations.clear(), super.dispose();
  }
  _update() {
    if (this._model.isDisposed()) return;
    if (!this._model.mightContainNonBasicASCII()) return void this._decorations.clear();
    const i = this._model.getVersionId();
    this._editorWorkerService.computedUnicodeHighlights(this._model.uri, this._options).then((e) => {
      if (this._model.isDisposed() || this._model.getVersionId() !== i) return;
      this._updateState(e);
      const t = [];
      if (!e.hasMore) for (const n of e.ranges) t.push({ range: n, options: RS.instance.getDecorationFromOptions(this._options) });
      this._decorations.set(t);
    });
  }
  getDecorationInfo(i) {
    if (!this._decorations.has(i)) return null;
    const e = this._editor.getModel();
    return lA(e, i) ? { reason: DU(e.getValueInRange(i.range), this._options), inComment: dA(e, i), inString: hA(e, i) } : null;
  }
};
AT = FP([Mm(3, Qo)], AT);
class Ahe extends V {
  constructor(e, t, n) {
    super(), this._editor = e, this._options = t, this._updateState = n, this._model = this._editor.getModel(), this._decorations = this._editor.createDecorationsCollection(), this._updateSoon = this._register(new It(() => this._update(), 250)), this._register(this._editor.onDidLayoutChange(() => {
      this._updateSoon.schedule();
    })), this._register(this._editor.onDidScrollChange(() => {
      this._updateSoon.schedule();
    })), this._register(this._editor.onDidChangeHiddenAreas(() => {
      this._updateSoon.schedule();
    })), this._register(this._editor.onDidChangeModelContent(() => {
      this._updateSoon.schedule();
    })), this._updateSoon.schedule();
  }
  dispose() {
    this._decorations.clear(), super.dispose();
  }
  _update() {
    if (this._model.isDisposed()) return;
    if (!this._model.mightContainNonBasicASCII()) return void this._decorations.clear();
    const e = this._editor.getVisibleRanges(), t = [], n = { ranges: [], ambiguousCharacterCount: 0, invisibleCharacterCount: 0, nonBasicAsciiCharacterCount: 0, hasMore: !1 };
    for (const s of e) {
      const o = LR.computeUnicodeHighlights(this._model, this._options, s);
      for (const r of o.ranges) n.ranges.push(r);
      n.ambiguousCharacterCount += n.ambiguousCharacterCount, n.invisibleCharacterCount += n.invisibleCharacterCount, n.nonBasicAsciiCharacterCount += n.nonBasicAsciiCharacterCount, n.hasMore = n.hasMore || o.hasMore;
    }
    if (!n.hasMore) for (const s of n.ranges) t.push({ range: s, options: RS.instance.getDecorationFromOptions(this._options) });
    this._updateState(n), this._decorations.set(t);
  }
  getDecorationInfo(e) {
    if (!this._decorations.has(e)) return null;
    const t = this._editor.getModel(), n = t.getValueInRange(e.range);
    return lA(t, e) ? { reason: DU(n, this._options), inComment: dA(t, e), inString: hA(t, e) } : null;
  }
}
const kU = m(0, "Configure Unicode Highlight Options");
let PT = class {
  constructor(i, e, t) {
    this._editor = i, this._languageService = e, this._openerService = t, this.hoverOrdinal = 5;
  }
  computeSync(i, e) {
    if (!this._editor.hasModel() || i.type !== 1) return [];
    const t = this._editor.getModel(), n = this._editor.getContribution(Tm.ID);
    if (!n) return [];
    const s = [], o = /* @__PURE__ */ new Set();
    let r = 300;
    for (const a of e) {
      const l = n.getDecorationInfo(a);
      if (!l) continue;
      const d = t.getValueInRange(a.range).codePointAt(0), h = lN(d);
      let c;
      switch (l.reason.kind) {
        case 0:
          c = f1(l.reason.confusableWith) ? m(0, "The character {0} could be confused with the ASCII character {1}, which is more common in source code.", h, lN(l.reason.confusableWith.codePointAt(0))) : m(0, "The character {0} could be confused with the character {1}, which is more common in source code.", h, lN(l.reason.confusableWith.codePointAt(0)));
          break;
        case 1:
          c = m(0, "The character {0} is invisible.", h);
          break;
        case 2:
          c = m(0, "The character {0} is not a basic ASCII character.", h);
      }
      if (o.has(c)) continue;
      o.add(c);
      const u = { codePoint: d, reason: l.reason, inComment: l.inComment, inString: l.inString }, g = m(0, "Adjust settings"), p = `command:${c1.ID}?${encodeURIComponent(JSON.stringify(u))}`, f = new Vn("", !0).appendMarkdown(c).appendText(" ").appendLink(p, g, kU);
      s.push(new Jr(this, a.range, [f], !1, r++));
    }
    return s;
  }
  renderHoverParts(i, e) {
    return Lz(i, e, this._editor, this._languageService, this._openerService);
  }
};
function OT(i) {
  return `U+${i.toString(16).padStart(4, "0")}`;
}
function lN(i) {
  let e = `\`${OT(i)}\``;
  return gl.isInvisibleCharacter(i) || (e += ` "${function(t) {
    return t === 96 ? "`` ` ``" : "`" + String.fromCodePoint(t) + "`";
  }(i)}"`), e;
}
function DU(i, e) {
  return LR.computeUnicodeHighlightReason(i, e);
}
PT = FP([Mm(1, Xt), Mm(2, Fs)], PT);
class RS {
  constructor() {
    this.map = /* @__PURE__ */ new Map();
  }
  getDecorationFromOptions(e) {
    return this.getDecoration(!e.includeComments, !e.includeStrings);
  }
  getDecoration(e, t) {
    const n = `${e}${t}`;
    let s = this.map.get(n);
    return s || (s = Ve.createDynamic({ description: "unicode-highlight", stickiness: 1, className: "unicode-highlight", showIfCollapsed: !0, overviewRuler: null, minimap: null, hideInCommentTokens: e, hideInStringTokens: t }), this.map.set(n, s)), s;
  }
}
RS.instance = new RS();
class Phe extends he {
  constructor() {
    super({ id: Wc.ID, label: m(0, "Disable highlighting of characters in comments"), alias: "Disable highlighting of characters in comments", precondition: void 0 }), this.shortLabel = m(0, "Disable Highlight In Comments");
  }
  async run(e, t, n) {
    const s = e == null ? void 0 : e.get(Ye);
    s && this.runAction(s);
  }
  async runAction(e) {
    await e.updateValue(A7, !1, 2);
  }
}
class Ohe extends he {
  constructor() {
    super({ id: Wc.ID, label: m(0, "Disable highlighting of characters in strings"), alias: "Disable highlighting of characters in strings", precondition: void 0 }), this.shortLabel = m(0, "Disable Highlight In Strings");
  }
  async run(e, t, n) {
    const s = e == null ? void 0 : e.get(Ye);
    s && this.runAction(s);
  }
  async runAction(e) {
    await e.updateValue(P7, !1, 2);
  }
}
class Wc extends he {
  constructor() {
    super({ id: Wc.ID, label: m(0, "Disable highlighting of ambiguous characters"), alias: "Disable highlighting of ambiguous characters", precondition: void 0 }), this.shortLabel = m(0, "Disable Ambiguous Highlight");
  }
  async run(e, t, n) {
    const s = e == null ? void 0 : e.get(Ye);
    s && this.runAction(s);
  }
  async runAction(e) {
    await e.updateValue(R7, !1, 2);
  }
}
Wc.ID = "editor.action.unicodeHighlight.disableHighlightingOfAmbiguousCharacters";
class kf extends he {
  constructor() {
    super({ id: kf.ID, label: m(0, "Disable highlighting of invisible characters"), alias: "Disable highlighting of invisible characters", precondition: void 0 }), this.shortLabel = m(0, "Disable Invisible Highlight");
  }
  async run(e, t, n) {
    const s = e == null ? void 0 : e.get(Ye);
    s && this.runAction(s);
  }
  async runAction(e) {
    await e.updateValue(M7, !1, 2);
  }
}
kf.ID = "editor.action.unicodeHighlight.disableHighlightingOfInvisibleCharacters";
class Df extends he {
  constructor() {
    super({ id: Df.ID, label: m(0, "Disable highlighting of non basic ASCII characters"), alias: "Disable highlighting of non basic ASCII characters", precondition: void 0 }), this.shortLabel = m(0, "Disable Non ASCII Highlight");
  }
  async run(e, t, n) {
    const s = e == null ? void 0 : e.get(Ye);
    s && this.runAction(s);
  }
  async runAction(e) {
    await e.updateValue(T7, !1, 2);
  }
}
Df.ID = "editor.action.unicodeHighlight.disableHighlightingOfNonBasicAsciiCharacters";
class c1 extends he {
  constructor() {
    super({ id: c1.ID, label: m(0, "Show Exclude Options"), alias: "Show Exclude Options", precondition: void 0 });
  }
  async run(e, t, n) {
    const { codePoint: s, reason: o, inString: r, inComment: a } = n, l = String.fromCodePoint(s), d = e.get(La), h = e.get(Ye), c = [];
    if (o.kind === 0) for (const g of o.notAmbiguousInLocales) c.push({ label: m(0, 'Allow unicode characters that are more common in the language "{0}".', g), run: async () => {
      Fhe(h, [g]);
    } });
    if (c.push({ label: function(g) {
      return gl.isInvisibleCharacter(g) ? m(0, "Exclude {0} (invisible character) from being highlighted", OT(g)) : m(0, "Exclude {0} from being highlighted", `${OT(g)} "${l}"`);
    }(s), run: () => async function(g, p) {
      const f = g.getValue(kN);
      let _;
      _ = typeof f == "object" && f ? f : {};
      for (const v of p) _[String.fromCodePoint(v)] = !0;
      await g.updateValue(kN, _, 2);
    }(h, [s]) }), a) {
      const g = new Phe();
      c.push({ label: g.label, run: async () => g.runAction(h) });
    } else if (r) {
      const g = new Ohe();
      c.push({ label: g.label, run: async () => g.runAction(h) });
    }
    if (o.kind === 0) {
      const g = new Wc();
      c.push({ label: g.label, run: async () => g.runAction(h) });
    } else if (o.kind === 1) {
      const g = new kf();
      c.push({ label: g.label, run: async () => g.runAction(h) });
    } else if (o.kind === 2) {
      const g = new Df();
      c.push({ label: g.label, run: async () => g.runAction(h) });
    } else (function(g) {
      throw new Error(`Unexpected value: ${g}`);
    })(o);
    const u = await d.pick(c, { title: kU });
    u && await u.run();
  }
}
async function Fhe(i, e) {
  var t;
  const n = (t = i.inspect(DN).user) === null || t === void 0 ? void 0 : t.value;
  let s;
  s = typeof n == "object" && n ? Object.assign({}, n) : {};
  for (const o of e) s[o] = !0;
  await i.updateValue(DN, s, 2);
}
c1.ID = "editor.action.unicodeHighlight.showExcludeOptions", X(Wc), X(kf), X(Df), X(c1), ft(Tm.ID, Tm, 1), Rc.register(PT);
var Bhe = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, $9 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const G9 = "ignoreUnusualLineTerminators";
let h_ = class extends V {
  constructor(i, e, t) {
    super(), this._editor = i, this._dialogService = e, this._codeEditorService = t, this._isPresentingDialog = !1, this._config = this._editor.getOption(126), this._register(this._editor.onDidChangeConfiguration((n) => {
      n.hasChanged(126) && (this._config = this._editor.getOption(126), this._checkForUnusualLineTerminators());
    })), this._register(this._editor.onDidChangeModel(() => {
      this._checkForUnusualLineTerminators();
    })), this._register(this._editor.onDidChangeModelContent((n) => {
      n.isUndoing || this._checkForUnusualLineTerminators();
    })), this._checkForUnusualLineTerminators();
  }
  async _checkForUnusualLineTerminators() {
    if (this._config === "off" || !this._editor.hasModel()) return;
    const i = this._editor.getModel();
    if (!i.mightContainUnusualLineTerminators() || function(n, s) {
      return n.getModelProperty(s.uri, G9);
    }(this._codeEditorService, i) === !0 || this._editor.getOption(91)) return;
    if (this._config === "auto") return void i.removeUnusualLineTerminators(this._editor.getSelections());
    if (this._isPresentingDialog) return;
    let t;
    try {
      this._isPresentingDialog = !0, t = await this._dialogService.confirm({ title: m(0, "Unusual Line Terminators"), message: m(0, "Detected unusual line terminators"), detail: m(0, "The file '{0}' contains one or more unusual line terminator characters, like Line Separator (LS) or Paragraph Separator (PS).\n\nIt is recommended to remove them from the file. This can be configured via `editor.unusualLineTerminators`.", ir(i.uri)), primaryButton: m(0, "&&Remove Unusual Line Terminators"), cancelButton: m(0, "Ignore") });
    } finally {
      this._isPresentingDialog = !1;
    }
    t.confirmed ? i.removeUnusualLineTerminators(this._editor.getSelections()) : function(n, s, o) {
      n.setModelProperty(s.uri, G9, o);
    }(this._codeEditorService, i, !0);
  }
};
h_.ID = "editor.contrib.unusualLineTerminatorsDetector", h_ = Bhe([$9(1, M1), $9(2, mt)], h_), ft(h_.ID, h_, 1);
var qi, FT, xU = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Dw = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
const xw = new ae("hasWordHighlights", !1);
function NU(i, e, t, n) {
  return cR(i.ordered(e).map((s) => () => Promise.resolve(s.provideDocumentHighlights(e, t, n)).then(void 0, Ni)), zn).then((s) => {
    if (s) {
      const o = new Di();
      return o.set(e.uri, s), o;
    }
    return new Di();
  });
}
class BP {
  constructor(e, t, n) {
    this._model = e, this._selection = t, this._wordSeparators = n, this._wordRange = this._getCurrentWordRange(e, t), this._result = null;
  }
  get result() {
    return this._result || (this._result = on((e) => this._compute(this._model, this._selection, this._wordSeparators, e))), this._result;
  }
  _getCurrentWordRange(e, t) {
    const n = e.getWordAtPosition(t.getPosition());
    return n ? new D(t.startLineNumber, n.startColumn, t.startLineNumber, n.endColumn) : null;
  }
  isValid(e, t, n) {
    const s = t.startLineNumber, o = t.startColumn, r = t.endColumn, a = this._getCurrentWordRange(e, t);
    let l = !!(this._wordRange && this._wordRange.equalsRange(a));
    for (let d = 0, h = n.length; !l && d < h; d++) {
      const c = n.getRange(d);
      c && c.startLineNumber === s && c.startColumn <= o && c.endColumn >= r && (l = !0);
    }
    return l;
  }
  cancel() {
    this.result.cancel();
  }
}
class Whe extends BP {
  constructor(e, t, n, s) {
    super(e, t, n), this._providers = s;
  }
  _compute(e, t, n, s) {
    return NU(this._providers, e, t.getPosition(), s).then((o) => o || new Di());
  }
}
class Vhe extends BP {
  constructor(e, t, n, s, o) {
    super(e, t, n), this._providers = s, this._otherModels = o;
  }
  _compute(e, t, n, s) {
    return function(o, r, a, l, d, h) {
      return cR(o.ordered(r).map((c) => () => {
        const u = h.filter((g) => G8(g)).filter((g) => gA(c.selector, g.uri, g.getLanguageId(), !0, void 0, void 0) > 0);
        return Promise.resolve(c.provideMultiDocumentHighlights(r, a, u, d)).then(void 0, Ni);
      }), (c) => c instanceof Di && c.size > 0);
    }(this._providers, e, t.getPosition(), 0, s, this._otherModels).then((o) => o || new Di());
  }
}
class Z9 extends BP {
  constructor(e, t, n, s, o) {
    super(e, t, s), this._otherModels = o, this._selectionIsEmpty = t.isEmpty(), this._word = n;
  }
  _compute(e, t, n, s) {
    return bc(250, s).then(() => {
      const o = new Di();
      let r;
      if (r = this._word ? this._word : e.getWordAtPosition(t.getPosition()), !r) return new Di();
      const a = [e, ...this._otherModels];
      for (const l of a) {
        if (l.isDisposed()) continue;
        const d = l.findMatches(r.word, !0, !1, !0, n, !1).map((h) => ({ range: h.range, kind: X0.Text }));
        d && o.set(l.uri, d);
      }
      return o;
    });
  }
  isValid(e, t, n) {
    const s = t.isEmpty();
    return this._selectionIsEmpty === s && super.isValid(e, t, n);
  }
}
qa("_executeDocumentHighlights", async (i, e, t) => {
  const n = i.get(fe), s = await NU(n.documentHighlightProvider, e, t, et.None);
  return s == null ? void 0 : s.get(e.uri);
});
let q_ = qi = class {
  constructor(i, e, t, n, s) {
    this.toUnhook = new G(), this.workerRequestTokenId = 0, this.workerRequestCompleted = !1, this.workerRequestValue = new Di(), this.lastCursorPositionChangeTime = 0, this.renderDecorationsTimer = -1, this.editor = i, this.providers = e, this.multiDocumentProviders = t, this.codeEditorService = s, this._hasWordHighlights = xw.bindTo(n), this._ignorePositionChangeEvent = !1, this.occurrencesHighlight = this.editor.getOption(81), this.model = this.editor.getModel(), this.toUnhook.add(i.onDidChangeCursorPosition((o) => {
      this._ignorePositionChangeEvent || this.occurrencesHighlight !== "off" && this._onPositionChanged(o);
    })), this.toUnhook.add(i.onDidFocusEditorText((o) => {
      this.occurrencesHighlight !== "off" && (this.workerRequest || this._run());
    })), this.toUnhook.add(i.onDidChangeModelContent((o) => {
      this._stopAll();
    })), this.toUnhook.add(i.onDidChangeModel((o) => {
      !o.newModelUrl && o.oldModelUrl ? this._stopSingular() : qi.query && this._run();
    })), this.toUnhook.add(i.onDidChangeConfiguration((o) => {
      const r = this.editor.getOption(81);
      this.occurrencesHighlight !== r && (this.occurrencesHighlight = r, this._stopAll());
    })), this.decorations = this.editor.createDecorationsCollection(), this.workerRequestTokenId = 0, this.workerRequest = null, this.workerRequestCompleted = !1, this.lastCursorPositionChangeTime = 0, this.renderDecorationsTimer = -1, qi.query && this._run();
  }
  hasDecorations() {
    return this.decorations.length > 0;
  }
  restore() {
    this.occurrencesHighlight !== "off" && this._run();
  }
  _getSortedHighlights() {
    return this.decorations.getRanges().sort(D.compareRangesUsingStarts);
  }
  moveNext() {
    const i = this._getSortedHighlights(), e = i.findIndex((s) => s.containsPosition(this.editor.getPosition())), t = (e + 1) % i.length, n = i[t];
    try {
      this._ignorePositionChangeEvent = !0, this.editor.setPosition(n.getStartPosition()), this.editor.revealRangeInCenterIfOutsideViewport(n);
      const s = this._getWord();
      s && Io(`${this.editor.getModel().getLineContent(n.startLineNumber)}, ${t + 1} of ${i.length} for '${s.word}'`);
    } finally {
      this._ignorePositionChangeEvent = !1;
    }
  }
  moveBack() {
    const i = this._getSortedHighlights(), e = i.findIndex((s) => s.containsPosition(this.editor.getPosition())), t = (e - 1 + i.length) % i.length, n = i[t];
    try {
      this._ignorePositionChangeEvent = !0, this.editor.setPosition(n.getStartPosition()), this.editor.revealRangeInCenterIfOutsideViewport(n);
      const s = this._getWord();
      s && Io(`${this.editor.getModel().getLineContent(n.startLineNumber)}, ${t + 1} of ${i.length} for '${s.word}'`);
    } finally {
      this._ignorePositionChangeEvent = !1;
    }
  }
  _removeSingleDecorations() {
    if (!this.editor.hasModel()) return;
    const i = qi.storedDecorations.get(this.editor.getModel().uri);
    i && (this.editor.removeDecorations(i), qi.storedDecorations.delete(this.editor.getModel().uri), this.decorations.length > 0 && (this.decorations.clear(), this._hasWordHighlights.set(!1)));
  }
  _removeAllDecorations() {
    const i = this.codeEditorService.listCodeEditors(), e = [];
    for (const t of i) {
      if (!t.hasModel()) continue;
      const n = qi.storedDecorations.get(t.getModel().uri);
      if (!n) continue;
      t.removeDecorations(n), e.push(t.getModel().uri);
      const s = Rd.get(t);
      s != null && s.wordHighlighter && s.wordHighlighter.decorations.length > 0 && (s.wordHighlighter.decorations.clear(), s.wordHighlighter.workerRequest = null, s.wordHighlighter._hasWordHighlights.set(!1));
    }
    for (const t of e) qi.storedDecorations.delete(t);
  }
  _stopSingular() {
    var i, e, t, n;
    this._removeSingleDecorations(), this.editor.hasTextFocus() && (((i = this.editor.getModel()) === null || i === void 0 ? void 0 : i.uri.scheme) !== Ue.vscodeNotebookCell && ((t = (e = qi.query) === null || e === void 0 ? void 0 : e.modelInfo) === null || t === void 0 ? void 0 : t.model.uri.scheme) !== Ue.vscodeNotebookCell ? (qi.query = null, this._run()) : !((n = qi.query) === null || n === void 0) && n.modelInfo && (qi.query.modelInfo = null)), this.renderDecorationsTimer !== -1 && (clearTimeout(this.renderDecorationsTimer), this.renderDecorationsTimer = -1), this.workerRequest !== null && (this.workerRequest.cancel(), this.workerRequest = null), this.workerRequestCompleted || (this.workerRequestTokenId++, this.workerRequestCompleted = !0);
  }
  _stopAll() {
    this._removeAllDecorations(), this.renderDecorationsTimer !== -1 && (clearTimeout(this.renderDecorationsTimer), this.renderDecorationsTimer = -1), this.workerRequest !== null && (this.workerRequest.cancel(), this.workerRequest = null), this.workerRequestCompleted || (this.workerRequestTokenId++, this.workerRequestCompleted = !0);
  }
  _onPositionChanged(i) {
    var e;
    this.occurrencesHighlight !== "off" && (i.reason === 3 || ((e = this.editor.getModel()) === null || e === void 0 ? void 0 : e.uri.scheme) === Ue.vscodeNotebookCell) ? this._run() : this._stopAll();
  }
  _getWord() {
    const i = this.editor.getSelection(), e = i.startLineNumber, t = i.startColumn;
    return this.model.isDisposed() ? null : this.model.getWordAtPosition({ lineNumber: e, column: t });
  }
  getOtherModelsToHighlight(i) {
    if (!i) return [];
    if (i.uri.scheme === Ue.vscodeNotebookCell) {
      const n = [], s = this.codeEditorService.listCodeEditors();
      for (const o of s) {
        const r = o.getModel();
        r && r !== i && r.uri.scheme === Ue.vscodeNotebookCell && n.push(r);
      }
      return n;
    }
    const e = [], t = this.codeEditorService.listCodeEditors();
    for (const n of t) {
      if (!rP(n)) continue;
      const s = n.getModel();
      s && i === s.modified && e.push(s.modified);
    }
    if (e.length) return e;
    if (this.occurrencesHighlight === "singleFile") return [];
    for (const n of t) {
      const s = n.getModel();
      s && s !== i && e.push(s);
    }
    return e;
  }
  _run() {
    var i;
    let e;
    if (this.editor.hasTextFocus()) {
      const t = this.editor.getSelection();
      if (!t || t.startLineNumber !== t.endLineNumber) return qi.query = null, void this._stopAll();
      const n = t.startColumn, s = t.endColumn, o = this._getWord();
      if (!o || o.startColumn > n || o.endColumn < s) return qi.query = null, void this._stopAll();
      e = this.workerRequest && this.workerRequest.isValid(this.model, t, this.decorations), qi.query = { modelInfo: { model: this.model, selection: t }, word: o };
    } else if (!qi.query) return;
    if (this.lastCursorPositionChangeTime = (/* @__PURE__ */ new Date()).getTime(), e) this.workerRequestCompleted && this.renderDecorationsTimer !== -1 && (clearTimeout(this.renderDecorationsTimer), this.renderDecorationsTimer = -1, this._beginRenderDecorations());
    else {
      this._stopAll();
      const t = ++this.workerRequestTokenId;
      this.workerRequestCompleted = !1;
      const n = this.getOtherModelsToHighlight(this.editor.getModel());
      if (!qi.query.modelInfo || qi.query.modelInfo.model.isDisposed()) return;
      this.workerRequest = this.computeWithModel(qi.query.modelInfo.model, qi.query.modelInfo.selection, qi.query.word, n), (i = this.workerRequest) === null || i === void 0 || i.result.then((s) => {
        t === this.workerRequestTokenId && (this.workerRequestCompleted = !0, this.workerRequestValue = s || [], this._beginRenderDecorations());
      }, We);
    }
  }
  computeWithModel(i, e, t, n) {
    return n.length ? function(s, o, r, a, l, d) {
      return s.has(o) ? new Vhe(o, r, l, s, d) : new Z9(o, r, a, l, d);
    }(this.multiDocumentProviders, i, e, t, this.editor.getOption(131), n) : function(s, o, r, a, l) {
      return s.has(o) ? new Whe(o, r, l, s) : new Z9(o, r, a, l, []);
    }(this.providers, i, e, t, this.editor.getOption(131));
  }
  _beginRenderDecorations() {
    const i = (/* @__PURE__ */ new Date()).getTime(), e = this.lastCursorPositionChangeTime + 250;
    i >= e ? (this.renderDecorationsTimer = -1, this.renderDecorations()) : this.renderDecorationsTimer = setTimeout(() => {
      this.renderDecorations();
    }, e - i);
  }
  renderDecorations() {
    var i, e, t;
    this.renderDecorationsTimer = -1;
    const n = this.codeEditorService.listCodeEditors();
    for (const o of n) {
      const r = Rd.get(o);
      if (!r) continue;
      const a = [], l = (i = o.getModel()) === null || i === void 0 ? void 0 : i.uri;
      if (l && this.workerRequestValue.has(l)) {
        const d = qi.storedDecorations.get(l), h = this.workerRequestValue.get(l);
        if (h) for (const u of h) u.range && a.push({ range: u.range, options: (s = u.kind, s === X0.Write ? jde : s === X0.Text ? qde : Zde) });
        let c = [];
        o.changeDecorations((u) => {
          c = u.deltaDecorations(d ?? [], a);
        }), qi.storedDecorations = qi.storedDecorations.set(l, c), a.length > 0 && ((e = r.wordHighlighter) === null || e === void 0 || e.decorations.set(a), (t = r.wordHighlighter) === null || t === void 0 || t._hasWordHighlights.set(!0));
      }
    }
    var s;
  }
  dispose() {
    this._stopSingular(), this.toUnhook.dispose();
  }
};
q_.storedDecorations = new Di(), q_.query = null, q_ = qi = xU([Dw(4, mt)], q_);
let Rd = FT = class extends V {
  static get(i) {
    return i.getContribution(FT.ID);
  }
  constructor(i, e, t, n) {
    super(), this._wordHighlighter = null;
    const s = () => {
      i.hasModel() && !i.getModel().isTooLargeForTokenization() && (this._wordHighlighter = new q_(i, t.documentHighlightProvider, t.multiDocumentHighlightProvider, e, n));
    };
    this._register(i.onDidChangeModel((o) => {
      this._wordHighlighter && (this._wordHighlighter.dispose(), this._wordHighlighter = null), s();
    })), s();
  }
  get wordHighlighter() {
    return this._wordHighlighter;
  }
  saveViewState() {
    return !(!this._wordHighlighter || !this._wordHighlighter.hasDecorations());
  }
  moveNext() {
    var i;
    (i = this._wordHighlighter) === null || i === void 0 || i.moveNext();
  }
  moveBack() {
    var i;
    (i = this._wordHighlighter) === null || i === void 0 || i.moveBack();
  }
  restoreViewState(i) {
    this._wordHighlighter && i && this._wordHighlighter.restore();
  }
  dispose() {
    this._wordHighlighter && (this._wordHighlighter.dispose(), this._wordHighlighter = null), super.dispose();
  }
};
Rd.ID = "editor.contrib.wordHighlighter", Rd = FT = xU([Dw(1, Te), Dw(2, fe), Dw(3, mt)], Rd);
class Y9 extends he {
  constructor(e, t) {
    super(t), this._isNext = e;
  }
  run(e, t) {
    const n = Rd.get(t);
    n && (this._isNext ? n.moveNext() : n.moveBack());
  }
}
ft(Rd.ID, Rd, 0), X(class extends Y9 {
  constructor() {
    super(!0, { id: "editor.action.wordHighlight.next", label: m(0, "Go to Next Symbol Highlight"), alias: "Go to Next Symbol Highlight", precondition: xw, kbOpts: { kbExpr: E.editorTextFocus, primary: 65, weight: 100 } });
  }
}), X(class extends Y9 {
  constructor() {
    super(!1, { id: "editor.action.wordHighlight.prev", label: m(0, "Go to Previous Symbol Highlight"), alias: "Go to Previous Symbol Highlight", precondition: xw, kbOpts: { kbExpr: E.editorTextFocus, primary: 1089, weight: 100 } });
  }
}), X(class extends he {
  constructor() {
    super({ id: "editor.action.wordHighlight.trigger", label: m(0, "Trigger Symbol Highlight"), alias: "Trigger Symbol Highlight", precondition: xw.toNegated(), kbOpts: { kbExpr: E.editorTextFocus, primary: 0, weight: 100 } });
  }
  run(i, e, t) {
    const n = Rd.get(e);
    n && n.restoreViewState(!0);
  }
});
class Sk extends Zi {
  constructor(e) {
    super(e), this._inSelectionMode = e.inSelectionMode, this._wordNavigationType = e.wordNavigationType;
  }
  runEditorCommand(e, t, n) {
    if (!t.hasModel()) return;
    const s = zo(t.getOption(131), t.getOption(130)), o = t.getModel(), r = t.getSelections().map((a) => {
      const l = new W(a.positionLineNumber, a.positionColumn), d = this._move(s, o, l, this._wordNavigationType);
      return this._moveTo(a, d, this._inSelectionMode);
    });
    if (o.pushStackElement(), t._getViewModel().setCursorStates("moveWordCommand", 3, r.map((a) => pt.fromModelSelection(a))), r.length === 1) {
      const a = new W(r[0].positionLineNumber, r[0].positionColumn);
      t.revealPosition(a, 0);
    }
  }
  _moveTo(e, t, n) {
    return n ? new _e(e.selectionStartLineNumber, e.selectionStartColumn, t.lineNumber, t.column) : new _e(t.lineNumber, t.column, t.lineNumber, t.column);
  }
}
class ih extends Sk {
  _move(e, t, n, s) {
    return Ct.moveWordLeft(e, t, n, s);
  }
}
class nh extends Sk {
  _move(e, t, n, s) {
    return Ct.moveWordRight(e, t, n, s);
  }
}
class AS extends Zi {
  constructor(e) {
    super(e), this._whitespaceHeuristics = e.whitespaceHeuristics, this._wordNavigationType = e.wordNavigationType;
  }
  runEditorCommand(e, t, n) {
    const s = e.get(zt);
    if (!t.hasModel()) return;
    const o = zo(t.getOption(131), t.getOption(130)), r = t.getModel(), a = t.getSelections(), l = t.getOption(6), d = t.getOption(11), h = s.getLanguageConfiguration(r.getLanguageId()).getAutoClosingPairs(), c = t._getViewModel(), u = a.map((g) => {
      const p = this._delete({ wordSeparators: o, model: r, selection: g, whitespaceHeuristics: this._whitespaceHeuristics, autoClosingDelete: t.getOption(9), autoClosingBrackets: l, autoClosingQuotes: d, autoClosingPairs: h, autoClosedCharacters: c.getCursorAutoClosedCharacters() }, this._wordNavigationType);
      return new Dn(p, "");
    });
    t.pushUndoStop(), t.executeCommands(this.id, u), t.pushUndoStop();
  }
}
class dN extends AS {
  _delete(e, t) {
    return Ct.deleteWordLeft(e, t) || new D(1, 1, 1, 1);
  }
}
class hN extends AS {
  _delete(e, t) {
    const n = Ct.deleteWordRight(e, t);
    if (n) return n;
    const s = e.model.getLineCount(), o = e.model.getLineMaxColumn(s);
    return new D(s, o, s, o);
  }
}
re(new class extends ih {
  constructor() {
    super({ inSelectionMode: !1, wordNavigationType: 0, id: "cursorWordStartLeft", precondition: void 0 });
  }
}()), re(new class extends ih {
  constructor() {
    super({ inSelectionMode: !1, wordNavigationType: 2, id: "cursorWordEndLeft", precondition: void 0 });
  }
}()), re(new class extends ih {
  constructor() {
    var i;
    super({ inSelectionMode: !1, wordNavigationType: 1, id: "cursorWordLeft", precondition: void 0, kbOpts: { kbExpr: q.and(E.textInputFocus, (i = q.and(m_, Ub)) === null || i === void 0 ? void 0 : i.negate()), primary: 2063, mac: { primary: 527 }, weight: 100 } });
  }
}()), re(new class extends ih {
  constructor() {
    super({ inSelectionMode: !0, wordNavigationType: 0, id: "cursorWordStartLeftSelect", precondition: void 0 });
  }
}()), re(new class extends ih {
  constructor() {
    super({ inSelectionMode: !0, wordNavigationType: 2, id: "cursorWordEndLeftSelect", precondition: void 0 });
  }
}()), re(new class extends ih {
  constructor() {
    var i;
    super({ inSelectionMode: !0, wordNavigationType: 1, id: "cursorWordLeftSelect", precondition: void 0, kbOpts: { kbExpr: q.and(E.textInputFocus, (i = q.and(m_, Ub)) === null || i === void 0 ? void 0 : i.negate()), primary: 3087, mac: { primary: 1551 }, weight: 100 } });
  }
}()), re(new class extends nh {
  constructor() {
    super({ inSelectionMode: !1, wordNavigationType: 0, id: "cursorWordStartRight", precondition: void 0 });
  }
}()), re(new class extends nh {
  constructor() {
    var i;
    super({ inSelectionMode: !1, wordNavigationType: 2, id: "cursorWordEndRight", precondition: void 0, kbOpts: { kbExpr: q.and(E.textInputFocus, (i = q.and(m_, Ub)) === null || i === void 0 ? void 0 : i.negate()), primary: 2065, mac: { primary: 529 }, weight: 100 } });
  }
}()), re(new class extends nh {
  constructor() {
    super({ inSelectionMode: !1, wordNavigationType: 2, id: "cursorWordRight", precondition: void 0 });
  }
}()), re(new class extends nh {
  constructor() {
    super({ inSelectionMode: !0, wordNavigationType: 0, id: "cursorWordStartRightSelect", precondition: void 0 });
  }
}()), re(new class extends nh {
  constructor() {
    var i;
    super({ inSelectionMode: !0, wordNavigationType: 2, id: "cursorWordEndRightSelect", precondition: void 0, kbOpts: { kbExpr: q.and(E.textInputFocus, (i = q.and(m_, Ub)) === null || i === void 0 ? void 0 : i.negate()), primary: 3089, mac: { primary: 1553 }, weight: 100 } });
  }
}()), re(new class extends nh {
  constructor() {
    super({ inSelectionMode: !0, wordNavigationType: 2, id: "cursorWordRightSelect", precondition: void 0 });
  }
}()), re(new class extends ih {
  constructor() {
    super({ inSelectionMode: !1, wordNavigationType: 3, id: "cursorWordAccessibilityLeft", precondition: void 0 });
  }
  _move(i, e, t, n) {
    return super._move(zo(ta.wordSeparators.defaultValue, i.intlSegmenterLocales), e, t, n);
  }
}()), re(new class extends ih {
  constructor() {
    super({ inSelectionMode: !0, wordNavigationType: 3, id: "cursorWordAccessibilityLeftSelect", precondition: void 0 });
  }
  _move(i, e, t, n) {
    return super._move(zo(ta.wordSeparators.defaultValue, i.intlSegmenterLocales), e, t, n);
  }
}()), re(new class extends nh {
  constructor() {
    super({ inSelectionMode: !1, wordNavigationType: 3, id: "cursorWordAccessibilityRight", precondition: void 0 });
  }
  _move(i, e, t, n) {
    return super._move(zo(ta.wordSeparators.defaultValue, i.intlSegmenterLocales), e, t, n);
  }
}()), re(new class extends nh {
  constructor() {
    super({ inSelectionMode: !0, wordNavigationType: 3, id: "cursorWordAccessibilityRightSelect", precondition: void 0 });
  }
  _move(i, e, t, n) {
    return super._move(zo(ta.wordSeparators.defaultValue, i.intlSegmenterLocales), e, t, n);
  }
}()), re(new class extends dN {
  constructor() {
    super({ whitespaceHeuristics: !1, wordNavigationType: 0, id: "deleteWordStartLeft", precondition: E.writable });
  }
}()), re(new class extends dN {
  constructor() {
    super({ whitespaceHeuristics: !1, wordNavigationType: 2, id: "deleteWordEndLeft", precondition: E.writable });
  }
}()), re(new class extends dN {
  constructor() {
    super({ whitespaceHeuristics: !0, wordNavigationType: 0, id: "deleteWordLeft", precondition: E.writable, kbOpts: { kbExpr: E.textInputFocus, primary: 2049, mac: { primary: 513 }, weight: 100 } });
  }
}()), re(new class extends hN {
  constructor() {
    super({ whitespaceHeuristics: !1, wordNavigationType: 0, id: "deleteWordStartRight", precondition: E.writable });
  }
}()), re(new class extends hN {
  constructor() {
    super({ whitespaceHeuristics: !1, wordNavigationType: 2, id: "deleteWordEndRight", precondition: E.writable });
  }
}()), re(new class extends hN {
  constructor() {
    super({ whitespaceHeuristics: !0, wordNavigationType: 2, id: "deleteWordRight", precondition: E.writable, kbOpts: { kbExpr: E.textInputFocus, primary: 2068, mac: { primary: 532 }, weight: 100 } });
  }
}()), X(class extends he {
  constructor() {
    super({ id: "deleteInsideWord", precondition: E.writable, label: m(0, "Delete Word"), alias: "Delete Word" });
  }
  run(i, e, t) {
    if (!e.hasModel()) return;
    const n = zo(e.getOption(131), e.getOption(130)), s = e.getModel(), o = e.getSelections().map((r) => {
      const a = Ct.deleteInsideWord(n, s, r);
      return new Dn(a, "");
    });
    e.pushUndoStop(), e.executeCommands(this.id, o), e.pushUndoStop();
  }
});
class X9 extends Sk {
  _move(e, t, n, s) {
    return uy.moveWordPartLeft(e, t, n);
  }
}
dt.registerCommandAlias("cursorWordPartStartLeft", "cursorWordPartLeft");
dt.registerCommandAlias("cursorWordPartStartLeftSelect", "cursorWordPartLeftSelect");
class Q9 extends Sk {
  _move(e, t, n, s) {
    return uy.moveWordPartRight(e, t, n);
  }
}
re(new class extends AS {
  constructor() {
    super({ whitespaceHeuristics: !0, wordNavigationType: 0, id: "deleteWordPartLeft", precondition: E.writable, kbOpts: { kbExpr: E.textInputFocus, primary: 0, mac: { primary: 769 }, weight: 100 } });
  }
  _delete(i, e) {
    return uy.deleteWordPartLeft(i) || new D(1, 1, 1, 1);
  }
}()), re(new class extends AS {
  constructor() {
    super({ whitespaceHeuristics: !0, wordNavigationType: 2, id: "deleteWordPartRight", precondition: E.writable, kbOpts: { kbExpr: E.textInputFocus, primary: 0, mac: { primary: 788 }, weight: 100 } });
  }
  _delete(i, e) {
    const t = uy.deleteWordPartRight(i);
    if (t) return t;
    const n = i.model.getLineCount(), s = i.model.getLineMaxColumn(n);
    return new D(n, s, n, s);
  }
}()), re(new class extends X9 {
  constructor() {
    super({ inSelectionMode: !1, wordNavigationType: 0, id: "cursorWordPartLeft", precondition: void 0, kbOpts: { kbExpr: E.textInputFocus, primary: 0, mac: { primary: 783 }, weight: 100 } });
  }
}()), re(new class extends X9 {
  constructor() {
    super({ inSelectionMode: !0, wordNavigationType: 0, id: "cursorWordPartLeftSelect", precondition: void 0, kbOpts: { kbExpr: E.textInputFocus, primary: 0, mac: { primary: 1807 }, weight: 100 } });
  }
}()), re(new class extends Q9 {
  constructor() {
    super({ inSelectionMode: !1, wordNavigationType: 2, id: "cursorWordPartRight", precondition: void 0, kbOpts: { kbExpr: E.textInputFocus, primary: 0, mac: { primary: 785 }, weight: 100 } });
  }
}()), re(new class extends Q9 {
  constructor() {
    super({ inSelectionMode: !0, wordNavigationType: 2, id: "cursorWordPartRightSelect", precondition: void 0, kbOpts: { kbExpr: E.textInputFocus, primary: 0, mac: { primary: 1809 }, weight: 100 } });
  }
}());
class cN extends V {
  constructor(e) {
    super(), this.editor = e, this._register(this.editor.onDidAttemptReadOnlyEdit(() => this._onDidAttemptReadOnlyEdit()));
  }
  _onDidAttemptReadOnlyEdit() {
    const e = bs.get(this.editor);
    if (e && this.editor.hasModel()) {
      let t = this.editor.getOptions().get(92);
      t || (t = this.editor.isSimpleWidget ? new Vn(m(0, "Cannot edit in read-only input")) : new Vn(m(0, "Cannot edit in read-only editor"))), e.showMessage(t, this.editor.getPosition());
    }
  }
}
cN.ID = "editor.contrib.readOnlyMessageController", ft(cN.ID, cN, 2);
var Hhe = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, J9 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let uN = class extends V {
  constructor(i, e, t) {
    super(), this._textModel = i, this._languageFeaturesService = e, this._outlineModelService = t, this._currentModel = lt(this, void 0);
    const n = Hn("documentSymbolProvider.onDidChange", this._languageFeaturesService.documentSymbolProvider.onDidChange), s = Hn("_textModel.onDidChangeContent", se.debounce((o) => this._textModel.onDidChangeContent(o), () => {
    }, 100));
    this._register(nr(async (o, r) => {
      n.read(o), s.read(o);
      const a = r.add(new rne()), l = await this._outlineModelService.getOrCreate(this._textModel, a.token);
      r.isDisposed || this._currentModel.set(l, void 0);
    }));
  }
  getBreadcrumbItems(i, e) {
    const t = this._currentModel.read(e);
    if (!t) return [];
    const n = t.asListOfDocumentSymbols().filter((s) => i.contains(s.range.startLineNumber) && !i.contains(s.range.endLineNumber));
    return n.sort(f7(jo((s) => s.range.endLineNumber - s.range.startLineNumber, od))), n.map((s) => ({ name: s.name, kind: s.kind, startLineNumber: s.range.startLineNumber }));
  }
};
uN = Hhe([J9(1, fe), J9(2, n1)], uN), w0.setBreadcrumbsSourceFactory((i, e) => e.createInstance(uN, i));
class BT extends V {
  constructor(e) {
    super(), this.editor = e, this.widget = null, ua && (this._register(e.onDidChangeConfiguration(() => this.update())), this.update());
  }
  update() {
    const e = !this.editor.getOption(91);
    !this.widget && e ? this.widget = new Lk(this.editor) : this.widget && !e && (this.widget.dispose(), this.widget = null);
  }
  dispose() {
    super.dispose(), this.widget && (this.widget.dispose(), this.widget = null);
  }
}
BT.ID = "editor.contrib.iPadShowKeyboard";
class Lk extends V {
  constructor(e) {
    super(), this.editor = e, this._domNode = document.createElement("textarea"), this._domNode.className = "iPadShowKeyboard", this._register(K(this._domNode, "touchstart", (t) => {
      this.editor.focus();
    })), this._register(K(this._domNode, "focus", (t) => {
      this.editor.focus();
    })), this.editor.addOverlayWidget(this);
  }
  dispose() {
    this.editor.removeOverlayWidget(this), super.dispose();
  }
  getId() {
    return Lk.ID;
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return { preference: 1 };
  }
}
Lk.ID = "editor.contrib.ShowKeyboardWidget", ft(BT.ID, BT, 3);
var WT, zhe = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, e7 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let Rm = WT = class extends V {
  static get(i) {
    return i.getContribution(WT.ID);
  }
  constructor(i, e, t) {
    super(), this._editor = i, this._languageService = t, this._widget = null, this._register(this._editor.onDidChangeModel((n) => this.stop())), this._register(this._editor.onDidChangeModelLanguage((n) => this.stop())), this._register(ci.onDidChange((n) => this.stop())), this._register(this._editor.onKeyUp((n) => n.keyCode === 9 && this.stop()));
  }
  dispose() {
    this.stop(), super.dispose();
  }
  launch() {
    this._widget || this._editor.hasModel() && (this._widget = new kk(this._editor, this._languageService));
  }
  stop() {
    this._widget && (this._widget.dispose(), this._widget = null);
  }
};
Rm.ID = "editor.contrib.inspectTokens", Rm = WT = zhe([e7(1, Ro), e7(2, Xt)], Rm);
class kk extends V {
  constructor(e, t) {
    super(), this.allowEditorOverflow = !0, this._editor = e, this._languageService = t, this._model = this._editor.getModel(), this._domNode = document.createElement("div"), this._domNode.className = "tokens-inspect-widget", this._tokenizationSupport = function(n, s) {
      const o = ci.get(s);
      if (o) return o;
      const r = n.encodeLanguageId(s);
      return { getInitialState: () => zm, tokenize: (a, l, d) => IR(s, d), tokenizeEncoded: (a, l, d) => sL(r, d) };
    }(this._languageService.languageIdCodec, this._model.getLanguageId()), this._compute(this._editor.getPosition()), this._register(this._editor.onDidChangeCursorPosition((n) => this._compute(this._editor.getPosition()))), this._editor.addContentWidget(this);
  }
  dispose() {
    this._editor.removeContentWidget(this), super.dispose();
  }
  getId() {
    return kk._ID;
  }
  _compute(e) {
    const t = this._getTokensAtLine(e.lineNumber);
    let n = 0;
    for (let l = t.tokens1.length - 1; l >= 0; l--) {
      const d = t.tokens1[l];
      if (e.column - 1 >= d.offset) {
        n = l;
        break;
      }
    }
    let s = 0;
    for (let l = t.tokens2.length >>> 1; l >= 0; l--) if (e.column - 1 >= t.tokens2[l << 1]) {
      s = l;
      break;
    }
    const o = this._model.getLineContent(e.lineNumber);
    let r = "";
    if (n < t.tokens1.length) {
      const l = t.tokens1[n].offset, d = n + 1 < t.tokens1.length ? t.tokens1[n + 1].offset : o.length;
      r = o.substring(l, d);
    }
    wn(this._domNode, Q("h2.tm-token", void 0, function(l) {
      let d = "";
      for (let h = 0, c = l.length; h < c; h++) {
        const u = l.charCodeAt(h);
        switch (u) {
          case 9:
            d += "→";
            break;
          case 32:
            d += "·";
            break;
          default:
            d += String.fromCharCode(u);
        }
      }
      return d;
    }(r), Q("span.tm-token-length", void 0, `${r.length} ${r.length === 1 ? "char" : "chars"}`))), Z(this._domNode, Q("hr.tokens-inspect-separator", { style: "clear:both" }));
    const a = 1 + (s << 1) < t.tokens2.length ? this._decodeMetadata(t.tokens2[1 + (s << 1)]) : null;
    Z(this._domNode, Q("table.tm-metadata-table", void 0, Q("tbody", void 0, Q("tr", void 0, Q("td.tm-metadata-key", void 0, "language"), Q("td.tm-metadata-value", void 0, `${a ? a.languageId : "-?-"}`)), Q("tr", void 0, Q("td.tm-metadata-key", void 0, "token type"), Q("td.tm-metadata-value", void 0, `${a ? this._tokenTypeToString(a.tokenType) : "-?-"}`)), Q("tr", void 0, Q("td.tm-metadata-key", void 0, "font style"), Q("td.tm-metadata-value", void 0, `${a ? this._fontStyleToString(a.fontStyle) : "-?-"}`)), Q("tr", void 0, Q("td.tm-metadata-key", void 0, "foreground"), Q("td.tm-metadata-value", void 0, `${a ? z.Format.CSS.formatHex(a.foreground) : "-?-"}`)), Q("tr", void 0, Q("td.tm-metadata-key", void 0, "background"), Q("td.tm-metadata-value", void 0, `${a ? z.Format.CSS.formatHex(a.background) : "-?-"}`))))), Z(this._domNode, Q("hr.tokens-inspect-separator")), n < t.tokens1.length && Z(this._domNode, Q("span.tm-token-type", void 0, t.tokens1[n].type)), this._editor.layoutContentWidget(this);
  }
  _decodeMetadata(e) {
    const t = ci.getColorMap(), n = In.getLanguageId(e), s = In.getTokenType(e), o = In.getFontStyle(e), r = In.getForeground(e), a = In.getBackground(e);
    return { languageId: this._languageService.languageIdCodec.decodeLanguageId(n), tokenType: s, fontStyle: o, foreground: t[r], background: t[a] };
  }
  _tokenTypeToString(e) {
    switch (e) {
      case 0:
        return "Other";
      case 1:
        return "Comment";
      case 2:
        return "String";
      case 3:
        return "RegEx";
      default:
        return "??";
    }
  }
  _fontStyleToString(e) {
    let t = "";
    return 1 & e && (t += "italic "), 2 & e && (t += "bold "), 4 & e && (t += "underline "), 8 & e && (t += "strikethrough "), t.length === 0 && (t = "---"), t;
  }
  _getTokensAtLine(e) {
    const t = this._getStateBeforeLine(e), n = this._tokenizationSupport.tokenize(this._model.getLineContent(e), !0, t), s = this._tokenizationSupport.tokenizeEncoded(this._model.getLineContent(e), !0, t);
    return { startState: t, tokens1: n.tokens, tokens2: s.tokens, endState: n.endState };
  }
  _getStateBeforeLine(e) {
    let t = this._tokenizationSupport.getInitialState();
    for (let n = 1; n < e; n++)
      t = this._tokenizationSupport.tokenize(this._model.getLineContent(n), !0, t).endState;
    return t;
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return { position: this._editor.getPosition(), preference: [2, 1] };
  }
}
kk._ID = "editor.contrib.inspectTokensWidget", ft(Rm.ID, Rm, 4), X(class extends he {
  constructor() {
    super({ id: "editor.action.inspectTokens", label: zI.inspectTokensAction, alias: "Developer: Inspect Tokens", precondition: void 0 });
  }
  run(i, e) {
    const t = Rm.get(e);
    t == null || t.launch();
  }
});
var $_, Uhe = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, t7 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let kC = $_ = class {
  constructor(i, e) {
    this.quickInputService = i, this.keybindingService = e, this.registry = li.as(Ag);
  }
  provide(i) {
    const e = new G();
    return e.add(i.onDidAccept(() => {
      const [t] = i.selectedItems;
      t && this.quickInputService.quickAccess.show(t.prefix, { preserveValue: !0 });
    })), e.add(i.onDidChangeValue((t) => {
      const n = this.registry.getQuickAccessProvider(t.substr($_.PREFIX.length));
      n && n.prefix && n.prefix !== $_.PREFIX && this.quickInputService.quickAccess.show(n.prefix, { preserveValue: !0 });
    })), i.items = this.getQuickAccessProviders().filter((t) => t.prefix !== $_.PREFIX), e;
  }
  getQuickAccessProviders() {
    return this.registry.getQuickAccessProviders().sort((i, e) => i.prefix.localeCompare(e.prefix)).flatMap((i) => this.createPicks(i));
  }
  createPicks(i) {
    return i.helpEntries.map((e) => {
      const t = e.prefix || i.prefix, n = t || "…";
      return { prefix: t, label: n, keybinding: e.commandId ? this.keybindingService.lookupKeybinding(e.commandId) : void 0, ariaLabel: m(0, "{0}, {1}", n, e.description), description: e.description };
    });
  }
};
kC.PREFIX = "?", kC = $_ = Uhe([t7(0, La), t7(1, Dt)], kC), li.as(Ag).registerQuickAccessProvider({ ctor: kC, prefix: "", helpEntries: [{ description: UI.helpQuickAccessActionLabel }] });
class EU {
  constructor(e) {
    this.options = e, this.rangeHighlightDecorationId = void 0;
  }
  provide(e, t) {
    var n;
    const s = new G();
    e.canAcceptInBackground = !!(!((n = this.options) === null || n === void 0) && n.canAcceptInBackground), e.matchOnLabel = e.matchOnDescription = e.matchOnDetail = e.sortByLabel = !1;
    const o = s.add(new rn());
    return o.value = this.doProvide(e, t), s.add(this.onDidActiveTextEditorControlChange(() => {
      o.value = void 0, o.value = this.doProvide(e, t);
    })), s;
  }
  doProvide(e, t) {
    var n;
    const s = new G(), o = this.activeTextEditorControl;
    if (o && this.canProvideWithTextEditor(o)) {
      const r = { editor: o }, a = nH(o);
      if (a) {
        let l = (n = o.saveViewState()) !== null && n !== void 0 ? n : void 0;
        s.add(a.onDidChangeCursorPosition(() => {
          var d;
          l = (d = o.saveViewState()) !== null && d !== void 0 ? d : void 0;
        })), r.restoreViewState = () => {
          l && o === this.activeTextEditorControl && o.restoreViewState(l);
        }, s.add(mc(t.onCancellationRequested)(() => {
          var d;
          return (d = r.restoreViewState) === null || d === void 0 ? void 0 : d.call(r);
        }));
      }
      s.add(ye(() => this.clearDecorations(o))), s.add(this.provideWithTextEditor(r, e, t));
    } else s.add(this.provideWithoutTextEditor(e, t));
    return s;
  }
  canProvideWithTextEditor(e) {
    return !0;
  }
  gotoLocation({ editor: e }, t) {
    e.setSelection(t.range, "code.jump"), e.revealRangeInCenter(t.range, 0), t.preserveFocus || e.focus();
    const n = e.getModel();
    n && "getLineContent" in n && vl(`${n.getLineContent(t.range.startLineNumber)}`);
  }
  getModel(e) {
    var t;
    return rP(e) ? (t = e.getModel()) === null || t === void 0 ? void 0 : t.modified : e.getModel();
  }
  addDecorations(e, t) {
    e.changeDecorations((n) => {
      const s = [];
      this.rangeHighlightDecorationId && (s.push(this.rangeHighlightDecorationId.overviewRulerDecorationId), s.push(this.rangeHighlightDecorationId.rangeHighlightId), this.rangeHighlightDecorationId = void 0);
      const o = [{ range: t, options: { description: "quick-access-range-highlight", className: "rangeHighlight", isWholeLine: !0 } }, { range: t, options: { description: "quick-access-range-highlight-overview", overviewRuler: { color: ui(IB), position: Do.Full } } }], [r, a] = n.deltaDecorations(s, o);
      this.rangeHighlightDecorationId = { rangeHighlightId: r, overviewRulerDecorationId: a };
    });
  }
  clearDecorations(e) {
    const t = this.rangeHighlightDecorationId;
    t && (e.changeDecorations((n) => {
      n.deltaDecorations([t.overviewRulerDecorationId, t.rangeHighlightId], []);
    }), this.rangeHighlightDecorationId = void 0);
  }
}
class Dk extends EU {
  constructor() {
    super({ canAcceptInBackground: !0 });
  }
  provideWithoutTextEditor(e) {
    const t = m(0, "Open a text editor first to go to a line.");
    return e.items = [{ label: t }], e.ariaLabel = t, V.None;
  }
  provideWithTextEditor(e, t, n) {
    const s = e.editor, o = new G();
    o.add(t.onDidAccept((l) => {
      const [d] = t.selectedItems;
      if (d) {
        if (!this.isValidLineNumber(s, d.lineNumber)) return;
        this.gotoLocation(e, { range: this.toRange(d.lineNumber, d.column), keyMods: t.keyMods, preserveFocus: l.inBackground }), l.inBackground || t.hide();
      }
    }));
    const r = () => {
      const l = this.parsePosition(s, t.value.trim().substr(Dk.PREFIX.length)), d = this.getPickLabel(s, l.lineNumber, l.column);
      if (t.items = [{ lineNumber: l.lineNumber, column: l.column, label: d }], t.ariaLabel = d, !this.isValidLineNumber(s, l.lineNumber)) return void this.clearDecorations(s);
      const h = this.toRange(l.lineNumber, l.column);
      s.revealRangeInCenter(h, 0), this.addDecorations(s, h);
    };
    r(), o.add(t.onDidChangeValue(() => r()));
    const a = nH(s);
    return a && a.getOptions().get(68).renderType === 2 && (a.updateOptions({ lineNumbers: "on" }), o.add(ye(() => a.updateOptions({ lineNumbers: "relative" })))), o;
  }
  toRange(e = 1, t = 1) {
    return { startLineNumber: e, startColumn: t, endLineNumber: e, endColumn: t };
  }
  parsePosition(e, t) {
    const n = t.split(/,|:|#/).map((o) => parseInt(o, 10)).filter((o) => !isNaN(o)), s = this.lineCount(e) + 1;
    return { lineNumber: n[0] > 0 ? n[0] : s + n[0], column: n[1] };
  }
  getPickLabel(e, t, n) {
    if (this.isValidLineNumber(e, t)) return this.isValidColumn(e, t, n) ? m(0, "Go to line {0} and character {1}.", t, n) : m(0, "Go to line {0}.", t);
    const s = e.getPosition() || { lineNumber: 1, column: 1 }, o = this.lineCount(e);
    return o > 1 ? m(0, "Current Line: {0}, Character: {1}. Type a line number between 1 and {2} to navigate to.", s.lineNumber, s.column, o) : m(0, "Current Line: {0}, Character: {1}. Type a line number to navigate to.", s.lineNumber, s.column);
  }
  isValidLineNumber(e, t) {
    return !(!t || typeof t != "number") && t > 0 && t <= this.lineCount(e);
  }
  isValidColumn(e, t, n) {
    if (!n || typeof n != "number") return !1;
    const s = this.getModel(e);
    if (!s) return !1;
    const o = { lineNumber: t, column: n };
    return s.validatePosition(o).equals(o);
  }
  lineCount(e) {
    var t, n;
    return (n = (t = this.getModel(e)) === null || t === void 0 ? void 0 : t.getLineCount()) !== null && n !== void 0 ? n : 0;
  }
}
Dk.PREFIX = ":";
var Khe = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, jhe = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let u1 = class extends Dk {
  constructor(i) {
    super(), this.editorService = i, this.onDidActiveTextEditorControlChange = se.None;
  }
  get activeTextEditorControl() {
    var i;
    return (i = this.editorService.getFocusedCodeEditor()) !== null && i !== void 0 ? i : void 0;
  }
};
u1 = Khe([jhe(0, mt)], u1);
let gN = class IU extends he {
  constructor() {
    super({ id: IU.ID, label: Ry.gotoLineActionLabel, alias: "Go to Line/Column...", precondition: void 0, kbOpts: { kbExpr: E.focus, primary: 2085, mac: { primary: 293 }, weight: 100 } });
  }
  run(e) {
    e.get(La).quickAccess.show(u1.PREFIX);
  }
};
gN.ID = "editor.action.gotoLine", X(gN), li.as(Ag).registerQuickAccessProvider({ ctor: u1, prefix: u1.PREFIX, helpEntries: [{ description: Ry.gotoLineActionLabel, commandId: gN.ID }] });
const MU = [void 0, []];
function pN(i, e, t = 0, n = 0) {
  const s = e;
  return s.values && s.values.length > 1 ? function(o, r, a, l) {
    let d = 0;
    const h = [];
    for (const c of r) {
      const [u, g] = i7(o, c, a, l);
      if (typeof u != "number") return MU;
      d += u, h.push(...g);
    }
    return [d, qhe(h)];
  }(i, s.values, t, n) : i7(i, e, t, n);
}
function i7(i, e, t, n) {
  const s = pg(e.original, e.originalLowercase, t, i, i.toLowerCase(), n, { firstMatchCanBeWeak: !0, boostFullMatch: !0 });
  return s ? [s[0], T1(s)] : MU;
}
function qhe(i) {
  const e = i.sort((s, o) => s.start - o.start), t = [];
  let n;
  for (const s of e) n && $he(n, s) ? (n.start = Math.min(n.start, s.start), n.end = Math.max(n.end, s.end)) : (n = s, t.push(s));
  return t;
}
function $he(i, e) {
  return !(i.end < e.start) && !(e.end < i.start);
}
function n7(i) {
  return i.startsWith('"') && i.endsWith('"');
}
const TU = " ";
function VT(i) {
  typeof i != "string" && (i = "");
  const e = i.toLowerCase(), { pathNormalized: t, normalized: n, normalizedLowercase: s } = s7(i), o = t.indexOf(oa) >= 0, r = n7(i);
  let a;
  const l = i.split(TU);
  if (l.length > 1) for (const d of l) {
    const h = n7(d), { pathNormalized: c, normalized: u, normalizedLowercase: g } = s7(d);
    u && (a || (a = []), a.push({ original: d, originalLowercase: d.toLowerCase(), pathNormalized: c, normalized: u, normalizedLowercase: g, expectContiguousMatch: h }));
  }
  return { original: i, originalLowercase: e, pathNormalized: t, normalized: n, normalizedLowercase: s, values: a, containsPathSeparator: o, expectContiguousMatch: r };
}
function s7(i) {
  let e;
  e = Tn ? i.replace(/\//g, oa) : i.replace(/\\/g, oa);
  const t = (n = e, n.replace(/\*/g, "")).replace(/\s|"/g, "");
  var n;
  return { pathNormalized: e, normalized: t, normalizedLowercase: t.toLowerCase() };
}
function o7(i) {
  return Array.isArray(i) ? VT(i.map((e) => e.original).join(TU)) : VT(i.original);
}
var Am, Ghe = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, r7 = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let il = Am = class extends EU {
  constructor(i, e, t = /* @__PURE__ */ Object.create(null)) {
    super(t), this._languageFeaturesService = i, this._outlineModelService = e, this.options = t, this.options.canAcceptInBackground = !0;
  }
  provideWithoutTextEditor(i) {
    return this.provideLabelPick(i, m(0, "To go to a symbol, first open a text editor with symbol information.")), V.None;
  }
  provideWithTextEditor(i, e, t) {
    const n = i.editor, s = this.getModel(n);
    return s ? this._languageFeaturesService.documentSymbolProvider.has(s) ? this.doProvideWithEditorSymbols(i, s, e, t) : this.doProvideWithoutEditorSymbols(i, s, e, t) : V.None;
  }
  doProvideWithoutEditorSymbols(i, e, t, n) {
    const s = new G();
    return this.provideLabelPick(t, m(0, "The active text editor does not provide symbol information.")), (async () => await this.waitForLanguageSymbolRegistry(e, s) && !n.isCancellationRequested && s.add(this.doProvideWithEditorSymbols(i, e, t, n)))(), s;
  }
  provideLabelPick(i, e) {
    i.items = [{ label: e, index: 0, kind: 14 }], i.ariaLabel = e;
  }
  async waitForLanguageSymbolRegistry(i, e) {
    if (this._languageFeaturesService.documentSymbolProvider.has(i)) return !0;
    const t = new b1(), n = e.add(this._languageFeaturesService.documentSymbolProvider.onDidChange(() => {
      this._languageFeaturesService.documentSymbolProvider.has(i) && (n.dispose(), t.complete(!0));
    }));
    return e.add(ye(() => t.complete(!1))), t.p;
  }
  doProvideWithEditorSymbols(i, e, t, n) {
    var s;
    const o = i.editor, r = new G();
    r.add(t.onDidAccept((h) => {
      const [c] = t.selectedItems;
      c && c.range && (this.gotoLocation(i, { range: c.range.selection, keyMods: t.keyMods, preserveFocus: h.inBackground }), h.inBackground || t.hide());
    })), r.add(t.onDidTriggerItemButton(({ item: h }) => {
      h && h.range && (this.gotoLocation(i, { range: h.range.selection, keyMods: t.keyMods, forceSideBySide: !0 }), t.hide());
    }));
    const a = this.getDocumentSymbols(e, n);
    let l;
    const d = async (h) => {
      l == null || l.dispose(!0), t.busy = !1, l = new Ci(n), t.busy = !0;
      try {
        const c = VT(t.value.substr(Am.PREFIX.length).trim()), u = await this.doGetSymbolPicks(a, c, void 0, l.token);
        if (n.isCancellationRequested) return;
        if (u.length > 0) {
          if (t.items = u, h && c.original.length === 0) {
            const g = sv(u, (p) => !!(p.type !== "separator" && p.range && D.containsPosition(p.range.decoration, h)));
            g && (t.activeItems = [g]);
          }
        } else c.original.length > 0 ? this.provideLabelPick(t, m(0, "No matching editor symbols")) : this.provideLabelPick(t, m(0, "No editor symbols"));
      } finally {
        n.isCancellationRequested || (t.busy = !1);
      }
    };
    return r.add(t.onDidChangeValue(() => d(void 0))), d((s = o.getSelection()) === null || s === void 0 ? void 0 : s.getPosition()), r.add(t.onDidChangeActive(() => {
      const [h] = t.activeItems;
      h && h.range && (o.revealRangeInCenter(h.range.selection, 0), this.addDecorations(o, h.range.decoration));
    })), r;
  }
  async doGetSymbolPicks(i, e, t, n) {
    var s, o;
    const r = await i;
    if (n.isCancellationRequested) return [];
    const a = e.original.indexOf(Am.SCOPE_PREFIX) === 0, l = a ? 1 : 0;
    let d, h, c;
    e.values && e.values.length > 1 ? (d = o7(e.values[0]), h = o7(e.values.slice(1))) : d = e;
    const u = (o = (s = this.options) === null || s === void 0 ? void 0 : s.openSideBySideDirection) === null || o === void 0 ? void 0 : o.call(s);
    u && (c = [{ iconClass: u === "right" ? Ee.asClassName(ne.splitHorizontal) : Ee.asClassName(ne.splitVertical), tooltip: m(0, u === "right" ? "Open to the Side" : "Open to the Bottom") }]);
    const g = [];
    for (let b = 0; b < r.length; b++) {
      const C = r[b], w = xK(C.name), y = `$(${Ow.toIcon(C.kind).id}) ${w}`, L = y.length - w.length;
      let k, N, A, B, T = C.containerName;
      if (t != null && t.extraContainerLabel && (T = T ? `${t.extraContainerLabel} • ${T}` : t.extraContainerLabel), e.original.length > l) {
        let H = !1;
        if (d !== e && ([k, N] = pN(y, { ...e, values: void 0 }, l, L), typeof k == "number" && (H = !0)), typeof k != "number" && ([k, N] = pN(y, d, l, L), typeof k != "number")) continue;
        if (!H && h) {
          if (T && h.original.length > 0 && ([A, B] = pN(T, h)), typeof A != "number") continue;
          typeof k == "number" && (k += A);
        }
      }
      const O = C.tags && C.tags.indexOf(1) >= 0;
      g.push({ index: b, kind: C.kind, score: k, label: y, ariaLabel: (p = C.name, f = C.kind, m(0, "{0} ({1})", p, LK[f])), description: T, highlights: O ? void 0 : { label: N, description: B }, range: { selection: D.collapseToStart(C.selectionRange), decoration: C.range }, strikethrough: O, buttons: c });
    }
    var p, f;
    const _ = g.sort((b, C) => a ? this.compareByKindAndScore(b, C) : this.compareByScore(b, C));
    let v = [];
    if (a) {
      let y = function() {
        C && typeof b == "number" && w > 0 && (C.label = rg(fN[b] || mN, w));
      }, b, C, w = 0;
      for (const L of _) b !== L.kind ? (y(), b = L.kind, w = 1, C = { type: "separator" }, v.push(C)) : w++, v.push(L);
      y();
    } else _.length > 0 && (v = [{ label: m(0, "symbols ({0})", g.length), type: "separator" }, ..._]);
    return v;
  }
  compareByScore(i, e) {
    if (typeof i.score != "number" && typeof e.score == "number") return 1;
    if (typeof i.score == "number" && typeof e.score != "number") return -1;
    if (typeof i.score == "number" && typeof e.score == "number") {
      if (i.score > e.score) return -1;
      if (i.score < e.score) return 1;
    }
    return i.index < e.index ? -1 : i.index > e.index ? 1 : 0;
  }
  compareByKindAndScore(i, e) {
    const t = fN[i.kind] || mN, n = fN[e.kind] || mN, s = t.localeCompare(n);
    return s === 0 ? this.compareByScore(i, e) : s;
  }
  async getDocumentSymbols(i, e) {
    const t = await this._outlineModelService.getOrCreate(i, e);
    return e.isCancellationRequested ? [] : t.asListOfDocumentSymbols();
  }
};
il.PREFIX = "@", il.SCOPE_PREFIX = ":", il.PREFIX_BY_CATEGORY = `${Am.PREFIX}${Am.SCOPE_PREFIX}`, il = Am = Ghe([r7(0, fe), r7(1, n1)], il);
const mN = m(0, "properties ({0})"), fN = { 5: m(0, "methods ({0})"), 11: m(0, "functions ({0})"), 8: m(0, "constructors ({0})"), 12: m(0, "variables ({0})"), 4: m(0, "classes ({0})"), 22: m(0, "structs ({0})"), 23: m(0, "events ({0})"), 24: m(0, "operators ({0})"), 10: m(0, "interfaces ({0})"), 2: m(0, "namespaces ({0})"), 3: m(0, "packages ({0})"), 25: m(0, "type parameters ({0})"), 1: m(0, "modules ({0})"), 6: m(0, "properties ({0})"), 9: m(0, "enumerations ({0})"), 21: m(0, "enumeration members ({0})"), 14: m(0, "strings ({0})"), 0: m(0, "files ({0})"), 17: m(0, "arrays ({0})"), 15: m(0, "numbers ({0})"), 16: m(0, "booleans ({0})"), 18: m(0, "objects ({0})"), 19: m(0, "keys ({0})"), 7: m(0, "fields ({0})"), 13: m(0, "constants ({0})") };
var Zhe = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, _N = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let HT = class extends il {
  constructor(i, e, t) {
    super(e, t), this.editorService = i, this.onDidActiveTextEditorControlChange = se.None;
  }
  get activeTextEditorControl() {
    var i;
    return (i = this.editorService.getFocusedCodeEditor()) !== null && i !== void 0 ? i : void 0;
  }
};
HT = Zhe([_N(0, mt), _N(1, fe), _N(2, n1)], HT);
class V0 extends he {
  constructor() {
    super({ id: V0.ID, label: Ev.quickOutlineActionLabel, alias: "Go to Symbol...", precondition: E.hasDocumentSymbolProvider, kbOpts: { kbExpr: E.focus, primary: 3117, weight: 100 }, contextMenuOpts: { group: "navigation", order: 3 } });
  }
  run(e) {
    e.get(La).quickAccess.show(il.PREFIX, { itemActivation: Kr.NONE });
  }
}
function vN(i, e) {
  return e && (i.stack || i.stacktrace) ? m(0, "{0}: {1}", l7(i), a7(i.stack) || a7(i.stacktrace)) : l7(i);
}
function a7(i) {
  return Array.isArray(i) ? i.join(`
`) : i;
}
function l7(i) {
  return i.code === "ERR_UNC_HOST_NOT_ALLOWED" ? `${i.message}. Please update the 'security.allowedUNCHosts' setting if you want to allow this host.` : typeof i.code == "string" && typeof i.errno == "number" && typeof i.syscall == "string" ? m(0, "A system error occurred ({0})", i.message) : i.message || m(0, "An unknown error occurred. Please consult the log for more details.");
}
function RU(i = null, e = !1) {
  if (!i) return m(0, "An unknown error occurred. Please consult the log for more details.");
  if (Array.isArray(i)) {
    const t = ca(i), n = RU(t[0], e);
    return t.length > 1 ? m(0, "{0} ({1} errors in total)", n, t.length) : n;
  }
  if (ps(i)) return i;
  if (i.detail) {
    const t = i.detail;
    if (t.error) return vN(t.error, e);
    if (t.exception) return vN(t.exception, e);
  }
  return i.stack ? vN(i, e) : i.message ? i.message : m(0, "An unknown error occurred. Please consult the log for more details.");
}
V0.ID = "editor.action.quickOutline", X(V0), li.as(Ag).registerQuickAccessProvider({ ctor: HT, prefix: il.PREFIX, helpEntries: [{ description: Ev.quickOutlineActionLabel, prefix: il.PREFIX, commandId: V0.ID }, { description: Ev.quickOutlineByCategoryActionLabel, prefix: il.PREFIX_BY_CATEGORY }] });
class H0 {
  constructor() {
    this.chunkCount = 0, this.chunkOccurrences = /* @__PURE__ */ new Map(), this.documents = /* @__PURE__ */ new Map();
  }
  calculateScores(e, t) {
    const n = this.computeEmbedding(e), s = /* @__PURE__ */ new Map(), o = [];
    for (const [r, a] of this.documents) {
      if (t.isCancellationRequested) return [];
      for (const l of a.chunks) {
        const d = this.computeSimilarityScore(l, n, s);
        d > 0 && o.push({ key: r, score: d });
      }
    }
    return o;
  }
  static termFrequencies(e) {
    return function(t) {
      var n;
      const s = /* @__PURE__ */ new Map();
      for (const o of t) s.set(o, ((n = s.get(o)) !== null && n !== void 0 ? n : 0) + 1);
      return s;
    }(H0.splitTerms(e));
  }
  static *splitTerms(e) {
    const t = (n) => n.toLowerCase();
    for (const [n] of e.matchAll(new RegExp("\\b\\p{Letter}[\\p{Letter}\\d]{2,}\\b", "gu"))) {
      yield t(n);
      const s = n.replace(/([a-z])([A-Z])/g, "$1 $2").split(/\s+/g);
      if (s.length > 1) for (const o of s) o.length > 2 && new RegExp("\\p{Letter}{3,}", "gu").test(o) && (yield t(o));
    }
  }
  updateDocuments(e) {
    var t;
    for (const { key: n } of e) this.deleteDocument(n);
    for (const n of e) {
      const s = [];
      for (const o of n.textChunks) {
        const r = H0.termFrequencies(o);
        for (const a of r.keys()) this.chunkOccurrences.set(a, ((t = this.chunkOccurrences.get(a)) !== null && t !== void 0 ? t : 0) + 1);
        s.push({ text: o, tf: r });
      }
      this.chunkCount += s.length, this.documents.set(n.key, { chunks: s });
    }
    return this;
  }
  deleteDocument(e) {
    const t = this.documents.get(e);
    if (t) {
      this.documents.delete(e), this.chunkCount -= t.chunks.length;
      for (const n of t.chunks) for (const s of n.tf.keys()) {
        const o = this.chunkOccurrences.get(s);
        if (typeof o == "number") {
          const r = o - 1;
          r <= 0 ? this.chunkOccurrences.delete(s) : this.chunkOccurrences.set(s, r);
        }
      }
    }
  }
  computeSimilarityScore(e, t, n) {
    let s = 0;
    for (const [o, r] of Object.entries(t)) {
      const a = e.tf.get(o);
      if (!a) continue;
      let l = n.get(o);
      typeof l != "number" && (l = this.computeIdf(o), n.set(o, l)), s += a * l * r;
    }
    return s;
  }
  computeEmbedding(e) {
    const t = H0.termFrequencies(e);
    return this.computeTfidf(t);
  }
  computeIdf(e) {
    var t;
    const n = (t = this.chunkOccurrences.get(e)) !== null && t !== void 0 ? t : 0;
    return n > 0 ? Math.log((this.chunkCount + 1) / n) : 0;
  }
  computeTfidf(e) {
    const t = /* @__PURE__ */ Object.create(null);
    for (const [n, s] of e) {
      const o = this.computeIdf(n);
      o > 0 && (t[n] = s * o);
    }
    return t;
  }
}
var Yp;
function bN(i) {
  const e = i;
  return Array.isArray(e.items);
}
function d7(i) {
  const e = i;
  return !!e.picks && e.additionalPicks instanceof Promise;
}
(function(i) {
  i[i.NO_ACTION = 0] = "NO_ACTION", i[i.CLOSE_PICKER = 1] = "CLOSE_PICKER", i[i.REFRESH_PICKER = 2] = "REFRESH_PICKER", i[i.REMOVE_ITEM = 3] = "REMOVE_ITEM";
})(Yp || (Yp = {}));
class Yhe extends V {
  constructor(e, t) {
    super(), this.prefix = e, this.options = t;
  }
  provide(e, t, n) {
    var s;
    const o = new G();
    let r;
    e.canAcceptInBackground = !!(!((s = this.options) === null || s === void 0) && s.canAcceptInBackground), e.matchOnLabel = e.matchOnDescription = e.matchOnDetail = e.sortByLabel = !1;
    const a = o.add(new rn()), l = async () => {
      var h;
      const c = a.value = new G();
      r == null || r.dispose(!0), e.busy = !1, r = new Ci(t);
      const u = r.token;
      let g = e.value.substring(this.prefix.length);
      !((h = this.options) === null || h === void 0) && h.shouldSkipTrimPickFilter || (g = g.trim());
      const p = this._getPicks(g, c, u, n), f = (v, b) => {
        var C;
        let w, y;
        if (bN(v) ? (w = v.items, y = v.active) : w = v, w.length === 0) {
          if (b) return !1;
          (g.length > 0 || e.hideInput) && (!((C = this.options) === null || C === void 0) && C.noResultsPick) && (w = j0(this.options.noResultsPick) ? [this.options.noResultsPick(g)] : [this.options.noResultsPick]);
        }
        return e.items = w, y && (e.activeItems = [y]), !0;
      }, _ = async (v) => {
        let b = !1, C = !1;
        await Promise.all([(async () => {
          typeof v.mergeDelay == "number" && (await bc(v.mergeDelay), u.isCancellationRequested) || C || (b = f(v.picks, !0));
        })(), (async () => {
          e.busy = !0;
          try {
            const w = await v.additionalPicks;
            if (u.isCancellationRequested) return;
            let y, L, k, N;
            if (bN(v.picks) ? (y = v.picks.items, L = v.picks.active) : y = v.picks, bN(w) ? (k = w.items, N = w.active) : k = w, k.length > 0 || !b) {
              let A;
              if (!L && !N) {
                const B = e.activeItems[0];
                B && y.indexOf(B) !== -1 && (A = B);
              }
              f({ items: [...y, ...k], active: L || N || A });
            }
          } finally {
            u.isCancellationRequested || (e.busy = !1), C = !0;
          }
        })()]);
      };
      if (p !== null) if (d7(p)) await _(p);
      else if (p instanceof Promise) {
        e.busy = !0;
        try {
          const v = await p;
          if (u.isCancellationRequested) return;
          d7(v) ? await _(v) : f(v);
        } finally {
          u.isCancellationRequested || (e.busy = !1);
        }
      } else f(p);
    };
    o.add(e.onDidChangeValue(() => l())), l(), o.add(e.onDidAccept((h) => {
      const [c] = e.selectedItems;
      typeof (c == null ? void 0 : c.accept) == "function" && (h.inBackground || e.hide(), c.accept(e.keyMods, h));
    }));
    const d = async (h, c) => {
      var u, g;
      if (typeof c.trigger != "function") return;
      const p = (g = (u = c.buttons) === null || u === void 0 ? void 0 : u.indexOf(h)) !== null && g !== void 0 ? g : -1;
      if (p >= 0) {
        const f = c.trigger(p, e.keyMods), _ = typeof f == "number" ? f : await f;
        if (t.isCancellationRequested) return;
        switch (_) {
          case Yp.NO_ACTION:
            break;
          case Yp.CLOSE_PICKER:
            e.hide();
            break;
          case Yp.REFRESH_PICKER:
            l();
            break;
          case Yp.REMOVE_ITEM: {
            const v = e.items.indexOf(c);
            if (v !== -1) {
              const b = e.items.slice(), C = b.splice(v, 1), w = e.activeItems.filter((L) => L !== C[0]), y = e.keepScrollPosition;
              e.keepScrollPosition = !0, e.items = b, w && (e.activeItems = w), e.keepScrollPosition = y;
            }
            break;
          }
        }
      }
    };
    return o.add(e.onDidTriggerItemButton(({ button: h, item: c }) => d(h, c))), o.add(e.onDidTriggerSeparatorButton(({ button: h, separator: c }) => d(h, c))), o;
  }
}
var uu, Bi, AU = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, Dh = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let gu = uu = class extends Yhe {
  constructor(i, e, t, n, s, o) {
    super(uu.PREFIX, i), this.instantiationService = e, this.keybindingService = t, this.commandService = n, this.telemetryService = s, this.dialogService = o, this.commandsHistory = this._register(this.instantiationService.createInstance(gh)), this.options = i;
  }
  async _getPicks(i, e, t, n) {
    var s, o, r, a;
    const l = await this.getCommandPicks(t);
    if (t.isCancellationRequested) return [];
    const d = mc(() => {
      const _ = new H0();
      return _.updateDocuments(l.map((v) => ({ key: v.commandId, textChunks: [this.getTfIdfChunk(v)] }))), function(v) {
        var b, C;
        const w = v.slice(0);
        w.sort((L, k) => k.score - L.score);
        const y = (C = (b = w[0]) === null || b === void 0 ? void 0 : b.score) !== null && C !== void 0 ? C : 0;
        if (y > 0) for (const L of w) L.score /= y;
        return w;
      }(_.calculateScores(i, t)).filter((v) => v.score > uu.TFIDF_THRESHOLD).slice(0, uu.TFIDF_MAX_RESULTS);
    }), h = [];
    for (const _ of l) {
      const v = (s = uu.WORD_FILTER(i, _.label)) !== null && s !== void 0 ? s : void 0, b = _.commandAlias && (o = uu.WORD_FILTER(i, _.commandAlias)) !== null && o !== void 0 ? o : void 0;
      if (v || b) _.highlights = { label: v, detail: this.options.showAlias ? b : void 0 }, h.push(_);
      else if (i === _.commandId) h.push(_);
      else if (i.length >= 3) {
        const C = d();
        if (t.isCancellationRequested) return [];
        const w = C.find((y) => y.key === _.commandId);
        w && (_.tfIdfScore = w.score, h.push(_));
      }
    }
    const c = /* @__PURE__ */ new Map();
    for (const _ of h) {
      const v = c.get(_.label);
      v ? (_.description = _.commandId, v.description = v.commandId) : c.set(_.label, _);
    }
    h.sort((_, v) => {
      if (_.tfIdfScore && v.tfIdfScore) return _.tfIdfScore === v.tfIdfScore ? _.label.localeCompare(v.label) : v.tfIdfScore - _.tfIdfScore;
      if (_.tfIdfScore) return 1;
      if (v.tfIdfScore) return -1;
      const b = this.commandsHistory.peek(_.commandId), C = this.commandsHistory.peek(v.commandId);
      if (b && C) return b > C ? -1 : 1;
      if (b) return -1;
      if (C) return 1;
      if (this.options.suggestedCommandIds) {
        const w = this.options.suggestedCommandIds.has(_.commandId), y = this.options.suggestedCommandIds.has(v.commandId);
        if (w && y) return 0;
        if (w) return -1;
        if (y) return 1;
      }
      return _.label.localeCompare(v.label);
    });
    const u = [];
    let g = !1, p = !0, f = !!this.options.suggestedCommandIds;
    for (let _ = 0; _ < h.length; _++) {
      const v = h[_];
      _ === 0 && this.commandsHistory.peek(v.commandId) && (u.push({ type: "separator", label: m(0, "recently used") }), g = !0), p && v.tfIdfScore !== void 0 && (u.push({ type: "separator", label: m(0, "similar commands") }), p = !1), f && v.tfIdfScore === void 0 && !this.commandsHistory.peek(v.commandId) && (!((r = this.options.suggestedCommandIds) === null || r === void 0) && r.has(v.commandId)) && (u.push({ type: "separator", label: m(0, "commonly used") }), g = !0, f = !1), !g || v.tfIdfScore !== void 0 || this.commandsHistory.peek(v.commandId) || !((a = this.options.suggestedCommandIds) === null || a === void 0) && a.has(v.commandId) || (u.push({ type: "separator", label: m(0, "other commands") }), g = !1), u.push(this.toCommandPick(v, n));
    }
    return this.hasAdditionalCommandPicks(i, t) ? { picks: u, additionalPicks: (async () => {
      var _;
      const v = await this.getAdditionalCommandPicks(l, h, i, t);
      if (t.isCancellationRequested) return [];
      const b = v.map((C) => this.toCommandPick(C, n));
      return p && ((_ = b[0]) === null || _ === void 0 ? void 0 : _.type) !== "separator" && b.unshift({ type: "separator", label: m(0, "similar commands") }), b;
    })() } : u;
  }
  toCommandPick(i, e) {
    if (i.type === "separator") return i;
    const t = this.keybindingService.lookupKeybinding(i.commandId), n = t ? m(0, "{0}, {1}", i.label, t.getAriaLabel()) : i.label;
    return { ...i, ariaLabel: n, detail: this.options.showAlias && i.commandAlias !== i.label ? i.commandAlias : void 0, keybinding: t, accept: async () => {
      var s, o;
      this.commandsHistory.push(i.commandId), this.telemetryService.publicLog2("workbenchActionExecuted", { id: i.commandId, from: (s = e == null ? void 0 : e.from) !== null && s !== void 0 ? s : "quick open" });
      try {
        !((o = i.args) === null || o === void 0) && o.length ? await this.commandService.executeCommand(i.commandId, ...i.args) : await this.commandService.executeCommand(i.commandId);
      } catch (r) {
        Sa(r) || this.dialogService.error(m(0, "Command '{0}' resulted in an error", i.label), RU(r));
      }
    } };
  }
  getTfIdfChunk({ label: i, commandAlias: e, commandDescription: t }) {
    let n = i;
    return e && e !== i && (n += ` - ${e}`), t && t.value !== i && (n += ` - ${t.value === t.original ? t.value : `${t.value} (${t.original})`}`), n;
  }
};
gu.PREFIX = ">", gu.TFIDF_THRESHOLD = 0.5, gu.TFIDF_MAX_RESULTS = 5, gu.WORD_FILTER = _A(xv, function(i, e, t = !1) {
  if (!e || e.length === 0) return null;
  let n = null, s = 0;
  for (i = i.toLowerCase(), e = e.toLowerCase(); s < e.length && (n = TI(i, e, 0, s, t), n === null); ) s = OW(e, s + 1);
  return n;
}, EW), gu = uu = AU([Dh(1, Se), Dh(2, Dt), Dh(3, ai), Dh(4, es), Dh(5, M1)], gu);
let gh = Bi = class extends V {
  constructor(i, e, t) {
    super(), this.storageService = i, this.configurationService = e, this.logService = t, this.configuredCommandsHistoryLength = 0, this.updateConfiguration(), this.load(), this.registerListeners();
  }
  registerListeners() {
    this._register(this.configurationService.onDidChangeConfiguration((i) => this.updateConfiguration(i))), this._register(this.storageService.onWillSaveState((i) => {
      i.reason === Fv.SHUTDOWN && this.saveState();
    }));
  }
  updateConfiguration(i) {
    i && !i.affectsConfiguration("workbench.commandPalette.history") || (this.configuredCommandsHistoryLength = Bi.getConfiguredCommandHistoryLength(this.configurationService), Bi.cache && Bi.cache.limit !== this.configuredCommandsHistoryLength && (Bi.cache.limit = this.configuredCommandsHistoryLength, Bi.hasChanges = !0));
  }
  load() {
    const i = this.storageService.get(Bi.PREF_KEY_CACHE, 0);
    let e;
    if (i) try {
      e = JSON.parse(i);
    } catch (n) {
      this.logService.error(`[CommandsHistory] invalid data: ${n}`);
    }
    const t = Bi.cache = new Ll(this.configuredCommandsHistoryLength, 1);
    if (e) {
      let n;
      n = e.usesLRU ? e.entries : e.entries.sort((s, o) => s.value - o.value), n.forEach((s) => t.set(s.key, s.value));
    }
    Bi.counter = this.storageService.getNumber(Bi.PREF_KEY_COUNTER, 0, Bi.counter);
  }
  push(i) {
    Bi.cache && (Bi.cache.set(i, Bi.counter++), Bi.hasChanges = !0);
  }
  peek(i) {
    var e;
    return (e = Bi.cache) === null || e === void 0 ? void 0 : e.peek(i);
  }
  saveState() {
    if (!Bi.cache || !Bi.hasChanges) return;
    const i = { usesLRU: !0, entries: [] };
    Bi.cache.forEach((e, t) => i.entries.push({ key: t, value: e })), this.storageService.store(Bi.PREF_KEY_CACHE, JSON.stringify(i), 0, 0), this.storageService.store(Bi.PREF_KEY_COUNTER, Bi.counter, 0, 0), Bi.hasChanges = !1;
  }
  static getConfiguredCommandHistoryLength(i) {
    var e, t;
    const n = (t = (e = i.getValue().workbench) === null || e === void 0 ? void 0 : e.commandPalette) === null || t === void 0 ? void 0 : t.history;
    return typeof n == "number" ? n : Bi.DEFAULT_COMMANDS_HISTORY_LENGTH;
  }
};
gh.DEFAULT_COMMANDS_HISTORY_LENGTH = 50, gh.PREF_KEY_CACHE = "commandPalette.mru.cache", gh.PREF_KEY_COUNTER = "commandPalette.mru.counter", gh.counter = 1, gh.hasChanges = !1, gh = Bi = AU([Dh(0, Nr), Dh(1, Ye), Dh(2, ts)], gh);
class Xhe extends gu {
  constructor(e, t, n, s, o, r) {
    super(e, t, n, s, o, r);
  }
  getCodeEditorCommandPicks() {
    const e = this.activeTextEditorControl;
    if (!e) return [];
    const t = [];
    for (const n of e.getSupportedActions()) t.push({ commandId: n.id, commandAlias: n.alias, label: yA(n.label) || n.id });
    return t;
  }
}
var Qhe = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, gp = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let g1 = class extends Xhe {
  get activeTextEditorControl() {
    var i;
    return (i = this.codeEditorService.getFocusedCodeEditor()) !== null && i !== void 0 ? i : void 0;
  }
  constructor(i, e, t, n, s, o) {
    super({ showAlias: !1 }, i, t, n, s, o), this.codeEditorService = e;
  }
  async getCommandPicks() {
    return this.getCodeEditorCommandPicks();
  }
  hasAdditionalCommandPicks() {
    return !1;
  }
  async getAdditionalCommandPicks() {
    return [];
  }
};
g1 = Qhe([gp(0, Se), gp(1, mt), gp(2, Dt), gp(3, ai), gp(4, es), gp(5, M1)], g1);
class z0 extends he {
  constructor() {
    super({ id: z0.ID, label: Ay.quickCommandActionLabel, alias: "Command Palette", precondition: void 0, kbOpts: { kbExpr: E.focus, primary: 59, weight: 100 }, contextMenuOpts: { group: "z_commands", order: 1 } });
  }
  run(e) {
    e.get(La).quickAccess.show(g1.PREFIX);
  }
}
z0.ID = "editor.action.quickCommand", X(z0), li.as(Ag).registerQuickAccessProvider({ ctor: g1, prefix: g1.PREFIX, helpEntries: [{ description: Ay.quickCommandHelp, commandId: z0.ID }] });
var Jhe = function(i, e, t, n) {
  var s, o = arguments.length, r = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(i, e, t, n);
  else for (var a = i.length - 1; a >= 0; a--) (s = i[a]) && (r = (o < 3 ? s(r) : o > 3 ? s(e, t, r) : s(e, t)) || r);
  return o > 3 && r && Object.defineProperty(e, t, r), r;
}, pp = function(i, e) {
  return function(t, n) {
    e(t, n, i);
  };
};
let CN = class extends lc {
  constructor(i, e, t, n, s, o, r) {
    super(!0, i, e, t, n, s, o, r);
  }
};
CN = Jhe([pp(1, Te), pp(2, mt), pp(3, Ri), pp(4, Se), pp(5, Nr), pp(6, Ye)], CN), ft(lc.ID, CN, 4);
X(class extends he {
  constructor() {
    super({ id: "editor.action.toggleHighContrast", label: KI.toggleHighContrast, alias: "Toggle High Contrast Theme", precondition: void 0 }), this._originalThemeName = null;
  }
  run(i, e) {
    const t = i.get(Ro), n = t.getColorTheme();
    la(n.type) ? (t.setTheme(this._originalThemeName || (Km(n.type) ? wm : td)), this._originalThemeName = null) : (t.setTheme(Km(n.type) ? Zu : Yu), this._originalThemeName = n.themeName);
  }
});
const Rce = Object.freeze(Object.defineProperty({ __proto__: null, CancellationTokenSource: aH, Emitter: aP, KeyCode: lH, KeyMod: dH, MarkerSeverity: pH, MarkerTag: mH, Position: hH, Range: cH, Selection: uH, SelectionDirection: gH, Token: _H, Uri: fH, editor: vH, languages: y0 }, Symbol.toStringTag, { value: "Module" }));
function ece(i) {
  return new Worker("/assets/editor.worker-kH-qYHP1.js", { name: i == null ? void 0 : i.name });
}
function tce(i) {
  return new Worker("/assets/json.worker-kXvdEO82.js", { name: i == null ? void 0 : i.name });
}
function ice(i) {
  return new Worker("/assets/css.worker-DC5nnw6R.js", { name: i == null ? void 0 : i.name });
}
function nce(i) {
  return new Worker("/assets/html.worker-BCaZjbWa.js", { name: i == null ? void 0 : i.name });
}
function sce(i) {
  return new Worker("/assets/ts.worker-BtbHax8g.js", { name: i == null ? void 0 : i.name });
}
function oce(i) {
  return new Worker("/assets/yaml.worker-tZqYN86i.js", { name: i == null ? void 0 : i.name });
}
function h7(i, e, t) {
  const n = /* @__PURE__ */ new Map(), s = (c) => {
    const u = c.getLanguageId();
    return Array.isArray(e) ? e.includes(u) : e === u;
  }, o = async (c) => {
    const u = c.getVersionId(), g = await t.provideMarkerData(c);
    u === c.getVersionId() && !c.isDisposed() && s(c) && i.editor.setModelMarkers(c, t.owner, g ?? []);
  }, r = (c) => {
    if (!s(c)) return;
    let u;
    n.set(c, c.onDidChangeContent(() => {
      clearTimeout(u), u = setTimeout(() => {
        o(c);
      }, 500);
    })), o(c);
  }, a = (c) => {
    i.editor.setModelMarkers(c, t.owner, []);
    const u = n.get(c);
    u && (u.dispose(), n.delete(c));
  }, l = i.editor.onDidCreateModel(r), d = i.editor.onWillDisposeModel((c) => {
    var u;
    a(c), (u = t.doReset) == null || u.call(t, c);
  }), h = i.editor.onDidChangeModelLanguage((c) => {
    var u;
    a(c.model), r(c.model), (u = t.doReset) == null || u.call(t, c.model);
  });
  for (const c of i.editor.getModels()) r(c);
  return { dispose() {
    for (const c of n.keys()) a(c);
    l.dispose(), d.dispose(), h.dispose();
  }, async revalidate() {
    await Promise.all(i.editor.getModels().map(o));
  } };
}
var PU;
(() => {
  var i = { 470: (s) => {
    function o(l) {
      if (typeof l != "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(l));
    }
    function r(l, d) {
      for (var h, c = "", u = 0, g = -1, p = 0, f = 0; f <= l.length; ++f) {
        if (f < l.length) h = l.charCodeAt(f);
        else {
          if (h === 47) break;
          h = 47;
        }
        if (h === 47) {
          if (!(g === f - 1 || p === 1)) if (g !== f - 1 && p === 2) {
            if (c.length < 2 || u !== 2 || c.charCodeAt(c.length - 1) !== 46 || c.charCodeAt(c.length - 2) !== 46) {
              if (c.length > 2) {
                var _ = c.lastIndexOf("/");
                if (_ !== c.length - 1) {
                  _ === -1 ? (c = "", u = 0) : u = (c = c.slice(0, _)).length - 1 - c.lastIndexOf("/"), g = f, p = 0;
                  continue;
                }
              } else if (c.length === 2 || c.length === 1) {
                c = "", u = 0, g = f, p = 0;
                continue;
              }
            }
            d && (c.length > 0 ? c += "/.." : c = "..", u = 2);
          } else c.length > 0 ? c += "/" + l.slice(g + 1, f) : c = l.slice(g + 1, f), u = f - g - 1;
          g = f, p = 0;
        } else h === 46 && p !== -1 ? ++p : p = -1;
      }
      return c;
    }
    var a = { resolve: function() {
      for (var l, d = "", h = !1, c = arguments.length - 1; c >= -1 && !h; c--) {
        var u;
        c >= 0 ? u = arguments[c] : (l === void 0 && (l = process.cwd()), u = l), o(u), u.length !== 0 && (d = u + "/" + d, h = u.charCodeAt(0) === 47);
      }
      return d = r(d, !h), h ? d.length > 0 ? "/" + d : "/" : d.length > 0 ? d : ".";
    }, normalize: function(l) {
      if (o(l), l.length === 0) return ".";
      var d = l.charCodeAt(0) === 47, h = l.charCodeAt(l.length - 1) === 47;
      return (l = r(l, !d)).length !== 0 || d || (l = "."), l.length > 0 && h && (l += "/"), d ? "/" + l : l;
    }, isAbsolute: function(l) {
      return o(l), l.length > 0 && l.charCodeAt(0) === 47;
    }, join: function() {
      if (arguments.length === 0) return ".";
      for (var l, d = 0; d < arguments.length; ++d) {
        var h = arguments[d];
        o(h), h.length > 0 && (l === void 0 ? l = h : l += "/" + h);
      }
      return l === void 0 ? "." : a.normalize(l);
    }, relative: function(l, d) {
      if (o(l), o(d), l === d || (l = a.resolve(l)) === (d = a.resolve(d))) return "";
      for (var h = 1; h < l.length && l.charCodeAt(h) === 47; ++h) ;
      for (var c = l.length, u = c - h, g = 1; g < d.length && d.charCodeAt(g) === 47; ++g) ;
      for (var p = d.length - g, f = u < p ? u : p, _ = -1, v = 0; v <= f; ++v) {
        if (v === f) {
          if (p > f) {
            if (d.charCodeAt(g + v) === 47) return d.slice(g + v + 1);
            if (v === 0) return d.slice(g + v);
          } else u > f && (l.charCodeAt(h + v) === 47 ? _ = v : v === 0 && (_ = 0));
          break;
        }
        var b = l.charCodeAt(h + v);
        if (b !== d.charCodeAt(g + v)) break;
        b === 47 && (_ = v);
      }
      var C = "";
      for (v = h + _ + 1; v <= c; ++v) v !== c && l.charCodeAt(v) !== 47 || (C.length === 0 ? C += ".." : C += "/..");
      return C.length > 0 ? C + d.slice(g + _) : (g += _, d.charCodeAt(g) === 47 && ++g, d.slice(g));
    }, _makeLong: function(l) {
      return l;
    }, dirname: function(l) {
      if (o(l), l.length === 0) return ".";
      for (var d = l.charCodeAt(0), h = d === 47, c = -1, u = !0, g = l.length - 1; g >= 1; --g) if ((d = l.charCodeAt(g)) === 47) {
        if (!u) {
          c = g;
          break;
        }
      } else u = !1;
      return c === -1 ? h ? "/" : "." : h && c === 1 ? "//" : l.slice(0, c);
    }, basename: function(l, d) {
      if (d !== void 0 && typeof d != "string") throw new TypeError('"ext" argument must be a string');
      o(l);
      var h, c = 0, u = -1, g = !0;
      if (d !== void 0 && d.length > 0 && d.length <= l.length) {
        if (d.length === l.length && d === l) return "";
        var p = d.length - 1, f = -1;
        for (h = l.length - 1; h >= 0; --h) {
          var _ = l.charCodeAt(h);
          if (_ === 47) {
            if (!g) {
              c = h + 1;
              break;
            }
          } else f === -1 && (g = !1, f = h + 1), p >= 0 && (_ === d.charCodeAt(p) ? --p == -1 && (u = h) : (p = -1, u = f));
        }
        return c === u ? u = f : u === -1 && (u = l.length), l.slice(c, u);
      }
      for (h = l.length - 1; h >= 0; --h) if (l.charCodeAt(h) === 47) {
        if (!g) {
          c = h + 1;
          break;
        }
      } else u === -1 && (g = !1, u = h + 1);
      return u === -1 ? "" : l.slice(c, u);
    }, extname: function(l) {
      o(l);
      for (var d = -1, h = 0, c = -1, u = !0, g = 0, p = l.length - 1; p >= 0; --p) {
        var f = l.charCodeAt(p);
        if (f !== 47) c === -1 && (u = !1, c = p + 1), f === 46 ? d === -1 ? d = p : g !== 1 && (g = 1) : d !== -1 && (g = -1);
        else if (!u) {
          h = p + 1;
          break;
        }
      }
      return d === -1 || c === -1 || g === 0 || g === 1 && d === c - 1 && d === h + 1 ? "" : l.slice(d, c);
    }, format: function(l) {
      if (l === null || typeof l != "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof l);
      return function(d, h) {
        var c = h.dir || h.root, u = h.base || (h.name || "") + (h.ext || "");
        return c ? c === h.root ? c + u : c + "/" + u : u;
      }(0, l);
    }, parse: function(l) {
      o(l);
      var d = { root: "", dir: "", base: "", ext: "", name: "" };
      if (l.length === 0) return d;
      var h, c = l.charCodeAt(0), u = c === 47;
      u ? (d.root = "/", h = 1) : h = 0;
      for (var g = -1, p = 0, f = -1, _ = !0, v = l.length - 1, b = 0; v >= h; --v) if ((c = l.charCodeAt(v)) !== 47) f === -1 && (_ = !1, f = v + 1), c === 46 ? g === -1 ? g = v : b !== 1 && (b = 1) : g !== -1 && (b = -1);
      else if (!_) {
        p = v + 1;
        break;
      }
      return g === -1 || f === -1 || b === 0 || b === 1 && g === f - 1 && g === p + 1 ? f !== -1 && (d.base = d.name = p === 0 && u ? l.slice(1, f) : l.slice(p, f)) : (p === 0 && u ? (d.name = l.slice(1, g), d.base = l.slice(1, f)) : (d.name = l.slice(p, g), d.base = l.slice(p, f)), d.ext = l.slice(g, f)), p > 0 ? d.dir = l.slice(0, p - 1) : u && (d.dir = "/"), d;
    }, sep: "/", delimiter: ":", win32: null, posix: null };
    a.posix = a, s.exports = a;
  } }, e = {};
  function t(s) {
    var o = e[s];
    if (o !== void 0) return o.exports;
    var r = e[s] = { exports: {} };
    return i[s](r, r.exports, t), r.exports;
  }
  t.d = (s, o) => {
    for (var r in o) t.o(o, r) && !t.o(s, r) && Object.defineProperty(s, r, { enumerable: !0, get: o[r] });
  }, t.o = (s, o) => Object.prototype.hasOwnProperty.call(s, o), t.r = (s) => {
    typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
  };
  var n = {};
  (() => {
    let s;
    t.r(n), t.d(n, { URI: () => u, Utils: () => B }), typeof process == "object" ? s = process.platform === "win32" : typeof navigator == "object" && (s = navigator.userAgent.indexOf("Windows") >= 0);
    const o = /^\w[\w\d+.-]*$/, r = /^\//, a = /^\/\//;
    function l(T, O) {
      if (!T.scheme && O) throw new Error(`[UriError]: Scheme is missing: {scheme: "", authority: "${T.authority}", path: "${T.path}", query: "${T.query}", fragment: "${T.fragment}"}`);
      if (T.scheme && !o.test(T.scheme)) throw new Error("[UriError]: Scheme contains illegal characters.");
      if (T.path) {
        if (T.authority) {
          if (!r.test(T.path)) throw new Error('[UriError]: If a URI contains an authority component, then the path component must either be empty or begin with a slash ("/") character');
        } else if (a.test(T.path)) throw new Error('[UriError]: If a URI does not contain an authority component, then the path cannot begin with two slash characters ("//")');
      }
    }
    const d = "", h = "/", c = /^(([^:/?#]+?):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/;
    class u {
      constructor(O, H, $, pe, me, ue = !1) {
        $d(this, "scheme");
        $d(this, "authority");
        $d(this, "path");
        $d(this, "query");
        $d(this, "fragment");
        typeof O == "object" ? (this.scheme = O.scheme || d, this.authority = O.authority || d, this.path = O.path || d, this.query = O.query || d, this.fragment = O.fragment || d) : (this.scheme = /* @__PURE__ */ function(ee, te) {
          return ee || te ? ee : "file";
        }(O, ue), this.authority = H || d, this.path = function(ee, te) {
          switch (ee) {
            case "https":
            case "http":
            case "file":
              te ? te[0] !== h && (te = h + te) : te = h;
          }
          return te;
        }(this.scheme, $ || d), this.query = pe || d, this.fragment = me || d, l(this, ue));
      }
      static isUri(O) {
        return O instanceof u || !!O && typeof O.authority == "string" && typeof O.fragment == "string" && typeof O.path == "string" && typeof O.query == "string" && typeof O.scheme == "string" && typeof O.fsPath == "string" && typeof O.with == "function" && typeof O.toString == "function";
      }
      get fsPath() {
        return b(this);
      }
      with(O) {
        if (!O) return this;
        let { scheme: H, authority: $, path: pe, query: me, fragment: ue } = O;
        return H === void 0 ? H = this.scheme : H === null && (H = d), $ === void 0 ? $ = this.authority : $ === null && ($ = d), pe === void 0 ? pe = this.path : pe === null && (pe = d), me === void 0 ? me = this.query : me === null && (me = d), ue === void 0 ? ue = this.fragment : ue === null && (ue = d), H === this.scheme && $ === this.authority && pe === this.path && me === this.query && ue === this.fragment ? this : new p(H, $, pe, me, ue);
      }
      static parse(O, H = !1) {
        const $ = c.exec(O);
        return $ ? new p($[2] || d, L($[4] || d), L($[5] || d), L($[7] || d), L($[9] || d), H) : new p(d, d, d, d, d);
      }
      static file(O) {
        let H = d;
        if (s && (O = O.replace(/\\/g, h)), O[0] === h && O[1] === h) {
          const $ = O.indexOf(h, 2);
          $ === -1 ? (H = O.substring(2), O = h) : (H = O.substring(2, $), O = O.substring($) || h);
        }
        return new p("file", H, O, d, d);
      }
      static from(O) {
        const H = new p(O.scheme, O.authority, O.path, O.query, O.fragment);
        return l(H, !0), H;
      }
      toString(O = !1) {
        return C(this, O);
      }
      toJSON() {
        return this;
      }
      static revive(O) {
        if (O) {
          if (O instanceof u) return O;
          {
            const H = new p(O);
            return H._formatted = O.external, H._fsPath = O._sep === g ? O.fsPath : null, H;
          }
        }
        return O;
      }
    }
    const g = s ? 1 : void 0;
    class p extends u {
      constructor() {
        super(...arguments);
        $d(this, "_formatted", null);
        $d(this, "_fsPath", null);
      }
      get fsPath() {
        return this._fsPath || (this._fsPath = b(this)), this._fsPath;
      }
      toString(H = !1) {
        return H ? C(this, !0) : (this._formatted || (this._formatted = C(this, !1)), this._formatted);
      }
      toJSON() {
        const H = { $mid: 1 };
        return this._fsPath && (H.fsPath = this._fsPath, H._sep = g), this._formatted && (H.external = this._formatted), this.path && (H.path = this.path), this.scheme && (H.scheme = this.scheme), this.authority && (H.authority = this.authority), this.query && (H.query = this.query), this.fragment && (H.fragment = this.fragment), H;
      }
    }
    const f = { 58: "%3A", 47: "%2F", 63: "%3F", 35: "%23", 91: "%5B", 93: "%5D", 64: "%40", 33: "%21", 36: "%24", 38: "%26", 39: "%27", 40: "%28", 41: "%29", 42: "%2A", 43: "%2B", 44: "%2C", 59: "%3B", 61: "%3D", 32: "%20" };
    function _(T, O, H) {
      let $, pe = -1;
      for (let me = 0; me < T.length; me++) {
        const ue = T.charCodeAt(me);
        if (ue >= 97 && ue <= 122 || ue >= 65 && ue <= 90 || ue >= 48 && ue <= 57 || ue === 45 || ue === 46 || ue === 95 || ue === 126 || O && ue === 47 || H && ue === 91 || H && ue === 93 || H && ue === 58) pe !== -1 && ($ += encodeURIComponent(T.substring(pe, me)), pe = -1), $ !== void 0 && ($ += T.charAt(me));
        else {
          $ === void 0 && ($ = T.substr(0, me));
          const ee = f[ue];
          ee !== void 0 ? (pe !== -1 && ($ += encodeURIComponent(T.substring(pe, me)), pe = -1), $ += ee) : pe === -1 && (pe = me);
        }
      }
      return pe !== -1 && ($ += encodeURIComponent(T.substring(pe))), $ !== void 0 ? $ : T;
    }
    function v(T) {
      let O;
      for (let H = 0; H < T.length; H++) {
        const $ = T.charCodeAt(H);
        $ === 35 || $ === 63 ? (O === void 0 && (O = T.substr(0, H)), O += f[$]) : O !== void 0 && (O += T[H]);
      }
      return O !== void 0 ? O : T;
    }
    function b(T, O) {
      let H;
      return H = T.authority && T.path.length > 1 && T.scheme === "file" ? `//${T.authority}${T.path}` : T.path.charCodeAt(0) === 47 && (T.path.charCodeAt(1) >= 65 && T.path.charCodeAt(1) <= 90 || T.path.charCodeAt(1) >= 97 && T.path.charCodeAt(1) <= 122) && T.path.charCodeAt(2) === 58 ? T.path[1].toLowerCase() + T.path.substr(2) : T.path, s && (H = H.replace(/\//g, "\\")), H;
    }
    function C(T, O) {
      const H = O ? v : _;
      let $ = "", { scheme: pe, authority: me, path: ue, query: ee, fragment: te } = T;
      if (pe && ($ += pe, $ += ":"), (me || pe === "file") && ($ += h, $ += h), me) {
        let be = me.indexOf("@");
        if (be !== -1) {
          const we = me.substr(0, be);
          me = me.substr(be + 1), be = we.lastIndexOf(":"), be === -1 ? $ += H(we, !1, !1) : ($ += H(we.substr(0, be), !1, !1), $ += ":", $ += H(we.substr(be + 1), !1, !0)), $ += "@";
        }
        me = me.toLowerCase(), be = me.lastIndexOf(":"), be === -1 ? $ += H(me, !1, !0) : ($ += H(me.substr(0, be), !1, !0), $ += me.substr(be));
      }
      if (ue) {
        if (ue.length >= 3 && ue.charCodeAt(0) === 47 && ue.charCodeAt(2) === 58) {
          const be = ue.charCodeAt(1);
          be >= 65 && be <= 90 && (ue = `/${String.fromCharCode(be + 32)}:${ue.substr(3)}`);
        } else if (ue.length >= 2 && ue.charCodeAt(1) === 58) {
          const be = ue.charCodeAt(0);
          be >= 65 && be <= 90 && (ue = `${String.fromCharCode(be + 32)}:${ue.substr(2)}`);
        }
        $ += H(ue, !0, !1);
      }
      return ee && ($ += "?", $ += H(ee, !1, !1)), te && ($ += "#", $ += O ? te : _(te, !1, !1)), $;
    }
    function w(T) {
      try {
        return decodeURIComponent(T);
      } catch {
        return T.length > 3 ? T.substr(0, 3) + w(T.substr(3)) : T;
      }
    }
    const y = /(%[0-9A-Za-z][0-9A-Za-z])+/g;
    function L(T) {
      return T.match(y) ? T.replace(y, (O) => w(O)) : T;
    }
    var k = t(470);
    const N = k.posix || k, A = "/";
    var B;
    (function(T) {
      T.joinPath = function(O, ...H) {
        return O.with({ path: N.join(O.path, ...H) });
      }, T.resolvePath = function(O, ...H) {
        let $ = O.path, pe = !1;
        $[0] !== A && ($ = A + $, pe = !0);
        let me = N.resolve($, ...H);
        return pe && me[0] === A && !O.authority && (me = me.substring(1)), O.with({ path: me });
      }, T.dirname = function(O) {
        if (O.path.length === 0 || O.path === A) return O;
        let H = N.dirname(O.path);
        return H.length === 1 && H.charCodeAt(0) === 46 && (H = ""), O.with({ path: H });
      }, T.basename = function(O) {
        return N.basename(O.path);
      }, T.extname = function(O) {
        return N.extname(O.path);
      };
    })(B || (B = {}));
  })(), PU = n;
})();
const { URI: yd, Utils: Ace } = PU;
function rce(i) {
  return i;
}
function ace(i) {
  return i;
}
function WP(i) {
  return { start: { line: i.startLineNumber - 1, character: i.startColumn - 1 }, end: { line: i.endLineNumber - 1, character: i.endColumn - 1 } };
}
function Xs(i) {
  return { startLineNumber: i.start.line + 1, startColumn: i.start.character + 1, endLineNumber: i.end.line + 1, endColumn: i.end.character + 1 };
}
function lce(i) {
  return { location: { range: WP(i), uri: String(i.resource) }, message: i.message };
}
function dce(i) {
  return { ...Xs(i.location.range), message: i.message, resource: yd.parse(i.location.uri) };
}
function hce(i) {
  const e = { message: i.message, range: WP(i), severity: (t = i.severity, t === 8 ? 1 : t === 4 ? 2 : t === 2 ? 3 : 4) };
  var t;
  return typeof i.code == "string" ? e.code = i.code : i.code != null && (e.code = i.code.value, e.codeDescription = { href: String(i.code.target) }), i.relatedInformation && (e.relatedInformation = i.relatedInformation.map(lce)), i.tags && (e.tags = i.tags.map(rce)), i.source != null && (e.source = i.source), e;
}
function OU(i, e) {
  const t = { ...Xs(i.range), message: i.message, severity: i.severity ? (n = i.severity, n === 1 ? 8 : n === 2 ? 4 : n === 3 ? 2 : 1) : 8 };
  var n;
  return i.code != null && (t.code = i.codeDescription == null ? String(i.code) : { value: String(i.code), target: yd.parse(i.codeDescription.href) }), i.relatedInformation && (t.relatedInformation = i.relatedInformation.map(dce)), i.tags && (t.tags = i.tags.map(ace)), i.source != null && (t.source = i.source), t;
}
function FU(i) {
  return { range: Xs(i.range), text: i.newText };
}
function cce(i) {
  const e = i.kind === "create" ? { newResource: yd.parse(i.uri) } : i.kind === "delete" ? { oldResource: yd.parse(i.uri) } : { oldResource: yd.parse(i.oldUri), newResource: yd.parse(i.newUri) };
  return i.options && (e.options = function(t) {
    const n = {};
    return t.ignoreIfExists != null && (n.ignoreIfExists = t.ignoreIfExists), t.ignoreIfNotExists != null && (n.ignoreIfNotExists = t.ignoreIfNotExists), t.overwrite != null && (n.overwrite = t.overwrite), t.recursive != null && (n.recursive = t.recursive), n;
  }(i.options)), e;
}
function c7(i, e, t) {
  return { resource: yd.parse(e), versionId: t, textEdit: FU(i) };
}
function uce(i, e) {
  const t = { title: i.title, isPreferred: i.isPreferred };
  return i.diagnostics && (t.diagnostics = i.diagnostics.map((n) => OU(n))), i.disabled && (t.disabled = i.disabled.reason), i.edit && (t.edit = function(n) {
    var s;
    const o = [];
    if (n.changes) for (const [r, a] of Object.entries(n.changes)) for (const l of a) o.push(c7(l, r));
    if (n.documentChanges) for (const r of n.documentChanges) if ("textDocument" in r) for (const a of r.edits) o.push(c7(a, r.textDocument.uri, (s = r.textDocument.version) !== null && s !== void 0 ? s : void 0));
    else o.push(cce(r));
    return { edits: o };
  }(i.edit)), i.isPreferred != null && (t.isPreferred = i.isPreferred), i.kind && (t.kind = i.kind), t;
}
function gce(i) {
  return i;
}
function BU(i) {
  return { value: i.value };
}
function pce(i) {
  return { range: Xs(i.range), text: i.newText };
}
function mce(i, e) {
  var t, n, s, o, r;
  const a = (t = e.itemDefaults) !== null && t !== void 0 ? t : {}, l = (n = i.textEdit) !== null && n !== void 0 ? n : a.editRange, d = (s = i.commitCharacters) !== null && s !== void 0 ? s : a.commitCharacters, h = (o = i.insertTextFormat) !== null && o !== void 0 ? o : a.insertTextFormat, c = (r = i.insertTextMode) !== null && r !== void 0 ? r : a.insertTextMode;
  let u, g = i.insertText;
  var p;
  l ? (u = "range" in (p = l) ? Xs(p.range) : "insert" in p && "replace" in p ? { insert: Xs(p.insert), replace: Xs(p.replace) } : Xs(p), "newText" in l && (g = l.newText)) : u = { ...e.range };
  const f = { insertText: g ?? i.label, kind: i.kind == null ? 18 : (_ = i.kind, _ === 1 ? 18 : _ === 2 ? 0 : _ === 3 ? 1 : _ === 4 ? 2 : _ === 5 ? 3 : _ === 6 ? 4 : _ === 7 ? 5 : _ === 8 ? 7 : _ === 9 ? 8 : _ === 10 ? 9 : _ === 11 ? 12 : _ === 12 ? 13 : _ === 13 ? 15 : _ === 14 ? 17 : _ === 15 ? 27 : _ === 16 ? 19 : _ === 17 ? 20 : _ === 18 ? 21 : _ === 19 ? 23 : _ === 20 ? 16 : _ === 21 ? 14 : _ === 22 ? 6 : _ === 23 ? 10 : _ === 24 ? 11 : 24), label: i.label, range: u };
  var _;
  return i.additionalTextEdits && (f.additionalTextEdits = i.additionalTextEdits.map(pce)), i.command && (f.command = function(v) {
    const b = { title: v.title, id: v.command };
    return v.arguments && (b.arguments = v.arguments), b;
  }(i.command)), d && (f.commitCharacters = d), i.detail != null && (f.detail = i.detail), typeof i.documentation == "string" ? f.documentation = i.documentation : i.documentation && (f.documentation = BU(i.documentation)), i.filterText != null && (f.filterText = i.filterText), h === 2 ? f.insertTextRules = 4 : c === 2 && (f.insertTextRules = 1), i.preselect != null && (f.preselect = i.preselect), i.sortText != null && (f.sortText = i.sortText), i.tags && (f.tags = i.tags.map(gce)), f;
}
function fce(i) {
  return i;
}
function WU(i) {
  var e, t, n;
  const s = { detail: (e = i.detail) !== null && e !== void 0 ? e : "", kind: (o = i.kind, o === 1 ? 0 : o === 2 ? 1 : o === 3 ? 2 : o === 4 ? 3 : o === 5 ? 4 : o === 6 ? 5 : o === 7 ? 6 : o === 8 ? 7 : o === 9 ? 8 : o === 10 ? 9 : o === 11 ? 10 : o === 12 ? 11 : o === 13 ? 12 : o === 14 ? 13 : o === 15 ? 14 : o === 16 ? 15 : o === 17 ? 16 : o === 18 ? 17 : o === 19 ? 18 : o === 20 ? 19 : o === 21 ? 20 : o === 22 ? 21 : o === 23 ? 22 : o === 24 ? 23 : o === 25 ? 24 : 25), name: i.name, range: Xs(i.range), selectionRange: Xs(i.selectionRange), tags: (n = (t = i.tags) === null || t === void 0 ? void 0 : t.map(fce)) !== null && n !== void 0 ? n : [] };
  var o;
  return i.children && (s.children = i.children.map(WU)), s;
}
function _ce(i) {
  const e = { start: i.startLine + 1, end: i.endLine + 1 };
  return i.kind != null && (e.kind = { value: i.kind }), e;
}
function u7(i) {
  return typeof i == "string" ? { value: i } : { value: `\`\`\`${i.language}
${i.value}
\`\`\`` };
}
function VP(i) {
  return { character: i.column - 1, line: i.lineNumber - 1 };
}
function vce(i) {
  const e = { range: Xs(i.range) };
  return i.tooltip != null && (e.tooltip = i.tooltip), i.target != null && (e.url = yd.parse(i.target)), e;
}
function bce(i) {
  const e = { range: Xs(i.targetRange), targetSelectionRange: Xs(i.targetSelectionRange), uri: yd.parse(i.targetUri) };
  return i.originSelectionRange && (e.originSelectionRange = Xs(i.originSelectionRange)), e;
}
function g7(i) {
  return { owner: "yaml", async provideMarkerData(e) {
    const t = await i(e.uri), n = await t.doValidation(String(e.uri));
    return n == null ? void 0 : n.map((s) => OU(s));
  }, async doReset(e) {
    await (await i(e.uri)).resetSchema(String(e.uri));
  } };
}
function Cce(i) {
  return { triggerCharacters: [" ", ":"], async provideCompletionItems(e, t) {
    const n = e.uri, s = e.getWordUntilPosition(t), o = await i(n), r = await o.doComplete(String(n), VP(t));
    if (r) return a = r, l = { range: { startLineNumber: t.lineNumber, startColumn: s.startColumn, endLineNumber: t.lineNumber, endColumn: s.endColumn } }, { incomplete: !!a.isIncomplete, suggestions: a.items.map((d) => mce(d, { range: l.range, itemDefaults: a.itemDefaults })) };
    var a, l;
  } };
}
function wce(i) {
  return { async provideDefinition(e, t) {
    const n = e.uri, s = await i(n), o = await s.doDefinition(String(n), VP(t));
    return o == null ? void 0 : o.map(bce);
  } };
}
function yce(i) {
  return { async provideHover(e, t) {
    const n = e.uri, s = await i(n), o = await s.doHover(String(n), VP(t));
    if (o) return function(r) {
      const a = { contents: (l = r.contents, typeof l == "string" || "language" in l ? [u7(l)] : Array.isArray(l) ? l.map(u7) : [BU(l)]) };
      var l;
      return r.range && (a.range = Xs(r.range)), a;
    }(o);
  } };
}
function Sce(i) {
  return { displayName: "yaml", async provideDocumentSymbols(e) {
    const t = e.uri, n = await i(t), s = await n.findDocumentSymbols(String(t));
    return s == null ? void 0 : s.map(WU);
  } };
}
function Lce(i) {
  return { displayName: "yaml", async provideDocumentFormattingEdits(e) {
    const t = e.uri, n = await i(t), s = await n.format(String(t));
    return s == null ? void 0 : s.map(FU);
  } };
}
function kce(i) {
  return { async provideLinks(e) {
    const t = e.uri, n = await i(t), s = await n.findLinks(String(t));
    if (s) return { links: s.map(vce) };
  } };
}
function Dce(i) {
  return { async provideCodeActions(e, t, n) {
    const s = e.uri, o = await i(s), r = await o.getCodeAction(String(s), WP(t), function(a) {
      const l = { diagnostics: a.markers.map(hce), triggerKind: a.trigger };
      return a.only != null && (l.only = [a.only]), l;
    }(n));
    if (r) return { actions: r.map((a) => uce(a)), dispose() {
    } };
  } };
}
function xce(i) {
  return { async provideFoldingRanges(e) {
    const t = e.uri, n = await i(t), s = await n.getFoldingRanges(String(t));
    return s == null ? void 0 : s.map(_ce);
  } };
}
function Pce(i, e) {
  const t = { completion: !0, customTags: [], enableSchemaRequest: !1, format: !0, isKubernetes: !1, hover: !0, schemas: [], validate: !0, yamlVersion: "1.2", ...e };
  i.languages.register({ id: "yaml", extensions: [".yaml", ".yml"], aliases: ["YAML", "yaml", "YML", "yml"], mimetypes: ["application/x-yaml"] });
  const n = function(r, a) {
    let l, { createData: d, interval: h = 3e4, label: c, moduleId: u, stopWhenIdleFor: g = 12e4 } = a, p = 0, f = !1;
    const _ = () => {
      l && (l.dispose(), l = void 0);
    }, v = setInterval(() => {
      l && Date.now() - p > g && _();
    }, h);
    return { dispose() {
      f = !0, clearInterval(v), _();
    }, getWorker(...b) {
      if (f) throw new Error("Worker manager has been disposed");
      return p = Date.now(), l || (l = r.editor.createWebWorker({ createData: d, label: c, moduleId: u })), l.withSyncedResources(b);
    }, updateCreateData(b) {
      d = b, _();
    } };
  }(i, { label: "yaml", moduleId: "monaco-yaml/yaml.worker", createData: t });
  let s = h7(i, "yaml", g7(n.getWorker));
  const o = [n, i.languages.registerCompletionItemProvider("yaml", Cce(n.getWorker)), i.languages.registerHoverProvider("yaml", yce(n.getWorker)), i.languages.registerDefinitionProvider("yaml", wce(n.getWorker)), i.languages.registerDocumentSymbolProvider("yaml", Sce(n.getWorker)), i.languages.registerDocumentFormattingEditProvider("yaml", Lce(n.getWorker)), i.languages.registerLinkProvider("yaml", kce(n.getWorker)), i.languages.registerCodeActionProvider("yaml", Dce(n.getWorker)), i.languages.registerFoldingRangeProvider("yaml", xce(n.getWorker)), i.languages.setLanguageConfiguration("yaml", { comments: { lineComment: "#" }, brackets: [["{", "}"], ["[", "]"], ["(", ")"]], autoClosingPairs: [{ open: "{", close: "}" }, { open: "[", close: "]" }, { open: "(", close: ")" }, { open: '"', close: '"' }, { open: "'", close: "'" }], surroundingPairs: [{ open: "{", close: "}" }, { open: "[", close: "]" }, { open: "(", close: ")" }, { open: '"', close: '"' }, { open: "'", close: "'" }], onEnterRules: [{ beforeText: /:\s*$/, action: { indentAction: i.languages.IndentAction.Indent } }] })];
  return { dispose() {
    for (const r of o) r.dispose();
    s.dispose();
  }, update(r) {
    n.updateCreateData(Object.assign(t, r)), s.dispose(), s = h7(i, "yaml", g7(n.getWorker));
  } };
}
self.MonacoEnvironment = { getWorker: (i, e) => e === "json" ? new tce() : e === "css" || e === "scss" || e === "less" ? new ice() : e === "html" || e === "handlebars" || e === "razor" ? new nce() : e === "typescript" || e === "javascript" ? new sce() : e === "yaml" ? new oce() : new ece() };
export {
  Rce as a,
  Pce as c,
  jL as m,
  s6 as t
};
